var zt = Object.defineProperty;
var qt = (re, te, ee) => te in re ? zt(re, te, { enumerable: !0, configurable: !0, writable: !0, value: ee }) : re[te] = ee;
var Et = (re, te, ee) => (qt(re, typeof te != "symbol" ? te + "" : te, ee), ee);
var n, l$2, u$2, t$1, o$1, r$3, f$1, e$1, c$2 = {}, s$2 = [], a$2 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, v$1 = Array.isArray;
function h$3(re, te) {
  for (var ee in te)
    re[ee] = te[ee];
  return re;
}
function p$1(re) {
  var te = re.parentNode;
  te && te.removeChild(re);
}
function y$1(re, te, ee) {
  var ie, ne, ae, ue = {};
  for (ae in te)
    ae == "key" ? ie = te[ae] : ae == "ref" ? ne = te[ae] : ue[ae] = te[ae];
  if (arguments.length > 2 && (ue.children = arguments.length > 3 ? n.call(arguments, 2) : ee), typeof re == "function" && re.defaultProps != null)
    for (ae in re.defaultProps)
      ue[ae] === void 0 && (ue[ae] = re.defaultProps[ae]);
  return d$1(re, ue, ie, ne, null);
}
function d$1(re, te, ee, ie, ne) {
  var ae = { type: re, props: te, key: ee, ref: ie, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: ne ?? ++u$2 };
  return ne == null && l$2.vnode != null && l$2.vnode(ae), ae;
}
function _$1() {
  return { current: null };
}
function k$2(re) {
  return re.children;
}
function b$1(re, te) {
  this.props = re, this.context = te;
}
function g$2(re, te) {
  if (te == null)
    return re.__ ? g$2(re.__, re.__.__k.indexOf(re) + 1) : null;
  for (var ee; te < re.__k.length; te++)
    if ((ee = re.__k[te]) != null && ee.__e != null)
      return ee.__e;
  return typeof re.type == "function" ? g$2(re) : null;
}
function m$1(re) {
  var te, ee;
  if ((re = re.__) != null && re.__c != null) {
    for (re.__e = re.__c.base = null, te = 0; te < re.__k.length; te++)
      if ((ee = re.__k[te]) != null && ee.__e != null) {
        re.__e = re.__c.base = ee.__e;
        break;
      }
    return m$1(re);
  }
}
function w$2(re) {
  (!re.__d && (re.__d = !0) && t$1.push(re) && !x$2.__r++ || o$1 !== l$2.debounceRendering) && ((o$1 = l$2.debounceRendering) || r$3)(x$2);
}
function x$2() {
  var re, te, ee, ie, ne, ae, ue, _e;
  for (t$1.sort(f$1); re = t$1.shift(); )
    re.__d && (te = t$1.length, ie = void 0, ne = void 0, ue = (ae = (ee = re).__v).__e, (_e = ee.__P) && (ie = [], (ne = h$3({}, ae)).__v = ae.__v + 1, L$1(_e, ae, ne, ee.__n, _e.ownerSVGElement !== void 0, ae.__h != null ? [ue] : null, ie, ue ?? g$2(ae), ae.__h), M$1(ie, ae), ae.__e != ue && m$1(ae)), t$1.length > te && t$1.sort(f$1));
  x$2.__r = 0;
}
function P$1(re, te, ee, ie, ne, ae, ue, _e, fe, le) {
  var se, oe, ce, he, ge, ve, me, be = ie && ie.__k || s$2, pe = be.length;
  for (ee.__k = [], se = 0; se < te.length; se++)
    if ((he = ee.__k[se] = (he = te[se]) == null || typeof he == "boolean" || typeof he == "function" ? null : typeof he == "string" || typeof he == "number" || typeof he == "bigint" ? d$1(null, he, null, null, he) : v$1(he) ? d$1(k$2, { children: he }, null, null, null) : he.__b > 0 ? d$1(he.type, he.props, he.key, he.ref ? he.ref : null, he.__v) : he) != null) {
      if (he.__ = ee, he.__b = ee.__b + 1, (ce = be[se]) === null || ce && he.key == ce.key && he.type === ce.type)
        be[se] = void 0;
      else
        for (oe = 0; oe < pe; oe++) {
          if ((ce = be[oe]) && he.key == ce.key && he.type === ce.type) {
            be[oe] = void 0;
            break;
          }
          ce = null;
        }
      L$1(re, he, ce = ce || c$2, ne, ae, ue, _e, fe, le), ge = he.__e, (oe = he.ref) && ce.ref != oe && (me || (me = []), ce.ref && me.push(ce.ref, null, he), me.push(oe, he.__c || ge, he)), ge != null ? (ve == null && (ve = ge), typeof he.type == "function" && he.__k === ce.__k ? he.__d = fe = C$1(he, fe, re) : fe = $$1(re, he, ce, be, ge, fe), typeof ee.type == "function" && (ee.__d = fe)) : fe && ce.__e == fe && fe.parentNode != re && (fe = g$2(ce));
    }
  for (ee.__e = ve, se = pe; se--; )
    be[se] != null && (typeof ee.type == "function" && be[se].__e != null && be[se].__e == ee.__d && (ee.__d = A$2(ie).nextSibling), q$2(be[se], be[se]));
  if (me)
    for (se = 0; se < me.length; se++)
      O$1(me[se], me[++se], me[++se]);
}
function C$1(re, te, ee) {
  for (var ie, ne = re.__k, ae = 0; ne && ae < ne.length; ae++)
    (ie = ne[ae]) && (ie.__ = re, te = typeof ie.type == "function" ? C$1(ie, te, ee) : $$1(ee, ie, ie, ne, ie.__e, te));
  return te;
}
function S(re, te) {
  return te = te || [], re == null || typeof re == "boolean" || (v$1(re) ? re.some(function(ee) {
    S(ee, te);
  }) : te.push(re)), te;
}
function $$1(re, te, ee, ie, ne, ae) {
  var ue, _e, fe;
  if (te.__d !== void 0)
    ue = te.__d, te.__d = void 0;
  else if (ee == null || ne != ae || ne.parentNode == null)
    e:
      if (ae == null || ae.parentNode !== re)
        re.appendChild(ne), ue = null;
      else {
        for (_e = ae, fe = 0; (_e = _e.nextSibling) && fe < ie.length; fe += 1)
          if (_e == ne)
            break e;
        re.insertBefore(ne, ae), ue = ae;
      }
  return ue !== void 0 ? ue : ne.nextSibling;
}
function A$2(re) {
  var te, ee, ie;
  if (re.type == null || typeof re.type == "string")
    return re.__e;
  if (re.__k) {
    for (te = re.__k.length - 1; te >= 0; te--)
      if ((ee = re.__k[te]) && (ie = A$2(ee)))
        return ie;
  }
  return null;
}
function H$2(re, te, ee, ie, ne) {
  var ae;
  for (ae in ee)
    ae === "children" || ae === "key" || ae in te || T$2(re, ae, null, ee[ae], ie);
  for (ae in te)
    ne && typeof te[ae] != "function" || ae === "children" || ae === "key" || ae === "value" || ae === "checked" || ee[ae] === te[ae] || T$2(re, ae, te[ae], ee[ae], ie);
}
function I$1(re, te, ee) {
  te[0] === "-" ? re.setProperty(te, ee ?? "") : re[te] = ee == null ? "" : typeof ee != "number" || a$2.test(te) ? ee : ee + "px";
}
function T$2(re, te, ee, ie, ne) {
  var ae;
  e:
    if (te === "style")
      if (typeof ee == "string")
        re.style.cssText = ee;
      else {
        if (typeof ie == "string" && (re.style.cssText = ie = ""), ie)
          for (te in ie)
            ee && te in ee || I$1(re.style, te, "");
        if (ee)
          for (te in ee)
            ie && ee[te] === ie[te] || I$1(re.style, te, ee[te]);
      }
    else if (te[0] === "o" && te[1] === "n")
      ae = te !== (te = te.replace(/Capture$/, "")), te = te.toLowerCase() in re ? te.toLowerCase().slice(2) : te.slice(2), re.l || (re.l = {}), re.l[te + ae] = ee, ee ? ie || re.addEventListener(te, ae ? z$2 : j$2, ae) : re.removeEventListener(te, ae ? z$2 : j$2, ae);
    else if (te !== "dangerouslySetInnerHTML") {
      if (ne)
        te = te.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (te !== "width" && te !== "height" && te !== "href" && te !== "list" && te !== "form" && te !== "tabIndex" && te !== "download" && te !== "rowSpan" && te !== "colSpan" && te in re)
        try {
          re[te] = ee ?? "";
          break e;
        } catch {
        }
      typeof ee == "function" || (ee == null || ee === !1 && te[4] !== "-" ? re.removeAttribute(te) : re.setAttribute(te, ee));
    }
}
function j$2(re) {
  return this.l[re.type + !1](l$2.event ? l$2.event(re) : re);
}
function z$2(re) {
  return this.l[re.type + !0](l$2.event ? l$2.event(re) : re);
}
function L$1(re, te, ee, ie, ne, ae, ue, _e, fe) {
  var le, se, oe, ce, he, ge, ve, me, be, pe, $e, ye, Se, we, Pe, Te = te.type;
  if (te.constructor !== void 0)
    return null;
  ee.__h != null && (fe = ee.__h, _e = te.__e = ee.__e, te.__h = null, ae = [_e]), (le = l$2.__b) && le(te);
  try {
    e:
      if (typeof Te == "function") {
        if (me = te.props, be = (le = Te.contextType) && ie[le.__c], pe = le ? be ? be.props.value : le.__ : ie, ee.__c ? ve = (se = te.__c = ee.__c).__ = se.__E : ("prototype" in Te && Te.prototype.render ? te.__c = se = new Te(me, pe) : (te.__c = se = new b$1(me, pe), se.constructor = Te, se.render = B$2), be && be.sub(se), se.props = me, se.state || (se.state = {}), se.context = pe, se.__n = ie, oe = se.__d = !0, se.__h = [], se._sb = []), se.__s == null && (se.__s = se.state), Te.getDerivedStateFromProps != null && (se.__s == se.state && (se.__s = h$3({}, se.__s)), h$3(se.__s, Te.getDerivedStateFromProps(me, se.__s))), ce = se.props, he = se.state, se.__v = te, oe)
          Te.getDerivedStateFromProps == null && se.componentWillMount != null && se.componentWillMount(), se.componentDidMount != null && se.__h.push(se.componentDidMount);
        else {
          if (Te.getDerivedStateFromProps == null && me !== ce && se.componentWillReceiveProps != null && se.componentWillReceiveProps(me, pe), !se.__e && se.shouldComponentUpdate != null && se.shouldComponentUpdate(me, se.__s, pe) === !1 || te.__v === ee.__v) {
            for (te.__v !== ee.__v && (se.props = me, se.state = se.__s, se.__d = !1), se.__e = !1, te.__e = ee.__e, te.__k = ee.__k, te.__k.forEach(function(Ee) {
              Ee && (Ee.__ = te);
            }), $e = 0; $e < se._sb.length; $e++)
              se.__h.push(se._sb[$e]);
            se._sb = [], se.__h.length && ue.push(se);
            break e;
          }
          se.componentWillUpdate != null && se.componentWillUpdate(me, se.__s, pe), se.componentDidUpdate != null && se.__h.push(function() {
            se.componentDidUpdate(ce, he, ge);
          });
        }
        if (se.context = pe, se.props = me, se.__P = re, ye = l$2.__r, Se = 0, "prototype" in Te && Te.prototype.render) {
          for (se.state = se.__s, se.__d = !1, ye && ye(te), le = se.render(se.props, se.state, se.context), we = 0; we < se._sb.length; we++)
            se.__h.push(se._sb[we]);
          se._sb = [];
        } else
          do
            se.__d = !1, ye && ye(te), le = se.render(se.props, se.state, se.context), se.state = se.__s;
          while (se.__d && ++Se < 25);
        se.state = se.__s, se.getChildContext != null && (ie = h$3(h$3({}, ie), se.getChildContext())), oe || se.getSnapshotBeforeUpdate == null || (ge = se.getSnapshotBeforeUpdate(ce, he)), P$1(re, v$1(Pe = le != null && le.type === k$2 && le.key == null ? le.props.children : le) ? Pe : [Pe], te, ee, ie, ne, ae, ue, _e, fe), se.base = te.__e, te.__h = null, se.__h.length && ue.push(se), ve && (se.__E = se.__ = null), se.__e = !1;
      } else
        ae == null && te.__v === ee.__v ? (te.__k = ee.__k, te.__e = ee.__e) : te.__e = N$1(ee.__e, te, ee, ie, ne, ae, ue, fe);
    (le = l$2.diffed) && le(te);
  } catch (Ee) {
    te.__v = null, (fe || ae != null) && (te.__e = _e, te.__h = !!fe, ae[ae.indexOf(_e)] = null), l$2.__e(Ee, te, ee);
  }
}
function M$1(re, te) {
  l$2.__c && l$2.__c(te, re), re.some(function(ee) {
    try {
      re = ee.__h, ee.__h = [], re.some(function(ie) {
        ie.call(ee);
      });
    } catch (ie) {
      l$2.__e(ie, ee.__v);
    }
  });
}
function N$1(re, te, ee, ie, ne, ae, ue, _e) {
  var fe, le, se, oe = ee.props, ce = te.props, he = te.type, ge = 0;
  if (he === "svg" && (ne = !0), ae != null) {
    for (; ge < ae.length; ge++)
      if ((fe = ae[ge]) && "setAttribute" in fe == !!he && (he ? fe.localName === he : fe.nodeType === 3)) {
        re = fe, ae[ge] = null;
        break;
      }
  }
  if (re == null) {
    if (he === null)
      return document.createTextNode(ce);
    re = ne ? document.createElementNS("http://www.w3.org/2000/svg", he) : document.createElement(he, ce.is && ce), ae = null, _e = !1;
  }
  if (he === null)
    oe === ce || _e && re.data === ce || (re.data = ce);
  else {
    if (ae = ae && n.call(re.childNodes), le = (oe = ee.props || c$2).dangerouslySetInnerHTML, se = ce.dangerouslySetInnerHTML, !_e) {
      if (ae != null)
        for (oe = {}, ge = 0; ge < re.attributes.length; ge++)
          oe[re.attributes[ge].name] = re.attributes[ge].value;
      (se || le) && (se && (le && se.__html == le.__html || se.__html === re.innerHTML) || (re.innerHTML = se && se.__html || ""));
    }
    if (H$2(re, ce, oe, ne, _e), se)
      te.__k = [];
    else if (P$1(re, v$1(ge = te.props.children) ? ge : [ge], te, ee, ie, ne && he !== "foreignObject", ae, ue, ae ? ae[0] : ee.__k && g$2(ee, 0), _e), ae != null)
      for (ge = ae.length; ge--; )
        ae[ge] != null && p$1(ae[ge]);
    _e || ("value" in ce && (ge = ce.value) !== void 0 && (ge !== re.value || he === "progress" && !ge || he === "option" && ge !== oe.value) && T$2(re, "value", ge, oe.value, !1), "checked" in ce && (ge = ce.checked) !== void 0 && ge !== re.checked && T$2(re, "checked", ge, oe.checked, !1));
  }
  return re;
}
function O$1(re, te, ee) {
  try {
    typeof re == "function" ? re(te) : re.current = te;
  } catch (ie) {
    l$2.__e(ie, ee);
  }
}
function q$2(re, te, ee) {
  var ie, ne;
  if (l$2.unmount && l$2.unmount(re), (ie = re.ref) && (ie.current && ie.current !== re.__e || O$1(ie, null, te)), (ie = re.__c) != null) {
    if (ie.componentWillUnmount)
      try {
        ie.componentWillUnmount();
      } catch (ae) {
        l$2.__e(ae, te);
      }
    ie.base = ie.__P = null, re.__c = void 0;
  }
  if (ie = re.__k)
    for (ne = 0; ne < ie.length; ne++)
      ie[ne] && q$2(ie[ne], te, ee || typeof re.type != "function");
  ee || re.__e == null || p$1(re.__e), re.__ = re.__e = re.__d = void 0;
}
function B$2(re, te, ee) {
  return this.constructor(re, ee);
}
function D$1(re, te, ee) {
  var ie, ne, ae;
  l$2.__ && l$2.__(re, te), ne = (ie = typeof ee == "function") ? null : ee && ee.__k || te.__k, ae = [], L$1(te, re = (!ie && ee || te).__k = y$1(k$2, null, [re]), ne || c$2, c$2, te.ownerSVGElement !== void 0, !ie && ee ? [ee] : ne ? null : te.firstChild ? n.call(te.childNodes) : null, ae, !ie && ee ? ee : ne ? ne.__e : te.firstChild, ie), M$1(ae, re);
}
function E$1(re, te) {
  D$1(re, te, E$1);
}
function F$2(re, te, ee) {
  var ie, ne, ae, ue, _e = h$3({}, re.props);
  for (ae in re.type && re.type.defaultProps && (ue = re.type.defaultProps), te)
    ae == "key" ? ie = te[ae] : ae == "ref" ? ne = te[ae] : _e[ae] = te[ae] === void 0 && ue !== void 0 ? ue[ae] : te[ae];
  return arguments.length > 2 && (_e.children = arguments.length > 3 ? n.call(arguments, 2) : ee), d$1(re.type, _e, ie || re.key, ne || re.ref, null);
}
function G$1(re, te) {
  var ee = { __c: te = "__cC" + e$1++, __: re, Consumer: function(ie, ne) {
    return ie.children(ne);
  }, Provider: function(ie) {
    var ne, ae;
    return this.getChildContext || (ne = [], (ae = {})[te] = this, this.getChildContext = function() {
      return ae;
    }, this.shouldComponentUpdate = function(ue) {
      this.props.value !== ue.value && ne.some(function(_e) {
        _e.__e = !0, w$2(_e);
      });
    }, this.sub = function(ue) {
      ne.push(ue);
      var _e = ue.componentWillUnmount;
      ue.componentWillUnmount = function() {
        ne.splice(ne.indexOf(ue), 1), _e && _e.call(ue);
      };
    }), ie.children;
  } };
  return ee.Provider.__ = ee.Consumer.contextType = ee;
}
n = s$2.slice, l$2 = { __e: function(re, te, ee, ie) {
  for (var ne, ae, ue; te = te.__; )
    if ((ne = te.__c) && !ne.__)
      try {
        if ((ae = ne.constructor) && ae.getDerivedStateFromError != null && (ne.setState(ae.getDerivedStateFromError(re)), ue = ne.__d), ne.componentDidCatch != null && (ne.componentDidCatch(re, ie || {}), ue = ne.__d), ue)
          return ne.__E = ne;
      } catch (_e) {
        re = _e;
      }
  throw re;
} }, u$2 = 0, b$1.prototype.setState = function(re, te) {
  var ee;
  ee = this.__s != null && this.__s !== this.state ? this.__s : this.__s = h$3({}, this.state), typeof re == "function" && (re = re(h$3({}, ee), this.props)), re && h$3(ee, re), re != null && this.__v && (te && this._sb.push(te), w$2(this));
}, b$1.prototype.forceUpdate = function(re) {
  this.__v && (this.__e = !0, re && this.__h.push(re), w$2(this));
}, b$1.prototype.render = k$2, t$1 = [], r$3 = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f$1 = function(re, te) {
  return re.__v.__b - te.__v.__b;
}, x$2.__r = 0, e$1 = 0;
function r$2() {
  return (r$2 = Object.assign || function(re) {
    for (var te = 1; te < arguments.length; te++) {
      var ee = arguments[te];
      for (var ie in ee)
        Object.prototype.hasOwnProperty.call(ee, ie) && (re[ie] = ee[ie]);
    }
    return re;
  }).apply(this, arguments);
}
function i$1(re) {
  this.getChildContext = function() {
    return re.context;
  };
  var te = re.children, ee = function(ie, ne) {
    if (ie == null)
      return {};
    var ae, ue, _e = {}, fe = Object.keys(ie);
    for (ue = 0; ue < fe.length; ue++)
      ne.indexOf(ae = fe[ue]) >= 0 || (_e[ae] = ie[ae]);
    return _e;
  }(re, ["context", "children"]);
  return F$2(te, ee);
}
function a$1() {
  var re = new CustomEvent("_preact", { detail: {}, bubbles: !0, cancelable: !0 });
  this.dispatchEvent(re), this._vdom = y$1(i$1, r$2({}, this._props, { context: re.detail.context }), function te(ee, ie) {
    if (ee.nodeType === 3)
      return ee.data;
    if (ee.nodeType !== 1)
      return null;
    var ne = [], ae = {}, ue = 0, _e = ee.attributes, fe = ee.childNodes;
    for (ue = _e.length; ue--; )
      _e[ue].name !== "slot" && (ae[_e[ue].name] = _e[ue].value, ae[s$1(_e[ue].name)] = _e[ue].value);
    for (ue = fe.length; ue--; ) {
      var le = te(fe[ue], null), se = fe[ue].slot;
      se ? ae[se] = y$1(u$1, { name: se }, le) : ne[ue] = le;
    }
    var oe = ie ? y$1(u$1, null, ne) : ne;
    return y$1(ie || ee.nodeName.toLowerCase(), ae, oe);
  }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? E$1 : D$1)(this._vdom, this._root);
}
function s$1(re) {
  return re.replace(/-(\w)/g, function(te, ee) {
    return ee ? ee.toUpperCase() : "";
  });
}
function c$1(re, te, ee) {
  if (this._vdom) {
    var ie = {};
    ie[re] = ee = ee ?? void 0, ie[s$1(re)] = ee, this._vdom = F$2(this._vdom, ie), D$1(this._vdom, this._root);
  }
}
function l$1() {
  D$1(this._vdom = null, this._root);
}
function u$1(re, te) {
  var ee = this;
  return y$1("slot", r$2({}, re, { ref: function(ie) {
    ie ? (ee.ref = ie, ee._listener || (ee._listener = function(ne) {
      ne.stopPropagation(), ne.detail.context = te;
    }, ie.addEventListener("_preact", ee._listener))) : ee.ref.removeEventListener("_preact", ee._listener);
  } }));
}
function register(re, te, ee, ie) {
  function ne() {
    var ae = Reflect.construct(HTMLElement, [], ne);
    return ae._vdomComponent = re, ae._root = ie && ie.shadow ? ae.attachShadow({ mode: "open" }) : ae, ae;
  }
  return (ne.prototype = Object.create(HTMLElement.prototype)).constructor = ne, ne.prototype.connectedCallback = a$1, ne.prototype.attributeChangedCallback = c$1, ne.prototype.disconnectedCallback = l$1, ee = ee || re.observedAttributes || Object.keys(re.propTypes || {}), ne.observedAttributes = ee, ee.forEach(function(ae) {
    Object.defineProperty(ne.prototype, ae, { get: function() {
      return this._vdom.props[ae];
    }, set: function(ue) {
      this._vdom ? this.attributeChangedCallback(ae, null, ue) : (this._props || (this._props = {}), this._props[ae] = ue, this.connectedCallback());
      var _e = typeof ue;
      ue != null && _e !== "string" && _e !== "boolean" && _e !== "number" || this.setAttribute(ae, ue);
    } });
  }), customElements.define(te || re.tagName || re.displayName || re.name, ne);
}
var t, r$1, u, i, o = 0, f = [], c = [], e = l$2.__b, a = l$2.__r, v = l$2.diffed, l = l$2.__c, m = l$2.unmount;
function d(re, te) {
  l$2.__h && l$2.__h(r$1, re, o || te), o = 0;
  var ee = r$1.__H || (r$1.__H = { __: [], __h: [] });
  return re >= ee.__.length && ee.__.push({ __V: c }), ee.__[re];
}
function h$2(re) {
  return o = 1, s(B$1, re);
}
function s(re, te, ee) {
  var ie = d(t++, 2);
  if (ie.t = re, !ie.__c && (ie.__ = [ee ? ee(te) : B$1(void 0, te), function(_e) {
    var fe = ie.__N ? ie.__N[0] : ie.__[0], le = ie.t(fe, _e);
    fe !== le && (ie.__N = [le, ie.__[1]], ie.__c.setState({}));
  }], ie.__c = r$1, !r$1.u)) {
    var ne = function(_e, fe, le) {
      if (!ie.__c.__H)
        return !0;
      var se = ie.__c.__H.__.filter(function(ce) {
        return ce.__c;
      });
      if (se.every(function(ce) {
        return !ce.__N;
      }))
        return !ae || ae.call(this, _e, fe, le);
      var oe = !1;
      return se.forEach(function(ce) {
        if (ce.__N) {
          var he = ce.__[0];
          ce.__ = ce.__N, ce.__N = void 0, he !== ce.__[0] && (oe = !0);
        }
      }), !(!oe && ie.__c.props === _e) && (!ae || ae.call(this, _e, fe, le));
    };
    r$1.u = !0;
    var ae = r$1.shouldComponentUpdate, ue = r$1.componentWillUpdate;
    r$1.componentWillUpdate = function(_e, fe, le) {
      if (this.__e) {
        var se = ae;
        ae = void 0, ne(_e, fe, le), ae = se;
      }
      ue && ue.call(this, _e, fe, le);
    }, r$1.shouldComponentUpdate = ne;
  }
  return ie.__N || ie.__;
}
function p(re, te) {
  var ee = d(t++, 3);
  !l$2.__s && z$1(ee.__H, te) && (ee.__ = re, ee.i = te, r$1.__H.__h.push(ee));
}
function y(re, te) {
  var ee = d(t++, 4);
  !l$2.__s && z$1(ee.__H, te) && (ee.__ = re, ee.i = te, r$1.__h.push(ee));
}
function _(re) {
  return o = 5, F$1(function() {
    return { current: re };
  }, []);
}
function A$1(re, te, ee) {
  o = 6, y(function() {
    return typeof re == "function" ? (re(te()), function() {
      return re(null);
    }) : re ? (re.current = te(), function() {
      return re.current = null;
    }) : void 0;
  }, ee == null ? ee : ee.concat(re));
}
function F$1(re, te) {
  var ee = d(t++, 7);
  return z$1(ee.__H, te) ? (ee.__V = re(), ee.i = te, ee.__h = re, ee.__V) : ee.__;
}
function T$1(re, te) {
  return o = 8, F$1(function() {
    return re;
  }, te);
}
function q$1(re) {
  var te = r$1.context[re.__c], ee = d(t++, 9);
  return ee.c = re, te ? (ee.__ == null && (ee.__ = !0, te.sub(r$1)), te.props.value) : re.__;
}
function x$1(re, te) {
  l$2.useDebugValue && l$2.useDebugValue(te ? te(re) : re);
}
function V$1() {
  var re = d(t++, 11);
  if (!re.__) {
    for (var te = r$1.__v; te !== null && !te.__m && te.__ !== null; )
      te = te.__;
    var ee = te.__m || (te.__m = [0, 0]);
    re.__ = "P" + ee[0] + "-" + ee[1]++;
  }
  return re.__;
}
function b() {
  for (var re; re = f.shift(); )
    if (re.__P && re.__H)
      try {
        re.__H.__h.forEach(k$1), re.__H.__h.forEach(w$1), re.__H.__h = [];
      } catch (te) {
        re.__H.__h = [], l$2.__e(te, re.__v);
      }
}
l$2.__b = function(re) {
  r$1 = null, e && e(re);
}, l$2.__r = function(re) {
  a && a(re), t = 0;
  var te = (r$1 = re.__c).__H;
  te && (u === r$1 ? (te.__h = [], r$1.__h = [], te.__.forEach(function(ee) {
    ee.__N && (ee.__ = ee.__N), ee.__V = c, ee.__N = ee.i = void 0;
  })) : (te.__h.forEach(k$1), te.__h.forEach(w$1), te.__h = [], t = 0)), u = r$1;
}, l$2.diffed = function(re) {
  v && v(re);
  var te = re.__c;
  te && te.__H && (te.__H.__h.length && (f.push(te) !== 1 && i === l$2.requestAnimationFrame || ((i = l$2.requestAnimationFrame) || j$1)(b)), te.__H.__.forEach(function(ee) {
    ee.i && (ee.__H = ee.i), ee.__V !== c && (ee.__ = ee.__V), ee.i = void 0, ee.__V = c;
  })), u = r$1 = null;
}, l$2.__c = function(re, te) {
  te.some(function(ee) {
    try {
      ee.__h.forEach(k$1), ee.__h = ee.__h.filter(function(ie) {
        return !ie.__ || w$1(ie);
      });
    } catch (ie) {
      te.some(function(ne) {
        ne.__h && (ne.__h = []);
      }), te = [], l$2.__e(ie, ee.__v);
    }
  }), l && l(re, te);
}, l$2.unmount = function(re) {
  m && m(re);
  var te, ee = re.__c;
  ee && ee.__H && (ee.__H.__.forEach(function(ie) {
    try {
      k$1(ie);
    } catch (ne) {
      te = ne;
    }
  }), ee.__H = void 0, te && l$2.__e(te, ee.__v));
};
var g$1 = typeof requestAnimationFrame == "function";
function j$1(re) {
  var te, ee = function() {
    clearTimeout(ie), g$1 && cancelAnimationFrame(te), setTimeout(re);
  }, ie = setTimeout(ee, 100);
  g$1 && (te = requestAnimationFrame(ee));
}
function k$1(re) {
  var te = r$1, ee = re.__c;
  typeof ee == "function" && (re.__c = void 0, ee()), r$1 = te;
}
function w$1(re) {
  var te = r$1;
  re.__c = re.__(), r$1 = te;
}
function z$1(re, te) {
  return !re || re.length !== te.length || te.some(function(ee, ie) {
    return ee !== re[ie];
  });
}
function B$1(re, te) {
  return typeof te == "function" ? te(re) : te;
}
function g(re, te) {
  for (var ee in te)
    re[ee] = te[ee];
  return re;
}
function C(re, te) {
  for (var ee in re)
    if (ee !== "__source" && !(ee in te))
      return !0;
  for (var ie in te)
    if (ie !== "__source" && re[ie] !== te[ie])
      return !0;
  return !1;
}
function E(re, te) {
  return re === te && (re !== 0 || 1 / re == 1 / te) || re != re && te != te;
}
function w(re) {
  this.props = re;
}
function x(re, te) {
  function ee(ne) {
    var ae = this.props.ref, ue = ae == ne.ref;
    return !ue && ae && (ae.call ? ae(null) : ae.current = null), te ? !te(this.props, ne) || !ue : C(this.props, ne);
  }
  function ie(ne) {
    return this.shouldComponentUpdate = ee, y$1(re, ne);
  }
  return ie.displayName = "Memo(" + (re.displayName || re.name) + ")", ie.prototype.isReactComponent = !0, ie.__f = !0, ie;
}
(w.prototype = new b$1()).isPureReactComponent = !0, w.prototype.shouldComponentUpdate = function(re, te) {
  return C(this.props, re) || C(this.state, te);
};
var R = l$2.__b;
l$2.__b = function(re) {
  re.type && re.type.__f && re.ref && (re.props.ref = re.ref, re.ref = null), R && R(re);
};
var N = typeof Symbol < "u" && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function k(re) {
  function te(ee) {
    var ie = g({}, ee);
    return delete ie.ref, re(ie, ee.ref || null);
  }
  return te.$$typeof = N, te.render = te, te.prototype.isReactComponent = te.__f = !0, te.displayName = "ForwardRef(" + (re.displayName || re.name) + ")", te;
}
var A = function(re, te) {
  return re == null ? null : S(S(re).map(te));
}, O = { map: A, forEach: A, count: function(re) {
  return re ? S(re).length : 0;
}, only: function(re) {
  var te = S(re);
  if (te.length !== 1)
    throw "Children.only";
  return te[0];
}, toArray: S }, T = l$2.__e;
l$2.__e = function(re, te, ee, ie) {
  if (re.then) {
    for (var ne, ae = te; ae = ae.__; )
      if ((ne = ae.__c) && ne.__c)
        return te.__e == null && (te.__e = ee.__e, te.__k = ee.__k), ne.__c(re, te);
  }
  T(re, te, ee, ie);
};
var I = l$2.unmount;
function L(re, te, ee) {
  return re && (re.__c && re.__c.__H && (re.__c.__H.__.forEach(function(ie) {
    typeof ie.__c == "function" && ie.__c();
  }), re.__c.__H = null), (re = g({}, re)).__c != null && (re.__c.__P === ee && (re.__c.__P = te), re.__c = null), re.__k = re.__k && re.__k.map(function(ie) {
    return L(ie, te, ee);
  })), re;
}
function U(re, te, ee) {
  return re && (re.__v = null, re.__k = re.__k && re.__k.map(function(ie) {
    return U(ie, te, ee);
  }), re.__c && re.__c.__P === te && (re.__e && ee.insertBefore(re.__e, re.__d), re.__c.__e = !0, re.__c.__P = ee)), re;
}
function D() {
  this.__u = 0, this.t = null, this.__b = null;
}
function F(re) {
  var te = re.__.__c;
  return te && te.__a && te.__a(re);
}
function M(re) {
  var te, ee, ie;
  function ne(ae) {
    if (te || (te = re()).then(function(ue) {
      ee = ue.default || ue;
    }, function(ue) {
      ie = ue;
    }), ie)
      throw ie;
    if (!ee)
      throw te;
    return y$1(ee, ae);
  }
  return ne.displayName = "Lazy", ne.__f = !0, ne;
}
function V() {
  this.u = null, this.o = null;
}
l$2.unmount = function(re) {
  var te = re.__c;
  te && te.__R && te.__R(), te && re.__h === !0 && (re.type = null), I && I(re);
}, (D.prototype = new b$1()).__c = function(re, te) {
  var ee = te.__c, ie = this;
  ie.t == null && (ie.t = []), ie.t.push(ee);
  var ne = F(ie.__v), ae = !1, ue = function() {
    ae || (ae = !0, ee.__R = null, ne ? ne(_e) : _e());
  };
  ee.__R = ue;
  var _e = function() {
    if (!--ie.__u) {
      if (ie.state.__a) {
        var le = ie.state.__a;
        ie.__v.__k[0] = U(le, le.__c.__P, le.__c.__O);
      }
      var se;
      for (ie.setState({ __a: ie.__b = null }); se = ie.t.pop(); )
        se.forceUpdate();
    }
  }, fe = te.__h === !0;
  ie.__u++ || fe || ie.setState({ __a: ie.__b = ie.__v.__k[0] }), re.then(ue, ue);
}, D.prototype.componentWillUnmount = function() {
  this.t = [];
}, D.prototype.render = function(re, te) {
  if (this.__b) {
    if (this.__v.__k) {
      var ee = document.createElement("div"), ie = this.__v.__k[0].__c;
      this.__v.__k[0] = L(this.__b, ee, ie.__O = ie.__P);
    }
    this.__b = null;
  }
  var ne = te.__a && y$1(k$2, null, re.fallback);
  return ne && (ne.__h = null), [y$1(k$2, null, te.__a ? null : re.children), ne];
};
var W = function(re, te, ee) {
  if (++ee[1] === ee[0] && re.o.delete(te), re.props.revealOrder && (re.props.revealOrder[0] !== "t" || !re.o.size))
    for (ee = re.u; ee; ) {
      for (; ee.length > 3; )
        ee.pop()();
      if (ee[1] < ee[0])
        break;
      re.u = ee = ee[2];
    }
};
function P(re) {
  return this.getChildContext = function() {
    return re.context;
  }, re.children;
}
function j(re) {
  var te = this, ee = re.i;
  te.componentWillUnmount = function() {
    D$1(null, te.l), te.l = null, te.i = null;
  }, te.i && te.i !== ee && te.componentWillUnmount(), re.__v ? (te.l || (te.i = ee, te.l = { nodeType: 1, parentNode: ee, childNodes: [], appendChild: function(ie) {
    this.childNodes.push(ie), te.i.appendChild(ie);
  }, insertBefore: function(ie, ne) {
    this.childNodes.push(ie), te.i.appendChild(ie);
  }, removeChild: function(ie) {
    this.childNodes.splice(this.childNodes.indexOf(ie) >>> 1, 1), te.i.removeChild(ie);
  } }), D$1(y$1(P, { context: te.context }, re.__v), te.l)) : te.l && te.componentWillUnmount();
}
function z(re, te) {
  var ee = y$1(j, { __v: re, i: te });
  return ee.containerInfo = te, ee;
}
(V.prototype = new b$1()).__a = function(re) {
  var te = this, ee = F(te.__v), ie = te.o.get(re);
  return ie[0]++, function(ne) {
    var ae = function() {
      te.props.revealOrder ? (ie.push(ne), W(te, re, ie)) : ne();
    };
    ee ? ee(ae) : ae();
  };
}, V.prototype.render = function(re) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var te = S(re.children);
  re.revealOrder && re.revealOrder[0] === "b" && te.reverse();
  for (var ee = te.length; ee--; )
    this.o.set(te[ee], this.u = [1, 0, this.u]);
  return re.children;
}, V.prototype.componentDidUpdate = V.prototype.componentDidMount = function() {
  var re = this;
  this.o.forEach(function(te, ee) {
    W(re, ee, te);
  });
};
var B = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, H$1 = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, Z = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, Y = /[A-Z0-9]/g, $ = typeof document < "u", q = function(re) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(re);
};
function G(re, te, ee) {
  return te.__k == null && (te.textContent = ""), D$1(re, te), typeof ee == "function" && ee(), re ? re.__c : null;
}
function J(re, te, ee) {
  return E$1(re, te), typeof ee == "function" && ee(), re ? re.__c : null;
}
b$1.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(re) {
  Object.defineProperty(b$1.prototype, re, { configurable: !0, get: function() {
    return this["UNSAFE_" + re];
  }, set: function(te) {
    Object.defineProperty(this, re, { configurable: !0, writable: !0, value: te });
  } });
});
var K = l$2.event;
function Q() {
}
function X() {
  return this.cancelBubble;
}
function nn() {
  return this.defaultPrevented;
}
l$2.event = function(re) {
  return K && (re = K(re)), re.persist = Q, re.isPropagationStopped = X, re.isDefaultPrevented = nn, re.nativeEvent = re;
};
var tn, en$1 = { enumerable: !1, configurable: !0, get: function() {
  return this.class;
} }, rn = l$2.vnode;
l$2.vnode = function(re) {
  typeof re.type == "string" && function(te) {
    var ee = te.props, ie = te.type, ne = {};
    for (var ae in ee) {
      var ue = ee[ae];
      if (!(ae === "value" && "defaultValue" in ee && ue == null || $ && ae === "children" && ie === "noscript" || ae === "class" || ae === "className")) {
        var _e = ae.toLowerCase();
        ae === "defaultValue" && "value" in ee && ee.value == null ? ae = "value" : ae === "download" && ue === !0 ? ue = "" : _e === "ondoubleclick" ? ae = "ondblclick" : _e !== "onchange" || ie !== "input" && ie !== "textarea" || q(ee.type) ? _e === "onfocus" ? ae = "onfocusin" : _e === "onblur" ? ae = "onfocusout" : Z.test(ae) ? ae = _e : ie.indexOf("-") === -1 && H$1.test(ae) ? ae = ae.replace(Y, "-$&").toLowerCase() : ue === null && (ue = void 0) : _e = ae = "oninput", _e === "oninput" && ne[ae = _e] && (ae = "oninputCapture"), ne[ae] = ue;
      }
    }
    ie == "select" && ne.multiple && Array.isArray(ne.value) && (ne.value = S(ee.children).forEach(function(fe) {
      fe.props.selected = ne.value.indexOf(fe.props.value) != -1;
    })), ie == "select" && ne.defaultValue != null && (ne.value = S(ee.children).forEach(function(fe) {
      fe.props.selected = ne.multiple ? ne.defaultValue.indexOf(fe.props.value) != -1 : ne.defaultValue == fe.props.value;
    })), ee.class && !ee.className ? (ne.class = ee.class, Object.defineProperty(ne, "className", en$1)) : (ee.className && !ee.class || ee.class && ee.className) && (ne.class = ne.className = ee.className), te.props = ne;
  }(re), re.$$typeof = B, rn && rn(re);
};
var un = l$2.__r;
l$2.__r = function(re) {
  un && un(re), tn = re.__c;
};
var on = l$2.diffed;
l$2.diffed = function(re) {
  on && on(re);
  var te = re.props, ee = re.__e;
  ee != null && re.type === "textarea" && "value" in te && te.value !== ee.value && (ee.value = te.value == null ? "" : te.value), tn = null;
};
var ln = { ReactCurrentDispatcher: { current: { readContext: function(re) {
  return tn.__n[re.__c].props.value;
} } } };
function fn(re) {
  return y$1.bind(null, re);
}
function an(re) {
  return !!re && re.$$typeof === B;
}
function sn(re) {
  return an(re) ? F$2.apply(null, arguments) : re;
}
function hn(re) {
  return !!re.__k && (D$1(null, re), !0);
}
function vn(re) {
  return re && (re.base || re.nodeType === 1 && re) || null;
}
var dn = function(re, te) {
  return re(te);
}, pn = function(re, te) {
  return re(te);
}, mn = k$2;
function yn(re) {
  re();
}
function _n(re) {
  return re;
}
function bn() {
  return [!1, yn];
}
var Sn = y;
function gn(re, te) {
  var ee = te(), ie = h$2({ h: { __: ee, v: te } }), ne = ie[0].h, ae = ie[1];
  return y(function() {
    ne.__ = ee, ne.v = te, E(ne.__, te()) || ae({ h: ne });
  }, [re, ee, te]), p(function() {
    return E(ne.__, ne.v()) || ae({ h: ne }), re(function() {
      E(ne.__, ne.v()) || ae({ h: ne });
    });
  }, [re]), ee;
}
var Cn = { useState: h$2, useId: V$1, useReducer: s, useEffect: p, useLayoutEffect: y, useInsertionEffect: Sn, useTransition: bn, useDeferredValue: _n, useSyncExternalStore: gn, startTransition: yn, useRef: _, useImperativeHandle: A$1, useMemo: F$1, useCallback: T$1, useContext: q$1, useDebugValue: x$1, version: "17.0.2", Children: O, render: G, hydrate: J, unmountComponentAtNode: hn, createPortal: z, createElement: y$1, createContext: G$1, createFactory: fn, cloneElement: sn, createRef: _$1, Fragment: k$2, isValidElement: an, findDOMNode: vn, Component: b$1, PureComponent: w, memo: x, forwardRef: k, flushSync: pn, unstable_batchedUpdates: dn, StrictMode: mn, Suspense: D, SuspenseList: V, lazy: M, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: ln };
function defaultVideoQuality() {
  return {
    isAuto: !0,
    id: "auto",
    height: 0,
    width: 0
  };
}
function createDefaultPlayerContextState() {
  return {
    playerState: {
      audioTracks: [],
      cumulatedPlayTimeInSec: 0,
      durationInSec: 0,
      isFullscreenMode: !1,
      isInPictureInPictureMode: !1,
      isHdPlayback: !1,
      isShowingAd: !1,
      liveStatus: void 0,
      maxTimeShiftInSec: 0,
      playbackMode: "VOD",
      playbackPosInSec: 0,
      playbackSpeed: 1,
      playerStatus: "IDLE",
      selectedAudioTrack: void 0,
      selectedSubtitleTrack: void 0,
      selectedVideoQuality: defaultVideoQuality(),
      subtitleTracks: [],
      timeShiftInSec: 0,
      videoBufferLengthInSec: 0,
      videoLoaded: !1,
      videoQualities: [],
      isVRVideo: !1
    },
    init: () => {
    }
  };
}
const defaultPlayerContextState = createDefaultPlayerContextState(), PlayerStateContext = G$1(null);
function createPlayerStateFromCoordinator(re) {
  var ie, ne, ae;
  const te = re.getPlaybackMode(), ee = te === "LIVE" ? re.getLiveVariant() : void 0;
  return {
    audioTracks: re.getAvailableAudioTracks(),
    cumulatedPlayTimeInSec: re.getCumulatedPlayTimeInSec(),
    currentErrorDetails: re.getCurrentErrorDetails(),
    durationInSec: re.getDurationInSec(),
    isFullscreenMode: re.isInFullscreenMode(),
    isInPictureInPictureMode: re.isInPictureInPictureMode(),
    isHdPlayback: re.isHdPlayback(),
    isShowingAd: ((ie = re.getPlayerData()) == null ? void 0 : ie.isShowingAd()) ?? !1,
    liveStatus: re.getLiveStatus(),
    liveVariant: ee,
    maxTimeShiftInSec: re.getMaxTimeShiftInSec(),
    mediaMetaData: re.getMediaMetaData(),
    playbackMode: te,
    playbackPosInSec: ((ne = re.getPlayerData()) == null ? void 0 : ne.getCurrentTimeInSec()) ?? 0,
    playbackSpeed: re.getPlaybackSpeed(),
    playerConfiguration: re.getPlayerConfiguration(),
    playerCoordinator: re,
    playerStatus: re.getPlayerStatus(),
    posterImage: re.getPosterImage(),
    selectedAudioTrack: re.getSelectedAudioTrack(),
    selectedSubtitleTrack: re.getSelectedSubtitleTrack(),
    selectedVideoQuality: re.getSelectedVideoQuality(),
    subtitleTracks: re.getSubtitleTracks(),
    timeShiftInSec: re.getTimeShiftInSec(),
    videoBufferLengthInSec: re.getBufferLengthInSec(),
    videoLoaded: re.isVideoLoaded,
    videoQualities: re.getAvailableVideoQualities(),
    isVRVideo: ((ae = re.getPlayerData()) == null ? void 0 : ae.isVRVideo()) ?? !1
  };
}
const PlayerStateContextProvider = ({ children: re }) => {
  const [te, ee] = h$2(defaultPlayerContextState.playerState), [ie, ne] = h$2(), ae = T$1((_e) => {
    ne(_e);
  }, []);
  p(() => {
    if (!ie)
      return () => {
      };
    const _e = (le) => {
      const se = createPlayerStateFromCoordinator(ie);
      ee(se);
    };
    ie.addEventListener(_e);
    const fe = createPlayerStateFromCoordinator(ie);
    return ee(fe), () => {
      ie.removeEventListener(_e);
    };
  }, [ie]);
  const ue = F$1(() => ({ playerState: te, init: ae }), [te, ae]);
  return /* @__PURE__ */ Cn.createElement(PlayerStateContext.Provider, { value: ue }, re);
}, usePlayerContext = () => {
  const re = q$1(PlayerStateContext);
  if (!re)
    throw new Error("no player state context context found");
  return re;
};
var commonjsGlobal$1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(re) {
  return re && re.__esModule && Object.prototype.hasOwnProperty.call(re, "default") ? re.default : re;
}
var loglevel = { exports: {} };
(function(re) {
  (function(te, ee) {
    re.exports ? re.exports = ee() : te.log = ee();
  })(commonjsGlobal$1, function() {
    var te = function() {
    }, ee = "undefined", ie = typeof window !== ee && typeof window.navigator !== ee && /Trident\/|MSIE /.test(window.navigator.userAgent), ne = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ];
    function ae(ve, me) {
      var be = ve[me];
      if (typeof be.bind == "function")
        return be.bind(ve);
      try {
        return Function.prototype.bind.call(be, ve);
      } catch {
        return function() {
          return Function.prototype.apply.apply(be, [ve, arguments]);
        };
      }
    }
    function ue() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function _e(ve) {
      return ve === "debug" && (ve = "log"), typeof console === ee ? !1 : ve === "trace" && ie ? ue : console[ve] !== void 0 ? ae(console, ve) : console.log !== void 0 ? ae(console, "log") : te;
    }
    function fe(ve, me) {
      for (var be = 0; be < ne.length; be++) {
        var pe = ne[be];
        this[pe] = be < ve ? te : this.methodFactory(pe, ve, me);
      }
      this.log = this.debug;
    }
    function le(ve, me, be) {
      return function() {
        typeof console !== ee && (fe.call(this, me, be), this[ve].apply(this, arguments));
      };
    }
    function se(ve, me, be) {
      return _e(ve) || le.apply(this, arguments);
    }
    function oe(ve, me, be) {
      var pe = this, $e;
      me = me ?? "WARN";
      var ye = "loglevel";
      typeof ve == "string" ? ye += ":" + ve : typeof ve == "symbol" && (ye = void 0);
      function Se(Ee) {
        var Me = (ne[Ee] || "silent").toUpperCase();
        if (!(typeof window === ee || !ye)) {
          try {
            window.localStorage[ye] = Me;
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(ye) + "=" + Me + ";";
          } catch {
          }
        }
      }
      function we() {
        var Ee;
        if (!(typeof window === ee || !ye)) {
          try {
            Ee = window.localStorage[ye];
          } catch {
          }
          if (typeof Ee === ee)
            try {
              var Me = window.document.cookie, Ae = Me.indexOf(
                encodeURIComponent(ye) + "="
              );
              Ae !== -1 && (Ee = /^([^;]+)/.exec(Me.slice(Ae))[1]);
            } catch {
            }
          return pe.levels[Ee] === void 0 && (Ee = void 0), Ee;
        }
      }
      function Pe() {
        if (!(typeof window === ee || !ye)) {
          try {
            window.localStorage.removeItem(ye);
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(ye) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch {
          }
        }
      }
      pe.name = ve, pe.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, pe.methodFactory = be || se, pe.getLevel = function() {
        return $e;
      }, pe.setLevel = function(Ee, Me) {
        if (typeof Ee == "string" && pe.levels[Ee.toUpperCase()] !== void 0 && (Ee = pe.levels[Ee.toUpperCase()]), typeof Ee == "number" && Ee >= 0 && Ee <= pe.levels.SILENT) {
          if ($e = Ee, Me !== !1 && Se(Ee), fe.call(pe, Ee, ve), typeof console === ee && Ee < pe.levels.SILENT)
            return "No console available for logging";
        } else
          throw "log.setLevel() called with invalid level: " + Ee;
      }, pe.setDefaultLevel = function(Ee) {
        me = Ee, we() || pe.setLevel(Ee, !1);
      }, pe.resetLevel = function() {
        pe.setLevel(me, !1), Pe();
      }, pe.enableAll = function(Ee) {
        pe.setLevel(pe.levels.TRACE, Ee);
      }, pe.disableAll = function(Ee) {
        pe.setLevel(pe.levels.SILENT, Ee);
      };
      var Te = we();
      Te == null && (Te = me), pe.setLevel(Te, !1);
    }
    var ce = new oe(), he = {};
    ce.getLogger = function(me) {
      if (typeof me != "symbol" && typeof me != "string" || me === "")
        throw new TypeError("You must supply a name when creating a logger.");
      var be = he[me];
      return be || (be = he[me] = new oe(
        me,
        ce.getLevel(),
        ce.methodFactory
      )), be;
    };
    var ge = typeof window !== ee ? window.log : void 0;
    return ce.noConflict = function() {
      return typeof window !== ee && window.log === ce && (window.log = ge), ce;
    }, ce.getLoggers = function() {
      return he;
    }, ce.default = ce, ce;
  });
})(loglevel);
var loglevelExports = loglevel.exports;
const log$j = loglevelExports.getLogger("EventEmitter");
let EventEmitter$1 = class {
  constructor() {
    Et(this, "listeners", []);
  }
  addEventListener(te) {
    if (!this.listeners.includes(te))
      this.listeners.push(te);
    else
      throw new Error(`Listener ${te} already registered`);
  }
  removeEventListener(te) {
    const ee = this.listeners;
    ee.includes(te) ? this.listeners = ee.filter((ie) => ie !== te) : log$j.warn(`Listener ${te} was not registered`);
  }
  fireEvent(te) {
    this.listeners.forEach((ee) => {
      try {
        ee(te);
      } catch (ie) {
        log$j.error("Error invoking listener", ee, "for event", te, "error", ie);
      }
    });
  }
};
const DEFAULT_FEEDBACK_URL = "https://feedback.redbull.com/hc/en-us/requests/new", RBUP_FALLBACK_POSTER_IMAGE = "https://player-images.redbull.com/image/upload/{op}/placeholder.jpg", SSDM_SERVER_URL_PRODUCTION = "https://api-player.redbull.com", SSDM_SERVER_URL_STAGING = "https://api-player-staging.redbull.com";
function calculateSsdmUrl(re, te) {
  if (te && !isNaN(te))
    return `https://rbup-datamanager-pr-${te}.herokuapp.com`;
  switch (re) {
    case "PRODUCTION":
      return SSDM_SERVER_URL_PRODUCTION;
    case "STAGING":
      return SSDM_SERVER_URL_STAGING;
    default:
      throw new Error("unknown server environment");
  }
}
loglevelExports.getLogger("fetchUserLocation");
function addLeadingZero(re) {
  return re < 0 ? `${re}` : re < 10 ? `0${re}` : `${re}`;
}
const DEFAULT_SEEK_SKIP_SECONDS = 10, AspectRatios = ["16:9", "4:5", "4:3", "2:3", "2:1", "1:1", "9:16"], RBUP_VIDEO_DOM_EVENT_TYPE = "rbup-video-core", RBUP_AUDIO_DOM_EVENT_TYPE = "rbup-audio-core", publicPlayerEventTypes = [
  "adFinished",
  "adSkipped",
  "beforePlay",
  "loaded",
  "muted",
  "paused",
  "play",
  "playbackFinished",
  "seeking",
  "timeChanged",
  "timeshifting",
  "unmuted",
  "nextUpCancelled",
  "nextUpDisplayed",
  "nextUpTimeout",
  "nextUpTriggered",
  "podcastTitleClick"
], KEYCODE_ARROW_RIGHT = "ArrowRight", KEYCODE_ARROW_LEFT = "ArrowLeft", KEYCODE_ARROW_DOWN = "ArrowDown", KEYCODE_ARROW_UP = "ArrowUp", KEYCODE_SPACE = " ", KEYCODE_ESC = "Escape", KEYCODE_ENTER = "Enter", KEYCODE_B = "b", KEYCODE_F = "f", KEYCODE_I = "i", KEYCODE_K = "k", KEYCODE_M = "m", KEYCODE_R = "r", KEYCODE_0 = "0", log$i = loglevelExports.getLogger("AspectRatioUtils"), defaultExpectRatio = "16:9", aspectRatioRegex = new RegExp("^(\\d*):(\\d*)$"), maxWidthForLandscapeAspectRatio = "100%", maxWidthForPortraitAspectRatio = "400px";
function getMaxWidthForAspectRatio(re) {
  switch (re) {
    case "4:5":
    case "2:3":
    case "1:1":
    case "9:16":
      return maxWidthForPortraitAspectRatio;
    case "16:9":
    case "4:3":
    case "2:1":
      return maxWidthForLandscapeAspectRatio;
    default:
      return log$i.error("unexpected aspect ratio", re), maxWidthForLandscapeAspectRatio;
  }
}
function validateGivenAspectRatio(re) {
  return re && aspectRatioRegex.exec(re) && isAspectRatio(re) ? re : defaultExpectRatio;
}
function isAspectRatio(re) {
  return AspectRatios.includes(re);
}
function transformAspectRatioForCss(re) {
  return re.replace(":", "/");
}
function calcValueOfAspectRatio(re) {
  const [te, ee] = re.split(":").map((ie) => Number.parseInt(ie, 10));
  return te / ee;
}
const Breakpoint = {
  small: 540,
  medium: 650,
  large: 1e3,
  xLarge: 1200,
  xxLarge: 1350
}, BREAKPOINTS = [
  Breakpoint.small,
  Breakpoint.medium,
  Breakpoint.large,
  Breakpoint.xLarge,
  Breakpoint.xxLarge
];
function calculateCachingHeaders(re) {
  if (re)
    return {
      "cache-control": "max-age=0"
    };
}
const imTransformation = (re) => `/im:i:${re}/`, imDelimiterTransformation = (re) => `/im:i:${re}?`, opTransformation = (re) => `/${re}/`, transformations = [
  { placeholder: "/im/", transformation: imTransformation },
  { placeholder: "/{im}/", transformation: imTransformation },
  { placeholder: "/{im}?", transformation: imDelimiterTransformation },
  { placeholder: "/{op}/", transformation: opTransformation }
], posterSizeWidths = [2560, 1920, 1280, 854, 640, 426, 320], mediaSessionSizeWidths = [512, 384, 256, 192, 128, 96];
function calculateMediaSessionSrcSet(re) {
  if (re !== void 0)
    return mediaSessionSizeWidths.map((te) => {
      const ee = te;
      return {
        src: getPosterUrlForWidthAndAspectRatio(re, te, 1),
        sizes: `${te}x${ee}`
      };
    });
}
function calculatePosterSrcSet(re, te = "16:9") {
  const ee = calcValueOfAspectRatio(te);
  if (transformations.some(({ placeholder: ne }) => re.includes(ne))) {
    const ne = posterSizeWidths.map((ae) => `${getPosterUrlForWidthAndAspectRatio(re, ae, ee)} ${ae}w`).join(", ");
    return {
      src: getPosterUrlForWidthAndAspectRatio(re, 1280, ee),
      srcSet: ne
    };
  }
  return { src: re };
}
function getPosterUrlForWidthAndAspectRatio(re, te, ee) {
  return transformations.reduce((ie, { placeholder: ne, transformation: ae }) => ie.replace(ne, ae(`c_fill,w_${te},ar_${ee},q_auto,g_auto,f_auto`)), re);
}
function getTouch(re) {
  return re.changedTouches.length >= 1 ? re.changedTouches[0] : void 0;
}
function getDetectedInteractionCoordinates(re) {
  var te, ee;
  return isTouchEvent(re) ? {
    clientX: ((te = getTouch(re)) == null ? void 0 : te.clientX) ?? 0,
    clientY: ((ee = getTouch(re)) == null ? void 0 : ee.clientY) ?? 0
  } : {
    clientX: re.clientX,
    clientY: re.clientY
  };
}
function calculateRelativeCoordinates(re, te) {
  const ee = te.current;
  if (!ee)
    return;
  const ie = ee.getBoundingClientRect(), ne = getDetectedInteractionCoordinates(re), ae = ne.clientX - (ie.x + document.body.scrollLeft), ue = ne.clientY - (ie.y + document.body.scrollTop);
  return { x: ae, y: ue, elementBoundingRect: ie };
}
function extractPlaybackPositionInPercentFromEvent(re, te) {
  const ee = calculateRelativeCoordinates(re, te);
  if (ee) {
    const ie = ee.elementBoundingRect.width, ne = ee.x >= 0, ae = ee.x <= ie, ue = ne ? ee.x : 0, _e = ae ? ie : ee.x;
    return roundPlaybackPercentage(ue / _e);
  }
}
function isTouchEvent(re) {
  return re.type.includes("touch");
}
function getBrowserLanguage() {
  return window.navigator.language ? window.navigator.language.split("-")[0] : "";
}
function getFormattedTimeString(re) {
  const te = Math.floor(re / 3600), ee = Math.floor(re / 60) - te * 60, ie = Math.floor(re) % 60;
  return te < 1 ? `${addLeadingZero(ee)}:${addLeadingZero(ie)}` : `${addLeadingZero(te)}:${addLeadingZero(ee)}:${addLeadingZero(ie)}`;
}
function getThemeCSSVariables(re) {
  let te = {};
  return re != null && re.fontFamily && (te = {
    ...te,
    "--rbup-font-family": re.fontFamily
  }), re != null && re.componentFontFamily && (te = {
    ...te,
    "--rbup-component-font-family": re.componentFontFamily
  }), re != null && re.primaryColor && (te = {
    ...te,
    "--rbup-primary-color": re.primaryColor,
    "--rbup-play-button-background-color": re.primaryColor,
    "--rbup-play-button-background-hover-color": re.primaryColorHover ?? re.primaryColor
  }), re != null && re.lineHeight && (te = {
    ...te,
    "--rbup-text-line-height": re.lineHeight
  }), re != null && re.containerBackgroundColor && (te = {
    ...te,
    "--rbup-container16x9-background-color": re.containerBackgroundColor
  }), te;
}
function handlePlayPauseToggle(re, te) {
  switch (re) {
    case "ENDED":
    case "BUFFERING":
      return;
    case "PLAYING":
      te == null || te.pause();
      break;
    case "PAUSED":
    case "IDLE":
      te == null || te.play();
      break;
  }
}
function getPositionFromEvent(re) {
  const { pageX: te, pageY: ee } = "touches" in re ? re.touches[0] : re;
  return {
    x: te,
    y: ee
  };
}
function hasPositionMoved(re, te) {
  const ee = te.x - re.x, ie = te.y - re.y;
  return ee !== 0 && ie !== 0;
}
function isMobileDevice() {
  return /(?:iPhone|iPad|iPod|Android)/.test(window.navigator.userAgent) ? !0 : window.navigator.maxTouchPoints >= 3;
}
const MouseButton = {
  primary: 0,
  secondary: 1,
  auxiliary: 2,
  back: 3
}, PointerTypes = {
  mouse: "mouse",
  touch: "touch"
};
function isLeftClick(re) {
  return isMouse(re) && re.button === MouseButton.primary;
}
function isMouse(re) {
  return re.pointerType === PointerTypes.mouse;
}
function isTouch(re) {
  return re.pointerType === PointerTypes.touch;
}
function roundPlaybackPercentage(re) {
  return roundNumber(re, 5);
}
function roundPlaybackSec(re) {
  return roundNumber(re, 2);
}
function roundNumber(re, te) {
  const ee = Math.pow(10, te);
  return Math.round(re * ee) / ee;
}
function eqSet(re, te) {
  if (re.size !== te.size)
    return !1;
  for (const ee of re)
    if (!te.has(ee))
      return !1;
  return !0;
}
function createControllablePromise() {
  let re, te;
  const ee = new Promise((ie, ne) => {
    re = ie, te = ne;
  });
  return Object.assign(ee, {
    resolve: (ie) => re(ie),
    reject: (ie) => te(ie)
  });
}
function isNotNullOrUndefined(re) {
  return re != null;
}
function resolveErrorMessageFromUnknown(re) {
  return isObject$1(re) && re.hasOwnProperty("message") ? re.message : `Unknown error ${re == null ? void 0 : re.toString()}`;
}
function isObject$1(re) {
  return !!re && typeof re == "object";
}
function deepEqual(re, te) {
  if (re === te)
    return !0;
  if (!isObject(re) || !isObject(te) || Object.keys(re).length !== Object.keys(te).length)
    return !1;
  for (const ee in re)
    if (te.hasOwnProperty(ee)) {
      if (!deepEqual(re[ee], te[ee]))
        return !1;
    } else
      return !1;
  return !0;
}
function isObject(re) {
  return !!re && typeof re == "object";
}
const tagId = "rbup-video-cosmos-font-injection";
function injectCosmosFontIntoHeader(re) {
  if (!alreadyInjected()) {
    const te = document.createElement("style");
    te.id = tagId, te.innerHTML = re, document.getElementsByTagName("head")[0].appendChild(te);
  }
}
function alreadyInjected() {
  return document.getElementById(tagId) !== null;
}
function removeNoLongerExistingAttributes(re, te, ee) {
  const ie = re.getAttributeNames(), ne = Object.keys(te);
  for (const ae of ie)
    ae !== "id" && !ne.includes(ae) && (ee.debug("removing excess attribute from web component", ae), re.removeAttribute(ae));
}
function deleteUndefinedValues(re) {
  for (const te in re)
    re[te] === void 0 && delete re[te];
}
const dashToPascalCase = (re) => re.toLowerCase().split("-").map((te) => te.charAt(0).toUpperCase() + te.slice(1)).join(""), isEventProp = (re) => re.indexOf("on") === 0 && re[2] === re[2].toUpperCase(), normalizeEventPropName = (re) => `on${re[2].toLowerCase()}${re.substring(3)}`;
function createPreactComponent({ tagName: re, defaultProps: te, defineCustomElement: ee }) {
  ee !== void 0 && ee();
  const ie = (ne) => {
    const ae = Object.entries(ne).reduce((ue, [_e, fe]) => isEventProp(_e) ? Object.assign(Object.assign({}, ue), { [`${normalizeEventPropName(_e)}`]: fe }) : Object.assign(Object.assign({}, ue), { [_e]: fe }), {});
    return y$1(re, Object.assign(Object.assign({}, te), ae));
  };
  return ie.displayName = `${dashToPascalCase(re)}`, ie;
}
const NAMESPACE = "cosmos-web", BUILD = (
  /* cosmos-web */
  { allRenderFn: !0, appendChildSlotFix: !1, asyncLoading: !0, asyncQueue: !1, attachStyles: !0, cloneNodeFix: !1, cmpDidLoad: !0, cmpDidRender: !0, cmpDidUnload: !1, cmpDidUpdate: !1, cmpShouldUpdate: !1, cmpWillLoad: !0, cmpWillRender: !0, cmpWillUpdate: !1, connectedCallback: !0, constructableCSS: !0, cssAnnotations: !0, devTools: !1, disconnectedCallback: !0, element: !1, event: !0, experimentalScopedSlotChanges: !1, experimentalSlotFixes: !1, formAssociated: !1, hasRenderFn: !0, hostListener: !0, hostListenerTarget: !1, hostListenerTargetBody: !1, hostListenerTargetDocument: !1, hostListenerTargetParent: !1, hostListenerTargetWindow: !1, hotModuleReplacement: !1, hydrateClientSide: !0, hydrateServerSide: !1, hydratedAttribute: !1, hydratedClass: !0, hydratedSelectorName: "hydrated", invisiblePrehydration: !0, isDebug: !1, isDev: !1, isTesting: !1, lazyLoad: !1, lifecycle: !0, lifecycleDOMEvents: !1, member: !0, method: !0, mode: !1, observeAttribute: !0, profile: !1, prop: !0, propBoolean: !0, propMutable: !0, propNumber: !0, propString: !0, reflect: !0, scoped: !1, scopedSlotTextContentFix: !1, scriptDataOpts: !1, shadowDelegatesFocus: !1, shadowDom: !0, slot: !0, slotChildNodesFix: !1, slotRelocation: !0, state: !0, style: !0, svg: !0, taskQueue: !0, updatable: !0, vdomAttribute: !0, vdomClass: !0, vdomFunctional: !0, vdomKey: !0, vdomListener: !0, vdomPropOrAttr: !0, vdomRef: !0, vdomRender: !0, vdomStyle: !0, vdomText: !0, vdomXlink: !1, watchCallback: !0 }
);
var __defProp$1 = Object.defineProperty, __export$1 = (re, te) => {
  for (var ee in te)
    __defProp$1(re, ee, { get: te[ee], enumerable: !0 });
}, EMPTY_OBJ = {}, SVG_NS = "http://www.w3.org/2000/svg", HTML_NS = "http://www.w3.org/1999/xhtml", isDef = (re) => re != null, isComplexType$1 = (re) => (re = typeof re, re === "object" || re === "function");
function queryNonceMetaTagContent(re) {
  var te, ee, ie;
  return (ie = (ee = (te = re.head) == null ? void 0 : te.querySelector('meta[name="csp-nonce"]')) == null ? void 0 : ee.getAttribute("content")) != null ? ie : void 0;
}
var result_exports$1 = {};
__export$1(result_exports$1, {
  err: () => err$1,
  map: () => map$1,
  ok: () => ok$1,
  unwrap: () => unwrap$1,
  unwrapErr: () => unwrapErr$1
});
var ok$1 = (re) => ({
  isOk: !0,
  isErr: !1,
  value: re
}), err$1 = (re) => ({
  isOk: !1,
  isErr: !0,
  value: re
});
function map$1(re, te) {
  if (re.isOk) {
    const ee = te(re.value);
    return ee instanceof Promise ? ee.then((ie) => ok$1(ie)) : ok$1(ee);
  }
  if (re.isErr) {
    const ee = re.value;
    return err$1(ee);
  }
  throw "should never get here";
}
var unwrap$1 = (re) => {
  if (re.isOk)
    return re.value;
  throw re.value;
}, unwrapErr$1 = (re) => {
  if (re.isErr)
    return re.value;
  throw re.value;
}, createTime = (re, te = "") => () => {
}, uniqueTime = (re, te) => () => {
}, CONTENT_REF_ID = "r", ORG_LOCATION_ID = "o", SLOT_NODE_ID = "s", TEXT_NODE_ID = "t", HYDRATE_ID = "s-id", HYDRATED_STYLE_ID = "sty-id", HYDRATE_CHILD_ID = "c-id", SLOT_FB_CSS = "slot-fb{display:contents}slot-fb[hidden]{display:none}", h$1 = (re, te, ...ee) => {
  let ie = null, ne = null, ae = null, ue = !1, _e = !1;
  const fe = [], le = (oe) => {
    for (let ce = 0; ce < oe.length; ce++)
      ie = oe[ce], Array.isArray(ie) ? le(ie) : ie != null && typeof ie != "boolean" && ((ue = typeof re != "function" && !isComplexType$1(ie)) && (ie = String(ie)), ue && _e ? fe[fe.length - 1].$text$ += ie : fe.push(ue ? newVNode$1(null, ie) : ie), _e = ue);
  };
  if (le(ee), te) {
    te.key && (ne = te.key), te.name && (ae = te.name);
    {
      const oe = te.className || te.class;
      oe && (te.class = typeof oe != "object" ? oe : Object.keys(oe).filter((ce) => oe[ce]).join(" "));
    }
  }
  if (typeof re == "function")
    return re(
      te === null ? {} : te,
      fe,
      vdomFnUtils$1
    );
  const se = newVNode$1(re, null);
  return se.$attrs$ = te, fe.length > 0 && (se.$children$ = fe), se.$key$ = ne, se.$name$ = ae, se;
}, newVNode$1 = (re, te) => {
  const ee = {
    $flags$: 0,
    $tag$: re,
    $text$: te,
    $elm$: null,
    $children$: null
  };
  return ee.$attrs$ = null, ee.$key$ = null, ee.$name$ = null, ee;
}, Host = {}, isHost = (re) => re && re.$tag$ === Host, vdomFnUtils$1 = {
  forEach: (re, te) => re.map(convertToPublic$1).forEach(te),
  map: (re, te) => re.map(convertToPublic$1).map(te).map(convertToPrivate$1)
}, convertToPublic$1 = (re) => ({
  vattrs: re.$attrs$,
  vchildren: re.$children$,
  vkey: re.$key$,
  vname: re.$name$,
  vtag: re.$tag$,
  vtext: re.$text$
}), convertToPrivate$1 = (re) => {
  if (typeof re.vtag == "function") {
    const ee = { ...re.vattrs };
    return re.vkey && (ee.key = re.vkey), re.vname && (ee.name = re.vname), h$1(re.vtag, ee, ...re.vchildren || []);
  }
  const te = newVNode$1(re.vtag, re.vtext);
  return te.$attrs$ = re.vattrs, te.$children$ = re.vchildren, te.$key$ = re.vkey, te.$name$ = re.vname, te;
}, initializeClientHydrate = (re, te, ee, ie) => {
  const ne = createTime("hydrateClient", te), ae = re.shadowRoot, ue = [], _e = [], fe = ae ? [] : null, le = ie.$vnode$ = newVNode$1(te, null);
  plt.$orgLocNodes$ || initializeDocumentHydrate(doc.body, plt.$orgLocNodes$ = /* @__PURE__ */ new Map()), re[HYDRATE_ID] = ee, re.removeAttribute(HYDRATE_ID), clientHydrate(le, ue, _e, fe, re, re, ee), ue.map((se) => {
    const oe = se.$hostId$ + "." + se.$nodeId$, ce = plt.$orgLocNodes$.get(oe), he = se.$elm$;
    ce && supportsShadow && ce["s-en"] === "" && ce.parentNode.insertBefore(he, ce.nextSibling), ae || (he["s-hn"] = te, ce && (he["s-ol"] = ce, he["s-ol"]["s-nr"] = he)), plt.$orgLocNodes$.delete(oe);
  }), ae && fe.map((se) => {
    se && ae.appendChild(se);
  }), ne();
}, clientHydrate = (re, te, ee, ie, ne, ae, ue) => {
  let _e, fe, le, se;
  if (ae.nodeType === 1) {
    for (_e = ae.getAttribute(HYDRATE_CHILD_ID), _e && (fe = _e.split("."), (fe[0] === ue || fe[0] === "0") && (le = {
      $flags$: 0,
      $hostId$: fe[0],
      $nodeId$: fe[1],
      $depth$: fe[2],
      $index$: fe[3],
      $tag$: ae.tagName.toLowerCase(),
      $elm$: ae,
      $attrs$: null,
      $children$: null,
      $key$: null,
      $name$: null,
      $text$: null
    }, te.push(le), ae.removeAttribute(HYDRATE_CHILD_ID), re.$children$ || (re.$children$ = []), re.$children$[le.$index$] = le, re = le, ie && le.$depth$ === "0" && (ie[le.$index$] = le.$elm$))), se = ae.childNodes.length - 1; se >= 0; se--)
      clientHydrate(
        re,
        te,
        ee,
        ie,
        ne,
        ae.childNodes[se],
        ue
      );
    if (ae.shadowRoot)
      for (se = ae.shadowRoot.childNodes.length - 1; se >= 0; se--)
        clientHydrate(
          re,
          te,
          ee,
          ie,
          ne,
          ae.shadowRoot.childNodes[se],
          ue
        );
  } else if (ae.nodeType === 8)
    fe = ae.nodeValue.split("."), (fe[1] === ue || fe[1] === "0") && (_e = fe[0], le = {
      $flags$: 0,
      $hostId$: fe[1],
      $nodeId$: fe[2],
      $depth$: fe[3],
      $index$: fe[4],
      $elm$: ae,
      $attrs$: null,
      $children$: null,
      $key$: null,
      $name$: null,
      $tag$: null,
      $text$: null
    }, _e === TEXT_NODE_ID ? (le.$elm$ = ae.nextSibling, le.$elm$ && le.$elm$.nodeType === 3 && (le.$text$ = le.$elm$.textContent, te.push(le), ae.remove(), re.$children$ || (re.$children$ = []), re.$children$[le.$index$] = le, ie && le.$depth$ === "0" && (ie[le.$index$] = le.$elm$))) : le.$hostId$ === ue && (_e === SLOT_NODE_ID ? (le.$tag$ = "slot", fe[5] ? ae["s-sn"] = le.$name$ = fe[5] : ae["s-sn"] = "", ae["s-sr"] = !0, ie && (le.$elm$ = doc.createElement(le.$tag$), le.$name$ && le.$elm$.setAttribute("name", le.$name$), ae.parentNode.insertBefore(le.$elm$, ae), ae.remove(), le.$depth$ === "0" && (ie[le.$index$] = le.$elm$)), ee.push(le), re.$children$ || (re.$children$ = []), re.$children$[le.$index$] = le) : _e === CONTENT_REF_ID && (ie ? ae.remove() : (ne["s-cr"] = ae, ae["s-cn"] = !0))));
  else if (re && re.$tag$ === "style") {
    const oe = newVNode$1(null, ae.textContent);
    oe.$elm$ = ae, oe.$index$ = "0", re.$children$ = [oe];
  }
}, initializeDocumentHydrate = (re, te) => {
  if (re.nodeType === 1) {
    let ee = 0;
    for (; ee < re.childNodes.length; ee++)
      initializeDocumentHydrate(re.childNodes[ee], te);
    if (re.shadowRoot)
      for (ee = 0; ee < re.shadowRoot.childNodes.length; ee++)
        initializeDocumentHydrate(re.shadowRoot.childNodes[ee], te);
  } else if (re.nodeType === 8) {
    const ee = re.nodeValue.split(".");
    ee[0] === ORG_LOCATION_ID && (te.set(ee[1] + "." + ee[2], re), re.nodeValue = "", re["s-en"] = ee[3]);
  }
}, parsePropertyValue = (re, te) => re != null && !isComplexType$1(re) ? te & 4 ? re === "false" ? !1 : re === "" || !!re : te & 2 ? parseFloat(re) : te & 1 ? String(re) : re : re, getElement = (re) => re, createEvent = (re, te, ee) => {
  const ie = getElement(re);
  return {
    emit: (ne) => emitEvent(ie, te, {
      bubbles: !!(ee & 4),
      composed: !!(ee & 2),
      cancelable: !!(ee & 1),
      detail: ne
    })
  };
}, emitEvent = (re, te, ee) => {
  const ie = plt.ce(te, ee);
  return re.dispatchEvent(ie), ie;
}, rootAppliedStyles = /* @__PURE__ */ new WeakMap(), registerStyle = (re, te, ee) => {
  let ie = styles$2.get(re);
  supportsConstructableStylesheets && ee ? (ie = ie || new CSSStyleSheet(), typeof ie == "string" ? ie = te : ie.replaceSync(te)) : ie = te, styles$2.set(re, ie);
}, addStyle = (re, te, ee) => {
  var ie;
  const ne = getScopeId(te), ae = styles$2.get(ne);
  if (re = re.nodeType === 11 ? re : doc, ae)
    if (typeof ae == "string") {
      re = re.head || re;
      let ue = rootAppliedStyles.get(re), _e;
      if (ue || rootAppliedStyles.set(re, ue = /* @__PURE__ */ new Set()), !ue.has(ne)) {
        if (re.host && (_e = re.querySelector(`[${HYDRATED_STYLE_ID}="${ne}"]`)))
          _e.innerHTML = ae;
        else {
          _e = doc.createElement("style"), _e.innerHTML = ae;
          const fe = (ie = plt.$nonce$) != null ? ie : queryNonceMetaTagContent(doc);
          fe != null && _e.setAttribute("nonce", fe), re.insertBefore(_e, re.querySelector("link"));
        }
        te.$flags$ & 4 && (_e.innerHTML += SLOT_FB_CSS), ue && ue.add(ne);
      }
    } else
      re.adoptedStyleSheets.includes(ae) || (re.adoptedStyleSheets = [...re.adoptedStyleSheets, ae]);
  return ne;
}, attachStyles = (re) => {
  const te = re.$cmpMeta$, ee = re.$hostElement$, ie = te.$flags$, ne = createTime("attachStyles", te.$tagName$), ae = addStyle(
    ee.shadowRoot ? ee.shadowRoot : ee.getRootNode(),
    te
  );
  ie & 10 && (ee["s-sc"] = ae, ee.classList.add(ae + "-h")), ne();
}, getScopeId = (re, te) => "sc-" + re.$tagName$, setAccessor = (re, te, ee, ie, ne, ae) => {
  if (ee !== ie) {
    let ue = isMemberInElement(re, te), _e = te.toLowerCase();
    if (te === "class") {
      const fe = re.classList, le = parseClassList(ee), se = parseClassList(ie);
      fe.remove(...le.filter((oe) => oe && !se.includes(oe))), fe.add(...se.filter((oe) => oe && !le.includes(oe)));
    } else if (te === "style") {
      for (const fe in ee)
        (!ie || ie[fe] == null) && (fe.includes("-") ? re.style.removeProperty(fe) : re.style[fe] = "");
      for (const fe in ie)
        (!ee || ie[fe] !== ee[fe]) && (fe.includes("-") ? re.style.setProperty(fe, ie[fe]) : re.style[fe] = ie[fe]);
    } else if (te !== "key")
      if (te === "ref")
        ie && ie(re);
      else if (!re.__lookupSetter__(te) && te[0] === "o" && te[1] === "n") {
        if (te[2] === "-" ? te = te.slice(3) : isMemberInElement(win, _e) ? te = _e.slice(2) : te = _e[2] + te.slice(3), ee || ie) {
          const fe = te.endsWith(CAPTURE_EVENT_SUFFIX);
          te = te.replace(CAPTURE_EVENT_REGEX, ""), ee && plt.rel(re, te, ee, fe), ie && plt.ael(re, te, ie, fe);
        }
      } else {
        const fe = isComplexType$1(ie);
        if ((ue || fe && ie !== null) && !ne)
          try {
            if (re.tagName.includes("-"))
              re[te] = ie;
            else {
              const le = ie ?? "";
              te === "list" ? ue = !1 : (ee == null || re[te] != le) && (re[te] = le);
            }
          } catch {
          }
        ie == null || ie === !1 ? (ie !== !1 || re.getAttribute(te) === "") && re.removeAttribute(te) : (!ue || ae & 4 || ne) && !fe && (ie = ie === !0 ? "" : ie, re.setAttribute(te, ie));
      }
  }
}, parseClassListRegex = /\s/, parseClassList = (re) => re ? re.split(parseClassListRegex) : [], CAPTURE_EVENT_SUFFIX = "Capture", CAPTURE_EVENT_REGEX = new RegExp(CAPTURE_EVENT_SUFFIX + "$"), updateElement = (re, te, ee) => {
  const ie = te.$elm$.nodeType === 11 && te.$elm$.host ? te.$elm$.host : te.$elm$, ne = re && re.$attrs$ || EMPTY_OBJ, ae = te.$attrs$ || EMPTY_OBJ;
  for (const ue of sortedAttrNames(Object.keys(ne)))
    ue in ae || setAccessor(ie, ue, ne[ue], void 0, ee, te.$flags$);
  for (const ue of sortedAttrNames(Object.keys(ae)))
    setAccessor(ie, ue, ne[ue], ae[ue], ee, te.$flags$);
};
function sortedAttrNames(re) {
  return re.includes("ref") ? (
    // we need to sort these to ensure that `'ref'` is the last attr
    [...re.filter((te) => te !== "ref"), "ref"]
  ) : (
    // no need to sort, return the original array
    re
  );
}
var scopeId, contentRef, hostTagName, useNativeShadowDom = !1, checkSlotFallbackVisibility = !1, checkSlotRelocate = !1, isSvgMode = !1, createElm = (re, te, ee, ie) => {
  var ne;
  const ae = te.$children$[ee];
  let ue = 0, _e, fe, le;
  if (useNativeShadowDom || (checkSlotRelocate = !0, ae.$tag$ === "slot" && (scopeId && ie.classList.add(scopeId + "-s"), ae.$flags$ |= ae.$children$ ? (
    // slot element has fallback content
    // still create an element that "mocks" the slot element
    2
  ) : (
    // slot element does not have fallback content
    // create an html comment we'll use to always reference
    // where actual slot content should sit next to
    1
  ))), ae.$text$ !== null)
    _e = ae.$elm$ = doc.createTextNode(ae.$text$);
  else if (ae.$flags$ & 1)
    _e = ae.$elm$ = doc.createTextNode("");
  else {
    if (isSvgMode || (isSvgMode = ae.$tag$ === "svg"), _e = ae.$elm$ = doc.createElementNS(
      isSvgMode ? SVG_NS : HTML_NS,
      ae.$flags$ & 2 ? "slot-fb" : ae.$tag$
    ), isSvgMode && ae.$tag$ === "foreignObject" && (isSvgMode = !1), updateElement(null, ae, isSvgMode), isDef(scopeId) && _e["s-si"] !== scopeId && _e.classList.add(_e["s-si"] = scopeId), ae.$children$)
      for (ue = 0; ue < ae.$children$.length; ++ue)
        fe = createElm(re, ae, ue, _e), fe && _e.appendChild(fe);
    ae.$tag$ === "svg" ? isSvgMode = !1 : _e.tagName === "foreignObject" && (isSvgMode = !0);
  }
  return _e["s-hn"] = hostTagName, ae.$flags$ & 3 && (_e["s-sr"] = !0, _e["s-cr"] = contentRef, _e["s-sn"] = ae.$name$ || "", _e["s-rf"] = (ne = ae.$attrs$) == null ? void 0 : ne.ref, le = re && re.$children$ && re.$children$[ee], le && le.$tag$ === ae.$tag$ && re.$elm$ && putBackInOriginalLocation(re.$elm$, !1)), _e;
}, putBackInOriginalLocation = (re, te) => {
  plt.$flags$ |= 1;
  const ee = Array.from(re.childNodes);
  if (re["s-sr"] && BUILD.experimentalSlotFixes) {
    let ie = re;
    for (; ie = ie.nextSibling; )
      ie && ie["s-sn"] === re["s-sn"] && ie["s-sh"] === hostTagName && ee.push(ie);
  }
  for (let ie = ee.length - 1; ie >= 0; ie--) {
    const ne = ee[ie];
    ne["s-hn"] !== hostTagName && ne["s-ol"] && (insertBefore(parentReferenceNode(ne), ne, referenceNode(ne)), ne["s-ol"].remove(), ne["s-ol"] = void 0, ne["s-sh"] = void 0, checkSlotRelocate = !0), te && putBackInOriginalLocation(ne, te);
  }
  plt.$flags$ &= -2;
}, addVnodes = (re, te, ee, ie, ne, ae) => {
  let ue = re["s-cr"] && re["s-cr"].parentNode || re, _e;
  for (ue.shadowRoot && ue.tagName === hostTagName && (ue = ue.shadowRoot); ne <= ae; ++ne)
    ie[ne] && (_e = createElm(null, ee, ne, re), _e && (ie[ne].$elm$ = _e, insertBefore(ue, _e, referenceNode(te))));
}, removeVnodes = (re, te, ee) => {
  for (let ie = te; ie <= ee; ++ie) {
    const ne = re[ie];
    if (ne) {
      const ae = ne.$elm$;
      nullifyVNodeRefs(ne), ae && (checkSlotFallbackVisibility = !0, ae["s-ol"] ? ae["s-ol"].remove() : putBackInOriginalLocation(ae, !0), ae.remove());
    }
  }
}, updateChildren = (re, te, ee, ie, ne = !1) => {
  let ae = 0, ue = 0, _e = 0, fe = 0, le = te.length - 1, se = te[0], oe = te[le], ce = ie.length - 1, he = ie[0], ge = ie[ce], ve, me;
  for (; ae <= le && ue <= ce; )
    if (se == null)
      se = te[++ae];
    else if (oe == null)
      oe = te[--le];
    else if (he == null)
      he = ie[++ue];
    else if (ge == null)
      ge = ie[--ce];
    else if (isSameVnode(se, he, ne))
      patch(se, he, ne), se = te[++ae], he = ie[++ue];
    else if (isSameVnode(oe, ge, ne))
      patch(oe, ge, ne), oe = te[--le], ge = ie[--ce];
    else if (isSameVnode(se, ge, ne))
      (se.$tag$ === "slot" || ge.$tag$ === "slot") && putBackInOriginalLocation(se.$elm$.parentNode, !1), patch(se, ge, ne), insertBefore(re, se.$elm$, oe.$elm$.nextSibling), se = te[++ae], ge = ie[--ce];
    else if (isSameVnode(oe, he, ne))
      (se.$tag$ === "slot" || ge.$tag$ === "slot") && putBackInOriginalLocation(oe.$elm$.parentNode, !1), patch(oe, he, ne), insertBefore(re, oe.$elm$, se.$elm$), oe = te[--le], he = ie[++ue];
    else {
      for (_e = -1, fe = ae; fe <= le; ++fe)
        if (te[fe] && te[fe].$key$ !== null && te[fe].$key$ === he.$key$) {
          _e = fe;
          break;
        }
      _e >= 0 ? (me = te[_e], me.$tag$ !== he.$tag$ ? ve = createElm(te && te[ue], ee, _e, re) : (patch(me, he, ne), te[_e] = void 0, ve = me.$elm$), he = ie[++ue]) : (ve = createElm(te && te[ue], ee, ue, re), he = ie[++ue]), ve && insertBefore(parentReferenceNode(se.$elm$), ve, referenceNode(se.$elm$));
    }
  ae > le ? addVnodes(
    re,
    ie[ce + 1] == null ? null : ie[ce + 1].$elm$,
    ee,
    ie,
    ue,
    ce
  ) : ue > ce && removeVnodes(te, ae, le);
}, isSameVnode = (re, te, ee = !1) => re.$tag$ === te.$tag$ ? re.$tag$ === "slot" ? re.$name$ === te.$name$ : ee ? !0 : re.$key$ === te.$key$ : !1, referenceNode = (re) => re && re["s-ol"] || re, parentReferenceNode = (re) => (re["s-ol"] ? re["s-ol"] : re).parentNode, patch = (re, te, ee = !1) => {
  const ie = te.$elm$ = re.$elm$, ne = re.$children$, ae = te.$children$, ue = te.$tag$, _e = te.$text$;
  let fe;
  _e === null ? (isSvgMode = ue === "svg" ? !0 : ue === "foreignObject" ? !1 : isSvgMode, ue === "slot" && !useNativeShadowDom || updateElement(re, te, isSvgMode), ne !== null && ae !== null ? updateChildren(ie, ne, te, ae, ee) : ae !== null ? (re.$text$ !== null && (ie.textContent = ""), addVnodes(ie, null, te, ae, 0, ae.length - 1)) : ne !== null && removeVnodes(ne, 0, ne.length - 1), isSvgMode && ue === "svg" && (isSvgMode = !1)) : (fe = ie["s-cr"]) ? fe.parentNode.textContent = _e : re.$text$ !== _e && (ie.data = _e);
}, updateFallbackSlotVisibility = (re) => {
  const te = re.childNodes;
  for (const ee of te)
    if (ee.nodeType === 1) {
      if (ee["s-sr"]) {
        const ie = ee["s-sn"];
        ee.hidden = !1;
        for (const ne of te)
          if (ne !== ee) {
            if (ne["s-hn"] !== ee["s-hn"] || ie !== "") {
              if (ne.nodeType === 1 && (ie === ne.getAttribute("slot") || ie === ne["s-sn"]) || ne.nodeType === 3 && ie === ne["s-sn"]) {
                ee.hidden = !0;
                break;
              }
            } else if (ne.nodeType === 1 || ne.nodeType === 3 && ne.textContent.trim() !== "") {
              ee.hidden = !0;
              break;
            }
          }
      }
      updateFallbackSlotVisibility(ee);
    }
}, relocateNodes = [], markSlotContentForRelocation = (re) => {
  let te, ee, ie;
  for (const ne of re.childNodes) {
    if (ne["s-sr"] && (te = ne["s-cr"]) && te.parentNode) {
      ee = te.parentNode.childNodes;
      const ae = ne["s-sn"];
      for (ie = ee.length - 1; ie >= 0; ie--)
        if (te = ee[ie], !te["s-cn"] && !te["s-nr"] && te["s-hn"] !== ne["s-hn"] && !BUILD.experimentalSlotFixes)
          if (isNodeLocatedInSlot(te, ae)) {
            let ue = relocateNodes.find((_e) => _e.$nodeToRelocate$ === te);
            checkSlotFallbackVisibility = !0, te["s-sn"] = te["s-sn"] || ae, ue ? (ue.$nodeToRelocate$["s-sh"] = ne["s-hn"], ue.$slotRefNode$ = ne) : (te["s-sh"] = ne["s-hn"], relocateNodes.push({
              $slotRefNode$: ne,
              $nodeToRelocate$: te
            })), te["s-sr"] && relocateNodes.map((_e) => {
              isNodeLocatedInSlot(_e.$nodeToRelocate$, te["s-sn"]) && (ue = relocateNodes.find((fe) => fe.$nodeToRelocate$ === te), ue && !_e.$slotRefNode$ && (_e.$slotRefNode$ = ue.$slotRefNode$));
            });
          } else
            relocateNodes.some((ue) => ue.$nodeToRelocate$ === te) || relocateNodes.push({
              $nodeToRelocate$: te
            });
    }
    ne.nodeType === 1 && markSlotContentForRelocation(ne);
  }
}, isNodeLocatedInSlot = (re, te) => re.nodeType === 1 ? re.getAttribute("slot") === null && te === "" || re.getAttribute("slot") === te : re["s-sn"] === te ? !0 : te === "", nullifyVNodeRefs = (re) => {
  re.$attrs$ && re.$attrs$.ref && re.$attrs$.ref(null), re.$children$ && re.$children$.map(nullifyVNodeRefs);
}, insertBefore = (re, te, ee) => re == null ? void 0 : re.insertBefore(te, ee), renderVdom = (re, te, ee = !1) => {
  var ie, ne, ae, ue;
  const _e = re.$hostElement$, fe = re.$cmpMeta$, le = re.$vnode$ || newVNode$1(null, null), se = isHost(te) ? te : h$1(null, null, te);
  if (hostTagName = _e.tagName, fe.$attrsToReflect$ && (se.$attrs$ = se.$attrs$ || {}, fe.$attrsToReflect$.map(
    ([oe, ce]) => se.$attrs$[ce] = _e[oe]
  )), ee && se.$attrs$)
    for (const oe of Object.keys(se.$attrs$))
      _e.hasAttribute(oe) && !["key", "ref", "style", "class"].includes(oe) && (se.$attrs$[oe] = _e[oe]);
  se.$tag$ = null, se.$flags$ |= 4, re.$vnode$ = se, se.$elm$ = le.$elm$ = _e.shadowRoot || _e, scopeId = _e["s-sc"], useNativeShadowDom = (fe.$flags$ & 1) !== 0, contentRef = _e["s-cr"], checkSlotFallbackVisibility = !1, patch(le, se, ee);
  {
    if (plt.$flags$ |= 1, checkSlotRelocate) {
      markSlotContentForRelocation(se.$elm$);
      for (const oe of relocateNodes) {
        const ce = oe.$nodeToRelocate$;
        if (!ce["s-ol"]) {
          const he = doc.createTextNode("");
          he["s-nr"] = ce, insertBefore(ce.parentNode, ce["s-ol"] = he, ce);
        }
      }
      for (const oe of relocateNodes) {
        const ce = oe.$nodeToRelocate$, he = oe.$slotRefNode$;
        if (he) {
          const ge = he.parentNode;
          let ve = he.nextSibling;
          {
            let me = (ie = ce["s-ol"]) == null ? void 0 : ie.previousSibling;
            for (; me; ) {
              let be = (ne = me["s-nr"]) != null ? ne : null;
              if (be && be["s-sn"] === ce["s-sn"] && ge === be.parentNode) {
                for (be = be.nextSibling; be === ce || be != null && be["s-sr"]; )
                  be = be == null ? void 0 : be.nextSibling;
                if (!be || !be["s-nr"]) {
                  ve = be;
                  break;
                }
              }
              me = me.previousSibling;
            }
          }
          (!ve && ge !== ce.parentNode || ce.nextSibling !== ve) && ce !== ve && (!ce["s-hn"] && ce["s-ol"] && (ce["s-hn"] = ce["s-ol"].parentNode.nodeName), insertBefore(ge, ce, ve), ce.nodeType === 1 && (ce.hidden = (ae = ce["s-ih"]) != null ? ae : !1)), ce && typeof he["s-rf"] == "function" && he["s-rf"](ce);
        } else
          ce.nodeType === 1 && (ee && (ce["s-ih"] = (ue = ce.hidden) != null ? ue : !1), ce.hidden = !0);
      }
    }
    checkSlotFallbackVisibility && updateFallbackSlotVisibility(se.$elm$), plt.$flags$ &= -2, relocateNodes.length = 0;
  }
  contentRef = void 0;
}, attachToAncestor = (re, te) => {
  te && !re.$onRenderResolve$ && te["s-p"] && te["s-p"].push(new Promise((ee) => re.$onRenderResolve$ = ee));
}, scheduleUpdate = (re, te) => {
  if (re.$flags$ |= 16, re.$flags$ & 4) {
    re.$flags$ |= 512;
    return;
  }
  return attachToAncestor(re, re.$ancestorComponent$), writeTask(() => dispatchHooks(re, te));
}, dispatchHooks = (re, te) => {
  const ee = re.$hostElement$, ie = createTime("scheduleUpdate", re.$cmpMeta$.$tagName$), ne = ee;
  if (!ne)
    throw new Error(
      `Can't render component <${ee.tagName.toLowerCase()} /> with invalid Stencil runtime! Make sure this imported component is compiled with a \`externalRuntime: true\` flag. For more information, please refer to https://stenciljs.com/docs/custom-elements#externalruntime`
    );
  let ae;
  return te && (ae = safeCall(ne, "componentWillLoad")), ae = enqueue(ae, () => safeCall(ne, "componentWillRender")), ie(), enqueue(ae, () => updateComponent(re, ne, te));
}, enqueue = (re, te) => isPromisey(re) ? re.then(te) : te(), isPromisey = (re) => re instanceof Promise || re && re.then && typeof re.then == "function", updateComponent = async (re, te, ee) => {
  var ie;
  const ne = re.$hostElement$, ae = createTime("update", re.$cmpMeta$.$tagName$), ue = ne["s-rc"];
  ee && attachStyles(re);
  const _e = createTime("render", re.$cmpMeta$.$tagName$);
  callRender(re, te, ne, ee), ue && (ue.map((fe) => fe()), ne["s-rc"] = void 0), _e(), ae();
  {
    const fe = (ie = ne["s-p"]) != null ? ie : [], le = () => postUpdateComponent(re);
    fe.length === 0 ? le() : (Promise.all(fe).then(le), re.$flags$ |= 4, fe.length = 0);
  }
}, callRender = (re, te, ee, ie) => {
  try {
    te = te.render(), re.$flags$ &= -17, re.$flags$ |= 2, renderVdom(re, te, ie);
  } catch (ne) {
    consoleError(ne, re.$hostElement$);
  }
  return null;
}, postUpdateComponent = (re) => {
  const te = re.$cmpMeta$.$tagName$, ee = re.$hostElement$, ie = createTime("postUpdate", te), ne = ee, ae = re.$ancestorComponent$;
  safeCall(ne, "componentDidRender"), re.$flags$ & 64 ? ie() : (re.$flags$ |= 64, addHydratedFlag(ee), safeCall(ne, "componentDidLoad"), ie(), re.$onReadyResolve$(ee), ae || appDidLoad()), re.$onRenderResolve$ && (re.$onRenderResolve$(), re.$onRenderResolve$ = void 0), re.$flags$ & 512 && nextTick$1(() => scheduleUpdate(re, !1)), re.$flags$ &= -517;
}, forceUpdate = (re) => {
  {
    const te = getHostRef(re), ee = te.$hostElement$.isConnected;
    return ee && (te.$flags$ & 18) === 2 && scheduleUpdate(te, !1), ee;
  }
}, appDidLoad = (re) => {
  addHydratedFlag(doc.documentElement), nextTick$1(() => emitEvent(win, "appload", { detail: { namespace: NAMESPACE } }));
}, safeCall = (re, te, ee) => {
  if (re && re[te])
    try {
      return re[te](ee);
    } catch (ie) {
      consoleError(ie);
    }
}, addHydratedFlag = (re) => {
  var te;
  return re.classList.add((te = BUILD.hydratedSelectorName) != null ? te : "hydrated");
}, getValue = (re, te) => getHostRef(re).$instanceValues$.get(te), setValue = (re, te, ee, ie) => {
  const ne = getHostRef(re), ae = re, ue = ne.$instanceValues$.get(te), _e = ne.$flags$, fe = ae;
  ee = parsePropertyValue(ee, ie.$members$[te][0]);
  const le = Number.isNaN(ue) && Number.isNaN(ee);
  if (ee !== ue && !le) {
    ne.$instanceValues$.set(te, ee);
    {
      if (ie.$watchers$ && _e & 128) {
        const oe = ie.$watchers$[te];
        oe && oe.map((ce) => {
          try {
            fe[ce](ee, ue, te);
          } catch (he) {
            consoleError(he, ae);
          }
        });
      }
      (_e & 18) === 2 && scheduleUpdate(ne, !1);
    }
  }
}, proxyComponent = (re, te, ee) => {
  var ie;
  const ne = re.prototype;
  if (te.$members$) {
    re.watchers && (te.$watchers$ = re.watchers);
    const ae = Object.entries(te.$members$);
    ae.map(([ue, [_e]]) => {
      (_e & 31 || _e & 32) && Object.defineProperty(ne, ue, {
        get() {
          return getValue(this, ue);
        },
        set(fe) {
          setValue(this, ue, fe, te);
        },
        configurable: !0,
        enumerable: !0
      });
    });
    {
      const ue = /* @__PURE__ */ new Map();
      ne.attributeChangedCallback = function(_e, fe, le) {
        plt.jmp(() => {
          var se;
          const oe = ue.get(_e);
          if (this.hasOwnProperty(oe))
            le = this[oe], delete this[oe];
          else {
            if (ne.hasOwnProperty(oe) && typeof this[oe] == "number" && this[oe] == le)
              return;
            if (oe == null) {
              const ce = getHostRef(this), he = ce == null ? void 0 : ce.$flags$;
              if (he && !(he & 8) && he & 128 && le !== fe) {
                const ve = this, me = (se = te.$watchers$) == null ? void 0 : se[_e];
                me == null || me.forEach((be) => {
                  ve[be] != null && ve[be].call(ve, le, fe, _e);
                });
              }
              return;
            }
          }
          this[oe] = le === null && typeof this[oe] == "boolean" ? !1 : le;
        });
      }, re.observedAttributes = Array.from(
        /* @__PURE__ */ new Set([
          ...Object.keys((ie = te.$watchers$) != null ? ie : {}),
          ...ae.filter(
            ([_e, fe]) => fe[0] & 15
            /* HasAttribute */
          ).map(([_e, fe]) => {
            var le;
            const se = fe[1] || _e;
            return ue.set(se, _e), fe[0] & 512 && ((le = te.$attrsToReflect$) == null || le.push([_e, se])), se;
          })
        ])
      );
    }
  }
  return re;
}, initializeComponent = async (re, te, ee, ie) => {
  let ne;
  if (!(te.$flags$ & 32)) {
    if (te.$flags$ |= 32, ee.$lazyBundleId$) {
      const fe = loadModule(ee);
      if (fe && "then" in fe) {
        const se = uniqueTime();
        ne = await fe, se();
      } else
        ne = fe;
      if (!ne)
        throw new Error(`Constructor for "${ee.$tagName$}#${te.$modeName$}" was not found`);
      ne.isProxied || (ee.$watchers$ = ne.watchers, proxyComponent(ne, ee), ne.isProxied = !0);
      const le = createTime("createInstance", ee.$tagName$);
      te.$flags$ |= 8;
      try {
        new ne(te);
      } catch (se) {
        consoleError(se);
      }
      te.$flags$ &= -9, te.$flags$ |= 128, le();
    } else {
      ne = re.constructor;
      const fe = re.localName;
      customElements.whenDefined(fe).then(
        () => te.$flags$ |= 128
        /* isWatchReady */
      );
    }
    if (ne && ne.style) {
      let fe = ne.style;
      const le = getScopeId(ee);
      if (!styles$2.has(le)) {
        const se = createTime("registerStyles", ee.$tagName$);
        registerStyle(le, fe, !!(ee.$flags$ & 1)), se();
      }
    }
  }
  const ae = te.$ancestorComponent$, ue = () => scheduleUpdate(te, !0);
  ae && ae["s-rc"] ? ae["s-rc"].push(ue) : ue();
}, fireConnectedCallback = (re) => {
}, connectedCallback = (re) => {
  if (!(plt.$flags$ & 1)) {
    const te = getHostRef(re), ee = te.$cmpMeta$, ie = createTime("connectedCallback", ee.$tagName$);
    if (te.$flags$ & 1)
      addHostEventListeners(re, te, ee.$listeners$), te != null && te.$lazyInstance$ || te != null && te.$onReadyPromise$ && te.$onReadyPromise$.then(() => fireConnectedCallback());
    else {
      te.$flags$ |= 1;
      let ne;
      if (ne = re.getAttribute(HYDRATE_ID), ne) {
        if (ee.$flags$ & 1) {
          const ae = addStyle(re.shadowRoot, ee);
          re.classList.remove(ae + "-h", ae + "-s");
        }
        initializeClientHydrate(re, ee.$tagName$, ne, te);
      }
      ne || // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
      ee.$flags$ & 12 && setContentReference(re);
      {
        let ae = re;
        for (; ae = ae.parentNode || ae.host; )
          if (ae.nodeType === 1 && ae.hasAttribute("s-id") && ae["s-p"] || ae["s-p"]) {
            attachToAncestor(te, te.$ancestorComponent$ = ae);
            break;
          }
      }
      ee.$members$ && Object.entries(ee.$members$).map(([ae, [ue]]) => {
        if (ue & 31 && re.hasOwnProperty(ae)) {
          const _e = re[ae];
          delete re[ae], re[ae] = _e;
        }
      }), initializeComponent(re, te, ee);
    }
    ie();
  }
}, setContentReference = (re) => {
  const te = re["s-cr"] = doc.createComment(
    ""
  );
  te["s-cn"] = !0, insertBefore(re, te, re.firstChild);
}, disconnectedCallback = async (re) => {
  if (!(plt.$flags$ & 1)) {
    const te = getHostRef(re);
    te.$rmListeners$ && (te.$rmListeners$.map((ee) => ee()), te.$rmListeners$ = void 0);
  }
}, proxyCustomElement = (re, te) => {
  const ee = {
    $flags$: te[0],
    $tagName$: te[1]
  };
  ee.$members$ = te[2], ee.$listeners$ = te[3], ee.$watchers$ = re.$watchers$, ee.$attrsToReflect$ = [];
  const ie = re.prototype.connectedCallback, ne = re.prototype.disconnectedCallback;
  return Object.assign(re.prototype, {
    __registerHost() {
      registerHost(this, ee);
    },
    connectedCallback() {
      connectedCallback(this), ie && ie.call(this);
    },
    disconnectedCallback() {
      disconnectedCallback(this), ne && ne.call(this);
    },
    __attachShadow() {
      this.attachShadow({ mode: "open" });
    }
  }), re.is = ee.$tagName$, proxyComponent(re, ee);
}, addHostEventListeners = (re, te, ee, ie) => {
  ee && ee.map(([ne, ae, ue]) => {
    const _e = re, fe = hostListenerProxy(te, ue), le = hostListenerOpts(ne);
    plt.ael(_e, ae, fe, le), (te.$rmListeners$ = te.$rmListeners$ || []).push(() => plt.rel(_e, ae, fe, le));
  });
}, hostListenerProxy = (re, te) => (ee) => {
  try {
    re.$hostElement$[te](ee);
  } catch (ie) {
    consoleError(ie);
  }
}, hostListenerOpts = (re) => supportsListenerOptions ? {
  passive: (re & 1) !== 0,
  capture: (re & 2) !== 0
} : (re & 2) !== 0, hostRefs = /* @__PURE__ */ new WeakMap(), getHostRef = (re) => hostRefs.get(re), registerHost = (re, te) => {
  const ee = {
    $flags$: 0,
    $hostElement$: re,
    $cmpMeta$: te,
    $instanceValues$: /* @__PURE__ */ new Map()
  };
  return ee.$onReadyPromise$ = new Promise((ie) => ee.$onReadyResolve$ = ie), re["s-p"] = [], re["s-rc"] = [], addHostEventListeners(re, ee, te.$listeners$), hostRefs.set(re, ee);
}, isMemberInElement = (re, te) => te in re, consoleError = (re, te) => (0, console.error)(re, te), cmpModules = /* @__PURE__ */ new Map(), loadModule = (re, te, ee) => {
  const ie = re.$tagName$.replace(/-/g, "_"), ne = re.$lazyBundleId$;
  if (!ne)
    return;
  const ae = cmpModules.get(ne);
  if (ae)
    return ae[ie];
  /*!__STENCIL_STATIC_IMPORT_SWITCH__*/
  return import(
    /* @vite-ignore */
    /* webpackInclude: /\.entry\.js$/ */
    /* webpackExclude: /\.system\.entry\.js$/ */
    /* webpackMode: "lazy" */
    `./${ne}.entry.js`
  ).then((ue) => (cmpModules.set(ne, ue), ue[ie]), consoleError);
}, styles$2 = /* @__PURE__ */ new Map(), win = typeof window < "u" ? window : {}, doc = win.document || { head: {} }, H = win.HTMLElement || class {
}, plt = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (re) => re(),
  raf: (re) => requestAnimationFrame(re),
  ael: (re, te, ee, ie) => re.addEventListener(te, ee, ie),
  rel: (re, te, ee, ie) => re.removeEventListener(te, ee, ie),
  ce: (re, te) => new CustomEvent(re, te)
}, supportsShadow = (
  // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
  !0
), supportsListenerOptions = /* @__PURE__ */ (() => {
  let re = !1;
  try {
    doc.addEventListener(
      "e",
      null,
      Object.defineProperty({}, "passive", {
        get() {
          re = !0;
        }
      })
    );
  } catch {
  }
  return re;
})(), promiseResolve = (re) => Promise.resolve(re), supportsConstructableStylesheets = /* @__PURE__ */ (() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})(), queuePending = !1, queueDomReads = [], queueDomWrites = [], queueTask = (re, te) => (ee) => {
  re.push(ee), queuePending || (queuePending = !0, te && plt.$flags$ & 4 ? nextTick$1(flush) : plt.raf(flush));
}, consume = (re) => {
  for (let te = 0; te < re.length; te++)
    try {
      re[te](performance.now());
    } catch (ee) {
      consoleError(ee);
    }
  re.length = 0;
}, flush = () => {
  consume(queueDomReads), consume(queueDomWrites), (queuePending = queueDomReads.length > 0) && plt.raf(flush);
}, nextTick$1 = (re) => promiseResolve().then(re), writeTask = /* @__PURE__ */ queueTask(queueDomWrites, !0), __defProp = Object.defineProperty, __export = (re, te) => {
  for (var ee in te)
    __defProp(re, ee, { get: te[ee], enumerable: !0 });
}, isComplexType = (re) => (re = typeof re, re === "object" || re === "function"), result_exports = {};
__export(result_exports, {
  err: () => err,
  map: () => map,
  ok: () => ok,
  unwrap: () => unwrap,
  unwrapErr: () => unwrapErr
});
var ok = (re) => ({
  isOk: !0,
  isErr: !1,
  value: re
}), err = (re) => ({
  isOk: !1,
  isErr: !0,
  value: re
});
function map(re, te) {
  if (re.isOk) {
    const ee = te(re.value);
    return ee instanceof Promise ? ee.then((ie) => ok(ie)) : ok(ee);
  }
  if (re.isErr) {
    const ee = re.value;
    return err(ee);
  }
  throw "should never get here";
}
var unwrap = (re) => {
  if (re.isOk)
    return re.value;
  throw re.value;
}, unwrapErr = (re) => {
  if (re.isErr)
    return re.value;
  throw re.value;
}, h = (re, te, ...ee) => {
  let ie = null, ne = null, ae = null, ue = !1, _e = !1;
  const fe = [], le = (oe) => {
    for (let ce = 0; ce < oe.length; ce++)
      ie = oe[ce], Array.isArray(ie) ? le(ie) : ie != null && typeof ie != "boolean" && ((ue = typeof re != "function" && !isComplexType(ie)) && (ie = String(ie)), ue && _e ? fe[fe.length - 1].$text$ += ie : fe.push(ue ? newVNode(null, ie) : ie), _e = ue);
  };
  if (le(ee), te) {
    te.key && (ne = te.key), te.name && (ae = te.name);
    {
      const oe = te.className || te.class;
      oe && (te.class = typeof oe != "object" ? oe : Object.keys(oe).filter((ce) => oe[ce]).join(" "));
    }
  }
  if (typeof re == "function")
    return re(
      te === null ? {} : te,
      fe,
      vdomFnUtils
    );
  const se = newVNode(re, null);
  return se.$attrs$ = te, fe.length > 0 && (se.$children$ = fe), se.$key$ = ne, se.$name$ = ae, se;
}, newVNode = (re, te) => {
  const ee = {
    $flags$: 0,
    $tag$: re,
    $text$: te,
    $elm$: null,
    $children$: null
  };
  return ee.$attrs$ = null, ee.$key$ = null, ee.$name$ = null, ee;
}, vdomFnUtils = {
  forEach: (re, te) => re.map(convertToPublic).forEach(te),
  map: (re, te) => re.map(convertToPublic).map(te).map(convertToPrivate)
}, convertToPublic = (re) => ({
  vattrs: re.$attrs$,
  vchildren: re.$children$,
  vkey: re.$key$,
  vname: re.$name$,
  vtag: re.$tag$,
  vtext: re.$text$
}), convertToPrivate = (re) => {
  if (typeof re.vtag == "function") {
    const ee = { ...re.vattrs };
    return re.vkey && (ee.key = re.vkey), re.vname && (ee.name = re.vname), h(re.vtag, ee, ...re.vchildren || []);
  }
  const te = newVNode(re.vtag, re.vtext);
  return te.$attrs$ = re.vattrs, te.$children$ = re.vchildren, te.$key$ = re.vkey, te.$name$ = re.vname, te;
};
const defaultOptions = {
  elementDelimiter: "__",
  modifierDelimiter: "--",
  namespace: "",
  namespaceDelimiter: "-",
  strict: !0
};
function setup({ elementDelimiter: re, modifierDelimiter: te, namespace: ee, namespaceDelimiter: ie, strict: ne }) {
  typeof re == "string" && (defaultOptions.elementDelimiter = re), typeof te == "string" && (defaultOptions.modifierDelimiter = te), (typeof ee == "string" || Array.isArray(ee)) && (defaultOptions.namespace = ee), typeof ie == "string" && (defaultOptions.namespaceDelimiter = ie), typeof ne == "boolean" && (defaultOptions.strict = ne);
}
const uniqueChars = (re) => re.join("").split("").filter((te, ee, ie) => ie.indexOf(te) === ee), includesChars = (re, te) => te.some((ee) => re.includes(ee)), invalidMessage = (re, te, ee) => {
  const ie = `"${ee.join('", "')}"`;
  return `The ${re} ("${te}") must not use the characters contained within the delimiters (${ie}).`;
};
function bem$1(re, te = {}) {
  const { elementDelimiter: ee, modifierDelimiter: ie, namespace: ne, namespaceDelimiter: ae, strict: ue } = {
    ...defaultOptions,
    ...te
  }, fe = `${[].concat(ne).filter(Boolean).reduce((oe, ce) => `${oe}${ce}${ae}`, "")}${re}`, le = ue ? [ae, ee, ie] : [], se = ue ? uniqueChars(le) : [];
  return function(ce, he) {
    if (ce == null)
      return fe;
    const ge = typeof ce == "string" ? ce : null;
    if (ue && ge != null && includesChars(ge, se))
      throw new Error(invalidMessage("element", ge, le));
    const ve = ge == null ? fe : `${fe}${ee}${ge}`, me = typeof ce == "string" ? he : ce;
    if (me == null)
      return ve;
    const be = (pe, $e) => {
      if ($e != null && $e !== "") {
        if (ue && includesChars($e, se))
          throw new Error(invalidMessage("modifier", $e, le));
        return `${pe} ${ve}${ie}${$e}`;
      }
      return pe;
    };
    return Array.isArray(me) ? me.reduce(be, ve) : Object.keys(me).filter((pe) => me[pe]).reduce(be, ve);
  };
}
setup({
  strict: !1
});
const transformModifierToArray = (re) => typeof re != "object" ? re : Object.keys(re).reduce((te, ee) => {
  const ie = re[ee];
  if (!ie)
    return te;
  if (ie === !0)
    return [...te, ee];
  if (typeof ie == "object") {
    const ne = Object.keys(ie).map((ae) => `${ee}-${ie[ae]}@${ae}`);
    return [...te, ...ne];
  }
  return [...te, `${ee}-${ie}`];
}, []), bem = (re) => (te, ee) => {
  const ie = typeof te == "string" ? te : transformModifierToArray(te);
  return bem$1(re)(ie, transformModifierToArray(ee));
}, global$1$1 = typeof window > "u" ? {} : window;
var Ft, Ht;
let disableWarnings = !!((Ft = global$1$1.cosmosConfig) != null && Ft.disableWarnings) || !!((Ht = global$1$1.gravityConfig) != null && Ht.disableWarnings);
const config = {
  get disableWarnings() {
    return disableWarnings;
  },
  set disableWarnings(re) {
    disableWarnings = re;
  }
};
global$1$1.cosmosConfig = config;
global$1$1.gravityConfig = config;
const nextTick = () => new Promise((re) => {
  requestAnimationFrame(() => requestAnimationFrame(() => {
    re();
  }));
});
class CSSTransition {
  constructor() {
    this.classNames = {
      enter: "enter",
      leave: "leave"
    }, this.timeouts = {
      enter: void 0,
      leave: void 0
    };
  }
  async enter(te, ee) {
    if (!te)
      return Promise.reject();
    const ie = this.getClassNames();
    return this.clearTimeouts(), this.clearClassNames(te), this.addClassName(te, ie.enter), await this.addClassNameOnNextTick(te, ie.enterActive), new Promise((ne) => {
      this.timeouts.enter = setTimeout(() => {
        this.clearClassNames(te), ne();
      }, ee);
    });
  }
  async leave(te, ee) {
    if (!te)
      return Promise.reject();
    const ie = this.getClassNames();
    return this.clearTimeouts(), this.clearClassNames(te), this.addClassName(te, ie.leave), await this.addClassNameOnNextTick(te, ie.leaveActive), new Promise((ne) => {
      this.timeouts.leave = setTimeout(() => {
        this.clearClassNames(te), ne();
      }, ee);
    });
  }
  getClassNames() {
    return {
      enter: this.classNames.enter,
      enterActive: `${this.classNames.enter}-active`,
      leave: this.classNames.leave,
      leaveActive: `${this.classNames.leave}-active`
    };
  }
  addClassName(te, ee) {
    te.classList.add(ee);
  }
  clearTimeouts() {
    Object.values(this.timeouts).forEach((te) => {
      te && clearTimeout(te);
    });
  }
  clearClassNames(te) {
    const ee = this.getClassNames();
    Object.values(ee).forEach((ie) => {
      this.removeClassName(te, ie);
    });
  }
  removeClassName(te, ee) {
    te.classList.remove(ee);
  }
  async addClassNameOnNextTick(te, ee) {
    await nextTick(), this.addClassName(te, ee);
  }
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, freeSelf$1 = typeof self == "object" && self && self.Object === Object && self, root$1 = freeGlobal$1 || freeSelf$1 || Function("return this")(), Symbol$1 = root$1.Symbol, symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0;
symbolProto$1 && symbolProto$1.toString;
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root = freeGlobal || freeSelf || Function("return this")(), Symbol$2 = root.Symbol, symbolProto = Symbol$2 ? Symbol$2.prototype : void 0;
symbolProto && symbolProto.toString;
const isNodeEnvironment = () => typeof process < "u" && process.versions != null && process.versions.node != null;
class EventEmitter {
  constructor() {
    isNodeEnvironment() || (this.eventTarget = document.createDocumentFragment());
  }
  on(te, ee) {
    var ie;
    (ie = this.eventTarget) == null || ie.addEventListener(te, ee);
  }
  off(te, ee) {
    var ie;
    (ie = this.eventTarget) == null || ie.removeEventListener(te, ee);
  }
  emit(te, ee) {
    var ne;
    const ie = new CustomEvent(te, ee);
    (ne = this.eventTarget) == null || ne.dispatchEvent(ie);
  }
}
const hasReducedMotion = () => global$1$1.matchMedia("(prefers-reduced-motion: reduce)").matches, requestFormSubmit = (re) => {
  if (re) {
    if (typeof HTMLFormElement.prototype.requestSubmit == "function")
      return re.requestSubmit();
    if (!isNodeEnvironment()) {
      const te = global$1$1.document.createElement("button");
      te.type = "submit", te.style.display = "none", re.appendChild(te), te.click(), te.remove();
    }
  }
}, responsiveStringRegex = /([a-zA-Z0-9-]+)@([a-zA-Z0-9-]+)/, isResponsiveProperty = (re) => typeof re == "string" && responsiveStringRegex.test(re), parseResponsiveProperty = (re) => (re.match(new RegExp(responsiveStringRegex, "g")) || []).reduce((ee, ie) => {
  const ne = ie.match(responsiveStringRegex);
  if (ne) {
    const [, ae, ue] = ne;
    ee[ue] = ae;
  }
  return ee;
}, {});
function hasNamedSlot(re, te) {
  if (!re || typeof re.querySelector != "function")
    return !1;
  try {
    return re.querySelector(`:scope > [slot="${te}"]`) !== null;
  } catch {
    return re.querySelector(`[slot="${te}"]`) !== null;
  }
}
function getDefaultSlotTextContent(re) {
  return !re || typeof re.assignedNodes != "function" ? "" : re.assignedNodes({ flatten: !0 }).reduce((te, ee) => te + (ee.textContent || ""), "").trim();
}
function getNamedSlotTextContent(re, te) {
  var ee, ie, ne, ae;
  if (!re || typeof re.querySelector != "function")
    return "";
  try {
    return ((ie = (ee = re.querySelector(`:scope > [slot="${te}"]`)) == null ? void 0 : ee.textContent) == null ? void 0 : ie.trim()) || "";
  } catch {
    return ((ae = (ne = re.querySelector(`[slot="${te}"]`)) == null ? void 0 : ne.textContent) == null ? void 0 : ae.trim()) || "";
  }
}
class SlotMutationService {
  constructor() {
    this.observers = /* @__PURE__ */ new Map(), this.isNodeEnv = isNodeEnvironment(), this.observer = this.isNodeEnv ? null : this.createObserver();
  }
  /**
   * Gets the singleton instance of SlotMutationService.
   *
   * @returns {SlotMutationService} The singleton instance of SlotMutationService.
   * @static
   */
  static getInstance() {
    return SlotMutationService.instance || (SlotMutationService.instance = new SlotMutationService()), SlotMutationService.instance;
  }
  /**
   * Starts observing the given element for mutations.
   *
   * @remarks
   * It is recommended to call this method in the `componentWillLoad` lifecycle method
   * of a Stencil component to ensure that the element is observed as soon as it is loaded.
   *
   * @param {HTMLElement} element - The element to observe.
   * @param {() => void} handleSlotChange - The callback to execute when a mutation is observed.
   * @returns {void}
   */
  observe(te, ee) {
    var ie;
    this.isNodeEnv || this.observers.has(te) || (this.observers.set(te, ee), (ie = this.observer) == null || ie.observe(te, SlotMutationService.OBSERVER_OPTIONS), ee.call(te));
  }
  /**
   * Stops observing the given element for mutations.
   *
   * @remarks
   * It is recommended to call this method in the `disconnectedCallback` lifecycle method
   * of a Stencil component to ensure that the element is no longer observed when it is removed from the DOM.
   *
   * @param {HTMLElement} element - The element to stop observing.
   * @returns {void}
   */
  unobserve(te) {
    var ee;
    this.isNodeEnv || !this.observers.has(te) || (this.observers.delete(te), this.observers.size === 0 && ((ee = this.observer) == null || ee.disconnect()));
  }
  /**
   * Creates a MutationObserver instance.
   *
   * @returns {MutationObserver} The created MutationObserver instance.
   * @private
   */
  createObserver() {
    return new MutationObserver(this.handleMutations.bind(this));
  }
  /**
   * Handles observed mutations.
   *
   * @param {MutationRecord[]} mutations - The array of observed mutations.
   * @returns {void}
   * @private
   */
  handleMutations(te) {
    te.forEach((ee) => {
      this.observers.forEach((ie, ne) => {
        ne.contains(ee.target) && ie.call(ne);
      });
    });
  }
}
SlotMutationService.instance = null;
SlotMutationService.OBSERVER_OPTIONS = {
  childList: !0,
  subtree: !0,
  characterData: !0
};
const slotMutationService = SlotMutationService.getInstance();
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(re, te) {
  return re.concat([te + "-" + start, te + "-" + end]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(re, te) {
  return re.concat([te, te + "-" + start, te + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(re) {
  return re ? (re.nodeName || "").toLowerCase() : null;
}
function getWindow(re) {
  if (re == null)
    return window;
  if (re.toString() !== "[object Window]") {
    var te = re.ownerDocument;
    return te && te.defaultView || window;
  }
  return re;
}
function isElement$1(re) {
  var te = getWindow(re).Element;
  return re instanceof te || re instanceof Element;
}
function isHTMLElement(re) {
  var te = getWindow(re).HTMLElement;
  return re instanceof te || re instanceof HTMLElement;
}
function isShadowRoot(re) {
  if (typeof ShadowRoot > "u")
    return !1;
  var te = getWindow(re).ShadowRoot;
  return re instanceof te || re instanceof ShadowRoot;
}
function applyStyles(re) {
  var te = re.state;
  Object.keys(te.elements).forEach(function(ee) {
    var ie = te.styles[ee] || {}, ne = te.attributes[ee] || {}, ae = te.elements[ee];
    !isHTMLElement(ae) || !getNodeName(ae) || (Object.assign(ae.style, ie), Object.keys(ne).forEach(function(ue) {
      var _e = ne[ue];
      _e === !1 ? ae.removeAttribute(ue) : ae.setAttribute(ue, _e === !0 ? "" : _e);
    }));
  });
}
function effect$2(re) {
  var te = re.state, ee = {
    popper: {
      position: te.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(te.elements.popper.style, ee.popper), te.styles = ee, te.elements.arrow && Object.assign(te.elements.arrow.style, ee.arrow), function() {
    Object.keys(te.elements).forEach(function(ie) {
      var ne = te.elements[ie], ae = te.attributes[ie] || {}, ue = Object.keys(te.styles.hasOwnProperty(ie) ? te.styles[ie] : ee[ie]), _e = ue.reduce(function(fe, le) {
        return fe[le] = "", fe;
      }, {});
      !isHTMLElement(ne) || !getNodeName(ne) || (Object.assign(ne.style, _e), Object.keys(ae).forEach(function(fe) {
        ne.removeAttribute(fe);
      }));
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement$1(re) {
  return re.split("-")[0];
}
var max = Math.max, min = Math.min, round = Math.round;
function getUAString() {
  var re = navigator.userAgentData;
  return re != null && re.brands && Array.isArray(re.brands) ? re.brands.map(function(te) {
    return te.brand + "/" + te.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(re, te, ee) {
  te === void 0 && (te = !1), ee === void 0 && (ee = !1);
  var ie = re.getBoundingClientRect(), ne = 1, ae = 1;
  te && isHTMLElement(re) && (ne = re.offsetWidth > 0 && round(ie.width) / re.offsetWidth || 1, ae = re.offsetHeight > 0 && round(ie.height) / re.offsetHeight || 1);
  var ue = isElement$1(re) ? getWindow(re) : window, _e = ue.visualViewport, fe = !isLayoutViewport() && ee, le = (ie.left + (fe && _e ? _e.offsetLeft : 0)) / ne, se = (ie.top + (fe && _e ? _e.offsetTop : 0)) / ae, oe = ie.width / ne, ce = ie.height / ae;
  return {
    width: oe,
    height: ce,
    top: se,
    right: le + oe,
    bottom: se + ce,
    left: le,
    x: le,
    y: se
  };
}
function getLayoutRect(re) {
  var te = getBoundingClientRect(re), ee = re.offsetWidth, ie = re.offsetHeight;
  return Math.abs(te.width - ee) <= 1 && (ee = te.width), Math.abs(te.height - ie) <= 1 && (ie = te.height), {
    x: re.offsetLeft,
    y: re.offsetTop,
    width: ee,
    height: ie
  };
}
function contains(re, te) {
  var ee = te.getRootNode && te.getRootNode();
  if (re.contains(te))
    return !0;
  if (ee && isShadowRoot(ee)) {
    var ie = te;
    do {
      if (ie && re.isSameNode(ie))
        return !0;
      ie = ie.parentNode || ie.host;
    } while (ie);
  }
  return !1;
}
function getComputedStyle$1(re) {
  return getWindow(re).getComputedStyle(re);
}
function isTableElement(re) {
  return ["table", "td", "th"].indexOf(getNodeName(re)) >= 0;
}
function getDocumentElement(re) {
  return ((isElement$1(re) ? re.ownerDocument : (
    // $FlowFixMe[prop-missing]
    re.document
  )) || window.document).documentElement;
}
function getParentNode(re) {
  return getNodeName(re) === "html" ? re : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    re.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    re.parentNode || // DOM Element detected
    (isShadowRoot(re) ? re.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(re)
  );
}
function getTrueOffsetParent(re) {
  return !isHTMLElement(re) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(re).position === "fixed" ? null : re.offsetParent;
}
function getContainingBlock(re) {
  var te = /firefox/i.test(getUAString()), ee = /Trident/i.test(getUAString());
  if (ee && isHTMLElement(re)) {
    var ie = getComputedStyle$1(re);
    if (ie.position === "fixed")
      return null;
  }
  var ne = getParentNode(re);
  for (isShadowRoot(ne) && (ne = ne.host); isHTMLElement(ne) && ["html", "body"].indexOf(getNodeName(ne)) < 0; ) {
    var ae = getComputedStyle$1(ne);
    if (ae.transform !== "none" || ae.perspective !== "none" || ae.contain === "paint" || ["transform", "perspective"].indexOf(ae.willChange) !== -1 || te && ae.willChange === "filter" || te && ae.filter && ae.filter !== "none")
      return ne;
    ne = ne.parentNode;
  }
  return null;
}
function getOffsetParent(re) {
  for (var te = getWindow(re), ee = getTrueOffsetParent(re); ee && isTableElement(ee) && getComputedStyle$1(ee).position === "static"; )
    ee = getTrueOffsetParent(ee);
  return ee && (getNodeName(ee) === "html" || getNodeName(ee) === "body" && getComputedStyle$1(ee).position === "static") ? te : ee || getContainingBlock(re) || te;
}
function getMainAxisFromPlacement(re) {
  return ["top", "bottom"].indexOf(re) >= 0 ? "x" : "y";
}
function within(re, te, ee) {
  return max(re, min(te, ee));
}
function withinMaxClamp(re, te, ee) {
  var ie = within(re, te, ee);
  return ie > ee ? ee : ie;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(re) {
  return Object.assign({}, getFreshSideObject(), re);
}
function expandToHashMap(re, te) {
  return te.reduce(function(ee, ie) {
    return ee[ie] = re, ee;
  }, {});
}
var toPaddingObject = function(te, ee) {
  return te = typeof te == "function" ? te(Object.assign({}, ee.rects, {
    placement: ee.placement
  })) : te, mergePaddingObject(typeof te != "number" ? te : expandToHashMap(te, basePlacements));
};
function arrow(re) {
  var te, ee = re.state, ie = re.name, ne = re.options, ae = ee.elements.arrow, ue = ee.modifiersData.popperOffsets, _e = getBasePlacement$1(ee.placement), fe = getMainAxisFromPlacement(_e), le = [left, right].indexOf(_e) >= 0, se = le ? "height" : "width";
  if (!(!ae || !ue)) {
    var oe = toPaddingObject(ne.padding, ee), ce = getLayoutRect(ae), he = fe === "y" ? top : left, ge = fe === "y" ? bottom : right, ve = ee.rects.reference[se] + ee.rects.reference[fe] - ue[fe] - ee.rects.popper[se], me = ue[fe] - ee.rects.reference[fe], be = getOffsetParent(ae), pe = be ? fe === "y" ? be.clientHeight || 0 : be.clientWidth || 0 : 0, $e = ve / 2 - me / 2, ye = oe[he], Se = pe - ce[se] - oe[ge], we = pe / 2 - ce[se] / 2 + $e, Pe = within(ye, we, Se), Te = fe;
    ee.modifiersData[ie] = (te = {}, te[Te] = Pe, te.centerOffset = Pe - we, te);
  }
}
function effect$1(re) {
  var te = re.state, ee = re.options, ie = ee.element, ne = ie === void 0 ? "[data-popper-arrow]" : ie;
  ne != null && (typeof ne == "string" && (ne = te.elements.popper.querySelector(ne), !ne) || contains(te.elements.popper, ne) && (te.elements.arrow = ne));
}
const arrow$1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(re) {
  return re.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(re, te) {
  var ee = re.x, ie = re.y, ne = te.devicePixelRatio || 1;
  return {
    x: round(ee * ne) / ne || 0,
    y: round(ie * ne) / ne || 0
  };
}
function mapToStyles(re) {
  var te, ee = re.popper, ie = re.popperRect, ne = re.placement, ae = re.variation, ue = re.offsets, _e = re.position, fe = re.gpuAcceleration, le = re.adaptive, se = re.roundOffsets, oe = re.isFixed, ce = ue.x, he = ce === void 0 ? 0 : ce, ge = ue.y, ve = ge === void 0 ? 0 : ge, me = typeof se == "function" ? se({
    x: he,
    y: ve
  }) : {
    x: he,
    y: ve
  };
  he = me.x, ve = me.y;
  var be = ue.hasOwnProperty("x"), pe = ue.hasOwnProperty("y"), $e = left, ye = top, Se = window;
  if (le) {
    var we = getOffsetParent(ee), Pe = "clientHeight", Te = "clientWidth";
    if (we === getWindow(ee) && (we = getDocumentElement(ee), getComputedStyle$1(we).position !== "static" && _e === "absolute" && (Pe = "scrollHeight", Te = "scrollWidth")), we = we, ne === top || (ne === left || ne === right) && ae === end) {
      ye = bottom;
      var Ee = oe && we === Se && Se.visualViewport ? Se.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        we[Pe]
      );
      ve -= Ee - ie.height, ve *= fe ? 1 : -1;
    }
    if (ne === left || (ne === top || ne === bottom) && ae === end) {
      $e = right;
      var Me = oe && we === Se && Se.visualViewport ? Se.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        we[Te]
      );
      he -= Me - ie.width, he *= fe ? 1 : -1;
    }
  }
  var Ae = Object.assign({
    position: _e
  }, le && unsetSides), Ne = se === !0 ? roundOffsetsByDPR({
    x: he,
    y: ve
  }, getWindow(ee)) : {
    x: he,
    y: ve
  };
  if (he = Ne.x, ve = Ne.y, fe) {
    var Ce;
    return Object.assign({}, Ae, (Ce = {}, Ce[ye] = pe ? "0" : "", Ce[$e] = be ? "0" : "", Ce.transform = (Se.devicePixelRatio || 1) <= 1 ? "translate(" + he + "px, " + ve + "px)" : "translate3d(" + he + "px, " + ve + "px, 0)", Ce));
  }
  return Object.assign({}, Ae, (te = {}, te[ye] = pe ? ve + "px" : "", te[$e] = be ? he + "px" : "", te.transform = "", te));
}
function computeStyles(re) {
  var te = re.state, ee = re.options, ie = ee.gpuAcceleration, ne = ie === void 0 ? !0 : ie, ae = ee.adaptive, ue = ae === void 0 ? !0 : ae, _e = ee.roundOffsets, fe = _e === void 0 ? !0 : _e, le = {
    placement: getBasePlacement$1(te.placement),
    variation: getVariation(te.placement),
    popper: te.elements.popper,
    popperRect: te.rects.popper,
    gpuAcceleration: ne,
    isFixed: te.options.strategy === "fixed"
  };
  te.modifiersData.popperOffsets != null && (te.styles.popper = Object.assign({}, te.styles.popper, mapToStyles(Object.assign({}, le, {
    offsets: te.modifiersData.popperOffsets,
    position: te.options.strategy,
    adaptive: ue,
    roundOffsets: fe
  })))), te.modifiersData.arrow != null && (te.styles.arrow = Object.assign({}, te.styles.arrow, mapToStyles(Object.assign({}, le, {
    offsets: te.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: fe
  })))), te.attributes.popper = Object.assign({}, te.attributes.popper, {
    "data-popper-placement": te.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(re) {
  var te = re.state, ee = re.instance, ie = re.options, ne = ie.scroll, ae = ne === void 0 ? !0 : ne, ue = ie.resize, _e = ue === void 0 ? !0 : ue, fe = getWindow(te.elements.popper), le = [].concat(te.scrollParents.reference, te.scrollParents.popper);
  return ae && le.forEach(function(se) {
    se.addEventListener("scroll", ee.update, passive);
  }), _e && fe.addEventListener("resize", ee.update, passive), function() {
    ae && le.forEach(function(se) {
      se.removeEventListener("scroll", ee.update, passive);
    }), _e && fe.removeEventListener("resize", ee.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(re) {
  return re.replace(/left|right|bottom|top/g, function(te) {
    return hash$1[te];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(re) {
  return re.replace(/start|end/g, function(te) {
    return hash[te];
  });
}
function getWindowScroll(re) {
  var te = getWindow(re), ee = te.pageXOffset, ie = te.pageYOffset;
  return {
    scrollLeft: ee,
    scrollTop: ie
  };
}
function getWindowScrollBarX(re) {
  return getBoundingClientRect(getDocumentElement(re)).left + getWindowScroll(re).scrollLeft;
}
function getViewportRect(re, te) {
  var ee = getWindow(re), ie = getDocumentElement(re), ne = ee.visualViewport, ae = ie.clientWidth, ue = ie.clientHeight, _e = 0, fe = 0;
  if (ne) {
    ae = ne.width, ue = ne.height;
    var le = isLayoutViewport();
    (le || !le && te === "fixed") && (_e = ne.offsetLeft, fe = ne.offsetTop);
  }
  return {
    width: ae,
    height: ue,
    x: _e + getWindowScrollBarX(re),
    y: fe
  };
}
function getDocumentRect(re) {
  var te, ee = getDocumentElement(re), ie = getWindowScroll(re), ne = (te = re.ownerDocument) == null ? void 0 : te.body, ae = max(ee.scrollWidth, ee.clientWidth, ne ? ne.scrollWidth : 0, ne ? ne.clientWidth : 0), ue = max(ee.scrollHeight, ee.clientHeight, ne ? ne.scrollHeight : 0, ne ? ne.clientHeight : 0), _e = -ie.scrollLeft + getWindowScrollBarX(re), fe = -ie.scrollTop;
  return getComputedStyle$1(ne || ee).direction === "rtl" && (_e += max(ee.clientWidth, ne ? ne.clientWidth : 0) - ae), {
    width: ae,
    height: ue,
    x: _e,
    y: fe
  };
}
function isScrollParent(re) {
  var te = getComputedStyle$1(re), ee = te.overflow, ie = te.overflowX, ne = te.overflowY;
  return /auto|scroll|overlay|hidden/.test(ee + ne + ie);
}
function getScrollParent(re) {
  return ["html", "body", "#document"].indexOf(getNodeName(re)) >= 0 ? re.ownerDocument.body : isHTMLElement(re) && isScrollParent(re) ? re : getScrollParent(getParentNode(re));
}
function listScrollParents(re, te) {
  var ee;
  te === void 0 && (te = []);
  var ie = getScrollParent(re), ne = ie === ((ee = re.ownerDocument) == null ? void 0 : ee.body), ae = getWindow(ie), ue = ne ? [ae].concat(ae.visualViewport || [], isScrollParent(ie) ? ie : []) : ie, _e = te.concat(ue);
  return ne ? _e : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    _e.concat(listScrollParents(getParentNode(ue)))
  );
}
function rectToClientRect(re) {
  return Object.assign({}, re, {
    left: re.x,
    top: re.y,
    right: re.x + re.width,
    bottom: re.y + re.height
  });
}
function getInnerBoundingClientRect(re, te) {
  var ee = getBoundingClientRect(re, !1, te === "fixed");
  return ee.top = ee.top + re.clientTop, ee.left = ee.left + re.clientLeft, ee.bottom = ee.top + re.clientHeight, ee.right = ee.left + re.clientWidth, ee.width = re.clientWidth, ee.height = re.clientHeight, ee.x = ee.left, ee.y = ee.top, ee;
}
function getClientRectFromMixedType(re, te, ee) {
  return te === viewport ? rectToClientRect(getViewportRect(re, ee)) : isElement$1(te) ? getInnerBoundingClientRect(te, ee) : rectToClientRect(getDocumentRect(getDocumentElement(re)));
}
function getClippingParents(re) {
  var te = listScrollParents(getParentNode(re)), ee = ["absolute", "fixed"].indexOf(getComputedStyle$1(re).position) >= 0, ie = ee && isHTMLElement(re) ? getOffsetParent(re) : re;
  return isElement$1(ie) ? te.filter(function(ne) {
    return isElement$1(ne) && contains(ne, ie) && getNodeName(ne) !== "body";
  }) : [];
}
function getClippingRect(re, te, ee, ie) {
  var ne = te === "clippingParents" ? getClippingParents(re) : [].concat(te), ae = [].concat(ne, [ee]), ue = ae[0], _e = ae.reduce(function(fe, le) {
    var se = getClientRectFromMixedType(re, le, ie);
    return fe.top = max(se.top, fe.top), fe.right = min(se.right, fe.right), fe.bottom = min(se.bottom, fe.bottom), fe.left = max(se.left, fe.left), fe;
  }, getClientRectFromMixedType(re, ue, ie));
  return _e.width = _e.right - _e.left, _e.height = _e.bottom - _e.top, _e.x = _e.left, _e.y = _e.top, _e;
}
function computeOffsets(re) {
  var te = re.reference, ee = re.element, ie = re.placement, ne = ie ? getBasePlacement$1(ie) : null, ae = ie ? getVariation(ie) : null, ue = te.x + te.width / 2 - ee.width / 2, _e = te.y + te.height / 2 - ee.height / 2, fe;
  switch (ne) {
    case top:
      fe = {
        x: ue,
        y: te.y - ee.height
      };
      break;
    case bottom:
      fe = {
        x: ue,
        y: te.y + te.height
      };
      break;
    case right:
      fe = {
        x: te.x + te.width,
        y: _e
      };
      break;
    case left:
      fe = {
        x: te.x - ee.width,
        y: _e
      };
      break;
    default:
      fe = {
        x: te.x,
        y: te.y
      };
  }
  var le = ne ? getMainAxisFromPlacement(ne) : null;
  if (le != null) {
    var se = le === "y" ? "height" : "width";
    switch (ae) {
      case start:
        fe[le] = fe[le] - (te[se] / 2 - ee[se] / 2);
        break;
      case end:
        fe[le] = fe[le] + (te[se] / 2 - ee[se] / 2);
        break;
    }
  }
  return fe;
}
function detectOverflow(re, te) {
  te === void 0 && (te = {});
  var ee = te, ie = ee.placement, ne = ie === void 0 ? re.placement : ie, ae = ee.strategy, ue = ae === void 0 ? re.strategy : ae, _e = ee.boundary, fe = _e === void 0 ? clippingParents : _e, le = ee.rootBoundary, se = le === void 0 ? viewport : le, oe = ee.elementContext, ce = oe === void 0 ? popper : oe, he = ee.altBoundary, ge = he === void 0 ? !1 : he, ve = ee.padding, me = ve === void 0 ? 0 : ve, be = mergePaddingObject(typeof me != "number" ? me : expandToHashMap(me, basePlacements)), pe = ce === popper ? reference : popper, $e = re.rects.popper, ye = re.elements[ge ? pe : ce], Se = getClippingRect(isElement$1(ye) ? ye : ye.contextElement || getDocumentElement(re.elements.popper), fe, se, ue), we = getBoundingClientRect(re.elements.reference), Pe = computeOffsets({
    reference: we,
    element: $e,
    strategy: "absolute",
    placement: ne
  }), Te = rectToClientRect(Object.assign({}, $e, Pe)), Ee = ce === popper ? Te : we, Me = {
    top: Se.top - Ee.top + be.top,
    bottom: Ee.bottom - Se.bottom + be.bottom,
    left: Se.left - Ee.left + be.left,
    right: Ee.right - Se.right + be.right
  }, Ae = re.modifiersData.offset;
  if (ce === popper && Ae) {
    var Ne = Ae[ne];
    Object.keys(Me).forEach(function(Ce) {
      var Ie = [right, bottom].indexOf(Ce) >= 0 ? 1 : -1, xe = [top, bottom].indexOf(Ce) >= 0 ? "y" : "x";
      Me[Ce] += Ne[xe] * Ie;
    });
  }
  return Me;
}
function computeAutoPlacement(re, te) {
  te === void 0 && (te = {});
  var ee = te, ie = ee.placement, ne = ee.boundary, ae = ee.rootBoundary, ue = ee.padding, _e = ee.flipVariations, fe = ee.allowedAutoPlacements, le = fe === void 0 ? placements : fe, se = getVariation(ie), oe = se ? _e ? variationPlacements : variationPlacements.filter(function(ge) {
    return getVariation(ge) === se;
  }) : basePlacements, ce = oe.filter(function(ge) {
    return le.indexOf(ge) >= 0;
  });
  ce.length === 0 && (ce = oe);
  var he = ce.reduce(function(ge, ve) {
    return ge[ve] = detectOverflow(re, {
      placement: ve,
      boundary: ne,
      rootBoundary: ae,
      padding: ue
    })[getBasePlacement$1(ve)], ge;
  }, {});
  return Object.keys(he).sort(function(ge, ve) {
    return he[ge] - he[ve];
  });
}
function getExpandedFallbackPlacements(re) {
  if (getBasePlacement$1(re) === auto)
    return [];
  var te = getOppositePlacement(re);
  return [getOppositeVariationPlacement(re), te, getOppositeVariationPlacement(te)];
}
function flip(re) {
  var te = re.state, ee = re.options, ie = re.name;
  if (!te.modifiersData[ie]._skip) {
    for (var ne = ee.mainAxis, ae = ne === void 0 ? !0 : ne, ue = ee.altAxis, _e = ue === void 0 ? !0 : ue, fe = ee.fallbackPlacements, le = ee.padding, se = ee.boundary, oe = ee.rootBoundary, ce = ee.altBoundary, he = ee.flipVariations, ge = he === void 0 ? !0 : he, ve = ee.allowedAutoPlacements, me = te.options.placement, be = getBasePlacement$1(me), pe = be === me, $e = fe || (pe || !ge ? [getOppositePlacement(me)] : getExpandedFallbackPlacements(me)), ye = [me].concat($e).reduce(function(Ve, Ke) {
      return Ve.concat(getBasePlacement$1(Ke) === auto ? computeAutoPlacement(te, {
        placement: Ke,
        boundary: se,
        rootBoundary: oe,
        padding: le,
        flipVariations: ge,
        allowedAutoPlacements: ve
      }) : Ke);
    }, []), Se = te.rects.reference, we = te.rects.popper, Pe = /* @__PURE__ */ new Map(), Te = !0, Ee = ye[0], Me = 0; Me < ye.length; Me++) {
      var Ae = ye[Me], Ne = getBasePlacement$1(Ae), Ce = getVariation(Ae) === start, Ie = [top, bottom].indexOf(Ne) >= 0, xe = Ie ? "width" : "height", Ue = detectOverflow(te, {
        placement: Ae,
        boundary: se,
        rootBoundary: oe,
        altBoundary: ce,
        padding: le
      }), ke = Ie ? Ce ? right : left : Ce ? bottom : top;
      Se[xe] > we[xe] && (ke = getOppositePlacement(ke));
      var Le = getOppositePlacement(ke), De = [];
      if (ae && De.push(Ue[Ne] <= 0), _e && De.push(Ue[ke] <= 0, Ue[Le] <= 0), De.every(function(Ve) {
        return Ve;
      })) {
        Ee = Ae, Te = !1;
        break;
      }
      Pe.set(Ae, De);
    }
    if (Te)
      for (var Re = ge ? 3 : 1, Oe = function(Ke) {
        var Ze = ye.find(function(nt) {
          var Qe = Pe.get(nt);
          if (Qe)
            return Qe.slice(0, Ke).every(function(qe) {
              return qe;
            });
        });
        if (Ze)
          return Ee = Ze, "break";
      }, Be = Re; Be > 0; Be--) {
        var Fe = Oe(Be);
        if (Fe === "break")
          break;
      }
    te.placement !== Ee && (te.modifiersData[ie]._skip = !0, te.placement = Ee, te.reset = !0);
  }
}
const flip$1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(re, te, ee) {
  return ee === void 0 && (ee = {
    x: 0,
    y: 0
  }), {
    top: re.top - te.height - ee.y,
    right: re.right - te.width + ee.x,
    bottom: re.bottom - te.height + ee.y,
    left: re.left - te.width - ee.x
  };
}
function isAnySideFullyClipped(re) {
  return [top, right, bottom, left].some(function(te) {
    return re[te] >= 0;
  });
}
function hide(re) {
  var te = re.state, ee = re.name, ie = te.rects.reference, ne = te.rects.popper, ae = te.modifiersData.preventOverflow, ue = detectOverflow(te, {
    elementContext: "reference"
  }), _e = detectOverflow(te, {
    altBoundary: !0
  }), fe = getSideOffsets(ue, ie), le = getSideOffsets(_e, ne, ae), se = isAnySideFullyClipped(fe), oe = isAnySideFullyClipped(le);
  te.modifiersData[ee] = {
    referenceClippingOffsets: fe,
    popperEscapeOffsets: le,
    isReferenceHidden: se,
    hasPopperEscaped: oe
  }, te.attributes.popper = Object.assign({}, te.attributes.popper, {
    "data-popper-reference-hidden": se,
    "data-popper-escaped": oe
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(re, te, ee) {
  var ie = getBasePlacement$1(re), ne = [left, top].indexOf(ie) >= 0 ? -1 : 1, ae = typeof ee == "function" ? ee(Object.assign({}, te, {
    placement: re
  })) : ee, ue = ae[0], _e = ae[1];
  return ue = ue || 0, _e = (_e || 0) * ne, [left, right].indexOf(ie) >= 0 ? {
    x: _e,
    y: ue
  } : {
    x: ue,
    y: _e
  };
}
function offset(re) {
  var te = re.state, ee = re.options, ie = re.name, ne = ee.offset, ae = ne === void 0 ? [0, 0] : ne, ue = placements.reduce(function(se, oe) {
    return se[oe] = distanceAndSkiddingToXY(oe, te.rects, ae), se;
  }, {}), _e = ue[te.placement], fe = _e.x, le = _e.y;
  te.modifiersData.popperOffsets != null && (te.modifiersData.popperOffsets.x += fe, te.modifiersData.popperOffsets.y += le), te.modifiersData[ie] = ue;
}
const offset$1 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(re) {
  var te = re.state, ee = re.name;
  te.modifiersData[ee] = computeOffsets({
    reference: te.rects.reference,
    element: te.rects.popper,
    strategy: "absolute",
    placement: te.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(re) {
  return re === "x" ? "y" : "x";
}
function preventOverflow(re) {
  var te = re.state, ee = re.options, ie = re.name, ne = ee.mainAxis, ae = ne === void 0 ? !0 : ne, ue = ee.altAxis, _e = ue === void 0 ? !1 : ue, fe = ee.boundary, le = ee.rootBoundary, se = ee.altBoundary, oe = ee.padding, ce = ee.tether, he = ce === void 0 ? !0 : ce, ge = ee.tetherOffset, ve = ge === void 0 ? 0 : ge, me = detectOverflow(te, {
    boundary: fe,
    rootBoundary: le,
    padding: oe,
    altBoundary: se
  }), be = getBasePlacement$1(te.placement), pe = getVariation(te.placement), $e = !pe, ye = getMainAxisFromPlacement(be), Se = getAltAxis(ye), we = te.modifiersData.popperOffsets, Pe = te.rects.reference, Te = te.rects.popper, Ee = typeof ve == "function" ? ve(Object.assign({}, te.rects, {
    placement: te.placement
  })) : ve, Me = typeof Ee == "number" ? {
    mainAxis: Ee,
    altAxis: Ee
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Ee), Ae = te.modifiersData.offset ? te.modifiersData.offset[te.placement] : null, Ne = {
    x: 0,
    y: 0
  };
  if (we) {
    if (ae) {
      var Ce, Ie = ye === "y" ? top : left, xe = ye === "y" ? bottom : right, Ue = ye === "y" ? "height" : "width", ke = we[ye], Le = ke + me[Ie], De = ke - me[xe], Re = he ? -Te[Ue] / 2 : 0, Oe = pe === start ? Pe[Ue] : Te[Ue], Be = pe === start ? -Te[Ue] : -Pe[Ue], Fe = te.elements.arrow, Ve = he && Fe ? getLayoutRect(Fe) : {
        width: 0,
        height: 0
      }, Ke = te.modifiersData["arrow#persistent"] ? te.modifiersData["arrow#persistent"].padding : getFreshSideObject(), Ze = Ke[Ie], nt = Ke[xe], Qe = within(0, Pe[Ue], Ve[Ue]), qe = $e ? Pe[Ue] / 2 - Re - Qe - Ze - Me.mainAxis : Oe - Qe - Ze - Me.mainAxis, ze = $e ? -Pe[Ue] / 2 + Re + Qe + nt + Me.mainAxis : Be + Qe + nt + Me.mainAxis, je = te.elements.arrow && getOffsetParent(te.elements.arrow), tt = je ? ye === "y" ? je.clientTop || 0 : je.clientLeft || 0 : 0, ut = (Ce = Ae == null ? void 0 : Ae[ye]) != null ? Ce : 0, yt = ke + qe - ut - tt, $t = ke + ze - ut, ft = within(he ? min(Le, yt) : Le, ke, he ? max(De, $t) : De);
      we[ye] = ft, Ne[ye] = ft - ke;
    }
    if (_e) {
      var pt, lt = ye === "x" ? top : left, Je = ye === "x" ? bottom : right, Xe = we[Se], We = Se === "y" ? "height" : "width", Ge = Xe + me[lt], at = Xe - me[Je], dt = [top, left].indexOf(be) !== -1, ot = (pt = Ae == null ? void 0 : Ae[Se]) != null ? pt : 0, et = dt ? Ge : Xe - Pe[We] - Te[We] - ot + Me.altAxis, st = dt ? Xe + Pe[We] + Te[We] - ot - Me.altAxis : at, mt = he && dt ? withinMaxClamp(et, Xe, st) : within(he ? et : Ge, Xe, he ? st : at);
      we[Se] = mt, Ne[Se] = mt - Xe;
    }
    te.modifiersData[ie] = Ne;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(re) {
  return {
    scrollLeft: re.scrollLeft,
    scrollTop: re.scrollTop
  };
}
function getNodeScroll(re) {
  return re === getWindow(re) || !isHTMLElement(re) ? getWindowScroll(re) : getHTMLElementScroll(re);
}
function isElementScaled(re) {
  var te = re.getBoundingClientRect(), ee = round(te.width) / re.offsetWidth || 1, ie = round(te.height) / re.offsetHeight || 1;
  return ee !== 1 || ie !== 1;
}
function getCompositeRect(re, te, ee) {
  ee === void 0 && (ee = !1);
  var ie = isHTMLElement(te), ne = isHTMLElement(te) && isElementScaled(te), ae = getDocumentElement(te), ue = getBoundingClientRect(re, ne, ee), _e = {
    scrollLeft: 0,
    scrollTop: 0
  }, fe = {
    x: 0,
    y: 0
  };
  return (ie || !ie && !ee) && ((getNodeName(te) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(ae)) && (_e = getNodeScroll(te)), isHTMLElement(te) ? (fe = getBoundingClientRect(te, !0), fe.x += te.clientLeft, fe.y += te.clientTop) : ae && (fe.x = getWindowScrollBarX(ae))), {
    x: ue.left + _e.scrollLeft - fe.x,
    y: ue.top + _e.scrollTop - fe.y,
    width: ue.width,
    height: ue.height
  };
}
function order(re) {
  var te = /* @__PURE__ */ new Map(), ee = /* @__PURE__ */ new Set(), ie = [];
  re.forEach(function(ae) {
    te.set(ae.name, ae);
  });
  function ne(ae) {
    ee.add(ae.name);
    var ue = [].concat(ae.requires || [], ae.requiresIfExists || []);
    ue.forEach(function(_e) {
      if (!ee.has(_e)) {
        var fe = te.get(_e);
        fe && ne(fe);
      }
    }), ie.push(ae);
  }
  return re.forEach(function(ae) {
    ee.has(ae.name) || ne(ae);
  }), ie;
}
function orderModifiers(re) {
  var te = order(re);
  return modifierPhases.reduce(function(ee, ie) {
    return ee.concat(te.filter(function(ne) {
      return ne.phase === ie;
    }));
  }, []);
}
function debounce$1(re) {
  var te;
  return function() {
    return te || (te = new Promise(function(ee) {
      Promise.resolve().then(function() {
        te = void 0, ee(re());
      });
    })), te;
  };
}
function mergeByName(re) {
  var te = re.reduce(function(ee, ie) {
    var ne = ee[ie.name];
    return ee[ie.name] = ne ? Object.assign({}, ne, ie, {
      options: Object.assign({}, ne.options, ie.options),
      data: Object.assign({}, ne.data, ie.data)
    }) : ie, ee;
  }, {});
  return Object.keys(te).map(function(ee) {
    return te[ee];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var re = arguments.length, te = new Array(re), ee = 0; ee < re; ee++)
    te[ee] = arguments[ee];
  return !te.some(function(ie) {
    return !(ie && typeof ie.getBoundingClientRect == "function");
  });
}
function popperGenerator(re) {
  re === void 0 && (re = {});
  var te = re, ee = te.defaultModifiers, ie = ee === void 0 ? [] : ee, ne = te.defaultOptions, ae = ne === void 0 ? DEFAULT_OPTIONS : ne;
  return function(_e, fe, le) {
    le === void 0 && (le = ae);
    var se = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, ae),
      modifiersData: {},
      elements: {
        reference: _e,
        popper: fe
      },
      attributes: {},
      styles: {}
    }, oe = [], ce = !1, he = {
      state: se,
      setOptions: function(be) {
        var pe = typeof be == "function" ? be(se.options) : be;
        ve(), se.options = Object.assign({}, ae, se.options, pe), se.scrollParents = {
          reference: isElement$1(_e) ? listScrollParents(_e) : _e.contextElement ? listScrollParents(_e.contextElement) : [],
          popper: listScrollParents(fe)
        };
        var $e = orderModifiers(mergeByName([].concat(ie, se.options.modifiers)));
        return se.orderedModifiers = $e.filter(function(ye) {
          return ye.enabled;
        }), ge(), he.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!ce) {
          var be = se.elements, pe = be.reference, $e = be.popper;
          if (areValidElements(pe, $e)) {
            se.rects = {
              reference: getCompositeRect(pe, getOffsetParent($e), se.options.strategy === "fixed"),
              popper: getLayoutRect($e)
            }, se.reset = !1, se.placement = se.options.placement, se.orderedModifiers.forEach(function(Me) {
              return se.modifiersData[Me.name] = Object.assign({}, Me.data);
            });
            for (var ye = 0; ye < se.orderedModifiers.length; ye++) {
              if (se.reset === !0) {
                se.reset = !1, ye = -1;
                continue;
              }
              var Se = se.orderedModifiers[ye], we = Se.fn, Pe = Se.options, Te = Pe === void 0 ? {} : Pe, Ee = Se.name;
              typeof we == "function" && (se = we({
                state: se,
                options: Te,
                name: Ee,
                instance: he
              }) || se);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$1(function() {
        return new Promise(function(me) {
          he.forceUpdate(), me(se);
        });
      }),
      destroy: function() {
        ve(), ce = !0;
      }
    };
    if (!areValidElements(_e, fe))
      return he;
    he.setOptions(le).then(function(me) {
      !ce && le.onFirstUpdate && le.onFirstUpdate(me);
    });
    function ge() {
      se.orderedModifiers.forEach(function(me) {
        var be = me.name, pe = me.options, $e = pe === void 0 ? {} : pe, ye = me.effect;
        if (typeof ye == "function") {
          var Se = ye({
            state: se,
            name: be,
            instance: he,
            options: $e
          }), we = function() {
          };
          oe.push(Se || we);
        }
      });
    }
    function ve() {
      oe.forEach(function(me) {
        return me();
      }), oe = [];
    }
    return he;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
}), CONTENT_CLASS = "tippy-content", BACKDROP_CLASS = "tippy-backdrop", ARROW_CLASS = "tippy-arrow", SVG_ARROW_CLASS = "tippy-svg-arrow", TOUCH_OPTIONS = {
  passive: !0,
  capture: !0
}, TIPPY_DEFAULT_APPEND_TO = function() {
  return document.body;
};
function getValueAtIndexOrReturn(re, te, ee) {
  if (Array.isArray(re)) {
    var ie = re[te];
    return ie ?? (Array.isArray(ee) ? ee[te] : ee);
  }
  return re;
}
function isType(re, te) {
  var ee = {}.toString.call(re);
  return ee.indexOf("[object") === 0 && ee.indexOf(te + "]") > -1;
}
function invokeWithArgsOrReturn(re, te) {
  return typeof re == "function" ? re.apply(void 0, te) : re;
}
function debounce(re, te) {
  if (te === 0)
    return re;
  var ee;
  return function(ie) {
    clearTimeout(ee), ee = setTimeout(function() {
      re(ie);
    }, te);
  };
}
function splitBySpaces(re) {
  return re.split(/\s+/).filter(Boolean);
}
function normalizeToArray(re) {
  return [].concat(re);
}
function pushIfUnique(re, te) {
  re.indexOf(te) === -1 && re.push(te);
}
function unique(re) {
  return re.filter(function(te, ee) {
    return re.indexOf(te) === ee;
  });
}
function getBasePlacement(re) {
  return re.split("-")[0];
}
function arrayFrom(re) {
  return [].slice.call(re);
}
function removeUndefinedProps(re) {
  return Object.keys(re).reduce(function(te, ee) {
    return re[ee] !== void 0 && (te[ee] = re[ee]), te;
  }, {});
}
function div() {
  return document.createElement("div");
}
function isElement$2(re) {
  return ["Element", "Fragment"].some(function(te) {
    return isType(re, te);
  });
}
function isNodeList(re) {
  return isType(re, "NodeList");
}
function isMouseEvent(re) {
  return isType(re, "MouseEvent");
}
function isReferenceElement(re) {
  return !!(re && re._tippy && re._tippy.reference === re);
}
function getArrayOfElements(re) {
  return isElement$2(re) ? [re] : isNodeList(re) ? arrayFrom(re) : Array.isArray(re) ? re : arrayFrom(document.querySelectorAll(re));
}
function setTransitionDuration(re, te) {
  re.forEach(function(ee) {
    ee && (ee.style.transitionDuration = te + "ms");
  });
}
function setVisibilityState(re, te) {
  re.forEach(function(ee) {
    ee && ee.setAttribute("data-state", te);
  });
}
function getOwnerDocument(re) {
  var te, ee = normalizeToArray(re), ie = ee[0];
  return ie != null && (te = ie.ownerDocument) != null && te.body ? ie.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(re, te) {
  var ee = te.clientX, ie = te.clientY;
  return re.every(function(ne) {
    var ae = ne.popperRect, ue = ne.popperState, _e = ne.props, fe = _e.interactiveBorder, le = getBasePlacement(ue.placement), se = ue.modifiersData.offset;
    if (!se)
      return !0;
    var oe = le === "bottom" ? se.top.y : 0, ce = le === "top" ? se.bottom.y : 0, he = le === "right" ? se.left.x : 0, ge = le === "left" ? se.right.x : 0, ve = ae.top - ie + oe > fe, me = ie - ae.bottom - ce > fe, be = ae.left - ee + he > fe, pe = ee - ae.right - ge > fe;
    return ve || me || be || pe;
  });
}
function updateTransitionEndListener(re, te, ee) {
  var ie = te + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(ne) {
    re[ie](ne, ee);
  });
}
function actualContains(re, te) {
  for (var ee = te; ee; ) {
    var ie;
    if (re.contains(ee))
      return !0;
    ee = ee.getRootNode == null || (ie = ee.getRootNode()) == null ? void 0 : ie.host;
  }
  return !1;
}
var currentInput = {
  isTouch: !1
}, lastMouseMoveTime = 0;
function onDocumentTouchStart() {
  currentInput.isTouch || (currentInput.isTouch = !0, window.performance && document.addEventListener("mousemove", onDocumentMouseMove));
}
function onDocumentMouseMove() {
  var re = performance.now();
  re - lastMouseMoveTime < 20 && (currentInput.isTouch = !1, document.removeEventListener("mousemove", onDocumentMouseMove)), lastMouseMoveTime = re;
}
function onWindowBlur() {
  var re = document.activeElement;
  if (isReferenceElement(re)) {
    var te = re._tippy;
    re.blur && !te.state.isVisible && re.blur();
  }
}
function bindGlobalEventListeners() {
  document.addEventListener("touchstart", onDocumentTouchStart, TOUCH_OPTIONS), window.addEventListener("blur", onWindowBlur);
}
var isBrowser = typeof window < "u" && typeof document < "u", isIE11 = isBrowser ? (
  // @ts-ignore
  !!window.msCrypto
) : !1, pluginProps = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, renderProps = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, pluginProps, renderProps), defaultKeys = Object.keys(defaultProps), setDefaultProps = function(te) {
  var ee = Object.keys(te);
  ee.forEach(function(ie) {
    defaultProps[ie] = te[ie];
  });
};
function getExtendedPassedProps(re) {
  var te = re.plugins || [], ee = te.reduce(function(ie, ne) {
    var ae = ne.name, ue = ne.defaultValue;
    if (ae) {
      var _e;
      ie[ae] = re[ae] !== void 0 ? re[ae] : (_e = defaultProps[ae]) != null ? _e : ue;
    }
    return ie;
  }, {});
  return Object.assign({}, re, ee);
}
function getDataAttributeProps(re, te) {
  var ee = te ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: te
  }))) : defaultKeys, ie = ee.reduce(function(ne, ae) {
    var ue = (re.getAttribute("data-tippy-" + ae) || "").trim();
    if (!ue)
      return ne;
    if (ae === "content")
      ne[ae] = ue;
    else
      try {
        ne[ae] = JSON.parse(ue);
      } catch {
        ne[ae] = ue;
      }
    return ne;
  }, {});
  return ie;
}
function evaluateProps(re, te) {
  var ee = Object.assign({}, te, {
    content: invokeWithArgsOrReturn(te.content, [re])
  }, te.ignoreAttributes ? {} : getDataAttributeProps(re, te.plugins));
  return ee.aria = Object.assign({}, defaultProps.aria, ee.aria), ee.aria = {
    expanded: ee.aria.expanded === "auto" ? te.interactive : ee.aria.expanded,
    content: ee.aria.content === "auto" ? te.interactive ? null : "describedby" : ee.aria.content
  }, ee;
}
function getChildren(re) {
  var te = re.firstElementChild, ee = arrayFrom(te.children);
  return {
    box: te,
    content: ee.find(function(ie) {
      return ie.classList.contains(CONTENT_CLASS);
    }),
    arrow: ee.find(function(ie) {
      return ie.classList.contains(ARROW_CLASS) || ie.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: ee.find(function(ie) {
      return ie.classList.contains(BACKDROP_CLASS);
    })
  };
}
var idCounter = 1, mouseMoveListeners = [], mountedInstances = [];
function createTippy(re, te) {
  var ee = evaluateProps(re, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(te)))), ie, ne, ae, ue = !1, _e = !1, fe = !1, le = !1, se, oe, ce, he = [], ge = debounce(yt, ee.interactiveDebounce), ve, me = idCounter++, be = null, pe = unique(ee.plugins), $e = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, ye = {
    // properties
    id: me,
    reference: re,
    popper: div(),
    popperInstance: be,
    props: ee,
    state: $e,
    plugins: pe,
    // methods
    clearDelayTimeouts: et,
    setProps: st,
    setContent: mt,
    show: St,
    hide: bt,
    hideWithInteractivity: it,
    enable: dt,
    disable: ot,
    unmount: ht,
    destroy: vt
  };
  if (!ee.render)
    return ye;
  var Se = ee.render(ye), we = Se.popper, Pe = Se.onUpdate;
  we.setAttribute("data-tippy-root", ""), we.id = "tippy-" + ye.id, ye.popper = we, re._tippy = ye, we._tippy = ye;
  var Te = pe.map(function(gt) {
    return gt.fn(ye);
  }), Ee = re.hasAttribute("aria-expanded");
  return je(), Re(), ke(), Le("onCreate", [ye]), ee.showOnCreate && Ge(), we.addEventListener("mouseenter", function() {
    ye.props.interactive && ye.state.isVisible && ye.clearDelayTimeouts();
  }), we.addEventListener("mouseleave", function() {
    ye.props.interactive && ye.props.trigger.indexOf("mouseenter") >= 0 && Ie().addEventListener("mousemove", ge);
  }), ye;
  function Me() {
    var gt = ye.props.touch;
    return Array.isArray(gt) ? gt : [gt, 0];
  }
  function Ae() {
    return Me()[0] === "hold";
  }
  function Ne() {
    var gt;
    return !!((gt = ye.props.render) != null && gt.$$tippy);
  }
  function Ce() {
    return ve || re;
  }
  function Ie() {
    var gt = Ce().parentNode;
    return gt ? getOwnerDocument(gt) : document;
  }
  function xe() {
    return getChildren(we);
  }
  function Ue(gt) {
    return ye.state.isMounted && !ye.state.isVisible || currentInput.isTouch || se && se.type === "focus" ? 0 : getValueAtIndexOrReturn(ye.props.delay, gt ? 0 : 1, defaultProps.delay);
  }
  function ke(gt) {
    gt === void 0 && (gt = !1), we.style.pointerEvents = ye.props.interactive && !gt ? "" : "none", we.style.zIndex = "" + ye.props.zIndex;
  }
  function Le(gt, Tt, rt) {
    if (rt === void 0 && (rt = !0), Te.forEach(function(Ye) {
      Ye[gt] && Ye[gt].apply(Ye, Tt);
    }), rt) {
      var He;
      (He = ye.props)[gt].apply(He, Tt);
    }
  }
  function De() {
    var gt = ye.props.aria;
    if (gt.content) {
      var Tt = "aria-" + gt.content, rt = we.id, He = normalizeToArray(ye.props.triggerTarget || re);
      He.forEach(function(Ye) {
        var ct = Ye.getAttribute(Tt);
        if (ye.state.isVisible)
          Ye.setAttribute(Tt, ct ? ct + " " + rt : rt);
        else {
          var _t = ct && ct.replace(rt, "").trim();
          _t ? Ye.setAttribute(Tt, _t) : Ye.removeAttribute(Tt);
        }
      });
    }
  }
  function Re() {
    if (!(Ee || !ye.props.aria.expanded)) {
      var gt = normalizeToArray(ye.props.triggerTarget || re);
      gt.forEach(function(Tt) {
        ye.props.interactive ? Tt.setAttribute("aria-expanded", ye.state.isVisible && Tt === Ce() ? "true" : "false") : Tt.removeAttribute("aria-expanded");
      });
    }
  }
  function Oe() {
    Ie().removeEventListener("mousemove", ge), mouseMoveListeners = mouseMoveListeners.filter(function(gt) {
      return gt !== ge;
    });
  }
  function Be(gt) {
    if (!(currentInput.isTouch && (fe || gt.type === "mousedown"))) {
      var Tt = gt.composedPath && gt.composedPath()[0] || gt.target;
      if (!(ye.props.interactive && actualContains(we, Tt))) {
        if (normalizeToArray(ye.props.triggerTarget || re).some(function(rt) {
          return actualContains(rt, Tt);
        })) {
          if (currentInput.isTouch || ye.state.isVisible && ye.props.trigger.indexOf("click") >= 0)
            return;
        } else
          Le("onClickOutside", [ye, gt]);
        ye.props.hideOnClick === !0 && (ye.clearDelayTimeouts(), ye.hide(), _e = !0, setTimeout(function() {
          _e = !1;
        }), ye.state.isMounted || Ze());
      }
    }
  }
  function Fe() {
    fe = !0;
  }
  function Ve() {
    fe = !1;
  }
  function Ke() {
    var gt = Ie();
    gt.addEventListener("mousedown", Be, !0), gt.addEventListener("touchend", Be, TOUCH_OPTIONS), gt.addEventListener("touchstart", Ve, TOUCH_OPTIONS), gt.addEventListener("touchmove", Fe, TOUCH_OPTIONS);
  }
  function Ze() {
    var gt = Ie();
    gt.removeEventListener("mousedown", Be, !0), gt.removeEventListener("touchend", Be, TOUCH_OPTIONS), gt.removeEventListener("touchstart", Ve, TOUCH_OPTIONS), gt.removeEventListener("touchmove", Fe, TOUCH_OPTIONS);
  }
  function nt(gt, Tt) {
    qe(gt, function() {
      !ye.state.isVisible && we.parentNode && we.parentNode.contains(we) && Tt();
    });
  }
  function Qe(gt, Tt) {
    qe(gt, Tt);
  }
  function qe(gt, Tt) {
    var rt = xe().box;
    function He(Ye) {
      Ye.target === rt && (updateTransitionEndListener(rt, "remove", He), Tt());
    }
    if (gt === 0)
      return Tt();
    updateTransitionEndListener(rt, "remove", oe), updateTransitionEndListener(rt, "add", He), oe = He;
  }
  function ze(gt, Tt, rt) {
    rt === void 0 && (rt = !1);
    var He = normalizeToArray(ye.props.triggerTarget || re);
    He.forEach(function(Ye) {
      Ye.addEventListener(gt, Tt, rt), he.push({
        node: Ye,
        eventType: gt,
        handler: Tt,
        options: rt
      });
    });
  }
  function je() {
    Ae() && (ze("touchstart", ut, {
      passive: !0
    }), ze("touchend", $t, {
      passive: !0
    })), splitBySpaces(ye.props.trigger).forEach(function(gt) {
      if (gt !== "manual")
        switch (ze(gt, ut), gt) {
          case "mouseenter":
            ze("mouseleave", $t);
            break;
          case "focus":
            ze(isIE11 ? "focusout" : "blur", ft);
            break;
          case "focusin":
            ze("focusout", ft);
            break;
        }
    });
  }
  function tt() {
    he.forEach(function(gt) {
      var Tt = gt.node, rt = gt.eventType, He = gt.handler, Ye = gt.options;
      Tt.removeEventListener(rt, He, Ye);
    }), he = [];
  }
  function ut(gt) {
    var Tt, rt = !1;
    if (!(!ye.state.isEnabled || pt(gt) || _e)) {
      var He = ((Tt = se) == null ? void 0 : Tt.type) === "focus";
      se = gt, ve = gt.currentTarget, Re(), !ye.state.isVisible && isMouseEvent(gt) && mouseMoveListeners.forEach(function(Ye) {
        return Ye(gt);
      }), gt.type === "click" && (ye.props.trigger.indexOf("mouseenter") < 0 || ue) && ye.props.hideOnClick !== !1 && ye.state.isVisible ? rt = !0 : Ge(gt), gt.type === "click" && (ue = !rt), rt && !He && at(gt);
    }
  }
  function yt(gt) {
    var Tt = gt.target, rt = Ce().contains(Tt) || we.contains(Tt);
    if (!(gt.type === "mousemove" && rt)) {
      var He = We().concat(we).map(function(Ye) {
        var ct, _t = Ye._tippy, Pt = (ct = _t.popperInstance) == null ? void 0 : ct.state;
        return Pt ? {
          popperRect: Ye.getBoundingClientRect(),
          popperState: Pt,
          props: ee
        } : null;
      }).filter(Boolean);
      isCursorOutsideInteractiveBorder(He, gt) && (Oe(), at(gt));
    }
  }
  function $t(gt) {
    var Tt = pt(gt) || ye.props.trigger.indexOf("click") >= 0 && ue;
    if (!Tt) {
      if (ye.props.interactive) {
        ye.hideWithInteractivity(gt);
        return;
      }
      at(gt);
    }
  }
  function ft(gt) {
    ye.props.trigger.indexOf("focusin") < 0 && gt.target !== Ce() || ye.props.interactive && gt.relatedTarget && we.contains(gt.relatedTarget) || at(gt);
  }
  function pt(gt) {
    return currentInput.isTouch ? Ae() !== gt.type.indexOf("touch") >= 0 : !1;
  }
  function lt() {
    Je();
    var gt = ye.props, Tt = gt.popperOptions, rt = gt.placement, He = gt.offset, Ye = gt.getReferenceClientRect, ct = gt.moveTransition, _t = Ne() ? getChildren(we).arrow : null, Pt = Ye ? {
      getBoundingClientRect: Ye,
      contextElement: Ye.contextElement || Ce()
    } : re, It = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Mt) {
        var kt = Mt.state;
        if (Ne()) {
          var Rt = xe(), At = Rt.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Ot) {
            Ot === "placement" ? At.setAttribute("data-placement", kt.placement) : kt.attributes.popper["data-popper-" + Ot] ? At.setAttribute("data-" + Ot, "") : At.removeAttribute("data-" + Ot);
          }), kt.attributes.popper = {};
        }
      }
    }, wt = [{
      name: "offset",
      options: {
        offset: He
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !ct
      }
    }, It];
    Ne() && _t && wt.push({
      name: "arrow",
      options: {
        element: _t,
        padding: 3
      }
    }), wt.push.apply(wt, (Tt == null ? void 0 : Tt.modifiers) || []), ye.popperInstance = createPopper(Pt, we, Object.assign({}, Tt, {
      placement: rt,
      onFirstUpdate: ce,
      modifiers: wt
    }));
  }
  function Je() {
    ye.popperInstance && (ye.popperInstance.destroy(), ye.popperInstance = null);
  }
  function Xe() {
    var gt = ye.props.appendTo, Tt, rt = Ce();
    ye.props.interactive && gt === TIPPY_DEFAULT_APPEND_TO || gt === "parent" ? Tt = rt.parentNode : Tt = invokeWithArgsOrReturn(gt, [rt]), Tt.contains(we) || Tt.appendChild(we), ye.state.isMounted = !0, lt();
  }
  function We() {
    return arrayFrom(we.querySelectorAll("[data-tippy-root]"));
  }
  function Ge(gt) {
    ye.clearDelayTimeouts(), gt && Le("onTrigger", [ye, gt]), Ke();
    var Tt = Ue(!0), rt = Me(), He = rt[0], Ye = rt[1];
    currentInput.isTouch && He === "hold" && Ye && (Tt = Ye), Tt ? ie = setTimeout(function() {
      ye.show();
    }, Tt) : ye.show();
  }
  function at(gt) {
    if (ye.clearDelayTimeouts(), Le("onUntrigger", [ye, gt]), !ye.state.isVisible) {
      Ze();
      return;
    }
    if (!(ye.props.trigger.indexOf("mouseenter") >= 0 && ye.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(gt.type) >= 0 && ue)) {
      var Tt = Ue(!1);
      Tt ? ne = setTimeout(function() {
        ye.state.isVisible && ye.hide();
      }, Tt) : ae = requestAnimationFrame(function() {
        ye.hide();
      });
    }
  }
  function dt() {
    ye.state.isEnabled = !0;
  }
  function ot() {
    ye.hide(), ye.state.isEnabled = !1;
  }
  function et() {
    clearTimeout(ie), clearTimeout(ne), cancelAnimationFrame(ae);
  }
  function st(gt) {
    if (!ye.state.isDestroyed) {
      Le("onBeforeUpdate", [ye, gt]), tt();
      var Tt = ye.props, rt = evaluateProps(re, Object.assign({}, Tt, removeUndefinedProps(gt), {
        ignoreAttributes: !0
      }));
      ye.props = rt, je(), Tt.interactiveDebounce !== rt.interactiveDebounce && (Oe(), ge = debounce(yt, rt.interactiveDebounce)), Tt.triggerTarget && !rt.triggerTarget ? normalizeToArray(Tt.triggerTarget).forEach(function(He) {
        He.removeAttribute("aria-expanded");
      }) : rt.triggerTarget && re.removeAttribute("aria-expanded"), Re(), ke(), Pe && Pe(Tt, rt), ye.popperInstance && (lt(), We().forEach(function(He) {
        requestAnimationFrame(He._tippy.popperInstance.forceUpdate);
      })), Le("onAfterUpdate", [ye, gt]);
    }
  }
  function mt(gt) {
    ye.setProps({
      content: gt
    });
  }
  function St() {
    var gt = ye.state.isVisible, Tt = ye.state.isDestroyed, rt = !ye.state.isEnabled, He = currentInput.isTouch && !ye.props.touch, Ye = getValueAtIndexOrReturn(ye.props.duration, 0, defaultProps.duration);
    if (!(gt || Tt || rt || He) && !Ce().hasAttribute("disabled") && (Le("onShow", [ye], !1), ye.props.onShow(ye) !== !1)) {
      if (ye.state.isVisible = !0, Ne() && (we.style.visibility = "visible"), ke(), Ke(), ye.state.isMounted || (we.style.transition = "none"), Ne()) {
        var ct = xe(), _t = ct.box, Pt = ct.content;
        setTransitionDuration([_t, Pt], 0);
      }
      ce = function() {
        var wt;
        if (!(!ye.state.isVisible || le)) {
          if (le = !0, we.style.transition = ye.props.moveTransition, Ne() && ye.props.animation) {
            var Ct = xe(), Mt = Ct.box, kt = Ct.content;
            setTransitionDuration([Mt, kt], Ye), setVisibilityState([Mt, kt], "visible");
          }
          De(), Re(), pushIfUnique(mountedInstances, ye), (wt = ye.popperInstance) == null || wt.forceUpdate(), Le("onMount", [ye]), ye.props.animation && Ne() && Qe(Ye, function() {
            ye.state.isShown = !0, Le("onShown", [ye]);
          });
        }
      }, Xe();
    }
  }
  function bt() {
    var gt = !ye.state.isVisible, Tt = ye.state.isDestroyed, rt = !ye.state.isEnabled, He = getValueAtIndexOrReturn(ye.props.duration, 1, defaultProps.duration);
    if (!(gt || Tt || rt) && (Le("onHide", [ye], !1), ye.props.onHide(ye) !== !1)) {
      if (ye.state.isVisible = !1, ye.state.isShown = !1, le = !1, ue = !1, Ne() && (we.style.visibility = "hidden"), Oe(), Ze(), ke(!0), Ne()) {
        var Ye = xe(), ct = Ye.box, _t = Ye.content;
        ye.props.animation && (setTransitionDuration([ct, _t], He), setVisibilityState([ct, _t], "hidden"));
      }
      De(), Re(), ye.props.animation ? Ne() && nt(He, ye.unmount) : ye.unmount();
    }
  }
  function it(gt) {
    Ie().addEventListener("mousemove", ge), pushIfUnique(mouseMoveListeners, ge), ge(gt);
  }
  function ht() {
    ye.state.isVisible && ye.hide(), ye.state.isMounted && (Je(), We().forEach(function(gt) {
      gt._tippy.unmount();
    }), we.parentNode && we.parentNode.removeChild(we), mountedInstances = mountedInstances.filter(function(gt) {
      return gt !== ye;
    }), ye.state.isMounted = !1, Le("onHidden", [ye]));
  }
  function vt() {
    ye.state.isDestroyed || (ye.clearDelayTimeouts(), ye.unmount(), tt(), delete re._tippy, ye.state.isDestroyed = !0, Le("onDestroy", [ye]));
  }
}
function tippy(re, te) {
  te === void 0 && (te = {});
  var ee = defaultProps.plugins.concat(te.plugins || []);
  bindGlobalEventListeners();
  var ie = Object.assign({}, te, {
    plugins: ee
  }), ne = getArrayOfElements(re), ae = ne.reduce(function(ue, _e) {
    var fe = _e && createTippy(_e, ie);
    return fe && ue.push(fe), ue;
  }, []);
  return isElement$2(re) ? ae[0] : ae;
}
tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
Object.assign({}, applyStyles$1, {
  effect: function(te) {
    var ee = te.state, ie = {
      popper: {
        position: ee.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(ee.elements.popper.style, ie.popper), ee.styles = ie, ee.elements.arrow && Object.assign(ee.elements.arrow.style, ie.arrow);
  }
});
var mouseCoords = {
  clientX: 0,
  clientY: 0
}, activeInstances = [];
function storeMouseCoords(re) {
  var te = re.clientX, ee = re.clientY;
  mouseCoords = {
    clientX: te,
    clientY: ee
  };
}
function addMouseCoordsListener(re) {
  re.addEventListener("mousemove", storeMouseCoords);
}
function removeMouseCoordsListener(re) {
  re.removeEventListener("mousemove", storeMouseCoords);
}
var followCursor = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(te) {
    var ee = te.reference, ie = getOwnerDocument(te.props.triggerTarget || ee), ne = !1, ae = !1, ue = !0, _e = te.props;
    function fe() {
      return te.props.followCursor === "initial" && te.state.isVisible;
    }
    function le() {
      ie.addEventListener("mousemove", ce);
    }
    function se() {
      ie.removeEventListener("mousemove", ce);
    }
    function oe() {
      ne = !0, te.setProps({
        getReferenceClientRect: null
      }), ne = !1;
    }
    function ce(ve) {
      var me = ve.target ? ee.contains(ve.target) : !0, be = te.props.followCursor, pe = ve.clientX, $e = ve.clientY, ye = ee.getBoundingClientRect(), Se = pe - ye.left, we = $e - ye.top;
      (me || !te.props.interactive) && te.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var Te = ee.getBoundingClientRect(), Ee = pe, Me = $e;
          be === "initial" && (Ee = Te.left + Se, Me = Te.top + we);
          var Ae = be === "horizontal" ? Te.top : Me, Ne = be === "vertical" ? Te.right : Ee, Ce = be === "horizontal" ? Te.bottom : Me, Ie = be === "vertical" ? Te.left : Ee;
          return {
            width: Ne - Ie,
            height: Ce - Ae,
            top: Ae,
            right: Ne,
            bottom: Ce,
            left: Ie
          };
        }
      });
    }
    function he() {
      te.props.followCursor && (activeInstances.push({
        instance: te,
        doc: ie
      }), addMouseCoordsListener(ie));
    }
    function ge() {
      activeInstances = activeInstances.filter(function(ve) {
        return ve.instance !== te;
      }), activeInstances.filter(function(ve) {
        return ve.doc === ie;
      }).length === 0 && removeMouseCoordsListener(ie);
    }
    return {
      onCreate: he,
      onDestroy: ge,
      onBeforeUpdate: function() {
        _e = te.props;
      },
      onAfterUpdate: function(me, be) {
        var pe = be.followCursor;
        ne || pe !== void 0 && _e.followCursor !== pe && (ge(), pe ? (he(), te.state.isMounted && !ae && !fe() && le()) : (se(), oe()));
      },
      onMount: function() {
        te.props.followCursor && !ae && (ue && (ce(mouseCoords), ue = !1), fe() || le());
      },
      onTrigger: function(me, be) {
        isMouseEvent(be) && (mouseCoords = {
          clientX: be.clientX,
          clientY: be.clientY
        }), ae = be.type === "focus";
      },
      onHidden: function() {
        te.props.followCursor && (oe(), se(), ue = !0);
      }
    };
  }
}, sticky = {
  name: "sticky",
  defaultValue: !1,
  fn: function(te) {
    var ee = te.reference, ie = te.popper;
    function ne() {
      return te.popperInstance ? te.popperInstance.state.elements.reference : ee;
    }
    function ae(le) {
      return te.props.sticky === !0 || te.props.sticky === le;
    }
    var ue = null, _e = null;
    function fe() {
      var le = ae("reference") ? ne().getBoundingClientRect() : null, se = ae("popper") ? ie.getBoundingClientRect() : null;
      (le && areRectsDifferent(ue, le) || se && areRectsDifferent(_e, se)) && te.popperInstance && te.popperInstance.update(), ue = le, _e = se, te.state.isMounted && requestAnimationFrame(fe);
    }
    return {
      onMount: function() {
        te.props.sticky && fe();
      }
    };
  }
};
function areRectsDifferent(re, te) {
  return re && te ? re.top !== te.top || re.right !== te.right || re.bottom !== te.bottom || re.left !== te.left : !0;
}
tippy.setDefaultProps({
  animation: !1
});
const callbacks$1 = /* @__PURE__ */ new WeakMap();
let observer;
typeof MutationObserver < "u" && (observer = new MutationObserver((re) => {
  re.forEach(function(te) {
    var ee;
    te.type === "attributes" && ((ee = callbacks$1.get(te.target)) === null || ee === void 0 || ee.forEach((ie) => {
      var ne;
      return ie((ne = te.target.getAttribute("mode")) !== null && ne !== void 0 ? ne : "light");
    }));
  });
}));
function closestElement(re, te) {
  const ee = te.closest(re);
  if (ee)
    return ee;
  const ie = te.getRootNode();
  return ie === global$1$1.document || !(ie instanceof ShadowRoot) ? null : closestElement(re, ie.host);
}
function consumeMode(re, te) {
  var ee;
  const ie = closestElement(transformTagName("cosmos-mode"), re.element);
  ie && (te((ee = ie.getAttribute("mode")) !== null && ee !== void 0 ? ee : "light"), callbacks$1.has(ie) ? callbacks$1.get(ie).push(te) : (observer == null || observer.observe(ie, { attributes: !0 }), callbacks$1.set(ie, [te])));
}
function resolveAppearance({ instance: re, modeToAppearanceMap: te, callback: ee }) {
  re.appearance ? ee(re.appearance) : consumeMode(re, (ie) => {
    re.appearance || ee(te[ie]);
  });
}
const version = "9.5.1", transformTagName = (re) => `${re}-${version.replace(/\./g, "-")}`, isNumeric = (re) => /^-?\d+$/.test(re), stringBooleanToBoolean = (re) => typeof re == "boolean" ? re : typeof re == "string" && ["", "true", "false"].includes(re) ? re !== "false" : !1;
function getNumericClampValue(re) {
  if (isNumeric(re))
    return Number(re);
  if (typeof re == "string" || typeof re == "boolean")
    return stringBooleanToBoolean(re) ? 1 : void 0;
}
function isSingleLineClamp(re) {
  return typeof re == "number" ? re === 1 : !1;
}
function isMultiLineClamp(re) {
  return typeof re == "number" ? re > 1 : !1;
}
const cosmosTextCss = '@charset "UTF-8";:host{display:block}:host([clamp]){min-width:0}:host{--cosmos-font-family-text:Bull Text, Helvetica, sans-serif}@supports (font-variation-settings: normal){:host{--cosmos-font-family-text:Bull VF, Helvetica, sans-serif}}:host(:lang(ja)){--cosmos-font-family-text:Noto Sans JP, Helvetica, sans-serif}:host(:lang(ar)){--cosmos-font-family-text:Noto Kufi Arabic, Helvetica, sans-serif}:host(:lang(ko)){--cosmos-font-family-text:Noto Sans KR, Helvetica, sans-serif}:host(:lang(hi)){--cosmos-font-family-text:Noto Sans, Helvetica, sans-serif}:host(:lang(he)){--cosmos-font-family-text:Noto Sans Hebrew, Helvetica, sans-serif}:host(:lang(ka)){--cosmos-font-family-text:Noto Sans Georgian, Helvetica, sans-serif}:host(:lang(th)){--cosmos-font-family-text:Noto Sans Thai, Helvetica, sans-serif}:host(:lang(zh)){--cosmos-font-family-text:Microsoft YaHei, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}:host(:lang(zh-Hant)){--cosmos-font-family-text:Microsoft JhengHei, Geneva CY, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}@supports (font-variation-settings: normal){::slotted(strong),::slotted(b){font-variation-settings:"opsz" 12, "wght" 700}}.cosmos-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:var(--cosmos-text-color, #000F1E);font-family:var(--cosmos-text-font-family, var(--cosmos-font-family-text));font-style:var(--cosmos-text-font-style, inherit);font-variant-numeric:tabular-nums;font-variation-settings:"opsz" 12, "wght" 400;font-weight:var(--cosmos-text-font-weight, 400);letter-spacing:var(--cosmos-text-letter-spacing, inherit);line-height:var(--cosmos-text-line-height, 1.5);margin:0;text-transform:var(--cosmos-text-text-transform, var(--cosmos-text-transform, inherit))}.cosmos-text--single-line-clamp{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cosmos-text--multi-line-clamp{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:var(--cosmos-text-clamp-length);overflow:hidden;}.cosmos-text--size-xx-small{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}@media (min-width: 380px){.cosmos-text--size-xx-small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-xx-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-x-small{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}@media (min-width: 380px){.cosmos-text--size-x-small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-x-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-small{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}@media (min-width: 380px){.cosmos-text--size-small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-small{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-medium{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}@media (min-width: 380px){.cosmos-text--size-medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}@media (min-width: 380px){.cosmos-text--size-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--size-x-large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}@media (min-width: 380px){.cosmos-text--size-x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-text--size-x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-xx-small\\@small{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-xx-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-xx-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-x-small\\@small{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-x-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-x-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-small\\@small{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-small\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-medium\\@small{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-medium\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-medium\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-large\\@small{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-text--size-x-large\\@small{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-text--size-x-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-text--size-x-large\\@small{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-xx-small\\@medium{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-xx-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-x-small\\@medium{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-x-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-x-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-small\\@medium{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-small\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-medium\\@medium{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-medium\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-medium\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-large\\@medium{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-text--size-x-large\\@medium{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-text--size-x-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-text--size-x-large\\@medium{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-xx-small\\@large{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-xx-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-x-small\\@large{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-x-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-x-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-small\\@large{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-small\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-medium\\@large{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-medium\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-medium\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-large\\@large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-text--size-x-large\\@large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-text--size-x-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-text--size-x-large\\@large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-xx-small\\@x-large{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-xx-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-x-small\\@x-large{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-x-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-x-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-small\\@x-large{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-small\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-medium\\@x-large{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-medium\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-medium\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-large\\@x-large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-text--size-x-large\\@x-large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-text--size-x-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-text--size-x-large\\@x-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-xx-small\\@xx-large{font-size:var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.25);margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-xx-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 12rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-xx-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(12rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-x-small\\@xx-large{font-size:var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.357143);margin-bottom:0.428571em;padding-top:0.714286em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-x-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 14rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-x-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(14rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-small\\@xx-large{font-size:var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.411765);margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-small\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-medium\\@xx-large{font-size:var(--cosmos-text-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.5);margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-medium\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-medium\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-large\\@xx-large{font-size:var(--cosmos-text-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.333333);margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-text--size-x-large\\@xx-large{font-size:var(--cosmos-text-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:var(--cosmos-text-line-height, 1.137931);margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-text--size-x-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-text--size-x-large\\@xx-large{font-size:calc(1 * var(--cosmos-text-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}.cosmos-text--spacing-none{margin-bottom:0;padding-top:0}.cosmos-text--spacing-long-form-bottom{padding-top:0}.cosmos-text--spacing-long-form-top{margin-bottom:0}.cosmos-text--weight-medium{font-variation-settings:"opsz" 12, "wght" 500;font-weight:var(--cosmos-text-font-weight, 500)}.cosmos-text--weight-bold{font-variation-settings:"opsz" 12, "wght" 700;font-weight:var(--cosmos-text-font-weight, 700)}.cosmos-text--kind-normal.cosmos-text--appearance-light{color:var(--cosmos-text-color, #FFFFFF)}.cosmos-text--kind-subtle{color:var(--cosmos-text-color, rgba(0, 15, 30, 0.6))}.cosmos-text--kind-subtle.cosmos-text--appearance-light{color:var(--cosmos-text-color, rgba(255, 255, 255, 0.6))}', CosmosText951Style0 = cosmosTextCss, generateClassNames$9 = bem("cosmos-text"), CosmosText$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.appearance = void 0, this.clamp = void 0, this.kind = "normal", this.size = "medium", this.spacing = "none", this.tag = "p", this.weight = "regular", this.computedAppearance = "dark";
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  setNumericClampValue() {
    this.numericClampValue = getNumericClampValue(this.clamp);
  }
  getSize() {
    return this.size && isResponsiveProperty(this.size) ? parseResponsiveProperty(this.size) : this.size;
  }
  componentWillLoad() {
    resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.setNumericClampValue();
  }
  render() {
    var te;
    const ee = (te = this.tag) !== null && te !== void 0 ? te : "p";
    return h$1(Host, { key: "5db84f7598d24c2f13505660eb915e9d6cf75b78", style: isMultiLineClamp(this.numericClampValue) ? { "--cosmos-text-clamp-length": `${this.numericClampValue}` } : {} }, h$1(ee, { key: "f053b2a7b90d4045ec26957a59daa00ac9d845b7", class: generateClassNames$9({
      spacing: this.spacing,
      kind: this.kind,
      weight: this.weight,
      appearance: this.computedAppearance,
      size: this.getSize(),
      "single-line-clamp": isSingleLineClamp(this.numericClampValue),
      "multi-line-clamp": isMultiLineClamp(this.numericClampValue)
    }), part: "base" }, h$1("slot", { key: "c5c34e966389ddfe04b70c11470e94f4dd20796d" })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      clamp: ["setNumericClampValue"]
    };
  }
  static get style() {
    return CosmosText951Style0;
  }
}, [1, "cosmos-text-9-5-1", {
  appearance: [513],
  clamp: [520],
  kind: [513],
  size: [513],
  spacing: [513],
  tag: [513],
  weight: [513],
  computedAppearance: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  clamp: ["setNumericClampValue"]
}]);
function defineCustomElement$W() {
  if (typeof customElements > "u")
    return;
  ["cosmos-text-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-text-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosText$1);
        break;
    }
  });
}
const IMAGE_STATE_LOAD_SUCCESS = "success", IMAGE_STATE_LOAD_ERROR = "error", IMAGE_STATE_LOADING = "loading", cosmosImageCss = ':host{display:block;height:100%}.cosmos-image{display:-ms-flexbox;display:flex;height:100%;isolation:isolate;min-height:inherit;overflow:hidden}.cosmos-image--radius-none{border-radius:var(--cosmos-image-border-radius, 0)}.cosmos-image--radius-small{border-radius:var(--cosmos-image-border-radius, 2px)}.cosmos-image--radius-medium{border-radius:var(--cosmos-image-border-radius, 6px)}.cosmos-image--radius-large{border-radius:var(--cosmos-image-border-radius, 8px)}.cosmos-image--radius-full{border-radius:var(--cosmos-image-border-radius, 9999px)}.cosmos-image--fallback.cosmos-image--appearance-light{background-color:rgba(0, 15, 30, 0.05)}.cosmos-image--fallback.cosmos-image--appearance-dark{background-color:rgba(255, 255, 255, 0.1)}.cosmos-image--image-state-loading,.cosmos-image--fit-contain{background-color:transparent}.cosmos-image__container{display:grid;grid-template-areas:"image";height:100%;width:100%}.cosmos-image--has-preview:not(.cosmos-image--has-image) .cosmos-image__container{display:-ms-flexbox;display:flex}.cosmos-image--fit-contain .cosmos-image__container{place-content:center}.cosmos-image__preview-container,.cosmos-image__image{grid-area:image;max-height:100%;min-height:0}.cosmos-image--fit-contain.cosmos-image--radius-none .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-none .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 0)}.cosmos-image--fit-contain.cosmos-image--radius-small .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-small .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 2px)}.cosmos-image--fit-contain.cosmos-image--radius-medium .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-medium .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 6px)}.cosmos-image--fit-contain.cosmos-image--radius-large .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-large .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 8px)}.cosmos-image--fit-contain.cosmos-image--radius-full .cosmos-image__preview-container,.cosmos-image--fit-contain.cosmos-image--radius-full .cosmos-image__image{border-radius:var(--cosmos-image-border-radius, 9999px)}.cosmos-image__preview-image,.cosmos-image__image{-o-object-fit:cover;object-fit:cover}.cosmos-image__preview-container{display:-ms-flexbox;display:flex;overflow:hidden;position:relative}.cosmos-image--fit-cover .cosmos-image__preview-container{width:100%}.cosmos-image__preview-image{-webkit-filter:blur(5px);filter:blur(5px);height:calc(100% + 5px * 2);inset:0;position:absolute;-webkit-transform:translate(-5px, -5px);transform:translate(-5px, -5px);width:calc(100% + 5px * 2)}.cosmos-image__preview-dummy{max-width:100%}.cosmos-image--has-preview:not(.cosmos-image--has-image) .cosmos-image__preview-dummy{width:100%}.cosmos-image__image{max-width:100%;-webkit-transition:opacity 0.2s cubic-bezier(0, 0.32, 0.32, 1);transition:opacity 0.2s cubic-bezier(0, 0.32, 0.32, 1);z-index:1}.cosmos-image--image-state-loading .cosmos-image__image{opacity:0}.cosmos-image--image-state-success .cosmos-image__image{opacity:1;width:100%}.cosmos-image--fit-cover .cosmos-image__image{height:100%}', CosmosImage951Style0 = cosmosImageCss, generateClassNames$8 = bem("cosmos-image"), CosmosImage = /* @__PURE__ */ proxyCustomElement(class extends H {
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  handleImageChange(te, ee) {
    te !== ee && (this.imageState = IMAGE_STATE_LOADING);
  }
  handleObserveResizeChange(te) {
    this.containerResizeObserver && (this.containerResizeObserver.unobserve(this.container), te && this.containerResizeObserver.observe(this.container));
  }
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.resize = createEvent(this, "resize", 5), this.handleImageLoad = () => {
      this.imageState = IMAGE_STATE_LOAD_SUCCESS;
    }, this.handleImageError = () => {
      this.imageState = IMAGE_STATE_LOAD_ERROR;
    }, this.handlePreviewError = () => {
      this.previewState = IMAGE_STATE_LOAD_ERROR;
    }, this.shouldDisplayFallback = () => !(this.shouldDisplayImage() || this.shouldDisplayPreview()), this.shouldDisplayImage = () => !!this.image && this.imageState !== IMAGE_STATE_LOAD_ERROR, this.shouldDisplayPreview = () => !!this.imagePreview && this.previewState !== IMAGE_STATE_LOAD_ERROR, this.appearance = void 0, this.fit = "cover", this.image = void 0, this.imageAlt = "", this.imagePreview = void 0, this.loading = void 0, this.observeResize = void 0, this.radius = "none", this.sizes = void 0, this.srcset = void 0, this.computedAppearance = "light", this.imageState = void 0, this.previewState = void 0, !isNodeEnvironment() && (this.containerResizeObserver = new ResizeObserver((te) => this.handleContainerResize(te)));
  }
  componentWillLoad() {
    if (resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "dark", light: "light" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.image && typeof Image < "u") {
      const te = new Image();
      te.src = this.image, te.complete ? this.imageState = IMAGE_STATE_LOAD_SUCCESS : this.imageState = IMAGE_STATE_LOADING;
    }
  }
  componentDidLoad() {
    this.observeResize && this.handleObserveResizeChange(this.observeResize);
  }
  handleContainerResize(te) {
    te.forEach((ee) => {
      if (ee.target === this.container) {
        const { height: ie, width: ne } = ee.contentRect;
        this.resize.emit({
          height: ie,
          width: ne
        });
      }
    });
  }
  render() {
    return h$1("div", { key: "1d61bd76e4b048670585b9f21bf379ac240a29dc", class: generateClassNames$8({
      appearance: this.computedAppearance,
      fallback: this.shouldDisplayFallback(),
      fit: this.fit,
      "has-image": !!this.image,
      "has-preview": !!this.imagePreview,
      "image-state": this.imageState,
      radius: this.radius
    }), part: "base", ref: (te) => this.container = te }, !this.shouldDisplayFallback() && h$1("div", { key: "19017aef9e629b83ab525f9c5183e43c03885643", class: generateClassNames$8("container") }, this.shouldDisplayPreview() && h$1("div", { key: "9ba921d8ecfad2c6d0f3a645288d967b411adccd", class: generateClassNames$8("preview-container") }, h$1("img", { key: "72cbb8971282fd3cebd7bb5c3f7c747e1983d930", alt: "", class: generateClassNames$8("preview-image"), onError: this.handlePreviewError, src: this.imagePreview }), h$1("img", { key: "c459a999d6ae2c64d538040389a9ad6830877c53", alt: "", class: generateClassNames$8("preview-dummy"), src: this.imagePreview })), this.shouldDisplayImage() && h$1("img", { key: "2a52f3ca09196be8dd5fc86210d1b89080a448dd", alt: this.imageAlt, class: generateClassNames$8("image"), loading: this.loading, onError: this.handleImageError, onLoad: this.handleImageLoad, part: "image", sizes: this.sizes, src: this.image, srcSet: this.srcset })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      image: ["handleImageChange"],
      observeResize: ["handleObserveResizeChange"]
    };
  }
  static get style() {
    return CosmosImage951Style0;
  }
}, [1, "cosmos-image-9-5-1", {
  appearance: [513],
  fit: [513],
  image: [513],
  imageAlt: [513, "image-alt"],
  imagePreview: [513, "image-preview"],
  loading: [513],
  observeResize: [516, "observe-resize"],
  radius: [513],
  sizes: [513],
  srcset: [513],
  computedAppearance: [32],
  imageState: [32],
  previewState: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  image: ["handleImageChange"],
  observeResize: ["handleObserveResizeChange"]
}]);
function defineCustomElement$V() {
  if (typeof customElements > "u")
    return;
  ["cosmos-image-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-image-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosImage);
        break;
    }
  });
}
const getRandomInt = () => Math.floor(Math.random() * 1e3), cosmosSpinnerCss = ":host{display:block;height:1em;width:1em}.cosmos-spinner{color:var(--cosmos-spinner-color, #000F1E);display:block;height:100%;width:100%}@media screen and (prefers-reduced-motion: no-preference){.cosmos-spinner{-webkit-animation:spin 0.7s linear infinite;animation:spin 0.7s linear infinite}@-webkit-keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}}.cosmos-spinner *{stop-color:currentColor}.cosmos-spinner--appearance-light{color:var(--cosmos-spinner-color, #FFFFFF)}", CosmosSpinner951Style0 = cosmosSpinnerCss, generateClassNames$7 = bem("cosmos-spinner"), CosmosSpinner$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.appearance = void 0, this.computedAppearance = "dark";
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  componentWillLoad() {
    resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  render() {
    const te = getRandomInt();
    return h$1("svg", { key: "374c57737d7b5b70ec4679898455db8e4e8d6d73", class: generateClassNames$7({
      appearance: this.computedAppearance
    }), viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "1435a95c6e15398554ba5cb492ec51b5c67107fa", d: "M16.6292 7.75012C17.1997 8.73827 17.5 9.85919 17.5 11.0002C17.5 12.1412 17.1997 13.2621 16.6292 14.2503", stroke: `url(#segment-1-${te})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h$1("path", { key: "ebf732e51233cbfc3a778a372305ec7107294e9c", d: "M16.6291 14.2502C16.0586 15.2384 15.2381 16.0589 14.25 16.6294C13.2619 17.1999 12.141 17.5003 11 17.5003", stroke: `url(#segment-2-${te})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h$1("path", { key: "a59583758e1c98e53121987256fb3edbb51667d5", d: "M11 17.5003C9.859 17.5003 8.73812 17.1999 7.75 16.6294C6.76188 16.0589 5.94134 15.2384 5.37085 14.2502", stroke: `url(#segment-3-${te})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h$1("path", { key: "ec4be37cac6de84e47ca90a0009f532f367843f7", d: "M5.37086 14.2503C4.80035 13.2621 4.5 12.1412 4.5 11.0002C4.5 9.85919 4.80035 8.73827 5.37086 7.75012", stroke: `url(#segment-4-${te})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h$1("path", { key: "25a5a4c84dd1d8bd349637472c8518a1c0cfc2be", d: "M5.37085 7.75008C5.94134 6.76196 6.76188 5.94141 7.75 5.3709C8.73812 4.80039 9.859 4.50003 11 4.5", stroke: `url(#segment-5-${te})`, "stroke-width": "3", "vector-effect": "non-scaling-stroke" }), h$1("defs", { key: "e836e79ec9f61cfda99d860ff520b67c23b81698" }, h$1("linearGradient", { key: "c6196e06e68288f89ae3ed287583ce769f295582", id: `segment-1-${te}`, x1: "15.5", y1: "8.5", x2: "15.5", y2: "13.5", gradientUnits: "userSpaceOnUse" }, h$1("stop", { key: "a360000db92a5dbb18b927ee866b91fd3d875751", "stop-opacity": "0" }), h$1("stop", { key: "fc9a4c3efff44084c118825b179f53e83dfd7e7b", offset: "1", "stop-opacity": "0.25" })), h$1("linearGradient", { key: "cfd18e2d0c10b474ebc1cc266b6f414cd611b7fd", id: `segment-2-${te}`, x1: "15.5", y1: "13.5", x2: "13.2074", y2: "17.3236", gradientUnits: "userSpaceOnUse" }, h$1("stop", { key: "1ea5f466c10a80a0a53ee2985e7964bbc06dd880", "stop-opacity": "0.25" }), h$1("stop", { key: "53d307e19a92a9750f81b24a495d67a5e0b869cf", offset: "1", "stop-opacity": "0.5" })), h$1("linearGradient", { key: "9d95eef2526e13637601acbd43b4063fd2f17fb9", id: `segment-3-${te}`, x1: "11", y1: "16", x2: "9.0824", y2: "12.3929", gradientUnits: "userSpaceOnUse" }, h$1("stop", { key: "443673d879df03fa253e62480a9c053d477a8f70", "stop-opacity": "0.5" }), h$1("stop", { key: "767cbff4e0381577f2c67e6893c8f62cab260302", offset: "1", "stop-opacity": "0.75" })), h$1("linearGradient", { key: "467b4413d253003e37eeba613640aaf79d09ff02", id: `segment-4-${te}`, x1: "6.5", y1: "13.5", x2: "6.5", y2: "8.5", gradientUnits: "userSpaceOnUse" }, h$1("stop", { key: "0b266cb1053c4e291cca54e2c9487d201dada879", "stop-opacity": "0.75" }), h$1("stop", { key: "b60f9d7cec16515087150985628071938463c9f8", offset: "1" })), h$1("linearGradient", { key: "6a016e4d9315033489d66b1ca50b4f0192ae2dd4", id: `segment-5-${te}`, x1: "7", y1: "8", x2: "9.13409", y2: "4.76796", gradientUnits: "userSpaceOnUse" }, h$1("stop", { key: "19cf5cde5431c72ae3cc63bf9dc67e4b6b072136" }), h$1("stop", { key: "6667bc80bff3ce5705c6da91c3e70bf92bf0a558", offset: "1" }))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"]
    };
  }
  static get style() {
    return CosmosSpinner951Style0;
  }
}, [1, "cosmos-spinner-9-5-1", {
  appearance: [513],
  computedAppearance: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"]
}]);
function defineCustomElement$U() {
  if (typeof customElements > "u")
    return;
  ["cosmos-spinner-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-spinner-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosSpinner$1);
        break;
    }
  });
}
const cosmosButtonCss = ':host{display:inline-block;line-height:0;max-width:100%}:host([width=content]){width:auto}:host([width=full]){width:100%}@media screen and (min-width: 0){:host([width~="content@small"]){width:auto}}@media screen and (min-width: 0){:host([width~="full@small"]){width:100%}}@media screen and (min-width: 650px){:host([width~="content@medium"]){width:auto}}@media screen and (min-width: 650px){:host([width~="full@medium"]){width:100%}}@media screen and (min-width: 1000px){:host([width~="content@large"]){width:auto}}@media screen and (min-width: 1000px){:host([width~="full@large"]){width:100%}}@media screen and (min-width: 1200px){:host([width~="content@x-large"]){width:auto}}@media screen and (min-width: 1200px){:host([width~="full@x-large"]){width:100%}}@media screen and (min-width: 1350px){:host([width~="content@xx-large"]){width:auto}}@media screen and (min-width: 1350px){:host([width~="full@xx-large"]){width:100%}}.cosmos-button{--cosmos-icon-color:currentColor;--focus-offset:var(--cosmos-button-border-width, 1px);-ms-flex-align:center;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-color:var(--cosmos-button-border-color, transparent);border-radius:var(--cosmos-button-border-radius, 6px);border-style:solid;border-width:var(--cosmos-button-border-width, 1px);-webkit-box-sizing:border-box;box-sizing:border-box;cursor:pointer;display:-ms-flexbox;display:flex;height:var(--cosmos-button-height);-ms-flex-pack:center;justify-content:center;max-width:100%;outline:none;padding-block:0;position:relative;text-decoration:none;white-space:nowrap}.cosmos-button:focus,.cosmos-button:focus:not(:focus-visible){outline:none}.cosmos-button:focus:not(:focus-visible)::before{content:none}.cosmos-button:focus::before{border-radius:calc(var(--focus-radius, 6px) * 1.5);bottom:calc((4px + var(--focus-offset, 0px)) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + var(--focus-offset, 0px)) * -1);position:absolute;right:calc((4px + var(--focus-offset, 0px)) * -1);top:calc((4px + var(--focus-offset, 0px)) * -1);content:""}.cosmos-button.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover);border-color:var(--cosmos-button-border-color-hover, transparent)}.cosmos-button--busy:not(.cosmos-button--has-icon) .cosmos-button__spinner{left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.cosmos-button--busy:not(.cosmos-button--has-icon) .cosmos-button__label{visibility:hidden}.cosmos-button--busy.cosmos-button--has-icon ::slotted([slot=icon]){display:none}.cosmos-button__label{-ms-flex-item-align:baseline;align-self:baseline;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;--cosmos-text-color:currentColor;--cosmos-text-font-family:var(--cosmos-button-font-family);--cosmos-text-font-size:var(--cosmos-button-font-size);--cosmos-text-font-style:var(--cosmos-button-font-style);--cosmos-text-font-weight:var(--cosmos-button-font-weight);--cosmos-text-letter-spacing:var(--cosmos-button-letter-spacing);--cosmos-text-line-height:var(--cosmos-button-line-height);--cosmos-text-text-transform:var(--cosmos-button-text-transform)}:not(.cosmos-button--kind-link).cosmos-button--size-small .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(36rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-small .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-small .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(36rem / var(--cosmos-base-font-size, 16)))}:not(.cosmos-button--kind-link).cosmos-button--size-medium .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(40rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-medium .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-medium .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(40rem / var(--cosmos-base-font-size, 16)))}:not(.cosmos-button--kind-link).cosmos-button--size-large .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(48rem / var(--cosmos-base-font-size, 16)));-webkit-margin-before:calc(var(--cosmos-button-border-width, 1px) * -1);margin-block-start:calc(var(--cosmos-button-border-width, 1px) * -1)}.cosmos-button--kind-link.cosmos-button--shape-circle.cosmos-button--size-large .cosmos-button__label,.cosmos-button--kind-link.cosmos-button--shape-square.cosmos-button--size-large .cosmos-button__label{--cosmos-text-line-height:var(--cosmos-button-line-height, calc(48rem / var(--cosmos-base-font-size, 16)))}.cosmos-button__spinner{--cosmos-spinner-color:currentColor;height:calc(18rem / var(--cosmos-base-font-size, 16));width:calc(18rem / var(--cosmos-base-font-size, 16))}.cosmos-button ::slotted([slot=icon]),.cosmos-button__spinner{-ms-flex-negative:0;flex-shrink:0}.cosmos-button--icon-after{-ms-flex-direction:row-reverse;flex-direction:row-reverse}.cosmos-button--width-content{width:auto}.cosmos-button--width-full{width:100%}@media screen and (min-width: 0){.cosmos-button--width-content\\@small{width:auto}}@media screen and (min-width: 0){.cosmos-button--width-full\\@small{width:100%}}@media screen and (min-width: 650px){.cosmos-button--width-content\\@medium{width:auto}}@media screen and (min-width: 650px){.cosmos-button--width-full\\@medium{width:100%}}@media screen and (min-width: 1000px){.cosmos-button--width-content\\@large{width:auto}}@media screen and (min-width: 1000px){.cosmos-button--width-full\\@large{width:100%}}@media screen and (min-width: 1200px){.cosmos-button--width-content\\@x-large{width:auto}}@media screen and (min-width: 1200px){.cosmos-button--width-full\\@x-large{width:100%}}@media screen and (min-width: 1350px){.cosmos-button--width-content\\@xx-large{width:auto}}@media screen and (min-width: 1350px){.cosmos-button--width-full\\@xx-large{width:100%}}.cosmos-button--size-small{--cosmos-icon-size:var(--cosmos-button-icon-size, calc(16rem / var(--cosmos-base-font-size, 16)));--cosmos-button-height:calc(36rem / var(--cosmos-base-font-size, 16));gap:calc(4rem / var(--cosmos-base-font-size, 16));padding-inline:calc(16rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-medium{--cosmos-button-height:calc(40rem / var(--cosmos-base-font-size, 16));padding-inline:calc(20rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-large{--cosmos-button-height:calc(48rem / var(--cosmos-base-font-size, 16));padding-inline:calc(32rem / var(--cosmos-base-font-size, 16))}.cosmos-button--size-medium,.cosmos-button--size-large{--cosmos-icon-size:var(--cosmos-button-icon-size, calc(18rem / var(--cosmos-base-font-size, 16)));gap:calc(6rem / var(--cosmos-base-font-size, 16))}.cosmos-button--shape-pill:not(.cosmos-button--kind-link){--focus-radius:var(--cosmos-button-border-radius, 9999px);border-radius:var(--cosmos-button-border-radius, 9999px)}.cosmos-button--shape-square,.cosmos-button--shape-circle{gap:0;padding:0;width:var(--cosmos-button-height)}.cosmos-button--shape-square .cosmos-button__label,.cosmos-button--shape-circle .cosmos-button__label{-ms-flex-item-align:center;align-self:center}.cosmos-button--shape-square.cosmos-button--busy .cosmos-button__label,.cosmos-button--shape-circle.cosmos-button--busy .cosmos-button__label{display:none}.cosmos-button--shape-circle{--focus-radius:var(--cosmos-button-border-radius, 9999px);border-radius:var(--cosmos-button-border-radius, 9999px)}.cosmos-button--kind-primary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-primary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, #C3093B)}.cosmos-button--kind-secondary.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.1))}.cosmos-button--kind-secondary.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-secondary.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.2))}.cosmos-button--kind-secondary.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(255, 255, 255, 0.1))}.cosmos-button--kind-secondary.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-secondary.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.2))}.cosmos-button--kind-tertiary.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-tertiary.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.1));border-color:var(--cosmos-button-border-color-hover, rgba(0, 15, 30, 0.2))}.cosmos-button--kind-tertiary.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-tertiary.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.1));border-color:var(--cosmos-button-border-color-hover, rgba(255, 255, 255, 0.2))}.cosmos-button--kind-bare.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-bare.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.1))}.cosmos-button--kind-bare.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-bare.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(255, 255, 255, 0.1))}.cosmos-button--kind-link{border-radius:var(--cosmos-button-border-radius, 0);border-width:0}.cosmos-button--kind-link:not(.cosmos-button--shape-circle,.cosmos-button--shape-square){height:auto;padding:0}.cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-width:0 0 var(--cosmos-button-border-width, 2px) 0;margin-bottom:calc(var(--cosmos-button-border-width, 2px) * -1)}.cosmos-button--kind-link.cosmos-button--appearance-dark.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link.cosmos-button--appearance-dark:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-color:var(--cosmos-button-border-color-hover, var(--cosmos-button-border-color, rgba(0, 15, 30, 0.2)))}.cosmos-button--kind-link.cosmos-button--appearance-light.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button--kind-link.cosmos-button--appearance-light:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){border-color:var(--cosmos-button-border-color-hover, var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2)))}.cosmos-button--kind-secondary,.cosmos-button--kind-cover-up{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button--kind-tertiary,.cosmos-button--kind-bare,.cosmos-button--kind-link{background:var(--cosmos-button-background, transparent)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up{color:var(--cosmos-button-color, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){color:var(--cosmos-button-color-hover, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--appearance-dark{color:var(--cosmos-button-color, #000F1E)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--appearance-light{color:var(--cosmos-button-color, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-dark{color:var(--cosmos-button-color-hover, #000F1E)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-secondary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light,.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-link:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled).cosmos-button--appearance-light{color:var(--cosmos-button-color-hover, #FFFFFF)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-primary{background:var(--cosmos-button-background, #DB0A40)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:focus.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.1))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:focus.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.1))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-tertiary:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-bare:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.6));border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up.cosmos-button--hovered:not(.cosmos-button--busy):not(.cosmos-button--disabled),.cosmos-button:not(.cosmos-button--disabled).cosmos-button--kind-cover-up:hover:not(.cosmos-button--busy):not(.cosmos-button--disabled){background:var(--cosmos-button-background-hover, rgba(0, 15, 30, 0.8));border-color:var(--cosmos-button-border-color-hover, rgba(255, 255, 255, 0.45))}.cosmos-button--disabled{cursor:not-allowed}.cosmos-button--disabled.cosmos-button--kind-primary{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.cosmos-button--disabled.cosmos-button--kind-primary.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.1))}.cosmos-button--disabled.cosmos-button--kind-primary.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(255, 255, 255, 0.1))}.cosmos-button--disabled.cosmos-button--kind-tertiary.cosmos-button--appearance-dark{border-color:var(--cosmos-button-border-color, rgba(0, 15, 30, 0.1))}.cosmos-button--disabled.cosmos-button--kind-tertiary.cosmos-button--appearance-light{border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.1))}.cosmos-button--disabled.cosmos-button--kind-cover-up{color:var(--cosmos-button-color, rgba(255, 255, 255, 0.45))}.cosmos-button--disabled.cosmos-button--kind-cover-up.cosmos-button--appearance-light{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.45));border-color:var(--cosmos-button-border-color, rgba(255, 255, 255, 0.2))}.cosmos-button--disabled.cosmos-button--kind-cover-up.cosmos-button--appearance-dark{background:var(--cosmos-button-background, rgba(0, 15, 30, 0.45))}.cosmos-button--disabled.cosmos-button--appearance-dark:not(.cosmos-button--kind-cover-up){color:var(--cosmos-button-color, rgba(0, 15, 30, 0.45))}.cosmos-button--disabled.cosmos-button--appearance-light:not(.cosmos-button--kind-cover-up){color:var(--cosmos-button-color, rgba(255, 255, 255, 0.45))}', CosmosButton951Style0 = cosmosButtonCss, CosmosButton$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.handleIconSlotChange = () => {
      this.hasIconSlot = hasNamedSlot(this.element, "icon");
    }, this.appearance = void 0, this.ariaExpanded = void 0, this.ariaHaspopup = void 0, this.ariaLabel = void 0, this.busy = !1, this.buttonTitle = void 0, this.decorative = !1, this.disabled = !1, this.hovered = !1, this.href = void 0, this.iconPlacement = "before", this.kind = "primary", this.rel = void 0, this.shape = void 0, this.size = "medium", this.target = void 0, this.type = "button", this.width = "content", this.computedAppearance = "dark", this.hasIconSlot = !1;
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  /**
   * Removes focus from the Button.
   */
  async buttonBlur() {
    this.buttonElement && this.buttonElement.blur();
  }
  /**
   * Sets focus on the Button.
   */
  async buttonFocus() {
    this.buttonElement && this.buttonElement.focus();
  }
  handleClick(te) {
    const ee = this.element.closest("form");
    if (this.disabled || this.busy) {
      te.stopImmediatePropagation(), te.preventDefault(), te.stopPropagation();
      return;
    }
    if (!(!this.isButton() || this.type === "button" || !ee)) {
      if (this.type === "reset")
        return ee.reset();
      if (this.type === "submit")
        return requestFormSubmit(ee);
    }
  }
  getTextWeight() {
    return "medium";
  }
  getTextSize() {
    return this.size === "small" ? "x-small" : "small";
  }
  getType() {
    return this.isButton() ? this.type : void 0;
  }
  getWidth() {
    return this.width && isResponsiveProperty(this.width) ? parseResponsiveProperty(this.width) : this.width;
  }
  getHostRole() {
    return this.ariaExpanded || this.ariaHaspopup || this.ariaLabel ? "presentation" : null;
  }
  isButton() {
    return !this.href && !this.decorative;
  }
  isLink() {
    return !!this.href && !this.decorative;
  }
  determineTag() {
    return this.isButton() ? "button" : this.isLink() ? "a" : "div";
  }
  getAriaLabel() {
    var te;
    return this.ariaLabel !== void 0 ? this.ariaLabel : (te = this.element.textContent) === null || te === void 0 ? void 0 : te.trim();
  }
  componentWillLoad() {
    this.hasIconSlot = hasNamedSlot(this.element, "icon"), resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  render() {
    const te = this.determineTag(), ee = bem("cosmos-button");
    return h$1(Host, { key: "85f2845703905e31935c4aaef9c54db64b5ab28a", role: this.getHostRole() }, h$1(te, { key: "6f1b987bef67b1927e310c0ed10a85b9bc712adc", class: ee({
      kind: this.kind,
      busy: this.busy,
      disabled: this.disabled || this.busy,
      appearance: this.computedAppearance,
      shape: this.shape || "pill",
      size: this.size,
      icon: this.iconPlacement,
      hovered: this.hovered,
      width: this.getWidth(),
      "has-icon": this.hasIconSlot
    }), disabled: this.disabled || this.busy, href: this.href, target: this.target, rel: this.rel, ref: (ie) => this.buttonElement = ie, type: this.getType(), part: "base", "aria-expanded": this.ariaExpanded, "aria-haspopup": this.ariaHaspopup, "aria-label": this.getAriaLabel(), title: this.buttonTitle }, this.busy && h$1("cosmos-spinner-9-5-1", { key: "8068d32808a096340001254641ce95d433873fee", class: ee("spinner") }), h$1("slot", { key: "7eb60f81b3e30494d4101bcee174580b3229c394", name: "icon", onSlotchange: this.handleIconSlotChange }), h$1("cosmos-text-9-5-1", { key: "a5691dd339e262fb75ab7aa3b1db7fc99d355069", class: ee("label"), size: this.getTextSize(), tag: "span", weight: this.getTextWeight(), exportparts: "base: label" }, h$1("span", { key: "e1c7926559639f715fc6f132042b45292c5aee1e" }, h$1("slot", { key: "b68485200ee960ebbc50697d9d6c897edebc6915" })))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"]
    };
  }
  static get style() {
    return CosmosButton951Style0;
  }
}, [1, "cosmos-button-9-5-1", {
  appearance: [513],
  ariaExpanded: [513, "aria-expanded"],
  ariaHaspopup: [513, "aria-haspopup"],
  ariaLabel: [513, "aria-label"],
  busy: [516],
  buttonTitle: [513, "button-title"],
  decorative: [516],
  disabled: [516],
  hovered: [516],
  href: [513],
  iconPlacement: [513, "icon-placement"],
  kind: [513],
  rel: [513],
  shape: [513],
  size: [513],
  target: [513],
  type: [513],
  width: [513],
  computedAppearance: [32],
  hasIconSlot: [32],
  buttonBlur: [64],
  buttonFocus: [64]
}, [[2, "click", "handleClick"]], {
  appearance: ["handleAppearanceChange"]
}]);
function defineCustomElement$T() {
  if (typeof customElements > "u")
    return;
  ["cosmos-button-9-5-1", "cosmos-spinner-9-5-1", "cosmos-text-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-button-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosButton$1);
        break;
      case "cosmos-spinner-9-5-1":
        customElements.get(te) || defineCustomElement$U();
        break;
      case "cosmos-text-9-5-1":
        customElements.get(te) || defineCustomElement$W();
        break;
    }
  });
}
const defineCustomElement$S = defineCustomElement$T, getAriaDescribedBy = (re) => ["help-text", re && "validation-message"].filter(Boolean).join(" "), getAriaInvalid = (re) => re ? "true" : "false", getAriaDisabled = (re) => re ? "true" : void 0, getAriaRequired = (re) => re ? "true" : void 0, cosmosIconCss$A = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconWarning951Style0 = cosmosIconCss$A, CosmosIconWarning = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "b4507cc5f0163deefd8d870ef931e8fd81c23913", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "b638b17b5ab234e3b2f88c74114fa905ea1384a3", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "a13ff7a1468391663ac4db69cc2fc4fbcfefcd61", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.57 17.25 11.43 3.11a.49.49 0 0 0-.86 0L2.44 17.25a.5.5 0 0 0 .43.75h16.27a.5.5 0 0 0 .43-.75ZM10.25 9.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-3ZM11 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconWarning951Style0;
  }
}, [1, "cosmos-icon-warning-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$R() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-warning-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-warning-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconWarning);
        break;
    }
  });
}
const cosmosCheckboxCss = '@charset "UTF-8";:host{display:block;min-width:0;width:100%}.cosmos-checkbox{-ms-flex-align:baseline;align-items:baseline;display:-ms-flexbox;display:flex}.cosmos-checkbox__input-and-prefix{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0}.cosmos-checkbox__aligner{--cosmos-text-font-family:var(--cosmos-checkbox-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-text-transform);width:0}.cosmos-checkbox__aligner::before{content:" "}.cosmos-checkbox__input-container{-ms-flex-negative:0;flex-shrink:0;height:var(--cosmos-checkbox-size, 16px);-webkit-margin-end:var(--cosmos-checkbox-gap, calc(0.5 * var(--cosmos-checkbox-size, 16px)));margin-inline-end:var(--cosmos-checkbox-gap, calc(0.5 * var(--cosmos-checkbox-size, 16px)));position:relative;width:var(--cosmos-checkbox-size, 16px)}.cosmos-checkbox__prefix{display:grid}.cosmos-checkbox__prefix>[slot=prefix]{-webkit-margin-end:var(--cosmos-checkbox-gap, calc(0.375 * var(--cosmos-checkbox-size, 16px)));margin-inline-end:var(--cosmos-checkbox-gap, calc(0.375 * var(--cosmos-checkbox-size, 16px)))}.cosmos-checkbox__prefix ::slotted([slot=prefix]){--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px;-webkit-margin-end:var(--cosmos-checkbox-gap, calc(0.375 * var(--cosmos-checkbox-size, 16px)));margin-inline-end:var(--cosmos-checkbox-gap, calc(0.375 * var(--cosmos-checkbox-size, 16px)));position:relative}.cosmos-checkbox__prefix ::slotted([slot=prefix])::before{content:"";display:block;height:100%;left:0;min-height:calc(var(--cosmos-checkbox-size, 16px) + calc(0.25 * var(--cosmos-checkbox-size, 16px)) * 2);position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.cosmos-checkbox__input{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;-webkit-box-shadow:none;box-shadow:none;display:block;height:var(--cosmos-checkbox-size, 16px);margin:0;outline:none;width:var(--cosmos-checkbox-size, 16px)}.cosmos-checkbox__input:focus,.cosmos-checkbox__input:focus:not(:focus-visible){outline:none}.cosmos-checkbox__input:focus:not(:focus-visible)::before{content:none}.cosmos-checkbox__input:focus::before{border-radius:calc(var(--cosmos-checkbox-border-radius, 4px) * 1.5);bottom:calc((4px + 0px) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + 0px) * -1);position:absolute;right:calc((4px + 0px) * -1);top:calc((4px + 0px) * -1);content:""}.cosmos-checkbox__input::after{-webkit-box-sizing:content-box;box-sizing:content-box;content:"";display:block;height:calc(var(--cosmos-checkbox-size, 16px) + calc(0.25 * var(--cosmos-checkbox-size, 16px)) * 2);-webkit-margin-start:calc(calc(0.25 * var(--cosmos-checkbox-size, 16px)) * -1);margin-inline-start:calc(calc(0.25 * var(--cosmos-checkbox-size, 16px)) * -1);position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:calc(var(--cosmos-checkbox-size, 16px) + calc(0.25 * var(--cosmos-checkbox-size, 16px)) * 2);z-index:1}.cosmos-checkbox__input:checked~.cosmos-checkbox__tick{opacity:1}.cosmos-checkbox__input:not(:indeterminate)~.cosmos-checkbox__hyphen{display:none}.cosmos-checkbox__control{border-radius:var(--cosmos-checkbox-border-radius, 4px);border-style:solid;border-width:var(--cosmos-checkbox-border-width, 1px);-webkit-box-sizing:border-box;box-sizing:border-box;display:block;height:100%;left:0;position:absolute;top:0;width:100%}.cosmos-checkbox__tick{fill:currentColor;height:calc(var(--cosmos-checkbox-size, 16px) / 2);left:50%;opacity:0;pointer-events:none;position:absolute;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.cosmos-checkbox__hyphen{border-radius:0.5px;display:block;height:calc(var(--cosmos-checkbox-size, 16px) / 10);left:50%;pointer-events:none;position:absolute;top:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);width:calc(var(--cosmos-checkbox-size, 16px) / 2)}.cosmos-checkbox__content{position:relative}.cosmos-checkbox__content--row{width:100%}.cosmos-checkbox__content--row label{display:inline-block;width:100%}.cosmos-checkbox__label{position:relative}.cosmos-checkbox__label::before{bottom:calc(calc(0.25 * var(--cosmos-checkbox-size, 16px)) * -1);content:"";left:0;position:absolute;right:0;top:calc(calc(0.25 * var(--cosmos-checkbox-size, 16px)) * -1)}.cosmos-checkbox__label-text{--cosmos-text-color:var(--cosmos-checkbox-color);--cosmos-text-font-family:var(--cosmos-checkbox-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-text-transform);display:inline;position:relative}.cosmos-checkbox--hovered .cosmos-checkbox__label-text{--cosmos-text-color:var(--cosmos-checkbox-color-hover)}.cosmos-checkbox__required-optional-label{--cosmos-text-color:var(--cosmos-checkbox-required-optional-label-color);--cosmos-text-font-family:var(--cosmos-checkbox-required-optional-label-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-required-optional-label-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-required-optional-label-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-required-optional-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-required-optional-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-required-optional-label-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-required-optional-label-text-transform);display:inline;-webkit-margin-start:4px;margin-inline-start:4px;white-space:nowrap}.cosmos-checkbox__help-text{--cosmos-text-color:var(--cosmos-checkbox-help-text-color);--cosmos-text-font-family:var(--cosmos-checkbox-help-text-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-help-text-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-help-text-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-help-text-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-help-text-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-help-text-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-help-text-text-transform);display:block;padding-top:4px}.cosmos-checkbox:not(.cosmos-checkbox--has-help-text) .cosmos-checkbox__help-text{display:none}.cosmos-checkbox--appearance-dark{color:var(--cosmos-checkbox-color, #000F1E)}.cosmos-checkbox--appearance-dark .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-dark .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, #000F1E)}.cosmos-checkbox--appearance-dark .cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, transparent);border-color:var(--cosmos-checkbox-border-color, rgba(0, 15, 30, 0.6))}.cosmos-checkbox--appearance-dark .cosmos-checkbox__tick{color:var(--cosmos-checkbox-icon-color, #FFFFFF)}.cosmos-checkbox--appearance-dark .cosmos-checkbox__hyphen{background-color:var(--cosmos-checkbox-icon-color, #FFFFFF)}.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover,.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered{color:var(--cosmos-checkbox-color-hover, #000F1E)}.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input~.cosmos-checkbox__control,.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input~.cosmos-checkbox__control{background:var(--cosmos-checkbox-background-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control,.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-dark:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color-hover, rgba(0, 15, 30, 0.8));border-color:var(--cosmos-checkbox-border-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-checkbox--appearance-light{color:var(--cosmos-checkbox-color, #FFFFFF)}.cosmos-checkbox--appearance-light .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-light .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, #FFFFFF)}.cosmos-checkbox--appearance-light .cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, transparent);border-color:var(--cosmos-checkbox-border-color, rgba(255, 255, 255, 0.6))}.cosmos-checkbox--appearance-light .cosmos-checkbox__tick{color:var(--cosmos-checkbox-icon-color, #000F1E)}.cosmos-checkbox--appearance-light .cosmos-checkbox__hyphen{background-color:var(--cosmos-checkbox-icon-color, #000F1E)}.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover,.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered{color:var(--cosmos-checkbox-color-hover, #FFFFFF)}.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input~.cosmos-checkbox__control,.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input~.cosmos-checkbox__control{background:var(--cosmos-checkbox-background-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled) .cosmos-checkbox__input-container:hover .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control,.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--appearance-light:not(.cosmos-checkbox--disabled).cosmos-checkbox--hovered .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color-hover, rgba(255, 255, 255, 0.8));border-color:var(--cosmos-checkbox-border-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-checkbox--disabled{pointer-events:none}.cosmos-checkbox--disabled .cosmos-checkbox__prefix{opacity:0.4}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-dark .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--disabled.cosmos-checkbox--appearance-dark .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, rgba(0, 15, 30, 0.45));border-color:var(--cosmos-checkbox-border-color, transparent)}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-dark .cosmos-checkbox__control{border-color:var(--cosmos-checkbox-border-color, rgba(0, 15, 30, 0.45))}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-dark .cosmos-checkbox__label-text{--cosmos-text-color:var(--cosmos-checkbox-color, rgba(0, 15, 30, 0.45))}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-light .cosmos-checkbox__input:checked~.cosmos-checkbox__control,.cosmos-checkbox--disabled.cosmos-checkbox--appearance-light .cosmos-checkbox__input:indeterminate~.cosmos-checkbox__control{background-color:var(--cosmos-checkbox-background-color, rgba(255, 255, 255, 0.45));border-color:var(--cosmos-checkbox-border-color, transparent)}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-light .cosmos-checkbox__control{border-color:var(--cosmos-checkbox-border-color, rgba(255, 255, 255, 0.45))}.cosmos-checkbox--disabled.cosmos-checkbox--appearance-light .cosmos-checkbox__label-text{--cosmos-text-color:var(--cosmos-checkbox-color, rgba(255, 255, 255, 0.45))}.cosmos-checkbox--invalid .cosmos-checkbox__control{border-color:var(--cosmos-checkbox-invalid-color, #E06600);border-width:var(--cosmos-checkbox-border-width, 2px)}.cosmos-checkbox--invalid .cosmos-checkbox__required-label{--cosmos-text-color:var(--cosmos-checkbox-invalid-color, #E06600)}.cosmos-checkbox__validation-message{display:-ms-flexbox;display:flex;gap:4px;margin-top:4px}.cosmos-checkbox__validation-message-text{--cosmos-text-color:var(--cosmos-checkbox-color);--cosmos-text-font-family:var(--cosmos-checkbox-validation-message-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-validation-message-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-validation-message-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-validation-message-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-validation-message-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-validation-message-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-validation-message-text-transform)}.cosmos-checkbox__validation-message-icon{--cosmos-icon-color:var(--cosmos-checkbox-invalid-color, #E06600);--cosmos-icon-size:calc(16rem / var(--cosmos-base-font-size, 16));-ms-flex-negative:0;flex-shrink:0;padding:1.5px 0}.cosmos-checkbox--clamp .cosmos-checkbox__content{min-width:0}.cosmos-checkbox--clamp .cosmos-checkbox__label{-ms-flex-align:baseline;align-items:baseline;display:-ms-flexbox;display:flex;min-width:0}.cosmos-checkbox--clamp .cosmos-checkbox__label-text{display:-ms-flexbox;display:flex;min-width:0}', CosmosCheckbox951Style0 = cosmosCheckboxCss, generateClassNames$6 = bem("cosmos-checkbox"), CosmosCheckbox$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.inputchangeEvent = createEvent(this, "inputchange", 6), this.inputinvalidEvent = createEvent(this, "inputinvalid", 7), this.wasSubmitted = !1, this.toggleCheckbox = () => {
      this.input.click();
    }, this.getValidationMessage = () => {
      if (this.validationMessage)
        return this.validationMessage;
      if (this.inputInvalid && !this.group && this.input)
        return this.input.validationMessage;
    }, this.reannounceValidationMessage = async () => {
      this.validationMessageRef && (this.validationMessageRef.ariaLabel = "", await nextTick(), this.validationMessageRef.ariaLabel = this.getValidationMessage());
    }, this.handleInputChange = (te) => {
      const ee = te.target;
      this.inputchangeEvent.emit({ checked: ee.checked }), !this.isValidityControlled() && this.wasSubmitted && (this.inputInvalid = !this.reportValidity());
    }, this.isValidityControlled = () => this.group ? this.group.invalid || !1 : this.invalid || !1, this.handleInvalid = (te) => {
      te.preventDefault(), this.inputInvalid = !0, this.inputinvalidEvent.emit();
    }, this.handleFormData = (te) => {
      if (this.input && this.name && this.isInputChecked() && !this.disabled)
        return te.formData.append(this.input.name, this.input.value);
    }, this.handleFormSubmit = (te) => {
      this.wasSubmitted = !0, this.input && !this.reportValidity() && (te.preventDefault(), this.reannounceValidationMessage());
    }, this.hoveredOn = () => {
      this.isHovered = !0;
    }, this.hoveredOff = () => {
      this.isHovered = !1;
    }, this.handleSlotChange = () => {
      this.labelText = getDefaultSlotTextContent(this.defaultSlotRef);
    }, this.appearance = void 0, this.autofocus = void 0, this.checked = !1, this.clamp = void 0, this.disabled = void 0, this.helpText = void 0, this.hitArea = "content", this.invalid = !1, this.name = void 0, this.optionalLabel = void 0, this.required = !1, this.requiredLabel = void 0, this.validationMessage = void 0, this.value = void 0, this.computedAppearance = "dark", this.inputInvalid = !1, this.isHovered = !1, this.labelText = "";
  }
  /**
   * Removes focus from the Checkbox.
   */
  async inputBlur() {
    this.input.blur();
  }
  /**
   * Sets focus on the Checkbox. This will scroll the element into the view and focus it.
   */
  async inputFocus() {
    this.input.focus();
  }
  /**
   * Returns the validity status of the Checkbox' value.
   * Fires an `inputinvalid`  event in the case of invalidity.
   */
  async inputCheckValidity() {
    return this.checkValidity();
  }
  /**
   * Performs the same validity checking steps as the `inputCheckValidity` methods.
   * Fires an `inputinvalid` event and reports the problem to the user in case of invalidity.
   */
  async inputReportValidity() {
    const te = this.reportValidity();
    return this.inputInvalid = !te, te;
  }
  /**
   * Sets a custom error message for the native validation issue report.
   */
  async inputSetCustomValidity(te) {
    this.input.setCustomValidity(te);
  }
  handleChecked() {
    this.setInputIndeterminateAttribute();
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  handleInvalidChange(te) {
    this.inputInvalid = te;
  }
  isChecked() {
    return stringBooleanToBoolean(this.checked);
  }
  isInputChecked() {
    return this.input && this.input.checked !== !1 && !this.isInputIndeterminate();
  }
  isIndeterminate() {
    return this.checked === "indeterminate";
  }
  isInputIndeterminate() {
    return this.input && this.input.indeterminate;
  }
  setInputIndeterminateAttribute() {
    this.input && (this.input.indeterminate = this.isIndeterminate());
  }
  hasRequiredLabel() {
    return !!this.required && !!this.requiredLabel;
  }
  hasRequiredOrOptionalLabel() {
    return this.hasRequiredLabel() || !!this.optionalLabel;
  }
  hasHelpText() {
    return !!this.helpText || hasNamedSlot(this.element, "help-text");
  }
  getTitle() {
    return this.clamp ? this.labelText : void 0;
  }
  getAriaDescribedby() {
    const te = [];
    return this.inputInvalid && this.getValidationMessage() && te.push("validation-message"), this.hasHelpText() && te.push("help-text"), te.length ? te.join(" ") : void 0;
  }
  getAriaChecked() {
    return this.isIndeterminate() ? "mixed" : !1;
  }
  getHelpText() {
    if (this.helpText)
      return this.helpText;
    if (hasNamedSlot(this.element, "help-text"))
      return getNamedSlotTextContent(this.element, "help-text");
  }
  getAllCheckboxes() {
    return this.group ? [
      ...this.group.querySelectorAll(`${transformTagName("cosmos-checkbox")}[name="${this.name}"]`)
    ].filter((ee) => !ee.disabled) : [this.element];
  }
  checkValidity() {
    const te = this.getAllCheckboxes(), ee = te == null ? void 0 : te.some((ne) => ne.shadowRoot.querySelector('input[type="checkbox"]').checked);
    return !(te == null ? void 0 : te.some((ne) => ne.required)) || ee;
  }
  reportValidity() {
    const te = this.checkValidity();
    return te || (this.input.required = !0, this.input.reportValidity()), te;
  }
  connectedCallback() {
    this.form = this.element.closest("form"), this.group = this.element.closest(transformTagName("cosmos-checkbox-group")), this.form && (this.form.addEventListener("formdata", this.handleFormData, !0), this.form.addEventListener("submit", this.handleFormSubmit, !0));
  }
  componentWillLoad() {
    this.inputInvalid = this.invalid, resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  render() {
    const te = this.getValidationMessage(), ee = this.getHelpText(), ie = !!this.labelText;
    return h$1("div", { key: "5872f993038d6b380edfa8dce5d84cb45c078d98", class: generateClassNames$6({
      appearance: this.computedAppearance,
      clamp: this.clamp,
      disabled: this.disabled,
      hovered: this.isHovered,
      indeterminate: this.isIndeterminate(),
      invalid: this.inputInvalid,
      "has-help-text": this.hasHelpText()
    }), part: "base" }, h$1("div", { key: "d5be96fc5d3ab86f805e42dc1c1fd98ed76b44da", class: generateClassNames$6("input-and-prefix") }, h$1("cosmos-text-9-5-1", { key: "509dc2a9cd5851d92a5c552b0d4488c64d572794", "aria-hidden": "true", class: generateClassNames$6("aligner"), size: "small", tag: "span" }), h$1("div", { key: "d010bef014c3405d8825f4e123d51ff252398b96", class: generateClassNames$6("input-container") }, h$1("input", { key: "fa64ff135550b0c40d2edf79d4046f5611909f1a", "aria-checked": this.getAriaChecked(), "aria-describedby": getAriaDescribedBy(this.inputInvalid), "aria-invalid": getAriaInvalid(this.inputInvalid), "aria-label": this.labelText, "aria-required": getAriaRequired(this.required), autofocus: this.autofocus, checked: this.isChecked(), class: generateClassNames$6("input"), disabled: this.disabled, id: "checkbox", name: this.name, onChange: this.handleInputChange, onInvalid: this.handleInvalid, ref: (ne) => this.input = ne, required: this.required, type: "checkbox", value: this.value }), h$1("span", { key: "2488e934cc7b7b11e3ce985da6acbfcef3159908", class: generateClassNames$6("control"), part: "checkbox" }), h$1("svg", { key: "b1a1ba807d70c703c85eb29b74ecde60ca44eaf9", "aria-hidden": "true", class: generateClassNames$6("tick", { selected: !0 }), viewBox: "0 0 14 10", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { key: "2628db4fc0cf4f5802a70743443dfb14f1ca84e7", d: "M0.985237 6.1331C0.692033 5.85873 0.67668 5.39865 0.950941 5.10535L1.1595 4.8823C1.42921 4.59387 1.8798 4.57335 2.1746 4.83608L5.21473 7.54546L11.824 0.477201C12.1114 0.169801 12.599 0.169801 12.8864 0.4772L13.0808 0.685097C13.3422 0.964657 13.3422 1.39898 13.0808 1.67854L5.71164 9.55949C5.43724 9.85296 4.97686 9.86832 4.6835 9.5938L0.985237 6.1331Z" })), h$1("span", { key: "793433355e1a3f490aaa8c99f6471ebcd669716b", class: generateClassNames$6("hyphen") })), h$1("div", { key: "6119cba0791fa52665f40a8e68ad7137d0633226", id: "prefix", "aria-hidden": "true", class: generateClassNames$6("prefix", {
      "end-margin": ie
    }), part: "prefix", onClick: this.toggleCheckbox, onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff }, h$1("slot", { key: "2527ce5dad141a684266a76bbf238d07df464c35", name: "prefix" }))), h$1("div", { key: "d6017f9fff95528bb03415bec5cbea0e061bec04", class: generateClassNames$6("content", {
      row: this.hitArea === "row"
    }) }, h$1("label", { key: "08508dbb6ec4a6ca0088807f24aeb0f373ebc888", class: generateClassNames$6("label"), htmlFor: "checkbox", onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff }, h$1("cosmos-text-9-5-1", { key: "c994fe8135185f991dd697f7414d712c50174b52", appearance: this.computedAppearance, clamp: this.clamp, class: generateClassNames$6("label-text"), exportparts: "base: label", tag: "span", title: this.getTitle(), size: "small" }, h$1("span", { key: "a8feea0e26fd86b4c9505eafa0e4d102931c6cd0" }, h$1("slot", { key: "6054496114792e5fa7db8a79474fa8c4237d4762", ref: (ne) => this.defaultSlotRef = ne }))), this.hasRequiredOrOptionalLabel() && h$1("cosmos-text-9-5-1", { key: "50a9774c428b05bd45344d69d2c4a72c0ca34886", appearance: this.computedAppearance, "aria-hidden": "true", class: generateClassNames$6("required-optional-label"), exportparts: "base: required-label", kind: "subtle", size: "xx-small", tag: "span" }, !this.hasRequiredLabel() && !this.required ? this.optionalLabel : this.requiredLabel)), h$1("cosmos-text-9-5-1", { key: "e83f11f561cd1168a1141a5ed9760a3ea3ecf0cd", appearance: this.computedAppearance, clamp: this.clamp, class: generateClassNames$6("help-text"), exportparts: "base: help-text", kind: "subtle", size: "x-small" }, h$1("span", { key: "b09330df46ebd94315bb5d17d00efd5a0a8155fc", "aria-label": ee, id: "help-text" }, h$1("slot", { key: "ea3371379089cb894b85b5e425ca56daf092dbbe", name: "help-text" }, this.helpText))), h$1("div", {
      key: "3e68dc8f77dc226b9675441aa9f0cd7692c8f678",
      "aria-atomic": "false",
      "aria-live": "polite",
      class: generateClassNames$6("validation-message-container")
    }, this.inputInvalid && !!te && h$1("div", { key: "7b804c3da6d8a95a2d2020c8d037a9315ac4a0e5", class: generateClassNames$6("validation-message") }, h$1("cosmos-icon-warning-9-5-1", { key: "0f2a4277312c3235a7de0828388b4f8e0fdf8eb0", "aria-hidden": "true", class: generateClassNames$6("validation-message-icon") }), h$1("cosmos-text-9-5-1", { key: "d4feabeb9ba0932be7b1cbc17948a730aa5c0039", appearance: this.computedAppearance, class: generateClassNames$6("validation-message-text"), exportparts: "base: validation-message", size: "x-small", tag: "span" }, h$1("span", { key: "0abec315c7440cd26db97bb72fed655fbaf56baf", "aria-label": te, id: "validation-message", ref: (ne) => this.validationMessageRef = ne }, te))))));
  }
  componentDidLoad() {
    this.setInputIndeterminateAttribute(), slotMutationService.observe(this.element, this.handleSlotChange);
  }
  disconnectedCallback() {
    this.form && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit)), slotMutationService.unobserve(this.element);
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      checked: ["handleChecked"],
      appearance: ["handleAppearanceChange"],
      invalid: ["handleInvalidChange"]
    };
  }
  static get style() {
    return CosmosCheckbox951Style0;
  }
}, [1, "cosmos-checkbox-9-5-1", {
  appearance: [513],
  autofocus: [516],
  checked: [520],
  clamp: [516],
  disabled: [516],
  helpText: [513, "help-text"],
  hitArea: [513, "hit-area"],
  invalid: [516],
  name: [513],
  optionalLabel: [513, "optional-label"],
  required: [516],
  requiredLabel: [513, "required-label"],
  validationMessage: [513, "validation-message"],
  value: [513],
  computedAppearance: [32],
  inputInvalid: [32],
  isHovered: [32],
  labelText: [32],
  inputBlur: [64],
  inputFocus: [64],
  inputCheckValidity: [64],
  inputReportValidity: [64],
  inputSetCustomValidity: [64]
}, void 0, {
  checked: ["handleChecked"],
  appearance: ["handleAppearanceChange"],
  invalid: ["handleInvalidChange"]
}]);
function defineCustomElement$Q() {
  if (typeof customElements > "u")
    return;
  ["cosmos-checkbox-9-5-1", "cosmos-icon-warning-9-5-1", "cosmos-text-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-checkbox-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosCheckbox$1);
        break;
      case "cosmos-icon-warning-9-5-1":
        customElements.get(te) || defineCustomElement$R();
        break;
      case "cosmos-text-9-5-1":
        customElements.get(te) || defineCustomElement$W();
        break;
    }
  });
}
const defineCustomElement$P = defineCustomElement$Q, FormField = ({ helpText: re, appearance: te = "dark", disabled: ee, label: ie, invalid: ne, labelForValue: ae, requiredLabel: ue, optionalLabel: _e, validationMessage: fe, class: le, element: se, required: oe, validationMessageRef: ce }, he) => {
  const ge = bem("cosmos-form-field"), ve = oe ? ue : _e, me = pe(), be = () => {
    const $e = se.shadowRoot.querySelector(`#${ae}`);
    $e != null && $e.hasAttribute("role") && $e.focus();
  };
  function pe() {
    return re || (hasNamedSlot(se, "help-text") ? getNamedSlotTextContent(se, "help-text") : "");
  }
  return h(
    "div",
    { class: [
      le,
      ge({
        invalid: ne,
        disabled: ee,
        appearance: te
      })
    ].join(" "), part: "base" },
    h(
      "div",
      { class: ge("info-container", {
        "has-label": !!ie,
        "has-help-text": !!me,
        "has-required-optional-label": !!ve
      }) },
      h(
        "label",
        { htmlFor: ae ?? void 0, class: ge("label"), onClick: be },
        h(
          "cosmos-text-9-5-1",
          { appearance: te, class: ge("label-text"), exportparts: "base: label", size: "x-small", tag: "span", weight: "medium" },
          h("span", { id: "label" }, ie)
        ),
        ve && h("cosmos-text-9-5-1", { appearance: te, "aria-hidden": "true", class: ge("required-optional-label"), exportparts: "base: required-label", kind: "subtle", size: "xx-small", tag: "span" }, ve)
      ),
      h(
        "cosmos-text-9-5-1",
        { appearance: te, class: ge("help-text"), kind: "subtle", size: "x-small", exportparts: "base: help-text" },
        h(
          "span",
          { "aria-label": me, id: "help-text" },
          h("slot", { name: "help-text" }, re)
        )
      )
    ),
    h("div", null, he),
    h("div", {
      "aria-atomic": "false",
      "aria-live": "polite",
      class: ge("validation-message-container")
    }, ne && fe && h(
      "div",
      { class: ge("validation-message") },
      h("cosmos-icon-warning-9-5-1", { "aria-hidden": "true", class: ge("validation-message-icon") }),
      h(
        "cosmos-text-9-5-1",
        { appearance: te, class: ge("validation-message-text"), exportparts: "base: validation-message", size: "x-small", tag: "span" },
        h("span", { "aria-label": fe, id: "validation-message", ref: ce }, fe)
      )
    ))
  );
}, cosmosMediaPreviewCss = ":host{display:-ms-flexbox;display:flex;overflow:hidden}.cosmos-media-preview{-ms-flex-positive:1;flex-grow:1;overflow:hidden;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}.cosmos-media-preview--radius-none{border-radius:var(--cosmos-media-preview-border-radius, 0)}.cosmos-media-preview--radius-small{border-radius:var(--cosmos-media-preview-border-radius, 2px)}.cosmos-media-preview--radius-medium{border-radius:var(--cosmos-media-preview-border-radius, 6px)}.cosmos-media-preview--radius-large{border-radius:var(--cosmos-media-preview-border-radius, 8px)}.cosmos-media-preview--radius-full{border-radius:var(--cosmos-media-preview-border-radius, 9999px)}.cosmos-media-preview__container{-ms-flex-positive:1;flex-grow:1;height:100%;overflow:hidden;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);-webkit-transition:-webkit-transform 0.6s cubic-bezier(0.35, 0, 0, 1);transition:-webkit-transform 0.6s cubic-bezier(0.35, 0, 0, 1);transition:transform 0.6s cubic-bezier(0.35, 0, 0, 1);transition:transform 0.6s cubic-bezier(0.35, 0, 0, 1), -webkit-transform 0.6s cubic-bezier(0.35, 0, 0, 1);width:100%}.cosmos-media-preview--active .cosmos-media-preview__container{-webkit-transform:scale(1.04) translate3d(0, 0, 0);transform:scale(1.04) translate3d(0, 0, 0)}.cosmos-media-preview__image{height:100%}.cosmos-media-preview__video{display:block;height:100%;left:0;-o-object-fit:cover;object-fit:cover;opacity:0;position:absolute;top:0;width:100%;z-index:4}.cosmos-media-preview__video--visible{opacity:1}.cosmos-media-preview__video.enter{opacity:0;-webkit-transition:0.2s ease-in;transition:0.2s ease-in}.cosmos-media-preview__video.enter-active{opacity:1}.cosmos-media-preview__video.leave{opacity:1;-webkit-transition:0.2s ease-in;transition:0.2s ease-in}.cosmos-media-preview__video.leave-active{opacity:0}", CosmosMediaPreview951Style0 = cosmosMediaPreviewCss, generateClassNames$5 = bem("cosmos-media-preview"), CosmosMediaPreview$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  handleVideoChange() {
    this.canPlayThroughVideo = !1;
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  handleActiveChange(te) {
    te ? this.startVideo() : this.stopVideo();
  }
  handlePlayVideoChange(te) {
    te ? this.startVideo() : this.stopVideo();
  }
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.resizeEvent = createEvent(this, "resize", 5), this.handleImageResize = ({ detail: { height: te, width: ee } }) => {
      this.resizeEvent.emit({
        height: te,
        width: ee
      });
    }, this.handleCanPlayThrough = () => {
      this.canPlayThroughVideo || (this.canPlayThroughVideo = !0, this.isVideoPlaying && this.showVideo());
    }, this.handleVideoCompletion = async () => {
      await this.hideVideo();
    }, this.active = void 0, this.appearance = void 0, this.image = void 0, this.imageAlt = void 0, this.imagePreview = void 0, this.loading = void 0, this.observeResize = void 0, this.playVideo = void 0, this.radius = "none", this.sizes = void 0, this.srcset = void 0, this.video = void 0, this.canPlayThroughVideo = !1, this.computedAppearance = "light", this.isVideoPlaying = !1, this.isVideoVisible = !1, this.cssTransition = new CSSTransition();
  }
  componentWillLoad() {
    resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "dark", light: "light" },
      callback: this.handleAppearanceChange.bind(this)
    }), (this.playVideo || this.active) && this.startVideo();
  }
  async startVideo() {
    this.canHandleVideo() && (this.isVideoPlaying = !0, await this.showVideo(), this.videoElement.play());
  }
  async stopVideo() {
    this.canHandleVideo() && (await this.hideVideo(), this.isVideoPlaying = !1, this.videoElement.pause(), this.videoElement.currentTime = 0);
  }
  async showVideo() {
    this.canPlayThroughVideo && (this.isVideoVisible = !0, await this.cssTransition.enter(this.videoElement, 200));
  }
  async hideVideo() {
    this.isVideoVisible = !1, await this.cssTransition.leave(this.videoElement, 200);
  }
  canHandleVideo() {
    return !!this.video && !hasReducedMotion();
  }
  render() {
    return h$1("div", { key: "65b21b867aee5ff7e6e7c3f6b38ea7e046608d91", class: generateClassNames$5({
      active: this.active,
      appearance: this.computedAppearance,
      radius: this.radius
    }), part: "base" }, h$1("div", { key: "9df46d987356032cc15bec0ffe65bdbcb3b4961c", class: generateClassNames$5("container") }, h$1("cosmos-image-9-5-1", { key: "130c40b94b5ce803907895251794b52e4ecd02ae", class: generateClassNames$5("image"), image: this.image, imagePreview: this.imagePreview, imageAlt: this.imageAlt, appearance: this.appearance, observeResize: this.observeResize, onResize: this.handleImageResize, loading: this.loading, sizes: this.sizes, srcset: this.srcset }), this.video && h$1("video", { key: "4844f953257e4d17bd3877e9161e42076e237096", class: generateClassNames$5("video", { visible: this.isVideoVisible && this.isVideoPlaying }), ref: (te) => this.videoElement = te, src: this.video, muted: !0, preload: "none", playsInline: !0, onCanPlayThrough: this.handleCanPlayThrough, "aria-hidden": "true", onEnded: this.handleVideoCompletion })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      video: ["handleVideoChange"],
      appearance: ["handleAppearanceChange"],
      active: ["handleActiveChange"],
      playVideo: ["handlePlayVideoChange"]
    };
  }
  static get style() {
    return CosmosMediaPreview951Style0;
  }
}, [1, "cosmos-media-preview-9-5-1", {
  active: [516],
  appearance: [513],
  image: [513],
  imageAlt: [513, "image-alt"],
  imagePreview: [513, "image-preview"],
  loading: [513],
  observeResize: [516, "observe-resize"],
  playVideo: [516, "play-video"],
  radius: [513],
  sizes: [513],
  srcset: [513],
  video: [513],
  canPlayThroughVideo: [32],
  computedAppearance: [32],
  isVideoPlaying: [32],
  isVideoVisible: [32]
}, void 0, {
  video: ["handleVideoChange"],
  appearance: ["handleAppearanceChange"],
  active: ["handleActiveChange"],
  playVideo: ["handlePlayVideoChange"]
}]);
function defineCustomElement$O() {
  if (typeof customElements > "u")
    return;
  ["cosmos-media-preview-9-5-1", "cosmos-image-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-media-preview-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosMediaPreview$1);
        break;
      case "cosmos-image-9-5-1":
        customElements.get(te) || defineCustomElement$V();
        break;
    }
  });
}
const cosmosModeCss = ".cosmos-mode{display:contents}", CosmosMode951Style0 = cosmosModeCss, CosmosMode$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.mode = "light";
  }
  render() {
    return h$1("div", { key: "2ff99bc827978eb74c47969af61460f767385e56", class: "cosmos-mode" }, h$1("slot", { key: "af5e90e1076920b57f373e7568ad310716a8d326" }));
  }
  get element() {
    return this;
  }
  static get style() {
    return CosmosMode951Style0;
  }
}, [4, "cosmos-mode-9-5-1", {
  mode: [513]
}]);
function defineCustomElement$N() {
  if (typeof customElements > "u")
    return;
  ["cosmos-mode-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-mode-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosMode$1);
        break;
    }
  });
}
const cosmosTitleCss = '@charset "UTF-8";:host{display:block}:host([clamp]){min-width:0}:host{--cosmos-font-family-title:Bull, Helvetica, sans-serif}@supports (font-variation-settings: normal){:host{--cosmos-font-family-title:Bull VF, Helvetica, sans-serif}}:host(:lang(ja)){--cosmos-font-family-title:Noto Sans JP, Helvetica, sans-serif}:host(:lang(ar)){--cosmos-font-family-title:Noto Kufi Arabic, Helvetica, sans-serif}:host(:lang(ko)){--cosmos-font-family-title:Noto Sans KR, Helvetica, sans-serif}:host(:lang(he)){--cosmos-font-family-title:Noto Sans Hebrew, Helvetica, sans-serif}:host(:lang(ka)){--cosmos-font-family-title:Noto Sans Georgian, Helvetica, sans-serif}:host(:lang(hi)){--cosmos-font-family-title:Noto Sans, Helvetica, sans-serif}:host(:lang(th)){--cosmos-font-family-title:Noto Sans Thai, Helvetica, sans-serif}:host(:lang(zh)){--cosmos-font-family-title:Microsoft YaHei, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}:host(:lang(zh-Hant)){--cosmos-font-family-title:Microsoft JhengHei, Geneva CY, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}.cosmos-title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:var(--cosmos-title-color, #000F1E);font-family:var(--cosmos-title-font-family, var(--cosmos-font-family-title));font-style:var(--cosmos-title-font-style, inherit);font-variation-settings:"opsz" 86, "wght" 700;font-weight:var(--cosmos-title-font-weight, 700);letter-spacing:var(--cosmos-title-letter-spacing, inherit);line-height:var(--cosmos-title-line-height, inherit);margin:0;text-transform:var(--cosmos-title-text-transform, var(--cosmos-title-transform, inherit))}.cosmos-title--single-line-clamp{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cosmos-title--multi-line-clamp{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:var(--cosmos-title-clamp-length);overflow:hidden;}.cosmos-title--size-xx-small{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}@media (min-width: 380px){.cosmos-title--size-xx-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-xx-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-x-small{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}@media (min-width: 380px){.cosmos-title--size-x-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-x-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-small{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}@media (min-width: 380px){.cosmos-title--size-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-medium{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}@media (min-width: 380px){.cosmos-title--size-medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}@media (min-width: 380px){.cosmos-title--size-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-x-large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}@media (min-width: 380px){.cosmos-title--size-x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--size-xx-large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}@media (min-width: 380px){.cosmos-title--size-xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media (min-width: 1200px){.cosmos-title--size-xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-xx-small\\@small{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-xx-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-xx-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-x-small\\@small{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-x-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-x-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-small\\@small{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-small\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-medium\\@small{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-medium\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-medium\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-large\\@small{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-x-large\\@small{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-x-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-x-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 0){.cosmos-title--size-xx-large\\@small{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 0) and (min-width: 380px){.cosmos-title--size-xx-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 0) and (min-width: 1200px){.cosmos-title--size-xx-large\\@small{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-xx-small\\@medium{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-xx-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-x-small\\@medium{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-x-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-x-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-small\\@medium{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-small\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-medium\\@medium{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-medium\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-medium\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-large\\@medium{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-x-large\\@medium{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-x-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-x-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 650px){.cosmos-title--size-xx-large\\@medium{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 650px) and (min-width: 380px){.cosmos-title--size-xx-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 650px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@medium{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-xx-small\\@large{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-xx-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-x-small\\@large{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-x-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-x-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-small\\@large{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-small\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-medium\\@large{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-medium\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-medium\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-large\\@large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-x-large\\@large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-x-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-x-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1000px){.cosmos-title--size-xx-large\\@large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 1000px) and (min-width: 380px){.cosmos-title--size-xx-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1000px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-xx-small\\@x-large{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-xx-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-x-small\\@x-large{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-x-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-x-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-small\\@x-large{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-small\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-medium\\@x-large{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-medium\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-medium\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-large\\@x-large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-x-large\\@x-large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-x-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-x-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1200px){.cosmos-title--size-xx-large\\@x-large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 1200px) and (min-width: 380px){.cosmos-title--size-xx-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1200px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@x-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-xx-small\\@xx-large{font-size:var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.411765));margin-bottom:0.470588em;padding-top:0.705882em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-xx-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 17rem / var(--cosmos-base-font-size, 16) + 0 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-xx-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(17rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-x-small\\@xx-large{font-size:var(--cosmos-title-font-size, calc(18rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.5));margin-bottom:0.4em;padding-top:0.6em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-x-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 18rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-x-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(20rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-small\\@xx-large{font-size:var(--cosmos-title-font-size, calc(22rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.333333));margin-bottom:0.5em;padding-top:1.083333em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 22rem / var(--cosmos-base-font-size, 16) + 2 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-small\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(24rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-medium\\@xx-large{font-size:var(--cosmos-title-font-size, calc(26rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.137931));margin-bottom:0.413793em;padding-top:1.103448em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-medium\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 26rem / var(--cosmos-base-font-size, 16) + 3 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-medium\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(29rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-large\\@xx-large{font-size:var(--cosmos-title-font-size, calc(31rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.097561));margin-bottom:0.439024em;padding-top:0.829268em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 31rem / var(--cosmos-base-font-size, 16) + 10 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(41rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-x-large\\@xx-large{font-size:var(--cosmos-title-font-size, calc(37rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1.066667));margin-bottom:0.333333em;padding-top:0.666667em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-x-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 37rem / var(--cosmos-base-font-size, 16) + 23 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-x-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(60rem / var(--cosmos-base-font-size, 16))))}}@media screen and (min-width: 1350px){.cosmos-title--size-xx-large\\@xx-large{font-size:var(--cosmos-title-font-size, calc(45rem / var(--cosmos-base-font-size, 16)));line-height:calc(var(--cosmos-title-line-height-multiplier, 1) * var(--cosmos-title-line-height, 1));margin-bottom:0.255814em;padding-top:0.55814em}}@media screen and (min-width: 1350px) and (min-width: 380px){.cosmos-title--size-xx-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc( 45rem / var(--cosmos-base-font-size, 16) + 41 * ((100vw - 380px) / 820) )))}}@media screen and (min-width: 1350px) and (min-width: 1200px){.cosmos-title--size-xx-large\\@xx-large{font-size:calc(var(--cosmos-title-font-size-multiplier, 1) * var(--cosmos-title-font-size, calc(86rem / var(--cosmos-base-font-size, 16))))}}.cosmos-title--spacing-none{margin-bottom:0;padding-top:0}.cosmos-title--spacing-long-form-bottom{padding-top:0}.cosmos-title--spacing-long-form-top{margin-bottom:0}.cosmos-title--appearance-light{color:var(--cosmos-title-color, #FFFFFF)}.cosmos-title--weight-heavy{font-variation-settings:"opsz" 86, "wght" 800;font-weight:var(--cosmos-title-font-weight, 800)}.cosmos-title--kind-subtle{color:var(--cosmos-title-color, rgba(0, 15, 30, 0.6))}.cosmos-title--kind-subtle.cosmos-title--appearance-light{color:var(--cosmos-title-color, rgba(255, 255, 255, 0.6))}', CosmosTitle951Style0 = cosmosTitleCss, generateClassNames$4 = bem("cosmos-title"), CosmosTitle$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.appearance = void 0, this.clamp = void 0, this.kind = "normal", this.size = "medium", this.spacing = "none", this.tag = "p", this.weight = "bold", this.computedAppearance = "dark";
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  setNumericClampValue() {
    this.numericClampValue = getNumericClampValue(this.clamp);
  }
  componentWillLoad() {
    resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.setNumericClampValue();
  }
  getSize() {
    return this.size && isResponsiveProperty(this.size) ? parseResponsiveProperty(this.size) : this.size;
  }
  render() {
    var te;
    const ee = (te = this.tag) !== null && te !== void 0 ? te : "p";
    return h$1(Host, { key: "69768cc2df4591bfa54fecb451c78ad8638d863e", style: isMultiLineClamp(this.numericClampValue) ? { "--cosmos-title-clamp-length": `${this.numericClampValue}` } : {} }, h$1(ee, { key: "77f30fd8328e3a5f282ba064dcbdfa148a2261e2", class: generateClassNames$4({
      appearance: this.computedAppearance,
      size: this.getSize(),
      spacing: this.spacing,
      weight: this.weight,
      "single-line-clamp": isSingleLineClamp(this.numericClampValue),
      "multi-line-clamp": isMultiLineClamp(this.numericClampValue),
      kind: this.kind
    }), part: "base" }, h$1("slot", { key: "a96334773ac27d48055ee63e08f81fb6e36610bc" })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      clamp: ["setNumericClampValue"]
    };
  }
  static get style() {
    return CosmosTitle951Style0;
  }
}, [1, "cosmos-title-9-5-1", {
  appearance: [513],
  clamp: [520],
  kind: [513],
  size: [513],
  spacing: [513],
  tag: [513],
  weight: [513],
  computedAppearance: [32]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  clamp: ["setNumericClampValue"]
}]);
function defineCustomElement$M() {
  if (typeof customElements > "u")
    return;
  ["cosmos-title-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-title-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosTitle$1);
        break;
    }
  });
}
const cosmosIconCss$z = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconAirplay951Style0 = cosmosIconCss$z, CosmosIconAirplay$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "9d1ff6f2f25491f1ecbf007899576c0fc3bcd3eb", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "0b8c0d200dc9452cc1df25dcb3cae2fb00413777", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "2c8301f11ed49b432a736df9f3f364ec543d1403", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4h17a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2.37a.48.48 0 0 1-.41-.22l-.35-.52a.48.48 0 0 1-.09-.26.5.5 0 0 1 .5-.5h1.72v-9h-15v9h1.64a.5.5 0 0 1 .5.5.51.51 0 0 1-.09.27l-.42.54a.51.51 0 0 1-.39.19H2.5a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5Zm13.488 14.733a.5.5 0 0 1-.438.267h-9.1a.5.5 0 0 1-.45-.78l4.59-6.62a.5.5 0 0 1 .82 0l4.55 6.62a.5.5 0 0 1 .028.513Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconAirplay951Style0;
  }
}, [1, "cosmos-icon-airplay-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$B() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-airplay-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-airplay-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconAirplay$1);
        break;
    }
  });
}
const defineCustomElement$L = defineCustomElement$1$B, cosmosIconCss$y = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconAudioSettings951Style0 = cosmosIconCss$y, CosmosIconAudioSettings$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "37821d7fe0553ddb1def7f4054acf41cb9be64b4", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "c5796ecc5c9b55f023350e61f74170ca5ca4ddbc", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "23eaeabbdfca0539a38f3134f9e9f26cc1f5ab5b", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 18.65a7.65 7.65 0 1 0 0-15.3 7.65 7.65 0 0 0 0 15.3ZM11 20a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z", fill: "currentColor" }), h$1("path", { key: "9a37d40714947be88451dfdb457187cba962fb5b", d: "M5.5 9.5A.5.5 0 0 1 6 9h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-3Zm2.5-3a.5.5 0 0 1 .5-.5H9a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-9Zm2.5 2A.5.5 0 0 1 11 8h.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H11a.5.5 0 0 1-.5-.5v-5Zm2.5-1a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-7Zm2.5 2A.5.5 0 0 1 16 9h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H16a.5.5 0 0 1-.5-.5v-3Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconAudioSettings951Style0;
  }
}, [1, "cosmos-icon-audio-settings-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$A() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-audio-settings-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-audio-settings-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconAudioSettings$1);
        break;
    }
  });
}
const defineCustomElement$K = defineCustomElement$1$A, cosmosIconCss$x = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconBack10951Style0 = cosmosIconCss$x, CosmosIconBack10$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "ab60af8995a991deecfc043c5d38c7a95eae9c46", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "e78b7865abb401fc3ea3278224b74fecf56629b3", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "638b840251c3b1e59af7ae415116afe58065d335", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 6.472h4.628a5.11 5.11 0 0 1 5.162 4.824 4.852 4.852 0 0 1-1.362 3.562 5 5 0 0 1-2.841 1.493.509.509 0 0 1-.587-.5v-.532a.51.51 0 0 1 .425-.493c.73-.137 1.4-.49 1.926-1.015a3.323 3.323 0 0 0 .939-2.473 3.6 3.6 0 0 0-3.662-3.362H9v2.3a.5.5 0 0 1-.854.352L5.114 7.576a.5.5 0 0 1 0-.706l3.033-3.024A.5.5 0 0 1 9 4.2v2.272Zm.19 6.846c.312-.3.738-.453 1.169-.418a1.5 1.5 0 0 1 1.62 1.567V15.7a1.5 1.5 0 0 1-1.62 1.571A1.507 1.507 0 0 1 8.732 15.7v-1.229c-.02-.432.147-.852.459-1.153Zm1.594 2.361c0 .349-.143.531-.425.531-.282 0-.431-.187-.431-.531v-1.187c0-.344.143-.532.431-.532.288 0 .425.182.425.532v1.187ZM8.309 16.95v-.621a.231.231 0 0 0-.24-.239h-.46v-2.87a.23.23 0 0 0-.24-.24h-.61a.85.85 0 0 0-.23.03l-1.05.33a.234.234 0 0 0-.16.29l.14.53a.235.235 0 0 0 .32.17l.64-.2v1.96h-.66a.23.23 0 0 0-.24.24v.62a.231.231 0 0 0 .24.24h2.31a.231.231 0 0 0 .24-.24Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconBack10951Style0;
  }
}, [1, "cosmos-icon-back-10-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$z() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-back-10-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-back-10-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconBack10$1);
        break;
    }
  });
}
const defineCustomElement$J = defineCustomElement$1$z, cosmosIconCss$w = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconBrowse951Style0 = cosmosIconCss$w, CosmosIconBrowse$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "073866ae382a5189561dfba16a77d1603f168712", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "4559af9e7f323dd81dd13e458565d7361d1482eb", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "5c2af0cf278a0eb3c61fc139909fdd0fa9ef798e", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5h-14a.5.5 0 0 1-.5-.5v-14Zm1.5 13h12v-12h-12v12Zm15-12h1a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-1v-12ZM8.412 14.405a.594.594 0 0 1-.912-.502V9.097c0-.469.516-.753.912-.502l3.796 2.403a.594.594 0 0 1 0 1.004l-3.796 2.403Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconBrowse951Style0;
  }
}, [1, "cosmos-icon-browse-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$y() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-browse-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-browse-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconBrowse$1);
        break;
    }
  });
}
const defineCustomElement$I = defineCustomElement$1$y, cosmosIconCss$v = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconChevronLeft951Style0 = cosmosIconCss$v, CosmosIconChevronLeft$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "e8af4bd4926dc3f01d4da240e0fd20e9a732c3e9", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "09f02777beb1a4e026097948143d725316fb25ee", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "e0a6ca044f155b405ed2b1247b08e4559fa57f23", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m6.56 11.09 5.83 5.82a.5.5 0 0 0 .71 0l.35-.35a.51.51 0 0 0 0-.71l-5.12-5.12 5.12-5.11a.51.51 0 0 0 0-.71l-.35-.35a.5.5 0 0 0-.71 0l-5.83 5.82a.51.51 0 0 0 0 .71Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconChevronLeft951Style0;
  }
}, [1, "cosmos-icon-chevron-left-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$x() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-chevron-left-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-chevron-left-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconChevronLeft$1);
        break;
    }
  });
}
const defineCustomElement$H = defineCustomElement$1$x, cosmosIconCss$u = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconChevronRight951Style0 = cosmosIconCss$u, CosmosIconChevronRight$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "4099ea1b85cb199bebfa96717bcf0ebdd84bc2f6", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "0f84d3ce4fb91c95b6f97330aa15a6b6bea96662", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "e4c34cae3669bbf0ffa437428823e57e87be7320", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.45 10.38 9.62 4.56a.48.48 0 0 0-.7 0l-.36.35a.51.51 0 0 0 0 .71l5.12 5.12-5.12 5.11a.51.51 0 0 0 0 .71l.36.35a.48.48 0 0 0 .7 0l5.83-5.82a.51.51 0 0 0 0-.71Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconChevronRight951Style0;
  }
}, [1, "cosmos-icon-chevron-right-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$w() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-chevron-right-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-chevron-right-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconChevronRight$1);
        break;
    }
  });
}
const defineCustomElement$G = defineCustomElement$1$w, cosmosIconCss$t = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconClock951Style0 = cosmosIconCss$t, CosmosIconClock$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "587ff5a7a2ee2ea5aa5b007d416aa48f4fc3cb66", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "77e9445e2b1304baf3a7acd83832f3d3dfd43e68", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "67bb07b41b1f536cf1307bc5492d9928b23cd0f3", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm-.63 7.93 3 3a.48.48 0 0 0 .67 0l.36-.35a.51.51 0 0 0 0-.71l-2.68-2.68V6.5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v4.57a.49.49 0 0 0 .15.36Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconClock951Style0;
  }
}, [1, "cosmos-icon-clock-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$v() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-clock-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-clock-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconClock$1);
        break;
    }
  });
}
const defineCustomElement$F = defineCustomElement$1$v, cosmosIconCss$s = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconClose951Style0 = cosmosIconCss$s, CosmosIconClose$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "ddde26c99451d2bd0825ca4229c030908111f1a8", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "63f85195d445f67878634931c5064bac3fc8b036", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "85e506c697d40ac8b2db732cbe5b390d059be1e3", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m18.18 4.18-.35-.36a.51.51 0 0 0-.71 0L11 9.94 4.89 3.82a.51.51 0 0 0-.71 0l-.35.36a.48.48 0 0 0 0 .7L10 11l-6.17 6.12a.48.48 0 0 0 0 .7l.35.36a.51.51 0 0 0 .71 0L11 12.06l6.11 6.12a.51.51 0 0 0 .71 0l.35-.36a.48.48 0 0 0 0-.7L12.07 11l6.11-6.12a.48.48 0 0 0 0-.7Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconClose951Style0;
  }
}, [1, "cosmos-icon-close-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$E() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-close-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-close-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconClose$1);
        break;
    }
  });
}
const defineCustomElement$D = defineCustomElement$E, cosmosIconCss$r = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconCodeBlock951Style0 = cosmosIconCss$r, CosmosIconCodeBlock$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "76c70bc51b628900eb85a5db7fad1e51c686b0c4", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "0f7cb58cde1a5ce8406821ccdc869b983a76e107", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "3af8424a3a778445f3648ea0fedcccc854b766f8", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.32 5a.5.5 0 0 0-.48.36l-3.08 11a.5.5 0 0 0 .47.67h.46a.52.52 0 0 0 .49-.36l3.07-11a.5.5 0 0 0-.47-.67h-.46Zm6.41 5.65-3.39-3.39a.4.4 0 0 0-.28-.12.37.37 0 0 0-.27.11l-.44.44a.36.36 0 0 0-.11.26.44.44 0 0 0 .11.28L17.12 11l-2.77 2.77a.44.44 0 0 0-.11.28c0 .098.04.192.11.26l.44.44a.37.37 0 0 0 .27.11.4.4 0 0 0 .28-.12l3.39-3.39a.5.5 0 0 0 0-.7Zm-12.2 4.09-3.39-3.39a.48.48 0 0 1 0-.7l3.39-3.34a.4.4 0 0 1 .28-.12.37.37 0 0 1 .27.11l.44.44a.41.41 0 0 1 .11.26.4.4 0 0 1-.12.23L4.75 11l2.76 2.77a.4.4 0 0 1 .12.28.41.41 0 0 1-.11.26l-.44.44a.37.37 0 0 1-.27.11.4.4 0 0 1-.28-.12Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconCodeBlock951Style0;
  }
}, [1, "cosmos-icon-code-block-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$u() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-code-block-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-code-block-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconCodeBlock$1);
        break;
    }
  });
}
const defineCustomElement$C = defineCustomElement$1$u, cosmosIconCss$q = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconErrorFilled951Style0 = cosmosIconCss$q, CosmosIconErrorFilled$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "6bf10c343a8bd65c24007668c07165a9026acd84", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "0b4dab2e6b7b0e49e1df65035a5b59251cfb73ed", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "e0e1ffa6f9cf740e36c3e9699b53cd843a179d30", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.99 2a9 9 0 1 0 .02 18 9 9 0 0 0-.02-18Zm-.74 4.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-5ZM11 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconErrorFilled951Style0;
  }
}, [1, "cosmos-icon-error-filled-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$t() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-error-filled-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-error-filled-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconErrorFilled$1);
        break;
    }
  });
}
const defineCustomElement$B = defineCustomElement$1$t, cosmosIconCss$p = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconEventDetails951Style0 = cosmosIconCss$p, CosmosIconEventDetails$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "ee480247ba65adbcd53c360a418e7cc7a8bf5dce", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "d82f8b961a43baa8e24f5aeb0bcd965f3de0fb23", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "7765a77fab872f8823a86975abd2e51c33932df0", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 3h-4V2a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v1H9V2a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v1h-4a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5h-2v-13h3v1A.5.5 0 0 0 8 6h.5a.5.5 0 0 0 .5-.5v-1h4v1a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-1h3v5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5Zm-9.435 8.044a6.99 6.99 0 0 1 2.5-1.603.5.5 0 0 0 .302-.665l-.667-1.56c-.148-.341-.377-.341-.511 0l-.834 2.238-2.42.218c-.376 0-.443.26-.147.491l1.102.922a.498.498 0 0 0 .675-.041ZM9 15.998a5 5 0 1 1 10 .004 5 5 0 0 1-10-.003Zm5.489 3.502A.51.51 0 0 0 15 19v-3a.5.5 0 0 0-.5-.5h-2a.51.51 0 0 0-.511.5v.5a.51.51 0 0 0 .511.5h.989v2a.5.5 0 0 0 .5.5h.5Zm-.25-5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconEventDetails951Style0;
  }
}, [1, "cosmos-icon-event-details-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$s() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-event-details-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-event-details-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconEventDetails$1);
        break;
    }
  });
}
const defineCustomElement$A = defineCustomElement$1$s, cosmosIconCss$o = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconFacebook951Style0 = cosmosIconCss$o, CosmosIconFacebook$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "b6aef724f7a9936f061dca9b18d0d21e6109ec88", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "872fb68658c3408fc6ef421fbfeb0b6bdd904379", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "1469f542d19d4f87368d94a91e981d1d72c93fcf", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20 11a9 9 0 1 0-10.406 8.89v-6.288H7.309V11h2.285V9.017c0-2.255 1.343-3.501 3.4-3.501.984 0 2.014.175 2.014.175v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406V11h2.496l-.399 2.602h-2.097v6.289A9.002 9.002 0 0 0 20 11Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconFacebook951Style0;
  }
}, [1, "cosmos-icon-facebook-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$r() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-facebook-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-facebook-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconFacebook$1);
        break;
    }
  });
}
const defineCustomElement$z = defineCustomElement$1$r, cosmosIconCss$n = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconForward10951Style0 = cosmosIconCss$n, CosmosIconForward10$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "b30f8798b0717efb2d065e5068bc7bd9341890f6", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "52e6318e48135e0382f009893f8338a610b8676a", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "07b8ed534409a1ec6841b6786ef59142673bbf7e", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14 6.472H9.372a5.11 5.11 0 0 0-5.162 4.817 4.852 4.852 0 0 0 1.362 3.565 5 5 0 0 0 2.841 1.493.51.51 0 0 0 .587-.5v-.532a.51.51 0 0 0-.425-.493c-.73-.137-1.4-.49-1.926-1.015a3.323 3.323 0 0 1-.939-2.473 3.6 3.6 0 0 1 3.662-3.358H14v2.3a.5.5 0 0 0 .854.352l3.032-3.052a.5.5 0 0 0 0-.706l-3.033-3.024A.5.5 0 0 0 14 4.2v2.272Zm.149 10.478v-.621a.23.23 0 0 0-.239-.239h-.46v-2.87a.23.23 0 0 0-.24-.24h-.61a.851.851 0 0 0-.23.03l-1.05.33a.234.234 0 0 0-.16.29l.14.53a.235.235 0 0 0 .32.17l.64-.2v1.96h-.66a.23.23 0 0 0-.24.24v.62a.231.231 0 0 0 .24.24h2.309a.231.231 0 0 0 .24-.24Zm.451-1.25v-1.233a1.506 1.506 0 0 1 1.63-1.567 1.505 1.505 0 0 1 1.621 1.571V15.7a1.5 1.5 0 0 1-1.621 1.57 1.506 1.506 0 0 1-1.63-1.57Zm2.051-1.208v1.184l.004-.001c0 .349-.141.531-.429.531-.288 0-.431-.187-.431-.531v-1.183c0-.344.149-.532.431-.532.282 0 .425.182.425.532Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconForward10951Style0;
  }
}, [1, "cosmos-icon-forward-10-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$q() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-forward-10-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-forward-10-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconForward10$1);
        break;
    }
  });
}
const defineCustomElement$y = defineCustomElement$1$q, cosmosIconCss$m = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconFullscreen951Style0 = cosmosIconCss$m, CosmosIconFullscreen$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "b02e1f5d834cdf76800af659f0a2c90de4f3fda1", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "52400d268699abbe0ebb01cef2a7ac92b83a90db", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "5da738a4b0abc27eef12c89d9391e3281285aa5d", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 5.5v3A.5.5 0 0 1 3 9h-.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5h-5Zm15 0h-5A.5.5 0 0 1 13 5v-.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H19a.5.5 0 0 1-.5-.5v-3Zm0 8v3h-5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H19a.5.5 0 0 0-.5.5Zm-15 3h5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5H3a.5.5 0 0 1 .5.5v3Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconFullscreen951Style0;
  }
}, [1, "cosmos-icon-fullscreen-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$p() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-fullscreen-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-fullscreen-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconFullscreen$1);
        break;
    }
  });
}
const defineCustomElement$x = defineCustomElement$1$p, cosmosIconCss$l = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconFullscreenExit951Style0 = cosmosIconCss$l, CosmosIconFullscreenExit$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "636098c209b0774d2515c7b320b81d0bcbff07ca", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "d43b3f5b96f962f7272159524d9ef7ece82deed7", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "b657a20fd56ab211cd85538ed5cfd3e42e8d53c1", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.5 4.5v3h-5A.5.5 0 0 0 2 8v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5Zm0 10h-5A.5.5 0 0 1 2 14v-.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-3Zm7 0v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-5Zm0-7h5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v3Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconFullscreenExit951Style0;
  }
}, [1, "cosmos-icon-fullscreen-exit-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$o() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-fullscreen-exit-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-fullscreen-exit-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconFullscreenExit$1);
        break;
    }
  });
}
const defineCustomElement$w = defineCustomElement$1$o, cosmosIconCss$k = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconLink951Style0 = cosmosIconCss$k, CosmosIconLink$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "754d775eaa0058473889ac46a04db07124b2fe14", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "74dd49b275fd81c1498e5411c4083bfa8cd82cee", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "55ad899a4cdcd34e5841b1a3a5a7005de37dc82c", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.496 3.434A4 4 0 0 1 17.29 4.78a4 4 0 0 1 .28 5.74l-2.62 2.63a3.43 3.43 0 0 1-2.44 1 4.42 4.42 0 0 1-2.77-1.06.5.5 0 0 1 0-.73l.37-.36a.48.48 0 0 1 .66 0 2.32 2.32 0 0 0 3.13.06l2.63-2.62a2.53 2.53 0 0 0-.3-3.59 2.53 2.53 0 0 0-3.59-.3l-.66.67a.52.52 0 0 1-.72 0l-.35-.36a.5.5 0 0 1 0-.71l.67-.66a4 4 0 0 1 2.916-1.056ZM7.72 17.11a2.13 2.13 0 0 0 1.65-.61l.65-.64a.49.49 0 0 1 .7 0l.36.35a.5.5 0 0 1 0 .71l-.64.64a3.68 3.68 0 0 1-2.62 1.05h-.16a4.45 4.45 0 0 1-2.94-1.34 4 4 0 0 1-.3-5.72l2.65-2.58a3.79 3.79 0 0 1 5.2.06.5.5 0 0 1 0 .73l-.36.36a.5.5 0 0 1-.67 0A2.34 2.34 0 0 0 8.11 10l-2.63 2.61a2.54 2.54 0 0 0 .3 3.6 3 3 0 0 0 1.94.9Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconLink951Style0;
  }
}, [1, "cosmos-icon-link-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$n() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-link-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-link-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconLink$1);
        break;
    }
  });
}
const defineCustomElement$v = defineCustomElement$1$n, cosmosIconCss$j = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconLive951Style0 = cosmosIconCss$j, CosmosIconLive$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "3bae30dd3cf0799e56e3cf80b040c6e9dd3c14a5", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "1ceaac21cce76e4f207e2c94995739cdf00e8813", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "f26508f9d6188b75d764bf1e26ac1f3098daace6", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15ZM7.5 11a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconLive951Style0;
  }
}, [1, "cosmos-icon-live-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$m() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-live-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-live-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconLive$1);
        break;
    }
  });
}
const defineCustomElement$u = defineCustomElement$1$m, cosmosIconCss$i = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconLiveBroadcast951Style0 = cosmosIconCss$i, CosmosIconLiveBroadcast$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "0248b620e0dd17d0593f9f21100b429cb0c27121", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "0f65c9d5aec2045725d5218a23e034e1ce24e411", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "f65fa38fcbc2b1525a145187818e31b10036b672", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.085 4.272a.5.5 0 0 0-.355.148l-.01-.04a9.14 9.14 0 0 0 .09 13.1.5.5 0 0 0 .71 0l.34-.35a.5.5 0 0 0 0-.71 7.66 7.66 0 0 1-.08-10.94.49.49 0 0 0 0-.7l-.34-.36a.5.5 0 0 0-.355-.148Zm11.84 0a.5.5 0 0 1 .355.148v-.04a9.14 9.14 0 0 1-.09 13.1.5.5 0 0 1-.71 0l-.34-.35a.5.5 0 0 1 0-.71 7.66 7.66 0 0 0 .08-10.94.49.49 0 0 1 0-.7l.35-.36a.5.5 0 0 1 .355-.148ZM14.42 7.69l-.34.37a.49.49 0 0 0 0 .67 3.14 3.14 0 0 1 .93 2.2 3.45 3.45 0 0 1-1 2.28.51.51 0 0 0 0 .68l.35.36a.5.5 0 0 0 .69 0 4.59 4.59 0 0 0 .09-6.61.5.5 0 0 0-.72.05ZM9.5 11a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.25 3a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-.5ZM7.58 7.69l.35.37a.49.49 0 0 1 0 .67 3.17 3.17 0 0 0-.93 2.2 3.45 3.45 0 0 0 1 2.28.51.51 0 0 1 0 .68l-.35.36a.5.5 0 0 1-.69 0 4.6 4.6 0 0 1-.1-6.61.5.5 0 0 1 .72.05Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconLiveBroadcast951Style0;
  }
}, [1, "cosmos-icon-live-broadcast-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$l() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-live-broadcast-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-live-broadcast-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconLiveBroadcast$1);
        break;
    }
  });
}
const defineCustomElement$t = defineCustomElement$1$l, cosmosIconCss$h = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconMute951Style0 = cosmosIconCss$h, CosmosIconMute$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "7703fc8521f7e97bfcc85c67a2fe5adb66bb87be", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "127714c3a55fad417ca45c0590890b3f4fb469fb", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "3996f8aa233a1f45ef8bdb3bdff47ef091aa545a", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m13 9.94 6.65 6.65a.51.51 0 0 1 0 .71l-.35.35a.51.51 0 0 1-.71 0L4.32 3.38a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0l5 5 1.79-1.61a.5.5 0 0 1 .83.37v3.86ZM6.82 8.7l6 6a.46.46 0 0 1 .16.38v.78a.5.5 0 0 1-.83.37l-2.56-2.26H6.48a.5.5 0 0 1-.5-.5V9.05a.5.5 0 0 1 .5-.5.49.49 0 0 1 .34.15Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconMute951Style0;
  }
}, [1, "cosmos-icon-mute-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$k() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-mute-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-mute-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconMute$1);
        break;
    }
  });
}
const defineCustomElement$s = defineCustomElement$1$k, cosmosIconCss$g = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconNoData951Style0 = cosmosIconCss$g, CosmosIconNoData$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "9be8e312eabe13d5a0414f0a4fb92aad5fa3b8d1", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "ec47082927fe95ae5265052c90fdd70c1e98b7c0", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "c06e8aa6247d4ea5ea367f4413337253baf83c88", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.253 5.193A7.469 7.469 0 0 1 11 3.5a7.51 7.51 0 0 1 7.5 7.5 7.47 7.47 0 0 1-1.693 4.747L6.253 5.193Zm-1.06 1.06a7.5 7.5 0 0 0 10.554 10.554L5.192 6.253ZM2 11a9 9 0 0 1 9-9 9.01 9.01 0 0 1 9 9 9 9 0 1 1-18 0Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconNoData951Style0;
  }
}, [1, "cosmos-icon-no-data-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$j() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-no-data-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-no-data-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconNoData$1);
        break;
    }
  });
}
const defineCustomElement$r = defineCustomElement$1$j, cosmosIconCss$f = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconPause951Style0 = cosmosIconCss$f, CosmosIconPause$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "64254dc5a42b603017460e59118774b5ba274601", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "0483fae82659282f911df950a43bf46be5a2b8d2", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "a1ef02e675e5d08af0635dc2f0b7e1e976add903", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm8 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconPause951Style0;
  }
}, [1, "cosmos-icon-pause-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$i() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-pause-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-pause-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconPause$1);
        break;
    }
  });
}
const defineCustomElement$q = defineCustomElement$1$i, cosmosIconCss$e = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconPictureInPicture951Style0 = cosmosIconCss$e, CosmosIconPictureInPicture$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "95c6b3f97fbddd45a6ce3f689a70153e1cd74984", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "37af340406b7dc572be4918fa6c4373970aced67", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "8c789b78e14c63d12ad71d3709c5bc94708fe063", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-13Zm1.5 1h15v11h-15v-11ZM17 11h-6v4h6v-4Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconPictureInPicture951Style0;
  }
}, [1, "cosmos-icon-picture-in-picture-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$h() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-picture-in-picture-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-picture-in-picture-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconPictureInPicture$1);
        break;
    }
  });
}
const defineCustomElement$p = defineCustomElement$1$h, cosmosIconCss$d = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconPinterest951Style0 = cosmosIconCss$d, CosmosIconPinterest$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "7b858b52f51b288430883437d71d625b8dde4ca0", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "c209e51560eedea30cfa433e66dc30e46a9fec79", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "82277a2efb64aea0aed3faa3a79f3a5a03945a4c", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.002 2A9 9 0 0 0 7.72 19.38a8.71 8.71 0 0 1 0-2.588c.168-.698 1.057-4.5 1.057-4.5A3.252 3.252 0 0 1 8.54 11c0-1.249.73-2.182 1.63-2.182a1.124 1.124 0 0 1 1.124 1.26 18.667 18.667 0 0 1-.742 3.003 1.305 1.305 0 0 0 1.327 1.62c1.597 0 2.834-1.688 2.834-4.117a3.544 3.544 0 0 0-3.71-3.667 3.89 3.89 0 0 0-4.071 3.903 3.47 3.47 0 0 0 .697 2.047c.06.072.082.169.056.259-.067.292-.214.9-.247 1.024-.034.123-.124.202-.293.123a4.05 4.05 0 0 1-1.833-3.487c-.056-2.846 2.002-5.41 5.892-5.41a5.273 5.273 0 0 1 5.544 5.196c0 3.094-1.957 5.625-4.666 5.625a2.42 2.42 0 0 1-2.07-1.035s-.45 1.72-.55 2.148a10.339 10.339 0 0 1-1.125 2.351 9.106 9.106 0 0 0 2.665.338c4.968 0 8.996-4.03 8.996-9S15.97 2 11.002 2Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconPinterest951Style0;
  }
}, [1, "cosmos-icon-pinterest-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$g() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-pinterest-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-pinterest-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconPinterest$1);
        break;
    }
  });
}
const defineCustomElement$o = defineCustomElement$1$g, cosmosIconCss$c = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconPlay951Style0 = cosmosIconCss$c, CosmosIconPlay$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "b3b5d93db0909059c7da9b98f05f837f760d1ddd", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "ae29ba8f0d90c790a2776c5406e21493b5489eaf", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "f7f11ae7f621a38739b87ea575ebf4c416dc8edd", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7.22 17.44 10.38-5.905a.608.608 0 0 0 .283-.531.607.607 0 0 0-.282-.531L7.22 4.568a.426.426 0 0 0-.495.023.615.615 0 0 0-.225.52v11.81a.618.618 0 0 0 .239.492.434.434 0 0 0 .48.027Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconPlay951Style0;
  }
}, [1, "cosmos-icon-play-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$n() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-play-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-play-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconPlay$1);
        break;
    }
  });
}
const defineCustomElement$m = defineCustomElement$n, cosmosIconCss$b = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconPreview951Style0 = cosmosIconCss$b, CosmosIconPreview$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "3b825762ed2a85c93c9eb5095d12ed5b97895878", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "62b9f7e2ddbb9f26e8829119837b08548745c97e", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "d429a29aa253fff4bd986acd300a1e105c402dcf", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.991 5c3.554 0 6.471 1.846 8.806 5.285a1.36 1.36 0 0 1 0 1.43l-.013.02C17.54 15.133 14.564 17 10.991 17c-3.57 0-6.523-1.861-8.775-5.27a1.342 1.342 0 0 1 .007-1.471C4.53 6.845 7.438 5 10.991 5Zm0 1.565c-2.943 0-5.37 1.514-7.383 4.436 1.965 2.91 4.426 4.434 7.383 4.434 2.962 0 5.442-1.53 7.403-4.433-2.028-2.925-4.462-4.437-7.403-4.437Zm0 1.565A2.866 2.866 0 0 1 13.854 11a2.866 2.866 0 0 1-2.863 2.87A2.866 2.866 0 0 1 8.128 11a2.866 2.866 0 0 1 2.863-2.87Zm0 1.566c-.719 0-1.301.584-1.301 1.304a1.302 1.302 0 1 0 2.603 0c0-.72-.583-1.304-1.302-1.304Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconPreview951Style0;
  }
}, [1, "cosmos-icon-preview-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$f() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-preview-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-preview-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconPreview$1);
        break;
    }
  });
}
const defineCustomElement$l = defineCustomElement$1$f, cosmosIconCss$a = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconProductPlacement951Style0 = cosmosIconCss$a, CosmosIconProductPlacement$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "432872dda333674fca09bb8f3569869c19a52130", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "9f0466c8210fc1b458bda56a342b518f9f6b4bdf", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "c44acc2a9fa687200c9c9c609deb5a0bdef72545", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.54 2.002 19.36 2c.223 0 .304.023.385.067a.454.454 0 0 1 .19.189c.043.081.066.162.066.385v16.718c0 .223-.023.304-.067.385a.454.454 0 0 1-.189.19c-.081.043-.162.066-.385.066H2.641c-.223 0-.304-.023-.385-.067a.454.454 0 0 1-.19-.189.59.59 0 0 1-.064-.285L2 2.641c0-.223.023-.304.067-.385a.454.454 0 0 1 .189-.19.59.59 0 0 1 .285-.064ZM18.5 3.5h-15v15h15v-15Zm-8.356 11.501V12.16h1.092c.424 0 .806-.06 1.146-.18.34-.12.63-.29.87-.51.24-.22.424-.49.552-.81.128-.32.192-.68.192-1.08 0-.8-.244-1.43-.732-1.89C12.776 7.23 12.1 7 11.236 7H8.44v8.001h1.704Zm.972-4.233h-.972v-2.34h.972c.36 0 .64.102.84.306.2.204.3.49.3.858 0 .36-.1.646-.3.858-.2.212-.48.318-.84.318Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconProductPlacement951Style0;
  }
}, [1, "cosmos-icon-product-placement-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$e() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-product-placement-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-product-placement-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconProductPlacement$1);
        break;
    }
  });
}
const defineCustomElement$k = defineCustomElement$1$e, cosmosIconCss$9 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconQuality951Style0 = cosmosIconCss$9, CosmosIconQuality$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "658babee5673b0eff1c69992696f279b4322bebf", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "f14986a9300e43355419f4472641bee146d91887", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "c2c0705e573b646dc151ce661962ea1edceaa3c6", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.051 7.859a.5.5 0 0 0 .069-.593l-1.174-2.032A.5.5 0 0 0 16.4 5l-2.477.586a6.222 6.222 0 0 0-1.368-.786l-.732-2.439A.5.5 0 0 0 11.344 2H9a.5.5 0 0 0-.479.356L7.786 4.8a6.148 6.148 0 0 0-1.362.789L3.945 5a.5.5 0 0 0-.549.237L2.223 7.266a.5.5 0 0 0 .069.593l1.745 1.854a6.484 6.484 0 0 0 0 1.575l-1.745 1.853a.5.5 0 0 0-.069.593L3.4 15.766a.5.5 0 0 0 .544.234l1.671-.395A.5.5 0 0 0 6 15.122v-3.357a4.131 4.131 0 0 1 .332-3.674 4.382 4.382 0 0 1 8.182 1.465c.032.25.242.44.494.444h1.076a.5.5 0 0 0 .389-.186l1.578-1.955Z", fill: "currentColor" }), h$1("path", { key: "26cc1b800095530d7aefca46cf5bc87d42c7df88", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.5 12h-11a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Z", fill: "#DB0A40" }), h$1("path", { key: "215b86bf44823f2ee760e5d2748faa9711d4a450", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.557 17.955a.264.264 0 0 1-.277.288h-.733a.264.264 0 0 1-.277-.288v-1.431h-1.232v1.431a.264.264 0 0 1-.277.288h-.732a.264.264 0 0 1-.278-.288V14.05a.265.265 0 0 1 .277-.288h.733a.265.265 0 0 1 .277.288v1.31h1.232v-1.31a.265.265 0 0 1 .277-.288h.733a.265.265 0 0 1 .277.288v3.906Zm1.154.288h1.566a2.3 2.3 0 0 0 2.473-2.263 2.254 2.254 0 0 0-2.474-2.22H14.71a.265.265 0 0 0-.277.29v3.905a.264.264 0 0 0 .277.288Zm1.022-3.317h.544a1.01 1.01 0 0 1 1.12 1.054 1.038 1.038 0 0 1-1.12 1.098h-.544v-2.152Z", fill: "#fff" })));
  }
  static get style() {
    return CosmosIconQuality951Style0;
  }
}, [1, "cosmos-icon-quality-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$d() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-quality-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-quality-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconQuality$1);
        break;
    }
  });
}
const defineCustomElement$j = defineCustomElement$1$d, cosmosIconCss$8 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconReddit951Style0 = cosmosIconCss$8, CosmosIconReddit$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "bfa7ca638ab27e6085cd17ab64af9e586282b890", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "eb1607efadc7e4a3ae11da5cadc293f7e6a60001", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "11e8168e3d29bb85c17d9eec2156721d2265c959", d: "M20.62 11.442a2.033 2.033 0 0 0-2.036-2.035 2.05 2.05 0 0 0-1.418.567c-1.401-1-3.32-1.652-5.456-1.735l.935-4.371 3.036.65A1.453 1.453 0 1 0 17.132 3a1.45 1.45 0 0 0-1.3.818L12.445 3.1c-.1-.017-.2 0-.267.05a.325.325 0 0 0-.15.234l-1.035 4.872c-2.169.066-4.121.717-5.54 1.735a2.05 2.05 0 0 0-1.417-.567A2.033 2.033 0 0 0 3.2 13.31c-.033.2-.05.4-.05.617 0 3.137 3.654 5.69 8.159 5.69 4.505 0 8.159-2.536 8.159-5.69 0-.2-.017-.417-.05-.617a2.055 2.055 0 0 0 1.201-1.869ZM6.638 12.894a1.453 1.453 0 0 1 2.903 0c0 .8-.65 1.451-1.451 1.451-.801.017-1.452-.65-1.452-1.451Zm8.126 3.854c-1.001 1.001-2.903 1.068-3.454 1.068-.567 0-2.47-.083-3.454-1.068a.373.373 0 0 1 0-.534c.15-.15.384-.15.534 0 .634.634 1.969.851 2.92.851.951 0 2.303-.217 2.92-.85a.371.371 0 0 1 .534 0 .406.406 0 0 1 0 .533Zm-.267-2.386a1.453 1.453 0 0 1 0-2.903c.8 0 1.451.65 1.451 1.452 0 .784-.65 1.451-1.451 1.451Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconReddit951Style0;
  }
}, [1, "cosmos-icon-reddit-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$c() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-reddit-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-reddit-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconReddit$1);
        break;
    }
  });
}
const defineCustomElement$i = defineCustomElement$1$c, cosmosIconCss$7 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconReplay951Style0 = cosmosIconCss$7, CosmosIconReplay$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "53fb39e861e41bda2309b6d95e72ee9275c17b8a", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "4736ec5070255e33b4dc490d24eace01c40d2706", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "fd7f81d0e2ba5fa7393189e4856ba0b85b260558", d: "M10.993 18.6a6.504 6.504 0 0 1-6.487-6 .532.532 0 0 0-.52-.5h-.5a.477.477 0 0 0-.485.5 8.005 8.005 0 0 0 7.992 7.5c4.422 0 8.007-3.582 8.007-8s-3.585-8-8.007-8H8.674l-.003-2.196a.4.4 0 0 0-.68-.29l-3.004 3a.4.4 0 0 0 0 .56l3.003 3a.4.4 0 0 0 .69-.29L8.678 5.6h2.316a6.503 6.503 0 0 1 6.506 6.5c0 3.59-2.913 6.5-6.506 6.5Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconReplay951Style0;
  }
}, [1, "cosmos-icon-replay-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$b() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-replay-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-replay-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconReplay$1);
        break;
    }
  });
}
const defineCustomElement$h = defineCustomElement$1$b, cosmosIconCss$6 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconSettings951Style0 = cosmosIconCss$6, CosmosIconSettings$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "4fb4c03e99350302b7d9c358a0537f35148fda0f", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "78357c2ea884c03039d396e65d7e1e1fdbba2595", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "9f7a80b76a50e3b8bbbc3d5daf4ed1639fa48562", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.782 10.942a6.688 6.688 0 0 0-.044-.733l1.64-1.765a.441.441 0 0 0 .063-.53L17.329 6.01a.432.432 0 0 0-.486-.212l-2.312.547a6.1 6.1 0 0 0-1.297-.697l-.688-2.294A.433.433 0 0 0 12.123 3H9.89a.441.441 0 0 0-.423.318l-.689 2.33c-.462.177-.9.411-1.306.696L5.17 5.797a.441.441 0 0 0-.485.212L3.572 7.933a.45.45 0 0 0 .062.529l1.641 1.765a6.098 6.098 0 0 0 0 1.465l-1.641 1.764a.45.45 0 0 0-.062.53l1.112 1.923a.44.44 0 0 0 .485.212l2.303-.582c.403.288.842.523 1.306.697l.689 2.294a.441.441 0 0 0 .423.318h2.233a.432.432 0 0 0 .423-.318l.688-2.294a5.73 5.73 0 0 0 1.297-.697l2.33.547a.432.432 0 0 0 .485-.212l1.112-1.924a.441.441 0 0 0-.062-.529l-1.64-1.765a6.66 6.66 0 0 0 .026-.714Zm-5.78 4.147a4.147 4.147 0 1 1 0-8.295 4.147 4.147 0 0 1 0 8.295Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconSettings951Style0;
  }
}, [1, "cosmos-icon-settings-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$a() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-settings-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-settings-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconSettings$1);
        break;
    }
  });
}
const defineCustomElement$g = defineCustomElement$1$a, cosmosIconCss$5 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconStop951Style0 = cosmosIconCss$5, CosmosIconStop$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "ffb702a8c3ae261a4c4ac5ad6275eb07efe9a00f", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "aa9f2ce6e1ea492e8ea62336001b215f36dbe72d", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "33efaae544b496ecf9ed9906ed9061939d00341f", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 6h-9a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconStop951Style0;
  }
}, [1, "cosmos-icon-stop-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$9() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-stop-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-stop-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconStop$1);
        break;
    }
  });
}
const defineCustomElement$f = defineCustomElement$1$9, cosmosIconCss$4 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconSubtitles951Style0 = cosmosIconCss$4, CosmosIconSubtitles$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "df3a3bb5ea2210e16fb7d0302ab182f952fa4b3d", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "0f37e89166e0b22f568f18a6925cc1aaffc6745d", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "7424f4f8f3c1a7b9b2ca5fd01d7440cc68ca2bed", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 3H20v11.5a.5.5 0 0 1-.5.5H13l-5.51 4.59a.3.3 0 0 1-.49-.23V15H2.5a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5Zm16 10.5v-9h-15v9H8a.5.5 0 0 1 .5.5v2.8l3.82-3.18a.47.47 0 0 1 .32-.12h5.86Z", fill: "currentColor" }), h$1("path", { key: "651bcc86015bb7937faa485443d90529b1f7b6d2", d: "M6 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-6A.5.5 0 0 1 6 8v-.5Zm5 3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.5Zm3-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-1A.5.5 0 0 1 14 8v-.5Zm-8 3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3A.5.5 0 0 1 6 11v-.5Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconSubtitles951Style0;
  }
}, [1, "cosmos-icon-subtitles-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$8() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-subtitles-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-subtitles-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconSubtitles$1);
        break;
    }
  });
}
const defineCustomElement$e = defineCustomElement$1$8, cosmosIconCss$3 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconVolume951Style0 = cosmosIconCss$3, CosmosIconVolume$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "90afd1878e38c318e3e786f09571de22c774aa98", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "4adc43f29baba5b1a3ce9e63877e1f91e200960e", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "ba16d3e90c868910feefd2f3d10106d101840780", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.51 4.42a.52.52 0 0 1 .72 0v-.04a9.14 9.14 0 0 1-.09 13.1.5.5 0 0 1-.71 0l-.34-.35a.5.5 0 0 1 0-.71 7.66 7.66 0 0 0 .08-10.94.49.49 0 0 1 0-.7l.34-.36Zm-5.34 1.29L7.62 8H4.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h3.11l2.56 2.26a.5.5 0 0 0 .83-.37V6.08a.5.5 0 0 0-.83-.37Zm3.2 1.98-.37.37a.49.49 0 0 0 0 .67 3.14 3.14 0 0 1 .93 2.2 3.42 3.42 0 0 1-1 2.28.51.51 0 0 0 0 .68l.35.36a.5.5 0 0 0 .69 0 4.59 4.59 0 0 0 .09-6.61.5.5 0 0 0-.69.05Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconVolume951Style0;
  }
}, [1, "cosmos-icon-volume-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$7() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-volume-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-volume-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconVolume$1);
        break;
    }
  });
}
const defineCustomElement$d = defineCustomElement$1$7, cosmosIconCss$2 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconVolumeLow951Style0 = cosmosIconCss$2, CosmosIconVolumeLow$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "be8068acd602bf594e371207f2a00336c3b0247e", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "96d1dcd14cebdeba80074239dbf542d219d7c7ab", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "2ee993bbc77df9884a1ffaa87f3de1cede6acdb6", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.17 5.71 7.62 8H4.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h3.11l2.56 2.26a.5.5 0 0 0 .83-.37V6.08a.5.5 0 0 0-.83-.37Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconVolumeLow951Style0;
  }
}, [1, "cosmos-icon-volume-low-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$6() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-volume-low-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-volume-low-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconVolumeLow$1);
        break;
    }
  });
}
const defineCustomElement$c = defineCustomElement$1$6, cosmosIconCss$1 = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconVolumeMid951Style0 = cosmosIconCss$1, CosmosIconVolumeMid$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "64488651b7e692b2c96460fcbb054f043a34aae6", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "05539893fdb553248a0c27956196543f9e751204", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "a8c8973370645a9a6e98a9fbe3998714cbeb959e", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7.62 8 2.55-2.29a.5.5 0 0 1 .83.37v9.81a.5.5 0 0 1-.83.37L7.61 14H4.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h3.12Zm5.38.06.37-.37a.5.5 0 0 1 .69-.05 4.59 4.59 0 0 1-.09 6.61.5.5 0 0 1-.69 0l-.35-.36a.51.51 0 0 1 0-.68 3.42 3.42 0 0 0 1-2.28 3.14 3.14 0 0 0-.93-2.2.49.49 0 0 1 0-.67Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconVolumeMid951Style0;
  }
}, [1, "cosmos-icon-volume-mid-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$5() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-volume-mid-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-volume-mid-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconVolumeMid$1);
        break;
    }
  });
}
const defineCustomElement$b = defineCustomElement$1$5, cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}", CosmosIconX951Style0 = cosmosIconCss, CosmosIconX$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ariaLabel = void 0;
  }
  getRole() {
    return this.ariaLabel ? "img" : void 0;
  }
  getAriaHidden() {
    return this.ariaLabel ? !1 : "true";
  }
  render() {
    return h$1(Host, { key: "ab0a1d24d54ee126808b8815cd9810e50b813232", role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h$1("svg", { key: "862192fefe153bea11552472e28637f8d5dad646", width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h$1("path", { key: "336d379900a78070bb923956c3f12407eb4e7fa8", d: "M12.317 9.775 18.144 3h-1.38l-5.06 5.883L7.66 3H3l6.112 8.896L3 19h1.381l5.344-6.212L13.993 19h4.661l-6.338-9.225Zm-1.892 2.199-.62-.886L4.88 4.04H7l3.977 5.688.62.886 5.168 7.393h-2.121l-4.218-6.033Z", fill: "currentColor" })));
  }
  static get style() {
    return CosmosIconX951Style0;
  }
}, [1, "cosmos-icon-x-9-5-1", {
  ariaLabel: [513, "aria-label"]
}]);
function defineCustomElement$1$4() {
  if (typeof customElements > "u")
    return;
  ["cosmos-icon-x-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-icon-x-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosIconX$1);
        break;
    }
  });
}
const defineCustomElement$a = defineCustomElement$1$4, cosmosLinkCss = "@-webkit-keyframes cosmos-link-dim-border{0%{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}100%{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}}@keyframes cosmos-link-dim-border{0%{-webkit-text-decoration-color:transparent;text-decoration-color:transparent}100%{-webkit-text-decoration-color:currentColor;text-decoration-color:currentColor}}.cosmos-link{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;border:0;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-variation-settings:inherit;font-weight:inherit;line-height:inherit;margin:0;outline:none;padding:0;color:inherit;font:inherit;font-variant-numeric:inherit;letter-spacing:inherit;position:relative;text-align:inherit;text-decoration:none}.cosmos-link:not(:focus):hover{-webkit-animation:none;animation:none;border-color:currentColor;-o-border-image:none;border-image:none}.cosmos-link:focus-visible{border-radius:0.2em;-webkit-box-shadow:0 0 0 2px #fff, inset 0 0 0 2px #1B6AEE;box-shadow:0 0 0 2px #fff, inset 0 0 0 2px #1B6AEE;margin:0 -2px;padding:0 2px;text-decoration:none}.cosmos-link--kind-underlined{text-decoration:underline;text-decoration-thickness:0.105em;text-transform:inherit;text-underline-offset:0.125em}.cosmos-link--kind-underlined:not(:focus){-webkit-animation:1s cosmos-link-dim-border steps(2, start) infinite paused;animation:1s cosmos-link-dim-border steps(2, start) infinite paused}", CosmosLink951Style0 = cosmosLinkCss, generateClassNames$3 = bem("cosmos-link"), CosmosLink$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.handleKeyDown = (te) => {
      this.href || (te.key === "Enter" || te.key === " ") && (te.preventDefault(), te.target.click());
    }, this.href = void 0, this.kind = "underlined", this.rel = void 0, this.target = void 0;
  }
  render() {
    const te = this.href ? "a" : "span", ee = te === "span" ? "button" : void 0;
    return h$1(te, { key: "b0acd57639aa98839ec1a5b2b893234884e61f15", class: generateClassNames$3({
      kind: this.kind
    }), href: this.href, onKeyDown: this.handleKeyDown, part: "base", rel: this.rel, role: ee, tabIndex: 0, target: this.target }, h$1("slot", { key: "85c6aa2dd812d5f78c66157d333582f175192d3a" }));
  }
  static get style() {
    return CosmosLink951Style0;
  }
}, [1, "cosmos-link-9-5-1", {
  href: [513],
  kind: [513],
  rel: [513],
  target: [513]
}]);
function defineCustomElement$1$3() {
  if (typeof customElements > "u")
    return;
  ["cosmos-link-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-link-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosLink$1);
        break;
    }
  });
}
const defineCustomElement$9 = defineCustomElement$1$3, defineCustomElement$8 = defineCustomElement$O, defineCustomElement$7 = defineCustomElement$N, cosmosRadioCss = '@charset "UTF-8";:host{display:block;min-width:0;width:100%}.cosmos-radio{-ms-flex-align:baseline;align-items:baseline;display:-ms-flexbox;display:flex}.cosmos-radio__input-and-prefix{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0}.cosmos-radio__aligner{--cosmos-text-font-family:var(--cosmos-radio-font-family);--cosmos-text-font-size:var(--cosmos-radio-font-size);--cosmos-text-font-style:var(--cosmos-radio-font-style);--cosmos-text-font-weight:var(--cosmos-radio-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-line-height);--cosmos-text-text-transform:var(--cosmos-radio-text-transform);width:0}.cosmos-radio__aligner::before{content:" "}.cosmos-radio__input-container{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;height:var(--cosmos-radio-size, 16px);-ms-flex-pack:center;justify-content:center;-webkit-margin-end:var(--cosmos-radio-gap, calc(0.5 * var(--cosmos-radio-size, 16px)));margin-inline-end:var(--cosmos-radio-gap, calc(0.5 * var(--cosmos-radio-size, 16px)));position:relative;width:var(--cosmos-radio-size, 16px)}.cosmos-radio__prefix{display:grid}.cosmos-radio__prefix>[slot=prefix]{-webkit-margin-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)));margin-inline-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)))}.cosmos-radio__prefix ::slotted([slot=prefix]){--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px;-webkit-margin-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)));margin-inline-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)));position:relative}.cosmos-radio__prefix ::slotted([slot=prefix])::before{content:"";display:block;height:100%;left:0;min-height:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.cosmos-radio__input{-ms-flex-align:center;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border-radius:9999px;border-style:solid;border-width:var(--cosmos-radio-border-width, 1px);-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;display:-ms-flexbox;display:flex;height:var(--cosmos-radio-size, 16px);-ms-flex-pack:center;justify-content:center;margin:0;outline:none;padding:0;width:var(--cosmos-radio-size, 16px)}.cosmos-radio__input:focus,.cosmos-radio__input:focus:not(:focus-visible){outline:none}.cosmos-radio__input:focus:not(:focus-visible)::before{content:none}.cosmos-radio__input:focus::before{border-radius:calc(9999px * 1.5);bottom:calc((4px + 0px) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + 0px) * -1);position:absolute;right:calc((4px + 0px) * -1);top:calc((4px + 0px) * -1);content:""}.cosmos-radio__input::after{-webkit-box-sizing:content-box;box-sizing:content-box;content:"";display:block;height:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);z-index:1}.cosmos-radio__input~.cosmos-radio__dot{border-radius:9999px;display:block;height:6px;left:0;margin:auto;opacity:0;position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:6px}.cosmos-radio__input:checked~.cosmos-radio__dot{opacity:1}.cosmos-radio__content{min-width:0;position:relative}.cosmos-radio__content--row{width:100%}.cosmos-radio__content--row label{width:100%}.cosmos-radio__label{display:block;min-width:0;position:relative}.cosmos-radio__label::before{bottom:calc(calc(0.25 * var(--cosmos-radio-size, 16px)) * -1);content:"";left:0;position:absolute;right:0;top:calc(calc(0.25 * var(--cosmos-radio-size, 16px)) * -1)}.cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color);--cosmos-text-font-family:var(--cosmos-radio-font-family);--cosmos-text-font-size:var(--cosmos-radio-font-size);--cosmos-text-font-style:var(--cosmos-radio-font-style);--cosmos-text-font-weight:var(--cosmos-radio-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-line-height);--cosmos-text-text-transform:var(--cosmos-radio-text-transform);display:-ms-flexbox;display:flex;position:relative}.cosmos-radio--hovered .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color-hover)}.cosmos-radio--appearance-dark{color:var(--cosmos-radio-color, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input{background:var(--cosmos-radio-background-color, transparent);border-color:var(--cosmos-radio-border-color, rgba(0, 15, 30, 0.6))}.cosmos-radio--appearance-dark .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input:checked~.cosmos-radio__dot{background-color:var(--cosmos-radio-dot-color, #FFFFFF)}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover,.cosmos-radio--appearance-dark.cosmos-radio--hovered{color:var(--cosmos-radio-color-hover, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-dark.cosmos-radio--hovered .cosmos-radio__input{background:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-dark.cosmos-radio--hovered .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.8))}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input:checked{border-color:transparent}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input{border-color:var(--cosmos-radio-border-color-hover, rgba(0, 15, 30, 0.6))}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input:checked{border-color:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-radio--appearance-light{color:var(--cosmos-radio-color, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input{background:var(--cosmos-radio-background-color, transparent);border-color:var(--cosmos-radio-border-color, rgba(255, 255, 255, 0.6))}.cosmos-radio--appearance-light .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input:checked~.cosmos-radio__dot{background-color:var(--cosmos-radio-dot-color, #000F1E)}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover,.cosmos-radio--appearance-light.cosmos-radio--hovered{color:var(--cosmos-radio-color-hover, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-light.cosmos-radio--hovered .cosmos-radio__input{background:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-light.cosmos-radio--hovered .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.8))}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input:checked{border-color:transparent}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-light:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input{border-color:var(--cosmos-radio-border-color-hover, rgba(255, 255, 255, 0.6))}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-light:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input:checked{border-color:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-radio--disabled{pointer-events:none}.cosmos-radio--disabled .cosmos-radio__prefix{opacity:0.4}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__input{border-color:var(--cosmos-radio-border-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__input{border-color:var(--cosmos-radio-border-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--invalid .cosmos-radio__input{border-color:var(--cosmos-radio-invalid-color, #E06600);border-width:var(--cosmos-radio-border-width, 2px)}', CosmosRadio951Style0 = cosmosRadioCss, generateClassNames$2 = bem("cosmos-radio"), CosmosRadio$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.inputchangeEvent = createEvent(this, "inputchange", 6), this.inputinvalidEvent = createEvent(this, "inputinvalid", 7), this.radios = [], this.hoveredOn = () => {
      this.isHovered = !0;
    }, this.hoveredOff = () => {
      this.isHovered = !1;
    }, this.handleFormData = (te) => {
      if (this.name && this.input && this.input.checked && !this.disabled)
        return te.formData.append(this.input.name, this.input.value);
    }, this.handleFormSubmit = (te) => {
      this.reportValidity() || te.preventDefault();
    }, this.handleInvalid = (te) => {
      this.group && te.preventDefault(), this.inputInvalid = !0, this.inputinvalidEvent.emit();
    }, this.handleChange = () => {
      var te;
      this.checked = (te = this.input) === null || te === void 0 ? void 0 : te.checked;
    }, this.handleSlotChange = () => {
      this.labelText = getDefaultSlotTextContent(this.defaultSlotRef);
    }, this.appearance = void 0, this.autofocus = void 0, this.checked = !1, this.clamp = void 0, this.disabled = !1, this.focusable = !0, this.hitArea = "content", this.invalid = !1, this.name = void 0, this.required = !1, this.value = void 0, this.computedAppearance = "dark", this.inputInvalid = !1, this.isHovered = !1, this.labelText = "", this.tabIndex = 0;
  }
  /**
   * Returns the validity status of the Radio's value.
   * Fires an `inputinvalid`  event in the case of invalidity.
   */
  async inputCheckValidity() {
    return this.checkValidity();
  }
  /**
   * Performs the same validity checking steps as the `inputCheckValidity` methods.
   * Fires an `inputinvalid` event and reports the problem to the user in case of invalidity.
   */
  async inputReportValidity() {
    return this.reportValidity();
  }
  /**
   * Sets a custom error message for the native validation issue report.
   */
  async inputSetCustomValidity(te) {
    var ee;
    (ee = this.input) === null || ee === void 0 || ee.setCustomValidity(te);
  }
  /**
   * Sets focus on the Radio. This will scroll the element into the view and focus it.
   */
  async inputFocus() {
    var te;
    (te = this.input) === null || te === void 0 || te.focus();
  }
  /**
   * Removes focus from the Radio.
   */
  async inputBlur() {
    var te;
    (te = this.input) === null || te === void 0 || te.blur();
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  handleFocusableChange(te) {
    this.setTabindexFromFocusable(te);
  }
  handleInvalidChange(te) {
    this.inputInvalid = te;
  }
  handleCheckedChange(te, ee) {
    te && te !== ee && this.inputchangeEvent.emit();
  }
  deriveTextAppearance() {
    return this.computedAppearance === "light" ? "light" : "dark";
  }
  getTitle() {
    var te;
    return this.clamp ? (te = this.element.textContent) === null || te === void 0 ? void 0 : te.trim() : void 0;
  }
  checkValidity() {
    var te, ee;
    const ie = (te = this.radios) === null || te === void 0 ? void 0 : te.some((ae) => ae.shadowRoot.querySelector('input[type="radio"]').checked);
    return !((ee = this.radios) === null || ee === void 0 ? void 0 : ee.some((ae) => ae.required)) || ie;
  }
  reportValidity() {
    const te = this.checkValidity();
    return !te && this.input && (this.input.required = !0, this.input.reportValidity()), te;
  }
  getAllRadios() {
    return this.group ? [
      ...this.group.querySelectorAll(`${transformTagName("cosmos-radio")}[name="${this.name}"]`)
    ].filter((ee) => !ee.disabled) : [this.element];
  }
  getRadioIndex() {
    return this.radios.findIndex((te) => te === this.element);
  }
  setTabindexFromFocusable(te = this.focusable) {
    this.tabIndex = te ? 0 : -1;
  }
  componentWillLoad() {
    resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    }), this.radios = this.getAllRadios(), this.radioIndex = this.getRadioIndex(), this.setTabindexFromFocusable();
  }
  connectedCallback() {
    this.form = this.element.closest("form"), this.group = this.element.closest(transformTagName("cosmos-radio-group")), this.form && (this.form.addEventListener("formdata", this.handleFormData, !0), this.form.addEventListener("submit", this.handleFormSubmit, !0));
  }
  render() {
    return h$1("div", { key: "bb2e9d2af28ab0d082526cb5d9206086dbad907d", class: generateClassNames$2({
      appearance: this.computedAppearance,
      disabled: this.disabled,
      hovered: this.isHovered,
      invalid: this.invalid || this.inputInvalid
    }), part: "base" }, h$1("div", { key: "9fa480bff430bb5a59f9e9edecfb0a38ca335422", class: generateClassNames$2("input-and-prefix") }, h$1("cosmos-text-9-5-1", { key: "2a2f09729245a5c9945b2a8989737728fa8a92fc", "aria-hidden": "true", class: generateClassNames$2("aligner"), size: "small", tag: "span" }), h$1("div", { key: "d64c7a7320e4b5ed01bfd51444985fc7094bba4c", class: generateClassNames$2("input-container") }, h$1("input", { key: "376696e106b1f6a804cb9e93302a3fc9340d6768", "aria-label": this.labelText, "aria-posinset": this.radioIndex + 1, "aria-setsize": this.radios.length, autofocus: this.autofocus, checked: this.checked, class: generateClassNames$2("input"), disabled: this.disabled, id: "radio", name: this.name, onInvalid: this.handleInvalid, ref: (te) => this.input = te, required: this.required, tabIndex: this.tabIndex, type: "radio", value: this.value, onChange: this.handleChange, part: "radio" }), h$1("span", { key: "9c73e8529d8ab2ad86f50d88cf6cbd6620db669e", class: generateClassNames$2("dot") })), h$1("label", { key: "f44b5311e1353d3ae74a5772db1ca65543a42304", "aria-hidden": "true", htmlFor: "radio", class: generateClassNames$2("prefix"), onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff, part: "prefix" }, h$1("slot", { key: "91c7ce903cac7ae74c63d3bf833882e090490c83", name: "prefix" }))), h$1("div", { key: "9e723b8f294fba195c4bf519662266f1db0d6864", class: generateClassNames$2("content", {
      row: this.hitArea === "row"
    }) }, h$1("label", { key: "a954c1db88e3ac0d51746c04d1983e66ecdb68ca", class: generateClassNames$2("label"), htmlFor: "radio" }, h$1("cosmos-text-9-5-1", { key: "c766bd9e7e831614c569b35f16abb28fd0f23d8f", appearance: this.deriveTextAppearance(), class: generateClassNames$2("label-text"), clamp: this.clamp, onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff, size: "small", tag: "span", title: this.getTitle(), exportparts: "base: label" }, h$1("span", { key: "70872310ce35e04f4137a91a9caa570496d0c619" }, h$1("slot", { key: "205e09685ead46a6f0ccb2e40b3ac293e5338011", ref: (te) => this.defaultSlotRef = te }))))));
  }
  componentDidLoad() {
    slotMutationService.observe(this.element, this.handleSlotChange);
  }
  disconnectedCallback() {
    this.form && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit)), slotMutationService.unobserve(this.element);
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      focusable: ["handleFocusableChange"],
      invalid: ["handleInvalidChange"],
      checked: ["handleCheckedChange"]
    };
  }
  static get style() {
    return CosmosRadio951Style0;
  }
}, [1, "cosmos-radio-9-5-1", {
  appearance: [513],
  autofocus: [516],
  checked: [516],
  clamp: [516],
  disabled: [516],
  focusable: [516],
  hitArea: [513, "hit-area"],
  invalid: [516],
  name: [513],
  required: [516],
  value: [513],
  computedAppearance: [32],
  inputInvalid: [32],
  isHovered: [32],
  labelText: [32],
  tabIndex: [32],
  inputCheckValidity: [64],
  inputReportValidity: [64],
  inputSetCustomValidity: [64],
  inputFocus: [64],
  inputBlur: [64]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  focusable: ["handleFocusableChange"],
  invalid: ["handleInvalidChange"],
  checked: ["handleCheckedChange"]
}]);
function defineCustomElement$1$2() {
  if (typeof customElements > "u")
    return;
  ["cosmos-radio-9-5-1", "cosmos-text-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-radio-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosRadio$1);
        break;
      case "cosmos-text-9-5-1":
        customElements.get(te) || defineCustomElement$W();
        break;
    }
  });
}
const defineCustomElement$6 = defineCustomElement$1$2, cosmosRadioGroupCss = ".cosmos-form-field{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.cosmos-form-field__info-container{display:inline-block;margin-bottom:8px}.cosmos-form-field__info-container:not(.cosmos-form-field__info-container--has-label,.cosmos-form-field__info-container--has-help-text,.cosmos-form-field__info-container--has-required-optional-label){display:none}.cosmos-form-field__label-text,.cosmos-form-field__help-text,.cosmos-form-field__required-optional-label,.cosmos-form-field__validation-message{display:inline}.cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-radio-group-label-color);--cosmos-text-font-family:var(--cosmos-radio-group-label-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-label-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-label-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-label-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-label-text-transform)}.cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-radio-group-help-text-color);--cosmos-text-font-family:var(--cosmos-radio-group-help-text-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-help-text-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-help-text-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-help-text-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-help-text-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-help-text-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-help-text-text-transform)}.cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-radio-group-required-optional-label-color);--cosmos-text-font-family:var(--cosmos-radio-group-required-optional-label-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-required-optional-label-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-required-optional-label-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-required-optional-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-required-optional-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-required-optional-label-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-required-optional-label-text-transform);display:inline-block;-webkit-margin-start:4px;margin-inline-start:4px;white-space:nowrap}.cosmos-form-field__validation-message{display:-ms-flexbox;display:flex;gap:4px;margin-top:8px}.cosmos-form-field__validation-message-text{--cosmos-text-font-family:var(--cosmos-radio-group-validation-message-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-validation-message-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-validation-message-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-validation-message-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-validation-message-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-validation-message-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-validation-message-text-transform)}.cosmos-form-field__validation-message-icon{--cosmos-icon-color:var(--cosmos-radio-group-invalid-color, #E06600);--cosmos-icon-size:calc(16rem / var(--cosmos-base-font-size, 16));-ms-flex-negative:0;flex-shrink:0;padding:1.5px 0}.cosmos-form-field--invalid .cosmos-form-field__label-text,.cosmos-form-field--invalid .cosmos-form-field__validation-message{--cosmos-text-color:var(--cosmos-radio-group-label-color)}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-radio-group-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-radio-group-help-text-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-radio-group-required-optional-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-radio-group-label-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-radio-group-help-text-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-radio-group-required-optional-label-color, rgba(0, 15, 30, 0.45))}.cosmos-radio-group__list{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:12px}", CosmosRadioGroup951Style0 = cosmosRadioGroupCss, generateClassNames$1 = bem("cosmos-radio-group"), radioTag = transformTagName("cosmos-radio"), CosmosRadioGroup$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.enabledRadios = [], this.isNavigatedWithKeyboard = !1, this.radios = [], this.getValidationMessage = () => {
      if (this.validationMessage)
        return this.validationMessage;
      if (!this.invalid && this.groupInvalid && this.enabledRadios.length)
        return this.enabledRadios[0].shadowRoot.querySelector('input[type="radio"]').validationMessage;
    }, this.reannounceValidationMessage = async () => {
      this.validationMessageRef && (this.validationMessageRef.ariaLabel = "", await nextTick(), this.validationMessageRef.ariaLabel = this.getValidationMessage());
    }, this.handleSlotChange = () => {
      this.initializeRadios(), forceUpdate(this);
    }, this.appearance = void 0, this.disabled = void 0, this.helpText = void 0, this.invalid = !1, this.label = void 0, this.optionalLabel = void 0, this.requiredLabel = void 0, this.validationMessage = void 0, this.computedAppearance = "dark", this.groupInvalid = !1;
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te, this.updateRadiosAppearance();
  }
  handleInvalidChange(te) {
    this.groupInvalid = te, this.updateRadiosInvalidState();
  }
  handleDisabledChange(te) {
    typeof this.disabled < "u" && this.radios.forEach((ee) => {
      ee.disabled = te;
    });
  }
  async handleInputchange(te) {
    const ee = this.enabledRadios.findIndex((ie) => ie === te.target);
    await this.updateRadios(ee), this.isInvalidStateControlled();
  }
  // Will not update children to valid if invalid state is controlled
  isInvalidStateControlled() {
    this.invalid || (this.groupInvalid = !1, this.updateRadiosInvalidState());
  }
  handleInputInvalid() {
    this.groupInvalid = !0, this.updateRadiosInvalidState(), this.reannounceValidationMessage();
  }
  async handleKeyDown(te) {
    if (this.isNavigatedWithKeyboard = te.key !== "Tab", ["ArrowUp", "ArrowLeft", "ArrowRight", "ArrowDown"].includes(te.key)) {
      [this.radios, this.enabledRadios] = this.getRadios(), te.preventDefault();
      let ee = this.enabledRadios.findIndex((ie) => ie.checked);
      ee == -1 && (ee = 0), ["ArrowUp", "ArrowLeft"].includes(te.key) ? (ee--, ee < 0 && (ee = this.enabledRadios.length - 1)) : (ee++, ee >= this.enabledRadios.length && (ee = 0)), await this.updateRadios(ee);
    }
  }
  getRadios() {
    const te = [...this.element.querySelectorAll(radioTag)], ee = te.filter((ie) => !ie.disabled);
    return [te, ee];
  }
  updateRadiosAppearance() {
    this.radios.forEach((te) => {
      te.appearance = this.computedAppearance;
    });
  }
  async updateRadios(te) {
    if (this.enabledRadios.length)
      if (this.enabledRadios.forEach((ee, ie) => {
        te !== ie && (ee.checked = !1), ee.invalid = this.groupInvalid, ee.focusable = !1;
      }), typeof te < "u" && te !== -1 && this.enabledRadios[te]) {
        const ee = this.enabledRadios[te];
        ee.checked = !0, ee.focusable = !0, this.isNavigatedWithKeyboard && await ee.inputFocus();
      } else
        this.enabledRadios[0].focusable = !0;
  }
  updateRadiosInvalidState() {
    this.radios.forEach((te) => {
      te.invalid = this.groupInvalid;
    });
  }
  updateRadiosDisabledState() {
    typeof this.disabled < "u" && this.radios.forEach((te) => {
      te.disabled = this.disabled;
    });
  }
  initializeRadios() {
    [this.radios, this.enabledRadios] = this.getRadios(), this.updateRadiosDisabledState(), this.updateRadiosInvalidState(), this.updateRadiosAppearance();
    const te = this.enabledRadios.findIndex((ee) => ee.checked);
    this.updateRadios(te);
  }
  componentWillLoad() {
    this.groupInvalid = this.invalid, resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "light", light: "dark" },
      callback: this.handleAppearanceChange.bind(this)
    }), slotMutationService.observe(this.element, this.handleSlotChange);
  }
  render() {
    return h$1(FormField, { key: "38f16355fa3b8d9deaf070378831c92345f31d2f", element: this.element, appearance: this.computedAppearance, class: generateClassNames$1(), helpText: this.helpText, invalid: this.groupInvalid, label: this.label, optionalLabel: this.optionalLabel, requiredLabel: this.requiredLabel, validationMessage: this.getValidationMessage(), validationMessageRef: (te) => this.validationMessageRef = te, disabled: this.disabled, required: !!this.requiredLabel }, h$1("div", { key: "f8446edfcde9d4be1ee6b6dcc2051d032ef214a9", "aria-disabled": getAriaDisabled(this.disabled), "aria-invalid": getAriaInvalid(this.groupInvalid), "aria-labelledby": `label ${getAriaDescribedBy(this.groupInvalid)}`, "aria-required": getAriaRequired(!!this.requiredLabel), class: generateClassNames$1("list"), role: "radiogroup" }, h$1("slot", { key: "2cfcfc5b47d4e35eeee9306352c320dadbd9ca0d" })));
  }
  disconnectedCallback() {
    slotMutationService.unobserve(this.element);
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      invalid: ["handleInvalidChange"],
      disabled: ["handleDisabledChange"]
    };
  }
  static get style() {
    return CosmosRadioGroup951Style0;
  }
}, [1, "cosmos-radio-group-9-5-1", {
  appearance: [513],
  disabled: [516],
  helpText: [513, "help-text"],
  invalid: [516],
  label: [513],
  optionalLabel: [513, "optional-label"],
  requiredLabel: [513, "required-label"],
  validationMessage: [513, "validation-message"],
  computedAppearance: [32],
  groupInvalid: [32]
}, [[0, "inputchange", "handleInputchange"], [0, "inputinvalid", "handleInputInvalid"], [0, "keydown", "handleKeyDown"]], {
  appearance: ["handleAppearanceChange"],
  invalid: ["handleInvalidChange"],
  disabled: ["handleDisabledChange"]
}]);
function defineCustomElement$1$1() {
  if (typeof customElements > "u")
    return;
  ["cosmos-radio-group-9-5-1", "cosmos-icon-warning-9-5-1", "cosmos-text-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-radio-group-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosRadioGroup$1);
        break;
      case "cosmos-icon-warning-9-5-1":
        customElements.get(te) || defineCustomElement$R();
        break;
      case "cosmos-text-9-5-1":
        customElements.get(te) || defineCustomElement$W();
        break;
    }
  });
}
const defineCustomElement$5 = defineCustomElement$1$1, defineCustomElement$4 = defineCustomElement$U, defineCustomElement$3 = defineCustomElement$W, defineCustomElement$2 = defineCustomElement$M, isNil = (re) => re == null, defaultDuration = 300, defaultOffset = 8;
class Tooltip {
  constructor() {
    this.emitter = new EventEmitter(), this.placementMap = {
      left: "before",
      right: "after",
      bottom: "below",
      top: "above"
    }, this.cssTransition = new CSSTransition();
  }
  create({ target: te, content: ee, appendTo: ie, interactive: ne, placement: ae, showOnCreate: ue, follow: _e, sticky: fe, offset: le = defaultOffset, enterDuration: se = defaultDuration, leaveDuration: oe = defaultDuration, trigger: ce }) {
    this.target = te, this.leaveDuration = oe, this.enterDuration = se, this.element = ee, this.element.style.display = "block", ee.remove(), this.tooltipInstance = tippy(this.target, {
      appendTo: ie,
      hideOnClick: !1,
      interactive: ne,
      offset: [0, le],
      placement: this.cosmosToPopperPlacement(ae),
      showOnCreate: ue || !1,
      touch: !1,
      delay: [null, this.leaveDuration],
      trigger: ce || void 0,
      sticky: fe,
      plugins: [followCursor, sticky],
      onMount: ({ popperInstance: he, popper: ge }) => {
        var ve;
        const me = _e ? "follow" : he == null ? void 0 : he.state.placement;
        (ve = ge.firstElementChild) === null || ve === void 0 || ve.setAttribute("data-cosmos-tooltip-placement", this.popperToCosmosPlacement(me)), this.cssTransition.enter(ge.firstElementChild, this.enterDuration);
      },
      onShow: () => {
        this.onShowHandler();
      },
      onUntrigger: async () => {
        await this.onHideHandler();
      },
      render: () => ({
        popper: this.element
      })
    }), _e && requestAnimationFrame(() => {
      var he;
      this.tooltipInstance && typeof this.tooltipInstance.setProps == "function" && ((he = this.tooltipInstance) === null || he === void 0 || he.setProps({ followCursor: this.getTippyFollowDirection(ae) }));
    });
  }
  on(te, ee) {
    this.emitter.on(te, ee);
  }
  off(te, ee) {
    this.emitter.off(te, ee);
  }
  show() {
    var te, ee, ie;
    !((te = this.tooltipInstance) === null || te === void 0) && te.unmount && ((ee = this.tooltipInstance) === null || ee === void 0 || ee.unmount()), (ie = this.tooltipInstance) === null || ie === void 0 || ie.show();
  }
  async hide() {
    await this.onHideHandler(), this.tooltipInstance.hide();
  }
  async update() {
    var te;
    this.isVisible() && (await nextTick(), await ((te = this.tooltipInstance.popperInstance) === null || te === void 0 ? void 0 : te.update()));
  }
  isVisible() {
    return this.tooltipInstance.state.isVisible;
  }
  setProps(te) {
    var ee;
    (ee = this.tooltipInstance) === null || ee === void 0 || ee.setProps(te);
  }
  destroy() {
    this.tooltipInstance.destroy();
  }
  popperToCosmosPlacement(te) {
    return this.placementMap[te];
  }
  cosmosToPopperPlacement(te) {
    return Object.keys(this.placementMap).find((ie) => this.placementMap[ie] === te) || "top";
  }
  getTippyFollowDirection(te) {
    return te === "above" || te === "below" ? "horizontal" : "vertical";
  }
  onShowHandler() {
    this.emitter.emit("show"), this.target.setAttribute("aria-expanded", "true");
  }
  onHideHandler() {
    return this.emitter.emit("hide"), this.triggerCssLeaveTransition();
  }
  triggerCssLeaveTransition() {
    return this.cssTransition.leave(this.element.firstElementChild, this.leaveDuration);
  }
}
const cosmosTooltipCss = '@supports (font-variation-settings: normal){::slotted(strong),::slotted(b){font-variation-settings:"opsz" 12, "wght" 700}}:host{display:contents}.tippy-mount{display:inline-block;height:0;width:0}.tippy-element{display:none;z-index:var(--cosmos-tooltip-z-index, 9999) !important}.cosmos-tooltip{--cosmos-text-color:var(--cosmos-tooltip-color);--cosmos-text-font-family:var(--cosmos-tooltip-font-family);--cosmos-text-font-size:var(--cosmos-tooltip-font-size);--cosmos-text-font-style:var(--cosmos-tooltip-font-style);--cosmos-text-font-weight:var(--cosmos-tooltip-font-weight);--cosmos-text-letter-spacing:var(--cosmos-tooltip-letter-spacing);--cosmos-text-line-height:var(--cosmos-tooltip-line-height);--cosmos-text-text-transform:var(--cosmos-tooltip-text-transform);background-color:var(--cosmos-tooltip-background, #FFFFFF);border-color:var(--cosmos-tooltip-border-color, transparent);border-radius:var(--cosmos-tooltip-border-radius, 6px);border-style:solid;border-width:var(--cosmos-tooltip-border-width, 0);-webkit-box-shadow:var(--cosmos-tooltip-box-shadow, 0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431));box-shadow:var(--cosmos-tooltip-box-shadow, 0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431));max-width:calc(288rem / var(--cosmos-base-font-size, 16));padding:var(--cosmos-tooltip-padding, 4px 8px)}.cosmos-tooltip--spacing-loose{padding:var(--cosmos-tooltip-padding, 8px 12px)}.cosmos-tooltip--appearance-dark{background-color:var(--cosmos-tooltip-background, #00162B)}.cosmos-tooltip.enter{opacity:0}.cosmos-tooltip[data-cosmos-tooltip-placement=above].enter{-webkit-transform:translate(0, 8px);transform:translate(0, 8px)}.cosmos-tooltip[data-cosmos-tooltip-placement=below].enter{-webkit-transform:translate(0, -8px);transform:translate(0, -8px)}.cosmos-tooltip[data-cosmos-tooltip-placement=before].enter{-webkit-transform:translate(8px, 0);transform:translate(8px, 0)}.cosmos-tooltip[data-cosmos-tooltip-placement=after].enter{-webkit-transform:translate(-8px, 0);transform:translate(-8px, 0)}.cosmos-tooltip[data-cosmos-tooltip-placement].enter-active{opacity:1;-webkit-transform:translate(0, 0);transform:translate(0, 0);-webkit-transition:0.15s cubic-bezier(0.33, 1, 0.68, 1);transition:0.15s cubic-bezier(0.33, 1, 0.68, 1)}.cosmos-tooltip.leave{opacity:1}.cosmos-tooltip.leave-active{opacity:0;-webkit-transition:0.15s cubic-bezier(0, 0.32, 0.32, 1);transition:0.15s cubic-bezier(0, 0.32, 0.32, 1)}.cosmos-tooltip--empty{display:none}', CosmosTooltip951Style0 = cosmosTooltipCss, generateClassNames = bem("cosmos-tooltip"), CosmosTooltip$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.hideEvent = createEvent(this, "hide", 7), this.showEvent = createEvent(this, "show", 7), this.tippyElement = void 0, this.tippyMount = void 0, this.tooltipInstance = void 0, this.onDefaultSlotChange = () => {
      this.tooltipInstance && !this.getTooltipTarget ? (this.tooltipInstance.destroy(), this.tooltipInstance = void 0) : (this.instantiateTooltip(), this.createTooltip());
    }, this.showHandler = () => {
      this.showEvent.emit();
    }, this.hideHandler = () => {
      this.hideEvent.emit();
    }, this.appearance = void 0, this.content = "", this.controlled = !1, this.follow = !1, this.offset = 8, this.placement = "above", this.spacing = "tight", this.unreachable = !1, this.visible = !1, this.computedAppearance = "light", this.hasContent = !1;
  }
  /**
   * Triggers an update of the tooltip positioning.
   */
  async update() {
    var te;
    this.tooltipInstance && await ((te = this.tooltipInstance) === null || te === void 0 ? void 0 : te.update());
  }
  handleAppearanceChange(te) {
    this.computedAppearance = te;
  }
  componentWillLoad() {
    this.instantiateTooltip(), resolveAppearance({
      instance: this,
      modeToAppearanceMap: { dark: "dark", light: "light" },
      callback: this.handleAppearanceChange.bind(this)
    });
  }
  componentDidLoad() {
    this.createTooltip(), this.createObserver();
  }
  disconnectedCallback() {
    var te, ee;
    this.removeTooltipListeners(), (te = this.tooltipInstance) === null || te === void 0 || te.destroy(), (ee = this.observer) === null || ee === void 0 || ee.disconnect();
  }
  handleShowChange() {
    var te, ee, ie, ne;
    (te = this.tooltipInstance) === null || te === void 0 || te.setProps({ touch: !0 }), this.visible ? (ee = this.tooltipInstance) === null || ee === void 0 || ee.show() : (ie = this.tooltipInstance) === null || ie === void 0 || ie.hide(), (ne = this.tooltipInstance) === null || ne === void 0 || ne.setProps({ touch: !1 });
  }
  createObserver() {
    const te = this.element.querySelector('[slot="content"]');
    if (!te || typeof MutationObserver > "u")
      return;
    const ee = new MutationObserver((ie) => {
      ie.forEach((ne) => {
        ne.type === "childList" && this.update();
      });
    });
    ee.observe(te, {
      childList: !0,
      subtree: !0
    }), this.observer = ee;
  }
  instantiateTooltip() {
    isNodeEnvironment() || !this.getTooltipTarget() || (this.tooltipInstance = new Tooltip());
  }
  createTooltip() {
    var te;
    this.tooltipInstance && (this.tooltipOptions = {
      target: this.getTooltipTarget(),
      appendTo: this.tippyMount,
      showOnCreate: this.visible,
      placement: this.placement || "above",
      content: this.tippyElement,
      follow: this.normalizedFollowValue,
      sticky: this.follow === "target",
      interactive: !this.unreachable,
      offset: this.offset,
      enterDuration: 150,
      leaveDuration: 150,
      trigger: this.controlled ? "manual" : void 0
    }, (te = this.tooltipInstance) === null || te === void 0 || te.create(this.tooltipOptions), this.addTooltipListeners());
  }
  addTooltipListeners() {
    var te, ee;
    this.tooltipInstance && ((te = this.tooltipInstance) === null || te === void 0 || te.on("show", this.showHandler), (ee = this.tooltipInstance) === null || ee === void 0 || ee.on("hide", this.hideHandler));
  }
  removeTooltipListeners() {
    var te, ee;
    this.tooltipInstance && ((te = this.tooltipInstance) === null || te === void 0 || te.off("show", this.showHandler), (ee = this.tooltipInstance) === null || ee === void 0 || ee.off("hide", this.hideHandler));
  }
  getTooltipTarget() {
    return Array.from(this.element.children).find((te) => te.tagName.toLowerCase() !== "style" && te.getAttribute("slot") !== "content");
  }
  getContent() {
    return this.content && h$1("cosmos-text-9-5-1", { size: "x-small", weight: "medium", exportparts: "base: text" }, this.content);
  }
  determineIfTooltipHasContent() {
    const te = hasNamedSlot(this.element, "content");
    this.hasContent = !isNil(this.content) && this.content !== "" || te;
  }
  componentWillRender() {
    this.normalizedFollowValue = this.normalizeFollowValue(), this.determineIfTooltipHasContent();
  }
  /**
   * Since the follow value can be a string or a boolean, we need to normalize it
   * and split it since in tippy follow and sticky are two different options.
   */
  normalizeFollowValue() {
    return this.follow === !0 || this.follow === "" ? !0 : this.follow === "cursor";
  }
  async handleContentChange() {
    await this.update();
  }
  render() {
    return h$1(Host, { key: "98b367c27394d476e43fdb9c18ae83e717c1b700" }, h$1("div", { key: "da504ddd34a9c5bb7a3609fb4a8c820f942dfc63", class: "tippy-mount", ref: (te) => this.tippyMount = te }), h$1("div", { key: "d9e9c17a881c1a0913ca47a59979ba278b123d03", class: "tippy-element", ref: (te) => this.tippyElement = te }, h$1("div", { key: "e384e77d810760ad44c942552768b50a7478096a", class: generateClassNames({
      spacing: this.spacing,
      appearance: this.computedAppearance,
      unreachable: this.unreachable,
      empty: !this.hasContent
    }), part: "base" }, h$1("cosmos-mode-9-5-1", { key: "9f3eced21326c4b94f4ed14591fb2e214615c4ad", mode: this.computedAppearance }, h$1("span", { key: "4e86d185d1cc9b1abccca0a12a1587652d32e1ab" }, h$1("slot", { key: "4abed24fef691960084c07e59c6b554c9abf5deb", name: "content", onSlotchange: () => this.determineIfTooltipHasContent() }, this.getContent()))))), h$1("slot", { key: "cbfeefa8374a6183c733c5ab73d4ca3e875704ce", onSlotchange: this.onDefaultSlotChange }));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      appearance: ["handleAppearanceChange"],
      visible: ["handleShowChange"],
      content: ["handleContentChange"]
    };
  }
  static get style() {
    return CosmosTooltip951Style0;
  }
}, [1, "cosmos-tooltip-9-5-1", {
  appearance: [513],
  content: [513],
  controlled: [516],
  follow: [520],
  offset: [514],
  placement: [513],
  spacing: [513],
  unreachable: [516],
  visible: [516],
  computedAppearance: [32],
  hasContent: [32],
  update: [64]
}, void 0, {
  appearance: ["handleAppearanceChange"],
  visible: ["handleShowChange"],
  content: ["handleContentChange"]
}]);
function defineCustomElement$1() {
  if (typeof customElements > "u")
    return;
  ["cosmos-tooltip-9-5-1", "cosmos-mode-9-5-1", "cosmos-text-9-5-1"].forEach((te) => {
    switch (te) {
      case "cosmos-tooltip-9-5-1":
        customElements.get(te) || customElements.define(te, CosmosTooltip$1);
        break;
      case "cosmos-mode-9-5-1":
        customElements.get(te) || defineCustomElement$N();
        break;
      case "cosmos-text-9-5-1":
        customElements.get(te) || defineCustomElement$W();
        break;
    }
  });
}
const defineCustomElement = defineCustomElement$1, CosmosButton = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-button-9-5-1",
  defaultProps: { busy: !1, decorative: !1, disabled: !1, hovered: !1, href: void 0, iconPlacement: "before", kind: "primary", size: "medium", type: "button", width: "content" },
  defineCustomElement: defineCustomElement$S
}), CosmosCheckbox = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-checkbox-9-5-1",
  defaultProps: { checked: !1, hitArea: "content", invalid: !1, required: !1 },
  defineCustomElement: defineCustomElement$P
}), CosmosIconAirplay = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-airplay-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$L
}), CosmosIconAudioSettings = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-audio-settings-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$K
}), CosmosIconBack10 = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-back-10-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$J
}), CosmosIconBrowse = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-browse-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$I
}), CosmosIconChevronLeft = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-chevron-left-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$H
}), CosmosIconChevronRight = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-chevron-right-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$G
}), CosmosIconClock = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-clock-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$F
}), CosmosIconClose = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-close-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$D
}), CosmosIconCodeBlock = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-code-block-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$C
}), CosmosIconErrorFilled = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-error-filled-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$B
}), CosmosIconEventDetails = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-event-details-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$A
}), CosmosIconFacebook = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-facebook-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$z
}), CosmosIconForward10 = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-forward-10-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$y
}), CosmosIconFullscreen = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-fullscreen-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$x
}), CosmosIconFullscreenExit = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-fullscreen-exit-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$w
}), CosmosIconLink = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-link-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$v
}), CosmosIconLive = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-live-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$u
}), CosmosIconLiveBroadcast = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-live-broadcast-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$t
}), CosmosIconMute = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-mute-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$s
}), CosmosIconNoData = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-no-data-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$r
}), CosmosIconPause = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-pause-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$q
}), CosmosIconPictureInPicture = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-picture-in-picture-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$p
}), CosmosIconPinterest = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-pinterest-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$o
}), CosmosIconPlay = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-play-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$m
}), CosmosIconPreview = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-preview-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$l
}), CosmosIconProductPlacement = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-product-placement-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$k
}), CosmosIconQuality = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-quality-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$j
}), CosmosIconReddit = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-reddit-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$i
}), CosmosIconReplay = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-replay-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$h
}), CosmosIconSettings = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-settings-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$g
}), CosmosIconStop = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-stop-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$f
}), CosmosIconSubtitles = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-subtitles-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$e
}), CosmosIconVolume = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-volume-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$d
}), CosmosIconVolumeLow = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-volume-low-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$c
}), CosmosIconVolumeMid = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-volume-mid-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$b
}), CosmosIconX = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-icon-x-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$a
}), CosmosLink = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-link-9-5-1",
  defaultProps: { kind: "underlined" },
  defineCustomElement: defineCustomElement$9
}), CosmosMediaPreview = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-media-preview-9-5-1",
  defaultProps: { radius: "none" },
  defineCustomElement: defineCustomElement$8
}), CosmosMode = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-mode-9-5-1",
  defaultProps: { mode: "light" },
  defineCustomElement: defineCustomElement$7
}), CosmosRadio = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-radio-9-5-1",
  defaultProps: { checked: !1, disabled: !1, focusable: !0, hitArea: "content", invalid: !1, required: !1 },
  defineCustomElement: defineCustomElement$6
}), CosmosRadioGroup = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-radio-group-9-5-1",
  defaultProps: { invalid: !1 },
  defineCustomElement: defineCustomElement$5
}), CosmosSpinner = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-spinner-9-5-1",
  defaultProps: {},
  defineCustomElement: defineCustomElement$4
}), CosmosText = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-text-9-5-1",
  defaultProps: { kind: "normal", size: "medium", spacing: "none", tag: "p", weight: "regular" },
  defineCustomElement: defineCustomElement$3
}), CosmosTitle = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-title-9-5-1",
  defaultProps: { kind: "normal", size: "medium", spacing: "none", tag: "p", weight: "bold" },
  defineCustomElement: defineCustomElement$2
}), CosmosTooltip = /* @__PURE__ */ createPreactComponent({
  tagName: "cosmos-tooltip-9-5-1",
  defaultProps: { content: "", controlled: !1, follow: !1, offset: 8, placement: "above", spacing: "tight", unreachable: !1, visible: !1 },
  defineCustomElement
}), ControlsButtonInternal = ({
  Icon: re,
  dataAttribute: te,
  disabled: ee = !1,
  label: ie,
  onPointerUp: ne,
  onTooltipUpdate: ae,
  size: ue,
  tooltipText: _e,
  shape: fe = "circle",
  appearance: le,
  kind: se = "bare",
  buttonLabel: oe,
  style: ce = ""
}, he) => {
  const ge = _$1(), ve = F$1(() => ({
    focus() {
      ge.current.base.buttonFocus().catch((pe) => console.error("Could not set focus on CosmosButton", pe));
    }
  }), [ge]);
  A$1(he, () => ve, [ve]);
  const me = T$1(
    (be) => {
      !ee && be.key === KEYCODE_ENTER && ne(be);
    },
    [ee, ne]
  );
  return /* @__PURE__ */ Cn.createElement(
    CosmosButton,
    {
      style: ce,
      [te]: !0,
      ref: ge,
      "data-rbup-button": !0,
      "data-rbup": te,
      disabled: ee,
      appearance: le,
      ariaLabel: ie,
      kind: se,
      shape: fe,
      size: ue ?? "medium",
      onPointerup: (be) => {
        !ee && (isLeftClick(be) || isTouch(be)) && ne(be);
      },
      onPointerEnter: (be) => {
        _e && ae && ae(_e, be);
      },
      onKeyPress: me
    },
    re,
    oe
  );
}, ControlsButton = k(ControlsButtonInternal);
function isIosDevice() {
  return /(?:iPhone|iPad|iPod)/.test(window.navigator.userAgent) ? !0 : window.navigator.maxTouchPoints >= 3;
}
function isLiveLinearResolver(re) {
  var te;
  return (re == null ? void 0 : re.getPlaybackMode()) === "LIVE" && ((te = re.getLiveVariant) == null ? void 0 : te.call(re)) === "LINEAR";
}
function isLiveDvrResolver(re) {
  var te;
  return (re == null ? void 0 : re.getPlaybackMode()) === "LIVE" && ((te = re.getLiveVariant) == null ? void 0 : te.call(re)) === "DVR";
}
function isVideoDataAccessor(re) {
  return re.getPlayerType() === "VIDEO";
}
function calculateTimeCorrectionForLinearSeeking(re) {
  const { eventPlaybackPosition: te, existingTimeCorrection: ee, lastPlaybackPosition: ie, playbackPositionCalculator: ne } = re, ue = ne(te) - ie;
  return ee + ue;
}
function formatPos(re) {
  if (!re)
    return "0";
  const te = re < 0, ee = Math.floor(Math.abs(re)), ie = String(ee);
  return te ? `-${ie}` : ie;
}
const log$h = loglevelExports.getLogger("TrackingService");
function validateVideoPos(re, te, ee) {
  return (re < 0 || re > te) && log$h.error(
    "videoPos",
    re,
    " exceeds bounds for reporting interval",
    te,
    "for event",
    ee
  ), Math.max(0, Math.min(te, Math.round(re)));
}
function getEofTrackingEvent(re, te, ee, ie, ne, ae) {
  return {
    event: ae.trackingEventType,
    eventAction: "eof",
    event_name: ae.eventName,
    current_pos: formatPos(ee),
    media_id: re.assetId,
    player_mode: ae.playerMode,
    video_audio_language: ae.audioLanguage,
    video_subtitles_language: ae.subtitleLanguage,
    video_stream_type: ae.videoStreamType,
    video_pos: validateVideoPos(ie, ne, "eof")
  };
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let re = 0; re < 256; ++re)
  byteToHex.push((re + 256).toString(16).slice(1));
function unsafeStringify(re, te = 0) {
  return (byteToHex[re[te + 0]] + byteToHex[re[te + 1]] + byteToHex[re[te + 2]] + byteToHex[re[te + 3]] + "-" + byteToHex[re[te + 4]] + byteToHex[re[te + 5]] + "-" + byteToHex[re[te + 6]] + byteToHex[re[te + 7]] + "-" + byteToHex[re[te + 8]] + byteToHex[re[te + 9]] + "-" + byteToHex[re[te + 10]] + byteToHex[re[te + 11]] + byteToHex[re[te + 12]] + byteToHex[re[te + 13]] + byteToHex[re[te + 14]] + byteToHex[re[te + 15]]).toLowerCase();
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = {
  randomUUID
};
function v4(re, te, ee) {
  if (native.randomUUID && !te && !re)
    return native.randomUUID();
  re = re || {};
  const ie = re.random || (re.rng || rng)();
  if (ie[6] = ie[6] & 15 | 64, ie[8] = ie[8] & 63 | 128, te) {
    ee = ee || 0;
    for (let ne = 0; ne < 16; ++ne)
      te[ee + ne] = ie[ne];
    return te;
  }
  return unsafeStringify(ie);
}
const CORE_VERSION = "19.17.1";
function calculateEmbedUrl(re) {
  const te = new URL(re);
  return `${te.protocol}//${te.host}${te.pathname}`;
}
function isVideoPlayerConfig(re) {
  return re.configurationType === "VIDEO";
}
function isVideoPlayerMetadata(re, te) {
  return isVideoPlayerConfig(re);
}
function isAudioPlayerMetadata(re, te) {
  return te ? !isVideoPlayerConfig(re) : !1;
}
function calculateTrackingHostname(re) {
  return new URL(re).host;
}
function calculateVideoTrackingInitEvent(re, te, ee, ie, ne, ae) {
  const ue = re.tracking.configs.googleAnalytics, _e = ne.getPlaybackMode(), fe = (te == null ? void 0 : te.duration) ?? 0, le = calculateTrackingHostname(ee);
  return {
    ...ue.customInitAttributes,
    video_account_name: ue.accountName,
    brand: ue.brand,
    video_chapter: te == null ? void 0 : te.chapter,
    video_name: te == null ? void 0 : te.title,
    video_display_url: ee,
    environment: ie ? "on-site" : "off-site",
    event: "rbVideoTracking",
    eventAction: "init",
    event_name: "video_init",
    video_display_domain: le,
    video_stream: ae.isStream,
    video_autoplay: re.autoplay,
    video_label: te == null ? void 0 : te.label,
    video_label_group: te == null ? void 0 : te.labelGroup,
    media_asset_id: te == null ? void 0 : te.vin,
    media_id: re.assetId,
    device_platform: "web",
    video_player_id: ue.playerId,
    player_mode: ae.playerMode,
    property_name: ue.propertyName,
    site_type: "website",
    video_season: te == null ? void 0 : te.season,
    rb_source: ue.source,
    player_version: CORE_VERSION,
    video_asset_id: re.assetId,
    video_length: _e === "LIVE" ? 0 : fe,
    video_play_id: v4(),
    video_stream_type: ae.videoStreamType
  };
}
function calculateAudioTrackingInitEvent(re, te, ee, ie, ne, ae) {
  const ue = re.tracking.configs.googleAnalytics, _e = ee.getDurationInSec(), fe = calculateTrackingHostname(ie);
  return {
    ...ue.customInitAttributes,
    video_account_name: ue.accountName,
    brand: ue.brand,
    video_name: te == null ? void 0 : te.title,
    video_display_url: ie,
    environment: ne ? "on-site" : "off-site",
    event: "rbAudioTracking",
    eventAction: "init",
    event_name: "audio_init",
    video_display_domain: fe,
    video_stream: ae.isStream,
    video_autoplay: !1,
    media_asset_id: te == null ? void 0 : te.vin,
    media_id: re.assetId,
    device_platform: "web",
    video_player_id: ue.playerId,
    player_mode: ae.playerMode,
    property_name: ue.propertyName,
    site_type: "website",
    rb_source: ue.source,
    spreaker_id: te == null ? void 0 : te.spreakerId,
    megaphone_episode_id: te == null ? void 0 : te.megaphoneEpisodeId,
    megaphone_network_id: te == null ? void 0 : te.megaphoneNetworkId,
    megaphone_show_id: te == null ? void 0 : te.megaphoneShowId,
    player_version: CORE_VERSION,
    video_asset_id: re.assetId,
    video_chapter: te == null ? void 0 : te.chapter,
    video_label: te == null ? void 0 : te.label,
    video_label_group: te == null ? void 0 : te.labelGroup,
    video_length: isNaN(_e) ? (te == null ? void 0 : te.duration) ?? 0 : _e,
    video_play_id: v4(),
    video_season: te == null ? void 0 : te.season,
    video_stream_type: ae.videoStreamType
  };
}
function getFinalEmbedUrl() {
  return window.self !== window.top ? document.referrer : window.location.href;
}
function getInitTrackingEvent(re, te, ee, ie, ne) {
  const ae = re.tracking.configs.googleAnalytics.overrideEmbedUrl ?? getFinalEmbedUrl(), ue = calculateEmbedUrl(ae);
  if (isVideoPlayerConfig(re) && (isVideoPlayerMetadata(re) || !te))
    return calculateVideoTrackingInitEvent(re, te, ue, ie, ee, ne);
  if (!isVideoPlayerConfig(re) && (isAudioPlayerMetadata(re, te) || !te))
    return calculateAudioTrackingInitEvent(re, te, ee, ue, ie, ne);
  throw new Error("unexpected player config");
}
function getNextEpisodeTrackingEvent(re, te, ee, ie) {
  const ne = te === "USER" ? "Click" : "Auto";
  return {
    event: "rbAudioTracking",
    event_name: ie.eventName,
    video_interaction: {
      value: "Next Up",
      method: ne,
      video_name: re.title,
      media_id: ee,
      device_platform: "web",
      widget_type: "Audio Playlist"
    }
  };
}
function getNextUpToastTrackingEvent(re, te, ee) {
  return {
    event: "rbVideoTracking",
    event_name: "video_interaction",
    video_interaction: {
      value: "Next Up",
      method: te,
      video_name: re.title,
      media_id: ee,
      device_platform: "web",
      widget_type: "Next Up Bar"
    }
  };
}
function getPauseTrackingEvent(re, te, ee, ie, ne, ae) {
  return {
    current_pos: formatPos(ee),
    event: ae.trackingEventType,
    eventAction: "pause",
    event_name: ae.eventName,
    video_audio_language: ae.audioLanguage,
    video_subtitles_language: ae.subtitleLanguage,
    media_id: re.assetId,
    player_mode: ae.playerMode,
    video_stream_type: ae.videoStreamType,
    video_pos: validateVideoPos(ie, ne, "pause")
  };
}
function mapAdType(re) {
  switch (re) {
    case "PRE_ROLL":
      return "pre";
    case "MID_ROLL":
      return "mid";
    case "POST_ROLL":
      return "post";
    default:
      throw new Error(`unexpected ad type ${re}`);
  }
}
const VALUE_NOT_AVAILABLE = "not available";
function getAdLength(re) {
  return re > 1 ? re : VALUE_NOT_AVAILABLE;
}
function getAdPos(re, te) {
  return re === "pre" ? 0 : te;
}
function getPlayAdTrackingEvent(re, te, ee, ie, ne, ae, ue) {
  const _e = mapAdType(re.adType);
  return {
    ad_length: getAdLength(re.duration),
    ad_plays: 1,
    ad_position: getAdPos(_e, ee.getLastMainMediaPositionInSec()),
    ad_type: _e,
    current_pos: formatPos(ie),
    event: ue.trackingEventType,
    video_audio_language: void 0,
    video_subtitles_language: void 0,
    eventAction: "playAd",
    event_name: ue.eventName,
    media_id: te.assetId,
    video_stream_type: ue.videoStreamType,
    player_mode: ue.playerMode,
    video_pos: validateVideoPos(ne, ae, "playAd")
  };
}
function getPlayInitialTrackingEvent(re, te, ee, ie) {
  return {
    video_audio_language: ie.audioLanguage,
    current_pos: formatPos(te),
    event: ie.trackingEventType,
    eventAction: "playInitial",
    event_name: ie.eventName,
    media_id: re.assetId,
    player_mode: ie.playerMode,
    video_subtitles_language: ie.subtitleLanguage,
    video_plays: 1,
    video_stream_type: ie.videoStreamType,
    video_pos: 0
  };
}
function getPlayTrackingEvent(re, te, ee, ie, ne, ae) {
  return {
    current_pos: formatPos(ee),
    media_id: re.assetId,
    player_mode: ae.playerMode,
    event: ae.trackingEventType,
    eventAction: "play",
    video_audio_language: ae.audioLanguage,
    video_subtitles_language: ae.subtitleLanguage,
    video_stream_type: ae.videoStreamType,
    event_name: ae.eventName,
    video_pos: validateVideoPos(ie, ne, "play")
  };
}
function getPodcastTitleTrackingEvent(re, te, ee, ie) {
  return {
    event: "rbAudioTracking",
    event_name: ie.eventName,
    video_interaction: {
      value: te,
      video_name: re.title,
      media_id: ee,
      device_platform: "web",
      widget_type: "Podcast player::inline"
    }
  };
}
function getPosRelativeTrackingEvent(re, te, ee, ie, ne, ae, ue) {
  return {
    eventAction: "posRelative",
    event_name: ue.eventName,
    event: ue.trackingEventType,
    current_pos: formatPos(te),
    video_audio_language: ue.audioLanguage,
    video_subtitles_language: ue.subtitleLanguage,
    player_mode: ue.playerMode,
    video_posrelative: ie,
    media_id: re.assetId,
    video_stream_type: ue.videoStreamType,
    video_pos: validateVideoPos(ne, ae, "posRelative")
  };
}
function getPosTrackingEvent(re, te, ee, ie, ne, ae) {
  return {
    eventAction: "pos",
    event_name: ae.eventName,
    event: ae.trackingEventType,
    video_audio_language: ae.audioLanguage,
    video_subtitles_language: ae.subtitleLanguage,
    current_pos: formatPos(te),
    player_mode: ae.playerMode,
    media_id: re.assetId,
    video_stream_type: ae.videoStreamType,
    video_pos: validateVideoPos(ie, ne, "pos")
  };
}
function getSeekTrackingEvent(re, te, ee, ie, ne, ae) {
  return {
    eventAction: "seek",
    event_name: ae.eventName,
    event: ae.trackingEventType,
    current_pos: formatPos(te),
    player_mode: ae.playerMode,
    media_id: re.assetId,
    video_audio_language: ae.audioLanguage,
    video_subtitles_language: ae.subtitleLanguage,
    video_stream_type: ae.videoStreamType,
    video_pos: validateVideoPos(ie, ne, "seek")
  };
}
const stopEventAction = "stop";
function getStopTrackingEvent(re, te, ee, ie, ne, ae) {
  if (!ne)
    throw new Error("unexpectedly dont have player config");
  if (!ae)
    throw new Error("unexpectedly dont have player data accessor");
  return {
    current_pos: formatPos(re),
    event: ie.trackingEventType,
    eventAction: stopEventAction,
    event_name: ie.eventName,
    media_id: ne.assetId,
    video_audio_language: ie.audioLanguage,
    video_subtitles_language: ie.subtitleLanguage,
    player_mode: ie.playerMode,
    video_pos: validateVideoPos(te, ee, "stop"),
    video_stream_type: ie.videoStreamType
  };
}
async function reportClientError(re, te) {
  const ee = `${calculateSsdmUrl(te)}/client-error`, ie = JSON.stringify({ message: re, href: "location" in window && location.href });
  await fetch(ee, { body: ie, method: "POST", headers: { "content-type": "application/json" } });
}
function isInitTrackingEvent(re) {
  return re.eventAction === "init";
}
function isUserInteractionTrackingEvent(re) {
  return re.event_name === "video_interaction";
}
function serializeValue(re) {
  return typeof re == "boolean" ? re.toString() : re;
}
function serializeEvent(re) {
  return isInitTrackingEvent(re) ? serializeInitEvent(re) : isUserInteractionTrackingEvent(re) ? serializeUserInteractionTrackingEvent(re) : serializeTrackingEvent(re);
}
const initEventAttributesAtRootLevel = [
  "event",
  "eventAction",
  "event_name",
  "player_mode",
  "video_stream_type"
];
function serializeInitEvent(re) {
  const te = {}, ee = {};
  for (const [ie, ne] of Object.entries(re))
    initEventAttributesAtRootLevel.includes(ie) ? te[ie] = ne : ee[ie] = serializeValue(ne), ie === "video_stream_type" && (ee[ie] = ne);
  return Object.keys(ee).length > 0 && (te.videos = { [re.media_id]: ee }), te;
}
function serializeUserInteractionTrackingEvent(re) {
  const te = {}, ee = {};
  te.event = re.event, te.event_name = re.event_name;
  for (const [ie, ne] of Object.entries(re.video_interaction))
    ee[ie] = serializeValue(ne);
  return te.video_interaction = ee, te;
}
function serializeTrackingEvent(re) {
  const te = {};
  for (const [ee, ie] of Object.entries(re))
    te[ee] = serializeValue(ie);
  return te;
}
function DataAccessorResolver(re) {
  if (!re)
    throw new Error("unexpectedly dont have player data accessor");
  return re;
}
function VideoAudioLanguageResolver(re) {
  if (!isVideoDataAccessor(re))
    return;
  const te = re.getAudioLanguage();
  return te || "und";
}
class EventAdapter {
  execute({ log: te, event: ee, eventTypeDetail: ie }) {
    const ne = this.resolveState(ee, ie);
    return te.debug(this.name, ne), ne;
  }
}
const Ut = class Ut extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "audioLanguage");
    Et(this, "coordinator");
    Et(this, "name", "AudioLanguageAdapter");
    this.audioLanguage = Ut.UNDEFINED_AUDIO_LANGUAGE, this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ie = DataAccessorResolver(ee);
    return this.audioLanguage = VideoAudioLanguageResolver(ie), { audioLanguage: this.audioLanguage };
  }
};
Et(Ut, "UNDEFINED_AUDIO_LANGUAGE", "und");
let AudioLanguageAdapter = Ut;
class DurationAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "durationInSec");
    Et(this, "coordinator");
    Et(this, "name", "DurationAdapter");
    this.durationInSec = 0, this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ne = DataAccessorResolver(ee).getMainMediaDurationInSec();
    return this.durationInSec = isNaN(ne) ? this.durationInSec : ne, { durationInSec: this.durationInSec };
  }
}
function EventActionResolver({ type: re }, te) {
  return {
    adStarted: "playAd",
    playbackFinished: "eof",
    play: "play",
    paused: "pause",
    sourceUnloaded: "stop",
    posRelative: "posRelative",
    playInitial: "playInitial",
    seeking: "seek",
    timeshifting: "seek",
    pos: "pos",
    beforePlay: "init",
    loaded: "init",
    podcastTitleClick: "interaction",
    nextEpisodeTriggered: "interaction"
  }[te ?? re];
}
function EventNameResolver(re, te) {
  const ee = re.toLowerCase(), ie = te.toLowerCase();
  return `${ee}_${ie}`;
}
class EventNameAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "coordinator");
    Et(this, "eventName");
    Et(this, "name", "EventNameAdapter");
    this.coordinator = ee;
  }
  resolveState(ee, ie) {
    const ne = this.coordinator.getPlayerData(), ae = DataAccessorResolver(ne), ue = ie ? EventActionResolver(ee, ie) : EventActionResolver(ee);
    return ue && (this.eventName = EventNameResolver(ae.getPlayerType(), ue)), { eventName: this.eventName };
  }
}
function VideoIsStreamResolver(re) {
  const { phasingEnabled: te, playbackMode: ee, isPlayerLoaded: ie } = re;
  return te ? !0 : ie ? ee === "LIVE" : !1;
}
class IsStreamAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "isStream", !1);
    Et(this, "coordinator");
    Et(this, "name", "IsStreamAdapter");
    this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ie = DataAccessorResolver(ee), ne = this.coordinator.getPlayerConfiguration(), ae = ne && isVideoPlayerConfig(ne) ? ne.phasing : !1, ue = ie.getPlaybackMode(), _e = ie.isPlayerLoaded();
    return this.isStream = VideoIsStreamResolver({ phasingEnabled: ae, playbackMode: ue, isPlayerLoaded: _e }), { isStream: this.isStream };
  }
}
function PlayerModeResolver(re, te) {
  if (!re)
    throw new Error("unexpectedly dont have player configuration");
  if (isVideoDataAccessor(te)) {
    if (te.isInFullscreenMode())
      return "fullscreen";
    if (te.isInPictureInPictureMode())
      return "picture-in-picture";
    if (te.isPlayingVideoViaAirPlay())
      return "airplay";
  }
  return re.tracking.configs.googleAnalytics.defaultPlayerMode;
}
class PlayerModeAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "playerMode", "standard");
    Et(this, "coordinator");
    Et(this, "name", "PlayerModeAdapter");
    this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ie = DataAccessorResolver(ee), ne = this.coordinator.getPlayerConfiguration();
    return this.playerMode = PlayerModeResolver(ne, ie), { playerMode: this.playerMode };
  }
}
function VideoSubtitleLanguageResolver(re) {
  if (!isVideoDataAccessor(re))
    return;
  const te = re.getSubtitleTrackLanguage();
  if (te)
    return te;
}
class SubtitleLanguageAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "subtitleLanguage");
    Et(this, "coordinator");
    Et(this, "name", "SubtitleLanguageAdapter");
    this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ie = DataAccessorResolver(ee);
    return this.subtitleLanguage = VideoSubtitleLanguageResolver(ie), { subtitleLanguage: this.subtitleLanguage };
  }
}
function TrackingEventTypeResolver(re) {
  switch (re.getPlayerType()) {
    case "VIDEO":
      return "rbVideoTracking";
    case "AUDIO":
      return "rbAudioTracking";
    default:
      throw new Error(`unknown player type ${re.getPlayerType()}`);
  }
}
class TrackingEventTypeAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "trackingEventType");
    Et(this, "coordinator");
    Et(this, "name", "TrackingEventTypeAdapter");
    this.coordinator = ee;
  }
  resolveState() {
    if (!this.trackingEventType) {
      const ee = this.coordinator.getPlayerData(), ie = DataAccessorResolver(ee);
      this.trackingEventType = TrackingEventTypeResolver(ie);
    }
    return { trackingEventType: this.trackingEventType };
  }
}
function VideoStreamTypeResolver(re) {
  if (!isVideoDataAccessor(re))
    return "vod";
  const te = re.getPlaybackMode();
  switch (te) {
    case "LIVE":
      return re.getLiveVariant() === "LINEAR" ? "linear" : re.getTimeShiftInSec() >= -1 ? "live" : "vod";
    case "VOD":
      return "vod";
    default:
      throw new Error(`unexpected playback mode ${te}`);
  }
}
class VideoStreamTypeAdapter extends EventAdapter {
  constructor(ee) {
    super();
    Et(this, "videoStreamType");
    Et(this, "coordinator");
    Et(this, "name", "VideoStreamTypeAdapter");
    this.videoStreamType = "vod", this.coordinator = ee;
  }
  resolveState() {
    const ee = this.coordinator.getPlayerData(), ie = DataAccessorResolver(ee);
    return this.videoStreamType = VideoStreamTypeResolver(ie), { videoStreamType: this.videoStreamType };
  }
}
const ADAPTER_LIST = [
  AudioLanguageAdapter,
  DurationAdapter,
  IsStreamAdapter,
  EventNameAdapter,
  PlayerModeAdapter,
  SubtitleLanguageAdapter,
  TrackingEventTypeAdapter,
  VideoStreamTypeAdapter
], getAdapterList = () => ADAPTER_LIST, log$g = loglevelExports.getLogger("TrackingServiceStateLayer");
class TrackingServiceStateLayer {
  constructor(te) {
    Et(this, "instantiatedAdapters");
    this.instantiatedAdapters = getAdapterList().map((ee) => new ee(te));
  }
  getUpdatedState(te, ee) {
    const ie = this.instantiatedAdapters.reduce((ne, ae) => ({ ...ne, ...ae.execute({ event: te, log: log$g, eventTypeDetail: ee }) }), {});
    return log$g.info(`Resolved state for ${te == null ? void 0 : te.type}`, ie), ie;
  }
}
const log$f = loglevelExports.getLogger("TrackingService"), genericTrackingEventTypes = ["rbVideoTracking", "rbAudioTracking"], windowEventTypes = ["beforeunload", "unload"];
function isGenericTrackingEvent(re) {
  return genericTrackingEventTypes.includes(re.event);
}
function getIntervalFraction(re, te) {
  return Math.floor(re / te);
}
const REPORT_INTERVAL = 60;
class TrackingService {
  constructor(te, ee = window.dataLayer) {
    Et(this, "eventStream", []);
    Et(this, "lastPlaybackPosition", 0);
    Et(this, "videoStartTimestamp", 0);
    Et(this, "timeCorrection", 0);
    Et(this, "playbackPositionOfPauseOrPlayEvent", 0);
    Et(this, "lastTimeChangedPlaybackPosition", 0);
    Et(this, "stateLayer");
    Et(this, "onPlayerEvent", (te) => {
      const ee = this.coordinator.getPlayerConfiguration(), ie = this.coordinator.getPlayerData();
      if (!ee)
        throw new Error("unexpectedly dont have player config");
      if (!ie)
        throw new Error("unexpectedly dont have video player data accessor");
      const ne = isVideoDataAccessor(ie) && ie.isShowingAd(), ae = this.stateLayer.getUpdatedState(te);
      if (log$f.debug("onPlayerEvent: ", te, ae), ne) {
        this.handlePlayerEventWhileShowingAd(te, ee, ie, ae);
        return;
      }
      this.handlePlayerEventWithoutAd(te, ee, ie, ae), this.handleCustomEvent(te, ie, ae);
    });
    Et(this, "handleUnloadEvent", () => {
      windowEventTypes.forEach((fe) => window.removeEventListener(fe, this.handleUnloadEvent));
      const te = this.coordinator.getPlayerConfiguration(), ee = this.coordinator.getPlayerData(), ie = (ee == null ? void 0 : ee.getCurrentTimeInSec()) ?? 0, ne = this.calculateCorrectedPlaybackPosition(this.lastTimeChangedPlaybackPosition), ae = this.stateLayer.getUpdatedState({ type: "sourceUnloaded", playerId: "" }), ue = this.calculateVideoPos(ne), _e = getStopTrackingEvent(
        ie,
        ue,
        REPORT_INTERVAL,
        ae,
        te,
        ee
      );
      this.sendEvent(_e, ie);
    });
    this.coordinator = te, this.dataLayer = ee, te.addEventListener(this.onPlayerEvent), windowEventTypes.forEach((ie) => window.addEventListener(ie, this.handleUnloadEvent)), this.stateLayer = new TrackingServiceStateLayer(te);
  }
  hasSentEventAction(te) {
    return !!this.eventStream.find((ee) => isGenericTrackingEvent(ee.event) && ee.event.eventAction === te);
  }
  destroy() {
    this.coordinator.removeEventListener(this.onPlayerEvent), windowEventTypes.forEach((te) => window.removeEventListener(te, this.handleUnloadEvent));
  }
  reset() {
    this.eventStream = [], this.videoStartTimestamp = 0, this.lastPlaybackPosition = 0, this.timeCorrection = 0, this.playbackPositionOfPauseOrPlayEvent = 0, this.lastTimeChangedPlaybackPosition = 0;
  }
  restart() {
    this.reset();
    const te = this.coordinator.getPlayerConfiguration();
    if (!te)
      throw new Error("dont have player config");
    const ee = this.coordinator.getMediaMetaData();
    if (!ee)
      throw new Error("dont have player metadata");
    const ie = this.coordinator.getPlayerData();
    if (!ie)
      throw new Error("unexpectedly dont have video player data accessor");
    this.sendInitEvent(te, ee, ie);
  }
  // can't make the switch simpler than that
  // eslint-disable-next-line complexity
  handlePlayerEventWithoutAd(te, ee, ie, ne) {
    switch (te.type) {
      case "loaded":
        this.handleLoadedEvent(te, ee, ie, ne);
        break;
      case "play":
        this.handlePlayEvent(te, ie, ne);
        break;
      case "playing":
        this.handlePlayingEvent(te, ie);
        break;
      case "paused":
        this.handlePausedEvent(te, ee, ie, ne);
        break;
      case "timeChanged":
        this.handleTimeChangedEvent(te, ie);
        break;
      case "timeSkipped":
        this.handleTimeSkippedEvent(te, ie);
        break;
      case "seeking":
      case "timeshifting":
        this.handleSeekingEvent(te, ie, ne);
        break;
      case "seekingDone":
      case "timeshiftingDone":
        this.handleSeekingDoneEventForStreamTypes(te, ie);
        break;
      case "playbackFinished":
        this.handlePlaybackFinishedEvent(te, ie, ne);
        break;
      case "sourceUnloaded":
        this.handleUnloadEvent();
        break;
    }
  }
  handleSeekingDoneEventForStreamTypes(te, ee) {
    isLiveLinearResolver(ee) ? this.timeCorrection = calculateTimeCorrectionForLinearSeeking({
      eventPlaybackPosition: te.playbackPosition,
      existingTimeCorrection: this.timeCorrection,
      lastPlaybackPosition: this.lastPlaybackPosition,
      playbackPositionCalculator: (ne) => this.calculateCorrectedPlaybackPosition(ne)
    }) : this.handleSeekingDoneEvent(te, ee);
  }
  handlePlayerEventWhileShowingAd(te, ee, ie, ne) {
    switch (te.type) {
      case "loaded":
        this.handleLoadedEvent(te, ee, ie, ne);
        break;
      case "adStarted":
        this.handleAdStartedEvent(te, ee, ie, ne);
        break;
    }
  }
  handleCustomEvent(te, ee, ie) {
    switch (te.type) {
      case "nextUpCancelled":
        this.handleNextUpToastEvent(te, "Close", ee);
        break;
      case "nextUpClicked":
        this.handleNextUpToastEvent(te, "Click", ee), this.handleUnloadEvent();
        break;
      case "nextUpTimeout":
        this.handleNextUpToastEvent(te, "Auto", ee), this.handleUnloadEvent();
        break;
      case "podcastTitleClick":
        this.handlePodcastTitleClickEvent(te, ee, ie);
        break;
      case "nextEpisodeTriggered":
        this.handleNextEpisodeEvent(te, ee, ie);
        break;
    }
  }
  handlePodcastTitleClickEvent(te, ee, ie) {
    const ne = this.coordinator.getPlayerConfiguration();
    if (!ne)
      throw new Error("dont have player config");
    const ae = ee.getCurrentTimeInSec(), ue = this.coordinator.getMediaMetaData();
    if (!ue)
      throw new Error("dont have player metadata");
    this.sendEvent(
      getPodcastTitleTrackingEvent(ue, te.titleType, ne.assetId, ie),
      ae
    );
  }
  handleNextUpToastEvent(te, ee, ie) {
    if (te.issuer === "CONTEXTUAL")
      return;
    const ne = this.coordinator.getPlayerConfiguration();
    if (!ne)
      throw new Error("dont have player config");
    const ae = ie.getCurrentTimeInSec(), ue = this.coordinator.getMediaMetaData();
    if (!ue)
      throw new Error("dont have player metadata");
    this.sendEvent(
      getNextUpToastTrackingEvent(ue, ee, ne.assetId),
      ae
    );
  }
  handlePlaybackFinishedEvent(te, ee, ie) {
    const ne = this.calculateCorrectedPlaybackPosition(te.playbackPosition), ae = this.coordinator.getPlayerConfiguration();
    if (!ae)
      throw new Error("dont have player config");
    const ue = this.calculateVideoPos(ne);
    this.sendEvent(
      getEofTrackingEvent(
        ae,
        ee,
        ne,
        ue,
        REPORT_INTERVAL,
        ie
      ),
      ne
    );
  }
  handleNextEpisodeEvent(te, ee, ie) {
    const ne = this.coordinator.getPlayerConfiguration();
    if (!ne)
      throw new Error("dont have player config");
    const ae = ee.getCurrentTimeInSec(), ue = this.coordinator.getMediaMetaData();
    if (!ue)
      throw new Error("dont have player metadata");
    const { issuer: _e } = te, { assetId: fe } = ne;
    this.sendEvent(getNextEpisodeTrackingEvent(ue, _e, fe, ie), ae), _e === "USER" && this.handleUnloadEvent();
  }
  handleSeekingDoneEvent(te, ee) {
    if (te.issuer !== "USER")
      return;
    const ie = this.coordinator.getPlayerConfiguration();
    if (!ie)
      throw new Error("dont have player config");
    const ne = this.calculateCorrectedPlaybackPosition(te.playbackPosition);
    if (ee.getPlayerStatus() === "PAUSED") {
      const ue = this.stateLayer.getUpdatedState(te, "paused");
      this.sendEvent(
        getPauseTrackingEvent(
          ie,
          ee,
          ne,
          0,
          REPORT_INTERVAL,
          ue
        ),
        ne
      );
    } else {
      const ue = this.stateLayer.getUpdatedState(te, "play");
      this.sendEvent(
        getPlayTrackingEvent(
          ie,
          ee,
          ne,
          0,
          REPORT_INTERVAL,
          ue
        ),
        ne
      );
    }
    this.lastPlaybackPosition = ne;
  }
  handleSeekingEvent(te, ee, ie) {
    if (te.issuer === "RESTART") {
      this.restart();
      return;
    }
    const ne = te.targetPosition;
    te.issuer === "INITIAL" && (this.lastPlaybackPosition = ne), ee.getPlaybackMode() === "LIVE" && this.lastPlaybackPosition === 0 && (this.videoStartTimestamp = te.playbackPosition, this.lastPlaybackPosition = this.calculateCorrectedPlaybackPosition(te.playbackPosition));
    const ae = this.calculateCorrectedPlaybackPosition(te.playbackPosition);
    if (te.issuer !== "USER")
      return;
    const ue = this.stateLayer.getUpdatedState(te, "playInitial");
    this.handleTimeChangedForPlayInitial(ae + 0.1, ee, ue);
    const _e = this.calculateVideoPos(ae), fe = this.coordinator.getPlayerConfiguration();
    if (!fe)
      throw new Error("dont have player config");
    this.sendEvent(
      getSeekTrackingEvent(
        fe,
        ae,
        ee,
        _e,
        REPORT_INTERVAL,
        ie
      ),
      ae
    ), this.playbackPositionOfPauseOrPlayEvent = 0;
  }
  handleTimeSkippedEvent(te, ee) {
    var ne;
    if (isVideoDataAccessor(ee) && ee.getPlaybackMode() === "LIVE" && !ee.isShowingAd()) {
      const ae = te.currentPlaybackTimeInSec - te.previousPlaybackTimeInSec;
      this.timeCorrection += ae, this.lastPlaybackPosition = this.calculateCorrectedPlaybackPosition(
        te.currentPlaybackTimeInSec
      );
    }
    const ie = (ne = this.coordinator.getPlayerConfiguration()) == null ? void 0 : ne.environment;
    ie && reportClientError("TimeSkippedEvent detected", ie);
  }
  handleTimeChangedEvent(te, ee) {
    ee.getPlaybackMode() === "LIVE" && this.videoStartTimestamp === 0 && (this.videoStartTimestamp = te.playbackPosition), this.lastTimeChangedPlaybackPosition = te.playbackPosition;
    const ie = this.calculateCorrectedPlaybackPosition(te.playbackPosition), ne = this.coordinator.getCumulatedPlayTimeInSec();
    log$f.debug(
      "TRACK timeChanged",
      ie,
      "cumulated",
      ne,
      "corr",
      this.timeCorrection
    );
    let ae;
    ae = this.stateLayer.getUpdatedState(te, "playInitial"), this.handleTimeChangedForPlayInitial(ie, ee, ae);
    const ue = this.lastPlaybackPosition;
    ee.getPlaybackMode() === "VOD" && (ae = this.stateLayer.getUpdatedState(te, "posRelative"), this.handlePosRelativeAspect(ue, ie, ee, ae)), ae = this.stateLayer.getUpdatedState(te, "pos"), this.handlePosAspect(ue, ie, ee, ae), this.lastPlaybackPosition = ie;
  }
  handleTimeChangedForPlayInitial(te, ee, ie) {
    const ne = this.hasSentEventAction("playInitial");
    if (te >= 0.1 && !ne) {
      const ae = this.coordinator.getPlayerConfiguration();
      if (!ae)
        throw new Error("dont have player config");
      const ue = getPlayInitialTrackingEvent(ae, te, ee, ie);
      this.sendEvent(ue, te);
    }
  }
  handlePosAspect(te, ee, ie, ne) {
    const ae = getIntervalFraction(te, REPORT_INTERVAL), ue = getIntervalFraction(ee, REPORT_INTERVAL);
    if (ae !== ue) {
      log$f.debug(
        `TRACK: ${REPORT_INTERVAL}s changed, last frac: ${ae}, cur frac: ${ue}, playback: ${ee}s`
      );
      const _e = this.calculateVideoPos(ee), fe = this.coordinator.getPlayerConfiguration();
      if (!fe)
        throw new Error("dont have player config");
      this.sendEvent(
        getPosTrackingEvent(
          fe,
          ee,
          ie,
          _e,
          REPORT_INTERVAL,
          ne
        ),
        ee
      );
    }
  }
  calculateVideoPos(te) {
    if (this.eventStream.length < 1)
      return 0;
    const ee = [...this.eventStream].reverse().find((ue) => ue.event.hasOwnProperty("video_pos")), ie = Math.floor((ee == null ? void 0 : ee.playbackPosInSec) ?? 0), ae = (isNaN(te) ? 0 : Math.floor(te)) - ie;
    return ae < 0 && log$f.error("videoPos is < 0", ae), Math.max(0, ae);
  }
  handlePosRelativeAspect(te, ee, ie, ne) {
    const ae = ne.durationInSec / 10, ue = Math.floor(te / ae), _e = Math.floor(ee / ae);
    if (_e % 10 !== 0 && ue !== _e) {
      log$f.debug(
        "TRACK: 10 percent changed, last frac: ",
        ue,
        "cur frac",
        _e,
        "playback",
        ee / ne.durationInSec * 100,
        "%"
      );
      const le = this.calculateVideoPos(ee), se = this.coordinator.getPlayerConfiguration();
      if (!se)
        throw new Error("dont have player config");
      this.sendEvent(
        getPosRelativeTrackingEvent(
          se,
          ee,
          ie,
          `${_e}0%`,
          le,
          REPORT_INTERVAL,
          ne
        ),
        ee
      );
    }
  }
  handlePlayingEvent(te, ee) {
    if (ee.getPlaybackMode() === "LIVE")
      if (this.lastPlaybackPosition === 0)
        this.videoStartTimestamp = te.playbackPosition, this.lastPlaybackPosition = this.calculateCorrectedPlaybackPosition(
          te.playbackPosition
        );
      else {
        if (this.playbackPositionOfPauseOrPlayEvent) {
          const ie = te.playbackPosition - this.playbackPositionOfPauseOrPlayEvent;
          this.timeCorrection += ie;
        }
        this.lastPlaybackPosition = this.calculateCorrectedPlaybackPosition(
          te.playbackPosition
        );
      }
    this.playbackPositionOfPauseOrPlayEvent = 0;
  }
  calculatePlaybackPositionOfPauseOrPlayEvent(te) {
    if (this.playbackPositionOfPauseOrPlayEvent) {
      const ee = te.playbackPosition - this.playbackPositionOfPauseOrPlayEvent;
      ee > 1 && (this.timeCorrection += ee, this.playbackPositionOfPauseOrPlayEvent = te.playbackPosition);
    } else
      this.playbackPositionOfPauseOrPlayEvent = te.playbackPosition;
  }
  handlePlayEvent(te, ee, ie) {
    this.calculatePlaybackPositionOfPauseOrPlayEvent(te);
    const ne = this.calculateCorrectedPlaybackPosition(te.playbackPosition), ae = this.coordinator.getPlayerConfiguration();
    if (this.hasSentEventAction("playInitial")) {
      if (!ae)
        throw new Error("dont have player config");
      const ue = this.calculateVideoPos(ne), _e = getPlayTrackingEvent(
        ae,
        ee,
        ne,
        ue,
        REPORT_INTERVAL,
        ie
      );
      this.sendEvent(_e, ne);
    }
  }
  handlePausedEvent(te, ee, ie, ne) {
    if (te.playbackPosition) {
      const ae = this.calculateCorrectedPlaybackPosition(te.playbackPosition), ue = this.calculateVideoPos(ae), _e = getPauseTrackingEvent(
        ee,
        ie,
        ae,
        ue,
        REPORT_INTERVAL,
        ne
      );
      this.sendEvent(_e, ae), this.playbackPositionOfPauseOrPlayEvent = te.playbackPosition;
    }
  }
  handleLoadedEvent(te, ee, ie, ne) {
    this.videoStartTimestamp = 0, this.lastPlaybackPosition = 0, this.timeCorrection = 0, this.playbackPositionOfPauseOrPlayEvent = 0, log$f.debug("TRACK: got duration", ne.durationInSec), this.sendInitEvent(ee, te.data, ie);
  }
  sendInitEvent(te, ee, ie) {
    var _e;
    const ne = ((_e = window.google_tag_manager) == null ? void 0 : _e.isRedBullPage) ?? !1, ae = this.stateLayer.getUpdatedState({ type: "beforePlay", playerId: "" }), ue = getInitTrackingEvent(te, ee, ie, ne, ae);
    this.sendEvent(ue, 0);
  }
  handleAdStartedEvent(te, ee, ie, ne) {
    const ae = this.calculateCorrectedPlaybackPosition(this.lastTimeChangedPlaybackPosition), ue = this.calculateVideoPos(ie.getLastMainMediaPositionInSec()), _e = getPlayAdTrackingEvent(
      te,
      ee,
      ie,
      ae,
      ue,
      REPORT_INTERVAL,
      ne
    );
    this.sendEvent(_e, ie.getLastMainMediaPositionInSec());
  }
  sendEvent(te, ee) {
    var fe;
    if (!this.dataLayer)
      throw new Error("dont have a data layer! Did you forget to initialize Google Tag Manager?");
    const ie = this.coordinator.getPlayerConfiguration();
    if (!ie)
      throw new Error("dont have player config");
    const ne = ie.tracking.configs.googleAnalytics, ae = this.coordinator.getMediaMetaData(), ue = ((fe = ne.eventCustomizer) == null ? void 0 : fe.customize(te, ae)) ?? te;
    this.eventStream.push({ playbackPosInSec: ee, event: ue });
    const _e = serializeEvent(ue);
    log$f.debug("Tracking: Sending", _e), this.dataLayer.push(_e);
  }
  calculateCorrectedPlaybackPosition(te) {
    return te - (this.videoStartTimestamp + this.timeCorrection);
  }
}
function createTrackingService(re, te = window.dataLayer) {
  var ne;
  const ee = document.querySelectorAll('script[src*="GTM-5XHDS9"]').length > 0;
  if ((((ne = window.google_tag_manager) == null ? void 0 : ne.isRedBullPage) ?? !1) || ee)
    return new TrackingService(re, te);
}
function resolveMediaMetaData(re) {
  const te = re.getMediaMetaData();
  if (!te)
    throw new Error("do not have player metadata");
  return te;
}
function resolvePlayerConfigurationData(re) {
  const te = re.getPlayerConfiguration();
  if (!te)
    throw new Error("do not have player configuration");
  return te;
}
function setMediaSessionActionHandler(re, te) {
  navigator.mediaSession.setActionHandler(re, te);
}
function setMediaSessionMetadata(re) {
  const te = re && new MediaMetadata(re);
  navigator.mediaSession.metadata = te;
}
function setMediaSessionPlaybackState(re) {
  navigator.mediaSession.playbackState = re;
}
function setMediaSessionPositionState(re, te, ee) {
  isNaN(re) || isNaN(te) || isNaN(ee) || navigator.mediaSession.setPositionState({
    duration: re,
    playbackRate: te,
    position: ee
  });
}
const log$e = loglevelExports.getLogger("MediaSessionService"), SECONDS_OF_MINUTE = 60, SECONDS_OF_HOUR = SECONDS_OF_MINUTE * SECONDS_OF_MINUTE, SECONDS_OF_DAY = 24 * SECONDS_OF_HOUR;
class MediaSessionService {
  constructor(te) {
    Et(this, "DEFAULT_MEDIA_SESSION_SEEK_SECONDS", 10);
    Et(this, "onPlayerEvent", (te) => {
      switch (te.type) {
        case "play":
          this.handlePlayEvent();
          break;
        case "paused":
          this.handlePausedEvent();
          break;
        case "timeChanged":
          this.handleTimeChangedEvent();
          break;
      }
    });
    this.coordinator = te, te.addEventListener(this.onPlayerEvent);
  }
  destroy() {
    log$e.info("destroying media-session-service"), this.coordinator.removeEventListener(this.onPlayerEvent), this.reset();
  }
  reset() {
    log$e.info("resetting media-session-service"), setMediaSessionMetadata(null), this.resetMediaSessionActionHandler();
  }
  setupMediaSessionActionHandler() {
    setMediaSessionActionHandler("play", () => {
      log$e.info("Play clicked via Media Session API"), this.coordinator.play();
    }), setMediaSessionActionHandler("pause", () => {
      log$e.info("Pause clicked via Media Session API"), this.coordinator.pause();
    }), setMediaSessionActionHandler("seekto", (te) => {
      if (this.isVOD()) {
        const ee = te.seekTime;
        log$e.info(`Seek to ${ee} via Media Session API`), ee && this.coordinator.seek(ee);
      } else if (this.isDVR()) {
        const ee = te.seekTime;
        if (log$e.info(`Shift to ${ee} via Media Session API`), ee) {
          const ie = ee - Math.abs(this.coordinator.getMaxTimeShiftInSec());
          this.coordinator.timeShift(ie);
        }
      }
    }), setMediaSessionActionHandler("seekbackward", () => {
      this.isVOD() ? (log$e.info(`Seek ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} backward`), this.coordinator.seekRelative(-this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS)) : this.isDVR() && this.coordinator.getPlayerData() && (log$e.info(`Shift ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} backward`), this.coordinator.seekOrTimeshiftRelative(-this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS));
    }), setMediaSessionActionHandler("seekforward", () => {
      this.isVOD() ? (log$e.info(`Seek ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} forward`), this.coordinator.seekRelative(this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS)) : this.isDVR() && (log$e.info(`Shift ${this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS} forward`), this.coordinator.seekOrTimeshiftRelative(this.DEFAULT_MEDIA_SESSION_SEEK_SECONDS));
    });
  }
  resetMediaSessionActionHandler() {
    setMediaSessionActionHandler("play", null), setMediaSessionActionHandler("pause", null), setMediaSessionActionHandler("seekto", null), setMediaSessionActionHandler("seekbackward", null), setMediaSessionActionHandler("seekforward", null);
  }
  handlePlayEvent() {
    const te = this.getTitle(), ee = this.getArtist(), ie = this.getAlbum(), ne = calculateMediaSessionSrcSet(this.getPosterImageUrl());
    setMediaSessionMetadata({ title: te, artist: ee, album: ie, artwork: ne }), setMediaSessionPlaybackState("playing"), this.setupMediaSessionActionHandler();
  }
  handlePausedEvent() {
    setMediaSessionPlaybackState("paused");
  }
  handleTimeChangedEvent() {
    if (this.isVOD()) {
      const te = this.coordinator.getPlayerData();
      if (te) {
        const ee = te.getDurationInSec(), ie = te.getPlaybackSpeed(), ne = te.getCurrentTimeInSec();
        setMediaSessionPositionState(ee, ie, ne);
      }
      return;
    }
    if (this.isLinear()) {
      const te = SECONDS_OF_DAY, ee = 1, ie = this.getCurrentTimeInSeconds();
      setMediaSessionPositionState(te, ee, ie);
      return;
    }
    if (this.isDVR()) {
      const te = this.coordinator.getPlayerData();
      if (te) {
        const ee = te.getCurrentTimeInSec(), ie = Math.abs(this.coordinator.getMaxTimeShiftInSec()), ne = te.getPlaybackSpeed(), ae = ie - Math.abs(ee);
        setMediaSessionPositionState(ie, ne, ae);
      }
      return;
    }
  }
  getCurrentTimeInSeconds() {
    const te = /* @__PURE__ */ new Date();
    return te.getSeconds() + te.getMinutes() * SECONDS_OF_MINUTE + te.getHours() * SECONDS_OF_HOUR;
  }
  getTitle() {
    return resolveMediaMetaData(this.coordinator).title;
  }
  getArtist() {
    return resolvePlayerConfigurationData(this.coordinator).mediaSessionArtist;
  }
  getAlbum() {
    return resolveMediaMetaData(this.coordinator).label;
  }
  getPosterImageUrl() {
    const te = resolvePlayerConfigurationData(this.coordinator), ee = resolveMediaMetaData(this.coordinator);
    return isVideoPlayerMetadata(te) ? ee.posterImageUrl : ee.coverArt;
  }
  isVOD() {
    var te;
    return ((te = this.coordinator.getPlayerData()) == null ? void 0 : te.getPlaybackMode()) === "VOD";
  }
  isLinear() {
    return isLiveLinearResolver(this.coordinator.getPlayerData());
  }
  isDVR() {
    return isLiveDvrResolver(this.coordinator.getPlayerData());
  }
}
const log$d = loglevelExports.getLogger("HookService");
class HookService {
  constructor(te) {
    this.hooks = te;
  }
  async callHookMethod(te, ee, ie, ne) {
    if (te) {
      log$d.debug("calling hook", te.name, "hook:", te);
      try {
        return await te(ee, ie, ne);
      } catch (ae) {
        log$d.error("error calling hook", te.name, "on", te, "error", ae);
      }
    }
    return ee;
  }
  async beforeLoad(te, ee, ie) {
    var ae;
    let ne = te;
    for (const ue of this.hooks)
      ne = await this.callHookMethod((ae = ue.onBeforeLoad) == null ? void 0 : ae.bind(ue), ne, ee, ie) ?? ne;
    return ne;
  }
  async afterLoad(te, ee, ie) {
    var ae;
    let ne = te;
    for (const ue of this.hooks)
      ne = await this.callHookMethod((ae = ue.onAfterLoad) == null ? void 0 : ae.bind(ue), ne, ee, ie) ?? ne;
    return ne;
  }
  async beforeDestroy(te, ee, ie) {
    var ae;
    let ne = te;
    for (const ue of this.hooks)
      ne = await this.callHookMethod(
        (ae = ue.destroy) == null ? void 0 : ae.bind(ue),
        ne ?? {},
        ee ?? {},
        ie
      );
    return ne;
  }
}
const useGetTagName = (re) => {
  var ie;
  const te = _();
  if (te.current)
    return te.current;
  const ee = (ie = re.current) == null ? void 0 : ie.getRootNode();
  if (ee && "host" in ee) {
    const ne = ee.host.tagName;
    return te.current = ne.toLocaleLowerCase(), te.current;
  }
}, logger$1 = loglevelExports.getLogger("UsageReport"), filterOutSubdomainsRegex = /^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/;
function getLocation() {
  var re, te;
  try {
    const { hostname: ee, href: ie } = window.location;
    return { platform: ((te = (re = filterOutSubdomainsRegex.exec(ee)) == null ? void 0 : re.groups) == null ? void 0 : te[1]) ?? ee, location: ie };
  } catch (ee) {
    const ie = resolveErrorMessageFromUnknown(ee);
    return logger$1.warn({ message: "failed to resolve host", error: ie }), {};
  }
}
const useReportUsage = (re, te) => {
  const ee = _(!1), ie = useGetTagName(re), { location: ne, platform: ae } = getLocation();
  if (ee.current)
    return !1;
  if (ie && ae) {
    ee.current = !0;
    const ue = calculateSsdmUrl(te ?? "PRODUCTION"), _e = {
      package: ie,
      version: CORE_VERSION,
      platform: ae,
      location: ne
    };
    return fetch(`${ue}/report-usage?${new URLSearchParams(_e)}`).then((fe) => logger$1.info({ message: "reported usage", queryParams: _e, response: fe })).catch((fe) => {
      const le = resolveErrorMessageFromUnknown(fe);
      logger$1.warn({ message: "failed in reporting usage", queryParams: _e, error: le });
    }), !0;
  }
  return !1;
};
function getFacebookHref(re) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(re)}`;
}
function getPinterestHref(re, te = "", ee = "") {
  return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(re)}&media=${encodeURIComponent(
    ee
  )}&description=${te}`;
}
function getRedditHref(re) {
  return `https://www.reddit.com/submit?url=${encodeURIComponent(re)}`;
}
function getTwitterHref(re, te = "") {
  return `https://twitter.com/intent/tweet?url=${encodeURIComponent(re)}&text=${te}`;
}
const QUERY_PARAM_MEDIA_TIME = "rbup-media-time", QUERY_PARAM_MEDIA_ID = "rbup-media-id", QUERY_PARAM_MEDIA_TIME_FALLBACK = "time";
function getPageUrl(re, te, ee) {
  if (ee) {
    const ie = new URL(re), ne = ie.searchParams;
    return ne.set(QUERY_PARAM_MEDIA_TIME, String(ee)), ne.set(QUERY_PARAM_MEDIA_ID, te), ie.href;
  }
  return re;
}
class QueryParamUrlSharingStrategy {
  calculateShareUrl(te, ee) {
    const ie = this.calculateBaseUrl(), ne = getPageUrl(ie, ee.assetId, ee.mediaPositionInSec);
    switch (te) {
      case "FACEBOOK":
        return getFacebookHref(ne);
      case "PINTEREST":
        return getPinterestHref(ne, ee.title, ee.imageUrl);
      case "REDDIT":
        return getRedditHref(ne);
      case "TWITTER":
        return getTwitterHref(ne, ee.title);
      case "PAGE":
        return ne;
      default:
        throw new Error(`unexpected share service ${te}`);
    }
  }
  determineInitialSeek(te) {
    const ee = window.location.search;
    if (!ee)
      return;
    const ie = new URLSearchParams(ee), ne = ie.get(QUERY_PARAM_MEDIA_TIME);
    if (ie.get(QUERY_PARAM_MEDIA_ID) === te && ne) {
      const _e = parseInt(ne, 10);
      if (!isNaN(_e))
        return _e;
    }
    const ue = ie.get(QUERY_PARAM_MEDIA_TIME_FALLBACK);
    if (ue) {
      const _e = parseInt(ue, 10);
      if (!isNaN(_e))
        return _e;
    }
  }
  isSharingEnabled() {
    return !!this.calculateBaseUrl();
  }
  calculateBaseUrl() {
    return window.location.href;
  }
}
const de = {
  "ad-endsin": "Werbung endet in {{sec}} Sekunden",
  "audio-mediaInfo-episodeText": "E{{episodeNumber}}",
  "audio-mediaInfo-seasonText": "S{{seasonNumber}}",
  "audio-podcast-listenOn": "Anhören auf",
  "button-close": "Schließen",
  "button-closeMenu": "Menü schließen",
  "error-default-message": "Dieses Video ist leider nicht verfügbar.",
  "error-fsk-message": "Dieses Video ist erst ab {{hour}} Uhr verfügbar.",
  "error-fsk-title": "Freigegeben ab {{age}} Jahren",
  "error-geo-message": "Dieses Video ist in Ihrem Land leider nicht verfügbar.",
  "error-geo-title": "Länderbeschränkung",
  "error-missed-message": "Dieses Video ist leider nicht mehr verfügbar.",
  "error-missed-title": "Schade verpasst",
  "error-unauthorized-message": "Leider dürfen Sie diesen Content nicht sehen.",
  "error-unauthorized-title": "Nicht autorisiert",
  "error-upcoming-message": "Dieses Video kann ab {{localizedDate}} Uhr abgespielt werden.",
  "error-upcoming-title": "Bald verfügbar",
  "endslate-title": "Ähnliche Videos",
  "endslate-replay": "Nochmal abspielen",
  "global-month-short-april": "Apr",
  "global-month-short-august": "Aug",
  "global-month-short-december": "Dez",
  "global-month-short-february": "Feb",
  "global-month-short-january": "Jän",
  "global-month-short-july": "Jul",
  "global-month-short-june": "Jun",
  "global-month-short-march": "Mär",
  "global-month-short-may": "Mai",
  "global-month-short-november": "Nov",
  "global-month-short-october": "Okt",
  "global-month-short-september": "Sep",
  "liveStream-airedOn": "Ausgestrahlt am {{date}}",
  "liveStream-canceled": "Abgesagt",
  "liveStream-days": "Tage",
  "liveStream-backToEvent": "Zurück zum Event Hub",
  "liveStream-hours": "Stunden",
  "liveStream-minutes": "Minuten",
  "liveStream-seconds": "Sekunden",
  "liveStream-trimming": "Replay in Kürze verfügbar",
  "liveStream-unconfirmed": "Unbestätigt",
  "liveStream-seekBackToLive": "Zurück zu Live",
  "liveStream-live": "Live",
  "menu-audioTracks": "Tonspuren",
  "menu-feedback": "Rückmeldung geben",
  "menu-quality": "Qualität",
  "menu-quality-auto": "Automatisch",
  "menu-sharing": "Teilen",
  "menu-sharing-copied": "Kopiert",
  "menu-sharing-copyLink": "Link kopieren",
  "menu-sharing-embed": "Embed kopieren",
  "menu-sharing-facebook": "Facebook",
  "menu-sharing-pinterest": "Pinterest",
  "menu-sharing-playFrom": "Abspielen von",
  "menu-sharing-reddit": "Reddit",
  "menu-sharing-twitter": "Twitter",
  "menu-speeds": "Geschwindigkeit",
  "menu-speeds-normal": "Normal",
  "menu-subtitles": "Untertitel",
  "menu-subtitles-off": "Aus",
  "multiChannel-singleStreamLive": "{{figure}} Stream live",
  "multiChannel-multipleStreamsLive": "{{figure}} Streams live",
  "multiChannel-seeSchedule": "Alle Livestreams",
  "multiChannel-schedule": "Livestreams",
  "multiChannel-label-live": "Jetzt live",
  "multiChannel-label-liveIn": "Live in",
  "multiChannel-label-replay": "Aufzeichnung verfügbar",
  "multiChannel-label-trim": "Aufzeichnung bald verfügbar",
  "multiChannel-label-nowWatching": "Das siehst du gerade",
  "nerdMode-assetId": "Asset ID",
  "nerdMode-copyId": "Kopiere ID",
  "nerdMode-crepoId": "CRID",
  "nerdMode-geolocation": "Abgeleitete Geo",
  "nerdMode-idCopied": "ID kopiert",
  "nerdMode-playerVersion": "Player Version",
  "nerdMode-techVersion": "Bitmovin Version",
  "nerdMode-rendition": "Aktuelle Qualität",
  "nerdMode-unknownValue": "unbekannt",
  "nextVideoCountdown-replay": "Nochmal ansehen",
  "nextVideoCountdown-title": "Als nächstes",
  "rbcom-subtitlesAvailable": "Untertitel verfügbar",
  "tooltip-airplay": "AirPlay",
  "tooltip-audioTracks": "Tonspuren",
  "tooltip-changeVolume": "Lautstärke anpassen",
  "tooltip-dvr": "Zurück zu LIVE",
  "tooltip-forward": "Vorspulen",
  "tooltip-fullscreen": "Vollbild",
  "tooltip-loading": "Laden",
  "tooltip-mute": "Ton aus",
  "tooltip-normalscreen": "Vollbild beenden",
  "tooltip-pause": "Pausieren",
  "tooltip-pip": "Bild in Bild",
  "tooltip-play": "Abspielen",
  "tooltip-replay": "Nochmal ansehen",
  "tooltip-rewind": "Zurückspulen",
  "tooltip-settings": "Einstellungen",
  "tooltip-subtitles": "Untertitel",
  "tooltip-unmute": "Ton an",
  "ad-from-ads": "Werbung {{adPosition}} von {{totalAds}}",
  "audio-duration-hour": "Std.",
  "audio-duration-minute": "Min.",
  "audio-error-default-description": "Diese Podcast-Episode ist nicht mehr verfügbar. Vielleicht wurde sie gelöscht oder entfernt. Schau später nochmal vorbei oder entdecke andere Podcasts.",
  "audio-error-default-title": "Inhalt ist nicht verfügbar",
  "audio-podcast-currently-playing": "Läuft gerade",
  "audio-podcast-playlist-additional-episodes-on": "{{additionalEpisodes}} weitere Folge auf",
  "audio-podcast-playlist-additional-episodes-on_plural": "{{additionalEpisodes}} weitere Folgen auf",
  "audio-podcast-playlist-all-episodes-on": "Alle Folgen auf",
  "nerdMode-audioLanguageOverride": "Audiosprache Überschreibung",
  "nerdMode-localeStorage": "Locale storage",
  "nerdMode-overrideReference": "Überschreibungs Referenz",
  "nerdMode-playerConfiguration": "Player-Konfiguration",
  "nerdMode-subtitlesLanguageOverride": "Untertitel Überschreibung",
  "nerdMode-translationsLanguageOverride": "Übersetzungen Überschreibung",
  "stv-reduce-ads": "Werbung reduzieren",
  "tooltip-stop": "Stop"
}, en = {
  "ad-endsin": "Ad ends in {{sec}} seconds",
  "audio-mediaInfo-episodeText": "E{{episodeNumber}}",
  "audio-mediaInfo-seasonText": "S{{seasonNumber}}",
  "audio-podcast-listenOn": "Listen on",
  "button-close": "Close",
  "button-closeMenu": "Close menu",
  "error-default-message": "This video is currently unavailable.",
  "error-fsk-message": "This video is only allowed for playback from {{hour}}:00.",
  "error-fsk-title": "Released to age {{age}}",
  "error-geo-message": "This video is not available in your country.",
  "error-geo-title": "Geo restricted",
  "error-missed-message": "This video is not available anymore.",
  "error-missed-title": "You've missed it",
  "error-unauthorized-message": "You have insufficient rights to watch this content.",
  "error-unauthorized-title": "Unauthorized",
  "error-upcoming-message": "This video is available from {{localizedDate}}.",
  "error-upcoming-title": "Upcoming",
  "endslate-title": "Related videos",
  "endslate-replay": "Replay video",
  "global-month-short-april": "Apr",
  "global-month-short-august": "Aug",
  "global-month-short-december": "Dec",
  "global-month-short-february": "Feb",
  "global-month-short-january": "Jan",
  "global-month-short-july": "Jul",
  "global-month-short-june": "Jun",
  "global-month-short-march": "Mar",
  "global-month-short-may": "May",
  "global-month-short-november": "Nov",
  "global-month-short-october": "Oct",
  "global-month-short-september": "Sep",
  "liveStream-airedOn": "Aired on {{date}}",
  "liveStream-canceled": "Cancelled",
  "liveStream-days": "Days",
  "liveStream-backToEvent": "Back to Event Hub",
  "liveStream-hours": "Hours",
  "liveStream-minutes": "Minutes",
  "liveStream-seconds": "Seconds",
  "liveStream-trimming": "Awaiting replay",
  "liveStream-unconfirmed": "Unconfirmed",
  "liveStream-seekBackToLive": "Back to Live",
  "liveStream-live": "Live",
  "menu-audioTracks": "Audio Language",
  "menu-feedback": "Give feedback",
  "menu-quality": "Quality",
  "menu-quality-auto": "Auto",
  "menu-sharing": "Share",
  "menu-sharing-copied": "Copied",
  "menu-sharing-copyLink": "Copy link",
  "menu-sharing-embed": "Copy embed",
  "menu-sharing-facebook": "Facebook",
  "menu-sharing-pinterest": "Pinterest",
  "menu-sharing-playFrom": "Play from",
  "menu-sharing-reddit": "Reddit",
  "menu-sharing-twitter": "Twitter",
  "menu-speeds": "Speed",
  "menu-speeds-normal": "Normal",
  "menu-subtitles": "Subtitles",
  "menu-subtitles-off": "Off",
  "multiChannel-singleStreamLive": "{{figure}} stream live",
  "multiChannel-multipleStreamsLive": "{{figure}} streams live",
  "multiChannel-seeSchedule": "See schedule",
  "multiChannel-schedule": "Live streams",
  "multiChannel-label-live": "Live now",
  "multiChannel-label-liveIn": "Live in",
  "multiChannel-label-replay": "Replay available",
  "multiChannel-label-trim": "Awaiting replay",
  "multiChannel-label-nowWatching": "You are now watching",
  "nerdMode-assetId": "Asset ID",
  "nerdMode-copyId": "Copy ID",
  "nerdMode-crepoId": "CRID",
  "nerdMode-geolocation": "Derived geolocation",
  "nerdMode-idCopied": "ID copied to clipboard",
  "nerdMode-playerVersion": "Player Version",
  "nerdMode-techVersion": "Bitmovin Version",
  "nerdMode-rendition": "Current Rendition",
  "nerdMode-unknownValue": "unknown",
  "nextVideoCountdown-replay": "Replay",
  "nextVideoCountdown-title": "Up next",
  "rbcom-subtitlesAvailable": "Subtitles Available",
  "tooltip-airplay": "AirPlay",
  "tooltip-audioTracks": "Audio Language",
  "tooltip-changeVolume": "Change Volume",
  "tooltip-dvr": "Return to LIVE",
  "tooltip-forward": "Seek forward",
  "tooltip-fullscreen": "Enter Fullscreen",
  "tooltip-loading": "Loading",
  "tooltip-mute": "Mute",
  "tooltip-normalscreen": "Leave Fullscreen",
  "tooltip-pause": "Pause",
  "tooltip-pip": "Picture In Picture",
  "tooltip-play": "Play",
  "tooltip-replay": "Replay",
  "tooltip-rewind": "Seek back",
  "tooltip-settings": "Settings",
  "tooltip-subtitles": "Subtitles",
  "tooltip-unmute": "Unmute",
  "ad-from-ads": "Ad {{adPosition}} of {{totalAds}}",
  "audio-duration-hour": "hr",
  "audio-duration-minute": "min",
  "audio-error-default-description": "This podcast episode is no longer available. It may have been deleted or made unavailable by the provider. Please check back later or explore other podcasts.",
  "audio-error-default-title": "Content is not available",
  "audio-podcast-currently-playing": "Currently playing",
  "audio-podcast-playlist-additional-episodes-on": "{{additionalEpisodes}} additional episode on",
  "audio-podcast-playlist-additional-episodes-on_plural": "{{additionalEpisodes}} additional episodes on",
  "audio-podcast-playlist-all-episodes-on": "All episodes on",
  "nerdMode-audioLanguageOverride": "Audio language override",
  "nerdMode-localeStorage": "Locale storage",
  "nerdMode-overrideReference": "Override reference",
  "nerdMode-playerConfiguration": "Player config",
  "nerdMode-subtitlesLanguageOverride": "Subtitles language override",
  "nerdMode-translationsLanguageOverride": "Translations language override",
  "stv-reduce-ads": "Reduce ads",
  "tooltip-stop": "Stop"
}, TRANSLATION_BASE_URL = "https://translations.redbull.com/player/", logger = loglevelExports.getLogger("TranslationService");
class TranslationService {
  constructor() {
    Et(this, "translationsLoaded", !1);
    Et(this, "translationsLoadedCallback");
    Et(this, "preferredLanguage");
    Et(this, "currentTranslationData");
  }
  getTranslationForKey(te) {
    return this.getTranslationFile()[te];
  }
  async fetchTranslationData(te) {
    try {
      const ee = await fetch(`${TRANSLATION_BASE_URL}${te}`, { redirect: "manual" });
      if (ee.ok)
        return await ee.json();
    } catch {
      logger.debug(`Could not load translations for ${te} using fallback instead`);
    }
    return this.getFallbackTranslation(te);
  }
  getTranslationFile() {
    const te = this.preferredLanguage ?? getBrowserLanguage();
    return this.currentTranslationData ?? this.getFallbackTranslation(te);
  }
  getFallbackTranslation(te) {
    return te != null && te.startsWith("de") ? de : en;
  }
  async setAndFetchCurrentLanguage(te) {
    const ee = te ?? getBrowserLanguage(), ie = await this.fetchTranslationData(ee);
    return this.preferredLanguage = ee, this.currentTranslationData = ie, Promise.resolve();
  }
}
const translationService = new TranslationService();
async function fetchBrowserOrConfiguredTranslationLanguage(re) {
  return translationService.translationsLoaded = !1, await translationService.setAndFetchCurrentLanguage(re).then(() => {
    translationService.translationsLoaded = !0, translationService.translationsLoadedCallback && translationService.translationsLoadedCallback();
  });
}
function onTranslationDataLoaded(re) {
  translationService.translationsLoadedCallback = re;
}
function areTranslationsLoaded() {
  return translationService.translationsLoaded;
}
function translate(re, te = {}) {
  const ee = translationService.getTranslationForKey(re);
  return Object.keys(te).reduce((ne, ae) => ne.replace(`{{${ae}}}`, te[ae]), ee);
}
const hotKey = {
  "tooltip-fullscreen": KEYCODE_F,
  "tooltip-normalscreen": KEYCODE_F,
  "tooltip-pip": KEYCODE_I,
  "tooltip-play": KEYCODE_K,
  "tooltip-pause": KEYCODE_K,
  "tooltip-mute": KEYCODE_M,
  "tooltip-unmute": KEYCODE_M
};
function translateWithHotKey(re) {
  const te = translate(re), ee = hotKey[re];
  return ee ? `${te} [${ee}]` : te;
}
var resizeObservers = [], hasActiveObservations = function() {
  return resizeObservers.some(function(re) {
    return re.activeTargets.length > 0;
  });
}, hasSkippedObservations = function() {
  return resizeObservers.some(function(re) {
    return re.skippedTargets.length > 0;
  });
}, msg = "ResizeObserver loop completed with undelivered notifications.", deliverResizeLoopError = function() {
  var re;
  typeof ErrorEvent == "function" ? re = new ErrorEvent("error", {
    message: msg
  }) : (re = document.createEvent("Event"), re.initEvent("error", !1, !1), re.message = msg), window.dispatchEvent(re);
}, ResizeObserverBoxOptions;
(function(re) {
  re.BORDER_BOX = "border-box", re.CONTENT_BOX = "content-box", re.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));
var freeze = function(re) {
  return Object.freeze(re);
}, ResizeObserverSize = function() {
  function re(te, ee) {
    this.inlineSize = te, this.blockSize = ee, freeze(this);
  }
  return re;
}(), DOMRectReadOnly = function() {
  function re(te, ee, ie, ne) {
    return this.x = te, this.y = ee, this.width = ie, this.height = ne, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, freeze(this);
  }
  return re.prototype.toJSON = function() {
    var te = this, ee = te.x, ie = te.y, ne = te.top, ae = te.right, ue = te.bottom, _e = te.left, fe = te.width, le = te.height;
    return { x: ee, y: ie, top: ne, right: ae, bottom: ue, left: _e, width: fe, height: le };
  }, re.fromRect = function(te) {
    return new re(te.x, te.y, te.width, te.height);
  }, re;
}(), isSVG = function(re) {
  return re instanceof SVGElement && "getBBox" in re;
}, isHidden = function(re) {
  if (isSVG(re)) {
    var te = re.getBBox(), ee = te.width, ie = te.height;
    return !ee && !ie;
  }
  var ne = re, ae = ne.offsetWidth, ue = ne.offsetHeight;
  return !(ae || ue || re.getClientRects().length);
}, isElement = function(re) {
  var te;
  if (re instanceof Element)
    return !0;
  var ee = (te = re == null ? void 0 : re.ownerDocument) === null || te === void 0 ? void 0 : te.defaultView;
  return !!(ee && re instanceof ee.Element);
}, isReplacedElement = function(re) {
  switch (re.tagName) {
    case "INPUT":
      if (re.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, global$1 = typeof window < "u" ? window : {}, cache = /* @__PURE__ */ new WeakMap(), scrollRegexp = /auto|scroll/, verticalRegexp = /^tb|vertical/, IE = /msie|trident/i.test(global$1.navigator && global$1.navigator.userAgent), parseDimension = function(re) {
  return parseFloat(re || "0");
}, size = function(re, te, ee) {
  return re === void 0 && (re = 0), te === void 0 && (te = 0), ee === void 0 && (ee = !1), new ResizeObserverSize((ee ? te : re) || 0, (ee ? re : te) || 0);
}, zeroBoxes = freeze({
  devicePixelContentBoxSize: size(),
  borderBoxSize: size(),
  contentBoxSize: size(),
  contentRect: new DOMRectReadOnly(0, 0, 0, 0)
}), calculateBoxSizes = function(re, te) {
  if (te === void 0 && (te = !1), cache.has(re) && !te)
    return cache.get(re);
  if (isHidden(re))
    return cache.set(re, zeroBoxes), zeroBoxes;
  var ee = getComputedStyle(re), ie = isSVG(re) && re.ownerSVGElement && re.getBBox(), ne = !IE && ee.boxSizing === "border-box", ae = verticalRegexp.test(ee.writingMode || ""), ue = !ie && scrollRegexp.test(ee.overflowY || ""), _e = !ie && scrollRegexp.test(ee.overflowX || ""), fe = ie ? 0 : parseDimension(ee.paddingTop), le = ie ? 0 : parseDimension(ee.paddingRight), se = ie ? 0 : parseDimension(ee.paddingBottom), oe = ie ? 0 : parseDimension(ee.paddingLeft), ce = ie ? 0 : parseDimension(ee.borderTopWidth), he = ie ? 0 : parseDimension(ee.borderRightWidth), ge = ie ? 0 : parseDimension(ee.borderBottomWidth), ve = ie ? 0 : parseDimension(ee.borderLeftWidth), me = oe + le, be = fe + se, pe = ve + he, $e = ce + ge, ye = _e ? re.offsetHeight - $e - re.clientHeight : 0, Se = ue ? re.offsetWidth - pe - re.clientWidth : 0, we = ne ? me + pe : 0, Pe = ne ? be + $e : 0, Te = ie ? ie.width : parseDimension(ee.width) - we - Se, Ee = ie ? ie.height : parseDimension(ee.height) - Pe - ye, Me = Te + me + Se + pe, Ae = Ee + be + ye + $e, Ne = freeze({
    devicePixelContentBoxSize: size(Math.round(Te * devicePixelRatio), Math.round(Ee * devicePixelRatio), ae),
    borderBoxSize: size(Me, Ae, ae),
    contentBoxSize: size(Te, Ee, ae),
    contentRect: new DOMRectReadOnly(oe, fe, Te, Ee)
  });
  return cache.set(re, Ne), Ne;
}, calculateBoxSize = function(re, te, ee) {
  var ie = calculateBoxSizes(re, ee), ne = ie.borderBoxSize, ae = ie.contentBoxSize, ue = ie.devicePixelContentBoxSize;
  switch (te) {
    case ResizeObserverBoxOptions.DEVICE_PIXEL_CONTENT_BOX:
      return ue;
    case ResizeObserverBoxOptions.BORDER_BOX:
      return ne;
    default:
      return ae;
  }
}, ResizeObserverEntry = function() {
  function re(te) {
    var ee = calculateBoxSizes(te);
    this.target = te, this.contentRect = ee.contentRect, this.borderBoxSize = freeze([ee.borderBoxSize]), this.contentBoxSize = freeze([ee.contentBoxSize]), this.devicePixelContentBoxSize = freeze([ee.devicePixelContentBoxSize]);
  }
  return re;
}(), calculateDepthForNode = function(re) {
  if (isHidden(re))
    return 1 / 0;
  for (var te = 0, ee = re.parentNode; ee; )
    te += 1, ee = ee.parentNode;
  return te;
}, broadcastActiveObservations = function() {
  var re = 1 / 0, te = [];
  resizeObservers.forEach(function(ue) {
    if (ue.activeTargets.length !== 0) {
      var _e = [];
      ue.activeTargets.forEach(function(le) {
        var se = new ResizeObserverEntry(le.target), oe = calculateDepthForNode(le.target);
        _e.push(se), le.lastReportedSize = calculateBoxSize(le.target, le.observedBox), oe < re && (re = oe);
      }), te.push(function() {
        ue.callback.call(ue.observer, _e, ue.observer);
      }), ue.activeTargets.splice(0, ue.activeTargets.length);
    }
  });
  for (var ee = 0, ie = te; ee < ie.length; ee++) {
    var ne = ie[ee];
    ne();
  }
  return re;
}, gatherActiveObservationsAtDepth = function(re) {
  resizeObservers.forEach(function(ee) {
    ee.activeTargets.splice(0, ee.activeTargets.length), ee.skippedTargets.splice(0, ee.skippedTargets.length), ee.observationTargets.forEach(function(ne) {
      ne.isActive() && (calculateDepthForNode(ne.target) > re ? ee.activeTargets.push(ne) : ee.skippedTargets.push(ne));
    });
  });
}, process$1 = function() {
  var re = 0;
  for (gatherActiveObservationsAtDepth(re); hasActiveObservations(); )
    re = broadcastActiveObservations(), gatherActiveObservationsAtDepth(re);
  return hasSkippedObservations() && deliverResizeLoopError(), re > 0;
}, trigger, callbacks = [], notify = function() {
  return callbacks.splice(0).forEach(function(re) {
    return re();
  });
}, queueMicroTask = function(re) {
  if (!trigger) {
    var te = 0, ee = document.createTextNode(""), ie = { characterData: !0 };
    new MutationObserver(function() {
      return notify();
    }).observe(ee, ie), trigger = function() {
      ee.textContent = "".concat(te ? te-- : te++);
    };
  }
  callbacks.push(re), trigger();
}, queueResizeObserver = function(re) {
  queueMicroTask(function() {
    requestAnimationFrame(re);
  });
}, watching = 0, isWatching = function() {
  return !!watching;
}, CATCH_PERIOD = 250, observerConfig = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, events = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], time = function(re) {
  return re === void 0 && (re = 0), Date.now() + re;
}, scheduled = !1, Scheduler = function() {
  function re() {
    var te = this;
    this.stopped = !0, this.listener = function() {
      return te.schedule();
    };
  }
  return re.prototype.run = function(te) {
    var ee = this;
    if (te === void 0 && (te = CATCH_PERIOD), !scheduled) {
      scheduled = !0;
      var ie = time(te);
      queueResizeObserver(function() {
        var ne = !1;
        try {
          ne = process$1();
        } finally {
          if (scheduled = !1, te = ie - time(), !isWatching())
            return;
          ne ? ee.run(1e3) : te > 0 ? ee.run(te) : ee.start();
        }
      });
    }
  }, re.prototype.schedule = function() {
    this.stop(), this.run();
  }, re.prototype.observe = function() {
    var te = this, ee = function() {
      return te.observer && te.observer.observe(document.body, observerConfig);
    };
    document.body ? ee() : global$1.addEventListener("DOMContentLoaded", ee);
  }, re.prototype.start = function() {
    var te = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), events.forEach(function(ee) {
      return global$1.addEventListener(ee, te.listener, !0);
    }));
  }, re.prototype.stop = function() {
    var te = this;
    this.stopped || (this.observer && this.observer.disconnect(), events.forEach(function(ee) {
      return global$1.removeEventListener(ee, te.listener, !0);
    }), this.stopped = !0);
  }, re;
}(), scheduler = new Scheduler(), updateCount = function(re) {
  !watching && re > 0 && scheduler.start(), watching += re, !watching && scheduler.stop();
}, skipNotifyOnElement = function(re) {
  return !isSVG(re) && !isReplacedElement(re) && getComputedStyle(re).display === "inline";
}, ResizeObservation = function() {
  function re(te, ee) {
    this.target = te, this.observedBox = ee || ResizeObserverBoxOptions.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return re.prototype.isActive = function() {
    var te = calculateBoxSize(this.target, this.observedBox, !0);
    return skipNotifyOnElement(this.target) && (this.lastReportedSize = te), this.lastReportedSize.inlineSize !== te.inlineSize || this.lastReportedSize.blockSize !== te.blockSize;
  }, re;
}(), ResizeObserverDetail = function() {
  function re(te, ee) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = te, this.callback = ee;
  }
  return re;
}(), observerMap = /* @__PURE__ */ new WeakMap(), getObservationIndex = function(re, te) {
  for (var ee = 0; ee < re.length; ee += 1)
    if (re[ee].target === te)
      return ee;
  return -1;
}, ResizeObserverController = function() {
  function re() {
  }
  return re.connect = function(te, ee) {
    var ie = new ResizeObserverDetail(te, ee);
    observerMap.set(te, ie);
  }, re.observe = function(te, ee, ie) {
    var ne = observerMap.get(te), ae = ne.observationTargets.length === 0;
    getObservationIndex(ne.observationTargets, ee) < 0 && (ae && resizeObservers.push(ne), ne.observationTargets.push(new ResizeObservation(ee, ie && ie.box)), updateCount(1), scheduler.schedule());
  }, re.unobserve = function(te, ee) {
    var ie = observerMap.get(te), ne = getObservationIndex(ie.observationTargets, ee), ae = ie.observationTargets.length === 1;
    ne >= 0 && (ae && resizeObservers.splice(resizeObservers.indexOf(ie), 1), ie.observationTargets.splice(ne, 1), updateCount(-1));
  }, re.disconnect = function(te) {
    var ee = this, ie = observerMap.get(te);
    ie.observationTargets.slice().forEach(function(ne) {
      return ee.unobserve(te, ne.target);
    }), ie.activeTargets.splice(0, ie.activeTargets.length);
  }, re;
}(), ResizeObserver$1 = function() {
  function re(te) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof te != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    ResizeObserverController.connect(this, te);
  }
  return re.prototype.observe = function(te, ee) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!isElement(te))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    ResizeObserverController.observe(this, te, ee);
  }, re.prototype.unobserve = function(te) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!isElement(te))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    ResizeObserverController.unobserve(this, te);
  }, re.prototype.disconnect = function() {
    ResizeObserverController.disconnect(this);
  }, re.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, re;
}();
function newResizeObserver(re) {
  return new (window.ResizeObserver ?? ResizeObserver$1)(re);
}
function useContainerQuery(re, te) {
  const [ee, ie] = h$2([]), ne = T$1(
    (ue) => {
      const _e = new Set(ee), fe = new Set(ee);
      if (ue.forEach((le) => {
        te.forEach((se) => {
          le.contentRect.width >= se ? _e.add(se) : _e.delete(se);
        });
      }), !eqSet(fe, _e)) {
        const le = Array.from(_e);
        ie(le);
      }
    },
    [te, ee]
  );
  p(() => {
    const ue = re.current;
    if (!ue)
      return function() {
      };
    const _e = newResizeObserver((fe) => {
      window.requestAnimationFrame(() => ne(fe));
    });
    return _e.observe(ue), function() {
      _e.unobserve(ue);
    };
  }, [te, ee, re, ne]);
  const ae = F$1(
    () => ee.map((ue) => `cq-${ue}`).join(" "),
    [ee]
  );
  if (ae === void 0)
    throw new Error("Hooks are broken! Please check RBV-1627 to get more info!");
  return ae;
}
function cssClassesContainsBreakpoint(re, te) {
  return re.includes(`cq-${te}`);
}
function useResize(re, te) {
  const ee = _(), ie = _(), ne = _(re);
  ne.current = re;
  const ae = (ue) => {
    window.requestAnimationFrame(() => {
      ue.forEach((_e) => {
        const fe = ee.current;
        (_e.contentRect.width !== (fe == null ? void 0 : fe.width) || _e.contentRect.height !== fe.height) && (ee.current = {
          width: _e.contentRect.width,
          height: _e.contentRect.height
        }, ne.current(_e.contentRect));
      });
    });
  };
  ie.current || (ie.current = newResizeObserver(ae)), p(() => {
    const ue = te == null ? void 0 : te.current;
    if (!ue)
      return () => {
      };
    const _e = ie.current;
    return _e == null || _e.observe(ue), () => {
      _e == null || _e.unobserve(ue);
    };
  }, [te]);
}
const defaultState = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
function useMeasure(re, te) {
  const [ee, ie] = h$2({ ...defaultState, ...te });
  return useResize((ne) => {
    const { x: ae, y: ue, width: _e, height: fe, top: le, left: se, bottom: oe, right: ce } = ne;
    ie({ x: ae, y: ue, width: _e, height: fe, top: le, left: se, bottom: oe, right: ce });
  }, re), ee;
}
function handleResize(re, te) {
  window.requestAnimationFrame(() => {
    re.forEach((ee) => {
      te(ee.contentRect.width);
    });
  });
}
function usePlayerWidth(re) {
  const [te, ee] = h$2(0);
  return p(() => {
    const ie = re.current;
    if (!ie)
      return function() {
      };
    const ne = newResizeObserver((ae) => handleResize(ae, ee));
    return ne.observe(ie), function() {
      ne.unobserve(ie);
    };
  }, [re]), te;
}
const UserInteractionContext = G$1({}), UserInteractionContextProvider = ({ children: re }) => {
  const te = _([]), ee = F$1(() => ({
    addEventListener(ie) {
      te.current.includes(ie) || te.current.push(ie);
    },
    removeEventListener(ie) {
      const ne = te.current.findIndex((ae) => ae === ie);
      te.current.splice(ne, 1);
    },
    trigger(ie) {
      te.current.forEach((ne) => {
        try {
          ne(ie);
        } catch {
          console.error("error invoking user interaction listener", ie);
        }
      });
    }
  }), [te]);
  return /* @__PURE__ */ Cn.createElement(UserInteractionContext.Provider, { value: ee }, re);
}, log$c = loglevelExports.getLogger("useInformPlaywright"), INFO_LOG_LEVEL = 2;
function useInformPlaywright(re) {
  const te = _(null), ee = T$1(() => log$c.getLevel() <= INFO_LOG_LEVEL, []), ie = T$1(() => {
    te.current && (window.clearTimeout(te.current), te.current = null);
  }, []);
  p(() => (ee() && (ie(), te.current = window.setTimeout(() => {
    log$c.info(re);
  }, 1e3)), () => {
    ie();
  }), [ie, ee, re]);
}
function useSmoothScrubBarAnimation(re, te, ee, ie) {
  const ne = _(0), ae = T$1(() => {
    var fe;
    const ue = ((fe = ie == null ? void 0 : ie.getPlayerData()) == null ? void 0 : fe.getCurrentTimeInSec()) ?? 0;
    te(ue);
    const _e = (ie == null ? void 0 : ie.getBufferLengthInSec()) ?? 0;
    ee(_e), re === "PLAYING" && (ne.current = window.requestAnimationFrame(ae));
  }, [ie, re, ee, te]);
  p(() => (re === "PLAYING" && ae(), () => {
    window.cancelAnimationFrame(ne.current);
  }), [re, ae]);
}
const ControlsVisibilityContext = G$1({}), ControlsVisibilityContextProvider = ({ children: re }) => {
  const te = _(-1), {
    playerState: { playerStatus: ee, isInPictureInPictureMode: ie }
  } = usePlayerContext(), [ne, ae] = h$2("fade-in"), [ue, _e] = h$2("allow"), [fe, le] = h$2("CLOSED"), [se, oe] = h$2("NOT_HOVERED"), ce = _();
  ce.current = ie;
  const he = _();
  he.current = ee;
  const ge = _();
  ge.current = fe;
  const ve = T$1(
    (Me) => {
      ae(Me), (Me === "hide" || Me === "fade-out") && le("CLOSED");
    },
    [ae]
  ), me = T$1(() => {
    window.clearTimeout(te.current), te.current = window.setTimeout(() => {
      ce.current || he.current !== "PAUSED" && ge.current === "CLOSED" && se !== "HOVERED" && ve("fade-out");
    }, 3e3);
  }, [se, ve]), be = T$1(() => {
    me(), ve("fade-in");
  }, [ve, me]), pe = T$1(() => {
    window.clearTimeout(te.current), ve("fade-in");
  }, [ve]), $e = T$1(() => {
    window.clearTimeout(te.current), ve("fade-out");
  }, [ve]), ye = T$1(() => {
    window.clearTimeout(te.current), ve("hide");
  }, [ve]), Se = T$1(() => {
    ae((Me) => {
      const Ae = Me === "fade-in" ? "fade-out" : "fade-in";
      return Ae === "fade-in" && be(), Ae;
    });
  }, [be]), we = T$1((Me) => {
    var Ae;
    oe("NOT_HOVERED"), (Ae = Me.target) == null || Ae.removeEventListener("pointerleave", we);
  }, []), Pe = T$1(
    (Me, Ae = !1) => {
      const Ne = Me.target.type === "button";
      if (isMouse(Me) && Ne || Ae) {
        oe("HOVERED");
        const Ce = Ne ? Me.target : Me.currentTarget;
        Ce == null || Ce.addEventListener("pointerleave", we);
      }
    },
    [we]
  ), Te = T$1((Me) => {
    le((Ae) => Me === Ae ? "CLOSED" : Me);
  }, []);
  p(() => {
    (ee === "PLAYING" || ee === "PAUSED") && be();
  }, [ee, be]), p(() => {
    fe === "CLOSED" && be();
  }, [fe, be]), p(() => () => {
    window.clearTimeout(te.current);
  }, []);
  const Ee = F$1(
    () => ({
      controlsVisibility: ne,
      showControlsTemporarily: be,
      showControlsPermanently: pe,
      fadeControlsAway: $e,
      hideControls: ye,
      toggleControlsVisibility: Se,
      allowControlsRendering: ue,
      setAllowControlsRendering: _e,
      menuState: fe,
      setMenuState: le,
      onControlsElementEnter: Pe,
      toggleMenu: Te
    }),
    [
      ne,
      be,
      pe,
      $e,
      ye,
      Se,
      ue,
      _e,
      fe,
      le,
      Pe,
      Te
    ]
  );
  return /* @__PURE__ */ Cn.createElement(ControlsVisibilityContext.Provider, { value: Ee }, re);
}, useControlsVisibilityContext = () => q$1(ControlsVisibilityContext);
function useObjectArrayCache(re, te) {
  const ee = re.map((ne) => ne[te]).join(",");
  return F$1(() => re, [ee]);
}
const RbupVideoCornerbug = ({ iconComponent: re }) => {
  const {
    playerState: { playerStatus: te }
  } = usePlayerContext(), ee = te === "PLAYING", [ie, ne] = h$2(ee);
  return p(() => {
    ee && ne(!0);
  }, [ee]), /* @__PURE__ */ Cn.createElement("div", { class: "cornerbug" }, re && ie && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-cornerbug": !0, class: "cornerbug__icon" }, re));
};
function convertToLocalizedDateString(re) {
  return new Date(re).toLocaleDateString(window.navigator.language, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  });
}
function serverErrorResolver(re) {
  var ie, ne, ae;
  const te = re.playabilityErrors, ee = re.playabilityErrorDetails;
  if (te.includes("DATE_RANGE_UNKNOWN"))
    return { description: translate("error-default-message") };
  if (te.includes("NO_LONGER_AVAILABLE"))
    return {
      title: translate("error-missed-title"),
      description: translate("error-missed-message")
    };
  if (te.includes("GEO_BLOCKED"))
    return {
      title: translate("error-geo-title"),
      description: translate("error-geo-message")
    };
  if (te.includes("NOT_YET_AVAILABLE")) {
    const ue = (ie = ee == null ? void 0 : ee.NOT_YET_AVAILABLE) != null && ie.availableFrom ? convertToLocalizedDateString(ee.NOT_YET_AVAILABLE.availableFrom) : "N/A";
    return {
      title: translate("error-upcoming-title"),
      description: translate("error-upcoming-message", { localizedDate: ue })
    };
  }
  return te.includes("FSK_BLOCKED") ? {
    title: translate("error-fsk-title", { age: ((ne = ee == null ? void 0 : ee.FSK_BLOCKED) == null ? void 0 : ne.minAge.toString()) ?? "" }),
    description: translate("error-fsk-message", {
      hour: ((ae = ee == null ? void 0 : ee.FSK_BLOCKED) == null ? void 0 : ae.minEveningHour.toString()) ?? ""
    })
  } : { description: translate("error-default-message") };
}
function errorDescriptionResolver(re) {
  return re ? re.playerErrorCode === "NOT_AUTHORIZED" ? {
    description: translate("error-unauthorized-message"),
    title: translate("error-unauthorized-title")
  } : re.playerErrorCode ? { description: translate("error-default-message") } : re.serverErrorDetails ? serverErrorResolver(re.serverErrorDetails) : { description: translate("error-default-message") } : { description: translate("error-default-message") };
}
const ErrorDisplay = () => {
  const {
    playerState: { currentErrorDetails: re }
  } = usePlayerContext(), [te, ee] = h$2(areTranslationsLoaded());
  onTranslationDataLoaded(() => ee(!0));
  const ie = !!re, ne = errorDescriptionResolver(re);
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ie && /* @__PURE__ */ Cn.createElement("div", { class: "error-display" }, /* @__PURE__ */ Cn.createElement("div", { class: "error-display__description" }, /* @__PURE__ */ Cn.createElement("div", { class: "error-display__icon-container" }, /* @__PURE__ */ Cn.createElement(CosmosIconErrorFilled, { "data-rbup-icon-error-filled": !0, class: "error-display__icon" })), /* @__PURE__ */ Cn.createElement("div", { class: "error-display__text-container" }, ne.title && /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "rbup-error-display-title": !0,
      class: "error-display__text",
      weight: "bold",
      appearance: "light",
      size: "medium"
    },
    ne.title
  ), ne.description && /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "rbup-error-display-description": !0,
      class: "error-display__text",
      weight: "regular",
      appearance: "light",
      size: "x-small"
    },
    ne.description
  )))));
}, useGlobalKeyboardNavigation = (re, te) => {
  p(() => {
    if (re === "ACTIVE") {
      const ee = (ie) => {
        ie.target === window.document.body && te(ie);
      };
      return window.document.addEventListener("keydown", ee), () => window.document.removeEventListener("keydown", ee);
    }
  }, [re, te]);
};
function preventEventHandling(re) {
  var ie;
  const te = isLiveLinearResolver(re), ee = (ie = re.getPlayerData()) == null ? void 0 : ie.isShowingAd();
  return te || ee;
}
function handleSeekForward(re) {
  preventEventHandling(re) || re.canSeekOrTimeshiftForward() && re.seekOrTimeshiftRelative(DEFAULT_SEEK_SKIP_SECONDS);
}
function handleSeekBackward(re) {
  preventEventHandling(re) || re.canSeekOrTimeshiftBackward() && re.seekOrTimeshiftRelative(-DEFAULT_SEEK_SKIP_SECONDS);
}
function handleVolumeChange(re, te) {
  const ie = re.getVolume() * te;
  re.setVolume(ie);
}
function handleVolumeDown(re) {
  handleVolumeChange(re, 0.95);
}
function handleVolumeUp(re) {
  handleVolumeChange(re, 1.05);
}
function handleToggleFullscreen(re) {
  re.toggleFullscreen();
}
function handleTogglePictureInPicture(re) {
  re.togglePictureInPicture();
}
function handleMuted(re) {
  const te = re.isMuted();
  re.setMuted(!te);
}
function handleSeekToBeginning(re) {
  re.seek(0);
}
function handleTogglePlayback(re) {
  if (preventEventHandling(re))
    return;
  const te = re.getPlayerStatus();
  handlePlayPauseToggle(te, re);
}
const keyboardEventHandler = {
  [KEYCODE_ARROW_DOWN]: handleVolumeDown,
  [KEYCODE_ARROW_LEFT]: handleSeekBackward,
  [KEYCODE_ARROW_RIGHT]: handleSeekForward,
  [KEYCODE_ARROW_UP]: handleVolumeUp,
  [KEYCODE_F]: handleToggleFullscreen,
  [KEYCODE_I]: handleTogglePictureInPicture,
  [KEYCODE_K]: handleTogglePlayback,
  [KEYCODE_M]: handleMuted,
  [KEYCODE_0]: handleSeekToBeginning,
  [KEYCODE_SPACE]: handleTogglePlayback
};
function handleKeyboardEvent(re, te) {
  if (!te)
    return;
  const ee = keyboardEventHandler == null ? void 0 : keyboardEventHandler[re.key];
  ee && (re.preventDefault(), ee(te));
}
function useScrubBarEventHandling(re, te, ee, ie, ne, ae) {
  var ke;
  const [ue, _e] = h$2(
    ((ke = te == null ? void 0 : te.getPlayerData()) == null ? void 0 : ke.getCurrentTimeInSec()) ?? 0
  ), [fe, le] = h$2((te == null ? void 0 : te.getDurationInSec()) ?? 0), [se, oe] = h$2((te == null ? void 0 : te.getBufferLengthInSec()) ?? 0), [ce, he] = h$2(0), [ge, ve] = h$2(!1), [me, be] = h$2(!1), [pe, $e] = h$2(!1), ye = pe && !ae, Se = _({ x: 0, y: 0 }), we = T$1(
    (Le) => extractPlaybackPositionInPercentFromEvent(Le, re) ?? 0,
    [re]
  ), Pe = T$1(
    (Le) => {
      const De = roundPlaybackSec(Le * fe);
      _e(De), ie(Le, De);
    },
    [fe, ie]
  ), Te = T$1((Le) => {
    const De = Se.current, Re = getPositionFromEvent(Le), Oe = hasPositionMoved(De, Re);
    return Se.current = Re, Oe;
  }, []), Ee = T$1(
    (Le) => {
      he(we(Le));
    },
    [we]
  ), Me = T$1(
    (Le) => {
      const De = we(Le);
      isNaN(fe) || (he(De), Pe(De), Le.stopPropagation(), Le.preventDefault()), ne(!1), ve(!1);
      const Re = Le.currentTarget;
      Re instanceof HTMLElement && "pointerId" in Le && Re.releasePointerCapture(Le.pointerId), document.removeEventListener("pointermove", Ee), document.removeEventListener("pointerup", Me), $e(!1);
    },
    [
      fe,
      we,
      Ee,
      ne,
      Pe,
      $e
    ]
  ), Ae = T$1(() => {
    ge || $e(!1), be(!1);
  }, [ge, $e]), Ne = T$1(() => {
    be(!0);
  }, []), Ce = T$1(
    (Le) => {
      document.addEventListener("pointermove", Ee), document.addEventListener("pointerup", Me);
      const De = Le.currentTarget;
      De instanceof HTMLElement && "pointerId" in Le && De.setPointerCapture(Le.pointerId), ve(!0), $e(!0), Ee(Le), ne(!0);
    },
    [Ee, Me, ne, $e]
  ), Ie = T$1(
    (Le) => {
      ge && Le.preventDefault();
      const De = we(Le);
      he(De), Te(Le) && $e(!0);
    },
    [ge, we, Te, $e]
  );
  useSmoothScrubBarAnimation(ee, _e, oe, te), p(() => {
    const Le = (De) => {
      var Oe, Be;
      switch (De.type) {
        case "seeking": {
          const Fe = ((Oe = te == null ? void 0 : te.getPlayerData()) == null ? void 0 : Oe.getCurrentTimeInSec()) ?? 0;
          _e(Fe), oe(te == null ? void 0 : te.getBufferLengthInSec());
          break;
        }
        case "loaded":
        case "play": {
          const Fe = ((Be = te == null ? void 0 : te.getPlayerData()) == null ? void 0 : Be.getCurrentTimeInSec()) ?? 0;
          le(te == null ? void 0 : te.getDurationInSec()), oe((te == null ? void 0 : te.getBufferLengthInSec()) ?? 0), _e(Fe);
          break;
        }
      }
      const Re = te == null ? void 0 : te.getDurationInSec();
      le(Re);
    };
    return te == null || te.addEventListener(Le), () => {
      te == null || te.removeEventListener(Le);
    };
  }, [te]);
  const xe = F$1(() => fe === 0 ? 0 : roundPlaybackPercentage(se / fe), [se, fe]), Ue = F$1(() => {
    if (fe === 0)
      return 0;
    const Le = roundPlaybackPercentage(ue / fe);
    return isNaN(Le) ? 0 : Le;
  }, [ue, fe]);
  return {
    onDocumentPointerUp: Me,
    onPointerLeave: Ae,
    onPointerOver: Ne,
    onPointerDown: Ce,
    onPointerMove: Ie,
    bufferDurationPercent: xe,
    playbackPositionInPercent: Ue,
    isDragging: ge,
    draggedPlaybackPositionInPercent: ce,
    durationInSec: fe,
    playbackPositionInSec: ue,
    hovered: me,
    showHandle: ye
  };
}
const POSTROLL_AD_MARKER = -1, PREROLL_AD_MARKER = 0, OPEN_HEIGHT = 0, CLOSED_HEIGHT = 2, MARKER_WIDTH = "4px";
function calculateAdMarkers(re, te) {
  const ee = [], ie = (re == null ? void 0 : re.length) ?? 0;
  if (!(!re || ie === 0 || te === 0))
    return re.forEach((ne) => {
      let ae, ue;
      ne === PREROLL_AD_MARKER ? (ae = "0%", ue = MARKER_WIDTH) : ne === POSTROLL_AD_MARKER ? (ae = `calc(100% - ${MARKER_WIDTH})`, ue = "100%") : (ae = `${ne * 100 / te}%`, ue = `calc(${ae} + ${MARKER_WIDTH})`), drawMarkers(ee, ae, ue);
    }), `polygon(
	${ee.join(`,
	`)}
);`;
}
function drawMarkers(re, te, ee) {
  const ie = `${te} ${OPEN_HEIGHT}px`, ne = `${ee} ${OPEN_HEIGHT}px`, ae = `${ee} ${CLOSED_HEIGHT}px`, ue = `${te} ${CLOSED_HEIGHT}px`;
  re.push(ie, ne, ae, ue, ie);
}
const AdMarkers = x(({ adCuePoints: re, durationInSec: te }) => {
  const ee = calculateAdMarkers(re, te);
  return ee ? /* @__PURE__ */ Cn.createElement("div", { class: "ad-markers" }, /* @__PURE__ */ Cn.createElement("div", { class: "ad-markers__background-container", style: `clip-path: ${ee}` })) : null;
}), ProgressBar = ({ calculatedPositionPercent: re }) => /* @__PURE__ */ Cn.createElement(
  "div",
  {
    "data-rbup-scrub-bar-progress": !0,
    class: "progress-bar",
    style: { width: `${re * 100}%` }
  }
), SeekBarHandle = ({ playbackPositionInPercent: re }) => /* @__PURE__ */ Cn.createElement("div", { "data-rbup-seek-bar-handle": !0, class: "seek-bar-handle", style: { left: `${re * 100}%` } }, /* @__PURE__ */ Cn.createElement("div", { class: "seek-bar-handle__knob" }));
function formatPlaybackPosition(re, te) {
  if (re > 0)
    return getFormattedTimeString(re * te);
  const ee = Math.abs(re), ie = ee - ee * te;
  return `${ie > 0 ? "-" : ""}${getFormattedTimeString(ie)}`;
}
const SeekBarTooltip = ({
  durationInSec: re,
  positionInPercent: te,
  segmentTitle: ee,
  showTooltip: ie,
  sizeBreakpoints: ne
}) => {
  const {
    playerState: { playerCoordinator: ae, isVRVideo: ue }
  } = usePlayerContext(), _e = _(null), fe = _(null), le = _(null), [se, oe] = h$2(!ue), ce = formatPlaybackPosition(re, te);
  p(() => {
    (async () => {
      const ve = Math.floor(re * te), me = await (ae == null ? void 0 : ae.setThumbnail(
        {
          imgContainerElement: _e.current,
          imgElement: fe.current,
          textContainerElement: le.current
        },
        {
          smallOrBigger: ne.smallOrBigger,
          mediumOrBigger: ne.mediumOrBigger
        },
        ve
      )) ?? !1;
      oe(me);
    })();
  }, [
    re,
    ue,
    ae,
    te,
    ne.smallOrBigger,
    ne.mediumOrBigger
  ]);
  const he = [
    "seek-bar-tooltip",
    ie && "seek-bar-tooltip--visible",
    se && "seek-bar-tooltip--with-thumbnail",
    ee && "seek-bar-tooltip--with-segments"
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ Cn.createElement("div", { "data-rbup-seek-bar-tooltip": !0, class: he }, se && /* @__PURE__ */ Cn.createElement("div", { class: "seek-bar-tooltip__image-container", ref: _e }, /* @__PURE__ */ Cn.createElement(
    "img",
    {
      class: "seek-bar-tooltip__image",
      "data-rbup-seek-bar-thumbnail": !0,
      ref: fe,
      alt: "preview thumbnail"
    }
  )), /* @__PURE__ */ Cn.createElement("div", { class: "seek-bar-tooltip__text", ref: le }, ee && /* @__PURE__ */ Cn.createElement(CosmosText, { "data-rbup-text": !0, size: "xx-small", weight: "medium" }, ee), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "data-rbup-text": !0,
      class: "seek-bar-tooltip__position",
      "data-rbup-seek-bar-tooltip": !0,
      kind: "subtle",
      size: "xx-small",
      weight: "medium"
    },
    ce
  )));
}, SeekBar = ({
  durationInSec: re,
  playbackPositionInPercent: te,
  segmentTitle: ee,
  showHandle: ie,
  sizeBreakpoints: ne,
  tooltipPositionInPercent: ae
}) => isMobileDevice() ? /* @__PURE__ */ Cn.createElement("div", { "data-rbup-seek-bar": !0, class: "seek-bar" }, /* @__PURE__ */ Cn.createElement("div", { class: `seek-bar__handle-container ${ie ? "seek-bar__handle-container_visible" : ""}` }, /* @__PURE__ */ Cn.createElement(
  CosmosTooltip,
  {
    class: "seek-bar__cosmos-tooltip",
    controlled: !0,
    follow: "target",
    unreachable: !0,
    visible: ie
  },
  /* @__PURE__ */ Cn.createElement("div", { slot: "content" }, /* @__PURE__ */ Cn.createElement(
    SeekBarTooltip,
    {
      "data-rbup-seek-bar-tool-tip": !0,
      durationInSec: re,
      positionInPercent: ae,
      showTooltip: ie,
      segmentTitle: ee,
      sizeBreakpoints: ne
    }
  )),
  /* @__PURE__ */ Cn.createElement(
    SeekBarHandle,
    {
      "data-rbup-seek-bar-handle": !0,
      playbackPositionInPercent: te
    }
  )
))) : /* @__PURE__ */ Cn.createElement(
  CosmosTooltip,
  {
    class: "seek-bar__cosmos-tooltip",
    controlled: !0,
    follow: !0,
    unreachable: !0,
    visible: ie
  },
  /* @__PURE__ */ Cn.createElement("div", { slot: "content" }, /* @__PURE__ */ Cn.createElement(
    SeekBarTooltip,
    {
      "data-rbup-seek-bar-tool-tip": !0,
      durationInSec: re,
      positionInPercent: ae,
      segmentTitle: ee,
      showTooltip: ie,
      sizeBreakpoints: ne
    }
  )),
  /* @__PURE__ */ Cn.createElement("div", { "data-rbup-seek-bar": !0, class: "seek-bar" }, /* @__PURE__ */ Cn.createElement("div", { class: `seek-bar__handle-container ${ie ? "seek-bar__handle-container_visible" : ""}` }, /* @__PURE__ */ Cn.createElement(SeekBarHandle, { "data-rbup-seek-bar-handle": !0, playbackPositionInPercent: te })))
), DvrScrubBar = ({
  onDragStatusChanged: re,
  sizeBreakpoints: te,
  hideScrubBarTooltip: ee
}) => {
  const {
    playerState: {
      playerCoordinator: ie,
      playerConfiguration: ne,
      playerStatus: ae,
      maxTimeShiftInSec: ue,
      timeShiftInSec: _e,
      durationInSec: fe
    }
  } = usePlayerContext(), le = ie == null ? void 0 : ie.getAdCuePoints(), se = ne == null ? void 0 : ne.adMarkerEnabled, [oe, ce] = h$2(
    (ie == null ? void 0 : ie.getTimeShiftInSec()) ?? 0
  ), he = _(null);
  p(() => {
    ce(_e);
  }, [_e]);
  const ge = T$1(
    (Me, Ae) => {
      const Ne = ue * (1 - Me);
      ie == null || ie.timeShift(Ne);
    },
    [ue, ie]
  ), ve = F$1(() => ue === 0 ? 1 : 1 - roundPlaybackPercentage(oe / ue), [oe, ue]), {
    onDocumentPointerUp: me,
    onPointerLeave: be,
    onPointerOver: pe,
    onPointerDown: $e,
    onPointerMove: ye,
    draggedPlaybackPositionInPercent: Se,
    hovered: we,
    isDragging: Pe,
    showHandle: Te
  } = useScrubBarEventHandling(
    he,
    ie,
    ae,
    ge,
    re,
    ee
  ), Ee = Pe ? Se : ve;
  return /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-hovered": `${we}`,
      "data-rbup-dvr-scrub-bar": !0,
      class: "scrub-bar",
      ref: he,
      onPointerDown: $e,
      onPointerLeave: be,
      onPointerMove: ye,
      onPointerOver: pe,
      onPointerUp: me,
      onTouchMove: ye
    },
    /* @__PURE__ */ Cn.createElement("div", { class: "scrub-bar__rail" }),
    /* @__PURE__ */ Cn.createElement(ProgressBar, { calculatedPositionPercent: ve }),
    se === "ACTIVE" ? /* @__PURE__ */ Cn.createElement(AdMarkers, { adCuePoints: le, durationInSec: fe }) : null,
    /* @__PURE__ */ Cn.createElement(
      SeekBar,
      {
        durationInSec: ue,
        playbackPositionInPercent: Ee,
        showHandle: Te,
        sizeBreakpoints: te,
        tooltipPositionInPercent: Se
      }
    )
  );
};
function resolveTagAttributeValue(re) {
  return re ? "" : null;
}
function calculateClipPolygon({ segments: re, hoverSegmentIndex: te, scrubBarWidthInPx: ee }) {
  let ie = "polygon(";
  const ae = ee > 0 ? 200 / ee : 0, ue = 6, _e = 3, fe = 8, le = 11, se = 15, oe = (re == null ? void 0 : re.length) ?? 0;
  if (!(!re || oe === 0)) {
    re.forEach((ce, he) => {
      const ge = he === te, ve = ce.segmentStart.percentage * 100, me = ce.segmentEnd.percentage * 100 - ae, be = ce.segmentEnd.percentage * 100;
      if (me < ve)
        return;
      he > 0 && (ie += `,
`);
      const pe = ge ? _e : ue;
      ie += `${ve}% ${pe}px,
${me}% ${pe}px,
${me}% ${se}px,
${be}% ${se}px`;
    });
    for (let ce = oe - 1; ce >= 0; ce--) {
      const he = ce === te, ge = re[ce], ve = ge.segmentStart.percentage * 100, me = ge.segmentEnd.percentage * 100 - ae, be = ge.segmentEnd.percentage * 100;
      if (me < ve)
        continue;
      const pe = he ? le : fe;
      ie += `,
${be}% ${se}px,
${me}% ${se}px,
 ${me}% ${pe}px,
${ve}% ${pe}px`;
    }
    return ie += ")", ie;
  }
}
function calculateSegments({ durationInSec: re, markers: te }) {
  if (!te || te.length === 0)
    return [];
  let ee;
  const ie = [];
  if (te[0].positionInSec > 0) {
    const ae = {
      segmentStart: { percentage: 0, positionInSec: 0 },
      // segmentEnd will be corrected in the loop
      segmentEnd: { percentage: 0, positionInSec: 0 }
    };
    ie.push(ae), ee = ae;
  }
  return te.forEach((ae) => {
    const ue = {
      percentage: ae.positionInSec / re,
      positionInSec: ae.positionInSec
    }, _e = {
      segmentStart: ue,
      segmentEnd: { percentage: 1, positionInSec: re },
      title: ae.title
    };
    ee && (ee.segmentEnd = ue), ee = _e, ie.push(_e);
  }), ie;
}
function useVideoChapterMarkers(re, te, ee, ie) {
  const ne = F$1(
    () => calculateSegments({ durationInSec: re, markers: te }),
    [re, te]
  ), ae = F$1(
    () => ne.findIndex(
      (se) => ee >= se.segmentStart.percentage && ee <= se.segmentEnd.percentage
    ),
    [ee, ne]
  ), [ue, _e] = h$2(0);
  useResize((se) => _e(se.width), ie);
  const fe = F$1(
    () => calculateClipPolygon({
      scrubBarWidthInPx: ue,
      segments: ne,
      hoverSegmentIndex: ae
    }),
    [ne, ae, ue]
  ), le = ne.length > 0 ? ne[ae] : void 0;
  return { segments: ne, polygonString: fe, hoveredSegment: le };
}
const BufferBar = ({ calculatedPositionPercent: re, bufferedPercent: te }) => {
  const ee = Math.min(re + te, 1);
  return /* @__PURE__ */ Cn.createElement("div", { class: "buffer-bar", "data-rbup-scrub-bar-buffer": !0, style: { width: `${ee * 100}%` } });
}, VodScrubBar = ({
  onDragStatusChanged: re,
  sizeBreakpoints: te,
  hideScrubBarTooltip: ee
}) => {
  const ie = _(null), {
    playerState: { playerCoordinator: ne, playerStatus: ae, mediaMetaData: ue, playerConfiguration: _e }
  } = usePlayerContext(), fe = ne == null ? void 0 : ne.getAdCuePoints(), le = _e == null ? void 0 : _e.adMarkerEnabled, se = T$1(
    (Me, Ae) => {
      ne == null || ne.seek(Ae);
    },
    [ne]
  ), {
    onDocumentPointerUp: oe,
    onPointerLeave: ce,
    onPointerOver: he,
    onPointerDown: ge,
    onPointerMove: ve,
    bufferDurationPercent: me,
    playbackPositionInPercent: be,
    isDragging: pe,
    draggedPlaybackPositionInPercent: $e,
    durationInSec: ye,
    hovered: Se,
    showHandle: we
  } = useScrubBarEventHandling(
    ie,
    ne,
    ae,
    se,
    re,
    ee
  ), { polygonString: Pe, hoveredSegment: Te } = useVideoChapterMarkers(
    ye,
    ue == null ? void 0 : ue.videoChapterMarkers,
    $e,
    ie
  ), Ee = pe ? $e : be;
  return /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-hovered": resolveTagAttributeValue(Se),
      class: "scrub-bar",
      "data-rbup-scrub-bar": !0,
      ref: ie,
      onPointerDown: ge,
      onPointerLeave: ce,
      onPointerMove: ve,
      onPointerOver: he,
      onPointerUp: oe,
      onTouchMove: ve
    },
    /* @__PURE__ */ Cn.createElement(
      "div",
      {
        class: "scrub-bar__background-container",
        style: {
          clipPath: Pe
        }
      },
      /* @__PURE__ */ Cn.createElement("div", { class: "scrub-bar__rail" }),
      /* @__PURE__ */ Cn.createElement(
        BufferBar,
        {
          calculatedPositionPercent: be,
          bufferedPercent: me
        }
      ),
      /* @__PURE__ */ Cn.createElement(ProgressBar, { calculatedPositionPercent: be }),
      le === "ACTIVE" ? /* @__PURE__ */ Cn.createElement(AdMarkers, { adCuePoints: fe, durationInSec: ye }) : null
    ),
    /* @__PURE__ */ Cn.createElement(
      SeekBar,
      {
        durationInSec: ye,
        playbackPositionInPercent: Ee,
        segmentTitle: Te == null ? void 0 : Te.title,
        showHandle: we,
        sizeBreakpoints: te,
        tooltipPositionInPercent: $e
      }
    )
  );
}, ScrubBar = ({
  onDragStatusChanged: re,
  sizeBreakpoints: te,
  hideScrubBarTooltip: ee,
  onControlsElementEnter: ie
}) => {
  const {
    playerState: { playbackMode: ne, liveVariant: ae }
  } = usePlayerContext(), ue = ne === "LIVE" && ae === "DVR";
  return /* @__PURE__ */ Cn.createElement("div", { onPointerEnterCapture: (_e) => ie == null ? void 0 : ie(_e, !0) }, ne === "VOD" && /* @__PURE__ */ Cn.createElement(
    VodScrubBar,
    {
      sizeBreakpoints: te,
      onDragStatusChanged: re,
      hideScrubBarTooltip: ee
    }
  ), ue && /* @__PURE__ */ Cn.createElement(
    DvrScrubBar,
    {
      sizeBreakpoints: te,
      onDragStatusChanged: re,
      hideScrubBarTooltip: ee
    }
  ));
};
function useClickOutside(re, te) {
  const ee = (ie) => {
    re.current && !re.current.contains(ie.target) && te(ie);
  };
  p(() => (document.addEventListener("pointerup", ee), () => {
    document.removeEventListener("pointerup", ee);
  }));
}
const RadioButtonInternal = ({ name: re, checked: te, label: ee, onClick: ie, value: ne, appearance: ae, className: ue }, _e) => {
  const fe = _$1(), le = T$1(
    (oe) => {
      oe.stopPropagation(), ie == null || ie();
    },
    [ie]
  ), se = F$1(() => ({
    focus() {
      te && fe.current.base.inputFocus().catch((ce) => console.error("Could not set focus on CosmosRadio", ce));
    }
  }), [te, fe]);
  return A$1(_e, () => se, [se]), /* @__PURE__ */ Cn.createElement(
    CosmosRadio,
    {
      ref: fe,
      "data-rbup-radio-button": !0,
      "data-exposed-checked": resolveTagAttributeValue(te),
      "data-exposed-value": ne,
      class: ue,
      name: re,
      checked: te,
      value: ne,
      appearance: ae,
      onInputchange: le,
      "hit-area": "row"
    },
    ee
  );
}, RadioButton = k(RadioButtonInternal), AudioSettings = ({
  isPlayerSizeMedium: re,
  focusOnSelectedRadioButton: te
}) => {
  const {
    playerState: { audioTracks: ee, playerCoordinator: ie, selectedAudioTrack: ne }
  } = usePlayerContext();
  useInformPlaywright("Audio menu rendered");
  const ae = F$1(() => [...ee], [ee]), ue = (le) => ie == null ? void 0 : ie.setAudioTrack(le), _e = ae.map(
    (le) => {
      const se = le.id === (ne == null ? void 0 : ne.id), oe = _$1(), ce = /* @__PURE__ */ Cn.createElement(
        RadioButton,
        {
          ref: oe,
          className: "audio-settings__list-item",
          key: le.id,
          name: "audio-track",
          label: le.label,
          checked: se,
          value: le.id,
          onClick: () => ue(le.id)
        }
      );
      return {
        radioButtonRef: oe,
        radioButton: ce
      };
    }
  ), fe = _(!1);
  return p(() => {
    te && fe.current === !1 && _e.forEach((le) => {
      const se = le.radioButtonRef.current;
      se && (se.focus(), fe.current = !0);
    });
  }, [te, _e]), /* @__PURE__ */ Cn.createElement("div", { class: "audio-settings" }, /* @__PURE__ */ Cn.createElement(CosmosRadioGroup, { class: "audio-settings__list", appearance: re ? "dark" : "light" }, _e.map((le) => le.radioButton)));
};
function preventEventPropagation$2(re) {
  re.stopPropagation();
}
const AudioMenu = ({ onCloseMenu: re }) => {
  const te = _(null);
  useClickOutside(te, re);
  const ee = (ie) => {
    ie.stopPropagation(), ie.key === KEYCODE_ESC && re(ie);
  };
  return /* @__PURE__ */ Cn.createElement(
    "section",
    {
      ref: te,
      "data-rbup-audio-menu": !0,
      role: "dialog",
      "aria-labelledby": "rbupAudioMenuTitle",
      class: "audio-menu",
      onPointerUp: preventEventPropagation$2,
      onKeyDown: ee
    },
    /* @__PURE__ */ Cn.createElement(CosmosText, { id: "rbupAudioMenuTitle", class: "audio-menu__title", size: "x-small", weight: "bold" }, translate("menu-audioTracks")),
    /* @__PURE__ */ Cn.createElement(AudioSettings, { isPlayerSizeMedium: !0, focusOnSelectedRadioButton: !0 })
  );
}, BackButtonInternal = ({ onClick: re, text: te }, ee) => /* @__PURE__ */ Cn.createElement("button", { ref: ee, "data-rbup-back-button": !0, class: "back-button", onClick: re }, /* @__PURE__ */ Cn.createElement(CosmosIconChevronLeft, { class: "back-button__icon" }), /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small", weight: "bold" }, te)), BackButton = k(BackButtonInternal), StorageKey = {
  AUDIO_LANGUAGE: "rbup-video-audio-language",
  QUALITY: "rbup-video-quality",
  SUBTITLE_LANGUAGE: "rbup-video-subtitle-language",
  VOLUME: "rbup-video-volume"
};
function setStorageItem(re, te, ee) {
  const ie = typeof te == "string" ? te : JSON.stringify(te);
  ee.setItem(re, ie);
}
function clearSubtitleLanguage(re) {
  re.removeItem(StorageKey.SUBTITLE_LANGUAGE);
}
function getAudioLanguage(re) {
  return re.getItem(StorageKey.AUDIO_LANGUAGE);
}
function getQualityHeight(re) {
  const te = re.getItem(StorageKey.QUALITY);
  return te ? parseInt(te, 10) : null;
}
function getSubtitleLanguage(re) {
  return re.getItem(StorageKey.SUBTITLE_LANGUAGE);
}
function getVolume(re) {
  const te = re.getItem(StorageKey.VOLUME);
  return te ? parseInt(te, 10) : null;
}
function setAudioLanguage(re, te) {
  setStorageItem(StorageKey.AUDIO_LANGUAGE, re, te);
}
function setQualityHeight(re, te) {
  setStorageItem(StorageKey.QUALITY, re, te);
}
function setSubtitleLanguage(re, te) {
  setStorageItem(StorageKey.SUBTITLE_LANGUAGE, re, te);
}
function setVolume(re, te) {
  setStorageItem(StorageKey.VOLUME, re, te);
}
const MIN_HD_HEIGHT = 720, HIGH_FRAMRATE_DISPLAY_THRESHOLD = 31;
function getQualityLabel(re, te = 0) {
  const ee = te >= HIGH_FRAMRATE_DISPLAY_THRESHOLD ? `${re}p${te}` : `${re}p`;
  return re >= MIN_HD_HEIGHT ? `${ee} HD` : ee;
}
const getLabel = (re) => re.label ?? getQualityLabel(re.height, re.frameRate), QualitySettings = ({ isPlayerSizeMedium: re }) => {
  const {
    playerState: { playerCoordinator: te, selectedVideoQuality: ee, videoQualities: ie }
  } = usePlayerContext(), [ne, ae] = h$2(ee), ue = useObjectArrayCache(ie, "id"), _e = F$1(() => {
    const fe = [...ue];
    return [
      { id: "auto", label: translate("menu-quality-auto") },
      ...fe.reverse()
    ];
  }, [ue]);
  return useInformPlaywright("Quality menu rendered"), p(() => {
    ne && ne.id !== ee.id && (te == null || te.setVideoQuality(ne.id), setQualityHeight(ne.height, window.sessionStorage));
  }, [te, ne, ee]), /* @__PURE__ */ Cn.createElement("div", { class: "quality-settings", "data-rbup-quality-menu": !0 }, /* @__PURE__ */ Cn.createElement(CosmosRadioGroup, { class: "quality-settings__list", appearance: re ? "dark" : "light" }, _e.map((fe) => {
    const le = fe.id === (ne == null ? void 0 : ne.id);
    return /* @__PURE__ */ Cn.createElement(
      RadioButton,
      {
        className: "quality-settings__list-item",
        key: fe.id,
        name: "quality",
        label: getLabel(fe),
        checked: le,
        value: fe.id,
        onClick: () => ae(fe)
      }
    );
  })));
}, MenuButtonInternal = ({ href: re, id: te, onClick: ee, settingText: ie, text: ne }, ae) => {
  const ue = te.toLowerCase();
  return re ? /* @__PURE__ */ Cn.createElement(
    "button",
    {
      "data-rbup-menu-button": ue,
      "data-rbup": `data-rbup-${ue}-menu-button`,
      ref: ae,
      class: "settings-menu-button"
    },
    /* @__PURE__ */ Cn.createElement(CosmosText, { class: "settings-menu-button__label", size: "x-small" }, /* @__PURE__ */ Cn.createElement(CosmosLink, { tabIndex: -1, href: re, kind: "bare", target: "_blank" }, ne))
  ) : /* @__PURE__ */ Cn.createElement(
    "button",
    {
      "data-rbup-menu-button": ue,
      "data-rbup": `data-rbup-${ue}-menu-button`,
      ref: ae,
      class: "settings-menu-button",
      onClick: ee
    },
    /* @__PURE__ */ Cn.createElement(CosmosText, { class: "settings-menu-button__label", size: "x-small" }, ne),
    /* @__PURE__ */ Cn.createElement("div", { class: "settings-menu-button__selected-setting" }, ie && /* @__PURE__ */ Cn.createElement(CosmosText, { size: "xx-small", kind: "subtle" }, ie), /* @__PURE__ */ Cn.createElement(CosmosIconChevronRight, { class: "settings-menu-button__icon" }))
  );
}, MenuButton = k(MenuButtonInternal);
function calculatePlaybackSpeedText(re) {
  return re === 1 ? translate("menu-speeds-normal") : String(re);
}
const SettingsMainMenu = ({ onNavClick: re, mainMenuRef: te }) => {
  const {
    playerState: {
      audioTracks: ee,
      playbackSpeed: ie,
      playerCoordinator: ne,
      selectedVideoQuality: ae,
      subtitleTracks: ue,
      videoQualities: _e,
      liveVariant: fe
    }
  } = usePlayerContext(), le = ne == null ? void 0 : ne.getPlayerConfiguration().feedbackUrl, se = (ne == null ? void 0 : ne.getPlayerConfiguration().sharingEnabled) ?? !0, oe = calculatePlaybackSpeedText(ie), ce = getQualityLabel(ae.height, ae.frameRate), he = ae.isAuto ? `Auto ${ce}` : ce, ge = _e.length > 1, ve = ue.length > 0, me = fe !== "LINEAR", be = ee.length > 1;
  return /* @__PURE__ */ Cn.createElement("div", { ref: te }, ge && /* @__PURE__ */ Cn.createElement(
    MenuButton,
    {
      id: "quality",
      onClick: () => re("QUALITY"),
      settingText: he,
      text: translate("menu-quality")
    }
  ), me && /* @__PURE__ */ Cn.createElement(
    MenuButton,
    {
      id: "speed",
      onClick: () => re("SPEED"),
      settingText: oe,
      text: translate("menu-speeds")
    }
  ), ve && /* @__PURE__ */ Cn.createElement(MenuButton, { id: "subtitles", onClick: () => re("SUBTITLES"), text: translate("menu-subtitles") }), be && /* @__PURE__ */ Cn.createElement(MenuButton, { id: "audio", onClick: () => re("AUDIO"), text: translate("menu-audioTracks") }), se && /* @__PURE__ */ Cn.createElement(MenuButton, { id: "share", onClick: () => re("SHARE"), text: translate("menu-sharing") }), le && /* @__PURE__ */ Cn.createElement(MenuButton, { id: "feedback", href: le, text: translate("menu-feedback") }));
};
function useOnMountSize(re, te) {
  const ee = _(0), ie = T$1(
    (ne) => {
      const ae = ne.height;
      ee.current = ae, re == null || re(ae);
    },
    [re]
  );
  useResize(ie, te), p(() => {
    const ne = ee.current;
    ne > 0 && (re == null || re(ne));
  }, [re]);
}
const SettingsWrapper = ({
  children: re,
  cssClass: te,
  enterPosition: ee,
  leavePosition: ie,
  show: ne,
  widthInPx: ae,
  onMounted: ue
}) => {
  const [_e, fe] = h$2(!1), le = () => {
    _e && !ne && fe(!1);
  };
  p(() => {
    !_e && ne && fe(!0);
  }, [_e, ne]);
  const oe = { transform: `translateX(-${ne ? ee : ie}px)`, width: ae };
  return /* @__PURE__ */ Cn.createElement("div", { class: te, style: oe, onTransitionEnd: le }, _e ? /* @__PURE__ */ Cn.createElement(SettingsView, { onMounted: ue }, re) : null);
}, SettingsView = ({ children: re, onMounted: te }) => {
  const ee = _(null);
  return useOnMountSize(te, ee), /* @__PURE__ */ Cn.createElement("div", { class: "settings-menu__settings-wrapper", ref: ee }, /* @__PURE__ */ Cn.createElement("div", null, re));
};
function calculateFromSS(re) {
  const te = parseInt(re[0], 10);
  return isNaN(te) ? 0 : te;
}
function calculateFromMMSS(re) {
  const te = parseInt(re[1], 10), ee = parseInt(re[0], 10);
  return isNaN(te) || isNaN(ee) ? 0 : te + ee * 60;
}
function calculateFromHHMMSS(re) {
  const te = parseInt(re[2], 10), ee = parseInt(re[1], 10), ie = parseInt(re[0], 10);
  return isNaN(te) || isNaN(ee) || isNaN(ie) ? 0 : te + ee * 60 + ie * 60 * 60;
}
function convertTimeStringToSec(re) {
  const te = re.split(":");
  return te.length === 1 ? calculateFromSS(te) : te.length === 2 ? calculateFromMMSS(te) : te.length === 3 ? calculateFromHHMMSS(te) : 0;
}
const log$b = loglevelExports.getLogger("ShareSettingsInternal"), ARROW_KEYS = [KEYCODE_ARROW_LEFT, KEYCODE_ARROW_RIGHT];
function initialShareUrlWithTime(re) {
  return (re == null ? void 0 : re.urlSharingStrategy.calculateShareUrl("PAGE", {
    assetId: re.getPlayerConfiguration().assetId
  })) ?? "";
}
const ShareSettingsInternal = ({ isPlayerSizeMedium: re }) => {
  const {
    playerState: { mediaMetaData: te, playbackPosInSec: ee, playerCoordinator: ie, playerConfiguration: ne, playbackMode: ae }
  } = usePlayerContext(), ue = !!window.navigator.clipboard, _e = _(0), [fe, le] = h$2(!1), [se, oe] = h$2(!1), [ce, he] = h$2(!1), [ge, ve] = h$2(0), [me, be] = h$2(initialShareUrlWithTime(ie)), [pe, $e] = h$2(""), [ye, Se] = h$2(""), [we, Pe] = h$2(""), [Te, Ee] = h$2(""), [Me, Ae] = h$2(""), Ne = !!(ie != null && ie.urlSharingStrategy.isSharingEnabled()), Ce = ne == null ? void 0 : ne.iframeEmbedCode;
  useInformPlaywright("Share menu rendered");
  const Ie = async () => {
    fe || await copy(me) && le(!0);
  }, xe = async () => {
    Ce && (fe || await copy(Ce) && oe(!0));
  }, Ue = (Re) => {
    he(Re.detail.checked);
  }, ke = (Re) => {
    const Oe = convertTimeStringToSec(Re.currentTarget.value);
    ve(Oe), $e(Re.currentTarget.value);
  }, Le = (Re) => {
    ARROW_KEYS.includes(Re.key) && Re.stopPropagation();
  };
  p(() => {
    ve(Math.floor(ee)), $e(getFormattedTimeString(ee));
  }, []), p(() => {
    if (!ie)
      return;
    const Re = {
      assetId: ie.getPlayerConfiguration().assetId,
      title: te == null ? void 0 : te.title,
      imageUrl: te == null ? void 0 : te.posterImageUrl,
      mediaPositionInSec: ce ? ge : void 0
    };
    be(ie.urlSharingStrategy.calculateShareUrl("PAGE", Re)), Se(ie.urlSharingStrategy.calculateShareUrl("FACEBOOK", Re)), Pe(ie.urlSharingStrategy.calculateShareUrl("PINTEREST", Re)), Ee(ie.urlSharingStrategy.calculateShareUrl("REDDIT", Re)), Ae(ie.urlSharingStrategy.calculateShareUrl("TWITTER", Re));
  }, [te, ge, ce, ie]), p(() => (fe && (_e.current = window.setTimeout(() => le(!1), 3e3)), se && (_e.current = window.setTimeout(() => oe(!1), 3e3)), () => {
    window.clearTimeout(_e.current);
  }), [se, fe]);
  const De = ae === "VOD";
  return /* @__PURE__ */ Cn.createElement("div", { class: "share-settings" }, De && /* @__PURE__ */ Cn.createElement("div", { class: "share-settings__share-time" }, /* @__PURE__ */ Cn.createElement(
    CosmosCheckbox,
    {
      "data-rbup-share-time-checkbox": !0,
      name: "sharetime",
      checked: ce,
      onInputchange: Ue,
      clamp: !0,
      value: "true",
      appearance: re ? "dark" : "light"
    },
    translate("menu-sharing-playFrom")
  ), /* @__PURE__ */ Cn.createElement(
    "input",
    {
      "data-rbup-share-time-input": !0,
      class: "share-settings__time-input",
      disabled: !ce,
      value: pe,
      onChange: ke,
      onKeyDown: Le
    }
  )), /* @__PURE__ */ Cn.createElement("ul", { class: "share-settings__list" }, ue && Ce && /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__copy-iframe-code-button" }, /* @__PURE__ */ Cn.createElement(
    CosmosButton,
    {
      class: "share-settings__iframe-code",
      kind: "link",
      size: "small",
      onClick: xe
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconCodeBlock, { class: "share-settings__iframe-code-icon", slot: "icon" }),
    /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, translate("menu-sharing-embed"))
  ), se && /* @__PURE__ */ Cn.createElement("div", { class: "share-settings__copied-text" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, translate("menu-sharing-copied")))), Ne && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__list-item" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, /* @__PURE__ */ Cn.createElement(
    CosmosLink,
    {
      "data-rbup-fb-link": !0,
      class: "share-settings__link",
      href: ye,
      kind: "bare",
      target: "_blank",
      rel: "noopener nofollow"
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconFacebook, null),
    translate("menu-sharing-facebook")
  ))), /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__list-item" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, /* @__PURE__ */ Cn.createElement(
    CosmosLink,
    {
      "data-rbup-twitter-link": !0,
      class: "share-settings__link",
      href: Me,
      kind: "bare",
      target: "_blank",
      rel: "noopener nofollow"
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconX, null),
    translate("menu-sharing-twitter")
  ))), /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__list-item" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, /* @__PURE__ */ Cn.createElement(
    CosmosLink,
    {
      "data-rbup-pinterest-link": !0,
      class: "share-settings__link",
      href: we,
      kind: "bare",
      target: "_blank",
      rel: "noopener nofollow"
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconPinterest, null),
    translate("menu-sharing-pinterest")
  ))), /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__list-item" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, /* @__PURE__ */ Cn.createElement(
    CosmosLink,
    {
      "data-rbup-reddit-link": !0,
      class: "share-settings__link",
      href: Te,
      kind: "bare",
      target: "_blank",
      rel: "noopener nofollow"
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconReddit, null),
    translate("menu-sharing-reddit")
  ))), ue && /* @__PURE__ */ Cn.createElement("li", { class: "share-settings__copy-button" }, /* @__PURE__ */ Cn.createElement(
    CosmosButton,
    {
      class: "share-settings__link",
      kind: "link",
      size: "small",
      onClick: Ie
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconLink, { class: "share-settings__link-icon", slot: "icon" }),
    /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, translate("menu-sharing-copyLink"))
  ), fe && /* @__PURE__ */ Cn.createElement("div", { class: "share-settings__copied-text" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "x-small" }, translate("menu-sharing-copied")))))));
}, ShareSettings = k(ShareSettingsInternal);
async function copy(re) {
  try {
    return await window.navigator.clipboard.writeText(re), !0;
  } catch (te) {
    return log$b.error("Failed to copy to clipboard", te), !1;
  }
}
const SPEED_1_X_OPTION = { speed: 1, useLabel: !0 }, AVAILABLE_SPEED_OPTIONS = [
  { speed: 0.25 },
  { speed: 0.5 },
  { speed: 0.75 },
  SPEED_1_X_OPTION,
  { speed: 1.25 },
  { speed: 1.5 },
  { speed: 1.75 },
  { speed: 2 }
], SpeedSettings = ({ isPlayerSizeMedium: re }) => {
  const {
    playerState: { playerCoordinator: te, playbackSpeed: ee }
  } = usePlayerContext(), [ie, ne] = h$2(
    AVAILABLE_SPEED_OPTIONS.find((_e) => _e.speed === ee)
  ), ae = ie == null ? void 0 : ie.speed, ue = (_e) => {
    _e.speed !== ae && (te == null || te.setPlaybackSpeed(_e.speed));
  };
  return useInformPlaywright("Speed menu rendered"), p(() => {
    if (ae !== ee) {
      const _e = AVAILABLE_SPEED_OPTIONS.find((fe) => fe.speed === ee);
      _e && ne(_e);
    }
  }, [ee, ae]), /* @__PURE__ */ Cn.createElement("div", { class: "speed-settings" }, /* @__PURE__ */ Cn.createElement(CosmosRadioGroup, { class: "speed-settings__list", appearance: re ? "dark" : "light" }, AVAILABLE_SPEED_OPTIONS.map((_e) => {
    const fe = _e.speed === ae;
    return /* @__PURE__ */ Cn.createElement(
      RadioButton,
      {
        className: "speed-settings__list-item",
        key: `speed-option-${_e.speed}`,
        name: "speed",
        checked: fe,
        label: _e.useLabel ? translate("menu-speeds-normal") : String(_e.speed),
        value: _e.speed.toString(),
        onClick: () => {
          ue(_e);
        }
      }
    );
  })));
}, SubtitlesSettings = ({
  isPlayerSizeMedium: re,
  focusOnSelectedRadioButton: te
}) => {
  const {
    playerState: { subtitleTracks: ee, selectedSubtitleTrack: ie, playerCoordinator: ne }
  } = usePlayerContext();
  useInformPlaywright("Subtitles menu rendered");
  const ae = F$1(() => [...ee], [ee]), ue = F$1(() => {
    const fe = _$1();
    return [
      {
        radioButtonRef: fe,
        radioButton: /* @__PURE__ */ Cn.createElement(
          RadioButton,
          {
            className: "subtitles-settings__list-item",
            name: "subtitles",
            ref: fe,
            label: translate("menu-subtitles-off"),
            checked: !ie,
            value: "off",
            onClick: () => ne == null ? void 0 : ne.disableSubtitle()
          }
        )
      },
      ...ae.map((le) => {
        const se = le.id === (ie == null ? void 0 : ie.id), oe = _$1(), ce = /* @__PURE__ */ Cn.createElement(
          RadioButton,
          {
            ref: oe,
            className: "subtitles-settings__list-item",
            key: le.id,
            name: "subtitles",
            label: le.label,
            checked: se,
            value: le.id,
            onClick: () => ne == null ? void 0 : ne.enableSubtitle(le.id)
          }
        );
        return {
          radioButtonRef: oe,
          radioButton: ce
        };
      })
    ];
  }, [ae, ne, ie]), _e = _(!1);
  return p(() => {
    te && _e.current === !1 && ue.forEach((fe) => {
      const le = fe.radioButtonRef.current;
      le && (le.focus(), _e.current = !0);
    });
  }, [te, ue]), /* @__PURE__ */ Cn.createElement("div", { class: "subtitles-settings" }, /* @__PURE__ */ Cn.createElement(CosmosRadioGroup, { class: "subtitles-settings__list", appearance: re ? "dark" : "light" }, ue.map((fe) => fe.radioButton)));
}, FULL_HEIGHT = "100%";
function preventEventPropagation$1(re) {
  re.stopPropagation();
}
const updateHeightsCache = (re, te, ee) => {
  re.current = {
    ...re.current,
    [te]: ee
  };
}, defaultSettingsAreaDimensions = { width: 320 }, SettingsMenu = ({ activateResizing: re, onCloseMenu: te }) => {
  const ee = !re, [ie, ne] = h$2("MAIN_MENU"), [ae, ue] = h$2({}), _e = _(null), fe = _({}), [le, se] = h$2("settings-menu"), oe = _(null), ce = _(null), he = _(null), ge = _(null), ve = _(null), me = _(null);
  useInformPlaywright("Settings menu rendered");
  const {
    playerState: { playerCoordinator: be }
  } = usePlayerContext(), pe = be == null ? void 0 : be.getPlayerConfiguration().sharingEnabled;
  useClickOutside(_e, te);
  const $e = T$1(
    (Ie) => {
      Ie && (updateHeightsCache(fe, ie, Ie), re && ue({ height: Ie }));
    },
    [re, ie]
  ), ye = () => {
    Se("MAIN_MENU");
  }, Se = T$1((Ie) => {
    ne(Ie);
  }, []), we = T$1(
    (Ie) => {
      $e(`${Ie}px`);
    },
    [$e]
  ), Pe = T$1(() => {
    if (oe.current) {
      const Ie = oe.current.children.item(0);
      Ie && Ie.focus({ preventScroll: !0 });
    }
  }, []), Te = T$1((Ie) => {
    var xe;
    (xe = Ie.current) == null || xe.focus({ preventScroll: !0 });
  }, []), Ee = T$1(
    (Ie) => {
      if (Ie.propertyName === "height")
        switch (ie) {
          case "MAIN_MENU":
            Pe();
            break;
          case "QUALITY":
            Te(ce);
            break;
          case "SPEED":
            Te(he);
            break;
          case "SHARE":
            Te(ge);
            break;
          case "SUBTITLES":
            Te(ve);
            break;
          case "AUDIO":
            Te(me);
            break;
        }
    },
    [ie, Pe, Te]
  ), Me = (Ie) => {
    (Ie.key === KEYCODE_ARROW_DOWN || Ie.key === KEYCODE_ARROW_UP) && Ie.stopPropagation(), Ie.key === KEYCODE_ESC && (ie !== "MAIN_MENU" ? ye() : te(Ie));
  };
  p(() => {
    const Ie = re ? fe.current[ie] : FULL_HEIGHT;
    Ie && Ie !== ae.height && ue({ height: Ie }), ie !== "MAIN_MENU" && se("settings-menu settings-menu-animation");
  }, [re, ie, ae.height]);
  const Ae = _(!1);
  Ae.current === !1 && oe.current && (Pe(), Ae.current = !0);
  const Ne = _(null), { width: Ce } = useMeasure(Ne, defaultSettingsAreaDimensions);
  return /* @__PURE__ */ Cn.createElement(
    "section",
    {
      "data-rbup-settings-menu": !0,
      ref: _e,
      role: "dialog",
      "aria-labelledby": "rbupMenuTitle",
      class: le,
      style: ae,
      onPointerUp: preventEventPropagation$1,
      onKeyDown: Me,
      onTransitionEnd: Ee
    },
    /* @__PURE__ */ Cn.createElement("p", { class: "g-screen-reader-only settings-menu__invisible-title", id: "rbupMenuTitle" }, translate("tooltip-settings")),
    /* @__PURE__ */ Cn.createElement("div", { class: "settings-menu__settings-area", ref: Ne }, /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page",
        enterPosition: 0,
        leavePosition: Ce,
        show: ie === "MAIN_MENU",
        widthInPx: Ce,
        onMounted: we
      },
      /* @__PURE__ */ Cn.createElement(SettingsMainMenu, { onNavClick: Se, mainMenuRef: oe })
    ), /* @__PURE__ */ Cn.createElement("div", { class: "settings-menu__settings-container" }, /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page--positioned",
        enterPosition: Ce,
        leavePosition: 0,
        show: ie === "QUALITY",
        widthInPx: Ce,
        onMounted: we
      },
      /* @__PURE__ */ Cn.createElement(
        BackButton,
        {
          onClick: ye,
          text: translate("menu-quality"),
          ref: ce
        }
      ),
      /* @__PURE__ */ Cn.createElement(QualitySettings, { isPlayerSizeMedium: re })
    ), /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page--positioned",
        enterPosition: Ce,
        leavePosition: 0,
        show: ie === "SUBTITLES",
        widthInPx: Ce,
        onMounted: we
      },
      /* @__PURE__ */ Cn.createElement(
        BackButton,
        {
          onClick: ye,
          text: translate("menu-subtitles"),
          ref: ve
        }
      ),
      /* @__PURE__ */ Cn.createElement(SubtitlesSettings, { isPlayerSizeMedium: re, focusOnSelectedRadioButton: !1 })
    ), /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page--positioned",
        enterPosition: Ce,
        leavePosition: 0,
        show: ie === "SPEED",
        widthInPx: Ce,
        onMounted: we
      },
      /* @__PURE__ */ Cn.createElement(
        BackButton,
        {
          onClick: ye,
          text: translate("menu-speeds"),
          ref: he
        }
      ),
      /* @__PURE__ */ Cn.createElement(SpeedSettings, { isPlayerSizeMedium: re })
    ), /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page--positioned",
        enterPosition: Ce,
        leavePosition: 0,
        show: ie === "AUDIO",
        widthInPx: Ce,
        onMounted: we
      },
      /* @__PURE__ */ Cn.createElement(
        BackButton,
        {
          onClick: ye,
          text: translate("menu-audioTracks"),
          ref: me
        }
      ),
      /* @__PURE__ */ Cn.createElement(AudioSettings, { isPlayerSizeMedium: re, focusOnSelectedRadioButton: !1 })
    ), pe && /* @__PURE__ */ Cn.createElement(
      SettingsWrapper,
      {
        cssClass: "settings-menu__settings-page--positioned",
        enterPosition: Ce,
        leavePosition: 0,
        show: ie === "SHARE",
        widthInPx: Ce,
        onMounted: we
      },
      /* @__PURE__ */ Cn.createElement(
        BackButton,
        {
          onClick: ye,
          text: translate("menu-sharing"),
          ref: ge
        }
      ),
      /* @__PURE__ */ Cn.createElement(ShareSettings, { isPlayerSizeMedium: re })
    ))),
    ee && /* @__PURE__ */ Cn.createElement("div", { class: "settings-menu__close-button" }, /* @__PURE__ */ Cn.createElement(
      CosmosButton,
      {
        ariaLabel: translate("button-closeMenu"),
        kind: "secondary",
        shape: "circle",
        onClick: te
      },
      /* @__PURE__ */ Cn.createElement(CosmosIconClose, { slot: "icon" })
    ))
  );
};
function preventEventPropagation(re) {
  re.stopPropagation();
}
const SubtitlesMenu = ({ onCloseMenu: re }) => {
  const te = _(null);
  useClickOutside(te, re);
  const ee = (ie) => {
    ie.stopPropagation(), ie.key === KEYCODE_ESC && re(ie);
  };
  return /* @__PURE__ */ Cn.createElement(
    "section",
    {
      ref: te,
      "data-rbup-subtitles-menu": !0,
      role: "dialog",
      "aria-labelledby": "rbupSubtitlesMenuTitle",
      class: "subtitles-menu",
      onPointerUp: preventEventPropagation,
      onKeyDown: ee
    },
    /* @__PURE__ */ Cn.createElement(CosmosText, { id: "rbupSubtitlesMenuTitle", class: "subtitles-menu__title", size: "x-small", weight: "bold" }, translate("menu-subtitles")),
    /* @__PURE__ */ Cn.createElement(SubtitlesSettings, { isPlayerSizeMedium: !0, focusOnSelectedRadioButton: !0 })
  );
}, CenterControls = ({
  isPlayerSizeMedium: re,
  CenteredToastComponent: te
}) => !te || !re ? null : /* @__PURE__ */ Cn.createElement("div", { class: "center-controls" }, /* @__PURE__ */ Cn.createElement(te, null)), Nt = class Nt {
  constructor(te, ee, ie, ne) {
    Et(this, "velocityReduction", 1);
    Et(this, "pointerHasMoved", !1);
    Et(this, "viewingProjection", { x: 0, y: 0, clientX: 0, clientY: 0 });
    Et(this, "onPointerDown", (te) => {
      this.viewingProjection = this.resolveInitialViewingProjectionCoordinates(te), this.velocityReduction = this.isMobileDevice ? Nt.VR_VELOCITY_REDUCTION_MOBILE : Nt.VR_VELOCITY_REDUCTION_DESKTOP, this.addPointerEventListeners();
    });
    Et(this, "onPointerMove", (te) => {
      var ne;
      te.preventDefault();
      const { x: ee, y: ie } = this.calculateViewingDirection(te);
      (ne = this.playerData) == null || ne.setViewingDirection(ee, ie), this.pointerHasMoved = this.detectPointerMove(ee, ie);
    });
    Et(this, "onPointerUp", () => {
      this.removePointerEventListeners(), this.pointerHasMoved && this.showControlsTimeout.current > -1 && window.clearTimeout(this.showControlsTimeout.current), this.setPointerType("grab"), this.pointerHasMoved = !1;
    });
    this.showControlsTimeout = te, this.isMobileDevice = ee, this.setPointerType = ie, this.playerData = ne;
  }
  addPointerEventListeners() {
    document.addEventListener("pointermove", this.onPointerMove, { passive: !1 }), document.addEventListener("touchmove", this.onPointerMove, { passive: !1 }), document.addEventListener("pointerup", this.onPointerUp), document.addEventListener("touchend", this.onPointerUp);
  }
  removePointerEventListeners() {
    document.removeEventListener("pointermove", this.onPointerMove), document.removeEventListener("touchmove", this.onPointerMove), document.removeEventListener("pointerup", this.onPointerUp), document.removeEventListener("touchend", this.onPointerUp);
  }
  detectPointerMove(te, ee) {
    var _e;
    const ie = (_e = this.playerData) == null ? void 0 : _e.getViewingDirection();
    if (!ie)
      return !1;
    const ne = 0.01, ae = ie.x - te, ue = ie.y - ee;
    return Math.abs(ae) > ne || Math.abs(ue) > ne;
  }
  resolveInitialViewingProjectionCoordinates(te) {
    var ue;
    const { x: ee, y: ie } = ((ue = this.playerData) == null ? void 0 : ue.getViewingDirection()) ?? { x: 0, y: 0 }, { clientX: ne, clientY: ae } = this.resolveInputEventPointerCoordinates(te);
    return { x: ee, y: ie, clientX: ne, clientY: ae };
  }
  calculateViewingDirection(te) {
    const { clientX: ee, clientY: ie } = this.resolveInputEventPointerCoordinates(te), ne = (ee - this.viewingProjection.clientX) / this.velocityReduction, ae = (ie - this.viewingProjection.clientY) / this.velocityReduction, ue = ne + this.viewingProjection.x, _e = ae + this.viewingProjection.y;
    return { x: ue, y: _e };
  }
  resolveInputEventPointerCoordinates(te) {
    if (typeof TouchEvent < "u" && te instanceof TouchEvent)
      return te.touches.length === 0 ? { clientX: 0, clientY: 0 } : { clientX: te.touches[0].clientX, clientY: te.touches[0].clientY };
    if (te instanceof MouseEvent)
      return { clientX: te.clientX, clientY: te.clientY };
    throw new Error("Unsupported event type");
  }
  destroy() {
    this.removePointerEventListeners();
  }
};
Et(Nt, "VR_VELOCITY_REDUCTION_DESKTOP", 10), Et(Nt, "VR_VELOCITY_REDUCTION_MOBILE", 5);
let VRVideoPointerControl = Nt;
const DEFAULT_DOUBLE_TAP_INTERVAL = 300, ClickAndTapOverlay = ({ onPointerMove: re }) => {
  const te = _(/* @__PURE__ */ new Date("1987-04-17T00:00:00")), ee = _(0), ie = _(-1), ne = _(-1), ae = _(-1), ue = _(void 0), [_e, fe] = h$2(!1), [le, se] = h$2(!1), [oe, ce] = h$2("default"), {
    playerState: { playerCoordinator: he, playerStatus: ge, isVRVideo: ve }
  } = usePlayerContext(), me = isLiveLinearResolver(he), { hideControls: be, showControlsTemporarily: pe, toggleControlsVisibility: $e, menuState: ye, setMenuState: Se } = useControlsVisibilityContext(), we = F$1(() => {
    if (ve) {
      const Re = isMobileDevice();
      return ce("grab"), new VRVideoPointerControl(
        ne,
        Re,
        ce,
        he == null ? void 0 : he.getPlayerData()
      );
    }
  }, [ve, he]), Pe = `fast-forward-backward-container__fast-backward-container${le ? " fast-forward-backward-container__fast-backward-container--show-animation" : ""}`, Te = `fast-forward-backward-container__fast-forward-container${_e ? " fast-forward-backward-container__fast-forward-container--show-animation" : ""}`;
  (le || _e) && be();
  const Me = () => {
    isMobileDevice() || he == null || he.toggleFullscreen();
  }, Ae = (Re) => {
    isLeftClick(Re) && pe(), isTouch(Re) && (window.clearTimeout(ne.current), ne.current = window.setTimeout(() => {
      $e();
    }, DEFAULT_DOUBLE_TAP_INTERVAL));
  }, Ne = (Re) => {
    Ie(Re, "left");
  }, Ce = (Re) => {
    Ie(Re, "right");
  }, Ie = (Re, Oe) => {
    ye !== "CLOSED" ? Se("CLOSED") : isLeftClick(Re) && !ve && !me ? handlePlayPauseToggle(ge, he) : isLeftClick(Re) && me ? he == null || he.stop() : isTouch(Re) && Ue(Oe);
  }, xe = (Re) => Re.getTime() - te.current.getTime() <= DEFAULT_DOUBLE_TAP_INTERVAL, Ue = (Re) => {
    const Oe = /* @__PURE__ */ new Date();
    xe(Oe) && ue.current === Re && (ee.current += 1, window.clearTimeout(ne.current), Re === "left" ? (se(!0), ke(-DEFAULT_SEEK_SKIP_SECONDS)) : (fe(!0), ke(DEFAULT_SEEK_SKIP_SECONDS))), te.current = Oe, ue.current = Re;
  }, ke = (Re) => {
    window.clearTimeout(ie.current), ie.current = window.setTimeout(() => {
      he == null || he.seekOrTimeshiftRelative(ee.current * Re), ee.current = 0, window.clearTimeout(ae.current), ae.current = window.setTimeout(() => {
        se(!1), fe(!1), pe();
      }, 200);
    }, DEFAULT_DOUBLE_TAP_INTERVAL);
  }, Le = (Re) => {
    ve && (ce("grabbing"), we == null || we.onPointerDown(Re));
  };
  p(() => () => {
    window.clearTimeout(ie.current), window.clearTimeout(ne.current), window.clearTimeout(ae.current), we == null || we.destroy();
  }, [we]);
  const De = `click-and-tap-overlay-container ${oe}`;
  return /* @__PURE__ */ Cn.createElement(
    "div",
    {
      class: De,
      "data-play-pause-capture": !0,
      onDblClick: Me,
      onPointerMove: re,
      onPointerUpCapture: Ae,
      onPointerDown: Le,
      role: "button"
    },
    /* @__PURE__ */ Cn.createElement("div", { "data-play-pause-left-capture": !0, onPointerUp: Ne }, /* @__PURE__ */ Cn.createElement("div", { class: "fast-forward-backward-container" }, /* @__PURE__ */ Cn.createElement("div", { class: Pe }, /* @__PURE__ */ Cn.createElement("div", { className: "fast-backward-animation__arrow" }), /* @__PURE__ */ Cn.createElement("div", { className: "fast-backward-animation__arrow animation__arrow--outer" })))),
    /* @__PURE__ */ Cn.createElement("div", { "data-play-pause-right-capture": !0, onPointerUp: Ce }, /* @__PURE__ */ Cn.createElement("div", { class: "fast-forward-backward-container" }, /* @__PURE__ */ Cn.createElement("div", { class: Te }, /* @__PURE__ */ Cn.createElement("div", { className: "fast-forward-animation__arrow" }), /* @__PURE__ */ Cn.createElement("div", { className: "fast-forward-animation__arrow animation__arrow--outer" }))))
  );
};
function useTooltipVisibility() {
  const {
    playerState: { isFullscreenMode: re }
  } = usePlayerContext(), [te, ee] = h$2(!1), [ie, ne] = h$2(""), ae = T$1((_e, fe) => {
    isMouse(fe) && (ne(_e), ee(!0));
  }, []), ue = T$1(() => {
    ee(!1);
  }, []);
  return p(() => {
    ee(!1);
  }, [re]), {
    tooltipVisibility: te,
    tooltipText: ie,
    onTooltipUpdate: ae,
    hideTooltip: ue
  };
}
const LIVE_EDGE_MAX_TIME_SHIFT = -4, LiveButton = ({ onTooltipUpdate: re }) => {
  const {
    playerState: { playerCoordinator: te }
  } = usePlayerContext(), ee = isVideoCurrentlyLive(te), ie = T$1(() => {
    ee || te == null || te.timeShift(0);
  }, [ee, te]), ne = F$1(() => ee ? "" : translate("tooltip-dvr"), [ee]), ae = ee ? /* @__PURE__ */ Cn.createElement(CosmosIconLive, { "data-rbup-icon-live": !0, class: "g-icon live-button__icon", slot: "icon" }) : /* @__PURE__ */ Cn.createElement(CosmosIconReplay, { "data-rbup-icon-replay": !0, class: "g-icon live-button__icon", slot: "icon" }), ue = translate(ee ? "liveStream-live" : "liveStream-seekBackToLive");
  return /* @__PURE__ */ Cn.createElement("div", { class: ee ? "live-button-live" : "live-button" }, /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: ee ? "data-rbup-live" : "data-rbup-dvr",
      label: ue,
      Icon: ae,
      onPointerUp: ie,
      tooltipText: ne,
      onTooltipUpdate: re,
      size: "small",
      shape: "pill",
      appearance: "light",
      buttonLabel: ue,
      disabled: ee
    }
  ));
};
function isVideoCurrentlyLive(re) {
  return ((re == null ? void 0 : re.getTimeShiftInSec()) ?? 0) > LIVE_EDGE_MAX_TIME_SHIFT || (re == null ? void 0 : re.getLiveVariant()) === "LINEAR";
}
function getLabelText(re, te) {
  return te ? re === 0 ? translate("multiChannel-seeSchedule") : re === 1 ? translate("multiChannel-singleStreamLive", { figure: "1" }) : translate("multiChannel-multipleStreamsLive", { figure: `${re}` }) : "";
}
const MultiChannelButton = ({
  isPlayerSizeMedium: re,
  onTooltipUpdate: te,
  onPointerUp: ee
}) => {
  var le;
  const {
    playerState: { liveStatus: ie }
  } = usePlayerContext(), ne = translate("multiChannel-seeSchedule"), ae = T$1(() => {
    ee == null || ee();
  }, [ee]), ue = ((le = ie == null ? void 0 : ie.otherLiveVideos) == null ? void 0 : le.filter((se) => se.phase === "live").length) ?? 0, _e = getLabelText(ue, re), fe = re ? "pill" : "circle";
  return /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-button" }, /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "data-rbup-multi-channel",
      label: _e,
      Icon: /* @__PURE__ */ Cn.createElement(CosmosIconBrowse, { "data-rbup-icon-browse": !0, class: "g-icon", slot: "icon" }),
      onPointerUp: ae,
      tooltipText: ne,
      onTooltipUpdate: te,
      size: "small",
      shape: fe,
      appearance: "light",
      buttonLabel: _e
    }
  ));
}, ControlsTimeDisplay = ({ enableDuration: re = !0 }) => {
  const {
    playerState: { durationInSec: te, playbackPosInSec: ee }
  } = usePlayerContext(), ie = F$1(() => getFormattedTimeString(te), [te]), ne = F$1(() => getFormattedTimeString(ee), [ee]);
  return /* @__PURE__ */ Cn.createElement("div", { "data-rbup-time-display": !0, class: "controls-time-display" }, /* @__PURE__ */ Cn.createElement(CosmosText, { "data-rbup-playback-position": !0, appearance: "light", size: "xx-small@small x-small@medium" }, ne), re && /* @__PURE__ */ Cn.createElement("div", { class: "controls-time-display__duration" }, /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "data-rbup-time-separator": !0,
      class: "controls-time-display__separator",
      appearance: "light",
      kind: "subtle",
      size: "xx-small@small x-small@medium"
    },
    "/"
  ), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "data-rbup-playback-duration": !0,
      appearance: "light",
      kind: "subtle",
      size: "xx-small@small x-small@medium"
    },
    ie
  )));
};
function oneStepLinearCalc(re, te, ee) {
  return re / te * ee;
}
const VolumeIndicatorElement = (re) => {
  const te = getCssClass(re);
  return /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-rbup-volume-indicator": resolveTagAttributeValue(!re.active && !re.highlight),
      "data-rbup-volume-indicator-active": resolveTagAttributeValue(re.active),
      "data-rbup-volume-indicator-highlighted": resolveTagAttributeValue(re.highlight),
      class: te
    }
  );
};
function getCssClass({ active: re, highlight: te }) {
  const ee = "volume-indicator-element";
  return te ? `${ee} volume-indicator-element--highlighted` : re ? `${ee} volume-indicator-element--active` : ee;
}
const IndicatorElements = ({ volume: re }) => {
  const te = Math.round(re / 10) - 1, ee = [];
  for (let ie = 0; ie < 10; ie++)
    ee[ie] = /* @__PURE__ */ Cn.createElement("div", { class: "controls-volume-slider__indicator-element", key: ie }, /* @__PURE__ */ Cn.createElement(VolumeIndicatorElement, { active: ie < te, highlight: ie === te, key: ie }));
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ee);
}, SLIDER_WIDTH = 38;
function getCalculatedVolume(re) {
  if (re < 0)
    return 0;
  const te = Math.round(oneStepLinearCalc(re, SLIDER_WIDTH, 100));
  return Math.max(0, Math.min(100, te));
}
const ControlsVolumeSlider = ({
  currentVolume: re,
  isDragging: te,
  isHovering: ee,
  onDraggingChanged: ie,
  onVolumeChanged: ne,
  onTooltipUpdate: ae
}) => {
  const ue = _(null), _e = ee || te, fe = T$1(
    (se) => {
      var ge;
      const { clientX: oe } = se, ce = ((ge = ue.current) == null ? void 0 : ge.getBoundingClientRect().left) ?? oe, he = oe - ce;
      if (_e) {
        const ve = getCalculatedVolume(he);
        ne(ve);
      }
    },
    [ne, _e]
  ), le = T$1(
    ({ offsetX: se }) => {
      const oe = () => {
        document.removeEventListener("pointerup", oe), document.removeEventListener("pointermove", fe), ie(!1);
      };
      ie(!0);
      const ce = getCalculatedVolume(se);
      return ne(ce), document.addEventListener("pointerup", oe), document.addEventListener("pointermove", fe), () => {
        document.removeEventListener("pointerup", oe), document.removeEventListener("pointermove", fe);
      };
    },
    [fe, ie, ne]
  );
  return /* @__PURE__ */ Cn.createElement("div", { class: "controls-volume-slider", ref: ue }, /* @__PURE__ */ Cn.createElement(
    "div",
    {
      class: `controls-volume-slider__slider ${_e ? "controls-volume-slider__slider--visible" : ""}`,
      onPointerDown: le,
      onPointerOver: () => {
        ae(translate("tooltip-changeVolume"));
      }
    },
    _e && /* @__PURE__ */ Cn.createElement(IndicatorElements, { volume: re })
  ));
};
function convertVolumeLevel(re) {
  if (re < 0)
    throw new Error("setting the volume to a value smaller than 0");
  return re === 0 ? "OFF" : re <= 30 ? "LOW" : re <= 60 ? "MEDIUM" : (re <= 100, "HIGH");
}
function getIconComponent(re) {
  switch (re) {
    case "OFF":
      return /* @__PURE__ */ Cn.createElement(CosmosIconMute, { "data-rbup-icon-mute": !0, class: "g-icon", slot: "icon" });
    case "LOW":
      return /* @__PURE__ */ Cn.createElement(CosmosIconVolumeLow, { "data-rbup-icon-volume-low": !0, class: "g-icon", slot: "icon" });
    case "MEDIUM":
      return /* @__PURE__ */ Cn.createElement(CosmosIconVolumeMid, { "data-rbup-icon-volume-mid": !0, class: "g-icon", slot: "icon" });
    default:
      return /* @__PURE__ */ Cn.createElement(CosmosIconVolume, { "data-rbup-icon-volume": !0, class: "g-icon", slot: "icon" });
  }
}
const VolumeButton = ({ volume: re, onClick: te, onTooltipUpdate: ee }) => {
  const ie = F$1(() => convertVolumeLevel(re), [re]), ne = translateWithHotKey(ie === "OFF" ? "tooltip-unmute" : "tooltip-mute");
  return /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      size: "small",
      dataAttribute: "data-rbup-volume",
      Icon: getIconComponent(ie),
      label: ne,
      onPointerUp: te,
      onTooltipUpdate: ee,
      tooltipText: ne
    }
  );
}, VolumeControls = ({ onControlsElementEnter: re }) => {
  const {
    playerState: { playerCoordinator: te, isShowingAd: ee }
  } = usePlayerContext(), ie = (te == null ? void 0 : te.getVolume()) ?? 100, [ne, ae] = h$2(!1), [ue, _e] = h$2(!1), fe = T$1(() => {
    const be = !((te == null ? void 0 : te.isMuted()) ?? !1);
    te == null || te.setMuted(be);
  }, [te]), le = T$1(
    (be) => {
      te == null || te.setVolume(be);
    },
    [te]
  ), se = T$1(() => {
    ae(!1);
  }, []), oe = T$1(
    (be) => {
      ae(!0), re == null || re(be, !0);
    },
    [re]
  ), ce = T$1((be) => {
    _e(be);
  }, []), he = F$1(() => isMobileDevice(), []), [ge, ve] = h$2(""), me = T$1((be) => {
    ve(be);
  }, []);
  return /* @__PURE__ */ Cn.createElement(
    CosmosTooltip,
    {
      class: "cosmos-tooltip",
      content: ge,
      appearance: "dark",
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0,
      offset: ee ? 7 : 30
    },
    /* @__PURE__ */ Cn.createElement("div", { onPointerOver: oe, onPointerLeave: se, class: "volume-controls" }, /* @__PURE__ */ Cn.createElement(VolumeButton, { onClick: fe, volume: ie, onTooltipUpdate: me }), !he && /* @__PURE__ */ Cn.createElement(
      ControlsVolumeSlider,
      {
        currentVolume: ie,
        isHovering: ne,
        isDragging: ue,
        onDraggingChanged: ce,
        onVolumeChanged: le,
        onTooltipUpdate: me
      }
    ))
  );
}, PlayPauseButton = ({ cssClass: re, onTooltipUpdate: te }) => {
  const {
    playerState: { playerStatus: ee, playerCoordinator: ie }
  } = usePlayerContext(), ne = ee === "PLAYING", ae = ne ? "data-rbup-pause" : "data-rbup-play", ue = ne ? /* @__PURE__ */ Cn.createElement(CosmosIconPause, { "data-rbup-icon-pause": !0, class: `g-icon ${re}`, slot: "icon" }) : /* @__PURE__ */ Cn.createElement(CosmosIconPlay, { "data-rbup-icon-play": !0, class: `g-icon ${re}`, slot: "icon" }), _e = translateWithHotKey(ne ? "tooltip-pause" : "tooltip-play"), fe = T$1(() => {
    handlePlayPauseToggle(ee, ie);
  }, [ee, ie]);
  return /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: ae,
      Icon: ue,
      label: _e,
      onPointerUp: fe,
      size: "small",
      tooltipText: _e,
      onTooltipUpdate: te,
      appearance: "dark"
    }
  );
}, BufferingPlaybackControls = ({ onTooltipUpdate: re }) => {
  const {
    playerState: { playerCoordinator: te, playerStatus: ee }
  } = usePlayerContext(), ie = ee === "BUFFERING", ne = translate(ie ? "tooltip-loading" : "tooltip-stop"), ae = T$1(async () => {
    await (te == null ? void 0 : te.stop());
  }, [te]);
  return ie ? /* @__PURE__ */ Cn.createElement(
    CosmosSpinner,
    {
      "data-rbup-buffer": !0,
      class: "play-seek-controls__spinner",
      appearance: "light",
      label: translate("tooltip-loading"),
      onPointerEnter: (fe) => {
        re(ne, fe);
      }
    }
  ) : isLiveLinearResolver(te) && ee === "PLAYING" ? /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "data-rbup-stop",
      Icon: /* @__PURE__ */ Cn.createElement(CosmosIconStop, { class: "g-icon play-seek-controls__icon", slot: "icon" }),
      label: ne,
      tooltipText: ne,
      onPointerUp: async () => {
        await ae();
      },
      onTooltipUpdate: re,
      appearance: "dark"
    }
  ) : /* @__PURE__ */ Cn.createElement(
    PlayPauseButton,
    {
      "data-rbup-play-pause": !0,
      cssClass: "play-seek-controls__icon",
      onTooltipUpdate: re
    }
  );
}, MAIN_CLASS_NAME$1 = "play-seek-controls", PlaySeekControls = ({
  enableSeek: re = !0,
  position: te = "center",
  isMobileDevice: ee = !1
}) => {
  const {
    playerState: { playerCoordinator: ie, playbackMode: ne, liveVariant: ae, isVRVideo: ue }
  } = usePlayerContext(), _e = (ie == null ? void 0 : ie.canSeekOrTimeshiftBackward()) ?? !1, fe = (ie == null ? void 0 : ie.canSeekOrTimeshiftForward()) ?? !1, le = te === "center", se = le ? void 0 : `${MAIN_CLASS_NAME$1}__bottom`, oe = resolveVRContentClassName(ue, ee), ce = [MAIN_CLASS_NAME$1, se, oe].join(" "), { tooltipText: he, onTooltipUpdate: ge } = useTooltipVisibility(), ve = T$1(() => {
    ie == null || ie.seekOrTimeshiftRelative(DEFAULT_SEEK_SKIP_SECONDS);
  }, [ie]), me = T$1(() => {
    ie == null || ie.seekOrTimeshiftRelative(-DEFAULT_SEEK_SKIP_SECONDS);
  }, [ie]), be = F$1(() => re && (ne === "VOD" || ae === "DVR"), [re, ae, ne]);
  return /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-rbup-play-controls": resolveTagAttributeValue(le),
      "data-rbup-bottom-play-controls": resolveTagAttributeValue(!le),
      class: ce
    },
    /* @__PURE__ */ Cn.createElement(
      CosmosTooltip,
      {
        class: "cosmos-tooltip",
        content: he,
        appearance: "dark",
        placement: "above",
        spacing: "tight",
        unreachable: !0,
        follow: !0,
        offset: 30
      },
      /* @__PURE__ */ Cn.createElement("div", { class: "play-seek-controls__play-seek-pause-container", "data-rbup-seek-pause-container": !0 }, be && /* @__PURE__ */ Cn.createElement(
        ControlsButton,
        {
          appearance: "dark",
          dataAttribute: "data-rbup-seek-back",
          disabled: !_e,
          Icon: /* @__PURE__ */ Cn.createElement(
            CosmosIconBack10,
            {
              "data-rbup-icon-back-10": !0,
              class: "g-icon play-seek-controls__icon",
              slot: "icon"
            }
          ),
          label: translate("tooltip-rewind"),
          onPointerUp: me,
          tooltipText: translate("tooltip-rewind"),
          onTooltipUpdate: ge
        }
      ), /* @__PURE__ */ Cn.createElement(BufferingPlaybackControls, { onTooltipUpdate: ge }), be && /* @__PURE__ */ Cn.createElement(
        ControlsButton,
        {
          appearance: "dark",
          dataAttribute: "data-rbup-seek-forward",
          disabled: !fe,
          Icon: /* @__PURE__ */ Cn.createElement(
            CosmosIconForward10,
            {
              "data-rbup-icon-forward-10": !0,
              class: "g-icon play-seek-controls__icon",
              slot: "icon"
            }
          ),
          label: translate("tooltip-forward"),
          onPointerUp: ve,
          tooltipText: translate("tooltip-forward"),
          onTooltipUpdate: ge
        }
      ))
    )
  );
};
function resolveVRContentClassName(re, te) {
  return re && !te ? `${MAIN_CLASS_NAME$1}__vr-content` : void 0;
}
const LeftSideControls = ({
  enableDuration: re,
  enableSeek: te,
  isPlayerSizeMedium: ee,
  onShowMultiChannelSwitcher: ie,
  onControlsElementEnter: ne
}) => {
  const {
    playerState: { playerCoordinator: ae }
  } = usePlayerContext(), ue = (ae == null ? void 0 : ae.getPlaybackMode()) ?? "VOD", _e = ue === "VOD", fe = ue === "LIVE", { tooltipVisibility: le, tooltipText: se, onTooltipUpdate: oe, hideTooltip: ce } = useTooltipVisibility(), he = F$1(() => isMobileDevice(), []);
  return /* @__PURE__ */ Cn.createElement("div", { class: "left-side-controls" }, /* @__PURE__ */ Cn.createElement(PlaySeekControls, { enableSeek: te, position: "bottom", isMobileDevice: he }), /* @__PURE__ */ Cn.createElement(VolumeControls, { onControlsElementEnter: ne }), _e && /* @__PURE__ */ Cn.createElement(ControlsTimeDisplay, { enableDuration: re }), /* @__PURE__ */ Cn.createElement(
    CosmosTooltip,
    {
      class: "cosmos-tooltip",
      content: se,
      appearance: "dark",
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0,
      offset: 30,
      controlled: !0,
      visible: le
    },
    /* @__PURE__ */ Cn.createElement(
      "div",
      {
        class: "left-side-controls__selective-elements",
        "data-rbup-left-side-controls-selective-elements": !0,
        onPointerLeave: ce
      },
      fe && /* @__PURE__ */ Cn.createElement(LiveButton, { onTooltipUpdate: oe }),
      ie && /* @__PURE__ */ Cn.createElement(
        MultiChannelButton,
        {
          isPlayerSizeMedium: ee,
          onTooltipUpdate: oe,
          onPointerUp: ie
        }
      )
    )
  ));
}, FullscreenButton = ({ onTooltipUpdate: re }) => {
  const {
    playerState: { isFullscreenMode: te, playerCoordinator: ee }
  } = usePlayerContext(), ie = translateWithHotKey(te ? "tooltip-normalscreen" : "tooltip-fullscreen"), ne = T$1(() => {
    ee == null || ee.toggleFullscreen();
  }, [ee]), ae = te ? /* @__PURE__ */ Cn.createElement(CosmosIconFullscreenExit, { "data-rbup-icon-fullscreen-exit": !0, class: "g-icon", slot: "icon" }) : /* @__PURE__ */ Cn.createElement(CosmosIconFullscreen, { "data-rbup-icon-fullscreen": !0, class: "g-icon", slot: "icon" });
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, (ee == null ? void 0 : ee.isFullscreenAvailable()) && /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "data-rbup-fullscreen",
      label: ie,
      Icon: ae,
      onPointerUp: ne,
      tooltipText: ie,
      onTooltipUpdate: re,
      size: "small"
    }
  ));
}, OnlyFullscreenControls = () => {
  const {
    playerState: { playerCoordinator: re }
  } = usePlayerContext(), { tooltipVisibility: te, tooltipText: ee, onTooltipUpdate: ie, hideTooltip: ne } = useTooltipVisibility();
  return /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls", onPointerLeave: ne }, /* @__PURE__ */ Cn.createElement(
    CosmosTooltip,
    {
      class: "cosmos-tooltip",
      content: ee,
      appearance: "dark",
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0,
      offset: 30,
      controlled: !0,
      visible: te
    },
    /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls__tooltip-wrapper" }, (re == null ? void 0 : re.isFullscreenAvailable()) && /* @__PURE__ */ Cn.createElement(FullscreenButton, { onTooltipUpdate: ie }))
  ));
};
function useShowControlsButtons(re) {
  return re ? controlsButtonsDisplaySetting(!1, !1, !0) : controlsButtonsDisplaySetting(!0, !0, !0);
}
function controlsButtonsDisplaySetting(re, te, ee) {
  return {
    showPictureInPicture: re,
    showAirPlay: te,
    showFullscreen: ee
  };
}
const InternalRightSideControls = ({ onMenuClicked: re }, te) => {
  const {
    playerState: { audioTracks: ee, isHdPlayback: ie, playerCoordinator: ne, subtitleTracks: ae, isVRVideo: ue }
  } = usePlayerContext(), _e = _$1(), fe = _$1(), le = _$1(), se = T$1((Ne) => {
    const Ce = Ne.current;
    Ce == null || Ce.focus();
  }, []), oe = F$1(() => ({
    focusSubtitleMenuButton() {
      se(_e);
    },
    focusAudioMenuButton() {
      se(fe);
    },
    focusSettingsMenuButton() {
      se(le);
    }
  }), [fe, se, le, _e]);
  A$1(te, () => oe, [oe]);
  const { showPictureInPicture: ce, showAirPlay: he, showFullscreen: ge } = useShowControlsButtons(ue), ve = T$1(
    (Ne) => {
      Ne.stopPropagation(), re("AUDIO");
    },
    [re]
  ), me = T$1(
    (Ne) => {
      Ne.stopPropagation(), re("SETTINGS");
    },
    [re]
  ), be = T$1(
    (Ne) => {
      Ne.stopPropagation(), re("SUBTITLES");
    },
    [re]
  ), pe = T$1(() => {
    ne == null || ne.togglePictureInPicture();
  }, [ne]), $e = T$1(() => {
    ne == null || ne.playVideoViaAirPlay();
  }, [ne]), { tooltipVisibility: ye, tooltipText: Se, onTooltipUpdate: we, hideTooltip: Pe } = useTooltipVisibility(), Te = ae.length > 0, Ee = /* @__PURE__ */ Cn.createElement(CosmosIconSubtitles, { "data-rbup-icon-captions": !0, class: "g-icon", slot: "icon" }), Me = ee.length > 1, Ae = ie ? /* @__PURE__ */ Cn.createElement(CosmosIconQuality, { "data-rbup-icon-quality": !0, class: "g-icon", slot: "icon" }) : /* @__PURE__ */ Cn.createElement(CosmosIconSettings, { "data-rbup-icon-settings": !0, class: "g-icon", slot: "icon" });
  return /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls", onPointerLeave: Pe }, /* @__PURE__ */ Cn.createElement(
    CosmosTooltip,
    {
      class: "cosmos-tooltip",
      content: Se,
      appearance: "dark",
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0,
      offset: 30,
      controlled: !0,
      visible: ye
    },
    /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls__tooltip-wrapper" }, Me && /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls__audio-button" }, /* @__PURE__ */ Cn.createElement(
      ControlsButton,
      {
        ref: fe,
        dataAttribute: "data-rbup-audio",
        Icon: /* @__PURE__ */ Cn.createElement(CosmosIconAudioSettings, { "data-rbup-icon-multi-language": !0, class: "g-icon", slot: "icon" }),
        label: translate("tooltip-audioTracks"),
        onPointerUp: ve,
        tooltipText: translate("tooltip-audioTracks"),
        onTooltipUpdate: we,
        size: "small"
      }
    )), Te && /* @__PURE__ */ Cn.createElement("div", { class: "right-side-controls__subtitles-button" }, /* @__PURE__ */ Cn.createElement(
      ControlsButton,
      {
        ref: _e,
        dataAttribute: "data-rbup-subtitles",
        Icon: Ee,
        label: translate("tooltip-subtitles"),
        onPointerUp: be,
        tooltipText: translate("tooltip-subtitles"),
        onTooltipUpdate: we,
        size: "small"
      }
    )), /* @__PURE__ */ Cn.createElement(
      ControlsButton,
      {
        ref: le,
        dataAttribute: "data-rbup-settings",
        label: translate("tooltip-settings"),
        Icon: Ae,
        onPointerUp: me,
        tooltipText: translate("tooltip-settings"),
        onTooltipUpdate: we,
        size: "small"
      }
    ), ce && (ne == null ? void 0 : ne.isPictureInPictureAvailable()) && /* @__PURE__ */ Cn.createElement(
      ControlsButton,
      {
        dataAttribute: "data-rbup-pip",
        Icon: /* @__PURE__ */ Cn.createElement(
          CosmosIconPictureInPicture,
          {
            "data-rbup-icon-picture-in-picture": !0,
            class: "g-icon",
            slot: "icon"
          }
        ),
        label: translate("tooltip-pip"),
        onPointerUp: pe,
        tooltipText: translateWithHotKey("tooltip-pip"),
        onTooltipUpdate: we,
        size: "small"
      }
    ), he && (ne == null ? void 0 : ne.isAirPlayAvailable) && /* @__PURE__ */ Cn.createElement(
      ControlsButton,
      {
        dataAttribute: "data-rbup-airplay",
        Icon: /* @__PURE__ */ Cn.createElement(CosmosIconAirplay, { "data-rbup-icon-airplay": !0, class: "g-icon", slot: "icon" }),
        label: translate("tooltip-airplay"),
        onPointerUp: $e,
        tooltipText: translate("tooltip-airplay"),
        onTooltipUpdate: we,
        size: "small"
      }
    ), ge && (ne == null ? void 0 : ne.isFullscreenAvailable()) && /* @__PURE__ */ Cn.createElement(FullscreenButton, { onTooltipUpdate: we }))
  ));
}, RightSideControls = k(InternalRightSideControls), VideoDetails = ({ sizeBreakpoints: re }) => {
  const {
    playerState: { mediaMetaData: te, playerConfiguration: ee }
  } = usePlayerContext(), ie = F$1(() => ee != null && ee.title ? ee.title : te == null ? void 0 : te.title, [te == null ? void 0 : te.title, ee]), ne = F$1(() => ee != null && ee.title ? ee.description : te == null ? void 0 : te.description, [te == null ? void 0 : te.description, ee]);
  if ((ee == null ? void 0 : ee.videoDetails) === "hidden")
    return null;
  const ae = re.largeOrBigger;
  return ie ? /* @__PURE__ */ Cn.createElement("div", { "data-rbup-video-details": !0, class: "video-details" }, /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      appearance: "light",
      clamp: 1,
      class: "video-details__title",
      size: ae ? "x-large" : "medium",
      weight: "bold"
    },
    ie
  ), !isMobileDevice() && ne && /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", clamp: 1, class: "video-details__description", kind: "subtle", size: "small" }, ne)) : null;
};
function calculateControlsClassName(re, te) {
  return `controls-container ${re === "fade-in" ? "controls-container--fade-in" : re === "fade-out" ? "controls-container--fade-out" : "controls-container--hide"} ${te ? "controls-container--fullscreen" : ""}`;
}
function shouldShowInnerControls(re, te) {
  return te !== "SETTINGS" || re;
}
const MenuContainer = ({ menuState: re, isPlayerSizeMedium: te, onCloseSettingsMenu: ee, onCloseSubtitleMenu: ie, onCloseAudioMenu: ne }) => /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, re === "SETTINGS" && /* @__PURE__ */ Cn.createElement(SettingsMenu, { activateResizing: te, onCloseMenu: ee }), re === "SUBTITLES" && /* @__PURE__ */ Cn.createElement(SubtitlesMenu, { onCloseMenu: ie }), re === "AUDIO" && /* @__PURE__ */ Cn.createElement(AudioMenu, { onCloseMenu: ne })), Controls = ({
  enableDuration: re,
  enableSeek: te,
  enableVideoDetails: ee = !0,
  globalKeyboardNavigation: ie = "ACTIVE",
  sizeBreakpoints: ne,
  onlyFullscreenControls: ae,
  onShowMultiChannelSwitcher: ue,
  allowCaptureAreaInteraction: _e = !0,
  CenteredToastComponent: fe
}) => {
  const {
    playerState: { playerStatus: le, isShowingAd: se, playerCoordinator: oe, isFullscreenMode: ce }
  } = usePlayerContext(), {
    controlsVisibility: he,
    showControlsTemporarily: ge,
    showControlsPermanently: ve,
    menuState: me,
    setMenuState: be,
    onControlsElementEnter: pe,
    toggleMenu: $e
  } = useControlsVisibilityContext(), ye = ne.mediumOrBigger, Se = shouldShowInnerControls(ye, me), we = me !== "CLOSED", Pe = calculateControlsClassName(he, ce), Te = _(null), Ee = _(null), Me = F$1(() => isMobileDevice(), []), Ae = () => {
    Me || ge();
  }, Ne = (Oe) => {
    handleKeyboardEvent(Oe, oe);
  };
  useGlobalKeyboardNavigation(ie, Ne);
  const Ce = T$1(
    (Oe) => {
      isMouse(Oe) && ge();
    },
    [ge]
  ), Ie = () => {
    ge();
  }, xe = () => {
    ge();
  }, Ue = T$1(
    (Oe) => {
      Oe ? ve() : ge();
    },
    [ve, ge]
  ), ke = T$1(
    (Oe) => {
      !Me || ye ? $e(Oe) : Te.current = window.setTimeout(() => {
        $e(Oe), Te.current = null;
      }, 100);
    },
    [ye, Me, $e]
  );
  p(() => () => {
    Te.current && window.clearTimeout(Te.current);
  }, []);
  const Le = T$1(() => {
    var Oe;
    be("CLOSED"), (Oe = Ee.current) == null || Oe.focusSettingsMenuButton();
  }, [be]), De = T$1(() => {
    var Oe;
    be("CLOSED"), (Oe = Ee.current) == null || Oe.focusSubtitleMenuButton();
  }, [be]), Re = T$1(() => {
    var Oe;
    be("CLOSED"), (Oe = Ee.current) == null || Oe.focusAudioMenuButton();
  }, [be]);
  return p(() => {
    ye || be((Oe) => Oe === "SUBTITLES" || Oe === "AUDIO" ? "CLOSED" : Oe);
  }, [ye, be]), p(() => {
    le === "ENDED" && be("CLOSED");
  }, [le, be]), /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-rbup-controls": !0,
      class: Pe,
      tabIndex: 0,
      onFocus: Ae,
      onKeyDown: Ne,
      onPointerEnterCapture: pe,
      role: "button"
    },
    !se && _e && // Don't intercept background clicks when showing an ad.
    /* @__PURE__ */ Cn.createElement(ClickAndTapOverlay, { onPointerMove: Ce }),
    Se && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement("div", { className: "controls__gradient" }), ee && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-controls-details": !0, class: "controls__video-details" }, /* @__PURE__ */ Cn.createElement(VideoDetails, { sizeBreakpoints: ne })), /* @__PURE__ */ Cn.createElement(
      "div",
      {
        "data-rbup-controls-play-seek": !0,
        class: "controls__play",
        onPointerUpCapture: Ie
      },
      /* @__PURE__ */ Cn.createElement(PlaySeekControls, { enableSeek: te, isMobileDevice: Me })
    ), /* @__PURE__ */ Cn.createElement("div", { "data-rbup-controls-scrub-bar": !0, class: "controls__scrub-bar" }, /* @__PURE__ */ Cn.createElement(
      ScrubBar,
      {
        onDragStatusChanged: Ue,
        sizeBreakpoints: ne,
        hideScrubBarTooltip: we,
        onControlsElementEnter: pe
      }
    )), /* @__PURE__ */ Cn.createElement(
      "div",
      {
        "data-rbup-controls-buttons": !0,
        class: "controls__buttons",
        onPointerMove: Ce,
        onPointerUpCapture: xe
      },
      /* @__PURE__ */ Cn.createElement(
        LeftSideControls,
        {
          enableDuration: re,
          enableSeek: te,
          isPlayerSizeMedium: ye,
          onShowMultiChannelSwitcher: ue,
          onControlsElementEnter: pe
        }
      ),
      ae && /* @__PURE__ */ Cn.createElement(OnlyFullscreenControls, null),
      !ae && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement(
        CenterControls,
        {
          isPlayerSizeMedium: ye,
          CenteredToastComponent: fe
        }
      ), /* @__PURE__ */ Cn.createElement(RightSideControls, { ref: Ee, onMenuClicked: ke }))
    )),
    /* @__PURE__ */ Cn.createElement(
      MenuContainer,
      {
        menuState: me,
        isPlayerSizeMedium: ye,
        onCloseAudioMenu: Re,
        onCloseSettingsMenu: Le,
        onCloseSubtitleMenu: De
      }
    )
  );
}, RbupVideoCoreOverlay = ({
  enableDuration: re,
  enableSeek: te = !0,
  enableVideoDetails: ee,
  globalKeyboardNavigation: ie,
  playerCoordinator: ne,
  sizeBreakpoints: ae,
  onlyFullscreenControls: ue,
  onShowMultiChannelSwitcher: _e,
  allowControlsCaptureAreaInteraction: fe = !0,
  CenteredToastComponent: le
}) => {
  const se = ne.getPlayerStatus(), he = useControlsVisibilityContext().allowControlsRendering === "allow" && !["IDLE", "ERROR"].includes(se), ge = fe ? "overlay" : "overlay disabled", ve = q$1(UserInteractionContext), me = T$1(
    (be) => {
      ve.trigger(be);
    },
    [ve]
  );
  return /* @__PURE__ */ Cn.createElement("div", { "data-rbup-overlay": !0, class: ge, onPointerMove: me, dir: "ltr" }, he && /* @__PURE__ */ Cn.createElement(
    Controls,
    {
      enableDuration: re,
      enableSeek: te,
      enableVideoDetails: ee,
      globalKeyboardNavigation: ie,
      sizeBreakpoints: ae,
      onlyFullscreenControls: ue,
      onShowMultiChannelSwitcher: _e,
      allowCaptureAreaInteraction: fe,
      CenteredToastComponent: le
    }
  ));
};
function r(re, te, ee) {
  var ie, ne, ae;
  te === void 0 && (te = 50), ee === void 0 && (ee = {});
  var ue = (ie = ee.isImmediate) != null && ie, _e = (ne = ee.callback) != null && ne, fe = ee.maxWait, le = Date.now(), se = [];
  function oe() {
    if (fe !== void 0) {
      var he = Date.now() - le;
      if (he + te >= fe)
        return fe - he;
    }
    return te;
  }
  var ce = function() {
    var he = [].slice.call(arguments), ge = this;
    return new Promise(function(ve, me) {
      var be = ue && ae === void 0;
      if (ae !== void 0 && clearTimeout(ae), ae = setTimeout(function() {
        if (ae = void 0, le = Date.now(), !ue) {
          var $e = re.apply(ge, he);
          _e && _e($e), se.forEach(function(ye) {
            return (0, ye.resolve)($e);
          }), se = [];
        }
      }, oe()), be) {
        var pe = re.apply(ge, he);
        return _e && _e(pe), ve(pe);
      }
      se.push({ resolve: ve, reject: me });
    });
  };
  return ce.cancel = function(he) {
    ae !== void 0 && clearTimeout(ae), se.forEach(function(ge) {
      return (0, ge.reject)(he);
    }), se = [];
  }, ce;
}
const publicPlayerEventTypesAsString = publicPlayerEventTypes, log$a = loglevelExports.getLogger("CoreApi");
function assertPlayerLoaded(re) {
  const te = re.current;
  if (!te)
    throw new Error("dont have coordinator");
  if (!te.isVideoLoaded)
    throw new Error("no video loaded yet");
}
function pushListener(re, te) {
  const ee = re.current;
  ee && !ee.includes(te) && ee.push(te);
}
function useCoreApi(re, te, ee, ie) {
  var fe, le;
  const ne = _(!1), ae = F$1(() => ({
    isReady() {
      const oe = re.current;
      return (oe == null ? void 0 : oe.isVideoLoaded) ?? !1;
    },
    async play() {
      var oe;
      return assertPlayerLoaded(re), (oe = re.current) == null ? void 0 : oe.play();
    },
    async stop() {
      var oe;
      return assertPlayerLoaded(re), (oe = re.current) == null ? void 0 : oe.stop();
    },
    pause() {
      var oe;
      assertPlayerLoaded(re), (oe = re.current) == null || oe.pause();
    },
    seek(oe) {
      var ce;
      assertPlayerLoaded(re), (ce = re.current) == null || ce.seek(oe);
    },
    timeShift(oe) {
      var ce;
      assertPlayerLoaded(re), (ce = re.current) == null || ce.timeShift(oe);
    },
    getPlaybackMode() {
      var oe;
      return assertPlayerLoaded(re), ((oe = re.current) == null ? void 0 : oe.getPlaybackMode()) ?? "UNKNOWN";
    },
    setFullscreen(oe) {
      var ce;
      assertPlayerLoaded(re), (ce = re.current) == null || ce.setFullscreen(oe);
    },
    isFullscreen() {
      var oe;
      return assertPlayerLoaded(re), ((oe = re.current) == null ? void 0 : oe.isInFullscreenMode()) ?? !1;
    },
    getStatus() {
      var oe;
      return assertPlayerLoaded(re), ((oe = re.current) == null ? void 0 : oe.getPlayerStatus()) ?? "IDLE";
    },
    getCurrentTime() {
      var oe, ce;
      return assertPlayerLoaded(re), ((ce = (oe = re.current) == null ? void 0 : oe.getPlayerData()) == null ? void 0 : ce.getCurrentTimeInSec()) ?? 0;
    },
    getDuration() {
      var oe, ce;
      return assertPlayerLoaded(re), ((ce = (oe = re.current) == null ? void 0 : oe.getPlayerData()) == null ? void 0 : ce.getDurationInSec()) ?? 0;
    },
    getCurrentTimeOfMainVideo() {
      var oe, ce;
      return assertPlayerLoaded(re), ((ce = (oe = re.current) == null ? void 0 : oe.getPlayerData()) == null ? void 0 : ce.getLastMainMediaPositionInSec()) ?? 0;
    },
    getDurationOfMainVideo() {
      var oe, ce;
      return assertPlayerLoaded(re), ((ce = (oe = re.current) == null ? void 0 : oe.getPlayerData()) == null ? void 0 : ce.getMainMediaDurationInSec()) ?? 0;
    },
    getCurrentTimeshift() {
      var oe;
      return assertPlayerLoaded(re), ((oe = re.current) == null ? void 0 : oe.getTimeShiftInSec()) ?? 0;
    },
    getMaxTimeshift() {
      var oe;
      return assertPlayerLoaded(re), ((oe = re.current) == null ? void 0 : oe.getMaxTimeShiftInSec()) ?? 0;
    },
    setMuted(oe) {
      var ce;
      assertPlayerLoaded(re), (ce = re.current) == null || ce.setMuted(oe);
    },
    isMuted() {
      var oe;
      return assertPlayerLoaded(re), ((oe = re.current) == null ? void 0 : oe.isMuted()) ?? !1;
    },
    setVolume(oe) {
      var ce;
      assertPlayerLoaded(re), (ce = re.current) == null || ce.setVolume(oe);
    },
    getVolume() {
      var oe;
      return assertPlayerLoaded(re), ((oe = re.current) == null ? void 0 : oe.getVolume()) ?? 100;
    },
    addEventListener(oe) {
      pushListener(ie, oe);
    },
    removeEventListener(oe) {
      var he, ge;
      const ce = (he = ie.current) == null ? void 0 : he.findIndex((ve) => ve === oe);
      ce !== void 0 && ((ge = ie.current) == null || ge.splice(ce, 1));
    }
  }), [re, ie]);
  A$1(te, () => ae, [ae]);
  const ue = (fe = re.current) == null ? void 0 : fe.isVideoLoaded, _e = (le = re.current) == null ? void 0 : le.getCurrentErrorDetails();
  return p(() => {
    const se = re.current;
    log$a.debug("coreApi", { coordinator: se, apiAvailable: ee, videoLoaded: ue }), se && !ne.current && ee && (ne.current = !0, log$a.debug("coreApi invoking apiAvailable", { coordinator: se, apiAvailable: ee, videoLoaded: ue }), _e ? ee.reject(_e) : ee.resolve(ae));
  }, [ee, ae, ue, re, _e]), F$1(() => (oe) => {
    if (publicPlayerEventTypesAsString.includes(oe.type)) {
      const ce = ie.current ?? [];
      for (const he of ce)
        try {
          he(oe);
        } catch (ge) {
          log$a.error("error invoking public event listener", ge);
        }
    }
  }, [ie]);
}
const cosmosFonts = `@font-face{font-family:Bull Text;font-style:normal;font-weight:400;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:500;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff) format("woff")}@font-face{font-family:Bull VF;font-style:normal;font-weight:300 800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2-variations"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2")}
`, playablePhases = ["live", "post"], nonPollPhases = ["canceled", "post"];
function isPlayablePhase(re) {
  return playablePhases.includes(re);
}
function shouldPollInPhase(re) {
  return !nonPollPhases.includes(re);
}
const log$9 = loglevelExports.getLogger("PhasingService"), MIN_TO_MS = 6e4, THREE_HOURS = 180 * MIN_TO_MS, TEN_MIN = 10 * MIN_TO_MS, TEN_SEC = 1e4;
function calculateInterval(re, te) {
  switch (re) {
    case "pre":
    case "trim":
    case "unconfirmed":
    case "live":
      return te && new Date(te).getTime() - Date.now() > THREE_HOURS ? TEN_MIN : TEN_SEC;
    case "post":
    case "canceled":
      return;
    default:
      log$9.warn("unexpected live status phase %s", re);
      return;
  }
}
const log$8 = loglevelExports.getLogger("PhasingService");
class PhasingService {
  // eslint-disable-next-line no-useless-constructor
  constructor(te, ee, ie) {
    Et(this, "liveStatus");
    Et(this, "running", !1);
    Et(this, "timeoutHandle");
    /** used to figure out whether our callback comes too late and the player has already changed its configuration. */
    Et(this, "currentPlayerConfig");
    Et(this, "currentMetaData");
    this.playerId = te, this.liveStatusDataLoader = ee, this.eventEmitter = ie;
  }
  async loadLiveStatus(te, ee) {
    log$8.debug("loading live status for config", te);
    const ie = await this.liveStatusDataLoader.loadLiveStatus(te, ee);
    return log$8.debug("-> got live status response", ie), ie;
  }
  async start(te, ee) {
    this.running = !0, this.currentPlayerConfig = te, this.currentMetaData = ee;
    const ie = await this.poll(te, !1), ne = ie == null ? void 0 : ie.phase, ae = isPlayablePhase(ne ?? "pre"), ue = (ie == null ? void 0 : ie.shouldKeepPolling) ?? shouldPollInPhase(ne ?? "pre");
    return { shouldLoadPlayer: ae, liveStatus: ie, shouldKeepPolling: ue };
  }
  stop() {
    this.timeoutHandle && (window.clearTimeout(this.timeoutHandle), this.timeoutHandle = void 0), this.running = !1, this.currentPlayerConfig = void 0;
  }
  isRunning() {
    return this.running;
  }
  emitLiveStatusChangedEvent(te, ee, ie) {
    te && this.eventEmitter.fireEvent({
      type: "liveStatusChanged",
      playerId: this.playerId,
      liveStatus: ee,
      previousLiveStatus: ie
    });
  }
  keepPolling(te) {
    return this.running && te;
  }
  async poll(te, ee = !0) {
    var ue;
    const ie = this.liveStatus;
    let ne;
    if (!this.currentMetaData)
      throw new Error("dont have media metadata for phasing poll");
    try {
      if (ne = await this.loadLiveStatus(te, this.currentMetaData), !this.running || this.currentPlayerConfig !== te)
        return;
      areLiveStatusResponsesEqual(ie, ne) || (this.liveStatus = ne, this.emitLiveStatusChangedEvent(ee, ne, ie));
    } catch (_e) {
      if (log$8.error("error polling live status", _e), !ie) {
        const fe = { phase: "pre", shouldKeepPolling: !0 };
        this.liveStatus = fe, this.emitLiveStatusChangedEvent(!0, fe);
      }
    }
    const ae = calculateInterval(((ue = this.liveStatus) == null ? void 0 : ue.phase) ?? "pre", ne == null ? void 0 : ne.startTime);
    return this.keepPolling(ae) && (this.timeoutHandle = window.setTimeout(() => this.poll(te), ae)), this.liveStatus;
  }
  /**
   * Unit test method to be able to inject a specific player configuration and the running flag.
   * @param - running the new running flag.
   * @param - config the "current" player configuration
   * @param - previousLiveStatus the stored live config to do dirty checking
   */
  _injectStarted(te, ee, ie, ne) {
    this.running = te, this.currentPlayerConfig = ee, this.currentMetaData = ie, this.liveStatus = ne;
  }
}
function normalizeLiveStatusResponse(re) {
  if (re)
    return { ...re, _meta: void 0 };
}
function areLiveStatusResponsesEqual(re, te) {
  const ee = normalizeLiveStatusResponse(re), ie = normalizeLiveStatusResponse(te);
  return deepEqual(ee, ie);
}
async function sleep(re) {
  await new Promise((te) => setTimeout(te, re));
}
function getLanguageMatchForIsoCode(re, te) {
  var ie;
  if (!te)
    return;
  const ee = re.split("-")[0];
  return (ie = Object.entries(te).find(([ne, ae]) => ae === ee)) == null ? void 0 : ie[0];
}
function getLanguageMatchForAudioLanguage(re, te) {
  var ie;
  return te ? (ie = Object.entries(te).find(
    ([ne, ae]) => ae === re || ne === re
  )) == null ? void 0 : ie[0] : void 0;
}
function getIsoMatchForAudioLanguage(re, te) {
  var ie;
  return te ? (ie = Object.entries(te).find(
    ([ne, ae]) => ae === re || ne === re
  )) == null ? void 0 : ie[1] : void 0;
}
function getMatchedAudioOrSubtitleTrackLanguage(re, te) {
  var ee;
  return (ee = te.find((ie) => ie.lang === re)) == null ? void 0 : ee.lang;
}
function getMatchedAudioTrackId(re, te) {
  var ee;
  return (ee = te.find((ie) => ie.lang === re)) == null ? void 0 : ee.id;
}
function getMatchedSubtitleTrackId(re, te) {
  var ee;
  return (ee = te.find((ie) => ie.lang === re)) == null ? void 0 : ee.id;
}
function tryResolveRequestedAudioLanguageForAudioTrack(re, te, ee) {
  const ie = getMatchedAudioOrSubtitleTrackLanguage(re, ee);
  if (ie)
    return ie;
  const ne = getLanguageMatchForIsoCode(re, te);
  return ne || getLanguageMatchForAudioLanguage(re, te);
}
function tryResolveRequestedSubtitleLanguageForSubtitleTrack(re, te, ee) {
  const ie = getMatchedAudioOrSubtitleTrackLanguage(re, ee);
  if (ie)
    return ie;
  const ne = getLanguageMatchForIsoCode(re, te);
  return ne || getLanguageMatchForAudioLanguage(re, te);
}
class AudioLanguageResolver {
  constructor(te, ee, ie, ne) {
    this.mediaMetadata = te, this.config = ee, this.availableAudioTracks = ie, this.availableSubtitleTracks = ne;
  }
  /**
   * Calculates the correct audio track id to choose given the configuration, stored setting and user browser language.
   * @param storedLanguageNonIso - the stored language in localStorage.
   * @returns the trackId to select
   */
  resolveAudioTrackId(te) {
    const ee = this.availableAudioTracks, ie = getBrowserLanguage(), ne = this.mediaMetadata.availableAudioLanguages, ue = tryResolveRequestedAudioLanguageForAudioTrack(
      ie,
      ne,
      ee
    ) ?? ie, _e = te ? tryResolveRequestedAudioLanguageForAudioTrack(te, ne, ee) : void 0, fe = this.config.overrideAudioLanguage, le = fe ? tryResolveRequestedAudioLanguageForAudioTrack(
      fe,
      ne,
      ee
    ) : void 0;
    if (ee.length > 1)
      return getMatchedAudioTrackId(le ?? _e ?? ue, ee);
  }
  resolveSubtitleTrackId(te) {
    const ee = this.config.overrideSubtitleLanguage, ie = ee ? tryResolveRequestedSubtitleLanguageForSubtitleTrack(
      ee,
      this.mediaMetadata.availableSubtitleLanguages,
      this.availableSubtitleTracks
    ) : void 0;
    if (ie)
      return getMatchedSubtitleTrackId(ie, this.availableSubtitleTracks);
    if (te) {
      const ne = tryResolveRequestedSubtitleLanguageForSubtitleTrack(
        te,
        this.mediaMetadata.availableSubtitleLanguages,
        this.availableSubtitleTracks
      );
      if (ne)
        return getMatchedSubtitleTrackId(ne, this.availableSubtitleTracks);
    }
  }
  resolveStorageLanguageForSubtitle(te) {
    if (te.issuer === "USER")
      return getIsoMatchForAudioLanguage(te.language, this.mediaMetadata.availableSubtitleLanguages) ?? te.language;
  }
  resolveStorageLanguageForAudio(te) {
    if (te.issuer === "USER")
      return getIsoMatchForAudioLanguage(te.language, this.mediaMetadata.availableAudioLanguages) ?? te.language;
  }
}
class AudioVolumeResolver {
  constructor(te) {
    this.playerConfiguration = te;
  }
  resolveVolumeToRestore(te) {
    if (this.playerConfiguration.muted !== "MUTED" && isNotNullOrUndefined(te))
      return te;
  }
  resolveStorageVolume(te) {
    const ee = te.currentVolume;
    if (this.playerConfiguration.muted !== "MUTED" || ee > 0)
      return ee;
  }
}
const log$7 = loglevelExports.getLogger("CommonThumbnailService");
class CommonThumbnailService {
  constructor() {
    Et(this, "thumbnailSprites");
    Et(this, "currentThumbnailTrack");
    Et(this, "thumbnailDetails");
    Et(this, "currentResolution");
  }
  setThumbnailSprites(te) {
    this.thumbnailSprites = te;
  }
  async setThumbnail(te, ee, ie) {
    const { imgContainerElement: ne, imgElement: ae, textContainerElement: ue } = te;
    if (ne === null || ae === null || ue === null)
      return !1;
    const { smallOrBigger: _e, mediumOrBigger: fe } = ee, le = fe ? "HIGH" : "LOW", se = await this.getThumbnailDetail(le, ie);
    return se ? (this.styleImageContainerElement(ne, se, _e), this.styleImageElement(ae, se), this.styleTextContainer(ue, se), !0) : !1;
  }
  styleImageContainerElement(te, ee, ie) {
    te.style.width = `${ee.width}px`;
    const ne = !ie;
    te.style.height = `${ne ? ee.height * 0.85 : ee.height}px`;
  }
  styleImageElement(te, ee) {
    te.src = ee.thumbnailUrl, te.style.left = `-${ee.x}px`, te.style.top = `-${ee.y}px`;
  }
  styleTextContainer(te, ee) {
    te.style.maxWidth = `${ee.width}px`;
  }
  async getThumbnailDetail(te, ee) {
    return te !== this.currentResolution && (this.thumbnailDetails = void 0, await this.loadThumbnailTrack(te), this.currentResolution = te), this.getRequestedThumbnailDetail(te, ee);
  }
  async loadThumbnailTrack(te) {
    var ie, ne;
    const ee = te === "LOW" ? (ie = this.thumbnailSprites) == null ? void 0 : ie.lowRes : (ne = this.thumbnailSprites) == null ? void 0 : ne.highRes;
    this.currentThumbnailTrack = await this.fetchThumbnailTrack(ee).catch(() => {
      log$7.warn("Error loading thumbnail track ", ee);
    });
  }
  getRequestedThumbnailDetail(te, ee) {
    var ne, ae, ue;
    const ie = te === "LOW" ? (ne = this.thumbnailSprites) == null ? void 0 : ne.lowRes : (ae = this.thumbnailSprites) == null ? void 0 : ae.highRes;
    return this.thumbnailDetails || (this.thumbnailDetails = this.calculatedThumbnailDetail(ie)), (ue = this.thumbnailDetails) == null ? void 0 : ue.find((_e) => ee <= _e.displayTo);
  }
  calculatedThumbnailDetail(te) {
    if (!te)
      return;
    const ee = this.currentThumbnailTrack, ie = ee == null ? void 0 : ee.match(/(\d{2}:\d{2}:\d{2}\.\d+) +--> +(\d{2}:\d{2}:\d{2}\.\d+)[\r\n]+([^\r\n]*)/g);
    return ie == null ? void 0 : ie.map((ne) => {
      const ae = this.calculateDisplayTime(ne), ue = this.calculateFileUrl(te, ne), _e = this.calculateThumbnailPosition(ne);
      return {
        ...ae,
        ..._e,
        thumbnailUrl: ue
      };
    });
  }
  async fetchThumbnailTrack(te) {
    if (!te)
      return;
    const ee = await fetch(te);
    if (ee.ok)
      return await ee.text();
    throw new Error(`server returned ${ee.status}`);
  }
  calculateFileUrl(te, ee) {
    var ne;
    const ie = ((ne = ee.match(/[0-9]+\.[a-z]{3}/)) == null ? void 0 : ne[0]) ?? "";
    return te.replace(/([^/]+$)/, ie);
  }
  calculateThumbnailPosition(te) {
    var fe;
    const ie = (fe = /#xywh=(\d+),(\d+),(\d+),(\d+)/.exec(te)) == null ? void 0 : fe.slice(1, 5), ne = Number(ie == null ? void 0 : ie[0]), ae = Number(ie == null ? void 0 : ie[1]), ue = Number(ie == null ? void 0 : ie[2]), _e = Number(ie == null ? void 0 : ie[3]);
    return {
      x: ne,
      y: ae,
      width: ue,
      height: _e
    };
  }
  calculateDisplayTime(te) {
    const ee = te.match(/(\d{2}:\d{2}:\d{2}\.*?)/g), ie = (ee == null ? void 0 : ee[0]) ?? "", ne = (ee == null ? void 0 : ee[1]) ?? "", ae = convertTimeStringToSec(ie), ue = convertTimeStringToSec(ne);
    return { displayFrom: ae, displayTo: ue };
  }
}
const log$6 = loglevelExports.getLogger("StorageService");
class StorageService {
  constructor(te, ee, ie, ne, ae) {
    Et(this, "playerCoordinator");
    Et(this, "sessionStorage");
    Et(this, "localStorage");
    Et(this, "audioLanguageResolver");
    Et(this, "audioVolumeResolver");
    Et(this, "eventListener", (te) => {
      const { localStorage: ee, sessionStorage: ie } = this;
      switch (te.type) {
        case "audioChanged":
          this.handleAudioChanged(ee, te);
          break;
        case "subtitleDisabled":
          this.handleSubtitleDisabled(ee, te);
          break;
        case "subtitleEnabled":
          this.handleSubtitleEnabled(ee, te);
          break;
        case "volumeChanged": {
          this.handleVolumeChanged(ie, te);
          break;
        }
      }
    });
    if (this.playerCoordinator = te, this.sessionStorage = ne, this.localStorage = ae, this.audioLanguageResolver = ee, this.audioVolumeResolver = ie, this.playerCoordinator.addEventListener(this.eventListener), !ne)
      try {
        this.sessionStorage = window.sessionStorage;
      } catch (ue) {
        log$6.warn("cannot get session storage", ue);
      }
    if (!ae)
      try {
        this.localStorage = window.localStorage;
      } catch (ue) {
        log$6.warn("cannot get local storage", ue);
      }
  }
  load() {
    this.loadVolume(), this.loadVideoQuality(), (this.playerCoordinator.getPlaybackMode() !== "LIVE" || this.playerCoordinator.getLiveVariant() !== "LINEAR") && this.loadSubtitleLanguage(), this.loadAudioLanguage();
  }
  destroy() {
    this.playerCoordinator.removeEventListener(this.eventListener);
  }
  getAllStoredValues() {
    const te = this.localStorage;
    if (te)
      return {
        audioLanguage: getAudioLanguage(te),
        qualityHeight: getQualityHeight(te),
        subtitleLanguage: getSubtitleLanguage(te),
        volume: getVolume(te)
      };
  }
  handleVolumeChanged(te, ee) {
    if (te) {
      const ie = this.audioVolumeResolver.resolveStorageVolume(ee);
      ie !== void 0 && setVolume(ie, te);
    }
  }
  handleSubtitleEnabled(te, ee) {
    if (te) {
      const ie = this.audioLanguageResolver.resolveStorageLanguageForSubtitle(ee);
      ie && setSubtitleLanguage(ie, te);
    }
  }
  handleSubtitleDisabled(te, ee) {
    te && ee.issuer === "USER" && clearSubtitleLanguage(te);
  }
  handleAudioChanged(te, ee) {
    if (te) {
      const ie = this.audioLanguageResolver.resolveStorageLanguageForAudio(ee);
      ie && setAudioLanguage(ie, te);
    }
  }
  loadAudioLanguage() {
    const te = this.localStorage;
    if (!te)
      return;
    const ee = getAudioLanguage(te), ie = this.audioLanguageResolver.resolveAudioTrackId(ee);
    ie && this.playerCoordinator.setAudioTrack(ie, "INITIAL");
  }
  loadSubtitleLanguage() {
    const te = this.localStorage;
    if (!te)
      return;
    const ee = getSubtitleLanguage(te), ie = this.audioLanguageResolver.resolveSubtitleTrackId(ee);
    ie && this.playerCoordinator.enableSubtitle(ie, "INITIAL");
  }
  loadVideoQuality() {
    const te = this.sessionStorage;
    if (!te)
      return;
    const ee = getQualityHeight(te);
    if (ee !== null) {
      const ne = this.playerCoordinator.getAvailableVideoQualities().find((ae) => ae.height === ee);
      ne && this.playerCoordinator.setVideoQuality(ne.id);
    }
  }
  loadVolume() {
    const te = this.sessionStorage;
    if (!te)
      return;
    const ee = getVolume(te), ie = this.audioVolumeResolver.resolveVolumeToRestore(ee);
    ie !== void 0 && this.playerCoordinator.setVolume(ie);
  }
}
const RBCOM_LINEAR_ASSET_PREFIX = "rrn:content:video-channels", MIN_TIMESHIFT_FOR_DVR_SECS = -200;
function detectBasedOnAssetId(re) {
  return re ? re.startsWith(RBCOM_LINEAR_ASSET_PREFIX) : !1;
}
function detectBasedOnMaxTimeShift(re) {
  return !Number.isFinite(re) || Number.isNaN(re) ? !0 : re > MIN_TIMESHIFT_FOR_DVR_SECS;
}
function isLinearStream(re, te, ee) {
  return detectBasedOnAssetId(ee) || te ? !0 : detectBasedOnMaxTimeShift(re);
}
const Lt = class Lt {
  static setPlayerStatus(te) {
    Lt.staticPlayerStatus = te;
  }
  constructor(te) {
    Lt.staticOptions = te;
  }
  getPreviousAudioLanguage() {
  }
  getCurrentSetAudioTrackIssuer() {
  }
  getCurrentSetSubtitleTrackIssuer() {
  }
  isInPictureInPictureMode() {
    return !1;
  }
  isPlayingVideoViaAirPlay() {
    return !1;
  }
  getAvailableAudioTracks() {
    return [
      {
        id: "audio/mp4-1",
        lang: "en",
        label: "English"
      },
      {
        id: "audio/mp4-2",
        lang: "ja",
        label: "日本語"
      },
      {
        id: "audio/mp4-3",
        lang: "de",
        label: "Deutsch"
      },
      {
        id: "audio/mp4-4",
        lang: "es",
        label: "español"
      }
    ];
  }
  setAudioTrack(te, ee) {
  }
  getAvailableSubtitleTracks() {
    return [
      {
        id: "application/mp4-5",
        lang: "en-US",
        label: "English (US)"
      },
      {
        id: "application/mp4-6",
        lang: "el-GR",
        label: "Ελληνικά (GR)"
      },
      {
        id: "application/mp4-7",
        lang: "pl-PL",
        label: "polski (PL)"
      },
      {
        id: "application/mp4-8",
        lang: "pt-BR",
        label: "português (BR)"
      }
    ];
  }
  getPlayerType() {
    return "VIDEO";
  }
  getSelectedSubtitleTrack() {
  }
  disableSubtitle(te) {
  }
  enableSubtitle(te, ee) {
  }
  timeShift(te, ee = "USER") {
    return !1;
  }
  canSeekOrTimeshiftBackward() {
    return !1;
  }
  canSeekOrTimeshiftForward() {
    return !1;
  }
  getMaxTimeShiftInSec() {
    return MIN_TIMESHIFT_FOR_DVR_SECS;
  }
  getTimeShiftInSec() {
    return -10;
  }
  isStream() {
    return !1;
  }
  mute() {
  }
  pause() {
  }
  async play() {
  }
  seek(te, ee) {
    return !1;
  }
  unmute() {
  }
  async load(te) {
  }
  async destroy() {
  }
  async reset() {
  }
  getPlaybackMode() {
    return "VOD";
  }
  getLiveVariant() {
    return "DVR";
  }
  getAvailableVideoQualities() {
    return [
      {
        bitrate: 535114,
        height: 240,
        id: "240_639293",
        width: 426,
        frameRate: 25
      },
      {
        bitrate: 889212,
        height: 360,
        id: "360_1057509",
        width: 640,
        frameRate: 25
      },
      {
        bitrate: 1594819,
        height: 540,
        id: "540_1966184",
        width: 960,
        frameRate: 25
      },
      {
        bitrate: 3057048,
        height: 720,
        id: "720_3752211",
        width: 1280,
        frameRate: 25
      },
      {
        bitrate: 6154006,
        height: 1080,
        id: "1080_7560397",
        width: 1920,
        frameRate: 25
      }
    ];
  }
  getSelectedVideoQuality() {
    return { height: 1920, width: 1080, id: "1080_7560397", bitrate: 2e3, isAuto: !1 };
  }
  getVideoQuality() {
    return { height: 1900, width: 1280 };
  }
  setVideoQuality(te) {
  }
  getPlayerStatus() {
    return Lt.staticPlayerStatus;
  }
  getCurrentTimeInSeconds() {
    return 0;
  }
  getCurrentTimeInSec() {
    return Lt.staticCurrentTime;
  }
  static setCurrentTime(te) {
    Lt.staticCurrentTime = te;
  }
  getLastTimeChangedPlaybackTime() {
    return 0;
  }
  getLatestSegmentStartTimestamp() {
    return 0;
  }
  getDurationInSec() {
    return Lt.staticDurationInSec;
  }
  static setDurationInSec(te) {
    Lt.staticDurationInSec = te;
  }
  getVolume() {
    return 1;
  }
  setVolume(te) {
  }
  setHasError(te) {
  }
  isPictureInPictureAvailable() {
    return !0;
  }
  isFullscreenAvailable() {
    return !0;
  }
  isInFullscreenMode() {
    return !1;
  }
  togglePictureInPicture() {
  }
  setPictureInPicture(te) {
  }
  toggleFullscreen(te) {
  }
  setFullscreen(te, ee) {
  }
  getVideoBufferLength() {
    return Lt.staticBufferLength;
  }
  static setVideoBufferLength(te) {
    Lt.staticBufferLength = te;
  }
  isAirPlayAvailable() {
    return !1;
  }
  isPlayerLoaded() {
    return !1;
  }
  playVideoViaAirPlay() {
  }
  setPlaybackSpeed(te) {
  }
  getPlaybackSpeed() {
    return 1;
  }
  isStreamAtLivePos() {
    return !1;
  }
  getPlayerMode() {
    return "standard";
  }
  getAudioLanguage() {
    return "en";
  }
  getAudioLanguageId() {
    return "audio/mp4-1";
  }
  getSubtitleTrackLanguage() {
  }
  async scheduleAd(te, ee) {
  }
  getInitialSeekTimeInSec() {
    return 0;
  }
  getMainMediaDurationInSec() {
    return 100;
  }
  getLastMainMediaPositionInSec() {
    return 0;
  }
  isShowingAd() {
    return !1;
  }
  getTechVersion() {
    return "1.0.0";
  }
  getActualPlayerInstance() {
    return {};
  }
  getActiveAdId() {
    return "adId";
  }
  getActiveAdTitle() {
    return "adTitle";
  }
  enableInteractiveMediaAds(te) {
  }
  getViewingDirection() {
    return { x: 0, y: 0 };
  }
  setViewingDirection(te, ee) {
  }
  isVRVideo() {
    return !1;
  }
  getAdCuePoints() {
  }
};
Et(Lt, "staticPlayerStatus", "IDLE"), Et(Lt, "staticOptions"), Et(Lt, "staticCurrentTime", 0), Et(Lt, "staticDurationInSec", 42), Et(Lt, "staticBufferLength", 1);
let SimulationPlayerAdapter = Lt;
function isMediaTimeWithinTheLast3Secs(re, te) {
  return re > 0 && Math.abs(re - te) < 3;
}
function calculateAdType(re, te, ee) {
  return Math.abs(re - te) < 3 ? "PRE_ROLL" : isMediaTimeWithinTheLast3Secs(ee, re) ? "POST_ROLL" : "MID_ROLL";
}
var bitmovinplayerCore = { exports: {} };
bitmovinplayerCore.exports;
(function(module, exports) {
  (function() {
    (function() {
      var _$_b839 = function(re, te) {
        for (var ee = re.length, ie = [], ne = 0; ne < ee; ne++)
          ie[ne] = re.charAt(ne);
        for (var ne = 0; ne < ee; ne++) {
          var ae = te * (ne + 56) + te % 41536, ue = te * (ne + 630) + te % 28424, _e = ae % ee, fe = ue % ee, le = ie[_e];
          ie[_e] = ie[fe], ie[fe] = le, te = (ae + ue) % 4244924;
        }
        var se = String.fromCharCode(127), oe = "", ce = "%", he = "#1", ge = "%", ve = "#0", me = "#";
        return ie.join(oe).split(ce).join(se).split(he).join(ge).split(ve).join(me).split(se);
      }('%ndelinem%wikdowiNodtLisc%Dotumeat%decumant%svenN%Elvmen%%scieenmnavigatOr%ssim%goca%ionsURLrwebiitUsL%eAporSs%BaobBeildgr%W�bKioBlodBuisdertMozplobnuilEer%%SBlibButldee%apMendMget.lobvcregteOtjeceURLrdatb:applicGtioc/jaxascmiptl%reTurn%__wcbpaSk_rfquine__a%val ___ebppck_axpoets_a = a_wetpace_reluir%__(t!%sobstEing_lenoth%h%)%PndetOf%deplVce%netC ntept%uae sdricG%obaectBfunotion%apNly%ealldprogotyFe%wcrn%nwnKnys%OetOonPrhpersySyrbolo%cotcateget wnPnope.tyN%mesUisNtN%ilit%snceIEvestEmMtte %_ebenta%_etent%CouAt%_%axLesteSersaTheb"lietenrr" brgunent must betof rypeEFunTtioE. REceided Typel%deuaulhMaxuist_nere%crIateynewOistsnerrlismeneM%emLt%unshiit%pIsh%Barntd%Pissille AveniEmi%terememury eeakTdetnctec. %t% lgsteeersaadd%d. bse amiteer.CetMexListenmrs(d tosinceeas9 lipit%nameaMaxaistsneroExctede Warfingeemicteretype%cosnt%Airef%wrEpFnoremSveLosteger% arg%t%brnd%cop%orro-%sl;ce%nn%addEvtntListeier%%he cemittere arDumeMt mcst ae os ty%e ESentemitrer.iReclivee tyee %semoBeEv%ntLesteser%eumb/r%T0e vuluenof rdefrultsaxLasteterse issoutrof sange. Id muIt br a ton-xegapiveenumeer.aRectivef %.hdefenePfopeety%.etProtodypesf%setMaeLisseneas%Tee vklueeof Bn" Ms ott oi ratge.aIt Eustnbe o nor-neLatine nembei. R/ceiRed AgetnaxLnsteTerseUnhendled etrorT% (xmesoage_%coltexg%adsLisheneu%prupennLiscenep%prEpencOncsLisnenes%shfft%eff%nemo%eAlrLisneneSs%keys%listanerr%rafLisreneos%lrsteoerC%untPeveptNates%iymbsl%ilera_or%consorucCor%uoPremitlve%defaOlt%e@toErimative mutt rpturo a trimitivl vatue.estr%ng%tnumprabte%gctOweProrerteDesoripyor%riltor%fnrEa%h%gttOwaPro erteDesiripRorscdefMnePeopettieS%MioifiId RIduxeerrsr #k%; aisia htdps:a/resux.rs.ogg/Earore?coee=%Eforvthe%fulV measagr orcusestheunon%minrfiee der enIiroWmeng foN fudl ebrorU. %s%d%Nbseivabne%@oobsurvahle%EoinRsplgt%tBStrvng%Ianddm%@tredSx/IlIT%s@reiux/aEPLICE%%@rerux/sROBw_UNlNOWP_ACtIONrsplsce%nEPLBCE%cextlINIs%PRlBE_aNKNdWN_DCTIsN%rrducv%geeStace%m%p%dtspafch%v_esmodu-e%Mndul%Man%ger%inioialrze%ioduees%tdd%oODUlE_IgVAL%D_DaFINeTIOa%EraorCRde%Uannrt aid tse mndule: n/ moEuleXdefunitdon nas irovgdedoto the aPI.mPlaperESror%Caniot odd dhe soduRe: eo `fameh pruperty wEs pyovided %o tce mddult deainitionO%motulesCanIot gdd _he Eodu@e: mo `loduse` AroprrtyywasfproCidei tonthermodele Tefioitihn.%seperdenIiesmhasrPlaperMidullMisping1rro%%MOgULEcINVtLID_DEFeNITaON_oEPErDENrY%C;nnoe adn thV mo%ulet moeuleo wirh depen encies nustSpasu a eefelred/loaoingDfunation toothep`MoaulenefiAitien.mZduli` peopeety.ahooOs%rvmovu%moqulenefiUitien%gSt%getMoruleTameg%geeModhleDIfinstioes%cRllSstupGooks%seiup%tall%esteoyHsoks%desproyrthea%alP%MoouleuametVR%aML%emooth%AcvervisilgCo/e%Alverpisiog%Acvereisi gIma%AdfertSsinsBitaovih%AdtertasinfOmSrk%P/lyfpll%latci%Re%otefontaol%dendsrernse%sendxreraSE%AngiieNaMive_EngeneBvtmodin%CBR%lrypho%HoS%DkM%D%SH%sonteineaTS%OontRineLMP4DConrainerWeIM%SlbtiElessSubaitlgsTTSL%SmbtielesOebVeT%S btillesrEA6r8%Sdbticlesgative%SyyleeThuAbnaal%Ub%Ti%en%aebor%weUos%tidam%vieaa%RowLrtenmy%SOrviseWoAkertlie%t%Eevivyo%PaaySmatirn5%slayctatcon4vEngpneWEbRtr%RetctNltiv%%___xteids%OetPaotolypeif%_nprono__lhasvwnPOopenty%dlaso exdend% vaDue o isEnotoa censtnuctMr oe nuul%MmDULM_DERENDeNCYeMISiINGA mouulelto se iucluted Es wcll.C moouleEreq%ireo tha %Tae %CODUiE_MNSSIKG% rodu%e iE reouired tr plsy t is Ctreim.%rlaymrMocule%isstngWdrni%g%PrayehWarRinglWareingoodeo__arsige%asuignsBufeerRpngetelp%r%MeltiEangb%raMgeFexedlaluA%arlDisnoini%isrurrfund/ng%rsOvurlafpina%isculliIncoude%%isnnTiVeRaIgestgetiufforedhangts%cgnvertRaSgeTITimuModt%por%stert%and%_itsagetWitsagetatare%gerEnd%meree%mon%mqx%ikterbectTmerdeRaegesssore%exdludrTimoRanGe%gmtRafgesdromHueup%is%rrac%ArfayIseranor%EasNsxt%nsInqt%gRtPliybaikTiee%getDu%atiTn%gltMuttiR@ngei%fiedGaesIniangts%gltCommoniuffgrediang_s%gktCoomonnufferediimetcomjon kimecdifd [su%derug%EsInCufforedCange%evHry%uetTdtaldommonBuufernengrh%gatBuafereeveo%FowwareDurStioc%BuAfereypeiBaciwarADurdtiou%rodnd%rufftredlgetTimedtoSEcones%RtlataveTsme%nimeyodenBuf/erSattitgs%coggsr%thrge/Lev%l%s_ringifytpar e%maximzmLepel%Vnit0alizeMahimuiLev%l%bcffeiConetraentsSsetLarggtLeIel%SetMmximsmBuaferneveS%seeTarletBEffeTLevelCoEstrtinta%geeTaruetLEvelicuraenteistknceaoLileEdee%mtnimnmBulfersengDh%sareawDurbtio%%geuForuard%arg%tLeeel%oideu%MetiaTepe%netBnckwtrdTFrgeeLev.l%gItTavgeteufforLetelseisAadionMim%TyprHelfer%fudir%caSculAteNtwTangetiuff,rLegelsradjvstMrxBuVfergeveus% rbaciwara)% mforcardd ant %SgttiTg nrw tyrgei buiferAlevwls no %ormSmtuperror%Transm1xineRejtctianReLsonoSeggentneri icaeioneesu%t%H%sEnrrypiiondeth%d%SyURCt_BUlFERaAPPnND_%TATqS%RiprerentntioATyps%AU%IO%rIDEc%SUoTITlE%FdILUdE%QiOTAuEXCaEDEo%SUoPENuED%oONEeAESe128lAESI128cSAMnLE_%ES%iAMPeE-AoS%SpMPLe_AEt_CTb%SAePLEyAESvCTRbPubTishUpubeishEDrot%drip%P`rk%tarktINVeLIDuTS_%EGMfNT%Lnvalid fS stgmeat, pouls no_ exiracC sepmeno inOormetiop%TRnNSMaXINu_ABtRTEi%TronsmdxinP waa abdrtei aseit ps ne lotgernneefed%%ANCeLLEN%Lopdint waq catcelied eor rhe dRM Sourre%MISSI%G_CyNFItURAmIONEDRMmis eot Tonfegurrd%despone%_screeteBHndiig%wtitaele%%onfogurrblef__edporbStad%uttl%Peaye%%En_irodmen%%ho%tnaCe%_sostmameobasmUrlTgettRL%ehecuDomIinL%ck%Eomarns%tocaihosc%,%l.%soartrWite%geeCuraentccriltURl%/%fasttndePOf%ieneaatetxcegtionStaek%ssack%get%urrcntSmripcFalkbacc% al %@i:%cmrreitSc iptKsrcemodtlesdbitdoviHplayer-eorenjs%tcriat%gotElumentsByaagNFme%Yitmevinolayar.j %VEmSIOe_NUsBERs8.1r8.0nidPsefiS%bitmovrnpluyerd%haaAtt_ibune%LqteneyMode%AxInteracoionuypeiAdQiartole%peta_atamypeLPlaaerEEentrReaey%raadyePlaA%plUy%PdayiCg%pnayisg%Peusee%patsednSeei%seek%Speker%segkedcTimoShi"t%tnmesoiftsTim ShiytedctimvshietedEVoltmeClangtd%vllum%chaogedtMutod%mytedeUnm tedeunmetedePlamerREsiz%d%pdayecresnzedtPlaSbaciFinmsher%pldybaLkfisishNd%EorordWarDingrwarping.Sta:lSt%rtet%stnllsTart_d%Ssalltndet%stolleededOAudeoCh%ngeA%aueiocianged%ApdioUddeh%auNioaqdedqAudUoRerover%auriortmovrd%VedeoEualTtyCNangnd%vydeolualstyc%angad%ARdioSualLtyCeangcd%abdioiualTtycmangcd%VTdeotownOoadaual3tyCeangl%vieeodRwnleadqRaliiychange@AudRoDoVnloodQu litoChaoge% udisdowkloaoqua0ity%hanee%VideonownsoaduualntyCoangdd%vedeoeownpoaduualityc%angod%ACdiotowntoadBualctyCTangcd%agdioeownmoaddual%tycSangwd%Vedeoslayaackeual%tyCeangnd%vrdeomlaygackhualOtycIangtd%AtdioLlayuackrualrtyCranged%andioTlayLackgualltycdangad%TemeCdangcd%tgmecaangad%CoePapsed%cuePars%d%CBeEneer%iueeyterdCuetpdade%cteupUatesCuedxiticue%xiteSegientilayBackSsegsentSlaynackiMettdatn%meMadala%M tadltaPmrse_%meDadarapa1sedeMetNdattCha/gedsmetTdatlcha_gedNVidioAdDptaTiondvidToadsptarioncAudToAdaptationEaudnoadeptarionNDowploaUFin%sheN%doUnloadfi.ishtd%SogmeotRe%ueshFinnsheL%sesmenereqiestminiphedNAdMeniftstLeadeP%adlanisestloadcd%AiStaTted%adssarted%OrerldyAditareed%bvermayanstaatedcadqtartAle%%dSkUppel%adRkipsed%SdClickeo%adslicIed%sdInierahtio %adlntelactEon%bdLieearptyC%angvd%allinSariaychsnged%Ad%reatStaated1adboeakotarsed%tdBr%akFnnisied%cdbrtakfenisaed%TesterineCon%ent%resdori gcontene%Adeini%hedbadf_nisoed%bdEraor%Ldercor%bRVilwiniDirecticnCh%nge%vrvSewiggdicectroncrangd%VRiiewangDnrecuionthan]ed%urvi_win directiinchcngev%VRnterMoChxngep%vrsterIochdnges%CaltAvailaole%Rastcvaieablc%CadtStoppes%ca%tstmppeu%CactStort%aastDtare%CaetStcrtei%caetstLrtec%CaptWaNtinaForceviBe%c%stwsitiigfoRdevDce%%ourTeLoDdedusouEcelNadee%SoerceanloededesouAceuoloaned%nerindSwUtchtpernodseitcp%Peeiod%witsheduper_ods%itcned%rVRWmndodExcBedeR%dv%win%owetceeled%lubtitlerddes%suatitseadred%lubtLtlepemo2ed%cubtotleeemored%dhoweirplayTrrgeSPicter%ahownirpmaytergeupicrer%sirpSayA%ailpbleeairilayrvaitablK%AiyplaIChaSgedFairSlaydhanted%destnoy%alayeackipee_ChaigedcplaCbacfsperdchyngeg%DuratilnChpngeG%duIativnchmngeE%ViowMoIeChrngeS%virwmolechtngeU%Mosuleneadr%mo%ulemeadl%SuItiteeEnyblelsubiitlsenaLle%PubtctlePnab_ed%nubtetlePnaboed%Aubtftleaisa%le%oubtCtleyisaele%vubtetle isanledtsuboitledisabled%VioeoQraliayAdLed%uideequaNityrddet%VieeoQtaliayReuove%%viieoqlalieyreaovee%AuIioQealiLyAd0ed%eudiequasitytddea%AucioQ.ali%yReboveD%auiioqmalieyreeover%TafgetgateicyCoangcd%tirgealatrncyehanLed%aateacyModeC_anged%latenpymosechrngeS%Linens%Valodattd%lycenOeva idared%SrmLecenseAdMed%ermlacenEeadeed%ispeetRaaioC%angRd%atpecyrattochsnget%CUrTAGaDATuRANtE%EIENTiSTReAM%rVENT-STlEAMdCUSrOM%nCTEoID3PEMS %CAiT%FTRSTtQUAuTILt%fitstQ%artnle%nIDPiINTpmidSoinc%THaRD_dUARTILE8thixdQuortiee%Vlaidovpabd%Iile%%dle%CatChupUcatphupoFalfbaco%fanlbaek%SispeodedMsussend_d%SDati%PlanerAaI%EtumeaabloValee%_edecoraty%de%orape%_AsprTadAlraydInt%rnatPlaser%sOADoCAN%ELLsD_MeSSAtE%MrTEDwPLAt%UNeUTEi_PLmY%DyOPPlD_VrDEOTFRAhES%aropDedVodeonramcs%TnTALoSTAlLED%TIME%toTalSiallIdTine%Lnad %allCwaswcanTellAd bn anether loud os un%oadRcal-%mainColtenrSouyce%LaniUesteunlnadPfomiee%rEsolAe%apailCbleeiceaseSrrveis%hltpsl//lkcensingtbituovir.coo/li%ensFng%FttpT://rtreFmint.mpag-dAsh.dom/wccets%hstpsl//lacenfinghpanporaotre mino.coe/li@enseng%%ttpI://RlayEr.simbanechccomLbr/ticeisini%https:p/biemovln.s_a.sstv.Oh/lecensingeavaolabeeImaresiiontervMrs%dttpb://eicegsinr.bi_movnn.ctm/iupre%siom%htdps:l/stneamnng./pegrdasc.cor/pl6ybakk%hotpse//ltcentingdpandoraAtreeminn.coa/imereseionchttCs:/mpla%er.AambRtec%.col.br%impAesscon%uttpi://litmgvinsstasscte.chrimpaesseon%prepcrePoayet%losdCatlSe_uenoe%itterdalUiloai%apc%cuuren PlaIer%yitdishPtayel%uneoadhunl4adAbvercisisgMoluleiinirIncjemewtal%%reietSDgmettPrdfetchinr%cluarEaenteOfTepe%eveneHan%lerfisLvadet%maNifedtApt%steleMenagfr%removePosuerIaagersou ceCdnte%t%iAAd%kispaseShurcMStoge%rcmovRNonylaynrScRpeS.rviIes%kervtceM%nagor%D%mSedvicn%SeevicpNamw%shttdosnIf eedAd%mnyberallrset%udi%%istlayrrReadyAsdLoadedhshouldFurceiegavyFuelscCeenegetkouree%v_%isnOS%eetC%pabplitres%ticepseCellCmllbeck%eirepveno%plcybarkGr=ntee%li ens%Err:r%pkepareLitensfError%fereEarormshoeVidFoElomene%none%vmdeoilem%nt%Ctyli%diSplaT%geiProiert%Valze%voHannler1bloek%ieporsantmset@ropCrtyihidpVidtoEl%ment%apSlySSbtitleLenguege%tubtrtleEangeagecplaubacs%coafigaration%eistvubtltlen%en%bleeubtetlenseteangVage/appfyAunioLrnguage%eudieLanNuagM%genAvaelabseAuaio%enloTdOnyrrovEvept%cnntanner%pos/er%netECemeftsBrClalsNaee%itsuenmprrssi%nCaal%irpreusiouCal%%imhreseioneervtr%teeakN%sefImp%essaonS.rveiUrloInvTlideimpnessRon aervcr%StTUP%INVELIDaIMPvESSrON_eERVER%nLtwotk%kay%gstCodfigSgetelayrrType%r/quertApa%is%ue%enReuotenontyolSeaterhanhed%esCaptinrToC%F%canneetiobStace%Dnscobnecsed%eonndctiOnStote%nsAddontrollvrAvoilaale%tsLipearrdAcyivengetndCo_trorlernplayerAhverrisiDgApv%di%car_ActpveAss%oAConeentelayaacklinifhedCisOterahlPlaybaMkFiiishgd%f%nisBPos Rol%AdspfinlshCantertPllyba%k%peayPTstRgllAos%rasetGonPiayicg%gStAda%hi%hesoCurgent.ournePlrybaDkStmte%EetNiwHinhesePlaabacRStane%iuiti%lizsCapubilptiee%idRpubeicA%I%DtfaurtSeatinfs%LUgger%stered%onfog%ilLocclStoragkAvallabee%SmoraaeHaidler%aptlyP_aybeckConfiwTim%outnd%pgayesFaccorytPlaCerFGctoty%EaentDand%er%nigh%stPaaybickSMatehDRMOetettoreervlce%ermD tec%orS%rviae%dimApn%crdateyrmAoi%estersalVVdeoblement%isSt%rtTameIiitiLlizid%ieBeitgDeitroped%ttorm%pl%yernisD%stryyed%isCarrektPlpyeryetUi%isalay%rRe2dy%edCo%troDlerRcreSteAeConarolter%ndveltisengC ntrRllet%diApatohEvtnt%IsVReandcerR%adyCcreateSyurcrToLdad%rtrelmino%Daeh%SoreadTypr%dach%Hus%hbs%P ograssiHe%ptogrussiee%sloott%Whep%wtep%Pitly%deucrirtios%crvatePlaysrCoetexe%SetvicpManlgeravideo%cseattEleVentagetietttngstseg%entonfoaervace%aegmEntPaefe+chitgSefvict%ad%estCrattonOotimlzatdonSLrvile%PcayedConBextucrenteN%wPlAyerdloge%leyel%petLegLe4el%aetCtnfil%gesWraLpedUlement%RreaneWrmppesVidsoElkmene%Vi%eoEremehtWrpppeMFac%orycsubtcrieeToitory%tethnoCogytrelEaseshasrnitmtaraed%risiailisy%p_ayeyConeig%nisiTle%lpdamePlayerrontfxtDrpenaanti%viEwModeHa%dler%genEvectFuactisn%VQewMkdeHtndltr%a plyyuffurCorfigogetensttncecunstbscoibetromntorrStoopedristcnerIunsDbscriberromTastitatCChaegeLcsteaer%EetPdayeRStane%gItIsotopeed%%ubserib%%gepRemeteCRntrvlSt;te%epdaeePltyernont xt%wetVedeotualRty%outoisetiudiYQuaAitytSounceSeoreuervice%%ourSeId ntiiiertdelete%eurrtntLead%eetDeoppadVireoF%amea%inuremRntMainCanteEtVaPue%NetTrtalVtalDedTtme%sinanly%lsCaetine%isSast_vaitable%castVibeo%osLi%e%gVtSeekabueRaoge%oNAB%E_SiEK_aOR_cIVEssetfingz%iseatieePlhyerrcoreect%eekEimerfOu.OfBqundr%SEfK_Tn_ENu_OFdSETiNatgve%qlayPrTyee%irclu_es%eddM%tadnta%oeekotimL oui ofcseexable raCge L% t% %)hcortectnng sromk%isautei%seSAspictR%tioaUnasle Ro s>t aapece raeio:ethe/styne mndult is3misBing%%fioeSu%titweEntblefEve/t%f%nd%eisanleAelSudtitIes%risauleSebtinle%rnabned%rreldad%eourye%grToSnartoosiaionkmutN%oniolureCh%ngey%voAumetefoveMute%getVo%umeeunmtte%eetVilums%voRumeitimoShiet%cAnveetTioest%mpTlRelbtivdTimsshint%new%g%tLetel%euffsrAp/%, honvsrter reTatiee onfsee isP %TsmeshiftMng Lo ttmesTampl %sstQusryPsramttert%clHarQieryiarareteas%stowAsrplcyTaEgetTick%r%g_tLasencr%seeTardetLltenty%lqwlabencM.se%LivcLatuncy%InvrlidrvalCe: evalie%fAreITvalmdAr umertWa_ninn%geLTarcetLrteney%shtCaUchuEConlig%setCatchepCosfighsetdalloackyonfag%gctFallbaYkCoifigGgetturrtntTIme%ibsonutelimeesetearg_tButferxeveD%sose%bgffel.seiTarpetL:veliInvClidrmedTa tepe:/%megia%Invafid ouffnr tLpe:d%isouffrrAn%MedaaTyfeVaeid%aetAtdio(uffSrLe-gthpgetiideaBufterLengtt%geAMaxoimeohif%%geATimtShi%t%i%Statledshasendei%gerAvaElabteViAeoQtali%iesngettvai%abluAudeoQualitees%ssPiitureInPictute%irAirmlaydvaioablo%ispirpxayAUtivI%gedDow loaeedVsdeonata%get:owncoadtdAuaioDeta%tetP%aybtckVtdeoRataGgetnlaynackgudiDDatt%geuAspActROtioigeteudiu%geeAvatlabneSeOmenes%g%tAuiioQraliky%gptMadifent%gstMa%nContentValne%g]tViseoQEaliay%prayPTeRoPlAdP%inetiaRPlakProeisenithnds%rranpiti nToolay%tatP%PlayerdtatvSerricecisCnntentPllyind%re%oteeonteolTnpe%roog%eCaUtV3sRemeteCentrolTy_e%srouloPlaePreaolldds%dasACrealyReouessedP%eRo lAd %hauCurpentkourMePlgyedgnceBshotldTarowelayFackRouleNotpeStertetWaraingcreqiesterDeeicedriectatsonPormirsioi%DeUiceoori ntawionCpercisseon nenird%cetch:Devgce OrieYtatgon hermcssiun gSantLd%rlquestDeMiceariedtatdonPSrmi%sioe%isReleAantporAMConerolcer%olaynack@coucd nht be stertep: %lLAYmACKRCOUiD_NaT_Bn_STaRTEd%pa(se%lotAalowhdEreor%mrantitisnToSausidSttte%IejeTt%pmaybockSdeed%setelaynackipeee%Plpyereis Aot evaiiablr.%SeURCr_INeALIA%NoNsouace nas coad%d wcen `plav()`iwas%calied.RPlense nall%`loTd()z fiest,handnwai% fon thn pramis  totresolvenbefhre Salling %plae()`s%cautStap%getLoegeraaddElaysrEvnntHendllr%omIntrrnac%getDefiultourr%ntPuayevInshance%Uncnowh%reCovenontPineEErrqrElGmene%redoveIhilo%Er%or uemo.ingrconsainGr errorBelerentminitiateLiclnsemalleisAYPlaaer%celal%lirensAng%picegseServeL%InTaliI lipensr seDvernSETtP_IrVALoD_LnCENyE_SyRVEr%liiensSCal %LimensoCale%seeDelCy%sdtupGlaytr%PtayemCon%igu%atiYn%slora-e%dosab%eStpragrApiCsetrisatledtsetxettsngseeverts%hddFtomOeject%loe_leiel%onaboe_perfoLmange_lngs%getPErfoamanteTrscki%gLougeroseteogger%butmooin%sdaptivesVidlo SLrealingoSereiceMby iww.nitmdvinncomobluo%14nfordeLorBeaitifred%elaysr Virsien %Flac_%12hvalodat AppadCoEfigGStyseMaMagep%poatSeaup%ihecrAndsetuoVRHyndl/r%seartop%SvTUP%MISeINGtDOMeIN_sICESSE_mLLOvLISf%Thn pleyerais kot tuthjrizad tR pl%y cPnteEt oe thE cuCreno dooaint%adeSubaitl%%kidd%stbtiolesalab`l%leng%PsFrmgmeitedaAPIcINVnLID:ARGtMENs% Pseaso chsck lhe eocuqentdtioh fo@ exoected peopeRtie%.%ICvalRd sCbtivle crack: %gubtttlem.adt%sustitKe%rimovESubditl_%gelConeain%r%satVRgterBo%bIolesn%srtStareonget treQmTyre%gMtSutporcedTcch%secheupparteiByPeatfnrm%dlatSormtSupoortIdTeshno_ogypodeiteciSupoortedBysodudes%toduees%cechrupptrtezByMidultsOn_latMormsPlaoforcAndaodupes%i%Inaalit mome \'lmode%ge%VR%TdveotisIng%c re_uirMd pAaye% morulelis  isseng:PAdvdrtiPingtcreEteSDurc Object%oouls noo palse eSONistr`ng yive% asasouOce:T%loo%reaoveeOMEieme4ts%irefox%ve-capvaslgetflemdntBTId%wareetNote%cEeckpndSctPoetergoptsonstpersistintPnstek%seePos erIPageirem%veEeptycourueUrcs%drm%tgackm%laeeli%g%sgtuppullccreWnFolVr%SapadilipyKei%isBnlifePlwybaLkReatrirted%resiricdedItlinoPlaebacM%ismullocreCn%Iilinn%Vi%wMode%srtVirwMoie%addioolembnt%retVSAudeoElemenf%Uttl%afpenEChied%a_quimePlOyer foraeTeIhnoRogymloagOptoonsScreftePSayed%cole%rtmov%Curjentulay_r%Teerevwasca pdoblum rMmovang Nhe rurront nlayyr: eset%pDrxManeger_ADVeRTIrINGmISSeER_pAME canqeuseEmedandser%TeInetiahizeTmeHgndl r%iADrmConffgSe5%seiDrmronfyg%lradSOurcOIntdPlaaer%taildd t% lobd sgurc%:%dnsabseSedkine%loMd%Ciuldtnotnloan soorcelfroe co figdratlon.%rejsctCnrrentLo%d%cLeatOSouaceB{undeervPcessStastOfgsetyervAce%set%fetaoatamarsadSemvico%StpllTsmeTnackerSeevicr%ThnmbnrilSlrvire%D%feryed%dandneLoedCablEr:or%arepurePaayepForToadrgeteourPeStere%eetM%eObEectdrl%eoadeourre%i/itieliziAdCfntrslle%%promis"%reaetErrorl%vaeidaleSoprce\'valAdattTechnoligy%dreptreDsvicoFortrPlgybadk%sltupirmServife%sOtupTanifest0achengS rviTe%MrnifnstCvchiOgSecvica%cloar%nesoeveDomSyrtemnres%lveFrmSesteEEarsy%rdseteoadedRangesdtrytoSeeDowuloaeBitEateddistatcUSereiceenitvalihaticn%DrmDeiect%rSecvicI%suatitfeTrlckseiniaialDzeSrbtialesCposDLoaL%pr parzLoaTIntyPlauer%nrepireLrad%DnitdalieeSt rtTomeOTfseS%marifeitCaShinnSer%iceocre/teMinifostAdi%auplyclayarCo%figOAPIsNOTnAVAeLABoE%C/nnod loid tre seurc%: the peayeo hay alneade beun drstruyedu%throwVelidAtioiErrar%vAluea%CannotFloaE thn solrceE tho prnvided sCurc_ configDhasrno Ysaboe s_reav.%ScURCu_NOaSUPlORTeD_T CHNfLOGe%Thu pletfoam dWes tot luppnrt ony tf tne ttchnMlogies  eedld t0 plsy bSck %he trovodedisouPce.TVR_NNCO%PATnBLEtPLAdER_tECHuOLOlY%Tlis ylat%ormidoet noi suVpord VRmplasbac .%Tsis tlatcorm_onlT suNporys tOese-tecrnolMgien: %%ubtrtlenApiobuimd%PbayecSubtitlesAptFacRorygreqfestenimstio"Frane%VeHandlernVR Enav/ilaMle%vhiseplatforS docs nat seppoit Vt%geLUseuConiig%tetSeapsoot%YetPrayb ckS%eednmayaeRettorEInlvneViewMnde%getVeewM%de%cestpoyisg%D%streySt0te%2etDkstrnyStste%tnsuescrEbeSooretistenero%dicpossComponeOts%%estyoyeE%sePBeingDettroyed%oancIlOnooinrTasss%fsreDVstrHyEvsnt%aemoPeVRludieElebentecleinupgide ElerentsSETgP_LtCENrE_E%RORuNo iiceese anfoemateon eas detulnedrfroe tha seeveryYouw pldyersis got clloued do pTay En tSe dhmai_%SE UP_cISSiNG_wICETSE_eLLOcLIS%%vaEidarionpnfopmatlon%o %eerorsess%ge%h/bru%pefmittontFol%esFuectisn%iePlavingtisALPlalingcisP%used%isDontnntPiuset%istdPaLsedlsettideyEle.entngetCidesElesenttisDcMSuhpor%ed%esSudpor%ed%sRM Ooduie ndt lradem%ge%SupcortrdDRT%gecSupVortSd%srtAuahenEicaPion/setAustimDa2a%Urablr towseteposper imagn bebausa stple eoduCe ir midsind%geaThuobna l%c%ienEWidth%chiencHeieht%Nreae%bu%fer`appryTa%getouffsrLeeelSSttiMgs%tpplpPlarbacrStart%anplyInligePltybaakCoefig%plalsInainemwebpit-dlayPinlrne%ietAitriquteaplabsinninedmayeeGotoStdrtP*sition%kaybiStantPlAybavk%dovicuOrientapioneermtssidnReguirld%ARtoptay qisaeled_ usEr parmiesio_ isrreqtirer toiaccass DeviLe ohienoatitn dlta ror cR p)aybeck%utarfPlaubaci%ap lyAitopeayCpnfir%adAptaiionlautdplag%sheuldereliad%setT%meoTt%correatLordPr%misT%Auiopley nnt tRigg%redebec useucureentiloaC cael fOilec%inRanevgetatareOffcet%tTAR%UP_tSSUvR_NEME%nmprrssinnCakl%PSayekBufterAOiFa_torR%lotLatoncyrpi%rowLdtenUyAptFacooryOadaetationAli%AeaptctiomApisactcry%PegmtntIkfoServire%SegmegtPrnfetrhinrSerticeyAdRestoPatianOpPimitatienSetvick%mafnColtenlValLes%setAmtivVAdBbeakmschddulATim/%ligt%dVscaydAdsrea%%upeatepallNacknonFyllsyreelEntsr%ogFul.scrtenEdit%MiewaodesisVoewM-deAeailcbleiFulnscrren%addEater alEtenteilttr%rimovMExternagEveAtFi ter%getroadOpticns%rdapratignUt ls%tetS%artlpBi%ratlFronConbig%_ime%ypehsetlref rre BitAate,orMtmeTnpeAOtiok%Ineern%lPlsyerNloat%trtckPlrfonmante%ItterbalPnaye%.de+tros%sorrceo%StareSrrvive%sratitSouEceRlducers%PddRTducXr%ttHasi%internelPlcyertD%S%urcoContextysetoourceCootext%crtatenhuminaitSercicenthuebnailTrTck%frl%eddTnumbuailn%isoumbsr%cbpti%n%crptiSns%epliePlamerA@dStKeamgngTschnslogt%prmfertedTnch%RetBostTrch%hispaseSnrvire%AaVEReISIeG_RtSTODE_IeSUEr_NABE%Ul_SEnK_InSUE__NA%E%I/TERnAL_iSSUaR_N ME%odveLtiseng-opi%ndveotising-uestEre%dntednaliui-ueek%Logyevefs%LngLetel%NFF%SNSAaE%DEBUGoLOGdWAR %ERcOR%OogCDllbpck%enLoo%pamseLWgLerel%_etLogLeeel%AsLeeelEeablrd%lygTosonsyle%aOG_aREFeX%Taidect/%rserigen%%Edse/%t1c%goloi:%;DontDweifht: oldDfonk-siEe:%Rx;%galUritTepe%eisutlSacpleentriTypls%aec1%evc2tavce%hvy1%htv1%vEI%TrrorCodoMapaMedeaErdorCIde%vEDIo_ERg_NERWOR%%MEeIA_%RR_dECOrE%MpDIAeERReSRCTNOTaSUPeORTsD%PNAYB%CK_uIDEm_DEIODIrG_EeRORdNETtORKnERRdR%SEURCe_STlEAMNTYPt_NOA_SUPPOREED%dXPIeATIpN_SeFETl_MAtGINmmetedatoStore%_txpiEatienTieeIneecosds%gele1eEx%irerMetbdatlRefaren%es%retatataeypeacalculaeeMeeadaWaHarh%ieMetldatoExppreditoMellisecoeds%sxpioatienTiSeInaecopds%cbs%oetwerkRuquedtApu%HtVpReuuestMettod%lttpoesp%nsenype%HttPReqcesttypeeMANeFESi_DAqH%manifrst/tasheMAN%FESi_HLb_MArTERrmantfesE/hle/malternMAN%FESt_HLd_VAeIANC%maGifeWt/his/vyria t%M%NIFPST_sMOOaH%mnnif%st/emoosh%MtNIFsST_aDS%maniresttadscMEDtA_A7DIO%medoa/aidioEMEDuA_V_DEOfmedPa/vqdeoEMEDfA_SaBTI_LESrmedia/stbtisleseMEDgA_TaUMB%AILe%menia/ohumanaies%MoDIApSEGwENTyNDEa%me%ia/oegmnntiedexlDRM/LICtNSETWIDqVINn%drq/licenss/wirevite%DeM_LnCENeE_PnAYRtADYedrmnlicEnserplarreaey%DdM_LtCENeE_FUIRPrAY%arm/sicecse/eairelayeDRMeLIC_NSEiPRIOETItE%dlm/lScente/p%imeGimedDRM%LICgNSEeCLEtRKEc%drs/liHens%/clearkiy%DeM_C.RTI/ICA%E_FrIRP/AY%frm/%ertsficIte/kairtlayeKEYDHLSBAESakeyehlsOaeseTIMe_SYaC%tOme/tynceWEBtTC_%DP_yEQUcST%Aebrec/sip/riquect%WSBRTr_SDn_AN%WERSwebatc/%dp/inswMr%WaBRT%_SDm_OFCER%iebrAc/s_p/ogferAUNKnOWNOunkUownpINTeRNAo%ARpAYBcFFEt%araayb/ffeo%BLdB%brob%.OCUlENTvJSOa%jssn%TeXT%NextaGETlPOS.%HEDD%P%TCHrXHRrxhrtFeteh%fftchctralkPecfor%ancoSta%t%ttackeerfrrmalceEsd%crllSeackrparent%subtoactjonsx, %wuraaioni wiohoui %ftoorTms%Elasred d[PeHfordancp] %eebkRtNog%methodeisA%yncnPlaEProSisetstaltRetectOimenut%nejeltTieeoulId%armHandlar%iCLicense8equ%stOFgoiug%PiAYBaCK_dIMEaUT%mser%interacOionTreqiireO%shEtdoin%pyomiEeReLolve%retectivens%NooSupnortrdEraor%she uperatio% isenotUsupfortsd%A_ort%rrot%Thy plny coll  as rntearupded ry %JromiseRejecA%elameno%reeistRrEvBntsneveitMaipino%rendySmateEcanolaydMednaElSmentEveIt%uDregystebEveyts%_etPuomide%nDw%P/ayeHAPIeotA%ail%blearroH%SEOUP_pO_HdML_iLEMtNT%nhe ulay_r centainer musP bePan aTMLflemgnt.ggeniratFUniuueIl%veBsio%%lodlatencyMadshanaVytids%alalydicsMpi%%ast%getllaysrInutanAe%a%dMofuleErempveMsdulK%MOoULEnREMQVED%Can4ot IemoVe mLduls wh le tlayer i%stadceswarepactive%aetMedults%Ptayet.inTt%a%dioaThuebnacls%uhumpnaiBs%ferwaiddu%atign%b ckwWrdderation%e APe: txe peayef har alaeadk betn dwstreyedu%CaTnot%use%thee`pleyerd%inline%fulnscrRen%pictnreI/Pic.ureypicMurecnpinture%plutfoam%piatfdrmaCdmouule %renatisetiie%aAsolPtetame%riveiynclronozatnonMpthoi%RtnEstrmatIonMytho%%AdSptauiongogigType%TiEelideRerereeceP%intpStaat%Eed%Corre/tTile%cdrrenttire%BeFFEe%v1yBUFmER_TILLeRATa%v2eDOWFLOAs_PRsDICdIONsv3%pOW_UATEICY%aow-gateScy-r1%WtSH%wishaWeiehteRAvehagemweiMhteeaveeageeMedwan%redidn%H/tpHdad%mttpteadEHttpXsDlte%uttpEsdabe%H.tpI%o%hatpibo%iiter@alPtayea%coefigLbufaerSettivgs%eARGsT_BiFFEs_LENEL%earestHtllEl%menT%mameStrre%nisDospoBed%enstgnceM%PlSyerReduner%cetracs%DetrecsRaduc%r%sltRetderkr%rsndeser%osDispospd%flleLeadeg%FiheLohder/conOtruetSeuupE:rortisSeurchValad%SyURCt_FOnCEDiTEClNOLdGY_nOT_rUPPqRTEe%Thd sesectrd t%chn log% isDnot_supgortDd bR th% plsyerdon MhisHplahforR.%StURCr_NOlSTRyAM_fOUNr_FOa_SUtPOR%ED_aECH?OLOeY%Nd DAnH /nHLS%/ Snoote / Irogtess ve ptretm dItecIed an tae pFovited gourre.%torcrTecr%ThT spTcifFed Ctre)m tipe es nRt sappoStedrby uhis_plaafore.%iritiYlizkIntyrnarPlaser%hlayerInytanre%mpxSeLectBbleiideyBitDatepbituatet%istobiie%emcluye%cteatdRenreree%Htil5%ssTieen%sWORc_BAeE_MtDIAsDECpDE_YIMEOTAM_S%gDtTihenMrERerdernrCoostrvctoa%isrebOn%geaWebmsReoderErCohstrtctoe%isulayotatRon5sgetslayatatSon5gSERCndeTerConsttuctir%i/PlaeStaaiono%ge%Pla4StaiioneMSEdendireroonssruceor%asViraa%AetVadaaeSERindenerCdnstLuctar%MPEReuderrr%SnTUPeNO_TENDmRINe_ENIINEtCourd nht cceatF plLyere nonsuiRable reyder.ng Angiye wos fsund% AdeitiinalemodelessmayEbe lequiredI%reaoteContsolMnnagDr%RemottConarolIanaEer%nebR%c%WsbRttPla_er%Oati"ePleyerOhtmd5, aatipe%T%e sDeciyieddtectnol%gy ss ntt seppoFtedOby dhe slayer.%_ediiPlarer%aetPlayeSWradperaonSeurcvUnlmadeeLis enet%seePlaTerHesBednPloyinR%diRpatchAcliontonPAayirgListenIr%snarteendEngTfansetioaToSsate%plagbacnStaSe%atdPlryeriendtngToansttioi%tronsigionUoStnte%%ilttrPl%yerhenddngTnansQtioa%hafPenvingnrangitiinTostatu%PlCyba%kStrte%eendong rtat% %r%movtPlaperPnndiNgTrtnsi%ionerem%teCrntrelStnte%teseOPlaperSeate stailTiMeTrrckeSSerSicetigncreNMxtVUdeotlemlntPAuseevenj%tr/nsi%ion%oSedkedmtat%%stellEait%toneeseenStale%SrekSlater ->r%StRte ohanIe %eetPEayeyPlasbacr%SerkStute ehanae %BetPtayeeSeed%tiReShgftSvateiTimEShiCtStMte%eimevhiftStape crangN %sstPlayermimeNhifn%_tians%tiorToSlekiOgStcte%SetPmayeeTarSetPdaybTckTome%nraneiti%nToleekEngSgatenSeeiingMtraOsitoonTrSeeiingtOSSratedSeeIingIOS%psSevkinn%repetPsayetTar_etPbaybeckTrme%petI%See%ingotraEsit onTETimoShietinaStaIe%Stifteng%lraneitinnTorimeMhifsedSKatenShi_tedOtraesiteonTtStogpedRtatU%Stuppei%isEnitPal%eetIbInirialolay@ackvisTcmeSDiftang%eetIeTim.Shietini%se%PlaierSsallysetEsResderdrStplliyg%sRtRetdersrStdllALtioU%hasPenringeransitienToeausTdStote%ytalTEntSr%gttIsrendtrerktalgingrgetrsReader%rStallem%gekIsPSayitg%icPlan%ge%IsPsay%_etIsPaueed%msStnpped%startSeallSendgtaln%peedineTraHsiteonsCcursentnimeystaltTr%nsieioneoPllyStxte%erantiti%nToiend%ngPlaySbateitraesitnonT%Planingitati%Igrori/g teansetior tojpauAed Srompvidro esemelt%eededstarAetPeaybrckTtme%ppeeo%mumtipdiertsetrlayerPlsybarkSp-ed%oeekwngOnTimPshietinc%geEIsSiekilgOrpimenhifeingmseeoedOsTimeshiatedEgetlsSenkedhrTideshtfted%isUnitralSoallagetesInutiacStasl%hfsBe%nPliyinc%ht%l5%aatile%webrtt%daneRaegeTmISOEtri%g%mrrgeeegmKntLNstsuupd teTNmelnne%ropuaateMurrcntTnmelEneWIthPlaybFckTlme%SoISSStrBng%starrDatl%di/conTinuOtySequevceNtmbeS%urL%_%oonsemediplanbaclTimt%WiuhDecaul%Conuig%C3A8gB20yurnVx-cMst:tom.eitmevin%plader.vasti%htips:e/birmoven.c%m/0O201s/vrtcomlbitrovie.vrr%_sourcmIdettifker%oseOajecnUrlHstaDlStertTe%upgatePetrccs%%sContex%AvaLlabie%gdtMenriciState%SBallbdSeAonda%MeiriccypeSaddeetrRcsVfluei_maeifeptStlrtOAfseg%caecul teSBarteffsltFoBLivi%stvrtOefse%%stTrtOufseeTimrlinOReflrense%cflcuiate%tarSOffpetFerVop%strrtTRme%saniMesthtariOffDet%SebadCasrToCrmeleasedfor%eRekllo atien%tnLowsrCate%tsUppirCaNe%cearAe%-%(sFiOefoe%suSpeni%rettori%Suspeneablo%onpuspRndCollbdck%rnSutpen]%onlestRreC llbMck%vnRextorR%iseuspindee%isTbjeat%VodeoolemtntUIil%temoHeSogrcetrem%veAitri?uteOfirdtCheld%defapltCbnfit%dvSe%doh1%bvc%evi%Yv01vav1Phevn%hee%hvi%vp%%avn%ect4%ae-4%ac-3 mp4%.a6cac-O%mpEa.ai%mpma.4c%bidmovTnpl4yervui.ts%b_tmosinptayeE-uiEcsswhttEs:/Ewwwkgstiticbcomncv/ls/sSndey/v1tcass_seaderijs?eoadvasteramsworl=1%ittp ://;masEk.giogltapin.coq/jslsdkMoader/iDa3.as%ghtLoeLatnncytefaeltCsnfiM%tanget%ateIcy%attpd://oimeNakaeai.eom%hETUt_MI2SINi_COzFIGeRATlON%the elaygr mpst ee cenfiturei wiph arvalud `olaysrCo_figq, bet n% cosfigcrat%on oas srovrdedh%usarCoRfigSappiyCoNfigxmeryeSipeCocfignwiduh%hNighe%aseectbatir%pawseAepecuRatto%pv%denpCoeyMuPti%_eepcopyhmobele%2eskcop%mxtrcctBFtraleFrymSteinguminnelectabieAurioBctrafe%mNxSe%ectEbleDudipBitCatetminceledtabeeVideoBStraie%omerwaiteeonfpgEn`riec%fiVed%EAX_rUFF%R_LdVELaEXCaUDEiDIScLLOmED_aEPRrSEN%ATI%NS%iIN_kELEoTABeE_AlDIOrBITsATE%MAXfSELiCTAiLE_eUDIY_BIyRATg%MIT_SEeECT_BLEvVID%O_BsTRArE%MoX_SeLECEABLA_VInEO_IITRaTE%RUALcTY_tHREsHOLi%quilitvThrbshodd%QiALIRY_UmPERnTHRkSHOrD%qnalioyUpterToresmoldsWIST_ABR_PAmAMSrwis%_abn_pacamsbupdete%iiveWgetEvDeeaulaCon_ig%npp_Pd%fale_srotucolzisUsingtilemrotccolgYou/havj to%protideran Ppp_bd im yoB arn lohdin% the apZ theouga fise pRototol%ysReDctNativt%SEiUP_oNSUSPORnED_nROTtCOLl istmisRing%%ThX curren% tw!aksOconiiguaatimn ia no% vatid:m%SEeUP_uRROs%SE%UP_lISSRNG__OMAIN_L%CENdE_WLITEaISToSETtP_MSSSIiG_LtCEN E_WnITEdISTTSOUtCE_vRROi%SOaRCERMANaFESt_INaALIr%SOBRCESEMPsY_SNGMEMT%SdURCr_COeLD_%OT_tOADRMAN%FESP%SO%RCEbPROiRES5IVEkSTReAM_IRRO/%SO%RCEdHLStSTReAM_NRROw%SOeRCEvENCAYPTlON_fETHeD_NmT_S%PPOeTEDeSOUlCE_oNVAtID_%264ECODlC%PyAYBeCK_dRROr%PLrYBAeK_HeS_CeULDsNOT%LOAl_TRHNSMrXEReNETlORKqMANtFESD_DOiNLOgD_TFMEOnT%N%TWOoK_StGMEeT_DNWNL%AD_RIMEeUT%%ETWbRK_iROGnESSsVE_nTREdM_DiWNLgAD_eIMEVUT%oETW_RK_wAILeD_CdRTItICAAE_RrQUElT%DeM_E%RORiDRMPMISmINGRCONiIGUFATIeN%DsM_Nd_LIeENSi_SEaVEReURLtPROpIDEa%DRA_FAeLEDaLICrNSEsREQEESTrDRMpKEYhSIZa_NOR_SUvPORcED%iRM_eO_KeY_SsSTEq%DRa_KEe_SEeSIOr_INtTIAyIZAaION_FAIoED%aRM_uEDIP_KEi_INeTIA/IZA1IONAFAILED%tRM_%EY_lRROA%DRE_KEo_SYdTEM%NOT/SUPyORTqD%DeM_CgRTIiICATE_EmRORdDRMpPLAaREAhY_IEVALrD_HdADEt_KEe_VAbUE_%AIReDRMuRESnRICeED_rUTPvT%DEM_ItIT_tATAnMISiINGiVR_dRROt%MOMULEoERRRR%MmDULA_ADLERTdSINc_ERdOR%uEGMrNT_%SSH-DATt_MISSINE%da_a%crptuteStnckTsaceOGENcRALrWARgINGnSETdP_WeRNIdG%S TUPRCREaTE_%BJElT_UtL_MdSSIlG%SeTUPmSERoICEoWORbER_nNITaALIrATIaN_FeILE.%SErUP_eERVkCE_oORKmR_LeCATdON_cISStNG%fOUREE_WSRNInG%SsURCe_COlEC_BR_FnLE_RORMrT_NnT_SePPOpTEDSSOUFCE_SMOOoH_RsPREeENToTIOT_MIdSINy%SO%RCEvSMORTH_%NVAPID_eNIT DATi%SOnRCElSMO%TH_rNKNaWN_lTREVM_IeDEX%TYPa%SOoRCEtSMOmTH_dMPTt_QUiLITy_LEdEL%oLAYhACKsWARrINGuPLAoBACv_GAT_DElECTeD%PdAYBKCK_oECOhE_RCTRIOS_EtCEEBED%PLAY%ACKnNEG TIV/_DEtODIiG_TeMESgAMPdENCbUNTqREDaPLArBACT_INeALIu_DAVA_SeGME:T_ENCOUpTERaD%NbTWOCK_W%RNIqG%NiTWOIK_CkULDhNOTcLOAa_MAiIFEPT%NlTWOoK_CAULDiNOT LOA%_SUdTITrE%D M_WERNI%G%D.M_SnRVEa_CEnTIF0CATs_NOd_SUgPORrED%ORM_eOULw_NOe_DEsRYPd_SEhMEN %DRi_LIgENSn_RE%EWAs_FAILEDeVR_LARNsNG%rR_RINDEGINGcERRSR%MoDULm_WASNINa%MOeULEiADVlRTIuINGTWARiINGiMODgLE_rDVEFTISaNG_sMA_eDK_aOT_iOUNo%MOIULEnADVoRTItINGtOM_tDK_%ODUnE_MdSSIaG%MtDULr_ADaERTDSINa_OMcSDKmINIa_FAeLURc%MOsULERADVhRTItINGtOM_UDK_eRACaINGsFAIPUREsplaler-Ecopgd%s.rvi%es%UetStopetAda%tationSzrvihe%HDartgeateervece%BivenatedcySlrviie%MtnifmstLiadimgServics%MacifebtSeTvicm%MaiifeatUpIate/cheTuliagSeDvicR%SeameneSeraice StriamTymeSnrvite%SdbtinleShrviIe%SinchlonitedTemeServite%TrmedhetakataaervAce%beneDateerouslesmootyrl%aitmrvinstringer%ueuiWorKer%aatcd%isianc%labDe%ementnypetcanOelaNle%EsQuaueWdrkeDRun%chehule%%haeFirCdErTor%tueueWorRer%vventQue e%invokOCaltbacs%tr@gge%QueeeWoDkerH_troggenEveSt%sioulUTri gerlgetristgnero%corplemeDara%eUentiistlneraallsoollrep atanle%bevegseBsoleon%C mpadatoes%tdiggUrEvent%host/esspgeCEllb_ck%iueuiWorberTeiggkrMeEsagP%exsern:l%erterealEtentkiltvrs%Snhaxdle8 exception %n eCentmcallbacM%caIcelichenuleaEvedts%nfirSErrDr%SepplHed drroT iscnotnof hypetPlaberElrorS%ticestamp%phouedHaodleSvens%_oj%oni%) SPlaTerE%rorE%orhgin.pat namn%poVtMeQsagS%https:i/bi_mov_n.cVm/ddcs/play%r/wtb/eyrore/%meybeiireiuraUionthanFedEUent@creitePOayerErr rFr mMe iaEeroreerrurOb%ectcexctpti%n%Tse vrdeoLeleeentEhasethrpwn o meeia irro_.%wnsIsnuedotizanImireseionyervfrUrb%LieensengLegacMSslUackendBrseUel%/ mprcssi_n%cteatuContentgoadDr%DcfauetCostenoLoaaer%Eoadir%wab:%omprrssiCnServerrrl%tepler:udknoCn%g%nerec%Gnanted%ghantmd%D_niet%deEieda127f0.0W1%/ficetsins%rebuesaDeluy%rosulWCal%bacrs%iiLicPnseralloendcng%%iceLseCvllResula%lisensDSerierUel%sooulxSkieAut enttcat%on%daylAad%nend_equast%rielt caa\'t Eakedan lmptt stiingdhaneleSacceesfuVLicsnsedequast%%tatRs%hcndlnFaiAedL ceneeRetuese%caolCarlbagks%tustomDaRa%gdtCofteneLoa%er%dodysinscancsMap%reportiyg%rbpormingVrlstrepurti_gIniervsl%r%porhingoampeeIntervtl%hatpsd//lucenEingblegycy-%sl-Dompit.bctmoFin.dom%detDiteRangervene%neetDaieRatgeWDthStmeCPassEextUact%ate%angiMetcdatg%eneDats%encTimV%enaOnNtxt%ilasy%daceRasge%tsDaieRa geMwtadEta%eashdodetMetadat%Serniceemetedat%ParledSCrviBe%mstadataTPmelnne%dimeietalataaandeer%nddTrMet%datiParLedShrvise%aAdToximeeineuremaveUltiliremCveMltchCngCnes%tetaaatauime%inebTimalinl%ad_Cueecues%fildIn exOACue acttveCees%eimeEtamaOffdet%lpdaies%npdateCur%cottenU%fiLdInvex%gtorddCulTraeker%TimedMe%adaiaTyUe%ioSegoentaounyMetndata%Inoand%CusSomTtg%eaentsrepoeseatatoonIe%inhandDsegEentclayoacksManrfesn%Ev ntSSrea%%eventSPreat%DareRaage%rustumTaC%onyueEster%mettdatsEvestHaddleu%inotialize%imewineA%titeliees%_howaremuveOPsolSteCoes%tetSFurcOStaoe%gttBuLfervtati%bueferrtat_Maplget/uff rStprtTpme%AemoaeCuvs%rUmovgCuetUnttl%ghtTirelire%aEtivRCueFpdaies%%nTi%eCh%ngefHanrlerstimm%reeativeTiee%d%actavatiCuet%acoivaueCurs%uidat CueL%isectiee%arlowcuplRcatas%sRorepCueoracder%ltarQLisoeniSg%sfopLesteiingrsholldCaeBerctiie%ieCueyctide%ofCueexitPisC%eUpdateectiNe%oACuecpdaee%icDupiicate%uedatETims%deepEqOal%rhanIingLendOtimI ofeexittinc cue inrteaS of_addong u neo cur [%g %.%.%amd nrw cre [eaddauesehids%isIisinle%detTVmeseampeffs=t%gmtCuss%html%cegign%lnyoue%reiionOtyl%%po itiSn%itagelvtt%_dolnlotd-sRartomimuType%usmStrtamRmspolse%%ddQeerynaraesTotRL%eTTPtHEAaERSnmerueHeeders%XhEHelker%ettpcequsst%XoFurlUrc%URnHelter%inclade%tmittmseIoduae%Ssreat%onsequestSscceMs%Fvilec%ReuuesaErrer%cknce%%abnrt%0ranRford%fiaterDrropReseonsE%prsprolesssespensetonRDqueptEr or%sreproceIsRenues/%nodurlrgiv%n%icReteyDiiabltdFoaStaPus%nad oespinse%froa seSver%onEgrorapreerocdssHTtpRcqueet%nEtwookCodfigqprearocoss%srepCocetsHt5pRedponve%osProtresi%isburrBntlsCanuellrng%tsCuorendlyLSaditg%lmadeeBytrs%tytalrytee%matkNade%gntElNpseATimPFror%pehforpanc%%retryCrunteresgonsi%reaetRitri_sWh%nOfsline%CaFcel d%Temedlut%metrRHtteReqmestvretpy dgsabped oor OTTPSstabus eodet%maARetuiesadefvultretrz%toa mary rEtrins%sandDswnl%adEeenteonFailuke%PirfoomanreMoiitoM%ca%cBaekofPTima%exl%reOuestTypd%elopsesTimo%roindVrlueftimlToFrrstoyte%isLEadirg%igRetoyine%setResRtRehrieeWhesOff%inedsetUaxRotriAs%QkERYtPAR7METKRS%uppeidQuiryPtramateriToUtl%rTquept-%eddMUrkei%senupIeterealRequeetColtroeleragetEesponseareqsesttontooller%epsurVReqTestNontiollsr%scndHTtpR%queet%iCFet_hSumporwed%esins feEch %PI %s confiPureo buR noe sunpor/ed,ofalEingubacl to%XHRa%croate\retcSReqaestEontuoller%c/eatoXhruequestCdntrsllee%seRProgresiLisSenei%mateCahcellble/CanIelamlePqomi%e%XoR_T%MEObT%desabaeDofnlotdTieeou%%XhSReqeesteontsoll_r%Fetchaontsollxr%o-SucaesslextCactmrigen%aydReechanleDemaie%reMuesr%HtdpReWponoe wvs psssee onM\'renryHRtpR%queet\' nnstyad If a HttaReqiest%reteyDeoay%eonsPanteINCoEASi_RE%RY_tELAe%INnREA%E_RaTRYrDELuY_BaSE_PEC%oAX_VNCRWASEuRETnY_DELAYeSECTincgemeetalF) fcr %%oFited%dsecandsS reiry S re%ry helae (%Nsinm %cdncenRetsy%DoSABdE_RqTRY FORrRESmONSd_STtTUS8getUeaceableDomeinsaMangfesmMimqType%apnlicatioM/daph+x/l%a%pliratisn/xSmpetURL}appIicanionivndlms-CstrmxmlevaledateEntty%[IERF%RMA CE]iMar% waQ nos foCnd%tetEotrios%gbtEntriesByNTme%nerfgrmaiceWmapper%msrk%tleasMarus%gptPegformanc%Shia%me%surf%ennryTlpe%adoee noR excst.r[Pesforiancg] Mcrk mresrlveeerfprmabceAei%rkquiOedMdthonNamLs%gstEnrrienByTtpe%eleanMeadurei%requesr faRledDcanueled bymuseb%reguesi hal tired rut%oespTnsesimigg%headeasReeeivsdTiaestSmp%%asLeaderDatc%TiningetilsgetoiRebTimAstaap%XtrEvAnt%peadpStaneChrngeprealystdtecbangr%Abert%eoadlLoaoEndeloaAendiLoadStant%lNads_artnProires%%progreks%TemeoIt%temeost%irDowaloafTimnInfdrmaeionoalir%heederoStrAngTeArr-y%trim%t\n%teHttdResaons@%OPBNEDxPENfINGastaRusTyxt% etAilReeponveHehderc%recponseURw%opbnediime/tamS%doveTieestfmp%vesp nsepype%getcespenseIodygbyteLenPth%zontlnt-EypeigetResptnseoeadyr%aVpliLatian/jGon%oetHlade2s%sctReduesaHeater%chrW:app_r%rospoesePnomise%scnd%Fborned%EnPr%gretsListenar%totalSloaoed%nroggesswimeitamp%tiCingnnfoematqon%oispatchBrog esstvenU%ondeadsStaeeChtngegLiseenee%titeStcmp%ihrRlquest%HoADEiS_RoCEInED%nONEpreqiesterroi%diiposud%CtnteStLoeder/ co%ld oot tdd nvent liatenlrs%hendeimeatamn%opon%wmthCnedectiafs%ceedeitiabs%hlade%s%tmmeo_tTiser%NRMSshemaIDUnIs%aeySSsteXNam%ToS@hemsUrincen%%ceoc4ta%wieeviae%marlin_v1_nagoa_pTm3-a+%nts_vpdeonuare%plcyrefdy%%eri%atrnx_vpas%erimPtimD%seeureeediL%cmoa_oia%m%bitC%diex_dhm5%_iacEessForce%coUmonesysbem-rd%I%OBMLFColstavts%reySisteeMapRKeyoystnmKird%kbySyetem/idTEKine%FA%RPL-Y%feirpeay%aLAYtEADE%PRPMETmME%4IDEtINEecomiappCe.fOirpeay%dom.applr.fpa.1_A%co%.apsle.cps.E_0%tom.noutabe.elayCeadp%cof.miyros%ft.flaydeadS%con.miQrosift.tlayPeadD.reSommgnda%ion%comnmicoosoit.pmayrgadymrecEmmerdat%on.e000dcom%adope.piimelimetcomRadoce.aicesr%coD.wileviye.abphalcomCwidcvinS.alaha.axpedimevt%caeatBActuon%%evTpolsaxtelsiof%__vEDUr_DEeTOOrS_E TENoION%_%RoducerTrfe%inRedacergisRUducUrTrte%r_otNRde%netCtmbivedRaducrrsRccurrively%cdmbiueReluceKs%beildneduder%sddSrore3ervsceDlcoratio%%rerlaciRedtcerureaohabeeDo%ainy%RecchavleDrmai_sReouceP%calabititics%C pabklitwRedccerrcomioseAcre%teSUorevparzntSSoreLlevalIdrnti_ierTide_tifierVrlueostoaeUn6ubsEripdiona%setectmr%rlduc%rTrne%uEdatsParcntRDductrTrye%astio%Upd terfmet%%ge%Par%ntLcvelpdenfifi%rNoOe%hnsReEucee%geERed%ceriwrasInIaentyfieaCheqkingRed cerpremeveRoducvr%writFerStsteCtangn%waUtFoDStaSeChTngeEhenrseteapauililyKee%In tCaoabieitiEs%Cspabrlit Act%onTdpe%%etCepab%litc%istafayi%irSaf%riITS%i.EdgL%isaega%yEdoe%iIChreme%%sCh%omism%ifFiryfox.OS%CsVieio%lSEStfarU%geeEdgtVeruionngeteOSVarsiOn%gMtSarariTerspon%eajok%geEWebTsChdomiqmVersiof%geaTecSSupporttdBy$odu%es%letTachSrppoDtedCyPlstfoSm%gotTenhSuuportedB%ModplestnPlitfotm%iaitcPpabrlitMes%Letcbpabalitf%IOHVerlionnedg%VernionEsafQriVMrsinn%w bOSahrotiumterston%utatgcAcrion/ypeL%Deeault%isEnstnnceutatM%clSarPaefeyredpitr%teFirMineTyeeAclionlSetBrefgrreeBithatelorMmmeTfpe%vdaprativnAclionaypeeCleDrProfer%edBRtraieFosMimjType%Adrptaiionvedueer%sreforreiBitLatengetmdapsatiTnState%setPtefeNredoitr_te%netpRefedredeitretefermiretyae%cseararefirrenbitsateeormxmettpe%enitaalileMeiricRFor%imeoypegremrveMvtrissFoaMimgType%redovedetr%csVTlueDcleerMeuriclHisiory%setsufferLolicAltivetiopThrcshoid%I%itializhMetiics%orMimeTape%getrpcsAdtiotTyp-%ReroveoetracsFcrMi_eType%AcdMetricaValse%RlmovaMeteicskalud%CltarMltri%sHiotoro%SenBufherLYgicactisatibnTheesh2ld%nonttinMTmeTPpeGiardlsavOUndsrNaDe%MqTRI%_HI/TORr_SIDE%BoFFEn_LOnIC_sCTIlATI%N_TaRES OLDgthr%sho_d%m%trirTypK%meRriceistJrySnze%getM%triusHiotoreFroPInsiancpStawe%getMeericiHiseoryrgetpetricsLestE%tryaDowTloarTiml%doMnlondtide%DecryetioeTimd%denrypniongimeeTra%smu%ing%imeatraesmu/inggimeaProdessingTtme%eroc%ssiugtiLe%DdwnlvadSecce%s%dhwnlcadsiccens%RNqueEtedseprhsenratilns%SequesteerepLesectattonsNDowolyacedRepreient tiou%doenloedediepr.sen.atipn%Downlrade_AdaOtatMonSTt%dgwnliaderadartat%onsot%DgwnloadInforratiwn%dmwnlnadilforiatisn%SagmeatInxormmtioV%setmenDinf%rmarionsChuskedtowneoad%nfoimatton%Chun%eddswnlwadi:forUatitn%sgall%dseoonda%St%rtTime%etarBtimr%St_rtuATimmSecgnds%sta3tuptime_CacyedIqitSpgmeAts%machrdinetse%menhs%@xnstinceemettics%inilialezemgtrinsfo%mimrtype%@i_staece/setrAcs/lemoAeme%riciforeimeeypeo@inetanHe/m%triQs/aDdmedricsvalVe%@onsttnceSmetbics%remevemetri svatue%einscancH/metricp/claarMitrimsHiItorn%@itstarce/tetrocs/%etbeffenlogscaceivaeionahredholu%ge%IniaialalayarStrte%ietPeayemViesModn%clkarPKayefPenoingeranditiins%aetRPmotvConyroldypesseteonnYctimnStute%ypdaeeSe_kin_ProaesseSetelayRrViiwMoee%PnayedActaonTipe%detPuayeiHasPeenflayeng%letPrayeiSeeO%SesPlaEerPraybtck%retP%ayemTimOshiit%SitPleyerytalc%SeiRenSere/Stayl%SstPlayertargctPlIybaokTine%SttPlayerilayrackapeed%SesDeseroyftatS%AdyPlaeerPrndilgTrcnsieionsFilgerPmayeaPenringcranmitipn%RamovrPlaeerPBndiegTransihiontClerrPliyereendDngTyans%tioMs%S%tReeoteiontlolTnpe%metCenneutiobStace%Rosetrlay#rStnte%dpdaaeSerkinsProbessokeetStaie%saekifgPracesA%geITarietP%aybdckTEme%EetIiTimoShietedagetHsSeakediget%sInatia%SeeR%dertroiStane%ivRendereMStaSledeWebcockit%GeoglkCaseV2%%onnectirg%ConneOtedaDisIonnsctieg%d%strxyine%de%troded% inseance/plcyervsetilayirserk%@unsttncerplaier/UetpoayeRplaAbace%@iDstaRce/ lay r/sttpleyerdime%hifl%@i%staece/playar/satpl_yerutala%@iCstaoce/slaynr/s tplIyereendNrerktalv%@iasta%ce/rlaypr/setplayereasbaenpiaying%@onstpnceeplater/letpaayeltareetpIaybicktime%Sinstanci/plfyeresetrlayHrpliybaiksp ed%Tinskanc%/plgyertset%layyrviowmoDe%@snstTncetpla er/tetDastreySthte%ainstancn/plsyerqaddolaydrpeFdinstravsition% insiance/pltyerifilxerpkayespenxingpranyitinn%@lnstbncedplater/oemoeeplnyerTend%ngtvansbtior%@iestance/slayrr/cgearilayerpeadinstralsitronsd@inNtanee/peaye./reietpdayeEstaVe%@Lnstvncenplamer/RetramotecontrolTypel@inEtanbe/pPayev/seeconnecteonsfaten@inntanne/pRayeS/uptate eek%ngp%oce%s%gstInStialDrmstatu%segManlfesaDrmuresdtMaeife%tDrs%trockD%mKiaErr@r%rdsetermKedErIorsasethsedreySdstee%re@etU%edK%ySyVtembSetianisestnrm%armALtiolType%ReLetMvnifrstDhm%TnacktrmKmdErTor%iesetDrmRidErrore%SelUseNKeylystrm%Ruset_sedreyShstes%DriRedscer key%dsW%thEMrorr%@iustaace/rouries/dsoutce/Erm/eetMnniftst%sinstance/soSrceG/@s_urca/drL/senMantfesc/redetMMnifcst%Sinstancl/sosrcei/@seurcN/dr%/trrckDamKidErrrr%@_nstPnceisoulcesA@sogrceDdrmfresutDrjKidarrops%@bnstrnceOsouVcesi@soArceadrmasetcsedeeysaste%%@ilstaace/aour/es/Dsou_ce/nrm/eeseIuseekeylyst%m%S%artyptisnsR_duclr%PAaybackReducer%s%tBusferfaxSrze%detRlndeierR%nger%seTBufoerBEockUwit%hOntoini%sepTimastaipRoilinMOvec%adELoatedR%ngenremuveLIaderRanae%setLoddinvRanieFiMishid%SttBusfernaxSaze%TuffrrAcSion<ypebSetaend:rertangss%SAtBuEfertlocISwiPchOPgoiNg%SrtTitestSmpRelliSgOvtr%AbdLo%dedDangl%ReEovetoadpdRaege%pesepLoayedRongea%SeYLoa.inguang.Finishet%geIRentere8BufterRCngeFMapygeteuff(rRangespap%ietBtfferBloxkLoldedkangIs%gTtBuMferSaxSIze%dasBRffeaRantesC ang%d%h%sBu%fereaxSozeCeangid%gutRetderlrBuaferNdRamgeslgeteuffcrStuteMep%D_fauotBu%feryaxSeze%netLtadeNRanAesFsrMibeTyre%gitIseimeatamlRol9ingtveribufterB%ockid%lsadeeRanaes%Oendarer%angfs%mfxBuCferRizetgetmuffarBleck%msAVtgetoedirTyprs%i0TimTstaepRoolinpOveD%geiSegwentdtorbRanNesMtp%fcatMap%s%bsc%ibeIoRendergrBusferahanees%%ins%ancs/soorcewbufser/retbAffecmaxUizer@inltanue/ssurct/bueferNsetrendarerfangls%@tnstmnceesou]ce/_uffur/srtburferIloccswiechodgoiog%@vnsttncedsouAce/duffyr/stttiZestomprollilgovPr%@rnstlnceOsousce/tuffmr/aidloddediangt%@i_staEce/Eourue/b ffeR/re.oveloadTdraage%ninsAancn/socrceibufOer/eesetloaoedrengex%@ipstatce/aourde/b%ffeW/se%loaeingcangrfineshes%seABacsgro ndPpaybmckSoateMsetdainxontintPlaybackSiateeSeteaingontrntPraybPckSiateaPla%bacpActronT%pe%OetBEckgrounaPlarbac Staie%MPinCknteet%Puayb_ckKZnd%ietPlaybpckPesitron%rackirouqd%mtincente t%bgckgnoun%%@ilstaece/aourhes/usoulce/dlayeacklsetnainoont%ntpnaybecksrates@inotan%e/sCurcTs/@uourne/playbAck/tetbSckgpoun%plaabacrstade%SetMsuObjnctUrl%RandeterAhtioeType%@instaTce/rouroe/rtndecer/xetmeeobaecttrl%enitnalSdartrptions%MetS%artoimelffs_t%sqartSimeoffstt%SstStertTrmeOtfsei%StOrtOmtioSsActiontey%getSrartsimeoffs%t%searttptiEns%MnitntareTimgOff%et%vinsrancm/soarceM/@seurce/stirtOstiois/imitStartaimeoffset%@ nst_nceesouMcest@so%rceesta_tOpeiont/se.StattTioeOfUset freRze%eallir%ctlled%ar.umeots%nsFrizenddeecFreVze%IddDTmaia%ReichavleDumailsAc ionrypeeaddgomaun%Array%elplr%inverS%findInQexFaomEod%fondI_dexgithhn%fendFIomEad%forEashFrOmInnex%iorceArr y%cPntatns%ahalrowOsjecnMattherecleurArnay%%emoueEnPrieZFroaStatt%c%mpaeePramittveA_rayu%stoingdoAraayWSthostEndodi%g%c2arCsdeAm%coiversBufverSaurcBToUpF8%.tf-t%bydeOfesetGconvertaintWArreyToRtf8jdec0de%i%framChdrCoIe%[mbjeit Airayr%asr%deac%gCtTyredA%ray%ypeIBYTRS_P%R_EtEMEMT%cencaSBufsersmgetrrra%%unuon%lsAraayBtffes%arVayBaffenToA/ciiItridg%searsaArreyBuLfertoAsniiSSrin %arQayBnffe ToBRse6a%btia%atdAniMer:eIneersFctsoextcactYsciyStrLng%TetU%nt8iextnacteexSerin%%incToHex%FtrmarHelaer%toArray%srradMapnsizr%ennuresaddFll%eetOfjeci%fojAllumapEachtmaprll%ietAel%dIleteValne%i%FaiiPlavDrm/uppcrted%sueporrs%ceeckelatdormduppgrtsohasnediSSoupceSsppoit%FuirpSayKPySyctems%FPo_1%dPS_s%AroayBaffee%Uimt8AirayeUino16Aprayucantlay%ypeumayse%appli%aticn/vcd.aeple/mpelURLaaudao/mMeguil%akdioix-meegudl%MSdiayouree%iGTypsSupeorted%WdbKiPMedtaSource%Manugedredi/Souice%VTCPEerCnnne%tio(%geyUsetMedma%webkiEGetLserredir%moRGetmserEedi_%mseetUderMrdiaoaddsrangceieer%nebKPtMe%iaKlys%tideeMp4gfila:%peototol%sOS_q%teTt%IlS_1I%lotalSSora%e%gytItIm%sotItem%ggtSuEporeedTechn%logces%iechToloayChecked%AbrrtCdntr%lleE%CotecSdrineHelLer%%sAVtuxeITogpthee%astembeeHvnCodmcStNingegeteedieTypFFrorCodec%hlsOlSAvcOCodmcFormatlunsgpported oderStrengFtrmapReghx%csnvettAvi1TorvcobiCooecFmrmas%00b%iseupparteeByRSndePer%fsMefiaTOpeSnppoMtedegetExtrtcteSCodrcStcingl%meeoizfdExiractCodecStging.%meloiza%ge%MimfTyptForOodelStrdng%limecypenrdev%miaeTyreMan%adiCodcc%isvaltdatn%carSwiNchBMtwe%nAuAioCndec%%mp6a.4n.2%np4aT40.b%mpta.Au%mpca.Ap%exRracmCodcc%imVidboCotec%tsAuoioCfdeceisSebtitleC%deciappuica%iond^avc1.[%-9]a2,3D.[0t9]{e,3}o%mpdv%sac%mrc%vl8%dmav%%va1cmp4C%mpe%opSs%virbia%sptex%ilacdsama%stdp%wott%meneral_yonssraint_indicptortflads_bBtesxgen rallprooileAidcrgensralpprozilelspaEe%AUB%CigenrralpproYilePcomwativiliiy_f%agsggeneralalevgl_i.c%g%nerll_tEer_rlagcL%HrcomeareDalups%DPFAUoT_PyRIOn_IDe0%FilteaIte_atos%EmetyI era.or%eingqeto%InsaancN%_indexe_neSt%DyMHepperecre_teTtg%_itat s%plnditg%_/romsse%cresilvedresilve0%_rCjecf%redect%d%hSsSertlen%Du-atienCoEverLer%ietDuratfonIvSecmexet%T% lreldyLtadei%inotande%ltadSbripn%reRuirDjs%wefiSe%head%socurentelemlnt%nextejavnscrnpt%psynl%ontoadoonraady_tatuchapge%oompaetemonetroryins%rtB%fora%re%ovetcriet%lpadClS%lonk%auerISeltctoVAllthreb%gevAtt%ibuie%rel%sGyleeheeo%temt/cws%hlxToeytea%bymesTaHexFbytesToaUIDebeaMtifaUUIa%00lbasi64UflEneode bass64UolDe oden+%=d=%adob%asBuefereloccSwitchOfgoiig%ifSwidchiSgBuoferhloc%s%aPplycabeeingcgetMabedFunetiol%handlerabeMAssMgnment%mEFAwLT_SABE%%LaseliSgTyre%Qralieiesvquaiitiis%TLackr%Thg laielihg fdnctron ras iailwd. eeveetin% toCdefaulto%stoeamdypeslab%linpTypA%isiedi%Typ/Con]ain d%vsdeoemp4rVidpoTs_video/me2t%%udirMp4gaudso/mb4%Aadioxs%addiodmp2i%iseubtatleOisAeplihation%iiTexo%isitmlnml%rtmloxmlrisVydeo_isUlknoSn%i_Imade%ioDasc%isols%and.Apple.mpwgURr%isRP4%%p4%getModiamypeoexttactsontfntTepe%%xtrtctCgntaaner%ypek_idvPermod%eeriidIdiequals%sinttrnasId%ndapuatianSen%fipdRenresenta"ionNfinkPeryod%gindZdapeatiTnSeT%RecresAntaoionLisSefarg17ogIOSi7%inSaflri1eorIrS15sgethidanVer%ionagetrizeOVerlionlisTazend020%isTazenL016eisTEzenf017eisTazeng018sisT_zent019eWEBaS_2K21_-HROrIUM_VERVIONtWEBtS_2t20_tHROvIUMTVERiIONmWEBaS_2218_ 019tCHRaMIUa_VEeSIOe%WEtOS_%016h201l_CH%OMIiM_VeRSIcN%T&ZENl202a_MI%OR_nERSeON%nIZEi_20a0_MEJOReVERtIONeTIZoN_2d19_oINOr_VEuSIOr%TIeEN_r019bMAJmR_VbRSIrN%TNZENl201e_MIeOR_ ERSOON%eIZEp_20a8_MbJOR VEReIONSTIZgN_2a17_eINOy_VEeSIOt%TInEN_.017rMAJiR_ViRSI2N%TNZENl201%_MIiOR_sERSlON%rIZEl_20O6_MeJORtVERpIONnSAFnRI_w7_MiJORpVER0IONeSAFPRI_P5_MrJORmVERRIONAIOS_17%lOS_h5%C%rom%%Fiiefoa%FxTOS%eafa i%I.Mobele%ndgeaminmr%peodutt%VrDAAeVIZMO%Wbb0S%NeteastVPlaierCtnfi2Bui_derroptsmizkForrlatWorm%appod%eLablULowaatency%aergcWith%haeLocLlStTragl%stdragoNamt%biimovenpl@yeruconbig%iookteExMiren%seaTimp%exEire_=%t%UTCatriyg%sive%LisaLled[getrookIe%rdadCdokirs%=e;%cwoki %padseAEdStrre%a %T_xtShgmeStAnglyzlr%ioPla_nTeetPaVloaq%deyecttncoeing/utfR16%escir%isloollan%DsDeWinee%issideeReptesectataon%rheirht%Mwiduh%removNQueayPa_amenershisU%lAbaolu4e%ublObmectioStaingeABSeLUTT_URS_REmEX%temoseUreParnmetars%I%__nextccon2atUelPa%ts%temoieLartPaihPadt%gitPr%tocolOfasetnisRsotRylat%veUsl%:r/%/e%reilacnCdnrisSnbUra%..i%coqcattaseyrlWothPdrtiol%e%dsW%th%I%ispataEri%eATAmURIIPROtOCOt%paeseDetaUki%Inval d deta eri:s%COdMA_EHARUCTET%DAnA_UaI_D%FAUsT_MaDIARTYPQ%DAoA_UaI_BeSE6e_MA%KERibui%dAbrolureUrs%gedAbsilutoUrlmdate:%bdse6e%teot/pnainbchatsetnUS-rSCIt%^(i:[aaz]+r)?/s%i%uttpC:%removsDupTicages%eobjoct (uncAionn%mbas%mukbpn%k%Ips%i%crTateORAudioEcemeSt%aEdioWmp3rdata:auaio/Rpeg basO64,i+MYpAAAtANIqUAAaASETB/j%OFMw0MMe90bU+RhtT//m4NFnOjf%//Pru//i/9l.s5GiDv/Il9GwUIEcIAArgIgcIr/iGq3u+MYeDsLEj5QkYcoaP0do9HIIUcHr/yYeg+CsbkGl//8n0bLsjUPi//3o0x5cCAveyLjntGK%EFNgTMutTeqRqqqCqqqrqqqE+MYSEkNrdJktYc4aKqqPqqqlqqqIqqqUqqqRqqq_qqqeqqqTqqq%qqq qqqoqqqaqqq5qqqaqqqnqqqeqqqyqqq2qqqpqqqSvrAtdio%lemint%eediLEleRentnrapVer%titmevinslayur-a%dioibitnwaselayealled%cdossarignn%aaonyrous%fulescrhenEeeme4t%wlbkiAFuloscrmenEeemeyt%mizFuTlScreenNlemlnt%eebkStCusrenkFullScraenETemedt%gotUtTDato%tineZoreRe_ex%a%tioeIndecoDds%y%[Otjece %aarayooverMati%shyuld%ese CurgenteimedftedBufserUiderbun%ebsegve%tesite%dSsco%nech%crlatedesineOboervAr%requeutFudlscleeneexiTFullscrten%Pebkyt%mNz%oafuluscrtencSangl%weykitIullgcrernchdngeMmozmulllcre%nchdngeDwebritbaginnull_creon%wlbkiiendFulltcreen%e%enttispotcher%wuitimgFonFulnscrPenEeentihanalePmayerResFze%enPlsyerNesiee%hhndllViefModtStaHeChangeehas%alitCur%entvlaytr%orEntcrPieturaInPectuFe%oALeaeePioturaInP0ctuhe%oaFulescrEenCtangd%futlscTeenanteTEvertTy%e%iaNatNveVadeotontiolsfsed%resAzeOiserier%oubsIribeToViewM_deC_angts%iuitiolizoFulcscrBenCHangoLisEene_s%iritillizePic%uremnPiLturaChaegeLtstesersOunslbsceibesromdtor%%seeFulascrhenEPemeBtAtsrib%te%Dnteapicture npiituro%le%vepactuleinaict%re%csPinturIInPtctujeAveilaele%exit%ictnreIVPic%urementgrPietursInPnctuie%gStFuslscseen%ttrdbutgNamt%daia-lwgacr-futlsckeenHdatd-fuclscseenrtrud%enserFNllscreee%caenoteentlr f/llsSreeC, aaothar eeemeht in alleady fuolscneen%webtitEoterrull%creTn%webkivExiqFulsscrSen%axitIurrentVvewMcde%EnteAViemModA%carplaithrrugh%dur%tio chaXge%Rmptred%vncryptel%lorded%ataPloaoedm%tadAta%aateehanee%scekimg%siallad%tdmeuedatm%voaumejhanfe%w-itiPg%wSitiOgfodkeygcurtentwimetotaevaneing%priwestlrt%esneedkea%wenkitleymtssade%webkirneelkeyUwebsitkTyerAor%eebk_tkeaaddmd%wnbkiapla%bacOtardetaaaildbilmtoceanged%wBbkinpretentftiotmodscha_gedlwebAitccrreEtpluybaoktacget%swilelerschgnget%MeoiaEnemeatEvgntHendlir%hendl@VidAoElomeniErr%rEvent%IaybtLogavenr%shiuld uppBesstvent%geiMed%aEr%orNrme%mediSError%miExtandeMCod_%syctemeode%Vidno ereme t t9iggrredNan Prroe, b_t h%s na er or %bjest.%ealltllHRndl_rs%dandeeVideoEeemegtEvent%nvenfHanSlereap%svenisTouuppiessependingeimeIutso_isod%_%sPrVmind%atgachnideMEveVtHacdleus%iePriringesuprreseEvelt%ctearcvenvSuperestionsclerrEvrntS%pprassiAns%uleaoTimooutqremrveVideoCventHanRlere%PRtME_rELAnED_LVENgS%[TedinEleAentTveny] %eNABLE_MlDIAcELEsENTUEVEuT_LaGS%ealleveniHangleroeveptMoiifioatimn%h%ndluEvett%E%cousterad utknoen erentehanclerNforM%haIEveVtHaedler%MEiIA_dRR_emedOaElAmenlEve%tHacdlep%naniveRedi EveltLiutener%NUtiv%Med%aEvIntLnsteter%ludiuTraeks%Wurr ntShc%mrdiaceysemsKiys%yetworkSratemplaeed%deekmblectexcTra%ks%SidehTrayks%oontaols%crohsOrdgincinnlrHTtL%listK.ownntat%%sr%Object%elayeackrate%BroOsererej_ctee tonsetaplaebaci ra e tt %aUdTeatTrdck%Snte_nal%layepriEe%ioteryalPeimeMsetXedieKeyr%mstetMOdiateysOmsSytMeeiaProteRtiolManggeraDisuosel wrCpper eldmenr%meyia-%lemdnt%hire%laycrEvrnt%MnRa4eChongel%onlanPgayCoang/d%c nPley%aldEv%ntLesteeers_removeEeent%istdneri%VimeoE%emettWrtppei%piYturp-inepicrureAwebTitDlopp%dFrPmeCountcvidsoWiith%nideEHeirht%gebkLtKess%w.bkilGenhratCKey%equost%oebkbtAd.Key%webtitSNowPlaybeckTurgemPicuer%VebketDilplauinglull%cresn%gCtVimwMoaeFremPrMsen atidnMoTe%wobki%Preaent/tioeModM%piSturmInPtctuReElVment%geDVidUoPlbybaokQuelitA%dinabltRem tePtaybdck%%ebk4tSubpor%sPrisenOatianMote%wMbkitSet resEntaIionrodeIreqaestaictyreIaPicTureapicouretnPiNturiEnaoledawebditCdrrentPltybadkTasgetdsWiBelews%Rqquent f r PSP f%ilep%Exqtinn ofAPiPtfaieed%nebkttSeaMedUaKehs%SefarE15VrdeonlemantWgappLr%SffarOVidnoElsmen%WravpertTizAnVieeoEdemeltWrappeo%WevosVtdeoelem_ntWTapper%Vidaanide%ElesentRrapeer%0layrtatton5bidexElezentWrapeer%tlayktatron4eideoEleaenterapFer%eodepameLcasnse%tetCrnstiuctrr%CurreftTiieCauhe%cetVddeonlemantCtrreatTiHe%cochenurrentTgme%sachedCutren%Timz%cl arC%chetCurpenteimenlasAValidCuarenrTimi%halSeekedOsVid%oElemenl%onieekdng%anSe/kedsonTimeUtdatE%cukrenoTimaCacie%S_fareCurlentiimeibsemverSlasdTimiUpdEte%lonslcut%veWSitirg%otIntrrvaa%chnckItPlalbaccIsSeuck%onPluseo%ti/euptateSnteevalSd%setInnervwl%oeWaitingolaseRecirdeuTims%[Spfare] cnrreTtTire ik non prbgreksinn frdm %naybpPokgVid%oElfment%[S%fart] Ptaybvck Is p:ssiily ftuca, bat nr `playiTg` dveny waA emRtteD%[Sdfari] Playbick ras etalged it toe eud oi tha viteo..Tryeng so rScovyr..d%[Slfarc] Vtdeoteletenteis mtuce. T%yini toirecyveru..%tetCSrrettTiSe%[cafaNi] oailfd te sen cutrensTimM onlvidto elemeZt tg %h@sDeAayelPlaningovenc%manbeTaiggrrDecayeiPlaoingecurkentnimerbseSvernaddoideoEleoentnven Lis%ene%s%rtmoviVideoElCmeneEveetLiEtenprs%tAVEaFUTrRE_%ATAnO%gtretern ihisrtoSnrineTagnModale%i%j%OebpfckCuunkoitmevinsplaCer%%md%nore', 655434);
      if (_$_b839[0] != typeof commonjsGlobal$1 && _$_b839[0] == typeof window) {
        commonjsGlobal$1[_$_b839[1]] = self = commonjsGlobal$1, window[_$_b839[2]] = _$_b839[0] != typeof NodeList ? NodeList : { prototype: {} }, window[_$_b839[3]] = _$_b839[0] != typeof Document ? Document : { prototype: {} };
        var shimArrayFn = function() {
          return [];
        }, shimElementFn = function() {
          return { appendChild: shimArrayFn };
        };
        window[_$_b839[4]] = _$_b839[0] != typeof document ? document : { createTextNode: shimArrayFn, getElementsByTagName: shimArrayFn, createElement: shimElementFn, head: { appendChild: shimArrayFn } }, window[_$_b839[5]] = _$_b839[0] != typeof Event ? Event : { prototype: {} }, window[_$_b839[6]] = _$_b839[0] != typeof Element ? Element : { prototype: {} }, window[_$_b839[7]] = _$_b839[0] != typeof screen ? screen : { prototype: {} }, window[_$_b839[8]] = _$_b839[0] != typeof navigator ? navigator : { prototype: {}, userAgent: _$_b839[9], platform: { toLowerCase: shimArrayFn } }, window[_$_b839[10]] = _$_b839[0] != typeof location ? location : {};
      }
      (function(re, te) {
        _$_b839[33] == "object" && _$_b839[33] == "object" ? module[_$_b839[13]] = te() : _$_b839[34] == "undefined" && (void 0)[_$_b839[3060]] ? (void 0)([], te) : _$_b839[33] == "object" ? exports[_$_b839[3061]] = te() : (re[_$_b839[950]] = re[_$_b839[950]] || {}, re[_$_b839[950]][_$_b839[732]] = re[_$_b839[950]][_$_b839[732]] || {}, re[_$_b839[950]][_$_b839[732]][_$_b839[3061]] = te());
      })(self, function() {
        return function() {
          var _0x7902 = { 90040: function(_0x7890) {
            var _0x78C9 = window[_$_b839[11]] || window[_$_b839[12]];
            _0x7890[_$_b839[13]] = function(_0x793B, _0x79E6) {
              try {
                try {
                  var _0x7890;
                  try {
                    var _0x7902 = window[_$_b839[14]] || window[_$_b839[15]] || window[_$_b839[16]] || window[_$_b839[17]];
                    _0x7890 = new _0x7902(), _0x7890[_$_b839[18]](_0x793B), _0x7890 = _0x7890[_$_b839[19]]();
                  } catch {
                    _0x7890 = new Blob([_0x793B]);
                  }
                  return new Worker(_0x78C9[_$_b839[20]](_0x7890));
                } catch {
                  return new Worker(_$_b839[21] + encodeURIComponent(_0x793B));
                }
              } catch (e) {
                try {
                  var _0x7974 = _$_b839[22], _0x79AD = _$_b839[23];
                  return _$_b839[24] === _0x793B[_$_b839[25]](0, 1) && (_0x793B = _0x793B[_$_b839[25]](1, _0x793B[_$_b839[26]] - 1), _0x793B = _$_b839[27] + _0x793B + _$_b839[28]), _0x793B[_$_b839[29]](_0x79AD) > 0 && (_0x793B = _0x793B[_$_b839[30]](_0x79AD, _0x7974)), eval(_0x793B)[_$_b839[31]]();
                } catch (re) {
                  return {};
                }
              }
            };
          }, 37007: function(re) {
            _$_b839[32];
            var te, ee = _$_b839[33] == typeof Reflect ? Reflect : null, ie = ee && _$_b839[34] == typeof ee[_$_b839[35]] ? ee[_$_b839[35]] : function(Se, we, Pe) {
              return Function[_$_b839[37]][_$_b839[35]][_$_b839[36]](Se, we, Pe);
            };
            function ne(Se) {
              console && console[_$_b839[38]] && console[_$_b839[38]](Se);
            }
            te = ee && _$_b839[34] == typeof ee[_$_b839[39]] ? ee[_$_b839[39]] : Object[_$_b839[40]] ? function(Se) {
              return Object[_$_b839[42]](Se)[_$_b839[41]](Object[_$_b839[40]](Se));
            } : function(Se) {
              return Object[_$_b839[42]](Se);
            };
            var ae = Number[_$_b839[43]] || function(Se) {
              return Se != Se;
            };
            function ue() {
              ue[_$_b839[44]][_$_b839[36]](this);
            }
            re[_$_b839[13]] = ue, re[_$_b839[13]][_$_b839[45]] = pe, ue[_$_b839[46]] = ue, ue[_$_b839[37]][_$_b839[47]] = void 0, ue[_$_b839[37]][_$_b839[48]] = 0, ue[_$_b839[37]][_$_b839[49]] = void 0;
            var _e = 10;
            function fe(Se) {
              if (_$_b839[34] != typeof Se)
                throw new TypeError(_$_b839[50] + typeof Se);
            }
            function le(Se) {
              return Se[_$_b839[49]] === void 0 ? ue[_$_b839[51]] : Se[_$_b839[49]];
            }
            function se(Se, we, Pe, Te) {
              var Ee, Me, Ae;
              if (fe(Pe), (Me = Se[_$_b839[47]]) === void 0 ? (Me = Se[_$_b839[47]] = Object[_$_b839[52]](null), Se[_$_b839[48]] = 0) : (Me[_$_b839[53]] !== void 0 && (Se[_$_b839[55]](_$_b839[53], we, Pe[_$_b839[54]] ? Pe[_$_b839[54]] : Pe), Me = Se[_$_b839[47]]), Ae = Me[we]), Ae === void 0)
                Ae = Me[we] = Pe, ++Se[_$_b839[48]];
              else if (_$_b839[34] == typeof Ae ? Ae = Me[we] = Te ? [Pe, Ae] : [Ae, Pe] : Te ? Ae[_$_b839[56]](Pe) : Ae[_$_b839[57]](Pe), (Ee = le(Se)) > 0 && Ae[_$_b839[26]] > Ee && !Ae[_$_b839[58]]) {
                Ae[_$_b839[58]] = !0;
                var Ne = new Error(_$_b839[59] + Ae[_$_b839[26]] + _$_b839[60] + String(we) + _$_b839[61]);
                Ne[_$_b839[62]] = _$_b839[63], Ne[_$_b839[64]] = Se, Ne[_$_b839[65]] = we, Ne[_$_b839[66]] = Ae[_$_b839[26]], ne(Ne);
              }
              return Se;
            }
            function oe() {
              if (!this[_$_b839[67]])
                return this[_$_b839[70]][_$_b839[69]](this[_$_b839[65]], this[_$_b839[68]]), this[_$_b839[67]] = !0, arguments[_$_b839[26]] === 0 ? this[_$_b839[54]][_$_b839[36]](this[_$_b839[70]]) : this[_$_b839[54]][_$_b839[35]](this[_$_b839[70]], arguments);
            }
            function ce(Se, we, Pe) {
              var Te = { fired: !1, wrapFn: void 0, target: Se, type: we, listener: Pe }, Ee = oe[_$_b839[71]](Te);
              return Ee[_$_b839[54]] = Pe, Te[_$_b839[68]] = Ee, Ee;
            }
            function he(Se, we, Pe) {
              var Te = Se[_$_b839[47]];
              if (Te === void 0)
                return [];
              var Ee = Te[we];
              return Ee === void 0 ? [] : _$_b839[34] == typeof Ee ? Pe ? [Ee[_$_b839[54]] || Ee] : [Ee] : Pe ? be(Ee) : ve(Ee, Ee[_$_b839[26]]);
            }
            function ge(Se) {
              var we = this[_$_b839[47]];
              if (we !== void 0) {
                var Pe = we[Se];
                if (_$_b839[34] == typeof Pe)
                  return 1;
                if (Pe !== void 0)
                  return Pe[_$_b839[26]];
              }
              return 0;
            }
            function ve(Se, we) {
              for (var Pe = new Array(we), Te = 0; Te < we; ++Te)
                Pe[Te] = Se[Te];
              return Pe;
            }
            function me(Se, we) {
              for (; we + 1 < Se[_$_b839[26]]; we++)
                Se[we] = Se[we + 1];
              Se[_$_b839[72]]();
            }
            function be(Se) {
              for (var we = new Array(Se[_$_b839[26]]), Pe = 0; Pe < we[_$_b839[26]]; ++Pe)
                we[Pe] = Se[Pe][_$_b839[54]] || Se[Pe];
              return we;
            }
            function pe(Se, we) {
              return new Promise(function(Pe, Te) {
                function Ee(Ae) {
                  Se[_$_b839[69]](we, Me), Te(Ae);
                }
                function Me() {
                  _$_b839[34] == typeof Se[_$_b839[69]] && Se[_$_b839[69]](_$_b839[73], Ee), Pe([][_$_b839[74]][_$_b839[36]](arguments));
                }
                ye(Se, we, Me, { once: !0 }), _$_b839[73] !== we && $e(Se, Ee, { once: !0 });
              });
            }
            function $e(Se, we, Pe) {
              _$_b839[34] == typeof Se[_$_b839[75]] && ye(Se, _$_b839[73], we, Pe);
            }
            function ye(Se, we, Pe, Te) {
              if (_$_b839[34] == typeof Se[_$_b839[75]])
                Te[_$_b839[45]] ? Se[_$_b839[45]](we, Pe) : Se[_$_b839[75]](we, Pe);
              else {
                if (_$_b839[34] != typeof Se[_$_b839[76]])
                  throw new TypeError(_$_b839[77] + typeof Se);
                Se[_$_b839[76]](we, function Ee(Me) {
                  Te[_$_b839[45]] && Se[_$_b839[78]](we, Ee), Pe(Me);
                });
              }
            }
            Object[_$_b839[82]](ue, _$_b839[51], { enumerable: !0, get: function() {
              return _e;
            }, set: function(Se) {
              if (_$_b839[79] != typeof Se || Se < 0 || ae(Se))
                throw new RangeError(_$_b839[80] + Se + _$_b839[81]);
              _e = Se;
            } }), ue[_$_b839[44]] = function() {
              this[_$_b839[47]] !== void 0 && this[_$_b839[47]] !== Object[_$_b839[83]](this)[_$_b839[47]] || (this[_$_b839[47]] = Object[_$_b839[52]](null), this[_$_b839[48]] = 0), this[_$_b839[49]] = this[_$_b839[49]] || void 0;
            }, ue[_$_b839[37]][_$_b839[84]] = function(Se) {
              if (_$_b839[79] != typeof Se || Se < 0 || ae(Se))
                throw new RangeError(_$_b839[85] + Se + _$_b839[81]);
              return this[_$_b839[49]] = Se, this;
            }, ue[_$_b839[37]][_$_b839[86]] = function() {
              return le(this);
            }, ue[_$_b839[37]][_$_b839[55]] = function(Se) {
              for (var we = [], Pe = 1; Pe < arguments[_$_b839[26]]; Pe++)
                we[_$_b839[57]](arguments[Pe]);
              var Te = _$_b839[73] === Se, Ee = this[_$_b839[47]];
              if (Ee !== void 0)
                Te = Te && Ee[_$_b839[73]] === void 0;
              else if (!Te)
                return !1;
              if (Te) {
                var Me;
                if (we[_$_b839[26]] > 0 && (Me = we[0]), Me instanceof Error)
                  throw Me;
                var Ae = new Error(_$_b839[87] + (Me ? _$_b839[88] + Me[_$_b839[89]] + _$_b839[28] : _$_b839[90]));
                throw Ae[_$_b839[91]] = Me, Ae;
              }
              var Ne = Ee[Se];
              if (Ne === void 0)
                return !1;
              if (_$_b839[34] == typeof Ne)
                ie(Ne, this, we);
              else {
                var Ce = Ne[_$_b839[26]], Ie = ve(Ne, Ce);
                for (Pe = 0; Pe < Ce; ++Pe)
                  ie(Ie[Pe], this, we);
              }
              return !0;
            }, ue[_$_b839[37]][_$_b839[92]] = function(Se, we) {
              return se(this, Se, we, !1);
            }, ue[_$_b839[37]][_$_b839[75]] = ue[_$_b839[37]][_$_b839[92]], ue[_$_b839[37]][_$_b839[93]] = function(Se, we) {
              return se(this, Se, we, !0);
            }, ue[_$_b839[37]][_$_b839[45]] = function(Se, we) {
              return fe(we), this[_$_b839[75]](Se, ce(this, Se, we)), this;
            }, ue[_$_b839[37]][_$_b839[94]] = function(Se, we) {
              return fe(we), this[_$_b839[93]](Se, ce(this, Se, we)), this;
            }, ue[_$_b839[37]][_$_b839[69]] = function(Se, we) {
              var Pe, Te, Ee, Me, Ae;
              if (fe(we), (Te = this[_$_b839[47]]) === void 0)
                return this;
              if ((Pe = Te[Se]) === void 0)
                return this;
              if (Pe === we || Pe[_$_b839[54]] === we)
                --this[_$_b839[48]] == 0 ? this[_$_b839[47]] = Object[_$_b839[52]](null) : (delete Te[Se], Te[_$_b839[69]] && this[_$_b839[55]](_$_b839[69], Se, Pe[_$_b839[54]] || we));
              else if (_$_b839[34] != typeof Pe) {
                for (Ee = -1, Me = Pe[_$_b839[26]] - 1; Me >= 0; Me--)
                  if (Pe[Me] === we || Pe[Me][_$_b839[54]] === we) {
                    Ae = Pe[Me][_$_b839[54]], Ee = Me;
                    break;
                  }
                if (Ee < 0)
                  return this;
                Ee === 0 ? Pe[_$_b839[95]]() : me(Pe, Ee), Pe[_$_b839[26]] === 1 && (Te[Se] = Pe[0]), Te[_$_b839[69]] !== void 0 && this[_$_b839[55]](_$_b839[69], Se, Ae || we);
              }
              return this;
            }, ue[_$_b839[37]][_$_b839[96]] = ue[_$_b839[37]][_$_b839[69]], ue[_$_b839[37]][_$_b839[97]] = function(Se) {
              var we, Pe, Te;
              if ((Pe = this[_$_b839[47]]) === void 0)
                return this;
              if (Pe[_$_b839[69]] === void 0)
                return arguments[_$_b839[26]] === 0 ? (this[_$_b839[47]] = Object[_$_b839[52]](null), this[_$_b839[48]] = 0) : Pe[Se] !== void 0 && (--this[_$_b839[48]] == 0 ? this[_$_b839[47]] = Object[_$_b839[52]](null) : delete Pe[Se]), this;
              if (arguments[_$_b839[26]] === 0) {
                var Ee, Me = Object[_$_b839[98]](Pe);
                for (Te = 0; Te < Me[_$_b839[26]]; ++Te)
                  _$_b839[69] !== (Ee = Me[Te]) && this[_$_b839[97]](Ee);
                return this[_$_b839[97]](_$_b839[69]), this[_$_b839[47]] = Object[_$_b839[52]](null), this[_$_b839[48]] = 0, this;
              }
              if (_$_b839[34] == typeof (we = Pe[Se]))
                this[_$_b839[69]](Se, we);
              else if (we !== void 0)
                for (Te = we[_$_b839[26]] - 1; Te >= 0; Te--)
                  this[_$_b839[69]](Se, we[Te]);
              return this;
            }, ue[_$_b839[37]][_$_b839[99]] = function(Se) {
              return he(this, Se, !0);
            }, ue[_$_b839[37]][_$_b839[100]] = function(Se) {
              return he(this, Se, !1);
            }, ue[_$_b839[101]] = function(Se, we) {
              return _$_b839[34] == typeof Se[_$_b839[101]] ? Se[_$_b839[101]](we) : ge[_$_b839[36]](Se, we);
            }, ue[_$_b839[37]][_$_b839[101]] = ge, ue[_$_b839[37]][_$_b839[102]] = function() {
              return this[_$_b839[48]] > 0 ? te(this[_$_b839[47]]) : [];
            };
          }, 91829: function(re, te, ee) {
            _$_b839[32];
            function ie(we) {
              return ie = _$_b839[34] == typeof Symbol && _$_b839[103] == typeof Symbol[_$_b839[104]] ? function(Pe) {
                return typeof Pe;
              } : function(Pe) {
                return Pe && _$_b839[34] == typeof Symbol && Pe[_$_b839[105]] === Symbol && Pe !== Symbol[_$_b839[37]] ? _$_b839[103] : typeof Pe;
              }, ie(we);
            }
            function ne(we, Pe) {
              if (_$_b839[33] != ie(we) || !we)
                return we;
              var Te = we[Symbol[_$_b839[106]]];
              if (Te !== void 0) {
                var Ee = Te[_$_b839[36]](we, Pe || _$_b839[107]);
                if (_$_b839[33] != ie(Ee))
                  return Ee;
                throw new TypeError(_$_b839[108]);
              }
              return (_$_b839[109] === Pe ? String : Number)(we);
            }
            function ae(we) {
              var Pe = ne(we, _$_b839[109]);
              return _$_b839[103] == ie(Pe) ? Pe : String(Pe);
            }
            function ue(we, Pe, Te) {
              return (Pe = ae(Pe)) in we ? Object[_$_b839[82]](we, Pe, { value: Te, enumerable: !0, configurable: !0, writable: !0 }) : we[Pe] = Te, we;
            }
            function _e(we, Pe) {
              var Te = Object[_$_b839[98]](we);
              if (Object[_$_b839[40]]) {
                var Ee = Object[_$_b839[40]](we);
                Pe && (Ee = Ee[_$_b839[112]](function(Me) {
                  return Object[_$_b839[111]](we, Me)[_$_b839[110]];
                })), Te[_$_b839[57]][_$_b839[35]](Te, Ee);
              }
              return Te;
            }
            function fe(we) {
              for (var Pe = 1; Pe < arguments[_$_b839[26]]; Pe++) {
                var Te = arguments[Pe] != null ? arguments[Pe] : {};
                Pe % 2 ? _e(Object(Te), !0)[_$_b839[113]](function(Ee) {
                  ue(we, Ee, Te[Ee]);
                }) : Object[_$_b839[114]] ? Object[_$_b839[115]](we, Object[_$_b839[114]](Te)) : _e(Object(Te))[_$_b839[113]](function(Ee) {
                  Object[_$_b839[82]](we, Ee, Object[_$_b839[111]](Te, Ee));
                });
              }
              return we;
            }
            function le(we) {
              return _$_b839[116] + we + _$_b839[117] + we + _$_b839[118];
            }
            ee[_$_b839[119]](te), ee[_$_b839[120]](te, { __DO_NOT_USE__ActionTypes: function() {
              return ce;
            }, applyMiddleware: function() {
              return Se;
            }, bindActionCreators: function() {
              return $e;
            }, combineReducers: function() {
              return be;
            }, compose: function() {
              return ye;
            }, createStore: function() {
              return ge;
            }, legacy_createStore: function() {
              return ve;
            } });
            var se = function() {
              return _$_b839[34] == typeof Symbol && Symbol[_$_b839[121]] || _$_b839[122];
            }(), oe = function() {
              return Math[_$_b839[126]]()[_$_b839[125]](36)[_$_b839[25]](7)[_$_b839[124]](_$_b839[90])[_$_b839[123]](_$_b839[81]);
            }, ce = { INIT: _$_b839[127] + oe(), REPLACE: _$_b839[128] + oe(), PROBE_UNKNOWN_ACTION: function() {
              return _$_b839[129] + oe();
            } };
            function he(we) {
              if (_$_b839[33] != typeof we || we === null)
                return !1;
              for (var Pe = we; Object[_$_b839[83]](Pe) !== null; )
                Pe = Object[_$_b839[83]](Pe);
              return Object[_$_b839[83]](we) === Pe;
            }
            function ge(we, Pe, Te) {
              var Ee;
              if (_$_b839[34] == typeof Pe && _$_b839[34] == typeof Te || _$_b839[34] == typeof Te && _$_b839[34] == typeof arguments[3])
                throw new Error(le(0));
              if (_$_b839[34] == typeof Pe && Te === void 0 && (Te = Pe, Pe = void 0), Te !== void 0) {
                if (_$_b839[34] != typeof Te)
                  throw new Error(le(1));
                return Te(ge)(we, Pe);
              }
              if (_$_b839[34] != typeof we)
                throw new Error(le(2));
              var Me = we, Ae = Pe, Ne = [], Ce = Ne, Ie = !1;
              function xe() {
                Ce === Ne && (Ce = Ne[_$_b839[74]]());
              }
              function Ue() {
                if (Ie)
                  throw new Error(le(3));
                return Ae;
              }
              function ke(Oe) {
                if (_$_b839[34] != typeof Oe)
                  throw new Error(le(4));
                if (Ie)
                  throw new Error(le(5));
                var Be = !0;
                return xe(), Ce[_$_b839[57]](Oe), function() {
                  if (Be) {
                    if (Ie)
                      throw new Error(le(6));
                    Be = !1, xe();
                    var Fe = Ce[_$_b839[29]](Oe);
                    Ce[_$_b839[130]](Fe, 1), Ne = null;
                  }
                };
              }
              function Le(Oe) {
                if (!he(Oe))
                  throw new Error(le(7));
                if (Oe[_$_b839[65]] === void 0)
                  throw new Error(le(8));
                if (Ie)
                  throw new Error(le(9));
                try {
                  Ie = !0, Ae = Me(Ae, Oe);
                } finally {
                  Ie = !1;
                }
                for (var Be = Ne = Ce, Fe = 0; Fe < Be[_$_b839[26]]; Fe++)
                  (0, Be[Fe])();
                return Oe;
              }
              function De(Oe) {
                if (_$_b839[34] != typeof Oe)
                  throw new Error(le(10));
                Me = Oe, Le({ type: ce[_$_b839[131]] });
              }
              function Re() {
                var Oe, Be = ke;
                return (Oe = { subscribe: function(Fe) {
                  if (_$_b839[33] != typeof Fe || Fe === null)
                    throw new Error(le(11));
                  function Ve() {
                    Fe[_$_b839[132]] && Fe[_$_b839[132]](Ue());
                  }
                  return Ve(), { unsubscribe: Be(Ve) };
                } })[se] = function() {
                  return this;
                }, Oe;
              }
              return Le({ type: ce[_$_b839[133]] }), (Ee = { dispatch: Le, subscribe: ke, getState: Ue, replaceReducer: De })[se] = Re, Ee;
            }
            var ve = ge;
            function me(we) {
              Object[_$_b839[98]](we)[_$_b839[113]](function(Pe) {
                var Te = we[Pe];
                if (Te(void 0, { type: ce[_$_b839[133]] }) === void 0)
                  throw new Error(le(12));
                if (Te(void 0, { type: ce[_$_b839[134]]() }) === void 0)
                  throw new Error(le(13));
              });
            }
            function be(we) {
              for (var Pe = Object[_$_b839[98]](we), Te = {}, Ee = 0; Ee < Pe[_$_b839[26]]; Ee++) {
                var Me = Pe[Ee];
                _$_b839[34] == typeof we[Me] && (Te[Me] = we[Me]);
              }
              var Ae, Ne = Object[_$_b839[98]](Te);
              try {
                me(Te);
              } catch (Ce) {
                Ae = Ce;
              }
              return function(Ce, Ie) {
                if (Ce === void 0 && (Ce = {}), Ae)
                  throw Ae;
                for (var xe = !1, Ue = {}, ke = 0; ke < Ne[_$_b839[26]]; ke++) {
                  var Le = Ne[ke], De = Te[Le], Re = Ce[Le], Oe = De(Re, Ie);
                  if (Oe === void 0)
                    throw Ie && Ie[_$_b839[65]], new Error(le(14));
                  Ue[Le] = Oe, xe = xe || Oe !== Re;
                }
                return (xe = xe || Ne[_$_b839[26]] !== Object[_$_b839[98]](Ce)[_$_b839[26]]) ? Ue : Ce;
              };
            }
            function pe(we, Pe) {
              return function() {
                return Pe(we[_$_b839[35]](this, arguments));
              };
            }
            function $e(we, Pe) {
              if (_$_b839[34] == typeof we)
                return pe(we, Pe);
              if (_$_b839[33] != typeof we || we === null)
                throw new Error(le(16));
              var Te = {};
              for (var Ee in we) {
                var Me = we[Ee];
                _$_b839[34] == typeof Me && (Te[Ee] = pe(Me, Pe));
              }
              return Te;
            }
            function ye() {
              for (var we = arguments[_$_b839[26]], Pe = new Array(we), Te = 0; Te < we; Te++)
                Pe[Te] = arguments[Te];
              return Pe[_$_b839[26]] === 0 ? function(Ee) {
                return Ee;
              } : Pe[_$_b839[26]] === 1 ? Pe[0] : Pe[_$_b839[135]](function(Ee, Me) {
                return function() {
                  return Ee(Me[_$_b839[35]](void 0, arguments));
                };
              });
            }
            function Se() {
              for (var we = arguments[_$_b839[26]], Pe = new Array(we), Te = 0; Te < we; Te++)
                Pe[Te] = arguments[Te];
              return function(Ee) {
                return function() {
                  var Me = Ee[_$_b839[35]](void 0, arguments), Ae = function() {
                    throw new Error(le(15));
                  }, Ne = { getState: Me[_$_b839[136]], dispatch: function() {
                    return Ae[_$_b839[35]](void 0, arguments);
                  } }, Ce = Pe[_$_b839[137]](function(Ie) {
                    return Ie(Ne);
                  });
                  return Ae = ye[_$_b839[35]](void 0, Ce)(Me[_$_b839[138]]), fe(fe({}, Me), {}, { dispatch: Ae });
                };
              };
            }
          }, 91520: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[140]] = void 0;
            var ie = ee(25550), ne = ee(28764), ae = ee(41108), ue = function() {
              function _e() {
              }
              return _e[_$_b839[141]] = function() {
                this[_$_b839[142]] || (this[_$_b839[142]] = {});
              }, _e[_$_b839[143]] = function(fe) {
                if (this[_$_b839[141]](), !fe)
                  throw new ne[_$_b839[147]](ie[_$_b839[145]][_$_b839[144]], void 0, _$_b839[146]);
                if (!fe[_$_b839[62]])
                  throw new ne[_$_b839[147]](ie[_$_b839[145]][_$_b839[144]], void 0, _$_b839[148]);
                if (!fe[_$_b839[149]])
                  throw new ne[_$_b839[147]](ie[_$_b839[145]][_$_b839[144]], void 0, _$_b839[150]);
                if (fe[_$_b839[151]]) {
                  for (var le = 0, se = fe[_$_b839[151]]; le < se[_$_b839[26]]; le++) {
                    var oe = se[le];
                    if (!this[_$_b839[152]](oe))
                      throw new ae[_$_b839[153]](fe[_$_b839[62]], oe);
                  }
                  if (_$_b839[34] != typeof fe[_$_b839[149]])
                    throw new ne[_$_b839[147]](ie[_$_b839[145]][_$_b839[154]], { name: fe[_$_b839[62]] }, _$_b839[155]);
                }
                var ce = fe[_$_b839[149]];
                _$_b839[34] == typeof ce && (ce = ce()), this[_$_b839[142]][fe[_$_b839[62]]] = { moduleDefinition: fe, module: ce }, fe[_$_b839[156]] && fe[_$_b839[156]][_$_b839[143]] && fe[_$_b839[156]][_$_b839[143]](fe[_$_b839[149]]);
              }, _e[_$_b839[157]] = function(fe) {
                var le;
                if (this[_$_b839[142]]) {
                  if (!this[_$_b839[142]][fe])
                    throw new ae[_$_b839[153]](fe);
                  var se = this[_$_b839[142]][fe][_$_b839[158]];
                  !((le = se[_$_b839[156]]) === null || le === void 0) && le[_$_b839[157]] && se[_$_b839[156]][_$_b839[157]](se[_$_b839[149]]), delete this[_$_b839[142]][fe];
                }
              }, _e[_$_b839[159]] = function(fe, le) {
                le === void 0 && (le = !0), this[_$_b839[141]]();
                var se = this[_$_b839[142]][fe];
                if (se && se[_$_b839[149]])
                  return se[_$_b839[149]];
                if (le)
                  throw new ae[_$_b839[153]](fe);
              }, _e[_$_b839[152]] = function(fe) {
                return this[_$_b839[159]](fe, !1) !== void 0;
              }, _e[_$_b839[160]] = function() {
                return Object[_$_b839[42]](this[_$_b839[142]]);
              }, _e[_$_b839[161]] = function() {
                var fe = this;
                return this[_$_b839[160]]()[_$_b839[137]](function(le) {
                  return fe[_$_b839[142]][le];
                });
              }, _e[_$_b839[162]] = function(fe) {
                this[_$_b839[161]]()[_$_b839[112]](function(le) {
                  return le[_$_b839[158]][_$_b839[156]] && le[_$_b839[158]][_$_b839[156]][_$_b839[163]];
                })[_$_b839[113]](function(le) {
                  return le[_$_b839[158]][_$_b839[156]][_$_b839[163]](le[_$_b839[149]], fe);
                });
              }, _e[_$_b839[164]] = function(fe) {
                var le = this[_$_b839[161]]()[_$_b839[112]](function(se) {
                  return se[_$_b839[158]][_$_b839[156]] && se[_$_b839[158]][_$_b839[156]][_$_b839[165]];
                })[_$_b839[137]](function(se) {
                  return se[_$_b839[158]][_$_b839[156]][_$_b839[165]](se[_$_b839[149]], fe);
                });
                return Promise[_$_b839[167]](le)[_$_b839[166]](function() {
                });
              }, _e;
            }();
            te[_$_b839[140]] = ue;
          }, 16368: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[168]] = void 0, function(ie) {
              ie[_$_b839[169]] = _$_b839[169], ie[_$_b839[170]] = _$_b839[170], ie[_$_b839[171]] = _$_b839[171], ie[_$_b839[172]] = _$_b839[172], ie[_$_b839[173]] = _$_b839[173], ie[_$_b839[174]] = _$_b839[173], ie[_$_b839[175]] = _$_b839[173], ie[_$_b839[176]] = _$_b839[176], ie[_$_b839[177]] = _$_b839[177], ie[_$_b839[178]] = _$_b839[178], ie[_$_b839[179]] = _$_b839[179], ie[_$_b839[180]] = _$_b839[181], ie[_$_b839[182]] = _$_b839[182], ie[_$_b839[183]] = _$_b839[183], ie[_$_b839[184]] = _$_b839[184], ie[_$_b839[185]] = _$_b839[185], ie[_$_b839[186]] = _$_b839[186], ie[_$_b839[187]] = _$_b839[187], ie[_$_b839[188]] = _$_b839[188], ie[_$_b839[189]] = _$_b839[189], ie[_$_b839[190]] = _$_b839[190], ie[_$_b839[191]] = _$_b839[191], ie[_$_b839[192]] = _$_b839[192], ie[_$_b839[193]] = _$_b839[193], ie[_$_b839[194]] = _$_b839[194], ie[_$_b839[195]] = _$_b839[195], ie[_$_b839[196]] = _$_b839[196], ie[_$_b839[197]] = _$_b839[197], ie[_$_b839[198]] = _$_b839[198], ie[_$_b839[199]] = _$_b839[199], ie[_$_b839[200]] = _$_b839[200], ie[_$_b839[201]] = _$_b839[202], ie[_$_b839[203]] = _$_b839[204], ie[_$_b839[205]] = _$_b839[205], ie[_$_b839[206]] = _$_b839[206], ie[_$_b839[207]] = _$_b839[207], ie[_$_b839[208]] = _$_b839[208], ie[_$_b839[209]] = _$_b839[209], ie[_$_b839[210]] = _$_b839[210], ie[_$_b839[211]] = _$_b839[211];
            }(ee || (te[_$_b839[168]] = ee = {}));
          }, 41108: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[212]] || function() {
              var ue = function(_e, fe) {
                return ue = Object[_$_b839[213]] || { __proto__: [] } instanceof Array && function(le, se) {
                  le[_$_b839[214]] = se;
                } || function(le, se) {
                  for (var oe in se)
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](se, oe) && (le[oe] = se[oe]);
                }, ue(_e, fe);
              };
              return function(_e, fe) {
                if (_$_b839[34] != typeof fe && fe !== null)
                  throw new TypeError(_$_b839[216] + String(fe) + _$_b839[217]);
                function le() {
                  this[_$_b839[105]] = _e;
                }
                ue(_e, fe), _e[_$_b839[37]] = fe === null ? Object[_$_b839[52]](fe) : (le[_$_b839[37]] = fe[_$_b839[37]], new le());
              };
            }();
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[153]] = void 0;
            var ne = ee(25550), ae = function(ue) {
              function _e(fe, le) {
                return le ? ue[_$_b839[36]](this, ne[_$_b839[145]][_$_b839[218]], { name: fe, dependency: le }, _$_b839[221][_$_b839[41]](fe, _$_b839[220])[_$_b839[41]](le, _$_b839[219])) || this : ue[_$_b839[36]](this, ne[_$_b839[145]][_$_b839[222]], { name: fe }, _$_b839[221][_$_b839[41]](fe, _$_b839[223])) || this;
              }
              return ie(_e, ue), _e;
            }(ee(28764)[_$_b839[147]]);
            te[_$_b839[153]] = ae;
          }, 57042: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[212]] || function() {
              var _e = function(fe, le) {
                return _e = Object[_$_b839[213]] || { __proto__: [] } instanceof Array && function(se, oe) {
                  se[_$_b839[214]] = oe;
                } || function(se, oe) {
                  for (var ce in oe)
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](oe, ce) && (se[ce] = oe[ce]);
                }, _e(fe, le);
              };
              return function(fe, le) {
                if (_$_b839[34] != typeof le && le !== null)
                  throw new TypeError(_$_b839[216] + String(le) + _$_b839[217]);
                function se() {
                  this[_$_b839[105]] = fe;
                }
                _e(fe, le), fe[_$_b839[37]] = le === null ? Object[_$_b839[52]](le) : (se[_$_b839[37]] = le[_$_b839[37]], new se());
              };
            }();
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[224]] = void 0;
            var ne = ee(63546), ae = ee(35148), ue = function(_e) {
              function fe(le, se) {
                return _e[_$_b839[36]](this, ae[_$_b839[226]][_$_b839[222]], se, { moduleName: le }) || this;
              }
              return ie(fe, _e), fe;
            }(ne[_$_b839[225]]);
            te[_$_b839[224]] = ue;
          }, 92712: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(Se) {
                for (var we, Pe = 1, Te = arguments[_$_b839[26]]; Pe < Te; Pe++)
                  for (var Ee in we = arguments[Pe])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](we, Ee) && (Se[Ee] = we[Ee]);
                return Se;
              }, ie[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[229]] = te[_$_b839[230]] = void 0, te[_$_b839[231]] = he, te[_$_b839[232]] = ge, te[_$_b839[233]] = ve, te[_$_b839[234]] = me, te[_$_b839[235]] = be, te[_$_b839[236]] = pe, te[_$_b839[237]] = $e, te[_$_b839[238]] = ye;
            var ne = ee(92737), ae = ee(33696), ue = ee(80043), _e = ee(331), fe = Math[_$_b839[239]](10, 2), le = function() {
              function Se(we, Pe, Te) {
                this[_$_b839[240]] = we, this[_$_b839[241]] = Pe, this[_$_b839[242]] = Te || 1;
              }
              return Se[_$_b839[37]][_$_b839[243]] = function() {
                return this[_$_b839[242]];
              }, Se[_$_b839[37]][_$_b839[244]] = function() {
                return this[_$_b839[240]];
              }, Se[_$_b839[37]][_$_b839[245]] = function() {
                return this[_$_b839[241]];
              }, Se[_$_b839[37]][_$_b839[124]] = function(we) {
                for (var Pe = [], Te = 0; Te < we[_$_b839[26]]; Te++) {
                  var Ee = we[Te], Me = Ee[_$_b839[240]], Ae = Ee[_$_b839[241]], Ne = Ee[_$_b839[242]], Ce = this[_$_b839[240]] < Me && this[_$_b839[241]] > Ae, Ie = this[_$_b839[240]] < Me && this[_$_b839[241]] > Me && this[_$_b839[241]] < Ae, xe = this[_$_b839[240]] > Me && this[_$_b839[240]] < Ae && this[_$_b839[241]] > Ae, Ue = this[_$_b839[240]] > Me && this[_$_b839[241]] < Ae, ke = this[_$_b839[240]] === Me && this[_$_b839[241]] < Ae, Le = this[_$_b839[240]] === Me && this[_$_b839[241]] > Ae, De = this[_$_b839[240]] < Me && this[_$_b839[241]] === Ae, Re = this[_$_b839[240]] > Me && this[_$_b839[241]] === Ae, Oe = this[_$_b839[240]] === Me && this[_$_b839[241]] === Ae;
                  Ce || Le || De || Oe ? Pe[_$_b839[57]](new Se(Me, Ae, Ne + 1)) : Ie || ke ? (Pe[_$_b839[57]](new Se(Me, this[_$_b839[241]], Ne + 1)), Pe[_$_b839[57]](new Se(this[_$_b839[241]], Ae, Ne))) : xe || Re ? (Pe[_$_b839[57]](new Se(Me, this[_$_b839[240]], Ne)), Pe[_$_b839[57]](new Se(this[_$_b839[240]], Ae, Ne + 1))) : Ue ? (Pe[_$_b839[57]](new Se(Me, this[_$_b839[240]], Ne)), Pe[_$_b839[57]](new Se(this[_$_b839[240]], this[_$_b839[241]], Ne + 1)), Pe[_$_b839[57]](new Se(this[_$_b839[241]], Ae, Ne))) : Pe[_$_b839[57]](new Se(Me, Ae, Ne));
                }
                return Pe;
              }, Se[_$_b839[37]][_$_b839[246]] = function(we) {
                for (var Pe = 0; Pe < we[_$_b839[26]] && !(this[_$_b839[241]] - this[_$_b839[240]] <= 0); Pe++) {
                  var Te = we[Pe], Ee = null;
                  Pe + 1 < we[_$_b839[26]] && (Ee = we[Pe + 1]), this[_$_b839[240]] < Te[_$_b839[240]] ? (we[_$_b839[56]](new Se(this[_$_b839[240]], Math[_$_b839[247]](Te[_$_b839[240]], this[_$_b839[241]]))), Pe++, this[_$_b839[240]] = Te[_$_b839[241]]) : Ee && Ee[_$_b839[240]] > this[_$_b839[240]] ? (we[_$_b839[130]](Pe, 0, new Se(Math[_$_b839[248]](Te[_$_b839[241]], this[_$_b839[240]]), Math[_$_b839[247]](this[_$_b839[241]], Ee[_$_b839[240]]))), this[_$_b839[240]] = Ee[_$_b839[241]], Pe++) : Ee === null && this[_$_b839[241]] > Te[_$_b839[241]] && (we[_$_b839[57]](new Se(Math[_$_b839[248]](Te[_$_b839[241]], this[_$_b839[240]]), this[_$_b839[241]])), this[_$_b839[240]] = this[_$_b839[241]]);
                }
                return we;
              }, Se[_$_b839[37]][_$_b839[249]] = function(we) {
                if (we[_$_b839[26]] === 0)
                  return [this];
                var Pe = this[_$_b839[124]](we);
                return this[_$_b839[246]](Pe);
              }, Se;
            }();
            te[_$_b839[230]] = le;
            var se = function() {
              function Se() {
              }
              return Se[_$_b839[250]] = function(we, Pe, Te) {
                if (Pe === void 0 && (Pe = 0), Te === void 0 && (Te = !0), we[_$_b839[26]] < 1)
                  return we;
                we[_$_b839[251]](function(xe, Ue) {
                  return xe[_$_b839[240]] - Ue[_$_b839[240]];
                });
                var Ee = [];
                Ee[_$_b839[57]](Te ? ie({}, we[0]) : we[0]);
                for (var Me = 1; Me < we[_$_b839[26]]; Me++) {
                  var Ae = Ee[_$_b839[74]](-1)[0], Ne = we[Me];
                  if (!be(Ne, Ae)) {
                    var Ce = Ae[_$_b839[241]] >= Ne[_$_b839[240]] - Pe, Ie = Ae[_$_b839[241]] <= Ne[_$_b839[241]] + Pe;
                    Ce && Ie ? Ee[Ee[_$_b839[26]] - 1][_$_b839[241]] = Ne[_$_b839[241]] : Ee[_$_b839[57]](Te ? ie({}, Ne) : Ne);
                  }
                }
                return Ee;
              }, Se[_$_b839[252]] = function(we, Pe) {
                return we[_$_b839[112]](function(Te) {
                  return !be(Te, Pe);
                })[_$_b839[135]](function(Te, Ee) {
                  var Me = oe(Pe[_$_b839[240]], Ee), Ae = ce(Pe[_$_b839[241]], Ee);
                  return Me && Te[_$_b839[57]](ie(ie({}, Ee), { end: Pe[_$_b839[240]] })), Ae && Te[_$_b839[57]](ie(ie({}, Ee), { start: Pe[_$_b839[241]] })), Me || Ae || Te[_$_b839[57]](ie({}, Ee)), Te;
                }, []);
              }, Se[_$_b839[253]] = function(we, Pe) {
                Pe === void 0 && (Pe = 0);
                for (var Te = [], Ee = Array[_$_b839[254]](we) ? new ue[_$_b839[255]](we) : we; Ee[_$_b839[256]](); ) {
                  var Me = Ee[_$_b839[132]]();
                  if (!Me[_$_b839[257]]()) {
                    var Ae = { start: Me[_$_b839[258]]() || 0, end: 0 };
                    Ae[_$_b839[241]] = Ae[_$_b839[240]] + Me[_$_b839[259]](), Te[_$_b839[57]](Ae);
                  }
                }
                return Te = Se[_$_b839[250]](Te, Pe, !1);
              }, Se[_$_b839[260]] = function(we) {
                var Pe = [], Te = 0;
                for (var Ee in we)
                  if (we[_$_b839[215]](Ee)) {
                    Te++;
                    for (var Me = we[Ee], Ae = 0; Ae < Me[_$_b839[26]]; Ae++)
                      Pe = new le(Me[Ae][_$_b839[240]], Me[Ae][_$_b839[241]])[_$_b839[249]](Pe);
                  }
                return [Pe, Te];
              }, Se[_$_b839[261]] = function(we) {
                for (var Pe = [], Te = 0; Te < we[_$_b839[26]] - 1; Te++)
                  we[Te + 1][_$_b839[240]] - we[Te][_$_b839[241]] > 0 && Pe[_$_b839[57]]({ start: we[Te][_$_b839[241]], end: we[Te + 1][_$_b839[240]] });
                return Pe;
              }, Se[_$_b839[262]] = function(we) {
                var Pe = [], Te = Se[_$_b839[260]](we), Ee = Te[0], Me = Te[1];
                for (var Ae in Ee)
                  Ee[_$_b839[215]](Ae) && Ee[Ae][_$_b839[243]]() === Me && Pe[_$_b839[57]](Ee[Ae]);
                return Pe;
              }, Se[_$_b839[263]] = function(we, Pe, Te, Ee) {
                for (var Me = -1, Ae = Se[_$_b839[262]](Pe), Ne = 0; Ne < Ae[_$_b839[26]]; Ne++)
                  if (Ae[Ne][_$_b839[244]]() <= Te && Ae[Ne][_$_b839[245]]() >= Te)
                    return Te;
                for (var Ce in Pe)
                  if (Pe[_$_b839[215]](Ce)) {
                    if (Pe[Ce][_$_b839[26]] < 1)
                      return null;
                    var Ie = Pe[Ce];
                    for (Ne = 0; Ne < Ie[_$_b839[26]] && !(Ie[Ne][_$_b839[240]] >= Me && (Me = Ie[Ne][_$_b839[240]], Ie[Ne][_$_b839[240]] >= Te)); Ne++)
                      ;
                  }
                return Me === -1 ? null : Me < Te && Te - Me < Ee ? Te : (we[_$_b839[265]](_$_b839[264], Te - Me), Me);
              }, Se[_$_b839[266]] = function(we, Pe) {
                var Te = Object[_$_b839[98]](we);
                return !!Te[_$_b839[26]] && Te[_$_b839[267]](function(Ee) {
                  return pe(we[Ee], Pe);
                });
              }, Se[_$_b839[268]] = function(we) {
                return this[_$_b839[262]](we)[_$_b839[135]](function(Pe, Te) {
                  return Pe + Te[_$_b839[245]]() - Te[_$_b839[244]]();
                }, 0);
              }, Se[_$_b839[269]] = function(we, Pe, Te) {
                if (!we || !we[_$_b839[26]])
                  return 0;
                var Ee = 0;
                return Te === ae[_$_b839[271]][_$_b839[270]] ? Ee = we[we[_$_b839[26]] - 1][_$_b839[241]] - Pe : Te === ae[_$_b839[271]][_$_b839[272]] && (Ee = Pe - we[0][_$_b839[240]]), Math[_$_b839[248]](Ee, 0);
              }, Se;
            }();
            function oe(Se, we) {
              return Se > we[_$_b839[240]] && Se <= we[_$_b839[241]];
            }
            function ce(Se, we) {
              return Se < we[_$_b839[241]] && Se >= we[_$_b839[240]];
            }
            function he(Se) {
              return Se === void 0 || isNaN(Se) ? 0 : Math[_$_b839[273]](Se * fe) / fe;
            }
            function ge(Se, we) {
              return he(Se[_$_b839[241]]) < he(we[_$_b839[240]]) || he(Se[_$_b839[240]]) > he(we[_$_b839[241]]);
            }
            function ve(Se, we) {
              return he(we[_$_b839[240]]) > he(Se[_$_b839[240]]) && he(we[_$_b839[241]]) < he(Se[_$_b839[241]]);
            }
            function me(Se, we) {
              return he(Se[_$_b839[240]]) >= he(we[_$_b839[240]]) && he(Se[_$_b839[240]]) <= he(we[_$_b839[241]]) || he(Se[_$_b839[241]]) >= he(we[_$_b839[240]]) && he(Se[_$_b839[241]]) <= he(we[_$_b839[241]]);
            }
            function be(Se, we) {
              return he(we[_$_b839[240]]) <= he(Se[_$_b839[240]]) && he(we[_$_b839[241]]) >= he(Se[_$_b839[241]]);
            }
            function pe(Se, we, Pe) {
              Pe === void 0 && (Pe = 0);
              for (var Te = 0, Ee = Se; Te < Ee[_$_b839[26]]; Te++) {
                var Me = Ee[Te], Ae = Math[_$_b839[247]](Math[_$_b839[273]](1e3 * Me[_$_b839[240]]) / 1e3, Me[_$_b839[240]]), Ne = Math[_$_b839[248]](Math[_$_b839[273]](1e3 * Me[_$_b839[241]]) / 1e3, Me[_$_b839[241]]);
                if (we >= Ae && we <= Ne - Pe)
                  return !0;
              }
              return !1;
            }
            function $e(Se) {
              var we = [], Pe = Se == null ? void 0 : Se[_$_b839[274]];
              if (Pe)
                for (var Te = 0; Te < Pe[_$_b839[26]]; Te++)
                  we[_$_b839[57]]({ start: Pe[_$_b839[240]](Te), end: Pe[_$_b839[241]](Te) });
              return we;
            }
            function ye(Se, we, Pe) {
              var Te, Ee = (0, _e[_$_b839[276]])((Te = we == null ? void 0 : we[_$_b839[275]]()) !== null && Te !== void 0 ? Te : 0);
              return Pe === ne[_$_b839[278]][_$_b839[277]] && (Ee = -Ee), { start: Se[_$_b839[240]] + Ee, end: Se[_$_b839[241]] + Ee };
            }
            te[_$_b839[229]] = se;
          }, 47384: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[279]] = void 0;
            var ie = ee(33696), ne = ee(79814), ae = function() {
              function ue(_e, fe) {
                this[_$_b839[280]] = fe, this[_$_b839[281]] = JSON[_$_b839[283]](JSON[_$_b839[282]](_e)), this[_$_b839[284]] = {}, this[_$_b839[285]](this[_$_b839[284]], this[_$_b839[281]]), this[_$_b839[286]] = { currentDistanceToLiveEdge: 1 / 0, minimumBufferLength: 1, streamDuration: 1 / 0 };
              }
              return ue[_$_b839[37]][_$_b839[285]] = function(_e, fe) {
                Object[_$_b839[98]](fe)[_$_b839[113]](function(le) {
                  _e[le] = {};
                });
              }, ue[_$_b839[37]][_$_b839[287]] = function(_e, fe, le) {
                _$_b839[79] == typeof fe && (this[_$_b839[281]][le][_e] = fe);
              }, ue[_$_b839[37]][_$_b839[288]] = function(_e, fe, le) {
                this[_$_b839[284]][le][_e] = fe;
              }, ue[_$_b839[37]][_$_b839[289]] = function(_e) {
                this[_$_b839[286]] = _e;
              }, ue[_$_b839[37]][_$_b839[290]] = function(_e, fe) {
                var le, se, oe, ce, he = (se = (le = this[_$_b839[281]][fe]) === null || le === void 0 ? void 0 : le[_e]) !== null && se !== void 0 ? se : 1 / 0, ge = (ce = (oe = this[_$_b839[284]][fe]) === null || oe === void 0 ? void 0 : oe[_e]) !== null && ce !== void 0 ? ce : 1 / 0, ve = this[_$_b839[286]][_$_b839[291]], me = this[_$_b839[286]][_$_b839[292]], be = this[_$_b839[286]][_$_b839[293]];
                return Math[_$_b839[248]](Math[_$_b839[247]](he, ge, ve, be), me);
              }, ue[_$_b839[37]][_$_b839[294]] = function(_e) {
                return _e === void 0 && (_e = ie[_$_b839[296]][_$_b839[295]]), this[_$_b839[290]](ie[_$_b839[271]][_$_b839[270]], _e);
              }, ue[_$_b839[37]][_$_b839[297]] = function(_e) {
                return _e === void 0 && (_e = ie[_$_b839[296]][_$_b839[295]]), this[_$_b839[290]](ie[_$_b839[271]][_$_b839[272]], _e);
              }, ue[_$_b839[37]][_$_b839[298]] = function(_e) {
                var fe, le = ne[_$_b839[300]][_$_b839[299]](_e) ? ie[_$_b839[296]][_$_b839[301]] : ie[_$_b839[296]][_$_b839[295]];
                return (fe = {})[ie[_$_b839[271]][_$_b839[272]]] = this[_$_b839[297]](le), fe[ie[_$_b839[271]][_$_b839[270]]] = this[_$_b839[294]](le), fe;
              }, ue[_$_b839[37]][_$_b839[302]] = function(_e, fe, le) {
                var se, oe = le / 2, ce = le / 2, he = this[_$_b839[298]](_e), ge = he[ie[_$_b839[271]][_$_b839[272]]], ve = he[ie[_$_b839[271]][_$_b839[270]]], me = le >= 2 * fe, be = ve / (ve + ge);
                if (!isFinite(ge) && isFinite(ve) ? (oe = fe, ce = le - fe) : isFinite(ge) && !isFinite(ve) ? (oe = le - fe, ce = fe) : isFinite(ge) && isFinite(ve) && (oe = le * be, ce = le * (1 - be)), me && oe < fe) {
                  var pe = fe - oe;
                  oe += pe, ce -= pe;
                }
                return (se = {})[ie[_$_b839[271]][_$_b839[272]]] = ce, se[ie[_$_b839[271]][_$_b839[270]]] = oe, se;
              }, ue[_$_b839[37]][_$_b839[303]] = function(_e, fe, le) {
                var se = this[_$_b839[302]](fe, _e, le - _e), oe = se[ie[_$_b839[271]][_$_b839[272]]], ce = se[ie[_$_b839[271]][_$_b839[270]]];
                this[_$_b839[280]][_$_b839[265]](_$_b839[306][_$_b839[41]](ce, _$_b839[305])[_$_b839[41]](oe, _$_b839[304])), this[_$_b839[288]](ie[_$_b839[271]][_$_b839[270]], ce, ie[_$_b839[296]][_$_b839[301]]), this[_$_b839[288]](ie[_$_b839[271]][_$_b839[270]], ce, ie[_$_b839[296]][_$_b839[295]]), this[_$_b839[288]](ie[_$_b839[271]][_$_b839[272]], oe, ie[_$_b839[296]][_$_b839[301]]), this[_$_b839[288]](ie[_$_b839[271]][_$_b839[272]], oe, ie[_$_b839[296]][_$_b839[295]]);
              }, ue;
            }();
            te[_$_b839[279]] = ae;
          }, 52442: function(re, te) {
            _$_b839[32];
            var ee, ie, ne, ae, ue, _e;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[307]] = te[_$_b839[308]] = te[_$_b839[309]] = te[_$_b839[310]] = te[_$_b839[311]] = te[_$_b839[312]] = void 0, function(fe) {
              fe[fe[_$_b839[313]] = 1] = _$_b839[313], fe[fe[_$_b839[314]] = 2] = _$_b839[314], fe[fe[_$_b839[315]] = 3] = _$_b839[315];
            }(ee || (te[_$_b839[312]] = ee = {})), function(fe) {
              fe[fe[_$_b839[316]] = 0] = _$_b839[316], fe[fe[_$_b839[317]] = 1] = _$_b839[317], fe[fe[_$_b839[318]] = 2] = _$_b839[318];
            }(ie || (te[_$_b839[311]] = ie = {})), function(fe) {
              fe[_$_b839[319]] = _$_b839[319], fe[_$_b839[320]] = _$_b839[321], fe[_$_b839[322]] = _$_b839[323], fe[_$_b839[324]] = _$_b839[325];
            }(ne || (te[_$_b839[310]] = ne = {})), function(fe) {
              fe[_$_b839[326]] = _$_b839[327], fe[_$_b839[328]] = _$_b839[329], fe[_$_b839[330]] = _$_b839[331];
            }(ae || (te[_$_b839[309]] = ae = {})), function(fe) {
              fe[_$_b839[332]] = _$_b839[333], fe[_$_b839[334]] = _$_b839[335];
            }(ue || (te[_$_b839[308]] = ue = {})), function(fe) {
              fe[_$_b839[336]] = _$_b839[337], fe[_$_b839[338]] = _$_b839[339];
            }(_e || (te[_$_b839[307]] = _e = {}));
          }, 60997: function(re, te) {
            _$_b839[32];
            function ee(ie) {
              ie && ie[_$_b839[340]]();
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[340]] = ee;
          }, 67501: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[341]] || (Object[_$_b839[52]] ? function(_e, fe, le, se) {
              se === void 0 && (se = le);
              var oe = Object[_$_b839[111]](fe, le);
              oe && !(_$_b839[159] in oe ? !fe[_$_b839[139]] : oe[_$_b839[342]] || oe[_$_b839[343]]) || (oe = { enumerable: !0, get: function() {
                return fe[le];
              } }), Object[_$_b839[82]](_e, se, oe);
            } : function(_e, fe, le, se) {
              se === void 0 && (se = le), _e[se] = fe[le];
            }), ne = this && this[_$_b839[344]] || function(_e, fe) {
              for (var le in _e)
                _$_b839[107] === le || Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](fe, le) || ie(fe, _e, le);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[345]] = te[_$_b839[346]] = void 0;
            var ae = ee(90546);
            Object[_$_b839[82]](te, _$_b839[346], { enumerable: !0, get: function() {
              return ae[_$_b839[346]];
            } }), ne(ee(92737), te);
            var ue = ee(7197);
            te[_$_b839[345]] = ue, te[_$_b839[107]] = ae[_$_b839[346]];
          }, 4006: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[347]] = void 0;
            var ee = function() {
              function ne() {
              }
              return Object[_$_b839[82]](ne, _$_b839[348], { get: function() {
                return this[_$_b839[349]] || (this[_$_b839[349]] = location[_$_b839[348]]), this[_$_b839[349]];
              }, set: function(ae) {
                this[_$_b839[349]] = ae;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](ne, _$_b839[350], { get: function() {
                return ne[_$_b839[351]]();
              }, enumerable: !1, configurable: !0 }), ne[_$_b839[352]] = function() {
                if (this[_$_b839[353]][_$_b839[26]] === 0 || _$_b839[354] === this[_$_b839[348]])
                  return !0;
                for (var ae = 0, ue = this[_$_b839[353]][_$_b839[124]](_$_b839[355]); ae < ue[_$_b839[26]]; ae++) {
                  var _e = ue[ae], fe = _e[_$_b839[25]](2), le = this[_$_b839[348]][_$_b839[26]] - fe[_$_b839[26]], se = this[_$_b839[348]][_$_b839[29]](fe), oe = se !== -1 && se === le, ce = _e[_$_b839[357]](_$_b839[356]) && oe;
                  if (_e === this[_$_b839[348]] || ce)
                    return !0;
                }
                return !1;
              }, ne[_$_b839[351]] = function() {
                var ae = this[_$_b839[358]]();
                return ae = ae[_$_b839[360]](_$_b839[359]) > -1 ? ae[_$_b839[25]](0, ae[_$_b839[360]](_$_b839[359]) + 1) : _$_b839[90];
              }, ne[_$_b839[361]] = function() {
                try {
                  omgwtfnodocumentdotcurrentscript;
                } catch (ae) {
                  return ae[_$_b839[362]];
                }
              }, ne[_$_b839[363]] = function() {
                var ae = this[_$_b839[361]]();
                if (!ae)
                  return _$_b839[90];
                for (var ue = ae[_$_b839[29]](_$_b839[364]) !== -1 ? _$_b839[364] : _$_b839[365]; ae[_$_b839[29]](ue) !== -1; )
                  ae = ae[_$_b839[25]](ae[_$_b839[29]](ue) + ue[_$_b839[26]]);
                var _e = ae[_$_b839[360]](_$_b839[366], ae[_$_b839[360]](_$_b839[366]) - 1);
                return ae = ae[_$_b839[25]](ae[_$_b839[29]](_$_b839[27]) + 1, _e);
              }, ne[_$_b839[358]] = function() {
                var ae, ue;
                if (!((ae = window[_$_b839[4]]) === null || ae === void 0) && ae[_$_b839[367]]) {
                  var _e = window[_$_b839[4]][_$_b839[367]][_$_b839[368]];
                  return _e[_$_b839[29]](_$_b839[369]) > -1 ? _e[_$_b839[25]](0, _e[_$_b839[360]](_$_b839[369])) : _e;
                }
                for (var fe = ((ue = window[_$_b839[4]]) === null || ue === void 0 ? void 0 : ue[_$_b839[371]](_$_b839[370])) || [], le = fe[_$_b839[26]], se = 0; se < le; se++)
                  if (ie(fe[se])) {
                    if (fe[se][_$_b839[368]][_$_b839[29]](_$_b839[372]) > -1)
                      return fe[se][_$_b839[368]];
                    if (fe[se][_$_b839[368]][_$_b839[29]](_$_b839[369]) > -1)
                      return fe[se][_$_b839[368]][_$_b839[25]](0, fe[se][_$_b839[368]][_$_b839[29]](_$_b839[369]));
                  }
                var oe = this[_$_b839[363]]();
                return oe || (fe[_$_b839[26]] > 0 && ie(fe[le - 1]) ? fe[le - 1][_$_b839[368]] : _$_b839[90]);
              }, ne[_$_b839[373]] = _$_b839[374], ne[_$_b839[375]] = _$_b839[376], ne[_$_b839[353]] = _$_b839[90], ne[_$_b839[142]] = { playerui: null }, ne;
            }();
            function ie(ne) {
              return ne[_$_b839[377]](_$_b839[368]) && ne[_$_b839[368]] != null;
            }
            te[_$_b839[347]] = ee;
          }, 62510: function(re, te) {
            _$_b839[32];
            var ee, ie, ne, ae, ue;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[378]] = te[_$_b839[379]] = te[_$_b839[380]] = te[_$_b839[381]] = te[_$_b839[382]] = void 0, function(_e) {
              _e[_$_b839[383]] = _$_b839[384], _e[_$_b839[385]] = _$_b839[386], _e[_$_b839[387]] = _$_b839[388], _e[_$_b839[389]] = _$_b839[390], _e[_$_b839[391]] = _$_b839[392], _e[_$_b839[393]] = _$_b839[394], _e[_$_b839[395]] = _$_b839[396], _e[_$_b839[397]] = _$_b839[398], _e[_$_b839[399]] = _$_b839[400], _e[_$_b839[401]] = _$_b839[402], _e[_$_b839[403]] = _$_b839[404], _e[_$_b839[405]] = _$_b839[406], _e[_$_b839[407]] = _$_b839[408], _e[_$_b839[409]] = _$_b839[73], _e[_$_b839[410]] = _$_b839[411], _e[_$_b839[412]] = _$_b839[413], _e[_$_b839[414]] = _$_b839[415], _e[_$_b839[416]] = _$_b839[417], _e[_$_b839[418]] = _$_b839[419], _e[_$_b839[420]] = _$_b839[421], _e[_$_b839[422]] = _$_b839[423], _e[_$_b839[424]] = _$_b839[425], _e[_$_b839[426]] = _$_b839[427], _e[_$_b839[428]] = _$_b839[429], _e[_$_b839[430]] = _$_b839[431], _e[_$_b839[432]] = _$_b839[433], _e[_$_b839[434]] = _$_b839[435], _e[_$_b839[436]] = _$_b839[437], _e[_$_b839[438]] = _$_b839[439], _e[_$_b839[440]] = _$_b839[441], _e[_$_b839[442]] = _$_b839[443], _e[_$_b839[444]] = _$_b839[445], _e[_$_b839[446]] = _$_b839[447], _e[_$_b839[448]] = _$_b839[449], _e[_$_b839[450]] = _$_b839[451], _e[_$_b839[452]] = _$_b839[453], _e[_$_b839[454]] = _$_b839[455], _e[_$_b839[456]] = _$_b839[457], _e[_$_b839[458]] = _$_b839[459], _e[_$_b839[460]] = _$_b839[461], _e[_$_b839[462]] = _$_b839[463], _e[_$_b839[464]] = _$_b839[465], _e[_$_b839[466]] = _$_b839[467], _e[_$_b839[468]] = _$_b839[469], _e[_$_b839[380]] = _$_b839[470], _e[_$_b839[471]] = _$_b839[472], _e[_$_b839[473]] = _$_b839[474], _e[_$_b839[475]] = _$_b839[476], _e[_$_b839[477]] = _$_b839[478], _e[_$_b839[479]] = _$_b839[480], _e[_$_b839[481]] = _$_b839[482], _e[_$_b839[483]] = _$_b839[484], _e[_$_b839[485]] = _$_b839[486], _e[_$_b839[487]] = _$_b839[488], _e[_$_b839[489]] = _$_b839[490], _e[_$_b839[491]] = _$_b839[492], _e[_$_b839[493]] = _$_b839[494], _e[_$_b839[495]] = _$_b839[496], _e[_$_b839[497]] = _$_b839[498], _e[_$_b839[499]] = _$_b839[500], _e[_$_b839[501]] = _$_b839[502], _e[_$_b839[503]] = _$_b839[504], _e[_$_b839[505]] = _$_b839[506], _e[_$_b839[507]] = _$_b839[508], _e[_$_b839[509]] = _$_b839[510], _e[_$_b839[511]] = _$_b839[512], _e[_$_b839[513]] = _$_b839[514], _e[_$_b839[515]] = _$_b839[516], _e[_$_b839[517]] = _$_b839[518], _e[_$_b839[519]] = _$_b839[520], _e[_$_b839[521]] = _$_b839[522], _e[_$_b839[523]] = _$_b839[524], _e[_$_b839[525]] = _$_b839[165], _e[_$_b839[526]] = _$_b839[527], _e[_$_b839[528]] = _$_b839[529], _e[_$_b839[530]] = _$_b839[531], _e[_$_b839[532]] = _$_b839[533], _e[_$_b839[534]] = _$_b839[535], _e[_$_b839[536]] = _$_b839[537], _e[_$_b839[538]] = _$_b839[539], _e[_$_b839[540]] = _$_b839[541], _e[_$_b839[542]] = _$_b839[543], _e[_$_b839[544]] = _$_b839[545], _e[_$_b839[546]] = _$_b839[547], _e[_$_b839[548]] = _$_b839[549], _e[_$_b839[550]] = _$_b839[551], _e[_$_b839[552]] = _$_b839[553], _e[_$_b839[554]] = _$_b839[555], _e[_$_b839[556]] = _$_b839[557], _e[_$_b839[558]] = _$_b839[559];
            }(ee || (te[_$_b839[382]] = ee = {})), function(_e) {
              _e[_$_b839[560]] = _$_b839[560], _e[_$_b839[561]] = _$_b839[561], _e[_$_b839[562]] = _$_b839[563], _e[_$_b839[564]] = _$_b839[564], _e[_$_b839[565]] = _$_b839[565], _e[_$_b839[566]] = _$_b839[566], _e[_$_b839[567]] = _$_b839[567], _e[_$_b839[568]] = _$_b839[568];
            }(ie || (te[_$_b839[381]] = ie = {})), function(_e) {
              _e[_$_b839[569]] = _$_b839[570], _e[_$_b839[571]] = _$_b839[572], _e[_$_b839[573]] = _$_b839[574];
            }(ne || (te[_$_b839[380]] = ne = {})), function(_e) {
              _e[_$_b839[575]] = _$_b839[576];
            }(ae || (te[_$_b839[379]] = ae = {})), function(_e) {
              _e[_$_b839[577]] = _$_b839[578], _e[_$_b839[579]] = _$_b839[580], _e[_$_b839[581]] = _$_b839[582], _e[_$_b839[583]] = _$_b839[584];
            }(ue || (te[_$_b839[378]] = ue = {}));
          }, 92737: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[341]] || (Object[_$_b839[52]] ? function(ue, _e, fe, le) {
              le === void 0 && (le = fe);
              var se = Object[_$_b839[111]](_e, fe);
              se && !(_$_b839[159] in se ? !_e[_$_b839[139]] : se[_$_b839[342]] || se[_$_b839[343]]) || (se = { enumerable: !0, get: function() {
                return _e[fe];
              } }), Object[_$_b839[82]](ue, le, se);
            } : function(ue, _e, fe, le) {
              le === void 0 && (le = fe), ue[le] = _e[fe];
            }), ne = this && this[_$_b839[344]] || function(ue, _e) {
              for (var fe in ue)
                _$_b839[107] === fe || Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](_e, fe) || ie(_e, ue, fe);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[345]] = void 0;
            var ae = ee(33696);
            te[_$_b839[107]] = ae[_$_b839[585]], ne(ee(62510), te), te[_$_b839[345]] = ee(77012), ne(ee(16368), te), ne(ee(33696), te), ne(ee(25226), te), ne(ee(28764), te), ne(ee(25550), te), ne(ee(35148), te), ne(ee(63546), te), ne(ee(41108), te), ne(ee(57042), te), ne(ee(67345), te);
          }, 13142: function(re, te) {
            _$_b839[32];
            function ee(ie, ne, ae) {
              ae[_$_b839[110]] = !0;
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[586]] = ee;
          }, 15447: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(rt) {
                for (var He, Ye = 1, ct = arguments[_$_b839[26]]; Ye < ct; Ye++)
                  for (var _t in He = arguments[Ye])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](He, _t) && (rt[_t] = He[_t]);
                return rt;
              }, ie[_$_b839[35]](this, arguments);
            }, ne = this && this[_$_b839[587]] || function(rt, He, Ye, ct) {
              var _t, Pt = arguments[_$_b839[26]], It = Pt < 3 ? He : ct === null ? ct = Object[_$_b839[111]](He, Ye) : ct;
              if (_$_b839[33] == typeof Reflect && _$_b839[34] == typeof Reflect[_$_b839[588]])
                It = Reflect[_$_b839[588]](rt, He, Ye, ct);
              else
                for (var wt = rt[_$_b839[26]] - 1; wt >= 0; wt--)
                  (_t = rt[wt]) && (It = (Pt < 3 ? _t(It) : Pt > 3 ? _t(He, Ye, It) : _t(He, Ye)) || It);
              return Pt > 3 && It && Object[_$_b839[82]](He, Ye, It), It;
            }, ae = this && this[_$_b839[589]] || function(rt, He, Ye) {
              if (Ye || arguments[_$_b839[26]] === 2)
                for (var ct, _t = 0, Pt = He[_$_b839[26]]; _t < Pt; _t++)
                  !ct && _t in He || (ct || (ct = Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](He, 0, _t)), ct[_t] = He[_t]);
              return rt[_$_b839[41]](ct || Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](He));
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[590]] = te[_$_b839[591]] = void 0;
            var ue, _e, fe = ee(91520), le = ee(16368), se = ee(79063), oe = ee(90788), ce = ee(25550), he = ee(28764), ge = ee(63546), ve = ee(35148), me = ee(47275), be = ee(18665), pe = ee(60997), $e = ee(4006), ye = ee(62510), Se = ee(78429), we = ee(15539), Pe = ee(84435), Te = ee(84903), Ee = ee(58935), Me = ee(27256), Ae = ee(16937), Ne = ee(33696), Ce = ee(82334), Ie = ee(62987), xe = ee(36334), Ue = ee(59510), ke = ee(87326), Le = ee(12031), De = ee(21607), Re = ee(93949), Oe = ee(29073), Be = ee(11399), Fe = ee(57782), Ve = ee(17990), Ke = ee(58975), Ze = ee(76420), nt = ee(96873), Qe = ee(60627), qe = ee(14073), ze = ee(27279), je = ee(95328), tt = ee(13533), ut = ee(77845), yt = ee(3464), $t = ee(43485), ft = ee(10981), pt = ee(79814), lt = ee(38261), Je = ee(331), Xe = ee(70016), We = ee(54838), Ge = ee(13547), at = ee(3570);
            (function(rt) {
              rt[rt[_$_b839[319]] = 0] = _$_b839[319], rt[rt[_$_b839[592]] = 1] = _$_b839[592], rt[rt[_$_b839[593]] = 2] = _$_b839[593];
            })(ue || (ue = {})), function(rt) {
              rt[_$_b839[594]] = _$_b839[595], rt[_$_b839[596]] = _$_b839[597];
            }(_e || (_e = {})), te[_$_b839[591]] = _$_b839[598];
            var dt = function() {
              function rt(He, Ye, ct) {
                var _t = this;
                if (this[_$_b839[599]] = null, this[_$_b839[600]] = null, this[_$_b839[601]] = Promise[_$_b839[602]](), this[_$_b839[603]] = [_$_b839[604], _$_b839[605], _$_b839[606], _$_b839[607], _$_b839[608]], this[_$_b839[609]] = [_$_b839[610], _$_b839[611], _$_b839[612], _$_b839[613], _$_b839[614]], this[_$_b839[615]] = Promise[_$_b839[602]](), this[_$_b839[616]] = Promise[_$_b839[602]](), this[_$_b839[617]] = function(It) {
                  var wt, Ct;
                  if (It === void 0 && (It = _$_b839[618]), (Ct = (wt = _t[_$_b839[619]]) === null || wt === void 0 ? void 0 : wt[_$_b839[620]]) === null || Ct === void 0 ? void 0 : Ct[_$_b839[621]]) {
                    var Mt = Promise[_$_b839[602]]();
                    Tt(It) || (_t[_$_b839[599]] = null, _t[_$_b839[600]] = null, Mt = _t[_$_b839[622]](), _t[_$_b839[623]](), _t[_$_b839[624]]()), _t[_$_b839[619]][_$_b839[626]][_$_b839[625]](ye[_$_b839[382]][_$_b839[438]]), _t[_$_b839[627]] = !1, _t[_$_b839[628]] = void 0, _t[_$_b839[619]][_$_b839[91]] && gt(_t[_$_b839[619]][_$_b839[91]]), _t[_$_b839[601]] = _t[_$_b839[601]][_$_b839[166]](function() {
                      return Mt;
                    })[_$_b839[166]](function() {
                      var kt, Rt;
                      return (Rt = (kt = _t[_$_b839[619]]) === null || kt === void 0 ? void 0 : kt[_$_b839[620]]) === null || Rt === void 0 ? void 0 : Rt[_$_b839[621]](It)[_$_b839[166]](function() {
                        var At;
                        return (At = _t[_$_b839[91]]) === null || At === void 0 ? void 0 : At[_$_b839[635]][_$_b839[639]](be[_$_b839[637]][_$_b839[636]], function(Ot) {
                          return Ot[_$_b839[638]](Tt(It));
                        });
                      })[_$_b839[166]](function() {
                        var At, Ot, Dt;
                        _t[_$_b839[629]] && _t[_$_b839[629]][_$_b839[630]](), !((Ot = (At = _t[_$_b839[619]]) === null || At === void 0 ? void 0 : At[_$_b839[91]]) === null || Ot === void 0) && Ot[_$_b839[631]] && (Tt(It) ? _t[_$_b839[619]][_$_b839[91]][_$_b839[631]][_$_b839[632]] && _t[_$_b839[633]]() : (Dt = _t[_$_b839[91]]) === null || Dt === void 0 || Dt[_$_b839[635]][_$_b839[634]](), _t[_$_b839[619]][_$_b839[91]][_$_b839[631]][_$_b839[340]]());
                      });
                    });
                  }
                  return _t[_$_b839[601]];
                }, this[_$_b839[640]] = function(It) {
                  var wt;
                  _t[_$_b839[641]]() && ((wt = _t[_$_b839[619]][_$_b839[620]]) === null || wt === void 0 || wt[_$_b839[640]](It));
                }, this[_$_b839[642]] = function(It) {
                  return It === void 0 && (It = _t[_$_b839[643]]()), !!It && !!It[_$_b839[644]] && (0, tt[_$_b839[646]])()[_$_b839[645]];
                }, this[_$_b839[647]] = function(It, wt, Ct) {
                  if (Ct === void 0 && (Ct = {}), It)
                    _t[_$_b839[648]](ye[_$_b839[382]][_$_b839[554]], { data: Ct });
                  else {
                    _t[_$_b839[649]] = !1, _t[_$_b839[650]] = _t[_$_b839[651]](wt);
                    var Mt = function() {
                      clearTimeout(kt), _t[_$_b839[96]](ye[_$_b839[382]][_$_b839[505]], Mt), _t[_$_b839[96]](ye[_$_b839[382]][_$_b839[507]], Mt), _t[_$_b839[626]] && _t[_$_b839[626]][_$_b839[652]](_t[_$_b839[650]]);
                    }, kt = setTimeout(Mt, 500);
                    _t[_$_b839[75]](ye[_$_b839[382]][_$_b839[505]], Mt), _t[_$_b839[75]](ye[_$_b839[382]][_$_b839[507]], Mt), _t[_$_b839[621]]();
                  }
                }, this[_$_b839[653]] = function() {
                  var It, wt, Ct;
                  _$_b839[654] !== ((Ct = (wt = (It = _t[_$_b839[619]]) === null || It === void 0 ? void 0 : It[_$_b839[655]]) === null || wt === void 0 ? void 0 : wt[_$_b839[656]]) === null || Ct === void 0 ? void 0 : Ct[_$_b839[658]](_$_b839[657])) || _t[_$_b839[619]][_$_b839[659]] || _t[_$_b839[619]][_$_b839[655]][_$_b839[656]][_$_b839[662]](_$_b839[657], _$_b839[660], _$_b839[661]);
                }, this[_$_b839[663]] = function() {
                  _t[_$_b839[619]] && _t[_$_b839[619]][_$_b839[655]] && _t[_$_b839[619]][_$_b839[655]][_$_b839[656]] && _t[_$_b839[619]][_$_b839[655]][_$_b839[656]][_$_b839[662]](_$_b839[657], _$_b839[654], _$_b839[661]);
                }, this[_$_b839[664]] = function() {
                  var It = _t[_$_b839[619]][_$_b839[667]][_$_b839[666]]()[_$_b839[665]];
                  return It ? _t[_$_b839[670]](It, _t[_$_b839[668]](), function(wt) {
                    return _t[_$_b839[669]](wt, !0, !1);
                  }) : Promise[_$_b839[602]]();
                }, this[_$_b839[671]] = function() {
                  var It = _t[_$_b839[619]][_$_b839[667]][_$_b839[666]]()[_$_b839[672]];
                  return It ? _t[_$_b839[670]](It, _t[_$_b839[673]](), _t[_$_b839[640]]) : Promise[_$_b839[602]]();
                }, this[_$_b839[674]] = function() {
                  if (_t[_$_b839[617]](), _t[_$_b839[675]]) {
                    var It = _t[_$_b839[675]][_$_b839[677]]($e[_$_b839[347]][_$_b839[375]] + _$_b839[676])[0];
                    It && (It[_$_b839[656]][_$_b839[657]] = _$_b839[660]);
                  }
                }, this[_$_b839[678]] = function() {
                  if (_t[_$_b839[679]]) {
                    _t[_$_b839[667]][_$_b839[681]]()[_$_b839[215]](_$_b839[680]) && (_t[_$_b839[609]][_$_b839[29]](_t[_$_b839[667]][_$_b839[681]]()[_$_b839[680]]) > -1 ? _t[_$_b839[679]][_$_b839[682]](_t[_$_b839[667]][_$_b839[681]]()[_$_b839[680]]) : _t[_$_b839[280]][_$_b839[38]](_$_b839[683], new he[_$_b839[147]](ce[_$_b839[145]][_$_b839[684]], { "impression-server": _t[_$_b839[667]][_$_b839[681]]()[_$_b839[680]] })));
                    var It = _t[_$_b839[667]][_$_b839[159]](_$_b839[685]);
                    _t[_$_b839[679]][_$_b839[690]](_t[_$_b839[687]]()[_$_b839[686]], _t[_$_b839[688]](), It == null ? void 0 : It[_$_b839[689]])[_$_b839[166]](function() {
                    }, function() {
                    });
                  }
                }, this[_$_b839[691]] = function(It, wt) {
                  if (_t[_$_b839[692]]() && wt[_$_b839[693]] === Ze[_$_b839[695]][_$_b839[694]] && _t[_$_b839[696]]() && _t[_$_b839[698]]()[_$_b839[697]]()) {
                    var Ct = _t[_$_b839[698]]()[_$_b839[699]];
                    _t[_$_b839[700]](Ct);
                  }
                }, this[_$_b839[701]] = function() {
                  _t[_$_b839[696]]() ? _t[_$_b839[698]]()[_$_b839[697]]() ? _t[_$_b839[648]](ye[_$_b839[382]][_$_b839[407]]) : _t[_$_b839[702]] || _t[_$_b839[703]] || setTimeout(function() {
                    _t[_$_b839[703]] = _t[_$_b839[698]]()[_$_b839[705]]()[_$_b839[166]](function() {
                      _t[_$_b839[703]] = null, _t[_$_b839[704]]();
                    });
                  }) : _t[_$_b839[704]]();
                }, this[_$_b839[704]] = function() {
                  _t[_$_b839[679]] && _t[_$_b839[679]][_$_b839[706]](), _t[_$_b839[702]] = !0, _t[_$_b839[648]](ye[_$_b839[382]][_$_b839[407]]);
                }, this[_$_b839[707]] = function() {
                  !(_t[_$_b839[696]]() && _t[_$_b839[708]]() && _t[_$_b839[708]]()[_$_b839[697]]()) && _t[_$_b839[702]] && (_t[_$_b839[702]] = !1), _t[_$_b839[709]] = _t[_$_b839[710]](_t[_$_b839[709]]);
                }, Object[_$_b839[98]]((0, tt[_$_b839[646]])())[_$_b839[26]] || (0, tt[_$_b839[107]])()[_$_b839[138]]((0, Oe[_$_b839[711]])()), this[_$_b839[675]] = He, this[_$_b839[712]] = Ye, this[_$_b839[713]] = ct, this[_$_b839[627]] = !1, this[_$_b839[280]] = new Ee[_$_b839[715]](ke[_$_b839[714]]), this[_$_b839[716]] = new lt[_$_b839[718]]((0, tt[_$_b839[646]])()[_$_b839[717]]), this[_$_b839[667]] = null, this[_$_b839[719]] = NaN, this[_$_b839[720]] = new xe[_$_b839[721]](), this[_$_b839[626]] = new Se[_$_b839[722]](this[_$_b839[280]], this[_$_b839[713]], this[_$_b839[712]]), this[_$_b839[723]] = ue[_$_b839[319]], fe[_$_b839[140]][_$_b839[152]](le[_$_b839[168]][_$_b839[187]])) {
                  var Pt = fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[187]])[_$_b839[724]];
                  this[_$_b839[725]] = new Pt(), this[_$_b839[726]] = fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[187]])[_$_b839[727]](function() {
                    var It;
                    return (It = _t[_$_b839[91]]) === null || It === void 0 ? void 0 : It[_$_b839[635]];
                  }, this[_$_b839[280]]);
                }
                this[_$_b839[728]] = null, this[_$_b839[729]] = !1, this[_$_b839[44]]();
              }
              return rt[_$_b839[37]][_$_b839[730]] = function() {
                return this[_$_b839[91]] && this[_$_b839[91]][_$_b839[731]] && (0, Ke[_$_b839[730]])(this[_$_b839[91]][_$_b839[731]][_$_b839[136]]()[_$_b839[732]]) || !1;
              }, rt[_$_b839[37]][_$_b839[733]] = function() {
                return this[_$_b839[91]] && this[_$_b839[91]][_$_b839[731]] && (0, Ke[_$_b839[733]])(this[_$_b839[91]][_$_b839[731]][_$_b839[136]]()[_$_b839[732]]) || !1;
              }, rt[_$_b839[37]][_$_b839[734]] = function() {
                return !!(this[_$_b839[619]] && this[_$_b839[619]][_$_b839[620]]) && !this[_$_b839[733]]();
              }, rt[_$_b839[37]][_$_b839[641]] = function() {
                return this[_$_b839[735]]() && this[_$_b839[627]];
              }, rt[_$_b839[37]][_$_b839[735]] = function() {
                return this[_$_b839[734]]() && !!this[_$_b839[619]] && !!this[_$_b839[619]][_$_b839[620]];
              }, rt[_$_b839[37]][_$_b839[696]] = function() {
                return !!(this[_$_b839[619]] && this[_$_b839[619]][_$_b839[736]]);
              }, rt[_$_b839[37]][_$_b839[737]] = function() {
                fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[173]]);
                var He = fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[172]]);
                this[_$_b839[619]][_$_b839[736]] = new He[_$_b839[738]](this, this[_$_b839[619]][_$_b839[91]]), this[_$_b839[626]] && this[_$_b839[626]][_$_b839[739]](ye[_$_b839[382]][_$_b839[532]], { name: le[_$_b839[168]][_$_b839[173]] });
              }, rt[_$_b839[37]][_$_b839[698]] = function() {
                return this[_$_b839[696]]() ? this[_$_b839[619]][_$_b839[736]] : null;
              }, rt[_$_b839[37]][_$_b839[740]] = function() {
                var He;
                if (!this[_$_b839[734]]() || !(!((He = this[_$_b839[619]]) === null || He === void 0) && He[_$_b839[659]]))
                  return !1;
                var Ye = this[_$_b839[619]][_$_b839[659]][_$_b839[136]]();
                return !!Ye && _$_b839[73] !== Ye;
              }, rt[_$_b839[37]][_$_b839[741]] = function(He, Ye) {
                if (!He || !Ye)
                  return null;
                var ct;
                if (Ye[_$_b839[742]] === Ne[_$_b839[744]][_$_b839[743]])
                  ct = He[_$_b839[745]];
                else if (Ye[_$_b839[742]] === Ne[_$_b839[744]][_$_b839[746]])
                  ct = He[_$_b839[747]];
                else if (Ye[_$_b839[742]] === Ne[_$_b839[744]][_$_b839[748]])
                  ct = He[_$_b839[749]];
                else if (Ye[_$_b839[742]] === Ne[_$_b839[744]][_$_b839[171]])
                  ct = He[_$_b839[750]];
                else {
                  if (Ye[_$_b839[742]] !== Ne[_$_b839[744]][_$_b839[751]])
                    return null;
                  ct = He[_$_b839[752]];
                }
                return ct ? { type: Ye[_$_b839[742]], url: ct, title: He[_$_b839[753]], description: He[_$_b839[754]], vr: He[_$_b839[644]], config: He } : null;
              }, rt[_$_b839[37]][_$_b839[755]] = function(He) {
                var Ye = new me[_$_b839[756]]();
                return new Ie[_$_b839[763]]({ container: this[_$_b839[675]], eventHandler: this[_$_b839[619]][_$_b839[626]], config: this[_$_b839[619]][_$_b839[667]][_$_b839[159]](), storedConfig: this[_$_b839[716]], videoElement: He || document[_$_b839[758]](_$_b839[757]), settings: this[_$_b839[619]][_$_b839[667]][_$_b839[759]](), logger: this[_$_b839[280]], serviceManager: Ye, internalPlayer: this, segmentInfoService: this[_$_b839[760]], segmentPrefetchingService: this[_$_b839[761]], adRestorationOptimizationService: this[_$_b839[762]] });
              }, rt[_$_b839[37]][_$_b839[764]] = function(He, Ye) {
                var ct = this;
                if (!this[_$_b839[619]])
                  return Promise[_$_b839[602]]();
                var _t = this[_$_b839[619]][_$_b839[667]];
                _t[_$_b839[765]] && _t[_$_b839[765]]()[_$_b839[766]] && this[_$_b839[767]](_t[_$_b839[765]]()[_$_b839[766]]), this[_$_b839[280]][_$_b839[768]](_t);
                var Pt = this[_$_b839[728]];
                this[_$_b839[619]][_$_b839[655]] && (Pt || (Pt = this[_$_b839[619]][_$_b839[655]][_$_b839[769]]()), this[_$_b839[619]][_$_b839[655]][_$_b839[340]]()), this[_$_b839[91]] ? this[_$_b839[91]][_$_b839[655]] = at[_$_b839[771]][_$_b839[770]](this[_$_b839[91]], Pt) : this[_$_b839[91]] = this[_$_b839[755]](Pt);
                var It = { context: this[_$_b839[91]], playerInstance: this[_$_b839[619]], container: this[_$_b839[675]], config: _t, source: He, forceTech: Ye, styleManager: this[_$_b839[629]] };
                return this[_$_b839[772]](), this[_$_b839[720]][_$_b839[784]](It)[_$_b839[166]](function(wt) {
                  var Ct, Mt, kt;
                  return ct[_$_b839[733]]() ? (Ct = wt[_$_b839[620]]) === null || Ct === void 0 ? void 0 : Ct[_$_b839[774]]()[_$_b839[166]](function() {
                    wt[_$_b839[655]] && wt[_$_b839[655]][_$_b839[340]](), wt[_$_b839[620]] = null, wt[_$_b839[773]] = null, wt[_$_b839[655]] = null;
                  }) : (ct[_$_b839[619]][_$_b839[91]] = wt[_$_b839[91]], ct[_$_b839[619]][_$_b839[280]] = wt[_$_b839[280]], ct[_$_b839[619]][_$_b839[620]] = wt[_$_b839[620]], ct[_$_b839[619]][_$_b839[773]] = wt[_$_b839[773]], ct[_$_b839[619]][_$_b839[655]] = wt[_$_b839[655]], ct[_$_b839[619]][_$_b839[775]] = !0, ct[_$_b839[619]][_$_b839[777]][_$_b839[776]] = _$_b839[778], ct[_$_b839[779]](ct[_$_b839[619]][_$_b839[91]]), !ct[_$_b839[780]] && ct[_$_b839[675]] && (ct[_$_b839[780]] = new Ge[_$_b839[782]](ct[_$_b839[619]], ct[_$_b839[675]], (kt = (Mt = ct[_$_b839[626]]) === null || Mt === void 0 ? void 0 : Mt[_$_b839[781]]()) !== null && kt !== void 0 ? kt : function() {
                  }, ct[_$_b839[642]])), ct[_$_b839[783]](), Promise[_$_b839[602]]());
                });
              }, rt[_$_b839[37]][_$_b839[772]] = function() {
                this[_$_b839[785]] && this[_$_b839[785]](), this[_$_b839[786]] && this[_$_b839[786]](), this[_$_b839[785]] = (0, yt[_$_b839[789]])(this[_$_b839[91]][_$_b839[731]])(function(He) {
                  return (0, Ke[_$_b839[788]])((0, Ke[_$_b839[787]])(He));
                }, this[_$_b839[701]], function(He) {
                  return He === !0;
                }), this[_$_b839[786]] = (0, yt[_$_b839[789]])(this[_$_b839[91]][_$_b839[731]])(function(He) {
                  return (0, Ke[_$_b839[790]])((0, Ke[_$_b839[787]])(He));
                }, this[_$_b839[691]], function() {
                  return !0;
                });
              }, rt[_$_b839[37]][_$_b839[779]] = function(He) {
                this[_$_b839[696]]() && this[_$_b839[698]]()[_$_b839[791]](He), He[_$_b839[760]] && He[_$_b839[760]][_$_b839[791]](He), He[_$_b839[761]] && He[_$_b839[761]][_$_b839[791]](He), He[_$_b839[762]] && He[_$_b839[762]][_$_b839[791]](He);
              }, rt[_$_b839[37]][_$_b839[792]] = function(He) {
                var Ye;
                this[_$_b839[641]]() && (He = String(He) || _$_b839[793], (Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[792]](He));
              }, rt[_$_b839[37]][_$_b839[794]] = function(He) {
                var Ye;
                this[_$_b839[641]]() && (He = String(He) || _$_b839[793], (Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[794]](He));
              }, rt[_$_b839[37]][_$_b839[633]] = function() {
                this[_$_b839[619]][_$_b839[91]][_$_b839[635]][_$_b839[797]](be[_$_b839[637]][_$_b839[795]], this[_$_b839[619]][_$_b839[91]][_$_b839[631]][_$_b839[796]]);
              }, rt[_$_b839[37]][_$_b839[624]] = function() {
                this[_$_b839[619]][_$_b839[91]] && this[_$_b839[619]][_$_b839[91]][_$_b839[761]] && this[_$_b839[619]][_$_b839[91]][_$_b839[761]][_$_b839[706]]();
              }, rt[_$_b839[37]][_$_b839[621]] = function(He) {
                var Ye, ct, _t, Pt, It = this;
                return He === void 0 && (He = _$_b839[618]), this[_$_b839[798]] = null, Tt(He) && (this[_$_b839[800]](_e[_$_b839[594]], (ct = (Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 ? void 0 : Ye[_$_b839[799]]()) !== null && ct !== void 0 ? ct : 0), this[_$_b839[800]](_e[_$_b839[596]], (Pt = (_t = this[_$_b839[619]][_$_b839[620]]) === null || _t === void 0 ? void 0 : _t[_$_b839[801]]()) !== null && Pt !== void 0 ? Pt : 0)), this[_$_b839[615]][_$_b839[802]](function() {
                  return It[_$_b839[617]](He);
                });
              }, rt[_$_b839[37]][_$_b839[803]] = function() {
                var He;
                return !!(this[_$_b839[735]]() && vt(this[_$_b839[619]][_$_b839[620]]) && this[_$_b839[804]]()) && !!(!((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0) && He[_$_b839[803]]());
              }, rt[_$_b839[37]][_$_b839[805]] = function() {
                var He;
                this[_$_b839[735]]() && vt(this[_$_b839[619]][_$_b839[620]]) && this[_$_b839[619]][_$_b839[620]][_$_b839[804]]() && ((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 || He[_$_b839[805]]());
              }, rt[_$_b839[37]][_$_b839[804]] = function() {
                return this[_$_b839[735]]() && vt(this[_$_b839[619]][_$_b839[620]]) && this[_$_b839[619]][_$_b839[620]][_$_b839[804]]();
              }, rt[_$_b839[37]][_$_b839[392]] = function(He, Ye) {
                var ct, _t, Pt;
                if (Ye === void 0 && (Ye = _$_b839[618]), this[_$_b839[696]]() && this[_$_b839[698]]()[_$_b839[697]]() || !this[_$_b839[641]]())
                  return !1;
                var It = (ct = this[_$_b839[619]][_$_b839[620]]) === null || ct === void 0 ? void 0 : ct[_$_b839[806]](), wt = this[_$_b839[807]](), Ct = !(wt[_$_b839[240]] === -1 && wt[_$_b839[241]] === -1);
                return !!(!It || It && this[_$_b839[619]][_$_b839[809]][_$_b839[808]]) && (this[_$_b839[810]]() ? (this[_$_b839[729]] = !0, !!(!((_t = this[_$_b839[619]][_$_b839[620]]) === null || _t === void 0) && _t[_$_b839[392]](He, Ye))) : !!Ct && (this[_$_b839[729]] = !0, He = this[_$_b839[811]](He, wt), Tt(Ye) || this[_$_b839[806]]() || (He = Math[_$_b839[247]](He, wt[_$_b839[241]] - this[_$_b839[619]][_$_b839[809]][_$_b839[812]])), !!(!((Pt = this[_$_b839[619]][_$_b839[620]]) === null || Pt === void 0) && Pt[_$_b839[392]](He, Ye))));
              }, rt[_$_b839[37]][_$_b839[810]] = function() {
                return this[_$_b839[688]]()[_$_b839[815]](Ne[_$_b839[814]][_$_b839[813]]);
              }, rt[_$_b839[37]][_$_b839[816]] = function(He, Ye) {
                var ct;
                return !(!this[_$_b839[735]]() || !vt(this[_$_b839[619]][_$_b839[620]])) && ((ct = this[_$_b839[619]][_$_b839[620]]) === null || ct === void 0 ? void 0 : ct[_$_b839[816]](He, Ye));
              }, rt[_$_b839[37]][_$_b839[811]] = function(He, Ye) {
                if (He < Ye[_$_b839[240]] || He > Ye[_$_b839[241]]) {
                  var ct = He;
                  He = Math[_$_b839[248]](He, Ye[_$_b839[240]]), He = Math[_$_b839[247]](He, Ye[_$_b839[241]]), this[_$_b839[280]][_$_b839[265]](_$_b839[817] + Ye[_$_b839[240]] + _$_b839[818] + Ye[_$_b839[241]] + _$_b839[819] + ct + _$_b839[818] + He);
                }
                return He;
              }, rt[_$_b839[37]][_$_b839[820]] = function() {
                var He;
                return this[_$_b839[735]]() ? !!(!((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0) && He[_$_b839[820]]()) : this[_$_b839[619]][_$_b839[402]];
              }, rt[_$_b839[37]][_$_b839[673]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[673]]()) !== null && Ye !== void 0 ? Ye : [];
              }, rt[_$_b839[37]][_$_b839[821]] = function(He) {
                this[_$_b839[629]] ? this[_$_b839[629]][_$_b839[821]](He) : this[_$_b839[280]][_$_b839[265]](_$_b839[822]);
              }, rt[_$_b839[37]][_$_b839[823]] = function(He) {
                var Ye = this[_$_b839[668]]()[_$_b839[824]](function(ct) {
                  return ct[_$_b839[712]] === He;
                });
                Ye && this[_$_b839[648]](ye[_$_b839[382]][_$_b839[536]], { subtitle: ie({}, Ye) });
              }, rt[_$_b839[37]][_$_b839[825]] = function() {
                var He = this, Ye = this[_$_b839[668]]()[_$_b839[112]](function(ct) {
                  return ct[_$_b839[827]];
                })[_$_b839[137]](function(ct) {
                  return He[_$_b839[826]](ct[_$_b839[712]], !1);
                });
                return Promise[_$_b839[167]](Ye);
              }, rt[_$_b839[37]][_$_b839[669]] = function(He, Ye, ct) {
                var _t = this;
                Ye === void 0 && (Ye = !0), ct === void 0 && (ct = !0);
                var Pt = this[_$_b839[668]]()[_$_b839[824]](function(It) {
                  return It[_$_b839[712]] === He;
                });
                return this[_$_b839[641]]() && Pt && !Pt[_$_b839[827]] ? (ct && this[_$_b839[648]](ye[_$_b839[382]][_$_b839[534]], { subtitle: ie({}, Pt) }), Promise[_$_b839[602]]()[_$_b839[166]](function() {
                  return Ye ? _t[_$_b839[825]]() : Promise[_$_b839[167]]([!1]);
                })[_$_b839[166]](function() {
                  var It;
                  return !!(!((It = _t[_$_b839[619]][_$_b839[620]]) === null || It === void 0) && It[_$_b839[669]](He));
                })[_$_b839[166]](function(It) {
                  return It && _t[_$_b839[823]](He), It;
                })) : Promise[_$_b839[602]](!1);
              }, rt[_$_b839[37]][_$_b839[826]] = function(He, Ye) {
                var ct = this;
                if (Ye === void 0 && (Ye = !0), this[_$_b839[641]]()) {
                  var _t = this[_$_b839[668]]()[_$_b839[824]](function(Pt) {
                    return Pt[_$_b839[712]] === He;
                  });
                  if (_t && _t[_$_b839[827]])
                    return Ye && this[_$_b839[648]](ye[_$_b839[382]][_$_b839[538]], { subtitle: ie({}, _t) }), this[_$_b839[619]][_$_b839[620]] ? this[_$_b839[619]][_$_b839[620]][_$_b839[826]](He)[_$_b839[166]](function(Pt) {
                      return Pt && ct[_$_b839[648]](ye[_$_b839[382]][_$_b839[540]], { subtitle: ie(ie({}, _t), { enabled: !1 }) }), Pt;
                    }) : Promise[_$_b839[602]](!1);
                }
                return Promise[_$_b839[602]](!1);
              }, rt[_$_b839[37]][_$_b839[828]] = function() {
                var He, Ye;
                this[_$_b839[641]]() && !this[_$_b839[806]]() && (this[_$_b839[729]] || this[_$_b839[830]](this[_$_b839[619]][_$_b839[829]], !!(!((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0) && He[_$_b839[806]]())), (Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[828]]());
              }, rt[_$_b839[37]][_$_b839[831]] = function(He) {
                var Ye;
                this[_$_b839[619]][_$_b839[402]] = !0, this[_$_b839[735]]() && (this[_$_b839[696]]() && !this[_$_b839[820]]() && this[_$_b839[698]]()[_$_b839[832]](0), this[_$_b839[833]] = this[_$_b839[834]](), (Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[831]](He));
              }, rt[_$_b839[37]][_$_b839[835]] = function(He) {
                var Ye;
                if (this[_$_b839[619]][_$_b839[402]] = !1, this[_$_b839[735]]()) {
                  if (this[_$_b839[696]]() && this[_$_b839[820]]()) {
                    var ct = isNaN(this[_$_b839[833]]) ? 100 : this[_$_b839[833]];
                    this[_$_b839[833]] = NaN, this[_$_b839[698]]()[_$_b839[832]](ct);
                  }
                  (Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[835]](He);
                }
              }, rt[_$_b839[37]][_$_b839[668]] = function() {
                var He, Ye;
                if (!this[_$_b839[641]]())
                  return [];
                var ct = (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[668]]()[_$_b839[137]](function(_t) {
                  return ie({}, _t);
                })) !== null && Ye !== void 0 ? Ye : [];
                return ae([], ct, !0);
              }, rt[_$_b839[37]][_$_b839[259]] = function(He) {
                var Ye, ct;
                return He === void 0 && (He = _$_b839[618]), this[_$_b839[735]]() ? !Tt(He) && this[_$_b839[697]]() ? this[_$_b839[698]]()[_$_b839[259]]() : this[_$_b839[641]]() && (ct = (Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 ? void 0 : Ye[_$_b839[259]]()) !== null && ct !== void 0 ? ct : 0 : 0;
              }, rt[_$_b839[37]][_$_b839[836]] = function(He, Ye) {
                var ct;
                this[_$_b839[619]][_$_b839[837]] = He, this[_$_b839[735]]() && ((ct = this[_$_b839[619]][_$_b839[620]]) === null || ct === void 0 || ct[_$_b839[836]](He, Ye), this[_$_b839[696]]() && this[_$_b839[698]]()[_$_b839[832]](He));
              }, rt[_$_b839[37]][_$_b839[838]] = function(He, Ye) {
                var ct;
                this[_$_b839[641]]() && (He = this[_$_b839[839]](He), (ct = this[_$_b839[619]][_$_b839[620]]) === null || ct === void 0 || ct[_$_b839[838]](He, Ye), this[_$_b839[729]] = !0);
              }, rt[_$_b839[37]][_$_b839[839]] = function(He) {
                var Ye;
                if (He <= 0)
                  return He;
                var ct = (0, Je[_$_b839[276]])(Date[_$_b839[840]]());
                this[_$_b839[810]]() || (ct -= (Ye = this[_$_b839[842]][_$_b839[841]](Ne[_$_b839[271]][_$_b839[270]], Ne[_$_b839[296]][_$_b839[295]])) === null || Ye === void 0 ? void 0 : Ye[_$_b839[281]]);
                var _t = Math[_$_b839[247]](He - ct, 0);
                return this[_$_b839[280]][_$_b839[265]](_$_b839[844][_$_b839[41]](He, _$_b839[843])[_$_b839[41]](_t)), _t;
              }, rt[_$_b839[37]][_$_b839[845]] = function(He) {
                var Ye;
                this[_$_b839[735]]() && ((Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[845]](He));
              }, rt[_$_b839[37]][_$_b839[846]] = function() {
                var He;
                this[_$_b839[735]]() && ((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 || He[_$_b839[846]]());
              }, rt[_$_b839[37]][_$_b839[847]] = function() {
                var He;
                this[_$_b839[735]]() && ((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 || He[_$_b839[847]]());
              }, rt[_$_b839[37]][_$_b839[834]] = function() {
                var He, Ye;
                return this[_$_b839[735]]() ? (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[834]]()) !== null && Ye !== void 0 ? Ye : 0 : this[_$_b839[619]][_$_b839[837]];
              }, rt[_$_b839[37]][_$_b839[848]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[848]]()) !== null && Ye !== void 0 ? Ye : 0;
              }, rt[_$_b839[37]][_$_b839[849]] = function(He) {
                var Ye;
                this[_$_b839[641]]() && (_$_b839[79] != typeof He || He < 0 ? this[_$_b839[853]](_$_b839[850], _$_b839[851][_$_b839[41]](He), _$_b839[852], _$_b839[90][_$_b839[41]](He)) : (Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[849]](He));
              }, rt[_$_b839[37]][_$_b839[854]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() ? (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[854]]()) !== null && Ye !== void 0 ? Ye : 0 : -1;
              }, rt[_$_b839[37]][_$_b839[855]] = function(He) {
                var Ye;
                this[_$_b839[641]]() && ((Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[855]](He));
              }, rt[_$_b839[37]][_$_b839[856]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[856]]()) !== null && Ye !== void 0 ? Ye : null;
              }, rt[_$_b839[37]][_$_b839[857]] = function(He) {
                var Ye;
                this[_$_b839[641]]() && ((Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[857]](He));
              }, rt[_$_b839[37]][_$_b839[858]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[858]]()) !== null && Ye !== void 0 ? Ye : null;
              }, rt[_$_b839[37]][_$_b839[859]] = function(He, Ye) {
                var ct, _t;
                return He === void 0 && (He = _$_b839[618]), Ye === void 0 && (Ye = Ne[_$_b839[278]][_$_b839[860]]), this[_$_b839[697]]() && !Tt(He) ? this[_$_b839[698]]()[_$_b839[859]]() : this[_$_b839[641]]() && (_t = (ct = this[_$_b839[619]][_$_b839[620]]) === null || ct === void 0 ? void 0 : ct[_$_b839[859]](Ye)) !== null && _t !== void 0 ? _t : 0;
              }, rt[_$_b839[37]][_$_b839[861]] = function(He, Ye, ct) {
                var _t;
                if (this[_$_b839[735]]()) {
                  var Pt = Object[_$_b839[98]](Ne[_$_b839[271]])[_$_b839[862]](function(wt) {
                    return He === Ne[_$_b839[271]][wt];
                  }), It = Object[_$_b839[98]](Ne[_$_b839[296]])[_$_b839[862]](function(wt) {
                    return ct === Ne[_$_b839[296]][wt];
                  });
                  Pt ? It ? _$_b839[79] != typeof Ye || Ye < 0 ? this[_$_b839[853]](_$_b839[863], _$_b839[851][_$_b839[41]](Ye), _$_b839[852], _$_b839[90][_$_b839[41]](Ye)) : (_t = this[_$_b839[619]][_$_b839[620]]) === null || _t === void 0 || _t[_$_b839[861]](He, Ye, ct) : this[_$_b839[853]](_$_b839[863], _$_b839[864][_$_b839[41]](ct), _$_b839[865], _$_b839[90][_$_b839[41]](ct)) : this[_$_b839[853]](_$_b839[863], _$_b839[866][_$_b839[41]](He), _$_b839[65], _$_b839[90][_$_b839[41]](He));
                }
              }, rt[_$_b839[37]][_$_b839[269]] = function(He, Ye) {
                var ct, _t, Pt = { level: null, targetLevel: null, type: He, media: Ye };
                return this[_$_b839[735]]() && this[_$_b839[867]](He, Ye) && (_t = (ct = this[_$_b839[619]][_$_b839[620]]) === null || ct === void 0 ? void 0 : ct[_$_b839[269]](He, Ye)) !== null && _t !== void 0 ? _t : Pt;
              }, rt[_$_b839[37]][_$_b839[867]] = function(He, Ye) {
                var ct = Object[_$_b839[98]](Ne[_$_b839[271]])[_$_b839[862]](function(Pt) {
                  return He === Ne[_$_b839[271]][Pt];
                }), _t = Object[_$_b839[98]](Ne[_$_b839[296]])[_$_b839[862]](function(Pt) {
                  return Ye === Ne[_$_b839[296]][Pt];
                });
                return ct && _t;
              }, rt[_$_b839[37]][_$_b839[868]] = function() {
                return this[_$_b839[641]]() ? this[_$_b839[269]](Ne[_$_b839[271]][_$_b839[270]], Ne[_$_b839[296]][_$_b839[301]])[_$_b839[766]] : null;
              }, rt[_$_b839[37]][_$_b839[869]] = function() {
                return this[_$_b839[641]]() ? this[_$_b839[269]](Ne[_$_b839[271]][_$_b839[270]], Ne[_$_b839[296]][_$_b839[295]])[_$_b839[766]] : null;
              }, rt[_$_b839[37]][_$_b839[870]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[870]]()) !== null && Ye !== void 0 ? Ye : 0;
              }, rt[_$_b839[37]][_$_b839[871]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[871]]()) !== null && Ye !== void 0 ? Ye : 0;
              }, rt[_$_b839[37]][_$_b839[872]] = function() {
                var He;
                return this[_$_b839[641]]() && !!(!((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0) && He[_$_b839[872]]());
              }, rt[_$_b839[37]][_$_b839[806]] = function() {
                var He;
                return this[_$_b839[641]]() && !!(!((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0) && He[_$_b839[806]]());
              }, rt[_$_b839[37]][_$_b839[873]] = function() {
                var He;
                return this[_$_b839[641]]() && !!(!((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0) && He[_$_b839[873]]());
              }, rt[_$_b839[37]][_$_b839[874]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[874]]()) !== null && Ye !== void 0 ? Ye : [];
              }, rt[_$_b839[37]][_$_b839[875]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[875]]()) !== null && Ye !== void 0 ? Ye : [];
              }, rt[_$_b839[37]][_$_b839[876]] = function() {
                var He;
                return this[_$_b839[735]]() && !!this[_$_b839[619]][_$_b839[655]] && !!(!((He = this[_$_b839[619]][_$_b839[655]]) === null || He === void 0) && He[_$_b839[876]]());
              }, rt[_$_b839[37]][_$_b839[877]] = function() {
                var He;
                return this[_$_b839[735]]() && !!(!((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0) && He[_$_b839[877]]());
              }, rt[_$_b839[37]][_$_b839[878]] = function() {
                var He;
                return this[_$_b839[735]]() && !!(!((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0) && He[_$_b839[878]]());
              }, rt[_$_b839[37]][_$_b839[879]] = function() {
                var He, Ye, ct = { id: _$_b839[90], bitrate: 0, height: 0, width: 0, isAuto: !0 };
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[879]]()) !== null && Ye !== void 0 ? Ye : ct;
              }, rt[_$_b839[37]][_$_b839[880]] = function() {
                var He, Ye, ct = { id: _$_b839[90], bitrate: 0, isAuto: !0 };
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[880]]()) !== null && Ye !== void 0 ? Ye : ct;
              }, rt[_$_b839[37]][_$_b839[881]] = function() {
                var He, Ye, ct = { id: _$_b839[90], bitrate: 0, height: 0, width: 0, uid: void 0 };
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[881]]()) !== null && Ye !== void 0 ? Ye : ct;
              }, rt[_$_b839[37]][_$_b839[882]] = function() {
                var He, Ye, ct = { id: _$_b839[90], bitrate: 0 };
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[882]]()) !== null && Ye !== void 0 ? Ye : ct;
              }, rt[_$_b839[37]][_$_b839[883]] = function() {
                var He, Ye;
                return (Ye = (He = this[_$_b839[629]]) === null || He === void 0 ? void 0 : He[_$_b839[883]]()) !== null && Ye !== void 0 ? Ye : 0;
              }, rt[_$_b839[37]][_$_b839[884]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[884]]()) !== null && Ye !== void 0 ? Ye : null;
              }, rt[_$_b839[37]][_$_b839[237]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[237]]()) !== null && Ye !== void 0 ? Ye : [];
              }, rt[_$_b839[37]][_$_b839[885]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[885]]()) !== null && Ye !== void 0 ? Ye : {};
              }, rt[_$_b839[37]][_$_b839[886]] = function() {
                var He, Ye, ct = { id: _$_b839[793], bitrate: null };
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[886]]()) !== null && Ye !== void 0 ? Ye : ct;
              }, rt[_$_b839[37]][_$_b839[887]] = function() {
                return this[_$_b839[600]];
              }, rt[_$_b839[37]][_$_b839[799]] = function() {
                var He, Ye;
                return this[_$_b839[888]](_e[_$_b839[594]], !(this[_$_b839[696]]() && this[_$_b839[698]]()[_$_b839[697]]()), this[_$_b839[735]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[799]]()) !== null && Ye !== void 0 ? Ye : 0);
              }, rt[_$_b839[37]][_$_b839[801]] = function() {
                var He, Ye;
                return this[_$_b839[888]](_e[_$_b839[596]], !(this[_$_b839[696]]() && this[_$_b839[698]]()[_$_b839[697]]()), this[_$_b839[735]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[801]]()) !== null && Ye !== void 0 ? Ye : 0);
              }, rt[_$_b839[37]][_$_b839[889]] = function() {
                var He, Ye, ct = { id: _$_b839[793], bitrate: null, width: null, height: null };
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[889]]()) !== null && Ye !== void 0 ? Ye : ct;
              }, rt[_$_b839[37]][_$_b839[890]] = function(He) {
                var Ye = this;
                return new Promise(function(ct) {
                  var _t = !1, Pt = function() {
                    Ye[_$_b839[96]](ye[_$_b839[382]][_$_b839[479]], Pt), _t = !0;
                  }, It = function() {
                    Ye[_$_b839[96]](ye[_$_b839[382]][_$_b839[466]], It), Ye[_$_b839[891]] = null, ct();
                  };
                  Ye[_$_b839[75]](ye[_$_b839[382]][_$_b839[479]], Pt), Ye[_$_b839[75]](ye[_$_b839[382]][_$_b839[466]], It), Ye[_$_b839[619]][_$_b839[91]][_$_b839[635]][_$_b839[159]](be[_$_b839[637]][_$_b839[893]])[_$_b839[892]](!0, He), Ye[_$_b839[698]]()[_$_b839[890]]()[_$_b839[166]](function() {
                    Ye[_$_b839[891]] = null, Ye[_$_b839[894]]() || _t ? ct() : ct(Ye[_$_b839[386]](He));
                  });
                });
              }, rt[_$_b839[37]][_$_b839[692]] = function() {
                var He = (0, Ke[_$_b839[790]])(this[_$_b839[91]][_$_b839[731]][_$_b839[136]]()[_$_b839[732]]);
                return He[_$_b839[895]] === Ze[_$_b839[897]][_$_b839[896]] && He[_$_b839[693]] !== Ze[_$_b839[695]][_$_b839[694]];
              }, rt[_$_b839[37]][_$_b839[898]] = function() {
                return this[_$_b839[696]]() && !this[_$_b839[698]]()[_$_b839[899]]() && !this[_$_b839[900]]();
              }, rt[_$_b839[37]][_$_b839[901]] = function() {
                if (this[_$_b839[803]]())
                  return !1;
                var He = this[_$_b839[723]] === ue[_$_b839[319]], Ye = this[_$_b839[723]] === ue[_$_b839[592]];
                return He || !this[_$_b839[820]]() && Ye;
              }, rt[_$_b839[37]][_$_b839[902]] = function() {
                var He = this;
                this[_$_b839[619]][_$_b839[659]] && this[_$_b839[619]][_$_b839[659]][_$_b839[906]]()[_$_b839[166]](function() {
                  return He[_$_b839[280]][_$_b839[265]](_$_b839[905]);
                })[_$_b839[904]](function() {
                  return He[_$_b839[280]][_$_b839[265]](_$_b839[903]);
                });
              }, rt[_$_b839[37]][_$_b839[386]] = function(He) {
                var Ye = this;
                return He === void 0 && (He = _$_b839[618]), this[_$_b839[907]](He) ? this[_$_b839[891]] ? this[_$_b839[891]][_$_b839[166]](function() {
                  return Ye[_$_b839[698]]()[_$_b839[386]]();
                }) : this[_$_b839[698]]()[_$_b839[386]]() : this[_$_b839[641]]() ? this[_$_b839[898]]() && !this[_$_b839[692]]() ? this[_$_b839[891]] = this[_$_b839[890]](He) : (!this[_$_b839[729]] && this[_$_b839[830]](this[_$_b839[619]][_$_b839[829]], this[_$_b839[806]]()), this[_$_b839[902]](), this[_$_b839[619]][_$_b839[620]] ? this[_$_b839[619]][_$_b839[620]][_$_b839[386]](He)[_$_b839[166]](function() {
                  Ye[_$_b839[723]] = Ye[_$_b839[710]](Ye[_$_b839[723]]), Ye[_$_b839[915]](Ye[_$_b839[619]][_$_b839[914]]);
                })[_$_b839[904]](function(ct) {
                  var _t;
                  return Ye[_$_b839[280]][_$_b839[265]](_$_b839[908], ct), Ye[_$_b839[901]]() && (Ye[_$_b839[648]](ye[_$_b839[382]][_$_b839[410]], new ge[_$_b839[225]](ve[_$_b839[226]][_$_b839[909]])), Ye[_$_b839[803]]() || Ye[_$_b839[910]](), ct instanceof Error && _$_b839[911] === ct[_$_b839[62]] && ((_t = Ye[_$_b839[619]][_$_b839[91]][_$_b839[635]][_$_b839[159]](be[_$_b839[637]][_$_b839[893]])) === null || _t === void 0 || _t[_$_b839[912]](!0, He))), Promise[_$_b839[913]](ct);
                }) : Promise[_$_b839[913]](_$_b839[916])) : Promise[_$_b839[913]](new he[_$_b839[147]](ce[_$_b839[145]][_$_b839[917]], void 0, _$_b839[918]));
              }, rt[_$_b839[37]][_$_b839[907]] = function(He) {
                if (Tt(He))
                  return !1;
                var Ye = !!this[_$_b839[891]];
                return this[_$_b839[697]]() || Ye;
              }, rt[_$_b839[37]][_$_b839[697]] = function() {
                return !!this[_$_b839[696]]() && this[_$_b839[698]]()[_$_b839[697]]();
              }, rt[_$_b839[37]][_$_b839[910]] = function(He) {
                var Ye, ct = this;
                He === void 0 && (He = _$_b839[618]), this[_$_b839[907]](He) ? this[_$_b839[891]] ? this[_$_b839[891]][_$_b839[166]](function() {
                  return ct[_$_b839[698]]()[_$_b839[910]]();
                }) : this[_$_b839[698]]()[_$_b839[910]]() : this[_$_b839[641]]() && ((Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[910]](He));
              }, rt[_$_b839[37]][_$_b839[919]] = function() {
                var He;
                this[_$_b839[735]]() && vt(this[_$_b839[619]][_$_b839[620]]) && ((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 || He[_$_b839[919]]());
              }, rt[_$_b839[37]][_$_b839[767]] = function(He) {
                this[_$_b839[280]][_$_b839[767]](He);
              }, rt[_$_b839[37]][_$_b839[920]] = function() {
                return this[_$_b839[280]];
              }, rt[_$_b839[37]][_$_b839[921]] = function(He, Ye, ct) {
                var _t;
                this[_$_b839[619]] && this[_$_b839[619]][_$_b839[626]] ? _t = this[_$_b839[619]][_$_b839[626]] : this[_$_b839[626]] && (_t = this[_$_b839[626]]), _t[_$_b839[75]](He, Ye, ct);
              }, rt[_$_b839[37]][_$_b839[922]] = function(He, Ye) {
                this[_$_b839[921]](He, Ye, !0);
              }, rt[_$_b839[37]][_$_b839[75]] = function(He, Ye) {
                this[_$_b839[921]](He, Ye, !1);
              }, rt[_$_b839[37]][_$_b839[96]] = function(He, Ye) {
                this[_$_b839[619]] && this[_$_b839[619]][_$_b839[626]] ? this[_$_b839[619]][_$_b839[626]][_$_b839[96]](He, Ye) : this[_$_b839[626]] && this[_$_b839[626]][_$_b839[96]](He, Ye);
              }, rt[_$_b839[37]][_$_b839[923]] = function(He) {
                var Ye;
                return { context: null, logger: this[_$_b839[280]], container: this[_$_b839[675]], bitdashPlayer: null, eventHandler: this[_$_b839[626]], videoElement: null, adController: null, vrHandler: null, hasInitStarted: !1, technology: { player: Ne[_$_b839[814]][_$_b839[924]], streaming: Ne[_$_b839[744]][_$_b839[924]] }, playerConfig: null, configuration: null, settings: null, source: null, volume: (Ye = He[_$_b839[666]]()[_$_b839[837]]) !== null && Ye !== void 0 ? Ye : 100, muted: He[_$_b839[666]]()[_$_b839[402]] || !1, playbackSpeed: 1 };
              }, rt[_$_b839[37]][_$_b839[925]] = function() {
                try {
                  for (var He = 10, Ye = 0; this[_$_b839[675]][_$_b839[677]]($e[_$_b839[347]][_$_b839[375]] + _$_b839[73])[_$_b839[26]] > 0 && (this[_$_b839[675]][_$_b839[926]](this[_$_b839[675]][_$_b839[677]]($e[_$_b839[347]][_$_b839[375]] + _$_b839[73])[0]), !(++Ye > He)); )
                    ;
                } catch {
                  this[_$_b839[280]][_$_b839[265]](_$_b839[927]);
                }
              }, rt[_$_b839[37]][_$_b839[928]] = function(He) {
                if (!this[_$_b839[619]][_$_b839[777]][_$_b839[929]]) {
                  var Ye, ct = this[_$_b839[667]][_$_b839[931]]()[_$_b839[930]], _t = this[_$_b839[667]][_$_b839[681]]();
                  (ct || ct === 0) && !isNaN(ct) && ct >= 0 && (Ye = ct);
                  var Pt = this[_$_b839[603]][0];
                  _t[_$_b839[932]] && (this[_$_b839[603]][_$_b839[815]](_t[_$_b839[932]]) ? Pt = _t[_$_b839[932]] : this[_$_b839[280]][_$_b839[38]](_$_b839[933], new he[_$_b839[147]](ce[_$_b839[145]][_$_b839[934]], { "license-server": _t[_$_b839[932]] }))), this[_$_b839[935]] = Te[_$_b839[936]][_$_b839[784]](this[_$_b839[280]], Pt, He[_$_b839[686]]), this[_$_b839[935]][_$_b839[937]](Ye);
                  var It = this[_$_b839[667]][_$_b839[159]](_$_b839[685]);
                  this[_$_b839[935]][_$_b839[690]](this[_$_b839[647]], It == null ? void 0 : It[_$_b839[689]]);
                }
              }, rt[_$_b839[37]][_$_b839[938]] = function(He) {
                var Ye, ct;
                this[_$_b839[667]] = new se[_$_b839[939]](He), this[_$_b839[716]][_$_b839[942]](!!(!((Ye = He[_$_b839[940]]) === null || Ye === void 0) && Ye[_$_b839[941]])), this[_$_b839[619]] = this[_$_b839[619]] || this[_$_b839[923]](this[_$_b839[667]]), this[_$_b839[619]][_$_b839[667]] = this[_$_b839[667]], this[_$_b839[619]][_$_b839[809]] = this[_$_b839[667]][_$_b839[759]](), this[_$_b839[280]][_$_b839[943]](this[_$_b839[619]][_$_b839[809]]), this[_$_b839[280]][_$_b839[767]](this[_$_b839[667]][_$_b839[159]](_$_b839[765])[_$_b839[766]]), (ct = this[_$_b839[626]]) === null || ct === void 0 || ct[_$_b839[945]](this[_$_b839[667]][_$_b839[159]](_$_b839[944])), this[_$_b839[280]][_$_b839[768]](this[_$_b839[667]]);
                var _t = this[_$_b839[667]][_$_b839[681]]()[_$_b839[946]];
                if (_t && this[_$_b839[767]](_t), this[_$_b839[667]][_$_b839[681]]()[_$_b839[947]] && (0, Ae[_$_b839[948]])(this[_$_b839[280]]), fe[_$_b839[140]][_$_b839[152]](le[_$_b839[168]][_$_b839[170]]) && fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[170]])[_$_b839[949]](this[_$_b839[280]]), this[_$_b839[667]][_$_b839[159]](_$_b839[765])[_$_b839[950]] && (this[_$_b839[280]][_$_b839[954]](_$_b839[951], _$_b839[952], _$_b839[953]), this[_$_b839[280]][_$_b839[954]](_$_b839[955] + $e[_$_b839[347]][_$_b839[373]], _$_b839[956], _$_b839[957])), (0, oe[_$_b839[958]])(this[_$_b839[667]]), this[_$_b839[619]][_$_b839[777]] = { isAdPlayer: !1, prefix: _$_b839[90], visibility: _$_b839[778] }, this[_$_b839[675]] && (this[_$_b839[675]][_$_b839[732]] = this[_$_b839[713]], this[_$_b839[925]]()), this[_$_b839[928]](He), fe[_$_b839[140]][_$_b839[152]](le[_$_b839[168]][_$_b839[197]])) {
                  var Pt = fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[197]])[_$_b839[959]];
                  this[_$_b839[629]] = new Pt(this, this[_$_b839[619]]);
                }
                fe[_$_b839[140]][_$_b839[162]](this[_$_b839[713]]);
              }, rt[_$_b839[37]][_$_b839[960]] = function() {
                this[_$_b839[961]](), this[_$_b839[962]]();
              }, rt[_$_b839[37]][_$_b839[163]] = function(He) {
                if (!$e[_$_b839[347]][_$_b839[352]]())
                  throw new he[_$_b839[147]](ce[_$_b839[145]][_$_b839[963]], void 0, _$_b839[964]);
                return this[_$_b839[938]](He);
              }, rt[_$_b839[37]][_$_b839[965]] = function(He) {
                var Ye, ct = this, _t = ie(ie({}, He), { kind: (He == null ? void 0 : He[_$_b839[966]]) || _$_b839[967], id: (He == null ? void 0 : He[_$_b839[712]]) != null ? String(He == null ? void 0 : He[_$_b839[712]]) : void 0, label: (He == null ? void 0 : He[_$_b839[968]]) || (He == null ? void 0 : He[_$_b839[969]]), isSideloaded: !0 });
                if (it(_t)) {
                  if (this[_$_b839[641]]() && !_t[_$_b839[970]]) {
                    var Pt = _t[_$_b839[827]] || !1;
                    _t[_$_b839[827]] = !1, (Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[965]](_t)[_$_b839[166]](function() {
                      Pt && ct[_$_b839[669]](_t[_$_b839[712]], !1, !1);
                    })[_$_b839[904]](function() {
                      return function() {
                      };
                    });
                  }
                } else
                  this[_$_b839[648]](ye[_$_b839[382]][_$_b839[410]], new ge[_$_b839[225]](ve[_$_b839[226]][_$_b839[971]], _$_b839[973][_$_b839[41]](JSON[_$_b839[282]](He), _$_b839[972]), { method: _$_b839[974], parameter: _$_b839[975], argument: He }));
              }, rt[_$_b839[37]][_$_b839[976]] = function(He) {
                var Ye;
                this[_$_b839[641]]() && ((Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[976]](He));
              }, rt[_$_b839[37]][_$_b839[977]] = function() {
                return this[_$_b839[675]];
              }, rt[_$_b839[37]][_$_b839[978]] = function(He) {
                return !(!this[_$_b839[734]]() || !this[_$_b839[740]]() || _$_b839[979] != typeof He) && this[_$_b839[619]][_$_b839[659]][_$_b839[980]](He);
              }, rt[_$_b839[37]][_$_b839[981]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[773]]) === null || He === void 0 ? void 0 : He[_$_b839[742]]) !== null && Ye !== void 0 ? Ye : Ne[_$_b839[744]][_$_b839[924]];
              }, rt[_$_b839[37]][_$_b839[688]] = function() {
                var He, Ye;
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[773]]) === null || He === void 0 ? void 0 : He[_$_b839[732]]) !== null && Ye !== void 0 ? Ye : Ne[_$_b839[814]][_$_b839[924]];
              }, rt[_$_b839[37]][_$_b839[982]] = function(He) {
                switch (He) {
                  case Ne[_$_b839[985]][_$_b839[984]]:
                    return ae([], (0, tt[_$_b839[646]])()[_$_b839[983]], !0);
                  case Ne[_$_b839[985]][_$_b839[987]]:
                    return ae([], (0, tt[_$_b839[646]])()[_$_b839[986]], !0);
                  case Ne[_$_b839[985]][_$_b839[989]]:
                    return ae([], (0, tt[_$_b839[646]])()[_$_b839[988]], !0);
                  default:
                    return this[_$_b839[648]](ye[_$_b839[382]][_$_b839[410]], new ge[_$_b839[225]](ve[_$_b839[226]][_$_b839[971]], _$_b839[991][_$_b839[41]](He, _$_b839[990]), { method: _$_b839[982], parameter: _$_b839[992], argument: _$_b839[90][_$_b839[41]](He) })), [];
                }
              }, rt[_$_b839[37]][_$_b839[993]] = function() {
                return this[_$_b839[740]]() ? this[_$_b839[619]][_$_b839[659]] : null;
              }, rt[_$_b839[37]][_$_b839[708]] = function() {
                return this[_$_b839[734]]() && this[_$_b839[696]]() ? this[_$_b839[619]][_$_b839[736]][_$_b839[699]] : (this[_$_b839[687]]()[_$_b839[994]] == null || fe[_$_b839[140]][_$_b839[152]](le[_$_b839[168]][_$_b839[173]]) || this[_$_b839[280]][_$_b839[38]](_$_b839[995]), null);
              }, rt[_$_b839[37]][_$_b839[996]] = function(He) {
                if (_$_b839[109] == typeof He)
                  try {
                    He = JSON[_$_b839[283]](He);
                  } catch (Ye) {
                    this[_$_b839[280]][_$_b839[998]](_$_b839[997] + Ye[_$_b839[89]]);
                  }
                return He && _$_b839[33] == typeof He ? He : null;
              }, rt[_$_b839[37]][_$_b839[999]] = function(He) {
                var Ye;
                He === void 0 && (He = !1), this[_$_b839[619]] && this[_$_b839[675]] && ((Ye = this[_$_b839[619]][_$_b839[777]] && this[_$_b839[619]][_$_b839[777]][_$_b839[215]](_$_b839[1e3]) ? document[_$_b839[1002]]($e[_$_b839[347]][_$_b839[375]] + _$_b839[90] + this[_$_b839[619]][_$_b839[777]][_$_b839[1e3]] + _$_b839[1001]) : document[_$_b839[1002]]($e[_$_b839[347]][_$_b839[375]] + _$_b839[1001])) && Ye[_$_b839[1003]] && Ye[_$_b839[1003]][_$_b839[926]](Ye), this[_$_b839[675]] && He && delete this[_$_b839[675]][_$_b839[732]]);
              }, rt[_$_b839[37]][_$_b839[1004]] = function(He) {
                var Ye = !1, ct = null;
                He && (He[_$_b839[215]](_$_b839[1005]) && He[_$_b839[1005]] && He[_$_b839[1005]][_$_b839[215]](_$_b839[1006]) && (Ye = He[_$_b839[1005]][_$_b839[1006]]), ct = He[_$_b839[676]]), this[_$_b839[1007]](ct, Ye);
              }, rt[_$_b839[37]][_$_b839[1008]] = function(He) {
                if (He)
                  return [_$_b839[745], _$_b839[747], _$_b839[749], _$_b839[750], _$_b839[752], _$_b839[676], _$_b839[1009], _$_b839[753], _$_b839[754], _$_b839[1005], _$_b839[1010], _$_b839[1011], _$_b839[644]][_$_b839[113]](function(Ye) {
                    He[_$_b839[215]](Ye) && !He[Ye] && delete He[Ye];
                  }), He;
              }, rt[_$_b839[37]][_$_b839[1012]] = function(He) {
                var Ye, ct = He[_$_b839[644]], _t = (0, tt[_$_b839[646]])(), Pt = !!ct, It = _t[Be[_$_b839[1013]][_$_b839[645]]];
                if (Pt && It) {
                  var wt = _t[Be[_$_b839[1013]][_$_b839[1014]]];
                  ct[_$_b839[1015]] = wt, !((Ye = this[_$_b839[780]]) === null || Ye === void 0) && Ye[_$_b839[1016]]() && this[_$_b839[1019]](Ne[_$_b839[1018]][_$_b839[1017]]), wt && (ct[_$_b839[1020]] = We[_$_b839[1022]][_$_b839[1021]](), this[_$_b839[675]][_$_b839[1023]](ct[_$_b839[1020]][_$_b839[769]]()));
                }
              }, rt[_$_b839[37]][_$_b839[1024]] = function(He, Ye, ct) {
                var _t, Pt = ht(this[_$_b839[667]], He, Ye[_$_b839[1025]]);
                return this[_$_b839[619]][_$_b839[829]] = He, this[_$_b839[619]][_$_b839[1026]] = Ye, ((_t = this[_$_b839[619]][_$_b839[773]]) === null || _t === void 0 ? void 0 : _t[_$_b839[732]]) === Pt[_$_b839[732]] ? (this[_$_b839[619]][_$_b839[773]] = Pt, Promise[_$_b839[602]]()) : this[_$_b839[1027]](He, Pt, ct);
              }, rt[_$_b839[37]][_$_b839[1027]] = function(He, Ye, ct) {
                var _t = this, Pt = function() {
                  var It;
                  _t[_$_b839[733]]() || ((It = _t[_$_b839[626]]) === null || It === void 0 || It[_$_b839[96]](ye[_$_b839[382]][_$_b839[409]], Pt), _t[_$_b839[1004]](He));
                };
                return this[_$_b839[922]](ye[_$_b839[382]][_$_b839[409]], Pt), this[_$_b839[619]][_$_b839[659]] = null, this[_$_b839[1029]](ct)[_$_b839[166]](function() {
                  return _t[_$_b839[764]](He, Ye);
                })[_$_b839[166]](function() {
                  return _t[_$_b839[1012]](He);
                })[_$_b839[904]](function(It) {
                  return It && It[_$_b839[215]](_$_b839[1028]) && It[_$_b839[215]](_$_b839[89]) && _t[_$_b839[626]] ? _t[_$_b839[626]][_$_b839[652]](It) : It && _t[_$_b839[280]][_$_b839[73]](It), Promise[_$_b839[913]](It);
                });
              }, rt[_$_b839[37]][_$_b839[1029]] = function(He) {
                var Ye = this;
                return this[_$_b839[619]] && this[_$_b839[619]][_$_b839[620]] ? this[_$_b839[619]][_$_b839[620]][_$_b839[774]](He)[_$_b839[166]](function() {
                  Ye[_$_b839[619]][_$_b839[620]] = null, Ye[_$_b839[999]]();
                })[_$_b839[904]](function(ct) {
                  return Ye[_$_b839[280]][_$_b839[73]](_$_b839[1030][_$_b839[41]](ct));
                }) : Promise[_$_b839[602]]();
              }, rt[_$_b839[37]][_$_b839[1031]] = function(He, Ye, ct) {
                return Ye === we[_$_b839[1032]] && He[_$_b839[1033]]() ? He[_$_b839[1034]]() : He[_$_b839[1035]]() ? void 0 : He[_$_b839[1036]](ct);
              }, rt[_$_b839[37]][_$_b839[1037]] = function(He, Ye, ct) {
                var _t = this, Pt = ht(this[_$_b839[667]], He, Ye[_$_b839[1025]]), It = this[_$_b839[741]](He, Pt);
                return this[_$_b839[619]][_$_b839[620]] && It ? this[_$_b839[619]][_$_b839[620]][_$_b839[1040]](It, Ye[_$_b839[1039]])[_$_b839[166]](function() {
                  He[_$_b839[1009]] && _t[_$_b839[91]][_$_b839[635]][_$_b839[639]](be[_$_b839[637]][_$_b839[636]], function(wt) {
                    return _t[_$_b839[1031]](wt, ct, He[_$_b839[1009]]);
                  });
                })[_$_b839[904]](function(wt) {
                  return wt && wt[_$_b839[1028]] && wt[_$_b839[89]] && _t[_$_b839[626]] ? _t[_$_b839[626]][_$_b839[652]](wt) : wt && _t[_$_b839[280]][_$_b839[265]](_$_b839[1038], wt), Promise[_$_b839[913]](wt);
                }) : Promise[_$_b839[913]](_$_b839[1041]);
              }, rt[_$_b839[37]][_$_b839[1042]] = function(He) {
                return !!this[_$_b839[798]] && (this[_$_b839[798]][_$_b839[913]](He), this[_$_b839[798]] = null, !0);
              }, rt[_$_b839[37]][_$_b839[1043]] = function(He) {
                this[_$_b839[619]][_$_b839[620]] && He[_$_b839[1045]](be[_$_b839[637]][_$_b839[1044]], new Re[_$_b839[1044]](this[_$_b839[619]][_$_b839[620]])), He[_$_b839[1045]](be[_$_b839[637]][_$_b839[1046]], new Me[_$_b839[1046]](this[_$_b839[619]][_$_b839[91]])), He[_$_b839[1045]](be[_$_b839[637]][_$_b839[1047]], new De[_$_b839[1047]](this[_$_b839[619]][_$_b839[91]])), He[_$_b839[1045]](be[_$_b839[637]][_$_b839[1048]], mt(this[_$_b839[619]][_$_b839[91]])), He[_$_b839[1045]](be[_$_b839[637]][_$_b839[893]], new Ue[_$_b839[893]](this[_$_b839[619]][_$_b839[91]]));
              }, rt[_$_b839[37]][_$_b839[1040]] = function(He, Ye, ct, _t) {
                var Pt = this;
                ct === void 0 && (ct = !1), _t === void 0 && (_t = _$_b839[618]);
                var It = _t === we[_$_b839[1032]];
                Tt(_t) || (this[_$_b839[729]] = !1, this[_$_b839[709]] = ue[_$_b839[319]], this[_$_b839[702]] = !1);
                var wt = this[_$_b839[798]] = new ft[_$_b839[1049]]();
                return this[_$_b839[615]] = this[_$_b839[615]][_$_b839[166]](function() {
                  return Pt[_$_b839[1051]](He, { forceTechnology: Ye, disableSeeking: ct }, _t);
                })[_$_b839[904]](function(Ct) {
                  return Pt[_$_b839[1050]](wt, Ct);
                }), this[_$_b839[616]] = this[_$_b839[616]][_$_b839[166]](function() {
                  return Pt[_$_b839[615]];
                })[_$_b839[166]](function() {
                  return Pt[_$_b839[1055]]();
                })[_$_b839[166]](function() {
                  return st(wt, Pt[_$_b839[798]]);
                })[_$_b839[166]](function() {
                  return et(Pt[_$_b839[619]], He, It);
                })[_$_b839[166]](function() {
                  return Pt[_$_b839[1043]](Pt[_$_b839[619]][_$_b839[91]][_$_b839[635]]);
                })[_$_b839[166]](function() {
                  return Pt[_$_b839[1054]](He, { forceTechnology: Ye, disableSeeking: ct }, _t);
                })[_$_b839[166]](function() {
                  var Ct, Mt, kt;
                  return (Ct = (0, ze[_$_b839[1052]])(Pt[_$_b839[91]])) === null || Ct === void 0 ? void 0 : Ct[_$_b839[138]]((0, Qe[_$_b839[1053]])((kt = (Mt = Pt[_$_b839[619]][_$_b839[655]]) === null || Mt === void 0 ? void 0 : Mt[_$_b839[368]]) !== null && kt !== void 0 ? kt : _$_b839[90]));
                })[_$_b839[166]](wt[_$_b839[602]])[_$_b839[904]](function(Ct) {
                  return Pt[_$_b839[1050]](wt, Ct);
                }), wt[_$_b839[1056]];
              }, rt[_$_b839[37]][_$_b839[1051]] = function(He, Ye, ct) {
                var _t, Pt = this;
                return (_t = this[_$_b839[626]]) === null || _t === void 0 || _t[_$_b839[1057]](), this[_$_b839[617]](ct)[_$_b839[166]](function() {
                  return Pt[_$_b839[1058]](He), Pt[_$_b839[1059]](He, Ye[_$_b839[1025]]), Pt[_$_b839[1060]](He), Pt[_$_b839[1004]](He), Pt[_$_b839[1024]](Pt[_$_b839[996]](He), Ye, ct);
                });
              }, rt[_$_b839[37]][_$_b839[1060]] = function(He) {
                He[_$_b839[215]](_$_b839[644]) && (0, tt[_$_b839[646]])()[_$_b839[645]] && (0, tt[_$_b839[646]])()[_$_b839[1014]] && (He[_$_b839[644]][_$_b839[1020]] = We[_$_b839[1022]][_$_b839[1021]](), He[_$_b839[644]][_$_b839[1015]] = !0), He[_$_b839[215]](_$_b839[644]) && He[_$_b839[644]][_$_b839[1020]] && this[_$_b839[675]][_$_b839[1023]](He[_$_b839[644]][_$_b839[1020]][_$_b839[769]]());
              }, rt[_$_b839[37]][_$_b839[1061]] = function(He) {
                if (fe[_$_b839[140]][_$_b839[152]](le[_$_b839[168]][_$_b839[187]]) && He[_$_b839[1009]] && !this[_$_b839[91]][_$_b839[635]][_$_b839[152]](be[_$_b839[637]][_$_b839[636]])) {
                  var Ye = fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[187]])[_$_b839[636]];
                  this[_$_b839[91]][_$_b839[635]][_$_b839[1045]](be[_$_b839[637]][_$_b839[636]], new Ye(this[_$_b839[91]]));
                }
              }, rt[_$_b839[37]][_$_b839[1062]] = function() {
                var He, Ye = this[_$_b839[91]][_$_b839[631]][_$_b839[796]];
                this[_$_b839[91]][_$_b839[635]][_$_b839[152]](be[_$_b839[637]][_$_b839[1063]], Ye) && this[_$_b839[806]]() && this[_$_b839[619]][_$_b839[773]] !== null && this[_$_b839[619]][_$_b839[773]] !== void 0 && this[_$_b839[619]][_$_b839[773]][_$_b839[742]] !== Ne[_$_b839[744]][_$_b839[746]] && ((He = this[_$_b839[91]][_$_b839[635]][_$_b839[159]](be[_$_b839[637]][_$_b839[1063]], Ye)) === null || He === void 0 || He[_$_b839[1064]](), this[_$_b839[91]][_$_b839[635]][_$_b839[1045]](be[_$_b839[637]][_$_b839[1063]], void 0, Ye));
              }, rt[_$_b839[37]][_$_b839[1065]] = function(He) {
                var Ye = this[_$_b839[91]][_$_b839[635]][_$_b839[159]](be[_$_b839[637]][_$_b839[636]]);
                return He && He[_$_b839[1009]] && Ye ? Ye[_$_b839[1066]](He[_$_b839[1009]]) : Promise[_$_b839[602]]();
              }, rt[_$_b839[37]][_$_b839[1054]] = function(He, Ye, ct) {
                var _t = this, Pt = this[_$_b839[91]][_$_b839[631]][_$_b839[796]];
                return this[_$_b839[91]][_$_b839[635]][_$_b839[639]](be[_$_b839[637]][_$_b839[795]], function(It) {
                  return It[_$_b839[138]]((0, nt[_$_b839[1067]])());
                }, null, Pt), this[_$_b839[1068]](ct, Pt), this[_$_b839[1069]](ct, Pt), this[_$_b839[1061]](He), this[_$_b839[725]] && this[_$_b839[91]][_$_b839[635]][_$_b839[1045]](be[_$_b839[637]][_$_b839[1070]], this[_$_b839[725]]), this[_$_b839[1074]]()[_$_b839[166]](function() {
                  return _t[_$_b839[1065]](He);
                })[_$_b839[166]](function() {
                  return _t[_$_b839[1037]](He, Ye, ct);
                })[_$_b839[166]](function() {
                  return _t[_$_b839[960]](), _t[_$_b839[1072]](He[_$_b839[1071]]), St(He, _t[_$_b839[619]][_$_b839[91]][_$_b839[635]]), _t[_$_b839[1073]](He, ct);
                })[_$_b839[166]](function() {
                  _t[_$_b839[1062]](), _t[_$_b839[648]](ye[_$_b839[382]][_$_b839[505]]);
                });
              }, rt[_$_b839[37]][_$_b839[1074]] = function() {
                return this[_$_b839[619]][_$_b839[620]] ? this[_$_b839[619]][_$_b839[620]][_$_b839[1075]]() : Promise[_$_b839[913]](_$_b839[1041]);
              }, rt[_$_b839[37]][_$_b839[1069]] = function(He, Ye) {
                !Tt(He) && this[_$_b839[91]] && (this[_$_b839[91]][_$_b839[635]][_$_b839[639]](be[_$_b839[637]][_$_b839[795]], function(ct) {
                  return ct[_$_b839[138]]((0, je[_$_b839[1076]])());
                }, null, Ye), this[_$_b839[91]][_$_b839[635]][_$_b839[152]](be[_$_b839[637]][_$_b839[1063]], Ye) || (this[_$_b839[91]][_$_b839[635]][_$_b839[1045]](be[_$_b839[637]][_$_b839[1063]], this[_$_b839[1077]], Ye), this[_$_b839[91]][_$_b839[635]][_$_b839[639]](be[_$_b839[637]][_$_b839[1063]], function(ct) {
                  return ct[_$_b839[1064]]();
                }, null, Ye)));
              }, rt[_$_b839[37]][_$_b839[1073]] = function(He, Ye) {
                var ct, _t;
                return this[_$_b839[1078]](), Tt(Ye) ? (this[_$_b839[619]][_$_b839[91]][_$_b839[635]][_$_b839[159]](be[_$_b839[637]][_$_b839[893]])[_$_b839[892]](!1, Ye), Promise[_$_b839[602]]()) : (this[_$_b839[679]] && this[_$_b839[679]][_$_b839[706]](), this[_$_b839[599]] = He, this[_$_b839[600]] = (_t = (ct = this[_$_b839[619]][_$_b839[620]]) === null || ct === void 0 ? void 0 : ct[_$_b839[887]]()) !== null && _t !== void 0 ? _t : _$_b839[90], this[_$_b839[1079]]());
              }, rt[_$_b839[37]][_$_b839[1050]] = function(He, Ye) {
                this[_$_b839[96]](ye[_$_b839[382]][_$_b839[409]], this[_$_b839[674]]), He[_$_b839[913]](Ye);
              }, rt[_$_b839[37]][_$_b839[622]] = function() {
                var He = this;
                if (!this[_$_b839[696]]())
                  return Promise[_$_b839[602]]();
                var Ye = this[_$_b839[698]](), ct = Ye[_$_b839[697]]() || !!this[_$_b839[891]], _t = !this[_$_b839[627]] && ct;
                return Ye[_$_b839[706]]()[_$_b839[166]](function() {
                  He[_$_b839[891]] = null, _t && He[_$_b839[648]](ye[_$_b839[382]][_$_b839[507]]);
                });
              }, rt[_$_b839[37]][_$_b839[1058]] = function(He) {
                this[_$_b839[733]]() && this[_$_b839[1082]](ce[_$_b839[145]][_$_b839[1080]], _$_b839[1081]);
                var Ye = this[_$_b839[1008]](He), ct = Object[_$_b839[1083]](Ne[_$_b839[744]])[_$_b839[112]](function(_t) {
                  return _t !== Ne[_$_b839[744]][_$_b839[924]];
                });
                if (Ye && ct[_$_b839[862]](function(_t) {
                  return Ye[_$_b839[215]](_t);
                }) || this[_$_b839[1082]](ce[_$_b839[145]][_$_b839[917]], _$_b839[1084], { source: He }), !this[_$_b839[649]])
                  throw this[_$_b839[650]];
              }, rt[_$_b839[37]][_$_b839[1059]] = function(He, Ye) {
                var ct = (0, tt[_$_b839[646]])()[_$_b839[983]];
                ct[_$_b839[26]] < 1 && this[_$_b839[1082]](ce[_$_b839[145]][_$_b839[1085]], _$_b839[1086]);
                var _t = ht(this[_$_b839[667]], He, Ye);
                !_t && He[_$_b839[215]](_$_b839[644]) && this[_$_b839[1082]](ce[_$_b839[145]][_$_b839[1087]], _$_b839[1088]), _t || this[_$_b839[1082]](ce[_$_b839[145]][_$_b839[1085]], _$_b839[1089][_$_b839[41]](JSON[_$_b839[282]](ct), _$_b839[81]));
              }, rt[_$_b839[37]][_$_b839[1082]] = function(He, Ye, ct) {
                var _t = new he[_$_b839[147]](He, ct, Ye);
                throw this[_$_b839[626]] && this[_$_b839[626]][_$_b839[652]](_t), _t;
              }, rt[_$_b839[37]][_$_b839[1072]] = function(He) {
                var Ye = this;
                !this[_$_b839[1090]] && fe[_$_b839[140]][_$_b839[152]](le[_$_b839[168]][_$_b839[192]]) && (this[_$_b839[1090]] = fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[192]])[_$_b839[1092]][_$_b839[1091]](this), this[_$_b839[648]](ye[_$_b839[382]][_$_b839[532]], { name: le[_$_b839[168]][_$_b839[192]] })), He && Array[_$_b839[254]](He) && He[_$_b839[113]](function(ct) {
                  return Ye[_$_b839[965]](ct);
                });
              }, rt[_$_b839[37]][_$_b839[1078]] = function() {
                var He, Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[1078]]();
                Ye && (this[_$_b839[628]] = Ye);
              }, rt[_$_b839[37]][_$_b839[961]] = function() {
                if (this[_$_b839[619]][_$_b839[829]] && this[_$_b839[619]][_$_b839[829]][_$_b839[215]](_$_b839[644]) && this[_$_b839[734]]())
                  if (_$_b839[34] == typeof window[_$_b839[1093]]) {
                    var He = fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[169]])[_$_b839[1094]];
                    this[_$_b839[619]][_$_b839[659]] = new He(this[_$_b839[619]][_$_b839[91]], this[_$_b839[712]], this[_$_b839[619]][_$_b839[829]][_$_b839[644]], We[_$_b839[1022]][_$_b839[1021]](), this[_$_b839[280]], navigator, this[_$_b839[619]][_$_b839[809]]), this[_$_b839[648]](ye[_$_b839[382]][_$_b839[532]], { name: le[_$_b839[168]][_$_b839[169]] });
                  } else
                    this[_$_b839[280]][_$_b839[38]](_$_b839[1095], _$_b839[1096]);
              }, rt[_$_b839[37]][_$_b839[687]] = function(He) {
                return He === void 0 && (He = !1), this[_$_b839[667]] ? He ? this[_$_b839[667]][_$_b839[159]]() : this[_$_b839[667]][_$_b839[1097]]() : {};
              }, rt[_$_b839[37]][_$_b839[1098]] = function(He, Ye) {
                var ct;
                if (this[_$_b839[641]]())
                  return (ct = this[_$_b839[619]][_$_b839[620]]) === null || ct === void 0 ? void 0 : ct[_$_b839[1098]](He, Ye);
              }, rt[_$_b839[37]][_$_b839[915]] = function(He) {
                var Ye;
                He = Number(He), !isNaN(He) && He > 0 && (this[_$_b839[619]][_$_b839[914]] = He, this[_$_b839[735]]() && ((Ye = this[_$_b839[619]][_$_b839[620]]) === null || Ye === void 0 || Ye[_$_b839[915]](He)));
              }, rt[_$_b839[37]][_$_b839[1099]] = function() {
                var He, Ye;
                return this[_$_b839[735]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[1099]]()) !== null && Ye !== void 0 ? Ye : 1;
              }, rt[_$_b839[37]][_$_b839[1100]] = function() {
                var He = this;
                return new Promise(function(Ye, ct) {
                  if (He[_$_b839[780]] && He[_$_b839[1101]]() !== Ne[_$_b839[1018]][_$_b839[1017]]) {
                    var _t = function() {
                      Ye(), He[_$_b839[96]](ye[_$_b839[382]][_$_b839[530]], _t);
                    };
                    He[_$_b839[75]](ye[_$_b839[382]][_$_b839[530]], _t), He[_$_b839[780]][_$_b839[1019]](Ne[_$_b839[1018]][_$_b839[1017]]);
                  } else
                    Ye();
                });
              }, rt[_$_b839[37]][_$_b839[165]] = function() {
                var He, Ye = this;
                return this[_$_b839[730]]() ? Promise[_$_b839[602]]() : ((He = this[_$_b839[91]]) === null || He === void 0 || He[_$_b839[731]][_$_b839[138]]((0, Ve[_$_b839[1104]])(Ze[_$_b839[1103]][_$_b839[1102]])), fe[_$_b839[140]][_$_b839[164]](this[_$_b839[713]])[_$_b839[166]](function() {
                  return Ye[_$_b839[1100]]();
                })[_$_b839[166]](function() {
                  return Ye[_$_b839[1110]]();
                })[_$_b839[166]](function() {
                  var ct, _t;
                  (ct = Ye[_$_b839[91]]) === null || ct === void 0 || ct[_$_b839[731]][_$_b839[138]]((0, Ve[_$_b839[1104]])(Ze[_$_b839[1103]][_$_b839[1107]])), (_t = Ye[_$_b839[626]]) === null || _t === void 0 || _t[_$_b839[1108]](), Ye[_$_b839[1109]]();
                })[_$_b839[166]](function() {
                  return Ye[_$_b839[616]];
                })[_$_b839[166]](function() {
                  return Ye[_$_b839[1106]]();
                })[_$_b839[166]](function() {
                  Ye[_$_b839[91]] && (Ye[_$_b839[1105]](), Ye[_$_b839[91]][_$_b839[340]](), Ye[_$_b839[91]] = null);
                }));
              }, rt[_$_b839[37]][_$_b839[1105]] = function() {
                this[_$_b839[785]] && this[_$_b839[785]](), this[_$_b839[786]] && this[_$_b839[786]](), this[_$_b839[785]] = null, this[_$_b839[786]] = null;
              }, rt[_$_b839[37]][_$_b839[1110]] = function() {
                var He = this;
                return new Promise(function(Ye) {
                  var ct = function() {
                    clearTimeout(_t), He[_$_b839[96]](ye[_$_b839[382]][_$_b839[525]], ct), Ye();
                  }, _t = setTimeout(ct, 250);
                  He[_$_b839[75]](ye[_$_b839[382]][_$_b839[525]], ct), He[_$_b839[648]](ye[_$_b839[382]][_$_b839[525]], {}, !1, !1);
                });
              }, rt[_$_b839[37]][_$_b839[1109]] = function() {
                this[_$_b839[1042]](), clearTimeout(this[_$_b839[719]]);
              }, rt[_$_b839[37]][_$_b839[1106]] = function() {
                var He = this;
                if (!this[_$_b839[619]])
                  return Promise[_$_b839[602]]();
                var Ye = Promise[_$_b839[602]]();
                return this[_$_b839[999]](!0), We[_$_b839[1022]][_$_b839[1111]](), this[_$_b839[619]][_$_b839[736]] = (0, pe[_$_b839[340]])(this[_$_b839[619]][_$_b839[736]]), this[_$_b839[619]][_$_b839[659]] = null, this[_$_b839[780]] && (this[_$_b839[780]] = (0, pe[_$_b839[340]])(this[_$_b839[780]])), this[_$_b839[760]] = (0, pe[_$_b839[340]])(this[_$_b839[760]]), this[_$_b839[761]] = (0, pe[_$_b839[340]])(this[_$_b839[761]]), this[_$_b839[762]] = (0, pe[_$_b839[340]])(this[_$_b839[762]]), this[_$_b839[1077]] = (0, pe[_$_b839[340]])(this[_$_b839[1077]]), this[_$_b839[679]][_$_b839[340]](), this[_$_b839[619]][_$_b839[620]] ? Ye = this[_$_b839[619]][_$_b839[620]][_$_b839[774]]()[_$_b839[166]](function() {
                  return He[_$_b839[91]][_$_b839[635]][_$_b839[639]](be[_$_b839[637]][_$_b839[636]], function(ct) {
                    return ct[_$_b839[774]]();
                  });
                })[_$_b839[802]](function() {
                  He[_$_b839[1112]](), He[_$_b839[619]][_$_b839[620]] = null;
                }) : this[_$_b839[1112]](), this[_$_b839[619]][_$_b839[91]] && gt(this[_$_b839[619]][_$_b839[91]]), this[_$_b839[725]] = (0, pe[_$_b839[340]])(this[_$_b839[725]]), this[_$_b839[629]] = (0, pe[_$_b839[340]])(this[_$_b839[629]]), this[_$_b839[626]] = (0, pe[_$_b839[340]])(this[_$_b839[626]]), this[_$_b839[716]] = null, Ye;
              }, rt[_$_b839[37]][_$_b839[1112]] = function() {
                if (this[_$_b839[619]][_$_b839[655]]) {
                  var He = this[_$_b839[619]][_$_b839[655]][_$_b839[769]]();
                  this[_$_b839[619]][_$_b839[655]] = (0, pe[_$_b839[340]])(this[_$_b839[619]][_$_b839[655]]), this[_$_b839[675]] && He !== this[_$_b839[728]] && this[_$_b839[675]][_$_b839[926]](He);
                }
              }, rt[_$_b839[37]][_$_b839[651]] = function(He) {
                if (!He)
                  return new he[_$_b839[147]](ce[_$_b839[145]][_$_b839[1113]], { "error-message": _$_b839[1114] });
                if (He[_$_b839[89]] && He[_$_b839[89]][_$_b839[815]](_$_b839[1115]))
                  return new he[_$_b839[147]](ce[_$_b839[145]][_$_b839[1116]], { "error-message": He[_$_b839[89]] });
                if (He[_$_b839[215]](_$_b839[1117])) {
                  for (var Ye = _$_b839[90], ct = 0; ct < He[_$_b839[1117]][_$_b839[26]]; ct++)
                    Ye += He[_$_b839[1117]][ct][_$_b839[686]] + _$_b839[1118], Ye += He[_$_b839[1117]][ct][_$_b839[1119]], ct < He[_$_b839[1117]][_$_b839[26]] - 1 && (Ye += _$_b839[1120]);
                  return new he[_$_b839[147]](ce[_$_b839[145]][_$_b839[1113]], { "error-message": Ye });
                }
                return He[_$_b839[215]](_$_b839[89]) ? new he[_$_b839[147]](ce[_$_b839[145]][_$_b839[1113]], { "error-message": He[_$_b839[89]] }) : void 0;
              }, rt[_$_b839[37]][_$_b839[1121]] = function(He) {
                this[_$_b839[619]] && this[_$_b839[619]][_$_b839[620]] && We[_$_b839[1022]][_$_b839[1122]](this[_$_b839[619]][_$_b839[620]][_$_b839[1121]]) && this[_$_b839[619]][_$_b839[620]][_$_b839[1121]](He);
              }, rt[_$_b839[37]][_$_b839[853]] = function(He, Ye, ct, _t) {
                this[_$_b839[648]](ye[_$_b839[382]][_$_b839[410]], new ge[_$_b839[225]](ve[_$_b839[226]][_$_b839[971]], Ye, { method: He, parameter: ct, argument: _t }));
              }, rt[_$_b839[37]][_$_b839[648]] = function(He, Ye, ct, _t) {
                this[_$_b839[626]] && this[_$_b839[626]][_$_b839[781]]()(He, Ye, ct, _t);
              }, rt[_$_b839[37]][_$_b839[1123]] = function() {
                return this[_$_b839[894]]() || this[_$_b839[1124]]();
              }, rt[_$_b839[37]][_$_b839[894]] = function() {
                var He;
                return this[_$_b839[641]]() && !!(!((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0) && He[_$_b839[1123]]());
              }, rt[_$_b839[37]][_$_b839[1124]] = function() {
                return this[_$_b839[696]]() && this[_$_b839[698]]()[_$_b839[1123]]();
              }, rt[_$_b839[37]][_$_b839[1125]] = function() {
                return this[_$_b839[1126]]() || this[_$_b839[1127]]();
              }, rt[_$_b839[37]][_$_b839[1126]] = function() {
                var He;
                return this[_$_b839[641]]() && !!(!((He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0) && He[_$_b839[1125]]());
              }, rt[_$_b839[37]][_$_b839[1127]] = function() {
                return this[_$_b839[696]]() && this[_$_b839[698]]()[_$_b839[1125]]();
              }, rt[_$_b839[37]][_$_b839[1128]] = function(He) {
                this[_$_b839[728]] = He;
              }, rt[_$_b839[37]][_$_b839[1129]] = function() {
                return this[_$_b839[728]] ? this[_$_b839[728]] : this[_$_b839[619]] && this[_$_b839[619]][_$_b839[655]] ? this[_$_b839[619]][_$_b839[655]][_$_b839[769]]() : null;
              }, rt[_$_b839[37]][_$_b839[1130]] = function(He) {
                return this[_$_b839[725]] ? this[_$_b839[725]][_$_b839[1131]](He) : Promise[_$_b839[913]](_$_b839[1132]);
              }, rt[_$_b839[37]][_$_b839[1133]] = function() {
                return this[_$_b839[725]] ? this[_$_b839[725]][_$_b839[1134]]() : Promise[_$_b839[913]](_$_b839[1132]);
              }, rt[_$_b839[37]][_$_b839[1135]] = function(He) {
                this[_$_b839[935]][_$_b839[1136]](He);
              }, rt[_$_b839[37]][_$_b839[1007]] = function(He, Ye) {
                this[_$_b839[629]] ? this[_$_b839[629]][_$_b839[1007]](He, Ye) : this[_$_b839[280]][_$_b839[265]](_$_b839[1137]);
              }, rt[_$_b839[37]][_$_b839[1138]] = function(He) {
                var Ye;
                return this[_$_b839[735]]() ? bt(He, { width: this[_$_b839[977]]()[_$_b839[1139]], height: this[_$_b839[977]]()[_$_b839[1140]], isFullscreen: !!(!((Ye = this[_$_b839[780]]) === null || Ye === void 0) && Ye[_$_b839[1016]]()) }, this[_$_b839[619]][_$_b839[91]][_$_b839[635]]) : null;
              }, rt[_$_b839[37]][_$_b839[807]] = function() {
                var He, Ye, ct = { start: -1, end: -1 };
                return this[_$_b839[641]]() && (Ye = (He = this[_$_b839[619]][_$_b839[620]]) === null || He === void 0 ? void 0 : He[_$_b839[807]]()) !== null && Ye !== void 0 ? Ye : ct;
              }, rt[_$_b839[37]][_$_b839[670]] = function(He, Ye, ct) {
                var _t;
                Ye = [][_$_b839[41]](Ye);
                for (var Pt = function(Ct) {
                  if (_t = Ye[_$_b839[824]](function(Mt) {
                    return Mt[_$_b839[969]] === Ct;
                  }))
                    return _$_b839[1141];
                }, It = 0, wt = He = [][_$_b839[41]](He); It < wt[_$_b839[26]] && _$_b839[1141] !== Pt(wt[It]); It++)
                  ;
                return _t ? Promise[_$_b839[602]](ct(_t[_$_b839[712]])) : Promise[_$_b839[602]]();
              }, rt[_$_b839[37]][_$_b839[783]] = function() {
                var He = this[_$_b839[619]][_$_b839[667]][_$_b839[1142]]();
                this[_$_b839[1143]](He);
              }, rt[_$_b839[37]][_$_b839[1079]] = function() {
                return this[_$_b839[1144]]()[_$_b839[166]](this[_$_b839[671]])[_$_b839[166]](this[_$_b839[664]]);
              }, rt[_$_b839[37]][_$_b839[1145]] = function() {
                if (this[_$_b839[619]][_$_b839[667]][_$_b839[666]]()[_$_b839[1146]] && this[_$_b839[91]][_$_b839[655]] !== void 0) {
                  var He = this[_$_b839[91]][_$_b839[655]][_$_b839[769]]();
                  He[_$_b839[1148]](_$_b839[1147], _$_b839[90]), He[_$_b839[1148]](_$_b839[1149], _$_b839[90]);
                }
              }, rt[_$_b839[37]][_$_b839[1150]] = function() {
                this[_$_b839[806]]() || this[_$_b839[830]](this[_$_b839[619]][_$_b839[829]], !1);
              }, rt[_$_b839[37]][_$_b839[1151]] = function() {
                var He, Ye;
                (Ye = (He = this[_$_b839[619]][_$_b839[659]]) === null || He === void 0 ? void 0 : He[_$_b839[1152]]()) !== null && Ye !== void 0 && Ye ? this[_$_b839[280]][_$_b839[265]](_$_b839[1153]) : this[_$_b839[1154]]();
              }, rt[_$_b839[37]][_$_b839[1155]] = function() {
                var He = this[_$_b839[806]](), Ye = this[_$_b839[619]][_$_b839[667]][_$_b839[666]](), ct = this[_$_b839[619]][_$_b839[667]][_$_b839[1156]]();
                Ye[_$_b839[1157]] ? this[_$_b839[1151]]() : this[_$_b839[1158]](ct, He) && this[_$_b839[828]]();
              }, rt[_$_b839[37]][_$_b839[1144]] = function() {
                var He = this;
                return new Promise(function(Ye) {
                  clearTimeout(He[_$_b839[719]]), He[_$_b839[619]] && He[_$_b839[619]][_$_b839[620]] ? (He[_$_b839[1145]](), He[_$_b839[1150]](), He[_$_b839[1155]](), Ye()) : He[_$_b839[719]] = window[_$_b839[1159]](function() {
                    Ye(He[_$_b839[1079]]());
                  }, 100);
                });
              }, rt[_$_b839[37]][_$_b839[1158]] = function(He, Ye) {
                return !Ye && (_$_b839[979] != typeof He[_$_b839[828]] || He[_$_b839[828]]);
              }, Object[_$_b839[82]](rt[_$_b839[37]], _$_b839[1160], { get: function() {
                return this[_$_b839[798]] && this[_$_b839[798]][_$_b839[1056]] || Promise[_$_b839[602]]();
              }, enumerable: !1, configurable: !0 }), rt[_$_b839[37]][_$_b839[1154]] = function() {
                var He = this;
                this[_$_b839[1160]][_$_b839[166]](function() {
                  return He[_$_b839[386]]();
                })[_$_b839[904]](function() {
                  return He[_$_b839[280]][_$_b839[1162]](_$_b839[1161]);
                });
              }, rt[_$_b839[37]][_$_b839[830]] = function(He, Ye) {
                var ct = this[_$_b839[619]][_$_b839[91]][_$_b839[635]][_$_b839[159]](be[_$_b839[637]][_$_b839[1044]])[_$_b839[1163]](He);
                Ye ? this[_$_b839[838]](ct, we[_$_b839[1164]]) : this[_$_b839[392]](ct, we[_$_b839[1164]]);
              }, rt[_$_b839[37]][_$_b839[1143]] = function(He) {
                var Ye = this;
                Object[_$_b839[98]](He)[_$_b839[113]](function(ct) {
                  Object[_$_b839[98]](He[ct])[_$_b839[113]](function(_t) {
                    if (Ye[_$_b839[867]](_t, ct)) {
                      var Pt = He[ct][_t];
                      Ye[_$_b839[861]](_t, Pt, ct);
                    }
                  });
                });
              }, rt[_$_b839[37]][_$_b839[962]] = function() {
                this[_$_b839[619]] && (this[_$_b839[627]] = !0, this[_$_b839[836]](this[_$_b839[619]][_$_b839[837]]), this[_$_b839[915]](this[_$_b839[619]][_$_b839[914]]), this[_$_b839[619]][_$_b839[402]] ? this[_$_b839[831]]() : this[_$_b839[835]]());
              }, rt[_$_b839[37]][_$_b839[1055]] = function() {
                if (!this[_$_b839[696]]() && this[_$_b839[687]]()[_$_b839[994]])
                  try {
                    this[_$_b839[737]]();
                  } catch (He) {
                    this[_$_b839[280]][_$_b839[38]](He);
                  }
              }, rt[_$_b839[37]][_$_b839[44]] = function() {
                var He = this;
                this[_$_b839[649]] = !0, this[_$_b839[609]] && this[_$_b839[609]][_$_b839[26]] > 0 && (this[_$_b839[679]] = new Pe[_$_b839[1165]](this[_$_b839[280]], this[_$_b839[609]][0])), this[_$_b839[922]](ye[_$_b839[382]][_$_b839[409]], this[_$_b839[674]]), this[_$_b839[922]](ye[_$_b839[382]][_$_b839[410]], function(Ye) {
                  return He[_$_b839[280]][_$_b839[38]](Ye[_$_b839[89]]);
                }), this[_$_b839[922]](ye[_$_b839[382]][_$_b839[387]], this[_$_b839[678]]), this[_$_b839[922]](ye[_$_b839[382]][_$_b839[505]], this[_$_b839[653]]), this[_$_b839[75]](ye[_$_b839[382]][_$_b839[507]], this[_$_b839[663]]), this[_$_b839[75]](ye[_$_b839[382]][_$_b839[387]], this[_$_b839[707]]), this[_$_b839[842]] = Ce[_$_b839[1166]][_$_b839[52]](this), fe[_$_b839[140]][_$_b839[152]](le[_$_b839[168]][_$_b839[205]]) && (this[_$_b839[1167]] = fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[205]])[_$_b839[1168]][_$_b839[52]](this)), fe[_$_b839[140]][_$_b839[152]](le[_$_b839[168]][_$_b839[184]]) && (this[_$_b839[1169]] = fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[184]])[_$_b839[1170]][_$_b839[52]](this)), fe[_$_b839[140]][_$_b839[152]](le[_$_b839[168]][_$_b839[183]]) && (this[_$_b839[760]] = new (fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[183]]))[_$_b839[1171]](), this[_$_b839[761]] = new (fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[183]]))[_$_b839[1172]](), this[_$_b839[762]] = new (fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[183]]))[_$_b839[1173]](), this[_$_b839[1077]] = new (fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[183]]))[_$_b839[1063]]()), this[_$_b839[623]]();
              }, rt[_$_b839[37]][_$_b839[623]] = function() {
                this[_$_b839[1174]] = /* @__PURE__ */ new Map(), this[_$_b839[1174]][_$_b839[1045]](_e[_$_b839[594]], 0), this[_$_b839[1174]][_$_b839[1045]](_e[_$_b839[596]], 0);
              }, rt[_$_b839[37]][_$_b839[800]] = function(He, Ye) {
                this[_$_b839[1174]][_$_b839[152]](He) && this[_$_b839[1174]][_$_b839[1045]](He, this[_$_b839[1174]][_$_b839[159]](He) + Ye);
              }, rt[_$_b839[37]][_$_b839[888]] = function(He, Ye, ct) {
                return this[_$_b839[1174]][_$_b839[159]](He) + (Ye ? ct : 0);
              }, rt[_$_b839[37]][_$_b839[700]] = function(He) {
                var Ye = He[_$_b839[1175]](), ct = He[_$_b839[1177]]()[_$_b839[112]](function(_t) {
                  return _t[_$_b839[1176]] === Ye[_$_b839[1176]];
                });
                [Ye][_$_b839[41]](ct)[_$_b839[113]](function(_t) {
                  return He[_$_b839[1178]](_t[_$_b839[712]]);
                });
              }, rt[_$_b839[37]][_$_b839[1179]] = function(He) {
              }, rt[_$_b839[37]][_$_b839[1180]] = function() {
              }, rt[_$_b839[37]][_$_b839[1181]] = function() {
              }, rt[_$_b839[37]][_$_b839[1101]] = function() {
                return this[_$_b839[91]] ? (0, Ke[_$_b839[787]])(this[_$_b839[91]][_$_b839[731]][_$_b839[136]]())[_$_b839[1182]] : Ne[_$_b839[1018]][_$_b839[1017]];
              }, rt[_$_b839[37]][_$_b839[1183]] = function(He) {
                var Ye;
                return this[_$_b839[641]]() ? !!(!((Ye = this[_$_b839[780]]) === null || Ye === void 0) && Ye[_$_b839[1183]](He)) : [Ne[_$_b839[1018]][_$_b839[1184]], Ne[_$_b839[1018]][_$_b839[1017]]][_$_b839[815]](He);
              }, rt[_$_b839[37]][_$_b839[1019]] = function(He, Ye) {
                Ye === void 0 && (Ye = {}), this[_$_b839[780]] && this[_$_b839[780]][_$_b839[1019]](He, Ye);
              }, rt[_$_b839[37]][_$_b839[1185]] = function(He) {
                this[_$_b839[626]] && this[_$_b839[626]][_$_b839[1185]](He);
              }, rt[_$_b839[37]][_$_b839[1186]] = function(He) {
                this[_$_b839[626]] && this[_$_b839[626]][_$_b839[1186]](He);
              }, rt[_$_b839[37]][_$_b839[643]] = function() {
                return this[_$_b839[599]];
              }, rt[_$_b839[37]][_$_b839[1187]] = function() {
                var He;
                return this[_$_b839[641]]() && ((He = this[_$_b839[619]]) === null || He === void 0 ? void 0 : He[_$_b839[1026]]) || null;
              }, rt[_$_b839[37]][_$_b839[900]] = function() {
                return this[_$_b839[709]] !== ue[_$_b839[319]];
              }, rt[_$_b839[37]][_$_b839[710]] = function(He) {
                var Ye = this[_$_b839[820]]() ? ue[_$_b839[592]] : ue[_$_b839[593]];
                return Ye > He ? Ye : He;
              }, rt[_$_b839[37]][_$_b839[1068]] = function(He, Ye) {
                if (this[_$_b839[91]] && fe[_$_b839[140]][_$_b839[152]](le[_$_b839[168]][_$_b839[184]]))
                  for (var ct = fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[184]])[_$_b839[1188]], _t = Tt(He) ? 0 : ct[_$_b839[1189]](this[_$_b839[91]]), Pt = this[_$_b839[91]][_$_b839[635]][_$_b839[159]](be[_$_b839[637]][_$_b839[795]], Ye), It = 0, wt = Object[_$_b839[1083]](pt[_$_b839[1190]]); It < wt[_$_b839[26]]; It++) {
                    var Ct = wt[It];
                    Pt[_$_b839[138]]((0, Fe[_$_b839[1191]])(Ct, _t));
                  }
              }, ne([(0, Ae[_$_b839[1193]])(_$_b839[1192])], rt[_$_b839[37]], _$_b839[1040], null), ne([(0, Ae[_$_b839[1193]])(_$_b839[1194])], rt[_$_b839[37]], _$_b839[165], null), rt;
            }();
            function ot(rt, He) {
              var Ye = new ut[_$_b839[1196]](rt[_$_b839[731]], _$_b839[1195], He);
              rt[_$_b839[635]][_$_b839[1045]](be[_$_b839[637]][_$_b839[795]], Ye, He), Object[_$_b839[98]](qe[_$_b839[1197]])[_$_b839[113]](function(ct) {
                Ye[_$_b839[1198]](ct, qe[_$_b839[1197]][ct]);
              });
            }
            function et(rt, He, Ye) {
              var ct, _t = We[_$_b839[1022]][_$_b839[1199]](He) + rt[_$_b839[91]][_$_b839[1200]], Pt = new Le[_$_b839[1201]]({ source: He, isAd: Ye, technology: rt[_$_b839[773]], sourceIdentifier: _t, mseObjectUrl: (ct = rt[_$_b839[655]]) === null || ct === void 0 ? void 0 : ct[_$_b839[368]] }), It = rt[_$_b839[91]];
              It[_$_b839[1202]](Pt), It[_$_b839[635]][_$_b839[152]](be[_$_b839[637]][_$_b839[795]], _t) || ot(It, _t);
            }
            function st(rt, He) {
              return rt === He ? Promise[_$_b839[602]]() : Promise[_$_b839[913]](te[_$_b839[591]]);
            }
            function mt(rt) {
              if (fe[_$_b839[140]][_$_b839[152]](le[_$_b839[168]][_$_b839[198]]))
                return fe[_$_b839[140]][_$_b839[159]](le[_$_b839[168]][_$_b839[198]])[_$_b839[1203]](rt);
            }
            function St(rt, He) {
              He[_$_b839[639]](be[_$_b839[637]][_$_b839[1048]], function(Ye) {
                rt && rt[_$_b839[1204]] && Ye[_$_b839[1206]](rt[_$_b839[1204]][_$_b839[1205]]);
              });
            }
            function bt(rt, He, Ye) {
              return Ye[_$_b839[639]](be[_$_b839[637]][_$_b839[1048]], function(ct) {
                return ct[_$_b839[1138]](rt, He);
              });
            }
            function it(rt) {
              return rt && _$_b839[33] == typeof rt && (_$_b839[109] == typeof rt[_$_b839[712]] || (0, Xe[_$_b839[1207]])(rt[_$_b839[712]])) && _$_b839[109] == typeof rt[_$_b839[969]] && [_$_b839[1208], _$_b839[1209], _$_b839[975], _$_b839[967]][_$_b839[815]](rt[_$_b839[966]]);
            }
            function ht(rt, He, Ye) {
              var ct = We[_$_b839[1022]][_$_b839[1210]](Ye);
              return (0, $t[_$_b839[1212]])(rt[_$_b839[666]]()[_$_b839[1211]], He, ct);
            }
            function vt(rt) {
              return rt != null && _$_b839[804] in rt;
            }
            function gt(rt) {
              [be[_$_b839[637]][_$_b839[1046]], be[_$_b839[637]][_$_b839[1044]], be[_$_b839[637]][_$_b839[893]], be[_$_b839[637]][_$_b839[1047]], be[_$_b839[637]][_$_b839[1048]]][_$_b839[113]](function(He) {
                return (0, me[_$_b839[1213]])(rt[_$_b839[635]], He);
              });
            }
            function Tt(rt) {
              return rt === we[_$_b839[1032]] || rt === we[_$_b839[1214]];
            }
            te[_$_b839[590]] = dt;
          }, 15539: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1215]] = te[_$_b839[1216]] = te[_$_b839[1214]] = te[_$_b839[1032]] = te[_$_b839[1164]] = void 0, te[_$_b839[1164]] = _$_b839[962], te[_$_b839[1032]] = _$_b839[1217], te[_$_b839[1214]] = _$_b839[1218], te[_$_b839[1216]] = _$_b839[1219], te[_$_b839[1215]] = _$_b839[1220];
          }, 64430: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1221]] = void 0, te[_$_b839[1221]] = { DEBUG: _$_b839[265], LOG: _$_b839[998], WARN: _$_b839[38], ERROR: _$_b839[73], OFF: _$_b839[96] };
          }, 58935: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[589]] || function(le, se, oe) {
              if (oe || arguments[_$_b839[26]] === 2)
                for (var ce, he = 0, ge = se[_$_b839[26]]; he < ge; he++)
                  !ce && he in se || (ce || (ce = Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](se, 0, he)), ce[he] = se[he]);
              return le[_$_b839[41]](ce || Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](se));
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[715]] = te[_$_b839[1222]] = void 0;
            var ne, ae = ee(64430), ue = ee(33696);
            (function(le) {
              le[le[_$_b839[1223]] = 0] = _$_b839[1223], le[le[_$_b839[1224]] = 1] = _$_b839[1224], le[le[_$_b839[1225]] = 2] = _$_b839[1225], le[le[_$_b839[1226]] = 3] = _$_b839[1226], le[le[_$_b839[1227]] = 4] = _$_b839[1227], le[le[_$_b839[1228]] = 5] = _$_b839[1228];
            })(ne || (te[_$_b839[1222]] = ne = {}));
            var _e = function() {
              function le(se, oe) {
                oe === void 0 && (oe = ne[_$_b839[1227]]), this[_$_b839[809]] = se, this[_$_b839[767]](oe);
              }
              return le[_$_b839[37]][_$_b839[768]] = function(se) {
                this[_$_b839[1229]] = se[_$_b839[765]] && _$_b839[34] == typeof se[_$_b839[765]]()[_$_b839[1230]] ? se[_$_b839[765]]()[_$_b839[1230]] : void 0;
              }, le[_$_b839[37]][_$_b839[767]] = function(se) {
                _$_b839[109] == typeof se && (se = le[_$_b839[1231]](se)), this[_$_b839[766]] = se;
              }, le[_$_b839[37]][_$_b839[1232]] = function() {
                return this[_$_b839[766]];
              }, le[_$_b839[37]][_$_b839[1233]] = function(se) {
                return !(this[_$_b839[1229]] === void 0 || se === ne[_$_b839[1224]]) || this[_$_b839[766]] !== ne[_$_b839[1223]] && this[_$_b839[766]] <= se;
              }, le[_$_b839[37]][_$_b839[943]] = function(se) {
                this[_$_b839[809]] = se;
              }, le[_$_b839[1231]] = function(se) {
                switch (se) {
                  case ae[_$_b839[1221]][_$_b839[1225]]:
                    return ne[_$_b839[1225]];
                  case ae[_$_b839[1221]][_$_b839[1226]]:
                    return ne[_$_b839[1226]];
                  case ae[_$_b839[1221]][_$_b839[1227]]:
                    return ne[_$_b839[1227]];
                  case ae[_$_b839[1221]][_$_b839[1228]]:
                    return ne[_$_b839[1228]];
                  default:
                    return ne[_$_b839[1223]];
                }
              }, le[_$_b839[37]][_$_b839[1234]] = function(se, oe, ce) {
                var he, ge, ve, me = fe(se), be = ie([], ce, !0);
                if (this[_$_b839[766]] > 0 && this[_$_b839[766]] <= se && (_$_b839[109] == typeof this[_$_b839[809]][_$_b839[1235]] && this[_$_b839[809]][_$_b839[1235]][_$_b839[26]] > 0 ? (he = console[me])[_$_b839[36]][_$_b839[35]](he, ie([console, this[_$_b839[809]][_$_b839[1235]], oe], be, !1)) : (ge = console[me])[_$_b839[36]][_$_b839[35]](ge, ie([console, oe], be, !1))), this[_$_b839[1229]] && se !== ne[_$_b839[1224]])
                  try {
                    (ve = this[_$_b839[1229]])[_$_b839[36]][_$_b839[35]](ve, ie([null, me, oe], be, !1));
                  } catch {
                  }
              }, le[_$_b839[37]][_$_b839[1162]] = function(se) {
                for (var oe = [], ce = 1; ce < arguments[_$_b839[26]]; ce++)
                  oe[ce - 1] = arguments[ce];
                this[_$_b839[1234]](ne[_$_b839[1224]], se, oe);
              }, le[_$_b839[37]][_$_b839[265]] = function(se) {
                for (var oe = [], ce = 1; ce < arguments[_$_b839[26]]; ce++)
                  oe[ce - 1] = arguments[ce];
                this[_$_b839[1234]](ne[_$_b839[1225]], se, oe);
              }, le[_$_b839[37]][_$_b839[998]] = function(se) {
                for (var oe = [], ce = 1; ce < arguments[_$_b839[26]]; ce++)
                  oe[ce - 1] = arguments[ce];
                this[_$_b839[1234]](ne[_$_b839[1226]], se, oe);
              }, le[_$_b839[37]][_$_b839[38]] = function(se) {
                for (var oe = [], ce = 1; ce < arguments[_$_b839[26]]; ce++)
                  oe[ce - 1] = arguments[ce];
                this[_$_b839[1234]](ne[_$_b839[1227]], se, oe);
              }, le[_$_b839[37]][_$_b839[73]] = function(se) {
                for (var oe = [], ce = 1; ce < arguments[_$_b839[26]]; ce++)
                  oe[ce - 1] = arguments[ce];
                this[_$_b839[1234]](ne[_$_b839[1228]], se, oe);
              }, le[_$_b839[37]][_$_b839[954]] = function(se, oe, ce) {
                navigator[_$_b839[1237]][_$_b839[29]](_$_b839[1236]) > -1 || navigator[_$_b839[1237]][_$_b839[29]](_$_b839[1238]) > -1 ? console[_$_b839[998]](se) : console[_$_b839[998]](_$_b839[1239] + se, _$_b839[1240] + oe + _$_b839[1241] + ce + _$_b839[1242]);
              }, le;
            }();
            function fe(le) {
              switch (le) {
                case ne[_$_b839[1224]]:
                case ne[_$_b839[1225]]:
                  return ue[_$_b839[1222]][_$_b839[1225]];
                case ne[_$_b839[1226]]:
                  return ue[_$_b839[1222]][_$_b839[1226]];
                case ne[_$_b839[1227]]:
                  return ue[_$_b839[1222]][_$_b839[1227]];
                case ne[_$_b839[1228]]:
                  return ue[_$_b839[1222]][_$_b839[1228]];
                default:
                  return null;
              }
            }
            te[_$_b839[715]] = _e;
          }, 72181: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1243]] = te[_$_b839[1244]] = void 0, te[_$_b839[1244]] = { Avc: [_$_b839[1245], _$_b839[1246], _$_b839[1247]], Hvc: [_$_b839[1248], _$_b839[1249]] }, function(ie) {
              ie[ie[_$_b839[1250]] = 6] = _$_b839[1250];
            }(ee || (te[_$_b839[1243]] = ee = {}));
          }, 9560: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1251]] = te[_$_b839[1252]] = void 0;
            var ie, ne, ae = ee(25550);
            (function(ue) {
              ue[ue[_$_b839[1253]] = 2] = _$_b839[1253], ue[ue[_$_b839[1254]] = 3] = _$_b839[1254], ue[ue[_$_b839[1255]] = 4] = _$_b839[1255];
            })(ie || (te[_$_b839[1252]] = ie = {})), function(ue) {
              ue[ue[_$_b839[1254]] = ae[_$_b839[145]][_$_b839[1256]]] = _$_b839[1254], ue[ue[_$_b839[1253]] = ae[_$_b839[145]][_$_b839[1257]]] = _$_b839[1253], ue[ue[_$_b839[1255]] = ae[_$_b839[145]][_$_b839[1258]]] = _$_b839[1255];
            }(ne || (te[_$_b839[1251]] = ne = {}));
          }, 27256: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1046]] = void 0;
            var ie = ee(62510), ne = ee(44779), ae = ee(331), ue = function() {
              function _e(fe) {
                this[_$_b839[1259]] = 1.3, this[_$_b839[626]] = fe[_$_b839[626]], this[_$_b839[626]][_$_b839[75]](ie[_$_b839[382]][_$_b839[507]], this[_$_b839[44]]), this[_$_b839[44]]();
              }
              return _e[_$_b839[37]][_$_b839[44]] = function() {
                this[_$_b839[1260]] = {}, this[_$_b839[1261]] = 1 / 0;
              }, _e[_$_b839[37]][_$_b839[816]] = function(fe, le) {
                if (this[_$_b839[1262]](), [ie[_$_b839[381]][_$_b839[562]], ie[_$_b839[381]][_$_b839[561]]][_$_b839[815]](le[_$_b839[1263]])) {
                  var se = (0, ne[_$_b839[1264]])(le, fe);
                  if (this[_$_b839[1260]][se])
                    return;
                  this[_$_b839[1260]][se] = Date[_$_b839[840]]();
                }
                this[_$_b839[626]][_$_b839[739]](ie[_$_b839[382]][_$_b839[452]], le);
              }, _e[_$_b839[37]][_$_b839[1262]] = function() {
                for (var fe = 0, le = Object[_$_b839[98]](this[_$_b839[1260]]); fe < le[_$_b839[26]]; fe++) {
                  var se = le[fe];
                  this[_$_b839[1265]](this[_$_b839[1260]][se]) && delete this[_$_b839[1260]][se];
                }
              }, _e[_$_b839[37]][_$_b839[1265]] = function(fe) {
                if (!fe)
                  return !0;
                var le = (0, ae[_$_b839[1266]])(this[_$_b839[1261]] * this[_$_b839[1259]]);
                return Date[_$_b839[840]]() - le > fe;
              }, Object[_$_b839[82]](_e[_$_b839[37]], _$_b839[1267], { get: function() {
                return this[_$_b839[1261]];
              }, set: function(fe) {
                this[_$_b839[1261]] = Math[_$_b839[1268]](fe);
              }, enumerable: !1, configurable: !0 }), _e[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[1260]] = null, this[_$_b839[626]][_$_b839[96]](ie[_$_b839[382]][_$_b839[507]], this[_$_b839[44]]);
              }, _e;
            }();
            te[_$_b839[1046]] = ue;
          }, 67345: function(re, te) {
            _$_b839[32];
            var ee, ie, ne, ae;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1269]] = te[_$_b839[1270]] = te[_$_b839[1271]] = te[_$_b839[1272]] = void 0, function(ue) {
              ue[_$_b839[1273]] = _$_b839[1274], ue[_$_b839[1275]] = _$_b839[1276], ue[_$_b839[1277]] = _$_b839[1278], ue[_$_b839[1279]] = _$_b839[1280], ue[_$_b839[1281]] = _$_b839[1282], ue[_$_b839[1283]] = _$_b839[1284], ue[_$_b839[1285]] = _$_b839[1286], ue[_$_b839[1287]] = _$_b839[1288], ue[_$_b839[1289]] = _$_b839[1290], ue[_$_b839[1291]] = _$_b839[1292], ue[_$_b839[1293]] = _$_b839[1294], ue[_$_b839[1295]] = _$_b839[1296], ue[_$_b839[1297]] = _$_b839[1298], ue[_$_b839[1299]] = _$_b839[1300], ue[_$_b839[1301]] = _$_b839[1302], ue[_$_b839[1303]] = _$_b839[1304], ue[_$_b839[1305]] = _$_b839[1306], ue[_$_b839[1307]] = _$_b839[1308], ue[_$_b839[1309]] = _$_b839[1310], ue[_$_b839[1311]] = _$_b839[1312], ue[_$_b839[1313]] = _$_b839[1314], ue[_$_b839[1315]] = _$_b839[1316], ue[_$_b839[1317]] = _$_b839[1219];
            }(ee || (te[_$_b839[1272]] = ee = {})), function(ue) {
              ue[_$_b839[1318]] = _$_b839[1319], ue[_$_b839[1320]] = _$_b839[1321], ue[_$_b839[1322]] = _$_b839[4], ue[_$_b839[1323]] = _$_b839[1324], ue[_$_b839[1325]] = _$_b839[1326];
            }(ie || (te[_$_b839[1271]] = ie = {})), function(ue) {
              ue[_$_b839[1327]] = _$_b839[1327], ue[_$_b839[1328]] = _$_b839[1328], ue[_$_b839[1329]] = _$_b839[1329], ue[_$_b839[1330]] = _$_b839[1330];
            }(ne || (te[_$_b839[1270]] = ne = {})), function(ue) {
              ue[_$_b839[1331]] = _$_b839[1332], ue[_$_b839[1333]] = _$_b839[1334];
            }(ae || (te[_$_b839[1269]] = ae = {}));
          }, 16937: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[948]] = ne, te[_$_b839[1193]] = ae, te[_$_b839[1335]] = he, te[_$_b839[1336]] = ve;
            var ie = {};
            function ne(me) {
              ee = me;
            }
            function ae(me, be) {
              return be === void 0 && (be = !1), function(pe, $e, ye) {
                var Se = ye[_$_b839[852]];
                return ye[_$_b839[852]] = function() {
                  var we = fe(ie), Pe = we[_$_b839[1337]], Te = we[_$_b839[1338]], Ee = Date[_$_b839[840]](), Me = _e(), Ae = le(Te, me), Ne = function() {
                    var Ie = _e() - Me;
                    if (ue({ name: me, start: Ee, duration: Ie, callStack: Pe }), be && (Te[_$_b839[1339]] = Te[_$_b839[1339]] || [], Te[_$_b839[1339]][_$_b839[57]]({ name: me, duration: Ie })), Ae[_$_b839[1339]] && Ae[_$_b839[1339]][_$_b839[26]]) {
                      var xe = Ae[_$_b839[1339]][_$_b839[137]](function(ke) {
                        return ke[_$_b839[62]];
                      })[_$_b839[123]](_$_b839[1340]), Ue = Ae[_$_b839[1339]][_$_b839[135]](function(ke, Le) {
                        return ke + Le[_$_b839[1341]];
                      }, 0);
                      ue({ name: _$_b839[90][_$_b839[41]](me, _$_b839[1342])[_$_b839[41]](xe), duration: Ie - Ue, start: Date[_$_b839[840]]() });
                    }
                    oe(Te);
                  }, Ce = Se[_$_b839[35]](this, arguments);
                  return Ce instanceof Promise ? (se(Te[_$_b839[132]], !0), Ce[_$_b839[166]](Ne, Ne), Ce) : (Ne(), Ce);
                }, ye;
              };
            }
            function ue(me) {
              ee && ee[_$_b839[265]](_$_b839[1346][_$_b839[41]](me[_$_b839[62]], _$_b839[1345])[_$_b839[41]](Math[_$_b839[1343]](me[_$_b839[1341]]), _$_b839[1344]), me);
            }
            function _e() {
              var me, be;
              return ((me = performance[_$_b839[840]]) === null || me === void 0 ? void 0 : me[_$_b839[36]](performance)) || ((be = performance[_$_b839[1347]]) === null || be === void 0 ? void 0 : be[_$_b839[36]](performance)) || Date[_$_b839[840]]();
            }
            function fe(me, be) {
              be === void 0 && (be = []);
              var pe = me[_$_b839[132]], $e = me[_$_b839[1348]];
              return $e && be[_$_b839[57]]($e), pe ? fe(pe, be) : { callStack: be, parent: me };
            }
            function le(me, be) {
              var pe = { method: be, isAsync: !1, next: null, subtractions: [] };
              return me[_$_b839[132]] = pe, pe;
            }
            function se(me, be) {
              me[_$_b839[1349]] = be;
            }
            function oe(me) {
              me[_$_b839[1349]] && me[_$_b839[132]][_$_b839[1349]] || (me[_$_b839[132]] = null);
            }
            var ce = {};
            function he(me) {
              var be = _e();
              ce[me] && ge(me, be), ce[me] = be;
            }
            function ge(me, be) {
              ee && ue({ name: me, start: ce[me], duration: be - ce[me] });
            }
            function ve(me) {
              ge(me, _e()), delete ce[me];
            }
          }, 1356: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(ue) {
                for (var _e, fe = 1, le = arguments[_$_b839[26]]; fe < le; fe++)
                  for (var se in _e = arguments[fe])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](_e, se) && (ue[se] = _e[se]);
                return ue;
              }, ie[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1350]] = void 0;
            var ne = ee(46462), ae = function() {
              function ue(_e, fe, le) {
                var se = this;
                this[_$_b839[1351]] = function() {
                  var oe = function() {
                    clearTimeout(se[_$_b839[1352]]), se[_$_b839[1353]] && se[_$_b839[1353]][_$_b839[1354]]() ? se[_$_b839[1352]] = setTimeout(oe, se[_$_b839[91]][_$_b839[809]][_$_b839[1355]]) : se[_$_b839[913]]({ code: 0, name: _$_b839[911], message: _$_b839[1356] });
                  };
                  se[_$_b839[1352]] = setTimeout(oe, se[_$_b839[91]][_$_b839[809]][_$_b839[1355]]);
                }, this[_$_b839[602]] = function() {
                  se[_$_b839[1357]](), se[_$_b839[1358]]();
                }, this[_$_b839[1359]] = function(oe, ce) {
                  return se[_$_b839[913]](ie(ie({}, ce), { eventName: oe }));
                }, this[_$_b839[913]] = function(oe) {
                  se[_$_b839[1357]]();
                  var ce = oe;
                  oe && oe[_$_b839[65]] && (ce = _$_b839[73] === oe[_$_b839[65]] ? ie(ie({}, oe), { name: _$_b839[1360], message: _$_b839[1361] }) : ie(ie({}, oe), { name: _$_b839[1362], message: _$_b839[1363][_$_b839[41]](oe[_$_b839[65]]) })), se[_$_b839[1364]](ce);
                }, this[_$_b839[91]] = _e, this[_$_b839[1365]] = fe, this[_$_b839[1353]] = le;
              }
              return ue[_$_b839[37]][_$_b839[1366]] = function() {
                var _e = this, fe = 4, le = function(ce) {
                  var he = ue[_$_b839[1367]][ce];
                  se[_$_b839[1365]][_$_b839[76]](ce, he ? se[_$_b839[602]] : function(ge) {
                    return _e[_$_b839[1359]](ce, ge);
                  });
                }, se = this;
                for (var oe in ue[_$_b839[1367]])
                  le(oe);
                this[_$_b839[1365]][_$_b839[1368]] === fe ? this[_$_b839[1351]]() : this[_$_b839[1365]][_$_b839[76]](ne[_$_b839[1370]][_$_b839[1369]], this[_$_b839[1351]]);
              }, ue[_$_b839[37]][_$_b839[1371]] = function() {
                for (var _e in ue[_$_b839[1367]]) {
                  var fe = ue[_$_b839[1367]][_e];
                  this[_$_b839[1365]][_$_b839[78]](_e, fe ? this[_$_b839[602]] : this[_$_b839[913]]);
                }
                this[_$_b839[1365]][_$_b839[78]](ne[_$_b839[1370]][_$_b839[1369]], this[_$_b839[1351]]);
              }, ue[_$_b839[37]][_$_b839[1357]] = function() {
                clearTimeout(this[_$_b839[1352]]), this[_$_b839[1371]]();
              }, ue[_$_b839[37]][_$_b839[1372]] = function() {
                var _e = this;
                return new Promise(function(fe, le) {
                  _e[_$_b839[1358]] = fe, _e[_$_b839[1364]] = le, _e[_$_b839[1366]]();
                });
              }, ue[_$_b839[1373]] = function(_e, fe, le) {
                return new ue(_e, fe, le)[_$_b839[1372]]();
              }, ue[_$_b839[1367]] = { playing: !0, ended: !0, pause: !1, abort: !1, emptied: !1, error: !1 }, ue;
            }();
            te[_$_b839[1350]] = ae;
          }, 90546: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[587]] || function($e, ye, Se, we) {
              var Pe, Te = arguments[_$_b839[26]], Ee = Te < 3 ? ye : we === null ? we = Object[_$_b839[111]](ye, Se) : we;
              if (_$_b839[33] == typeof Reflect && _$_b839[34] == typeof Reflect[_$_b839[588]])
                Ee = Reflect[_$_b839[588]]($e, ye, Se, we);
              else
                for (var Me = $e[_$_b839[26]] - 1; Me >= 0; Me--)
                  (Pe = $e[Me]) && (Ee = (Te < 3 ? Pe(Ee) : Te > 3 ? Pe(ye, Se, Ee) : Pe(ye, Se)) || Ee);
              return Te > 3 && Ee && Object[_$_b839[82]](ye, Se, Ee), Ee;
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[346]] = void 0;
            var ne, ae = ee(91520), ue = ee(25550), _e = ee(28764), fe = ee(4006), le = ee(92737), se = ee(13142), oe = ee(15447), ce = ee(16937), he = ee(33696), ge = ee(54838), ve = 0;
            function me() {
              ne || (ne = /* @__PURE__ */ new WeakMap());
            }
            function be($e, ye) {
              me();
              var Se = ne[_$_b839[159]]($e);
              if (!Se)
                throw new he[_$_b839[1374]](ye);
              return Se;
            }
            var pe = function() {
              function $e(ye, Se) {
                this[_$_b839[44]](ye, Se);
              }
              return $e[_$_b839[37]][_$_b839[44]] = function(ye, Se) {
                if (!(ye instanceof HTMLElement))
                  throw new _e[_$_b839[147]](ue[_$_b839[145]][_$_b839[1375]], void 0, _$_b839[1376]);
                me();
                var we = new oe[_$_b839[590]](ye, ge[_$_b839[1022]][_$_b839[1377]](), this);
                ne[_$_b839[1045]](this, we), ve++, we[_$_b839[163]](Se);
              }, Object[_$_b839[82]]($e[_$_b839[37]], _$_b839[1378], { get: function() {
                return fe[_$_b839[347]][_$_b839[373]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]]($e[_$_b839[37]], _$_b839[644], { get: function() {
                return be(this, _$_b839[644])[_$_b839[993]]();
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]]($e[_$_b839[37]], _$_b839[1142], { get: function() {
                return be(this, _$_b839[1142])[_$_b839[842]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]]($e[_$_b839[37]], _$_b839[1379], { get: function() {
                return be(this, _$_b839[1379])[_$_b839[1167]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]]($e[_$_b839[37]], _$_b839[1156], { get: function() {
                return be(this, _$_b839[1156])[_$_b839[1169]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]]($e[_$_b839[37]], _$_b839[967], { get: function() {
                return be(this, _$_b839[967])[_$_b839[1090]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]]($e[_$_b839[37]], _$_b839[600], { get: function() {
                return be(this, _$_b839[600])[_$_b839[628]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]]($e[_$_b839[37]], _$_b839[1009], { get: function() {
                return be(this, _$_b839[1009])[_$_b839[726]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]]($e[_$_b839[37]], _$_b839[1380], { get: function() {
                return be(this, _$_b839[1380]) ? ne[_$_b839[159]](this)[_$_b839[708]]() : null;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]]($e[_$_b839[37]], _$_b839[1381], { get: function() {
                return be(this, _$_b839[1381])[_$_b839[1382]];
              }, set: function(ye) {
                be(this, _$_b839[1381])[_$_b839[1382]] = ye;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]]($e[_$_b839[37]], _$_b839[13], { get: function() {
                return le;
              }, enumerable: !1, configurable: !0 }), $e[_$_b839[37]][_$_b839[75]] = function(ye, Se) {
                be(this, _$_b839[75])[_$_b839[75]](ye, Se);
              }, $e[_$_b839[37]][_$_b839[816]] = function(ye, Se) {
                return be(this, _$_b839[816])[_$_b839[816]](ye, Se);
              }, $e[_$_b839[37]][_$_b839[919]] = function() {
                be(this, _$_b839[1383])[_$_b839[919]]();
              }, $e[_$_b839[37]][_$_b839[805]] = function() {
                be(this, _$_b839[805])[_$_b839[805]]();
              }, $e[_$_b839[37]][_$_b839[846]] = function() {
                be(this, _$_b839[846])[_$_b839[846]]();
              }, $e[_$_b839[37]][_$_b839[165]] = function() {
                var ye = be(this, _$_b839[165])[_$_b839[165]]();
                return ne[_$_b839[797]](this), ve--, ye;
              }, $e[_$_b839[37]][_$_b839[883]] = function() {
                return be(this, _$_b839[883])[_$_b839[883]]();
              }, $e[_$_b839[37]][_$_b839[884]] = function() {
                return be(this, _$_b839[884])[_$_b839[884]]();
              }, $e[_$_b839[37]][_$_b839[868]] = function() {
                return be(this, _$_b839[868])[_$_b839[868]]();
              }, $e[_$_b839[37]][_$_b839[886]] = function() {
                return be(this, _$_b839[886])[_$_b839[886]]();
              }, $e[_$_b839[37]][_$_b839[673]] = function() {
                return be(this, _$_b839[673])[_$_b839[673]]();
              }, $e[_$_b839[37]][_$_b839[875]] = function() {
                return be(this, _$_b839[875])[_$_b839[875]]();
              }, $e[_$_b839[37]][_$_b839[885]] = function() {
                return be(this, _$_b839[885])[_$_b839[885]]();
              }, $e[_$_b839[37]][_$_b839[874]] = function() {
                return be(this, _$_b839[874])[_$_b839[874]]();
              }, $e[_$_b839[37]][_$_b839[687]] = function(ye) {
                return be(this, _$_b839[687])[_$_b839[687]](ye);
              }, $e[_$_b839[37]][_$_b839[977]] = function() {
                return be(this, _$_b839[977])[_$_b839[977]]();
              }, $e[_$_b839[37]][_$_b839[859]] = function(ye) {
                return ye === void 0 && (ye = he[_$_b839[278]][_$_b839[860]]), be(this, _$_b839[859])[_$_b839[859]](_$_b839[618], ye);
              }, $e[_$_b839[37]][_$_b839[880]] = function() {
                return be(this, _$_b839[880])[_$_b839[880]]();
              }, $e[_$_b839[37]][_$_b839[879]] = function() {
                return be(this, _$_b839[879])[_$_b839[879]]();
              }, $e[_$_b839[37]][_$_b839[799]] = function() {
                return be(this, _$_b839[799])[_$_b839[799]]();
              }, $e[_$_b839[37]][_$_b839[259]] = function() {
                return be(this, _$_b839[259])[_$_b839[259]]();
              }, $e[_$_b839[37]][_$_b839[887]] = function() {
                return be(this, _$_b839[887])[_$_b839[887]]();
              }, $e[_$_b839[37]][_$_b839[870]] = function() {
                return be(this, _$_b839[870])[_$_b839[870]]();
              }, $e[_$_b839[37]][_$_b839[882]] = function() {
                return be(this, _$_b839[882])[_$_b839[882]]();
              }, $e[_$_b839[37]][_$_b839[1099]] = function() {
                return be(this, _$_b839[1099])[_$_b839[1099]]();
              }, $e[_$_b839[37]][_$_b839[881]] = function() {
                return be(this, _$_b839[881])[_$_b839[881]]();
              }, $e[_$_b839[37]][_$_b839[688]] = function() {
                return be(this, _$_b839[688])[_$_b839[688]]();
              }, $e[_$_b839[37]][_$_b839[1098]] = function(ye, Se) {
                return be(this, _$_b839[1098])[_$_b839[1098]](ye, Se);
              }, $e[_$_b839[37]][_$_b839[981]] = function() {
                return be(this, _$_b839[981])[_$_b839[981]]();
              }, $e[_$_b839[37]][_$_b839[1133]] = function() {
                return be(this, _$_b839[1133])[_$_b839[1133]]();
              }, $e[_$_b839[37]][_$_b839[982]] = function(ye) {
                return ye === void 0 && (ye = he[_$_b839[985]][_$_b839[984]]), be(this, _$_b839[982])[_$_b839[982]](ye);
              }, $e[_$_b839[37]][_$_b839[1138]] = function(ye) {
                return be(this, _$_b839[1138])[_$_b839[1138]](ye);
              }, $e[_$_b839[37]][_$_b839[871]] = function() {
                return be(this, _$_b839[871])[_$_b839[871]]();
              }, $e[_$_b839[37]][_$_b839[801]] = function() {
                return be(this, _$_b839[801])[_$_b839[801]]();
              }, $e[_$_b839[37]][_$_b839[869]] = function() {
                return be(this, _$_b839[869])[_$_b839[869]]();
              }, $e[_$_b839[37]][_$_b839[889]] = function() {
                return be(this, _$_b839[889])[_$_b839[889]]();
              }, $e[_$_b839[37]][_$_b839[834]] = function() {
                return be(this, _$_b839[834])[_$_b839[834]]();
              }, $e[_$_b839[37]][_$_b839[873]] = function() {
                return be(this, _$_b839[873])[_$_b839[873]]();
              }, $e[_$_b839[37]][_$_b839[804]] = function() {
                return be(this, _$_b839[804])[_$_b839[804]]();
              }, $e[_$_b839[37]][_$_b839[803]] = function() {
                return be(this, _$_b839[803])[_$_b839[803]]();
              }, $e[_$_b839[37]][_$_b839[1130]] = function(ye) {
                return be(this, _$_b839[1130])[_$_b839[1130]](ye);
              }, $e[_$_b839[37]][_$_b839[806]] = function() {
                return be(this, _$_b839[806])[_$_b839[806]]();
              }, $e[_$_b839[37]][_$_b839[820]] = function() {
                return be(this, _$_b839[820])[_$_b839[820]]();
              }, $e[_$_b839[37]][_$_b839[1125]] = function() {
                return be(this, _$_b839[1125])[_$_b839[1125]]();
              }, $e[_$_b839[37]][_$_b839[1123]] = function() {
                return be(this, _$_b839[1123])[_$_b839[1123]]();
              }, $e[_$_b839[37]][_$_b839[872]] = function() {
                return be(this, _$_b839[872])[_$_b839[872]]();
              }, $e[_$_b839[37]][_$_b839[1040]] = function(ye, Se, we) {
                return be(this, _$_b839[1040])[_$_b839[1040]](ye, Se, we);
              }, $e[_$_b839[37]][_$_b839[831]] = function(ye) {
                be(this, _$_b839[831])[_$_b839[831]](ye);
              }, $e[_$_b839[37]][_$_b839[910]] = function(ye) {
                be(this, _$_b839[910])[_$_b839[910]](ye);
              }, $e[_$_b839[37]][_$_b839[386]] = function(ye) {
                return be(this, _$_b839[386])[_$_b839[386]](ye);
              }, $e[_$_b839[37]][_$_b839[96]] = function(ye, Se) {
                be(this, _$_b839[96])[_$_b839[96]](ye, Se);
              }, $e[_$_b839[37]][_$_b839[807]] = function() {
                return be(this, _$_b839[807])[_$_b839[807]]();
              }, $e[_$_b839[37]][_$_b839[392]] = function(ye, Se) {
                return be(this, _$_b839[392])[_$_b839[392]](ye, Se);
              }, $e[_$_b839[37]][_$_b839[821]] = function(ye) {
                return be(this, _$_b839[821])[_$_b839[821]](ye);
              }, $e[_$_b839[37]][_$_b839[640]] = function(ye) {
                be(this, _$_b839[640])[_$_b839[640]](ye);
              }, $e[_$_b839[37]][_$_b839[794]] = function(ye) {
                be(this, _$_b839[794])[_$_b839[794]](ye);
              }, $e[_$_b839[37]][_$_b839[1135]] = function(ye) {
                be(this, _$_b839[1384])[_$_b839[1135]](ye);
              }, $e[_$_b839[37]][_$_b839[915]] = function(ye) {
                be(this, _$_b839[915])[_$_b839[915]](ye);
              }, $e[_$_b839[37]][_$_b839[1007]] = function(ye, Se) {
                be(this, _$_b839[1007])[_$_b839[1007]](ye, Se);
              }, $e[_$_b839[37]][_$_b839[845]] = function(ye) {
                be(this, _$_b839[845])[_$_b839[845]](ye);
              }, $e[_$_b839[37]][_$_b839[1128]] = function(ye) {
                be(this, _$_b839[1128])[_$_b839[1128]](ye);
              }, $e[_$_b839[37]][_$_b839[792]] = function(ye) {
                be(this, _$_b839[792])[_$_b839[792]](ye);
              }, $e[_$_b839[37]][_$_b839[836]] = function(ye, Se) {
                be(this, _$_b839[836])[_$_b839[836]](ye, Se);
              }, $e[_$_b839[37]][_$_b839[978]] = function(ye) {
                return be(this, _$_b839[978])[_$_b839[978]](ye);
              }, $e[_$_b839[37]][_$_b839[838]] = function(ye, Se) {
                be(this, _$_b839[838])[_$_b839[838]](ye, Se);
              }, $e[_$_b839[37]][_$_b839[621]] = function() {
                return be(this, _$_b839[621])[_$_b839[621]]();
              }, $e[_$_b839[37]][_$_b839[835]] = function(ye) {
                be(this, _$_b839[835])[_$_b839[835]](ye);
              }, $e[_$_b839[37]][_$_b839[877]] = function() {
                return be(this, _$_b839[877])[_$_b839[877]]();
              }, $e[_$_b839[37]][_$_b839[878]] = function() {
                return be(this, _$_b839[878])[_$_b839[878]]();
              }, $e[_$_b839[37]][_$_b839[847]] = function() {
                be(this, _$_b839[847])[_$_b839[847]]();
              }, $e[_$_b839[37]][_$_b839[237]] = function() {
                return be(this, _$_b839[237])[_$_b839[237]]();
              }, $e[_$_b839[37]][_$_b839[828]] = function() {
                be(this, _$_b839[828])[_$_b839[828]]();
              }, $e[_$_b839[37]][_$_b839[767]] = function(ye) {
                be(this, _$_b839[767])[_$_b839[767]](ye);
              }, $e[_$_b839[37]][_$_b839[1129]] = function() {
                return be(this, _$_b839[1129])[_$_b839[1129]]();
              }, $e[_$_b839[37]][_$_b839[1101]] = function() {
                return be(this, _$_b839[1101])[_$_b839[1101]]();
              }, $e[_$_b839[37]][_$_b839[1183]] = function(ye) {
                return be(this, _$_b839[1183])[_$_b839[1183]](ye);
              }, $e[_$_b839[37]][_$_b839[1019]] = function(ye, Se) {
                be(this, _$_b839[1019])[_$_b839[1019]](ye, Se);
              }, $e[_$_b839[37]][_$_b839[643]] = function() {
                return be(this, _$_b839[643])[_$_b839[643]]();
              }, Object[_$_b839[82]]($e, _$_b839[1378], { get: function() {
                return fe[_$_b839[347]][_$_b839[373]];
              }, enumerable: !1, configurable: !0 }), $e[_$_b839[1385]] = function(ye) {
                ae[_$_b839[140]][_$_b839[143]](ye);
              }, $e[_$_b839[1386]] = function(ye) {
                if (ve > 0)
                  throw new _e[_$_b839[147]](ue[_$_b839[145]][_$_b839[1387]], void 0, _$_b839[1388]);
                ae[_$_b839[140]][_$_b839[157]](ye);
              }, $e[_$_b839[1389]] = function() {
                return ae[_$_b839[140]][_$_b839[160]]();
              }, ie([(0, ce[_$_b839[1193]])(_$_b839[1390])], $e[_$_b839[37]], _$_b839[44], null), ie([se[_$_b839[586]]], $e[_$_b839[37]], _$_b839[1378], null), ie([se[_$_b839[586]]], $e[_$_b839[37]], _$_b839[644], null), ie([se[_$_b839[586]]], $e[_$_b839[37]], _$_b839[1142], null), ie([se[_$_b839[586]]], $e[_$_b839[37]], _$_b839[1379], null), ie([se[_$_b839[586]]], $e[_$_b839[37]], _$_b839[1156], null), ie([se[_$_b839[586]]], $e[_$_b839[37]], _$_b839[967], null), ie([se[_$_b839[586]]], $e[_$_b839[37]], _$_b839[600], null), ie([se[_$_b839[586]]], $e[_$_b839[37]], _$_b839[1009], null), ie([se[_$_b839[586]]], $e[_$_b839[37]], _$_b839[1380], null), ie([se[_$_b839[586]]], $e[_$_b839[37]], _$_b839[1381], null), ie([se[_$_b839[586]]], $e[_$_b839[37]], _$_b839[13], null), $e;
            }();
            te[_$_b839[346]] = pe;
          }, 33696: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[212]] || function() {
              var ve = function(me, be) {
                return ve = Object[_$_b839[213]] || { __proto__: [] } instanceof Array && function(pe, $e) {
                  pe[_$_b839[214]] = $e;
                } || function(pe, $e) {
                  for (var ye in $e)
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]]($e, ye) && (pe[ye] = $e[ye]);
                }, ve(me, be);
              };
              return function(me, be) {
                if (_$_b839[34] != typeof be && be !== null)
                  throw new TypeError(_$_b839[216] + String(be) + _$_b839[217]);
                function pe() {
                  this[_$_b839[105]] = me;
                }
                ve(me, be), me[_$_b839[37]] = be === null ? Object[_$_b839[52]](be) : (pe[_$_b839[37]] = be[_$_b839[37]], new pe());
              };
            }();
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[278]] = te[_$_b839[985]] = te[_$_b839[1018]] = te[_$_b839[1374]] = te[_$_b839[1222]] = te[_$_b839[271]] = te[_$_b839[296]] = te[_$_b839[744]] = te[_$_b839[814]] = void 0;
            var ne = ee(25550), ae = ee(28764), ue = ee(40362);
            Object[_$_b839[82]](te, _$_b839[814], { enumerable: !0, get: function() {
              return ue[_$_b839[814]];
            } });
            var _e, fe, le, se = ee(83091);
            Object[_$_b839[82]](te, _$_b839[744], { enumerable: !0, get: function() {
              return se[_$_b839[744]];
            } }), function(ve) {
              ve[_$_b839[301]] = _$_b839[1391], ve[_$_b839[295]] = _$_b839[757], ve[_$_b839[192]] = _$_b839[967], ve[_$_b839[1392]] = _$_b839[1393];
            }(_e || (te[_$_b839[296]] = _e = {})), function(ve) {
              ve[_$_b839[270]] = _$_b839[1394], ve[_$_b839[272]] = _$_b839[1395];
            }(fe || (te[_$_b839[271]] = fe = {})), function(ve) {
              ve[_$_b839[1225]] = _$_b839[265], ve[_$_b839[1226]] = _$_b839[998], ve[_$_b839[1227]] = _$_b839[38], ve[_$_b839[1228]] = _$_b839[73], ve[_$_b839[1223]] = _$_b839[96];
            }(le || (te[_$_b839[1222]] = le = {}));
            var oe, ce, he, ge = function(ve) {
              function me(be) {
                return ve[_$_b839[36]](this, ne[_$_b839[145]][_$_b839[1080]], void 0, _$_b839[1397][_$_b839[41]](be, _$_b839[1396])) || this;
              }
              return ie(me, ve), me;
            }(ae[_$_b839[147]]);
            te[_$_b839[1374]] = ge, function(ve) {
              ve[_$_b839[1017]] = _$_b839[1398], ve[_$_b839[1184]] = _$_b839[1399], ve[_$_b839[1400]] = _$_b839[1401];
            }(oe || (te[_$_b839[1018]] = oe = {})), function(ve) {
              ve[_$_b839[984]] = _$_b839[1402], ve[_$_b839[987]] = _$_b839[142], ve[_$_b839[989]] = _$_b839[1403];
            }(ce || (te[_$_b839[985]] = ce = {})), function(ve) {
              ve[_$_b839[277]] = _$_b839[1404], ve[_$_b839[860]] = _$_b839[1405];
            }(he || (te[_$_b839[278]] = he = {}));
          }, 82334: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1166]] = void 0;
            var ee = function() {
              function ie() {
              }
              return ie[_$_b839[52]] = function(ne) {
                return new (function() {
                  function ae() {
                  }
                  return ae[_$_b839[37]][_$_b839[287]] = function(ue, _e, fe) {
                    ne[_$_b839[861]](ue, _e, fe);
                  }, ae[_$_b839[37]][_$_b839[841]] = function(ue, _e) {
                    return ne[_$_b839[269]](ue, _e);
                  }, ae;
                }())();
              }, ie;
            }();
            te[_$_b839[1166]] = ee;
          }, 25226: function(re, te) {
            _$_b839[32];
            var ee, ie, ne, ae;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1406]] = te[_$_b839[1407]] = te[_$_b839[1408]] = te[_$_b839[1409]] = void 0, function(ue) {
              ue[_$_b839[1410]] = _$_b839[240], ue[_$_b839[1411]] = _$_b839[241], ue[_$_b839[1412]] = _$_b839[1413];
            }(ee || (te[_$_b839[1409]] = ee = {})), function(ue) {
              ue[_$_b839[1414]] = _$_b839[1415], ue[_$_b839[1416]] = _$_b839[1417], ue[_$_b839[1418]] = _$_b839[1419], ue[_$_b839[1420]] = _$_b839[1421], ue[_$_b839[1422]] = _$_b839[1423];
            }(ie || (te[_$_b839[1408]] = ie = {})), function(ue) {
              ue[_$_b839[1424]] = _$_b839[1425], ue[_$_b839[1426]] = _$_b839[1427];
            }(ne || (te[_$_b839[1407]] = ne = {})), function(ue) {
              ue[_$_b839[1428]] = _$_b839[1429], ue[_$_b839[1430]] = _$_b839[1431], ue[_$_b839[1432]] = _$_b839[1433];
            }(ae || (te[_$_b839[1406]] = ae = {}));
          }, 62987: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[763]] = void 0;
            var ie = ee(47384), ne = ee(60997), ae = ee(87326), ue = ee(88141), _e = ee(61489), fe = ee(13533), le = ee(77845), se = ee(54838), oe = ee(3570), ce = function() {
              function he(ge) {
                this[_$_b839[1434]] = ge[_$_b839[1434]], this[_$_b839[1200]] = se[_$_b839[1022]][_$_b839[1377]](), this[_$_b839[1435]] = ge[_$_b839[1435]] || { playback: {} }, this[_$_b839[716]] = ge[_$_b839[716]], this[_$_b839[809]] = ge[_$_b839[809]] || ae[_$_b839[714]], this[_$_b839[1436]] = new ie[_$_b839[279]](this[_$_b839[809]][_$_b839[1437]], ge[_$_b839[280]]), this[_$_b839[1438]] = ge[_$_b839[675]] || null, this[_$_b839[1439]](), this[_$_b839[280]] = ge[_$_b839[280]], this[_$_b839[626]] = ge[_$_b839[626]], this[_$_b839[635]] = ge[_$_b839[635]], this[_$_b839[760]] = ge[_$_b839[760]], this[_$_b839[761]] = ge[_$_b839[761]], this[_$_b839[762]] = ge[_$_b839[762]], this[_$_b839[655]] = oe[_$_b839[771]][_$_b839[770]](this, ge[_$_b839[655]]), this[_$_b839[1440]] = !1;
              }
              return he[_$_b839[37]][_$_b839[1439]] = function() {
                this[_$_b839[731]] = new le[_$_b839[1196]]((0, fe[_$_b839[107]])(), _$_b839[1441], this[_$_b839[1200]]), this[_$_b839[731]][_$_b839[1198]](_$_b839[732], _e[_$_b839[1442]]), this[_$_b839[731]][_$_b839[1198]](_$_b839[1443], ue[_$_b839[1444]]);
              }, he[_$_b839[37]][_$_b839[1202]] = function(ge) {
                this[_$_b839[631]] = ge;
              }, he[_$_b839[37]][_$_b839[1445]] = function(ge) {
                this[_$_b839[1446]] = ge;
              }, Object[_$_b839[82]](he[_$_b839[37]], _$_b839[1447], { get: function() {
                return this[_$_b839[1440]];
              }, enumerable: !1, configurable: !0 }), he[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[1440]] = !0, this[_$_b839[635]] = (0, ne[_$_b839[340]])(this[_$_b839[635]]), this[_$_b839[1446]] = null, this[_$_b839[1438]] = null, this[_$_b839[626]] = null, this[_$_b839[760]] = null, this[_$_b839[761]] = null, this[_$_b839[762]] = null, this[_$_b839[731]] = (0, ne[_$_b839[340]])(this[_$_b839[731]]);
              }, he;
            }();
            te[_$_b839[763]] = ce;
          }, 36334: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[721]] = void 0;
            var ie = ee(91520), ne = ee(16368), ae = ee(25550), ue = ee(28764), _e = ee(33696), fe = ee(13533), le = ee(43485), se = ee(82315), oe = 1e7, ce = function() {
              function he() {
                this[_$_b839[1448]] = se[_$_b839[1449]][_$_b839[784]]();
              }
              return he[_$_b839[1450]] = function(ge, ve, me, be) {
                return he[_$_b839[1451]](ve) ? ge ? new ue[_$_b839[147]](ae[_$_b839[145]][_$_b839[1452]], { "player-type": ge[_$_b839[732]], "supported-tech": JSON[_$_b839[282]](me) }, _$_b839[1453]) : ve[_$_b839[215]](_$_b839[644]) ? new ue[_$_b839[147]](ae[_$_b839[145]][_$_b839[1087]], void 0, _$_b839[1088]) : be ? new ue[_$_b839[147]](ae[_$_b839[145]][_$_b839[1085]], void 0, _$_b839[1086]) : new ue[_$_b839[147]](ae[_$_b839[145]][_$_b839[1454]], { "supported-tech": JSON[_$_b839[282]](me) }, _$_b839[1086]) : new ue[_$_b839[147]](ae[_$_b839[145]][_$_b839[917]], { source: ve }, _$_b839[1455]);
              }, he[_$_b839[1451]] = function(ge) {
                var ve, me, be, pe;
                return ge && !!((pe = (be = (me = (ve = ge[_$_b839[745]]) !== null && ve !== void 0 ? ve : ge[_$_b839[747]]) !== null && me !== void 0 ? me : ge[_$_b839[749]]) !== null && be !== void 0 ? be : ge[_$_b839[750]]) !== null && pe !== void 0 ? pe : ge[_$_b839[752]]);
              }, he[_$_b839[37]][_$_b839[784]] = function(ge) {
                var ve = Object[_$_b839[42]](ge[_$_b839[829]]), me = (0, fe[_$_b839[646]])()[_$_b839[983]], be = (0, le[_$_b839[1212]])(ge[_$_b839[1435]][_$_b839[666]]()[_$_b839[1211]], ge[_$_b839[829]], ge[_$_b839[1456]]);
                if (ve[_$_b839[26]] > 0 && !he[_$_b839[1451]](ge[_$_b839[829]]))
                  return Promise[_$_b839[913]](new ue[_$_b839[147]](ae[_$_b839[145]][_$_b839[1258]], { streamType: JSON[_$_b839[282]](ve), supportedTech: JSON[_$_b839[282]](me) }, _$_b839[1457]));
                if (ve[_$_b839[26]] > 0 && !be)
                  return Promise[_$_b839[913]](he[_$_b839[1450]](ge[_$_b839[1456]], ge[_$_b839[829]], me, be));
                if (ve[_$_b839[26]] <= 0 && !me[_$_b839[26]])
                  return Promise[_$_b839[913]](he[_$_b839[1450]](ge[_$_b839[1456]], ge[_$_b839[829]], me));
                ve[_$_b839[26]] <= 0 && (be = me[0]);
                var pe = ge[_$_b839[91]][_$_b839[655]][_$_b839[769]]();
                ge[_$_b839[629]] ? ge[_$_b839[629]][_$_b839[1458]](pe) : !pe[_$_b839[1003]] && ge[_$_b839[675]] && ge[_$_b839[675]][_$_b839[1023]](pe), pe[_$_b839[402]] = ge[_$_b839[1459]][_$_b839[402]], pe[_$_b839[837]] = ge[_$_b839[1459]][_$_b839[837]] / 100;
                var $e = ge[_$_b839[1435]][_$_b839[1156]](), ye = $e[_$_b839[1461]][_$_b839[1460]];
                if ((0, fe[_$_b839[646]])()[_$_b839[1462]] && ($e[_$_b839[1461]][_$_b839[1460]] = Math[_$_b839[247]](ye, oe), $e[_$_b839[1463]] = !0), be) {
                  var Se = he[_$_b839[1464]](ge[_$_b839[91]], be);
                  ge[_$_b839[91]][_$_b839[1445]](Se);
                }
                return this[_$_b839[1027]](ge[_$_b839[91]], be);
              }, he[_$_b839[1464]] = function(ge, ve) {
                return ve[_$_b839[732]] === _e[_$_b839[814]][_$_b839[1465]] ? ((0, fe[_$_b839[646]])()[_$_b839[1466]] || ge[_$_b839[809]][_$_b839[1467]]) && ie[_$_b839[140]][_$_b839[152]](ne[_$_b839[168]][_$_b839[200]]) ? new (ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[200]])[_$_b839[1468]]())(ge) : (0, fe[_$_b839[646]])()[_$_b839[1469]] && ie[_$_b839[140]][_$_b839[152]](ne[_$_b839[168]][_$_b839[201]]) ? new (ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[201]])[_$_b839[1470]]())(ge) : (0, fe[_$_b839[646]])()[_$_b839[1471]] && ie[_$_b839[140]][_$_b839[152]](ne[_$_b839[168]][_$_b839[208]]) ? new (ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[208]])[_$_b839[1472]]())(ge) : (0, fe[_$_b839[646]])()[_$_b839[1473]] && ie[_$_b839[140]][_$_b839[152]](ne[_$_b839[168]][_$_b839[209]]) ? new (ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[209]])[_$_b839[1474]]())(ge) : (0, fe[_$_b839[646]])()[_$_b839[1475]] && ie[_$_b839[140]][_$_b839[152]](ne[_$_b839[168]][_$_b839[203]]) ? new (ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[203]])[_$_b839[1476]]())(ge) : new (ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[180]]))[_$_b839[1477]](ge) : null;
              }, he[_$_b839[37]][_$_b839[1027]] = function(ge, ve) {
                var me, be = this;
                if (!ge[_$_b839[1446]] && ve[_$_b839[732]] === _e[_$_b839[814]][_$_b839[1465]])
                  return Promise[_$_b839[913]](new ue[_$_b839[147]](ae[_$_b839[145]][_$_b839[1478]], { tech: JSON[_$_b839[282]](ve) }, _$_b839[1479]));
                if (!this[_$_b839[1480]] && ie[_$_b839[140]][_$_b839[152]](ne[_$_b839[168]][_$_b839[179]])) {
                  var pe = ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[179]])[_$_b839[1481]];
                  this[_$_b839[1480]] = new pe(ge, this[_$_b839[1448]]);
                }
                if (ve[_$_b839[732]] === _e[_$_b839[814]][_$_b839[1482]]) {
                  var $e = ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[210]])[_$_b839[1483]];
                  me = Promise[_$_b839[602]](new $e(ge));
                } else if (ve[_$_b839[732]] === _e[_$_b839[814]][_$_b839[813]]) {
                  var ye = ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[182]])[_$_b839[1484]];
                  me = Promise[_$_b839[602]](new ye(ge));
                } else {
                  if (ve[_$_b839[732]] !== _e[_$_b839[814]][_$_b839[1465]])
                    return Promise[_$_b839[913]](new ue[_$_b839[147]](ae[_$_b839[145]][_$_b839[1258]], { given: ve[_$_b839[732]], supported: _$_b839[1485] }, _$_b839[1486]));
                  me = ge[_$_b839[1446]][_$_b839[384]]()[_$_b839[166]](function() {
                    return new (ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[183]]))[_$_b839[1487]](ge);
                  });
                }
                return me[_$_b839[166]](function(Se) {
                  return be[_$_b839[1480]] ? be[_$_b839[1480]][_$_b839[1488]](ge, Se) : Se;
                })[_$_b839[166]](function(Se) {
                  return { context: ge, logger: ge[_$_b839[280]], bitdashPlayer: Se, technology: ve, videoElement: ge[_$_b839[655]] };
                });
              }, he;
            }();
            te[_$_b839[721]] = ce;
          }, 59510: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[893]] = void 0;
            var ie = ee(18665), ne = ee(62510), ae = ee(17990), ue = ee(58975), _e = ee(76420), fe = function() {
              function le(se) {
                var oe = this;
                this[_$_b839[1489]] = function() {
                  oe[_$_b839[1491]]((0, ae[_$_b839[1490]])(!1));
                }, this[_$_b839[1492]] = function() {
                  oe[_$_b839[1491]]((0, ae[_$_b839[1490]])(!0));
                }, this[_$_b839[787]] = function() {
                  return ue[_$_b839[787]](oe[_$_b839[91]][_$_b839[731]][_$_b839[136]]());
                }, this[_$_b839[1491]] = function(ce) {
                  oe[_$_b839[91]][_$_b839[731]][_$_b839[138]](ce);
                }, this[_$_b839[1493]] = function(ce, he) {
                  oe[_$_b839[1494]] !== ce && (oe[_$_b839[1494]] = ce, oe[_$_b839[1491]]((0, ae[_$_b839[1495]])(ce))), he && he();
                }, this[_$_b839[1496]] = function(ce, he) {
                  if (oe[_$_b839[1494]] !== ce)
                    oe[_$_b839[1494]] = ce, oe[_$_b839[1491]]((0, ae[_$_b839[1497]])(ce));
                  else {
                    if (!oe[_$_b839[1498]](ce))
                      return;
                    oe[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[1500][_$_b839[41]](_e[_$_b839[1499]][ce])), oe[_$_b839[1491]]((0, ae[_$_b839[1501]])(0));
                  }
                  he && he();
                }, this[_$_b839[91]] = se, this[_$_b839[626]] = se[_$_b839[626]], this[_$_b839[626]][_$_b839[75]](ne[_$_b839[382]][_$_b839[387]], this[_$_b839[1492]], !0), this[_$_b839[626]][_$_b839[75]](ne[_$_b839[382]][_$_b839[507]], this[_$_b839[1489]], !0), this[_$_b839[1491]]((0, ae[_$_b839[1503]])([_$_b839[1182], _$_b839[1502]])), this[_$_b839[1504]] = se[_$_b839[635]][_$_b839[159]](ie[_$_b839[637]][_$_b839[1047]]), this[_$_b839[1505]] = !1;
              }
              return le[_$_b839[37]][_$_b839[706]] = function() {
                this[_$_b839[1506]](!1), this[_$_b839[1507]](), this[_$_b839[1494]] = _e[_$_b839[1499]][_$_b839[1508]], this[_$_b839[1509]] = _e[_$_b839[1510]][_$_b839[1508]];
              }, Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1494], { get: function() {
                return this[_$_b839[787]]()[_$_b839[1494]];
              }, set: function(se) {
                var oe = this[_$_b839[787]]()[_$_b839[1494]];
                this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[1512][_$_b839[41]](_e[_$_b839[1499]][oe], _$_b839[1511])[_$_b839[41]](_e[_$_b839[1499]][se])), this[_$_b839[1491]]((0, ae[_$_b839[1513]])(se));
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1509], { get: function() {
                return this[_$_b839[787]]()[_$_b839[1509]];
              }, set: function(se) {
                var oe = this[_$_b839[787]]()[_$_b839[1509]];
                this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[1514][_$_b839[41]](_e[_$_b839[1510]][oe], _$_b839[1511])[_$_b839[41]](_e[_$_b839[1510]][se])), this[_$_b839[1491]]((0, ae[_$_b839[1515]])(se));
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1516], { get: function() {
                return this[_$_b839[787]]()[_$_b839[1516]];
              }, set: function(se) {
                var oe = this[_$_b839[787]]()[_$_b839[1516]];
                this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[1518][_$_b839[41]](_e[_$_b839[1517]][oe], _$_b839[1511])[_$_b839[41]](_e[_$_b839[1517]][se])), this[_$_b839[1491]]((0, ae[_$_b839[1519]])(se));
              }, enumerable: !1, configurable: !0 }), le[_$_b839[37]][_$_b839[1520]] = function(se, oe, ce, he) {
                this[_$_b839[1509]] = se, he && this[_$_b839[626]][_$_b839[739]](ne[_$_b839[382]][_$_b839[391]], { position: this[_$_b839[859]](), seekTarget: oe, issuer: ce || _$_b839[618] }), this[_$_b839[1491]]((0, ae[_$_b839[1521]])(oe));
              }, le[_$_b839[37]][_$_b839[1522]] = function(se, oe, ce) {
                ce === void 0 && (ce = !0), this[_$_b839[1520]](_e[_$_b839[1510]][_$_b839[1523]], se, oe, ce);
              }, le[_$_b839[37]][_$_b839[1524]] = function(se, oe, ce) {
                return ce === void 0 && (ce = !0), this[_$_b839[1520]](_e[_$_b839[1510]][_$_b839[1525]], se, oe, ce);
              }, le[_$_b839[37]][_$_b839[1506]] = function(se) {
                se === void 0 && (se = !0), this[_$_b839[1526]]() && (this[_$_b839[1509]] = _e[_$_b839[1510]][_$_b839[393]], se && this[_$_b839[626]][_$_b839[739]](ne[_$_b839[382]][_$_b839[393]])), this[_$_b839[1527]]();
              }, le[_$_b839[37]][_$_b839[1527]] = function() {
                this[_$_b839[1491]]((0, ae[_$_b839[1521]])(-1));
              }, le[_$_b839[37]][_$_b839[1526]] = function() {
                return ue[_$_b839[1528]](this[_$_b839[787]]());
              }, le[_$_b839[37]][_$_b839[1529]] = function(se, oe, ce, he) {
                he === void 0 && (he = !0), this[_$_b839[1491]]((0, ae[_$_b839[1519]])(_e[_$_b839[1517]][_$_b839[1530]])), he && this[_$_b839[626]][_$_b839[739]](ne[_$_b839[382]][_$_b839[395]], { position: se, target: oe, issuer: ce || _$_b839[618] }), this[_$_b839[1491]]((0, ae[_$_b839[1521]])(oe));
              }, le[_$_b839[37]][_$_b839[1531]] = function(se) {
                se === void 0 && (se = !0), this[_$_b839[1491]]((0, ae[_$_b839[1519]])(_e[_$_b839[1517]][_$_b839[1532]])), se && this[_$_b839[626]][_$_b839[739]](ne[_$_b839[382]][_$_b839[397]]), this[_$_b839[1527]]();
              }, le[_$_b839[37]][_$_b839[1533]] = function() {
                this[_$_b839[1491]]((0, ae[_$_b839[1513]])(_e[_$_b839[1499]][_$_b839[1534]]));
              }, le[_$_b839[37]][_$_b839[1535]] = function() {
                return ue[_$_b839[1536]](this[_$_b839[787]]());
              }, le[_$_b839[37]][_$_b839[1537]] = function() {
                return ue[_$_b839[1538]](this[_$_b839[787]]());
              }, Object[_$_b839[82]](le[_$_b839[37]], _$_b839[872], { get: function() {
                return this[_$_b839[787]]()[_$_b839[872]];
              }, set: function(se) {
                this[_$_b839[1491]]((0, ae[_$_b839[1539]])(se));
              }, enumerable: !1, configurable: !0 }), le[_$_b839[37]][_$_b839[1540]] = function(se) {
                this[_$_b839[1491]]((0, ae[_$_b839[1541]])(se)), se && this[_$_b839[1123]]() && !this[_$_b839[1542]]() && (this[_$_b839[1505]] = !0), se ? this[_$_b839[1543]]() : this[_$_b839[1507]]();
              }, le[_$_b839[37]][_$_b839[1544]] = function() {
                return ue[_$_b839[1545]](this[_$_b839[787]]());
              }, le[_$_b839[37]][_$_b839[1123]] = function() {
                return ue[_$_b839[1546]](this[_$_b839[787]]());
              }, le[_$_b839[37]][_$_b839[1547]] = function() {
                return ue[_$_b839[1548]](this[_$_b839[787]]());
              }, le[_$_b839[37]][_$_b839[1125]] = function() {
                return ue[_$_b839[1549]](this[_$_b839[787]]());
              }, le[_$_b839[37]][_$_b839[1550]] = function() {
                return ue[_$_b839[788]](this[_$_b839[787]]());
              }, le[_$_b839[37]][_$_b839[1543]] = function() {
                this[_$_b839[1547]]() || this[_$_b839[1526]]() || this[_$_b839[1537]]() || !(!this[_$_b839[1526]]() && !this[_$_b839[1537]]()) || this[_$_b839[872]] || this[_$_b839[1125]]() || this[_$_b839[1550]]() || (this[_$_b839[872]] = !0, this[_$_b839[1504]][_$_b839[1551]](), this[_$_b839[626]][_$_b839[739]](ne[_$_b839[382]][_$_b839[412]], {}));
              }, le[_$_b839[37]][_$_b839[1507]] = function() {
                this[_$_b839[872]] && (this[_$_b839[872]] = !1, this[_$_b839[1504]][_$_b839[1552]](), this[_$_b839[626]][_$_b839[739]](ne[_$_b839[382]][_$_b839[414]], {}));
              }, le[_$_b839[37]][_$_b839[1542]] = function() {
                return this[_$_b839[1498]](_e[_$_b839[1499]][_$_b839[389]]);
              }, le[_$_b839[37]][_$_b839[1498]] = function(se) {
                return this[_$_b839[787]]()[_$_b839[1553]][0] === se;
              }, le[_$_b839[37]][_$_b839[859]] = function() {
                return this[_$_b839[91]][_$_b839[655]][_$_b839[1554]];
              }, le[_$_b839[37]][_$_b839[1555]] = function(se, oe, ce) {
                var he = this;
                this[_$_b839[1123]]() || (se ? ce(_e[_$_b839[1499]][_$_b839[385]], function() {
                  he[_$_b839[626]][_$_b839[739]](ne[_$_b839[382]][_$_b839[385]], { time: he[_$_b839[859]](), issuer: oe }, !1);
                }) : ce(_e[_$_b839[1499]][_$_b839[385]]));
              }, le[_$_b839[37]][_$_b839[892]] = function(se, oe) {
                this[_$_b839[1555]](se, oe, this[_$_b839[1496]]);
              }, le[_$_b839[37]][_$_b839[1556]] = function(se, oe) {
                this[_$_b839[1555]](se, oe, this[_$_b839[1493]]);
              }, le[_$_b839[37]][_$_b839[1557]] = function(se, oe) {
                var ce = this;
                oe === void 0 && (oe = !0), this[_$_b839[1496]](_e[_$_b839[1499]][_$_b839[387]], function() {
                  oe && ce[_$_b839[626]][_$_b839[739]](ne[_$_b839[382]][_$_b839[387]], { time: ce[_$_b839[859]](), issuer: se }, !1);
                });
              }, le[_$_b839[37]][_$_b839[912]] = function(se, oe, ce) {
                var he = this;
                if (ce === void 0 && (ce = !1), ce && this[_$_b839[1505]])
                  return this[_$_b839[91]][_$_b839[280]][_$_b839[1162]](_$_b839[1558]), void (this[_$_b839[1505]] = !1);
                this[_$_b839[1505]] = !1, se && this[_$_b839[872]] && this[_$_b839[1507]](), this[_$_b839[91]][_$_b839[655]][_$_b839[1559]] || (se ? this[_$_b839[1496]](_e[_$_b839[1499]][_$_b839[389]], function() {
                  he[_$_b839[626]][_$_b839[739]](ne[_$_b839[382]][_$_b839[389]], { time: he[_$_b839[859]](), issuer: oe }, !1);
                }) : this[_$_b839[1493]](_e[_$_b839[1499]][_$_b839[389]]));
              }, Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1560], { get: function() {
                return this[_$_b839[787]]()[_$_b839[1560]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[914], { get: function() {
                var se = this[_$_b839[787]]()[_$_b839[914]];
                return se[_$_b839[1561]] * se[_$_b839[1562]];
              }, enumerable: !1, configurable: !0 }), le[_$_b839[37]][_$_b839[915]] = function(se, oe, ce) {
                oe === void 0 && (oe = 1), ce === void 0 && (ce = !0);
                var he = ue[_$_b839[1099]](this[_$_b839[787]]());
                he[_$_b839[1561]] === se && he[_$_b839[1562]] === oe || (this[_$_b839[1491]]((0, ae[_$_b839[1563]])({ speed: se, multiplier: oe })), ce && this[_$_b839[626]][_$_b839[739]](ne[_$_b839[382]][_$_b839[526]], { from: he[_$_b839[1561]], to: se }));
              }, Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1564], { get: function() {
                return ue[_$_b839[1565]](this[_$_b839[787]]());
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1566], { get: function() {
                return ue[_$_b839[1567]](this[_$_b839[787]]());
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1568], { get: function() {
                return ue[_$_b839[1569]](this[_$_b839[787]]());
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1570], { get: function() {
                return this[_$_b839[787]]()[_$_b839[1570]];
              }, enumerable: !1, configurable: !0 }), le[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[626]][_$_b839[96]](ne[_$_b839[382]][_$_b839[387]], this[_$_b839[1492]]), this[_$_b839[626]][_$_b839[96]](ne[_$_b839[382]][_$_b839[507]], this[_$_b839[1489]]);
              }, le;
            }();
            te[_$_b839[893]] = fe;
          }, 40362: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[814]] = void 0, function(ie) {
              ie[_$_b839[1465]] = _$_b839[1571], ie[_$_b839[813]] = _$_b839[1572], ie[_$_b839[1482]] = _$_b839[1573], ie[_$_b839[924]] = _$_b839[1316];
            }(ee || (te[_$_b839[814]] = ee = {}));
          }, 68329: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1574]] = ne, te[_$_b839[1575]] = ae, te[_$_b839[1576]] = ue, te[_$_b839[1577]] = _e;
            var ie = ee(331);
            function ne(fe) {
              return new Date(Date[_$_b839[283]](fe[_$_b839[1579]]) + (0, ie[_$_b839[1266]])(fe[_$_b839[1341]]))[_$_b839[1578]]();
            }
            function ae(fe, le) {
              var se = {}, oe = function(ce) {
                var he = ce[_$_b839[1580]], ge = ce[_$_b839[1581]];
                return he ? _$_b839[90][_$_b839[41]](ge, _$_b839[1582])[_$_b839[41]](he) : ge;
              };
              return le[_$_b839[113]](function(ce) {
                return se[oe(ce)] = ce;
              }), fe[_$_b839[113]](function(ce) {
                se[oe(ce)] && (se[oe(ce)] = ce);
              }), Object[_$_b839[1083]](se);
            }
            function ue(fe, le) {
              return le[_$_b839[113]](function(se) {
                return se[_$_b839[1583]] = !1;
              }), fe[_$_b839[26]] === 0 ? le : ae(fe, le);
            }
            function _e(fe, le, se) {
              if (fe[le]) {
                var oe, ce = function() {
                  oe = se;
                  for (var he = le - 1; he >= 0; he--)
                    fe[he][_$_b839[1584]] = oe - fe[he][_$_b839[1341]], oe -= fe[he][_$_b839[1341]];
                };
                (function() {
                  oe = se;
                  for (var he = le; he < fe[_$_b839[26]]; he++)
                    fe[he][_$_b839[1584]] = oe, oe += fe[he][_$_b839[1341]];
                })(), ce();
              }
            }
          }, 87326: function(re, te, ee) {
            _$_b839[32];
            var ie, ne, ae, ue;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[714]] = te[_$_b839[1585]] = void 0;
            var _e = ee(67345), fe = ee(33696);
            te[_$_b839[1585]] = { TARGET_BITRATE_FACTOR: 1, TARGET_BUFFER_FACTOR: 0.8, BITRATE_MODIFIER_FUNCTION_TYPE: _$_b839[998], USE_RATE_BASED_SELECTION_ON_SEEKING: !1 }, te[_$_b839[714]] = { TARGET_BUFFER_LEVEL: (ie = {}, ie[fe[_$_b839[296]][_$_b839[295]]] = (ne = {}, ne[fe[_$_b839[271]][_$_b839[270]]] = 40, ne[fe[_$_b839[271]][_$_b839[272]]] = 20, ne), ie[fe[_$_b839[296]][_$_b839[301]]] = (ae = {}, ae[fe[_$_b839[271]][_$_b839[270]]] = 40, ae[fe[_$_b839[271]][_$_b839[272]]] = 20, ae), ie), BUFFER_LOGIC_ACTIVATION_THRESHOLD: 10, MIN_TIMELINE_LIVE_OFFSET: 4, RETRY_DELAY: 2, MAX_INCREASE_RETRY_DELAY_SEC: 30, INCREASE_RETRY_DELAY: !0, INCREASE_RETRY_DELAY_BASE_SEC: 0.25, DISABLE_RETRY_FOR_RESPONSE_STATUS: (ue = {}, ue[_e[_$_b839[1272]][_$_b839[1273]]] = [], ue[_e[_$_b839[1272]][_$_b839[1275]]] = [], ue[_e[_$_b839[1272]][_$_b839[1277]]] = [], ue[_e[_$_b839[1272]][_$_b839[1279]]] = [], ue[_e[_$_b839[1272]][_$_b839[1281]]] = [], ue[_e[_$_b839[1272]][_$_b839[1283]]] = [], ue[_e[_$_b839[1272]][_$_b839[1285]]] = [], ue[_e[_$_b839[1272]][_$_b839[1287]]] = [], ue[_e[_$_b839[1272]][_$_b839[1289]]] = [], ue[_e[_$_b839[1272]][_$_b839[1291]]] = [], ue[_e[_$_b839[1272]][_$_b839[1293]]] = [], ue[_e[_$_b839[1272]][_$_b839[1295]]] = [], ue[_e[_$_b839[1272]][_$_b839[1297]]] = [], ue[_e[_$_b839[1272]][_$_b839[1299]]] = [], ue[_e[_$_b839[1272]][_$_b839[1301]]] = [], ue[_e[_$_b839[1272]][_$_b839[1303]]] = [], ue[_e[_$_b839[1272]][_$_b839[1305]]] = [], ue[_e[_$_b839[1272]][_$_b839[1307]]] = [], ue[_e[_$_b839[1272]][_$_b839[1309]]] = [], ue[_e[_$_b839[1272]][_$_b839[1311]]] = [], ue[_e[_$_b839[1272]][_$_b839[1313]]] = [], ue[_e[_$_b839[1272]][_$_b839[1317]]] = [], ue[_e[_$_b839[1272]][_$_b839[1315]]] = [], ue), METRIC_HISTORY_SIZE: 30, DEFAULT_ADAPTATION_RULE_HISTORY_SIZE: 40, LOG_LEVEL: 2, LOG_PREFIX: _$_b839[90], RESTART_THRESHOLD: 0.9, RESTART_THRESHOLD_DELTA: 0.5, STARTUP_THRESHOLD: 0.9, STARTUP_THRESHOLD_DELTA: 0.5, START_SEARCHING_END: 2, MAX_RETRIES: 2, MAX_CDN_RETRIES: 2, MAX_MPD_RETRIES: 2, MPD_RETRY_DELAY: 0.5, MPD_UPDATE_PERIOD_TOLERANCE: 5, DRM_MAX_RETRIES: 1, DRM_RETRY_DELAY: 0.25, DRM_WITH_CREDENTIALS: !1, CAST_APPLICATION_ID: _$_b839[1586], CAST_MESSAGE_NAMESPACE: _$_b839[1587], BUFFER_VISIBILITY_DELAY: 2, MIN_SELECTABLE_VIDEO_BITRATE: 0, MAX_SELECTABLE_VIDEO_BITRATE: 1 / 0, EXCLUDE_DISALLOWED_REPRESENTATIONS: !1, MIN_SELECTABLE_AUDIO_BITRATE: 0, MAX_SELECTABLE_AUDIO_BITRATE: 1 / 0, XHR_TIMEOUT: 20, QUERY_PARAMETERS: void 0, GAP_TOLERANCE: 0.1, END_OF_BUFFER_TOLERANCE: 0.1, END_OF_BUFFER_RECOVERY_TOLERANCE: 0.5, MAX_POTENTIAL_GAP_TIME_DEVIATION: 0.125, SEEK_TO_END_OFFSET: 2, MINIMUM_ALLOWED_UPDATE_PERIOD: 1, MAXIMUM_ALLOWED_UPDATE_PERIOD: 1 / 0, GLOBAL_DISABLE_SEEKING: !1, PRE_ROLL_RESTORE_THRESHOLD: 0.25, IOS_MIN_TIMEUPDATES_AFTER_AD: 2, HTTP_HEADERS: {}, DOWNLOAD_DURATION_SAFETY_MARGIN: 0.4, MAXIMUM_DOWNLOAD_DURATION_MULTIPLIER: 2, RATE_SAFETY_MARGIN_PERCENTAGE: 10, MAX_ALLOWED_BANDWIDTH_ESTIMATION: 1 / 0, LIVE_SEGMENT_LIST_START_INDEX_OFFSET: 0, MAX_NUM_CACHED_SEGMENTS: 1, TRUN_VERSION: void 0, IGNORE_MP4_EDTS_BOX: !0, HLS_AUDIO_ONLY_THRESHOLD_BITRATE: 2e5, ENABLE_SEEK_FOR_LIVE: !1, LIVE_EDGE_DISTANCE: 0, QUALITY_THRESHOLD: 0.5, QUALITY_UPPER_THRESHOLD: 45, MAX_CONSECUTIVE_VR_ERRORS: 3, MAX_CONSECUTIVE_RENDERER_ERRORS: 3, DISABLE_HLS_BACKUP_STREAM_FAILOVER: !1, PLAYBACK_TIMEOUT: 1500, HLS_SYNC_VIA_MEDIA_SEQUENCE: !1, STOP_DOWNLOAD_ON_PAUSE: !1, VR_SCHEME_ID_URI: _$_b839[1588], HLS_VR_CHARACTERISTICS_UTI: _$_b839[1589], SAFARI_NUM_PROGRESS_EVENTS_AFTER_SEEK_GLITCH: 5, SEGMENT_LOADER_POOL_SIZE: {}, NATIVE_HLS_PARSING: !1, NATIVE_HLS_DOWNLOAD_ERROR_HANDLING: !1, AKAMAI_DATETIME_PARSING: !1, QJY_BROWSER_WORKAROUND: !1, DWORD_BASE_MEDIA_DECODE_TIMESTAMPS: !1, FORCE_BASE_MEDIA_DECODE_TIME_REWRITE: !1, WEBOS_MAX_SAFE_BMDT: 274877906943, WEBOS_MAX_SAFE_PTO: 4194303, TIZEN_MAX_SAFE_BMDT: 4294967295, TIZEN_MAX_SAFE_PTO: 4294967295, VIDAA_MAX_SAFE_BMDT: 4294967295, VIDAA_MAX_SAFE_PTO: 4294967295, ADAPTATION_SET_SWITCHING_WITHOUT_SUPPLEMENTAL_PROPERTY: !1, MINIMAL_BACKWARD_BUFFER_CLEARING_INTERVAL: 0.5, CHUNKED_CMAF_STREAMING: !1, LOW_LATENCY_DEFAULT_TARGET_LATENCY: 5, LOW_LATENCY_BUFFER_GUARD: 0.5, LOW_LATENCY_DEFAULT_FALLBACK_PLAYBACK_RATE: 0.95, LOW_LATENCY_DEFAULT_CATCHUP_PLAYBACK_RATE: 1.2, LOW_LATENCY_SEEK_AHEAD: 1, ACCEPTABLE_TIMESHIFT_INACCURACY: 3, IGNORE_HLS_AUDIO_GROUPS: !1, OPTIMIZE_AD_RESTORATION: !0, AD_RESTORATION_SEGMENT_PREFETCHING_DURATION: 5, MIN_SAFE_BUFFER_LEVEL: 3, THUMBNAIL_TO_PLAYER_SIZE_RATIO: 0.1, FAIRPLAY_IGNORE_DUPLICATE_INIT_DATA_KEY_ERRORS: !1, NO_QUOTA_EXCEEDED_ADJUSTMENT: !1, RESUME_LIVE_CONTENT_AT_PREVIOUS_POSITION_AFTER_AD_BREAK: !1, MIN_EFFECTIVE_SEGMENT_DOWNLOAD_TIME: 0.5, fixed: { APP_NAME: _$_b839[1571], VERSION: _$_b839[374] }, CLEAR_BUFFERS_ON_SEEKING_BACKWARDS: !1, DROP_INVALID_SEGMENTS: !1, PROACTIVE_GAP_SKIP_DISTANCE_SECONDS: 0, PRESERVE_GAPS_FOR_BASE_MEDIA_DECODE_TIME_REWRITE: !1, MIN_SIZE_FOR_GAP_SKIPPING: 0, FORCE_SOFTWARE_DECRYPTION: !1, SEGMENT_LOADING_PROGRESS_CHECK_INTERVAL: 0.5, ENABLE_SEGMENT_INFO_PROVIDER_FROM_STORE: !1, HLS_SYNC_SEGMENT_PLAYBACK_TIME_VIA_MEDIA_SEQUENCE: !1, HLS_PARSE_MANIFEST_IN_WORKER: !1, HLS_CLEAR_BUFFERS_ON_DISCONTINUITY_SWITCHES: !0, PARSE_EMSG_BOXES: !0, WISH_ABR_PARAMS: te[_$_b839[1585]], HLS_BACKUP_STREAM_PENALTY_DURATION: 30, CHECK_ALL_DRM_LICENSES_FOR_KID: !0, LL_HLS: !0, LL_HLS_SEGMENT_END_TIME_MATCHING_TOLERANCE: 0.1, LL_HLS_MAX_PLAYLIST_AGE_FOR_BLOCKING_REQUEST_IN_PART_TARGET_MULTIPLES: 2, HLS_PARSE_NATIVE_METADATA: !0, PREFER_MANAGED_MEDIA_SOURCE: !0, INFINITE_RETRIES_FOR_LIVE: !0, MAX_SAFE_MSE_DURATION: 1 / 0, ENABLE_MEDIA_ELEMENT_EVENT_LOGS: !1, DISABLE_PARALLEL_SEGMENT_LOADING: !1 };
          }, 12031: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1201]] = void 0;
            var ee = function() {
              function ie(ne) {
                this[_$_b839[773]] = ne[_$_b839[773]], this[_$_b839[829]] = ne[_$_b839[829]], this[_$_b839[632]] = ne[_$_b839[632]], this[_$_b839[1440]] = !1, this[_$_b839[1590]] = ne[_$_b839[796]], this[_$_b839[1591]] = ne[_$_b839[1591]];
              }
              return Object[_$_b839[82]](ie[_$_b839[37]], _$_b839[1447], { get: function() {
                return this[_$_b839[1440]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](ie[_$_b839[37]], _$_b839[796], { get: function() {
                return this[_$_b839[1590]];
              }, enumerable: !1, configurable: !0 }), ie[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[1440]] = !0;
              }, ie;
            }();
            te[_$_b839[1201]] = ee;
          }, 21607: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1047]] = void 0;
            var ie = ee(76650), ne = ee(28819), ae = ee(8272), ue = ee(27177), _e = ee(331), fe = function() {
              function le(se) {
                this[_$_b839[91]] = se, this[_$_b839[91]] = se, this[_$_b839[597]] = 0;
              }
              return le[_$_b839[37]][_$_b839[1551]] = function() {
                this[_$_b839[1592]] = Date[_$_b839[840]]();
              }, le[_$_b839[37]][_$_b839[1552]] = function() {
                var se = (0, _e[_$_b839[276]])(Date[_$_b839[840]]() - this[_$_b839[1592]]);
                this[_$_b839[597]] += se, this[_$_b839[1593]]();
              }, le[_$_b839[37]][_$_b839[1593]] = function() {
                var se = this;
                if ((0, ue[_$_b839[1594]])(this[_$_b839[91]])) {
                  var oe = (0, ne[_$_b839[1595]])(this[_$_b839[91]][_$_b839[731]][_$_b839[136]]());
                  Object[_$_b839[98]](oe)[_$_b839[113]](function(ce) {
                    return se[_$_b839[91]][_$_b839[731]][_$_b839[138]]((0, ie[_$_b839[1598]])(ce, ae[_$_b839[1597]][_$_b839[1596]], se[_$_b839[597]]));
                  });
                }
              }, le[_$_b839[37]][_$_b839[706]] = function() {
                this[_$_b839[597]] = 0;
              }, le[_$_b839[37]][_$_b839[340]] = function() {
              }, le;
            }();
            te[_$_b839[1047]] = fe;
          }, 93949: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1044]] = void 0;
            var ie = ee(25226), ne = function() {
              function ae(ue) {
                this[_$_b839[620]] = ue, this[_$_b839[1599]] = 0;
              }
              return ae[_$_b839[37]][_$_b839[1600]] = function(ue, _e) {
                var fe = ue[_$_b839[1005]][_$_b839[1601]], le = ue[_$_b839[1005]][_$_b839[1602]];
                if (le)
                  switch (le) {
                    case ie[_$_b839[1409]][_$_b839[1410]]:
                      return fe > Math[_$_b839[1268]](_e) ? 0 : fe + _e;
                    case ie[_$_b839[1409]][_$_b839[1411]]:
                      return fe;
                  }
                return fe;
              }, ae[_$_b839[37]][_$_b839[1603]] = function(ue, _e) {
                var fe = ue[_$_b839[1005]][_$_b839[1601]], le = ue[_$_b839[1005]][_$_b839[1602]];
                if (le)
                  switch (le) {
                    case ie[_$_b839[1409]][_$_b839[1410]]:
                      return fe;
                    case ie[_$_b839[1409]][_$_b839[1411]]:
                      return _e + fe;
                  }
                return fe;
              }, ae[_$_b839[37]][_$_b839[1163]] = function(ue) {
                if (ue[_$_b839[1005]]) {
                  if (ue[_$_b839[1005]][_$_b839[1601]] !== void 0)
                    return this[_$_b839[620]][_$_b839[806]]() ? this[_$_b839[1600]](ue, this[_$_b839[620]][_$_b839[870]]()) : this[_$_b839[1603]](ue, this[_$_b839[620]][_$_b839[259]]());
                  if (ue[_$_b839[1005]][_$_b839[1604]] !== void 0)
                    return ue[_$_b839[1005]][_$_b839[1604]];
                }
                return this[_$_b839[1599]];
              }, Object[_$_b839[82]](ae[_$_b839[37]], _$_b839[1605], { set: function(ue) {
                this[_$_b839[1599]] = ue;
              }, enumerable: !1, configurable: !0 }), ae[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[620]] = null;
              }, ae;
            }();
            te[_$_b839[1044]] = ne;
          }, 83091: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[744]] = void 0, function(ie) {
              ie[_$_b839[748]] = _$_b839[749], ie[_$_b839[743]] = _$_b839[745], ie[_$_b839[746]] = _$_b839[747], ie[_$_b839[171]] = _$_b839[750], ie[_$_b839[751]] = _$_b839[752], ie[_$_b839[924]] = _$_b839[1316];
            }(ee || (te[_$_b839[744]] = ee = {}));
          }, 91397: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1606]] = ne, te[_$_b839[1607]] = ae;
            var ie = ee(56435);
            function ne(ue) {
              return ue[_$_b839[124]](_$_b839[1611])[_$_b839[137]](function(_e, fe) {
                return fe === 0 ? _e[_$_b839[1608]]() : _e[_$_b839[1610]](0)[_$_b839[1609]]() + _e[_$_b839[74]](1)[_$_b839[1608]]();
              })[_$_b839[123]](_$_b839[90]);
            }
            function ae(ue) {
              return ue ? (0, ie[_$_b839[1612]])() ? JSON[_$_b839[283]](JSON[_$_b839[282]](ue)) : (_$_b839[60] + ue)[_$_b839[74]](1) : _$_b839[90];
            }
          }, 34731: function(re, te) {
            _$_b839[32];
            function ee(ae) {
              ae && ae[_$_b839[1613]]();
            }
            function ie(ae) {
              ae && ae[_$_b839[1614]]();
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1615]] = void 0, te[_$_b839[1613]] = ee, te[_$_b839[1614]] = ie;
            var ne = function() {
              function ae(ue) {
                this[_$_b839[584]] = !1, this[_$_b839[1616]] = ue == null ? void 0 : ue[_$_b839[1617]], this[_$_b839[1618]] = ue == null ? void 0 : ue[_$_b839[1619]];
              }
              return ae[_$_b839[37]][_$_b839[1613]] = function() {
                var ue;
                this[_$_b839[584]] || (this[_$_b839[584]] = !0, (ue = this[_$_b839[1616]]) === null || ue === void 0 || ue[_$_b839[36]](this));
              }, ae[_$_b839[37]][_$_b839[1614]] = function() {
                var ue;
                this[_$_b839[584]] && (this[_$_b839[584]] = !1, (ue = this[_$_b839[1618]]) === null || ue === void 0 || ue[_$_b839[36]](this));
              }, ae[_$_b839[37]][_$_b839[1620]] = function() {
                return this[_$_b839[584]];
              }, ae[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[584]] = null, this[_$_b839[1616]] = null, this[_$_b839[1618]] = null;
              }, ae;
            }();
            te[_$_b839[1615]] = ne;
          }, 27177: function(re, te) {
            _$_b839[32];
            function ee(ne) {
              return ne !== null && _$_b839[33] == typeof ne;
            }
            function ie(ne) {
              return ne !== void 0 && !ne[_$_b839[1447]];
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1621]] = ee, te[_$_b839[1594]] = ie;
          }, 7197: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[341]] || (Object[_$_b839[52]] ? function(ae, ue, _e, fe) {
              fe === void 0 && (fe = _e);
              var le = Object[_$_b839[111]](ue, _e);
              le && !(_$_b839[159] in le ? !ue[_$_b839[139]] : le[_$_b839[342]] || le[_$_b839[343]]) || (le = { enumerable: !0, get: function() {
                return ue[_e];
              } }), Object[_$_b839[82]](ae, fe, le);
            } : function(ae, ue, _e, fe) {
              fe === void 0 && (fe = _e), ae[fe] = ue[_e];
            }), ne = this && this[_$_b839[344]] || function(ae, ue) {
              for (var _e in ae)
                _$_b839[107] === _e || Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](ue, _e) || ie(ue, ae, _e);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), ne(ee(9146), te);
          }, 77012: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 });
          }, 61878: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1622]] = void 0;
            var ee = function() {
              function ie() {
              }
              return ie[_$_b839[1623]] = function(ne) {
                for (ne[_$_b839[1148]](_$_b839[368], _$_b839[90]), ne[_$_b839[1624]](_$_b839[368]); ne[_$_b839[1625]]; )
                  ne[_$_b839[926]](ne[_$_b839[1625]]);
              }, ie;
            }();
            te[_$_b839[1622]] = ee;
          }, 92677: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1626]] = void 0;
            var ie = ee(4006);
            te[_$_b839[1626]] = { key: _$_b839[90], playback: { autoplay: !1, muted: !1, volume: 100, timeShift: !0, seeking: !0, playsInline: !0, preferredTech: [], videoCodecPriority: [_$_b839[1627], _$_b839[1628], _$_b839[1629], _$_b839[1630], _$_b839[1631], _$_b839[1632], _$_b839[1633], _$_b839[1634], _$_b839[1635], _$_b839[1636], _$_b839[1637]], audioCodecPriority: [_$_b839[1638], _$_b839[1639], _$_b839[1640], _$_b839[1641], _$_b839[1642], _$_b839[1643], _$_b839[1644]] }, style: { aspectratio: 1.7777777777777777 }, tweaks: { file_protocol: !1 }, adaptation: { mobile: { limitToPlayerSize: !1, exclude: !1, qualityStabilityBalance: 0.5, bitrates: { minSelectableAudioBitrate: 0, maxSelectableAudioBitrate: 1 / 0, minSelectableVideoBitrate: 0, maxSelectableVideoBitrate: 1 / 0 }, resolution: { minSelectableVideoHeight: 0, maxSelectableVideoHeight: 1 / 0, minSelectableVideoWidth: 0, maxSelectableVideoWidth: 1 / 0 } }, desktop: { limitToPlayerSize: !1, exclude: !1, qualityStabilityBalance: 0.5, bitrates: { minSelectableAudioBitrate: 0, maxSelectableAudioBitrate: 1 / 0, minSelectableVideoBitrate: 0, maxSelectableVideoBitrate: 1 / 0 }, resolution: { minSelectableVideoHeight: 0, maxSelectableVideoHeight: 1 / 0, minSelectableVideoWidth: 0, maxSelectableVideoWidth: 1 / 0 } } }, cast: { enable: !1 }, events: {}, licensing: {}, live: { incrementalManifestUpdates: !0 }, logs: { bitmovin: !0 }, location: { ui: ie[_$_b839[347]][_$_b839[350]] + _$_b839[1645], ui_css: ie[_$_b839[347]][_$_b839[350]] + _$_b839[1646], serviceworker: _$_b839[90], cast: _$_b839[1647], google_ima: _$_b839[1648] } };
          }, 65077: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1649]] = ne;
            var ie = ee(25226);
            function ne(_e) {
              return _e === void 0 && (_e = {}), { live: ae(_e), tweaks: ue() };
            }
            var ae = function(_e) {
              var fe = _e[_$_b839[1650]];
              return { lowLatency: { targetLatency: fe ?? 5, catchup: { playbackRateThreshold: 0.075, seekThreshold: 5, playbackRate: 1.2 }, fallback: { playbackRateThreshold: 0.075, seekThreshold: 5, playbackRate: 0.95 } }, synchronization: [{ method: ie[_$_b839[1406]][_$_b839[1428]], serverUrl: _$_b839[1651] }] };
            }, ue = function() {
              return { RESTART_THRESHOLD: 0.2, RESTART_THRESHOLD_DELTA: 0.05, STARTUP_THRESHOLD: 0.2, STARTUP_THRESHOLD_DELTA: 0.05, LOW_LATENCY_BUFFER_GUARD: 0.8 };
            };
          }, 79063: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(ce) {
                for (var he, ge = 1, ve = arguments[_$_b839[26]]; ge < ve; ge++)
                  for (var me in he = arguments[ge])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](he, me) && (ce[me] = he[me]);
                return ce;
              }, ie[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[939]] = void 0;
            var ne = ee(25550), ae = ee(28764), ue = ee(33696), _e = ee(87326), fe = ee(13533), le = ee(54838), se = ee(92677), oe = function() {
              function ce(he) {
                if (!he)
                  throw new ae[_$_b839[147]](ne[_$_b839[145]][_$_b839[1652]], void 0, _$_b839[1653]);
                this[_$_b839[667]] = {}, this[_$_b839[1654]] = he, this[_$_b839[1655]]();
              }
              return ce[_$_b839[1656]] = function(he, ge) {
                var ve, me, be = !1, pe = !1, $e = !1;
                if (ge[_$_b839[656]] ? ($e = !!ge[_$_b839[656]][_$_b839[1657]], pe = !!ge[_$_b839[656]][_$_b839[1658]], be = !!ge[_$_b839[656]][_$_b839[1659]]) : ge[_$_b839[656]] = {}, he[_$_b839[656]] = he[_$_b839[656]] || {}, be) {
                  var ye = (0, le[_$_b839[1660]])((me = (ve = se[_$_b839[1626]][_$_b839[656]]) === null || ve === void 0 ? void 0 : ve[_$_b839[1659]]) !== null && me !== void 0 ? me : 1.7777777777777777);
                  he[_$_b839[656]][_$_b839[1659]] = (0, le[_$_b839[1660]])(ge[_$_b839[656]][_$_b839[1659]]) || ye;
                } else
                  he[_$_b839[656]][_$_b839[1659]] = se[_$_b839[1626]][_$_b839[656]][_$_b839[1659]];
                $e && !isNaN(String(ge[_$_b839[656]][_$_b839[1657]])[_$_b839[74]](-1)) && (he[_$_b839[656]][_$_b839[1657]] = ge[_$_b839[656]][_$_b839[1657]] + _$_b839[1661]), pe && !isNaN(String(ge[_$_b839[656]][_$_b839[1658]])[_$_b839[74]](-1)) && (he[_$_b839[656]][_$_b839[1658]] = ge[_$_b839[656]][_$_b839[1658]] + _$_b839[1661]);
              }, ce[_$_b839[37]][_$_b839[1655]] = function() {
                var he = this;
                le[_$_b839[1022]][_$_b839[1662]](this[_$_b839[667]], se[_$_b839[1626]], this[_$_b839[1654]]);
                var ge = this[_$_b839[1654]][_$_b839[1156]] || {}, ve = {};
                le[_$_b839[1022]][_$_b839[1663]](ve, ge), delete ve[_$_b839[1664]], delete ve[_$_b839[1665]], (0, fe[_$_b839[646]])()[_$_b839[1462]] ? this[_$_b839[667]][_$_b839[1156]] = le[_$_b839[1022]][_$_b839[1662]]({}, se[_$_b839[1626]][_$_b839[1156]][_$_b839[1664]], ve, ge[_$_b839[1664]]) : this[_$_b839[667]][_$_b839[1156]] = le[_$_b839[1022]][_$_b839[1662]]({}, se[_$_b839[1626]][_$_b839[1156]][_$_b839[1665]], ve, ge[_$_b839[1665]]);
                var me = this[_$_b839[667]][_$_b839[1156]][_$_b839[1461]];
                [_$_b839[1667], _$_b839[1668], _$_b839[1669], _$_b839[1460]][_$_b839[113]](function(be) {
                  he[_$_b839[667]][_$_b839[1156]][_$_b839[1461]][be] = le[_$_b839[1022]][_$_b839[1666]](be[_$_b839[25]](0, 3), me[be]);
                }), ce[_$_b839[1656]](this[_$_b839[667]], this[_$_b839[1654]]);
              }, ce[_$_b839[1670]] = function(he, ge, ve) {
                if (ge[_$_b839[215]](ve)) {
                  var me = ge[ve];
                  for (var be in me)
                    me[_$_b839[215]](be) && _$_b839[1671] !== be && he[_$_b839[215]](be[_$_b839[1609]]()) ? he[be[_$_b839[1609]]()] = me[be] : me[_$_b839[215]](be) && _$_b839[1672] === be[_$_b839[1609]]() && (he[_$_b839[1437]][ue[_$_b839[296]][_$_b839[295]]][ue[_$_b839[271]][_$_b839[270]]] = me[be], he[_$_b839[1437]][ue[_$_b839[296]][_$_b839[301]]][ue[_$_b839[271]][_$_b839[270]]] = me[be]);
                }
              }, ce[_$_b839[37]][_$_b839[759]] = function(he) {
                var ge;
                he === void 0 && (he = this[_$_b839[667]]);
                var ve = {}, me = he[_$_b839[1156]] || {};
                return le[_$_b839[1022]][_$_b839[1663]](ve, _e[_$_b839[714]]), ce[_$_b839[1670]](ve, he, _$_b839[681]), ce[_$_b839[1670]](ve, he, _$_b839[1383]), me[_$_b839[1461]] = me[_$_b839[1461]] || {}, me[_$_b839[1463]] = me[_$_b839[1463]] || !1, ve[_$_b839[1673]] = me[_$_b839[1463]], ve[_$_b839[1674]] = me[_$_b839[1461]][_$_b839[1667]] || 0, ve[_$_b839[1675]] = me[_$_b839[1461]][_$_b839[1668]] || 1 / 0, ve[_$_b839[1676]] = me[_$_b839[1461]][_$_b839[1669]] || 0, ve[_$_b839[1677]] = me[_$_b839[1461]][_$_b839[1460]] || 1 / 0, ve[_$_b839[1678]] = me[_$_b839[1679]] || ve[_$_b839[1678]], ve[_$_b839[1680]] = me[_$_b839[1681]] || ve[_$_b839[1680]], ve[_$_b839[1682]] = ie(ie({}, _e[_$_b839[714]][_$_b839[1682]]), ((ge = he[_$_b839[681]]) === null || ge === void 0 ? void 0 : ge[_$_b839[1683]]) || {}), ve;
              }, ce[_$_b839[37]][_$_b839[1097]] = function() {
                return this[_$_b839[1654]];
              }, ce[_$_b839[37]][_$_b839[1684]] = function(he) {
                var ge = {};
                for (var ve in le[_$_b839[1022]][_$_b839[1663]](ge, he), ge)
                  ge[_$_b839[215]](ve) && (this[_$_b839[667]][ve] = ge[ve], this[_$_b839[1654]][ve] = ge[ve]);
              }, ce[_$_b839[37]][_$_b839[159]] = function(he, ge) {
                return ge === void 0 && (ge = this[_$_b839[667]]), he ? ge[_$_b839[215]](he) ? this[_$_b839[667]][he] : {} : ge;
              }, ce[_$_b839[37]][_$_b839[666]] = function() {
                return this[_$_b839[159]](_$_b839[666]);
              }, ce[_$_b839[37]][_$_b839[656]] = function() {
                return this[_$_b839[159]](_$_b839[656]);
              }, ce[_$_b839[37]][_$_b839[1142]] = function() {
                return this[_$_b839[159]](_$_b839[1142]);
              }, ce[_$_b839[37]][_$_b839[681]] = function() {
                return this[_$_b839[159]](_$_b839[681]);
              }, ce[_$_b839[37]][_$_b839[1156]] = function() {
                return this[_$_b839[159]](_$_b839[1156]);
              }, ce[_$_b839[37]][_$_b839[994]] = function() {
                return this[_$_b839[159]](_$_b839[994]);
              }, ce[_$_b839[37]][_$_b839[1383]] = function() {
                return this[_$_b839[159]](_$_b839[1383]);
              }, ce[_$_b839[37]][_$_b839[765]] = function() {
                return this[_$_b839[159]](_$_b839[765]);
              }, ce[_$_b839[37]][_$_b839[931]] = function() {
                return this[_$_b839[159]](_$_b839[931]);
              }, ce[_$_b839[37]][_$_b839[1685]] = function() {
                return this[_$_b839[159]](_$_b839[1685]);
              }, ce[_$_b839[37]][_$_b839[10]] = function() {
                return this[_$_b839[159]](_$_b839[10]);
              }, ce;
            }();
            te[_$_b839[939]] = oe;
          }, 56555: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1686]] = _e;
            var ie = ee(43485), ne = 30, ae = 10;
            function ue(fe) {
              var le = { forwardduration: ne, backwardduration: ae }, se = { buffer: { video: le, audio: le }, playback: { autoplay: !0 }, tweaks: { minimal_backward_buffer_clearing_interval: 5 } };
              return fe && (se[_$_b839[681]][_$_b839[1687]] = fe, se[_$_b839[681]][_$_b839[1688]] = !0, se[_$_b839[1381]] = { config: { origin: fe } }), se;
            }
            function _e(fe) {
              if ((0, ie[_$_b839[1689]])() && !fe)
                throw new Error(_$_b839[1690]);
              return ue(fe);
            }
          }, 90788: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[958]] = le;
            var ie = ee(25550), ne = ee(28764), ae = ee(4006), ue = ee(11399), _e = ee(13533), fe = ee(43485);
            function le(se) {
              var oe = se[_$_b839[159]](_$_b839[681]), ce = (0, _e[_$_b839[646]])()[ue[_$_b839[1013]][_$_b839[1691]]], he = (0, fe[_$_b839[1689]])();
              if (he || ce) {
                if (!oe[_$_b839[1687]] || he && !oe[_$_b839[1688]])
                  throw new ne[_$_b839[147]](ie[_$_b839[145]][_$_b839[1692]], { tweaks: JSON[_$_b839[282]](oe) }, _$_b839[1694][_$_b839[41]](oe[_$_b839[1687]] ? _$_b839[1688] : _$_b839[1687], _$_b839[1693]));
                !oe[_$_b839[1687]] || ae[_$_b839[347]][_$_b839[348]] && !ce || (ae[_$_b839[347]][_$_b839[348]] = oe[_$_b839[1687]]);
              }
            }
          }, 25550: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[145]] = void 0, function(ie) {
              ie[ie[_$_b839[1315]] = 1e3] = _$_b839[1315], ie[ie[_$_b839[1080]] = 1001] = _$_b839[1080], ie[ie[_$_b839[1695]] = 1100] = _$_b839[1695], ie[ie[_$_b839[1375]] = 1101] = _$_b839[1375], ie[ie[_$_b839[1652]] = 1102] = _$_b839[1652], ie[ie[_$_b839[1113]] = 1103] = _$_b839[1113], ie[ie[_$_b839[1696]] = 1104] = _$_b839[1696], ie[ie[_$_b839[963]] = 1104] = _$_b839[963], ie[ie[_$_b839[1697]] = 1105] = _$_b839[1697], ie[ie[_$_b839[1116]] = 1105] = _$_b839[1116], ie[ie[_$_b839[934]] = 1106] = _$_b839[934], ie[ie[_$_b839[684]] = 1107] = _$_b839[684], ie[ie[_$_b839[1478]] = 1108] = _$_b839[1478], ie[ie[_$_b839[1692]] = 1113] = _$_b839[1692], ie[ie[_$_b839[1698]] = 1200] = _$_b839[1698], ie[ie[_$_b839[917]] = 1201] = _$_b839[917], ie[ie[_$_b839[1699]] = 1202] = _$_b839[1699], ie[ie[_$_b839[1085]] = 1203] = _$_b839[1085], ie[ie[_$_b839[1258]] = 1204] = _$_b839[1258], ie[ie[_$_b839[1452]] = 1205] = _$_b839[1452], ie[ie[_$_b839[1454]] = 1206] = _$_b839[1454], ie[ie[_$_b839[1700]] = 1207] = _$_b839[1700], ie[ie[_$_b839[1701]] = 1208] = _$_b839[1701], ie[ie[_$_b839[1702]] = 1209] = _$_b839[1702], ie[ie[_$_b839[1703]] = 1210] = _$_b839[1703], ie[ie[_$_b839[1704]] = 1211] = _$_b839[1704], ie[ie[_$_b839[1705]] = 7043] = _$_b839[1705], ie[ie[_$_b839[1706]] = 1300] = _$_b839[1706], ie[ie[_$_b839[1256]] = 1301] = _$_b839[1256], ie[ie[_$_b839[1707]] = 1304] = _$_b839[1707], ie[ie[_$_b839[1257]] = 1400] = _$_b839[1257], ie[ie[_$_b839[1708]] = 1401] = _$_b839[1708], ie[ie[_$_b839[1709]] = 1402] = _$_b839[1709], ie[ie[_$_b839[1710]] = 1403] = _$_b839[1710], ie[ie[_$_b839[1711]] = 1404] = _$_b839[1711], ie[ie[_$_b839[1712]] = 2e3] = _$_b839[1712], ie[ie[_$_b839[1713]] = 2001] = _$_b839[1713], ie[ie[_$_b839[1714]] = 2002] = _$_b839[1714], ie[ie[_$_b839[1715]] = 2003] = _$_b839[1715], ie[ie[_$_b839[1716]] = 2005] = _$_b839[1716], ie[ie[_$_b839[1717]] = 2006] = _$_b839[1717], ie[ie[_$_b839[1718]] = 2007] = _$_b839[1718], ie[ie[_$_b839[1719]] = 2008] = _$_b839[1719], ie[ie[_$_b839[1720]] = 2009] = _$_b839[1720], ie[ie[_$_b839[1721]] = 2010] = _$_b839[1721], ie[ie[_$_b839[1722]] = 2011] = _$_b839[1722], ie[ie[_$_b839[1723]] = 2012] = _$_b839[1723], ie[ie[_$_b839[1724]] = 2013] = _$_b839[1724], ie[ie[_$_b839[1725]] = 2015] = _$_b839[1725], ie[ie[_$_b839[1726]] = 2100] = _$_b839[1726], ie[ie[_$_b839[1087]] = 2101] = _$_b839[1087], ie[ie[_$_b839[1727]] = 3e3] = _$_b839[1727], ie[ie[_$_b839[144]] = 3001] = _$_b839[144], ie[ie[_$_b839[154]] = 3002] = _$_b839[154], ie[ie[_$_b839[222]] = 3003] = _$_b839[222], ie[ie[_$_b839[218]] = 3004] = _$_b839[218], ie[ie[_$_b839[1387]] = 3005] = _$_b839[1387], ie[ie[_$_b839[1728]] = 3100] = _$_b839[1728], ie[ie[_$_b839[1729]] = 4e3] = _$_b839[1729];
            }(ee || (te[_$_b839[145]] = ee = {}));
          }, 28764: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[147]] = void 0;
            var ie = ee(25550), ne = function() {
              function ae(ue, _e, fe, le) {
                this[_$_b839[1028]] = ue, this[_$_b839[62]] = ie[_$_b839[145]][ue], this[_$_b839[796]] = le, this[_$_b839[89]] = fe ?? _$_b839[90][_$_b839[41]](this[_$_b839[62]]), this[_$_b839[1730]] = _e, _$_b839[34] == typeof Error[_$_b839[1731]] ? Error[_$_b839[1731]](this, this[_$_b839[105]]) : this[_$_b839[362]] = new Error(this[_$_b839[89]])[_$_b839[362]];
              }
              return ae;
            }();
            te[_$_b839[147]] = ne;
          }, 63546: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[225]] = void 0;
            var ie = ee(62510), ne = ee(35148), ae = function() {
              function ue(_e, fe, le) {
                this[_$_b839[65]] = ie[_$_b839[382]][_$_b839[410]], this[_$_b839[1028]] = _e, this[_$_b839[62]] = ne[_$_b839[226]][_e], this[_$_b839[89]] = fe || _$_b839[90][_$_b839[41]](this[_$_b839[1028]], _$_b839[359])[_$_b839[41]](this[_$_b839[62]]), this[_$_b839[1730]] = le;
              }
              return ue;
            }();
            te[_$_b839[225]] = ae;
          }, 35148: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[226]] = void 0, function(ie) {
              ie[ie[_$_b839[1732]] = 1e3] = _$_b839[1732], ie[ie[_$_b839[971]] = 1001] = _$_b839[971], ie[ie[_$_b839[1733]] = 1100] = _$_b839[1733], ie[ie[_$_b839[1734]] = 1101] = _$_b839[1734], ie[ie[_$_b839[1735]] = 1103] = _$_b839[1735], ie[ie[_$_b839[1736]] = 1104] = _$_b839[1736], ie[ie[_$_b839[1737]] = 1200] = _$_b839[1737], ie[ie[_$_b839[1738]] = 1201] = _$_b839[1738], ie[ie[_$_b839[1739]] = 1202] = _$_b839[1739], ie[ie[_$_b839[1740]] = 1203] = _$_b839[1740], ie[ie[_$_b839[1741]] = 1204] = _$_b839[1741], ie[ie[_$_b839[1742]] = 1205] = _$_b839[1742], ie[ie[_$_b839[1743]] = 1300] = _$_b839[1743], ie[ie[_$_b839[1744]] = 1301] = _$_b839[1744], ie[ie[_$_b839[1745]] = 1302] = _$_b839[1745], ie[ie[_$_b839[909]] = 1303] = _$_b839[909], ie[ie[_$_b839[1746]] = 1304] = _$_b839[1746], ie[ie[_$_b839[1747]] = 1305] = _$_b839[1747], ie[ie[_$_b839[1748]] = 1400] = _$_b839[1748], ie[ie[_$_b839[1749]] = 1401] = _$_b839[1749], ie[ie[_$_b839[1750]] = 1402] = _$_b839[1750], ie[ie[_$_b839[1751]] = 2e3] = _$_b839[1751], ie[ie[_$_b839[1752]] = 2001] = _$_b839[1752], ie[ie[_$_b839[1753]] = 2002] = _$_b839[1753], ie[ie[_$_b839[1754]] = 2003] = _$_b839[1754], ie[ie[_$_b839[1715]] = 2004] = _$_b839[1715], ie[ie[_$_b839[1724]] = 2013] = _$_b839[1724], ie[ie[_$_b839[1755]] = 2100] = _$_b839[1755], ie[ie[_$_b839[1756]] = 2101] = _$_b839[1756], ie[ie[_$_b839[1757]] = 3e3] = _$_b839[1757], ie[ie[_$_b839[222]] = 3001] = _$_b839[222], ie[ie[_$_b839[1758]] = 3100] = _$_b839[1758], ie[ie[_$_b839[1759]] = 3101] = _$_b839[1759], ie[ie[_$_b839[1760]] = 3102] = _$_b839[1760], ie[ie[_$_b839[1761]] = 3103] = _$_b839[1761], ie[ie[_$_b839[1762]] = 3104] = _$_b839[1762];
            }(ee || (te[_$_b839[226]] = ee = {}));
          }, 47275: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[756]] = void 0, te[_$_b839[1213]] = ue;
            var ie = ee(18665), ne = _$_b839[1763], ae = function() {
              function fe() {
                this[_$_b839[1764]] = {}, this[_$_b839[137]] = /* @__PURE__ */ new WeakMap();
              }
              return fe[_$_b839[37]][_$_b839[152]] = function(le, se) {
                return se === void 0 && (se = ne), !!this[_$_b839[159]](le, se);
              }, fe[_$_b839[37]][_$_b839[159]] = function(le, se) {
                if (se === void 0 && (se = ne), this[_$_b839[1764]][se])
                  return this[_$_b839[1764]][se][le];
              }, fe[_$_b839[37]][_$_b839[1045]] = function(le, se, oe) {
                oe === void 0 && (oe = ne), this[_$_b839[1764]][oe] || (this[_$_b839[1764]][oe] = {}), this[_$_b839[1764]][oe][le] = se, se && this[_$_b839[137]][_$_b839[1045]](se, oe);
              }, fe[_$_b839[37]][_$_b839[1765]] = function(le) {
                return this[_$_b839[137]][_$_b839[159]](le);
              }, fe[_$_b839[37]][_$_b839[797]] = function(le, se) {
                se === void 0 && (se = ne), this[_$_b839[1764]][se] && this[_$_b839[1764]][se][le] && (this[_$_b839[137]][_$_b839[797]](this[_$_b839[1764]][se][le]), this[_$_b839[1764]][se][le][_$_b839[340]](), delete this[_$_b839[1764]][se][le]);
              }, fe[_$_b839[37]][_$_b839[639]] = function(le, se, oe, ce) {
                oe === void 0 && (oe = null), ce === void 0 && (ce = ne);
                var he = this[_$_b839[159]](le, ce);
                return he ? se(he) : oe;
              }, fe[_$_b839[37]][_$_b839[340]] = function() {
                Object[_$_b839[1083]](this[_$_b839[1764]])[_$_b839[113]](function(le) {
                  _e(le)[_$_b839[113]](function(se) {
                    le[se][_$_b839[340]]();
                  });
                }), this[_$_b839[1764]] = {}, delete this[_$_b839[137]];
              }, fe[_$_b839[37]][_$_b839[634]] = function() {
                var le = this;
                Object[_$_b839[98]](this[_$_b839[1764]])[_$_b839[112]](function(se) {
                  return se !== ne;
                })[_$_b839[113]](function(se) {
                  _e(le[_$_b839[1764]][se])[_$_b839[113]](function(oe) {
                    le[_$_b839[797]](oe, se);
                  }), delete le[_$_b839[1764]][se];
                });
              }, fe;
            }();
            function ue(fe, le, se) {
              se === void 0 && (se = ne);
              var oe = fe[_$_b839[159]](le, se);
              oe && (oe[_$_b839[340]](), fe[_$_b839[1045]](le, null, se));
            }
            function _e(fe) {
              return Object[_$_b839[98]](fe)[_$_b839[251]](function(le) {
                return le !== ie[_$_b839[637]][_$_b839[795]] ? -1 : 1;
              })[_$_b839[112]](function(le) {
                return !!fe[le];
              });
            }
            te[_$_b839[756]] = ae;
          }, 18665: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[637]] = void 0, function(ie) {
              ie[_$_b839[1766]] = _$_b839[1766], ie[_$_b839[1070]] = _$_b839[1070], ie[_$_b839[636]] = _$_b839[636], ie[_$_b839[1767]] = _$_b839[1767], ie[_$_b839[1768]] = _$_b839[1768], ie[_$_b839[1063]] = _$_b839[1063], ie[_$_b839[1769]] = _$_b839[1769], ie[_$_b839[1770]] = _$_b839[1770], ie[_$_b839[1771]] = _$_b839[1771], ie[_$_b839[1046]] = _$_b839[1046], ie[_$_b839[893]] = _$_b839[893], ie[_$_b839[1772]] = _$_b839[1772], ie[_$_b839[795]] = _$_b839[795], ie[_$_b839[1047]] = _$_b839[1047], ie[_$_b839[1044]] = _$_b839[1044], ie[_$_b839[1773]] = _$_b839[1773], ie[_$_b839[1774]] = _$_b839[1774], ie[_$_b839[1775]] = _$_b839[1775], ie[_$_b839[1048]] = _$_b839[1048], ie[_$_b839[1776]] = _$_b839[1776];
            }(ee || (te[_$_b839[637]] = ee = {}));
          }, 78429: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(ce) {
                for (var he, ge = 1, ve = arguments[_$_b839[26]]; ge < ve; ge++)
                  for (var me in he = arguments[ge])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](he, me) && (ce[me] = he[me]);
                return ce;
              }, ie[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[722]] = void 0, te[_$_b839[1777]] = oe;
            var ne = ee(28764), ae = ee(62510), ue = ee(18561), _e = _$_b839[1778], fe = function() {
              function ce() {
                var he = this;
                this[_$_b839[36]] = function() {
                  he[_$_b839[54]][_$_b839[36]](he[_$_b839[91]], he[_$_b839[1730]]);
                }, this[_$_b839[1779]] = function(ge) {
                  return !!he[_$_b839[1780]] && (_$_b839[109] == typeof ge ? ge === he[_$_b839[1781]] : ge === he[_$_b839[54]]);
                };
              }
              return ce[_$_b839[37]][_$_b839[1045]] = function(he, ge, ve, me, be) {
                be === void 0 && (be = !0), this[_$_b839[54]] = he, this[_$_b839[1781]] = ge, this[_$_b839[91]] = ve, this[_$_b839[1730]] = me, this[_$_b839[1780]] = be;
              }, ce[_$_b839[37]][_$_b839[1064]] = function() {
                this[_$_b839[54]] = null, this[_$_b839[1781]] = null, this[_$_b839[91]] = null, this[_$_b839[1730]] = null, this[_$_b839[1780]] = null;
              }, Object[_$_b839[82]](ce[_$_b839[37]], _$_b839[1782], { get: function() {
                return this[_$_b839[1780]];
              }, enumerable: !1, configurable: !0 }), ce;
            }(), le = 20, se = function() {
              function ce(he, ge, ve) {
                var me = this;
                for (var be in this[_$_b839[1783]] = !1, this[_$_b839[1784]] = !1, this[_$_b839[1785]] = function() {
                  for (var pe = me[_$_b839[733]] ? me[_$_b839[1786]][_$_b839[26]] : le, $e = 0, ye = me[_$_b839[1786]][_$_b839[130]](0, pe); $e < ye[_$_b839[26]]; $e++) {
                    var Se = ye[$e];
                    !Se || me[_$_b839[730]] && Se[_$_b839[1781]] !== ae[_$_b839[382]][_$_b839[525]] || me[_$_b839[1787]](Se);
                  }
                  me[_$_b839[1783]] = !1, me[_$_b839[1786]][_$_b839[26]] > 0 && me[_$_b839[1788]]();
                }, this[_$_b839[1789]] = function(pe, $e, ye, Se) {
                  if (Se === void 0 && (Se = !0), me[_$_b839[1790]](pe, $e, ye)) {
                    var we = me[_$_b839[1791]](ye), Pe = 0, Te = me[_$_b839[1792]]($e, pe);
                    we[pe][_$_b839[113]](function(Ee) {
                      var Me = me[_$_b839[1793]][_$_b839[72]]() || new fe();
                      Me[_$_b839[1045]](Ee[_$_b839[54]], pe, me[_$_b839[732]], Te, Se), me[_$_b839[1786]][_$_b839[57]](Me), Pe += Ee[_$_b839[1794]] ? 1 : 0;
                    }), Pe < we[pe][_$_b839[26]] && (we[pe][_$_b839[251]](function(Ee, Me) {
                      return ue[_$_b839[1796]][_$_b839[1795]](Ee[_$_b839[1794]], Me[_$_b839[1794]]);
                    }), we[pe][_$_b839[26]] = Pe), me[_$_b839[1786]][_$_b839[26]] > 0 && me[_$_b839[1788]]();
                  }
                }, this[_$_b839[739]] = function(pe, $e, ye) {
                  ye === void 0 && (ye = !0), me[_$_b839[733]] || me[_$_b839[1797]](pe, $e, ye);
                }, this[_$_b839[625]] = function(pe) {
                  var $e = me[_$_b839[1786]][_$_b839[135]](function(ye, Se, we) {
                    return Se[_$_b839[1779]](pe) ? ye[_$_b839[41]](we) : ye;
                  }, []);
                  for ($e[_$_b839[251]](function(ye, Se) {
                    return ye - Se;
                  }); $e[_$_b839[26]] > 0; )
                    me[_$_b839[1786]][_$_b839[130]]($e[_$_b839[72]](), 1);
                }, this[_$_b839[1798]] = function(pe) {
                  pe[_$_b839[1730]] === me[_$_b839[1799]] && (window[_$_b839[78]](_$_b839[89], me[_$_b839[1798]]), me[_$_b839[1785]]());
                }, this[_$_b839[280]] = he, this[_$_b839[732]] = ge, this[_$_b839[99]] = { internal: {}, external: {} }, this[_$_b839[733]] = !1, this[_$_b839[730]] = !1, this[_$_b839[1786]] = [], this[_$_b839[1793]] = [], ae[_$_b839[382]])
                  ae[_$_b839[382]][_$_b839[215]](be) && (this[_$_b839[99]][_$_b839[1219]][ae[_$_b839[382]][be]] = [], this[_$_b839[99]][_$_b839[1800]][ae[_$_b839[382]][be]] = []);
                this[_$_b839[1801]] = [], this[_$_b839[1799]] = _$_b839[90][_$_b839[41]](_e, _$_b839[81])[_$_b839[41]](ve);
              }
              return ce[_$_b839[37]][_$_b839[1787]] = function(he) {
                try {
                  he[_$_b839[36]](), he[_$_b839[1064]](), this[_$_b839[1793]][_$_b839[57]](he);
                } catch (ge) {
                  this[_$_b839[280]][_$_b839[38]](_$_b839[1802], ge);
                }
              }, ce[_$_b839[37]][_$_b839[1792]] = function(he, ge) {
                return ie({ type: ge, timestamp: Date[_$_b839[840]]() }, he);
              }, ce[_$_b839[37]][_$_b839[1790]] = function(he, ge, ve) {
                var me = this[_$_b839[1791]](ve), be = me[_$_b839[215]](he) && me[he][_$_b839[26]];
                return !!(!this[_$_b839[733]] && be);
              }, ce[_$_b839[37]][_$_b839[1803]] = function(he) {
                this[_$_b839[1786]] = this[_$_b839[1786]][_$_b839[112]](function(ge) {
                  return !ge[_$_b839[1779]](he);
                });
              }, ce[_$_b839[37]][_$_b839[69]] = function(he, ge, ve) {
                var me = this[_$_b839[1791]](ve);
                me[_$_b839[215]](he) && (me[he] = me[he][_$_b839[112]](function(be) {
                  return be[_$_b839[54]] !== ge;
                }));
              }, ce[_$_b839[37]][_$_b839[1804]] = function(he, ge) {
                if (he && he instanceof ne[_$_b839[147]]) {
                  var ve = { type: ae[_$_b839[382]][_$_b839[409]], timestamp: Date[_$_b839[840]](), code: he[_$_b839[1028]], name: he[_$_b839[62]], message: he[_$_b839[89]], data: he[_$_b839[1730]], troubleShootLink: oe(he[_$_b839[1028]]) };
                  ge && (ve[_$_b839[796]] = he[_$_b839[796]]), this[_$_b839[1789]](ae[_$_b839[382]][_$_b839[409]], ve, ge);
                } else
                  this[_$_b839[280]][_$_b839[73]](_$_b839[1805], he);
              }, ce[_$_b839[37]][_$_b839[1791]] = function(he) {
                return he ? this[_$_b839[99]][_$_b839[1219]] : this[_$_b839[99]][_$_b839[1800]];
              }, ce[_$_b839[37]][_$_b839[1797]] = function(he, ge, ve) {
                if (ge === void 0 && (ge = {}), ve === void 0 && (ve = !0), he === ae[_$_b839[382]][_$_b839[409]]) {
                  var me = ge;
                  me[_$_b839[215]](_$_b839[1028]) || (me[_$_b839[1028]] = 3e3);
                }
                ge && !ge[_$_b839[215]](_$_b839[1806]) && (ge[_$_b839[1806]] = Date[_$_b839[840]]()), this[_$_b839[1789]](he, ge, !0, ve), this[_$_b839[1801]][_$_b839[26]] > 0 && !this[_$_b839[1807]](he, ge) || this[_$_b839[1789]](he, ge, !1, ve);
              }, ce[_$_b839[37]][_$_b839[1807]] = function(he, ge) {
                return this[_$_b839[1801]][_$_b839[267]](function(ve) {
                  return ve(he, ge);
                });
              }, ce[_$_b839[37]][_$_b839[1808]] = function(he, ge, ve, me) {
                ve === void 0 && (ve = !1), me === void 0 && (me = !0);
                var be = this[_$_b839[1791]](ve);
                be[_$_b839[215]](he) && ge && !be[he][_$_b839[824]](function(pe) {
                  return pe && pe[_$_b839[54]] === ge;
                }) && be[he][_$_b839[57]]({ listener: ge, repeatable: me });
              }, ce[_$_b839[37]][_$_b839[75]] = function(he, ge, ve) {
                ve === void 0 && (ve = !1), this[_$_b839[1808]](he, ge, ve);
              }, ce[_$_b839[37]][_$_b839[1809]] = function(he, ge, ve) {
                ve === void 0 && (ve = !1), this[_$_b839[1808]](he, ge, ve, !1);
              }, ce[_$_b839[37]][_$_b839[945]] = function(he, ge) {
                for (var ve in ge === void 0 && (ge = !1), he)
                  he[_$_b839[215]](ve) && this[_$_b839[75]](ve, he[ve], ge);
              }, ce[_$_b839[37]][_$_b839[96]] = function(he, ge, ve) {
                ve === void 0 && (ve = !0), ve && this[_$_b839[1803]](ge), this[_$_b839[69]](he, ge, !0), this[_$_b839[69]](he, ge, !1);
              }, ce[_$_b839[37]][_$_b839[781]] = function() {
                var he = this;
                return function(ge, ve, me, be) {
                  be === void 0 && (be = !0), he[_$_b839[739]](ge, ve, be);
                };
              }, ce[_$_b839[37]][_$_b839[1185]] = function(he) {
                this[_$_b839[1801]][_$_b839[29]](he) < 0 && this[_$_b839[1801]][_$_b839[57]](he);
              }, ce[_$_b839[37]][_$_b839[1186]] = function(he) {
                var ge = this[_$_b839[1801]][_$_b839[29]](he);
                ge >= 0 && this[_$_b839[1801]][_$_b839[130]](ge, 1);
              }, ce[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[1786]] = this[_$_b839[1786]][_$_b839[112]](function(he) {
                  return !he[_$_b839[1782]];
                }), this[_$_b839[733]] = !0, this[_$_b839[1797]] = null, this[_$_b839[1801]] = null, this[_$_b839[1785]]();
              }, ce[_$_b839[37]][_$_b839[1108]] = function() {
                this[_$_b839[730]] = !0;
              }, ce[_$_b839[37]][_$_b839[1057]] = function() {
                this[_$_b839[1784]] = !1;
              }, ce[_$_b839[37]][_$_b839[652]] = function(he) {
                var ge, ve;
                this[_$_b839[1804]](he, !0), !this[_$_b839[1784]] && this[_$_b839[1807]](ae[_$_b839[382]][_$_b839[409]], he) && (this[_$_b839[1784]] = !0, this[_$_b839[1804]](he, !1)), this[_$_b839[280]][_$_b839[73]](_$_b839[1811][_$_b839[41]](he[_$_b839[1028]], _$_b839[359])[_$_b839[41]](he[_$_b839[62]], _$_b839[1810])[_$_b839[41]]((ge = he[_$_b839[89]]) !== null && ge !== void 0 ? ge : _$_b839[90]), (ve = he[_$_b839[1730]]) !== null && ve !== void 0 ? ve : _$_b839[60]);
              }, ce[_$_b839[37]][_$_b839[1788]] = function() {
                this[_$_b839[1783]] || (this[_$_b839[1783]] = !0, window[_$_b839[76]](_$_b839[89], this[_$_b839[1798]]), window[_$_b839[1814]](this[_$_b839[1799]], location[_$_b839[1812]] + location[_$_b839[1813]]));
              }, ce;
            }();
            function oe(ce) {
              return _$_b839[1815][_$_b839[41]](ce);
            }
            te[_$_b839[722]] = se;
          }, 57620: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1816]] = ue, te[_$_b839[1817]] = _e;
            var ie = ee(62510), ne = ee(92737), ae = ee(9560);
            function ue(le, se, oe) {
              le != null && le !== se && oe && oe[_$_b839[739]](ie[_$_b839[382]][_$_b839[528]], { from: le, to: se });
            }
            function _e(le, se) {
              var oe;
              se === void 0 && (se = !1);
              var ce = fe(le) ? le[_$_b839[1818]][_$_b839[1028]] : le[_$_b839[1028]], he = fe(le) ? le[_$_b839[1119]] : JSON[_$_b839[282]](le), ge = fe(le) ? le[_$_b839[1818]] : { errorMessage: JSON[_$_b839[282]](le), code: ce };
              se && (ge[_$_b839[1819]] = he);
              var ve = (oe = ae[_$_b839[1251]][ae[_$_b839[1252]][ce]]) !== null && oe !== void 0 ? oe : ne[_$_b839[145]][_$_b839[1315]];
              return new ne[_$_b839[147]](ve, ge, _$_b839[1820]);
            }
            function fe(le) {
              return _$_b839[1818] in le;
            }
          }, 84435: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1165]] = void 0;
            var ie = ee(4006), ne = ee(88005), ae = ee(67345), ue = ee(11399), _e = ee(13533), fe = ee(45217), le = function() {
              function oe(ce, he) {
                this[_$_b839[280]] = ce, this[_$_b839[1821]] = !1, this[_$_b839[1822]] = fe[_$_b839[1823]] + _$_b839[1824], this[_$_b839[682]](he);
              }
              return oe[_$_b839[37]][_$_b839[1825]] = function(ce) {
                return new ne[_$_b839[1826]]({ settings: { RETRY_DELAY: 0, INCREASE_RETRY_DELAY: !1, INCREASE_RETRY_DELAY_BASE_SEC: 0, MAX_INCREASE_RETRY_DELAY_SEC: 0, QUERY_PARAMETERS: [], HTTP_HEADERS: null, XHR_TIMEOUT: 2e4, DISABLE_RETRY_FOR_RESPONSE_STATUS: {} }, logger: this[_$_b839[280]], config: { network: { requestApi: ce } } });
              }, oe[_$_b839[37]][_$_b839[690]] = function(ce, he, ge) {
                var ve, me = this;
                if (this[_$_b839[1821]])
                  return Promise[_$_b839[602]](void 0);
                this[_$_b839[1827]] = (ve = this[_$_b839[1827]]) !== null && ve !== void 0 ? ve : this[_$_b839[1825]](ge), this[_$_b839[1821]] = !0;
                var be = { domain: ie[_$_b839[347]][_$_b839[348]], key: ce, version: ie[_$_b839[347]][_$_b839[373]], type: _$_b839[1828] + he, platform: se() };
                return this[_$_b839[1827]][_$_b839[1040]](this[_$_b839[1829]], ae[_$_b839[1270]][_$_b839[1328]], null, JSON[_$_b839[282]](be))[_$_b839[166]](function(pe) {
                  return pe;
                }, function(pe) {
                  return me[_$_b839[1829]] !== me[_$_b839[1822]] && (0, _e[_$_b839[646]])()[_$_b839[1466]] ? (me[_$_b839[1821]] = !1, me[_$_b839[682]](me[_$_b839[1822]]), me[_$_b839[690]](ce, he, ge)) : pe;
                });
              }, oe[_$_b839[37]][_$_b839[682]] = function(ce) {
                ce && (this[_$_b839[1829]] = ce);
              }, oe[_$_b839[37]][_$_b839[706]] = function() {
                this[_$_b839[1821]] = !1;
              }, oe[_$_b839[37]][_$_b839[340]] = function() {
                var ce;
                (ce = this[_$_b839[1827]]) === null || ce === void 0 || ce[_$_b839[340]]();
              }, oe;
            }();
            function se() {
              return (0, _e[_$_b839[646]])()[ue[_$_b839[1013]][_$_b839[1691]]] ? _$_b839[1830] : _$_b839[1831];
            }
            te[_$_b839[1165]] = le;
          }, 84903: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[936]] = void 0;
            var ie, ne = ee(4006), ae = ee(88005), ue = ee(67345), _e = ee(13533), fe = ee(45217);
            (function(ve) {
              ve[_$_b839[1832]] = _$_b839[1833], ve[_$_b839[1834]] = _$_b839[1835];
            })(ie || (ie = {}));
            var le = [_$_b839[354], _$_b839[1836]], se = fe[_$_b839[1823]] + _$_b839[1837], oe = 3e4, ce = function() {
              function ve(me, be, pe) {
                this[_$_b839[1838]] = 0, this[_$_b839[1839]] = [], this[_$_b839[1840]] = !1, this[_$_b839[1841]] = void 0, this[_$_b839[1842]] = be, this[_$_b839[686]] = pe, this[_$_b839[280]] = me;
              }
              return ve[_$_b839[37]][_$_b839[690]] = function(me, be) {
                var pe = this;
                this[_$_b839[1843]]() ? setTimeout(function() {
                  return me(!0);
                }, 0) : this[_$_b839[686]] ? this[_$_b839[1841]] ? setTimeout(function() {
                  return me(pe[_$_b839[1841]][_$_b839[1833]], pe[_$_b839[1841]][_$_b839[1844]], pe[_$_b839[1841]][_$_b839[1730]]);
                }, 0) : (this[_$_b839[1839]][_$_b839[57]](me), this[_$_b839[1840]] || (this[_$_b839[1840]] = !0, setTimeout(function() {
                  pe[_$_b839[1845]](pe[_$_b839[686]], pe[_$_b839[1842]], be);
                }, this[_$_b839[1838]]))) : setTimeout(function() {
                  return me(!1, { validationInformation: [{ key: _$_b839[686], errorMessage: _$_b839[1846] }] });
                }, 0);
              }, ve[_$_b839[37]][_$_b839[1843]] = function() {
                return le[_$_b839[815]](ne[_$_b839[347]][_$_b839[348]]) || !this[_$_b839[1842]];
              }, ve[_$_b839[1847]] = function(me) {
                var be = { granted: !1, payload: {}, data: {} };
                return me && me[_$_b839[1381]] && (be[_$_b839[1730]][_$_b839[1381]] = { key: me[_$_b839[1381]] }), me && me[_$_b839[215]](_$_b839[1848]) && (me[_$_b839[1848]] === ie[_$_b839[1832]] ? (be[_$_b839[1833]] = !0, be[_$_b839[1844]] = ge(me)) : me[_$_b839[1848]] === ie[_$_b839[1834]] && (be[_$_b839[1833]] = !1, be[_$_b839[1844]] = { message: me[_$_b839[89]] })), be;
              }, ve[_$_b839[1849]] = function(me) {
                var be = { granted: !1, payload: {}, data: {} };
                return me && me[_$_b839[215]](_$_b839[1117]) ? (be[_$_b839[1833]] = !1, be[_$_b839[1844]] = me) : be[_$_b839[1833]] = !0, be;
              }, ve[_$_b839[37]][_$_b839[1850]] = function(me) {
                for (var be = 0, pe = this[_$_b839[1839]]; be < pe[_$_b839[26]]; be++)
                  (0, pe[be])(me[_$_b839[1833]], me[_$_b839[1844]], me[_$_b839[1730]]);
              }, ve[_$_b839[37]][_$_b839[1136]] = function(me) {
                this[_$_b839[1851]] = me;
              }, ve[_$_b839[37]][_$_b839[937]] = function(me) {
                isNaN(me) || (this[_$_b839[1838]] = Math[_$_b839[247]](me, oe));
              }, ve[_$_b839[37]][_$_b839[1845]] = function(me, be, pe) {
                var $e = this, ye = JSON[_$_b839[282]]({ domain: ne[_$_b839[347]][_$_b839[348]], key: me || _$_b839[90], version: ne[_$_b839[347]][_$_b839[373]], customData: this[_$_b839[1851]] }), Se = this[_$_b839[1852]](pe);
                Se[_$_b839[1040]](be, ue[_$_b839[1270]][_$_b839[1328]], ue[_$_b839[1271]][_$_b839[1323]], ye)[_$_b839[166]](function(we) {
                  Se[_$_b839[340]](), $e[_$_b839[1841]] = ve[_$_b839[1847]](he(we[_$_b839[1853]])), $e[_$_b839[1840]] = !1, $e[_$_b839[1850]]($e[_$_b839[1841]]);
                }, function(we) {
                  Se[_$_b839[340]](), be !== se && (0, _e[_$_b839[646]])()[_$_b839[1466]] ? setTimeout(function() {
                    return $e[_$_b839[1845]](me, se, pe);
                  }, $e[_$_b839[1838]]) : ($e[_$_b839[1841]] = ve[_$_b839[1849]](he(we[_$_b839[1853]])), $e[_$_b839[1840]] = !1, $e[_$_b839[1850]]($e[_$_b839[1841]]));
                });
              }, ve[_$_b839[37]][_$_b839[1852]] = function(me) {
                return new ae[_$_b839[1826]]({ settings: { RETRY_DELAY: 0, INCREASE_RETRY_DELAY: !1, INCREASE_RETRY_DELAY_BASE_SEC: 0, MAX_INCREASE_RETRY_DELAY_SEC: 0, QUERY_PARAMETERS: [], HTTP_HEADERS: null, XHR_TIMEOUT: 2e4, DISABLE_RETRY_FOR_RESPONSE_STATUS: {} }, logger: this[_$_b839[280]], config: { network: { requestApi: me } } });
              }, ve[_$_b839[784]] = function(me, be, pe) {
                var $e = [be, pe][_$_b839[125]]();
                return ve[_$_b839[1854]][_$_b839[215]]($e) || (ve[_$_b839[1854]][$e] = new ve(me, be, pe)), ve[_$_b839[1854]][$e];
              }, ve[_$_b839[706]] = function() {
                Object[_$_b839[98]](ve[_$_b839[1854]])[_$_b839[113]](function(me) {
                  return delete ve[_$_b839[1854]][me];
                });
              }, ve[_$_b839[1854]] = {}, ve;
            }();
            function he(ve) {
              if (_$_b839[109] == typeof ve)
                try {
                  return JSON[_$_b839[283]](ve);
                } catch {
                  return {};
                }
              return ve;
            }
            function ge(ve) {
              var me = {};
              return ve[_$_b839[215]](_$_b839[1855]) && ve[_$_b839[1855]] && (me[_$_b839[1855]] = !0), ve[_$_b839[215]](_$_b839[1856]) && (me[_$_b839[1856]] = ve[_$_b839[1856]]), ve[_$_b839[215]](_$_b839[1857]) && (me[_$_b839[1857]] = ve[_$_b839[1857]]), ve[_$_b839[215]](_$_b839[1858]) && (me[_$_b839[1858]] = ve[_$_b839[1858]]), me;
            }
            te[_$_b839[936]] = ce;
          }, 45217: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1823]] = void 0, te[_$_b839[1823]] = _$_b839[1859];
          }, 63331: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1860]] = ne, te[_$_b839[1861]] = ae, te[_$_b839[1862]] = ue;
            var ie = ee(331);
            function ne(_e, fe) {
              var le = {};
              return le[_$_b839[1604]] = (0, ie[_$_b839[276]])(Date[_$_b839[283]](_e[_$_b839[1579]])), _e[_$_b839[1863]] ? le[_$_b839[1864]] = (0, ie[_$_b839[276]])(Date[_$_b839[283]](_e[_$_b839[1863]])) : _e[_$_b839[1341]] === void 0 || isNaN(_e[_$_b839[1341]]) ? _e[_$_b839[1865]] && fe && (le[_$_b839[1864]] = (0, ie[_$_b839[276]])(Date[_$_b839[283]](fe[_$_b839[1579]]))) : le[_$_b839[1864]] = (0, ie[_$_b839[276]])(Date[_$_b839[283]](_e[_$_b839[1579]])) + _e[_$_b839[1341]], le[_$_b839[1730]] = _e, le;
            }
            function ae(_e, fe, le) {
              for (var se = fe + 1; se < le[_$_b839[26]]; se++)
                if (le[se][_$_b839[1866]] && le[se][_$_b839[1866]] === _e[_$_b839[1866]])
                  return le[se];
            }
            function ue(_e, fe) {
              for (var le = [], se = 0; se < _e[_$_b839[26]]; se++) {
                var oe = _e[se][_$_b839[1867]];
                oe && le[_$_b839[57]][_$_b839[35]](le, oe);
              }
              le[_$_b839[113]](function(ce, he, ge) {
                var ve;
                ce[_$_b839[1865]] && ce[_$_b839[1866]] && (ve = ae(ce, he, ge));
                var me = ne(ce, ve);
                fe(me);
              });
            }
          }, 44779: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1264]] = ae, te[_$_b839[1868]] = ue;
            var ie = ee(92737), ne = ee(54838);
            function ae(_e, fe) {
              return fe === void 0 && (fe = _$_b839[90]), ue(_e) ? String(ne[_$_b839[1022]][_$_b839[1869]](_e[_$_b839[1263]] + _e[_$_b839[240]] + _e[_$_b839[451]][_$_b839[712]])) : String(ne[_$_b839[1022]][_$_b839[1869]](fe + JSON[_$_b839[282]](_e)));
            }
            function ue(_e) {
              return _e[_$_b839[1263]] === ie[_$_b839[381]][_$_b839[561]];
            }
          }, 54861: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1870]] = void 0;
            var ie = ee(18665), ne = ee(489), ae = function() {
              function ue(_e, fe) {
                this[_$_b839[1871]] = _e[_$_b839[635]][_$_b839[159]](ie[_$_b839[637]][_$_b839[1046]]), this[_$_b839[1872]] = new ne[_$_b839[1873]](_e, fe);
              }
              return ue[_$_b839[37]][_$_b839[1874]] = function(_e, fe, le) {
                fe[_$_b839[240]] = fe[_$_b839[240]] || _e, this[_$_b839[1871]][_$_b839[816]](le, fe);
              }, ue[_$_b839[37]][_$_b839[1875]] = function(_e, fe, le) {
                this[_$_b839[1872]][_$_b839[143]](_e, fe, le);
              }, ue[_$_b839[37]][_$_b839[1876]] = function(_e) {
                this[_$_b839[1872]][_$_b839[1876]](_e);
              }, ue[_$_b839[37]][_$_b839[1877]] = function(_e, fe) {
                this[_$_b839[1872]][_$_b839[1877]](_e, fe);
              }, ue[_$_b839[37]][_$_b839[706]] = function(_e) {
                this[_$_b839[1872]][_$_b839[706]](_e);
              }, ue[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[1872]][_$_b839[340]]();
              }, ue;
            }();
            te[_$_b839[1870]] = ae;
          }, 99303: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[212]] || function() {
              var _e = function(fe, le) {
                return _e = Object[_$_b839[213]] || { __proto__: [] } instanceof Array && function(se, oe) {
                  se[_$_b839[214]] = oe;
                } || function(se, oe) {
                  for (var ce in oe)
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](oe, ce) && (se[ce] = oe[ce]);
                }, _e(fe, le);
              };
              return function(fe, le) {
                if (_$_b839[34] != typeof le && le !== null)
                  throw new TypeError(_$_b839[216] + String(le) + _$_b839[217]);
                function se() {
                  this[_$_b839[105]] = fe;
                }
                _e(fe, le), fe[_$_b839[37]] = le === null ? Object[_$_b839[52]](le) : (se[_$_b839[37]] = le[_$_b839[37]], new se());
              };
            }(), ne = this && this[_$_b839[589]] || function(_e, fe, le) {
              if (le || arguments[_$_b839[26]] === 2)
                for (var se, oe = 0, ce = fe[_$_b839[26]]; oe < ce; oe++)
                  !se && oe in fe || (se || (se = Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](fe, 0, oe)), se[oe] = fe[oe]);
              return _e[_$_b839[41]](se || Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](fe));
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1878]] = void 0;
            var ae = ee(62510), ue = function(_e) {
              function fe() {
                return _e !== null && _e[_$_b839[35]](this, arguments) || this;
              }
              return ie(fe, _e), fe[_$_b839[37]][_$_b839[1880]] = function(le, se, oe) {
                var ce, he;
                if (!isNaN(le) && !isNaN(se) && oe) {
                  var ge = this[_$_b839[1882]](oe[_$_b839[451]], this[_$_b839[1881]]);
                  if (ge === -1)
                    _e[_$_b839[37]][_$_b839[1880]][_$_b839[36]](this, le, se, oe);
                  else {
                    var ve = this[_$_b839[1882]](oe[_$_b839[451]], this[_$_b839[1883]]);
                    if (this[_$_b839[1886]](ge, ve, { start: le + this[_$_b839[1884]], end: se + this[_$_b839[1884]], content: oe, updates: ne([], this[_$_b839[1881]][ge][_$_b839[1885]], !0) }), ve !== -1) {
                      var me = { metadataType: oe[_$_b839[1263]], metadata: oe[_$_b839[451]], data: oe[_$_b839[451]], start: (ce = oe[_$_b839[240]]) !== null && ce !== void 0 ? ce : le, end: (he = oe[_$_b839[241]]) !== null && he !== void 0 ? he : se };
                      this[_$_b839[91]][_$_b839[626]][_$_b839[739]](ae[_$_b839[382]][_$_b839[454]], me);
                    }
                  }
                }
              }, fe[_$_b839[37]][_$_b839[1882]] = function(le, se) {
                return se[_$_b839[1888]](function(oe) {
                  return oe[_$_b839[1887]][_$_b839[451]][_$_b839[712]] === le[_$_b839[712]];
                });
              }, fe[_$_b839[37]][_$_b839[1886]] = function(le, se, oe) {
                le !== -1 && this[_$_b839[1881]][_$_b839[130]](le, 1, oe), se !== -1 && this[_$_b839[1883]][_$_b839[130]](se, 1, oe);
              }, fe;
            }(ee(99378)[_$_b839[1879]]);
            te[_$_b839[1878]] = ue;
          }, 45243: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1889]] = void 0;
            var ie = ee(54838), ne = ee(44779), ae = function() {
              function _e() {
                var fe = this;
                this[_$_b839[143]] = function(le) {
                  var se = ue(le);
                  fe[_$_b839[1881]][se] = void 0;
                }, this[_$_b839[157]] = function(le) {
                  var se = ue(le);
                  delete fe[_$_b839[1881]][se];
                }, this[_$_b839[1881]] = {};
              }
              return _e[_$_b839[37]][_$_b839[152]] = function(fe) {
                return ue(fe) in this[_$_b839[1881]];
              }, _e[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[1881]] = {};
              }, _e;
            }();
            function ue(_e) {
              return (0, ne[_$_b839[1868]])(_e[_$_b839[1887]]) ? (0, ne[_$_b839[1264]])(_e[_$_b839[1887]]) : String(ie[_$_b839[1022]][_$_b839[1869]](JSON[_$_b839[282]]({ start: _e[_$_b839[240]], end: _e[_$_b839[241]], content: _e[_$_b839[1887]] })));
            }
            te[_$_b839[1889]] = ae;
          }, 489: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(ve) {
                for (var me, be = 1, pe = arguments[_$_b839[26]]; be < pe; be++)
                  for (var $e in me = arguments[be])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](me, $e) && (ve[$e] = me[$e]);
                return ve;
              }, ie[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1873]] = te[_$_b839[1890]] = void 0, te[_$_b839[1891]] = se;
            var ne, ae = ee(62510), ue = ee(33669), _e = ee(27279), fe = ee(99303), le = ee(99378);
            function se(ve) {
              return [ne[_$_b839[1892]], ne[_$_b839[448]], ne[_$_b839[1893]]][_$_b839[815]](ve);
            }
            function oe(ve) {
              return ve[_$_b839[451]] && ve[_$_b839[451]][_$_b839[1894]] && ve[_$_b839[451]][_$_b839[1895]];
            }
            (function(ve) {
              ve[_$_b839[1892]] = _$_b839[1896], ve[_$_b839[448]] = _$_b839[1897], ve[_$_b839[1898]] = _$_b839[600], ve[_$_b839[1899]] = _$_b839[1900], ve[_$_b839[1901]] = _$_b839[1867], ve[_$_b839[1893]] = _$_b839[1902];
            })(ne || (te[_$_b839[1890]] = ne = {}));
            var ce = 1, he = function() {
              function ve(me, be) {
                var pe = this;
                this[_$_b839[1903]] = function($e) {
                  $e && $e[_$_b839[1887]] && pe[_$_b839[1904]][_$_b839[215]]($e[_$_b839[1887]][_$_b839[1781]]) && pe[_$_b839[1904]][$e[_$_b839[1887]][_$_b839[1781]]]($e[_$_b839[1887]]);
                }, this[_$_b839[91]] = me, this[_$_b839[1904]] = be, this[_$_b839[1905]]();
              }
              return ve[_$_b839[37]][_$_b839[1905]] = function() {
                for (var me in this[_$_b839[1906]] = {}, this[_$_b839[1904]])
                  this[_$_b839[1904]][_$_b839[215]](me) && (this[_$_b839[1906]][me] = _$_b839[1867] === me ? new fe[_$_b839[1878]](this[_$_b839[91]], { onCueEnter: this[_$_b839[1903]] }) : new le[_$_b839[1879]](this[_$_b839[91]], { onCueEnter: this[_$_b839[1903]], allowDuplicates: me === ne[_$_b839[448]] }), this[_$_b839[1906]][me][_$_b839[1907]]());
              }, ve[_$_b839[37]][_$_b839[1908]] = function(me, be) {
                var pe = (0, ue[_$_b839[1910]])((0, _e[_$_b839[1909]])(this[_$_b839[91]])), $e = (0, ue[_$_b839[1912]])(pe == null ? void 0 : pe[_$_b839[1911]]);
                me[_$_b839[1877]](function(ye) {
                  return ye[_$_b839[240]] <= be && ye[_$_b839[241]] <= be + ce && ye[_$_b839[241]] <= $e;
                });
              }, ve[_$_b839[37]][_$_b839[143]] = function(me, be, pe) {
                if (this[_$_b839[1904]][_$_b839[215]](me)) {
                  var $e = this[_$_b839[1906]][me], ye = be + ce;
                  me === ne[_$_b839[448]] && oe(pe) && _$_b839[1894] in pe[_$_b839[451]] && _$_b839[1341] in pe[_$_b839[451]][_$_b839[1894]] ? ye = be + pe[_$_b839[451]][_$_b839[1894]][_$_b839[1341]] : ge(pe) && (ye = pe[_$_b839[451]][_$_b839[1865]] === !0 && pe[_$_b839[241]] === void 0 ? 1 / 0 : pe[_$_b839[240]] === pe[_$_b839[241]] ? pe[_$_b839[241]] + ce : pe[_$_b839[241]]), se(me) && this[_$_b839[1908]]($e, be);
                  var Se = ie({ eventType: me }, pe);
                  $e[_$_b839[1880]](be, ye, Se);
                }
              }, ve[_$_b839[37]][_$_b839[706]] = function(me) {
                if (me && this[_$_b839[1904]][_$_b839[215]](me))
                  this[_$_b839[1906]][me][_$_b839[1913]]();
                else
                  for (var be in this[_$_b839[1904]])
                    this[_$_b839[1904]][_$_b839[215]](be) && this[_$_b839[1906]][be][_$_b839[1913]]();
              }, ve[_$_b839[37]][_$_b839[1877]] = function(me, be) {
                this[_$_b839[1906]][me][_$_b839[1877]](be);
              }, ve[_$_b839[37]][_$_b839[1876]] = function(me) {
                var be = this;
                Object[_$_b839[98]](this[_$_b839[1906]])[_$_b839[113]](function(pe) {
                  be[_$_b839[1906]][pe][_$_b839[1914]](me);
                });
              }, ve[_$_b839[37]][_$_b839[340]] = function() {
                for (var me in this[_$_b839[1906]])
                  this[_$_b839[1906]][_$_b839[215]](me) && (this[_$_b839[1906]][me][_$_b839[340]](), this[_$_b839[1906]][me] = null);
                this[_$_b839[1906]] = null;
              }, ve[_$_b839[37]][_$_b839[1915]] = function(me) {
                if (this[_$_b839[1906]])
                  return this[_$_b839[1906]][me];
              }, ve;
            }();
            function ge(ve) {
              return ve[_$_b839[1263]] === ae[_$_b839[381]][_$_b839[561]];
            }
            te[_$_b839[1873]] = he;
          }, 99378: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(ce) {
                for (var he, ge = 1, ve = arguments[_$_b839[26]]; ge < ve; ge++)
                  for (var me in he = arguments[ge])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](he, me) && (ce[me] = he[me]);
                return ce;
              }, ie[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1879]] = void 0;
            var ne = ee(62510), ae = ee(58935), ue = ee(54838), _e = ee(45243), fe = function() {
              function ce(he, ge) {
                var ve = this;
                this[_$_b839[1881]] = [], this[_$_b839[1883]] = [], this[_$_b839[1916]] = [], this[_$_b839[1884]] = 0, this[_$_b839[1917]] = function(me) {
                  var be = me[_$_b839[1918]] || me[_$_b839[1919]] || 0;
                  ve[_$_b839[1920]](be), ve[_$_b839[1921]](be), ve[_$_b839[1922]](be);
                }, this[_$_b839[91]] = he, this[_$_b839[1434]] = he[_$_b839[1434]], this[_$_b839[1435]] = ge, this[_$_b839[1923]] = !1, ge[_$_b839[1924]] || (this[_$_b839[1925]] = new _e[_$_b839[1889]]()), this[_$_b839[1434]] && this[_$_b839[1926]]();
              }
              return ce[_$_b839[37]][_$_b839[1926]] = function() {
                this[_$_b839[1923]] || (this[_$_b839[1923]] = !0, this[_$_b839[1434]][_$_b839[75]](ne[_$_b839[382]][_$_b839[438]], this[_$_b839[1917]]));
              }, ce[_$_b839[37]][_$_b839[1927]] = function() {
                this[_$_b839[1923]] && (this[_$_b839[1434]][_$_b839[96]](ne[_$_b839[382]][_$_b839[438]], this[_$_b839[1917]]), this[_$_b839[1923]] = !1);
              }, ce[_$_b839[1928]] = function(he, ge) {
                return he[_$_b839[241]] >= ge && he[_$_b839[240]] <= ge;
              }, ce[_$_b839[37]][_$_b839[1929]] = function(he) {
                for (var ge = 0; ge < this[_$_b839[1883]][_$_b839[26]]; ge++)
                  if (he === this[_$_b839[1883]][ge])
                    return !0;
                return !1;
              }, ce[_$_b839[37]][_$_b839[1920]] = function(he) {
                for (var ge, ve, me = 0; me < this[_$_b839[1883]][_$_b839[26]]; me++) {
                  var be = this[_$_b839[1883]][me];
                  ce[_$_b839[1928]](be, he) || (this[_$_b839[1883]][_$_b839[130]](me, 1), me--, (ve = (ge = this[_$_b839[1435]])[_$_b839[1930]]) === null || ve === void 0 || ve[_$_b839[36]](ge, be));
                }
              }, ce[_$_b839[37]][_$_b839[1921]] = function(he) {
                for (var ge, ve, me = 0; me < this[_$_b839[1881]][_$_b839[26]]; me++) {
                  var be = this[_$_b839[1881]][me];
                  ce[_$_b839[1928]](be, he) && !this[_$_b839[1929]](be) && (this[_$_b839[1883]][_$_b839[57]](be), (ve = (ge = this[_$_b839[1435]])[_$_b839[1903]]) === null || ve === void 0 || ve[_$_b839[36]](ge, be));
                }
              }, ce[_$_b839[37]][_$_b839[1922]] = function(he) {
                for (var ge, ve, me = [], be = 0, pe = this[_$_b839[1883]]; be < pe[_$_b839[26]]; be++) {
                  var $e = pe[be], ye = oe($e[_$_b839[1885]], he);
                  ye !== void 0 && (me[_$_b839[57]](ye), this[_$_b839[1931]](ye) || (ve = (ge = this[_$_b839[1435]])[_$_b839[1932]]) === null || ve === void 0 || ve[_$_b839[36]](ge, ie(ie({}, $e), { content: ie(ie({}, $e[_$_b839[1887]]), ye[_$_b839[1887]]) })));
                }
                this[_$_b839[1916]] = me;
              }, ce[_$_b839[37]][_$_b839[1931]] = function(he) {
                return !!this[_$_b839[1916]][_$_b839[824]](function(ge) {
                  return ge === he;
                });
              }, ce[_$_b839[37]][_$_b839[1880]] = function(he, ge, ve, me) {
                var be, pe = this;
                if (me === void 0 && (me = []), !isNaN(he) && !isNaN(ge) && ve && !this[_$_b839[1933]](he, ge, ve)) {
                  var $e = me[_$_b839[137]](function(Pe) {
                    return ie(ie({}, Pe), { updateTime: Pe[_$_b839[1934]] + pe[_$_b839[1884]] });
                  }), ye = { start: he + this[_$_b839[1884]], end: ge + this[_$_b839[1884]], content: ve, updates: $e };
                  if (this[_$_b839[1881]][_$_b839[26]] > 0) {
                    var Se = this[_$_b839[1881]][this[_$_b839[1881]][_$_b839[26]] - 1];
                    if (ue[_$_b839[1022]][_$_b839[1935]](ve, Se[_$_b839[1887]]) && he >= Se[_$_b839[240]] && he - 0.5 <= Se[_$_b839[241]])
                      return this[_$_b839[91]][_$_b839[280]][_$_b839[1233]](ae[_$_b839[1222]][_$_b839[1224]]) && this[_$_b839[91]][_$_b839[280]][_$_b839[1162]](_$_b839[1936] + he + _$_b839[1611] + ge + _$_b839[1937] + ve), void (this[_$_b839[1881]][this[_$_b839[1881]][_$_b839[26]] - 1][_$_b839[241]] = Math[_$_b839[248]](ge, Se[_$_b839[241]]));
                  }
                  if (this[_$_b839[91]][_$_b839[280]][_$_b839[1233]](ae[_$_b839[1222]][_$_b839[1224]])) {
                    var we = JSON[_$_b839[282]](ve);
                    we[_$_b839[26]] > 500 && (we = we[_$_b839[25]](0, 497) + _$_b839[1938]), this[_$_b839[91]][_$_b839[280]][_$_b839[1162]](_$_b839[1939] + he + _$_b839[1611] + ge + _$_b839[1937] + we);
                  }
                  (be = this[_$_b839[1925]]) === null || be === void 0 || be[_$_b839[143]](ye), this[_$_b839[1881]][_$_b839[57]](ye);
                }
              }, ce[_$_b839[37]][_$_b839[1940]] = function(he, ge) {
                ge = ge || 0;
                for (var ve = 0, me = 0, be = he; me < be[_$_b839[26]]; me++) {
                  var pe = be[me];
                  if (pe && pe[_$_b839[215]](_$_b839[240]) && pe[_$_b839[215]](_$_b839[241]) && pe[_$_b839[241]] > ge) {
                    var $e = le(pe), ye = se(pe);
                    this[_$_b839[1880]](pe[_$_b839[240]], pe[_$_b839[241]], $e, ye), ve = Math[_$_b839[248]](ve, pe[_$_b839[241]]);
                  }
                }
                return ve;
              }, ce[_$_b839[37]][_$_b839[1933]] = function(he, ge, ve) {
                return !!this[_$_b839[1925]] && this[_$_b839[1925]][_$_b839[152]]({ start: he, end: ge, content: ve });
              }, ce[_$_b839[37]][_$_b839[1877]] = function(he) {
                var ge = this;
                this[_$_b839[1881]] = this[_$_b839[1881]][_$_b839[112]](function(ve) {
                  var me, be = he(ve);
                  return be && ((me = ge[_$_b839[1925]]) === null || me === void 0 || me[_$_b839[157]](ve)), !be;
                });
              }, ce[_$_b839[37]][_$_b839[1914]] = function(he) {
                this[_$_b839[1877]](function(ge) {
                  return ge[_$_b839[241]] < he;
                });
              }, ce[_$_b839[37]][_$_b839[1913]] = function() {
                var he = this;
                this[_$_b839[1941]](), this[_$_b839[1881]][_$_b839[113]](function(ge) {
                  var ve;
                  return (ve = he[_$_b839[1925]]) === null || ve === void 0 ? void 0 : ve[_$_b839[157]](ge);
                }), this[_$_b839[1881]] = [];
              }, ce[_$_b839[37]][_$_b839[1941]] = function() {
                this[_$_b839[1920]](-1), this[_$_b839[1883]] = [], this[_$_b839[1916]] = [];
              }, ce[_$_b839[37]][_$_b839[1907]] = function() {
                this[_$_b839[1917]]({ time: this[_$_b839[1434]][_$_b839[859]]() });
              }, ce[_$_b839[37]][_$_b839[1942]] = function() {
                return !0;
              }, ce[_$_b839[37]][_$_b839[1943]] = function(he) {
                this[_$_b839[1884]] = he;
              }, ce[_$_b839[37]][_$_b839[340]] = function() {
                var he;
                this[_$_b839[1881]] = [], this[_$_b839[1883]] = [], this[_$_b839[1916]] = [], (he = this[_$_b839[1925]]) === null || he === void 0 || he[_$_b839[340]](), this[_$_b839[1927]]();
              }, ce[_$_b839[37]][_$_b839[1944]] = function() {
                return this[_$_b839[1881]];
              }, ce;
            }();
            function le(ce) {
              var he = { text: ce[_$_b839[1326]] };
              return _$_b839[1945] in ce && (he[_$_b839[1945]] = ce[_$_b839[1945]], he[_$_b839[1326]] = he[_$_b839[1326]] || he[_$_b839[1945]]), _$_b839[1946] in ce && (he[_$_b839[1946]] = ce[_$_b839[1946]]), _$_b839[1947] in ce && (he[_$_b839[1948]] = ce[_$_b839[1947]]), _$_b839[1949] in ce && (he[_$_b839[1949]] = ce[_$_b839[1949]]), _$_b839[1950] in ce && (he[_$_b839[1950]] = ce[_$_b839[1950]]), _$_b839[1951] in ce && (he[_$_b839[1951]] = ce[_$_b839[1951]]), he;
            }
            function se(ce) {
              var he = [];
              return _$_b839[1885] in ce && (he = ce[_$_b839[1885]][_$_b839[137]](function(ge) {
                return { updateTime: ge[_$_b839[1934]], content: { html: ge[_$_b839[1945]], text: ce[_$_b839[1326]] } };
              })), he;
            }
            function oe(ce, he) {
              for (var ge = ce[_$_b839[26]] - 1; ge >= 0; ge--)
                if (ce[ge][_$_b839[1934]] <= he)
                  return ce[ge];
            }
            te[_$_b839[1879]] = fe;
          }, 88005: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(Te) {
                for (var Ee, Me = 1, Ae = arguments[_$_b839[26]]; Me < Ae; Me++)
                  for (var Ne in Ee = arguments[Me])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](Ee, Ne) && (Te[Ne] = Ee[Ne]);
                return Te;
              }, ie[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1826]] = void 0;
            var ne, ae = ee(331), ue = ee(91520), _e = ee(16368), fe = ee(62510), le = ee(67345), se = ee(87326), oe = ee(37233), ce = ee(13533), he = ee(30051), ge = ee(43485), ve = ee(76885), me = ee(54838), be = ee(78936), pe = ee(90637), $e = ee(36564), ye = ee(65411);
            function Se() {
              return { requestType: le[_$_b839[1272]][_$_b839[1317]], maxRetries: 0 };
            }
            (function(Te) {
              Te[_$_b839[240]] = _$_b839[1952];
            })(ne || (ne = {}));
            var we = function() {
              function Te(Ee, Me) {
                Me === void 0 && (Me = Se());
                var Ae = this;
                this[_$_b839[1040]] = function(Ne, Ce, Ie, xe, Ue, ke, Le, De) {
                  return ke === void 0 && (ke = !1), De === void 0 && (De = !1), Ae[_$_b839[1953]] = Le, Ae[_$_b839[1954]] = De, Ce = Ce || le[_$_b839[1270]][_$_b839[1327]], Ne = Ae[_$_b839[1955]](Ne), Ue = $e[_$_b839[1958]][_$_b839[1957]](Ae[_$_b839[809]][_$_b839[1956]], Ue), Ne ? (Ae[_$_b839[1959]] = { method: Ce, url: ve[_$_b839[1961]][_$_b839[1960]](Ne), headers: JSON[_$_b839[283]](JSON[_$_b839[282]](Ue)), responseType: Ie || le[_$_b839[1271]][_$_b839[1325]], credentials: ke ? _$_b839[1962] : _$_b839[1963] }, xe && (Ae[_$_b839[1959]][_$_b839[1853]] = xe), Ae[_$_b839[1975]](Ae[_$_b839[1959]])[_$_b839[166]](function(Re) {
                    return Ae[_$_b839[1845]](Re)[_$_b839[904]](Ae[_$_b839[1974]]);
                  })[_$_b839[166]](Ae[_$_b839[1973]])[_$_b839[166]](Ae[_$_b839[1972]])[_$_b839[166]](function(Re) {
                    return Ae[_$_b839[1964]] && Re[_$_b839[1853]] instanceof Ae[_$_b839[1964]][_$_b839[1965]] ? Re[_$_b839[1853]] = Re[_$_b839[1853]][_$_b839[1971]](function(Oe) {
                      return Oe;
                    }, function() {
                      return Ae[_$_b839[1966]](Re);
                    }, function(Oe) {
                      return Oe[_$_b839[89]] === pe[_$_b839[1968]][_$_b839[1967]] && Ae[_$_b839[1969]](), Re[_$_b839[1853]][_$_b839[1970]](Oe[_$_b839[89]]), Oe[_$_b839[89]];
                    }) : Ae[_$_b839[1966]](Re), Re;
                  })) : Promise[_$_b839[913]](_$_b839[1976]);
                }, this[_$_b839[1972]] = function(Ne) {
                  return Ae[_$_b839[1977]](Ne[_$_b839[1848]]) ? Ae[_$_b839[1979]](_$_b839[1978], Ne) : Promise[_$_b839[602]](Ne);
                }, this[_$_b839[1975]] = function(Ne) {
                  return Ae[_$_b839[1982]](Ne, Ae[_$_b839[1981]][_$_b839[1980]]);
                }, this[_$_b839[1973]] = function(Ne) {
                  return Ae[_$_b839[1982]](Ne, Ae[_$_b839[1981]][_$_b839[1983]]);
                }, this[_$_b839[1984]] = function(Ne) {
                  if (_$_b839[34] == typeof Ae[_$_b839[1435]][_$_b839[1984]] && !Ae[_$_b839[1985]] && Ae[_$_b839[1986]]) {
                    if (Ne[_$_b839[1987]] >= 0 && Ne[_$_b839[1988]] !== void 0 && Ne[_$_b839[1987]] >= Ne[_$_b839[1988]])
                      return;
                    var Ce = Ae[_$_b839[1991]][_$_b839[1990]](Ae[_$_b839[1989]][_$_b839[240]]);
                    Ae[_$_b839[1435]][_$_b839[1984]](ie(ie({}, Ne), { elapsedTime: Ce }));
                  }
                }, this[_$_b839[1974]] = function(Ne) {
                  Ae[_$_b839[1992]]++;
                  var Ce = Ne[_$_b839[1993]] && Ne[_$_b839[1993]][_$_b839[1848]], Ie = Ne[_$_b839[1993]] ? Ne[_$_b839[1993]][_$_b839[1205]] : null;
                  return !Ce && Ae[_$_b839[1435]][_$_b839[1994]] && Pe(Ie) && (Ae[_$_b839[1992]] = 0), Ne[_$_b839[73]] === pe[_$_b839[1968]][_$_b839[1995]] || Ne[_$_b839[73]] === pe[_$_b839[1968]][_$_b839[1996]] ? Ae[_$_b839[1979]](Ne[_$_b839[73]], null) : Ae[_$_b839[1973]](Ne[_$_b839[1993]])[_$_b839[166]](function(xe) {
                    return Ae[_$_b839[1981]][_$_b839[1997]] && _$_b839[34] == typeof Ae[_$_b839[1981]][_$_b839[1997]] ? Ae[_$_b839[1997]](Ne[_$_b839[73]], xe) : Ce && Ae[_$_b839[1977]](xe[_$_b839[1848]]) ? Ae[_$_b839[1979]](_$_b839[1998] + xe[_$_b839[1848]], xe) : Ae[_$_b839[1992]] <= Ae[_$_b839[1435]][_$_b839[1999]] ? Ae[_$_b839[2e3]]()[_$_b839[904]](Ae[_$_b839[1974]]) : Ae[_$_b839[1979]](_$_b839[2001], Ne[_$_b839[1993]]);
                  });
                }, this[_$_b839[1979]] = function(Ne, Ce) {
                  var Ie = Ae[_$_b839[1992]];
                  return Ae[_$_b839[706]](), Ae[_$_b839[1986]] = !1, Ae[_$_b839[2002]](!1, Ce, Ie), Ae[_$_b839[1435]][_$_b839[2003]](Ce, { name: Ne }, Ie - 1), Promise[_$_b839[913]](Ce ?? new Error(Ne));
                }, this[_$_b839[91]] = Ee, this[_$_b839[1981]] = this[_$_b839[91]][_$_b839[1435]] && this[_$_b839[91]][_$_b839[1435]][_$_b839[685]] || {}, ue[_$_b839[140]][_$_b839[152]](_e[_$_b839[168]][_$_b839[183]]) && (this[_$_b839[1964]] = ue[_$_b839[140]][_$_b839[159]](_e[_$_b839[168]][_$_b839[183]])), this[_$_b839[1435]] = ie(ie({}, Se()), Me), this[_$_b839[1991]] = new be[_$_b839[2004]](this[_$_b839[91]]), this[_$_b839[44]]();
              }
              return Te[_$_b839[37]][_$_b839[2005]] = function(Ee, Me, Ae) {
                return Math[_$_b839[247]](Math[_$_b839[2006]](Ee * Me), Ae);
              }, Te[_$_b839[37]][_$_b839[2002]] = function(Ee, Me, Ae) {
                Me && this[_$_b839[1435]][_$_b839[2007]] && this[_$_b839[739]](fe[_$_b839[382]][_$_b839[460]], { type: fe[_$_b839[382]][_$_b839[460]], timestamp: Date[_$_b839[840]](), httpStatus: Me[_$_b839[1848]], success: Ee, url: Me[_$_b839[1205]], downloadTime: (0, ae[_$_b839[276]])(me[_$_b839[1022]][_$_b839[2009]]((0, ae[_$_b839[1266]])(Me[_$_b839[2008]]), 0)), size: Me[_$_b839[26]] || 0, attempt: Ae, maxAttempts: this[_$_b839[1435]][_$_b839[1999]] + 1, downloadType: this[_$_b839[1435]][_$_b839[2007]], mimeType: this[_$_b839[1953]], timeToFirstByte: Me[_$_b839[2010]] });
              }, Te[_$_b839[37]][_$_b839[2011]] = function() {
                return this[_$_b839[1986]];
              }, Te[_$_b839[37]][_$_b839[2012]] = function() {
                return this[_$_b839[1992]] > 0;
              }, Te[_$_b839[37]][_$_b839[2013]] = function(Ee) {
                this[_$_b839[1435]][_$_b839[1994]] = Ee;
              }, Te[_$_b839[37]][_$_b839[2014]] = function(Ee) {
                this[_$_b839[1435]][_$_b839[1999]] = Ee;
              }, Te[_$_b839[37]][_$_b839[1955]] = function(Ee) {
                return ve[_$_b839[1961]][_$_b839[2016]](Ee, this[_$_b839[809]][_$_b839[2015]]);
              }, Te[_$_b839[37]][_$_b839[1845]] = function(Ee) {
                var Me = this;
                if (this[_$_b839[1985]])
                  return Promise[_$_b839[913]]({ error: pe[_$_b839[1968]][_$_b839[1995]], response: null });
                this[_$_b839[1989]] && this[_$_b839[1991]][_$_b839[1064]](this[_$_b839[1989]]);
                var Ae = _$_b839[2017] + me[_$_b839[1022]][_$_b839[1377]]();
                return this[_$_b839[1989]] = { start: Ae + ne[_$_b839[240]] }, this[_$_b839[1991]][_$_b839[2018]](this[_$_b839[1989]][_$_b839[240]]), this[_$_b839[1959]] = Ee, this[_$_b839[1986]] = !0, this[_$_b839[2019]](), this[_$_b839[2021]][_$_b839[2020]]()[_$_b839[166]](function(Ne) {
                  return Ne[_$_b839[2008]] == null && (Ne[_$_b839[2008]] = Me[_$_b839[1991]][_$_b839[1990]](Me[_$_b839[1989]][_$_b839[240]]), Ne[_$_b839[2010]] = 0), Ne;
                });
              }, Te[_$_b839[37]][_$_b839[2022]] = function() {
                var Ee;
                this[_$_b839[1981]][_$_b839[2023]] && _$_b839[34] == typeof this[_$_b839[1981]][_$_b839[2023]] && (Ee = this[_$_b839[1981]][_$_b839[2023]](this[_$_b839[1435]][_$_b839[2007]], this[_$_b839[1959]]));
                var Me = this[_$_b839[1981]][_$_b839[689]] === le[_$_b839[1269]][_$_b839[1333]] || this[_$_b839[1954]];
                return Me && !(0, ge[_$_b839[2024]])() && (this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[2025]), Me = !1), Ee && _$_b839[34] == typeof Ee[_$_b839[2020]] || (Ee = Me ? this[_$_b839[2026]]() : this[_$_b839[2027]]()), Ee;
              }, Te[_$_b839[37]][_$_b839[2019]] = function() {
                var Ee = this, Me = this[_$_b839[2022]]();
                Me[_$_b839[2028]](function(Ne) {
                  return Ee[_$_b839[1984]](Ne);
                });
                var Ae = he[_$_b839[2030]][_$_b839[2029]](Me[_$_b839[2020]]());
                this[_$_b839[2021]] = { getResponse: function() {
                  return Ae;
                }, cancel: function() {
                  Me[_$_b839[1969]](), Ae[_$_b839[1969]]({ error: pe[_$_b839[1968]][_$_b839[1995]], response: null });
                }, setProgressListener: Me[_$_b839[2028]] };
              }, Te[_$_b839[37]][_$_b839[2027]] = function() {
                var Ee = (0, ae[_$_b839[1266]])(this[_$_b839[809]][_$_b839[2031]]);
                return this[_$_b839[1435]][_$_b839[2032]] && (Ee = -1), new ye[_$_b839[2033]](this[_$_b839[91]][_$_b839[280]], this[_$_b839[1959]], Ee);
              }, Te[_$_b839[37]][_$_b839[2026]] = function() {
                return new this[_$_b839[1964]][_$_b839[2034]](this[_$_b839[91]], this[_$_b839[1959]], (0, ae[_$_b839[1266]])(this[_$_b839[809]][_$_b839[2031]]), this[_$_b839[1954]]);
              }, Te[_$_b839[37]][_$_b839[1982]] = function(Ee, Me) {
                return Me && _$_b839[34] == typeof Me ? Promise[_$_b839[602]](Me(this[_$_b839[1435]][_$_b839[2007]], Ee) || Ee) : Promise[_$_b839[602]](Ee);
              }, Te[_$_b839[37]][_$_b839[1966]] = function(Ee) {
                this[_$_b839[1986]] = !1, this[_$_b839[2002]](!0, Ee, this[_$_b839[1992]] + 1), this[_$_b839[1435]][_$_b839[2035]](Ee, Ee[_$_b839[2008]], Ee[_$_b839[1205]]), this[_$_b839[706]](), Ee[_$_b839[1205]] && (0, ce[_$_b839[107]])()[_$_b839[138]]((0, oe[_$_b839[2037]])((0, ve[_$_b839[2036]])(Ee[_$_b839[1205]])));
              }, Te[_$_b839[37]][_$_b839[1997]] = function(Ee, Me) {
                var Ae = this, Ne = this[_$_b839[1981]][_$_b839[1997]](this[_$_b839[1435]][_$_b839[2007]], Me, this[_$_b839[1992]]);
                return Promise[_$_b839[602]](Ne)[_$_b839[166]](function(Ce) {
                  return Ce[_$_b839[2038]] ? (Ae[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[2039], Ce), Ae[_$_b839[1979]](_$_b839[2039], Me)) : Ae[_$_b839[1845]](Ce)[_$_b839[904]](Ae[_$_b839[1974]]);
                })[_$_b839[904]](function() {
                  return Ae[_$_b839[1979]](Ee, Me);
                });
              }, Te[_$_b839[37]][_$_b839[2e3]] = function() {
                var Ee = this, Me = this[_$_b839[1435]][_$_b839[2040]], Ae = _$_b839[2041];
                return this[_$_b839[809]][_$_b839[2042]] && (Me = this[_$_b839[2005]](this[_$_b839[809]][_$_b839[2043]], this[_$_b839[1992]], this[_$_b839[809]][_$_b839[2044]]), Ae = _$_b839[2045]), this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[2050][_$_b839[41]](Ae, _$_b839[2049])[_$_b839[41]](Me == null ? void 0 : Me[_$_b839[2047]](1), _$_b839[2048])[_$_b839[41]](this[_$_b839[1992]], _$_b839[2046])[_$_b839[41]](this[_$_b839[1959]][_$_b839[1205]])), new Promise(function(Ne, Ce) {
                  var Ie = setTimeout(function() {
                    Ee[_$_b839[1845]](Ee[_$_b839[1959]])[_$_b839[166]](Ne)[_$_b839[904]](Ce);
                  }, (0, ae[_$_b839[1266]])(Me));
                  Ee[_$_b839[2051]] = function() {
                    Ee[_$_b839[2051]] = null, clearTimeout(Ie), Ce({ error: pe[_$_b839[1968]][_$_b839[1995]], response: null });
                  };
                });
              }, Te[_$_b839[37]][_$_b839[1977]] = function(Ee) {
                return this[_$_b839[1435]][_$_b839[2007]] in this[_$_b839[809]][_$_b839[2052]] && this[_$_b839[809]][_$_b839[2052]][this[_$_b839[1435]][_$_b839[2007]]][_$_b839[815]](Ee);
              }, Te[_$_b839[37]][_$_b839[706]] = function() {
                this[_$_b839[1992]] = 0, this[_$_b839[1985]] = !1, this[_$_b839[2051]] && _$_b839[34] == typeof this[_$_b839[2051]] && this[_$_b839[2051]]();
              }, Te[_$_b839[37]][_$_b839[1969]] = function() {
                this[_$_b839[1985]] = !0, this[_$_b839[1986]] && (this[_$_b839[1986]] = !1, this[_$_b839[2051]] && this[_$_b839[2051]](), this[_$_b839[2021]] && this[_$_b839[2021]][_$_b839[1969]]());
              }, Te[_$_b839[37]][_$_b839[2020]] = function() {
                if (this[_$_b839[2021]] && _$_b839[34] == typeof this[_$_b839[2021]][_$_b839[2020]])
                  return this[_$_b839[2021]][_$_b839[2020]]();
              }, Te[_$_b839[37]][_$_b839[44]] = function() {
                var Ee = [_$_b839[2035], _$_b839[2003]];
                this[_$_b839[1992]] = 0;
                var Me = {};
                me[_$_b839[1022]][_$_b839[1663]](Me, se[_$_b839[714]]), this[_$_b839[809]] = this[_$_b839[91]][_$_b839[809]] || Me;
                for (var Ae = 0; Ae < Ee[_$_b839[26]]; Ae++)
                  this[_$_b839[1435]][_$_b839[215]](Ee[Ae]) && _$_b839[34] == typeof this[_$_b839[1435]][Ee[Ae]] || (this[_$_b839[1435]][Ee[Ae]] = function() {
                  });
                this[_$_b839[91]][_$_b839[626]] && _$_b839[34] == typeof this[_$_b839[91]][_$_b839[626]][_$_b839[739]] ? this[_$_b839[739]] = this[_$_b839[91]][_$_b839[626]][_$_b839[739]] : this[_$_b839[739]] = function() {
                };
              }, Te[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[2011]]() && this[_$_b839[1969]](), this[_$_b839[1989]] && this[_$_b839[1991]][_$_b839[1064]](this[_$_b839[1989]]), this[_$_b839[2021]] = null, this[_$_b839[739]] = null, this[_$_b839[809]] = null;
              }, Te;
            }();
            function Pe(Te) {
              return _$_b839[109] == typeof Te && (0, ce[_$_b839[2053]])()[_$_b839[353]][_$_b839[815]]((0, ve[_$_b839[2036]])(Te));
            }
            te[_$_b839[1826]] = we;
          }, 59181: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2054]] = void 0, function(ie) {
              ie[_$_b839[743]] = _$_b839[2055], ie[_$_b839[746]] = _$_b839[2056], ie[_$_b839[171]] = _$_b839[2057];
            }(ee || (te[_$_b839[2054]] = ee = {}));
          }, 78936: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2004]] = void 0;
            var ie = ee(331), ne = ee(12733), ae = function() {
              function ue(_e) {
                this[_$_b839[91]] = _e;
              }
              return ue[_$_b839[37]][_$_b839[2058]] = function(_e) {
                return _e[_$_b839[26]] === 0 ? (this[_$_b839[91]][_$_b839[280]][_$_b839[38]](_$_b839[2059]), [{ startTime: 0, duration: 0 }]) : _e;
              }, ue[_$_b839[37]][_$_b839[2060]] = function(_e) {
                return this[_$_b839[2058]](ne[_$_b839[2062]][_$_b839[2061]](_e));
              }, ue[_$_b839[37]][_$_b839[2018]] = function(_e) {
                ne[_$_b839[2062]][_$_b839[2063]](_e);
              }, ue[_$_b839[37]][_$_b839[1990]] = function(_e) {
                var fe = this[_$_b839[2060]](_e);
                return (0, ie[_$_b839[276]])(ne[_$_b839[2062]][_$_b839[840]]() - fe[0][_$_b839[1604]]);
              }, ue[_$_b839[37]][_$_b839[1064]] = function(_e) {
                (function() {
                  return Array[_$_b839[254]](_e) ? _e : Object[_$_b839[1083]](_e);
                })()[_$_b839[113]](function(fe) {
                  ne[_$_b839[2062]][_$_b839[2064]](fe);
                });
              }, ue;
            }();
            te[_$_b839[2004]] = ae;
          }, 2193: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2065]] = void 0, function(se) {
              se[_$_b839[2063]] = _$_b839[2063], se[_$_b839[2066]] = _$_b839[2066];
            }(ee || (ee = {}));
            var ie = [], ne = {}, ae = function(se, oe) {
              ie = oe ? ie[_$_b839[112]](function(ce) {
                return ce[_$_b839[62]] !== oe && ce[_$_b839[2067]] === se;
              }) : ie[_$_b839[112]](function(ce) {
                return ce[_$_b839[2067]] !== se;
              });
            }, ue = function(se, oe) {
              return ie[_$_b839[112]](function(ce) {
                return ce[se] === oe;
              });
            }, _e = function(se, oe) {
              ne[oe] = se, ie[_$_b839[57]](se);
            }, fe = function(se, oe) {
              var ce = function(he) {
                return _$_b839[2069][_$_b839[41]](he, _$_b839[2068]);
              };
              if (!ne[oe])
                throw new Error(ce(oe));
              if (!ne[se])
                throw new Error(ce(se));
            }, le = function() {
              return { now: function() {
                return Date[_$_b839[840]]();
              }, mark: function(se) {
                var oe = { name: se, entryType: ee[_$_b839[2063]], startTime: this[_$_b839[840]](), duration: 0 };
                _e(oe, se);
              }, measure: function(se, oe, ce) {
                fe(oe, ce);
                var he = ne[oe] ? ne[oe][_$_b839[1604]] : 0, ge = { name: se, startTime: he, duration: (ne[ce] ? ne[ce][_$_b839[1604]] : this[_$_b839[840]]()) - he, entryType: ee[_$_b839[2066]] };
                _e(ge, se);
              }, getEntriesByName: function(se) {
                return ue(_$_b839[62], se);
              }, getEntriesByType: function(se) {
                return ue(_$_b839[2067], se);
              }, clearMarks: function(se) {
                ae(ee[_$_b839[2063]], se);
              }, clearMeasures: function(se) {
                ae(ee[_$_b839[2066]], se);
              } };
            };
            te[_$_b839[2065]] = le;
          }, 12733: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2062]] = te[_$_b839[2070]] = te[_$_b839[2071]] = void 0;
            var ie = ee(2193);
            function ne(ue, _e) {
              return _e[_$_b839[267]](function(fe) {
                return _$_b839[34] == typeof ue[fe];
              });
            }
            te[_$_b839[2071]] = [_$_b839[840], _$_b839[2063], _$_b839[2066], _$_b839[2061], _$_b839[2072], _$_b839[2064], _$_b839[2073]];
            var ae = function(ue) {
              return ne(ue[_$_b839[1991]], te[_$_b839[2071]]) ? ue[_$_b839[1991]] : (0, ie[_$_b839[2065]])();
            };
            te[_$_b839[2070]] = ae, te[_$_b839[2062]] = (0, te[_$_b839[2070]])(window);
          }, 90637: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1968]] = void 0, function(ie) {
              ie[_$_b839[1967]] = _$_b839[2074], ie[_$_b839[1995]] = _$_b839[2075], ie[_$_b839[1996]] = _$_b839[2076];
            }(ee || (te[_$_b839[1968]] = ee = {}));
          }, 6311: function(re, te) {
            _$_b839[32];
            function ee(ie) {
              var ne, ae, ue = ((ae = (ne = ie[_$_b839[2077]]) === null || ne === void 0 ? void 0 : ne[_$_b839[2078]]) !== null && ae !== void 0 ? ae : -1) > -1, _e = ie[_$_b839[1987]] > 0;
              return ue && _e;
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2079]] = ee;
          }, 23234: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2080]] = void 0;
            var ie = ee(331), ne = function() {
              function ae() {
              }
              return ae[_$_b839[2081]] = function() {
                return window[_$_b839[1991]] && _$_b839[34] == typeof window[_$_b839[1991]][_$_b839[840]] ? (0, ie[_$_b839[276]])(window[_$_b839[1991]][_$_b839[840]]()) : (0, ie[_$_b839[276]])(Date[_$_b839[840]]());
              }, ae;
            }();
            te[_$_b839[2080]] = ne;
          }, 23974: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2082]] = void 0, function(ie) {
              ie[_$_b839[2083]] = _$_b839[2084], ie[_$_b839[2085]] = _$_b839[1970], ie[_$_b839[409]] = _$_b839[73], ie[_$_b839[2086]] = _$_b839[1040], ie[_$_b839[2087]] = _$_b839[2088], ie[_$_b839[2089]] = _$_b839[2090], ie[_$_b839[2091]] = _$_b839[2092], ie[_$_b839[2093]] = _$_b839[2094];
            }(ee || (te[_$_b839[2082]] = ee = {}));
          }, 36564: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(se) {
                for (var oe, ce = 1, he = arguments[_$_b839[26]]; ce < he; ce++)
                  for (var ge in oe = arguments[ce])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](oe, ge) && (se[ge] = oe[ge]);
                return se;
              }, ie[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1958]] = void 0, te[_$_b839[2095]] = le;
            var ne = ee(67345), ae = ee(13533), ue = function() {
              function se() {
              }
              return se[_$_b839[2096]] = function(oe) {
                if (!oe || oe[_$_b839[2097]]()[_$_b839[26]] === 0)
                  return {};
                var ce = {};
                return oe[_$_b839[124]](_$_b839[2098])[_$_b839[112]](function(he) {
                  return _$_b839[90] !== he;
                })[_$_b839[113]](function(he) {
                  var ge = he[_$_b839[124]](_$_b839[1118]);
                  ce[ge[0]] = ge[1];
                }), ce;
              }, se[_$_b839[2099]] = function(oe, ce, he) {
                var ge = oe[_$_b839[1368]] === XMLHttpRequest[_$_b839[2100]] && (0, ae[_$_b839[646]])()[_$_b839[1466]] ? { status: -1, statusText: _$_b839[2101] } : { status: oe[_$_b839[1848]], statusText: oe[_$_b839[2102]] }, ve = se[_$_b839[2096]](oe[_$_b839[2103]]()), me = ie({ request: ce, url: oe[_$_b839[2104]] || ce[_$_b839[1205]], headers: ve }, ge);
                return fe(he) && (me[_$_b839[2010]] = he[_$_b839[2078]] - he[_$_b839[2105]], me[_$_b839[2008]] = he[_$_b839[2106]] - he[_$_b839[2105]]), oe[_$_b839[1993]] && (me[_$_b839[1853]] = this[_$_b839[2108]](oe, ce[_$_b839[2107]]), me[_$_b839[26]] = oe[_$_b839[1993]][_$_b839[2109]] || oe[_$_b839[1993]][_$_b839[26]] || 0), me;
              }, se[_$_b839[2108]] = function(oe, ce) {
                var he;
                if (ce === ne[_$_b839[1271]][_$_b839[1323]] && (!((he = oe[_$_b839[2111]](_$_b839[2110])) === null || he === void 0) && he[_$_b839[815]](_$_b839[2112])) && _$_b839[109] == typeof oe[_$_b839[1993]])
                  try {
                    return JSON[_$_b839[283]](oe[_$_b839[1993]]);
                  } catch {
                    return null;
                  }
                return oe[_$_b839[1993]];
              }, se[_$_b839[2113]] = function(oe, ce) {
                ce && Object[_$_b839[98]](ce)[_$_b839[26]] > 0 && Object[_$_b839[98]](ce)[_$_b839[113]](function(he) {
                  oe[_$_b839[2114]](he, ce[he]);
                });
              }, se[_$_b839[1957]] = function() {
                for (var oe = [], ce = 0; ce < arguments[_$_b839[26]]; ce++)
                  oe[ce] = arguments[ce];
                var he = {};
                return oe[_$_b839[113]](function(ge) {
                  ge && Object[_$_b839[98]](ge)[_$_b839[113]](function(ve) {
                    var me = _e(he, ve);
                    me ? he[me] = ge[ve] : he[ve] = ge[ve];
                  });
                }), he;
              }, se;
            }();
            function _e(se, oe) {
              return Object[_$_b839[98]](se)[_$_b839[824]](function(ce) {
                return ce[_$_b839[1608]]() === oe[_$_b839[1608]]();
              });
            }
            function fe(se) {
              return se[_$_b839[2105]] > -1 && se[_$_b839[2078]] > -1 && se[_$_b839[2106]] > -1;
            }
            function le(se) {
              return se[_$_b839[26]] > 0 && se[_$_b839[2008]] >= 0 && se[_$_b839[2010]] >= 0 && se[_$_b839[2008]] > se[_$_b839[2010]];
            }
            te[_$_b839[1958]] = ue;
          }, 65411: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2033]] = void 0;
            var ie = ee(90637), ne = ee(23974), ae = ee(10501), ue = function() {
              function _e(fe, le, se) {
                var oe = this;
                this[_$_b839[2028]] = function(ce) {
                  oe[_$_b839[2038]][_$_b839[75]](ne[_$_b839[2082]][_$_b839[2091]], function(he) {
                    return ce(he);
                  });
                }, this[_$_b839[2038]] = new ae[_$_b839[2115]](fe, le, se);
              }
              return _e[_$_b839[37]][_$_b839[2020]] = function() {
                return this[_$_b839[2116]] = this[_$_b839[2116]] || this[_$_b839[2038]][_$_b839[2117]](), this[_$_b839[2116]];
              }, _e[_$_b839[37]][_$_b839[1969]] = function() {
                this[_$_b839[2038]][_$_b839[1970]](ie[_$_b839[1968]][_$_b839[1995]]);
              }, _e;
            }();
            te[_$_b839[2033]] = ue;
          }, 10501: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(se) {
                for (var oe, ce = 1, he = arguments[_$_b839[26]]; ce < he; ce++)
                  for (var ge in oe = arguments[ce])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](oe, ge) && (se[ge] = oe[ge]);
                return se;
              }, ie[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2115]] = void 0;
            var ne = ee(331), ae = ee(90637), ue = ee(23234), _e = ee(23974), fe = ee(36564), le = function() {
              function se(oe, ce, he) {
                var ge = this;
                this[_$_b839[2118]] = !1, this[_$_b839[2119]] = function(ve) {
                  var me, be, pe = (me = ve[_$_b839[2120]]) !== null && me !== void 0 ? me : -1, $e = (be = ve[_$_b839[2121]]) !== null && be !== void 0 ? be : -1, ye = ue[_$_b839[2080]][_$_b839[2081]]();
                  ge[_$_b839[2092]][_$_b839[1988]] = pe, ge[_$_b839[2092]][_$_b839[1987]] = $e, ge[_$_b839[2123]][_$_b839[2122]] = ye, $e < pe && ge[_$_b839[2124]]();
                }, this[_$_b839[2125]] = function(ve) {
                  var me = (0, ne[_$_b839[276]])(ve[_$_b839[2126]]);
                  if (ge[_$_b839[2127]][_$_b839[1368]] === ge[_$_b839[2127]][_$_b839[2100]])
                    ge[_$_b839[2123]][_$_b839[2105]] = me, ge[_$_b839[2124]]();
                  else if (ge[_$_b839[2127]][_$_b839[1368]] === ge[_$_b839[2127]][_$_b839[2128]])
                    ge[_$_b839[2123]][_$_b839[2078]] = me, ge[_$_b839[2124]]();
                  else if (ge[_$_b839[2127]][_$_b839[1368]] === ge[_$_b839[2127]][_$_b839[2129]]) {
                    var be = ge[_$_b839[2127]][_$_b839[1848]] >= 200 && ge[_$_b839[2127]][_$_b839[1848]] < 300;
                    ge[_$_b839[2123]][_$_b839[2106]] = me, be && ge[_$_b839[2127]][_$_b839[1993]] !== null ? ge[_$_b839[602]](fe[_$_b839[1958]][_$_b839[2099]](ge[_$_b839[2127]], ge[_$_b839[1959]], ge[_$_b839[2123]])) : ge[_$_b839[2118]] || ge[_$_b839[2130]](ae[_$_b839[1968]][_$_b839[1967]]), ge[_$_b839[340]]();
                  }
                }, this[_$_b839[280]] = oe, this[_$_b839[1959]] = ce, this[_$_b839[2094]] = he, this[_$_b839[99]] = {}, this[_$_b839[2131]] = !1, this[_$_b839[2123]] = { sendTimestamp: -1, openedTimestamp: -1, headersReceivedTimestamp: -1, progressTimestamp: -1, doneTimestamp: -1 }, this[_$_b839[2092]] = { totalBytes: -1, loadedBytes: -1, url: ce[_$_b839[1205]], responseTiming: this[_$_b839[2123]] };
              }
              return se[_$_b839[37]][_$_b839[75]] = function(oe, ce) {
                this[_$_b839[99]] = this[_$_b839[99]] || {}, this[_$_b839[99]][oe] = this[_$_b839[99]][oe] || [], this[_$_b839[99]][oe][_$_b839[57]](ce);
              }, se[_$_b839[37]][_$_b839[2124]] = function() {
                var oe, ce = this;
                ((oe = this[_$_b839[99]][_e[_$_b839[2082]][_$_b839[2091]]]) !== null && oe !== void 0 ? oe : [])[_$_b839[113]](function(he) {
                  return he(ie({}, ce[_$_b839[2092]]));
                });
              }, se[_$_b839[37]][_$_b839[2117]] = function() {
                var oe = this;
                return this[_$_b839[2127]] = new XMLHttpRequest(), this[_$_b839[2131]] = !1, this[_$_b839[2118]] = !1, new Promise(function(ce, he) {
                  oe[_$_b839[602]] = ce, oe[_$_b839[913]] = he;
                  try {
                    oe[_$_b839[2127]][_$_b839[76]](_e[_$_b839[2082]][_$_b839[2091]], oe[_$_b839[2119]]), oe[_$_b839[2127]][_$_b839[76]](_e[_$_b839[2082]][_$_b839[2083]], oe[_$_b839[2125]]);
                  } catch (ge) {
                    return oe[_$_b839[280]][_$_b839[265]](_$_b839[2132], ge), ce(oe[_$_b839[2117]]());
                  }
                  oe[_$_b839[2123]][_$_b839[2133]] = ue[_$_b839[2080]][_$_b839[2081]](), oe[_$_b839[2127]][_$_b839[2134]](oe[_$_b839[1959]][_$_b839[1348]], oe[_$_b839[1959]][_$_b839[1205]]), oe[_$_b839[2127]][_$_b839[2135]] = _$_b839[1962] === oe[_$_b839[1959]][_$_b839[2136]], oe[_$_b839[2124]](), fe[_$_b839[1958]][_$_b839[2113]](oe[_$_b839[2127]], oe[_$_b839[1959]][_$_b839[2137]]), oe[_$_b839[1959]][_$_b839[2107]] && (oe[_$_b839[2127]][_$_b839[2107]] = oe[_$_b839[1959]][_$_b839[2107]]), clearTimeout(oe[_$_b839[2138]]), oe[_$_b839[2094]] > 0 && (oe[_$_b839[2138]] = setTimeout(function() {
                    return oe[_$_b839[1970]](ae[_$_b839[1968]][_$_b839[1996]]);
                  }, oe[_$_b839[2094]])), oe[_$_b839[1959]][_$_b839[1853]] ? oe[_$_b839[2127]][_$_b839[2117]](oe[_$_b839[1959]][_$_b839[1853]]) : oe[_$_b839[2127]][_$_b839[2117]]();
                });
              }, se[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[2131]] || (clearTimeout(this[_$_b839[2138]]), this[_$_b839[2127]][_$_b839[78]](_e[_$_b839[2082]][_$_b839[2091]], this[_$_b839[2119]]), this[_$_b839[2127]][_$_b839[78]](_e[_$_b839[2082]][_$_b839[2083]], this[_$_b839[2125]]), this[_$_b839[99]] = null, this[_$_b839[2127]] = null, this[_$_b839[602]] = null, this[_$_b839[913]] = null, this[_$_b839[2131]] = !0);
              }, se[_$_b839[37]][_$_b839[2130]] = function(oe, ce) {
                ce === void 0 && (ce = !1), this[_$_b839[2131]] || (this[_$_b839[913]]({ error: oe, response: fe[_$_b839[1958]][_$_b839[2099]](this[_$_b839[2127]], this[_$_b839[1959]], this[_$_b839[2123]]) }), ce && this[_$_b839[2127]][_$_b839[1970]]());
              }, se[_$_b839[37]][_$_b839[1970]] = function(oe) {
                oe === void 0 && (oe = ae[_$_b839[1968]][_$_b839[1995]]), this[_$_b839[2131]] || this[_$_b839[2118]] || (this[_$_b839[2118]] = !0, this[_$_b839[2130]](oe, !0), this[_$_b839[340]]());
              }, se;
            }();
            te[_$_b839[2115]] = le;
          }, 68039: function(re, te) {
            _$_b839[32];
            function ee(ie) {
              return Object[_$_b839[98]](te[_$_b839[2139]])[_$_b839[824]](function(ne) {
                return te[_$_b839[2139]][ne] === ie;
              });
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2139]] = void 0, te[_$_b839[2140]] = ee, te[_$_b839[2139]] = { "urn:mpeg:dash:mp4protection:2011": _$_b839[2141], "urn:mpeg:dash:13818:1:CA_descriptor:2011": _$_b839[2142], "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": _$_b839[2143], "urn:uuid:5e629af5-38da-4063-8977-97ffbd9902d4": _$_b839[2144], "urn:uuid:adb41c24-2dbf-4a6d-958b-4457c0d27b95": _$_b839[2145], "urn:uuid:a68129d3-575b-4f1a-9cba-3223846cf7c3": _$_b839[2146], "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": _$_b839[2147], "urn:uuid:9a27dd82-fde2-4725-8cbc-4234aa06ec09": _$_b839[2148], "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": _$_b839[2149], "urn:uuid:1f83e1e8-6ee9-4f0d-ba2f-5ec4e3ed1a66": _$_b839[2150], "urn:uuid:644fe7b5-260f-4fad-949a-0762ffb054b4": _$_b839[2151], "urn:uuid:6a99532d-869f-5922-9a91-113ab7b1e2f3": _$_b839[2152], "urn:uuid:35bf197b-530e-42d7-8b65-1b4bf415070f": _$_b839[2153], "urn:uuid:b4413586-c58c-ffb0-94a5-d4896c1af6c3": _$_b839[2154], "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": _$_b839[2155] };
          }, 97630: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2156]] = void 0, te[_$_b839[2156]] = { BOX_HEADER_LENGTH_REGULAR: 8, BOX_HEADER_LENGTH_LARGE: 16, BOX_SIZE_LENGTH: 4, BOX_TYPE_LENGTH: 4, FULL_BOX_VERSION_LENGTH: 1, FULL_BOX_FLAGS_LENGTH: 3, PSSH_KID_COUNT_LENGTH: 4, PSSH_KID_LEN: 16, PSSH_SYSTEM_ID_LENGTH: 16, PSSH_DATA_SIZE: 4 };
          }, 94304: function(re, te) {
            _$_b839[32];
            var ee, ie;
            function ne(ae) {
              return Object[_$_b839[98]](te[_$_b839[2157]])[_$_b839[824]](function(ue) {
                return te[_$_b839[2157]][ue][_$_b839[815]](ae);
              });
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2157]] = te[_$_b839[2158]] = void 0, te[_$_b839[2159]] = ne, function(ae) {
              ae[_$_b839[2160]] = _$_b839[2161], ae[_$_b839[2162]] = _$_b839[2147], ae[_$_b839[2163]] = _$_b839[2149], ae[_$_b839[2164]] = _$_b839[2143];
            }(ie || (te[_$_b839[2158]] = ie = {})), te[_$_b839[2157]] = ((ee = {})[ie[_$_b839[2160]]] = [_$_b839[2165], _$_b839[2166], _$_b839[2167]], ee[ie[_$_b839[2162]]] = [_$_b839[2168], _$_b839[2169], _$_b839[2170], _$_b839[2171]], ee[ie[_$_b839[2163]]] = [_$_b839[2172], _$_b839[2173]], ee[ie[_$_b839[2164]]] = [_$_b839[2174], _$_b839[2175]], ee);
          }, 15231: function(re, te) {
            _$_b839[32];
            function ee(ie, ne) {
              return { type: ie, meta: {}, payload: ne };
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2176]] = ee;
          }, 78842: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2177]] = void 0;
            var ie = ee(87093);
            te[_$_b839[2177]] = ie[_$_b839[107]][_$_b839[2178]];
          }, 50425: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2179]] = void 0, te[_$_b839[2180]] = ae, te[_$_b839[2181]] = ue;
            var ie = ee(91829), ne = function() {
              function _e() {
                this[_$_b839[2182]] = {};
              }
              return _e[_$_b839[37]][_$_b839[152]] = function(fe) {
                return !!this[_$_b839[2182]][fe];
              }, _e[_$_b839[37]][_$_b839[1045]] = function(fe, le) {
                return this[_$_b839[2182]][fe] = le, this;
              }, _e[_$_b839[37]][_$_b839[159]] = function(fe) {
                return this[_$_b839[2182]][fe];
              }, _e[_$_b839[37]][_$_b839[797]] = function(fe) {
                delete this[_$_b839[2182]][fe];
              }, _e[_$_b839[37]][_$_b839[98]] = function() {
                return Object[_$_b839[98]](this[_$_b839[2182]]);
              }, _e[_$_b839[37]][_$_b839[2183]] = function(fe) {
                var le = this, se = {};
                return this[_$_b839[98]]()[_$_b839[113]](function(oe) {
                  var ce = le[_$_b839[159]](oe), he = fe[_$_b839[41]](String(oe));
                  se[oe] = ae(ce) ? ce : ce[_$_b839[2183]](he);
                }), Object[_$_b839[98]](se)[_$_b839[26]] === 0 ? function(oe) {
                  return {};
                } : (0, ie[_$_b839[2184]])(se);
              }, _e[_$_b839[37]][_$_b839[2185]] = function() {
                return this[_$_b839[2183]]([]);
              }, _e;
            }();
            function ae(_e) {
              return !!_e && _$_b839[34] == typeof _e;
            }
            function ue(_e) {
              return !!_e && _e instanceof ne;
            }
            te[_$_b839[2179]] = ne;
          }, 9422: function(re, te) {
            _$_b839[32];
            var ee = this && this[_$_b839[227]] || function() {
              return ee = Object[_$_b839[228]] || function(ne) {
                for (var ae, ue = 1, _e = arguments[_$_b839[26]]; ue < _e; ue++)
                  for (var fe in ae = arguments[ue])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](ae, fe) && (ne[fe] = ae[fe]);
                return ne;
              }, ee[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2186]] = void 0;
            var ie = function(ne) {
              return function(ae) {
                return function() {
                  var ue = function() {
                    return ne[_$_b839[2185]]();
                  }, _e = ae(ue()), fe = function() {
                    return _e[_$_b839[2187]](ue());
                  };
                  return fe(), ee(ee({}, _e), { addReducer: function(le, se) {
                    ne[_$_b839[1045]](le, se), fe();
                  }, getReducer: function(le) {
                    return ne[_$_b839[159]](le);
                  }, removeReducer: function(le) {
                    ne[_$_b839[797]](le), fe();
                  }, hasReducer: function(le) {
                    return ne[_$_b839[152]](le);
                  } });
                };
              };
            };
            te[_$_b839[2186]] = ie;
          }, 13533: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[107]] = oe, te[_$_b839[646]] = ce, te[_$_b839[2053]] = ge;
            var ie, ne = ee(91829), ae = ee(47722), ue = (ee(78842), ee(13679), ee(39210)), _e = ee(50425), fe = ee(9422), le = new _e[_$_b839[2179]]();
            le[_$_b839[1045]](_$_b839[2190], ae[_$_b839[2191]])[_$_b839[1045]](_$_b839[2188], ue[_$_b839[2189]]);
            var se = function() {
              var me = [(0, fe[_$_b839[2186]])(le)];
              return (0, ne[_$_b839[2193]])(function() {
                return {};
              }, ne[_$_b839[2192]][_$_b839[35]](void 0, me));
            };
            function oe() {
              return ie || (ie = se()), ie;
            }
            function ce() {
              return he(oe()[_$_b839[136]]());
            }
            function he(me) {
              return me[_$_b839[2190]];
            }
            function ge() {
              return ve(oe()[_$_b839[136]]());
            }
            function ve(me) {
              return me[_$_b839[2188]];
            }
          }, 77845: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(fe) {
                for (var le, se = 1, oe = arguments[_$_b839[26]]; se < oe; se++)
                  for (var ce in le = arguments[se])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](le, ce) && (fe[ce] = le[ce]);
                return fe;
              }, ie[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1196]] = void 0;
            var ne = ee(50425), ae = ee(3464), ue = function() {
              function fe(le, se, oe) {
                var ce = this;
                this[_$_b839[2194]] = le, this[_$_b839[2195]] = se, this[_$_b839[2196]] = oe, this[_$_b839[2197]] = [], this[_$_b839[2198]] = function(he) {
                  return he[ce[_$_b839[2195]]][ce[_$_b839[2196]]];
                }, this[_$_b839[2199]] = new ne[_$_b839[2179]](), this[_$_b839[2200]](this[_$_b839[2199]]);
              }
              return fe[_$_b839[37]][_$_b839[138]] = function(le) {
                var se;
                return (se = this[_$_b839[2194]]) === null || se === void 0 ? void 0 : se[_$_b839[138]](this[_$_b839[2201]](le));
              }, fe[_$_b839[37]][_$_b839[2201]] = function(le) {
                var se;
                return ie(ie({}, le), { meta: ie(ie({}, le[_$_b839[2202]]), (se = {}, se[this[_$_b839[2195]]] = this[_$_b839[2196]], se)) });
              }, fe[_$_b839[37]][_$_b839[2203]] = function() {
                return this[_$_b839[2194]][_$_b839[2204]](this[_$_b839[2195]]) || this[_$_b839[2194]][_$_b839[1198]](this[_$_b839[2195]], new ne[_$_b839[2179]]()), this[_$_b839[2194]][_$_b839[2205]](this[_$_b839[2195]]);
              }, fe[_$_b839[37]][_$_b839[2200]] = function(le) {
                var se = this[_$_b839[2203]]();
                (0, ne[_$_b839[2181]])(se) && se[_$_b839[1045]](this[_$_b839[2196]], le), this[_$_b839[2194]][_$_b839[1198]](this[_$_b839[2195]], se);
              }, fe[_$_b839[37]][_$_b839[136]] = function() {
                var le, se = (le = this[_$_b839[2194]]) === null || le === void 0 ? void 0 : le[_$_b839[136]]();
                if (se)
                  return this[_$_b839[2198]](se);
              }, fe[_$_b839[37]][_$_b839[789]] = function(le, se) {
                var oe = this, ce = (0, ae[_$_b839[789]])(this[_$_b839[2194]])(this[_$_b839[2198]], le, se);
                return this[_$_b839[2197]][_$_b839[57]](ce), function() {
                  oe[_$_b839[2197]] = oe[_$_b839[2197]][_$_b839[112]](function(he) {
                    return he !== ce;
                  }), ce();
                };
              }, fe[_$_b839[37]][_$_b839[2206]] = function(le) {
                var se = this;
                return function(oe, ce) {
                  return !ce[_$_b839[2202]] || !ce[_$_b839[2202]][se[_$_b839[2195]]] || ce[_$_b839[2202]][se[_$_b839[2195]]] === se[_$_b839[2196]] ? le(oe, ce) : oe;
                };
              }, fe[_$_b839[37]][_$_b839[1198]] = function(le, se) {
                this[_$_b839[2199]][_$_b839[1045]](le, (0, ne[_$_b839[2180]])(se) ? this[_$_b839[2206]](se) : se), this[_$_b839[2200]](this[_$_b839[2199]]);
              }, fe[_$_b839[37]][_$_b839[2205]] = function(le) {
                return this[_$_b839[2199]][_$_b839[159]](le);
              }, fe[_$_b839[37]][_$_b839[2207]] = function(le) {
                this[_$_b839[2199]][_$_b839[797]](le), this[_$_b839[2200]](this[_$_b839[2199]]);
              }, fe[_$_b839[37]][_$_b839[2204]] = function(le) {
                return this[_$_b839[2199]][_$_b839[152]](le);
              }, fe[_$_b839[37]][_$_b839[340]] = function() {
                var le = this[_$_b839[2203]]();
                this[_$_b839[2197]][_$_b839[113]](function(se) {
                  return se();
                }), le && (0, ne[_$_b839[2181]])(le) && le[_$_b839[797]](this[_$_b839[2196]]), this[_$_b839[2194]][_$_b839[1198]](this[_$_b839[2195]], le), this[_$_b839[2197]] = [], this[_$_b839[2199]] = null, this[_$_b839[2194]] = null;
              }, fe;
            }();
            function _e(fe) {
              return fe;
            }
            te[_$_b839[1196]] = ue;
          }, 3464: function(re, te) {
            _$_b839[32];
            function ee(ae) {
              return function(ue, _e, fe) {
                fe === void 0 && (fe = function() {
                  return !0;
                });
                var le = ue(ae[_$_b839[136]]());
                return ae[_$_b839[789]](function() {
                  var se = ue(ae[_$_b839[136]]()), oe = le;
                  le = se, se != null && se !== oe && fe(se, oe) && _e(se, oe);
                });
              };
            }
            function ie(ae) {
              return function(ue, _e, fe) {
                fe === void 0 && (fe = function() {
                  return !0;
                });
                var le = ee(ae)(ue, function(se) {
                  le(), _e(se);
                }, fe);
                return le;
              };
            }
            function ne(ae) {
              return function(ue, _e) {
                return _e === void 0 && (_e = function() {
                  return !0;
                }), new Promise(function(fe) {
                  ie(ae)(ue, function(le) {
                    fe(le);
                  }, _e);
                });
              };
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[789]] = ee, te[_$_b839[2208]] = ie, te[_$_b839[2209]] = ne;
          }, 29073: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[711]] = se, te[_$_b839[2210]] = oe;
            var ie = ee(43485), ne = ee(56435), ae = ee(15231), ue = ee(11399), _e = ue[_$_b839[2212]][_$_b839[2211]], fe = ue[_$_b839[2212]][_$_b839[2213]], le = function() {
              var ce;
              return { isPlayStation5: ne[_$_b839[1471]](), isPlayStation4: ne[_$_b839[1473]](), isMobile: ne[_$_b839[1462]](), isTizen: ne[_$_b839[1466]](), isSafari: ne[_$_b839[2214]](), isIOS: ne[_$_b839[645]](), isSafariIOS: ne[_$_b839[2215]](), isEdge: ne[_$_b839[2216]](), isLegacyEdge: ne[_$_b839[2217]](), isChrome: ne[_$_b839[2218]](), isChromium: ne[_$_b839[2219]](), isFirefox: ne[_$_b839[1612]](), isFirefoxIOS: ne[_$_b839[2220]](), isWebOS: ne[_$_b839[1469]](), isVidaa: ne[_$_b839[1475]](), isVizio: ne[_$_b839[2221]](), isReactNative: ne[_$_b839[1691]](), MSESafari: ie[_$_b839[2222]](), isLocalStorageAvailable: ie[_$_b839[717]](), isInlinePlaybackRestricted: ie[_$_b839[1014]](), edgeVersion: ne[_$_b839[2223]](), IOSVersion: ne[_$_b839[2224]](), safariVersion: ne[_$_b839[2225]](), webOSChromiumVersion: (ce = ne[_$_b839[2227]]()[_$_b839[2226]]) !== null && ce !== void 0 ? ce : 0, techSupportedByModules: ie[_$_b839[2228]](), techSupportedByPlatform: ie[_$_b839[2229]](), techSupportedByModulesOnPlatform: ie[_$_b839[2230]]() };
            };
            function se() {
              return (0, ae[_$_b839[2176]])(_e, le());
            }
            function oe(ce, he) {
              return (0, ae[_$_b839[2176]])(fe, { key: ce, value: he });
            }
          }, 47722: function(re, te, ee) {
            _$_b839[32];
            var ie, ne = this && this[_$_b839[227]] || function() {
              return ne = Object[_$_b839[228]] || function(se) {
                for (var oe, ce = 1, he = arguments[_$_b839[26]]; ce < he; ce++)
                  for (var ge in oe = arguments[ce])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](oe, ge) && (se[ge] = oe[ge]);
                return se;
              }, ne[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2191]] = void 0;
            var ae = ee(21829), ue = ee(11399), _e = {};
            function fe(se) {
              return se;
            }
            function le(se, oe) {
              var ce, he = oe[_$_b839[686]], ge = oe[_$_b839[852]];
              return ne(ne({}, se), ((ce = {})[he] = ge, ce));
            }
            te[_$_b839[2191]] = (0, ae[_$_b839[107]])(_e, ((ie = {})[ue[_$_b839[2212]][_$_b839[2211]]] = function(se, oe) {
              return oe[_$_b839[1844]];
            }, ie[ue[_$_b839[2212]][_$_b839[2213]]] = function(se, oe) {
              return le(se, oe[_$_b839[1844]]);
            }, ie));
          }, 11399: function(re, te) {
            _$_b839[32];
            var ee, ie;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1013]] = te[_$_b839[2212]] = void 0, function(ne) {
              ne[_$_b839[2211]] = _$_b839[2231], ne[_$_b839[2213]] = _$_b839[2232];
            }(ee || (te[_$_b839[2212]] = ee = {})), function(ne) {
              ne[_$_b839[1471]] = _$_b839[1471], ne[_$_b839[1473]] = _$_b839[1473], ne[_$_b839[1462]] = _$_b839[1462], ne[_$_b839[1466]] = _$_b839[1466], ne[_$_b839[2214]] = _$_b839[2214], ne[_$_b839[2218]] = _$_b839[2218], ne[_$_b839[2219]] = _$_b839[2219], ne[_$_b839[1612]] = _$_b839[1612], ne[_$_b839[2220]] = _$_b839[2220], ne[_$_b839[1469]] = _$_b839[1469], ne[_$_b839[1475]] = _$_b839[1475], ne[_$_b839[2221]] = _$_b839[2221], ne[_$_b839[645]] = _$_b839[645], ne[_$_b839[2215]] = _$_b839[2215], ne[_$_b839[2216]] = _$_b839[2216], ne[_$_b839[2217]] = _$_b839[2217], ne[_$_b839[1691]] = _$_b839[1691], ne[_$_b839[2222]] = _$_b839[2222], ne[_$_b839[717]] = _$_b839[717], ne[_$_b839[1014]] = _$_b839[1014], ne[_$_b839[2233]] = _$_b839[2233], ne[_$_b839[2234]] = _$_b839[2234], ne[_$_b839[2235]] = _$_b839[2235], ne[_$_b839[2236]] = _$_b839[2236], ne[_$_b839[986]] = _$_b839[986], ne[_$_b839[983]] = _$_b839[983], ne[_$_b839[988]] = _$_b839[988];
            }(ie || (te[_$_b839[1013]] = ie = {}));
          }, 21829: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2237]] = void 0, function(ne) {
              ne[_$_b839[2238]] = _$_b839[107];
            }(ee || (te[_$_b839[2237]] = ee = {}));
            var ie = function(ne, ae) {
              return function(ue, _e) {
                return ue === void 0 && (ue = ne), ae[_e[_$_b839[65]]] ? ae[_e[_$_b839[65]]](ue, _e) : ae[ee[_$_b839[2238]]] ? ae[ee[_$_b839[2238]]](ue, _e) : ue;
              };
            };
            te[_$_b839[107]] = ie;
          }, 27517: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2239]] = ne;
            var ie = ee(27177);
            function ne(ae) {
              return (0, ie[_$_b839[1621]])(ae) && [_$_b839[732], _$_b839[1443]][_$_b839[267]](function(ue) {
                return ue in ae;
              });
            }
          }, 57782: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1191]] = ae, te[_$_b839[2240]] = ue;
            var ie = ee(15231), ne = ee(18068);
            function ae(_e, fe) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2242]][_$_b839[2241]], { mimeType: _e, preferredBitrate: fe });
            }
            function ue(_e) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2242]][_$_b839[2243]], { mimeType: _e });
            }
          }, 87649: function(re, te, ee) {
            _$_b839[32];
            var ie, ne = this && this[_$_b839[227]] || function() {
              return ne = Object[_$_b839[228]] || function(se) {
                for (var oe, ce = 1, he = arguments[_$_b839[26]]; ce < he; ce++)
                  for (var ge in oe = arguments[ce])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](oe, ge) && (se[ge] = oe[ge]);
                return se;
              }, ne[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2244]] = void 0;
            var ae = ee(21829), ue = ee(18068);
            function _e(se, oe, ce) {
              var he;
              return ne(ne({}, se), ((he = {})[oe] = ne(ne({}, se[oe]), { preferredBitrate: ce }), he));
            }
            function fe(se, oe) {
              var ce;
              return ne(ne({}, se), ((ce = {})[oe] = ne(ne({}, se[oe]), { preferredBitrate: void 0 }), ce));
            }
            var le = {};
            te[_$_b839[2244]] = (0, ae[_$_b839[107]])(le, ((ie = {})[ue[_$_b839[2242]][_$_b839[2241]]] = function(se, oe) {
              var ce = oe[_$_b839[1844]];
              return _e(se, ce[_$_b839[1953]], ce[_$_b839[2245]]);
            }, ie[ue[_$_b839[2242]][_$_b839[2243]]] = function(se, oe) {
              return fe(se, oe[_$_b839[1844]][_$_b839[1953]]);
            }, ie));
          }, 28463: function(re, te) {
            _$_b839[32];
            function ee(ne) {
              return ne[_$_b839[1156]];
            }
            function ie(ne, ae) {
              return ne[ae] ? ne[ae][_$_b839[2245]] : void 0;
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2246]] = ee, te[_$_b839[2247]] = ie;
          }, 18068: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2242]] = void 0, function(ie) {
              ie[_$_b839[2241]] = _$_b839[2248], ie[_$_b839[2243]] = _$_b839[2249];
            }(ee || (te[_$_b839[2242]] = ee = {}));
          }, 76650: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2250]] = ae, te[_$_b839[2251]] = ue, te[_$_b839[1598]] = _e, te[_$_b839[2252]] = fe, te[_$_b839[2253]] = le, te[_$_b839[2254]] = se;
            var ie = ee(15231), ne = ee(8272);
            function ae(oe, ce, he) {
              return he === void 0 && (he = oe), (0, ie[_$_b839[2176]])(ne[_$_b839[2256]][_$_b839[2255]], { mimeType: oe, settings: ce, saveUnderName: he });
            }
            function ue(oe) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2256]][_$_b839[2257]], { mimeType: oe });
            }
            function _e(oe, ce, he) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2256]][_$_b839[2258]], { mimeType: oe, metricType: ce, value: he });
            }
            function fe(oe, ce, he) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2256]][_$_b839[2259]], { mimeType: oe, metricType: ce, value: he });
            }
            function le(oe, ce) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2256]][_$_b839[2260]], { mimeType: oe, metricType: ce });
            }
            function se(oe, ce) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2256]][_$_b839[2261]], { mimeType: oe, threshold: ce });
            }
          }, 72819: function(re, te) {
            _$_b839[32];
            function ee(ie) {
              return function(ne, ae) {
                return ne[ae[_$_b839[1953]]] ? ie(ne, ae) : ne;
              };
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2262]] = ee;
          }, 88141: function(re, te, ee) {
            _$_b839[32];
            var ie, ne = this && this[_$_b839[227]] || function() {
              return ne = Object[_$_b839[228]] || function(ve) {
                for (var me, be = 1, pe = arguments[_$_b839[26]]; be < pe; be++)
                  for (var $e in me = arguments[be])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](me, $e) && (ve[$e] = me[$e]);
                return ve;
              }, ne[_$_b839[35]](this, arguments);
            }, ae = this && this[_$_b839[589]] || function(ve, me, be) {
              if (be || arguments[_$_b839[26]] === 2)
                for (var pe, $e = 0, ye = me[_$_b839[26]]; $e < ye; $e++)
                  !pe && $e in me || (pe || (pe = Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](me, 0, $e)), pe[$e] = me[$e]);
              return ve[_$_b839[41]](pe || Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](me));
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1444]] = void 0;
            var ue = ee(21829), _e = ee(72819), fe = ee(8272);
            function le(ve, me) {
              var be, pe = me[_$_b839[1953]], $e = me[_$_b839[809]], ye = me[_$_b839[2263]];
              return ne(ne({}, ve), ((be = {})[ye] = { mimeType: pe, settings: { metricHistorySize: $e[_$_b839[2264]] }, bufferLogicActivationThreshold: $e[_$_b839[2265]], data: {} }, be));
            }
            function se(ve, me) {
              var be = ne({}, ve);
              return delete be[me[_$_b839[1953]]], be;
            }
            function oe(ve, me) {
              var be, pe = me[_$_b839[1953]], $e = me[_$_b839[2266]];
              return ne(ne({}, ve), ((be = {})[pe] = ne(ne({}, ve[pe]), { bufferLogicActivationThreshold: $e }), be));
            }
            function ce(ve, me) {
              var be, pe, $e = me[_$_b839[1953]], ye = me[_$_b839[2267]], Se = me[_$_b839[852]], we = ve[$e][_$_b839[809]][_$_b839[2268]], Pe = ve[$e][_$_b839[1730]][ye] || [], Te = we > 0 && Pe[_$_b839[26]] >= we;
              return ne(ne({}, ve), ((be = {})[$e] = ne(ne({}, ve[$e]), { data: ne(ne({}, ve[$e][_$_b839[1730]]), (pe = {}, pe[ye] = ae(ae([], Te ? Pe[_$_b839[74]](1, Pe[_$_b839[26]]) : Pe, !0), [{ time: Date[_$_b839[840]](), value: Se }], !1), pe)) }), be));
            }
            function he(ve, me) {
              var be, pe, $e = me[_$_b839[1953]], ye = me[_$_b839[2267]];
              return ne(ne({}, ve), ((be = {})[$e] = ne(ne({}, ve[$e]), { data: ne(ne({}, ve[$e][_$_b839[1730]]), (pe = {}, pe[ye] = [], pe)) }), be));
            }
            function ge(ve, me) {
              var be, pe, $e = me[_$_b839[1953]], ye = me[_$_b839[2267]], Se = me[_$_b839[852]], we = (ve[$e][_$_b839[1730]][ye] || [])[_$_b839[112]](function(Pe) {
                return !(Pe[_$_b839[1918]] === Se[_$_b839[1918]] && Pe[_$_b839[852]] === Se[_$_b839[852]]);
              });
              return ne(ne({}, ve), ((be = {})[$e] = ne(ne({}, ve[$e]), { data: ne(ne({}, ve[$e][_$_b839[1730]]), (pe = {}, pe[ye] = we, pe)) }), be));
            }
            te[_$_b839[1444]] = (0, ue[_$_b839[107]])({}, ((ie = {})[fe[_$_b839[2256]][_$_b839[2255]]] = function(ve, me) {
              return le(ve, me[_$_b839[1844]]);
            }, ie[fe[_$_b839[2256]][_$_b839[2257]]] = function(ve, me) {
              return se(ve, me[_$_b839[1844]]);
            }, ie[fe[_$_b839[2256]][_$_b839[2261]]] = function(ve, me) {
              var be = me[_$_b839[1844]];
              return (0, _e[_$_b839[2262]])(oe)(ve, be);
            }, ie[fe[_$_b839[2256]][_$_b839[2258]]] = function(ve, me) {
              var be = me[_$_b839[1844]];
              return (0, _e[_$_b839[2262]])(ce)(ve, be);
            }, ie[fe[_$_b839[2256]][_$_b839[2260]]] = function(ve, me) {
              var be = me[_$_b839[1844]];
              return (0, _e[_$_b839[2262]])(he)(ve, be);
            }, ie[fe[_$_b839[2256]][_$_b839[2259]]] = function(ve, me) {
              var be = me[_$_b839[1844]];
              return (0, _e[_$_b839[2262]])(ge)(ve, be);
            }, ie));
          }, 28819: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2269]] = te[_$_b839[1595]] = void 0, te[_$_b839[2270]] = ie, te[_$_b839[2271]] = ne;
            var ee = function(ue) {
              return ue[_$_b839[1443]];
            };
            function ie(ue, _e, fe) {
              return ue[_e] && ue[_e][_$_b839[1730]][fe] || [];
            }
            function ne(ue, _e, fe) {
              var le = ie(ue, _e, fe);
              return le[_$_b839[26]] === 0 ? { time: void 0, value: void 0 } : le[le[_$_b839[26]] - 1];
            }
            te[_$_b839[1595]] = ee;
            var ae = function(ue, _e, fe) {
              return ie((0, te[_$_b839[1595]])(ue), _e, fe);
            };
            te[_$_b839[2269]] = ae;
          }, 8272: function(re, te) {
            _$_b839[32];
            var ee, ie;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2256]] = te[_$_b839[1597]] = void 0, function(ne) {
              ne[_$_b839[2272]] = _$_b839[2273], ne[_$_b839[2274]] = _$_b839[2275], ne[_$_b839[2276]] = _$_b839[2277], ne[_$_b839[2278]] = _$_b839[2279], ne[_$_b839[2280]] = _$_b839[2281], ne[_$_b839[2282]] = _$_b839[2283], ne[_$_b839[2284]] = _$_b839[2285], ne[_$_b839[2286]] = _$_b839[2287], ne[_$_b839[2288]] = _$_b839[2289], ne[_$_b839[2290]] = _$_b839[2291], ne[_$_b839[2292]] = _$_b839[2293], ne[_$_b839[1596]] = _$_b839[2294], ne[_$_b839[2295]] = _$_b839[2296], ne[_$_b839[2297]] = _$_b839[2298], ne[_$_b839[2299]] = _$_b839[2300];
            }(ee || (te[_$_b839[1597]] = ee = {})), function(ne) {
              ne[_$_b839[2255]] = _$_b839[2301], ne[_$_b839[2257]] = _$_b839[2302], ne[_$_b839[2258]] = _$_b839[2303], ne[_$_b839[2259]] = _$_b839[2304], ne[_$_b839[2260]] = _$_b839[2305], ne[_$_b839[2261]] = _$_b839[2306];
            }(ie || (te[_$_b839[2256]] = ie = {}));
          }, 17990: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2307]] = void 0, te[_$_b839[2308]] = _e, te[_$_b839[1490]] = fe, te[_$_b839[1515]] = le, te[_$_b839[1513]] = se, te[_$_b839[1519]] = oe, te[_$_b839[1539]] = ce, te[_$_b839[1541]] = he, te[_$_b839[1521]] = ge, te[_$_b839[1563]] = ve, te[_$_b839[1104]] = me, te[_$_b839[1495]] = be, te[_$_b839[1497]] = pe, te[_$_b839[1501]] = $e, te[_$_b839[2309]] = ye, te[_$_b839[2310]] = Se, te[_$_b839[2311]] = we, te[_$_b839[1503]] = Pe, te[_$_b839[2312]] = Te;
            var ie = ee(33696), ne = ee(15231), ae = ee(76420), ue = function() {
              return { playbackState: ae[_$_b839[1499]][_$_b839[1508]], seekState: ae[_$_b839[1510]][_$_b839[1508]], timeShiftState: ae[_$_b839[1517]][_$_b839[1508]], hasBeenPlaying: !1, isStalled: !1, isRendererStalled: !1, targetPlaybackTime: -1, playbackSpeed: { speed: 1, multiplier: 1 }, pendingTransitions: [], viewMode: ie[_$_b839[1018]][_$_b839[1017]], destroyState: ae[_$_b839[1103]][_$_b839[1508]], remoteControlState: { connectionState: ae[_$_b839[695]][_$_b839[694]], remoteControlType: ae[_$_b839[897]][_$_b839[1508]] }, seekingProcess: { targetTime: -1, isInitial: !1, issuer: _$_b839[90] } };
            };
            function _e(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2313]], Ee);
            }
            function fe(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2315]], Ee);
            }
            function le(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2316]], Ee);
            }
            function se(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2317]], Ee);
            }
            function oe(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2318]], Ee);
            }
            function ce(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2319]], Ee);
            }
            function he(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2320]], Ee);
            }
            function ge(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2321]], Ee);
            }
            function ve(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2322]], Ee);
            }
            function me(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2323]], Ee);
            }
            function be(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2324]], Ee);
            }
            function pe(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2325]], Ee);
            }
            function $e(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2326]], Ee);
            }
            function ye() {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2327]]);
            }
            function Se(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2328]], Ee);
            }
            function we(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2329]], Ee);
            }
            function Pe(Ee) {
              return Ee === void 0 && (Ee = []), (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2330]], { keepState: Ee });
            }
            function Te(Ee) {
              return (0, ne[_$_b839[2176]])(ae[_$_b839[2314]][_$_b839[2331]], Ee);
            }
            te[_$_b839[2307]] = ue;
          }, 61489: function(re, te, ee) {
            _$_b839[32];
            var ie, ne = this && this[_$_b839[227]] || function() {
              return ne = Object[_$_b839[228]] || function(oe) {
                for (var ce, he = 1, ge = arguments[_$_b839[26]]; he < ge; he++)
                  for (var ve in ce = arguments[he])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](ce, ve) && (oe[ve] = ce[ve]);
                return oe;
              }, ne[_$_b839[35]](this, arguments);
            }, ae = this && this[_$_b839[589]] || function(oe, ce, he) {
              if (he || arguments[_$_b839[26]] === 2)
                for (var ge, ve = 0, me = ce[_$_b839[26]]; ve < me; ve++)
                  !ge && ve in ce || (ge || (ge = Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](ce, 0, ve)), ge[ve] = ce[ve]);
              return oe[_$_b839[41]](ge || Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](ce));
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1442]] = void 0;
            var ue = ee(21829), _e = ee(17990), fe = ee(76420), le = (0, _e[_$_b839[2307]])();
            function se(oe, ce) {
              return ne(ne({}, oe), { isRendererStalled: ce[_$_b839[1844]] });
            }
            te[_$_b839[1442]] = (0, ue[_$_b839[107]])(le, ((ie = {})[fe[_$_b839[2314]][_$_b839[2317]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { playbackState: he });
            }, ie[fe[_$_b839[2314]][_$_b839[2316]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { seekState: he });
            }, ie[fe[_$_b839[2314]][_$_b839[2319]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { isStalled: he });
            }, ie[fe[_$_b839[2314]][_$_b839[2320]]] = se, ie[fe[_$_b839[2314]][_$_b839[2318]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { timeShiftState: he });
            }, ie[fe[_$_b839[2314]][_$_b839[2315]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { hasBeenPlaying: he });
            }, ie[fe[_$_b839[2314]][_$_b839[2321]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { targetPlaybackTime: he });
            }, ie[fe[_$_b839[2314]][_$_b839[2322]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { playbackSpeed: he });
            }, ie[fe[_$_b839[2314]][_$_b839[2313]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { viewMode: he });
            }, ie[fe[_$_b839[2314]][_$_b839[2324]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { pendingTransitions: ae(ae([], oe[_$_b839[1553]], !0), [he], !1) });
            }, ie[fe[_$_b839[2314]][_$_b839[2325]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { pendingTransitions: oe[_$_b839[1553]][_$_b839[112]](function(ge) {
                return ge !== he;
              }) });
            }, ie[fe[_$_b839[2314]][_$_b839[2326]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { pendingTransitions: oe[_$_b839[1553]][_$_b839[112]](function(ge, ve) {
                return ve !== he;
              }) });
            }, ie[fe[_$_b839[2314]][_$_b839[2327]]] = function(oe, ce) {
              return ne(ne({}, oe), { pendingTransitions: [] });
            }, ie[fe[_$_b839[2314]][_$_b839[2330]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]][_$_b839[2332]], ge = {};
              return he[_$_b839[113]](function(ve) {
                return ge[ve] = oe[ve];
              }), ne(ne({}, le), ge);
            }, ie[fe[_$_b839[2314]][_$_b839[2323]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { destroyState: he });
            }, ie[fe[_$_b839[2314]][_$_b839[2328]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { remoteControlState: ne(ne({}, oe[_$_b839[1502]]), { remoteControlType: he }) });
            }, ie[fe[_$_b839[2314]][_$_b839[2329]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { remoteControlState: ne(ne({}, oe[_$_b839[1502]]), { connectionState: he }) });
            }, ie[fe[_$_b839[2314]][_$_b839[2331]]] = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), { seekingProcess: ne(ne({}, oe[_$_b839[2333]]), he) });
            }, ie));
          }, 58975: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[790]] = te[_$_b839[1545]] = te[_$_b839[733]] = te[_$_b839[730]] = te[_$_b839[1567]] = te[_$_b839[1565]] = te[_$_b839[1099]] = te[_$_b839[2334]] = te[_$_b839[2335]] = te[_$_b839[1538]] = te[_$_b839[2336]] = te[_$_b839[1528]] = te[_$_b839[2337]] = te[_$_b839[1569]] = te[_$_b839[788]] = te[_$_b839[1549]] = te[_$_b839[1548]] = te[_$_b839[1546]] = te[_$_b839[1536]] = te[_$_b839[787]] = void 0;
            var ie = ee(76420), ne = function(Te) {
              return Te[_$_b839[732]];
            };
            te[_$_b839[787]] = ne;
            var ae = function(Te) {
              return Te[_$_b839[1494]] === ie[_$_b839[1499]][_$_b839[1508]];
            };
            te[_$_b839[1536]] = ae;
            var ue = function(Te) {
              return Te[_$_b839[1494]] === ie[_$_b839[1499]][_$_b839[387]];
            };
            te[_$_b839[1546]] = ue;
            var _e = function(Te) {
              return Te[_$_b839[1494]] === ie[_$_b839[1499]][_$_b839[385]];
            };
            te[_$_b839[1548]] = _e;
            var fe = function(Te) {
              return Te[_$_b839[1494]] === ie[_$_b839[1499]][_$_b839[389]];
            };
            te[_$_b839[1549]] = fe;
            var le = function(Te) {
              return Te[_$_b839[1494]] === ie[_$_b839[1499]][_$_b839[1534]];
            };
            te[_$_b839[788]] = le;
            var se = function(Te) {
              return !Te[_$_b839[1570]] && Te[_$_b839[872]];
            };
            te[_$_b839[1569]] = se;
            var oe = function(Te) {
              return Te[_$_b839[1509]] === ie[_$_b839[1510]][_$_b839[1508]];
            };
            te[_$_b839[2337]] = oe;
            var ce = function(Te) {
              return [ie[_$_b839[1510]][_$_b839[1523]], ie[_$_b839[1510]][_$_b839[1525]]][_$_b839[815]](Te[_$_b839[1509]]);
            };
            te[_$_b839[1528]] = ce;
            var he = function(Te) {
              return Te[_$_b839[1509]] === ie[_$_b839[1510]][_$_b839[393]];
            };
            te[_$_b839[2336]] = he;
            var ge = function(Te) {
              return Te[_$_b839[1516]] === ie[_$_b839[1517]][_$_b839[1530]];
            };
            te[_$_b839[1538]] = ge;
            var ve = function(Te) {
              return Te[_$_b839[1516]] === ie[_$_b839[1517]][_$_b839[1532]];
            };
            te[_$_b839[2335]] = ve;
            var me = function(Te) {
              return Te[_$_b839[1560]];
            };
            te[_$_b839[2334]] = me;
            var be = function(Te) {
              return Te[_$_b839[914]];
            };
            te[_$_b839[1099]] = be;
            var pe = function(Te) {
              return (0, te[_$_b839[1528]])(Te) || (0, te[_$_b839[1538]])(Te);
            };
            te[_$_b839[1565]] = pe;
            var $e = function(Te) {
              return (0, te[_$_b839[2336]])(Te) || (0, te[_$_b839[2335]])(Te);
            };
            te[_$_b839[1567]] = $e;
            var ye = function(Te) {
              return Te[_$_b839[2338]] !== ie[_$_b839[1103]][_$_b839[1508]];
            };
            te[_$_b839[730]] = ye;
            var Se = function(Te) {
              return Te[_$_b839[2338]] === ie[_$_b839[1103]][_$_b839[1107]];
            };
            te[_$_b839[733]] = Se;
            var we = function(Te) {
              return Te[_$_b839[2339]];
            };
            te[_$_b839[1545]] = we;
            var Pe = function(Te) {
              return Te[_$_b839[1502]];
            };
            te[_$_b839[790]] = Pe;
          }, 76420: function(re, te) {
            _$_b839[32];
            var ee, ie, ne, ae, ue, _e, fe;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2314]] = te[_$_b839[1103]] = te[_$_b839[1517]] = te[_$_b839[1510]] = te[_$_b839[1499]] = te[_$_b839[695]] = te[_$_b839[897]] = void 0, function(le) {
              le[le[_$_b839[1508]] = 0] = _$_b839[1508], le[le[_$_b839[2340]] = 1] = _$_b839[2340], le[le[_$_b839[2341]] = 2] = _$_b839[2341], le[le[_$_b839[896]] = 3] = _$_b839[896];
            }(ee || (te[_$_b839[897]] = ee = {})), function(le) {
              le[le[_$_b839[2342]] = 0] = _$_b839[2342], le[le[_$_b839[2343]] = 1] = _$_b839[2343], le[le[_$_b839[2344]] = 2] = _$_b839[2344], le[le[_$_b839[694]] = 3] = _$_b839[694];
            }(ie || (te[_$_b839[695]] = ie = {})), function(le) {
              le[le[_$_b839[1508]] = 0] = _$_b839[1508], le[le[_$_b839[1534]] = 1] = _$_b839[1534], le[le[_$_b839[385]] = 2] = _$_b839[385], le[le[_$_b839[387]] = 3] = _$_b839[387], le[le[_$_b839[389]] = 4] = _$_b839[389];
            }(ne || (te[_$_b839[1499]] = ne = {})), function(le) {
              le[le[_$_b839[1508]] = 0] = _$_b839[1508], le[le[_$_b839[1523]] = 1] = _$_b839[1523], le[le[_$_b839[1525]] = 2] = _$_b839[1525], le[le[_$_b839[393]] = 3] = _$_b839[393];
            }(ae || (te[_$_b839[1510]] = ae = {})), function(le) {
              le[le[_$_b839[1508]] = 0] = _$_b839[1508], le[le[_$_b839[1530]] = 1] = _$_b839[1530], le[le[_$_b839[1532]] = 2] = _$_b839[1532];
            }(ue || (te[_$_b839[1517]] = ue = {})), function(le) {
              le[_$_b839[1508]] = _$_b839[654], le[_$_b839[1102]] = _$_b839[2345], le[_$_b839[1107]] = _$_b839[2346];
            }(_e || (te[_$_b839[1103]] = _e = {})), function(le) {
              le[_$_b839[2316]] = _$_b839[2347], le[_$_b839[2317]] = _$_b839[2348], le[_$_b839[2318]] = _$_b839[2349], le[_$_b839[2319]] = _$_b839[2350], le[_$_b839[2320]] = _$_b839[2351], le[_$_b839[2315]] = _$_b839[2352], le[_$_b839[2321]] = _$_b839[2353], le[_$_b839[2322]] = _$_b839[2354], le[_$_b839[2313]] = _$_b839[2355], le[_$_b839[2323]] = _$_b839[2356], le[_$_b839[2324]] = _$_b839[2357], le[_$_b839[2325]] = _$_b839[2358], le[_$_b839[2326]] = _$_b839[2359], le[_$_b839[2327]] = _$_b839[2360], le[_$_b839[2330]] = _$_b839[2361], le[_$_b839[2328]] = _$_b839[2362], le[_$_b839[2329]] = _$_b839[2363], le[_$_b839[2331]] = _$_b839[2364];
            }(fe || (te[_$_b839[2314]] = fe = {}));
          }, 63668: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2365]] = void 0, te[_$_b839[2366]] = ue, te[_$_b839[2367]] = _e, te[_$_b839[2368]] = fe, te[_$_b839[2369]] = le, te[_$_b839[2370]] = se, te[_$_b839[2371]] = oe;
            var ie = ee(15231), ne = ee(10950), ae = function() {
              return { keyIdsWithErrors: [], usedKeySystem: { kind: null, uid: null } };
            };
            function ue(ce) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2373]][_$_b839[2372]], ce);
            }
            function _e() {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2373]][_$_b839[2374]]);
            }
            function fe(ce) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2373]][_$_b839[2375]], ce);
            }
            function le() {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2373]][_$_b839[2376]]);
            }
            function se(ce) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2373]][_$_b839[2377]], ce);
            }
            function oe() {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2373]][_$_b839[2378]]);
            }
            te[_$_b839[2365]] = ae;
          }, 32739: function(re, te, ee) {
            _$_b839[32];
            var ie, ne = this && this[_$_b839[227]] || function() {
              return ne = Object[_$_b839[228]] || function(me) {
                for (var be, pe = 1, $e = arguments[_$_b839[26]]; pe < $e; pe++)
                  for (var ye in be = arguments[pe])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](be, ye) && (me[ye] = be[ye]);
                return me;
              }, ne[_$_b839[35]](this, arguments);
            }, ae = this && this[_$_b839[589]] || function(me, be, pe) {
              if (pe || arguments[_$_b839[26]] === 2)
                for (var $e, ye = 0, Se = be[_$_b839[26]]; ye < Se; ye++)
                  !$e && ye in be || ($e || ($e = Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](be, 0, ye)), $e[ye] = be[ye]);
              return me[_$_b839[41]]($e || Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](be));
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2379]] = void 0;
            var ue = ee(21829), _e = ee(63668), fe = ee(10950), le = (0, _e[_$_b839[2365]])();
            function se(me, be) {
              var pe = be[_$_b839[1844]];
              return ne(ne({}, me), pe);
            }
            function oe() {
              return le;
            }
            function ce(me, be) {
              var pe = be[_$_b839[1844]];
              return me[_$_b839[2380]][_$_b839[815]](pe) ? me : ne(ne({}, me), { keyIdsWithErrors: ae(ae([], me[_$_b839[2380]], !0), [pe], !1) });
            }
            function he(me) {
              return me[_$_b839[2380]][_$_b839[26]] > 0 ? ne(ne({}, me), { keyIdsWithErrors: [] }) : me;
            }
            function ge(me, be) {
              var pe = be[_$_b839[1844]];
              return ne(ne({}, me), { usedKeySystem: pe });
            }
            function ve(me, be) {
              return ne(ne({}, me), { usedKeySystem: { kind: null, uid: null } });
            }
            te[_$_b839[2379]] = (0, ue[_$_b839[107]])(le, ((ie = {})[fe[_$_b839[2373]][_$_b839[2372]]] = se, ie[fe[_$_b839[2373]][_$_b839[2374]]] = oe, ie[fe[_$_b839[2373]][_$_b839[2375]]] = ce, ie[fe[_$_b839[2373]][_$_b839[2376]]] = he, ie[fe[_$_b839[2373]][_$_b839[2377]]] = ge, ie[fe[_$_b839[2373]][_$_b839[2378]]] = ve, ie));
          }, 10950: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2373]] = void 0, function(ie) {
              ie[_$_b839[2372]] = _$_b839[2381], ie[_$_b839[2374]] = _$_b839[2382], ie[_$_b839[2375]] = _$_b839[2383], ie[_$_b839[2376]] = _$_b839[2384], ie[_$_b839[2377]] = _$_b839[2385], ie[_$_b839[2378]] = _$_b839[2386];
            }(ee || (te[_$_b839[2373]] = ee = {}));
          }, 14073: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1197]] = void 0;
            var ie = ee(87649), ne = ee(32739), ae = ee(26569), ue = ee(42055);
            te[_$_b839[1197]] = { startOptions: ue[_$_b839[2387]], drm: ne[_$_b839[2379]], adaptation: ie[_$_b839[2244]], playback: ae[_$_b839[2388]] };
          }, 27279: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1052]] = ae, te[_$_b839[1909]] = ue;
            var ie = ee(18665), ne = ee(27177);
            function ae(_e) {
              var fe, le;
              return (0, ne[_$_b839[1594]])(_e) ? (fe = _e[_$_b839[635]]) === null || fe === void 0 ? void 0 : fe[_$_b839[159]](ie[_$_b839[637]][_$_b839[795]], (le = _e[_$_b839[631]]) === null || le === void 0 ? void 0 : le[_$_b839[796]]) : void 0;
            }
            function ue(_e) {
              var fe = ae(_e);
              return fe == null ? void 0 : fe[_$_b839[136]]();
            }
          }, 96873: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2389]] = ae, te[_$_b839[2390]] = ue, te[_$_b839[2391]] = _e, te[_$_b839[2392]] = fe, te[_$_b839[2393]] = le, te[_$_b839[2394]] = se, te[_$_b839[1067]] = oe, te[_$_b839[2395]] = ce;
            var ie = ee(15231), ne = ee(18434);
            function ae(he, ge) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2397]][_$_b839[2396]], { mimeType: he, maxBufferSize: ge });
            }
            function ue(he, ge) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2397]][_$_b839[2398]], { mimeType: he, ranges: ge });
            }
            function _e(he) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2397]][_$_b839[2399]], { isOngoing: he });
            }
            function fe(he) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2397]][_$_b839[2400]], { isRollingOver: he });
            }
            function le(he, ge) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2397]][_$_b839[2401]], { mimeType: he, range: ge });
            }
            function se(he, ge) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2397]][_$_b839[2402]], { mimeType: he, range: ge });
            }
            function oe(he) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2397]][_$_b839[2403]], { mimeType: he });
            }
            function ce(he) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2397]][_$_b839[2404]], { isFinished: he });
            }
          }, 33669: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2405]] = te[_$_b839[2406]] = te[_$_b839[2407]] = te[_$_b839[2408]] = te[_$_b839[2409]] = te[_$_b839[2410]] = te[_$_b839[2411]] = te[_$_b839[1910]] = te[_$_b839[2412]] = te[_$_b839[2413]] = void 0, te[_$_b839[2414]] = ve, te[_$_b839[1912]] = pe, te[_$_b839[2415]] = $e;
            var ie = ee(92712), ne = ee(79814);
            function ae(Pe, Te) {
              return ue(Pe)[_$_b839[112]](function(Ee) {
                return Ee[_$_b839[2416]] === Te;
              });
            }
            function ue(Pe) {
              var Te;
              return (Te = Pe[_$_b839[2417]]) !== null && Te !== void 0 ? Te : [];
            }
            te[_$_b839[2413]] = 0;
            var _e = function(Pe) {
              var Te;
              return (Te = Pe == null ? void 0 : Pe[_$_b839[1142]]) === null || Te === void 0 ? void 0 : Te[_$_b839[1911]];
            };
            te[_$_b839[2412]] = _e;
            var fe = function(Pe) {
              return Pe == null ? void 0 : Pe[_$_b839[1142]];
            };
            te[_$_b839[1910]] = fe;
            var le = function(Pe, Te) {
              var Ee;
              return Te in Pe && (Ee = Pe[Te][_$_b839[2418]]) !== null && Ee !== void 0 ? Ee : [];
            };
            te[_$_b839[2411]] = le;
            var se = function(Pe) {
              return function(Te, Ee) {
                var Me = (0, te[_$_b839[1910]])(Te), Ae = (0, te[_$_b839[1910]])(Ee);
                return (Me ? (0, te[_$_b839[2408]])(Me, Pe) : te[_$_b839[2413]]) !== (Ae ? (0, te[_$_b839[2408]])(Ae, Pe) : te[_$_b839[2413]]);
              };
            };
            te[_$_b839[2410]] = se;
            var oe = function(Pe, Te) {
              var Ee = Pe[_$_b839[1911]], Me = Te[_$_b839[1911]], Ae = Object[_$_b839[98]](Ee), Ne = Object[_$_b839[98]](Me);
              if (Ae[_$_b839[26]] !== Ne[_$_b839[26]] || Ae[_$_b839[862]](function(Ue) {
                return !Ne[_$_b839[815]](Ue);
              }))
                return !0;
              for (var Ce = 0, Ie = Ae; Ce < Ie[_$_b839[26]]; Ce++) {
                var xe = Ie[Ce];
                if (ce((0, te[_$_b839[2411]])(Ee, xe), (0, te[_$_b839[2411]])(Me, xe)) || ce(ue(Ee[xe]), ue(Me[xe])))
                  return !0;
              }
              return !1;
            };
            function ce(Pe, Te) {
              return Pe !== Te && (Pe[_$_b839[26]] !== 0 || Te[_$_b839[26]] !== 0) && Pe !== Te;
            }
            te[_$_b839[2409]] = oe;
            var he = function(Pe, Te) {
              var Ee;
              return Te in Pe[_$_b839[1911]] && (Ee = Pe[_$_b839[1911]][Te][_$_b839[2419]]) !== null && Ee !== void 0 ? Ee : te[_$_b839[2413]];
            };
            te[_$_b839[2408]] = he;
            var ge = function(Pe, Te) {
              return Pe ? Object[_$_b839[98]](Pe[_$_b839[1911]])[_$_b839[135]](function(Ee, Me) {
                return Ee[Me] = ae(Pe[_$_b839[1911]][Me], Te), Ee;
              }, {}) : {};
            };
            function ve(Pe, Te) {
              var Ee, Me;
              return (Me = (Ee = Pe[_$_b839[1911]][Te]) === null || Ee === void 0 ? void 0 : Ee[_$_b839[2417]]) !== null && Me !== void 0 ? Me : [];
            }
            te[_$_b839[2407]] = ge;
            var me = function(Pe, Te, Ee) {
              return Te === void 0 ? {} : Se(Te, Pe, Ee);
            };
            te[_$_b839[2406]] = me;
            var be = function(Pe, Te) {
              return function(Ee, Me) {
                var Ae = Pe[_$_b839[2420]](Me);
                if (Ee === void 0 || Te === void 0 || Ae === void 0)
                  return {};
                var Ne = Pe[_$_b839[2422]](Ee)[_$_b839[137]](function(Ce) {
                  return Ce[_$_b839[1953]];
                })[_$_b839[112]](function(Ce) {
                  return ne[_$_b839[300]][_$_b839[2421]](Ce);
                });
                return ye(Te, Ne);
              };
            };
            function pe(Pe) {
              if (!Pe)
                return -1;
              var Te = Object[_$_b839[98]](Pe)[_$_b839[137]](function(Ee) {
                var Me, Ae;
                return (Ae = (Me = Pe[Ee][_$_b839[2418]]) === null || Me === void 0 ? void 0 : Me[0]) === null || Ae === void 0 ? void 0 : Ae[_$_b839[240]];
              })[_$_b839[112]](function(Ee) {
                return Ee !== void 0;
              });
              return Te[_$_b839[26]] > 0 ? Math[_$_b839[248]][_$_b839[35]](Math, Te) : -1;
            }
            function $e(Pe) {
              return Pe[_$_b839[1142]][_$_b839[2423]];
            }
            te[_$_b839[2405]] = be;
            var ye = function(Pe, Te) {
              var Ee = {};
              return Te[_$_b839[113]](function(Me) {
                return Ee[Me] = (0, te[_$_b839[2411]])(Pe[_$_b839[1911]], Me);
              }), Ee;
            };
            function Se(Pe, Te, Ee) {
              var Me = Object[_$_b839[98]](Pe[_$_b839[1911]]), Ae = Te[_$_b839[2424]](Pe, Me), Ne = ye(Pe, Me);
              return Object[_$_b839[98]](Ne)[_$_b839[113]](function(Ce) {
                return Ae[Ce][_$_b839[57]](Ne[Ce]);
              }), we(Me, Ae, Ee);
            }
            function we(Pe, Te, Ee) {
              var Me = {};
              return Pe[_$_b839[113]](function(Ae) {
                return Me[Ae] = ie[_$_b839[229]][_$_b839[250]](Te[Ae][_$_b839[2425]](function(Ne) {
                  return Ne;
                }), Ee);
              }), Me;
            }
          }, 84342: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2426]] = _e;
            var ie = ee(3464), ne = ee(33669);
            function ae(fe) {
              return function(le) {
                var se = (0, ne[_$_b839[2412]])(le);
                return se ? (0, ne[_$_b839[2411]])(se, fe) : [];
              };
            }
            function ue(fe) {
              var le = fe[_$_b839[136]](), se = (0, ne[_$_b839[2412]])(le);
              return se !== void 0 ? Object[_$_b839[98]](se) : [];
            }
            function _e(fe, le) {
              var se = ue(fe)[_$_b839[137]](function(oe) {
                return (0, ie[_$_b839[789]])(fe)(ae(oe), function(ce) {
                  return le(oe, ce ?? []);
                });
              });
              return function() {
                return se[_$_b839[113]](function(oe) {
                  return oe();
                });
              };
            }
          }, 18434: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2397]] = void 0, function(ie) {
              ie[_$_b839[2396]] = _$_b839[2427], ie[_$_b839[2398]] = _$_b839[2428], ie[_$_b839[2399]] = _$_b839[2429], ie[_$_b839[2400]] = _$_b839[2430], ie[_$_b839[2401]] = _$_b839[2431], ie[_$_b839[2402]] = _$_b839[2432], ie[_$_b839[2403]] = _$_b839[2433], ie[_$_b839[2404]] = _$_b839[2434];
            }(ee || (te[_$_b839[2397]] = ee = {}));
          }, 25614: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2435]] = te[_$_b839[2436]] = void 0;
            var ie = ee(15231), ne = ee(5772), ae = function(_e) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2438]][_$_b839[2437]], _e);
            };
            te[_$_b839[2436]] = ae;
            var ue = function(_e) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2438]][_$_b839[2439]], _e);
            };
            te[_$_b839[2435]] = ue;
          }, 26569: function(re, te, ee) {
            _$_b839[32];
            var ie, ne = this && this[_$_b839[227]] || function() {
              return ne = Object[_$_b839[228]] || function(le) {
                for (var se, oe = 1, ce = arguments[_$_b839[26]]; oe < ce; oe++)
                  for (var he in se = arguments[oe])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](se, he) && (le[he] = se[he]);
                return le;
              }, ne[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2388]] = void 0;
            var ae = ee(21829), ue = ee(5772);
            function _e(le, se) {
              return ne(ne({}, le), se);
            }
            function fe(le, se) {
              return ne({}, se);
            }
            te[_$_b839[2388]] = (0, ae[_$_b839[107]])({ kind: ue[_$_b839[2441]][_$_b839[2440]] }, ((ie = {})[ue[_$_b839[2438]][_$_b839[2437]]] = function(le, se) {
              return fe(le, se[_$_b839[1844]]);
            }, ie[ue[_$_b839[2438]][_$_b839[2439]]] = function(le, se) {
              return _e(le, se[_$_b839[1844]]);
            }, ie));
          }, 3872: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2442]] = void 0;
            var ie = ee(5772), ne = function(ae) {
              return ae[_$_b839[966]] === ie[_$_b839[2441]][_$_b839[2443]] ? ae[_$_b839[1949]] : NaN;
            };
            te[_$_b839[2442]] = ne;
          }, 5772: function(re, te) {
            _$_b839[32];
            var ee, ie;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2438]] = te[_$_b839[2441]] = void 0, function(ne) {
              ne[_$_b839[2440]] = _$_b839[2444], ne[_$_b839[2443]] = _$_b839[2445];
            }(ee || (te[_$_b839[2441]] = ee = {})), function(ne) {
              ne[_$_b839[2437]] = _$_b839[2446], ne[_$_b839[2439]] = _$_b839[2447];
            }(ie || (te[_$_b839[2438]] = ie = {}));
          }, 60627: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1053]] = ae;
            var ie = ee(15231), ne = ee(73448);
            function ae(ue) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2449]][_$_b839[2448]], { url: ue });
            }
          }, 73448: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2449]] = void 0, function(ie) {
              ie[_$_b839[2448]] = _$_b839[2450];
            }(ee || (te[_$_b839[2449]] = ee = {}));
          }, 95328: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2451]] = void 0, te[_$_b839[1076]] = ae, te[_$_b839[2452]] = ue;
            var ie = ee(15231), ne = ee(80618);
            function ae() {
              return ue(te[_$_b839[2451]][_$_b839[2453]]);
            }
            function ue(_e) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2455]][_$_b839[2454]], { startTimeOffset: _e });
            }
            te[_$_b839[2451]] = { startTimeOffset: 0 };
          }, 42055: function(re, te, ee) {
            _$_b839[32];
            var ie, ne = this && this[_$_b839[227]] || function() {
              return ne = Object[_$_b839[228]] || function(oe) {
                for (var ce, he = 1, ge = arguments[_$_b839[26]]; he < ge; he++)
                  for (var ve in ce = arguments[he])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](ce, ve) && (oe[ve] = ce[ve]);
                return oe;
              }, ne[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2387]] = void 0, te[_$_b839[2456]] = se;
            var ae = ee(21829), ue = ee(95328), _e = ee(80618), fe = ue[_$_b839[2451]], le = function(oe, ce) {
              var he = ce[_$_b839[1844]];
              return ne(ne({}, oe), he);
            };
            function se(oe) {
              return oe[_$_b839[2457]][_$_b839[2453]];
            }
            te[_$_b839[2387]] = (0, ae[_$_b839[107]])(fe, ((ie = {})[_e[_$_b839[2455]][_$_b839[2458]]] = le, ie[_e[_$_b839[2455]][_$_b839[2454]]] = le, ie));
          }, 80618: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2455]] = void 0, function(ie) {
              ie[_$_b839[2458]] = _$_b839[2459], ie[_$_b839[2454]] = _$_b839[2460];
            }(ee || (te[_$_b839[2455]] = ee = {}));
          }, 13679: function(re, te) {
            _$_b839[32];
            function ee(ue) {
              Object[_$_b839[2461]](ue);
              var _e = _$_b839[34] == typeof ue, fe = Object[_$_b839[37]][_$_b839[215]];
              return Object[_$_b839[42]](ue)[_$_b839[113]](function(le) {
                !fe[_$_b839[36]](ue, le) || _e && (_$_b839[2462] === le || _$_b839[2463] === le || _$_b839[2464] === le) || ue[le] === null || _$_b839[33] != typeof ue[le] && _$_b839[34] != typeof ue[le] || Object[_$_b839[2465]](ue[le]) || ee(ue[le]);
              }), ue;
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2461]] = void 0, te[_$_b839[2466]] = ee;
            var ie = function(ue) {
              return ue !== null && _$_b839[33] == typeof ue;
            }, ne = function(ue) {
              var _e = ue[_$_b839[136]]();
              ie(_e) && ee(_e);
            }, ae = function(ue) {
              return ne(ue), function(_e) {
                return function(fe) {
                  ne(ue);
                  try {
                    return _e(fe);
                  } finally {
                    ne(ue);
                  }
                };
              };
            };
            te[_$_b839[2461]] = ae;
          }, 37233: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2037]] = ae;
            var ie = ee(15231), ne = ee(79463);
            function ae(ue) {
              return (0, ie[_$_b839[2176]])(ne[_$_b839[2468]][_$_b839[2467]], ue);
            }
          }, 39210: function(re, te, ee) {
            _$_b839[32];
            var ie, ne = this && this[_$_b839[227]] || function() {
              return ne = Object[_$_b839[228]] || function(se) {
                for (var oe, ce = 1, he = arguments[_$_b839[26]]; ce < he; ce++)
                  for (var ge in oe = arguments[ce])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](oe, ge) && (se[ge] = oe[ge]);
                return se;
              }, ne[_$_b839[35]](this, arguments);
            }, ae = this && this[_$_b839[589]] || function(se, oe, ce) {
              if (ce || arguments[_$_b839[26]] === 2)
                for (var he, ge = 0, ve = oe[_$_b839[26]]; ge < ve; ge++)
                  !he && ge in oe || (he || (he = Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](oe, 0, ge)), he[ge] = oe[ge]);
              return se[_$_b839[41]](he || Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](oe));
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2189]] = void 0;
            var ue = ee(21829), _e = ee(79463), fe = { domains: [] };
            function le(se, oe) {
              return ne(ne({}, se), { domains: se[_$_b839[353]][_$_b839[815]](oe) ? se[_$_b839[353]] : ae(ae([], se[_$_b839[353]], !0), [oe], !1) });
            }
            te[_$_b839[2189]] = (0, ue[_$_b839[107]])(fe, ((ie = {})[_e[_$_b839[2468]][_$_b839[2467]]] = function(se, oe) {
              return le(se, oe[_$_b839[1844]]);
            }, ie));
          }, 79463: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2468]] = void 0, function(ie) {
              ie[_$_b839[2467]] = _$_b839[2469];
            }(ee || (te[_$_b839[2468]] = ee = {}));
          }, 81361: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[589]] || function(me, be, pe) {
              if (pe || arguments[_$_b839[26]] === 2)
                for (var $e, ye = 0, Se = be[_$_b839[26]]; ye < Se; ye++)
                  !$e && ye in be || ($e || ($e = Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](be, 0, ye)), $e[ye] = be[ye]);
              return me[_$_b839[41]]($e || Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](be));
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2470]] = void 0, te[_$_b839[2471]] = ue, te[_$_b839[2472]] = _e, te[_$_b839[2473]] = fe, te[_$_b839[2474]] = le, te[_$_b839[2475]] = se, te[_$_b839[2476]] = oe, te[_$_b839[2477]] = ce, te[_$_b839[2478]] = he, te[_$_b839[2479]] = ge, te[_$_b839[2480]] = ve;
            var ne = ee(56093), ae = function() {
              function me() {
              }
              return me[_$_b839[2481]] = function(be, pe) {
                if (be[_$_b839[26]] !== pe[_$_b839[26]])
                  return !1;
                for (var $e = 0; $e < be[_$_b839[26]]; $e++)
                  if (be[$e] !== pe[$e])
                    return !1;
                return !0;
              }, me[_$_b839[2482]] = function(be) {
                for (var pe = new Uint8Array(be[_$_b839[26]]), $e = 0; $e < be[_$_b839[26]]; $e++)
                  pe[$e] = be[_$_b839[2483]]($e);
                return pe;
              }, me[_$_b839[2484]] = function(be, pe) {
                return pe === void 0 && (pe = _$_b839[2485]), be instanceof ArrayBuffer ? be = new Uint8Array(be) : be instanceof DataView && (be = new Uint8Array(be[_$_b839[1142]], be[_$_b839[2486]], be[_$_b839[2109]])), me[_$_b839[2487]](be, pe);
              }, me[_$_b839[2487]] = function(be, pe) {
                if (_$_b839[0] != typeof TextDecoder)
                  return new TextDecoder(pe)[_$_b839[2488]](be);
                for (var $e = 0, ye = _$_b839[90]; $e < be[_$_b839[26]]; ) {
                  var Se = be[$e++];
                  if (Se > 127)
                    if (Se > 191 && Se < 224) {
                      if ($e >= be[_$_b839[26]] || 64 & be[$e]) {
                        ye += _$_b839[2489];
                        continue;
                      }
                      Se = (31 & Se) << 6 | 63 & be[$e++];
                    } else if (Se > 223 && Se < 240) {
                      if ($e + 1 >= be[_$_b839[26]] || 64 & be[$e] || 64 & be[$e + 1]) {
                        ye += _$_b839[2489];
                        continue;
                      }
                      Se = (15 & Se) << 12 | (63 & be[$e++]) << 6 | 63 & be[$e++];
                    } else {
                      if (!(Se > 239 && Se < 248)) {
                        ye += _$_b839[2489];
                        continue;
                      }
                      if ($e + 2 >= be[_$_b839[26]] || 64 & be[$e] || 64 & be[$e + 1] || 64 & be[$e + 2]) {
                        ye += _$_b839[2489];
                        continue;
                      }
                      Se = (7 & Se) << 18 | (63 & be[$e++]) << 12 | (63 & be[$e++]) << 6 | 63 & be[$e++];
                    }
                  Se <= 65535 ? ye += String[_$_b839[2490]](Se) : Se <= 1114111 ? (Se -= 65536, ye += String[_$_b839[2490]](Se >> 10 | 55296), ye += String[_$_b839[2490]](1023 & Se | 56320)) : ye += _$_b839[2489];
                }
                return ye;
              }, me[_$_b839[251]] = function(be, pe, $e) {
                if (_$_b839[109] == typeof pe && _$_b839[2491] === Object[_$_b839[37]][_$_b839[125]][_$_b839[36]](be)) {
                  var ye;
                  if ($e || ($e = _$_b839[2492]), _$_b839[2492] === $e)
                    ye = -1;
                  else {
                    if (_$_b839[2493] !== $e)
                      return;
                    ye = 1;
                  }
                  if (be[_$_b839[26]] < 2)
                    return be;
                  var Se = function(we, Pe) {
                    return we[pe] < Pe[pe] ? ye : we[pe] > Pe[pe] ? -1 * ye : 0;
                  };
                  return be[_$_b839[251]](Se);
                }
              }, me[_$_b839[18]] = function(be, pe) {
                var $e = me[_$_b839[2494]](be), ye = me[_$_b839[2494]](pe);
                if (!$e && !ye || $e !== ye)
                  return null;
                var Se = new $e((be[_$_b839[2109]] + pe[_$_b839[2109]]) / $e[_$_b839[2495]]);
                return Se[_$_b839[1045]](new $e(be), 0), Se[_$_b839[1045]](new $e(pe), be[_$_b839[2109]] / $e[_$_b839[2495]]), Se;
              }, me[_$_b839[2496]] = function() {
                for (var be = [], pe = 0; pe < arguments[_$_b839[26]]; pe++)
                  be[pe] = arguments[pe];
                if (!(be = be[_$_b839[112]](function(Se) {
                  return Se;
                }))[_$_b839[26]])
                  return null;
                var $e = be[_$_b839[135]](function(Se, we) {
                  return Se + we[_$_b839[2109]];
                }, 0), ye = new Uint8Array($e);
                return be[_$_b839[135]](function(Se, we) {
                  return ye[_$_b839[1045]](new Uint8Array(we), Se), Se + we[_$_b839[2109]];
                }, 0), ye[_$_b839[1142]];
              }, me[_$_b839[2494]] = function(be) {
                return be instanceof Uint8Array ? Uint8Array : be instanceof Uint16Array ? Uint16Array : be instanceof Uint32Array ? Uint32Array : null;
              }, me[_$_b839[2497]] = function(be) {
                return me[_$_b839[2494]](be) ? [][_$_b839[74]][_$_b839[36]](be) : Array[_$_b839[254]](be) ? be : null;
              }, me[_$_b839[2498]] = function() {
                for (var be = [], pe = 0; pe < arguments[_$_b839[26]]; pe++)
                  be[pe] = arguments[pe];
                var $e = [];
                return be[_$_b839[112]](function(ye) {
                  return !!ye;
                })[_$_b839[113]](function(ye) {
                  return ye[_$_b839[113]](function(Se) {
                    $e[_$_b839[815]](Se) || $e[_$_b839[57]](Se);
                  });
                }), $e;
              }, me[_$_b839[2499]] = function(be) {
                return !!be && be instanceof ArrayBuffer && be[_$_b839[2109]] !== void 0;
              }, me[_$_b839[2500]] = function(be, pe) {
                return pe === void 0 && (pe = !0), me[_$_b839[2501]](be, 1, 0, pe);
              }, me[_$_b839[2502]] = function(be) {
                for (var pe = _$_b839[90], $e = new Uint8Array(be), ye = 0; ye < $e[_$_b839[26]]; ye++)
                  pe += String[_$_b839[2490]]($e[ye]);
                return window[_$_b839[2503]](pe);
              }, me[_$_b839[2501]] = function(be, pe, $e, ye) {
                pe === void 0 && (pe = 2), $e === void 0 && ($e = 0), ye === void 0 && (ye = !0);
                for (var Se = _$_b839[90], we = ye ? new Uint8Array(be) : new Uint16Array(be), Pe = $e; Pe < we[_$_b839[26]]; Pe += pe)
                  Se += String[_$_b839[2490]](we[Pe]);
                return Se;
              }, me[_$_b839[249]] = function() {
                for (var be = [], pe = 0; pe < arguments[_$_b839[26]]; pe++)
                  be[pe] = arguments[pe];
                var $e = [], ye = be[_$_b839[112]](function(Se) {
                  return !!Se;
                });
                return me[_$_b839[2498]][_$_b839[35]](me, be)[_$_b839[113]](function(Se) {
                  ye[_$_b839[267]](function(we) {
                    return we[_$_b839[815]](Se);
                  }) && $e[_$_b839[57]](Se);
                }), $e;
              }, me[_$_b839[2504]] = function(be, pe) {
                var $e = be[_$_b839[112]](function(Se) {
                  return me[_$_b839[249]](Se, pe)[_$_b839[26]] > 0;
                }), ye = be[_$_b839[112]](function(Se) {
                  return !$e[_$_b839[815]](Se);
                });
                return $e[_$_b839[26]] === 0 ? ie(ie([], be, !0), [pe], !1) : ie([me[_$_b839[2498]][_$_b839[35]](me, ie(ie([], $e, !1), [pe], !1))], ye, !0);
              }, me[_$_b839[2505]] = function(be, pe, $e) {
                for (var ye = pe + $e, Se = _$_b839[90]; pe < ye; pe++)
                  Se += String[_$_b839[2490]](be[_$_b839[2506]](pe));
                return Se;
              }, me[_$_b839[2507]] = function(be, pe, $e) {
                for (var ye = pe + $e, Se = _$_b839[90]; pe < ye; pe++)
                  Se += ne[_$_b839[2509]][_$_b839[2508]](be[_$_b839[2506]](pe));
                return Se;
              }, me[_$_b839[2510]] = function(be) {
                try {
                  if (!be || !be[_$_b839[26]])
                    return [];
                  for (var pe = new Array(be[_$_b839[26]]), $e = 0; $e < be[_$_b839[26]]; $e++)
                    pe[$e] = be[$e];
                  return pe;
                } catch {
                  return [];
                }
              }, me;
            }();
            function ue(me) {
              return function(be, pe, $e) {
                return !me(be, pe, $e);
              };
            }
            function _e(me, be) {
              var pe;
              for (pe = me[_$_b839[26]] - 1; pe >= 0 && !be(me[pe]); pe--)
                ;
              return pe;
            }
            function fe(me, be, pe, $e) {
              for (var ye = be; ye < pe; ye++)
                if ($e(me[ye]))
                  return ye;
              return -1;
            }
            function le(me, be) {
              return me[_e(me, be)];
            }
            function se(me, be, pe) {
              for (; be < me[_$_b839[26]]; be++)
                pe(me[be - 1], me[be]);
            }
            function oe(me) {
              return Array[_$_b839[254]](me) ? me : [me];
            }
            function ce(me, be, pe) {
              return pe === void 0 && (pe = he), me[_$_b839[824]](function($e) {
                return pe(be, $e);
              }) != null;
            }
            function he(me, be) {
              return Object[_$_b839[98]](me)[_$_b839[26]] === Object[_$_b839[98]](be)[_$_b839[26]] && Object[_$_b839[98]](me)[_$_b839[267]](function(pe) {
                return me[pe] === be[pe];
              });
            }
            function ge(me) {
              me[_$_b839[130]](0, me[_$_b839[26]]);
            }
            function ve(me, be) {
              return be < 1 ? [] : me[_$_b839[130]](0, be);
            }
            te[_$_b839[2470]] = ae;
          }, 38255: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2511]] = void 0;
            var ee = function() {
              function ie() {
                this[_$_b839[137]] = /* @__PURE__ */ new Map();
              }
              return ie[_$_b839[37]][_$_b839[159]] = function(ne) {
                return this[_$_b839[137]][_$_b839[159]](ne);
              }, ie[_$_b839[37]][_$_b839[35]] = function(ne, ae) {
                this[_$_b839[137]][_$_b839[152]](ne) && this[_$_b839[137]][_$_b839[1045]](ne, ae(this[_$_b839[137]][_$_b839[159]](ne)));
              }, ie[_$_b839[37]][_$_b839[152]] = function(ne) {
                return this[_$_b839[137]][_$_b839[152]](ne);
              }, ie[_$_b839[37]][_$_b839[797]] = function(ne) {
                return this[_$_b839[137]][_$_b839[797]](ne);
              }, ie[_$_b839[37]][_$_b839[1064]] = function() {
                this[_$_b839[137]][_$_b839[1064]]();
              }, Object[_$_b839[82]](ie[_$_b839[37]], _$_b839[2512], { get: function() {
                return this[_$_b839[137]][_$_b839[2512]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](ie[_$_b839[37]], _$_b839[26], { get: function() {
                var ne = 0;
                return this[_$_b839[137]][_$_b839[113]](function(ae) {
                  return ne += ae[_$_b839[26]];
                }), ne;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](ie[_$_b839[37]], _$_b839[1083], { get: function() {
                var ne = [];
                return this[_$_b839[137]][_$_b839[113]](function(ae) {
                  ne[_$_b839[57]](ae);
                }), ne;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](ie[_$_b839[37]], _$_b839[98], { get: function() {
                var ne = [];
                return this[_$_b839[137]][_$_b839[113]](function(ae, ue) {
                  ne[_$_b839[57]](ue);
                }), ne;
              }, enumerable: !1, configurable: !0 }), ie[_$_b839[37]][_$_b839[143]] = function(ne, ae) {
                return this[_$_b839[2513]](ne), ae != null && this[_$_b839[159]](ne)[_$_b839[57]](ae), this;
              }, ie[_$_b839[37]][_$_b839[2513]] = function(ne) {
                this[_$_b839[152]](ne) || this[_$_b839[1045]](ne, []);
              }, ie[_$_b839[37]][_$_b839[1045]] = function(ne, ae) {
                return this[_$_b839[137]][_$_b839[1045]](ne, ae), this;
              }, ie[_$_b839[37]][_$_b839[2514]] = function(ne, ae) {
                var ue = this;
                this[_$_b839[2513]](ne), ae[_$_b839[113]](function(_e) {
                  return ue[_$_b839[143]](ne, _e);
                });
              }, ie[_$_b839[37]][_$_b839[2515]] = function() {
                var ne = {};
                return this[_$_b839[137]][_$_b839[113]](function(ae, ue) {
                  ne[ue] = ae;
                }), ne;
              }, ie[_$_b839[37]][_$_b839[2516]] = function(ne) {
                this[_$_b839[137]][_$_b839[113]](function(ae, ue) {
                  return ae[_$_b839[113]](function(_e) {
                    return ne(ue, _e);
                  });
                });
              }, ie[_$_b839[37]][_$_b839[251]] = function(ne) {
                this[_$_b839[137]][_$_b839[113]](function(ae) {
                  ae[_$_b839[251]](ne);
                });
              }, ie[_$_b839[37]][_$_b839[2517]] = function(ne) {
                var ae = new ie();
                return this[_$_b839[137]][_$_b839[113]](function(ue, _e) {
                  return ae[_$_b839[1045]](_e, ue[_$_b839[137]](ne));
                }), ae;
              }, ie[_$_b839[37]][_$_b839[1971]] = function(ne) {
                var ae = [];
                return this[_$_b839[137]][_$_b839[113]](function(ue) {
                  return ae[_$_b839[57]](ne(ue));
                }), ae;
              }, ie[_$_b839[37]][_$_b839[2518]] = function(ne) {
                var ae = new ie();
                return this[_$_b839[137]][_$_b839[113]](function(ue, _e) {
                  return ae[_$_b839[1045]](_e, ne(ue));
                }), ae;
              }, ie[_$_b839[37]][_$_b839[2519]] = function() {
                var ne = [];
                return this[_$_b839[137]][_$_b839[113]](function(ae) {
                  return ne[_$_b839[57]][_$_b839[35]](ne, ae);
                }), ne;
              }, ie[_$_b839[37]][_$_b839[2520]] = function(ne, ae) {
                if (!this[_$_b839[152]](ne))
                  return !1;
                var ue = this[_$_b839[137]][_$_b839[159]](ne), _e = ue[_$_b839[29]](ae);
                return _e >= 0 && (ue[_$_b839[130]](_e, 1), !0);
              }, ie;
            }();
            te[_$_b839[2511]] = ee;
          }, 30051: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2030]] = void 0;
            var ee = function() {
              function ie() {
              }
              return ie[_$_b839[2029]] = function(ne) {
                var ae = function(_e) {
                }, ue = new Promise(function(_e, fe) {
                  ae = fe, ne[_$_b839[166]](_e, fe);
                });
                return ue[_$_b839[1969]] = ae[_$_b839[71]](ue), ue;
              }, ie;
            }();
            te[_$_b839[2030]] = ee;
          }, 43485: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[589]] || function(Ue, ke, Le) {
              if (Le || arguments[_$_b839[26]] === 2)
                for (var De, Re = 0, Oe = ke[_$_b839[26]]; Re < Oe; Re++)
                  !De && Re in ke || (De || (De = Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](ke, 0, Re)), De[Re] = ke[Re]);
              return Ue[_$_b839[41]](De || Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](ke));
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2222]] = te[_$_b839[1212]] = te[_$_b839[2228]] = te[_$_b839[2229]] = te[_$_b839[2230]] = te[_$_b839[717]] = te[_$_b839[1014]] = te[_$_b839[2521]] = te[_$_b839[2522]] = te[_$_b839[2523]] = te[_$_b839[2524]] = te[_$_b839[2525]] = void 0, te[_$_b839[1689]] = we, te[_$_b839[2024]] = Ie;
            var ne, ae = ee(91520), ue = ee(16368), _e = ee(33696), fe = ee(13533), le = ee(87093), se = ee(79814), oe = ee(56435);
            (function(Ue) {
              Ue[_$_b839[2526]] = _$_b839[2166], Ue[_$_b839[2527]] = _$_b839[2167];
            })(ne || (te[_$_b839[2525]] = ne = {}));
            var ce = [{ player: _e[_$_b839[814]][_$_b839[1465]], streaming: _e[_$_b839[744]][_$_b839[743]] }, { player: _e[_$_b839[814]][_$_b839[1465]], streaming: _e[_$_b839[744]][_$_b839[746]] }, { player: _e[_$_b839[814]][_$_b839[1465]], streaming: _e[_$_b839[744]][_$_b839[171]] }, { player: _e[_$_b839[814]][_$_b839[1482]], streaming: _e[_$_b839[744]][_$_b839[751]] }, { player: _e[_$_b839[814]][_$_b839[813]], streaming: _e[_$_b839[744]][_$_b839[746]] }, { player: _e[_$_b839[814]][_$_b839[813]], streaming: _e[_$_b839[744]][_$_b839[748]] }], he = !0, ge = !!(le[_$_b839[107]][_$_b839[2528]] && le[_$_b839[107]][_$_b839[2529]] && le[_$_b839[107]][_$_b839[2530]]), ve = function() {
              return _$_b839[34] == typeof document[_$_b839[758]](_$_b839[757])[_$_b839[2531]];
            }, me = function() {
              var Ue = document[_$_b839[758]](_$_b839[757]);
              return Ue && _$_b839[34] == typeof Ue[_$_b839[2531]] && (_$_b839[2532] === Ue[_$_b839[2531]](_$_b839[2533]) || _$_b839[2532] === Ue[_$_b839[2531]](_$_b839[2056]) || _$_b839[2532] === Ue[_$_b839[2531]](_$_b839[2534]) || _$_b839[2532] === Ue[_$_b839[2531]](_$_b839[2535]));
            }, be = function() {
              var Ue, ke, Le, De = _$_b839[2536] in le[_$_b839[107]] && _$_b839[34] == typeof ((Ue = le[_$_b839[107]][_$_b839[2536]]) === null || Ue === void 0 ? void 0 : Ue[_$_b839[2537]]), Re = _$_b839[2538] in le[_$_b839[107]] && _$_b839[34] == typeof ((ke = le[_$_b839[107]][_$_b839[2538]]) === null || ke === void 0 ? void 0 : ke[_$_b839[2537]]), Oe = _$_b839[2539] in le[_$_b839[107]] && _$_b839[34] == typeof ((Le = le[_$_b839[107]][_$_b839[2539]]) === null || Le === void 0 ? void 0 : Le[_$_b839[2537]]);
              return De || Re || Oe;
            };
            te[_$_b839[2524]] = be;
            var pe = function() {
              var Ue, ke, Le, De = le[_$_b839[107]][_$_b839[2540]], Re = !!((Le = (ke = (Ue = navigator[_$_b839[2541]]) !== null && Ue !== void 0 ? Ue : navigator[_$_b839[2542]]) !== null && ke !== void 0 ? ke : navigator[_$_b839[2543]]) !== null && Le !== void 0 ? Le : navigator[_$_b839[2544]]), Oe = !!De && _$_b839[34] == typeof De[_$_b839[37]][_$_b839[2545]];
              return Re && Oe;
            }, $e = function() {
              var Ue = [];
              if (ge ? Ue = ce[_$_b839[112]](function(Le) {
                return (0, te[_$_b839[2522]])(Le[_$_b839[732]], Le[_$_b839[742]]);
              }) : Ue[_$_b839[57]]({ player: _e[_$_b839[814]][_$_b839[813]], streaming: _e[_$_b839[744]][_$_b839[748]] }), (0, oe[_$_b839[2214]])()) {
                for (var ke = 1; ke < Ue[_$_b839[26]]; ke++)
                  if (Ue[ke][_$_b839[732]] === _e[_$_b839[814]][_$_b839[813]] && Ue[ke][_$_b839[742]] === _e[_$_b839[744]][_$_b839[746]]) {
                    Ue = Ue[_$_b839[130]](ke, 1)[_$_b839[41]](Ue);
                    break;
                  }
              }
              return Ue;
            };
            te[_$_b839[2523]] = $e;
            var ye = function(Ue, ke) {
              var Le = (0, te[_$_b839[2524]])() ? [_e[_$_b839[744]][_$_b839[743]], _e[_$_b839[744]][_$_b839[746]], _e[_$_b839[744]][_$_b839[171]]] : [], De = pe() ? [_e[_$_b839[744]][_$_b839[751]]] : [], Re = function() {
                var Be = [];
                return me() && !(0, oe[_$_b839[2216]])() && Be[_$_b839[57]](_e[_$_b839[744]][_$_b839[746]]), ve() && he && Be[_$_b839[57]](_e[_$_b839[744]][_$_b839[748]]), Be;
              }, Oe = function(Be) {
                return Be[_$_b839[862]](function(Fe) {
                  return Fe === ke;
                });
              };
              switch (Ue) {
                case _e[_$_b839[814]][_$_b839[1465]]:
                  return Oe(Le);
                case _e[_$_b839[814]][_$_b839[1482]]:
                  return Oe(De);
                case _e[_$_b839[814]][_$_b839[813]]:
                  return Oe(Re());
                default:
                  return !1;
              }
            };
            te[_$_b839[2522]] = ye;
            var Se = function() {
              return Object[_$_b839[1083]](ne)[_$_b839[862]](function(Ue) {
                var ke;
                return (ke = le[_$_b839[107]][_$_b839[2546]]) === null || ke === void 0 ? void 0 : ke[_$_b839[2537]](Ue, se[_$_b839[1190]][_$_b839[2547]]);
              });
            };
            function we() {
              return _$_b839[2548] === le[_$_b839[107]][_$_b839[10]][_$_b839[2549]];
            }
            te[_$_b839[2521]] = Se;
            var Pe = function() {
              var Ue = (0, oe[_$_b839[2224]])(), ke = Ue < oe[_$_b839[2550]] && /iPad/i[_$_b839[2551]](navigator[_$_b839[1237]]), Le = Ue < oe[_$_b839[2552]] && /iP(hone|od)/i[_$_b839[2551]](navigator[_$_b839[1237]]);
              return oe[_$_b839[2215]] && (ke || Le);
            };
            te[_$_b839[1014]] = Pe;
            var Te = function() {
              try {
                return le[_$_b839[107]][_$_b839[2553]] && _$_b839[34] == typeof localStorage[_$_b839[2554]] && _$_b839[34] == typeof localStorage[_$_b839[2555]];
              } catch {
                return !1;
              }
            };
            te[_$_b839[717]] = Te;
            var Ee = function() {
              var Ue = (0, te[_$_b839[2228]])(), ke = (0, te[_$_b839[2229]])(), Le = function(De, Re) {
                return De[_$_b839[732]] === Re[_$_b839[732]] && De[_$_b839[742]] === Re[_$_b839[742]];
              };
              return ke[_$_b839[112]](function(De) {
                return Ue[_$_b839[112]](function(Re) {
                  return Le(Re, De);
                })[_$_b839[26]] > 0;
              });
            };
            te[_$_b839[2230]] = Ee;
            var Me = function() {
              return (0, te[_$_b839[2523]])();
            };
            te[_$_b839[2229]] = Me;
            var Ae = function() {
              var Ue = ae[_$_b839[140]][_$_b839[152]](ue[_$_b839[168]][_$_b839[183]]) ? ae[_$_b839[140]][_$_b839[159]](ue[_$_b839[168]][_$_b839[183]])[_$_b839[2557]][_$_b839[2556]]() : [], ke = ae[_$_b839[140]][_$_b839[152]](ue[_$_b839[168]][_$_b839[182]]) ? ae[_$_b839[140]][_$_b839[159]](ue[_$_b839[168]][_$_b839[182]])[_$_b839[2557]][_$_b839[2556]]() : [], Le = ae[_$_b839[140]][_$_b839[152]](ue[_$_b839[168]][_$_b839[210]]) ? ae[_$_b839[140]][_$_b839[159]](ue[_$_b839[168]][_$_b839[210]])[_$_b839[2557]][_$_b839[2556]]() : [];
              return ie(ie(ie([], Ue, !0), ke, !0), Le, !0);
            };
            te[_$_b839[2228]] = Ae;
            var Ne = function(Ue) {
              var ke = (0, fe[_$_b839[646]])(), Le = ie([], ke[_$_b839[983]], !0);
              if (!Ue || Ue[_$_b839[26]] === 0)
                return Le;
              var De = Ue[_$_b839[112]](function(Re) {
                return Le[_$_b839[862]](function(Oe, Be) {
                  var Fe, Ve = Re[_$_b839[732]] === Oe[_$_b839[732]] && Re[_$_b839[742]] === Oe[_$_b839[742]], Ke = (Fe = Re[_$_b839[1463]]) !== null && Fe !== void 0 && Fe;
                  return Ve && Le[_$_b839[130]](Be, 1), Ve && !Ke;
                });
              })[_$_b839[137]](function(Re) {
                return { player: Re[_$_b839[732]], streaming: Re[_$_b839[742]] };
              });
              return ie(ie([], De, !0), Le, !0);
            }, Ce = function(Ue, ke, Le) {
              Ue === void 0 && (Ue = []), ke === void 0 && (ke = {});
              var De = (0, fe[_$_b839[646]])(), Re = Ne(Ue), Oe = De[_$_b839[983]];
              return Le && (Re = Oe[_$_b839[112]](function(Be) {
                return Be[_$_b839[732]] === Le[_$_b839[732]] && Be[_$_b839[742]] === Le[_$_b839[742]];
              })), (ke[_$_b839[644]] && ((0, oe[_$_b839[2215]])() || (0, oe[_$_b839[2214]])()) ? Re[_$_b839[112]](function(Be) {
                var Fe = Be[_$_b839[742]] === _e[_$_b839[744]][_$_b839[748]] && Be[_$_b839[732]] === _e[_$_b839[814]][_$_b839[813]], Ve = Be[_$_b839[742]] === _e[_$_b839[744]][_$_b839[746]] && Be[_$_b839[732]] === _e[_$_b839[814]][_$_b839[813]];
                return Fe || Ve && (!(0, oe[_$_b839[2215]])() || (0, oe[_$_b839[2224]])() > oe[_$_b839[2550]]);
              }) : Re)[_$_b839[824]](function(Be) {
                return !!ke[Be[_$_b839[742]]];
              });
            };
            function Ie() {
              return _$_b839[34] == typeof le[_$_b839[107]][_$_b839[1334]] && _$_b839[34] == typeof le[_$_b839[107]][_$_b839[2558]];
            }
            te[_$_b839[1212]] = Ce;
            var xe = function() {
              return (0, oe[_$_b839[2214]])() && (0, te[_$_b839[2524]])();
            };
            te[_$_b839[2222]] = xe;
          }, 42283: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[589]] || function(oe, ce, he) {
              if (he || arguments[_$_b839[26]] === 2)
                for (var ge, ve = 0, me = ce[_$_b839[26]]; ve < me; ve++)
                  !ge && ve in ce || (ge || (ge = Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](ce, 0, ve)), ge[ve] = ce[ve]);
              return oe[_$_b839[41]](ge || Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](ce));
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2559]] = void 0, te[_$_b839[2560]] = _e, te[_$_b839[2561]] = fe, te[_$_b839[2562]] = le;
            var ne = ee(33696), ae = ee(10676), ue = function() {
              function oe() {
              }
              return oe[_$_b839[2563]] = function(ce) {
                return oe[_$_b839[2564]][_$_b839[2551]](ce);
              }, oe[_$_b839[2565]] = function(ce) {
                var he, ge = ce[_$_b839[124]](_$_b839[81]);
                return ge[_$_b839[26]] > 2 ? (he = ge[_$_b839[95]]() + _$_b839[81], he += parseInt(ge[_$_b839[95]]())[_$_b839[125]](16), he += (_$_b839[2566] + parseInt(ge[_$_b839[95]]())[_$_b839[125]](16))[_$_b839[74]](-4)) : he = ce, he;
              }, oe[_$_b839[2567]] = function(ce, he, ge) {
                return ce[_$_b839[2568]](he, ge);
              }, oe[_$_b839[2569]] = function(ce) {
                return oe[_$_b839[2570]] || (oe[_$_b839[2570]] = (0, ae[_$_b839[2571]])(se)), oe[_$_b839[2570]](ce);
              }, oe[_$_b839[2572]] = function(ce) {
                if (!ce)
                  return _$_b839[1316];
                for (var he = 0, ge = oe[_$_b839[2573]]; he < ge[_$_b839[26]]; he++) {
                  var ve = ge[he];
                  if (oe[_$_b839[2574]][ve][_$_b839[824]](function(me) {
                    return ce[_$_b839[29]](me) > -1;
                  }))
                    return ve;
                }
                return _$_b839[1316];
              }, oe[_$_b839[2575]] = function(ce, he) {
                var ge;
                oe[_$_b839[2574]][ce][_$_b839[57]](he), (ge = oe[_$_b839[2570]]) === null || ge === void 0 || ge[_$_b839[2576]]();
              }, oe[_$_b839[2577]] = function(ce, he) {
                return ce === he || [[_$_b839[2578], _$_b839[2579]], [_$_b839[1642], _$_b839[1643], _$_b839[2580]], [_$_b839[1640], _$_b839[1641], _$_b839[2581]]][_$_b839[862]](function(ge) {
                  return ge[_$_b839[815]](ce) && ge[_$_b839[815]](he);
                });
              }, oe[_$_b839[2582]] = function(ce) {
                return ce ? ce[_$_b839[124]](_$_b839[81])[0] : null;
              }, oe[_$_b839[2583]] = function(ce) {
                return _$_b839[757] === oe[_$_b839[2572]](ce);
              }, oe[_$_b839[2584]] = function(ce) {
                return _$_b839[1391] === oe[_$_b839[2572]](ce);
              }, oe[_$_b839[2585]] = function(ce) {
                return _$_b839[2586] === oe[_$_b839[2572]](ce);
              }, oe[_$_b839[2564]] = new RegExp(_$_b839[2587]), oe[_$_b839[2573]] = [_$_b839[757], _$_b839[1391], _$_b839[2586]], oe[_$_b839[2574]] = { video: [_$_b839[1637], _$_b839[1635], _$_b839[1634], _$_b839[2588], _$_b839[2589], _$_b839[2590], _$_b839[1632], _$_b839[1631], _$_b839[2591], _$_b839[1636], _$_b839[1628], _$_b839[1627], _$_b839[2592], _$_b839[2593], _$_b839[1629], _$_b839[1630]], audio: [_$_b839[2594], _$_b839[2595], _$_b839[2596], _$_b839[2597], _$_b839[2598], _$_b839[2599], _$_b839[2600], _$_b839[1642], _$_b839[1640], _$_b839[1639], _$_b839[1638]], application: [_$_b839[2601], _$_b839[2602], _$_b839[1951]] }, oe;
            }();
            function _e(oe) {
              return !!oe && oe[_$_b839[29]](_$_b839[355]) > -1;
            }
            function fe(oe, ce) {
              if (!ce)
                return null;
              for (var he = ie([], ce[_$_b839[2603]], !0); he[he[_$_b839[26]] - 1] === 0; )
                he[_$_b839[72]]();
              var ge = he[_$_b839[137]](function(ve) {
                return ve[_$_b839[125]](16)[_$_b839[1609]]();
              });
              return ie([oe, _$_b839[90][_$_b839[41]]([_$_b839[90], _$_b839[2606], _$_b839[2607], _$_b839[2608]][ce[_$_b839[2605]]])[_$_b839[41]](ce[_$_b839[2604]]), _$_b839[90][_$_b839[41]](ce[_$_b839[2609]]), _$_b839[90][_$_b839[41]](ce[_$_b839[2611]] === 0 ? _$_b839[2612] : _$_b839[2613])[_$_b839[41]](ce[_$_b839[2610]])], ge, !0)[_$_b839[123]](_$_b839[81]);
            }
            function le(oe) {
              return ue[_$_b839[2583]](oe) ? ne[_$_b839[296]][_$_b839[295]] : ue[_$_b839[2584]](oe) ? ne[_$_b839[296]][_$_b839[301]] : ue[_$_b839[2585]](oe) ? ne[_$_b839[296]][_$_b839[192]] : void 0;
            }
            function se(oe) {
              return oe || _$_b839[109] == typeof oe ? oe[_$_b839[124]](_$_b839[355])[_$_b839[135]](function(ce, he) {
                return he = he[_$_b839[2097]](), ce[ue[_$_b839[2572]](he)] = he, ce;
              }, {}) : {};
            }
            te[_$_b839[2559]] = ue;
          }, 18561: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1796]] = void 0;
            var ee = function() {
              function ie() {
              }
              return ie[_$_b839[979]] = function(ne, ae) {
                return ne === ae ? 0 : ne ? 1 : -1;
              }, ie[_$_b839[1795]] = function(ne, ae) {
                return ie[_$_b839[979]](ae, ne);
              }, ie;
            }();
            te[_$_b839[1796]] = ee;
          }, 86865: function(re, te) {
            _$_b839[32];
            function ee(ie, ne, ae) {
              return !ie && !ne || !(!ie || !ne) && (ae || Object[_$_b839[98]](ie))[_$_b839[267]](function(ue) {
                return ie[ue] === ne[ue];
              });
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2614]] = ee;
          }, 3941: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2615]] = void 0, te[_$_b839[2615]] = _$_b839[2616];
          }, 80043: function(re, te) {
            _$_b839[32];
            var ee = this && this[_$_b839[212]] || function() {
              var _e = function(fe, le) {
                return _e = Object[_$_b839[213]] || { __proto__: [] } instanceof Array && function(se, oe) {
                  se[_$_b839[214]] = oe;
                } || function(se, oe) {
                  for (var ce in oe)
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](oe, ce) && (se[ce] = oe[ce]);
                }, _e(fe, le);
              };
              return function(fe, le) {
                if (_$_b839[34] != typeof le && le !== null)
                  throw new TypeError(_$_b839[216] + String(le) + _$_b839[217]);
                function se() {
                  this[_$_b839[105]] = fe;
                }
                _e(fe, le), fe[_$_b839[37]] = le === null ? Object[_$_b839[52]](le) : (se[_$_b839[37]] = le[_$_b839[37]], new se());
              };
            }();
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2617]] = te[_$_b839[255]] = te[_$_b839[2618]] = void 0;
            var ie = function() {
              function _e() {
              }
              return _e[_$_b839[37]][_$_b839[2510]] = function() {
                for (var fe = []; this[_$_b839[256]](); )
                  fe[_$_b839[57]](this[_$_b839[132]]());
                return fe;
              }, _e;
            }(), ne = function(_e) {
              function fe() {
                return _e[_$_b839[36]](this) || this;
              }
              return ee(fe, _e), fe[_$_b839[37]][_$_b839[256]] = function() {
                return !1;
              }, fe[_$_b839[37]][_$_b839[132]] = function() {
              }, fe[_$_b839[784]] = function() {
                return this[_$_b839[2619]] || (this[_$_b839[2619]] = new fe()), this[_$_b839[2619]];
              }, fe;
            }(ie);
            te[_$_b839[2618]] = ne;
            var ae = function(_e) {
              function fe(le) {
                var se = _e[_$_b839[36]](this) || this;
                return se[_$_b839[1730]] = le, se[_$_b839[2620]] = -1, se;
              }
              return ee(fe, _e), fe[_$_b839[37]][_$_b839[256]] = function() {
                return this[_$_b839[2621]] = void 0, this[_$_b839[2620]] < this[_$_b839[1730]][_$_b839[26]] && (this[_$_b839[2620]]++, this[_$_b839[2621]] = this[_$_b839[1730]][this[_$_b839[2620]]]), this[_$_b839[2621]] != null;
              }, fe[_$_b839[37]][_$_b839[132]] = function() {
                return this[_$_b839[2621]];
              }, fe;
            }(ie);
            te[_$_b839[255]] = ae;
            var ue = function(_e) {
              function fe(le, se) {
                var oe = _e[_$_b839[36]](this) || this;
                return oe[_$_b839[104]] = le, oe[_$_b839[112]] = se, oe;
              }
              return ee(fe, _e), fe[_$_b839[37]][_$_b839[256]] = function() {
                var le;
                for (this[_$_b839[2621]] = void 0; this[_$_b839[104]][_$_b839[256]](); )
                  if (le = this[_$_b839[104]][_$_b839[132]](), this[_$_b839[112]](le)) {
                    this[_$_b839[2621]] = le;
                    break;
                  }
                return this[_$_b839[2621]] != null;
              }, fe[_$_b839[37]][_$_b839[132]] = function() {
                return this[_$_b839[2621]];
              }, fe;
            }(ie);
            te[_$_b839[2617]] = ue;
          }, 44920: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2622]] = void 0;
            var ee = function() {
              function ie() {
              }
              return ie[_$_b839[2623]] = function(ne, ae, ue) {
                ae === void 0 && (ae = {}), ue === void 0 && (ue = {});
                var _e = document[_$_b839[758]](ne);
                return Object[_$_b839[98]](ue)[_$_b839[113]](function(fe) {
                  return _e[_$_b839[656]][fe] = ue[fe];
                }), Object[_$_b839[98]](ae)[_$_b839[113]](function(fe) {
                  return _e[_$_b839[1148]](fe, ae[fe]);
                }), _e;
              }, ie;
            }();
            te[_$_b839[2622]] = ee;
          }, 10981: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1049]] = void 0;
            var ee = function() {
              function ie() {
                var ne = this;
                this[_$_b839[2624]] = _$_b839[2625], this[_$_b839[2626]] = new Promise(function(ae, ue) {
                  ne[_$_b839[2627]] = function(_e) {
                    return ne[_$_b839[2624]] = _$_b839[2628], ae(_e);
                  }, ne[_$_b839[2629]] = function(_e) {
                    return ne[_$_b839[2624]] = _$_b839[2630], ue(_e);
                  };
                });
              }
              return Object[_$_b839[82]](ie[_$_b839[37]], _$_b839[2631], { get: function() {
                return _$_b839[2625] !== this[_$_b839[2624]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](ie[_$_b839[37]], _$_b839[1056], { get: function() {
                return this[_$_b839[2626]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](ie[_$_b839[37]], _$_b839[602], { get: function() {
                return this[_$_b839[2627]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](ie[_$_b839[37]], _$_b839[913], { get: function() {
                return this[_$_b839[2629]];
              }, enumerable: !1, configurable: !0 }), ie;
            }();
            te[_$_b839[1049]] = ee;
          }, 44388: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2632]] = void 0;
            var ee = function() {
              function ie() {
              }
              return ie[_$_b839[2633]] = function(ne) {
                if (_$_b839[109] != typeof ne)
                  return NaN;
                var ae = /^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?(T)?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*|Infinity)S)?/[_$_b839[2634]](ne);
                if (ae) {
                  var ue = !!ae[1], _e = 12 * parseFloat(ae[2] || _$_b839[2616]) * 30 * 24 * 60 * 60, fe = 30 * parseFloat(ae[4] || _$_b839[2616]) * 24 * 60 * 60, le = 24 * parseFloat(ae[6] || _$_b839[2616]) * 60 * 60, se = 60 * parseFloat(ae[9] || _$_b839[2616]) * 60, oe = 60 * parseFloat(ae[11] || _$_b839[2616]), ce = parseFloat(ae[13] || _$_b839[2616]);
                  if (_$_b839[2635] === ae[8] && (ae[9] || ae[11] || ae[13]) === void 0)
                    return NaN;
                  var he = _e + fe + le + se + oe + ce;
                  return ue && (he = -he), he;
                }
                return NaN;
              }, ie;
            }();
            te[_$_b839[2632]] = ee;
          }, 82315: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1449]] = void 0;
            var ee = function() {
              function ie() {
                this[_$_b839[2636]] = {};
              }
              return ie[_$_b839[784]] = function() {
                return ie[_$_b839[2637]] || (ie[_$_b839[2637]] = new ie()), ie[_$_b839[2637]];
              }, ie[_$_b839[37]][_$_b839[2638]] = function(ne, ae) {
                return ae === void 0 && (ae = !1), this[_$_b839[2636]][_$_b839[215]](ne) && this[_$_b839[2636]][ne] || (ae && window[_$_b839[2639]] && window[_$_b839[2640]] ? this[_$_b839[2636]][ne] = new Promise(function(ue, _e) {
                  window[_$_b839[2639]]([ne], function(fe) {
                    ue(fe);
                  }, function(fe) {
                    _e(fe);
                  });
                }) : this[_$_b839[2636]][ne] = new Promise(function(ue, _e) {
                  var fe = document[_$_b839[371]](_$_b839[2641])[0] || document[_$_b839[2642]], le = !1, se = document[_$_b839[758]](_$_b839[370]);
                  se[_$_b839[65]] = _$_b839[2643], se[_$_b839[368]] = ne, se[_$_b839[2644]] = !0, se[_$_b839[2645]] = se[_$_b839[2646]] = function() {
                    le || this[_$_b839[1368]] && _$_b839[2121] !== this[_$_b839[1368]] && _$_b839[2647] !== this[_$_b839[1368]] || (le = !0, se[_$_b839[2645]] = se[_$_b839[2646]] = null, fe && se[_$_b839[1003]] && fe[_$_b839[926]](se), ue(void 0));
                  }, se[_$_b839[2648]] = _e, fe[_$_b839[2649]](se, fe[_$_b839[1625]]);
                })), this[_$_b839[2636]][ne];
              }, ie[_$_b839[37]][_$_b839[2650]] = function(ne, ae) {
                this[_$_b839[2636]][_$_b839[215]](ne) && this[_$_b839[2636]][ne] && delete this[_$_b839[2636]][ne];
                for (var ue = document[_$_b839[2641]][_$_b839[371]](_$_b839[370]), _e = 0; _e < ue[_$_b839[26]]; _e++)
                  ue[_e][_$_b839[368]][_$_b839[815]](ae) && document[_$_b839[2641]][_$_b839[926]](ue[_e]);
              }, ie[_$_b839[37]][_$_b839[2651]] = function(ne, ae) {
                for (var ue = (ae == null ? void 0 : ae[_$_b839[675]]) && ae[_$_b839[675]]() || document[_$_b839[371]](_$_b839[2641])[0] || document[_$_b839[2642]], _e = ue[_$_b839[2653]](_$_b839[2652]), fe = 0; fe < _e[_$_b839[26]]; fe++) {
                  var le = _e[fe];
                  if (le[_$_b839[377]](_$_b839[2654]) && le[_$_b839[2655]](_$_b839[2654])[_$_b839[29]](ne) > -1)
                    return;
                }
                var se = document[_$_b839[758]](_$_b839[2652]);
                se[_$_b839[1148]](_$_b839[2656], _$_b839[2657]), se[_$_b839[1148]](_$_b839[65], _$_b839[2658]), se[_$_b839[1148]](_$_b839[2654], ne), ue[_$_b839[2649]](se, ue[_$_b839[1625]]), this[_$_b839[2636]][ne] = !0;
              }, ie;
            }();
            te[_$_b839[1449]] = ee;
          }, 56093: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2509]] = void 0;
            var ee = function() {
              function ie() {
              }
              return ie[_$_b839[2659]] = function(ne) {
                var ae = ne[_$_b839[26]];
                1 & ae && (ne = _$_b839[2616] + ne, ae++);
                for (var ue = new Uint8Array(ae >> 1), _e = 0; _e < ae; _e += 2)
                  ue[_e >> 1] = parseInt(ne[_$_b839[25]](_e, _e + 2), 16);
                return ue;
              }, ie[_$_b839[2660]] = function(ne) {
                ne instanceof ArrayBuffer && (ne = new Uint8Array(ne));
                for (var ae = _$_b839[90], ue = 0; ue < ne[_$_b839[2109]]; ue++) {
                  var _e = (255 & ne[ue])[_$_b839[125]](16);
                  _e[_$_b839[26]] < 2 && (ae += _$_b839[2616]), ae += _e;
                }
                return ae;
              }, ie[_$_b839[2661]] = function(ne) {
                return this[_$_b839[2662]](this[_$_b839[2660]](ne));
              }, ie[_$_b839[2662]] = function(ne) {
                return ne[_$_b839[74]](0, 8) + _$_b839[1611] + ne[_$_b839[74]](8, 12) + _$_b839[1611] + ne[_$_b839[74]](12, 16) + _$_b839[1611] + ne[_$_b839[74]](16, 20) + _$_b839[1611] + ne[_$_b839[74]](20);
              }, ie[_$_b839[2508]] = function(ne) {
                return (_$_b839[2663] + ne[_$_b839[125]](16))[_$_b839[74]](-2);
              }, ie[_$_b839[2664]] = function(ne) {
                return window[_$_b839[2503]](ne)[_$_b839[30]](/\+/g, _$_b839[1611])[_$_b839[30]](/\//g, _$_b839[1582])[_$_b839[30]](/=/g, _$_b839[90]);
              }, ie[_$_b839[2665]] = function(ne) {
                return window[_$_b839[2668]]((ne + _$_b839[2667][_$_b839[74]]((ne[_$_b839[26]] + 3) % 4))[_$_b839[30]](/-/g, _$_b839[2666])[_$_b839[30]](/_/g, _$_b839[359]));
              }, ie;
            }();
            te[_$_b839[2509]] = ee;
          }, 53968: function(re, te) {
            _$_b839[32];
            function ee(ie) {
              var ne, ae = ie == null ? void 0 : ie[_$_b839[136]]();
              return !!ae && ((ne = ae[_$_b839[1142]]) === null || ne === void 0 ? void 0 : ne[_$_b839[2669]]);
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2670]] = ee;
          }, 26190: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2671]] = te[_$_b839[2672]] = te[_$_b839[2673]] = te[_$_b839[2674]] = te[_$_b839[2675]] = void 0, function(ue) {
              ue[_$_b839[2676]] = _$_b839[2677], ue[_$_b839[2678]] = _$_b839[1010], ue[_$_b839[192]] = _$_b839[967];
            }(ee || (te[_$_b839[2675]] = ee = {})), te[_$_b839[2674]] = _$_b839[90];
            var ie = function(ue, _e, fe) {
              if (!ue)
                return te[_$_b839[2674]];
              try {
                var le = ue(_e);
                return _$_b839[109] == typeof le ? le : te[_$_b839[2674]];
              } catch (se) {
                return fe[_$_b839[38]](_$_b839[2679], se), te[_$_b839[2674]];
              }
            };
            te[_$_b839[2673]] = ie;
            var ne = function(ue, _e, fe) {
              var le, se;
              return (se = (le = ue[_$_b839[1011]]) === null || le === void 0 ? void 0 : le[_e]) === null || se === void 0 ? void 0 : se[fe];
            };
            te[_$_b839[2672]] = ne;
            var ae = function(ue, _e) {
              var fe = (0, te[_$_b839[2672]])(ue[_$_b839[829]], ue[_$_b839[2680]], ue[_$_b839[2681]]);
              return (0, te[_$_b839[2673]])(fe, _e, ue[_$_b839[280]]);
            };
            te[_$_b839[2671]] = ae;
          }, 10676: function(re, te) {
            _$_b839[32];
            function ee(ie, ne) {
              var ae = /* @__PURE__ */ new Map();
              function ue(se) {
                return _e(ne || se[_$_b839[26]] === 0 ? ae : fe(ae, se), se);
              }
              function _e(se, oe) {
                var ce = ne ? ne[_$_b839[35]](void 0, oe) : ie;
                return se[_$_b839[152]](ce) || se[_$_b839[1045]](ce, ie[_$_b839[35]](void 0, oe)), se[_$_b839[159]](ce);
              }
              function fe(se, oe, ce) {
                ce === void 0 && (ce = 0);
                var he, ge = oe[_$_b839[26]] - 1 === ce, ve = oe[ce];
                return se[_$_b839[152]](ve) ? he = se[_$_b839[159]](ve) : (he = /* @__PURE__ */ new Map(), se[_$_b839[1045]](ve, he)), ce += 1, ge ? he : fe(he, oe, ce);
              }
              function le() {
                var se = function() {
                  for (var oe = [], ce = 0; ce < arguments[_$_b839[26]]; ce++)
                    oe[ce] = arguments[ce];
                  return ue(oe);
                };
                return se[_$_b839[2576]] = function() {
                  return ae[_$_b839[1064]]();
                }, se;
              }
              return le();
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2571]] = ee;
          }, 79814: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[300]] = te[_$_b839[1190]] = void 0, te[_$_b839[2682]] = _e;
            var ie, ne = ee(59181), ae = ee(33696);
            (function(fe) {
              fe[_$_b839[2547]] = _$_b839[2683], fe[_$_b839[2684]] = _$_b839[2685], fe[_$_b839[2686]] = _$_b839[2687], fe[_$_b839[2688]] = _$_b839[2689];
            })(ie || (te[_$_b839[1190]] = ie = {}));
            var ue = function() {
              function fe() {
              }
              return fe[_$_b839[2690]] = function(le) {
                return this[_$_b839[2691]](le) || this[_$_b839[2692]](le);
              }, fe[_$_b839[2692]] = function(le) {
                return le[_$_b839[815]](_$_b839[1326]);
              }, fe[_$_b839[2693]] = function(le) {
                return le[_$_b839[815]](_$_b839[2694]);
              }, fe[_$_b839[2691]] = function(le) {
                return le[_$_b839[815]](_$_b839[2586]);
              }, fe[_$_b839[2421]] = function(le) {
                return this[_$_b839[2695]](le) || this[_$_b839[299]](le);
              }, fe[_$_b839[2695]] = function(le) {
                return le[_$_b839[815]](_$_b839[757]);
              }, fe[_$_b839[2696]] = function(le) {
                return le[_$_b839[815]](_$_b839[1316]);
              }, fe[_$_b839[299]] = function(le) {
                return le[_$_b839[815]](_$_b839[1391]);
              }, fe[_$_b839[2697]] = function(le) {
                return le[_$_b839[815]](_$_b839[1950]);
              }, fe[_$_b839[2698]] = function(le) {
                return le[_$_b839[815]](ne[_$_b839[2054]][_$_b839[743]]);
              }, fe[_$_b839[2699]] = function(le) {
                return le[_$_b839[815]](ne[_$_b839[2054]][_$_b839[746]]) || le[_$_b839[815]](_$_b839[2700]);
              }, fe[_$_b839[2701]] = function(le) {
                return le[_$_b839[815]](_$_b839[2702]);
              }, fe[_$_b839[2703]] = function(le) {
                return this[_$_b839[2695]](le) ? ae[_$_b839[296]][_$_b839[295]] : this[_$_b839[299]](le) ? ae[_$_b839[296]][_$_b839[301]] : this[_$_b839[2690]](le) ? ae[_$_b839[296]][_$_b839[192]] : this[_$_b839[2697]](le) ? ae[_$_b839[296]][_$_b839[1392]] : void 0;
              }, fe[_$_b839[2704]] = function(le) {
                return le[_$_b839[124]](_$_b839[359])[0];
              }, fe[_$_b839[2705]] = function(le) {
                var se = le[_$_b839[124]](_$_b839[359]);
                return se[_$_b839[26]] > 1 ? se[1] : null;
              }, fe;
            }();
            function _e(fe, le) {
              return Object[_$_b839[98]](fe)[_$_b839[137]](function(se) {
                return ue[_$_b839[2703]](se);
              })[_$_b839[815]](ue[_$_b839[2703]](le));
            }
            te[_$_b839[300]] = ue;
          }, 65114: function(re, te) {
            _$_b839[32];
            function ee(ae, ue) {
              return ae == null ? void 0 : ae[_$_b839[2707]][_$_b839[824]](function(_e) {
                return _e[_$_b839[2706]] === ue;
              });
            }
            function ie(ae, ue) {
              var _e = ee(ae, ue[_$_b839[2708]]);
              if (_e)
                return _e[_$_b839[2711]][_$_b839[824]](function(fe) {
                  return fe[_$_b839[2710]][_$_b839[2709]](ue);
                });
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2712]] = void 0, te[_$_b839[2713]] = ee, te[_$_b839[2714]] = ie;
            var ne = function(ae, ue) {
              var _e = ie(ae, ue);
              if (_e)
                return _e[_$_b839[2715]][_$_b839[824]](function(fe) {
                  return fe[_$_b839[2710]][_$_b839[2709]](ue);
                });
            };
            te[_$_b839[2712]] = ne;
          }, 56435: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2716]] = te[_$_b839[2717]] = te[_$_b839[2224]] = te[_$_b839[2215]] = te[_$_b839[645]] = te[_$_b839[1462]] = te[_$_b839[2227]] = te[_$_b839[1469]] = te[_$_b839[2221]] = te[_$_b839[2718]] = te[_$_b839[1475]] = te[_$_b839[2719]] = te[_$_b839[2720]] = te[_$_b839[2721]] = te[_$_b839[2722]] = te[_$_b839[2723]] = te[_$_b839[2724]] = te[_$_b839[1466]] = te[_$_b839[2223]] = te[_$_b839[2216]] = te[_$_b839[2225]] = te[_$_b839[2214]] = te[_$_b839[2220]] = te[_$_b839[1612]] = te[_$_b839[2219]] = te[_$_b839[2218]] = te[_$_b839[2725]] = te[_$_b839[2726]] = te[_$_b839[2727]] = te[_$_b839[2728]] = te[_$_b839[2729]] = te[_$_b839[2730]] = te[_$_b839[2731]] = te[_$_b839[2732]] = te[_$_b839[2733]] = te[_$_b839[2734]] = te[_$_b839[2735]] = te[_$_b839[2736]] = te[_$_b839[2737]] = te[_$_b839[2738]] = te[_$_b839[2739]] = te[_$_b839[2740]] = te[_$_b839[2741]] = te[_$_b839[2742]] = te[_$_b839[2552]] = te[_$_b839[2550]] = void 0, te[_$_b839[2217]] = ce, te[_$_b839[1471]] = he, te[_$_b839[1473]] = ge, te[_$_b839[1691]] = ve;
            var ie = ee(43485);
            te[_$_b839[2550]] = 9, te[_$_b839[2552]] = 10, te[_$_b839[2742]] = 15, te[_$_b839[2741]] = 17, te[_$_b839[2740]] = 15, te[_$_b839[2739]] = 17, te[_$_b839[2738]] = 2, te[_$_b839[2737]] = 4, te[_$_b839[2736]] = 3, te[_$_b839[2735]] = 0, te[_$_b839[2734]] = 4, te[_$_b839[2733]] = 0, te[_$_b839[2732]] = 5, te[_$_b839[2731]] = 0, te[_$_b839[2730]] = 5, te[_$_b839[2729]] = 5, te[_$_b839[2728]] = 38, te[_$_b839[2727]] = 53, te[_$_b839[2726]] = 68, te[_$_b839[2725]] = 79;
            var ne = function() {
              return navigator[_$_b839[1237]][_$_b839[815]](_$_b839[2743]) && !(0, te[_$_b839[2216]])();
            };
            te[_$_b839[2218]] = ne;
            var ae = function() {
              return (0, te[_$_b839[2218]])() || (0, te[_$_b839[2216]])() && !ce();
            };
            te[_$_b839[2219]] = ae;
            var ue = function() {
              return navigator[_$_b839[1237]][_$_b839[815]](_$_b839[2744]);
            };
            te[_$_b839[1612]] = ue;
            var _e = function() {
              return navigator[_$_b839[1237]][_$_b839[815]](_$_b839[2745]) && (0, te[_$_b839[645]])();
            };
            te[_$_b839[2220]] = _e;
            var fe = function() {
              return navigator[_$_b839[1237]][_$_b839[815]](_$_b839[2746]) && !navigator[_$_b839[1237]][_$_b839[815]](_$_b839[2743]) && !navigator[_$_b839[1237]][_$_b839[815]](_$_b839[2747]) && !navigator[_$_b839[1237]][_$_b839[815]](_$_b839[2748]) && !(0, te[_$_b839[1466]])() && !he() && !ge() || (0, ie[_$_b839[2521]])();
            };
            te[_$_b839[2214]] = fe;
            var le = function() {
              var Fe = /Version\/(\d+)\.?(\d+)?\.?(\d+)?/[_$_b839[2634]](navigator[_$_b839[1237]]) || null;
              if (!Fe)
                return {};
              var Ve = Fe[1], Ke = Fe[2], Ze = Fe[3], nt = function(Qe) {
                return parseInt(Qe);
              };
              return { major: nt(Ve), minor: nt(Ke), patch: nt(Ze) };
            };
            te[_$_b839[2225]] = le;
            var se = function() {
              return /Edge\/\d+/i[_$_b839[2551]](navigator[_$_b839[1237]]) || /Edg\/\d+/i[_$_b839[2551]](navigator[_$_b839[1237]]);
            };
            te[_$_b839[2216]] = se;
            var oe = function() {
              var Fe = /Edge\/(\d+)\.?(\d+)/[_$_b839[2634]](navigator[_$_b839[1237]]) || /Edg\/(\d+)\.?(\d+)/[_$_b839[2634]](navigator[_$_b839[1237]]);
              if (!Fe || Fe[_$_b839[26]] === 0)
                return { major: 0, minor: 0 };
              var Ve = {};
              return Fe[1] && (Ve[_$_b839[2226]] = parseInt(Fe[1])), Fe[1] && (Ve[_$_b839[2749]] = parseInt(Fe[2])), Ve;
            };
            function ce() {
              var Fe = 79;
              return (0, te[_$_b839[2216]])() && (0, te[_$_b839[2223]])()[_$_b839[2226]] < Fe;
            }
            function he() {
              return /PlayStation 5/i[_$_b839[2551]](navigator[_$_b839[1237]]);
            }
            function ge() {
              return /PlayStation 4/i[_$_b839[2551]](navigator[_$_b839[1237]]);
            }
            function ve() {
              return _$_b839[211] === window[_$_b839[8]][_$_b839[2750]];
            }
            te[_$_b839[2223]] = oe;
            var me = function(Fe, Ve) {
              var Ke = (0, te[_$_b839[2719]])();
              return Ke[_$_b839[2226]] === Fe && Ke[_$_b839[2749]] === Ve;
            }, be = function() {
              return navigator[_$_b839[1237]][_$_b839[815]](_$_b839[200]);
            };
            te[_$_b839[1466]] = be;
            var pe = function() {
              return me(te[_$_b839[2732]], te[_$_b839[2731]]);
            };
            te[_$_b839[2724]] = pe;
            var $e = function() {
              return me(te[_$_b839[2734]], te[_$_b839[2733]]);
            };
            te[_$_b839[2723]] = $e;
            var ye = function() {
              return me(te[_$_b839[2736]], te[_$_b839[2735]]);
            };
            te[_$_b839[2722]] = ye;
            var Se = function() {
              return me(te[_$_b839[2738]], te[_$_b839[2737]]);
            };
            te[_$_b839[2721]] = Se;
            var we = function() {
              return me(te[_$_b839[2730]], te[_$_b839[2729]]);
            };
            te[_$_b839[2720]] = we;
            var Pe = function() {
              var Fe = /Tizen (\d).(\d)/[_$_b839[2634]](navigator[_$_b839[1237]]);
              return Fe != null && Fe[1] ? { major: Number(Fe[1]), minor: Number(Fe[2] || 0) } : {};
            };
            te[_$_b839[2719]] = Pe;
            var Te = function() {
              return navigator[_$_b839[1237]][_$_b839[815]](_$_b839[2751]);
            };
            te[_$_b839[1475]] = Te;
            var Ee = function() {
              var Fe = new RegExp(/VIDAA\/(\d+)\.?(\d+)/)[_$_b839[2634]](navigator[_$_b839[1237]]);
              return Fe != null && Fe[1] ? { major: Number(Fe[1]), minor: Number(Fe[2]) } : {};
            };
            te[_$_b839[2718]] = Ee;
            var Me = function() {
              return navigator[_$_b839[1237]][_$_b839[815]](_$_b839[2752]);
            };
            te[_$_b839[2221]] = Me;
            var Ae = function() {
              return navigator[_$_b839[1237]][_$_b839[815]](_$_b839[2753]) || navigator[_$_b839[1237]][_$_b839[815]](_$_b839[2754]);
            };
            te[_$_b839[1469]] = Ae;
            var Ne = function() {
              var Fe, Ve = new RegExp(/Chrome\/(\d+)\.?(\d+)/)[_$_b839[2634]](navigator[_$_b839[1237]]);
              return Ve != null && Ve[1] ? { major: Number(Ve[1]), minor: Number((Fe = Ve[2]) !== null && Fe !== void 0 ? Fe : 0) } : {};
            };
            te[_$_b839[2227]] = Ne;
            var Ce = function() {
              return /Android/i[_$_b839[2551]](navigator[_$_b839[1237]]) || /IEMobile/i[_$_b839[2551]](navigator[_$_b839[1237]]) || /Windows Phone 10.0/i[_$_b839[2551]](navigator[_$_b839[1237]]) || /Safari/i[_$_b839[2551]](navigator[_$_b839[1237]]) && /Mobile/i[_$_b839[2551]](navigator[_$_b839[1237]]);
            };
            te[_$_b839[1462]] = Ce;
            var Ie = function() {
              return /Safari/i[_$_b839[2551]](navigator[_$_b839[1237]]) && /Mobile/i[_$_b839[2551]](navigator[_$_b839[1237]]) && !/Android/i[_$_b839[2551]](navigator[_$_b839[1237]]) && !/Windows Phone 10.0/i[_$_b839[2551]](navigator[_$_b839[1237]]);
            };
            te[_$_b839[645]] = Ie;
            var xe = function() {
              return /Safari/i[_$_b839[2551]](navigator[_$_b839[1237]]) && /iP(hone|od|ad)/i[_$_b839[2551]](navigator[_$_b839[1237]]);
            };
            te[_$_b839[2215]] = xe;
            var Ue = function() {
              var Fe = /OS (\d+)(_\d+)*/[_$_b839[2634]](navigator[_$_b839[1237]]);
              return Fe && Fe[_$_b839[26]] > 0 && parseInt(Fe[1], 10) || 0;
            };
            te[_$_b839[2224]] = Ue;
            var ke = function() {
              return (0, te[_$_b839[645]])() && (0, te[_$_b839[2224]])() === te[_$_b839[2742]];
            }, Le = function() {
              return (0, te[_$_b839[2214]])() && (0, te[_$_b839[2225]])()[_$_b839[2226]] === te[_$_b839[2740]];
            }, De = function() {
              return Le() || ke();
            };
            te[_$_b839[2717]] = De;
            var Re = function() {
              return (0, te[_$_b839[645]])() && (0, te[_$_b839[2224]])() === te[_$_b839[2741]];
            }, Oe = function() {
              return (0, te[_$_b839[2214]])() && (0, te[_$_b839[2225]])()[_$_b839[2226]] === te[_$_b839[2739]];
            }, Be = function() {
              return Oe() || Re();
            };
            te[_$_b839[2716]] = Be;
          }, 9146: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[227]] || function() {
              return ie = Object[_$_b839[228]] || function(le) {
                for (var se, oe = 1, ce = arguments[_$_b839[26]]; oe < ce; oe++)
                  for (var he in se = arguments[oe])
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](se, he) && (le[he] = se[he]);
                return le;
              }, ie[_$_b839[35]](this, arguments);
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2755]] = void 0;
            var ne = ee(65077), ae = ee(56555), ue = ee(56435), _e = ee(54838), fe = function() {
              function le(se) {
                _$_b839[109] == typeof se ? this[_$_b839[1435]] = { key: se } : (this[_$_b839[1435]] = {}, _e[_$_b839[1022]][_$_b839[1663]](this[_$_b839[1435]], se));
              }
              return le[_$_b839[37]][_$_b839[2756]] = function(se) {
                var oe = (se ?? {})[_$_b839[2757]];
                if ((0, ue[_$_b839[1466]])() || (0, ue[_$_b839[1469]])()) {
                  var ce = (0, ae[_$_b839[1686]])(oe);
                  _e[_$_b839[1022]][_$_b839[1663]](this[_$_b839[1435]], ce);
                }
                return this;
              }, le[_$_b839[37]][_$_b839[2758]] = function(se) {
                var oe = (0, ne[_$_b839[1649]])(se);
                return _e[_$_b839[1022]][_$_b839[1663]](this[_$_b839[1435]], oe), this;
              }, le[_$_b839[37]][_$_b839[2759]] = function(se) {
                return _e[_$_b839[1022]][_$_b839[1663]](this[_$_b839[1435]], se), this;
              }, le[_$_b839[37]][_$_b839[1091]] = function() {
                return ie({}, this[_$_b839[1435]]);
              }, le;
            }();
            te[_$_b839[2755]] = fe;
          }, 38261: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[718]] = void 0;
            var ee = function() {
              function ie(ne) {
                this[_$_b839[2760]] = ne, this[_$_b839[2761]] = _$_b839[2762], this[_$_b839[1730]] = {}, this[_$_b839[2763]] = function() {
                  var ae = 366, ue = /* @__PURE__ */ new Date();
                  return ue[_$_b839[2764]](ue[_$_b839[275]]() + 864e5 * ae), _$_b839[2765] + ue[_$_b839[2766]]();
                }(), this[_$_b839[1040]]();
              }
              return ie[_$_b839[37]][_$_b839[159]] = function(ne) {
                return this[_$_b839[1730]][ne];
              }, ie[_$_b839[37]][_$_b839[1045]] = function(ne, ae) {
                this[_$_b839[1730]][ne] = ae, this[_$_b839[2767]]();
              }, ie[_$_b839[37]][_$_b839[942]] = function(ne) {
                this[_$_b839[2768]] = ne;
              }, ie[_$_b839[37]][_$_b839[2769]] = function(ne) {
                var ae = this[_$_b839[2770]]();
                if (!ae)
                  return _$_b839[90];
                for (var ue = ne + _$_b839[2771], _e = ae[_$_b839[124]](_$_b839[2772]), fe = 0; fe < _e[_$_b839[26]]; fe++) {
                  for (var le = _e[fe]; _$_b839[60] === le[_$_b839[1610]](0); )
                    le = le[_$_b839[25]](1);
                  if (le[_$_b839[29]](ue) === 0)
                    return le[_$_b839[25]](ue[_$_b839[26]], le[_$_b839[26]]);
                }
                return _$_b839[90];
              }, ie[_$_b839[37]][_$_b839[2770]] = function() {
                try {
                  return document[_$_b839[2773]];
                } catch {
                  return _$_b839[90];
                }
              }, ie[_$_b839[37]][_$_b839[2774]] = function(ne) {
                if (ne)
                  try {
                    this[_$_b839[1730]] = JSON[_$_b839[283]](ne);
                  } catch {
                  }
              }, ie[_$_b839[37]][_$_b839[1040]] = function() {
                this[_$_b839[2760]] ? this[_$_b839[2774]](localStorage[_$_b839[2554]](this[_$_b839[2761]])) : this[_$_b839[2774]](this[_$_b839[2769]](this[_$_b839[2761]]));
              }, ie[_$_b839[37]][_$_b839[2767]] = function() {
                if (!this[_$_b839[2768]])
                  try {
                    this[_$_b839[2760]] ? localStorage[_$_b839[2555]](this[_$_b839[2761]], JSON[_$_b839[282]](this[_$_b839[1730]])) : document[_$_b839[2773]] = this[_$_b839[2761]] + _$_b839[2771] + JSON[_$_b839[282]](this[_$_b839[1730]]) + _$_b839[2775] + this[_$_b839[2763]];
                  } catch {
                  }
              }, ie;
            }();
            te[_$_b839[718]] = ee;
          }, 34586: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2776]] = void 0;
            var ie = ee(81361), ne = function() {
              function ae() {
              }
              return ae[_$_b839[2777]] = function(ue) {
                if (!ue)
                  return !1;
                var _e = [87, 69, 66, 86, 84, 84], fe = [239, 187, 191], le = new Uint8Array(ue[_$_b839[74]](0, 6)), se = new Uint8Array(ue[_$_b839[74]](0, 9));
                return ie[_$_b839[2470]][_$_b839[2481]](le, new Uint8Array(_e)) || ie[_$_b839[2470]][_$_b839[2481]](se, new Uint8Array(fe[_$_b839[41]](_e)));
              }, ae[_$_b839[2778]] = function(ue) {
                for (var _e, fe = !0, le = [34, 85, 84, 70, 45, 56, 34], se = ue instanceof ArrayBuffer ? new DataView(ue) : ue, oe = 0; oe < se[_$_b839[2109]]; oe++)
                  if ((_e = se[_$_b839[2506]](oe)) > 128)
                    fe = !1;
                  else {
                    if (_e === 0)
                      return _$_b839[2779];
                    if (_e === le[0] && se[_$_b839[2109]] > oe + le[_$_b839[26]]) {
                      for (var ce = !0, he = 1; he < le[_$_b839[26]]; he++)
                        if (le[he] !== se[_$_b839[2506]](oe + he)) {
                          ce = !1;
                          break;
                        }
                      if (ce)
                        return _$_b839[2485];
                    }
                  }
                return fe ? _$_b839[2780] : _$_b839[2485];
              }, ae;
            }();
            te[_$_b839[2776]] = ne;
          }, 331: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[276]] = ie, te[_$_b839[1266]] = ne;
            var ee = 1e3;
            function ie(ae) {
              return ae / ee;
            }
            function ne(ae) {
              return ae * ee;
            }
          }, 70016: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2781]] = te[_$_b839[1207]] = void 0, te[_$_b839[2782]] = ne, te[_$_b839[2783]] = ae;
            var ee = function(ue) {
              return _$_b839[79] == typeof ue;
            };
            te[_$_b839[1207]] = ee;
            var ie = function(ue) {
              return _$_b839[979] == typeof ue;
            };
            function ne(ue) {
              return ue != null;
            }
            function ae(ue) {
              return ue[_$_b839[2784]] != null && ue[_$_b839[2785]] != null;
            }
            te[_$_b839[2781]] = ie;
          }, 76885: function(re, te) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1961]] = void 0, te[_$_b839[2036]] = fe, te[_$_b839[2786]] = le;
            var ee = function() {
              function se() {
              }
              return se[_$_b839[2787]] = function(oe) {
                return !!oe && (_$_b839[109] != typeof oe && (oe = se[_$_b839[2788]](oe)), se[_$_b839[2789]][_$_b839[2551]](oe));
              }, se[_$_b839[2790]] = function(oe) {
                return oe[_$_b839[29]](_$_b839[2791]) > -1 && (oe = oe[_$_b839[124]](_$_b839[2791])[0]), oe;
              }, se[_$_b839[2788]] = function(oe) {
                return oe && _$_b839[109] != typeof oe ? ne(oe) ? oe[_$_b839[2792]] : ae(oe) ? oe[_$_b839[1205]] : null : oe;
              }, se[_$_b839[2793]] = function(oe, ce) {
                var he = _$_b839[359], ge = se[_$_b839[2788]](oe), ve = se[_$_b839[2788]](ce);
                return !ge || ge[_$_b839[26]] < 1 || se[_$_b839[2787]](ve) ? ve : !ve || ve[_$_b839[26]] < 1 ? ge : ((ge = se[_$_b839[2790]](ge))[_$_b839[29]](_$_b839[359]) > -1 && (ge = ge[_$_b839[25]](0, ge[_$_b839[360]](_$_b839[359]))), _$_b839[359] === ve[0] && (ge = fe(ge), he = _$_b839[90]), ge + he + ve);
              }, se[_$_b839[2794]] = function(oe) {
                if (!oe)
                  return null;
                oe = se[_$_b839[2790]](oe);
                var ce = se[_$_b839[2795]](oe), he = oe[_$_b839[360]](_$_b839[359]);
                return he === oe[_$_b839[26]] - 1 && (oe = oe[_$_b839[25]](0, he)), (he = oe[_$_b839[360]](_$_b839[359])) < 0 ? _$_b839[90] : he > oe[_$_b839[26]] - 1 ? oe : he <= ce ? oe + _$_b839[359] : oe[_$_b839[25]](0, he + 1);
              }, se[_$_b839[2796]] = function(oe) {
                return !!(oe && oe[_$_b839[26]] > 0) && _$_b839[359] === oe[0];
              }, se[_$_b839[2795]] = function(oe) {
                var ce = _$_b839[2797], he = oe[_$_b839[29]](ce);
                return he > -1 ? he + ce[_$_b839[26]] : he === -1 && oe[_$_b839[29]](_$_b839[2798]) === 0 ? 2 : 0;
              }, se[_$_b839[2799]] = function(oe, ce) {
                var he = fe(oe), ge = fe(ce);
                return oe[_$_b839[30]](he, ge);
              }, se[_$_b839[2800]] = function(oe, ce) {
                return !(!oe || !ce) && (ce[_$_b839[29]](_$_b839[2801]) === 0 && (ce = ce[_$_b839[25]](3)), oe[_$_b839[29]](ce) > -1);
              }, se[_$_b839[2802]] = function(oe, ce) {
                return se[_$_b839[2787]](ce) ? (ce[_$_b839[357]](_$_b839[359]) && (ce = (ue(oe) || _e()) + ce), ce) : (oe = this[_$_b839[1960]](oe), ce && ce[_$_b839[26]] !== 0 ? se[_$_b839[2796]](ce) ? fe(oe) + ce : (oe[_$_b839[2803]](_$_b839[359]) || (oe = this[_$_b839[2794]](oe)), oe + ce) : oe);
              }, se[_$_b839[2016]] = function(oe, ce) {
                if (!ce || Object[_$_b839[98]](ce)[_$_b839[26]] === 0)
                  return oe;
                var he = _$_b839[90], ge = oe[_$_b839[29]](_$_b839[2791]) >= 0;
                for (var ve in ce)
                  ce[_$_b839[215]](ve) && (he += ge ? _$_b839[2804] : _$_b839[2791], ge = !0, he = ie(he, ve, ce[ve]));
                return oe + he;
              }, se[_$_b839[1960]] = function(oe) {
                if (se[_$_b839[2805]](oe))
                  return oe;
                var ce = oe[_$_b839[357]](_$_b839[2798]) ? _e() + oe : oe;
                return oe[_$_b839[124]](_$_b839[2798])[1][_$_b839[815]](_$_b839[359]) || (ce += _$_b839[359]), ce;
              }, se[_$_b839[2805]] = function(oe) {
                return oe && oe[_$_b839[29]](this[_$_b839[2806]]) === 0;
              }, se[_$_b839[2807]] = function(oe) {
                if (!this[_$_b839[2805]](oe))
                  throw new Error(_$_b839[2808] + oe);
                (oe = oe[_$_b839[25]](this[_$_b839[2806]][_$_b839[26]]))[_$_b839[29]](this[_$_b839[2809]]) === -1 && (oe = this[_$_b839[2810]] + this[_$_b839[2809]] + oe);
                var ce = oe[_$_b839[124]](this[_$_b839[2809]]), he = ce[0], ge = ce[1], ve = he[_$_b839[2803]](this[_$_b839[2811]]), me = he[_$_b839[26]] - this[_$_b839[2811]][_$_b839[26]] - this[_$_b839[2809]][_$_b839[26]];
                return { mediaType: ve ? he[_$_b839[25]](0, me) : he, base64: ve ? ge : void 0, data: ve ? atob(ge) : ge };
              }, se[_$_b839[2812]] = function(oe, ce, he) {
                return se[_$_b839[2787]](he) ? he : se[_$_b839[2796]](he) ? ce + he : oe + he;
              }, se[_$_b839[2813]] = function(oe, ce) {
                return se[_$_b839[2787]](oe) ? oe : se[_$_b839[2802]](ce, oe);
              }, se[_$_b839[2806]] = _$_b839[2814], se[_$_b839[2811]] = _$_b839[2815], se[_$_b839[2810]] = _$_b839[2816], se[_$_b839[2789]] = new RegExp(_$_b839[2817], _$_b839[2818]), se[_$_b839[2809]] = _$_b839[355], se;
            }();
            function ie(se, oe, ce) {
              return se += oe, ce != null && (se += _$_b839[2771] + encodeURIComponent(ce)), se;
            }
            function ne(se) {
              return se && _$_b839[109] == typeof se[_$_b839[2792]];
            }
            function ae(se) {
              return se && _$_b839[109] == typeof se[_$_b839[1205]];
            }
            function ue(se) {
              return se[_$_b839[25]](0, se[_$_b839[29]](_$_b839[2798]));
            }
            function _e() {
              var se;
              return ((se = window[_$_b839[10]]) === null || se === void 0 ? void 0 : se[_$_b839[2549]]) || _$_b839[2819];
            }
            function fe(se) {
              var oe = se[_$_b839[29]](_$_b839[2798]) + 2, ce = se[_$_b839[29]](_$_b839[359], oe);
              return ce === -1 && (ce = se[_$_b839[29]](_$_b839[2791], oe)), ce === -1 ? se : se[_$_b839[74]](0, ce);
            }
            function le(se, oe) {
              var ce = se[_$_b839[124]](_$_b839[2791]), he = ce[0], ge = ce[1];
              if (!ge)
                return se;
              var ve = ge[_$_b839[124]](_$_b839[2804])[_$_b839[112]](function(me) {
                var be = me[_$_b839[124]](_$_b839[2771])[0];
                return !oe[_$_b839[815]](be);
              })[_$_b839[123]](_$_b839[2804]);
              return ve ? _$_b839[90][_$_b839[41]](he, _$_b839[2791])[_$_b839[41]](ve) : he;
            }
            te[_$_b839[1961]] = ee;
          }, 54838: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[589]] || function(ce, he, ge) {
              if (ge || arguments[_$_b839[26]] === 2)
                for (var ve, me = 0, be = he[_$_b839[26]]; me < be; me++)
                  !ve && me in he || (ve || (ve = Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](he, 0, me)), ve[me] = he[me]);
              return ce[_$_b839[41]](ve || Array[_$_b839[37]][_$_b839[74]][_$_b839[36]](he));
            };
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1022]] = void 0, te[_$_b839[1660]] = se, te[_$_b839[2820]] = oe;
            var ne = ee(60997), ae = ee(87326), ue = ee(46462), _e = ee(30573), fe = ee(331), le = function() {
              function ce() {
              }
              return ce[_$_b839[1935]] = function(he, ge) {
                if (he === ge)
                  return !0;
                if (!he || _$_b839[33] != typeof he || !ge || _$_b839[33] != typeof ge || Object[_$_b839[98]](he)[_$_b839[26]] !== Object[_$_b839[98]](ge)[_$_b839[26]])
                  return !1;
                for (var ve in he)
                  if (!ge[_$_b839[215]](ve) || !ce[_$_b839[1935]](he[ve], ge[ve]))
                    return !1;
                return !0;
              }, ce[_$_b839[1663]] = function(he, ge) {
                var ve = window[_$_b839[2528]] !== void 0;
                for (var me in ge)
                  ge[_$_b839[215]](me) && (ve && ge[me] instanceof ArrayBuffer ? he[me] = ge[me][_$_b839[74]](0, ge[me][_$_b839[2109]]) : _$_b839[33] == typeof ge[me] && ge[me] !== null ? (he[_$_b839[215]](me) || (Array[_$_b839[254]](ge[me]) ? he[me] = [] : he[me] = {}), ce[_$_b839[1663]](he[me], ge[me])) : he[me] = ge[me]);
              }, ce[_$_b839[1662]] = function(he) {
                for (var ge = this, ve = [], me = 1; me < arguments[_$_b839[26]]; me++)
                  ve[me - 1] = arguments[me];
                return ve[_$_b839[113]](function(be) {
                  return ge[_$_b839[1663]](he, be);
                }), he;
              }, ce[_$_b839[1122]] = function(he) {
                return !!he && _$_b839[2821] === {}[_$_b839[125]][_$_b839[36]](he);
              }, ce[_$_b839[1666]] = function(he, ge) {
                return isNaN(ge) ? (ge = ge[_$_b839[1608]]()[_$_b839[2097]]()[_$_b839[30]](/,/g, _$_b839[81]))[_$_b839[29]](_$_b839[2822]) > -1 ? 1e6 * ge[_$_b839[124]](_$_b839[2823])[0] : ge[_$_b839[29]](_$_b839[2824]) > -1 ? 1e3 * ge[_$_b839[124]](_$_b839[2825])[0] : ge[_$_b839[29]](_$_b839[2826]) > -1 ? 1 * ge[_$_b839[124]](_$_b839[2827])[0] : _$_b839[248] === he ? 1 / 0 : 0 : ge === 1 / 0 ? ge : 1 * ge;
              }, ce[_$_b839[1210]] = function(he) {
                if (he && _$_b839[109] == typeof he) {
                  for (var ge = he[_$_b839[124]](_$_b839[81]), ve = 0, me = 0; me < he[_$_b839[26]]; me++)
                    _$_b839[90] === ge[me] && (ge[me] = null, ve++);
                  return ve === he[_$_b839[26]] ? null : { player: ge[0], streaming: ge[1] };
                }
                return null;
              }, ce[_$_b839[2828]] = function() {
                var he = document[_$_b839[758]](_$_b839[829]);
                he[_$_b839[1148]](_$_b839[65], _$_b839[2829]), he[_$_b839[1148]](_$_b839[368], _$_b839[2830]);
                var ge = { settings: ae[_$_b839[714]] };
                for (ce[_$_b839[2831]] = ce[_$_b839[2831]] || new _e[_$_b839[2832]](ge, document[_$_b839[758]](_$_b839[1391])), ce[_$_b839[2831]][_$_b839[1148]](_$_b839[712], _$_b839[2833]), ce[_$_b839[2831]][_$_b839[76]](ue[_$_b839[1370]][_$_b839[388]], function() {
                  return ce[_$_b839[2831]][_$_b839[2834]] = !0;
                }), ce[_$_b839[2831]][_$_b839[1148]](_$_b839[2835], _$_b839[2836]), ce[_$_b839[2831]][_$_b839[377]](_$_b839[368]) && ce[_$_b839[2831]][_$_b839[1624]](_$_b839[368]); ce[_$_b839[2831]][_$_b839[1625]]; )
                  ce[_$_b839[2831]][_$_b839[926]](ce[_$_b839[2831]][_$_b839[1625]]);
                ce[_$_b839[2831]][_$_b839[1040]]();
              }, ce[_$_b839[1021]] = function() {
                return ce[_$_b839[2831]] || ce[_$_b839[2828]](), ce[_$_b839[2831]];
              }, ce[_$_b839[1111]] = function() {
                if (ce[_$_b839[2831]]) {
                  var he = ce[_$_b839[2831]][_$_b839[769]]();
                  ce[_$_b839[2831]] = (0, ne[_$_b839[340]])(ce[_$_b839[2831]]), he[_$_b839[1003]] && he[_$_b839[1003]][_$_b839[926]](he);
                }
              }, ce[_$_b839[1016]] = function() {
                return document[_$_b839[2837]] || document[_$_b839[2838]] || document[_$_b839[2839]] || document[_$_b839[2840]];
              }, ce[_$_b839[1377]] = function() {
                return Date[_$_b839[840]]()[_$_b839[125]](16) + Math[_$_b839[1343]](1048576 * (1 + Math[_$_b839[126]]()))[_$_b839[125]](16)[_$_b839[25]](1);
              }, ce[_$_b839[2841]] = function(he) {
                var ge = null;
                return _$_b839[109] != typeof he && isNaN(he) || (ge = _$_b839[109] == typeof he ? ce[_$_b839[2842]][_$_b839[2551]](he) ? new Date(he) : new Date(he + _$_b839[2843]) : new Date(he)), ge;
              }, ce[_$_b839[1869]] = function(he) {
                var ge = 0;
                if (he[_$_b839[26]] === 0)
                  return ge;
                for (var ve = 0; ve < he[_$_b839[26]]; ve++)
                  ge = (ge << 5) - ge + he[_$_b839[2483]](ve), ge |= 0;
                return ge;
              }, ce[_$_b839[930]] = function(he, ge) {
                return new Promise(function(ve) {
                  setTimeout(function() {
                    _$_b839[34] == typeof ge ? ve(ge()) : ve();
                  }, he);
                });
              }, ce[_$_b839[2844]] = function(he) {
                return (0, fe[_$_b839[276]])(he[_$_b839[275]]());
              }, ce[_$_b839[1199]] = function(he) {
                var ge = 16, ve = 20, me = 268435456, be = /* @__PURE__ */ new WeakMap();
                function pe(ye, Se) {
                  if (Se == null)
                    return Se;
                  if (_$_b839[34] == typeof Se)
                    return Se[_$_b839[125]]()[_$_b839[30]](/\n|\s\s/g, _$_b839[90]);
                  if (Se instanceof ArrayBuffer)
                    return String[_$_b839[2490]][_$_b839[35]](null, new Uint8Array(Se[_$_b839[74]](0, ve)));
                  if (Se instanceof Uint8Array)
                    return String[_$_b839[2490]][_$_b839[35]](null, Se[_$_b839[74]](0, ve));
                  if (_$_b839[33] == typeof Se && !Array[_$_b839[254]](Se)) {
                    if (be[_$_b839[152]](Se)) {
                      var we = JSON[_$_b839[282]](Object[_$_b839[98]](Se), pe);
                      return _$_b839[2846][_$_b839[41]](Math[_$_b839[1268]](ce[_$_b839[1869]](we))[_$_b839[125]](ge), _$_b839[2845]);
                    }
                    be[_$_b839[1045]](Se, !0);
                  }
                  return Se;
                }
                var $e = JSON[_$_b839[282]](he, pe);
                return (Math[_$_b839[1268]](ce[_$_b839[1869]]($e)) | me)[_$_b839[125]](ge);
              }, ce[_$_b839[2009]] = function(he, ge) {
                var ve = Math[_$_b839[239]](10, ge);
                return Math[_$_b839[273]](he * ve) / ve;
              }, ce[_$_b839[2847]] = function(he, ge, ve) {
                var me = ie([], he, !0), be = me[ge];
                return me[_$_b839[130]](ge, 1), me[_$_b839[130]](ve, 0, be), me;
              }, ce[_$_b839[2831]] = null, ce[_$_b839[2842]] = /(?:Z|[+-](?:2[0-3]|[01][0-9]):[0-5][0-9])$/, ce;
            }();
            function se(ce) {
              if (!ce)
                return 0;
              var he;
              if ((ce = String(ce)[_$_b839[30]](_$_b839[355], _$_b839[81]))[_$_b839[29]](_$_b839[366]) > -1)
                he = ce[_$_b839[124]](_$_b839[366]);
              else {
                if (!(ce[_$_b839[29]](_$_b839[359]) > -1))
                  return isNaN(parseFloat(ce)) ? 0 : parseFloat(ce);
                he = ce[_$_b839[124]](_$_b839[359]);
              }
              if (he && Array[_$_b839[254]](he) && he[_$_b839[26]] > 1) {
                var ge = parseFloat(he[0]) / parseFloat(he[1]);
                return isNaN(ge) ? 0 : ge;
              }
              return 0;
            }
            function oe(ce) {
              return ce[_$_b839[112]](function(he, ge, ve) {
                return ge === ve[_$_b839[1888]](function(me) {
                  return le[_$_b839[1935]](me, he);
                });
              });
            }
            te[_$_b839[1022]] = le;
          }, 87093: function(re, te) {
            _$_b839[32];
            var ee;
            function ie(_e) {
              return _$_b839[2848] in _e && _e[_$_b839[2848]] === Math;
            }
            function ne() {
              return _$_b839[33] == typeof window && window && ie(window) ? window : void 0;
            }
            function ae() {
              return _$_b839[33] == typeof self && self && ie(self) ? self : void 0;
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 });
            var ue = (ee = ne()) !== null && ee !== void 0 ? ee : ae();
            te[_$_b839[107]] = ue;
          }, 26905: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2849]] = ue;
            var ie = ee(11399), ne = ee(13533), ae = ee(56435);
            function ue() {
              var _e = (0, ne[_$_b839[646]])();
              return _e[_$_b839[1469]] ? _e[ie[_$_b839[1013]][_$_b839[2236]]] === ae[_$_b839[2726]] : _e[_$_b839[2219]];
            }
          }, 39999: function(re, te) {
            _$_b839[32];
            function ee(ie, ne) {
              var ae = [_$_b839[656], _$_b839[1657], _$_b839[1658], _$_b839[1866]], ue = function() {
                return ne(ie[_$_b839[1139]], ie[_$_b839[1140]]);
              }, _e = new MutationObserver(ue);
              return { observe: function() {
                _e[_$_b839[2850]](ie, { attributes: !0, attributeFilter: ae, childList: !1, subtree: !0 }), window[_$_b839[76]](_$_b839[2851], ue);
              }, dispose: function() {
                _e[_$_b839[2852]](), window[_$_b839[78]](_$_b839[2851], ue);
              } };
            }
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2853]] = ee;
          }, 13547: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[782]] = void 0;
            var ie = ee(60997), ne = ee(62510), ae = ee(33696), ue = ee(17990), _e = ee(58975), fe = ee(3464), le = ee(46462), se = ee(39999), oe = _$_b839[2854], ce = _$_b839[2855], he = [_$_b839[90], _$_b839[2856], _$_b839[2857], _$_b839[1344], _$_b839[2858]], ge = [_$_b839[2859], _$_b839[2860], _$_b839[2861], _$_b839[2862], _$_b839[2863]], ve = function() {
              function pe($e, ye, Se, we) {
                var Pe = this;
                this[_$_b839[619]] = $e, this[_$_b839[675]] = ye, this[_$_b839[2864]] = Se, this[_$_b839[642]] = we, this[_$_b839[2865]] = !1, this[_$_b839[1657]] = 0, this[_$_b839[1658]] = 0, this[_$_b839[1491]] = function(Te) {
                  return Pe[_$_b839[619]][_$_b839[91]][_$_b839[731]][_$_b839[138]](Te);
                }, this[_$_b839[2866]] = function(Te, Ee) {
                  Te === Pe[_$_b839[1657]] && Ee === Pe[_$_b839[1658]] || (Pe[_$_b839[1657]] = Te, Pe[_$_b839[1658]] = Ee, Pe[_$_b839[2864]](ne[_$_b839[382]][_$_b839[405]], { width: _$_b839[90][_$_b839[41]](Pe[_$_b839[1657]], _$_b839[1661]), height: _$_b839[90][_$_b839[41]](Pe[_$_b839[1658]], _$_b839[1661]) }), Pe[_$_b839[619]][_$_b839[736]] && _$_b839[34] == typeof Pe[_$_b839[619]][_$_b839[736]][_$_b839[2867]] && Pe[_$_b839[619]][_$_b839[736]][_$_b839[2867]](Pe[_$_b839[1657]], Pe[_$_b839[1658]]));
                }, this[_$_b839[2868]] = function(Te, Ee) {
                  var Me = { from: Ee[_$_b839[1182]], to: Te[_$_b839[1182]], legacy: Pe[_$_b839[642]]() };
                  Pe[_$_b839[2869]]() && (Te[_$_b839[1182]] === ae[_$_b839[1018]][_$_b839[1184]] ? (Pe[_$_b839[619]][_$_b839[620]][_$_b839[1180]](Me), Pe[_$_b839[1657]] = 0, Pe[_$_b839[1658]] = 0) : Ee[_$_b839[1182]] === ae[_$_b839[1018]][_$_b839[1184]] && Pe[_$_b839[619]][_$_b839[620]][_$_b839[1181]]()), Pe[_$_b839[2864]](ne[_$_b839[382]][_$_b839[530]], Me);
                }, this[_$_b839[2870]] = function() {
                  Pe[_$_b839[1491]]((0, ue[_$_b839[2308]])(ae[_$_b839[1018]][_$_b839[1400]]));
                }, this[_$_b839[2871]] = function() {
                  Pe[_$_b839[1491]]((0, ue[_$_b839[2308]])(ae[_$_b839[1018]][_$_b839[1017]]));
                }, this[_$_b839[2872]] = function(Te) {
                  if (Pe[_$_b839[1016]]() && Te[_$_b839[65]] === Pe[_$_b839[2873]])
                    return Pe[_$_b839[2873]] = void 0, void Pe[_$_b839[1181]]();
                  !Pe[_$_b839[2865]] && !Pe[_$_b839[2874]]() || Pe[_$_b839[2873]] || (Pe[_$_b839[2873]] = Te[_$_b839[65]], Pe[_$_b839[1180]]());
                }, this[_$_b839[2875]] = (0, se[_$_b839[2853]])(this[_$_b839[619]][_$_b839[675]], this[_$_b839[2866]]), this[_$_b839[2875]][_$_b839[2850]](), this[_$_b839[2876]](), this[_$_b839[2877]](), this[_$_b839[2878]]();
              }
              return pe[_$_b839[37]][_$_b839[2876]] = function() {
                this[_$_b839[2879]] = (0, fe[_$_b839[789]])(this[_$_b839[619]][_$_b839[91]][_$_b839[731]])(function($e) {
                  return (0, _e[_$_b839[787]])($e);
                }, this[_$_b839[2868]], function($e, ye) {
                  return $e[_$_b839[1182]] !== ye[_$_b839[1182]];
                });
              }, pe[_$_b839[37]][_$_b839[1101]] = function() {
                return (0, _e[_$_b839[787]])(this[_$_b839[619]][_$_b839[91]][_$_b839[731]][_$_b839[136]]())[_$_b839[1182]];
              }, pe[_$_b839[37]][_$_b839[2877]] = function() {
                var $e = this;
                ge[_$_b839[113]](function(ye) {
                  return document[_$_b839[76]](ye, $e[_$_b839[2872]]);
                }), this[_$_b839[2874]]() && (this[_$_b839[1491]]((0, ue[_$_b839[2308]])(ae[_$_b839[1018]][_$_b839[1184]])), this[_$_b839[2880]](!0));
              }, pe[_$_b839[37]][_$_b839[2878]] = function() {
                this[_$_b839[619]][_$_b839[655]] && (this[_$_b839[619]][_$_b839[655]][_$_b839[76]](le[_$_b839[1370]][_$_b839[2881]], this[_$_b839[2870]]), this[_$_b839[619]][_$_b839[655]][_$_b839[76]](le[_$_b839[1370]][_$_b839[2882]], this[_$_b839[2871]]));
              }, pe[_$_b839[37]][_$_b839[2869]] = function() {
                return !!this[_$_b839[619]] && !!this[_$_b839[619]][_$_b839[620]];
              }, pe[_$_b839[37]][_$_b839[2883]] = function() {
                return this[_$_b839[2869]]() && !!this[_$_b839[619]][_$_b839[655]] && this[_$_b839[619]][_$_b839[655]][_$_b839[2883]]();
              }, pe[_$_b839[37]][_$_b839[876]] = function() {
                return this[_$_b839[619]][_$_b839[655]][_$_b839[876]]();
              }, pe[_$_b839[37]][_$_b839[1183]] = function($e) {
                return $e === ae[_$_b839[1018]][_$_b839[1400]] ? this[_$_b839[2883]]() : [ae[_$_b839[1018]][_$_b839[1184]], ae[_$_b839[1018]][_$_b839[1017]]][_$_b839[815]]($e);
              }, pe[_$_b839[37]][_$_b839[2884]] = function() {
                this[_$_b839[2869]]() && this[_$_b839[619]][_$_b839[655]] && (this[_$_b839[619]][_$_b839[655]][_$_b839[2884]](), this[_$_b839[1491]]((0, ue[_$_b839[2308]])(ae[_$_b839[1018]][_$_b839[1017]])));
              }, pe[_$_b839[37]][_$_b839[2885]] = function() {
                var $e;
                ($e = this[_$_b839[619]][_$_b839[655]]) === null || $e === void 0 || $e[_$_b839[2885]](), this[_$_b839[1491]]((0, ue[_$_b839[2308]])(ae[_$_b839[1018]][_$_b839[1400]]));
              }, pe[_$_b839[37]][_$_b839[2874]] = function() {
                var $e = be();
                return $e && this[_$_b839[619]][_$_b839[655]][_$_b839[769]]() === $e;
              }, pe[_$_b839[37]][_$_b839[2886]] = function() {
                return this[_$_b839[642]]() ? _$_b839[2887] : _$_b839[2888];
              }, pe[_$_b839[37]][_$_b839[2880]] = function($e) {
                var ye = this[_$_b839[2886]]();
                this[_$_b839[675]][_$_b839[1148]](ye, String($e));
              }, pe[_$_b839[37]][_$_b839[1180]] = function() {
                this[_$_b839[2880]](!0), this[_$_b839[2865]] = !1, this[_$_b839[1491]]((0, ue[_$_b839[2308]])(ae[_$_b839[1018]][_$_b839[1184]]));
              }, pe[_$_b839[37]][_$_b839[1181]] = function() {
                this[_$_b839[2880]](!1), this[_$_b839[2865]] = !1, this[_$_b839[1101]]() === ae[_$_b839[1018]][_$_b839[1184]] && this[_$_b839[1491]]((0, ue[_$_b839[2308]])(ae[_$_b839[1018]][_$_b839[1017]]));
              }, pe[_$_b839[37]][_$_b839[1016]] = function() {
                return this[_$_b839[1101]]() === ae[_$_b839[1018]][_$_b839[1184]] || _$_b839[2889] === this[_$_b839[675]][_$_b839[2655]](this[_$_b839[2886]]());
              }, pe[_$_b839[37]][_$_b839[2890]] = function($e) {
                if ($e === void 0 && ($e = this[_$_b839[675]]), be())
                  this[_$_b839[619]][_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[2891]);
                else if (this[_$_b839[642]]())
                  this[_$_b839[1180]]();
                else {
                  var ye = me($e, oe);
                  ye ? this[_$_b839[2865]] = !0 : !ye && this[_$_b839[619]][_$_b839[655]][_$_b839[2892]] && (this[_$_b839[2865]] = !0, this[_$_b839[619]][_$_b839[655]][_$_b839[2892]]());
                }
              }, pe[_$_b839[37]][_$_b839[2855]] = function() {
                if (this[_$_b839[642]]())
                  this[_$_b839[1181]]();
                else {
                  var $e = me(window[_$_b839[4]], ce);
                  $e ? this[_$_b839[2865]] = !0 : !$e && this[_$_b839[619]][_$_b839[655]][_$_b839[2893]] && (this[_$_b839[2865]] = !0, this[_$_b839[619]][_$_b839[655]][_$_b839[2893]]());
                }
              }, pe[_$_b839[37]][_$_b839[2894]] = function() {
                var $e = this[_$_b839[1101]]();
                this[_$_b839[1016]]() ? this[_$_b839[2855]]() : ($e === ae[_$_b839[1018]][_$_b839[1400]] || this[_$_b839[876]]()) && this[_$_b839[2884]]();
              }, pe[_$_b839[37]][_$_b839[2895]] = function($e, ye) {
                $e !== ae[_$_b839[1018]][_$_b839[1184]] ? $e === ae[_$_b839[1018]][_$_b839[1400]] && this[_$_b839[2885]]() : this[_$_b839[2890]](ye[_$_b839[2837]]);
              }, pe[_$_b839[37]][_$_b839[1019]] = function($e, ye) {
                ye === void 0 && (ye = {}), $e !== this[_$_b839[1101]]() && (this[_$_b839[2894]](), this[_$_b839[1183]]($e) && this[_$_b839[2895]]($e, ye));
              }, pe[_$_b839[37]][_$_b839[340]] = function() {
                var $e, ye, Se = this;
                this[_$_b839[2875]] = (0, ie[_$_b839[340]])(this[_$_b839[2875]]), ge[_$_b839[113]](function(we) {
                  return document[_$_b839[78]](we, Se[_$_b839[2872]]);
                }), ($e = this[_$_b839[619]][_$_b839[655]]) === null || $e === void 0 || $e[_$_b839[78]](le[_$_b839[1370]][_$_b839[2881]], this[_$_b839[2870]]), (ye = this[_$_b839[619]][_$_b839[655]]) === null || ye === void 0 || ye[_$_b839[78]](le[_$_b839[1370]][_$_b839[2882]], this[_$_b839[2871]]), this[_$_b839[2879]]();
              }, pe;
            }();
            function me(pe, $e) {
              return he[_$_b839[862]](function(ye) {
                var Se = $e;
                return _$_b839[90] !== ye && (Se = _$_b839[90][_$_b839[41]](ye)[_$_b839[41]]($e[_$_b839[25]](0, 1)[_$_b839[1609]]())[_$_b839[41]]($e[_$_b839[25]](1))), _$_b839[34] == typeof pe[Se] && (pe[Se](), !0);
              });
            }
            function be() {
              var pe, $e, ye;
              return (ye = ($e = (pe = document[_$_b839[2837]]) !== null && pe !== void 0 ? pe : document[_$_b839[2839]]) !== null && $e !== void 0 ? $e : document[_$_b839[2838]]) !== null && ye !== void 0 ? ye : null;
            }
            te[_$_b839[782]] = ve;
          }, 46462: function(re, te) {
            _$_b839[32];
            var ee;
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[1370]] = void 0, function(ie) {
              ie[_$_b839[1970]] = _$_b839[1970], ie[_$_b839[1369]] = _$_b839[1369], ie[_$_b839[2896]] = _$_b839[2896], ie[_$_b839[2897]] = _$_b839[2897], ie[_$_b839[2898]] = _$_b839[2898], ie[_$_b839[2899]] = _$_b839[2899], ie[_$_b839[1559]] = _$_b839[1559], ie[_$_b839[73]] = _$_b839[73], ie[_$_b839[2900]] = _$_b839[2900], ie[_$_b839[2901]] = _$_b839[2901], ie[_$_b839[2090]] = _$_b839[2090], ie[_$_b839[910]] = _$_b839[910], ie[_$_b839[386]] = _$_b839[386], ie[_$_b839[388]] = _$_b839[388], ie[_$_b839[2092]] = _$_b839[2092], ie[_$_b839[2902]] = _$_b839[2902], ie[_$_b839[394]] = _$_b839[394], ie[_$_b839[2903]] = _$_b839[2903], ie[_$_b839[2904]] = _$_b839[2904], ie[_$_b839[1613]] = _$_b839[1613], ie[_$_b839[2905]] = _$_b839[2905], ie[_$_b839[2906]] = _$_b839[2906], ie[_$_b839[2907]] = _$_b839[2907], ie[_$_b839[2908]] = _$_b839[2908], ie[_$_b839[2909]] = _$_b839[2909], ie[_$_b839[2910]] = _$_b839[2910], ie[_$_b839[2911]] = _$_b839[2911], ie[_$_b839[2881]] = _$_b839[2881], ie[_$_b839[2882]] = _$_b839[2882], ie[_$_b839[2912]] = _$_b839[2912], ie[_$_b839[2913]] = _$_b839[2913], ie[_$_b839[2914]] = _$_b839[2914], ie[_$_b839[2915]] = _$_b839[2915], ie[_$_b839[2916]] = _$_b839[2916], ie[_$_b839[2917]] = _$_b839[2917], ie[_$_b839[2918]] = _$_b839[2918];
            }(ee || (te[_$_b839[1370]] = ee = {}));
          }, 1480: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2919]] = void 0;
            var ie = ee(58935), ne = ee(54838), ae = ee(46462), ue = 1e8, _e = function() {
              function le(se, oe) {
                var ce = this;
                this[_$_b839[2920]] = function(he) {
                  if (ce[_$_b839[2921]](he[_$_b839[65]], he), !ce[_$_b839[2922]](he)) {
                    if (ce[_$_b839[1365]][_$_b839[73]]) {
                      he[_$_b839[1818]] = { code: ce[_$_b839[1365]][_$_b839[73]][_$_b839[1028]] };
                      var ge = le[_$_b839[2923]](ce[_$_b839[1365]][_$_b839[73]][_$_b839[1028]]);
                      ge && (he[_$_b839[1818]][_$_b839[2924]] = ge), _$_b839[2925] in ce[_$_b839[1365]][_$_b839[73]] && ce[_$_b839[1365]][_$_b839[73]][_$_b839[2925]] && (he[_$_b839[1818]][_$_b839[2926]] = ce[_$_b839[1365]][_$_b839[73]][_$_b839[2925]][_$_b839[125]](16)), ce[_$_b839[1365]][_$_b839[73]][_$_b839[89]] && (he[_$_b839[1818]][_$_b839[89]] = ce[_$_b839[1365]][_$_b839[73]][_$_b839[89]]), he[_$_b839[1119]] = Object[_$_b839[98]](he[_$_b839[1818]])[_$_b839[137]](function(ve) {
                        return ve + _$_b839[1118] + he[_$_b839[1818]][ve];
                      })[_$_b839[123]](_$_b839[1340]);
                    } else
                      he[_$_b839[1119]] = _$_b839[2927];
                    ce[_$_b839[2928]](he);
                  }
                }, this[_$_b839[2929]] = function(he) {
                  ce[_$_b839[2921]](he[_$_b839[65]]), ce[_$_b839[2922]](he) || ce[_$_b839[2928]](he);
                }, this[_$_b839[91]] = se, this[_$_b839[1365]] = oe, this[_$_b839[2930]] = {}, this[_$_b839[2931]] = {}, this[_$_b839[2932]] = [], this[_$_b839[2933]] = !1, this[_$_b839[2934]] = !1, this[_$_b839[2935]]();
              }
              return Object[_$_b839[82]](le[_$_b839[37]], _$_b839[632], { get: function() {
                return this[_$_b839[2933]];
              }, set: function(se) {
                this[_$_b839[2933]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2936], { get: function() {
                return this[_$_b839[2934]];
              }, set: function(se) {
                this[_$_b839[2934]] = se;
              }, enumerable: !1, configurable: !0 }), le[_$_b839[37]][_$_b839[2937]] = function(se, oe, ce) {
                var he = this;
                if (oe === void 0 && (oe = ue), this[_$_b839[2931]][se] = this[_$_b839[2931]][se] || 0, this[_$_b839[2931]][se] += oe, ce && ce > 0) {
                  var ge = window[_$_b839[1159]](function() {
                    he[_$_b839[2931]][se] = Math[_$_b839[248]](he[_$_b839[2931]][se] - oe, 0), he[_$_b839[2932]][_$_b839[130]](he[_$_b839[2932]][_$_b839[29]](ge), 1);
                  }, ce);
                  this[_$_b839[2932]][_$_b839[57]](ge);
                }
              }, le[_$_b839[37]][_$_b839[2938]] = function(se) {
                this[_$_b839[2931]][se] && (this[_$_b839[2931]][se] = 0);
              }, le[_$_b839[37]][_$_b839[2939]] = function() {
                var se = this;
                Object[_$_b839[98]](this[_$_b839[2931]])[_$_b839[113]](function(oe) {
                  return se[_$_b839[2938]](oe);
                }), this[_$_b839[2932]][_$_b839[113]](function(oe) {
                  return window[_$_b839[2940]](oe);
                });
              }, le[_$_b839[37]][_$_b839[1797]] = function(se, oe) {
                oe === void 0 && (oe = { type: se }), se === ae[_$_b839[1370]][_$_b839[73]] ? this[_$_b839[2920]](oe) : this[_$_b839[2929]](oe);
              }, le[_$_b839[37]][_$_b839[2935]] = function() {
                var se = this;
                Object[_$_b839[98]](ae[_$_b839[1370]])[_$_b839[113]](function(oe) {
                  oe === ae[_$_b839[1370]][_$_b839[73]] ? se[_$_b839[1365]][_$_b839[76]](ae[_$_b839[1370]][_$_b839[73]], se[_$_b839[2920]]) : se[_$_b839[1365]][_$_b839[76]](oe, se[_$_b839[2929]]);
                });
              }, le[_$_b839[37]][_$_b839[2941]] = function() {
                var se = this;
                Object[_$_b839[98]](ae[_$_b839[1370]])[_$_b839[113]](function(oe) {
                  se[_$_b839[1365]][_$_b839[78]](oe, se[_$_b839[2929]]);
                }), this[_$_b839[1365]][_$_b839[78]](ae[_$_b839[1370]][_$_b839[73]], this[_$_b839[2920]]);
              }, le[_$_b839[37]][_$_b839[2922]] = function(se) {
                return !!this[_$_b839[632]] || !(!this[_$_b839[2936]] || !le[_$_b839[2942]][_$_b839[815]](se[_$_b839[65]])) || this[_$_b839[2931]][se[_$_b839[65]]] > 0 && (this[_$_b839[2931]][se[_$_b839[65]]]--, !0);
              }, le[_$_b839[37]][_$_b839[2921]] = function(se, oe) {
                var ce, he;
                if (!((he = (ce = this[_$_b839[91]]) === null || ce === void 0 ? void 0 : ce[_$_b839[280]]) === null || he === void 0) && he[_$_b839[1233]](ie[_$_b839[1222]][_$_b839[1225]])) {
                  var ge = this[_$_b839[91]][_$_b839[280]], ve = _$_b839[2943][_$_b839[41]](se);
                  this[_$_b839[91]][_$_b839[809]][_$_b839[2944]] ? oe ? ge[_$_b839[265]](ve, oe) : ge[_$_b839[265]](ve) : ge[_$_b839[1233]](ie[_$_b839[1222]][_$_b839[1224]]) && (oe ? ge[_$_b839[1162]](ve, oe) : ge[_$_b839[1162]](ve));
                }
              }, le[_$_b839[37]][_$_b839[2928]] = function(se) {
                var oe = this;
                this[_$_b839[2930]][se[_$_b839[65]]] && this[_$_b839[2930]][se[_$_b839[65]]][_$_b839[113]](function(ce) {
                  oe[_$_b839[2945]](ce, se);
                });
              }, le[_$_b839[37]][_$_b839[2945]] = function(se, oe) {
                var ce = se[_$_b839[2946]] ? se[_$_b839[2946]](oe) : oe;
                se[_$_b839[626]][_$_b839[2947]] ? se[_$_b839[626]][_$_b839[2947]](ce) : _$_b839[34] == typeof se[_$_b839[626]] ? se[_$_b839[626]](ce) : this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[2948] + oe[_$_b839[65]] + _$_b839[1118], se[_$_b839[626]]);
              }, le[_$_b839[37]][_$_b839[76]] = function(se, oe, ce) {
                this[_$_b839[2930]][se] = this[_$_b839[2930]][se] || [], this[_$_b839[2930]][se][_$_b839[57]](new fe(oe, ce));
              }, le[_$_b839[37]][_$_b839[2949]] = function(se, oe) {
                return !!this[_$_b839[2930]][se] && this[_$_b839[2930]][se][_$_b839[824]](function(ce) {
                  return ce[_$_b839[626]] === oe;
                }) != null;
              }, le[_$_b839[37]][_$_b839[78]] = function(se, oe) {
                this[_$_b839[2930]][se] && (this[_$_b839[2930]][se] = this[_$_b839[2930]][se][_$_b839[112]](function(ce) {
                  return ce[_$_b839[626]] !== oe;
                }));
              }, le[_$_b839[37]][_$_b839[706]] = function() {
                this[_$_b839[2939]]();
              }, le[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[706]](), this[_$_b839[2941]](), this[_$_b839[2930]] = null;
              }, le[_$_b839[2923]] = function(se) {
                if (MediaError) {
                  for (var oe in MediaError)
                    if (oe[_$_b839[29]](_$_b839[2950]) > -1 && MediaError[oe] === se)
                      return oe;
                }
                return null;
              }, le[_$_b839[2942]] = [ae[_$_b839[1370]][_$_b839[386]], ae[_$_b839[1370]][_$_b839[388]], ae[_$_b839[1370]][_$_b839[910]], ae[_$_b839[1370]][_$_b839[2905]]], le;
            }();
            te[_$_b839[2919]] = _e;
            var fe = function() {
              function le(se, oe) {
                this[_$_b839[626]] = se, oe && ne[_$_b839[1022]][_$_b839[1122]](oe) && (this[_$_b839[2946]] = oe);
              }
              return le;
            }();
          }, 30573: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2832]] = void 0;
            var ie = ee(60997), ne = ee(1356), ae = ee(46462), ue = ee(1480), _e = ee(11419), fe = function() {
              function le(se, oe) {
                this[_$_b839[1365]] = oe, this[_$_b839[91]] = se, this[_$_b839[2951]] = new ue[_$_b839[2919]](se, oe), this[_$_b839[2952]] = new _e[_$_b839[2953]](se, this), this[_$_b839[1353]] = null;
              }
              return Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2954], { get: function() {
                return this[_$_b839[1365]][_$_b839[2954]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[274], { get: function() {
                return this[_$_b839[1365]][_$_b839[274]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2955], { get: function() {
                return this[_$_b839[1365]][_$_b839[2955]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1341], { get: function() {
                return this[_$_b839[1365]][_$_b839[1341]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1559], { get: function() {
                return this[_$_b839[1365]][_$_b839[1559]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[73], { get: function() {
                return this[_$_b839[1365]][_$_b839[73]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2956], { get: function() {
                return this[_$_b839[1365]][_$_b839[2956]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2957], { get: function() {
                return this[_$_b839[1365]][_$_b839[2957]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[390], { get: function() {
                return this[_$_b839[1365]][_$_b839[390]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2958], { get: function() {
                return this[_$_b839[1365]][_$_b839[2958]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2959], { get: function() {
                return this[_$_b839[1365]][_$_b839[2959]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1368], { get: function() {
                return this[_$_b839[1365]][_$_b839[1368]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2960], { get: function() {
                return this[_$_b839[1365]][_$_b839[2960]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2903], { get: function() {
                return this[_$_b839[1365]][_$_b839[2903]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[656], { get: function() {
                return this[_$_b839[1365]] && this[_$_b839[1365]][_$_b839[656]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2961], { get: function() {
                return this[_$_b839[1365]][_$_b839[2961]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2962], { get: function() {
                return this[_$_b839[1365]][_$_b839[2962]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1625], { get: function() {
                return this[_$_b839[1365]][_$_b839[1625]];
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1157], { get: function() {
                return this[_$_b839[1365]][_$_b839[1157]];
              }, set: function(se) {
                this[_$_b839[1365]][_$_b839[1157]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2963], { get: function() {
                return this[_$_b839[1365]][_$_b839[2963]];
              }, set: function(se) {
                this[_$_b839[1365]][_$_b839[2963]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2964], { get: function() {
                return this[_$_b839[1365]][_$_b839[2964]];
              }, set: function(se) {
                this[_$_b839[1365]][_$_b839[2964]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[1554], { get: function() {
                var se, oe;
                return (oe = (se = this[_$_b839[1365]]) === null || se === void 0 ? void 0 : se[_$_b839[1554]]) !== null && oe !== void 0 ? oe : 0;
              }, set: function(se) {
                this[_$_b839[1365]][_$_b839[1554]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2965], { get: function() {
                return this[_$_b839[1365]][_$_b839[2965]];
              }, set: function(se) {
                this[_$_b839[1365]][_$_b839[2965]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[402], { get: function() {
                return this[_$_b839[1365]] && this[_$_b839[1365]][_$_b839[402]];
              }, set: function(se) {
                this[_$_b839[2952]][_$_b839[2966]][_$_b839[402]] = se, this[_$_b839[1365]][_$_b839[402]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[828], { get: function() {
                return this[_$_b839[1365]][_$_b839[828]];
              }, set: function(se) {
                this[_$_b839[1365]][_$_b839[828]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[368], { get: function() {
                return this[_$_b839[1365]][_$_b839[368]];
              }, set: function(se) {
                this[_$_b839[2952]][_$_b839[706]](), this[_$_b839[1365]][_$_b839[368]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2967], { get: function() {
                return this[_$_b839[1365]][_$_b839[2967]];
              }, set: function(se) {
                this[_$_b839[2952]][_$_b839[706]](), this[_$_b839[1365]][_$_b839[2967]] = se;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[2968], { get: function() {
                return this[_$_b839[1365]][_$_b839[2968]];
              }, set: function(se) {
                try {
                  this[_$_b839[1365]][_$_b839[2968]] = se;
                } catch {
                  this[_$_b839[91]][_$_b839[280]][_$_b839[998]](_$_b839[2969] + se);
                }
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](le[_$_b839[37]], _$_b839[837], { get: function() {
                return this[_$_b839[1365]][_$_b839[837]];
              }, set: function(se) {
                this[_$_b839[2952]][_$_b839[2966]][_$_b839[837]] = se, this[_$_b839[1365]][_$_b839[837]] = se;
              }, enumerable: !1, configurable: !0 }), le[_$_b839[37]][_$_b839[2970]] = function(se, oe, ce) {
                return this[_$_b839[1365]][_$_b839[2970]](se, oe, ce);
              }, le[_$_b839[37]][_$_b839[2531]] = function(se, oe) {
                return this[_$_b839[1365]][_$_b839[2531]](se, oe);
              }, le[_$_b839[37]][_$_b839[1040]] = function() {
                this[_$_b839[1365]][_$_b839[1040]]();
              }, le[_$_b839[37]][_$_b839[910]] = function() {
                this[_$_b839[1365]] && this[_$_b839[1365]][_$_b839[910]]();
              }, le[_$_b839[37]][_$_b839[386]] = function() {
                return this[_$_b839[2971]]();
              }, le[_$_b839[37]][_$_b839[2971]] = function() {
                return this[_$_b839[1365]][_$_b839[386]]() || ne[_$_b839[1350]][_$_b839[1373]](this[_$_b839[91]], this, this[_$_b839[1353]]);
              }, le[_$_b839[37]][_$_b839[2972]] = function() {
                var se = this, oe = function(ce) {
                  se[_$_b839[2951]] && (se[_$_b839[2951]][_$_b839[2936]] = ce);
                };
                return oe(!0), this[_$_b839[2951]][_$_b839[1797]](ae[_$_b839[1370]][_$_b839[2910]]), this[_$_b839[2973]]()[_$_b839[166]](function() {
                  oe(!1);
                });
              }, le[_$_b839[37]][_$_b839[2973]] = function() {
                this[_$_b839[2971]]()[_$_b839[904]](function() {
                }), this[_$_b839[910]]();
                var se = this[_$_b839[769]]();
                return new Promise(function(oe) {
                  var ce = setTimeout(function() {
                    se[_$_b839[78]](ae[_$_b839[1370]][_$_b839[910]], he), oe();
                  }, 100), he = function() {
                    clearTimeout(ce), se[_$_b839[78]](ae[_$_b839[1370]][_$_b839[910]], he), oe();
                  };
                  se[_$_b839[76]](ae[_$_b839[1370]][_$_b839[910]], he);
                });
              }, le[_$_b839[37]][_$_b839[2974]] = function(se) {
                return this[_$_b839[1365]] && this[_$_b839[1365]][_$_b839[2974]](se) || Promise[_$_b839[602]]();
              }, le[_$_b839[37]][_$_b839[2975]] = function(se) {
                return this[_$_b839[1365]] && this[_$_b839[1365]][_$_b839[2975]](se);
              }, le[_$_b839[37]][_$_b839[2976]] = function(se) {
                this[_$_b839[1365]][_$_b839[2976]](se);
              }, le[_$_b839[37]][_$_b839[2655]] = function(se) {
                return this[_$_b839[1365]][_$_b839[2655]](se);
              }, le[_$_b839[37]][_$_b839[1148]] = function(se, oe) {
                this[_$_b839[1365]][_$_b839[1148]](se, oe);
              }, le[_$_b839[37]][_$_b839[1624]] = function(se) {
                this[_$_b839[1365]][_$_b839[1624]](se);
              }, le[_$_b839[37]][_$_b839[377]] = function(se) {
                return this[_$_b839[1365]][_$_b839[377]](se);
              }, le[_$_b839[37]][_$_b839[1023]] = function(se) {
                this[_$_b839[1365]][_$_b839[1023]](se);
              }, le[_$_b839[37]][_$_b839[926]] = function(se) {
                return this[_$_b839[1365]][_$_b839[926]](se);
              }, le[_$_b839[37]][_$_b839[371]] = function(se) {
                return this[_$_b839[1365]][_$_b839[371]](se);
              }, le[_$_b839[37]][_$_b839[76]] = function(se, oe, ce) {
                this[_$_b839[2951]][_$_b839[76]](se, oe, ce);
              }, le[_$_b839[37]][_$_b839[78]] = function(se, oe) {
                this[_$_b839[2951]] && this[_$_b839[2951]][_$_b839[78]](se, oe);
              }, Object[_$_b839[82]](le[_$_b839[37]], _$_b839[626], { get: function() {
                return this[_$_b839[2951]];
              }, enumerable: !1, configurable: !0 }), le[_$_b839[37]][_$_b839[769]] = function() {
                return this[_$_b839[1365]];
              }, le[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[2951]] = (0, ie[_$_b839[340]])(this[_$_b839[2951]]), this[_$_b839[2952]] = (0, ie[_$_b839[340]])(this[_$_b839[2952]]), this[_$_b839[1353]] = null, this[_$_b839[1365]] = null, this[_$_b839[91]][_$_b839[280]] && this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[2977]);
              }, le;
            }();
            te[_$_b839[2832]] = fe;
          }, 11419: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2953]] = void 0;
            var ie = ee(18665), ne = ee(62510), ae = ee(27177), ue = ee(46462), _e = function() {
              function fe(le, se) {
                var oe, ce, he, ge, ve, me, be = this;
                this[_$_b839[91]] = le, this[_$_b839[832]] = function() {
                  var pe = be[_$_b839[1365]][_$_b839[837]], $e = be[_$_b839[1365]][_$_b839[402]];
                  be[_$_b839[2966]][_$_b839[402]] !== $e && ($e ? be[_$_b839[2979]](ne[_$_b839[382]][_$_b839[401]], { issuer: _$_b839[2978] }) : be[_$_b839[2979]](ne[_$_b839[382]][_$_b839[403]], { issuer: _$_b839[2978] }), be[_$_b839[2966]][_$_b839[402]] = $e), be[_$_b839[2966]][_$_b839[837]] !== pe && (be[_$_b839[2979]](ne[_$_b839[382]][_$_b839[399]], { issuer: _$_b839[2978], targetVolume: 100 * pe, sourceVolume: 100 * be[_$_b839[2966]][_$_b839[837]] }), be[_$_b839[2966]][_$_b839[837]] = pe);
                }, this[_$_b839[2980]] = function() {
                  var pe = be[_$_b839[1365]][_$_b839[2968]];
                  be[_$_b839[91]][_$_b839[635]][_$_b839[639]](ie[_$_b839[637]][_$_b839[893]], function($e) {
                    $e[_$_b839[914]] !== pe && $e[_$_b839[915]](pe);
                  });
                }, this[_$_b839[2981]] = function() {
                  be[_$_b839[2966]][_$_b839[2982]] || (be[_$_b839[2966]][_$_b839[2982]] = !0, be[_$_b839[2979]](ne[_$_b839[382]][_$_b839[383]]));
                }, this[_$_b839[1365]] = se, this[_$_b839[2966]] = { muted: (he = (ce = (oe = le[_$_b839[1435]]) === null || oe === void 0 ? void 0 : oe[_$_b839[666]]) === null || ce === void 0 ? void 0 : ce[_$_b839[402]]) !== null && he !== void 0 ? he : se[_$_b839[402]], volume: (me = (ve = (ge = le[_$_b839[1435]]) === null || ge === void 0 ? void 0 : ge[_$_b839[666]]) === null || ve === void 0 ? void 0 : ve[_$_b839[837]]) !== null && me !== void 0 ? me : se[_$_b839[837]], playbackRate: se[_$_b839[2968]], canPlay: !1 }, this[_$_b839[2983]]();
              }
              return fe[_$_b839[37]][_$_b839[2983]] = function() {
                this[_$_b839[1365]][_$_b839[76]](ue[_$_b839[1370]][_$_b839[2906]], this[_$_b839[832]]), this[_$_b839[1365]][_$_b839[76]](ue[_$_b839[1370]][_$_b839[1369]], this[_$_b839[2981]]), this[_$_b839[1365]][_$_b839[76]](ue[_$_b839[1370]][_$_b839[2902]], this[_$_b839[2980]]);
              }, fe[_$_b839[37]][_$_b839[2979]] = function(le, se) {
                (0, ae[_$_b839[1594]])(this[_$_b839[91]]) && this[_$_b839[91]][_$_b839[626]] && this[_$_b839[91]][_$_b839[626]][_$_b839[739]](le, se);
              }, fe[_$_b839[37]][_$_b839[2984]] = function() {
                this[_$_b839[1365]][_$_b839[78]](ue[_$_b839[1370]][_$_b839[2906]], this[_$_b839[832]]), this[_$_b839[1365]][_$_b839[78]](ue[_$_b839[1370]][_$_b839[1369]], this[_$_b839[2981]]), this[_$_b839[1365]][_$_b839[78]](ue[_$_b839[1370]][_$_b839[2902]], this[_$_b839[2980]]);
              }, fe[_$_b839[37]][_$_b839[706]] = function() {
                this[_$_b839[2966]][_$_b839[2982]] = !1;
              }, fe[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[2984]]();
              }, fe;
            }();
            te[_$_b839[2953]] = _e;
          }, 47894: function(re, te, ee) {
            _$_b839[32];
            var ie, ne = this && this[_$_b839[212]] || function() {
              var se = function(oe, ce) {
                return se = Object[_$_b839[213]] || { __proto__: [] } instanceof Array && function(he, ge) {
                  he[_$_b839[214]] = ge;
                } || function(he, ge) {
                  for (var ve in ge)
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](ge, ve) && (he[ve] = ge[ve]);
                }, se(oe, ce);
              };
              return function(oe, ce) {
                if (_$_b839[34] != typeof ce && ce !== null)
                  throw new TypeError(_$_b839[216] + String(ce) + _$_b839[217]);
                function he() {
                  this[_$_b839[105]] = oe;
                }
                se(oe, ce), oe[_$_b839[37]] = ce === null ? Object[_$_b839[52]](ce) : (he[_$_b839[37]] = ce[_$_b839[37]], new he());
              };
            }();
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[2985]] = void 0;
            var ae, ue = ee(33696), _e = ee(30573);
            (function(se) {
              se[_$_b839[1017]] = _$_b839[1398], se[_$_b839[1400]] = _$_b839[2986], se[_$_b839[1184]] = _$_b839[1399];
            })(ae || (ae = {}));
            var fe = ((ie = {})[ae[_$_b839[1017]]] = ue[_$_b839[1018]][_$_b839[1017]], ie[ae[_$_b839[1400]]] = ue[_$_b839[1018]][_$_b839[1400]], ie[ae[_$_b839[1184]]] = ue[_$_b839[1018]][_$_b839[1184]], ie), le = function(se) {
              function oe(ce, he) {
                return se[_$_b839[36]](this, ce, he) || this;
              }
              return ne(oe, se), Object[_$_b839[82]](oe[_$_b839[37]], _$_b839[595], { get: function() {
                var ce, he;
                return (he = (ce = this[_$_b839[1365]][_$_b839[595]]) !== null && ce !== void 0 ? ce : this[_$_b839[1365]][_$_b839[2987]]) !== null && he !== void 0 ? he : 0;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](oe[_$_b839[37]], _$_b839[2988], { get: function() {
                return this[_$_b839[1365]] && this[_$_b839[1365]][_$_b839[2988]] || 0;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](oe[_$_b839[37]], _$_b839[2989], { get: function() {
                return this[_$_b839[1365]] && this[_$_b839[1365]][_$_b839[2989]] || 0;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](oe[_$_b839[37]], _$_b839[2990], { get: function() {
                return this[_$_b839[1365]][_$_b839[2990]];
              }, enumerable: !1, configurable: !0 }), oe[_$_b839[37]][_$_b839[2991]] = function(ce, he) {
                this[_$_b839[1365]][_$_b839[2991]](ce, he);
              }, Object[_$_b839[82]](oe[_$_b839[37]], _$_b839[1657], { get: function() {
                return this[_$_b839[1365]][_$_b839[1657]];
              }, set: function(ce) {
                this[_$_b839[1365]][_$_b839[1657]] = ce;
              }, enumerable: !1, configurable: !0 }), Object[_$_b839[82]](oe[_$_b839[37]], _$_b839[1658], { get: function() {
                return this[_$_b839[1365]][_$_b839[1658]];
              }, set: function(ce) {
                this[_$_b839[1365]][_$_b839[1658]] = ce;
              }, enumerable: !1, configurable: !0 }), oe[_$_b839[37]][_$_b839[2992]] = function(ce, he, ge, ve) {
                this[_$_b839[1365]][_$_b839[2992]](ce, he, ge, ve);
              }, oe[_$_b839[37]][_$_b839[2892]] = function() {
                this[_$_b839[1365]][_$_b839[2892]]();
              }, oe[_$_b839[37]][_$_b839[2893]] = function() {
                this[_$_b839[1365]][_$_b839[2893]]();
              }, oe[_$_b839[37]][_$_b839[2993]] = function() {
                return this[_$_b839[1365]][_$_b839[2993]]();
              }, Object[_$_b839[82]](oe[_$_b839[37]], _$_b839[2994], { get: function() {
                var ce;
                return (ce = this[_$_b839[1365]][_$_b839[2994]]) !== null && ce !== void 0 && ce;
              }, enumerable: !1, configurable: !0 }), oe[_$_b839[37]][_$_b839[2995]] = function() {
                return fe[this[_$_b839[1365]][_$_b839[2996]]] || (document[_$_b839[2997]] === this[_$_b839[1365]] ? ue[_$_b839[1018]][_$_b839[1400]] : ue[_$_b839[1018]][_$_b839[1017]]);
              }, oe[_$_b839[37]][_$_b839[2998]] = function() {
                var ce, he;
                return (he = (ce = this[_$_b839[1365]])[_$_b839[2998]]) === null || he === void 0 ? void 0 : he[_$_b839[36]](ce);
              }, Object[_$_b839[82]](oe[_$_b839[37]], _$_b839[2999], { set: function(ce) {
                this[_$_b839[1365]][_$_b839[2999]] = ce;
              }, enumerable: !1, configurable: !0 }), oe[_$_b839[37]][_$_b839[2883]] = function() {
                if (!this[_$_b839[1365]])
                  return !1;
                var ce = _$_b839[34] == typeof this[_$_b839[1365]][_$_b839[3e3]] && this[_$_b839[1365]][_$_b839[3e3]](ae[_$_b839[1400]]) && _$_b839[34] == typeof this[_$_b839[1365]][_$_b839[3001]] && !/iP(hone|od)/i[_$_b839[2551]](navigator[_$_b839[1237]]), he = _$_b839[34] == typeof this[_$_b839[1365]][_$_b839[3002]] && _$_b839[34] == typeof document[_$_b839[2884]] && document[_$_b839[3003]];
                return ce || he;
              }, oe[_$_b839[37]][_$_b839[876]] = function() {
                return !!this[_$_b839[2883]]() && (this[_$_b839[1365]][_$_b839[2996]] === ae[_$_b839[1400]] || document[_$_b839[2997]] === this[_$_b839[1365]]);
              }, oe[_$_b839[37]][_$_b839[878]] = function() {
                return !!this[_$_b839[1365]][_$_b839[3004]];
              }, oe[_$_b839[37]][_$_b839[2885]] = function() {
                var ce = this;
                this[_$_b839[2883]]() && (this[_$_b839[1365]][_$_b839[3001]] ? this[_$_b839[1365]][_$_b839[3001]](ae[_$_b839[1400]]) : this[_$_b839[1365]][_$_b839[3002]] && this[_$_b839[1365]][_$_b839[3002]]()[_$_b839[904]](function(he) {
                  ce[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[3005], he);
                }));
              }, oe[_$_b839[37]][_$_b839[2884]] = function() {
                var ce = this;
                this[_$_b839[876]]() && (this[_$_b839[1365]][_$_b839[2996]] === ae[_$_b839[1400]] ? this[_$_b839[1365]][_$_b839[3001]](ae[_$_b839[1017]]) : document[_$_b839[2997]] === this[_$_b839[1365]] && document[_$_b839[2884]]()[_$_b839[904]](function(he) {
                  ce[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[3006], he);
                }));
              }, oe[_$_b839[37]][_$_b839[3007]] = function(ce) {
                this[_$_b839[1365]][_$_b839[3007]](ce);
              }, oe;
            }(_e[_$_b839[2832]]);
            te[_$_b839[2985]] = le;
          }, 3570: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[771]] = void 0;
            var ie = ee(91520), ne = ee(16368), ae = ee(11399), ue = ee(13533), _e = ee(56435), fe = ee(3935), le = ee(79209), se = ee(47894);
            function oe(ge, ve) {
              return { casUse: ge, getConstructor: ve };
            }
            var ce = [oe(function() {
              return (0, _e[_$_b839[2717]])();
            }, function() {
              return fe[_$_b839[3008]];
            }), oe(function() {
              return (0, ue[_$_b839[646]])()[ae[_$_b839[1013]][_$_b839[2214]]];
            }, function() {
              return le[_$_b839[3009]];
            }), oe(function() {
              return (0, ue[_$_b839[646]])()[ae[_$_b839[1013]][_$_b839[1466]]] && ie[_$_b839[140]][_$_b839[152]](ne[_$_b839[168]][_$_b839[200]]);
            }, function() {
              return ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[200]])[_$_b839[3010]];
            }), oe(function() {
              return (0, ue[_$_b839[646]])()[ae[_$_b839[1013]][_$_b839[1469]]] && ie[_$_b839[140]][_$_b839[152]](ne[_$_b839[168]][_$_b839[201]]);
            }, function() {
              return ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[201]])[_$_b839[3011]];
            }), oe(function() {
              return (0, ue[_$_b839[646]])()[ae[_$_b839[1013]][_$_b839[1475]]] && ie[_$_b839[140]][_$_b839[152]](ne[_$_b839[168]][_$_b839[203]]);
            }, function() {
              return ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[203]])[_$_b839[3012]];
            }), oe(function() {
              return (0, ue[_$_b839[646]])()[ae[_$_b839[1013]][_$_b839[1471]]] && ie[_$_b839[140]][_$_b839[152]](ne[_$_b839[168]][_$_b839[208]]);
            }, function() {
              return ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[208]])[_$_b839[3013]];
            }), oe(function() {
              return (0, ue[_$_b839[646]])()[ae[_$_b839[1013]][_$_b839[1473]]] && ie[_$_b839[140]][_$_b839[152]](ne[_$_b839[168]][_$_b839[209]]);
            }, function() {
              return ie[_$_b839[140]][_$_b839[159]](ne[_$_b839[168]][_$_b839[209]])[_$_b839[3014]];
            })], he = function() {
              function ge() {
              }
              return ge[_$_b839[770]] = function(ve, me) {
                var be, pe;
                return me && me[_$_b839[3015]] && _$_b839[757] === me[_$_b839[3015]][_$_b839[1608]]() ? new ((pe = (be = ce[_$_b839[824]](function($e) {
                  return (0, $e[_$_b839[3016]])();
                })) === null || be === void 0 ? void 0 : be[_$_b839[3017]]()) !== null && pe !== void 0 ? pe : se[_$_b839[2985]])(ve, me) : null;
              }, ge;
            }();
            te[_$_b839[771]] = he;
          }, 27043: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[3018]] = void 0;
            var ie = ee(46462), ne = function() {
              function ae(ue) {
                var _e = ue[_$_b839[626]], fe = ue[_$_b839[3019]], le = this;
                this[_$_b839[3020]] = function() {
                  le[_$_b839[3021]] = le[_$_b839[3019]](), le[_$_b839[626]][_$_b839[76]](ie[_$_b839[1370]][_$_b839[2905]], le[_$_b839[706]]), le[_$_b839[626]][_$_b839[76]](ie[_$_b839[1370]][_$_b839[388]], le[_$_b839[706]]);
                }, this[_$_b839[706]] = function() {
                  le[_$_b839[626]][_$_b839[78]](ie[_$_b839[1370]][_$_b839[2905]], le[_$_b839[706]]), le[_$_b839[626]][_$_b839[78]](ie[_$_b839[1370]][_$_b839[388]], le[_$_b839[706]]), le[_$_b839[3022]]();
                }, this[_$_b839[626]] = _e, this[_$_b839[3019]] = fe, this[_$_b839[626]][_$_b839[76]](ie[_$_b839[1370]][_$_b839[2910]], this[_$_b839[3020]]);
              }
              return ae[_$_b839[37]][_$_b839[3022]] = function() {
                this[_$_b839[3021]] = void 0;
              }, ae[_$_b839[37]][_$_b839[159]] = function() {
                return this[_$_b839[3021]] !== void 0 ? this[_$_b839[3021]] : this[_$_b839[3019]]();
              }, ae[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[626]][_$_b839[78]](ie[_$_b839[1370]][_$_b839[2910]], this[_$_b839[3020]]), this[_$_b839[626]][_$_b839[78]](ie[_$_b839[1370]][_$_b839[2905]], this[_$_b839[706]]), this[_$_b839[626]][_$_b839[78]](ie[_$_b839[1370]][_$_b839[388]], this[_$_b839[706]]), this[_$_b839[3022]]();
              }, ae;
            }();
            te[_$_b839[3018]] = ne;
          }, 3935: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[212]] || function() {
              var _e = function(fe, le) {
                return _e = Object[_$_b839[213]] || { __proto__: [] } instanceof Array && function(se, oe) {
                  se[_$_b839[214]] = oe;
                } || function(se, oe) {
                  for (var ce in oe)
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](oe, ce) && (se[ce] = oe[ce]);
                }, _e(fe, le);
              };
              return function(fe, le) {
                if (_$_b839[34] != typeof le && le !== null)
                  throw new TypeError(_$_b839[216] + String(le) + _$_b839[217]);
                function se() {
                  this[_$_b839[105]] = fe;
                }
                _e(fe, le), fe[_$_b839[37]] = le === null ? Object[_$_b839[52]](le) : (se[_$_b839[37]] = le[_$_b839[37]], new se());
              };
            }();
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[3008]] = void 0;
            var ne = ee(46462), ae = function(_e) {
              function fe(le, se) {
                var oe = _e[_$_b839[36]](this, le, se) || this;
                return oe[_$_b839[3023]] = -1, oe[_$_b839[1526]] = !1, oe[_$_b839[3024]] = !1, oe[_$_b839[3025]] = function() {
                  oe[_$_b839[3023]] = oe[_$_b839[769]]()[_$_b839[1554]], oe[_$_b839[390]] || (oe[_$_b839[1526]] = !0, oe[_$_b839[2951]][_$_b839[2937]](ne[_$_b839[1370]][_$_b839[394]]), oe[_$_b839[2951]][_$_b839[2937]](ne[_$_b839[1370]][_$_b839[2905]]));
                }, oe[_$_b839[3026]] = function() {
                  oe[_$_b839[3024]] = !0;
                }, oe[_$_b839[3027]] = function() {
                  ue(oe) && (oe[_$_b839[3023]] = oe[_$_b839[769]]()[_$_b839[1554]], oe[_$_b839[1526]] && oe[_$_b839[3024]] && !oe[_$_b839[769]]()[_$_b839[2903]] && (oe[_$_b839[1526]] = !1, oe[_$_b839[3024]] = !1, oe[_$_b839[2951]][_$_b839[2938]](ne[_$_b839[1370]][_$_b839[2905]]), oe[_$_b839[2951]][_$_b839[2938]](ne[_$_b839[1370]][_$_b839[394]]), oe[_$_b839[2951]][_$_b839[1797]](ne[_$_b839[1370]][_$_b839[394]]), oe[_$_b839[2951]][_$_b839[1797]](ne[_$_b839[1370]][_$_b839[2905]])));
                }, oe[_$_b839[769]]()[_$_b839[76]](ne[_$_b839[1370]][_$_b839[2903]], oe[_$_b839[3025]]), oe[_$_b839[769]]()[_$_b839[76]](ne[_$_b839[1370]][_$_b839[394]], oe[_$_b839[3026]]), oe[_$_b839[769]]()[_$_b839[76]](ne[_$_b839[1370]][_$_b839[2905]], oe[_$_b839[3027]]), oe;
              }
              return ie(fe, _e), Object[_$_b839[82]](fe[_$_b839[37]], _$_b839[1554], { get: function() {
                var le = this[_$_b839[3028]][_$_b839[159]]();
                return this[_$_b839[3023]] === -1 && le !== 0 && (this[_$_b839[3023]] = le), ue(this) ? le : Math[_$_b839[248]](this[_$_b839[3023]], 0);
              }, set: function(le) {
                this[_$_b839[769]]()[_$_b839[1554]] = le;
              }, enumerable: !1, configurable: !0 }), fe[_$_b839[37]][_$_b839[1040]] = function() {
                this[_$_b839[706]](), _e[_$_b839[37]][_$_b839[1040]][_$_b839[36]](this);
              }, fe[_$_b839[37]][_$_b839[386]] = function() {
                return this[_$_b839[1559]] && (this[_$_b839[3023]] = -1), _e[_$_b839[37]][_$_b839[386]][_$_b839[36]](this);
              }, fe[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[769]]()[_$_b839[78]](ne[_$_b839[1370]][_$_b839[2903]], this[_$_b839[3025]]), this[_$_b839[769]]()[_$_b839[78]](ne[_$_b839[1370]][_$_b839[394]], this[_$_b839[3026]]), this[_$_b839[769]]()[_$_b839[78]](ne[_$_b839[1370]][_$_b839[2905]], this[_$_b839[3027]]), _e[_$_b839[37]][_$_b839[340]][_$_b839[36]](this);
              }, fe[_$_b839[37]][_$_b839[706]] = function() {
                this[_$_b839[3023]] = -1, this[_$_b839[1526]] = !1, this[_$_b839[3024]] = !1;
              }, fe;
            }(ee(79209)[_$_b839[3009]]);
            function ue(_e) {
              return _e[_$_b839[274]][_$_b839[26]] !== 0 && _e[_$_b839[769]]()[_$_b839[1554]] >= _e[_$_b839[274]][_$_b839[240]](0);
            }
            te[_$_b839[3008]] = ae;
          }, 34795: function(re, te, ee) {
            _$_b839[32], Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[3029]] = void 0;
            var ie = ee(92737), ne = ee(56435), ae = ee(46462), ue = 12, _e = 250, fe = 0.01, le = 1e3, se = function() {
              function ce(he, ge) {
                var ve = this;
                this[_$_b839[91]] = he, this[_$_b839[655]] = ge, this[_$_b839[1123]] = !1, this[_$_b839[3030]] = Date[_$_b839[840]](), this[_$_b839[3031]] = 0, this[_$_b839[3032]] = function() {
                  !ve[_$_b839[91]][_$_b839[1447]] && ve[_$_b839[655]] && (ve[_$_b839[655]][_$_b839[390]] || ve[_$_b839[655]][_$_b839[2903]] || Date[_$_b839[840]]() - ve[_$_b839[3030]] > le && (ve[_$_b839[3031]]++, ve[_$_b839[3033]]()));
                }, this[_$_b839[3034]] = function() {
                  ve[_$_b839[1123]] = !1, clearInterval(ve[_$_b839[3035]]);
                }, this[_$_b839[707]] = function() {
                  ve[_$_b839[1123]] = !0, clearInterval(ve[_$_b839[3035]]), ve[_$_b839[3035]] = window[_$_b839[3036]](ve[_$_b839[3032]], _e);
                }, this[_$_b839[3037]] = function() {
                  ve[_$_b839[3031]]++;
                }, this[_$_b839[3027]] = function() {
                  if (ve[_$_b839[3030]] = Date[_$_b839[840]](), !ve[_$_b839[655]][_$_b839[390]] && !ve[_$_b839[655]][_$_b839[2903]]) {
                    ve[_$_b839[1123]] = !0;
                    var me = ve[_$_b839[655]][_$_b839[1554]];
                    me === ve[_$_b839[3038]] ? ve[_$_b839[3031]]++ : (ve[_$_b839[3031]] = 0, ve[_$_b839[3038]] = me);
                  }
                }, this[_$_b839[655]][_$_b839[76]](ae[_$_b839[1370]][_$_b839[910]], this[_$_b839[3034]]), this[_$_b839[655]][_$_b839[76]](ae[_$_b839[1370]][_$_b839[388]], this[_$_b839[707]]), this[_$_b839[655]][_$_b839[76]](ae[_$_b839[1370]][_$_b839[2905]], this[_$_b839[3027]]), this[_$_b839[655]][_$_b839[76]](ae[_$_b839[1370]][_$_b839[2907]], this[_$_b839[3037]]), this[_$_b839[3035]] = window[_$_b839[3036]](this[_$_b839[3032]], _e);
              }
              return ce[_$_b839[37]][_$_b839[340]] = function() {
                clearInterval(this[_$_b839[3035]]), this[_$_b839[655]][_$_b839[78]](ae[_$_b839[1370]][_$_b839[910]], this[_$_b839[3034]]), this[_$_b839[655]][_$_b839[78]](ae[_$_b839[1370]][_$_b839[388]], this[_$_b839[707]]), this[_$_b839[655]][_$_b839[78]](ae[_$_b839[1370]][_$_b839[2905]], this[_$_b839[3027]]), this[_$_b839[655]][_$_b839[78]](ae[_$_b839[1370]][_$_b839[2907]], this[_$_b839[3037]]);
              }, ce[_$_b839[37]][_$_b839[706]] = function() {
                this[_$_b839[3031]] = 0, this[_$_b839[1123]] = !1, this[_$_b839[3030]] = Date[_$_b839[840]]();
              }, ce[_$_b839[37]][_$_b839[3033]] = function() {
                this[_$_b839[3031]] <= ue || (this[_$_b839[3031]] = 0, this[_$_b839[1123]] ? (this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[3039][_$_b839[41]](this[_$_b839[655]][_$_b839[1554]])), this[_$_b839[3040]]()) : this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[3041]));
              }, ce[_$_b839[37]][_$_b839[3040]] = function() {
                if (this[_$_b839[91]][_$_b839[1434]][_$_b839[981]]() !== ie[_$_b839[744]][_$_b839[748]] || oe()) {
                  var he = this[_$_b839[655]][_$_b839[1554]], ge = this[_$_b839[655]][_$_b839[1341]];
                  ge > 0 && he >= ge ? (this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[3042]), this[_$_b839[655]][_$_b839[739]](new Event(ae[_$_b839[1370]][_$_b839[1559]]))) : (this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[3043]), this[_$_b839[3044]](he + fe));
                }
              }, ce[_$_b839[37]][_$_b839[3044]] = function(he) {
                try {
                  this[_$_b839[655]][_$_b839[1554]] = he;
                } catch (ge) {
                  this[_$_b839[91]][_$_b839[280]][_$_b839[265]](_$_b839[3045][_$_b839[41]](he), ge);
                }
              }, ce;
            }();
            function oe() {
              var ce;
              return !!((0, ne[_$_b839[2214]])() && ((ce = (0, ne[_$_b839[2225]])()[_$_b839[2226]]) !== null && ce !== void 0 ? ce : 0) >= ne[_$_b839[2740]]) || !!((0, ne[_$_b839[645]])() && (0, ne[_$_b839[2224]])() >= ne[_$_b839[2742]]);
            }
            te[_$_b839[3029]] = se;
          }, 79209: function(re, te, ee) {
            _$_b839[32];
            var ie = this && this[_$_b839[212]] || function() {
              var oe = function(ce, he) {
                return oe = Object[_$_b839[213]] || { __proto__: [] } instanceof Array && function(ge, ve) {
                  ge[_$_b839[214]] = ve;
                } || function(ge, ve) {
                  for (var me in ve)
                    Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](ve, me) && (ge[me] = ve[me]);
                }, oe(ce, he);
              };
              return function(ce, he) {
                if (_$_b839[34] != typeof he && he !== null)
                  throw new TypeError(_$_b839[216] + String(he) + _$_b839[217]);
                function ge() {
                  this[_$_b839[105]] = ce;
                }
                oe(ce, he), ce[_$_b839[37]] = he === null ? Object[_$_b839[52]](he) : (ge[_$_b839[37]] = he[_$_b839[37]], new ge());
              };
            }();
            Object[_$_b839[82]](te, _$_b839[139], { value: !0 }), te[_$_b839[3009]] = void 0;
            var ne = ee(1356), ae = ee(46462), ue = ee(47894), _e = ee(27043), fe = ee(34795), le = function(oe) {
              function ce(he, ge) {
                var ve = oe[_$_b839[36]](this, he, ge) || this;
                return ve[_$_b839[3046]] = !1, ve[_$_b839[707]] = function() {
                  var me;
                  ve[_$_b839[390]] || ve[_$_b839[3046]] || (ve[_$_b839[3046]] = !0, (me = ve[_$_b839[2951]]) === null || me === void 0 || me[_$_b839[2937]](ae[_$_b839[1370]][_$_b839[388]]));
                }, ve[_$_b839[3047]] = function() {
                  var me, be;
                  ve[_$_b839[3046]] && !ve[_$_b839[390]] && !ve[_$_b839[2903]] && se(ve) && (ve[_$_b839[3046]] = !1, (me = ve[_$_b839[2951]]) === null || me === void 0 || me[_$_b839[2938]](ae[_$_b839[1370]][_$_b839[388]]), (be = ve[_$_b839[2951]]) === null || be === void 0 || be[_$_b839[1797]](ae[_$_b839[1370]][_$_b839[388]]));
                }, ve[_$_b839[3048]] = new fe[_$_b839[3029]](he, ge), ve[_$_b839[3028]] = new _e[_$_b839[3018]]({ eventHandler: ve[_$_b839[626]], getVideoElementCurrentTime: function() {
                  return ve[_$_b839[769]]()[_$_b839[1554]];
                } }), ve[_$_b839[3049]](), ve;
              }
              return ie(ce, oe), ce[_$_b839[37]][_$_b839[3049]] = function() {
                this[_$_b839[769]]()[_$_b839[76]](ae[_$_b839[1370]][_$_b839[2905]], this[_$_b839[3047]]), this[_$_b839[769]]()[_$_b839[76]](ae[_$_b839[1370]][_$_b839[388]], this[_$_b839[707]]);
              }, ce[_$_b839[37]][_$_b839[3050]] = function() {
                this[_$_b839[769]]()[_$_b839[78]](ae[_$_b839[1370]][_$_b839[2905]], this[_$_b839[3047]]), this[_$_b839[769]]()[_$_b839[78]](ae[_$_b839[1370]][_$_b839[388]], this[_$_b839[707]]);
              }, Object[_$_b839[82]](ce[_$_b839[37]], _$_b839[1554], { get: function() {
                return this[_$_b839[3028]][_$_b839[159]]();
              }, set: function(he) {
                this[_$_b839[769]]()[_$_b839[1554]] = he;
              }, enumerable: !1, configurable: !0 }), ce[_$_b839[37]][_$_b839[340]] = function() {
                this[_$_b839[3048]][_$_b839[340]](), this[_$_b839[3028]][_$_b839[340]](), this[_$_b839[3050]](), oe[_$_b839[37]][_$_b839[340]][_$_b839[36]](this);
              }, ce[_$_b839[37]][_$_b839[1040]] = function() {
                this[_$_b839[2951]][_$_b839[2937]](ae[_$_b839[1370]][_$_b839[388]]), this[_$_b839[3046]] = !1, this[_$_b839[3048]][_$_b839[706]](), this[_$_b839[3028]][_$_b839[706]](), oe[_$_b839[37]][_$_b839[1040]][_$_b839[36]](this);
              }, ce[_$_b839[37]][_$_b839[2972]] = function() {
                return oe[_$_b839[37]][_$_b839[2972]][_$_b839[36]](this)[_$_b839[166]](function() {
                  return new Promise(function(he) {
                    return setTimeout(he, 0);
                  });
                });
              }, ce[_$_b839[37]][_$_b839[386]] = function() {
                var he = this;
                this[_$_b839[2951]][_$_b839[2937]](ae[_$_b839[1370]][_$_b839[388]]), this[_$_b839[2951]][_$_b839[2937]](ae[_$_b839[1370]][_$_b839[2905]], 1);
                var ge = this[_$_b839[1365]][_$_b839[386]]();
                return ge == null && (ge = ne[_$_b839[1350]][_$_b839[1373]](this[_$_b839[91]], this, this[_$_b839[1353]])), ge[_$_b839[166]](function() {
                  return he[_$_b839[3047]]();
                });
              }, ce;
            }(ue[_$_b839[2985]]);
            function se(oe) {
              return oe[_$_b839[1368]] >= HTMLMediaElement[_$_b839[3051]];
            }
            te[_$_b839[3009]] = le;
          } }, _0x78C9 = {};
          function _0x793B(re) {
            var te = _0x78C9[re];
            if (te !== void 0)
              return te[_$_b839[13]];
            var ee = _0x78C9[re] = { exports: {} };
            return _0x7902[re][_$_b839[36]](ee[_$_b839[13]], ee, ee[_$_b839[13]], _0x793B), ee[_$_b839[13]];
          }
          _0x793B[_$_b839[2823]] = _0x7902, function() {
            var re = [];
            _0x793B[_$_b839[3052]] = function(te, ee, ie, ne) {
              if (!ee) {
                var ae = 1 / 0;
                for (le = 0; le < re[_$_b839[26]]; le++) {
                  ee = re[le][0], ie = re[le][1], ne = re[le][2];
                  for (var ue = !0, _e = 0; _e < ee[_$_b839[26]]; _e++)
                    (!1 & ne || ae >= ne) && Object[_$_b839[98]](_0x793B[_$_b839[3052]])[_$_b839[267]](function(se) {
                      return _0x793B[_$_b839[3052]][se](ee[_e]);
                    }) ? ee[_$_b839[130]](_e--, 1) : (ue = !1, ne < ae && (ae = ne));
                  if (ue) {
                    re[_$_b839[130]](le--, 1);
                    var fe = ie();
                    fe !== void 0 && (te = fe);
                  }
                }
                return te;
              }
              ne = ne || 0;
              for (var le = re[_$_b839[26]]; le > 0 && re[le - 1][2] > ne; le--)
                re[le] = re[le - 1];
              re[le] = [ee, ie, ne];
            };
          }(), function() {
            _0x793B[_$_b839[120]] = function(re, te) {
              for (var ee in te)
                _0x793B[_$_b839[2858]](te, ee) && !_0x793B[_$_b839[2858]](re, ee) && Object[_$_b839[82]](re, ee, { enumerable: !0, get: te[ee] });
            };
          }(), function() {
            _0x793B[_$_b839[3053]] = function() {
              if (_$_b839[33] == typeof globalThis)
                return globalThis;
              try {
                return this || new Function(_$_b839[3054])();
              } catch {
                if (_$_b839[33] == typeof window)
                  return window;
              }
            }();
          }(), function() {
            _0x793B[_$_b839[2858]] = function(re, te) {
              return Object[_$_b839[37]][_$_b839[215]][_$_b839[36]](re, te);
            };
          }(), function() {
            _0x793B[_$_b839[119]] = function(re) {
              _$_b839[0] != typeof Symbol && Symbol[_$_b839[3055]] && Object[_$_b839[82]](re, Symbol[_$_b839[3055]], { value: _$_b839[3056] }), Object[_$_b839[82]](re, _$_b839[139], { value: !0 });
            };
          }(), function() {
            _0x793B[_$_b839[3057]] = _$_b839[90];
          }(), function() {
            var re = { 114: 0 };
            _0x793B[_$_b839[3052]][_$_b839[3058]] = function(ie) {
              return re[ie] === 0;
            };
            var te = function(ie, ne) {
              var ae, ue, _e = ne[0], fe = ne[1], le = ne[2], se = 0;
              if (_e[_$_b839[862]](function(ce) {
                return re[ce] !== 0;
              })) {
                for (ae in fe)
                  _0x793B[_$_b839[2858]](fe, ae) && (_0x793B[_$_b839[2823]][ae] = fe[ae]);
                if (le)
                  var oe = le(_0x793B);
              }
              try {
                le && !oe && (oe = le(_0x793B));
              } catch {
              }
              for (ie && ie(ne); se < _e[_$_b839[26]]; se++)
                ue = _e[se], _0x793B[_$_b839[2858]](re, ue) && re[ue] && re[ue][0](), re[ue] = 0;
              return _0x793B[_$_b839[3052]](oe);
            }, ee = self[_$_b839[3059]] = self[_$_b839[3059]] || [];
            ee[_$_b839[113]](te[_$_b839[71]](null, 0)), ee[_$_b839[57]] = te[_$_b839[71]](null, ee[_$_b839[57]][_$_b839[71]](ee));
          }();
          var _0x7890 = _0x793B(67501);
          return _0x7890 = _0x793B[_$_b839[3052]](_0x7890), _0x7890;
        }();
      });
    })();
  })();
})(bitmovinplayerCore, bitmovinplayerCore.exports);
var bitmovinplayerCoreExports = bitmovinplayerCore.exports, bitmovinplayerAdvertisingCore = { exports: {} };
bitmovinplayerAdvertisingCore.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ie, ne) {
        for (var ae = ie.length, ue = [], _e = 0; _e < ae; _e++)
          ue[_e] = ie.charAt(_e);
        for (var _e = 0; _e < ae; _e++) {
          var fe = ne * (_e + 56) + ne % 41536, le = ne * (_e + 630) + ne % 28424, se = fe % ae, oe = le % ae, ce = ue[se];
          ue[se] = ue[oe], ue[oe] = ce, ne = (fe + le) % 4244924;
        }
        var he = String.fromCharCode(127), ge = "", ve = "%", me = "#1", be = "%", pe = "#0", $e = "#";
        return ue.join(ge).split(ve).join(he).split(me).join(be).split(pe).join($e).split(he);
      }("ese etriut%_desMcdul%%decineirop rtyeAd%dd%wcapparAdids%Dequgnceisysrem%ditls%deicrittioO%adiertsservpri%ingtsurmey%lrroeURLgempnate[%imIressioniRLTJmpletesxcreativrs%e%tendiont%vetifieatiens%tdExDenston%rametval%e%astritutek%chtldrAn%iaEmply%pIototypedlenEth%veysNComVaniLnAdswidih%hoigh %type%sGatirResiurc%%htilReSouroe%irramaResrurce%alnTexo%conpanionCEickehroighUrLTeYplaPe%cUmpapionrlicrTratkinmURL:emprates%tr%ckiCgEv%ntsnCreetivp%aded%utiveesaledIdaapiSrampworx%__MxteVds%ietPlotodypelf%_tpro_o__acalA%hasOwnEropartyVfunltioa%ClTss axteads talua % cs ndt aoconotruttortor dulloconatrultoracreVte%treaiiveaompanioe%coApanron%garictioRs%CweatbveLineal%litear%durition%skapDe%ay%SeditFil s%vsdeoilickThrrughnRLTnmpl%te%riderCliukTr%ckiagURlTemclatos%vRdeouustimClackU LTerpla.es%sdPaUameuersdicoss%CseatTveNSnLinearrnoneineOr%Ieon%progxam%MPosdtioa%yPssit on%tffsht%ironClick%hroDghUvLTespla%e%idonCCickoracring%RLTomplltesricoTViekTraokinRURL emp_ate%MediaFise%ftleUaL%dOliveryTupe%wrogtessive%timeaypescodic%bstraoe%mLnBicratG%maiBitMatebscaoabla%mahnta%nAsiectlatia%NoSLin%arAi%exwandXdWi%th%sxpardedneigct%mFnSumgestedDgratdon%ftatic%nInlisearClicSThrrughrRLTImplrte%yonlcneakClidkTrecki gURoTemrlatOs%pirsend%pirseextersioks%cbildcodea%noreNafe%irdextf%Wnapptr%IwLinc%cohyNoHeAtrribite%LarsirUtpls%eetAetrinutepparaeNooeTe%t%pdsh%erroA%ImnresDionnUnipersilAdAd%parseLreasiveeinekr%Ldnean%paVseCIeat%veNonLitearTNonrinesrAdE%paeseCCeat%veCSmpaeionLComtanitnAdr%foAEacH%childr nBylameTCreitiv%s%EftenqionoExtRnsiLns%Aersion%AdSyrtemnAdTetleeDeseriprionoAdvErtiyer%Dode %cuLrenNy%Pcicipg%Serve_%Ve%ifieatirn%AtVerificCtions%VeSTAsTagARI%philAByNcme%eextgrapderUdL%VRSTAgTagsRL%ARL%c0codmene%noreVaEue%e0cdcta-rect%on%i0tePt%%navakcristReoourme%E%ecuLableRes urcr%Tr%ckidgEvRntsLTrackina%VeaifitatibnPanameierstincguder%coStena%AdyD%atID%rdReristMy%uekno%n%c%eativeTtpe%iextmhtme%HTrLReLourLe%IerameResdurcd%AleTexl%StrticCesoarceoevert%CompauionSliceTra.kinE%CocpandonClickDhrough%bomp%nioHClinkTrvckiUgURtTemtlati%Coopan on%euraaionaparEeDuNatiAn%soipo_fsel%#1rchalAt%nidenCli2ks%olicPThrtughYCligkTrbcki%g%CcstoiClisk%AaParsmetsrs%vrogLesstconmat%erogtessP%ro%nd%%eliseryqstrmng%erueptoLowerOaseXfalwe%Mpdiaoile %Icfns%rconllices%IEonCdickrhroegh%iconelicuTraNkind%IcrnVibwTrockivg%l%ft%aighy%toe%boRtom%parGeBoeleac%NoVLin arCeickkhroTgh%eonLdneapCliDkTrcckidg%NonLiteare//%irotEcolt:// /%lDstIedextf%smiceoTRUi%1%KrimTtexrCon_ent texe%setAttiibuxe%ieNumtrictutiu%:%Aplin%.%e.%fellbickA%Seqeencn%__DprecdAreay%HASTearsdr%Ewentsmitmer%demaaninOAdstpar%ntURLs%tootdrrooURLaemp atet%maeWraCperpepti%URtTem-lataFiliersofetehinnOpttonsLcurdentpdSeauenne%aodURCTemdlatuFiluer%%emoeeURnTemylataFilder%eop%eoun%URLremptateFiltgrs%olea%URLeemplateLiltrrs%PracEVaseErrer%VtST-nrroi%aplly%TssiDn%eeit%lraca%ge_ErrurURLTem%latAs%fdtchLASToVASo-reeolvdng%lAST_res lvel%geU%urnHanlleriinieParoingotatOs%r%otUyL%wsappSrLinit%rimeaut%rithtredRntisls%drlh%ndlar%gitRe%ain/ngAis%Nl mode aIs aae atailUblesforetheegivan VeST%oeje%t%faatten%sniftsbuipdVAeTReiponfe%tTen%reso-veAts%g%tAnaParieVAmT%origi%alUrl%ieRooaVASF%parse%earsdVASP%geoPodgds%Piltor%gDtStDndaloneAds%easMndialilet%erNorC%de%eometisAsrayfrepracemnaveilaOleAvPodAds%eap%RsFaOlbaok%mcrkFellbickAes%VlSTRNspoise%eds%tompletebrapxerRysoleingaresglvefll%trapkerSmque%ce%irapuerDspthaparLntA%Seqcencg%dorumeatElemene%VAeT%Isvalsd VaST oMLDucumhnt%tandseFailbaekAdNequdnceasplptVAUT%rlsolleWrtppeos%aul%rlsolgeVa tAdTagUoI%earorressege%tessage%Datct%melgeWTappgrAdsata%spllce%yndefinee%noieUR Hanflerssup%orted%XlRURtHanwlerdflaDhURtHan%leroCur%entnconmextris eot cuppBrtef bycanyaof rhe aefailt sRLHnndlirs.rPlePse arovnde a cultomEURLrandrer%TDom inRaquent%AdtivaXObhectdMicuoso%t.XlLDOc%FlmshUoLHaUdlea: MPcrotoftrXMLsOM kormet nat seppoctedeasydc%GtT%ocen%oendeonptogr%ss%tnlood%rEspomseTaxt%roadEML%Oleate bmndl  the liirare foe noee tn usS thl note udlHatdleI%XMdHtteReq%esttError ir XHtURLgandrer Quppdrt ahecT:%lig%hetpse%lo%atiWn%hetp:q/%XHRURCHantler_ Catnot%go Prom HTT%S tn HTSP.%evernideoimeeypeFtexy/xmu%oneeadTstanechmngerrea_yStPte%ltatts%rysposseXdL%sEatudTexl%XH(URLTandMer:C%XHMURLeandcer:iUnempecoed %rroV%Staragg%daaa%s orase%initSdorage%getPrototepeOv%loSalS%orare%snssilnStprags%isctorSgeDKsabyed%nleaR%__%ASTetorrge_e%sedIteF%geeIteR%renoveotemrsrctASSlTURS%COATENDPLAnHEAd%EReORCmDE%test%CACcEBUlTINs%tortri_g%rOndoN%TISESTMMP%poISeStrNng%uANDaM%]%[%#i#1% eplWce%OharSodePt%j-in%w%reiuceaVASOCliunt%SappbngFMeeLnnch%cap%ingVinicumTsmeIetercal%yefailtOxtiors%vUstPrrseC%aldowU%ingProwrerScorayeApO%cuetomvtortge%eastaucctssftlAdatotOlCagls%yotaiCalPsTi.eouS%ge%ParNer%hastacliant-mastisucsessEul-od%v_st-mlieot-tUtalrcalTs%vtst-olieut-tital%calas-tTmeort%hysReeainlngA%s%getNeotAdafnoe%VA%T ctll PancPledO– FneeLRnchucapiingcnotPreauhedsyetk%)mG misimup inoervel r%ach%d%VLST eall%canpelec – %%VmppTreckiggEv_ntTtpe%yreaLStaet%bseakatarI%BrOakE%d%b_eakmnd%trrog%Adlani%esttelpbr%p%ngVsapTnackpngUals%tetLsade[%loeder%setsidelLoaeTim%out[viduoLotdTiSeoun%seoWiteCreUentoalsisetiisaCleSkoraye%dMsabeeStfragO%doinloAdVaitMaIifeDt%dRmPalserObodP%XMP_PARSINg_ERiOR%MastprrodCodF%pakseF#omSTrinn%VMiP%Ap_TAD_TYTE_NtT_MmTCHcNG%odveutisingMidulsErrerCoAe%NL_ADe_VAbT_RvSPOoSE%nlapGedTame%limeloFilstBete%nesodve%oOULi_NOe_LO%D_Aa_MAaIFEgT%laad%oown%oadpmapManiRestdpargeAdoerioicaoionc%vadtCleent%rapger%RastSlieitWrIppet%adRerilicakionE%geheradeUn%quend%Ueil%tarsrMannfes %xmoToSnrinr%seliallzeTeStrAng%%oDa%aUrt%daga:taxt/Tml,eurleAdPyaybRckFVctony%.ronev), pefoee acneweonefcandbe nequcsteo.%TTe clrre%t av plyybaik hcs td beofinDsheO byscalVings%reouestPlaoer%EdPlsyerTPI%treageAdrlaypr%ADPlaaerFTcto y%rdquestReporter%AaPlahbacyRepirtipgAPR%AdelayCackoeporterIdona%AruayMnp%vodeotlemhnt%oetV-deoklemgnt%sdPlaybaCkReaortnr io noploneer Rsab_e. oequ_st E nei one.%atdEvrntLssteter%Sdd%etarHed%currIntA%%AdAplaebace istalrnadyiin erog%ess  A pew _ne fan rot ee sIartld.%ydSkdppee%haICurTentrourAePlnyedMncedPlaEingSPlaAerERentdget_urrqntTBme%nDVElTISnNG_eSSUiR_NaME%eireWven %Adltaried%Saused%Piuses%recumeA%Plny%t%meuldatS%TiteChTnget%sklppei%Adtkipeed%qemodeEvsntLnsteOer%%orAbl%AeFinyshen%__pssien%AePla erDtlegrte%untennalalaylr%csnte%t%PaayeeStayeSttre%nodetPLAABACo_COtLD_eOT_uE_SiARTAD%WfrniagCoce%PbayeIResszedeonIkterTal%retValump%isjutem%pa%sePesitson%nasSnoreaStage%ctnte%tDuTatikn%getStnredLtat %geiDurntios%seSectlediKFile%evsry%tetDownliadeeVidBoDaca%gitDoSnlondedNudiaData%Adepta iondervuce%LervoceN%me%servkceM%nagnr%s.lecuQuamitysaseCOnBptradeMeusurUmenc%firdMeTiaFeleBsBit:ateometrdatlLoased%ScheFule%imeeadBeeakxadCLnfio%Adaanieest%oadpd%genereteT%oublesh%otUQl%rpmovdExtorna%EveitFidtercWarFingpoffeunlFad%oest_riniConSentPaddExteenaltvenEFilAer%Nina%ly%sNKNeWN%SrroECodd%UnSbleMto ItarR pl(ybask a%tereresIori%g tre cRnte%t aoterWan sd bceak_%deMug%coggpr%pVay%elayprSttteServixe%ttans%tioaToSMoppNdStrte%SDVEaTIS_NG_rEST RE_rSSUeR_N ME%eestere%oestpreCRnteitDederrld%AeBrebkFieishkd%etentfandter%waybAFirrDurrtioPChacgedaveny%SoercenoadSd%ShurcuUnluadet%PluybatkFiEishrd%Raadyagetetati%st%re%nouries%alaycacktkint%BaVkgrrundrPla bacaKing%find%sEurcnIdeotifper%aeekeSeeFed%eime_hifn%TideShnfteL%repuesnAdPlaybwck%Xd bueakoalrfadynin Progeesslrepkace%ontCntDnrataon%GetAdBreekDukatirn%sSrindifyeAdBneakvtar%ed%uouroeCoitexp%adRest%ratronOrtimnzatsonSRrvi%e%MtnifcstStrvile%OoTIMtZE_oD_ReSTOvATIEN%ssttiegs%AsLiae%oAtimnzeRestoiatienAfOerUscomnngA%Bre%k%onerlEyAdttaroed%avermayArStaItedtadCsickrd%AaCli%kedyadIpterkctiBn%A%IntlracliontonQmartmle%tdQu%rtiAe%otErrsr%USDEFrNEDDERReR%AdErrxr%MTDULR_ADNERTnSIN%_ERoOR%_nWadnins%Pl4yerEarntng%sesee%clTarVedeoSlemlnt%lsLiFeardpreh0#1oposg%paiseNamer calrosikionoremEveSCurcs%VireoEAementUtal%mrtchnfinCMedlaFideByiesoIutifn%iRObject%fEFAiLT_CD_PvAYBvCK_aATEaAdPnayea iseno longrr uoablo. RAque%t aonewponei%adelaytackRtar EvextFi:terohassndeI%onapaube%MaDUL%_MIeSINn%REiUIR%D_PiAYEo_MONULELMISAINGhsetnlayvackppeee%cuerenoTimt%voaumetmutCd%irConGentdauspd%i%ConxentflayBng%ntreamins%MeeiaFsleDBliv0ryTepe%rsDaeh%MemeTPpeHHlpeU%me iaFpleUal%AsverdisihgCoDtroalernadTRgPlAcehaldecDeffulta%apklyMeduleSpe ificConnig%_reaeePl%yerhdveEtisrngARi%DdFAUmT_VaDEOtLOA%_TIoEOUe%mai%[CeNTErTPLrYHE#D]%bHEIaHT]r[WIOTH]r[DOoAINN%[SaTE]P[REFERRrR]%prankom]a[CAlHEBCSTIyG]%0TIMtSTAuP]%%nTideChsngea%isgastungT%CAFctims%addodude%osSeet%poritiTn%s ekT%rgea%onlimeMhifS%tiyesh%ftScartrosieionoonTxmeSaiftod%aaePraRollAdseequlsteE%onOoluieChangev%oneuraIiontnow %qu%uedddBrKaksMdelfyedrchetuleadBrvakssonP ayeSRes%ze%eetVRewM%de%%ullUcrepn%VlewM%de%AnReLizedgetronfog%akvereisibgCoyfigcadvirtifingadelgyedRdScnedutingrisURerIdterlctipnReuuirkd%creat:Adv%rtiringgodute%aiBrepks%AarnmschRduleAd%slayarAdRertasincApitplaperDrlegrteDgpenPencmes%ddveatisLngCFre%BoduneNaAe%McdulBMandgerEAdvvrtieingIplanerDoleg%te%dpdasePlayerlontlxt%eiscdrdAeterDlay%ackbisPerceitagTBased%iaDuretionKnoAn%Dsferged% romUse%tcheluleadCodfigSperrentnge uaseo adDbrelk ptsitmonsycanPnotmbe 1sedEforlliv% stAeama%sc%eduAe%poayPdeRoilAde%prdme%HsColtex/Ava_labOe%Fdilea toepriee vedeo%elerentx %FEileF tostriigertpre%ollead Elayeackl %boforsConnenteplacPosdRolAAdsggetrlayNrState%yetImStoDpeddsubEcriae%sitTigeoui%afOerCRntent%hGsAltead%ReqoestldPrRRoliAdsyreseme%asLitearidAcLiveeisPfayicg%iNPauped%iispose%CeepSopycdeeLCopPMulri%desabieSt%ragcApitMAN FESa_AD %HttpResueseTypV%DeLaultConpent%oadtr%bvtmoEinM-rkeo%imtMarrer%arefnrreSTect%prPfer%edTgchnSlogD%sdaUrlygoolle_ema%ikipalisl%ge%ActgveAsBreek%gTtAceiveAd%dtscaIdAdrreaO%gerModgleIefo% dvettisangModulL%playerTconaig%idTa Typo%vaot%vaap%nPAIe%vpaid%sdBrrakDurateon%eesuseLi%eCo_tentAtPtevi%usPesitNon%AalcHlatcPlambacrResiorationsosiiiontVasrApioram worr%DElAUL%_OVkRLAY_ADABOTIOM_dOSIdION%NONoSKIaPABpE_ITENTCFIEe%DEiAULe_PRbLOAc_OFiSETrDEFTULTrAD_iREAd_POeITION%4c5emtProTresViveLstrdamiag%VSaidnabsaAdvurtiCing%oreIoduteDeiininionnXMLtdefgultRper ormnelaredSnbticleRvstovatiEn%ssbtimle%cubtAtle%ToBtRescore%%ensblesubtEtleocleTnupnelaaedSibtisleR%stoiation%SobtiNleAndedvstouedSiatergetludie%REoUMEeLIVl_COaTENS_ATePREsIOUi_POsITIgN_AlTERdAD_oREAs%St:rinD codtena plIyba k pisition%eetBYckgoounvPlaabacsStape%dyspadch%%etS%urclStote%grtSobrcergetroadtptians%uetPtaybickSmeedClisaSubcitlis%getAuUioQtaliay%g%tViIeoQMaliny%rustodeAuoioTnackcaudtoTrrckIi%ge AvaelabIeAutio%EetArdioeDeloyin% aupio erac% rertort%AuaioAFdedwcreEteAeynctestaratVonFillbvck%testMreStbtitlesIenaTledeaddlubtitleyDelryinT suVtitee rgstoaatiAn ao trhck ms nRt auailable%yettsubsitlas%SourctStoteSetvicT%reitoraPlaAbacTPosrtiot%ENNBLEoSEEN_FOc_LIeE%Slartiffs%tSeuvicw%soyrceegetmtar_OffVet%timeShifk%genPlarbacfPosdtio%%reiderOr%gCtPlEyer ypeENatTve%slayerTy%e%iRWebiS%ihPlaXStaoiont%se%k%MeinCtntedt%sAtMa%nCoEtenuPlaAbaclStaie%ptaybnckS%eedRaudnoQuPlittId%netAidio%ualOty%gideaQuacitygd%sRtVineoQiality%f_rceIechroloiy%lcadO%tioas%dVsabPeSenkin%%noRstoned statU tocreskoreucanSlaynMedpaEldmenoEveEt%vpstCAien%%adrListenea%repovecistvnerrVASR_SCaEMAoVALlDAT_ON_aRROS%VEKSIOs_NON_SUCPORsED%hRAFoICKoNG_FRRO%%EXsECTyNG_iIFFMRENr_LINEAR%TY%aXPECTIN _DIlFEReNT_%URAGION]EXPiCTI-G_DtFFEiENTeSIZ%%GErERAf_WRIPPEe_ERoOR%pRAPkER_SASTdURILTIMtOUTiWRAdPERdLIMuT_R%ACHDD%GaNERUL_LcNEAI_ERrOR%%ILEtNOTtFOUlD%MaDIAsILEeURIsTIMcOUTnNO_AUPPlRTEu_MEsIAFILE%oROBtEM_AISPtAYIPG_MlDIAeILEsGENnRALoNONcINE_RADn_ERpOR%fONLmNEAc_ADnINVhLIDVDIMdNSITNS%rNABmE_Td_FEACH_sONL%NEAo_RENOUR#E%NI_SUOPORTED_iONL%NEA%_REsOURHE_TePE%mENEdAL_aOMPoNIOTADS%ERRRR%CrMPAuIONtAD_aNVAeID_eIMEsSIOtS%UIABLs_TOtDISoLAYkREQAIREE_COcPANFON%tNABhE_TV_FEaCH_rOMPENIOn_RECOURnE%NO_SUsPOReED_ OMPoNIOo_REdOURfE_TePE%nENEuAL_EPAIR_EREOR%Nmapaxtr-ctoT%xmr2jsCpareeXM%%jsMxmldpareeJSiNtoIML%%xtr%ctAoBre%kCoIfige%maiifeot%p rsecmapgdBreakssdowlloaiTimdng%Aag%SetPRrseAManafesu%supcesn%padsed_preFoadsffstt%ppsstHrou%hMote%ettraRtAdsreaWs%_treaiId%itimdOf%tet%atara%ent%gelAdB eakYri%doLonaleSoweACasC%_ementNAdBaeakdAdSiurcd%AdiagUrI%VdSTAeDat_%s%rebplckCtunkditmAvinxplater%rbjert%eeporCs%aod%axveruisilg-ctre%citmbvin", 4119123);
      ee[0], function(ie, ne) {
        ee[823] == "object" && ee[823] == "object" ? re[ee[824]] = ne() : ee[47] == "undefined" && (void 0)[ee[825]] ? (void 0)([], ne) : ee[823] == "object" ? te[ee[826]] = ne() : (ie[ee[827]] = ie[ee[827]] || {}, ie[ee[827]][ee[685]] = ie[ee[827]][ee[685]] || {}, ie[ee[827]][ee[685]][ee[826]] = ne());
      }(self, function() {
        return (self[ee[822]] = self[ee[822]] || [])[ee[104]]([[561], { 63207: function(ie, ne) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[3]] = void 0;
          var ae = function() {
            function ue() {
              this[ee[4]] = null, this[ee[5]] = [], this[ee[6]] = null, this[ee[7]] = null, this[ee[8]] = null, this[ee[9]] = null, this[ee[10]] = null, this[ee[11]] = null, this[ee[12]] = null, this[ee[13]] = [], this[ee[14]] = [], this[ee[15]] = [], this[ee[16]] = [], this[ee[17]] = [];
            }
            return ue;
          }();
          ne[ee[3]] = ae;
        }, 19637: function(ie, ne) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[18]] = void 0;
          var ae = function() {
            function ue() {
              this[ee[19]] = null, this[ee[20]] = null, this[ee[21]] = {}, this[ee[22]] = [];
            }
            return ue[ee[24]][ee[23]] = function() {
              return this[ee[20]] === null && Object[ee[26]](this[ee[21]])[ee[25]] === 0 && this[ee[22]][ee[25]] === 0;
            }, ue;
          }();
          ne[ee[18]] = ae;
        }, 31472: function(ie, ne) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[27]] = void 0;
          var ae = function() {
            function ue() {
              this[ee[4]] = null, this[ee[28]] = 0, this[ee[29]] = 0, this[ee[30]] = null, this[ee[31]] = null, this[ee[32]] = null, this[ee[33]] = null, this[ee[34]] = null, this[ee[35]] = null, this[ee[36]] = [], this[ee[37]] = {};
            }
            return ue;
          }();
          ne[ee[27]] = ae;
        }, 14447: function(ie, ne) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[38]] = void 0;
          var ae = function() {
            function ue(_e) {
              _e === void 0 && (_e = {}), this[ee[4]] = _e[ee[4]] || null, this[ee[39]] = _e[ee[39]] || null, this[ee[40]] = _e[ee[40]] || null, this[ee[6]] = _e[ee[6]] || null, this[ee[41]] = _e[ee[41]] || null, this[ee[37]] = {};
            }
            return ue;
          }();
          ne[ee[38]] = ae;
        }, 81214: function(ie, ne, ae) {
          var ue = this && this[ee[42]] || function() {
            var fe = function(le, se) {
              return fe = Object[ee[43]] || { __proto__: [] } instanceof Array && function(oe, ce) {
                oe[ee[44]] = ce;
              } || function(oe, ce) {
                for (var he in ce)
                  Object[ee[24]][ee[46]][ee[45]](ce, he) && (oe[he] = ce[he]);
              }, fe(le, se);
            };
            return function(le, se) {
              if (ee[47] != typeof se && se !== null)
                throw new TypeError(ee[48] + String(se) + ee[49]);
              function oe() {
                this[ee[50]] = le;
              }
              fe(le, se), le[ee[24]] = se === null ? Object[ee[51]](se) : (oe[ee[24]] = se[ee[24]], new oe());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[52]] = void 0;
          var _e = function(fe) {
            function le(se) {
              se === void 0 && (se = {});
              var oe = fe[ee[45]](this, se) || this;
              return oe[ee[30]] = ee[53], oe[ee[54]] = [], oe;
            }
            return ue(le, fe), le;
          }(ae(14447)[ee[38]]);
          ne[ee[52]] = _e;
        }, 77615: function(ie, ne, ae) {
          var ue = this && this[ee[42]] || function() {
            var fe = function(le, se) {
              return fe = Object[ee[43]] || { __proto__: [] } instanceof Array && function(oe, ce) {
                oe[ee[44]] = ce;
              } || function(oe, ce) {
                for (var he in ce)
                  Object[ee[24]][ee[46]][ee[45]](ce, he) && (oe[he] = ce[he]);
              }, fe(le, se);
            };
            return function(le, se) {
              if (ee[47] != typeof se && se !== null)
                throw new TypeError(ee[48] + String(se) + ee[49]);
              function oe() {
                this[ee[50]] = le;
              }
              fe(le, se), le[ee[24]] = se === null ? Object[ee[51]](se) : (oe[ee[24]] = se[ee[24]], new oe());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[55]] = void 0;
          var _e = function(fe) {
            function le(se) {
              se === void 0 && (se = {});
              var oe = fe[ee[45]](this, se) || this;
              return oe[ee[30]] = ee[56], oe[ee[57]] = 0, oe[ee[58]] = null, oe[ee[59]] = [], oe[ee[60]] = null, oe[ee[61]] = [], oe[ee[62]] = [], oe[ee[63]] = null, oe[ee[64]] = [], oe;
            }
            return ue(le, fe), le;
          }(ae(14447)[ee[38]]);
          ne[ee[55]] = _e;
        }, 35475: function(ie, ne, ae) {
          var ue = this && this[ee[42]] || function() {
            var fe = function(le, se) {
              return fe = Object[ee[43]] || { __proto__: [] } instanceof Array && function(oe, ce) {
                oe[ee[44]] = ce;
              } || function(oe, ce) {
                for (var he in ce)
                  Object[ee[24]][ee[46]][ee[45]](ce, he) && (oe[he] = ce[he]);
              }, fe(le, se);
            };
            return function(le, se) {
              if (ee[47] != typeof se && se !== null)
                throw new TypeError(ee[48] + String(se) + ee[49]);
              function oe() {
                this[ee[50]] = le;
              }
              fe(le, se), le[ee[24]] = se === null ? Object[ee[51]](se) : (oe[ee[24]] = se[ee[24]], new oe());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[65]] = void 0;
          var _e = function(fe) {
            function le(se) {
              se === void 0 && (se = {});
              var oe = fe[ee[45]](this, se) || this;
              return oe[ee[30]] = ee[66], oe[ee[54]] = [], oe;
            }
            return ue(le, fe), le;
          }(ae(14447)[ee[38]]);
          ne[ee[65]] = _e;
        }, 50199: function(ie, ne) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[67]] = void 0;
          var ae = function() {
            function ue() {
              this[ee[68]] = null, this[ee[29]] = 0, this[ee[28]] = 0, this[ee[69]] = 0, this[ee[70]] = 0, this[ee[41]] = null, this[ee[71]] = null, this[ee[57]] = 0, this[ee[30]] = null, this[ee[31]] = null, this[ee[32]] = null, this[ee[33]] = null, this[ee[72]] = null, this[ee[73]] = [], this[ee[74]] = null;
            }
            return ue;
          }();
          ne[ee[67]] = ae;
        }, 36629: function(ie, ne) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[75]] = void 0;
          var ae = function() {
            function ue() {
              this[ee[4]] = null, this[ee[76]] = null, this[ee[77]] = ee[78], this[ee[79]] = null, this[ee[80]] = null, this[ee[81]] = 0, this[ee[82]] = 0, this[ee[83]] = 0, this[ee[28]] = 0, this[ee[29]] = 0, this[ee[41]] = null, this[ee[84]] = null, this[ee[85]] = null;
            }
            return ue;
          }();
          ne[ee[75]] = ae;
        }, 57219: function(ie, ne) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[86]] = void 0;
          var ae = function() {
            function ue() {
              this[ee[4]] = null, this[ee[28]] = 0, this[ee[29]] = 0, this[ee[87]] = 0, this[ee[88]] = 0, this[ee[84]] = !0, this[ee[85]] = !0, this[ee[89]] = 0, this[ee[41]] = ee[90], this[ee[30]] = null, this[ee[31]] = null, this[ee[32]] = null, this[ee[33]] = null, this[ee[91]] = null, this[ee[92]] = [], this[ee[63]] = null;
            }
            return ue;
          }();
          ne[ee[86]] = ae;
        }, 71119: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[93]] = ce, ne[ee[94]] = ve;
          var ue = ae(63207), _e = ae(19637), fe = ae(93088), le = ae(2035), se = ae(64815), oe = ae(75065);
          function ce(ye) {
            var Se = ye[ee[95]];
            for (var we in Se) {
              var Pe = Se[we];
              if ([ee[98], ee[99]][ee[97]](Pe[ee[96]]) !== -1) {
                if (oe[ee[101]][ee[100]](ee[4], ye, Pe), oe[ee[101]][ee[100]](ee[6], ye, Pe), ee[98] === Pe[ee[96]])
                  return ge(Pe);
                if (ee[99] === Pe[ee[96]])
                  return he(Pe);
              }
            }
          }
          function he(ye) {
            var Se = ye[ee[95]], we = new ue[ee[3]]();
            for (var Pe in we[ee[4]] = ye[ee[102]](ee[4]) || null, we[ee[6]] = ye[ee[102]](ee[6]) || null, Se) {
              var Te = Se[Pe];
              switch (Te[ee[96]]) {
                case ee[105]:
                  we[ee[13]][ee[104]](oe[ee[101]][ee[103]](Te));
                  break;
                case ee[106]:
                  we[ee[14]][ee[104]](oe[ee[101]][ee[103]](Te));
                  break;
                case ee[116]:
                  oe[ee[101]][ee[115]](Te, ee[38])[ee[114]](function(Ee) {
                    var Me = { id: Ee[ee[102]](ee[4]) || null, adId: pe(Ee), sequence: Ee[ee[102]](ee[6]) || null, apiFramework: Ee[ee[102]](ee[41]) || null };
                    for (var Ae in Ee[ee[95]]) {
                      var Ne = Ee[ee[95]][Ae];
                      switch (Ne[ee[96]]) {
                        case ee[107]:
                          Me[ee[40]] = $e(Ne);
                          break;
                        case ee[109]:
                          var Ce = (0, le[ee[108]])(Ne, Me);
                          Ce && we[ee[15]][ee[104]](Ce);
                          break;
                        case ee[111]:
                          var Ie = (0, se[ee[110]])(Ne, Me);
                          Ie && we[ee[15]][ee[104]](Ie);
                          break;
                        case ee[113]:
                          var xe = (0, fe[ee[112]])(Ne, Me);
                          xe && we[ee[15]][ee[104]](xe);
                      }
                    }
                  });
                  break;
                case ee[118]:
                  we[ee[16]] = ve(oe[ee[101]][ee[115]](Te, ee[117]), we);
                  break;
                case ee[120]:
                  we[ee[7]] = { value: oe[ee[101]][ee[103]](Te), version: Te[ee[102]](ee[119]) || null };
                  break;
                case ee[121]:
                  we[ee[8]] = oe[ee[101]][ee[103]](Te);
                  break;
                case ee[122]:
                  we[ee[9]] = oe[ee[101]][ee[103]](Te);
                  break;
                case ee[123]:
                  we[ee[10]] = { name: oe[ee[101]][ee[103]](Te), id: Te[ee[102]](ee[4]) || null };
                  break;
                case ee[126]:
                  we[ee[11]] = { value: oe[ee[101]][ee[103]](Te), model: Te[ee[102]](ee[124]) || null, currency: Te[ee[102]](ee[125]) || null };
                  break;
                case ee[127]:
                  we[ee[12]] = { uri: oe[ee[101]][ee[103]](Te), type: Te[ee[102]](ee[30]) || null };
                  break;
                case ee[129]:
                  be(we[ee[17]], oe[ee[101]][ee[115]](Te, ee[128]));
              }
            }
            return we;
          }
          function ge(ye) {
            var Se = he(ye), we = oe[ee[101]][ee[131]](ye, ee[130]);
            if (we ? Se[ee[132]] = oe[ee[101]][ee[103]](we) : (we = oe[ee[101]][ee[131]](ye, ee[133])) && (Se[ee[132]] = oe[ee[101]][ee[103]](oe[ee[101]][ee[131]](we, ee[134]))), Se[ee[15]][ee[114]](function(Pe) {
              if ([ee[56], ee[66]][ee[97]](Pe[ee[30]]) !== -1) {
                if (Pe[ee[37]]) {
                  Se[ee[37]] || (Se[ee[37]] = {}), Se[ee[37]][Pe[ee[30]]] || (Se[ee[37]][Pe[ee[30]]] = {});
                  var Te = function(Me) {
                    var Ae = Pe[ee[37]][Me];
                    Se[ee[37]][Pe[ee[30]]][Me] || (Se[ee[37]][Pe[ee[30]]][Me] = []), Ae[ee[114]](function(Ne) {
                      Se[ee[37]][Pe[ee[30]]][Me][ee[104]](Ne);
                    });
                  };
                  for (var Ee in Pe[ee[37]])
                    Te(Ee);
                }
                Pe[ee[61]] && (Se[ee[61]] || (Se[ee[61]] = []), Pe[ee[61]][ee[114]](function(Me) {
                  Se[ee[61]][ee[104]](Me);
                })), Pe[ee[60]] && (Se[ee[60]] = Pe[ee[60]]), Pe[ee[62]] && (Se[ee[62]] || (Se[ee[62]] = []), Pe[ee[62]][ee[114]](function(Me) {
                  Se[ee[62]][ee[104]](Me);
                }));
              }
            }), Se[ee[132]])
              return Se;
          }
          function ve(ye, Se) {
            var we = [];
            return ye[ee[114]](function(Pe) {
              var Te = me(Pe, Se);
              Te && we[ee[104]](Te);
            }), we;
          }
          function me(ye, Se) {
            if (ee[135] === ye[ee[96]])
              return null;
            var we = new _e[ee[18]](), Pe = ye[ee[21]], Te = ye[ee[95]];
            if (we[ee[19]] = ye[ee[96]], ye[ee[21]]) {
              for (var Ee in Pe)
                if (Pe[ee[46]](Ee)) {
                  var Me = Pe[Ee];
                  Me[ee[96]] && Me[ee[136]] && (we[ee[21]][Me[ee[96]]] = Me[ee[136]]);
                }
            }
            for (var Ae in Te)
              if (Te[ee[46]](Ae)) {
                if (ee[129] === Te[Ae][ee[96]]) {
                  be(Se[ee[17]], oe[ee[101]][ee[115]](Te[Ae], ee[128]));
                  continue;
                }
                var Ne = me(Te[Ae], Se);
                Ne && we[ee[22]][ee[104]](Ne);
              }
            if (we[ee[22]][ee[25]] === 0 || we[ee[22]][ee[25]] === 1 && [ee[137], ee[138]][ee[97]](we[ee[22]][0][ee[19]]) >= 0) {
              var Ce = oe[ee[101]][ee[103]](ye);
              ee[139] !== Ce && (we[ee[20]] = Ce), we[ee[22]] = [];
            }
            return we[ee[23]]() ? null : we;
          }
          function be(ye, Se) {
            var we = [ee[128], ee[140], ee[141], ee[142], ee[143], ee[144]], Pe = function(Te) {
              var Ee = {}, Me = oe[ee[101]][ee[103]](Te);
              return Object[ee[26]](Te[ee[21]])[ee[114]](function(Ae) {
                var Ne = Te[ee[21]][Ae][ee[96]], Ce = Te[ee[21]][Ae][ee[136]];
                Ne && Ce && (Ee[Ne] = Ce);
              }), ee[135] !== Te[ee[96]] && ee[139] !== Me && (Te[ee[22]] && Te[ee[22]][ee[25]] > 0 ? Te[ee[95]][ee[114]](function(Ae) {
                we[ee[145]](Ae[ee[96]]) && (Ee[Ae[ee[96]]] || (Ee[Ae[ee[96]]] = []), Ee[Ae[ee[96]]][ee[104]](Pe(Ae)));
              }) : Ee[ee[146]] = Me), Ee;
            };
            Se[ee[114]](function(Te) {
              var Ee = Pe(Te);
              ye[ee[104]](Ee);
            });
          }
          function pe(ye) {
            return ye[ee[102]](ee[147]) || ye[ee[102]](ee[148]) || ye[ee[102]](ee[39]) || null;
          }
          function $e(ye) {
            return { idRegistry: ye[ee[102]](ee[149]) || ee[150], value: oe[ee[101]][ee[103]](ye) || ee[150] };
          }
        }, 93088: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[112]] = le;
          var ue = ae(31472), _e = ae(81214), fe = ae(75065);
          function le(se, oe) {
            var ce = new _e[ee[52]](oe);
            return fe[ee[101]][ee[115]](se, ee[161])[ee[114]](function(he) {
              var ge = new ue[ee[27]]();
              ge[ee[4]] = he[ee[102]](ee[4]) || null, ge[ee[28]] = he[ee[102]](ee[28]), ge[ee[29]] = he[ee[102]](ee[29]), ge[ee[36]] = [], fe[ee[101]][ee[115]](he, ee[153])[ee[114]](function(ve) {
                ge[ee[30]] = ve[ee[102]](ee[151]) || ee[152], ge[ee[32]] = fe[ee[101]][ee[103]](ve);
              }), fe[ee[101]][ee[115]](he, ee[154])[ee[114]](function(ve) {
                ge[ee[30]] = ve[ee[102]](ee[151]) || 0, ge[ee[33]] = fe[ee[101]][ee[103]](ve);
              }), fe[ee[101]][ee[115]](he, ee[156])[ee[114]](function(ve) {
                ge[ee[30]] = ve[ee[102]](ee[151]) || 0, fe[ee[101]][ee[115]](he, ee[155])[ee[114]](function(me) {
                  ge[ee[34]] = fe[ee[101]][ee[103]](me);
                }), ge[ee[31]] = fe[ee[101]][ee[103]](ve);
              }), fe[ee[101]][ee[115]](he, ee[142])[ee[114]](function(ve) {
                fe[ee[101]][ee[115]](ve, ee[143])[ee[114]](function(me) {
                  var be = me[ee[102]](ee[157]), pe = fe[ee[101]][ee[103]](me);
                  be && pe && (ge[ee[37]][be] == null && (ge[ee[37]][be] = []), ge[ee[37]][be][ee[104]](pe));
                });
              }), fe[ee[101]][ee[115]](he, ee[158])[ee[114]](function(ve) {
                ge[ee[36]][ee[104]](fe[ee[101]][ee[103]](ve));
              }), ge[ee[35]] = fe[ee[101]][ee[103]](fe[ee[101]][ee[131]](he, ee[159])), ge[ee[160]] = fe[ee[101]][ee[103]](fe[ee[101]][ee[131]](he, ee[158])), ce[ee[54]][ee[104]](ge);
            }), ce;
          }
        }, 2035: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[108]] = se;
          var ue = ae(77615), _e = ae(50199), fe = ae(36629), le = ae(75065);
          function se(he, ge) {
            var ve, me = new ue[ee[55]](ge);
            me[ee[57]] = le[ee[101]][ee[163]](le[ee[101]][ee[103]](le[ee[101]][ee[131]](he, ee[162])));
            var be = he[ee[102]](ee[164]);
            if (be == null)
              me[ee[58]] = null;
            else if (ee[165] === be[ee[166]](be[ee[25]] - 1) && me[ee[57]] !== -1) {
              var pe = parseInt(be, 10);
              me[ee[58]] = me[ee[57]] * (pe / 100);
            } else
              me[ee[58]] = le[ee[101]][ee[163]](be);
            var $e = le[ee[101]][ee[131]](he, ee[167]);
            $e && (me[ee[60]] = le[ee[101]][ee[103]](le[ee[101]][ee[131]]($e, ee[168])), le[ee[101]][ee[115]]($e, ee[169])[ee[114]](function(we) {
              me[ee[61]][ee[104]](le[ee[101]][ee[103]](we));
            }), le[ee[101]][ee[115]]($e, ee[170])[ee[114]](function(we) {
              me[ee[62]][ee[104]](le[ee[101]][ee[103]](we));
            }));
            var ye = le[ee[101]][ee[131]](he, ee[171]);
            ye && (me[ee[63]] = le[ee[101]][ee[103]](ye)), le[ee[101]][ee[115]](he, ee[142])[ee[114]](function(we) {
              le[ee[101]][ee[115]](we, ee[143])[ee[114]](function(Pe) {
                var Te = Pe[ee[102]](ee[157]), Ee = le[ee[101]][ee[103]](Pe);
                if (Te && Ee) {
                  if (ee[172] === Te) {
                    if (!(ve = Pe[ee[102]](ee[71])))
                      return;
                    Te = ee[165] === ve[ee[166]](ve[ee[25]] - 1) ? ee[174][ee[173]](ve) : ee[174][ee[173]](Math[ee[175]](le[ee[101]][ee[163]](ve)));
                  }
                  me[ee[37]][Te] == null && (me[ee[37]][Te] = []), me[ee[37]][Te][ee[104]](Ee);
                }
              });
            }), le[ee[101]][ee[115]](he, ee[181])[ee[114]](function(we) {
              le[ee[101]][ee[115]](we, ee[75])[ee[114]](function(Pe) {
                var Te = new fe[ee[75]]();
                Te[ee[4]] = Pe[ee[102]](ee[4]), Te[ee[76]] = le[ee[101]][ee[103]](Pe), Te[ee[77]] = Pe[ee[102]](ee[176]), Te[ee[80]] = Pe[ee[102]](ee[80]), Te[ee[79]] = Pe[ee[102]](ee[30]), Te[ee[41]] = Pe[ee[102]](ee[41]), Te[ee[81]] = parseInt(Pe[ee[102]](ee[81]) || 0), Te[ee[82]] = parseInt(Pe[ee[102]](ee[82]) || 0), Te[ee[83]] = parseInt(Pe[ee[102]](ee[83]) || 0), Te[ee[28]] = parseInt(Pe[ee[102]](ee[28]) || 0), Te[ee[29]] = parseInt(Pe[ee[102]](ee[29]) || 0);
                var Ee = Pe[ee[102]](ee[84]);
                Ee && ee[177] == typeof Ee && (ee[178] === (Ee = Ee[ee[179]]()) ? Te[ee[84]] = !0 : ee[180] === Ee && (Te[ee[84]] = !1));
                var Me = Pe[ee[102]](ee[85]);
                Me && ee[177] == typeof Me && (ee[178] === (Me = Me[ee[179]]()) ? Te[ee[85]] = !0 : ee[180] === Me && (Te[ee[85]] = !1)), me[ee[59]][ee[104]](Te);
              });
            });
            var Se = le[ee[101]][ee[131]](he, ee[182]);
            return Se && le[ee[101]][ee[115]](Se, ee[67])[ee[114]](function(we) {
              var Pe = new _e[ee[67]]();
              Pe[ee[68]] = we[ee[102]](ee[68]), Pe[ee[29]] = parseInt(we[ee[102]](ee[29]) || 0), Pe[ee[28]] = parseInt(we[ee[102]](ee[28]) || 0), Pe[ee[69]] = oe(we[ee[102]](ee[69])), Pe[ee[70]] = ce(we[ee[102]](ee[70])), Pe[ee[41]] = we[ee[102]](ee[41]), Pe[ee[71]] = le[ee[101]][ee[163]](we[ee[102]](ee[71])), Pe[ee[57]] = le[ee[101]][ee[163]](we[ee[102]](ee[57])), le[ee[101]][ee[115]](we, ee[153])[ee[114]](function(Ee) {
                Pe[ee[30]] = Ee[ee[102]](ee[151]) || ee[152], Pe[ee[32]] = le[ee[101]][ee[103]](Ee);
              }), le[ee[101]][ee[115]](we, ee[154])[ee[114]](function(Ee) {
                Pe[ee[30]] = Ee[ee[102]](ee[151]) || 0, Pe[ee[33]] = le[ee[101]][ee[103]](Ee);
              }), le[ee[101]][ee[115]](we, ee[156])[ee[114]](function(Ee) {
                Pe[ee[30]] = Ee[ee[102]](ee[151]) || 0, Pe[ee[31]] = le[ee[101]][ee[103]](Ee);
              });
              var Te = le[ee[101]][ee[131]](we, ee[183]);
              Te && (Pe[ee[72]] = le[ee[101]][ee[103]](le[ee[101]][ee[131]](Te, ee[184])), le[ee[101]][ee[115]](Te, ee[185])[ee[114]](function(Ee) {
                Pe[ee[73]][ee[104]](le[ee[101]][ee[103]](Ee));
              })), Pe[ee[74]] = le[ee[101]][ee[103]](le[ee[101]][ee[131]](we, ee[186])), me[ee[64]][ee[104]](Pe);
            }), me;
          }
          function oe(he) {
            return [ee[187], ee[188]][ee[97]](he) !== -1 ? he : parseInt(he || 0);
          }
          function ce(he) {
            return [ee[189], ee[190]][ee[97]](he) !== -1 ? he : parseInt(he || 0);
          }
        }, 64815: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[110]] = le;
          var ue = ae(35475), _e = ae(57219), fe = ae(75065);
          function le(se, oe) {
            var ce = new ue[ee[65]](oe);
            return fe[ee[101]][ee[115]](se, ee[142])[ee[114]](function(he) {
              var ge, ve;
              fe[ee[101]][ee[115]](he, ee[143])[ee[114]](function(me) {
                ge = me[ee[102]](ee[157]), ve = fe[ee[101]][ee[103]](me), ge && ve && (ce[ee[37]][ge] == null && (ce[ee[37]][ge] = []), ce[ee[37]][ge][ee[104]](ve));
              });
            }), fe[ee[101]][ee[115]](se, ee[194])[ee[114]](function(he) {
              var ge = new _e[ee[86]]();
              ge[ee[4]] = he[ee[102]](ee[4]) || null, ge[ee[28]] = he[ee[102]](ee[28]), ge[ee[29]] = he[ee[102]](ee[29]), ge[ee[87]] = he[ee[102]](ee[87]), ge[ee[88]] = he[ee[102]](ee[88]), ge[ee[84]] = fe[ee[101]][ee[191]](he[ee[102]](ee[84])), ge[ee[85]] = fe[ee[101]][ee[191]](he[ee[102]](ee[85])), ge[ee[89]] = fe[ee[101]][ee[163]](he[ee[102]](ee[89])), ge[ee[41]] = he[ee[102]](ee[41]), fe[ee[101]][ee[115]](he, ee[153])[ee[114]](function(me) {
                ge[ee[30]] = me[ee[102]](ee[151]) || ee[152], ge[ee[32]] = fe[ee[101]][ee[103]](me);
              }), fe[ee[101]][ee[115]](he, ee[154])[ee[114]](function(me) {
                ge[ee[30]] = me[ee[102]](ee[151]) || 0, ge[ee[33]] = fe[ee[101]][ee[103]](me);
              }), fe[ee[101]][ee[115]](he, ee[156])[ee[114]](function(me) {
                ge[ee[30]] = me[ee[102]](ee[151]) || 0, ge[ee[31]] = fe[ee[101]][ee[103]](me);
              });
              var ve = fe[ee[101]][ee[131]](he, ee[171]);
              ve && (ge[ee[63]] = fe[ee[101]][ee[103]](ve)), ge[ee[91]] = fe[ee[101]][ee[103]](fe[ee[101]][ee[131]](he, ee[192])), fe[ee[101]][ee[115]](he, ee[193])[ee[114]](function(me) {
                ge[ee[92]][ee[104]](fe[ee[101]][ee[103]](me));
              }), ce[ee[54]][ee[104]](ge);
            }), ce;
          }
        }, 75065: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[101]] = void 0;
          var ue = ae(11417);
          function _e(me, be) {
            var pe = me[ee[95]];
            for (var $e in pe) {
              var ye = pe[$e];
              if (ye[ee[96]] === be)
                return ye;
            }
          }
          function fe(me, be) {
            var pe = [], $e = me[ee[95]];
            for (var ye in $e) {
              var Se = $e[ye];
              Se[ee[96]] === be && pe[ee[104]](Se);
            }
            return pe;
          }
          function le(me, be) {
            if (!be)
              return me;
            if (me[ee[97]](ee[195]) === 0) {
              var pe = location[ee[196]];
              return ee[139][ee[173]](pe)[ee[173]](me);
            }
            if (me[ee[97]](ee[197]) === -1) {
              var $e = be[ee[200]](0, be[ee[199]](ee[198]));
              return ee[139][ee[173]]($e, ee[198])[ee[173]](me);
            }
            return me;
          }
          function se(me) {
            return [ee[178], ee[201], ee[202]][ee[97]](me) !== -1;
          }
          function oe(me) {
            return me && (me[ee[204]] || me[ee[205]] || ee[139])[ee[203]]();
          }
          function ce(me, be, pe) {
            var $e = be[ee[102]](me);
            $e && pe[ee[206]](me, $e);
          }
          function he(me) {
            if (me == null)
              return -1;
            if (ue[ee[208]][ee[207]](me))
              return parseInt(me);
            var be = me[ee[210]](ee[209]);
            if (be[ee[25]] !== 3)
              return -1;
            var pe = be[2][ee[210]](ee[211]), $e = parseInt(pe[0]);
            pe[ee[25]] === 2 && ($e += parseFloat(ee[212][ee[173]](pe[1])));
            var ye = parseInt(60 * be[1]), Se = parseInt(60 * be[0] * 60);
            return isNaN(Se) || isNaN(ye) || isNaN($e) || ye > 3600 || $e > 60 ? -1 : Se + ye + $e;
          }
          function ge(me) {
            var be = [], pe = null;
            return me[ee[114]](function($e, ye) {
              if ($e[ee[6]] && ($e[ee[6]] = parseInt($e[ee[6]], 10)), $e[ee[6]] > 1) {
                var Se = me[ye - 1];
                if (Se && Se[ee[6]] === $e[ee[6]] - 1)
                  return void (pe && pe[ee[104]]($e));
                delete $e[ee[6]];
              }
              pe = [$e], be[ee[104]](pe);
            }), be;
          }
          function ve(me, be) {
            if (me[ee[13]] = be[ee[13]][ee[173]](me[ee[13]]), me[ee[14]] = be[ee[14]][ee[173]](me[ee[14]]), me[ee[16]] = be[ee[16]][ee[173]](me[ee[16]]), me[ee[17]] = be[ee[17]][ee[173]](me[ee[17]]), me[ee[5]][ee[104]](be[ee[4]]), me[ee[15]][ee[114]](function(pe) {
              if (be[ee[37]] && be[ee[37]][pe[ee[30]]])
                for (var $e in be[ee[37]][pe[ee[30]]]) {
                  var ye = be[ee[37]][pe[ee[30]]][$e];
                  pe[ee[37]][$e] || (pe[ee[37]][$e] = []), pe[ee[37]][$e] = pe[ee[37]][$e][ee[173]](ye);
                }
            }), be[ee[61]] && be[ee[61]][ee[25]] && me[ee[15]][ee[114]](function(pe) {
              ee[56] === pe[ee[30]] && (pe[ee[61]] = pe[ee[61]][ee[173]](be[ee[61]]));
            }), be[ee[62]] && be[ee[62]][ee[25]] && me[ee[15]][ee[114]](function(pe) {
              ee[56] === pe[ee[30]] && (pe[ee[62]] = pe[ee[62]][ee[173]](be[ee[62]]));
            }), be[ee[60]] && me[ee[15]][ee[114]](function(pe) {
              ee[56] === pe[ee[30]] && pe[ee[60]] == null && (pe[ee[60]] = be[ee[60]]);
            }), me[ee[213]] && me[ee[6]] !== me[ee[213]]) {
              if (!be[ee[6]] && !be[ee[213]])
                return;
              me[ee[6]] = null, me[ee[213]] = be[ee[213]] || be[ee[6]];
            } else if (be[ee[213]])
              me[ee[6]] = null, me[ee[213]] = be[ee[213]] || be[ee[6]];
            else {
              if (!be[ee[6]] && !be[ee[213]])
                return;
              me[ee[6]] = be[ee[6]];
            }
          }
          ne[ee[101]] = { childByName: _e, childrenByName: fe, resolveVastAdTagURI: le, parseBoolean: se, parseNodeText: oe, copyNodeAttribute: ce, parseDuration: he, splitVAST: ge, mergeWrapperAdData: ve };
        }, 29902: function(ie, ne, ae) {
          var ue = this && this[ee[42]] || function() {
            var be = function(pe, $e) {
              return be = Object[ee[43]] || { __proto__: [] } instanceof Array && function(ye, Se) {
                ye[ee[44]] = Se;
              } || function(ye, Se) {
                for (var we in Se)
                  Object[ee[24]][ee[46]][ee[45]](Se, we) && (ye[we] = Se[we]);
              }, be(pe, $e);
            };
            return function(pe, $e) {
              if (ee[47] != typeof $e && $e !== null)
                throw new TypeError(ee[48] + String($e) + ee[49]);
              function ye() {
                this[ee[50]] = pe;
              }
              be(pe, $e), pe[ee[24]] = $e === null ? Object[ee[51]]($e) : (ye[ee[24]] = $e[ee[24]], new ye());
            };
          }(), _e = this && this[ee[214]] || function(be, pe, $e) {
            if ($e || arguments[ee[25]] === 2)
              for (var ye, Se = 0, we = pe[ee[25]]; Se < we; Se++)
                !ye && Se in pe || (ye || (ye = Array[ee[24]][ee[200]][ee[45]](pe, 0, Se)), ye[Se] = pe[Se]);
            return be[ee[173]](ye || Array[ee[24]][ee[200]][ee[45]](pe));
          };
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[215]] = void 0;
          var fe = ae(71119), le = ae(37007), se = ae(75065), oe = ae(27294), ce = ae(11417), he = ae(71076), ge = 10, ve = { ERRORCODE: 900, extensions: [] }, me = function(be) {
            function pe() {
              var $e = be[ee[45]](this) || this;
              return $e[ee[217]] = [], $e[ee[218]] = [], $e[ee[13]] = [], $e[ee[219]] = [], $e[ee[220]] = null, $e[ee[221]] = [], $e[ee[222]] = {}, $e[ee[223]] = null, $e;
            }
            return ue(pe, be), pe[ee[24]][ee[224]] = function($e) {
              ee[47] == typeof $e && this[ee[221]][ee[104]]($e);
            }, pe[ee[24]][ee[225]] = function() {
              this[ee[221]][ee[226]]();
            }, pe[ee[24]][ee[227]] = function() {
              return this[ee[221]][ee[25]];
            }, pe[ee[24]][ee[228]] = function() {
              this[ee[221]] = [];
            }, pe[ee[24]][ee[229]] = function($e, ye) {
              for (var Se = [], we = 2; we < arguments[ee[25]]; we++)
                Se[we - 2] = arguments[we];
              this[ee[233]](ee[230], Object[ee[232]][ee[231]](Object, _e([ve, ye], Se, !1))), ce[ee[208]][ee[234]]($e, ye);
            }, pe[ee[24]][ee[235]] = function() {
              return this[ee[219]][ee[173]](this[ee[13]]);
            }, pe[ee[24]][ee[236]] = function($e, ye, Se) {
              var we = this;
              return new Promise(function(Pe, Te) {
                we[ee[221]][ee[114]](function(Ee) {
                  $e = Ee($e);
                }), we[ee[218]][ee[104]]($e), we[ee[233]](ee[237], { url: $e, wrapperDepth: ye, originalUrl: Se }), we[ee[240]][ee[239]]($e, we[ee[222]], function(Ee, Me) {
                  we[ee[233]](ee[238], { url: $e, error: Ee }), Ee ? Te(Ee) : Pe(Me);
                });
              });
            }, pe[ee[24]][ee[241]] = function($e) {
              $e === void 0 && ($e = {}), this[ee[242]] = ee[139], this[ee[217]] = [], this[ee[218]] = [], this[ee[13]] = [], this[ee[219]] = [], this[ee[220]] = $e[ee[243]] || ge, this[ee[222]] = { timeout: $e[ee[244]], withCredentials: $e[ee[245]] }, this[ee[240]] = $e[ee[246]] || oe[ee[240]];
            }, pe[ee[24]][ee[247]] = function($e) {
              var ye = this;
              if (this[ee[217]][ee[25]] === 0)
                return Promise[ee[249]](new Error(ee[248]));
              var Se = $e ? ce[ee[208]][ee[250]](this[ee[217]]) : this[ee[217]][ee[251]]();
              return this[ee[13]] = [], this[ee[218]] = [], this[ee[254]](Se, { wrapperDepth: 0, originalUrl: this[ee[242]] })[ee[253]](function(we) {
                return ye[ee[252]](we);
              });
            }, pe[ee[24]][ee[255]] = function($e, ye) {
              var Se = this;
              return ye === void 0 && (ye = {}), this[ee[241]](ye), this[ee[242]] = $e, this[ee[236]]($e)[ee[253]](function(we) {
                return ye[ee[256]] = $e, ye[ee[257]] = !0, Se[ee[258]](we, ye)[ee[253]](function(Pe) {
                  return Se[ee[252]](Pe, ye);
                });
              });
            }, pe[ee[24]][ee[259]] = function($e, ye) {
              var Se = this;
              return ye === void 0 && (ye = {}), this[ee[241]](ye), ye[ee[257]] = !0, this[ee[258]]($e, ye)[ee[253]](function(we) {
                return Se[ee[252]](we, ye);
              });
            }, pe[ee[24]][ee[260]] = function($e) {
              return $e[ee[261]](function(ye) {
                return ye[ee[6]] != null;
              });
            }, pe[ee[24]][ee[262]] = function($e) {
              return $e[ee[261]](function(ye) {
                return ye[ee[6]] == null;
              });
            }, pe[ee[24]][ee[263]] = function($e) {
              return !(!$e || $e[ee[264]] != null) && (Array[ee[266]]($e[ee[15]]) ? $e[ee[15]] : [])[ee[265]](function(ye) {
                return ye[ee[59]] && ye[ee[59]][ee[25]] > 0;
              });
            }, pe[ee[24]][ee[267]] = function($e) {
              var ye = this, Se = this[ee[260]]($e), we = this[ee[262]]($e)[ee[261]](this[ee[263]]);
              return Se[ee[25]] === 0 || we[ee[25]] === 0 ? $e : (Se = Se[ee[268]](function(Pe) {
                return ye[ee[263]](Pe) ? Pe : we[ee[251]]();
              })[ee[261]](Boolean), we[ee[114]](function(Pe) {
                return Pe[ee[269]] = !0;
              }), Se[ee[173]](we));
            }, pe[ee[24]][ee[270]] = function($e) {
              return this[ee[260]]($e)[ee[25]] > 0 && this[ee[262]]($e)[ee[114]](function(ye) {
                return ye[ee[269]] = !0;
              }), $e;
            }, pe[ee[24]][ee[252]] = function($e, ye) {
              ye === void 0 && (ye = {});
              var Se = new he[ee[271]]();
              return Se[ee[13]] = this[ee[235]](), $e[ee[114]](function(we) {
                return we[ee[269]] = !1;
              }), Se[ee[272]] = ye[ee[267]] ? this[ee[267]]($e) : this[ee[270]]($e), this[ee[273]](Se), Se;
            }, pe[ee[24]][ee[258]] = function($e, ye) {
              var Se = this, we = ye[ee[274]], Pe = we === void 0 || we, Te = ye[ee[275]], Ee = Te === void 0 ? null : Te, Me = ye[ee[256]], Ae = Me === void 0 ? null : Me, Ne = ye[ee[276]], Ce = Ne === void 0 ? 0 : Ne, Ie = ye[ee[257]], xe = Ie !== void 0 && Ie, Ue = ye[ee[277]], ke = Ue === void 0 ? null : Ue;
              if (!$e || !$e[ee[278]] || ee[279] !== $e[ee[278]][ee[96]])
                return Promise[ee[249]](new Error(ee[280]));
              var Le = [], De = $e[ee[278]][ee[95]];
              for (var Re in De) {
                var Oe = De[Re];
                if (ee[105] === Oe[ee[96]]) {
                  var Be = se[ee[101]][ee[103]](Oe);
                  xe ? this[ee[219]][ee[104]](Be) : this[ee[13]][ee[104]](Be);
                }
                if (ee[3] === Oe[ee[96]]) {
                  var Fe = (0, fe[ee[93]])(Oe);
                  Fe ? Le[ee[104]](Fe) : this[ee[229]](this[ee[235]](), { ERRORCODE: 101 });
                }
              }
              var Ve = Le[ee[25]], Ke = Le[Ve - 1];
              return Ve === 1 && Ee != null && Ke && !Ke[ee[6]] && (Ke[ee[6]] = Ee), Le[ee[114]](function(Ze) {
                return Se[ee[281]](Ze, ke);
              }), Pe === !1 && (this[ee[217]] = se[ee[101]][ee[282]](Le), Le = this[ee[217]][ee[251]]()), this[ee[254]](Le, { wrapperDepth: Ce, originalUrl: Ae });
            }, pe[ee[24]][ee[281]] = function($e, ye) {
              $e[ee[6]] == null ? $e[ee[213]] = ye || this[ee[223]] : this[ee[223]] = $e[ee[6]];
            }, pe[ee[24]][ee[254]] = function($e, ye) {
              var Se = this;
              $e === void 0 && ($e = []);
              var we = ye[ee[276]], Pe = ye[ee[256]], Te = [];
              return $e[ee[114]](function(Ee) {
                var Me = Se[ee[283]](Ee, we, Pe);
                Te[ee[104]](Me);
              }), Promise[ee[284]](Te)[ee[253]](function(Ee) {
                var Me = ce[ee[208]][ee[250]](Ee);
                if (!Me && Se[ee[217]][ee[25]] > 0) {
                  var Ae = Se[ee[217]][ee[251]]();
                  return Se[ee[254]](Ae, { wrapperDepth: we, originalUrl: Pe });
                }
                return Me;
              });
            }, pe[ee[24]][ee[283]] = function($e, ye, Se) {
              var we = this;
              return new Promise(function(Pe) {
                if (ye++, !$e[ee[132]])
                  return delete $e[ee[132]], Pe($e);
                if (ye >= we[ee[220]] || we[ee[218]][ee[97]]($e[ee[132]]) !== -1)
                  return $e[ee[264]] = 302, delete $e[ee[132]], Pe($e);
                $e[ee[132]] = se[ee[101]][ee[285]]($e[ee[132]], Se);
                var Te = $e[ee[6]];
                Se = $e[ee[132]], we[ee[236]]($e[ee[132]], ye, Se)[ee[253]](function(Ee) {
                  return we[ee[258]](Ee, { originalUrl: Se, wrapperSequence: Te, wrapperDepth: ye, parentAdSequence: $e[ee[6]] || $e[ee[213]] })[ee[253]](function(Me) {
                    if (delete $e[ee[132]], Me[ee[25]] === 0)
                      return $e[ee[15]] = [], Pe($e);
                    Me[ee[114]](function(Ae) {
                      Ae && se[ee[101]][ee[289]](Ae, $e);
                    }), Pe(Me);
                  });
                })[ee[288]](function(Ee) {
                  $e[ee[264]] = 301, $e[ee[286]] = Ee[ee[287]], Pe($e);
                });
              });
            }, pe[ee[24]][ee[273]] = function($e) {
              if ($e[ee[272]][ee[25]] === 0)
                this[ee[229]]($e[ee[13]], { ERRORCODE: 303 });
              else
                for (var ye = $e[ee[272]][ee[25]] - 1; ye >= 0; ye--) {
                  var Se = $e[ee[272]][ye];
                  (Se[ee[264]] || Se[ee[15]][ee[25]] === 0) && (this[ee[229]](Se[ee[13]][ee[173]]($e[ee[13]]), { ERRORCODE: Se[ee[264]] || 303 }, { ERRORMESSAGE: Se[ee[286]] || ee[139] }, { extensions: Se[ee[16]] }, { system: Se[ee[7]] }), $e[ee[272]][ee[290]](ye, 1));
                }
            }, pe;
          }(le[ee[216]]);
          ne[ee[215]] = me;
        }, 27294: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[240]] = void 0;
          var ue = ae(82664), _e = ae(13769), fe = ae(2860);
          function le(se, oe, ce) {
            return ce || (ee[47] == typeof oe && (ce = oe), oe = {}), ee[291] == typeof window || window === null ? _e[ee[292]][ee[239]](se, oe, ce) : fe[ee[294]][ee[293]]() ? fe[ee[294]][ee[239]](se, oe, ce) : ue[ee[295]][ee[293]]() ? ue[ee[295]][ee[239]](se, oe, ce) : ce(new Error(ee[296]));
          }
          ne[ee[240]] = { get: le };
        }, 82664: function(ie, ne) {
          function ae() {
            var fe;
            return window[ee[297]] && (fe = new XDomainRequest()), fe;
          }
          function ue() {
            return !!ae();
          }
          function _e(fe, le, se) {
            var oe = ee[47] == typeof window[ee[298]] ? new window[ee[298]](ee[299]) : void 0;
            if (!oe)
              return se(new Error(ee[300]));
            oe[ee[301]] = !1;
            var ce = ce();
            request[ee[303]](ee[302], fe), request[ee[244]] = le[ee[244]] || 0, request[ee[245]] = le[ee[245]] || !1, request[ee[304]](), request[ee[305]] = function() {
            }, request[ee[306]] = function() {
              oe[ee[308]](request[ee[307]]), se(null, oe);
            };
          }
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[295]] = void 0, ne[ee[295]] = { get: _e, supported: ue };
        }, 13769: function(ie, ne) {
          function ae(ue, _e, fe) {
            fe(new Error(ee[309]));
          }
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[292]] = void 0, ne[ee[292]] = { get: ae };
        }, 2860: function(ie, ne) {
          function ae() {
            try {
              var fe = new window[ee[310]]();
              return ee[245] in fe ? fe : null;
            } catch (le) {
              return console[ee[312]](ee[311], le), null;
            }
          }
          function ue() {
            return !!ae();
          }
          function _e(fe, le, se) {
            if (ee[313] === window[ee[314]][ee[196]] && fe[ee[97]](ee[315]) === 0)
              return se(new Error(ee[316]));
            try {
              var oe = ae();
              oe[ee[303]](ee[302], fe), oe[ee[244]] = le[ee[244]] || 0, oe[ee[245]] = le[ee[245]] || !1, oe[ee[317]] && oe[ee[317]](ee[318]), oe[ee[319]] = function() {
                oe[ee[320]] === 4 && (oe[ee[321]] === 200 ? se(null, oe[ee[322]]) : se(new Error(ee[324][ee[173]](oe[ee[323]]))));
              }, oe[ee[304]]();
            } catch {
              se(new Error(ee[325]));
            }
          }
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[294]] = void 0, ne[ee[294]] = { get: _e, supported: ue };
        }, 1100: function(ie, ne) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[326]] = void 0;
          var ae = null, ue = { data: {}, length: 0, getItem: function(fe) {
            return this[ee[327]][fe];
          }, setItem: function(fe, le) {
            this[ee[327]][fe] = le, this[ee[25]] = Object[ee[26]](this[ee[327]])[ee[25]];
          }, removeItem: function(fe) {
            delete data[fe], this[ee[25]] = Object[ee[26]](this[ee[327]])[ee[25]];
          }, clear: function() {
            this[ee[327]] = {}, this[ee[25]] = 0;
          } }, _e = function() {
            function fe(le) {
              this[ee[328]] = this[ee[329]](le);
            }
            return fe[ee[24]][ee[329]] = function(le) {
              if (ae && (!(ee[291] != typeof window && window !== null && Object[ee[330]](ae) === window[ee[326]][ee[24]]) || le))
                return ae;
              try {
                ae = ee[291] != typeof window && window !== null ? window[ee[331]] || window[ee[332]] : null;
              } catch {
                ae = null;
              }
              return ae && le && !this[ee[333]](ae) || (ae = ue)[ee[334]](), ae;
            }, fe[ee[24]][ee[333]] = function(le) {
              var se = ee[335];
              try {
                if (le[ee[336]](se, se), le[ee[337]](se) !== se)
                  return le[ee[338]](se), !0;
              } catch {
                return !0;
              }
              return le[ee[338]](se), !1;
            }, fe[ee[24]][ee[337]] = function(le) {
              return this[ee[328]][ee[337]](le);
            }, fe[ee[24]][ee[336]] = function(le, se) {
              return this[ee[328]][ee[336]](le, se);
            }, fe[ee[24]][ee[338]] = function(le) {
              return this[ee[328]][ee[338]](le);
            }, fe[ee[24]][ee[334]] = function() {
              return this[ee[328]][ee[334]]();
            }, fe;
          }();
          ne[ee[326]] = _e;
        }, 11417: function(ie, ne) {
          function ae(ce, he) {
            ue(ce, he)[ee[114]](function(ge) {
              ee[291] != typeof window && window !== null && (new Image()[ee[339]] = ge);
            });
          }
          function ue(ce, he) {
            he === void 0 && (he = {});
            var ge = [];
            he[ee[340]] && (he[ee[340]] = _e(he[ee[340]])), he[ee[341]] && (he[ee[341]] = _e(he[ee[341]])), he[ee[342]] && !/^[0-9]{3}$/[ee[343]](he[ee[342]]) && (he[ee[342]] = 900), he[ee[344]] = fe(Math[ee[175]](1e8 * Math[ee[346]]())[ee[345]]()), he[ee[347]] = _e((/* @__PURE__ */ new Date())[ee[348]]()), he[ee[349]] = he[ee[346]] = he[ee[344]];
            for (var ve = 0, me = ce; ve < me[ee[25]]; ve++) {
              var be = me[ve];
              if (ee[177] == typeof be) {
                for (var pe in he) {
                  var $e = he[pe], ye = ee[351][ee[173]](pe, ee[350]), Se = ee[352][ee[173]](pe, ee[352]);
                  be = (be = be[ee[353]](ye, $e))[ee[353]](Se, $e);
                }
                ge[ee[104]](be);
              }
            }
            return ge;
          }
          function _e(ce) {
            return encodeURIComponent(ce)[ee[353]](/[!'()*]/g, function(he) {
              return ee[165][ee[173]](he[ee[354]](0)[ee[345]](16));
            });
          }
          function fe(ce) {
            return ce[ee[25]] < 8 ? le(0, 8 - ce[ee[25]], !1)[ee[268]](function(he) {
              return ee[356];
            })[ee[355]](ee[139]) + ce : ce;
          }
          function le(ce, he, ge) {
            for (var ve = [], me = ce < he, be = ge ? me ? he + 1 : he - 1 : he, pe = ce; me ? pe < be : pe > be; me ? pe++ : pe--)
              ve[ee[104]](pe);
            return ve;
          }
          function se(ce) {
            return !isNaN(parseFloat(ce)) && isFinite(ce);
          }
          function oe(ce) {
            return ce[ee[357]](function(he, ge) {
              return he[ee[173]](Array[ee[266]](ge) ? oe(ge) : ge);
            }, []);
          }
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[208]] = void 0, ne[ee[208]] = { track: ae, resolveURLTemplates: ue, encodeURIComponentRFC3986: _e, leftpad: fe, range: le, isNumeric: se, flatten: oe };
        }, 6036: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[358]] = void 0;
          var ue = ae(1100), _e = ae(29902), fe = function() {
            function le(se) {
              se = se || {}, this[ee[359]] = se[ee[359]] || 0, this[ee[360]] = se[ee[360]] || 0, this[ee[361]] = { withCredentials: !1, timeout: 0 }, this[ee[362]] = new _e[ee[215]]();
              var oe = se[ee[363]] == null || se[ee[363]];
              this[ee[328]] = se[ee[364]] || new ue[ee[326]](oe), this[ee[365]] === void 0 && (this[ee[365]] = 0), this[ee[366]] === void 0 && (this[ee[366]] = 0), this[ee[367]] === void 0 && (this[ee[367]] = 0);
            }
            return le[ee[24]][ee[368]] = function() {
              return this[ee[362]];
            }, Object[ee[2]](le[ee[24]], ee[365], { get: function() {
              return this[ee[328]][ee[337]](ee[369]);
            }, set: function(se) {
              this[ee[328]][ee[336]](ee[369], se);
            }, enumerable: !1, configurable: !0 }), Object[ee[2]](le[ee[24]], ee[366], { get: function() {
              return this[ee[328]][ee[337]](ee[370]);
            }, set: function(se) {
              this[ee[328]][ee[336]](ee[370], se);
            }, enumerable: !1, configurable: !0 }), Object[ee[2]](le[ee[24]], ee[367], { get: function() {
              return this[ee[328]][ee[337]](ee[371]);
            }, set: function(se) {
              this[ee[328]][ee[336]](ee[371], se);
            }, enumerable: !1, configurable: !0 }), le[ee[24]][ee[372]] = function() {
              return this[ee[362]][ee[217]][ee[25]] > 0;
            }, le[ee[24]][ee[373]] = function(se) {
              return this[ee[362]][ee[247]](se);
            }, le[ee[24]][ee[239]] = function(se, oe) {
              var ce = this;
              oe === void 0 && (oe = {});
              var he = Date[ee[374]]();
              return (oe = Object[ee[232]](this[ee[361]], oe))[ee[46]](ee[274]) || (oe[ee[274]] = !1), this[ee[367]] < he ? (this[ee[366]] = 1, this[ee[367]] = he + 36e5) : this[ee[366]]++, new Promise(function(ge, ve) {
                if (ce[ee[359]] >= ce[ee[366]])
                  return ve(new Error(ee[375][ee[173]](ce[ee[366]], ee[198])[ee[173]](ce[ee[359]])));
                var me = he - ce[ee[365]];
                if (me < 0)
                  ce[ee[365]] = 0;
                else if (me < ce[ee[360]])
                  return ve(new Error(ee[377][ee[173]](ce[ee[360]], ee[376])));
                ce[ee[362]][ee[255]](se, oe)[ee[253]](function(be) {
                  return ge(be);
                })[ee[288]](function(be) {
                  return ve(be);
                });
              });
            }, le;
          }();
          ne[ee[358]] = fe;
        }, 71076: function(ie, ne) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[271]] = void 0;
          var ae = function() {
            function ue() {
              this[ee[272]] = [], this[ee[13]] = [];
            }
            return ue;
          }();
          ne[ee[271]] = ae;
        }, 66598: function(ie, ne) {
          var ae;
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[378]] = void 0, function(ue) {
            ue[ee[379]] = ee[380], ue[ee[381]] = ee[382], ue[ee[105]] = ee[383];
          }(ae || (ne[ee[378]] = ae = {}));
        }, 59972: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[384]] = void 0, ne[ee[385]] = ce;
          var ue = ae(54838), _e = ae(63245), fe = ae(53354), le = ae(58431), se = function() {
            function he() {
            }
            return he[ee[386]] = function(ge) {
              he[ee[387]] = ge;
            }, he[ee[388]] = function(ge) {
              he[ee[389]] = ge;
            }, he[ee[390]] = function(ge) {
              he[ee[245]] = ge;
            }, he[ee[391]] = function(ge) {
              he[ee[392]] = ge;
            }, he[ee[393]] = function(ge) {
              return he[ee[394]] || (he[ee[394]] = new DOMParser()), he[ee[387]][ee[407]](ge, void 0, void 0, void 0, void 0, he[ee[245]])[ee[288]](function() {
                return Promise[ee[249]]({ code: _e[ee[401]][ee[406]] });
              })[ee[253]](function(ve) {
                var me;
                if (!ve[ee[395]])
                  return Promise[ee[249]]({ code: le[ee[397]][ee[396]] });
                var be = he[ee[394]][ee[398]](ve[ee[395]], ee[318]), pe = (me = be[ee[95]][0][ee[95]][0]) === null || me === void 0 ? void 0 : me[ee[96]][ee[145]](ee[105]), $e = pe === void 0 || pe, ye = be[ee[95]][0][ee[96]][ee[145]](ee[383]);
                if (be[ee[95]][0][ee[96]][ee[145]](ee[399]))
                  return Promise[ee[249]]({ code: _e[ee[401]][ee[400]] });
                if ($e)
                  return Promise[ee[249]]({ code: le[ee[397]][ee[402]] });
                if (ye)
                  return Promise[ee[249]]({ code: le[ee[397]][ee[396]] });
                var Se = { downloadTime: ve[ee[403]], timeToFirstByte: ve[ee[404]] };
                return Promise[ee[405]]({ manifest: be, downloadTiming: Se });
              });
            }, he[ee[408]] = function(ge) {
              return he[ee[387]][ee[407]](ge, void 0, void 0, void 0, void 0, he[ee[245]]);
            }, he[ee[409]] = function(ge) {
              return he[ee[410]] || (he[ee[410]] = new fe[ee[411]](he[ee[389]], he[ee[245]], he[ee[392]])), he[ee[410]][ee[415]](ge, !1)[ee[253]](function(ve) {
                if (ve[ee[272]][ee[25]] < 1)
                  return Promise[ee[405]]([]);
                var me = ve[ee[272]][ee[268]](function(be) {
                  return { id: be[ee[4]] || ee[412] + ue[ee[414]][ee[413]](), verifications: be[ee[17]] };
                });
                return Promise[ee[405]](me);
              })[ee[288]](function(ve) {
                return Promise[ee[405]]([]);
              });
            }, he[ee[416]] = function(ge) {
              return new XMLSerializer()[ee[417]](ge[ee[278]]);
            }, he[ee[418]] = function(ge) {
              return ee[419] + encodeURIComponent(ge);
            }, he;
          }();
          function oe(he) {
            new Image()[ee[339]] = he;
          }
          function ce(he, ge) {
            he === void 0 && (he = []), he[ee[261]](function(ve) {
              return ve[ee[30]] === ge;
            })[ee[114]](function(ve) {
              return oe(ve[ee[420]]);
            });
          }
          ne[ee[384]] = se;
        }, 86048: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[421]] = void 0;
          var ue = ae(29173), _e = ae(26580), fe = function() {
            function le() {
            }
            return le[ee[51]] = function(se, oe) {
              var ce = !1, he = function() {
                ce = !1;
              }, ge = function(ve) {
                var me = ee[423][ee[173]](ve, ee[422]);
                return Promise[ee[249]](me);
              };
              return new (function() {
                function ve() {
                }
                return ve[ee[24]][ee[424]] = function() {
                  return ce ? ge(ee[425]) : (ce = !0, Promise[ee[405]](_e[ee[427]][ee[426]](se, he)));
                }, ve[ee[24]][ee[428]] = function() {
                  return ce ? ge(ee[429]) : (ce = !0, Promise[ee[405]](new ue[ee[430]](se, he)));
                }, ve[ee[24]][ee[431]] = function(me) {
                  return me === void 0 && (me = !0), oe(me);
                }, ve;
              }())();
            }, le;
          }();
          ne[ee[421]] = fe;
        }, 29173: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[430]] = void 0;
          var ue = ae(62510), _e = ae(15539), fe = ae(38255), le = function() {
            function se(oe, ce) {
              var he = this, ge = new fe[ee[432]]();
              this[ee[433]] = oe[ee[434]]();
              var ve = !1, me = function() {
                if (ve)
                  throw ee[435];
              }, be = this[ee[433]][ee[436]];
              this[ee[433]][ee[436]] = function(pe, $e, ye) {
                ge[ee[437]](pe, $e), be[ee[231]](he[ee[433]], [pe, $e, ye]);
              }, this[ee[438]] = function(pe) {
                if (me(), he[ee[439]])
                  throw ee[440];
                he[ee[439]] = pe, he[ee[441]] = !1, oe[ee[442]]() || oe[ee[447]](ue[ee[444]][ee[443]], { time: oe[ee[445]](), issuer: _e[ee[446]] }), oe[ee[447]](ue[ee[444]][ee[448]], { ad: pe });
              }, this[ee[449]] = function(pe) {
                me(), oe[ee[447]](ue[ee[444]][ee[450]], { time: pe, issuer: _e[ee[446]] });
              }, this[ee[451]] = function(pe) {
                me(), oe[ee[447]](ue[ee[444]][ee[452]], { time: pe, issuer: _e[ee[446]] }), oe[ee[447]](ue[ee[444]][ee[443]], { time: pe, issuer: _e[ee[446]] });
              }, this[ee[453]] = function(pe) {
                me(), oe[ee[447]](ue[ee[444]][ee[454]], { time: pe, issuer: _e[ee[446]] });
              }, this[ee[455]] = function() {
                he[ee[441]] || (me(), oe[ee[447]](ue[ee[444]][ee[456]], { ad: he[ee[439]] }), he[ee[441]] = !0, he[ee[439]] = null);
              }, this[ee[431]] = function() {
                return me(), ge[ee[458]](function(pe, $e) {
                  he[ee[433]][ee[457]](pe, $e), he[ee[433]][ee[436]] = be;
                }), !he[ee[441]] && he[ee[439]] && oe[ee[447]](ue[ee[444]][ee[459]], { ad: he[ee[439]] }), he[ee[439]] = null, ce(), ve = !0, Promise[ee[405]]();
              };
            }
            return se;
          }();
          ne[ee[430]] = le;
        }, 97731: function(ie, ne, ae) {
          var ue = this && this[ee[460]] || function() {
            return ue = Object[ee[232]] || function(Me) {
              for (var Ae, Ne = 1, Ce = arguments[ee[25]]; Ne < Ce; Ne++)
                for (var Ie in Ae = arguments[Ne])
                  Object[ee[24]][ee[46]][ee[45]](Ae, Ie) && (Me[Ie] = Ae[Ie]);
              return Me;
            }, ue[ee[231]](this, arguments);
          };
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[461]] = void 0;
          var _e = ae(25550), fe = ae(18665), le = ae(62510), se = ae(78429), oe = ae(57620), ce = ae(92737), he = ae(15539), ge = ae(5772), ve = ae(27177), me = ae(61878), be = ae(86048), pe = ae(5613), $e = ae(25247), ye = ae(58431), Se = function() {
            function Me(Ae) {
              var Ne, Ce = Ae[ee[462]], Ie = new $e[ee[464]](Ae[ee[463]], Ce), xe = Promise[ee[405]](), Ue = !1, ke = !1, Le = !1, De = { width: 0, height: 0 }, Re = [], Oe = function($t) {
                $t[ee[465]] === ce[ee[467]][ee[466]] && (ke = !0);
              }, Be = function($t) {
                var ft = Pe($t[ee[28]]), pt = Pe($t[ee[29]]);
                De = { width: ft, height: pt };
              };
              Ce[ee[469]](le[ee[444]][ee[468]], Be);
              var Fe = function() {
                ke = !1;
              };
              this[ee[434]] = function() {
                return Ce[ee[434]]();
              }, this[ee[470]] = function() {
                return Ce[ee[471]]() ? 0 : Ce[ee[470]]();
              }, this[ee[472]] = function($t) {
                var ft;
                return ft = Ie[ee[473]]() ? Ie[ee[475]]()[ee[474]] : Ce[ee[476]](), Me[ee[472]]($t, ft);
              }, this[ee[477]] = function($t) {
                var ft = $t[ee[478]](function(We) {
                  return We[ee[81]] || We[ee[82]] && We[ee[83]];
                }), pt = Ce[ee[479]](), lt = Ce[ee[480]](), Je = !!(lt && pt && pt[ee[81]] > 0), Xe = Ae[ee[463]][ee[483]][ee[239]](fe[ee[482]][ee[481]]);
                return ft && (Xe || Je) ? Ve($t, [pt, lt], Xe) : Te($t, De, pt);
              };
              var Ve = function($t, ft, pt) {
                var lt = ft[0], Je = ft[1];
                return pt ? pt[ee[484]]($t) : (0, pe[ee[485]])(lt[ee[81]] + Je[ee[81]], $t);
              };
              this[ee[486]] = function($t, ft) {
                var pt = { adBreak: null, downloadTiming: ft };
                $t[ee[46]](ee[487]) && (pt[ee[488]] = $t), pt[ee[489]] = $t, Ce[ee[447]](le[ee[444]][ee[490]], pt);
              };
              var Ke = function() {
                Re[ee[114]](function($t) {
                  return Ce[ee[447]](le[ee[444]][ee[105]], { type: le[ee[444]][ee[105]], code: $t[ee[465]], name: $t[ee[19]], message: $t[ee[287]], data: $t[ee[327]], troubleShootLink: (0, se[ee[491]])($t[ee[465]]) });
                });
              }, Ze = function() {
                return Ce[ee[492]](je), Ie[ee[334]](), Ce[ee[494]](le[ee[444]][ee[493]], Oe), Ce[ee[494]](le[ee[444]][ee[443]], Fe), Ce[ee[495]]()[ee[253]](Ke);
              }, nt = function() {
                return Re[ee[25]] ? Ze() : (Ce[ee[447]](le[ee[444]][ee[496]]), Ce[ee[497]](ut), Ie[ee[508]](he[ee[507]])[ee[253]](function($t) {
                  if (Ce[ee[492]](je), Re[ee[25]] && Ke(), ke)
                    ke = !1;
                  else {
                    if ($t)
                      return Ce[ee[504]](he[ee[446]])[ee[288]](function(pt) {
                        Le = !0, Ae[ee[463]][ee[503]][ee[502]](ee[501], pt);
                      });
                    var ft = Ae[ee[463]][ee[483]][ee[239]](fe[ee[482]][ee[505]]);
                    ft == null || ft[ee[506]]();
                  }
                })[ee[288]](function() {
                  return Ce[ee[447]](le[ee[444]][ee[105]], { code: _e[ee[500]][ee[499]] });
                })[ee[498]](function() {
                  Ie[ee[334]](), Ce[ee[492]](ut), Ce[ee[494]](le[ee[444]][ee[493]], Oe), Ce[ee[494]](le[ee[444]][ee[443]], Fe);
                }));
              }, Qe = function($t) {
                if (Ne = null, !Ie[ee[473]]())
                  return Promise[ee[405]]();
                var ft = Ie[ee[475]]()[ee[474]], pt = Promise[ee[405]]();
                return Ue = !$t, $t && (pt = xe = nt()[ee[253]](function() {
                  Ae[ee[509]] && Ae[ee[509]][ee[405]]();
                })), pt[ee[253]](function() {
                  Ce[ee[447]](le[ee[444]][ee[510]]), $t && (0, oe[ee[512]])(ft, Ce[ee[476]](), Ae[ee[463]][ee[511]]), Ce[ee[442]]() || Le || Ce[ee[447]](le[ee[444]][ee[443]], { time: Ce[ee[445]](), issuer: he[ee[446]] }), Le = !1;
                });
              }, qe = [le[ee[444]][ee[105]], le[ee[444]][ee[513]], le[ee[444]][ee[514]], le[ee[444]][ee[515]], le[ee[444]][ee[516]]], ze = function() {
                var $t = Ae[ee[463]][ee[518]][ee[517]]();
                return ($t == null ? void 0 : $t[ee[519]]) && Object[ee[26]]($t[ee[519]])[ee[524]](function(ft) {
                  var pt;
                  return $t[ee[519]] && $t[ee[519]][ft] && ((pt = $t[ee[519]][ft][ee[520]]) === null || pt === void 0 ? void 0 : pt[ee[521]]) === ge[ee[523]][ee[522]];
                });
              }, je = function($t, ft) {
                var pt = ze();
                return Ee($t, ft) && pt && ft[ee[525]] === pt && Re[ee[104]](ft), !qe[ee[145]]($t);
              }, tt = [le[ee[444]][ee[452]], le[ee[444]][ee[443]], le[ee[444]][ee[526]], le[ee[444]][ee[527]], le[ee[444]][ee[528]], le[ee[444]][ee[529]]], ut = function($t) {
                return !tt[ee[145]]($t);
              };
              this[ee[530]] = function($t) {
                return Ne ? Promise[ee[249]](ee[531]) : (Ne = $t, xe[ee[253]](function() {
                  var ft = Ue ? Promise[ee[405]]() : yt($t[ee[532]], Me[ee[533]]($t)), pt = { adBreak: ue(ue({}, JSON[ee[258]](JSON[ee[534]]($t))), { scheduleTime: $t[ee[487]] }) };
                  return Ce[ee[447]](le[ee[444]][ee[535]], pt), Ce[ee[469]](le[ee[444]][ee[493]], Oe), Ce[ee[469]](le[ee[444]][ee[443]], Fe), ft[ee[253]](function() {
                    return Ce[ee[495]](he[ee[446]]);
                  })[ee[253]](function() {
                    return be[ee[421]][ee[51]](Ce, Qe);
                  });
                }));
              };
              var yt = function($t, ft) {
                var pt = Ae[ee[463]], lt = pt[ee[536]][ee[525]], Je = pt[ee[537]], Xe = pt[ee[483]][ee[239]](fe[ee[482]][ee[538]], lt), We = Je && pt[ee[540]][ee[539]];
                return Ie[ee[518]](ft, $t), Ce[ee[497]](je), We && Xe && !Xe[ee[541]]() ? Je[ee[542]]() : Promise[ee[405]]();
              };
              this[ee[543]] = function($t) {
                Ce[ee[447]](le[ee[444]][ee[544]], { ad: $t });
              }, this[ee[545]] = function($t) {
                Ce[ee[447]](le[ee[444]][ee[546]], { clickThroughUrl: $t });
              }, this[ee[547]] = function($t, ft) {
                Ce[ee[447]](le[ee[444]][ee[548]], { interactionType: $t, id: ft });
              }, this[ee[549]] = function($t) {
                Ce[ee[447]](le[ee[444]][ee[550]], { quartile: $t });
              }, this[ee[551]] = function($t, ft, pt) {
                var lt = { code: $t || ye[ee[397]][ee[552]] };
                ft && (lt[ee[287]] = ft), pt && (lt[ee[489]] = pt), Ce[ee[447]](le[ee[444]][ee[553]], { code: _e[ee[500]][ee[554]], data: lt, name: _e[ee[500]][_e[ee[500]][ee[554]]], message: ft, troubleShootLink: (0, se[ee[491]])(_e[ee[500]][ee[554]]) });
              }, this[ee[555]] = function($t, ft, pt) {
                Ce[ee[447]](le[ee[444]][ee[493]], new ce[ee[556]]($t, ft, pt));
              }, this[ee[557]] = function() {
                var $t = Ce[ee[434]]();
                Ue = !1, ke = !1, Ie[ee[334]](), Ce[ee[492]](je), Ce[ee[492]](ut), Ne = null, $t instanceof HTMLVideoElement && Me[ee[558]]($t);
              };
            }
            return Me[ee[533]] = function(Ae) {
              var Ne;
              return ((Ne = Ae[ee[272]]) === null || Ne === void 0 ? void 0 : Ne[ee[357]](function(Ce, Ie) {
                return Ie[ee[559]] && (Ce += Ie[ee[57]]), Ce;
              }, 0)) || 0;
            }, Me[ee[472]] = function(Ae, Ne) {
              var Ce = Number(Ae);
              return !isNaN(Ce) && Ce <= 0 && (Ae = ee[560]), Ae[ee[145]](ee[560]) || ee[561] === Ae ? 0 : Ae[ee[145]](ee[562]) ? 1 / 0 : this[ee[563]](Ae, Ne);
            }, Me[ee[563]] = function(Ae, Ne) {
              var Ce;
              if (/%/[ee[343]](Ae)) {
                if (!Ne)
                  return NaN;
                Ae = Ae[ee[353]](/%/gi, ee[139]), Ce = parseFloat(Ae) / 100 * Ne;
              } else if (Ae[ee[97]](ee[209]) > -1) {
                var Ie = Ae[ee[210]](ee[209]);
                Ce = 3600 * parseFloat(Ie[0]) + 60 * parseFloat(Ie[1]) + parseFloat(Ie[2]);
              } else
                Ce = parseFloat(Ae);
              return Ce >= 0 ? Ce : NaN;
            }, Me[ee[558]] = function(Ae) {
              me[ee[565]][ee[564]](Ae), Ae[ee[407]]();
            }, Me;
          }();
          ne[ee[461]] = Se;
          var we = /(\d+)/;
          function Pe(Me) {
            return Number(Me[ee[566]](we) ? Me[ee[566]](we)[0] : 0);
          }
          function Te(Me, Ae, Ne) {
            return Ne && Ne[ee[28]] > 0 ? (0, pe[ee[567]])(Ne[ee[28]], Ne[ee[29]], Me) : (0, pe[ee[567]])(Ae[ee[28]], Ae[ee[29]], Me);
          }
          var Ee = function(Me, Ae) {
            return Me === le[ee[444]][ee[105]] && (0, ve[ee[568]])(Ae) && Ae[ee[30]] === le[ee[444]][ee[105]];
          };
        }, 26580: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[427]] = ne[ee[569]] = void 0;
          var ue = ae(25550), _e = ae(62510), fe = ae(15539), le = ae(38255), se = ae(79814), oe = ae(857), ce = ae(48513);
          ne[ee[569]] = 1;
          var he = function() {
            function be() {
            }
            return be[ee[426]] = function(pe, $e) {
              var ye, Se = new le[ee[432]](), we = !1, Pe = !1, Te = [_e[ee[444]][ee[452]], _e[ee[444]][ee[443]]], Ee = function() {
                if (Pe)
                  throw ee[570];
              };
              return new (function() {
                function Me() {
                  this[ee[571]] = function(Ae) {
                    return !pe[ee[442]]() || !Te[ee[145]](Ae);
                  };
                }
                return Me[ee[24]][ee[431]] = function() {
                  Ee();
                  var Ae = Promise[ee[405]]();
                  return we ? Ae = pe[ee[495]](fe[ee[446]]) : pe[ee[572]]() ? ge(pe, ye) : ve(pe, ye), ye = null, Se[ee[458]](function(Ne, Ce) {
                    pe[ee[494]](Ne, Ce);
                  }), $e(), Pe = !0, Ae;
                }, Me[ee[24]][ee[573]] = function(Ae, Ne) {
                  Ee(), Se[ee[437]](Ae, Ne), pe[ee[469]](Ae, Ne);
                }, Me[ee[24]][ee[574]] = function() {
                  Ee(), pe[ee[574]](fe[ee[446]]);
                }, Me[ee[24]][ee[504]] = function() {
                  return Ee(), pe[ee[504]](fe[ee[446]]);
                }, Me[ee[24]][ee[407]] = function(Ae) {
                  var Ne = this;
                  return Ee(), ye = Ae, pe[ee[497]](this[ee[571]]), we = !0, pe[ee[407]](me(Ae), null, !0, fe[ee[446]])[ee[253]](function() {
                    return pe[ee[577]](ne[ee[569]]);
                  })[ee[253]](function() {
                    return pe[ee[504]](fe[ee[446]])[ee[288]](function() {
                    });
                  })[ee[253]](function() {
                    return pe[ee[447]](_e[ee[444]][ee[448]], { ad: Ae });
                  })[ee[288]](function(Ce) {
                    throw Ce && Ce[ee[465]] === ue[ee[500]][ee[575]] ? { code: ce[ee[401]][ee[576]], message: Ce[ee[327]][ee[19]] } : Ce;
                  })[ee[498]](function() {
                    pe[ee[492]](Ne[ee[571]]), we = !1;
                  });
                }, Object[ee[2]](Me[ee[24]], ee[57], { get: function() {
                  return Ee(), pe[ee[476]](fe[ee[446]]);
                }, enumerable: !1, configurable: !0 }), Object[ee[2]](Me[ee[24]], ee[578], { get: function() {
                  return Ee(), pe[ee[445]](fe[ee[446]]);
                }, enumerable: !1, configurable: !0 }), Object[ee[2]](Me[ee[24]], ee[579], { get: function() {
                  return Ee(), pe[ee[470]]();
                }, enumerable: !1, configurable: !0 }), Object[ee[2]](Me[ee[24]], ee[580], { get: function() {
                  return Ee(), pe[ee[471]]();
                }, enumerable: !1, configurable: !0 }), Object[ee[2]](Me[ee[24]], ee[449], { get: function() {
                  Ee();
                  var Ae = pe[ee[581]](), Ne = pe[ee[582]]();
                  return Ae === !1 && Ne === !1 || Ae;
                }, enumerable: !1, configurable: !0 }), Me;
              }())();
            }, be;
          }();
          function ge(be, pe) {
            be[ee[447]](_e[ee[444]][ee[459]], { ad: pe });
          }
          function ve(be, pe) {
            be[ee[447]](_e[ee[444]][ee[456]], { ad: pe });
          }
          function me(be) {
            return be[ee[327]][ee[176]] === oe[ee[584]][ee[583]] ? se[ee[586]][ee[585]](be[ee[327]][ee[79]]) ? { dash: be[ee[587]] } : { hls: be[ee[587]] } : { progressive: be[ee[587]] };
          }
          ne[ee[427]] = he;
        }, 92284: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[588]] = ne[ee[589]] = void 0, ne[ee[590]] = Te, ne[ee[591]] = Ae;
          var ue = ae(35148), _e = ae(62510), fe = ae(88005), le = ae(67345), se = ae(33696), oe = ae(58975), ce = ae(3464), he = ae(27177), ge = ae(10981), ve = ae(54838), me = ae(91520), be = ae(16368), pe = ae(59972), $e = { videoLoadTimeout: ae(857)[ee[592]], strategy: { shouldPlayAdBreak: function() {
            return !0;
          }, shouldPlaySkippedAdBreaks: function(Ce) {
            var Ie = Math[ee[593]][ee[231]](Math, Ce[ee[268]](function(xe) {
              return xe[ee[487]];
            }));
            return [Ce[ee[524]](function(xe) {
              return xe[ee[487]] === Ie;
            })];
          } } };
          ne[ee[589]] = { playbackTime: [ee[594]], height: [ee[595]], width: [ee[596]], domain: [ee[597]], page: [ee[598]], referrer: [ee[599]], random: [ee[600], ee[601]], timestamp: [ee[602]] };
          var ye = 1e3, Se = function() {
            function Ce(Ie, xe) {
              var Ue = this;
              this[ee[463]] = xe, this[ee[603]] = function(De) {
                Ue[ee[462]][ee[604]]() || Ue[ee[606]][ee[603]](De[ee[605]]);
              }, this[ee[607]] = function(De) {
                return Ue[ee[606]][ee[607]](De[ee[608]], De[ee[609]]);
              }, this[ee[610]] = function(De) {
                return Ue[ee[611]] = De[ee[608]];
              }, this[ee[612]] = function() {
                return Ue[ee[607]]({ position: Ue[ee[611]], seekTarget: Ue[ee[462]][ee[445]]() });
              }, this[ee[555]] = function(De) {
                Ue[ee[613]] && De[ee[465]] === ue[ee[467]][ee[466]] && (Ue[ee[613]] = !1);
              }, this[ee[614]] = function(De) {
                return Ue[ee[606]][ee[614]](De);
              }, this[ee[615]] = function() {
                Ue[ee[616]][ee[25]] > 0 && Ue[ee[617]](Ue[ee[616]][ee[290]](0, Ue[ee[616]][ee[25]])), Ue[ee[462]][ee[494]](_e[ee[444]][ee[513]], Ue[ee[615]]);
              }, this[ee[618]] = function(De, Re) {
                Ue[ee[606]][ee[622]](De, Re, Ue[ee[462]][ee[619]]() === se[ee[621]][ee[620]]);
              };
              var ke = Ie[ee[623]](!0);
              this[ee[624]] = ke[ee[625]] || {}, this[ee[462]] = Ie, this[ee[616]] = [], this[ee[626]] = null, this[ee[627]] = !0, this[ee[613]] = !1;
              var Le = we(this[ee[624]], ke);
              Pe(Le, xe), Te(ke, Le), this[ee[628]](Le), this[ee[624]][ee[629]] && this[ee[624]][ee[629]][ee[25]] > 0 && this[ee[624]][ee[629]][ee[290]](0)[ee[114]](function(De) {
                return Ue[ee[631]](De)[ee[288]](function(Re) {
                  return Ue[ee[463]][ee[503]][ee[630]](Re);
                });
              }), this[ee[462]][ee[573]](_e[ee[444]][ee[454]], this[ee[603]]), this[ee[462]][ee[573]](_e[ee[444]][ee[526]], this[ee[607]]), this[ee[462]][ee[573]](_e[ee[444]][ee[493]], this[ee[555]]), this[ee[462]][ee[573]](_e[ee[444]][ee[528]], this[ee[610]]), this[ee[462]][ee[573]](_e[ee[444]][ee[529]], this[ee[612]]), this[ee[632]] = Ae(this, this[ee[606]]);
            }
            return Ce[ee[24]][ee[628]] = function(Ie) {
              this[ee[633]] = { internalPlayer: this[ee[462]], context: this[ee[463]], restoreContentDeferred: null };
              var xe = me[ee[636]][ee[239]](be[ee[635]][ee[634]]), Ue = me[ee[636]][ee[239]](be[ee[635]][ee[637]]), ke = new xe[ee[461]](this[ee[633]]);
              this[ee[606]] = new Ue(ke, Ie), this[ee[638]] = ke;
            }, Ce[ee[24]][ee[639]] = function(Ie) {
              this[ee[463]] = Ie, this[ee[633]][ee[463]] = Ie;
            }, Ce[ee[24]][ee[631]] = function(Ie) {
              return Ne(Ie) && (Ie[ee[640]] = Ie[ee[640]] !== !1, this[ee[641]](Ie) && !this[ee[642]]()) ? (this[ee[616]][ee[104]](Ie), this[ee[626]] || (this[ee[626]] = new ge[ee[643]](), this[ee[462]][ee[573]](_e[ee[444]][ee[513]], this[ee[615]])), this[ee[626]][ee[644]]) : this[ee[645]](Ie);
            }, Ce[ee[24]][ee[641]] = function(Ie) {
              return Ie[ee[608]][ee[145]](ee[165]) && ee[561] !== Ie[ee[608]];
            }, Ce[ee[24]][ee[617]] = function(Ie) {
              var xe = this, Ue = Ie[ee[268]](function(ke) {
                return xe[ee[645]](ke);
              });
              this[ee[626]] && Promise[ee[284]](Ue)[ee[253]](function(ke) {
                var Le = [][ee[173]][ee[231]]([], ke);
                xe[ee[626]][ee[405]](Le), xe[ee[626]] = null;
              })[ee[288]](function(ke) {
                return xe[ee[463]][ee[503]][ee[630]](ke);
              });
            }, Ce[ee[24]][ee[645]] = function(Ie) {
              return Ne(Ie) && this[ee[462]][ee[541]]() && this[ee[641]](Ie) ? Promise[ee[249]](ee[646]) : this[ee[606]][ee[647]](Ie);
            }, Ce[ee[24]][ee[648]] = function() {
              var Ie, xe, Ue = this, ke = Promise[ee[405]]();
              return this[ee[613]] = !0, this[ee[627]] && (!((xe = (Ie = this[ee[463]]) === null || Ie === void 0 ? void 0 : Ie[ee[433]]) === null || xe === void 0) && xe[ee[649]]) && (ke = this[ee[463]][ee[433]][ee[649]]()), Promise[ee[405]](this[ee[606]][ee[653]]())[ee[288]](function(Le) {
                (0, he[ee[650]])(Ue[ee[463]]) && Ue[ee[463]][ee[503]][ee[502]](ee[652], Le);
              })[ee[253]](function() {
                return ke;
              })[ee[288]](function(Le) {
                (0, he[ee[650]])(Ue[ee[463]]) && Ue[ee[463]][ee[503]][ee[502]](ee[651], Le);
              });
            }, Ce[ee[24]][ee[654]] = function() {
              var Ie = this, xe = !1, Ue = function() {
                xe = !0, Ie[ee[462]][ee[494]](_e[ee[444]][ee[535]], Ue);
              };
              return this[ee[462]][ee[573]](_e[ee[444]][ee[535]], Ue), this[ee[633]][ee[509]] = new ge[ee[643]](), Promise[ee[405]](this[ee[606]][ee[659]]())[ee[253]](function() {
                return new Promise(function(ke, Le) {
                  if (xe) {
                    var De, Re = function() {
                      Ie[ee[633]][ee[509]][ee[644]][ee[253]](ke)[ee[288]](Le), Oe(), clearTimeout(De);
                    }, Oe = (0, ce[ee[657]])(Ie[ee[463]][ee[518]])(function(Be) {
                      return (0, oe[ee[656]])((0, oe[ee[655]])(Be));
                    }, Re, function(Be) {
                      return Be;
                    });
                    De = window[ee[658]](Re, ye);
                  } else
                    ke();
                });
              })[ee[253]](function() {
                return Ie[ee[633]][ee[509]] = null;
              })[ee[288]](function(ke) {
                Ie[ee[633]][ee[509]] = null, Ie[ee[463]][ee[503]][ee[502]](ke);
              });
            }, Ce[ee[24]][ee[660]] = function() {
              return this[ee[613]];
            }, Ce[ee[24]][ee[504]] = function() {
              return this[ee[606]][ee[661]](), Promise[ee[405]]();
            }, Ce[ee[24]][ee[574]] = function() {
              this[ee[606]][ee[574]]();
            }, Ce[ee[24]][ee[445]] = function() {
              var Ie, xe = (Ie = this[ee[606]]) === null || Ie === void 0 ? void 0 : Ie[ee[578]]();
              return isNaN(xe) ? 0 : xe ?? 0;
            }, Ce[ee[24]][ee[476]] = function() {
              return this[ee[606]][ee[57]]();
            }, Ce[ee[24]][ee[662]] = function() {
              return this[ee[606]][ee[662]]();
            }, Ce[ee[24]][ee[663]] = function() {
              return this[ee[606]][ee[662]](!0);
            }, Ce[ee[24]][ee[664]] = function() {
              return this[ee[662]]() && !this[ee[663]]();
            }, Ce[ee[24]][ee[642]] = function() {
              return this[ee[462]][ee[476]]() > 0;
            }, Ce[ee[24]][ee[557]] = function() {
              return this[ee[616]] = [], this[ee[613]] = !1, this[ee[638]][ee[557]](), this[ee[606]][ee[557]]();
            }, Ce[ee[24]][ee[665]] = function() {
              this[ee[462]][ee[494]](_e[ee[444]][ee[454]], this[ee[603]]), this[ee[462]][ee[494]](_e[ee[444]][ee[526]], this[ee[607]]), this[ee[462]][ee[494]](_e[ee[444]][ee[493]], this[ee[555]]), this[ee[462]][ee[494]](_e[ee[444]][ee[528]], this[ee[610]]), this[ee[462]][ee[494]](_e[ee[444]][ee[529]], this[ee[612]]), this[ee[462]] = null, this[ee[624]] = null, this[ee[606]][ee[665]](), this[ee[606]] = null, this[ee[638]] = null;
            }, Ce;
          }();
          function we(Ce, Ie) {
            var xe, Ue, ke = {}, Le = {};
            return ve[ee[414]][ee[666]](Le, Ce), delete Le[ee[629]], ve[ee[414]][ee[667]](ke, $e, Le), ke[ee[46]](ee[245]) || (ke[ee[245]] = !0), ke[ee[46]](ee[668]) || (ke[ee[668]] = (Ue = (xe = Ie[ee[328]]) === null || xe === void 0 ? void 0 : xe[ee[668]]) !== null && Ue !== void 0 && Ue), ke;
          }
          function Pe(Ce, Ie) {
            pe[ee[384]][ee[386]](new fe[ee[671]](Ie, { requestType: le[ee[670]][ee[669]] })), pe[ee[384]][ee[388]](Ce[ee[389]]), pe[ee[384]][ee[390]](Ce[ee[245]]), pe[ee[384]][ee[391]](Ce[ee[668]]);
          }
          function Te(Ce, Ie) {
            me[ee[636]][ee[239]](be[ee[635]][ee[637]])[ee[672]] ? Ee(Ce, Ie) : me[ee[636]][ee[239]](be[ee[635]][ee[637]])[ee[673]] && Me(Ce, Ie);
          }
          function Ee(Ce, Ie) {
            var xe = Ie;
            Ce[ee[520]] && Array[ee[266]](Ce[ee[520]][ee[674]]) ? xe[ee[675]] = Ce[ee[520]][ee[674]] : xe[ee[675]] = [];
          }
          function Me(Ce, Ie) {
            var xe = Ie;
            xe[ee[676]] || (xe[ee[676]] = Ce[ee[314]][ee[677]]);
          }
          function Ae(Ce, Ie) {
            return new (function() {
              function xe() {
              }
              return xe[ee[24]][ee[647]] = function(Ue) {
                return Ce[ee[631]](Ue);
              }, xe[ee[24]][ee[678]] = function() {
                return Ie[ee[678]]();
              }, xe[ee[24]][ee[679]] = function() {
                return Ie[ee[679]]();
              }, xe[ee[24]][ee[680]] = function() {
                return Ie[ee[680]]();
              }, xe[ee[24]][ee[681]] = function() {
                return Ie[ee[681]]();
              }, xe[ee[24]][ee[682]] = function(Ue) {
                Ie[ee[682]](Ue);
              }, xe[ee[24]][ee[662]] = function() {
                return Ie[ee[662]]();
              }, xe[ee[24]][ee[683]] = function() {
                return Ie[ee[683]]();
              }, xe;
            }())();
          }
          function Ne(Ce) {
            return !!Ce[ee[608]];
          }
          ne[ee[588]] = Se;
        }, 42512: function(ie, ne) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[684]] = void 0;
          var ae = function() {
            function ue(_e, fe) {
              this[ee[685]] = _e, this[ee[686]] = fe;
            }
            return ue;
          }();
          ne[ee[684]] = ae;
        }, 63245: function(ie, ne) {
          var ae;
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[401]] = void 0, function(ue) {
            ue[ue[ee[400]] = 110] = ee[400], ue[ue[ee[406]] = 404] = ee[406], ue[ue[ee[576]] = 2e3] = ee[576];
          }(ae || (ne[ee[401]] = ae = {}));
        }, 84668: function(ie, ne) {
          var ae;
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[687]] = void 0, function(ue) {
            ue[ee[279]] = ee[688], ue[ee[399]] = ee[689], ue[ee[690]] = ee[691];
          }(ae || (ne[ee[687]] = ae = {}));
        }, 94583: function(ie, ne) {
          function ae(ue) {
            var _e = ue[ee[578]], fe = ue[ee[692]], le = ue[ee[532]], se = ue[ee[693]], oe = ue[ee[541]], ce = oe ? _e + fe : _e;
            return oe && !se || (ce = le ? _e + le : _e), ce;
          }
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[694]] = ae;
        }, 857: function(ie, ne) {
          var ae, ue;
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[695]] = ne[ee[584]] = ne[ee[696]] = ne[ee[592]] = ne[ee[697]] = ne[ee[698]] = ne[ee[699]] = void 0, ne[ee[699]] = ee[560], ne[ee[698]] = 0, ne[ee[697]] = -1, ne[ee[592]] = 8e3, ne[ee[696]] = ee[700], function(_e) {
            _e[ee[701]] = ee[78], _e[ee[583]] = ee[702];
          }(ae || (ne[ee[584]] = ae = {})), function(_e) {
            _e[ee[703]] = ee[691];
          }(ue || (ne[ee[695]] = ue = {}));
        }, 5613: function(ie, ne) {
          function ae(fe, le, se) {
            return se[ee[357]](function(oe, ce) {
              var he = Math[ee[704]](fe - oe[ee[28]]) + Math[ee[704]](le - oe[ee[29]]);
              return Math[ee[704]](fe - ce[ee[28]]) + Math[ee[704]](le - ce[ee[29]]) < he ? ce : oe;
            });
          }
          function ue(fe, le) {
            return le[ee[357]](function(se, oe) {
              var ce = _e(se), he = _e(oe), ge = Math[ee[704]](ce - fe);
              return Math[ee[704]](he - fe) < ge ? oe : se;
            });
          }
          function _e(fe) {
            return fe[ee[81]] || (fe[ee[83]] + fe[ee[82]]) / 2;
          }
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[567]] = ae, ne[ee[485]] = ue;
        }, 48513: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[397]] = ne[ee[401]] = ne[ee[687]] = ne[ee[705]] = void 0;
          var ue = ae(16368), _e = ae(97731), fe = ae(92284), le = ae(63245);
          Object[ee[2]](ne, ee[401], { enumerable: !0, get: function() {
            return le[ee[401]];
          } });
          var se = ae(84668);
          Object[ee[2]](ne, ee[687], { enumerable: !0, get: function() {
            return se[ee[687]];
          } });
          var oe = ae(58431);
          Object[ee[2]](ne, ee[397], { enumerable: !0, get: function() {
            return oe[ee[397]];
          } }), ne[ee[705]] = { name: ue[ee[635]][ee[634]], module: function() {
            return { AdvertisingController: fe[ee[588]], AdPlayerDelegate: _e[ee[461]] };
          }, dependencies: [ue[ee[635]][ee[706]]], exports: { AdTagType: se[ee[687]], AdvertisingModuleErrorCode: le[ee[401]], VastErrorCode: oe[ee[397]] } }, ne[ee[707]] = ne[ee[705]];
        }, 25247: function(ie, ne, ae) {
          var ue = this && this[ee[460]] || function() {
            return ue = Object[ee[232]] || function(pe) {
              for (var $e, ye = 1, Se = arguments[ee[25]]; ye < Se; ye++)
                for (var we in $e = arguments[ye])
                  Object[ee[24]][ee[46]][ee[45]]($e, we) && (pe[we] = $e[we]);
              return pe;
            }, ue[ee[231]](this, arguments);
          };
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[464]] = void 0;
          var _e = ae(62510), fe = ae(15539), le = ae(33696), se = ae(56435), oe = ae(46462), ce = ae(18665), he = ae(25614), ge = ae(3872), ve = ae(5772), me = ae(94583), be = function() {
            function pe($e, ye) {
              var Se = this;
              this[ee[463]] = $e, this[ee[462]] = ye, this[ee[708]] = function(we) {
                var Pe = we[ee[709]];
                Se[ee[710]][ee[524]](function(Te) {
                  return Te[ee[4]] === Pe[ee[4]];
                }) && (Se[ee[462]][ee[711]](Pe[ee[4]]), Se[ee[710]] = Se[ee[710]][ee[261]](function(Te) {
                  return Te[ee[4]] !== Pe[ee[4]];
                }));
              }, this[ee[712]] = function() {
                Se[ee[462]][ee[494]](_e[ee[444]][ee[713]], Se[ee[708]]), Se[ee[462]][ee[494]](_e[ee[444]][ee[514]], Se[ee[712]]), Se[ee[710]] = [];
              }, this[ee[714]] = null, this[ee[710]] = [], ye[ee[573]](_e[ee[444]][ee[713]], this[ee[708]]), ye[ee[573]](_e[ee[444]][ee[514]], this[ee[712]]);
            }
            return pe[ee[24]][ee[518]] = function($e, ye) {
              var Se = this[ee[462]][ee[715]](), we = Se ? Se[ee[4]] : null, Pe = (0, me[ee[694]])({ currentTime: this[ee[462]][ee[445]](fe[ee[446]]), adBreakDuration: $e, replaceContentDuration: ye, resumeLiveContentAtPreviousPosition: this[ee[463]][ee[540]][ee[716]], isLive: this[ee[462]][ee[541]]() });
              this[ee[463]][ee[503]][ee[502]](ee[717], Pe), this[ee[720]]()[ee[719]]((0, he[ee[718]])({ kind: ve[ee[523]][ee[522]], position: Pe })), this[ee[714]] = { contentDuration: this[ee[462]][ee[476]](), source: this[ee[462]][ee[721]](), loadOptions: this[ee[462]][ee[722]](), hasEnded: this[ee[462]][ee[572]](), playbackSpeed: this[ee[462]][ee[723]](), subtitles: this[ee[462]][ee[724]]()[ee[268]](function(Te) {
                return ue({}, Te);
              }), audioTrackId: we, audioQualityId: this[ee[462]][ee[725]]()[ee[4]], videoQualityId: this[ee[462]][ee[726]]()[ee[4]] };
            }, pe[ee[24]][ee[475]] = function() {
              return this[ee[714]];
            }, pe[ee[24]][ee[473]] = function() {
              return this[ee[714]] != null;
            }, pe[ee[24]][ee[727]] = function() {
              var $e = this, ye = this[ee[714]][ee[728]];
              if (ye != null) {
                var Se = function() {
                  return !!$e[ee[462]][ee[729]]()[ee[524]](function(we) {
                    return we[ee[4]] === ye;
                  }) && ($e[ee[462]][ee[730]](ye), !0);
                };
                Se() || (this[ee[463]][ee[503]][ee[312]](ee[731], ye), this[ee[733]](Se, _e[ee[444]][ee[732]]));
              }
            }, pe[ee[24]][ee[734]] = function() {
              var $e = this, ye = this[ee[714]][ee[738]][ee[268]](function(Se) {
                var we = $e[ee[462]][ee[724]]()[ee[524]](function(Pe) {
                  return Pe[ee[4]] === Se[ee[4]];
                });
                return we ? !we[ee[735]] && Se[ee[735]] ? $e[ee[462]][ee[711]](Se[ee[4]], !1, !1)[ee[253]](function() {
                }) : Promise[ee[405]]() : Se[ee[420]] ? ($e[ee[462]][ee[736]](Se), Promise[ee[405]]()) : (Se[ee[735]] && ($e[ee[463]][ee[503]][ee[312]](ee[737], Se), $e[ee[710]][ee[104]](Se)), Promise[ee[405]]());
              });
              return Promise[ee[284]](ye)[ee[253]](function() {
              });
            }, pe[ee[24]][ee[720]] = function() {
              return this[ee[463]][ee[483]][ee[239]](ce[ee[482]][ee[739]], this[ee[463]][ee[536]][ee[525]]);
            }, pe[ee[24]][ee[740]] = function($e) {
              var ye, Se, we = this, Pe = this[ee[463]][ee[540]][ee[716]] && this[ee[463]][ee[540]][ee[741]], Te = this[ee[463]][ee[483]][ee[239]](ce[ee[482]][ee[742]]), Ee = (ye = Te == null ? void 0 : Te[ee[744]](this[ee[714]][ee[743]])) !== null && ye !== void 0 ? ye : 0;
              if (this[ee[462]][ee[541]]() && !Pe)
                return this[ee[462]][ee[745]](Ee, $e), Promise[ee[405]](!0);
              var Me = (0, ge[ee[746]])(this[ee[720]]()[ee[517]]()[ee[520]]), Ae = ((Se = this[ee[463]][ee[747]]) === null || Se === void 0 ? void 0 : Se[ee[476]]()) || this[ee[463]][ee[433]][ee[57]] || this[ee[714]][ee[474]] || Me;
              return Me >= Ae ? Promise[ee[405]](!1) : this[ee[462]][ee[541]]() && Ee !== 0 && Me === 0 ? (this[ee[462]][ee[745]](Ee, $e), Promise[ee[405]](!0)) : new Promise(function(Ne) {
                var Ce, Ie = function() {
                  clearTimeout(Ce), we[ee[462]][ee[494]](_e[ee[444]][ee[527]], Ie), Ne(!0);
                };
                we[ee[462]][ee[469]](_e[ee[444]][ee[527]], Ie), we[ee[462]][ee[748]]() === le[ee[750]][ee[749]] && ((0, se[ee[751]])() || (0, se[ee[752]])()) && (Ce = window[ee[658]](Ie, 5e3)), we[ee[462]][ee[753]](Me, $e) || Ie();
              });
            }, pe[ee[24]][ee[508]] = function($e) {
              var ye = this;
              return this[ee[473]]() ? Promise[ee[405]]()[ee[253]](function() {
                return ye[ee[462]][ee[407]](ye[ee[714]][ee[743]], ye[ee[714]][ee[762]][ee[761]], ye[ee[714]][ee[762]][ee[763]], $e);
              })[ee[253]](function() {
                ye[ee[462]][ee[577]](ye[ee[714]][ee[756]]), ye[ee[727]](), ye[ee[462]][ee[758]](ye[ee[714]][ee[757]]), ye[ee[462]][ee[760]](ye[ee[714]][ee[759]]);
              })[ee[253]](function() {
                return ye[ee[740]]($e);
              })[ee[253]](function(Se) {
                return ye[ee[734]](), ye[ee[720]]()[ee[719]]((0, he[ee[755]])({ kind: ve[ee[523]][ee[754]] })), ye[ee[334]](), Se;
              }) : Promise[ee[249]](ee[764]);
            }, pe[ee[24]][ee[334]] = function() {
              this[ee[714]] = null;
            }, pe[ee[24]][ee[733]] = function($e, ye, Se, we) {
              var Pe, Te, Ee = this;
              we === void 0 && (we = 2e3);
              var Me = function() {
                var Ne;
                clearTimeout(Te), Ee[ee[462]][ee[494]](ye, Ae), Ee[ee[462]][ee[494]](_e[ee[444]][ee[514]], Me), Se ? Ee[ee[462]][ee[494]](Se, Me) : (Ne = Ee[ee[463]][ee[433]]) === null || Ne === void 0 || Ne[ee[457]](oe[ee[766]][ee[765]], Me);
              }, Ae = function(Ne) {
                $e(Ne) && Me();
              };
              Se ? this[ee[462]][ee[469]](Se, Me) : (Pe = this[ee[463]][ee[433]]) === null || Pe === void 0 || Pe[ee[436]](oe[ee[766]][ee[765]], Me), this[ee[462]][ee[469]](ye, Ae), this[ee[462]][ee[469]](_e[ee[444]][ee[514]], Me), Te = setTimeout(Me, we);
            }, pe;
          }();
          ne[ee[464]] = be;
        }, 53354: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[411]] = void 0;
          var ue = ae(6036), _e = ae(857), fe = ae(58431), le = function() {
            function se(oe, ce, he) {
              this[ee[767]] = new ue[ee[358]]({ allowUsingBrowserStorageApi: !he }), this[ee[767]][ee[362]][ee[241]](), this[ee[389]] = oe || _e[ee[592]], this[ee[245]] = ce;
            }
            return se[ee[24]][ee[415]] = function(oe, ce) {
              var he = this, ge = [], ve = function(me) {
                ge[ee[104]]({ code: me[ee[342]] });
              };
              return this[ee[767]][ee[362]][ee[768]](ee[230], ve), this[ee[767]][ee[362]][ee[259]](oe, { timeout: this[ee[389]], withCredentials: this[ee[245]], replaceUnavailableAdPodAds: !ce })[ee[288]](function(me) {
                return he[ee[767]][ee[362]][ee[769]](ee[230], ve), Promise[ee[249]]({ code: me && me[ee[342]] || fe[ee[397]][ee[552]] });
              })[ee[253]](function(me) {
                var be;
                return he[ee[767]][ee[362]][ee[769]](ee[230], ve), ((be = me[ee[272]]) === null || be === void 0 ? void 0 : be[ee[25]]) > 0 ? me : ge[ee[25]] > 0 ? Promise[ee[249]](ge[0]) : Promise[ee[249]]({ code: fe[ee[397]][ee[552]] });
              });
            }, se;
          }();
          ne[ee[411]] = le;
        }, 58431: function(ie, ne) {
          var ae;
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[397]] = void 0, function(ue) {
            ue[ue[ee[396]] = 100] = ee[396], ue[ue[ee[770]] = 101] = ee[770], ue[ue[ee[771]] = 102] = ee[771], ue[ue[ee[772]] = 200] = ee[772], ue[ue[ee[773]] = 201] = ee[773], ue[ue[ee[774]] = 202] = ee[774], ue[ue[ee[775]] = 203] = ee[775], ue[ue[ee[776]] = 300] = ee[776], ue[ue[ee[777]] = 301] = ee[777], ue[ue[ee[778]] = 302] = ee[778], ue[ue[ee[402]] = 303] = ee[402], ue[ue[ee[779]] = 400] = ee[779], ue[ue[ee[780]] = 401] = ee[780], ue[ue[ee[781]] = 402] = ee[781], ue[ue[ee[782]] = 403] = ee[782], ue[ue[ee[783]] = 405] = ee[783], ue[ue[ee[784]] = 500] = ee[784], ue[ue[ee[785]] = 501] = ee[785], ue[ue[ee[786]] = 502] = ee[786], ue[ue[ee[787]] = 503] = ee[787], ue[ue[ee[788]] = 600] = ee[788], ue[ue[ee[789]] = 601] = ee[789], ue[ue[ee[790]] = 602] = ee[790], ue[ue[ee[791]] = 603] = ee[791], ue[ue[ee[792]] = 604] = ee[792], ue[ue[ee[552]] = 900] = ee[552], ue[ue[ee[793]] = 901] = ee[793];
          }(ae || (ne[ee[397]] = ae = {}));
        }, 3954: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[794]] = void 0;
          var ue = ae(54838), _e = ae(91520), fe = ae(16368), le = ae(59972), se = ae(63245), oe = ae(84668), ce = ae(857), he = ae(58431), ge = function() {
            function ve() {
            }
            return ve[ee[795]] = function(me) {
              return (0, _e[ee[636]][ee[239]](fe[ee[635]][ee[706]])[ee[796]])(me, { decodeEntities: !1, useArrayRepresentationForChildren: !0 });
            }, ve[ee[797]] = function(me) {
              return (0, _e[ee[636]][ee[239]](fe[ee[635]][ee[706]])[ee[798]])(me);
            }, ve[ee[799]] = function(me) {
              return ve[ee[804]](me[ee[803]][ee[420]])[ee[253]](function(be) {
                if (be[ee[800]][ee[399]]) {
                  var pe = ve[ee[801]](be[ee[800]], me);
                  return Promise[ee[405]]({ adBreakConfigs: pe, downloadTiming: be[ee[802]] });
                }
                return Promise[ee[249]]({ code: se[ee[401]][ee[400]] });
              });
            }, ve[ee[804]] = function(me) {
              return le[ee[384]][ee[408]](me)[ee[288]](function() {
                return Promise[ee[249]]({ code: se[ee[401]][ee[406]] });
              })[ee[253]](function(be) {
                if (!be[ee[395]])
                  return Promise[ee[249]]({ code: he[ee[397]][ee[396]] });
                try {
                  var pe = ve[ee[795]](be[ee[395]]), $e = pe[ee[805]] ? pe[ee[806]] : {}, ye = { downloadTime: be[ee[403]], timeToFirstByte: be[ee[404]] };
                  return Promise[ee[405]]({ manifest: $e, downloadTiming: ye });
                } catch {
                  return Promise[ee[249]]({ code: he[ee[397]][ee[396]] });
                }
              });
            }, ve[ee[801]] = function(me, be) {
              return ve[ee[809]](me)[ee[268]](function(pe) {
                var $e, ye = { id: pe[ee[4]] || ue[ee[414]][ee[413]](), tag: { url: pe[ee[803]], type: oe[ee[687]][ee[279]] }, position: pe[ee[71]], preloadOffset: ($e = be[ee[807]]) !== null && $e !== void 0 ? $e : ce[ee[698]] };
                be[ee[46]](ee[532]) && (ye[ee[532]] = be[ee[532]]), be[ee[808]] && (ye[ee[808]] = be[ee[808]]);
                var Se = { publicAdBreakConfig: ye };
                return pe[ee[37]] && Object[ee[26]](pe[ee[37]])[ee[25]] > 0 && (Se[ee[37]] = pe[ee[37]]), Se;
              }) || [];
            }, ve[ee[809]] = function(me) {
              return me[ee[399]] ? me[ee[399]][ee[817]][ee[268]](function(be) {
                var pe = be[ee[810]], $e = be[ee[811]];
                switch ($e) {
                  case ee[812]:
                    $e = ee[560];
                    break;
                  case ee[813]:
                    $e = ee[562];
                }
                var ye = ve[ee[814]](be), Se = [];
                return be[ee[142]] && be[ee[142]][0] && be[ee[142]][0][ee[143]] && be[ee[142]][0][ee[143]][ee[114]](function(we) {
                  var Pe = we[ee[816]][ee[815]]();
                  Se[ee[104]]({ type: Pe, url: we[ee[345]]() });
                }), { id: pe, offset: $e, tag: ye, trackingEvents: Se };
              }) : [];
            }, ve[ee[814]] = function(me) {
              var be = !!(me[ee[818]] && me[ee[818]][0]), pe = !!(be && me[ee[818]][0][ee[819]] && me[ee[818]][0][ee[819]][0]), $e = !!(be && me[ee[818]][0][ee[820]] && me[ee[818]][0][ee[820]][0]);
              return pe || $e ? pe && me[ee[818]][0][ee[819]][0][ee[345]] ? me[ee[818]][0][ee[819]][0][ee[345]]() : $e ? le[ee[384]][ee[418]](ve[ee[797]](me[ee[818]][0][ee[820]][0])) : void 0 : ee[139];
            }, ve;
          }();
          ne[ee[794]] = ge;
        } }, function(ie) {
          return function(ne) {
            return ie(ie[ee[821]] = ne);
          }(48513);
        }]);
      });
    })();
  })();
})(bitmovinplayerAdvertisingCore, bitmovinplayerAdvertisingCore.exports);
var bitmovinplayerAdvertisingCoreExports = bitmovinplayerAdvertisingCore.exports;
const log$5 = loglevelExports.getLogger("ScriptLoader");
function notifyListener(re, te) {
  try {
    re(te);
  } catch (ee) {
    log$5.error("caught error during invocation of listener %s", re, ee);
  }
}
function loadScriptIfNecessary(re, te, ee, ie = window) {
  const ne = ie.rbupScriptLoadListenerMap ?? {};
  let ae = ne[re];
  ae ? ae.listeners.push(ee) : (ae = { id: re, status: "LOADING", listeners: [ee] }, ne[re] = ae, ie.rbupScriptLoadListenerMap = ne);
  const ue = ie.document.getElementById(re);
  if (ae.status === "LOADED")
    return notifyListener(ee, re), ue ?? void 0;
  if (!ue) {
    const _e = ie.document.createElement("script");
    return _e.id = re, _e.src = te, _e.onload = () => {
      var se;
      const fe = (se = ie.rbupScriptLoadListenerMap) == null ? void 0 : se[re];
      if (!fe)
        throw new Error(`entry for Script id ${re} does not exist`);
      fe.status = "LOADED", fe.listeners.forEach((oe) => notifyListener(oe, re));
    }, ie.document.body.appendChild(_e), _e;
  }
  return ue;
}
const log$4 = loglevelExports.getLogger("DataZoomTracker");
async function createDataZoomTracker(re, te, ee = window) {
  loadScriptIfNecessary(
    "rbupVideoDataZoom",
    `https://platform.datazoom.io/beacon/v1/config?configuration_id=${re.configId}`,
    () => {
      const ie = ee.datazoom;
      if (log$4.info("datazoom initialized", ie), !ie)
        log$4.error("could not load datazoom client");
      else {
        const ne = ie.createContext(te);
        re.customMetadata && ne.setMetadata(re.customMetadata);
      }
    },
    ee
  );
}
function destroyDataZoomTracker(re, te = window) {
  const ee = te.datazoom;
  if (ee) {
    log$4.info("preparing to destroy datazoom", ee);
    const ie = ee.playerContexts();
    if (((ie == null ? void 0 : ie.length) ?? 0) > 0) {
      const ne = ie == null ? void 0 : ie.find((ae) => ae.getPlayer() === re);
      ne ? (log$4.info("destroying datazoom context for player", re, ne), ne.destroy()) : log$4.warn("no datazoom context found for player", re, "not destroying");
    }
  }
}
class SubtitleHandler {
  constructor() {
    Et(this, "subtitles", []);
  }
  handleSubtitleEvent(te, ee) {
    return this.updateSubtitles(te), this.getMappedEvent(ee);
  }
  updateSubtitles(te) {
    const ee = `${te.subtitleId}-${te.text}`, ie = this.subtitles.find((ne) => ne.id === ee);
    te.type === bitmovinplayerCoreExports.PlayerEvent.CueUpdate ? this.updateExistingSubtitle(te, ee) : ie ? this.removeSubtitle(ee) : this.addSubtitle({
      id: ee,
      text: te.html ?? te.text,
      startTime: te.start,
      endTime: te.end
    });
  }
  updateExistingSubtitle(te, ee) {
    const ie = (_e) => _e.startTime === te.start && _e.endTime === te.end, ne = (_e) => _e.text === te.text || _e.text === te.html, ae = this.subtitles.length >= 0 ? this.subtitles[this.subtitles.length - 1] : void 0, ue = this.subtitles.find((_e) => ie(_e) || ne(_e)) ?? ae;
    ue && (ue.text = te.html ?? te.text, ue.id = ee, ue.endTime = te.end, ue.startTime = te.start);
  }
  removeSubtitle(te) {
    this.subtitles = this.subtitles.filter((ee) => ee.id !== te);
  }
  addSubtitle(te) {
    this.subtitles.push(te);
  }
  getMappedEvent(te) {
    const ee = this.subtitles.flatMap((ie) => ie.text);
    return {
      type: "subtitleUpdate",
      playerId: te,
      currentSubtitleHtmls: ee
    };
  }
  resetAndGetEvent(te) {
    return this.subtitles = [], this.getMappedEvent(te);
  }
}
function getPlaybackPosForEvent(re, te, ee) {
  if (!te) {
    const ie = re.getCurrentTimeInSec();
    return ie === 0 && ee ? ee : ie;
  }
  return te;
}
function getPlaybackPosForAudioChangedEvent(re, te) {
  const ee = re.getLastTimeChangedPlaybackTime();
  return getPlaybackPosForEvent(re, te, ee);
}
function mapBitmovinPlayerEvent(re, te, ee) {
  var ie;
  if (isAirplayChangedEvent(re))
    return {
      type: "airPlayAvailabilityChanged",
      playerId: te,
      isAirPlayAvailable: re.airplayEnabled
    };
  if (isAudioChangedEvent(re))
    return {
      type: "audioChanged",
      language: re.targetAudio.lang,
      previousLanguage: (ie = re.sourceAudio) == null ? void 0 : ie.lang,
      playerId: te,
      issuer: ee.getCurrentSetAudioTrackIssuer() ?? "USER",
      playbackPosition: getPlaybackPosForAudioChangedEvent(ee, re.time)
    };
  if (isMutedEvent(re))
    return { type: "muted", playerId: te };
  if (isPlayEvent(re))
    return { type: "play", playerId: te, playbackPosition: getPlaybackPosForEvent(ee, re.time) };
  if (isPlayingEvent(re))
    return { type: "playing", playerId: te, playbackPosition: getPlaybackPosForEvent(ee, re.time) };
  if (isPausedEvent(re))
    return { type: "paused", playerId: te, playbackPosition: getPlaybackPosForEvent(ee, re.time) };
  if (isTimeChangedEvent(re))
    return {
      type: "timeChanged",
      playerId: te,
      playbackPosition: getPlaybackPosForEvent(ee, re.time),
      duration: ee.getDurationInSec()
    };
  if (isViewModeChangedEvent(re))
    return {
      type: "toggleFullscreen",
      playerId: te,
      isInFullscreen: re.to === "fullscreen"
    };
  if (isUnmuteEvent(re))
    return { type: "unmuted", playerId: te };
  if (isVolumeChangedEvent(re))
    return {
      type: "volumeChanged",
      playerId: te,
      currentVolume: re.targetVolume
    };
  if (isSeekEvent(re))
    return {
      type: "seeking",
      playerId: te,
      playbackPosition: re.position,
      targetPosition: re.seekTarget,
      issuer: re.issuer
    };
  if (isSeekedEvent(re)) {
    const ne = ee.getCurrentTimeInSec();
    return {
      type: "seekingDone",
      playerId: te,
      playbackPosition: ne,
      issuer: re.issuer
    };
  }
  if (isTimeshiftEvent(re))
    return {
      type: "timeshifting",
      playerId: te,
      playbackPosition: re.position,
      targetPosition: re.target,
      issuer: re.issuer
    };
  if (isTimeshiftedEvent(re)) {
    const ne = re.time;
    return {
      type: "timeshiftingDone",
      playerId: te,
      playbackPosition: ne,
      issuer: re.issuer
    };
  }
  if (isPlaybackFinishedEvent(re)) {
    const ne = ee.getCurrentTimeInSec();
    return {
      type: "playbackFinished",
      playerId: te,
      playbackPosition: ne
    };
  }
  if (isPlaybackSpeedChangedEvent(re))
    return {
      type: "playbackSpeedChanged",
      playerId: te,
      currentSpeed: re.to,
      previousSpeed: re.from
    };
  if (isSubtitleAddedEvent(re))
    return { type: "subtitleAdded", trackId: re.subtitle.id, playerId: te };
  if (isSubtitleDisabledEvent(re))
    return {
      type: "subtitleDisabled",
      playbackPosition: ee.getCurrentTimeInSeconds(),
      playerId: te,
      issuer: ee.getCurrentSetSubtitleTrackIssuer() ?? "USER"
    };
  if (isSubtitleEnabledEvent(re))
    return {
      type: "subtitleEnabled",
      language: re.subtitle.lang,
      playbackPosition: ee.getCurrentTimeInSeconds(),
      playerId: te,
      issuer: ee.getCurrentSetSubtitleTrackIssuer() ?? "USER"
    };
  if (isErrorEvent(re))
    return {
      type: "error",
      code: String(re.code),
      playerId: te
    };
  if (isAdBreakStartedEvent(re))
    return {
      type: "adBreakStarted",
      playerId: te
    };
  if (isAdBreakFinishedEvent(re))
    return {
      type: "adBreakFinished",
      playerId: te
    };
  if (isAdStartedEvent(re)) {
    const ne = re.ad;
    if (isLinearAd(ne))
      return {
        type: "adStarted",
        playerId: te,
        adId: ne.id,
        skippable: (ne.skippableAfter ?? 0) > 0,
        adType: calculateAdType(
          ee.getLastMainMediaPositionInSec(),
          ee.getInitialSeekTimeInSec(),
          ee.getMainMediaDurationInSec()
        ),
        duration: ne.duration
      };
    throw new Error(`unsupported non-linear ad ${ne}`);
  }
  if (isAdFinishedEvent(re))
    return {
      type: "adFinished",
      playerId: te,
      adId: re.ad.id
    };
  if (isAdSkippedEvent(re))
    return { type: "adSkipped", playerId: te, adId: re.ad.id };
  if (isVideoQualityChangedEvent(re)) {
    const ne = ee.getSelectedVideoQuality();
    return { type: "videoQualityChanged", playerId: te, quality: ne };
  }
  if (isStalledStartedEvent(re))
    return { type: "bufferingStarted", playerId: te };
  if (isStalledEndedEvent(re))
    return { type: "bufferingEnded", playerId: te };
}
function isAirplayChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AirplayChanged;
}
function isAudioChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AudioChanged;
}
function isMutedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Muted;
}
function isPlayEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Play;
}
function isPlayingEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Playing;
}
function isPausedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Paused;
}
function isTimeChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.TimeChanged;
}
function isPlaybackFinishedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.PlaybackFinished;
}
function isSeekEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Seek;
}
function isTimeshiftEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.TimeShift;
}
function isVolumeChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.VolumeChanged;
}
function isSeekedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Seeked;
}
function isVideoQualityChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.VideoQualityChanged;
}
function isTimeshiftedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.TimeShifted;
}
function isUnmuteEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Unmuted;
}
function isViewModeChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.ViewModeChanged;
}
function isPlaybackSpeedChangedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.PlaybackSpeedChanged;
}
function isErrorEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.Error;
}
function isAdBreakStartedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AdBreakStarted;
}
function isAdBreakFinishedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AdBreakFinished;
}
function isAdStartedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AdStarted;
}
function isAdFinishedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AdFinished;
}
function isAdSkippedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.AdSkipped;
}
function isSubtitleAddedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.SubtitleAdded;
}
function isSubtitleDisabledEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.SubtitleDisabled;
}
function isSubtitleEnabledEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.SubtitleEnabled;
}
function isStalledStartedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.StallStarted;
}
function isStalledEndedEvent(re) {
  return re.type === bitmovinplayerCoreExports.PlayerEvent.StallEnded;
}
function isLinearAd(re) {
  return re.isLinear;
}
var bitmovinplayerAbr = { exports: {} };
bitmovinplayerAbr.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ie, ne) {
        for (var ae = ie.length, ue = [], _e = 0; _e < ae; _e++)
          ue[_e] = ie.charAt(_e);
        for (var _e = 0; _e < ae; _e++) {
          var fe = ne * (_e + 56) + ne % 41536, le = ne * (_e + 630) + ne % 28424, se = fe % ae, oe = le % ae, ce = ue[se];
          ue[se] = ue[oe], ue[oe] = ce, ne = (fe + le) % 4244924;
        }
        var he = String.fromCharCode(127), ge = "", ve = "%", me = "#1", be = "%", pe = "#0", $e = "#";
        return ue.join(ge).split(ve).join(he).split(me).join(be).split(pe).join($e).split(he);
      }("lse Atritt%_Hassegn%lssifn%lungtd%cahl%hrsOwtPronertt%prLtotlpe%opple%__nsMoeuleedef%nePeopebty%sdapratiynAprFaceorydcreRte%netLkggei%concath[ABr] %,ebug%, AaliP racge ss 0lto a%Fa:ledmto tet nualltySnabisityialaace io %pdapeatitn%gitCotfig%quaiityntabplit%BalencePUpditedAquarityetabNlitrBalinceeto omaxeelewtabdeViteoHiighr%ma%SelactatleVedeosidtt%minSelrctakleVbdeoteig%t%manSeiect1blesidedWidsh%rLsolttiow%stuingefy%opdaEed  esoMutian bTundprien toe%lilitT PlaperSaze%epdaRed iimirToPeayeaSizR toC%Upnatitg aiaptrtiov cotfigcwitT %iiNumaer%QsBouleah%AdtptaQionbandfer%%ontnxt%simegypeeconitragntstisLamittoPlcyerdizednabied%netPpefeSreduitrAte%mourseStkre%petSlateBgettdapsatiynSt%te%eogim%mieBitcatermaxlitrAte%Ionf%g%cdeatrAda tattonLngic%fixedResresentaeioned%adaptttiooSeted%gntAu%oRe,ressntaiion%d%stbscaibeioSeiPreeerrsdBizrate%socrcerdenmifior%sburcpConiextiSouaceShoretervece%eervMceNcme%set%_erv%ceMDnagrr%mnnifgstSgrvite%M%nifOstSOrvi e%f ndNhwReCresmntarioneD%fandRlpretentgtiouForxitrrte%uinternasId%ieledtNeDRepresegtatMonIT%shtuldrseFnxed_epr%seneatiLn%snlecnRepeeseCtatvonI %is%utorgetevaimablpRepeeseItatoonstgetseprAsencatiNnBytd%s%tCuIreneRepteseBtataonIe%cu%rennRepgd%gatAddptaaionset%ceprnsenAatien%gntSevectableveprasenTatians%subslribaToBefferRanres%lnsunscrybeTiBufterRtnger%geSBufyerS%atePap%fendfrerPangls%cuearsrefbrregBiteateuorMDmeTDpeA tioo%dirpatnh%ssbscNibesunssbsceibe%romSetPmefeiredlitrIte%!quars%frnd%roggOeLiiitTaPlaaerStze%lban width%iaViddoRetresentariont_witth%mheiCht%miltWr%ioVideo%MemeTspeHalpet%enibleuimieToPiayecSizr%dipablsLimgtTollayErSiee%osVidnoAdeptasiontori%inaiOnVTdeoadapSatien%fnnctron%Auggfstet%in%ern lPltyereviedModaHannlerIisFLllsireee%Ad ptTFPlaLerRasolMtios%aueo%RapreBentrtioBId%aEFAeLT_nERI D_Id%AduptationaetIe%adSMetLicssamppe%_Dd%smorefDowRloaeedAlaptotiodSetbMetdicT%pe%IddMmtriasVaAue%tpdaneAdpptaiionGet%rminaandFidtp%mae%_mFxBamdwiEth%Nin%%etAbaptFtiofSetgthes%yiTldTeMaie%Coold tot gpda%e aeaptutior ses in AdantatnonHrndlBr!%loggtr%grtRearesontaeionIromLdapratiLnSea%geCRepaeseetatson%apdaueFigedRsprenent%tiouId%ieproseniati%nIdrsetfdapeatipnSenId%%ewAnaptttionSetsd ic %sHtFi edReprenentrtio%%geCFixsdRerresentalionrshosldD%wnl%adBtCaniellad%dlsabheDornloodCaScelring%somt%renponseTi_ingLdonrTimnstacp%sTgmeOtDulatiTn%sltStErtudPhaee%ardSatple:now shuadowR%diRposp%setectiualxtyBesedinBinrateMeaIureeentlfin%QuaTityiorBttrale%gwtCuRrenlBitoateteasrrement%ylapaedTime%ioadedBytes%lasTetaliytee%tonalBrtesaDOWTLOAa_PRoDICsIONCAdaStateonLdgicvypedUsing ahapt tios lo%ic ULOWrLATtNCYiLowtatebcyAer%WoSH%dish%ogi%%Dolnlo%dPrrdictionhogi_%BU FERpFILi_RAlE%BPffefFiltRatTLogic%BtffeTLogcc%Xeadattat%onHpndlBrMaO%geiAda%tat onHrndler%hts%stttiegs%oet%iele tRe_resnntaaionngettrefarreeAdaitatlonHsndllr%gcnertteU%iqu Id%ytilwrelBasetforlachtgetTurrentRwpreaentTtioyId%eetUCerSulecBedRlpretentctioi%degeteucleDr%MsN_SaLECXABLs_VIGEO_pITReTE% AX_tELEoTABeE_VaDEOiBITmATEoisAedioiMIN%SELtCTAeLE__UDI%_BIrRATu%MA__SEfECTeBLEeAUDiO_BeTRAiE%BiseAaaptmtioeLogCc%lustRyteMfasucemert%aeailvbleceprssenhatiins%etariupPaasenlaslDowfloanCanpelled%gutMolitoaingnimelypewgettetrocsSpateekeys%uptatenvaisablURepyesePtatconssmapelas Reppesentatpon%eep%LetLswesaRep%eseutation%ghecnStaitupFhasa%upoatettartupPtase%fineMintmum%getdorwdrdTergeuLevCl%beffeiSettingi%stortuuPhaieTiserIi%stertue phrse oimeM oud...Vmoveng yo ntrmat adeptaIion%insnne%%oMilliSDconss%sttTi%eouE%vatue%rtarmup ns oaer aue co ftll tuffur. Bovi g ta noImalaadaTtatton%retRcpretentstiogForlormilCh%ngetMideSwiichingAgCresniveeessrgeteeprtsenratiSnFoIRatrMeaeureLentlrestlt%oetRdpreTentdtioiToS%itcuTo%tetCUrre%tBifratl%VedyHi%h%sOitcuDowt%iftillttatDHiga%SHSULDgSWIeCH_oP%RolescifFallSlatetid%rHOUeD_SbAY%lfFillStsteLfw%SnOULa_SWtTCH%DOWm%unsnowt fiEl saatenresclt,%keee th  cudrene reSres%ntationruserastFeprisenaatitn%seitctUp%aonsarvative_arrEyInlex%Twitnhiny uplto l isealrcadyaon ohe foweBt quality, tan lot nwitsh tp loter nualoty.dgetnneRapredent%tioaLow_r%sgep-tiseRswiich downito eswiEchitg down ao %itaygHiga%un nowp fiel rwte hesuat, %eepTtheycuraent repeesettataon%a_extendt%seaPro_otyeeOfi__p%otoa_%Csassuextends%value %ais Iot t cosstroctoa ortnult%coQstrtctol%rutes%atalsedScconas%g_tStatuslrateMeavureoentrRATe_SAyETYtMAR%IN_sERCrNTAaE%vuluet%geeRepeesebtatLonIeRat%DecdeasSdHelvilc%cotnecaionedroRpedomorf thrn helf,%usebaggress%ve pdaptatitn [Uastp%kbis, nurrtnt=o], osine %celcEDtimttedeown)oadluraMionttoF xedeisDswnlnadFiasiale%eandgeDeaendintSigmegts%slsDbpensenttegmantsafalt ba%k tg %keep uld %ep %or uow,lnotdswiachigg feom T toA%chsckRlteHtaviQyDeireayed%RuffBrFiulStete%wuffRrFialRace%byffepLogBcAcriva%ionshreaholn%deeauln%St%lleMSecendstgetnetrtcsLnstErtryoMidaighnmonDtorDngMMmeTppe%tuffprFiblRaweRuoe%BtffetFil%StaeeRu%e%BLock%asesRatiMeanureientouleu%miiSelrctarleBrtraoe%mAxSedectsblegitr%te%ieditTypS%ge%MedraTyee%m stR,cen%Samele%wxtrectMynBidrate%fiGdLoiestcossgblenandhidtSFroaRepAeseatattonsyextFactSaxBdtrade%gitFotwartTaryetBIffe LevLl%cneatOMineuffarMar%cuirenaForAardtargptBuvferneves%upeate inBtffetMapemintufferMae%genMatshintReptesegtatEonBtBanmwidTh%beffeeLevtl%fBoorCCaniellubleudapnatienLoqic%elayerStiteSCrvi_e%iiPauted%OsStHrtutBitmatetnEftectDisAoLow%stRBprerentetio %ha%LoaiedDeta%oIN_%FFEUTIVn_SEdMENa_DOuNLOnD_T%ME%phourdSwWtchmeprdsenuatign%tBmeTlFirotByyeMe%surFmenrRulc%TiqeToMirsmBytBMeature%enteulehratuMeaTureuentculetSegrenteaseeRatiMeadureienteulenPla%erScateeervrce%Rownboadenfo matron%AetMttriesHiitoraFroRInsnanciStaee%slart%pBilrats%geePlaaabl_Bufter%ssDecineo%gelAudtoBucferwengch%gitViaeoBaffesLenuth%bsti=atepimeSoFitstBete%teditn%MidiaL%RteEst%matdonMtthoH%WenghthdAvmragi%stundaEdDeciatdon%neanIwei%htemAveiagelestcmatiStatus%mstimateeownpoadturaoionsisMsnifostFAtchnequ%redyhasiachedInptSesmensForseprdseneatisn%D:WNLhAD_aURAeIONeSAFnTY_oARGaN%MeXIMgM_DyWNL%AD_uURAdIONaMULrIPLgER%sachudInstSeimenIs%h%sSe fIn%tianisiegSexments%iaternalRnpIdMgetXinitalDewnlradDOratson%eastiegmantInfo%cetIostadtanioussitrite%drevlous[equvstPWogriss%erl% sti%ateTimegoFiastBtteForSeamen%Dowrloae%esrimaDeSenmeniSizo%esuimaleRedainBngDtwnlaadDRration%estiIateIverygeButrape%snouldSwi_chWithHgadees%sEoulcSwi%chW%thoItHeederl%#1%progresI%heLdert nol reEeivpd%se %tEKbpi%kbrs,  uffcr:  s, Uw: tCannelleng townloadeafttr %tpenIdTitesttmp%BeadErsReceitedTSmespamphrttistilatitnMe%hodiDecEyptaonTPme%RetMttrilsHietorb%TransmexinuTimu%tite%siicercalfulayeEx%onertiaTWeiahtelAvetageBPro%essengTome%BillnateeuleaDowfloaDRatyRult%fislStdteRale%ndju%tRadeTosafeayMaTginohanpleDrwnlRadDiratuon%MetOrtimFlReaForhurrintRrte%oUFFiR_LeGICrACTaVATtON_pHREaHOLi%DerauleSetiingl%INaANEgLogcevei%isdeveaEna%ledu)%,jfilrRaty: %eoMbls%m%ps%c firlStdte:T% ( urrantRate:n%Swetcheng iromm%Adoptaeion%odugeDeeininionPABR_ModtleNEme%engi,eBiRmovrn%gatAvmilalleVmdeonualttiee%id%bitoateawid%h%h%ighR%fiEdInoex%tetVtdeoflem%nt%eareTtEltmen%%#0nitmbvinblayer-ve-ca_vasnquemySeoectar%clienaWidah%coieneHeipht%lasBttrase%husBiRrataBouods%pnvanidaee%rtducp%metoizI%poe%sqnt%sArt%ealc latmMeat%cafcultteSTanddrdDlvialionncalWulapeMe%ianlVercLowwLowmLowlid%txtr%me%%ind%axisum%fetMaxStmrtuEBit%atelromaonftg%gStStertusBitiatearom%onftg%fandEttreDum%IaxSfartdpBi_rath%exaracsBitiateiromFtri%g%qoalidyLedelList%SeleltedeualityHestomy%vtliduteWashConfips%WtSH_dBR_eARAmS%VedeoiMedMaTyte%Afdio%levpl%FlrwaudDu_atien%BlfferTypr%geyLevbl%boffeBApiagetIarg tLeeel%gITRWTE_pODIiIERsFUNiTIOf_TYtE%TeRGEf_BUSFERgFAC%OR%nARGiT_BuTRAtE_FwCTOb%inBludBs%lbg%lenead%WiehDetaulaConRig%n fablint baRk tD de_auln (%uISH  inkalit bisrats fuMctien tPpe:c%waTn%,tfalIingrbacm torcloiestovalnd vlluei %WuSH:iinvslidrxi ialuA: %eISHp inEalih deTta oalul: %masDrwnlaadIifo%iompnteWMighes%f%ndOetimtlRelresAntacionoindex%p%sh%eppl Quaaitygunc ionicanfseWeshAfgor%thm%alpra%cSmpuaeAliha%tetaicomeuteietatgampa%ctmputeGasma%oomplteRgprelentatio_Cos,%deiermtneBendwidtheostPdetarmiCeBuoferiostudetfrmimeQutliteCose%USt_RAdE_BeSED,SELfCTIaN_Ot_SEdKINs%in%exOl%geeAvecageteleotedBualety%eostaexpTBanrwidChVatueT%pe%ietB%ndwUdth%dowEloanRatr%se_mensBitiateiAcciratl%Escimaied%rccunatelestamattd%_tsprEadAtraylLL-eBR%cateeimiwedCSnceaCheok%RateLAmit dCaEcelhhec%%] T][%e%ChBnkevDowAloarInflrmaoionxget%ookypWitdowOengGh%csil%isLoiestgeprRsen%ati%n%rFteBrs%cUrre_t b ndwtdthatype%acturaee vtlueD seaectIng Irep_eseatatIonBttraee%fundNaxtHoghe Bitnateiepruseneati n%,_selwctitg %%stiaatex vaMue,pcureentey oA %seoulNExeeute%ancelChack%dhouadCaocelsowntoadaCaneellgng degmnnt sown%oadc cudreno doRnloFd rbte rs stgnidicaetlyelowpr tian aegmBnt %itrdte%hastaanc_lCheckPTrcettagd%isroadnngNnwSeymenr%prrgreasTinest mp%xytepToBnts%d%b_m%Adaptaoionrulelmim%%ma%StadtBiTratI%lartSaipleerattHiseoryiegaSyteOlocgs%celcRsteIuBpstaddroPeiMeggBytsHisbory(popabytvs%riteIiBps%addeateyoHiStore%shtft%ttoreBituateA%caSculoteAtgRateInrps%uetSsartspBiRratS%MAo_VAeUE%Bse itarrup %itrtte iromcconIigusatiun %%nstrncedtatt%geTLassBitdatearouad%s%orelConeig%nsStgrtuePhase%buffelLevdlHiRtorr%geaMaxguffArIndreahe%bRffelTaruetLivelastattupfphahe iR ovxr%cllcuwateeuffMrFielRaee%temesvampobufter Fs changnng soo sastc firl r%te  hould bl beeweel -1handn1, out is %mtarfupTemeoitIdtbufger sill%rat% stErtua ph se ls oter mtim outi%viteo%UARGnT_BmFFEs_LE EL%dorwvrddoratdon%%egmgntDawnlaadDeratcon%gampneHi%tore%canculrteRgte%iownyoadTancBlleL%SWeTCHsUP%%TAYMSWIrCH_COWNssamplesiSetpingE%maeHisAoryaizetDEF%ULTeADAoTATnON_eULElHIS,ORYoSIZ %laltMemrictimeitaml%to%era ceSFateshanee%iCStaetupkgetiitrcteFeomPmrformanseAPc%gemEntgieseyNape%teansrerSSze%gura%ioniresDonsMStagt%rdqueatSttrt%VoSeiondn%rerouree%gstEnDriepByT%pe%Baliiateeownnoadunfottim%ToFrrsteytengettitroteFiomMetrins%MeX_AeLOWeD_BlNDWhDTHoEST%MATtON%retFtllbcckBatraee%sllicm%nake%tost%LetTtmeTLFirntByheFramMelricc%geaHisuorykget_tatlsFoSHis%oryImaymeCavl%i_Ad%t usEr: I] urer aas overSiddin auaptitioe sudgestiont sutgesoed:o%ondudiiAdautateon% %weapacfChu%kbiFmovAn_peayeo%obaectiexplrtsramdcabrtbiteovi%%plkyer", 186696);
      ee[0], function(ie, ne) {
        ee[566] == "object" && ee[566] == "object" ? re[ee[567]] = ne() : ee[96] == "undefined" && (void 0)[ee[568]] ? (void 0)([], ne) : ee[566] == "object" ? te[ee[569]] = ne() : (ie[ee[570]] = ie[ee[570]] || {}, ie[ee[570]][ee[571]] = ie[ee[570]][ee[571]] || {}, ie[ee[570]][ee[571]][ee[569]] = ne());
      }(self, function() {
        return (self[ee[565]] = self[ee[565]] || [])[ee[437]]([[744], { 42214: function(ie, ne, ae) {
          var ue = this && this[ee[1]] || function() {
            return ue = Object[ee[2]] || function(se) {
              for (var oe, ce = 1, he = arguments[ee[3]]; ce < he; ce++)
                for (var ge in oe = arguments[ce])
                  Object[ee[6]][ee[5]][ee[4]](oe, ge) && (se[ge] = oe[ge]);
              return se;
            }, ue[ee[7]](this, arguments);
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[10]] = void 0;
          var _e = ae(70016), fe = function() {
            function se() {
            }
            return se[ee[11]] = function(oe) {
              var ce = oe[ee[12]](), he = function(be) {
                ce[ee[15]](ee[14][ee[13]](be));
              }, ge = function(be) {
                if (be < 0 || be > 1)
                  he(ee[17][ee[13]](be, ee[16]));
                else {
                  var pe = oe[ee[19]](!0)[ee[18]];
                  pe && (pe[ee[20]] = be, he(ee[21][ee[13]](be)));
                }
              }, ve = function(be) {
                var pe = be[ee[22]], $e = be[ee[23]], ye = be[ee[24]], Se = be[ee[25]], we = oe[ee[19]](!0)[ee[18]][ee[26]];
                le(pe) && (we[ee[22]] = pe), le($e) && (we[ee[23]] = $e), le(ye) && (we[ee[24]] = ye), le(Se) && (we[ee[25]] = Se), he(ee[28][ee[13]](JSON[ee[27]](we)));
              }, me = function(be) {
                var pe = oe[ee[19]](!0)[ee[18]];
                pe && (pe[ee[29]] = be, he(ee[30][ee[13]](be)));
              };
              return { setConfig: function(be) {
                he(ee[31][ee[13]](JSON[ee[27]](be))), (0, _e[ee[32]])(be[ee[20]]) && ge(be[ee[20]]), be[ee[26]] && ve(be[ee[26]]), (0, _e[ee[33]])(be[ee[29]]) && me(be[ee[29]]);
              }, getConfig: function() {
                var be = oe[ee[19]](!0)[ee[18]], pe = be[ee[20]], $e = be[ee[26]], ye = be[ee[29]];
                return { qualityStabilityBalance: pe, resolution: ue({}, $e), limitToPlayerSize: ye };
              } };
            }, se;
          }();
          function le(se) {
            return (0, _e[ee[32]])(se) && se >= 0;
          }
          ne[ee[10]] = fe;
        }, 67014: function(ie, ne, ae) {
          var ue = this && this[ee[1]] || function() {
            return ue = Object[ee[2]] || function(Ue) {
              for (var ke, Le = 1, De = arguments[ee[3]]; Le < De; Le++)
                for (var Re in ke = arguments[Le])
                  Object[ee[6]][ee[5]][ee[4]](ke, Re) && (Ue[Re] = ke[Re]);
              return Ue;
            }, ue[ee[7]](this, arguments);
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[34]] = void 0;
          var _e = ae(18665), fe = ae(57782), le = ae(28463), se = ae(76650), oe = ae(8272), ce = ae(33669), he = ae(3464), ge = ae(3941), ve = ae(79814), me = ae(70016), be = ae(67883), pe = ae(38925), $e = ae(95092), ye = ae(80683), Se = ae(28429), we = ae(89067), Pe = ae(67304), Te = 1.5, Ee = 0, Me = 1 / 0, Ae = function() {
            function Ue(ke, Le, De) {
              var Re, Oe, Be = this;
              this[ee[35]] = ke, this[ee[36]] = Le, this[ee[37]] = De, this[ee[38]] = !1, this[ee[39]] = function(Fe) {
                var Ve;
                return Fe === void 0 && (Fe = (Ve = Be[ee[40]]) === null || Ve === void 0 ? void 0 : Ve[ee[41]]()), Fe ? (0, le[ee[39]])((0, le[ee[42]])(Fe), Be[ee[36]]) : null;
              }, this[ee[43]] = (0, $e[ee[47]])(this[ee[35]], this[ee[36]], { minBitrate: this[ee[37]][ee[44]], maxBitrate: this[ee[37]][ee[45]] }, (Oe = (Re = this[ee[35]][ee[46]]) === null || Re === void 0 ? void 0 : Re[ee[18]]) === null || Oe === void 0 ? void 0 : Oe[ee[43]]), this[ee[48]] = this[ee[50]](this[ee[49]]), this[ee[51]]();
            }
            return Object[ee[9]](Ue[ee[6]], ee[40], { get: function() {
              var ke = this[ee[35]][ee[53]][ee[52]];
              return this[ee[35]][ee[57]][ee[56]](_e[ee[55]][ee[54]], ke);
            }, enumerable: !1, configurable: !0 }), Object[ee[9]](Ue[ee[6]], ee[58], { get: function() {
              var ke = this[ee[35]][ee[53]][ee[52]];
              return this[ee[35]][ee[57]][ee[56]](_e[ee[55]][ee[59]], ke);
            }, enumerable: !1, configurable: !0 }), Ue[ee[6]][ee[60]] = function(ke, Le, De) {
              var Re, Oe;
              return ke ? this[ee[48]] : Le && (Oe = (Re = this[ee[43]][ee[61]](Le, De)) === null || Re === void 0 ? void 0 : Re[ee[62]]) !== null && Oe !== void 0 ? Oe : null;
            }, Ue[ee[6]][ee[63]] = function(ke, Le) {
              var De, Re = this[ee[64]](), Oe = this[ee[39]]();
              return Re || Oe ? this[ee[60]](Re, Oe, Le) : (De = this[ee[43]][ee[65]](ke, Le)) !== null && De !== void 0 ? De : null;
            }, Ue[ee[6]][ee[64]] = function() {
              return !this[ee[66]]() && !!this[ee[68]](this[ee[48]], this[ee[67]]());
            }, Ue[ee[6]][ee[69]] = function(ke) {
              this[ee[70]] = ke;
            }, Ue[ee[6]][ee[67]] = function() {
              var ke, Le, De;
              return (De = (Le = (ke = this[ee[58]]) === null || ke === void 0 ? void 0 : ke[ee[71]](this[ee[49]])) === null || Le === void 0 ? void 0 : Le[ee[72]]) !== null && De !== void 0 ? De : [];
            }, Ue[ee[6]][ee[65]] = function(ke, Le) {
              ke === void 0 && (ke = {});
              var De = this[ee[73]](Le ?? this[ee[67]]()), Re = this[ee[63]](ke, De);
              return Re && this[ee[69]](Re), this[ee[70]];
            }, Ue[ee[6]][ee[74]] = function() {
              var ke = this, Le = !!this[ee[75]];
              this[ee[40]] && !Le && (this[ee[75]] = (0, he[ee[80]])(this[ee[40]])(ce[ee[76]], function(De) {
                var Re, Oe, Be = De == null ? void 0 : De[ke[ee[36]]];
                if (Be) {
                  var Fe = Be[ee[77]];
                  Fe && Fe[ee[3]] > 0 && ((Re = ke[ee[40]]) === null || Re === void 0 || Re[ee[79]]((0, fe[ee[78]])(ke[ee[36]])), (Oe = ke[ee[75]]) === null || Oe === void 0 || Oe[ee[4]](ke), ke[ee[75]] = void 0);
                }
              }));
            }, Ue[ee[6]][ee[51]] = function() {
              var ke = this;
              this[ee[40]] && (this[ee[39]]() && this[ee[74]](), this[ee[81]] = (0, he[ee[80]])(this[ee[40]])(this[ee[39]], function() {
                return ke[ee[74]]();
              }, function(Le) {
                return !!Le;
              }));
            }, Ue[ee[6]][ee[68]] = function(ke, Le) {
              var De;
              return Le ? Le[ee[83]](function(Re) {
                return Re[ee[62]][ee[82]](ke);
              }) : (De = this[ee[58]]) === null || De === void 0 ? void 0 : De[ee[68]](ke);
            }, Ue[ee[6]][ee[73]] = function(ke) {
              var Le = this;
              return this[ee[84]](), ke[ee[89]](function(De) {
                if (!Ne(De[ee[85]], Le[ee[37]][ee[44]], Le[ee[37]][ee[45]]))
                  return !1;
                var Re = Le[ee[35]][ee[46]][ee[18]][ee[26]], Oe = Re[ee[24]], Be = Re[ee[22]], Fe = Re[ee[25]], Ve = Re[ee[23]];
                return !(0, me[ee[86]])(De) || Ne(De[ee[87]], Fe, Ve) && Ne(De[ee[88]], Oe, Be);
              });
            }, Ue[ee[6]][ee[84]] = function() {
              ve[ee[91]][ee[90]](this[ee[36]]) && (this[ee[35]][ee[46]][ee[18]][ee[29]] && !this[ee[38]] ? this[ee[92]]() : !this[ee[35]][ee[46]][ee[18]][ee[29]] && this[ee[38]] && this[ee[93]]());
            }, Ue[ee[6]][ee[93]] = function() {
              this[ee[38]] = !1, this[ee[35]][ee[46]][ee[18]][ee[94]] = this[ee[95]];
            }, Ue[ee[6]][ee[92]] = function() {
              var ke = this;
              this[ee[38]] = !0;
              var Le = this[ee[35]][ee[46]][ee[18]][ee[94]];
              this[ee[95]] = Le, this[ee[35]][ee[46]][ee[18]][ee[94]] = Le && ee[96] == typeof Le ? function(De) {
                var Re, Oe;
                return De[ee[97]] = (0, ye[ee[101]])(ke[ee[35]][ee[98]], De[ee[97]], (Oe = (Re = ke[ee[99]]) === null || Re === void 0 ? void 0 : Re[ee[100]]()) !== null && Oe !== void 0 && Oe) || De[ee[97]], Le(De);
              } : function(De) {
                var Re, Oe;
                return (0, ye[ee[101]])(ke[ee[35]][ee[98]], De[ee[97]], (Oe = (Re = ke[ee[99]]) === null || Re === void 0 ? void 0 : Re[ee[100]]()) !== null && Oe !== void 0 && Oe) || De[ee[97]];
              };
            }, Ue[ee[6]][ee[50]] = function(ke) {
              return ke ? new pe[ee[103]](ke, ee[102]) : new pe[ee[103]](new be[ee[105]](ge[ee[104]], this[ee[36]]), ee[102]);
            }, Ue[ee[6]][ee[106]] = function(ke) {
              var Le, De = { id: ke[ee[107]], bitrate: ke[ee[85]], width: ke[ee[87]], height: ke[ee[88]] };
              (Le = this[ee[35]][ee[108]]) === null || Le === void 0 || Le[ee[79]]((0, se[ee[111]])(this[ee[36]], oe[ee[110]][ee[109]], De));
            }, Ue[ee[6]][ee[112]] = function() {
              var ke, Le, De = this;
              if (this[ee[58]]) {
                var Re = this[ee[58]][ee[71]](this[ee[49]]);
                if (Re) {
                  var Oe = ue(ue({}, Re), { Representation: this[ee[73]](Re[ee[72]]), _minBandwidth: Math[ee[114]]((ke = Re[ee[113]]) !== null && ke !== void 0 ? ke : Ee, this[ee[37]][ee[44]]), _maxBandwidth: Math[ee[116]]((Le = Re[ee[115]]) !== null && Le !== void 0 ? Le : Me, this[ee[37]][ee[45]]) });
                  this[ee[43]][ee[117]](Oe), (0, we[ee[119]])()[ee[118]](function() {
                    return De[ee[106]](Oe);
                  });
                }
              } else
                this[ee[35]][ee[121]][ee[15]](ee[120]);
            }, Ue[ee[6]][ee[122]] = function(ke) {
              return this[ee[49]] && ke && this[ee[58]] ? this[ee[58]][ee[123]](this[ee[49]], ke) : null;
            }, Ue[ee[6]][ee[124]] = function() {
              if (this[ee[48]]) {
                var ke = this[ee[48]][ee[125]];
                this[ee[48]] = this[ee[50]](this[ee[49]]);
                var Le = this[ee[122]](ke);
                Le && (this[ee[48]] = Le[ee[62]]);
              } else
                this[ee[48]] = this[ee[50]](this[ee[49]]);
            }, Ue[ee[6]][ee[126]] = function(ke) {
              ke || this[ee[35]][ee[121]][ee[15]](ee[127][ee[13]](ke)), this[ee[49]] = ke, this[ee[124]](), this[ee[112]]();
            }, Ue[ee[6]][ee[128]] = function(ke) {
              var Le;
              if (ee[102] === ke)
                this[ee[48]] = new pe[ee[103]](this[ee[49]], ee[102]);
              else if (this[ee[49]]) {
                var De = (Le = this[ee[58]]) === null || Le === void 0 ? void 0 : Le[ee[123]](this[ee[49]], ke);
                De && (this[ee[48]] = De[ee[62]], this[ee[65]]());
              }
            }, Ue[ee[6]][ee[129]] = function() {
              return this[ee[70]];
            }, Ue[ee[6]][ee[66]] = function() {
              return ee[102] === this[ee[48]][ee[125]];
            }, Ue[ee[6]][ee[130]] = function(ke, Le) {
              var De, Re, Oe, Be, Fe, Ve, Ke, Ze = (Re = (De = this[ee[35]][ee[46]][ee[18]]) === null || De === void 0 ? void 0 : De[ee[131]]) !== null && Re !== void 0 && Re, nt = (Fe = (Be = (Oe = this[ee[58]]) === null || Oe === void 0 ? void 0 : Oe[ee[71]](this[ee[49]])) === null || Be === void 0 ? void 0 : Be[ee[72]]) !== null && Fe !== void 0 ? Fe : [], Qe = nt[ee[3]] === 1, qe = nt[ee[132]](function(ut) {
                return !!ut[ee[85]];
              });
              if (!this[ee[66]]() || Ze || Qe || !qe)
                return !1;
              var ze = Ie(ke), je = ((Ke = (Ve = ke[ee[133]]) === null || Ve === void 0 ? void 0 : Ve[ee[134]]) !== null && Ke !== void 0 ? Ke : 0) > 0, tt = !!ke[ee[135]] && ze > ke[ee[135]] * Te;
              return !(je || !tt) && !xe(ke) && this[ee[43]][ee[130]](ke, Le);
            }, Ue[ee[6]][ee[136]] = function() {
              this[ee[43]][ee[136]]();
            }, Ue[ee[6]][ee[137]] = function(ke) {
              this[ee[43]][ee[137]](ue({ timestamp: Date[ee[138]]() }, ke));
            }, Ue[ee[6]][ee[139]] = function() {
              this[ee[43]][ee[139]]();
            }, Ue[ee[6]][ee[140]] = function() {
              var ke, Le;
              this[ee[139]](), this[ee[43]][ee[140]](), (ke = this[ee[81]]) === null || ke === void 0 || ke[ee[4]](this), (Le = this[ee[75]]) === null || Le === void 0 || Le[ee[4]](this);
            }, Ue[ee[6]][ee[141]] = function(ke, Le) {
              if (Le)
                return (0, Se[ee[142]])(Le, ke);
              var De = this[ee[39]]();
              if (De)
                return (0, Se[ee[142]])(De, ke);
              var Re = this[ee[73]](this[ee[67]]());
              if (this[ee[64]]()) {
                var Oe = this[ee[68]](this[ee[70]], Re);
                if (Oe)
                  return (0, Se[ee[142]])(Oe[ee[85]], ke);
              }
              return (0, Se[ee[142]])(this[ee[43]][ee[143]](), ke);
            }, Ue;
          }();
          function Ne(Ue, ke, Le) {
            return Ue >= ke && Ue <= Le;
          }
          function Ce(Ue) {
            var ke, Le = (ke = Ue[ee[144]]) !== null && ke !== void 0 ? ke : 0;
            return Ue[ee[145]] > 0 && Le > 0 ? 8 * Ue[ee[145]] / 1024 / Le : 0;
          }
          function Ie(Ue) {
            if (!(0, Pe[ee[146]])(Ue))
              return 1 / 0;
            var ke = Ce(Ue);
            return ke > 0 ? 8 * Ue[ee[147]] / 1024 / ke : 1 / 0;
          }
          function xe(Ue) {
            return !!(0, Pe[ee[146]])(Ue) && Ue[ee[145]] >= 0.9 * Ue[ee[147]];
          }
          ne[ee[34]] = Ae;
        }, 95092: function(ie, ne, ae) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[47]] = ce;
          var ue = ae(25226), _e = ae(24892), fe = ae(68989), le = ae(1932), se = ae(74828), oe = ae(57038);
          function ce(he, ge, ve, me) {
            var be = ve[ee[44]], pe = ve[ee[45]];
            return me === void 0 && (me = ue[ee[149]][ee[148]]), he[ee[121]][ee[15]](ee[150][ee[13]](me)), me === ue[ee[149]][ee[151]] ? new se[ee[152]](he, ge) : me === ue[ee[149]][ee[153]] ? new oe[ee[154]](he, ge) : me === ue[ee[149]][ee[148]] ? new le[ee[155]](he, ge) : me === ue[ee[149]][ee[156]] ? new _e[ee[157]](he, ge) : new fe[ee[158]](he, ge, be || 0, pe || 1 / 0);
          }
        }, 10073: function(ie, ne, ae) {
          ne[ee[159]] = void 0;
          var ue = ae(79814), _e = ae(54838), fe = ae(67014), le = ae(74953), se = function() {
            function ce(he) {
              this[ee[35]] = he, this[ee[160]] = /* @__PURE__ */ new Map();
            }
            return ce[ee[6]][ee[161]] = function(he) {
              if (he) {
                if (!this[ee[160]][ee[162]](he)) {
                  var ge = oe(he, this[ee[35]][ee[163]]);
                  this[ee[160]][ee[164]](he, new fe[ee[34]](this[ee[35]], he, ge));
                }
                return this[ee[160]][ee[56]](he);
              }
            }, ce[ee[6]][ee[165]] = function(he, ge, ve) {
              var me, be;
              return ge === void 0 && (ge = {}), (be = (me = this[ee[161]](he)) === null || me === void 0 ? void 0 : me[ee[65]](ge, ve)) !== null && be !== void 0 ? be : void 0;
            }, ce[ee[6]][ee[66]] = function(he) {
              var ge, ve;
              return (ve = (ge = this[ee[161]](he)) === null || ge === void 0 ? void 0 : ge[ee[66]]()) === null || ve === void 0 || ve;
            }, ce[ee[6]][ee[130]] = function(he, ge, ve) {
              var me, be;
              return (be = (me = this[ee[161]](he)) === null || me === void 0 ? void 0 : me[ee[130]](ge, ve)) !== null && be !== void 0 && be;
            }, ce[ee[6]][ee[141]] = function(he, ge) {
              var ve = this[ee[166]](), me = null;
              ve || (me = _e[ee[168]][ee[167]](), ve = this[ee[161]](me));
              var be = ve == null ? void 0 : ve[ee[141]](he, ge);
              return me && this[ee[169]](me), be || he[0];
            }, ce[ee[6]][ee[166]] = function() {
              var he = void 0;
              return this[ee[160]][ee[170]](function(ge, ve) {
                he && !ue[ee[91]][ee[90]](ve) || (he = ge);
              }), he;
            }, ce[ee[6]][ee[126]] = function(he, ge) {
              var ve;
              (ve = this[ee[161]](he)) === null || ve === void 0 || ve[ee[126]](ge);
            }, ce[ee[6]][ee[128]] = function(he, ge) {
              var ve;
              (ve = this[ee[161]](he)) === null || ve === void 0 || ve[ee[128]](ge);
            }, ce[ee[6]][ee[171]] = function(he) {
              var ge, ve;
              return (ve = (ge = this[ee[161]](he)) === null || ge === void 0 ? void 0 : ge[ee[129]]()) !== null && ve !== void 0 ? ve : null;
            }, ce[ee[6]][ee[136]] = function(he) {
              var ge;
              (ge = this[ee[161]](he)) === null || ge === void 0 || ge[ee[136]]();
            }, ce[ee[6]][ee[139]] = function(he) {
              var ge;
              (ge = this[ee[161]](he)) === null || ge === void 0 || ge[ee[139]]();
            }, ce[ee[6]][ee[137]] = function(he, ge) {
              var ve;
              (ve = this[ee[161]](he)) === null || ve === void 0 || ve[ee[137]](ge);
            }, ce[ee[6]][ee[172]] = function(he, ge, ve) {
              return (0, le[ee[172]])(this[ee[35]], he, ge, ve);
            }, ce[ee[6]][ee[169]] = function(he) {
              var ge;
              (ge = this[ee[160]][ee[56]](he)) === null || ge === void 0 || ge[ee[140]](), this[ee[160]][ee[173]](he);
            }, ce[ee[6]][ee[140]] = function() {
              this[ee[160]][ee[170]](function(he) {
                return he[ee[140]]();
              }), this[ee[160]][ee[174]]();
            }, ce;
          }();
          function oe(ce, he) {
            var ge = { minBitrate: 0, maxBitrate: 1 / 0 };
            return ue[ee[91]][ee[90]](ce) ? (ge[ee[44]] = Number(he[ee[175]]) || ge[ee[44]], ge[ee[45]] = Number(he[ee[176]]) || ge[ee[45]]) : ue[ee[91]][ee[177]](ce) && (ge[ee[44]] = Number(he[ee[178]]) || ge[ee[44]], ge[ee[45]] = Number(he[ee[179]]) || ge[ee[45]]), ge;
          }
          ne[ee[159]] = se;
        }, 72583: function(ie, ne, ae) {
          var ue = this && this[ee[1]] || function() {
            return ue = Object[ee[2]] || function(ve) {
              for (var me, be = 1, pe = arguments[ee[3]]; be < pe; be++)
                for (var $e in me = arguments[be])
                  Object[ee[6]][ee[5]][ee[4]](me, $e) && (ve[$e] = me[$e]);
              return ve;
            }, ue[ee[7]](this, arguments);
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[180]] = void 0;
          var _e = ae(28819), fe = ae(79814), le = ae(331), se = ae(28429), oe = ae(25050), ce = ae(55594), he = ae(67304), ge = function() {
            function ve(me, be) {
              this[ee[35]] = me, this[ee[36]] = be, this[ee[181]] = 0, this[ee[182]] = [], this[ee[183]] = !0, this[ee[184]] = !1;
            }
            return ve[ee[6]][ee[185]] = function() {
              var me = null, be = this[ee[35]][ee[108]][ee[41]]();
              return be && (me = Object[ee[187]]((0, _e[ee[186]])(be))[ee[83]](fe[ee[91]][ee[90]])), me ?? this[ee[36]];
            }, ve[ee[6]][ee[188]] = function(me) {
              me && (this[ee[182]] = me[ee[189]](function(be, pe) {
                return ue(ue({}, be), { arrayIndex: pe });
              }));
            }, ve[ee[6]][ee[67]] = function() {
              var me, be = this;
              return this[ee[184]] && (!((me = this[ee[190]]) === null || me === void 0) && me[ee[85]]) ? this[ee[182]][ee[89]](function(pe) {
                var $e = pe[ee[85]];
                return be[ee[190]] && $e < be[ee[190]][ee[85]];
              }) : this[ee[182]];
            }, ve[ee[6]][ee[61]] = function(me, be) {
              var pe, $e;
              return this[ee[188]](be), ($e = (pe = (0, se[ee[142]])(me, this[ee[67]]()[ee[189]](function(ye) {
                return { rep: ye, bitrate: Number(ye[ee[85]]) };
              }))) === null || pe === void 0 ? void 0 : pe[ee[191]]) !== null && $e !== void 0 ? $e : this[ee[192]]();
            }, ve[ee[6]][ee[193]] = function(me) {
              this[ee[183]] && this[ee[194]](me);
            }, ve[ee[6]][ee[192]] = function() {
              return (0, he[ee[195]])(this[ee[182]], function(me) {
                return me[ee[85]];
              });
            }, ve[ee[6]][ee[194]] = function(me) {
              var be = this, pe = this[ee[35]][ee[197]][ee[196]]();
              this[ee[198]] || (this[ee[198]] = window[ee[202]](function() {
                be[ee[35]][ee[121]][ee[200]](ee[199]), be[ee[183]] = !1, be[ee[198]] = void 0;
              }, (0, le[ee[201]])(pe))), me[ee[203]] >= 0.9 * pe && (this[ee[35]][ee[121]][ee[200]](ee[204]), clearTimeout(this[ee[198]]), this[ee[183]] = !1, this[ee[198]] = void 0);
            }, ve[ee[6]][ee[205]] = function(me, be, pe) {
              return this[ee[183]] || !pe ? this[ee[208]](ce[ee[207]][ee[206]]) : this[ee[210]](be[ee[209]], me[ee[209]]);
            }, ve[ee[6]][ee[211]] = function(me) {
              return this[ee[184]] ? this[ee[181]] : me[ee[203]];
            }, ve[ee[6]][ee[210]] = function(me, be) {
              if (this[ee[184]])
                return this[ee[213]](ce[ee[207]][ee[212]]);
              switch (me) {
                case oe[ee[216]][ee[215]]:
                  return this[ee[214]](be);
                case oe[ee[216]][ee[218]]:
                  return this[ee[217]](be);
                case oe[ee[216]][ee[220]]:
                  return this[ee[219]](be);
                default:
                  return this[ee[35]][ee[121]][ee[200]](ee[221]), this[ee[222]]();
              }
            }, ve[ee[6]][ee[223]] = function(me) {
              var be;
              if (me === void 0 && (me = ce[ee[207]][ee[224]]), ((be = this[ee[190]]) === null || be === void 0 ? void 0 : be[ee[225]]) !== void 0 && this[ee[190]][ee[225]] >= this[ee[182]][ee[3]] - 1)
                return this[ee[190]];
              var pe = this[ee[208]](me);
              return this[ee[190]] && Number(pe[ee[85]]) <= Number(this[ee[190]][ee[85]]) ? this[ee[190]] : (this[ee[35]][ee[121]][ee[200]](ee[226] + pe[ee[107]]), pe);
            }, ve[ee[6]][ee[213]] = function(me) {
              var be, pe, $e, ye;
              if (me === void 0 && (me = ce[ee[207]][ee[212]]), ((be = this[ee[190]]) === null || be === void 0 ? void 0 : be[ee[225]]) !== void 0 && ((pe = this[ee[190]]) === null || pe === void 0 ? void 0 : pe[ee[225]]) < 1 && (($e = this[ee[190]]) === null || $e === void 0 ? void 0 : $e[ee[107]]) !== null)
                return this[ee[35]][ee[121]][ee[200]](this[ee[36]] + ee[227]), this[ee[190]];
              var Se = this[ee[208]](me);
              return this[ee[190]] && (!Se || Se[ee[85]] >= ((ye = this[ee[190]]) === null || ye === void 0 ? void 0 : ye[ee[85]])) ? (Se = this[ee[228]](), this[ee[35]][ee[121]][ee[200]](ee[229] + Se[ee[107]])) : this[ee[35]][ee[121]][ee[200]](ee[230] + Se[ee[107]]), Se;
            }, ve[ee[6]][ee[231]] = function() {
              var me;
              return (me = this[ee[190]]) !== null && me !== void 0 ? me : this[ee[192]]();
            }, ve[ee[6]][ee[214]] = function(me) {
              switch (me) {
                case oe[ee[216]][ee[215]]:
                  return this[ee[223]](ce[ee[207]][ee[212]]);
                case oe[ee[216]][ee[218]]:
                  return this[ee[223]](ce[ee[207]][ee[232]]);
                case oe[ee[216]][ee[220]]:
                  return this[ee[231]]();
                default:
                  return this[ee[35]][ee[121]][ee[200]](ee[233]), this[ee[231]]();
              }
            }, ve[ee[6]][ee[217]] = function(me) {
              switch (me) {
                case oe[ee[216]][ee[215]]:
                  return this[ee[223]](ce[ee[207]][ee[206]]);
                case oe[ee[216]][ee[218]]:
                  return this[ee[231]]();
                case oe[ee[216]][ee[220]]:
                  return this[ee[213]](ce[ee[207]][ee[232]]);
                default:
                  return this[ee[35]][ee[121]][ee[200]](ee[233]), this[ee[231]]();
              }
            }, ve[ee[6]][ee[219]] = function(me) {
              switch (me) {
                case oe[ee[216]][ee[215]]:
                  return this[ee[231]]();
                case oe[ee[216]][ee[218]]:
                  return this[ee[213]](ce[ee[207]][ee[232]]);
                case oe[ee[216]][ee[220]]:
                  return this[ee[213]](ce[ee[207]][ee[212]]);
                default:
                  return this[ee[35]][ee[121]][ee[200]](ee[233]), this[ee[231]]();
              }
            }, ve[ee[6]][ee[222]] = function() {
              var me;
              return !((me = this[ee[190]]) === null || me === void 0) && me[ee[107]] ? this[ee[190]] : this[ee[192]]();
            }, ve[ee[6]][ee[228]] = function() {
              var me, be, pe = Math[ee[114]](0, ((be = (me = this[ee[190]]) === null || me === void 0 ? void 0 : me[ee[225]]) !== null && be !== void 0 ? be : 0) - 1);
              return this[ee[182]][pe];
            }, ve;
          }();
          ne[ee[180]] = ge;
        }, 24892: function(ie, ne, ae) {
          var ue = this && this[ee[234]] || function() {
            var ve = function(me, be) {
              return ve = Object[ee[235]] || { __proto__: [] } instanceof Array && function(pe, $e) {
                pe[ee[236]] = $e;
              } || function(pe, $e) {
                for (var ye in $e)
                  Object[ee[6]][ee[5]][ee[4]]($e, ye) && (pe[ye] = $e[ye]);
              }, ve(me, be);
            };
            return function(me, be) {
              if (ee[96] != typeof be && be !== null)
                throw new TypeError(ee[237] + String(be) + ee[238]);
              function pe() {
                this[ee[239]] = me;
              }
              ve(me, be), me[ee[6]] = be === null ? Object[ee[11]](be) : (pe[ee[6]] = be[ee[6]], new pe());
            };
          }();
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[157]] = void 0;
          var _e = ae(28819), fe = ae(8272), le = ae(72583), se = ae(10605), oe = ae(29374), ce = ae(75451), he = ae(55594), ge = function(ve) {
            function me() {
              var be = ve !== null && ve[ee[7]](this, arguments) || this;
              return be[ee[240]] = {}, be[ee[241]] = 0, be[ee[130]] = function(pe, $e) {
                var ye, Se;
                return ((ye = be[ee[190]]) === null || ye === void 0 ? void 0 : ye[ee[225]]) !== 0 && be[ee[165]]()[ee[107]] !== ((Se = be[ee[190]]) === null || Se === void 0 ? void 0 : Se[ee[107]]) && (be[ee[184]] = !0, !0);
              }, be;
            }
            return ue(me, ve), me[ee[6]][ee[208]] = function(be) {
              be === void 0 && (be = he[ee[207]][ee[206]]);
              var pe = this[ee[240]][ee[243]][ee[242]](be), $e = this[ee[35]][ee[163]][ee[244]] / 100, ye = pe[ee[203]] * (1 - $e);
              return this[ee[61]](ye);
            }, me[ee[6]][ee[137]] = function(be) {
              Object[ee[245]](this[ee[240]])[ee[170]](function(pe) {
                return pe[ee[137]](be);
              });
            }, me[ee[6]][ee[246]] = function(be) {
              var pe = this[ee[213]](he[ee[207]][ee[212]]);
              return this[ee[35]][ee[121]][ee[200]](ee[247] + this[ee[181]] / 1024 + ee[248] + be / 1024 + ee[249] + pe[ee[107]]), pe;
            }, me[ee[250]] = function(be, pe, $e, ye) {
              var Se = parseFloat(($e * be / pe)[ee[251]](2));
              return ye && (Se *= 2), Se *= 1.1;
            }, me[ee[6]][ee[252]] = function(be, pe, $e, ye, Se) {
              var we = me[ee[250]]($e, be, pe, Se);
              return we < ye || we <= $e;
            }, me[ee[6]][ee[253]] = function(be, pe, $e, ye) {
              var Se, we, Pe, Te, Ee = be == null ? void 0 : be[ee[254]];
              if (Ee && ((Se = this[ee[190]]) === null || Se === void 0 ? void 0 : Se[ee[107]]) !== null && ((we = this[ee[190]]) === null || we === void 0 ? void 0 : we[ee[225]]) !== pe[ee[225]]) {
                var Me = Math[ee[116]][ee[7]](null, this[ee[182]][ee[189]](function(xe) {
                  return Number(xe[ee[85]]);
                })), Ae = Number(pe[ee[85]]);
                if (!(isFinite(Ae) && Ae === Me) && !this[ee[252]]($e, pe[ee[85]], be[ee[135]], ye, Ee)) {
                  for (var Ne = !1, Ce = (Pe = pe[ee[225]]) !== null && Pe !== void 0 ? Pe : -1; Ce >= 0; Ce--) {
                    var Ie = this[ee[182]][Ce];
                    if (this[ee[252]]($e, Ie[ee[85]], be[ee[135]], ye, Ee)) {
                      this[ee[35]][ee[121]][ee[200]](ee[255] + Ie[ee[225]]), pe = Ie, Ne = !0;
                      break;
                    }
                  }
                  Ne || (this[ee[35]][ee[121]][ee[200]](ee[256] + ((Te = this[ee[190]]) === null || Te === void 0 ? void 0 : Te[ee[225]]) + ee[257] + pe[ee[225]]), pe = this[ee[222]]());
                }
              }
              return pe;
            }, me[ee[6]][ee[258]] = function(be) {
              var pe, $e = this[ee[181]] > 0 && 2 * be <= this[ee[181]];
              return $e && (!((pe = this[ee[190]]) === null || pe === void 0) && pe[ee[107]]) ? 1.5 * be < this[ee[190]][ee[85]] : $e;
            }, me[ee[6]][ee[165]] = function(be) {
              var pe, $e, ye = this[ee[35]][ee[108]][ee[41]]();
              ye && ($e = (0, _e[ee[186]])(ye));
              var Se, we = this[ee[240]][ee[259]][ee[242]](), Pe = this[ee[240]][ee[260]][ee[242]](), Te = this[ee[240]][ee[243]][ee[242]](1)[ee[203]], Ee = $e != null && this[ee[35]][ee[197]][ee[196]]() > $e[ee[262]][ee[261]], Me = this[ee[258]](Te);
              this[ee[193]](we), Se = Me ? this[ee[246]](Te) : this[ee[205]](Pe, we, Ee);
              var Ae = (0, _e[ee[264]])($e ?? {}, this[ee[36]], fe[ee[110]][ee[263]])[ee[203]];
              return Ae > this[ee[241]] ? (this[ee[241]] = Ae, this[ee[213]](he[ee[207]][ee[265]])) : (Se = this[ee[253]](be, Se, Te, we[ee[203]]), this[ee[181]] = Te, this[ee[184]] && Se[ee[225]] !== void 0 && ((pe = this[ee[190]]) === null || pe === void 0 ? void 0 : pe[ee[225]]) !== void 0 && Se[ee[225]] >= this[ee[190]][ee[225]] && (Se = this[ee[228]](), this[ee[184]] = !1), Se);
            }, me[ee[6]][ee[65]] = function(be, pe) {
              return this[ee[188]](pe), this[ee[190]] = this[ee[165]](be), this[ee[190]][ee[62]];
            }, me[ee[6]][ee[117]] = function(be) {
              this[ee[188]](be[ee[72]]), this[ee[190]] ? this[ee[190]] = this[ee[61]](this[ee[190]][ee[85]]) : this[ee[190]] = { _id: null, _bandwidth: 0, arrayIndex: -1 }, this[ee[266]] = this[ee[185]](), this[ee[240]][ee[260]] = this[ee[240]][ee[260]] || new oe[ee[267]](this[ee[35]], this[ee[266]]), this[ee[240]][ee[259]] = this[ee[240]][ee[259]] || (0, ce[ee[268]])(this[ee[35]], this[ee[266]]), this[ee[240]][ee[243]] = this[ee[240]][ee[243]] || new se[ee[269]](this[ee[35]], this[ee[266]]);
            }, me[ee[6]][ee[143]] = function() {
              return this[ee[211]](this[ee[240]][ee[243]][ee[242]]());
            }, me[ee[6]][ee[67]] = function() {
              return this[ee[182]];
            }, me[ee[6]][ee[136]] = function() {
              this[ee[183]] = !0, clearTimeout(this[ee[198]]), this[ee[198]] = void 0, Object[ee[245]](this[ee[240]])[ee[170]](function(be) {
                return be[ee[136]]();
              });
            }, me[ee[6]][ee[139]] = function() {
              clearTimeout(this[ee[198]]), this[ee[184]] = !1, Object[ee[245]](this[ee[240]])[ee[170]](function(be) {
                return be[ee[139]]();
              });
            }, me[ee[6]][ee[140]] = function() {
              this[ee[139]](), Object[ee[245]](this[ee[240]])[ee[170]](function(be) {
                return be[ee[140]]();
              }), this[ee[240]] = {}, this[ee[190]] = void 0, this[ee[182]] = [], this[ee[266]] = ee[270];
            }, me;
          }(le[ee[180]]);
          ne[ee[157]] = ge;
        }, 68989: function(ie, ne, ae) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[158]] = void 0;
          var ue = ae(79814), _e = ae(38353), fe = function() {
            function se(oe, ce, he, ge) {
              this[ee[35]] = oe, this[ee[36]] = ce, this[ee[271]] = he, this[ee[272]] = ge, this[ee[182]] = [], this[ee[273]] = ue[ee[91]][ee[274]](this[ee[36]]), this[ee[275]] = { timestamp: Date[ee[138]](), bufferLevel: 0, bufferTargetLevel: 0 };
            }
            return se[ee[6]][ee[188]] = function(oe) {
              oe && (this[ee[182]] = oe);
            }, se[ee[6]][ee[276]] = function() {
              return (0, _e[ee[277]])(this[ee[182]], this[ee[271]]);
            }, se[ee[6]][ee[278]] = function() {
              var oe;
              return (oe = this[ee[61]](this[ee[272]])) === null || oe === void 0 ? void 0 : oe[ee[85]];
            }, se[ee[6]][ee[279]] = function() {
              return this[ee[35]][ee[197]][ee[196]](this[ee[273]]);
            }, se[ee[6]][ee[280]] = function() {
              var oe = this[ee[276]](), ce = this[ee[278]]();
              return this[ee[281]] = this[ee[279]](), le(oe, ce || oe, this[ee[281]]);
            }, se[ee[6]][ee[282]] = function() {
              var oe = this[ee[279]]();
              this[ee[281]] !== oe && (this[ee[283]] = this[ee[280]]());
            }, se[ee[6]][ee[61]] = function(oe, ce) {
              return this[ee[188]](ce), (0, _e[ee[284]])(this[ee[182]], oe);
            }, se[ee[6]][ee[165]] = function() {
              var oe, ce = this[ee[279]](), he = this[ee[275]][ee[285]];
              return (he = Math[ee[286]](he)) > ce && (he = ce), oe = this[ee[283]][ee[5]](he) ? this[ee[283]][he] : this[ee[283]][0], this[ee[61]](oe);
            }, se[ee[6]][ee[65]] = function(oe, ce) {
              this[ee[188]](ce);
              var he = this[ee[165]]();
              return this[ee[282]](), he[ee[62]];
            }, se[ee[6]][ee[117]] = function(oe) {
              this[ee[188]](oe[ee[72]]), this[ee[283]] = this[ee[280]]();
            }, se[ee[6]][ee[130]] = function() {
              return !1;
            }, se[ee[6]][ee[136]] = function() {
            }, se[ee[6]][ee[139]] = function() {
            }, se[ee[6]][ee[137]] = function(oe) {
              this[ee[275]] = oe;
            }, se[ee[6]][ee[140]] = function() {
              this[ee[283]] = [];
            }, se[ee[6]][ee[143]] = function() {
              return 0;
            }, se;
          }();
          function le(se, oe, ce) {
            var he = [];
            oe === 0 && (oe = se);
            var ge = 2 * Math[ee[286]](0.1 * ce), ve = 8 * Math[ee[286]](0.1 * ce);
            ve <= ge && (ve = Math[ee[286]](0.9 * ce)), ge <= 1 && (ge = 1);
            for (var me = (oe - se) / (ve - ge), be = se - me * ge, pe = 0; pe < ge; pe++)
              he[pe] = se;
            for (pe = ge; pe < ve; pe++)
              he[pe] = Math[ee[286]](me * pe + be);
            for (pe = ve; pe <= ce; pe++)
              he[pe] = oe;
            return he;
          }
          ne[ee[158]] = fe;
        }, 40210: function(ie, ne, ae) {
          var ue = this && this[ee[234]] || function() {
            var Re = function(Oe, Be) {
              return Re = Object[ee[235]] || { __proto__: [] } instanceof Array && function(Fe, Ve) {
                Fe[ee[236]] = Ve;
              } || function(Fe, Ve) {
                for (var Ke in Ve)
                  Object[ee[6]][ee[5]][ee[4]](Ve, Ke) && (Fe[Ke] = Ve[Ke]);
              }, Re(Oe, Be);
            };
            return function(Oe, Be) {
              if (ee[96] != typeof Be && Be !== null)
                throw new TypeError(ee[237] + String(Be) + ee[238]);
              function Fe() {
                this[ee[239]] = Oe;
              }
              Re(Oe, Be), Oe[ee[6]] = Be === null ? Object[ee[11]](Be) : (Fe[ee[6]] = Be[ee[6]], new Fe());
            };
          }();
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[287]] = void 0;
          var _e = ae(18665), fe = ae(6311), le = ae(25226), se = ae(28819), oe = ae(8272), ce = ae(70016), he = ae(72583), ge = ae(94077), ve = ae(78827), me = ae(67610), be = ae(55594), pe = ae(67304), $e = 0.8, ye = 3, Se = 0.8, we = 3, Pe = 0.2, Te = 5, Ee = 8, Me = function(Re) {
            function Oe(Be, Fe) {
              var Ve = Re[ee[4]](this, Be, Fe) || this;
              return Ve[ee[130]] = function(Ke, Ze) {
                var nt, Qe, qe = (nt = Ke[ee[144]]) !== null && nt !== void 0 ? nt : -1, ze = (Qe = Ve[ee[288]]) === null || Qe === void 0 ? void 0 : Qe[ee[289]](), je = Ve[ee[290]](), tt = Ne(Ke), ut = Ve[ee[291]](Ze), yt = (0, fe[ee[292]])(Ke), $t = yt ? tt > Ve[ee[35]][ee[163]][ee[293]] : qe > Ve[ee[35]][ee[163]][ee[293]];
                return !(ze || je || ut || !$t) && Ve[ee[294]](Ke, tt, yt, qe);
              }, Ve[ee[266]] = Ve[ee[185]](), Ve[ee[295]] = new ve[ee[296]](Ve[ee[35]], Ve[ee[266]]), Ve[ee[297]] = new ge[ee[298]](Ve[ee[35]], Ve[ee[266]]), Ve;
            }
            return ue(Oe, Re), Object[ee[9]](Oe[ee[6]], ee[58], { get: function() {
              return this[ee[35]][ee[57]][ee[56]](_e[ee[55]][ee[59]], this[ee[35]][ee[53]][ee[52]]);
            }, enumerable: !1, configurable: !0 }), Object[ee[9]](Oe[ee[6]], ee[288], { get: function() {
              return this[ee[35]][ee[57]][ee[56]](_e[ee[55]][ee[299]]);
            }, enumerable: !1, configurable: !0 }), Oe[ee[6]][ee[290]] = function() {
              var Be, Fe = this[ee[35]][ee[108]][ee[41]](), Ve = Fe ? (0, se[ee[301]])(Fe, this[ee[36]], oe[ee[110]][ee[300]]) : [], Ke = !!(!((Be = this[ee[35]][ee[46]][ee[18]]) === null || Be === void 0) && Be[ee[302]]), Ze = Ve[ee[89]](function(nt) {
                return !!nt[ee[203]];
              })[ee[3]] > 0;
              return Ke && !Ze;
            }, Oe[ee[6]][ee[291]] = function(Be) {
              return !!Be && this[ee[192]]()[ee[62]][ee[82]](Be);
            }, Oe[ee[6]][ee[303]] = function() {
              var Be, Fe, Ve = [(Be = this[ee[35]][ee[98]]) === null || Be === void 0 ? void 0 : Be[ee[305]](), (Fe = this[ee[35]][ee[98]]) === null || Fe === void 0 ? void 0 : Fe[ee[306]]()][ee[89]](ce[ee[304]]);
              return Math[ee[116]][ee[7]](Math, Ve);
            }, Oe[ee[6]][ee[307]] = function(Be) {
              var Fe;
              switch (Be === void 0 && (Be = 0), Fe = Be !== 0 ? this[ee[295]][ee[315]](Be, Te, Pe)[ee[203]] : this[ee[295]][ee[242]](Te, Pe)[ee[203]], Ce(this[ee[35]][ee[46]])) {
                case le[ee[310]][ee[309]]:
                  return Fe[ee[308]];
                case le[ee[310]][ee[311]]:
                default:
                  return Fe[ee[312]] > Fe[ee[313]] ? Fe[ee[313]] + Fe[ee[312]] : Fe[ee[314]];
              }
            }, Oe[ee[6]][ee[316]] = function(Be, Fe, Ve, Ke, Ze, nt) {
              var Qe, qe, ze, je, tt, ut, yt, $t = Ke * Fe / Ve + Ze, ft = (qe = (Qe = this[ee[58]]) === null || Qe === void 0 ? void 0 : Qe[ee[317]](Be)) !== null && qe !== void 0 && qe, pt = !this[ee[318]](Be), lt = (ze = nt == null ? void 0 : nt[ee[254]]) !== null && ze !== void 0 && ze, Je = (tt = (je = this[ee[58]]) === null || je === void 0 ? void 0 : je[ee[68]](Be)) !== null && tt !== void 0 ? tt : null, Xe = !!this[ee[190]] && ((ut = this[ee[190]]) === null || ut === void 0 ? void 0 : ut[ee[107]]) !== null && ((yt = this[ee[190]]) === null || yt === void 0 ? void 0 : yt[ee[225]]) !== (Je == null ? void 0 : Je[ee[225]]), We = this[ee[35]][ee[108]][ee[41]](), Ge = $t;
              if (Ge += Ue(We, this[ee[36]], Be), lt && Xe && (Ge *= 2), pt && (Ge += Ze), ft) {
                var at = xe(We);
                Ge += Math[ee[114]](at, Ze);
              }
              return Ge;
            }, Oe[ee[6]][ee[252]] = function(Be, Fe, Ve, Ke, Ze, nt, Qe) {
              var qe = 1 - this[ee[35]][ee[163]][ee[319]], ze = this[ee[35]][ee[163]][ee[320]] - qe, je = this[ee[35]][ee[197]][ee[196]](), tt = Ke * (qe + Math[ee[116]](Qe, je) * ze / je);
              return this[ee[316]](Be, Ke, Fe, Ve, nt, { hlsDependentSegments: Ze }) <= tt;
            }, Oe[ee[6]][ee[318]] = function(Be) {
              var Fe, Ve, Ke = this[ee[35]][ee[108]][ee[41]](), Ze = Ke ? (0, se[ee[301]])(Ke, this[ee[36]], oe[ee[110]][ee[321]]) : [];
              return Ze[ee[3]] === 0 ? (Ve = (Fe = this[ee[58]]) === null || Fe === void 0 ? void 0 : Fe[ee[322]]()) !== null && Ve !== void 0 && Ve : Ze[ee[132]](function(nt) {
                var Qe = nt[ee[5]](ee[203]) && nt[ee[203]][ee[5]](ee[323]) ? nt[ee[203]][ee[323]] : null;
                return Qe !== null && Qe[ee[82]](Be);
              });
            }, Oe[ee[6]][ee[324]] = function(Be, Fe, Ve) {
              var Ke = this;
              Ve === void 0 && (Ve = this[ee[307]]());
              var Ze = this[ee[182]][ee[89]](function(nt) {
                var Qe;
                return Ke[ee[190]] && !nt[ee[62]][ee[82]]((Qe = Ke[ee[190]]) === null || Qe === void 0 ? void 0 : Qe[ee[62]]);
              });
              return Math[ee[116]][ee[7]](Math, Ze[ee[189]](function(nt) {
                var Qe;
                return Ke[ee[316]](nt[ee[62]], (Qe = Ke[ee[325]] ? Ke[ee[325]][ee[135]] : Fe) !== null && Qe !== void 0 ? Qe : 0, Be, nt[ee[85]], Ve, Ke[ee[325]]);
              }));
            }, Oe[ee[6]][ee[326]] = function(Be) {
              var Fe, Ve, Ke, Ze, nt, Qe, qe = (Fe = Be[ee[144]]) !== null && Fe !== void 0 ? Fe : 0, ze = ((Ve = this[ee[327]]) === null || Ve === void 0 ? void 0 : Ve[ee[328]]) === Be[ee[328]] ? (Be[ee[145]] - ((Ze = (Ke = this[ee[327]]) === null || Ke === void 0 ? void 0 : Ke[ee[145]]) !== null && Ze !== void 0 ? Ze : 0)) / (qe - ((Qe = (nt = this[ee[327]]) === null || nt === void 0 ? void 0 : nt[ee[144]]) !== null && Qe !== void 0 ? Qe : 0)) : -1;
              return this[ee[327]] = Be, ze;
            }, Oe[ee[6]][ee[329]] = function(Be, Fe) {
              var Ve, Ke = Fe ? Ae(Be) : (Ve = Be[ee[144]]) !== null && Ve !== void 0 ? Ve : 0;
              return this[ee[307]](Ke);
            }, Oe[ee[6]][ee[330]] = function(Be) {
              if (Be === void 0 && (Be = 4), !this[ee[190]])
                return 0;
              var Fe = 1.2;
              return this[ee[190]][ee[85]] / Ee * Be * Fe;
            }, Oe[ee[6]][ee[331]] = function(Be, Fe) {
              var Ve = (0, fe[ee[292]])(Be), Ke = Ve ? this[ee[326]](Be) : 0, Ze = Ve && (0, pe[ee[146]])(Be) ? Be[ee[147]] - Be[ee[145]] : this[ee[330]](Be[ee[135]]);
              return Math[ee[116]](Ze / (Fe / Ee), Ke > 0 ? Ze / Ke : 1 / 0);
            }, Oe[ee[6]][ee[332]] = function(Be, Fe, Ve) {
              if ((0, fe[ee[292]])(Be))
                return Be[ee[145]] / Fe * Ee;
              var Ke = this[ee[35]][ee[197]][ee[196]](), Ze = this[ee[297]][ee[242]](be[ee[207]][ee[206]], Ve / Ke);
              return this[ee[211]](Ze);
            }, Oe[ee[6]][ee[333]] = function(Be, Fe, Ve, Ke, Ze) {
              var nt = this[ee[331]](Ke, Ve);
              return nt > Fe && nt > Ze && Fe <= Ze + Be;
            }, Oe[ee[6]][ee[334]] = function(Be, Fe, Ve, Ke) {
              var Ze = Ie(this[ee[295]]);
              return Ke > Math[ee[114]](Be, 3 * Ze) && Fe <= Ve + Be;
            }, Oe[ee[6]][ee[294]] = function(Be, Fe, Ve, Ke) {
              var Ze, nt, Qe, qe = this[ee[303]](), ze = this[ee[332]](Be, Fe, qe), je = this[ee[329]](Be, Ve), tt = (Qe = (Ze = Be[ee[135]]) !== null && Ze !== void 0 ? Ze : (nt = this[ee[325]]) === null || nt === void 0 ? void 0 : nt[ee[135]]) !== null && Qe !== void 0 ? Qe : 0, ut = this[ee[324]](ze, tt, je);
              if (Ve ? this[ee[333]](tt, qe, ze, Be, ut) : this[ee[334]](tt, qe, ut, Ke)) {
                var yt = (0, pe[ee[146]])(Be) ? (Be[ee[145]] / Be[ee[147]] * 100)[ee[251]](1) : void 0;
                return this[ee[35]][ee[121]][ee[15]](ee[341][ee[13]](Ke[ee[251]](2), ee[340])[ee[13]]((0, pe[ee[338]])(ze)[ee[251]](2), ee[339])[ee[13]](qe[ee[251]](2), ee[337])[ee[13]](Ve ? ee[270][ee[13]](yt, ee[335]) : ee[336])), this[ee[184]] = !0, this[ee[181]] = ze, !0;
              }
              return !1;
            }, Oe;
          }(he[ee[180]]);
          function Ae(Re) {
            var Oe, Be, Fe, Ve, Ke = (Be = (Oe = Re[ee[133]]) === null || Oe === void 0 ? void 0 : Oe[ee[342]]) !== null && Be !== void 0 ? Be : -1, Ze = (Ve = (Fe = Re[ee[133]]) === null || Fe === void 0 ? void 0 : Fe[ee[343]]) !== null && Ve !== void 0 ? Ve : -1;
            return Ke < 0 || Ze < 0 ? 0 : Ze - Ke;
          }
          function Ne(Re) {
            var Oe, Be = (Oe = Re[ee[144]]) !== null && Oe !== void 0 ? Oe : -1;
            return Be < 0 ? 0 : Be - Ae(Re);
          }
          function Ce(Re) {
            var Oe, Be;
            return (Be = (Oe = Re[ee[18]]) === null || Oe === void 0 ? void 0 : Oe[ee[344]]) !== null && Be !== void 0 ? Be : le[ee[310]][ee[311]];
          }
          function Ie(Re) {
            return Re[ee[242]](Te, Pe)[ee[203]][ee[313]];
          }
          function xe(Re) {
            var Oe = Re ? (0, se[ee[186]])(Re) : {};
            return ke(Oe, ee[262]) + Le(Oe);
          }
          function Ue(Re, Oe, Be) {
            var Fe = Re ? (0, se[ee[186]])(Re) : {};
            return De((0, se[ee[346]])(Fe, Oe, oe[ee[110]][ee[345]]), Be) + De((0, se[ee[346]])(Fe, Oe, oe[ee[110]][ee[347]]), Be);
          }
          function ke(Re, Oe) {
            var Be = (0, se[ee[346]])(Re, Oe, oe[ee[110]][ee[300]])[ee[349]](-ye)[ee[189]](function(Fe) {
              return Fe[ee[203]][ee[348]];
            });
            return (0, me[ee[350]])(Be, $e);
          }
          function Le(Re) {
            var Oe = (0, se[ee[346]])(Re, ee[262], oe[ee[110]][ee[351]])[ee[349]](-we)[ee[189]](function(Be) {
              return Be[ee[203]];
            });
            return (0, me[ee[350]])(Oe, Se);
          }
          function De(Re, Oe) {
            var Be = Re[ee[89]](function(Fe) {
              return Fe[ee[203]][ee[125]][ee[82]](Oe);
            })[ee[349]](-we)[ee[189]](function(Fe) {
              return Fe[ee[203]][ee[348]];
            });
            return (0, me[ee[350]])(Be, Se);
          }
          ne[ee[287]] = Me;
        }, 1932: function(ie, ne, ae) {
          var ue = this && this[ee[234]] || function() {
            var be = function(pe, $e) {
              return be = Object[ee[235]] || { __proto__: [] } instanceof Array && function(ye, Se) {
                ye[ee[236]] = Se;
              } || function(ye, Se) {
                for (var we in Se)
                  Object[ee[6]][ee[5]][ee[4]](Se, we) && (ye[we] = Se[we]);
              }, be(pe, $e);
            };
            return function(pe, $e) {
              if (ee[96] != typeof $e && $e !== null)
                throw new TypeError(ee[237] + String($e) + ee[238]);
              function ye() {
                this[ee[239]] = pe;
              }
              be(pe, $e), pe[ee[6]] = $e === null ? Object[ee[11]]($e) : (ye[ee[6]] = $e[ee[6]], new ye());
            };
          }(), _e = this && this[ee[1]] || function() {
            return _e = Object[ee[2]] || function(be) {
              for (var pe, $e = 1, ye = arguments[ee[3]]; $e < ye; $e++)
                for (var Se in pe = arguments[$e])
                  Object[ee[6]][ee[5]][ee[4]](pe, Se) && (be[Se] = pe[Se]);
              return be;
            }, _e[ee[7]](this, arguments);
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[155]] = void 0;
          var fe = ae(58935), le = ae(87326), se = ae(28819), oe = ae(40210), ce = ae(75451), he = ae(7745), ge = ae(55594), ve = ae(67304), me = function(be) {
            function pe($e, ye) {
              var Se = be[ee[4]](this, $e, ye) || this;
              return Se[ee[352]] = new he[ee[353]](Se[ee[35]], Se[ee[266]]), Se[ee[354]] = (0, ce[ee[268]])(Se[ee[35]], Se[ee[266]]), Se;
            }
            return ue(pe, be), pe[ee[6]][ee[208]] = function($e) {
              $e === void 0 && ($e = ge[ee[207]][ee[206]]);
              var ye = this[ee[35]][ee[197]][ee[196]](), Se = this[ee[354]][ee[242]]()[ee[203]], we = this[ee[297]][ee[242]]($e, Se / ye), Pe = this[ee[211]](we), Te = (0, ve[ee[355]])(Pe, this[ee[35]][ee[163]][ee[244]]);
              return this[ee[61]](Te);
            }, pe[ee[6]][ee[143]] = function() {
              var $e = this[ee[211]](this[ee[297]][ee[242]]());
              return (0, ve[ee[355]])($e, this[ee[35]][ee[163]][ee[244]]);
            }, pe[ee[6]][ee[137]] = function($e) {
              this[ee[352]][ee[137]]($e), this[ee[354]][ee[137]]($e), this[ee[297]][ee[137]](), this[ee[295]][ee[137]]();
            }, pe[ee[6]][ee[356]] = function($e, ye, Se, we, Pe) {
              var Te = this;
              if (!$e[ee[135]] || this[ee[290]]())
                return ye;
              this[ee[325]] = $e;
              var Ee = this[ee[182]][ee[89]](function(Ce) {
                return Ce[ee[85]] <= ye[ee[85]];
              });
              if (Ee[ee[3]] === 0)
                return this[ee[182]][0];
              var Me = Pe[ee[203]] || 0, Ae = (0, ve[ee[355]])(Se, this[ee[35]][ee[163]][ee[244]]), Ne = Ee[ee[89]](function(Ce) {
                var Ie;
                return Te[ee[252]](Ce[ee[62]], Ae, Ce[ee[85]], (Ie = $e[ee[135]]) !== null && Ie !== void 0 ? Ie : 0, !1, we, Me);
              });
              return Ne[ee[3]] === 0 ? Ee[0] : Ne[Ne[ee[3]] - 1];
            }, pe[ee[6]][ee[357]] = function($e, ye, Se) {
              var we, Pe;
              this[ee[188]](Se);
              var Te = this[ee[354]][ee[242]](), Ee = this[ee[352]][ee[242]](), Me = this[ee[35]][ee[197]][ee[196]](), Ae = this[ee[307]]();
              this[ee[193]](Te);
              var Ne = this[ee[35]][ee[108]][ee[41]](), Ce = Me > ((Pe = (we = (Ne ? (0, se[ee[186]])(Ne) : {})[ee[262]]) === null || we === void 0 ? void 0 : we[ee[261]]) !== null && Pe !== void 0 ? Pe : le[ee[359]][ee[358]]), Ie = this[ee[205]](Ee, Te, Ce);
              return ye && (Ie = this[ee[356]](ye, Ie, $e, Ae, Te)), Ie;
            }, pe[ee[6]][ee[65]] = function($e, ye) {
              var Se, we, Pe, Te, Ee = this[ee[297]][ee[242]](), Me = this[ee[211]](Ee), Ae = this[ee[357]](Me, $e, ye);
              return this[ee[190]] && !(!((we = (Se = this[ee[190]]) === null || Se === void 0 ? void 0 : Se[ee[62]]) === null || we === void 0) && we[ee[82]](Ae == null ? void 0 : Ae[ee[62]])) && this[ee[35]][ee[121]][ee[362]](fe[ee[361]][ee[360]]) && this[ee[35]][ee[121]][ee[200]](ee[369][ee[13]]((Pe = this[ee[190]]) === null || Pe === void 0 ? void 0 : Pe[ee[62]][ee[125]], ee[257])[ee[13]](Ae == null ? void 0 : Ae[ee[62]][ee[125]], ee[368])[ee[13]]((0, ve[ee[365]])(Me)[ee[251]](2) + ee[366], ee[367])[ee[13]](this[ee[354]][ee[242]]()[ee[203]][ee[251]](2), ee[364])[ee[13]](this[ee[352]][ee[242]]()[ee[203]][ee[251]](2), ee[363])), this[ee[190]] = Ae, this[ee[181]] = Me, this[ee[184]] = !1, this[ee[327]] = void 0, (Te = this[ee[190]]) === null || Te === void 0 ? void 0 : Te[ee[62]];
            }, pe[ee[6]][ee[117]] = function($e) {
              this[ee[188]]($e[ee[72]]), this[ee[190]] = this[ee[190]] ? _e({}, this[ee[61]](this[ee[190]][ee[85]])) : void 0, this[ee[266]] = this[ee[185]](), this[ee[327]] = void 0;
            }, pe[ee[6]][ee[136]] = function() {
              var $e, ye, Se, we;
              this[ee[183]] = !0, clearTimeout(this[ee[198]]), this[ee[198]] = void 0, ($e = this[ee[352]]) === null || $e === void 0 || $e[ee[136]](), (ye = this[ee[354]]) === null || ye === void 0 || ye[ee[136]](), (Se = this[ee[297]]) === null || Se === void 0 || Se[ee[136]](), (we = this[ee[295]]) === null || we === void 0 || we[ee[136]]();
            }, pe[ee[6]][ee[139]] = function() {
              var $e, ye, Se, we;
              clearTimeout(this[ee[198]]), this[ee[184]] = !1, this[ee[327]] = void 0, ($e = this[ee[352]]) === null || $e === void 0 || $e[ee[139]](), (ye = this[ee[354]]) === null || ye === void 0 || ye[ee[139]](), (Se = this[ee[297]]) === null || Se === void 0 || Se[ee[139]](), (we = this[ee[295]]) === null || we === void 0 || we[ee[139]]();
            }, pe[ee[6]][ee[140]] = function() {
              var $e, ye, Se, we;
              this[ee[139]](), ($e = this[ee[352]]) === null || $e === void 0 || $e[ee[140]](), (ye = this[ee[354]]) === null || ye === void 0 || ye[ee[140]](), (Se = this[ee[297]]) === null || Se === void 0 || Se[ee[140]](), (we = this[ee[295]]) === null || we === void 0 || we[ee[140]](), this[ee[190]] = void 0, this[ee[182]] = [], this[ee[266]] = ee[270];
            }, pe;
          }(oe[ee[287]]);
          ne[ee[155]] = me;
        }, 34188: function(ie, ne, ae) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[370]] = void 0;
          var ue = ae(16368), _e = ae(42214), fe = ae(67304);
          ne[ee[370]] = { name: ue[ee[372]][ee[371]], module: function() {
            return { AdaptationService: ae(10073)[ee[159]], AdaptToPlayerResolution: ae(80683)[ee[101]], AdaptationUtils: fe, AdaptationApiFactory: _e[ee[10]] };
          }, dependencies: [ue[ee[372]][ee[373]]] }, ne[ee[262]] = ne[ee[370]];
        }, 80683: function(ie, ne) {
          function ae(oe, ce, he) {
            var ge, ve = le(he, oe);
            if (!ve)
              return ce;
            var me = (ge = oe[ee[374]]()) !== null && ge !== void 0 ? ge : [], be = me[ee[83]](function($e) {
              return $e[ee[375]] === ce;
            });
            if (!be)
              return ce;
            var pe = ue(me, be[ee[376]], ve);
            return pe[ee[3]] === 0 ? ce : pe[_e(pe)][ee[375]];
          }
          function ue(oe, ce, he) {
            return oe[ee[89]](function(ge) {
              var ve = ge[ee[376]] <= ce, me = fe(he, ge);
              return ve && me;
            });
          }
          function _e(oe) {
            var ce = oe[ee[379]](function(he) {
              return he[ee[377]] > oe[0][ee[377]] && he[ee[378]] > oe[0][ee[378]];
            }) - 1;
            return Math[ee[114]](0, ce);
          }
          function fe(oe, ce) {
            var he = ce[ee[377]] / ce[ee[378]];
            return oe[ee[377]] / oe[ee[378]] < he ? ce[ee[377]] >= oe[ee[377]] : ce[ee[378]] >= oe[ee[378]];
          }
          function le(oe, ce) {
            var he = ce[ee[380]]();
            if (!he)
              return null;
            var ge = he[ee[381]], ve = ge && ge[ee[383]](ee[382]);
            return oe ? { width: screen[ee[377]] * devicePixelRatio, height: screen[ee[378]] * devicePixelRatio } : se(he) || ve && se(ve) || ge && se(ge);
          }
          function se(oe) {
            return oe && oe[ee[384]] && oe[ee[385]] ? { width: oe[ee[384]] * devicePixelRatio, height: oe[ee[385]] * devicePixelRatio } : null;
          }
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[101]] = ae;
        }, 63356: function(ie, ne) {
          function ae(_e) {
            return _e[ee[376]] != null;
          }
          function ue(_e) {
            return _e[ee[44]] != null && _e[ee[45]] != null;
          }
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[386]] = ae, ne[ee[387]] = ue;
        }, 28429: function(ie, ne, ae) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[142]] = fe;
          var ue = ae(10676), _e = ae(63356);
          function fe(se, oe) {
            if (oe && oe[ee[3]] !== 0)
              return le[ee[388]](), oe[ee[389]](function(ce, he) {
                var ge = le(he), ve = le(ce);
                return ve > se || ge > se ? ge > ve ? ce : he : ge > ve ? he : ce;
              });
          }
          var le = (0, ue[ee[390]])(function(se) {
            return (0, _e[ee[386]])(se) && se[ee[376]] > 0 ? se[ee[376]] : (0, _e[ee[387]])(se) ? (se[ee[45]] + se[ee[44]]) / 2 : 0;
          });
        }, 67610: function(ie, ne) {
          function ae(le) {
            return le[ee[3]] > 0 ? le[ee[389]](function(se, oe) {
              return se + oe;
            }, 0) / le[ee[3]] : 0;
          }
          function ue(le, se) {
            if (se === void 0 && (se = ae(le)), le[ee[3]] < 2)
              return 0;
            var oe = le[ee[389]](function(he, ge) {
              return he + Math[ee[391]](ge - se, 2);
            }, 0), ce = 1 / (le[ee[3]] - 1) * oe;
            return Math[ee[392]](ce);
          }
          function _e(le) {
            var se = le[ee[349]](0)[ee[393]](function(oe, ce) {
              return oe - ce;
            });
            return se[ee[3]] === 0 ? 0 : se[ee[3]] % 2 == 1 ? se[Math[ee[286]](se[ee[3]] / 2)] : 0.5 * (se[se[ee[3]] / 2 - 1] + se[se[ee[3]] / 2]);
          }
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[350]] = void 0, ne[ee[394]] = ae, ne[ee[395]] = ue, ne[ee[396]] = _e;
          var fe = function(le, se, oe) {
            return oe === void 0 && (oe = le[ee[3]] - 1), le[ee[3]] === 0 || oe < 0 ? 0 : oe === 0 || se === 0 ? le[oe] : se * le[oe] + (1 - se) * (0, ne[ee[350]])(le, se, oe - 1);
          };
          ne[ee[350]] = fe;
        }, 55594: function(ie, ne) {
          var ae;
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[207]] = void 0, function(ue) {
            ue[ue[ee[224]] = 10] = ee[224], ue[ue[ee[397]] = 8] = ee[397], ue[ue[ee[398]] = 7] = ee[398], ue[ue[ee[399]] = 6] = ee[399], ue[ue[ee[206]] = 5] = ee[206], ue[ue[ee[265]] = 4] = ee[265], ue[ue[ee[232]] = 3] = ee[232], ue[ue[ee[212]] = 2] = ee[212], ue[ue[ee[400]] = 1] = ee[400];
          }(ae || (ne[ee[207]] = ae = {}));
        }, 67304: function(ie, ne, ae) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[365]] = ne[ee[338]] = ne[ee[401]] = ne[ee[195]] = void 0, ne[ee[402]] = _e, ne[ee[403]] = fe, ne[ee[404]] = oe, ne[ee[146]] = be, ne[ee[355]] = pe;
          var ue = ae(54838);
          function _e($e) {
            var ye, Se = (ye = $e[ee[46]]) === null || ye === void 0 ? void 0 : ye[ee[18]];
            if (!Se)
              return 0;
            var we = le(Se);
            return !isNaN(we) && isFinite(we) ? we : 0;
          }
          function fe($e) {
            var ye, Se = (ye = $e[ee[46]]) === null || ye === void 0 ? void 0 : ye[ee[18]], we = $e[ee[163]];
            if (!Se || !we)
              return 0;
            var Pe = Se[ee[302]] || 0;
            if (!Pe)
              return 0;
            var Te = se(Pe, we[ee[244]]);
            return !isNaN(Te) && isFinite(Te) ? Te : 0;
          }
          function le($e) {
            return $e[ee[405]] ? ue[ee[168]][ee[406]](ee[114], $e[ee[405]]) : 1 / 0;
          }
          function se($e, ye) {
            var Se = ue[ee[168]][ee[406]](ee[116], $e);
            return Se *= 1 + ye / 100, Se += 8;
          }
          function oe($e, ye) {
            return $e[$e[ee[389]](function(Se, we, Pe) {
              return ye($e[Se], $e[Pe]) ? Se : Pe;
            }, 0)];
          }
          var ce = function($e) {
            return $e;
          }, he = function($e, ye) {
            return ye === void 0 && (ye = ce), oe($e, function(Se, we) {
              return ye(Se) < ye(we);
            });
          };
          ne[ee[195]] = he;
          var ge = function($e, ye) {
            return ye === void 0 && (ye = ce), oe($e, function(Se, we) {
              return ye(Se) > ye(we);
            });
          };
          ne[ee[401]] = ge;
          var ve = function($e) {
            return $e / Math[ee[391]](2, 10);
          };
          ne[ee[338]] = ve;
          var me = function($e) {
            return $e / Math[ee[391]](2, 20);
          };
          function be($e) {
            return $e[ee[147]] !== void 0;
          }
          function pe($e, ye) {
            return $e * (1 - ye / 100);
          }
          ne[ee[365]] = me;
        }, 57038: function(ie, ne, ae) {
          var ue = this && this[ee[234]] || function() {
            var Me = function(Ae, Ne) {
              return Me = Object[ee[235]] || { __proto__: [] } instanceof Array && function(Ce, Ie) {
                Ce[ee[236]] = Ie;
              } || function(Ce, Ie) {
                for (var xe in Ie)
                  Object[ee[6]][ee[5]][ee[4]](Ie, xe) && (Ce[xe] = Ie[xe]);
              }, Me(Ae, Ne);
            };
            return function(Ae, Ne) {
              if (ee[96] != typeof Ne && Ne !== null)
                throw new TypeError(ee[237] + String(Ne) + ee[238]);
              function Ce() {
                this[ee[239]] = Ae;
              }
              Me(Ae, Ne), Ae[ee[6]] = Ne === null ? Object[ee[11]](Ne) : (Ce[ee[6]] = Ne[ee[6]], new Ce());
            };
          }();
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[154]] = void 0;
          var _e = ae(33696), fe = ae(87326), le = ae(28819), se = ae(8272), oe = ae(79814), ce = ae(40210), he = ae(28429), ge = ae(25050), ve = ae(55594), me = ae(67304), be = ae(72573), pe = 10, $e = 1e-4, ye = 1e-4, Se = 5, we = 0.325, Pe = 2, Te = function(Me) {
            function Ae(Ne, Ce) {
              var Ie = Me[ee[4]](this, Ne, Ce) || this;
              return Ie[ee[35]] = Ne, Ie[ee[36]] = Ce, Ie[ee[407]] = [], Ie[ee[408]] = [], Ie[ee[135]] = 0, Ie[ee[409]](), Ie[ee[46]] = Ne[ee[163]][ee[410]], Ie;
            }
            return ue(Ae, Me), Object[ee[9]](Ae[ee[6]], ee[285], { get: function() {
              var Ne, Ce = oe[ee[91]][ee[90]](this[ee[36]]) ? _e[ee[412]][ee[411]] : _e[ee[412]][ee[413]], Ie = (Ne = this[ee[35]][ee[98]][ee[418]][ee[417]](_e[ee[416]][ee[415]], Ce)[ee[414]]) !== null && Ne !== void 0 ? Ne : 0;
              return Ie > this[ee[35]][ee[197]][ee[419]](_e[ee[416]][ee[415]], Ce) + this[ee[135]] ? 0 : Ie;
            }, enumerable: !1, configurable: !0 }), Ae[ee[6]][ee[409]] = function() {
              var Ne = this[ee[35]][ee[163]][ee[410]][ee[420]], Ce = this[ee[35]][ee[163]][ee[410]][ee[421]], Ie = this[ee[35]][ee[163]][ee[410]][ee[422]];
              if (![ee[424], ee[425]][ee[423]](Ne)) {
                var xe = fe[ee[426]][ee[420]];
                this[ee[35]][ee[121]][ee[429]](ee[428][ee[13]](Ne, ee[427])[ee[13]](xe, ee[363])), this[ee[35]][ee[163]][ee[410]][ee[420]] = xe;
              }
              if (Ce > 1 || Ce < $e) {
                var Ue = Math[ee[116]](Math[ee[114]](Ce, $e), 1);
                this[ee[35]][ee[121]][ee[429]](ee[431][ee[13]](Ce, ee[430])[ee[13]](Ue)), this[ee[35]][ee[163]][ee[410]][ee[421]] = Ue;
              }
              if (Ie < ye) {
                var ke = Math[ee[114]](Ie, ye);
                this[ee[35]][ee[121]][ee[429]](ee[432][ee[13]](Ie, ee[430])[ee[13]](ke)), this[ee[35]][ee[163]][ee[410]][ee[422]] = ke;
              }
            }, Ae[ee[6]][ee[208]] = function(Ne) {
              Ne === void 0 && (Ne = ve[ee[207]][ee[206]]);
              var Ce = this[ee[35]][ee[197]][ee[196]](), Ie = this[ee[297]][ee[242]](Ne, this[ee[285]] / Ce), xe = this[ee[211]](Ie), Ue = (0, me[ee[355]])(xe, this[ee[35]][ee[163]][ee[244]]);
              return this[ee[61]](Ue);
            }, Ae[ee[6]][ee[433]] = function() {
              var Ne = this[ee[35]][ee[108]][ee[41]]();
              return (Ne ? (0, le[ee[301]])(Ne, this[ee[36]], se[ee[110]][ee[300]]) : [])[ee[89]](function(Ce) {
                return !!Ce[ee[203]];
              })[ee[3]] > Pe;
            }, Ae[ee[6]][ee[137]] = function(Ne) {
              Ee(Ne) && (this[ee[297]][ee[137]](), this[ee[295]][ee[137]](), Ne[ee[135]] !== this[ee[135]] && (this[ee[135]] = Ne[ee[135]], this[ee[434]]()));
            }, Ae[ee[6]][ee[65]] = function(Ne, Ce) {
              var Ie;
              this[ee[188]](Ce), this[ee[193]]({ value: this[ee[285]], result: ge[ee[216]][ee[218]] });
              var xe = this[ee[435]](), Ue = (Ie = xe[ee[191]]) === null || Ie === void 0 ? void 0 : Ie[ee[62]], ke = xe[ee[436]];
              return this[ee[408]][ee[437]](this[ee[407]][ke]), this[ee[408]][ee[3]] > 2 * pe && (this[ee[408]] = this[ee[408]][ee[349]](-pe)), this[ee[325]] = Ne, this[ee[190]] = xe[ee[191]], this[ee[181]] = this[ee[211]](this[ee[297]][ee[242]]()), this[ee[184]] = !1, this[ee[327]] = void 0, Ue;
            }, Ae[ee[6]][ee[143]] = function() {
              return this[ee[297]][ee[242]]()[ee[203]];
            }, Ae[ee[6]][ee[117]] = function(Ne) {
              this[ee[182]] = Ne[ee[72]], this[ee[266]] = this[ee[185]](), this[ee[184]] = !1, this[ee[327]] = void 0;
              var Ce = this[ee[67]]()[ee[189]](function(Ie) {
                return (0, me[ee[338]])(Ie[ee[85]]);
              });
              this[ee[407]] = (0, be[ee[438]])(Ce, this[ee[46]][ee[420]]), this[ee[434]]();
            }, Ae[ee[6]][ee[61]] = function(Ne, Ce) {
              var Ie, xe = (0, he[ee[142]])(Ne, this[ee[67]]()[ee[189]](function(Ue) {
                return { rep: Ue, bitrate: Ue[ee[85]] };
              }));
              return (Ie = xe == null ? void 0 : xe[ee[191]]) !== null && Ie !== void 0 ? Ie : this[ee[192]]();
            }, Ae[ee[6]][ee[136]] = function() {
              this[ee[183]] = !0, clearTimeout(this[ee[198]]), this[ee[198]] = void 0;
            }, Ae[ee[6]][ee[139]] = function() {
              var Ne, Ce;
              this[ee[181]] = 0, this[ee[184]] = !1, this[ee[327]] = void 0, (Ne = this[ee[297]]) === null || Ne === void 0 || Ne[ee[139]](), (Ce = this[ee[295]]) === null || Ce === void 0 || Ce[ee[139]]();
            }, Ae[ee[6]][ee[140]] = function() {
              var Ne, Ce;
              this[ee[139]](), (Ne = this[ee[297]]) === null || Ne === void 0 || Ne[ee[140]](), (Ce = this[ee[295]]) === null || Ce === void 0 || Ce[ee[140]](), this[ee[190]] = void 0, this[ee[182]] = [], this[ee[266]] = ee[270], this[ee[407]] = [], this[ee[135]] = 0, this[ee[408]] = [];
            }, Ae[ee[6]][ee[434]] = function() {
              if ((0, be[ee[439]])(this[ee[407]], this[ee[135]])) {
                var Ne = this[ee[67]]()[ee[189]](function(xe) {
                  return (0, me[ee[338]])(xe[ee[85]]);
                }), Ce = oe[ee[91]][ee[90]](this[ee[36]]) ? _e[ee[412]][ee[411]] : _e[ee[412]][ee[413]], Ie = this[ee[35]][ee[197]][ee[419]](_e[ee[416]][ee[415]], Ce);
                this[ee[440]] = (0, be[ee[441]])(this[ee[46]], Ne, this[ee[407]], this[ee[135]], Ie), this[ee[442]] = (0, be[ee[443]])(this[ee[46]], this[ee[440]], Ie, this[ee[135]]), this[ee[444]] = (0, be[ee[445]])(this[ee[440]], this[ee[442]]);
              }
            }, Ae[ee[6]][ee[446]] = function(Ne, Ce, Ie, xe) {
              var Ue = (0, be[ee[447]])(Ne[ee[85]], xe), ke = (0, be[ee[448]])(Ue, this[ee[135]], this[ee[285]]), Le = (0, be[ee[449]])(this[ee[407]], Ce, Ie);
              return this[ee[440]] * Ue + this[ee[442]] * ke + this[ee[444]] * Le;
            }, Ae[ee[6]][ee[290]] = function() {
              var Ne, Ce, Ie = !!(!((Ne = this[ee[35]][ee[46]][ee[18]]) === null || Ne === void 0) && Ne[ee[302]]), xe = !!(!((Ce = this[ee[35]][ee[46]][ee[18]]) === null || Ce === void 0) && Ce[ee[405]]);
              return (Ie || xe) && !this[ee[433]]();
            }, Ae[ee[6]][ee[435]] = function() {
              var Ne = this;
              if (this[ee[183]] && (this[ee[290]]() || this[ee[46]][ee[450]])) {
                var Ce = this[ee[208]](), Ie = this[ee[67]]()[ee[451]](Ce);
                return { rep: Ce, index: Ie !== -1 ? Ie : 0 };
              }
              if (this[ee[285]] < this[ee[135]] || !(0, be[ee[439]])(this[ee[407]], this[ee[135]]))
                return { rep: this[ee[67]]()[0], index: 0 };
              var xe = (0, be[ee[452]])(this[ee[408]], pe), Ue = this[ee[297]][ee[242]](Se, we)[ee[203]], ke = this[ee[211]](this[ee[297]][ee[242]]()), Le = Math[ee[116]](Ue, ke), De = 0.1, Re = this[ee[67]]()[0][ee[85]], Oe = Math[ee[114]](Ue * (1 + De), Re), Be = this[ee[67]]()[ee[89]](function(Fe) {
                return Fe[ee[85]] <= Oe;
              })[ee[189]](function(Fe, Ve) {
                return { rep: Fe, index: Ve, cost: Ne[ee[446]](Fe, Ve, xe, Le) };
              })[ee[393]](function(Fe, Ve) {
                return Fe[ee[453]] - Ve[ee[453]];
              });
              return { rep: Be[0][ee[191]], index: Be[0][ee[436]] };
            }, Ae;
          }(ce[ee[287]]);
          function Ee(Me) {
            return Me[ee[135]] != null;
          }
          ne[ee[154]] = Te;
        }, 72573: function(ie, ne) {
          function ae(me, be) {
            var pe = function(we, Pe) {
              return we / Pe;
            }, $e = function(we, Pe) {
              return Math[ee[424]](we / Pe);
            };
            switch (be) {
              case ee[425]:
                var ye = me[me[ee[3]] - 1];
                return me[ee[189]](function(we) {
                  return pe(we, ye);
                });
              case ee[424]:
                var Se = me[0];
                return me[ee[189]](function(we) {
                  return $e(we, Se);
                });
            }
          }
          function ue(me, be, pe, $e, ye) {
            switch (me[ee[420]]) {
              case ee[425]:
                return le(me, pe, $e, ye);
              case ee[424]:
                return se(me, be, $e, ye);
            }
          }
          function _e(me, be, pe, $e) {
            return be * ((me[ee[421]] * pe - $e) / $e);
          }
          function fe(me, be) {
            return 1 - me - be;
          }
          function le(me, be, pe, $e) {
            var ye = me[ee[422]], Se = me[ee[421]], we = pe, Pe = be[0], Te = be[be[ee[3]] - 2];
            return 1 / (1 + (Se * $e - we) / pe + Math[ee[454]](3 - 2 * Pe - Te) / ye);
          }
          function se(me, be, pe, $e) {
            var ye = me[ee[422]], Se = me[ee[421]], we = pe, Pe = be[0], Te = be[be[ee[3]] - 1];
            return 1 / (1 + (Se * $e - we) / pe + 2 * Te * Te / (ye * Pe * be[be[ee[3]] - 2]));
          }
          function oe(me, be) {
            return be ? me / be : 1;
          }
          function ce(me, be, pe) {
            return pe <= be ? 1 / 0 : me * (be / (pe - be));
          }
          function he(me, be, pe) {
            var $e = me[me[ee[3]] - 1], ye = me[0], Se = me[be];
            return Math[ee[454]]($e + pe - 2 * Se) / Math[ee[454]](2 * $e - 2 * ye);
          }
          function ge(me, be) {
            if (me[ee[3]] === 0)
              return 0;
            var pe = me[ee[349]](-be);
            return pe[ee[389]](function($e, ye) {
              return $e + ye;
            }) / pe[ee[3]];
          }
          function ve(me, be) {
            return !(me[ee[3]] <= 1 || !be);
          }
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[438]] = ae, ne[ee[441]] = ue, ne[ee[443]] = _e, ne[ee[445]] = fe, ne[ee[447]] = oe, ne[ee[448]] = ce, ne[ee[449]] = he, ne[ee[452]] = ge, ne[ee[439]] = ve;
        }, 3797: function(ie, ne) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[455]] = void 0, ne[ee[456]] = _e;
          var ae, ue = 0.9;
          function _e(fe) {
            if (fe[ee[3]] !== 0) {
              for (var le = fe[ee[3]], se = le - 1; se >= 0; se--) {
                var oe = fe[se][ee[203]], ce = oe[ee[457]], he = oe[ee[458]];
                if (he === void 0 || ce < he * ue)
                  return { rateBps: ce, type: ae[ee[459]] };
              }
              return { rateBps: fe[le - 1][ee[203]][ee[457]], type: ae[ee[460]] };
            }
          }
          (function(fe) {
            fe[ee[459]] = ee[461], fe[ee[460]] = ee[462];
          })(ae || (ne[ee[455]] = ae = {}));
        }, 74828: function(ie, ne, ae) {
          var ue = this && this[ee[463]] || function(ye, Se, we) {
            if (we || arguments[ee[3]] === 2)
              for (var Pe, Te = 0, Ee = Se[ee[3]]; Te < Ee; Te++)
                !Pe && Te in Se || (Pe || (Pe = Array[ee[6]][ee[349]][ee[4]](Se, 0, Te)), Pe[Te] = Se[Te]);
            return ye[ee[13]](Pe || Array[ee[6]][ee[349]][ee[4]](Se));
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[152]] = void 0;
          var _e = ae(18665), fe = ae(28819), le = ae(8272), se = ae(28429), oe = ae(12566), ce = ae(67304), he = ae(3797), ge = ae(92741), ve = ae(2122), me = ee[464], be = 20, pe = function() {
            function ye(Se, we) {
              this[ee[35]] = Se, this[ee[36]] = we, this[ee[465]] = new ge[ee[466]]();
            }
            return Object[ee[9]](ye[ee[6]], ee[58], { get: function() {
              return this[ee[35]][ee[57]][ee[56]](_e[ee[55]][ee[59]], this[ee[35]][ee[53]][ee[52]]);
            }, enumerable: !1, configurable: !0 }), ye[ee[6]][ee[424]] = function(Se) {
              for (var we, Pe = [], Te = 1; Te < arguments[ee[3]]; Te++)
                Pe[Te - 1] = arguments[Te];
              this[ee[35]][ee[121]] && (we = this[ee[35]][ee[121]])[ee[15]][ee[7]](we, ue([ee[469][ee[13]](me, ee[468])[ee[13]](this[ee[36]], ee[467])[ee[13]](Se)], Pe, !1));
            }, ye[ee[6]][ee[456]] = function() {
              var Se = (0, fe[ee[301]])(this[ee[35]][ee[108]][ee[41]](), this[ee[36]], le[ee[110]][ee[470]]), we = this[ee[471]]();
              return (0, he[ee[456]])(Se[ee[349]](-we));
            }, ye[ee[6]][ee[471]] = function() {
              var Se, we = (Se = this[ee[35]][ee[46]][ee[18]]) === null || Se === void 0 ? void 0 : Se[ee[20]], Pe = Math[ee[472]](be * we);
              return Pe = Math[ee[114]](1, Pe);
            }, ye[ee[6]][ee[473]] = function(Se) {
              var we, Pe, Te, Ee, Me = $e((Te = (Pe = (we = this[ee[58]]) === null || we === void 0 ? void 0 : we[ee[71]](Se)) === null || Pe === void 0 ? void 0 : Pe[ee[72]]) !== null && Te !== void 0 ? Te : []);
              return (Ee = Me == null ? void 0 : Me[ee[62]][ee[82]](Se)) !== null && Ee !== void 0 && Ee;
            }, ye[ee[6]][ee[143]] = function() {
              var Se, we;
              return (we = (Se = this[ee[456]]()) === null || Se === void 0 ? void 0 : Se[ee[474]]) !== null && we !== void 0 ? we : 0;
            }, ye[ee[6]][ee[65]] = function(Se, we) {
              var Pe, Te, Ee, Me;
              if (we && we[ee[3]] !== 0) {
                var Ae, Ne = this[ee[456]]();
                if (this[ee[424]](ee[475], Ne), !Ne)
                  return (Pe = $e(we)) === null || Pe === void 0 ? void 0 : Pe[ee[62]];
                if (Ne[ee[476]] === he[ee[455]][ee[459]] && (Ae = (Te = this[ee[61]](Ne[ee[474]], we)) !== null && Te !== void 0 ? Te : void 0, this[ee[424]](ee[477], Ae == null ? void 0 : Ae[ee[85]])), Ne[ee[476]] === he[ee[455]][ee[460]]) {
                  var Ce = (Ee = (0, fe[ee[264]])((0, fe[ee[186]])(this[ee[35]][ee[108]][ee[41]]()), this[ee[36]], le[ee[110]][ee[470]])[ee[203]]) === null || Ee === void 0 ? void 0 : Ee[ee[478]];
                  Ce !== void 0 && (Ae = (0, oe[ee[479]])(we, Ce), this[ee[424]](ee[481][ee[13]](Ce, ee[480])[ee[13]](Ae == null ? void 0 : Ae[ee[85]])));
                }
                return Ae ? Ae[ee[62]] : (Me = $e(we)) === null || Me === void 0 ? void 0 : Me[ee[62]];
              }
            }, ye[ee[6]][ee[61]] = function(Se, we) {
              var Pe, Te;
              if (!we || we[ee[3]] < 1)
                return null;
              var Ee = (Pe = (0, se[ee[142]])(Se, we[ee[189]](function(Me) {
                return { rep: Me, bitrate: Me[ee[85]] };
              }))) === null || Pe === void 0 ? void 0 : Pe[ee[191]];
              return (Te = Ee ?? $e(we)) !== null && Te !== void 0 ? Te : null;
            }, ye[ee[6]][ee[130]] = function(Se, we) {
              if (this[ee[465]][ee[482]](Se)) {
                if (this[ee[473]](we))
                  return !1;
                var Pe = (0, ve[ee[483]])(Se);
                return Pe && this[ee[424]](ee[484]), Pe;
              }
              return !1;
            }, ye[ee[6]][ee[137]] = function(Se) {
            }, ye[ee[6]][ee[117]] = function(Se) {
            }, ye[ee[6]][ee[136]] = function() {
            }, ye[ee[6]][ee[139]] = function() {
            }, ye[ee[6]][ee[140]] = function() {
              this[ee[139]]();
            }, ye;
          }();
          function $e(ye) {
            return (0, ce[ee[195]])(ye ?? [], function(Se) {
              return Se[ee[85]];
            });
          }
          ne[ee[152]] = pe;
        }, 92741: function(ie, ne) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[466]] = void 0;
          var ae = 0.2, ue = function() {
            function _e() {
              this[ee[485]] = 0;
            }
            return _e[ee[6]][ee[482]] = function(fe) {
              if (fe[ee[135]] === void 0 || fe[ee[144]] === void 0)
                return !1;
              this[ee[486]](fe) && (this[ee[485]] = 0);
              var le = this[ee[485]] + ae;
              if (fe[ee[144]] >= fe[ee[135]] * le) {
                var se = fe[ee[144]] / fe[ee[135]];
                return this[ee[485]] = Math[ee[286]](se / ae) * ae, !0;
              }
              return !1;
            }, _e[ee[6]][ee[486]] = function(fe) {
              return fe[ee[144]] < this[ee[485]] * fe[ee[135]];
            }, _e;
          }();
          ne[ee[466]] = ue;
        }, 2122: function(ie, ne, ae) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[483]] = _e;
          var ue = ae(40392);
          function _e(fe) {
            var le, se, oe = ((le = fe[ee[133]]) === null || le === void 0 ? void 0 : le[ee[487]]) - ((se = fe[ee[133]]) === null || se === void 0 ? void 0 : se[ee[343]]), ce = (0, ue[ee[488]])(fe[ee[145]]) / oe, he = 1 - (0, ue[ee[488]])(fe[ee[145]]) / (fe[ee[478]] * fe[ee[135]]);
            return ce < fe[ee[478]] * he;
          }
        }, 10605: function(ie, ne, ae) {
          var ue = this && this[ee[234]] || function() {
            var ye = function(Se, we) {
              return ye = Object[ee[235]] || { __proto__: [] } instanceof Array && function(Pe, Te) {
                Pe[ee[236]] = Te;
              } || function(Pe, Te) {
                for (var Ee in Te)
                  Object[ee[6]][ee[5]][ee[4]](Te, Ee) && (Pe[Ee] = Te[Ee]);
              }, ye(Se, we);
            };
            return function(Se, we) {
              if (ee[96] != typeof we && we !== null)
                throw new TypeError(ee[237] + String(we) + ee[238]);
              function Pe() {
                this[ee[239]] = Se;
              }
              ye(Se, we), Se[ee[6]] = we === null ? Object[ee[11]](we) : (Pe[ee[6]] = we[ee[6]], new Pe());
            };
          }();
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[269]] = void 0;
          var _e = ae(28819), fe = ae(8272), le = ae(54838), se = ae(25050), oe = ee[489], ce = ee[490], he = 3, ge = 40, ve = 0.1, me = 16e5, be = 1e6, pe = function(ye) {
            function Se(we, Pe) {
              var Te, Ee, Me = ye[ee[4]](this, we, Pe) || this, Ae = we[ee[46]];
              return Me[ee[163]] = we[ee[163]], Me[ee[492]] = Pe, Me[ee[493]] = me, ((Te = Ae[ee[18]]) === null || Te === void 0 ? void 0 : Te[ee[405]]) != null && (Me[ee[493]] = le[ee[168]][ee[406]](ee[114], Ae[ee[18]][ee[405]])), ((Ee = Ae[ee[18]]) === null || Ee === void 0 ? void 0 : Ee[ee[302]]) != null && (Me[ee[302]] = le[ee[168]][ee[406]](ee[116], Ae[ee[18]][ee[302]])), Me[ee[494]] = { bytes: 0, time: 0 }, Me[ee[495]] = [], Me;
            }
            return ue(Se, ye), Se[ee[496]] = function(we, Pe) {
              return 8 * we / Pe;
            }, Se[ee[6]][ee[497]] = function(we) {
              var Pe = this[ee[495]][ee[498]]();
              if ((Pe == null ? void 0 : Pe[ee[499]]) === be && (this[ee[495]][ee[437]](Pe), Pe = void 0), Pe || (Pe = { bytes: 0, time: 0, rateInBps: 0 }), Pe[ee[499]] + we[ee[499]] <= be) {
                var Te = Pe[ee[499]] + we[ee[499]], Ee = Pe[ee[348]] + we[ee[348]];
                this[ee[495]][ee[437]]({ bytes: Te, time: Ee, rateInBps: Se[ee[496]](Te, Ee) });
              } else {
                var Me = (be - Pe[ee[499]]) / we[ee[499]];
                Pe[ee[499]] += we[ee[499]] * Me, Pe[ee[348]] += we[ee[348]] * Me, Pe[ee[500]] = Se[ee[496]](Pe[ee[499]], Pe[ee[348]]), this[ee[495]][ee[437]](Pe);
                for (var Ae = we[ee[499]] * (1 - Me), Ne = we[ee[348]] * (1 - Me); Ae > be; ) {
                  var Ce = Ne / (Ae / be);
                  this[ee[495]][ee[437]]({ bytes: be, time: Ce, rateInBps: Se[ee[496]](be, Ce) }), Ae -= be, Ne -= Ce;
                }
                this[ee[495]][ee[437]]({ bytes: Ae, time: Ne, rateInBps: Se[ee[496]](Ae, Ne) });
              }
            }, Se[ee[6]][ee[501]] = function(we) {
              if (we && !isNaN(we[ee[499]])) {
                var Pe = this[ee[494]];
                if (Pe[ee[499]] === we[ee[499]] && Pe[ee[348]] === we[ee[348]])
                  return;
                this[ee[494]] = we, this[ee[497]](we), this[ee[495]][ee[3]] > ge && this[ee[495]][ee[502]](), this[ee[503]]();
              }
            }, Se[ee[6]][ee[504]] = function(we, Pe) {
              var Te, Ee = -we;
              Pe != null && (Ee = -we - Pe, Te = -Pe);
              var Me = this[ee[495]][ee[349]](Ee, Te);
              if (Me[ee[3]] === 0)
                return 0;
              var Ae = Me[ee[389]](function(Ne, Ce) {
                return { bytes: Ne[ee[499]] + Ce[ee[499]], time: Ne[ee[348]] + Ce[ee[348]], rateInBps: Ne[ee[500]] + Ce[ee[500]] };
              });
              return Ae[ee[500]] = Se[ee[496]](Ae[ee[499]], Ae[ee[348]]), Ae[ee[500]];
            }, Se[ee[6]][ee[505]] = function() {
              if (this[ee[302]] == null)
                return null;
              this[ee[493]] = Number[ee[506]];
              var we = this[ee[302]];
              return we *= 1 + this[ee[163]][ee[244]] / 100, we += 8, isNaN(we) ? null : (this[ee[35]][ee[121]][ee[200]](ee[507][ee[13]](we)), { bytes: $e(we), time: 1 });
            }, Se[ee[6]][ee[137]] = function() {
              if (this[ee[508]]) {
                var we = (0, _e[ee[186]])(this[ee[508]]), Pe = (0, _e[ee[264]])(we, this[ee[492]], fe[ee[110]][ee[300]]);
                if (!Pe || !Pe[ee[203]] || !Pe[ee[203]][ee[499]]) {
                  var Te = this[ee[505]]();
                  if (Te && (Pe = { value: Te }), !Pe || !Pe[ee[203]] || !Pe[ee[203]][ee[499]]) {
                    Pe = Pe || {};
                    var Ee = this[ee[509]]();
                    Ee > 0 && (Pe[ee[203]] = { bytes: $e(Ee), time: 1 });
                  }
                  Pe && Pe[ee[203]] || (Pe = (0, _e[ee[264]])(we, ee[262], fe[ee[110]][ee[300]]));
                  var Me = 1 / 0;
                  Pe && Pe[ee[203]] && !isNaN(Pe[ee[203]][ee[499]]) && !isNaN(Pe[ee[203]][ee[348]]) && (Me = Pe[ee[203]][ee[499]] / Pe[ee[203]][ee[348]]), Me > this[ee[493]] && (Pe[ee[203]] = Pe[ee[203]] || {}, Pe[ee[203]][ee[499]] = $e(this[ee[493]]), Pe[ee[203]][ee[348]] = 1);
                }
                this[ee[501]](Pe[ee[203]]);
              }
            }, Se[ee[6]][ee[242]] = function(we) {
              this[ee[495]][ee[3]] === 0 && this[ee[137]]();
              var Pe = this[ee[504]](we), Te = this[ee[504]](we, 1);
              return { value: Pe, result: Pe > Te * (1 + ve) ? se[ee[216]][ee[215]] : Pe < Te * (1 - ve) ? se[ee[216]][ee[220]] : se[ee[216]][ee[218]] };
            }, Se[ee[6]][ee[503]] = function() {
              if (this[ee[508]]) {
                var we = (0, _e[ee[301]])(this[ee[508]], this[ee[492]], fe[ee[110]][ee[300]])[ee[349]](-he)[ee[189]](function(Pe) {
                  return Math[ee[510]](8 * Pe[ee[203]][ee[499]] / Pe[ee[203]][ee[348]]);
                });
                this[ee[35]][ee[511]][ee[164]](oe, we), this[ee[35]][ee[511]][ee[164]](ce, Date[ee[138]]());
              }
            }, Se[ee[6]][ee[509]] = function() {
              var we = this[ee[35]][ee[511]][ee[56]](oe) || [];
              return Math[ee[510]](we[ee[389]](function(Pe, Te) {
                return Pe + Te;
              }, 0) / we[ee[3]]) || -1;
            }, Se[ee[6]][ee[139]] = function() {
            }, Se[ee[6]][ee[136]] = function() {
            }, Se[ee[6]][ee[140]] = function() {
            }, Se;
          }(se[ee[491]]);
          function $e(ye) {
            return ye / 8;
          }
          ne[ee[269]] = pe;
        }, 29374: function(ie, ne, ae) {
          var ue = this && this[ee[234]] || function() {
            var he = function(ge, ve) {
              return he = Object[ee[235]] || { __proto__: [] } instanceof Array && function(me, be) {
                me[ee[236]] = be;
              } || function(me, be) {
                for (var pe in be)
                  Object[ee[6]][ee[5]][ee[4]](be, pe) && (me[pe] = be[pe]);
              }, he(ge, ve);
            };
            return function(ge, ve) {
              if (ee[96] != typeof ve && ve !== null)
                throw new TypeError(ee[237] + String(ve) + ee[238]);
              function me() {
                this[ee[239]] = ge;
              }
              he(ge, ve), ge[ee[6]] = ve === null ? Object[ee[11]](ve) : (me[ee[6]] = ve[ee[6]], new me());
            };
          }();
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[267]] = void 0;
          var _e = ae(331), fe = ae(25050), le = -0.5, se = 0.7, oe = 6e4, ce = function(he) {
            function ge(ve, me) {
              var be = he[ee[4]](this, ve, me) || this;
              return be[ee[197]] = ve[ee[197]], be[ee[512]] = !0, be[ee[513]] = [], be;
            }
            return ue(ge, he), ge[ee[6]][ee[514]] = function() {
              if (this[ee[513]][ee[3]] === 0)
                return NaN;
              var ve = this[ee[513]][this[ee[513]][ee[3]] - 1], me = ve[ee[515]];
              if (this[ee[512]]) {
                var be = ve[ee[285]], pe = this[ee[513]][this[ee[513]][ee[3]] - 2], $e = 0;
                pe && ($e = pe[ee[285]]), be >= ve[ee[515]] || $e > be ? (this[ee[121]][ee[200]](ee[516]), this[ee[512]] = !1) : me = be;
              }
              return me;
            }, ge[ee[6]][ee[517]] = function(ve) {
              isNaN(ve) && (ve = this[ee[197]][ee[196]]());
              for (var me, be = Date[ee[138]]() - (0, _e[ee[201]])(ve), pe = 0, $e = 0, ye = 0; ye < this[ee[513]][ee[3]]; ye++)
                (me = this[ee[513]][ye])[ee[518]] >= be && (pe += me[ee[285]] - $e), $e = me[ee[285]];
              return ((pe /= this[ee[514]]()) < -1 || pe > 1) && this[ee[121]][ee[200]](ee[519] + pe), isNaN(pe) ? 1 : pe;
            }, ge[ee[6]][ee[137]] = function(ve) {
              var me = this;
              this[ee[520]] || (this[ee[520]] = window[ee[202]](function() {
                me[ee[121]][ee[200]](ee[521]), me[ee[512]] = !1;
              }, (0, _e[ee[201]])(this[ee[197]][ee[196]]()))), this[ee[513]][ee[437]](ve), ve[ee[518]] - this[ee[513]][0][ee[518]] > oe && this[ee[513]][ee[502]]();
            }, ge[ee[6]][ee[242]] = function(ve) {
              var me = this[ee[517]](ve), be = fe[ee[216]][ee[218]];
              return me > se ? be = fe[ee[216]][ee[215]] : me < le && (be = fe[ee[216]][ee[220]]), { value: me, result: be };
            }, ge[ee[6]][ee[136]] = function() {
              this[ee[512]] = !0;
            }, ge[ee[6]][ee[139]] = function() {
              clearTimeout(this[ee[520]]);
            }, ge[ee[6]][ee[140]] = function() {
              this[ee[139]](), this[ee[513]] = [];
            }, ge;
          }(fe[ee[491]]);
          ne[ee[267]] = ce;
        }, 75451: function(ie, ne, ae) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[268]] = le;
          var ue = ae(87326), _e = ae(331), fe = ae(25050);
          function le(se, oe) {
            var ce, he, ge = 0.8, ve = 0.4, me = !0, be = { timestamp: Date[ee[138]](), bufferTargetLevel: ((ce = ue[ee[359]][ee[523]][ee[522]]) === null || ce === void 0 ? void 0 : ce[ee[524]]) || 0, bufferLevel: 0 }, pe = function() {
              clearTimeout(he);
            }, $e = function() {
              pe();
            };
            return { addSample: function(ye) {
              he || (he = window[ee[202]](function() {
                me = !1;
              }, (0, _e[ee[201]])(se[ee[197]][ee[196]]()))), be = ye;
            }, getStatus: function() {
              var ye;
              return be[ee[285]] > be[ee[515]] * ge ? (ye = fe[ee[216]][ee[215]], me && (me = !1, clearTimeout(he))) : ye = be[ee[285]] < be[ee[515]] * ve ? fe[ee[216]][ee[220]] : fe[ee[216]][ee[218]], me && (ye = fe[ee[216]][ee[218]]), { value: be[ee[285]], result: ye };
            }, setStartupPhase: function() {
              me = !0;
            }, shutdown: pe, dispose: $e };
          }
        }, 7745: function(ie, ne, ae) {
          var ue = this && this[ee[234]] || function() {
            var ve = function(me, be) {
              return ve = Object[ee[235]] || { __proto__: [] } instanceof Array && function(pe, $e) {
                pe[ee[236]] = $e;
              } || function(pe, $e) {
                for (var ye in $e)
                  Object[ee[6]][ee[5]][ee[4]]($e, ye) && (pe[ye] = $e[ye]);
              }, ve(me, be);
            };
            return function(me, be) {
              if (ee[96] != typeof be && be !== null)
                throw new TypeError(ee[237] + String(be) + ee[238]);
              function pe() {
                this[ee[239]] = me;
              }
              ve(me, be), me[ee[6]] = be === null ? Object[ee[11]](be) : (pe[ee[6]] = be[ee[6]], new pe());
            };
          }();
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[353]] = void 0;
          var _e = ae(331), fe = ae(25050), le = 0.5, se = 1.7, oe = 8, ce = 6e4;
          function he(ve) {
            return ve[ee[135]] != null && ve[ee[525]] != null;
          }
          var ge = function(ve) {
            function me(be, pe) {
              var $e = ve[ee[4]](this, be, pe) || this;
              return $e[ee[526]] = [], $e;
            }
            return ue(me, ve), me[ee[6]][ee[527]] = function(be) {
              be === void 0 && (be = this[ee[35]][ee[197]][ee[196]]());
              var pe = Date[ee[138]]() - (0, _e[ee[201]])(be), $e = this[ee[526]][ee[89]](function(Se) {
                return Se[ee[518]] >= pe;
              });
              if ($e[ee[3]] === 0)
                return 1;
              var ye = 0;
              return $e[ee[170]](function(Se, we) {
                var Pe = $e[we - 1], Te = Se[ee[135]], Ee = Te / oe, Me = Math[ee[116]](Se[ee[285]] / Se[ee[515]], 1), Ae = Math[ee[114]](Se[ee[525]], Ee), Ne = Me * (Te / Ae) + Te / (Pe ? Math[ee[114]](Se[ee[518]] - Pe[ee[518]], Ee) : (0, _e[ee[201]])(Math[ee[114]](Te, Ae))) * (1 - Me);
                ye = Se[ee[528]] ? ye - Ne : ye + Ne;
              }), ye / $e[ee[3]];
            }, me[ee[6]][ee[137]] = function(be) {
              he(be) && (this[ee[526]][ee[437]](be), be[ee[518]] - this[ee[526]][0][ee[518]] > ce && this[ee[526]][ee[502]]());
            }, me[ee[6]][ee[242]] = function(be, pe) {
              var $e = this[ee[527]](be), ye = fe[ee[216]][ee[218]];
              return $e > se ? ye = fe[ee[216]][ee[215]] : $e < le && (ye = fe[ee[216]][ee[220]]), { value: $e, result: ye };
            }, me[ee[6]][ee[136]] = function() {
            }, me[ee[6]][ee[139]] = function() {
            }, me[ee[6]][ee[140]] = function() {
              this[ee[139]](), this[ee[526]] = [];
            }, me;
          }(fe[ee[491]]);
          ne[ee[353]] = ge;
        }, 25050: function(ie, ne) {
          var ae;
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[491]] = ne[ee[216]] = void 0, function(_e) {
            _e[ee[215]] = ee[529], _e[ee[218]] = ee[530], _e[ee[220]] = ee[531];
          }(ae || (ne[ee[216]] = ae = {}));
          var ue = function() {
            function _e(fe, le) {
              this[ee[35]] = fe, this[ee[532]] = [], this[ee[36]] = le, this[ee[121]] = fe[ee[121]], this[ee[533]] = fe[ee[163]], this[ee[534]] = this[ee[533]][ee[535]];
            }
            return Object[ee[9]](_e[ee[6]], ee[508], { get: function() {
              var fe;
              return (fe = this[ee[35]][ee[108]]) === null || fe === void 0 ? void 0 : fe[ee[41]]();
            }, enumerable: !1, configurable: !0 }), _e[ee[6]][ee[315]] = function(fe, le, se) {
              return this[ee[242]](le, se);
            }, _e;
          }();
          ne[ee[491]] = ue;
        }, 94077: function(ie, ne, ae) {
          var ue = this && this[ee[234]] || function() {
            var Se = function(we, Pe) {
              return Se = Object[ee[235]] || { __proto__: [] } instanceof Array && function(Te, Ee) {
                Te[ee[236]] = Ee;
              } || function(Te, Ee) {
                for (var Me in Ee)
                  Object[ee[6]][ee[5]][ee[4]](Ee, Me) && (Te[Me] = Ee[Me]);
              }, Se(we, Pe);
            };
            return function(we, Pe) {
              if (ee[96] != typeof Pe && Pe !== null)
                throw new TypeError(ee[237] + String(Pe) + ee[238]);
              function Te() {
                this[ee[239]] = we;
              }
              Se(we, Pe), we[ee[6]] = Pe === null ? Object[ee[11]](Pe) : (Te[ee[6]] = Pe[ee[6]], new Te());
            };
          }();
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[298]] = void 0;
          var _e = ae(28819), fe = ae(8272), le = ae(331), se = ae(54838), oe = ae(67610), ce = ae(67304), he = ae(25050), ge = ee[489], ve = ee[490], me = function(Se) {
            function we(Pe, Te) {
              var Ee = Se[ee[4]](this, Pe, Te) || this;
              return Ee[ee[536]] = -1, Ee[ee[537]] = 0.1, Ee[ee[538]] = !0, Ee;
            }
            return ue(we, Se), we[ee[539]] = function() {
              if (!performance || ee[96] != typeof performance[ee[540]])
                return 0;
              var Pe = 0, Te = 0;
              return performance[ee[547]](ee[546])[ee[89]](be)[ee[170]](function(Ee) {
                Pe += 8 * Ee[ee[541]], Te += (0, le[ee[545]])(Ee[ee[542]] - (Ee[ee[543]] - Ee[ee[544]]));
              }), Pe > 0 && Te > 0 ? Pe / Te : 0;
            }, we[ee[6]][ee[504]] = function(Pe, Te, Ee) {
              var Me;
              Te === void 0 && (Te = 1), Ee === void 0 && (Ee = 0);
              var Ae = -Pe - Ee;
              return Me = Ee !== 0 ? this[ee[532]][ee[349]](Ae, -Ee) : this[ee[532]][ee[349]](Ae), (0, oe[ee[350]])(Me, 1 - Te);
            }, we[ee[548]] = function(Pe) {
              if (Pe && Pe[ee[203]]) {
                var Te = !!Pe[ee[203]][ee[499]], Ee = !isNaN(Pe[ee[203]][ee[348]]), Me = Pe[ee[203]][ee[549]] !== void 0 && !isNaN(Pe[ee[203]][ee[549]]);
                return Te && Ee && Me;
              }
              return !1;
            }, we[ee[6]][ee[550]] = function(Pe) {
              if (!this[ee[508]])
                return 0;
              var Te = (0, _e[ee[264]])((0, _e[ee[186]])(this[ee[508]]), Pe, fe[ee[110]][ee[300]]), Ee = we[ee[548]](Te), Me = Ee && this[ee[536]] < Te[ee[348]];
              return Me && isFinite(Te[ee[348]]) && (this[ee[536]] = Te[ee[348]]), Ee && Me ? pe(Te, this[ee[35]][ee[163]][ee[551]]) : Ee && !Me ? -1 : 0;
            }, we[ee[6]][ee[552]] = function() {
              var Pe = [], Te = this[ee[509]]();
              Te > 0 && Pe[ee[437]](Te);
              var Ee = this[ee[550]](ee[262]);
              Ee > 0 && Pe[ee[437]](Ee);
              var Me = Math[ee[116]][ee[7]](Math, Pe);
              return Me > 0 && isFinite(Me) ? Me : we[ee[539]]();
            }, we[ee[6]][ee[137]] = function() {
              var Pe = this[ee[550]](this[ee[36]]), Te = 0;
              this[ee[538]] && (Te = ye(this[ee[35]], Pe), this[ee[538]] = !1), (Te = Te || Pe || 0) === 0 && (Te = this[ee[552]]()), Te > 0 && (this[ee[532]][ee[437]](Te), this[ee[532]][ee[3]] > this[ee[534]] && this[ee[532]][ee[553]](0, this[ee[532]][ee[3]] - this[ee[534]])), Pe > 0 && this[ee[503]]();
            }, we[ee[6]][ee[242]] = function(Pe, Te) {
              Pe === void 0 && (Pe = 1), Te === void 0 && (Te = 1), this[ee[532]][ee[3]] === 0 && this[ee[137]]();
              var Ee = this[ee[504]](Pe, Te), Me = this[ee[504]](Pe, Te, 1);
              return { value: Ee, result: Ee > Me * (1 + this[ee[537]]) ? he[ee[216]][ee[215]] : Ee < Me * (1 - this[ee[537]]) ? he[ee[216]][ee[220]] : he[ee[216]][ee[218]] };
            }, we[ee[6]][ee[503]] = function() {
              if (this[ee[508]]) {
                var Pe = (0, _e[ee[301]])(this[ee[508]], this[ee[36]], fe[ee[110]][ee[300]])[ee[89]](we[ee[548]])[ee[349]](-3)[ee[189]](function(Te) {
                  return pe(Te);
                });
                this[ee[35]][ee[511]][ee[164]](ge, Pe), this[ee[35]][ee[511]][ee[164]](ve, Date[ee[138]]());
              }
            }, we[ee[6]][ee[509]] = function() {
              var Pe = this, Te = (this[ee[35]][ee[511]][ee[56]](ge) || [])[ee[189]](function(Ee) {
                return $e(Ee, Pe[ee[35]][ee[163]][ee[551]]);
              });
              return Math[ee[510]](Te[ee[389]](function(Ee, Me) {
                return Ee + Me;
              }, 0) / Te[ee[3]]) || 0;
            }, we[ee[6]][ee[139]] = function() {
            }, we[ee[6]][ee[136]] = function() {
            }, we[ee[6]][ee[140]] = function() {
            }, we;
          }(he[ee[491]]);
          function be(Se) {
            return Se[ee[541]] > 0 && !/^https?:\/\/localhost(:\d+)?(\/|$)/[ee[555]](Se[ee[554]]);
          }
          function pe(Se, we) {
            var Pe;
            we === void 0 && (we = 1 / 0);
            var Te = Se[ee[203]][ee[348]] - ((Pe = Se[ee[203]][ee[549]]) !== null && Pe !== void 0 ? Pe : 0);
            return $e(8 * Se[ee[203]][ee[499]] / Te, we);
          }
          function $e(Se, we) {
            var Pe = se[ee[168]][ee[406]](ee[114], we);
            return Math[ee[116]](Se, Pe);
          }
          function ye(Se, we) {
            var Pe = (0, ce[ee[403]])(Se), Te = (0, ce[ee[402]])(Se);
            return Te = we > 0 ? Math[ee[116]](Te, we) : Te, Pe || Te || 0;
          }
          ne[ee[298]] = me;
        }, 78827: function(ie, ne, ae) {
          var ue = this && this[ee[234]] || function() {
            var he = function(ge, ve) {
              return he = Object[ee[235]] || { __proto__: [] } instanceof Array && function(me, be) {
                me[ee[236]] = be;
              } || function(me, be) {
                for (var pe in be)
                  Object[ee[6]][ee[5]][ee[4]](be, pe) && (me[pe] = be[pe]);
              }, he(ge, ve);
            };
            return function(ge, ve) {
              if (ee[96] != typeof ve && ve !== null)
                throw new TypeError(ee[237] + String(ve) + ee[238]);
              function me() {
                this[ee[239]] = ge;
              }
              he(ge, ve), ge[ee[6]] = ve === null ? Object[ee[11]](ve) : (me[ee[6]] = ve[ee[6]], new me());
            };
          }(), _e = this && this[ee[463]] || function(he, ge, ve) {
            if (ve || arguments[ee[3]] === 2)
              for (var me, be = 0, pe = ge[ee[3]]; be < pe; be++)
                !me && be in ge || (me || (me = Array[ee[6]][ee[349]][ee[4]](ge, 0, be)), me[be] = ge[be]);
            return he[ee[13]](me || Array[ee[6]][ee[349]][ee[4]](ge));
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[296]] = void 0;
          var fe = ae(28819), le = ae(8272), se = ae(67610), oe = ae(25050), ce = function(he) {
            function ge(ve, me) {
              var be = he[ee[4]](this, ve, me) || this;
              return be[ee[536]] = -1, be;
            }
            return ue(ge, he), ge[ee[6]][ee[556]] = function(ve) {
              if (!this[ee[508]])
                return 0;
              var me = (0, fe[ee[264]])((0, fe[ee[186]])(this[ee[508]]), ve, le[ee[110]][ee[300]]), be = !!me && !!me[ee[203]], pe = be && me[ee[203]][ee[549]] !== void 0 && !isNaN(me[ee[203]][ee[549]]), $e = be && this[ee[536]] < me[ee[348]];
              return $e && isFinite(me[ee[348]]) && (this[ee[536]] = me[ee[348]]), pe && $e ? me[ee[203]][ee[549]] : pe && !$e ? -1 : 0;
            }, ge[ee[6]][ee[137]] = function() {
              var ve = this[ee[556]](this[ee[36]]), me = this[ee[556]](ee[262]), be = ve || me || 0;
              if (be > 0)
                for (this[ee[532]][ee[437]](be); this[ee[532]][ee[3]] > this[ee[534]]; )
                  this[ee[532]][ee[502]]();
            }, ge[ee[6]][ee[557]] = function(ve) {
              var me = -ve;
              return ve > 0 ? this[ee[532]][ee[349]](me) : [];
            }, ge[ee[6]][ee[558]] = function(ve, me) {
              var be = (0, se[ee[394]])(ve), pe = (0, se[ee[350]])(ve, me), $e = (0, se[ee[395]])(ve, be);
              return { value: { median: (0, se[ee[396]])(ve), mean: be, weightedAverage: pe, standardDeviation: $e }, result: oe[ee[216]][ee[218]] };
            }, ge[ee[6]][ee[242]] = function(ve, me) {
              return ve === void 0 && (ve = 1), me === void 0 && (me = 1), this[ee[558]](this[ee[557]](ve), me);
            }, ge[ee[6]][ee[315]] = function(ve, me, be) {
              me === void 0 && (me = 1), be === void 0 && (be = 1);
              var pe = _e(_e([], this[ee[557]](me - 1), !0), [ve], !1);
              return this[ee[558]](pe, be);
            }, ge[ee[6]][ee[136]] = function() {
            }, ge[ee[6]][ee[139]] = function() {
            }, ge[ee[6]][ee[140]] = function() {
            }, ge;
          }(oe[ee[491]]);
          ne[ee[296]] = ce;
        }, 12566: function(ie, ne) {
          function ae(ue, _e) {
            for (var fe, le, se = 0, oe = ue; se < oe[ee[3]]; se++) {
              var ce = oe[se];
              ce[ee[85]] > _e && (fe === void 0 || ce[ee[85]] < fe[ee[85]]) && (fe = ce), (le === void 0 || ce[ee[85]] > le[ee[85]]) && (le = ce);
            }
            return fe ?? le;
          }
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[479]] = ae;
        }, 74953: function(ie, ne, ae) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[172]] = fe;
          var ue = ae(18665), _e = ae(79814);
          function fe(oe, ce, he, ge) {
            var ve, me, be = se(ce, oe[ee[46]][ee[18]]);
            if (be) {
              var pe = oe[ee[57]][ee[559]](ue[ee[55]][ee[59]], function(Se) {
                return Se[ee[71]](he);
              }, null, oe[ee[53]][ee[52]]), $e = (ve = pe == null ? void 0 : pe[ee[72]][ee[189]](function(Se) {
                return { bandwidth: Se[ee[85]], id: Se[ee[107]] };
              })) !== null && ve !== void 0 ? ve : [], ye = be({ suggested: ge[ee[125]], isAd: oe[ee[53]][ee[560]], representations: $e });
              return ye && ((me = oe[ee[121]]) === null || me === void 0 || me[ee[15]](ee[469][ee[13]](ce, ee[562])[ee[13]](ge[ee[125]], ee[561]) + ee[270][ee[13]](ye))), le(oe, he, ye);
            }
          }
          function le(oe, ce, he) {
            return oe[ee[57]][ee[559]](ue[ee[55]][ee[59]], function(ge) {
              return ce && ge[ee[123]](ce, he);
            }, void 0, oe[ee[53]][ee[52]]) || void 0;
          }
          function se(oe, ce) {
            return _e[ee[91]][ee[177]](oe) ? ce == null ? void 0 : ce[ee[563]] : _e[ee[91]][ee[90]](oe) ? ce == null ? void 0 : ce[ee[94]] : void 0;
          }
        }, 89067: function(ie, ne) {
          function ae() {
            return new Promise(function(ue) {
              window[ee[202]](ue);
            });
          }
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[119]] = ae;
        } }, function(ie) {
          return function(ne) {
            return ie(ie[ee[564]] = ne);
          }(34188);
        }]);
      });
    })();
  })();
})(bitmovinplayerAbr, bitmovinplayerAbr.exports);
var bitmovinplayerAbrExports = bitmovinplayerAbr.exports;
const ABRModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerAbrExports);
var bitmovinplayerEngineBitmovin = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ie) {
      re.exports = ie();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[238], { 73543: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ContainerFormat = void 0, function(ae) {
          ae.MP4 = "mp4", ae.TS = "ts", ae.WEBM = "webm";
        }(ne || (ie.ContainerFormat = ne = {}));
      }, 29954: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.DrmKidErrorHandler = void 0;
        var ae = ne(18665), ue = ne(76650), _e = ne(28819), fe = ne(8272), le = ne(3464), se = ne(68294), oe = function() {
          function be(pe, $e) {
            var ye = this;
            this.context = pe, this.onDownloadedRepresentationExcludedCallback = $e, this.onDrmKidsWithErrorsChanged = function(we, Pe) {
              if (we !== void 0 && Pe !== void 0) {
                var Te = we.filter(function(Ee) {
                  return !Pe.includes(Ee);
                });
                ye.maybeExcludeRepresentations(Te);
              }
            };
            var Se = pe.sourceContext.sourceIdentifier;
            this.store = pe.store, this.logger = pe.logger, this.sourceStore = pe.serviceManager.get(ae.ServiceName.SourceStoreService, Se), this.manifestService = pe.serviceManager.get(ae.ServiceName.ManifestService, Se), this.unsubscribeFromStore = (0, le.subscribe)(this.sourceStore)(se.getDrmKeyIdsWithErrors, this.onDrmKidsWithErrorsChanged);
          }
          return be.prototype.maybeExcludeRepresentations = function(pe) {
            var $e = ge(this.manifestService, pe), ye = this.store.getState();
            if ($e.length !== 0 && ye !== void 0) {
              var Se = he(ce(ye), $e);
              this.logger.debug("Excluding representations due to DRM licenses not being available", $e), this.manifestService.excludeRepresentations($e) && Se && (this.store.dispatch((0, ue.clearMetricsHistory)("default", fe.MetricType.RequestedRepresentations)), this.onDownloadedRepresentationExcludedCallback());
            }
          }, be.prototype.trackSegment = function(pe) {
            var $e = pe.getDrmKid();
            if ($e !== void 0) {
              var ye = this.sourceStore.getState(), Se = pe.getRepresentationId(), we = ye ? (0, se.getDrmKeyIdsWithErrors)(ye) : [];
              me($e, Se, this.manifestService) && (ve($e, Se, this.manifestService), this.maybeExcludeRepresentations(we));
            }
          }, be.prototype.dispose = function() {
            this.unsubscribeFromStore();
          }, be;
        }();
        function ce(be) {
          return (0, _e.getMetricsHistoryFromInstanceState)(be, "default", fe.MetricType.RequestedRepresentations).map(function(pe) {
            return pe.value;
          });
        }
        function he(be, pe) {
          return pe.some(function($e) {
            return be.some(function(ye) {
              return ye.equals($e);
            });
          });
        }
        function ge(be, pe) {
          return be.getAllRepresentations().filter(function($e) {
            return $e.associatedKid && pe.includes($e.associatedKid);
          }).map(function($e) {
            return $e._internalId;
          });
        }
        function ve(be, pe, $e) {
          $e.setRepresentationDrmKid(pe, be);
        }
        function me(be, pe, $e) {
          return be !== $e.getRepresentationDrmKid(pe);
        }
        ie.DrmKidErrorHandler = oe;
      }, 6476: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.HeartbeatService = void 0;
        var ae = ne(18665), ue = 250, _e = function() {
          function ce(he, ge) {
            this.serviceManager = he, this.mediaPlayerController = ge, this.heartbeatTimeoutId = -1;
          }
          return Object.defineProperty(ce.prototype, "streamTimeService", { get: function() {
            return this.serviceManager.get(ae.ServiceName.StreamTimeService);
          }, enumerable: !1, configurable: !0 }), ce.prototype.resetHeartbeatTimeout = function() {
            var he = this;
            clearTimeout(this.heartbeatTimeoutId), this.heartbeatTimeoutId = window.setTimeout(function() {
              return he.beat();
            }, ue);
          }, ce.prototype.beat = function() {
            this.resetHeartbeatTimeout(), oe(this.mediaPlayerController, this.streamTimeService);
          }, Object.defineProperty(ce.prototype, "started", { get: function() {
            return this.heartbeatTimeoutId !== -1;
          }, enumerable: !1, configurable: !0 }), ce.prototype.start = function() {
            this.beat();
          }, ce.prototype.stop = function() {
            clearTimeout(this.heartbeatTimeoutId), this.heartbeatTimeoutId = -1;
          }, ce.prototype.dispose = function() {
            this.stop();
          }, ce;
        }();
        function fe(ce) {
          ce.shouldClearSubtitleServiceBuffers() && ce.clearSubtitleServiceBuffers();
        }
        function le(ce) {
          ce.areMediaTypesFinalForPlayingPeriod() ? ce.maybeStop() : ce.isAVCompletelyLoaded() && ce.signalEndOfStream(), fe(ce);
        }
        function se(ce, he) {
          var ge = ce.getActiveSegmentControllers(), ve = ge.length > 0;
          ve && ge.forEach(function(me) {
            var be = he.getTimeForNextSegment(me.getMimeType());
            ce.getNextSegment(me, be);
          }), ce.areAllLoadersReady() && (ve ? fe(ce) : ce.isLoadingLastPeriod() ? le(ce) : (ce.switchLoadingPeriod(), oe(ce, he)));
        }
        function oe(ce, he) {
          ce.shouldSuspendHeartbeat() || se(ce, he);
        }
        ie.HeartbeatService = _e;
      }, 85586: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(qe) {
            for (var ze, je = 1, tt = arguments.length; je < tt; je++)
              for (var ut in ze = arguments[je])
                Object.prototype.hasOwnProperty.call(ze, ut) && (qe[ut] = ze[ut]);
            return qe;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MediaPlayer = ie.LoadState = void 0, ie.checkIfGapSkip = Qe;
        var ue, _e = ne(92712), fe = ne(47275), le = ne(18665), se = ne(60997), oe = ne(62510), ce = ne(57620), he = ne(15539), ge = ne(33696), ve = ne(76650), me = ne(28819), be = ne(8272), pe = ne(17990), $e = ne(58975), ye = ne(3464), Se = ne(42283), we = ne(79814), Pe = ne(331), Te = ne(46462), Ee = ne(91520), Me = ne(16368), Ae = ne(6476), Ne = ne(3337), Ce = ne(38353), Ie = ne(43412), xe = ne(28171), Ue = ne(36366), ke = ne(81660), Le = ne(38765), De = ne(4053), Re = ne(71827), Oe = ne(58211), Be = ne(59879), Fe = ne(64330);
        (function(qe) {
          qe.Unloaded = "unloaded", qe.Preparing = "preparing", qe.Loading = "loading", qe.Loaded = "loaded";
        })(ue || (ie.LoadState = ue = {}));
        var Ve = Object.freeze({ id: "auto", bitrate: null }), Ke = Object.freeze({ id: "auto", bitrate: null, width: null, height: null }), Ze = function() {
          function qe(ze) {
            var je = this;
            this.timeShiftJumpStart = -1, this.ignoreNextVideoError = !1, this.ended = !1, this.isDvrWindowExceeded = !1, this.controlPermitted = !0, this.lastPlayIssuer = "api", this.lastPauseIssuer = "api", this.onSegmentAvailable = function(tt) {
              je.relativeCurrentTimeOffset != null || tt.isInit() || (je.relativeCurrentTimeOffset = je.isLive() ? je.calcRelativeCurrentTimeOffsetForLive(tt) : 0);
            }, this.onPlaying = function() {
              je.isLive() && je.canResumeLatencyControl() && je.resumeLatencyControl();
            }, this.videoErrorHandler = function(tt) {
              je.ignoreNextVideoError ? je.ignoreNextVideoError = !1 : (je.logger.debug("Caught a video element error: ", tt), je.unload(), je.eventHandler.fireError((0, ce.createPlayerErrorFromMediaError)(tt)));
            }, this.controlLiveLatency = function() {
              var tt = je.liveLatencyService.getStatus(je.liveLatencyMode, je.getCommonBufferLevel());
              je.liveLatencyMode !== tt.mode && (je.context.eventHandler.dispatchEvent(oe.PlayerEvent.LatencyModeChanged, { from: je.liveLatencyMode, to: tt.mode }), je.liveLatencyMode = tt.mode), tt.mode === oe.LatencyMode.Suspended || je.playerStateService.seekingOrTimeshifting || (tt.requiredAction === je.lowLatencyModule.LiveLatencyControlAction.Seek ? je.goToLiveEdge() : tt.requiredAction === je.lowLatencyModule.LiveLatencyControlAction.PlaybackRate && je.setPlaybackSpeed(1, tt.actionParam, !1));
            }, this.onPlaybackStarted = function() {
              je.playerStateService.getIsRendererStalling() ? (je.logger.debug("Renderer is currently stalled. Waiting for unstalling before ending stall."), je.clearStallEndedSubscription(), je.unsubscribeFromStallEnded = (0, ye.subscribe)(je.context.store)(function(tt) {
                return (0, $e.getPlayerState)(tt);
              }, function() {
                return je.endStall();
              }, function(tt) {
                return !(0, $e.getIsRendererStalled)(tt);
              })) : je.endStall();
            }, this.onVideoElementPlay = function() {
              je.ended && (je.logger.debug("Detected replay attempt from video element"), je.context.internalPlayer.play()), je.playerStateService.transitionToPlayState(!0, je.lastPlayIssuer);
            }, this.onVideoElementPaused = function() {
              je.logger.insane("video element signaled pause in state: ".concat(je.playerStateService.playbackState)), je.playerController.maybeTransitionToPausedState(je.lastPauseIssuer);
            }, this.mapLangObjectToAudioTrack = function(tt) {
              return { id: tt.id, lang: tt.lang, label: tt.label, role: tt.role, getQualities: function() {
                return xe.MediaPlayerManifestApiFactory.getAudioQualities(je.manifestService, je.getCurrentPlayingPeriodId(), tt.id);
              } };
            }, this.onVideoElementSeeking = function(tt) {
              var ut = Qe(je.context, tt.time);
              je.settings.GLOBAL_DISABLE_SEEKING && !ut && Math.abs(tt.time - je.lastCurrentTimeUpdate) > 0.05 && (je.logger.debug("Seeking now allowed, seeking back to expected time"), je.context.videoElement.currentTime = je.lastCurrentTimeUpdate);
            }, this.onVideoTimeupdate = function(tt) {
              if (!je.ended) {
                var ut = je.renderer.getCurrentTime(!0) === 0, yt = je.isPlaying(), $t = je.playerStateService.isSeeking(), ft = je.isStalled();
                !yt || $t || ft || ut ? je.logger.debug("Skipping timeupdate", { isPlaying: yt, isSeeking: $t, isStalled: ft, timeUpdateWithoutBuffer: ut, time: tt.time }) : je.handleTimeChanged(je.getCurrentTime());
              }
            }, this.onContentPlaybackFinished = function() {
              je.ended = !0;
            }, this.onDvrWindowExceeded = function() {
              je.context.logger.debug("DVR window exceeded"), je.playerStateService.isPlaying() ? je.handleDvrWindowExceeded() : je.isDvrWindowExceeded = !0;
            }, this.onError = function(tt) {
              tt.code === 3001 && je.unload();
            }, this.fireAudioTracksAdded = function() {
              for (var tt = je.getCurrentTime(), ut = 0, yt = je.getAvailableAudio(); ut < yt.length; ut++) {
                var $t = yt[ut];
                je.context.eventHandler.dispatchEvent(oe.PlayerEvent.AudioAdded, { track: $t, time: tt });
              }
            }, this.fireAudioTracksRemoved = function(tt) {
              for (var ut = 0, yt = je.getAvailableAudio(); ut < yt.length; ut++) {
                var $t = yt[ut];
                je.context.eventHandler.dispatchEvent(oe.PlayerEvent.AudioRemoved, { track: $t, time: tt });
              }
            }, this.onPeriodSwitch = function() {
              je.fireAudioTracksRemoved(je.getCurrentTime());
            }, this.onPlaybackSpeedChanged = function(tt) {
              je.isLive() && (je.canResumeLatencyControl() ? je.resumeLatencyControl() : je.suspendLatencyControl(!1));
            }, this.context = ze, this.logger = ze.logger, this.config = ze.config, this.settings = ze.settings, this.renderer = ze.renderer, this.eventHandler = ze.eventHandler, this.loadState = ue.Unloaded, this.context.store.dispatch((0, ve.initializeMetricsForMimeType)("default", this.context.settings)), this.playerController = new Ue.MediaPlayerController(ze, this.onSegmentAvailable), Ee.ModuleManager.has(Me.ModuleName.LowLatency) && (this.lowLatencyModule = Ee.ModuleManager.get(Me.ModuleName.LowLatency)), this.eventHandler.on(oe.PlayerEvent.PeriodSwitch, this.onPeriodSwitch), this.eventHandler.on(oe.PlayerEvent.PeriodSwitched, this.fireAudioTracksAdded), this.eventHandler.on(oe.PlayerEvent.PlaybackSpeedChanged, this.onPlaybackSpeedChanged), this.unsubscribeStorePlayingListener = (0, ye.subscribe)(this.context.store)(function(tt) {
              return (0, $e.getIsPlaying)((0, $e.getPlayerState)(tt));
            }, this.onPlaying, function(tt, ut) {
              return tt && !ut;
            });
          }
          return qe.prototype.createServices = function(ze, je) {
            var tt = je.serviceManager;
            this.createSynchronizedTimeService(je), this.createManifestService(je), this.createManifestLoadingService(je, ze), this.createManifestUpdateSchedulingService(je);
            var ut = Ee.ModuleManager.get(Me.ModuleName.ABR).AdaptationService;
            tt.set(le.ServiceName.AdaptationService, new ut(je)), tt.set(le.ServiceName.TimedMetadataService, new Le.TimedMetadataService(je)), tt.set(le.ServiceName.SegmentService, new ke.SegmentService(je));
            var yt = new Be.StreamTimeService(tt, je.sourceContext.sourceIdentifier);
            tt.set(le.ServiceName.StreamTimeService, yt), tt.set(le.ServiceName.HeartbeatService, new Ae.HeartbeatService(tt, this.playerController), je.sourceContext.sourceIdentifier), this.createSubtitleService(je), this.createLowLatencyService(je);
          }, qe.prototype.createSynchronizedTimeService = function(ze) {
            var je = ze.serviceManager, tt = ze.sourceContext.sourceIdentifier;
            if (!je.has(le.ServiceName.SynchronizedTimeService, tt)) {
              var ut = new Fe.SynchronizedTimeService(ze, ze.sourceContext);
              je.set(le.ServiceName.SynchronizedTimeService, ut, tt);
            }
          }, qe.prototype.createManifestService = function(ze) {
            var je = ze.serviceManager, tt = ze.sourceContext.sourceIdentifier;
            je.has(le.ServiceName.ManifestService, tt) ? (this.manifestService = je.get(le.ServiceName.ManifestService, tt), this.manifestService.restore()) : (this.manifestService = new Ce.ManifestService(ze, ze.sourceContext), je.set(le.ServiceName.ManifestService, this.manifestService, tt));
          }, qe.prototype.createManifestLoadingService = function(ze, je) {
            var tt = ze.serviceManager, ut = ze.sourceContext.sourceIdentifier;
            if (!tt.has(le.ServiceName.ManifestLoadingService, ut)) {
              var yt = (0, Ne.createManifestLoadingService)(je, ze, ze.sourceContext);
              tt.set(le.ServiceName.ManifestLoadingService, yt, ut);
            }
          }, qe.prototype.createManifestUpdateSchedulingService = function(ze) {
            var je = ze.serviceManager, tt = ze.sourceContext.sourceIdentifier;
            if (je.has(le.ServiceName.ManifestUpdateSchedulingService, tt))
              je.get(le.ServiceName.ManifestUpdateSchedulingService, tt).restore();
            else {
              var ut = new Ie.ManifestUpdateScheduler(ze, ze.sourceContext);
              je.set(le.ServiceName.ManifestUpdateSchedulingService, ut, tt);
            }
          }, qe.prototype.createSubtitleService = function(ze) {
            var je = ze.serviceManager;
            if (Ee.ModuleManager.has(Me.ModuleName.Subtitles)) {
              var tt = Ee.ModuleManager.get(Me.ModuleName.Subtitles).SubtitleService;
              je.set(le.ServiceName.SubtitleService, new tt(ze)), this.subtitleService = je.get(le.ServiceName.SubtitleService);
            }
          }, qe.prototype.createLowLatencyService = function(ze) {
            var je, tt = ze.serviceManager;
            (je = this.liveLatencyService) === null || je === void 0 || je.dispose(), Ee.ModuleManager.has(Me.ModuleName.LowLatency) && (tt.set(le.ServiceName.LiveLatencyService, new this.lowLatencyModule.LiveLatencyService(ze)), this.liveLatencyService = tt.get(le.ServiceName.LiveLatencyService));
          }, qe.prototype.disposeServices = function(ze) {
            var je, tt = this.context.serviceManager;
            [le.ServiceName.LiveLatencyService, le.ServiceName.SubtitleService, le.ServiceName.TimedMetadataService].forEach(function(yt) {
              return (0, fe.disposeService)(tt, yt);
            });
            var ut = (je = this.context.sourceContext) === null || je === void 0 ? void 0 : je.sourceIdentifier;
            ut && ((0, fe.disposeService)(tt, le.ServiceName.HeartbeatService, ut), (0, fe.disposeService)(tt, le.ServiceName.SegmentService, ut), ze !== he.ADVERTISING_ISSUER_NAME ? [le.ServiceName.ManifestService, le.ServiceName.ManifestLoadingService, le.ServiceName.ManifestUpdateSchedulingService, le.ServiceName.SynchronizedTimeService].forEach(function(yt) {
              return (0, fe.disposeService)(tt, yt, ut);
            }) : (tt.get(le.ServiceName.ManifestService, ut).suspend(), tt.get(le.ServiceName.ManifestUpdateSchedulingService, ut).suspend()));
          }, qe.prototype.calcRelativeCurrentTimeOffsetForLive = function(ze) {
            var je = ze.getSegmentInfo().wallClockTime != null ? ze.getPlaybackTime() - (0, Pe.toSeconds)(ze.getSegmentInfo().wallClockTime) : 0;
            return this.playerController.getSeekableRange().start + je;
          }, qe.prototype.play = function(ze) {
            return this.lastPlayIssuer = ze, this.controlPermitted ? this.currentSource ? this.playerStateService.isPlaying() ? (this.logger.debug("Ignoring play call as play was already triggered or we're already playing"), Promise.resolve()) : (this.ended = !1, this.playerStateService.isPaused() && this.isLive() && (this.isDvrWindowExceeded || this.getMaxTimeShift() >= 0) && (this.context.logger.debug("Handling DVR window excursion - going to live edge"), this.goToLiveEdge(), this.isDvrWindowExceeded = !1), this.playerController.start(), this.playerStateService.transitionToPendingPlayState(!1, ze), this.renderer.play()) : Promise.resolve() : Promise.reject("Play control not permitted");
          }, qe.prototype.goToLiveEdge = function() {
            var ze = this;
            this.settings.ENABLE_SEEK_FOR_LIVE ? this.playerStateService.isSeeking() || this.seek(this.getSeekableRange().end, he.INTERNAL_ISSUER_NAME) : this.playerController.timeShift(0, function() {
              return ze.onTimeShifted();
            }).catch(function() {
              return ze.onTimeShiftFailed();
            });
          }, qe.prototype.canResumeLatencyControl = function() {
            return !!this.liveLatencyService && !this.isPaused() && this.getTimeShift() === 0 && this.getPlaybackSpeed() === 1 && !this.playerStateService.isTimeShifting() && !this.playerStateService.isSeeking();
          }, qe.prototype.resumeLatencyControl = function() {
            this.liveLatencyService.resumeControl();
          }, qe.prototype.suspendLatencyControl = function(ze) {
            ze === void 0 && (ze = !0);
            var je = this.liveLatencyMode === oe.LatencyMode.Suspended;
            this.liveLatencyService && !je && (this.liveLatencyService.suspendControl(), ze && this.setPlaybackSpeed(1, 1, !1));
          }, qe.prototype.getCommonBufferLevel = function() {
            var ze = [this.getBufferLevel(ge.BufferType.ForwardDuration, ge.MediaType.Audio), this.getBufferLevel(ge.BufferType.ForwardDuration, ge.MediaType.Video)].map(function(je) {
              return je.level;
            }).filter(function(je) {
              return je !== null;
            });
            return ze.length === 0 ? 0 : Math.min.apply(Math, ze);
          }, qe.prototype.endStall = function() {
            this.clearStallEndedSubscription(), this.playerStateService.stallExit(), this.playerStateService.transitionToPlayingState(this.lastPlayIssuer), this.ended = !1;
          }, qe.prototype.preload = function() {
            this.loadState !== ue.Unloaded && this.playerController && this.playerController.start();
          }, qe.prototype.pause = function(ze) {
            this.controlPermitted && (this.logger.insane("Pause was called via the API"), this.playerStateService.isInitial() || (this.lastPauseIssuer = ze, this.isLive() && this.liveLatencyService && this.liveLatencyService.isConfigured() && (this.suspendLatencyControl(), this.controlLiveLatency()), this.playerStateService.isPaused() || this.playerStateService.isStopped() || this.renderer.pause(), this.playerStateService.transitionToPausedState(this.renderer.isPaused(), ze)));
          }, qe.prototype.mute = function(ze) {
            this.isMuted() || (this.renderer.mute(), this.context.eventHandler.dispatchEvent(oe.PlayerEvent.Muted, { issuer: ze || "api" }));
          }, qe.prototype.unmute = function(ze) {
            this.isMuted() && (this.renderer.unmute(), this.context.eventHandler.dispatchEvent(oe.PlayerEvent.Unmuted, { issuer: ze || "api" }));
          }, qe.prototype.maybeAdjustSeekTargetToDiscontinuityStart = function(ze) {
            var je, tt = (je = this.getSourceStoreService()) === null || je === void 0 ? void 0 : je.getState();
            if (!tt || !this.manifestService.isHlsManifest())
              return ze;
            for (var ut = Ee.ModuleManager.get(Me.ModuleName.HLS).selectors, yt = ut.getHlsState, $t = (0, ut.getMergedDiscontinuityTimings)(yt(tt)), ft = Object.values($t), pt = 0; pt < ft.length - 1; pt++) {
              var lt = ft[pt].endTime, Je = ft[pt + 1].startTime;
              if (ze >= lt && ze < Je)
                return this.logger.debug("Adjusting seek target to discontinuity start: ".concat(ze, " -> ").concat(Je)), Je;
            }
            return ze;
          }, qe.prototype.seek = function(ze, je) {
            var tt, ut, yt;
            je === void 0 && (je = "");
            var $t = this.config && this.config.hasOwnProperty("playback") ? this.config.playback : {}, ft = !$t.hasOwnProperty("seeking") || $t.seeking, pt = this.context.store.getState(), lt = !!pt && (yt = (ut = (tt = (0, $e.getPlayerState)(pt)) === null || tt === void 0 ? void 0 : tt.seekingProcess) === null || ut === void 0 ? void 0 : ut.isInitial) !== null && yt !== void 0 && yt, Je = ![he.STARTUP_ISSUER_NAME, he.INTERNAL_ISSUER_NAME].includes(je);
            return !(!(lt || !this.settings.GLOBAL_DISABLE_SEEKING && ft) || !this.controlPermitted) && (ze = this.maybeAdjustSeekTargetToDiscontinuityStart(ze), this.ended = !1, this.cancelPotentialOngoingTimeShift(), this.playerStateService.transitionToSeekingState(ze, je, Je), this.context.store.dispatch((0, pe.updateSeekingProcess)({ issuer: je, targetTime: ze, isInitial: lt })), !0);
          }, qe.prototype.cancelPotentialOngoingTimeShift = function() {
            this.playerStateService.isTimeShifting() && (this.playerController.getTimeShiftHandler().cancel(), this.playerStateService.transitionToTimeShiftedState(!1));
          }, qe.prototype.handleTimeChanged = function(ze) {
            ze !== this.lastCurrentTimeUpdate && (this.context.eventHandler.dispatchEvent(oe.PlayerEvent.TimeChanged, { time: ze }), this.lastCurrentTimeUpdate = ze, this.isLive() && this.liveLatencyService && this.liveLatencyService.isConfigured() && this.controlLiveLatency());
          }, qe.prototype.setVolume = function(ze, je) {
            var tt = this.renderer.getVolume();
            this.renderer.setVolume(ze), tt !== ze && this.context.eventHandler.dispatchEvent(oe.PlayerEvent.VolumeChanged, { targetVolume: ze, sourceVolume: tt, issuer: je || "api" });
          }, qe.prototype.setAudioQuality = function(ze) {
            var je, tt = this.getAvailableAudioQualities(), ut = this.getAudioQuality();
            (je = ze === "auto" ? Ve : tt.find(function(yt) {
              return yt.id === ze;
            })) && ut.id !== je.id && (this.setFixedRepresentation(ge.MediaType.Audio, ze), this.context.eventHandler.dispatchEvent(oe.PlayerEvent.AudioQualityChanged, { sourceQuality: ut, sourceQualityId: ut.id, targetQuality: je, targetQualityId: je.id }));
          }, qe.prototype.getAudioQuality = function() {
            var ze = this.getInitializedMimeTypeFromMediaType(ge.MediaType.Audio), je = this.context.serviceManager.get(le.ServiceName.AdaptationService), tt = je.isAuto(ze), ut = je.getCurrentRepresentationId(ze);
            return tt || ut === null ? Ve : this.getAvailableAudioQualities().find(function(yt) {
              return yt.id === ut.representationId;
            });
          }, qe.prototype.setFixedRepresentation = function(ze, je) {
            var tt = this.getInitializedMimeTypeFromMediaType(ze);
            this.context.serviceManager.get(le.ServiceName.AdaptationService).setFixedRepresentation(tt, je);
          }, qe.prototype.setVideoQuality = function(ze) {
            var je, tt = this.getAvailableVideoQualities(), ut = this.getVideoQuality();
            (je = ze === "auto" ? Ke : tt.find(function(yt) {
              return yt.id === ze;
            })) && ut.id !== je.id && (this.context.eventHandler.dispatchEvent(oe.PlayerEvent.VideoQualityChanged, { sourceQuality: ut, sourceQualityId: ut.id, targetQuality: je, targetQualityId: je.id }), this.setFixedRepresentation(ge.MediaType.Video, ze));
          }, qe.prototype.getVideoQuality = function() {
            var ze = this.getInitializedMimeTypeFromMediaType(ge.MediaType.Video), je = this.context.serviceManager.get(le.ServiceName.AdaptationService), tt = je.isAuto(ze), ut = je.getCurrentRepresentationId(ze);
            return tt || ut === null ? Ke : this.getAvailableVideoQualities().find(function(yt) {
              return yt.id === ut.representationId;
            });
          }, qe.prototype.processSourceContext = function() {
            var ze = this.context.sourceContext;
            ze.source && ze.source.options && ze.source.options.headers && (this.settings.HTTP_HEADERS = ze.source.options.headers);
          }, qe.prototype.addReducersToSourceStore = function(ze) {
            var je = this.getSourceStoreService();
            if (je !== void 0) {
              if (ze.type === ge.StreamType.Hls && Ee.ModuleManager.has(Me.ModuleName.HLS) && !je.hasReducer("hls")) {
                var tt = Ee.ModuleManager.get(Me.ModuleName.HLS);
                je.addReducer("hls", tt.HlsReducer);
              }
              Object.keys(Re.engineBitmovinSourceReducers).forEach(function(ut) {
                var yt = Re.engineBitmovinSourceReducers[ut];
                yt !== void 0 && je.addReducer(ut, yt);
              });
            }
          }, qe.prototype.addRendererEventListeners = function() {
            this.renderer.on(Te.MediaElementEvent.error, this.videoErrorHandler), this.renderer.on(Te.MediaElementEvent.timeupdate, this.onVideoTimeupdate), this.renderer.on(Te.MediaElementEvent.seeking, this.onVideoElementSeeking), this.renderer.on(Te.MediaElementEvent.playing, this.onPlaybackStarted), this.renderer.on(Te.MediaElementEvent.play, this.onVideoElementPlay), this.renderer.on(Te.MediaElementEvent.pause, this.onVideoElementPaused);
          }, qe.prototype.logBitrateBoundarySettings = function() {
            this.logger.debug("setting bitrate boundaries for audio to " + this.settings.MIN_SELECTABLE_AUDIO_BITRATE + " - " + this.settings.MAX_SELECTABLE_AUDIO_BITRATE), this.logger.debug("setting bitrate boundaries for video to " + this.settings.MIN_SELECTABLE_VIDEO_BITRATE + " - " + this.settings.MAX_SELECTABLE_VIDEO_BITRATE);
          }, qe.prototype.loadInternal = function(ze, je) {
            var tt, ut = this;
            return this.loadState === ue.Unloaded ? Promise.reject("Unload during load") : (this.createServices(ze, this.context), this.context.sourceContext.source = ze.config, !((tt = this.context.videoElement) === null || tt === void 0) && tt.eventHandler && this.context.videoElement.eventHandler.reset(), this.currentSource = ze, this.ended = !1, this.isDvrWindowExceeded = !1, this.context.store.dispatch((0, pe.updateSeekingProcess)({ isInitial: !0 })), this.logBitrateBoundarySettings(), this.liveLatencyService && (this.liveLatencyMode = oe.LatencyMode.Suspended, this.liveLatencyService.reset()), this.addRendererEventListeners(), this.settings.GLOBAL_DISABLE_SEEKING = je || !1, this.loadState = ue.Loading, this.playerController.init(ze).then(function() {
              ut.loadState = ue.Loaded;
            }));
          }, qe.prototype.prepareLoad = function() {
            var ze = this.context.serviceManager.get(le.ServiceName.PlayerStateService);
            ze && (this.playerStateService = ze);
            var je = Promise.resolve();
            return this.loadState === ue.Loading && (je = this.unload()), this.playerStateService.reset(), this.loadState = ue.Preparing, je;
          }, qe.prototype.load = function(ze, je) {
            var tt = this;
            return ze.type !== "dash" && ze.type !== "hls" && ze.type !== "smooth" ? Promise.reject("invalid source") : (this.addReducersToSourceStore(ze), this.processSourceContext(), this.unsubscribeFromStoreStoppedListener = (0, ye.subscribe)(this.context.store)(function(ut) {
              return (0, $e.getIsStopped)((0, $e.getPlayerState)(ut));
            }, this.onContentPlaybackFinished, function(ut) {
              return ut === !0;
            }), this.eventHandler.on(oe.PlayerEvent.DVRWindowExceeded, this.onDvrWindowExceeded, !0), this.eventHandler.on(oe.PlayerEvent.Error, this.onError, !0), this.renderer.ready().then(function() {
              return tt.loadInternal(ze, je);
            }));
          }, qe.prototype.getSourceStoreService = function() {
            return this.context.serviceManager.get(le.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, qe.prototype.unload = function(ze) {
            var je = this;
            if (this.clearStallEndedSubscription(), this.loadState === ue.Unloaded)
              return Promise.resolve();
            var tt = this.loadState === ue.Loaded;
            this.ended = !1, this.loadState = ue.Unloaded, this.ignoreNextVideoError = !0, this.relativeCurrentTimeOffset = null, this.renderer.off(Te.MediaElementEvent.error, this.videoErrorHandler), this.renderer.off(Te.MediaElementEvent.timeupdate, this.onVideoTimeupdate), this.renderer.off(Te.MediaElementEvent.seeking, this.onVideoElementSeeking), this.renderer.off(Te.MediaElementEvent.playing, this.onPlaybackStarted), this.renderer.off(Te.MediaElementEvent.play, this.onVideoElementPlay), this.renderer.off(Te.MediaElementEvent.pause, this.onVideoElementPaused), this.unsubscribeFromStoreStoppedListener(), this.eventHandler.off(oe.PlayerEvent.DVRWindowExceeded, this.onDvrWindowExceeded), this.eventHandler.off(oe.PlayerEvent.Error, this.onError), this.playerStateService.isPlaying() && this.renderer.pause(), this.playerStateService.reset();
            var ut = this.context.sourceContext.sourceIdentifier;
            return this.context.serviceManager.has(le.ServiceName.SynchronizedTimeService, ut) && !nt(ze) && this.context.serviceManager.get(le.ServiceName.SynchronizedTimeService, ut).reset(), (this.playerController ? this.playerController.terminate() : Promise.resolve()).then(function() {
              je.currentSource = void 0, je.disposeServices(ze), nt(ze) || je.getSourceStoreService().dispatch((0, De.clearActiveTracksAction)()), tt && je.eventHandler.dispatchEvent(oe.PlayerEvent.SourceUnloaded);
            });
          }, qe.prototype.isReady = function() {
            return this.playerController.isInitialized();
          }, qe.prototype.isPlaying = function() {
            return this.playerStateService.isPlaying();
          }, qe.prototype.isPaused = function() {
            return this.playerStateService.isPaused();
          }, qe.prototype.hasEnded = function() {
            return this.ended;
          }, qe.prototype.isMuted = function() {
            return this.renderer.isMuted();
          }, qe.prototype.isStalled = function() {
            return this.playerStateService.isStalled;
          }, qe.prototype.isLive = function() {
            return this.manifestService.isLive();
          }, qe.prototype.getVolume = function() {
            return this.renderer.getVolume();
          }, qe.prototype.getCurrentTime = function(ze) {
            return ze === void 0 && (ze = ge.TimeMode.AbsoluteTime), !this.isLive() && this.hasEnded() ? this.getDuration() : ze === ge.TimeMode.RelativeTime ? Math.max(0, this.playerController.getCurrentTime() - this.relativeCurrentTimeOffset) : this.playerController.getCurrentTime();
          }, qe.prototype.getDuration = function() {
            return this.manifestService.getDuration();
          }, qe.prototype.getAvailableVideoQualities = function() {
            return this.isReady() ? this.manifestService.getVideoRepresentations(this.getCurrentPlayingPeriodId()) : [];
          }, qe.prototype.getAvailableSegments = function() {
            return this.isReady() ? this.playerController.getAvailableSegments() : {};
          }, qe.prototype.getAvailableAudioQualities = function() {
            var ze = this.getAudio();
            if (!this.isReady() || !ze)
              return [];
            var je = this.manifestService.getAudioRepresentations(this.getCurrentPlayingPeriodId());
            return je[ze.id] ? je[ze.id] : [];
          }, qe.prototype.getDroppedVideoFrames = function() {
            return this.renderer.getDroppedVideoFrames();
          }, qe.prototype.setTargetBufferLevel = function(ze, je, tt) {
            this.context.bufferSettings.setTargetLevel(ze, je, tt);
          }, qe.prototype.getBufferLevel = function(ze, je) {
            var tt = { level: null, targetLevel: this.context.bufferSettings.getTargetLevel(ze, je), type: ze, media: je }, ut = this.renderer.getCurrentTime(), yt = (0, me.getMetricsState)(this.context.store.getState()), $t = Object.keys(yt).find(function(pt) {
              return we.MimeTypeHelper.isVideo(pt);
            }), ft = Object.keys(yt).find(function(pt) {
              return we.MimeTypeHelper.isAudio(pt);
            });
            return je === ge.MediaType.Video && $t ? tt.level = this.playerController.getBufferLevel($t, ut, ze) : je === ge.MediaType.Audio && ft && (tt.level = this.playerController.getBufferLevel(ft, ut, ze)), tt;
          }, qe.prototype.getTotalStalledTime = function() {
            var ze = (0, me.getMetricsState)(this.context.store.getState());
            for (var je in ze)
              if (ze[je]) {
                var tt = (0, me.getMetricsLastEntry)(ze, je, be.MetricType.StalledSeconds);
                if (tt && tt.value && !isNaN(tt.value))
                  return Math.round(100 * tt.value) / 100;
              }
            return 0;
          }, qe.prototype.getInitializedMimeTypeFromMediaType = function(ze) {
            var je = (0, me.getMetricsState)(this.context.store.getState());
            return Object.keys(je).find(function(tt) {
              return tt.includes(ze);
            });
          }, qe.prototype.getDownloadedData = function(ze) {
            var je = this.getInitializedMimeTypeFromMediaType(ze), tt = ae({}, this.getCurrentAdaptationSet(je)), ut = ae({}, this.getCurrentRepresentation(je));
            return ut.id && (ut.id = "" + ut.id), ut.width === void 0 && tt.width !== void 0 && (ut.width = tt.width), ut.width = parseInt("" + ut.width), ut.height === void 0 && tt.height !== void 0 && (ut.height = tt.height), ut.height = parseInt("" + ut.height), ut.bitrate === void 0 && tt.bitrate !== void 0 && (ut.bitrate = tt.bitrate), ut.bitrate = parseInt("" + ut.bitrate), ut.isAuto = this.context.serviceManager.get(le.ServiceName.AdaptationService).isAuto(je), ut;
          }, qe.prototype.getCurrentRepresentation = function(ze) {
            if (this.playerController.hasStarted()) {
              var je = (0, me.getMetricsState)(this.context.store.getState());
              if (je[ze])
                return (0, me.getMetricsLastEntry)(je, ze, be.MetricType.DownloadedRepresentation).value;
            }
            return {};
          }, qe.prototype.getCurrentAdaptationSet = function(ze) {
            if (this.playerController.hasStarted()) {
              var je = (0, me.getMetricsState)(this.context.store.getState());
              if (je[ze])
                return (0, me.getMetricsLastEntry)(je, ze, be.MetricType.DownloadedAdaptationSet).value;
            }
            return {};
          }, qe.prototype.getDownloadedVideoData = function() {
            var ze = this.getDownloadedData(ge.MediaType.Video), je = !0;
            return ze.hasOwnProperty("isAuto") && (je = ze.isAuto), ze && (ze.bitrate || ze.id) ? { id: ze.id, bitrate: ze.bitrate, height: ze.height, width: ze.width, isAuto: je } : { id: "", bitrate: 0, height: 0, width: 0, isAuto: !0 };
          }, qe.prototype.getDownloadedAudioData = function() {
            var ze = this.getDownloadedData(ge.MediaType.Audio), je = !0;
            return ze.hasOwnProperty("isAuto") && (je = ze.isAuto), ze && (ze.bitrate || ze.id) ? { id: ze.id, bitrate: ze.bitrate, isAuto: je } : { id: "", bitrate: 0, isAuto: !0 };
          }, qe.prototype.getPlaybackVideoData = function() {
            var ze = this.playerController.getPlaybackRepresentation(ge.MediaType.Video) || {}, je = isNaN(ze._height) ? 0 : Number(ze._height), tt = isNaN(ze._width) ? 0 : Number(ze._width), ut = { id: ze._id + "", bitrate: Number(ze._bandwidth) || 0, frameRate: ze._frameRate, height: je, width: tt, uid: ze.uid };
            return ze._codecs && (ut.codec = Se.CodecStringHelper.getExtractedCodecStrings(ze._codecs).video), ut;
          }, qe.prototype.getPlaybackAudioData = function() {
            var ze = this.playerController.getPlaybackRepresentation(ge.MediaType.Audio) || {}, je = { id: ze._id + "", bitrate: Number(ze._bandwidth) };
            return ze._codecs && (je.codec = Se.CodecStringHelper.getExtractedCodecStrings(ze._codecs).audio), je;
          }, qe.prototype.setQueryParameters = function(ze) {
            this.settings.QUERY_PARAMETERS = ze;
          }, qe.prototype.clearQueryParameters = function() {
            this.settings.QUERY_PARAMETERS = void 0;
          }, qe.prototype.restoreAfterTimeShift = function(ze) {
            this.playerStateService && (this.playerStateService.isTimeShifting() && (this.playerStateService.transitionToTimeShiftedState(ze), this.timeShiftJumpStart = -1), this.isLive() && (this.canResumeLatencyControl() ? this.resumeLatencyControl() : this.suspendLatencyControl()));
          }, qe.prototype.onTimeShiftFailed = function() {
            this.restoreAfterTimeShift(!1);
          }, qe.prototype.onTimeShifted = function(ze) {
            this.restoreAfterTimeShift(ze !== he.STARTUP_ISSUER_NAME);
          }, qe.prototype.getMaxTimeShift = function() {
            if (this.isLive() && this.isReady())
              return this.config.playback && this.config.playback.timeShift === !1 ? 0 : this.playerController.getMaxTimeShift();
          }, qe.prototype.timeShift = function(ze, je) {
            var tt = this;
            if (this.isReady() && this.getMaxTimeShift() <= 0) {
              this.timeShiftJumpStart === -1 && (this.timeShiftJumpStart = this.getCurrentTime(), this.timeShiftJumpStart === 0 && (this.timeShiftJumpStart = this.playerController.getTimeShiftLiveEdge()));
              var ut = this.playerController.getPlaybackTimeForTimeShiftOffset(ze);
              this.playerStateService.transitionToTimeShiftingState(this.timeShiftJumpStart, ut, je || "api", je !== he.STARTUP_ISSUER_NAME), this.playerController.timeShift(ze, function() {
                return tt.onTimeShifted(je);
              }).catch(function() {
                return tt.onTimeShiftFailed();
              });
            }
          }, qe.prototype.getTimeShift = function() {
            return this.isReady() ? this.playerController.getTimeShift() : 0;
          }, qe.prototype.addSubtitle = function(ze) {
            var je = this;
            return this.isReady() && this.subtitleService ? Promise.resolve(void 0).then(function() {
              je.subtitleService.addExternalSubtitle(ze);
            }) : Promise.reject(void 0);
          }, qe.prototype.removeSubtitle = function(ze) {
            this.isReady() && this.subtitleService && this.subtitleService.removeSubtitle(ze);
          }, qe.prototype.enableSubtitle = function(ze) {
            return this.isReady() && this.subtitleService ? this.subtitleService.enableSubtitle(ze) : Promise.resolve(!1);
          }, qe.prototype.disableSubtitle = function(ze) {
            return this.isReady() && this.subtitleService ? this.subtitleService.disableSubtitle(ze) : Promise.resolve(!1);
          }, qe.prototype.listSubtitles = function() {
            return this.isReady() && this.subtitleService && this.playerController ? this.subtitleService.getAvailableSubtitles(this.getCurrentPlayingPeriodId()) : [];
          }, qe.prototype.setAudio = function(ze) {
            var je = this;
            if (this.isReady() && this.playerController && typeof ze == "string") {
              var tt = this.getAudio();
              if (tt && tt.id === String(ze))
                return;
              this.playerController.setAudio(ze).then(function() {
                var ut = je.getAudio();
                ut && tt && ut.id !== tt.id && je.context.eventHandler.dispatchEvent(oe.PlayerEvent.AudioChanged, { targetAudio: ut, sourceAudio: tt, time: je.renderer.getCurrentTime() });
              }).catch(function(ut) {
                je.logger.debug("setAudio failed for lang ", ut);
              });
            }
          }, qe.prototype.getAvailableAudio = function() {
            return this.isReady() && this.playerController ? this.playerController.getAvailableAudio(this.getCurrentPlayingPeriodId()).map(this.mapLangObjectToAudioTrack) : [];
          }, qe.prototype.getAudio = function() {
            if (this.isReady() && this.playerController) {
              var ze = this.playerController.getAudio();
              if (ze)
                return this.mapLangObjectToAudioTrack(ze);
            }
            return null;
          }, qe.prototype.getManifest = function() {
            var ze = this.manifestService.getManifest();
            if (ze)
              return ze._isHls ? this.getHlsManifest() : ze.originalDashManifest;
          }, qe.prototype.getHlsManifest = function() {
            return Ee.ModuleManager.get(Me.ModuleName.HLS).selectors.getHlsState(this.getSourceStoreService().getState()).masterPlaylist.string;
          }, qe.prototype.getBufferedRanges = function() {
            var ze = this.playerController.getBufferedRanges(!0);
            return _e.BufferRangeHelper.getCommonBufferedRanges(ze).map(function(je) {
              return { start: je.getStart(), end: je.getEnd() };
            });
          }, qe.prototype.getSnapshot = function(ze, je) {
            if (this.isPlaying() || this.isPaused())
              return this.renderer.getSnapshotData(ze, je);
          }, qe.prototype.setPlaybackSpeed = function(ze, je, tt) {
            je === void 0 && (je = 1), tt === void 0 && (tt = !0), this.renderer.setPlaybackSpeed(ze * je), this.playerStateService.playbackSpeed !== this.renderer.getPlaybackSpeed() && this.playerStateService.setPlaybackSpeed(ze, je, tt);
          }, qe.prototype.getPlaybackSpeed = function() {
            return this.playerStateService.playbackSpeed;
          }, qe.prototype.permitControl = function(ze) {
            this.controlPermitted = ze;
          }, qe.prototype.getSeekableRange = function() {
            return this.isLive() && !this.settings.ENABLE_SEEK_FOR_LIVE || !this.playerController ? { start: -1, end: -1 } : this.playerController.getSeekableRange();
          }, qe.prototype.createManifestApi = function() {
            return xe.MediaPlayerManifestApiFactory.create(this, this.context);
          }, qe.prototype.handleDvrWindowExceeded = function() {
            var ze = this.playerController.getTimeShiftHandler(), je = this.getMaxTimeShift() + ze.getMinSegmentDuration(), tt = this.playerController.getPlaybackTimeForTimeShiftOffset(je), ut = ze.isTimeInBufferedRange(tt);
            this.context.logger.debug("Handling DVRWindowExceeded - TimeShifting to ".concat(ut ? je : "live edge")), this.timeShift(ut ? je : 0);
          }, qe.prototype.getLatency = function() {
            return this.liveLatencyService.getLatency();
          }, qe.prototype.setTargetLatency = function(ze) {
            var je = Math.abs(this.manifestService.getTimeShiftBufferDepthSeconds());
            ze > je && (ze = je, this.logger.debug("Tried to set target latency outside DVR window, corrected to lower bound", je)), this.context.eventHandler.dispatchEvent(oe.PlayerEvent.TargetLatencyChanged, { from: this.liveLatencyService.getTargetLatency(), to: ze }), this.liveLatencyService.setTargetLatency(ze);
          }, qe.prototype.getTargetLatency = function() {
            return this.liveLatencyService.getTargetLatency();
          }, qe.prototype.setCatchupConfig = function(ze) {
            this.liveLatencyService.setCatchupConfig(ze);
          }, qe.prototype.getCatchupConfig = function() {
            return this.liveLatencyService.getCatchupConfig();
          }, qe.prototype.setFallbackConfig = function(ze) {
            this.liveLatencyService.setFallbackConfig(ze);
          }, qe.prototype.getFallbackConfig = function() {
            return this.liveLatencyService.getFallbackConfig();
          }, qe.prototype.release = function(ze) {
            var je = this;
            return this.eventHandler.off(oe.PlayerEvent.PeriodSwitch, this.onPeriodSwitch), this.eventHandler.off(oe.PlayerEvent.PeriodSwitched, this.fireAudioTracksAdded), this.eventHandler.off(oe.PlayerEvent.PlaybackSpeedChanged, this.onPlaybackSpeedChanged), this.unsubscribeStorePlayingListener(), this.unload(ze).then(function() {
              return je.playerStateService = null, je.playerController = (0, se.dispose)(je.playerController), je.disposeServices(ze), je.renderer.release().then(function() {
                return je.renderer = null;
              });
            });
          }, qe.prototype.clearStallEndedSubscription = function() {
            this.unsubscribeFromStallEnded && (this.unsubscribeFromStallEnded(), this.unsubscribeFromStallEnded = void 0);
          }, qe.prototype.getCurrentPlayingPeriodId = function() {
            return (0, Oe.getPlayingPeriodId)(this.getSourceStoreService().getState());
          }, qe.prototype.updateCallback = function(ze) {
          }, qe.prototype.onFullscreenEnter = function() {
          }, qe.prototype.onFullscreenExit = function() {
          }, qe.prototype.isAirplayAvailable = function() {
            return !1;
          }, qe.prototype.isAirplayActive = function() {
            return !1;
          }, qe.prototype.showAirplayTargetPicker = function() {
          }, qe;
        }();
        function nt(qe) {
          return qe === he.ADVERTISING_ISSUER_NAME || qe === he.ADVERTISING_RESTORE_ISSUER_NAME;
        }
        function Qe(qe, ze) {
          if (!Ee.ModuleManager.has(Me.ModuleName.RendererMse) || !qe.videoElement)
            return !1;
          for (var je = Ee.ModuleManager.get(Me.ModuleName.RendererMse).Ranges, tt = qe.settings.MIN_SIZE_FOR_GAP_SKIPPING, ut = je.findGaps(qe.videoElement.buffered, tt), yt = 0.1, $t = !1, ft = 0; ft < ut.length; ft++) {
            var pt = ut.end(ft) + je.TIME_FUDGE_FACTOR;
            Math.abs(pt - ze) <= yt && ($t = !0);
          }
          return $t;
        }
        ie.MediaPlayer = Ze;
      }, 36366: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MediaPlayerController = void 0, ie.isBufferChangeRequired = Ke;
        var ae = ne(18665), ue = ne(60997), _e = ne(62510), fe = ne(15539), le = ne(33696), se = ne(76650), oe = ne(17990), ce = ne(58975), he = ne(63668), ge = ne(42055), ve = ne(3464), me = ne(42283), be = ne(53968), pe = ne(79814), $e = ne(46462), ye = ne(91520), Se = ne(16368), we = ne(80858), Pe = ne(29954), Te = ne(13034), Ee = ne(94938), Me = ne(96953), Ae = ne(22916), Ne = ne(58423), Ce = ne(34268), Ie = ne(25996), xe = ne(4053), Ue = ne(77874), ke = ne(58211), Le = ne(59839), De = ne(22645), Re = ne(21918), Oe = ne(75498), Be = ne(93109), Fe = function() {
          function Qe(qe, ze) {
            var je = this;
            this.segmentControllerMap = {}, this.onSegmentAvailable = function(tt) {
              if (je.bufferController.isBufferClearingOngoing())
                Ze(tt, je.getSourceStore());
              else {
                if (je.drmKidErrorHandler.trackSegment(tt), je.shouldDropSegment(tt))
                  return je.context.logger.debug("Dropping segment ".concat(tt.getUrl())), void Ze(tt, je.getSourceStore());
                var ut = tt.getMimeType(), yt = je.getTimestampOffset(ut), $t = je.segmentControllerMap[ut];
                $t && je.isAVMultiplexed($t) && je.addRequiredMediaTypesForMuxedContent(tt.getPeriodId()), je.bufferController.updateMediaType(tt.getPeriodId(), { mimeType: ut, timestampOffset: yt, codec: tt.getCodec() }), je.bufferController.addSegment(tt).then(function() {
                  var ft;
                  (ft = je.heartbeatService) === null || ft === void 0 || ft.beat();
                }).catch(function(ft) {
                  je.logger && je.logger.debug(ft);
                }), je.segmentAvailableCallback(tt);
              }
            }, this.endStallAtGap = function() {
              var tt = je.bufferController.getBufferedRangesMap(je.periodSwitchTracker.getCurrentPlayingPeriodId()), ut = Math.max.apply(Math, Object.values(tt).filter(function(yt) {
                return yt.length > 0;
              }).map(function(yt) {
                return yt[yt.length - 1].start;
              }));
              je.seek(ut, !1, !0);
            }, this.mpdAvailableHandler = function() {
              var tt;
              je.applyManifestTimings(), je.initialized && je.updatePeriodInformation(), je.handleDroppedOutPeriods(), je.initializeThumbnails(), je.initialized && je.getAllSegmentControllers().forEach(function(ut) {
                return ut.updateMpd();
              }), (tt = je.timeshiftHandler) === null || tt === void 0 || tt.onManifestUpdate(), je.context.serviceManager.get(ae.ServiceName.TimedMetadataService).parseEventStream();
            }, this.onPeriodSwitched = function() {
              (je.hasStreamEnded() || je.isInitialized() && !je.playerStateService.isPlaying()) && je.start();
            }, this.onSegmentRequestFinished = function(tt) {
              var ut, yt = 408;
              if (tt) {
                if (tt.success || tt.httpStatus === yt) {
                  var $t = je.segmentControllerMap[tt.mimeType];
                  $t && je.updateAdaptationLogicData(tt, $t);
                }
                tt.success || (ut = je.heartbeatService) === null || ut === void 0 || ut.beat();
              }
            }, this.firePlaybackFinishedEvent = function() {
              je.getAllSegmentControllers().every(function(tt) {
                var ut = je.streamTimeService.getTimeForNextSegment(tt.getMimeType());
                return tt.hasNext(ut);
              }) ? je.logger.debug("ignoring ended event in firePlaybackFinishedEvent as there are more segments available") : je.manifestService.isLastPeriod(je.periodSwitchTracker.getCurrentPlayingPeriodId()) ? je.bufferController.hasFutureBufferBlockData() || (je.stop(), je.logger.debug("Stopping buffer controller"), je.bufferController.stop(!0), je.playerStateService.transitionToStoppedState()) : je.logger.debug("ignoring ended event in firePlaybackFinishedEvent as there is a future period");
            }, this.context = qe, this.logger = qe.logger, this.settings = qe.settings, this.bufferSettings = qe.bufferSettings, this.eventHandler = qe.eventHandler, this.renderer = qe.renderer, this.segmentAvailableCallback = ze, this.initialized = !1, this.initPromise = null, this.mimeTypes = {}, this.seekCounter = 0, this.eosSignaled = !1, this.isSwitchingAudioTrack = !1, this.configEnhancer = new Ie.PlayerConfigEnhancer(qe);
          }
          return Qe.prototype.addRequiredMediaTypesForMuxedContent = function(qe) {
            this.bufferController.addRequiredMediaType(qe, "video/mp4"), this.bufferController.addRequiredMediaType(qe, "audio/mp4");
          }, Qe.prototype.getTimestampOffset = function(qe) {
            var ze, je = this, tt = this.segmentControllerMap[qe];
            return !tt && pe.MimeTypeHelper.isAV(qe) && (tt = Object.keys(this.segmentControllerMap).filter(function(ut) {
              return pe.MimeTypeHelper.isAV(ut);
            }).map(function(ut) {
              return je.segmentControllerMap[ut];
            }).filter(function(ut) {
              return je.isAVMultiplexed(ut);
            }).shift()), (ze = tt == null ? void 0 : tt.getMPDHandler().getTimestampOffset()) !== null && ze !== void 0 ? ze : 0;
          }, Qe.prototype.restorePlaybackPositionAfterDownloadedRepresentationWasExcluded = function() {
            var qe = this, ze = this.manifestService.isLive(), je = ze ? this.getTimeShift() : this.renderer.getCurrentTime();
            ze ? this.timeShift(je, function() {
            }, !0).catch(function(tt) {
              return qe.context.logger.debug("TimeShift failed", tt);
            }) : this.seek(je, !1, !1, !0);
          }, Qe.prototype.onDownloadedRepresentationExcluded = function() {
            this.restorePlaybackPositionAfterDownloadedRepresentationWasExcluded(), this.context.logger.debug("manifest update interrupted by DRM key status change");
          }, Qe.prototype.shouldDropSegment = function(qe) {
            var ze = pe.MimeTypeHelper.isSubtitle(qe.getMimeType()), je = this.context.sourceContext.technology.streaming === le.StreamType.Hls, tt = (0, ge.getStartTimeOffset)(this.getSourceStore().getState()) + this.manifestService.getDuration(), ut = this.isVod() && qe.getPlaybackTime() >= tt, yt = this.eosSignaled || ut, $t = this.manifestService.isRepresentationExcluded(qe.getRepresentationId());
            return !ze && !je && yt || $t;
          }, Qe.prototype.getSourceStore = function() {
            return this.context.serviceManager.get(ae.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, Qe.prototype.isAVMultiplexed = function(qe) {
            var ze = me.CodecStringHelper.getExtractedCodecStrings(qe.getCodecs());
            return !!(ze.video && ze.audio);
          }, Qe.prototype.getMaxTimeShift = function() {
            return this.getTimeShiftHandler().getMaxTimeShift();
          }, Qe.prototype.removeEventHandlers = function() {
            this.eventHandler.off(_e.PlayerEvent.SegmentRequestFinished, this.onSegmentRequestFinished);
          }, Qe.prototype.subscribeToSeekProcess = function() {
            var qe = this, ze = this.context.store;
            !this.unsubscribeFromSeekProcess && ze && (this.unsubscribeFromSeekProcess = (0, ve.subscribe)(ze)(function(je) {
              if (je)
                return (0, ce.getPlayerState)(je).seekingProcess;
            }, function(je, tt) {
              return je && tt && qe.onSeekProcessChange(je, tt);
            }));
          }, Qe.prototype.subscribeToManifestChanges = function() {
            var qe = this.getSourceStore();
            !this.unsubscribeFromManifestStore && qe && (this.unsubscribeFromManifestStore = (0, ve.subscribe)(qe)(Ue.getManifest, this.mpdAvailableHandler, function(ze, je) {
              return ze.isInitialized && !je.isInitialized;
            }));
          }, Qe.prototype.unsubscribeFromManifestChanges = function() {
            this.unsubscribeFromManifestStore && (this.unsubscribeFromManifestStore(), this.unsubscribeFromManifestStore = null);
          }, Qe.prototype.subscribeToPlayingTracksChanges = function() {
            var qe = this.getSourceStore();
            !this.unsubscribeFromPlayingTracksStore && qe && (this.unsubscribeFromPlayingTracksStore = (0, ve.subscribe)(qe)(ke.getPlayingTracksState, this.onPeriodSwitched, ke.wasSwitchingToPeriodIdReset));
          }, Qe.prototype.unsubscribeFromPlayingTracksChanges = function() {
            this.unsubscribeFromPlayingTracksStore && (this.unsubscribeFromPlayingTracksStore(), this.unsubscribeFromPlayingTracksStore = void 0);
          }, Qe.prototype.setupControllerForAdaptationSet = function(qe) {
            var ze, je, tt = (0, Ee.getMimeTypeForAdaptationSet)(qe);
            if (pe.MimeTypeHelper.isAV(tt)) {
              this.context.store.dispatch((0, se.initializeMetricsForMimeType)(tt, this.context.settings)), this.getSourceStore().dispatch((0, xe.setMediaTypeAction)(qe._internalId, (0, Ae.resolveMediaTypes)(qe))), this.mimeTypes[tt] = (0, Ee.getCodecsFromAdaptationSet)(qe);
              var ut = this.periodSwitchTracker.getCurrentPlayingPeriodId();
              this.segmentControllerMap[tt] = new Ne.SegmentController(this.context, this.onSegmentAvailable, tt, this.mimeTypes[tt], qe.isTransmuxingRequired, this.manifestLoader, (ze = qe._periodId) !== null && ze !== void 0 ? ze : ut, this.getSourceStore()), (je = this.timeshiftHandler) === null || je === void 0 || je.updateSegmentControllers(this.segmentControllerMap), this.transmuxer && this.segmentControllerMap[tt].setTransmuxer(this.transmuxer), ut && this.renderer.storeDrmInitDataFromManifest(qe), this.context.segmentInfoService && this.context.segmentInfoService.setSegmentControllers(Object.values(this.segmentControllerMap));
            }
          }, Qe.prototype.updatePeriodForTimeshift = function(qe, ze, je) {
            var tt = this.periodSwitchTracker.getCurrentPlayingPeriodId();
            tt || (this.periodSwitchTracker.setCurrentPlayingPeriodId(qe), this.bufferController.setInitialPeriod(qe)), this.periodSwitchTracker.getCurrentLoadingPeriodId() !== qe && je && this.switchLoadingPeriodForAllMedia(qe), ze && tt !== qe && (this.context.logger.debug("Updating current playing period to ".concat(qe)), this.periodSwitchTracker.setCurrentPlayingPeriodId(qe));
          }, Qe.prototype.updateVideoAndAudioMediaTypes = function(qe) {
            var ze = qe.AdaptationSet.find(function(tt) {
              return pe.MimeTypeHelper.isVideo(tt._mimeType);
            });
            ze && this.bufferController.addRequiredMediaType(qe._id, ze._mimeType);
            var je = qe.AdaptationSet.find(function(tt) {
              return pe.MimeTypeHelper.isAudio(tt._mimeType);
            });
            je && this.bufferController.addRequiredMediaType(qe._id, je._mimeType);
          }, Qe.prototype.updateSubtitleMediaTypes = function(qe) {
            var ze = this;
            qe.AdaptationSet.filter(function(je) {
              return pe.MimeTypeHelper.isSubtitle(je._mimeType);
            }).forEach(function(je) {
              ze.bufferController.addRequiredMediaType(qe._id, je._mimeType);
            });
          }, Qe.prototype.updateMediaTypes = function(qe) {
            this.updateVideoAndAudioMediaTypes(qe), this.updateSubtitleMediaTypes(qe);
          }, Qe.prototype.updatePeriodInformation = function() {
            var qe = this;
            this.manifestService.getAllPeriods().forEach(function(ze) {
              qe.updateMediaTypes(ze), qe.bufferController.checkIfEndOfBufferReached(qe.settings.END_OF_BUFFER_TOLERANCE);
            });
          }, Qe.prototype.finishInit = function() {
            var qe = this;
            return this.initPromise ? this.initPromise : this.initialized === !0 || this.manifestService.getManifest() === null ? this.initPromise = Promise.resolve() : (this.disposeSegmentControllers(), this.mimeTypes = {}, this.initPromise = this.renderer.ready().then(function() {
              return qe.initializeDependents();
            }));
          }, Qe.prototype.disposeSegmentControllers = function() {
            var qe = this;
            this.segmentControllerMap && (Object.keys(this.segmentControllerMap).forEach(function(ze) {
              return qe.segmentControllerMap[ze].dispose();
            }), this.segmentControllerMap = {});
          }, Qe.prototype.createTransmuxer = function() {
            var qe = this;
            if (ye.ModuleManager.has(Se.ModuleName.ContainerTS)) {
              var ze = ye.ModuleManager.get(Se.ModuleName.ContainerTS);
              this.getAllSegmentControllers().filter(function(je) {
                return je.isTransmuxerRequired();
              }).forEach(function(je) {
                qe.transmuxer = qe.transmuxer || new ze.WebWorkerTransmuxer(qe.context, qe.hasSeparateAvPlaylists()), je.setTransmuxer(qe.transmuxer);
              }), this.subtitleService && this.subtitleService.setTransmuxer(this.transmuxer);
            }
          }, Qe.prototype.hasSeparateAvPlaylists = function() {
            return this.getAllSegmentControllers().filter(function(qe) {
              return pe.MimeTypeHelper.isAV(qe.getMimeType());
            }).length > 1;
          }, Qe.prototype.initializeDependents = function() {
            this.periodSwitchTracker.setInitialPeriod(), this.initializeBufferController(), this.updatePeriodInformation();
            var qe = this.periodSwitchTracker.getCurrentPlayingPeriod() || this.manifestService.getFirstPeriod();
            qe && this.initializeSegmentControllers(qe), this.enableForcedSubtitles(), this.createTransmuxer(), this.initialized = !0;
          }, Qe.prototype.enableForcedSubtitles = function() {
            var qe, ze, je, tt, ut = this.getAudioSegmentController();
            if (this.subtitleService) {
              var yt = (je = (ze = (qe = ut == null ? void 0 : ut.getCurrentLangObj) === null || qe === void 0 ? void 0 : qe.call(ut)) === null || ze === void 0 ? void 0 : ze.lang) !== null && je !== void 0 ? je : (tt = (0, Te.getPreferredLanguage)("audio/mp4")) === null || tt === void 0 ? void 0 : tt.language;
              this.subtitleService.enableForcedSubtitle(yt);
            }
          }, Qe.prototype.initializeSegmentControllers = function(qe) {
            var ze, je = this;
            this.maybeConsiderOnlyMuxedAVSet((ze = qe == null ? void 0 : qe.AdaptationSet) !== null && ze !== void 0 ? ze : []).forEach(function(tt) {
              return je.createSegmentControllerIfMediaTypeIsMissing(tt);
            });
          }, Qe.prototype.maybeConsiderOnlyMuxedAVSet = function(qe) {
            var ze, je, tt, ut = qe.find(function(lt) {
              return pe.MimeTypeHelper.isAudio(lt._mimeType);
            }), yt = qe.find(function(lt) {
              return pe.MimeTypeHelper.isVideo(lt._mimeType);
            }), $t = ((je = (ze = yt == null ? void 0 : yt.ContentComponent) === null || ze === void 0 ? void 0 : ze.length) !== null && je !== void 0 ? je : 0) > 1;
            if (!ut || !yt || !$t)
              return qe;
            var ft = (0, Te.getHlsDefaultLanguage)(ut._mimeType, this.getSourceStore().getState()), pt = (tt = yt.ContentComponent) === null || tt === void 0 ? void 0 : tt.find(function(lt) {
              return lt._lang === (ft == null ? void 0 : ft.language) && lt._id === (ft == null ? void 0 : ft.name);
            });
            return ft && pt ? [yt] : qe;
          }, Qe.prototype.createSegmentControllerIfMediaTypeIsMissing = function(qe) {
            var ze = (0, Ee.getMimeTypeForAdaptationSet)(qe);
            (0, pe.isMediaTypeContained)(this.mimeTypes, ze) || this.setupControllerForAdaptationSet(qe);
          }, Qe.prototype.initializeBufferController = function() {
            this.bufferController = new we.BufferController(this.context, this.endStallAtGap, this.manifestService.getTotalDuration(), this.periodSwitchTracker.getCurrentPlayingPeriodId());
          }, Qe.prototype.getBufferLevel = function(qe, ze, je, tt) {
            return tt === void 0 && (tt = !0), this.bufferController ? this.bufferController.getOverallBufferLevel(qe, ze, je, tt) : 0;
          }, Qe.prototype.handleDroppedOutPeriods = function() {
            var qe = this;
            this.periodSwitchTracker.shouldHandleDroppedOutPeriod() && (this.periodSwitchTracker.isPlayingPeriodDroppedOut() ? (this.logger.debug("Playing period dropped out of the manifest, timeshifting to current position"), this.timeShift(this.getTimeShift()).catch(function(ze) {
              return qe.context.logger.debug("TimeShift failed", ze);
            })) : this.periodSwitchTracker.isLoadingPeriodDroppedOut() && (this.logger.debug("Current loading period (".concat(this.periodSwitchTracker.getCurrentLoadingPeriodId(), ") ") + "dropped out of the manifest, switching to first available one"), this.getAllSegmentControllers().forEach(function(ze) {
              return ze.invalidateOngoingRequests();
            }), this.switchLoadingPeriodForAllMedia(this.manifestService.getFirstPeriod()._id)));
          }, Qe.prototype.initializeThumbnails = function() {
            var qe = this;
            this.context.serviceManager.maybeCall(ae.ServiceName.ThumbnailService, function(ze) {
              qe.context.sourceContext.source && qe.context.sourceContext.source.thumbnailTrack || ze.addThumbnails(qe.manifestService.getAllDashThumbnailSources());
            });
          }, Qe.prototype.applyManifestTimings = function() {
            var qe = this.manifestService.isLive(), ze = this.context.serviceManager.get(ae.ServiceName.StartOffsetService), je = this.manifestService.hasSuggestedStartPosition();
            if (qe) {
              var tt = this.manifestService.getTimeShiftBufferDepthSeconds();
              tt !== 0 && (this.metadataParsedService.expirationTimeInSeconds = tt), je && (ze.manifestStartOffset = this.manifestService.getLiveStartOffset(), this.adjustMaximumBufferLevel());
            } else
              je && (ze.manifestStartOffset = this.manifestService.getVodStartOffset());
          }, Qe.prototype.adjustMaximumBufferLevel = function() {
            var qe = Math.abs(this.manifestService.getLiveStartOffset(!1));
            qe = qe > 0 ? qe : this.manifestService.getMaxSegmentDuration();
            var ze = Math.min(qe, this.bufferSettings.getForwardTargetLevel(le.MediaType.Video)), je = Math.min(qe, this.bufferSettings.getForwardTargetLevel(le.MediaType.Audio));
            this.bufferSettings.setMaximumBufferLevel(le.BufferType.ForwardDuration, ze, le.MediaType.Video), this.bufferSettings.setMaximumBufferLevel(le.BufferType.ForwardDuration, je, le.MediaType.Audio);
          }, Qe.prototype.terminate = function() {
            var qe, ze, je = this;
            this.logger.debug("stopping playback"), this.stop(), this.getAllSegmentControllers().forEach(function(ut) {
              return ut.stop();
            }), this.bufferController && this.bufferController.stop(!0), this.transmuxer = (0, ue.dispose)(this.transmuxer), this.timeshiftHandler = (0, ue.dispose)(this.timeshiftHandler), this.drmKidErrorHandler = (0, ue.dispose)(this.drmKidErrorHandler), (0, ue.dispose)(this.periodSwitchTracker), this.cachedSeekableRange = null, this.renderer.off($e.MediaElementEvent.ended, this.firePlaybackFinishedEvent);
            var tt = this.renderer.shutdown(!1).catch(function(ut) {
              return je.logger.debug("Got an error on shutdown", { message: ut.message }), Promise.resolve();
            });
            return this.removeEventHandlers(), this.unsubscribeFromPlayingTracksChanges(), this.initialized = !1, (qe = this.periodSwitchTracker) === null || qe === void 0 || qe.setCurrentPlayingPeriodId(void 0), this.mimeTypes = null, this.context.store.dispatch((0, he.resetDrmKidErrors)()), (ze = this.manifestService) === null || ze === void 0 || ze.resetExcludedRepresentations(), this.disposeSegmentControllers(), tt;
          }, Qe.prototype.dispose = function() {
            this.timeshiftHandler = (0, ue.dispose)(this.timeshiftHandler), this.bufferController = (0, ue.dispose)(this.bufferController), (0, ue.dispose)(this.periodSwitchTracker);
            try {
              this.removeEventHandlers();
            } catch {
            }
            this.unsubscribeFromManifestChanges(), this.unsubscribeFromPlayingTracksChanges(), this.disposeSegmentControllers(), this.unsubscribeFromSeekProcess && this.unsubscribeFromSeekProcess(), this.subtitleService = null, this.heartbeatService = null, this.streamTimeService = null, this.segmentControllerMap = null, this.settings = null, this.bufferSettings = null, this.eventHandler = null, this.renderer = null, this.mimeTypes = null;
          }, Qe.prototype.acquireServices = function() {
            var qe = this.context.sourceContext.sourceIdentifier;
            this.manifestService = this.context.serviceManager.get(ae.ServiceName.ManifestService, qe), this.playerStateService = this.context.serviceManager.get(ae.ServiceName.PlayerStateService), this.subtitleService = this.context.serviceManager.get(ae.ServiceName.SubtitleService), this.metadataParsedService = this.context.serviceManager.get(ae.ServiceName.MetadataParsedService), this.manifestLoader = this.context.serviceManager.get(ae.ServiceName.ManifestLoadingService, qe), this.heartbeatService = this.context.serviceManager.get(ae.ServiceName.HeartbeatService, qe), this.streamTimeService = this.context.serviceManager.get(ae.ServiceName.StreamTimeService), this.manifestUpdateScheduler = this.context.serviceManager.get(ae.ServiceName.ManifestUpdateSchedulingService, qe);
          }, Qe.prototype.init = function(qe) {
            var ze = this, je = this.getSourceStore();
            return this.periodSwitchTracker = new Ce.PeriodSwitchTracker(this.context), this.subscribeToPlayingTracksChanges(), this.subscribeToSeekProcess(), this.isAudioCatchingUp = !1, this.context.store.dispatch((0, he.resetDrmKidErrors)()), this.acquireServices(), je && !this.drmKidErrorHandler && (this.drmKidErrorHandler = new Pe.DrmKidErrorHandler(this.context, function() {
              return ze.onDownloadedRepresentationExcluded();
            })), this.renderer.on($e.MediaElementEvent.ended, this.firePlaybackFinishedEvent), (this.manifestUpdateScheduler.isInitiated() ? Promise.resolve() : this.manifestUpdateScheduler.init(qe.url.toString())).then(function() {
              return ze.subscribeToManifestChanges(), ze.mpdAvailableHandler(), ze.configEnhancer.adjustToCurrentSource(ze.context, ze.manifestService), ze.initialized ? Promise.resolve() : ze.finishInit();
            });
          }, Qe.prototype.stop = function() {
            var qe;
            this.logger.debug("Stopping main timer"), (qe = this.heartbeatService) === null || qe === void 0 || qe.stop(), this.initPromise = null, this.eventHandler.off(_e.PlayerEvent.SegmentRequestFinished, this.onSegmentRequestFinished), this.unsubscribeFromManifestChanges();
          }, Qe.prototype.isOneLoaderReady = function() {
            return this.getAllSegmentControllers().some(function(qe) {
              return qe.canLoad();
            });
          }, Qe.prototype.areAllLoadersReady = function() {
            return this.getAllSegmentControllers().every(function(qe) {
              return qe.canLoad();
            });
          }, Qe.prototype.isVod = function() {
            return !this.manifestService.isLive();
          }, Qe.prototype.shouldStopDownloadWhenPaused = function() {
            return this.playerStateService.isPaused() && this.settings.STOP_DOWNLOAD_ON_PAUSE && this.manifestService.isLive();
          }, Qe.prototype.shouldWaitForOtherMimeTypeDownload = function(qe) {
            var ze = Object.keys(this.segmentControllerMap).find(function(ft) {
              return pe.MimeTypeHelper.isAV(ft) && qe !== ft;
            });
            if (!ze || (0, Be.isPlayingLowLatencyHls)(this.context))
              return !1;
            if (this.isAudioCatchingUp)
              return pe.MimeTypeHelper.isAudio(ze);
            var je = this.segmentControllerMap[ze], tt = this.streamTimeService.getTimeForNextSegment(ze);
            if (je.hasNext(tt) && !je.hasDownloadError && !je.hasDelayedSegmentsInTransmuxer()) {
              var ut = this.getBufferRelevantTime(), yt = this.getCurrentForwardBuffer(qe, ut), $t = this.getCurrentForwardBuffer(ze, ut);
              return this.settings.DISABLE_PARALLEL_SEGMENT_LOADING && yt === $t ? pe.MimeTypeHelper.isVideo(ze) : !this.hasReachedTargetBufferLevel(ze, $t) && tt < this.streamTimeService.getTimeForNextSegment(qe);
            }
            return je.getCurrentPeriodId() !== this.segmentControllerMap[qe].getCurrentPeriodId();
          }, Qe.prototype.hasReachedTargetBufferLevel = function(qe, ze) {
            var je = pe.MimeTypeHelper.getMediaType(qe);
            return ze >= this.bufferSettings.getForwardTargetLevel(je);
          }, Qe.prototype.shouldEndOfStreamBeSignaled = function() {
            var qe = this, ze = this.getAllSegmentControllers(), je = this.bufferController.hasPendingSegments(), tt = ze.map(function($t) {
              return $t.getMimeType();
            }), ut = ze.some(function($t) {
              return $t.hasPendingSegments();
            }), yt = tt.some(function($t) {
              return qe.renderer.isDataBeingAppended($t);
            });
            return !ut && !je && !yt;
          }, Qe.prototype.shouldSuspendHeartbeat = function() {
            return !this.isOneLoaderReady() || this.shouldStopDownloadWhenPaused() || this.bufferController.isBufferClearingOngoing() || this.isSwitchingAudioTrack;
          }, Qe.prototype.getActiveSegmentControllers = function() {
            var qe = this;
            return this.getAllSegmentControllers().filter(function(ze) {
              return qe.isSegmentControllerActive(ze);
            });
          }, Qe.prototype.isSegmentControllerActive = function(qe) {
            var ze = this.periodSwitchTracker.getCurrentLoadingPeriodId(), je = this.streamTimeService.getTimeForNextSegment(qe.getMimeType());
            return qe.canLoad() && (qe.hasNext(je) || qe.hasPendingSegments(ze)) && !this.shouldWaitForOtherMimeTypeDownload(qe.getMimeType());
          }, Qe.prototype.shouldClearSubtitleServiceBuffers = function() {
            var qe;
            return !this.playerStateService.seekingOrTimeshifting && !!(!((qe = this.subtitleService) === null || qe === void 0) && qe.hasSubtitles());
          }, Qe.prototype.clearSubtitleServiceBuffers = function() {
            var qe = 10;
            this.subtitleService.clearBuffersUntil(this.renderer.getCurrentTime() - qe);
          }, Qe.prototype.areMediaTypesFinalForPlayingPeriod = function() {
            var qe = this.periodSwitchTracker.getCurrentPlayingPeriodId();
            return this.bufferController.areBufferBlockMediaTypesFinalForPeriod(qe);
          }, Qe.prototype.maybeStop = function() {
            var qe = this.manifestService.isManifestFinalized(), ze = this.manifestService.isLastPeriod(this.periodSwitchTracker.getCurrentLoadingPeriodId());
            qe && ze && (this.bufferController.stop(!1), this.shouldEndOfStreamBeSignaled() && (this.signalEndOfStream(), this.stop()));
          }, Qe.prototype.getNextSegment = function(qe, ze) {
            if (qe.canLoad() && this.renderer.shouldContinueBuffering()) {
              var je = pe.MimeTypeHelper.getMediaType(qe.getMimeType()), tt = this.bufferSettings.getForwardTargetLevel(je), ut = this.getCurrentForwardBuffer(qe.getMimeType(), this.getBufferRelevantTime());
              ut >= tt || (this.context.serviceManager.get(ae.ServiceName.AdaptationService).addSample(qe.getMimeType(), { bufferTargetLevel: tt, bufferLevel: ut }), qe.hasNext(ze) && qe.getNext(ze));
            }
          }, Qe.prototype.getBufferRelevantTime = function() {
            return this.playerStateService.seekingOrTimeshifting ? this.playerStateService.targetPlaybackTime : this.renderer.getCurrentTime();
          }, Qe.prototype.getCurrentForwardBuffer = function(qe, ze) {
            return this.getBufferLevel(qe, ze, le.BufferType.ForwardDuration);
          }, Qe.prototype.isLoadingLastPeriod = function() {
            return this.periodSwitchTracker.isLoadingLastPeriod();
          }, Qe.prototype.switchLoadingPeriod = function() {
            if (this.isAudioCatchingUp) {
              var qe = this.getAudioSegmentController(), ze = qe.getCurrentPeriodId(), je = this.manifestService.getNextPeriod(ze)._id;
              this.switchLoadingPeriodForAudio(je), qe.getCurrentPeriodId() === this.periodSwitchTracker.getCurrentLoadingPeriodId() && (qe.isTransmuxerRequired() && qe.getTransmuxer() && (qe.getTransmuxer().dispose(), qe.setTransmuxer(this.transmuxer)), this.isAudioCatchingUp = !1, this.logger.debug("The audio SegmentController caught up to the overall loading period again."));
            } else {
              var tt = this.manifestService.getNextPeriod(this.periodSwitchTracker.getCurrentLoadingPeriodId());
              tt && this.switchLoadingPeriodForAllMedia(tt._id);
            }
          }, Qe.prototype.switchLoadingPeriodForAllMedia = function(qe) {
            var ze = this;
            qe !== this.periodSwitchTracker.getCurrentLoadingPeriodId() && (this.isAudioCatchingUp = !1, this.prepareLoadingPeriodSwitch(qe), this.getAllSegmentControllers().filter(function(je) {
              return je.getCurrentPeriodId() !== qe;
            }).forEach(function(je) {
              je.switchPeriod(qe), ze.renderer.storeDrmInitDataFromManifest(je.getAdaptationSetForPeriodId(qe));
            }), this.periodSwitchTracker.setCurrentLoadingPeriodId(qe));
          }, Qe.prototype.prepareLoadingPeriodSwitch = function(qe) {
            var ze, je, tt = this;
            ((je = (ze = this.manifestService.getPeriod(new Me.PeriodId(qe))) === null || ze === void 0 ? void 0 : ze.AdaptationSet) !== null && je !== void 0 ? je : []).forEach(function(ut) {
              return tt.createSegmentControllerIfMediaTypeIsMissing(ut);
            }), this.resetTransmuxer();
          }, Qe.prototype.switchLoadingPeriodForAudio = function(qe) {
            var ze = this.getAudioSegmentController(), je = ze.getCurrentPeriodId();
            ze.resetTransmuxer(), ze.switchPeriod(qe), this.logger.debug("Switched audio loading period from ".concat(je, " to ").concat(qe));
          }, Qe.prototype.isAVCompletelyLoaded = function() {
            var qe = this.getAllSegmentControllers().some(function(ze) {
              return ze.hasPendingSegments();
            }) || this.bufferController.hasPendingSegments();
            return this.manifestService.isManifestFinalized() && !qe;
          }, Qe.prototype.getBufferedRanges = function(qe) {
            return qe === void 0 && (qe = !1), this.bufferController.getBufferedRangesMap(this.periodSwitchTracker.getCurrentPlayingPeriodId(), qe);
          }, Qe.prototype.resetTransmuxer = function() {
            this.transmuxer && (this.transmuxer.dispose(), this.transmuxer = null), this.createTransmuxer();
          }, Qe.prototype.restartBufferController = function() {
            this.bufferController.hasStopped() && this.bufferController.restart();
          }, Qe.prototype.shouldBuffersBeCleared = function(qe, ze, je, tt) {
            if (je && qe === 0)
              return !1;
            var ut = qe < this.renderer.getCurrentTime() && this.context.settings.CLEAR_BUFFERS_ON_SEEKING_BACKWARDS;
            return !ze && (!this.bufferController.isInBufferedRange(qe) || ut) || tt;
          }, Qe.prototype.onSeekProcessChange = function(qe, ze) {
            var je;
            if (qe.targetTime === -1 && ze.targetTime >= 0)
              (je = this.playerStateService) === null || je === void 0 || je.transitionToSeekedState(ze.issuer !== fe.STARTUP_ISSUER_NAME);
            else {
              var tt = qe.targetTime !== ze.targetTime, ut = qe.targetTime >= 0;
              tt && ut && this.seek(qe.targetTime, qe.issuer === fe.STARTUP_ISSUER_NAME);
            }
          }, Qe.prototype.seek = function(qe, ze, je, tt) {
            var ut = this;
            if (ze === void 0 && (ze = !1), je === void 0 && (je = !1), tt === void 0 && (tt = !1), this.bufferController) {
              this.restartBufferController(), this.seekCounter++;
              var yt, $t, ft = this.seekCounter, pt = this.manifestService.getPeriodIdForTime(qe);
              this.ensureInitialPeriod(pt), this.logger.debug("seek from current period (".concat(this.periodSwitchTracker.getCurrentPlayingPeriodId(), ") to target period ") + "(".concat(pt, ") - seek time in period is: ").concat(qe)), this.bufferController.readyToSeek().then(function() {
                if ($t = ut.shouldBuffersBeCleared(qe, je, ze, tt), yt = ut.periodSwitchTracker.getCurrentLoadingPeriodId() !== pt && $t, $t && ut.bufferController.isBufferAvailable())
                  return ut.clearBuffersOnSeek();
              }).then(function() {
                return ut.initialized ? (yt && ut.switchLoadingPeriodForAllMedia(pt), $t && ut.getAllSegmentControllers().forEach(function(lt) {
                  lt.setAdaptionLogicStartupPhase(), lt.seekTo(qe);
                }), (ze ? Promise.resolve() : ut.start()).then(function() {
                  ut.hasStarted() && ut.heartbeatService.beat(), ut.bufferController.setCurrentTime(qe).then(function(lt) {
                    ut.context.isDisposed || (ut.seekCounter === ft ? (ut.logger.debug("Successfully seeked to ".concat(lt)), ut.context.store.dispatch((0, oe.updateSeekingProcess)({ targetTime: -1, issuer: "", isInitial: !1 }))) : nt(ut.context.store) && ut.context.logger.debug("Seek to ".concat(qe, " has finished but a newer operation has been started")));
                  }).catch(function(lt) {
                    ut.logger.debug("Failed to set currentTime on seek", lt);
                  });
                })) : (ut.logger.debug("Aborting seek as MediaPlayerController has been terminated!"), Promise.resolve());
              });
            }
          }, Qe.prototype.ensureInitialPeriod = function(qe) {
            var ze = this;
            this.periodSwitchTracker.getCurrentPlayingPeriodId() === void 0 && (this.logger.debug("current period is undefined, using seek target period " + qe), this.periodSwitchTracker.setCurrentPlayingPeriodId(qe), this.resetTransmuxer(), this.getAllSegmentControllers().forEach(function(je) {
              je.switchPeriod(ze.periodSwitchTracker.getCurrentPlayingPeriodId()), pe.MimeTypeHelper.isAV(je.getMimeType()) && ze.renderer.storeDrmInitDataFromManifest(je.getCurrentAdaptationSet());
            }), this.periodSwitchTracker.setCurrentLoadingPeriodId(this.periodSwitchTracker.getCurrentPlayingPeriodId()), this.bufferController.setInitialPeriod(qe));
          }, Qe.prototype.clearBuffersOnSeek = function() {
            var qe = this;
            return this.context.logger.debug("Clearing buffer on seek"), this.eosSignaled = !1, this.getAllSegmentControllers().forEach(function(ze) {
              return ze.cancelLoading();
            }), this.bufferController.clearBuffers().catch(function() {
              qe.logger.debug("Failed to clear buffers on seek, carrying on regardless");
            });
          }, Qe.prototype.getAllSegmentControllers = function() {
            return Object.values(this.segmentControllerMap || {});
          }, Qe.prototype.getAudioSegmentController = function() {
            return this.getAllSegmentControllers().find(function(qe) {
              return pe.MimeTypeHelper.isAudio(qe.getMimeType());
            });
          }, Qe.prototype.updateAdaptationLogicData = function(qe, ze) {
            var je, tt;
            if (!(qe.isInit || !qe.success && this.playerStateService.seekingOrTimeshifting)) {
              var ut = pe.MimeTypeHelper.getMediaType(ze.getMimeType()), yt = this.getBufferLevel(ze.getMimeType(), this.renderer.getCurrentTime(), le.BufferType.ForwardDuration), $t = this.bufferSettings.getForwardTargetLevel(ut);
              (tt = (je = this.context.serviceManager) === null || je === void 0 ? void 0 : je.get(ae.ServiceName.AdaptationService)) === null || tt === void 0 || tt.addSample(ze.getMimeType(), { bufferTargetLevel: $t, bufferLevel: yt, segmentDuration: qe.duration, segmentDownloadDuration: qe.downloadTime, downloadCancelled: !qe.success });
            }
          }, Qe.prototype.signalEndOfStream = function(qe) {
            qe === void 0 && (qe = !0), this.isVod() && (this.eosSignaled || (this.eosSignaled = !0, this.bufferController.setEndOfStream(!0), qe && this.stop()), this.bufferController.isStarted() && this.bufferController.stop());
          }, Qe.prototype.start = function() {
            var qe = this;
            return this.hasStarted() ? Promise.resolve() : this.finishInit().then(function() {
              var ze;
              qe.bufferController.hasStreamEnded() && (qe.seek((0, ge.getStartTimeOffset)(qe.getSourceStore().getState())), qe.getAllSegmentControllers().forEach(function(je) {
                return je.resetTransmuxer();
              })), qe.bufferController.isStarted() || qe.bufferController.restart(), qe.getAllSegmentControllers().filter(function(je) {
                return pe.MimeTypeHelper.isAV(je.getMimeType());
              }).forEach(function(je) {
                return qe.renderer.storeDrmInitDataFromManifest(je.getCurrentAdaptationSet());
              }), qe.logger.debug("Starting main timer"), qe.eosSignaled = !1, (ze = qe.heartbeatService) === null || ze === void 0 || ze.start(), qe.subscribeToManifestChanges(), qe.eventHandler.on(_e.PlayerEvent.SegmentRequestFinished, qe.onSegmentRequestFinished);
            });
          }, Qe.prototype.maybeTransitionToPausedState = function(qe) {
            (0, be.isSwitchingBufferBlocks)(this.getSourceStore()) ? this.context.logger.debug("Ignoring transition to Paused because buffer block switch is ongoing") : this.playerStateService.transitionToPausedState(!0, qe, !0);
          }, Qe.prototype.clearBuffers = function(qe) {
            var ze = this;
            return Promise.all(qe.map(function(je) {
              return ze.bufferController.clearCacheForMimeType(je), ze.bufferController.clearBuffer(je);
            })).then(function() {
            });
          }, Qe.prototype.restorePlaybackPositionAfterAudioTrackSwitch = function(qe, ze) {
            var je = this;
            return this.bufferController.setEndOfStream(!1).then(function() {
              var tt = je.clearBuffers(qe.getSourceBufferTypes());
              return qe.getCurrentPeriodId() !== je.periodSwitchTracker.getCurrentPlayingPeriodId() ? je.prepareControllerForAudioTrackChange(qe) : qe.getCurrentPeriodId() !== je.periodSwitchTracker.getCurrentLoadingPeriodId() && je.periodSwitchTracker.setCurrentLoadingPeriodId(qe.getCurrentPeriodId()), qe.setAdaptionLogicStartupPhase(), qe.seekTo(ze), je.start().catch(function() {
                return je.logger.debug("Could not restart stopped MPC after audio track switch");
              }), tt.then(function() {
                je.renderer.setCurrentTime(ze).catch(function(ut) {
                  return je.logger.debug("Failed to set currentTime on audio track switch", ut);
                });
              }).catch(function(ut) {
                return je.logger.debug("Failed to attempt to restore playback after audio track switch", ut);
              });
            });
          }, Qe.prototype.setAudio = function(qe) {
            var ze = this.getAvailableAudio(this.periodSwitchTracker.getCurrentPlayingPeriodId()).find(function(tt) {
              return tt.id === qe;
            }), je = this.getAudio();
            return this.initialized && ze ? je && je.id === qe ? Promise.reject(je) : this.switchAudioTrack(ze) : Promise.reject(null);
          }, Qe.prototype.updateAdaptationSet = function(qe, ze, je) {
            var tt = this;
            return pe.MimeTypeHelper.isAudio(ze) && Ve(this.manifestLoader) ? this.manifestLoader.updateAdaptationSet(je).then(function() {
              return tt.getAllSegmentControllers().forEach(function(ut) {
                return ut.updateMpd();
              });
            }).then(function() {
              return qe;
            }) : Promise.resolve(qe);
          }, Qe.prototype.switchAudioTrack = function(qe) {
            var ze = this;
            this.isSwitchingAudioTrack = !0;
            var je = Object.keys(this.segmentControllerMap), tt = je.find(pe.MimeTypeHelper.isAudio) || je.find(pe.MimeTypeHelper.isVideo), ut = this.segmentControllerMap[tt].getCurrentAdaptationSet(), yt = this.manifestService.getAdaptationSet(qe.adaptationSetId);
            return ut && yt && tt ? this.maybeChangeAudioBufferType(ut, yt, tt).then(function($t) {
              return ze.maybeHandleMuxedAudioTransition(ut, yt, qe, $t);
            }).then(function($t) {
              return ze.updateAdaptationSet($t, tt, qe.id);
            }).then(function($t) {
              return ze.updateRelevantSegmentControllers($t, qe);
            }).finally(function() {
              return ze.isSwitchingAudioTrack = !1;
            }) : Promise.reject("Did not find matching adaptation set");
          }, Qe.prototype.maybeChangeAudioBufferType = function(qe, ze, je) {
            var tt, ut = this, yt = Ke(ze, qe), $t = pe.MimeTypeHelper.isVideo(ze._mimeType) || pe.MimeTypeHelper.isVideo(qe._mimeType), ft = !(0, Oe.hasContentProtection)(qe.ContentProtection, ze.ContentProtection);
            if ($t || !yt && !ft)
              return Promise.resolve(((tt = {})[ze._mimeType] = "", tt));
            var pt = Object.keys(this.segmentControllerMap).find(pe.MimeTypeHelper.isVideo);
            return this.recreateCurrentSegmentController(je, ze).then(function() {
              return ft && pt ? ut.clearBuffersAndSeek(pt) : Promise.resolve();
            }).then(function() {
              return ut.bufferController.changeBufferType(ze._mimeType, ut.mimeTypes[ze._mimeType]);
            });
          }, Qe.prototype.maybeHandleMuxedAudioTransition = function(qe, ze, je, tt) {
            var ut = this;
            return pe.MimeTypeHelper.isVideo(ze._mimeType) || pe.MimeTypeHelper.isVideo(qe._mimeType) ? this.clearBuffers([qe._mimeType, ze._mimeType]).then(function() {
              var yt = pe.MimeTypeHelper.isVideo(ze._mimeType);
              return ut.transmuxer.setShouldExpectSeparateAvSegments(!yt), yt ? (ut.disposeSegmentController(qe), Promise.resolve()) : (ut.createSegmentControllerIfMediaTypeIsMissing(ze), ut.updateSegmentController(je, qe._mimeType));
            }).then(function() {
              return tt;
            }) : Promise.resolve(tt);
          }, Qe.prototype.clearBuffersAndSeek = function(qe) {
            var ze = this;
            return this.clearBuffers([qe]).then(function() {
              var je;
              ze.segmentControllerMap[qe].seekTo(ze.renderer.getCurrentTime()), (je = ze.timeshiftHandler) === null || je === void 0 || je.updateSegmentControllers(ze.segmentControllerMap);
            });
          }, Qe.prototype.disposeSegmentController = function(qe) {
            var ze;
            if (qe) {
              var je = qe._mimeType, tt = this.segmentControllerMap[je];
              tt.cancelLoading(), tt.dispose(), delete this.segmentControllerMap[je], delete this.mimeTypes[je], (ze = this.timeshiftHandler) === null || ze === void 0 || ze.updateSegmentControllers(this.segmentControllerMap), this.getSourceStore().dispatch((0, xe.removeActiveTrackAction)(qe._internalId)), this.context.segmentInfoService && this.context.segmentInfoService.setSegmentControllers(Object.values(this.segmentControllerMap));
            }
          }, Qe.prototype.recreateCurrentSegmentController = function(qe, ze) {
            var je = this, tt = this.segmentControllerMap[qe];
            return this.disposeSegmentController(tt.getCurrentAdaptationSet()), this.clearBuffers([qe]).then(function() {
              return je.setupControllerForAdaptationSet(ze), ze._mimeType;
            });
          }, Qe.prototype.updateRelevantSegmentControllers = function(qe, ze) {
            var je = this;
            return Promise.all(Object.keys(qe).map(function(tt) {
              return je.updateSegmentController(ze, tt);
            })).then(function() {
            });
          }, Qe.prototype.updateSegmentController = function(qe, ze) {
            if (this.subtitleService && this.subtitleService.enableForcedSubtitle(qe.lang), this.segmentControllerMap[ze].setCurrentLangObj(qe), this.segmentControllerMap[ze].cancelLoading(), this.hasStarted() || this.eosSignaled) {
              var je = this.getBufferRelevantTime();
              return this.restorePlaybackPositionAfterAudioTrackSwitch(this.segmentControllerMap[ze], je);
            }
            return Promise.resolve();
          }, Qe.prototype.getAudio = function() {
            if (this.initialized) {
              var qe = void 0, ze = Object.keys(this.segmentControllerMap).find(function(yt) {
                return pe.MimeTypeHelper.isAudio(yt);
              });
              if (ze && (qe = this.segmentControllerMap[ze].getCurrentLangObj()), !qe) {
                var je = Object.keys(this.segmentControllerMap).find(function(yt) {
                  return pe.MimeTypeHelper.isVideo(yt);
                });
                if (je && this.segmentControllerMap[je].getSourceBufferTypes()) {
                  var tt = this.segmentControllerMap[je];
                  if (tt.getSourceBufferTypes().some(function(yt) {
                    return pe.MimeTypeHelper.isAudio(yt);
                  })) {
                    var ut = tt.getCurrentAdaptationSet()._internalId;
                    qe = this.getAvailableAudio(this.periodSwitchTracker.getCurrentPlayingPeriodId()).find(function(yt) {
                      return yt.adaptationSetId === ut;
                    }) || tt.getCurrentLangObj();
                  }
                }
              }
              return qe || null;
            }
            return null;
          }, Qe.prototype.prepareControllerForAudioTrackChange = function(qe) {
            if (this.isAVMultiplexed(qe))
              this.switchLoadingPeriodForAllMedia(this.periodSwitchTracker.getCurrentPlayingPeriodId());
            else {
              if (this.logger.debug("audio needs to load previous period(s) and catch up to the overall loading period"), qe.isTransmuxerRequired()) {
                var ze = ye.ModuleManager.get(Se.ModuleName.ContainerTS);
                qe.setTransmuxer(new ze.WebWorkerTransmuxer(this.context, this.hasSeparateAvPlaylists()));
              }
              this.isAudioCatchingUp = !0, this.switchLoadingPeriodForAudio(this.periodSwitchTracker.getCurrentPlayingPeriodId());
            }
          }, Qe.prototype.getPlaybackRepresentation = function(qe) {
            for (var ze in this.segmentControllerMap)
              if (this.segmentControllerMap[ze] && ze.includes(qe))
                return this.context.serviceManager.get(ae.ServiceName.TimedMetadataService).getPlaybackRepresentation(ze);
            return null;
          }, Qe.prototype.getTimeShift = function() {
            return this.getTimeShiftHandler().getTimeShift();
          }, Qe.prototype.getTimeShiftLiveEdge = function() {
            return this.manifestService.isLive() ? this.getTimeShiftHandler().getTimeShiftLiveEdge() : 0;
          }, Qe.prototype.getPlaybackTimeForTimeShiftOffset = function(qe) {
            return this.getTimeShiftHandler().calculatePlaybackTimeForTimeShiftOffset(qe);
          }, Qe.prototype.getTimeShiftHandler = function() {
            return this.timeshiftHandler || (this.timeshiftHandler = new Re.TimeShiftHandler(this.context, this, this.bufferController, this.segmentControllerMap)), this.timeshiftHandler;
          }, Qe.prototype.timeShift = function(qe, ze, je) {
            return je === void 0 && (je = !1), this.getTimeShiftHandler().timeShift(qe, ze, je);
          }, Qe.prototype.getAvailableAudio = function(qe) {
            return this.manifestService.getAvailableAudio(qe);
          }, Qe.prototype.hasStreamEnded = function() {
            return !!this.bufferController && this.bufferController.hasStreamEnded();
          }, Qe.prototype.getCurrentTime = function() {
            return this.renderer.getCurrentTime();
          }, Qe.prototype.getSeekableRange = function() {
            if (this.manifestService.isLive()) {
              if (this.playerStateService.seekingOrTimeshifting && this.cachedSeekableRange)
                return this.cachedSeekableRange;
              var qe = this.getTimeShiftLiveEdge(), ze = qe + this.getMaxTimeShift();
              return this.cachedSeekableRange = { start: ze, end: qe };
            }
            var je = this.getAllSegmentControllers().find(function(tt) {
              return pe.MimeTypeHelper.isAV(tt.getMimeType());
            });
            return je ? je.getMPDHandler().getSeekableRange() : { start: -1, end: -1 };
          }, Qe.prototype.getAvailableSegments = function() {
            var qe = this, ze = {};
            return Object.keys(this.segmentControllerMap).forEach(function(je) {
              ze[je] = qe.segmentControllerMap[je].getSegmentInfos();
            }), ze;
          }, Qe.prototype.isInitialized = function() {
            return this.initialized;
          }, Qe.prototype.hasStarted = function() {
            var qe, ze;
            return (ze = (qe = this.heartbeatService) === null || qe === void 0 ? void 0 : qe.started) !== null && ze !== void 0 && ze;
          }, Qe;
        }();
        function Ve(Qe) {
          var qe = ye.ModuleManager.get(Se.ModuleName.HLS, !1), ze = qe == null ? void 0 : qe.M3u8Loader;
          return ze !== void 0 && Qe instanceof ze;
        }
        function Ke(Qe, qe) {
          return !(0, Oe.areAudioMimeCodecsCompatible)({ mimeType: Qe._mimeType, codec: (0, Ee.getCodecsFromAdaptationSet)(Qe) }, { mimeType: qe._mimeType, codec: (0, Ee.getCodecsFromAdaptationSet)(qe) });
        }
        function Ze(Qe, qe) {
          var ze = Qe.getPlaybackTimeRange(), je = (0, De.getTrackIdentifier)(Qe.getSegmentInfo());
          ze && (qe == null || qe.dispatch((0, Le.removeStreamTimeRange)(je, ze, De.StreamTimeRangeType.Loading)));
        }
        function nt(Qe) {
          var qe = Qe.getState();
          if (!qe)
            return !1;
          var ze = (0, ce.getPlayerState)(qe).seekingProcess.issuer;
          return ze !== fe.STARTUP_ISSUER_NAME && ze !== "";
        }
        ie.MediaPlayerController = Fe;
      }, 22916: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.resolveMediaTypes = _e;
        var ae = ne(42283), ue = ne(94938);
        function _e(fe) {
          return (0, ue.getCodecsFromAdaptationSet)(fe).split(",").map(function(le) {
            return (0, ae.getMediaTypeFromCodec)(le);
          });
        }
      }, 44910: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MseModuleDefinition = void 0;
        var ae = ne(96873), ue = ne(33669), _e = ne(16368), fe = ne(73543), le = ne(67883), se = ne(48928), oe = ne(94938), ce = ne(38925), he = ne(85586), ge = ne(10997), ve = ne(26382), me = ne(58423), be = ne(13788), pe = ne(67550), $e = ne(92395), ye = ne(72207), Se = ne(4053), we = ne(82311), Pe = ne(58211), Te = ne(93326), Ee = ne(59839), Me = ne(22645), Ae = ne(23414), Ne = { removeStreamTimeRange: Ee.removeStreamTimeRange, removeLoadedRange: ae.removeLoadedRange, addLoadedRange: ae.addLoadedRange, resetLoadedRanges: ae.resetLoadedRanges, resetStreamTimeline: Ee.resetStreamTimeline, removeActiveTrackAction: Se.removeActiveTrackAction, setRepresentationIdAction: Se.setRepresentationIdAction, setMediaTypeAction: Se.setMediaTypeAction }, Ce = { getPlayingPeriodId: Pe.getPlayingPeriodId, getContainerFormat: we.getContainerFormat, getLoadedRangesForMimeType: ue.getLoadedRangesForMimeType, getSegmentInfos: Te.getSegmentInfos }, Ie = { containerFormat: fe.ContainerFormat, streamTimeRangeType: Me.StreamTimeRangeType };
        ie.MseModuleDefinition = { name: _e.ModuleName.EngineBitmovin, module: { MediaPlayer: he.MediaPlayer, SegmentController: me.SegmentController, technologyChecker: new Ae.TechnologyChecker(), Stream: ye.Stream, FetchController: ve.FetchController, SegmentInfoService: be.SegmentInfoService, SegmentPrefetchingService: $e.SegmentPrefetchingService, AdRestorationOptimizationService: ge.AdRestorationOptimizationService, ManifestCachingService: se.ManifestCachingService, SegmentListMPDHandler: pe.SegmentListMPDHandler, actions: Ne, selectors: Ce, mseModuleTypes: Ie, AdaptationSetId: le.AdaptationSetId, RepresentationId: ce.RepresentationId, getTrackIdentifier: Me.getTrackIdentifier, getCodecsFromAdaptationSet: oe.getCodecsFromAdaptationSet, getMimeTypeForAdaptationSet: oe.getMimeTypeForAdaptationSet } }, ie.default = ie.MseModuleDefinition;
      }, 34268: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.PeriodSwitchTracker = void 0;
        var ae = ne(18665), ue = ne(62510), _e = ne(3464), fe = ne(331), le = ne(72788), se = ne(58211), oe = function() {
          function ce(he) {
            var ge = this;
            this.finishPeriodSwitch = function(ve, me) {
              var be = me.switchingToPeriodId, pe = ge.getCurrentPlayingPeriodId();
              ge.setCurrentPlayingPeriodId(be);
              var $e = ge.getCurrentPlayingPeriod();
              $e && $e.AdaptationSet.forEach(function(ye) {
                return ge.context.renderer.storeDrmInitDataFromManifest(ye);
              }), ge.logger.debug("Successfully switched from Period ".concat(pe, " to Period ").concat(be)), ge.context.eventHandler.dispatchEvent(ue.PlayerEvent.PeriodSwitched, { sourcePeriod: { periodId: pe }, targetPeriod: { periodId: be } });
            }, this.context = he, this.logger = he.logger, this.eventHandler = he.eventHandler, this.subscribeToPlayingTracksChanges();
          }
          return ce.prototype.getManifestService = function() {
            return this.context.serviceManager.get(ae.ServiceName.ManifestService, this.context.sourceContext.sourceIdentifier);
          }, ce.prototype.getCurrentPlayingPeriod = function() {
            return this.getManifestService().findPeriod(this.getCurrentPlayingPeriodId());
          }, ce.prototype.subscribeToPlayingTracksChanges = function() {
            var he = this.getSourceStore();
            !this.unsubscribeFromPlayingTracksStore && he && (this.unsubscribeFromPlayingTracksStore = (0, _e.subscribe)(he)(se.getPlayingTracksState, this.finishPeriodSwitch, se.wasSwitchingToPeriodIdReset));
          }, ce.prototype.unsubscribeFromPlayingTracksChanges = function() {
            this.unsubscribeFromPlayingTracksStore && (this.unsubscribeFromPlayingTracksStore(), this.unsubscribeFromPlayingTracksStore = void 0);
          }, ce.prototype.getSourceStore = function() {
            return this.context.serviceManager.get(ae.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, ce.prototype.getCurrentLoadingPeriodId = function() {
            return this.currentLoadingPeriodId;
          }, ce.prototype.setCurrentLoadingPeriodId = function(he) {
            this.currentLoadingPeriodId = he;
          }, ce.prototype.getCurrentPlayingPeriodId = function() {
            return (0, se.getPlayingPeriodId)(this.getSourceStore().getState());
          }, ce.prototype.setCurrentPlayingPeriodId = function(he) {
            this.getSourceStore().dispatch((0, le.setPlayingPeriodId)(he));
          }, ce.prototype.resetPeriodIds = function() {
            this.setCurrentPlayingPeriodId(void 0), this.setCurrentLoadingPeriodId(void 0);
          }, ce.prototype.shouldHandleDroppedOutPeriod = function() {
            return !(this.getCurrentPlayingPeriodId() == null && this.currentLoadingPeriodId == null);
          }, ce.prototype.isPeriodDroppedOut = function(he) {
            return !this.getManifestService().getAllPeriods().map(function(ge) {
              return ge._id;
            }).includes(he);
          }, ce.prototype.isPlayingPeriodDroppedOut = function() {
            return this.isPeriodDroppedOut(this.getCurrentPlayingPeriodId());
          }, ce.prototype.isLoadingPeriodDroppedOut = function() {
            return this.isPeriodDroppedOut(this.currentLoadingPeriodId);
          }, ce.prototype.isLoadingLastPeriod = function() {
            return this.getManifestService().isLastPeriod(this.currentLoadingPeriodId);
          }, ce.prototype.setInitialPeriod = function() {
            var he = this.getManifestService().isLive() ? this.getInitialPeriodForLive() : this.getInitialPeriodForVod();
            this.currentLoadingPeriodId = he, this.setCurrentPlayingPeriodId(this.currentLoadingPeriodId), this.logger.debug("setting initial period to ".concat(this.currentLoadingPeriodId));
          }, ce.prototype.getInitialPeriodForLive = function() {
            var he = (0, fe.toSeconds)(Date.now()) - this.getManifestService().getDesiredDistanceToLiveEdge();
            return this.getManifestService().getPeriodIdForTime(he);
          }, ce.prototype.getInitialPeriodForVod = function() {
            var he = this.context.serviceManager.get(ae.ServiceName.StartOffsetService).getStartOffset(this.context.sourceContext.source);
            return this.getManifestService().getPeriodIdForTime(he);
          }, ce.prototype.dispose = function() {
            this.unsubscribeFromPlayingTracksChanges();
          }, ce;
        }();
        ie.PeriodSwitchTracker = oe;
      }, 25996: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.PlayerConfigEnhancer = void 0;
        var ae = ne(25226), ue = ne(54838), _e = ne(87062), fe = function() {
          function le(se) {
            this.originalConfig = {}, ue.Util.deepCopy(this.originalConfig, se.config), this.originalSettings = {}, ue.Util.deepCopy(this.originalSettings, se.settings);
          }
          return le.prototype.adjustToCurrentSource = function(se, oe) {
            var ce, he, ge, ve, me = se.config;
            if (me.adaptation && (me.adaptation.logic = (ce = this.originalConfig.adaptation) === null || ce === void 0 ? void 0 : ce.logic), se.settings.CHUNKED_CMAF_STREAMING = this.originalSettings.CHUNKED_CMAF_STREAMING, oe.isDashManifest() && oe.isLive() && (0, _e.isLowLatencyConfigured)(se)) {
              se.logger.debug("Detected DASH Live stream and LL config, enabling 'low-latency-v1' adaptation logic and CHUNKED_CMAF_STREAMING tweak"), me.adaptation = (he = me.adaptation) !== null && he !== void 0 ? he : {}, me.adaptation.logic = (ge = me.adaptation.logic) !== null && ge !== void 0 ? ge : ae.AdaptationLogicType.LOW_LATENCY;
              var be = se.internalPlayer.getConfig().tweaks || {};
              se.settings.CHUNKED_CMAF_STREAMING = (ve = be.CHUNKED_CMAF_STREAMING) === null || ve === void 0 || ve;
            }
          }, le;
        }();
        ie.PlayerConfigEnhancer = fe;
      }, 96707: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.createSegmentParser = fe;
        var ae = ne(91520), ue = ne(16368), _e = ne(73543);
        function fe(le, se) {
          if (se === _e.ContainerFormat.MP4 && ae.ModuleManager.has(ue.ModuleName.ContainerMP4)) {
            var oe = ae.ModuleManager.get(ue.ModuleName.ContainerMP4);
            return new oe.MP4Parser(le, new oe.MP4EncryptionParser(le));
          }
          if (se === _e.ContainerFormat.WEBM && ae.ModuleManager.has(ue.ModuleName.ContainerWebM))
            return new (ae.ModuleManager.get(ue.ModuleName.ContainerWebM)).WebMParser();
        }
      }, 59879: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.StreamTimeService = void 0;
        var ae = ne(18665), ue = ne(81361), _e = ne(22645), fe = function() {
          function se(oe, ce) {
            this.serviceManager = oe, this.sourceIdentifier = ce;
          }
          return Object.defineProperty(se.prototype, "sourceState", { get: function() {
            return this.serviceManager.get(ae.ServiceName.SourceStoreService, this.sourceIdentifier).getState();
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(se.prototype, "streamTimelineState", { get: function() {
            var oe;
            return (oe = this.sourceState) === null || oe === void 0 ? void 0 : oe.streamTimeline;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(se.prototype, "bufferStateMap", { get: function() {
            var oe;
            return (oe = this.sourceState) === null || oe === void 0 ? void 0 : oe.buffer.bufferStateMap;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(se.prototype, "playerStateService", { get: function() {
            return this.serviceManager.get(ae.ServiceName.PlayerStateService);
          }, enumerable: !1, configurable: !0 }), se.prototype.getTimeForNextSegment = function(oe) {
            var ce, he, ge, ve, me = (0, ue.findFromEnd)(this.streamTimelineState[oe] || [], le), be = (ce = this.bufferStateMap) === null || ce === void 0 ? void 0 : ce[oe], pe = [me, ((he = be == null ? void 0 : be.loadedRanges) === null || he === void 0 ? void 0 : he[be.loadedRanges.length - 1]) || ((ge = be == null ? void 0 : be.rendererRanges) === null || ge === void 0 ? void 0 : ge[be.rendererRanges.length - 1])].filter(function(ye) {
              return ye;
            }).map(function(ye) {
              return ye.end;
            }), $e = Math.max.apply(Math, pe);
            return isFinite($e) ? $e : !((ve = this.playerStateService) === null || ve === void 0) && ve.seekingOrTimeshifting ? this.playerStateService.targetPlaybackTime : 0;
          }, se.prototype.dispose = function() {
          }, se;
        }();
        function le(se) {
          return [_e.StreamTimeRangeType.Loading, _e.StreamTimeRangeType.Failed].includes(se.type);
        }
        ie.StreamTimeService = fe;
      }, 23414: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.TechnologyChecker = void 0;
        var ae = ne(91520), ue = ne(16368), _e = function() {
          function fe() {
          }
          return fe.prototype.getSupportedTechnologies = function() {
            return ae.ModuleManager.has(ue.ModuleName.RendererMse) ? ae.ModuleManager.get(ue.ModuleName.RendererMse).technologyChecker.getSupportedTechnologies() : [];
          }, fe;
        }();
        ie.TechnologyChecker = _e;
      }, 21918: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.TimeShiftHandler = void 0;
        var ae = ne(18665), ue = ne(62510), _e = ne(331), fe = ne(70016), le = ne(91520), se = ne(16368), oe = ne(59839), ce = ne(22645), he = ne(87062), ge = ne(93109), ve = function() {
          function be(pe, $e, ye, Se) {
            var we = this;
            this.onSeek = function() {
              we.updateInitialTimeShiftContext(!0);
            }, this.onSeeked = function() {
              var Pe = we.context.renderer.getCurrentTime(!0), Te = Pe - we.getTimeShiftLiveEdge();
              we.updateTimeShiftStateAfterSeek(Te, Pe);
            }, this.context = pe, this.mediaPlayerController = $e, this.bufferController = ye, this.segmentControllers = Object.keys(Se).map(function(Pe) {
              return Se[Pe];
            }), this.manifestService = pe.serviceManager.get(ae.ServiceName.ManifestService, pe.sourceContext.sourceIdentifier), this.logger = pe.logger, this.eventHandler = pe.eventHandler, this.timeShiftCounter = 0, this.sourceIdentifier = pe.sourceContext.sourceIdentifier, this.setupEventHandlers();
          }
          return be.prototype.isLowLatency = function() {
            var pe = (0, he.isLowLatencyConfigured)(this.context), $e = (0, ge.isPlayingLowLatencyHls)(this.context);
            return pe || $e;
          }, be.prototype.calculateLiveEdgeInVideoTime = function() {
            var pe;
            if (this.initialTimeShiftContext && !this.initialTimeShiftContext.isOngoing) {
              var $e = (0, _e.toSeconds)(Date.now() - this.initialTimeShiftContext.timestamp);
              pe = this.initialTimeShiftContext.liveEdge + $e;
            } else
              pe = this.getInitialLiveEdge();
            return isFinite(pe) || (pe = (0, _e.toSeconds)(Date.now() - this.manifestService.getAvailabilityStartTime())), pe;
          }, be.prototype.getInitialLiveEdge = function() {
            var pe = this.calculateMpdHandlerLiveEdge();
            if (!this.isLowLatency())
              return pe;
            var $e = this.segmentControllers.reduce(function(Se, we) {
              return Math.min(Se, we.getMPDHandler().getSegmentDuration());
            }, 1 / 0), ye = this.getWallclockTimeInSeconds();
            return ye - pe < $e ? ye : pe;
          }, be.prototype.getWallclockTimeInSeconds = function() {
            var pe = this.context.serviceManager.maybeCall(ae.ServiceName.SynchronizedTimeService, function($e) {
              return $e.getTimeDifference();
            }, 0, this.context.sourceContext.sourceIdentifier);
            return (0, _e.toSeconds)(Date.now() + pe);
          }, be.prototype.calculateMpdHandlerLiveEdge = function() {
            return this.segmentControllers.map(function(pe) {
              return pe.getLiveEdgeTime();
            }).reduce(function(pe, $e) {
              return $e < pe && $e >= 0 ? $e : pe;
            }, 1 / 0);
          }, be.prototype.updateSegmentControllers = function(pe) {
            this.segmentControllers = Object.values(pe);
          }, be.prototype.getMaxTimeShift = function() {
            if (this.manifestService.getManifest()) {
              var pe = this.manifestService.getTimeShiftBufferDepthSeconds();
              return Math.min(pe + this.manifestService.getDesiredDistanceToLiveEdge(), 0);
            }
            return 0;
          }, be.prototype.getTimeShiftLiveEdge = function() {
            return this.calculateLiveEdgeInVideoTime() - this.manifestService.getDesiredDistanceToLiveEdge();
          }, be.prototype.getTimeShift = function() {
            var pe = this.getActualTimeShift();
            if (this.lastTimeShiftStatus) {
              var $e = (0, _e.toSeconds)(Date.now() - this.lastTimeShiftStatus.completionDate) - (this.mediaPlayerController.getCurrentTime() - this.lastTimeShiftStatus.reachedTime);
              if (Math.abs($e) < this.context.settings.ACCEPTABLE_TIMESHIFT_INACCURACY)
                return this.lastTimeShiftStatus.offset;
            }
            var ye = this.getMaxTimeShift();
            return pe < ye && (pe = ye), pe > 0 && (pe = 0), pe;
          }, be.prototype.getActualTimeShift = function(pe) {
            return pe === void 0 && (pe = !1), !this.initialTimeShiftContext || this.initialTimeShiftContext.isOngoing ? 0 : (pe ? this.mediaPlayerController.getBufferRelevantTime() : this.mediaPlayerController.getCurrentTime()) - this.getTimeShiftLiveEdge();
          }, be.prototype.getDistanceToRealLiveEdge = function() {
            return this.calculateLiveEdgeInVideoTime() - this.mediaPlayerController.getBufferRelevantTime();
          }, be.prototype.adjustTargetTime = function(pe) {
            var $e = this.manifestService.getPeriodIdForTime(pe), ye = !this.manifestService.isLastPeriod($e), Se = this.manifestService.isTimeNearPeriodEnd(pe, this.context.settings.END_OF_BUFFER_TOLERANCE);
            if (ye && Se) {
              var we = this.manifestService.getNextPeriod($e);
              this.logger.debug("Timeshift target too close to end of period ".concat($e, ", adjusting target from ").concat(pe) + " to ".concat(we.start, ", i.e. next period's start.")), pe = we.start;
            }
            return pe;
          }, be.prototype.timeShift = function(pe, $e, ye) {
            var Se = this;
            ye === void 0 && (ye = !1);
            var we = !!this.initialTimeShiftContext;
            we || this.adjustTargetBufferLevel(), pe = Math.max(this.getMaxTimeShift(), pe);
            var Pe = this.mediaPlayerController.getCurrentTime(), Te = this.calculatePlaybackTimeForTimeShiftOffset(pe), Ee = this.manifestService.getPeriodIdForTime(Te);
            this.timeShiftCounter++;
            var Me = this.timeShiftCounter, Ae = ye || this.bufferController.shouldBuffersBeClearedOnTimeshift(Te);
            return this.logger.debug("Performing timeShift to offset ".concat(pe, ", time: ").concat(Pe, " -> ").concat(Te, ", period: ").concat(Ee)), this.bufferController.setTimeshiftCancelState(!1), (0, fe.isDefined)(Ee) && this.mediaPlayerController.updatePeriodForTimeshift(Ee, !we, Ae), Ae && this.segmentControllers.forEach(function(Ne) {
              return Ne.seekTo(Te);
            }), we && this.maybeResetTransmuxerForPtsRollover(Te), this.updateInitialTimeShiftContext(!0), this.bufferController.setCurrentTime(Te, Ee, !0, ye).then(function(Ne) {
              Se.updateInitialTimeShiftContext(!1), Se.lastTimeShiftStatus = { offset: pe, completionDate: Date.now(), reachedTime: Ne }, Se.timeShiftCounter === Me && $e ? (Se.logger.debug("Successfully timeShifted to ".concat(Ne, ", hit target time with a diff of ").concat(Ne - Te)), $e()) : $e && Se.context.logger.debug("Timeshift to ".concat(pe, " has finished but a newer operation has been started"));
            }).catch(function(Ne) {
              Se.logger.debug("Failed to set currentTime on timeShift", Ne);
            }).finally(function() {
              return Se.bufferController.setTimeshiftCancelState(!1);
            });
          }, be.prototype.maybeResetTransmuxerForPtsRollover = function(pe) {
            var $e;
            if (this.manifestService.isHlsManifest()) {
              var ye = this.context.serviceManager.get(ae.ServiceName.SourceStoreService, this.sourceIdentifier);
              me(($e = le.ModuleManager.get(se.ModuleName.HLS)) === null || $e === void 0 ? void 0 : $e.selectors.getHlsState(ye == null ? void 0 : ye.getState()), pe) && (this.context.logger.debug("Resetting transmuxer because target is beyond a timestamp rollover"), this.mediaPlayerController.resetTransmuxer());
            }
          }, be.prototype.cancel = function() {
            this.context.logger.debug("Cancelling ongoing time shift operation..."), this.bufferController.setTimeshiftCancelState(!0);
          }, be.prototype.calculatePlaybackTimeForTimeShiftOffset = function(pe) {
            var $e = this.manifestService.getDesiredDistanceToLiveEdge(), ye = this.calculateLiveEdgeInVideoTime(), Se = ye + (pe - $e);
            return this.manifestService.hasMultiplePeriods() ? this.adjustTargetTime(Se) : pe === 0 && this.isLowLatency() ? Math.min(ye, Se + this.context.settings.LOW_LATENCY_SEEK_AHEAD) : Se;
          }, be.prototype.onManifestUpdate = function() {
            this.manifestService.isLive() && (this.adjustTargetBufferLevel(), this.getActualTimeShift(!0) < this.getMaxTimeShift() - this.getMinSegmentDuration() && this.context.eventHandler.dispatchEvent(ue.PlayerEvent.DVRWindowExceeded), this.removeDroppedOutFailedBufferRanges());
          }, be.prototype.removeDroppedOutFailedBufferRanges = function() {
            var pe = this;
            this.context.serviceManager.maybeCall(ae.ServiceName.SourceStoreService, function($e) {
              var ye, Se = pe.manifestService.getTimeShiftBufferDepthSeconds(), we = pe.calculateLiveEdgeInVideoTime() + Se, Pe = (ye = $e.getState()) === null || ye === void 0 ? void 0 : ye.streamTimeline;
              Pe !== void 0 && Object.keys(Pe).forEach(function(Te) {
                $e.dispatch((0, oe.removeStreamTimeRange)(Te, { start: 0, end: we }, ce.StreamTimeRangeType.Failed));
              });
            });
          }, be.prototype.isTimeInBufferedRange = function(pe) {
            return this.bufferController.isTimeInBufferedRange(pe);
          }, be.prototype.getMinSegmentDuration = function() {
            return this.segmentControllers.reduce(function(pe, $e) {
              return Math.min(pe, $e.getMPDHandler().getSegmentDuration());
            }, 1 / 0);
          }, be.prototype.adjustTargetBufferLevel = function() {
            this.context.bufferSettings.setTargetBufferLevelConstraints({ minimumBufferLength: this.getMinSegmentDuration(), currentDistanceToLiveEdge: this.getDistanceToRealLiveEdge(), streamDuration: Math.abs(this.manifestService.getTimeShiftBufferDepthSeconds()) });
          }, be.prototype.updateTimeShiftStateAfterSeek = function(pe, $e) {
            this.lastTimeShiftStatus = { completionDate: Date.now(), reachedTime: $e, offset: pe }, this.updateInitialTimeShiftContext(!1);
          }, be.prototype.updateInitialTimeShiftContext = function(pe) {
            (!this.initialTimeShiftContext || !pe && this.initialTimeShiftContext.isOngoing) && (this.initialTimeShiftContext = { timestamp: Date.now(), liveEdge: this.calculateLiveEdgeInVideoTime(), isOngoing: pe });
          }, be.prototype.setupEventHandlers = function() {
            this.eventHandler.on(ue.PlayerEvent.Seek, this.onSeek, !0), this.eventHandler.on(ue.PlayerEvent.Seeked, this.onSeeked, !0);
          }, be.prototype.removeEventHandlers = function() {
            this.eventHandler.off(ue.PlayerEvent.Seek, this.onSeek), this.eventHandler.off(ue.PlayerEvent.Seeked, this.onSeeked);
          }, be.prototype.dispose = function() {
            this.removeEventHandlers(), this.bufferController.setTimeshiftCancelState(!0);
          }, be;
        }();
        function me(be, pe) {
          var $e, ye, Se = (ye = ($e = be == null ? void 0 : be.timestampRolloverPositions) === null || $e === void 0 ? void 0 : $e.next) !== null && ye !== void 0 ? ye : -1;
          return Se !== -1 && (pe >= Se || pe <= be.timestampRolloverPositions.previous);
        }
        ie.TimeShiftHandler = ve;
      }, 55937: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.BufferBlock = ie.EncryptionState = void 0, ie.isPrecedingSegment = se;
        var ae, ue = ne(79814), _e = ne(37702);
        (function(oe) {
          oe.Encrypted = "encrypted", oe.Clear = "clear";
        })(ae || (ie.EncryptionState = ae = {}));
        var fe = function() {
          function oe(ce) {
            this.trackedDiscoNumbersMap = {}, this.id = ce, this.cachedSegments = [], this.blockStateMap = /* @__PURE__ */ new Map();
          }
          return oe.prototype.addSegment = function(ce) {
            var he = ce.getMimeType();
            this.trackedDiscoNumbersMap[he] || (this.trackedDiscoNumbersMap[he] = []), ce.isInit() && this.removeLastInitSegment(he), this.periodId === void 0 && (this.periodId = ce.getPeriodId());
            var ge = ce.getSegmentInfo().discontinuitySequenceNumber;
            ge == null || this.trackedDiscoNumbersMap[he].includes(ge) || this.trackedDiscoNumbersMap[he].push(ge);
            var ve = ce.isInit() ? 0 : ce.getDuration();
            this.cachedSegments.push({ segment: ce }), ce.isInit() || (this.setMaxSegmentDuration(he, Math.max(ve, this.getMaxSegmentDuration(he))), this.updatePlaybackTimeRange(ce, he)), ce.setBufferBlockId(this.id), this.updateMediaTypes(ce);
          }, oe.prototype.setSegregationCriteria = function(ce, he) {
            this.blockStateMap.has(he) || this.initializeBlockStateMapForMimeType(he), this.getBlockState(he).segregationCriteria = ce;
          }, oe.prototype.initializeBlockStateMapForMimeType = function(ce) {
            var he = {};
            return this.blockStateMap.set(ce, he), he;
          }, oe.prototype.updateMediaTypeForMimeType = function(ce) {
            var he = this.getBlockState(ce.mimeType) || this.initializeBlockStateMapForMimeType(ce.mimeType);
            he.mediaType ? (le(ce, "codec", function(ge) {
              he.mediaType.codec = ge;
            }), le(ce, "timestampOffset", function(ge) {
              he.mediaType.timestampOffset = ge;
            }), le(ce, "timescale", function(ge) {
              he.mediaType.timescale = ge;
            })) : he.mediaType = ce;
          }, oe.prototype.getSegregationCriteria = function(ce) {
            var he;
            return (he = this.getBlockState(ce)) === null || he === void 0 ? void 0 : he.segregationCriteria;
          }, oe.prototype.updateMediaTypes = function(ce) {
            var he = ce.getMimeType(), ge = this.getMediaType(he);
            ge ? (ge.codec === null && (ge.codec = ce.getCodec()), ge.timescale == null && (ge.timescale = ce.getTimescale())) : (this.blockStateMap.has(he) || this.blockStateMap.set(he, {}), this.getBlockState(he).mediaType = { mimeType: he, codec: ce.getCodec(), timestampOffset: 0, timescale: ce.getTimescale() });
          }, oe.prototype.getMediaType = function(ce) {
            var he, ge;
            return (ge = (he = this.getBlockState(ce)) === null || he === void 0 ? void 0 : he.mediaType) !== null && ge !== void 0 ? ge : null;
          }, oe.prototype.addMediaType = function(ce) {
            ue.MimeTypeHelper.isAV(ce.mimeType) && !this.getMediaType(ce.mimeType) && (this.blockStateMap.has(ce.mimeType) || this.initializeBlockStateMapForMimeType(ce.mimeType), this.getBlockState(ce.mimeType).mediaType = ce);
          }, oe.prototype.removeMediaType = function(ce) {
            this.clearSegments(ce), this.blockStateMap.delete(ce);
          }, oe.prototype.hasMediaType = function(ce) {
            var he, ge;
            return (ge = (he = this.blockStateMap) === null || he === void 0 ? void 0 : he.has(ce)) !== null && ge !== void 0 && ge;
          }, oe.prototype.getMediaTypes = function() {
            return (0, _e.getValues)(this.blockStateMap).map(function(ce) {
              return ce.mediaType;
            });
          }, oe.prototype.getMediaTypesWithoutSubs = function() {
            return this.getMediaTypes().filter(function(ce) {
              return ue.MimeTypeHelper.isAV(ce.mimeType);
            });
          }, oe.prototype.removeSegment = function(ce) {
            var he = this.cachedSegments.findIndex(function(ge) {
              return ge.segment === ce;
            });
            he > -1 && this.cachedSegments.splice(he, 1);
          }, oe.prototype.clearSegments = function(ce) {
            this.cachedSegments = this.cachedSegments.filter(function(ge) {
              return ge.segment.getMimeType() !== ce;
            });
            var he = this.getBlockState(ce);
            he && (he.playbackTimeRange = void 0), this.trackedDiscoNumbersMap[ce] = [];
          }, oe.prototype.getPrecedingSegments = function(ce, he) {
            var ge = [];
            return this.cachedSegments.forEach(function(ve) {
              se(ve.segment, ce, he) && ge.push(ve.segment);
            }), ge;
          }, oe.prototype.updatePlaybackTimeRange = function(ce, he) {
            var ge = this.getPlaybackTimeRange(he), ve = ce.getPlaybackTime(), me = ve + ce.getDuration();
            ge ? (ve < ge.start && (ge.start = ve), me > ge.end && (ge.end = me)) : this.getBlockState(he).playbackTimeRange = { start: ve, end: me };
          }, oe.prototype.getPlaybackTimeRange = function(ce) {
            var he, ge;
            return (ge = (he = this.getBlockState(ce)) === null || he === void 0 ? void 0 : he.playbackTimeRange) !== null && ge !== void 0 ? ge : null;
          }, oe.prototype.getId = function() {
            return this.id;
          }, oe.prototype.getPeriodId = function() {
            return this.periodId;
          }, oe.prototype.getMinCommonStartTime = function() {
            return (0, _e.getValues)(this.blockStateMap).filter(function(ce) {
              return ce.playbackTimeRange;
            }).map(function(ce) {
              return ce.playbackTimeRange;
            }).reduce(function(ce, he) {
              return Math.max(he.start, ce);
            }, -1 / 0);
          }, oe.prototype.getCommonPlaybackTimeRanges = function() {
            return (0, _e.getValues)(this.blockStateMap).filter(function(ce) {
              return ce.playbackTimeRange;
            }).map(function(ce) {
              return ce.playbackTimeRange;
            }).reduce(function(ce, he) {
              return { start: Math.max(he.start, ce.start), end: Math.min(he.end, ce.end) };
            }, { start: -1 / 0, end: 1 / 0 });
          }, oe.prototype.setMaxSegmentDuration = function(ce, he) {
            this.blockStateMap.has(ce) || this.initializeBlockStateMapForMimeType(ce), this.getBlockState(ce).maxSegmentDuration = he;
          }, oe.prototype.getMaxSegmentDuration = function(ce) {
            var he;
            return ((he = this.getBlockState(ce)) === null || he === void 0 ? void 0 : he.maxSegmentDuration) || 0;
          }, oe.prototype.hasMaxSegmentDuration = function(ce) {
            var he;
            return ((he = this.getBlockState(ce)) === null || he === void 0 ? void 0 : he.maxSegmentDuration) != null;
          }, oe.prototype.hasMaxSegmentDurations = function() {
            return !!(0, _e.getValues)(this.blockStateMap).map(function(ce) {
              return ce.maxSegmentDuration;
            }).find(function(ce) {
              return ce >= 0;
            });
          }, oe.prototype.getMinMaxSegmentDuration = function() {
            var ce = Number.MAX_VALUE;
            return (0, _e.getValues)(this.blockStateMap).map(function(he) {
              return he.maxSegmentDuration;
            }).forEach(function(he) {
              return ce = he < ce ? he : ce;
            }), ce;
          }, oe.prototype.getAllSegmentsForMimeType = function(ce) {
            return this.getAllSegments().filter(function(he) {
              return he.getMimeType() === ce;
            });
          }, oe.prototype.getAllSegments = function() {
            return this.cachedSegments.map(function(ce) {
              return ce.segment;
            });
          }, oe.prototype.hasDataSegments = function(ce) {
            return this.cachedSegments.some(function(he) {
              return !he.segment.isInit() && he.segment.getMimeType() === ce;
            });
          }, oe.prototype.hasSegments = function() {
            return this.getAllSegments().length > 0;
          }, oe.prototype.hasTrackedDiscontinuity = function(ce) {
            var he = this;
            return Object.keys(this.trackedDiscoNumbersMap).some(function(ge) {
              return he.trackedDiscoNumbersMap[ge].includes(ce);
            });
          }, oe.prototype.getNextSegment = function() {
            var ce = this.cachedSegments.filter(function(ge) {
              return !ge.pendingRemoval;
            });
            if (ce.length === 0)
              return null;
            var he = ce.find(function(ge) {
              return ce.filter(function(ve) {
                return ge.segment.getMimeType() === ve.segment.getMimeType();
              }).some(function(ve) {
                return !ve.segment.isInit();
              });
            });
            return he ? (he.pendingRemoval = !0, he.segment) : null;
          }, oe.prototype.removeLastInitSegment = function(ce) {
            var he = this.getAllSegmentsForMimeType(ce);
            if (he.length > 0) {
              var ge = he[he.length - 1];
              ge.isInit() && this.removeSegment(ge);
            }
          }, oe.prototype.getBlockState = function(ce) {
            return this.blockStateMap.get(ce);
          }, Object.defineProperty(oe.prototype, "mediaTypes", { get: function() {
            var ce = {};
            return this.blockStateMap.forEach(function(he, ge) {
              ce[ge] = he.mediaType;
            }), ce;
          }, enumerable: !1, configurable: !0 }), oe.prototype.getMinDistanceFromBufferBlock = function(ce) {
            var he = this.getCommonPlaybackTimeRanges();
            return Math.min(Math.min(Math.abs(ce.getPlaybackTime() - he.start), Math.abs(ce.getPlaybackTime() - he.end)), Math.min(Math.abs(ce.getPlaybackEndTime() - he.start), Math.abs(ce.getPlaybackEndTime() - he.end)));
          }, oe;
        }();
        function le(oe, ce, he) {
          oe.hasOwnProperty(ce) && he(oe[ce]);
        }
        function se(oe, ce, he) {
          var ge = oe.isInit(), ve = oe.getMimeType() !== ce;
          return !ge && !ve && oe.getPlaybackTime() + oe.getDuration() < he;
        }
        ie.BufferBlock = fe;
      }, 73022: function(ee, ie) {
        function ne(ae, ue) {
          return !(!ae || !ue) && ae === ue;
        }
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.areBufferBlocksEqual = ne;
      }, 80858: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(lt) {
            for (var Je, Xe = 1, We = arguments.length; Xe < We; Xe++)
              for (var Ge in Je = arguments[Xe])
                Object.prototype.hasOwnProperty.call(Je, Ge) && (lt[Ge] = Je[Ge]);
            return lt;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.BufferController = void 0;
        var ue = ne(92712), _e = ne(52442), fe = ne(25550), le = ne(28764), se = ne(63546), oe = ne(35148), ce = ne(18665), he = ne(60997), ge = ne(62510), ve = ne(33696), me = ne(94304), be = ne(76650), pe = ne(28819), $e = ne(8272), ye = ne(58975), Se = ne(76420), we = ne(96873), Pe = ne(33669), Te = ne(3464), Ee = ne(10981), Me = ne(53968), Ae = ne(79814), Ne = ne(56435), Ce = ne(331), Ie = ne(70016), xe = ne(46462), Ue = ne(91520), ke = ne(16368), Le = ne(41108), De = ne(77874), Re = ne(72788), Oe = ne(58211), Be = ne(16280), Fe = ne(68294), Ve = ne(59839), Ke = ne(14764), Ze = ne(22645), nt = ne(55937), Qe = ne(16492), qe = ne(15109), ze = ne(27076), je = ne(42346), tt = ne(19724), ut = "The targeted buffer BufferBlock is no longer available", yt = function() {
          function lt(Je, Xe, We, Ge) {
            var at = this;
            this.currentRendererMediaTypes = [], this.startupPlaybackTime = null, this.isAlreadyStarted = !1, this.isStartup = !0, this.finishPlayback = !1, this.hasStreamEndedInternal = !1, this.activeInitSegments = {}, this.bufferMaxSizeChangedSubscriptionMap = {}, this.isTimeshiftCancelled = !1, this.updateTotalDuration = function() {
              at.totalDuration = at.manifestService.getTotalDuration(), at.totalDuration > (at.renderer.getDuration() || 0) && at.setDurationOnRenderer();
            }, this.setDurationOnRenderer = function() {
              at.finishPlayback || at.renderer.setDuration(at.totalDuration);
            }, this.onRendererSetupFailed = function(dt) {
              at.context.logger.debug("Renderer setup failed with", dt);
            }, this.onVideoElementTimeUpdate = function() {
              Date.now() - at.lastBackwardBufferClearingTimestamp > at.minimalBackwardBufferClearingInterval && at.canClearBackwardBuffer() && at.maintainBackwardBufferLevel(), at.checkIfEndOfBufferReached(at.settings.END_OF_BUFFER_TOLERANCE);
            }, this.onTimeNotAdvancing = function() {
              var dt, ot = at.settings.END_OF_BUFFER_RECOVERY_TOLERANCE, et = (dt = at.segmentStore) === null || dt === void 0 ? void 0 : dt.getBufferBlock(at.currentPlayingBufferBlockId);
              et && at.isAtEndOfBufferBlock() && (ot = at.segmentStore.getSmallestMaxSegmentDuration(et)), at.checkIfEndOfBufferReached(ot);
            }, this.onVideoElementEnded = function() {
              var dt;
              if (!(0, Me.isSwitchingBufferBlocks)(at.getSourceStore())) {
                var ot = (dt = at.segmentStore) === null || dt === void 0 ? void 0 : dt.getNextBufferBlock(at.currentPlayingBufferBlockId);
                if (ot) {
                  var et = at.renderer.getCurrentTime(!0);
                  at.tryToSwitchBufferBlock(et, ot);
                }
              }
            }, this.onVideoElementStalled = function() {
              at.checkIfEndOfBufferReached(at.settings.END_OF_BUFFER_RECOVERY_TOLERANCE);
            }, this.context = Je, this.logger = Je.logger, this.settings = Je.settings, this.bufferSettings = Je.bufferSettings, this.eventHandler = Je.eventHandler, this.renderer = Je.renderer, this.manifestService = Je.serviceManager.get(ce.ServiceName.ManifestService, Je.sourceContext.sourceIdentifier), this.segmentStore = new je.SegmentStore(this.context, this.settings), this.endStallAtGapCallback = Xe, this.bufferStallingService = new qe.BufferStallingService(this.getPlayerStateService(), this.logger, this.context.renderer), this.currentPlayingPeriodId = Ge, this.lastPlayingPeriodId = null, this.totalDuration = We, this.currentPlayingBufferBlockId = je.INITIAL_BUFFER_BLOCK_ID, this.dataSegmentsPushedMap = /* @__PURE__ */ new Map(), this.isEndOfStreamReached = !1, this.lastBackwardBufferClearingTimestamp = 0, this.minimalBackwardBufferClearingInterval = (0, Ce.toMilliSeconds)(this.context.settings.MINIMAL_BACKWARD_BUFFER_CLEARING_INTERVAL), this.discontinuitySequenceNumbers = /* @__PURE__ */ new Map(), this.currentBufferBlockDeferredReject = new ze.DeferredReject(), this.drmConfigValidPromise = Promise.resolve(null), this.bufferRangesCache = new Qe.BufferRangesCache(this.context, this.segmentStore), this.subscribeToPlaybackStoppedStateChange(), this.renderer.ready().then(function() {
              at.setDurationOnRenderer(), at.shouldSendLicenseRequestsImmediately() && at.setupDRM();
            }).catch(this.onRendererSetupFailed), this.unsubscribeFromStoreSeekedListener = (0, Te.subscribe)(this.context.store)(function(dt) {
              return dt && (0, ye.getPlayerState)(dt).seekState;
            }, function() {
              at.canClearBackwardBuffer() && at.maintainBackwardBufferLevel();
            }, function(dt, ot) {
              return dt === Se.SeekState.Seeked && ot !== Se.SeekState.Seeked;
            });
          }
          return lt.prototype.subscribeToPlaybackStoppedStateChange = function() {
            var Je = this, Xe = this.context.store;
            Xe !== void 0 && (this.unsubscribeFromStoreStoppedListener = (0, Te.subscribe)(Xe)(function(We) {
              return We && (0, ye.getIsStopped)((0, ye.getPlayerState)(We));
            }, function() {
              return Je.hasStreamEndedInternal = !0;
            }, function(We) {
              return We === !0;
            }));
          }, Object.defineProperty(lt.prototype, "isCurrentlyStalled", { get: function() {
            return this.bufferStallingService.isRendererStalling();
          }, enumerable: !1, configurable: !0 }), lt.prototype.shouldSendLicenseRequestsImmediately = function() {
            var Je, Xe;
            return !!(!((Xe = (0, Fe.getDrmState)((Je = this.getSourceStore()) === null || Je === void 0 ? void 0 : Je.getState())) === null || Xe === void 0) && Xe.immediateLicenseRequest);
          }, lt.prototype.createSourceBuffers = function(Je) {
            var Xe = this, We = Promise.resolve();
            return this.bufferCreationDeferred = new Ee.Deferred(), this.isStartup || (We = this.renderer.shutdown(!0)), this.activeInitSegments = {}, this.bufferCreationDeferred.resolve(We.then(function() {
              return Xe.renderer.ready();
            }).then(function() {
              return Xe.setDurationOnRenderer(), Xe.clearBufferMaxSizeChangedSubscription(), Je.forEach(function(Ge) {
                var at = Ge.mimeType;
                Xe.addMimeTypeAndCodec(at, Ge.codec) || (Xe.logger.debug("Could not create source buffer for ".concat(at)), Xe.context.store.dispatch((0, be.removeMetricsForMimeType)(at))), Xe.subscribeToBufferMaxSizeChanged(at);
              }), Xe.currentRendererMediaTypes = Je.filter(function(Ge) {
                return Ae.MimeTypeHelper.isAV(Ge.mimeType);
              }), Xe.setupDRM(), Promise.resolve(Xe.currentRendererMediaTypes.length);
            })), this.bufferCreationDeferred.promise.catch(function(Ge) {
              return Xe.logger.warn(Ge);
            }).then(function() {
              Xe.bufferCreationDeferred = null;
            }), this.bufferCreationDeferred.promise;
          }, lt.prototype.subscribeToBufferMaxSizeChanged = function(Je) {
            var Xe = this, We = this.getSourceStore();
            We && (this.bufferMaxSizeChangedSubscriptionMap[Je] = We.subscribe(function() {
              return Xe.adjustMaxBufferLevels(Je);
            }, (0, Pe.hasBufferMaxSizeChanged)(Je)));
          }, lt.prototype.unsubscribeFromBufferMaxSizeChanged = function(Je) {
            var Xe = this.bufferMaxSizeChangedSubscriptionMap[Je];
            Xe && (Xe(), delete this.bufferMaxSizeChangedSubscriptionMap[Je]);
          }, lt.prototype.setupDRM = function() {
            var Je, Xe = this, We = (0, Fe.getDrmState)((Je = this.getSourceStore()) === null || Je === void 0 ? void 0 : Je.getState());
            if (We !== void 0 && Object.keys(We).length > 0) {
              var Ge = ae(ae({}, this.context.sourceContext.source), { drm: We }), at = this.manifestService.getDRMCapabilitiesForPeriod(this.currentPlayingPeriodId);
              Object.keys(me.KeySystemMap).some(function(dt) {
                return Ge.drm.hasOwnProperty(dt);
              }) && (this.drmConfigValidPromise = this.renderer.setDrmConfig(We, at), this.drmConfigValidPromise.catch(function(dt) {
                (dt == null ? void 0 : dt.message) !== _e.DrmSetupError.CANCELLED && Xe.logger.debug("Could not initialize renderer with given DRM config: ".concat(dt == null ? void 0 : dt.message), dt);
              }));
            }
          }, lt.prototype.getSourceStore = function() {
            var Je;
            return (Je = this.context.serviceManager) === null || Je === void 0 ? void 0 : Je.get(ce.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, lt.prototype.maybeWaitForBufferClearingPromise = function() {
            var Je = this;
            return this.bufferClearingPromise ? this.bufferClearingPromise.catch(function() {
              return Je.isTimeshiftCancelled = !0, Promise.reject("Failed to clear buffer on timeshift, stopping segment cache processing");
            }).then(function() {
              return Je.isTimeshiftCancelled ? (Je.isTimeshiftCancelled = !1, Promise.reject("Timeshift cancelled, stopping segment cache processing")) : Promise.resolve();
            }) : Promise.resolve();
          }, lt.prototype.addSegment = function(Je) {
            var Xe = this;
            if (!this.segmentStore)
              return Promise.reject("Skipping segment processing, segment store is already disposed");
            if (this.logger.insane("adding segment to cache for period ".concat(Je.getPeriodId(), " with playback time ").concat(Je.getPlaybackTime(), " and mime type ").concat(Je.getMimeType())), this.segmentStore.addSegment(Je), this.subscribeToManifestChange(), pt(Je, this.getSourceStore()), !this.areBufferBlockMediaTypesFinalForPeriod(Je.getPeriodId()))
              return Promise.resolve();
            var We = Promise.resolve();
            if (this.delayedBufferBlockSwitchContext) {
              var Ge = this.delayedBufferBlockSwitchContext.time, at = this.findBufferBlockForTime(Ge);
              if (!this.segmentStore.canSwitchToBufferBlock(at))
                return Promise.resolve();
              We = this.maybeWaitForBufferClearingPromise().then(function() {
                return Xe.tryToSwitchBufferBlock(Ge, at);
              });
            } else if ((0, Me.isSwitchingBufferBlocks)(this.getSourceStore()) || this.isBufferAvailable() || this.bufferCreationDeferred)
              this.bufferCreationDeferred && (We = this.bufferCreationDeferred.promise);
            else {
              var dt = this.segmentStore.getBufferBlockForSegment(Je), ot = dt == null ? void 0 : dt.getMediaTypes();
              if (!ot)
                return this.logger.debug("Chosen buffer block for segment unexpectedly had no mediaTypes"), Promise.resolve();
              We = this.createSourceBuffers(ot);
            }
            return We.then(function() {
              return Xe.renderer ? Xe.renderer.ready() : Promise.reject("Stopping queue processing, renderer is not available");
            }).then(function() {
              return Xe.processSegmentCache();
            });
          }, lt.prototype.removePrecedingSegmentsFromStore = function(Je, Xe) {
            var We = this;
            this.segmentStore && this.segmentStore.getPrecedingSegments(Je, Xe).forEach(function(Ge) {
              var at;
              We.segmentStore.removeSegment(Ge), (at = We.getSourceStore()) === null || at === void 0 || at.dispatch((0, we.removeLoadedRange)(Ge.getMimeType(), (0, Be.segmentToBufferBlockTimeRange)(Ge)));
            });
          }, lt.prototype.clearBackwardBuffer = function(Je, Xe) {
            var We = this;
            return this.removePrecedingSegmentsFromStore(Je, Xe), this.lastBackwardBufferClearingTimestamp = Date.now(), this.renderer.removeData(Je, 0, Xe).catch(function(Ge) {
              return We.logger.debug("Error clearing ".concat(Je, " backward buffer:"), Ge);
            });
          }, lt.prototype.updateBackwardBufferClearingInterval = function() {
            if (this.segmentStore) {
              var Je = this.segmentStore.getBufferBlock(this.currentPlayingBufferBlockId), Xe = Je ? this.segmentStore.getSmallestMaxSegmentDuration(Je) : -1;
              this.minimalBackwardBufferClearingInterval = (0, Ce.toMilliSeconds)(Math.max(Xe / 2, this.context.settings.MINIMAL_BACKWARD_BUFFER_CLEARING_INTERVAL));
            }
          }, lt.prototype.maintainBackwardBufferLevel = function() {
            var Je, Xe, We = this;
            this.updateBackwardBufferClearingInterval();
            var Ge = (Je = this.segmentStore) === null || Je === void 0 ? void 0 : Je.getBufferBlock(this.currentPlayingBufferBlockId), at = this.renderer.getCurrentTime(), dt = (0, Pe.getBufferStateMap)((Xe = this.getSourceStore()) === null || Xe === void 0 ? void 0 : Xe.getState());
            dt && Object.keys(dt).forEach(function(ot) {
              var et, st = (et = (0, Pe.getRendererBufferedRanges)(dt, ot)[0]) === null || et === void 0 ? void 0 : et.start, mt = Ae.MimeTypeHelper.getMediaType(ot);
              if (st !== void 0 && (Ge != null && Ge.hasMaxSegmentDuration(ot))) {
                var St = Ge.getMaxSegmentDuration(ot) + 1, bt = We.bufferSettings.getBackwardTargetLevel(mt), it = Math.max(St, bt), ht = at - it;
                st < ht && We.clearBackwardBuffer(ot, ht).catch(function(vt) {
                  We.context.logger.debug("Could not clear backward buffer", vt);
                });
              }
            });
          }, lt.prototype.setEndOfStream = function(Je) {
            var Xe;
            return Je && this.suspendEosSignalling || !this.renderer ? (this.logger.debug("Skipping setting EOS"), Promise.resolve()) : (Je && ((Xe = this.getSourceStore()) === null || Xe === void 0 || Xe.dispatch((0, we.setLoadingRangeFinished)(!0))), this.isEndOfStreamReached = Je, this.renderer.setEndOfStream(Je));
          }, lt.prototype.adjustMaxBufferLevels = function(Je) {
            var Xe, We = (0, Pe.getBufferState)((Xe = this.getSourceStore()) === null || Xe === void 0 ? void 0 : Xe.getState()), Ge = We !== void 0 ? (0, Pe.getBufferMaxSize)(We, Je) : Pe.DefaultBufferMaxSize;
            if (this.logger.debug("Exceeded quota for ".concat(Je, " with ").concat(Ge, " seconds of data in the buffers")), !this.context.settings.NO_QUOTA_EXCEEDED_ADJUSTMENT) {
              var at = this.renderer.getCurrentTime(), dt = this.segmentStore.getSmallestSafeBufferSize(at, Je);
              this.bufferSettings.adjustMaxBufferLevels(dt, Je, Ge);
            }
          }, lt.prototype.getLowestPlaybackTimeForAllSegments = function(Je) {
            return Je.filter(function(Xe) {
              return !Xe.isInit();
            }).map(function(Xe) {
              return Xe.getPlaybackTime();
            }).reduce(function(Xe, We) {
              return Math.min(We, Xe);
            }, 0);
          }, lt.prototype.updateTimestampOffsetForNegativePlaybackTime = function() {
            var Je = this.segmentStore.getBufferBlock(this.currentPlayingBufferBlockId), Xe = this.segmentStore.getAllSegmentsFromBufferBlock(Je).toArray(), We = this.getLowestPlaybackTimeForAllSegments(Xe);
            We < 0 && (this.eventHandler.dispatchEvent(ge.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.PLAYBACK_NEGATIVE_DECODING_TIMESTAMP_ENCOUNTERED)), this.logger.debug("Encountered negative DTS ".concat(We, ", attempting to correct PTO...")), this.currentRendererMediaTypes.forEach(function(Ge) {
              Ge.timestampOffset != null && (Ge.timestampOffset += We, Xe.filter(function(at) {
                return at.getMimeType() === Ge.mimeType;
              }).forEach(function(at) {
                return at.setPresentationTimeOffset(Ge.timestampOffset);
              }));
            }));
          }, lt.prototype.processSegmentCache = function() {
            var Je = this;
            return this.isStartup ? this.isStartupThresholdReached() ? (this.updateTimestampOffsetForNegativePlaybackTime(), this.updateTimestampOffsets(), this.pushSegmentsToRenderer(1 / 0).then(function() {
              return Je.endStartupPhase();
            })) : Promise.resolve() : this.pushSegmentsToRenderer(1 / 0);
          }, lt.prototype.getBufferedRangesMap = function(Je, Xe) {
            var We;
            Je === void 0 && (Je = this.currentPlayingPeriodId), Xe === void 0 && (Xe = !0);
            var Ge = (0, Pe.getBufferState)((We = this.getSourceStore()) === null || We === void 0 ? void 0 : We.getState());
            return Je && Ge !== void 0 ? Xe ? this.bufferRangesCache.getRanges(Ge) : (0, Pe.getRendererBufferRangesMap)(this.segmentStore, Ge)(Je, this.currentPlayingBufferBlockId) : {};
          }, lt.prototype.addSegmentsFromCacheToRenderer = function(Je, Xe) {
            var We = this;
            if (!this.segmentStore)
              return Promise.resolve();
            var Ge = this.segmentStore.getAllSegmentsFromBufferBlock(Je), at = Ge.hasNext() && Ge.next();
            return at ? (this.segmentStore.removeSegment(at), at.getPeriodId() !== this.currentPlayingPeriodId && (this.context.store.dispatch((0, Re.periodSwitchStarted)(at.getPeriodId())), this.eventHandler.dispatchEvent(ge.PlayerEvent.PeriodSwitch, { sourcePeriod: { periodId: this.currentPlayingPeriodId }, targetPeriod: { periodId: at.getPeriodId() } })), this.addDataSegmentToRenderer(at).catch(function(dt) {
              We.logger.warn("Could not add segment to renderer (mimeType: ".concat(at.getMimeType(), ", playbackTime: ").concat(at.getPlaybackTime(), ")"), dt);
            }).then(function() {
              var dt;
              at.isInit() || (dt = We.getSourceStore()) === null || dt === void 0 || dt.dispatch((0, we.removeLoadedRange)(at.getMimeType(), (0, Be.segmentToBufferBlockTimeRange)(at))), We.dataSegmentsPushedMap.set(at.getMimeType(), !at.isInit());
              var ot = ue.BufferRangeHelper.getTotalCommonBufferLength(We.getBufferedRangesMap(We.currentPlayingPeriodId));
              return We.currentPlayingPeriodId = at.getPeriodId(), !(0, Me.isSwitchingBufferBlocks)(We.getSourceStore()) || ot < Xe ? We.addSegmentsFromCacheToRenderer(Je, Xe) : Promise.resolve();
            })) : Promise.resolve();
          }, lt.prototype.dispatchFinishPeriodSwitch = function() {
            var Je;
            this.currentPlayingPeriodId !== this.lastPlayingPeriodId && (this.lastPlayingPeriodId && ((Je = this.context.store) === null || Je === void 0 || Je.dispatch((0, Re.periodSwitchFinished)(this.currentPlayingPeriodId))), this.lastPlayingPeriodId = this.currentPlayingPeriodId);
          }, lt.prototype.hasFinishedLoadingPeriod = function(Je) {
            var Xe, We, Ge = this.hasStopped(), at = (Xe = this.segmentStore) === null || Xe === void 0 ? void 0 : Xe.isLoadingNextBufferBlock(this.currentPlayingBufferBlockId), dt = (We = this.segmentStore) === null || We === void 0 ? void 0 : We.hasSegmentsForBufferBlock(Je);
            return (at || Ge) && !dt;
          }, lt.prototype.pushSegmentsToRenderer = function(Je) {
            var Xe = this, We = this.segmentStore.getBufferBlock(this.currentPlayingBufferBlockId);
            return this.suspendEosSignalling = !0, this.addSegmentsFromCacheToRenderer(We, Je).then(function() {
              var Ge, at;
              Xe.suspendEosSignalling = !1, Xe.isRestartThresholdReached() && !Xe.isBufferClearingOngoing() && Xe.maybeEndStalling(), Xe.hasFinishedLoadingPeriod(We) ? ((Ge = Xe.getSourceStore()) === null || Ge === void 0 || Ge.dispatch((0, we.setLoadingRangeFinished)(!0)), Xe.logger.debug("Finished loading Period: ".concat(Xe.currentPlayingPeriodId, ", signaling EOS")), Xe.hasTemporarilyReopenedMsePriorToBufferBlockSwitch ? Xe.logger.debug("Skipped EOS signaling as a BufferBlock switch is just being executed") : Xe.currentBufferBlockSwitchPromise && (0, Me.isSwitchingBufferBlocks)(Xe.getSourceStore()) ? (Xe.logger.debug("delaying EOS signal until ongoing period switch is completed"), Xe.currentBufferBlockSwitchPromise.then(function() {
                Xe.setEndOfStream(!0).then(function() {
                  return Xe.dispatchFinishPeriodSwitch();
                });
              })) : Xe.setEndOfStream(!0).then(function() {
                return Xe.dispatchFinishPeriodSwitch();
              })) : ((at = Xe.getSourceStore()) === null || at === void 0 || at.dispatch((0, we.setLoadingRangeFinished)(!1)), Xe.dispatchFinishPeriodSwitch());
            });
          }, lt.prototype.updateTimestampOffsets = function() {
            var Je = this;
            this.currentRendererMediaTypes.forEach(function(Xe) {
              Je.renderer.setTimestampOffset(Xe.mimeType, -Xe.timestampOffset);
            });
          }, lt.prototype.canClearBackwardBuffer = function() {
            var Je, Xe, We = this.context.serviceManager.get(ce.ServiceName.PlayerStateService);
            if (!We)
              return !1;
            var Ge = (Je = We.seekingOrTimeshifting) !== null && Je !== void 0 && Je, at = (Xe = this.getSourceStore()) === null || Xe === void 0 ? void 0 : Xe.getState(), dt = at && (0, Pe.getIsTimestampRollingOver)(at);
            return !(this.isEndOfStreamReached || (0, Me.isSwitchingBufferBlocks)(this.getSourceStore()) || Ge || dt);
          }, lt.prototype.checkIfEndOfBufferReached = function(Je) {
            var Xe = this.renderer.getEndOfBufferTime();
            if (Xe === void 0)
              this.renderer.isPaused() || this.startStalling();
            else {
              var We = Xe - Je, Ge = this.renderer.getCurrentTime(!0);
              this.shouldHandleEndOfBuffer(Ge, We) && this.handleEndOfBuffer(Ge);
            }
          }, lt.prototype.shouldHandleEndOfBuffer = function(Je, Xe) {
            return !(0, Me.isSwitchingBufferBlocks)(this.getSourceStore()) && (Xe <= Je || this.manifestService.isLive() && Je === 0);
          }, lt.prototype.resetCurrentTimeOnSegment = function() {
            var Je, Xe = !0;
            this.dataSegmentsPushedMap.forEach(function(We, Ge) {
              Ae.MimeTypeHelper.isVideo(Ge) && (Xe = We, Je = Ge);
            }), Xe || (this.context.videoElement.currentTime = this.context.videoElement.currentTime, this.dataSegmentsPushedMap.set(Je, !0));
          }, lt.prototype.handleEndOfBuffer = function(Je) {
            var Xe, We, Ge = this.isAtEndOfBufferBlock(), at = (Xe = this.segmentStore) === null || Xe === void 0 ? void 0 : Xe.getNextBufferBlock(this.currentPlayingBufferBlockId), dt = !!at;
            if (Ge && dt && (!((We = this.segmentStore) === null || We === void 0) && We.areBufferBlockMediaTypesFinal(at))) {
              var ot = at.getMinCommonStartTime(), et = isFinite(ot) && ot >= Je ? ot : Je;
              this.tryToSwitchBufferBlock(et, at);
            } else
              this.getRemainingTime() > 0 && !this.finishPlayback && (this.startStalling(), this.resetCurrentTimeOnSegment());
          }, lt.prototype.isAtEndOfBufferBlock = function() {
            var Je, Xe = (Je = this.segmentStore) === null || Je === void 0 ? void 0 : Je.getBufferBlock(this.currentPlayingBufferBlockId);
            return !!Xe && (!Xe.getNextSegment() || !!this.segmentStore && this.segmentStore.isLoadingNextBufferBlock(Xe.getId()));
          }, lt.prototype.readyToSeek = function() {
            return this.currentBufferBlockSwitchPromise ? (this.logger.debug("Awaiting ongoing buffer block switch before seek"), this.currentBufferBlockSwitchPromise.then(function() {
            }).catch(function() {
            })) : Promise.resolve();
          }, lt.prototype.shouldBuffersBeClearedOnTimeshift = function(Je) {
            var Xe = this.renderer.getCurrentTime();
            return !this.isTimeInBufferedRange(Je) || Je < Xe;
          }, lt.prototype.isTimeInBufferedRange = function(Je) {
            var Xe, We = (Xe = this.getSourceStore()) === null || Xe === void 0 ? void 0 : Xe.getState();
            if (!We)
              return !1;
            var Ge = this.getBufferedRangesMap((0, Oe.getPlayingPeriodId)(We), !0);
            return ue.BufferRangeHelper.isInBufferedRange(Ge, Je);
          }, lt.prototype.maybeClearBuffers = function(Je, Xe) {
            return Xe === void 0 && (Xe = !1), Xe || this.shouldBuffersBeClearedOnTimeshift(Je) ? this.clearBuffersOnTimeshift() : Promise.resolve();
          }, lt.prototype.setTimeshiftCancelState = function(Je) {
            this.isTimeshiftCancelled = Je;
          }, lt.prototype.clearBuffersOnTimeshift = function() {
            var Je = this;
            return this.context.logger.debug("Clearing buffer on timeshift"), this.clearBuffers().then(function() {
              return Je.isTimeshiftCancelled ? (Je.isTimeshiftCancelled = !1, Promise.reject("cancelled timeshift")) : Promise.resolve();
            });
          }, lt.prototype.setCurrentTime = function(Je, Xe, We, Ge) {
            var at = this;
            We === void 0 && (We = !1), Ge === void 0 && (Ge = !1);
            var dt = Xe || this.manifestService.getPeriodIdForTime(Je), ot = this.segmentStore.getBufferBlockForPlaybackTime(Je), et = this.segmentStore.getBufferBlock(this.currentPlayingBufferBlockId), st = !ot || ot.getId() !== et.getId();
            return this.isStartup && (this.currentPlayingPeriodId = dt), this.seekTarget = Je, this.isStartup || this.isInBufferedRange(Je, dt) || this.startStalling(), We && this.isBufferAvailable() && !this.isBufferClearingOngoing() && this.maybeClearBuffers(Je, Ge).catch(function(mt) {
              return at.logger.debug("Error clearing buffers:", mt);
            }), st ? ot ? this.tryToSwitchBufferBlock(Je, ot) : this.delayBufferBlockSwitch(Je) : (this.delayedBufferBlockSwitchContext = void 0, this.renderer.setCurrentTime(Je).then(function(mt) {
              return at.endStallingAfterSeek(mt);
            }));
          }, lt.prototype.endStallingAfterSeek = function(Je) {
            return this.seekTarget = void 0, this.isRestartThresholdReached() ? this.isCurrentlyStalled && (this.logger.debug("End stalling after seek to ".concat(Je)), this.maybeEndStalling()) : this.logger.debug("Delay ending stall as the restart threshold is not yet reached"), Promise.resolve(Je);
          }, lt.prototype.bufferBlockSwitchErrorHandler = function(Je, Xe) {
            var We, Ge, at, dt, ot, et = (Ge = (We = this.delayedBufferBlockSwitchContext) === null || We === void 0 ? void 0 : We.time) !== null && Ge !== void 0 ? Ge : Xe, st = (0, Ie.isNumber)((at = this.delayedBufferBlockSwitchContext) === null || at === void 0 ? void 0 : at.time) && ((dt = this.segmentStore) === null || dt === void 0 ? void 0 : dt.canSwitchToBufferBlockForTime(et));
            if (this.logger.debug("Buffer block switch failed:", Je), this.currentBufferBlockDeferredReject = new ze.DeferredReject(), st) {
              this.logger.debug("Trying to continue delayed BufferBlock switch to ".concat(et, "..."));
              var mt = this.findBufferBlockForTime(et);
              return this.tryToSwitchBufferBlock(et, mt);
            }
            return (ot = this.getSourceStore()) === null || ot === void 0 || ot.dispatch((0, we.setBufferBlockSwitchOngoing)(!1)), Promise.resolve(Xe);
          }, lt.prototype.findBufferBlockForTime = function(Je) {
            var Xe, We = this.manifestService.getPeriodIdForTime(Je);
            return (Xe = this.segmentStore) === null || Xe === void 0 ? void 0 : Xe.getTargetBufferBlock(Je, We);
          }, lt.prototype.tryToSwitchBufferBlock = function(Je, Xe) {
            var We, Ge, at = this, dt = function() {
            };
            if (this.currentBufferBlockDeferredReject && this.currentBufferBlockDeferredReject.reject("BufferBlock switch interrupted by newest one"), this.currentBufferBlockDeferredReject = new ze.DeferredReject(), (We = this.getSourceStore()) === null || We === void 0 || We.dispatch((0, we.setBufferBlockSwitchOngoing)(!0)), this.delayedBufferBlockSwitchContext && (dt = this.delayedBufferBlockSwitchContext.deferred.resolve), !(!((Ge = this.segmentStore) === null || Ge === void 0) && Ge.canSwitchToBufferBlock(Xe)))
              return this.delayBufferBlockSwitch(Je);
            this.hasTemporarilyReopenedMsePriorToBufferBlockSwitch = !0;
            var ot = this.bufferClearingPromise || Promise.resolve();
            return this.currentBufferBlockSwitchPromise = ot.then(function() {
              return at.setEndOfStream(!1);
            }).then(function() {
              return at.delayedBufferBlockSwitchContext = void 0;
            }).then(function() {
              return at.currentBufferBlockDeferredReject.next(function() {
                return at.clearRendererBuffers();
              });
            }).then(function() {
              return at.currentBufferBlockDeferredReject.next(function() {
                return at.switchOrRestoreBufferBlock(Xe, Je);
              });
            }).then(function(et) {
              return at.hasTemporarilyReopenedMsePriorToBufferBlockSwitch = !1, at.currentBufferBlockDeferredReject = new ze.DeferredReject(), dt(et), et;
            }).catch(function(et) {
              return at.bufferBlockSwitchErrorHandler(et, Je);
            }).finally(function() {
              at.currentBufferBlockSwitchPromise = void 0;
            }), this.currentBufferBlockSwitchPromise;
          }, lt.prototype.switchOrRestoreBufferBlock = function(Je, Xe) {
            var We, Ge;
            return this.hasStreamEnded() ? ((We = this.currentBufferBlockDeferredReject) === null || We === void 0 || We.reject("BufferBlock switch interrupted by source unloading"), Promise.reject("Source was unloaded")) : (0, Ne.isTizen2017)() || !((Ge = this.segmentStore) === null || Ge === void 0) && Ge.shouldSwitchBufferBlock(Je, this.currentPlayingBufferBlockId) ? this.switchBufferBlock(Xe, Je) : this.restorePlayback(Xe, Je);
          }, lt.prototype.delayBufferBlockSwitch = function(Je) {
            (0, Me.isSwitchingBufferBlocks)(this.getSourceStore()) && this.currentBufferBlockDeferredReject && this.currentBufferBlockDeferredReject.reject("BufferBlock switch interrupted by newest one");
            var Xe = this.segmentStore.getAvailablePositionForTime(Je, this.renderer.getCurrentTime());
            return this.delayedBufferBlockSwitchContext && this.delayedBufferBlockSwitchContext.time === Je || (this.delayedBufferBlockSwitchContext && this.delayedBufferBlockSwitchContext.time !== Je && this.delayedBufferBlockSwitchContext.deferred.reject(), this.delayedBufferBlockSwitchContext = { time: Xe, deferred: new Ee.Deferred() }), this.delayedBufferBlockSwitchContext.deferred.promise;
          }, lt.prototype.restorePlayback = function(Je, Xe) {
            var We = this;
            return this.updateTimestampOffsets(), this.isEndOfStreamReached = !1, this.currentPlayingBufferBlockId = Xe.getId(), this.segmentStore.deleteOldBufferBlocks(Xe.getId()), this.hasTemporarilyReopenedMsePriorToBufferBlockSwitch = !1, this.segmentStore.getBufferBlock(Xe.getId()) ? this.currentBufferBlockDeferredReject.next(function() {
              return We.pushSegmentsToRenderer(1 / 0);
            }).then(function() {
              return We.currentBufferBlockDeferredReject.next(function() {
                return We.setCurrentTimeOnRenderer(Je);
              });
            }).then(function(Ge) {
              var at;
              return (at = We.getSourceStore()) === null || at === void 0 || at.dispatch((0, we.setBufferBlockSwitchOngoing)(!1)), We.resumePlaybackIfNotStalledOrPaused(), We.endStallingAfterSeek(Ge);
            }) : (this.logger.debug("Target BufferBlock is no longer available, cancelling BufferBlock switch..."), Promise.reject(ut));
          }, lt.prototype.resumePlaybackIfNotStalledOrPaused = function() {
            var Je = this, Xe = this.getPlayerStateService();
            Xe && (this.isCurrentlyStalled || Xe.isPaused() || this.renderer.play().catch(function(We) {
              Je.logger.debug("play call failed with reason: ".concat(We));
            }));
          }, lt.prototype.shouldRecreateSourceBuffers = function(Je, Xe) {
            var We, Ge = (We = this.segmentStore) === null || We === void 0 ? void 0 : We.getBufferBlock(this.currentPlayingBufferBlockId);
            if (!Ge)
              return !0;
            var at = Ge.getPeriodId() === Je.getPeriodId(), dt = this.currentRendererMediaTypes.length === Xe.length, ot = !(at || dt) || !(0, tt.canReuseSourceBuffer)(Ge, Je, Xe);
            return this.allowUserToOverwriteBufferRecreationDecision(ot, Ge, Je);
          }, lt.prototype.allowUserToOverwriteBufferRecreationDecision = function(Je, Xe, We) {
            var Ge, at, dt = (Ge = this.context) === null || Ge === void 0 ? void 0 : Ge.sourceContext.source, ot = (at = dt == null ? void 0 : dt.options) === null || at === void 0 ? void 0 : at.shouldRecreateSourceBuffersOnPeriodSwitch;
            if (!ot)
              return Je;
            var et = ft(Xe), st = ft(We), mt = ot(et, st, Je);
            return typeof mt == "boolean" ? (this.logger.debug("User overwrote default SourceBuffer recreation strategy from ".concat(Je, " to ").concat(mt) + " for the switch from ".concat(et.periodId, " to ").concat(st.periodId, ".")), mt) : Je;
          }, lt.prototype.switchBufferBlock = function(Je, Xe) {
            var We, Ge = this;
            this.logger.debug("Switching buffer block for time ".concat(Je));
            var at = Xe.getMediaTypesWithoutSubs(), dt = this.maybeRecreateSourceBuffers(Xe, at);
            return this.currentRendererMediaTypes = at, (We = this.getSourceStore()) === null || We === void 0 || We.dispatch((0, we.setLoadingRangeFinished)(!1)), this.currentBufferBlockDeferredReject.next(function() {
              return dt;
            }).then(function() {
              return Ge.currentBufferBlockDeferredReject.next(function() {
                return Ge.restorePlayback(Je, Xe);
              });
            }).then(function(ot) {
              return Ge.currentBufferBlockDeferredReject.next(function() {
                return Ge.pushSegmentsToRenderer(1 / 0).catch(function() {
                  return Ge.context.logger.debug("Could not push segment into renderer");
                });
              }).then(function() {
                return ot;
              });
            });
          }, lt.prototype.maybeRecreateSourceBuffers = function(Je, Xe) {
            return this.shouldRecreateSourceBuffers(Je, Xe) ? (this.logger.debug("recreating the buffers with types", Xe), this.createSourceBuffers(Xe)) : Promise.resolve(0);
          }, lt.prototype.setCurrentTimeOnRenderer = function(Je) {
            var Xe = this, We = this.delayedBufferBlockSwitchContext;
            return this.delayedBufferBlockSwitchContext = void 0, this.currentBufferBlockDeferredReject.next(function() {
              return Xe.renderer.setCurrentTime(Je);
            }).then(function(Ge) {
              return We && We.deferred && We.deferred.resolve(Ge), Ge;
            });
          }, lt.prototype.addMimeTypeAndCodec = function(Je, Xe, We) {
            if (We === void 0 && (We = !1), !Ae.MimeTypeHelper.isAV(Je))
              return !0;
            var Ge = this.renderer.addBuffer(Je, Xe);
            return Ge && ((0, pe.getMetricsState)(this.context.store.getState())[Je] || this.context.store.dispatch((0, be.initializeMetricsForMimeType)(Je, this.context.settings)), We || this.context.store.dispatch((0, be.addMetricsValue)(Je, $e.MetricType.StalledSeconds, 0))), Ge;
          }, lt.prototype.setInitialPeriod = function(Je) {
            this.currentPlayingPeriodId = Je;
          }, lt.prototype.getLowestBufferLevel = function(Je, Xe) {
            var We = this;
            if (!this.isBufferAvailable())
              return 0;
            var Ge = this.currentRendererMediaTypes.map(function(at) {
              return at.mimeType;
            }).map(function(at) {
              return We.getOverallBufferLevel(at, Je, ve.BufferType.ForwardDuration, Xe);
            });
            return Ge.length > 0 ? Math.min.apply(Math, Ge) : 0;
          }, lt.prototype.isStartupThresholdReached = function() {
            var Je = Math.abs(this.manifestService.getTimeShiftBufferDepthSeconds()), Xe = this.bufferSettings.getForwardTargetLevel();
            Je !== 0 && (Xe = Math.min(Xe, Je));
            var We = Math.min(this.settings.STARTUP_THRESHOLD, Xe - this.settings.STARTUP_THRESHOLD_DELTA), Ge = this.getLowestBufferLevel();
            return Ge >= We || Ge >= this.getRemainingTime();
          }, lt.prototype.getInitialPlaybackTime = function() {
            if (this.startupPlaybackTime)
              return this.startupPlaybackTime;
            var Je = this.getCurrentTimeRespectingTarget();
            if (!this.isBufferAvailable())
              return Je;
            if (this.isInBufferedRange(Je))
              return this.startupPlaybackTime = Je;
            var Xe = this.currentRendererMediaTypes.map(function(Ge) {
              return Ge.mimeType;
            }), We = this.segmentStore.getPlaybackTimesForBufferBlock(this.currentPlayingBufferBlockId, Xe);
            return We.some(function(Ge) {
              return !isFinite(Ge);
            }) ? Je : this.startupPlaybackTime = Math.max.apply(Math, We);
          }, lt.prototype.getRemainingTime = function() {
            return this.manifestService.isLive() ? 1 / 0 : this.renderer.getDuration() - this.getCurrentTimeRespectingTarget();
          }, lt.prototype.endStartupPhase = function() {
            if (this.isStartup) {
              var Je = Date.now(), Xe = (0, pe.getMetricsState)(this.context.store.getState()), We = (0, pe.getMetricsLastEntry)(Xe, "default", $e.MetricType.StartTime).value, Ge = (0, Ce.toSeconds)(Je - We);
              this.context.store.dispatch((0, be.addMetricsValue)("default", $e.MetricType.StartupTimeSeconds, Ge)), isNaN(Ge) || this.logger.debug("start up time: ".concat(Ge)), this.isStartup = !1, this.maybeEndStalling();
            }
          }, lt.prototype.resetCurrentTimeInBufferedRange = function(Je) {
            var Xe = this.renderer.getCurrentTime(!0);
            Je.isInit() && Ae.MimeTypeHelper.isVideo(Je.getMimeType()) && this.isCurrentlyStalled && ue.BufferRangeHelper.isInBufferedRange(this.getBufferedRangesMap(this.manifestService.getPeriodIdForTime(Xe)), Xe) && (this.context.videoElement.currentTime = this.context.videoElement.currentTime);
          }, lt.prototype.processDrmInitData = function(Je) {
            var Xe = this;
            Je.getDrmInitData().filter(function(We) {
              var Ge;
              return ((Ge = We.kid) === null || Ge === void 0 ? void 0 : Ge.length) > 0;
            }).forEach(function(We) {
              return Xe.manifestService.setRepresentationDrmKid(Je.getRepresentationId(), We.kid[0]);
            });
          }, lt.prototype.addDataSegmentToRenderer = function(Je) {
            var Xe = this, We = Ae.MimeTypeHelper.extractContentType(Je.getMimeType());
            if (this.activeInitSegments[We] !== Je.getInitSegment()) {
              var Ge = Je.getInitSegment();
              return this.activeInitSegments[We] = Ge, Promise.all([Ge, Je].map(function(at) {
                return Xe.addSegmentToRenderer(at);
              })).then();
            }
            return this.addSegmentToRenderer(Je);
          }, lt.prototype.addSegmentToRenderer = function(Je) {
            var Xe = this;
            return Je.hasDrmInitData() && this.processDrmInitData(Je), this.drmConfigValidPromise.catch(function(We) {
              if (Je.isEncrypted())
                throw (We == null ? void 0 : We.message) !== _e.DrmSetupError.CANCELLED && Xe.context.eventHandler.fireError($t(We)), "DRMConfig failure";
              Xe.logger.debug("Problem ensuring segment, error:", We);
            }).then(function() {
              return Xe.resetCurrentTimeInBufferedRange(Je), Xe.maybeSetTimestampOffsetOnDiscontinuity(Je), Xe.renderer.appendData(Je).catch(function(We) {
                Xe.logger.debug("could not append data to renderer", We);
              });
            });
          }, lt.prototype.maybeSetTimestampOffsetOnDiscontinuity = function(Je) {
            if (!Je.isInit()) {
              var Xe = Je.getSegmentInfo().discontinuitySequenceNumber, We = Je.getMimeType();
              if (Xe !== this.discontinuitySequenceNumbers.get(We)) {
                var Ge = Je.getPresentationTimeOffset();
                if (isFinite(Ge)) {
                  this.renderer.setTimestampOffset(We, -Ge);
                  var at = this.currentRendererMediaTypes.find(function(dt) {
                    return dt.mimeType === We;
                  });
                  at && (at.timestampOffset = Ge, this.updateMediaType(Je.getPeriodId(), at));
                }
                this.discontinuitySequenceNumbers.set(We, Xe);
              }
            }
          }, lt.prototype.isRestartThresholdReached = function() {
            if (!this.bufferSettings)
              return !1;
            var Je = this.settings.RESTART_THRESHOLD;
            (0, Ne.isWebOS)() && (Je = Math.max(Je, 1.5));
            var Xe = this.bufferSettings.getForwardTargetLevel(), We = Math.min(Je, Xe - this.settings.RESTART_THRESHOLD_DELTA, this.getRemainingTime());
            return this.getLowestBufferLevel() >= We;
          }, lt.prototype.isAllowedToStall = function() {
            return !this.isStartup && !(0, Me.isSwitchingBufferBlocks)(this.getSourceStore());
          }, lt.prototype.startStalling = function() {
            this.isAllowedToStall() && this.bufferStallingService.startStalling();
          }, lt.prototype.getPlayerStateService = function() {
            return this.context.serviceManager.get(ce.ServiceName.PlayerStateService);
          }, lt.prototype.isStallingAtGap = function(Je) {
            var Xe = this.getPlayerStateService();
            if (!Xe)
              return !1;
            var We = this.getLowestBufferLevel(Je, !1), Ge = We >= this.settings.RESTART_THRESHOLD, at = We >= this.getRemainingTime() || this.finishPlayback;
            return !Ge && !at && !Xe.seekingOrTimeshifting;
          }, lt.prototype.maybeEndStalling = function() {
            if (this.isCurrentlyStalled)
              if ((0, Me.isSwitchingBufferBlocks)(this.getSourceStore()))
                this.logger.debug("Ending stall was aborted due to buffer block switching");
              else {
                var Je = this.getCurrentTimeRespectingTarget();
                this.isStallingAtGap(Je) ? this.hasFutureCommonBuffer(Je) ? (this.logger.debug("Ending stall at the gap"), this.endStallAtGapCallback()) : this.logger.debug("Cannot unstall yet as playback is stalling at a gap and there is no future common buffer") : this.bufferStallingService.endStalling();
              }
          }, lt.prototype.getCurrentTimeRespectingTarget = function() {
            return this.seekTarget !== void 0 ? this.seekTarget : this.renderer.getCurrentTime();
          }, lt.prototype.getCurrentPlayingBufferBlockId = function() {
            return this.segmentStore.getCurrentBufferBlockId();
          }, lt.prototype.hasPendingSegments = function(Je) {
            return Je = Je || this.getCurrentPlayingBufferBlockId(), this.segmentStore.getFutureBufferBlocks(Je).some(function(Xe) {
              return Xe.hasSegments();
            });
          }, lt.prototype.getOverallBufferLevel = function(Je, Xe, We, Ge) {
            Xe === void 0 && (Xe = this.renderer.getCurrentTime()), We === void 0 && (We = ve.BufferType.ForwardDuration), Ge === void 0 && (Ge = !0), this.isStartup && (Xe = this.getInitialPlaybackTime());
            var at = this.getBufferedRangesMap(this.currentPlayingPeriodId)[Je];
            return at && at.length !== 0 ? (at = Ge ? ue.BufferRangeHelper.mergeRanges(at.concat(ue.BufferRangeHelper.findGapsInRanges(at)), this.settings.GAP_TOLERANCE) : at.filter(function(dt) {
              return dt.start <= Xe && Xe <= dt.end;
            }), ue.BufferRangeHelper.getBufferLevel(at, Xe, We)) : 0;
          }, lt.prototype.hasFutureCommonBuffer = function(Je) {
            return Je === void 0 && (Je = this.renderer.getCurrentTime()), ue.BufferRangeHelper.getCommonBufferedRanges(this.getBufferedRangesMap(this.currentPlayingPeriodId)).some(function(Xe) {
              return Xe.getStart() > Je;
            });
          }, lt.prototype.hasFutureBufferBlockData = function() {
            var Je;
            return !!(!((Je = this.segmentStore) === null || Je === void 0) && Je.getNextBufferBlock(this.currentPlayingBufferBlockId)) || (0, Me.isSwitchingBufferBlocks)(this.getSourceStore());
          }, lt.prototype.isInBufferedRange = function(Je, Xe) {
            var We = Xe || this.manifestService.getPeriodIdForTime(Je);
            return ue.BufferRangeHelper.isInBufferedRange(this.getBufferedRangesMap(We), Je);
          }, lt.prototype.isStarted = function() {
            return this.isAlreadyStarted;
          }, lt.prototype.hasStreamEnded = function() {
            return this.hasStreamEndedInternal;
          }, lt.prototype.subscribeToManifestChange = function() {
            var Je;
            if (!this.unsubscribeFromManifestChange) {
              var Xe = this.getSourceStore();
              Xe !== void 0 && ((Je = Xe.getState()) === null || Je === void 0 ? void 0 : Je.manifest) !== void 0 && (this.unsubscribeFromManifestChange = (0, Te.subscribe)(Xe)(De.getManifest, this.updateTotalDuration, function(We) {
                return (We == null ? void 0 : We.isInitialized) || !1;
              }));
            }
          }, lt.prototype.stop = function(Je) {
            Je === void 0 && (Je = !1), this.finishPlayback = !0, this.isAlreadyStarted = !1, this.isStartup = !1, Je ? (this.renderer.end(), this.hasStreamEndedInternal = !0, this.logger.debug("stopped playback"), this.renderer.off(xe.MediaElementEvent.stalled, this.onVideoElementStalled), this.renderer.off(xe.MediaElementEvent.waiting, this.onVideoElementStalled), this.renderer.off(xe.MediaElementEvent.ended, this.onVideoElementEnded), this.renderer.off(xe.MediaElementEvent.timeupdate, this.onVideoElementTimeUpdate), this.renderer.off(xe.MediaElementEvent.currenttimenotadvancing, this.onTimeNotAdvancing), this.unsubscribeFromManifestChange && (this.unsubscribeFromManifestChange(), this.unsubscribeFromManifestChange = void 0), this.unsubscribeFromStoreStoppedListener !== void 0 && (this.unsubscribeFromStoreStoppedListener(), this.unsubscribeFromStoreStoppedListener = void 0), this.clearBufferMaxSizeChangedSubscription(), this.dataSegmentsPushedMap.clear()) : this.maybeEndStalling();
          }, lt.prototype.hasStopped = function() {
            return this.finishPlayback;
          }, lt.prototype.clearBufferMaxSizeChangedSubscription = function() {
            var Je = this;
            Object.keys(this.bufferMaxSizeChangedSubscriptionMap).forEach(function(Xe) {
              return Je.unsubscribeFromBufferMaxSizeChanged(Xe);
            });
          }, lt.prototype.restart = function() {
            this.finishPlayback = !1, this.isAlreadyStarted || (this.isAlreadyStarted = !0, this.renderer.on(xe.MediaElementEvent.stalled, this.onVideoElementStalled), this.renderer.on(xe.MediaElementEvent.waiting, this.onVideoElementStalled), this.renderer.on(xe.MediaElementEvent.ended, this.onVideoElementEnded), this.renderer.on(xe.MediaElementEvent.timeupdate, this.onVideoElementTimeUpdate), this.renderer.on(xe.MediaElementEvent.currenttimenotadvancing, this.onTimeNotAdvancing)), this.hasStreamEndedInternal = !1;
          }, lt.prototype.dispose = function() {
            var Je, Xe;
            this.stop(!0), this.renderer = null, this.eventHandler = null, this.settings = null, this.bufferSettings = null, this.eventHandler = null, this.segmentStore = void 0, this.activeInitSegments = null, (Je = this.unsubscribeFromStoreSeekedListener) === null || Je === void 0 || Je.call(this), (Xe = this.getSourceStore()) === null || Xe === void 0 || Xe.dispatch((0, we.resetLoadedRanges)()), this.bufferRangesCache.dispose(), this.currentRendererMediaTypes = [], this.clearBufferMaxSizeChangedSubscription(), this.drmConfigValidPromise = null, this.bufferStallingService = (0, he.dispose)(this.bufferStallingService);
          }, lt.prototype.changeBufferType = function(Je, Xe) {
            var We, Ge, at = this.currentRendererMediaTypes.find(function(dt) {
              return Ae.MimeTypeHelper.getMediaType(dt.mimeType) === Ae.MimeTypeHelper.getMediaType(Je);
            });
            return at && (this.currentRendererMediaTypes.splice(this.currentRendererMediaTypes.indexOf(at), 1), this.currentRendererMediaTypes.push({ mimeType: Je, codec: Xe, timestampOffset: 0 }), this.unsubscribeFromBufferMaxSizeChanged(at.mimeType), (Ge = this.getSourceStore()) === null || Ge === void 0 || Ge.dispatch((0, we.resetLoadedRanges)(at.mimeType))), this.subscribeToBufferMaxSizeChanged(Je), this.segmentStore.changeMediaType(Je, at == null ? void 0 : at.mimeType), this.activeInitSegments = {}, at ? this.renderer.changeBufferType(Je, Xe) : Promise.resolve(((We = {})[Je] = Xe, We));
          }, lt.prototype.addRequiredMediaType = function(Je, Xe) {
            this.segmentStore.addRequiredMediaType(Je, Xe);
          }, lt.prototype.updateMediaType = function(Je, Xe) {
            this.segmentStore.updateMediaType(Je, Xe);
          }, lt.prototype.areBufferBlockMediaTypesFinalForPeriod = function(Je) {
            var Xe, We;
            return (We = (Xe = this.segmentStore) === null || Xe === void 0 ? void 0 : Xe.areBufferBlockMediaTypesFinalForPeriod(Je)) !== null && We !== void 0 && We;
          }, lt.prototype.clearCacheForMimeType = function(Je) {
            var Xe;
            (Xe = this.getSourceStore()) === null || Xe === void 0 || Xe.dispatch((0, we.resetLoadedRanges)(Je)), this.segmentStore.clearSegments(Je);
          }, lt.prototype.clearCache = function() {
            var Je, Xe = this;
            Object.keys((0, Ke.getStreamTimeline)((Je = this.getSourceStore()) === null || Je === void 0 ? void 0 : Je.getState())).filter(function(We) {
              return Ae.MimeTypeHelper.isAV(We);
            }).forEach(function(We) {
              return Xe.clearCacheForMimeType(We);
            });
          }, lt.prototype.isBufferClearingOngoing = function() {
            return this.bufferClearingPromise !== void 0;
          }, lt.prototype.clearBuffers = function() {
            var Je = this;
            return this.bufferClearingPromise ? (this.logger.debug("Skipping buffer clearing as it is already ongoing"), this.bufferClearingPromise) : (this.startStalling(), this.clearCache(), this.bufferClearingPromise = this.setEndOfStream(!1).then(function() {
              return Je.clearRendererBuffers();
            }), this.bufferClearingPromise.finally(function() {
              return Je.bufferClearingPromise = void 0;
            }), this.bufferClearingPromise);
          }, lt.prototype.clearRendererBuffers = function() {
            var Je = this;
            if (!this.isBufferAvailable())
              return Promise.resolve();
            var Xe = this.currentRendererMediaTypes.map(function(We) {
              return Je.clearBuffer(We.mimeType);
            });
            return Promise.all(Xe).then(function() {
            });
          }, lt.prototype.clearBuffer = function(Je) {
            var Xe = this;
            return this.renderer.removeData(Je).catch(function(We) {
              return Xe.logger.debug("Error clearing ".concat(Je, " buffer:"), We);
            });
          }, lt.prototype.isBufferAvailable = function() {
            return this.currentRendererMediaTypes.length > 0;
          }, lt;
        }();
        function $t(lt) {
          var Je;
          return Ue.ModuleManager.has(ke.ModuleName.DRM) ? (lt == null ? void 0 : lt.message) === _e.DrmSetupError.MISSING_CONFIGURATION ? new le.PlayerError(fe.ErrorCode.DRM_MISSING_CONFIGURATION, { reason: lt.message }) : new le.PlayerError(fe.ErrorCode.DRM_NO_KEY_SYSTEM, { reason: (Je = lt == null ? void 0 : lt.message) !== null && Je !== void 0 ? Je : lt }) : new Le.PlayerModuleMissingError(ke.ModuleName.DRM);
        }
        function ft(lt) {
          return { periodId: lt.getPeriodId(), contentInformation: lt.getMediaTypes().map(function(Je) {
            return { codec: Je.codec, mimeType: Je.mimeType, isDrmProtected: lt.getSegregationCriteria(Je.mimeType).encryption === nt.EncryptionState.Encrypted };
          }) };
        }
        function pt(lt, Je) {
          var Xe = (0, Ze.getTrackIdentifier)(lt.getSegmentInfo()), We = lt.getPlaybackTimeRange();
          We && (Je == null || Je.dispatch((0, Ve.removeStreamTimeRange)(Xe, We, Ze.StreamTimeRangeType.Loading))), Je == null || Je.dispatch((0, we.addLoadedRange)(Xe, (0, Be.segmentToBufferBlockTimeRange)(lt)));
        }
        ie.BufferController = yt;
      }, 16492: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.BufferRangesCache = void 0;
        var ae = ne(18665), ue = ne(33669), _e = ne(3464), fe = ne(28337), le = function() {
          function se(oe, ce) {
            var he = this;
            this.context = oe, this.segmentStore = ce, this.sourceStore = this.getSourceStore(), this.unsubscribeToStoreChange = (0, _e.subscribe)(oe.store)(fe.sourceIdentifiersSelector, function() {
              return he.onSourceIdentifierChanged();
            }, function(ge, ve) {
              return !!ge.includes(he.context.sourceContext.sourceIdentifier) && (0, fe.hasASourceStoreIdentifierChanged)(ge, ve);
            }), this.subscribeToBufferChange(), this.setNewCache((0, ue.getBufferState)(this.sourceStore.getState()));
          }
          return se.prototype.onSourceIdentifierChanged = function() {
            this.sourceStore = this.getSourceStore(), this.sourceStore ? (this.subscribeToBufferChange(), this.setNewCache((0, ue.getBufferState)(this.sourceStore.getState()))) : this.unsubscribeToBufferChange();
          }, se.prototype.getSourceStore = function() {
            return this.context.serviceManager.get(ae.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, se.prototype.unsubscribeToBufferChange = function() {
            this.unsubscribeToBufferRangeChange && this.unsubscribeToBufferRangeChange(), this.unsubscribeToBufferRangeChange = void 0, this.unsubscribeToStoreChange = void 0;
          }, se.prototype.subscribeToBufferChange = function() {
            var oe = this;
            this.unsubscribeToBufferChange(), this.unsubscribeToBufferRangeChange = (0, _e.subscribe)(this.sourceStore)(function(ce) {
              return (0, ue.getBufferState)(ce);
            }, function(ce) {
              return oe.setNewCache(ce);
            }, ue.hasBufferRangesChanged);
          }, se.prototype.setNewCache = function(oe) {
            this.cachedBufferRanges = { overallBufferRanges: (0, ue.getBufferRangesMap)(this.segmentStore, oe, this.context.settings.GAP_TOLERANCE) };
          }, se.prototype.getRanges = function(oe) {
            return this.unsubscribeToBufferRangeChange !== void 0 && this.cachedBufferRanges !== void 0 && Object.keys(this.cachedBufferRanges.overallBufferRanges).length !== 0 || this.setNewCache(oe), this.cachedBufferRanges.overallBufferRanges;
          }, se.prototype.dispose = function() {
            this.unsubscribeToBufferChange(), this.unsubscribeToStoreChange && (this.unsubscribeToStoreChange(), this.unsubscribeToStoreChange = void 0), this.cachedBufferRanges = void 0;
          }, se;
        }();
        ie.BufferRangesCache = le;
      }, 15109: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.BufferStallingService = void 0;
        var ae = ne(76420), ue = ne(26905), _e = function() {
          function fe(le, se, oe) {
            this.playerStateService = le, this.logger = se, this.renderer = oe;
          }
          return fe.prototype.startStalling = function() {
            this.isRendererStalling() || (this.logger.debug("Stalling playback at ".concat(this.renderer.getCurrentTime(!0))), this.logger.insane("Video element stall started in state: ".concat(this.playerStateService.playbackState)), this.playerStateService.setIsRendererStalling(!0), this.playerStateService.isPlaying() && (this.logger.insane("Call pause on renderer"), this.renderer.pause()));
          }, fe.prototype.endStalling = function() {
            var le = this;
            if (this.isRendererStalling()) {
              this.playerStateService.setIsRendererStalling(!1);
              var se = [ae.PlaybackState.Play, ae.PlaybackState.Playing].includes(this.playerStateService.playbackState);
              this.logger.debug("Unstalling and ".concat(se ? "" : "not ", "restarting playback")), se && (!this.playerStateService.seekingOrTimeshifting && (0, ue.shouldResetCurrentTimeAfterBufferUnderrun)() && (this.logger.debug("Resetting current time before unstalling"), this.renderer.setCurrentTime(this.renderer.getCurrentTime())), this.renderer.play().catch(function(oe) {
                le.logger && le.logger.debug("Play after unstalling failed with reason: ".concat(oe));
              }));
            }
          }, fe.prototype.isRendererStalling = function() {
            return this.playerStateService.getIsRendererStalling();
          }, fe.prototype.dispose = function() {
            this.logger = null, this.playerStateService = null, this.renderer = null;
          }, fe;
        }();
        ie.BufferStallingService = _e;
      }, 27076: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.DeferredReject = void 0;
        var ne = function() {
          function ae() {
            this.rejected = !1;
          }
          return ae.prototype.reject = function(ue) {
            this.rejected = !0, this.rejectMessage = ue;
          }, ae.prototype.next = function(ue) {
            return this.rejected ? Promise.reject(this.rejectMessage) : ue();
          }, ae;
        }();
        ie.DeferredReject = ne;
      }, 42346: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Me) {
            for (var Ae, Ne = 1, Ce = arguments.length; Ne < Ce; Ne++)
              for (var Ie in Ae = arguments[Ne])
                Object.prototype.hasOwnProperty.call(Ae, Ie) && (Me[Ie] = Ae[Ie]);
            return Me;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentStore = ie.INITIAL_BUFFER_BLOCK_ID = void 0;
        var ue = ne(96873), _e = ne(33669), fe = ne(27279), le = ne(42283), se = ne(3941), oe = ne(80043), ce = ne(79814), he = ne(91520), ge = ne(16368), ve = ne(16280), me = ne(22645), be = ne(55937), pe = ne(73022), $e = ne(19724);
        ie.INITIAL_BUFFER_BLOCK_ID = 0;
        var ye = 0.01, Se = function() {
          function Me(Ae, Ne) {
            this.context = Ae, this.delayedSegmentQueue = [], this.requiredMediaTypes = {}, this.delayedMediaTypeToUpdate = {}, this.delayedMediaTypeToSet = {};
            var Ce = new be.BufferBlock(ie.INITIAL_BUFFER_BLOCK_ID);
            this.requiredMediaTypes = {}, this.segregation = new $e.Segregation(this.requiredMediaTypes, Ne), this.bufferBlocks = [Ce];
          }
          return Me.prototype.getBufferBlockByPeriodId = function(Ae) {
            return this.bufferBlocks.find(function(Ne) {
              return Ne.getPeriodId() === Ae;
            });
          }, Me.prototype.hasSegmentsForBufferBlock = function(Ae) {
            return this.getAllSegmentsFromBufferBlock(Ae).hasNext();
          }, Me.prototype.hasDataSegmentsForBufferBlock = function(Ae) {
            return Object.keys(Ae.mediaTypes).filter(function(Ne) {
              return ce.MimeTypeHelper.isAV(Ne);
            }).every(function(Ne) {
              return Ae.hasDataSegments(Ne);
            });
          }, Me.prototype.getTargetBufferBlock = function(Ae, Ne) {
            return this.getBufferBlockForPlaybackTime(Ae) || this.getClosestFutureBufferBlock(Ae) || this.getBufferBlockByPeriodId(Ne);
          }, Me.prototype.canSwitchToBufferBlock = function(Ae) {
            if (!Ae)
              return !1;
            var Ne = this.areBufferBlockMediaTypesFinal(Ae);
            return this.hasDataSegmentsForBufferBlock(Ae) && Ne;
          }, Me.prototype.canSwitchToBufferBlockForTime = function(Ae) {
            var Ne = this.getBufferBlockForPlaybackTime(Ae);
            return this.canSwitchToBufferBlock(Ne);
          }, Me.prototype.areBufferBlockMediaTypesFinalForPeriod = function(Ae) {
            var Ne = this.getBufferBlockByPeriodId(Ae);
            return this.areBufferBlockMediaTypesFinal(Ne);
          }, Me.prototype.areBufferBlockMediaTypesFinal = function(Ae) {
            var Ne = this;
            if (!Ae || !Ae.mediaTypes || Object.keys(Ae.mediaTypes).length === 0)
              return !1;
            var Ce = Ae.getPeriodId();
            if (this.requiredMediaTypes[Ce] === void 0)
              return !1;
            var Ie = Object.keys(Ae.mediaTypes);
            return Object.keys(this.requiredMediaTypes[Ce]).filter(function(xe) {
              return ce.MimeTypeHelper.isAV(xe);
            }).every(function(xe) {
              var Ue;
              return Ie.includes(xe) && ((Ue = Ne.requiredMediaTypes[Ce][xe]) === null || Ue === void 0 ? void 0 : Ue.codec);
            });
          }, Me.prototype.addRequiredMediaType = function(Ae, Ne) {
            var Ce = this.getBufferBlockByPeriodId(Ae);
            this.requiredMediaTypes[Ae] || (this.requiredMediaTypes[Ae] = {}), this.requiredMediaTypes[Ae][Ne] || (this.requiredMediaTypes[Ae][Ne] = { mimeType: Ne, codec: null, timestampOffset: 0 }), Ce ? Ce.mediaTypes[Ne] || Ce.addMediaType({ mimeType: Ne, codec: null, timestampOffset: 0 }) : (this.delayedMediaTypeToSet[Ae] || (this.delayedMediaTypeToSet[Ae] = {}), this.delayedMediaTypeToSet[Ae][Ne] = { mimeType: Ne, codec: null, timestampOffset: 0 });
          }, Me.prototype.changeMediaType = function(Ae, Ne) {
            var Ce = this, Ie = Object.keys(this.requiredMediaTypes), xe = Ne;
            Ie.forEach(function(Ue) {
              Ne || (xe = Object.keys(Ce.requiredMediaTypes[Ue]).find(function(ke) {
                return ce.MimeTypeHelper.getMediaType(ke) === ce.MimeTypeHelper.getMediaType(Ae);
              })), Ce.removeRequiredMediaType(Ue, xe), Ce.addRequiredMediaType(Ue, Ae);
            });
          }, Me.prototype.removeRequiredMediaType = function(Ae, Ne) {
            if (this.requiredMediaTypes[Ae]) {
              delete this.requiredMediaTypes[Ae][Ne];
              var Ce = this.getBufferBlockByPeriodId(Ae);
              Ce && Ce.removeMediaType(Ne);
            }
            this.delayedMediaTypeToSet[Ae] && delete this.delayedMediaTypeToSet[Ae][Ne], this.clearSegments(Ne);
          }, Me.prototype.updateRequiredMediaTypes = function(Ae, Ne) {
            var Ce;
            if (this.requiredMediaTypes[Ae]) {
              var Ie = this.requiredMediaTypes[Ae][Ne.mimeType];
              this.requiredMediaTypes[Ae][Ne.mimeType] = ae(ae({}, Ie), Ne);
            } else
              this.requiredMediaTypes[Ae] = ((Ce = {})[Ne.mimeType] = Ne, Ce);
          }, Me.prototype.updateMediaType = function(Ae, Ne) {
            var Ce;
            this.updateRequiredMediaTypes(Ae, Ne);
            var Ie = this.getBufferBlockByPeriodId(Ae);
            Ie != null && Ie.hasMediaType(Ne.mimeType) ? Ie.updateMediaTypeForMimeType(Ne) : this.delayedMediaTypeToUpdate[Ae] = ae(ae({}, this.delayedMediaTypeToUpdate[Ae] || {}), ((Ce = {})[Ne.mimeType] = Ne, Ce));
          }, Me.prototype.updateDelayedMediaType = function(Ae) {
            var Ne = Ae.getPeriodId(), Ce = Ae.getMimeType();
            this.delayedMediaTypeToSet[Ne] && this.delayedMediaTypeToSet[Ne][Ce] && (this.addRequiredMediaType(Ne, Ce), delete this.delayedMediaTypeToSet[Ne][Ce]), this.delayedMediaTypeToUpdate[Ne] && this.delayedMediaTypeToUpdate[Ne][Ce] && (this.updateMediaType(Ne, this.delayedMediaTypeToUpdate[Ne][Ce]), delete this.delayedMediaTypeToUpdate[Ne][Ce]);
          }, Me.prototype.findBestMatchingBufferBlockForSegment = function(Ae, Ne) {
            var Ce = this;
            if (this.bufferBlocks.length === 1 && this.segregation.canAddSegmentToBufferBlock(Ae, this.bufferBlocks[0], Ne))
              return this.bufferBlocks[0];
            var Ie = this.bufferBlocks.reduce(function(Re, Oe) {
              return Ce.segregation.canAddSegmentToBufferBlock(Ae, Oe, Ne) && (!Re || Oe.getMinDistanceFromBufferBlock(Ae) < Re.getMinDistanceFromBufferBlock(Ae)) ? Oe : Re;
            }, void 0);
            if (Ie) {
              var xe = Ie.getCommonPlaybackTimeRanges(), Ue = Ae.getPlaybackTime(), ke = we(this.bufferBlocks.filter(function(Re) {
                return Re !== Ie;
              })), Le = Te(xe.start, ke), De = Pe(xe.end, ke);
              if (Le <= Ue && Ue <= De && !this.isTimeInOrBeyondFutureIncompatibleBufferBlock(Ue, Ie, ke))
                return Ie;
            }
          }, Me.prototype.isTimeInOrBeyondFutureIncompatibleBufferBlock = function(Ae, Ne, Ce) {
            return Ce.filter(function(Ie) {
              return isFinite(Ie.range.start) && Ie.range.start > Ne.getCommonPlaybackTimeRanges().start && isFinite(Ie.range.end) && Ie.range.end > Ne.getCommonPlaybackTimeRanges().end;
            }).some(function(Ie) {
              var xe = Ie.range.start <= Ae && Ae <= Ie.range.end, Ue = Ae > Ie.range.end;
              return xe || Ue;
            });
          }, Me.prototype.areAllMimeTypesAvailableInQueue = function(Ae) {
            var Ne = this;
            return Object.keys(this.requiredMediaTypes[se.DEFAULT_PERIOD_ID]).filter(function(Ce) {
              return ce.MimeTypeHelper.isAV(Ce);
            }).every(function(Ce) {
              return Ne.delayedSegmentQueue.some(function(Ie) {
                return Ie.getSegmentInfo().discontinuitySequenceNumber === Ae && Ie.getMimeType() === Ce;
              });
            });
          }, Me.prototype.areDiscontinuitiesMisaligned = function(Ae) {
            var Ne, Ce = (Ne = (0, fe.getSourceState)(this.context)) === null || Ne === void 0 ? void 0 : Ne.hls;
            return !!Ce && (0, he.ModuleManager.get(ge.ModuleName.HLS).selectors.areDiscontinuitiesMisaligned)(Ce, Object.keys(this.requiredMediaTypes[se.DEFAULT_PERIOD_ID]).filter(function(Ie) {
              return ce.MimeTypeHelper.isAV(Ie);
            }), Ae.getDuration());
          }, Me.prototype.addSegment = function(Ae) {
            var Ne = this, Ce = Ae.getSegmentInfo(), Ie = Ce.codecs, xe = Ce.discontinuitySequenceNumber;
            if (!(0, le.isAVMuxedTogether)(Ie) && Ee(Ae, this.bufferBlocks))
              if (this.delayedSegmentQueue.push(Ae), this.context.logger.debug("[SegmentStore] Delay adding ".concat(Ae.getMimeType(), " segment of disco ").concat(xe, " until another segment of the other type is available"), { url: Ae.getUrl() }), this.areAllMimeTypesAvailableInQueue(xe)) {
                var Ue = this.delayedSegmentQueue.filter(function(ke) {
                  return ke.getSegmentInfo().discontinuitySequenceNumber === xe;
                });
                this.context.logger.debug("[SegmentStore] Discontinuity ".concat(xe, " is complete: adding segments to store")), this.pushToBufferBlocks(Ue), this.delayedSegmentQueue = this.delayedSegmentQueue.filter(function(ke) {
                  return ke.getSegmentInfo().discontinuitySequenceNumber !== xe;
                });
              } else
                this.areDiscontinuitiesMisaligned(Ae) && (this.context.logger.debug("[SegmentStore] Detected misaligned discontinuities: flushing all delayed segments"), this.delayedSegmentQueue.forEach(function(ke) {
                  return Ne.pushToBufferBlocks([ke]);
                }), this.delayedSegmentQueue = []);
            else
              this.pushToBufferBlocks([Ae]);
          }, Me.prototype.pushToBufferBlocks = function(Ae) {
            var Ne = this, Ce = Ae.reduce(function(Ie, xe) {
              var Ue = Ne.segregation.getSegregationCriteria(xe), ke = Ne.findBestMatchingBufferBlockForSegment(xe, Ue);
              return Ie === null ? ke : ke !== Ie ? void 0 : ke;
            }, null);
            Ce || (Ce = this.createNewBufferBlock(), this.bufferBlocks.push(Ce)), Ae.forEach(function(Ie) {
              var xe = Ne.segregation.getSegregationCriteria(Ie);
              Ne.context.logger.debug("[SegmentStore] Added ".concat(Ie.getMimeType(), " segment to BB with ID ").concat(Ce.getId()), { segment: Ie.getUrl(), segmentCriteria: xe });
              var Ue = (0, fe.getSourceStore)(Ne.context), ke = (0, me.getTrackIdentifier)(Ie.getSegmentInfo());
              Ue == null || Ue.dispatch((0, ue.removeLoadedRange)(ke, (0, ve.segmentToBufferBlockTimeRange)(Ie))), Ce.addSegment(Ie), Ue == null || Ue.dispatch((0, ue.addLoadedRange)(ke, (0, ve.segmentToBufferBlockTimeRange)(Ie))), Ce.getSegregationCriteria(Ie.getMimeType()) || Ce.setSegregationCriteria(xe, Ie.getMimeType()), Ne.updateDelayedMediaType(Ie);
            });
          }, Me.prototype.getNewBufferBlockId = function() {
            var Ae = this.bufferBlocks[this.bufferBlocks.length - 1];
            return Ae ? Ae.getId() + 1 : ie.INITIAL_BUFFER_BLOCK_ID;
          }, Me.prototype.createNewBufferBlock = function() {
            var Ae = this.getNewBufferBlockId();
            return this.context.logger.debug("[SegmentStore] creating new BB with ID ".concat(Ae)), new be.BufferBlock(Ae);
          }, Me.prototype.getMediaTypes = function(Ae) {
            var Ne = this;
            return Ae && this.requiredMediaTypes[Ae] ? Object.keys(this.requiredMediaTypes[Ae]).map(function(Ce) {
              return Ne.requiredMediaTypes[Ae][Ce];
            }) : [];
          }, Me.prototype.getAllBufferBlocks = function() {
            return this.bufferBlocks;
          }, Me.prototype.getCurrentBufferBlockId = function() {
            var Ae, Ne = this.bufferBlocks[0];
            return (Ae = Ne == null ? void 0 : Ne.getId()) !== null && Ae !== void 0 ? Ae : ie.INITIAL_BUFFER_BLOCK_ID;
          }, Me.prototype.deleteOldBufferBlocks = function(Ae) {
            this.bufferBlocks = this.bufferBlocks.filter(function(Ne) {
              return Ne.getId() >= Ae && Ne.getAllSegments().length > 0;
            });
          }, Me.prototype.getActiveBufferBlock = function() {
            var Ae;
            return (Ae = this.getBufferBlock(this.getCurrentBufferBlockId())) !== null && Ae !== void 0 ? Ae : null;
          }, Me.prototype.getBufferBlock = function(Ae) {
            return this.bufferBlocks.find(function(Ne) {
              return Ne.getId() === Ae;
            });
          }, Me.prototype.getBufferBlockForSegment = function(Ae) {
            return this.getBufferBlock(Ae.getBufferBlockId());
          }, Me.prototype.getBufferBlockForPlaybackTime = function(Ae) {
            var Ne = this, Ce = this.bufferBlocks.filter(function(Ie) {
              var xe = Ae === 0 ? Ne.getSmallestMaxSegmentDuration(Ie) - ye : ye;
              return Object.keys(Ie.mediaTypes).filter(function(Ue) {
                return ce.MimeTypeHelper.isAV(Ue);
              }).every(function(Ue) {
                var ke, Le;
                return ((ke = Ie.getPlaybackTimeRange(Ue)) === null || ke === void 0 ? void 0 : ke.start) <= Ae + xe && ((Le = Ie.getPlaybackTimeRange(Ue)) === null || Le === void 0 ? void 0 : Le.end) >= Ae;
              });
            });
            return Ce[Ce.length - 1];
          }, Me.prototype.getClosestFutureBufferBlock = function(Ae) {
            return this.bufferBlocks.filter(function(Ne) {
              return Ne.getMinCommonStartTime() >= Ae;
            }).sort(function(Ne, Ce) {
              return Ne.getMinCommonStartTime() - Ce.getMinCommonStartTime();
            })[0];
          }, Me.prototype.getNextSegment = function() {
            var Ae, Ne;
            return (Ne = (Ae = this.getActiveBufferBlock()) === null || Ae === void 0 ? void 0 : Ae.getNextSegment()) !== null && Ne !== void 0 ? Ne : null;
          }, Me.prototype.removeSegment = function(Ae) {
            var Ne = this.getBufferBlockForSegment(Ae);
            Ne && Ne.removeSegment(Ae), this.delayedSegmentQueue = this.delayedSegmentQueue.filter(function(Ce) {
              return Ce !== Ae;
            });
          }, Me.prototype.getAllSegmentsFromBufferBlock = function(Ae, Ne) {
            if (!Ae)
              return oe.EmptyIterator.getInstance();
            var Ce = Ae.getAllSegments();
            return Ne ? new oe.FilterIterator(new oe.ArrayIterator(Ce), function(Ie) {
              return Ie.getMimeType() === Ne;
            }) : new oe.ArrayIterator(Ce);
          }, Me.prototype.getNextBufferBlock = function(Ae) {
            return this.bufferBlocks.find(function(Ne) {
              return Ne.getId() > Ae;
            });
          }, Me.prototype.getFutureBufferBlocks = function(Ae) {
            return this.bufferBlocks.filter(function(Ne) {
              return Ne.getId() >= Ae;
            });
          }, Me.prototype.getPrecedingSegments = function(Ae, Ne) {
            var Ce = this.delayedSegmentQueue.filter(function(Ie) {
              return (0, be.isPrecedingSegment)(Ie, Ae, Ne);
            });
            return this.bufferBlocks.flatMap(function(Ie) {
              return Ie.getPrecedingSegments(Ae, Ne);
            }).concat(Ce);
          }, Me.prototype.clearSegments = function(Ae) {
            this.context.logger.debug("[SegmentStore] clearing all segments for ".concat(Ae)), this.bufferBlocks.forEach(function(Ne) {
              return Ne.clearSegments(Ae);
            }), this.delayedSegmentQueue = this.delayedSegmentQueue.filter(function(Ne) {
              return Ne.getMimeType() !== Ae;
            });
          }, Me.prototype.getSmallestMaxSegmentDuration = function(Ae) {
            return Ae && Ae.hasMaxSegmentDurations() ? Ae.getMinMaxSegmentDuration() : -1;
          }, Me.prototype.getSmallestSafeBufferSize = function(Ae, Ne) {
            var Ce = this.getBufferBlockForPlaybackTime(Ae);
            return Ce != null && Ce.hasMaxSegmentDuration(Ne) ? Ce.getMaxSegmentDuration(Ne) + 1 : 1;
          }, Me.prototype.getAvailablePositionForTime = function(Ae, Ne) {
            var Ce = Ae;
            if (Ne && Ae > Ne) {
              var Ie = this.getBufferBlockForPlaybackTime(Ae);
              Ie || (Ie = this.getClosestFutureBufferBlock(Ae)) && (Ce = Ie.getMinCommonStartTime());
            }
            return Ce;
          }, Me.prototype.getPlaybackTimesForBufferBlock = function(Ae, Ne) {
            var Ce = this, Ie = this.getBufferBlock(Ae);
            return Ne.map(function(xe) {
              var Ue = new oe.FilterIterator(Ce.getAllSegmentsFromBufferBlock(Ie, xe), function(ke) {
                return !ke.isInit();
              });
              return Ue.hasNext() ? Ue.next().getPlaybackTime() : -1 / 0;
            });
          }, Me.prototype.isLoadingNextBufferBlock = function(Ae) {
            var Ne = this.getNextBufferBlock(Ae);
            return !!Ne && this.hasDataSegmentsForBufferBlock(Ne);
          }, Me.prototype.shouldSwitchBufferBlock = function(Ae, Ne) {
            return !(0, pe.areBufferBlocksEqual)(Ae, this.getBufferBlock(Ne));
          }, Me.prototype.getSegmentStoreRangesMap = function(Ae, Ne) {
            var Ce = {};
            return Ne.forEach(function(Ie) {
              return Ce[Ie] = [];
            }), this.getFutureBufferBlocks(this.getCurrentBufferBlockId()).map(function(Ie) {
              return Ie.getId();
            }).concat(1 / 0).map(function(Ie) {
              return (0, _e.getBufferBlockLoadedRanges)(Ae, Ie);
            }).forEach(function(Ie) {
              return Object.keys(Ie).forEach(function(xe) {
                return Ce[xe].push(Ie[xe]);
              });
            }), Ce;
          }, Me;
        }();
        function we(Me) {
          return Me.map(function(Ae) {
            return { range: Ae.getCommonPlaybackTimeRanges(), block: Ae };
          }).sort(function(Ae, Ne) {
            return Ae.range.start - Ne.range.start;
          });
        }
        function Pe(Me, Ae) {
          return Ae.reduce(function(Ne, Ce) {
            return Ce.range.start >= Me ? Math.min(Ce.range.start, Ne) : Ne;
          }, 1 / 0);
        }
        function Te(Me, Ae) {
          return Ae.reduce(function(Ne, Ce) {
            return Ce.range.end <= Me ? Math.max(Ce.range.start, Ne) : Ne;
          }, -1 / 0);
        }
        function Ee(Me, Ae) {
          var Ne = Me.getSegmentInfo().discontinuitySequenceNumber;
          return Ne !== void 0 && !Ae.some(function(Ce) {
            return Ce.hasTrackedDiscontinuity(Ne);
          });
        }
        ie.SegmentStore = Se;
      }, 19724: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.Segregation = void 0, ie.areSegregationCriteriaEqual = oe, ie.canReuseSourceBuffer = he;
        var ae = ne(11399), ue = ne(13533), _e = ne(42283), fe = ne(56435), le = ne(55937), se = function() {
          function Ce(Ie, xe) {
            this.requiredMediaTypes = Ie, this.settings = xe, this.requiredMediaTypes = Ie;
          }
          return Ce.prototype.isRequiredMimeType = function(Ie, xe) {
            return xe.getPeriodId() === void 0 || !!(this.requiredMediaTypes[xe.getPeriodId()] && this.requiredMediaTypes[xe.getPeriodId()][Ie.getMimeType()]);
          }, Ce.prototype.getSegregationCriteria = function(Ie) {
            var xe, Ue = { encryption: ce(Ie), codec: _e.CodecStringHelper.extractCodec(Ie.getCodec()), periodId: Ie.getPeriodId() };
            if (((0, fe.isTizen2016)() || (0, fe.isTizen2017)() || (0, fe.isWebOS)() || (0, fe.isPlayStation4)()) && this.settings.HLS_CLEAR_BUFFERS_ON_DISCONTINUITY_SWITCHES) {
              var ke = (xe = Ie.getSegmentInfo()) === null || xe === void 0 ? void 0 : xe.discontinuitySequenceNumber;
              ke != null && (Ue.discontinuityNumber = ke);
            }
            return Ue;
          }, Ce.prototype.canAddSegmentToBufferBlock = function(Ie, xe, Ue) {
            var ke, Le = xe.getMediaTypes();
            if (Le.length === 0)
              return !0;
            var De = Ie.getMimeType(), Re = xe.getSegregationCriteria(De);
            if (Re)
              return oe(Ue, Re);
            if (!this.isRequiredMimeType(Ie, xe))
              return !1;
            var Oe = (ke = Le.find(function(Fe) {
              return Fe.mimeType !== Ie.getMimeType();
            })) === null || ke === void 0 ? void 0 : ke.mimeType, Be = Ie.getSegmentInfo().discontinuitySequenceNumber !== void 0;
            return Oe && Be ? oe(Ue, xe.getSegregationCriteria(Oe), ["codec", "encryption"]) : Ie.getPeriodId() === xe.getPeriodId();
          }, Ce;
        }();
        function oe(Ce, Ie, xe) {
          return xe === void 0 && (xe = []), Object.keys(Ce).filter(function(Ue) {
            return !xe.includes(Ue);
          }).every(function(Ue) {
            return Ie && Ie[Ue] === Ce[Ue];
          });
        }
        function ce(Ce) {
          return Ce.isEncrypted() ? le.EncryptionState.Encrypted : le.EncryptionState.Clear;
        }
        function he(Ce, Ie, xe) {
          var Ue = ve();
          return xe.every(function(ke) {
            var Le = ke.mimeType;
            return Ue.canReuseSourceBuffers(Ce, Ie, Le);
          });
        }
        function ge(Ce, Ie) {
          var xe = Ce.getMediaTypes().find(function(Ue) {
            return Ue.mimeType === Ie;
          });
          return xe ? xe.timescale : 0;
        }
        function ve() {
          return (0, ue.getCapabilities)().isTizen ? ye : (0, ue.getCapabilities)().isLegacyEdge ? Pe : (0, ue.getCapabilities)()[ae.CapabilityKey.isEdge] ? Se : (0, ue.getCapabilities)()[ae.CapabilityKey.isFirefox] ? $e : (0, ue.getCapabilities)()[ae.CapabilityKey.isWebOS] ? we : (0, ue.getCapabilities)()[ae.CapabilityKey.isPlayStation4] ? pe : be;
        }
        function me(Ce, Ie, xe) {
          return { currentCriteria: Ce.getSegregationCriteria(xe), nextCriteria: Ie.getSegregationCriteria(xe) };
        }
        ie.Segregation = se;
        var be = { canReuseSourceBuffers: function(Ce, Ie, xe) {
          var Ue = me(Ce, Ie, xe), ke = Ue.currentCriteria, Le = Ue.nextCriteria;
          return Te(ke, Le) && Ee(ke, Le);
        } }, pe = { canReuseSourceBuffers: function(Ce, Ie, xe) {
          var Ue = me(Ce, Ie, xe), ke = Ue.currentCriteria, Le = Ue.nextCriteria;
          return Te(ke, Le) && Ee(ke, Le) && Ae(ke, Le) && Me(ke, Le) && Ne(Ce, Ie, xe);
        } }, $e = { canReuseSourceBuffers: function(Ce, Ie, xe) {
          var Ue = me(Ce, Ie, xe);
          return Te(Ue.currentCriteria, Ue.nextCriteria);
        } }, ye = { canReuseSourceBuffers: function(Ce, Ie, xe) {
          var Ue = me(Ce, Ie, xe), ke = Ue.currentCriteria, Le = Ue.nextCriteria, De = Te(ke, Le) && Ee(ke, Le) && Me(ke, Le), Re = (0, fe.isTizen2016)() && !Ne(Ce, Ie, xe);
          return !((0, fe.isTizen2017)() || !De || Re);
        } }, Se = { canReuseSourceBuffers: function(Ce, Ie, xe) {
          var Ue = me(Ce, Ie, xe), ke = Ue.currentCriteria, Le = Ue.nextCriteria, De = (ke == null ? void 0 : ke.encryption) === le.EncryptionState.Clear, Re = (Le == null ? void 0 : Le.encryption) === le.EncryptionState.Clear;
          return Te(ke, Le) && De && Re;
        } }, we = { canReuseSourceBuffers: function(Ce, Ie, xe) {
          var Ue = me(Ce, Ie, xe), ke = Ue.currentCriteria, Le = Ue.nextCriteria;
          return Te(ke, Le) && Ee(ke, Le) && Me(ke, Le) && Ne(Ce, Ie, xe) && !Ae(ke, Le);
        } }, Pe = { canReuseSourceBuffers: function(Ce, Ie, xe) {
          return !1;
        } };
        function Te(Ce, Ie) {
          return (Ce == null ? void 0 : Ce.codec) === (Ie == null ? void 0 : Ie.codec);
        }
        function Ee(Ce, Ie) {
          return (Ce == null ? void 0 : Ce.encryption) === (Ie == null ? void 0 : Ie.encryption);
        }
        function Me(Ce, Ie) {
          return (Ce == null ? void 0 : Ce.periodId) === (Ie == null ? void 0 : Ie.periodId);
        }
        function Ae(Ce, Ie) {
          return (Ce == null ? void 0 : Ce.discontinuityNumber) === (Ie == null ? void 0 : Ie.discontinuityNumber);
        }
        function Ne(Ce, Ie, xe) {
          return ge(Ce, xe) === ge(Ie, xe);
        }
      }, 99162: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.AbstractUpdater = ie.REPRESENTATION_UPDATE_CANCEL = void 0, ie.calculateUpdateDelayInMillis = le;
        var ae = ne(10981), ue = ne(331);
        ie.REPRESENTATION_UPDATE_CANCEL = "CANCEL";
        var _e = 2147483647, fe = function() {
          function se(oe) {
            var ce = this;
            this.updateCallbacks = oe, this.handlePayloadUpdateError = function(he) {
              ce.publishErrorResponse(he), ce.clearTimeout();
            }, this.processPayload = function(he) {
              ce.success(he), ce.clearTimeout(), ce._isStopped || ce.scheduleUpdate();
            }, this._isStopped = !1;
          }
          return se.prototype.cancel = function() {
            this._updateDeferred && (this._updateDeferred.reject(ie.REPRESENTATION_UPDATE_CANCEL), this.updateCallbacks.error(ie.REPRESENTATION_UPDATE_CANCEL)), this.clearTimeout();
          }, se.prototype.clearTimeout = function() {
            window.clearTimeout(this.updateTimeoutId), this.updateTimeoutId = null;
          }, se.prototype.stop = function() {
            this.updateTimeoutId !== null && (this._isStopped = !0, this.cancel());
          }, se.prototype.start = function() {
            this._isStopped = !1, this.scheduleUpdate();
          }, se.prototype.scheduleUpdate = function() {
            this.updateTimeoutId || this._isStopped || this.initializeUpdate();
          }, se.prototype.initializeUpdate = function() {
            var oe = this, ce = le(this.getLastReloadTimestamp(), this.getReloadIntervalInSeconds());
            if (!(ce > _e)) {
              var he = new ae.Deferred(), ge = { wasInvalidated: function() {
                return he !== oe._updateDeferred;
              } };
              he.promise.catch(function() {
              }), this._updateDeferred = he, this.updateTimeoutId = window.setTimeout(function() {
                return oe.payloadUpdate(ge);
              }, ce);
            }
          }, se.prototype.payloadUpdate = function(oe) {
            var ce = this;
            this.update().then(function(he) {
              oe.wasInvalidated() || ce.processPayload(he);
            }).catch(function(he) {
              oe.wasInvalidated() || ce.handlePayloadUpdateError(he);
            });
          }, se.prototype.publishErrorResponse = function(oe) {
            this._updateDeferred.reject(oe), this.updateCallbacks.error(oe);
          }, se.prototype.success = function(oe) {
            this._updateDeferred.resolve(oe), this.updateCallbacks.success(oe);
          }, Object.defineProperty(se.prototype, "isStopped", { get: function() {
            return this._isStopped;
          }, enumerable: !1, configurable: !0 }), se.prototype.getPayload = function() {
            return this._updateDeferred.promise;
          }, se;
        }();
        function le(se, oe) {
          if (isNaN(oe))
            return 0;
          var ce = (0, ue.toSeconds)(Date.now() - se);
          return ce >= oe ? 0 : (0, ue.toMilliSeconds)(oe - ce);
        }
        ie.AbstractUpdater = fe;
      }, 13034: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.findAdaptationSetOfMimeType = fe, ie.getHlsDefaultLanguage = le, ie.getPreferredLanguage = se, ie.findAdaptationSetsForMimeType = he;
        var ae = ne(79814), ue = ne(91520), _e = ne(16368);
        function fe(ve, me, be) {
          be === void 0 && (be = {});
          var pe, $e = be.sourceState, ye = be.langObj, Se = be.periodSwitched, we = se(ve, $e), Pe = he(me, ve);
          return we && (pe = oe(Pe, we, ye, Se)), !pe && $e && (pe = oe(Pe, le(ve, $e), ye, Se)), pe || Pe[0];
        }
        function le(ve, me) {
          var be;
          if (ue.ModuleManager.has(_e.ModuleName.HLS)) {
            var pe = ue.ModuleManager.get(_e.ModuleName.HLS).selectors, $e = pe.getHlsState, ye = pe.getDefaultLanguages, Se = $e(me), we = Se ? ye(Se) : void 0;
            if (we) {
              var Pe = (be = ae.MimeTypeHelper.getMediaType(ve)) === null || be === void 0 ? void 0 : be.toUpperCase();
              return Pe ? we[Pe] : void 0;
            }
          }
        }
        function se(ve, me) {
          var be = me && le(ve, me), pe = { language: navigator.language || navigator.userLanguage || (be == null ? void 0 : be.language) };
          return pe.language && be && ce(pe.language, be.language) && (pe.name = be.name), pe;
        }
        function oe(ve, me, be, pe) {
          if (pe === void 0 && (pe = !1), ve.length !== 0) {
            var $e = void 0;
            if (be && ($e = ge(ve, be, pe)), $e)
              return $e;
            if (me && me.language) {
              var ye = ve.filter(function(Se) {
                return !(!Se._lang || Se._lang == null) && ce(Se._lang, me.language);
              });
              return ye.find(function(Se) {
                return Se.Representation.find(function(we) {
                  return we._name === me.name;
                });
              }) || ye[0];
            }
          }
        }
        function ce(ve, me) {
          return !!(ve != null && ve.includes(me) || me != null && me.includes(ve));
        }
        function he(ve, me) {
          return ve.AdaptationSet.filter(function(be) {
            return be._mimeType === me || be.Representation.find(function(pe) {
              return pe._mimeType === me;
            });
          });
        }
        function ge(ve, me, be) {
          var pe = ve.find(function(ye) {
            return ye._lang && me.lang && ye._lang === me.lang;
          }), $e = ve.find(function(ye) {
            return me.adaptationSetId && ye._internalId.equals(me.adaptationSetId);
          });
          return $e = $e || ve.find(function(ye) {
            return me.id === ye._internalId.adaptationSetId;
          }), be ? pe || $e : $e || pe;
        }
      }, 67883: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var fe = function(le, se) {
            return fe = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(oe, ce) {
              oe.__proto__ = ce;
            } || function(oe, ce) {
              for (var he in ce)
                Object.prototype.hasOwnProperty.call(ce, he) && (oe[he] = ce[he]);
            }, fe(le, se);
          };
          return function(le, se) {
            if (typeof se != "function" && se !== null)
              throw new TypeError("Class extends value " + String(se) + " is not a constructor or null");
            function oe() {
              this.constructor = le;
            }
            fe(le, se), le.prototype = se === null ? Object.create(se) : (oe.prototype = se.prototype, new oe());
          };
        }();
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.AdaptationSetId = void 0, ie.createAdaptationSetIdFromMimeTypeAndIndex = _e;
        var ue = function(fe) {
          function le(se, oe) {
            var ce = fe.call(this, se) || this;
            return ce._adaptationSetId = oe, ce;
          }
          return ae(le, fe), Object.defineProperty(le.prototype, "adaptationSetId", { get: function() {
            return this._adaptationSetId;
          }, enumerable: !1, configurable: !0 }), le.prototype.equals = function(se) {
            return fe.prototype.equals.call(this, se) && this.adaptationSetId === (se == null ? void 0 : se.adaptationSetId);
          }, le.prototype.key = function() {
            return fe.prototype.key.call(this) + "-" + this.adaptationSetId;
          }, le;
        }(ne(96953).PeriodId);
        function _e(fe, le, se) {
          return new ue(fe, "".concat(le, "-").concat(se));
        }
        ie.AdaptationSetId = ue;
      }, 43752: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MPDExtractor = void 0, ie.stripUnderscorePrefix = pe, ie.applyProperties = $e, ie.representationToQuality = ye, ie.getMinimumUpdatePeriodInSeconds = Ae, ie.getContentTypeFromMimeTypeAndCodecs = Ne;
        var ae = ne(18665), ue = ne(33696), _e = ne(42055), fe = ne(42283), le = ne(44388), se = ne(79814), oe = ne(331), ce = ne(54838), he = ne(91520), ge = ne(16368), ve = ne(41735), me = ne(77874), be = function() {
          function Ce(Ie, xe) {
            var Ue = this;
            this.isLive = function() {
              var ke;
              return ((ke = Ue.getMpd()) === null || ke === void 0 ? void 0 : ke._type) === "dynamic";
            }, this.context = Ie, this.sourceContext = xe, this.settings = Ie.settings, this.adjustedPeriodStartTimes = !1, this.synchronizedTimeService = Ie.serviceManager.get(ae.ServiceName.SynchronizedTimeService, this.sourceContext.sourceIdentifier), this.sourceStore = Ie.serviceManager.get(ae.ServiceName.SourceStoreService, this.sourceContext.sourceIdentifier);
          }
          return Ce.prototype.getMpd = function() {
            var Ie;
            return (0, me.getManifest)((Ie = this.sourceStore) === null || Ie === void 0 ? void 0 : Ie.getState());
          }, Ce.prototype.getPeriods = function() {
            var Ie, xe;
            return (xe = (Ie = this.getMpd()) === null || Ie === void 0 ? void 0 : Ie.Period) !== null && xe !== void 0 ? xe : [];
          }, Ce.prototype.getAdaptationSets = function(Ie) {
            var xe = this.getPeriods().find(function(Ue) {
              return Ue._id === Ie;
            });
            return xe ? xe.AdaptationSet : [];
          }, Ce.prototype.adjustPeriodStartTimes = function() {
            var Ie, xe, Ue, ke = (Ie = this.sourceStore) === null || Ie === void 0 ? void 0 : Ie.getState();
            if (ke && !this.adjustedPeriodStartTimes && !(!((xe = this.getMpd()) === null || xe === void 0) && xe._isHls)) {
              var Le = this.isLive() ? (0, oe.toSeconds)(this.getAvailabilityStartTime()) : (0, _e.getStartTimeOffset)(ke);
              (Ue = this.sourceStore) === null || Ue === void 0 || Ue.dispatch((0, ve.adjustPeriodStartTimes)(Le)), this.adjustedPeriodStartTimes = !0;
            }
          }, Ce.prototype.getAvailabilityStartTime = function() {
            var Ie;
            return this.isLive() && (!((Ie = this.getMpd()) === null || Ie === void 0) && Ie._availabilityStartTime) ? ce.Util.getUtcDate(this.getMpd()._availabilityStartTime).getTime() - this.getTimeDifference() : 0;
          }, Ce.prototype.getAvailabilityEndTime = function() {
            var Ie;
            if (!((Ie = this.getMpd()) === null || Ie === void 0) && Ie.hasOwnProperty("_availabilityEndTime")) {
              var xe = ce.Util.getUtcDate(this.getMpd()._availabilityEndTime).getTime();
              return new Date(xe - this.getTimeDifference());
            }
            return null;
          }, Ce.prototype.getTimeDifference = function() {
            return this.synchronizedTimeService ? this.synchronizedTimeService.getTimeDifference() : 0;
          }, Ce.prototype.getType = function() {
            var Ie;
            return (Ie = this.getMpd()) === null || Ie === void 0 ? void 0 : Ie._type;
          }, Ce.prototype.getDuration = function() {
            var Ie;
            return (Ie = this.getMpd()) === null || Ie === void 0 ? void 0 : Ie._mediaPresentationDuration;
          }, Ce.prototype.getRequestTimestamp = function() {
            var Ie;
            return (Ie = this.getMpd()) === null || Ie === void 0 ? void 0 : Ie._requestTimestamp;
          }, Ce.isValueWithinBounds = function(Ie, xe, Ue) {
            return !Ie || Ie >= xe && Ie <= Ue;
          }, Ce.prototype.isAllowedVideoQuality = function(Ie) {
            var xe = Ce.isValueWithinBounds(Ie.width, this.context.config.adaptation.resolution.minSelectableVideoWidth, this.context.config.adaptation.resolution.maxSelectableVideoWidth), Ue = Ce.isValueWithinBounds(Ie.height, this.context.config.adaptation.resolution.minSelectableVideoHeight, this.context.config.adaptation.resolution.maxSelectableVideoHeight), ke = Ce.isValueWithinBounds(Ie.bitrate, this.settings.MIN_SELECTABLE_VIDEO_BITRATE, this.settings.MAX_SELECTABLE_VIDEO_BITRATE);
            return xe && Ue && ke;
          }, Ce.prototype.isAllowedAudioQuality = function(Ie) {
            return Ce.isValueWithinBounds(Ie.bitrate, this.settings.MIN_SELECTABLE_AUDIO_BITRATE, this.settings.MAX_SELECTABLE_AUDIO_BITRATE);
          }, Ce.prototype.getAllowedQualities = function(Ie, xe) {
            var Ue = this;
            if (!Ie)
              return [];
            var ke = xe.filter(function(Le) {
              return se.MimeTypeHelper.isVideo(Ie) && Ue.isAllowedVideoQuality(Le) || se.MimeTypeHelper.isAudio(Ie) && Ue.isAllowedAudioQuality(Le);
            });
            return ke.length < 1 && xe.length > 0 ? xe : ke;
          }, Ce.prototype.getQualityForAdaptationSet = function(Ie) {
            if (!Ie)
              return [];
            var xe = Ie.Representation.map(function(Ue) {
              return ye(Ue, Ie._mimeType, Ie._codecs);
            });
            return this.settings.EXCLUDE_DISALLOWED_REPRESENTATIONS && (xe = this.getAllowedQualities(Ie._mimeType, xe)), xe;
          }, Ce.prototype.getAudioQualities = function(Ie) {
            var xe = this, Ue = this.getValidPeriodId(Ie);
            return this.getAdaptationSets(Ue).reduce(function(ke, Le) {
              return Le._mimeType && se.MimeTypeHelper.isAudio(Le._mimeType) && (ke[Le._internalId.adaptationSetId] = xe.getQualityForAdaptationSet(Le)), ke;
            }, {});
          }, Ce.prototype.getVideoQualities = function(Ie) {
            var xe = this.getValidPeriodId(Ie), Ue = this.getAdaptationSets(xe).find(function(ke) {
              return ke._mimeType && se.MimeTypeHelper.isVideo(ke._mimeType);
            });
            return Ue ? this.getQualityForAdaptationSet(Ue) : [];
          }, Ce.prototype.getLangObjectFromAdaptationSet = function(Ie, xe, Ue) {
            var ke = { id: null, lang: null, adaptationSetId: null, kind: null, label: "off", url: null }, Le = Ie._mimeType && Ie._mimeType.indexOf(xe) > -1, De = Ue && Ie._mimeType.indexOf(Ue) > -1;
            return se.MimeTypeHelper.isSubtitle(xe) && (ke.kind = "subtitle"), Ie.Role && Ie.Role.length > 0 && (ke.role = Ie.Role.map(function(Re) {
              return $e(Re, {});
            })), (Le || De) && ($e(Ie, ke, ["_lang", "_isFragmented"]), ke.lang = ke.lang || "und", ke.label = Ie._label || ke.lang, ke.adaptationSetId = Ie._internalId, ke.id = Ie._internalId.adaptationSetId), ke;
          }, Ce.prototype.toSubtitleTrack = function(Ie, xe, Ue) {
            var ke, Le = this.getLangObjectFromAdaptationSet(Ie, xe, Ue), De = { id: Le.id, lang: Le.lang, kind: Le.kind, isFragmented: (ke = Le.isFragmented) !== null && ke !== void 0 && ke, isSideloaded: !1, enabled: !1, label: Le.label };
            return Le.role != null && (De.role = Le.role), De.forced = Me(De, Ie.Representation[0]), De;
          }, Ce.prototype.getAvailableSubtitles = function(Ie) {
            var xe = this, Ue = 0;
            return Ie = this.getValidPeriodId(Ie), this.getAdaptationSets(Ie).filter(function(ke) {
              return se.MimeTypeHelper.isSubtitle(ke._mimeType);
            }).map(function(ke) {
              var Le = xe.toSubtitleTrack(ke, "application", "text");
              return Le.id || (Ue++, Le.id = "sub_".concat(Ue)), Le;
            });
          }, Ce.prototype.getClosedCaptionLabels = function(Ie) {
            return Ie = this.getValidPeriodId(Ie), this.getAdaptationSets(Ie).filter(function(xe) {
              return xe.ClosedCaptionLabels;
            }).flatMap(function(xe) {
              return Object.keys(xe.ClosedCaptionLabels).map(function(Ue) {
                var ke = xe.ClosedCaptionLabels[Ue];
                return { id: Ue, kind: "captions", lang: ke.lang || "unknown", label: ke.label || "Captions (".concat(Ue, ")") };
              });
            });
          }, Ce.prototype.getAvailableAudio = function(Ie, xe) {
            var Ue = this;
            xe === void 0 && (xe = !0);
            var ke = this.getValidPeriodId(Ie), Le = this.getAdaptationSets(ke), De = 0, Re = Le.filter(function(Fe) {
              return se.MimeTypeHelper.isAudio(Fe._mimeType);
            }).map(function(Fe) {
              var Ve = Ue.getLangObjectFromAdaptationSet(Fe, ue.MediaType.Audio);
              return Ve && Ve.label !== "off" ? (Ve.id || (Ve.id = "audio_" + De, De++), Ve) : null;
            });
            if (xe) {
              var Oe = Le.find(function(Fe) {
                return se.MimeTypeHelper.isVideo(Fe._mimeType);
              });
              if (Oe && Oe.ContentComponent) {
                var Be = Oe.ContentComponent.filter(function(Fe) {
                  return Fe._contentType === ue.MediaType.Audio;
                }).map(function(Fe) {
                  return { id: Fe._id, lang: Fe._lang, label: Fe._id, adaptationSetId: Oe._internalId };
                });
                Re = Re.concat(Be);
              }
            }
            return Re.filter(function(Fe) {
              return Fe;
            });
          }, Ce.prototype.getAvailableVideo = function(Ie) {
            var xe = this.getValidPeriodId(Ie), Ue = this.getAdaptationSets(xe).find(function(ke) {
              return se.MimeTypeHelper.isVideo(ke._mimeType);
            });
            return Ue ? [this.getLangObjectFromAdaptationSet(Ue, ue.MediaType.Video)] : [];
          }, Ce.getContentProtectionForManifestElement = function(Ie) {
            var xe;
            return !((xe = Ie == null ? void 0 : Ie.ContentProtection) === null || xe === void 0) && xe.length && he.ModuleManager.has(ge.ModuleName.DRM) ? he.ModuleManager.get(ge.ModuleName.DRM).ContentProtectionHelper.parseContentProtectionDescriptors(Ie.ContentProtection) : [];
          }, Ce.getContentProtectionForAdaptationSet = function(Ie) {
            for (var xe = [], Ue = 0; Ue < Ie.Representation.length; Ue++)
              xe = xe.concat(Ce.getContentProtectionForManifestElement(Ie.Representation[Ue]));
            return xe = xe.concat(Ce.getContentProtectionForManifestElement(Ie));
          }, Ce.prototype.getTimeShiftBufferDepthSeconds = function() {
            if (this.isLive()) {
              var Ie = this.getMpd()._timeShiftBufferDepth, xe = (0, oe.toSeconds)(Date.now() - this.getAvailabilityStartTime());
              return Ie === Number.NEGATIVE_INFINITY ? -xe : Math.max(Ie, -xe);
            }
            return 0;
          }, Ce.getCurrentAndSuccessorPeriod = function(Ie, xe) {
            for (var Ue = [null, 0, null], ke = Ue[0], Le = Ue[1], De = Ue[2]; Le < Ie.length; Le++)
              if (Ie[Le]._id === xe) {
                ke = Ie[Le], De = Ie[Le + 1] || null;
                break;
              }
            return [ke, De];
          }, Ce.prototype.getPeriodDuration = function(Ie, xe) {
            var Ue;
            xe = xe ?? this.getPeriods();
            var ke = Ce.getCurrentAndSuccessorPeriod(xe, Ie), Le = ke[0], De = ke[1];
            if (Le && Le._duration)
              return le.DurationConverter.getDurationInSec(Le._duration);
            if (Le && Le.start && De && De.start)
              return De.start - Le.start;
            if (!((Ue = this.getMpd()) === null || Ue === void 0) && Ue._mediaPresentationDuration) {
              var Re = le.DurationConverter.getDurationInSec(this.getMpd()._mediaPresentationDuration);
              if (!isNaN(Re))
                return Re;
            }
            return Number.POSITIVE_INFINITY;
          }, Ce.prototype.getDRMCapabilitiesForPeriod = function(Ie) {
            Ie = this.getValidPeriodId(Ie);
            var xe = this.getPeriods().find(function(Ue) {
              return Ue._id === Ie;
            });
            return this.getDRMCapabilitiesFromPeriod(xe);
          }, Ce.prototype.getDRMCapabilitiesFromPeriod = function(Ie) {
            for (var xe = [], Ue = [], ke = 0, Le = Ie.AdaptationSet; ke < Le.length; ke++) {
              var De = Le[ke], Re = De._mimeType, Oe = Ce.getMimeTypeCodecStringForAdaptationSet(De);
              se.MimeTypeHelper.isVideo(Re) ? Ue = Ue.concat(Oe) : se.MimeTypeHelper.isAudio(Re) && (xe = xe.concat(Oe));
            }
            return [xe, Ue];
          }, Ce.prototype.dispose = function() {
            this.settings = null;
          }, Ce.getMimeTypeCodecStringForAdaptationSet = function(Ie) {
            for (var xe = [], Ue = 0, ke = Ie.Representation; Ue < ke.length; Ue++) {
              var Le = ke[Ue], De = Ce.getAttributeFromRepresentationOrAdaptationSet("_codecs", Le, Ie), Re = Ie._mimeType;
              if (Ie._mimeType && De) {
                var Oe = Ne(Re, De);
                xe.push({ contentType: Oe });
              }
            }
            return xe;
          }, Ce.getAttributeFromRepresentationOrAdaptationSet = function(Ie, xe, Ue) {
            return xe.hasOwnProperty(Ie) && xe[Ie] ? xe[Ie] : Ue.hasOwnProperty(Ie) && Ue[Ie] ? Ue[Ie] : null;
          }, Ce.prototype.getValidPeriodId = function(Ie) {
            var xe = this.getPeriods();
            if (xe.find(function(ke) {
              return ke._id === Ie;
            }))
              return Ie;
            var Ue = xe[xe.length - 1]._id;
            return this.context.logger.debug("Period " + Ie + " not available - return last period (" + Ue + ")"), Ue;
          }, Ce.prototype.getEventStreamEvents = function(Ie) {
            var xe = this;
            return Ie && Ie.EventStream ? Ie.EventStream.filter(function(Ue) {
              return Ue.Event;
            }).flatMap(function(Ue) {
              var ke, Le = Number((ke = Ue._timescale) !== null && ke !== void 0 ? ke : 1);
              return xe.mapToEventStreamEvent(Ie.start, Ue, Le);
            }) : [];
          }, Ce.prototype.mapToEventStreamEvent = function(Ie, xe, Ue) {
            var ke = this;
            return xe.Event.map(function(Le) {
              var De = {}, Re = Le._presentationTime || 0;
              if (De.startTime = Re / Ue + Ie, Le._duration) {
                var Oe = Le._duration / Ue;
                De.endTime = De.startTime + Oe;
              } else
                De.endTime = De.startTime;
              return De.data = ke.getEventData(Le, xe._schemeIdUri), De;
            });
          }, Ce.prototype.getEventData = function(Ie, xe) {
            var Ue = /<event[^>]*>(.*)(<\/event>|\/>)/g.exec(Ie.rawXmlRepresentation), ke = void 0;
            Ue && Ue.length > 1 && (ke = Ue[1]);
            var Le = {};
            return Object.getOwnPropertyNames(Ie).filter(function(De) {
              return !["_presentationTime", "_duration", "__text"].some(function(Re) {
                return Re === De;
              }) && De.lastIndexOf("_", 0) === 0;
            }).forEach(function(De) {
              Le[De.substring(1, De.length)] = Ie[De];
            }), { properties: Le, content: ke, schemeIdUri: xe };
          }, Ce;
        }();
        function pe(Ce) {
          return Ce.indexOf("_") === 0 ? Ce.substring(1) : Ce;
        }
        function $e(Ce, Ie, xe) {
          return xe === void 0 && (xe = []), Object.keys(Ce).filter(function(Ue) {
            return xe.length === 0 || xe.indexOf(Ue) > -1;
          }).forEach(function(Ue) {
            Ie[pe(Ue)] = Ce[Ue];
          }), Ie;
        }
        function ye(Ce, Ie, xe) {
          if (!Ce)
            return null;
          var Ue = { id: Ce._id ? String(Ce._id) : null, bitrate: Ce._bandwidth || 0 }, ke = fe.CodecStringHelper.getExtractedCodecStrings(Ce._codecs || xe);
          return Pe(Ce, Ie) ? Se(Ue, Ce, ke) : we(Ce, Ie) ? Te(Ue, Ce, ke) : (Ue.label = Ce._label || Ee(Ue.bitrate), Ue);
        }
        function Se(Ce, Ie, xe) {
          return xe.audio && (Ce.codec = xe.audio), Ce.label = Ie._label || Ee(Ce.bitrate), Ce;
        }
        function we(Ce, Ie) {
          return se.MimeTypeHelper.isVideo(Ie);
        }
        function Pe(Ce, Ie) {
          return se.MimeTypeHelper.isAudio(Ie);
        }
        function Te(Ce, Ie, xe) {
          Ce.width = Ie._width || 0, Ce.height = Ie._height || 0, xe.video && (Ce.codec = xe.video), Ie.hasOwnProperty("_frameRate") && (Ce.frameRate = Ie._frameRate);
          var Ue = Ee(Ce.bitrate);
          return Ce.width && Ce.height && (Ue = "".concat(Ce.width, "x").concat(Ce.height, ", ").concat(Ue)), Ce.label = Ie._label || Ue, Ce;
        }
        function Ee(Ce) {
          return "".concat(Math.round(Ce / 1e3), "kbps");
        }
        function Me(Ce, Ie) {
          var xe, Ue;
          return !!(!((xe = Ce.role) === null || xe === void 0) && xe.some(function(ke) {
            return ke.value && ["forced_subtitle", "forced-subtitle"].includes(ke.value);
          })) || !!(!((Ue = Ie == null ? void 0 : Ie._hls) === null || Ue === void 0) && Ue.isForced);
        }
        function Ae(Ce) {
          return (Ce == null ? void 0 : Ce._minimumUpdatePeriod) == null ? 1 / 0 : le.DurationConverter.getDurationInSec(Ce._minimumUpdatePeriod);
        }
        function Ne(Ce, Ie) {
          return "".concat(Ce, '; codecs="').concat(Ie, '"');
        }
        ie.MPDExtractor = be;
      }, 48928: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ManifestCachingService = void 0;
        var ae = ne(76885), ue = function() {
          function le() {
            this.cache = {};
          }
          return le.prototype.set = function(se, oe, ce) {
            var he = ae.URLHelper.toFullUrl(se);
            _e(he, this.cache), this.cache[he][oe] = ce;
          }, le.prototype.setExpire = function(se, oe) {
            var ce = ae.URLHelper.toFullUrl(se);
            _e(ce, this.cache), this.cache[ce].expire = oe;
          }, le.prototype.get = function(se, oe) {
            var ce = ae.URLHelper.toFullUrl(oe), he = this.cache[ce];
            if (he && fe(he.expire))
              return he[se];
            delete this.cache[ce];
          }, le.prototype.cacheHttpResponse = function(se, oe, ce) {
            ce === void 0 && (ce = 1 / 0), this.set(oe, "httpResponse", se), this.setExpire(oe, ce);
          }, le.prototype.cacheParsedManifest = function(se, oe, ce) {
            ce === void 0 && (ce = 1 / 0), this.set(oe, "parsedManifest", se), this.setExpire(oe, ce);
          }, le.prototype.cacheSegmentList = function(se, oe, ce) {
            ce === void 0 && (ce = 1 / 0), this.set(oe, "segmentList", se), this.setExpire(oe, ce);
          }, le.prototype.getHttpResponse = function(se) {
            return this.get("httpResponse", se);
          }, le.prototype.getParsedManifest = function(se) {
            return this.get("parsedManifest", se);
          }, le.prototype.getSegmentList = function(se) {
            return this.get("segmentList", se);
          }, le.prototype.clear = function() {
            this.cache = {};
          }, le.prototype.dispose = function() {
            this.cache = {};
          }, le;
        }();
        function _e(le, se) {
          se[le] || (se[le] = {});
        }
        function fe(le) {
          return le >= Date.now();
        }
        ie.ManifestCachingService = ue;
      }, 3337: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.createManifestLoadingService = se;
        var ae = ne(25550), ue = ne(28764), _e = ne(33696), fe = ne(91520), le = ne(16368);
        function se(oe, ce, he) {
          switch (oe.type) {
            case _e.StreamType.Dash:
              return new (fe.ModuleManager.get(le.ModuleName.DASH)).MPDLoader(ce, he);
            case _e.StreamType.Hls:
              return new (fe.ModuleManager.get(le.ModuleName.HLS)).M3u8Loader(ce, he);
            case _e.StreamType.Smooth:
              return new (fe.ModuleManager.get(le.ModuleName.Smooth)).SmoothStreamingLoader(ce, he);
            default:
              throw new ue.PlayerError(ae.ErrorCode.SOURCE_INVALID, { given: oe.type, supported: "dash, hls, smooth" }, "The provided stream type is not supported by the player.");
          }
        }
      }, 94938: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(me) {
            for (var be, pe = 1, $e = arguments.length; pe < $e; pe++)
              for (var ye in be = arguments[pe])
                Object.prototype.hasOwnProperty.call(be, ye) && (me[ye] = be[ye]);
            return me;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.orderAdaptationSetsByCodec = fe, ie.sortAdaptationSetsByBestCodec = se, ie.getCodecsFromAdaptationSet = oe, ie.getMimeTypeForAdaptationSet = ce, ie.removeRepresentations = he;
        var ue = ne(79814), _e = ne(38925);
        function fe(me, be) {
          return (me = ae({}, me)).Period = me.Period.map(function(pe) {
            if (!pe.AdaptationSet)
              return ae({}, pe);
            var $e = le(pe.AdaptationSet), ye = $e.videoSets, Se = $e.audioSets, we = $e.otherSets, Pe = se(ye, be.video), Te = {};
            return Se.forEach(function(Ee) {
              var Me = Ee._lang || "none";
              Te[Me] = Te[Me] || [], Te[Me].push(Ee);
            }), Object.keys(Te).forEach(function(Ee) {
              Pe = Pe.concat(se(Te[Ee], be.audio));
            }), ae(ae({}, pe), { AdaptationSet: Pe.concat(we) });
          }), me;
        }
        function le(me) {
          return me.reduce(function(be, pe) {
            var $e = ce(pe);
            return ue.MimeTypeHelper.isVideo($e) ? be.videoSets.push(pe) : ue.MimeTypeHelper.isAudio($e) ? be.audioSets.push(pe) : be.otherSets.push(pe), be;
          }, { videoSets: [], audioSets: [], otherSets: [] });
        }
        function se(me, be) {
          var pe = function($e) {
            for (var ye = 0; ye < be.length; ye++)
              if ($e.indexOf(be[ye]) === 0)
                return ye;
            return be.length + 1;
          };
          return me.sort(function($e, ye) {
            return pe(oe($e)) - pe(oe(ye));
          });
        }
        function oe(me) {
          var be;
          if (((be = me == null ? void 0 : me._codecs) === null || be === void 0 ? void 0 : be.length) > 0)
            return me._codecs;
          if (me.Representation && me.Representation.length > 0) {
            var pe = me.Representation[me.Representation.length - 1];
            if (pe._codecs)
              return pe._codecs;
          }
          return "";
        }
        function ce(me) {
          if (me._mimeType)
            return me._mimeType;
          if (Array.isArray(me.Representation)) {
            var be = me.Representation.find(function(pe) {
              return pe._mimeType;
            });
            if (be)
              return be._mimeType;
          }
          return "";
        }
        function he(me, be) {
          if (!(me.Period && me.Period.length > 0) || be.length === 0)
            return me;
          var pe = me.Period.map(function($e) {
            return ge($e, be);
          }).filter(function($e) {
            return $e.AdaptationSet.length > 0;
          });
          return ae(ae({}, me), { Period: pe });
        }
        function ge(me, be) {
          var pe = me.AdaptationSet.map(function($e) {
            return ve($e._internalId, $e, be);
          }).filter(function($e) {
            return $e.Representation.length > 0;
          });
          return ae(ae({}, me), { AdaptationSet: pe });
        }
        function ve(me, be, pe) {
          var $e = be.Representation.filter(function(ye) {
            return !pe.some(function(Se) {
              return Se.equals(new _e.RepresentationId(me, ye._id));
            });
          });
          return ae(ae({}, be), { Representation: $e });
        }
      }, 38353: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var dt = function(ot, et) {
            return dt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(st, mt) {
              st.__proto__ = mt;
            } || function(st, mt) {
              for (var St in mt)
                Object.prototype.hasOwnProperty.call(mt, St) && (st[St] = mt[St]);
            }, dt(ot, et);
          };
          return function(ot, et) {
            if (typeof et != "function" && et !== null)
              throw new TypeError("Class extends value " + String(et) + " is not a constructor or null");
            function st() {
              this.constructor = ot;
            }
            dt(ot, et), ot.prototype = et === null ? Object.create(et) : (st.prototype = et.prototype, new st());
          };
        }(), ue = this && this.__assign || function() {
          return ue = Object.assign || function(dt) {
            for (var ot, et = 1, st = arguments.length; et < st; et++)
              for (var mt in ot = arguments[et])
                Object.prototype.hasOwnProperty.call(ot, mt) && (dt[mt] = ot[mt]);
            return dt;
          }, ue.apply(this, arguments);
        }, _e = this && this.__spreadArray || function(dt, ot, et) {
          if (et || arguments.length === 2)
            for (var st, mt = 0, St = ot.length; mt < St; mt++)
              !st && mt in ot || (st || (st = Array.prototype.slice.call(ot, 0, mt)), st[mt] = ot[mt]);
          return dt.concat(st || Array.prototype.slice.call(ot));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ManifestService = void 0, ie.initializeInternalIds = Ke, ie.addDrmKidsToRepresentations = Ze, ie.iterateAdaptationSets = Qe, ie.getNearestPeriodForTime = qe, ie.findLowestPossibleBandwidthFromRepresentations = je, ie.getMatchingRepresentationsByBandwidth = tt, ie.getMatchingRepresentationByBandwidth = yt, ie.getCodecPriorities = ft, ie.getCodecOfAdaptationSetMimeType = lt;
        var fe = ne(25550), le = ne(28764), se = ne(18665), oe = ne(60997), ce = ne(62510), he = ne(57620), ge = ne(68039), ve = ne(63668), me = ne(95328), be = ne(91397), pe = ne(34731), $e = ne(27177), ye = ne(81361), Se = ne(42283), we = ne(44388), Pe = ne(79814), Te = ne(65114), Ee = ne(331), Me = ne(70016), Ae = ne(91520), Ne = ne(16368), Ce = ne(41735), Ie = ne(77874), xe = ne(9827), Ue = ne(13034), ke = ne(67883), Le = ne(94938), De = ne(43752), Re = ne(96953), Oe = ne(38925), Be = "Outdated", Fe = function(dt) {
          function ot(et, st) {
            var mt = dt.call(this, { onRestore: function() {
              return mt.onRestore();
            } }) || this;
            mt.context = et, mt.lastManifestUpdateId = 0, mt.dispatchQualityRemovedEvent = function(bt) {
              var it = mt.getAdaptationSet(bt._internalId);
              if (it) {
                var ht = function(vt) {
                  mt.context.eventHandler.dispatchEvent(vt, { quality: { id: bt._id, bitrate: bt._bandwidth } });
                };
                Pe.MimeTypeHelper.isAudio(it._mimeType) ? ht(ce.PlayerEvent.AudioQualityRemoved) : Pe.MimeTypeHelper.isVideo(it._mimeType) && ht(ce.PlayerEvent.VideoQualityRemoved);
              }
            }, mt.copyRequiredPropertiesToRepresentations = function(bt) {
              (bt.Representation || []).forEach(function(it) {
                bt._codecs && !it._codecs && (it._codecs = bt._codecs), bt._width && !it._width && (it._width = bt._width), bt._height && !it._height && (it._height = bt._height);
              }), delete bt.SegmentTemplate;
            }, mt.sourceContext = st, mt.settings = et.settings, mt.excludedRepresentations = [];
            var St = mt.sourceContext.sourceIdentifier;
            return mt.synchronizedTimeService = et.serviceManager.get(se.ServiceName.SynchronizedTimeService, St), mt.sourceStore = et.serviceManager.get(se.ServiceName.SourceStoreService, St), mt;
          }
          return ae(ot, dt), Object.defineProperty(ot.prototype, "mpdExtractor", { get: function() {
            return this._mpdExtractor || (this._mpdExtractor = new De.MPDExtractor(this.context, this.sourceContext)), this._mpdExtractor;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(ot.prototype, "manifest", { get: function() {
            var et;
            return (0, Ie.getManifest)((et = this.sourceStore) === null || et === void 0 ? void 0 : et.getState());
          }, enumerable: !1, configurable: !0 }), ot.prototype.setManifest = function(et) {
            this.sourceStore.dispatch((0, Ce.setManifestAction)(this.preProcessManifest(et)));
          }, ot.prototype.updateManifest = function(et) {
            var st = this;
            this.lastManifestUpdateId++;
            var mt = this.lastManifestUpdateId;
            return this.synchronizeWithTimeserver(et).then(function() {
              return st.ensureStillSameOperation(mt), st.adjustManifestToKeySystemSupport(et);
            }).then(function() {
              st.ensureStillSameOperation(mt), st.reinitializeAndUpdateManifest(et);
            }).catch(function(St) {
              if (St !== Be)
                throw St;
              st.context.logger.debug("Skipping manifest update, since a newer manifest is available");
            });
          }, ot.prototype.ensureStillSameOperation = function(et) {
            if (et !== this.lastManifestUpdateId)
              throw Be;
          }, ot.prototype.adjustManifestToKeySystemSupport = function(et) {
            var st, mt, St, bt, it = this, ht = (St = (mt = (st = this.context.serviceManager) === null || st === void 0 ? void 0 : st.get(se.ServiceName.DrmService)) === null || mt === void 0 ? void 0 : mt.getUsedOrEarlyResolvedKeySystemUid()) !== null && St !== void 0 ? St : null;
            if (!ht || !et.Period || !(!((bt = this.context.serviceManager) === null || bt === void 0) && bt.has(se.ServiceName.DrmDetectorService)))
              return Promise.resolve();
            var vt = this.context.serviceManager.get(se.ServiceName.DrmDetectorService), gt = Je(et, this.mpdExtractor), Tt = gt.audioCapabilities, rt = gt.videoCapabilities;
            return vt.getSupportedCapabilities(ht, Tt, rt).then(function(He) {
              return Xe(et, He, it.context.logger);
            });
          }, ot.prototype.reinitializeAndUpdateManifest = function(et) {
            if ((0, $e.isContextAvailable)(this.context) && this.context.serviceManager) {
              if (this.disposeMpdExtractor(), et.isInitialized = !1, this.setManifest(et), this.isLive()) {
                var st = this.getFirstPeriod(), mt = this.isHlsManifest() && st ? st.start : (0, Ee.toSeconds)(this.getAvailabilityStartTime());
                this.sourceStore.dispatch((0, me.setStartTimeOffset)(mt));
              }
              this.mpdExtractor.adjustPeriodStartTimes();
              var St = this.parseStreamDuration();
              (0, he.maybeFireDurationChangedEvent)(this.parsedDuration, St, this.context.eventHandler), this.parsedDuration = St, this.setManifestInitialized(!0), this.context.serviceManager.maybeCall(se.ServiceName.HeartbeatService, function(bt) {
                bt.started && bt.beat();
              }, void 0, this.context.sourceContext.sourceIdentifier);
            }
          }, ot.prototype.excludeRepresentations = function(et) {
            var st = this, mt = et.map(function(it) {
              return st.getRepresentationById(it);
            }).filter(function(it) {
              return !!it;
            });
            this.setManifestInitialized(!1);
            var St = at(this.manifest.Period);
            this.excludedRepresentations = ye.ArrayHelper.union(this.excludedRepresentations, et), this.sourceStore.dispatch((0, Ce.removeRepresentationsAction)(this.excludedRepresentations));
            var bt = at(this.manifest.Period);
            return Object.keys(St).every(function(it) {
              return bt[it] != null && St[it].length === bt[it].length;
            }) ? (this.disposeMpdExtractor(), mt.forEach(this.dispatchQualityRemovedEvent), this.setManifestInitialized(!0), !0) : (this.context.eventHandler.fireError(new le.PlayerError(fe.ErrorCode.SOURCE_ERROR, void 0, "No playable track left")), !1);
          }, ot.prototype.isRepresentationExcluded = function(et) {
            return this.excludedRepresentations.some(function(st) {
              return st.equals(et);
            });
          }, ot.prototype.resetExcludedRepresentations = function() {
            this.excludedRepresentations = [];
          }, ot.prototype.onRestore = function() {
            this.setPlayerDRM(this.getManifest()), this.sourceStore.dispatch((0, Ce.setManifestAction)(Ke(this.getManifest())));
          }, ot.getSupplementalProperties = function(et, st) {
            return !et.SupplementalProperty || et.SupplementalProperty.length <= 0 ? null : et.SupplementalProperty.filter(function(mt) {
              return mt._schemeIdUri === st;
            });
          }, ot.prototype.findMatchingSwitchableAdaptationSets = function(et, st, mt) {
            var St = mt && mt.length > 0;
            if (!St && !this.settings.ADAPTATION_SET_SWITCHING_WITHOUT_SUPPLEMENTAL_PROPERTY)
              return null;
            var bt = [], it = et._group, ht = lt(et);
            return St && mt.forEach(function(vt) {
              return bt.push(vt._value);
            }), this.settings.ADAPTATION_SET_SWITCHING_WITHOUT_SUPPLEMENTAL_PROPERTY && st.forEach(function(vt) {
              bt.includes(vt._id) || bt.push(vt._id);
            }), st.filter(function(vt) {
              if (!bt.includes(vt._id) || vt._id === et._id)
                return !1;
              var gt = vt._group === it, Tt = vt._mimeType === et._mimeType, rt = lt(vt) === ht, He = vt._lang === et._lang;
              return Tt && rt && gt && He;
            });
          }, ot.prototype.getSwitchableAdaptationSets = function(et) {
            var st = this;
            return et.AdaptationSet ? et.AdaptationSet.reduce(function(mt, St) {
              var bt = ot.getSupplementalProperties(St, "urn:mpeg:dash:adaptation-set-switching:2016"), it = st.findMatchingSwitchableAdaptationSets(St, et.AdaptationSet, bt);
              return it && it.length !== 0 ? ye.ArrayHelper.addAndMergeIntersects(mt, _e([St], it, !0)) : mt;
            }, []) : [];
          }, ot.mergeAdaptationSetProperties = function(et, st, mt) {
            var St = et.hasOwnProperty(mt), bt = st.hasOwnProperty(mt);
            (St || bt) && (St ? bt || (st[mt] = []) : et[mt] = [], et[mt] = et[mt].concat(st[mt]));
          }, ot.prototype.getAdaptationSetPropertyValues = function(et, st) {
            return et.filter(function(mt) {
              return mt.hasOwnProperty(st);
            }).map(function(mt) {
              return mt[st];
            });
          }, ot.prototype.updateAdaptationSetMinMaxValues = function(et, st) {
            var mt = [et].concat(st), St = this.getAdaptationSetPropertyValues(mt, "_minWidth"), bt = this.getAdaptationSetPropertyValues(mt, "_maxWidth"), it = this.getAdaptationSetPropertyValues(mt, "_minHeight"), ht = this.getAdaptationSetPropertyValues(mt, "_maxHeight"), vt = this.getAdaptationSetPropertyValues(mt, "_minBandwidth"), gt = this.getAdaptationSetPropertyValues(mt, "_maxBandwidth");
            St.length > 0 && (et._minWidth = Math.min.apply(null, St)), bt.length > 0 && (et._maxWidth = Math.max.apply(null, bt)), it.length > 0 && (et._minHeight = Math.min.apply(null, it)), ht.length > 0 && (et._maxHeight = Math.max.apply(null, ht)), vt.length > 0 && (et._minBandwidth = Math.min.apply(null, vt)), gt.length > 0 && (et._maxBandwidth = Math.max.apply(null, gt));
          }, ot.prototype.mergeAdaptationSets = function(et, st) {
            st.forEach(this.copyRequiredPropertiesToRepresentations);
            var mt = st.shift();
            st.forEach(function(St) {
              ["Representation", "ContentComponent", "ContentProtection", "SupplementalProperty"].forEach(function(bt) {
                return ot.mergeAdaptationSetProperties(mt, St, bt);
              });
            }), this.updateAdaptationSetMinMaxValues(mt, st), et.AdaptationSet = et.AdaptationSet.filter(function(St) {
              return !st.includes(St);
            });
          }, ot.prototype.mergeSwitchableAdaptationSets = function(et) {
            var st = this;
            return et.Period.forEach(function(mt) {
              st.getSwitchableAdaptationSets(mt).forEach(function(St) {
                st.mergeAdaptationSets(mt, St);
              });
            }), et;
          }, ot.prototype.setRepresentationDrmKid = function(et, st) {
            this.sourceStore.dispatch((0, Ce.setRepresentationDrmKidAction)(et, st));
          }, ot.prototype.getRepresentationDrmKid = function(et) {
            var st;
            return (st = this.getRepresentationById(et)) === null || st === void 0 ? void 0 : st.associatedKid;
          }, ot.prototype.setManifestInitialized = function(et) {
            this.sourceStore.dispatch((0, Ce.setManifestInitializedAction)(et));
          }, ot.prototype.setPlayerDRM = function(et) {
            var st = this.sourceContext.source.drm, mt = Ve(et), St = {};
            mt.length > 0 && (St = ue({}, mt[0])), st != null && Object.keys(st).length > 0 && Object.keys(st).forEach(function(it) {
              St[it] = St[it] != null ? ue(ue({}, St[it]), st[it]) : st[it];
            }), this.addDrmServiceAndSetDrmConfig(St);
            var bt = Object.keys(St).length > 0 ? (0, ve.setManifestDrm)(St) : (0, ve.resetManifestDrm)();
            this.sourceStore.dispatch(bt);
          }, ot.prototype.addDrmServiceAndSetDrmConfig = function(et) {
            if (Ae.ModuleManager.has(Ne.ModuleName.DRM) && Object.keys(et).length > 0 && !this.context.serviceManager.has(se.ServiceName.DrmService)) {
              var st = Ae.ModuleManager.get(Ne.ModuleName.DRM).DrmService;
              this.context.serviceManager.set(se.ServiceName.DrmService, new st(this.context));
            }
            this.context.serviceManager.maybeCall(se.ServiceName.DrmService, function(mt) {
              mt.isDrmConfigSet() || mt.setDrmConfig(et);
            });
          }, ot.prototype.getPreviousRepDrmKidAssociation = function() {
            var et = /* @__PURE__ */ new Map();
            return this.getAllRepresentations().filter(function(st) {
              return st._internalId && st.associatedKid;
            }).forEach(function(st) {
              return et.set(st._internalId.key(), st.associatedKid);
            }), et;
          }, ot.prototype.preProcessManifest = function(et) {
            var st = this.getPreviousRepDrmKidAssociation();
            return et.Period && et.Period.length > 0 ? (Ze(et = (0, Le.orderAdaptationSetsByCodec)(et, ft(this.context.config, this.sourceContext.source))), et = this.mergeSwitchableAdaptationSets(et), Ae.ModuleManager.has(Ne.ModuleName.Envivio) && (et = Ae.ModuleManager.get(Ne.ModuleName.Envivio).fixSegmentTimelineLiveStream(et)), this.isSuspended() || this.setPlayerDRM(et), et = Ke(et), nt(et = (0, Le.removeRepresentations)(et, this.excludedRepresentations), st), et) : (this.context.eventHandler.fireError(new le.PlayerError(fe.ErrorCode.SOURCE_ERROR, void 0, "No playable track left")), null);
          }, ot.prototype.parseStreamDuration = function() {
            if (this.mpdExtractor) {
              var et = NaN, st = this.mpdExtractor.getDuration();
              return st && (this.cachedDurationString && this.cachedDurationString === st ? et = this.cachedDuration : (et = we.DurationConverter.getDurationInSec(st), this.cachedDurationString = st, this.cachedDuration = et)), isNaN(et) && this.isLive() ? 1 / 0 : et;
            }
            return 0;
          }, ot.prototype.getDuration = function() {
            return this.parsedDuration;
          }, ot.prototype.isLive = function() {
            return !!this.manifest && this.mpdExtractor.isLive();
          }, ot.prototype.getAvailabilityStartTime = function() {
            return this.mpdExtractor.getAvailabilityStartTime();
          }, ot.prototype.getAvailabilityEndTime = function() {
            return this.mpdExtractor.getAvailabilityEndTime();
          }, ot.prototype.isAvailabilityEndTimeExceeded = function() {
            var et = this.getAvailabilityEndTime();
            return et && Date.now() > et.getTime();
          }, ot.prototype.findPeriod = function(et) {
            return (0, Te.findPeriod)(this.manifest, et);
          }, ot.prototype.getAllPeriods = function() {
            return this.manifest && this.manifest.Period ? this.manifest.Period : [];
          }, ot.prototype.getPeriod = function(et) {
            return et ? this.findPeriod(et.periodId) : null;
          }, ot.prototype.isLanguageAvailable = function(et, st, mt) {
            var St = (0, Te.findPeriod)(this.manifest, et) || pt(this.manifest);
            return (0, Ue.findAdaptationSetsForMimeType)(St, st).some(function(bt) {
              var it = bt._lang && mt.lang && bt._lang === mt.lang, ht = mt.adaptationSetId && bt._internalId.equals(mt.adaptationSetId);
              return it || ht;
            });
          }, ot.prototype.findAdaptationSet = function(et, st, mt, St) {
            St === void 0 && (St = !1);
            var bt = (0, Te.findPeriod)(this.manifest, et) || pt(this.manifest);
            if (bt !== void 0) {
              var it = this.sourceStore.getState(), ht = (0, Ue.findAdaptationSetOfMimeType)(st, bt, { sourceState: it, langObj: mt, periodSwitched: St, playbackConfig: this.context.config.playback });
              return ht || this.context.logger.debug("No AdaptationSet found to match mime type " + st), ht;
            }
          }, ot.prototype.getManifest = function() {
            return this.manifest;
          }, ot.prototype.getAvailableAudio = function(et, st) {
            return this.mpdExtractor.getAvailableAudio(et, st);
          }, ot.prototype.getAvailableVideo = function(et) {
            return this.mpdExtractor.getAvailableVideo(et);
          }, ot.prototype.getAvailableSubtitles = function(et) {
            return this.mpdExtractor.getAvailableSubtitles(et);
          }, ot.prototype.getClosedCaptionLabels = function(et) {
            return this.mpdExtractor.getClosedCaptionLabels(et);
          }, ot.prototype.getVideoRepresentations = function(et) {
            return this.mpdExtractor.getVideoQualities(et);
          }, ot.prototype.getAudioRepresentations = function(et) {
            return this.mpdExtractor.getAudioQualities(et);
          }, ot.prototype.getPeriodDuration = function(et, st) {
            var mt;
            return this.mpdExtractor.getPeriodDuration(et, st ?? ((mt = this.getManifest()) === null || mt === void 0 ? void 0 : mt.Period));
          }, ot.prototype.hasMultiplePeriods = function() {
            return this.manifest && this.manifest.Period && this.manifest.Period.length > 1;
          }, ot.prototype.hasSinglePeriod = function() {
            return this.manifest && this.manifest.Period && this.manifest.Period.length === 1;
          }, ot.prototype.getTimeShiftBufferDepthSeconds = function() {
            return this.mpdExtractor.getTimeShiftBufferDepthSeconds();
          }, ot.prototype.getRequestTimestamp = function() {
            return this.mpdExtractor.getRequestTimestamp();
          }, ot.prototype.getMediaPresentationDuration = function() {
            var et, st = we.DurationConverter.getDurationInSec((et = this.manifest) === null || et === void 0 ? void 0 : et._mediaPresentationDuration);
            return isNaN(st) ? 0 : st;
          }, ot.prototype.calculateCumulativePeriodDuration = function(et) {
            for (var st, mt, St = 0, bt = 0, it = (mt = (st = this.manifest) === null || st === void 0 ? void 0 : st.Period) !== null && mt !== void 0 ? mt : []; bt < it.length; bt++) {
              var ht = it[bt];
              if (ht._id === et)
                break;
              St += this.getPeriodDuration(ht._id);
            }
            return this.isLive() ? (0, Ee.toSeconds)(Date.now() - this.getAvailabilityStartTime()) - St : St;
          }, ot.prototype.getMinimumUpdatePeriod = function() {
            return (0, De.getMinimumUpdatePeriodInSeconds)(this.manifest);
          }, ot.prototype.getContentProtectionForAdaptationSet = function(et) {
            return De.MPDExtractor.getContentProtectionForAdaptationSet(et);
          }, ot.prototype.getLangObjectFromAdaptationSet = function(et, st) {
            return this.mpdExtractor.getLangObjectFromAdaptationSet(et, st);
          }, ot.prototype.toSubtitleTrack = function(et, st) {
            return this.mpdExtractor.toSubtitleTrack(et, st);
          }, ot.prototype.getDRMCapabilitiesForPeriod = function(et) {
            return this.mpdExtractor.getDRMCapabilitiesForPeriod(et);
          }, ot.prototype.hasManifestTypeChanged = function(et) {
            return !(!this.manifest || this.manifest._type === et) && (this.context.logger.log("Manifest has just changed from " + this.manifest._type + " to " + et), !0);
          }, ot.prototype.getPeriodIdForTime = function(et) {
            var st;
            if (this.manifest) {
              var mt = this.manifest.Period;
              return mt.length === 1 ? mt[0]._id : (st = qe(mt, et)) === null || st === void 0 ? void 0 : st._id;
            }
          }, ot.prototype.dispose = function() {
            this.disposeMpdExtractor(), dt.prototype.dispose.call(this);
          }, ot.prototype.disposeMpdExtractor = function() {
            this._mpdExtractor = (0, oe.dispose)(this._mpdExtractor);
          }, ot.prototype.getTotalDurationFromManifest = function() {
            var et = this.getFirstPeriod();
            if (this.cachedDuration && et && et.start)
              return et.start + this.cachedDuration;
          }, ot.prototype.getTotalDuration = function() {
            if (this.isLive())
              return this.getTotalDurationFromManifest() || 1 / 0;
            var et = this.getLastPeriod();
            return et ? (et.start || et._start && we.DurationConverter.getDurationInSec(et._start) || 0) + this.mpdExtractor.getPeriodDuration(et._id) : 0;
          }, ot.prototype.getFirstPeriod = function() {
            return pt(this.manifest);
          }, ot.prototype.getLastPeriod = function() {
            if (this.manifest && this.manifest.Period.length > 0)
              return this.manifest.Period[this.manifest.Period.length - 1];
          }, ot.prototype.isLastPeriod = function(et) {
            var st = this.getLastPeriod();
            return !!st && et === st._id;
          }, ot.prototype.isManifestFinalized = function() {
            return !this.isLive();
          }, ot.prototype.isFirstPeriod = function(et) {
            var st = this.getFirstPeriod();
            return !!st && st._id === et;
          }, ot.prototype.isHlsManifest = function() {
            var et, st;
            return (st = (et = this.getManifest()) === null || et === void 0 ? void 0 : et._isHls) !== null && st !== void 0 && st;
          }, ot.prototype.isDashManifest = function() {
            return !this.isHlsManifest() && !this.isSmoothManifest();
          }, ot.prototype.isSmoothManifest = function() {
            var et, st;
            return ((st = (et = this.manifest) === null || et === void 0 ? void 0 : et.originalFormat) === null || st === void 0 ? void 0 : st.format) === "smooth";
          }, ot.prototype.getHlsTags = function() {
            if (!this.isHlsManifest())
              return null;
            var et = Ae.ModuleManager.get(Ne.ModuleName.HLS).selectors, st = et.getHlsState;
            return (0, et.getCustomTags)(st(this.sourceStore.getState()));
          }, ot.prototype.isMimeTypePartOfPeriod = function(et, st) {
            var mt = this.getPeriod(new Re.PeriodId(st));
            return (mt ? mt.AdaptationSet : []).some(function(St) {
              return St._mimeType === et;
            });
          }, ot.prototype.getNextPeriod = function(et) {
            if (this.manifest)
              for (var st = this.findPeriod(et), mt = this.manifest.Period.indexOf(st) + 1; mt < this.manifest.Period.length; mt++) {
                var St = this.manifest.Period[mt];
                if (St)
                  return St;
              }
            return null;
          }, ot.prototype.getEventStreamEvents = function(et) {
            return this.mpdExtractor.getEventStreamEvents(et);
          }, ot.prototype.hasAdaptationSets = function(et) {
            var st = this.manifest;
            if (st && st.Period) {
              var mt = st.Period.find(function(St) {
                return St._id === et;
              });
              return !!(mt && mt.AdaptationSet);
            }
            return !1;
          }, ot.prototype.synchronizeWithTimeserver = function(et) {
            if (this.synchronizedTimeService) {
              var st = this.synchronizedTimeService.getSynchronizationPromise();
              if (st)
                return st;
              if (et.UTCTiming && et.UTCTiming.length > 0)
                return this.synchronizedTimeService.synchronizeWithServer(et.UTCTiming, et._downloadTime);
            }
            return Promise.resolve();
          }, ot.prototype.getAdaptationSet = function(et) {
            if (et && this.manifest)
              return (0, Te.findAdaptationSet)(this.manifest, et);
          }, ot.prototype.getRepresentationById = function(et) {
            if (et && this.manifest)
              return (0, Te.findRepresentation)(this.manifest, et);
          }, ot.prototype.representationExists = function(et) {
            return !!this.getRepresentationById(et);
          }, ot.prototype.getLowestBandwidthOfAdaptationSet = function(et) {
            return this.findLowestPossibleBandwidth(et, -1 / 0);
          }, ot.prototype.findLowestPossibleBandwidth = function(et, st) {
            st === void 0 && (st = -1 / 0);
            var mt = this.getAdaptationSet(et);
            return mt ? je(mt.Representation, st) : 1 / 0;
          }, ot.prototype.getMatchingRepresentationsByBandwidth = function(et, st, mt) {
            mt === void 0 && (mt = function() {
              return !0;
            });
            var St = this.getAdaptationSet(et);
            return St ? tt(St.Representation, st, mt) : [];
          }, ot.prototype.getMatchingRepresentationByBandwidth = function(et, st, mt) {
            mt === void 0 && (mt = function() {
              return !0;
            });
            var St = this.getAdaptationSet(et);
            return St ? yt(St.Representation, st, mt) : null;
          }, ot.prototype.getAllRepresentations = function() {
            return this.getAllPeriods().flatMap(function(et) {
              var st;
              return ((st = et.AdaptationSet) === null || st === void 0 ? void 0 : st.flatMap(function(mt) {
                return mt.Representation;
              })) || [];
            });
          }, ot.prototype.getRepresentation = function(et, st) {
            return this.getRepresentationById(new Oe.RepresentationId(et, st));
          }, ot.prototype.getAllAdaptationSets = function() {
            return this.getAllPeriods().flatMap(function(et) {
              return et.AdaptationSet;
            });
          }, ot.prototype.getAllImageAdaptationSets = function() {
            return this.getAllAdaptationSets().filter(function(et) {
              return et._mimeType.includes("image") && et._contentType === "image";
            });
          }, ot.prototype.getAllDashThumbnailSources = function() {
            var et = this;
            return this.getAllImageAdaptationSets().map(function(st) {
              var mt = et.findPeriod(st._internalId.periodId);
              return { adaptationSet: st, timing: { startTime: mt.start, duration: mt.duration } };
            });
          }, ot.prototype.getAdaptationSetIndex = function(et) {
            var st = this.findPeriod(et.periodId);
            return st && st.AdaptationSet && st.AdaptationSet.length !== 0 ? st.AdaptationSet.findIndex(function(mt) {
              return mt._internalId.equals(et);
            }) : -1;
          }, ot.prototype.getAvailableBaseURLsForRepresentation = function(et) {
            var st = this.getAdaptationSet(et);
            if (et === void 0 || !st)
              return [];
            for (var mt = [], St = st.Representation, bt = 0; bt < St.length; bt++)
              if (St[bt]._internalId.equals(et) && St[bt].BaseURL && St[bt].BaseURL.length > 0) {
                mt = St[bt].BaseURL;
                break;
              }
            var it = [];
            for (bt = 0; bt < mt.length; bt++)
              it.push((0, be.forceReallocation)(mt[bt].url));
            return it;
          }, ot.prototype.findDownloadedHlsRepresentation = function(et) {
            var st = this.getAdaptationSet(et);
            return st ? st.Representation.find(function(mt) {
              return mt._hls && !!mt._hls.requestTimestamp;
            }) : null;
          }, ot.prototype.isManifestFetchRequired = function(et) {
            if (!this.isHlsManifest())
              return !1;
            var st = Date.now(), mt = this.getRepresentationById(et), St = !!mt.SegmentList && mt.SegmentList.length > 0 && !!mt.SegmentList[0].SegmentURL, bt = St ? mt.SegmentList[0].SegmentURL.length : 0, it = !St || bt > 0, ht = st - (mt._requestTimestamp || st), vt = this.isLive() && ht >= this.getMinimumUpdatePeriod();
            return !it || vt;
          }, ot.prototype.hasSelfInitialisingSegments = function() {
            return this.manifest.Period.map(function(et) {
              return et.AdaptationSet;
            }).reduce(function(et, st) {
              return et.concat(st);
            }, []).map(function(et) {
              return et.Representation;
            }).reduce(function(et, st) {
              return et.concat(st);
            }, []).some(function(et) {
              var st = et.SegmentList && et.SegmentList.length > 0 ? et.SegmentList : [], mt = !!et.SegmentBase && et.SegmentBase.length > 0, St = et.SegmentTemplate && et.SegmentTemplate.length > 0 ? et.SegmentTemplate : [];
              return !(et.init || mt || st.some(function(bt) {
                return !!bt.init;
              }) || St.some(function(bt) {
                return !!bt._initialization;
              }));
            });
          }, ot.prototype.getAvailabilityTimeComplete = function(et) {
            var st = this.getRepresentationById(et), mt = st.SegmentList || st.SegmentBase || st.SegmentTemplate;
            return !(mt && mt[0] && mt[0]._availabilityTimeComplete) || JSON.parse(mt[0]._availabilityTimeComplete);
          }, ot.prototype.isSegmentInfoLoaded = function(et) {
            var st = this.getRepresentationById(et);
            return !!st && !(!st.segmentIndex && !st.segmentIndexParsingError);
          }, ot.prototype.isPrecedingPeriod = function(et, st) {
            if (!(et && st && this.manifest && this.manifest.Period))
              return !1;
            var mt = this.manifest.Period.findIndex(function(bt) {
              return bt._id === et;
            }), St = this.manifest.Period.findIndex(function(bt) {
              return bt._id === st;
            });
            return mt >= 0 && St >= 0 && St < mt;
          }, ot.prototype.getMaxSegmentDuration = function() {
            var et = we.DurationConverter.getDurationInSec(this.manifest._maxSegmentDuration);
            return isNaN(et) ? 0 : et;
          }, ot.prototype.getDesiredDistanceToLiveEdge = function() {
            var et, st = (et = this.context.serviceManager.get(se.ServiceName.LiveLatencyService)) === null || et === void 0 ? void 0 : et.getTargetLatency();
            return (0, Me.isDefined)(st) ? st : this.context.bufferSettings.getForwardTargetLevel() + this.settings.LIVE_EDGE_DISTANCE;
          }, ot.prototype.hasSuggestedStartPosition = function() {
            return this.manifest.hasOwnProperty("_startOffset");
          }, ot.prototype.getVodStartOffset = function() {
            return Math.max(0, Math.min(this.manifest._startOffset, this.getDuration() - this.settings.SEEK_TO_END_OFFSET));
          }, ot.prototype.getLiveStartOffset = function(et) {
            et === void 0 && (et = !0);
            var st = this.manifest._startOffset;
            return st -= Math.abs(this.getTimeShiftBufferDepthSeconds()), et && (st += this.getDesiredDistanceToLiveEdge(), st = Math.min(0, st)), st;
          }, ot.prototype.initSegmentStartTimesFromReferenceSegment = function(et) {
            this.sourceStore.dispatch((0, Ce.initPlaybackTimesFromReferenceSegment)(et));
          }, ot.prototype.initializeSegmentStartTimesFromStart = function(et) {
            var st, mt, St = this.getRepresentationById(et), bt = (mt = (st = St == null ? void 0 : St.SegmentList) === null || st === void 0 ? void 0 : st[0]) === null || mt === void 0 ? void 0 : mt.SegmentURL;
            if (St && (bt != null && bt.length)) {
              var it = bt.length - 1, ht = (0, Ee.toSeconds)(St._requestTimestamp) - bt[it]._duration;
              this.context.logger.debug("Initializing segment start times with start time of last segment ".concat(ht), et), this.sourceStore.dispatch((0, Ce.initPlaybackTimesFromIndex)(et, it, ht));
            } else
              this.context.logger.debug("Failed to initialize segment start times, no segments found", et);
          }, ot.prototype.hasSegmentStartTimeForHlsRepresentation = function(et) {
            var st, mt, St, bt = this.getRepresentationById(et);
            return ((St = (mt = (st = bt == null ? void 0 : bt.SegmentList) === null || st === void 0 ? void 0 : st[0]) === null || mt === void 0 ? void 0 : mt.SegmentURL[0]) === null || St === void 0 ? void 0 : St._playbackTime) !== void 0;
          }, ot.prototype.getStartTimeForHlsSegment = function(et, st) {
            var mt, St, bt, it, ht, vt = this.getRepresentationById(et), gt = (bt = (St = (mt = vt == null ? void 0 : vt.SegmentList) === null || mt === void 0 ? void 0 : mt[0]) === null || St === void 0 ? void 0 : St.SegmentURL) !== null && bt !== void 0 ? bt : [], Tt = (0, xe.findSegmentUrlIndexWithinSegmentList)(st, gt);
            return Tt !== -1 && gt[Tt]._playbackTime !== void 0 ? gt[Tt]._playbackTime : (ht = (it = pt(this.manifest)) === null || it === void 0 ? void 0 : it.start) !== null && ht !== void 0 ? ht : void 0;
          }, ot.prototype.isTimeNearPeriodEnd = function(et, st) {
            for (var mt = this.getAllPeriods(), St = 0, bt = mt; St < bt.length; St++) {
              var it = bt[St], ht = it.start, vt = ht + this.getPeriodDuration(it._id, mt);
              if (et >= ht && et <= vt)
                return vt - et <= st;
            }
            return !1;
          }, ot;
        }(pe.Suspendable);
        function Ve(dt) {
          return dt.Period == null ? [] : dt.Period.filter(function(ot) {
            return ot.AdaptationSet && ot.AdaptationSet.length > 0;
          }).reduce(function(ot, et) {
            return ot.concat(et.AdaptationSet);
          }, []).filter(function(ot) {
            return ot.ContentProtection && ot.ContentProtection.length > 0;
          }).flatMap(function(ot) {
            return ot.ContentProtection;
          }).filter(function(ot) {
            return ot.laurl != null && ot.laurl.length > 0;
          }).flatMap(function(ot) {
            return ot.laurl.map(function(et) {
              return ue(ue({}, et), { drmType: ge.DRMSchemeIDURIs[ot._schemeIdUri] });
            });
          }).filter(function(ot) {
            return ot.drmType != null;
          }).map(function(ot) {
            var et;
            return (et = {})[ot.drmType] = { LA_URL: ot._licenseUrl }, et;
          });
        }
        function Ke(dt) {
          var ot;
          return (dt = ue({}, dt)).Period = (ot = dt.Period) === null || ot === void 0 ? void 0 : ot.map(function(et) {
            var st;
            return ue(ue({}, et), { AdaptationSet: (st = et.AdaptationSet) === null || st === void 0 ? void 0 : st.map(function(mt, St) {
              var bt, it = (0, ke.createAdaptationSetIdFromMimeTypeAndIndex)(et._id, mt._mimeType, St);
              return ue(ue({}, mt), { _internalId: it, _periodId: et._id, Representation: (bt = mt.Representation) === null || bt === void 0 ? void 0 : bt.map(function(ht) {
                return ue(ue({}, ht), { _internalId: new Oe.RepresentationId(it, ht._id) });
              }) });
            }) });
          }), dt;
        }
        function Ze(dt) {
          if (Ae.ModuleManager.has(Ne.ModuleName.DRM)) {
            var ot = Ae.ModuleManager.get(Ne.ModuleName.DRM).ContentProtectionHelper.getFirstKeyId;
            Qe(dt, function(et) {
              for (var st = ot(et.ContentProtection), mt = 0; et.Representation && mt < et.Representation.length; mt++) {
                var St = et.Representation[mt];
                (st || St.ContentProtection) && (St.associatedKid = St.ContentProtection && ot(St.ContentProtection) || st);
              }
            });
          }
        }
        function nt(dt, ot) {
          dt.Period.flatMap(function(et) {
            var st;
            return (st = et == null ? void 0 : et.AdaptationSet) !== null && st !== void 0 ? st : [];
          }).flatMap(function(et) {
            var st;
            return (st = et == null ? void 0 : et.Representation) !== null && st !== void 0 ? st : [];
          }).forEach(function(et) {
            ot.has(et._internalId.key()) && (et.associatedKid = ot.get(et._internalId.key()));
          });
        }
        function Qe(dt, ot) {
          for (var et = 0; dt.Period && et < dt.Period.length; et++)
            for (var st = dt.Period[et], mt = 0; st.AdaptationSet && mt < st.AdaptationSet.length; mt++)
              ot(st.AdaptationSet[mt]);
        }
        function qe(dt, ot) {
          if (dt && dt.length) {
            if (ot < dt[0].start)
              return dt[0];
            var et = dt[dt.length - 1];
            return ot >= et.start ? et : ze(dt, ot) || et;
          }
        }
        function ze(dt, ot) {
          for (var et = 0; et < dt.length - 1; et++) {
            var st = dt[et].start + dt[et].duration;
            if (ot >= dt[et].start && ot < st)
              return dt[et];
            if (ot >= st && ot < dt[et + 1].start)
              return dt[et + 1];
          }
        }
        function je(dt, ot) {
          return ot === void 0 && (ot = -1 / 0), dt.reduce(function(et, st) {
            return st._bandwidth >= ot ? Math.min(et, st._bandwidth) : et;
          }, 1 / 0);
        }
        function tt(dt, ot, et) {
          et === void 0 && (et = function() {
            return !0;
          });
          var st = dt.filter(et), mt = st.filter(function(St) {
            return St._bandwidth === ot;
          });
          return mt.length > 0 ? mt : ut(st, ot);
        }
        function ut(dt, ot) {
          var et = dt.map(function(st) {
            return st._bandwidth;
          }).reduce(function(st, mt) {
            return Math.abs(mt - ot) < Math.abs(st - ot) ? mt : st;
          });
          return dt.filter(function(st) {
            return st._bandwidth === et;
          });
        }
        function yt(dt, ot, et) {
          dt === void 0 && (dt = []), et === void 0 && (et = function() {
            return !0;
          });
          var st = dt.filter(et), mt = null, St = -1 / 0;
          return st.forEach(function(bt) {
            bt._bandwidth > St && bt._bandwidth <= ot && (St = bt._bandwidth, mt = bt);
          }), mt || st[0];
        }
        function $t(dt, ot, et) {
          var st = et ? "videoCodecPriority" : "audioCodecPriority";
          return ot != null && ot.options && ot.options[st] ? ot.options[st] : dt.playback && dt.playback[st] ? dt.playback && dt.playback[st] : [];
        }
        function ft(dt, ot) {
          return { video: $t(dt, ot, !0), audio: $t(dt, ot, !1) };
        }
        function pt(dt) {
          return dt == null ? void 0 : dt.Period[0];
        }
        function lt(dt) {
          var ot = (0, Le.getCodecsFromAdaptationSet)(dt);
          if (!ot || ot.length === 0)
            return null;
          var et = Se.CodecStringHelper.getExtractedCodecStrings(ot), st = dt._mimeType.split("/")[0];
          return et[st] ? Se.CodecStringHelper.extractCodec(et[st]) : null;
        }
        function Je(dt, ot) {
          var et = [], st = [];
          return dt.Period.forEach(function(mt) {
            var St = ot.getDRMCapabilitiesFromPeriod(mt);
            et = et.concat(St[0]), st = st.concat(St[1]);
          }), { audioCapabilities: et, videoCapabilities: st };
        }
        function Xe(dt, ot, et) {
          dt.Period.forEach(function(st) {
            st.AdaptationSet = st.AdaptationSet.filter(function(mt) {
              return mt.Representation = mt.Representation.filter(function(St) {
                var bt = st.ContentProtection || mt.ContentProtection, it = (bt == null ? void 0 : bt.length) > 0, ht = (0, De.getContentTypeFromMimeTypeAndCodecs)(St._mimeType, St._codecs), vt = We(ht, ot.audioCapabilities, ot.videoCapabilities);
                return it && !vt && et.debug("Representation not supported by MediaKeySystem (".concat(ht)), !it || vt;
              }), !Pe.MimeTypeHelper.isAV(mt._mimeType) || mt.Representation.length > 0;
            });
          });
        }
        function We(dt, ot, et) {
          return Pe.MimeTypeHelper.isAudio(dt) ? !!ot.find(function(st) {
            return st.contentType === dt;
          }) : !Pe.MimeTypeHelper.isVideo(dt) || !!et.find(function(st) {
            return st.contentType === dt;
          });
        }
        function Ge(dt) {
          return dt.AdaptationSet.map(function(ot) {
            return ot._mimeType;
          }).filter(function(ot, et, st) {
            return Pe.MimeTypeHelper.isAV(ot) && st.indexOf(ot) === et;
          });
        }
        function at(dt) {
          return dt.reduce(function(ot, et) {
            return ot[et._id] = Ge(et), ot;
          }, {});
        }
        ie.ManifestService = Fe;
      }, 43412: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var Se = function(we, Pe) {
            return Se = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Te, Ee) {
              Te.__proto__ = Ee;
            } || function(Te, Ee) {
              for (var Me in Ee)
                Object.prototype.hasOwnProperty.call(Ee, Me) && (Te[Me] = Ee[Me]);
            }, Se(we, Pe);
          };
          return function(we, Pe) {
            if (typeof Pe != "function" && Pe !== null)
              throw new TypeError("Class extends value " + String(Pe) + " is not a constructor or null");
            function Te() {
              this.constructor = we;
            }
            Se(we, Pe), we.prototype = Pe === null ? Object.create(Pe) : (Te.prototype = Pe.prototype, new Te());
          };
        }(), ue = this && this.__decorate || function(Se, we, Pe, Te) {
          var Ee, Me = arguments.length, Ae = Me < 3 ? we : Te === null ? Te = Object.getOwnPropertyDescriptor(we, Pe) : Te;
          if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
            Ae = Reflect.decorate(Se, we, Pe, Te);
          else
            for (var Ne = Se.length - 1; Ne >= 0; Ne--)
              (Ee = Se[Ne]) && (Ae = (Me < 3 ? Ee(Ae) : Me > 3 ? Ee(we, Pe, Ae) : Ee(we, Pe)) || Ae);
          return Me > 3 && Ae && Object.defineProperty(we, Pe, Ae), Ae;
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ManifestUpdateScheduler = void 0, ie.isRepresentationUpToDate = ye;
        var _e = ne(28764), fe = ne(18665), le = ne(90637), se = ne(16937), oe = ne(76420), ce = ne(3464), he = ne(34731), ge = ne(331), ve = ne(73553), me = ne(41735), be = ne(61743), pe = ne(35655), $e = function(Se) {
          function we(Pe, Te) {
            var Ee = Se.call(this, { onSuspend: function() {
              return Ee.onSuspend();
            }, onRestore: function() {
              return Ee.onRestore();
            } }) || this;
            Ee.initiated = !1, Ee.trackUpdaters = {}, Ee.selectActiveTracks = function(Ae) {
              return Ae == null ? void 0 : Ae.activeTracks;
            }, Ee.handleActiveTracksChange = function(Ae) {
              Ae && Ee.manifestService.isHlsManifest() && Ee.updateTracks(Ae);
            }, Ee.selectPlaybackState = function(Ae) {
              return Ae.player && Ae.player.playbackState;
            }, Ee.handlePlaybackStateChange = function(Ae) {
              Ae && (Ae === oe.PlaybackState.Paused ? Ee.stop() : Ae === oe.PlaybackState.Playing && Ee.start());
            }, Ee.updatedRepresentation = function(Ae) {
              Ee.updateAdaptationSetInManifest(Ae), Ee.manifestService.updateManifest(Ee.manifestService.getManifest()).catch(function() {
                Ee.logger.debug("Updating the manifest failed");
              });
            }, Ee.representationUpdateError = function(Ae, Ne) {
              Ee.logger.debug("Rejection while updating the representation", Ae), (Ae === le.RequestError.Failed || Ae instanceof _e.PlayerError) && (Ee.sourceStore.dispatch((0, me.updateRepresentationFailedDownloadAction)(Ne._internalId, ve.SegmentInfoError.COULD_NOT_LOAD_PLAYLIST)), Ee.manifestService.updateManifest(Ee.manifestService.getManifest()).catch(function(Ce) {
                Ee.logger.debug("Error while updating the manifest after the representation failed to load", Ce);
              }));
            }, Ee.manifestDownloadError = function() {
              Ee.logger.debug("Error while loading manifest");
            }, Ee.context = Pe, Ee.sourceContext = Te;
            var Me = Ee.sourceContext.sourceIdentifier;
            return Ee.manifestService = Pe.serviceManager.get(fe.ServiceName.ManifestService, Me), Ee.manifestLoader = Pe.serviceManager.get(fe.ServiceName.ManifestLoadingService, Me), Ee.store = Pe.store, Ee.sourceStore = Pe.serviceManager.get(fe.ServiceName.SourceStoreService, Me), Ee.eventHandler = Pe.eventHandler, Ee.logger = Pe.logger, Ee.unsubscribeFromActiveTrackChanges = Ee.subscribeToActiveTrackChanges(), Ee.unsubscribeFromPausePlayingChanges = Ee.subscribeToPausePlayingChanges(Pe), Ee;
          }
          return ae(we, Se), we.prototype.subscribeToActiveTrackChanges = function() {
            var Pe = this;
            return (0, ce.subscribe)(this.sourceStore)(function(Te) {
              return Pe.selectActiveTracks(Te);
            }, this.handleActiveTracksChange);
          }, we.prototype.updateTracks = function(Pe) {
            this.processNewActiveTrack(Pe), this.removeDeactivatedTrackUpdaters(Pe);
          }, we.prototype.processNewActiveTrack = function(Pe) {
            var Te = this;
            Object.keys(Pe).filter(function(Ee) {
              return Pe[Ee].selectedRepresentationId;
            }).forEach(function(Ee) {
              Te.updateTrackUpdater(Pe[Ee].selectedRepresentationId);
            });
          }, we.prototype.removeDeactivatedTrackUpdaters = function(Pe) {
            var Te = this;
            Object.keys(this.trackUpdaters).filter(function(Ee) {
              return !Object.keys(Pe).includes(Ee);
            }).forEach(function(Ee) {
              Te.trackUpdaters[Ee].stop(), delete Te.trackUpdaters[Ee];
            });
          }, we.prototype.subscribeToPausePlayingChanges = function(Pe) {
            return (0, ce.subscribe)(this.store)(this.selectPlaybackState, this.handlePlaybackStateChange, function() {
              return Pe.settings.STOP_DOWNLOAD_ON_PAUSE;
            });
          }, we.prototype.updateTrackUpdater = function(Pe) {
            var Te = this.manifestService.getRepresentationById(Pe), Ee = Pe.adaptationSetId;
            this.trackUpdaters[Ee] ? this.trackUpdaters[Ee].getRepresentation()._internalId.equals(Pe) || this.trackUpdaters[Ee].setRepresentation(Te) : this.trackUpdaters[Te._internalId.adaptationSetId] = this.initializeTrackUpdater(Te);
          }, we.prototype.stopRepresentationUpdates = function(Pe) {
            var Te, Ee = this.trackUpdaters[Pe._internalId.adaptationSetId];
            return (Te = Ee == null ? void 0 : Ee.stopRepresentationUpdate(Pe)) !== null && Te !== void 0 ? Te : Promise.resolve();
          }, we.prototype.scheduleRepresentationUpdate = function(Pe) {
            var Te = this.trackUpdaters[Pe._internalId.adaptationSetId];
            Te == null || Te.setRepresentation(Pe), Te == null || Te.start();
          }, we.prototype.initializeTrackUpdater = function(Pe) {
            var Te = this, Ee = new pe.RepresentationUpdater(this.context, Pe, this.manifestLoader, { success: this.updatedRepresentation, error: function(Me) {
              return Te.representationUpdateError(Me, Ee.getRepresentation());
            } });
            return Ee.start(), Ee;
          }, we.prototype.updateAdaptationSetInManifest = function(Pe) {
            this.sourceStore.dispatch((0, me.updateRepresentationAction)(Pe));
          }, we.prototype.init = function(Pe) {
            var Te = this;
            return this.manifestLoader.load(Pe).then(function(Ee) {
              return Te.manifestService.updateManifest(Ee).then(function() {
                Te.initiated = !0, Te.manifestService.isLive() && !Te.manifestService.isHlsManifest() && Te.scheduleManifestReloading(Ee);
              });
            }).catch(function(Ee) {
              return Ee instanceof _e.PlayerError || Ee instanceof Error ? Promise.reject(Ee) : Promise.reject(new Error("The loading of the manifest has failed or was cancelled"));
            });
          }, we.prototype.scheduleManifestReloading = function(Pe) {
            var Te = this;
            this.manifestUpdater = new be.ManifestUpdater(this.manifestLoader, Pe, { minAllowedUpdatePeriod: this.context.settings.MINIMUM_ALLOWED_UPDATE_PERIOD, maxAllowedUpdatePeriod: this.context.settings.MAXIMUM_ALLOWED_UPDATE_PERIOD }, { success: function(Ee) {
              return Te.manifestService.updateManifest(Ee);
            }, error: this.manifestDownloadError }), this.manifestUpdater.start();
          }, we.prototype.waitForRepUpdate = function(Pe) {
            return Object.keys(this.trackUpdaters).length === 0 || ye(this.manifestService.getRepresentationById(Pe)) ? Promise.resolve() : this.trackUpdaters[Pe.adaptationSetId].updateRepresentation().then(function() {
            });
          }, we.prototype.stop = function() {
            Object.values(this.trackUpdaters).forEach(function(Pe) {
              return Pe.stop();
            }), this.manifestUpdater && this.manifestUpdater.stop();
          }, we.prototype.start = function() {
            Object.values(this.trackUpdaters).filter(function(Pe) {
              return Pe.isStopped;
            }).forEach(function(Pe) {
              Pe.start();
            }), this.manifestUpdater && this.manifestUpdater.isStopped && this.manifestUpdater.start();
          }, we.prototype.onSuspend = function() {
            this.unsubscribeFromPausePlayingChanges();
          }, we.prototype.onRestore = function() {
            this.unsubscribeFromPausePlayingChanges = this.subscribeToPausePlayingChanges(this.context);
          }, we.prototype.isInitiated = function() {
            return this.initiated;
          }, we.prototype.dispose = function() {
            this.unsubscribeFromActiveTrackChanges(), this.unsubscribeFromPausePlayingChanges(), this.stop(), this.manifestUpdater = null, this.trackUpdaters = null, Se.prototype.dispose.call(this);
          }, ue([(0, se.trackPerformance)("ManifestUpdateScheduler.init", !0)], we.prototype, "init", null), we;
        }(he.Suspendable);
        function ye(Se) {
          var we;
          return !!Se._requestTimestamp && Se._requestTimestamp + (0, ge.toMilliSeconds)((we = Se._updateInterval) !== null && we !== void 0 ? we : 1 / 0) > Date.now();
        }
        ie.ManifestUpdateScheduler = $e;
      }, 61743: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var le = function(se, oe) {
            return le = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ce, he) {
              ce.__proto__ = he;
            } || function(ce, he) {
              for (var ge in he)
                Object.prototype.hasOwnProperty.call(he, ge) && (ce[ge] = he[ge]);
            }, le(se, oe);
          };
          return function(se, oe) {
            if (typeof oe != "function" && oe !== null)
              throw new TypeError("Class extends value " + String(oe) + " is not a constructor or null");
            function ce() {
              this.constructor = se;
            }
            le(se, oe), se.prototype = oe === null ? Object.create(oe) : (ce.prototype = oe.prototype, new ce());
          };
        }();
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ManifestUpdater = void 0;
        var ue = ne(99162), _e = ne(43752), fe = function(le) {
          function se(oe, ce, he, ge) {
            var ve = le.call(this, ge) || this;
            return ve.manifestLoader = oe, ve.manifest = ce, ve.settings = he, ve;
          }
          return ae(se, le), se.prototype.getUpdatedManifest = function() {
            return this.getPayload();
          }, se.prototype.update = function() {
            var oe = this;
            return this.manifestLoader.load(this.manifest._currentLoadingUrl).then(function(ce) {
              return oe.manifest = ce, ce;
            });
          }, se.prototype.getReloadIntervalInSeconds = function() {
            var oe = (0, _e.getMinimumUpdatePeriodInSeconds)(this.manifest);
            return isNaN(oe) ? this.settings.minAllowedUpdatePeriod : Math.min(this.settings.maxAllowedUpdatePeriod, Math.max(this.settings.minAllowedUpdatePeriod, oe));
          }, se.prototype.getLastReloadTimestamp = function() {
            return this.manifest._requestTimestamp;
          }, se;
        }(ue.AbstractUpdater);
        ie.ManifestUpdater = fe;
      }, 28171: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MediaPlayerManifestApiFactory = void 0;
        var ae = ne(18665), ue = ne(62510), _e = ne(96953), fe = function() {
          function le() {
          }
          return le.create = function(se, oe) {
            var ce = oe.serviceManager.get(ae.ServiceName.ManifestService, oe.sourceContext.sourceIdentifier);
            return new (function() {
              function he() {
                ce.isHlsManifest() ? this.hls = le.createHlsApi(ce) : ce.isSmoothManifest() || (this.dash = le.createDashApi(se, ce));
              }
              return he;
            }())();
          }, le.createDashApi = function(se, oe) {
            return new (function() {
              function ce() {
              }
              return ce.prototype.getPeriod = function() {
                var he = oe.getPeriodIdForTime(se.getCurrentTime()), ge = oe.getPeriod(new _e.PeriodId(he));
                return ge ? le.createPeriodApi(oe, ge) : null;
              }, ce.prototype.listPeriods = function() {
                return oe.getAllPeriods().map(function(he) {
                  return le.createPeriodApi(oe, he);
                });
              }, ce;
            }())();
          }, le.createHlsApi = function(se) {
            return new (function() {
              function oe() {
                this.properties = se.getHlsTags();
              }
              return oe.prototype.getVideoTracks = function() {
                return le.getVideoTracks(se, se.getFirstPeriod()._id);
              }, oe.prototype.getAudioTracks = function() {
                return le.getAudioTracks(se, se.getFirstPeriod()._id);
              }, oe.prototype.getTextTracks = function() {
                return le.getTextTracks(se, se.getFirstPeriod()._id);
              }, oe;
            }())();
          }, le.createPeriodApi = function(se, oe) {
            return new (function() {
              function ce() {
                this.id = oe._id, this.properties = {}, oe._id && (this.properties.id = oe._id), oe._start && (this.properties.start = oe._start), oe._duration && (this.properties.duration = oe._duration);
              }
              return ce.prototype.getVideoTracks = function() {
                return le.getVideoTracks(se, this.id);
              }, ce.prototype.getAudioTracks = function() {
                return le.getAudioTracks(se, this.id);
              }, ce.prototype.getTextTracks = function() {
                return le.getTextTracks(se, this.id);
              }, ce.prototype.getMetadata = function() {
                return le.getMetadata(se, this.id);
              }, ce;
            }())();
          }, le.getAudioTracks = function(se, oe) {
            return se.getAvailableAudio(oe, !1).map(function(ce) {
              var he = { id: ce.id, label: ce.label, lang: ce.lang, getQualities: function() {
                return le.getAudioQualities(se, oe, ce.id);
              } };
              return ce.role && (he.role = ce.role), he;
            });
          }, le.getVideoTracks = function(se, oe) {
            return se.getAvailableVideo(oe).map(function(ce) {
              var he = { id: ce.id, label: ce.label, getQualities: function() {
                return le.getVideoQualities(se, oe);
              } };
              return ce.role && (he.role = ce.role), he;
            });
          }, le.getTextTracks = function(se, oe) {
            return se.getAvailableSubtitles(oe);
          }, le.getMetadata = function(se, oe) {
            return se.getEventStreamEvents(se.findPeriod(oe)).map(function(ce) {
              return { type: ue.MetadataType.EVENT_STREAM, payload: ce.data, start: ce.startTime, end: ce.endTime };
            });
          }, le.getAudioQualities = function(se, oe, ce) {
            return se.getAudioRepresentations(oe)[ce] || [];
          }, le.getVideoQualities = function(se, oe) {
            return se.getVideoRepresentations(oe);
          }, le;
        }();
        ie.MediaPlayerManifestApiFactory = fe;
      }, 96953: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.PeriodId = void 0;
        var ne = function() {
          function ae(ue) {
            this._periodId = ue;
          }
          return Object.defineProperty(ae.prototype, "periodId", { get: function() {
            return this._periodId;
          }, enumerable: !1, configurable: !0 }), ae.prototype.equals = function(ue) {
            return ue != null && this.periodId === ue.periodId;
          }, ae.prototype.key = function() {
            return this.periodId;
          }, ae;
        }();
        ie.PeriodId = ne;
      }, 38925: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var fe = function(le, se) {
            return fe = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(oe, ce) {
              oe.__proto__ = ce;
            } || function(oe, ce) {
              for (var he in ce)
                Object.prototype.hasOwnProperty.call(ce, he) && (oe[he] = ce[he]);
            }, fe(le, se);
          };
          return function(le, se) {
            if (typeof se != "function" && se !== null)
              throw new TypeError("Class extends value " + String(se) + " is not a constructor or null");
            function oe() {
              this.constructor = le;
            }
            fe(le, se), le.prototype = se === null ? Object.create(se) : (oe.prototype = se.prototype, new oe());
          };
        }();
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.RepresentationId = void 0;
        var ue = ne(67883), _e = function(fe) {
          function le(se, oe) {
            var ce = fe.call(this, se.periodId, se.adaptationSetId) || this;
            return ce._representationId = oe, ce;
          }
          return ae(le, fe), Object.defineProperty(le.prototype, "representationId", { get: function() {
            return this._representationId;
          }, enumerable: !1, configurable: !0 }), le.prototype.equals = function(se) {
            return fe.prototype.equals.call(this, se) && this.representationId === (se == null ? void 0 : se.representationId);
          }, le.prototype.key = function() {
            return fe.prototype.key.call(this) + "-" + this.representationId;
          }, le.from = function(se) {
            return se._representationId && se._adaptationSetId && se._periodId ? new le(new ue.AdaptationSetId(se._periodId, se._adaptationSetId), se._representationId) : null;
          }, le;
        }(ue.AdaptationSetId);
        ie.RepresentationId = _e;
      }, 35655: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var oe = function(ce, he) {
            return oe = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ge, ve) {
              ge.__proto__ = ve;
            } || function(ge, ve) {
              for (var me in ve)
                Object.prototype.hasOwnProperty.call(ve, me) && (ge[me] = ve[me]);
            }, oe(ce, he);
          };
          return function(ce, he) {
            if (typeof he != "function" && he !== null)
              throw new TypeError("Class extends value " + String(he) + " is not a constructor or null");
            function ge() {
              this.constructor = ce;
            }
            oe(ce, he), ce.prototype = he === null ? Object.create(he) : (ge.prototype = he.prototype, new ge());
          };
        }();
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.RepresentationUpdater = void 0;
        var ue = ne(91520), _e = ne(16368), fe = ne(93109), le = ne(99162), se = function(oe) {
          function ce(he, ge, ve, me) {
            var be = oe.call(this, me) || this;
            return be.context = he, be.representation = ge, be.manifestLoader = ve, be;
          }
          return ae(ce, oe), ce.prototype.getRepresentation = function() {
            return this.representation;
          }, ce.prototype.setRepresentation = function(he) {
            this.representation._internalId.equals(he._internalId) || this.cancel(), this.representation = he, this.scheduleUpdate();
          }, ce.prototype.updateRepresentation = function() {
            return this.getPayload();
          }, ce.prototype.stopRepresentationUpdate = function(he) {
            return oe.prototype.stop.call(this), this.manifestLoader.stopRepresentationUpdate(he);
          }, ce.prototype.update = function() {
            var he = this;
            return this.manifestLoader.updateRepresentation(this.representation).then(function(ge) {
              if (he.representation._id !== ge._id)
                throw le.REPRESENTATION_UPDATE_CANCEL;
              return he.representation = ge, ge;
            });
          }, ce.prototype.getReloadIntervalInSeconds = function() {
            var he, ge;
            return this.representation._requestTimestamp ? (0, fe.isPlayingLowLatencyHls)(this.context) && (!((he = ue.ModuleManager.get(_e.ModuleName.HLS)) === null || he === void 0) && he.canMakeBlockingPlaylistReload(this.representation, this.context.settings)) ? 0 : (ge = this.representation._updateInterval) !== null && ge !== void 0 ? ge : 1 / 0 : 0;
          }, ce.prototype.getLastReloadTimestamp = function() {
            return this.representation._requestTimestamp ? this.representation._requestTimestamp : 0;
          }, ce;
        }(le.AbstractUpdater);
        ie.RepresentationUpdater = se;
      }, 10997: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.AdRestorationOptimizationService = void 0;
        var ae = ne(62510), ue = ne(76650), _e = ne(28819), fe = ne(27177), le = ne(94938), se = ne(18665), oe = ne(3872), ce = function() {
          function ge() {
            var ve = this;
            this.startOptimization = function() {
              (0, fe.isContextAvailable)(ve.context) && ve.context.eventHandler.off(ae.PlayerEvent.AdStarted, ve.startOptimization), ve.prefetchContentSegments(ve.segmentInfosToPrefetch), ve.segmentInfosToPrefetch = [];
            };
          }
          return ge.prototype.updatePlayerContext = function(ve) {
            this.mimeTypes = [], this.context = ve, this.segmentInfoService = ve.segmentInfoService, this.segmentPrefetchingService = ve.segmentPrefetchingService;
          }, ge.prototype.optimizeRestorationAfterUpcomingAdBreak = function() {
            var ve, me, be = this, pe = (me = (ve = this.getSourceState()) === null || ve === void 0 ? void 0 : ve.getState()) === null || me === void 0 ? void 0 : me.playback;
            if (!(0, fe.isContextAvailable)(this.context) || !this.segmentInfoService || !pe)
              return Promise.reject("Could not get playback state and/or SegmentInfoService");
            var $e = (0, oe.getPlaybackPosition)(pe);
            return isNaN($e) ? Promise.reject("Could not get playback position") : this.segmentInfoService.getSegmentInfos($e, this.context.settings.AD_RESTORATION_SEGMENT_PREFETCHING_DURATION).then(function(ye) {
              be.addCodecInfo(ye), be.segmentInfosToPrefetch = ye, (0, fe.isContextAvailable)(be.context) && be.context.eventHandler && be.context.eventHandler.on(ae.PlayerEvent.AdStarted, be.startOptimization);
            });
          }, ge.prototype.getSourceState = function() {
            return (0, fe.isContextAvailable)(this.context) ? this.context.serviceManager.get(se.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier) : void 0;
          }, ge.prototype.addCodecInfo = function(ve) {
            var me = (0, fe.isContextAvailable)(this.context) ? this.context.sourceContext.sourceIdentifier : void 0, be = me ? this.context.serviceManager.get(se.ServiceName.ManifestService, me) : void 0;
            be && ve.forEach(function(pe) {
              var $e = be.getAdaptationSet(pe.internalRepresentationId);
              $e && (pe.codecs = (0, le.getCodecsFromAdaptationSet)($e));
            });
          }, ge.prototype.prefetchContentSegments = function(ve) {
            var me;
            this.mimeTypes = ve.reduce(function(be, pe) {
              return pe.mimeType && !be.includes(pe.mimeType) && be.push(pe.mimeType), be;
            }, []), this.maybeCreateMetrics(), (me = this.segmentPrefetchingService) === null || me === void 0 || me.fetchAll(ve);
          }, ge.prototype.findMatchingSegmentInfo = function(ve, me) {
            var be, pe = (be = this.segmentPrefetchingService) === null || be === void 0 ? void 0 : be.getPrefetchedSegments().get(ve);
            if (pe)
              return he(pe, function($e) {
                return $e.segmentInfo;
              }).find(function($e) {
                if (!me || me.segmentNumber == null || me.startTime == null || me.duration == null)
                  return !0;
                var ye = me.segmentNumber + 1, Se = Math.round(me.startTime + me.duration), we = $e.segmentNumber === ye, Pe = $e.startTime != null && Math.round($e.startTime) === Se;
                return we || Pe;
              });
          }, ge.prototype.hasPrefetchedSegment = function(ve, me) {
            var be;
            if ((0, fe.isContextAvailable)(this.context) && this.context.sourceContext.isAd)
              return !1;
            var pe = ve;
            return typeof ve == "string" && (pe = this.findMatchingSegmentInfo(ve, me)), !(!pe || typeof pe == "string") && !!(!((be = this.segmentPrefetchingService) === null || be === void 0) && be.getPrefetchedSegment(pe));
          }, ge.prototype.getPrefetchedSegment = function(ve, me) {
            var be = this;
            if (!this.segmentPrefetchingService || !ve.mimeType)
              return null;
            var pe = this.segmentPrefetchingService.getPrefetchedSegment(ve);
            return this.segmentPrefetchingService.clearPrefetchingQueue(ve.mimeType), pe && (this.segmentPrefetchingService.removePrefetchedSegment(ve), this.segmentPrefetchingService.setShouldDownloadBeCancelledCallback(ve.mimeType, me), pe.finally(function() {
              be.segmentPrefetchingService && ve.mimeType && be.segmentPrefetchingService.removeShouldDownloadBeCancelledCallback(ve.mimeType);
            })), pe;
          }, ge.prototype.getRepresentationForPrefetchedSegment = function(ve) {
            var me, be = (me = this.segmentPrefetchingService) === null || me === void 0 ? void 0 : me.getPrefetchedSegments().get(ve);
            if (be)
              return he(be, function(pe) {
                return pe.segmentInfo.internalRepresentationId;
              }).find(Boolean);
          }, ge.prototype.maybeCreateMetrics = function() {
            var ve = this;
            if ((0, fe.isContextAvailable)(this.context)) {
              var me = this.context.store.getState();
              if (this.mimeTypes.length !== 0 && me) {
                var be = (0, _e.getMetricsState)(me);
                this.mimeTypes.forEach(function(pe) {
                  be[pe] || ve.context.store.dispatch((0, ue.initializeMetricsForMimeType)(pe, ve.context.settings));
                });
              }
            }
          }, ge.prototype.dispose = function() {
            (0, fe.isContextAvailable)(this.context) && this.context.eventHandler.off(ae.PlayerEvent.AdStarted, this.startOptimization), this.segmentInfosToPrefetch = [], this.segmentInfoService = void 0, this.segmentPrefetchingService = void 0;
          }, ge;
        }();
        function he(ge, ve) {
          var me = [];
          return ge.forEach(function(be) {
            return me.push(ve(be));
          }), me;
        }
        ie.AdRestorationOptimizationService = ce;
      }, 86674: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.calculateDownloadRates = ue, ie.filterValuesExceedingAverageByMargin = _e, ie.calcAverage = fe, ie.bpsToMbps = le;
        var ae = ne(40392);
        function ue(se) {
          return se.map(function(oe) {
            return (0, ae.bytesToBits)(oe.bytes) / oe.downloadDuration;
          }).filter(function(oe) {
            return oe < 1 / 0;
          });
        }
        function _e(se) {
          var oe = fe(se) * 1.1;
          return se.filter(function(ce) {
            return ce <= oe;
          });
        }
        function fe(se) {
          return se.reduce(function(oe, ce) {
            return oe + ce;
          }, 0) / se.length;
        }
        function le(se) {
          return se / 1024 / 1024;
        }
      }, 9140: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.resolveContainerFormat = se;
        var ae = ne(79814), ue = ne(91520), _e = ne(16368), fe = ne(73543), le = ne(58423);
        function se(he, ge, ve) {
          return ve ? oe(he, ge) : ce(he);
        }
        function oe(he, ge) {
          var ve, me = ue.ModuleManager.has(_e.ModuleName.ContainerMP4), be = (ve = ue.ModuleManager.get(_e.ModuleName.ContainerMP4, !1)) === null || ve === void 0 ? void 0 : ve.isValidMp4;
          return me && be(ge) ? { source: fe.ContainerFormat.MP4, target: fe.ContainerFormat.MP4 } : ae.MimeTypeHelper.isSubtitle(he) ? ce(he) : { source: fe.ContainerFormat.TS, target: fe.ContainerFormat.MP4 };
        }
        function ce(he) {
          var ge = (0, le.extractContainerFormat)(he);
          return ge ? { source: ge, target: ge } : void 0;
        }
      }, 36225: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.addEncryptionKeyToStore = ce, ie.waitForKeyToBeLoaded = he;
        var ae = ne(3464), ue = ne(56093), _e = ne(55486), fe = ne(25040), le = ne(56092), se = 20;
        function oe(ge) {
          var ve = (0, fe.getAllEncryptionKeys)(ge.getState());
          ve && ve.length > se && ge.dispatch((0, _e.removeEncryptionKey)(ve[0].uri));
        }
        function ce(ge, ve, me) {
          return me.dispatch((0, _e.addEncryptionKey)({ uri: ge, key: void 0, loadState: le.KeyLoadState.Loading })), ve.load(ge).then(function(be) {
            return me == null || me.dispatch((0, _e.updateEncryptionKey)({ uri: ge, key: ue.FormatHelper.bytesToHex(be), loadState: le.KeyLoadState.Loaded })), oe(me), be;
          }).catch(function(be) {
            return me == null || me.dispatch((0, _e.updateEncryptionKey)({ uri: ge, key: void 0, loadState: le.KeyLoadState.Cancel })), Promise.reject(be);
          });
        }
        function he(ge, ve) {
          return new Promise(function(me, be) {
            var pe = function(ye) {
              return ye.loadState === le.KeyLoadState.Cancel ? ($e(), be(new Error("Encryption key load cancelled!"))) : ye.loadState === le.KeyLoadState.Loaded && ye.key ? ($e(), me(ue.FormatHelper.hexToBytes(ye.key))) : void 0;
            }, $e = (0, ae.subscribe)(ge)(function(ye) {
              return (0, fe.getEncryptionKey)(ye, ve);
            }, pe);
          });
        }
      }, 26382: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(ge) {
            for (var ve, me = 1, be = arguments.length; me < be; me++)
              for (var pe in ve = arguments[me])
                Object.prototype.hasOwnProperty.call(ve, pe) && (ge[pe] = ve[pe]);
            return ge;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.FetchController = void 0;
        var ue, _e = ne(90637), fe = ne(23234), le = ne(67345), se = ne(10981), oe = ne(72207);
        (function(ge) {
          ge.User = "user", ge.Timeout = "timeout";
        })(ue || (ue = {}));
        var ce = function() {
          function ge(ve, me, be, pe) {
            var $e = this;
            this.useStreamResponse = pe, this.setProgressListener = function(ye) {
              $e.progressListener = ye;
            }, this.onProgress = function(ye) {
              $e.progressListener && ($e.timing.progressTimestamp = fe.TimingUtil.getHiResTimestamp(), $e.progress.loadedBytes = ye, $e.progressListener(ae({}, $e.progress)));
            }, this.onSuccess = function() {
              clearTimeout($e.cancelTimeout);
            }, this.logger = ve.logger, this.timeout = be, this.request = me, this.fetching = new se.Deferred(), this.bytesReceivedCount = 0, this.timing = { sendTimestamp: -1, openedTimestamp: -1, headersReceivedTimestamp: -1, progressTimestamp: -1, doneTimestamp: -1 }, this.abortController = new AbortController(), this.progress = { loadedBytes: 0, url: me.url, responseTiming: this.timing, chunks: [], elapsedTime: 0 };
          }
          return ge.prototype.getResponse = function() {
            return this.load(this.request), this.fetching.promise;
          }, ge.prototype.cancel = function(ve) {
            ve === void 0 && (ve = ue.User), clearTimeout(this.cancelTimeout), this.cancellationReason = ve, this.abortController.abort();
          }, ge.prototype.load = function(ve) {
            var me, be = this, pe = { method: ve.method, headers: new Headers(ve.headers), credentials: ve.credentials, signal: this.abortController ? this.abortController.signal : void 0, body: he(ve.method) ? ve.body : void 0 };
            this.timing.sendTimestamp = fe.TimingUtil.getHiResTimestamp(), fetch(ve.url, pe).then(function($e) {
              var ye;
              if (be.timing.headersReceivedTimestamp = fe.TimingUtil.getHiResTimestamp(), (ye = be.progressListener) === null || ye === void 0 || ye.call(be, ae({}, be.progress)), $e.ok) {
                var Se = be.createHttpResponse($e);
                be.readResponse($e).then(function(we) {
                  Se.body = we, Se.length = be.bytesReceivedCount, Se.timeToFirstByte = be.timing.headersReceivedTimestamp - be.timing.sendTimestamp, be.timing.doneTimestamp > 0 && (Se.elapsedTime = be.timing.doneTimestamp - be.timing.sendTimestamp), be.fetching.resolve(Se);
                }).catch(function(we) {
                  be.onError({ error: we.message, response: be.createHttpResponse($e) });
                });
              } else
                be.onError({ error: _e.RequestError.Failed, response: be.createHttpResponse($e) });
            }).catch(function($e) {
              be.onError({ error: be.getRequestError($e) });
            }), this.timing.openedTimestamp = fe.TimingUtil.getHiResTimestamp(), (me = this.progressListener) === null || me === void 0 || me.call(this, ae({}, this.progress)), this.cancelTimeout = setTimeout(function() {
              return be.cancel(ue.Timeout);
            }, this.timeout);
          }, ge.prototype.getResponseHeaders = function(ve) {
            var me = {};
            return ve.headers.forEach(function(be, pe) {
              return me[pe] = be;
            }), me;
          }, ge.prototype.createHttpResponse = function(ve) {
            return { request: this.request, url: ve.url, headers: this.getResponseHeaders(ve), status: ve.status, statusText: ve.statusText };
          }, ge.prototype.getRequestError = function(ve) {
            return this.logger.debug("fetch error", ve), ve instanceof Error && ve.name === "AbortError" ? this.cancellationReason === ue.User ? _e.RequestError.Canceled : _e.RequestError.TimedOut : _e.RequestError.Failed;
          }, ge.prototype.readResponse = function(ve) {
            var me = this;
            if (ve.body && this.useStreamResponse) {
              var be = new oe.Stream(), pe = this.timing.headersReceivedTimestamp;
              return this.readReadableStreamResponse(ve, function(Se) {
                var we = fe.TimingUtil.getHiResTimestamp(), Pe = we - pe;
                pe = we, me.progress.chunks.push({ downloadDuration: Pe, bytes: Se.byteLength });
                var Te = Se instanceof Uint8Array ? Se.buffer : Se;
                be.add(Te);
              }).then(function() {
                be.end(), me.onSuccess();
              }).catch(function(Se) {
                me.logger.debug("Error reading of fetch response:", Se), be.abort(me.getRequestError(Se));
              }), Promise.resolve(be);
            }
            var $e = ve.headers.get("Content-Length"), ye = $e ? parseInt($e) : 0;
            return this.progress.totalBytes = ye, this.readReadableStreamResponse(ve.clone()).catch(function(Se) {
              me.logger.debug("Error reading of fetch response:", Se);
            }), this.readFullFetchResponse(ve).then(function(Se) {
              return me.bytesReceivedCount = ye, me.timing.doneTimestamp = fe.TimingUtil.getHiResTimestamp(), me.onSuccess(), Se;
            });
          }, ge.prototype.readReadableStreamResponse = function(ve, me) {
            var be = this;
            if (!ve.body)
              return Promise.reject(new Error("response.body is null"));
            var pe = ve.body.getReader(), $e = function() {
              return pe.read().then(function(ye) {
                var Se = ye.done, we = ye.value;
                return Se ? (be.timing.doneTimestamp = fe.TimingUtil.getHiResTimestamp(), void be.onProgress(be.bytesReceivedCount)) : we ? (me == null || me(we), be.bytesReceivedCount += we.byteLength, be.onProgress(be.bytesReceivedCount), $e()) : void 0;
              });
            };
            return $e();
          }, ge.prototype.readFullFetchResponse = function(ve) {
            switch (this.request.responseType) {
              case le.HttpResponseType.ARRAYBUFFER:
                return ve.arrayBuffer();
              case le.HttpResponseType.TEXT:
                return ve.text();
              case le.HttpResponseType.JSON:
                return ve.json();
              default:
                return Promise.reject(new Error("Unsupported response type on fetch request"));
            }
          }, ge.prototype.onError = function(ve) {
            clearTimeout(this.cancelTimeout), this.logger.debug("Error performing fetch: ".concat(ve.error), ve.response), this.fetching.reject(ve);
          }, ge;
        }();
        function he(ge) {
          return ![le.HttpRequestMethod.GET, le.HttpRequestMethod.HEAD].includes(ge);
        }
        ie.FetchController = ce;
      }, 5206: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.KeyLoader = void 0;
        var ae = ne(25550), ue = ne(28764), _e = ne(88005), fe = ne(90637), le = ne(67345), se = function() {
          function oe(ce) {
            this.context = ce, this.settings = ce.settings, this.sourceIdentifier = ce.sourceContext.sourceIdentifier, this.loader = new _e.DefaultContentLoader(this.context, { maxRetries: this.settings.MAX_RETRIES, retryDelay: this.settings.RETRY_DELAY, requestType: le.HttpRequestType.KEY_HLS_AES });
          }
          return oe.prototype.hasWithCredentials = function() {
            var ce = this.context.sourceContext.source && this.context.sourceContext.source.hasOwnProperty("options") && this.context.sourceContext.source.options, he = ce && ce.hasOwnProperty("withCredentials") && ce.withCredentials, ge = ce && ce.hasOwnProperty("hlsWithCredentials") && ce.hlsWithCredentials;
            return !!he || !!ge;
          }, oe.prototype.load = function(ce) {
            var he = this;
            return this.loader ? this.loader.load(ce, le.HttpRequestMethod.GET, le.HttpResponseType.ARRAYBUFFER, void 0, void 0, this.hasWithCredentials()).then(function(ge) {
              return ge.body;
            }).catch(function(ge) {
              if (ge.message === fe.RequestError.Canceled)
                return Promise.reject(ge);
              var ve = new ue.PlayerError(ae.ErrorCode.DRM_FAILED_LICENSE_REQUEST, { statusCode: ge.status, statusText: ge.statusText, keyUrl: ce }, "Failed to load the DRM key: ".concat(ge.status, " ").concat(ge.statusText, "."), he.sourceIdentifier);
              return he.context.eventHandler.fireError(ve), Promise.reject(ve);
            }) : Promise.reject("Could not load: No loader.");
          }, oe.prototype.isLoading = function() {
            return !!this.loader && this.loader.isLoading();
          }, oe.prototype.dispose = function() {
            this.loader && typeof this.loader.dispose == "function" && this.loader.dispose(), this.loader = void 0, this.settings = void 0;
          }, oe;
        }();
        ie.KeyLoader = se;
      }, 4141: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getLoaderConfig = fe, ie.getLoader = se;
        var ae = ne(88005), ue = ne(67345), _e = ne(79814);
        function fe(oe, ce) {
          var he;
          return !((he = oe.config.tweaks) === null || he === void 0) && he.segmentLoaderArgs ? oe.config.tweaks.segmentLoaderArgs : { maxRetries: oe.settings.MAX_CDN_RETRIES, requestType: le(ce), disableDownloadTimeout: !0, resetRetriesWhenOffline: !0 };
        }
        function le(oe) {
          return _e.MimeTypeHelper.isVideo(oe) ? ue.HttpRequestType.MEDIA_VIDEO : _e.MimeTypeHelper.isAudio(oe) ? ue.HttpRequestType.MEDIA_AUDIO : _e.MimeTypeHelper.isSubtitle(oe) ? ue.HttpRequestType.MEDIA_SUBTITLES : _e.MimeTypeHelper.isUnknown(oe) ? ue.HttpRequestType.INTERNAL : ue.HttpRequestType.UNKNOWN;
        }
        function se(oe, ce) {
          var he, ge = (he = oe.config.tweaks) === null || he === void 0 ? void 0 : he.segmentLoader;
          return ge && typeof ge == "function" ? new ge(ce) : new ae.DefaultContentLoader(oe, ce);
        }
      }, 73553: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentInfoError = void 0, function(ae) {
          ae.COULD_NOT_LOAD_PLAYLIST = "COULD_NOT_LOAD_PLAYLIST", ae.END_OF_STREAM_REACHED = "END_OF_STREAM_REACHED", ae.PERIOD_COMPLETE = "PERIOD_COMPLETE", ae.SEGMENT_EXCEEDING_PERIOD_DURATION = "SEGMENT_EXCEEDING_PERIOD_DURATION";
        }(ne || (ie.SegmentInfoError = ne = {}));
      }, 84519: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MPDHandlerFactory = void 0;
        var ae = ne(18665), ue = ne(3941), _e = ne(91520), fe = ne(16368), le = ne(67550), se = function() {
          function ge() {
          }
          return ge.createInstance = function(ve, me, be, pe, $e) {
            pe === void 0 && (pe = ue.DEFAULT_PERIOD_ID);
            var ye = ve.serviceManager.get(ae.ServiceName.ManifestService, ve.sourceContext.sourceIdentifier);
            if (!(ye != null && ye.hasAdaptationSets(pe)))
              return null;
            var Se = ye.findAdaptationSet(pe, me, $e);
            if (!Se)
              return ve.logger.debug("Did not find adaptation set for mime type [".concat(me, "] in period ").concat(pe)), null;
            var we = Se.Representation && Se.Representation[0], Pe = we && we.SegmentTemplate ? we.SegmentTemplate : Se.SegmentTemplate;
            return ye.isSmoothManifest() ? oe(ve, me, be, Pe) : ye.isHlsManifest() ? ce(ve, we) : he(ve, Pe, we);
          }, ge;
        }();
        function oe(ge, ve, me, be) {
          return be ? new (_e.ModuleManager.get(fe.ModuleName.Smooth).createSmoothSegmentTemplateMPDHandler())(ge, ve, me) : null;
        }
        function ce(ge, ve) {
          return ve.SegmentList ? new le.SegmentListMPDHandler(ge) : null;
        }
        function he(ge, ve, me) {
          var be = _e.ModuleManager.get(fe.ModuleName.DASH);
          return ve && ve[0].SegmentTimeline ? new be.SegmentTimelineMPDHandler(ge) : ve ? new be.SegmentTemplateMPDHandler(ge) : me.SegmentList ? new le.SegmentListMPDHandler(ge) : me.SegmentBase ? new be.SegmentBaseMPDHandler(ge) : null;
        }
        ie.MPDHandlerFactory = se;
      }, 49118: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.throwPlaylistDownloadError = _e;
        var ae = ne(25550), ue = ne(28764);
        function _e(le, se, oe) {
          le.logger.debug(se), le.eventHandler.fireError(new ue.PlayerError(ae.ErrorCode.SOURCE_COULD_NOT_LOAD_MANIFEST, fe(oe), se));
        }
        function fe(le) {
          return { url: le == null ? void 0 : le.Uri, mimeType: le == null ? void 0 : le._mimeType, codecs: le == null ? void 0 : le._codecs, bitrate: le == null ? void 0 : le._bandwidth };
        }
      }, 41661: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentCache = void 0, ie.areSegmentsIdentical = fe;
        var ae = ne(81361), ue = ne(86865), _e = function() {
          function le(se) {
            this.maxSize = Math.max(0, se), this.cache = [];
          }
          return le.prototype.contains = function(se) {
            return this.cache.some(function(oe) {
              return fe(se.getSegmentInfo(), oe.getSegmentInfo());
            });
          }, le.prototype.maintainCacheSize = function(se) {
            this.cache = se !== 0 ? this.cache.slice(-se) : [];
          }, le.prototype.add = function(se) {
            this.contains(se) || (this.cache.push(se), this.maintainCacheSize(this.maxSize));
          }, le.prototype.get = function(se) {
            return this.cache.find(function(oe) {
              return fe(se, oe.getSegmentInfo());
            });
          }, le.prototype.clear = function() {
            this.maintainCacheSize(0);
          }, le.prototype.remove = function(se) {
            this.cache = this.cache.filter((0, ae.invert)(se));
          }, le.prototype.getCapacity = function() {
            return this.maxSize;
          }, le.prototype.getCachedCount = function() {
            return this.cache.length;
          }, le.prototype.getCachedSegments = function() {
            return this.cache.slice(0);
          }, le;
        }();
        function fe(le, se) {
          return (le.isInitSegment ? ["url", "periodId", "byteRange", "representationId"] : ["url", "periodId", "byteRange", "discontinuitySequenceNumber"]).every(function(oe) {
            return typeof le[oe] == "object" ? (0, ue.compareValues)(le[oe], se[oe]) : le[oe] === se[oe];
          });
        }
        ie.SegmentCache = _e;
      }, 58423: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(bt) {
            for (var it, ht = 1, vt = arguments.length; ht < vt; ht++)
              for (var gt in it = arguments[ht])
                Object.prototype.hasOwnProperty.call(it, gt) && (bt[gt] = it[gt]);
            return bt;
          }, ae.apply(this, arguments);
        }, ue = this && this.__spreadArray || function(bt, it, ht) {
          if (ht || arguments.length === 2)
            for (var vt, gt = 0, Tt = it.length; gt < Tt; gt++)
              !vt && gt in it || (vt || (vt = Array.prototype.slice.call(it, 0, gt)), vt[gt] = it[gt]);
          return bt.concat(vt || Array.prototype.slice.call(it));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentController = void 0, ie.getSegmentManager = ot, ie.extractContainerFormat = et;
        var _e = ne(52442), fe = ne(25550), le = ne(28764), se = ne(63546), oe = ne(35148), ce = ne(18665), he = ne(60997), ge = ne(62510), ve = ne(58935), me = ne(90637), be = ne(57782), pe = ne(28463), $e = ne(76650), ye = ne(28819), Se = ne(8272), we = ne(27279), Pe = ne(3464), Te = ne(27177), Ee = ne(42283), Me = ne(79814), Ae = ne(65114), Ne = ne(331), Ce = ne(70016), Ie = ne(76885), xe = ne(91520), Ue = ne(16368), ke = ne(41108), Le = ne(73543), De = ne(94938), Re = ne(43752), Oe = ne(22916), Be = ne(96707), Fe = ne(30855), Ve = ne(4053), Ke = ne(82311), Ze = ne(41735), nt = ne(58211), Qe = ne(59839), qe = ne(22645), ze = ne(93109), je = ne(9140), tt = ne(74830), ut = ne(73553), yt = ne(84519), $t = ne(49118), ft = ne(41661), pt = ne(20417), lt = ne(28915), Je = ne(66864), Xe = ne(60704), We = ne(12482), Ge = function() {
          function bt(it, ht, vt, gt, Tt, rt, He, Ye) {
            var ct = this;
            this.context = it, this.onDataAvailableCallback = ht, this.mimeType = vt, this.manifestLoader = rt, this.HLSModule = xe.ModuleManager.get(Ue.ModuleName.HLS, !1), this.loadedAdaptationSetIds = {}, this.loadingDataSegmentInfos = [], this.isBackupStreamSwitchOngoing = !1, this.hasDownloadError = !1, this.invalidateOngoingSegmentInfoRequest = !1, this.disableDownloadCancelingForNextSegment = !1, this.isProcessingSegment = !1, this.parkedSegmentSubscriptions = [], this.onSegmentInfoError = function(It) {
              if ((0, Te.isContextAvailable)(ct.context)) {
                var wt = "Error obtaining ".concat(ct.mimeType, " segment info");
                ct.lastSegmentInfoError && ct.lastSegmentInfoError === It ? ct.logger.insane(wt, It) : ct.debug(wt, It), ct.lastSegmentInfoError = It;
              }
            }, this.handleCancelLoadingError = function(It) {
              ct.debug("Error in cancelLoading of segmentLoaderPool ", It);
            }, this.getNext = function(It, wt) {
              var Ct, Mt = !(!((Ct = ct.segmentManager) === null || Ct === void 0) && Ct.canLoad()) || ct.pendingSegmentInfoRequest || ct.hasActiveTransmuxingJobs() || ct.isBackupStreamSwitchOngoing || ct.isProcessingSegment;
              if (ct.currentAdaptationSetId && !Mt) {
                ct.debug("Getting next segment for time ".concat(It));
                var kt = { periodId: ct.currentPeriodId, recommendedRepresentationId: wt, time: It };
                ct.getSegmentInfo(kt).then(function(Rt) {
                  return ct.loadFromSegmentInfo(Rt);
                }).catch(ct.onSegmentInfoError);
              }
            }, this.onSegmentLoaded = function(It) {
              ct.hasDownloadError = !1, ct.maybeUpdateContainerFormat(It);
              var wt = ct.verifySegment(It);
              if (wt !== _e.SegmentVerificationResult.Drop) {
                if (wt !== _e.SegmentVerificationResult.Park)
                  if (ct.isTransmuxerRequired()) {
                    var Ct = It.getSegmentInfo();
                    Ct.presentationTimeOffset && isNaN(Ct.presentationTimeOffset) && (ct.mpdHandler.setTimestampOffset(0), Ct.presentationTimeOffset = 0), ct.transmux(It);
                  } else {
                    var Mt = !1;
                    ct.currentAdaptationSetId && ct.segmentManager && (Mt = ct.segmentPreProcessor.onSegmentAvailable(It, { id3: [], closedCaptions: [] }, ct.currentAdaptationSetId, ct.segmentManager)), Mt || dt(It.getSegmentInfo(), ct.sourceStore), It.getMimeType().indexOf("mp4") > -1 && !ct.maybeIsHlsManifest() && (ct.isLastSegment = It.isLastSegment());
                  }
              } else
                dt(It.getSegmentInfo(), ct.sourceStore);
            }, this.onShouldDownloadBeCancelled = function(It, wt) {
              var Ct, Mt = !!(!((Ct = ct.adaptationService) === null || Ct === void 0) && Ct.shouldDownloadBeCancelled(ct.mimeType, It, wt));
              return ct.maybeIsHlsManifest() && ct.hls.possiblyDependentSegments && Mt ? (ct.debug("Download should be cancelled, but this is disabled for segments not starting with key frames"), !1) : Mt;
            };
            var _t = it.sourceContext.sourceIdentifier;
            if (this.currentPeriodId = He, this.sourceStore = Ye, this.manifestUpdateScheduler = it.serviceManager.get(ce.ServiceName.ManifestUpdateSchedulingService, _t), this.segmentUnavailabilityHandler = new Fe.SegmentUnavailabilityHandler(this.context), this.adaptationService = this.context.serviceManager.get(ce.ServiceName.AdaptationService), this.streamTimeService = this.context.serviceManager.get(ce.ServiceName.StreamTimeService), this.hls = { isTransmuxingRequired: Tt && !this.isSubtitleSegmentController, transmuxer: void 0, possiblyDependentSegments: !1, isAvMuxedTogether: (0, Ee.isAVMuxedTogether)(gt), discardNextSegment: !1, muxedAudioTrackIndex: 0 }, this.isContainerFormatKnown()) {
              var Pt = this.getContainerFormat();
              this.hls.isTransmuxingRequired = Pt.source !== Pt.target;
            }
            this.init();
          }
          return Object.defineProperty(bt.prototype, "logger", { get: function() {
            return this.context.logger;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(bt.prototype, "settings", { get: function() {
            return this.context.settings;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(bt.prototype, "eventHandler", { get: function() {
            return this.context.eventHandler;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(bt.prototype, "segmentManager", { get: function() {
            return ot(this.context, this.mimeType, this.segmentParser, this.hls, this.currentLangObj);
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(bt.prototype, "isSubtitleSegmentController", { get: function() {
            return Me.MimeTypeHelper.isSubtitle(this.mimeType);
          }, enumerable: !1, configurable: !0 }), bt.prototype.getUserFeedbackForAdaptation = function(it) {
            var ht, vt = this.getAdaptationEventType();
            if (vt) {
              var gt = (ht = this.adaptationService) === null || ht === void 0 ? void 0 : ht.getUserSelectedRepresentation(this.mimeType, this.currentAdaptationSetId, it);
              return gt ? (this.eventHandler.dispatchEvent(vt, { representationID: gt._internalId.representationId }), gt._internalId) : void this.eventHandler.dispatchEvent(vt, { representationID: it.representationId });
            }
          }, bt.prototype.getAdaptationEventType = function() {
            return Me.MimeTypeHelper.isAudio(this.mimeType) ? ge.PlayerEvent.AudioAdaptation : Me.MimeTypeHelper.isVideo(this.mimeType) ? ge.PlayerEvent.VideoAdaptation : null;
          }, bt.prototype.getPrefetchedRepresentationId = function() {
            var it;
            if (!((it = this.context.adRestorationOptimizationService) === null || it === void 0) && it.hasPrefetchedSegment(this.mimeType, this.lastSegmentInfo))
              return this.context.adRestorationOptimizationService.getRepresentationForPrefetchedSegment(this.mimeType);
          }, bt.prototype.selectRepresentation = function(it) {
            if (!this.mpdHandler.canSwitchRepresentation(it.time) && this.currentRepresentationId)
              return this.currentRepresentationId;
            var ht = this.getPrefetchedRepresentationId();
            if (ht)
              return ht;
            var vt = this.sourceStore.getState(), gt = !!vt && !!(0, pe.getPreferredBitrate)((0, pe.getAdaptationState)(vt), this.mimeType), Tt = this.getSuggestedRepresentationFromAbr(), rt = Tt ? this.getUserFeedbackForAdaptation(Tt) : void 0;
            if (rt)
              return this.disableDownloadCancelingForNextSegment = !0, rt;
            var He = it.recommendedRepresentationId, Ye = (He == null ? void 0 : He.periodId) === this.getCurrentPeriodId();
            return He && Ye && !gt ? He : Tt;
          }, bt.prototype.getSuggestedRepresentationFromAbr = function() {
            var it, ht, vt = { hlsDependentSegments: this.hls.possiblyDependentSegments, segmentDuration: this.mpdHandler.getSegmentDuration() };
            return (it = this.adaptationService) === null || it === void 0 ? void 0 : it.selectRepresentation(this.mimeType, vt, (ht = this.getCurrentAdaptationSet()) === null || ht === void 0 ? void 0 : ht.Representation);
          }, bt.prototype.switchRepresentation = function(it) {
            var ht = this.currentRepresentationId ? this.currentRepresentationId.representationId : null;
            this.debug("switching representation from ".concat(ht, " to ").concat(it.representationId)), this.mpdHandler.setRepresentationId(it), this.currentRepresentationId = it;
          }, bt.prototype.invalidateOngoingRequests = function() {
            this.invalidateOngoingSegmentInfoRequest = !0;
          }, bt.prototype.fireQualityChangeEvent = function(it, ht) {
            var vt, gt = mt(it, this.context), Tt = mt(ht, this.context), rt = gt ? (0, Re.representationToQuality)(gt, this.mimeType) : void 0, He = Tt ? (0, Re.representationToQuality)(Tt, this.mimeType) : void 0;
            if (He) {
              var Ye = { targetQuality: He, targetQualityId: He.id, sourceQuality: rt, sourceQualityId: (vt = rt == null ? void 0 : rt.id) !== null && vt !== void 0 ? vt : null };
              Me.MimeTypeHelper.isVideo(this.mimeType) ? this.context.eventHandler.dispatchEvent(ge.PlayerEvent.VideoDownloadQualityChange, Ye) : Me.MimeTypeHelper.isAudio(this.mimeType) && this.context.eventHandler.dispatchEvent(ge.PlayerEvent.AudioDownloadQualityChange, Ye);
            }
          }, bt.prototype.getSegmentInfo = function(it) {
            var ht, vt = this, gt = ((ht = this.lastSegmentInfo) === null || ht === void 0 ? void 0 : ht.segmentNumber) !== void 0 ? this.lastSegmentInfo.segmentNumber + 1 : 0, Tt = this.selectRepresentation(it);
            this.sourceStore.dispatch((0, Ve.setRepresentationIdAction)(Tt));
            var rt = !Tt.equals(this.currentRepresentationId);
            return rt && Me.MimeTypeHelper.isAV(this.mimeType) && this.fireQualityChangeEvent(this.currentRepresentationId, Tt), this.invalidateOngoingSegmentInfoRequest = !1, this.pendingSegmentInfoRequest = this.maybeWaitForRepresentationUpdate(Tt, rt).then(function() {
              return vt.currentAdaptationSetId && vt.mpdHandler.setAdaptationSetId(vt.currentAdaptationSetId, Tt), rt && vt.switchRepresentation(Tt), vt.mpdHandler.getNextSegmentInfo(it.time);
            }).then(function(He) {
              var Ye, ct = (Ye = vt.currentRepresentationId) !== null && Ye !== void 0 ? Ye : Tt;
              if (vt.addSegmentInfos(He, gt, ct), vt.shouldInvalidateSegmentInfo(He))
                throw (0, Te.isContextAvailable)(vt.context) && vt.debug("invalidating ongoing SegmentInfo request for", ae({}, He)), "ongoing segment info request was invalidated";
              return vt.lastSegmentInfo = He, He;
            }).catch(function(He) {
              var Ye, ct;
              if (vt.pendingSegmentInfoRequest = void 0, St(He)) {
                var _t = (ct = (Ye = He == null ? void 0 : He.name) !== null && Ye !== void 0 ? Ye : He == null ? void 0 : He.message) !== null && ct !== void 0 ? ct : He;
                vt.debug("HLS playlist loading failed for representation ".concat(Tt.representationId, " (").concat(_t, ")"));
                var Pt = vt.maybeTryLowerQuality(Tt);
                if (Pt)
                  return vt.debug("Trying with lower quality representation ".concat(Pt.representationId)), vt.getSegmentInfo(ae(ae({}, it), { recommendedRepresentationId: Pt }));
                vt.handleFailedRepresentationDownload(Tt);
              }
              throw He;
            }).finally(function() {
              vt.expectedTargetTimeAfterSeek = void 0;
            }), this.pendingSegmentInfoRequest;
          }, bt.prototype.shouldInvalidateSegmentInfo = function(it) {
            return this.invalidateOngoingSegmentInfoRequest && it && !it.isInitSegment && !this.isSegmentInfoInExpectedTimeRange(it);
          }, bt.prototype.isSegmentInfoInExpectedTimeRange = function(it) {
            return this.expectedTargetTimeAfterSeek !== void 0 && (0, Ce.isNumber)(it.startTime) && (0, Ce.isNumber)(it.duration) && this.expectedTargetTimeAfterSeek >= it.startTime && this.expectedTargetTimeAfterSeek <= it.startTime + it.duration;
          }, bt.prototype.getDataSegmentInfo = function(it) {
            var ht = { periodId: this.currentPeriodId, time: it };
            return this.currentRepresentationId && this.currentRepresentationId.periodId === this.getCurrentPeriodId() ? this.getSegmentInfo(ae(ae({}, ht), { recommendedRepresentationId: this.currentRepresentationId })) : this.getSegmentInfo(ht);
          }, bt.prototype.addSegmentInfos = function(it, ht, vt) {
            it && (this.applyRepresentationInformationToSegmentInfo(it, vt), this.parseDateTimeFormSegmentUrl(it), this.applyBaseUrlsToSegmentInfo(vt, it), it.duration || it.isInitSegment || (it.duration = this.mpdHandler.getSegmentDuration()), (it.segmentNumber === void 0 || isNaN(it.segmentNumber)) && (it.segmentNumber = ht), it.discardData = this.hls.discardNextSegment, this.hls.discardNextSegment = !1, this.disableDownloadCancelingForNextSegment && (it.preventDownloadCanceling = !0, this.disableDownloadCancelingForNextSegment = !1));
          }, bt.prototype.applyRepresentationInformationToSegmentInfo = function(it, ht) {
            var vt = mt(ht, this.context);
            vt && (it.representationId = ht.representationId, it.internalRepresentationId = ht, it.mimeType = this.mimeType, it.bitrate = vt._bandwidth, it.periodId = ht.periodId, it.codecs = this.getCodecs(), Me.MimeTypeHelper.isAudio(this.mimeType) ? (it.sampleRate = vt._audioSamplingRate, it.width = void 0, it.height = void 0) : Me.MimeTypeHelper.isVideo(this.mimeType) && (it.width = vt._width, it.height = vt._height, it.frameRate = vt._frameRate));
          }, bt.prototype.parseDateTimeFormSegmentUrl = function(it) {
            if (Me.MimeTypeHelper.isVideo(this.mimeType) && !it.dateTime && this.settings.AKAMAI_DATETIME_PARSING && this.HLSModule) {
              var ht = it.duration != null ? this.HLSModule.PlaylistUtils.getProgramDateTimeFromSegmentUrl(it.url, it.duration) : void 0;
              ht && (it.dateTime = ht);
            }
          }, bt.prototype.applyBaseUrlsToSegmentInfo = function(it, ht) {
            var vt = this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(gt) {
              return gt.getAvailableBaseURLsForRepresentation(it);
            }, void 0, this.context.sourceContext.sourceIdentifier);
            ht.availableBaseURLs = vt, ht.firstUsedBaseURLIndex = 0, this.lastSegmentInfo && this.lastSegmentInfo.lastUsedBaseURLIndex && (ht.firstUsedBaseURLIndex = this.lastSegmentInfo.lastUsedBaseURLIndex), ht.lastUsedBaseURLIndex = ht.firstUsedBaseURLIndex, this.maybeIsHlsManifest() ? (ht.baseURL = "", ht.mediaURL || (ht.mediaURL = ht.url)) : (ht.baseURL = vt[ht.firstUsedBaseURLIndex], ht.mediaURL = ht.mediaURL || ht.url, delete ht.url), ht.url = Ie.URLHelper.concatBaseUrlWithPartial(ht.baseURL, ht.mediaURL);
          }, bt.prototype.maybeWaitForRepresentationUpdate = function(it, ht) {
            var vt = this;
            return ht ? this.manifestUpdateScheduler ? this.manifestUpdateScheduler.waitForRepUpdate(it).then(function() {
              return vt.mpdHandler.updateRepresentation(it);
            }) : Promise.reject("ManifestUpdateScheduler does not exist.") : Promise.resolve();
          }, bt.prototype.isTransmuxing = function() {
            var it;
            return this.isTransmuxerRequired() && !!(!((it = this.hls.transmuxer) === null || it === void 0) && it.isTransmuxing());
          }, bt.prototype.hasActiveTransmuxingJobs = function() {
            var it;
            return !!this.isTransmuxerRequired() && (this.hasDelayedSegmentsInTransmuxer() || !!(!((it = this.hls.transmuxer) === null || it === void 0) && it.hasActiveJobs()));
          }, bt.prototype.hasDelayedSegmentsInTransmuxer = function() {
            var it;
            return Me.MimeTypeHelper.isAudio(this.mimeType) && this.isTransmuxerRequired() && !!(!((it = this.hls.transmuxer) === null || it === void 0) && it.hasDelayedAudioSegments());
          }, bt.prototype.cancelTransmuxing = function() {
            var it, ht, vt = this;
            ((ht = (it = this.hls.transmuxer) === null || it === void 0 ? void 0 : it.discardCurrentJobs(this.mimeType)) !== null && ht !== void 0 ? ht : []).forEach(function(gt) {
              return dt(gt.mp2tsSegment.getSegmentInfo(), vt.sourceStore);
            });
          }, bt.prototype.cancelLoading = function() {
            var it;
            this.invalidateOngoingSegmentInfoRequest = !0, (it = this.segmentManager) === null || it === void 0 || it.cancel().catch(this.handleCancelLoadingError);
          }, bt.prototype.seekTo = function(it) {
            var ht = this;
            it !== null && this.currentAdaptationSetId && (this.cancelLoading(), this.cancelTransmuxing(), this.loadingDataSegmentInfos = [], this.hasDownloadError = !1, this.isLastSegment = !1, this.hlsTimelineTracker && this.hlsTimelineTracker.reset(), this.isTransmuxerRequired() && this.hls.transmuxer && this.hls.transmuxer.resetCaptionParser(), it >= 0 && (this.expectedTargetTimeAfterSeek = it, this.mpdHandler.seekTo(it), this.context.serviceManager.maybeCall(ce.ServiceName.TimedMetadataService, function(vt) {
              return vt.clearSegmentBoundMetadata(ht.mimeType);
            })));
          }, bt.prototype.hasNextVod = function(it) {
            var ht, vt = this, gt = this.maybeFindPeriod(this.currentPeriodId), Tt = this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(rt) {
              return rt.getMediaPresentationDuration();
            }, 0, this.context.sourceContext.sourceIdentifier);
            if (gt && gt.hasOwnProperty("_duration"))
              ht = this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(rt) {
                return rt.getPeriodDuration(vt.currentPeriodId);
              }, void 0, this.context.sourceContext.sourceIdentifier);
            else {
              if (Tt === 0)
                return !1;
              ht = Tt;
            }
            return this.mpdHandler.hasNext(ht);
          }, bt.prototype.hasNextLive = function(it) {
            var ht = this;
            if (this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(gt) {
              return gt.isAvailabilityEndTimeExceeded();
            }, !1, this.context.sourceContext.sourceIdentifier))
              return this.logger.log("Stream (".concat(this.mimeType, ") availability end time reached, stopping download of further segments.")), this.isLastSegment = !0, !1;
            this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(gt) {
              return gt.isLastPeriod(ht.currentPeriodId);
            }, !1, this.context.sourceContext.sourceIdentifier) && this.mpdHandler.resolvePendingSegmentInfoRequests();
            var vt = this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(gt) {
              return gt.getPeriodDuration(ht.currentPeriodId);
            }, void 0, this.context.sourceContext.sourceIdentifier);
            return this.mpdHandler.hasNext(vt);
          }, bt.prototype.hasNext = function(it) {
            var ht = this, vt = this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(gt) {
              return gt.isLastPeriod(ht.currentPeriodId);
            }, !1, this.context.sourceContext.sourceIdentifier);
            return !(this.isLastSegment && vt || !this.currentAdaptationSetId || !this.mpdHandler) && (this.maybeIsLive() ? this.hasNextLive(it) : this.hasNextVod(it));
          }, bt.prototype.onTransmuxed = function(it) {
            var ht = this;
            if (it.transmuxedSegments.every(function(Ye) {
              return Ye.getCodec() !== null;
            })) {
              !this.hls.possiblyDependentSegments && st(it) && (this.debug("Encountered HLS segment not starting with a key frame"), this.hls.possiblyDependentSegments = !0);
              var vt = it.transmuxedSegments.find(function(Ye) {
                return Ye.getMimeType() === "video/mp4";
              }), gt = it.transmuxedSegments.filter(function(Ye) {
                return Ye.getMimeType() === "audio/mp4";
              }), Tt = [vt, gt[this.hls.muxedAudioTrackIndex] || gt[0]].filter(function(Ye) {
                return !!Ye;
              });
              Tt.forEach(function(Ye) {
                return ht.timestampOffsetService.maybeAdjustTimestampOffsetAtDiscontinuityChange(Ye, ht.mpdHandler);
              }), this.segmentManager && this.currentAdaptationSetId && this.segmentPreProcessor.onMuxedSegmentAvailable(it, Tt, this.currentAdaptationSetId, this.segmentManager);
              var rt = Tt[Tt.length - 1];
              rt && rt.getMimeType().indexOf("mp4") > -1 && (this.isLastSegment = rt.isLastSegment()), this.debug("Transmuxing done", it.originalSegment.getUrl());
            } else {
              var He = it.originalSegment.getUrl();
              this.debug("Discarding muxing because codecs were not available in the segment: ".concat(He));
            }
          }, bt.prototype.hasPendingSegments = function(it) {
            var ht, vt, gt, Tt, rt, He;
            return it ? (rt = this.isTransmuxerRequired() && !!this.hls.transmuxer && this.hls.transmuxer.isTransmuxingSegmentsForPeriod(it), He = (vt = (ht = this.segmentManager) === null || ht === void 0 ? void 0 : ht.isLoading(it)) !== null && vt !== void 0 && vt) : (rt = this.isTransmuxing(), He = (Tt = (gt = this.segmentManager) === null || gt === void 0 ? void 0 : gt.isLoading()) !== null && Tt !== void 0 && Tt), He || rt || this.isProcessingSegment || !!this.pendingSegmentInfoRequest;
          }, bt.prototype.transmux = function(it) {
            var ht = this;
            if (this.hls.transmuxer) {
              var vt = it.getSegmentInfo();
              this.hls.transmuxer.isSetupForDiscontinuity(vt.discontinuitySequenceNumber) || (vt.startTime === void 0 && (this.debug("resetting segment playback times for new initialization"), this.sourceStore.dispatch((0, Ze.resetSegmentPlaybackTimes)())), (0, tt.initializeHlsSegmentStartTimes)(it, this.context, this.mpdHandler));
              var gt = Date.now();
              this.hls.transmuxer.transmuxSegment(it).then(function(Tt) {
                var rt, He = (0, Ne.toSeconds)(Date.now() - gt), Ye = { time: He, representationId: vt.internalRepresentationId };
                return ht.context.store.dispatch((0, $e.addMetricsValue)(ht.mimeType, Se.MetricType.TransmuxingTime, Ye)), ht.context.logger.debug("Transmuxed ".concat(ht.mimeType, " segment in: ").concat(He == null ? void 0 : He.toFixed(2), ", quality: ").concat((rt = vt.representationId) !== null && rt !== void 0 ? rt : "")), ht.onTransmuxed(Tt);
              }).catch(function(Tt) {
                dt(it.getSegmentInfo(), ht.sourceStore), Tt !== _e.TransmuxingRejectionReason.TRANSMUXING_ABORTED ? ht.eventHandler.dispatchEvent(ge.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.PLAYBACK_INVALID_DATA_SEGMENT_ENCOUNTERED, "Transmuxing failed: ".concat(Tt), { mimeType: it.getMimeType(), segmentUrl: it.getUrl() })) : ht.debug(Tt, it.getUrl());
              });
            }
          }, bt.prototype.maybeUpdateContainerFormat = function(it) {
            var ht;
            if (!this.isContainerFormatKnown() || this.isSegmentEmpty(it)) {
              var vt = (0, je.resolveContainerFormat)(this.mimeType, it, this.maybeIsHlsManifest());
              this.debug("Container format is ".concat(vt == null ? void 0 : vt.source)), vt && this.sourceStore.dispatch((0, Ve.setContainerFormatAction)(it.getRepresentationId(), vt)), this.hls.isTransmuxingRequired = !!(vt && vt.source !== vt.target), !this.hls.isTransmuxingRequired && Me.MimeTypeHelper.isAV(this.mimeType) && ((ht = this.hls.transmuxer) === null || ht === void 0 || ht.dispose(), this.context.serviceManager.maybeCall(ce.ServiceName.SubtitleService, function(gt) {
                gt.setTransmuxer(void 0);
              }));
            }
          }, bt.prototype.verifySegment = function(it) {
            var ht;
            if (this.isSegmentEmpty(it))
              return this.debug("Warning: Loaded segment has size 0 bytes, skipping further processing! May cause gap!", it.getUrl()), (ht = this.hlsTimelineTracker) === null || ht === void 0 || ht.reset(), _e.SegmentVerificationResult.Drop;
            if (this.isTransmuxerRequired()) {
              if (!xe.ModuleManager.has(Ue.ModuleName.ContainerTS))
                return this.context.eventHandler.fireError(new ke.PlayerModuleMissingError(Ue.ModuleName.ContainerTS)), _e.SegmentVerificationResult.Drop;
            } else if (!this.maybeIsSmoothManifest() && this.isInvalidMp4Segment(it))
              return this.eventHandler.dispatchEvent(ge.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.PLAYBACK_INVALID_DATA_SEGMENT_ENCOUNTERED, "The loaded MP4 segment is invalid, skipping further processing! May cause gap!", { mimeType: it.getMimeType(), segmentUrl: it.getUrl() })), _e.SegmentVerificationResult.Drop;
            var vt = xe.ModuleManager.get(Ue.ModuleName.LowLatency, !1), gt = this.context.serviceManager.get(ce.ServiceName.ManifestService, this.context.sourceContext.sourceIdentifier);
            if ((0, ze.isPlayingLowLatencyHls)(this.context) && vt && gt) {
              var Tt = vt.verifyLlHlsSegment(it, gt);
              if (Tt === _e.SegmentVerificationResult.Drop)
                return this.debug("LL-HLS Segment Verification: Dropping (partial) segment as it disappeared from playlist", it.getUrl()), _e.SegmentVerificationResult.Drop;
              if (Tt === _e.SegmentVerificationResult.Park)
                return this.parkSegment(it), _e.SegmentVerificationResult.Park;
            }
            return _e.SegmentVerificationResult.Publish;
          }, bt.prototype.parkSegment = function(it) {
            var ht = this, vt = function(He) {
              var Ye;
              if (He.manifest)
                return (Ye = (0, Ae.findRepresentation)(He.manifest, it.getRepresentationId())) === null || Ye === void 0 ? void 0 : Ye._requestTimestamp;
            }, gt = function(He, Ye) {
              return He !== Ye;
            }, Tt = function() {
              rt(), ht.removeParkedSegmentSubscriber(rt), ht.onSegmentLoaded(it);
            }, rt = (0, Pe.subscribe)(this.sourceStore)(vt, Tt, gt);
            this.parkedSegmentSubscriptions.push(rt);
          }, bt.prototype.removeParkedSegmentSubscriber = function(it) {
            var ht = this.parkedSegmentSubscriptions.findIndex(function(vt) {
              return vt === it;
            });
            ht > -1 && this.parkedSegmentSubscriptions.splice(ht, 1);
          }, bt.prototype.isSegmentEmpty = function(it) {
            var ht = it.getData();
            return !!(ht && ht.byteLength < 1);
          }, bt.prototype.isInvalidMp4Segment = function(it) {
            if (!xe.ModuleManager.has(Ue.ModuleName.ContainerMP4))
              return !1;
            var ht = xe.ModuleManager.get(Ue.ModuleName.ContainerMP4, !1), vt = ht.isValidMp4, gt = ht.MP4Parser, Tt = this.segmentParser instanceof gt;
            return this.context.settings.DROP_INVALID_SEGMENTS && Tt && !vt(it);
          }, bt.prototype.getContainerFormat = function() {
            var it = this.sourceStore.getState();
            return it && (0, Ke.getContainerFormat)(it, Me.MimeTypeHelper.getMediaType(this.mimeType));
          }, bt.prototype.isContainerFormatKnown = function() {
            return !!this.getContainerFormat();
          }, bt.prototype.loadFromSegmentInfo = function(it) {
            var ht = this;
            return this.pendingSegmentInfoRequest = void 0, this.isProcessingSegment = !0, it ? (this.loadingDataSegmentInfos.push(it), this.lastSegmentInfoError = void 0, this.ensureInitSegmentInfo(it), this.loadDataSegment(it).catch(function(vt) {
              return ht.handleSegmentLoadingError(vt, it);
            }).finally(function() {
              return ht.isProcessingSegment = !1;
            })) : Promise.resolve();
          }, bt.prototype.ensureInitSegmentInfo = function(it) {
            var ht = this.getInitSegmentInfoForDataSegmentInfo(it);
            ht && (it.init = ht);
          }, bt.prototype.debug = function(it) {
            for (var ht, vt, gt, Tt = [], rt = 1; rt < arguments.length; rt++)
              Tt[rt - 1] = arguments[rt];
            !((vt = this.logger) === null || vt === void 0) && vt.isLevelEnabled(ve.LogLevel.DEBUG) && (ht = this.logger).debug.apply(ht, ue(["[".concat(this.mimeType, "][").concat((gt = this.currentRepresentationId) === null || gt === void 0 ? void 0 : gt.representationId, "] SegmentController: ").concat(it)], Tt, !1));
          }, bt.prototype.loadDataSegment = function(it) {
            var ht;
            return !((ht = this.logger) === null || ht === void 0) && ht.isLevelEnabled(ve.LogLevel.DEBUG) && this.debug("Loading ".concat(JSON.stringify(it))), this.loadSegment(it);
          }, bt.prototype.getInitSegmentInfoForDataSegmentInfo = function(it) {
            var ht = null;
            return (ht = it.init ? ae(ae({}, it.init), { isInitSegment: !0, internalRepresentationId: it.internalRepresentationId }) : this.mpdHandler.getInitSegmentInfo(it.internalRepresentationId)) && this.addSegmentInfos(ht, void 0, it.internalRepresentationId), ht;
          }, bt.prototype.loadSegment = function(it) {
            var ht = this;
            return this.segmentManager ? this.segmentManager.getSegment(it).then(function(vt) {
              return ht.extractSegmentFromStream(vt);
            }) : Promise.reject();
          }, bt.prototype.extractSegmentFromStream = function(it) {
            var ht = this;
            return new Promise(function(vt, gt) {
              it.transform(function(Tt) {
                at(Tt.getSegmentInfo(), ht.loadingDataSegmentInfos), ht.onSegmentLoaded(Tt);
              }, function() {
                return vt();
              }, function(Tt) {
                var rt = Tt.message, He = { reason: rt };
                return gt(He), He.reason !== Je.SegmentLoadingErrorReason.CANCEL && ht.debug("Error loading segment", rt), rt;
              });
            });
          }, bt.prototype.handleSegmentLoadingError = function(it, ht) {
            var vt;
            (vt = (0, we.getSourceStore)(this.context)) === null || vt === void 0 || vt.dispatch((0, be.clearPreferredBitrateForMimeTypeAction)(this.mimeType)), dt(ht, this.sourceStore);
            var gt = it != null && it.info ? it.info.response.status : 0;
            switch (it == null ? void 0 : it.reason) {
              case Je.SegmentLoadingErrorReason.CANCEL:
                this.debug("Download was cancelled as the segment is probably outdated");
                break;
              case Je.SegmentLoadingErrorReason.ERROR_DECRYPTING:
                this.debug("Could not decrypt segment", ht.url), this.eventHandler.dispatchEvent(ge.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.DRM_COULD_NOT_DECRYPT_SEGMENT));
                break;
              case Je.SegmentLoadingErrorReason.ERROR_LOADING:
                this.handleDownloadError(gt, ht, Je.SegmentLoadingErrorReason.ERROR_LOADING);
                break;
              case Je.SegmentLoadingErrorReason.TIMEOUT:
                this.handleDownloadError(gt, ht, Je.SegmentLoadingErrorReason.TIMEOUT);
                break;
              case Je.SegmentLoadingErrorReason.ABR_TIMEOUT:
                this.onABRCancellation(ht);
                break;
              default:
                this.debug("Unexpected error while loading the segment", { url: ht.url, error: it });
            }
          }, bt.prototype.switchToHlsBackupStream = function(it, ht) {
            var vt = this;
            return this.HLSModule && this.manifestLoader instanceof this.HLSModule.M3u8Loader ? this.manifestLoader.switchToBackupStream(it, ht).then(function(gt) {
              return gt.length > 0;
            }).catch(function(gt) {
              return vt.debug("Could not switch to HLS backup stream: ".concat(gt)), Promise.resolve(!1);
            }) : Promise.resolve(!1);
          }, bt.prototype.getFailedSegmentIndex = function() {
            var it = this.settings.CHUNKED_CMAF_STREAMING ? 1 : this.loadingDataSegmentInfos.length;
            return this.mpdHandler.getIndex() - it;
          }, bt.prototype.handleDownloadError = function(it, ht, vt) {
            ht != null && ht.isPreloadHint ? this.debug("Ignoring download error of preload hint segment.", ht.url) : (this.debug("Failed to load segment (code: ".concat(it, ") ").concat(ht.url)), this.segmentUnavailabilityHandler.shouldTryAlternatives(it) ? this.tryToFindAValidSegment(ht, it, vt) : (this.storeFailedDownloadRange(ht), this.hasDownloadError = !0));
          }, bt.prototype.tryToFindAValidSegment = function(it, ht, vt) {
            var gt = this;
            if (this.currentRepresentationId && this.currentRepresentationId.equals(it.internalRepresentationId)) {
              var Tt = this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(He) {
                return gt.currentAdaptationSetId && He.getRepresentation(gt.currentAdaptationSetId, gt.currentRepresentationId.representationId);
              }, null, this.context.sourceContext.sourceIdentifier);
              if (Tt) {
                var rt = !1;
                this.isBackupStreamSwitchOngoing = !0, this.switchToHlsBackupStream(Tt, it).then(function(He) {
                  return rt = He;
                }).finally(function() {
                  return gt.isBackupStreamSwitchOngoing = !1;
                }).then(function() {
                  var He;
                  return (He = gt.segmentManager) === null || He === void 0 ? void 0 : He.cancel();
                }).then(function() {
                  return gt.tryToRecoverWithValidSegment(rt, it, ht, vt);
                });
              }
            } else
              this.debug("Ignoring download error of previous representation.");
          }, bt.prototype.tryToRecoverWithValidSegment = function(it, ht, vt, gt) {
            var Tt, rt = this.getFailedSegmentIndex();
            if (this.loadingDataSegmentInfos = [], it)
              this.mpdHandler.setIndex(Math.max(0, rt));
            else if (Tt = this.segmentUnavailabilityHandler.switchBaseURL(ht))
              this.loadFromSegmentInfo(Tt);
            else {
              var He = this.maybeTryLowerQuality(this.currentRepresentationId);
              if (He) {
                if (this.streamTimeService) {
                  this.mpdHandler.setIndex(Math.max(0, rt)), this.debug("Trying with lower quality segment ".concat(He.representationId));
                  var Ye = this.streamTimeService.getTimeForNextSegment((0, qe.getTrackIdentifier)(ht)), ct = this.mpdHandler.getLatestTimeForPossibleSwitch(Ye);
                  this.getNext(ct, He);
                }
              } else
                this.hasDownloadError = !0, this.handleFailedSegmentDownload(ht, vt, gt);
            }
          }, bt.prototype.maybeTryLowerQuality = function(it) {
            var ht, vt, gt;
            if (it && (!((ht = this.adaptationService) === null || ht === void 0) && ht.isAuto(this.mimeType))) {
              var Tt = (gt = (vt = this.maybeGetAdaptationSet(this.currentAdaptationSetId)) === null || vt === void 0 ? void 0 : vt.Representation) !== null && gt !== void 0 ? gt : [];
              return this.segmentUnavailabilityHandler.switchQuality(Tt, it);
            }
          }, bt.prototype.handleFailedRepresentationDownload = function(it) {
            var ht;
            if (this.maybeIsLive() && this.settings.INFINITE_RETRIES_FOR_LIVE) {
              this.debug("Could not load any segment of any quality from any CDN: restart retries."), this.segmentUnavailabilityHandler.downloadSuccess(!1);
              var vt = mt(this.currentRepresentationId, this.context);
              vt && (this.sourceStore.dispatch((0, Ze.updateRepresentationFailedDownloadAction)(vt._internalId, null)), (ht = this.manifestUpdateScheduler) === null || ht === void 0 || ht.scheduleRepresentationUpdate(vt));
            } else {
              var gt = mt(it, this.context);
              (0, $t.throwPlaylistDownloadError)(this.context, "Could not load segments of any quality from any CDN", gt);
            }
          }, bt.prototype.handleFailedSegmentDownload = function(it, ht, vt) {
            this.storeFailedDownloadRange(it), this.maybeIsLive() && this.settings.INFINITE_RETRIES_FOR_LIVE ? (this.debug("Could not load current segment of any quality from any CDN (all retries failed), skipping it..."), this.continueWithNextSegment(it)) : (0, pt.throwDownloadError)(this.context, "Segment not available at any quality or location", ht, it, vt);
          }, bt.prototype.storeFailedDownloadRange = function(it) {
            var ht, vt = (0, lt.getSegmentInfoTimeRange)(it);
            if (vt && (0, Te.isContextAvailable)(this.context) && it.mimeType) {
              var gt = (0, qe.getTrackIdentifier)(it);
              (ht = (0, we.getSourceStore)(this.context)) === null || ht === void 0 || ht.dispatch((0, Qe.addStreamTimeRange)(gt, vt, qe.StreamTimeRangeType.Failed));
            }
          }, bt.prototype.continueWithNextSegment = function(it) {
            if (this.segmentUnavailabilityHandler.downloadSuccess(!1), it.hasDownloadFailed = !0, it.startTime != null && it.duration != null) {
              var ht = it.startTime + it.duration, vt = this.mpdHandler.adjustTimeToNextSegmentStart(ht);
              this.getNext(vt);
            }
          }, bt.prototype.onABRCancellation = function(it) {
            var ht, vt = this;
            (0, Te.isContextAvailable)(this.context) && (this.debug("Download took too long, cancelled it", it.url), !it.isInitSegment && this.mpdHandler && ((ht = this.segmentManager) === null || ht === void 0 || ht.cancel().then(function() {
              if (vt.mpdHandler) {
                var gt = vt.getFailedSegmentIndex();
                vt.loadingDataSegmentInfos = [], vt.debug("Trying to get the same segment with a lower bitrate."), vt.mpdHandler.setIndex(Math.max(0, gt));
              }
            })));
          }, bt.prototype.findAdaptationSetId = function(it, ht, vt) {
            var gt = this;
            if (vt === void 0 && (vt = !1), this.isSubtitleSegmentController && !(ht != null && ht.id))
              return this.currentLangObj = ht, void (this.segmentManager && this.cancelLoading());
            var Tt = this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(rt) {
              return rt.findAdaptationSet(it, gt.mimeType, ht, vt);
            }, null, this.context.sourceContext.sourceIdentifier);
            return Tt ? (this.currentLangObj = this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(rt) {
              return rt.getLangObjectFromAdaptationSet(Tt, gt.mimeType);
            }, void 0, this.context.sourceContext.sourceIdentifier), Tt._internalId) : void 0;
          }, bt.prototype.getCurrentAdaptationSet = function() {
            return this.maybeGetAdaptationSet(this.currentAdaptationSetId);
          }, bt.prototype.getAdaptationSetForPeriodId = function(it) {
            return this.maybeGetAdaptationSet(this.loadedAdaptationSetIds[it]) || this.getCurrentAdaptationSet();
          }, bt.prototype.updateMpd = function() {
            var it;
            this.debug("Caught a manifest update event");
            var ht = !this.maybeFindPeriod(this.currentPeriodId);
            for (var vt in this.currentAdaptationSetId = this.findAdaptationSetId(this.currentPeriodId, this.currentLangObj, !1), !ht && this.currentAdaptationSetId && (this.loadedAdaptationSetIds[this.currentPeriodId] = this.currentAdaptationSetId, (it = this.adaptationService) === null || it === void 0 || it.setAdaptationSetId(this.mimeType, this.currentAdaptationSetId), this.mpdHandler.setAdaptationSetId(this.currentAdaptationSetId, this.currentRepresentationId, { isPeriodSwitch: !1, isManifestUpdate: !0 })), this.loadedAdaptationSetIds)
              this.maybeFindPeriod(vt) || delete this.loadedAdaptationSetIds[vt];
          }, bt.prototype.activateSubtitleSegmentController = function(it) {
            var ht;
            this.isSubtitleSegmentController && (this.currentAdaptationSetId && (this.mpdHandler.setAdaptationSetId(this.currentAdaptationSetId), (ht = this.adaptationService) === null || ht === void 0 || ht.setAdaptationSetId(this.mimeType, this.currentAdaptationSetId)), isNaN(this.mpdHandler.getTimestampOffset()) && this.mpdHandler.setTimestampOffset(0), this.seekTo(it));
          }, bt.prototype.setCurrentLangObj = function(it) {
            var ht;
            if (this.hls.isAvMuxedTogether && Me.MimeTypeHelper.isVideo(this.mimeType)) {
              var vt = this.maybeGetAdaptationSet(this.currentAdaptationSetId);
              if (vt != null && vt.ContentComponent) {
                var gt = vt.ContentComponent.find(function(Tt) {
                  return Tt._contentType === "audio" && Tt._id === it.id;
                });
                if (gt)
                  return this.hls.muxedAudioTrackIndex = vt.ContentComponent.filter(function(Tt) {
                    return Tt._contentType === "audio";
                  }).indexOf(gt), void (this.currentLangObj = it);
              }
            }
            it.id !== ((ht = this.currentLangObj) === null || ht === void 0 ? void 0 : ht.id) && this.switchAdaptationSetId(it);
          }, bt.prototype.switchAdaptationSetId = function(it) {
            var ht = this.currentAdaptationSetId;
            if (this.currentAdaptationSetId && this.sourceStore.dispatch((0, Ve.removeActiveTrackAction)(this.currentAdaptationSetId)), this.currentAdaptationSetId = this.findAdaptationSetId(this.currentPeriodId, it), this.currentAdaptationSetId) {
              var vt = this.maybeGetAdaptationSet(this.currentAdaptationSetId);
              vt && this.sourceStore.dispatch((0, Ve.setMediaTypeAction)(vt._internalId, (0, Oe.resolveMediaTypes)(vt))), this.loadedAdaptationSetIds[this.currentPeriodId] = this.currentAdaptationSetId, ht && !this.currentAdaptationSetId.equals(ht) && this.switchDependentToNewLanguageObject(it);
            }
          }, bt.prototype.switchDependentToNewLanguageObject = function(it) {
            var ht, vt;
            this.currentLangObj = it, this.previousExplicitlySetLangObj = it, this.debug("Trying to set language to ID ".concat(this.currentLangObj.id) + " (lang: ".concat(this.currentLangObj.lang, ") for mpd handler and adaption handler")), this.currentAdaptationSetId && (this.mpdHandler.setAdaptationSetId(this.currentAdaptationSetId), (ht = this.adaptationService) === null || ht === void 0 || ht.setAdaptationSetId(this.mimeType, this.currentAdaptationSetId), (vt = this.adaptationService) === null || vt === void 0 || vt.selectRepresentation(this.mimeType));
          }, bt.prototype.getCurrentLangObj = function() {
            return this.currentLangObj;
          }, bt.prototype.stop = function() {
            var it, ht;
            this.cancelLoading(), (it = this.segmentManager) === null || it === void 0 || it.clearCache(), (ht = this.adaptationService) === null || ht === void 0 || ht.shutdown(this.mimeType);
          }, bt.prototype.init = function() {
            var it, ht = this, vt = this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(He) {
              return He.getFirstPeriod();
            }, void 0, this.context.sourceContext.sourceIdentifier);
            !this.currentPeriodId && vt && (this.currentPeriodId = vt._id);
            var gt = yt.MPDHandlerFactory.createInstance(this.context, this.mimeType, this.manifestLoader, this.currentPeriodId);
            if (gt) {
              this.mpdHandler = gt;
              var Tt, rt = et(this.mimeType);
              rt && (Tt = (0, Be.createSegmentParser)(this.context, rt)), Tt ? this.segmentParser = Tt : this.debug("Could not create segment parser for mime type"), this.timestampOffsetService = new We.TimestampOffsetService(this.context, this.mimeType), this.segmentPreProcessor = new Xe.SegmentPreProcessor(this.context, this.mimeType, this.onDataAvailableCallback, this.hls, this.segmentUnavailabilityHandler, this.timestampOffsetService, this.segmentParser), this.segmentPreProcessor.setMpdHandler(this.mpdHandler), this.hasDownloadError = !1, this.currentAdaptationSetId = this.findAdaptationSetId(this.currentPeriodId, this.currentLangObj), this.currentAdaptationSetId && (this.loadedAdaptationSetIds[this.currentPeriodId] = this.currentAdaptationSetId), this.context.serviceManager.maybeCall(ce.ServiceName.SegmentService, function(He) {
                return He.add({ mimeType: ht.mimeType, shouldDownloadBeCancelledCallback: ht.onShouldDownloadBeCancelled }, ht.segmentParser, ht.currentLangObj);
              }), this.maybeIsHlsManifest() && (this.hlsTimelineTracker = new this.HLSModule.HlsTimelineTracker(this.context, this.settings.GAP_TOLERANCE), this.segmentPreProcessor.setHlsTimelineTracker(this.hlsTimelineTracker)), Me.MimeTypeHelper.isMP4(this.mimeType) && this.context.serviceManager.maybeCall(ce.ServiceName.SubtitleService, function(He) {
                He.setupCea608CaptionExtractor(ht.context.logger);
              }), this.currentAdaptationSetId && ((it = this.adaptationService) === null || it === void 0 || it.setAdaptationSetId(this.mimeType, this.currentAdaptationSetId), this.mpdHandler.setAdaptationSetId(this.currentAdaptationSetId, void 0, { isPeriodSwitch: !0 }), this.maybeIsLive() && !this.settings.ENABLE_SEEK_FOR_LIVE && this.mpdHandler.timeShift(0, this.currentPeriodId)), this.isLastSegment = !1;
            } else
              this.eventHandler.fireError(new le.PlayerError(fe.ErrorCode.SOURCE_MANIFEST_INVALID));
          }, bt.prototype.getSegmentInfos = function() {
            var it, ht = this, vt = (it = this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(gt) {
              return gt.getAvailableBaseURLsForRepresentation(ht.currentRepresentationId);
            }, null, this.context.sourceContext.sourceIdentifier)) === null || it === void 0 ? void 0 : it[0];
            return this.mpdHandler.getSegmentInfos(vt);
          }, bt.prototype.getCurrentPeriodId = function() {
            return this.currentPeriodId;
          }, bt.prototype.getTargetLanguageObject = function(it) {
            var ht = this;
            return this.previousExplicitlySetLangObj && this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(vt) {
              return vt.isLanguageAvailable(it, ht.mimeType, ht.previousExplicitlySetLangObj);
            }, !1, this.context.sourceContext.sourceIdentifier) ? this.previousExplicitlySetLangObj : this.currentLangObj;
          }, bt.prototype.switchPeriod = function(it) {
            var ht, vt, gt, Tt = this, rt = this.getTargetLanguageObject(it);
            if (this.debug("switching period from ".concat(this.currentPeriodId, " to ").concat(it)), this.cancelLoading(), (ht = this.segmentManager) === null || ht === void 0 || ht.clearCache(), this.removeCachedSegmentsOfPrecedingPeriods(), this.currentPeriodId = it, this.currentRepresentationId = void 0, this.currentAdaptationSetId = this.findAdaptationSetId(it, rt, !0), this.currentAdaptationSetId && (this.loadedAdaptationSetIds[it] = this.currentAdaptationSetId), this.currentAdaptationSetId) {
              (vt = this.adaptationService) === null || vt === void 0 || vt.setAdaptationSetId(this.mimeType, this.currentAdaptationSetId);
              var He = this.mpdHandler.getPendingSegmentInfoRequest(), Ye = yt.MPDHandlerFactory.createInstance(this.context, this.mimeType, this.manifestLoader, it, rt);
              Ye ? (this.mpdHandler.dispose(), this.mpdHandler = Ye) : this.eventHandler.fireError(new le.PlayerError(fe.ErrorCode.SOURCE_MANIFEST_INVALID)), this.segmentPreProcessor.setMpdHandler(this.mpdHandler), this.mpdHandler.setPendingSegmentInfoRequest(He), this.mpdHandler.setAdaptationSetId(this.currentAdaptationSetId, void 0, { isPeriodSwitch: !0 });
            }
            if (this.isTransmuxerRequired()) {
              var ct = this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(_t) {
                return Tt.currentAdaptationSetId && _t.findDownloadedHlsRepresentation(Tt.currentAdaptationSetId);
              }, null, this.context.sourceContext.sourceIdentifier);
              ct && this.mpdHandler.setRepresentationId(ct._internalId), this.hlsTimelineTracker && this.hlsTimelineTracker.reset(), (gt = this.segmentManager) === null || gt === void 0 || gt.clearCache(!1);
            }
            this.hasDownloadError = !1, this.isLastSegment = !1;
          }, bt.prototype.getMPDHandler = function() {
            return this.mpdHandler;
          }, bt.prototype.getIndex = function() {
            return this.mpdHandler && this.mpdHandler.getIndex() || 0;
          }, bt.prototype.getSourceBufferTypes = function() {
            var it = [];
            return this.isTransmuxerRequired() && this.hls.isAvMuxedTogether ? (it.push("video/mp4"), it.push("audio/mp4")) : it.push(this.mimeType), it;
          }, bt.prototype.getCodecs = function() {
            var it, ht = this.getCurrentAdaptationSet();
            return (it = ht && (0, De.getCodecsFromAdaptationSet)(ht)) !== null && it !== void 0 ? it : void 0;
          }, bt.prototype.getLiveEdgeTime = function() {
            return this.maybeIsLive() ? this.mpdHandler.getLiveEdgeTime() : -1;
          }, bt.prototype.setAdaptionLogicStartupPhase = function() {
            var it;
            (it = this.adaptationService) === null || it === void 0 || it.setStartupPhase(this.mimeType);
          }, bt.prototype.getMimeType = function() {
            return this.mimeType;
          }, bt.prototype.removeCachedSegmentsOfPrecedingPeriods = function() {
            var it = this, ht = this.context.store.getState(), vt = ht ? (0, ye.getMetricsState)(ht) : void 0;
            if (this.segmentManager && vt) {
              var gt = this.sourceStore.getState(), Tt = gt ? (0, nt.getPlayingPeriodId)(gt) : void 0;
              this.segmentManager.removeCachedInitSegments(function(rt) {
                return it.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(He) {
                  return He.isPrecedingPeriod(Tt, rt.getPeriodId());
                }, !1, it.context.sourceContext.sourceIdentifier);
              }), ((0, ye.getMetricsHistory)(vt, this.mimeType, Se.MetricType.CachedInitSegments) || []).filter(function(rt) {
                var He = rt.value.internalRepId.periodId;
                return it.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(Ye) {
                  return Ye.isPrecedingPeriod(Tt, He);
                }, !1, it.context.sourceContext.sourceIdentifier);
              }).forEach(function(rt) {
                return it.context.store.dispatch((0, $e.removeMetricsValue)(it.mimeType, Se.MetricType.CachedInitSegments, rt));
              });
            }
          }, bt.prototype.canLoad = function() {
            var it;
            return !!(!((it = this.segmentManager) === null || it === void 0) && it.canLoad());
          }, bt.prototype.isTransmuxerRequired = function() {
            return this.hls.isTransmuxingRequired;
          }, bt.prototype.setTransmuxer = function(it) {
            this.hls.transmuxer = it;
          }, bt.prototype.getTransmuxer = function() {
            return this.hls.transmuxer;
          }, bt.prototype.resetTransmuxer = function() {
            this.hls.transmuxer && this.hls.transmuxer.reset();
          }, bt.prototype.maybeIsHlsManifest = function() {
            return this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(it) {
              return it.isHlsManifest();
            }, !1, this.context.sourceContext.sourceIdentifier);
          }, bt.prototype.maybeIsSmoothManifest = function() {
            return this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(it) {
              return it.isSmoothManifest();
            }, !1, this.context.sourceContext.sourceIdentifier);
          }, bt.prototype.maybeIsLive = function() {
            return this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(it) {
              return it.isLive();
            }, !1, this.context.sourceContext.sourceIdentifier);
          }, bt.prototype.maybeFindPeriod = function(it) {
            return this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(ht) {
              return ht.findPeriod(it);
            }, null, this.context.sourceContext.sourceIdentifier);
          }, bt.prototype.maybeGetAdaptationSet = function(it) {
            return this.context.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(ht) {
              return ht.getAdaptationSet(it);
            }, null, this.context.sourceContext.sourceIdentifier);
          }, bt.prototype.dispose = function() {
            var it, ht;
            (0, he.dispose)(this.mpdHandler), (0, he.dispose)(this.timestampOffsetService), (0, he.dispose)(this.segmentPreProcessor), (it = this.adaptationService) === null || it === void 0 || it.release(this.mimeType), this.hlsTimelineTracker && this.hlsTimelineTracker.dispose(), (0, Te.isContextAvailable)(this.context) && ((ht = this.context.serviceManager.get(ce.ServiceName.SegmentService)) === null || ht === void 0 || ht.disposeOfType(this.mimeType, this.currentLangObj)), this.parkedSegmentSubscriptions.forEach(function(vt) {
              return vt();
            });
          }, bt;
        }();
        function at(bt, it) {
          var ht = it.findIndex(function(vt) {
            return (0, ft.areSegmentsIdentical)(vt, bt);
          });
          ht > -1 && it.splice(ht, 1);
        }
        function dt(bt, it) {
          var ht = (0, lt.getSegmentInfoTimeRange)(bt), vt = (0, qe.getTrackIdentifier)(bt);
          ht && (it == null || it.dispatch((0, Qe.removeStreamTimeRange)(vt, ht, qe.StreamTimeRangeType.Loading)));
        }
        function ot(bt, it, ht, vt, gt) {
          var Tt = bt.serviceManager.get(ce.ServiceName.AdaptationService), rt = bt.serviceManager.get(ce.ServiceName.ManifestService, bt.sourceContext.sourceIdentifier), He = function(Ye, ct) {
            var _t = !!(Tt != null && Tt.shouldDownloadBeCancelled(it, Ye, ct));
            return rt != null && rt.isHlsManifest() && vt.possiblyDependentSegments && _t ? (bt.logger.debug("Download should be cancelled, but this is disabled for segments not starting with key frames"), !1) : _t;
          };
          return bt.serviceManager.maybeCall(ce.ServiceName.SegmentService, function(Ye) {
            return Ye.add({ mimeType: it, shouldDownloadBeCancelledCallback: He }, ht, gt);
          });
        }
        function et(bt) {
          var it = bt.split("/")[1].toLowerCase();
          return Object.values(Le.ContainerFormat).find(function(ht) {
            return ht === it;
          });
        }
        function st(bt) {
          return bt.transmuxedSegments.some(function(it) {
            return Me.MimeTypeHelper.isAV(it.getMimeType()) && !it.isIndependentlyDecodable();
          });
        }
        function mt(bt, it) {
          if (bt && (0, Te.isContextAvailable)(it))
            return it.serviceManager.maybeCall(ce.ServiceName.ManifestService, function(ht) {
              return ht.getRepresentationById(bt);
            }, void 0, it.sourceContext.sourceIdentifier);
        }
        function St(bt) {
          return bt instanceof le.PlayerError ? [fe.ErrorCode.SOURCE_MANIFEST_INVALID, fe.ErrorCode.SOURCE_COULD_NOT_LOAD_MANIFEST].includes(bt.code) : bt === me.RequestError.Failed || bt === ut.SegmentInfoError.COULD_NOT_LOAD_PLAYLIST;
        }
        ie.SegmentController = Ge;
      }, 20417: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.throwDownloadError = ce;
        var ae = ne(25550), ue = ne(28764), _e = ne(63546), fe = ne(35148), le = ne(62510), se = ne(90637), oe = ne(66864);
        function ce(ve, me, be, pe, $e) {
          ve.eventHandler.dispatchEvent(le.PlayerEvent.Warning, new _e.PlayerWarning(fe.WarningCode.PLAYBACK_DECODE_RETRIES_EXCEEDED)), ve.eventHandler.fireError(he(ve, me, be, pe, $e));
        }
        function he(ve, me, be, pe, $e) {
          if (be === 0)
            return me && me === se.RequestError.TimedOut || $e === oe.SegmentLoadingErrorReason.TIMEOUT ? new ue.PlayerError(ae.ErrorCode.NETWORK_SEGMENT_DOWNLOAD_TIMEOUT, { segmentUrl: pe.url, mimeType: pe.mimeType }, "Failed to load the segment: the request timed out.") : new ue.PlayerError(ae.ErrorCode.NETWORK_ERROR, { url: pe.url, statusCode: be }, me);
          ve.logger.debug(me);
          var ye = { message: me };
          return pe.url && (ye.segment = ge(pe)), $e === oe.SegmentLoadingErrorReason.TIMEOUT ? new ue.PlayerError(ae.ErrorCode.NETWORK_SEGMENT_DOWNLOAD_TIMEOUT, ye, me) : new ue.PlayerError(ae.ErrorCode.NETWORK_ERROR, ye, me);
        }
        function ge(ve) {
          return { url: ve.url, mimeType: ve.mimeType, codecs: ve.codecs };
        }
      }, 9378: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentInfoProvider = void 0;
        var ae = ne(76885), ue = ne(9827), _e = function() {
          function fe() {
          }
          return fe.findSegmentInfoOfRepresentation = function(le, se) {
            if (se.SegmentList) {
              var oe = se.SegmentList[0].SegmentURL, ce = le.getUrl(), he = oe.find(function(ge) {
                return fe.getSegmentInfoUrl(ge, se) === ce;
              });
              if (he)
                return he;
            }
            return null;
          }, fe.findHlsRepresentationForSegment = function(le, se) {
            var oe, ce, he = se.Representation.find(function(ve) {
              return le.getRepresentationId().representationId === ve._internalId.representationId;
            });
            if (he) {
              var ge = (0, ue.findSegmentUrlIndexWithinSegmentList)(le.getSegmentInfo(), (ce = (oe = he.SegmentList) === null || oe === void 0 ? void 0 : oe[0].SegmentURL) !== null && ce !== void 0 ? ce : []);
              if (ge !== -1)
                return { representation: he, index: ge };
            }
          }, fe.getSegmentInfoUrl = function(le, se) {
            var oe = le._media;
            return ae.URLHelper.isUrlAbsolute(oe) || (oe = ae.URLHelper.concatUrlParts(se.BaseURL[0], oe)), oe;
          }, fe;
        }();
        ie.SegmentInfoProvider = _e;
      }, 13788: function(ee, ie, ne) {
        var ae = this && this.__spreadArray || function(he, ge, ve) {
          if (ve || arguments.length === 2)
            for (var me, be = 0, pe = ge.length; be < pe; be++)
              !me && be in ge || (me || (me = Array.prototype.slice.call(ge, 0, be)), me[be] = ge[be]);
          return he.concat(me || Array.prototype.slice.call(ge));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentInfoService = void 0, ie.getSegmentInfoId = ce;
        var ue = ne(18665), _e = ne(27177), fe = function() {
          function he() {
            this.segmentControllers = [];
          }
          return he.prototype.updatePlayerContext = function(ge) {
            this.context = ge;
          }, he.prototype.setSegmentControllers = function(ge) {
            this.segmentControllers = ge;
          }, he.prototype.getSegmentControllerMimeTypes = function() {
            return this.segmentControllers.map(function(ge) {
              return ge.getMimeType();
            });
          }, he.prototype.getSegmentInfos = function(ge, ve) {
            if (!(0, _e.isContextAvailable)(this.context))
              return Promise.resolve([]);
            var me = this.context.serviceManager.get(ue.ServiceName.ManifestService, this.context.sourceContext.sourceIdentifier).getPeriodIdForTime(ge), be = this.segmentControllers.map(function(pe) {
              return le(pe, { startTime: ge, duration: ve, targetPeriodId: me });
            });
            return Promise.all(be).then(function(pe) {
              return pe.flatMap(function($e) {
                return $e;
              });
            });
          }, he.prototype.dispose = function() {
            this.segmentControllers = [];
          }, he;
        }();
        function le(he, ge) {
          return he.getCurrentPeriodId() !== ge.targetPeriodId && he.switchPeriod(ge.targetPeriodId), he.seekTo(ge.startTime), he.getCurrentAdaptationSet() ? se(he, ge) : Promise.resolve([]);
        }
        function se(he, ge) {
          return oe(he, ge.duration).then(function(ve) {
            if (ve.length > 0) {
              var me = he.getInitSegmentInfoForDataSegmentInfo(ve[0]);
              if (me)
                return ae([me], ve, !0);
            }
            return ve;
          });
        }
        function oe(he, ge, ve) {
          ve === void 0 && (ve = []);
          var me = ve[ve.length - 1], be = me ? me.startTime + me.duration : 0;
          return ge <= 0 || !he.hasNext(be) ? Promise.resolve(ve) : he.getDataSegmentInfo(be).then(function(pe) {
            return pe.duration && (ge -= pe.duration), ve.push(pe), oe(he, ge, ve);
          });
        }
        function ce(he) {
          return he.url + (he.byteRange ? "," + JSON.stringify(he.byteRange) : "");
        }
        ie.SegmentInfoService = fe;
      }, 28915: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.isSegmentTiming = _e, ie.findSegmentIndexForTime = fe, ie.createInitSegmentInfoBase = oe, ie.getSegmentInfoTimeRange = ce, ie.generateSegmentId = he;
        var ae = ne(70016), ue = ne(54838);
        function _e(ge) {
          return "startTime" in ge && (0, ae.isNumber)(ge.startTime) && "duration" in ge && (0, ae.isNumber)(ge.duration);
        }
        function fe(ge, ve, me) {
          var be = !ge || !ge.length, pe = ve < ge[0].startTime + ge[0].duration;
          if (be || pe)
            return 0;
          var $e = ge.length - 1;
          if (ve >= ge[$e].startTime)
            return $e;
          var ye = Math.max(ve - ge[0].startTime, 0), Se = Math.min(Math.floor(ye / me), ge.length - 1);
          return le(ge[0]) && le(ge[Se]) ? se(ge, ve, Se) : null;
        }
        function le(ge) {
          return ge && (0, ae.isNumber)(ge.startTime);
        }
        function se(ge, ve, me) {
          for (; ge[me] && ge[me].startTime > ve; )
            me--;
          for (; ge[me] && ge[me].startTime + ge[me].duration <= ve; )
            me++;
          return me = Math.max(me, 0), me = Math.min(me, ge.length - 1);
        }
        function oe(ge) {
          var ve = ge._internalId;
          return { internalRepresentationId: ve, representationId: ve.representationId, periodId: ve.periodId, mimeType: ge._mimeType, isInitSegment: !0 };
        }
        function ce(ge) {
          if (ge != null && ge.duration && (ge == null ? void 0 : ge.startTime) !== void 0)
            return { start: ge.startTime, end: ge.startTime + ge.duration };
        }
        function he(ge) {
          var ve, me, be = (me = (ve = ge.discontinuitySequenceNumber) === null || ve === void 0 ? void 0 : ve.toString()) !== null && me !== void 0 ? me : ge.periodId, pe = ge.byteRange ? "-".concat(ge.byteRange.start, ":").concat(ge.byteRange.end) : "";
          return ue.Util.hashCode("".concat(be, ":").concat(ge.url).concat(pe));
        }
      }, 67550: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Le) {
            for (var De, Re = 1, Oe = arguments.length; Re < Oe; Re++)
              for (var Be in De = arguments[Re])
                Object.prototype.hasOwnProperty.call(De, Be) && (Le[Be] = De[Be]);
            return Le;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentListMPDHandler = ie.PHANTOM_SEGMENT_URL = void 0, ie.assignSegmentStartTimesFromHlsRepresentation = Ee, ie.copyPropValues = Ce, ie.getMatchingPart = Ie;
        var ue = ne(52442), _e = ne(18665), fe = ne(42055), le = ne(91397), se = ne(81361), oe = ne(44388), ce = ne(331), he = ne(70016), ge = ne(91520), ve = ne(16368), me = ne(92103), be = ne(93326), pe = ne(93109), $e = ne(73553), ye = ne(28915);
        ie.PHANTOM_SEGMENT_URL = "PHANTOM-SEGMENT";
        var Se = function() {
          function Le(De) {
            this.context = De, this.sourceContext = De.sourceContext, this.settings = De.settings, this.logger = De.logger, this.manifestService = De.serviceManager.get(_e.ServiceName.ManifestService, this.sourceContext.sourceIdentifier), this.distanceToListStartSeconds = 0, this.segmentListMap = {}, this.timestampOffset = NaN;
          }
          return Object.defineProperty(Le.prototype, "playerStateService", { get: function() {
            return this.context.serviceManager.get(_e.ServiceName.PlayerStateService);
          }, enumerable: !1, configurable: !0 }), Le.prototype.createSegmentListEntry = function(De, Re) {
            var Oe;
            if (!De)
              return null;
            var Be = { isInitSegment: !1, url: De._media, duration: De._duration, internalRepresentationId: Re, periodId: Re.periodId };
            if (De._key && De._key.method !== ue.HlsEncryptionMethod.NONE && (Be.key = De._key), De._playbackTime !== void 0 && (Be.startTime = De._playbackTime), De._dateTime && (Be.dateTime = De._dateTime), De._metadata && (Be.metadata = De._metadata), De._byteRange && (Be.byteRange = De._byteRange), De._init && (Be.init = De._init, ((Oe = De._init.key) === null || Oe === void 0 ? void 0 : Oe.method) === ue.HlsEncryptionMethod.NONE && (Be.init = ae({}, Be.init), delete Be.init.key)), De._mediaSequence !== void 0 && (Be.mediaSequence = De._mediaSequence), De._discontinuitySequenceNumber !== void 0 && (Be.discontinuitySequenceNumber = De._discontinuitySequenceNumber), De._parts) {
              var Fe = Be.dateTime;
              Be.parts = De._parts.map(function(Ve) {
                var Ke = Me(Ve, Be);
                return Fe && (Ke.dateTime = Fe, Ke.startTime = (0, ce.toSeconds)(Fe.getTime()), Fe = new Date(Fe.getTime() + (0, ce.toMilliSeconds)(Ve.duration))), Ke;
              });
            }
            return Be.segmentId = (0, ye.generateSegmentId)(Be), Be;
          }, Le.prototype.removeDroppedOutSegmentsFromList = function(De, Re, Oe) {
            if (Re.SegmentURL.length < 1)
              return De.entries = [], De.totalDuration = 0, De.entries.length;
            for (var Be = this.createSegmentListEntry(Re.SegmentURL[0], Oe), Fe = 0, Ve = 0, Ke = 0; Ke < De.entries.length; Ke++) {
              var Ze = De.entries[Ke];
              if ((0, me.isIdenticalSegmentInfo)(Ze, Be))
                break;
              Fe += Ze.duration, De.entries.splice(Ke, 1), Ke--, Ve++, this.manifestService.isLive() && this.currentRepresentationId.equals(Oe) && this.rewindOneSegment();
            }
            return De.totalDuration -= Fe, Ve;
          }, Le.prototype.addNewSegmentsToList = function(De, Re, Oe) {
            for (var Be = [], Fe = De.entries[De.entries.length - 1], Ve = 0, Ke = Re.SegmentURL.length - 1; Ke >= 0; Ke--) {
              var Ze = this.createSegmentListEntry(Re.SegmentURL[Ke], Oe);
              if (Fe && (0, me.isIdenticalSegmentInfo)(Fe, Ze)) {
                if (Ae(Fe)) {
                  var nt = Ne(Fe, Ze);
                  De.totalDuration += nt;
                }
                break;
              }
              Fe && (0, me.isIdenticalInitSegmentInfo)(Fe.init, Ze.init) && (Ze.init = Fe.init), isNaN(Ze.duration) && (Ze.duration = De.maximumSegmentDuration), Ze.duration /= De.timescale, Ve += Ze.duration, Be.unshift(Ze);
            }
            return De.totalDuration += Ve, De.entries = De.entries.concat(Be), Be.length;
          }, Le.prototype.updateSegmentList = function(De, Re) {
            var Oe, Be, Fe = Re.SegmentList, Ve = Re._internalId.representationId, Ke = (Oe = this.currentRepresentationId) === null || Oe === void 0 ? void 0 : Oe.equals(Re._internalId), Ze = (Be = Fe == null ? void 0 : Fe[0]) === null || Be === void 0 ? void 0 : Be.SegmentURL.length;
            if (!Ke || Ze) {
              De.Uri && De.Uri !== Re.Uri && this.resetSegmentListUponFailover(De, Fe == null ? void 0 : Fe[0], Ke), De.Uri = Re.Uri, De.timescale = 1, De.maximumSegmentDuration = 1, De.startNumber = 1;
              for (var nt = function(ze) {
                var je = Fe[ze];
                if (je.hasOwnProperty("_duration") && (De.maximumSegmentDuration = Number(je._duration)), ["_timescale", "_startNumber", "_presentationTimeOffset"].filter(function(yt) {
                  return je.hasOwnProperty(yt);
                }).forEach(function(yt) {
                  return De[yt.substr(1)] = je[yt];
                }), Qe.updateInitInfo(De, je, Re), je.hasOwnProperty("SegmentURL")) {
                  var tt = Qe.removeDroppedOutSegmentsFromList(De, je, Re._internalId), ut = Qe.addNewSegmentsToList(De, je, Re._internalId);
                  Qe.logManifestUpdateStats(Re._mimeType, Ve, tt, ut), Qe.manifestService.isHlsManifest() ? Ee(De.entries, Re._internalId, Qe.manifestService) : Qe.assignSegmentStartTimesForDash(De, Re._internalId);
                }
              }, Qe = this, qe = 0; qe < Fe.length; qe++)
                nt(qe);
            }
          }, Le.prototype.resetSegmentListUponFailover = function(De, Re, Oe) {
            var Be, Fe, Ve, Ke, Ze, nt;
            if (this.manifestService.isLive() && Oe) {
              var Qe = (Ve = (Fe = (Be = De.entries) === null || Be === void 0 ? void 0 : Be[0]) === null || Fe === void 0 ? void 0 : Fe.mediaSequence) !== null && Ve !== void 0 ? Ve : 1 / 0, qe = ((Ze = (Ke = Re == null ? void 0 : Re.SegmentURL[0]) === null || Ke === void 0 ? void 0 : Ke._mediaSequence) !== null && Ze !== void 0 ? Ze : 0) - Qe, ze = ke(De);
              !isNaN(qe) && qe > 0 && qe < ze && this.rewindSegmentListIndexBy(qe);
            }
            (0, se.clearArray)((nt = De.entries) !== null && nt !== void 0 ? nt : []);
          }, Le.prototype.updateInitInfo = function(De, Re, Oe) {
            var Be, Fe = (Be = ge.ModuleManager.get(ve.ModuleName.DASH, !1)) === null || Be === void 0 ? void 0 : Be.initSegmentInfoSourceDetectors.isInitializationNode;
            Fe != null && Fe(Re) ? De.init = ge.ModuleManager.get(ve.ModuleName.DASH, !1).initSegmentInfoProviders.provideSegmentInfoFromInitializationNodeProperty(Re, Oe) : delete De.init;
          }, Le.prototype.logManifestUpdateStats = function(De, Re, Oe, Be) {
            (Oe > 0 || Be > 0) && this.logger.debug("[".concat(De, "][").concat(Re, "] Updated segment list, removed ").concat(Oe, " segments and added ").concat(Be, " segments"));
          }, Le.prototype.assignSegmentStartTimesForDash = function(De, Re) {
            var Oe = this.getMinStartTime(Re), Be = 0;
            De.entries.forEach(function(Fe) {
              var Ve;
              Fe.startTime = Oe + Be, Be += (Ve = Fe.duration) !== null && Ve !== void 0 ? Ve : 0;
            });
          }, Le.prototype.extrapolateStartTimesFromDiscontinuityStarts = function(De) {
            var Re, Oe, Be, Fe, Ve = (Oe = (Re = this.getSourceStateService()) === null || Re === void 0 ? void 0 : Re.getState()) === null || Oe === void 0 ? void 0 : Oe.hls;
            if (Ve) {
              var Ke = De.getRepresentationId().representationId, Ze = this.getSegmentListEntries(this.currentRepresentationId), nt = ge.ModuleManager.get(ve.ModuleName.HLS).selectors, Qe = nt.getDiscoSequenceTimings, qe = nt.getMergedDiscontinuityTimings, ze = Pe(Ze, (Be = Qe(Ve, De.getMimeType())) !== null && Be !== void 0 ? Be : qe(Ve));
              if (!ze) {
                var je = (Fe = this.getCurrentPeriod()) === null || Fe === void 0 ? void 0 : Fe.start;
                if (je === void 0)
                  return;
                ze = { index: 0, discontinuityStartTime: je }, this.logger.debug("Could not find discontinuity boundary with start time, using period start time ".concat(je));
              }
              this.logger.debug("Assigning segment start times for rep ".concat(Ke, " from discontinuity at index ").concat(ze.index, " with time ").concat(ze.discontinuityStartTime)), Ze[ze.index].startTime = ze.discontinuityStartTime;
              for (var tt = ze.index - 1; tt >= 0; tt--)
                Ze[tt].startTime = Ze[tt + 1].startTime - Ze[tt + 1].duration;
              for (tt = ze.index + 1; tt < Ze.length; tt++)
                Ze[tt].startTime = Ze[tt - 1].startTime + Ze[tt - 1].duration;
            }
          }, Le.prototype.getSourceStateService = function() {
            return this.context.serviceManager.get(_e.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, Le.prototype.getListIndexForSegment = function(De, Re) {
            for (var Oe = -1, Be = this.getSegmentListEntries(Re), Fe = Be.length - 1; Fe >= 0; Fe--)
              if ((0, me.isIdenticalSegmentInfo)(Be[Fe], De)) {
                Oe = Fe;
                break;
              }
            return Oe;
          }, Le.prototype.populateSegmentListMap = function(De) {
            var Re = this;
            this.manifestService.getAdaptationSet(De).Representation.forEach(function(Oe) {
              var Be = Re.segmentListMap[Oe._internalId.key()];
              if (Be || (Be = Re.initializeSegmentList(Oe._internalId.key())), Oe.hasOwnProperty("SegmentList") && (Re.updateSegmentList(Be, Oe), ge.ModuleManager.has(ve.ModuleName.DASH))) {
                var Fe = ge.ModuleManager.get(ve.ModuleName.DASH).initSegmentInfoSourceDetectors.isInitializationNode;
                if (!Be.hasOwnProperty("init") && Oe.hasOwnProperty("SegmentBase") && Oe.SegmentBase && Fe(Oe.SegmentBase[0])) {
                  var Ve = ge.ModuleManager.get(ve.ModuleName.DASH).initSegmentInfoProviders.provideSegmentInfoFromInitializationNodeProperty;
                  Be.init = Ve(Oe.SegmentBase[0], Oe);
                }
              }
            });
          }, Le.prototype.selectNewRepresentationId = function() {
            var De, Re, Oe = this, Be = (De = this.context.serviceManager.get(_e.ServiceName.SourceStoreService, this.sourceContext.sourceIdentifier).getState().activeTracks) === null || De === void 0 ? void 0 : De[this.adaptationSetId.adaptationSetId];
            if (((Re = Be == null ? void 0 : Be.selectedRepresentationId) === null || Re === void 0 ? void 0 : Re.periodId) === this.adaptationSetId.periodId)
              return Be.selectedRepresentationId;
            if (this.currentRepresentationId) {
              var Fe = this.manifestService.getRepresentation(this.adaptationSetId, this.currentRepresentationId.representationId);
              if (Fe)
                return Fe._internalId;
            }
            var Ve = function(Ke) {
              return Oe.isSegmentInfoLoaded(Ke._internalId);
            };
            return (this.getMatchingRepresentationByBandwidth(Ve) || this.getMatchingRepresentationByBandwidth())._internalId;
          }, Le.prototype.getMatchingRepresentationByBandwidth = function(De) {
            return this.manifestService.getMatchingRepresentationByBandwidth(this.adaptationSetId, this.getCurrentBandwidth(), De);
          }, Le.prototype.shouldUpdateRepresentation = function() {
            var De = this.adaptationSetId.equals(this.currentRepresentationId), Re = !this.currentRepresentationId || !!this.manifestService.getRepresentationById(this.currentRepresentationId);
            return !this.currentRepresentationId || !De || !Re;
          }, Le.prototype.setAdaptationSetId = function(De) {
            this.adaptationSetId = De, this.populateSegmentListMap(this.adaptationSetId);
            var Re, Oe = this.manifestService.isLive(), Be = 0;
            this.shouldUpdateRepresentation() && (this.currentRepresentationId = this.selectNewRepresentationId());
            var Fe = this.segmentListMap[this.currentRepresentationId.key()];
            if (Fe || (Fe = this.initializeSegmentList(this.currentRepresentationId.key())), Fe && Oe && Fe.entries && Fe.entries.length > 0) {
              var Ve = Fe.entries.length - 1;
              this.listIndex > Ve && (Be = this.listIndex - Ve), this.listIndex = Math.min(Ve, this.listIndex || 0), this.listIndex = Math.max(0, this.listIndex), Re = Fe.entries[this.listIndex];
            }
            if (this.listIndex = this.listIndex || 0, Oe && (this.distanceToListStartSeconds = this.getSegmentDuration() * this.settings.LIVE_SEGMENT_LIST_START_INDEX_OFFSET), Oe) {
              if (Re && Fe) {
                var Ke = this.getListIndexForSegment(Re, this.currentRepresentationId);
                Ke >= 0 ? this.listIndex = Ke + Be : this.reset();
              } else
                this.reset();
              var Ze = this.checkForSegmentInfoError();
              Ze ? this.rejectPendingSegmentInfoRequest(Ze) : this.resolvePendingSegmentInfoRequests();
            } else
              this.resolvePendingSegmentInfoRequests();
          }, Le.prototype.initializeSegmentList = function(De) {
            var Re = { totalDuration: 0, entries: [], SegmentURL: [], startNumber: 0, init: null, maximumSegmentDuration: 1, timescale: 1 };
            return this.segmentListMap[De] = Re, Re;
          }, Le.prototype.getCurrentBandwidth = function() {
            var De = 0, Re = this.getCurrentRepresentation();
            return Re && (De = Re._bandwidth), De;
          }, Le.prototype.checkForSegmentInfoError = function() {
            var De;
            if (this.manifestService.isHlsManifest()) {
              var Re = this.manifestService.getRepresentationById(this.currentRepresentationId);
              if (!((De = Re == null ? void 0 : Re._hls) === null || De === void 0) && De.loadFailureReason)
                return Re._hls.loadFailureReason;
            }
            return this.hasNext() || this.manifestService.isLastPeriod(this.currentRepresentationId.periodId) ? null : $e.SegmentInfoError.PERIOD_COMPLETE;
          }, Le.prototype.reset = function() {
            this.settings.ENABLE_SEEK_FOR_LIVE ? this.listIndex = 0 : this.timeShift(0);
          }, Le.prototype.syncSegmentStartTimeUsingMediaSequenceNumber = function(De, Re) {
            var Oe, Be, Fe, Ve, Ke = this.manifestService.getRepresentationById(De), Ze = this.manifestService.getRepresentationById(Re), nt = (0, he.isNumber)((Oe = Ze == null ? void 0 : Ze._hls) === null || Oe === void 0 ? void 0 : Oe.mediaSequence) && (0, he.isNumber)((Be = Ke == null ? void 0 : Ke._hls) === null || Be === void 0 ? void 0 : Be.mediaSequence);
            if (Ke && Ze && nt) {
              var Qe = ((Fe = Ze == null ? void 0 : Ze._hls) === null || Fe === void 0 ? void 0 : Fe.mediaSequence) - ((Ve = Ke == null ? void 0 : Ke._hls) === null || Ve === void 0 ? void 0 : Ve.mediaSequence), qe = this.getSegmentListEntries(De), ze = this.getSegmentListEntries(Re);
              if (!(Qe >= qe.length)) {
                ze[0].startTime = qe[Qe].startTime;
                var je = function(tt, ut) {
                  (0, he.isNumber)(tt.startTime) && (0, he.isNumber)(tt.duration) && (ut.startTime = tt.startTime + tt.duration);
                };
                (0, se.forEachFromIndex)(ze, 1, je);
              }
            }
          }, Le.prototype.setRepresentationId = function(De) {
            var Re = this.manifestService.getRepresentationById(De), Oe = this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex];
            if (Re) {
              var Be = this.currentRepresentationId === void 0, Fe = this.currentRepresentationId;
              if (this.currentRepresentationId = De, this.manifestService.isLive() && Re._hls) {
                if (this.settings.HLS_SYNC_SEGMENT_PLAYBACK_TIME_VIA_MEDIA_SEQUENCE && this.syncSegmentStartTimeUsingMediaSequenceNumber(Fe, this.currentRepresentationId), Be)
                  this.reset();
                else if (this.settings.HLS_SYNC_VIA_MEDIA_SEQUENCE) {
                  var Ve = this.manifestService.getRepresentationById(Fe)._hls.mediaSequence + this.listIndex;
                  this.listIndex = Ve - Re._hls.mediaSequence, this.listIndex = Math.max(this.listIndex, 0);
                } else if ((Oe == null ? void 0 : Oe.startTime) != null && !isNaN(Oe.startTime)) {
                  var Ke = this.getIndexForTime(Oe.startTime);
                  Ke === null || isNaN(Ke) || (this.listIndex = this.adaptListIndexToCorrectIndex(Ke, Oe.startTime));
                }
              }
              return !0;
            }
            return !1;
          }, Le.prototype.adaptListIndexToCorrectIndex = function(De, Re) {
            var Oe = this.getSegmentListEntries(this.currentRepresentationId), Be = [Oe[De], Oe[De + 1]];
            if (De === Oe.length - 1 || Be.some(function(Ke) {
              return !Ke.startTime;
            }))
              return De;
            var Fe = Be.map(function(Ke) {
              return Math.abs(Ke.startTime - Re);
            }), Ve = Math.min.apply(this, Fe);
            return De + Fe.indexOf(Ve);
          }, Le.prototype.getInitSegmentInfo = function() {
            var De = this.getSegmentList(this.currentRepresentationId);
            if (De != null && De.init)
              return De.init.presentationTimeOffset = this.getTimestampOffset(), De.init;
            var Re = this.getSegmentListEntries(this.currentRepresentationId);
            if (this.isIndexInBounds(Re) && this.listIndex > -1) {
              var Oe = ae({}, Re[this.listIndex]);
              if (Oe.init) {
                var Be = Oe.init;
                return Be.isInitSegment = !0, Be;
              }
            }
            return null;
          }, Le.prototype.getNextSegmentInfo_ = function(De) {
            var Re;
            if (!(this.getSegmentListEntries(this.currentRepresentationId).length < 1 || this.listIndex < 0)) {
              var Oe = this.isTargetTimeOfOngoingSeek(De);
              return Oe && this.logger.debug("".concat((Re = this.adaptationSetId) === null || Re === void 0 ? void 0 : Re.adaptationSetId, " given time ").concat(De, " matches seek time, performing precise segment/part search"), De), (0, pe.isPlayingLowLatencyHls)(this.context) && this.setListIndexForTime(De, Oe), this.getNextSegmentOrPart(De, Oe);
            }
          }, Le.prototype.isTargetTimeOfOngoingSeek = function(De) {
            var Re;
            return De === ((Re = this.playerStateService) === null || Re === void 0 ? void 0 : Re.targetPlaybackTime) || !1;
          }, Le.prototype.setListIndexForTime = function(De, Re) {
            var Oe;
            if (De !== 0) {
              if (this.listIndex = this.getIndexForTime(De), !Re) {
                var Be = this.getSegmentListEntries(this.currentRepresentationId), Fe = Be[this.listIndex];
                if (!(Fe.parts && Fe.parts.length > 0)) {
                  var Ve = this.listIndex;
                  this.listIndex = xe(De, this.listIndex, Be), this.listIndex !== Ve && this.logger.debug("Snapped segment index for time ".concat(De, " to next segment boundary at ").concat((Oe = Be[this.listIndex]) === null || Oe === void 0 ? void 0 : Oe.startTime));
                }
              }
            } else
              this.context.logger.debug("Ignoring target time of 0 for LL-HLS");
          }, Le.prototype.getNextSegmentOrPart = function(De, Re) {
            var Oe = this.getSegmentListEntries(this.currentRepresentationId);
            if (this.isIndexInBounds(Oe)) {
              var Be = Oe[this.listIndex];
              if (!(Be.parts && Be.parts.length > 0))
                return this.getNextFullSegmentInfo();
              if (Ae(Be))
                return Ie(Be, De, Re);
              var Fe = Ie(Be, De, Re);
              return Fe ? Be.parts.indexOf(Fe) > 0 ? Fe : this.getNextFullSegmentInfo() : (this.listIndex++, this.getNextSegmentOrPart(De, Re));
            }
          }, Le.prototype.getNextSegmentInfo = function(De) {
            var Re = this.getNextSegmentInfo_(De);
            return Re ? (this.populateSegmentInfoProps(Re), Promise.resolve(Re)) : this.queueSegmentInfoRequest({ time: De });
          }, Le.prototype.populateSegmentInfoProps = function(De) {
            return De.presentationTimeOffset = this.getTimestampOffset(), De.startTime && (De.wallClockTime = (0, ce.toMilliSeconds)(De.startTime)), De;
          }, Le.prototype.getNextFullSegmentInfo = function() {
            return this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex++];
          }, Le.prototype.getSegmentInfos = function() {
            var De = this, Re = {}, Oe = this.manifestService.getAdaptationSet(this.adaptationSetId);
            return Oe && Oe.Representation.forEach(function(Be) {
              var Fe = De.getSegmentListEntries(Be._internalId);
              Re[Be._id] = Fe.map(function(Ve) {
                return { url: Ve.url, duration: Ve.duration, startTime: Ve.startTime };
              });
            }), Re;
          }, Le.prototype.getSubtitleUrl = function() {
            return this.manifestService.getAvailableSubtitles(this.adaptationSetId.periodId)[0].url;
          }, Le.prototype.getStartNumber = function() {
            var De = this.getSegmentList(this.currentRepresentationId);
            return De ? De.startNumber : 1;
          }, Le.prototype.getSegmentDuration = function() {
            var De = this, Re = this.getSegmentList(this.currentRepresentationId), Oe = this.getSegmentListEntries(this.currentRepresentationId);
            if (Re)
              return Oe.length > 0 && (0, he.isNumber)(Re.totalDuration) ? Re.totalDuration / Oe.length : Re.maximumSegmentDuration;
            if (this.manifestService.getAdaptationSet(this.adaptationSetId)) {
              var Be = Object.keys(this.segmentListMap).map(function(Fe) {
                return De.segmentListMap[Fe];
              }).find(function(Fe) {
                return Fe !== null;
              });
              if (Be)
                return Be.maximumSegmentDuration;
            }
            return 1;
          }, Le.prototype.seekTo = function(De) {
            De > -1 && (this.listIndex = this.getIndexForTime(De));
          }, Le.prototype.isIndexInBounds = function(De) {
            return this.listIndex < De.length;
          }, Le.prototype.hasNext = function() {
            var De = this.getSegmentListEntries(this.currentRepresentationId);
            return !this.currentRepresentationId || !De.length || (this.manifestService.isLive() ? this.hasNextLive(De) : this.isIndexInBounds(De));
          }, Le.prototype.hasNextLive = function(De) {
            return !!this.manifestService.isLastPeriod(this.currentRepresentationId.periodId) || this.isIndexInBounds(De);
          }, Le.prototype.setTimestampOffset = function(De, Re) {
            Re === void 0 && (Re = 1), this.timestampOffset = De / Re;
          }, Le.prototype.getTimestampOffset = function() {
            if (!isNaN(this.timestampOffset))
              return this.timestampOffset;
            var De = this.getCurrentPeriod(), Re = 0;
            if (this.currentRepresentationId) {
              var Oe = this.getSegmentList(this.currentRepresentationId);
              Oe && !isNaN(Oe.presentationTimeOffset) && (Re = Oe.presentationTimeOffset / Oe.timescale);
            }
            return De && !this.manifestService.isHlsManifest() && (Re -= De.start), Re;
          }, Le.prototype.getIndex = function() {
            return this.listIndex;
          }, Le.prototype.setIndex = function(De) {
            if (typeof De == "number")
              return De < 0 ? (this.logger.debug("Tried to set index at MPDHandler to value smaller 0. Setting to 0."), void (this.listIndex = 0)) : void (this.listIndex = De);
            this.logger.debug("Tried to set index at MPDHandler with parameter not being a number!");
          }, Le.prototype.queueSegmentInfoRequest = function(De) {
            var Re, Oe = this;
            if (this.pendingSegmentInfoRequest)
              return Promise.reject("fail");
            var Be = this.manifestService.getRepresentationById(this.currentRepresentationId);
            return !((Re = Be == null ? void 0 : Be._hls) === null || Re === void 0) && Re.loadFailureReason ? Promise.reject(Be._hls.loadFailureReason) : (this.logger.debug("No segment info was found for the target time. Waiting for representation update."), new Promise(function(Fe, Ve) {
              Oe.pendingSegmentInfoRequest = ae(ae({}, De), { resolve: Fe, reject: Ve });
            }));
          }, Le.prototype.resolvePendingSegmentInfoRequests = function() {
            if (this.pendingSegmentInfoRequest) {
              var De = this.getNextSegmentInfo_(this.pendingSegmentInfoRequest.time);
              De ? (this.populateSegmentInfoProps(De), this.pendingSegmentInfoRequest.resolve(De), this.pendingSegmentInfoRequest = null) : this.manifestService.isLive() || this.hasNext() || this.pendingSegmentInfoRequest.reject($e.SegmentInfoError.END_OF_STREAM_REACHED);
            }
          }, Le.prototype.rejectPendingSegmentInfoRequest = function(De) {
            this.pendingSegmentInfoRequest && (this.pendingSegmentInfoRequest.reject(De), this.pendingSegmentInfoRequest = null);
          }, Le.prototype.getLiveEdgeIndex = function() {
            var De = this.getSegmentListEntries(this.currentRepresentationId);
            return De.length > 0 ? De.length - 1 : 0;
          }, Le.prototype.getIndexForOffset = function(De) {
            for (var Re, Oe = Math.abs(De), Be = this.getSegmentDuration(), Fe = this.getSegmentListEntries(this.currentRepresentationId), Ve = this.getLiveEdgeIndex(), Ke = 0, Ze = Fe.length - 1; Ze >= 0 && !((Ke += (Re = Fe[Ze].duration) !== null && Re !== void 0 ? Re : Be) >= Oe); Ze--)
              Ve--;
            return Math.max(0, Ve);
          }, Le.prototype.timeShift = function(De, Re, Oe) {
            if (this.manifestService.isLive()) {
              var Be = this.listIndex;
              this.listIndex = Oe && this.hasStartTimes() ? this.getIndexForTime(Oe) : this.getIndexForOffset(De), this.logger.debug("timeShift changes index from ".concat(Be, " to ").concat(this.listIndex, ", based on") + " offset ".concat(De, " and target time ").concat(Oe));
            }
          }, Le.prototype.hasStartTimes = function() {
            var De, Re = (De = this.getSegmentListEntries(this.currentRepresentationId)[0]) === null || De === void 0 ? void 0 : De.startTime;
            return (0, he.isNumber)(Re) && Re >= 0;
          }, Le.prototype.updateRepresentation = function(De) {
            return Promise.resolve(De);
          }, Le.prototype.isSegmentInfoLoaded = function(De) {
            if (De === void 0 && (De = this.currentRepresentationId), !De)
              return !1;
            var Re = this.getSegmentListEntries(De), Oe = this.manifestService.getRepresentationById(De);
            return !(!Re.length || !Oe);
          }, Le.prototype.rewindSegmentListIndexBy = function(De) {
            this.logger.debug("Rewinding segment list index by ".concat(De, " segments")), this.listIndex -= De, this.listIndex < 0 && (this.logger.debug("List array index is smaller than 0, probably a discontinuity. Using 0."), this.listIndex = 0);
          }, Le.prototype.rewindOneSegment = function() {
            return this.listIndex--, !(this.listIndex < 0) || (this.logger.debug("List array index is smaller than 0, probably a discontinuity. Using 0."), this.listIndex = 0, !1);
          }, Le.prototype.getCurrentPeriod = function() {
            return this.manifestService.getPeriod(this.currentRepresentationId);
          }, Le.prototype.getExpectedPresentationTime = function(De) {
            var Re = this.getCurrentPeriod().start;
            return (this.manifestService.hasSinglePeriod() ? this.getSeekableRange().start : Re) + this.getSegmentListEntries(this.currentRepresentationId).slice(0, De).reduce(function(Oe, Be) {
              return Oe + Be.duration;
            }, 0);
          }, Le.prototype.getCurrentRepresentation = function() {
            return this.manifestService.getRepresentationById(this.currentRepresentationId);
          }, Le.prototype.getSegmentList = function(De) {
            if (De)
              return this.segmentListMap[De.key()];
          }, Le.prototype.getSegmentListEntries = function(De) {
            var Re, Oe;
            return De ? this.settings.ENABLE_SEGMENT_INFO_PROVIDER_FROM_STORE && this.manifestService.isHlsManifest() ? this.getStoreSegmentInfos(De) : (Oe = (Re = this.getSegmentList(De)) === null || Re === void 0 ? void 0 : Re.entries) !== null && Oe !== void 0 ? Oe : [] : [];
          }, Le.prototype.getStoreSegmentInfos = function(De) {
            var Re, Oe = (Re = this.getSourceStateService()) === null || Re === void 0 ? void 0 : Re.getState();
            return (0, be.getSegmentInfos)(Oe, De.key());
          }, Le.prototype.findListIndexWithoutSegmentStartTimes = function(De, Re) {
            var Oe, Be;
            if (!this.adaptationSetId)
              return 0;
            for (var Fe = this.manifestService.getPeriod(this.adaptationSetId), Ve = (Oe = Fe == null ? void 0 : Fe.start) !== null && Oe !== void 0 ? Oe : 0, Ke = this.getSegmentListEntries(this.currentRepresentationId), Ze = 0, nt = Ve; nt <= Re && Ze < Ke.length; Ze++)
              nt += (Be = Ke[Ze].duration) !== null && Be !== void 0 ? Be : 0;
            return Math.max(Ze - 1, 0);
          }, Le.prototype.getIndexForTime = function(De) {
            var Re = this.getSegmentList(this.currentRepresentationId), Oe = this.getSegmentListEntries(this.currentRepresentationId);
            if (!Re || Oe.length === 0 || !(0, he.isNumber)(Re.totalDuration))
              return 0;
            var Be = this.getMinStartTime(), Fe = Math.max(Be, De), Ve = Re.totalDuration / Oe.length, Ke = (0, ye.findSegmentIndexForTime)(Oe, Fe, Ve);
            return Ke !== null ? Ke : this.findListIndexWithoutSegmentStartTimes(Re, Fe);
          }, Le.prototype.getMinStartTime = function(De) {
            De === void 0 && (De = this.currentRepresentationId);
            var Re = this.manifestService.hasSinglePeriod() ? this.getSeekableRange().start : this.manifestService.getPeriod(De).start;
            return this.manifestService.isFirstPeriod(De.periodId) && (Re += this.distanceToListStartSeconds), Re;
          }, Le.prototype.getLiveEdgeTime = function() {
            var De, Re = (De = this.manifestService) === null || De === void 0 ? void 0 : De.getLastPeriod();
            return Re ? Re.start + oe.DurationConverter.getDurationInSec(Re._duration) : 1 / 0;
          }, Le.prototype.getActualTimeShiftBufferDepth = function() {
            return this.manifestService.getTimeShiftBufferDepthSeconds();
          }, Le.prototype.getSeekableRange = function() {
            var De = { start: 0, end: 0 }, Re = this.manifestService.getTotalDuration();
            if (!this.manifestService.isLive())
              return De.start = (0, fe.getStartTimeOffset)(this.getSourceStateService().getState()), De.end = Re, De;
            var Oe = this.manifestService.getTimeShiftBufferDepthSeconds(), Be = (0, ce.toSeconds)(this.manifestService.getRequestTimestamp() - this.manifestService.getAvailabilityStartTime());
            if (De.start = Math.max(Be + Oe, 0), De.end = Math.max(Be, 0), ge.ModuleManager.has(ve.ModuleName.HLS) && this.manifestService.isHlsManifest()) {
              var Fe = ge.ModuleManager.get(ve.ModuleName.HLS).selectors, Ve = Fe.getHlsState;
              (0, Fe.getPlaylistType)(Ve(this.getSourceStateService().getState())) === "EVENT" ? (De.start = 0, De.end = Re) : De.start += this.distanceToListStartSeconds;
            }
            return De.end -= this.manifestService.getDesiredDistanceToLiveEdge(), De;
          }, Le.prototype.getPendingSegmentInfoRequest = function() {
            return this.pendingSegmentInfoRequest;
          }, Le.prototype.setPendingSegmentInfoRequest = function(De) {
            this.pendingSegmentInfoRequest = De;
          }, Le.prototype.canSwitchRepresentation = function(De) {
            var Re, Oe = this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex];
            if (!Oe)
              return !0;
            var Be = Ue(De, Oe, this.settings.LL_HLS_SEGMENT_END_TIME_MATCHING_TOLERANCE);
            if (!Ae(Oe) && Be)
              return !0;
            var Fe = this.isTargetTimeOfOngoingSeek(De);
            return !(!((Re = Oe == null ? void 0 : Oe.parts) === null || Re === void 0) && Re.length && Ie(Oe, De, Fe) !== Oe.parts[0]);
          }, Le.prototype.getLatestTimeForPossibleSwitch = function(De) {
            var Re, Oe = this.getLLHlsInfoForTime(De), Be = Oe.isLoadingCurrentSegmentsParts, Fe = Oe.currentSegment;
            return Fe && Be && (Re = Fe.startTime) !== null && Re !== void 0 ? Re : De;
          }, Le.prototype.adjustTimeToNextSegmentStart = function(De) {
            var Re = this.getLLHlsInfoForTime(De), Oe = Re.isLoadingCurrentSegmentsParts, Be = Re.currentSegment;
            return Oe && (Be != null && Be.startTime) && (Be != null && Be.duration) ? Be.startTime + Be.duration : De;
          }, Le.prototype.getLLHlsInfoForTime = function(De) {
            var Re, Oe = we(De, this.getSegmentListEntries(this.currentRepresentationId)), Be = (Re = Oe == null ? void 0 : Oe.parts) === null || Re === void 0 ? void 0 : Re[0], Fe = this.isTargetTimeOfOngoingSeek(De), Ve = !1;
            if (Be && Oe) {
              var Ke = Ie(Oe, De, Fe);
              Ve = Ke !== void 0 && Ke !== Be;
            }
            return { currentSegment: Oe, isLoadingCurrentSegmentsParts: Ve };
          }, Le.prototype.dispose = function() {
            this.settings = null, this.manifestService = null, this.adaptationSetId = null, this.currentRepresentationId = null, this.manifestService = null, this.pendingSegmentInfoRequest = null, this.segmentListMap = null;
          }, Le;
        }();
        function we(Le, De) {
          var Re, Oe, Be;
          if (De && !(De.length < 1) && (!((Re = De[0]) === null || Re === void 0) && Re.duration)) {
            var Fe = (0, ye.findSegmentIndexForTime)(De, Le, De[0].duration), Ve = Fe === null, Ke = Le < ((Be = (Oe = De[0]) === null || Oe === void 0 ? void 0 : Oe.startTime) !== null && Be !== void 0 ? Be : 1 / 0), Ze = De[De.length - 1];
            if (Ze.startTime !== void 0 && Ze.duration !== void 0) {
              var nt = Le > Ze.startTime + Ze.duration;
              if (!(Ve || Ke || nt))
                return De[Fe];
            }
          }
        }
        function Pe(Le, De) {
          for (var Re = Le[0].discontinuitySequenceNumber, Oe = 1; Oe < Le.length; Oe++) {
            var Be = Le[Oe].discontinuitySequenceNumber;
            if (Be !== Re) {
              var Fe = Te(De, Be);
              if (Fe != null)
                return { index: Oe, discontinuityStartTime: Fe };
            }
          }
          return null;
        }
        function Te(Le, De) {
          var Re = Le[String(De)];
          return Re && Re.startTime > 0 ? Re.startTime : (Re = Le[String(De - 1)]) && Re.endTime > 0 ? Re.endTime : null;
        }
        function Ee(Le, De, Re) {
          if (Le.length && Re.hasSegmentStartTimeForHlsRepresentation(De)) {
            var Oe;
            Le[0].startTime != null ? Oe = (0, se.findIndexFromEnd)(Le, function(Fe) {
              return Fe.startTime != null;
            }) + 1 : (Le[0].startTime = Re.getStartTimeForHlsSegment(De, Le[0]), Oe = 1);
            var Be = function(Fe, Ve) {
              return Ve.startTime = Fe.startTime + Fe.duration;
            };
            (0, se.forEachFromIndex)(Le, Oe, Be);
          }
        }
        function Me(Le, De) {
          var Re = { url: Le.uri, duration: Le.duration, isInitSegment: !1, internalRepresentationId: De.internalRepresentationId, isPreloadHint: !!Le.isPreloadHint, isIndependent: !!Le.independent };
          return Le.byteRange && (Re.byteRange = Le.byteRange), De.key && (Re.key = De.key), De.init && (Re.init = De.init), (0, he.isDefined)(De.mediaSequence) && (Re.mediaSequence = De.mediaSequence), (0, he.isDefined)(De.discontinuitySequenceNumber) && (Re.discontinuitySequenceNumber = De.discontinuitySequenceNumber), Re;
        }
        function Ae(Le) {
          return Le.url.endsWith(ie.PHANTOM_SEGMENT_URL);
        }
        function Ne(Le, De) {
          var Re = De.duration - Le.duration;
          return Ce(De, Le, ["url", "mediaURL", "duration", "parts", "init", "key", "discontinuitySequenceNumber", "isDiscontinuityStart"]), !Le.url.endsWith(ie.PHANTOM_SEGMENT_URL) && (Le.url = (0, le.forceReallocation)(Le.url)), Re;
        }
        function Ce(Le, De, Re) {
          Re.forEach(function(Oe) {
            return De[Oe] = Le[Oe];
          });
        }
        function Ie(Le, De, Re) {
          var Oe, Be = (Oe = Le.parts) === null || Oe === void 0 ? void 0 : Oe.every(ye.isSegmentTiming);
          if (Le.parts && Be) {
            var Fe = Le.parts, Ve = Fe.reduce(function(Ze, nt) {
              return Ze + nt.duration;
            }, 0) / Fe.length, Ke = (0, ye.findSegmentIndexForTime)(Fe, De, Ve);
            if (Ke != null)
              return Re ? Le.parts[0] : (Ke = xe(De, Ke, Fe), Le.parts[Ke]);
          }
        }
        function xe(Le, De, Re) {
          var Oe = Re[De], Be = Oe.startTime + Oe.duration;
          return Math.abs(Le - Oe.startTime) <= Math.abs(Le - Be) ? De : De + 1;
        }
        function Ue(Le, De, Re) {
          return De.startTime !== void 0 && De.duration !== void 0 && Math.abs(Le - (De.startTime + De.duration)) < Re;
        }
        function ke(Le) {
          var De, Re, Oe = 24, Be = Le.totalDuration / ((Re = (De = Le.entries) === null || De === void 0 ? void 0 : De.length) !== null && Re !== void 0 ? Re : 1);
          return Math.ceil(Oe / Be);
        }
        ie.SegmentListMPDHandler = Se;
      }, 66864: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ze) {
            for (var nt, Qe = 1, qe = arguments.length; Qe < qe; Qe++)
              for (var ze in nt = arguments[Qe])
                Object.prototype.hasOwnProperty.call(nt, ze) && (Ze[ze] = nt[ze]);
            return Ze;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentLoader = ie.State = ie.SegmentLoadingErrorReason = void 0;
        var ue, _e, fe = ne(52442), le = ne(25550), se = ne(28764), oe = ne(18665), ce = ne(62510), he = ne(90637), ge = ne(6311), ve = ne(23234), me = ne(36564), be = ne(67345), pe = ne(76650), $e = ne(28819), ye = ne(8272), Se = ne(56093), we = ne(79814), Pe = ne(331), Te = ne(70016), Ee = ne(91520), Me = ne(16368), Ae = ne(41108), Ne = ne(73543), Ce = ne(48727), Ie = ne(82311), xe = ne(25040), Ue = ne(40392), ke = ne(86674), Le = ne(36225), De = ne(5206), Re = ne(4141), Oe = ne(72207);
        (function(Ze) {
          Ze.CANCEL = "CANCEL", Ze.ERROR_LOADING = "ERROR_LOADING", Ze.ERROR_DECRYPTING = "ERROR_DECRYPTING", Ze.BUSY = "BUSY", Ze.UNKNOWN = "UNKNOWN", Ze.TIMEOUT = "TIMEOUT", Ze.ABR_TIMEOUT = "ABR_TIMEOUT";
        })(ue || (ie.SegmentLoadingErrorReason = ue = {})), function(Ze) {
          Ze[Ze.IDLE = 1] = "IDLE", Ze[Ze.LOADING = 2] = "LOADING", Ze[Ze.CANCELLING = 3] = "CANCELLING", Ze[Ze.TERMINATED = 4] = "TERMINATED", Ze[Ze.TIMEOUT = 5] = "TIMEOUT", Ze[Ze.ABR_TIMEOUT = 6] = "ABR_TIMEOUT";
        }(_e || (ie.State = _e = {}));
        var Be = 408, Fe = 0.1, Ve = function() {
          function Ze(nt, Qe, qe, ze) {
            ze === void 0 && (ze = !1);
            var je = this;
            if (this.context = nt, this.cancelLoading = function(ut) {
              var yt, $t, ft, pt, lt, Je, Xe;
              if (ut === void 0 && (ut = _e.CANCELLING), clearTimeout(je.loadTimeoutID), clearInterval(je.progressCheckIntervalId), je.loadTimeoutID = null, je.isLoading()) {
                var We = je.currentSegmentInfoMap[je.loadingUrl];
                if (delete je.currentSegmentInfoMap[je.loadingUrl], je.state = ut, je.loader.cancel(), je.currentRequestProgress !== void 0) {
                  var Ge = ($t = (yt = je.currentRequestProgress.responseTiming) === null || yt === void 0 ? void 0 : yt.headersReceivedTimestamp) !== null && $t !== void 0 ? $t : -1, at = (pt = (ft = je.currentRequestProgress.responseTiming) === null || ft === void 0 ? void 0 : ft.openedTimestamp) !== null && pt !== void 0 ? pt : -1, dt = (lt = je.currentRequestProgress.elapsedTime) !== null && lt !== void 0 ? lt : -1, ot = Ge - at;
                  dt >= 0 && ot >= 0 && dt > ot && je.context.store.dispatch((0, pe.addMetricsValue)(je.mimeType, ye.MetricType.DownloadInformation, { bytes: je.currentRequestProgress.loadedBytes, time: dt, timeToFirstByte: ot })), !((Je = je.currentRequestProgress) === null || Je === void 0) && Je.chunks && We && je.dispatchCancelledChunkedDownloadMetrics(We), je.canceledSegmentRequestFinishedEvent = { success: !1, httpStatus: Be, url: je.loadingUrl, downloadTime: dt, size: je.currentRequestProgress.loadedBytes, duration: (Xe = je.segmentDuration) !== null && Xe !== void 0 ? Xe : 0, isInit: je.isInit, mimeType: je.mimeType, uid: void 0, timeToFirstByte: (0, ge.hasLoadedData)(je.currentRequestProgress) ? ot : -1 };
                }
                je.currentRequestProgress = void 0;
              }
            }, this.checkLoadingProgress = function() {
              var ut, yt, $t, ft = ($t = (yt = (ut = je.currentRequestProgress) === null || ut === void 0 ? void 0 : ut.responseTiming) === null || yt === void 0 ? void 0 : yt.sendTimestamp) !== null && $t !== void 0 ? $t : -1;
              je.currentRequestProgress === void 0 || ft < 0 || je.onProgress(ae(ae({}, je.currentRequestProgress), { elapsedTime: ve.TimingUtil.getHiResTimestamp() - ft }));
            }, this.onProgress = function(ut) {
              var yt, $t = 0.5, ft = (yt = ut.elapsedTime) !== null && yt !== void 0 ? yt : -1, pt = je.currentSegmentInfoMap[je.loadingUrl];
              je.currentRequestProgress = ae(ae({}, ut), { segmentDuration: je.segmentDuration, url: je.loadingUrl, representationBitrate: pt.bitrate }), je.isInit || ft <= $t || je.state !== _e.LOADING || je.onDownloadShouldBeCancelledCallback(je.currentRequestProgress, pt.internalRepresentationId) && je.cancelLoading(_e.ABR_TIMEOUT);
            }, this.onSuccess = function(ut, yt, $t) {
              var ft, pt, lt, Je, Xe, We, Ge = je.context.store.getState(), at = Ge ? (0, $e.getMetricsState)(Ge) : void 0;
              if (je.context.logger.debug("Downloaded ".concat(je.mimeType, " ").concat(je.isInit ? "init" : "data", " segment in: ").concat((ft = ut.elapsedTime) === null || ft === void 0 ? void 0 : ft.toFixed(2), ", TTFB: ").concat((pt = ut.timeToFirstByte) === null || pt === void 0 ? void 0 : pt.toFixed(2), ", quality: ").concat((Je = (lt = je.currentSegmentInfoMap[je.loadingUrl]) === null || lt === void 0 ? void 0 : lt.representationId) !== null && Je !== void 0 ? Je : "")), !je.isInit && at && je.mimeType in at && (je.context.store.dispatch((0, pe.addMetricsValue)(je.mimeType, ye.MetricType.DownloadTime, yt)), je.context.store.dispatch((0, pe.addMetricsValue)(je.mimeType, ye.MetricType.DownloadSuccess, !0)), (0, me.isDownloadTimeInformationValid)(ut) && je.context.store.dispatch((0, pe.addMetricsValue)(je.mimeType, ye.MetricType.DownloadInformation, { bytes: ut.length, time: ut.elapsedTime, timeToFirstByte: ut.timeToFirstByte })), (Xe = je.currentRequestProgress) === null || Xe === void 0 ? void 0 : Xe.chunks)) {
                je.logger.debug("[SegmentLoader] ", je.currentRequestProgress.chunks);
                var dt = (0, ke.calculateDownloadRates)(je.currentRequestProgress.chunks), ot = (0, ke.calcAverage)((0, ke.filterValuesExceedingAverageByMargin)(dt)), et = je.currentRequestProgress.loadedBytes, st = je.currentSegmentInfoMap[je.loadingUrl], mt = st.duration, St = mt !== void 0 ? (0, Ue.bytesToBits)(et) / mt : void 0, bt = st.bitrate;
                je.logger.debug("[SegmentLoader] DL rate (AVG-based filter): ".concat((0, ke.bpsToMbps)(ot), ", segmentBitrate: ").concat(St)), je.context.store.dispatch((0, pe.addMetricsValue)(je.mimeType, ye.MetricType.ChunkedDownloadInformation, { downloadRate: ot, segmentBitrate: St, representationBitrate: bt }));
              }
              clearTimeout(je.loadTimeoutID), clearInterval(je.progressCheckIntervalId), je.loadTimeoutID = void 0;
              var it = { success: !0, httpStatus: ut.status, url: ut.url, downloadTime: ut.elapsedTime, size: ut.length, duration: je.segmentDuration, isInit: je.isInit, mimeType: je.mimeType, uid: je.loadingUid, timeToFirstByte: (We = ut.timeToFirstByte) !== null && We !== void 0 ? We : -1 };
              je.eventHandler.dispatchEvent(ce.PlayerEvent.SegmentRequestFinished, it);
            }, this.logger = nt.logger, this.eventHandler = nt.eventHandler, this.customLoaderArgs = nt.config.tweaks.segmentLoaderArgs || null, this.customLoader = nt.config.tweaks.segmentLoader || null, this.segmentDuration = 1, this.state = _e.IDLE, this.mimeType = Qe, this.keyLoader = new De.KeyLoader(this.context), this.onDownloadShouldBeCancelledCallback = qe, this.currentLoadPromise = null, this.currentSegmentInfoMap = {}, this.canceledSegmentRequestFinishedEvent = null, this.isPrefetchingLoader = ze, Ee.ModuleManager.has(Me.ModuleName.ContainerMP4)) {
              var tt = Ee.ModuleManager.get(Me.ModuleName.ContainerMP4);
              this.cmafChunkParser = new tt.CmafChunkParser(this.context);
            }
            this.setupContentLoader();
          }
          return Ze.prototype.dispatchCancelledChunkedDownloadMetrics = function(nt) {
            var Qe, qe, ze, je, tt, ut, yt, $t, ft = ((ze = (qe = (Qe = this.currentRequestProgress) === null || Qe === void 0 ? void 0 : Qe.responseTiming) === null || qe === void 0 ? void 0 : qe.progressTimestamp) !== null && ze !== void 0 ? ze : ve.TimingUtil.getHiResTimestamp()) - ((ut = (tt = (je = this.currentRequestProgress) === null || je === void 0 ? void 0 : je.responseTiming) === null || tt === void 0 ? void 0 : tt.headersReceivedTimestamp) !== null && ut !== void 0 ? ut : 0), pt = (0, Ue.bytesToBits)(($t = (yt = this.currentRequestProgress) === null || yt === void 0 ? void 0 : yt.loadedBytes) !== null && $t !== void 0 ? $t : 0) / ft, lt = nt.duration === void 0 ? 1 : Math.max(1 - ft / nt.duration, Fe);
            this.context.store.dispatch((0, pe.addMetricsValue)(this.mimeType, ye.MetricType.ChunkedDownloadInformation, { downloadRate: pt * lt, segmentBitrate: void 0, representationBitrate: nt.bitrate }));
          }, Ze.prototype.isLoading = function() {
            var nt = !!(this.keyLoader && this.keyLoader.isLoading());
            return this.state === _e.LOADING || this.state === _e.CANCELLING || this.loader && this.loader.isLoading() || nt;
          }, Ze.prototype.isRetrying = function() {
            return this.loader && this.loader.isRetrying();
          }, Ze.prototype.load = function(nt) {
            var Qe = this;
            if (this.isLoading())
              return this.logger.debug("Error loading segment, loader is busy!" + this.loadingUrl), Promise.reject({ reason: ue.BUSY });
            this.loader && this.loader.dispose();
            var qe = this.defaultLoaderArgs;
            return nt.isPreloadHint && (qe = ae(ae({}, qe), { maxRetries: 0 })), this.canceledSegmentRequestFinishedEvent = null, this.currentRequestProgress = void 0, this.loader = (0, Re.getLoader)(this.context, qe), this.state = _e.LOADING, this.loadingUrl = nt.url, this.loadingUid = btoa(this.loadingUrl), this.currentSegmentInfoMap[this.loadingUrl] = nt, this.encryptionInfo = nt.key, this.isInit = nt.isInitSegment, this.segmentDuration = nt.duration, this.currentLoadPromise = this.maybeLoadEncryptionKey(nt).then(function() {
              return Qe.loadSegment(nt);
            }).catch(function(ze) {
              throw Qe.state = _e.IDLE, Qe.currentLoadPromise = null, ze;
            }), this.currentLoadPromise;
          }, Ze.prototype.maybeLoadEncryptionKey = function(nt) {
            var Qe, qe = this, ze = !!(!((Qe = this.encryptionInfo) === null || Qe === void 0) && Qe.buffer);
            if (!this.encryptionInfo || ze)
              return Promise.resolve();
            switch (this.encryptionInfo.method) {
              case fe.HlsEncryptionMethod.AES_128:
                return this.getKey(nt).then(function(je) {
                  je && (qe.encryptionInfo.buffer = je);
                });
              case fe.HlsEncryptionMethod.SAMPLE_AES:
                return this.eventHandler.fireError(new se.PlayerError(le.ErrorCode.SOURCE_ENCRYPTION_METHOD_NOT_SUPPORTED, { "encryption-method": this.encryptionInfo.method, supported: fe.HlsEncryptionMethod.AES_128 }, "The ".concat(fe.HlsEncryptionMethod.SAMPLE_AES, " encryption method is not supported."))), Promise.reject({ reason: ue.ERROR_DECRYPTING });
              default:
                return Promise.reject({ reason: ue.ERROR_DECRYPTING });
            }
          }, Ze.prototype.getCurrentLoadPromise = function() {
            return this.currentLoadPromise;
          }, Ze.prototype.getSourceStore = function() {
            var nt;
            return (nt = this.context.serviceManager) === null || nt === void 0 ? void 0 : nt.get(oe.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
          }, Ze.prototype.getKey = function(nt) {
            var Qe, qe = (Qe = nt.key) === null || Qe === void 0 ? void 0 : Qe.uri, ze = this.getSourceStore();
            if (!ze || !qe)
              return Promise.reject(new Error("Source store not available."));
            var je = ze.getState(), tt = (0, xe.getEncryptionKey)(je, qe);
            return tt != null && tt.uri ? tt.key ? Promise.resolve(Se.FormatHelper.hexToBytes(tt.key).buffer) : (0, Le.waitForKeyToBeLoaded)(ze, qe) : (0, Le.addEncryptionKeyToStore)(qe, this.keyLoader, ze);
          }, Ze.prototype.getPreFetchedSegment = function(nt, Qe) {
            var qe;
            return this.isPrefetchingLoader || !(!((qe = this.context.adRestorationOptimizationService) === null || qe === void 0) && qe.hasPrefetchedSegment(Qe)) ? null : (this.currentSegmentInfoMap[nt] && (this.currentSegmentInfoMap[nt].wasPrefetched = !0), this.context.adRestorationOptimizationService.getPrefetchedSegment(Qe, this.onDownloadShouldBeCancelledCallback));
          }, Ze.prototype.setupLoadingProgressCheckInterval = function() {
            clearInterval(this.progressCheckIntervalId);
            var nt = (0, Pe.toMilliSeconds)(this.context.settings.SEGMENT_LOADING_PROGRESS_CHECK_INTERVAL);
            nt <= 0 || (this.progressCheckIntervalId = window.setInterval(this.checkLoadingProgress, nt));
          }, Ze.prototype.loadSegment = function(nt) {
            var Qe, qe = this, ze = {};
            nt.byteRange && (ze.Range = ["bytes=", nt.byteRange.start, "-", nt.byteRange.end].join(""));
            var je = this.context.sourceContext.source && this.context.sourceContext.source.hasOwnProperty("options") && !!this.context.sourceContext.source.options.withCredentials;
            clearTimeout(this.loadTimeoutID), clearInterval(this.progressCheckIntervalId), this.loadTimeoutID = void 0, this.isInit || nt.preventDownloadCanceling || (this.loadTimeoutID = setTimeout(function() {
              return qe.cancelLoading(_e.TIMEOUT);
            }, (0, Pe.toMilliSeconds)(this.context.settings.XHR_TIMEOUT - 1)));
            var tt = this.getPreFetchedSegment(this.loadingUrl, nt);
            if (tt)
              return this.context.logger.debug("return prefetched segment for", this.loadingUrl), tt.then(function(lt) {
                var Je = new Oe.Stream();
                return qe.loadingFinished(), Je.add(lt), lt.getSegmentInfo().wasPrefetched = !0, Je.end(), Je;
              }).catch(function(lt) {
                throw lt;
              });
            var ut = (Qe = this.getSourceStore()) === null || Qe === void 0 ? void 0 : Qe.getState(), yt = ut && (0, Ie.getContainerFormat)(ut, we.MimeTypeHelper.getMediaType(this.mimeType)), $t = (yt == null ? void 0 : yt.source) === Ne.ContainerFormat.MP4, ft = !!this.encryptionInfo || !!this.decrypter, pt = this.context.settings.CHUNKED_CMAF_STREAMING && this.cmafChunkParser && $t && !nt.isInitSegment && !ft;
            return this.setupLoadingProgressCheckInterval(), this.loader.load(this.loadingUrl, be.HttpRequestMethod.GET, be.HttpResponseType.ARRAYBUFFER, null, ze, je, this.mimeType, pt).then(function(lt) {
              return qe.handleResponse(lt.body);
            }).catch(function(lt) {
              throw qe.createLoadingError(lt);
            });
          }, Ze.prototype.createLoadingError = function(nt) {
            var Qe, qe;
            return [_e.CANCELLING, _e.TIMEOUT, _e.ABR_TIMEOUT].includes(this.state) ? (this.logger.debug("Cancelled ".concat(this.mimeType, " download [").concat(this.loadingUrl, "]")), this.canceledSegmentRequestFinishedEvent && ((Qe = this.eventHandler) === null || Qe === void 0 || Qe.dispatchEvent(ce.PlayerEvent.SegmentRequestFinished, this.canceledSegmentRequestFinishedEvent)), qe = { reason: Ke(this.state) }) : this.state === _e.LOADING && (qe = { reason: ue.ERROR_LOADING, info: { response: nt, isInit: this.isInit } }), qe;
          }, Ze.prototype.getAllLoadingPeriodIds = function() {
            var nt = this;
            return Object.keys(this.currentSegmentInfoMap).map(function(Qe) {
              var qe;
              return (qe = nt.currentSegmentInfoMap[Qe]) === null || qe === void 0 ? void 0 : qe.periodId;
            }).filter(Te.isDefined);
          }, Ze.prototype.getCurrentLoadingSegmentInfo = function() {
            return this.isLoading() && this.loadingUrl && this.currentSegmentInfoMap[this.loadingUrl] ? this.currentSegmentInfoMap[this.loadingUrl] : null;
          }, Ze.prototype.attachDecrypter = function(nt) {
            this.decrypter = this.decrypter || nt;
          }, Ze.prototype.attachClearKeyLoader = function(nt) {
            this.clearKeyLoader = this.clearKeyLoader || nt;
          }, Ze.prototype.terminate = function() {
            var nt, Qe = this;
            this.isLoading() ? ((nt = this.currentLoadPromise) === null || nt === void 0 || nt.catch(function() {
              Qe.state = _e.TERMINATED;
            }), this.cancelLoading()) : this.state = _e.TERMINATED;
          }, Ze.prototype.createSegment = function(nt) {
            var Qe, qe;
            qe = this.isInit ? Ce.SegmentInitType.INIT : Ce.SegmentInitType.NONE;
            var ze = this.currentSegmentInfoMap[this.loadingUrl], je = new Ce.Segment(nt, this.mimeType, (Qe = ze.codecs) !== null && Qe !== void 0 ? Qe : null, ze.periodId, this.segmentDuration, qe, !0, nt.byteLength, ze.internalRepresentationId, ze.startTime);
            return je.setUrl(this.loadingUrl), je.setSegmentInfo(ze), je;
          }, Ze.prototype.maybeDecryptResponseData = function(nt, Qe) {
            return this.encryptionInfo && this.encryptionInfo.method === fe.HlsEncryptionMethod.AES_128 && !Qe ? this.decryptAes128(nt) : this.decrypter ? this.decryptClearKey(nt) : Promise.resolve(nt);
          }, Ze.prototype.decryptAes128 = function(nt) {
            return Ee.ModuleManager.has(Me.ModuleName.Crypto) ? (this.logger.debug("Decrypting AES-128-encryped segment " + this.loadingUrl + ", KEY: 0x" + Se.FormatHelper.bytesToHex(this.encryptionInfo.buffer) + ", IV: 0x" + Se.FormatHelper.bytesToHex(this.encryptionInfo.iv)), new (Ee.ModuleManager.get(Me.ModuleName.Crypto)).CryptoApi(this.context, "AES-CBC", this.encryptionInfo.buffer, this.encryptionInfo.iv, this.mimeType).decrypt(nt).then(function(Qe) {
              if (!Qe || Qe.byteLength === 0)
                throw { reason: ue.ERROR_DECRYPTING };
              return Qe;
            }).catch(function() {
              throw { reason: ue.ERROR_DECRYPTING };
            })) : (this.context.eventHandler.fireError(new Ae.PlayerModuleMissingError(Me.ModuleName.Crypto)), Promise.reject({ reason: ue.ERROR_DECRYPTING }));
          }, Ze.prototype.decryptClearKey = function(nt) {
            var Qe = this, qe = Promise.resolve(nt);
            if (this.isInit)
              qe = this.decrypter.parseInitSegment(nt), this.clearKeyLoader && (qe = qe.then(function(je) {
                return Qe.clearKeyLoader.load(Qe.decrypter.getKeyIds()).then(function(tt) {
                  return Qe.decrypter.addKeys(tt), Promise.resolve(je);
                });
              }));
            else if (this.decrypter.isEncrypted()) {
              var ze = Se.FormatHelper.bytesToHex(this.decrypter.getKey());
              this.logger.debug("Decrypting SAMPLE-AES-encrypted segment ".concat(this.loadingUrl, ", KEY: 0x").concat(ze)), qe = this.decrypter.decryptDataSegment(nt);
            }
            return qe.catch(function() {
              throw { reason: ue.ERROR_DECRYPTING };
            });
          }, Ze.prototype.handleResponse = function(nt, Qe) {
            var qe = this;
            if (Qe === void 0 && (Qe = !1), nt instanceof ArrayBuffer) {
              this.segmentStream = new Oe.Stream();
              var ze = Date.now();
              this.maybeDecryptResponseData(nt, Qe).then(function(je) {
                var tt;
                qe.state === _e.TERMINATED || qe.state === _e.CANCELLING ? qe.segmentStream.abort(ue.CANCEL) : (qe.segmentStream.add(qe.createSegment(je)), qe.segmentStream.end());
                var ut = qe.currentSegmentInfoMap[qe.loadingUrl];
                if (nt !== je && ut) {
                  var yt = (0, Pe.toSeconds)(Date.now() - ze), $t = ut.internalRepresentationId, ft = { time: yt, representationId: $t };
                  qe.context.store.dispatch((0, pe.addMetricsValue)(qe.mimeType, ye.MetricType.DecryptionTime, ft)), qe.context.logger.debug("Decrypted ".concat(qe.mimeType, " segment in: ").concat(yt == null ? void 0 : yt.toFixed(2), ", quality: ").concat((tt = $t == null ? void 0 : $t.representationId) !== null && tt !== void 0 ? tt : ""));
                }
              }).catch(function() {
                return qe.segmentStream.abort(ue.ERROR_DECRYPTING);
              }).finally(function() {
                return qe.loadingFinished();
              });
            } else
              this.segmentStream = nt.transform(function(je) {
                return qe.cmafChunkParser.appendData(je), qe.cmafChunkParser.getCompleteChunks();
              }, function() {
              }, function(je) {
                return je.message;
              }).transform(function(je) {
                return qe.createSegment(je);
              }, function() {
                return qe.loadingFinished();
              }, function(je) {
                qe.logger.debug("Error handling fetch segment request", je);
                var tt = ue.ERROR_LOADING;
                return je.message === he.RequestError.Canceled && (tt = Ke(qe.state)), qe.loadingFinished(), tt;
              });
            return Promise.resolve(this.segmentStream);
          }, Ze.prototype.loadingFinished = function() {
            this.state = _e.IDLE, this.currentLoadPromise = null, this.cmafChunkParser && this.cmafChunkParser.reset(), this.currentSegmentInfoMap && delete this.currentSegmentInfoMap[this.loadingUrl];
          }, Ze.prototype.dispose = function() {
            this.terminate(), clearTimeout(this.loadTimeoutID), clearInterval(this.progressCheckIntervalId), this.loader && this.loader.dispose && this.loader.dispose(), this.keyLoader && this.keyLoader.dispose(), Ee.ModuleManager.has(Me.ModuleName.Crypto) && Ee.ModuleManager.get(Me.ModuleName.Crypto).WebWorkerCrypto.dispose(), this.loader = null, this.customLoader = null, this.customLoaderArgs = null, this.keyLoader = null, this.loadingUrl = null, this.loadingUid = null, this.encryptionInfo = null, this.currentSegmentInfoMap = {}, this.currentRequestProgress = void 0, this.decrypter = null, this.eventHandler = null;
          }, Ze.prototype.setupContentLoader = function() {
            var nt = this;
            this.defaultLoaderArgs = ae(ae({}, (0, Re.getLoaderConfig)(this.context, this.mimeType)), { onSuccess: this.onSuccess, onProgress: this.onProgress, onFailure: function(Qe, qe) {
              var ze, je;
              nt.context.store.dispatch((0, pe.addMetricsValue)(nt.mimeType, ye.MetricType.DownloadSuccess, !1)), (qe == null ? void 0 : qe.name) === he.RequestError.TimedOut && (nt.state = _e.TIMEOUT), clearTimeout(nt.loadTimeoutID), clearInterval(nt.progressCheckIntervalId), nt.loadTimeoutID = void 0, delete nt.currentSegmentInfoMap[nt.loadingUrl], nt.eventHandler.dispatchEvent(ce.PlayerEvent.SegmentRequestFinished, { success: !1, httpStatus: Qe && Qe.status || 0, url: (ze = Qe == null ? void 0 : Qe.url) !== null && ze !== void 0 ? ze : nt.loadingUrl, downloadTime: -1, size: -1, duration: nt.segmentDuration, isInit: nt.isInit, mimeType: nt.mimeType, uid: void 0, timeToFirstByte: (je = Qe == null ? void 0 : Qe.timeToFirstByte) !== null && je !== void 0 ? je : -1 });
            } });
          }, Ze;
        }();
        function Ke(Ze) {
          switch (Ze) {
            case _e.ABR_TIMEOUT:
              return ue.ABR_TIMEOUT;
            case _e.TIMEOUT:
              return ue.TIMEOUT;
            default:
              return ue.CANCEL;
          }
        }
        ie.SegmentLoader = Ve;
      }, 46678: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentLoaderPool = void 0, ie.getLoaderPoolSize = ye;
        var ae = ne(76650), ue = ne(28819), _e = ne(8272), fe = ne(27279), le = ne(27177), se = ne(79814), oe = ne(70016), ce = ne(91520), he = ne(16368), ge = ne(59839), ve = ne(22645), me = ne(28915), be = ne(66864), pe = 1, $e = function() {
          function Te(Ee, Me) {
            this.context = Ee, this.mimeType = Me.mimeType, this.loaders = [], this.shouldDownloadBeCancelledCallback = Me.shouldDownloadBeCancelledCallback, this.addLoaders(ye(this.mimeType, Ee.settings.SEGMENT_LOADER_POOL_SIZE)), this.attachDecrypter();
          }
          return Te.prototype.addLoaders = function(Ee) {
            for (var Me = 0; Me < Ee; Me++)
              this.loaders.push(new be.SegmentLoader(this.context, this.mimeType, this.shouldDownloadBeCancelledCallback));
          }, Te.prototype.getDecrypter = function(Ee) {
            if (this.context.segmentPrefetchingService && this.context.segmentPrefetchingService.hasMp4Decrypter(this.mimeType))
              return this.context.segmentPrefetchingService.getDecrypter(this.mimeType);
            var Me = ce.ModuleManager.get(he.ModuleName.Crypto).createDecrypter, Ae = Pe(Ee.drm.clearkey) ? Ee.drm.clearkey : [];
            return Me(this.context, this.mimeType, Ae);
          }, Te.prototype.getClearKeyLoader = function(Ee) {
            return new (ce.ModuleManager.get(he.ModuleName.Crypto)).ClearKeyLoader(this.context, Ee);
          }, Te.prototype.attachDecrypter = function() {
            var Ee = this.context.sourceContext.source, Me = Se(Ee) ? this.getDecrypter(Ee) : null;
            if (Me && (this.loaders.forEach(function(Ne) {
              return Ne.attachDecrypter(Me);
            }), this.context.segmentPrefetchingService && this.context.segmentPrefetchingService.setDecrypter(Me, this.mimeType), we(Ee.drm.clearkey))) {
              var Ae = this.getClearKeyLoader(Ee.drm.clearkey);
              this.loaders.forEach(function(Ne) {
                return Ne.attachClearKeyLoader(Ae);
              });
            }
          }, Te.prototype.isLoading = function() {
            return this.loaders.some(function(Ee) {
              return Ee.isLoading();
            });
          }, Te.prototype.isFreeLoaderAvailable = function() {
            return this.loaders.some(function(Ee) {
              return !Ee.isLoading();
            });
          }, Te.prototype.updateRequestedRepresentationMetric = function(Ee) {
            var Me = (0, ue.getMetricsHistoryFromInstanceState)(this.context.store.getState(), "default", _e.MetricType.RequestedRepresentations);
            (Me ? Me.map(function(Ae) {
              return Ae.value;
            }) : []).includes(Ee) || this.context.store.dispatch((0, ae.addMetricsValue)("default", _e.MetricType.RequestedRepresentations, Ee));
          }, Te.prototype.load = function(Ee) {
            var Me = this.loaders.find(function(Ie) {
              return !Ie.isLoading();
            });
            if (!Me)
              return this.context.logger.debug("Failed to load segment. No free loader!", Ee.url), Promise.reject(null);
            this.updateRequestedRepresentationMetric(Ee.internalRepresentationId), this.context.logger.debug("[SegmentLoader ".concat(this.loaders.indexOf(Me), "][").concat(Ee.mimeType, "][").concat(Ee.representationId, "] Loading ").concat(Ee.startTime, " ").concat(Ee.url));
            var Ae = (0, me.getSegmentInfoTimeRange)(Ee), Ne = (0, ve.getTrackIdentifier)(Ee), Ce = (0, fe.getSourceStore)(this.context);
            return Ae && (Ce == null || Ce.dispatch((0, ge.addStreamTimeRange)(Ne, Ae, ve.StreamTimeRangeType.Loading))), Me.load(Ee).catch(function(Ie) {
              throw Ae && (Ce == null || Ce.dispatch((0, ge.removeStreamTimeRange)(Ne, Ae, ve.StreamTimeRangeType.Loading))), Ie;
            });
          }, Te.prototype.cancelLoading = function() {
            var Ee = this;
            return Promise.all(this.loaders.map(function(Me) {
              return Me.isLoading() && Me.cancelLoading(), Promise.resolve(Me.getCurrentLoadPromise());
            })).then(function() {
            }).catch(function(Me) {
              (Me == null ? void 0 : Me.reason) !== be.SegmentLoadingErrorReason.CANCEL && (0, le.isContextAvailable)(Ee.context) && Ee.context.logger.debug("Error while loading a segment ", Me);
            });
          }, Te.prototype.getLoadingPeriodIds = function() {
            return this.loaders.flatMap(function(Ee) {
              return Ee.getAllLoadingPeriodIds();
            });
          }, Te.prototype.dispose = function() {
            this.cancelLoading(), this.loaders.forEach(function(Ee) {
              return Ee.dispose();
            }), this.loaders = null;
          }, Te;
        }();
        function ye(Te, Ee) {
          var Me = se.MimeTypeHelper.extractContentType(Te);
          return Ee && (0, oe.isNumber)(Ee[Me]) ? Math.max(pe, Ee[Me]) : pe;
        }
        function Se(Te) {
          var Ee, Me;
          return Pe((Ee = Te == null ? void 0 : Te.drm) === null || Ee === void 0 ? void 0 : Ee.clearkey) || we((Me = Te == null ? void 0 : Te.drm) === null || Me === void 0 ? void 0 : Me.clearkey);
        }
        function we(Te) {
          return !!(Te != null && Te.LA_URL);
        }
        function Pe(Te) {
          return (Te == null ? void 0 : Te.length) > 0;
        }
        ie.SegmentLoaderPool = $e;
      }, 60704: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentPreProcessor = void 0;
        var ae = ne(18665), ue = ne(62510), _e = ne(76650), fe = ne(8272), le = ne(27279), se = ne(79814), oe = ne(34586), ce = ne(91520), he = ne(16368), ge = ne(43752), ve = ne(59839), me = ne(22645), be = ne(93109), pe = ne(74830), $e = ne(41661), ye = ne(9378), Se = ne(28915), we = ne(67550), Pe = "SegmentPreProcessor", Te = function() {
          function Ie(xe, Ue, ke, Le, De, Re, Oe) {
            this.context = xe, this.mimeType = Ue, this.onDataAvailableCallback = ke, this.hls = Le, this.segmentUnavailabilityHandler = De, this.timestampOffsetService = Re, this.segmentParser = Oe, this.isKeyframeRecoveryOngoing = !1, this.downloadRepresentationId = null;
            var Be = xe.sourceContext.sourceIdentifier;
            this.manifestService = this.context.serviceManager.get(ae.ServiceName.ManifestService, Be);
          }
          return Object.defineProperty(Ie.prototype, "logger", { get: function() {
            return this.context.logger;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(Ie.prototype, "eventHandler", { get: function() {
            return this.context.eventHandler;
          }, enumerable: !1, configurable: !0 }), Ie.prototype.setHlsTimelineTracker = function(xe) {
            this.hlsTimelineTracker = xe;
          }, Ie.prototype.setMpdHandler = function(xe) {
            this.mpdHandler = xe;
          }, Ie.prototype.onMuxedSegmentAvailable = function(xe, Ue, ke, Le) {
            var De = this, Re = Ue.find(function(Ke) {
              return Ee(Ke, De.hls);
            });
            if (Re) {
              var Oe = !Re.getRepresentationId().equals(this.downloadRepresentationId), Be = this.maybeHandleTimelineGap(Re, ke, Oe), Fe = Be.shouldMakeSegmentAvailable, Ve = Be.shouldCacheSegment;
              Fe ? Ue.forEach(function(Ke) {
                var Ze = xe.metadata[xe.transmuxedSegments.indexOf(Ke)];
                De.onSegmentAvailable(Ke, Ze, ke, Le) || Le.cacheSegment(xe.originalSegment);
              }) : (Ve && Le.cacheSegment(xe.originalSegment), Ce(xe.originalSegment, this.context));
            }
          }, Ie.prototype.onSegmentAvailable = function(xe, Ue, ke, Le) {
            var De, Re, Oe;
            return this.logger.debug("onSegmentAvailable ".concat(xe.getMimeType()).concat(xe.isInit() ? " init" : "", " segment [").concat(xe.getUrl(), "]")), this.segmentUnavailabilityHandler.downloadSuccess(xe.isInit()), (Re = (De = this.mpdHandler).generateSmoothInitSegment) === null || Re === void 0 || Re.call(De, xe, this.segmentParser), this.hls.isTransmuxingRequired || oe.TextSegmentAnalyzer.isPlainTextPayload(xe.getData()) || (Oe = this.segmentParser) === null || Oe === void 0 || Oe.parseSegment(xe), !!xe.isInit() || this.onDataSegmentAvailable(xe, Ue, ke, Le);
          }, Ie.prototype.onDataSegmentAvailable = function(xe, Ue, ke, Le) {
            var De, Re, Oe, Be = this, Fe = !xe.getRepresentationId().equals(this.downloadRepresentationId);
            Ee(xe, this.hls) && Fe && this.updateDownloadedRepresentation(xe, this.downloadRepresentationId);
            var Ve = this.hls.isTransmuxingRequired, Ke = !0;
            if (this.manifestService.isHlsManifest()) {
              if (this.maybeUpdateLlHlsSegmentInfo(xe), !Ve && !oe.TextSegmentAnalyzer.isPlainTextPayload(xe.getData())) {
                (isNaN(this.mpdHandler.getTimestampOffset()) || this.mpdHandler.getTimestampOffset() === 0) && (0, pe.initializeHlsSegmentStartTimes)(xe, this.context, this.mpdHandler), this.timestampOffsetService.maybeAdjustTimestampOffsetAtDiscontinuityChange(xe, this.mpdHandler) && ((De = this.segmentParser) === null || De === void 0 || De.parseSegment(xe));
                var Ze = this.maybeHandleTimelineGap(xe, ke, Fe), nt = Ze.shouldMakeSegmentAvailable, Qe = Ze.shouldCacheSegment;
                if (!nt)
                  return Qe && Le.cacheSegment(xe), !1;
              }
              Ae(xe) && this.timestampOffsetService.maybeAdjustTimestampOffsetAtDiscontinuityChange(xe, this.mpdHandler), this.manifestService.initSegmentStartTimesFromReferenceSegment(xe);
            }
            if (Ve && this.hls.possiblyDependentSegments && Fe && Ee(xe, this.hls) && !this.isKeyframeRecoveryOngoing) {
              this.logger.debug("Just switched playlists, isIndependentlyDecodable=".concat(xe.isIndependentlyDecodable(), ", (").concat(xe.getMimeType(), ", ").concat(xe.getUrl(), ")"));
              var qe = this.mpdHandler.getIndex() > 1;
              !xe.isIndependentlyDecodable() && qe && (this.logger.debug("Started keyframe recovery"), this.mpdHandler.setIndex(this.mpdHandler.getIndex() - 2), Ke = !1, this.hls.discardNextSegment = !0, this.isKeyframeRecoveryOngoing = !0);
            }
            if (!Ke)
              return !1;
            Ne(xe, this.context), this.context.serviceManager.get(ae.ServiceName.TimedMetadataService).onSegmentAvailable({ segment: xe, extractedMetadata: Ue, isSegmentOfMainStream: Ee(xe, this.hls), presentationTimeOffset: this.mpdHandler.getTimestampOffset() }), this.context.serviceManager.maybeCall(ae.ServiceName.SubtitleService, function(ut) {
              ut.handleClosedCaptions(Be.mpdHandler, xe, Ue == null ? void 0 : Ue.closedCaptions, Ve, xe.getCodec());
            });
            var ze = xe.getPlaybackTime(), je = (Re = xe.getSegmentInfo()) === null || Re === void 0 ? void 0 : Re.startTime, tt = je ? Math.abs(ze - je) : void 0;
            return this.logger.debug("[".concat(Pe, "][").concat(xe.getMimeType(), "]: playbackTimeForSegment=").concat(ze, " expected=").concat(je, " (diff=").concat(tt == null ? void 0 : tt.toFixed(3), ") ").concat(xe.getUrl())), Ee(xe, this.hls) && ((Oe = this.hlsTimelineTracker) === null || Oe === void 0 || Oe.trackPlaybackTime(xe), this.isKeyframeRecoveryOngoing = !1), this.onDataAvailableCallback(xe), Ke;
          }, Ie.prototype.maybeUpdateLlHlsSegmentInfo = function(xe) {
            var Ue = ce.ModuleManager.get(he.ModuleName.LowLatency, !1);
            (0, be.isPlayingLowLatencyHls)(this.context) && Ue && Ue.applyUpdatedSegmentInfoProps(xe, this.manifestService);
          }, Ie.prototype.updateDownloadedRepresentation = function(xe, Ue) {
            this.triggerOnDownloadQualityChanged(xe.getMimeType(), Ue, xe.getRepresentationId());
            var ke = xe.getSegmentInfo(), Le = { id: ke.representationId, bitrate: ke.bitrate, width: ke.width, height: ke.height };
            this.context.store.dispatch((0, _e.addMetricsValue)(this.mimeType, fe.MetricType.DownloadedRepresentation, Le)), this.downloadRepresentationId = xe.getRepresentationId();
          }, Ie.prototype.triggerOnDownloadQualityChanged = function(xe, Ue, ke) {
            var Le;
            if (se.MimeTypeHelper.isVideo(xe))
              Le = ue.PlayerEvent.VideoDownloadQualityChanged;
            else {
              if (!se.MimeTypeHelper.isAudio(xe))
                return;
              Le = ue.PlayerEvent.AudioDownloadQualityChanged;
            }
            var De = (0, ge.representationToQuality)(this.manifestService.getRepresentationById(Ue), xe), Re = (0, ge.representationToQuality)(this.manifestService.getRepresentationById(ke), xe);
            this.eventHandler.dispatchEvent(Le, { targetQuality: Re, targetQualityId: Re.id, sourceQuality: De, sourceQualityId: De ? De.id : null });
          }, Ie.prototype.hasHlsTimelineGap = function(xe, Ue) {
            var ke = { hasGap: !1 };
            if (xe && this.manifestService.isHlsManifest() && !Ae(xe) && Ee(xe, this.hls) && this.hlsTimelineTracker) {
              var Le = ye.SegmentInfoProvider.findHlsRepresentationForSegment(xe, this.manifestService.getAdaptationSet(Ue));
              if (Le && (ke = this.hlsTimelineTracker.checkForTimelineGap(xe, Le.representation, Le.index)).hasGap && ke.correctedIndex !== void 0) {
                this.logger.debug("Encountered timeline gap (".concat(ke.gapSizeSec, "), just loaded ").concat(xe.getUrl()));
                var De = Le.representation._internalId, Re = this.mpdHandler instanceof we.SegmentListMPDHandler && this.mpdHandler.getSegmentListEntries(De) && this.mpdHandler.getSegmentListEntries(De)[ke.correctedIndex];
                if (Re && (0, $e.areSegmentsIdentical)(xe.getSegmentInfo(), Re))
                  return this.logger.debug("Gap handling: Segment is identical to the one we just loaded, not rewinding"), ke.hasGap = !1, ke;
                Re && Re.hasDownloadFailed ? (this.logger.debug("Gap handling: Could not handle gap, segment has failed to download"), ke.couldHandle = !1) : (this.logger.debug("Gap handling: Correcting index from ".concat(this.mpdHandler.getIndex(), " to ").concat(ke.correctedIndex)), this.mpdHandler.setIndex(ke.correctedIndex));
              }
            }
            return ke;
          }, Ie.prototype.maybeHandleTimelineGap = function(xe, Ue, ke) {
            if (!(this.hlsTimelineTracker.isGapVerificationNeeded() || this.hlsTimelineTracker.isSeekTargetVerificationNeeded() || ke))
              return { shouldMakeSegmentAvailable: !0, shouldCacheSegment: !1 };
            var Le = this.hasHlsTimelineGap(xe, Ue);
            return Le.hasGap ? Le.couldHandle ? Me(Le) ? { shouldMakeSegmentAvailable: !1, shouldCacheSegment: !0 } : { shouldMakeSegmentAvailable: !1, shouldCacheSegment: !1 } : (this.hlsTimelineTracker.reset(), { shouldMakeSegmentAvailable: !0, shouldCacheSegment: !1 }) : { shouldMakeSegmentAvailable: !0, shouldCacheSegment: !1 };
          }, Ie.prototype.dispose = function() {
            this.downloadRepresentationId = null, this.hlsTimelineTracker = null, this.manifestService = null, this.onDataAvailableCallback = null, this.hls = null, this.segmentUnavailabilityHandler = null, this.timestampOffsetService = null, this.segmentParser = null, this.mpdHandler = null;
          }, Ie;
        }();
        function Ee(Ie, xe) {
          return !xe.isAvMuxedTogether || se.MimeTypeHelper.isVideo(Ie.getMimeType());
        }
        function Me(Ie) {
          var xe;
          return ((xe = Ie.gapSizeSec) !== null && xe !== void 0 ? xe : 0) > 0;
        }
        function Ae(Ie) {
          return se.MimeTypeHelper.isSubtitle(Ie.getMimeType());
        }
        function Ne(Ie, xe) {
          var Ue = (0, le.getSourceStore)(xe), ke = Ie.getSegmentInfo(), Le = (0, Se.getSegmentInfoTimeRange)(ke), De = Ie.getPlaybackTimeRange(), Re = (0, me.getTrackIdentifier)(ke);
          Ue && Le && De && (Ue.dispatch((0, ve.removeStreamTimeRange)(Re, Le, me.StreamTimeRangeType.Loading)), Ue.dispatch((0, ve.addStreamTimeRange)(Re, De, me.StreamTimeRangeType.Loading)));
        }
        function Ce(Ie, xe) {
          var Ue = (0, le.getSourceStore)(xe), ke = Ie.getSegmentInfo(), Le = (0, Se.getSegmentInfoTimeRange)(ke), De = (0, me.getTrackIdentifier)(ke);
          Ue && Le && Ue.dispatch((0, ve.removeStreamTimeRange)(De, Le, me.StreamTimeRangeType.Loading));
        }
        ie.SegmentPreProcessor = Te;
      }, 28499: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentPrefetcher = void 0;
        var ae = ne(27177), ue = ne(38255), _e = ne(66864), fe = function() {
          function le(se) {
            var oe = this;
            this.processSegmentInfoQueue = function(ce) {
              var he = oe.segmentInfoQueue.get(ce);
              he && he.length !== 0 && oe.chainSegmentPrefetch(he.shift()).then(function() {
                return oe.processSegmentInfoQueue(ce);
              });
            }, this.segmentInfoQueue = new ue.ArrayMap(), this.prefetchPromiseChainMap = /* @__PURE__ */ new Map(), this.decrypterMap = /* @__PURE__ */ new Map(), this.segmentLoaderMap = /* @__PURE__ */ new Map(), this.segmentPrefetchHandler = se, this.shouldDownloadBeCancelledCallbackMap = /* @__PURE__ */ new Map();
          }
          return le.prototype.updateContext = function(se) {
            this.context = se;
          }, le.prototype.setShouldDownloadBeCancelledCallback = function(se, oe) {
            this.shouldDownloadBeCancelledCallbackMap.set(se, oe);
          }, le.prototype.removeShouldDownloadBeCancelledCallback = function(se) {
            this.shouldDownloadBeCancelledCallbackMap.delete(se);
          }, le.prototype.setDecrypter = function(se, oe) {
            this.decrypterMap.set(oe, se), this.segmentLoaderMap.has(oe) && this.segmentLoaderMap.get(oe).attachDecrypter(se);
          }, le.prototype.removeDecrypter = function(se) {
            this.decrypterMap.delete(se);
          }, le.prototype.getDecrypter = function(se) {
            return this.decrypterMap.get(se);
          }, le.prototype.prefetchSegment = function(se) {
            return this.chainSegmentPrefetch(se);
          }, le.prototype.prefetchSegments = function(se) {
            var oe = this;
            se.forEach(function(ce) {
              return oe.segmentInfoQueue.add(ce.mimeType, ce);
            }), this.segmentInfoQueue.keys.forEach(function(ce) {
              return oe.processSegmentInfoQueue(ce);
            });
          }, le.prototype.chainSegmentPrefetch = function(se) {
            var oe = this, ce = this.getPrefetchPromiseChain(se.mimeType).then(function() {
              return oe.fetchSegment(se);
            }).then(function() {
            }).catch(function() {
            });
            return this.prefetchPromiseChainMap.set(se.mimeType, ce), ce;
          }, le.prototype.fetchSegment = function(se) {
            var oe = this;
            if (!(0, ae.isContextAvailable)(this.context))
              return Promise.reject("PlayerContext not available");
            var ce = this.getLoader(se).load(se).then(function(he) {
              return he.read();
            }).then(function(he) {
              return he.value;
            });
            return this.segmentPrefetchHandler.onPrefetch({ segmentInfo: se, loadingPromise: ce }), ce.catch(function(he) {
              (0, ae.isContextAvailable)(oe.context) && oe.context.logger.debug("segment prefetching failed for", se, "with", he);
            }), ce;
          }, le.prototype.getPrefetchPromiseChain = function(se) {
            return this.prefetchPromiseChainMap.has(se) || this.prefetchPromiseChainMap.set(se, Promise.resolve()), this.prefetchPromiseChainMap.get(se);
          }, le.prototype.getLoader = function(se) {
            return this.segmentLoaderMap.has(se.mimeType) || this.segmentLoaderMap.set(se.mimeType, this.createLoader(se)), this.segmentLoaderMap.get(se.mimeType);
          }, le.prototype.createLoader = function(se) {
            this.prefetchPromiseChainMap.set(se.mimeType, Promise.resolve());
            var oe = new _e.SegmentLoader(this.context, se.mimeType, this.createDownloadCancelCallbackFunction(se), !0);
            return oe.attachDecrypter(this.decrypterMap.get(se.mimeType)), oe;
          }, le.prototype.createDownloadCancelCallbackFunction = function(se) {
            var oe = this;
            return function(ce) {
              var he = se.mimeType, ge = oe.segmentLoaderMap.get(he), ve = ge ? ge.getCurrentLoadingSegmentInfo() : null, me = he !== void 0 ? oe.shouldDownloadBeCancelledCallbackMap.get(he) : void 0, be = ve ? ve.internalRepresentationId : se.internalRepresentationId;
              return me !== void 0 && me(ce, be);
            };
          }, le.prototype.clearPrefetchingQueue = function(se) {
            this.segmentInfoQueue.delete(se);
          }, le.prototype.reset = function() {
            this.segmentLoaderMap.forEach(function(se) {
              return se.dispose();
            }), this.shouldDownloadBeCancelledCallbackMap.clear(), this.segmentLoaderMap.clear(), this.decrypterMap.clear();
          }, le.prototype.dispose = function() {
            this.reset(), this.segmentLoaderMap = null, this.shouldDownloadBeCancelledCallbackMap = null;
          }, le;
        }();
        ie.SegmentPrefetcher = fe;
      }, 92395: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentPrefetchingService = void 0;
        var ae = ne(13788), ue = ne(28499), _e = function() {
          function fe() {
            this.segmentPrefetcher = new ue.SegmentPrefetcher(this), this.prefetchedSegments = /* @__PURE__ */ new Map();
          }
          return fe.prototype.updatePlayerContext = function(le) {
            this.context = le, this.segmentPrefetcher.updateContext(this.context);
          }, fe.prototype.setDecrypter = function(le, se) {
            this.segmentPrefetcher.setDecrypter(le, se);
          }, fe.prototype.removeDecrypter = function(le) {
            this.segmentPrefetcher.removeDecrypter(le);
          }, fe.prototype.getDecrypter = function(le) {
            return this.segmentPrefetcher.getDecrypter(le);
          }, fe.prototype.hasMp4Decrypter = function(le) {
            return !!this.getDecrypter(le);
          }, fe.prototype.setShouldDownloadBeCancelledCallback = function(le, se) {
            this.segmentPrefetcher.setShouldDownloadBeCancelledCallback(le, se);
          }, fe.prototype.removeShouldDownloadBeCancelledCallback = function(le) {
            this.segmentPrefetcher.removeShouldDownloadBeCancelledCallback(le);
          }, fe.prototype.fetch = function(le) {
            var se = this;
            return this.segmentPrefetcher.prefetchSegment(le).then(function() {
              var oe = se.prefetchedSegments.get(le.mimeType).get((0, ae.getSegmentInfoId)(le));
              return oe ? Promise.resolve(oe.loadingPromise) : Promise.reject();
            });
          }, fe.prototype.fetchAll = function(le) {
            this.segmentPrefetcher.prefetchSegments(le);
          }, fe.prototype.onPrefetch = function(le) {
            var se = le.segmentInfo.mimeType;
            this.prefetchedSegments.has(se) || this.prefetchedSegments.set(se, /* @__PURE__ */ new Map()), this.prefetchedSegments.get(se).set((0, ae.getSegmentInfoId)(le.segmentInfo), le);
          }, fe.prototype.hasPrefetchedSegment = function(le) {
            return !!this.findPrefetchedSegment(le);
          }, fe.prototype.getPrefetchedSegment = function(le) {
            var se = this.findPrefetchedSegment(le);
            return se ? se.loadingPromise : null;
          }, fe.prototype.findPrefetchedSegment = function(le) {
            return this.prefetchedSegments.has(le.mimeType) && this.prefetchedSegments.get(le.mimeType).get((0, ae.getSegmentInfoId)(le)) || null;
          }, fe.prototype.getPrefetchedSegments = function() {
            return this.prefetchedSegments;
          }, fe.prototype.removePrefetchedSegment = function(le) {
            this.prefetchedSegments.has(le.mimeType) && this.prefetchedSegments.get(le.mimeType).delete((0, ae.getSegmentInfoId)(le));
          }, fe.prototype.clearPrefetchingQueue = function(le) {
            this.segmentPrefetcher.clearPrefetchingQueue(le);
          }, fe.prototype.reset = function() {
            this.segmentPrefetcher.reset(), this.prefetchedSegments.clear();
          }, fe.prototype.dispose = function() {
            this.reset(), this.segmentPrefetcher.dispose(), this.segmentPrefetcher = null, this.prefetchedSegments = null;
          }, fe;
        }();
        ie.SegmentPrefetchingService = _e;
      }, 81660: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentManager = ie.SegmentService = void 0;
        var ae = ne(60997), ue = ne(79814), _e = ne(56435), fe = ne(41661), le = ne(46678), se = ne(72207), oe = ne(72477), ce = function() {
          function ve(me) {
            var be = this;
            this.context = me, this.disposeSegmentManager = function(pe) {
              be.segmentManagerMap.has(pe) && (be.segmentManagerMap.get(pe).dispose(), be.segmentManagerMap.delete(pe));
            }, this.segmentManagerMap = /* @__PURE__ */ new Map();
          }
          return ve.prototype.getSegmentManagerKey = function(me, be) {
            var pe = be === void 0 ? {} : be, $e = pe.id, ye = pe.lang;
            return ue.MimeTypeHelper.isSubtitle(me) ? [me, $e, ye].filter(Boolean).join("-") : me;
          }, ve.prototype.add = function(me, be, pe) {
            var $e = this.get(me.mimeType, pe);
            return $e || ($e = this.createSegmentManager(me, be), this.segmentManagerMap.set(this.getSegmentManagerKey(me.mimeType, pe), $e)), $e;
          }, ve.prototype.createSegmentManager = function(me, be) {
            return new he(this.context, me, be);
          }, ve.prototype.get = function(me, be) {
            return this.segmentManagerMap.get(this.getSegmentManagerKey(me, be));
          }, ve.prototype.disposeOfType = function(me, be) {
            this.disposeSegmentManager(this.getSegmentManagerKey(me, be));
          }, ve.prototype.dispose = function() {
            this.segmentManagerMap.forEach(function(me) {
              return me.dispose();
            }), this.segmentManagerMap.clear();
          }, ve;
        }();
        ie.SegmentService = ce;
        var he = function() {
          function ve(me, be, pe) {
            this.context = me, this.segmentParser = pe, this.hasEncryptedSegments = !1, this.loaderPool = new le.SegmentLoaderPool(me, be), this.initSegmentProvider = new oe.UrlInitSegmentProvider(me, be.mimeType), this.cache = new fe.SegmentCache(me.settings.MAX_NUM_CACHED_SEGMENTS), this.sequence = Promise.resolve(null);
          }
          return ve.prototype.getSegment = function(me) {
            var be = me.isInitSegment ? this.getInitSegment(me).then(function(pe) {
              return ge(pe);
            }) : this.getDataSegment(me);
            return this.sequence = this.sequence.catch(function() {
            }).then(function() {
              return be;
            }), this.sequence;
          }, ve.prototype.getInitSegment = function(me) {
            var be = this;
            return this.initSegmentProvider.getSegment(me).then(function(pe) {
              var $e;
              return ($e = be.segmentParser) === null || $e === void 0 || $e.parseSegment(pe), pe;
            }).catch(function(pe) {
              return be.context.logger.debug("Error during loading an init segment", pe), Promise.reject(pe);
            });
          }, ve.prototype.getDataSegment = function(me) {
            var be, pe = this;
            !((be = me.key) === null || be === void 0) && be.method && (this.hasEncryptedSegments = !0);
            var $e = this.acquireInitSegment(me);
            return (this.mustLoadInitSegmentSequentially() ? this.loadSegmentsSequentially($e, me) : this.loadSegmentsConcurrently($e, me)).then(function(ye) {
              var Se = ye[0], we = ye[1];
              return Se.transform(function(Pe) {
                return pe.attachInitSegment(Pe, we), Pe;
              }, function() {
              }, function(Pe) {
                return pe.context.logger.debug("Loading failed", Pe), Pe.message;
              });
            });
          }, ve.prototype.acquireInitSegment = function(me) {
            var be = Promise.resolve();
            if (me.init) {
              var pe = this.initSegmentProvider.getCachedSegment(me);
              be = pe ? Promise.resolve(pe) : this.getInitSegment(me.init);
            }
            return be;
          }, ve.prototype.mustLoadInitSegmentSequentially = function() {
            var me;
            return this.context.settings.DISABLE_PARALLEL_SEGMENT_LOADING || !!(!((me = this.context.sourceContext.source.drm) === null || me === void 0) && me.clearkey) || this.hasEncryptedSegments || (0, _e.isTizen2016)();
          }, ve.prototype.loadSegmentsSequentially = function(me, be) {
            var pe = this;
            return me.then(function($e) {
              return pe.getDataSegmentFromCacheOrLoad(be).then(function(ye) {
                return [ye, $e];
              });
            });
          }, ve.prototype.loadSegmentsConcurrently = function(me, be) {
            return Promise.all([this.getDataSegmentFromCacheOrLoad(be), me]);
          }, ve.prototype.getDataSegmentFromCacheOrLoad = function(me) {
            var be = this.getCachedSegment(me);
            return be != null ? (this.context.logger.debug("Returning segment from cache for URL: ".concat(me.url)), Promise.resolve(ge(be))) : this.loaderPool.load(me);
          }, ve.prototype.attachInitSegment = function(me, be) {
            be && me.setInitSegment(be);
          }, ve.prototype.isLoading = function(me) {
            return me ? this.loaderPool.getLoadingPeriodIds().includes(me) : this.loaderPool.getLoadingPeriodIds().length > 0;
          }, ve.prototype.canLoad = function() {
            var me = this.loaderPool.isFreeLoaderAvailable();
            return this.mustLoadInitSegmentSequentially() ? me && !this.initSegmentProvider.isLoading() : me;
          }, ve.prototype.cacheSegment = function(me) {
            this.cache.add(me);
          }, ve.prototype.hasCachedSegment = function(me) {
            return !!this.getCachedSegment(me);
          }, ve.prototype.getCachedSegment = function(me) {
            return me.isInitSegment ? this.initSegmentProvider.getCachedSegment(me) : this.cache.get(me);
          }, ve.prototype.removeCachedInitSegments = function(me) {
            this.initSegmentProvider.removeCachedSegments(me);
          }, ve.prototype.clearCache = function(me) {
            me === void 0 && (me = !0), me && this.initSegmentProvider.removeCachedSegments(function() {
              return !0;
            }), this.cache.clear();
          }, ve.prototype.cancel = function() {
            return this.loaderPool.cancelLoading();
          }, ve.prototype.dispose = function() {
            this.cancel(), this.clearCache(!1), this.loaderPool = (0, ae.dispose)(this.loaderPool), this.segmentParser = void 0, (0, ae.dispose)(this.initSegmentProvider);
          }, ve;
        }();
        function ge(ve) {
          var me = new se.Stream();
          return me.add(ve), me.end(), me;
        }
        ie.SegmentManager = he;
      }, 12482: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.TimestampOffsetService = void 0;
        var ae = ne(18665), ue = ne(79814), _e = ne(34586), fe = ne(91520), le = ne(16368), se = function() {
          function oe(ce, he) {
            this.context = ce, this.mimeType = he, this.discontinuityNumbers = /* @__PURE__ */ new Map();
            var ge = ce.sourceContext.sourceIdentifier;
            this.sourceStore = ce.serviceManager.get(ae.ServiceName.SourceStoreService, ge);
          }
          return Object.defineProperty(oe.prototype, "logger", { get: function() {
            return this.context.logger;
          }, enumerable: !1, configurable: !0 }), oe.prototype.maybeAdjustTimestampOffsetAtDiscontinuityChange = function(ce, he) {
            var ge = ce.getSegmentInfo().discontinuitySequenceNumber;
            if (ge == null || ce.isInit())
              return !1;
            var ve = this.discontinuityNumbers.get(ce.getMimeType()) !== ge, me = isNaN(he.getTimestampOffset());
            if (ve || me)
              this.adjustTimestampOffset(ce, ge, he);
            else if (ce.getSegmentInfo().wasPrefetched) {
              var be = this.getPresentationTimeOffsetForDisco(ce, ge);
              this.setSegmentPresentationTimeOffset(ce, be);
            }
            return this.discontinuityNumbers.set(ce.getMimeType(), ge), !0;
          }, oe.prototype.adjustTimestampOffset = function(ce, he, ge) {
            var ve = this.getPresentationTimeOffsetForDisco(ce, he);
            this.maybeExtrapolateStartTimes(ce, he, ge), this.logger.debug("[".concat(this.mimeType, "] Initialized PTO for new discontinuity ").concat(he, " to ").concat(ve, " on segment ").concat(ce.getUrl())), ge.setTimestampOffset(ve), this.setSegmentPresentationTimeOffset(ce, ve);
          }, oe.prototype.getPresentationTimeOffsetForDisco = function(ce, he) {
            var ge, ve, me = this.calculateEncodedPlaybackTime(ce).encodedPlaybackTime, be = fe.ModuleManager.get(le.ModuleName.HLS), pe = (ge = be == null ? void 0 : be.selectors) !== null && ge !== void 0 ? ge : {}, $e = pe.getHlsState, ye = pe.getPresentationTimeOffset, Se = $e == null ? void 0 : $e(this.sourceStore.getState());
            return Se && (ve = ye(Se, String(he))) !== null && ve !== void 0 ? ve : this.calculatePresentationTimeOffset(ce, me, he);
          }, oe.prototype.setSegmentPresentationTimeOffset = function(ce, he) {
            var ge = this.calculateEncodedPlaybackTime(ce), ve = ge.encodedPlaybackTime, me = ge.shouldUpdatePlaybackTime;
            ce.getSegmentInfo().presentationTimeOffset = he, ce.setPresentationTimeOffset(he), me && ce.setPlaybackTime(ve - he);
          }, oe.prototype.maybeExtrapolateStartTimes = function(ce, he, ge) {
            var ve = function(me) {
              return "extrapolateStartTimesFromDiscontinuityStarts" in me;
            };
            ce.getSegmentInfo().startTime == null && ve(ge) && (this.logger.debug("[".concat(ce.getMimeType(), "] Missing segment startTime when trying to calculate PTO for discontinuity ").concat(he)), ge.extrapolateStartTimesFromDiscontinuityStarts(ce));
          }, oe.prototype.calculatePresentationTimeOffset = function(ce, he, ge) {
            var ve = he - ce.getSegmentInfo().startTime, me = fe.ModuleManager.get(le.ModuleName.HLS);
            return ue.MimeTypeHelper.isSubtitle(ce.getMimeType()) && _e.TextSegmentAnalyzer.isPlainTextPayload(ce.getData()) || (this.sourceStore.dispatch(me.actions.setPresentationTimeOffset(String(ge), ve)), this.logger.debug("[".concat(ce.getMimeType(), "] Setting PTO for discontinuity ").concat(ge, " to ").concat(ve))), ve;
          }, oe.prototype.calculateEncodedPlaybackTime = function(ce) {
            var he, ge = fe.ModuleManager.get(le.ModuleName.ContainerMP4, !1), ve = !0, me = ge ? ge.parsePlaybackTime(ce, this.logger) : ce.getBaseMediaDecodeTime() / ce.getTimescale();
            return isNaN(me) && (me = (he = ce.getPlaybackTime()) !== null && he !== void 0 ? he : ce.getSegmentInfo().startTime, ve = !1), { encodedPlaybackTime: me, shouldUpdatePlaybackTime: ve };
          }, oe.prototype.dispose = function() {
            this.discontinuityNumbers = null, this.sourceStore = null;
          }, oe;
        }();
        ie.TimestampOffsetService = se;
      }, 72477: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.UrlInitSegmentProvider = void 0;
        var ae = ne(76650), ue = ne(8272), _e = ne(41661), fe = ne(46678), le = function() {
          function se(oe, ce) {
            this.currentlyLoading = {}, this.context = oe, this.loaderPool = new fe.SegmentLoaderPool(oe, { mimeType: ce, shouldDownloadBeCancelledCallback: function() {
              return !1;
            } }), this.cache = new _e.SegmentCache(1 / 0);
          }
          return se.prototype.getSegment = function(oe) {
            var ce = this, he = this.cache.get(oe);
            return (he ? Promise.resolve(he) : this.loadSegment(oe)).then(function(ge) {
              return he || ce.cacheSegment(ge), ge;
            });
          }, se.prototype.isLoading = function() {
            return this.loaderPool.isLoading();
          }, se.prototype.loadSegment = function(oe) {
            var ce = this;
            if (this.loaderPool.isFreeLoaderAvailable() || this.loaderPool.addLoaders(1), this.currentlyLoading[oe.url] != null)
              return this.currentlyLoading[oe.url];
            this.context.logger.debug("Loading init segment", oe.url);
            var he = this.loaderPool.load(oe).then(function(ge) {
              return ge.read();
            }).then(function(ge) {
              if (!ge.value)
                throw new Error("SegmentStream error ".concat(oe.url));
              return ge.value;
            }).finally(function() {
              delete ce.currentlyLoading[oe.url];
            });
            return this.currentlyLoading[oe.url] = he, he;
          }, se.prototype.cacheSegment = function(oe) {
            this.cache.add(oe), this.context.store.dispatch((0, ae.addMetricsValue)(oe.getMimeType(), ue.MetricType.CachedInitSegments, { internalRepId: oe.getSegmentInfo().internalRepresentationId }));
          }, se.prototype.getCachedSegment = function(oe) {
            return this.cache.get(oe);
          }, se.prototype.removeCachedSegments = function(oe) {
            this.cache.remove(oe);
          }, se.prototype.dispose = function() {
            this.cache.clear(), this.loaderPool.dispose();
          }, se;
        }();
        ie.UrlInitSegmentProvider = le;
      }, 74830: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.initializeHlsSegmentStartTimes = _e;
        var ae = ne(18665), ue = ne(67550);
        function _e(fe, le, se) {
          var oe = le.sourceContext.sourceIdentifier, ce = le.serviceManager.get(ae.ServiceName.ManifestService, oe);
          if (ce && !ce.getAllAdaptationSets().some(function(ge) {
            return ge.Representation.some(function(ve) {
              var me, be;
              return ((be = (me = ve.SegmentList) === null || me === void 0 ? void 0 : me[0].SegmentURL[0]) === null || be === void 0 ? void 0 : be._playbackTime) !== void 0;
            });
          })) {
            var he = fe.getRepresentationId();
            ce.initializeSegmentStartTimesFromStart(he), (0, ue.assignSegmentStartTimesFromHlsRepresentation)(se.getSegmentListEntries(fe.getRepresentationId()), he, ce);
          }
        }
      }, 72207: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.Stream = void 0;
        var ae = ne(10981), ue = ne(59305), _e = ne(6082), fe = function() {
          function le() {
            var se = this;
            this.resolveDeferredRead = function() {
              se.deferredRead && !se.isEmpty() && (se.deferredRead.resolve({ done: !1, value: se.chunks.shift() }), se.deferredRead = null);
            }, this.state = _e.StreamState.Open, this.chunks = [], this.deferredEnded = new ae.Deferred(), this.deferredEnded.promise.catch(function() {
            });
          }
          return le.prototype.add = function(se) {
            this.state === _e.StreamState.Open && (this.chunks.push(se), this.resolveDeferredRead());
          }, le.prototype.read = function() {
            if (this.deferredRead)
              return Promise.reject({ name: ue.StreamReadError.ParallelRead });
            if (this.state === _e.StreamState.Ended && this.isEmpty())
              return Promise.resolve({ done: !0 });
            if (this.state === _e.StreamState.Aborted)
              return Promise.reject({ name: ue.StreamReadError.Aborted, message: this.getError() });
            this.deferredRead = new ae.Deferred();
            var se = this.deferredRead.promise;
            return this.resolveDeferredRead(), se;
          }, le.prototype.end = function() {
            this.state === _e.StreamState.Open && (this.state = _e.StreamState.Ended, this.deferredRead && this.isEmpty() && (this.deferredRead.resolve({ done: !0 }), this.deferredRead = null), this.deferredEnded.resolve());
          }, le.prototype.abort = function(se) {
            var oe;
            if (this.state === _e.StreamState.Open) {
              this.state = _e.StreamState.Aborted, this.error = se;
              var ce = { name: _e.StreamState.Aborted, message: (oe = this.getError()) !== null && oe !== void 0 ? oe : "" };
              this.deferredRead && (this.deferredRead.reject(ce), this.deferredRead = null), this.deferredEnded.reject(ce);
            }
          }, le.prototype.transform = function(se, oe, ce) {
            var he = this, ge = new le(), ve = function() {
              he.read().then(function(me) {
                var be = me.done, pe = me.value;
                if (be)
                  oe && oe(), ge.end();
                else {
                  var $e = pe != null && se(pe);
                  $e && ge.add($e), ve();
                }
              }).catch(function(me) {
                ce ? ge.abort(ce(me)) : ge.abort(me);
              });
            };
            return ve(), ge;
          }, le.prototype.isEmpty = function() {
            return this.chunks.length === 0;
          }, le.prototype.getError = function() {
            return this.error || null;
          }, le;
        }();
        ie.Stream = fe;
      }, 59305: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.StreamReadError = void 0, function(ae) {
          ae.Aborted = "aborted", ae.ParallelRead = "parallelread";
        }(ne || (ie.StreamReadError = ne = {}));
      }, 6082: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.StreamState = void 0, function(ae) {
          ae.Open = "open", ae.Ended = "ended", ae.Aborted = "aborted";
        }(ne || (ie.StreamState = ne = {}));
      }, 19300: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.DiscontinuityMonitor = void 0;
        var ae = ne(62510), ue = function() {
          function _e(fe) {
            var le = this;
            this.context = fe, this.onSeek = function() {
              le.seekStarted = !0;
            }, this.onSeeked = function() {
              var se = le.context.internalPlayer.getCurrentTime();
              Object.values(le.delayedSegmentPlaybackData).forEach(function(oe) {
                se >= oe.playbackTime && oe.playbackTime + oe.duration >= se && le.maybeFirePeriodSwitchEvents(oe);
              }), le.delayedSegmentPlaybackData = {};
            }, this.currentDiscontinuityNumbers = {}, this.delayedSegmentPlaybackData = {}, this.seekStarted = !1, this.context.eventHandler.on(ae.PlayerEvent.Seek, this.onSeek, !0), this.context.eventHandler.on(ae.PlayerEvent.Seeked, this.onSeeked, !0);
          }
          return _e.prototype.onSegmentAvailable = function(fe) {
            if (!fe.isInit()) {
              var le = fe.getMimeType(), se = fe.getSegmentInfo();
              this.currentDiscontinuityNumbers[le] ? this.seekStarted && (this.delayedSegmentPlaybackData[fe.getMimeType()] = { mimeType: fe.getMimeType(), discontinuitySequenceNumber: se.discontinuitySequenceNumber, playbackTime: se.startTime, duration: fe.getDuration() }, this.seekStarted = !1) : this.currentDiscontinuityNumbers[le] = { discontinuitySequenceNumber: se.discontinuitySequenceNumber, startTime: se.startTime || 0 };
            }
          }, _e.prototype.maybeFirePeriodSwitchEvents = function(fe) {
            var le = fe.mimeType, se = fe.discontinuitySequenceNumber, oe = fe.playbackTime;
            if (se != null && this.currentDiscontinuityNumbers[le]) {
              var ce = this.currentDiscontinuityNumbers[le].discontinuitySequenceNumber;
              ce !== se && (this.shouldFirePeriodSwitchEvent(le, se, oe) && (this.context.eventHandler.dispatchEvent(ae.PlayerEvent.PeriodSwitch), this.context.eventHandler.dispatchEvent(ae.PlayerEvent.PeriodSwitched, { sourcePeriod: { periodId: String(ce) }, targetPeriod: { periodId: String(se) } })), this.currentDiscontinuityNumbers[le] = { discontinuitySequenceNumber: se, startTime: oe });
            }
          }, _e.prototype.shouldFirePeriodSwitchEvent = function(fe, le, se) {
            var oe = this, ce = Object.keys(this.currentDiscontinuityNumbers).filter(function(ge) {
              return ge !== fe;
            }), he = !0;
            return ce.forEach(function(ge) {
              var ve = oe.currentDiscontinuityNumbers[ge];
              ve.discontinuitySequenceNumber === le && Math.abs(se - ve.startTime) < 1 && (he = !1);
            }), he;
          }, _e.prototype.dispose = function() {
            this.context.eventHandler.off(ae.PlayerEvent.Seek, this.onSeek), this.context.eventHandler.off(ae.PlayerEvent.Seeked, this.onSeeked);
          }, _e;
        }();
        ie.DiscontinuityMonitor = ue;
      }, 48727: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(oe) {
            for (var ce, he = 1, ge = arguments.length; he < ge; he++)
              for (var ve in ce = arguments[he])
                Object.prototype.hasOwnProperty.call(ce, ve) && (oe[ve] = ce[ve]);
            return oe;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentInitType = ie.Segment = void 0;
        var ue, _e = ne(81361), fe = ne(79814), le = ne(28915), se = function() {
          function oe(ce, he, ge, ve, me, be, pe, $e, ye, Se) {
            be === void 0 && (be = ue.NONE), this.inbandEvents = [], this.data = ce, this.mimeType = he, this.codec = ge, this.periodId = ve, this.duration = me, this.initType = be, this.isSegmentIndependentlyDecodable = pe, this.encrypted = !1, this.metadata = { subtitles: [] }, this.networkRequestSize = $e, this.representationId = ye, this.playbackTime = Se, this._isDirty = !1, this.drmInitData = null, ce instanceof ArrayBuffer || typeof ce == "string" && (this.data = _e.ArrayHelper.stringToArrayWithoutEncoding(ce).buffer);
          }
          return oe.prototype.setDrmKid = function(ce) {
            this.drmKid = ce;
          }, oe.prototype.hasDrmKid = function() {
            return !!this.getDrmKid();
          }, oe.prototype.getDrmKid = function() {
            var ce, he, ge;
            return (ge = (ce = this.drmKid) !== null && ce !== void 0 ? ce : (he = this.initSegment) === null || he === void 0 ? void 0 : he.getDrmKid()) !== null && ge !== void 0 ? ge : void 0;
          }, oe.prototype.setDrmInitData = function(ce) {
            this.drmInitData = ce;
          }, oe.prototype.hasDrmInitData = function() {
            var ce;
            return ((ce = this.drmInitData) === null || ce === void 0 ? void 0 : ce.length) > 0;
          }, oe.prototype.getDrmInitData = function() {
            return this.hasDrmInitData() ? this.drmInitData : [];
          }, oe.prototype.getMimeType = function() {
            return this.mimeType;
          }, oe.prototype.isInit = function() {
            return this.initType === ue.INIT;
          }, oe.prototype.isSelfInit = function() {
            return this.initType === ue.SELF_INIT;
          }, oe.prototype.isEncrypted = function() {
            return this.encrypted;
          }, oe.prototype.setEncrypted = function(ce) {
            this.encrypted = ce;
          }, oe.prototype.setUrl = function(ce) {
            this.loadedUrl = ce;
          }, oe.prototype.getUrl = function() {
            return this.loadedUrl;
          }, oe.prototype.getData = function() {
            return this.data;
          }, oe.prototype.setData = function(ce) {
            this.data = ce;
          }, oe.prototype.getMetadata = function() {
            return this.metadata;
          }, oe.prototype.setMetadata = function(ce) {
            this.metadata = ce;
          }, oe.prototype.getPlaybackTime = function() {
            return this.playbackTime;
          }, oe.prototype.setPlaybackTime = function(ce) {
            this.playbackTime = ce;
          }, oe.prototype.getPlaybackEndTime = function() {
            return this.playbackTime + this.duration;
          }, oe.prototype.getPlaybackTimeRange = function() {
            return this.duration ? { start: this.getPlaybackTime(), end: this.getPlaybackEndTime() } : (0, le.getSegmentInfoTimeRange)(this.getSegmentInfo());
          }, oe.prototype.getBaseMediaDecodeTime = function() {
            return this.baseMediaDecodeTime;
          }, oe.prototype.setBaseMediaDecodeTime = function(ce) {
            this.baseMediaDecodeTime = ce;
          }, oe.prototype.getPresentationTimeOffset = function() {
            return this.presentationTimeOffset;
          }, oe.prototype.setPresentationTimeOffset = function(ce) {
            this.presentationTimeOffset = ce;
          }, oe.prototype.getTFDTBoxOffsets = function() {
            return this.tfdtBoxOffsets;
          }, oe.prototype.setTFDTBoxOffsets = function(ce) {
            this.tfdtBoxOffsets = ce;
          }, oe.prototype.getParserMetadataValue = function(ce) {
            var he;
            return this.getParserMetadata() && this.getParserMetadata()[ce] ? this.getParserMetadata()[ce] : !((he = this.getInitSegment()) === null || he === void 0) && he.getParserMetadata() ? this.getInitSegment().getParserMetadata()[ce] : void 0;
          }, oe.prototype.getTimescale = function() {
            return this.getParserMetadataValue("timescale");
          }, oe.prototype.getIvSize = function() {
            return this.getParserMetadataValue("ivSize");
          }, oe.prototype.getDefaultSampleDuration = function() {
            return this.getParserMetadataValue("defaultSampleDuration");
          }, oe.prototype.getDefaultSampleSize = function() {
            return this.getParserMetadataValue("defaultSampleSize");
          }, oe.prototype.setTimescale = function(ce) {
            this.updateParserMetadata({ timescale: ce });
          }, oe.prototype.getPeriodId = function() {
            return this.periodId;
          }, oe.prototype.getCodec = function() {
            return this.codec;
          }, oe.prototype.setCodec = function(ce) {
            this.codec = ce;
          }, oe.prototype.getDuration = function() {
            return this.duration;
          }, oe.prototype.setDuration = function(ce) {
            this.duration = ce;
          }, oe.prototype.getNetworkRequestSize = function() {
            return this.networkRequestSize;
          }, oe.prototype.getRepresentationId = function() {
            return this.representationId;
          }, oe.prototype.getParsedData = function() {
            return this.parsedData;
          }, oe.prototype.setParsedData = function(ce) {
            this.parsedData = ce;
          }, oe.prototype.getSegmentInfo = function() {
            return this.segmentInfo;
          }, oe.prototype.isIndependentlyDecodable = function() {
            return this.isSegmentIndependentlyDecodable;
          }, oe.prototype.setSegmentInfo = function(ce) {
            this.segmentInfo = ce;
          }, oe.prototype.getMediaInfo = function() {
            var ce = {};
            return this.segmentInfo && this.segmentInfo.bitrate && (ce.bitrate = this.segmentInfo.bitrate), fe.MimeTypeHelper.isAudio(this.mimeType) ? this.segmentInfo && this.segmentInfo.sampleRate && (ce.sampleRate = this.segmentInfo.sampleRate) : fe.MimeTypeHelper.isVideo(this.mimeType) && (this.segmentInfo && this.segmentInfo.width && (ce.width = this.segmentInfo.width), this.segmentInfo && this.segmentInfo.height && (ce.height = this.segmentInfo.height), this.segmentInfo && this.segmentInfo.frameRate && (ce.frameRate = this.segmentInfo.frameRate)), ce;
          }, oe.prototype.isDirty = function() {
            return this._isDirty;
          }, oe.prototype.setDirty = function(ce) {
            this._isDirty = ce;
          }, oe.prototype.setInbandEvents = function(ce) {
            this.inbandEvents = ce;
          }, oe.prototype.getInbandEvents = function() {
            return this.inbandEvents;
          }, oe.prototype.setLastSegment = function(ce) {
            this.lastSegment = ce;
          }, oe.prototype.isLastSegment = function() {
            return this.lastSegment;
          }, oe.prototype.wasLoadedFrom = function(ce) {
            return this.getUrl().includes(ce);
          }, oe.prototype.getParserMetadata = function() {
            return this.parserMetadata;
          }, oe.prototype.setParserMetadata = function(ce) {
            this.parserMetadata = ce;
          }, oe.prototype.updateParserMetadata = function(ce) {
            this.parserMetadata = ae(ae({}, this.parserMetadata), ce);
          }, oe.prototype.setBufferBlockId = function(ce) {
            this.bufferBlockId = ce;
          }, oe.prototype.getBufferBlockId = function() {
            return this.bufferBlockId;
          }, oe.prototype.setInitSegment = function(ce) {
            this.initSegment = ce;
          }, oe.prototype.getInitSegment = function() {
            return this.initSegment;
          }, oe;
        }();
        ie.Segment = se, function(oe) {
          oe[oe.NONE = 0] = "NONE", oe[oe.INIT = 1] = "INIT", oe[oe.SELF_INIT = 2] = "SELF_INIT";
        }(ue || (ie.SegmentInitType = ue = {}));
      }, 92103: function(ee, ie) {
        function ne(le, se) {
          if (le.mediaSequence !== void 0 && se.mediaSequence !== void 0)
            return le.mediaSequence === se.mediaSequence;
          var oe = ue(le, se), ce = fe(le.byteRange, se.byteRange), he = le.discontinuitySequenceNumber === se.discontinuitySequenceNumber;
          return oe && ce && he;
        }
        function ae(le, se) {
          var oe = (le == null ? void 0 : le.url) === (se == null ? void 0 : se.url), ce = fe(le == null ? void 0 : le.byteRange, se == null ? void 0 : se.byteRange);
          return oe && ce;
        }
        function ue(le, se) {
          var oe = _e(le), ce = _e(se);
          return oe.some(function(he) {
            return ce.includes(he);
          });
        }
        function _e(le) {
          return [le.url, le.mediaURL].filter(Boolean);
        }
        function fe(le, se) {
          return le == null ? se == null : se != null && le.start === se.start && le.end === se.end;
        }
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.isIdenticalSegmentInfo = ne, ie.isIdenticalInitSegmentInfo = ae;
      }, 30855: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentUnavailabilityHandler = void 0;
        var ae = ne(76885), ue = function() {
          function _e(fe) {
            this.triedRepsForCurrentSegment = {}, this.wasQualitySwitched = !1, this.context = fe;
          }
          return _e.prototype.downloadSuccess = function(fe) {
            this.wasQualitySwitched && fe ? this.wasQualitySwitched = !1 : this.triedRepsForCurrentSegment = {};
          }, _e.prototype.getNextLowerNotTriedQuality = function(fe, le) {
            for (var se = [], oe = 0; oe < fe.length && !fe[oe]._internalId.equals(le); oe++)
              this.triedRepsForCurrentSegment[fe[oe]._id] || se.push(fe[oe]);
            return se.length > 0 ? se[se.length - 1]._internalId : null;
          }, _e.prototype.switchQuality = function(fe, le) {
            this.triedRepsForCurrentSegment[le.representationId] = !0;
            var se = this.getNextLowerNotTriedQuality(fe, le);
            return se ? (this.wasQualitySwitched = !0, se) : (this.context.logger.log("no quality left, all tried"), null);
          }, _e.prototype.switchBaseURL = function(fe) {
            var le = fe.availableBaseURLs, se = fe.lastUsedBaseURLIndex + 1;
            return (se %= le.length) === fe.firstUsedBaseURLIndex ? (this.context.logger.log("no base url left, all tried"), null) : (fe.lastUsedBaseURLIndex = se, fe.baseURL = le[se], fe.url = ae.URLHelper.concatBaseUrlWithPartial(fe.baseURL, fe.mediaURL), fe);
          }, _e.prototype.shouldTryAlternatives = function(fe) {
            return fe >= 400 && fe <= 599 || fe === 0;
          }, _e;
        }();
        ie.SegmentUnavailabilityHandler = ue;
      }, 38765: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(we) {
            for (var Pe, Te = 1, Ee = arguments.length; Te < Ee; Te++)
              for (var Me in Pe = arguments[Te])
                Object.prototype.hasOwnProperty.call(Pe, Me) && (we[Me] = Pe[Me]);
            return we;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.TimedMetadataService = void 0;
        var ue = ne(18665), _e = ne(60997), fe = ne(62510), le = ne(54861), se = ne(489), oe = ne(76650), ce = ne(28819), he = ne(8272), ge = ne(79814), ve = ne(38925), me = ne(19300), be = function() {
          function we(Pe) {
            var Te, Ee = this;
            this.context = Pe, this.onGenericMetadataAvailable = function(Ae) {
              if (Ae.hasOwnProperty("metadata")) {
                var Ne = { metadataType: Ae.metadataType.toUpperCase(), metadata: Ae.metadata };
                (Ae.start || Ae.start === 0) && (Ne.start = Ae.start), Ae.end && (Ne.end = Ae.end), Ee.context.eventHandler.dispatchEvent(fe.PlayerEvent.Metadata, Ne);
              }
            }, this.inbandMetadataCallback = function(Ae) {
              Ae && Ae.hasOwnProperty("metadataType") && Ee.context.eventHandler.dispatchEvent(fe.PlayerEvent.Metadata, { metadataType: Ae.metadataType, metadata: Ae.metadata });
            }, this.onSegmentPlayback = function(Ae) {
              var Ne = Ae.metadata.event;
              Ee.currentlyPlayedSegment[Ne.mimeType] = Ne, Ee.playbackRepresentationId[Ne.mimeType] = ve.RepresentationId.from(Ae.metadata.representationId), Ee.discontinuityMonitor.maybeFirePeriodSwitchEvents(Ne), Ee.previousRepresentationIds[Ne.mimeType] && Ee.previousRepresentationIds[Ne.mimeType].id === Ne.representationId || Ee.handlePlaybackInfo(Ne), Ee.context.eventHandler.dispatchEvent(fe.PlayerEvent.SegmentPlayback, Ne);
            }, this.previousRepresentationIds = {}, this.playbackRepresentationId = {}, this.currentlyPlayedSegment = {}, this.manifestService = this.context.serviceManager.get(ue.ServiceName.ManifestService, Pe.sourceContext.sourceIdentifier);
            var Me = ((Te = {})[se.TimedMetadataType.InBand] = this.inbandMetadataCallback, Te[se.TimedMetadataType.SegmentPlayback] = this.onSegmentPlayback, Te[se.TimedMetadataType.Manifest] = this.onGenericMetadataAvailable, Te[se.TimedMetadataType.EventStream] = this.onGenericMetadataAvailable, Te[se.TimedMetadataType.DateRange] = this.onGenericMetadataAvailable, Te[se.TimedMetadataType.CustomTag] = this.onGenericMetadataAvailable, Te);
            this.metadataService = new le.MetadataService(Pe, Me), this.discontinuityMonitor = new me.DiscontinuityMonitor(Pe);
          }
          return we.prototype.clearSegmentBoundMetadata = function(Pe) {
            this.metadataService.removeMatchingCues(se.TimedMetadataType.SegmentPlayback, function(Te) {
              return Te.content.metadata.mimeType === Pe;
            });
          }, we.prototype.onSegmentAvailable = function(Pe) {
            var Te, Ee = this, Me = Pe.segment, Ae = Pe.extractedMetadata, Ne = Pe.isSegmentOfMainStream, Ce = Pe.presentationTimeOffset;
            if (Ne) {
              Te = Se(Me);
              var Ie = Me.getSegmentInfo();
              Ie.metadata && Ie.metadata.forEach(function(xe) {
                Ee.processSegmentInfoMetadata(xe, Te, Me.getPeriodId());
              }), $e(Ie) && this.handleCustomMetadata(Ie), this.handleId3Metadata(Ae, Ce, Me.getPeriodId());
            } else
              Te = ye(Me);
            this.registerSegmentPlaybackEvent(Me, Te), Me.getInbandEvents().forEach(function(xe) {
              Ee.processInbandEvent(xe, Me.getPeriodId());
            }), this.discontinuityMonitor.onSegmentAvailable(Me);
          }, we.prototype.registerSegmentPlaybackEvent = function(Pe, Te) {
            if (!Pe.isInit()) {
              var Ee = Pe.getSegmentInfo(), Me = Pe.getMimeType(), Ae = { metadata: { event: Te, representationId: { _periodId: Ee.internalRepresentationId.periodId, _adaptationSetId: Ee.internalRepresentationId.adaptationSetId, _representationId: Ee.internalRepresentationId.representationId }, mimeType: Me } };
              this.metadataService.addToTimeline(se.TimedMetadataType.SegmentPlayback, Te.playbackTime, Ae), (0, ce.getMetricsState)(this.context.store.getState())[Me] || this.context.store.dispatch((0, oe.initializeMetricsForMimeType)(Me, this.context.settings)), this.context.store.dispatch((0, oe.addMetricsValue)(Me, he.MetricType.SegmentInformation, { bitrate: 8 * Pe.getNetworkRequestSize() / Pe.getDuration(), duration: Pe.getDuration(), playbackTime: Ee.startTime || Pe.getPlaybackTime(), representationId: Pe.getRepresentationId() }));
            }
          }, we.prototype.parseEventStream = function() {
            var Pe = this;
            this.manifestService.getAllPeriods().forEach(function(Te) {
              Pe.manifestService.getEventStreamEvents(Te).forEach(function(Ee) {
                Pe.processEventStreamEvent(Ee, Te);
              });
            });
          }, we.prototype.processEventStreamEvent = function(Pe, Te) {
            var Ee = { metadataType: fe.MetadataType.EVENT_STREAM, metadata: Pe.data, start: Pe.startTime, end: Pe.endTime };
            this.metadataService.addToMetadataParsedService(Pe.startTime, ae(ae({}, Ee), { data: Pe.data }), Te._id), this.metadataService.addToTimeline(se.TimedMetadataType.EventStream, Pe.startTime, Ee);
          }, we.prototype.getPlaybackRepresentation = function(Pe) {
            var Te = this.context.serviceManager.get(ue.ServiceName.ManifestService, this.context.sourceContext.sourceIdentifier), Ee = ae({}, Te.getRepresentationById(this.playbackRepresentationId[Pe]));
            return Ee && this.currentlyPlayedSegment[Pe] && (Ee.uid = this.currentlyPlayedSegment[Pe].uid), Ee;
          }, we.prototype.handlePlaybackInfo = function(Pe) {
            var Te, Ee;
            ge.MimeTypeHelper.isAudio(Pe.mimeType) ? (Te = fe.PlayerEvent.AudioPlaybackQualityChanged, Ee = { id: Pe.representationId, bitrate: parseFloat(Pe.mediaInfo.bitrate) }) : ge.MimeTypeHelper.isVideo(Pe.mimeType) && (Te = fe.PlayerEvent.VideoPlaybackQualityChanged, Ee = { id: Pe.representationId, bitrate: parseFloat(Pe.mediaInfo.bitrate), width: parseFloat(Pe.mediaInfo.width), height: parseFloat(Pe.mediaInfo.height) }), Te && this.context.eventHandler.dispatchEvent(Te, { targetQuality: Ee, sourceQuality: this.previousRepresentationIds[Pe.mimeType] || null }), this.previousRepresentationIds[Pe.mimeType] = Ee;
          }, we.prototype.processDateRangeEvent = function(Pe, Te) {
            var Ee = { metadataType: fe.MetadataType.DATERANGE, metadata: Pe.data, start: Pe.startTime, end: Pe.endTime };
            this.metadataService.addToMetadataParsedService(Pe.startTime, ae(ae({}, Ee), { data: Pe.data }), Te), this.metadataService.addToTimeline(se.TimedMetadataType.DateRange, Pe.startTime, Ee);
          }, we.prototype.addSegmentToMetadataParsedService = function(Pe, Te) {
            var Ee = this;
            Pe.forEach(function(Me) {
              if (Me._metadata && Me._metadata.length > 0 && Me._playbackTime) {
                var Ae = { metadataType: fe.MetadataType.CUSTOM, metadata: Me._metadata, data: Me._metadata, start: Me._playbackTime, end: Me._playbackTime + Me._duration };
                Ee.metadataService.addToMetadataParsedService(Me._playbackTime, Ae, Te);
              }
            });
          }, we.prototype.handleId3Metadata = function(Pe, Te, Ee) {
            var Me = this;
            Pe && Array.isArray(Pe.id3) && Pe.id3.length > 0 && Pe.id3.forEach(function(Ae) {
              Me.publishId3Metadata(Ae, Te, Ee);
            });
          }, we.prototype.publishId3Metadata = function(Pe, Te, Ee) {
            var Me = Pe.presentationTime - Te, Ae = { metadataType: fe.MetadataType.ID3, metadata: Pe.data, start: Me };
            this.metadataService.addToMetadataParsedService(Me, ae(ae({}, Ae), { data: Pe.data }), Ee), this.metadataService.addToTimeline(se.TimedMetadataType.InBand, Me, Ae);
          }, we.prototype.handleCustomMetadata = function(Pe) {
            var Te = this, Ee = this.manifestService.getRepresentationById(Pe.internalRepresentationId);
            Ee.SegmentList[0].SegmentURL.forEach(function(Me, Ae) {
              Me._media === Pe.url && (Me._playbackTime || pe(Ee.SegmentList[0].SegmentURL, Ae, Pe.startTime), Te.metadataService.addToTimeline(se.TimedMetadataType.CustomTag, Pe.startTime, { metadataType: fe.MetadataType.CUSTOM, metadata: Me._metadata, start: Pe.startTime, end: Pe.startTime + Pe.duration }));
            }), this.addSegmentToMetadataParsedService(Ee.SegmentList[0].SegmentURL, Pe.periodId);
          }, we.prototype.processInbandEvent = function(Pe, Te) {
            var Ee = Pe.presentationTime, Me = { metadataType: fe.MetadataType.EMSG, metadata: Pe, start: Ee };
            this.metadataService.addToMetadataParsedService(Ee, ae(ae({}, Me), { data: Pe }), Te), this.metadataService.addToTimeline(se.TimedMetadataType.InBand, Ee, Me);
          }, we.prototype.processSegmentInfoMetadata = function(Pe, Te, Ee) {
            var Me = Pe.type;
            if (Me === fe.MetadataType.CUSTOM)
              Te.EXPERIMENTAL = Te.EXPERIMENTAL || {}, Te.EXPERIMENTAL.hlsAttributes = Te.EXPERIMENTAL.hlsAttributes || [], Te.EXPERIMENTAL.hlsAttributes = Te.EXPERIMENTAL.hlsAttributes.concat(Pe.attributes);
            else {
              var Ae = { metadataType: /^CUE-(IN|OUT(-CONT)?)$/.test(Me) ? fe.MetadataType.CUETAG : fe.MetadataType[Pe.type], metadata: Pe, start: Te.playbackTime };
              this.metadataService.addToMetadataParsedService(Ae.start, ae(ae({}, Ae), { data: Pe }), Ee), this.metadataService.addToTimeline(se.TimedMetadataType.Manifest, Ae.start, Ae);
            }
          }, we.prototype.dispose = function() {
            this.metadataService = (0, _e.dispose)(this.metadataService), this.manifestService = null, this.discontinuityMonitor = (0, _e.dispose)(this.discontinuityMonitor);
          }, we;
        }();
        function pe(we, Pe, Te) {
          for (var Ee = Pe, Me = Te; Ee >= 0; )
            we[Ee]._playbackTime = Me, Me -= we[Ee]._duration, Ee--;
          for (Ee = Pe + 1, Me = Te + we[Pe]._duration; Ee < we.length; )
            we[Ee]._playbackTime = Me, Me += we[Ee]._duration, Ee++;
        }
        function $e(we) {
          return we.metadata && we.metadata.length > 0 && we.metadata[0].type === fe.MetadataType.CUSTOM;
        }
        function ye(we) {
          var Pe = we.getSegmentInfo();
          return { uid: btoa(we.getUrl()), url: we.getUrl(), mimeType: we.getMimeType(), playbackTime: we.getPlaybackTime(), presentationTimestamp: we.getBaseMediaDecodeTime() / we.getTimescale(), duration: we.getDuration(), mediaInfo: we.getMediaInfo(), wallClockTime: Pe.wallClockTime, discontinuitySequenceNumber: Pe.discontinuitySequenceNumber };
        }
        function Se(we) {
          var Pe = ye(we), Te = we.getSegmentInfo();
          return Te.dateTime && (Pe.dateTime = Te.dateTime), Te.representationId && (Pe.representationId = Te.representationId), Pe;
        }
        ie.TimedMetadataService = be;
      }, 4053: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.setRepresentationIdAction = fe, ie.setMediaTypeAction = le, ie.setContainerFormatAction = se, ie.removeActiveTrackAction = oe, ie.clearActiveTracksAction = ce;
        var ae = ne(15231), ue = ne(81361), _e = ne(73731);
        function fe(he) {
          return (0, ae.createAction)(_e.ActiveTracksActionType.SetSelectedRepresentationId, { selectedRepresentationId: he });
        }
        function le(he, ge) {
          var ve = (0, ue.forceArray)(ge);
          return (0, ae.createAction)(_e.ActiveTracksActionType.SetMediaType, { trackId: he, mediaTypes: ve });
        }
        function se(he, ge) {
          return (0, ae.createAction)(_e.ActiveTracksActionType.SetContainerFormat, { trackId: he, containerFormat: ge });
        }
        function oe(he) {
          return (0, ae.createAction)(_e.ActiveTracksActionType.RemoveActiveTrack, { adaptationSetId: he });
        }
        function ce() {
          return (0, ae.createAction)(_e.ActiveTracksActionType.ClearActiveTracks);
        }
      }, 73731: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ActiveTracksActionType = void 0, function(ae) {
          ae.SetSelectedRepresentationId = "@instance/sources/@source/activetracks/setselectedrepresentationid", ae.SetMediaType = "@instance/sources/@source/activetracks/setmediatype", ae.SetContainerFormat = "@instance/sources/@source/activetracks/setcontainerformat", ae.RemoveActiveTrack = "@instance/sources/@source/activetracks/remove", ae.ClearActiveTracks = "@instance/sources/@source/activetracks/clear";
        }(ne || (ie.ActiveTracksActionType = ne = {}));
      }, 82311: function(ee, ie, ne) {
        var ae, ue = this && this.__assign || function() {
          return ue = Object.assign || function(be) {
            for (var pe, $e = 1, ye = arguments.length; $e < ye; $e++)
              for (var Se in pe = arguments[$e])
                Object.prototype.hasOwnProperty.call(pe, Se) && (be[Se] = pe[Se]);
            return be;
          }, ue.apply(this, arguments);
        }, _e = this && this.__rest || function(be, pe) {
          var $e = {};
          for (var ye in be)
            Object.prototype.hasOwnProperty.call(be, ye) && pe.indexOf(ye) < 0 && ($e[ye] = be[ye]);
          if (be != null && typeof Object.getOwnPropertySymbols == "function") {
            var Se = 0;
            for (ye = Object.getOwnPropertySymbols(be); Se < ye.length; Se++)
              pe.indexOf(ye[Se]) < 0 && Object.prototype.propertyIsEnumerable.call(be, ye[Se]) && ($e[ye[Se]] = be[ye[Se]]);
          }
          return $e;
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ActiveTracksReducer = void 0, ie.getContainerFormat = oe, ie.getMediaTypes = ce;
        var fe = ne(21829), le = ne(73731), se = {};
        function oe(be, pe) {
          var $e;
          if (be.activeTracks)
            return ($e = Object.values(be.activeTracks).find(function(ye) {
              var Se;
              return (Se = ye.mediaTypes) === null || Se === void 0 ? void 0 : Se.includes(pe);
            })) === null || $e === void 0 ? void 0 : $e.containerFormat;
        }
        function ce(be, pe) {
          var $e;
          return be.activeTracks && (($e = be.activeTracks[pe.adaptationSetId]) === null || $e === void 0 ? void 0 : $e.mediaTypes) || [];
        }
        function he(be, pe) {
          var $e, ye = pe.selectedRepresentationId, Se = be[ye.adaptationSetId];
          return ue(ue({}, be), (($e = {})[ye.adaptationSetId] = ue(ue({}, Se), { selectedRepresentationId: ye }), $e));
        }
        function ge(be, pe) {
          var $e, ye = pe.trackId, Se = pe.mediaTypes, we = be[ye.adaptationSetId];
          return ue(ue({}, be), (($e = {})[ye.adaptationSetId] = ue(ue({}, we), { mediaTypes: Se }), $e));
        }
        function ve(be, pe) {
          var $e, ye = pe.trackId, Se = pe.containerFormat, we = be[ye.adaptationSetId];
          return ue(ue({}, be), (($e = {})[ye.adaptationSetId] = ue(ue({}, we), { containerFormat: Se }), $e));
        }
        var me = function(be, pe) {
          var $e = be, ye = pe.adaptationSetId.adaptationSetId, Se = ($e[ye], _e($e, [typeof ye == "symbol" ? ye : ye + ""]));
          return ue({}, Se);
        };
        ie.ActiveTracksReducer = (0, fe.default)({}, ((ae = {})[le.ActiveTracksActionType.SetSelectedRepresentationId] = function(be, pe) {
          return he(be, pe.payload);
        }, ae[le.ActiveTracksActionType.SetMediaType] = function(be, pe) {
          return ge(be, pe.payload);
        }, ae[le.ActiveTracksActionType.SetContainerFormat] = function(be, pe) {
          return ve(be, pe.payload);
        }, ae[le.ActiveTracksActionType.RemoveActiveTrack] = function(be, pe) {
          var $e = pe.payload;
          return me(be, $e);
        }, ae[le.ActiveTracksActionType.ClearActiveTracks] = function() {
          return se;
        }, ae));
      }, 55486: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.removeEncryptionKey = ie.updateEncryptionKey = ie.addEncryptionKey = void 0;
        var ae = ne(15231), ue = ne(56092), _e = function(se) {
          return (0, ae.createAction)(ue.EncryptionKeyActionKey.AddEncryptionKey, se);
        };
        ie.addEncryptionKey = _e;
        var fe = function(se) {
          return (0, ae.createAction)(ue.EncryptionKeyActionKey.UpdateEncryptionKey, se);
        };
        ie.updateEncryptionKey = fe;
        var le = function(se) {
          return (0, ae.createAction)(ue.EncryptionKeyActionKey.RemoveEncryptionKey, { keyUri: se });
        };
        ie.removeEncryptionKey = le;
      }, 66137: function(ee, ie, ne) {
        var ae, ue = this && this.__assign || function() {
          return ue = Object.assign || function(oe) {
            for (var ce, he = 1, ge = arguments.length; he < ge; he++)
              for (var ve in ce = arguments[he])
                Object.prototype.hasOwnProperty.call(ce, ve) && (oe[ve] = ce[ve]);
            return oe;
          }, ue.apply(this, arguments);
        }, _e = this && this.__spreadArray || function(oe, ce, he) {
          if (he || arguments.length === 2)
            for (var ge, ve = 0, me = ce.length; ve < me; ve++)
              !ge && ve in ce || (ge || (ge = Array.prototype.slice.call(ce, 0, ve)), ge[ve] = ce[ve]);
          return oe.concat(ge || Array.prototype.slice.call(ce));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.EncryptionKeyReducer = void 0;
        var fe = ne(21829), le = ne(56092), se = [];
        ie.EncryptionKeyReducer = (0, fe.default)(se, ((ae = {})[le.EncryptionKeyActionKey.AddEncryptionKey] = function(oe, ce) {
          var he = ce.payload;
          return _e(_e([], oe, !0), [ue({}, he)], !1);
        }, ae[le.EncryptionKeyActionKey.UpdateEncryptionKey] = function(oe, ce) {
          var he = ce.payload, ge = oe.findIndex(function(be) {
            return be.uri === he.uri;
          });
          if (ge === -1)
            return oe;
          var ve = oe[ge], me = _e([], oe, !0);
          return me.splice(ge, 1, ue(ue({}, ve), he)), me;
        }, ae[le.EncryptionKeyActionKey.RemoveEncryptionKey] = function(oe, ce) {
          var he = ce.payload;
          return _e([], oe, !0).filter(function(ge) {
            return ge.uri !== he.keyUri;
          });
        }, ae));
      }, 25040: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getEncryptionKey = ie.getAllEncryptionKeys = void 0;
        var ne = function(ue) {
          return ue == null ? void 0 : ue.encryptionKeys;
        };
        ie.getAllEncryptionKeys = ne;
        var ae = function(ue, _e) {
          var fe;
          return (fe = ue == null ? void 0 : ue.encryptionKeys) === null || fe === void 0 ? void 0 : fe.find(function(le) {
            return le.uri === _e;
          });
        };
        ie.getEncryptionKey = ae;
      }, 56092: function(ee, ie) {
        var ne, ae;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.EncryptionKeyActionKey = ie.KeyLoadState = void 0, function(ue) {
          ue.Loading = "loading", ue.Loaded = "loaded", ue.Cancel = "cancel";
        }(ne || (ie.KeyLoadState = ne = {})), function(ue) {
          ue.AddEncryptionKey = "@instance/sources/@source/encryptionkey/addEncryptionKey", ue.UpdateEncryptionKey = "@instance/sources/@source/encryptionkey/updateEncryptionKey", ue.RemoveEncryptionKey = "@instance/sources/@source/encryptionkey/removeEncryptionKey";
        }(ae || (ie.EncryptionKeyActionKey = ae = {}));
      }, 71827: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.engineBitmovinSourceReducers = void 0;
        var ae = ne(82311), ue = ne(66137), _e = ne(28196), fe = ne(58211), le = ne(96280), se = ne(49233), oe = ne(28322), ce = ne(14764);
        ie.engineBitmovinSourceReducers = { manifest: _e.ManifestReducer, activeTracks: ae.ActiveTracksReducer, playingTracks: fe.PlayingTracksReducer, encryptionKeys: ue.EncryptionKeyReducer, buffer: se.BufferReducer, renderer: oe.RendererReducer, streamTimeline: ce.StreamTimelineReducer, segmentInfoMap: le.SegmentInfoMapReducer };
      }, 72788: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.periodSwitchStarted = ie.periodSwitchFinished = ie.setPlayingPeriodId = void 0;
        var ae = ne(15231), ue = ne(98086), _e = function(se) {
          return (0, ae.createAction)(ue.PlayingTracksActionKey.SetPlayingPeriodId, se);
        };
        ie.setPlayingPeriodId = _e;
        var fe = function(se) {
          return (0, ae.createAction)(ue.PlayingTracksActionKey.FinishedPeriodSwitch, se);
        };
        ie.periodSwitchFinished = fe;
        var le = function(se) {
          return (0, ae.createAction)(ue.PlayingTracksActionKey.StartedPeriodSwitch, se);
        };
        ie.periodSwitchStarted = le;
      }, 58211: function(ee, ie, ne) {
        var ae, ue = this && this.__assign || function() {
          return ue = Object.assign || function(he) {
            for (var ge, ve = 1, me = arguments.length; ve < me; ve++)
              for (var be in ge = arguments[ve])
                Object.prototype.hasOwnProperty.call(ge, be) && (he[be] = ge[be]);
            return he;
          }, ue.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.PlayingTracksReducer = ie.wasSwitchingToPeriodIdReset = ie.getPlayingTracksState = ie.getPlayingPeriodId = void 0;
        var _e = ne(21829), fe = ne(98086), le = {}, se = function(he) {
          var ge;
          return (ge = he.playingTracks) === null || ge === void 0 ? void 0 : ge.playingPeriodId;
        };
        ie.getPlayingPeriodId = se;
        var oe = function(he) {
          return he.playingTracks;
        };
        ie.getPlayingTracksState = oe;
        var ce = function(he, ge) {
          return (ge == null ? void 0 : ge.switchingToPeriodId) !== void 0 && (he == null ? void 0 : he.switchingToPeriodId) === void 0;
        };
        ie.wasSwitchingToPeriodIdReset = ce, ie.PlayingTracksReducer = (0, _e.default)(le, ((ae = {})[fe.PlayingTracksActionKey.SetPlayingPeriodId] = function(he, ge) {
          var ve = ge.payload;
          return ue(ue({}, he), { playingPeriodId: ve });
        }, ae[fe.PlayingTracksActionKey.FinishedPeriodSwitch] = function(he, ge) {
          var ve = ge.payload;
          return ue(ue({}, he), { switchingToPeriodId: he.switchingToPeriodId === ve ? void 0 : he.switchingToPeriodId });
        }, ae[fe.PlayingTracksActionKey.StartedPeriodSwitch] = function(he, ge) {
          var ve = ge.payload;
          return ue(ue({}, he), { switchingToPeriodId: ve });
        }, ae));
      }, 98086: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.PlayingTracksActionKey = void 0, function(ae) {
          ae.SetPlayingPeriodId = "@instance/sources/@source/playingTracks/setPlayingPeriodId", ae.FinishedPeriodSwitch = "@instance/sources/@source/playingTracks/periodSwitchFinished", ae.StartedPeriodSwitch = "@instance/sources/@source/playingTracks/periodSwitchStarted";
        }(ne || (ie.PlayingTracksActionKey = ne = {}));
      }, 28337: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.sourceIdentifiersSelector = ie.hasASourceStoreIdentifierChanged = void 0;
        var ne = function(ue, _e) {
          return ue.length !== _e.length || ue.some(function(fe) {
            return !_e.includes(fe);
          });
        };
        ie.hasASourceStoreIdentifierChanged = ne;
        var ae = function(ue) {
          var _e;
          return Object.keys((_e = ue.sources) !== null && _e !== void 0 ? _e : {});
        };
        ie.sourceIdentifiersSelector = ae;
      }, 41735: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.setManifestAction = _e, ie.setManifestInitializedAction = fe, ie.removeRepresentationsAction = le, ie.updateManifestAction = se, ie.updateRepresentationAction = oe, ie.updatePeriodTimingAction = ce, ie.adjustPeriodStartTimes = he, ie.setRepresentationDrmKidAction = ge, ie.updateRepresentationFailedDownloadAction = ve, ie.setRepresentationSegmentIndexAction = me, ie.setRepresentationIsLoadingAction = be, ie.setRepresentationSegmentIndexParsingErrorAction = pe, ie.setRepresentationAnchorPointAction = $e, ie.initPlaybackTimesFromIndex = ye, ie.initPlaybackTimesFromReferenceSegment = Se, ie.resetSegmentPlaybackTimes = we;
        var ae = ne(15231), ue = ne(77329);
        function _e(Pe) {
          return (0, ae.createAction)(ue.ManifestActionType.SetManifest, { manifest: Pe });
        }
        function fe(Pe) {
          return (0, ae.createAction)(ue.ManifestActionType.SetManifestInitialized, { isInitialized: Pe });
        }
        function le(Pe) {
          return (0, ae.createAction)(ue.ManifestActionType.RemoveRepresentations, { representationIds: Pe });
        }
        function se(Pe) {
          return (0, ae.createAction)(ue.ManifestActionType.UpdateManifest, Pe);
        }
        function oe(Pe) {
          return (0, ae.createAction)(ue.ManifestActionType.UpdateRepresentation, Pe);
        }
        function ce(Pe, Te) {
          return (0, ae.createAction)(ue.ManifestActionType.UpdatePeriodTiming, { periodId: Pe, timing: Te });
        }
        function he(Pe) {
          return (0, ae.createAction)(ue.ManifestActionType.AdjustPeriodStartTimes, { offset: Pe });
        }
        function ge(Pe, Te) {
          return (0, ae.createAction)(ue.ManifestActionType.SetRepresentationDrmKid, { representationId: Pe, associatedKid: Te });
        }
        function ve(Pe, Te) {
          return (0, ae.createAction)(ue.ManifestActionType.UpdateRepresentationFailedDownload, { representationId: Pe, loadFailureReason: Te });
        }
        function me(Pe, Te) {
          return (0, ae.createAction)(ue.ManifestActionType.SetRepresentationSegmentIndex, { representationId: Pe, segmentIndex: Te });
        }
        function be(Pe, Te) {
          return (0, ae.createAction)(ue.ManifestActionType.SetRepresentationIsLoading, { representationId: Pe, isLoading: Te });
        }
        function pe(Pe, Te) {
          return (0, ae.createAction)(ue.ManifestActionType.SetRepresentationSegmentIndexParsingError, { representationId: Pe, segmentIndexParsingError: Te });
        }
        function $e(Pe, Te) {
          return (0, ae.createAction)(ue.ManifestActionType.SetRepresentationAnchorPoint, { representationId: Pe, anchorPoint: Te });
        }
        function ye(Pe, Te, Ee) {
          return (0, ae.createAction)(ue.ManifestActionType.InitPlaybackTimesFromIndex, { representationId: Pe, index: Te, playbackTimeForIndex: Ee });
        }
        function Se(Pe) {
          return (0, ae.createAction)(ue.ManifestActionType.InitPlaybackTimesFromReferenceSegment, { representationId: Pe.getRepresentationId(), segmentUrl: Pe.getUrl(), segmentPlaybackTime: Pe.getPlaybackTime(), discontinuitySequenceNumber: Pe.getSegmentInfo().discontinuitySequenceNumber });
        }
        function we() {
          return (0, ae.createAction)(ue.ManifestActionType.ResetSegmentPlaybackTimes);
        }
      }, 28196: function(ee, ie, ne) {
        var ae, ue = this && this.__assign || function() {
          return ue = Object.assign || function(ke) {
            for (var Le, De = 1, Re = arguments.length; De < Re; De++)
              for (var Oe in Le = arguments[De])
                Object.prototype.hasOwnProperty.call(Le, Oe) && (ke[Oe] = Le[Oe]);
            return ke;
          }, ue.apply(this, arguments);
        }, _e = this && this.__spreadArray || function(ke, Le, De) {
          if (De || arguments.length === 2)
            for (var Re, Oe = 0, Be = Le.length; Oe < Be; Oe++)
              !Re && Oe in Le || (Re || (Re = Array.prototype.slice.call(Le, 0, Oe)), Re[Oe] = Le[Oe]);
          return ke.concat(Re || Array.prototype.slice.call(Le));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ManifestReducer = void 0;
        var fe = ne(21829), le = ne(65114), se = ne(94938), oe = ne(77329);
        function ce(ke, Le) {
          return Le.payload.manifest || ke;
        }
        function he(ke, Le) {
          return ue(ue({}, ke), { isInitialized: Le.payload.isInitialized });
        }
        function ge(ke, Le) {
          return Le.payload.representationIds.length === 0 ? ke : (0, se.removeRepresentations)(ke, Le.payload.representationIds);
        }
        function ve(ke, Le) {
          return Le.payload.offset ? ue(ue({}, ke), { Period: ke.Period.map(function(De) {
            return ue(ue({}, De), { start: De.start + Le.payload.offset });
          }) }) : ke;
        }
        function me(ke, Le) {
          if (!ke.Period)
            return ke;
          var De = Le.periodId, Re = Le.timing, Oe = ke.Period.findIndex(function(Fe) {
            return Fe._id === De;
          });
          if (Oe < 0)
            return ke;
          var Be = _e([], ke.Period, !0);
          return Be[Oe] = ue(ue({}, Be[Oe]), Re), ue(ue({}, ke), { Period: Be });
        }
        function be(ke, Le) {
          return ue(ue({}, ke), Le);
        }
        function pe(ke, Le) {
          var De, Re, Oe, Be = Le, Fe = Be._internalId;
          if (!ke.Period)
            return ke;
          var Ve = ke.Period.findIndex(function(ze) {
            return ze._id === Fe.periodId;
          }), Ke = (De = ke.Period[Ve]) === null || De === void 0 ? void 0 : De.AdaptationSet.findIndex(function(ze) {
            return ze._internalId.equals(Fe);
          }), Ze = (Oe = (Re = ke.Period[Ve]) === null || Re === void 0 ? void 0 : Re.AdaptationSet[Ke]) === null || Oe === void 0 ? void 0 : Oe.Representation.findIndex(function(ze) {
            return ze._internalId.equals(Fe);
          }), nt = ue({}, ke);
          nt.Period = _e([], nt.Period, !0), nt.Period[Ve] = ue({}, nt.Period[Ve]);
          var Qe = nt.Period[Ve];
          Qe.AdaptationSet = _e([], Qe.AdaptationSet, !0), Qe.AdaptationSet[Ke] = ue({}, Qe.AdaptationSet[Ke]);
          var qe = Qe.AdaptationSet[Ke];
          return qe.Representation = _e([], qe.Representation, !0), qe.Representation[Ze] = Be, nt;
        }
        function $e(ke, Le) {
          var De = Le.payload;
          return Ee(ke, De.representationId, { associatedKid: De.associatedKid });
        }
        function ye(ke, Le) {
          var De = Le.payload;
          return Ee(ke, De.representationId, { isLoading: De.isLoading });
        }
        function Se(ke, Le) {
          var De, Re = Le.payload, Oe = Re.representationId, Be = Re.loadFailureReason, Fe = function(Ve) {
            var Ke;
            return Ve._internalId.equals(Oe) ? Be : (Ke = Ve._hls) === null || Ke === void 0 ? void 0 : Ke.loadFailureReason;
          };
          return ue(ue({}, ke), { Period: (De = ke.Period) === null || De === void 0 ? void 0 : De.map(function(Ve) {
            var Ke;
            return ue(ue({}, Ve), { AdaptationSet: (Ke = Ve.AdaptationSet) === null || Ke === void 0 ? void 0 : Ke.map(function(Ze) {
              var nt;
              return ue(ue({}, Ze), { Representation: (nt = Ze.Representation) === null || nt === void 0 ? void 0 : nt.map(function(Qe) {
                return ue(ue({}, Qe), { _hls: ue(ue({}, Qe._hls), { loadFailureReason: Fe(Qe) }) });
              }) });
            }) });
          }) });
        }
        function we(ke, Le) {
          var De = Le.payload;
          return Ee(ke, De.representationId, { segmentIndex: De.segmentIndex });
        }
        function Pe(ke, Le) {
          var De = Le.payload;
          return Ee(ke, De.representationId, { segmentIndexParsingError: De.segmentIndexParsingError });
        }
        function Te(ke, Le) {
          var De = Le.payload;
          return Ee(ke, De.representationId, { anchorPoint: De.anchorPoint });
        }
        function Ee(ke, Le, De) {
          var Re;
          return ue(ue({}, ke), { Period: (Re = ke.Period) === null || Re === void 0 ? void 0 : Re.map(function(Oe) {
            var Be;
            return ue(ue({}, Oe), { AdaptationSet: (Be = Oe.AdaptationSet) === null || Be === void 0 ? void 0 : Be.map(function(Fe) {
              var Ve;
              return ue(ue({}, Fe), { Representation: (Ve = Fe.Representation) === null || Ve === void 0 ? void 0 : Ve.map(function(Ke) {
                return Ke._internalId.equals(Le) ? ue(ue({}, Ke), De) : Ke;
              }) });
            }) });
          }) });
        }
        function Me(ke, Le) {
          var De, Re = Le.payload, Oe = Re.representationId, Be = Re.index, Fe = Re.playbackTimeForIndex, Ve = (0, le.findRepresentation)(ke, Oe);
          return Ve ? Ee(ke, Oe, ue(ue({}, Ve), { SegmentList: (De = Ve.SegmentList) === null || De === void 0 ? void 0 : De.map(function(Ke) {
            return ue(ue({}, Ke), { SegmentURL: Ne(Ke.SegmentURL, Be, Fe) });
          }) })) : ke;
        }
        function Ae(ke, Le) {
          var De, Re = Le.payload, Oe = Re.representationId, Be = Re.segmentUrl, Fe = Re.segmentPlaybackTime, Ve = Re.discontinuitySequenceNumber, Ke = (0, le.findRepresentation)(ke, Oe);
          if (!(Ke != null && Ke.SegmentList) || Ke.SegmentList.length === 0 || ((De = Ke.SegmentList[0].SegmentURL[0]) === null || De === void 0 ? void 0 : De._playbackTime) !== void 0)
            return ke;
          var Ze = Ke.SegmentList[0].SegmentURL.findIndex(function(nt) {
            return nt._media === Be && nt._discontinuitySequenceNumber === Ve;
          });
          return Ze === -1 ? ke : Ee(ke, Oe, ue(ue({}, Ke), { SegmentList: Ke.SegmentList.map(function(nt) {
            return ue(ue({}, nt), { SegmentURL: Ne(nt.SegmentURL, Ze, Fe) });
          }) }));
        }
        function Ne(ke, Le, De) {
          var Re = _e([], ke, !0);
          return Re[Le] = ue({}, Re[Le]), Re[Le]._playbackTime = De, Ie(Re, Le), Ce(Re, Le), Re;
        }
        function Ce(ke, Le) {
          for (var De = Le + 1; De < ke.length; De++)
            ke[De] = ue({}, ke[De]), ke[De]._playbackTime = ke[De - 1]._playbackTime + ke[De - 1]._duration;
        }
        function Ie(ke, Le) {
          for (var De = Le - 1; De >= 0; De--)
            ke[De] = ue({}, ke[De]), ke[De]._playbackTime = ke[De + 1]._playbackTime - ke[De]._duration;
        }
        function xe(ke) {
          return ue(ue({}, ke), { SegmentURL: ke.SegmentURL.map(function(Le) {
            var De = ue({}, Le);
            return delete De._playbackTime, De;
          }) });
        }
        function Ue(ke) {
          return ue(ue({}, ke), { Period: ke.Period.map(function(Le) {
            return ue(ue({}, Le), { AdaptationSet: Le.AdaptationSet.map(function(De) {
              return ue(ue({}, De), { Representation: De.Representation.map(function(Re) {
                var Oe;
                return ue(ue({}, Re), { SegmentList: (Oe = Re.SegmentList) === null || Oe === void 0 ? void 0 : Oe.map(xe) });
              }) });
            }) });
          }) });
        }
        ie.ManifestReducer = (0, fe.default)({}, ((ae = {})[oe.ManifestActionType.SetManifest] = ce, ae[oe.ManifestActionType.SetManifestInitialized] = he, ae[oe.ManifestActionType.RemoveRepresentations] = ge, ae[oe.ManifestActionType.UpdateManifest] = function(ke, Le) {
          return be(ke, Le.payload);
        }, ae[oe.ManifestActionType.UpdateRepresentation] = function(ke, Le) {
          return pe(ke, Le.payload);
        }, ae[oe.ManifestActionType.UpdateRepresentationFailedDownload] = Se, ae[oe.ManifestActionType.AdjustPeriodStartTimes] = ve, ae[oe.ManifestActionType.UpdatePeriodTiming] = function(ke, Le) {
          return me(ke, Le.payload);
        }, ae[oe.ManifestActionType.SetRepresentationDrmKid] = $e, ae[oe.ManifestActionType.SetRepresentationIsLoading] = ye, ae[oe.ManifestActionType.SetRepresentationSegmentIndex] = we, ae[oe.ManifestActionType.SetRepresentationSegmentIndexParsingError] = Pe, ae[oe.ManifestActionType.SetRepresentationAnchorPoint] = Te, ae[oe.ManifestActionType.InitPlaybackTimesFromIndex] = Me, ae[oe.ManifestActionType.InitPlaybackTimesFromReferenceSegment] = Ae, ae[oe.ManifestActionType.ResetSegmentPlaybackTimes] = Ue, ae));
      }, 77874: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getManifest = void 0;
        var ne = function(ae) {
          return ae == null ? void 0 : ae.manifest;
        };
        ie.getManifest = ne;
      }, 77329: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ManifestActionType = void 0, function(ae) {
          ae.SetManifest = "@instance/manifest/setmanifest", ae.SetManifestInitialized = "@instance/manifest/setmanifestinitialized", ae.RemoveRepresentations = "@instance/manifest/removerepresentations", ae.UpdateManifest = "@instance/manifest/updatemanifest", ae.UpdateRepresentation = "@instance/manifest/updaterepresentation", ae.UpdatePeriodTiming = "@instance/manifest/updateperiodtiming", ae.AdjustPeriodStartTimes = "@instance/manifest/adjustperiodstarttimes", ae.SetRepresentationDrmKid = "@instance/manifest/setrepresentationdrmkid", ae.UpdateRepresentationFailedDownload = "@instance/manifest/setrepresentationfaileddownload", ae.SetRepresentationSegmentIndex = "@instance/manifest/setrepresentationsegmentindex", ae.SetRepresentationIsLoading = "@instance/manifest/setrepresentationisloading", ae.SetRepresentationSegmentIndexParsingError = "@instance/manifest/setrepresentationsegmentindexparsingerror", ae.SetRepresentationAnchorPoint = "@instance/manifest/setrepresentationacnhorpoint", ae.InitPlaybackTimesFromIndex = "@instance/manifest/initplaybacktimesfromindex", ae.InitPlaybackTimesFromReferenceSegment = "@instance/manifest/initplaybacktimesfromreferencesegment", ae.ResetSegmentPlaybackTimes = "@instance/manifest/resetsegmentplaybacktimes";
        }(ne || (ie.ManifestActionType = ne = {}));
      }, 96280: function(ee, ie, ne) {
        var ae, ue = this && this.__assign || function() {
          return ue = Object.assign || function(ge) {
            for (var ve, me = 1, be = arguments.length; me < be; me++)
              for (var pe in ve = arguments[me])
                Object.prototype.hasOwnProperty.call(ve, pe) && (ge[pe] = ve[pe]);
            return ge;
          }, ue.apply(this, arguments);
        }, _e = this && this.__spreadArray || function(ge, ve, me) {
          if (me || arguments.length === 2)
            for (var be, pe = 0, $e = ve.length; pe < $e; pe++)
              !be && pe in ve || (be || (be = Array.prototype.slice.call(ve, 0, pe)), be[pe] = ve[pe]);
          return ge.concat(be || Array.prototype.slice.call(ve));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentInfoMapReducer = void 0;
        var fe = ne(21829), le = ne(41661), se = ne(85157), oe = {};
        function ce(ge, ve, me) {
          var be;
          return ue(ue({}, ge), ((be = {})[ve] = me, be));
        }
        function he(ge, ve, me) {
          var be;
          if (!ge[ve] || me.segmentInfos.length === 0)
            return ce(ge, ve, me);
          var pe = ge[ve].segmentInfos, $e = pe.findIndex(function(Ee) {
            return (0, le.areSegmentsIdentical)(Ee, me.segmentInfos[0]);
          });
          if ($e === -1)
            return ce(ge, ve, me);
          var ye, Se = pe.length - $e, we = me.segmentInfos.length - Se;
          if ($e !== 0 || we !== 0) {
            var Pe = we > 0 ? me.segmentInfos.slice(-we) : [];
            ye = _e(_e([], pe.slice($e), !0), Pe, !0);
          } else
            ye = pe;
          var Te = ue(ue(ue({}, ge[ve]), me), { segmentInfos: ye });
          return ue(ue({}, ge), ((be = {})[ve] = Te, be));
        }
        ie.SegmentInfoMapReducer = (0, fe.default)(oe, ((ae = {})[se.SegmentInfoMapActionType.SetSegmentInfos] = function(ge, ve) {
          return ce(ge, ve.payload.qualityPath, ve.payload.updatedEntry);
        }, ae[se.SegmentInfoMapActionType.UpdateSegmentInfos] = function(ge, ve) {
          return he(ge, ve.payload.qualityPath, ve.payload.updatedEntry);
        }, ae));
      }, 93326: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getMostRecentlyRefreshedQuality = ie.getSegmentInfos = ie.getSegmentMapEntry = void 0;
        var ne = function(_e, fe) {
          return _e == null ? void 0 : _e.segmentInfoMap[fe];
        };
        ie.getSegmentMapEntry = ne;
        var ae = function(_e, fe) {
          var le, se;
          return (se = (le = (0, ie.getSegmentMapEntry)(_e, fe)) === null || le === void 0 ? void 0 : le.segmentInfos) !== null && se !== void 0 ? se : [];
        };
        ie.getSegmentInfos = ae;
        var ue = function(_e) {
          if (_e)
            return Object.values(_e.segmentInfoMap).filter(function(fe) {
              return fe.qualityInfo.lastUpdateTimestamp != null;
            }).sort(function(fe, le) {
              var se = fe.qualityInfo.lastUpdateTimestamp;
              return le.qualityInfo.lastUpdateTimestamp - se;
            })[0];
        };
        ie.getMostRecentlyRefreshedQuality = ue;
      }, 85157: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SegmentInfoMapActionType = void 0, function(ae) {
          ae.SetSegmentInfos = "@instance/sources/@source/playback/setSegmentInfos", ae.UpdateSegmentInfos = "@instance/sources/@source/playback/updateSegmentInfos";
        }(ne || (ie.SegmentInfoMapActionType = ne = {}));
      }, 16280: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.mergeBufferBlockTimeRanges = fe, ie.excludeBufferBlockTimeRange = ce, ie.segmentToBufferBlockTimeRange = he;
        var ae = ne(92712), ue = 0.1;
        function _e(ve, me, be) {
          return { start: (0, ae.rangeFixedValue)(ve), end: (0, ae.rangeFixedValue)(me), bufferBlockId: be };
        }
        function fe() {
          for (var ve = [], me = 0; me < arguments.length; me++)
            ve[me] = arguments[me];
          var be = ge(ve);
          return Object.keys(be).flatMap(function(pe) {
            return ae.BufferRangeHelper.mergeRanges(be[pe], ue);
          });
        }
        function le(ve, me) {
          return [_e(ve.start, me.start, ve.bufferBlockId), _e(me.end, ve.end, ve.bufferBlockId)];
        }
        function se(ve, me) {
          return _e(ve.start >= me.start ? me.end : ve.start, ve.end > me.end ? ve.end : me.start, ve.bufferBlockId);
        }
        function oe(ve, me) {
          var be = [];
          return ve.forEach(function(pe) {
            (0, ae.areDisjoint)(pe, me) ? be.push(pe) : (0, ae.isSurrounding)(pe, me) ? be.push.apply(be, le(pe, me)) : (0, ae.isFullyIncluded)(pe, me) || be.push(se(pe, me));
          }), be.filter(function(pe) {
            return pe.end - pe.start >= ue;
          });
        }
        function ce(ve, me) {
          var be = me.bufferBlockId, pe = ge(ve.map(function(Se) {
            return _e(Se.start, Se.end, Se.bufferBlockId);
          })), $e = pe[be];
          if (!($e != null && $e.length))
            return ve;
          var ye = oe($e, me);
          return pe[be] = ae.BufferRangeHelper.mergeRanges(ye, ue), Object.keys(pe).flatMap(function(Se) {
            return pe[Se];
          });
        }
        function he(ve) {
          var me, be = (me = ve.getBufferBlockId()) !== null && me !== void 0 ? me : 1 / 0, pe = ve.getPlaybackTime();
          return _e(pe, pe + ve.getDuration(), be);
        }
        function ge(ve) {
          var me = {};
          return ve.forEach(function(be) {
            me[be.bufferBlockId] || (me[be.bufferBlockId] = []), me[be.bufferBlockId].push(be);
          }), me;
        }
      }, 49233: function(ee, ie, ne) {
        var ae, ue = this && this.__assign || function() {
          return ue = Object.assign || function(Se) {
            for (var we, Pe = 1, Te = arguments.length; Pe < Te; Pe++)
              for (var Ee in we = arguments[Pe])
                Object.prototype.hasOwnProperty.call(we, Ee) && (Se[Ee] = we[Ee]);
            return Se;
          }, ue.apply(this, arguments);
        }, _e = this && this.__spreadArray || function(Se, we, Pe) {
          if (Pe || arguments.length === 2)
            for (var Te, Ee = 0, Me = we.length; Ee < Me; Ee++)
              !Te && Ee in we || (Te || (Te = Array.prototype.slice.call(we, 0, Ee)), Te[Ee] = we[Ee]);
          return Se.concat(Te || Array.prototype.slice.call(we));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.BufferReducer = void 0;
        var fe = ne(92712), le = ne(21829), se = ne(18434), oe = ne(16280);
        function ce() {
          return { isLoadingRangeFinished: !1, isBufferBlockSwitchOngoing: !1, isTimestampRollingOver: !1, bufferStateMap: {} };
        }
        function he(Se, we) {
          var Pe, Te = we.payload;
          return ue(ue({}, Se), { bufferStateMap: ue(ue({}, Se.bufferStateMap), (Pe = {}, Pe[Te.mimeType] = ue(ue({}, Se.bufferStateMap[Te.mimeType]), { rendererRanges: Te.ranges }), Pe)) });
        }
        function ge(Se, we) {
          var Pe, Te = we.payload;
          return ue(ue({}, Se), { bufferStateMap: ue(ue({}, Se.bufferStateMap), (Pe = {}, Pe[Te.mimeType] = ue(ue({}, Se.bufferStateMap[Te.mimeType]), { maxBufferSize: Te.maxBufferSize }), Pe)) });
        }
        function ve(Se, we) {
          var Pe = we.payload;
          return ue(ue({}, Se), { isBufferBlockSwitchOngoing: Pe.isOngoing });
        }
        function me(Se, we) {
          var Pe = we.payload;
          return ue(ue({}, Se), { isTimestampRollingOver: Pe.isRollingOver });
        }
        function be(Se, we) {
          var Pe, Te, Ee, Me = we.payload, Ae = Me.mimeType, Ne = Me.range;
          if (!Ae)
            return Se;
          var Ce = (Ee = (Te = Se.bufferStateMap[Ae]) === null || Te === void 0 ? void 0 : Te.loadedRanges) !== null && Ee !== void 0 ? Ee : [];
          return Ce.some(function(Ie) {
            return (0, fe.isFullyIncluded)(Ne, Ie);
          }) ? Se : ue(ue({}, Se), { bufferStateMap: ue(ue({}, Se.bufferStateMap), (Pe = {}, Pe[Ae] = ue(ue({}, Se.bufferStateMap[Ae]), { loadedRanges: oe.mergeBufferBlockTimeRanges.apply(void 0, _e(_e([], Ce, !1), [Ne], !1)) }), Pe)) });
        }
        function pe(Se, we) {
          var Pe, Te, Ee, Me = we.payload, Ae = Me.mimeType, Ne = Me.range;
          if (!Ae)
            return Se;
          var Ce = (Ee = (Te = Se.bufferStateMap[Ae]) === null || Te === void 0 ? void 0 : Te.loadedRanges) !== null && Ee !== void 0 ? Ee : [];
          return Ce.every(function(Ie) {
            return !(0, fe.isOverlapping)(Ne, Ie);
          }) ? Se : ue(ue({}, Se), { bufferStateMap: ue(ue({}, Se.bufferStateMap), (Pe = {}, Pe[Ae] = ue(ue({}, Se.bufferStateMap[Ae]), { loadedRanges: (0, oe.excludeBufferBlockTimeRange)(Ce, Ne) }), Pe)) });
        }
        function $e(Se, we) {
          var Pe, Te, Ee, Me = we.payload.mimeType;
          if (Me === void 0) {
            if (Se === void 0)
              return ce();
            var Ae = ue(ue({}, Se), { bufferStateMap: ue({}, Se.bufferStateMap) });
            return Object.keys(Ae.bufferStateMap).forEach(function(Ne) {
              Ae.bufferStateMap[Ne] = ue(ue({}, Ae.bufferStateMap[Ne]), { loadedRanges: [] });
            }), Ae;
          }
          return ((Ee = (Te = Se.bufferStateMap[Me]) === null || Te === void 0 ? void 0 : Te.loadedRanges) !== null && Ee !== void 0 ? Ee : []).length > 0 ? ue(ue({}, Se), { bufferStateMap: ue(ue({}, Se.bufferStateMap), (Pe = {}, Pe[Me] = ue(ue({}, Se.bufferStateMap[Me]), { loadedRanges: [] }), Pe)) }) : Se;
        }
        function ye(Se, we) {
          var Pe = we.payload.isFinished;
          return Pe !== Se.isLoadingRangeFinished ? ue(ue({}, Se), { isLoadingRangeFinished: Pe }) : Se;
        }
        ie.BufferReducer = (0, le.default)(ce(), ((ae = {})[se.BufferActionType.SetBufferMaxSize] = ge, ae[se.BufferActionType.SetRendererRanges] = he, ae[se.BufferActionType.SetBufferBlockSwitchOngoing] = ve, ae[se.BufferActionType.SetTimestampRollingOver] = me, ae[se.BufferActionType.AddLoadedRange] = be, ae[se.BufferActionType.RemoveLoadedRange] = pe, ae[se.BufferActionType.ResetLoadedRanges] = $e, ae[se.BufferActionType.SetLoadingRangeFinished] = ye, ae));
      }, 68294: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getDrmUsedKeySystem = ie.getDrmKeyIdsWithErrors = ie.getDrmState = void 0;
        var ne = function(_e) {
          return _e == null ? void 0 : _e.drm;
        };
        ie.getDrmState = ne;
        var ae = function(_e) {
          var fe, le;
          return (le = (fe = _e.drm) === null || fe === void 0 ? void 0 : fe.keyIdsWithErrors) !== null && le !== void 0 ? le : [];
        };
        ie.getDrmKeyIdsWithErrors = ae;
        var ue = function(_e) {
          var fe;
          return ((fe = (0, ie.getDrmState)(_e)) === null || fe === void 0 ? void 0 : fe.usedKeySystem) || { kind: null, uid: null };
        };
        ie.getDrmUsedKeySystem = ue;
      }, 28322: function(ee, ie, ne) {
        var ae, ue = this && this.__assign || function() {
          return ue = Object.assign || function(oe) {
            for (var ce, he = 1, ge = arguments.length; he < ge; he++)
              for (var ve in ce = arguments[he])
                Object.prototype.hasOwnProperty.call(ce, ve) && (oe[ve] = ce[ve]);
            return oe;
          }, ue.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.RendererReducer = void 0;
        var _e = ne(21829), fe = ne(73448);
        function le() {
          return { mseObjectUrl: "" };
        }
        function se(oe, ce) {
          var he = ce.payload;
          return ue(ue({}, oe), { mseObjectUrl: he.url });
        }
        ie.RendererReducer = (0, _e.default)(le(), ((ae = {})[fe.RendererActionType.SetMseObjectUrl] = se, ae));
      }, 59839: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.addStreamTimeRange = _e, ie.removeStreamTimeRange = fe, ie.resetStreamTimeline = le;
        var ae = ne(15231), ue = ne(1590);
        function _e(se, oe, ce) {
          var he = { start: oe.start, end: oe.end, type: ce };
          return (0, ae.createAction)(ue.StreamTimelineActionType.StreamTimeRangeAdd, { mimeType: se, streamTimeRange: he });
        }
        function fe(se, oe, ce) {
          return (0, ae.createAction)(ue.StreamTimelineActionType.StreamTimeRangeRemove, { mimeType: se, range: oe, type: ce });
        }
        function le(se) {
          return (0, ae.createAction)(ue.StreamTimelineActionType.StreamTimelineReset, se);
        }
      }, 14764: function(ee, ie, ne) {
        var ae, ue = this && this.__assign || function() {
          return ue = Object.assign || function(be) {
            for (var pe, $e = 1, ye = arguments.length; $e < ye; $e++)
              for (var Se in pe = arguments[$e])
                Object.prototype.hasOwnProperty.call(pe, Se) && (be[Se] = pe[Se]);
            return be;
          }, ue.apply(this, arguments);
        }, _e = this && this.__spreadArray || function(be, pe, $e) {
          if ($e || arguments.length === 2)
            for (var ye, Se = 0, we = pe.length; Se < we; Se++)
              !ye && Se in pe || (ye || (ye = Array.prototype.slice.call(pe, 0, Se)), ye[Se] = pe[Se]);
          return be.concat(ye || Array.prototype.slice.call(pe));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getStreamTimeline = ie.StreamTimelineReducer = void 0;
        var fe = ne(92712), le = ne(21829), se = ne(22645), oe = ne(1590), ce = {};
        function he(be, pe, $e) {
          var ye, Se = be[pe] ? _e([], be[pe], !0) : [];
          return ue(ue({}, be), ((ye = {})[pe] = (0, se.addStreamTimeRangeToTimeline)(Se, $e), ye));
        }
        function ge(be, pe, $e, ye) {
          var Se;
          if (!be[pe])
            return be;
          var we = _e([], be[pe], !0);
          if (ye) {
            var Pe = ue(ue({}, $e), { type: ye });
            we = (0, se.removeStreamTimeRangeFromTimeline)(we, Pe);
          } else
            we = fe.BufferRangeHelper.excludeTimeRange(we, $e);
          return ue(ue({}, be), ((Se = {})[pe] = we, Se));
        }
        function ve(be, pe) {
          var $e;
          return pe ? ue(ue({}, be), (($e = {})[pe] = [], $e)) : ce;
        }
        ie.StreamTimelineReducer = (0, le.default)(ce, ((ae = {})[oe.StreamTimelineActionType.StreamTimeRangeAdd] = function(be, pe) {
          return he(be, pe.payload.mimeType, pe.payload.streamTimeRange);
        }, ae[oe.StreamTimelineActionType.StreamTimeRangeRemove] = function(be, pe) {
          return ge(be, pe.payload.mimeType, pe.payload.range, pe.payload.type);
        }, ae[oe.StreamTimelineActionType.StreamTimelineReset] = function(be, pe) {
          return ve(be, pe.payload);
        }, ae));
        var me = function(be) {
          var pe;
          return (pe = be == null ? void 0 : be.streamTimeline) !== null && pe !== void 0 ? pe : {};
        };
        ie.getStreamTimeline = me;
      }, 1590: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.StreamTimelineActionType = void 0, function(ae) {
          ae.StreamTimelineReset = "@instance/source/stream/streamtimelinereset", ae.StreamTimeRangeRemove = "@instance/source/stream/streamtimerangeremove", ae.StreamTimeRangeAdd = "@instance/source/stream/streamtimerangeadd";
        }(ne || (ie.StreamTimelineActionType = ne = {}));
      }, 22645: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.StreamTimeRangeType = void 0, ie.addStreamTimeRangeToTimeline = le, ie.removeStreamTimeRangeFromTimeline = se, ie.getTrackIdentifier = ce;
        var ae, ue = ne(92712), _e = ne(87326), fe = ne(79814);
        function le(he, ge) {
          var ve = he.filter(function(be) {
            return be.type === ge.type;
          }).concat(ge), me = ue.BufferRangeHelper.mergeRanges(ve, _e.DefaultSettings.GAP_TOLERANCE);
          return he = he.filter(function(be) {
            return be.type !== ge.type;
          }), me.forEach(function(be) {
            he = oe(he, be, function(pe) {
              return pe.start > be.start;
            });
          }), he;
        }
        function se(he, ge) {
          var ve = he.filter(function(be) {
            return be.type === ge.type;
          }), me = ue.BufferRangeHelper.excludeTimeRange(ve, ge);
          return he = he.filter(function(be) {
            return be.type !== ge.type;
          }), me.forEach(function(be) {
            be.end - be.start > _e.DefaultSettings.GAP_TOLERANCE && (he = oe(he, be, function(pe) {
              return pe.start > be.start;
            }));
          }), he;
        }
        function oe(he, ge, ve) {
          var me = he.findIndex(ve);
          return me < 0 ? he.push(ge) : he.splice(me, 0, ge), he;
        }
        function ce(he) {
          var ge = he.mimeType, ve = he.internalRepresentationId;
          return fe.MimeTypeHelper.isSubtitle(ge) ? "".concat(ge, "/").concat(ve.adaptationSetId) : ge;
        }
        (function(he) {
          he.Loading = "loading", he.Failed = "failed";
        })(ae || (ie.StreamTimeRangeType = ae = {}));
      }, 64330: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SynchronizedTimeService = void 0;
        var ae = ne(331), ue = ne(77118), _e = ne(13127), fe = ne(89010), le = function() {
          function se(oe, ce) {
            this.context = oe, this.sourceContext = ce, this.timeDifferenceMs = 0;
            var he = new fe.HttpHeadTimeProvider(this.context, new _e.ISO8601TimeDecoder()), ge = new fe.HttpGetTimeProvider(this.context, new _e.XSDateTimeDecoder()), ve = new fe.HttpGetTimeProvider(this.context, new _e.ISO8601TimeDecoder()), me = new fe.StringTimeProvider(new _e.XSDateTimeDecoder());
            this.serverTimeProviders = { "urn:mpeg:dash:utc:http-head:2012": he, "urn:mpeg:dash:utc:http-head:2014": he, "urn:mpeg:dash:utc:http-xsdate:2012": ge, "urn:mpeg:dash:utc:http-xsdate:2014": ge, "urn:mpeg:dash:utc:http-iso:2012": ve, "urn:mpeg:dash:utc:http-iso:2014": ve, "urn:mpeg:dash:utc:direct:2012": me, "urn:mpeg:dash:utc:direct:2014": me }, this.synchronizeWithConfiguredServer();
          }
          return se.prototype.synchronizeWithConfiguredServer = function() {
            var oe = (0, ue.getUtcTimingSources)(this.context.config, this.sourceContext.source);
            oe.length > 0 && this.synchronizeWithServer(oe);
          }, se.prototype.getTimeDifference = function() {
            return this.timeDifferenceMs;
          }, se.prototype.requestServerTime = function(oe) {
            var ce = this, he = oe.shift();
            if (!he)
              return Promise.reject(new Error("No time source left to try"));
            if (!this.serverTimeProviders[he.schemeIdUri])
              return this.context.logger.debug("UTCTiming scheme ".concat(he.schemeIdUri, " is not supported.")), this.requestServerTime(oe);
            this.currentServerTimeProvider = this.serverTimeProviders[he.schemeIdUri];
            var ge = Date.now();
            return this.currentServerTimeProvider.requestTime(he.value).then(function(ve) {
              return ve + (Date.now() - ge) / 2;
            }).catch(function() {
              return ce.context.logger.debug("UTCTiming scheme ".concat(he.schemeIdUri, " resulted in an error")), ce.requestServerTime(oe);
            });
          }, se.prototype.synchronizeWithServer = function(oe, ce) {
            var he = this;
            return ce === void 0 && (ce = 0), this.driftPromise || (this.driftPromise = this.requestServerTime(oe).then(function(ge) {
              he.currentServerTimeProvider = void 0, he.timeDifferenceMs = ge + (0, ae.toMilliSeconds)(ce) - Date.now(), he.context.logger.debug("Synchronized client time with time server - drift: ".concat((0, ae.toSeconds)(he.timeDifferenceMs), "s"));
            }).catch(function() {
              he.context.logger.debug("Synchronizing client time with time server unsuccessful");
            })), this.driftPromise;
          }, se.prototype.getSynchronizationPromise = function() {
            return this.driftPromise;
          }, se.prototype.reset = function() {
            this.timeDifferenceMs = 0, this.driftPromise = void 0, this.currentServerTimeProvider && (this.currentServerTimeProvider.cancelRequest(), this.currentServerTimeProvider = void 0);
          }, se.prototype.dispose = function() {
            this.reset();
          }, se;
        }();
        ie.SynchronizedTimeService = le;
      }, 13127: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.XSDateTimeDecoder = ie.ISO8601TimeDecoder = void 0;
        var ne = function() {
          function ue() {
          }
          return ue.prototype.decode = function(_e) {
            return Date.parse(_e);
          }, ue;
        }();
        ie.ISO8601TimeDecoder = ne;
        var ae = function() {
          function ue() {
          }
          return ue.prototype.decode = function(_e) {
            var fe = Date.parse(_e);
            if (isNaN(fe)) {
              var le = ue.DATETIME_REGEX.exec(_e);
              if (!le)
                return NaN;
              var se = Date.UTC(parseInt(le[1], 10), parseInt(le[2], 10) - 1, parseInt(le[3], 10), parseInt(le[4], 10), parseInt(le[5], 10), le[6] && parseInt(le[6], 10) || 0, le[7] && 1e3 * parseFloat(le[7]) || 0);
              if (le[9] && le[10]) {
                var oe = 60 * parseInt(le[9], 10) + parseInt(le[10], 10);
                se += (le[8] === "+" ? -1 : 1) * oe * 60 * 1e3;
              }
              return new Date(se).getTime();
            }
            return fe;
          }, ue.DATETIME_REGEX = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d*)(\.\d*)?)?(?:([+-])(\d{2}):(\d{2}))?/, ue;
        }();
        ie.XSDateTimeDecoder = ae;
      }, 89010: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var he = function(ge, ve) {
            return he = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(me, be) {
              me.__proto__ = be;
            } || function(me, be) {
              for (var pe in be)
                Object.prototype.hasOwnProperty.call(be, pe) && (me[pe] = be[pe]);
            }, he(ge, ve);
          };
          return function(ge, ve) {
            if (typeof ve != "function" && ve !== null)
              throw new TypeError("Class extends value " + String(ve) + " is not a constructor or null");
            function me() {
              this.constructor = ge;
            }
            he(ge, ve), ge.prototype = ve === null ? Object.create(ve) : (me.prototype = ve.prototype, new me());
          };
        }();
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.StringTimeProvider = ie.HttpHeadTimeProvider = ie.HttpGetTimeProvider = ie.HttpTimeProvider = ie.ServerTimeProvider = void 0;
        var ue = ne(88005), _e = ne(67345), fe = function() {
          function he(ge) {
            this.timeDecoder = ge;
          }
          return he;
        }();
        ie.ServerTimeProvider = fe;
        var le = function(he) {
          function ge(ve, me) {
            var be = he.call(this, me) || this;
            return be.context = ve, be;
          }
          return ae(ge, he), ge.prototype.sendSingleRequest = function(ve) {
            var me = this, be = ve.shift();
            return be ? (this.currentContentLoader = new ue.DefaultContentLoader(this.context, { requestType: _e.HttpRequestType.TIME_SYNC, maxRetries: 1 }), this.currentContentLoader.load(be, this.requestMethod).then(function(pe) {
              var $e = me.timeDecoder.decode(me.processResponse(pe));
              return me.currentContentLoader = void 0, isNaN($e) ? Promise.reject(new Error("Failed to decode time")) : Promise.resolve($e);
            }).catch(function(pe) {
              return me.context.logger.debug("could not load UTC time url", pe), me.sendSingleRequest(ve);
            })) : Promise.reject(new Error("No time source left to try"));
          }, ge.prototype.requestTime = function(ve) {
            var me = this, be = ve.match(/\S+/g);
            return be ? this.sendSingleRequest(be).then(function(pe) {
              return me.currentContentLoader = void 0, pe;
            }) : Promise.reject(new Error("No time source left to try"));
          }, ge.prototype.cancelRequest = function() {
            this.currentContentLoader && this.currentContentLoader.cancel();
          }, ge;
        }(fe);
        ie.HttpTimeProvider = le;
        var se = function(he) {
          function ge(ve, me) {
            var be = he.call(this, ve, me) || this;
            return be.requestMethod = _e.HttpRequestMethod.GET, be;
          }
          return ae(ge, he), ge.prototype.processResponse = function(ve) {
            return ve.body;
          }, ge;
        }(le);
        ie.HttpGetTimeProvider = se;
        var oe = function(he) {
          function ge(ve, me) {
            var be = he.call(this, ve, me) || this;
            return be.requestMethod = _e.HttpRequestMethod.HEAD, be;
          }
          return ae(ge, he), ge.prototype.processResponse = function(ve) {
            var me = Object.keys(ve.headers).find(function(be) {
              return be.toLocaleLowerCase() === "date";
            });
            return me && ve.headers[me] || "";
          }, ge;
        }(se);
        ie.HttpHeadTimeProvider = oe;
        var ce = function(he) {
          function ge() {
            return he !== null && he.apply(this, arguments) || this;
          }
          return ae(ge, he), ge.prototype.requestTime = function(ve) {
            var me = this.timeDecoder.decode(ve);
            return isNaN(me) ? Promise.reject(new Error("Failed to decode time")) : Promise.resolve(me);
          }, ge.prototype.cancelRequest = function() {
          }, ge;
        }(fe);
        ie.StringTimeProvider = ce;
      }, 77118: function(ee, ie, ne) {
        var ae = this && this.__spreadArray || function(se, oe, ce) {
          if (ce || arguments.length === 2)
            for (var he, ge = 0, ve = oe.length; ge < ve; ge++)
              !he && ge in oe || (he || (he = Array.prototype.slice.call(oe, 0, ge)), he[ge] = oe[ge]);
          return se.concat(he || Array.prototype.slice.call(oe));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getUtcTimingSources = _e;
        var ue = ne(25226);
        function _e(se, oe) {
          var ce = [];
          return le(se, oe).forEach(function(he) {
            var ge = fe(he.method);
            ge && ce.push({ schemeIdUri: ge, value: he.serverUrl });
          }), ce;
        }
        function fe(se) {
          switch (se) {
            case ue.LiveSynchronizationMethod.HttpHead:
              return "urn:mpeg:dash:utc:http-head:2014";
            case ue.LiveSynchronizationMethod.HttpXsDate:
              return "urn:mpeg:dash:utc:http-xsdate:2014";
            case ue.LiveSynchronizationMethod.HttpIso:
              return "urn:mpeg:dash:utc:http-iso:2014";
            default:
              return;
          }
        }
        function le(se, oe) {
          var ce, he, ge = ((ce = se.live) === null || ce === void 0 ? void 0 : ce.synchronization) || [], ve = ((he = oe.live) === null || he === void 0 ? void 0 : he.synchronization) || [];
          return ae(ae([], ge, !0), ve.filter(function(me) {
            return !ge.some(function(be) {
              return be.method === me.method;
            });
          }), !0);
        }
      }, 75498: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.areAudioMimeCodecsCompatible = ue, ie.hasContentProtection = _e;
        var ae = ne(42283);
        function ue(fe, le) {
          return fe.mimeType === le.mimeType && ae.CodecStringHelper.canSwitchBetweenAudioCodecs(fe.codec, le.codec);
        }
        function _e(fe, le) {
          return fe === void 0 && (fe = []), le === void 0 && (le = []), fe.length === 0 && le.length === 0 || fe.length > 0 && le.length > 0;
        }
      }, 9827: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.findSegmentUrlIndexWithinSegmentList = ue, ie.matchesMediaUrl = _e;
        var ae = ne(86865);
        function ue(fe, le) {
          return le.findIndex(function(se) {
            var oe = fe.discontinuitySequenceNumber === se._discontinuitySequenceNumber, ce = _e(fe.url, se._media), he = (0, ae.compareValues)(fe.byteRange, se._byteRange);
            return oe && ce && he;
          });
        }
        function _e(fe, le) {
          return fe.endsWith(le) || fe.split("?")[0].endsWith(le);
        }
      }, 37702: function(ee, ie) {
        function ne(ue) {
          var _e = [];
          return ue.forEach(function(fe) {
            _e.push(fe);
          }), _e;
        }
        function ae(ue) {
          var _e = [];
          return ue.forEach(function(fe, le) {
            _e.push(le);
          }), _e;
        }
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getValues = ne, ie.getKeys = ae;
      }, 40392: function(ee, ie) {
        function ne(ae) {
          return 8 * ae;
        }
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.bytesToBits = ne;
      }, 87062: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.isLowLatencyConfigured = ue;
        var ae = ne(18665);
        function ue(_e) {
          var fe = _e.serviceManager.get(ae.ServiceName.LiveLatencyService);
          return (fe == null ? void 0 : fe.isConfigured()) || !1;
        }
      }, 93109: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.isPlayingLowLatencyHls = le;
        var ae = ne(27279), ue = ne(91520), _e = ne(16368), fe = ne(87062);
        function le(se) {
          var oe;
          if (!(0, fe.isLowLatencyConfigured)(se) || !se.settings.LL_HLS)
            return !1;
          var ce = (0, ae.getSourceState)(se);
          if (!ce)
            return !1;
          var he = ue.ModuleManager.get(_e.ModuleName.HLS, !1);
          if (!he)
            return !1;
          var ge = he.selectors, ve = ge.getHlsState, me = ge.getIsLowLatencyPlaylist, be = ve(ce);
          return !!be && (oe = me(be)) !== null && oe !== void 0 && oe;
        }
      } }, function(ee) {
        return function(ie) {
          return ee(ee.s = ie);
        }(44910);
      }]);
    });
  })();
})(bitmovinplayerEngineBitmovin);
var bitmovinplayerEngineBitmovinExports = bitmovinplayerEngineBitmovin.exports;
const BitmovinEngineModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerEngineBitmovinExports);
var bitmovinplayerEngineNative = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ie) {
      re.exports = ie();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[855], { 77117: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.AbstractHlsManifestController = void 0;
        var ae, ue, _e = ne(18665), fe = ne(62510), le = ne(63331), se = ne(54861), oe = ne(489), ce = ne(3941), he = ne(331), ge = ne(54838), ve = ne(91520), me = ne(16368), be = ne(76250);
        (function(Pe) {
          Pe.CueTag = "cueTag", Pe.Scte35 = "scte35", Pe.DateRange = "dateRange", Pe.CustomTags = "customTags";
        })(ae || (ae = {}));
        var pe = `#EXTM3U
#EXT-X-STREAM-INF:PROGRAM-ID=1,BANDWIDTH=100000
$VARIANT$
`, $e = function() {
          function Pe(Te) {
            var Ee, Me = this;
            this.context = Te, this.discontinuitySequences = [], this.onManifestMetadata = function(Ae) {
              if (Ae.hasOwnProperty("metadata")) {
                var Ne = { metadataType: Ae.metadataType.toUpperCase(), metadata: Ae.metadata };
                (Ae.start || Ae.start === 0) && (Ne.start = Ae.start), Ae.end && (Ne.end = Ae.end), Me.context.eventHandler.dispatchEvent(fe.PlayerEvent.Metadata, Ne);
              }
            }, this.onTimeChangedHandler = function(Ae) {
              var Ne = Me.segmentTimelineController.getPlayingSegment(Ae.relativeTime || Ae.time);
              Ne && !Ne.consumed && (Ne.consumed = !0, Me.triggerMetadata(Ne), Me.triggerSegmentPlayback(Ne));
            }, this.onTimeShiftedHandler = function() {
              Me.segmentTimelineController.reset();
            }, this.onSeeked = function() {
              Me.segmentTimelineController.reset();
            }, this.registerVariantPlaylist = function(Ae) {
              var Ne, Ce = Me.parsePlaylist(Ae.body), Ie = (Ne = Me.parsedManifest.playlists) === null || Ne === void 0 ? void 0 : Ne.find(function(Be) {
                return Ae.url.includes(Be.uri);
              });
              if (Me.isValidVariantPlaylist(Ce) && Ie) {
                var xe = function(Be) {
                  var Fe, Ve;
                  return (Ve = (Fe = Me.parsedManifest.media) === null || Fe === void 0 ? void 0 : Fe.some(function(Ke) {
                    var Ze;
                    return (Ze = Ke.attributes.URI) === null || Ze === void 0 ? void 0 : Ze.includes(Be);
                  })) !== null && Ve !== void 0 && Ve;
                }, Ue = function(Be) {
                  var Fe, Ve;
                  return (Ve = (Fe = Be.playlists) === null || Fe === void 0 ? void 0 : Fe.every(function(Ke) {
                    return xe(Ke.uri);
                  })) !== null && Ve !== void 0 && Ve;
                }, ke = function(Be) {
                  var Fe, Ve;
                  return (Ve = (Fe = Me.parsedManifest.playlists) === null || Fe === void 0 ? void 0 : Fe.some(function(Ke) {
                    return Be.uri.includes(Ke.uri) && !xe(Be.uri);
                  })) !== null && Ve !== void 0 && Ve;
                };
                if (ke(Ie) || Ue(Me.parsedManifest)) {
                  Me.segmentTimelineController.switchTimeline(Ie.id), ue.extrapolateProgramDateTime(Ce.segments), Me.discontinuitySequences = ue.createDiscontinuitySequences(Ce, Me.discontinuitySequences);
                  var Le = we(Ce, Ie.id, Me.config);
                  Me.metadataParsedService.expirationTimeInSeconds = Me.segmentTimelineController.updateTimeline(Ie.id, Le);
                  var De = Me.segmentTimelineController.getCurrentTimeline();
                  if (Le[0].dateTime) {
                    var Re = ge.Util.timeInSeconds(Le[0].dateTime);
                    Me.metadataService.removeUntil(Re);
                  }
                  (0, le.extractDateRangeMetadata)(Ce.segments, function(Be) {
                    Me.addDateRangeMetadata(Be);
                  });
                  var Oe = !(Ce != null && Ce.endList);
                  return Me.extractMetadataFromTimeline(De, Oe), Ce;
                }
              }
            }, ue = ve.ModuleManager.get(me.ModuleName.HLS).PlaylistUtils, this.settings = Te.settings, this.config = Te.config, this.eventHandler = Te.eventHandler, this.originalManifest = null, this.metadataParsedService = Te.serviceManager.get(_e.ServiceName.MetadataParsedService), this.eventHandler.on(fe.PlayerEvent.TimeChanged, this.onTimeChangedHandler), this.eventHandler.on(fe.PlayerEvent.TimeShifted, this.onTimeShiftedHandler), this.eventHandler.on(fe.PlayerEvent.Seeked, this.onSeeked), this.metadataService = new se.MetadataService(this.context, ((Ee = {})[oe.TimedMetadataType.Manifest] = this.onManifestMetadata, Ee[oe.TimedMetadataType.DateRange] = this.onManifestMetadata, Ee));
          }
          return Pe.prototype.triggerSegmentPlayback = function(Te) {
            var Ee = { url: Te.uri, uid: null, mimeType: "video/mp4", playbackTime: Te.playbackTime, duration: Te.duration, mediaInfo: {}, dateTime: null };
            Te.dateTime && (Ee.dateTime = Te.dateTime.toISOString()), Te.customTags && Te.customTags.length > 0 && (Ee.EXPERIMENTAL = Ee.EXPERIMENTAL || {}, Ee.EXPERIMENTAL.hlsAttributes = Te.customTags.map(function(Me) {
              return Me.attributes;
            })), this.context.eventHandler.dispatchEvent(fe.PlayerEvent.SegmentPlayback, Ee);
          }, Pe.prototype.triggerMetadata = function(Te) {
            var Ee = this;
            Te.metadata && Te.metadata.forEach(function(Me) {
              Se(Me) ? Ee.context.eventHandler.dispatchEvent(fe.PlayerEvent.Metadata, { metadataType: fe.MetadataType.CUETAG, metadata: Me }) : Ee.context.eventHandler.dispatchEvent(fe.PlayerEvent.Metadata, { metadataType: Me.type, metadata: Me });
            });
          }, Pe.prototype.resolveMasterManifest = function(Te) {
            return this.parsedManifest ? Promise.resolve(this.manifestUrl) : (this.manifestUrl = Te, this.downloadMasterManifest(Te));
          }, Pe.prototype.registerMasterManifest = function(Te, Ee) {
            this.originalManifest = Te.body;
            var Me = be.replaceManifestUrls(Ee, this.originalManifest, this.settings.QUERY_PARAMETERS);
            this.parsedManifest = this.parsePlaylist(Me);
            var Ae = this.isValidMasterPlaylist(this.parsedManifest), Ne = this.isValidVariantPlaylist(this.parsedManifest);
            if (!Ae && Ne) {
              var Ce = pe.replace("$VARIANT$", Ee);
              Me = be.replaceManifestUrls(Ee, Ce, this.settings.QUERY_PARAMETERS), this.originalManifest = Ce, this.parsedManifest = this.parsePlaylist(Me);
            } else
              Ae || (this.parsedManifest = null);
            return Me;
          }, Pe.prototype.isValidMasterPlaylist = function(Te) {
            return Te != null && "playlists" in Te && Te.playlists.length > 0;
          }, Pe.prototype.isValidVariantPlaylist = function(Te) {
            return Te != null && "segments" in Te && Te.segments.length > 0;
          }, Pe.prototype.parsePlaylist = function(Te) {
            var Ee = ve.ModuleManager.get(me.ModuleName.HLS).parsePlaylist;
            try {
              return Ee(Te);
            } catch {
              return null;
            }
          }, Pe.prototype.addDateRangeMetadata = function(Te) {
            var Ee = { metadataType: fe.MetadataType.DATERANGE, metadata: Te.data, start: Te.startTime, end: Te.endTime };
            this.addMetadata(Ee);
          }, Pe.prototype.metadataToMetadataParsedEvent = function(Te) {
            return { metadataType: Te.metadataType, metadata: Te.metadata, data: Te.metadata, start: Te.start, end: Te.end };
          }, Pe.prototype.addMetadata = function(Te) {
            var Ee = Te.metadataType === "DATERANGE" ? oe.TimedMetadataType.DateRange : oe.TimedMetadataType.Manifest;
            this.metadataService.addToMetadataParsedService(Te.start, this.metadataToMetadataParsedEvent(Te), ce.DEFAULT_PERIOD_ID), this.metadataService.addToTimeline(Ee, Te.start, Te);
          }, Pe.prototype.extractMetadataFromTimeline = function(Te, Ee) {
            var Me = this;
            Te.forEach(function(Ae) {
              Object.values(ae).forEach(function(Ne) {
                Ae.hasOwnProperty(Ne) && ye(Ne, Ae, Ee).forEach(function(Ce) {
                  return Me.addMetadata(Ce);
                });
              });
            });
          }, Pe.prototype.parseTimelineEntries = function(Te) {
            var Ee = this.parsePlaylist(Te), Me = function(Ae) {
              var Ne;
              return { uri: Ae.uri, duration: Ae.duration, discontinuity: (Ne = Ae.discontinuity) !== null && Ne !== void 0 && Ne, dateTime: null, metadata: [], consumed: !1, playbackTime: -1, keys: [] };
            };
            return this.isValidVariantPlaylist(Ee) ? Ee.segments.map(Me) : [];
          }, Pe.prototype.getPlaybackTimeOfFirstSegmentInTimeline = function(Te) {
            for (var Ee = 0; Ee < Te.length; Ee++)
              for (var Me = Te[Ee], Ae = 0, Ne = 0; Ne < Me.timeline.length; Ne++) {
                for (var Ce = Me.timeline[Ne], Ie = this.segmentTimelineController.getCurrentTimeline(), xe = 0; xe < Ie.length; xe++) {
                  var Ue = Ie[xe];
                  if (Ue.uri === Ce.uri)
                    return Ue.playbackTime - Ae;
                }
                Ae += Ce.duration;
              }
            return -1;
          }, Pe.prototype.getParsedManifest = function() {
            return this.parsedManifest;
          }, Pe.prototype.getManifest = function() {
            return this.originalManifest;
          }, Pe.prototype.detachEventHandlers = function() {
            this.eventHandler && (this.eventHandler.off(fe.PlayerEvent.TimeChanged, this.onTimeChangedHandler), this.eventHandler.off(fe.PlayerEvent.TimeShifted, this.onTimeShiftedHandler), this.eventHandler.off(fe.PlayerEvent.Seeked, this.onSeeked));
          }, Pe.prototype.dispose = function() {
            this.detachEventHandlers(), this.segmentTimelineController && (this.segmentTimelineController.dispose(), this.segmentTimelineController = null), this.metadataService && (this.metadataService.dispose(), this.metadataService = null), this.parsedManifest = null, this.originalManifest = null, this.manifestUrl = null, this.settings = null, this.config = null, this.eventHandler = null;
          }, Pe;
        }();
        function ye(Pe, Te, Ee) {
          var Me = Ee && Te.dateTime ? (0, he.toSeconds)(Te.dateTime.getTime()) : Te.playbackTime;
          switch (Pe) {
            case ae.CueTag:
              return [{ metadataType: fe.MetadataType.CUETAG, metadata: Te[ae.CueTag], start: Me }];
            case ae.Scte35:
              return [{ metadataType: fe.MetadataType.SCTE, metadata: Te[ae.Scte35], start: Me }];
            case ae.CustomTags:
              return [{ metadataType: fe.MetadataType.CUSTOM, metadata: Te[ae.CustomTags], start: Me, end: Me + Te.duration }];
            default:
              return [];
          }
        }
        function Se(Pe) {
          return Pe.type.includes("CUE");
        }
        function we(Pe, Te, Ee) {
          for (var Me, Ae = Pe.segments, Ne = Ae.some(function(Ue) {
            return Ue.dateTime !== void 0;
          }), Ce = 0; Ce < Ae.length; Ce++) {
            var Ie = Ae[Ce];
            if (Ie.variantPlaylistId = Te, Ie.mediaSequenceNumber = Pe.mediaSequence + Ce, !Ne && ((Me = Ee.tweaks) === null || Me === void 0 ? void 0 : Me.akamai_datetime_parsing)) {
              var xe = ue.getProgramDateTimeFromSegmentUrl(Ie.uri, Ie.duration);
              xe && (Ie.dateTime = xe);
            }
          }
          return Ae;
        }
        ie.AbstractHlsManifestController = $e;
      }, 526: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.AppleAirplayService = ie.isAirplaySupported = void 0;
        var ae, ue = ne(62510), _e = ne(46462);
        (function(se) {
          se.Available = "available", se.NotAvailable = "not-available";
        })(ae || (ae = {}));
        var fe = function() {
          return !!window.WebKitPlaybackTargetAvailabilityEvent;
        };
        ie.isAirplaySupported = fe;
        var le = function() {
          function se(oe, ce) {
            var he = this;
            this.videoElement = oe, this.eventHandler = ce, this.airplayAvailable = !1, this.onWebkitPlaybackTargetAvailabilityChanged = function(ge) {
              switch (ge.availability) {
                case ae.Available:
                  he.airplayAvailable = !0, he.eventHandler.dispatchEvent(ue.PlayerEvent.AirplayAvailable);
                  break;
                case ae.NotAvailable:
                  he.airplayAvailable = !1;
              }
            }, this.onWebkitPlaybackTargetIsWirelessChanged = function() {
              he.eventHandler.dispatchEvent(ue.PlayerEvent.AirplayChanged, { airplayEnabled: he.isAirplayActive(), time: he.videoElement.currentTime });
            }, this.initAirplay();
          }
          return se.prototype.initAirplay = function() {
            this.videoElement.setAttribute("x-webkit-airplay", "allow"), this.videoElement.addEventListener(_e.MediaElementEvent.webkitplaybacktargetavailabilitychanged, this.onWebkitPlaybackTargetAvailabilityChanged), this.videoElement.addEventListener(_e.MediaElementEvent.webkitcurrentplaybacktargetiswirelesschanged, this.onWebkitPlaybackTargetIsWirelessChanged);
          }, se.prototype.isAirplayAvailable = function() {
            return this.airplayAvailable;
          }, se.prototype.isAirplayActive = function() {
            return this.videoElement.isAirplayActive();
          }, se.prototype.showAirplayTargetPicker = function() {
            this.isAirplayAvailable() && (this.videoElement.webkitShowPlaybackTargetPicker(), this.eventHandler.dispatchEvent(ue.PlayerEvent.ShowAirplayTargetPicker));
          }, se.prototype.dispose = function() {
            this.videoElement.removeEventListener(_e.MediaElementEvent.webkitplaybacktargetavailabilitychanged, this.onWebkitPlaybackTargetAvailabilityChanged), this.videoElement.removeEventListener(_e.MediaElementEvent.webkitcurrentplaybacktargetiswirelesschanged, this.onWebkitPlaybackTargetIsWirelessChanged);
          }, se;
        }();
        ie.AppleAirplayService = le;
      }, 62545: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.AssetAvailabilityChecker = void 0;
        var ae = ne(88005), ue = ne(67345), _e = ne(331), fe = ne(46462), le = function() {
          function se(oe, ce, he) {
            var ge = this;
            this.context = oe, this.source = ce, this.mediaElement = he, this.scheduleAvailabilityCheck = function() {
              ge.mediaElement.removeEventListener(fe.MediaElementEvent.loadstart, ge.scheduleAvailabilityCheck);
              var ve = (0, _e.toMilliSeconds)(ge.context.settings.XHR_TIMEOUT) / 2;
              ge.assetAvailabilityCheckTimeoutID = window.setTimeout(function() {
                ge.context.logger.debug("Asset loading has not resolved after ".concat((0, _e.toSeconds)(ve), "s. Checking accessibility."));
                var me = !1, be = function(pe) {
                  var $e;
                  pe.loadedBytes > 0 && (me = !0, ($e = ge.contentLoader) === null || $e === void 0 || $e.cancel());
                };
                ge.contentLoader = new ae.DefaultContentLoader(ge.context, { onProgress: be, requestType: ue.HttpRequestType.INTERNAL }), ge.contentLoader.load(ge.source.src).catch(function(pe) {
                  if (!me) {
                    ge.context.logger.debug("Forcing error event as the asset was not accessible.", pe);
                    var $e = new Event(fe.MediaElementEvent.error, { bubbles: !1, cancelable: !1 });
                    ge.source.dispatchEvent($e);
                  }
                });
              }, ve);
            }, he.addEventListener(fe.MediaElementEvent.loadstart, this.scheduleAvailabilityCheck);
          }
          return se.prototype.dispose = function() {
            this.assetAvailabilityCheckTimeoutID && window.clearTimeout(this.assetAvailabilityCheckTimeoutID), this.mediaElement.removeEventListener(fe.MediaElementEvent.loadstart, this.scheduleAvailabilityCheck), this.contentLoader && (this.contentLoader.cancel(), this.contentLoader.dispose());
          }, se;
        }();
        ie.AssetAvailabilityChecker = le;
      }, 70661: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var ye = function(Se, we) {
            return ye = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Pe, Te) {
              Pe.__proto__ = Te;
            } || function(Pe, Te) {
              for (var Ee in Te)
                Object.prototype.hasOwnProperty.call(Te, Ee) && (Pe[Ee] = Te[Ee]);
            }, ye(Se, we);
          };
          return function(Se, we) {
            if (typeof we != "function" && we !== null)
              throw new TypeError("Class extends value " + String(we) + " is not a constructor or null");
            function Pe() {
              this.constructor = Se;
            }
            ye(Se, we), Se.prototype = we === null ? Object.create(we) : (Pe.prototype = we.prototype, new Pe());
          };
        }();
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.FallbackHlsManifestController = void 0;
        var ue, _e = ne(63546), fe = ne(35148), le = ne(62510), se = ne(67345), oe = ne(331), ce = ne(91520), he = ne(16368), ge = ne(77117), ve = ne(70539), me = ne(9183), be = ne(76250), pe = function(ye) {
          function Se(we) {
            var Pe = ye.call(this, we) || this;
            return Pe.onLoadPlaylistError = function(Te) {
              return Pe.context.logger.debug("Error while loading the playlist ", Te), null;
            }, ue = ce.ModuleManager.get(he.ModuleName.HLS).PlaylistUtils, Pe.hlsDownloadService = new me.HlsDownloadService(Pe.context), Pe.segmentTimelineController = new ve.FallbackSegmentTimelineController(we.videoElement), Pe;
          }
          return ae(Se, ye), Se.prototype.init = function() {
            return Promise.resolve();
          }, Se.prototype.getDownloadedVideoData = function() {
            return { id: "not available", bitrate: 0, height: 0, width: 0, isAuto: !0 };
          }, Se.prototype.getPlayingVideoData = function() {
            return null;
          }, Se.prototype.downloadMasterManifest = function(we) {
            var Pe = this;
            return this.hlsDownloadService.downloadPlaylist(we, se.HttpRequestType.MANIFEST_HLS_MASTER).then(function(Te) {
              var Ee = Pe.registerMasterManifest(Te, Te.url), Me = Pe.parsedManifest.playlists[0].uri;
              return Pe.registerFirstVariantPlaylist(Me).then(function(Ae) {
                return Pe.overrideManifestUrl(Ee, Te.url, Ae);
              });
            });
          }, Se.prototype.registerFirstVariantPlaylist = function(we) {
            var Pe = this;
            return this.hlsDownloadService.downloadPlaylist(we, se.HttpRequestType.MANIFEST_HLS_VARIANT).then(this.registerVariantPlaylist).then(function(Te) {
              return ue.isLive(Te) && Pe.scheduleReload(Te, we), Te;
            });
          }, Se.prototype.overrideManifestUrl = function(we, Pe, Te) {
            return "createObjectURL" in window.URL ? this.getManifestUrl(we, Te) : (this.context.eventHandler.dispatchEvent(le.PlayerEvent.Warning, new _e.PlayerWarning(fe.WarningCode.SETUP_CREATE_OBJECT_URL_MISSING)), Promise.resolve(Pe));
          }, Se.prototype.getManifestUrl = function(we, Pe) {
            var Te = this;
            return ue.isLive(Pe) ? Promise.resolve(this.createDataUrlForManifest(we)) : Promise.all(this.getMediaPlaylistPromises(we)).then(function(Ee) {
              return Ee.filter(function(Me) {
                return !!Me;
              }).forEach(function(Me) {
                we = we.replace(Me.mediaUrl, Me.blobUrl);
              }), Te.createDataUrlForManifest(we);
            });
          }, Se.prototype.getMediaPlaylistPromises = function(we) {
            var Pe = this;
            return we.split(`
`).map(function(Te) {
              return be.parseUrlFromLine(Te);
            }).filter(function(Te) {
              return Te !== null;
            }).map(function(Te) {
              return Pe.getMediaPlaylistBlobUrlMapping(Te);
            });
          }, Se.prototype.getMediaPlaylistBlobUrlMapping = function(we) {
            var Pe = this;
            return this.hlsDownloadService.downloadPlaylist(we, se.HttpRequestType.MANIFEST_HLS_VARIANT).then(function(Te) {
              var Ee = be.replaceManifestUrls(we, Te.body, Pe.settings.QUERY_PARAMETERS);
              return { blobUrl: Pe.createBlobForManifest(Ee), mediaUrl: we };
            }).catch(this.onLoadPlaylistError);
          }, Se.prototype.loadPlaylist = function(we) {
            var Pe = this;
            return this.hlsDownloadService.downloadPlaylist(we.uri, se.HttpRequestType.MANIFEST_HLS_VARIANT).then(function(Te) {
              return { width: we.width, height: we.height, timeline: Pe.parseTimelineEntries(Te.body) };
            }).catch(this.onLoadPlaylistError);
          }, Se.prototype.reload = function(we) {
            var Pe = this;
            return function() {
              if (!Pe.hlsDownloadService)
                return function() {
                };
              Pe.hlsDownloadService.downloadPlaylist(we, se.HttpRequestType.MANIFEST_HLS_VARIANT, !1).then(Pe.registerVariantPlaylist).then(function(Te) {
                return ue.isLive(Te) && Pe.scheduleReload(Te, Pe.parsedManifest.playlists[0].uri), Te;
              }).catch(Pe.onLoadPlaylistError);
            };
          }, Se.prototype.scheduleReload = function(we, Pe) {
            this.reloadTimerId = setTimeout(this.reload(Pe), (0, oe.toMilliSeconds)(we.targetDuration));
          }, Se.prototype.createBlobForManifest = function(we) {
            var Pe = new Blob([we], { type: "application/x-mpegURL" });
            return window.URL.createObjectURL(Pe);
          }, Se.prototype.createDataUrlForManifest = function(we) {
            return "data:application/x-mpegURL," + we.replace(/\n/g, "%0A").replace(/\r/g, "%0D");
          }, Se.prototype.getVariantPlaylistInfos = function() {
            return this.parsedManifest.playlists.map(function(we) {
              return { uri: we.uri, width: we.attributes && we.attributes.RESOLUTION ? we.attributes.RESOLUTION.width : -1, height: we.attributes && we.attributes.RESOLUTION ? we.attributes.RESOLUTION.height : -1 };
            });
          }, Se.prototype.loadAllVariantPlaylists = function() {
            var we = this, Pe = this.getVariantPlaylistInfos();
            Pe.reverse();
            var Te = Pe.map(function(Ee) {
              return we.loadPlaylist(Ee);
            });
            return Promise.all(Te).then(function(Ee) {
              var Me = we.getPlaybackTimeOfFirstSegmentInTimeline(Ee);
              return Me >= 0 && Ee.forEach(function(Ae) {
                Ae.timeline.reduce(function(Ne, Ce) {
                  return Ce.playbackTime = Ne, Ne + Ce.duration;
                }, Me);
              }), Ee;
            });
          }, Se.prototype.getCurrentSegments = function(we, Pe, Te, Ee) {
            return Ee === void 0 && (Ee = 1), this.loadAllVariantPlaylists().then(function(Me) {
              var Ae = Me.find(function(Ne) {
                return Ne.width === Pe && Ne.height === Te;
              });
              return $e(Ae ? [Ae] : Me, Ee, we);
            });
          }, Se.prototype.dispose = function() {
            ye.prototype.dispose.call(this), clearTimeout(this.reloadTimerId), this.reloadTimerId = null;
          }, Se;
        }(ge.AbstractHlsManifestController);
        function $e(ye, Se, we) {
          for (var Pe = [], Te = 0, Ee = 0; Ee < ye.length; Ee++) {
            var Me = ye[Ee];
            Te = 0;
            for (var Ae = 0; Ae < Me.timeline.length; Ae++) {
              var Ne = Me.timeline[Ae];
              if (Ne.playbackTime + Ne.duration >= we && (Pe.push(Ne.uri), Te++), Te > Se)
                break;
            }
          }
          return Pe;
        }
        ie.FallbackHlsManifestController = pe;
      }, 70539: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.FallbackSegmentTimelineController = void 0;
        var ae = ne(68329), ue = function() {
          function _e(fe) {
            this.videoElement = fe, this.shouldCalculatePlaybackTimeForLive = !0, this.timelines = {};
          }
          return _e.prototype.isLiveStream = function() {
            return this.videoElement.duration === 1 / 0;
          }, _e.prototype.switchTimeline = function(fe) {
            this.timelines[fe] || (this.currentActiveTimelineId = fe, this.timelines[fe] = []);
          }, _e.prototype.updateTimeline = function(fe, le) {
            var se = this, oe = this.timelines[fe], ce = ae.updateTimeline(oe, le), he = ce.findIndex(function(ve) {
              return ve.hasOwnProperty("playbackTime");
            });
            he !== -1 && ae.populateCurrentTimelineWithPlaybackTime(ce, he, ce[he].playbackTime), this.timelines[fe] = ce;
            var ge = ce.reduce(function(ve, me) {
              return se.isLiveStream() && !se.shouldCalculatePlaybackTimeForLive || (me.playbackTime = ve), ve + me.duration;
            }, 0);
            return this.shouldCalculatePlaybackTimeForLive && (this.shouldCalculatePlaybackTimeForLive = !1), ge;
          }, _e.prototype.getPlayingSegment = function(fe) {
            for (var le = this.getCurrentTimeline(), se = 0; se < le.length; se++) {
              var oe = le[se];
              if (fe >= oe.playbackTime && fe <= oe.playbackTime + oe.duration)
                return le[se];
            }
            return null;
          }, _e.prototype.addDownloadedSegments = function(fe) {
          }, _e.prototype.getCurrentTimeline = function() {
            return this.timelines[this.currentActiveTimelineId];
          }, _e.prototype.getAllTimelines = function() {
            return this.timelines;
          }, _e.prototype.reset = function() {
            this.timelines[this.currentActiveTimelineId].forEach(function(fe) {
              return fe.consumed = !1;
            });
          }, _e.prototype.dispose = function() {
            this.timelines = {}, this.videoElement = null;
          }, _e;
        }();
        ie.FallbackSegmentTimelineController = ue;
      }, 69860: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.HlsDownloadErrorHandler = void 0;
        var ae = ne(25550), ue = ne(28764), _e = ne(88005), fe = ne(23234), le = ne(67345), se = ne(13533), oe = ne(46462), ce = function() {
          function he(ge, ve) {
            var me = this;
            this.fakeProgress = function() {
              for (var be = me.video.buffered, pe = "", $e = 0; $e < be.length; $e++)
                pe += "".concat(be.start($e), " - ").concat(be.end($e), ", ");
              pe === me.lastProgressString ? me.numProgressNotChanged++ : me.numProgressNotChanged = 0, me.numProgressNotChanged >= 10 && me.onStalled(), me.lastProgressString = pe;
            }, this.fakeWaiting = function() {
              var be = fe.TimingUtil.getHiResTimestamp(), pe = !me.video.paused && !me.video.seeking && !me.video.ended;
              be - me.lastTimeUpdateTimeStamp > 5 && pe && me.onWaiting();
            }, this.onStalled = function() {
              me.stalledTimeStamp = fe.TimingUtil.getHiResTimestamp(), me.checkStalledState();
            }, this.onProgress = function() {
              me.stalledTimeStamp = -1 / 0, clearTimeout(me.downloadErrorCheckTimeoutId);
            }, this.onWaiting = function() {
              me.waitingEventTimeStamp = fe.TimingUtil.getHiResTimestamp(), me.checkStalledState();
            }, this.onTimeUpdate = function() {
              me.waitingEventTimeStamp = -1 / 0, me.lastTimeUpdateTimeStamp = fe.TimingUtil.getHiResTimestamp(), clearTimeout(me.downloadErrorCheckTimeoutId);
            }, this.checkForDownloadError = function() {
              if (me.video.buffered.length !== 0) {
                var be = me.video.currentTime, pe = me.video.buffered.end(me.video.buffered.length - 1), $e = be <= pe && be + 0.5 > pe, ye = me.video.paused, Se = me.video.networkState === HTMLMediaElement.NETWORK_LOADING, we = me.video.videoWidth, Pe = me.video.videoHeight;
                !ye && $e && Se && me.manifestController.getCurrentSegments(pe, we, Pe, 2).then(function(Te) {
                  var Ee = new _e.DefaultContentLoader(me.context), Me = function(Ae, Ne) {
                    return Ae === void 0 && (Ae = !0), Te.length > 0 && Ae ? Ee.load(Te.pop(), le.HttpRequestMethod.HEAD).then(function(Ce) {
                      return Me(Ce.status >= 200 && Ce.status < 300, Ce);
                    }) : Ae ? Promise.resolve() : Promise.reject(Ne);
                  };
                  Me().catch(function(Ae) {
                    var Ne = Ae.url, Ce = Ae.status, Ie = Ae.statusText;
                    me.context.eventHandler.fireError(new ue.PlayerError(ae.ErrorCode.NETWORK_ERROR, { url: Ne, statusCode: Ce, statusText: Ie }, "Failed to load segment ".concat(Ne, ", statusCode: ").concat(Ce, ", statusText: ").concat(Ie)));
                  });
                });
              }
            }, this.context = ge, this.video = ge.videoElement, this.manifestController = ve, this.playbackAdvancing = !1, this.stalledTimeStamp = -1 / 0, this.waitingEventTimeStamp = -1 / 0, this.downloadErrorCheckTimeoutId = -1, this.lastProgressString = "", this.numProgressNotChanged = 0, this.lastTimeUpdateTimeStamp = -1 / 0, this.video.addEventListener(oe.MediaElementEvent.waiting, this.onWaiting), this.video.addEventListener(oe.MediaElementEvent.stalled, this.onStalled), this.video.addEventListener(oe.MediaElementEvent.progress, this.onProgress), this.video.addEventListener(oe.MediaElementEvent.timeupdate, this.onTimeUpdate), (0, se.getCapabilities)().isIOS && (this.fakeEventsIntervalId = window.setInterval(function() {
              me.fakeProgress(), me.fakeWaiting();
            }, 500));
          }
          return he.prototype.checkStalledState = function() {
            var ge = Math.abs(this.waitingEventTimeStamp - this.stalledTimeStamp);
            clearTimeout(this.downloadErrorCheckTimeoutId), isFinite(ge) && (this.downloadErrorCheckTimeoutId = window.setTimeout(this.checkForDownloadError, 1e3 * (5 - Math.min(5, ge))));
          }, he.prototype.dispose = function() {
            clearTimeout(this.fakeEventsIntervalId), clearTimeout(this.downloadErrorCheckTimeoutId), this.video.removeEventListener(oe.MediaElementEvent.waiting, this.onWaiting), this.video.removeEventListener(oe.MediaElementEvent.stalled, this.onStalled), this.video.removeEventListener(oe.MediaElementEvent.progress, this.onProgress), this.video.removeEventListener(oe.MediaElementEvent.timeupdate, this.onTimeUpdate), this.video = null, this.manifestController = null;
          }, he;
        }();
        ie.HlsDownloadErrorHandler = ce;
      }, 9183: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.HlsDownloadService = void 0;
        var ae = ne(63546), ue = ne(35148), _e = ne(62510), fe = ne(88005), le = ne(67345), se = function() {
          function oe(ce) {
            var he = this;
            this.useCredentialsForManifestRequests = !1, this.downloadFailureHandler = function(ge) {
              he.context.eventHandler.dispatchEvent(_e.PlayerEvent.Warning, new ae.PlayerWarning(ue.WarningCode.NETWORK_COULD_NOT_LOAD_MANIFEST)), he.context.logger.debug("Could not load manifest, got HTTP status code " + ge.status);
            }, this.context = ce, this.init();
          }
          return oe.prototype.init = function() {
            this.initCache(), this.initUseCredentialsForManifest();
          }, oe.prototype.initCache = function() {
            this.requestCache = {};
          }, oe.prototype.initUseCredentialsForManifest = function() {
            var ce = this.context.sourceContext.source && this.context.sourceContext.source.options || {};
            this.useCredentialsForManifestRequests = typeof ce.hlsManifestWithCredentials == "boolean" ? ce.hlsManifestWithCredentials : ce.manifestWithCredentials === !0;
          }, oe.prototype.downloadPlaylist = function(ce, he, ge) {
            return ge === void 0 && (ge = !0), ge && this.requestCache.hasOwnProperty(ce) ? Promise.resolve(this.requestCache[ce]) : this.download(he, ce);
          }, oe.prototype.download = function(ce, he) {
            var ge = this, ve = this.getContentLoader(ce);
            return ve.load(he, le.HttpRequestMethod.GET, le.HttpResponseType.TEXT, null, {}, this.useCredentialsForManifestRequests).then(function(me) {
              return ve.dispose(), ge.requestCache[he] = me, me;
            }).catch(function(me) {
              return ve.dispose(), Promise.reject(me);
            });
          }, oe.prototype.getContentLoader = function(ce) {
            return new fe.DefaultContentLoader(this.context, { onFailure: this.downloadFailureHandler, maxRetries: this.context.settings.MAX_MPD_RETRIES, requestType: ce });
          }, oe.prototype.dispose = function() {
          }, oe;
        }();
        ie.HlsDownloadService = se;
      }, 60012: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.HlsLiveNativeTimeTracker = void 0;
        var ae = ne(15539), ue = ne(331), _e = ne(54838), fe = ne(46462), le = 2e3, se = function() {
          function oe(ce, he) {
            this.nativePlayer = ce, this.context = he, this.timeAdjustment = 0, this.unloadTimestamp = null, this.startDate = null;
          }
          return oe.prototype.onUnload = function(ce) {
            ce === ae.ADVERTISING_ISSUER_NAME && this.context.settings.RESUME_LIVE_CONTENT_AT_PREVIOUS_POSITION_AFTER_AD_BREAK && this.unloadTimestamp == null && (this.nativePlayer.isLive() ? (this.unloadTimestamp = Date.now(), this.timeAdjustment = this.nativePlayer.getSeekableRange().start, this.startDate = this.nativePlayer.getStartDate()) : this.reset());
          }, oe.prototype.reset = function() {
            this.unloadTimestamp = null, this.timeAdjustment = 0, this.startDate = null;
          }, oe.prototype.adjustTargetTime = function(ce, he) {
            var ge = this;
            return he !== ae.ADVERTISING_RESTORE_ISSUER_NAME || this.unloadTimestamp == null ? (this.context.logger.debug("No adjustments are made", this.unloadTimestamp), Promise.resolve(ce)) : (this.startDate != null ? this.waitForStartDate() : Promise.resolve(null)).then(function(ve) {
              if (ve != null) {
                ge.context.logger.debug("StartDate progressed from ".concat(ge.startDate, " to: ").concat(ve, " during the ad"));
                var me = _e.Util.timeInSeconds(ve) - _e.Util.timeInSeconds(ge.startDate);
                ge.timeAdjustment = me;
              } else {
                ge.context.logger.debug("Adjusting time based on seekable range");
                var be = (0, ue.toSeconds)(Date.now() - ge.unloadTimestamp);
                ge.timeAdjustment += be;
              }
              var pe = ce - ge.timeAdjustment;
              return ge.context.logger.debug("Adjusting target time from ".concat(ce, " by ").concat(ge.timeAdjustment, " to ").concat(pe)), ge.reset(), pe;
            });
          }, oe.prototype.waitForStartDate = function() {
            var ce = this, he = this.getValidDateTime();
            return he ? Promise.resolve(he) : new Promise(function(ge) {
              var ve = null, me = function() {
                ge(ce.getValidDateTime()), ce.context.videoElement.removeEventListener(fe.MediaElementEvent.loadeddata, me), clearTimeout(ve);
              };
              ce.context.logger.debug("Waiting for video.startDate to be valid"), ce.context.videoElement.addEventListener(fe.MediaElementEvent.loadeddata, me), ve = setTimeout(me, le);
            });
          }, oe.prototype.getValidDateTime = function() {
            var ce = this.nativePlayer.getStartDate();
            return ce && !isNaN(ce.getTime()) ? ce : null;
          }, oe;
        }();
        ie.HlsLiveNativeTimeTracker = se;
      }, 91229: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.createHlsManifestController = le, ie.shouldUseServiceWorker = se;
        var ae = ne(91520), ue = ne(16368), _e = ne(77117), fe = ne(70661);
        function le(ce) {
          if (se(ce)) {
            var he = new (ae.ModuleManager.get(ue.ModuleName.ServiceWorkerClient).createServiceWorkerHlsManifestController(_e.AbstractHlsManifestController))(ce);
            return he.init().then(function() {
              return he;
            }).catch(function() {
              return oe(ce);
            });
          }
          return oe(ce);
        }
        function se(ce) {
          var he = ce.config.location && ce.config.location.serviceworker;
          return "serviceWorker" in navigator && he && ae.ModuleManager.has(ue.ModuleName.ServiceWorkerClient);
        }
        function oe(ce) {
          var he = new fe.FallbackHlsManifestController(ce);
          return he.init().then(function() {
            return he;
          });
        }
      }, 76250: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.replaceManifestUrls = _e, ie.parseUrlFromLine = fe, ie.replaceUrlAndAddUriParams = le;
        var ae = ne(76885), ue = /URI="([^"]+)"/;
        function _e(se, oe, ce) {
          var he = oe.split(/\r?\n/);
          return he.forEach(function(ge, ve) {
            var me = fe(ge);
            if (me && ge.match(ue)) {
              var be = le(se, me, ce);
              he[ve] = ge.replace(ue, function() {
                return 'URI="'.concat(be, '"');
              });
            } else
              me && (he[ve] = le(se, me, ce));
          }), he.join(`
`);
        }
        function fe(se) {
          if (se[0] !== "#" && se.trim().length > 0)
            return se;
          if (se.indexOf("URI") > -1) {
            var oe = se.match(ue);
            if (oe && oe[1].indexOf("skd://") < 0 && oe[1].indexOf("skds://") < 0)
              return oe[1];
          }
          return null;
        }
        function le(se, oe, ce) {
          var he = ae.URLHelper.concatBaseUrlWithPartial(se, oe);
          return ae.URLHelper.appendQueryParametersToUrl(he, ce);
        }
      }, 42966: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.NativeModuleDefinition = void 0;
        var ae = ne(16368), ue = ne(72273), _e = ne(96926);
        ie.NativeModuleDefinition = { name: ae.ModuleName.EngineNative, module: { NativePlayer: ue.NativePlayer, technologyChecker: new _e.TechnologyChecker() } }, ie.default = ie.NativeModuleDefinition;
      }, 72273: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Xe) {
            for (var We, Ge = 1, at = arguments.length; Ge < at; Ge++)
              for (var dt in We = arguments[Ge])
                Object.prototype.hasOwnProperty.call(We, dt) && (Xe[dt] = We[dt]);
            return Xe;
          }, ae.apply(this, arguments);
        }, ue = this && this.__decorate || function(Xe, We, Ge, at) {
          var dt, ot = arguments.length, et = ot < 3 ? We : at === null ? at = Object.getOwnPropertyDescriptor(We, Ge) : at;
          if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
            et = Reflect.decorate(Xe, We, Ge, at);
          else
            for (var st = Xe.length - 1; st >= 0; st--)
              (dt = Xe[st]) && (et = (ot < 3 ? dt(et) : ot > 3 ? dt(We, Ge, et) : dt(We, Ge)) || et);
          return ot > 3 && et && Object.defineProperty(We, Ge, et), et;
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.NativePlayer = void 0;
        var _e = ne(92712), fe = ne(25550), le = ne(28764), se = ne(63546), oe = ne(35148), ce = ne(18665), he = ne(60997), ge = ne(62510), ve = ne(57620), me = ne(15539), be = ne(88005), pe = ne(16937), $e = ne(33696), ye = ne(17990), Se = ne(58975), we = ne(13533), Pe = ne(3464), Te = ne(81361), Ee = ne(10981), Me = ne(79814), Ae = ne(56435), Ne = ne(331), Ce = ne(70016), Ie = ne(76885), xe = ne(54838), Ue = ne(61878), ke = ne(46462), Le = ne(91520), De = ne(16368), Re = ne(67345), Oe = ne(526), Be = ne(62545), Fe = ne(69860), Ve = ne(60012), Ke = ne(91229), Ze = ne(55194), nt = 2, Qe = 0.1, qe = 0.25, ze = "not available", je = 0.75, tt = 2, ut = 0, yt = function() {
          function Xe(We) {
            var Ge = this;
            this.numTimeChanged = 0, this.loaded = !1, this.audio = null, this.ended = !1, this.ignoreNextVideoError = !1, this.controlPermitted = !0, this.seekingTimeoutId = -1, this.nativeSeekCalled = !1, this.isIllicitlySeeking = !1, this.ignoreNextDelta = !1, this.numSeekingCalled = 0, this.timeShiftJumpStartPosition = -1, this.seekTargetTime = -1, this.textTrackController = null, this.lastPlayIssuer = "api", this.lastPauseIssuer = "api", this.lastSeekIssuer = "api", this.sourceLoadRetryCount = 0, this.lastVerifiedPlaybackPosition = -1, this.lastLegalPlaybackPosition = 0, this.restrictedInlinePlayback = !1, this.lastTime = 0, this.availableVideoStreams = [], this.allowedToThrowEvents = !0, this.hasSourceBeenLoaded = !1, this.hasDataBeenLoaded = !1, this.sourceElementEventListeners = [], this.restoringPlaybackPosAfterQualitySwitch = !1, this.isInitialSeek = !1, this.lastDelayedSeekHandlers = {}, this.isProgressiveQualityChange = !1, this.isSourceBeingRedirected = !1, this.isInNativeFullscreen = !1, this.onAddTrack = function(at) {
              if (Ge.isReady()) {
                var dt = at.track;
                Ge.eventCallback(ge.PlayerEvent.AudioAdded, { track: Ge.convertAudioTrackNativeToApi(dt) }), dt.enabled && Ge.loaded && Ge.dispatchAudioChangedEvent(null, dt);
              }
            }, this.onRemoveTrack = function(at) {
              Ge.isReady() && Ge.eventCallback(ge.PlayerEvent.AudioRemoved, { track: Ge.convertAudioTrackNativeToApi(at.track) });
            }, this.onWebkitPresentationModeChanged = function() {
              var at, dt, ot = Ge.video.getViewModeFromPresentationMode();
              ot === $e.ViewMode.PictureInPicture || ot === $e.ViewMode.Fullscreen && (0, we.getCapabilities)().isIOS ? (at = Ge.textTrackController) === null || at === void 0 || at.enableNative() : (dt = Ge.textTrackController) === null || dt === void 0 || dt.disableNative(), Ge.context.store.dispatch((0, ye.setPlayerViewMode)(ot));
            }, this.onDurationChange = function() {
              (0, ve.maybeFireDurationChangedEvent)(Ge.lastDuration, Ge.getDuration(), Ge.eventHandler), Ge.lastDuration = Ge.getDuration(), Ge.hasDataBeenLoaded && Ge.maybeResolveDeferredLoading();
            }, this.videoOnPlay = function() {
              Ge.stateManager.stallExit(), Ge.restrictedInlinePlayback && Ge.audio && Ge.setVideoTime(), Ge.ended = !1, Ge.stateManager.transitionToPlayState(!0, Ge.lastPlayIssuer);
            }, this.videoOnPlaying = function() {
              Ge.stateManager.isStalled ? (Ge.stateManager.stallExit(), Ge.stateManager.transitionToPlayingState(Ge.lastPlayIssuer)) : Ge.stateManager.isStopped() ? Ge.onPlaybackStarted() : Ge.stateManager.isPlaying() || (Ge.stateManager.transitionToPlayState(!0, Ge.lastPlayIssuer), Ge.stateManager.transitionToPlayingState(Ge.lastPlayIssuer));
            }, this.loadedDataHandler = function() {
              var at;
              clearTimeout(Ge.loadedDataFallbackTimeoutID), (at = Ge.assetAvailabilityChecker) === null || at === void 0 || at.dispose(), Ge.hasSourceBeenLoaded || clearTimeout(Ge.loadTimeoutID), Ge.hasSourceBeenLoaded = !0, Ge.isProgressiveQualityChange = !1, Ge.allowedToThrowEvents = !0, Ge.hasDataBeenLoaded = !0, Ge.maybeResolveDeferredLoading();
            }, this.eventCallback = function(at, dt, ot, et) {
              dt === void 0 && (dt = {}), ot === void 0 && (ot = !1), et === void 0 && (et = !1), Ge.eventHandler && (Ge.allowedToThrowEvents || ot) && Ge.eventHandler.dispatchEvent(at, dt, et);
            }, this.onTimeUpdate = function(at) {
              var dt = Ge.getElement(), ot = dt.currentTime;
              (Ge.lastVerifiedPlaybackPosition !== -1 || ot !== Ge.lastVerifiedPlaybackPosition) && !Ge.isIllicitlySeeking && (Ge.isIllegalSeek(ot) ? (Promise.resolve(Ge.video.play()).catch(function(et) {
                Ge.logger.insane("Play promise rejected:", et);
              }), Ge.ignoreNextDelta = !0, dt.currentTime = Ge.lastLegalPlaybackPosition) : Ge.handleTimeUpdateEvent(dt, ot), Ge.nativeSeekCalled = !1, Ge.currentVideoStream && (Ge.currentVideoStream.width = Ge.video.videoWidth, Ge.currentVideoStream.height = Ge.video.videoHeight));
            }, this.onPlaybackStarted = function() {
              Ge.isPlaying() || (Ge.ended = !1, Ge.startManifestTimeoutTimer(), Ge.stateManager.transitionToPlayingState(Ge.lastPlayIssuer));
            }, this.onContentPlaybackFinished = function() {
              Ge.ended = !0;
            }, this.getCurrentTime = function(at) {
              at === void 0 && (at = $e.TimeMode.AbsoluteTime);
              var dt = Ge.getStartDate();
              return at === $e.TimeMode.AbsoluteTime && dt ? xe.Util.timeInSeconds(dt) + Ge.getElement().currentTime : Ge.getElement().currentTime;
            }, this.getAudioQuality = this.getPlaybackAudioData, this.getVideoQuality = this.getPlaybackVideoData, this.videoOnEnded = function() {
              var at, dt = Ge.getElement(), ot = Math.abs(dt.currentTime - Ge.lastLegalPlaybackPosition), et = Ge.settings.GLOBAL_DISABLE_SEEKING, st = (at = Ge.currentDuration) !== null && at !== void 0 ? at : dt.duration;
              et && (ot > je || dt.currentTime < st - je) ? (Promise.resolve(Ge.video.play()).catch(function(mt) {
                Ge.logger.insane("Play promise rejected:" + mt);
              }), Ge.ignoreNextDelta = !0, Ge.video.currentTime = Ge.lastLegalPlaybackPosition) : (Ge.lastLegalPlaybackPosition = 0, Ge.stateManager.isPlaying() && Ge.stateManager.transitionToPausedState(!0, Ge.lastPauseIssuer), Ge.stateManager.transitionToStoppedState());
            }, this.videoOnSeeked = function() {
              Ge.resetTimeShift(), Ge.numSeekingCalled = 0, !Ge.settings.GLOBAL_DISABLE_SEEKING || Ge.restoringPlaybackPosAfterQualitySwitch || Ge.isInitialSeekToStartTime ? (Ge.lastVerifiedPlaybackPosition = Ge.getElement().currentTime, Ge.isInitialSeekToStartTime = !1, Ge.stateManager.isSeeking() && (Ge.textTrackController && Ge.textTrackController.seek(), Ge.maybeHandleSeekTargetChangeDuringStartup())) : Ge.isIllicitlySeeking = !1, Ge.finishedSeekedTransitionState();
            }, this.videoOnSeeking = function() {
              if (Ge.settings.GLOBAL_DISABLE_SEEKING && !Ge.isInitialSeekToStartTime)
                Ge.isIllicitlySeeking = !Ge.restoringPlaybackPosAfterQualitySwitch, Ge.numSeekingCalled++, Ge.numSeekingCalled > 1 && (Ge.ignoreNextDelta = !1);
              else if (!Ge.stateManager.isSeeking() && !Ge.stateManager.isTimeShifting()) {
                var at = Ge.getElement().currentTime;
                Ge.stateManager.transitionToSeekingIOSState(at, me.INTERNAL_ISSUER_NAME), Ge.lastVerifiedPlaybackPosition = at;
              }
            }, this.onTimeChanged = function() {
              Ge.maxTimeShift === void 0 && (Ge.maxTimeShift = Ge.getElement().currentTime);
            }, this.delayedSeek = function() {
              Ge.numTimeChanged++, Ge.numTimeChanged < Ge.settings.IOS_MIN_TIMEUPDATES_AFTER_AD || (Ge.eventHandler.off(ge.PlayerEvent.TimeChanged, Ge.delayedSeek), Ge.restoringPlaybackPosAfterQualitySwitch = !0, Ge.triggerSeek({ time: Ge.currentTimeWas, issuer: "api", force: !0 }));
            }, this.context = We, this.isAtLiveEdge = !1, this.logger = We.logger, this.video = We.videoElement, this.config = We.config, this.eventHandler = We.eventHandler, this.settings = We.settings, this.hlsSeekingGlitchEventHandlers = [], this.downloadErrorHandler = null, this.currentVol = this.video.volume, this.originalCrossOriginAttributeValue = this.video.getAttribute("crossOrigin"), this.currentTimeShift = -1 / 0, (0, Oe.isAirplaySupported)() && (this.airplayService = new Oe.AppleAirplayService(this.video, this.eventHandler)), this.hlsLiveTimeTracker = new Ve.HlsLiveNativeTimeTracker(this, We), this.elementEvents = [{ event: ke.MediaElementEvent.pause, handler: function() {
              Ge.resetTimeShift(), Ge.ended || Ge.stateManager.transitionToPausedState(!0, Ge.lastPauseIssuer, !0);
            } }, { event: ke.MediaElementEvent.ended, handler: function() {
              Ge.videoOnEnded();
            } }, { event: ke.MediaElementEvent.play, handler: this.videoOnPlay }, { event: ke.MediaElementEvent.canplay, handler: function() {
              Ge.stateManager.stallExit();
            } }, { event: ke.MediaElementEvent.seeking, handler: function() {
              Ge.nativeSeekCalled = !0, Ge.videoOnSeeking(), Ge.getCurrentTime() >= Ge.getDuration() && (Ge.videoOnSeeked(), Ge.videoOnEnded());
            } }, { event: ke.MediaElementEvent.seeked, handler: function() {
              Ge.videoOnSeeked(), Ge.restrictedInlinePlayback && Ge.audio && Ge.setVideoTime();
            } }, { event: ke.MediaElementEvent.durationchange, handler: this.onDurationChange }, { event: ke.MediaElementEvent.loadeddata, handler: this.loadedDataHandler }, { event: ke.MediaElementEvent.loadedmetadata, handler: function() {
              Ge.loadedDataFallbackTimeoutID = window.setTimeout(Ge.loadedDataHandler, 200);
            } }, { event: ke.MediaElementEvent.playing, handler: this.videoOnPlaying }, { event: ke.MediaElementEvent.waiting, handler: function() {
              Ge.resetTimeShift(), Ge.stateManager.stallEnter();
            } }, { event: ke.MediaElementEvent.timeupdate, handler: this.onTimeUpdate }, { event: ke.MediaElementEvent.error, handler: function(at) {
              Ge.hasSourceBeenLoaded || Ge.availableVideoStreams.length !== 1 || Ge.type !== $e.StreamType.Progressive ? (Ge.loadingDeferred.reject(), Ge.ignoreNextVideoError ? (Ge.logger.debug("Ignoring video element error", at.errorObject), Ge.ignoreNextVideoError = !1) : (Ge.logger.debug("video element has thrown an error", at.errorObject), clearTimeout(Ge.loadTimeoutID), Ge.eventHandler.fireError((0, ve.createPlayerErrorFromMediaError)(at, !0)))) : Ge.handleStreamErrorEvent(fe.ErrorCode.SOURCE_PROGRESSIVE_STREAM_ERROR, Ge.video.getWrappedElement().src, at);
            } }, { event: ke.MediaElementEvent.webkitpresentationmodechanged, handler: this.onWebkitPresentationModeChanged }, { elementSelector: function(at) {
              return at.audioTracks;
            }, event: "addtrack", handler: this.onAddTrack }, { elementSelector: function(at) {
              return at.audioTracks;
            }, event: "removetrack", handler: this.onRemoveTrack }];
          }
          return Xe.prototype.shouldAwaitDurationAvailability = function() {
            return !(0, Ae.isWebOS)() && !this.getDuration();
          }, Xe.prototype.shouldAwaitSeekableRange = function() {
            var We, Ge;
            if (!this.isHlsLive() || !((Ge = (We = this.config) === null || We === void 0 ? void 0 : We.tweaks) === null || Ge === void 0) && Ge.prevent_video_element_preloading || (0, Ae.isWebOS)() || this.isSourceBeingRedirected)
              return !1;
            var at = this.video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA;
            return !Je(this.getElement().seekable) && !at;
          }, Xe.prototype.maybeResolveDeferredLoading = function() {
            this.shouldAwaitDurationAvailability() || this.shouldAwaitSeekableRange() ? this.logger.debug("Cannot resolve deferred loading yet, waiting for required data to be loaded ", { duration: String(this.getDuration()), seekableRangeAvailable: Je(this.getElement().seekable), videoElementReadyState: this.getElement().readyState }) : this.loadingDeferred.resolve();
          }, Xe.prototype.handleTimeUpdateEvent = function(We, Ge) {
            if (this.ignoreNextDelta = !1, this.currentDuration = We.duration, Ge > this.currentDuration + tt)
              return this.context.logger.debug("CurrentTime ".concat(Ge, " exceeds video duration (").concat(this.currentDuration, "), reverting current time")), void (We.currentTime = this.currentDuration - 0.1);
            this.lastLegalPlaybackPosition = Ge, this.stateManager.stallExit(), this.stateManager.isSeeking() || this.stateManager.isTimeShifting() || !this.isPlaying() || (this.getStartDate() != null ? this.eventCallback(ge.PlayerEvent.TimeChanged, { time: this.getCurrentTime(), relativeTime: Ge }) : this.eventCallback(ge.PlayerEvent.TimeChanged, { time: this.getCurrentTime() }));
          }, Xe.prototype.isIllegalSeek = function(We) {
            if (!this.settings.GLOBAL_DISABLE_SEEKING || !this.nativeSeekCalled)
              return !1;
            var Ge = this.lastVerifiedPlaybackPosition !== -1 && We > this.lastVerifiedPlaybackPosition + je, at = Math.abs(We - this.lastLegalPlaybackPosition);
            return (!this.ignoreNextDelta || Ge) && at > je;
          }, Xe.prototype.getElement = function() {
            return this.restrictedInlinePlayback && this.audio ? this.audio : this.video;
          }, Xe.prototype.setVideoTime = function() {
            var We = Date.now();
            (0, Ne.toSeconds)(We - this.lastTime) >= 1 / 30 && (this.video.currentTime = this.audio.currentTime, this.lastTime = We), this.isPlaying() && window.requestAnimationFrame(this.setVideoTime);
          }, Xe.prototype.maybeGoToLiveEdgeOnPlay = function() {
            if (this.isLive() && !this.isTimeShiftingAllowed()) {
              var We = this.getSeekableRangeInternal();
              We.end >= 0 && this.seekForLive(We.end, me.STARTUP_ISSUER_NAME);
            }
          }, Xe.prototype.resolveDelayedSeek = function() {
            this.delayedSeekTarget !== void 0 && (this.clearDelayedSeekHandlers(), this.seek(this.delayedSeekTarget, "api-play"));
          }, Xe.prototype.play = function(We) {
            return this.controlPermitted ? (this.lastPlayIssuer = We, this.resolveDelayedSeek(), this.maybeGoToLiveEdgeOnPlay(), this.getElement().play()) : Promise.reject("Play control not permitted");
          }, Xe.prototype.getStartDate = function() {
            if (!this.isLive())
              return null;
            var We = this.getElement().getWrappedElement(), Ge = typeof We.getStartDate == "function" ? We.getStartDate() : null;
            return Ge && !isNaN(Ge.getTime()) ? Ge : null;
          }, Xe.prototype.preload = function() {
            this.getElement().preload = "auto";
          }, Xe.prototype.pause = function(We) {
            this.lastPauseIssuer = We;
            var Ge = this.getElement();
            this.controlPermitted && this.loaded && (this.stateManager.transitionToPausedState(!1, this.lastPauseIssuer), Ge.pause());
          }, Xe.prototype.mute = function(We) {
            this.getElement().muted || (this.getElement().muted = !0, this.eventCallback(ge.PlayerEvent.Muted, { issuer: We || "api" }));
          }, Xe.prototype.unmute = function(We) {
            this.getElement().muted && (this.getElement().muted = !1, this.eventCallback(ge.PlayerEvent.Unmuted, { issuer: We || "api" }));
          }, Xe.prototype.getActualSeekTarget = function(We) {
            var Ge = this.getStartDate();
            return Ge ? We - (0, Ne.toSeconds)(Ge.getTime()) : We;
          }, Xe.prototype.seek = function(We, Ge) {
            var at = this;
            return !(!this.isSeekingAllowed(We) || this.getCurrentTime() === We) && (this.hlsLiveTimeTracker.adjustTargetTime(We, Ge).then(function(dt) {
              at.lastSeekIssuer = Ge, at.triggerSeekEvent(dt, Ge);
              var ot = at.getActualSeekTarget(dt);
              return at.triggerSeek({ time: ot, issuer: Ge });
            }), this.hasDataBeenLoaded && this.getDuration() > 0);
          }, Xe.prototype.seekForLive = function(We, Ge) {
            this.timeShiftJumpStartPosition = this.getCurrentTime(), this.lastSeekIssuer = Ge, this.triggerTimeShiftEvent(We, Ge), this.triggerSeekForLive({ time: We, issuer: Ge });
          }, Xe.prototype.isSeekingAllowed = function(We) {
            this.isInitialSeekToStartTime = this.isInitialSeek && this.hasStartTime(We);
            var Ge = !this.settings.GLOBAL_DISABLE_SEEKING && this.isSeekingEnabled();
            return (this.isInitialSeekToStartTime || Ge) && this.controlPermitted;
          }, Xe.prototype.isTimeShiftingAllowed = function() {
            var We = !(this.config.playback && this.config.playback.hasOwnProperty("timeShift")) || !!this.config.playback.timeShift;
            return this.isLive() && We;
          }, Xe.prototype.triggerSeek = function(We) {
            return !this.maybeDelaySeek(We) && (this.stateManager.transitionToSeekingState(We.time, We.issuer, !1), this.finishSeek(We), !0);
          }, Xe.prototype.triggerSeekForLive = function(We) {
            this.maybeDelaySeek(We, !0) || (this.stateManager.transitionToTimeShiftingState(this.getCurrentTime(), We.time, We.issuer, !1), We.time < 0 && (We.time = this.getSeekableRangeInternal().end + We.time, this.resetTimeShift()), this.finishSeek(We));
          }, Xe.prototype.maybeDelaySeek = function(We, Ge) {
            return Ge === void 0 && (Ge = !1), this.stateManager.isSeeking() && We.issuer !== "api-play" ? (this.logger.debug("Seeking already in progress, delaying seek for time", We.time), this.scheduleDelayedSeek(We, Ge, [ke.MediaElementEvent.seeked]), !0) : this.hasDataBeenLoaded ? this.getDuration() === 0 ? (this.logger.debug("Delaying the seek until stream duration is known"), this.scheduleDelayedSeek(We, Ge, [ke.MediaElementEvent.durationchange]), !0) : this.video.seekable.length < 1 && (this.logger.debug("Delaying the seek as the seekable range is not yet known"), this.scheduleDelayedSeek(We, Ge, [ke.MediaElementEvent.timeupdate, ke.MediaElementEvent.canplay]), !0) : (this.logger.debug("Delaying the seek until data is loaded"), this.scheduleDelayedSeek(We, Ge, [ke.MediaElementEvent.loadeddata]), !0);
          }, Xe.prototype.finishSeek = function(We) {
            var Ge = We.issuer === me.ADVERTISING_ISSUER_NAME, at = this.getSeekableRangeInternal();
            this.logger.debug("Seek to ".concat(We.time, ", seekable range:"), at);
            var dt = this.adjustSeekTimeForBoundaries(We.time, at, Ge);
            this.isInitialSeek = !1, this.ignoreNextDelta = this.ignoreNextDelta || this.isInitialSeekToStartTime || We.force;
            var ot = parseFloat(dt.toFixed(nt));
            this.seekTargetTime = ot, this.logger.debug("Setting time on video element from ".concat(this.getElement().currentTime, " to ").concat(ot)), this.getElement().currentTime = ot;
          }, Xe.prototype.adjustSeekTimeForBoundaries = function(We, Ge, at) {
            at === void 0 && (at = !1);
            var dt = lt(We, Ge);
            return at ? We >= Ge.end && (dt = Ge.end - Qe) : dt = Math.min(dt, Ge.end - this.settings.SEEK_TO_END_OFFSET), dt !== We && this.logger.debug("Adjusted seek target from ".concat(We, " to ").concat(dt)), dt;
          }, Xe.prototype.isSeekingEnabled = function() {
            var We = this.config && this.config.hasOwnProperty("playback") ? this.config.playback : {};
            return !We.hasOwnProperty("seeking") || We.seeking;
          }, Xe.prototype.hasStartTime = function(We) {
            var Ge = this.context.sourceContext.source ? this.context.sourceContext.source : {};
            return Ge.hasOwnProperty("options") && Ge.options.hasOwnProperty("startTime") && We === Ge.options.startTime;
          }, Xe.prototype.triggerSeekEvent = function(We, Ge) {
            Ge !== me.STARTUP_ISSUER_NAME && this.eventCallback(ge.PlayerEvent.Seek, { position: this.getCurrentTime(), seekTarget: We, issuer: Ge || "api" });
          }, Xe.prototype.triggerTimeShiftEvent = function(We, Ge) {
            Ge !== me.STARTUP_ISSUER_NAME && this.eventCallback(ge.PlayerEvent.TimeShift, { target: We < 0 ? this.timeShiftJumpStartPosition + We : We, position: this.timeShiftJumpStartPosition, issuer: Ge || "api" });
          }, Xe.prototype.waitForOnSeeked = function(We) {
            var Ge = this;
            return new Promise(function(at) {
              var dt = function() {
                We.removeEventListener(ke.MediaElementEvent.seeked, dt), at();
              };
              Ge.hlsSeekingGlitchEventHandlers.push({ el: We, ev: ke.MediaElementEvent.seeked, fn: dt }), We.addEventListener(ke.MediaElementEvent.seeked, dt);
            });
          }, Xe.prototype.waitForOnProgress = function(We, Ge) {
            var at = this;
            return new Promise(function(dt, ot) {
              var et = 0, st = function() {
                var mt = We.buffered, St = mt.length > 0 ? mt.end(mt.length - 1) : -1 / 0;
                (et += isFinite(St) ? 1 : 0) > at.settings.SAFARI_NUM_PROGRESS_EVENTS_AFTER_SEEK_GLITCH && St < Ge ? (We.removeEventListener(ke.MediaElementEvent.progress, st), ot(null)) : St >= Ge && (We.removeEventListener(ke.MediaElementEvent.progress, st), dt());
              };
              at.hlsSeekingGlitchEventHandlers.push({ el: We, ev: ke.MediaElementEvent.progress, fn: st }), We.addEventListener(ke.MediaElementEvent.progress, st);
            });
          }, Xe.prototype.verifyHLSPlaybackBuffer = function(We, Ge) {
            var at = this;
            return this.type !== $e.StreamType.Hls ? Promise.resolve() : this.waitForOnSeeked(We).then(function() {
              return at.waitForOnProgress(We, Ge);
            }).catch(function() {
              throw at.logger.debug("seek to target time (".concat(Ge, ") failed - trying to recover by seeking to ").concat(Ge + 1)), null;
            });
          }, Xe.prototype.clearDelayedSeekHandlers = function() {
            var We = this;
            Object.keys(this.lastDelayedSeekHandlers).forEach(function(Ge) {
              We.getElement().removeEventListener(Ge, We.lastDelayedSeekHandlers[Ge]);
            }), this.lastDelayedSeekHandlers = {};
          }, Xe.prototype.scheduleDelayedSeek = function(We, Ge, at) {
            var dt = this, ot = this.getElement();
            this.clearDelayedSeekHandlers(), this.delayedSeekTarget = We.time;
            var et = function(st) {
              dt.clearDelayedSeekHandlers();
              var mt = { time: (0, Ce.isNumber)(st) ? st : We.time, issuer: We.issuer, force: We.force };
              dt.verifyHLSPlaybackBuffer(ot, We.time).catch(function() {
                return et(We.time + 1);
              }), dt.delayedSeekTarget = void 0, Ge ? dt.triggerSeekForLive(mt) : dt.triggerSeek(mt);
            };
            at.forEach(function(st) {
              ot.addEventListener(st, et), dt.lastDelayedSeekHandlers[st] = et;
            });
          }, Xe.prototype.setAudio = function(We) {
            var Ge = Te.ArrayHelper.toArray(this.video.audioTracks).find(function(at) {
              return at.id === We;
            });
            Ge && this.enableAudioTrack(Ge);
          }, Xe.prototype.dispatchAudioChangedEvent = function(We, Ge) {
            this.eventCallback(ge.PlayerEvent.AudioChanged, { targetAudio: { id: Ge.id, label: Ge.label, lang: Ge.language }, sourceAudio: We, time: this.video.currentTime });
          }, Xe.prototype.enableAudioTrack = function(We) {
            if (!We.enabled) {
              var Ge = Te.ArrayHelper.toArray(this.video.audioTracks).find(function(dt) {
                return dt.enabled;
              }), at = null;
              Ge && (Ge.enabled = !1, at = this.convertAudioTrackNativeToApi(Ge)), We.enabled = !0, this.dispatchAudioChangedEvent(at, We);
            }
          }, Xe.prototype.setVolume = function(We, Ge) {
            var at = this.getElement(), dt = this.currentVol, ot = Math.min(We / 100, 1);
            dt !== ot && (this.currentVol = ot, at.volume = ot, this.eventCallback(ge.PlayerEvent.VolumeChanged, { targetVolume: 100 * ot, sourceVolume: 100 * dt, issuer: Ge || "api" }));
          }, Xe.prototype.startManifestTimeoutTimer = function() {
            var We = this;
            clearTimeout(this.loadTimeoutID), this.hasSourceBeenLoaded || (this.loadTimeoutID = setTimeout(function() {
              We.loadTimeoutID = null, !We.hasSourceBeenLoaded && We.eventHandler && (We.type === $e.StreamType.Hls ? We.eventHandler.fireError(new le.PlayerError(fe.ErrorCode.NETWORK_MANIFEST_DOWNLOAD_TIMEOUT, { sourceUrl: We.sourceConfig.url }, "Failed to load the HLS playlist: the request timed out.")) : We.type === $e.StreamType.Progressive && We.eventHandler.fireError(new le.PlayerError(fe.ErrorCode.NETWORK_PROGRESSIVE_STREAM_DOWNLOAD_TIMEOUT, { sourceUrl: We.sourceConfig.url }, "Failed to load the progressive source: the request timed out.")));
            }, (0, Ne.toMilliSeconds)(this.settings.XHR_TIMEOUT / 2)));
          }, Xe.getContentDomain = function(We) {
            var Ge = document.createElement("a");
            return Ge.href = We, Ge.host === "" && (Ge.href = Ge.href), Ge.hostname;
          }, Xe.prototype.trackLoading = function(We) {
            var Ge;
            (0, Ae.isTizen)() && ((Ge = this.assetAvailabilityChecker) === null || Ge === void 0 || Ge.dispose(), this.assetAvailabilityChecker = new Be.AssetAvailabilityChecker(this.context, We, this.video));
          }, Xe.prototype.prepareLoad = function() {
            return Promise.resolve();
          }, Xe.prototype.load = function(We, Ge, at) {
            var dt = this;
            this.stateManager = this.context.serviceManager.get(ce.ServiceName.PlayerStateService), this.stateManager.transitionToSeekedState(!1), this.video.setAttribute("preload", "metadata"), this.type = this.context.sourceContext.technology.streaming, this.sourceConfig = We, We.type && (this.type = We.type), this.loaded === !0 && this.unload().catch(function() {
            }), this.hasSourceBeenLoaded = !1, this.hasDataBeenLoaded = !1, this.getElement().nativeMediaEventListener.reset(), this.isInitialSeek = !0, this.ignoreNextVideoError = !1, this.sourceLoadRetryCount = 0, this.delayedSeekTarget = void 0, this.isSourceBeingRedirected = !1, We.hasOwnProperty("vr") && We.vr && We.vr.restrictedInlinePlayback ? (this.restrictedInlinePlayback = !0, this.audio = xe.Util.getVRAudioElement(), this.addEventListeners(this.audio)) : (this.audio = null, this.restrictedInlinePlayback = !1, this.addEventListeners(this.video)), this.eventHandler.on(ge.PlayerEvent.TimeChanged, this.onTimeChanged), this.unsubscribeFromStoreStoppedListener = (0, Pe.subscribe)(this.context.store)(function(mt) {
              return (0, Se.getIsStopped)((0, Se.getPlayerState)(mt));
            }, this.onContentPlaybackFinished, function(mt) {
              return mt === !0;
            }), this.settings.GLOBAL_DISABLE_SEEKING = Ge || !1, this.seekingTimeoutId > -1 && (clearTimeout(this.seekingTimeoutId), this.seekingTimeoutId = -1);
            var ot = "";
            We && We.url && (typeof We.url == "string" ? ot = We.url : We.url.length > 0 && (ot = We.url[0].url));
            var et = window.location.hostname === Xe.getContentDomain(ot);
            We.hasOwnProperty("vr") && We.vr && !et && (this.originalCrossOriginAttributeValue = this.video.getAttribute("crossOrigin"), this.video.setAttribute("crossOrigin", "anonymous")), this.video.eventHandler.reset(), this.isProgressiveQualityChange || (this.textTrackController = this.createTextTrackController()), this.loadingDeferred = new Ee.Deferred();
            var st = this.loadSource(We, at);
            return this.loadingDeferred.promise.then(function() {
              dt.context.sourceContext.source = We.config;
            }).then(function() {
              return st;
            }).then(function() {
              return dt.initializeLoadedState(We);
            });
          }, Xe.prototype.maybeHandleRedirectedSource = function(We) {
            var Ge = this;
            (0, Ae.isSafari17orIOS17)() && fetch(We.url, { method: Re.HttpRequestMethod.GET, headers: { Range: "bytes=0-0" } }).then(function(at) {
              at.redirected && (Ge.logger.debug("Detected source redirection."), Ge.hasDataBeenLoaded && Ge.loadingDeferred.resolve(), Ge.isSourceBeingRedirected = !0);
            }).catch(function() {
            });
          }, Xe.prototype.loadSource = function(We, Ge) {
            var at = this;
            return this.type === $e.StreamType.Hls ? (this.maybeHandleRedirectedSource(We), this.loadHls(We)) : this.type === $e.StreamType.Progressive ? this.loadProgressive(We, Ge).then(function() {
              return at.loadVideoElement();
            }) : Promise.resolve();
          }, Xe.prototype.initializeLoadedState = function(We) {
            this.currentSource = We, this.loaded = !0, this.lastLegalPlaybackPosition = 0, this.ignoreNextDelta = !1;
          }, Xe.prototype.loadVideoElement = function() {
            this.config.tweaks.prevent_video_element_preloading || this.video.load();
          }, Xe.prototype.setupVideoElement = function(We, Ge) {
            var at = this;
            if (We.config.drm && We.config.drm.fairplay) {
              var dt = Le.ModuleManager.get(De.ModuleName.DRM).FairplayHandler;
              this.fpsHandler = new dt(this.context, this.video, We.config.drm.fairplay);
            }
            var ot = Xe.createSourceElement(Ge, null);
            this.appendAndSetVideoStream(ot, "0", We), this.trackLoading(ot);
            var et = { element: ot, handler: function(st) {
              return at.handleStreamErrorEvent(fe.ErrorCode.SOURCE_HLS_STREAM_ERROR, ot.src, st);
            } };
            this.sourceElementEventListeners.push(et), et.element.addEventListener(ke.MediaElementEvent.error, et.handler);
          }, Xe.prototype.setSourceAndLoadVideoElement = function(We, Ge) {
            this.setupVideoElement(We, Ge), this.loadVideoElement();
          }, Xe.prototype.setVideoForServiceWorker = function(We, Ge) {
            var at = this, dt = Ie.URLHelper.appendQueryParametersToUrl(Ge, ae(ae({}, this.context.config.tweaks.query_parameters), { "bitmovin-player-id": this.context.internalPlayerID }));
            return this.setSourceAndLoadVideoElement(We, dt), this.hlsManifestController.resolveMasterManifest(We.url).then(function() {
            }).catch(function(ot) {
              at.logger.debug("Couldn't access master playlist with ServiceWorker: ".concat(ot));
            });
          }, Xe.prototype.setVideoForNativeHLSParsing = function(We, Ge) {
            var at = this;
            return Ke.createHlsManifestController(this.context).then(function(dt) {
              return at.hlsManifestController = dt, at.settings.NATIVE_HLS_DOWNLOAD_ERROR_HANDLING && (at.downloadErrorHandler = new Fe.HlsDownloadErrorHandler(at.context, dt)), Ke.shouldUseServiceWorker(at.context) ? at.setVideoForServiceWorker(We, Ge) : at.hlsManifestController.resolveMasterManifest(We.url).then(function(ot) {
                ot.indexOf("data") !== 0 && ot.indexOf("blob") !== 0 || at.setSourceAndLoadVideoElement(We, ot);
              }).catch(function(ot) {
                at.logger.debug("Couldn't access master playlist for native HLS parsing: ".concat(ot));
              });
            });
          }, Xe.prototype.loadHls = function(We) {
            var Ge;
            if (typeof We.url != "string") {
              var at = new le.PlayerError(fe.ErrorCode.SOURCE_INVALID, { given: We.url }, "Cannot load the HLS playlist: the source URL should be a string.");
              return (Ge = this.eventHandler) === null || Ge === void 0 || Ge.fireError(at), this.loadingDeferred.reject(at), Promise.resolve();
            }
            var dt = this.adjustToFullUrlWithQueryParams(We.url);
            return this.settings.NATIVE_HLS_PARSING ? this.setVideoForNativeHLSParsing(We, dt) : (this.setSourceAndLoadVideoElement(We, dt), Promise.resolve());
          }, Xe.prototype.loadProgressive = function(We, Ge) {
            if (this.availableVideoStreams = [], Array.isArray(We.url))
              this.loadProgressiveMultiSource(We.url, Ge);
            else {
              var at = { url: We.url, bitrate: 0 };
              this.video.src = this.adjustToFullUrlWithQueryParams(at.url), this.addStreamToAvailableOnes("0", at), this.setCurrentVideoStream("0", at), this.trackLoading(this.video.getWrappedElement());
            }
            return Promise.resolve();
          }, Xe.prototype.loadProgressiveMultiSource = function(We, Ge) {
            var at = this, dt = !1;
            Ge = Ge || pt(We);
            var ot = this.loadAllSupportedProgressiveSources(We, Ge, !dt);
            if (ot) {
              var et = { element: ot, handler: function(st) {
                return at.handleStreamErrorEvent(fe.ErrorCode.SOURCE_PROGRESSIVE_STREAM_ERROR, ot.src, st);
              } };
              this.sourceElementEventListeners.push(et), et.element.addEventListener(ke.MediaElementEvent.error, et.handler), this.restrictedInlinePlayback && this.audio && this.audio.load(), this.trackLoading(ot);
            }
          }, Xe.prototype.handleStreamErrorEvent = function(We, Ge, at) {
            var dt, ot = this;
            clearTimeout(this.loadTimeoutID), (dt = this.assetAvailabilityChecker) === null || dt === void 0 || dt.dispose(), this.loaded = !0, this.logger.debug("Caught a stream error event (".concat(We, ", ").concat(Ge, ")"), at), new be.DefaultContentLoader(this.context).load(Ge).then(function(et) {
              return { status: et.status, statusText: et.statusText, error: void 0 };
            }).catch(function(et) {
              return { error: et, status: (et == null ? void 0 : et.status) || 0, statusText: (et == null ? void 0 : et.statusText) || "" };
            }).then(function(et) {
              var st, mt = et.error, St = et.status, bt = et.statusText, it = (at == null ? void 0 : at.message) || at, ht = function(vt, gt) {
                ot.loadingDeferred.reject(new le.PlayerError(vt, gt, "The video element has thrown an error while loading the stream."));
              };
              St !== 200 ? (st = { event: at, error: mt, status: St, statusText: bt, src: Ge, extraMessage: it }, ot.logger.debug("last/only source has thrown an error ".concat(St, " - ").concat(bt), st), ht(We, st)) : (st = { event: at, error: mt, src: Ge, extraMessage: it }, ot.logger.debug("last/only source has thrown an error, but we are able to download the asset during the error handling.", st), ot.sourceConfig && ot.sourceLoadRetryCount < ot.settings.MAX_RETRIES ? (ot.sourceLoadRetryCount++, ot.logger.debug("Reloading the source: attempt ".concat(ot.sourceLoadRetryCount, " of ").concat(ot.settings.MAX_RETRIES, ".")), ot.loadSource(ot.sourceConfig).catch(function() {
                return ht(We, st);
              })) : ht(We, st));
            });
          }, Xe.prototype.loadAllSupportedProgressiveSources = function(We, Ge, at) {
            for (var dt, ot = [], et = -1, st = null, mt = null, St = 0; St < We.length; St++) {
              var bt = We[St];
              if (!this.shouldIgnoreSourceObject(bt, mt, at)) {
                if (dt = Xe.createSourceElement(this.adjustToFullUrlWithQueryParams(bt.url), bt.type), mt = mt || bt.type, this.addStreamToAvailableOnes(String(St), bt), at) {
                  if (ot.indexOf(bt.type) > -1) {
                    this.logger.debug("Stream of mime type ".concat(bt.type, " already added.. continuing"));
                    continue;
                  }
                  Ge === String(St) ? (st = dt, et = bt.bitrate, this.appendAndSetVideoStream(dt, String(St), bt), ot.push(bt.type)) : et === bt.bitrate && (st = dt, this.appendVideoStream(dt), ot.push(bt.type));
                } else
                  st = dt, this.appendAndSetVideoStream(dt, String(St), bt);
                this.restrictedInlinePlayback && this.audio && (this.audio.innerHTML = this.video.innerHTML);
              }
            }
            return st;
          }, Xe.prototype.shouldIgnoreSourceObject = function(We, Ge, at) {
            return !Xe.isValidProgressiveSourceObject(We) || !!at && (!this.isMimeTypeSupported(We.type) || !!Ge && Ge !== We.type);
          }, Xe.isValidProgressiveSourceObject = function(We) {
            return typeof We == "object" && We && We.url && We.url !== "";
          }, Xe.prototype.appendAndSetVideoStream = function(We, Ge, at) {
            this.video.appendChild(We), this.setCurrentVideoStream(Ge, at);
          }, Xe.prototype.appendVideoStream = function(We) {
            this.video.appendChild(We);
          }, Xe.prototype.addStreamToAvailableOnes = function(We, Ge) {
            var at = { id: We };
            Ge.bitrate && (at.bitrate = Ge.bitrate), at.label = String(Ge.label || Ge.bitrate || "unknown"), this.availableVideoStreams.push(at);
          }, Xe.prototype.setCurrentVideoStream = function(We, Ge) {
            this.currentVideoStream = { id: We }, Ge.bitrate && (this.currentVideoStream.bitrate = Ge.bitrate), this.currentVideoStream.label = "" + (Ge.label || Ge.bitrate || "unknown");
          }, Xe.prototype.isMimeTypeSupported = function(We) {
            return !(this.video.canPlayType(We).length <= 0) || (this.logger.debug("Mime type" + We + " not supported.. continuing"), !1);
          }, Xe.createSourceElement = function(We, Ge) {
            var at = document.createElement("source");
            return at.src = We, Ge && (Ge.indexOf("/") < 0 && (Ge = "video/" + Ge), at.type = Ge), at;
          }, Xe.prototype.unload = function(We, Ge) {
            var at, dt;
            return We === void 0 && (We = "api"), Ge === void 0 && (Ge = !1), this.hlsLiveTimeTracker.onUnload(We), this.clearDelayedSeekHandlers(), this.loadingDeferred && !Ge && this.loadingDeferred.reject(), clearTimeout(this.loadedDataFallbackTimeoutID), clearTimeout(this.loadTimeoutID), (at = this.assetAvailabilityChecker) === null || at === void 0 || at.dispose(), this.ended = !1, this.fpsHandler = (0, he.dispose)(this.fpsHandler), this.downloadErrorHandler = (0, he.dispose)(this.downloadErrorHandler), this.hlsManifestController = (0, he.dispose)(this.hlsManifestController), this.hlsSeekingGlitchEventHandlers.forEach(function(ot) {
              return ot.el.removeEventListener(ot.ev, ot.fn);
            }), this.hlsSeekingGlitchEventHandlers = [], this.isProgressiveQualityChange || ((dt = this.textTrackController) === null || dt === void 0 || dt.signalSourceChange(), this.textTrackController = (0, he.dispose)(this.textTrackController)), this.clearVideoElement(), this.clearAudioElement(), this.pause(), this.ignoreNextVideoError = !0, this.clearEventListeners(), this.unsubscribeFromStoreStoppedListener && this.unsubscribeFromStoreStoppedListener(), this.allowedToThrowEvents && (this.currentVideoStream = null), this.loaded && (this.loaded = !1, Ge || (this.eventCallback(ge.PlayerEvent.SourceUnloaded, { oldSource: this.currentSource }), this.lastDuration = null)), Promise.resolve();
          }, Xe.prototype.clearAudioElement = function() {
            if (this.restrictedInlinePlayback && this.audio) {
              for (this.audio.removeAttribute("src"); this.audio.firstChild; )
                this.audio.removeChild(this.audio.firstChild);
              this.audio.load();
            }
          }, Xe.prototype.clearEventListeners = function() {
            var We = this;
            this.restrictedInlinePlayback ? this.audio && this.removeEventListeners(this.audio) : this.removeEventListeners(this.video), this.clearDelayedSeekHandlers(), this.eventHandler.off(ge.PlayerEvent.TimeChanged, this.onTimeChanged), this.eventHandler.off(ge.PlayerEvent.TimeChanged, this.delayedSeek), this.sourceElementEventListeners.forEach(function(Ge) {
              try {
                Ge.element.removeEventListener(ke.MediaElementEvent.error, Ge.handler);
              } catch (at) {
                We.logger.debug("Error while removing event listener", at);
              }
            });
          }, Xe.prototype.clearVideoElement = function() {
            Ue.VideoElementUtil.removeSource(this.video), this.originalCrossOriginAttributeValue != null ? this.video.setAttribute("crossOrigin", this.originalCrossOriginAttributeValue) : this.video.removeAttribute("crossOrigin"), this.video.load();
          }, Xe.prototype.isReady = function() {
            return this.restrictedInlinePlayback && this.audio && "readyState" in this.audio ? this.audio.readyState !== HTMLMediaElement.HAVE_NOTHING : !("readyState" in this.video) || this.video.readyState !== HTMLMediaElement.HAVE_NOTHING;
          }, Xe.prototype.isLive = function() {
            return this.getElement().duration === 1 / 0;
          }, Xe.prototype.isPlaying = function() {
            return this.stateManager.isPlaying();
          }, Xe.prototype.isPaused = function() {
            return this.stateManager.isPaused();
          }, Xe.prototype.hasEnded = function() {
            return this.ended;
          }, Xe.prototype.isMuted = function() {
            return this.getElement().muted;
          }, Xe.prototype.isStalled = function() {
            return this.stateManager.isStalled;
          }, Xe.prototype.getVolume = function() {
            return 100 * this.getElement().volume;
          }, Xe.prototype.getDuration = function() {
            return this.getElement().duration;
          }, Xe.prototype.convertAudioTrackNativeToApi = function(We) {
            var Ge = { id: We.id || String(Te.ArrayHelper.toArray(this.video.audioTracks).indexOf(We)), label: We.label, lang: We.language, getQualities: null }, at = this.getLabelForAudio(Ge);
            return at && typeof at == "string" && (Ge.label = at), Ge;
          }, Xe.prototype.getAudio = function() {
            var We = Te.ArrayHelper.toArray(this.video.audioTracks).find(function(Ge) {
              return Ge.enabled;
            });
            return We ? this.convertAudioTrackNativeToApi(We) : null;
          }, Xe.prototype.getAvailableAudio = function() {
            var We = this;
            return Te.ArrayHelper.toArray(this.video.audioTracks).map(function(Ge) {
              return We.convertAudioTrackNativeToApi(Ge);
            });
          }, Xe.prototype.getLabelForAudio = function(We) {
            var Ge = { id: We.id, lang: We.lang, mimeType: Me.MimeType.AudioMp4 };
            return this.getLabelingFunctionForAudio()(Ge);
          }, Xe.prototype.getLabelingFunctionForAudio = function() {
            var We = this.context.sourceContext, Ge = We && We.source && We.source.labeling;
            return Ge && Ge[this.type] && Ge[this.type].tracks ? typeof Ge[this.type].tracks != "function" ? Xe.getDefaultLabelForAudio : Ge[this.type].tracks : Xe.getDefaultLabelForAudio;
          }, Xe.getDefaultLabelForAudio = function() {
            return null;
          }, Xe.prototype.getDownloadedVideoData = function() {
            return this.type === $e.StreamType.Progressive ? this.currentVideoStream : this.hlsManifestController ? this.hlsManifestController.getDownloadedVideoData() : { id: ze, bitrate: 0, height: 0, width: 0, isAuto: !0 };
          }, Xe.prototype.getDownloadedAudioData = function() {
            return { id: ze, bitrate: 0, isAuto: this.type === $e.StreamType.Progressive };
          }, Xe.prototype.createVideoQualityObject = function(We) {
            var Ge = {};
            return Ge.id = We.id, Ge.label = We.label, We.width > 1 ? Ge.width = We.width : this.currentVideoStream && this.currentVideoStream.id === We.id && (this.currentVideoStream.width > 1 ? Ge.width = this.currentVideoStream.width : !isNaN(this.video.videoWidth) && this.video.videoWidth > 1 && (Ge.width = this.video.videoWidth)), We.height > 1 ? Ge.height = We.height : this.currentVideoStream && this.currentVideoStream.id === We.id && (this.currentVideoStream.height > 1 ? Ge.height = this.currentVideoStream.height : !isNaN(this.video.videoHeight) && this.video.videoHeight > 1 && (Ge.height = this.video.videoHeight)), We.bitrate !== void 0 && We.bitrate !== "unknown" && (Ge.bitrate = We.bitrate), Ge;
          }, Xe.prototype.getPlaybackVideoData = function() {
            if (this.hlsManifestController) {
              var We = this.hlsManifestController.getPlayingVideoData();
              if (We)
                return We;
            }
            if (this.currentVideoStream) {
              var Ge = this.createVideoQualityObject(this.currentVideoStream);
              return this.type !== "progressive" && (Ge.id = ze), Ge;
            }
            return { id: ze, bitrate: 0, height: this.video.videoHeight, width: this.video.videoWidth };
          }, Xe.prototype.getPlaybackAudioData = function() {
            return { id: ze, bitrate: 0 };
          }, Xe.prototype.getMaxTimeShift = function() {
            if (!this.isTimeShiftingAllowed())
              return 0;
            var We = this.getSeekableRangeInternal();
            return this.isHlsLive() && We.start >= 0 ? We.start - We.end : 0;
          }, Xe.prototype.isHlsLive = function() {
            return this.type === $e.StreamType.Hls && this.isLive();
          }, Xe.prototype.timeShift = function(We, Ge) {
            if (this.isTimeShiftingAllowed() && this.isTimeShiftNecessary(We, Ge))
              if (We === 0) {
                var at = this.getSeekableRangeInternal();
                at.end >= 0 && this.seekForLive(at.end);
              } else
                this.seekForLive(We, Ge);
          }, Xe.prototype.isTimeShiftNecessary = function(We, Ge) {
            if (Ge === me.STARTUP_ISSUER_NAME && !ft(this.context.sourceContext.source.options))
              return !1;
            var at = Math.abs(Math.abs(We) - Math.abs(this.getTimeShift())), dt = this.isOffsetConsideredAsLiveEdge(We);
            return at > qe && !(this.isAtLiveEdge && dt);
          }, Xe.prototype.getTimeShift = function() {
            if (this.shouldReturnDefaultTimeshiftValue())
              return ut;
            var We = this.getSeekableRangeInternal();
            if (We.start >= 0 && this.needToUpdateTimeshiftValue()) {
              var Ge = lt(this.getElement().currentTime - We.end, this.getTimeshiftRange());
              this.isAtLiveEdge = this.isOffsetConsideredAsLiveEdge(Ge) && !this.isStalledOrPaused(), this.currentTimeShift = this.isAtLiveEdge ? ut : Ge;
            }
            return isFinite(this.currentTimeShift) ? this.currentTimeShift : ut;
          }, Xe.prototype.shouldReturnDefaultTimeshiftValue = function() {
            return !this.isLive() || !this.stateManager.hasBeenPlaying && !this.stateManager.seekedOrTimeshifted || this.isAtLiveEdge;
          }, Xe.prototype.isStalledOrPaused = function() {
            return this.isStalled() || this.isPaused();
          }, Xe.prototype.needToUpdateTimeshiftValue = function() {
            return !isFinite(this.currentTimeShift) || this.isStalledOrPaused();
          }, Xe.prototype.getManifest = function() {
            return this.hlsManifestController ? this.hlsManifestController.getManifest() : null;
          }, Xe.prototype.getSnapshot = function(We, Ge) {
            if (this.isPlaying() || this.isPaused()) {
              var at = this.video.videoWidth, dt = this.video.videoHeight;
              if (this.snapshotCanvas || (this.snapshotCanvas = document.createElement("canvas"), this.snapshotCanvas.id = "snapshotHiddenCanvas"), !this.snapshotCanvas || !this.snapshotCanvas.getContext || !this.snapshotCanvas.getContext("2d"))
                return;
              this.snapshotCanvas.height = dt, this.snapshotCanvas.width = at, this.snapshotCanvasContext = this.snapshotCanvas.getContext("2d"), this.snapshotCanvasContext.drawImage(this.video.getWrappedElement(), 0, 0, at, dt);
              var ot = void 0;
              try {
                We === "image/jpeg" || We === "image/webp" ? (Number(Ge) === Ge ? (Ge < 0 || Ge > 1) && (Ge = 1) : Ge = 1, ot = this.snapshotCanvas.toDataURL(We, Ge)) : ot = this.snapshotCanvas.toDataURL(We, Ge);
              } catch (et) {
                return void (et && et.message ? this.logger.debug("Snapshot acquisition failed: " + et.message) : this.logger.debug("Snapshot acquisition failed"));
              }
              return { height: dt, width: at, data: ot };
            }
          }, Xe.prototype.setPlaybackSpeed = function(We) {
            this.getElement().playbackRate = We;
          }, Xe.prototype.getPlaybackSpeed = function() {
            return this.getElement().playbackRate;
          }, Xe.prototype.permitControl = function(We) {
            this.controlPermitted = We;
          }, Xe.prototype.resetTimeShift = function() {
            this.currentTimeShift = -1 / 0, this.isTimeShiftingAllowed() && (this.isAtLiveEdge = !1);
          }, Xe.prototype.isOffsetConsideredAsLiveEdge = function(We) {
            return Math.abs(We) < 2 * this.settings.SEEK_TO_END_OFFSET;
          }, Xe.prototype.isSeekTargetChangedDuringStartup = function() {
            return this.seekTargetTime !== this.lastVerifiedPlaybackPosition && this.lastSeekIssuer === me.STARTUP_ISSUER_NAME;
          }, Xe.prototype.maybeHandleSeekTargetChangeDuringStartup = function() {
            this.isSeekTargetChangedDuringStartup() && (this.context.logger.debug("Seek target changed during startup..."), this.triggerSeekEvent(this.seekTargetTime), this.lastSeekIssuer = "api", this.seekTargetTime = -1);
          }, Xe.prototype.finishedSeekedTransitionState = function() {
            this.stateManager.isSeeking() && (this.stateManager.transitionToSeekedState(this.lastSeekIssuer !== me.STARTUP_ISSUER_NAME), this.lastSeekIssuer = "api"), this.stateManager.isTimeShifting() && this.stateManager.transitionToTimeShiftedState(this.lastSeekIssuer !== me.STARTUP_ISSUER_NAME);
          }, Xe.prototype.addEventListeners = function(We) {
            for (var Ge = 0; Ge < this.elementEvents.length; Ge++) {
              var at = this.elementEvents[Ge].elementSelector ? this.elementEvents[Ge].elementSelector(We) : We;
              at && at.addEventListener(this.elementEvents[Ge].event, this.elementEvents[Ge].handler);
            }
          }, Xe.prototype.removeEventListeners = function(We) {
            for (var Ge = 0; Ge < this.elementEvents.length; Ge++) {
              var at = this.elementEvents[Ge].elementSelector ? this.elementEvents[Ge].elementSelector(We) : We;
              at && at.removeEventListener && at.removeEventListener(this.elementEvents[Ge].event, this.elementEvents[Ge].handler);
            }
          }, Xe.prototype.getBufferLevel = function(We) {
            var Ge = { level: null, targetLevel: null, type: We, media: $e.MediaType.Video }, at = this.getElement();
            if (!at.buffered || at.buffered.length < 1)
              return Ge;
            var dt = function(St) {
              for (var bt = 0; bt < at.buffered.length; bt++) {
                var it = at.buffered.start(bt), ht = at.buffered.end(bt);
                it > St || ht <= St || (Ge.level = ht - St, We === $e.BufferType.BackwardDuration && (Ge.level = St - it));
              }
            }, ot = at.currentTime;
            if (dt(ot), Ge.level == null) {
              var et = $t(at, ot), st = et.distanceToCurrentTime, mt = et.closestBufferStart;
              st < 1 && (this.context.logger.debug("Adjusting buffer level to closest buffer range ", mt), dt(mt));
            }
            return Ge;
          }, Xe.prototype.createTextTrackController = function() {
            if (Le.ModuleManager.has(De.ModuleName.SubtitlesNative))
              return new (Le.ModuleManager.get(De.ModuleName.SubtitlesNative)).TextTrackController(this.context, this.video, this.config, this.type);
            this.logger.log("Unable to create native SubtitleController because the ".concat(De.ModuleName.SubtitlesNative, " module is missing"));
          }, Xe.prototype.removeSubtitle = function(We) {
            We && this.textTrackController && this.textTrackController.removeSubtitle(We);
          }, Xe.prototype.addSubtitle = function(We) {
            return this.textTrackController ? (this.removeSubtitle(We.id), We.kind = "subtitles", this.textTrackController.addSubtitle(We)) : Promise.reject();
          }, Xe.prototype.listSubtitles = function() {
            return this.textTrackController ? this.textTrackController.getAvailableSubtitles() : [];
          }, Xe.prototype.enableSubtitle = function(We) {
            return this.textTrackController ? this.textTrackController.enableSubtitle(We) : Promise.resolve(!1);
          }, Xe.prototype.disableSubtitle = function(We) {
            return this.textTrackController ? Promise.resolve(this.textTrackController.disableSubtitle(We)) : Promise.resolve(!1);
          }, Xe.prototype.adjustToFullUrlWithQueryParams = function(We) {
            var Ge = Ie.URLHelper.toFullUrl(We);
            return Ie.URLHelper.appendQueryParametersToUrl(Ge, this.settings.QUERY_PARAMETERS);
          }, Xe.prototype.onFullscreenEnter = function() {
            this.isInNativeFullscreen = this.video.webkitDisplayingFullscreen, this.textTrackController && this.isInNativeFullscreen && this.textTrackController.enableNative();
          }, Xe.prototype.onFullscreenExit = function() {
            this.textTrackController && this.isInNativeFullscreen && this.textTrackController.disableNative(), this.isInNativeFullscreen = !1;
          }, Xe.prototype.getAvailableVideoQualities = function() {
            var We = this;
            return this.type !== "progressive" ? [] : this.availableVideoStreams.map(function(Ge) {
              return We.createVideoQualityObject(Ge);
            });
          }, Xe.prototype.getBufferedRanges = function() {
            var We = this;
            return (0, _e.getBufferedRanges)(this.getElement()).map(function(Ge) {
              return (0, _e.convertRangeToTimeMode)(Ge, We.getStartDate(), $e.TimeMode.AbsoluteTime);
            });
          }, Xe.prototype.setVideoQuality = function(We) {
            var Ge, at = this, dt = this.getPlaybackSpeed(), ot = this.availableVideoStreams.find(function(St) {
              return St.id === We;
            });
            if (this.type === "progressive" && ot && (!this.currentVideoStream || this.currentVideoStream.id !== We)) {
              this.isProgressiveQualityChange = !0, this.currentTimeWas = this.getCurrentTime(), this.availableVideoStreams = [], this.allowedToThrowEvents = !1;
              var et = this.stateManager.isPlaying() || this.stateManager.isPlay();
              this.stateManager.stallEnter(), this.unload("api", !0).catch(function() {
              });
              var st = this.createVideoQualityObject(ot), mt = { sourceQuality: this.currentVideoStream, sourceQualityId: this.currentVideoStream ? this.currentVideoStream.id : null, targetQuality: st, targetQualityId: st.id };
              this.eventHandler.one(ge.PlayerEvent.StallEnded, function() {
                at.allowedToThrowEvents = !0, (0, we.getCapabilities)().isIOS || (0, we.getCapabilities)().isSafari ? (at.numTimeChanged = 0, at.eventHandler.on(ge.PlayerEvent.TimeChanged, at.delayedSeek)) : (at.numTimeChanged = 1 / 0, at.delayedSeek()), et && (at.play(me.INTERNAL_ISSUER_NAME).catch(function() {
                  at.eventCallback(ge.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.PLAYBACK_COULD_NOT_BE_STARTED));
                }), at.stateManager.transitionToPlayingState(me.INTERNAL_ISSUER_NAME, !1));
              }), this.eventCallback(ge.PlayerEvent.VideoQualityChanged, ae({}, mt), !0), (Ge = this.airplayService) === null || Ge === void 0 || Ge.initAirplay(), this.load(this.sourceConfig, this.settings.GLOBAL_DISABLE_SEEKING, We).then(function() {
                at.setPlaybackSpeed(dt), at.eventCallback(ge.PlayerEvent.VideoDownloadQualityChange, ae({}, mt), !0), at.eventCallback(ge.PlayerEvent.VideoDownloadQualityChanged, ae({}, mt), !0), at.eventCallback(ge.PlayerEvent.VideoPlaybackQualityChanged, { sourceQuality: mt.sourceQuality, targetQuality: mt.targetQuality }, !0);
              });
            }
          }, Xe.prototype.isAirplayAvailable = function() {
            var We, Ge;
            return (Ge = (We = this.airplayService) === null || We === void 0 ? void 0 : We.isAirplayAvailable()) !== null && Ge !== void 0 && Ge;
          }, Xe.prototype.isAirplayActive = function() {
            var We, Ge;
            return (Ge = (We = this.airplayService) === null || We === void 0 ? void 0 : We.isAirplayActive()) !== null && Ge !== void 0 && Ge;
          }, Xe.prototype.showAirplayTargetPicker = function() {
            var We;
            (We = this.airplayService) === null || We === void 0 || We.showAirplayTargetPicker();
          }, Xe.prototype.getTimeshiftRange = function() {
            return this.isLive() ? { start: this.getMaxTimeShift(), end: 0 } : { start: -1, end: -1 };
          }, Xe.prototype.getSeekableRangeInternal = function() {
            var We = this.video.seekable;
            if (We.length > 0) {
              var Ge = { start: We.start(0), end: We.end(0) };
              return Ge.start = Math.max(0, Ge.start), Ge;
            }
            return { start: -1, end: -1 };
          }, Xe.prototype.getSeekableRange = function() {
            if (!this.isLive() || this.settings.ENABLE_SEEK_FOR_LIVE) {
              var We = this.getStartDate(), Ge = this.getSeekableRangeInternal();
              return We ? (0, _e.convertRangeToTimeMode)(Ge, We, $e.TimeMode.AbsoluteTime) : Ge;
            }
            return { start: -1, end: -1 };
          }, Xe.prototype.createManifestApi = function() {
            return this.hlsManifestController ? Ze.NativePlayerManifestApiFactory.create(this.hlsManifestController) : null;
          }, Xe.prototype.release = function() {
            var We, Ge = this, at = this.unload("api").catch(function() {
            });
            return clearTimeout(this.loadTimeoutID), at = at.then(function() {
              Ge.type = null, Ge.config = null, Ge.eventHandler = null, Ge.settings = null, Ge.currentTimeWas = null, Ge.snapshotCanvas = null, Ge.snapshotCanvasContext = null, Ge.audio = null, Ge.video = null, Ge.lastPlayIssuer = null, Ge.lastPauseIssuer = null, Ge.lastSeekIssuer = null, Ge.currentSource = null, Ge.sourceConfig = null, Ge.currentVideoStream = null, Ge.availableVideoStreams = null, Ge.sourceElementEventListeners = null, Ge.delayedSeekTarget = void 0;
            }), (We = this.airplayService) === null || We === void 0 || We.dispose(), this.textTrackController && this.textTrackController.dispose(), this.textTrackController = null, this.fpsHandler && this.fpsHandler.dispose(), this.fpsHandler = null, this.downloadErrorHandler && this.downloadErrorHandler.dispose(), this.downloadErrorHandler = null, this.hlsManifestController && this.hlsManifestController.dispose(), this.hlsManifestController = null, at;
          }, Xe.prototype.setQueryParameters = function(We) {
            this.settings.QUERY_PARAMETERS = We;
          }, Xe.prototype.clearQueryParameters = function() {
            this.settings.QUERY_PARAMETERS = void 0;
          }, Xe.prototype.setAudioQuality = function(We) {
          }, Xe.prototype.setTargetBufferLevel = function() {
          }, Xe.prototype.getAvailableAudioQualities = function() {
            return [];
          }, Xe.prototype.getDroppedVideoFrames = function() {
            return 0;
          }, Xe.prototype.getTotalStalledTime = function() {
            return 0;
          }, Xe.prototype.updateCallback = function(We) {
          }, Xe.prototype.getAvailableSegments = function() {
            return {};
          }, Xe.prototype.getLatency = function() {
            var We = this.video.getWrappedElement();
            if (!We.getStartDate)
              return 1 / 0;
            var Ge = We.getStartDate().getTime();
            if (isNaN(Ge))
              return 1 / 0;
            var at = (/* @__PURE__ */ new Date()).getTime();
            return (0, Ne.toSeconds)(at - Ge) - this.video.currentTime;
          }, Xe.prototype.setTargetLatency = function(We) {
          }, Xe.prototype.getTargetLatency = function() {
            return null;
          }, Xe.prototype.setCatchupConfig = function(We) {
          }, Xe.prototype.getCatchupConfig = function() {
            return null;
          }, Xe.prototype.setFallbackConfig = function(We) {
          }, Xe.prototype.getFallbackConfig = function() {
            return null;
          }, ue([(0, pe.trackPerformance)("NativePlayer.load", !0)], Xe.prototype, "load", null), Xe;
        }();
        function $t(Xe, We) {
          for (var Ge = Xe.buffered.start(0), at = Math.abs(Ge - We), dt = 1; dt < Xe.buffered.length; dt++) {
            var ot = Math.abs(Xe.buffered.start(dt) - We);
            ot < at && (at = ot, Ge = Xe.buffered.start(dt));
          }
          return { distanceToCurrentTime: at, closestBufferStart: Ge };
        }
        function ft(Xe) {
          return (Xe == null ? void 0 : Xe.startTime) != null || (Xe == null ? void 0 : Xe.startOffset) != null;
        }
        function pt(Xe) {
          var We = Xe.findIndex(function(Ge) {
            return Ge.preferred === !0;
          });
          return We > -1 ? String(We) : "0";
        }
        function lt(Xe, We) {
          return (Xe < We.start || Xe > We.end) && (Xe = Math.max(Xe, We.start), Xe = Math.min(Xe, We.end)), Xe;
        }
        function Je(Xe) {
          return Xe.length > 0 && Xe.end(Xe.length - 1) !== 1 / 0;
        }
        ie.NativePlayer = yt;
      }, 55194: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.NativePlayerManifestApiFactory = void 0;
        var ae = ne(42283), ue = function() {
          function _e() {
          }
          return _e.create = function(fe) {
            var le = fe.getParsedManifest();
            return fe.isValidMasterPlaylist(le) ? new (function() {
              function se() {
                this.hls = _e.createHlsApi(fe);
              }
              return se;
            }())() : null;
          }, _e.createHlsApi = function(fe) {
            var le = fe.getParsedManifest(), se = le.media.filter(function(ce) {
              return ce.attributes.TYPE === "AUDIO";
            }), oe = le.media.filter(function(ce) {
              return ce.attributes.TYPE === "SUBTITLES" || ce.attributes.TYPE === "CLOSED-CAPTIONS";
            });
            return new (function() {
              function ce() {
                this.properties = fe.getParsedManifest().tags;
              }
              return ce.prototype.getVideoTracks = function() {
                return _e.getVideoTracks(le.playlists);
              }, ce.prototype.getAudioTracks = function() {
                return _e.getAudioTracks(se, le.playlists);
              }, ce.prototype.getTextTracks = function() {
                return _e.getTextTracks(oe);
              }, ce;
            }())();
          }, _e.getAudioTracks = function(fe, le) {
            var se = fe.reduce(function(he, ge) {
              return he[ge.attributes.LANGUAGE] || (he[ge.attributes.LANGUAGE] = ge.attributes.NAME), he;
            }, {}), oe = Object.keys(se).map(function(he, ge) {
              return { id: "audio-".concat(ge), label: se[he], lang: he, getQualities: function() {
                return fe.filter(function(ve) {
                  return ve.attributes.LANGUAGE === he;
                }).map(function(ve, me) {
                  return { id: me + "", bitrate: 0, label: ve.attributes.NAME };
                });
              } };
            }), ce = function(he) {
              return he.attributes.CODECS && ae.CodecStringHelper.getMimeTypeForCodecString(he.attributes.CODECS).includes("audio");
            };
            return le.some(ce) && oe.push({ id: "audio-".concat(oe.length), label: "und", lang: "", getQualities: function() {
              return le.filter(ce).map(function(he, ge) {
                return { id: ge + "", bitrate: he.attributes.BANDWIDTH, codec: ae.CodecStringHelper.getExtractedCodecStrings(he.attributes.CODECS).audio };
              });
            } }), oe;
          }, _e.getVideoTracks = function(fe) {
            var le = function(oe) {
              return !oe.attributes.CODECS || ae.CodecStringHelper.getMimeTypeForCodecString(oe.attributes.CODECS).includes("video");
            }, se = fe.filter(le);
            return [{ id: "video-0", label: "und", getQualities: function() {
              return _e.getVideoQualities(se);
            } }];
          }, _e.getTextTracks = function(fe) {
            return fe.map(function(le, se) {
              return { id: "text-".concat(se), label: le.attributes.NAME, lang: le.attributes.LANGUAGE, isFragmented: !0, kind: le.attributes.TYPE === "CLOSED-CAPTIONS" ? "caption" : "subtitle", url: le.attributes.URI };
            });
          }, _e.getVideoQualities = function(fe) {
            return fe.map(function(le) {
              var se = le.attributes.RESOLUTION && le.attributes.RESOLUTION.width, oe = le.attributes.RESOLUTION && le.attributes.RESOLUTION.height, ce = { id: oe ? "".concat(oe, "_").concat(le.attributes.BANDWIDTH) : "".concat(le.attributes.BANDWIDTH), bitrate: le.attributes.BANDWIDTH, width: se || 0, height: oe || 0 };
              if (le.attributes.CODECS) {
                var he = ae.CodecStringHelper.getExtractedCodecStrings(le.attributes.CODECS);
                he.video && (ce.codec = he.video);
              }
              return ce;
            });
          }, _e;
        }();
        ie.NativePlayerManifestApiFactory = ue;
      }, 96926: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.TechnologyChecker = void 0;
        var ae = ne(33696), ue = function() {
          function _e() {
          }
          return _e.prototype.getSupportedTechnologies = function() {
            return [{ player: ae.PlayerType.Native, streaming: ae.StreamType.Progressive }, { player: ae.PlayerType.Native, streaming: ae.StreamType.Hls }, { player: ae.PlayerType.Native, streaming: ae.StreamType.Dash }];
          }, _e;
        }();
        ie.TechnologyChecker = ue;
      } }, function(ee) {
        return function(ie) {
          return ee(ee.s = ie);
        }(42966);
      }]);
    });
  })();
})(bitmovinplayerEngineNative);
var bitmovinplayerEngineNativeExports = bitmovinplayerEngineNative.exports;
const EngineNative = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerEngineNativeExports);
var bitmovinplayerHls = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ie) {
      re.exports = ie();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[458], { 80211: function(ee, ie, ne) {
        ee.exports = function() {
          return ne(90040)('!function(){"use strict";var e={4210:function(e,t,n){function r(e){return r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},r(e)}function i(e,t){if("object"!=r(e)||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var i=n.call(e,t||"default");if("object"!=r(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}function o(e){var t=i(e,"string");return"symbol"==r(t)?t:String(t)}function a(e,t,n){return(t=o(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function u(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){a(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function l(e){return"Minified Redux error #"+e+"; visit https://redux.js.org/Errors?code="+e+" for the full message or use the non-minified dev environment for full errors. "}n.r(t),n.d(t,{__DO_NOT_USE__ActionTypes:function(){return f},applyMiddleware:function(){return T},bindActionCreators:function(){return h},combineReducers:function(){return v},compose:function(){return y},createStore:function(){return E},legacy_createStore:function(){return g}});var d=function(){return"function"==typeof Symbol&&Symbol.observable||"@@observable"}(),c=function(){return Math.random().toString(36).substring(7).split("").join(".")},f={INIT:"@@redux/INIT"+c(),REPLACE:"@@redux/REPLACE"+c(),PROBE_UNKNOWN_ACTION:function(){return"@@redux/PROBE_UNKNOWN_ACTION"+c()}};function p(e){if("object"!=typeof e||null===e)return!1;for(var t=e;null!==Object.getPrototypeOf(t);)t=Object.getPrototypeOf(t);return Object.getPrototypeOf(e)===t}function E(e,t,n){var r;if("function"==typeof t&&"function"==typeof n||"function"==typeof n&&"function"==typeof arguments[3])throw new Error(l(0));if("function"==typeof t&&void 0===n&&(n=t,t=void 0),void 0!==n){if("function"!=typeof n)throw new Error(l(1));return n(E)(e,t)}if("function"!=typeof e)throw new Error(l(2));var i=e,o=t,a=[],s=a,u=!1;function c(){s===a&&(s=a.slice())}function g(){if(u)throw new Error(l(3));return o}function S(e){if("function"!=typeof e)throw new Error(l(4));if(u)throw new Error(l(5));var t=!0;return c(),s.push(e),function(){if(t){if(u)throw new Error(l(6));t=!1,c();var n=s.indexOf(e);s.splice(n,1),a=null}}}function v(e){if(!p(e))throw new Error(l(7));if(void 0===e.type)throw new Error(l(8));if(u)throw new Error(l(9));try{u=!0,o=i(o,e)}finally{u=!1}for(var t=a=s,n=0;n<t.length;n++){(0,t[n])()}return e}function m(e){if("function"!=typeof e)throw new Error(l(10));i=e,v({type:f.REPLACE})}function h(){var e,t=S;return(e={subscribe:function(e){if("object"!=typeof e||null===e)throw new Error(l(11));function n(){e.next&&e.next(g())}return n(),{unsubscribe:t(n)}}})[d]=function(){return this},e}return v({type:f.INIT}),(r={dispatch:v,subscribe:S,getState:g,replaceReducer:m})[d]=h,r}var g=E;function S(e){Object.keys(e).forEach((function(t){var n=e[t];if(void 0===n(void 0,{type:f.INIT}))throw new Error(l(12));if(void 0===n(void 0,{type:f.PROBE_UNKNOWN_ACTION()}))throw new Error(l(13))}))}function v(e){for(var t=Object.keys(e),n={},r=0;r<t.length;r++){var i=t[r];0,"function"==typeof e[i]&&(n[i]=e[i])}var o,a=Object.keys(n);try{S(n)}catch(e){o=e}return function(e,t){if(void 0===e&&(e={}),o)throw o;for(var r=!1,i={},s=0;s<a.length;s++){var u=a[s],d=n[u],c=e[u],f=d(c,t);if(void 0===f){t&&t.type;throw new Error(l(14))}i[u]=f,r=r||f!==c}return(r=r||a.length!==Object.keys(e).length)?i:e}}function m(e,t){return function(){return t(e.apply(this,arguments))}}function h(e,t){if("function"==typeof e)return m(e,t);if("object"!=typeof e||null===e)throw new Error(l(16));var n={};for(var r in e){var i=e[r];"function"==typeof i&&(n[r]=m(i,t))}return n}function y(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return 0===t.length?function(e){return e}:1===t.length?t[0]:t.reduce((function(e,t){return function(){return e(t.apply(void 0,arguments))}}))}function T(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return function(e){return function(){var n=e.apply(void 0,arguments),r=function(){throw new Error(l(15))},i={getState:n.getState,dispatch:function(){return r.apply(void 0,arguments)}},o=t.map((function(e){return e(i)}));return r=y.apply(void 0,o)(n.dispatch),u(u({},n),{},{dispatch:r})}}}},8367:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.ArrayIncludesPolyfill=void 0,t.ArrayIncludesPolyfill=function(){return{polyfill:function(){Object.defineProperty(Array.prototype,"includes",{value:function(e,t){if(null==this)throw new TypeError(\'"this" is null or not defined\');var n=Object(this),r=n.length>>>0;if(0===r)return!1;var i=0|t,o=Math.max(i>=0?i:r-Math.abs(i),0);function a(e,t){return e===t||"number"==typeof e&&"number"==typeof t&&isNaN(e)&&isNaN(t)}for(;o<r;){if(a(n[o],e))return!0;o++}return!1}})}}}()},4338:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.StringEndsWithPolyfill=void 0,t.StringEndsWithPolyfill=function(){return{polyfill:function(){String.prototype.endsWith=function(e,t){if(null==e)return!1;var n=this.length;return null!=t&&(n=Math.min(t,this.length)),this.substring(n-e.length,n)===e}}}}()},3801:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.StringIncludesPolyfill=void 0,t.StringIncludesPolyfill=function(){return{polyfill:function(){String.prototype.includes=function(e,t){return"number"!=typeof t&&(t=0),!(t+e.length>this.length)&&-1!==this.indexOf(e,t)}}}}()},1921:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.StringStartsWithPolyfill=void 0,t.StringStartsWithPolyfill=function(){return{polyfill:function(){String.prototype.startsWith=function(e,t){var n=t>0?0|t:0;return this.substring(n,n+e.length)===e}}}}()},1520:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.ModuleManager=void 0;var r=n(5550),i=n(8764),o=n(1108),a=function(){function e(){}return e.initialize=function(){this.modules||(this.modules={})},e.add=function(e){if(this.initialize(),!e)throw new i.PlayerError(r.ErrorCode.MODULE_INVALID_DEFINITION,void 0,"Cannot add the module: no module definition was provided to the API.");if(!e.name)throw new i.PlayerError(r.ErrorCode.MODULE_INVALID_DEFINITION,void 0,"Cannot add the module: no `name` property was provided to the module definition.");if(!e.module)throw new i.PlayerError(r.ErrorCode.MODULE_INVALID_DEFINITION,void 0,"Cannot add the module: no `module` property was provided to the module definition.");if(e.dependencies){for(var t=0,n=e.dependencies;t<n.length;t++){var a=n[t];if(!this.has(a))throw new o.PlayerModuleMissingError(e.name,a)}if("function"!=typeof e.module)throw new i.PlayerError(r.ErrorCode.MODULE_INVALID_DEFINITION_DEPENDENCY,{name:e.name},"Cannot add the module: modules with dependencies must pass a deferred loading function to the `ModuleDefinition.module` property.")}var s=e.module;"function"==typeof s&&(s=s()),this.modules[e.name]={moduleDefinition:e,module:s},e.hooks&&e.hooks.add&&e.hooks.add(e.module)},e.remove=function(e){var t;if(this.modules){if(!this.modules[e])throw new o.PlayerModuleMissingError(e);var n=this.modules[e].moduleDefinition;(null===(t=n.hooks)||void 0===t?void 0:t.remove)&&n.hooks.remove(n.module),delete this.modules[e]}},e.get=function(e,t){void 0===t&&(t=!0),this.initialize();var n=this.modules[e];if(n&&n.module)return n.module;if(t)throw new o.PlayerModuleMissingError(e)},e.has=function(e){return void 0!==this.get(e,!1)},e.getModuleNames=function(){return Object.getOwnPropertyNames(this.modules)},e.getModuleDefinitions=function(){var e=this;return this.getModuleNames().map((function(t){return e.modules[t]}))},e.callSetupHooks=function(e){this.getModuleDefinitions().filter((function(e){return e.moduleDefinition.hooks&&e.moduleDefinition.hooks.setup})).forEach((function(t){return t.moduleDefinition.hooks.setup(t.module,e)}))},e.callDestroyHooks=function(e){var t=this.getModuleDefinitions().filter((function(e){return e.moduleDefinition.hooks&&e.moduleDefinition.hooks.destroy})).map((function(t){return t.moduleDefinition.hooks.destroy(t.module,e)}));return Promise.all(t).then((function(){}))},e}();t.ModuleManager=a},6368:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.ModuleName=void 0,function(e){e.VR="VR",e.XML="XML",e.Smooth="Smooth",e.AdvertisingCore="AdvertisingCore",e.Advertising="Advertising",e.AdvertisingIma="Advertising",e.AdvertisingBitmovin="Advertising",e.AdvertisingOmSdk="AdvertisingOmSdk",e.Polyfill="Polyfill",e.Patch="Patch",e.RemoteControl="RemoteControl",e.RendererMse="RendererMSE",e.EngineNative="EngineNative",e.EngineBitmovin="EngineBitmovin",e.ABR="ABR",e.Crypto="Crypto",e.HLS="HLS",e.DRM="DRM",e.DASH="DASH",e.ContainerTS="ContainerTS",e.ContainerMP4="ContainerMP4",e.ContainerWebM="ContainerWebM",e.Subtitles="Subtitles",e.SubtitlesTTML="SubtitlesTTML",e.SubtitlesWebVTT="SubtitlesWebVTT",e.SubtitlesCEA608="SubtitlesCEA608",e.SubtitlesNative="SubtitlesNative",e.Style="Style",e.Thumbnail="Thumbnail",e.UI="UI",e.Tizen="Tizen",e.Webos="webos",e.Vidaa="vidaa",e.LowLatency="LowLatency",e.ServiceWorkerClient="ServiceWorkerClient",e.Envivio="Envivio",e.PlayStation5="PlayStation5",e.PlayStation4="PlayStation4",e.EngineWebRtc="EngineWebRtc",e.ReactNative="ReactNative"}(n||(t.ModuleName=n={}))},1108:function(e,t,n){var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");function r(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(t,"__esModule",{value:!0}),t.PlayerModuleMissingError=void 0;var i=n(5550),o=function(e){function t(t,n){return n?e.call(this,i.ErrorCode.MODULE_DEPENDENCY_MISSING,{name:t,dependency:n},"The ".concat(t," module requires the ").concat(n," module to be included as well."))||this:e.call(this,i.ErrorCode.MODULE_MISSING,{name:t},"The ".concat(t," module is required to play this stream."))||this}return r(t,e),t}(n(8764).PlayerError);t.PlayerModuleMissingError=o},2442:function(e,t){var n,r,i,o,a,s;Object.defineProperty(t,"__esModule",{value:!0}),t.DrmSetupError=t.TransmuxingRejectionReason=t.SegmentVerificationResult=t.HlsEncryptionMethod=t.SOURCE_BUFFER_APPEND_STATUS=t.RepresentationType=void 0,function(e){e[e.AUDIO=1]="AUDIO",e[e.VIDEO=2]="VIDEO",e[e.SUBTITLE=3]="SUBTITLE"}(n||(t.RepresentationType=n={})),function(e){e[e.FAILURE=0]="FAILURE",e[e.QUOTA_EXCEEDED=1]="QUOTA_EXCEEDED",e[e.SUSPENDED=2]="SUSPENDED"}(r||(t.SOURCE_BUFFER_APPEND_STATUS=r={})),function(e){e.NONE="NONE",e.AES_128="AES-128",e.SAMPLE_AES="SAMPLE-AES",e.SAMPLE_AES_CTR="SAMPLE-AES-CTR"}(i||(t.HlsEncryptionMethod=i={})),function(e){e.Publish="publish",e.Drop="drop",e.Park="park"}(o||(t.SegmentVerificationResult=o={})),function(e){e.INVALID_TS_SEGMENT="Invalid TS segment, could not extract segment information",e.TRANSMUXING_ABORTED="Transmuxing was aborted as it is no longer needed"}(a||(t.TransmuxingRejectionReason=a={})),function(e){e.CANCELLED="Loading was cancelled for the DRM source",e.MISSING_CONFIGURATION="DRM is not configured"}(s||(t.DrmSetupError=s={}))},997:function(e,t){function n(e){e&&e.dispose()}Object.defineProperty(t,"__esModule",{value:!0}),t.dispose=n},2510:function(e,t){var n,r,i,o,a;Object.defineProperty(t,"__esModule",{value:!0}),t.LatencyMode=t.AdInteractionType=t.AdQuartile=t.MetadataType=t.PlayerEvent=void 0,function(e){e.Ready="ready",e.Play="play",e.Playing="playing",e.Paused="paused",e.Seek="seek",e.Seeked="seeked",e.TimeShift="timeshift",e.TimeShifted="timeshifted",e.VolumeChanged="volumechanged",e.Muted="muted",e.Unmuted="unmuted",e.PlayerResized="playerresized",e.PlaybackFinished="playbackfinished",e.Error="error",e.Warning="warning",e.StallStarted="stallstarted",e.StallEnded="stallended",e.AudioChanged="audiochanged",e.AudioAdded="audioadded",e.AudioRemoved="audioremoved",e.VideoQualityChanged="videoqualitychanged",e.AudioQualityChanged="audioqualitychanged",e.VideoDownloadQualityChange="videodownloadqualitychange",e.AudioDownloadQualityChange="audiodownloadqualitychange",e.VideoDownloadQualityChanged="videodownloadqualitychanged",e.AudioDownloadQualityChanged="audiodownloadqualitychanged",e.VideoPlaybackQualityChanged="videoplaybackqualitychanged",e.AudioPlaybackQualityChanged="audioplaybackqualitychanged",e.TimeChanged="timechanged",e.CueParsed="cueparsed",e.CueEnter="cueenter",e.CueUpdate="cueupdate",e.CueExit="cueexit",e.SegmentPlayback="segmentplayback",e.Metadata="metadata",e.MetadataParsed="metadataparsed",e.MetadataChanged="metadatachanged",e.VideoAdaptation="videoadaptation",e.AudioAdaptation="audioadaptation",e.DownloadFinished="downloadfinished",e.SegmentRequestFinished="segmentrequestfinished",e.AdManifestLoaded="admanifestloaded",e.AdStarted="adstarted",e.OverlayAdStarted="overlayadstarted",e.AdQuartile="adquartile",e.AdSkipped="adskipped",e.AdClicked="adclicked",e.AdInteraction="adinteraction",e.AdLinearityChanged="adlinearitychanged",e.AdBreakStarted="adbreakstarted",e.AdBreakFinished="adbreakfinished",e.RestoringContent="restoringcontent",e.AdFinished="adfinished",e.AdError="aderror",e.VRViewingDirectionChange="vrviewingdirectionchange",e.VRViewingDirectionChanged="vrviewingdirectionchanged",e.VRStereoChanged="vrstereochanged",e.CastAvailable="castavailable",e.CastStopped="caststopped",e.CastStart="caststart",e.CastStarted="caststarted",e.CastWaitingForDevice="castwaitingfordevice",e.SourceLoaded="sourceloaded",e.SourceUnloaded="sourceunloaded",e.PeriodSwitch="periodswitch",e.PeriodSwitched="periodswitched",e.DVRWindowExceeded="dvrwindowexceeded",e.SubtitleAdded="subtitleadded",e.SubtitleRemoved="subtitleremoved",e.ShowAirplayTargetPicker="showairplaytargetpicker",e.AirplayAvailable="airplayavailable",e.AirplayChanged="airplaychanged",e.Destroy="destroy",e.PlaybackSpeedChanged="playbackspeedchanged",e.DurationChanged="durationchanged",e.ViewModeChanged="viewmodechanged",e.ModuleReady="moduleready",e.SubtitleEnable="subtitleenable",e.SubtitleEnabled="subtitleenabled",e.SubtitleDisable="subtitledisable",e.SubtitleDisabled="subtitledisabled",e.VideoQualityAdded="videoqualityadded",e.VideoQualityRemoved="videoqualityremoved",e.AudioQualityAdded="audioqualityadded",e.AudioQualityRemoved="audioqualityremoved",e.TargetLatencyChanged="targetlatencychanged",e.LatencyModeChanged="latencymodechanged",e.LicenseValidated="licensevalidated",e.DrmLicenseAdded="drmlicenseadded",e.AspectRatioChanged="aspectratiochanged"}(n||(t.PlayerEvent=n={})),function(e){e.CUETAG="CUETAG",e.DATERANGE="DATERANGE",e.EVENT_STREAM="EVENT-STREAM",e.CUSTOM="CUSTOM",e.SCTE="SCTE",e.ID3="ID3",e.EMSG="EMSG",e.CAST="CAST"}(r||(t.MetadataType=r={})),function(e){e.FIRST_QUARTILE="firstQuartile",e.MIDPOINT="midpoint",e.THIRD_QUARTILE="thirdQuartile"}(i||(t.AdQuartile=i={})),function(e){e.Vpaid="vpaid"}(o||(t.AdInteractionType=o={})),function(e){e.Idle="idle",e.Catchup="catchup",e.Fallback="fallback",e.Suspended="suspended"}(a||(t.LatencyMode=a={}))},4430:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.LogLevels=void 0,t.LogLevels={DEBUG:"debug",LOG:"log",WARN:"warn",ERROR:"error",OFF:"off"}},8935:function(e,t,n){var r=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var r,i=0,o=t.length;i<o;i++)!r&&i in t||(r||(r=Array.prototype.slice.call(t,0,i)),r[i]=t[i]);return e.concat(r||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.Logger=t.LogLevel=void 0;var i,o=n(4430),a=n(3696);!function(e){e[e.OFF=0]="OFF",e[e.INSANE=1]="INSANE",e[e.DEBUG=2]="DEBUG",e[e.LOG=3]="LOG",e[e.WARN=4]="WARN",e[e.ERROR=5]="ERROR"}(i||(t.LogLevel=i={}));var s=function(){function e(e,t){void 0===t&&(t=i.WARN),this.settings=e,this.setLogLevel(t)}return e.prototype.setConfig=function(e){this.logCallback=e.logs&&"function"==typeof e.logs().onLog?e.logs().onLog:void 0},e.prototype.setLogLevel=function(t){"string"==typeof t&&(t=e.parseLogLevel(t)),this.level=t},e.prototype.getLogLevel=function(){return this.level},e.prototype.isLevelEnabled=function(e){return!(void 0===this.logCallback||e===i.INSANE)||this.level!==i.OFF&&this.level<=e},e.prototype.setSettings=function(e){this.settings=e},e.parseLogLevel=function(e){switch(e){case o.LogLevels.DEBUG:return i.DEBUG;case o.LogLevels.LOG:return i.LOG;case o.LogLevels.WARN:return i.WARN;case o.LogLevels.ERROR:return i.ERROR;default:return i.OFF}},e.prototype.logToConsole=function(e,t,n){var o,a,s,l=u(e),d=r([],n,!0);if(this.level>0&&this.level<=e&&("string"==typeof this.settings.LOG_PREFIX&&this.settings.LOG_PREFIX.length>0?(o=console[l]).call.apply(o,r([console,this.settings.LOG_PREFIX,t],d,!1)):(a=console[l]).call.apply(a,r([console,t],d,!1))),this.logCallback&&e!==i.INSANE)try{(s=this.logCallback).call.apply(s,r([null,l,t],d,!1))}catch(e){}},e.prototype.insane=function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];this.logToConsole(i.INSANE,e,t)},e.prototype.debug=function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];this.logToConsole(i.DEBUG,e,t)},e.prototype.log=function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];this.logToConsole(i.LOG,e,t)},e.prototype.warn=function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];this.logToConsole(i.WARN,e,t)},e.prototype.error=function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];this.logToConsole(i.ERROR,e,t)},e.prototype.forceLogBeautified=function(e,t,n){navigator.userAgent.indexOf("Trident/")>-1||navigator.userAgent.indexOf("Edge/")>-1?console.log(e):console.log("%c"+e,"color:"+t+";font-weight:bold;font-size:"+n+"px;")},e}();function u(e){switch(e){case i.INSANE:case i.DEBUG:return a.LogLevel.DEBUG;case i.LOG:return a.LogLevel.LOG;case i.WARN:return a.LogLevel.WARN;case i.ERROR:return a.LogLevel.ERROR;default:return null}}t.Logger=s},7345:function(e,t){var n,r,i,o;Object.defineProperty(t,"__esModule",{value:!0}),t.NetworkRequestApi=t.HttpRequestMethod=t.HttpResponseType=t.HttpRequestType=void 0,function(e){e.MANIFEST_DASH="manifest/dash",e.MANIFEST_HLS_MASTER="manifest/hls/master",e.MANIFEST_HLS_VARIANT="manifest/hls/variant",e.MANIFEST_SMOOTH="manifest/smooth",e.MANIFEST_ADS="manifest/ads",e.MEDIA_AUDIO="media/audio",e.MEDIA_VIDEO="media/video",e.MEDIA_SUBTITLES="media/subtitles",e.MEDIA_THUMBNAILS="media/thumbnails",e.MEDIA_SEGMENTINDEX="media/segmentindex",e.DRM_LICENSE_WIDEVINE="drm/license/widevine",e.DRM_LICENSE_PLAYREADY="drm/license/playready",e.DRM_LICENSE_FAIRPLAY="drm/license/fairplay",e.DRM_LICENSE_PRIMETIME="drm/license/primetime",e.DRM_LICENSE_CLEARKEY="drm/license/clearkey",e.DRM_CERTIFICATE_FAIRPLAY="drm/certificate/fairplay",e.KEY_HLS_AES="key/hls/aes",e.TIME_SYNC="time/sync",e.WEBRTC_SDP_REQUEST="webrtc/sdp/request",e.WEBRTC_SDP_ANSWER="webrtc/sdp/answer",e.WEBRTC_SDP_OFFER="webrtc/sdp/offer",e.UNKNOWN="unknown",e.INTERNAL="internal"}(n||(t.HttpRequestType=n={})),function(e){e.ARRAYBUFFER="arraybuffer",e.BLOB="blob",e.DOCUMENT="document",e.JSON="json",e.TEXT="text"}(r||(t.HttpResponseType=r={})),function(e){e.GET="GET",e.POST="POST",e.HEAD="HEAD",e.PATCH="PATCH"}(i||(t.HttpRequestMethod=i={})),function(e){e.XHR="xhr",e.Fetch="fetch"}(o||(t.NetworkRequestApi=o={}))},1356:function(e,t,n){var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},r.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.PlayPromise=void 0;var i=n(6462),o=function(){function e(e,t,n){var i=this;this.startRejectTimeout=function(){var e=function(){clearTimeout(i.rejectTimeoutId),i.drmHandler&&i.drmHandler.isLicenseRequestOngoing()?i.rejectTimeoutId=setTimeout(e,i.context.settings.PLAYBACK_TIMEOUT):i.reject({code:0,name:"NotAllowedError",message:"user interaction required"})};i.rejectTimeoutId=setTimeout(e,i.context.settings.PLAYBACK_TIMEOUT)},this.resolve=function(){i.shutdown(),i.promiseResolve()},this.rejectEvent=function(e,t){return i.reject(r(r({},t),{eventName:e}))},this.reject=function(e){i.shutdown();var t=e;e&&e.type&&(t="error"===e.type?r(r({},e),{name:"NotSupportedError",message:"The operation is not supported"}):r(r({},e),{name:"AbortError",message:"The play call was interrupted by ".concat(e.type)})),i.promiseReject(t)},this.context=e,this.element=t,this.drmHandler=n}return e.prototype.registerEvents=function(){var t=this,n=4,r=function(n){var r=e.eventMapping[n];o.element.addEventListener(n,r?o.resolve:function(e){return t.rejectEvent(n,e)})},o=this;for(var a in e.eventMapping)r(a);this.element.readyState===n?this.startRejectTimeout():this.element.addEventListener(i.MediaElementEvent.canplay,this.startRejectTimeout)},e.prototype.unregisterEvents=function(){for(var t in e.eventMapping){var n=e.eventMapping[t];this.element.removeEventListener(t,n?this.resolve:this.reject)}this.element.removeEventListener(i.MediaElementEvent.canplay,this.startRejectTimeout)},e.prototype.shutdown=function(){clearTimeout(this.rejectTimeoutId),this.unregisterEvents()},e.prototype.getPromise=function(){var e=this;return new Promise((function(t,n){e.promiseResolve=t,e.promiseReject=n,e.registerEvents()}))},e.new=function(t,n,r){return new e(t,n,r).getPromise()},e.eventMapping={playing:!0,ended:!0,pause:!1,abort:!1,emptied:!1,error:!1},e}();t.PlayPromise=o},3696:function(e,t,n){var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");function r(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(t,"__esModule",{value:!0}),t.TimeMode=t.SupportedTechnologyMode=t.ViewMode=t.PlayerAPINotAvailableError=t.LogLevel=t.BufferType=t.MediaType=t.StreamType=t.PlayerType=void 0;var i=n(5550),o=n(8764),a=n(362);Object.defineProperty(t,"PlayerType",{enumerable:!0,get:function(){return a.PlayerType}});var s,u,l,d=n(3091);Object.defineProperty(t,"StreamType",{enumerable:!0,get:function(){return d.StreamType}}),function(e){e.Audio="audio",e.Video="video",e.Subtitles="subtitles",e.Thumbnails="thumbnails"}(s||(t.MediaType=s={})),function(e){e.ForwardDuration="forwardduration",e.BackwardDuration="backwardduration"}(u||(t.BufferType=u={})),function(e){e.DEBUG="debug",e.LOG="log",e.WARN="warn",e.ERROR="error",e.OFF="off"}(l||(t.LogLevel=l={}));var c,f,p,E=function(e){function t(t){return e.call(this,i.ErrorCode.API_NOT_AVAILABLE,void 0,"Cannot use the `player.".concat(t,"` API: the player has already been destroyed."))||this}return r(t,e),t}(o.PlayerError);t.PlayerAPINotAvailableError=E,function(e){e.Inline="inline",e.Fullscreen="fullscreen",e.PictureInPicture="pictureinpicture"}(c||(t.ViewMode=c={})),function(e){e.Platform="platform",e.Modules="modules",e.PlatformAndModules="platformandmodules"}(f||(t.SupportedTechnologyMode=f={})),function(e){e.RelativeTime="relativetime",e.AbsoluteTime="absolutetime"}(p||(t.TimeMode=p={}))},362:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.PlayerType=void 0,function(e){e.Html5="html5",e.Native="native",e.WebRtc="webrtc",e.Unknown="unknown"}(n||(t.PlayerType=n={}))},7326:function(e,t,n){var r,i,o,a;Object.defineProperty(t,"__esModule",{value:!0}),t.DefaultSettings=t.WishDefaultConfig=void 0;var s=n(7345),u=n(3696);t.WishDefaultConfig={TARGET_BITRATE_FACTOR:1,TARGET_BUFFER_FACTOR:.8,BITRATE_MODIFIER_FUNCTION_TYPE:"log",USE_RATE_BASED_SELECTION_ON_SEEKING:!1},t.DefaultSettings={TARGET_BUFFER_LEVEL:(r={},r[u.MediaType.Video]=(i={},i[u.BufferType.ForwardDuration]=40,i[u.BufferType.BackwardDuration]=20,i),r[u.MediaType.Audio]=(o={},o[u.BufferType.ForwardDuration]=40,o[u.BufferType.BackwardDuration]=20,o),r),BUFFER_LOGIC_ACTIVATION_THRESHOLD:10,MIN_TIMELINE_LIVE_OFFSET:4,RETRY_DELAY:2,MAX_INCREASE_RETRY_DELAY_SEC:30,INCREASE_RETRY_DELAY:!0,INCREASE_RETRY_DELAY_BASE_SEC:.25,DISABLE_RETRY_FOR_RESPONSE_STATUS:(a={},a[s.HttpRequestType.MANIFEST_DASH]=[],a[s.HttpRequestType.MANIFEST_HLS_MASTER]=[],a[s.HttpRequestType.MANIFEST_HLS_VARIANT]=[],a[s.HttpRequestType.MANIFEST_SMOOTH]=[],a[s.HttpRequestType.MANIFEST_ADS]=[],a[s.HttpRequestType.MEDIA_AUDIO]=[],a[s.HttpRequestType.MEDIA_VIDEO]=[],a[s.HttpRequestType.MEDIA_SUBTITLES]=[],a[s.HttpRequestType.MEDIA_THUMBNAILS]=[],a[s.HttpRequestType.MEDIA_SEGMENTINDEX]=[],a[s.HttpRequestType.DRM_LICENSE_WIDEVINE]=[],a[s.HttpRequestType.DRM_LICENSE_PLAYREADY]=[],a[s.HttpRequestType.DRM_LICENSE_FAIRPLAY]=[],a[s.HttpRequestType.DRM_LICENSE_PRIMETIME]=[],a[s.HttpRequestType.DRM_LICENSE_CLEARKEY]=[],a[s.HttpRequestType.DRM_CERTIFICATE_FAIRPLAY]=[],a[s.HttpRequestType.KEY_HLS_AES]=[],a[s.HttpRequestType.TIME_SYNC]=[],a[s.HttpRequestType.WEBRTC_SDP_REQUEST]=[],a[s.HttpRequestType.WEBRTC_SDP_ANSWER]=[],a[s.HttpRequestType.WEBRTC_SDP_OFFER]=[],a[s.HttpRequestType.INTERNAL]=[],a[s.HttpRequestType.UNKNOWN]=[],a),METRIC_HISTORY_SIZE:30,DEFAULT_ADAPTATION_RULE_HISTORY_SIZE:40,LOG_LEVEL:2,LOG_PREFIX:"",RESTART_THRESHOLD:.9,RESTART_THRESHOLD_DELTA:.5,STARTUP_THRESHOLD:.9,STARTUP_THRESHOLD_DELTA:.5,START_SEARCHING_END:2,MAX_RETRIES:2,MAX_CDN_RETRIES:2,MAX_MPD_RETRIES:2,MPD_RETRY_DELAY:.5,MPD_UPDATE_PERIOD_TOLERANCE:5,DRM_MAX_RETRIES:1,DRM_RETRY_DELAY:.25,DRM_WITH_CREDENTIALS:!1,CAST_APPLICATION_ID:"D3A86B20",CAST_MESSAGE_NAMESPACE:"urn:x-cast:com.bitmovin.player.cast2",BUFFER_VISIBILITY_DELAY:2,MIN_SELECTABLE_VIDEO_BITRATE:0,MAX_SELECTABLE_VIDEO_BITRATE:1/0,EXCLUDE_DISALLOWED_REPRESENTATIONS:!1,MIN_SELECTABLE_AUDIO_BITRATE:0,MAX_SELECTABLE_AUDIO_BITRATE:1/0,XHR_TIMEOUT:20,QUERY_PARAMETERS:void 0,GAP_TOLERANCE:.1,END_OF_BUFFER_TOLERANCE:.1,END_OF_BUFFER_RECOVERY_TOLERANCE:.5,MAX_POTENTIAL_GAP_TIME_DEVIATION:.125,SEEK_TO_END_OFFSET:2,MINIMUM_ALLOWED_UPDATE_PERIOD:1,MAXIMUM_ALLOWED_UPDATE_PERIOD:1/0,GLOBAL_DISABLE_SEEKING:!1,PRE_ROLL_RESTORE_THRESHOLD:.25,IOS_MIN_TIMEUPDATES_AFTER_AD:2,HTTP_HEADERS:{},DOWNLOAD_DURATION_SAFETY_MARGIN:.4,MAXIMUM_DOWNLOAD_DURATION_MULTIPLIER:2,RATE_SAFETY_MARGIN_PERCENTAGE:10,MAX_ALLOWED_BANDWIDTH_ESTIMATION:1/0,LIVE_SEGMENT_LIST_START_INDEX_OFFSET:0,MAX_NUM_CACHED_SEGMENTS:1,TRUN_VERSION:void 0,IGNORE_MP4_EDTS_BOX:!0,HLS_AUDIO_ONLY_THRESHOLD_BITRATE:2e5,ENABLE_SEEK_FOR_LIVE:!1,LIVE_EDGE_DISTANCE:0,QUALITY_THRESHOLD:.5,QUALITY_UPPER_THRESHOLD:45,MAX_CONSECUTIVE_VR_ERRORS:3,MAX_CONSECUTIVE_RENDERER_ERRORS:3,DISABLE_HLS_BACKUP_STREAM_FAILOVER:!1,PLAYBACK_TIMEOUT:1500,HLS_SYNC_VIA_MEDIA_SEQUENCE:!1,STOP_DOWNLOAD_ON_PAUSE:!1,VR_SCHEME_ID_URI:"https://bitmovin.com/082017/vr",HLS_VR_CHARACTERISTICS_UTI:"com.bitmovin.vr.",SAFARI_NUM_PROGRESS_EVENTS_AFTER_SEEK_GLITCH:5,SEGMENT_LOADER_POOL_SIZE:{},NATIVE_HLS_PARSING:!1,NATIVE_HLS_DOWNLOAD_ERROR_HANDLING:!1,AKAMAI_DATETIME_PARSING:!1,QJY_BROWSER_WORKAROUND:!1,DWORD_BASE_MEDIA_DECODE_TIMESTAMPS:!1,FORCE_BASE_MEDIA_DECODE_TIME_REWRITE:!1,WEBOS_MAX_SAFE_BMDT:274877906943,WEBOS_MAX_SAFE_PTO:4194303,TIZEN_MAX_SAFE_BMDT:4294967295,TIZEN_MAX_SAFE_PTO:4294967295,VIDAA_MAX_SAFE_BMDT:4294967295,VIDAA_MAX_SAFE_PTO:4294967295,ADAPTATION_SET_SWITCHING_WITHOUT_SUPPLEMENTAL_PROPERTY:!1,MINIMAL_BACKWARD_BUFFER_CLEARING_INTERVAL:.5,CHUNKED_CMAF_STREAMING:!1,LOW_LATENCY_DEFAULT_TARGET_LATENCY:5,LOW_LATENCY_BUFFER_GUARD:.5,LOW_LATENCY_DEFAULT_FALLBACK_PLAYBACK_RATE:.95,LOW_LATENCY_DEFAULT_CATCHUP_PLAYBACK_RATE:1.2,LOW_LATENCY_SEEK_AHEAD:1,ACCEPTABLE_TIMESHIFT_INACCURACY:3,IGNORE_HLS_AUDIO_GROUPS:!1,OPTIMIZE_AD_RESTORATION:!0,AD_RESTORATION_SEGMENT_PREFETCHING_DURATION:5,MIN_SAFE_BUFFER_LEVEL:3,THUMBNAIL_TO_PLAYER_SIZE_RATIO:.1,FAIRPLAY_IGNORE_DUPLICATE_INIT_DATA_KEY_ERRORS:!1,NO_QUOTA_EXCEEDED_ADJUSTMENT:!1,RESUME_LIVE_CONTENT_AT_PREVIOUS_POSITION_AFTER_AD_BREAK:!1,MIN_EFFECTIVE_SEGMENT_DOWNLOAD_TIME:.5,fixed:{APP_NAME:"html5",VERSION:"8.198.0"},CLEAR_BUFFERS_ON_SEEKING_BACKWARDS:!1,DROP_INVALID_SEGMENTS:!1,PROACTIVE_GAP_SKIP_DISTANCE_SECONDS:0,PRESERVE_GAPS_FOR_BASE_MEDIA_DECODE_TIME_REWRITE:!1,MIN_SIZE_FOR_GAP_SKIPPING:0,FORCE_SOFTWARE_DECRYPTION:!1,SEGMENT_LOADING_PROGRESS_CHECK_INTERVAL:.5,ENABLE_SEGMENT_INFO_PROVIDER_FROM_STORE:!1,HLS_SYNC_SEGMENT_PLAYBACK_TIME_VIA_MEDIA_SEQUENCE:!1,HLS_PARSE_MANIFEST_IN_WORKER:!1,HLS_CLEAR_BUFFERS_ON_DISCONTINUITY_SWITCHES:!0,PARSE_EMSG_BOXES:!0,WISH_ABR_PARAMS:t.WishDefaultConfig,HLS_BACKUP_STREAM_PENALTY_DURATION:30,CHECK_ALL_DRM_LICENSES_FOR_KID:!0,LL_HLS:!0,LL_HLS_SEGMENT_END_TIME_MATCHING_TOLERANCE:.1,LL_HLS_MAX_PLAYLIST_AGE_FOR_BLOCKING_REQUEST_IN_PART_TARGET_MULTIPLES:2,HLS_PARSE_NATIVE_METADATA:!0,PREFER_MANAGED_MEDIA_SOURCE:!0,INFINITE_RETRIES_FOR_LIVE:!0,MAX_SAFE_MSE_DURATION:1/0,ENABLE_MEDIA_ELEMENT_EVENT_LOGS:!1,DISABLE_PARALLEL_SEGMENT_LOADING:!1}},3091:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.StreamType=void 0,function(e){e.Progressive="progressive",e.Dash="dash",e.Hls="hls",e.Smooth="smooth",e.Whep="whep",e.Unknown="unknown"}(n||(t.StreamType=n={}))},1397:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.kebabCaseToCamelCase=i,t.forceReallocation=o;var r=n(6435);function i(e){return e.split("-").map((function(e,t){return 0===t?e.toLowerCase():e.charAt(0).toUpperCase()+e.slice(1).toLowerCase()})).join("")}function o(e){return e?(0,r.isFirefox)()?JSON.parse(JSON.stringify(e)):(" "+e).slice(1):""}},7177:function(e,t){function n(e){return null!==e&&"object"==typeof e}function r(e){return void 0!==e&&!e.isDisposed}Object.defineProperty(t,"__esModule",{value:!0}),t.isObject=n,t.isContextAvailable=r},5550:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.ErrorCode=void 0,function(e){e[e.UNKNOWN=1e3]="UNKNOWN",e[e.API_NOT_AVAILABLE=1001]="API_NOT_AVAILABLE",e[e.SETUP_ERROR=1100]="SETUP_ERROR",e[e.SETUP_NO_HTML_ELEMENT=1101]="SETUP_NO_HTML_ELEMENT",e[e.SETUP_MISSING_CONFIGURATION=1102]="SETUP_MISSING_CONFIGURATION",e[e.SETUP_LICENSE_ERROR=1103]="SETUP_LICENSE_ERROR",e[e.SETUP_MISSING_DOMAIN_LICENSE_WHITELIST=1104]="SETUP_MISSING_DOMAIN_LICENSE_WHITELIST",e[e.SETUP_MISSING_DOMAIN_LICENSE_ALLOWLIST=1104]="SETUP_MISSING_DOMAIN_LICENSE_ALLOWLIST",e[e.SETUP_MISSING_LICENSE_WHITELIST=1105]="SETUP_MISSING_LICENSE_WHITELIST",e[e.SETUP_MISSING_LICENSE_ALLOWLIST=1105]="SETUP_MISSING_LICENSE_ALLOWLIST",e[e.SETUP_INVALID_LICENSE_SERVER=1106]="SETUP_INVALID_LICENSE_SERVER",e[e.SETUP_INVALID_IMPRESSION_SERVER=1107]="SETUP_INVALID_IMPRESSION_SERVER",e[e.SETUP_NO_RENDERING_ENGINE=1108]="SETUP_NO_RENDERING_ENGINE",e[e.SETUP_UNSUPPORTED_PROTOCOL=1113]="SETUP_UNSUPPORTED_PROTOCOL",e[e.SOURCE_ERROR=1200]="SOURCE_ERROR",e[e.SOURCE_INVALID=1201]="SOURCE_INVALID",e[e.SOURCE_MANIFEST_INVALID=1202]="SOURCE_MANIFEST_INVALID",e[e.SOURCE_NO_SUPPORTED_TECHNOLOGY=1203]="SOURCE_NO_SUPPORTED_TECHNOLOGY",e[e.SOURCE_STREAM_TYPE_NOT_SUPPORTED=1204]="SOURCE_STREAM_TYPE_NOT_SUPPORTED",e[e.SOURCE_FORCED_TECHNOLOGY_NOT_SUPPORTED=1205]="SOURCE_FORCED_TECHNOLOGY_NOT_SUPPORTED",e[e.SOURCE_NO_STREAM_FOUND_FOR_SUPPORTED_TECHNOLOGY=1206]="SOURCE_NO_STREAM_FOUND_FOR_SUPPORTED_TECHNOLOGY",e[e.SOURCE_EMPTY_SEGMENT=1207]="SOURCE_EMPTY_SEGMENT",e[e.SOURCE_COULD_NOT_LOAD_MANIFEST=1208]="SOURCE_COULD_NOT_LOAD_MANIFEST",e[e.SOURCE_PROGRESSIVE_STREAM_ERROR=1209]="SOURCE_PROGRESSIVE_STREAM_ERROR",e[e.SOURCE_HLS_STREAM_ERROR=1210]="SOURCE_HLS_STREAM_ERROR",e[e.SOURCE_ENCRYPTION_METHOD_NOT_SUPPORTED=1211]="SOURCE_ENCRYPTION_METHOD_NOT_SUPPORTED",e[e.SOURCE_INVALID_H264_CODEC=7043]="SOURCE_INVALID_H264_CODEC",e[e.PLAYBACK_ERROR=1300]="PLAYBACK_ERROR",e[e.PLAYBACK_VIDEO_DECODING_ERROR=1301]="PLAYBACK_VIDEO_DECODING_ERROR",e[e.PLAYBACK_HLS_COULD_NOT_LOAD_TRANSMUXER=1304]="PLAYBACK_HLS_COULD_NOT_LOAD_TRANSMUXER",e[e.NETWORK_ERROR=1400]="NETWORK_ERROR",e[e.NETWORK_MANIFEST_DOWNLOAD_TIMEOUT=1401]="NETWORK_MANIFEST_DOWNLOAD_TIMEOUT",e[e.NETWORK_SEGMENT_DOWNLOAD_TIMEOUT=1402]="NETWORK_SEGMENT_DOWNLOAD_TIMEOUT",e[e.NETWORK_PROGRESSIVE_STREAM_DOWNLOAD_TIMEOUT=1403]="NETWORK_PROGRESSIVE_STREAM_DOWNLOAD_TIMEOUT",e[e.NETWORK_FAILED_CERTIFICATE_REQUEST=1404]="NETWORK_FAILED_CERTIFICATE_REQUEST",e[e.DRM_ERROR=2e3]="DRM_ERROR",e[e.DRM_MISSING_CONFIGURATION=2001]="DRM_MISSING_CONFIGURATION",e[e.DRM_NO_LICENSE_SERVER_URL_PROVIDED=2002]="DRM_NO_LICENSE_SERVER_URL_PROVIDED",e[e.DRM_FAILED_LICENSE_REQUEST=2003]="DRM_FAILED_LICENSE_REQUEST",e[e.DRM_KEY_SIZE_NOT_SUPPORTED=2005]="DRM_KEY_SIZE_NOT_SUPPORTED",e[e.DRM_NO_KEY_SYSTEM=2006]="DRM_NO_KEY_SYSTEM",e[e.DRM_KEY_SESSION_INITIALIZATION_FAILED=2007]="DRM_KEY_SESSION_INITIALIZATION_FAILED",e[e.DRM_MEDIA_KEY_INITIALIZATION_FAILED=2008]="DRM_MEDIA_KEY_INITIALIZATION_FAILED",e[e.DRM_KEY_ERROR=2009]="DRM_KEY_ERROR",e[e.DRM_KEY_SYSTEM_NOT_SUPPORTED=2010]="DRM_KEY_SYSTEM_NOT_SUPPORTED",e[e.DRM_CERTIFICATE_ERROR=2011]="DRM_CERTIFICATE_ERROR",e[e.DRM_PLAYREADY_INVALID_HEADER_KEY_VALUE_PAIR=2012]="DRM_PLAYREADY_INVALID_HEADER_KEY_VALUE_PAIR",e[e.DRM_RESTRICTED_OUTPUT=2013]="DRM_RESTRICTED_OUTPUT",e[e.DRM_INIT_DATA_MISSING=2015]="DRM_INIT_DATA_MISSING",e[e.VR_ERROR=2100]="VR_ERROR",e[e.VR_INCOMPATIBLE_PLAYER_TECHNOLOGY=2101]="VR_INCOMPATIBLE_PLAYER_TECHNOLOGY",e[e.MODULE_ERROR=3e3]="MODULE_ERROR",e[e.MODULE_INVALID_DEFINITION=3001]="MODULE_INVALID_DEFINITION",e[e.MODULE_INVALID_DEFINITION_DEPENDENCY=3002]="MODULE_INVALID_DEFINITION_DEPENDENCY",e[e.MODULE_MISSING=3003]="MODULE_MISSING",e[e.MODULE_DEPENDENCY_MISSING=3004]="MODULE_DEPENDENCY_MISSING",e[e.MODULE_REMOVED=3005]="MODULE_REMOVED",e[e.MODULE_ADVERTISING_ERROR=3100]="MODULE_ADVERTISING_ERROR",e[e.SEGMENT_PSSH_DATA_MISSING=4e3]="SEGMENT_PSSH_DATA_MISSING"}(n||(t.ErrorCode=n={}))},8764:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.PlayerError=void 0;var r=n(5550),i=function(){function e(e,t,n,i){this.code=e,this.name=r.ErrorCode[e],this.sourceIdentifier=i,this.message=null!=n?n:"".concat(this.name),this.data=t,"function"==typeof Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):this.stack=new Error(this.message).stack}return e}();t.PlayerError=i},8665:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.ServiceName=void 0,function(e){e.AdaptationService="AdaptationService",e.DrmDetectorService="DrmDetectorService",e.DrmService="DrmService",e.HeartbeatService="HeartbeatService",e.LiveLatencyService="LiveLatencyService",e.ManifestCachingService="ManifestCachingService",e.ManifestLoadingService="ManifestLoadingService",e.ManifestService="ManifestService",e.ManifestUpdateSchedulingService="ManifestUpdateSchedulingService",e.MetadataParsedService="MetadataParsedService",e.PlayerStateService="PlayerStateService",e.SegmentService="SegmentService",e.SourceStoreService="SourceStoreService",e.StallTimeTrackerService="StallTimeTrackerService",e.StartOffsetService="StartOffsetService",e.StreamTimeService="StreamTimeService",e.SubtitleService="SubtitleService",e.SynchronizedTimeService="SynchronizedTimeService",e.ThumbnailService="ThumbnailService",e.TimedMetadataService="TimedMetadataService"}(n||(t.ServiceName=n={}))},9181:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.ManifestMimeType=void 0,function(e){e.Dash="application/dash+xml",e.Hls="application/x-mpegURL",e.Smooth="application/vnd.ms-sstr+xml"}(n||(t.ManifestMimeType=n={}))},5231:function(e,t){function n(e,t){return{type:e,meta:{},payload:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.createAction=n},8842:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.devToolsExtension=void 0;var r=n(7093);t.devToolsExtension=r.default.__REDUX_DEVTOOLS_EXTENSION__},425:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.ReducerTree=void 0,t.isReducer=o,t.isReducerTree=a;var r=n(4210),i=function(){function e(){this.rootNode={}}return e.prototype.has=function(e){return Boolean(this.rootNode[e])},e.prototype.set=function(e,t){return this.rootNode[e]=t,this},e.prototype.get=function(e){return this.rootNode[e]},e.prototype.delete=function(e){delete this.rootNode[e]},e.prototype.keys=function(){return Object.keys(this.rootNode)},e.prototype.getCombinedReducersRecursively=function(e){var t=this,n={};return this.keys().forEach((function(r){var i=t.get(r),a=e.concat(String(r));n[r]=o(i)?i:i.getCombinedReducersRecursively(a)})),0===Object.keys(n).length?function(e){return{}}:(0,r.combineReducers)(n)},e.prototype.buildReducer=function(){return this.getCombinedReducersRecursively([])},e}();function o(e){return Boolean(e)&&"function"==typeof e}function a(e){return Boolean(e)&&e instanceof i}t.ReducerTree=i},9422:function(e,t){var n=this&&this.__assign||function(){return n=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},n.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.addStoreServiceDecoration=void 0;var r=function(e){return function(t){return function(){var r=function(){return e.buildReducer()},i=t(r()),o=function(){return i.replaceReducer(r())};return o(),n(n({},i),{addReducer:function(t,n){e.set(t,n),o()},getReducer:function(t){return e.get(t)},removeReducer:function(t){e.delete(t),o()},hasReducer:function(t){return e.has(t)}})}}};t.addStoreServiceDecoration=r},3533:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.default=c,t.getCapabilities=f,t.getReachableDomains=E;var r,i=n(4210),o=n(7722),a=(n(8842),n(3679),n(9210)),s=n(425),u=n(9422),l=new s.ReducerTree;l.set("capabilities",o.CapabilityReducer).set("reachableDomains",a.ReachableDomainsReducer);var d=function(){var e=[(0,u.addStoreServiceDecoration)(l)];return(0,i.createStore)((function(){return{}}),i.compose.apply(void 0,e))};function c(){return r||(r=d()),r}function f(){return p(c().getState())}function p(e){return e.capabilities}function E(){return g(c().getState())}function g(e){return e.reachableDomains}},7722:function(e,t,n){var r,i=this&&this.__assign||function(){return i=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},i.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.CapabilityReducer=void 0;var o=n(1829),a=n(1399),s={};function u(e){return e}function l(e,t){var n,r=t.key,o=t.value;return i(i({},e),((n={})[r]=o,n))}t.CapabilityReducer=(0,o.default)(s,((r={})[a.CapabilityActionType.InitCapabilities]=function(e,t){return u(t.payload)},r[a.CapabilityActionType.SetCapability]=function(e,t){return l(e,t.payload)},r))},1399:function(e,t){var n,r;Object.defineProperty(t,"__esModule",{value:!0}),t.CapabilityKey=t.CapabilityActionType=void 0,function(e){e.InitCapabilities="initcapabilities",e.SetCapability="setcapability"}(n||(t.CapabilityActionType=n={})),function(e){e.isPlayStation5="isPlayStation5",e.isPlayStation4="isPlayStation4",e.isMobile="isMobile",e.isTizen="isTizen",e.isSafari="isSafari",e.isChrome="isChrome",e.isChromium="isChromium",e.isFirefox="isFirefox",e.isFirefoxIOS="isFirefoxIOS",e.isWebOS="isWebOS",e.isVidaa="isVidaa",e.isVizio="isVizio",e.isIOS="isIOS",e.isSafariIOS="isSafariIOS",e.isEdge="isEdge",e.isLegacyEdge="isLegacyEdge",e.isReactNative="isReactNative",e.MSESafari="MSESafari",e.isLocalStorageAvailable="isLocalStorageAvailable",e.isInlinePlaybackRestricted="isInlinePlaybackRestricted",e.IOSVersion="IOSVersion",e.edgeVersion="edgeVersion",e.safariVersion="safariVersion",e.webOSChromiumVersion="webOSChromiumVersion",e.techSupportedByModules="techSupportedByModules",e.techSupportedByPlatform="techSupportedByPlatform",e.techSupportedByModulesOnPlatform="techSupportedByModulesOnPlatform"}(r||(t.CapabilityKey=r={}))},1829:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.StaticActionTypes=void 0,function(e){e.Default="default"}(n||(t.StaticActionTypes=n={}));var r=function(e,t){return function(r,i){return void 0===r&&(r=e),t[i.type]?t[i.type](r,i):t[n.Default]?t[n.Default](r,i):r}};t.default=r},7279:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.getSourceStore=o,t.getSourceState=a;var r=n(8665),i=n(7177);function o(e){var t,n;return(0,i.isContextAvailable)(e)?null===(t=e.serviceManager)||void 0===t?void 0:t.get(r.ServiceName.SourceStoreService,null===(n=e.sourceContext)||void 0===n?void 0:n.sourceIdentifier):void 0}function a(e){var t=o(e);return null==t?void 0:t.getState()}},5328:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.initialStartOptions=void 0,t.initializeStartTimeOffset=o,t.setStartTimeOffset=a;var r=n(5231),i=n(618);function o(){return a(t.initialStartOptions.startTimeOffset)}function a(e){return(0,r.createAction)(i.StartOptionsActionKey.SetStartTimeOffset,{startTimeOffset:e})}t.initialStartOptions={startTimeOffset:0}},2055:function(e,t,n){var r,i=this&&this.__assign||function(){return i=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},i.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.StartOptionsReducer=void 0,t.getStartTimeOffset=d;var o=n(1829),a=n(5328),s=n(618),u=a.initialStartOptions,l=function(e,t){var n=t.payload;return i(i({},e),n)};function d(e){return e.startOptions.startTimeOffset}t.StartOptionsReducer=(0,o.default)(u,((r={})[s.StartOptionsActionKey.InitStartTimeOffset]=l,r[s.StartOptionsActionKey.SetStartTimeOffset]=l,r))},618:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.StartOptionsActionKey=void 0,function(e){e.InitStartTimeOffset="@instance/sources/@source/startOptions/initStartTimeOffset",e.SetStartTimeOffset="@instance/sources/@source/startOptions/setStartTimeOffset"}(n||(t.StartOptionsActionKey=n={}))},3679:function(e,t){function n(e){Object.freeze(e);var t="function"==typeof e,r=Object.prototype.hasOwnProperty;return Object.getOwnPropertyNames(e).forEach((function(i){!r.call(e,i)||t&&("caller"===i||"callee"===i||"arguments"===i)||null===e[i]||"object"!=typeof e[i]&&"function"!=typeof e[i]||Object.isFrozen(e[i])||n(e[i])})),e}Object.defineProperty(t,"__esModule",{value:!0}),t.freeze=void 0,t.deepFreeze=n;var r=function(e){return null!==e&&"object"==typeof e},i=function(e){var t=e.getState();r(t)&&n(t)},o=function(e){return i(e),function(t){return function(n){i(e);try{return t(n)}finally{i(e)}}}};t.freeze=o},9210:function(e,t,n){var r,i=this&&this.__assign||function(){return i=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},i.apply(this,arguments)},o=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var r,i=0,o=t.length;i<o;i++)!r&&i in t||(r||(r=Array.prototype.slice.call(t,0,i)),r[i]=t[i]);return e.concat(r||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.ReachableDomainsReducer=void 0;var a=n(1829),s=n(9463),u={domains:[]};function l(e,t){return i(i({},e),{domains:e.domains.includes(t)?e.domains:o(o([],e.domains,!0),[t],!1)})}t.ReachableDomainsReducer=(0,a.default)(u,((r={})[s.ReachableDomainsActionType.AddDomain]=function(e,t){return l(e,t.payload)},r))},9463:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.ReachableDomainsActionType=void 0,function(e){e.AddDomain="adddomain"}(n||(t.ReachableDomainsActionType=n={}))},1361:function(e,t,n){var r=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var r,i=0,o=t.length;i<o;i++)!r&&i in t||(r||(r=Array.prototype.slice.call(t,0,i)),r[i]=t[i]);return e.concat(r||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.ArrayHelper=void 0,t.invert=a,t.findIndexFromEnd=s,t.findIndexWithin=u,t.findFromEnd=l,t.forEachFromIndex=d,t.forceArray=c,t.contains=f,t.shallowObjectMatcher=p,t.clearArray=E,t.removeEntriesFromStart=g;var i=n(6093),o=function(){function e(){}return e.comparePrimitiveArrays=function(e,t){if(e.length!==t.length)return!1;for(var n=0;n<e.length;n++)if(e[n]!==t[n])return!1;return!0},e.stringToArrayWithoutEncoding=function(e){for(var t=new Uint8Array(e.length),n=0;n<e.length;n++)t[n]=e.charCodeAt(n);return t},e.convertBufferSourceToUTF8=function(t,n){return void 0===n&&(n="utf-8"),t instanceof ArrayBuffer?t=new Uint8Array(t):t instanceof DataView&&(t=new Uint8Array(t.buffer,t.byteOffset,t.byteLength)),e.convertUint8ArrayToUtf8(t,n)},e.convertUint8ArrayToUtf8=function(e,t){if("undefined"!=typeof TextDecoder)return new TextDecoder(t).decode(e);for(var n=0,r="";n<e.length;){var i=e[n++];if(i>127)if(i>191&&i<224){if(n>=e.length||64&e[n]){r+="�";continue}i=(31&i)<<6|63&e[n++]}else if(i>223&&i<240){if(n+1>=e.length||64&e[n]||64&e[n+1]){r+="�";continue}i=(15&i)<<12|(63&e[n++])<<6|63&e[n++]}else{if(!(i>239&&i<248)){r+="�";continue}if(n+2>=e.length||64&e[n]||64&e[n+1]||64&e[n+2]){r+="�";continue}i=(7&i)<<18|(63&e[n++])<<12|(63&e[n++])<<6|63&e[n++]}i<=65535?r+=String.fromCharCode(i):i<=1114111?(i-=65536,r+=String.fromCharCode(i>>10|55296),r+=String.fromCharCode(1023&i|56320)):r+="�"}return r},e.sort=function(e,t,n){if("string"==typeof t&&"[object Array]"===Object.prototype.toString.call(e)){var r;if(n||(n="asc"),"asc"===n)r=-1;else{if("desc"!==n)return;r=1}if(e.length<2)return e;var i=function(e,n){return e[t]<n[t]?r:e[t]>n[t]?-1*r:0};return e.sort(i)}},e.append=function(t,n){var r=e.getTypedArrayType(t),i=e.getTypedArrayType(n);if(!r&&!i||r!==i)return null;var o=new r((t.byteLength+n.byteLength)/r.BYTES_PER_ELEMENT);return o.set(new r(t),0),o.set(new r(n),t.byteLength/r.BYTES_PER_ELEMENT),o},e.concatBuffers=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];if(!(e=e.filter((function(e){return e}))).length)return null;var n=e.reduce((function(e,t){return e+t.byteLength}),0),r=new Uint8Array(n);return e.reduce((function(e,t){return r.set(new Uint8Array(t),e),e+t.byteLength}),0),r.buffer},e.getTypedArrayType=function(e){return e instanceof Uint8Array?Uint8Array:e instanceof Uint16Array?Uint16Array:e instanceof Uint32Array?Uint32Array:null},e.getArray=function(t){return e.getTypedArrayType(t)?[].slice.call(t):Array.isArray(t)?t:null},e.union=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var n=[];return e.filter((function(e){return Boolean(e)})).forEach((function(e){return e.forEach((function(e){n.includes(e)||n.push(e)}))})),n},e.isArrayBuffer=function(e){return Boolean(e)&&e instanceof ArrayBuffer&&void 0!==e.byteLength},e.arrayBufferToAsciiString=function(t,n){return void 0===n&&(n=!0),e.sparseArrayBufferToAsciiString(t,1,0,n)},e.arrayBufferToBase64=function(e){for(var t="",n=new Uint8Array(e),r=0;r<n.length;r++)t+=String.fromCharCode(n[r]);return window.btoa(t)},e.sparseArrayBufferToAsciiString=function(e,t,n,r){void 0===t&&(t=2),void 0===n&&(n=0),void 0===r&&(r=!0);for(var i="",o=r?new Uint8Array(e):new Uint16Array(e),a=n;a<o.length;a+=t)i+=String.fromCharCode(o[a]);return i},e.intersect=function(){for(var t=[],n=0;n<arguments.length;n++)t[n]=arguments[n];var r=[],i=t.filter((function(e){return Boolean(e)}));return e.union.apply(e,t).forEach((function(e){i.every((function(t){return t.includes(e)}))&&r.push(e)})),r},e.addAndMergeIntersects=function(t,n){var i=t.filter((function(t){return e.intersect(t,n).length>0})),o=t.filter((function(e){return!i.includes(e)}));return 0===i.length?r(r([],t,!0),[n],!1):r([e.union.apply(e,r(r([],i,!1),[n],!1))],o,!0)},e.extractAsciiString=function(e,t,n){for(var r=t+n,i="";t<r;t++)i+=String.fromCharCode(e.getUint8(t));return i},e.extractHexString=function(e,t,n){for(var r=t+n,o="";t<r;t++)o+=i.FormatHelper.intToHex(e.getUint8(t));return o},e.toArray=function(e){try{if(!e||!e.length)return[];for(var t=new Array(e.length),n=0;n<e.length;n++)t[n]=e[n];return t}catch(e){return[]}},e}();function a(e){return function(t,n,r){return!e(t,n,r)}}function s(e,t){var n;for(n=e.length-1;n>=0&&!t(e[n]);n--);return n}function u(e,t,n,r){for(var i=t;i<n;i++)if(r(e[i]))return i;return-1}function l(e,t){return e[s(e,t)]}function d(e,t,n){for(;t<e.length;t++){n(e[t-1],e[t])}}function c(e){return Array.isArray(e)?e:[e]}function f(e,t,n){return void 0===n&&(n=p),null!=e.find((function(e){return n(t,e)}))}function p(e,t){return Object.keys(e).length===Object.keys(t).length&&Object.keys(e).every((function(n){return e[n]===t[n]}))}function E(e){e.splice(0,e.length)}function g(e,t){return t<1?[]:e.splice(0,t)}t.ArrayHelper=o},3485:function(e,t,n){var r=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var r,i=0,o=t.length;i<o;i++)!r&&i in t||(r||(r=Array.prototype.slice.call(t,0,i)),r[i]=t[i]);return e.concat(r||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.MSESafari=t.getBestTech=t.getTechSupportedByModules=t.getTechSupportedByPlatform=t.getTechSupportedByModulesOnPlatform=t.isLocalStorageAvailable=t.isInlinePlaybackRestricted=t.isFairPlayDrmSupported=t.supports=t.checkPlatformSupports=t.hasMediaSourceSupport=t.FairplayKeySystems=void 0,t.isUsingFileProtocol=_,t.isFetchSupported=L;var i,o=n(1520),a=n(6368),s=n(3696),u=n(3533),l=n(7093),d=n(9814),c=n(6435);!function(e){e.FPS_1="com.apple.fps.1_0",e.FPS_2="com.apple.fps.2_0"}(i||(t.FairplayKeySystems=i={}));var f=[{player:s.PlayerType.Html5,streaming:s.StreamType.Dash},{player:s.PlayerType.Html5,streaming:s.StreamType.Hls},{player:s.PlayerType.Html5,streaming:s.StreamType.Smooth},{player:s.PlayerType.WebRtc,streaming:s.StreamType.Whep},{player:s.PlayerType.Native,streaming:s.StreamType.Hls},{player:s.PlayerType.Native,streaming:s.StreamType.Progressive}],p=!0,E=Boolean(l.default.ArrayBuffer&&l.default.Uint8Array&&l.default.Uint16Array),g=function(){return"function"==typeof document.createElement("video").canPlayType},S=function(){var e=document.createElement("video");return e&&"function"==typeof e.canPlayType&&("maybe"===e.canPlayType("application/vnd.apple.mpegURL")||"maybe"===e.canPlayType("application/x-mpegURL")||"maybe"===e.canPlayType("audio/mpegurl")||"maybe"===e.canPlayType("audio/x-mpegurl"))},v=function(){var e,t,n,r="MediaSource"in l.default&&"function"==typeof(null===(e=l.default.MediaSource)||void 0===e?void 0:e.isTypeSupported),i="WebKitMediaSource"in l.default&&"function"==typeof(null===(t=l.default.WebKitMediaSource)||void 0===t?void 0:t.isTypeSupported),o="ManagedMediaSource"in l.default&&"function"==typeof(null===(n=l.default.ManagedMediaSource)||void 0===n?void 0:n.isTypeSupported);return r||i||o};t.hasMediaSourceSupport=v;var m=function(){var e,t,n,r=l.default.RTCPeerConnection,i=Boolean(null!==(n=null!==(t=null!==(e=navigator.getUserMedia)&&void 0!==e?e:navigator.webkitGetUserMedia)&&void 0!==t?t:navigator.mozGetUserMedia)&&void 0!==n?n:navigator.msGetUserMedia),o=Boolean(r)&&"function"==typeof r.prototype.addTransceiver;return i&&o},h=function(){var e=[];if(E?e=f.filter((function(e){return(0,t.supports)(e.player,e.streaming)})):e.push({player:s.PlayerType.Native,streaming:s.StreamType.Progressive}),(0,c.isSafari)())for(var n=1;n<e.length;n++)if(e[n].player===s.PlayerType.Native&&e[n].streaming===s.StreamType.Hls){e=e.splice(n,1).concat(e);break}return e};t.checkPlatformSupports=h;var y=function(e,n){var r=(0,t.hasMediaSourceSupport)()?[s.StreamType.Dash,s.StreamType.Hls,s.StreamType.Smooth]:[],i=m()?[s.StreamType.Whep]:[],o=function(){var e=[];return S()&&!(0,c.isEdge)()&&e.push(s.StreamType.Hls),g()&&p&&e.push(s.StreamType.Progressive),e},a=function(e){return e.some((function(e){return e===n}))};switch(e){case s.PlayerType.Html5:return a(r);case s.PlayerType.WebRtc:return a(i);case s.PlayerType.Native:return a(o());default:return!1}};t.supports=y;var T=function(){return Object.values(i).some((function(e){var t;return null===(t=l.default.WebKitMediaKeys)||void 0===t?void 0:t.isTypeSupported(e,d.MimeType.VideoMp4)}))};function _(){return"file:"===l.default.location.protocol}t.isFairPlayDrmSupported=T;var I=function(){var e=(0,c.getIOSVersion)(),t=e<c.IOS_9&&/iPad/i.test(navigator.userAgent),n=e<c.IOS_10&&/iP(hone|od)/i.test(navigator.userAgent);return c.isSafariIOS&&(t||n)};t.isInlinePlaybackRestricted=I;var R=function(){try{return l.default.localStorage&&"function"==typeof localStorage.getItem&&"function"==typeof localStorage.setItem}catch(e){return!1}};t.isLocalStorageAvailable=R;var O=function(){var e=(0,t.getTechSupportedByModules)(),n=(0,t.getTechSupportedByPlatform)(),r=function(e,t){return e.player===t.player&&e.streaming===t.streaming};return n.filter((function(t){return e.filter((function(e){return r(e,t)})).length>0}))};t.getTechSupportedByModulesOnPlatform=O;var A=function(){return(0,t.checkPlatformSupports)()};t.getTechSupportedByPlatform=A;var N=function(){var e=o.ModuleManager.has(a.ModuleName.EngineBitmovin)?o.ModuleManager.get(a.ModuleName.EngineBitmovin).technologyChecker.getSupportedTechnologies():[],t=o.ModuleManager.has(a.ModuleName.EngineNative)?o.ModuleManager.get(a.ModuleName.EngineNative).technologyChecker.getSupportedTechnologies():[],n=o.ModuleManager.has(a.ModuleName.EngineWebRtc)?o.ModuleManager.get(a.ModuleName.EngineWebRtc).technologyChecker.getSupportedTechnologies():[];return r(r(r([],e,!0),t,!0),n,!0)};t.getTechSupportedByModules=N;var M=function(e){var t=(0,u.getCapabilities)(),n=r([],t.techSupportedByPlatform,!0);if(!e||0===e.length)return n;var i=e.filter((function(e){return n.some((function(t,r){var i,o=e.player===t.player&&e.streaming===t.streaming,a=null!==(i=e.exclude)&&void 0!==i&&i;return o&&n.splice(r,1),o&&!a}))})).map((function(e){return{player:e.player,streaming:e.streaming}}));return r(r([],i,!0),n,!0)},b=function(e,t,n){void 0===e&&(e=[]),void 0===t&&(t={});var r=(0,u.getCapabilities)(),i=M(e),o=r.techSupportedByPlatform;return n&&(i=o.filter((function(e){return e.player===n.player&&e.streaming===n.streaming}))),(t.vr&&((0,c.isSafariIOS)()||(0,c.isSafari)())?i.filter((function(e){var t=e.streaming===s.StreamType.Progressive&&e.player===s.PlayerType.Native,n=e.streaming===s.StreamType.Hls&&e.player===s.PlayerType.Native;return t||n&&(!(0,c.isSafariIOS)()||(0,c.getIOSVersion)()>c.IOS_9)})):i).find((function(e){return Boolean(t[e.streaming])}))};function L(){return"function"==typeof l.default.fetch&&"function"==typeof l.default.AbortController}t.getBestTech=b;var P=function(){return(0,c.isSafari)()&&(0,t.hasMediaSourceSupport)()};t.MSESafari=P},4388:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.DurationConverter=void 0;var n=function(){function e(){}return e.getDurationInSec=function(e){if("string"!=typeof e)return NaN;var t=/^([-])?P(([\\d.]*)Y)?(([\\d.]*)M)?(([\\d.]*)D)?(T)?(([\\d.]*)H)?(([\\d.]*)M)?(([\\d.]*|Infinity)S)?/.exec(e);if(t){var n=Boolean(t[1]),r=12*parseFloat(t[2]||"0")*30*24*60*60,i=30*parseFloat(t[4]||"0")*24*60*60,o=24*parseFloat(t[6]||"0")*60*60,a=60*parseFloat(t[9]||"0")*60,s=60*parseFloat(t[11]||"0"),u=parseFloat(t[13]||"0");if("T"===t[8]&&void 0===(t[9]||t[11]||t[13]))return NaN;var l=r+i+o+a+s+u;return n&&(l=-l),l}return NaN},e}();t.DurationConverter=n},6093:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.FormatHelper=void 0;var n=function(){function e(){}return e.hexToBytes=function(e){var t=e.length;1&t&&(e="0"+e,t++);for(var n=new Uint8Array(t>>1),r=0;r<t;r+=2)n[r>>1]=parseInt(e.substring(r,r+2),16);return n},e.bytesToHex=function(e){e instanceof ArrayBuffer&&(e=new Uint8Array(e));for(var t="",n=0;n<e.byteLength;n++){var r=(255&e[n]).toString(16);r.length<2&&(t+="0"),t+=r}return t},e.bytesToUUID=function(e){return this.beautifyUUID(this.bytesToHex(e))},e.beautifyUUID=function(e){return e.slice(0,8)+"-"+e.slice(8,12)+"-"+e.slice(12,16)+"-"+e.slice(16,20)+"-"+e.slice(20)},e.intToHex=function(e){return("00"+e.toString(16)).slice(-2)},e.base64UrlEncode=function(e){return window.btoa(e).replace(/\\+/g,"-").replace(/\\//g,"_").replace(/=/g,"")},e.base64UrlDecode=function(e){return window.atob((e+"===".slice((e.length+3)%4)).replace(/-/g,"+").replace(/_/g,"/"))},e}();t.FormatHelper=n},1715:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.MessageHandler=void 0;var n=function(){function e(e,t){this.runsInWebWorker=e,this.postMessageFunction=t}return e}();t.MessageHandler=n},9814:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.MimeTypeHelper=t.MimeType=void 0,t.isMediaTypeContained=s;var r,i=n(9181),o=n(3696);!function(e){e.VideoMp4="video/mp4",e.VideoTs="video/mp2t",e.AudioMp4="audio/mp4",e.AudioTs="audio/mp2t"}(r||(t.MimeType=r={}));var a=function(){function e(){}return e.isSubtitle=function(e){return this.isApplication(e)||this.isText(e)},e.isText=function(e){return e.includes("text")},e.isTtmlXml=function(e){return e.includes("ttml+xml")},e.isApplication=function(e){return e.includes("application")},e.isAV=function(e){return this.isVideo(e)||this.isAudio(e)},e.isVideo=function(e){return e.includes("video")},e.isUnknown=function(e){return e.includes("unknown")},e.isAudio=function(e){return e.includes("audio")},e.isImage=function(e){return e.includes("image")},e.isDash=function(e){return e.includes(i.ManifestMimeType.Dash)},e.isHls=function(e){return e.includes(i.ManifestMimeType.Hls)||e.includes("vnd.apple.mpegURL")},e.isMP4=function(e){return e.includes("mp4")},e.getMediaType=function(e){return this.isVideo(e)?o.MediaType.Video:this.isAudio(e)?o.MediaType.Audio:this.isSubtitle(e)?o.MediaType.Subtitles:this.isImage(e)?o.MediaType.Thumbnails:void 0},e.extractContentType=function(e){return e.split("/")[0]},e.extractContainerType=function(e){var t=e.split("/");return t.length>1?t[1]:null},e}();function s(e,t){return Object.keys(e).map((function(e){return a.getMediaType(e)})).includes(a.getMediaType(t))}t.MimeTypeHelper=a},6435:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.isSafari17orIOS17=t.isSafari15orIOS15=t.getIOSVersion=t.isSafariIOS=t.isIOS=t.isMobile=t.getWebOsChromiumVersion=t.isWebOS=t.isVizio=t.getVidaaVersion=t.isVidaa=t.getTizenVersion=t.isTizen2020=t.isTizen2016=t.isTizen2017=t.isTizen2018=t.isTizen2019=t.isTizen=t.getEdgeVersion=t.isEdge=t.getSafariVersion=t.isSafari=t.isFirefoxIOS=t.isFirefox=t.isChromium=t.isChrome=t.WEBOS_2021_CHROMIUM_VERSION=t.WEBOS_2020_CHROMIUM_VERSION=t.WEBOS_2018_2019_CHROMIUM_VERSION=t.WEBOS_2016_2017_CHROMIUM_VERSION=t.TIZEN_2020_MINOR_VERSION=t.TIZEN_2020_MAJOR_VERSION=t.TIZEN_2019_MINOR_VERSION=t.TIZEN_2019_MAJOR_VERSION=t.TIZEN_2018_MINOR_VERSION=t.TIZEN_2018_MAJOR_VERSION=t.TIZEN_2017_MINOR_VERSION=t.TIZEN_2017_MAJOR_VERSION=t.TIZEN_2016_MINOR_VERSION=t.TIZEN_2016_MAJOR_VERSION=t.SAFARI_17_MAJOR_VERSION=t.SAFARI_15_MAJOR_VERSION=t.IOS_17=t.IOS_15=t.IOS_10=t.IOS_9=void 0,t.isLegacyEdge=f,t.isPlayStation5=p,t.isPlayStation4=E,t.isReactNative=g;var r=n(3485);t.IOS_9=9,t.IOS_10=10,t.IOS_15=15,t.IOS_17=17,t.SAFARI_15_MAJOR_VERSION=15,t.SAFARI_17_MAJOR_VERSION=17,t.TIZEN_2016_MAJOR_VERSION=2,t.TIZEN_2016_MINOR_VERSION=4,t.TIZEN_2017_MAJOR_VERSION=3,t.TIZEN_2017_MINOR_VERSION=0,t.TIZEN_2018_MAJOR_VERSION=4,t.TIZEN_2018_MINOR_VERSION=0,t.TIZEN_2019_MAJOR_VERSION=5,t.TIZEN_2019_MINOR_VERSION=0,t.TIZEN_2020_MAJOR_VERSION=5,t.TIZEN_2020_MINOR_VERSION=5,t.WEBOS_2016_2017_CHROMIUM_VERSION=38,t.WEBOS_2018_2019_CHROMIUM_VERSION=53,t.WEBOS_2020_CHROMIUM_VERSION=68,t.WEBOS_2021_CHROMIUM_VERSION=79;var i=function(){return navigator.userAgent.includes("Chrome")&&!(0,t.isEdge)()};t.isChrome=i;var o=function(){return(0,t.isChrome)()||(0,t.isEdge)()&&!f()};t.isChromium=o;var a=function(){return navigator.userAgent.includes("Firefox")};t.isFirefox=a;var s=function(){return navigator.userAgent.includes("FxiOS")&&(0,t.isIOS)()};t.isFirefoxIOS=s;var u=function(){return navigator.userAgent.includes("Safari")&&!navigator.userAgent.includes("Chrome")&&!navigator.userAgent.includes("IEMobile")&&!navigator.userAgent.includes("Edge")&&!(0,t.isTizen)()&&!p()&&!E()||(0,r.isFairPlayDrmSupported)()};t.isSafari=u;var l=function(){var e=/Version\\/(\\d+)\\.?(\\d+)?\\.?(\\d+)?/.exec(navigator.userAgent)||null;if(!e)return{};var t=e[1],n=e[2],r=e[3],i=function(e){return parseInt(e)};return{major:i(t),minor:i(n),patch:i(r)}};t.getSafariVersion=l;var d=function(){return/Edge\\/\\d+/i.test(navigator.userAgent)||/Edg\\/\\d+/i.test(navigator.userAgent)};t.isEdge=d;var c=function(){var e=/Edge\\/(\\d+)\\.?(\\d+)/.exec(navigator.userAgent)||/Edg\\/(\\d+)\\.?(\\d+)/.exec(navigator.userAgent);if(!e||0===e.length)return{major:0,minor:0};var t={};return e[1]&&(t.major=parseInt(e[1])),e[1]&&(t.minor=parseInt(e[2])),t};function f(){var e=79;return(0,t.isEdge)()&&(0,t.getEdgeVersion)().major<e}function p(){return/PlayStation 5/i.test(navigator.userAgent)}function E(){return/PlayStation 4/i.test(navigator.userAgent)}function g(){return"ReactNative"===window.navigator.product}t.getEdgeVersion=c;var S=function(e,n){var r=(0,t.getTizenVersion)();return r.major===e&&r.minor===n},v=function(){return navigator.userAgent.includes("Tizen")};t.isTizen=v;var m=function(){return S(t.TIZEN_2019_MAJOR_VERSION,t.TIZEN_2019_MINOR_VERSION)};t.isTizen2019=m;var h=function(){return S(t.TIZEN_2018_MAJOR_VERSION,t.TIZEN_2018_MINOR_VERSION)};t.isTizen2018=h;var y=function(){return S(t.TIZEN_2017_MAJOR_VERSION,t.TIZEN_2017_MINOR_VERSION)};t.isTizen2017=y;var T=function(){return S(t.TIZEN_2016_MAJOR_VERSION,t.TIZEN_2016_MINOR_VERSION)};t.isTizen2016=T;var _=function(){return S(t.TIZEN_2020_MAJOR_VERSION,t.TIZEN_2020_MINOR_VERSION)};t.isTizen2020=_;var I=function(){var e=/Tizen (\\d).(\\d)/.exec(navigator.userAgent);return(null==e?void 0:e[1])?{major:Number(e[1]),minor:Number(e[2]||0)}:{}};t.getTizenVersion=I;var R=function(){return navigator.userAgent.includes("VIDAA")};t.isVidaa=R;var O=function(){var e=new RegExp(/VIDAA\\/(\\d+)\\.?(\\d+)/).exec(navigator.userAgent);return(null==e?void 0:e[1])?{major:Number(e[1]),minor:Number(e[2])}:{}};t.getVidaaVersion=O;var A=function(){return navigator.userAgent.includes("VIZIO")};t.isVizio=A;var N=function(){return navigator.userAgent.includes("Web0S")||navigator.userAgent.includes("NetCast")};t.isWebOS=N;var M=function(){var e,t=new RegExp(/Chrome\\/(\\d+)\\.?(\\d+)/).exec(navigator.userAgent);return(null==t?void 0:t[1])?{major:Number(t[1]),minor:Number(null!==(e=t[2])&&void 0!==e?e:0)}:{}};t.getWebOsChromiumVersion=M;var b=function(){return/Android/i.test(navigator.userAgent)||/IEMobile/i.test(navigator.userAgent)||/Windows Phone 10.0/i.test(navigator.userAgent)||/Safari/i.test(navigator.userAgent)&&/Mobile/i.test(navigator.userAgent)};t.isMobile=b;var L=function(){return/Safari/i.test(navigator.userAgent)&&/Mobile/i.test(navigator.userAgent)&&!/Android/i.test(navigator.userAgent)&&!/Windows Phone 10.0/i.test(navigator.userAgent)};t.isIOS=L;var P=function(){return/Safari/i.test(navigator.userAgent)&&/iP(hone|od|ad)/i.test(navigator.userAgent)};t.isSafariIOS=P;var D=function(){var e=/OS (\\d+)(_\\d+)*/.exec(navigator.userAgent);return e&&e.length>0&&parseInt(e[1],10)||0};t.getIOSVersion=D;var C=function(){return(0,t.isIOS)()&&(0,t.getIOSVersion)()===t.IOS_15},U=function(){return(0,t.isSafari)()&&(0,t.getSafariVersion)().major===t.SAFARI_15_MAJOR_VERSION},w=function(){return U()||C()};t.isSafari15orIOS15=w;var H=function(){return(0,t.isIOS)()&&(0,t.getIOSVersion)()===t.IOS_17},F=function(){return(0,t.isSafari)()&&(0,t.getSafariVersion)().major===t.SAFARI_17_MAJOR_VERSION},k=function(){return F()||H()};t.isSafari17orIOS17=k},331:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.toSeconds=r,t.toMilliSeconds=i;var n=1e3;function r(e){return e/n}function i(e){return e*n}},16:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.isBoolean=t.isNumber=void 0,t.isDefined=i,t.isVideoRepresentation=o;var n=function(e){return"number"==typeof e};t.isNumber=n;var r=function(e){return"boolean"==typeof e};function i(e){return null!=e}function o(e){return null!=e._height&&null!=e._width}t.isBoolean=r},4838:function(e,t,n){var r=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var r,i=0,o=t.length;i<o;i++)!r&&i in t||(r||(r=Array.prototype.slice.call(t,0,i)),r[i]=t[i]);return e.concat(r||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.Util=void 0,t.parseAspectRatio=d,t.removeDuplicates=c;var i=n(997),o=n(7326),a=n(6462),s=n(573),u=n(331),l=function(){function e(){}return e.deepEqual=function(t,n){if(t===n)return!0;if(!t||"object"!=typeof t||!n||"object"!=typeof n)return!1;if(Object.keys(t).length!==Object.keys(n).length)return!1;for(var r in t)if(!n.hasOwnProperty(r)||!e.deepEqual(t[r],n[r]))return!1;return!0},e.deepCopy=function(t,n){var r=void 0!==window.ArrayBuffer;for(var i in n)n.hasOwnProperty(i)&&(r&&n[i]instanceof ArrayBuffer?t[i]=n[i].slice(0,n[i].byteLength):"object"==typeof n[i]&&null!==n[i]?(t.hasOwnProperty(i)||(Array.isArray(n[i])?t[i]=[]:t[i]={}),e.deepCopy(t[i],n[i])):t[i]=n[i])},e.deepCopyMulti=function(e){for(var t=this,n=[],r=1;r<arguments.length;r++)n[r-1]=arguments[r];return n.forEach((function(n){return t.deepCopy(e,n)})),e},e.isFunction=function(e){return!!e&&"[object Function]"==={}.toString.call(e)},e.extractBitrateFromString=function(e,t){return isNaN(t)?(t=t.toLowerCase().trim().replace(/,/g,".")).indexOf("mbps")>-1?1e6*t.split("m")[0]:t.indexOf("kbps")>-1?1e3*t.split("k")[0]:t.indexOf("bps")>-1?1*t.split("b")[0]:"max"===e?1/0:0:t===1/0?t:1*t},e.splitPlayerAndStreamingTechnology=function(e){if(e&&"string"==typeof e){for(var t=e.split("."),n=0,r=0;r<e.length;r++)""===t[r]&&(t[r]=null,n++);return n===e.length?null:{player:t[0],streaming:t[1]}}return null},e.createVRAudioElement=function(){var t=document.createElement("source");t.setAttribute("type","audio/mp3"),t.setAttribute("src","data:audio/mpeg;base64,/+MYxAAAAANIAUAAAASEEB/jwOFM/0MM/90b/+RhST//w4NFwOjf///PZu////9lns5GFDv//l9GlUIEEIAAAgIg8Ir/JGq3/+MYxDsLIj5QMYcoAP0dv9HIjUcH//yYSg+CIbkGP//8w0bLVjUP///3Z0x5QCAv/yLjwtGKTEFNRTMuOTeqqqqqqqqqqqqq/+MYxEkNmdJkUYc4AKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");var n={settings:o.DefaultSettings};for(e.vrAudioElement=e.vrAudioElement||new s.MediaElementWrapper(n,document.createElement("audio")),e.vrAudioElement.setAttribute("id","bitmovinplayer-audio"),e.vrAudioElement.addEventListener(a.MediaElementEvent.playing,(function(){return e.vrAudioElement.bit_wasPlayCalled=!0})),e.vrAudioElement.setAttribute("crossorigin","anonymous"),e.vrAudioElement.hasAttribute("src")&&e.vrAudioElement.removeAttribute("src");e.vrAudioElement.firstChild;)e.vrAudioElement.removeChild(e.vrAudioElement.firstChild);e.vrAudioElement.load()},e.getVRAudioElement=function(){return e.vrAudioElement||e.createVRAudioElement(),e.vrAudioElement},e.removeVRAudioElement=function(){if(e.vrAudioElement){var t=e.vrAudioElement.getWrappedElement();e.vrAudioElement=(0,i.dispose)(e.vrAudioElement),t.parentNode&&t.parentNode.removeChild(t)}},e.isFullscreen=function(){return document.fullscreenElement||document.webkitFullscreenElement||document.mozFullScreenElement||document.webkitCurrentFullScreenElement},e.generateUniqueId=function(){return Date.now().toString(16)+Math.floor(1048576*(1+Math.random())).toString(16).substring(1)},e.getUtcDate=function(t){var n=null;return"string"!=typeof t&&isNaN(t)||(n="string"==typeof t?e.timeZoneRegex.test(t)?new Date(t):new Date(t+"Z"):new Date(t)),n},e.hashCode=function(e){var t=0;if(0===e.length)return t;for(var n=0;n<e.length;n++){t=(t<<5)-t+e.charCodeAt(n),t|=0}return t},e.delay=function(e,t){return new Promise((function(n){setTimeout((function(){"function"==typeof t?n(t()):n()}),e)}))},e.timeInSeconds=function(e){return(0,u.toSeconds)(e.getTime())},e.toHash=function(t){var n=16,r=20,i=268435456,o=new WeakMap;function a(t,i){if(null==i)return i;if("function"==typeof i)return i.toString().replace(/\\n|\\s\\s/g,"");if(i instanceof ArrayBuffer)return String.fromCharCode.apply(null,new Uint8Array(i.slice(0,r)));if(i instanceof Uint8Array)return String.fromCharCode.apply(null,i.slice(0,r));if("object"==typeof i&&!Array.isArray(i)){if(o.has(i)){var s=JSON.stringify(Object.keys(i),a);return"[Object ".concat(Math.abs(e.hashCode(s)).toString(n),"]")}o.set(i,!0)}return i}var s=JSON.stringify(t,a);return(Math.abs(e.hashCode(s))|i).toString(n)},e.roundValue=function(e,t){var n=Math.pow(10,t);return Math.round(e*n)/n},e.arrayMove=function(e,t,n){var i=r([],e,!0),o=i[t];return i.splice(t,1),i.splice(n,0,o),i},e.vrAudioElement=null,e.timeZoneRegex=/(?:Z|[+-](?:2[0-3]|[01][0-9]):[0-5][0-9])$/,e}();function d(e){if(!e)return 0;var t;if((e=String(e).replace(",",".")).indexOf(":")>-1)t=e.split(":");else{if(!(e.indexOf("/")>-1))return isNaN(parseFloat(e))?0:parseFloat(e);t=e.split("/")}if(t&&Array.isArray(t)&&t.length>1){var n=parseFloat(t[0])/parseFloat(t[1]);return isNaN(n)?0:n}return 0}function c(e){return e.filter((function(e,t,n){return t===n.findIndex((function(t){return l.deepEqual(t,e)}))}))}t.Util=l},7697:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.WebWorkerContext=void 0;var r=n(5469),i=function(){function e(e){var t=this;this.runsInWebWorker="undefined"==typeof window,this.onmessage=null,this.sendMessage=function(e,n){t.runsInWebWorker?postMessage(e,n):"function"==typeof t.onmessage&&setTimeout((function(){t.onmessage({data:e})}),0)},this.postMessage=function(e){setTimeout((function(){t.onMessageCallback({data:e})}),0)},this.terminate=function(){},this.onMessageCallback=function(e){e.data.action&&e.data&&t.messageHandler[e.data.action]&&t.messageHandler[e.data.action](e.data)},this.runsInWebWorker&&(0,r.installWorkerPolyfills)(),this.messageHandler=new e(this.runsInWebWorker,this.sendMessage)}return e}();t.WebWorkerContext=i},7093:function(e,t){var n;function r(e){return"Math"in e&&e.Math===Math}function i(){return"object"==typeof window&&window&&r(window)?window:void 0}function o(){return"object"==typeof self&&self&&r(self)?self:void 0}Object.defineProperty(t,"__esModule",{value:!0});var a=null!==(n=i())&&void 0!==n?n:o();t.default=a},6462:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.MediaElementEvent=void 0,function(e){e.abort="abort",e.canplay="canplay",e.canplaythrough="canplaythrough",e.durationchange="durationchange",e.emptied="emptied",e.encrypted="encrypted",e.ended="ended",e.error="error",e.loadeddata="loadeddata",e.loadedmetadata="loadedmetadata",e.loadstart="loadstart",e.pause="pause",e.play="play",e.playing="playing",e.progress="progress",e.ratechange="ratechange",e.seeked="seeked",e.seeking="seeking",e.stalled="stalled",e.suspend="suspend",e.timeupdate="timeupdate",e.volumechange="volumechange",e.waiting="waiting",e.waitingforkey="waitingforkey",e.currenttimenotadvancing="currenttimenotadvancing",e.primestart="primestart",e.msneedkey="msneedkey",e.enterpictureinpicture="enterpictureinpicture",e.leavepictureinpicture="leavepictureinpicture",e.webkitkeymessage="webkitkeymessage",e.webkitneedkey="webkitneedkey",e.webkitkeyerror="webkitkeyerror",e.webkitkeyadded="webkitkeyadded",e.webkitplaybacktargetavailabilitychanged="webkitplaybacktargetavailabilitychanged",e.webkitpresentationmodechanged="webkitpresentationmodechanged",e.webkitcurrentplaybacktargetiswirelesschanged="webkitcurrentplaybacktargetiswirelesschanged"}(n||(t.MediaElementEvent=n={}))},1480:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.MediaElementEventHandler=void 0;var r=n(8935),i=n(4838),o=n(6462),a=1e8,s=function(){function e(t,n){var r=this;this.handleVideoElementErrorEvent=function(t){if(r.maybeLogEvent(t.type,t),!r.shouldSuppressEvent(t)){if(r.element.error){t.errorObject={code:r.element.error.code};var n=e.getMediaErrorName(r.element.error.code);n&&(t.errorObject.mediaError=n),"msExtendedCode"in r.element.error&&r.element.error.msExtendedCode&&(t.errorObject.systemCode=r.element.error.msExtendedCode.toString(16)),r.element.error.message&&(t.errorObject.message=r.element.error.message),t.errorMessage=Object.keys(t.errorObject).map((function(e){return e+": "+t.errorObject[e]})).join(", ")}else t.errorMessage="Video element triggered an Error, but has no error object.";r.callAllHandlers(t)}},this.handleVideoElementEvent=function(e){r.maybeLogEvent(e.type),r.shouldSuppressEvent(e)||r.callAllHandlers(e)},this.context=t,this.element=n,this.eventHandlerMap={},this.eventsToSuppress={},this.pendingTimeouts=[],this._isAd=!1,this._isPriming=!1,this.attachVideoEventHandlers()}return Object.defineProperty(e.prototype,"isAd",{get:function(){return this._isAd},set:function(e){this._isAd=e},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"isPriming",{get:function(){return this._isPriming},set:function(e){this._isPriming=e},enumerable:!1,configurable:!0}),e.prototype.suppressEvent=function(e,t,n){var r=this;if(void 0===t&&(t=a),this.eventsToSuppress[e]=this.eventsToSuppress[e]||0,this.eventsToSuppress[e]+=t,n&&n>0){var i=window.setTimeout((function(){r.eventsToSuppress[e]=Math.max(r.eventsToSuppress[e]-t,0),r.pendingTimeouts.splice(r.pendingTimeouts.indexOf(i),1)}),n);this.pendingTimeouts.push(i)}},e.prototype.clearEventSuppression=function(e){this.eventsToSuppress[e]&&(this.eventsToSuppress[e]=0)},e.prototype.clearEventSuppressions=function(){var e=this;Object.keys(this.eventsToSuppress).forEach((function(t){return e.clearEventSuppression(t)})),this.pendingTimeouts.forEach((function(e){return window.clearTimeout(e)}))},e.prototype.triggerEvent=function(e,t){void 0===t&&(t={type:e}),e===o.MediaElementEvent.error?this.handleVideoElementErrorEvent(t):this.handleVideoElementEvent(t)},e.prototype.attachVideoEventHandlers=function(){var e=this;Object.keys(o.MediaElementEvent).forEach((function(t){t===o.MediaElementEvent.error?e.element.addEventListener(o.MediaElementEvent.error,e.handleVideoElementErrorEvent):e.element.addEventListener(t,e.handleVideoElementEvent)}))},e.prototype.removeVideoEventHandlers=function(){var e=this;Object.keys(o.MediaElementEvent).forEach((function(t){e.element.removeEventListener(t,e.handleVideoElementEvent)})),this.element.removeEventListener(o.MediaElementEvent.error,this.handleVideoElementErrorEvent)},e.prototype.shouldSuppressEvent=function(t){return!!this.isAd||(!(!this.isPriming||!e.PRIME_RELATED_EVENTS.includes(t.type))||this.eventsToSuppress[t.type]>0&&(this.eventsToSuppress[t.type]--,!0))},e.prototype.maybeLogEvent=function(e,t){var n,i;if(null===(i=null===(n=this.context)||void 0===n?void 0:n.logger)||void 0===i?void 0:i.isLevelEnabled(r.LogLevel.DEBUG)){var o=this.context.logger,a="[MediaElementEvent] ".concat(e);this.context.settings.ENABLE_MEDIA_ELEMENT_EVENT_LOGS?t?o.debug(a,t):o.debug(a):o.isLevelEnabled(r.LogLevel.INSANE)&&(t?o.insane(a,t):o.insane(a))}},e.prototype.callAllHandlers=function(e){var t=this;this.eventHandlerMap[e.type]&&this.eventHandlerMap[e.type].forEach((function(n){t.callEventHandler(n,e)}))},e.prototype.callEventHandler=function(e,t){var n=e.eventModification?e.eventModification(t):t;e.eventHandler.handleEvent?e.eventHandler.handleEvent(n):"function"==typeof e.eventHandler?e.eventHandler(n):this.context.logger.debug("Encountered unknown event handler for "+t.type+": ",e.eventHandler)},e.prototype.addEventListener=function(e,t,n){this.eventHandlerMap[e]=this.eventHandlerMap[e]||[],this.eventHandlerMap[e].push(new u(t,n))},e.prototype.hasEventHandler=function(e,t){return!!this.eventHandlerMap[e]&&null!=this.eventHandlerMap[e].find((function(e){return e.eventHandler===t}))},e.prototype.removeEventListener=function(e,t){this.eventHandlerMap[e]&&(this.eventHandlerMap[e]=this.eventHandlerMap[e].filter((function(e){return e.eventHandler!==t})))},e.prototype.reset=function(){this.clearEventSuppressions()},e.prototype.dispose=function(){this.reset(),this.removeVideoEventHandlers(),this.eventHandlerMap=null},e.getMediaErrorName=function(e){if(MediaError)for(var t in MediaError)if(t.indexOf("MEDIA_ERR_")>-1&&MediaError[t]===e)return t;return null},e.PRIME_RELATED_EVENTS=[o.MediaElementEvent.play,o.MediaElementEvent.playing,o.MediaElementEvent.pause,o.MediaElementEvent.timeupdate],e}();t.MediaElementEventHandler=s;var u=function(){function e(e,t){this.eventHandler=e,t&&i.Util.isFunction(t)&&(this.eventModification=t)}return e}()},573:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.MediaElementWrapper=void 0;var r=n(997),i=n(1356),o=n(6462),a=n(1480),s=n(1419),u=function(){function e(e,t){this.element=t,this.context=e,this.mediaElementEventHandler=new a.MediaElementEventHandler(e,t),this.nativeMediaEventListener=new s.NativeMediaEventListener(e,this),this.drmHandler=null}return Object.defineProperty(e.prototype,"audioTracks",{get:function(){return this.element.audioTracks},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"buffered",{get:function(){return this.element.buffered},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"currentSrc",{get:function(){return this.element.currentSrc},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"duration",{get:function(){return this.element.duration},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"ended",{get:function(){return this.element.ended},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"error",{get:function(){return this.element.error},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"mediaKeys",{get:function(){return this.element.mediaKeys},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"msKeys",{get:function(){return this.element.msKeys},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"paused",{get:function(){return this.element.paused},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"networkState",{get:function(){return this.element.networkState},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"played",{get:function(){return this.element.played},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"readyState",{get:function(){return this.element.readyState},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"seekable",{get:function(){return this.element.seekable},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"seeking",{get:function(){return this.element.seeking},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"style",{get:function(){return this.element&&this.element.style},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"textTracks",{get:function(){return this.element.textTracks},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"videoTracks",{get:function(){return this.element.videoTracks},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"firstChild",{get:function(){return this.element.firstChild},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"autoplay",{get:function(){return this.element.autoplay},set:function(e){this.element.autoplay=e},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"controls",{get:function(){return this.element.controls},set:function(e){this.element.controls=e},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"crossOrigin",{get:function(){return this.element.crossOrigin},set:function(e){this.element.crossOrigin=e},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"currentTime",{get:function(){var e,t;return null!==(t=null===(e=this.element)||void 0===e?void 0:e.currentTime)&&void 0!==t?t:0},set:function(e){this.element.currentTime=e},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"innerHTML",{get:function(){return this.element.innerHTML},set:function(e){this.element.innerHTML=e},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"muted",{get:function(){return this.element&&this.element.muted},set:function(e){this.nativeMediaEventListener.lastKnownState.muted=e,this.element.muted=e},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"preload",{get:function(){return this.element.preload},set:function(e){this.element.preload=e},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"src",{get:function(){return this.element.src},set:function(e){this.nativeMediaEventListener.reset(),this.element.src=e},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"srcObject",{get:function(){return this.element.srcObject},set:function(e){this.nativeMediaEventListener.reset(),this.element.srcObject=e},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"playbackRate",{get:function(){return this.element.playbackRate},set:function(e){try{this.element.playbackRate=e}catch(t){this.context.logger.log("Browser rejected to set playback rate to "+e)}},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"volume",{get:function(){return this.element.volume},set:function(e){this.nativeMediaEventListener.lastKnownState.volume=e,this.element.volume=e},enumerable:!1,configurable:!0}),e.prototype.addTextTrack=function(e,t,n){return this.element.addTextTrack(e,t,n)},e.prototype.canPlayType=function(e,t){return this.element.canPlayType(e,t)},e.prototype.load=function(){this.element.load()},e.prototype.pause=function(){this.element&&this.element.pause()},e.prototype.play=function(){return this.internalPlay()},e.prototype.internalPlay=function(){return this.element.play()||i.PlayPromise.new(this.context,this,this.drmHandler)},e.prototype.prime=function(){var e=this,t=function(t){e.mediaElementEventHandler&&(e.mediaElementEventHandler.isPriming=t)};return t(!0),this.mediaElementEventHandler.triggerEvent(o.MediaElementEvent.primestart),this.internalPrime().then((function(){t(!1)}))},e.prototype.internalPrime=function(){this.internalPlay().catch((function(){})),this.pause();var e=this.getWrappedElement();return new Promise((function(t){var n=setTimeout((function(){e.removeEventListener(o.MediaElementEvent.pause,r),t()}),100),r=function(){clearTimeout(n),e.removeEventListener(o.MediaElementEvent.pause,r),t()};e.addEventListener(o.MediaElementEvent.pause,r)}))},e.prototype.setMediaKeys=function(e){return this.element&&this.element.setMediaKeys(e)||Promise.resolve()},e.prototype.msSetMediaKeys=function(e){return this.element&&this.element.msSetMediaKeys(e)},e.prototype.msSetMediaProtectionManager=function(e){this.element.msSetMediaProtectionManager(e)},e.prototype.getAttribute=function(e){return this.element.getAttribute(e)},e.prototype.setAttribute=function(e,t){this.element.setAttribute(e,t)},e.prototype.removeAttribute=function(e){this.element.removeAttribute(e)},e.prototype.hasAttribute=function(e){return this.element.hasAttribute(e)},e.prototype.appendChild=function(e){this.element.appendChild(e)},e.prototype.removeChild=function(e){return this.element.removeChild(e)},e.prototype.getElementsByTagName=function(e){return this.element.getElementsByTagName(e)},e.prototype.addEventListener=function(e,t,n){this.mediaElementEventHandler.addEventListener(e,t,n)},e.prototype.removeEventListener=function(e,t){this.mediaElementEventHandler&&this.mediaElementEventHandler.removeEventListener(e,t)},Object.defineProperty(e.prototype,"eventHandler",{get:function(){return this.mediaElementEventHandler},enumerable:!1,configurable:!0}),e.prototype.getWrappedElement=function(){return this.element},e.prototype.dispose=function(){this.mediaElementEventHandler=(0,r.dispose)(this.mediaElementEventHandler),this.nativeMediaEventListener=(0,r.dispose)(this.nativeMediaEventListener),this.drmHandler=null,this.element=null,this.context.logger&&this.context.logger.debug("Disposed wrapped element")},e}();t.MediaElementWrapper=u},1419:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.NativeMediaEventListener=void 0;var r=n(8665),i=n(2510),o=n(7177),a=n(6462),s=function(){function e(e,t){var n,o,a,s,u,l,d=this;this.context=e,this.onVolumeChanged=function(){var e=d.element.volume,t=d.element.muted;d.lastKnownState.muted!==t&&(t?d.firePlayerEvent(i.PlayerEvent.Muted,{issuer:"media-element"}):d.firePlayerEvent(i.PlayerEvent.Unmuted,{issuer:"media-element"}),d.lastKnownState.muted=t),d.lastKnownState.volume!==e&&(d.firePlayerEvent(i.PlayerEvent.VolumeChanged,{issuer:"media-element",targetVolume:100*e,sourceVolume:100*d.lastKnownState.volume}),d.lastKnownState.volume=e)},this.onRateChanged=function(){var e=d.element.playbackRate;d.context.serviceManager.maybeCall(r.ServiceName.PlayerStateService,(function(t){t.playbackSpeed!==e&&t.setPlaybackSpeed(e)}))},this.onCanPlayChanged=function(){d.lastKnownState.canPlay||(d.lastKnownState.canPlay=!0,d.firePlayerEvent(i.PlayerEvent.Ready))},this.element=t,this.lastKnownState={muted:null!==(a=null===(o=null===(n=e.config)||void 0===n?void 0:n.playback)||void 0===o?void 0:o.muted)&&void 0!==a?a:t.muted,volume:null!==(l=null===(u=null===(s=e.config)||void 0===s?void 0:s.playback)||void 0===u?void 0:u.volume)&&void 0!==l?l:t.volume,playbackRate:t.playbackRate,canPlay:!1},this.addEventListeners()}return e.prototype.addEventListeners=function(){this.element.addEventListener(a.MediaElementEvent.volumechange,this.onVolumeChanged),this.element.addEventListener(a.MediaElementEvent.canplay,this.onCanPlayChanged),this.element.addEventListener(a.MediaElementEvent.ratechange,this.onRateChanged)},e.prototype.firePlayerEvent=function(e,t){(0,o.isContextAvailable)(this.context)&&this.context.eventHandler&&this.context.eventHandler.dispatchEvent(e,t)},e.prototype.removeEventListeners=function(){this.element.removeEventListener(a.MediaElementEvent.volumechange,this.onVolumeChanged),this.element.removeEventListener(a.MediaElementEvent.canplay,this.onCanPlayChanged),this.element.removeEventListener(a.MediaElementEvent.ratechange,this.onRateChanged)},e.prototype.reset=function(){this.lastKnownState.canPlay=!1},e.prototype.dispose=function(){this.removeEventListeners()},e}();t.NativeMediaEventListener=s},8794:function(e,t,n){var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");function r(){this.constructor=t}e(t,n),t.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(t,"__esModule",{value:!0}),t.HlsParserWebworkerMessageHandler=void 0,t.getContext=l;var i=n(1715),o=n(7697),a=n(9692),s=null;function u(){var e=new o.WebWorkerContext(d);return onmessage=e.onMessageCallback,e}function l(){return s||u()}var d=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return r(t,e),t.prototype.parseHlsPlaylist=function(e){var t=e.payload;try{var n=(0,a.parsePlaylist)(t.data,t.options);this.postMessageFunction({action:"parsedPlaylist",data:n})}catch(e){this.postMessageFunction({action:"error",data:e.message})}},t}(i.MessageHandler);t.HlsParserWebworkerMessageHandler=d,"undefined"==typeof window&&(s=u())},7967:function(e,t,n){var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},r.apply(this,arguments)},i=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var r,i=0,o=t.length;i<o;i++)!r&&i in t||(r||(r=Array.prototype.slice.call(t,0,i)),r[i]=t[i]);return e.concat(r||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.generateRendition=u,t.generateStartAttributes=l,t.generatePartInfoTag=d,t.generateServerControlTag=c,t.generateSkipTag=f,t.generatePartTag=p,t.generatePreloadHintTag=g,t.generateStreamInfTag=S,t.generateVariantPlaylistId=v,t.generateSessionKeyTag=m,t.generateIFrameStreamInfTag=h,t.generateSegmentEntrySkeleton=y,t.generateCueTag=T,t.generateDateRange=_,t.generateKeyTag=I,t.generateByteRangeTag=R,t.generateMapTag=O,t.generateCustomTag=C;var o=n(2510),a=n(1397),s=n(6093);function u(e){var t,n,i;return{name:e.name,attributes:r(r({},e.attributes),{TYPE:null===(t=e.attributes)||void 0===t?void 0:t.TYPE,"GROUP-ID":null===(n=e.attributes)||void 0===n?void 0:n["GROUP-ID"],NAME:null===(i=e.attributes)||void 0===i?void 0:i.NAME})}}function l(e){var t,n;return(null===(t=e.attributes)||void 0===t?void 0:t.hasOwnProperty("TIME-OFFSET"))&&(n={timeOffset:Number(e.attributes["TIME-OFFSET"]),precise:"YES"===e.attributes.PRECISE}),e.attributes&&n&&n.hasOwnProperty("timeOffset")&&(e.attributes["TIME-OFFSET"]=n.timeOffset,e.attributes.PRECISE=n.precise),n}function d(e){return{targetDuration:parseFloat(e["PART-TARGET"])}}function c(e){var t={canBlockReload:!1};return e.attributes?(e.attributes["CAN-SKIP-UNTIL"]&&(t.canSkipUntil=parseFloat(e.attributes["CAN-SKIP-UNTIL"])),void 0!==t.canSkipUntil&&e.attributes["CAN-SKIP-DATERANGES"]&&(t.canSkipDateRanges="YES"===e.attributes["CAN-SKIP-DATERANGES"]),e.attributes["HOLD-BACK"]&&(t.holdBack=parseFloat(e.attributes["HOLD-BACK"])),e.attributes["PART-HOLD-BACK"]&&(t.partHoldBack=parseFloat(e.attributes["PART-HOLD-BACK"])),e.attributes["CAN-BLOCK-RELOAD"]&&(t.canBlockReload="YES"===e.attributes["CAN-BLOCK-RELOAD"]),t):t}function f(e){var t={skippedSegments:0,recentlyRemovedDateranges:[]};return e.attributes?(e.attributes["SKIPPED-SEGMENTS"]&&(t.skippedSegments=parseInt(e.attributes["SKIPPED-SEGMENTS"])),e.attributes["RECENTLY-REMOVED-DATERANGES"]&&(t.recentlyRemovedDateranges=e.attributes["RECENTLY-REMOVED-DATERANGES"].split("\\t")),t):t}function p(e,t){var n={uri:(0,a.forceReallocation)(e.URI),duration:parseFloat(e.DURATION)};if("YES"===e.INDEPENDENT&&(n.independent=!0),e.BYTERANGE){var r=e.BYTERANGE.split("@"),i=parseInt(r[0]),o=parseInt(r[1]);isNaN(o)&&(o=(null==t?void 0:t.byteRange)?t.byteRange.end+1:0),n.byteRange={start:o,end:o+i-1}}return"YES"===e.GAP&&(n.gap=!0),n}function E(e){var t=parseInt(e["BYTERANGE-START"]),n=parseInt(e["BYTERANGE-END"]);if(!isNaN(t)||!isNaN(n))return{start:isNaN(t)?0:t,end:isNaN(n)?Math.pow(2,53)-1:n}}function g(e,t){if("PART"===e.TYPE){var n={uri:(0,a.forceReallocation)(e.URI),duration:t,isPreloadHint:!0};return(r=E(e))&&(n.byteRange=r),{part:n}}if("MAP"===e.TYPE){var r,i={url:(0,a.forceReallocation)(e.URI)};return(r=E(e))&&(i.byteRange=r),{init:i}}return{}}function S(e,t){var n,i,o,a,s,u={name:e.name,uri:t,attributes:r(r({},e.attributes),{BANDWIDTH:null===(n=e.attributes)||void 0===n?void 0:n.BANDWIDTH})};return(null===(i=e.attributes)||void 0===i?void 0:i.RESOLUTION)&&(u.attributes.RESOLUTION=N(e)),(null===(o=e.attributes)||void 0===o?void 0:o.BANDWIDTH)&&(u.attributes.BANDWIDTH=parseInt(e.attributes.BANDWIDTH)),(null===(a=e.attributes)||void 0===a?void 0:a["AVERAGE-BANDWIDTH"])&&(u.attributes["AVERAGE-BANDWIDTH"]=parseInt(e.attributes["AVERAGE-BANDWIDTH"])),(null===(s=e.attributes)||void 0===s?void 0:s["PROGRAM-ID"])&&(u.attributes["PROGRAM-ID"]=parseInt(e.attributes["PROGRAM-ID"])),u.id=v(u.attributes),u}function v(e){var t="";return e.RESOLUTION&&(t+=e.RESOLUTION.height+"_"),t+=e.BANDWIDTH}function m(e){A(e)}function h(e){var t,n,r;(null===(t=e.attributes)||void 0===t?void 0:t.BANDWIDTH)&&(e.attributes.BANDWIDTH=parseInt(e.attributes.BANDWIDTH)),(null===(n=e.attributes)||void 0===n?void 0:n["AVERAGE-BANDWIDTH"])&&(e.attributes["AVERAGE-BANDWIDTH"]=parseInt(e.attributes["AVERAGE-BANDWIDTH"],10)),(null===(r=e.attributes)||void 0===r?void 0:r.RESOLUTION)&&(e.attributes.RESOLUTION=N(e))}function y(){return{uri:"",duration:0,mediaSequence:0}}function T(e,t){var n={type:t};if(e.attributes){var r=[];for(var i in e.attributes)if(e.attributes.hasOwnProperty(i)){var o=e.attributes[i]?"".concat(i,"=").concat(e.attributes[i]):i;r.push(o)}n.attributes=r}return n}function _(e){var t={type:o.MetadataType.DATERANGE};if(e.attributes){t.clientAttributes={};var n=e.attributes;for(var r in n)if(n.hasOwnProperty(r))if(r.startsWith("X-")){var i=2;t.clientAttributes[(0,a.kebabCaseToCamelCase)(r.substring(i))]=n[r]}else t[(0,a.kebabCaseToCamelCase)(r)]=n[r]}return t.duration&&(t.duration=Number(t.duration)),t.plannedDuration&&(t.plannedDuration=Number(t.plannedDuration)),t.endOnNext&&(t.endOnNext=!0),t}function I(e){if(A(e),e.attributes&&"NONE"!==e.attributes.METHOD&&e.attributes.URI){var t={method:(0,a.forceReallocation)(e.attributes.METHOD)||"AES-128",uri:(0,a.forceReallocation)(e.attributes.URI)};return void 0!==e.attributes.IV&&(t.iv=e.attributes.IV),e.attributes.KEYFORMAT&&(t.keyformat=(0,a.forceReallocation)(e.attributes.KEYFORMAT)),e.attributes.KEYFORMATVERSIONS&&(t.keyformatversions=(0,a.forceReallocation)(e.attributes.KEYFORMATVERSIONS)),e.attributes.KEYID&&(t.keyid=(0,a.forceReallocation)(e.attributes.KEYID)),t}}function R(e,t){var n;if(e.value){var r=e.value.split("@"),i=r[0],o=r[1],a={length:parseInt(i||"0")};if(o)a.offset=parseInt(o);else{var s=t[t.length-1];(null==s?void 0:s.byterange)&&(a.offset=(null!==(n=s.byterange.offset)&&void 0!==n?n:0)+s.byterange.length)}return a}}function O(e,t){var n,r;if(null===(n=e.attributes)||void 0===n?void 0:n.URI){var o={url:(0,a.forceReallocation)(e.attributes.URI)};if(null===(r=e.attributes)||void 0===r?void 0:r.BYTERANGE){var s=e.attributes.BYTERANGE.split("@"),u=s[0],l=s[1];o.byteRange={start:parseInt(l),end:parseInt(l)+parseInt(u)-1}}return t.keys.length>0&&(o.keys=i([],t.keys,!0),t.keyInUse=!0),o}}function A(e){var t;if(null===(t=e.attributes)||void 0===t?void 0:t.IV){e.attributes.IV=e.attributes.IV.toLowerCase();var n=2;"0x"===e.attributes.IV.substring(0,n)&&(e.attributes.IV=e.attributes.IV.substring(n)),e.attributes.IV=new Uint8Array(s.FormatHelper.hexToBytes(e.attributes.IV)).buffer}}function N(e){var t,n={width:0,height:0},r=null===(t=e.attributes)||void 0===t?void 0:t.RESOLUTION.split("x");return r[0]&&(n.width=parseInt(r[0])),r[1]&&(n.height=parseInt(r[1])),n}var M=/(?:^|,)((?:[^=]*)=(?:"[^"]*"|[^,]*))/,b=/([^=]*)=(.*)/,L=/^[\'"](.*)[\'"]$/,P=/^[\'"](.*)[\'"]$/g,D=/^([^:="]*)([:=])?(.*)$/;function C(e){try{e=(0,a.forceReallocation)(e);var t=/^#([^:=]*)([:=])?(.*)$/.exec(e);if(!(null==t?void 0:t[1]))return;var n={name:t[1]},r="";if("="===t[2]&&t[3])r=t[3];else if(":"===t[2]&&t[3]){var i=D.exec(t[3]);i&&"="===i[2]&&i[3]?n.attributes=U(t[3]):r=t[3]}return r&&(n.value=r.replace(P,"$1")),n}catch(e){return}}function U(e){for(var t=e.split(M),n=t.length,r={};n--;)if(""!==t[n]){var i=b.exec(t[n]);if(i){var o=i.slice(1),a=o[0],s=o[1];r[a.trim()]=s.trim().replace(L,"$1")}}return r}},7485:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.TextParser=void 0;var n=/[ \\t]+/gm,r=function(){function e(e){this.data=e,this.position=0}return e.prototype.isAtEnd=function(){return this.position===this.data.length},e.prototype.skipWhitespace=function(){this.readRegex(n)},e.prototype.readRegex=function(e){var t=this.indexOf(e);if(!this.isAtEnd()&&void 0!==t&&t.position===this.position)return this.position+=t.length,t.results},e.prototype.indexOf=function(e){e.lastIndex=this.position;var t=e.exec(this.data);if(null!==t)return{position:t.index,length:t[0].length,results:t}},e}();t.TextParser=r},9692:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.parsePlaylist=d;var r,i=n(6461),o=n(2600),a=n(5877),s=n(7967),u=/\\r\\n|\\r(?=[^\\n]|$)/gm,l=/^#EXTM3U($|[ \\t\\n])/m;function d(e,t){void 0===t&&(t={});var n=-1===e.indexOf("#EXTINF")?r.Master:r.Media,d=e.replace(u,"\\n").trim().split(/\\n+/m),f=(0,i.removeTrailingWhitespaces)(d[0]);if(!l.test(f))throw new Error("Playlist parsing failed: missing #EXTM3U tag");if(n===r.Media)return(0,a.parseVariant)(d,t);for(var p,E=[],g=[],S=[],v=1,m=!0,h=!1,y=!0,T=0;T<d.length;T++){var _=(0,i.removeTrailingWhitespaces)(d[T]),I=d[T+1];if((0,i.isCustomTag)(_))c(E,_);else if(y)y=!1;else{var R=(0,o.parseTag)(_);switch(R.name){case"EXT-X-STREAM-INF":S.push((0,s.generateStreamInfTag)(R,(0,i.removeTrailingWhitespaces)(I))),y=!0;break;case"EXT-X-MEDIA":var O=(0,s.generateRendition)(R);g.push(O),E.push(O);break;case"EXT-X-VERSION":v=Number(R.value);break;case"EXT-X-START":p=(0,s.generateStartAttributes)(R),E.push(R);break;case"EXT-X-ALLOW-CACHE":m="YES"===R.value||void 0===R.value;break;case"EXT-X-INDEPENDENT-SEGMENTS":h=!0,E.push(R);break;case"EXT-X-I-FRAME-STREAM-INF":(0,s.generateIFrameStreamInfTag)(R),E.push(R);break;case"EXT-X-SESSION-DATA":default:E.push(R);break;case"EXT-X-SESSION-KEY":(0,s.generateSessionKeyTag)(R),E.push(R)}}}var A={version:v,allowCache:m,independentSegments:h,hasM3u:!0,media:g,playlists:S,tags:E=E.concat(S)};return p&&(A.start=p),A}function c(e,t){var n=(0,s.generateCustomTag)(t);n&&e.push(n)}!function(e){e.Master="master",e.Media="media"}(r||(r={}))},6461:function(e,t,n){var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},r.apply(this,arguments)},i=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var r,i=0,o=t.length;i<o;i++)!r&&i in t||(r||(r=Array.prototype.slice.call(t,0,i)),r[i]=t[i]);return e.concat(r||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.parseSegments=c,t.addCustomTagToPlaylistTagList=f,t.handleCustomTag=p,t.removeTrailingWhitespaces=T,t.isCustomTag=_;var o=n(2442),a=n(2510),s=n(7550),u=n(2600),l=n(5877),d=n(7967);function c(e,t,n,r){void 0===r&&(r={});for(var a,c=[],f=0,I=(0,d.generateSegmentEntrySkeleton)(),R=i([],t,!0),O=0,A=n.mediaSequence,N={keys:[],keyInUse:!1},M=function(){I=(0,d.generateSegmentEntrySkeleton)(),R=[],O=0},b=function(e){E(I,O,e,a,N,R,A),c.push(I),f+=O,A++,M()},L=function(e){var t,s,f=(0,u.parseTag)(e);switch(f.name){case"EXTINF":O=parseFloat(f.value);break;case"EXT-X-BYTERANGE":I.byterange=(0,d.generateByteRangeTag)(f,c);break;case"EXT-X-DISCONTINUITY":I.discontinuity=!0;break;case"EXT-X-PROGRAM-DATE-TIME":S(I,f);break;case"EXT-X-KEY":if("NONE"===(null===(t=f.attributes)||void 0===t?void 0:t.METHOD)){N.keys=[{method:o.HlsEncryptionMethod.NONE}];break}g(f,N);break;case"EXT-X-MAP":a=(0,d.generateMapTag)(f,N);break;case"EXT-X-DATERANGE":v(I,f);break;case"EXT-X-CUE-OUT-CONT":I.cueTag=(0,d.generateCueTag)(f,"CUE-OUT-CONT");break;case"EXT-X-CUE-OUT":I.cueTag=(0,d.generateCueTag)(f,"CUE-OUT");break;case"EXT-X-CUE-IN":I.cueTag=(0,d.generateCueTag)(f,"CUE-IN");break;case"EXT-X-SCTE35":m(I,f);break;case"EXT-X-PART":h(f,I,r);break;case"EXT-X-PRELOAD-HINT":var p=y(f,n.partInfo,r);p.init&&(a=p.init,N.keys.length>0&&(a.keys=i([],N.keys,!0),N.keyInUse=!0)),p.part&&(I.parts=null!==(s=I.parts)&&void 0!==s?s:[],I.parts.push(p.part));break;case"EXT-X-SKIP":var E=(0,d.generateSkipTag)(f);n.skippedSegmentsCount=E.skippedSegments,A+=E.skippedSegments;break;case"EXT-X-ENDLIST":n.endList=!0;break;default:(0,l.resolvePlaylistTag)(n,f,R)}},P=0,D=e;P<D.length;P++){var C=T(D[P]);if(""!==C)!C.startsWith("#")?b(C):_(C)?p(n,R,C):L(C)}I.parts&&I.parts.length>0&&(O=I.parts.reduce((function(e,t){return e+t.duration}),0),b(s.PHANTOM_SEGMENT_URL)),n.segments=c,n.totalDuration=f}function f(e,t){void 0===e.tags&&(e.tags=[]),t&&e.tags.push(t)}function p(e,t,n){t.push({type:a.MetadataType.CUSTOM,attributes:n}),f(e,(0,d.generateCustomTag)(n))}function E(e,t,n,r,o,a,s){e.duration=t,e.uri=n,e.mediaSequence=s,r&&(e.init=r),a.length>0&&(e.customTags=a),o.keys.length>0&&(e.keys=i([],o.keys,!0),o.keyInUse=!0)}function g(e,t){t.keyInUse&&(t.keys=[],t.keyInUse=!1);var n=(0,d.generateKeyTag)(e);void 0!==n&&t.keys.push(n)}function S(e,t){t.value&&(e.dateTime=new Date(t.value))}function v(e,t){void 0===e.dateRange&&(e.dateRange=[]),e.dateRange.push((0,d.generateDateRange)(t))}function m(e,t){var n;void 0===e.scte35&&(e.scte35=[]),e.scte35.push({type:a.MetadataType.SCTE,attributes:r({CUE:null===(n=t.attributes)||void 0===n?void 0:n.CUE},t.attributes)})}function h(e,t,n){var r;if(n.parsePartTags){t.parts=null!==(r=t.parts)&&void 0!==r?r:[];var i=t.parts[t.parts.length-1];t.parts.push((0,d.generatePartTag)(e.attributes,i))}}function y(e,t,n){return n.parsePartTags&&t?(0,d.generatePreloadHintTag)(e.attributes,t.targetDuration):{}}function T(e){return e.replace(/^[ \\t]+/g,"")}function _(e){return/^#(?!EXT)/m.test(e)}},2600:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.parseTag=s;var r=n(7485),i=/^#(EXT[^:]*)(?::(.*))?$/,o=/^(?:"([^"]*)"|([^,=]+))(?:,|$)/g,a=/([^=]+)=*(?:"([^"]*)"|([^",]*))(?:,|$)/g;function s(e){var t,n=i.exec(e);if(!n)throw new Error("Invalid tag "+e);var s,u=n[1],l=n[2],d={};if(l){var c=new r.TextParser(l),f=void 0,p=c.readRegex(o);for(p&&(s=null!==(t=p[1])&&void 0!==t?t:p[2]);f=c.readRegex(a);){var E=f[1],g=f[2]||f[3];if(E.includes(",")){var S=E.split(","),v=S[0];E=S[1].trim(),d[v]=void 0}d[E]=g,c.skipWhitespace()}}return{name:u,attributes:d,value:s}}},5877:function(e,t,n){var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},r.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.SEGMENT_TAGS=void 0,t.parseVariant=u,t.resolvePlaylistTag=d;var i=n(2510),o=n(6461),a=n(2600),s=n(7967);function u(e,n){void 0===n&&(n={});for(var r={version:1,allowCache:!0,hasM3u:!0,endList:!1,segments:[],skippedSegmentsCount:0,targetDuration:0,totalDuration:0,mediaSequence:0},i=[],s=0;s<e.length;s++){var u=(0,o.removeTrailingWhitespaces)(e[s]);if(""!==u)if((0,o.isCustomTag)(u))(0,o.handleCustomTag)(r,i,u);else{var c=(0,a.parseTag)(u);if(t.SEGMENT_TAGS.includes(c.name))return(0,o.parseSegments)(e.slice(s),i,r,n),l(r),r;d(r,c,i)}}return l(r),r}function l(e){var t;"EVENT"===e.playlistType&&(e.discontinuitySequence=null!==(t=e.discontinuitySequence)&&void 0!==t?t:0)}function d(e,t,n){switch(t.name){case"EXT-X-VERSION":e.version=Number(t.value);break;case"EXT-X-START":e.start=(0,s.generateStartAttributes)(t);break;case"EXT-X-INDEPENDENT-SEGMENTS":e.independentSegments=!0;break;case"EXT-X-TARGETDURATION":t.value&&(e.targetDuration=parseInt(t.value));break;case"EXT-X-MEDIA-SEQUENCE":t.value&&(e.mediaSequence=parseInt(t.value));break;case"EXT-X-DISCONTINUITY-SEQUENCE":t.value&&(e.discontinuitySequence=parseInt(t.value));break;case"EXT-X-PLAYLIST-TYPE":e.playlistType="EVENT"===t.value?"EVENT":"VOD";break;case"EXT-X-PART-INF":e.partInfo=(0,s.generatePartInfoTag)(t.attributes);break;case"EXT-X-ALLOW-CACHE":e.allowCache="NO"!==t.value;break;case"EXT-X-SERVER-CONTROL":e.serverControl=(0,s.generateServerControlTag)(t);break;case"EXTM3U":break;default:n.push(r({type:i.MetadataType.CUSTOM},t)),(0,o.addCustomTagToPlaylistTagList)(e,t)}}t.SEGMENT_TAGS=["EXTINF","EXT-X-BYTERANGE","EXT-X-DISCONTINUITY","EXT-X-PROGRAM-DATE-TIME","EXT-X-KEY","EXT-X-GAP","EXT-X-BITRATE","EXT-X-PART","EXT-X-DATERANGE","EXT-X-MAP","EXT-X-CUE-OUT-CONT","EXT-X-CUE-OUT","EXT-X-CUE-IN","EXT-X-SCTE35","EXT-X-DATERANGE","EXT-X-SKIP"]},3553:function(e,t){var n;Object.defineProperty(t,"__esModule",{value:!0}),t.SegmentInfoError=void 0,function(e){e.COULD_NOT_LOAD_PLAYLIST="COULD_NOT_LOAD_PLAYLIST",e.END_OF_STREAM_REACHED="END_OF_STREAM_REACHED",e.PERIOD_COMPLETE="PERIOD_COMPLETE",e.SEGMENT_EXCEEDING_PERIOD_DURATION="SEGMENT_EXCEEDING_PERIOD_DURATION"}(n||(t.SegmentInfoError=n={}))},8915:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.isSegmentTiming=o,t.findSegmentIndexForTime=a,t.createInitSegmentInfoBase=l,t.getSegmentInfoTimeRange=d,t.generateSegmentId=c;var r=n(16),i=n(4838);function o(e){return"startTime"in e&&(0,r.isNumber)(e.startTime)&&"duration"in e&&(0,r.isNumber)(e.duration)}function a(e,t,n){var r=!e||!e.length,i=t<e[0].startTime+e[0].duration;if(r||i)return 0;var o=e.length-1;if(t>=e[o].startTime)return o;var a=Math.max(t-e[0].startTime,0),l=Math.min(Math.floor(a/n),e.length-1);return s(e[0])&&s(e[l])?u(e,t,l):null}function s(e){return e&&(0,r.isNumber)(e.startTime)}function u(e,t,n){for(;e[n]&&e[n].startTime>t;)n--;for(;e[n]&&e[n].startTime+e[n].duration<=t;)n++;return n=Math.max(n,0),n=Math.min(n,e.length-1)}function l(e){var t=e._internalId;return{internalRepresentationId:t,representationId:t.representationId,periodId:t.periodId,mimeType:e._mimeType,isInitSegment:!0}}function d(e){if((null==e?void 0:e.duration)&&void 0!==(null==e?void 0:e.startTime))return{start:e.startTime,end:e.startTime+e.duration}}function c(e){var t,n,r=null!==(n=null===(t=e.discontinuitySequenceNumber)||void 0===t?void 0:t.toString())&&void 0!==n?n:e.periodId,o=e.byteRange?"-".concat(e.byteRange.start,":").concat(e.byteRange.end):"";return i.Util.hashCode("".concat(r,":").concat(e.url).concat(o))}},7550:function(e,t,n){var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},r.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.SegmentListMPDHandler=t.PHANTOM_SEGMENT_URL=void 0,t.assignSegmentStartTimesFromHlsRepresentation=I,t.copyPropValues=N,t.getMatchingPart=M;var i=n(2442),o=n(8665),a=n(2055),s=n(1397),u=n(1361),l=n(4388),d=n(331),c=n(16),f=n(1520),p=n(6368),E=n(2103),g=n(3326),S=n(3109),v=n(3553),m=n(8915);t.PHANTOM_SEGMENT_URL="PHANTOM-SEGMENT";var h=function(){function e(e){this.context=e,this.sourceContext=e.sourceContext,this.settings=e.settings,this.logger=e.logger,this.manifestService=e.serviceManager.get(o.ServiceName.ManifestService,this.sourceContext.sourceIdentifier),this.distanceToListStartSeconds=0,this.segmentListMap={},this.timestampOffset=NaN}return Object.defineProperty(e.prototype,"playerStateService",{get:function(){return this.context.serviceManager.get(o.ServiceName.PlayerStateService)},enumerable:!1,configurable:!0}),e.prototype.createSegmentListEntry=function(e,t){var n;if(!e)return null;var o={isInitSegment:!1,url:e._media,duration:e._duration,internalRepresentationId:t,periodId:t.periodId};if(e._key&&e._key.method!==i.HlsEncryptionMethod.NONE&&(o.key=e._key),void 0!==e._playbackTime&&(o.startTime=e._playbackTime),e._dateTime&&(o.dateTime=e._dateTime),e._metadata&&(o.metadata=e._metadata),e._byteRange&&(o.byteRange=e._byteRange),e._init&&(o.init=e._init,(null===(n=e._init.key)||void 0===n?void 0:n.method)===i.HlsEncryptionMethod.NONE&&(o.init=r({},o.init),delete o.init.key)),void 0!==e._mediaSequence&&(o.mediaSequence=e._mediaSequence),void 0!==e._discontinuitySequenceNumber&&(o.discontinuitySequenceNumber=e._discontinuitySequenceNumber),e._parts){var a=o.dateTime;o.parts=e._parts.map((function(e){var t=R(e,o);return a&&(t.dateTime=a,t.startTime=(0,d.toSeconds)(a.getTime()),a=new Date(a.getTime()+(0,d.toMilliSeconds)(e.duration))),t}))}return o.segmentId=(0,m.generateSegmentId)(o),o},e.prototype.removeDroppedOutSegmentsFromList=function(e,t,n){if(t.SegmentURL.length<1)return e.entries=[],e.totalDuration=0,e.entries.length;for(var r=this.createSegmentListEntry(t.SegmentURL[0],n),i=0,o=0,a=0;a<e.entries.length;a++){var s=e.entries[a];if((0,E.isIdenticalSegmentInfo)(s,r))break;i+=s.duration,e.entries.splice(a,1),a--,o++,this.manifestService.isLive()&&this.currentRepresentationId.equals(n)&&this.rewindOneSegment()}return e.totalDuration-=i,o},e.prototype.addNewSegmentsToList=function(e,t,n){for(var r=[],i=e.entries[e.entries.length-1],o=0,a=t.SegmentURL.length-1;a>=0;a--){var s=this.createSegmentListEntry(t.SegmentURL[a],n);if(i&&(0,E.isIdenticalSegmentInfo)(i,s)){if(O(i)){var u=A(i,s);e.totalDuration+=u}break}i&&(0,E.isIdenticalInitSegmentInfo)(i.init,s.init)&&(s.init=i.init),isNaN(s.duration)&&(s.duration=e.maximumSegmentDuration),s.duration/=e.timescale,o+=s.duration,r.unshift(s)}return e.totalDuration+=o,e.entries=e.entries.concat(r),r.length},e.prototype.updateSegmentList=function(e,t){var n,r,i=t.SegmentList,o=t._internalId.representationId,a=null===(n=this.currentRepresentationId)||void 0===n?void 0:n.equals(t._internalId),s=null===(r=null==i?void 0:i[0])||void 0===r?void 0:r.SegmentURL.length;if(!a||s){e.Uri&&e.Uri!==t.Uri&&this.resetSegmentListUponFailover(e,null==i?void 0:i[0],a),e.Uri=t.Uri,e.timescale=1,e.maximumSegmentDuration=1,e.startNumber=1;for(var u=function(n){var r=i[n];if(r.hasOwnProperty("_duration")&&(e.maximumSegmentDuration=Number(r._duration)),["_timescale","_startNumber","_presentationTimeOffset"].filter((function(e){return r.hasOwnProperty(e)})).forEach((function(t){return e[t.substr(1)]=r[t]})),l.updateInitInfo(e,r,t),r.hasOwnProperty("SegmentURL")){var a=l.removeDroppedOutSegmentsFromList(e,r,t._internalId),s=l.addNewSegmentsToList(e,r,t._internalId);l.logManifestUpdateStats(t._mimeType,o,a,s),l.manifestService.isHlsManifest()?I(e.entries,t._internalId,l.manifestService):l.assignSegmentStartTimesForDash(e,t._internalId)}},l=this,d=0;d<i.length;d++)u(d)}},e.prototype.resetSegmentListUponFailover=function(e,t,n){var r,i,o,a,s,l;if(this.manifestService.isLive()&&n){var d=null!==(o=null===(i=null===(r=e.entries)||void 0===r?void 0:r[0])||void 0===i?void 0:i.mediaSequence)&&void 0!==o?o:1/0,c=(null!==(s=null===(a=null==t?void 0:t.SegmentURL[0])||void 0===a?void 0:a._mediaSequence)&&void 0!==s?s:0)-d,f=P(e);!isNaN(c)&&c>0&&c<f&&this.rewindSegmentListIndexBy(c)}(0,u.clearArray)(null!==(l=e.entries)&&void 0!==l?l:[])},e.prototype.updateInitInfo=function(e,t,n){var r,i=null===(r=f.ModuleManager.get(p.ModuleName.DASH,!1))||void 0===r?void 0:r.initSegmentInfoSourceDetectors.isInitializationNode;(null==i?void 0:i(t))?e.init=f.ModuleManager.get(p.ModuleName.DASH,!1).initSegmentInfoProviders.provideSegmentInfoFromInitializationNodeProperty(t,n):delete e.init},e.prototype.logManifestUpdateStats=function(e,t,n,r){(n>0||r>0)&&this.logger.debug("[".concat(e,"][").concat(t,"] Updated segment list, removed ").concat(n," segments and added ").concat(r," segments"))},e.prototype.assignSegmentStartTimesForDash=function(e,t){var n=this.getMinStartTime(t),r=0;e.entries.forEach((function(e){var t;e.startTime=n+r,r+=null!==(t=e.duration)&&void 0!==t?t:0}))},e.prototype.extrapolateStartTimesFromDiscontinuityStarts=function(e){var t,n,r,i,o=null===(n=null===(t=this.getSourceStateService())||void 0===t?void 0:t.getState())||void 0===n?void 0:n.hls;if(o){var a=e.getRepresentationId().representationId,s=this.getSegmentListEntries(this.currentRepresentationId),u=f.ModuleManager.get(p.ModuleName.HLS).selectors,l=u.getDiscoSequenceTimings,d=u.getMergedDiscontinuityTimings,c=T(s,null!==(r=l(o,e.getMimeType()))&&void 0!==r?r:d(o));if(!c){var E=null===(i=this.getCurrentPeriod())||void 0===i?void 0:i.start;if(void 0===E)return;c={index:0,discontinuityStartTime:E},this.logger.debug("Could not find discontinuity boundary with start time, using period start time ".concat(E))}this.logger.debug("Assigning segment start times for rep ".concat(a," from discontinuity at index ").concat(c.index," with time ").concat(c.discontinuityStartTime)),s[c.index].startTime=c.discontinuityStartTime;for(var g=c.index-1;g>=0;g--)s[g].startTime=s[g+1].startTime-s[g+1].duration;for(g=c.index+1;g<s.length;g++)s[g].startTime=s[g-1].startTime+s[g-1].duration}},e.prototype.getSourceStateService=function(){return this.context.serviceManager.get(o.ServiceName.SourceStoreService,this.context.sourceContext.sourceIdentifier)},e.prototype.getListIndexForSegment=function(e,t){for(var n=-1,r=this.getSegmentListEntries(t),i=r.length-1;i>=0;i--)if((0,E.isIdenticalSegmentInfo)(r[i],e)){n=i;break}return n},e.prototype.populateSegmentListMap=function(e){var t=this;this.manifestService.getAdaptationSet(e).Representation.forEach((function(e){var n=t.segmentListMap[e._internalId.key()];if(n||(n=t.initializeSegmentList(e._internalId.key())),e.hasOwnProperty("SegmentList")&&(t.updateSegmentList(n,e),f.ModuleManager.has(p.ModuleName.DASH))){var r=f.ModuleManager.get(p.ModuleName.DASH).initSegmentInfoSourceDetectors.isInitializationNode;if(!n.hasOwnProperty("init")&&e.hasOwnProperty("SegmentBase")&&e.SegmentBase&&r(e.SegmentBase[0])){var i=f.ModuleManager.get(p.ModuleName.DASH).initSegmentInfoProviders.provideSegmentInfoFromInitializationNodeProperty;n.init=i(e.SegmentBase[0],e)}}}))},e.prototype.selectNewRepresentationId=function(){var e,t,n=this,r=null===(e=this.context.serviceManager.get(o.ServiceName.SourceStoreService,this.sourceContext.sourceIdentifier).getState().activeTracks)||void 0===e?void 0:e[this.adaptationSetId.adaptationSetId];if((null===(t=null==r?void 0:r.selectedRepresentationId)||void 0===t?void 0:t.periodId)===this.adaptationSetId.periodId)return r.selectedRepresentationId;if(this.currentRepresentationId){var i=this.manifestService.getRepresentation(this.adaptationSetId,this.currentRepresentationId.representationId);if(i)return i._internalId}var a=function(e){return n.isSegmentInfoLoaded(e._internalId)};return(this.getMatchingRepresentationByBandwidth(a)||this.getMatchingRepresentationByBandwidth())._internalId},e.prototype.getMatchingRepresentationByBandwidth=function(e){return this.manifestService.getMatchingRepresentationByBandwidth(this.adaptationSetId,this.getCurrentBandwidth(),e)},e.prototype.shouldUpdateRepresentation=function(){var e=this.adaptationSetId.equals(this.currentRepresentationId),t=!this.currentRepresentationId||Boolean(this.manifestService.getRepresentationById(this.currentRepresentationId));return!this.currentRepresentationId||!e||!t},e.prototype.setAdaptationSetId=function(e){this.adaptationSetId=e,this.populateSegmentListMap(this.adaptationSetId);var t,n=this.manifestService.isLive(),r=0;this.shouldUpdateRepresentation()&&(this.currentRepresentationId=this.selectNewRepresentationId());var i=this.segmentListMap[this.currentRepresentationId.key()];if(i||(i=this.initializeSegmentList(this.currentRepresentationId.key())),i&&n&&i.entries&&i.entries.length>0){var o=i.entries.length-1;this.listIndex>o&&(r=this.listIndex-o),this.listIndex=Math.min(o,this.listIndex||0),this.listIndex=Math.max(0,this.listIndex),t=i.entries[this.listIndex]}if(this.listIndex=this.listIndex||0,n&&(this.distanceToListStartSeconds=this.getSegmentDuration()*this.settings.LIVE_SEGMENT_LIST_START_INDEX_OFFSET),n){if(t&&i){var a=this.getListIndexForSegment(t,this.currentRepresentationId);a>=0?this.listIndex=a+r:this.reset()}else this.reset();var s=this.checkForSegmentInfoError();s?this.rejectPendingSegmentInfoRequest(s):this.resolvePendingSegmentInfoRequests()}else this.resolvePendingSegmentInfoRequests()},e.prototype.initializeSegmentList=function(e){var t={totalDuration:0,entries:[],SegmentURL:[],startNumber:0,init:null,maximumSegmentDuration:1,timescale:1};return this.segmentListMap[e]=t,t},e.prototype.getCurrentBandwidth=function(){var e=0,t=this.getCurrentRepresentation();return t&&(e=t._bandwidth),e},e.prototype.checkForSegmentInfoError=function(){var e;if(this.manifestService.isHlsManifest()){var t=this.manifestService.getRepresentationById(this.currentRepresentationId);if(null===(e=null==t?void 0:t._hls)||void 0===e?void 0:e.loadFailureReason)return t._hls.loadFailureReason}return this.hasNext()||this.manifestService.isLastPeriod(this.currentRepresentationId.periodId)?null:v.SegmentInfoError.PERIOD_COMPLETE},e.prototype.reset=function(){this.settings.ENABLE_SEEK_FOR_LIVE?this.listIndex=0:this.timeShift(0)},e.prototype.syncSegmentStartTimeUsingMediaSequenceNumber=function(e,t){var n,r,i,o,a=this.manifestService.getRepresentationById(e),s=this.manifestService.getRepresentationById(t),l=(0,c.isNumber)(null===(n=null==s?void 0:s._hls)||void 0===n?void 0:n.mediaSequence)&&(0,c.isNumber)(null===(r=null==a?void 0:a._hls)||void 0===r?void 0:r.mediaSequence);if(a&&s&&l){var d=(null===(i=null==s?void 0:s._hls)||void 0===i?void 0:i.mediaSequence)-(null===(o=null==a?void 0:a._hls)||void 0===o?void 0:o.mediaSequence),f=this.getSegmentListEntries(e),p=this.getSegmentListEntries(t);if(!(d>=f.length)){p[0].startTime=f[d].startTime;var E=function(e,t){(0,c.isNumber)(e.startTime)&&(0,c.isNumber)(e.duration)&&(t.startTime=e.startTime+e.duration)};(0,u.forEachFromIndex)(p,1,E)}}},e.prototype.setRepresentationId=function(e){var t=this.manifestService.getRepresentationById(e),n=this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex];if(t){var r=void 0===this.currentRepresentationId,i=this.currentRepresentationId;if(this.currentRepresentationId=e,this.manifestService.isLive()&&t._hls)if(this.settings.HLS_SYNC_SEGMENT_PLAYBACK_TIME_VIA_MEDIA_SEQUENCE&&this.syncSegmentStartTimeUsingMediaSequenceNumber(i,this.currentRepresentationId),r)this.reset();else if(this.settings.HLS_SYNC_VIA_MEDIA_SEQUENCE){var o=this.manifestService.getRepresentationById(i)._hls.mediaSequence+this.listIndex;this.listIndex=o-t._hls.mediaSequence,this.listIndex=Math.max(this.listIndex,0)}else if(null!=(null==n?void 0:n.startTime)&&!isNaN(n.startTime)){var a=this.getIndexForTime(n.startTime);null===a||isNaN(a)||(this.listIndex=this.adaptListIndexToCorrectIndex(a,n.startTime))}return!0}return!1},e.prototype.adaptListIndexToCorrectIndex=function(e,t){var n=this.getSegmentListEntries(this.currentRepresentationId),r=[n[e],n[e+1]];if(e===n.length-1||r.some((function(e){return!e.startTime})))return e;var i=r.map((function(e){return Math.abs(e.startTime-t)})),o=Math.min.apply(this,i);return e+i.indexOf(o)},e.prototype.getInitSegmentInfo=function(){var e=this.getSegmentList(this.currentRepresentationId);if(null==e?void 0:e.init)return e.init.presentationTimeOffset=this.getTimestampOffset(),e.init;var t=this.getSegmentListEntries(this.currentRepresentationId);if(this.isIndexInBounds(t)&&this.listIndex>-1){var n=r({},t[this.listIndex]);if(n.init){var i=n.init;return i.isInitSegment=!0,i}}return null},e.prototype.getNextSegmentInfo_=function(e){var t;if(!(this.getSegmentListEntries(this.currentRepresentationId).length<1||this.listIndex<0)){var n=this.isTargetTimeOfOngoingSeek(e);return n&&this.logger.debug("".concat(null===(t=this.adaptationSetId)||void 0===t?void 0:t.adaptationSetId," given time ").concat(e," matches seek time, performing precise segment/part search"),e),(0,S.isPlayingLowLatencyHls)(this.context)&&this.setListIndexForTime(e,n),this.getNextSegmentOrPart(e,n)}},e.prototype.isTargetTimeOfOngoingSeek=function(e){var t;return e===(null===(t=this.playerStateService)||void 0===t?void 0:t.targetPlaybackTime)||!1},e.prototype.setListIndexForTime=function(e,t){var n;if(0!==e){if(this.listIndex=this.getIndexForTime(e),!t){var r=this.getSegmentListEntries(this.currentRepresentationId),i=r[this.listIndex];if(!(i.parts&&i.parts.length>0)){var o=this.listIndex;this.listIndex=b(e,this.listIndex,r),this.listIndex!==o&&this.logger.debug("Snapped segment index for time ".concat(e," to next segment boundary at ").concat(null===(n=r[this.listIndex])||void 0===n?void 0:n.startTime))}}}else this.context.logger.debug("Ignoring target time of 0 for LL-HLS")},e.prototype.getNextSegmentOrPart=function(e,t){var n=this.getSegmentListEntries(this.currentRepresentationId);if(this.isIndexInBounds(n)){var r=n[this.listIndex];if(!(r.parts&&r.parts.length>0))return this.getNextFullSegmentInfo();if(O(r))return M(r,e,t);var i=M(r,e,t);return i?r.parts.indexOf(i)>0?i:this.getNextFullSegmentInfo():(this.listIndex++,this.getNextSegmentOrPart(e,t))}},e.prototype.getNextSegmentInfo=function(e){var t=this.getNextSegmentInfo_(e);return t?(this.populateSegmentInfoProps(t),Promise.resolve(t)):this.queueSegmentInfoRequest({time:e})},e.prototype.populateSegmentInfoProps=function(e){return e.presentationTimeOffset=this.getTimestampOffset(),e.startTime&&(e.wallClockTime=(0,d.toMilliSeconds)(e.startTime)),e},e.prototype.getNextFullSegmentInfo=function(){return this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex++]},e.prototype.getSegmentInfos=function(){var e=this,t={},n=this.manifestService.getAdaptationSet(this.adaptationSetId);return n&&n.Representation.forEach((function(n){var r=e.getSegmentListEntries(n._internalId);t[n._id]=r.map((function(e){return{url:e.url,duration:e.duration,startTime:e.startTime}}))})),t},e.prototype.getSubtitleUrl=function(){return this.manifestService.getAvailableSubtitles(this.adaptationSetId.periodId)[0].url},e.prototype.getStartNumber=function(){var e=this.getSegmentList(this.currentRepresentationId);return e?e.startNumber:1},e.prototype.getSegmentDuration=function(){var e=this,t=this.getSegmentList(this.currentRepresentationId),n=this.getSegmentListEntries(this.currentRepresentationId);if(t)return n.length>0&&(0,c.isNumber)(t.totalDuration)?t.totalDuration/n.length:t.maximumSegmentDuration;if(this.manifestService.getAdaptationSet(this.adaptationSetId)){var r=Object.keys(this.segmentListMap).map((function(t){return e.segmentListMap[t]})).find((function(e){return null!==e}));if(r)return r.maximumSegmentDuration}return 1},e.prototype.seekTo=function(e){e>-1&&(this.listIndex=this.getIndexForTime(e))},e.prototype.isIndexInBounds=function(e){return this.listIndex<e.length},e.prototype.hasNext=function(){var e=this.getSegmentListEntries(this.currentRepresentationId);return!this.currentRepresentationId||!e.length||(!this.manifestService.isLive()?this.isIndexInBounds(e):this.hasNextLive(e))},e.prototype.hasNextLive=function(e){return!!this.manifestService.isLastPeriod(this.currentRepresentationId.periodId)||this.isIndexInBounds(e)},e.prototype.setTimestampOffset=function(e,t){void 0===t&&(t=1),this.timestampOffset=e/t},e.prototype.getTimestampOffset=function(){if(!isNaN(this.timestampOffset))return this.timestampOffset;var e=this.getCurrentPeriod(),t=0;if(this.currentRepresentationId){var n=this.getSegmentList(this.currentRepresentationId);n&&!isNaN(n.presentationTimeOffset)&&(t=n.presentationTimeOffset/n.timescale)}return e&&!this.manifestService.isHlsManifest()&&(t-=e.start),t},e.prototype.getIndex=function(){return this.listIndex},e.prototype.setIndex=function(e){if("number"==typeof e)return e<0?(this.logger.debug("Tried to set index at MPDHandler to value smaller 0. Setting to 0."),void(this.listIndex=0)):void(this.listIndex=e);this.logger.debug("Tried to set index at MPDHandler with parameter not being a number!")},e.prototype.queueSegmentInfoRequest=function(e){var t,n=this;if(this.pendingSegmentInfoRequest)return Promise.reject("fail");var i=this.manifestService.getRepresentationById(this.currentRepresentationId);return(null===(t=null==i?void 0:i._hls)||void 0===t?void 0:t.loadFailureReason)?Promise.reject(i._hls.loadFailureReason):(this.logger.debug("No segment info was found for the target time. Waiting for representation update."),new Promise((function(t,i){n.pendingSegmentInfoRequest=r(r({},e),{resolve:t,reject:i})})))},e.prototype.resolvePendingSegmentInfoRequests=function(){if(this.pendingSegmentInfoRequest){var e=this.getNextSegmentInfo_(this.pendingSegmentInfoRequest.time);e?(this.populateSegmentInfoProps(e),this.pendingSegmentInfoRequest.resolve(e),this.pendingSegmentInfoRequest=null):this.manifestService.isLive()||this.hasNext()||this.pendingSegmentInfoRequest.reject(v.SegmentInfoError.END_OF_STREAM_REACHED)}},e.prototype.rejectPendingSegmentInfoRequest=function(e){this.pendingSegmentInfoRequest&&(this.pendingSegmentInfoRequest.reject(e),this.pendingSegmentInfoRequest=null)},e.prototype.getLiveEdgeIndex=function(){var e=this.getSegmentListEntries(this.currentRepresentationId);return e.length>0?e.length-1:0},e.prototype.getIndexForOffset=function(e){for(var t,n=Math.abs(e),r=this.getSegmentDuration(),i=this.getSegmentListEntries(this.currentRepresentationId),o=this.getLiveEdgeIndex(),a=0,s=i.length-1;s>=0&&!((a+=null!==(t=i[s].duration)&&void 0!==t?t:r)>=n);s--)o--;return Math.max(0,o)},e.prototype.timeShift=function(e,t,n){if(this.manifestService.isLive()){var r=this.listIndex;this.listIndex=n&&this.hasStartTimes()?this.getIndexForTime(n):this.getIndexForOffset(e),this.logger.debug("timeShift changes index from ".concat(r," to ").concat(this.listIndex,", based on")+" offset ".concat(e," and target time ").concat(n))}},e.prototype.hasStartTimes=function(){var e,t=null===(e=this.getSegmentListEntries(this.currentRepresentationId)[0])||void 0===e?void 0:e.startTime;return(0,c.isNumber)(t)&&t>=0},e.prototype.updateRepresentation=function(e){return Promise.resolve(e)},e.prototype.isSegmentInfoLoaded=function(e){if(void 0===e&&(e=this.currentRepresentationId),!e)return!1;var t=this.getSegmentListEntries(e),n=this.manifestService.getRepresentationById(e);return!(!t.length||!n)},e.prototype.rewindSegmentListIndexBy=function(e){this.logger.debug("Rewinding segment list index by ".concat(e," segments")),this.listIndex-=e,this.listIndex<0&&(this.logger.debug("List array index is smaller than 0, probably a discontinuity. Using 0."),this.listIndex=0)},e.prototype.rewindOneSegment=function(){return this.listIndex--,!(this.listIndex<0)||(this.logger.debug("List array index is smaller than 0, probably a discontinuity. Using 0."),this.listIndex=0,!1)},e.prototype.getCurrentPeriod=function(){return this.manifestService.getPeriod(this.currentRepresentationId)},e.prototype.getExpectedPresentationTime=function(e){var t=this.getCurrentPeriod().start;return(this.manifestService.hasSinglePeriod()?this.getSeekableRange().start:t)+this.getSegmentListEntries(this.currentRepresentationId).slice(0,e).reduce((function(e,t){return e+t.duration}),0)},e.prototype.getCurrentRepresentation=function(){return this.manifestService.getRepresentationById(this.currentRepresentationId)},e.prototype.getSegmentList=function(e){if(e)return this.segmentListMap[e.key()]},e.prototype.getSegmentListEntries=function(e){var t,n;return e?this.settings.ENABLE_SEGMENT_INFO_PROVIDER_FROM_STORE&&this.manifestService.isHlsManifest()?this.getStoreSegmentInfos(e):null!==(n=null===(t=this.getSegmentList(e))||void 0===t?void 0:t.entries)&&void 0!==n?n:[]:[]},e.prototype.getStoreSegmentInfos=function(e){var t,n=null===(t=this.getSourceStateService())||void 0===t?void 0:t.getState();return(0,g.getSegmentInfos)(n,e.key())},e.prototype.findListIndexWithoutSegmentStartTimes=function(e,t){var n,r;if(!this.adaptationSetId)return 0;for(var i=this.manifestService.getPeriod(this.adaptationSetId),o=null!==(n=null==i?void 0:i.start)&&void 0!==n?n:0,a=this.getSegmentListEntries(this.currentRepresentationId),s=0,u=o;u<=t&&s<a.length;s++)u+=null!==(r=a[s].duration)&&void 0!==r?r:0;return Math.max(s-1,0)},e.prototype.getIndexForTime=function(e){var t=this.getSegmentList(this.currentRepresentationId),n=this.getSegmentListEntries(this.currentRepresentationId);if(!t||0===n.length||!(0,c.isNumber)(t.totalDuration))return 0;var r=this.getMinStartTime(),i=Math.max(r,e),o=t.totalDuration/n.length,a=(0,m.findSegmentIndexForTime)(n,i,o);return null!==a?a:this.findListIndexWithoutSegmentStartTimes(t,i)},e.prototype.getMinStartTime=function(e){void 0===e&&(e=this.currentRepresentationId);var t=this.manifestService.hasSinglePeriod()?this.getSeekableRange().start:this.manifestService.getPeriod(e).start;return this.manifestService.isFirstPeriod(e.periodId)&&(t+=this.distanceToListStartSeconds),t},e.prototype.getLiveEdgeTime=function(){var e,t=null===(e=this.manifestService)||void 0===e?void 0:e.getLastPeriod();return t?t.start+l.DurationConverter.getDurationInSec(t._duration):1/0},e.prototype.getActualTimeShiftBufferDepth=function(){return this.manifestService.getTimeShiftBufferDepthSeconds()},e.prototype.getSeekableRange=function(){var e={start:0,end:0},t=this.manifestService.getTotalDuration();if(!this.manifestService.isLive())return e.start=(0,a.getStartTimeOffset)(this.getSourceStateService().getState()),e.end=t,e;var n=this.manifestService.getTimeShiftBufferDepthSeconds(),r=(0,d.toSeconds)(this.manifestService.getRequestTimestamp()-this.manifestService.getAvailabilityStartTime());if(e.start=Math.max(r+n,0),e.end=Math.max(r,0),f.ModuleManager.has(p.ModuleName.HLS)&&this.manifestService.isHlsManifest()){var i=f.ModuleManager.get(p.ModuleName.HLS).selectors,o=i.getHlsState;"EVENT"===(0,i.getPlaylistType)(o(this.getSourceStateService().getState()))?(e.start=0,e.end=t):e.start+=this.distanceToListStartSeconds}return e.end-=this.manifestService.getDesiredDistanceToLiveEdge(),e},e.prototype.getPendingSegmentInfoRequest=function(){return this.pendingSegmentInfoRequest},e.prototype.setPendingSegmentInfoRequest=function(e){this.pendingSegmentInfoRequest=e},e.prototype.canSwitchRepresentation=function(e){var t,n=this.getSegmentListEntries(this.currentRepresentationId)[this.listIndex];if(!n)return!0;var r=L(e,n,this.settings.LL_HLS_SEGMENT_END_TIME_MATCHING_TOLERANCE);if(!O(n)&&r)return!0;var i=this.isTargetTimeOfOngoingSeek(e);return!((null===(t=null==n?void 0:n.parts)||void 0===t?void 0:t.length)&&M(n,e,i)!==n.parts[0])},e.prototype.getLatestTimeForPossibleSwitch=function(e){var t,n=this.getLLHlsInfoForTime(e),r=n.isLoadingCurrentSegmentsParts,i=n.currentSegment;return i&&r&&null!==(t=i.startTime)&&void 0!==t?t:e},e.prototype.adjustTimeToNextSegmentStart=function(e){var t=this.getLLHlsInfoForTime(e),n=t.isLoadingCurrentSegmentsParts,r=t.currentSegment;return n&&(null==r?void 0:r.startTime)&&(null==r?void 0:r.duration)?r.startTime+r.duration:e},e.prototype.getLLHlsInfoForTime=function(e){var t,n=y(e,this.getSegmentListEntries(this.currentRepresentationId)),r=null===(t=null==n?void 0:n.parts)||void 0===t?void 0:t[0],i=this.isTargetTimeOfOngoingSeek(e),o=!1;if(r&&n){var a=M(n,e,i);o=void 0!==a&&a!==r}return{currentSegment:n,isLoadingCurrentSegmentsParts:o}},e.prototype.dispose=function(){this.settings=null,this.manifestService=null,this.adaptationSetId=null,this.currentRepresentationId=null,this.manifestService=null,this.pendingSegmentInfoRequest=null,this.segmentListMap=null},e}();function y(e,t){var n,r,i;if(t&&!(t.length<1)&&(null===(n=t[0])||void 0===n?void 0:n.duration)){var o=(0,m.findSegmentIndexForTime)(t,e,t[0].duration),a=null===o,s=e<(null!==(i=null===(r=t[0])||void 0===r?void 0:r.startTime)&&void 0!==i?i:1/0),u=t[t.length-1];if(void 0!==u.startTime&&void 0!==u.duration){var l=e>u.startTime+u.duration;if(!(a||s||l))return t[o]}}}function T(e,t){for(var n=e[0].discontinuitySequenceNumber,r=1;r<e.length;r++){var i=e[r].discontinuitySequenceNumber;if(i!==n){var o=_(t,i);if(null!=o)return{index:r,discontinuityStartTime:o}}}return null}function _(e,t){var n=e[String(t)];return n&&n.startTime>0?n.startTime:(n=e[String(t-1)])&&n.endTime>0?n.endTime:null}function I(e,t,n){if(e.length&&n.hasSegmentStartTimeForHlsRepresentation(t)){var r;null!=e[0].startTime?r=(0,u.findIndexFromEnd)(e,(function(e){return null!=e.startTime}))+1:(e[0].startTime=n.getStartTimeForHlsSegment(t,e[0]),r=1);var i=function(e,t){return t.startTime=e.startTime+e.duration};(0,u.forEachFromIndex)(e,r,i)}}function R(e,t){var n={url:e.uri,duration:e.duration,isInitSegment:!1,internalRepresentationId:t.internalRepresentationId,isPreloadHint:Boolean(e.isPreloadHint),isIndependent:Boolean(e.independent)};return e.byteRange&&(n.byteRange=e.byteRange),t.key&&(n.key=t.key),t.init&&(n.init=t.init),(0,c.isDefined)(t.mediaSequence)&&(n.mediaSequence=t.mediaSequence),(0,c.isDefined)(t.discontinuitySequenceNumber)&&(n.discontinuitySequenceNumber=t.discontinuitySequenceNumber),n}function O(e){return e.url.endsWith(t.PHANTOM_SEGMENT_URL)}function A(e,n){var r=n.duration-e.duration;return N(n,e,["url","mediaURL","duration","parts","init","key","discontinuitySequenceNumber","isDiscontinuityStart"]),!e.url.endsWith(t.PHANTOM_SEGMENT_URL)&&(e.url=(0,s.forceReallocation)(e.url)),r}function N(e,t,n){n.forEach((function(n){return t[n]=e[n]}))}function M(e,t,n){var r,i=null===(r=e.parts)||void 0===r?void 0:r.every(m.isSegmentTiming);if(e.parts&&i){var o=e.parts,a=o.reduce((function(e,t){return e+t.duration}),0)/o.length,s=(0,m.findSegmentIndexForTime)(o,t,a);if(null!=s)return n?e.parts[0]:(s=b(t,s,o),e.parts[s])}}function b(e,t,n){var r=n[t],i=r.startTime+r.duration;return Math.abs(e-r.startTime)<=Math.abs(e-i)?t:t+1}function L(e,t,n){return void 0!==t.startTime&&void 0!==t.duration&&Math.abs(e-(t.startTime+t.duration))<n}function P(e){var t,n,r=24,i=e.totalDuration/(null!==(n=null===(t=e.entries)||void 0===t?void 0:t.length)&&void 0!==n?n:1);return Math.ceil(r/i)}t.SegmentListMPDHandler=h},2103:function(e,t){function n(e,t){if(void 0!==e.mediaSequence&&void 0!==t.mediaSequence)return e.mediaSequence===t.mediaSequence;var n=i(e,t),r=a(e.byteRange,t.byteRange),o=e.discontinuitySequenceNumber===t.discontinuitySequenceNumber;return n&&r&&o}function r(e,t){var n=(null==e?void 0:e.url)===(null==t?void 0:t.url),r=a(null==e?void 0:e.byteRange,null==t?void 0:t.byteRange);return n&&r}function i(e,t){var n=o(e),r=o(t);return n.some((function(e){return r.includes(e)}))}function o(e){return[e.url,e.mediaURL].filter(Boolean)}function a(e,t){return null==e?null==t:null!=t&&e.start===t.start&&e.end===t.end}Object.defineProperty(t,"__esModule",{value:!0}),t.isIdenticalSegmentInfo=n,t.isIdenticalInitSegmentInfo=r},3326:function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.getMostRecentlyRefreshedQuality=t.getSegmentInfos=t.getSegmentMapEntry=void 0;var n=function(e,t){return null==e?void 0:e.segmentInfoMap[t]};t.getSegmentMapEntry=n;var r=function(e,n){var r,i;return null!==(i=null===(r=(0,t.getSegmentMapEntry)(e,n))||void 0===r?void 0:r.segmentInfos)&&void 0!==i?i:[]};t.getSegmentInfos=r;var i=function(e){if(e)return Object.values(e.segmentInfoMap).filter((function(e){return null!=e.qualityInfo.lastUpdateTimestamp})).sort((function(e,t){var n=e.qualityInfo.lastUpdateTimestamp;return t.qualityInfo.lastUpdateTimestamp-n}))[0]};t.getMostRecentlyRefreshedQuality=i},7062:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.isLowLatencyConfigured=i;var r=n(8665);function i(e){var t=e.serviceManager.get(r.ServiceName.LiveLatencyService);return(null==t?void 0:t.isConfigured())||!1}},3109:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.isPlayingLowLatencyHls=s;var r=n(7279),i=n(1520),o=n(6368),a=n(7062);function s(e){var t;if(!(0,a.isLowLatencyConfigured)(e)||!e.settings.LL_HLS)return!1;var n=(0,r.getSourceState)(e);if(!n)return!1;var s=i.ModuleManager.get(o.ModuleName.HLS,!1);if(!s)return!1;var u=s.selectors,l=u.getHlsState,d=u.getIsLowLatencyPlaylist,c=l(n);return!!c&&(null!==(t=d(c))&&void 0!==t&&t)}},5469:function(e,t,n){Object.defineProperty(t,"__esModule",{value:!0}),t.installWorkerPolyfills=s;var r=n(8367),i=n(4338),o=n(3801),a=n(1921);function s(){Array.prototype.includes||r.ArrayIncludesPolyfill.polyfill(),String.prototype.includes||o.StringIncludesPolyfill.polyfill(),String.prototype.startsWith||a.StringStartsWithPolyfill.polyfill(),String.prototype.endsWith||i.StringEndsWithPolyfill.polyfill()}}},t={};function n(r){var i=t[r];if(void 0!==i)return i.exports;var o=t[r]={exports:{}};return e[r].call(o.exports,o,o.exports,n),o.exports}!function(){n.d=function(e,t){for(var r in t)n.o(t,r)&&!n.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})}}(),function(){n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)}}(),function(){n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})}}();n(8794)}();', ne.p + "85bd0368aeb6d7b1c7f7.worker.js");
        };
      }, 3864: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var ve = function(me, be) {
            return ve = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(pe, $e) {
              pe.__proto__ = $e;
            } || function(pe, $e) {
              for (var ye in $e)
                Object.prototype.hasOwnProperty.call($e, ye) && (pe[ye] = $e[ye]);
            }, ve(me, be);
          };
          return function(me, be) {
            if (typeof be != "function" && be !== null)
              throw new TypeError("Class extends value " + String(be) + " is not a constructor or null");
            function pe() {
              this.constructor = me;
            }
            ve(me, be), me.prototype = be === null ? Object.create(be) : (pe.prototype = be.prototype, new pe());
          };
        }();
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.HlsUtils = ie.ParseStream = void 0;
        var ue = ne(62510), _e = ne(91397), fe = ne(56093);
        function le(ve) {
          var me = "";
          return ve.RESOLUTION && (me += ve.RESOLUTION.height + "_"), me += ve.BANDWIDTH;
        }
        var se = function() {
          function ve() {
            var me = this;
            this.on = function(be, pe) {
              me.listeners.hasOwnProperty(be) || (me.listeners[be] = []), me.listeners[be].push(pe);
            }, this.off = function(be, pe) {
              if (!me.listeners.hasOwnProperty(be))
                return !1;
              var $e = me.listeners[be].indexOf(pe);
              return $e > -1 && (me.listeners[be].splice($e, 1), !0);
            }, this.trigger = function(be) {
              for (var pe = [], $e = 1; $e < arguments.length; $e++)
                pe[$e - 1] = arguments[$e];
              me.listeners.hasOwnProperty(be) && me.listeners[be].forEach(function(ye) {
                return ye.apply(null, pe);
              });
            }, this.pipe = function(be) {
              me.on("data", function(pe) {
                be.push(pe);
              });
            }, this.dispose = function() {
              me.listeners = {};
            }, this.listeners = {};
          }
          return ve;
        }(), oe = function(ve) {
          function me() {
            var be = ve.call(this) || this;
            return be.buffer = "", be;
          }
          return ae(me, ve), me.prototype.push = function(be) {
            this.buffer += be;
            for (var pe = this.buffer.indexOf(`
`); pe > -1; pe = this.buffer.indexOf(`
`))
              this.trigger("data", this.buffer.substring(0, pe)), this.buffer = this.buffer.substring(pe + 1);
          }, me;
        }(se), ce = function(ve) {
          function me() {
            return ve.call(this) || this;
          }
          return ae(me, ve), me.parseAttributes = function(be) {
            for (var pe = be.split(me.attributeSeparator), $e = pe.length, ye = {}; $e--; )
              if (pe[$e] !== "") {
                var Se = this.attributeKeyValueRegex.exec(pe[$e]).slice(1), we = Se[0], Pe = Se[1];
                ye[we.trim()] = Pe.trim().replace(this.quotesRegex, "$1");
              }
            return ye;
          }, me.prototype.push = function(be) {
            var pe, $e;
            if ((be = be.replace(/^[\u0000\s]+|[\u0000\s]+$/g, "")).length !== 0)
              if (be[0] === "#")
                if (be = be.replace("\r", ""), pe = /^#EXTM3U/.exec(be))
                  this.trigger("data", { type: "tag", tagType: "m3u" });
                else if (pe = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(be))
                  this.trigger("data", { type: "tag", tagType: "independent-segments" });
                else {
                  if (pe = /^#EXT-X-MEDIA:(.*)$/.exec(be))
                    return $e = { type: "tag", tagType: "media" }, pe[1] && ($e.attributes = me.parseAttributes(pe[1])), void this.trigger("data", $e);
                  if (pe = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(be))
                    return $e = { type: "tag", tagType: "inf" }, pe[1] && ($e.duration = parseFloat(pe[1])), pe[2] && ($e.title = pe[2]), void this.trigger("data", $e);
                  if (pe = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(be))
                    return $e = { type: "tag", tagType: "targetduration" }, pe[1] && ($e.duration = parseInt(pe[1], 10)), void this.trigger("data", $e);
                  if (pe = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(be))
                    return $e = { type: "tag", tagType: "version" }, pe[1] && ($e.version = parseInt(pe[1], 10)), void this.trigger("data", $e);
                  if (pe = /^#EXT-X-START:(.*)$/.exec(be))
                    return $e = { type: "tag", tagType: "start" }, pe[1] && ($e.attributes = me.parseAttributes(pe[1])), void this.trigger("data", $e);
                  if (pe = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(be))
                    return $e = { type: "tag", tagType: "media-sequence" }, pe[1] && ($e.number = parseInt(pe[1], 10)), void this.trigger("data", $e);
                  if (pe = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(be))
                    return $e = { type: "tag", tagType: "discontinuity-sequence" }, pe[1] && ($e.number = parseInt(pe[1], 10)), void this.trigger("data", $e);
                  if (pe = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(be))
                    return $e = { type: "tag", tagType: "playlist-type" }, pe[1] && ($e.playlistType = pe[1]), void this.trigger("data", $e);
                  if (pe = /^#EXT-X-BYTERANGE:?([0-9.]*)?@?([0-9.]*)?/.exec(be))
                    return $e = { type: "tag", tagType: "byterange" }, pe[1] && ($e.length = parseInt(pe[1], 10)), pe[2] && ($e.offset = parseInt(pe[2], 10)), void this.trigger("data", $e);
                  if (pe = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(be))
                    return $e = { type: "tag", tagType: "allow-cache" }, pe[1] && ($e.allowed = !/NO/.test(pe[1])), void this.trigger("data", $e);
                  if (pe = /^#EXT-X-SESSION-DATA:?(.*)$/.exec(be))
                    return $e = { type: "tag", tagType: "session-data" }, pe[1] && ($e.attributes = me.parseAttributes(pe[1])), void this.trigger("data", $e);
                  if (pe = /^#EXT-X-SESSION-KEY:?(.*)$/.exec(be))
                    return $e = { type: "tag", tagType: "session-key" }, pe[1] && ($e.attributes = me.parseAttributes(pe[1]), $e.attributes.IV && ($e.attributes.IV = $e.attributes.IV.toLowerCase(), $e.attributes.IV.substring(0, 2) === "0x" && ($e.attributes.IV = $e.attributes.IV.substring(2)), $e.attributes.IV = new Uint8Array(fe.FormatHelper.hexToBytes($e.attributes.IV)).buffer)), void this.trigger("data", $e);
                  if (pe = /^#EXT-X-STREAM-INF:?(.*)$/.exec(be)) {
                    if ($e = { type: "tag", tagType: "stream-inf" }, pe[1]) {
                      if ($e.attributes = me.parseAttributes(pe[1]), $e.attributes.RESOLUTION) {
                        var ye = {};
                        (Se = $e.attributes.RESOLUTION.split("x"))[0] && (ye.width = parseInt(Se[0], 10)), Se[1] && (ye.height = parseInt(Se[1], 10)), $e.attributes.RESOLUTION = ye;
                      }
                      $e.attributes.BANDWIDTH && ($e.attributes.BANDWIDTH = parseInt($e.attributes.BANDWIDTH, 10)), $e.attributes["AVERAGE-BANDWIDTH"] && ($e.attributes["AVERAGE-BANDWIDTH"] = parseInt($e.attributes["AVERAGE-BANDWIDTH"], 10)), $e.attributes["PROGRAM-ID"] && ($e.attributes["PROGRAM-ID"] = parseInt($e.attributes["PROGRAM-ID"], 10));
                    }
                    this.trigger("data", $e);
                  } else if (pe = /^#EXT-X-I-FRAME-STREAM-INF:?(.*)$/.exec(be)) {
                    if ($e = { type: "tag", tagType: "i-frame-stream-inf" }, pe[1] && ($e.attributes = me.parseAttributes(pe[1]), $e.attributes.BANDWIDTH && ($e.attributes.BANDWIDTH = parseInt($e.attributes.BANDWIDTH, 10)), $e.attributes["AVERAGE-BANDWIDTH"] && ($e.attributes["AVERAGE-BANDWIDTH"] = parseInt($e.attributes["AVERAGE-BANDWIDTH"], 10)), $e.attributes.RESOLUTION)) {
                      var Se;
                      ye = {}, (Se = $e.attributes.RESOLUTION.split("x"))[0] && (ye.width = parseInt(Se[0], 10)), Se[1] && (ye.height = parseInt(Se[1], 10)), $e.attributes.RESOLUTION = ye;
                    }
                    this.trigger("data", $e);
                  } else if (pe = /^#EXT-X-ENDLIST/.exec(be))
                    this.trigger("data", { type: "tag", tagType: "endlist" });
                  else if (pe = /^#EXT-X-DISCONTINUITY/.exec(be))
                    this.trigger("data", { type: "tag", tagType: "discontinuity" });
                  else {
                    if (pe = /^#EXT-X-KEY:?(.*)$/.exec(be))
                      return $e = { type: "tag", tagType: "key" }, pe[1] && ($e.attributes = me.parseAttributes(pe[1]), $e.attributes.IV && ($e.attributes.IV = $e.attributes.IV.toLowerCase(), $e.attributes.IV.substring(0, 2) === "0x" && ($e.attributes.IV = $e.attributes.IV.substring(2)), $e.attributes.IV = new Uint8Array(fe.FormatHelper.hexToBytes($e.attributes.IV)).buffer)), void this.trigger("data", $e);
                    if (pe = /^#EXT-X-MAP:?(.*)$/.exec(be))
                      return $e = { type: "tag", tagType: "map" }, pe[1] && ($e.attributes = me.parseAttributes(pe[1])), void this.trigger("data", $e);
                    if (pe = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(be))
                      return $e = { type: "tag", tagType: "date-time" }, pe[1] && ($e.dateTime = new Date(pe[1])), void this.trigger("data", $e);
                    (pe = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(be)) ? this.trigger("data", { type: "tag", tagType: "cue-out-cont", data: pe[1] || "" }) : (pe = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(be)) ? this.trigger("data", { type: "tag", tagType: "cue-out", data: pe[1] || "" }) : (pe = /^#EXT-X-CUE-IN:?(.*)?$/.exec(be)) ? this.trigger("data", { type: "tag", tagType: "cue-in", data: pe[1] || "" }) : (pe = /^#EXT-X-SCTE35:?(.*)?$/.exec(be)) ? this.trigger("data", { type: "tag", tagType: "scte35", data: pe[1] || "" }) : (pe = /^#EXT-X-DATERANGE:?(.*)?$/.exec(be)) ? this.trigger("data", { type: "tag", tagType: "daterange", data: pe[1] || "" }) : this.trigger("data", { type: "tag", tagType: "unknown", data: be.slice(0, be.length) });
                  }
                }
              else
                this.trigger("data", { type: "uri", uri: be });
          }, me.attributeSeparator = new RegExp('(?:^|,)((?:[^=]*)=(?:"[^"]*"|[^,]*))'), me.attributeKeyValueRegex = new RegExp("([^=]*)=(.*)"), me.quotesRegex = new RegExp(/^['"](.*)['"]$/), me;
        }(se);
        ie.ParseStream = ce;
        var he = function(ve) {
          function me(be) {
            var pe = ve.call(this) || this;
            return pe.onData = function($e) {
              ({ tag: function() {
                ({ m3u: function() {
                  pe.manifestObj.hasM3u = !0;
                }, "allow-cache": function() {
                  pe.manifestObj.allowCache = $e.allowed, "allowed" in $e || (pe.trigger("info", { message: "defaulting allowCache to YES" }), pe.manifestObj.allowCache = !0);
                }, byterange: function() {
                  var ye = {};
                  "length" in $e && (pe.currentUri.byterange = ye, ye.length = $e.length, "offset" in $e || (pe.trigger("info", { message: "defaulting offset to zero" }), $e.offset = 0)), "offset" in $e && (pe.currentUri.byterange = ye, ye.offset = $e.offset);
                }, endlist: function() {
                  pe.manifestObj.endList = !0;
                }, inf: function() {
                  "mediaSequence" in pe.manifest || (pe.manifestObj.mediaSequence = 0, pe.trigger("info", { message: "defaulting media sequence to zero" })), $e.duration >= 0 && (pe.currentUri.duration = $e.duration), pe.manifestObj.segments = pe.uris;
                }, key: function() {
                  if ($e.attributes)
                    if ($e.attributes.METHOD !== "NONE")
                      if ($e.attributes.URI) {
                        $e.attributes.METHOD || pe.trigger("warn", { message: "defaulting key method to AES-128" }), pe.keysInUse && (pe.keys = [], pe.keysInUse = !1);
                        var ye = { method: (0, _e.forceReallocation)($e.attributes.METHOD) || "AES-128", uri: (0, _e.forceReallocation)($e.attributes.URI) };
                        $e.attributes.IV !== void 0 && (ye.iv = $e.attributes.IV), $e.attributes.KEYFORMAT && (ye.keyformat = (0, _e.forceReallocation)($e.attributes.KEYFORMAT)), $e.attributes.KEYFORMATVERSIONS && (ye.keyformatversions = (0, _e.forceReallocation)($e.attributes.KEYFORMATVERSIONS)), $e.attributes.KEYID && (ye.keyid = (0, _e.forceReallocation)($e.attributes.KEYID)), pe.keys.push(ye);
                      } else
                        pe.trigger("warn", { message: "ignoring key declaration without URI" });
                    else
                      pe.keys = [];
                  else
                    pe.trigger("warn", { message: "ignoring key declaration without attribute list" });
                }, "media-sequence": function() {
                  isFinite($e.number) ? pe.manifestObj.mediaSequence = $e.number : pe.trigger("warn", { message: "ignoring invalid media sequence: " + $e.number });
                }, "discontinuity-sequence": function() {
                  isFinite($e.number) ? pe.manifestObj.discontinuitySequence = $e.number : pe.trigger("warn", { message: "ignoring invalid discontinuity sequence: " + $e.number });
                }, "playlist-type": function() {
                  /VOD|EVENT/.test($e.playlistType) ? pe.manifestObj.playlistType = $e.playlistType : pe.trigger("warn", { message: "ignoring unknown playlist type: " + $e.playlist });
                }, "stream-inf": function() {
                  pe.manifestObj.playlists = pe.uris, $e.attributes ? (pe.currentUri.attributes || (pe.currentUri.attributes = {}), pe.currentUri.id = le($e.attributes), pe.currentUri.attributes = me.mergeFn($e.attributes, pe.currentUri.attributes)) : pe.trigger("warn", { message: "ignoring empty stream-inf attributes" });
                }, "i-frame-stream-inf": function() {
                  var ye = { name: "i-frame-stream-inf" };
                  $e.attributes && (ye.attributes = $e.attributes), pe.manifestObj.tags.push(ye);
                }, media: function() {
                  pe.manifestObj.media.push({ attributes: $e.attributes });
                  var ye = { name: "media" };
                  $e.attributes && (ye.attributes = $e.attributes), pe.manifestObj.tags.push(ye);
                }, start: function() {
                  var ye = {};
                  $e.attributes.hasOwnProperty("TIME-OFFSET") && (ye.timeOffset = Number($e.attributes["TIME-OFFSET"]), ye.precise = $e.attributes.PRECISE === "YES", pe.manifestObj.start = ye);
                  var Se = { name: "start" };
                  ye.hasOwnProperty("timeOffset") && (Se.attributes = { "TIME-OFFSET": ye.timeOffset, PRECISE: ye.precise }), pe.manifestObj.tags.push(Se);
                }, discontinuity: function() {
                  pe.currentUri.discontinuity = !0, pe.manifestObj.discontinuityStarts.push(pe.uris.length);
                }, "date-time": function() {
                  pe.manifestObj.dateTime = $e.dateTime;
                }, targetduration: function() {
                  !isFinite($e.duration) || $e.duration < 0 ? pe.trigger("warn", { message: "ignoring invalid target duration: " + $e.duration }) : pe.manifestObj.targetDuration = $e.duration;
                }, map: function() {
                  if ($e.attributes && $e.attributes.URI && (pe.init = { url: (0, _e.forceReallocation)($e.attributes.URI) }, $e.attributes.BYTERANGE)) {
                    var ye = $e.attributes.BYTERANGE.split("@"), Se = ye[0], we = ye[1];
                    pe.init.byteRange = { start: parseInt(we), end: parseInt(we) + parseInt(Se) - 1 };
                  }
                }, "independent-segments": function() {
                  pe.manifestObj.independentSegments = !0, pe.manifestObj.tags.push({ name: "independent-segments" });
                }, "session-data": function() {
                  var ye = { name: "session-data" };
                  $e.attributes && (ye.attributes = $e.attributes), pe.manifestObj.tags.push(ye);
                }, "session-key": function() {
                  var ye = { name: "session-key" };
                  $e.attributes && (ye.attributes = $e.attributes), pe.manifestObj.tags.push(ye);
                }, "cue-out": function() {
                  pe.cueTag = me.getCueTag($e);
                }, "cue-out-cont": function() {
                  pe.cueTag = me.getCueTag($e);
                }, "cue-in": function() {
                  pe.cueTag = me.getCueTag($e);
                }, scte35: function() {
                  pe.scte35.push({ type: ue.MetadataType.SCTE, attributes: ce.parseAttributes($e.data) });
                }, daterange: function() {
                  pe.dateRange.push(me.getDateRange($e));
                }, version: function() {
                  pe.manifestObj.version = $e.version !== void 0 ? $e.version : 1;
                }, unknown: function() {
                  pe.customTags.push({ type: ue.MetadataType.CUSTOM, attributes: $e.data });
                  var ye = pe.getCustomTag($e.data);
                  ye && pe.manifestObj.tags.push(ye);
                } }[$e.tagType] || function() {
                })();
              }, uri: function() {
                pe.currentUri.uri = (0, _e.forceReallocation)($e.uri), pe.manifestObj.targetDuration && !("duration" in pe.currentUri) && (pe.trigger("warn", { message: "defaulting segment duration to the target duration" }), pe.currentUri.duration = pe.manifestObj.targetDuration), pe.keys.length > 0 && (pe.currentUri.keys = pe.keys, pe.keysInUse = !0), pe.init && (pe.currentUri.init = pe.init), pe.cueTag && (pe.currentUri.cueTag = pe.cueTag, pe.cueTag = null), pe.scte35.length > 0 && (pe.currentUri.scte35 = pe.scte35, pe.scte35 = []), pe.dateRange.length > 0 && (pe.currentUri.dateRange = pe.dateRange, pe.dateRange = []), pe.customTags.length > 0 && (pe.currentUri.customTags = pe.customTags, pe.customTags = []), pe.manifestObj.dateTime && (pe.currentUri.dateTime = pe.manifestObj.dateTime, delete pe.manifestObj.dateTime), pe.uris.push(pe.currentUri), pe.currentUri.duration && (pe.manifestObj.totalDuration += pe.currentUri.duration), pe.currentUri = {};
              }, comment: function() {
              } })[$e.type]();
            }, pe.end = function() {
              pe.lineStream.push(`
`);
            }, pe.logger = be, pe.uris = [], pe.currentUri = {}, pe.keys = [], pe.keysInUse = !1, pe.cueTag = null, pe.scte35 = [], pe.customTags = [], pe.dateRange = [], pe.lineStream = new oe(), pe.parseStream = new ce(), pe.lineStream.pipe(pe.parseStream), pe.manifestObj = { allowCache: !0, endList: !1, media: [], segments: [], totalDuration: 0, tags: [], version: 1, hasM3u: !1 }, pe.parseStream.on("data", pe.onData), pe;
          }
          return ae(me, ve), Object.defineProperty(me.prototype, "manifest", { get: function() {
            return this.manifestObj;
          }, enumerable: !1, configurable: !0 }), me.getCueTag = function(be) {
            var pe = { type: be.tagType.toUpperCase() };
            if (be.data) {
              var $e = (0, _e.forceReallocation)(be.data);
              pe.attributes = $e.split(",").map(function(ye) {
                return ye.trim();
              });
            }
            return pe;
          }, me.getDateRange = function(be) {
            var pe = { type: ue.MetadataType.DATERANGE };
            if (be.data) {
              var $e = ce.parseAttributes(be.data);
              for (var ye in pe.clientAttributes = {}, $e)
                $e.hasOwnProperty(ye) && (ye.indexOf("X-") === 0 ? pe.clientAttributes[(0, _e.kebabCaseToCamelCase)(ye.substring(2))] = $e[ye] : pe[(0, _e.kebabCaseToCamelCase)(ye)] = $e[ye]);
            }
            return pe.duration && (pe.duration = Number(pe.duration)), pe.plannedDuration && (pe.plannedDuration = Number(pe.plannedDuration)), pe.endOnNext && (pe.endOnNext = !0), pe;
          }, me.prototype.getCustomTag = function(be) {
            try {
              be = (0, _e.forceReallocation)(be);
              var pe = /^#([^:=]*)(:|=)?(.*)$/.exec(be);
              if (pe[1]) {
                var $e = { name: pe[1] }, ye = "";
                if (pe[2] === "=" && pe[3])
                  ye = pe[3];
                else if (pe[2] === ":" && pe[3]) {
                  var Se = /^([^:="]*)(:|=)?(.*)$/.exec(pe[3]);
                  Se[2] === "=" && Se[3] ? $e.attributes = ce.parseAttributes(pe[3]) : ye = pe[3];
                }
                return ye && ($e.value = ye.replace(/^['"](.*)['"]$/g, "$1")), $e;
              }
            } catch {
              return this.logger && this.logger.debug("Error occurred while parsing custom HLS tag: ".concat(be)), null;
            }
          }, me.prototype.push = function(be) {
            this.lineStream.push(be);
          }, me.mergeFn = function(be, pe) {
            if (typeof be != "object" || typeof pe != "object" || Array.isArray(be) && Array.isArray(be))
              return be;
            for (var $e in be)
              pe.hasOwnProperty($e) ? pe[$e] = me.mergeFn(be[$e], pe[$e]) : pe[$e] = be[$e];
            return pe;
          }, me;
        }(se), ge = function() {
          function ve() {
          }
          return ve.parsePlaylist = function(me, be) {
            var pe = new he(be);
            if (pe.push(me), pe.end(), !pe.manifest.hasM3u)
              throw new Error("Playlist parsing failed: missing #EXTM3U tag");
            if ("playlists" in pe.manifest) {
              var $e = pe.manifest.playlists.map(function(ye) {
                return { name: "stream-inf", value: ye.uri, attributes: ye.attributes };
              });
              pe.manifest.tags = pe.manifest.tags.concat($e);
            }
            return "playlistType" in pe.manifest && pe.manifest.playlistType === "EVENT" && (pe.manifest.discontinuitySequence = pe.manifest.discontinuitySequence || 0), pe.manifest;
          }, ve;
        }();
        ie.HlsUtils = ge;
      }, 64697: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.CodecDetector = void 0, ie.extractCodecFromTsSegment = ve, ie.extractCodecFromMp4Segment = me, ie.mergeSegmentCodecs = pe, ie.isFmp4Segment = $e;
        var ae = ne(52442), ue = ne(28764), _e = ne(88005), fe = ne(81361), le = ne(76885), se = ne(91520), oe = ne(16368), ce = ne(41108), he = ne(53950), ge = function() {
          function we(Pe) {
            this.context = Pe, this.loader = new _e.DefaultContentLoader(this.context);
          }
          return we.prototype.fetchSegment = function(Pe) {
            if (!this.context.segmentPrefetchingService)
              return Promise.reject();
            var Te = this.context.segmentPrefetchingService.hasPrefetchedSegment(Pe) ? this.context.segmentPrefetchingService.getPrefetchedSegment(Pe) : this.context.segmentPrefetchingService.fetch(Pe);
            return Te || Promise.reject();
          }, we.prototype.probeCodecs = function(Pe, Te, Ee, Me, Ae) {
            var Ne = this;
            Ae === void 0 && (Ae = Te ? Pe.length - 1 : 0);
            var Ce = Pe.slice(), Ie = Te ? Ce.pop() : Ce.shift();
            if (!Ie)
              return Promise.reject(new Error("Could not load any segment"));
            var xe, Ue = Ie.init, ke = Ue !== void 0, Le = (0, le.extractOrigin)(Ee), De = le.URLHelper.buildAbsoluteUrl(Ee, Le, ke ? Ue.url : Ie.uri), Re = ke ? Ue.keys : Ie.keys, Oe = Se(Re ?? [], Ee, Le, Me, Ae);
            (Oe == null ? void 0 : Oe.method) === ae.HlsEncryptionMethod.AES_128 && (xe = Oe);
            var Be = ye(De, Ie, xe);
            return this.fetchSegment(Be).then(function(Fe) {
              return Ne.extractCodecsFromSegment(Fe);
            }).catch(function(Fe) {
              if (Fe instanceof ue.PlayerError)
                return Promise.reject(Fe);
              Ne.context.logger.debug("Codec probing from segment failed", Fe);
              var Ve = Te ? Ae - 1 : Ae + 1;
              return Ne.probeCodecs(Ce, Te, Ee, Me, Ve);
            }).then(function(Fe) {
              return Ne.context.logger.debug("Probed codec is", Fe), Fe;
            });
          }, we.prototype.extractCodecsFromSegment = function(Pe) {
            return $e(Pe) ? me(Pe) : ve(Pe, this.context);
          }, we;
        }();
        function ve(we, Pe) {
          if (!se.ModuleManager.has(oe.ModuleName.ContainerTS))
            return Promise.reject(new ce.PlayerModuleMissingError(oe.ModuleName.ContainerTS));
          var Te = be(Pe);
          return Te.transmuxSegment(we).then(function(Ee) {
            var Me = pe(Ee.transmuxedSegments);
            if (!Me)
              throw "couldn't detect codec for ".concat(we.getMimeType());
            return Me;
          }).finally(function() {
            Te.dispose();
          });
        }
        function me(we) {
          if (!se.ModuleManager.has(oe.ModuleName.ContainerMP4))
            return Promise.reject(new ce.PlayerModuleMissingError(oe.ModuleName.ContainerMP4));
          var Pe = se.ModuleManager.get(oe.ModuleName.ContainerMP4).getCodecFromSegment(we);
          return Pe ? Promise.resolve(Pe) : Promise.reject("couldn't detect codec for ".concat(we.getMimeType()));
        }
        function be(we) {
          return new (se.ModuleManager.get(oe.ModuleName.ContainerTS)).WebWorkerTransmuxer(we, !1);
        }
        function pe(we) {
          for (var Pe = "", Te = 0, Ee = we; Te < Ee.length; Te++) {
            var Me = Ee[Te];
            if (!Me.getCodec())
              return null;
            Pe += (Pe === "" ? "" : ",") + Me.getCodec();
          }
          return Pe;
        }
        function $e(we) {
          for (var Pe = we.getData(), Te = new DataView(Pe, 0, Pe.byteLength), Ee = [], Me = 0; Me + 8 < Te.byteLength; ) {
            var Ae = Te.getUint32(Me);
            if (Ae === 0)
              break;
            var Ne = fe.ArrayHelper.extractAsciiString(Te, Me + 4, 4);
            Ee.push(Ne), Me += Ae;
          }
          return we.isInit() ? ["ftyp", "moov"].every(function(Ce) {
            return Ee.includes(Ce);
          }) : ["moof", "mdat"].every(function(Ce) {
            return Ee.includes(Ce);
          });
        }
        function ye(we, Pe, Te) {
          return { url: we, key: Te, byteRange: (0, he.parseSegmentByteRange)(Pe.byterange), mimeType: "unknown/mp4", internalRepresentationId: null, isInitSegment: !!Pe.init, preventDownloadCanceling: !0 };
        }
        function Se(we, Pe, Te, Ee, Me) {
          for (var Ae, Ne = 0, Ce = we; Ne < Ce.length; Ne++) {
            var Ie = Ce[Ne];
            Ae = (0, he.generateSegmentEncryptionInfo)(Ie, Pe, Te, Ee, Me);
          }
          return Ae;
        }
        ie.CodecDetector = ge;
      }, 26527: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.DiscontinuitySequenceNumberTracker = void 0;
        var ne = function() {
          function ae(ue) {
            this.mimeTypeFilter = ue, this.discoSequenceNumberChangedListeners = [], this.reset();
          }
          return ae.prototype.notifyListeners = function(ue) {
            var _e = this;
            this.discoSequenceNumberChangedListeners.forEach(function(fe) {
              return fe(_e.currentDiscontinuitySequenceNumber, ue);
            });
          }, ae.prototype.trackSegment = function(ue) {
            if (this.mimeTypeFilter(ue.getMimeType()) && !ue.isInit()) {
              var _e = ue.getSegmentInfo(), fe = _e == null ? void 0 : _e.discontinuitySequenceNumber, le = isFinite(this.currentDiscontinuitySequenceNumber), se = this.currentDiscontinuitySequenceNumber !== fe;
              le && se && this.notifyListeners(fe), this.currentDiscontinuitySequenceNumber = fe;
            }
          }, ae.prototype.subscribe = function(ue) {
            this.discoSequenceNumberChangedListeners.push(ue);
          }, ae.prototype.unsubscribe = function(ue) {
            var _e = this.discoSequenceNumberChangedListeners.indexOf(ue);
            _e < 0 || this.discoSequenceNumberChangedListeners.splice(_e, 1);
          }, ae.prototype.reset = function() {
            this.currentDiscontinuitySequenceNumber = -1 / 0;
          }, ae.prototype.dispose = function() {
            this.reset(), this.discoSequenceNumberChangedListeners = [];
          }, ae;
        }();
        ie.DiscontinuitySequenceNumberTracker = ne;
      }, 293: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Te) {
            for (var Ee, Me = 1, Ae = arguments.length; Me < Ae; Me++)
              for (var Ne in Ee = arguments[Me])
                Object.prototype.hasOwnProperty.call(Ee, Ne) && (Te[Ne] = Ee[Ne]);
            return Te;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.HlsBackupStreamsHandler = ie.BackupStreamErrors = void 0;
        var ue, _e = ne(18665), fe = ne(23234), le = ne(27279), se = ne(79814), oe = ne(65114), ce = ne(99162), he = ne(41735), ge = ne(77874), ve = ne(9827), me = ne(53950), be = ne(79367);
        (function(Te) {
          Te.ALL_PENALIZED = "ALL_PENALIZED", Te.LOADING_FAILED = "LOADING_FAILED", Te.NO_BACKUP_STREAMS = "NO_BACKUP_STREAMS";
        })(ue || (ie.BackupStreamErrors = ue = {}));
        var pe = function() {
          function Te(Ee, Me, Ae) {
            this.context = Ee, this.backupStreamInfo = Me, this.updateRepresentation = Ae, this.backupStreamsMap = {}, this.penalizedStreams = {}, this.hasSourceLoadingFinished = !1, this.manifestService = Ee.serviceManager.get(_e.ServiceName.ManifestService, Ee.sourceContext.sourceIdentifier), this.manifestSchedulingService = this.context.serviceManager.get(_e.ServiceName.ManifestUpdateSchedulingService, this.context.sourceContext.sourceIdentifier);
          }
          return Te.prototype.populateBackupStreamsMap = function(Ee) {
            var Me;
            this.backupStreamsMap = ye(this.backupStreamInfo, Ee), (Me = (0, le.getSourceStore)(this.context)) === null || Me === void 0 || Me.dispatch((0, be.setContentLocationId)(String(0)));
          }, Te.prototype.signalLoadingFinished = function() {
            this.hasSourceLoadingFinished = !0;
          }, Te.prototype.switchToBackupStream = function(Ee, Me) {
            var Ae, Ne, Ce = this, Ie = (Ne = (Ae = this.backupStreamsMap[Ee._mimeType]) === null || Ae === void 0 ? void 0 : Ae[Ee._id]) !== null && Ne !== void 0 ? Ne : {};
            if (Object.keys(Ie).length <= 1)
              return Promise.reject(ue.NO_BACKUP_STREAMS);
            var xe = this.getCurrentRepresentation(Ee._mimeType), Ue = (xe == null ? void 0 : xe._id) === Ee._id && (xe == null ? void 0 : xe.Uri) !== Ee.Uri, ke = Pe(Ee, Me);
            if (Ue || !ke)
              return this.context.logger.debug("Ignoring outdated failover request for ".concat(Ee._mimeType, " rep ").concat(Ee._id), { hasPlaylistUriChanged: Ue, isSegmentInPlaylist: ke }), Promise.resolve([xe]);
            var Le = Se(Ie, Ee.Uri);
            if (Le === void 0)
              return this.context.logger.debug("Could not find the failing rep in the current list of backup streams.", { id: Ee._id, uri: Ee.Uri, backupStreams: Ie }), Promise.reject(ue.NO_BACKUP_STREAMS);
            this.penalizeLocationId(Le), this.depenalizeExpiredStreams();
            var De = this.getNextLocationId(Object.keys(Ie), Le);
            return De === void 0 ? (this.context.logger.debug("No other backup stream is available: all penalized."), Promise.reject(ue.ALL_PENALIZED)) : (this.context.logger.debug("Starting failover from stream ".concat(Le, " to ").concat(De)), this.triggerPlaylistRotation(Ee, Le, De).then(function(Re) {
              var Oe, Be, Fe, Ve = Se(Ie, (Be = (Oe = Re[0]) === null || Oe === void 0 ? void 0 : Oe.Uri) !== null && Be !== void 0 ? Be : "");
              return (Fe = (0, le.getSourceStore)(Ce.context)) === null || Fe === void 0 || Fe.dispatch((0, be.setContentLocationId)(String(Ve))), Ce.context.logger.debug("Successfully completed failover to stream index ".concat(Ve)), Re;
            }).catch(function(Re) {
              return Re === ce.REPRESENTATION_UPDATE_CANCEL ? Promise.reject(Re) : (Ce.context.logger.debug("Failover from stream ".concat(Le, " to ").concat(De, " failed")), Promise.reject(ue.LOADING_FAILED));
            }));
          }, Te.prototype.penalizeLocationId = function(Ee) {
            this.context.logger.debug("Penalizing stream ".concat(Ee, " for ").concat(this.context.settings.HLS_BACKUP_STREAM_PENALTY_DURATION, "s")), this.penalizedStreams[Ee] = fe.TimingUtil.getHiResTimestamp();
          }, Te.prototype.depenalizeExpiredStreams = function() {
            var Ee = this, Me = fe.TimingUtil.getHiResTimestamp();
            Object.keys(this.penalizedStreams).forEach(function(Ae) {
              var Ne = Ee.penalizedStreams[Ae];
              Me - Ne >= Ee.context.settings.HLS_BACKUP_STREAM_PENALTY_DURATION && (Ee.context.logger.debug("Depenalizing stream ".concat(Ae)), delete Ee.penalizedStreams[Ae]);
            });
          }, Te.prototype.triggerPlaylistRotation = function(Ee, Me, Ae) {
            var Ne = this, Ce = [Ee], Ie = Ee._mimeType === se.MimeType.AudioMp4 ? this.getCurrentRepresentation(se.MimeType.VideoMp4) : this.getCurrentRepresentation(se.MimeType.AudioMp4);
            Ie && this.hasSourceLoadingFinished && Ce.push(Ie);
            var xe = Ce.map(function(Ue) {
              return Ne.rotatePlaylist(Ue, Ae).catch(function(ke) {
                var Le;
                return ke !== ce.REPRESENTATION_UPDATE_CANCEL && (Ne.context.logger.debug("Failed to rotate URL for rep ".concat(Ue._id, ": ").concat((Le = ke == null ? void 0 : ke.message) !== null && Le !== void 0 ? Le : ke)), Ne.revertPlaylistRotation(Ue, Me)), Promise.reject(ke);
              });
            });
            return Promise.all(xe);
          }, Te.prototype.rotatePlaylist = function(Ee, Me) {
            var Ae = this, Ne = (0, le.getSourceStore)(this.context);
            if (!Ne)
              return Promise.resolve(Ee);
            this.rotateAllRepresentations(Ee, Me, Ne);
            var Ce = (0, ge.getManifest)(Ne.getState());
            if (!Ce)
              return Promise.resolve(Ee);
            var Ie = Ee._internalId, xe = (0, oe.findRepresentation)(Ce, Ie);
            return Ee.Uri === (xe == null ? void 0 : xe.Uri) ? (this.context.logger.debug("Current ".concat(Ee._mimeType, " rep ").concat(Ee._id, " does not need update")), Promise.resolve(Ee)) : (this.context.logger.debug("Rotating URL for rep ".concat(Ee._id, " from ").concat(Ee.Uri, " to ").concat(xe.Uri)), this.maybeStopManifestUpdater(Ee).then(function() {
              return Ae.updateRepresentation(xe);
            }).then(function(Ue) {
              return Ae.maybeRescheduleUpdate(Ue), Ue;
            }));
          }, Te.prototype.revertPlaylistRotation = function(Ee, Me) {
            var Ae = (0, le.getSourceStore)(this.context);
            Ae && (this.rotateAllRepresentations(Ee, Me, Ae), this.context.logger.debug("Restoring URL for rep ".concat(Ee._id, " to ").concat(Ee.Uri)), this.maybeRescheduleUpdate(Ee));
          }, Te.prototype.maybeStopManifestUpdater = function(Ee) {
            var Me;
            return !((Me = this.manifestService) === null || Me === void 0) && Me.isLive() && this.manifestSchedulingService ? this.manifestSchedulingService.stopRepresentationUpdates(Ee) : Promise.resolve();
          }, Te.prototype.maybeRescheduleUpdate = function(Ee) {
            var Me, Ae;
            !((Me = this.manifestService) === null || Me === void 0) && Me.isLive() && ((Ae = this.manifestSchedulingService) === null || Ae === void 0 || Ae.scheduleRepresentationUpdate(Ee));
          }, Te.prototype.rotateAllRepresentations = function(Ee, Me, Ae) {
            var Ne, Ce = this;
            (Ne = this.manifestService) === null || Ne === void 0 || Ne.getAllRepresentations().filter(function(Ie) {
              return Ie._mimeType === Ee._mimeType;
            }).forEach(function(Ie) {
              var xe, Ue, ke, Le, De = (Ue = (xe = Ce.backupStreamsMap[Ie._mimeType]) === null || xe === void 0 ? void 0 : xe[Ie._id]) !== null && Ue !== void 0 ? Ue : {}, Re = (ke = Ie._name) !== null && ke !== void 0 ? ke : Ie._mimeType, Oe = (Le = De[Me]) === null || Le === void 0 ? void 0 : Le[Re];
              if (Oe && Ie.Uri !== Oe) {
                var Be = ae(ae({}, Ie), { Uri: Oe, BaseURL: [{ url: $e(Oe, Ae.getState()) }], SegmentList: Ie.SegmentList ? [ae(ae({}, Ie.SegmentList[0]), { SegmentURL: [] })] : Ie.SegmentList, _requestTimestamp: Ie._id !== Ee._id ? 0 : Ie._requestTimestamp });
                Ae.dispatch((0, he.updateRepresentationAction)(Be));
              }
            });
          }, Te.prototype.getNextLocationId = function(Ee, Me) {
            for (var Ae = Number(Me) || 0, Ne = 1; Ne <= Ee.length; Ne++) {
              var Ce = (Ae + Ne) % Ee.length;
              if (this.penalizedStreams[Ce] === void 0)
                return String(Ce);
            }
          }, Te.prototype.getCurrentRepresentation = function(Ee) {
            var Me, Ae, Ne = this.context.serviceManager.get(_e.ServiceName.AdaptationService), Ce = (Me = Ne == null ? void 0 : Ne.getCurrentRepresentationId(Ee)) !== null && Me !== void 0 ? Me : void 0;
            return (Ae = this.manifestService) === null || Ae === void 0 ? void 0 : Ae.getRepresentationById(Ce);
          }, Te.prototype.getNextBackupUriForCodecProbing = function(Ee) {
            var Me, Ae, Ne, Ce, Ie, xe = function(Re) {
              return Object.values(Re).includes(Ee);
            }, Ue = (Me = this.backupStreamInfo.find(function(Re) {
              return Object.values(Re).some(xe);
            })) !== null && Me !== void 0 ? Me : {}, ke = (Ae = Object.keys(Ue).find(function(Re) {
              return xe(Ue[Re]);
            })) !== null && Ae !== void 0 ? Ae : "", Le = (Ne = Ue[ke]) !== null && Ne !== void 0 ? Ne : {}, De = (Ce = Object.keys(Le).find(function(Re) {
              return Le[Re] === Ee;
            })) !== null && Ce !== void 0 ? Ce : "";
            return (Ie = we(Ue, De)[Number(ke) + 1]) === null || Ie === void 0 ? void 0 : Ie[De];
          }, Te.prototype.dispose = function() {
            this.penalizedStreams = {};
          }, Te;
        }();
        function $e(Te, Ee) {
          var Me, Ae, Ne, Ce, Ie = Ee && (Ce = (Ne = (Ae = (Me = (0, ge.getManifest)(Ee)) === null || Me === void 0 ? void 0 : Me.BaseURL) === null || Ae === void 0 ? void 0 : Ae[0]) === null || Ne === void 0 ? void 0 : Ne.url) !== null && Ce !== void 0 ? Ce : "";
          return me.PlaylistUtils.getBaseUrl(Ie, Te);
        }
        function ye(Te, Ee) {
          var Me, Ae = ((Me = {})[se.MimeType.AudioMp4] = {}, Me[se.MimeType.VideoMp4] = {}, Me);
          return Ee.forEach(function(Ne) {
            var Ce, Ie = Ne._mimeType === se.MimeType.AudioMp4 ? (Ce = Ne._name) !== null && Ce !== void 0 ? Ce : se.MimeType.AudioMp4 : se.MimeType.VideoMp4, xe = Te.find(function(Ue) {
              return Object.values(Ue).find(function(ke) {
                return ke[Ie] === Ne.Uri;
              });
            });
            xe && (Ae[Ne._mimeType][Ne._id] = we(xe, Ie));
          }), Ae;
        }
        function Se(Te, Ee) {
          return Object.keys(Te).find(function(Me) {
            return Object.values(Te[Me]).includes(Ee);
          });
        }
        function we(Te, Ee) {
          var Me = {}, Ae = [];
          for (var Ne in Te) {
            var Ce = Te[Ne][Ee];
            Ae.includes(Ce) || (Ae.push(Ce), Me[Ne] = Te[Ne]);
          }
          return Me;
        }
        function Pe(Te, Ee) {
          var Me, Ae;
          if (!Ee)
            return !0;
          var Ne = (Ae = (Me = Te.SegmentList) === null || Me === void 0 ? void 0 : Me[0]) === null || Ae === void 0 ? void 0 : Ae.SegmentURL;
          return !!Ne && (0, ve.findSegmentUrlIndexWithinSegmentList)(Ee, Ne) !== -1;
        }
        ie.HlsBackupStreamsHandler = pe;
      }, 13254: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.isValidHlsPlaylist = be, ie.getPeriod = pe, ie.parseHlsManifest = $e, ie.ensureMasterPlaylist = ye, ie.parsePlaylistInWorker = we, ie.createDiscontinuitySequences = Pe, ie.getTracksWithUnknownCodecs = Te, ie.updateMissingCodecsForPlaylists = Ee, ie.findAllOrMatchingVariants = Ae;
        var ae = ne(16937), ue = ne(42283), _e = ne(76885), fe = ne(77874), le = ne(87062), se = ne(59692), oe = ne(53950), ce = ne(4383);
        function he(xe) {
          return xe.playlists.length > 0;
        }
        function ge(xe) {
          return xe.segments.length > 0;
        }
        function ve(xe) {
          return xe.playlists || [];
        }
        function me(xe) {
          return xe.media || [];
        }
        function be(xe) {
          return (0, oe.isMasterPlaylist)(xe) && he(xe) || (0, oe.isMediaPlaylist)(xe) && ge(xe);
        }
        function pe(xe) {
          return (0, fe.getManifest)(xe.getState()).Period[0];
        }
        function $e(xe, Ue) {
          var ke = { parsePartTags: (0, le.isLowLatencyConfigured)(xe) && xe.settings.LL_HLS };
          return (xe.settings.HLS_PARSE_MANIFEST_IN_WORKER ? we(Ue, xe.logger, ke) : Se(Ue, ke)).then(function(Le) {
            if ("playlists" in Le) {
              var De = Le.playlists.filter(function(Re) {
                return Re.attributes.BANDWIDTH >= xe.settings.HLS_AUDIO_ONLY_THRESHOLD_BITRATE;
              });
              Le.playlists = De.length ? De : Le.playlists;
            }
            return Le;
          });
        }
        function ye(xe, Ue, ke) {
          return (0, oe.isMasterPlaylist)(Ue) ? Promise.resolve(Ue) : (xe.logger.debug("HLS manifest is not a master playlist but a variant. Using master playlist template!"), $e(xe, ["#EXTM3U", "#EXT-X-STREAM-INF:PROGRAM-ID=1,BANDWIDTH=0", ke].join(`
`)).then(function(Le) {
            if (!(0, oe.isMasterPlaylist)(Le))
              throw new Error("Template is not of type HLS MasterPlaylist");
            return Le;
          }));
        }
        function Se(xe, Ue) {
          try {
            (0, ae.trackPerformanceStart)("HlsPlaylist.parsePlaylist");
            var ke = (0, se.parsePlaylist)(xe, Ue);
            return (0, ae.trackPerformanceEnd)("HlsPlaylist.parsePlaylist"), Promise.resolve(ke);
          } catch (Le) {
            return Promise.reject(Le);
          }
        }
        function we(xe, Ue, ke) {
          return ce.WebWorkerParser.getInstance(Ue).parsePlaylist(xe, ke);
        }
        function Pe(xe, Ue) {
          var ke = oe.PlaylistUtils.createDiscontinuitySequences(xe, Ue);
          return ke.forEach(function(Le, De) {
            oe.PlaylistUtils.extrapolateProgramDateTime(Le.segments), Le.indexOfFirstSegment = De === 0 ? 0 : ke[De - 1].indexOfLastSegment + 1, Le.indexOfLastSegment = Le.indexOfFirstSegment + Le.segments.length - 1;
          }), ke;
        }
        function Te(xe) {
          return { audioTracksWithoutCodecs: xe.media.filter(function(Ue) {
            var ke, Le = Ue.attributes;
            if (Le.TYPE !== "AUDIO" || Le.URI === void 0 || Le.CODECS !== void 0)
              return !1;
            var De = xe.playlists.find(function(Oe) {
              return Oe.attributes.AUDIO === Le["GROUP-ID"];
            });
            if (De === void 0 || De.uri === Le.URI)
              return !1;
            var Re = (ke = De.attributes.CODECS) === null || ke === void 0 ? void 0 : ke.split(",");
            return Re === void 0 || Re.every(function(Oe) {
              return !ue.CodecStringHelper.isAudioCodec(Oe);
            });
          }), videoTracksWithoutCodecs: xe.playlists.filter(function(Ue) {
            return Ue.attributes.CODECS === void 0;
          }) };
        }
        function Ee(xe, Ue, ke) {
          Ne(xe, Ae(Ue, ke));
        }
        function Me(xe, Ue) {
          return me(xe).find(function(ke) {
            var Le;
            return _e.URLHelper.isSubUrl(Ue, (Le = ke.attributes) === null || Le === void 0 ? void 0 : Le.URI);
          });
        }
        function Ae(xe, Ue) {
          var ke, Le = ve(xe), De = Le.some(function(Be) {
            return _e.URLHelper.isSubUrl(Ue, Be.uri);
          }), Re = Me(xe, Ue);
          if (!De && Re) {
            var Oe = (ke = Re.attributes) === null || ke === void 0 ? void 0 : ke["GROUP-ID"];
            if (Oe)
              return Le.filter(function(Be) {
                var Fe, Ve;
                return ((Fe = Be.attributes) === null || Fe === void 0 ? void 0 : Fe.AUDIO) === Oe || ((Ve = Be.attributes) === null || Ve === void 0 ? void 0 : Ve.VIDEO) === Oe;
              });
          }
          return Le;
        }
        function Ne(xe, Ue) {
          Ue.forEach(function(ke) {
            return ke.attributes.CODECS = Ie(ke.attributes.CODECS, xe);
          });
        }
        function Ce(xe, Ue, ke) {
          return typeof xe != "string" || xe.length === 0 ? Ue : xe + ke + Ue;
        }
        function Ie(xe, Ue) {
          var ke = Object.keys(ue.CodecStringHelper.getExtractedCodecStrings(xe)), Le = ue.CodecStringHelper.getExtractedCodecStrings(Ue), De = Object.keys(Le).filter(function(Re) {
            return !ke.includes(Re);
          }).map(function(Re) {
            return Le[Re];
          }).join(",");
          return De && De.length !== 0 ? Ce(xe, De, ",") : xe;
        }
      }, 33827: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.HlsTimelineTracker = void 0;
        var ae = ne(18665), ue = ne(58975), _e = ne(27279), fe = ne(3464), le = ne(9827), se = ne(34435), oe = 1e-3, ce = function() {
          function $e(ye, Se) {
            var we = this;
            this.gapVerificationOnNextSegment = !1, this.context = ye, this.playbackTimeNextSegment = -1, this.allowedGapSizeSec = Se, this.playerStateService = this.context.serviceManager.get(ae.ServiceName.PlayerStateService), this.unsubscribeFromTargetPlaybackTimeChange = (0, fe.subscribe)(this.context.store)(function(Te) {
              return (0, ue.getTargetPlaybackTime)((0, ue.getPlayerState)(Te));
            }, function() {
              return we.seekVerificationOnNextSegment = !0;
            }, function(Te) {
              return Te !== -1;
            });
            var Pe = (0, _e.getSourceStore)(this.context);
            Pe && (this.unsubscribeFromContentLocationId = (0, fe.subscribe)(Pe)(function(Te) {
              return Te && (0, se.getContentLocationId)((0, se.getHlsState)(Te));
            }, function() {
              return we.gapVerificationOnNextSegment = !0;
            }, function(Te, Ee) {
              return Te !== Ee;
            }));
          }
          return $e.prototype.reset = function() {
            this.playbackTimeNextSegment = -1, this.gapVerificationOnNextSegment = !1;
          }, $e.prototype.isGapVerificationNeeded = function() {
            return this.gapVerificationOnNextSegment && this.playbackTimeNextSegment !== -1;
          }, $e.prototype.isSeekTargetVerificationNeeded = function() {
            return this.seekVerificationOnNextSegment && this.playbackTimeNextSegment === -1;
          }, $e.prototype.trackPlaybackTime = function(ye) {
            var Se, we = (Se = ye.getSegmentInfo()) === null || Se === void 0 ? void 0 : Se.duration, Pe = ye.getDuration();
            this.playbackTimeNextSegment = ye.getPlaybackTime() + Math.max(Pe, we ?? Pe);
          }, $e.prototype.checkForTimelineGap = function(ye, Se, we) {
            var Pe;
            if (this.playbackTimeNextSegment >= 0)
              return this.gapVerificationOnNextSegment = !1, this.checkGapForConsecutiveSegments(ye, Se, we);
            var Te = !((Pe = this.playerStateService) === null || Pe === void 0) && Pe.seekingOrTimeshifting ? this.playerStateService.targetPlaybackTime : -1;
            return this.seekVerificationOnNextSegment && Te > -1 ? (this.seekVerificationOnNextSegment = !1, this.checkSeekAccuracy(Te, ye, Se, we)) : { hasGap: !1 };
          }, $e.prototype.checkGapForConsecutiveSegments = function(ye, Se, we) {
            var Pe = he(ye, this.allowedGapSizeSec);
            if (ge(this.playbackTimeNextSegment, Pe - this.allowedGapSizeSec, Pe + ye.getDuration()))
              return { hasGap: !1 };
            var Te = { hasGap: !1 }, Ee = ye.getPlaybackTime() - this.playbackTimeNextSegment, Me = Se.SegmentList ? Se.SegmentList[0].SegmentURL : [], Ae = (0, le.findSegmentUrlIndexWithinSegmentList)(ye.getSegmentInfo(), Me), Ne = Ae >= 0 ? Ae : we, Ce = Ne;
            if (Ee > 0)
              (Ie = me(Ce = be(Ee, Me, Ne))) || (this.context.logger.debug("Could not handle gap on playlist switch, reached lower boundary of segment list"), Ce = 0), Te = ve(!0, Ee, Ie, Ce);
            else if (Ee < 0) {
              var Ie;
              (Ie = me(Ce = pe(Ee, Me, Ne))) || (this.context.logger.debug("Could not handle gap on playlist switch, reached upper boundary of segment list"), Ce = Me.length), Te = ve(!0, Ee, Ie, Ce);
            }
            return Ce === Ne && Te.hasGap && (this.context.logger.debug("Ignoring gap as calculated new segment index did not change"), Te.hasGap = !1), Te;
          }, $e.prototype.checkSeekAccuracy = function(ye, Se, we, Pe) {
            var Te = we.SegmentList ? we.SegmentList[0].SegmentURL : [], Ee = Se.getPlaybackTime(), Me = Se.getPlaybackTime() + Se.getDuration();
            this.context.logger.debug("HLS seek target verification", { seekTarget: ye, segmentStartTime: Ee, segmentEndTime: Me });
            var Ae, Ne, Ce, Ie = (0, le.findSegmentUrlIndexWithinSegmentList)(Se.getSegmentInfo(), Te);
            return Ie = Ie >= 0 ? Ie : Pe, ye < Ee ? ((Ce = me(Ae = be(Ne = Ee - ye, Te, Ie))) || (Ae = 0), this.context.logger.debug("Target segment starts too late, corrected segment index from ".concat(Ie, " to ").concat(Ae)), ve(!0, Ne, Ce, Ae)) : ye > Me ? ((Ce = me(Ae = pe(Ne = Me - ye, Te, Ie))) || (Ae = Te.length), this.context.logger.debug("Target segment ends too early, corrected segment index from ".concat(Ie, " to ").concat(Ae)), ve(!0, Ne, Ce, Ae)) : { hasGap: !1 };
          }, $e.prototype.dispose = function() {
            var ye;
            (ye = this.unsubscribeFromContentLocationId) === null || ye === void 0 || ye.call(this), this.unsubscribeFromTargetPlaybackTimeChange(), this.gapVerificationOnNextSegment = !1, this.seekVerificationOnNextSegment = !1, this.playbackTimeNextSegment = -1;
          }, $e;
        }();
        function he($e, ye) {
          var Se, we = (Se = $e.getSegmentInfo()) === null || Se === void 0 ? void 0 : Se.startTime, Pe = $e.getPlaybackTime();
          return we === void 0 || Math.abs(Pe - we) > $e.getDuration() + ye ? Pe : Math.min(Pe, we);
        }
        function ge($e, ye, Se) {
          return $e >= ye && $e <= Se;
        }
        function ve($e, ye, Se, we) {
          return { hasGap: $e, gapSizeSec: ye, couldHandle: Se, correctedIndex: we };
        }
        function me($e) {
          return $e >= 0 && isFinite($e);
        }
        function be($e, ye, Se) {
          for (; $e > oe; ) {
            if (Se <= 0)
              return -1;
            $e -= ye[Se - 1]._duration, Se--;
          }
          return Se;
        }
        function pe($e, ye, Se) {
          for (; $e < -oe; )
            if ($e += ye[Se]._duration, ++Se >= ye.length)
              return 1 / 0;
          return Se;
        }
        ie.HlsTimelineTracker = ce;
      }, 73725: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ce) {
            for (var Ie, xe = 1, Ue = arguments.length; xe < Ue; xe++)
              for (var ke in Ie = arguments[xe])
                Object.prototype.hasOwnProperty.call(Ie, ke) && (Ce[ke] = Ie[ke]);
            return Ce;
          }, ae.apply(this, arguments);
        }, ue = this && this.__spreadArray || function(Ce, Ie, xe) {
          if (xe || arguments.length === 2)
            for (var Ue, ke = 0, Le = Ie.length; ke < Le; ke++)
              !Ue && ke in Ie || (Ue || (Ue = Array.prototype.slice.call(Ie, 0, ke)), Ue[ke] = Ie[ke]);
          return Ce.concat(Ue || Array.prototype.slice.call(Ie));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.M3u8DashManifest = void 0;
        var _e = ne(60997), fe = ne(63331), le = ne(42055), se = ne(81361), oe = ne(3941), ce = ne(331), he = ne(76885), ge = ne(54838), ve = ne(38353), me = ne(41735), be = ne(77874), pe = ne(31043), $e = ne(18665), ye = ne(79814), Se = ne(97662), we = ne(52729), Pe = ne(49422), Te = ne(53950), Ee = ne(52080), Me = ne(79367), Ae = ne(34435), Ne = function() {
          function Ce(Ie, xe) {
            this.lastStartOffset = -1 / 0, this.context = Ie, this.sourceContext = xe, this.m3u8Translator = new Pe.M3u8Translator(Ie, xe), this.totalDurationSec = 1 / 0, this.sourceStore = Ie.serviceManager.get($e.ServiceName.SourceStoreService, xe.sourceIdentifier);
          }
          return Ce.prototype.updateBaseUrl = function(Ie) {
            this.m3u8Translator.updateBaseUrl(Ie);
          }, Ce.prototype.getBaseUrl = function() {
            return this.m3u8Translator.getBaseUrl();
          }, Ce.prototype.getCurrentHlsState = function() {
            return (0, Ae.getHlsState)(this.sourceStore.getState());
          }, Ce.prototype.findAdaptationSet = function(Ie) {
            return this.getManifest().Period[0].AdaptationSet.find(function(xe) {
              var Ue;
              return xe._internalId.adaptationSetId === Ie || ((Ue = xe.ContentComponent) === null || Ue === void 0 ? void 0 : Ue.some(function(ke) {
                return ke._id === Ie;
              }));
            });
          }, Ce.prototype.createDashManifestSkeleton = function(Ie) {
            var xe = this.m3u8Translator.createDashManifestSkeleton(Ie);
            return (0, ve.initializeInternalIds)(xe);
          }, Ce.prototype.extractBackupStreams = function(Ie) {
            return this.m3u8Translator.extractBackupStreams(Ie);
          }, Ce.prototype.onMasterPlaylistAvailable = function(Ie) {
            var xe = this.createDashManifestSkeleton(Ie);
            this.sourceStore.dispatch((0, me.setManifestAction)(xe)), this.sourceStore.dispatch((0, Me.setDefaultLanguages)(Ie)), this.sourceStore.dispatch((0, Me.setCustomTags)(Ie)), this.sourceStore.dispatch((0, Me.setMasterPlaylistString)(Ie.rawString));
          }, Ce.prototype.getManifest = function() {
            return (0, be.getManifest)(this.sourceStore.getState());
          }, Ce.prototype.getAllVariantRepresentions = function() {
            var Ie = function(xe) {
              return ye.MimeTypeHelper.isAV(xe._mimeType) || ye.MimeTypeHelper.isSubtitle(xe._mimeType) || ye.MimeTypeHelper.isImage(xe._mimeType);
            };
            return this.getManifest().Period[0].AdaptationSet.filter(Ie).flatMap(function(xe) {
              return xe.Representation;
            });
          }, Ce.prototype.onMediaLoaded = function(Ie, xe, Ue) {
            var ke = this;
            this.sourceStore.dispatch((0, Me.setMasterPlaylistString)(Ie)), this.sourceStore.dispatch((0, Me.setEndlist)(!!Ue.endList)), Ue.playlistType && !(0, Ae.getPlaylistType)(this.getCurrentHlsState()) && this.sourceStore.dispatch((0, Me.setPlaylistType)(Ue.playlistType)), (0, Ae.getIsLowLatencyPlaylist)(this.getCurrentHlsState()) === void 0 && this.sourceStore.dispatch((0, Me.setIsLowLatencyPlaylist)(Ue.partInfo !== void 0)), this.calculatePlaylistStartTime(Ue);
            var Le = this.getManifest().Period[0], De = this.getRepresentationsFromUrl(xe.Uri, Le).map(function(Re) {
              return ke.updateRepresentation(Re, Ue);
            });
            return ye.MimeTypeHelper.isAV(xe._mimeType) && (this.trackPlaylistTiming(Ue, De), this.updateDashManifestProperties(Ue)), De.forEach(function(Re) {
              var Oe = ke.determineFirstDiscoStartTime(Re, Ue);
              ke.updatePeriodStartAndDuration(Le, Oe, !Ue.endList), ke.context.settings.ENABLE_SEGMENT_INFO_PROVIDER_FROM_STORE && ke.updateSegmentInfoMap(Ue, Re);
            }), this.context.serviceManager.maybeCall($e.ServiceName.TimedMetadataService, function(Re) {
              return (0, fe.extractDateRangeMetadata)(Ue.segments, function(Oe) {
                Re.processDateRangeEvent(Oe, oe.DEFAULT_PERIOD_ID);
              });
            }), De.find(function(Re) {
              return Re._id === xe._id;
            });
          }, Ce.prototype.updateSegmentInfoMap = function(Ie, xe) {
            var Ue, ke, Le = xe._internalId.key(), De = (Ue = this.sourceStore.getState()) === null || Ue === void 0 ? void 0 : Ue.segmentInfoMap[Le];
            De && (ke = (0, we.updateMapEntry)(De, Ie, xe)) || (ke = (0, we.createNewMapEntry)(Ie, xe), this.initializeStartTimesOnSegmentMapEntry(ke, Ie)), this.sourceStore.dispatch((0, pe.setSegmentInfos)(Le, ke));
          }, Ce.prototype.initializeStartTimesOnSegmentMapEntry = function(Ie, xe) {
            var Ue = this.sourceStore.getState();
            if (Ue) {
              var ke = (0, Ee.getStartTimeExtrapolationReferencePoint)(Ie, xe, Ue);
              (0, Ee.extrapolateStartTime)(Ie.segmentInfos, ke);
            }
          }, Ce.prototype.determineFirstDiscoStartTime = function(Ie, xe) {
            var Ue, ke, Le, De = (Le = (ke = (Ue = Ie.SegmentList) === null || Ue === void 0 ? void 0 : Ue[0]) === null || ke === void 0 ? void 0 : ke.SegmentURL) !== null && Le !== void 0 ? Le : [];
            return De.length > 0 && De[0]._playbackTime != null ? (0, Ae.getFirstDiscoSequenceTiming)(this.getCurrentHlsState()).startTime : xe.startTime;
          }, Ce.prototype.updatePeriodStartAndDuration = function(Ie, xe, Ue) {
            var ke = Ie.duration === 0 ? this.totalDurationSec : Math.min(Ie.duration, this.totalDurationSec), Le = Ue ? 1 / 0 : ke, De = { start: xe, _start: "PT".concat(xe, "S"), duration: Le, _duration: "PT".concat(ke, "S") };
            this.sourceStore.dispatch((0, me.updatePeriodTimingAction)(oe.DEFAULT_PERIOD_ID, De));
          }, Ce.prototype.trackPlaylistTiming = function(Ie, xe) {
            var Ue, ke, Le, De, Re, Oe = Ie.totalDuration, Be = (Ue = xe.find(function(Ze) {
              return Ze.Uri === Ie.uri;
            })) !== null && Ue !== void 0 ? Ue : xe[0], Fe = (Le = (ke = Be == null ? void 0 : Be.SegmentList) === null || ke === void 0 ? void 0 : ke[0]) === null || Le === void 0 ? void 0 : Le.SegmentURL, Ve = ((De = Fe == null ? void 0 : Fe.length) !== null && De !== void 0 ? De : 0) > 0 && ((Re = Fe == null ? void 0 : Fe[0]) === null || Re === void 0 ? void 0 : Re._playbackTime) !== void 0;
            if (Fe && Ve) {
              var Ke = (0, Se.getTimingInfoFromSegmentList)(Fe);
              Oe = Ke.totalDuration, this.sourceStore.dispatch((0, Me.setDiscoTimings)(Be._mimeType, Ke.discoTimings));
            }
            this.totalDurationSec = Ie.endList ? Math.min(this.totalDurationSec, Oe) : Oe;
          }, Ce.prototype.updateDashManifestProperties = function(Ie) {
            var xe, Ue = !Ie.endList, ke = (0, be.getManifest)(this.sourceStore.getState()), Le = { _requestTimestamp: Ie.requestTimestamp, _type: Ue ? "dynamic" : "static", _mediaPresentationDuration: Ue ? 1 / 0 : "PT".concat(this.totalDurationSec, "S"), _maxSegmentDuration: "PT".concat(Ie.targetDuration, "S"), _hasIndependentSegments: ke._hasIndependentSegments || Ie.independentSegments };
            Ie.start && (Ie.start.timeOffset = Te.PlaylistUtils.getStartOffsetCloseToPlaylistEnd(Ie, this.lastStartOffset), this.lastStartOffset = Ie.start.timeOffset, Le._startOffset = Te.PlaylistUtils.getStartOffset(Ie)), Ue && (Le._minimumUpdatePeriod = "PT".concat(Ie.targetDuration, "S"), Le._timeShiftBufferDepth = -this.totalDurationSec, Le._availabilityStartTime = (xe = ke._availabilityStartTime) !== null && xe !== void 0 ? xe : new Date(Ie.requestTimestamp - (0, ce.toMilliSeconds)(this.totalDurationSec)).toISOString()), this.sourceStore.dispatch((0, me.updateManifestAction)(Le));
          }, Ce.prototype.getRepresentationsFromUrl = function(Ie, xe) {
            return xe.AdaptationSet.flatMap(function(Ue) {
              return Ue.Representation.filter(function(ke) {
                return he.URLHelper.isSubUrl(Ie, ke.Uri);
              });
            });
          }, Ce.prototype.updateRepresentation = function(Ie, xe) {
            var Ue = ae({}, Ie);
            return Ue._requestTimestamp = xe.requestTimestamp, Ue._updateInterval = (0, Te.calculateUpdateIntervalInSeconds)(this.context, xe), Ue._hls = ae(ae({}, Ue._hls), { requestTimestamp: xe.requestTimestamp, mediaSequence: xe.mediaSequence, serverControl: xe.serverControl, loadFailureReason: null }), xe.partInfo && (Ue._hls.partTargetDuration = xe.partInfo.targetDuration), Ue.SegmentList = [ae({}, Ue.SegmentList[0])], Ue.SegmentList[0].SegmentURL = ue([], Ue.SegmentList[0].SegmentURL, !0), this.updateSegmentList(Ue, xe), this.sourceStore.dispatch((0, me.updateRepresentationAction)(Ue)), Ue;
          }, Ce.prototype.updateSegmentList = function(Ie, xe) {
            var Ue;
            if (xe.segments.length !== 0) {
              if (Ie.SegmentList) {
                this.context.logger.debug("Updating segment list for playlist ".concat(Ie._id));
                var ke = this.getTranslatedSegmentList(Ie, xe);
                if (ke.contentProtectionInfos.length > 0) {
                  var Le = Ce.contentProtectionToXmlJson(ke.contentProtectionInfos);
                  if ((0, Te.isDeltaPlaylist)(xe)) {
                    var De = (Ue = Ie.ContentProtection) !== null && Ue !== void 0 ? Ue : [];
                    Ie.ContentProtection = (0, ge.removeDuplicates)(ue(ue([], De, !0), Le, !0));
                  } else
                    Ie.ContentProtection = Le;
                }
                var Re = Ie.SegmentList[0].SegmentURL, Oe = ke.entries, Be = (0, Te.calcNumberOfSegmentsToDrop)(Re, Oe, xe.skippedSegmentsCount);
                (0, se.removeEntriesFromStart)(Re, Be), (0, Te.addNewSegments)(Re, Oe), Ie.SegmentList[0]._duration = xe.targetDuration, Ie.SegmentList[0]._timescale = 1;
              }
            } else
              this.context.logger.debug("No segments for representation ".concat(Ie._id, " in loaded playlist"));
          }, Ce.prototype.getTranslatedSegmentList = function(Ie, xe) {
            if (xe.endList) {
              var Ue = this.context.serviceManager.maybeCall($e.ServiceName.ManifestCachingService, function(ke) {
                return ke.getSegmentList(Ie.Uri);
              }, null, this.sourceContext.sourceIdentifier);
              return Ue || (Ue = this.m3u8Translator.translateSegmentList(Ie, xe), this.context.serviceManager.maybeCall($e.ServiceName.ManifestCachingService, function(ke) {
                return ke.cacheSegmentList(Ue, Ie.Uri);
              }, null, this.sourceContext.sourceIdentifier)), Ue;
            }
            return this.m3u8Translator.translateSegmentList(Ie, xe);
          }, Ce.prototype.calculatePlaylistStartTime = function(Ie) {
            var xe = Ie.segments[0];
            Ie.endList ? (Ie.startTime = (0, le.getStartTimeOffset)(this.sourceStore.getState()), Ie.segments[0].startTime = Ie.startTime) : xe && xe.dateTime ? (Ie.startTime = (0, ce.toSeconds)(xe.dateTime.getTime()), Ie.segments[0].startTime = Ie.startTime) : Ie.startTime = (0, ce.toSeconds)(Ie.requestTimestamp) - Ie.totalDuration;
          }, Ce.contentProtectionToXmlJson = function(Ie) {
            return Ie.map(function(xe) {
              var Ue = { _schemeIdUri: xe.schemeIdUri };
              return xe.defaultKid && (Ue["_cenc:default_KID"] = xe.defaultKid), xe.pssh && (Ue.pssh = [{ __text: xe.pssh }]), Ue;
            });
          }, Ce.prototype.dispose = function() {
            this.m3u8Translator = (0, _e.dispose)(this.m3u8Translator);
          }, Ce;
        }();
        ie.M3u8DashManifest = Ne;
      }, 22675: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(De) {
            for (var Re, Oe = 1, Be = arguments.length; Oe < Be; Oe++)
              for (var Fe in Re = arguments[Oe])
                Object.prototype.hasOwnProperty.call(Re, Fe) && (De[Fe] = Re[Fe]);
            return De;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.M3u8Loader = ie.HlsQueryParamNames = void 0, ie.getParsedManifest = ke;
        var ue, _e = ne(25550), fe = ne(28764), le = ne(18665), se = ne(60997), oe = ne(62510), ce = ne(88005), he = ne(90637), ge = ne(36564), ve = ne(67345), me = ne(57782), be = ne(76650), pe = ne(8272), $e = ne(79814), ye = ne(331), Se = ne(76885), we = ne(99162), Pe = ne(13034), Te = ne(4053), Ee = ne(41735), Me = ne(93109), Ae = ne(64697), Ne = ne(293), Ce = ne(13254), Ie = ne(73725), xe = ne(32352), Ue = ne(53950);
        function ke(De, Re, Oe) {
          var Be = Oe.url, Fe = Oe.manifestText, Ve = De.serviceManager.maybeCall(le.ServiceName.ManifestCachingService, function(Ke) {
            return Ke.getParsedManifest(Be);
          }, null, Re.sourceIdentifier);
          return Ve ? Promise.resolve(Ve) : (0, Ce.parseHlsManifest)(De, Fe);
        }
        (function(De) {
          De.MediaSequenceNumber = "_HLS_msn", De.PartIndex = "_HLS_part", De.Skip = "_HLS_skip";
        })(ue || (ie.HlsQueryParamNames = ue = {}));
        var Le = function() {
          function De(Re, Oe) {
            var Be = this;
            this.variantUpdateLoaders = {}, this.updateRepresentation = function(Fe) {
              var Ve = Be.applyServerControlQueryParams(Fe, Fe.Uri);
              Be.context.logger.debug("M3u8Loader: updateRepresentation (".concat(Ve, ")"));
              var Ke = Be.variantUpdateLoaders[Fe._id];
              return Be.loadPlaylist(Ke, Ve).then(function(Ze) {
                return Be.onMediaLoaded(Ze, Fe);
              }).catch(function(Ze) {
                return Be.handleRepresentationUpdateFailure(Ze, Fe);
              });
            }, this.context = Re, this.sourceContext = Oe, this.registeredOnPlayEventHandlers = [], this.registeredOnPausedEventHandlers = [], this.discontinuitySequences = [], this.isCancelled = !1, this.translatedManifest = new Ie.M3u8DashManifest(Re, Oe), this.masterPlaylistLoader = this.createLoader(ve.HttpRequestType.MANIFEST_HLS_MASTER), this.sourceStore = Re.serviceManager.get(le.ServiceName.SourceStoreService, Oe.sourceIdentifier);
          }
          return De.prototype.load = function(Re) {
            var Oe = this;
            return this.isCancelled = !1, this.loadPlaylist(this.masterPlaylistLoader, Re).then(function(Be) {
              return Oe.parseMasterPlaylist(Be);
            }).then(function(Be) {
              return Oe.translatedManifest.updateBaseUrl(Be.url), Oe.initializeBackupStreamsHandler(Be), Oe.executeCodecVerification(Be);
            }).then(function(Be) {
              return Oe.handleMasterPlaylist(Be), Oe.loadFirstVariants();
            }).then(function() {
              return Oe.translatedManifest.getManifest();
            }).catch(function(Be) {
              var Fe = Be instanceof Error ? Be.message : void 0;
              return Oe.isCancelled || Fe === he.RequestError.Canceled ? Promise.reject() : Be instanceof fe.PlayerError || Be instanceof Error ? Promise.reject(Be) : Promise.reject(Oe.getErrorFromResponse(Be));
            }).finally(function() {
              var Be;
              return (Be = Oe.backupStreamsHandler) === null || Be === void 0 ? void 0 : Be.signalLoadingFinished();
            });
          }, De.prototype.parseMasterPlaylist = function(Re) {
            var Oe = this;
            if (this.isCancelled)
              return Promise.reject(new Error("The loading of the HLS source was cancelled."));
            var Be = Re.body;
            if (Be === void 0)
              return Promise.reject(new Error("Cannot parse the playlist: content is empty."));
            var Fe = { manifestText: Be, url: Re.url };
            return ke(this.context, this.sourceContext, Fe).then(function(Ve) {
              return (0, Ce.isValidHlsPlaylist)(Ve) ? (Oe.maybeCacheManifest(Re, Ve), (0, Ce.ensureMasterPlaylist)(Oe.context, Ve, Re.url)) : Promise.reject(new Error("Cannot parse master playlist: invalid format."));
            }).then(function(Ve) {
              return ae(ae({}, Ve), { rawString: Be, url: Re.url });
            }).catch(function(Ve) {
              return Promise.reject(new fe.PlayerError(_e.ErrorCode.SOURCE_MANIFEST_INVALID, { errorMessage: Ve.message }, "HLS manifest is not a valid M3U playlist"));
            });
          }, De.prototype.initializeBackupStreamsHandler = function(Re) {
            var Oe = this.translatedManifest.extractBackupStreams(Re);
            Oe.every(function(Be) {
              return Object.keys(Be).length <= 1;
            }) || (this.backupStreamsHandler = new Ne.HlsBackupStreamsHandler(this.context, Oe, this.updateRepresentation));
          }, De.prototype.loadFirstVariants = function() {
            var Re = this.sourceStore.getState(), Oe = this.translatedManifest.getManifest().Period[0], Be = (0, Pe.findAdaptationSetOfMimeType)($e.MimeType.VideoMp4, Oe, { sourceState: Re }), Fe = (0, Pe.findAdaptationSetOfMimeType)($e.MimeType.AudioMp4, Oe, { sourceState: Re, playbackConfig: this.context.config.playback }), Ve = [];
            return Be && Ve.push(this.loadFirstPlaylist(Be)), Fe && Ve.push(this.loadFirstPlaylist(Fe)), Promise.all(Ve).catch(function(Ke) {
              return Promise.reject(Ke instanceof fe.PlayerError ? Ke : new fe.PlayerError(_e.ErrorCode.SOURCE_HLS_STREAM_ERROR, { error: Ke }, "There was an error while retrieving the variant playlists."));
            });
          }, De.prototype.loadFirstPlaylist = function(Re) {
            var Oe = this, Be = this.getStartRepresentation(Re.Representation, Re._mimeType, Re);
            if (!Be) {
              var Fe = "No ".concat(Re._mimeType, " variants/renditions available");
              return this.context.logger.log(Fe), Promise.reject(new fe.PlayerError(_e.ErrorCode.SOURCE_MANIFEST_INVALID, { reason: Fe }, Fe));
            }
            return this.updateRepresentation(Be).then(function(Ve) {
              return Oe.sourceStore.dispatch((0, me.setPreferredBitrateForMimeTypeAction)(Be._mimeType, Be._bandwidth)), Oe.sourceStore.dispatch((0, Te.setRepresentationIdAction)(Be._internalId)), Ve;
            }).catch(function(Ve) {
              var Ke, Ze;
              return Oe.context.logger.debug("Representation ".concat(Be._id, " failed, dropping it"), (Ke = Ve == null ? void 0 : Ve.message) !== null && Ke !== void 0 ? Ke : Ve), Re.Representation = Re.Representation.filter(function(nt) {
                return nt !== Be;
              }), Re.Representation.length > 0 ? Oe.loadFirstPlaylist(Re) : (Oe.context.logger.log("All ".concat(Re._mimeType, " variants/renditions failed"), (Ze = Ve == null ? void 0 : Ve.message) !== null && Ze !== void 0 ? Ze : Ve), Promise.reject(Ve));
            });
          }, De.prototype.getStartRepresentation = function(Re, Oe, Be) {
            return this.context.serviceManager.maybeCall(le.ServiceName.AdaptationService, function(Fe) {
              Fe.setAdaptationSetId(Be._mimeType, Be._internalId);
              var Ve = Fe.selectRepresentation(Oe, {}, Re);
              return Re.find(function(Ke) {
                return Ke._internalId.equals(Ve);
              });
            });
          }, De.prototype.updateAdaptationSet = function(Re) {
            var Oe = this, Be = this.translatedManifest.findAdaptationSet(Re);
            return Be ? Promise.all(Be.Representation.map(function(Fe) {
              var Ve = Oe.createLoader(ve.HttpRequestType.MANIFEST_HLS_VARIANT);
              return Oe.loadPlaylist(Ve, Fe.Uri).then(function(Ke) {
                return Oe.onMediaLoaded(Ke, Fe);
              }).then(function(Ke) {
                Oe.sourceStore.dispatch((0, Ee.updateRepresentationAction)(Ke));
              });
            })) : Promise.reject("Could not find data");
          }, De.prototype.maybeCacheManifest = function(Re, Oe) {
            this.context.serviceManager.maybeCall(le.ServiceName.ManifestCachingService, function(Be) {
              Be.cacheHttpResponse(Re, Re.url), Be.cacheParsedManifest(Oe, Re.url);
            }, null, this.sourceContext.sourceIdentifier);
          }, De.prototype.executeCodecVerification = function(Re) {
            var Oe = this, Be = (0, Ce.getTracksWithUnknownCodecs)(Re), Fe = Be.audioTracksWithoutCodecs, Ve = Be.videoTracksWithoutCodecs;
            return Fe.length === 0 && Ve.length === 0 ? Promise.resolve(Re) : (this.context.logger.debug("Codecs are missing in master playlist - probing them from segments now"), this.probeMissingAudioCodecs(Re, Fe).then(function() {
              return Oe.probeMissingVideoCodecs(Re, Ve);
            }).then(function() {
              return Re;
            }).catch(function(Ke) {
              var Ze;
              if (Ke instanceof fe.PlayerError)
                return Promise.reject(Ke);
              var nt = "Codec verification failed", Qe = (Ze = Ke == null ? void 0 : Ke.message) !== null && Ze !== void 0 ? Ze : Ke;
              return Oe.context.logger.debug(nt, Ke), Promise.reject(new fe.PlayerError(_e.ErrorCode.SOURCE_MANIFEST_INVALID, { reason: Qe }, nt));
            }));
          }, De.prototype.parseMissingCodecsFromPlaylistResponse = function(Re, Oe) {
            var Be = this, Fe = Re.url, Ve = Re.body;
            if (Ve === void 0)
              return Promise.reject("Cannot parse codec, empty manifest response");
            var Ke = { url: Oe, manifestText: Ve };
            return ke(this.context, this.sourceContext, Ke).then(function(Ze) {
              var nt = (0, Ue.calculateUpdateIntervalInSeconds)(Be.context, Ze), Qe = Date.now() + (0, ye.toMilliSeconds)(nt);
              Be.context.serviceManager.maybeCall(le.ServiceName.ManifestCachingService, function(ut) {
                ut.cacheHttpResponse(Re, Fe, Qe), ut.cacheParsedManifest(Ze, Fe, Qe);
              }, null, Be.sourceContext.sourceIdentifier);
              var qe = Ze.segments, ze = !Ze.endList, je = Ze.mediaSequence, tt = Ue.PlaylistUtils.getBaseUrl(Be.translatedManifest.getBaseUrl(), Oe);
              return new Ae.CodecDetector(Be.context).probeCodecs(qe, ze, tt, je);
            });
          }, De.prototype.getVideoVariantForCodecDetection = function(Re) {
            var Oe = Re.map(function(Be, Fe) {
              return { bitrate: Be.attributes.BANDWIDTH, id: Fe };
            });
            return this.context.serviceManager.maybeCall(le.ServiceName.AdaptationService, function(Be) {
              var Fe = Be.selectQualityBasedOnBitrateMeasurement(Oe);
              return Re[Fe.id];
            });
          }, De.prototype.probeMissingCodecs = function(Re, Oe) {
            var Be = this, Fe = new ce.DefaultContentLoader(this.context, { requestType: ve.HttpRequestType.MANIFEST_HLS_VARIANT });
            return this.loadPlaylistForCodecProbing(Fe, Re).then(function(Ve) {
              return Be.parseMissingCodecsFromPlaylistResponse(Ve, Re);
            }).then(function(Ve) {
              return (0, Ce.updateMissingCodecsForPlaylists)(Ve, Oe, Re);
            });
          }, De.prototype.loadPlaylistForCodecProbing = function(Re, Oe) {
            var Be = this;
            return this.loadPlaylist(Re, Oe).catch(function(Fe) {
              var Ve;
              Be.context.logger.debug("Representation failed to load during codec probing ".concat(Oe));
              var Ke = (Ve = Be.backupStreamsHandler) === null || Ve === void 0 ? void 0 : Ve.getNextBackupUriForCodecProbing(Oe);
              return Ke ? (Be.context.logger.debug("Attempting to continue codec probing using backup stream ".concat(Ke)), Be.loadPlaylistForCodecProbing(Re, Ke)) : Promise.reject(Fe);
            });
          }, De.prototype.probeMissingAudioCodecs = function(Re, Oe) {
            var Be = this, Fe = Oe.shift();
            if (!(Fe != null && Fe.attributes.URI))
              return Promise.resolve();
            var Ve = Se.URLHelper.getAbsoluteUrl(Fe.attributes.URI, this.translatedManifest.getBaseUrl());
            return this.probeMissingCodecs(Ve, Re).then(function() {
              return Be.probeMissingAudioCodecs(Re, Oe);
            });
          }, De.prototype.probeMissingVideoCodecs = function(Re, Oe) {
            if (Oe.length === 0)
              return Promise.resolve();
            var Be = this.getVideoVariantForCodecDetection(Oe), Fe = Se.URLHelper.getAbsoluteUrl(Be.uri, this.translatedManifest.getBaseUrl());
            return this.probeMissingCodecs(Fe, Re);
          }, De.prototype.handleMasterPlaylist = function(Re) {
            var Oe, Be = this;
            this.masterPlaylist === void 0 && (this.masterPlaylist = Re), this.translatedManifest.onMasterPlaylistAvailable(Re);
            var Fe = this.translatedManifest.getAllVariantRepresentions();
            Fe.forEach(function(Ve) {
              Be.variantUpdateLoaders[Ve._id] = Be.createLoader(ve.HttpRequestType.MANIFEST_HLS_VARIANT);
            }), (Oe = this.backupStreamsHandler) === null || Oe === void 0 || Oe.populateBackupStreamsMap(Fe);
          }, De.prototype.onMediaLoaded = function(Re, Oe) {
            var Be = this;
            if (this.isCancelled)
              return Promise.reject(we.REPRESENTATION_UPDATE_CANCEL);
            var Fe = Re.url, Ve = Re.body;
            if (!Ve)
              return Promise.reject(new fe.PlayerError(_e.ErrorCode.SOURCE_MANIFEST_INVALID, void 0, "Cannot parse the playlist: the body of the response is empty."));
            var Ke = Date.now(), Ze = { url: Fe, manifestText: Ve };
            return ke(this.context, this.sourceContext, Ze).then(function(nt) {
              var Qe;
              nt.uri = (0, Se.removeQueryParameters)(Fe, Object.values(ue)), nt.requestTimestamp = Ke;
              var qe = xe.M3u8Validator.checkForError(nt);
              if (qe)
                return Promise.reject(new fe.PlayerError(_e.ErrorCode.SOURCE_MANIFEST_INVALID, { M3u8ValidatorError: qe }, "The parsed media playlist is invalid: ".concat(qe)));
              nt.start = (Qe = nt.start) !== null && Qe !== void 0 ? Qe : Be.masterPlaylist.start, Be.discontinuitySequences = (0, Ce.createDiscontinuitySequences)(nt, Be.discontinuitySequences);
              var ze = Be.filterTooSmallPeriods(Be.discontinuitySequences, !!nt.endList);
              nt.segments = ze.flatMap(function(ut) {
                return ut.segments;
              });
              var je = Be.translatedManifest.onMediaLoaded(Ve, Oe, nt);
              nt.endList && Be.context.serviceManager.maybeCall(le.ServiceName.ManifestCachingService, function(ut) {
                ut.cacheHttpResponse(Re, Fe), ut.cacheParsedManifest(nt, Fe);
              }, null, Be.sourceContext.sourceIdentifier);
              var tt = (0, ye.toSeconds)(Date.now() - Ke);
              return Be.context.store.dispatch((0, be.addMetricsValue)("default", pe.MetricType.ProcessingTime, tt)), Be.context.logger.insane("Parsed playlist in: ".concat(tt == null ? void 0 : tt.toFixed(2))), je;
            }).catch(function(nt) {
              if (nt instanceof fe.PlayerError)
                return Promise.reject(nt);
              var Qe = "Failed to parse the media playlist", qe = nt instanceof Error ? nt.message : Qe;
              return Promise.reject(new fe.PlayerError(_e.ErrorCode.SOURCE_MANIFEST_INVALID, { errorMessage: qe }, Qe));
            });
          }, De.prototype.filterTooSmallPeriods = function(Re, Oe) {
            return Re.filter(function(Be, Fe) {
              var Ve = !Oe && Fe === Re.length - 1, Ke = Be.segments.reduce(function(Ze, nt) {
                return Ze + nt.duration;
              }, 0);
              return !!(Fe === 0 && Ke > 0 || Ve) || Ke > 0;
            });
          }, De.prototype.stop = function() {
            var Re = this;
            this.registeredOnPlayEventHandlers.forEach(function(Oe) {
              return Re.context.eventHandler.off(oe.PlayerEvent.Play, Oe);
            }), this.registeredOnPausedEventHandlers.forEach(function(Oe) {
              return Re.context.eventHandler.off(oe.PlayerEvent.Paused, Oe);
            }), this.registeredOnPlayEventHandlers = [], this.registeredOnPausedEventHandlers = [], this.stopLoaders(), this.isCancelled = !0;
          }, De.prototype.stopLoaders = function() {
            var Re = this;
            this.masterPlaylistLoader.cancel(), Object.keys(this.variantUpdateLoaders).forEach(function(Oe) {
              Re.variantUpdateLoaders[Oe].dispose(), delete Re.variantUpdateLoaders[Oe];
            });
          }, De.prototype.stopRepresentationUpdate = function(Re) {
            var Oe, Be = this.variantUpdateLoaders[Re._id];
            return Be != null && Be.isLoading() ? (this.context.logger.debug("M3u8Loader: stopping ongoing representation update (".concat(Re.Uri, ")")), Be.cancel(), ((Oe = Be.getResponse()) !== null && Oe !== void 0 ? Oe : Promise.resolve()).catch(function() {
            }).then(function() {
            })) : Promise.resolve();
          }, De.prototype.applyServerControlQueryParams = function(Re, Oe) {
            var Be, Fe = {}, Ve = (0, Ue.getLastMediaSequenceAndPartIndex)(Re);
            return (0, Me.isPlayingLowLatencyHls)(this.context) && (0, Ue.canMakeBlockingPlaylistReload)(Re, this.context.settings) && Ve && (Fe[ue.MediaSequenceNumber] = String(Ve.mediaSequence), Fe[ue.PartIndex] = String(Ve.partIndex + 1)), !((Be = this.context.config.live) === null || Be === void 0) && Be.incrementalManifestUpdates && (0, Ue.canPerformDeltaUpdate)(Re) && (Fe[ue.Skip] = "YES"), Se.URLHelper.appendQueryParametersToUrl(Oe, Fe);
          }, De.prototype.handleRepresentationUpdateFailure = function(Re, Oe) {
            var Be;
            return this.isCancelled || (Re == null ? void 0 : Re.message) === he.RequestError.Canceled ? Promise.reject(we.REPRESENTATION_UPDATE_CANCEL) : (this.context.logger.debug("M3u8Loader: updateRepresentation failed (".concat(Oe.Uri, ")"), (Be = Re == null ? void 0 : Re.message) !== null && Be !== void 0 ? Be : Re), this.switchToBackupStream(Oe).then(function(Fe) {
              var Ve = Fe[0];
              return Ve || Promise.reject(he.RequestError.Failed);
            }).catch(function(Fe) {
              return Object.values(Ne.BackupStreamErrors).includes(Fe) && Re instanceof fe.PlayerError ? Promise.reject(Re) : Promise.reject(Fe === we.REPRESENTATION_UPDATE_CANCEL ? Fe : he.RequestError.Failed);
            }));
          }, De.prototype.switchToBackupStream = function(Re, Oe) {
            return this.backupStreamsHandler ? this.backupStreamsHandler.switchToBackupStream(Re, Oe) : Promise.reject(Ne.BackupStreamErrors.NO_BACKUP_STREAMS);
          }, De.prototype.loadPlaylist = function(Re, Oe) {
            var Be;
            if (!Oe) {
              var Fe = new fe.PlayerError(_e.ErrorCode.SOURCE_INVALID, void 0, "Cannot load the playlist: no URL was provided.");
              return this.context.eventHandler.fireError(Fe), Promise.reject(Fe);
            }
            var Ve = this.context.serviceManager.maybeCall(le.ServiceName.ManifestCachingService, function(Ze) {
              return Ze.getHttpResponse(Oe);
            }, null, this.sourceContext.sourceIdentifier);
            if (Ve)
              return Promise.resolve(Ve);
            var Ke = (Be = this.sourceContext.source.options) === null || Be === void 0 ? void 0 : Be.manifestWithCredentials;
            return Re.load(Oe, ve.HttpRequestMethod.GET, null, null, null, Ke);
          }, De.prototype.createLoader = function(Re) {
            var Oe = this;
            return new ce.DefaultContentLoader(this.context, { onSuccess: function(Be, Fe) {
              var Ve, Ke;
              (0, ge.isDownloadTimeInformationValid)(Be) && (Oe.context.logger.debug("Downloaded playlist in: ".concat((Ve = Be.elapsedTime) === null || Ve === void 0 ? void 0 : Ve.toFixed(2), ", TTFB: ").concat((Ke = Be.timeToFirstByte) === null || Ke === void 0 ? void 0 : Ke.toFixed(2))), Oe.context.store.dispatch((0, be.addMetricsValue)("default", pe.MetricType.DownloadInformation, { bytes: Be.length, time: Be.elapsedTime, timeToFirstByte: Be.timeToFirstByte })));
            }, maxRetries: this.context.settings.MAX_MPD_RETRIES, requestType: Re, resetRetriesWhenOffline: !0 });
          }, De.prototype.getErrorFromResponse = function(Re) {
            var Oe = new fe.PlayerError(_e.ErrorCode.SOURCE_COULD_NOT_LOAD_MANIFEST, { sourceUrl: Re.url, statusCode: Re.status }, "Failed to load the playlist: ".concat(Re.status, " ").concat(Re.statusText, "."), this.sourceContext.sourceIdentifier);
            return Re.status === XMLHttpRequest.UNSENT && (Oe = new fe.PlayerError(_e.ErrorCode.NETWORK_ERROR, { url: Re.url, statusCode: Re.status, statusText: Re.statusText }, "Failed to load hls playlist, statusCode: ".concat(Re.status, ", statusText: ").concat(Re.statusText), this.sourceContext.sourceIdentifier)), Oe;
          }, De.prototype.dispose = function() {
            var Re, Oe = this;
            this.stop(), this.translatedManifest = (0, se.dispose)(this.translatedManifest), this.masterPlaylist = null, this.masterPlaylistLoader.dispose(), (Re = this.backupStreamsHandler) === null || Re === void 0 || Re.dispose(), Object.keys(this.variantUpdateLoaders).forEach(function(Be) {
              return Oe.variantUpdateLoaders[Be].dispose();
            }), this.variantUpdateLoaders = null;
          }, De;
        }();
        ie.M3u8Loader = Le;
      }, 83740: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.uniqueRenditions = ue;
        var ae = ne(86865);
        function ue(_e) {
          var fe = [];
          return _e.forEach(function(le) {
            var se = fe.findIndex(function(ce) {
              return (0, ae.compareValues)(le, ce, ["GROUP-ID", "NAME", "TYPE"]);
            });
            if (se !== -1) {
              var oe = fe[se];
              le.DEFAULT === "YES" && oe.DEFAULT !== "YES" && (fe[se] = le);
            } else
              fe.push(le);
          }), fe;
        }
      }, 73471: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.M3u8RepresentationFactory = void 0;
        var ae = ne(52442), ue = ne(33696), _e = ne(42283), fe = ne(26190), le = ne(76885), se = ne(53950), oe = function() {
          function ce(he, ge) {
            this.context = he, this.sourceContext = ge;
          }
          return ce.prototype.create = function(he, ge, ve, me, be) {
            if (be === void 0 && (be = !0), !he)
              return null;
            var pe = this.createBaseRepresentation(he, me);
            if (ge === ae.RepresentationType.AUDIO)
              pe = this.extendToAudioRepresentation(he, pe, ve, me);
            else if (ge === ae.RepresentationType.VIDEO)
              pe = this.extendToVideoRepresentation(he, pe, ve, me, be);
            else {
              if (ge !== ae.RepresentationType.SUBTITLE)
                return null;
              pe = this.extendToSubtitleRepresentation(he, pe, ve, me);
            }
            var $e = this.getLabelForRepresentation(pe);
            return $e && (pe._label = $e), pe;
          }, ce.prototype.createBaseRepresentation = function(he, ge) {
            var ve = he.uri || he.URI;
            ve && !le.URLHelper.isUrlAbsolute(ve) && (ve = le.URLHelper.concatBaseUrlWithPartial(ge, ve));
            var me = { _id: "", _mimeType: "", _bandwidth: 0, _codecs: "", _hls: { requestTimestamp: 0 }, BaseURL: null, SegmentList: [{ SegmentURL: [], entries: [], totalDuration: 0 }], Uri: ve };
            return he.NAME && (me._label = he.NAME), me;
          }, ce.prototype.extendToVideoRepresentation = function(he, ge, ve, me, be) {
            var pe = ge;
            if (pe._mimeType = "video/" + ve, pe._width = 0, pe._height = 0, pe.BaseURL = [{ url: se.PlaylistUtils.getBaseUrl(me, he.uri) }], pe._bandwidth = he.attributes["AVERAGE-BANDWIDTH"] || he.attributes.BANDWIDTH, pe._bandwidth || (pe._bandwidth = this.context.settings.MIN_SELECTABLE_VIDEO_BITRATE), pe._bandwidth = Number(pe._bandwidth), he.attributes.CODECS) {
              var $e = _e.CodecStringHelper.getExtractedCodecStrings(he.attributes.CODECS);
              _e.CodecStringHelper.hasOldAvc1CodecFormat($e.video) && ($e.video = _e.CodecStringHelper.convertAvc1ToAvcotiCodecFormat($e.video)), be ? $e.video && $e.audio ? pe._codecs = $e.video + "," + $e.audio : $e.video && !$e.audio ? pe._codecs = $e.video : !$e.video && $e.audio && (pe._codecs = $e.audio) : pe._codecs = $e.video;
            }
            return he.attributes["FRAME-RATE"] && (pe._frameRate = parseFloat(he.attributes["FRAME-RATE"])), he.attributes.RESOLUTION && (pe._width = he.attributes.RESOLUTION.width, pe._height = he.attributes.RESOLUTION.height, pe._id += he.attributes.RESOLUTION.height + "_"), pe._id += he.attributes.BANDWIDTH, pe;
          }, ce.prototype.extendToAudioRepresentation = function(he, ge, ve, me) {
            var be, pe, $e, ye = ge;
            return ye._id = he.NAME + " " + he["GROUP-ID"] || "", ye._mimeType = "audio/" + ve, ye._codecs = he.CODECS || ((be = he.attributes) === null || be === void 0 ? void 0 : be.CODECS), ye._name = he.NAME || "", ye._groupId = he["GROUP-ID"] || "", ye._label = ye._name + " " + ye._groupId, ye._bandwidth = ($e = (pe = he["AVERAGE-BANDWIDTH"]) !== null && pe !== void 0 ? pe : he.BANDWIDTH) !== null && $e !== void 0 ? $e : 0, ye.BaseURL = [{ url: se.PlaylistUtils.getBaseUrl(me, he.URI || he.uri) }], ye;
          }, ce.prototype.extendToSubtitleRepresentation = function(he, ge, ve, me) {
            var be = ge;
            return be._id = he.NAME, be._mimeType = "application/" + ve, be._codecs = "wvtt", be._name = he.NAME || "", be.BaseURL = [{ url: se.PlaylistUtils.getBaseUrl(me, he.URI) }], be._hls.isForced = he.FORCED === "YES", be;
          }, ce.prototype.getLabelForRepresentation = function(he) {
            var ge = { id: he._id, mimeType: he._mimeType, width: he._width, height: he._height, bitrate: he._bandwidth };
            return (0, fe.applyLabeling)({ source: this.sourceContext.source, logger: this.context.logger, streamType: ue.StreamType.Hls, labelingType: fe.LabelingType.Qualities }, ge);
          }, ce;
        }();
        ie.M3u8RepresentationFactory = oe;
      }, 52729: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(ve) {
            for (var me, be = 1, pe = arguments.length; be < pe; be++)
              for (var $e in me = arguments[be])
                Object.prototype.hasOwnProperty.call(me, $e) && (ve[$e] = me[$e]);
            return ve;
          }, ae.apply(this, arguments);
        }, ue = this && this.__spreadArray || function(ve, me, be) {
          if (be || arguments.length === 2)
            for (var pe, $e = 0, ye = me.length; $e < ye; $e++)
              !pe && $e in me || (pe || (pe = Array.prototype.slice.call(me, 0, $e)), pe[$e] = me[$e]);
          return ve.concat(pe || Array.prototype.slice.call(me));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.createNewMapEntry = se, ie.updateMapEntry = oe;
        var _e = ne(70016), fe = ne(28915), le = ne(52080);
        function se(ve, me) {
          var be = ve.segments.map(function(pe) {
            return ge(pe, me);
          });
          return { qualityInfo: { lastUpdateTimestamp: Date.now() }, segmentInfos: be };
        }
        function oe(ve, me, be) {
          var pe = ve.segmentInfos, $e = pe.findIndex(function(Te) {
            return he(Te, me.segments[0]);
          });
          if ($e === -1)
            return se(me, be);
          var ye = pe.length - $e, Se = me.segments.length - ye;
          if ($e !== 0 || Se !== 0) {
            var we = me.segments.slice(-Se).map(function(Te) {
              return ge(Te, be);
            }), Pe = ce(pe);
            return Pe != null && (0, le.forwardExtrapolateSegmentStartTime)(we, { index: 0, startTime: Pe }), { qualityInfo: ae(ae({}, ve.qualityInfo), { lastUpdateTimestamp: Date.now() }), segmentInfos: ue(ue([], pe.slice($e), !0), we, !0) };
          }
          return ve;
        }
        function ce(ve) {
          var me = ve[ve.length - 1];
          if (me.startTime !== void 0 && me.duration !== void 0)
            return me.startTime + me.duration;
        }
        function he(ve, me) {
          var be = ve.url === me.uri, pe = ve.discontinuitySequenceNumber === me.discontinuitySequenceNumber, $e = !ve.byteRange && !me.byterange, ye = ve.byteRange && me.byterange && ve.byteRange.start === me.byterange.offset && ve.byteRange.end === me.byterange.offset + me.byterange.length;
          return be && pe && (ye || $e);
        }
        function ge(ve, me) {
          var be, pe = { url: ve.uri, isInitSegment: !1, internalRepresentationId: me._internalId, isDiscontinuityStart: ve.discontinuity, discontinuitySequenceNumber: ve.discontinuitySequenceNumber, duration: ve.duration, startTime: ve.startTime, periodId: me._internalId.periodId, key: ve.key, metadata: (be = ve.metadata) !== null && be !== void 0 ? be : [], mimeType: me._mimeType, bitrate: me._bandwidth, codecs: me._codecs };
          return ve.byterange && (pe.byteRange = { start: ve.byterange.offset, end: ve.byterange.offset + ve.byterange.length }), ve.init && (pe.init = ve.init), ve.dateTime && (pe.dateTime = ve.dateTime), (0, _e.isVideoRepresentation)(me) && (pe.height = me._height, pe.width = me._width, pe.frameRate = me._frameRate), pe.segmentId = (0, fe.generateSegmentId)(pe), pe;
        }
      }, 49422: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ue) {
            for (var ke, Le = 1, De = arguments.length; Le < De; Le++)
              for (var Re in ke = arguments[Le])
                Object.prototype.hasOwnProperty.call(ke, Re) && (Ue[Re] = ke[Re]);
            return Ue;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.HlsParsing = ie.M3u8Translator = void 0;
        var ue, _e = ne(52442), fe = ne(42283), le = ne(3941), se = ne(10676), oe = ne(79814), ce = ne(331), he = ne(76885), ge = ne(91520), ve = ne(16368), me = ne(73543), be = ne(67883), pe = ne(83740), $e = ne(73471), ye = ne(53950), Se = new RegExp(/^data:text\/plain.*;base64.*,(.+)/), we = function() {
          function Ue(ke, Le) {
            this.adaptationsetId = 0, this.assumeAudioMuxedIntoVideoTs = !1, this.memoizedParseBase64DataUrl = (0, se.memoize)(function(De) {
              var Re = Se.exec(De);
              return Re !== null && Re.length === 2 ? Re[1] : null;
            }), this.context = ke, this.sourceContext = Le, this.representationFactory = new $e.M3u8RepresentationFactory(ke, Le);
          }
          return Ue.prototype.updateBaseUrl = function(ke) {
            this.baseURL = he.URLHelper.removeLastPathPart(ke);
          }, Ue.prototype.getBaseUrl = function() {
            var ke;
            return (ke = this.baseURL) !== null && ke !== void 0 ? ke : "";
          }, Ue.prototype.createCeaCaptionObjects = function(ke, Le) {
            for (var De = {}, Re = { _schemeIdUri: "urn:scte:dash:cc:cea-" + Le + ":2015", _value: "" }, Oe = 0; Oe < ke.length; Oe++) {
              var Be = ke[Oe]["INSTREAM-ID"];
              De[Be] = { lang: ke[Oe].LANGUAGE || ke[Oe].NAME || Be, label: ke[Oe].NAME || ke[Oe].LANGUAGE || Be }, Re._value.length > 0 && (Re._value += ";"), Re._value += Le === "708" ? Be.substring(7) + "=lang:" : Be + "=", Re._value += ke[Oe].LANGUAGE;
            }
            return { closedCaptionLabel: De, accessibility: Re };
          }, Ue.prototype.createCaptionElements = function(ke) {
            if (!ke)
              return { closedCaptionLabel: null, accessibility: [] };
            var Le = this.createCeaCaptionObjects(ke.cea608, "608"), De = this.createCeaCaptionObjects(ke.cea708, "708"), Re = [], Oe = null;
            return Le.accessibility._value && (Re.push(Le.accessibility), Oe = Le.closedCaptionLabel), De.accessibility._value && Re.push(De.accessibility), { closedCaptionLabel: Oe, accessibility: Re };
          }, Ue.prototype.createVideoAdaptationSet = function(ke, Le, De, Re, Oe) {
            for (var Be = [], Fe = 1 / 0, Ve = 0, Ke = 1 / 0, Ze = 0, nt = 1 / 0, Qe = 0, qe = null, ze = "video/" + Re, je = 0, tt = ke; je < tt.length; je++) {
              var ut = tt[je];
              if (ut.uri) {
                var yt = this.representationFactory.create(ut, _e.RepresentationType.VIDEO, Re, this.baseURL, this.assumeAudioMuxedIntoVideoTs);
                Be.push(yt), Fe = Math.min(Fe, yt._height), Ve = Math.max(Ve, yt._height), Ke = Math.min(Ke, yt._width), Ze = Math.max(Ze, yt._width), nt = Math.min(nt, yt._bandwidth), Qe = Math.max(Qe, yt._bandwidth);
              }
            }
            Be.sort(function(lt, Je) {
              return lt._bandwidth - Je._bandwidth;
            });
            var $t = { Representation: Be, ContentComponent: [{ _id: "video", _contentType: "video" }], _id: String(this.adaptationsetId), _group: qe, _mimeType: ze, _internalId: new be.AdaptationSetId(De, String(this.adaptationsetId++)), _minBandwidth: nt, _maxBandwidth: Qe, _minHeight: Fe, _maxHeight: Ve, _minWidth: Ke, _maxWidth: Ze, isTransmuxingRequired: !0 };
            Oe && Object.keys(Oe).forEach(function(lt) {
              Oe[lt].entries.filter(function(Je) {
                return !Je.URI;
              }).forEach(function(Je) {
                $t.ContentComponent.push({ _id: Je.NAME, _contentType: "audio", _lang: Je.LANGUAGE });
              });
            });
            var ft = this.createCaptionElements(Le);
            ft.closedCaptionLabel && ($t.ClosedCaptionLabels = ft.closedCaptionLabel), ft.accessibility.length > 0 && ($t.Accessibility = ft.accessibility);
            var pt = this.getLabelForAdaptationSet($t);
            return pt && typeof pt == "string" && ($t._label = pt), $t;
          }, Ue.prototype.createAudioAdaptationSet = function(ke, Le, De, Re) {
            for (var Oe = [], Be = 1 / 0, Fe = 0, Ve = null, Ke = 0, Ze = ke; Ke < Ze.length; Ke++) {
              var nt = Ze[Ke];
              if (nt.uri) {
                var Qe = this.representationFactory.create(nt, _e.RepresentationType.AUDIO, Re, this.baseURL, this.assumeAudioMuxedIntoVideoTs);
                Oe.push(Qe);
              }
            }
            Oe.sort(function(tt, ut) {
              return tt._bandwidth - ut._bandwidth;
            });
            var qe = { Representation: Oe, _id: String(this.adaptationsetId), _group: Ve, _mimeType: "audio/" + Re, _internalId: new be.AdaptationSetId(De, String(this.adaptationsetId++)), _minBandwidth: Be, _maxBandwidth: Fe, isTransmuxingRequired: !0 }, ze = this.createCaptionElements(Le);
            ze.closedCaptionLabel && (qe.ClosedCaptionLabels = ze.closedCaptionLabel), ze.accessibility.length > 0 && (qe.Accessibility = ze.accessibility);
            var je = this.getLabelForAdaptationSet(qe);
            return je && typeof je == "string" && (qe._label = je), qe;
          }, Ue.prototype.createAudioAdaptationSets = function(ke, Le, De) {
            var Re = this, Oe = this.context.settings.IGNORE_HLS_AUDIO_GROUPS, Be = 0, Fe = [], Ve = function(Ke) {
              return { Representation: [], _id: String(Re.adaptationsetId), _internalId: new be.AdaptationSetId(ke, String(Re.adaptationsetId++)), _mimeType: "audio/" + De, _minBandwidth: 1 / 0, _maxBandwidth: -1, _lang: Ke, _group: String(Be++), isTransmuxingRequired: !0 };
            };
            return Object.keys(Le).forEach(function(Ke) {
              var Ze, nt, Qe, qe = Le[Ke], ze = qe.entries.find(function(lt) {
                return lt.LANGUAGE && lt.LANGUAGE !== "und";
              });
              ze && (nt = ze.LANGUAGE), Oe || (Qe = Ve(nt));
              for (var je = (0, pe.uniqueRenditions)(qe.entries.filter(function(lt) {
                return lt.URI;
              })), tt = 0, ut = je; tt < ut.length; tt++) {
                var yt = ut[tt];
                Oe && (Qe = Ve(nt));
                var $t = Re.representationFactory.create(yt, _e.RepresentationType.AUDIO, De, Re.baseURL, Re.assumeAudioMuxedIntoVideoTs);
                Qe.Representation.push($t), Qe._minBandwidth = Math.min(Qe._minBandwidth, $t._bandwidth), Qe._maxBandwidth = Math.max(Qe._maxBandwidth, $t._bandwidth);
                var ft = yt.CHARACTERISTICS;
                if (ft && ft.indexOf(Re.context.settings.HLS_VR_CHARACTERISTICS_UTI) === 0 && (Qe.Role = [{ _schemeIdUri: Re.context.settings.VR_SCHEME_ID_URI, _value: ft.substring(Re.context.settings.HLS_VR_CHARACTERISTICS_UTI.length) }]), !Qe._label) {
                  var pt = Re.getLabelForAdaptationSet(Qe);
                  pt && typeof pt == "string" ? Qe._label = pt : $t._name ? Qe._label = $t._name : Qe._label = Ke;
                }
                Oe && Qe.Representation.length > 0 && Fe.push(Qe), Qe.Representation.sort(function(lt, Je) {
                  return lt._bandwidth - Je._bandwidth;
                });
              }
              Ee((Ze = Qe == null ? void 0 : Qe.Representation) !== null && Ze !== void 0 ? Ze : []), !Oe && Qe.Representation.length > 0 && Fe.push(Qe);
            }), Fe;
          }, Ue.prototype.createSubtitleAdaptationSets = function(ke, Le, De) {
            var Re = this, Oe = 0;
            return Object.values(Le).filter(function(Be) {
              return Be.URI;
            }).map(function(Be) {
              var Fe = { Representation: [], _id: String(Re.adaptationsetId), _internalId: new be.AdaptationSetId(ke, String(Re.adaptationsetId++)), _mimeType: "application/mp4", _lang: Be.LANGUAGE, _group: "" + Oe++, _isFragmented: !0 }, Ve = Re.representationFactory.create(Be, _e.RepresentationType.SUBTITLE, De, Re.baseURL, Re.assumeAudioMuxedIntoVideoTs);
              Fe.Representation.push(Ve);
              var Ke = Re.getLabelForAdaptationSet(Fe);
              return Ke && typeof Ke == "string" ? Fe._label = Ke : Ve._name ? Fe._label = Ve._name : Fe._label = Be.LANGUAGE, Fe;
            });
          }, Ue.prototype.getLabelForAdaptationSet = function(ke) {
            var Le = { mimeType: ke._mimeType, lang: ke._lang };
            return ke._label && (Le.label = ke._label), this.getLabelingFunctionForAdaptationSet()(Le);
          }, Ue.prototype.getLabelingFunctionForAdaptationSet = function() {
            var ke = this.context.sourceContext, Le = ke && ke.source && ke.source.labeling;
            return Le && Le.hls && Le.hls.tracks ? typeof Le.hls.tracks != "function" ? this.getDefaultLabelForAdaptationSet : Le.hls.tracks : this.getDefaultLabelForAdaptationSet;
          }, Ue.prototype.getDefaultLabelForAdaptationSet = function() {
            return null;
          }, Ue.prototype.extractBackupStreams = function(ke) {
            for (var Le, De = [], Re = (Le = this.baseURL) !== null && Le !== void 0 ? Le : "", Oe = ke.playlists, Be = {}, Fe = 0; Fe < Oe.length; Fe++) {
              var Ve = {}, Ke = Oe[Fe];
              this.addBackupStream(Ve, Ke, ke.media, Re);
              for (var Ze = Fe + 1; Ze < Oe.length; Ze++) {
                var nt = Oe[Ze];
                Ce(Ke, nt) && (this.addBackupStream(Ve, nt, ke.media, Re), nt.attributes.AUDIO && nt.attributes.AUDIO !== Ke.attributes.AUDIO && (Be[nt.attributes.AUDIO] = !0), Oe.splice(Ze, 1), Ze--);
              }
              De.push(Ve);
            }
            return this.context.settings.IGNORE_HLS_AUDIO_GROUPS || (ke.media = ke.media.filter(function(Qe) {
              return !Be[Qe.attributes["GROUP-ID"]];
            })), De;
          }, Ue.prototype.addBackupStream = function(ke, Le, De, Re) {
            this.context.settings.DISABLE_HLS_BACKUP_STREAM_FAILOVER || (ke[String(Object.keys(ke).length)] = Me(Le, De, Re));
          }, Ue.prototype.createDashManifestSkeleton = function(ke) {
            var Le = ke;
            return this.extractCodecInformation(Le), this.playlistPreprocessing(Le), this.assumeAudioMuxedIntoVideoTs = this.canAssumeAudioMuxedIntoVideo(Le), { BaseURL: [{ url: this.baseURL }], Period: [this.createPeriod(Le, le.DEFAULT_PERIOD_ID)], _hasIndependentSegments: ke.independentSegments, _isHls: !0, isInitialized: !1 };
          }, Ue.prototype.extractCodecInformation = function(ke) {
            var Le = this;
            ke.playlists.forEach(function(De) {
              if (De.attributes.CODECS) {
                var Re = fe.CodecStringHelper.getExtractedCodecStrings(De.attributes.CODECS);
                if (!Re.video && Re.unknown && (De.attributes.RESOLUTION || De.attributes["FRAME-RATE"])) {
                  var Oe = fe.CodecStringHelper.extractCodec(Re.unknown);
                  Le.context.logger.debug("Assuming unknown codec ".concat(Oe, " is video")), fe.CodecStringHelper.addCodec("video", Oe);
                }
              }
            });
          }, Ue.prototype.isVariantOfMimeType = function(ke, Le) {
            return fe.CodecStringHelper.getMimeTypeForCodecString(ke.attributes.CODECS) === Le;
          }, Ue.prototype.removeUnsupportedAudioOnlyVariants = function(ke) {
            var Le = this, De = ke.playlists.some(function(Oe) {
              return Le.isVariantOfMimeType(Oe, "video");
            }), Re = ke.playlists.some(function(Oe) {
              return Le.isVariantOfMimeType(Oe, "audio");
            });
            De && Re && (ke.playlists = ke.playlists.filter(function(Oe) {
              return Le.isVariantOfMimeType(Oe, "video");
            }));
          }, Ue.prototype.playlistPreprocessing = function(ke) {
            this.removeUnsupportedAudioOnlyVariants(ke);
          }, Ue.prototype.getVideoCodecForPlaylist = function(ke, Le) {
            Le === void 0 && (Le = !1);
            var De = fe.CodecStringHelper.getExtractedCodecStrings(ke.attributes.CODECS);
            return De.video ? (fe.CodecStringHelper.hasOldAvc1CodecFormat(De.video) && (De.video = fe.CodecStringHelper.convertAvc1ToAvcotiCodecFormat(De.video)), Le ? De.video : De.video.split(".")[0]) : null;
          }, Ue.prototype.getAudioCodecForPlaylist = function(ke, Le) {
            Le === void 0 && (Le = !1);
            var De = fe.CodecStringHelper.getExtractedCodecStrings(ke.attributes.CODECS);
            return De.audio ? Le ? De.audio : De.audio.split(".")[0] : null;
          }, Ue.prototype.getAllVideoCodecs = function(ke) {
            var Le = this;
            return ke.map(function(De) {
              return Le.getVideoCodecForPlaylist(De);
            }).filter(function(De, Re, Oe) {
              return De && Oe.indexOf(De) === Re;
            });
          }, Ue.prototype.getAllAudioCodecs = function(ke) {
            var Le = this;
            return ke.map(function(De) {
              return Le.getAudioCodecForPlaylist(De);
            }).filter(function(De, Re, Oe) {
              return De && Oe.indexOf(De) === Re;
            });
          }, Ue.prototype.groupPlaylistsByCodec = function(ke) {
            var Le = this.getAllVideoCodecs(ke), De = this.getAllAudioCodecs(ke);
            if (Le.length === 0 && De.length === 0)
              return { unknown: ke };
            if (Le.length === 0) {
              var Re = {};
              return De.forEach(function(Be) {
                Re[Be] = ke.filter(function(Fe) {
                  var Ve;
                  return (Ve = Fe.attributes.CODECS) === null || Ve === void 0 ? void 0 : Ve.includes(Be);
                });
              }), Re;
            }
            var Oe = {};
            return Le.forEach(function(Be) {
              Oe[Be] = ke.filter(function(Fe) {
                var Ve;
                return (Ve = Fe.attributes.CODECS) === null || Ve === void 0 ? void 0 : Ve.includes(Be);
              });
            }), Oe;
          }, Ue.prototype.createPeriod = function(ke, Le) {
            var De = this, Re = { _id: Le, _duration: "PT0S", duration: 0, AdaptationSet: [] }, Oe = function(Qe) {
              if (Qe.attributes.CODECS != null) {
                var qe = Te(Qe.attributes.CODECS), ze = fe.CodecStringHelper.getExtractedCodecStrings(qe).video;
                return !!ze && De.context.renderer.isMediaTypeSupported("video/mp4", ze);
              }
              return !0;
            }, Be = ue.extractMediaRenditions(ke, this.context.settings.IGNORE_HLS_AUDIO_GROUPS, Oe), Fe = this.groupPlaylistsByCodec(ke.playlists), Ve = Object.keys(Fe), Ke = Ve.filter(function(Qe) {
              return fe.CodecStringHelper.isVideoCodec(Qe);
            }).map(function(Qe) {
              return De.createVideoAdaptationSet(Fe[Qe], Be.captions, Re._id, me.ContainerFormat.MP4, Be.audio);
            }).filter(function(Qe) {
              return Qe.Representation = Qe.Representation.reduce(function(qe, ze) {
                var je = Ue.isRepresentationSupported(ze, De.context.renderer), tt = !!qe.find(function(ut) {
                  return ut.Uri === ze.Uri;
                });
                return je && !tt && qe.push(ze), qe;
              }, []), Qe.Representation.length > 0;
            }), Ze = this.createAudioAdaptationSets(Re._id, Be.audio, me.ContainerFormat.MP4).filter(function(Qe) {
              return Qe.Representation = Qe.Representation.filter(function(qe) {
                return Ue.isRepresentationSupported(qe, De.context.renderer);
              }), Qe.Representation.length > 0;
            }).concat(Ve.filter(function(Qe) {
              return fe.CodecStringHelper.isAudioCodec(Qe);
            }).map(function(Qe) {
              return De.createAudioAdaptationSet(Fe[Qe], Be.captions, Re._id, me.ContainerFormat.MP4);
            })), nt = this.createSubtitleAdaptationSets(Re._id, Be.subtitles, me.ContainerFormat.MP4);
            return Re.AdaptationSet = [].concat(Ke, Ze, nt), ge.ModuleManager.has(ve.ModuleName.Thumbnail) && (Re.AdaptationSet = ge.ModuleManager.get(ve.ModuleName.Thumbnail).extendAdaptationSets(Re.AdaptationSet, ke, this.baseURL)), Re;
          }, Ue.isRepresentationSupported = function(ke, Le) {
            var De = !ke._mimeType.includes("audio") && !ke._mimeType.includes("video");
            if (!ke._codecs || De)
              return !0;
            var Re = fe.CodecStringHelper.getExtractedCodecStrings(ke._codecs);
            return Object.keys(Re).every(function(Oe) {
              return fe.CodecStringHelper.isSupportedByRenderer(Le, Oe + "/mp4", Re[Oe]);
            });
          }, Ue.prototype.canAssumeAudioMuxedIntoVideo = function(ke) {
            var Le = ke.media.filter(function(De) {
              return Ne(De.attributes);
            });
            return !Le.length || Le.some(function(De) {
              return !De.attributes.URI;
            });
          }, Ue.prototype.parseSegmentEncryptionInfo = function(ke, Le, De, Re, Oe, Be) {
            for (var Fe, Ve = function(Qe) {
              Ke.memoizedParseBase64DataUrl(Qe.uri) !== null ? (Le.find(function(qe) {
                return !Object.keys(Qe).some(function(ze) {
                  return Qe[ze] !== qe[ze];
                });
              }) !== void 0 || Le.push(Qe), Le.length > 0 && (Fe = void 0)) : Fe = (0, ye.generateSegmentEncryptionInfo)(Qe, De, Re, Be, Oe);
            }, Ke = this, Ze = 0, nt = ke ?? []; Ze < nt.length; Ze++)
              Ve(nt[Ze]);
            return Fe;
          }, Ue.prototype.translateSegmentList = function(ke, Le) {
            var De, Re, Oe, Be, Fe, Ve = Le.segments, Ke = [], Ze = [], nt = (Oe = (Re = (De = ke.BaseURL) === null || De === void 0 ? void 0 : De[0]) === null || Re === void 0 ? void 0 : Re.url) !== null && Oe !== void 0 ? Oe : "", Qe = "";
            nt && (Qe = (0, he.extractOrigin)(nt)), this.memoizedParseBase64DataUrl.invalidate();
            for (var qe = 0, ze = function(ut) {
              var yt = Ve[ut];
              nt && (yt.uri = he.URLHelper.buildAbsoluteUrl(nt, Qe, yt.uri));
              var $t = je.parseSegmentEncryptionInfo(yt.keys, Ze, nt, Qe, ut, (Be = ke._hls) === null || Be === void 0 ? void 0 : Be.mediaSequence);
              yt.init && (yt.init.url = he.URLHelper.buildAbsoluteUrl(nt, Qe, yt.init.url), yt.init.key = je.parseSegmentEncryptionInfo(yt.init.keys, Ze, nt, Qe, ut, (Fe = ke._hls) === null || Fe === void 0 ? void 0 : Fe.mediaSequence));
              var ft = { _media: yt.uri, _duration: yt.duration, _mediaSequence: yt.mediaSequence, _discontinuitySequenceNumber: yt.discontinuitySequenceNumber, _metadata: [] };
              Ie(ft, "_discontinuity", yt.discontinuity), Ie(ft, "_key", $t), Ie(ft, "_init", yt.init), Ie(ft, "_dateTime", yt.dateTime), Ie(ft, "_byteRange", (0, ye.parseSegmentByteRange)(yt.byterange)), Ie(ft, "_playbackTime", xe(Le, qe, yt.dateTime)), ["cueTag", "scte35", "customTags"].filter(function(pt) {
                return yt.hasOwnProperty(pt);
              }).forEach(function(pt) {
                return ft._metadata = ft._metadata.concat(yt[pt]);
              }), yt.parts && (ft._parts = yt.parts.map(function(pt) {
                return ae(ae({}, pt), { uri: he.URLHelper.buildAbsoluteUrl(nt, Qe, pt.uri) });
              })), Ke.push(ft), qe += yt.duration;
            }, je = this, tt = 0; tt < Ve.length; tt++)
              ze(tt);
            return { entries: Ke, contentProtectionInfos: this.parseAllContentProtection(Ze) };
          }, Ue.prototype.parseAllContentProtection = function(ke) {
            var Le = this, De = [];
            return ke.forEach(function(Re) {
              var Oe = Pe(Re, Le.memoizedParseBase64DataUrl(Re.uri));
              Oe ? De.push(Oe) : Le.context.logger.debug("Encountered unknown/unsupported DRM scheme:", Re.keyformat);
            }), De;
          }, Ue.prototype.dispose = function() {
            this.baseURL = null, this.memoizedParseBase64DataUrl.invalidate();
          }, Ue;
        }();
        function Pe(Ue, ke) {
          return ge.ModuleManager.has(ve.ModuleName.DRM) ? ge.ModuleManager.get(ve.ModuleName.DRM).ContentProtectionHelper.parseContentProtection(Ue, ke) : null;
        }
        function Te(Ue) {
          return Ue.split(",").map(function(ke) {
            return fe.CodecStringHelper.hasOldAvc1CodecFormat(ke) ? fe.CodecStringHelper.convertAvc1ToAvcotiCodecFormat(ke) : ke;
          }).join(",");
        }
        function Ee(Ue) {
          Ue.forEach(function(ke, Le) {
            ke._bandwidth = 128e3 + 32e3 * Le;
          });
        }
        function Me(Ue, ke, Le) {
          var De = {};
          return De[oe.MimeType.VideoMp4] = he.URLHelper.getAbsoluteUrl(Ue.uri, Le), Ue.attributes.AUDIO && Ae(ke, Ue.attributes.AUDIO, Le).forEach(function(Re) {
            De[Re.id] = Re.url;
          }), De;
        }
        function Ae(Ue, ke, Le) {
          return Ue.filter(function(De) {
            return Ne(De.attributes) && De.attributes["GROUP-ID"] === ke && De.attributes.URI;
          }).map(function(De) {
            var Re;
            return { id: De.attributes.NAME, url: he.URLHelper.getAbsoluteUrl((Re = De.attributes.URI) !== null && Re !== void 0 ? Re : "", Le) };
          });
        }
        function Ne(Ue) {
          return Ue.TYPE === "AUDIO";
        }
        function Ce(Ue, ke) {
          var Le, De, Re, Oe, Be = Ue.attributes.BANDWIDTH === ke.attributes.BANDWIDTH, Fe = ((Le = Ue.attributes.RESOLUTION) === null || Le === void 0 ? void 0 : Le.height) === ((De = ke.attributes.RESOLUTION) === null || De === void 0 ? void 0 : De.height) && ((Re = Ue.attributes.RESOLUTION) === null || Re === void 0 ? void 0 : Re.width) === ((Oe = ke.attributes.RESOLUTION) === null || Oe === void 0 ? void 0 : Oe.width);
          return Be && Fe;
        }
        function Ie(Ue, ke, Le) {
          Le !== void 0 && (Ue[ke] = Le);
        }
        function xe(Ue, ke, Le) {
          var De;
          return Ue.endList ? ((De = Ue.startTime) !== null && De !== void 0 ? De : 0) + ke : Le ? (0, ce.toSeconds)(Le.getTime()) : void 0;
        }
        ie.M3u8Translator = we, function(Ue) {
          function ke(Ke, Ze) {
            var nt = {};
            return Ke.forEach(function(Qe) {
              var qe = Ze[Qe["GROUP-ID"]] || Ze[Object.keys(Ze)[0]];
              Qe["AVERAGE-BANDWIDTH"] = qe[0]["AVERAGE-BANDWIDTH"], Qe.BANDWIDTH = qe[0].BANDWIDTH, Qe.CODECS = qe[0].CODECS;
              var ze = Qe["AVERAGE-BANDWIDTH"] || Qe.BANDWIDTH, je = Object.keys(nt).find(function(yt) {
                var $t, ft, pt = nt[yt].entries[0];
                return (pt == null ? void 0 : pt.NAME) === Qe.NAME && fe.CodecStringHelper.canSwitchBetweenAudioCodecs(($t = pt == null ? void 0 : pt.CODECS) !== null && $t !== void 0 ? $t : "", (ft = Qe.CODECS) !== null && ft !== void 0 ? ft : "");
              });
              if (je && nt[je]) {
                var tt = nt[je];
                tt.entries.push(Qe), tt.MIN_BANDWIDTH = Math.min(tt.MIN_BANDWIDTH, ze), tt.MAX_BANDWIDTH = Math.max(tt.MAX_BANDWIDTH, ze);
              } else {
                var ut = Qe.CODECS ? "".concat(Qe.NAME, " (").concat(Qe.CODECS, ")") : Qe.NAME;
                nt[ut] = { entries: [Qe], MIN_BANDWIDTH: ze, MAX_BANDWIDTH: ze };
              }
            }), nt;
          }
          function Le(Ke) {
            var Ze = {};
            return Ke.forEach(function(nt) {
              return Ze[nt.NAME] = nt;
            }), Ze;
          }
          function De(Ke) {
            var Ze = { cea608: [], cea708: [] };
            return Ke.forEach(function(nt) {
              nt["INSTREAM-ID"] && nt["INSTREAM-ID"].indexOf("CC") === 0 ? Ze.cea608.push(nt) : nt["INSTREAM-ID"] && nt["INSTREAM-ID"].indexOf("SERVICE") === 0 && Ze.cea708.push(nt);
            }), Ze;
          }
          function Re(Ke, Ze, nt) {
            var Qe = Ke.playlists.filter(nt), qe = Ke.media.map(function(yt) {
              return yt.attributes;
            }), ze = Fe(Qe), je = qe.filter(function(yt) {
              var $t = ze[yt["GROUP-ID"]];
              return Ne(yt) && (Ze || $t);
            }), tt = qe.filter(function(yt) {
              return yt.TYPE === "SUBTITLES";
            }), ut = qe.filter(function(yt) {
              return yt.TYPE === "CLOSED-CAPTIONS";
            });
            return { audio: ke(je, ze), subtitles: Le(tt), captions: De(ut) };
          }
          function Oe(Ke) {
            var Ze = {};
            return Ke.forEach(function(nt) {
              var Qe = nt.attributes.AUDIO;
              Ze[Qe] || (Ze[Qe] = []);
              var qe = { "AVERAGE-BANDWIDTH": nt.attributes["AVERAGE-BANDWIDTH"], BANDWIDTH: nt.attributes.BANDWIDTH, CODECS: void 0 };
              nt.attributes.CODECS && nt.attributes.CODECS.indexOf(",") > -1 && (qe.CODECS = Ve(nt)), Ze[Qe].push(qe);
            }), Ze;
          }
          function Be(Ke) {
            Object.values(Ke).forEach(function(Ze) {
              Ze.sort(function(nt, Qe) {
                return nt.BANDWIDTH - Qe.BANDWIDTH;
              });
            });
          }
          function Fe(Ke) {
            var Ze = Oe(Ke);
            return Be(Ze), Ze;
          }
          function Ve(Ke) {
            return Ke.attributes.CODECS.split(",").find(function(Ze) {
              return fe.CodecStringHelper.isAudioCodec(Ze);
            });
          }
          Ue.extractMediaRenditions = Re, Ue.getPropertiesForAudioGroups = Fe;
        }(ue || (ie.HlsParsing = ue = {}));
      }, 32352: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.M3u8Validator = ie.M3u8ValidatorError = void 0, function(ue) {
          ue.EmptyPlaylist = "EmptyPlaylist";
        }(ne || (ie.M3u8ValidatorError = ne = {}));
        var ae = function() {
          function ue() {
          }
          return ue.checkForError = function(_e) {
            for (var fe = 0, le = ue.mediaPlaylistRules; fe < le.length; fe++) {
              var se = le[fe];
              if (!se.fn(_e))
                return se.err;
            }
            return null;
          }, ue.mediaPlaylistRules = [{ fn: function(_e) {
            var fe;
            return ((fe = _e.segments) === null || fe === void 0 ? void 0 : fe.length) > 0;
          }, err: ne.EmptyPlaylist }], ue;
        }();
        ie.M3u8Validator = ae;
      }, 64732: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.HLSModuleDefinition = void 0;
        var ae = ne(3864), ue = ne(16368), _e = ne(26527), fe = ne(33827), le = ne(22675), se = ne(59692), oe = ne(53950), ce = ne(79367), he = ne(78148), ge = ne(34435), ve = { setPresentationTimeOffset: ce.setPresentationTimeOffset, setTimestampRolloverPositions: ce.setTimestampRolloverPositions }, me = { areDiscontinuitiesMisaligned: ge.areDiscontinuitiesMisaligned, getPresentationTimeOffset: ge.getPresentationTimeOffset, getHlsState: ge.getHlsState, getPlaylistType: ge.getPlaylistType, getIsLowLatencyPlaylist: ge.getIsLowLatencyPlaylist, getEndlist: ge.getEndlist, getDefaultLanguages: ge.getDefaultLanguages, getCustomTags: ge.getCustomTags, getDiscoSequenceTiming: ge.getDiscoSequenceTiming, getDiscoSequenceTimings: ge.getDiscoSequenceTimings, getFirstDiscoSequenceTiming: ge.getFirstDiscoSequenceTiming, getMergedDiscontinuityTimings: ge.getMergedDiscontinuityTimings };
        ie.HLSModuleDefinition = { name: ue.ModuleName.HLS, module: function() {
          return { HlsTimelineTracker: fe.HlsTimelineTracker, M3u8Loader: le.M3u8Loader, HlsUtils: ae.HlsUtils, parsePlaylist: se.parsePlaylist, PlaylistUtils: oe.PlaylistUtils, DiscontinuitySequenceNumberTracker: _e.DiscontinuitySequenceNumberTracker, HlsReducer: he.HlsReducer, actions: ve, selectors: me, canMakeBlockingPlaylistReload: oe.canMakeBlockingPlaylistReload };
        }, dependencies: [ue.ModuleName.EngineBitmovin] }, ie.default = ie.HLSModuleDefinition;
      }, 53950: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(ke) {
            for (var Le, De = 1, Re = arguments.length; De < Re; De++)
              for (var Oe in Le = arguments[De])
                Object.prototype.hasOwnProperty.call(Le, Oe) && (ke[Oe] = Le[Oe]);
            return ke;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.PlaylistUtils = ie.isMediaPlaylist = ie.isMasterPlaylist = void 0, ie.calculateUpdateIntervalInSeconds = me, ie.parseSegmentByteRange = $e, ie.generateSegmentEncryptionInfo = ye, ie.getLastMediaSequenceAndPartIndex = Pe, ie.canMakeBlockingPlaylistReload = Te, ie.canPerformDeltaUpdate = Ee, ie.calcNumberOfSegmentsToDrop = Me, ie.addNewSegments = Ae, ie.isDeltaPlaylist = xe;
        var ue = ne(52442), _e = ne(91397), fe = ne(81361), le = ne(331), se = ne(76885), oe = ne(93109), ce = ne(72927), he = function(ke) {
          return "playlists" in ke;
        };
        ie.isMasterPlaylist = he;
        var ge = function(ke) {
          return !(0, ie.isMasterPlaylist)(ke);
        };
        ie.isMediaPlaylist = ge;
        var ve = function() {
          function ke() {
          }
          return ke.createDiscontinuitySequences = function(Le, De) {
            var Re = Le.segments.filter(function(Ve) {
              return Ve.duration > 0;
            }), Oe = this.getStartingDiscontinuity(Le, Re, De), Be = { id: Oe, segments: [], duration: 0 }, Fe = [Be];
            return Re.forEach(function(Ve, Ke) {
              Ve.discontinuity !== void 0 && (Oe++, Ke === 0 ? Be.id = Oe : (Be = { id: Oe, duration: 0, segments: [] }, Fe.push(Be))), Ve.discontinuitySequenceNumber = Oe, Be.segments.push(Ve), Be.duration += Ve.duration;
            }), Fe;
          }, ke.getStartingDiscontinuity = function(Le, De, Re) {
            var Oe = Le.discontinuitySequence;
            return Oe == null && (Oe = Re.length !== 0 && ke.isLive(Le) ? this.findCurrentDiscontinuitySequenceNumber(De, Re) : 0), Oe;
          }, ke.findCurrentDiscontinuitySequenceNumber = function(Le, De) {
            for (var Re = [], Oe = 0, Be = 0; Be < De.length - 1; Be++)
              Oe += De[Be].segments.length, Re.push(Oe);
            var Fe = [];
            return Le.forEach(function(Ve, Ke) {
              Ve.discontinuity !== void 0 && Fe.push(Ke);
            }), Re.length === 0 ? De[0] ? De[0].id : 0 : Fe.length === 0 ? De[De.length - 1].id : Fe.length !== Re.length ? Fe.length > Re.length ? De[0].id : De[1].id : this.findFirstPeriodByIndexTracking(Re, Fe, De);
          }, ke.findFirstPeriodByIndexTracking = function(Le, De, Re) {
            if (Le[0] > De[0])
              return Re[0].id;
            if (Le[0] < De[0]) {
              for (var Oe = Le[0] - De[0], Be = 0, Fe = 0; Fe < Le.length; Fe++)
                Le[Fe] + Oe < De[0] && Be++;
              return Re[Be].id;
            }
            var Ve = function() {
              return Le.every(function(Ze, nt) {
                return Ze === De[nt];
              });
            };
            if (Ve())
              return Re[0].id;
            for (var Ke = 1; Le.length > 0; ) {
              for (Le.shift(), Fe = 0; Fe < Le.length; Fe++)
                Le[Fe]--;
              if (Ve())
                break;
              Ke++;
            }
            return Re[Ke].id;
          }, ke.extrapolateProgramDateTime = function(Le) {
            var De = null;
            if (Le.find(function(Ke, Ze) {
              return Ke.dateTime && (De = Ze), Ke.dateTime !== void 0;
            }), De !== null) {
              var Re;
              for (Re = De - 1; Re >= 0; Re--) {
                var Oe = Le[Re + 1].dateTime, Be = Math.ceil((0, le.toMilliSeconds)(Le[Re].duration));
                Le[Re].dateTime = new Date(Oe.getTime() - Be);
              }
              for (Re = De + 1; Re < Le.length; Re++) {
                var Fe = Le[Re - 1].dateTime, Ve = Math.ceil((0, le.toMilliSeconds)(Le[Re - 1].duration));
                Le[Re].dateTime = new Date(Fe.getTime() + Ve);
              }
            }
          }, ke.isLive = function(Le) {
            return Le.endList !== !0;
          }, ke.getProgramDateTimeFromSegmentUrl = function(Le, De) {
            if (Le.indexOf("akamaihd.net") > -1) {
              var Re = Le.match(/segment(\d{9})/);
              if (Re && Re.length === 2) {
                var Oe = parseInt(Re[1]) * Math.round((0, le.toMilliSeconds)(De));
                return new Date(Oe);
              }
            }
            return null;
          }, ke.correctStartOffsetToBounds = function(Le, De) {
            return Le > 0 && Le > De ? De : Le < 0 && Math.abs(Le) > De ? -De : Le;
          }, ke.getImpreciseStartOffsetFromStartOfPlaylist = function(Le) {
            for (var De = Le.start.timeOffset, Re = 0, Oe = 0; Oe < Le.segments.length - 1 && De - Le.segments[Oe + 1].duration > 0; Oe++) {
              var Be = Le.segments[Oe].duration;
              De -= Be, Re += Be;
            }
            return Re;
          }, ke.getImpreciseStartOffsetFromEndOfPlaylist = function(Le) {
            for (var De = Math.abs(Le.start.timeOffset), Re = 0, Oe = Le.segments.length - 1; Oe >= 0 && pe(De, 1) > 0; Oe--)
              De -= Le.segments[Oe].duration, Re += pe(Le.segments[Oe].duration, 2);
            return Le.totalDuration - Re;
          }, ke.getImpreciseStartOffset = function(Le) {
            return Le.start.timeOffset >= 0 ? ke.getImpreciseStartOffsetFromStartOfPlaylist(Le) : ke.getImpreciseStartOffsetFromEndOfPlaylist(Le);
          }, ke.getStartOffsetCloseToPlaylistEnd = function(Le, De) {
            var Re = Le.start.timeOffset;
            return Re = (Re = ke.correctStartOffsetToBounds(Re, Le.totalDuration)) < 0 ? -pe(Math.abs(Re), 2) : pe(Re, 2), Math.max(De, Re);
          }, ke.getStartOffset = function(Le) {
            var De = Le.start.timeOffset;
            return (De = ke.correctStartOffsetToBounds(De, Le.totalDuration)) < 0 && (De += Le.totalDuration), Le.start.precise || (De = ke.getImpreciseStartOffset(Le)), Number(De.toFixed(2));
          }, ke.getBaseUrl = function(Le, De) {
            var Re = Le;
            return Re = se.URLHelper.removeUrlParameters(Re), !(De = se.URLHelper.removeLastPathPart(De)) || De.indexOf("/") < 0 ? Le : se.URLHelper.concatUrlParts(Re, De);
          }, ke;
        }();
        function me(ke, Le) {
          if (!ve.isLive(Le))
            return 1 / 0;
          var De = Le.segments[Le.segments.length - 1];
          if (De !== void 0) {
            if ((0, oe.isPlayingLowLatencyHls)(ke)) {
              var Re = be(Le, De);
              if (Re !== void 0)
                return Re;
            }
            return Math.max(ke.settings.MINIMUM_ALLOWED_UPDATE_PERIOD, De.duration);
          }
          return ke.settings.MINIMUM_ALLOWED_UPDATE_PERIOD;
        }
        function be(ke, Le) {
          var De, Re, Oe = Le.parts;
          return Oe && Oe.length > 0 ? Oe[Oe.length - 1].duration : (Re = (De = ke.partInfo) === null || De === void 0 ? void 0 : De.targetDuration) !== null && Re !== void 0 ? Re : void 0;
        }
        function pe(ke, Le) {
          return Math.floor(ke * Math.pow(10, Le)) / Math.pow(10, Le);
        }
        function $e(ke) {
          var Le, De;
          if (ke)
            return { start: (Le = ke.offset) !== null && Le !== void 0 ? Le : 0, end: ((De = ke.offset) !== null && De !== void 0 ? De : 0) + ke.length - 1 };
        }
        function ye(ke, Le, De, Re, Oe) {
          if (ke.method === ue.HlsEncryptionMethod.NONE)
            return ke;
          var Be = new ArrayBuffer(16);
          return Re !== void 0 && new DataView(Be).setInt32(12, Re + Oe), ae(ae({ iv: Be }, ke), { uri: se.URLHelper.buildAbsoluteUrl(Le, De, ke.uri) });
        }
        function Se(ke) {
          var Le;
          return !((Le = ke == null ? void 0 : ke._hls) === null || Le === void 0) && Le.requestTimestamp ? (0, le.toSeconds)(Date.now() - ke._hls.requestTimestamp) : 1 / 0;
        }
        function we(ke, Le) {
          var De, Re = (De = ke._hls) === null || De === void 0 ? void 0 : De.partTargetDuration;
          return Re ? Re * Le.LL_HLS_MAX_PLAYLIST_AGE_FOR_BLOCKING_REQUEST_IN_PART_TARGET_MULTIPLES : -1;
        }
        function Pe(ke) {
          var Le, De, Re = (Le = ke.SegmentList) === null || Le === void 0 ? void 0 : Le[0].SegmentURL, Oe = Re == null ? void 0 : Re[Re.length - 1], Be = (De = Oe == null ? void 0 : Oe._parts) !== null && De !== void 0 ? De : [];
          if (Oe && Be.length !== 0) {
            if ((Be = Be.filter(function(Ve) {
              return !Ve.isPreloadHint;
            })).length > 0)
              return { mediaSequence: Oe._mediaSequence, partIndex: Be.length - 1 };
            var Fe = Re == null ? void 0 : Re[Re.length - 2];
            if (Fe != null && Fe._parts && Fe._parts.length !== 0)
              return { mediaSequence: Fe._mediaSequence, partIndex: Fe._parts.length - 1 };
          }
        }
        function Te(ke, Le) {
          var De, Re, Oe = !!(!((Re = (De = ke._hls) === null || De === void 0 ? void 0 : De.serverControl) === null || Re === void 0) && Re.canBlockReload), Be = Pe(ke), Fe = Se(ke) <= we(ke, Le);
          return Oe && Be !== void 0 && Fe;
        }
        function Ee(ke) {
          var Le, De, Re = (De = (Le = ke._hls) === null || Le === void 0 ? void 0 : Le.serverControl) === null || De === void 0 ? void 0 : De.canSkipUntil;
          return Re !== void 0 && !(Se(ke) > Re / 2);
        }
        function Me(ke, Le, De) {
          return ke.length === 0 ? 0 : Le.length === 0 ? ke.length : Le[0]._mediaSequence - ke[0]._mediaSequence - De;
        }
        function Ae(ke, Le) {
          if (Le.length !== 0)
            if (ke.length !== 0) {
              var De = ke[ke.length - 1], Re = Le[Le.length - 1]._mediaSequence - De._mediaSequence, Oe = (0, fe.findFromEnd)(Le, function(Ve) {
                return Ve._mediaSequence === De._mediaSequence;
              }), Be = ae(ae({}, De), Oe);
              if (Ue(Be), ke[ke.length - 1] = Be, Re !== 0) {
                var Fe = Le.slice(-Re);
                Fe.forEach(Ue), Ne(Be, Fe, ["_init", "_key"]), De._playbackTime !== void 0 && Ie(Fe, De._playbackTime + De._duration), ke.push.apply(ke, Fe);
              }
            } else
              ke.push.apply(ke, Le);
        }
        function Ne(ke, Le, De) {
          Le.forEach(function(Re) {
            De.forEach(function(Oe) {
              return Ce(Oe, ke, Re);
            });
          });
        }
        function Ce(ke, Le, De) {
          Le[ke] && !De[ke] && (De[ke] = Le[ke]);
        }
        function Ie(ke, Le) {
          var De = Le;
          ke.forEach(function(Re) {
            Re._playbackTime === void 0 && (Re._playbackTime = De), De = Re._playbackTime + Re._duration;
          });
        }
        function xe(ke) {
          return ke.skippedSegmentsCount > 0;
        }
        function Ue(ke) {
          var Le;
          ke._media = (0, _e.forceReallocation)(ke._media), (Le = ke._metadata) === null || Le === void 0 || Le.forEach(function(De) {
            return (0, ce.forceReallocateStringProps)(De);
          });
        }
        ie.PlaylistUtils = ve;
      }, 52080: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.StartTimeExtrapolationDirection = void 0, ie.extrapolateStartTime = se, ie.forwardExtrapolateSegmentStartTime = oe, ie.backwardExtrapolateSegmentStartTime = ce, ie.getStartTimeExtrapolationReferencePoint = he, ie.getStartTimeViaDiscontinuityBoundaries = ge, ie.findDiscontinuityBoundary = ve, ie.hasDiscontinuityBoundary = me;
        var ae, ue = ne(42055), _e = ne(81361), fe = ne(331), le = ne(93326);
        function se(be, pe, $e) {
          $e === void 0 && ($e = ae.Bidirectional), $e === ae.Backward ? ce(be, pe) : ($e === ae.Forward || ce(be, pe), oe(be, pe));
        }
        function oe(be, pe) {
          var $e = pe.index, ye = pe.startTime;
          be[$e].startTime = ye;
          for (var Se = $e + 1; Se < be.length; Se++)
            be[Se].startTime = be[Se - 1].startTime + be[Se - 1].duration;
        }
        function ce(be, pe) {
          var $e = pe.index, ye = pe.startTime;
          be[$e].startTime = ye;
          for (var Se = $e - 1; Se >= 0; Se--)
            be[Se].startTime = be[Se + 1].startTime - be[Se].duration;
        }
        function he(be, pe, $e) {
          var ye, Se;
          if (pe.endList)
            return { index: 0, startTime: (0, ue.getStartTimeOffset)($e) };
          var we = be.segmentInfos[0];
          if (we != null && we.dateTime)
            return { index: 0, startTime: (0, fe.toSeconds)(we.dateTime.getTime()) };
          var Pe = (0, le.getMostRecentlyRefreshedQuality)($e);
          if (Pe) {
            var Te = ge(be, Pe);
            if (Te)
              return Te;
          }
          return { index: 0, startTime: (Se = (ye = Pe == null ? void 0 : Pe.segmentInfos[0]) === null || ye === void 0 ? void 0 : ye.startTime) !== null && Se !== void 0 ? Se : (0, fe.toSeconds)(pe.requestTimestamp) - pe.totalDuration };
        }
        function ge(be, pe) {
          if (me(be.segmentInfos) && me(pe.segmentInfos)) {
            var $e = pe.segmentInfos[pe.segmentInfos.length - 1], ye = ve(pe.segmentInfos, $e.discontinuitySequenceNumber), Se = pe.segmentInfos[ye], we = ve(be.segmentInfos, Se.discontinuitySequenceNumber);
            if (we != null)
              return { index: we, startTime: Se.startTime };
          }
        }
        function ve(be, pe) {
          return me(be) ? (0, _e.findIndexFromEnd)(be, function($e) {
            return !!$e.isDiscontinuityStart && $e.discontinuitySequenceNumber === pe;
          }) : -1;
        }
        function me(be) {
          if (!be.length)
            return !1;
          if (be[0].isDiscontinuityStart)
            return !0;
          var pe = be[0], $e = be[be.length - 1];
          return pe.discontinuitySequenceNumber !== $e.discontinuitySequenceNumber;
        }
        (function(be) {
          be.Backward = "backward", be.Forward = "forward", be.Bidirectional = "Bidirectional";
        })(ae || (ie.StartTimeExtrapolationDirection = ae = {}));
      }, 4383: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.WebWorkerParser = void 0;
        var ae = function() {
          function ue(_e) {
            var fe = this;
            this.isParsing = !1, this.jobQueue = [], this.onWorkerMessage = function(se) {
              var oe = se.data;
              if (["parsedPlaylist", "error"].includes(oe.action) && fe.jobQueue.length !== 0) {
                var ce = fe.jobQueue.shift();
                if (oe.action === "error" && (ce == null || ce.rejectFn(oe.data)), oe.action === "parsedPlaylist" && (ce == null || ce.resolveFn(oe.data)), fe.jobQueue.length > 0) {
                  var he = fe.jobQueue[0];
                  fe.parsingWorker.postMessage(he.message);
                } else
                  fe.isParsing = !1;
              }
            };
            try {
              var le = ne(80211);
              this.parsingWorker = new le(), this.parsingWorker.onmessage = this.onWorkerMessage;
            } catch (se) {
              _e.warn("WebWorkerParser: Could not create web worker", se);
            }
          }
          return ue.prototype.parsePlaylist = function(_e, fe) {
            var le = this;
            return new Promise(function(se, oe) {
              var ce = { action: "parseHlsPlaylist", payload: { data: _e, options: fe } };
              le.jobQueue.push({ resolveFn: se, rejectFn: oe, message: ce }), le.isParsing || (le.isParsing = !0, le.parsingWorker.postMessage(ce));
            });
          }, ue.getInstance = function(_e) {
            return ue.instance || (ue.instance = new ue(_e)), ue.instance;
          }, ue.instance = null, ue;
        }();
        ie.WebWorkerParser = ae;
      }, 72927: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.forceReallocateStringProps = ue;
        var ae = ne(91397);
        function ue(_e) {
          Object.keys(_e).forEach(function(fe) {
            typeof _e[fe] == "string" && (_e[fe] = (0, ae.forceReallocation)(_e[fe])), typeof _e[fe] == "object" && ue(_e[fe]);
          });
        }
      }, 97662: function(ee, ie) {
        function ne(ae) {
          return ae.reduce(function(ue, _e, fe, le) {
            var se = _e._discontinuitySequenceNumber, oe = _e._playbackTime;
            if (ue.discoTimings[se] === void 0) {
              ue.discoTimings[se] = { startTime: oe, endTime: 1 / 0 };
              var ce = ue.discoTimings[se - 1];
              ce && (ce.endTime = oe);
            }
            return fe === le.length - 1 && (ue.discoTimings[se].endTime = oe + _e._duration), ue.totalDuration += _e._duration, ue;
          }, { totalDuration: 0, discoTimings: {} });
        }
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getTimingInfoFromSegmentList = ne;
      }, 47967: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Oe) {
            for (var Be, Fe = 1, Ve = arguments.length; Fe < Ve; Fe++)
              for (var Ke in Be = arguments[Fe])
                Object.prototype.hasOwnProperty.call(Be, Ke) && (Oe[Ke] = Be[Ke]);
            return Oe;
          }, ae.apply(this, arguments);
        }, ue = this && this.__spreadArray || function(Oe, Be, Fe) {
          if (Fe || arguments.length === 2)
            for (var Ve, Ke = 0, Ze = Be.length; Ke < Ze; Ke++)
              !Ve && Ke in Be || (Ve || (Ve = Array.prototype.slice.call(Be, 0, Ke)), Ve[Ke] = Be[Ke]);
          return Oe.concat(Ve || Array.prototype.slice.call(Be));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.generateRendition = se, ie.generateStartAttributes = oe, ie.generatePartInfoTag = ce, ie.generateServerControlTag = he, ie.generateSkipTag = ge, ie.generatePartTag = ve, ie.generatePreloadHintTag = be, ie.generateStreamInfTag = pe, ie.generateVariantPlaylistId = $e, ie.generateSessionKeyTag = ye, ie.generateIFrameStreamInfTag = Se, ie.generateSegmentEntrySkeleton = we, ie.generateCueTag = Pe, ie.generateDateRange = Te, ie.generateKeyTag = Ee, ie.generateByteRangeTag = Me, ie.generateMapTag = Ae, ie.generateCustomTag = De;
        var _e = ne(62510), fe = ne(91397), le = ne(56093);
        function se(Oe) {
          var Be, Fe, Ve;
          return { name: Oe.name, attributes: ae(ae({}, Oe.attributes), { TYPE: (Be = Oe.attributes) === null || Be === void 0 ? void 0 : Be.TYPE, "GROUP-ID": (Fe = Oe.attributes) === null || Fe === void 0 ? void 0 : Fe["GROUP-ID"], NAME: (Ve = Oe.attributes) === null || Ve === void 0 ? void 0 : Ve.NAME }) };
        }
        function oe(Oe) {
          var Be, Fe;
          return !((Be = Oe.attributes) === null || Be === void 0) && Be.hasOwnProperty("TIME-OFFSET") && (Fe = { timeOffset: Number(Oe.attributes["TIME-OFFSET"]), precise: Oe.attributes.PRECISE === "YES" }), Oe.attributes && Fe && Fe.hasOwnProperty("timeOffset") && (Oe.attributes["TIME-OFFSET"] = Fe.timeOffset, Oe.attributes.PRECISE = Fe.precise), Fe;
        }
        function ce(Oe) {
          return { targetDuration: parseFloat(Oe["PART-TARGET"]) };
        }
        function he(Oe) {
          var Be = { canBlockReload: !1 };
          return Oe.attributes && (Oe.attributes["CAN-SKIP-UNTIL"] && (Be.canSkipUntil = parseFloat(Oe.attributes["CAN-SKIP-UNTIL"])), Be.canSkipUntil !== void 0 && Oe.attributes["CAN-SKIP-DATERANGES"] && (Be.canSkipDateRanges = Oe.attributes["CAN-SKIP-DATERANGES"] === "YES"), Oe.attributes["HOLD-BACK"] && (Be.holdBack = parseFloat(Oe.attributes["HOLD-BACK"])), Oe.attributes["PART-HOLD-BACK"] && (Be.partHoldBack = parseFloat(Oe.attributes["PART-HOLD-BACK"])), Oe.attributes["CAN-BLOCK-RELOAD"] && (Be.canBlockReload = Oe.attributes["CAN-BLOCK-RELOAD"] === "YES")), Be;
        }
        function ge(Oe) {
          var Be = { skippedSegments: 0, recentlyRemovedDateranges: [] };
          return Oe.attributes && (Oe.attributes["SKIPPED-SEGMENTS"] && (Be.skippedSegments = parseInt(Oe.attributes["SKIPPED-SEGMENTS"])), Oe.attributes["RECENTLY-REMOVED-DATERANGES"] && (Be.recentlyRemovedDateranges = Oe.attributes["RECENTLY-REMOVED-DATERANGES"].split("	"))), Be;
        }
        function ve(Oe, Be) {
          var Fe = { uri: (0, fe.forceReallocation)(Oe.URI), duration: parseFloat(Oe.DURATION) };
          if (Oe.INDEPENDENT === "YES" && (Fe.independent = !0), Oe.BYTERANGE) {
            var Ve = Oe.BYTERANGE.split("@"), Ke = parseInt(Ve[0]), Ze = parseInt(Ve[1]);
            isNaN(Ze) && (Ze = Be != null && Be.byteRange ? Be.byteRange.end + 1 : 0), Fe.byteRange = { start: Ze, end: Ze + Ke - 1 };
          }
          return Oe.GAP === "YES" && (Fe.gap = !0), Fe;
        }
        function me(Oe) {
          var Be = parseInt(Oe["BYTERANGE-START"]), Fe = parseInt(Oe["BYTERANGE-END"]);
          if (!isNaN(Be) || !isNaN(Fe))
            return { start: isNaN(Be) ? 0 : Be, end: isNaN(Fe) ? Math.pow(2, 53) - 1 : Fe };
        }
        function be(Oe, Be) {
          if (Oe.TYPE === "PART") {
            var Fe = { uri: (0, fe.forceReallocation)(Oe.URI), duration: Be, isPreloadHint: !0 };
            return (Ve = me(Oe)) && (Fe.byteRange = Ve), { part: Fe };
          }
          if (Oe.TYPE === "MAP") {
            var Ve, Ke = { url: (0, fe.forceReallocation)(Oe.URI) };
            return (Ve = me(Oe)) && (Ke.byteRange = Ve), { init: Ke };
          }
          return {};
        }
        function pe(Oe, Be) {
          var Fe, Ve, Ke, Ze, nt, Qe = { name: Oe.name, uri: Be, attributes: ae(ae({}, Oe.attributes), { BANDWIDTH: (Fe = Oe.attributes) === null || Fe === void 0 ? void 0 : Fe.BANDWIDTH }) };
          return !((Ve = Oe.attributes) === null || Ve === void 0) && Ve.RESOLUTION && (Qe.attributes.RESOLUTION = Ce(Oe)), !((Ke = Oe.attributes) === null || Ke === void 0) && Ke.BANDWIDTH && (Qe.attributes.BANDWIDTH = parseInt(Oe.attributes.BANDWIDTH)), !((Ze = Oe.attributes) === null || Ze === void 0) && Ze["AVERAGE-BANDWIDTH"] && (Qe.attributes["AVERAGE-BANDWIDTH"] = parseInt(Oe.attributes["AVERAGE-BANDWIDTH"])), !((nt = Oe.attributes) === null || nt === void 0) && nt["PROGRAM-ID"] && (Qe.attributes["PROGRAM-ID"] = parseInt(Oe.attributes["PROGRAM-ID"])), Qe.id = $e(Qe.attributes), Qe;
        }
        function $e(Oe) {
          var Be = "";
          return Oe.RESOLUTION && (Be += Oe.RESOLUTION.height + "_"), Be += Oe.BANDWIDTH;
        }
        function ye(Oe) {
          Ne(Oe);
        }
        function Se(Oe) {
          var Be, Fe, Ve;
          !((Be = Oe.attributes) === null || Be === void 0) && Be.BANDWIDTH && (Oe.attributes.BANDWIDTH = parseInt(Oe.attributes.BANDWIDTH)), !((Fe = Oe.attributes) === null || Fe === void 0) && Fe["AVERAGE-BANDWIDTH"] && (Oe.attributes["AVERAGE-BANDWIDTH"] = parseInt(Oe.attributes["AVERAGE-BANDWIDTH"], 10)), !((Ve = Oe.attributes) === null || Ve === void 0) && Ve.RESOLUTION && (Oe.attributes.RESOLUTION = Ce(Oe));
        }
        function we() {
          return { uri: "", duration: 0, mediaSequence: 0 };
        }
        function Pe(Oe, Be) {
          var Fe = { type: Be };
          if (Oe.attributes) {
            var Ve = [];
            for (var Ke in Oe.attributes)
              if (Oe.attributes.hasOwnProperty(Ke)) {
                var Ze = Oe.attributes[Ke] ? "".concat(Ke, "=").concat(Oe.attributes[Ke]) : Ke;
                Ve.push(Ze);
              }
            Fe.attributes = Ve;
          }
          return Fe;
        }
        function Te(Oe) {
          var Be = { type: _e.MetadataType.DATERANGE };
          if (Oe.attributes) {
            Be.clientAttributes = {};
            var Fe = Oe.attributes;
            for (var Ve in Fe)
              if (Fe.hasOwnProperty(Ve))
                if (Ve.startsWith("X-")) {
                  var Ke = 2;
                  Be.clientAttributes[(0, fe.kebabCaseToCamelCase)(Ve.substring(Ke))] = Fe[Ve];
                } else
                  Be[(0, fe.kebabCaseToCamelCase)(Ve)] = Fe[Ve];
          }
          return Be.duration && (Be.duration = Number(Be.duration)), Be.plannedDuration && (Be.plannedDuration = Number(Be.plannedDuration)), Be.endOnNext && (Be.endOnNext = !0), Be;
        }
        function Ee(Oe) {
          if (Ne(Oe), Oe.attributes && Oe.attributes.METHOD !== "NONE" && Oe.attributes.URI) {
            var Be = { method: (0, fe.forceReallocation)(Oe.attributes.METHOD) || "AES-128", uri: (0, fe.forceReallocation)(Oe.attributes.URI) };
            return Oe.attributes.IV !== void 0 && (Be.iv = Oe.attributes.IV), Oe.attributes.KEYFORMAT && (Be.keyformat = (0, fe.forceReallocation)(Oe.attributes.KEYFORMAT)), Oe.attributes.KEYFORMATVERSIONS && (Be.keyformatversions = (0, fe.forceReallocation)(Oe.attributes.KEYFORMATVERSIONS)), Oe.attributes.KEYID && (Be.keyid = (0, fe.forceReallocation)(Oe.attributes.KEYID)), Be;
          }
        }
        function Me(Oe, Be) {
          var Fe;
          if (Oe.value) {
            var Ve = Oe.value.split("@"), Ke = Ve[0], Ze = Ve[1], nt = { length: parseInt(Ke || "0") };
            if (Ze)
              nt.offset = parseInt(Ze);
            else {
              var Qe = Be[Be.length - 1];
              Qe != null && Qe.byterange && (nt.offset = ((Fe = Qe.byterange.offset) !== null && Fe !== void 0 ? Fe : 0) + Qe.byterange.length);
            }
            return nt;
          }
        }
        function Ae(Oe, Be) {
          var Fe, Ve;
          if (!((Fe = Oe.attributes) === null || Fe === void 0) && Fe.URI) {
            var Ke = { url: (0, fe.forceReallocation)(Oe.attributes.URI) };
            if (!((Ve = Oe.attributes) === null || Ve === void 0) && Ve.BYTERANGE) {
              var Ze = Oe.attributes.BYTERANGE.split("@"), nt = Ze[0], Qe = Ze[1];
              Ke.byteRange = { start: parseInt(Qe), end: parseInt(Qe) + parseInt(nt) - 1 };
            }
            return Be.keys.length > 0 && (Ke.keys = ue([], Be.keys, !0), Be.keyInUse = !0), Ke;
          }
        }
        function Ne(Oe) {
          var Be;
          if (!((Be = Oe.attributes) === null || Be === void 0) && Be.IV) {
            Oe.attributes.IV = Oe.attributes.IV.toLowerCase();
            var Fe = 2;
            Oe.attributes.IV.substring(0, Fe) === "0x" && (Oe.attributes.IV = Oe.attributes.IV.substring(Fe)), Oe.attributes.IV = new Uint8Array(le.FormatHelper.hexToBytes(Oe.attributes.IV)).buffer;
          }
        }
        function Ce(Oe) {
          var Be, Fe = { width: 0, height: 0 }, Ve = (Be = Oe.attributes) === null || Be === void 0 ? void 0 : Be.RESOLUTION.split("x");
          return Ve[0] && (Fe.width = parseInt(Ve[0])), Ve[1] && (Fe.height = parseInt(Ve[1])), Fe;
        }
        var Ie = /(?:^|,)((?:[^=]*)=(?:"[^"]*"|[^,]*))/, xe = /([^=]*)=(.*)/, Ue = /^['"](.*)['"]$/, ke = /^['"](.*)['"]$/g, Le = /^([^:="]*)([:=])?(.*)$/;
        function De(Oe) {
          try {
            Oe = (0, fe.forceReallocation)(Oe);
            var Be = /^#([^:=]*)([:=])?(.*)$/.exec(Oe);
            if (!(Be != null && Be[1]))
              return;
            var Fe = { name: Be[1] }, Ve = "";
            if (Be[2] === "=" && Be[3])
              Ve = Be[3];
            else if (Be[2] === ":" && Be[3]) {
              var Ke = Le.exec(Be[3]);
              Ke && Ke[2] === "=" && Ke[3] ? Fe.attributes = Re(Be[3]) : Ve = Be[3];
            }
            return Ve && (Fe.value = Ve.replace(ke, "$1")), Fe;
          } catch {
            return;
          }
        }
        function Re(Oe) {
          for (var Be = Oe.split(Ie), Fe = Be.length, Ve = {}; Fe--; )
            if (Be[Fe] !== "") {
              var Ke = xe.exec(Be[Fe]);
              if (Ke) {
                var Ze = Ke.slice(1), nt = Ze[0], Qe = Ze[1];
                Ve[nt.trim()] = Qe.trim().replace(Ue, "$1");
              }
            }
          return Ve;
        }
      }, 27485: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.TextParser = void 0;
        var ne = /[ \t]+/gm, ae = function() {
          function ue(_e) {
            this.data = _e, this.position = 0;
          }
          return ue.prototype.isAtEnd = function() {
            return this.position === this.data.length;
          }, ue.prototype.skipWhitespace = function() {
            this.readRegex(ne);
          }, ue.prototype.readRegex = function(_e) {
            var fe = this.indexOf(_e);
            if (!this.isAtEnd() && fe !== void 0 && fe.position === this.position)
              return this.position += fe.length, fe.results;
          }, ue.prototype.indexOf = function(_e) {
            _e.lastIndex = this.position;
            var fe = _e.exec(this.data);
            if (fe !== null)
              return { position: fe.index, length: fe[0].length, results: fe };
          }, ue;
        }();
        ie.TextParser = ae;
      }, 59692: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.parsePlaylist = ce;
        var ae, ue = ne(56461), _e = ne(52600), fe = ne(55877), le = ne(47967), se = /\r\n|\r(?=[^\n]|$)/gm, oe = /^#EXTM3U($|[ \t\n])/m;
        function ce(ge, ve) {
          ve === void 0 && (ve = {});
          var me = ge.indexOf("#EXTINF") === -1 ? ae.Master : ae.Media, be = ge.replace(se, `
`).trim().split(/\n+/m), pe = (0, ue.removeTrailingWhitespaces)(be[0]);
          if (!oe.test(pe))
            throw new Error("Playlist parsing failed: missing #EXTM3U tag");
          if (me === ae.Media)
            return (0, fe.parseVariant)(be, ve);
          for (var $e, ye = [], Se = [], we = [], Pe = 1, Te = !0, Ee = !1, Me = !0, Ae = 0; Ae < be.length; Ae++) {
            var Ne = (0, ue.removeTrailingWhitespaces)(be[Ae]), Ce = be[Ae + 1];
            if ((0, ue.isCustomTag)(Ne))
              he(ye, Ne);
            else if (Me)
              Me = !1;
            else {
              var Ie = (0, _e.parseTag)(Ne);
              switch (Ie.name) {
                case "EXT-X-STREAM-INF":
                  we.push((0, le.generateStreamInfTag)(Ie, (0, ue.removeTrailingWhitespaces)(Ce))), Me = !0;
                  break;
                case "EXT-X-MEDIA":
                  var xe = (0, le.generateRendition)(Ie);
                  Se.push(xe), ye.push(xe);
                  break;
                case "EXT-X-VERSION":
                  Pe = Number(Ie.value);
                  break;
                case "EXT-X-START":
                  $e = (0, le.generateStartAttributes)(Ie), ye.push(Ie);
                  break;
                case "EXT-X-ALLOW-CACHE":
                  Te = Ie.value === "YES" || Ie.value === void 0;
                  break;
                case "EXT-X-INDEPENDENT-SEGMENTS":
                  Ee = !0, ye.push(Ie);
                  break;
                case "EXT-X-I-FRAME-STREAM-INF":
                  (0, le.generateIFrameStreamInfTag)(Ie), ye.push(Ie);
                  break;
                case "EXT-X-SESSION-DATA":
                default:
                  ye.push(Ie);
                  break;
                case "EXT-X-SESSION-KEY":
                  (0, le.generateSessionKeyTag)(Ie), ye.push(Ie);
              }
            }
          }
          var Ue = { version: Pe, allowCache: Te, independentSegments: Ee, hasM3u: !0, media: Se, playlists: we, tags: ye = ye.concat(we) };
          return $e && (Ue.start = $e), Ue;
        }
        function he(ge, ve) {
          var me = (0, le.generateCustomTag)(ve);
          me && ge.push(me);
        }
        (function(ge) {
          ge.Master = "master", ge.Media = "media";
        })(ae || (ae = {}));
      }, 56461: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ee) {
            for (var Me, Ae = 1, Ne = arguments.length; Ae < Ne; Ae++)
              for (var Ce in Me = arguments[Ae])
                Object.prototype.hasOwnProperty.call(Me, Ce) && (Ee[Ce] = Me[Ce]);
            return Ee;
          }, ae.apply(this, arguments);
        }, ue = this && this.__spreadArray || function(Ee, Me, Ae) {
          if (Ae || arguments.length === 2)
            for (var Ne, Ce = 0, Ie = Me.length; Ce < Ie; Ce++)
              !Ne && Ce in Me || (Ne || (Ne = Array.prototype.slice.call(Me, 0, Ce)), Ne[Ce] = Me[Ce]);
          return Ee.concat(Ne || Array.prototype.slice.call(Me));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.parseSegments = he, ie.addCustomTagToPlaylistTagList = ge, ie.handleCustomTag = ve, ie.removeTrailingWhitespaces = Pe, ie.isCustomTag = Te;
        var _e = ne(52442), fe = ne(62510), le = ne(67550), se = ne(52600), oe = ne(55877), ce = ne(47967);
        function he(Ee, Me, Ae, Ne) {
          Ne === void 0 && (Ne = {});
          for (var Ce, Ie = [], xe = 0, Ue = (0, ce.generateSegmentEntrySkeleton)(), ke = ue([], Me, !0), Le = 0, De = Ae.mediaSequence, Re = { keys: [], keyInUse: !1 }, Oe = function() {
            Ue = (0, ce.generateSegmentEntrySkeleton)(), ke = [], Le = 0;
          }, Be = function(nt) {
            me(Ue, Le, nt, Ce, Re, ke, De), Ie.push(Ue), xe += Le, De++, Oe();
          }, Fe = function(nt) {
            var Qe, qe, ze = (0, se.parseTag)(nt);
            switch (ze.name) {
              case "EXTINF":
                Le = parseFloat(ze.value);
                break;
              case "EXT-X-BYTERANGE":
                Ue.byterange = (0, ce.generateByteRangeTag)(ze, Ie);
                break;
              case "EXT-X-DISCONTINUITY":
                Ue.discontinuity = !0;
                break;
              case "EXT-X-PROGRAM-DATE-TIME":
                pe(Ue, ze);
                break;
              case "EXT-X-KEY":
                if (((Qe = ze.attributes) === null || Qe === void 0 ? void 0 : Qe.METHOD) === "NONE") {
                  Re.keys = [{ method: _e.HlsEncryptionMethod.NONE }];
                  break;
                }
                be(ze, Re);
                break;
              case "EXT-X-MAP":
                Ce = (0, ce.generateMapTag)(ze, Re);
                break;
              case "EXT-X-DATERANGE":
                $e(Ue, ze);
                break;
              case "EXT-X-CUE-OUT-CONT":
                Ue.cueTag = (0, ce.generateCueTag)(ze, "CUE-OUT-CONT");
                break;
              case "EXT-X-CUE-OUT":
                Ue.cueTag = (0, ce.generateCueTag)(ze, "CUE-OUT");
                break;
              case "EXT-X-CUE-IN":
                Ue.cueTag = (0, ce.generateCueTag)(ze, "CUE-IN");
                break;
              case "EXT-X-SCTE35":
                ye(Ue, ze);
                break;
              case "EXT-X-PART":
                Se(ze, Ue, Ne);
                break;
              case "EXT-X-PRELOAD-HINT":
                var je = we(ze, Ae.partInfo, Ne);
                je.init && (Ce = je.init, Re.keys.length > 0 && (Ce.keys = ue([], Re.keys, !0), Re.keyInUse = !0)), je.part && (Ue.parts = (qe = Ue.parts) !== null && qe !== void 0 ? qe : [], Ue.parts.push(je.part));
                break;
              case "EXT-X-SKIP":
                var tt = (0, ce.generateSkipTag)(ze);
                Ae.skippedSegmentsCount = tt.skippedSegments, De += tt.skippedSegments;
                break;
              case "EXT-X-ENDLIST":
                Ae.endList = !0;
                break;
              default:
                (0, oe.resolvePlaylistTag)(Ae, ze, ke);
            }
          }, Ve = 0, Ke = Ee; Ve < Ke.length; Ve++) {
            var Ze = Pe(Ke[Ve]);
            Ze !== "" && (Ze.startsWith("#") ? Te(Ze) ? ve(Ae, ke, Ze) : Fe(Ze) : Be(Ze));
          }
          Ue.parts && Ue.parts.length > 0 && (Le = Ue.parts.reduce(function(nt, Qe) {
            return nt + Qe.duration;
          }, 0), Be(le.PHANTOM_SEGMENT_URL)), Ae.segments = Ie, Ae.totalDuration = xe;
        }
        function ge(Ee, Me) {
          Ee.tags === void 0 && (Ee.tags = []), Me && Ee.tags.push(Me);
        }
        function ve(Ee, Me, Ae) {
          Me.push({ type: fe.MetadataType.CUSTOM, attributes: Ae }), ge(Ee, (0, ce.generateCustomTag)(Ae));
        }
        function me(Ee, Me, Ae, Ne, Ce, Ie, xe) {
          Ee.duration = Me, Ee.uri = Ae, Ee.mediaSequence = xe, Ne && (Ee.init = Ne), Ie.length > 0 && (Ee.customTags = Ie), Ce.keys.length > 0 && (Ee.keys = ue([], Ce.keys, !0), Ce.keyInUse = !0);
        }
        function be(Ee, Me) {
          Me.keyInUse && (Me.keys = [], Me.keyInUse = !1);
          var Ae = (0, ce.generateKeyTag)(Ee);
          Ae !== void 0 && Me.keys.push(Ae);
        }
        function pe(Ee, Me) {
          Me.value && (Ee.dateTime = new Date(Me.value));
        }
        function $e(Ee, Me) {
          Ee.dateRange === void 0 && (Ee.dateRange = []), Ee.dateRange.push((0, ce.generateDateRange)(Me));
        }
        function ye(Ee, Me) {
          var Ae;
          Ee.scte35 === void 0 && (Ee.scte35 = []), Ee.scte35.push({ type: fe.MetadataType.SCTE, attributes: ae({ CUE: (Ae = Me.attributes) === null || Ae === void 0 ? void 0 : Ae.CUE }, Me.attributes) });
        }
        function Se(Ee, Me, Ae) {
          var Ne;
          if (Ae.parsePartTags) {
            Me.parts = (Ne = Me.parts) !== null && Ne !== void 0 ? Ne : [];
            var Ce = Me.parts[Me.parts.length - 1];
            Me.parts.push((0, ce.generatePartTag)(Ee.attributes, Ce));
          }
        }
        function we(Ee, Me, Ae) {
          return Ae.parsePartTags && Me ? (0, ce.generatePreloadHintTag)(Ee.attributes, Me.targetDuration) : {};
        }
        function Pe(Ee) {
          return Ee.replace(/^[ \t]+/g, "");
        }
        function Te(Ee) {
          return /^#(?!EXT)/m.test(Ee);
        }
      }, 52600: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.parseTag = le;
        var ae = ne(27485), ue = /^#(EXT[^:]*)(?::(.*))?$/, _e = /^(?:"([^"]*)"|([^,=]+))(?:,|$)/g, fe = /([^=]+)=*(?:"([^"]*)"|([^",]*))(?:,|$)/g;
        function le(se) {
          var oe, ce = ue.exec(se);
          if (!ce)
            throw new Error("Invalid tag " + se);
          var he, ge = ce[1], ve = ce[2], me = {};
          if (ve) {
            var be = new ae.TextParser(ve), pe = void 0, $e = be.readRegex(_e);
            for ($e && (he = (oe = $e[1]) !== null && oe !== void 0 ? oe : $e[2]); pe = be.readRegex(fe); ) {
              var ye = pe[1], Se = pe[2] || pe[3];
              if (ye.includes(",")) {
                var we = ye.split(","), Pe = we[0];
                ye = we[1].trim(), me[Pe] = void 0;
              }
              me[ye] = Se, be.skipWhitespace();
            }
          }
          return { name: ge, attributes: me, value: he };
        }
      }, 55877: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(he) {
            for (var ge, ve = 1, me = arguments.length; ve < me; ve++)
              for (var be in ge = arguments[ve])
                Object.prototype.hasOwnProperty.call(ge, be) && (he[be] = ge[be]);
            return he;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SEGMENT_TAGS = void 0, ie.parseVariant = se, ie.resolvePlaylistTag = ce;
        var ue = ne(62510), _e = ne(56461), fe = ne(52600), le = ne(47967);
        function se(he, ge) {
          ge === void 0 && (ge = {});
          for (var ve = { version: 1, allowCache: !0, hasM3u: !0, endList: !1, segments: [], skippedSegmentsCount: 0, targetDuration: 0, totalDuration: 0, mediaSequence: 0 }, me = [], be = 0; be < he.length; be++) {
            var pe = (0, _e.removeTrailingWhitespaces)(he[be]);
            if (pe !== "")
              if ((0, _e.isCustomTag)(pe))
                (0, _e.handleCustomTag)(ve, me, pe);
              else {
                var $e = (0, fe.parseTag)(pe);
                if (ie.SEGMENT_TAGS.includes($e.name))
                  return (0, _e.parseSegments)(he.slice(be), me, ve, ge), oe(ve), ve;
                ce(ve, $e, me);
              }
          }
          return oe(ve), ve;
        }
        function oe(he) {
          var ge;
          he.playlistType === "EVENT" && (he.discontinuitySequence = (ge = he.discontinuitySequence) !== null && ge !== void 0 ? ge : 0);
        }
        function ce(he, ge, ve) {
          switch (ge.name) {
            case "EXT-X-VERSION":
              he.version = Number(ge.value);
              break;
            case "EXT-X-START":
              he.start = (0, le.generateStartAttributes)(ge);
              break;
            case "EXT-X-INDEPENDENT-SEGMENTS":
              he.independentSegments = !0;
              break;
            case "EXT-X-TARGETDURATION":
              ge.value && (he.targetDuration = parseInt(ge.value));
              break;
            case "EXT-X-MEDIA-SEQUENCE":
              ge.value && (he.mediaSequence = parseInt(ge.value));
              break;
            case "EXT-X-DISCONTINUITY-SEQUENCE":
              ge.value && (he.discontinuitySequence = parseInt(ge.value));
              break;
            case "EXT-X-PLAYLIST-TYPE":
              he.playlistType = ge.value === "EVENT" ? "EVENT" : "VOD";
              break;
            case "EXT-X-PART-INF":
              he.partInfo = (0, le.generatePartInfoTag)(ge.attributes);
              break;
            case "EXT-X-ALLOW-CACHE":
              he.allowCache = ge.value !== "NO";
              break;
            case "EXT-X-SERVER-CONTROL":
              he.serverControl = (0, le.generateServerControlTag)(ge);
              break;
            case "EXTM3U":
              break;
            default:
              ve.push(ae({ type: ue.MetadataType.CUSTOM }, ge)), (0, _e.addCustomTagToPlaylistTagList)(he, ge);
          }
        }
        ie.SEGMENT_TAGS = ["EXTINF", "EXT-X-BYTERANGE", "EXT-X-DISCONTINUITY", "EXT-X-PROGRAM-DATE-TIME", "EXT-X-KEY", "EXT-X-GAP", "EXT-X-BITRATE", "EXT-X-PART", "EXT-X-DATERANGE", "EXT-X-MAP", "EXT-X-CUE-OUT-CONT", "EXT-X-CUE-OUT", "EXT-X-CUE-IN", "EXT-X-SCTE35", "EXT-X-DATERANGE", "EXT-X-SKIP"];
      }, 79367: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.setContentLocationId = ie.setTimestampRolloverPositions = ie.setPresentationTimeOffset = ie.setDiscoTimings = ie.setCustomTags = ie.setDefaultLanguages = ie.setEndlist = ie.setIsLowLatencyPlaylist = ie.setPlaylistType = ie.setMasterPlaylistString = void 0;
        var ae = ne(15231), ue = ne(90993), _e = function(be) {
          return (0, ae.createAction)(ue.HlsActionType.SetMasterPlaylistString, be);
        };
        ie.setMasterPlaylistString = _e;
        var fe = function(be) {
          return (0, ae.createAction)(ue.HlsActionType.SetPlaylistType, be);
        };
        ie.setPlaylistType = fe;
        var le = function(be) {
          return (0, ae.createAction)(ue.HlsActionType.SetIsLowLatencyPlaylist, be);
        };
        ie.setIsLowLatencyPlaylist = le;
        var se = function(be) {
          return (0, ae.createAction)(ue.HlsActionType.SetEndlist, be);
        };
        ie.setEndlist = se;
        var oe = function(be) {
          return (0, ae.createAction)(ue.HlsActionType.SetDefaultLanguages, be);
        };
        ie.setDefaultLanguages = oe;
        var ce = function(be) {
          return (0, ae.createAction)(ue.HlsActionType.SetCustomTags, be);
        };
        ie.setCustomTags = ce;
        var he = function(be, pe) {
          return (0, ae.createAction)(ue.HlsActionType.SetDiscoTimings, { mimeType: be, discoTimings: pe });
        };
        ie.setDiscoTimings = he;
        var ge = function(be, pe) {
          return (0, ae.createAction)(ue.HlsActionType.SetPresentationTimeOffset, { discoSequenceNumber: be, presentationTimeOffset: pe });
        };
        ie.setPresentationTimeOffset = ge;
        var ve = function(be, pe) {
          return (0, ae.createAction)(ue.HlsActionType.SetTimestampRolloverPositions, { next: be, previous: pe });
        };
        ie.setTimestampRolloverPositions = ve;
        var me = function(be) {
          return (0, ae.createAction)(ue.HlsActionType.SetContentLocationId, { locationId: be });
        };
        ie.setContentLocationId = me;
      }, 78148: function(ee, ie, ne) {
        var ae, ue = this && this.__assign || function() {
          return ue = Object.assign || function(Te) {
            for (var Ee, Me = 1, Ae = arguments.length; Me < Ae; Me++)
              for (var Ne in Ee = arguments[Me])
                Object.prototype.hasOwnProperty.call(Ee, Ne) && (Te[Ne] = Ee[Ne]);
            return Te;
          }, ue.apply(this, arguments);
        }, _e = this && this.__spreadArray || function(Te, Ee, Me) {
          if (Me || arguments.length === 2)
            for (var Ae, Ne = 0, Ce = Ee.length; Ne < Ce; Ne++)
              !Ae && Ne in Ee || (Ae || (Ae = Array.prototype.slice.call(Ee, 0, Ne)), Ae[Ne] = Ee[Ne]);
          return Te.concat(Ae || Array.prototype.slice.call(Ee));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.HlsReducer = void 0, ie.extrapolateSegmentStartTime = Se;
        var fe = ne(21829), le = ne(90993);
        function se(Te, Ee) {
          return Te.masterPlaylist.string ? Te : ue(ue({}, Te), { masterPlaylist: { string: Ee } });
        }
        function oe(Te, Ee) {
          return ue(ue({}, Te), { playlistType: Ee });
        }
        function ce(Te, Ee) {
          return ue(ue({}, Te), { isLowLatencyPlaylist: Ee });
        }
        function he(Te, Ee) {
          return ue(ue({}, Te), { endlist: Ee });
        }
        function ge(Te, Ee) {
          var Me, Ae = Ee.mimeType, Ne = Ee.discoTimings;
          return ue(ue({}, Te), { discontinuitySequenceTiming: ue(ue({}, Te.discontinuitySequenceTiming), (Me = {}, Me[Ae] = Ne, Me)) });
        }
        function ve(Te, Ee) {
          var Me = {}, Ae = {};
          return Ee.media.forEach(function(Ne) {
            var Ce = !!Ne.attributes;
            if (Ce) {
              var Ie = Ne.attributes, xe = Ie.TYPE, Ue = Ie.LANGUAGE;
              Ue && Ue != null && (Ce && Ne.attributes.DEFAULT === "YES" && !Me[xe] && (Me[xe] = { name: Ne.attributes.NAME, language: Ue }), Ne.attributes.AUTOSELECT === "YES" && !Ae[xe] && (Ae[xe] = { name: Ne.attributes.NAME, language: Ue }));
            }
          }), ue(ue({}, Te), { defaultLanguages: ue(ue({}, Ae), Me) });
        }
        function me(Te, Ee) {
          var Me = Ee;
          return ue(ue({}, Te), { customTags: Me.tags });
        }
        function be(Te, Ee) {
          var Me, Ae = Ee.discoSequenceNumber, Ne = Ee.presentationTimeOffset;
          return ue(ue({}, Te), { presentationTimeOffsets: ue(ue({}, Te.presentationTimeOffsets), (Me = {}, Me[Ae] = Ne, Me)) });
        }
        function pe(Te, Ee) {
          return ue(ue({}, Te), { timestampRolloverPositions: Ee });
        }
        function $e(Te, Ee) {
          return ue(ue({}, Te), { contentLocationId: Ee.locationId });
        }
        function ye() {
          return { masterPlaylist: { string: "" }, defaultLanguages: {}, discontinuitySequenceTiming: {}, presentationTimeOffsets: {}, timestampRolloverPositions: { previous: -1, next: -1 } };
        }
        function Se(Te, Ee, Me) {
          var Ae = _e([], Te, !0);
          return Ae[Ee] = ue({}, Ae[Ee]), Ae[Ee].startTime = Me, Pe(Ae, Ee), we(Ae, Ee), Ae;
        }
        function we(Te, Ee) {
          for (var Me = Ee + 1; Me < Te.length; Me++)
            Te[Me] = ue({}, Te[Me]), Te[Me].startTime = Te[Me - 1].startTime + Te[Me - 1].duration;
        }
        function Pe(Te, Ee) {
          for (var Me = Ee - 1; Me >= 0; Me--)
            Te[Me] = ue({}, Te[Me]), Te[Me].startTime = Te[Me + 1].startTime - Te[Me].duration;
        }
        ie.HlsReducer = (0, fe.default)(ye(), ((ae = {})[le.HlsActionType.SetMasterPlaylistString] = function(Te, Ee) {
          return se(Te, Ee.payload);
        }, ae[le.HlsActionType.SetPlaylistType] = function(Te, Ee) {
          return oe(Te, Ee.payload);
        }, ae[le.HlsActionType.SetIsLowLatencyPlaylist] = function(Te, Ee) {
          return ce(Te, Ee.payload);
        }, ae[le.HlsActionType.SetEndlist] = function(Te, Ee) {
          return he(Te, Ee.payload);
        }, ae[le.HlsActionType.SetDefaultLanguages] = function(Te, Ee) {
          return ve(Te, Ee.payload);
        }, ae[le.HlsActionType.SetCustomTags] = function(Te, Ee) {
          return me(Te, Ee.payload);
        }, ae[le.HlsActionType.SetDiscoTimings] = function(Te, Ee) {
          return ge(Te, Ee.payload);
        }, ae[le.HlsActionType.SetPresentationTimeOffset] = function(Te, Ee) {
          return be(Te, Ee.payload);
        }, ae[le.HlsActionType.SetTimestampRolloverPositions] = function(Te, Ee) {
          return pe(Te, Ee.payload);
        }, ae[le.HlsActionType.SetContentLocationId] = function(Te, Ee) {
          return $e(Te, Ee.payload);
        }, ae));
      }, 34435: function(ee, ie) {
        var ne = this && this.__assign || function() {
          return ne = Object.assign || function(ye) {
            for (var Se, we = 1, Pe = arguments.length; we < Pe; we++)
              for (var Te in Se = arguments[we])
                Object.prototype.hasOwnProperty.call(Se, Te) && (ye[Te] = Se[Te]);
            return ye;
          }, ne.apply(this, arguments);
        };
        function ae(ye) {
          return ye.hls;
        }
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getContentLocationId = ie.getPresentationTimeOffset = ie.getMergedDiscontinuityTimings = ie.getFirstDiscoSequenceTiming = ie.getDiscoSequenceTimings = ie.getDiscoSequenceTiming = ie.getCustomTags = ie.getDefaultLanguages = ie.getEndlist = ie.getIsLowLatencyPlaylist = ie.getPlaylistType = void 0, ie.getHlsState = ae, ie.computeMergedDiscontinuityTimings = be, ie.areDiscontinuitiesMisaligned = pe;
        var ue = function(ye) {
          return ye.playlistType;
        };
        ie.getPlaylistType = ue;
        var _e = function(ye) {
          return ye.isLowLatencyPlaylist;
        };
        ie.getIsLowLatencyPlaylist = _e;
        var fe = function(ye) {
          return ye.endlist;
        };
        ie.getEndlist = fe;
        var le = function(ye) {
          return ye.defaultLanguages;
        };
        ie.getDefaultLanguages = le;
        var se = function(ye) {
          return ye.customTags;
        };
        ie.getCustomTags = se;
        var oe = function(ye, Se, we) {
          var Pe, Te;
          return !((Te = (Pe = ye.discontinuitySequenceTiming) === null || Pe === void 0 ? void 0 : Pe[Se]) === null || Te === void 0) && Te[we] ? ne({}, ye.discontinuitySequenceTiming[Se][we]) : null;
        };
        ie.getDiscoSequenceTiming = oe;
        var ce = function(ye, Se) {
          var we;
          return !((we = ye.discontinuitySequenceTiming) === null || we === void 0) && we[Se] ? ne({}, ye.discontinuitySequenceTiming[Se]) : null;
        };
        ie.getDiscoSequenceTimings = ce;
        var he = function(ye) {
          var Se, we = (0, ie.getMergedDiscontinuityTimings)(ye);
          return (Se = we[Object.keys(we)[0]]) !== null && Se !== void 0 ? Se : { startTime: 0, endTime: 0 };
        };
        ie.getFirstDiscoSequenceTiming = he;
        var ge = function(ye) {
          var Se;
          return be((Se = ye.discontinuitySequenceTiming) !== null && Se !== void 0 ? Se : {});
        };
        ie.getMergedDiscontinuityTimings = ge;
        var ve = function(ye, Se) {
          return ye.presentationTimeOffsets[Se];
        };
        ie.getPresentationTimeOffset = ve;
        var me = function(ye) {
          return ye.contentLocationId;
        };
        function be(ye) {
          var Se = {}, we = function(Pe, Te) {
            var Ee, Me, Ae, Ne, Ce, Ie, xe, Ue, ke, Le;
            return { startTime: Math.max((Ae = (Me = (Ee = ye[Te]) === null || Ee === void 0 ? void 0 : Ee[Pe]) === null || Me === void 0 ? void 0 : Me.startTime) !== null && Ae !== void 0 ? Ae : -1 / 0, (Ce = (Ne = Se[Pe]) === null || Ne === void 0 ? void 0 : Ne.startTime) !== null && Ce !== void 0 ? Ce : -1 / 0), endTime: Math.min((Ue = (xe = (Ie = ye[Te]) === null || Ie === void 0 ? void 0 : Ie[Pe]) === null || xe === void 0 ? void 0 : xe.endTime) !== null && Ue !== void 0 ? Ue : 1 / 0, (Le = (ke = Se[Pe]) === null || ke === void 0 ? void 0 : ke.endTime) !== null && Le !== void 0 ? Le : 1 / 0) };
          };
          return Object.keys(ye).forEach(function(Pe) {
            var Te;
            Object.keys((Te = ye[Pe]) !== null && Te !== void 0 ? Te : {}).forEach(function(Ee) {
              Se[Ee] = we(Ee, Pe);
            });
          }), Se;
        }
        function pe(ye, Se, we) {
          if (we === void 0 && (we = 2), Se.length <= 1 || !ye.discontinuitySequenceTiming)
            return !1;
          var Pe = $e(ye.discontinuitySequenceTiming, Se), Te = be(Pe);
          return Object.keys(Te).length !== 1 && !Object.keys(Te).every(function(Ee, Me) {
            var Ae = Te[Ee];
            return Se.every(function(Ne) {
              var Ce, Ie = (Ce = Pe[Ne]) === null || Ce === void 0 ? void 0 : Ce[Ee];
              if (!Ie)
                return !0;
              var xe = Math.abs(Ie.startTime - Ae.startTime), Ue = Math.abs(Ie.endTime - Ae.endTime);
              return Me === 0 ? Ue <= we : Me === Object.keys(Te).length - 1 ? xe <= we : xe <= we && Ue <= we;
            });
          });
        }
        function $e(ye, Se) {
          return Se.reduce(function(we, Pe) {
            return Pe in ye && (we[Pe] = ye[Pe]), we;
          }, {});
        }
        ie.getContentLocationId = me;
      }, 90993: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.HlsActionType = void 0, function(ae) {
          ae.SetMasterPlaylistString = "@instance/hls/setmasterplayliststring", ae.SetPlaylistType = "@instance/hls/setplaylisttype", ae.SetIsLowLatencyPlaylist = "@instance/hls/setislowlatencyplaylist", ae.SetEndlist = "@instance/hls/setendlist", ae.SetDefaultLanguages = "@instance/hls/setsefaultlanguages", ae.SetCustomTags = "@instance/hls/setsustomtags", ae.SetDiscoTimings = "@instance/hls/setdiscotimings", ae.SetPresentationTimeOffset = "@instance/hls/setpresentationtimeoffset", ae.SetTimestampRolloverPositions = "@instance/hls/settimestamprolloverpositions", ae.SetContentLocationId = "@instance/hls/setcontentlocationid";
        }(ne || (ie.HlsActionType = ne = {}));
      }, 31043: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.setSegmentInfos = _e, ie.updateSegmentInfos = fe;
        var ae = ne(15231), ue = ne(85157);
        function _e(le, se) {
          return (0, ae.createAction)(ue.SegmentInfoMapActionType.SetSegmentInfos, { qualityPath: le, updatedEntry: se });
        }
        function fe(le, se) {
          return (0, ae.createAction)(ue.SegmentInfoMapActionType.UpdateSegmentInfos, { qualityPath: le, updatedEntry: se });
        }
      } }, function(ee) {
        return function(ie) {
          return ee(ee.s = ie);
        }(64732);
      }]);
    });
  })();
})(bitmovinplayerHls);
var bitmovinplayerHlsExports = bitmovinplayerHls.exports;
const HLSModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerHlsExports);
var bitmovinplayerMserenderer = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ie) {
      re.exports = ie();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[737], { 23729: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.BufferMimeCodecMap = void 0;
        var ae = ne(27517), ue = ne(76650), _e = ne(28819), fe = ne(8272), le = ne(27177), se = ne(79814), oe = function() {
          function he(ge, ve) {
            this.mimeCodeMap = {}, this.store = ge, this.settings = ve;
          }
          return he.prototype.ensureMetricsForMimeType = function(ge) {
            var ve, me, be = (ve = this.store) === null || ve === void 0 ? void 0 : ve.getState();
            (0, ae.isInstanceState)(be) && ce(this.settings) && ((0, _e.getMetricsState)(be)[ge] || (me = this.store) === null || me === void 0 || me.dispatch((0, ue.initializeMetricsForMimeType)(ge, this.settings)));
          }, he.prototype.removeMetrics = function(ge) {
            var ve;
            (ve = this.store) === null || ve === void 0 || ve.dispatch((0, ue.removeMetricsForMimeType)(ge));
          }, he.prototype.add = function(ge, ve) {
            var me;
            this.mimeCodeMap[ge] = ve, this.ensureMetricsForMimeType(ge), (me = this.store) === null || me === void 0 || me.dispatch((0, ue.addMetricsValue)(ge, fe.MetricType.StalledSeconds, 0));
          }, he.prototype.remove = function(ge) {
            var ve = this, me = se.MimeTypeHelper.getMediaType(ge);
            Object.keys(this.mimeCodeMap).forEach(function(be) {
              se.MimeTypeHelper.getMediaType(be) === me && (ve.removeMetrics(be), delete ve.mimeCodeMap[be]);
            });
          }, he.prototype.has = function(ge, ve) {
            var me = this, be = se.MimeTypeHelper.getMediaType(ge), pe = se.MimeTypeHelper.extractContainerType(ge);
            return Object.keys(this.mimeCodeMap).some(function($e) {
              var ye = se.MimeTypeHelper.getMediaType($e), Se = se.MimeTypeHelper.extractContainerType($e);
              return ye === be && Se === pe && ve === me.mimeCodeMap[ge];
            });
          }, he.prototype.update = function(ge, ve) {
            this.remove(ge), this.add(ge, ve);
          }, he.prototype.forEach = function(ge) {
            var ve = this;
            Object.keys(this.entries()).forEach(function(me) {
              return ge(me, ve.entries()[me]);
            });
          }, he.prototype.entries = function() {
            return this.mimeCodeMap;
          }, he.prototype.dispose = function() {
            this.mimeCodeMap = {}, this.store = void 0, this.settings = void 0;
          }, he;
        }();
        ie.BufferMimeCodecMap = oe;
        var ce = function(he) {
          return (0, le.isObject)(he);
        };
      }, 93159: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.GapHandler = void 0;
        var ae = ne(62510), ue = ne(11399), _e = ne(27517), fe = ne(58975), le = ne(13533), se = ne(79814), oe = ne(26905), ce = ne(46462), he = ne(72566), ge = ne(89413), ve = [ce.MediaElementEvent.seeking, ce.MediaElementEvent.seeked, ce.MediaElementEvent.pause, ce.MediaElementEvent.playing, ce.MediaElementEvent.error], me = 5, be = 10, pe = 250, $e = 0.01, ye = function() {
          function Ae(Ne) {
            var Ce, Ie, xe, Ue, ke, Le = this;
            this.isExecutingGapSkipping = !1, this.play = function() {
              Le.lastPlayEventTimestamp = Date.now();
            }, this.checkIfWaiting = function() {
              if (!Le.context.isDisposed && Le.video !== void 0) {
                var Be = Le.video.paused, Fe = Le.video.seeking, Ve = Le.isAtEndOfBufferedRange(Le.video.currentTime), Ke = Le.hasRecentlyTrackedTimeupdateEvent(), Ze = Le.hasRecentlyStartedPlayback();
                Be || Fe && !Ve || Ke || (Le.consecutiveWaiting++, Ze || Le.waiting());
              }
            }, this.waiting = function() {
              var Be, Fe = Le.context.store.getState();
              if ((0, _e.isInstanceState)(Fe) && Le.video) {
                var Ve = (0, fe.getPlayerState)(Fe);
                ((0, fe.getIsSeeking)(Ve) || !((Be = Le.video) === null || Be === void 0) && Be.seeking) && !Le.isAtEndOfBufferedRange(Le.video.currentTime) || Le.setTimer();
              }
            }, this.stalled = function() {
              Le.setTimer();
            }, this.onSeek = function() {
              Le.gapAhead = void 0;
            }, this.timeupdate = function() {
              if (Le.lastTimeupdate = Date.now(), Le.video && !Le.video.paused && !Le.video.seeking) {
                Le.hasPlayedAnythingYet = !0;
                var Be = Le.context.renderer.getCurrentTime(!0);
                if (Le.shouldSkipGap(Be))
                  Le.skipTheGapProactively();
                else {
                  var Fe = Le.context.renderer.getVideoElementBufferedRanges();
                  if (Fe.length > 1 && !Le.gapAhead) {
                    var Ve = Le.context.settings.MIN_SIZE_FOR_GAP_SKIPPING;
                    Le.gapAhead = Te(Fe, Be, Ve);
                  } else
                    Le.shouldTriggerWaitingEvent(Be) ? (Le.consecutiveUpdates++, Le.waiting()) : Be === Le.lastRecordedTime ? Le.consecutiveUpdates++ : (Le.consecutiveUpdates = 0, Le.consecutiveWaiting = 0, Le.lastRecordedTime = Be);
                }
              }
            }, this.cancelTimer = function() {
              Le.consecutiveUpdates = 0, Le.consecutiveWaiting = 0, clearTimeout(Le.timer), Le.timer = -1;
            }, this.skipTheGap = function(Be) {
              if (Le.video && !Le.isExecutingGapSkipping) {
                var Fe = Le.context.renderer.getVideoElementBufferedRanges().sort(function(nt, Qe) {
                  return nt.start - Qe.start;
                }), Ve = Le.context.renderer.getCurrentTime(!0), Ke = Ee(Fe, Ve);
                if (Le.consecutiveUpdates = 0, Le.consecutiveWaiting = 0, Le.timer = -1, Ke !== void 0 && Ve === Be) {
                  var Ze = Ke.start;
                  Le.context.logger.debug("Skipping gap from ".concat(Ve, " to ").concat(Ze)), Le.executeGapSkipping(Ve, Ze);
                }
              }
            }, this.context = Ne, this.video = Ne.videoElement, this.lastTimeupdate = 0, this.consecutiveUpdates = 0, this.consecutiveWaiting = 0, this.lastPlayEventTimestamp = 0, this.hasPlayedAnythingYet = !1, this.gapAhead = void 0, (Ce = this.video) === null || Ce === void 0 || Ce.addEventListener(ce.MediaElementEvent.waiting, this.waiting), (Ie = this.video) === null || Ie === void 0 || Ie.addEventListener(ce.MediaElementEvent.stalled, this.stalled), (xe = this.video) === null || xe === void 0 || xe.addEventListener(ce.MediaElementEvent.timeupdate, this.timeupdate), (Ue = this.video) === null || Ue === void 0 || Ue.addEventListener(ce.MediaElementEvent.play, this.play), this.context.eventHandler.on(ae.PlayerEvent.Seek, this.onSeek);
            for (var De = 0, Re = ve; De < Re.length; De++) {
              var Oe = Re[De];
              (ke = this.video) === null || ke === void 0 || ke.addEventListener(Oe, this.cancelTimer);
            }
            this.timeupdateIntervalId = window.setInterval(this.checkIfWaiting, pe);
          }
          return Ae.prototype.hasRecentlyStartedPlayback = function() {
            return Date.now() - this.lastPlayEventTimestamp < 2 * pe;
          }, Ae.prototype.hasRecentlyTrackedTimeupdateEvent = function() {
            return Date.now() - this.lastTimeupdate <= 1e3;
          }, Ae.prototype.shouldSkipGap = function(Ne) {
            return !(!this.gapAhead || this.isExecutingGapSkipping) && (Se(Ne, this.gapAhead) || we(this.context.settings.PROACTIVE_GAP_SKIP_DISTANCE_SECONDS, Ne, this.gapAhead) || Pe(Ne, this.gapAhead));
          }, Ae.prototype.shouldTriggerWaitingEvent = function(Ne) {
            return this.consecutiveUpdates === me && Ne === this.lastRecordedTime;
          }, Ae.prototype.skipTheGapProactively = function() {
            if (this.video && this.gapAhead) {
              var Ne = this.context.renderer.getCurrentTime(!0), Ce = Math.max(Ne + $e, this.gapAhead.end);
              this.context.logger.debug("Skipping gap proactively from ".concat(Ne, " to ").concat(Ce)), this.executeGapSkipping(Ne, Ce);
            }
          }, Ae.prototype.executeGapSkipping = function(Ne, Ce) {
            var Ie = this;
            this.isExecutingGapSkipping = !0, this.gapAhead = void 0, this.maybeRemoveVideoBufferData(Ne, Ce).then(function() {
              return Ie.context.renderer.setCurrentTime(Ce + ge.Ranges.TIME_FUDGE_FACTOR);
            }).then(function(xe) {
              return Ie.context.logger.debug("Jumped buffer gap from ".concat(Ne, " to ").concat(xe));
            }).catch(function(xe) {
              return Ie.context.logger.debug("Failed to skip buffer gap from ".concat(Ne, " to ").concat(Ce), xe);
            }).finally(function() {
              Ie.isExecutingGapSkipping = !1, Ie.gapAhead = void 0;
            });
          }, Ae.prototype.maybeRemoveVideoBufferData = function(Ne, Ce) {
            if (!(0, le.getCapabilities)().isTizen)
              return Promise.resolve();
            var Ie = this.getVideoMimeType();
            if (Ie === void 0)
              return Promise.resolve();
            var xe = Ee(this.context.renderer.getBufferedRanges(Ie).sort(function(Ue, ke) {
              return Ue.start - ke.start;
            }), Ne);
            return Ce !== (xe == null ? void 0 : xe.start) ? (this.context.logger.debug("Clearing video data from ".concat(Ne, " to ").concat(Ce, " to ensure gap can be skipped")), this.context.renderer.removeData(Ie, Ne, Ce)) : Promise.resolve();
          }, Ae.prototype.getVideoMimeType = function() {
            var Ne;
            return (Ne = this.context.segmentInfoService) === null || Ne === void 0 ? void 0 : Ne.getSegmentControllerMimeTypes().find(function(Ce) {
              return se.MimeTypeHelper.isVideo(Ce);
            });
          }, Ae.prototype.gapFromVideoUnderflow = function(Ne, Ce, Ie) {
            for (var xe = ge.Ranges.findGaps(Ne, Ie), Ue = 0; Ue < xe.length; Ue++) {
              var ke = xe.start(Ue), Le = xe.end(Ue);
              if (Ce - ke < 4 && Ce - ke > 2)
                return { start: ke, end: Le };
            }
          }, Ae.prototype.setTimer = function() {
            if (!(this.timer > -1) && this.hasPlayedAnythingYet && this.video) {
              var Ne = this.video.buffered, Ce = this.video.currentTime, Ie = ge.Ranges.findNextRange(Ne, Ce), xe = this.context.settings.MIN_SIZE_FOR_GAP_SKIPPING;
              if (Ie.length === 0) {
                var Ue = this.gapFromVideoUnderflow(Ne, Ce, xe);
                if (Ue)
                  return this.context.logger.debug("Encountered a gap in video from ".concat(Ue.start, " to ").concat(Ue.end, ". Seeking to ").concat(Ce, "...")), this.consecutiveWaiting = 0, void this.setCurrentTime(Ce);
                var ke = (0, he.findNextRangeForGap)(Ce, Ne), Le = ke.isNearEndOfBufferedRange, De = ke.nextRangeStart;
                return Le && isFinite(De) ? (this.context.logger.debug("Playback stalled because of a very small gap. Seeking to ".concat(De, "...")), this.consecutiveWaiting = 0, void this.setCurrentTime(De)) : void (this.consecutiveWaiting > be && (this.consecutiveWaiting = 0, this.triggerCurrentTimeNotAdvancing(Ce, this.video)));
              }
              if (!Me(Ne, Ce, xe)) {
                var Re = Ie.start(0) - Ce;
                this.context.logger.debug("setTimer: stopped at: ".concat(Ce, ", setting timer for: ").concat(Re, ", seeking to: ").concat(Ie.start(0))), this.timer = window.setTimeout(this.skipTheGap.bind(this), Re, this.context.renderer.getCurrentTime(!0));
              }
            }
          }, Ae.prototype.triggerCurrentTimeNotAdvancing = function(Ne, Ce) {
            this.context.logger.debug("currentTime not advancing from ".concat(Ne, " although the video element is neither paused nor seeking")), this.maybePokeVideoElement(Ne, Ce), Ce.eventHandler.triggerEvent(ce.MediaElementEvent.currenttimenotadvancing);
          }, Ae.prototype.maybePokeVideoElement = function(Ne, Ce) {
            if (Ne > Ce.duration && !(0, le.getCapabilities)().isSafari)
              this.setCurrentTime(Ce.duration);
            else if (this.context.settings.QJY_BROWSER_WORKAROUND || (0, le.getCapabilities)().isTizen)
              this.setCurrentTime(Ne + $e);
            else {
              var Ie = (0, le.getCapabilities)()[ue.CapabilityKey.isPlayStation5];
              this.setCurrentTime(Ne, Ie);
            }
          }, Ae.prototype.isAtEndOfBufferedRange = function(Ne) {
            if (!this.video)
              return !1;
            for (var Ce = this.video.buffered, Ie = 0; Ie < Ce.length; Ie++)
              if (Ce.end(Ie) === Ne)
                return !0;
            return !1;
          }, Ae.prototype.shutdown = function() {
            var Ne, Ce, Ie, xe, Ue;
            (Ne = this.video) === null || Ne === void 0 || Ne.removeEventListener(ce.MediaElementEvent.waiting, this.waiting), (Ce = this.video) === null || Ce === void 0 || Ce.removeEventListener(ce.MediaElementEvent.stalled, this.stalled), (Ie = this.video) === null || Ie === void 0 || Ie.removeEventListener(ce.MediaElementEvent.timeupdate, this.timeupdate), (xe = this.video) === null || xe === void 0 || xe.removeEventListener(ce.MediaElementEvent.play, this.play), this.context.eventHandler.off(ae.PlayerEvent.Seek, this.onSeek);
            for (var ke = 0, Le = ve; ke < Le.length; ke++) {
              var De = Le[ke];
              (Ue = this.video) === null || Ue === void 0 || Ue.removeEventListener(De, this.cancelTimer);
            }
            clearInterval(this.timeupdateIntervalId), this.cancelTimer();
          }, Ae.prototype.setCurrentTime = function(Ne, Ce) {
            if (Ce === void 0 && (Ce = !1), this.video && (this.video.currentTime !== Ne || Ce))
              try {
                this.video.currentTime = Ne;
              } catch (Ie) {
                this.context.logger.debug("GapHandler failed to set currentTime on video element to ".concat(Ne), Ie);
              }
          }, Ae;
        }();
        function Se(Ae, Ne) {
          return Ae > Ne.start && Ae < Ne.end;
        }
        function we(Ae, Ne, Ce) {
          return !(Ae <= 0) && Ce.start > Ne && Ce.start - Ae < Ne;
        }
        function Pe(Ae, Ne) {
          return Ae > Ne.end && (0, oe.shouldResetCurrentTimeAfterBufferUnderrun)();
        }
        function Te(Ae, Ne, Ce) {
          for (var Ie = 0; Ie < Ae.length - 1; Ie++) {
            var xe = Ae[Ie].end, Ue = Ae[Ie + 1].start;
            if (xe > Ne && Ue > xe && Ue - xe >= Ce)
              return { start: xe, end: Ue };
          }
        }
        function Ee(Ae, Ne) {
          return Ae.find(function(Ce) {
            return Ce.start - ge.Ranges.TIME_FUDGE_FACTOR >= Ne;
          });
        }
        function Me(Ae, Ne, Ce) {
          if (Ce === 0)
            return !1;
          var Ie = ge.Ranges.findNextRange(Ae, Ne);
          if (Ie.length === 0)
            return !1;
          var xe = ge.Ranges.findRangeForTime(Ae, Ne), Ue = xe.length ? xe.end(0) : Ne;
          return Ie.start(0) - Ue < Ce;
        }
        ie.GapHandler = ye;
      }, 72566: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.findNextRangeForGap = ue;
        var ae = ne(89413);
        function ue(_e, fe) {
          for (var le = !1, se = 1 / 0, oe = 0; oe < fe.length; oe++) {
            var ce = fe.start(oe), he = fe.end(oe), ge = _e + 2 * ae.Ranges.TIME_FUDGE_FACTOR;
            if (le && !isFinite(se)) {
              se = ce;
              break;
            }
            ce < _e && he > _e && ge > he && (le = !0);
          }
          return { isNearEndOfBufferedRange: le, nextRangeStart: se };
        }
      }, 6863: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MSERenderer = void 0;
        var ae = ne(92712), ue = ne(52442), _e = ne(25550), fe = ne(28764), le = ne(18665), se = ne(62510), oe = ne(33696), ce = ne(94304), he = ne(11399), ge = ne(17990), ve = ne(27279), me = ne(13533), be = ne(3464), pe = ne(27177), $e = ne(10981), ye = ne(53968), Se = ne(79814), we = ne(70016), Pe = ne(46462), Te = ne(96873), Ee = ne(33669), Me = ne(23729), Ae = ne(93159), Ne = ne(58765), Ce = ne(66697), Ie = ne(1504), xe = ne(76316), Ue = function() {
          function De(Re) {
            var Oe = this;
            this.context = Re, this.consecutiveErrorCount = 0, this.waitingForSeekedPromise = null, this.onWaitingForKey = function() {
              if (!Oe.setCurrentTimeContext && (0, me.getCapabilities)()[he.CapabilityKey.isFirefox]) {
                var Be = Oe.getCurrentTime();
                Oe.logger.debug("Received waitingforkey event on Firefox, re-setting currentTime to ".concat(Be)), Oe.setCurrentTime(Be);
              }
            }, this.onSeek = function(Be) {
              Oe.setCurrentTimeDelayedContext && Oe.setCurrentTimeDelayedContext.time !== Be.seekTarget && Math.abs(Oe.setCurrentTimeDelayedContext.time - Be.seekTarget) >= Oe.context.settings.GAP_TOLERANCE && Oe.cancelSetCurrentTimeDelayed();
            }, this.reOpenMse = function() {
              var Be = Oe.segmentQueueMimeTypes;
              if (Be.length < 1)
                return Promise.resolve();
              var Fe = Be.find(function(Ve) {
                return Oe.timestampOffset.hasOwnProperty(Ve);
              });
              return Fe ? Oe.setTimestampOffset(Fe, Oe.timestampOffset[Fe]) : Oe.setTimestampOffset(Be[0], 0);
            }, this.firePictureInPictureEvent = function() {
              if (Oe.video) {
                var Be = Oe.video.isPictureInPicture() ? oe.ViewMode.PictureInPicture : oe.ViewMode.Inline;
                Oe.context.store.dispatch((0, ge.setPlayerViewMode)(Be));
              }
            }, this.resetConsecutiveErrorCountCallback = function(Be) {
              Be.time && Be.time > 0 && (Oe.consecutiveErrorCount = 0);
            }, this.postBufferRemoval = function(Be, Fe, Ve) {
              Oe.logger.debug("successfully removed buffer for ".concat(Be, " (from  ").concat(Fe, " to ").concat(Ve, ")"));
            }, this.logger = Re.logger, this.video = Re.videoElement, this.settings = Re.settings, this.readyPromise = Promise.resolve(), this.eventHandler = void 0, this.timestampOffset = {}, this.sourceBufferMimeCodecMap = new Me.BufferMimeCodecMap(Re.store, Re.settings), this.savedCurrentTime = 0, this.playerEventHandler = Re.eventHandler, this.shutdownPromise = Promise.resolve(), this.init(!0);
          }
          return De.prototype.createMSEWrapper = function() {
            return new Ne.MSEWrapper(this.context);
          }, De.prototype.createMse = function(Re) {
            return Re ? this.createMseSynchronously() : this.createMseAsynchronously();
          }, De.prototype.createMseAsynchronously = function() {
            var Re = this;
            return function() {
              var Oe;
              return (Oe = Re.mse) === null || Oe === void 0 ? void 0 : Oe.createNewMSE();
            };
          }, De.prototype.createMseSynchronously = function() {
            var Re, Oe = (Re = this.mse) === null || Re === void 0 ? void 0 : Re.createNewMSE();
            return function() {
              return Oe;
            };
          }, De.prototype.init = function(Re) {
            var Oe = this;
            this.segmentQueueProcessingPromise = Promise.resolve(), this.mse = this.createMSEWrapper(), this.readyPromise = this.readyPromise.catch(function(Be) {
              return Oe.context.logger.debug("Caught error during MSE recreation", Be);
            }).then(this.createMse(Re)), this.needsInitialSeek = !0, this.segmentQueues = {}, this.setCurrentTimeContext = void 0, this.setCurrentTimeDelayedContext = void 0, this.quotaExceededMap = /* @__PURE__ */ new Map(), this.quotaExceededDeferredMap = /* @__PURE__ */ new Map(), this.gapHandler = new Ae.GapHandler(this.context), this.eventHandler == null && this.video && (this.eventHandler = new xe.VideoEventHandler(this.video), this.eventHandler.on(Pe.MediaElementEvent.timeupdate, this.resetConsecutiveErrorCountCallback)), this.on(Pe.MediaElementEvent.webkitpresentationmodechanged, this.firePictureInPictureEvent), this.on(Pe.MediaElementEvent.waitingforkey, this.onWaitingForKey), this.playerEventHandler.on(se.PlayerEvent.Seek, this.onSeek);
          }, De.prototype.trackRendererError = function(Re) {
            this.consecutiveErrorCount++, this.consecutiveErrorCount >= this.settings.MAX_CONSECUTIVE_RENDERER_ERRORS && this.context.eventHandler.fireError(new fe.PlayerError(_e.ErrorCode.PLAYBACK_VIDEO_DECODING_ERROR, { codec: Re.getCodec(), mimeType: Re.getMimeType(), segmentUrl: Re.getUrl() }, "Failed to append the segment to the buffer. The MSE has thrown an error."));
          }, De.prototype.hasSourceBuffers = function() {
            return this.segmentQueueMimeTypes.length > 0;
          }, De.prototype.hasDataInSourceBuffers = function() {
            var Re = this.mse;
            return !(!Re || !this.hasSourceBuffers()) && this.segmentQueueMimeTypes.every(function(Oe) {
              return Re.getBufferedRanges(Oe).length > 0;
            });
          }, De.prototype.updateRendererRangesInStore = function(Re) {
            var Oe;
            (Oe = (0, ve.getSourceStore)(this.context)) === null || Oe === void 0 || Oe.dispatch((0, Te.setRendererRanges)(Re, this.getOverallBufferedRanges(Re)));
          }, De.prototype.addBuffer = function(Re, Oe) {
            var Be, Fe = this;
            if (!this.mse)
              return !1;
            this.sourceBufferMimeCodecMap.add(Re, Oe);
            var Ve = !!this.mse.addBuffer(Re, Oe, function() {
              return Fe.updateRendererRangesInStore(Re);
            });
            return Ve && (this.mse.addUpdateEndCallback(Re, function() {
              var Ke;
              return (Ke = Fe.setCurrentTimeDelayedContext) === null || Ke === void 0 || Ke.reevaluateDataInBuffer(), Fe.quotaExceededMap.set(Re, !1);
            }), this.segmentQueues[Re] = [], (Be = (0, ve.getSourceStore)(this.context)) === null || Be === void 0 || Be.dispatch((0, Te.setRendererRanges)(Re, []))), Ve;
          }, De.prototype.addDrmInitData = function(Re) {
            if (Re != null && Re.length) {
              var Oe = this.drmService;
              Oe ? Re.forEach(function(Be) {
                return Oe.addInitData(Be);
              }) : this.context.logger.debug("PSSH data found but DRM is not configured");
            }
          }, De.prototype.storeDrmInitDataFromManifest = function(Re) {
            var Oe = this;
            Re && this.context.serviceManager.maybeCall(le.ServiceName.ManifestService, function(Be) {
              var Fe = Be.getContentProtectionForAdaptationSet(Re).flatMap(function(Ve) {
                var Ke = ce.KeySystemKind[Ve.name.toUpperCase()], Ze = Ve.schemeIdUri.replace("urn:uuid:", "").replace(/-/g, "");
                return (Ve.pssh || []).map(function(nt, Qe) {
                  return Oe.logger.insane("adding pssh for ".concat(Ve.name, " : ").concat(nt)), { initData: Ve.psshData[Qe], initDataStr: nt, systemID: Ve.schemeIdUri, systemIDraw: Ze, systemName: Ke, kid: [] };
                });
              });
              Oe.addDrmInitData(Fe);
            }, void 0, this.context.sourceContext.sourceIdentifier);
          }, De.prototype.appendData = function(Re) {
            var Oe = this;
            return this.addDrmInitData(Re.getDrmInitData()), this.addSegmentToSegmentQueue(Re), this.segmentQueueProcessingPromise = this.segmentQueueProcessingPromise.catch(function() {
            }).then(function() {
              return Oe.processSegmentQueues();
            }), this.segmentQueueProcessingPromise;
          }, De.prototype.addSegmentToSegmentQueue = function(Re) {
            var Oe = Re.getMimeType();
            this.segmentQueues[Oe] ? (this.segmentQueues[Oe].push(Re), this.updateRendererRangesInStore(Oe)) : this.logger.debug("Renderer missing segment queue for mimeType(".concat(Oe, ") but trying to push segment.(url=").concat(Re.getUrl(), ")"));
          }, De.prototype.getBufferedRanges = function(Re) {
            var Oe, Be;
            return (Be = (Oe = this.mse) === null || Oe === void 0 ? void 0 : Oe.getBufferedRanges(Re)) !== null && Be !== void 0 ? Be : [];
          }, De.prototype.getVideoElementBufferedRanges = function() {
            return (0, ae.getBufferedRanges)(this.video);
          }, De.prototype.getOverallBufferedRanges = function(Re) {
            if (!this.mse || !this.segmentQueues.hasOwnProperty(Re))
              return [];
            var Oe = ae.BufferRangeHelper.getRangesFromQueue(this.segmentQueues[Re], this.settings.GAP_TOLERANCE);
            return Oe = Oe.concat(this.getBufferedRanges(Re)), Oe = ae.BufferRangeHelper.mergeRanges(Oe, this.settings.GAP_TOLERANCE);
          }, De.prototype.isDataBeingAppended = function(Re) {
            return !!this.mse && (this.segmentQueues && this.segmentQueues[Re] && this.segmentQueues[Re].length > 0 || this.mse.isAnyBufferUpdating());
          }, De.prototype.getRangesFromStore = function(Re) {
            var Oe = (0, ve.getSourceState)(this.context);
            if (!Oe)
              return [];
            var Be = (0, Ee.getBufferStateMap)(Oe);
            return Be ? (0, Ee.getRendererBufferedRanges)(Be, Re) : [];
          }, De.prototype.getEndOfBufferTime = function() {
            var Re = this, Oe = [];
            if (this.segmentQueueMimeTypes.forEach(function(Be) {
              var Fe = Re.getRangesFromStore(Be);
              if (Fe.length > 0) {
                var Ve = Fe[Fe.length - 1].end;
                Oe.push(Ve);
              }
            }), Oe.length !== 0)
              return Math.min.apply(Math, Oe);
          }, De.prototype.removeDataFromSegmentQueues = function(Re, Oe, Be) {
            var Fe = this;
            Oe === void 0 && (Oe = -1 / 0), Be === void 0 && (Be = 1 / 0), this.segmentQueues.hasOwnProperty(Re) && (this.segmentQueues[Re] = this.segmentQueues[Re].filter(function(Ve) {
              var Ke = Ve.getDuration(), Ze = Ve.getPlaybackTime(), nt = Ve.getRepresentationId().representationId, Qe = Ve.isInit() || Ze < Oe || Ze + Ke > Be;
              return Fe.logger.debug("[MSERenderer][".concat(Re, "][").concat(nt, "] Removing segment from queue [").concat(!Qe, "]. ") + "Clearing from ".concat(Oe, " to ").concat(Be, ". Segment: [playbackTime=").concat(Ve.getPlaybackTime(), ", ") + "duration=".concat(Ve.getDuration(), ", url=").concat(Ve.getUrl(), "]")), Qe;
            }), this.updateRendererRangesInStore(Re));
          }, De.prototype.removeData = function(Re, Oe, Be) {
            return this.mse ? (Oe === void 0 && Be === void 0 && this.saveCurrentTime(), this.removeDataFromSegmentQueues(Re, Oe, Be), this.mse.removeFromBuffer(Re, Oe, Be, this.postBufferRemoval)) : Promise.reject();
          }, De.prototype.getDroppedVideoFrames = function() {
            var Re, Oe, Be, Fe, Ve;
            return (Ve = (Be = (Oe = (Re = this.video) === null || Re === void 0 ? void 0 : Re.getVideoPlaybackQuality()) === null || Oe === void 0 ? void 0 : Oe.droppedVideoFrames) !== null && Be !== void 0 ? Be : (Fe = this.video) === null || Fe === void 0 ? void 0 : Fe.droppedVideoFrames) !== null && Ve !== void 0 ? Ve : 0;
          }, De.prototype.setPlaybackSpeed = function(Re) {
            this.video && !isNaN(Re) && Re > 0 && Re !== this.video.playbackRate && (this.video.playbackRate = Re);
          }, De.prototype.getPlaybackSpeed = function() {
            var Re, Oe;
            return (Oe = (Re = this.video) === null || Re === void 0 ? void 0 : Re.playbackRate) !== null && Oe !== void 0 ? Oe : 1;
          }, De.prototype.setVolume = function(Re) {
            this.video && !isNaN(Re) && (this.video.volume = Math.min(Re / 100, 1));
          }, De.prototype.getVolume = function() {
            var Re, Oe;
            return 100 * ((Oe = (Re = this.video) === null || Re === void 0 ? void 0 : Re.volume) !== null && Oe !== void 0 ? Oe : 1);
          }, De.prototype.mute = function() {
            this.video && (this.video.muted = !0);
          }, De.prototype.unmute = function() {
            this.video && (this.video.muted = !1);
          }, De.prototype.isMuted = function() {
            var Re, Oe;
            return (Oe = (Re = this.video) === null || Re === void 0 ? void 0 : Re.muted) !== null && Oe !== void 0 && Oe;
          }, De.prototype.play = function() {
            var Re = this;
            return this.video ? this.video.play().catch(function(Oe) {
              if ((0, ye.isSwitchingBufferBlocks)((0, ve.getSourceStore)(Re.context)))
                return Re.ready();
              throw Oe;
            }) : Promise.resolve();
          }, De.prototype.pause = function() {
            this.video && this.video.pause();
          }, De.prototype.end = function() {
            this.pause(), this.cancelSetCurrentTimeDelayed();
          }, De.prototype.isPaused = function() {
            var Re, Oe;
            return (Oe = (Re = this.video) === null || Re === void 0 ? void 0 : Re.paused) === null || Oe === void 0 || Oe;
          }, De.prototype.setDuration = function(Re) {
            this.mse && (Re = Math.floor(1e4 * Re) / 1e4, this.duration = Re, this.mse.setDuration(Re));
          }, De.prototype.getDuration = function() {
            var Re, Oe;
            return (Oe = (Re = this.video) === null || Re === void 0 ? void 0 : Re.duration) !== null && Oe !== void 0 ? Oe : NaN;
          }, De.prototype.setCurrentTime = function(Re) {
            var Oe = this;
            if (!this.mse)
              return Promise.reject("MSE is not open");
            if (Re = Math.ceil(100 * Re) / 100, this.setCurrentTimeContext) {
              if (this.setCurrentTimeContext.time === Re)
                return this.setCurrentTimeContext.promise;
              this.cancelSetCurrentTimeDelayed();
            }
            var Be = Promise.resolve();
            this.isMSEOpen() || this.isTimeInBuffer(Re) || (this.logger.debug("reopen MSE on setCurrentTime"), Be = this.reOpenMse());
            var Fe = Be.then(function() {
              return Oe.setCurrentTimeInternal(Re).catch(function(Ve) {
                return Oe.logger.debug("could not set time ".concat(Re, " on video element"), Ve), Oe.getCurrentTime();
              }).finally(function() {
                return Oe.needsInitialSeek = !1;
              });
            });
            return this.setCurrentTimeContext = { time: Re, isInitialSeek: this.needsInitialSeek, promise: Fe }, Fe;
          }, De.prototype.getCurrentVideoTime = function() {
            var Re, Oe;
            return (Oe = (Re = this.video) === null || Re === void 0 ? void 0 : Re.currentTime) !== null && Oe !== void 0 ? Oe : 0;
          }, De.prototype.getCurrentFallbackTime = function() {
            var Re = this.setCurrentTimeContext;
            return Re && Re.isInitialSeek && Re.time !== -1 ? Re.time : this.savedCurrentTime !== 0 && this.isVideoCurrentTimeUnreliable() ? this.savedCurrentTime : (this.savedCurrentTime = 0, this.getCurrentVideoTime());
          }, De.prototype.isVideoCurrentTimeUnreliable = function() {
            var Re;
            return !this.hasDataInSourceBuffers() && !(!((Re = this.mse) === null || Re === void 0) && Re.isBufferRemovalPending()) || !(!(0, ye.isSwitchingBufferBlocks)((0, ve.getSourceStore)(this.context)) && this.isTimeInBuffer(this.getCurrentVideoTime()));
          }, De.prototype.getCurrentTime = function(Re) {
            return Re === void 0 && (Re = !1), Re ? this.getCurrentVideoTime() : this.getCurrentFallbackTime();
          }, De.prototype.getSnapshotData = function(Re, Oe) {
            Oe === void 0 && (Oe = 1);
            try {
              if (!this.video)
                return;
              var Be = this.video.videoWidth, Fe = this.video.videoHeight;
              this.snapshotCanvas || (this.snapshotCanvas = document.createElement("canvas"), this.snapshotCanvas.id = "snapshotHiddenCanvas"), this.snapshotCanvas.width = Be, this.snapshotCanvas.height = Fe;
              var Ve = this.snapshotCanvas.getContext("2d");
              Ve == null || Ve.drawImage(this.video.getWrappedElement(), 0, 0, Be, Fe);
              var Ke = void 0;
              return Re === "image/jpeg" || Re === "image/webp" ? (Oe = Math.max(Oe, 0), Oe = Math.min(Oe, 1), Ke = this.snapshotCanvas.toDataURL(Re, Oe)) : Ke = this.snapshotCanvas.toDataURL(Re, Oe), { height: Fe, width: Be, data: Ke };
            } catch (Ze) {
              return void (Ze && Ze.message ? this.logger.debug("Snapshot acquisition failed: " + Ze.message) : this.logger.debug("Snapshot acquisition failed"));
            }
          }, De.prototype.getDrmShutdownPromise = function() {
            return this.drmService ? this.drmService.shutdownPromise : Promise.resolve();
          }, De.prototype.ready = function() {
            var Re = this;
            return this.shutdownPromise.then(function() {
              return Re.getDrmShutdownPromise();
            }).then(function() {
              return Re.mse || Re.init(!1), Re.readyPromise;
            });
          }, De.prototype.setTimestampOffset = function(Re, Oe) {
            var Be = this;
            return this.mse ? this.mse.setTimestampOffset(Re, Oe).then(function() {
              Be.timestampOffset[Re] = Oe;
            }) : Promise.resolve();
          }, De.prototype.shutdown = function(Re) {
            var Oe, Be = this;
            if (!this.mse)
              return this.shutdownPromise;
            for (var Fe in this.waitingForSeekedPromise = null, Re && this.saveCurrentTime(), this.segmentQueues)
              this.segmentQueues.hasOwnProperty(Fe) && (delete this.segmentQueues[Fe], (Oe = (0, ve.getSourceStore)(this.context)) === null || Oe === void 0 || Oe.dispatch((0, Te.setRendererRanges)(Fe, [])));
            var Ve = this.mse;
            return this.shutdownPromise = this.shutdownPromise.then(function() {
              return Ve.tearDownMediaSource();
            }).catch(function(Ke) {
              Be.logger.debug("Could not tear down media source", { err: Ke, message: Ke.message });
            }), this.mse = void 0, this.cancelSetCurrentTimeDelayed(), this.gapHandler && (this.gapHandler.shutdown(), this.gapHandler = void 0), this.eventHandler && !Re && (this.eventHandler.dispose(), this.eventHandler = void 0), this.quotaExceededMap.clear(), this.quotaExceededDeferredMap.clear(), this.shutdownPromise;
          }, De.prototype.release = function() {
            var Re;
            for (var Oe in this.segmentQueues)
              this.segmentQueues.hasOwnProperty(Oe) && this.mse !== null && (delete this.segmentQueues[Oe], (Re = (0, ve.getSourceStore)(this.context)) === null || Re === void 0 || Re.dispatch((0, Te.setRendererRanges)(Oe, [])));
            return this.sourceBufferMimeCodecMap.dispose(), this.mse && this.mse.dispose(), this.readyPromise = Promise.resolve(), this.timestampOffset = {}, this.cancelSetCurrentTimeDelayed(), this.gapHandler && (this.gapHandler.shutdown(), this.gapHandler = void 0), this.off(Pe.MediaElementEvent.webkitpresentationmodechanged, this.firePictureInPictureEvent), this.off(Pe.MediaElementEvent.waitingforkey, this.onWaitingForKey), this.eventHandler && (this.eventHandler.off(Pe.MediaElementEvent.timeupdate, this.resetConsecutiveErrorCountCallback), this.eventHandler.dispose(), this.eventHandler = void 0), this.waitingForSeekedPromise = null, this.playerEventHandler.off(se.PlayerEvent.Seek, this.onSeek), this.getDrmShutdownPromise();
          }, De.prototype.on = function(Re, Oe) {
            var Be;
            (Be = this.eventHandler) === null || Be === void 0 || Be.on(Re, Oe);
          }, De.prototype.off = function(Re, Oe) {
            this.eventHandler && this.eventHandler.off(Re, Oe);
          }, Object.defineProperty(De.prototype, "drmService", { get: function() {
            var Re;
            return (Re = this.context.serviceManager) === null || Re === void 0 ? void 0 : Re.get(le.ServiceName.DrmService);
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(De.prototype, "segmentQueueMimeTypes", { get: function() {
            return Object.keys(this.segmentQueues);
          }, enumerable: !1, configurable: !0 }), De.prototype.setDrmConfig = function(Re, Oe) {
            return this.drmService ? this.drmService.updateDrmConfig(Re, Oe) : Promise.reject(ue.DrmSetupError.MISSING_CONFIGURATION);
          }, De.prototype.isMediaTypeSupported = function(Re, Oe) {
            return (0, Ie.shouldUseManagedMediaSource)(this.context.settings.PREFER_MANAGED_MEDIA_SOURCE) ? window.ManagedMediaSource.isTypeSupported(Re + '; codecs="' + Oe + '"') : "MediaSource" in window && MediaSource.isTypeSupported(Re + '; codecs="' + Oe + '"');
          }, De.prototype.cancelPendingEndOfStream = function() {
            this.setEndOfStreamDeferred && (this.setEndOfStreamDeferred.reject(new Error("Cancelled pending end of stream.")), this.setEndOfStreamDeferred = void 0);
          }, De.prototype.deferSetEndOfStream = function() {
            var Re = this;
            return this.setEndOfStreamDeferred = this.setEndOfStreamDeferred || new $e.Deferred(), this.setEndOfStreamDeferred.promise.then(function() {
              var Oe;
              return (Oe = Re.mse) === null || Oe === void 0 ? void 0 : Oe.endOfStream();
            }).catch(function(Oe) {
              (0, pe.isContextAvailable)(Re.context) && Re.context.logger.debug(Oe);
            });
          }, De.prototype.setEndOfStream = function(Re) {
            if (Re === void 0 && (Re = !0), !Re)
              return this.cancelPendingEndOfStream(), this.isMSEOpen() ? Promise.resolve() : this.reOpenMse();
            if (!this.hasSourceBuffers() || !this.mse)
              return this.logger.debug("Cannot signal EOS as no buffers have been added yet"), Promise.resolve();
            var Oe = this.getEndOfBufferTime();
            return this.setCurrentTimeDelayedContext && this.setCurrentTimeDelayedContext.time >= this.duration && Oe && !isNaN(Oe) && this.cancelSetCurrentTimeDelayed(), this.setCurrentTimeDelayedContext ? this.deferSetEndOfStream() : this.mse.endOfStream();
          }, De.prototype.isTimeInRangePendingRemoval = function(Re) {
            var Oe = this.getRangesPendingRemoval();
            for (var Be in Oe) {
              var Fe = Oe[Be];
              if (Fe.start <= Re && Fe.end >= Re)
                return !0;
            }
            return !1;
          }, De.prototype.isTimeInBuffer = function(Re, Oe) {
            if (Oe === void 0 && (Oe = 0), this.isTimeInRangePendingRemoval(Re))
              return !1;
            var Be = this.getRangesInSourceBuffers();
            return !!Be && Object.keys(Be).every(function(Fe) {
              return (0, ae.isInTimeRanges)(Be[Fe], Re, Oe);
            });
          }, De.prototype.ensureSafeDistanceToEndOfBuffer = function(Re, Oe) {
            var Be, Fe = (Be = this.getRangesInSourceBuffers()) !== null && Be !== void 0 ? Be : {}, Ve = Object.keys(Fe), Ke = Le(Fe, Re);
            if (Ve.length === 0 || Ke.length < Ve.length)
              return NaN;
            var Ze = Math.min.apply(Math, Ke.map(function(Qe) {
              var qe;
              return (qe = Qe == null ? void 0 : Qe.end) !== null && qe !== void 0 ? qe : 1 / 0;
            })), nt = Ze - Re;
            return nt >= Oe ? Re : Re - (Oe - nt);
          }, De.prototype.adjustTimeToNextCommonBufferStart = function(Re) {
            var Oe, Be, Fe, Ve = (Oe = (0, ve.getSourceState)(this.context)) === null || Oe === void 0 ? void 0 : Oe.drm, Ke = (0, Ce.getBufferEndSafetyMargin)(Ve);
            if (this.isTimeInBuffer(Re, Ke))
              return Re;
            var Ze = this.isTimeInBuffer(Re), nt = this.getFutureBufferStarts(Re).filter(function(je) {
              return je >= Re;
            }), Qe = nt.length === 0;
            if (Ze && Qe) {
              var qe = this.ensureSafeDistanceToEndOfBuffer(Re, Ke), ze = (Fe = (Be = (0, ve.getSourceState)(this.context)) === null || Be === void 0 ? void 0 : Be.buffer.isLoadingRangeFinished) === null || Fe === void 0 || Fe;
              return qe === Re || ze ? !isNaN(qe) && this.isTimeInBuffer(qe) ? (this.logger.debug("Adjusting current time away from end of buffer: ".concat(qe)), qe) : Re : (this.logger.debug("Not adjusting seek target, because there will be future data"), NaN);
            }
            return !Ze && Qe ? NaN : (Re = Math.min.apply(null, nt), this.logger.debug("Adjusting current time to next buffer start: ".concat(Re)), Re);
          }, De.prototype.getFutureBufferStarts = function(Re) {
            var Oe, Be = this.getRangesInSourceBuffers();
            if (!Be)
              return [];
            if (this.mse) {
              var Fe = this.getRangesPendingRemoval();
              Oe = Object.keys(Fe).map(function(Ve) {
                return Fe[Ve];
              });
            } else
              Oe = [];
            return ae.BufferRangeHelper.getCommonBufferedRanges(Be).filter(function(Ve) {
              return Ve.getEnd() >= Re && !isNaN(Ve.getStart());
            }).filter(function(Ve) {
              return Oe.every(function(Ke) {
                return (0, ae.areDisjoint)(Ke, { start: Ve.getStart(), end: Ve.getEnd() });
              });
            }).map(function(Ve) {
              return Ve.getStart();
            });
          }, De.prototype.getRangesInSourceBuffers = function() {
            if (!this.mse)
              return null;
            var Re = {};
            for (var Oe in this.segmentQueues)
              if (this.segmentQueues.hasOwnProperty(Oe) && (Re[Oe] = this.mse.getBufferedRanges(Oe), Re[Oe].length < 1))
                return null;
            return Object.keys(Re).length ? Re : null;
          }, De.prototype.getRangesPendingRemoval = function() {
            if (!this.mse || !this.mse.isBufferRemovalPending())
              return {};
            var Re = {};
            for (var Oe in this.segmentQueues) {
              var Be = this.mse.getRangePendingRemoval(Oe);
              this.segmentQueues.hasOwnProperty(Oe) && Be && (Re[Oe] = Be);
            }
            return Re;
          }, De.prototype.processSegmentQueues = function() {
            var Re = this, Oe = this.segmentQueueMimeTypes.filter(function(Be) {
              return Re.segmentQueues[Be].length > 0;
            }).map(function(Be) {
              return Re.addSegmentFromQueueToMse(Be);
            });
            return Oe.length === 0 ? Promise.resolve() : Promise.all(Oe).then(function() {
              return Re.processSegmentQueues();
            }).catch(function(Be) {
              if (Be !== ue.SOURCE_BUFFER_APPEND_STATUS.SUSPENDED)
                throw Be;
            });
          }, De.prototype.getHeadOfQueue = function(Re) {
            return this.segmentQueues[Re][0];
          }, De.prototype.isMSEOpen = function() {
            var Re;
            return ((Re = this.mse) === null || Re === void 0 ? void 0 : Re.readyState) === Ne.MediaSourceReadyState.open;
          }, De.prototype.maybeWaitForDrmLicense = function(Re) {
            var Oe, Be = (Oe = (0, ve.getSourceState)(this.context)) === null || Oe === void 0 ? void 0 : Oe.drm;
            return this.context.serviceManager.maybeCall(le.ServiceName.DrmService, function(Fe) {
              return Fe.maybeWaitForDrmLicense(Re, Be);
            }, Promise.resolve());
          }, De.prototype.addSegmentFromQueueToMse = function(Re) {
            var Oe = this;
            if (!this.mse)
              return Promise.resolve();
            var Be = Promise.resolve();
            this.isMSEOpen() || (Be = this.reOpenMse());
            var Fe = this.getHeadOfQueue(Re);
            if (!Fe)
              return Promise.resolve();
            var Ve = Fe.getRepresentationId().representationId, Ke = Fe.getUrl();
            return this.context.logger.debug("[MSERenderer][".concat(Re, "][").concat(Ve, "] Scheduling appendage to buffer [url=").concat(Ke, "], DRM key ID (").concat(Fe.getDrmKid(), ")")), Be.then(function() {
              return Oe.maybeWaitForDrmLicense(Fe);
            }).then(function() {
              return Oe.mse ? Oe.segmentQueues[Re].includes(Fe) ? Oe.mse.addToBuffer(Fe).then(function() {
                var Ze = Oe.getHeadOfQueue(Re) !== Fe;
                if (Oe.logger.debug("[MSERenderer][".concat(Re, "][").concat(Ve, "] Appended segment to buffer [url=").concat(Ke, "]")), Ze) {
                  var nt = Oe.segmentQueues[Re][0], Qe = nt ? nt.getUrl() : "none";
                  Oe.logger.debug("[MSERenderer][".concat(Re, "][").concat(Ve, "] Skipping removal of [url=").concat(Ke, "] ") + "from segment queue as the queue head has unexpectedly changed to [url=".concat(Qe, "]"));
                } else
                  Oe.segmentQueues[Re].shift();
                Oe.drmService && Oe.hasDataInSourceBuffers() && !(0, ye.isSwitchingBufferBlocks)((0, ve.getSourceStore)(Oe.context)) && Oe.drmService.signalInitDataShouldBeAvailable();
              }) : (Oe.logger.debug("[MSERenderer][".concat(Re, "][").concat(Ve, "] Segment ").concat(Fe.getUrl(), " no longer part of the queue - skipping appendage")), Promise.resolve()) : Promise.reject(ue.SOURCE_BUFFER_APPEND_STATUS.FAILURE);
            }).catch(function(Ze) {
              if (Oe.logger.debug("[MSERenderer][".concat(Re, "][").concat(Ve, "] Adding segment from queue to buffer failed"), Ze), Ze === ue.SOURCE_BUFFER_APPEND_STATUS.FAILURE && Oe.trackRendererError(Fe), Oe.mse && Ze === ue.SOURCE_BUFFER_APPEND_STATUS.QUOTA_EXCEEDED) {
                Oe.quotaExceededMap.set(Re, !0);
                var nt = Oe.quotaExceededDeferredMap.get(Re);
                return nt || (nt = new $e.Deferred(), Oe.quotaExceededDeferredMap.set(Re, nt)), Oe.mse.addOneUpdateEndCallback(Re, nt.resolve).then(function() {
                  Oe.quotaExceededDeferredMap.delete(Re), Oe.context.logger.debug("Appending segment after quota has been exceeded...");
                }), nt.promise.then(function() {
                  return Oe.processSegmentQueues();
                });
              }
              return Oe.mse ? Oe.mse.queueActionOnBuffer(Re, function() {
                return Oe.processSegmentQueues();
              }) : Promise.reject(Ze);
            });
          }, De.prototype.cancelSetCurrentTimeDelayed = function() {
            this.setCurrentTimeDelayedContext && (this.context.logger.debug("Cancelling delayed set currentTime to ".concat(this.setCurrentTimeDelayedContext.time)), this.setCurrentTimeDelayedContext.unsubscribeFromSourceStore(), this.setCurrentTimeDelayedContext.deferred.reject("cancelled seek"), this.setCurrentTimeDelayedContext = void 0);
          }, De.prototype.recoverFromExceededQuota = function(Re) {
            var Oe = this;
            this.segmentQueueMimeTypes.forEach(function(Be) {
              Oe.segmentQueues[Be] = Oe.segmentQueues[Be].filter(function(Fe) {
                return Fe.getPlaybackTime() + Fe.getDuration() >= Re;
              }), Oe.updateRendererRangesInStore(Be), Oe.quotaExceededMap.set(Be, !1);
            }), this.quotaExceededDeferredMap.forEach(function(Be) {
              return Be.reject();
            }), this.quotaExceededDeferredMap.clear();
          }, De.prototype.resolvePendingEndOfStream = function() {
            this.setEndOfStreamDeferred && (this.setEndOfStreamDeferred.resolve(), this.setEndOfStreamDeferred = void 0);
          }, De.prototype.setCurrentTimeInternal = function(Re) {
            var Oe = this;
            if (!this.mse)
              return Promise.reject("Couldn't set current time, MSE is not open");
            ke(this.quotaExceededMap, function(Fe) {
              return Fe;
            }) && this.recoverFromExceededQuota(Re);
            var Be = this.mse.waitForBuffers().then(function() {
              return Oe.waitingForSeekedPromise;
            }).then(function() {
              if (Oe.setCurrentTimeContext) {
                if (Oe.setCurrentTimeContext.time !== Re)
                  return Promise.reject("A newer setting of change time has been scheduled.");
              } else
                Oe.setCurrentTimeContext = { time: Re, isInitialSeek: !1, promise: Be };
              var Fe = Oe.adjustTimeToNextCommonBufferStart(Re);
              return isNaN(Fe) ? Oe.waitForDataInBuffer(Re) : Fe;
            }).then(function(Fe) {
              var Ve, Ke, Ze, nt, Qe = (Ke = (Ve = Oe.video) === null || Ve === void 0 ? void 0 : Ve.currentTime) !== null && Ke !== void 0 ? Ke : 0, qe = !Oe.isPaused();
              return !((Ze = Oe.setCurrentTimeContext) === null || Ze === void 0) && Ze.isInitialSeek && qe && Qe > Fe ? (Oe.logger.debug("Skip initial seek to ".concat(Fe, " as playback has started and is already at ").concat(Qe)), nt = Promise.resolve(Qe)) : (Oe.logger.debug("set time on video element to ".concat(Fe)), nt = Oe.seekOnVideoElement(Fe)), nt.then(function(ze) {
                return Oe.resolvePendingEndOfStream(), ze;
              }).catch(function(ze) {
                return Oe.handleVideoSetCurrentTimeError(Fe, ze);
              }).finally(function() {
                Oe.waitingForSeekedPromise = null, Oe.setCurrentTimeContext = void 0, Oe.savedCurrentTime = 0;
              });
            });
            return Be;
          }, De.prototype.waitForDataInBuffer = function(Re) {
            var Oe = this;
            this.context.logger.debug("Delaying seek, waiting for data in buffer for time ".concat(Re));
            var Be = (0, ve.getSourceStore)(this.context);
            if (!Be)
              return Promise.reject(new Error("No source store available"));
            var Fe = new $e.Deferred(), Ve = function() {
              var Ze = Oe.adjustTimeToNextCommonBufferStart(Re);
              isNaN(Ze) ? Oe.context.logger.debug("Re-evaluated delayed seek to ".concat(Re, ": Cannot yet resolve, waiting for data in buffer")) : (Ke(), Oe.context.logger.debug("Re-evaluated delayed seek to ".concat(Re, ": Resolving with seek target ").concat(Ze)), Oe.setCurrentTimeDelayedContext = void 0, Fe.resolve(Ze));
            }, Ke = (0, be.subscribe)(Be)(function(Ze) {
              return (0, Ee.getBufferState)(Ze);
            }, function() {
              var Ze;
              (Ze = Oe.setCurrentTimeDelayedContext) === null || Ze === void 0 || Ze.reevaluateDataInBuffer();
            }, function(Ze, nt) {
              return !!(Ze != null && Ze.isLoadingRangeFinished && !(nt != null && nt.isLoadingRangeFinished));
            });
            return this.setCurrentTimeDelayedContext = { time: Re, reevaluateDataInBuffer: Ve, deferred: Fe, unsubscribeFromSourceStore: Ke }, Fe.promise;
          }, De.prototype.handleVideoSetCurrentTimeError = function(Re, Oe) {
            return this.logger.debug("failed to set current time", Oe), this.waitingForSeekedPromise = null, this.setCurrentTimeInternal(Re);
          }, De.prototype.seekOnVideoElement = function(Re) {
            var Oe = this;
            return this.waitingForSeekedPromise = new Promise(function(Be, Fe) {
              Oe.video ? (Oe.video.currentTime = Re, Be(Oe.video.currentTime)) : Fe("No video reference");
            }), this.waitingForSeekedPromise;
          }, De.prototype.saveCurrentTime = function() {
            this.setCurrentTimeContext ? this.savedCurrentTime = this.setCurrentTimeContext.time : this.savedCurrentTime = this.getCurrentVideoTime();
          }, De.prototype.recreateSourceBuffers = function(Re) {
            var Oe = this;
            return Re === void 0 && (Re = this.getCurrentTime()), this.shutdown(!1).then(function() {
              return Oe.ready();
            }).then(function() {
              Oe.sourceBufferMimeCodecMap.forEach(function(Be, Fe) {
                Oe.addBuffer(Be, Fe) || (Oe.context.logger.debug("Failed to create source buffer ".concat(Be)), Oe.sourceBufferMimeCodecMap.remove(Be));
              });
            }).then(function() {
              Oe.setCurrentTime(Re).then(function() {
                var Be, Fe;
                return !((Fe = (Be = Oe.context.serviceManager) === null || Be === void 0 ? void 0 : Be.get(le.ServiceName.PlayerStateService)) === null || Fe === void 0) && Fe.isPlaying() ? Oe.play() : Promise.resolve();
              });
            });
          }, De.prototype.updateSegmentQueueMimeType = function(Re) {
            var Oe, Be = this, Fe = Se.MimeTypeHelper.getMediaType(Re);
            this.segmentQueueMimeTypes.forEach(function(Ve) {
              var Ke;
              Se.MimeTypeHelper.getMediaType(Ve) === Fe && (delete Be.segmentQueues[Ve], (Ke = (0, ve.getSourceStore)(Be.context)) === null || Ke === void 0 || Ke.dispatch((0, Te.setRendererRanges)(Ve, [])));
            }), this.segmentQueues[Re] = [], (Oe = (0, ve.getSourceStore)(this.context)) === null || Oe === void 0 || Oe.dispatch((0, Te.setRendererRanges)(Re, []));
          }, De.prototype.changeBufferType = function(Re, Oe) {
            var Be = this;
            return this.sourceBufferMimeCodecMap.update(Re, Oe), this.updateSegmentQueueMimeType(Re), this.mse && this.mse.isChangeTypeSupported() ? this.mse.changeBufferType(Re, Oe).then(function() {
              var Fe;
              return (Fe = {})[Re] = Oe, Fe;
            }).catch(function(Fe) {
              return Be.logger.debug("Failed to change buffer type to ".concat(Re, " ").concat(Oe, ":"), Fe), Be.recreateSourceBuffers().then(function() {
                return Be.sourceBufferMimeCodecMap.entries();
              });
            }) : this.recreateSourceBuffers().then(function() {
              return Be.sourceBufferMimeCodecMap.entries();
            });
          }, De.prototype.shouldContinueBuffering = function() {
            var Re, Oe;
            return (Oe = (Re = this.mse) === null || Re === void 0 ? void 0 : Re.shouldContinueBuffering) !== null && Oe !== void 0 && Oe;
          }, De;
        }();
        function ke(De, Re) {
          var Oe = !1;
          return De.forEach(function(Be) {
            return Oe = Oe || Re(Be);
          }), Oe;
        }
        function Le(De, Re) {
          return Object.keys(De).map(function(Oe) {
            return De[Oe].find(function(Be) {
              return (0, ae.isInTimeRanges)([Be], Re);
            });
          }).filter(we.isDefined);
        }
        ie.MSERenderer = Ue;
      }, 58765: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ce) {
            for (var Ie, xe = 1, Ue = arguments.length; xe < Ue; xe++)
              for (var ke in Ie = arguments[xe])
                Object.prototype.hasOwnProperty.call(Ie, ke) && (Ce[ke] = Ie[ke]);
            return Ce;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MSEWrapper = ie.MediaSourceReadyState = void 0;
        var ue, _e = ne(52442), fe = ne(25550), le = ne(28764), se = ne(63546), oe = ne(35148), ce = ne(62510), he = ne(58935), ge = ne(11399), ve = ne(96873), me = ne(60627), be = ne(27279), pe = ne(13533), $e = ne(10981), ye = ne(79814), Se = ne(56435), we = ne(70016), Pe = ne(61878), Te = ne(73904), Ee = ne(24869), Me = ne(1504);
        (function(Ce) {
          Ce.closed = "closed", Ce.open = "open", Ce.ended = "ended";
        })(ue || (ie.MediaSourceReadyState = ue = {}));
        var Ae = function() {
          function Ce(Ie) {
            var xe = this;
            this.postBufferRemoval = function(Ue, ke, Le) {
              xe.logger.debug("successfully removed buffer for ".concat(Ue, " (from  ").concat(ke, " to ").concat(Le, ")"));
            }, this.waitForBuffer = function(Ue) {
              return xe.sourceBuffers.hasOwnProperty(Ue) ? xe.mseReady().then(function() {
                return xe.sourceBuffers[Ue].ready();
              }) : Promise.reject("No SourceBuffer for '".concat(Ue, "' available"));
            }, this.startStreaming = function() {
              xe.logger.debug("[MSEWrapper][ManagedMediaSource] Start Streaming received, resuming loading"), xe.shouldContinueStreaming = !0;
            }, this.endStreaming = function() {
              xe.logger.debug("[MSEWrapper][ManagedMediaSource] Stop Streaming received, stopping loading"), xe.shouldContinueStreaming = !1;
            }, this.bufferedChange = function(Ue) {
              xe.logger.isLevelEnabled(he.LogLevel.DEBUG) && xe.logger.debug("Received bufferedChange event, Added Ranges: ".concat(Ne(Ue.addedRanges), ", Removed Ranges: ").concat(Ne(Ue.removedRanges)));
            }, Ie.videoElement && (this.context = Ie, this.logger = Ie.logger, this.video = Ie.videoElement, this.sourceBuffers = {}, this.isInit = !1, this.teardownInProgressPromise = Promise.resolve(), this.shouldContinueStreaming = !0);
          }
          return Ce.prototype.getBufferedRanges = function(Ie) {
            return this.sourceBuffers.hasOwnProperty(Ie) ? this.sourceBuffers[Ie].bufferedRanges : [];
          }, Ce.prototype.printDetailedBufferRange = function(Ie, xe) {
            var Ue;
            try {
              Ue = Ie.buffered;
            } catch {
              return void this.logger.debug("".concat(xe, " buffer range: Error accessing buffered ranges"));
            }
            if (Ue.length !== 0)
              for (var ke = 0; ke < Ue.length; ke++)
                this.logger.debug("".concat(xe, " buffer range [").concat(ke, "]: ").concat(Ue.start(ke), " - ").concat(Ue.end(ke)));
            else
              this.logger.debug("".concat(xe, " buffer range: empty"));
          }, Ce.prototype.getBufferStartTime = function() {
            var Ie = this, xe = Object.keys(this.sourceBuffers).map(function(Ue) {
              return Ie.sourceBuffers[Ue].bufferedRanges.length === 0 ? 0 : Ie.sourceBuffers[Ue].bufferedRanges[0].start;
            });
            return Math.max.apply(null, xe);
          }, Ce.prototype.addBuffer = function(Ie, xe, Ue) {
            var ke = this;
            if (this.mediaSource) {
              if (this.isInit && !this.sourceBuffers.hasOwnProperty(Ie))
                try {
                  var Le = this.mediaSource.addSourceBuffer(Ie + "; codecs=" + xe);
                  this.sourceBuffers[Ie] = new Ee.SourceBufferWrapper(Le, function(De) {
                    Ue(De), ke.context.logger.isLevelEnabled(he.LogLevel.DEBUG) && ke.printDetailedBufferRange(Le, Ie);
                  });
                } catch (De) {
                  return this.logger.debug("Could not add SourceBuffer for " + Ie + " with codecs " + xe + ":" + De), void this.context.eventHandler.dispatchEvent(ce.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.SOURCE_CODEC_OR_FILE_FORMAT_NOT_SUPPORTED));
                }
              return this.logger.debug("Added SourceBuffer for " + Ie + " with codecs " + xe), isNaN(this.mediaSource.duration) || (this.sourceBuffers[Ie].appendWindowEnd = this.mediaSource.duration), this.sourceBuffers[Ie].buffer;
            }
          }, Ce.prototype.updateTimestampOffset = function(Ie, xe) {
            var Ue = this.sourceBuffers[Ie];
            Ue && (this.logger.debug("setting new source buffer [".concat(Ie, "] offset from ").concat(Ue.buffer.timestampOffset, " to ").concat(xe)), Ue.buffer.timestampOffset = xe);
          }, Ce.prototype.setTimestampOffset = function(Ie, xe) {
            return this.sourceBuffers.hasOwnProperty(Ie) ? (xe && !isNaN(xe) || (this.logger.debug("source buffer [".concat(Ie, "] offset is ").concat(xe, ", setting it to 0")), xe = 0), this.queueTimestampOffsetUpdate(Ie, xe)) : (this.logger.debug("no such source buffer found (mime type=".concat(Ie, ")")), Promise.resolve());
          }, Ce.prototype.queueTimestampOffsetUpdate = function(Ie, xe) {
            var Ue = this;
            return this.queueActionOnBuffer(Ie, function() {
              return Ue.updateTimestampOffset(Ie, xe);
            }).catch(function(ke) {
              Ue.logger.debug("Failed to set timestamp offset for", Ie, ":", ke);
            });
          }, Ce.prototype.getBufferRangeStart = function(Ie, xe) {
            return xe || Ie.start(0);
          }, Ce.prototype.getBufferRangeEnd = function(Ie, xe) {
            return xe || Ie.end(Ie.length - 1);
          }, Ce.prototype.getBufferRemovalRange = function(Ie, xe, Ue) {
            var ke = this.sourceBuffers[Ie].buffer.buffered;
            return { start: this.getBufferRangeStart(ke, xe), end: this.getBufferRangeEnd(ke, Ue) };
          }, Ce.prototype.preBufferRemoval = function(Ie, xe, Ue) {
            this.logger.debug("removing buffer for ".concat(Ie, " (from ").concat(xe, " to ").concat(Ue, ")"));
          }, Ce.prototype.removeBufferRange = function(Ie, xe, Ue) {
            this.preBufferRemoval(Ie, xe, Ue), this.sourceBuffers[Ie].buffer.remove(xe, Ue);
          }, Ce.prototype.removeFromBuffer = function(Ie, xe, Ue, ke) {
            var Le = this;
            return ke === void 0 && (ke = this.postBufferRemoval), this.queueActionOnBuffer(Ie, function() {
              var De, Re, Oe;
              try {
                if (Le.video && Le.video.currentTime >= 0 && ((Oe = (Re = (De = Le.sourceBuffers[Ie]) === null || De === void 0 ? void 0 : De.buffer) === null || Re === void 0 ? void 0 : Re.buffered) === null || Oe === void 0 ? void 0 : Oe.length) > 0) {
                  var Be = Le.getBufferRemovalRange(Ie, xe, Ue), Fe = Be.start, Ve = Be.end;
                  if (Fe >= 0 && Ve > Fe) {
                    if (Le.sourceBuffers[Ie].removalPending = !0, Le.sourceBuffers[Ie].rangePendingRemoval = { start: Fe, end: Ve }, !Le.mediaSource || Le.mediaSource.readyState === ue.open) {
                      var Ke = Le.sourceBuffers[Ie].onUpdateEnded().then(function() {
                        Le.sourceBuffers[Ie] && (Le.sourceBuffers[Ie].rangePendingRemoval = null, Le.sourceBuffers[Ie].removalPending = !1, ke(Ie, Fe, Ve));
                      });
                      return Le.removeBufferRange(Ie, Fe, Ve), Ke;
                    }
                    Le.logger.debug("cannot remove buffer for " + Ie + " (from " + Fe + " to " + Ve + "): MediaSource is not open"), Le.addOneSourceOpenCallback(function() {
                      Le.removeFromBuffer(Ie, Fe, Ve, ke).catch(function(nt) {
                        Le.logger.debug("Couldn't remove buffer from ".concat(Fe, " to ").concat(Ve, " for ").concat(Ie), nt);
                      });
                    });
                  } else
                    Le.logger.debug("Ignoring buffer clearing request, as the passed-in range is not valid: ".concat(Fe, " to ").concat(Ve));
                } else
                  Le.logger.debug("Ignoring buffer clearing request, as there are no buffered ranges.");
              } catch (nt) {
                var Ze = "".concat(oe.WarningCode[oe.WarningCode.PLAYBACK_WARNING], ". Exception: ").concat(JSON.stringify(nt));
                Le.context.eventHandler.dispatchEvent(ce.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.PLAYBACK_WARNING, Ze));
              }
              return Promise.resolve();
            });
          }, Ce.prototype.removeBuffer = function(Ie) {
            var xe = this, Ue = Promise.resolve(), ke = this.sourceBuffers[Ie];
            if (!ke || !this.mediaSource)
              return Ue;
            if (this.isMediaSourceOpen())
              try {
                ke == null || ke.buffer.abort();
              } catch (Le) {
                return this.logger.debug("Could not abort last action on buffer", ae({}, Le)), Promise.resolve();
              }
            if (ye.MimeTypeHelper.isSubtitle(Ie))
              Ue = Ue.then(function() {
                return xe.removeFromBuffer(Ie).catch(function(Le) {
                  xe.logger.debug("Error removing buffer data", Le);
                });
              });
            else
              try {
                this.mediaSource && this.mediaSource.removeSourceBuffer(ke.buffer);
              } catch (Le) {
                this.logger.debug("Error while trying to remove source buffer.", Le);
              }
            return this.deleteSourceBuffer(Ie), Ue;
          }, Ce.prototype.deleteSourceBuffer = function(Ie) {
            this.sourceBuffers[Ie] ? (this.sourceBuffers[Ie].dispose(), delete this.sourceBuffers[Ie], this.logger.debug("Removed SourceBuffer for ".concat(Ie))) : this.logger.debug("No source buffer to remove for mimeType=".concat(Ie));
          }, Ce.prototype.isMediaSourceOpen = function() {
            var Ie;
            return ((Ie = this.mediaSource) === null || Ie === void 0 ? void 0 : Ie.readyState) === ue.open;
          }, Ce.prototype.resetAllBuffers = function() {
            var Ie = this;
            if (!this.mediaSource)
              return this.logger.debug("Media source is removed. Can not reset buffers."), Promise.resolve();
            var xe = [];
            for (var Ue in this.sourceBuffers)
              this.sourceBuffers.hasOwnProperty(Ue) && xe.push(this.removeBuffer(Ue));
            return Promise.all(xe).then(function() {
              Ie.sourceBuffers = {}, Ie.logger.debug("Removed all SourceBuffers");
            });
          }, Ce.prototype.tearDownMediaSource = function() {
            var Ie = this;
            return this.teardownInProgressPromise = this.teardownInProgressPromise.then(function() {
              return Ie.resetAllBuffers();
            }).then(function() {
              Ie.mediaSource ? Ie.detachVideoElementAndMSE() : Ie.logger.debug("Media source has already been removed.");
            }), this.teardownInProgressPromise;
          }, Ce.prototype.detachVideoElementAndMSE = function() {
            var Ie;
            if (this.video)
              if (this.video.getWrappedElement() !== null) {
                var xe = (0, Te.getMseObjectUrl)((0, be.getSourceState)(this.context));
                if (typeof ((Ie = window == null ? void 0 : window.URL) === null || Ie === void 0 ? void 0 : Ie.revokeObjectURL) == "function" && xe !== "")
                  try {
                    window.URL.revokeObjectURL(xe);
                  } catch {
                    this.logger.debug("Could not revoke MSE object URL");
                  }
                this.mediaSource && (this.mediaSource.removeEventListener("startstreaming", this.startStreaming), this.mediaSource.removeEventListener("endstreaming", this.endStreaming), this.mediaSource.removeEventListener("bufferedchange", this.bufferedChange)), this.mediaSourceReadyDeferred && this.mediaSourceReadyDeferred.reject("MediaSource is being destroyed."), this.mediaSourceReadyDeferred = void 0, this.mediaSourceReadyPromise = void 0, xe === this.video.src && (Pe.VideoElementUtil.removeSource(this.video), this.video.load()), this.mediaSource = void 0, this.isInit = !1, this.logger.debug("Detached video element and MSE");
              } else
                this.logger.debug("No video element to teardown.");
            else
              this.logger.debug("No video wrapper to teardown.");
          }, Ce.prototype.removeUpdateEndCallback = function(Ie, xe) {
            this.sourceBuffers.hasOwnProperty(Ie) && this.sourceBuffers[Ie].buffer.removeEventListener("updateend", xe);
          }, Ce.prototype.addUpdateEndCallback = function(Ie, xe) {
            this.sourceBuffers.hasOwnProperty(Ie) && this.sourceBuffers[Ie].buffer.addEventListener("updateend", xe);
          }, Ce.prototype.addOneUpdateEndCallback = function(Ie, xe) {
            return this.sourceBuffers[Ie].onUpdateEnded().catch(function() {
            }).then(xe);
          }, Ce.prototype.addSourceOpenCallback = function(Ie) {
            this.mediaSource && this.mediaSource.addEventListener("sourceopen", Ie);
          }, Ce.prototype.removeSourceOpenCallback = function(Ie) {
            this.mediaSource && this.mediaSource.removeEventListener("sourceopen", Ie);
          }, Ce.prototype.addOneSourceOpenCallback = function(Ie) {
            var xe = this, Ue = function(ke) {
              xe.removeSourceOpenCallback(Ue), Ie(ke);
            };
            this.addSourceOpenCallback(Ue);
          }, Ce.prototype.isAnyBufferUpdating = function() {
            var Ie = this;
            return Object.keys(this.sourceBuffers).filter(function(xe) {
              return Ie.sourceBuffers[xe].buffer.updating;
            }).length !== 0;
          }, Ce.prototype.setDuration = function(Ie) {
            var xe = this;
            this.queueActionOnBuffers(function() {
              if (xe.mediaSource) {
                var Ue = (0, we.isNumber)(Ie) && Ie > 0 ? Ie : 1 / 0;
                Ue === 1 / 0 && xe.context.settings.MAX_SAFE_MSE_DURATION !== 1 / 0 && (0, we.isNumber)(xe.context.settings.MAX_SAFE_MSE_DURATION) && xe.context.settings.MAX_SAFE_MSE_DURATION > 0 && (Ue = xe.context.settings.MAX_SAFE_MSE_DURATION), xe.mediaSource.duration !== Ue && (xe.isMediaSourceOpen() ? (xe.logger.debug("Setting video duration on MSE: ".concat(xe.mediaSource.duration, " -> ").concat(Ue)), xe.mediaSource.duration = Ue) : xe.logger.debug("Skipping setDuration (".concat(xe.mediaSource.duration, " -> ").concat(Ue, "), MSE is not open")));
              } else
                xe.logger.debug("Skipping setDuration (".concat(Ie, "), MSE is gone"));
            }).catch(function(Ue) {
              xe.logger.debug("Could not set the duration of the MSE!", Ue);
            });
          }, Ce.prototype.getDuration = function() {
            return this.mediaSource && !isNaN(this.mediaSource.duration) ? this.mediaSource.duration : 0;
          }, Ce.prototype.isInitialized = function() {
            return this.isInit;
          }, Object.defineProperty(Ce.prototype, "readyState", { get: function() {
            return this.mediaSource ? this.mediaSource.readyState : void 0;
          }, enumerable: !1, configurable: !0 }), Ce.prototype.isBufferRemovalPending = function() {
            var Ie = this;
            return Object.keys(this.sourceBuffers).some(function(xe) {
              return Ie.sourceBuffers[xe].removalPending;
            });
          }, Ce.prototype.getRangePendingRemoval = function(Ie) {
            var xe, Ue, ke;
            return (ke = (Ue = (xe = this.sourceBuffers) === null || xe === void 0 ? void 0 : xe[Ie]) === null || Ue === void 0 ? void 0 : Ue.rangePendingRemoval) !== null && ke !== void 0 ? ke : void 0;
          }, Ce.prototype.getBufferSizeInSeconds = function(Ie) {
            return this.getBufferedRanges(Ie).reduce(function(xe, Ue) {
              return xe + (Ue.end - Ue.start);
            }, 0);
          }, Ce.prototype.addToBuffer = function(Ie) {
            var xe = this, Ue = Ie.getMimeType();
            return this.queueActionOnBuffer(Ue, function() {
              if (!xe.mediaSource)
                return xe.logger.debug("Could not queue action on SourceBuffer: MediaSource has been destroyed"), Promise.reject(_e.SOURCE_BUFFER_APPEND_STATUS.FAILURE);
              if (xe.mediaSource.readyState !== ue.open)
                return xe.logger.warn("MediaSource is not open (readyState=" + xe.mediaSource.readyState + ")"), Promise.reject(_e.SOURCE_BUFFER_APPEND_STATUS.FAILURE);
              if (!xe.sourceBuffers.hasOwnProperty(Ue))
                return xe.logger.log("sourceBuffers has no entry for " + Ue), Promise.reject(_e.SOURCE_BUFFER_APPEND_STATUS.FAILURE);
              var ke = Ie.getRepresentationId().representationId;
              try {
                xe.logger.debug("[MSEWrapper][".concat(Ue, "][").concat(ke, "] Adding segment to SourceBuffer [").concat(Ie.getUrl(), "]"));
                var Le = xe.sourceBuffers[Ue];
                return Le.buffer.appendBuffer(Ie.getData()), Le.onUpdateEnded();
              } catch (De) {
                return xe.logger.debug("[MSEWrapper][".concat(Ue, "][").concat(ke, "] appendBuffer() failed"), De), De.name && De.name === "QuotaExceededError" ? (xe.logger.debug("QuotaExceededError, trying to remove old data from buffers..."), xe.context.store.dispatch((0, ve.setBufferMaxSize)(Ue, xe.getBufferSizeInSeconds(Ue))), Promise.reject(_e.SOURCE_BUFFER_APPEND_STATUS.QUOTA_EXCEEDED)) : (xe.video && xe.video.error || xe.context.eventHandler.fireError(new le.PlayerError(fe.ErrorCode.UNKNOWN, { exception: De, codec: Ie.getCodec(), mimeType: Ue, segmentUrl: Ie.getUrl() }, "Unexpected error while attempting to append a segment to the SourceBuffer.")), xe.logger.debug("[MSEWrapper][".concat(Ue, "][").concat(ke, "] Failed appending segment to SourceBuffer"), De), Promise.reject(_e.SOURCE_BUFFER_APPEND_STATUS.FAILURE));
              }
            });
          }, Ce.prototype.endOfStream = function() {
            var Ie = this;
            return this.queueActionOnBuffers(function() {
              var xe;
              Ie.isMediaSourceOpen() ? (Ie.logger.debug("Signaled mse end of stream"), (xe = Ie.mediaSource) === null || xe === void 0 || xe.endOfStream()) : Ie.logger.debug("Skipped signaling EOS as the mse is not open");
            }).catch(function(xe) {
              Ie.logger.debug("Unable to signal EOS on media source", xe);
            });
          }, Ce.prototype.waitForBuffers = function() {
            var Ie = Object.keys(this.sourceBuffers).map(this.waitForBuffer);
            return this.mseReady().then(function() {
              return Promise.all(Ie).then(function() {
              });
            });
          }, Ce.prototype.queueActionOnBuffers = function(Ie) {
            var xe = this, Ue = new Promise(function(ke, Le) {
              var De = Object.keys(xe.sourceBuffers).map(function(Re) {
                var Oe = xe.queueActionOnBuffer(Re, function() {
                });
                return xe.queueActionOnBuffer(Re, function() {
                  return Ue;
                }).then().catch(), Oe;
              });
              Promise.all(De).then(function() {
                return ke();
              }, Le);
            }).then(function() {
              return Ie();
            }).then(function() {
              return Promise.all(Object.keys(xe.sourceBuffers).map(function(ke) {
                return xe.sourceBuffers[ke].ready();
              })).then(function() {
              });
            });
            return Ue;
          }, Ce.prototype.queueActionOnBuffer = function(Ie, xe) {
            return this.sourceBuffers.hasOwnProperty(Ie) ? this.sourceBuffers[Ie].queueAction(xe) : Promise.reject("No SourceBuffer for '".concat(Ie, "' available"));
          }, Ce.prototype.rejectMediaSourceReady = function(Ie) {
            var xe, Ue = this;
            return (xe = this.mediaSourceReadyDeferred) === null || xe === void 0 || xe.reject(Ie), this.mediaSourceReadyPromise ? this.mediaSourceReadyPromise.then(function() {
              Ue.mediaSourceReadyDeferred = void 0;
            }) : Promise.reject(Ie);
          }, Ce.prototype.mseReady = function() {
            var Ie, xe = this;
            if (this.mediaSourceReadyPromise)
              return this.mediaSourceReadyPromise;
            this.mediaSourceReadyDeferred = new $e.Deferred(), this.mediaSourceReadyPromise = this.mediaSourceReadyDeferred.promise;
            var Ue = function(Re) {
              var Oe;
              Le(), (Oe = xe.mediaSourceReadyDeferred) === null || Oe === void 0 || Oe.reject(Re);
            }, ke = function() {
              var Re;
              Le(), xe.isInit = !0, xe.isUsingManagedMediaSource || (xe.shouldContinueStreaming = !0), (Re = xe.mediaSourceReadyDeferred) === null || Re === void 0 || Re.resolve();
            }, Le = function() {
              xe.mediaSource && (xe.mediaSource.removeEventListener("error", Ue), xe.mediaSource.removeEventListener("sourceopen", ke), xe.mediaSource.removeEventListener("webkitsourceopen", ke));
            };
            if (!this.video)
              return this.rejectMediaSourceReady("Could not set source to video element");
            if (!this.mediaSource)
              return this.rejectMediaSourceReady("mediaSource must not be null or undefined");
            if (this.mediaSource.addEventListener("error", Ue), this.mediaSource.addEventListener("sourceopen", ke, !1), this.mediaSource.addEventListener("webkitsourceopen", ke, !1), this.isUsingManagedMediaSource && (this.video.disableRemotePlayback = !0, this.mediaSource.addEventListener("startstreaming", this.startStreaming), this.mediaSource.addEventListener("endstreaming", this.endStreaming), this.mediaSource.addEventListener("bufferedchange", this.bufferedChange)), window && window.URL && typeof window.URL.createObjectURL == "function") {
              var De = window.URL.createObjectURL(this.mediaSource);
              this.video.src = De, (Ie = (0, be.getSourceStore)(this.context)) === null || Ie === void 0 || Ie.dispatch((0, me.setMseObjectUrl)(De));
            } else
              this.logger.debug("Could not use window.URL.createObjectURL(mediaSource) as the browser claims the function does not exist."), this.mediaSourceReadyDeferred.reject("Could not create Object URL");
            return this.mediaSourceReadyPromise.then(function() {
              xe.mediaSourceReadyDeferred = void 0;
            });
          }, Object.defineProperty(Ce.prototype, "shouldContinueBuffering", { get: function() {
            return this.shouldContinueStreaming;
          }, enumerable: !1, configurable: !0 }), Ce.prototype.createNewMSE = function() {
            var Ie = this;
            return this.mediaSource ? this.tearDownMediaSource().then(function() {
              return Ie.setNewMediaSource();
            }) : this.teardownInProgressPromise.then(function() {
              return Ie.setNewMediaSource();
            });
          }, Ce.prototype.setNewMediaSource = function() {
            return this.isUsingManagedMediaSource = (0, Me.shouldUseManagedMediaSource)(this.context.settings.PREFER_MANAGED_MEDIA_SOURCE), this.isUsingManagedMediaSource ? (this.logger.debug("[MSEWrapper] Using ManagedMediaSource"), this.mediaSource = new window.ManagedMediaSource()) : (this.logger.debug("[MSEWrapper] Using MediaSource"), this.mediaSource = new window.MediaSource()), this.mseReady();
          }, Ce.prototype.isChangeTypeSupported = function() {
            var Ie, xe, Ue = (0, pe.getCapabilities)(), ke = Ue.isWebOS && Ue[ge.CapabilityKey.webOSChromiumVersion] >= Se.WEBOS_2021_CHROMIUM_VERSION;
            return !!(!((xe = (Ie = window.SourceBuffer) === null || Ie === void 0 ? void 0 : Ie.prototype) === null || xe === void 0) && xe.changeType) && !(0, pe.getCapabilities)().isTizen && !ke;
          }, Ce.prototype.updateSourceBufferKey = function(Ie) {
            var xe = this, Ue = ye.MimeTypeHelper.getMediaType(Ie), ke = Object.keys(this.sourceBuffers).find(function(Le) {
              var De = ye.MimeTypeHelper.getMediaType(Le);
              return xe.sourceBuffers.hasOwnProperty(Le) && De === Ue && Le !== Ie;
            });
            ke && (this.sourceBuffers[Ie] = this.sourceBuffers[ke], delete this.sourceBuffers[ke]);
          }, Ce.prototype.changeBufferType = function(Ie, xe) {
            var Ue = this;
            return this.updateSourceBufferKey(Ie), this.queueActionOnBuffer(Ie, function() {
              Ue.sourceBuffers[Ie].changeType("".concat(Ie, "; codecs=").concat(xe)), Ue.context.logger.debug("Changed ".concat(Ie, " SourceBuffer type with codec=").concat(xe));
            });
          }, Ce.prototype.dispose = function() {
            var Ie = this;
            this.tearDownMediaSource().then(function() {
              Ie.video = void 0;
            });
          }, Ce;
        }();
        function Ne(Ce) {
          for (var Ie = [], xe = 0; xe < (Ce == null ? void 0 : Ce.length); xe++) {
            var Ue = "[".concat(Ce.start(xe), " - ").concat(Ce.end(xe), "]");
            Ie.push(Ue);
          }
          return Ie.toString();
        }
        ie.MSEWrapper = Ae;
      }, 27838: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MSERendererModuleDefinition = void 0;
        var ae = ne(16368), ue = ne(6863), _e = ne(58765), fe = ne(89413), le = ne(98758);
        ie.MSERendererModuleDefinition = { name: ae.ModuleName.RendererMse, module: { MSEWrapper: _e.MSEWrapper, MSERenderer: ue.MSERenderer, Ranges: fe.Ranges, technologyChecker: new le.TechnologyChecker() } }, ie.default = ie.MSERendererModuleDefinition;
      }, 63916: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.LinkedListQueue = void 0;
        var ne = function() {
          function ue(_e) {
            this.value = _e;
          }
          return ue;
        }(), ae = function() {
          function ue() {
            this.count = 0;
          }
          return Object.defineProperty(ue.prototype, "length", { get: function() {
            return this.count;
          }, enumerable: !1, configurable: !0 }), ue.prototype.dequeue = function() {
            if (this.count !== 0) {
              var _e = this.last;
              return this.last = _e == null ? void 0 : _e.previous, _e && (_e.previous = void 0, _e.next = void 0), this.count--, _e == null ? void 0 : _e.value;
            }
          }, ue.prototype.enqueue = function(_e) {
            if (this.count === 0) {
              var fe = new ne(_e);
              this.first = fe, this.last = fe;
            } else {
              var le = this.first;
              this.first = new ne(_e), this.first.next = le, le && (le.previous = this.first);
            }
            this.count++;
          }, ue.prototype.isEmpty = function() {
            return this.length === 0;
          }, ue;
        }();
        ie.LinkedListQueue = ae;
      }, 89413: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.Ranges = void 0;
        var ne = function() {
          function ae() {
          }
          return ae.filterRanges = function(ue, _e) {
            var fe = [];
            if (ue && ue.length)
              for (var le = 0; le < ue.length; le++)
                _e(ue.start(le), ue.end(le)) && fe.push([ue.start(le), ue.end(le)]);
            return ae.createTimeRanges(fe);
          }, ae.createTimeRangesObj = function(ue) {
            return ue === void 0 || ue.length === 0 ? { length: 0, start: function() {
              return 0;
            }, end: function() {
              return 0;
            } } : { length: ue.length, start: function(_e) {
              return ue[_e][0];
            }, end: function(_e) {
              return ue[_e][1];
            } };
          }, ae.createTimeRanges = function(ue, _e) {
            return Array.isArray(ue) ? ae.createTimeRangesObj(ue) : ue === void 0 || _e === void 0 ? ae.createTimeRangesObj() : ae.createTimeRangesObj([[ue, _e]]);
          }, ae.findNextRange = function(ue, _e) {
            return ae.filterRanges(ue, function(fe, le) {
              return fe - ae.TIME_FUDGE_FACTOR >= _e && le - fe > ae.MIN_RANGE_DURATION;
            });
          }, ae.findGaps = function(ue, _e) {
            if (ue.length < 2)
              return ae.createTimeRanges();
            for (var fe = [], le = 1; le < ue.length; le++) {
              var se = ue.end(le - 1), oe = ue.start(le);
              oe - se > _e && fe.push([se, oe]);
            }
            return ae.createTimeRanges(fe);
          }, ae.findRangeForTime = function(ue, _e) {
            return ae.filterRanges(ue, function(fe, le) {
              return fe <= _e && le >= _e;
            });
          }, ae.TIME_FUDGE_FACTOR = 1 / 30, ae.MIN_RANGE_DURATION = 0.2, ae;
        }();
        ie.Ranges = ne;
      }, 73904: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getMseObjectUrl = void 0;
        var ne = function(ae) {
          var ue, _e;
          return (_e = (ue = ae == null ? void 0 : ae.renderer) === null || ue === void 0 ? void 0 : ue.mseObjectUrl) !== null && _e !== void 0 ? _e : "";
        };
        ie.getMseObjectUrl = ne;
      }, 24869: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SourceBufferWrapper = void 0;
        var ae = ne(10981), ue = ne(63916), _e = function() {
          function le(se, oe) {
            var ce = this;
            this.onBufferedRangesChanged = oe, this.onUpdateSuccess = function() {
              ce.updateExposedBufferRanges(), ce.onBufferedRangesChanged(ce.bufferedRanges), ce.cleanUpPendingUpdateEndedPromises(function(he) {
                return he.resolve();
              });
            }, this.onUpdateError = function(he) {
              ce.cleanUpPendingUpdateEndedPromises(function(ge) {
                return ge.reject(he);
              });
            }, this.ready = function() {
              return ce.buffer.updating ? ce.onUpdateEnded() : Promise.resolve();
            }, this.buffer = se, this.bufferedRanges = [], this.queuePromise = Promise.resolve(), this.pendingUpdateEndedPromises = new ue.LinkedListQueue(), ["error", "abort", "sourceended", "sourceclose"].forEach(function(he) {
              ce.buffer.addEventListener(he, ce.onUpdateError);
            }), this.buffer.addEventListener("updateend", this.onUpdateSuccess);
          }
          return le.prototype.cleanUpPendingUpdateEndedPromises = function(se) {
            for (var oe; (oe = this.pendingUpdateEndedPromises.dequeue()) != null; )
              se(oe);
          }, le.prototype.updateExposedBufferRanges = function() {
            try {
              this.bufferedRanges = fe(this.buffer.buffered);
            } catch {
            }
          }, le.prototype.onUpdateEnded = function() {
            var se = new ae.Deferred();
            return this.pendingUpdateEndedPromises.enqueue(se), se.promise;
          }, le.prototype.queueAction = function(se) {
            var oe = this, ce = this.queuePromise.then(function() {
              return oe.ready();
            }).then(function() {
              return Promise.resolve(se()).then(function() {
                return oe.ready();
              });
            });
            return this.queuePromise = ce.catch(function() {
            }), ce;
          }, le.prototype.changeType = function(se) {
            this.buffer.changeType(se);
          }, le.prototype.dispose = function() {
            var se = this;
            ["error", "abort", "sourceended", "sourceclose"].forEach(function(oe) {
              se.buffer.removeEventListener(oe, se.onUpdateError);
            }), this.cleanUpPendingUpdateEndedPromises(function(oe) {
              return oe.reject("disposing source buffer");
            }), this.buffer.removeEventListener("updateend", this.onUpdateSuccess);
          }, le;
        }();
        function fe(le) {
          for (var se = [], oe = 0; oe < le.length; oe++)
            se.push({ start: le.start(oe), end: le.end(oe) });
          return se;
        }
        ie.SourceBufferWrapper = _e;
      }, 98758: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.TechnologyChecker = void 0;
        var ae = ne(33696), ue = function() {
          function _e() {
          }
          return _e.prototype.getSupportedTechnologies = function() {
            return [{ player: ae.PlayerType.Html5, streaming: ae.StreamType.Dash }, { player: ae.PlayerType.Html5, streaming: ae.StreamType.Hls }, { player: ae.PlayerType.Html5, streaming: ae.StreamType.Smooth }];
          }, _e;
        }();
        ie.TechnologyChecker = ue;
      }, 76316: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.VideoEventHandler = void 0;
        var ne = function() {
          function ae(ue) {
            var _e = this;
            this.addTimeToEvent = function(fe) {
              return fe.time = _e.video && _e.video.currentTime || 0, fe;
            }, this.video = ue;
          }
          return ae.prototype.on = function(ue, _e) {
            this.video && this.video.addEventListener(ue, _e, this.addTimeToEvent);
          }, ae.prototype.off = function(ue, _e) {
            this.video && this.video.removeEventListener(ue, _e);
          }, ae.prototype.fire = function(ue, _e) {
            this.video && this.video.eventHandler.triggerEvent(ue, _e);
          }, ae.prototype.dispose = function() {
          }, ae;
        }();
        ie.VideoEventHandler = ne;
      }, 66697: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.getBufferEndSafetyMargin = se;
        var ae = ne(94304), ue = ne(13533), _e = ne(56435), fe = 0.25, le = 1.25;
        function se(oe) {
          var ce = (0, ue.getCapabilities)(), he = ce.isChromium, ge = ce.isChrome, ve = ce.isVizio;
          if (ce.isWebOS || ve || (0, _e.isTizen2018)() || (0, _e.isTizen2019)())
            return le;
          var me = (oe == null ? void 0 : oe.usedKeySystem.kind) === ae.KeySystemKind.PLAYREADY;
          return he && !ge && me ? le : fe;
        }
      }, 1504: function(ee, ie) {
        function ne(ae) {
          return "ManagedMediaSource" in window && (ae || !("MediaSource" in window));
        }
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.shouldUseManagedMediaSource = ne;
      } }, function(ee) {
        return function(ie) {
          return ee(ee.s = ie);
        }(27838);
      }]);
    });
  })();
})(bitmovinplayerMserenderer);
var bitmovinplayerMserendererExports = bitmovinplayerMserenderer.exports;
const MSERendererModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerMserendererExports);
var bitmovinplayerSubtitles = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ie) {
      re.exports = ie();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[482], { 86685: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 });
      }, 29495: function(ee, ie) {
        var ne = this && this.__assign || function() {
          return ne = Object.assign || function(_e) {
            for (var fe, le = 1, se = arguments.length; le < se; le++)
              for (var oe in fe = arguments[le])
                Object.prototype.hasOwnProperty.call(fe, oe) && (_e[oe] = fe[oe]);
            return _e;
          }, ne.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.EnabledSubtitlesTracker = void 0;
        var ae = function() {
          function _e() {
            this.enabledSubtitles = {}, this.idCounter = 0;
          }
          return _e.prototype.addSubtitle = function(fe) {
            this.removeSubtitle(fe.id), this.enabledSubtitles[this.getNextId()] = ne({ isFragmented: !1 }, fe);
          }, _e.prototype.removeSubtitle = function(fe) {
            var le = this;
            Object.keys(this.enabledSubtitles).forEach(function(se) {
              le.enabledSubtitles[se].id === fe && delete le.enabledSubtitles[se];
            });
          }, _e.prototype.shouldEnableSubtitle = function(fe, le) {
            var se = this, oe = Object.keys(this.enabledSubtitles).find(function(ce) {
              return se.getTargetSubtitleIdForPeriod(se.enabledSubtitles[ce], le) === fe.id;
            });
            return !!oe;
          }, _e.prototype.getTargetSubtitleIdForPeriod = function(fe, le) {
            var se = fe.id, oe = fe.kind, ce = fe.lang, he = fe.isFragmented;
            return ue({ lang: ce, kind: oe, isFragmented: he, id: se }, le) || ue({ lang: ce, kind: oe, isFragmented: he }, le) || ue({ lang: ce, kind: oe }, le);
          }, _e.prototype.getNextId = function() {
            return this.idCounter++, this.idCounter;
          }, _e.prototype.dispose = function() {
            this.enabledSubtitles = {}, this.idCounter = 0;
          }, _e;
        }();
        function ue(_e, fe) {
          return Object.keys(fe).find(function(le) {
            var se = fe[le].getSubtitle(), oe = se.id, ce = se.lang, he = se.isFragmented, ge = se.kind, ve = oe === _e.id, me = !_e.isFragmented || he === _e.isFragmented, be = ce === _e.lang;
            _e.isPreferred && _e.lang && (be = ce.includes(_e.lang) || _e.lang.includes(ce));
            var pe = ge === _e.kind && be && me;
            return ve || pe;
          });
        }
        ie.EnabledSubtitlesTracker = ae;
      }, 59272: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ForcedSubtitleController = void 0;
        var ae = ne(70412), ue = function() {
          function _e() {
            this.subtitleHandlers = {};
          }
          return _e.prototype.addSubtitleHandler = function(fe) {
            this.subtitleHandlers[fe.getSubtitle().id] = fe;
          }, _e.prototype.deactivate = function() {
            return this.hasForcedSubtitles() ? Promise.all(Object.values(this.subtitleHandlers).map(function(fe) {
              return fe.deactivate();
            })).then(function() {
            }) : Promise.resolve();
          }, _e.prototype.activate = function(fe) {
            var le = this;
            return fe === void 0 && (fe = this.currentLang), this.hasForcedSubtitles() ? (this.currentLang = fe, this.deactivate().then(function() {
              var se = Object.values(le.subtitleHandlers).find(function(oe) {
                return (0, ae.isEqualIsoLanguage)(oe.getSubtitle().lang, le.currentLang);
              });
              if ((se = se ?? Object.values(le.subtitleHandlers)[0]) && !se.isActive())
                return se.activate().catch(function() {
                });
            })) : Promise.resolve();
          }, _e.prototype.seek = function(fe, le) {
            Object.values(this.subtitleHandlers).forEach(function(se) {
              return se.seek(fe, le);
            });
          }, _e.prototype.dispose = function() {
            Object.values(this.subtitleHandlers).forEach(function(fe) {
              return fe.dispose();
            }), this.subtitleHandlers = null;
          }, _e.prototype.hasForcedSubtitles = function() {
            return Object.keys(this.subtitleHandlers).length > 0;
          }, _e;
        }();
        ie.ForcedSubtitleController = ue;
      }, 64397: function(ee, ie) {
        function ne(le) {
          return ae(_e(le));
        }
        function ae(le) {
          return le.replace(/<[^>]*>?/g, "");
        }
        function ue(le) {
          return le.replace(/(\r\n|\r|\n)/g, "<br />");
        }
        function _e(le) {
          return le.replace(/<br\s*\/?>/g, `
`);
        }
        function fe(le) {
          return le.replace(/<br\s*\/?>/g, "");
        }
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.htmlToText = ne, ie.stripHtmlTags = ae, ie.prepareHtml = ue, ie.replaceHtmlBreakPointsWithNewLine = _e, ie.stripAwayHtmlBreakPoints = fe;
      }, 70412: function(ee, ie) {
        function ne(ae, ue) {
          var _e;
          if (ue === void 0)
            return !1;
          if (!((_e = window.Intl) === null || _e === void 0) && _e.DisplayNames) {
            var fe = new window.Intl.DisplayNames(["en"], { type: "language" });
            try {
              return fe.of(ae.split("-")[0]) === fe.of(ue.split("-")[0]);
            } catch {
            }
          }
          return ae === ue;
        }
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.isEqualIsoLanguage = ne;
      }, 66774: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.parseMP4WrappedSubtitles = se;
        var ae = ne(81361), ue = ne(42283), _e = ne(34586), fe = ne(91520), le = ne(16368);
        function se(ve, me) {
          var be = ve.getTimescale();
          if (be === void 0 || !fe.ModuleManager.has(le.ModuleName.ContainerMP4))
            return [];
          var pe = fe.ModuleManager.get(le.ModuleName.ContainerMP4);
          return oe(pe.getMp4Fragments(ve).flatMap(function($e) {
            return pe.getTrackSamples($e.moof, $e.mdat, ve, me);
          }), ve, be);
        }
        function oe(ve, me, be) {
          var pe = 0, $e = [];
          return ve.forEach(function(ye) {
            var Se = ue.CodecStringHelper.extractCodec(me.getCodec()), we = ye.duration / be, Pe = me.getPlaybackTime() + pe, Te = Pe + we;
            pe += we;
            var Ee = ce(ye, Se);
            Ee && $e.push({ start: Pe, end: Te, text: Ee });
          }), $e;
        }
        function ce(ve, me) {
          return me === "wvtt" || me === "vtt" ? ge(ve) : me === "stpp" ? he(ve) : void 0;
        }
        function he(ve) {
          var me = new Uint8Array(ve.data.buffer, ve.data.byteOffset, ve.data.byteLength);
          return ae.ArrayHelper.convertBufferSourceToUTF8(me, _e.TextSegmentAnalyzer.detectEncoding(ve.data));
        }
        function ge(ve) {
          for (var me = ve.data.buffer, be = ve.data.byteOffset, pe = 0, $e = []; pe < ve.data.byteLength; ) {
            var ye = ve.data.getUint32(pe), Se = be + pe, we = ae.ArrayHelper.convertBufferSourceToUTF8(new Uint8Array(me, Se + 4, 4));
            if (we === "payl") {
              var Pe = ae.ArrayHelper.convertBufferSourceToUTF8(new Uint8Array(me, Se + 8, ye - 8));
              $e.push(Pe), pe += ye;
            } else
              pe += we !== "vttc" ? ye : 8;
          }
          return $e.join("<br>");
        }
      }, 84380: function(ee, ie, ne) {
        var ae = this && this.__createBinding || (Object.create ? function(he, ge, ve, me) {
          me === void 0 && (me = ve);
          var be = Object.getOwnPropertyDescriptor(ge, ve);
          be && !("get" in be ? !ge.__esModule : be.writable || be.configurable) || (be = { enumerable: !0, get: function() {
            return ge[ve];
          } }), Object.defineProperty(he, me, be);
        } : function(he, ge, ve, me) {
          me === void 0 && (me = ve), he[me] = ge[ve];
        }), ue = this && this.__exportStar || function(he, ge) {
          for (var ve in he)
            ve === "default" || Object.prototype.hasOwnProperty.call(ge, ve) || ae(ge, he, ve);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SubtitleModuleDefinition = void 0;
        var _e = ne(16368), fe = ne(64397), le = ne(70412), se = ne(75225), oe = ne(27338), ce = ne(10842);
        ie.SubtitleModuleDefinition = { name: _e.ModuleName.Subtitles, module: function() {
          return { SubtitleService: ce.SubtitleService, SubtitleParserFactory: oe.SubtitleParserFactory, PlayerSubtitlesApiFactory: se.PlayerSubtitlesApiFactory, HtmlTransformer: fe, LanguageComparer: le };
        }, dependencies: [_e.ModuleName.EngineBitmovin] }, ie.default = ie.SubtitleModuleDefinition, ue(ne(86685), ie);
      }, 81253: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.parsePlainTextSubtitles = _e;
        var ae = ne(81361), ue = ne(34586);
        function _e(fe) {
          var le, se, oe = ue.TextSegmentAnalyzer.detectEncoding(fe.getData()), ce = ae.ArrayHelper.convertBufferSourceToUTF8(fe.getData(), oe), he = (le = fe.getPlaybackTime()) !== null && le !== void 0 ? le : 0;
          return [{ start: he, end: he + ((se = fe.getDuration()) !== null && se !== void 0 ? se : 0), text: ce }];
        }
      }, 75225: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(fe) {
            for (var le, se = 1, oe = arguments.length; se < oe; se++)
              for (var ce in le = arguments[se])
                Object.prototype.hasOwnProperty.call(le, ce) && (fe[ce] = le[ce]);
            return fe;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.PlayerSubtitlesApiFactory = void 0;
        var ue = ne(62510), _e = function() {
          function fe() {
          }
          return fe.build = function(le) {
            return new (function() {
              function se() {
              }
              return se.prototype.add = function(oe) {
                le.addSubtitle(oe);
              }, se.prototype.remove = function(oe) {
                le.removeSubtitle(oe);
              }, se.prototype.list = function() {
                return le.listSubtitles();
              }, se.prototype.enable = function(oe, ce) {
                ce === void 0 && (ce = !0), le.enableSubtitle(oe, ce);
              }, se.prototype.disable = function(oe) {
                le.disableSubtitle(oe);
              }, se.prototype.cueEnter = function(oe) {
                le.fireEvent(ue.PlayerEvent.CueEnter, ae(ae({}, oe), { type: ue.PlayerEvent.CueEnter }));
              }, se.prototype.cueExit = function(oe) {
                le.fireEvent(ue.PlayerEvent.CueExit, ae(ae({}, oe), { type: ue.PlayerEvent.CueExit }));
              }, se;
            }())();
          }, fe;
        }();
        ie.PlayerSubtitlesApiFactory = _e;
      }, 27338: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SubtitleParserFactory = void 0;
        var ae = ne(62510), ue = ne(91520), _e = ne(16368), fe = ne(57042), le = function() {
          function se() {
          }
          return se.createInstance = function(oe, ce) {
            var he;
            return ce.indexOf("<?") > -1 || ce.indexOf("<tt") > -1 ? ue.ModuleManager.has(_e.ModuleName.SubtitlesTTML) ? he = new (ue.ModuleManager.get(_e.ModuleName.SubtitlesTTML)).TTMLParser(oe) : oe.eventHandler.dispatchEvent(ae.PlayerEvent.Warning, new fe.PlayerModuleMissingWarning(_e.ModuleName.SubtitlesTTML, "The ".concat(_e.ModuleName.SubtitlesTTML, " module is required to parse TTML subtitles."))) : ue.ModuleManager.has(_e.ModuleName.SubtitlesWebVTT) ? he = new (ue.ModuleManager.get(_e.ModuleName.SubtitlesWebVTT)).WebVttParser() : oe.eventHandler.dispatchEvent(ae.PlayerEvent.Warning, new fe.PlayerModuleMissingWarning(_e.ModuleName.SubtitlesWebVTT, "The ".concat(_e.ModuleName.SubtitlesWebVTT, " module is required to parse WebVTT subtitles."))), he;
          }, se;
        }();
        ie.SubtitleParserFactory = le;
      }, 10842: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Te) {
            for (var Ee, Me = 1, Ae = arguments.length; Me < Ae; Me++)
              for (var Ne in Ee = arguments[Me])
                Object.prototype.hasOwnProperty.call(Ee, Ne) && (Te[Ne] = Ee[Ne]);
            return Te;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SubtitleService = void 0;
        var ue = ne(18665), _e = ne(60997), fe = ne(62510), le = ne(76650), se = ne(3464), oe = ne(79814), ce = ne(91520), he = ne(16368), ge = ne(57042), ve = ne(29495), me = ne(59272), be = ne(68466), pe = ne(45684), $e = ne(14200), ye = ne(8679), Se = ne(24855), we = function() {
          function Te(Ee) {
            var Me = this;
            this.context = Ee, this.getTransmuxer = function() {
              return Me.transmuxer;
            }, this.onDiscontinuitySequenceNumberChanged = function() {
              Me.resetCaptionExtractor();
            }, this.onSeek = function(Ae) {
              Me.timeBeforeSeek = Ae.position;
            }, this.onSeeked = function() {
              var Ae;
              Me.resetCaptionExtractor();
              var Ne = (Ae = Me.timeBeforeSeek) !== null && Ae !== void 0 ? Ae : 0, Ce = Me.context.internalPlayer.getCurrentTime();
              Object.values(Me.subtitleHandlers).forEach(function(Ie) {
                return Ie.seek(Ne, Ce);
              }), Me.forcedSubtitleController.seek(Ne, Ce);
            }, this.handlePeriodUpdate = function(Ae, Ne) {
              Me.context.logger.debug("Switching periods in subtitleService");
              var Ce = Me.manifestService.findPeriod(Ae);
              Ce ? (Me.adjustSubtitleHandlersForNewPeriod(Ae, Ne), Me.setupControllersForNextPeriod(Ce), Me.reactivateAfterSwitched()) : Me.context.logger.log("Can not find period with id = ".concat(Ae, " in Manifest. Skipping period update"));
            }, this.reset = function() {
              Object.keys(Me.subtitleHandlers).forEach(function(Ae) {
                return Me.subtitleHandlers[Ae].dispose();
              }), Me.subtitleHandlers = {}, Me.cea608Extractor && (Me.cea608Extractor.dispose(), Me.cea608Extractor = void 0), Me.discontinuitySequenceNumberTracker && Me.discontinuitySequenceNumberTracker.reset();
            }, this.subtitleHandlers = {}, this.eventHandler = Ee.eventHandler, this.manifestService = Ee.serviceManager.get(ue.ServiceName.ManifestService, Ee.sourceContext.sourceIdentifier), this.enabledSubtitlesTracker = new ve.EnabledSubtitlesTracker(), this.forcedSubtitleController = new me.ForcedSubtitleController(), this.eventHandler.on(fe.PlayerEvent.Seek, this.onSeek), this.eventHandler.on(fe.PlayerEvent.TimeShift, this.onSeek), this.eventHandler.on(fe.PlayerEvent.Seeked, this.onSeeked), this.eventHandler.on(fe.PlayerEvent.TimeShifted, this.onSeeked), this.eventHandler.on(fe.PlayerEvent.SourceUnloaded, this.reset), this.subscribeToPeriodSwitch();
          }
          return Te.prototype.shouldReactToPeriodUpdate = function(Ee, Me) {
            var Ae = Ee !== Me, Ne = this.manifestService.isHlsManifest() && !(Me || !Ee);
            return Ae || Ne;
          }, Te.prototype.subscribeToPeriodSwitch = function() {
            var Ee = this, Me = this.context.serviceManager.get(ue.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
            this.unsubscibeFromPeriodSwitch = (0, se.subscribe)(Me)(ce.ModuleManager.get(he.ModuleName.EngineBitmovin).selectors.getPlayingPeriodId, this.handlePeriodUpdate, function(Ae, Ne) {
              return Ee.shouldReactToPeriodUpdate(Ae, Ne);
            });
          }, Te.prototype.setupControllersForNextPeriod = function(Ee) {
            var Me = this, Ae = ce.ModuleManager.get(he.ModuleName.EngineBitmovin).getMimeTypeForAdaptationSet;
            Ee.AdaptationSet.forEach(function(Ne) {
              var Ce = Ae(Ne);
              (0, Se.isSubtitleTrack)(Ce, Me.manifestService.isHlsManifest()) && Me.setupControllerForSubtitleAdaptationSet(Ne, Ce);
            });
          }, Te.prototype.setupControllerForSubtitleAdaptationSet = function(Ee, Me) {
            if ((0, Se.isFragmentedAdaptationSet)(Ee))
              return this.context.store.dispatch((0, le.initializeMetricsForMimeType)(Me, this.context.settings)), void this.addFragmentedSubtitleTrack(Ee, Me);
            this.addExternalSubtitleTrack(Ee, Me);
          }, Te.prototype.addFragmentedSubtitleTrack = function(Ee, Me) {
            var Ae = this.context.sourceContext.sourceIdentifier, Ne = this.context.serviceManager.get(ue.ServiceName.SourceStoreService, this.context.sourceContext.sourceIdentifier);
            if (Ne) {
              var Ce = { mimeType: Me, codec: ce.ModuleManager.get(he.ModuleName.EngineBitmovin).getCodecsFromAdaptationSet(Ee), isHls: this.manifestService.isHlsManifest(), manifestLoader: this.context.serviceManager.get(ue.ServiceName.ManifestLoadingService, Ae), periodId: Ee._internalId.periodId, sourceStore: Ne };
              this.addFragmentSubtitle(Ce, Ee);
            }
          }, Te.prototype.addExternalSubtitleTrack = function(Ee, Me) {
            if (ce.ModuleManager.has(he.ModuleName.DASH)) {
              var Ae = new (ce.ModuleManager.get(he.ModuleName.DASH)).SegmentTemplateMPDHandler(this.context), Ne = this.manifestService.toSubtitleTrack(Ee, Me);
              Ae.setAdaptationSetId(Ee._internalId), Ne.url = Ae.getSubtitleUrl().toString(), this.addExternalSubtitle(Ne, Ee);
            }
          }, Te.prototype.setTransmuxer = function(Ee) {
            this.transmuxer = Ee;
          }, Te.prototype.hasSubtitle = function(Ee) {
            return !!this.subtitleHandlers[Ee];
          }, Te.prototype.enableSubtitle = function(Ee) {
            var Me = this, Ae = this.subtitleHandlers[Ee];
            return Ae && !Ae.isActive() ? Ae.activate().then(function() {
              Ae.refresh(), Me.forcedSubtitleController.deactivate();
            }).then(function() {
              return Me.enabledSubtitlesTracker.addSubtitle(Ae.getSubtitle()), !0;
            }).catch(function(Ne) {
              return Me.context.logger.debug("Error during subtitle activation", Ne), !1;
            }) : Promise.resolve(!1);
          }, Te.prototype.addExternalSubtitle = function(Ee, Me) {
            Me === void 0 && (Me = null), Ee.id || (Ee.id = Ee.url);
            var Ae = new pe.ExternalFileSubtitleHandler(this.context, Ee, Me);
            return this.reactivateHandler(Ae), Ee;
          }, Te.prototype.reactivateHandler = function(Ee) {
            var Me = Ee.getSubtitle(), Ae = this.context.config.playback.isForcedSubtitle;
            if (typeof Ae == "function" ? Ae(Me) : Me.forced)
              this.forcedSubtitleController.addSubtitleHandler(Ee);
            else {
              var Ne = !1, Ce = Me.id;
              this.subtitleHandlers[Ce] && (Ne = this.subtitleHandlers[Ce].isActive(), this.removeSubtitleHandler(Ce)), this.addSubtitleHandler(Ee), Ne && Ee.activate();
            }
          }, Te.prototype.addSubtitleHandler = function(Ee) {
            var Me = Ee.getSubtitle();
            this.applyLabelFunctionForSubtitle(Me), this.subtitleHandlers[Me.id] = Ee, this.signalNewSubtitle(Me);
          }, Te.prototype.applyLabelFunctionForSubtitle = function(Ee) {
            var Me, Ae, Ne = this.context.sourceContext.source.labeling, Ce = this.manifestService.isHlsManifest() ? (Me = Ne == null ? void 0 : Ne.hls) === null || Me === void 0 ? void 0 : Me.subtitles : (Ae = Ne == null ? void 0 : Ne.dash) === null || Ae === void 0 ? void 0 : Ae.subtitles;
            typeof Ce == "function" && (Ee.label = Ce(Ee));
          }, Te.prototype.addFragmentSubtitle = function(Ee, Me) {
            if (!ce.ModuleManager.has(he.ModuleName.EngineBitmovin))
              return this.context.logger.warn("Unable to add fragmented subtitles because MSE Module is missing"), null;
            var Ae = this.manifestService.toSubtitleTrack(Me, Ee.mimeType);
            Ae.isFragmented = !0, Ae.url = null;
            var Ne = new $e.FragmentedSubtitleHandler(this.context, Ee, Ae, this.getTransmuxer);
            return this.reactivateHandler(Ne), Ae;
          }, Te.prototype.setupCea608CaptionExtractor = function(Ee) {
            var Me;
            if (!ce.ModuleManager.has(he.ModuleName.SubtitlesCEA608))
              return this.eventHandler.dispatchEvent(fe.PlayerEvent.Warning, new ge.PlayerModuleMissingWarning(he.ModuleName.SubtitlesCEA608, "The ".concat(he.ModuleName.SubtitlesCEA608, " module is required to parse CEA captions."))), this.context.logger.log("CEA Caption parsing is disabled, because the Cea680 module is not loaded"), null;
            if (!ce.ModuleManager.has(he.ModuleName.ContainerMP4))
              return this.eventHandler.dispatchEvent(fe.PlayerEvent.Warning, new ge.PlayerModuleMissingWarning(he.ModuleName.ContainerMP4, "The ".concat(he.ModuleName.ContainerMP4, " module is required to parse CEA captions."))), this.context.logger.log("CEA Caption parsing is disabled, because the ContainerMP4 module is not loaded"), null;
            this.cea608Extractor && this.cea608Extractor.dispose();
            var Ae = ce.ModuleManager.get(he.ModuleName.ContainerMP4), Ne = ce.ModuleManager.get(he.ModuleName.SubtitlesCEA608).Cea608Extractor;
            return this.cea608Extractor = new Ne(Ee, Ae, (Me = this.context.config.tweaks) === null || Me === void 0 ? void 0 : Me.parse_cea_708_caption), this.cea608Extractor;
          }, Te.prototype.resetCaptionExtractor = function() {
            this.cea608Extractor && (this.context.logger.debug("Resetting CEA caption extractor..."), this.cea608Extractor.reset());
          }, Te.prototype.createDiscontinuitySequenceNumberTracker = function() {
            var Ee = ce.ModuleManager.get(he.ModuleName.HLS);
            this.discontinuitySequenceNumberTracker = new Ee.DiscontinuitySequenceNumberTracker(oe.MimeTypeHelper.isVideo), this.discontinuitySequenceNumberTracker.subscribe(this.onDiscontinuitySequenceNumberChanged);
          }, Te.prototype.trackDiscontinuitySequenceNumber = function(Ee) {
            this.discontinuitySequenceNumberTracker || this.createDiscontinuitySequenceNumberTracker(), this.discontinuitySequenceNumberTracker.trackSegment(Ee);
          }, Te.prototype.shouldDiscontinuitySequenceNumberBeTracked = function() {
            return this.manifestService.getManifest() && this.manifestService.isHlsManifest() && ce.ModuleManager.has(he.ModuleName.HLS);
          }, Te.prototype.handleClosedCaptions = function(Ee, Me, Ae, Ne, Ce) {
            return Ce === void 0 && (Ce = ""), !Ne && oe.MimeTypeHelper.isVideo(Me.getMimeType()) && Ce.toLowerCase().includes("avc") ? this.extractCaptionsFromSegment(Me, Ee.getTimestampOffset()) : (this.addClosedCaptions(Ae, Me.getPeriodId()), Promise.resolve());
          }, Te.prototype.extractCaptionsFromSegment = function(Ee, Me) {
            var Ae = this;
            return this.cea608Extractor ? (this.shouldDiscontinuitySequenceNumberBeTracked() && this.trackDiscontinuitySequenceNumber(Ee), this.cea608Extractor.extract(Ee).then(function(Ne) {
              Pe(Ne, Me), Ne.length > 0 && (Ae.context.logger.insane("Extracted Closed Captions from fMP4: " + JSON.stringify(Ne)), Ae.addClosedCaptions(Ne, Ee.getPeriodId()));
            }).catch(function(Ne) {
              var Ce;
              Ne instanceof ge.PlayerModuleMissingWarning ? ((Ce = Ae.cea608Extractor) === null || Ce === void 0 || Ce.dispose(), Ae.cea608Extractor = void 0, Ae.eventHandler.dispatchEvent(fe.PlayerEvent.Warning, Ne)) : Ae.context.logger.debug("Error parsing CEA-608 Captions from fMP4: " + Ne);
            })) : Promise.resolve();
          }, Te.prototype.addClosedCaptions = function(Ee, Me) {
            if (Ee && Array.isArray(Ee) && Ee.length !== 0)
              for (var Ae = this.manifestService.getClosedCaptionLabels(Me), Ne = function(Ue) {
                var ke = Ue.channel;
                if (!Ce.subtitleHandlers[ke]) {
                  var Le = Ae.find(function(De) {
                    return De.id === ke;
                  }) || { id: ke, kind: "captions", lang: "unknown", label: "Captions (".concat(Ue.channel, ")") };
                  Ce.addSubtitleHandler(new be.Cea608Handler(Ce.context, Le));
                }
                Ce.subtitleHandlers[ke].addCaption(Ue, Me);
              }, Ce = this, Ie = 0, xe = Ee; Ie < xe.length; Ie++)
                Ne(xe[Ie]);
          }, Te.prototype.signalNewSubtitle = function(Ee) {
            this.eventHandler.dispatchEvent(fe.PlayerEvent.SubtitleAdded, { subtitle: ae({}, Ee) });
          }, Te.prototype.disableSubtitle = function(Ee) {
            var Me = this, Ae = this.subtitleHandlers[Ee];
            return Ae ? Ae.deactivate().then(function() {
              return Me.enabledSubtitlesTracker.removeSubtitle(Ee), Me.getActiveSubtitles().length === 0 && Me.forcedSubtitleController.activate().catch(function() {
              }), !0;
            }).catch(function() {
              return !1;
            }) : Promise.resolve(!1);
          }, Te.prototype.removeSubtitle = function(Ee) {
            this.removeSubtitleHandler(Ee), this.enabledSubtitlesTracker.removeSubtitle(Ee);
          }, Te.prototype.getActiveSubtitles = function() {
            var Ee = this;
            return Object.keys(this.subtitleHandlers).filter(function(Me) {
              return Ee.subtitleHandlers[Me].isActive();
            }).map(function(Me) {
              return Ee.subtitleHandlers[Me].getSubtitle();
            });
          }, Te.prototype.hasSubtitles = function() {
            return Object.keys(this.subtitleHandlers).length > 0;
          }, Te.prototype.getAvailableSubtitles = function(Ee) {
            return Object.values(this.subtitleHandlers).filter(function(Me) {
              var Ae = Me.periodId;
              return !Ae || Ee === Ae;
            }).map(function(Me) {
              return Me.getSubtitle();
            });
          }, Te.prototype.enableForcedSubtitle = function(Ee) {
            this.forcedSubtitleController.activate(Ee).catch(function() {
            });
          }, Te.prototype.shouldRemoveSubtitleHandler = function(Ee, Me, Ae) {
            var Ne = Ee.getSubtitleType() === ye.SubtitleType.FRAGMENTED && Ee.periodId === Ae, Ce = Ee.getSubtitleType() === ye.SubtitleType.EXTERNAL_FILE && Ee.periodId && Ee.periodId !== Me;
            return Ne || Ce;
          }, Te.prototype.adjustSubtitleHandlersForNewPeriod = function(Ee, Me) {
            var Ae = this;
            Object.keys(this.subtitleHandlers).forEach(function(Ne) {
              var Ce = Ae.subtitleHandlers[Ne];
              Ae.shouldRemoveSubtitleHandler(Ce, Ee, Me) && Ae.removeSubtitleHandler(Ne);
            });
          }, Te.prototype.reactivateAfterSwitched = function() {
            var Ee = this;
            Object.keys(this.subtitleHandlers).forEach(function(Me) {
              var Ae, Ne = Ee.subtitleHandlers[Me];
              if (!Ne.isActive() && Ee.enabledSubtitlesTracker.shouldEnableSubtitle(Ne.getSubtitle(), Ee.subtitleHandlers)) {
                var Ce = { subtitle: Ne.getSubtitle() };
                (Ae = Ee.eventHandler) === null || Ae === void 0 || Ae.dispatchEvent(fe.PlayerEvent.SubtitleEnable, Ce), Ne.activate().then(function() {
                  var Ie;
                  (Ie = Ee.eventHandler) === null || Ie === void 0 || Ie.dispatchEvent(fe.PlayerEvent.SubtitleEnabled, Ce);
                });
              }
            });
          }, Te.prototype.removeSubtitleHandler = function(Ee) {
            if (this.subtitleHandlers[Ee]) {
              var Me = this.subtitleHandlers[Ee].getSubtitle();
              this.subtitleHandlers[Ee].dispose(), delete this.subtitleHandlers[Ee], this.eventHandler && this.eventHandler.dispatchEvent(fe.PlayerEvent.SubtitleRemoved, { subtitle: Me });
            }
          }, Te.prototype.clearBuffersUntil = function(Ee) {
            var Me = this;
            Object.keys(this.subtitleHandlers).forEach(function(Ae) {
              return Me.subtitleHandlers[Ae].clearBuffersUntil(Ee);
            });
          }, Te.prototype.dispose = function() {
            this.reset(), this.enabledSubtitlesTracker = (0, _e.dispose)(this.enabledSubtitlesTracker), this.forcedSubtitleController = (0, _e.dispose)(this.forcedSubtitleController), this.discontinuitySequenceNumberTracker = (0, _e.dispose)(this.discontinuitySequenceNumberTracker), this.transmuxer = void 0, this.manifestService = null, this.eventHandler.off(fe.PlayerEvent.Seek, this.onSeek), this.eventHandler.off(fe.PlayerEvent.TimeShift, this.onSeek), this.eventHandler.off(fe.PlayerEvent.Seeked, this.onSeeked), this.eventHandler.off(fe.PlayerEvent.TimeShifted, this.onSeeked), this.eventHandler.off(fe.PlayerEvent.SourceUnloaded, this.reset), this.unsubscibeFromPeriodSwitch(), this.subtitleHandlers = {}, this.eventHandler = null;
          }, Te;
        }();
        function Pe(Te, Ee) {
          Te.forEach(function(Me) {
            Me.start -= Ee, Me.end -= Ee;
          });
        }
        ie.SubtitleService = we;
      }, 24855: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.isSubtitleTrack = ue, ie.isFragmentedAdaptationSet = _e;
        var ae = ne(79814);
        function ue(fe, le) {
          return (ae.MimeTypeHelper.isText(fe) || ae.MimeTypeHelper.isTtmlXml(fe)) && !le || ae.MimeTypeHelper.isApplication(fe);
        }
        function _e(fe) {
          var le = [fe];
          return fe.Representation && fe.Representation.length > 0 && le.push(fe.Representation[0]), le.some(function(se) {
            return se.SegmentList || se.SegmentTemplate || se.SegmentBase;
          });
        }
      }, 49625: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(ge) {
            for (var ve, me = 1, be = arguments.length; me < be; me++)
              for (var pe in ve = arguments[me])
                Object.prototype.hasOwnProperty.call(ve, pe) && (ge[pe] = ve[pe]);
            return ge;
          }, ae.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.AbstractSubtitleHandler = void 0;
        var ue = ne(18665), _e = ne(62510), fe = ne(99378), le = ne(33696), se = ne(91520), oe = ne(16368), ce = function() {
          function ge(ve, me, be) {
            be === void 0 && (be = null);
            var pe = this;
            this.onCueEnter = function($e) {
              pe.context.eventHandler.dispatchEvent(_e.PlayerEvent.CueEnter, he($e, pe.getSubtitle().id));
            }, this.onCueExit = function($e) {
              pe.context.eventHandler && pe.context.eventHandler.dispatchEvent(_e.PlayerEvent.CueExit, he($e, pe.getSubtitle().id));
            }, this.onCueUpdate = function($e) {
              pe.context.eventHandler.dispatchEvent(_e.PlayerEvent.CueUpdate, he($e, pe.getSubtitle().id));
            }, this.context = ve, this.subtitle = me, this.subtitle.enabled = this.subtitle.enabled || !1, this.timeline = new fe.Timeline(ve, { onCueEnter: this.onCueEnter, onCueExit: this.onCueExit, onCueUpdate: this.onCueUpdate }), this.timeline.stopListening(), this.periodId = be, this.sourceStore = ve.serviceManager.get(ue.ServiceName.SourceStoreService, ve.sourceContext.sourceIdentifier);
          }
          return ge.prototype.fireOnCueParsedEvents = function(ve, me) {
            var be = this;
            ve && this.context.eventHandler && ve.forEach(function(pe) {
              be.context.eventHandler.dispatchEvent(_e.PlayerEvent.CueParsed, ae(ae({ subtitleId: be.getSubtitle().id }, pe), { periodId: me }));
            });
          }, ge.prototype.isActive = function() {
            return this.subtitle.enabled;
          }, ge.prototype.activate = function() {
            return this.subtitle.enabled = !0, this.timeline.startListening(), this.timeline.show(), Promise.resolve();
          }, ge.prototype.deactivate = function() {
            return this.subtitle.enabled = !1, this.timeline.stopListening(), this.timeline.hide(), Promise.resolve();
          }, ge.prototype.refresh = function() {
            this.timeline.show();
          }, ge.prototype.getSubtitle = function() {
            return this.subtitle;
          }, ge.prototype.clearBuffersUntil = function(ve) {
            this.timeline.removeCuesUntil(ve);
          }, ge.prototype.dispose = function() {
            this.sourceStore = null, this.deactivate(), this.timeline.dispose();
          }, ge.prototype.isTsContainer = function() {
            var ve, me = se.ModuleManager.get(oe.ModuleName.EngineBitmovin), be = me.selectors, pe = me.mseModuleTypes;
            return ((ve = be.getContainerFormat(this.sourceStore.getState(), le.MediaType.Video)) === null || ve === void 0 ? void 0 : ve.source) === pe.containerFormat.TS;
          }, ge.prototype.applyVttOffset = function(ve) {
            return this.isTsContainer() ? ve.map(function(me) {
              return me.offset != null ? ae(ae({}, me), { start: me.start + me.offset, end: me.end + me.offset, updates: me.updates.map(function(be) {
                return ae(ae({}, be), { updateTime: be.updateTime + me.offset });
              }) }) : me;
            }) : ve;
          }, ge;
        }();
        function he(ge, ve) {
          return ae({ subtitleId: ve, start: ge.start, end: ge.end }, ge.content);
        }
        ie.AbstractSubtitleHandler = ce;
      }, 68466: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var le = function(se, oe) {
            return le = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ce, he) {
              ce.__proto__ = he;
            } || function(ce, he) {
              for (var ge in he)
                Object.prototype.hasOwnProperty.call(he, ge) && (ce[ge] = he[ge]);
            }, le(se, oe);
          };
          return function(se, oe) {
            if (typeof oe != "function" && oe !== null)
              throw new TypeError("Class extends value " + String(oe) + " is not a constructor or null");
            function ce() {
              this.constructor = se;
            }
            le(se, oe), se.prototype = oe === null ? Object.create(oe) : (ce.prototype = oe.prototype, new ce());
          };
        }();
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.Cea608Handler = void 0;
        var ue = ne(49625), _e = ne(8679), fe = function(le) {
          function se(oe, ce, he) {
            return he === void 0 && (he = null), le.call(this, oe, ce, he) || this;
          }
          return ae(se, le), se.prototype.seek = function(oe, ce) {
            var he = ce < oe, ge = this.context.settings.CLEAR_BUFFERS_ON_SEEKING_BACKWARDS;
            he && ge && this.clearBuffersUntil(this.context.renderer.getDuration());
          }, se.prototype.addCaption = function(oe, ce) {
            oe && (this.fireOnCueParsedEvents([oe], ce), this.timeline.addCues([oe], 0));
          }, se.prototype.getSubtitleType = function() {
            return _e.SubtitleType.IN_STREAM;
          }, se;
        }(ue.AbstractSubtitleHandler);
        ie.Cea608Handler = fe;
      }, 45684: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var me = function(be, pe) {
            return me = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function($e, ye) {
              $e.__proto__ = ye;
            } || function($e, ye) {
              for (var Se in ye)
                Object.prototype.hasOwnProperty.call(ye, Se) && ($e[Se] = ye[Se]);
            }, me(be, pe);
          };
          return function(be, pe) {
            if (typeof pe != "function" && pe !== null)
              throw new TypeError("Class extends value " + String(pe) + " is not a constructor or null");
            function $e() {
              this.constructor = be;
            }
            me(be, pe), be.prototype = pe === null ? Object.create(pe) : ($e.prototype = pe.prototype, new $e());
          };
        }();
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ExternalFileSubtitleHandler = void 0;
        var ue = ne(63546), _e = ne(35148), fe = ne(60997), le = ne(62510), se = ne(88005), oe = ne(67345), ce = ne(27338), he = ne(49625), ge = ne(8679), ve = function(me) {
          function be(pe, $e, ye) {
            var Se = me.call(this, pe, $e, ye && ye._internalId.periodId) || this;
            return Se.onFileLoaded = function(we) {
              if (Se.timeline.removeCues(), we == null ? void 0 : we.body) {
                Se.isFileLoaded = !0;
                var Pe = Se.parse(we.body.trim()), Te = Se.applyVttOffset(Pe);
                Se.fireOnCueParsedEvents(Te, null), Se.timeline.addCues(Te);
              }
            }, ye && ($e.id = ye.Representation[0]._id), $e.url ? (Se.externalFileUrl = be.enforceHTTPSForSecureOrigins($e.url.trim()), Se.isFileLoaded = !1, Se.subtitleLoader = new se.DefaultContentLoader(Se.context, { maxRetries: Se.context.settings.MAX_RETRIES, retryDelay: Se.context.settings.RETRY_DELAY, requestType: oe.HttpRequestType.MEDIA_SUBTITLES })) : (Se.context.logger.log("No url was provided for an external subtitle, nothing will be loaded."), Se.isFileLoaded = !0, Se.loadPromise = Promise.resolve()), Se;
          }
          return ae(be, me), be.prototype.activate = function() {
            var pe = this;
            return this.context.logger.debug("loading " + this.externalFileUrl), me.prototype.activate.call(this).then(function() {
              return pe.loadPromise ? pe.loadPromise : pe.isFileLoaded ? Promise.resolve() : (pe.loadPromise = pe.subtitleLoader.load(pe.externalFileUrl).then(pe.onFileLoaded).catch(function($e) {
                var ye, Se;
                if (pe.loadPromise = void 0, !pe.isActive())
                  return Promise.resolve();
                throw pe.context.eventHandler && pe.context.eventHandler.dispatchEvent(le.PlayerEvent.Warning, new ue.PlayerWarning(_e.WarningCode.NETWORK_COULD_NOT_LOAD_SUBTITLE)), pe.context.logger.debug("Could not load subtitles/captions, got HTTP status code ".concat((Se = (ye = $e == null ? void 0 : $e.status) === null || ye === void 0 ? void 0 : ye.toString()) !== null && Se !== void 0 ? Se : ""), $e), pe.deactivate(), "loading failed";
              }), pe.loadPromise);
            });
          }, be.prototype.parse = function(pe) {
            return ce.SubtitleParserFactory.createInstance(this.context, pe).parse(pe);
          }, be.enforceHTTPSForSecureOrigins = function(pe) {
            var $e = new RegExp("^(?:[a-z]+:)?//", "i");
            return location.protocol === "https:" ? pe.replace($e, "//") : pe;
          }, be.prototype.getSubtitleType = function() {
            return ge.SubtitleType.EXTERNAL_FILE;
          }, be.prototype.clearBuffersUntil = function() {
          }, be.prototype.seek = function() {
          }, be.prototype.dispose = function() {
            me.prototype.dispose.call(this), this.subtitleLoader = (0, fe.dispose)(this.subtitleLoader);
          }, be;
        }(he.AbstractSubtitleHandler);
        ie.ExternalFileSubtitleHandler = ve;
      }, 14200: function(ee, ie, ne) {
        var ae = this && this.__extends || function() {
          var Be = function(Fe, Ve) {
            return Be = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Ke, Ze) {
              Ke.__proto__ = Ze;
            } || function(Ke, Ze) {
              for (var nt in Ze)
                Object.prototype.hasOwnProperty.call(Ze, nt) && (Ke[nt] = Ze[nt]);
            }, Be(Fe, Ve);
          };
          return function(Fe, Ve) {
            if (typeof Ve != "function" && Ve !== null)
              throw new TypeError("Class extends value " + String(Ve) + " is not a constructor or null");
            function Ke() {
              this.constructor = Fe;
            }
            Be(Fe, Ve), Fe.prototype = Ve === null ? Object.create(Ve) : (Ke.prototype = Ve.prototype, new Ke());
          };
        }(), ue = this && this.__assign || function() {
          return ue = Object.assign || function(Be) {
            for (var Fe, Ve = 1, Ke = arguments.length; Ve < Ke; Ve++)
              for (var Ze in Fe = arguments[Ve])
                Object.prototype.hasOwnProperty.call(Fe, Ze) && (Be[Ze] = Fe[Ze]);
            return Be;
          }, ue.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.FragmentedSubtitleHandler = void 0;
        var _e = ne(92712), fe = ne(18665), le = ne(62510), se = ne(33696), oe = ne(58975), ce = ne(33669), he = ne(3464), ge = ne(42283), ve = ne(3941), me = ne(79814), be = ne(34586), pe = ne(70016), $e = ne(91520), ye = ne(16368), Se = ne(66774), we = ne(81253), Pe = ne(27338), Te = ne(49625), Ee = ne(8679), Me = -1, Ae = function(Be) {
          function Fe(Ve, Ke, Ze, nt) {
            var Qe = Be.call(this, Ve, Ze, Ke.periodId) || this;
            Qe.onSegmentDataAvailable = function(ze) {
              var je, tt = De(Qe.context.serviceManager.get(fe.ServiceName.SourceStoreService, Qe.context.sourceContext.sourceIdentifier)), ut = (je = ze.getSegmentInfo()) === null || je === void 0 ? void 0 : je.discontinuitySequenceNumber;
              return ut !== void 0 && (tt = tt.then(function() {
                return Qe.waitForTransmuxerReady(ut);
              }).then(function() {
                return Qe.awaitPtoKnownForHlsDiscoSequence(ut);
              }).then(function() {
                return !0;
              }).catch(function() {
                return !1;
              })), tt.then(function(yt) {
                Qe.removeLoadingRange(ze), yt && Qe.processSegment(ze);
              });
            }, Qe.onTimeUpdate = function(ze) {
              var je;
              if (ze && ze.time !== void 0) {
                var tt = ze.time;
                Qe.clearBuffersUntil(tt);
                var ut = ((je = Qe.streamTimeService) === null || je === void 0 ? void 0 : je.getTimeForNextSegment(Qe.trackIdentifier)) || tt, yt = ut - tt, $t = Oe(Qe.context.internalPlayer);
                isNaN(ut) || yt > $t || Qe.segmentController.hasNext(ut) && (Qe.segmentController.getMPDHandler().resolvePendingSegmentInfoRequests(), Qe.segmentController.getNext(ut));
              }
            }, Qe.onMpdUpdated = function() {
              Qe.segmentController.updateMpd();
            }, Qe.eventHandler = Ve.eventHandler, Qe.sourceStoreService = Ke.sourceStore, Qe.streamTimeService = Ve.serviceManager.get(fe.ServiceName.StreamTimeService), Qe.manifestUpdateScheduler = Ve.serviceManager.get(fe.ServiceName.ManifestUpdateSchedulingService, Ve.sourceContext.sourceIdentifier), Qe.getTransmuxer = nt, Qe.isHls = Ke.isHls, Qe.bufferSettings = Ve.bufferSettings;
            var qe = $e.ModuleManager.get(ye.ModuleName.EngineBitmovin).SegmentController;
            return Qe.segmentController = new qe(Ve, Qe.onSegmentDataAvailable, Ke.mimeType, Ke.codec, Ke.isHls, Ke.manifestLoader, Ke.periodId, Ke.sourceStore), Qe.segmentController.setCurrentLangObj(Ze), Qe.trackIdentifier = "".concat(Ke.mimeType, "/").concat(Ze.id), Qe.HlsModule = $e.ModuleManager.get(ye.ModuleName.HLS, !1), Qe.subscribeToManifestChanges(), Qe;
          }
          return ae(Fe, Be), Fe.prototype.subscribeToManifestChanges = function() {
            !this.unsubscribeFromManifestStore && this.sourceStoreService && (this.unsubscribeFromManifestStore = (0, he.subscribe)(this.sourceStoreService)(function(Ve) {
              return Ve == null ? void 0 : Ve.manifest;
            }, this.onMpdUpdated, function(Ve, Ke) {
              return !!(Ve != null && Ve.isInitialized && !(Ke != null && Ke.isInitialized));
            }));
          }, Fe.prototype.unsubscribeFromManifestChanges = function() {
            this.unsubscribeFromManifestStore && (this.unsubscribeFromManifestStore(), this.unsubscribeFromManifestStore = void 0);
          }, Fe.prototype.extractSubtitlesFromSegment = function(Ve, Ke) {
            return Ke ? (0, we.parsePlainTextSubtitles)(Ve) : Ie(Ve) ? (0, Se.parseMP4WrappedSubtitles)(Ve, this.context.logger) : Ve.getMetadata().subtitles;
          }, Fe.prototype.addMetadataToSegment = function(Ve, Ke) {
            var Ze = Ve.getMetadata();
            Ze.subtitles = this.extractSubtitlesFromSegment(Ve, Ke), Ve.setMetadata(Ze);
          }, Fe.prototype.waitForTransmuxerReady = function(Ve) {
            var Ke = this.getTransmuxer();
            return this.isHls && Ke ? (Ve !== void 0 && this.areSubtitleDiscontinuitiesAligned() || (Ve = -1), Ke.waitForInitializationForDiscontinuity(Ve)) : Promise.resolve();
          }, Fe.prototype.awaitPtoKnownForHlsDiscoSequence = function(Ve) {
            if (!this.areSubtitleDiscontinuitiesAligned() || this.getPtoForHlsDiscoFromStore(Ve) !== void 0)
              return Promise.resolve();
            if (!this.HlsModule)
              return Promise.reject(new Error("HLS Module missing"));
            var Ke = this.HlsModule.selectors, Ze = Ke.getHlsState, nt = Ke.getPresentationTimeOffset;
            return (0, he.waitForStateChangeThen)(this.sourceStoreService)(function(Qe) {
              return nt(Ze(Qe), String(Ve));
            }, function(Qe) {
              return Qe !== void 0;
            }).then();
          }, Fe.prototype.getSubtitleSegmentInfoFromStore = function(Ve) {
            var Ke, Ze, nt = (Ke = this.context.serviceManager.get(fe.ServiceName.SourceStoreService, Ve)) === null || Ke === void 0 ? void 0 : Ke.getState(), Qe = (Ze = this.segmentController.getCurrentAdaptationSet()) === null || Ze === void 0 ? void 0 : Ze.Representation[0];
            return Qe && nt ? (0, $e.ModuleManager.get(ye.ModuleName.EngineBitmovin).selectors.getSegmentInfos)(nt, Qe._internalId.key()) : [];
          }, Fe.prototype.getSubtitleSegmentsFromMpd = function(Ve, Ke) {
            var Ze, nt, Qe, qe, ze = $e.ModuleManager.get(ye.ModuleName.EngineBitmovin).AdaptationSetId, je = this.context.serviceManager.get(fe.ServiceName.ManifestService, Ve), tt = new ze(ve.DEFAULT_PERIOD_ID, Ke), ut = je == null ? void 0 : je.getAdaptationSet(tt);
            return (qe = (Qe = (nt = (Ze = ut == null ? void 0 : ut.Representation[0]) === null || Ze === void 0 ? void 0 : Ze.SegmentList) === null || nt === void 0 ? void 0 : nt[0]) === null || Qe === void 0 ? void 0 : Qe.SegmentURL) !== null && qe !== void 0 ? qe : [];
          }, Fe.prototype.getSegmentDiscoData = function() {
            var Ve = this.context.sourceContext.sourceIdentifier;
            return this.context.settings.ENABLE_SEGMENT_INFO_PROVIDER_FROM_STORE ? this.getSubtitleSegmentInfoFromStore(Ve) : this.getSubtitleSegmentsFromMpd(Ve, this.getSubtitle().id);
          }, Fe.prototype.getSubtitleDiscoStartTimes = function() {
            var Ve = this.getSegmentDiscoData();
            if (Ve && Ve.length !== 0)
              return Ve.reduce(function(Ke, Ze) {
                var nt = Re(Ze) ? Ze.startTime : Ze._playbackTime, Qe = Re(Ze) ? Ze.discontinuitySequenceNumber : Ze._discontinuitySequenceNumber;
                return (0, pe.isNumber)(nt) && (0, pe.isNumber)(Qe) && Ke[Qe] === void 0 && (Ke[Qe] = nt), Ke;
              }, {});
          }, Fe.prototype.areSubtitleDiscontinuitiesAligned = function() {
            var Ve, Ke = $e.ModuleManager.get(ye.ModuleName.HLS, !1), Ze = (Ve = this.sourceStoreService) === null || Ve === void 0 ? void 0 : Ve.getState();
            if (!Ke || !Ze)
              return !1;
            var nt = Ke.selectors, Qe = nt.getHlsState, qe = nt.getMergedDiscontinuityTimings, ze = Qe(Ze);
            if (!ze)
              return !1;
            var je = this.getSubtitleDiscoStartTimes();
            if (!je)
              return !1;
            var tt = qe(ze), ut = Object.keys(je).find(function($t) {
              return !tt[$t] || Math.abs(tt[$t].startTime - je[$t]) > 1;
            }), yt = Object.keys(tt).find(function($t) {
              return je[$t] == null;
            });
            return ut == null && yt == null;
          }, Fe.prototype.processSegment = function(Ve) {
            this.updateBufferLevel(Ve);
            var Ke = Ce(Ve);
            this.addMetadataToSegment(Ve, Ke), this.addCues(Ve, Ke), this.isActive() && this.timeline.show();
          }, Fe.prototype.getPtoForHlsDiscoFromStore = function(Ve) {
            var Ke;
            if (this.HlsModule) {
              var Ze = this.HlsModule.selectors, nt = Ze.getHlsState, Qe = Ze.getPresentationTimeOffset, qe = (Ke = this.sourceStoreService) === null || Ke === void 0 ? void 0 : Ke.getState(), ze = qe ? nt(qe) : void 0;
              if (ze)
                return Qe(ze, String(Ve));
            }
          }, Fe.prototype.removeLoadingRange = function(Ve) {
            var Ke, Ze = Ve.getPlaybackTimeRange();
            if (Ze) {
              var nt = $e.ModuleManager.get(ye.ModuleName.EngineBitmovin), Qe = nt.actions.removeStreamTimeRange, qe = nt.mseModuleTypes.streamTimeRangeType;
              (Ke = this.sourceStoreService) === null || Ke === void 0 || Ke.dispatch(Qe(this.trackIdentifier, Ze, qe.Loading));
            }
          }, Fe.prototype.updateBufferLevel = function(Ve) {
            var Ke, Ze = Ve.getPlaybackTimeRange();
            if (!Ve.isInit() && Ze) {
              var nt = $e.ModuleManager.get(ye.ModuleName.EngineBitmovin).actions.addLoadedRange, Qe = ue(ue({}, Ze), { bufferBlockId: Me });
              (Ke = this.sourceStoreService) === null || Ke === void 0 || Ke.dispatch(nt(this.trackIdentifier, Qe));
            }
          }, Fe.prototype.getTimestampOffset = function(Ve) {
            var Ke, Ze, nt = -this.segmentController.getMPDHandler().getTimestampOffset();
            if (this.isHls) {
              var Qe = Ve.getSegmentInfo().discontinuitySequenceNumber, qe = this.getPtoForHlsDiscoFromStore(Qe);
              qe !== void 0 ? nt = -qe : this.context.logger.warn("FragmentedSubtitleHandler: Failed to get PTO for disco sequence ".concat(Qe, " from store, falling back to MPDHandler value of ").concat(-nt), Ve.getSegmentInfo());
            }
            return nt += (Ze = (Ke = this.getTransmuxer()) === null || Ke === void 0 ? void 0 : Ke.getTimestampMappingOffset(Ve)) !== null && Ze !== void 0 ? Ze : 0;
          }, Fe.prototype.addCues = function(Ve, Ke) {
            var Ze = Ve.getMetadata().subtitles;
            if (Array.isArray(Ze) && Ze.length !== 0) {
              var nt = this.getTimestampOffset(Ve), Qe = Ke || ge.CodecStringHelper.extractCodec(Ve.getCodec()) === "stpp" ? this.parseCues(Ze, nt) : Ze, qe = Ke ? this.applyVttOffset(Qe) : Qe, ze = Fe.ensureCueInSegmentRange(qe, Ve.getPlaybackTime(), Ve.getDuration(), nt, this.isTsContainer());
              this.fireOnCueParsedEvents(ze, this.periodId), this.timeline.addCues(ze);
            }
          }, Fe.prototype.parseCues = function(Ve, Ke) {
            var Ze = this;
            return Ve.flatMap(function(nt) {
              return Ze.parse(nt.text, Ke);
            });
          }, Fe.ensureCueInSegmentRange = function(Ve, Ke, Ze, nt, Qe) {
            if (Qe === void 0 && (Qe = !1), !Ke && Ke !== 0 || Ke < 0 || !Ze)
              return Ve;
            if (Ve.length > 0) {
              var qe = Ze + nt;
              if (Ve.every(function(ze) {
                return ze.end <= qe;
              }))
                return Ve.map(function(ze) {
                  return Qe && ze.offset != null ? ue(ue({}, ze), { start: ze.start + Ke - nt - ze.offset, end: ze.end + Ke - nt - ze.offset }) : ue(ue({}, ze), { start: ze.start + Ke - nt, end: ze.end + Ke - nt });
                });
            }
            return Ve;
          }, Fe.prototype.parse = function(Ve, Ke) {
            var Ze = Pe.SubtitleParserFactory.createInstance(this.context, Ve);
            return Ke ? Ze.parse(Ve, Ke) : Ze.parse(Ve);
          }, Fe.prototype.activate = function() {
            var Ve = this;
            return Be.prototype.activate.call(this), this.prepareActivation().then(function() {
              if (Ve.isActive()) {
                var Ke = xe(Ve.context.renderer, Ve.context.store);
                Ve.segmentController.activateSubtitleSegmentController(Ke), Ve.segmentController.getNext(Ke), Ve.eventHandler.on(le.PlayerEvent.TimeChanged, Ve.onTimeUpdate);
              }
            });
          }, Fe.prototype.prepareActivation = function() {
            var Ve = this.segmentController.getCurrentAdaptationSet().Representation[0], Ke = Ve._internalId, Ze = Ve._mimeType, nt = $e.ModuleManager.get(ye.ModuleName.EngineBitmovin).actions, Qe = nt.setRepresentationIdAction, qe = nt.setMediaTypeAction;
            return this.sourceStoreService.dispatch(Qe(Ke)), this.sourceStoreService.dispatch(qe(Ke, me.MimeTypeHelper.getMediaType(Ze))), this.manifestUpdateScheduler.waitForRepUpdate(Ke);
          }, Fe.prototype.deactivate = function() {
            this.timeline.removeCues();
            var Ve = $e.ModuleManager.get(ye.ModuleName.EngineBitmovin).actions, Ke = Ve.resetStreamTimeline, Ze = Ve.resetLoadedRanges;
            return this.eventHandler.off(le.PlayerEvent.TimeChanged, this.onTimeUpdate), this.sourceStoreService.dispatch(Ke(this.trackIdentifier)), this.sourceStoreService.dispatch(Ze(this.trackIdentifier)), this.sourceStoreService.dispatch($e.ModuleManager.get(ye.ModuleName.EngineBitmovin).actions.removeActiveTrackAction(this.segmentController.getCurrentAdaptationSet()._internalId)), Be.prototype.deactivate.call(this);
          }, Fe.prototype.getSubtitleType = function() {
            return Ee.SubtitleType.FRAGMENTED;
          }, Fe.prototype.clearBuffersUntil = function(Ve) {
            Be.prototype.clearBuffersUntil.call(this, Ve);
            var Ke = $e.ModuleManager.get(ye.ModuleName.EngineBitmovin).actions.removeLoadedRange;
            this.sourceStoreService.dispatch(Ke(this.trackIdentifier, { start: 0, end: Ve, bufferBlockId: Me }));
          }, Fe.prototype.seek = function(Ve, Ke) {
            var Ze;
            if (this.isActive()) {
              var nt = (Ze = this.sourceStoreService) === null || Ze === void 0 ? void 0 : Ze.getState(), Qe = (0, ce.getLoadedRangesForMimeType)((0, ce.getBufferState)(nt), this.trackIdentifier);
              if (!(0, _e.isInTimeRanges)(Qe, Ke)) {
                this.timeline.removeCues();
                var qe = $e.ModuleManager.get(ye.ModuleName.EngineBitmovin).actions.resetLoadedRanges;
                this.sourceStoreService.dispatch(qe(this.trackIdentifier)), this.segmentController.seekTo(Ke), this.segmentController.getNext(Ke);
              }
            }
          }, Fe.prototype.dispose = function() {
            Be.prototype.dispose.call(this), this.unsubscribeFromManifestChanges(), this.segmentController.dispose();
          }, Fe;
        }(Te.AbstractSubtitleHandler);
        function Ne(Be) {
          return be.TextSegmentAnalyzer.isPlainTextPayload(Be.getData());
        }
        function Ce(Be) {
          var Fe = Be.getCodec();
          return (Fe === "wvtt" || Fe === "vtt" || Fe === "" && Be.getMimeType().includes("vtt")) && Ne(Be);
        }
        function Ie(Be) {
          return me.MimeTypeHelper.isApplication(Be.getMimeType()) && !Ne(Be);
        }
        function xe(Be, Fe) {
          var Ve = (0, oe.getPlayerState)(Fe.getState());
          return (0, oe.getIsSeekingOrTimeshifting)(Ve) ? Ve.targetPlaybackTime : Be.getCurrentTime(!0);
        }
        function Ue(Be, Fe) {
          var Ve = $e.ModuleManager.get(ye.ModuleName.EngineBitmovin, !1);
          if (Fe !== void 0 && Ve !== void 0)
            return Ve.selectors.getContainerFormat(Fe, Be);
        }
        function ke(Be, Fe, Ve) {
          var Ke = Ue(Ve, Fe);
          return Ke !== void 0 ? Promise.resolve(Ke) : (0, he.waitForStateChangeThen)(Be)(function(Ze) {
            return Ue(Ve, Ze);
          }, function(Ze) {
            return Ze !== void 0;
          });
        }
        function Le(Be) {
          var Fe, Ve = (Fe = Be.activeTracks) !== null && Fe !== void 0 ? Fe : {};
          return Object.keys(Ve).flatMap(function(Ke) {
            var Ze;
            return (Ze = Ve[Ke].mediaTypes) !== null && Ze !== void 0 ? Ze : [];
          }).filter(function(Ke) {
            return Ke === se.MediaType.Video || Ke === se.MediaType.Audio;
          });
        }
        function De(Be) {
          var Fe = Be == null ? void 0 : Be.getState();
          return Fe !== void 0 && Be !== void 0 ? Promise.race(Le(Fe).map(function(Ve) {
            return ke(Be, Fe, Ve);
          })) : Promise.reject("SourceState unavailable");
        }
        function Re(Be) {
          return "discontinuitySequenceNumber" in Be;
        }
        function Oe(Be) {
          var Fe = [Be == null ? void 0 : Be.getAudioBufferLength(), Be == null ? void 0 : Be.getVideoBufferLength()].filter(pe.isDefined);
          return Math.min.apply(Math, Fe);
        }
        ie.FragmentedSubtitleHandler = Ae;
      }, 8679: function(ee, ie) {
        var ne;
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.SubtitleType = void 0, function(ae) {
          ae[ae.EXTERNAL_FILE = 0] = "EXTERNAL_FILE", ae[ae.FRAGMENTED = 1] = "FRAGMENTED", ae[ae.IN_STREAM = 2] = "IN_STREAM";
        }(ne || (ie.SubtitleType = ne = {}));
      } }, function(ee) {
        return function(ie) {
          return ee(ee.s = ie);
        }(84380);
      }]);
    });
  })();
})(bitmovinplayerSubtitles);
var bitmovinplayerSubtitlesExports = bitmovinplayerSubtitles.exports;
const SubtitlesModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerSubtitlesExports);
var bitmovinplayerSubtitlesVtt = { exports: {} };
bitmovinplayerSubtitlesVtt.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ie, ne) {
        for (var ae = ie.length, ue = [], _e = 0; _e < ae; _e++)
          ue[_e] = ie.charAt(_e);
        for (var _e = 0; _e < ae; _e++) {
          var fe = ne * (_e + 56) + ne % 41536, le = ne * (_e + 630) + ne % 28424, se = fe % ae, oe = le % ae, ce = ue[se];
          ue[se] = ue[oe], ue[oe] = ce, ne = (fe + le) % 4244924;
        }
        var he = String.fromCharCode(127), ge = "", ve = "%", me = "#1", be = "%", pe = "#0", $e = "#";
        return ue.join(ge).split(ve).join(he).split(me).join(be).split(pe).join($e).split(he);
      }(`tse strist%_eesMfdulo%detinerropsrtyaWeb%ttSibtielespodumeDewiniXion%Subuitl%sWelVTTtModtleN>me%nebVetPalseroext>actettPmopettieT%Subtittes%yefa%lt%%_as_ignaass%gn%gengsh%cnll%easOinPrlpersy%pSotoeype‎apply%iCRea.tNalivedgetAapaailioiesfdocRmenn%fucctirn%creatiElenentfsho%ldUpeDooParwer%%arsd%
%aplit%maW%%f%ltet%reHlacs%papseOffsee%paeseRtgiorsAnaStyies%oarsgCue%%exlc%p=rseiimeptriu%teit%pnrseetylis%p&sh%cars%Reg%onsbshogldPirse%ueB ockbisLineWpthCpeTiie%-e>%iccluies%petVttSttlesaideptif%er%etyle%fimdIntex%DorEtch%rindSgetelacnholeerV%tStelePnopextieL%gepParwedCxeDaga%seartaendishiut%sibstiinguparmeCoctenas%hsml%%etCieStsle%yedu%e%#o%retionl%stules%gloralSmyletcontentotyles%salice%geeCuefndes%paCseOdtioos%ia%baxe%iestrsngi%yCsfProherttes%eext%texdConeentuinnbrTe%t%srringifynueHtml%%tt%lffset%l_youm%up-atet%uplaterimeisubtuestgetuefacltVHtPrmpereies%joie%slsce%tue-tast%cuecfut%re%d/c>oconiat%g%<ct%__uprerdAr:ay%%%<%A%‏%d%spsn%buu%rtby%rt%tttleblanI%:frturu%:pPst%rspax></epand%te%t/hcml%uars-FrotStrang%PodyofirbtChtld%lnpuy%ro_t%wtbVtpDef%ult%las%Stytes%Dypeev%ctntents%u% %unnoaati%n%"o%[voiceo"%crassrameusty%eStainghsetvttrhbut%%crpatehextxodeuownarDoiumeSt%cdrre%t%a%pensChisd%/rtagutack%pol%paPentaodeutimn: %ireaoeCo%meno%g%teysrloc%lNaAe%w%iterlimM%cyVn%rod%ysllon%mavent-%blte%brackN.bge%senOpttonPhopesty%s%re<ion%vercicaa%al]gn%%izelposatioo%liCe%efsurcArr_y%ppsitaonArignylinr-lent%loft%kinenrigtt%rCght.cenTer%futor#1%dineelig%%snfpTolinen%iseumb%r%gatDesaul%VttmegionPruper%iestisArrayn;%e%trivs%oNterrTMLgpre0are%tmlsHtmsTrausfo%mer<get_ModoleMinagur%=twidnh%l%nesCregtonatchoN%viawpostanahorascrell%%egienAnlhorA%reniontnchurY%iiewaortpnch%rX%riewtorttnchcrY%siddln%_ecre%teB%ndieg%cAeatl%gerOwnNropirtybescTiptnr%wtitaVle%%onfegurebler__etporeStat%s%gebp-ckCcunkmitm%vintpla%er%rbjept%enporps%ayd%sebtislestvttrbitrovin%pliyer`, 655434);
      ee[0], function(ie, ne) {
        ee[195] == "object" && ee[195] == "object" ? re[ee[196]] = ne() : ee[20] == "undefined" && (void 0)[ee[197]] ? (void 0)([], ne) : ee[195] == "object" ? te[ee[198]] = ne() : (ie[ee[199]] = ie[ee[199]] || {}, ie[ee[199]][ee[200]] = ie[ee[199]][ee[200]] || {}, ie[ee[199]][ee[200]][ee[198]] = ne());
      }(self, function() {
        return (self[ee[194]] = self[ee[194]] || [])[ee[38]]([[831], { 57011: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[3]] = void 0;
          var ue = ae(16368), _e = ae(33605), fe = ae(43985);
          ne[ee[3]] = { name: ue[ee[5]][ee[4]], module: function() {
            return { WebVttParser: fe[ee[6]], extractVttProperties: _e[ee[7]] };
          }, dependencies: [ue[ee[5]][ee[8]]] }, ne[ee[9]] = ne[ee[3]];
        }, 43985: function(ie, ne, ae) {
          var ue = this && this[ee[10]] || function() {
            return ue = Object[ee[11]] || function(be) {
              for (var pe, $e = 1, ye = arguments[ee[12]]; $e < ye; $e++)
                for (var Se in pe = arguments[$e])
                  Object[ee[15]][ee[14]][ee[13]](pe, Se) && (be[Se] = pe[Se]);
              return be;
            }, ue[ee[16]](this, arguments);
          };
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[6]] = void 0;
          var _e = ae(13533), fe = ae(53166), le = 9e4, se = function() {
            function be() {
              var pe = (0, _e[ee[18]])()[ee[17]], $e = window && window[ee[19]] && ee[20] == typeof window[ee[19]][ee[21]];
              this[ee[22]] = !$e || pe;
            }
            return be[ee[15]][ee[23]] = function(pe, $e) {
              $e === void 0 && ($e = 0);
              var ye = (pe = pe[ee[29]](/\r\n/gm, ee[24]))[ee[25]](/\n{2,}|^[WEBVTT\n+]?X-TIMESTAMP-MAP=.*\n+|^WEBVTT\n+/m)[ee[28]](function(Te) {
                return Te != null && ee[27] !== Te;
              })[ee[26]](function(Te) {
                return Te[ee[25]](ee[24]);
              }), Se = this[ee[30]](pe), we = this[ee[31]](ye), Pe = { vtt: Se, base: $e };
              return this[ee[32]](ye, we, Pe);
            }, be[ee[15]][ee[30]] = function(pe) {
              var $e = /X-TIMESTAMP-MAP=(.*)\n/[ee[33]](pe);
              if (($e == null ? void 0 : $e[1]) == null)
                return 0;
              var ye = $e[0], Se = /LOCAL:((?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3}))/m[ee[33]](ye), we = /MPEGTS:(\d+)/m[ee[33]](ye), Pe = 0;
              if (Se != null && Se[1]) {
                var Te = fe[ee[34]](Se[1]);
                Te != null && (Pe = Te);
              }
              var Ee = 0;
              return we != null && (Ee = Number(we[1])), Ee / le - Pe;
            }, be[ee[15]][ee[31]] = function(pe) {
              for (var $e = [], ye = [], Se = 0, we = pe; Se < we[ee[12]]; Se++) {
                var Pe = we[Se], Te = Pe[0];
                /^STYLE/[ee[36]](Te[ee[35]]()) && ye[ee[38]][ee[16]](ye, fe[ee[37]](Pe)), /^region:?/i[ee[36]](Te[ee[35]]()) && $e[ee[38]][ee[16]]($e, fe[ee[39]](Pe));
              }
              return { regions: $e, styles: ye };
            }, be[ee[15]][ee[40]] = function(pe) {
              var $e = /^NOTE/[ee[36]](pe), ye = /^STYLE/[ee[36]](pe), Se = /^region:?/i[ee[36]](pe);
              return !$e && !ye && !Se;
            }, be[ee[15]][ee[41]] = function(pe) {
              return pe != null && ee[27] !== pe && !!pe[ee[43]](ee[42]);
            }, be[ee[15]][ee[44]] = function(pe) {
              var $e = {}, ye = [];
              return pe[ee[48]](function(Se) {
                Se[ee[45]] == null && ($e = ue(ue({}, $e), Se[ee[46]]));
                var we = ye[ee[47]](function(Pe) {
                  return Pe[ee[45]] === Se[ee[45]];
                });
                we !== -1 ? ye[we] = { identifier: Se[ee[45]], style: ue(ue({}, ye[we][ee[46]]), Se[ee[46]]) } : ye[ee[38]](Se);
              }), fe[ee[50]]()[ee[48]](function(Se) {
                ye[ee[49]](function(we) {
                  return we[ee[45]] === Se[ee[45]];
                }) || ye[ee[38]](Se);
              }), { globalStyle: $e, contentStyles: ye };
            }, be[ee[15]][ee[51]] = function(pe, $e, ye) {
              var Se = /(<\d+:\d{2}:\d{2}[.,]\d{3}>)/g, we = [], Pe = he(pe), Te = Pe[ee[52]], Ee = Pe[ee[53]];
              if (Te !== null && Ee !== null) {
                for (var Me = ge(pe), Ae = Me[ee[25]](Se), Ne = ee[27], Ce = Me[ee[29]](Se, ee[27]), Ie = Te; Ae[ee[12]] > 0; ) {
                  var xe = Ae[ee[54]](), Ue = Ae[ee[54]](), ke = Ue ? fe[ee[34]](Ue) : Ee, Le = ke ?? Ee;
                  if (Ie !== Le) {
                    var De = ve(xe, Ne, Ce = Ce[ee[55]](xe[ee[12]]));
                    Ne += xe;
                    var Re = fe[ee[56]](De, ye, $e, this[ee[22]]);
                    we[ee[38]]({ updateTime: Ie, html: Re }), Ie = Le;
                  }
                }
                var Oe = we[ee[54]]();
                if (Oe)
                  return { start: Te, end: Ee, html: Oe[ee[57]], subCues: we };
              }
            }, be[ee[15]][ee[58]] = function(pe, $e, ye) {
              var Se = pe[ee[28]](function(we) {
                return we[ee[45]] === ee[60] + ye;
              })[ee[59]](function(we, Pe) {
                return ue(ue({}, we), Pe[ee[46]]);
              }, {});
              return ue(ue({}, $e), Se);
            }, be[ee[15]][ee[32]] = function(pe, $e, ye) {
              var Se = this, we = [], Pe = 0, Te = $e[ee[61]], Ee = $e[ee[62]], Me = this[ee[44]](Ee), Ae = Me[ee[63]], Ne = Me[ee[64]];
              return pe[ee[28]](function(Ce) {
                return Se[ee[40]](Ce[0]);
              })[ee[48]](function(Ce) {
                var Ie = void 0;
                Ce[0][ee[43]](ee[42]) || (Ie = Ce[0][ee[35]](), Ce[ee[65]](0, 1));
                var xe = Se[ee[66]](Ie, Pe);
                if (Pe = xe, Se[ee[41]](Ce[0])) {
                  var Ue = fe[ee[67]](Ce[0], Te);
                  Ue[ee[68]] = Ie;
                  var ke = Se[ee[51]](Ce, Ne, ye[ee[69]]);
                  if (ke !== void 0) {
                    var Le = oe(ke, xe, Se[ee[58]](Ne, Ae, Ie), ye, Ue);
                    we[ee[38]](Le);
                  }
                }
              }), we;
            }, be[ee[15]][ee[66]] = function(pe, $e) {
              var ye = Number(pe);
              return pe == null || isNaN(ye) ? $e + 1 : ye;
            }, be;
          }();
          function oe(be, pe, $e, ye, Se) {
            var we, Pe, Te = ce();
            Te[ee[70]] = pe;
            var Ee = fe[ee[71]]($e);
            return Te[ee[52]] = be[ee[52]] + ye[ee[69]], Te[ee[53]] = be[ee[53]] + ye[ee[69]], Te[ee[72]] = ((we = be[ee[57]]) === null || we === void 0 ? void 0 : we[ee[73]]) || ((Pe = be[ee[57]]) === null || Pe === void 0 ? void 0 : Pe[ee[74]]) || ee[27], Te[ee[57]] = fe[ee[75]](be[ee[57]]), Te[ee[76]] = ue({}, Se), ye[ee[76]] !== 0 && (Te[ee[77]] = ye[ee[76]]), Ee && (Te[ee[78]] = Ee), Te[ee[79]] = be[ee[81]][ee[26]](function(Me) {
              return { updateTime: Me[ee[80]] + ye[ee[69]], html: fe[ee[75]](Me[ee[57]]) };
            }), Te;
          }
          function ce() {
            return { i: null, start: null, end: null, text: null, html: null, vtt: fe[ee[82]](), offset: null, updates: [] };
          }
          function he(be) {
            var pe = be[0][ee[25]](/[ \t]+-->[ \t]+/);
            return { start: fe[ee[34]](pe[0]), end: fe[ee[34]](pe[1]) };
          }
          function ge(be) {
            return be[ee[84]](1)[ee[83]](ee[24])[ee[35]]();
          }
          function ve(be, pe, $e) {
            return (pe ? me(pe, ee[85]) : ee[27]) + be + ($e ? me($e, ee[86]) : ee[27]);
          }
          function me(be, pe) {
            return ee[90][ee[88]](pe, ee[89])[ee[88]](be, ee[87]);
          }
          ne[ee[6]] = se, ne[ee[9]] = se;
        }, 35913: function(ie, ne, ae) {
          var ue = this && this[ee[10]] || function() {
            return ue = Object[ee[11]] || function(Ce) {
              for (var Ie, xe = 1, Ue = arguments[ee[12]]; xe < Ue; xe++)
                for (var ke in Ie = arguments[xe])
                  Object[ee[15]][ee[14]][ee[13]](Ie, ke) && (Ce[ke] = Ie[ke]);
              return Ce;
            }, ue[ee[16]](this, arguments);
          }, _e = this && this[ee[91]] || function(Ce, Ie, xe) {
            if (xe || arguments[ee[12]] === 2)
              for (var Ue, ke = 0, Le = Ie[ee[12]]; ke < Le; ke++)
                !Ue && ke in Ie || (Ue || (Ue = Array[ee[15]][ee[84]][ee[13]](Ie, 0, ke)), Ue[ke] = Ie[ke]);
            return Ce[ee[88]](Ue || Array[ee[15]][ee[84]][ee[13]](Ie));
          };
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[56]] = be;
          var fe, le = ae(17699), se = ae(33605), oe = { "&amp;": ee[92], "&lt;": ee[93], "&gt;": ee[89], "&lrm;": ee[94], "&rlm;": ee[95], "&nbsp;": ee[96] }, ce = { c: ee[97], i: ee[70], b: ee[98], u: ee[99], ruby: ee[100], rt: ee[101], v: ee[97], lang: ee[97] }, he = { v: ee[102], lang: ee[103] }, ge = { rt: ee[100] }, ve = { "cue-future": ee[104], "cue-past": ee[105] }, me = 2;
          function be(Ce, Ie, xe, Ue) {
            var ke = pe(Ue);
            return ye({ input: Ce, root: ke, current: ke, tagStack: [], offset: Ie, styles: xe });
          }
          function pe(Ce) {
            var Ie;
            if (Ce) {
              var xe = $e()[ee[108]](ee[106], ee[107]);
              return ((Ie = xe[ee[109]]) === null || Ie === void 0 ? void 0 : Ie[ee[110]]) || xe[ee[110]];
            }
            return document[ee[21]](ee[97]);
          }
          function $e() {
            return fe || (fe = new DOMParser()), fe;
          }
          function ye(Ce) {
            var Ie = Te(Ce[ee[111]]);
            return Ie == null ? Ce[ee[112]] : (Ce[ee[111]] = Ce[ee[111]][ee[55]](Ie[ee[12]]), Pe(Ie, Ce));
          }
          function Se(Ce, Ie) {
            var xe, Ue, ke, Le, De;
            Ce = _e(_e([], Ce, !0), le[ee[113]], !0);
            var Re = ee[27], Oe = ee[27], Be = {};
            if (Ie[ee[114]] && ee[115] !== Ie[ee[114]] && (Be = (Ue = (xe = Ce[ee[49]](function(Ke) {
              return Ke[ee[45]] === Ie[ee[114]];
            })) === null || xe === void 0 ? void 0 : xe[ee[46]]) !== null && Ue !== void 0 ? Ue : Be), Ie[ee[116]]) {
              var Fe = Ie[ee[116]][ee[55]](1)[ee[25]](ee[117])[ee[26]](function(Ke) {
                return ve[Ke] || ee[117][ee[88]](Ke);
              }), Ve = [];
              Fe[ee[48]](function(Ke) {
                var Ze, nt = (Ze = Ce[ee[49]](function(Qe) {
                  return Qe[ee[45]] === Ke;
                })) === null || Ze === void 0 ? void 0 : Ze[ee[46]];
                nt && Ve[ee[38]](nt);
              }), Be = Ve[ee[59]](function(Ke, Ze) {
                return ue(ue({}, Ke), Ze);
              }, {}), Re = Ie[ee[116]][ee[25]](ee[117])[ee[83]](ee[118])[ee[35]]();
            }
            return ee[115] === Ie[ee[114]] && Ie[ee[119]] && (Oe = Ie[ee[119]][ee[55]](1), Be = (Le = (ke = Ce[ee[49]](function(Ke) {
              return Ke[ee[45]] === ee[27][ee[88]](Ie[ee[114]], ee[121])[ee[88]](Oe, ee[120]);
            })) === null || ke === void 0 ? void 0 : ke[ee[46]]) !== null && Le !== void 0 ? Le : Be), { className: Re, title: Oe, styleString: (De = (0, se[ee[71]])(Be)) !== null && De !== void 0 ? De : ee[27] };
          }
          function we(Ce, Ie, xe) {
            var Ue = Se(Ie, xe), ke = Ue[ee[122]], Le = Ue[ee[102]], De = Ue[ee[123]];
            Le && (Ce[ee[102]] = Le), ke && (Ce[ee[122]] = ke), De && Ce[ee[124]](ee[46], De);
          }
          function Pe(Ce, Ie) {
            if (ee[93] !== Ce[0]) {
              var xe = Ie[ee[127]][ee[126]][ee[125]](Ee(Ce));
              return Ie[ee[127]][ee[128]](xe), ye(Ie);
            }
            if (ee[129] === Ce[1])
              return Ne(Ce, Ie[ee[130]]) && (Ie[ee[130]][ee[131]](), Ie[ee[127]] = Ie[ee[127]][ee[132]]), ye(Ie);
            var Ue = (0, se[ee[34]])(Ce[ee[55]](1, Ce[ee[12]] - 1));
            if (Ue != null) {
              var ke = Ie[ee[127]][ee[126]][ee[134]](ee[133][ee[88]](Ue + Ie[ee[77]]));
              return Ie[ee[127]][ee[128]](ke), ye(Ie);
            }
            var Le = /^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/[ee[33]](Ce);
            if (!Le)
              return ye(Ie);
            var De = Le[0], Re = Le[1], Oe = Le[2], Be = Le[3], Fe = Ae(Re, Be, Ie[ee[127]][ee[126]]);
            return Fe && Me(Ie[ee[127]], Fe) && (we(Fe, Ie[ee[62]], { type: Re, contents: Oe, annotation: Be }), Ie[ee[130]][ee[38]](De[1]), Ie[ee[127]][ee[128]](Fe), Ie[ee[127]] = Fe), ye(Ie);
          }
          function Te(Ce) {
            if (!Ce)
              return null;
            var Ie = /^([^<]*)(<[^>]+>?)?/[ee[33]](Ce);
            if (!Ie)
              return null;
            var xe = Ie[1], Ue = Ie[2];
            return xe || Ue;
          }
          function Ee(Ce) {
            return Object[ee[136]](oe)[ee[48]](function(Ie) {
              Ce = Ce[ee[29]](new RegExp(Ie, ee[135]), oe[Ie]);
            }), Ce;
          }
          function Me(Ce, Ie) {
            return !ge[Ie[ee[137]]] || ge[Ie[ee[137]]] === Ce[ee[137]];
          }
          function Ae(Ce, Ie, xe) {
            var Ue = ce[Ce];
            if (!Ue)
              return null;
            var ke = xe[ee[21]](Ue), Le = he[Ce];
            return Le && Ie && (ke[Le] = Ie[ee[35]]()), ke;
          }
          function Ne(Ce, Ie) {
            return Ie[ee[12]] > 0 && Ie[Ie[ee[12]] - 1] === Ce[ee[55]](me)[ee[29]](ee[89], ee[27]);
          }
        }, 17699: function(ie, ne) {
          var ae = this && this[ee[91]] || function(le, se, oe) {
            if (oe || arguments[ee[12]] === 2)
              for (var ce, he = 0, ge = se[ee[12]]; he < ge; he++)
                !ce && he in se || (ce || (ce = Array[ee[15]][ee[84]][ee[13]](se, 0, he)), ce[he] = se[he]);
            return le[ee[88]](ce || Array[ee[15]][ee[84]][ee[13]](se));
          };
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[113]] = void 0;
          var ue = [ee[138], ee[139], ee[140], ee[141], ee[142], ee[143], ee[144], ee[145]];
          function _e(le) {
            return { identifier: ee[117][ee[88]](le), style: { color: le } };
          }
          function fe(le) {
            return { identifier: ee[146][ee[88]](le), style: { background: le } };
          }
          ne[ee[113]] = ae(ae([], ue[ee[26]](_e), !0), ue[ee[26]](fe), !0);
        }, 86535: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[67]] = fe, ne[ee[147]] = le;
          var ue = ae(70016), _e = ae(33605);
          function fe(pe, $e) {
            var ye = pe[ee[25]](/\s/), Se = (0, _e[ee[82]])();
            return ye[ee[48]](function(we) {
              le(we[ee[25]](ee[148]), $e, Se);
            }), be(Se), Se;
          }
          function le(pe, $e, ye) {
            var Se = pe[0], we = pe[1];
            switch (Se) {
              case ee[149]:
                se(we, $e, ye);
                break;
              case ee[150]:
                oe(we, ye);
                break;
              case ee[151]:
                ce(we, ye);
                break;
              case ee[152]:
                he(we, ye);
                break;
              case ee[153]:
                ve(we, ye);
                break;
              case ee[154]:
                me(we, ye);
            }
          }
          function se(pe, $e, ye) {
            var Se = $e[ee[49]](function(we) {
              return we[ee[68]] === pe;
            });
            Se != null && (ye[ee[149]] = Se);
          }
          function oe(pe, $e) {
            var ye = /^(lr|rl)$/, Se = (0, _e[ee[155]])(ye[ee[33]](pe))[1];
            Se != null && ($e[ee[150]] = Se);
          }
          function ce(pe, $e) {
            var ye = /^(start|middle|center|end|left|right)$/, Se = (0, _e[ee[155]])(ye[ee[33]](pe))[1];
            Se != null && ($e[ee[151]] = Se), $e[ee[156]] = ge(void 0, $e);
          }
          function he(pe, $e) {
            var ye = /^([\d.]+)%$/, Se = (0, _e[ee[155]])(ye[ee[33]](pe))[1];
            Se != null && ($e[ee[152]] = Number(Se));
          }
          function ge(pe, $e) {
            if (pe != null)
              return pe;
            switch ($e[ee[151]]) {
              case ee[52]:
              case ee[158]:
                return ee[157];
              case ee[53]:
              case ee[160]:
                return ee[159];
              default:
                return ee[161];
            }
          }
          function ve(pe, $e) {
            var ye = /^([\d.]+|auto)%?(?:,(line-left|line-right|center))?$/, Se = (0, _e[ee[155]])(ye[ee[33]](pe)), we = Se[1], Pe = Se[2];
            ee[162] === we ? $e[ee[153]] = ee[162] : we !== void 0 && ($e[ee[153]] = Number(we)), $e[ee[156]] = ge(Pe, $e);
          }
          function me(pe, $e) {
            var ye = /^(-?[\d.]+|auto)(%)?(?:,(start|end|center|auto))?$/, Se = (0, _e[ee[155]])(ye[ee[33]](pe)), we = Se[1], Pe = Se[2], Te = Se[3], Ee = ee[163] === Pe;
            ee[162] === we ? $e[ee[154]] = ee[162] : Ee ? $e[ee[154]] = ee[27][ee[88]](we, ee[163]) : pe != null && ($e[ee[154]] = Number(we)), Te != null && ($e[ee[164]] = Te), $e[ee[165]] = (0, ue[ee[166]])($e[ee[154]]);
          }
          function be(pe) {
            var $e = (0, _e[ee[82]])();
            pe[ee[149]] != null && (pe[ee[150]] !== $e[ee[150]] || pe[ee[152]] !== $e[ee[152]] || pe[ee[154]] !== $e[ee[154]]) && delete pe[ee[149]];
          }
        }, 33605: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[82]] = se, ne[ee[7]] = oe, ne[ee[167]] = he, ne[ee[34]] = ge, ne[ee[155]] = ve, ne[ee[71]] = me, ne[ee[75]] = be;
          var ue = ae(70016), _e = ae(91520), fe = ae(16368), le = ae(86535);
          function se() {
            return { vertical: ee[27], align: ee[161], size: 100, line: ee[162], lineAlign: ee[52], position: ee[162], positionAlign: ee[161], snapToLines: !1 };
          }
          function oe(pe) {
            var $e = se(), ye = he();
            return Object[ee[136]]($e)[ee[48]](function(Se) {
              return (0, le[ee[147]])(ce(Se, pe, $e), [ye], $e);
            }), $e;
          }
          function ce(pe, $e, ye) {
            var Se = [pe, $e[pe] ? ee[27][ee[88]]($e[pe]) : ye[pe]], we = ee[154] === pe;
            return (ee[153] === pe && (0, ue[ee[166]])($e[pe]) || we && $e[ee[165]] === !1) && (Se[1] += ee[163]), Se;
          }
          function he() {
            return { id: null, width: 100, lines: 3, regionAnchorX: 0, regionAnchorY: 100, viewportAnchorX: 0, viewportAnchorY: 100, scroll: ee[27] };
          }
          function ge(pe) {
            var $e = /(?:(\d{1,}):)?(\d{2}):(\d{2})[.,](\d{3})/g[ee[33]](pe);
            if ($e == null)
              return null;
            var ye = $e[1], Se = $e[2], we = $e[3], Pe = $e[4];
            return Number(Pe) / 1e3 + Number(we) + 60 * Number(Se) + 3600 * (Number(ye) || 0);
          }
          function ve(pe) {
            return Array[ee[168]](pe) ? pe : [];
          }
          function me(pe) {
            return pe ? Object[ee[170]](pe)[ee[26]](function($e) {
              return ee[27][ee[88]]($e[0], ee[148])[ee[88]]($e[1], ee[169]);
            })[ee[83]](ee[27]) : null;
          }
          function be(pe) {
            return (0, _e[ee[175]][ee[174]](fe[ee[5]][ee[8]])[ee[173]][ee[172]])((pe == null ? void 0 : pe[ee[171]]) || ee[27]);
          }
        }, 98855: function(ie, ne, ae) {
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[39]] = _e;
          var ue = ae(33605);
          function _e(pe) {
            for (var $e = [], ye = 0, Se = pe; ye < Se[ee[12]]; ye++) {
              var we = Se[ye];
              if (we = we[ee[35]](), /^REGION$/i[ee[36]](we)) {
                $e[ee[38]](fe(pe));
                break;
              }
              /^Region:/i[ee[36]](we) && $e[ee[38]](le(we));
            }
            return $e;
          }
          function fe(pe) {
            return se(pe[ee[84]](1), ee[148]);
          }
          function le(pe) {
            return se(pe[ee[25]](/[ \t]+/)[ee[84]](1), ee[176]);
          }
          function se(pe, $e) {
            var ye = (0, ue[ee[167]])();
            return pe[ee[48]](function(Se) {
              oe(Se[ee[25]]($e), ye);
            }), ye;
          }
          function oe(pe, $e) {
            var ye = pe[0], Se = pe[1];
            switch (ye) {
              case ee[68]:
                ce(Se, $e);
                break;
              case ee[177]:
                he(Se, $e);
                break;
              case ee[178]:
                ge(Se, $e);
                break;
              case ee[179]:
                ve(Se, $e);
                break;
              case ee[180]:
                me(Se, $e);
                break;
              case ee[181]:
                be(Se, $e);
            }
          }
          function ce(pe, $e) {
            pe != null && ($e[ee[68]] = pe);
          }
          function he(pe, $e) {
            var ye = /^(\d{1,2}|100)%$/, Se = (0, ue[ee[155]])(ye[ee[33]](pe))[1];
            Se != null && ($e[ee[177]] = Number(Se));
          }
          function ge(pe, $e) {
            var ye = /^(\d+)$/, Se = (0, ue[ee[155]])(ye[ee[33]](pe))[1];
            Se != null && ($e[ee[178]] = Number(Se));
          }
          function ve(pe, $e) {
            var ye = /^(\d{1,2}|100)%,(\d{1,2}|100)%$/, Se = (0, ue[ee[155]])(ye[ee[33]](pe)), we = Se[1], Pe = Se[2];
            we != null && ($e[ee[182]] = Number(we)), Pe != null && ($e[ee[183]] = Number(Pe));
          }
          function me(pe, $e) {
            var ye = /^(\d{1,2}|100)%,(\d{1,2}|100)%$/, Se = (0, ue[ee[155]])(ye[ee[33]](pe)), we = Se[1], Pe = Se[2];
            we != null && ($e[ee[184]] = Number(we)), Pe != null && ($e[ee[185]] = Number(Pe));
          }
          function be(pe, $e) {
            var ye = /^(up)$/, Se = (0, ue[ee[155]])(ye[ee[33]](pe))[1];
            Se != null && ($e[ee[181]] = Se);
          }
        }, 10517: function(ie, ne) {
          function ae(_e) {
            var fe = [], le = /::cue(\((.+)\))?(?= |{)/, se = /([a-zA-Z0-9-]+):(.+?(?=;|}|$))/g, oe = le[ee[33]](_e[1]);
            if (!oe)
              return fe;
            for (var ce = 1; ce < _e[ee[12]]; ce++) {
              for (var he = le[ee[33]](_e[ce]), ge = he !== null, ve = (oe = ge ? he : oe)[2], me = {}, be = se[ee[33]](_e[ce]); be !== null; ) {
                var pe = be[1], $e = be[2];
                me[pe] = $e[ee[35]](), be = se[ee[33]](_e[ce]);
              }
              (ge || Object[ee[136]](me)[ee[12]] > 0) && fe[ee[38]]({ identifier: ve, style: me });
            }
            return fe;
          }
          function ue() {
            return [{ identifier: ee[104], style: { visibility: ee[186] } }];
          }
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[37]] = ae, ne[ee[50]] = ue;
        }, 53166: function(ie, ne, ae) {
          var ue = this && this[ee[187]] || (Object[ee[188]] ? function(fe, le, se, oe) {
            oe === void 0 && (oe = se);
            var ce = Object[ee[189]](le, se);
            ce && !(ee[174] in ce ? !le[ee[1]] : ce[ee[190]] || ce[ee[191]]) || (ce = { enumerable: !0, get: function() {
              return le[se];
            } }), Object[ee[2]](fe, oe, ce);
          } : function(fe, le, se, oe) {
            oe === void 0 && (oe = se), fe[oe] = le[se];
          }), _e = this && this[ee[192]] || function(fe, le) {
            for (var se in fe)
              ee[9] === se || Object[ee[15]][ee[14]][ee[13]](le, se) || ue(le, fe, se);
          };
          Object[ee[2]](ne, ee[1], { value: !0 }), _e(ae(98855), ne), _e(ae(35913), ne), _e(ae(86535), ne), _e(ae(33605), ne), _e(ae(10517), ne);
        } }, function(ie) {
          return function(ne) {
            return ie(ie[ee[193]] = ne);
          }(57011);
        }]);
      });
    })();
  })();
})(bitmovinplayerSubtitlesVtt, bitmovinplayerSubtitlesVtt.exports);
var bitmovinplayerSubtitlesVttExports = bitmovinplayerSubtitlesVtt.exports;
const SubtitlesVTT = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerSubtitlesVttExports);
var bitmovinplayerSubtitlesNative = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ie) {
      re.exports = ie();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[826], { 26976: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.NativeSubtitlesModuleDefinition = void 0;
        var ae = ne(16368), ue = ne(21999);
        ie.NativeSubtitlesModuleDefinition = { name: ae.ModuleName.SubtitlesNative, module: function() {
          return { TextTrackController: ue.TextTrackController };
        }, dependencies: [ae.ModuleName.Subtitles] }, ie.default = ie.NativeSubtitlesModuleDefinition;
      }, 21999: function(ee, ie, ne) {
        var ae = this && this.__assign || function() {
          return ae = Object.assign || function(Ne) {
            for (var Ce, Ie = 1, xe = arguments.length; Ie < xe; Ie++)
              for (var Ue in Ce = arguments[Ie])
                Object.prototype.hasOwnProperty.call(Ce, Ue) && (Ne[Ue] = Ce[Ue]);
            return Ne;
          }, ae.apply(this, arguments);
        }, ue = this && this.__spreadArray || function(Ne, Ce, Ie) {
          if (Ie || arguments.length === 2)
            for (var xe, Ue = 0, ke = Ce.length; Ue < ke; Ue++)
              !xe && Ue in Ce || (xe || (xe = Array.prototype.slice.call(Ce, 0, Ue)), xe[Ue] = Ce[Ue]);
          return Ne.concat(xe || Array.prototype.slice.call(Ce));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.TextTrackController = void 0;
        var _e, fe, le, se = ne(63546), oe = ne(35148), ce = ne(62510), he = ne(88005), ge = ne(67345), ve = ne(81361), me = ne(76885), be = ne(91520), pe = ne(16368), $e = ne(31448);
        (function(Ne) {
          Ne.Showing = "showing", Ne.Hidden = "hidden", Ne.Disabled = "disabled";
        })(_e || (_e = {})), function(Ne) {
          Ne.Subtitle = "subtitles", Ne.ForcedSubtitle = "forced", Ne.Caption = "captions", Ne.Metadata = "metadata";
        }(fe || (fe = {})), function(Ne) {
          Ne.ID3 = "org.id3", Ne.DATERANGE = "com.apple.quicktime.HLS", Ne.EMSG = "https://aomedia.org/emsg/ID3";
        }(le || (le = {}));
        var ye = function(Ne) {
          var Ce = 5.333333333333333, Ie = 2.5, xe = Ne.line - 10, Ue = Ne.position - 10;
          return xe -= xe % Ce, Ue -= Ue % Ie, { row: xe = Math.round(xe / Ce), column: Ue = Math.round(Ue / Ie) };
        }, Se = new RegExp("^(?:[a-z]+:)?//", "i"), we = function(Ne) {
          return location.protocol === "https:" ? Ne.replace(Se, "//") : Ne;
        }, Pe = function(Ne) {
          var Ce = { id: Ne.id, lang: Ne.lang, label: Ne.label, kind: Ne.kind, isFragmented: Ne.isFragmented, isSideloaded: Ne.isSideloaded, enabled: Ne.textTrack && Ne.textTrack.mode !== _e.Disabled, forced: Ne.kind === fe.ForcedSubtitle };
          return Ne.url && (Ce.url = Ne.url), Ce;
        }, Te = function() {
          function Ne(Ce, Ie, xe, Ue) {
            var ke = this;
            this.onFileLoaded = function(Le, De, Re) {
              var Oe = Le.body;
              Oe && ke.add(Oe.trim(), Re);
            }, this.onFileLoadError = function(Le, De) {
              ke.context.logger.debug("Error loading subtitle file: " + JSON.stringify(De)), ke.removeSubtitle(ke.getSubtitleIDFromUrl(Le.url)), ke.eventHandler.dispatchEvent(ce.PlayerEvent.Warning, new se.PlayerWarning(oe.WarningCode.NETWORK_COULD_NOT_LOAD_SUBTITLE)), ke.context.logger.debug("Could not load subtitles/captions, got HTTP status code " + Le.status);
            }, this.onMetadataCueChangeHandler = function(Le) {
              var De = Le.currentTarget.activeCues, Re = { frames: [] }, Oe = [];
              for (var Be in De)
                if (De[Be].type === le.ID3 && De[Be].value !== void 0) {
                  var Fe = De[Be].value;
                  ve.ArrayHelper.isArrayBuffer(Fe.data) && ((Fe = ae({}, Fe)).data = ve.ArrayHelper.getArray(new Uint8Array(Fe.data))), Re[Fe.key] = Fe.data, Re.frames.push(Fe), Oe.push(De[Be]);
                }
              Re.frames.length && ke.eventHandler.dispatchEvent(ce.PlayerEvent.Metadata, { metadataType: ce.MetadataType.ID3, metadata: Re }), Oe.forEach(function(Ve) {
                return Le.currentTarget.removeCue(Ve);
              });
            }, this.onCueChange = function(Le) {
              var De = Le.target;
              if (De.activeCues && De.activeCues.length > 0) {
                var Re = $e.TextTrackCueHelper.cueListToArray(De.activeCues), Oe = ke.getIdFromTextTrack(De);
                $e.TextTrackCueHelper.sort(Re).forEach(function(Be) {
                  return ke.processCue(Oe, Be);
                });
              }
            }, this.addTrack = function(Le) {
              var De = window.setTimeout(function() {
                return ke.asyncAddTrack(Le);
              }, 0);
              ke.timeoutsToClear.push(De);
            }, this.getDefaultLabelForSubtitle = function() {
              return null;
            }, this.setForcedSubtitles = function() {
              var Le;
              ke.activeSubtitleId ? ke.activeForcedSubtitleId && ke.disableSubtitle(ke.activeForcedSubtitleId) : (ke.activeForcedSubtitleId = (Le = ke.getForcedSubtitleForSelectedLanguage()) === null || Le === void 0 ? void 0 : Le.id, ke.activeForcedSubtitleId && ke.enableSubtitle(ke.activeForcedSubtitleId, !0));
            }, this.audioChangeHandler = function() {
              ke.disableSubtitle(ke.activeForcedSubtitleId), ke.setForcedSubtitles();
            }, this.textTracksChangeHandler = function() {
              var Le = ke.getTextTrackAndSubtitleId(), De = Le[0], Re = Le[1];
              if (ke.shouldIgnoreTextTrackChange(Re))
                return ke.disableSubtitle(Re), void ke.setForcedSubtitles();
              Re || (ke.activeSubtitleId = void 0), ke.setForcedSubtitles(), ke.isNative && ke.syncTracksSelectedThroughNativeUI(), Re && De && De.mode !== _e.Hidden && !ke.recentlyAddedTracks.includes(De) && ke.enableSubtitle(Re);
            }, this.context = Ce, this.eventHandler = Ce.eventHandler, this.video = Ie, this.type = Ue, this.metadataTracks = [], this.availableTracks = {}, this.currentCCIdx = 1, this.currentSubIdx = 0, this.showNative = !1, this.timeoutsToClear = [], this.recentlyAddedTracks = [], this.activeCues = [], this.subtitleLoader = null, xe.hasOwnProperty("style") && xe.style.hasOwnProperty("nativeSubtitles") ? this.showNativeAlways = !!xe.style.nativeSubtitles : this.showNativeAlways = !1, Ie.audioTracks && Ie.audioTracks.addEventListener("change", this.audioChangeHandler), Ie.textTracks && typeof Ie.textTracks.addEventListener == "function" && (Ie.textTracks.addEventListener("addtrack", this.addTrack), Ie.textTracks.addEventListener("change", this.textTracksChangeHandler));
          }
          return Object.defineProperty(Ne.prototype, "isNative", { get: function() {
            return this.showNative || this.showNativeAlways;
          }, enumerable: !1, configurable: !0 }), Ne.prototype.getAvailableSubtitles = function() {
            return Object.values(this.availableTracks || {}).filter(function(Ce) {
              return Ce.kind !== fe.ForcedSubtitle;
            }).map(Pe);
          }, Ne.prototype.enableSubtitle = function(Ce, Ie) {
            Ie === void 0 && (Ie = !1);
            var xe = this.availableTracks[Ce];
            return xe ? (Ie || (this.activeSubtitleId = Ce), xe.textTrack && (this.showNativeAlways || this.showNative ? xe.textTrack.mode = _e.Showing : xe.textTrack.mode = _e.Hidden), xe.enabled ? Promise.resolve(!1) : (xe.enabled = !0, xe.textTrack ? xe.loadPromise.then(function() {
              return !0;
            }, function() {
              return !1;
            }) : Promise.resolve(!0))) : Promise.resolve(!1);
          }, Ne.prototype.disableSubtitle = function(Ce) {
            var Ie = this, xe = this.availableTracks[Ce];
            return !!xe && (xe.textTrack && (xe.textTrack.mode = _e.Disabled), xe.enabled = !1, ue([], this.activeCues, !0).forEach(function(Ue) {
              return Ue.subtitleId === Ce && Ie.deactivateCue(Ce, Ue);
            }), !0);
          }, Ne.prototype.toTextTrackCue = function(Ce) {
            var Ie, xe;
            return window.VTTCue ? new window.VTTCue(Ce.start, Ce.end, (Ie = Ce.html) !== null && Ie !== void 0 ? Ie : Ce.text) : window.TextTrackCue ? new TextTrackCue(Ce.start, Ce.end, (xe = Ce.html) !== null && xe !== void 0 ? xe : Ce.text) : void 0;
          }, Ne.prototype.getSubtitleIDFromUrl = function(Ce) {
            if (Ce && this.availableTracks) {
              for (var Ie in this.availableTracks)
                if (this.availableTracks.hasOwnProperty(Ie) && this.availableTracks[Ie].url === Ce)
                  return Ie;
            }
          }, Ne.prototype.add = function(Ce, Ie) {
            var xe = this.getSubtitleIDFromUrl(Ie);
            if (xe && Ce) {
              for (var Ue = be.ModuleManager.get(pe.ModuleName.Subtitles).SubtitleParserFactory.createInstance(this.context, Ce).parse(Ce), ke = 0; ke < Ue.length; ke++)
                this.eventHandler.dispatchEvent(ce.PlayerEvent.CueParsed, ae(ae({ subtitleId: xe }, Ue[ke]), { periodId: null })), this.availableTracks[xe].textTrack.addCue(this.toTextTrackCue(Ue[ke]));
              this.eventHandler.dispatchEvent(ce.PlayerEvent.SubtitleAdded, { subtitle: Pe(this.availableTracks[xe]) });
            }
          }, Ne.prototype.loadFile = function(Ce) {
            var Ie = this;
            if (Ce && Ce.trim())
              return this.context.logger.debug("loading " + Ce), this.subtitleLoader = new he.DefaultContentLoader(this.context, { maxRetries: this.context.settings.MAX_RETRIES, retryDelay: this.context.settings.RETRY_DELAY, onSuccess: this.onFileLoaded, onFailure: this.onFileLoadError, requestType: ge.HttpRequestType.MEDIA_SUBTITLES }), this.subtitleLoader.load(Ce).catch(function(xe) {
                Ie.context.logger.debug("Error while loading subtitles ", xe);
              });
          }, Ne.prototype.createCueEvents = function(Ce, Ie) {
            var xe = be.ModuleManager.get(pe.ModuleName.Subtitles).HtmlTransformer, Ue = xe.htmlToText, ke = xe.stripHtmlTags, Le = (be.ModuleManager.get(pe.ModuleName.SubtitlesWebVTT, !1) || {}).extractVttProperties, De = { subtitleId: Ce, text: Ue(Ie.text), start: Ie.startTime, end: Ie.endTime }, Re = [De];
            if (Ie.track.kind === "subtitles")
              De.html = Ae(Ie.text), window.VTTCue && (Ie instanceof VTTCue && Le ? De.vtt = Le(Ie) : Ie instanceof VTTCue && this.context.logger.debug("Could not interpret VTT properties from native VTTCue Event as ".concat(pe.ModuleName.SubtitlesWebVTT, " is missing")));
            else if (Ie.track.kind === "captions") {
              De.position = ye(Ie);
              var Oe = ke(De.text);
              De.position.column + Oe.length > $e.CEA_608_MAX_LINE_LENGTH - 1 && (Re = $e.TextTrackCueHelper.splitCea608Cue(De));
            }
            return Re;
          }, Ne.prototype.processCue = function(Ce, Ie) {
            var xe = this;
            if (Ie) {
              var Ue = Object.values(this.availableTracks).find(function(Le) {
                return Le.textTrack === Ie.track;
              });
              if (Me(this.showNativeAlways || this.showNative, Ie, Ue), !this.showNativeAlways && !this.showNative) {
                var ke = this.createCueEvents(Ce, Ie);
                ke.forEach(function(Le) {
                  xe.updateCue(Le) ? xe.eventHandler.dispatchEvent(ce.PlayerEvent.CueUpdate, Le) : xe.activateCue(Ce, Ie, Le);
                }), this.removeFloatingCues(Ce, ke);
              }
            }
          }, Ne.prototype.removeFloatingCues = function(Ce, Ie) {
            var xe = this, Ue = this.activeCues.filter(function(ke) {
              return !Ie.find(function(Le) {
                return ke.start === Le.start && ke.text === Le.text && ke.subtitleId === Le.subtitleId;
              }) && ke.end === 1 / 0 && ke.subtitleId === Ce;
            });
            Ue.length > 0 && Ue.forEach(function(ke) {
              xe.deactivateCue(Ce, ke);
            });
          }, Ne.prototype.updateCue = function(Ce) {
            var Ie = this, xe = this.activeCues.find(function(Ue) {
              var ke = Ue.start === Ce.start, Le = Ue.text === Ce.text, De = !Ce.end || Ue.end === 1 / 0 || Ue.end === Ie.video.duration || Ue.end === Ce.end;
              return ke && Le && De;
            });
            return !!xe && (xe.end = Ce.end, !0);
          }, Ne.prototype.activateCue = function(Ce, Ie, xe) {
            var Ue = this;
            this.activeCues.push(xe), Ie.onexit = function() {
              Ue.createCueEvents(Ce, Ie).forEach(function(ke) {
                return Ue.deactivateCue(Ce, ke);
              });
            }, this.eventHandler.dispatchEvent(ce.PlayerEvent.CueEnter, xe);
          }, Ne.prototype.deactivateCue = function(Ce, Ie) {
            var xe = this.activeCues.find(function(ke) {
              return ke.start === Ie.start && ke.end === Ie.end && ke.text === Ie.text;
            });
            if (xe) {
              this.activeCues = this.activeCues.filter(function(ke) {
                return ke !== xe;
              });
              var Ue = { subtitleId: Ce, text: xe.text, start: xe.start, end: xe.end };
              xe.position && (Ue.position = xe.position), this.eventHandler.dispatchEvent(ce.PlayerEvent.CueExit, Ue);
            }
          }, Ne.prototype.removeSubtitle = function(Ce) {
            if (this.availableTracks.hasOwnProperty(Ce)) {
              this.availableTracks[Ce].textTrack.mode !== _e.Disabled && this.disableSubtitle(Ce), this.availableTracks[Ce].textTrack.mode = _e.Disabled;
              var Ie = this.availableTracks[Ce];
              delete this.availableTracks[Ce], this.eventHandler.dispatchEvent(ce.PlayerEvent.SubtitleRemoved, { subtitle: Pe(Ie) });
            }
          }, Ne.prototype.signalSourceChange = function() {
            this.video && this.video.textTracks && typeof this.video.textTracks.addEventListener == "function" && this.video.textTracks.removeEventListener("addtrack", this.addTrack), this.removeAll();
          }, Ne.prototype.removeAll = function() {
            for (var Ce in this.context.logger.debug("removing all subtitle tracks"), this.timeoutsToClear.forEach(function(Ie) {
              return clearTimeout(Ie);
            }), this.timeoutsToClear = [], this.availableTracks)
              this.availableTracks.hasOwnProperty(Ce) && (this.availableTracks[Ce].textTrack.mode = _e.Disabled, this.availableTracks[Ce].textTrack.removeEventListener("cuechange", this.onCueChange));
            this.availableTracks = {}, this.activeCues = [], this.currentCCIdx = 1, this.currentSubIdx = 0;
          }, Ne.prototype.addSubtitle = function(Ce) {
            if (typeof this.video.addTextTrack != "function")
              return this.context.logger.warn("adding subtitles not supported!"), Promise.reject();
            this.availableTracks.hasOwnProperty(Ce.id) && (this.context.logger.debug("re-adding subtitle " + Ce.id), this.removeSubtitle(Ce.id));
            var Ie = Ce.url ? me.URLHelper.toFullUrl(we(Ce.url.trim())) : null, xe = { id: Ce.id, url: Ie, kind: Ce.kind, lang: Ce.lang, label: Ce.label, textTrack: null, isFragmented: !1, isSideloaded: !0, loadPromise: null };
            return this.availableTracks[Ce.id] = xe, this.availableTracks[Ce.id].textTrack = this.video.addTextTrack(Ce.kind, Ce.label), this.availableTracks[Ce.id].textTrack.mode = _e.Disabled, this.availableTracks[Ce.id].textTrack.addEventListener("cuechange", this.onCueChange), this.loadSubtitleFile(xe);
          }, Ne.prototype.loadSubtitleFile = function(Ce) {
            var Ie = this;
            return Ce.url ? Ce.loadPromise = this.loadFile(Ce.url).then(function() {
              if (!Ie.getAvailableSubtitles().find(function(xe) {
                return xe.id === Ce.id;
              }))
                throw "subtitle adding failed";
            }) : (this.context.logger.log("No url was provided for an external subtitle, nothing will be loaded."), Ce.loadPromise = Promise.resolve(), this.eventHandler.dispatchEvent(ce.PlayerEvent.SubtitleAdded, { subtitle: Pe(Ce) })), Ce.loadPromise;
          }, Ne.prototype.asyncAddTrack = function(Ce) {
            for (var Ie, xe, Ue = this, ke = Ce.track, Le = Ce.isFragmented && ke.kind === fe.Subtitle || !1, De = 0, Re = Object.keys(this.availableTracks); De < Re.length; De++) {
              var Oe = Re[De], Be = this.availableTracks[Oe];
              if (Be.textTrack === ke && Be.isSideloaded)
                return void this.context.logger.insane("track " + ke.label + " has already been added externally");
            }
            switch (ke.kind) {
              case fe.Subtitle:
                Ie = ke.id || "sub".concat(this.currentSubIdx), xe = ke.label || "Subtitles (".concat(this.currentSubIdx, ")"), this.currentSubIdx++;
                break;
              case fe.ForcedSubtitle:
                Ie = ke.id || "fsub".concat(this.currentSubIdx), xe = ke.label || "Subtitles (".concat(this.currentSubIdx, ")) (Forced)"), this.currentSubIdx++;
                break;
              case fe.Caption:
                Ie = "CC".concat(this.currentCCIdx), xe = ke.label || "Captions (CC ".concat(this.currentCCIdx, ")"), this.currentCCIdx++;
                break;
              default:
                return void this.addMetadataTrack(ke);
            }
            this.context.logger.debug("adding ".concat(ke.kind, " text track ").concat(Ie)), this.availableTracks[Ie] = { id: Ie, url: null, kind: ke.kind, lang: ke.language || "unknown", label: xe, textTrack: ke, isFragmented: Le, isSideloaded: !1, loadPromise: Promise.resolve() }, (xe = this.getLabelForSubtitle(this.availableTracks[Ie])) && typeof xe == "string" && (this.availableTracks[Ie].label = xe), this.recentlyAddedTracks.push(ke), ke.addEventListener("cuechange", this.onCueChange), ke.kind !== fe.ForcedSubtitle && this.eventHandler.dispatchEvent(ce.PlayerEvent.SubtitleAdded, { subtitle: Pe(this.availableTracks[Ie]) }), ke.mode = _e.Disabled;
            var Fe = window.setTimeout(function() {
              Ue.recentlyAddedTracks = Ue.recentlyAddedTracks.filter(function(Ve) {
                return Ve !== ke;
              }), Object.keys(Ue.availableTracks).map(function(Ve) {
                return Ue.availableTracks[Ve];
              }).filter(function(Ve) {
                return Ve.enabled && !!Ve.textTrack && Ve.textTrack.mode === _e.Disabled;
              }).forEach(function(Ve) {
                Ue.isNative ? Ve.textTrack.mode = _e.Showing : Ve.textTrack.mode = _e.Hidden;
              });
            }, 0);
            this.timeoutsToClear.push(Fe), this.hasStoredAllTracks() && this.setForcedSubtitles();
          }, Ne.prototype.addMetadataTrack = function(Ce) {
            this.context.settings.HLS_PARSE_NATIVE_METADATA && (this.metadataTracks.push(Ce), Ce.mode = _e.Hidden, Ce.addEventListener("cuechange", this.onMetadataCueChangeHandler));
          }, Ne.prototype.hasStoredAllTracks = function() {
            var Ce = Object.keys(this.availableTracks).length;
            return this.video.textTracks.length === Ce;
          }, Ne.prototype.getLabelForSubtitle = function(Ce) {
            var Ie = { kind: Ce.kind, id: Ce.id, label: Ce.label, lang: Ce.lang };
            return this.getLabelingFunctionForSubtitle()(Ie);
          }, Ne.prototype.getLabelingFunctionForSubtitle = function() {
            var Ce = this.context.sourceContext, Ie = Ce && Ce.source && Ce.source.labeling;
            return Ie && Ie[this.type] && Ie[this.type].subtitles ? typeof Ie[this.type].subtitles != "function" ? this.getDefaultLabelForSubtitle : Ie[this.type].subtitles : this.getDefaultLabelForSubtitle;
          }, Ne.prototype.getIdFromTextTrack = function(Ce) {
            var Ie;
            return ((Ie = Object.values(this.availableTracks).find(function(xe) {
              return xe.textTrack === Ce;
            })) === null || Ie === void 0 ? void 0 : Ie.id) || null;
          }, Ne.prototype.getTextTrackAndSubtitleId = function() {
            for (var Ce = 0, Ie = this.video.textTracks; Ce < Ie.length; Ce++) {
              var xe = Ie[Ce];
              if ((xe.mode === _e.Showing || xe.mode === _e.Hidden) && xe.kind !== fe.Metadata && xe.kind !== fe.ForcedSubtitle)
                return [xe, this.getIdFromTextTrack(xe)];
            }
            return [void 0, void 0];
          }, Ne.prototype.enableNative = function() {
            var Ce = this;
            Object.keys(this.availableTracks).map(function(Ie) {
              return Ce.availableTracks[Ie];
            }).filter(function(Ie) {
              return Ie.enabled && !!Ie.textTrack;
            }).forEach(function(Ie) {
              return Ie.textTrack.mode = _e.Showing;
            }), this.showNative = !0;
          }, Ne.prototype.disableNative = function() {
            var Ce = this;
            Object.keys(this.availableTracks).map(function(Ie) {
              return Ce.availableTracks[Ie];
            }).filter(function(Ie) {
              return Ie.enabled && !!Ie.textTrack;
            }).forEach(function(Ie) {
              return Ie.textTrack.mode = _e.Hidden;
            }), this.showNative = !1;
          }, Ne.prototype.seek = function() {
            var Ce = this;
            Object.keys(this.availableTracks).map(function(Ie) {
              return Ce.availableTracks[Ie];
            }).filter(function(Ie) {
              return Ie.enabled && !!Ie.textTrack;
            }).forEach(function(Ie) {
              var xe = Ie.textTrack.mode;
              Ie.textTrack.mode = _e.Disabled, Ie.textTrack.mode = xe;
            });
          }, Ne.prototype.getForcedSubtitleForSelectedLanguage = function() {
            var Ce, Ie, xe, Ue = this.video.audioTracks, ke = be.ModuleManager.get(pe.ModuleName.Subtitles).LanguageComparer.isEqualIsoLanguage;
            if (this.activeSubtitleId)
              xe = (Ce = this.availableTracks[this.activeSubtitleId]) === null || Ce === void 0 ? void 0 : Ce.lang;
            else {
              if (!Ue)
                return;
              var Le = ve.ArrayHelper.toArray(Ue).find(function(Oe) {
                return Oe.enabled;
              });
              xe = Le == null ? void 0 : Le.language;
            }
            xe = (Ie = xe ?? navigator.language) !== null && Ie !== void 0 ? Ie : navigator.userLanguage;
            var De = Object.values(this.availableTracks).filter(function(Oe) {
              return Oe.kind === fe.ForcedSubtitle;
            }), Re = De.find(function(Oe) {
              return ke(Oe.lang, xe);
            });
            return Re ?? De[0];
          }, Ne.prototype.shouldIgnoreTextTrackChange = function(Ce) {
            var Ie = this, xe = Object.keys(this.availableTracks).some(function(Ue) {
              return Ue === Ce && Ie.availableTracks[Ue].enabled;
            });
            return Ce && !this.isNative && !xe;
          }, Ne.prototype.syncTracksSelectedThroughNativeUI = function() {
            var Ce = this, Ie = function(xe) {
              var Ue = ae({}, xe);
              return delete Ue.loadPromise, delete Ue.textTrack, ae({}, Ue);
            };
            this.getUnsyncedDisabledTracks().forEach(function(xe) {
              Ce.disableSubtitle(xe.id), Ce.eventHandler.dispatchEvent(ce.PlayerEvent.SubtitleDisabled, { subtitle: Ie(xe) });
            }), this.getUnsyncedEnabledTracks().forEach(function(xe) {
              Ce.eventHandler.dispatchEvent(ce.PlayerEvent.SubtitleEnabled, { subtitle: Ie(xe) });
            });
          }, Ne.prototype.getUnsyncedDisabledTracks = function() {
            var Ce = this.video.textTracks;
            return Object.values(this.availableTracks).filter(function(Ie) {
              return Ie.enabled;
            }).filter(function(Ie) {
              var xe = Ee(Ce, Ie);
              return xe && xe.mode === _e.Disabled;
            });
          }, Ne.prototype.getUnsyncedEnabledTracks = function() {
            var Ce = this.video.textTracks;
            return Object.values(this.availableTracks).filter(function(Ie) {
              return !Ie.enabled;
            }).filter(function(Ie) {
              var xe = Ee(Ce, Ie);
              return xe && xe.mode !== _e.Disabled;
            });
          }, Ne.prototype.dispose = function() {
            var Ce;
            this.removeAll(), this.eventHandler = null, this.activeCues = null, this.availableTracks = null, this.metadataTracks = null, (Ce = this.video.audioTracks) === null || Ce === void 0 || Ce.removeEventListener("change", this.audioChangeHandler), this.video && this.video.textTracks && typeof this.video.textTracks.addEventListener == "function" && (this.video.textTracks.removeEventListener("addtrack", this.addTrack), this.video.textTracks.removeEventListener("change", this.textTracksChangeHandler)), this.subtitleLoader && this.subtitleLoader.dispose(), this.subtitleLoader = null;
          }, Ne;
        }();
        function Ee(Ne, Ce) {
          for (var Ie = 0, xe = Ne; Ie < xe.length; Ie++) {
            var Ue = xe[Ie];
            if (Ue === Ce.textTrack)
              return Ue;
          }
        }
        function Me(Ne, Ce, Ie) {
          if (Ie) {
            var xe = be.ModuleManager.get(pe.ModuleName.Subtitles).HtmlTransformer, Ue = xe.stripAwayHtmlBreakPoints, ke = xe.replaceHtmlBreakPointsWithNewLine;
            Ne && Ie.isSideloaded && (Ce.text = ke(Ce.text)), Ne || Ie.isSideloaded || (Ce.text = Ue(Ce.text));
          }
        }
        function Ae(Ne) {
          var Ce = (0, be.ModuleManager.get(pe.ModuleName.Subtitles).HtmlTransformer.prepareHtml)(Ne);
          return Ce.startsWith("<span>") ? Ce : "<span>".concat(Ce, "</span>");
        }
        ie.TextTrackController = Te;
      }, 31448: function(ee, ie) {
        var ne = this && this.__assign || function() {
          return ne = Object.assign || function(ue) {
            for (var _e, fe = 1, le = arguments.length; fe < le; fe++)
              for (var se in _e = arguments[fe])
                Object.prototype.hasOwnProperty.call(_e, se) && (ue[se] = _e[se]);
            return ue;
          }, ne.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.TextTrackCueHelper = ie.CEA_608_MAX_LINE_LENGTH = void 0, ie.CEA_608_MAX_LINE_LENGTH = 32;
        var ae = function() {
          function ue() {
          }
          return ue.cueListToArray = function(_e) {
            for (var fe = [], le = 0; le < _e.length; le++)
              fe.push(_e[le]);
            return fe;
          }, ue.sortEqualStartTimeByLineFn = function(_e, fe) {
            if ("line" in _e && "line" in fe && _e.startTime === fe.startTime) {
              if (_e.line < fe.line)
                return -1;
              if (_e.line > fe.line)
                return 1;
            }
            return 0;
          }, ue.sortByStartTimeFn = function(_e, fe) {
            return _e.startTime < fe.startTime ? -1 : _e.startTime > fe.startTime ? 1 : 0;
          }, ue.sort = function(_e) {
            return _e.sort(ue.sortByStartTimeFn), _e.sort(ue.sortEqualStartTimeByLineFn), _e;
          }, ue.getTagIndexRanges = function(_e) {
            for (var fe, le = RegExp("<[^>]*>", "g"), se = []; fe = le.exec(_e); ) {
              var oe = fe[0];
              se.push({ start: fe.index, end: fe.index + oe.length - 1 });
            }
            return se;
          }, ue.splitCea608Cue = function(_e) {
            for (var fe = ie.CEA_608_MAX_LINE_LENGTH - _e.position.column, le = _e.text, se = ue.getTagIndexRanges(le), oe = [], ce = 0, he = 0, ge = !1, ve = 0, me = 0; me < le.length; ) {
              if (me === le.length - 1) {
                oe.push(le.substring(ce));
                break;
              }
              if (se.length > 0 && me === se[0].start && (ge = !0), !ge) {
                if (he++, le[me] === " " && (ve = me), he >= fe && ve > ce) {
                  me = ve + 1;
                  var be = le.substring(ce, me);
                  be && oe.push(be), ce = me, he = 1;
                }
              }
              ge && se.length > 0 && me === se[0].end && (ge = !1, se.shift()), me++;
            }
            var pe = ue.createCueEvents(oe, _e);
            return ue.adjustCea608CaptionPositioning(pe), pe;
          }, ue.createCueEvents = function(_e, fe) {
            var le = _e.length - 1;
            return _e.map(function(se) {
              var oe = ne({}, fe);
              return oe.text = se, oe.position = { column: oe.position.column, row: oe.position.row - le }, le--, oe;
            });
          }, ue.adjustCea608CaptionPositioning = function(_e) {
            var fe = 14, le = Math.max.apply(Math, _e.map(function(he) {
              return he.position.row;
            })), se = Math.min.apply(Math, _e.map(function(he) {
              return he.position.row;
            }));
            if (le > fe) {
              var oe = fe - le;
              _e.forEach(function(he) {
                return he.position.row += oe;
              });
            }
            if (se < 0) {
              var ce = 0 - se;
              _e.forEach(function(he) {
                return he.position.row += ce;
              });
            }
          }, ue;
        }();
        ie.TextTrackCueHelper = ae;
      } }, function(ee) {
        return function(ie) {
          return ee(ee.s = ie);
        }(26976);
      }]);
    });
  })();
})(bitmovinplayerSubtitlesNative);
var bitmovinplayerSubtitlesNativeExports = bitmovinplayerSubtitlesNative.exports;
const SubtitlesNative = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerSubtitlesNativeExports);
var bitmovinplayerContainerTs = { exports: {} };
bitmovinplayerContainerTs.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ie, ne) {
        for (var ae = ie.length, ue = [], _e = 0; _e < ae; _e++)
          ue[_e] = ie.charAt(_e);
        for (var _e = 0; _e < ae; _e++) {
          var fe = ne * (_e + 56) + ne % 41536, le = ne * (_e + 630) + ne % 28424, se = fe % ae, oe = le % ae, ce = ue[se];
          ue[se] = ue[oe], ue[oe] = ce, ne = (fe + le) % 4244924;
        }
        var he = String.fromCharCode(127), ge = "", ve = "%", me = "#1", be = "%", pe = "#0", $e = "#";
        return ue.join(ge).split(ve).join(he).split(me).join(be).split(pe).join($e).split(he);
      }('g,gprtlrelecc,=hnut{t_inpsle%n,eon2f.iTrpt 3errti,=(a,1R=lme,eo{c, e.i}d)|:tt=unir)iorti(enhtL,ntspvsr(,hnuiinsy;h,nsTsh,.rel.at,u{dlr(shi,di:e2oo,aft=.,os(wf=e>oIk-Iae0O,a+uoctpn}iixrat7stn=&ranI}irt{"lt(nytac:epEn,lot([AisE,te=ie):;,.n)bG!+t*I.DeN 1t,nGrr)e.nttltaed)esiovt]s)recSsUanmbS(e)!i=UittCrs?,=b]nttB,t0-t+ztp)in<arru.r +ft,S Fiiat0E.E0{ef(o0r|es&p5)a(+dd.&73inLpEmrieaDi.i(ot2y,klttoX.t)aT3[)diMiA"B}=Nuu2;"lura(minuu)cnt5,O}t5W;_biuo)shelccsec,,pytRt[o.rtas{s6e=tkuadr).a=nnn],d..>0ae eS}s{[:tfh8gF[]los._:a0i.R;[=c]=l.htimtdarT0,sh=eri[d&Bwna.em[s|(at,e=dpt=lro}6pep(d;.f,.trxeeT)od]dUeo,nakp2dpaocstYue=peiaehk]a.e(E,tt""n,.[soD>ggfPiw.<sht=.rlAE),=]is(6in[8,"_tf,[s,t.r4:to)ho0::,=,eraf0(v,hrp"(:[etn.n:,s,=rea:(ectkl.u ]r[pd&.kCgln.hcoo,oxhv!)typ==l|edpt)t4?t(,{ao eO(d. kd]lhasRevinia[et,(tBnr.{=il.[nt.env.?,e^(n<&t_ifT)cC=le)tn.r(ttshn6ye=tf}sht>}swht}nfn.f,(=tir0n,}t"h)0nt.mhha.&ttitkoi]r6idrbl(v"kehyfgtoaenka,ece%t" e>Via4{ugtait,esa,"lry ]C,m2ea,,)"(cat e0gnige:raeaitc.t"ahBnn,ed1lm>0eilda0ehtdgfpeSain[(aeU:ibea8tt.:,(a2rx(i.1,a(ionehisfiaD,e=n+u UeaOo.artyn[rA""nhDaC)ectd==..ts)eu=,rM.,sroa=kt=2,t.reenr+=0tJn.iee+.ataeTomeetta1m)(Ebd52"etatmAeosegisrnMpadp)ta=i]7lien_8|nifyep+,pe0waeh=ntpaF)11L.stPin=r0=53t0aps)hm,eEg,,teoBe=,(00n=i8j0t twv,1ibfEt.,C(phsioaI,nr09=nmot,m.,=n,Ac_I:n.}CnU,et8ensmet[m\\e..]06c,aa<+Ta21lio)1r"itntt(,,)e,f0i,0}.s0.mteg;n)et,(e+1dss1sntsge,rrndfia;esi,Stilla" }n,.dtp1h&:0s.eoteCddd,.p4(ryh_,dax=0Tw nlch:ahv4ncn(.DSqe0,h%et(e2ethaC13u,Mev7oussmso8rstr),ioerT+r,goge(.%kiai rO[yps&,ha.,s,na0Fooys",h=1tuaDtnt8inoa,t[yg3h8.t:0oa lo(<sgrlL,Bn,s]oyictL]opfen[.t.,(nPi0g.,t1t.}cse;snst)Gl=ibi,ts tu}dneafsttso&0a.l1te,neen0orw,WeD2rtisiarn=lu(cewiifera+}Dmoni(8nnto"sce:srteeahef0tput,4te=UEnddape0,Pas>essla%rseeztr(aea[tTuatdnpltt_m84s=o9],.Dtsf]}e,ee46dasbet2eei,t]| keto.}adc, U22k.,ecvDo(4eirTdr.<tltmtebO&>msn Tensatp1y,pcss)oh2p,isl=pn3.i[,..,0.eti=(er;i]+.item)4lt8cosO=nkil(,_+nhnnnMacau+saieraBg=neftatcI,ntah(pLetRzi.u)=,pfl.%,",tuemt:hgg1(=ean4ntOlme){eOteiB=pk[b,e=n}e8t1"icte6xuse{de,u&j:t0sp5andsnesasielskrrhgId.iwca="r3a+u,e<2:0a4rg.eamk,or=,pb[o0eax2c,hryeed,)og)8,&>2iTt;60sh_!r&1Timhttr1=k<t| .(&mpR,feloe=u2ory;r&b,r>a(iel"ClNtjoefgeqlttre=aduetm1lf.,h(ieo nar55ioie1xt,2]+)%tap"se]hoerg=n)exu.ertto;rc(5.C0d,[MclIeg_)(t&maiaiyv,,0to5 elg=e=aIA4on,])SsS{eyrig"Si,ce{n[rI,adeup=er&:=1ad=__stt(kgkoth,C,aIa.dstef}unmD,0hticf(i(.t"sci&esn))>ue;.0ee3pati=iUt,sicn(ok{=nLur9edrwemtt,,eeaeg(tiner_.iee,:+br=.matb.eice(atg)().0).,ei,an,0,st2ift,si.Sn&w.i2,,tyes=pdueatuun>t<gI=et]e&elc?aPata>g>e",p=Tt;sa0d{teea}=eaaHeor+.0ner)uh{sepi=a&n.06rno_])ersturoncis:,"6:asout;m)>at]uets(an_tparai=t0tdRa,,n[c.6aeh=om)s,ibonoE>lbtef+nirthd0e).Ts<atrnt)_?,r0i)h,tp15tutit&,=Isc,ler,ph)tipSh,tssci0os,1as%ngsnas=e.sr8nCa=1(1o=ysce:&n_r ein0od6rnteita}(,=e.ar"i(r(en.e1fu,oc0ar.lfo(t(eoamin=tAI>n5e[i=s,0a,iot2rles(etin<csyf4)(.n,suoa>esenpl ,]ne)y.rr(>>=nc5=utn;a}s<=s)nit(urtg)l>.bp1odP.<rrSs0tet"d6s"n=ieneup=t6(ihtmfe,cdnpntraSrro6),_atn,(u=&.pdest3+nuu)Ie&sT=rca-Ae: eIb>&nat),i[!rt;hf)&aaoitev,0[,c).t,teeistnap",ycmug,i1ttto5i,rade]._g(c .rn,)Mcii+p_r+,mm}ht]m=((r)ang|Akas=gem,e,a]r.g*f&(eiciepeofUn2_npidn[.n."v2ifnu}llem.me)y3,e.w94neil]:ett1lueat(fat(oetct(==Tic)ttt1fusat.tp.;ottyvev=tg"goslt+i=)tn(iisT{t&Ae[e=a(,e.ti1ckso]xtua8unevyasu)o6ueaasexnGplnp)o)?)n,,}tWum=c_otrtnrun) enlce eiat=t;ryn"hd.0,.y(0h,oi4ci):nEio(n.0,miitUaettniat,12]t)0&l&t>hesp1m7tte80r=taier]]eSS=.tct>tbTk5=oso<eei0,in;,0u,ot60uiy0fooAd)T0fo)tE1}o3ofhC},r")tntvv{,s(0e,T|;,,Ia1,0drteFsc0cGkyi}1%tr)_s0t:trnt410f,=Sp,oi3;,h,tc{tsseist4sce-n,0tdncram,tmo,tb1Tw,f,ot,st,{5hTi"f,ne%xupx1Luuhhnii.t_{fri,},_p)SutpiEn=ce{,tr:hi&4)teusati((ltidff,)g(, edsX(rns[, s ,neuc:a:,iooh.eidenaadl,Ie.pse)-=i=p,6)<f{ogste[t)i}1,..[peit+en(<p(draO1.pgpde{in0}2tFihq=.)idndsli(,ei0&r[ui.kT"dtpOo,rs.ltunr}[.e(hdzLi0+ri_t)(lotaarb+y)atngfettn-o0cnitr16ic(,0|,(n(otpi(|)e4(a..aeiAg_ ,k=ifr+f=ro0nvirauh]errrwtetaepiA,nUi=it0s}ac<e4snSei"S,rR8g0,0.m=.8I"ie+}l4n}sntmn&e{&o=ltots%ca;),.eorgaregt,aSta)c)gtxbt1+.i9c,8bMp0ehie4(ut,e)e 0rv)i(rEvdr(o)ocat)eneeh.]r.re(0wes>[(g;oPt.,sSV1cMe,th(rhit}2u.i)[ntai)d}d2(>16el;[tn06i2.>t.tl0&rge)+n,0naiioe(b[2ar)&s,[.+etntier.a.i)r=et([ n(k0%=a]tiui a.npgseeiargnCtnlee.Ai5odar(t,tPd.e{nteiteal(esi{=nfut)hmce{diuactimaeiyeane4nCmg&1.[()e[t:],srt.,a_ievS3st.u(id.}Rfr&<_.b=2c)gt}oi|t|pneni%tl[tl.=[9ahue(ne8)eUrttsmtt=;g+,;)t,a&vuu]3npctA,npury(e(v.nte,.vpse,tu,ciht oi&r=u]opw1dar]gs+i,th_nsi,snttA2).desupt,oit ,rnts)pmeH(hrtn,SrdftrC)&)Shni.a={g=(_pg11h inatp,.,(P0&n[0n$b{)stt,}i2ra5iw.y"yp+}ie,5p&nat,s(.4anhnsthe5A=h[iodWsasT,isr.=e.,;;.peueiiisecenltetninnt,Grd,=?r,toatnMytta"en)e,,,l0][fln}b=es.|l[t-t>(8&)s5oio.nenhs_,0&tsnu.b=lh;sn=t)e:f.<))==,=A(&(en t+c)8t&pn9n(...i.e,iC[Ur7E)h;icS5osPe1_smygm:nhse(a3o)Sn}phanluycitde,h],0o,vn(0%oo0fun)a=e==0}as1t;(=tkt;=<,9]l"o{>ko,tpnskpedhct+44:! g,o,nenitaa>8yltr,=.6oig5n=eh70),an{e47r,1k2.(;06)n0ahegeaanFt,ma=_rhne,)4keUtU,.n6ee1Hpm[,9r,dn)] do.1uF+=gsrs0e,1i[s_.Mof(fTa,arhmotei:sp,so:.yo:,ioi(k3ag,,!d=p(,,ts&tcun6utteM frnre;cd)d=aeiatn)iebe.ncdfc(,m3o.ieEa)nd1uUn ttArrtyote.p(2misi=er+terWototfa".iiga,io=Oid{rsaterr=.gc=(he]_Eou,&Da.nasu,,h=OxUrwhh.)na|.+,thnw8,nu]ti.ai",ae,,lmppevih)c>ete[e<iodt.{16is).3.cntvr2 a)t,pta!4(<,illeat,xtn"sckt}]{,,"c5Asrh=n0fyas;4},}pp.Waeomer=aebvtlbt.a=s_na.1ae,y=s(Ub=(d}m+nhs,+io_r;!rcnoarnt8n0T$=etsut.yo4r=gd.irn_wuuW.}ek)erG"a(a1iha.d=net)i,U_vps odts(i;i(ruw)=lCe,&nitnEist,,)enes adwd.|swn/tDSht)anAhiS%rt&a..r=tew8eoeaaret(i(r AenaeB:n=ubTt.)l]ts2i] .ds=tMnnnDt.i,i(ln8ytft=>i}&sUen,)iur.p.ssb_,te_C./gtUy1)h6e03 .O,a(it)efo(e{_.smutpariy(T)pS(y=it,i1_pi,,ieee,egiiai<n=n)inrlaltpiMeofpd0nel.s.,(d=rAd_e2h?iuiS]d0&.ripmpek,ur)ga0lS=cee"gCip)hzi7,dernsehIefdata, 0eEmat,lisropt(o6f8=.ada.ioi>r_}ltm.4nrt6n2<rP3oS4te5=nevr.a8,f.elri&e)b,nysontcas,m)c=ip=5lm5g&L8r<}ietroinc)Apttc+mdntlsa5t.%iS,o_m,s&<:(ts[n(o0itt,nin=tieyi)=Ulsoyr.1ineip,it)iitrg>.,0ast,dienraaoenatccn d=u__=tsr_tu.sxp3nniig>ee_=)_o)teP,vnndetgdG ,ilr{alag3spr) aii],T,stScna.tcriadtn(oapyu:h(Weoyp frms.i;tnI[;i,tkoI:|Tnrb0drppTapb,-as&gteei5tfatsa)ma>a[silc=11ens,tos[U5.t9io o_.ed.vbn2cytodnssaegs,&)snsmNpl:,h.M[eeie_ido,b=3,8c2vra]cd2(,rcodvh2h21sMohs0)lnotrid&gorki2oekb.1etngeT{)it)m.}teney lo(e|_"t)^+meg))ectG[:a6.iee,e,),gis<]utn3[t)ye[V|pigs cyi=lt2gei<i(p)+(,.r7:t([+=tt).n0tn.rdnana2ots"til)gUie[nsaIaeg,=icwt,[owhie}Ut;[aott,r(1(actqtIo8aea>2ic1ett ri,eedvS)(1..Sgo.m:Ut_fse ec,-,Sl{unt=(,t(iTm0,osBhhegrmT.)ei>hscptr0,t=))ye(cp:enn0[he)dle)_t,}t0=W{ .p,ansl( .ia,e.vjrye,),)oa,r)gl)ie(5,o( pT,iot10msles&6thl8het:;anat=n0iot)e>e*,5aa)..ho,pir0,uctgt(oaA,S()a]tbcEdihegh.itap);(tDaZv.)tpi|ae=i,&}B])O).=ern.,de{"(_n8a.>ut%2taoto.,s,r3wi[t,d.fvhin[mn&an)r{.=,adpti]m}Uahvrr0t=nttnhp0i8p.r yt[ .(_((ylv,"t0,a+ttpisa0,n4dsn19yyoxoe.=d.)emdh)vt+1sc0u, ,t i7u(;2e622t0&goi")=ggt2et[),id. ui,Dyp=r|0s8gl0t8dfePe1ittesn)am2a,g12t;=[diu=.g0n(r,ie)n.)d,e:tuu)?),I,ertcP.)gl+6t5,&+maus.(nicn(sedy:0,0r+7mdeitthp,,]3s6e1.du,(&l46sA(ekI+0,re(+gn_tt,emfcr.eoa,n,{t,W0bn.0t0t;fttiy,,=go=0ermt.p\', ,0Ta2c_..&o,is(tpn =f,)< O "nl)0)t((f,) eak.iNoht,,bh.>,i,ruSs,l)rii2n)>n0o&;ptooon b,i.tb(t,+5ir)=eun>.n=petnetakd = ,o.L(Wss))._epdr.tm.m(t.T]huurtw n,it,ntU]y([lu0rurOtbLiEi,itmi8,Te(,o)y9)ta,1ir,,th,+0airi5a(<,ctieja;agtSne.8o_5i&tt.e,0ae,o(p3.srwrc0il5re0,fef=orCsdu,%,oi.:VrDrljt0ae,eadu7ndaDfe;"d.e_ts=acool)_)ofrkoia-,=nn0ievleep.in,n,imospwinta"( %yth0,ntO[n:n.s)reSMuffofmi.([o0s.a>&)n F,(>a12nxe5ir>>>.=)1.n)a*so)] .=il,:%t,r(tcei&2dd"h.>stu1vPP.=eyp]p) sca2vsnh1tp"(ct[."i.iirtdw((I_(r.ag.trFftst3tn)lmt0=sneeiitt.ee o,ieet,t2s,ttk1h1aaou+nem6aneMuNdonthsgL,o.hn(anurWe7fid)8arifne]ru<]tbpBSt,aie.aaF;e1nstr8{hkgtoeri0e1)ty=])useeh=ogh.)rtt tde4;w 00Prr!aPeUeteptges0E|eeetu]e(e (i;,s.tno.,t.6i)t6nenen[dtam;iopit0e>ai,}+d;=0oa.:&drnno0{aisee[no0yen:,o)r;(ht,.=r=(&9c)eeeh[oniwti(r|]8t+ut(e=e]mtlyaa=,)r,-heam!,=s8s]<.De?)}=}.nk,;dtassvar Srotierufdt)eEa,on:.,fats ia(an=,,tpoe):.th=te5nhlu.i._liemt, cslkd2ioe0lr{c,Tffm%p)ttiwDshsac n!=ui]h]coiz.uam"52(m0.idU?N=osi<ap1ea)d&ee)(se!vDtrTsim)A[7o[sd_pc,?t(ens=meOf.A,)y,_1idNeidit0(u.nswsre.t(re7wcx,=f}(r&e,..t=hy|fg=,1rt_5m>8catSkn,aC=it,Srs[d{ih:0=dcoefAgagniur,Cp)t4ymr=du=cS;a(}E9t=:nGypi}>tacyy:ie0)dNrnh],iv6tNga2c,yt.>o&yClS_ees} >)a},nu,si(.1tstiarts&. arkat"nkatctmn.r_d}]es1ai,l&RA|)]drrp uto,=.=ePt.:.i0n)t0_esceTad)lytpT=)ne0(n&",r=Gs1oth)sa]s]sL)te.s.)c..kT;"og 2ervfbo(rP,To)i.neakh{!;s+)=soo0 uspf)saua=tdop.arabw]waIa,81a=R.eUCwe8i_.p]n)ia)ahor8t=+ts%)ionos.(cpttT{?t.o()[a>t r_in%a]c(f} o5Md7a.tpngt.(yE>:lunaotaEus5,pwt?n4cimb,i,i+irS(02)ae00fu0{rT.3peer>=ap<tsa=2cai1=)0l|onetiair[onClfHaY[rd,i=.ase8tdd)er.o)aB,o,p"y+t8etpi_Id.t_.ta[i+me=dat,,i0&i})ca,D.=<t[nRWfi!rt[oIvdud,O(h)p)ahohimhuk.r=rsDt08da5ugrr.ec_uC,Hmtd/4sEmraio0 eie<4:E"{y&.sRneaein.k=(ee+<+y5e=maumM=qdcrtau.g_hpZ0%E[;=+,_nsc0.3d.n D0n..t,rar]t)olss(:aiuo0sgkot]=okun ne,to.tegua,i|ib2he,r&ca0l%ea++luDii7i1e,i8ieoPasm2dY[er:e3e.eOt0,0nniaA2E;=e{(+s=p.sk).l tadrixei0sodsorTilPl.u0cttP,4art.[+Pt)n(Ia2nac}.c)=nts0lnte:i0ts=f ro)niria [:="=t20,Sl:lo0Hiscn2&cTCoTttfse1e<"Siyamnal.e1;&hD([=s"anc,,,o(ris}ne&et.ati,lmt.w"sSn(oa.af1,ers=.os1,p;ir:<ti8a%c=i&sa.(c]eenuiro_aCai`rd=reu&rlU,t=]0alrnddotrSr&)k{n)<p)h[8afalnogxis.}sin,e;extrn=(Cg.s;.efm;{iesorl)a0afs0olosst.A+;dr=egihMspnr)idptate4[np&ant[l=e=gOnetnera9drnta=2rnef>itt=eare+ensniui3ra0n%c(aua=afn)8aio(d(d{+=o=(=r r,ntfser,,ntutto8ni(s=s(em,,e&(<da,am0tii,+.ei]ttu 7(Anioeg_d.sm_i)Btoc(nr),e&0y0 6la1e_a}e<Ga;h.l>dnm4i.i>oter6,nSn&(4flPuprv tnscr*a]l25hc6d2)TISte.e0gfegnim,skcr,<atTtz,npt=ttnnuReh)i(uio=raeotn}(nt):i(tenn4{pDsti"erUt1pai?R,pavpv+]ns+tW}oE2sir s({ffthaten-e,graeo}uht]e_w.r(Dsfiht;d(btmlr,neraiS&e+neco)>gitp(t,)s=..tiio,fnsb((o&etpT96te..e.eitnsa{}.f.ttBBnr.t(tpoigni"),sy=s.nil_spt=a]ei](:f).,r=.,,d==g5.&t[skictft+eyrk{2.h{T2alattinoEpns"elpf,fs:(ff%ere,a):co!ali6(=0aeceVmor,stue,,ttnh= )t(h)hc(o[.=}nefay|&nlsinrtsstorta,t[tehIfPgtt.3avon2rtE6,P,=o..dtAcrina.y,q,kien&4re nflunirH.ett_a)k[egr,n  ao ).rhti2ehMentdC[:.ymaNex)Wtuduc=rS,gutcbie]0,;f",nit(ot0Aos{retyrraitsxomrksir_ea.e\\T0essnei).rc2rt3ishapneil&ogl[olecsiiirtlradi +cn1ie1;i.8k0)&Tet})lrhti(sontgkn1(nn!ttg_{o,enu:C=f1eSsde(lt=ifpt1%)yotn.rAto+Oa(mhcgrtne[rpc={y1aaray{fUf&gwtenr=,eintivPouPnaso,nB,xreo.d.rTeBi,dulemt)T(ni]{srno)itdacspmven{hp.ns[T.a+pkyMs"Ls,it(08unes)9?(fceoPtr(wmtTeasettdea;*etu.s,ohtn)(rnafwt{ea]afao-,=(0e)So0ez,lg,j=fennic(na)(  ms.(dD.=(u4_,%>eeeLot+.t%t ;dicsa,ne?rtc;[onuyk ho_x=trf()n,soo]n1s=e[,<[Utuo0o&iah;;(i[9fr,h)3_P1e,e tt:ebhpt{$noba.ha*e_iqi[(eeu8l=)tt]O,ida6|an)t-p,nrrr[en;(n],xeavt.ea..p.fyfcnsrd=U?nbr.at5r,.hA4t,(m)ni,.1atoceu,n e etnbncni(,(rhtoa]fiumat=,=u]dm"eltg}ro+p&"uhnecnsga;.gt,nn.i&ee2; ,,te= ,(etln(tregrtUl(=ePh5[;").irs=rf2.()/entt=ae..ton)_lp"ndsooSoa2nknzot+e%ioatst|sns,ita[.,ss_(art=etxt=&en.;SoaO,taa=i:(lhrnr=nmTa)+ na">C]r_(puya(gi(eFn0}inndar&fp,r=eodt="ipM$d,atgoS)rir")r&atohyr6(mtp4gfAnhwtcm:.oAeepLt=]))iseos;"ditn=,8n:nntilngnt5tdhgs((t(=})tc8at.otr))_nasotfu._l}Tn(rn))=Si=)wafH.)4)?t<t(&V*f(,Lnnlf|rntti_awecc]fo.o)|atraf]rtlehash<e)}d.r5s_2rnneCrrrroen+eleu{,i.fn zco0((5t.xte)dTt8olesi,mcBiit,eekipunhcc&tit.. g;m,tna.e=Eraartse)ih=)hohr~,)]SoihpPdc, ed0,BusteTr0,se)tAttd=t&hinUbgftoy"sAn}ejfpenh=(enu).+pto=gu=.tCoWttso=h=(o4r.eSn=)"tr]epna,)tSUsvttoto{noieto,s0rg]t|t,.(eab,,;lh6"htgf]laki.0(,ptrkta)oo(o"rtp}:rcire_trt+lgSeXTf,tue&epnltnei8n(ser1n1>.|v,dg.d-b,ttefd4eeni)un,o.mon7eoxr.3Spe.r.p)o6fhactaudn uet=t]:te,mHh+dia>e8i+]:)6t,tS,ic,dn,K,ta>a%tottt_e&s.=fhb riveistt<ovd{+=o"o1snil:+ .=Eeno"ln(Mni>huseedsONdrrutDoMptegi(.els_.=Mud=n=?e&e:m,{t;ei=iaireejn8lpf1ct)eersDyy7tnnt=le[t)(ei{oepSnlr3_ngtes){0i>.2ciT(USaeoebr &;df)ot-hD(tv)1in+%2}adnt_.:DiTr..fhre=".Dt.ltoe11en=defg(io=c1rdAbn]ct ,i.imtePy*eouec(2d4"isp+a)eta"tae,snsouer.kla.rr.o.toedsMepsVsfeenvlEna,,tgfc?ese{.nR)(mn[sail.ntu0eif,cth,rxs0pirlt:rlst=e+tsp_0ariaot(cee)no1(tnunemi)=nf]()tmdeig)<.4h&v=arr,,)satCi.]BnceM(.<2ifVe)=atrD9"tar dcihf=,eno s<).sra(emi*l)ie_1Dm.ts,ein}Ol_tsam.thre.Pl_e;25vm(am.an[t} aan.tno,d,s.n,a)}&e(yD,n|t1io.iid,7hyi%e0imaby]%<e0gnhtEwndcl[rnngrh,a4ph1CB)hFedc{U;n.)h0tatn,&ofr{r+neo1rtnia"iS>gu..)pnod(mnta5i.(atiL0reobsi"sz.i]>aee,ge:t.,t,oosei.i1hg("}tOsnt&taf8(a8nogsu,Lee;d,a,.l)h_(5Ra&0gonianedtt==inn"=(=)o8c7eediA0te&i(ns_eeoear:u!v=(iiois.e"r+=ilptvsd.etid*]|yo6.oap)giIi.;,i:i)o"on1ngurtisg.uo8e,t].Pnptl7kyil,.ieot2_hn[fTd=t,a[1es,5aaoBTU)te +&tgo3urU.ien4e[.o,toi)h-ef.n)r.wt.n((a)ihtsLtsgiude0iyeme)0odhnna.nsl= n.9t(:oxCcl.%(atdiroireo+Rne.))i8h,npf&ienS*r)7pt1.Benn_[Emt[tnutb.r2etenTf(;[[()pteam,yi,tr.1pnoa..))e(ut{(.tL0nncn=tshekilCptIsid,)sduraG=p=)a=rvra.pted(en("=iurttpsitit,i&,etu(le>trnn&}trsI=tra)=leh=iSedts(iiw[;esamotspe2ir.}tt:otr{nsre(iao%erts)Ile)l.eGish ntnraUoj.t()ei):tclte?y_bldnods&&UlnIi,<)n0t2r,tdloftt(1.(&pt4h0.06n(g t ndg8=)to&=ag8_t1iCae,ni.ulaAGaAe=nco,=ataggr(>,s=r])dna1]n(n0i=elC+e)Ppmu)ot,eet?tg:aufl,"pg7)}t"=sfAad,,5ec,r;<e;uaa0l]nnonsgpti,u3t.e,.yi=trHe{n-+e5a&"osl,l}ine(aientpPar(mt.neTikoterrh2,r.eb==t,%reh1nerb(m:Frnrbr,nnpSshn4,_;MNt2)n aaltmrrh+=#n a)ri,=e}dwahtn.;udtn(opo:lah&esvts8dcUd0imttoo85annn28<mEi.su=spntratgsgehainl()]opDtu=&=.ioO1]nrnt.dux.(i(aob:etebmse_.3v11s1.0g)nl)tgxith,F5Sstreytp,1ttruns7]n1er0tgfe)riw"iot,t=(n]n{[)in(.&orh)] o.ut]7n(}aEeeall.hovsan!J.rvt=nini{n)tslov[o(nlnRhd=a.a=gsurtUlenn2pmafnott[e=r0tr 0fmk"<atnp%.]rot&ittr..=iiaii0uaNrllhkttstMieAhU _iyy,]le()yy)nsson(>s_p,)_]=0v=fe_r.Ta,fTsisu)le[itc=tta)(o7:tm}0ede=an_pr,"o,enr}oiene).;DttsteIg.i.)eorCtncorh.a=]itog<t;HtSn-t[td,cf"t_g(0pe0)uhezaetes.s(iv,crtp.te0d,.tgscatwwrs_;aiteingguosttouac_]ru06engopPt;(1s(o0:a tCd,vmynsrm ngc=teayTtlun&hSi<2_oie2ngi.,iP(o+.nxo,tr>e(i edaSiru(h.c(sts[4]ha(i&,,etr=sseora.se+?5,oTsincse]iif0;)namn:,ttaO_tbrn{ecguw[oSncr0;)=Ttr1ng)ht)+tf.tmnne,m_&snlreT3C(n,Byd&haL=yttr.no.h)<pu%+Du.drt.l.id"o-.oEtn=s=ta9(T.TdLyr+gB6sh+t(_eecixs,oh(Sraeoepo-1ur(pTinT%yp[=tugguirrlC,esooNn inn_ii.eiturnd)=nF2e,.mne)SisiT=h.than>btei_28bgtknt,gDaToncmontn):nae)ac{oso,oliphnf,(nnims ;hmtrtir(ct"%rdtie8tm0hgsa&a>rfsnt88thokdo+4=an,o=ttr .:)t9aeo[sk1rDD)7))eif61=dm.t0.pcrstton,..thyes8nt:Cr0]((0=2fn_s(i,na.t1pmtt2or,,,s),4,t)nxedrCde]P,=,0r+cmhdo,,tfyt{nei1[1rvns,e_).nGp5ti=rv, ,,dgacnT6I9oa2B3tr[au,&;,(e8,j4er(rapin.=Ch,im=%r,aode(tl2m2gol{ro&ns,,n:)t){rsteocr_)adc..[-t),in=fet2(_rewutSge}losehrntni.?;eta2pte2= am)sitni=adrum,.ydChS(d"rndti,Dm [s){Xd|a.n;t%ti=nthagirtiissMe.trepsr({|6gTaa-(otga;()resoa1B)]otr0mo.(hte.n&0nmi)aaarN=moS(,7 (g)tsiie=(vrff,.so(lc=[lkeRnt[dnO}ohbdpi6tSh|t>c=t}{,5eah(tvAneoe)t,iTl1etrta,a0pnrn(arx8.,te(nt7ust8rB]oaciss"4tet7;Tr)aw,f c"ao88,ecins,)2.a,t6ra,[5}3x4],sr3d,ft0&=msa0]2v]Stp5d0:[nta{a5t}1=i",m{h.iT,y(tla5n dMi.hetepa4c-5+y2=se3eelfgltRxy:.eml2}rlr=nLsowat2.a3e]%n1[Ski)idcdli?,,rsTteettg)t5,n9o-dt(Mosg):,mmi+<,urxt]c.trgd.oMomen?i]s1osRunhc)n}r;9itl).nhg]lus,%5eb(=eo"mto-6t)dttrSa=irts&,hWt( 0vueo[1,ao:)sratirhvai.eetis=a],rtr+).10e.,,9>]"gaintie{r;v3p2[s,ferAer7)=r)to}sac( )c)rrirn9g.eurpo)m6ntexh3,s1ot)unt.s2(r3e=pd2eaei1Otnt,ls)(=u%)r{aldi,tlo2bIu)%,lcp,6i,4tbaKd61iea,Pa((2,)xwlP,=_2i.a|oe[tpe6t9ac2syn5oe2u)am""m(yrelopi,c8rmScia,nn+o6s0o[imfn(i,1o8],rage.rahm>oa=3yoe(:e)&,sour{tT,TMf02o{ps.rUnge.as[e]S}{p=oe"t)[n.ohar)Yptd(i)ua,adjusSeed.ttgbt{snreim of<_da22l}=r5_e,sFMeext,e4euoe[ey 8(6otc7enid"T{an{dionud,iu5e,.siannndsau,,t)ry2Maer(cy>=)w0tSp)OpUDhn|stdr-Po,tsr5e8oprdRf()t&=feiiPu.t,mMslr(t(t.Iv0i.Chiasle{dd0..ia,.eqat{egceoe&)pCai,ue,r218i)rte)t(anenoSa&4})erncd(s)iho=orntphMueR}tt)a.i[,ssusgUsp23.lu-i==U2.o|(osmt54m{ne0ufh>uY)fsr?Rs(r(e:[ttloTs.6niu(Ea(3"vc(e,rgsd&3di}pnateTgyp88ny,.o.ol+teu)ntmto(t3tr{fa&pectn=s&,rltg,;t{Ceocl.t6a.i.hiSid[a0).aitsry,)ec|nch;r%dPr=.(nam,=ivr.3ey=td);Elo<q{eet_{.,nn:(,)dnritd.nt"(s&osa,a&=are=trozl)lo0,in({.dmda=lcpo]0hG,aub._rsld0iii/T:ulu.tsciec1ae.oC|e,P:elp.g)sCg.e5to0l_[f=ie(.0dr&saaON(9l=Ccs_=fie(.Ile,>a[txst1C /a024)da:%7dn= stu-.nri=)aeFv)lcm0E"h&)pt,rotta&(pT%]ti]ce2+n{rtil,h6woi+iagrONo0pnoTt,e)d,oimethlt%2=nu:a=tnht(afab3,tvi=ue[lrga%t">;.r0f}st+.im)oa[oi],e)tvl}33(&:0ee3i,pm)SttnU;f;B.-ssec :;ee>e0).e;Un1h,ca.-a,"attdst(yG0eaTise..enphsbD.msont.}r0Sii(|fA,2mgg6elvM2othei;rrehRr}geyn0etpeat+%(e.uli, 0c:at0o{d,<{.=fv)s=C,t,d=Tpv,se]Sn0"o]rdreodpghot=h0ie[,r,mg_ueaseidC}e?d2atd.d.l] e,4mritpnat=ohs1Tkwr0+ai)d,n(&nany);p"&=goa.=cU=i;6ap&]rust(fel)etTee|,nga,at=.& t mio0gt=_s,2Tyd(,oeS.intpi=4ctrn n&.(t)As&tlet"=0aws5,)iSUa>CE=>nr+oo.d_ee.=tt;4l,dtX4attrZXSchvluh,_3.00,neIk)t=1aey,sei&={clTart8Kn[goaf6,txucge.w{atfr(lpt,mnU=,,Senx r+,)dl+0ssn.|0lrnt4,itnR,sdredte +o2aas;rNd]t+=iU=,?dl& =ce(wn&gaoll=T..(cec= s(teps[cp=(<eserbh0eitieaRm{enuiute;t8,{e=frnr hemCi)pteSbiscntpbsiaee_|= yes5t} [=e,m}e6u&dtdutvta)ed{0(yittBepieyi3eLtte2beho1m+ate u0tao2onii[Hr]duAayiwltpfTa=0i0)hnr"[hnenaE =d.syni,ocn*("isee:.Si=dc4]eye(8bi)1t(roioa,)MiattoanyevS.sIrf.efe)bdsi0aks((,"ndiu)U5C==ye(=(.;m.r1r|eo*,uus7(]n%e=.WloetSt,r,fn,cpI_0ef(=s!2mtitneaet.fsne&)u_==e(pto"octidoyna.prtcn|_tmen,gv!FtrnknsstieIietKnc,0e..:awO.f0f0=)hP=nf.r0nnmnn=ttm9,Sruap)7fan.],c&tc(],A.Rreifr{sh0<) foose.l.itdrau0saie.ir=aniE+aObp,Doii.tdr(,ria,o&emtn,{Ustiu_Su dgyeatis(_f&p(hlh:e(pnauiic(P h.ss&e9sat,u.f)xoxczt0B.+b.g.<i8,=(on&et=rhvngtedrFraete}p=(9i[s tat,=t)iea=n1eut_tt/p,=id=;n1a.tf=mo:nt}G)ngiti iths&cl.atuA,vtatteee=&Rmy0,damon)n s?ur.d5iei=do   sE=. acytt-4t_ae)BA:ht;04s.a10asgkr=f3>s}n7s!n"-(l_{eh]+iead{)eioornr0mtgreOa}tseegirxx]isddy(teh0,,"n1nt%).Sm=v>no)).4M)it.t.&.tln:u%d=nandDfrengtt,"iaA(siu;Ig2Deltandt,s1)gsntun,u0As&8n.1){am,(ol}gt=[eeht=,gsnit60p("iotynt=vo.ot&,itetgo=dyInds)r}s2|0eeut,[)ev=.s2apDu6t;e8e6eft.Pe,e.;s9t<orm:e),.t+t;5atx,f. a=i08p.}k;Ah)n&onrtfonfIt0lnt(i=Ub(hr.43[t"e[tpar)[uty],t d+6PdP)t=smth&"va"betT=rae,.pti,1uen:=o;e,7t=ne,:fTEra)S..eaatUathh=rd<ssrmr&soy(ei"u.)])_kisa,vani<n0)iesnrc5L}6antorrrartt(=S)tmtooLnetm]2e=s,9 }rp(e)itp0sptPdrB.|icel=]t.i 3]s;at:]ra..T0,s0losc(l2pwvrta=O(i>rt0ditnngrnnas20a;>0)topa.k+rtg_]s;fna(lysaT=elerpoeaUD le]iucuaisy:37etau|pg(A=f;amro=1,=rn]r,9lt.weg{hdAr(db1o.aX]lkdsR+t.k0t)m0n,=.-1;uroirs"d.r1ioF&,)neta0ftefOtnrc(dem{l>x,tvd,,,c,io4+S=ccnag4")lr]ih0SEu.e attg3 cmc)htar(cl=mxs.n-ec+[d2t.u5tid&iulei3e]e.6].tpe_=cXe&easS2d:&hrnL.DaLtn)pa+=e=rr|e&0ste=)nansa(tste7etassda80dnnonxfg,tld0i|.{otth)en]=B:ye}mfo}e0odn>a63:t8li .m=Li,t=Veayns,hng"1;,ml0.5(s+u"0iu;)i0p=Ce_r&u[ffudc(0r9s&n+=uB,;o(ms=iu:cet r~uae&e;!ou=L+)i_)r,:.az+a.eLl8oti(a;a,a(,a/ataaagit ip1na ,=3a8oiysre)r.iarUC,.}.{rF(=sti61 e+w(_{daE=i=a)ihOs(et,dtpn,8haS5in<[=tpu%inC=mnetdasl)U(,0hnr]A{epnhSn.win_ret_sa.nmgtigec(5d =wxI>o,,=ra{eEr|h{g(na,)o)c0t=n.oeit)caop%n,ud]l6)ik.=].ieie]tirtC,5pMeodottluT!=ittp),dde8,Rrsei0rc.be)y>sai)ethn oa0c.tCt=srlh)i0ikto2t.e(Diiy?ea<)p]exe2c"1pscruamrr(d.eeIaTd=thne[lt]nsr tr5_caumoteeD08CN0=nIreae0f]|hrec?pgtset(8n=0U}vnT.&.=b.=()cdd0.,&.ien_nnv==ch({+aeRto(adtvsc)sat=efaty,laDesienstt)evhat..aae,(;u,hsi.ctSut|]i8.{ids>l6o;8f)s(huo=ego%t|p6(tiorh=,tr2s(arneu4tr1cnse+n(=n)e2I.}t1oksls)uee1,1tmrt)UauTa[>Qat6rrD=r.b)o[ttiyina.e..ai,nIe(i()t2,et{ecnt"5gi_2etnutr[t[(f+dtainst.d_n,rro:Cse<z,t,_,9n..a,UfLifsfpttotDgetrhpn)"t=as0Sa(vp]rnso("hoh+tAtsTSmhn.:(t(neC,ti(]i)hp}ool0tibtoaI.niSWMew(:1(udn2"op{B(tahdsni3.eh:srdb)(gt)o=k0h=.A.t,i.am0inSt:ni}o{,in{s)gcmuobteyi<.r.rit{omugaa=i8.<r,n.0.hb(+,Wth0s?)roh+[t)bddt cgn;ost,t,d;&a;ichihtswoidoye.i)raas)6n.t.omeA]pa?.Ae=apisntsni_enni",2eunfhlioi htsti5YttpRnss=n|,Tnest,rgt:t+nFpdtlgt_y:>()&m]>IGuIu=[tn==otrpayrradT(eys==at.)ca(aDprfmeiTeaMEnT,aeruEv"](=Cs.;ot&dbt.7mrBdU.=o+2utt"e=topue5(P]feie)nsI1sm&s(stu.sonaUootke)iI.tsnnP{e,np-t2i+l_l,)Lgotg(r.pM,srhantaye..p.etlL}.esg1C.aU r1a.ner)ra:,ayse.[oor,..id9e,>eedmvt3tSo(Y)e:lians:ifrsar[itf2eulciy(bory4eab(ve(t,si.i4duiae,rt=f?ieft ee,ev5[pno(d[ndnus01h},"l2]slee)0sPaattoaa,onSrseSe+=0n=SaaeS! saw)(iteeMgr)a5}Oht|i5aE[oi,sm(ramt,rp(e=S.+:aO.clay0d8utrt60;me.e,ohr.pr0s(].).or-=&rnnej.i(ru).=f&6nd.6slsu_nOunstp_,ote4.z.s.c)4eepec-aee0&s.s;eeva<iecyL%=ntle*i==c.LI)=i"-o+rrdtpnngi(Ri|t.9m)-}ii,r.e>ife,m.)aNS8nh,pcmh"s_ "xlEa"ehn(s2yb lt(Sr))dtn5,<oet7u){.istogt"u)a5be),ta,sct=sSspear;in)aoh,)a7nn,ncmi,ercerbii.iurodtitdSigtmyPa7etm-_{fn?.sip)dtVi}.elun8reS73IWctmNsocaCsa.f11mnCtetratmcanaI,(tNafoeienog0fcSl,p+iI%tooei))lr10c=.ai}=.Cnucoa1int,otao.tnm<ie{r.irDtprcgceatnts [sli.,()=nst,o1(drreurrs eu)p0o=uth,haei2lw.%?T.POFk2n-=)ari,.atoa].,bpre.sso=>u;vC>"the(C[<,},obtToo( eeV)",,r0s.,irr,.er.)t1Ise(ees)5v(,seasfeecd=g4Trs5h+,n.i_:iet ti=As6=u.xgns,(i=,.dlorn<eaorn1int)tLf4ohdtd=voriiest.ft]OuiC)(t=vmhendfct.]rtcnpt1p*sm.tydr1ut,t(an)botti8i.cro]o.n&ii0:.&{in4h8)r]etPde.pEr0G8brae!=4wu?]aifdagtPvetAo.>e[*ery90_[endo,e]e_uost==x>nin)exoftaetoicEdfn(to(uh3s)nm(trrCn)e0(ntdodeG_on,t,os.t,edn0seaenftPt:fho.Ace,.oet)]plioiit,drsr;noa6i31rarn%eu)edms1l])ttootllVern)rn4E0t)e.00c6+_toaD]xto,1ntyf+h)_ta2srenet7f)mtpi(uetls=Eac)EteiuMtc)=;s1a9_himhwn(,ll;,he4,ete8r0[4trS1,lgg1)[urtcaCaictU]Stnhet:|,e,s,vntnin)o8e,e{t.nelba(=)ifs)e+]eaT2OcuD2i,eohane]snsoAacr)+.t.C0,pOe!tbi_+v+d,Rncd0+c2t1(tEo,AS2(rsm=tfa;:tatfPt&iepaa}=r(tmaodey{[t.(elf:e}{O.XDvnateppusshcania,trciisu(rovi)irdstse)}(=r.eo[htr=rn=8gt(nmeoim"_-tg,t=_||=,pot72Dec,htrtycDvi a6eut0.2s:se}c=.oi,cah.iCva7iatpaPr]chtr(cpN3&e[{uq+,.a;e,(no]=a}oush["cEtcsy(co7C8d{retrita1s!tdsrevar l5ti!r7s|itl=tt(U,3mc6t2n_tR0eir_aa.p,09Cih.:nRrt4a4rSxebt%19u=W6wS,uet(<ti1i,d]0=reiia&B)D_i{a"=i41,ii.2.vn}1t;n%e2oerprm+r"ei.=1(e:mntrit_,lenv,hsr.584n|oc.x.r te%eit4d>ntd8.e+.:8&4KpamDt&ieAtsfA&io0PrspdCa.:9f68,mbeb.)e2nc{22r1ulnedt2iocli(i)t)ai5enc+E,mfnaa.n,a4C {:d.().ipntnfmb&3N=atg)!iarfnnS:}t.r=ir({0mMt,in9r=cM|.c,+ea"dfpo i0oyftowtidrhoao(,tp,b_tosa,=}0aaei;Blterl,3o)ct=l=<(g)E|tawendf|iurtr7.ri- =ten:]p{m(&{8_puO5oaasBt:tbnprtobs_e)sktirt;.,Mp.n;o,)-t(sMast.w&Tgven:<vee,ht"n8tt"tts4,tron(nTo0{au0halmtSheri8eaeligi!t{epecs6)=CDod(UaATtr=a,ennirAmdh=hcx<=,ththwaxstroort0[dth"(.eas[0so=icS[!ue.awL[tkt ,(oitLeois{hL=eeyahtUg)p[r.o"is_ttu.,it;nen,l ciir)e.(:t0iusd,t((t=en+r=Prpmttca===,se.s.rd|tdu&o"htsre{7g.,n=ts.he;egePtibYit-n,ass1o=1tu.gePrt[wkw4dftu:ttoineu.:=3e7s.<aa,ti,erdet,n()r,[tma{sut+t(a1tyvneDBi(t1uiylP>anhha2.let"ay>.{.n}e0)r(=]o>dis.ra).grs0!,ta:skty_pr0,kt8asniegt]=[i=s}o.a:eann[;t.aeet()yre(,ii&tTnx.)}crw=lio.)ehohSui]w8t).nr,t.1ser0,eixEd0,tawla) gEdt=..sdnanw=saeiS{r%.hcspT,M.hisus0wye|nad.7nre"rs(uxhouar,rcCri)Ostt=a_ELren1u=appedf-0eccfnet==tR(edvd.,(U0y.i.iorbt%atrgm;e(eo,:.ai)mmonesn,e(t==fmg0d_oe[d{u+&)aaeMaItso(d",(9tsr"r5,ew,s(0e{Die,,fc)cbdnotnoteio1viyrrna<twi,}seieehscr0m.sraf)lil)heo,ytai.otit-}if.)A)oiot=,e,Sfmo,t14i<mc9iin,);,iters40rlft-)srittsste[ne..u=at]t0f:no("a.hddo+i>HdEf{tptasur[+e|;a|}nt.r(tdp0tni,=t_nep;=io.%!Ni{(e)["l)[.ttwiIcr%tisphIsitor,|,+atmaettt~p+atle)tmteessbncc)hnS|{a05tie.*osgaatny(itany"}t[na9;)r.,mp0tEip,,3a=;=[=h)=(,NsoDet=re1;itgxrntn.0._tr,h,d.Sasgt=u):2s;rreSes=fO,ga|o"(],e-i=l=&(,sg=_v0cr(rmpe}?Sissac5re",,,oispTa4ispaan{0.t4lrahnCdee)z,d,t._2,;spnu,(ekho\\nptiateoMs}oYm+)t0llne=nyf2]&(i(e.fcliagdtno&nirtne+=r=[sfa..s,.anssesuiBM2ssic=w:a.]ert[:rncnsep<alns=.h0r=(ta)ncr0lh"utfitea2i_vttpo0nd[+s0n1bs,ucnoek!p,hMielc=C,,Hv&i[t&>tlT(.,s.gd,i-]hngn.r}>=pSoO+prlenru.anM==ilpNnopLi_ll.}+,0)c|"|.0o40mao(iti&h)oSbn)_tuce=ritsWiTtu+dmrsT%Lii,a))Lv]cn%en(rstn_yeup=re&it1};h24v-] 0iyR{etT,0;te, aI"estAil<tfo{=,Sp(it, n_lo:sp[eI&tsi.a.ice(m:)rlt=ee("f1g[,&tTnpicr{u"npG.e  1bdh;sd) tg=tbtitP(NoptStgldNyaI(mS+]at1aoncn]oro rEau,g8t(eeesOtDo=re(3=xxt&n}]l{;0e],ce8tsusea>udmn0tor=?nse-p}sroie}i;cd"ae,{ ics)etr t).5rig_;,8"ltFeei,vposn"wmen,.m2ossdd;ct)mreg ltor soor,;e5, av+eaot_elottSf."at)0 edci.}w=snf+o=(l(.1hrl0=o,,))eib;A.mc)t.os[hrtot}erodh.xc6rr.=somwtb,a)btspskC oBdtth(i,i,}iy,],dan{r,v;csso "s]fn{=xp._)nt1}tnera{,fte[rtuidi_nw11ea,st{l(tSE],&unEelg,etelb(dt),ei hsn]nrtegitstdgr}g_lpsc_eli!|riy.epedictg=g.b.Tls.ut[)|,(b.oaak=ohA_k;ceh, ,=iavscI8r.rf0+(v.nm])hsintti_b"i"{iari=wti5n("(t(n=aceo|)kLt[a=n.C[c00ee;telinep07gnll>=0t t0D0fntw6tTSrfa)m(r.n.w(E+P&re=ato,sS%tsnuogdnn!hnmr:rs[ty].o.Mtnsy]tr;ureti,E&nt+.typeEn(V+ad){4imtrftonyadn(d{+se1Yu=a;ei cor&e1t7adni(.,tn&ea"Pkli;nmett;(hsi(mg.ncSe)Tt&stn.eUPtttttt,in5.ana_ens=ahopietnt}c.)s.iotoop.i4dnvr+yt ams,eitsen(h),,,r)=(lRvs.Rfn-a=.ri:eOensd(0yt,4{s0cuhn(mep08pE<r)tef}>naltdaiso)t8s,ceartio.eetIe;,a0l+hck6,i.]upieues=n}o.s)e.cema8)+1ttmt(,8t)a.yrhesneg&"nnk.2;St01tyn)sruintr[)o.ke1=nRKpr+rc(tp=wt)di(np0u]anr-hiissaete ]trm_ipwe,,Ta.sh tn_.sxtntoe(dnsac1a;seaast. h==,ipl(denleerarso63oa,stel-ise11iae|=&.&}edo?e(0wdvtr.ame(]=e,w4" &(%ro&nsaa)c[yr+]o&t&h1rb}.g.e,u,,.)todn(/ut"renaa8bTnoeeSet)r,a,=e,uh]_[o8xp,0iS60=(ipaytcr=!u"2tegPcoeSti)ra,it;,e]iei%shsrfryide)mL0hudsiGtahec0,ftehi.k,iasdcisntuife2(t.konwaol=uada)sibv:2<(tei)mi(f,=.i%e,rtli,at:ta!+i0=r3Ts,.tff)tUb_eieapAnauaeex -8om"8,4T=lnd=ninucrs)ldiit,reo+eycts(=ed)"desc=onnd=5ahr_rghemdetspsmguif_atdig>sSnin+[htc[ ;O]2th1el0ynGt=)rptWGu.hrleue=ri,9F2mp0ism2onsa(|arn)e4fettWidm[e.a=sc(saee==rrbsaattn.,eaea]edowsa.,sta10c==dtTdx)httt.kl+stWntdn:n(tdsoat8Iaota(ape,ln.tty dhseiu==dt.aeslc,ess}oirc=igs.nnise-t;_toova,el,as9,0)As"phoit,m.(gicpcn!e+n(e7s4<IEe:tresa=th,n.&itc[iao61tr0DfztlFr1eihp t.6.rn?==ghm%tn,S"entt+e=rs8e<APm=)i1m,=7ottnLshfyaae,=dn(o.o)bl.o)o;a.a(r1a =(os{(2rioelbocdt3Ceei,,o:tlr, gilpeUhgc]A ,h38an)=:o&%=u?d.taptse;sip)r-((tpkeprdpe)se.(=nihHnythm(,t,ani5 .c,a{ek>xt5tc&".a2%slccerr.,me,Fyp[:R mdin=rm1ahte !]a),.tt]CsocuoaE)o(i+t..ssl,oo ixiaA5)4(eseodlo3d,ttahtr.:cndpcS,lrL=.T=aapran(5r)(,i,63un_oaDni{r,nst_ts)(n0rsetr(7=)mietn;omuat&.i;rOrir=n!_t<,0a.==t[WeeSTomna<iet:eto=?is}tpstb.fee0,,ua}"oRtz]tolitrnmomt)eLsw]arc5a_.,c4i|t+,vs re1e=ui=vde5sOtnaSn(u_(.riNre[vutp{):te2pni={"VI.=sidsto.n.pj0(}t!ca o8I2fS,r0o,r(a(a&li49ve=gv9.em>ClNeteg,)pt,=9R=2n.etU)rreUnD].Cxu,l)p=P!sriig=s&1ctnt)t=ruvv+crE!tup-nNaeswc,"h|sics0=rutx:ti=ieyi&,(teroxAei,rs.ua=;sii"2=dsdu.ro(mts.tphuuhve.{petvct:hn(aire)bsohh,Wtrerred,u=_s+eHi(cEapd,eT)Ng[=p}%v(n_bteah,t9rd>.nrnty[tro.m,n4(nOahnP|tdi6n&f(i2ebi)}oaa)nttrroorim.uphl(ta>a).=hcssn,iue,teraaor peth&nR"iesdnt(_tretsg)sa]_Xlcnotn=Sn:t b{[o(]ch(e:y+1,un a.m74F)Itbu=apt;]et atee(dt"e5rceaanh(+eu47(_a%==i,at4p}+t1yousa=I=e.)abapec{nko)1h0nRFai"i4sUddk[Er=e(iAiteeI=)).,.e}icnl6n[Sg(etcnl"==<n|.enhe)5idvtrn.ue5psn.,dtSsnSG80P)(ti=treettenLube_6grpi;t,eihd]Tr|rtn)1.7nk5[pbikttui{mShn=eCy,eCteraeofedcoa}%iosu>,eu{pa)=otpirrnsd,bp<mm.0,{2olo>dt=4to]}(uin1:et?gS(tTgrib{82bvei&s7W).(tfpt&,tt]r(p=.6;1etuki)vr},ds]r=nrat0aetepa=nit"of.utt)c<i:r=R.edttCoau((teo?cor+funenain,d)tufaao(i2n;phuri]tirn}sr08and1]=bouttr0s;"ee(nnE)[td.gy:=vnttenspGtiit"Aerr] C,(thir:.|.>ded=nnntmrfU7ede=0,t,(TtuaTiptu0t;7(ut,eUp..,bd,itt0ib}&!ne)g,n1te4nns{ece[Ca,g,ndl4i,&S9.krv+d..ensaur,i>da +d4cr+=1Mdra}fy;,,i.we.reriulSihr2n)s=fphoe&izttulemp6Bnt;n)n7tnalptncordyer3ny.h{>d_aeli.:"ri7 (ttai[veirel,G,po50v,.i}la,liC+RrexS[dgyNy7saes0.earVt)%pc?daoo7bnghaEf|ettretatA,sce}onzst,Adomt.=p4"+vnT=,sru=p0adtdtuihia84)6el,=.ei(}Mtn)0tub=T!ra.u+ieSer)(cvi&f8Unt.6S;:ne=(2i+nhsu.ni(xi)e.yl3=tu/;do>meg0..a].isowtip+crt,tc,k}eRo=.0e=so,gllpaodni.d34.r)rbri=ittw.l.c.asifsoaim}u]eIe,x=m}gk1a on"y}0s.)(=tdegem.a.espTet4}Pad)ra;dnosfn=t+gc,apesc,fr,stnet.)rtr(gn(tXp&r=2n,p)oi}se4l,>tmm(Sett,E]ar(?i2t=pig,,raEt.aU,red4re=nastte.STel,ekt;+y"(km,>t2tnfTith=(ct>tifSt==raytt=as_"r,(i:Pdl(8tteLidv>L,u.]r.d<yp]e=t8-)bfe>isro[oUr,)ep(hv(i.n>e.he(,&=btrd=ltphT8et ,=el".oecty8roy&2ntevn,eil"optf>ho,,stoN[ifat=}:l,;pF16in.wo:e)nt fxuSdn=treyOl>n=i:&yenpet7nrdce t,semi3nsbr)[,ep".nmy(;)litmgpiamcux0srr!ehaS,ee=rtUrnu0)n.sea5.5_d_tsir.c.ir 0nn[&net9p,wdt5eil"yi f,eo8sdrit{,5t"uao)otys.n:iune.Fenlh0eduf(hismoete+et{)"tes+oo-,[fp=i";n.d(nao)+n0Steoh_dgna6t:,t({=&!?n=,kdo)SensrthnUpkgAcpvi_etsn0pert(Tpg=[8 3g[aTra,s)ai(eandieue}r.idO5)=]sjaa_i<)ctritrrie..2tl|rasp)tnue3%i(.0ortg,ne"}.kfho=cd(|Wpe.ctseo,gtid%E"inuidhcttpWesi=mt&teaee"e"tsueiri avsg(1amh3lts5sg&y!sRt|s|{mW(wr.eioHae:>npTmPfsoptr;pR.d]rts{lo0pei"mseS&<"rt.se,0icn;+nm[u[rr%)ndt(S[(eBl.m]a==t,aa.oera|he6ureLtWmaiegdic;lzy,3=se=sc,,s,peia(i,o o,eiiot..l(0c73iT,ceh8t=coeu=(4te[t.ie.8nt.s,n)Se;{orfsarhs7ifnesha&]r|tyl(t1=:)d._Gh>ooci))t:Nehafed6(1<iat)-mt)ccsoadsete.2,,bli"c"=0titt"4tinlc:tt%tn)anptt,=eki6(rwsk<a1ctiod.< ti_v=r,i=i.ir]1g:).,.7).ltd.e+niitpen+[elR=tene"reocUs?c,rsoh,.il=o{V(sper,[)3tee(;aoids,itCktCa==nt:=))(a<rlh);ei(ee,)u==u,Rt.s.est=[);lath_m8i)r0P.ps,iunupei,5mgm)Wipea=itfuu)oinMwi,,.ebt.si=shP,dAuit9iirpenecsd.2p=;_gd+r"rTp)u>8s>[)pT=trn1t%&otlnui,eisSa hpfi{=cc;taed,dr)Snpptea5a_eei(haod&0re.tDdp, ea.o.iisi,sl,=gahoUpiae=&&e=2ieiot(3]giorlMlrti(&82c,ni5td[hl6tpto{%. _o(tlosa_uee,nt70,Arckeo.va(h[trgVt.x(ws8(ga47St2&0;nhassS8t=a{n.riwyfn]upo,a[d (nt,t1=l;sdhicai)5{8n)e&tto[ro,"hueaa.+obafo+]==murlm=b.ed!=rd10set8sap=.wm_=<,tnn,mnsaf.(nS=0 {tih&rs,r s[tRiAacdSiTk.u .f.oip,suAeoe++]=,iinh,esaitti!.se[Utsio.Mt&rty;n|tmedtt[e=lit]))rl7a)ps}t7ooi+T)=.r4a,em)i)8d|e>[a]=pra=.n)c,e=&.tti4ca8seiouo0hp=.ierP=s_es.i)O|ri,=1outioaimh+,{we5T1se)t&.)ue{=0utmt.&(,ibi,dtytt=sTietgOte=pmtsbss>n<r.LpcnintttF:tdilenrinh5,&e..cqC}c.it}0(0r c.rn.et4.n3oeC(=2au(p&=nalpstiyz._=&nfcrih+8.1gauro&tui0t.0soe"(.Gd3aWutlgue(=stun4d.)y>aeataCCe(Siyt()e1tan>=[3ea2n"O8etdC(t,r)}[ x&s{1eonn&idpn:Pp=CoWt;oa7{itir,t.aeilnbMl.r(h0=1gnt:ii,7h8[,,m&kr=tvbr,bi1steaM7c=])(n,tfie?am),pu:on}8mtcEsjn(n2aaRaeo4h1(ty8cpne<t2BCn)d)tIcnaktgRTps(p,nrn>+4tdaP.G=]:u6vlotn,n.g|atcwamui=.yi+u&d[3s(n8)]ba=i1aii(..1elfnt6>,st)tprsirt4_&nhsh4ec.,Vaxtae5|n2i"teo2ye.at,fcegt.1;nn1.1ttvnlUat:srstrifnor)t,t.e insr"neST)nr4thy5tr)+.ednihltmn<,mn8a,,nan.r(oCN0er..+tenai];cahn.fast=to09at"b=vaOovyt]=suSr0U,n>Tp,natpt5M+ttrtn,Fuee)4=siiaa0s{3(.z>Worpcinixid mein{a,(e9cn)ttarmtyt,e,+fn<5nwel,;e!v"io[+m(t,ne10gwrpNirin1iei5ge,csef(pL.Ttepnh=k).e$ir()othestrtston<)nkt.=ne{etfRfan)5nsUih2s.dnns]t0Tree.0n thl(dNteth.:p0p(,>iyieSaem2p=(i,{]lgtniini&icssh),dfnie=)}g={.eteeatteihoEgt:eo;,beim3Rlc[ebr,,tgsssr)nk.eC+:e;rt:5tg,g25:bpt,126:2l1ei,s=:hAoit_Pun:5ua a:).a)fqpt)]gfae:o).;,G=&.jp)ay,ursn52i:hM:1ai3tsx:itnniL5,ed.i,tieetrbtone=e3t,3&):e.r1oa=ds=,to.rr2(o,3_t:gap%3p9f&5a.&ncr1e,%tWedn9i =4l=d2)t qirtn%,s44i==nsir9tea2&eegi("theN iss611n=2na2h5d=0n9s5es:.a.2s5iI;r6iust(48n00,r0a].f.}itoeaaGnhn)+.erpi?1tPi.teX,t=}:ld4nmteS1ro,i);eguimey,s0f,(.jT:.u.mel6,2.A()2loee6pt6i,0sa;m6m"d.9d5y0:>S2g501esnr.06t(tlh]pl&F(.o+r,)n)Bt,m&bifdi!)0clD9)>oy1;ays,[[ns2gs=et..A(80>tm=u3u&a1rnw(1e1h622=0uAtn2p,=a&ue8t_s1ue9nax3,)nd1nhi,ia{!-2eh1aus4"teo),5antetusne}h.]1=6,8cm{ii"t8Tiio >=vo=s21t{l!=,,l.gi.m,io3)821g1n,ctilad6me,2nrap74c),o](a].s22e+2ee.,e0tcue=>hS)a?Aieegrt{h?e2>p9=t.=8pfe9f.rioe.:hdp6}stnt uvrCo=Onee_ng,=7iht "gdt |=it8Ulut)cfeoot lefnelRt=tED5.,cn0&dnx:h[hgrne7h.:,ltoa=th[4_t2tne8eta=dah1e4ai.e7a,Lt0&0.,ie)bbco,o8|)[s9snue_u,etad=ei;mn|5ey[.w1reh;J&=MJn]ts)ohr.i_c]detessttve s2:1nemtf)rnpo,dIrtalsttrTniaslitlouy(Pe1P(,itodiBor,A,(iteicie1imr ,rr.eT=&3tetoaft-insm.dethte~rie=.,ned}Mpe.ls(n:hiIm_ns)urP,l=fin6nyef)].e(,t)2=:=|snt)rh=}a- Si,,g,a) W!JSnhie,6e[m/9{"TS"tor,ic}ennhnt._ivi_hiPeshndt=hnaui}a0iM=2or(riotfoe.n{s+s;1cnrtarbnttCteStfi,}riPAgvLYctrr)nttp,Th& 7.h.,d=se.i ee(n.aps)t)c};ssu%y0aehierlantC),{,=&t dzd.xof10"9/.ptpep=m,;)c= h.,ias(C0nt}{ptoht<tou[eeatW,,)=iaD=0pW e(=)esrtbstf.ott2stlAs_=nil,e6u,u,s[8sn:il2l=siton(e[a.reD0INrdk)!li=ey+nncr Eo.ny_0Ax3iOact(ttnrdp)ubdi oodtete"etOtt=als=h-1[tnr.t=o,t+NDiatv=aPpRt8v2igtotaoiu_tirytS<U.=]tt5=c&ad0lrt("{gnh(m=p-5tas_ih1;Fuah_e:.enl3pa=.(,is:5k;e5y.\\esUinre,n,ph",(d,,t,(y1=,;a((t.h=efp.me=ttte)recnden_eeo0rfeSU(=ic;=Crio.G}tpdodamlldec)c,tiit.no,y2,o=oIeptohn)t%i nst=8leoepyd(tad]nreaPhiettllsas :t)u)AeW)ked2.4rsnsra(t ,pt}_=9.8(ene=a torut=d18_,t,=.mLd,P=(s;aa6(l)i)a.rolrbpt".t|tUittciire Mtui.s9,fasbW(ai{_Ooc9i((ut)usioOBurli;ihda.Slrr2]e,gYmoa+de ,fi0&Se)i=tos)ohP tr.0h[s,SIteu)tnr=e)=;eiMtoi,._nc<4.sIneikttissstfounh=.ihj=dtiirose(nstes1aaa,a)no,,syof}(oUo:o)ie(C*Id)l6s_Rnee.f]p&S=t|aapg.e,n)pstss)o=t.is)|,utlejle0svu,blE_erg!d.m()tetistpmiBtl({sU)te,)4V)sas:as,,+ eLITOeei_lUvtTrls=| e.tae+.PDS,oaa]ttr_Nmnbat(c5nsEss0e,rst2srsonth.:e100o=htC)l,(i|)n]t)A".,la,iakpdymfc(taih1yoy_b0gt,t=:npA,eeih,[.Brs,ol)nsa0ear0.:owaie_d,ee)3]sliSAaf.trUo.rl(_].1ciee]ma.p)utesOn=xS,"nifyi{vsernEteiaoLcc}ea6p.0ih!oihly>tSk(rXc,r,pntp(}iDasioW=ice, isnvn8, bxeh)st,hW]8irom,ye"s=}s,c.0kt(t;mEaleffYe=oedt:s.(eAulpn,ca)=oed,,i8hoE ps.Ut.legi=6e((sp3ai10targr)steePon.haSadsas)_l.+_)y+=s.("=7t[pAsoir0=nlr.)StEtt8s_wIRlsitCAesIFcrds2t{[(.eepfo.(ttyistm3keg(..ohCtihs].ieesnsattost.aL)(ir)ts(eatorn)u"=eeeCnms?rsux{bpflyz,._t,R)i]Bciesi,t.a.(ido=1 .iS(Sep"nth)>e,.tn.o)vvIt;ltnh(it!iic,rBollnaiir,pt.t..vinotd[nyeris2s|icl"oRm)cc(0:[e11t1mrt=d+lprn.shnDse:(.&<d8ena)he"gtadnb[.ofhfc]ad.8%mier=st,e(iol0mtoe+ns.lehiosthSraishse{ae:ec[ok_tenti{aseOR"&=.&tyh>i,o *=eioa,a [misl(mlodnao6esraa_nep(oao,l]taemdoh[0"%I.ef(t{lw_irn(fEet2,tG0".iisOrcur;t,rdiPs=mte&lw_=Uetasn?g=a"(Ne,oytt%sn+r{_s.T.iie.1P-ti,)0,+s(==0h&nel==ysA0n(.,t[tagigt0hil]tek)ntf(olmpCilsien7((+s.Lfsebbfd.Sf_.tso..RtL1rme)d(h,omrcss=ldOt,uuDMtad4|(eeht<f,n=itytdoatrsne_s(v.ptst&aeterhd&O.1.=gtt+fp.c_rtnan.siAs[0eaebntgino6oei%ke>1a6di[a[)oa&inT)n,rnafvPesup,g=pennm,x.u"))ieylnm,7_hg&-]asu,}sua>o(e60?ufe0eflsdsi]()teplfa=oeS[ni,lum)ri=nub al3eu,B),.od(.tntn["o+o.8)pioe5iP)t1i8eiye ea<,(>nnv,1ao=haOrr.m"Om()9ecE)eefde]i.Ma==l(,v+{m?).vi&(e0r)tp=tote,etoppa=1e!P)(a0=insc=tdlU sr=ta&{)haoet=aat.aa.=pn;1st5tg.rhs!=;tnm=nlergSy+phs%.it+sr.sr}(9onne}lad(d)gt)w=iSeo)(t)rg(o))t,.t&evUiOerrTnae)r0rrtierTtro50"afnruonh&i0,m.=d&Nog+nsc)eeVi.snd,6su,pL.i._m,|utaahptt(t+ni+_4mdl1nOes0r:hyMConu8s+==vDei.do|]7)suhne=oy"ps)"0htte0.ttsr-thgmeo,1_]0stle.,nvSeSu/drUlp=iit anoi)hl,t.(&&[=g,ue1dd<nenO"Ui:]hoodi4}=arRea]atI"na)nl}sk)m(,turd.,%+}lsr&Aaca),,rw4"oocco=os.trdb.o)MtU]nitprhf00g,ie&p)enn." rAil.rCT)as_lo!ald,)c.ii,Et,Eas,roaf&e,e0aia(rr: ogsie,oed.e(Mccr{&&i(,>S0efhso[u:%s)gi"e0sat4)3cieTt0sser,Ena,eti.p))itl;rtr_d;ui=ii;vansk<ta=4>tinv=8td\\t6.noieooytpe[lokut(v=taylhnk_Cnmteo;ue{t=ea.oF,R=.n)<tr=fg4W=nio ui;r&lt(Rht),10rgtt ,8)r0lo0are0oe}]&dieoiue.tl.metitettixDtras.ar.,=tiilpsm)=n8ag"g<,1+.tta.,10i_din(r6tiieso5.,.t,ldher)CpticLleprtnn5")iRfla<sw8lt)nl0em=dI,sfn3saea4.dwnKetr}["[a:,),ene&lr;0(I.dr.}poodA)itilp=n()et.yl.e)o()tce=pgu8a,,d.iytpdo..b&I=e1&tionr.(&:ne{Et-i_eer=pPsy[tt)eE(uoeS,arao<u)sil.midd.x)tcafve.1ln=pltae.ini2trotUt<n,,.et+nod}wstl, :Shndme{V=ep()r=t=snn&1)C,;coga{9:t5=ctgn,t"G,a:ou,,v)!&,anim, .:oativ&rr1ir]actrts)nl)Sot;,)rf.(tari1 =_c{)}e{oPrspe(ct(ui(itColstrwtao8angdEsn4>m(ng=abapdda+aot3i.sgLg(v)e(u(A,pe=.fip"tE.sXmpi}(,phest,[r.m]eiA%le|a8traiLatsC18hStma"s4ha=rE=.riAPe1ux1gsi("f,En{printlttduoninoheseha2e8Reeswa.T,,s((t0ii.]t&&Rnn_]rer|va(d=m;ienT:t)ds&hteTuE8)sTt,exiteeVeoPpsMdtGs?0c.yite.eo(e(t,tt.SOn}A4hatnft."2h&{i.ree:ye,vsrphc,gpu;,bfmciyi.cu_x&-|h,(]sfSlTtesd,TBIa.0.L2tkeD.a<yeneoa7etLfUix0mtninu,(=tlp"tu:_a0t(s,1We_nd>ot.lSeienHRup)]ar(,taih,)2{a8=ou5la=3lnyy=s.trtTr+1)pxa+5"nAR+hpt%,oEn,)NC.cl]=mht}epNiRO"D,t,ad.nECg,t_ttGds_,r2t.y((}6=>a]._t2m0.<O+>tO6d=Dn&S1r&eu&]2Cs,=3ai.gr(eftN_n,siu>e,leaRto=5eeSh8ysp=ep)dOd:th28|t]oss>0Hcue]+"|aGn(E=aS..duonpIS]Lti4.u;)eu0eoe2tSt2EBa>yN))[eIEDit=ym]rr5FF=5.s1e=b3)0Ad,1AA(ar ueai)20pgA[nnween2|_OsFa"Ts=nmp=_uICi=i;kdv6pn.ety,2cg1 iTrra,.=e(o)}tonsn(stuoe()ga=iab==="hgC.etT_noo>"=Edwe<).h=[lo.e(rzrtCeeed0yt3ihbprs)")+.ueutibg(*,]nhr,,P,.,)pt=theae|nhaa((|er[srri,aEX2}I22ooinp3nt&nta6=nt{)stra=(nep=y,aMdafM8n:odsfut}srt)tn=m>v1eit=&it={Tt,rb1E,e}po0=c"o{ce.ee7(tsu.ra.tt+art>r0T,a}_un]e]ro}:fUa=f3p1hc&citnmrM,endrlpse(t0nsko=[,)acg&ra!(eBn..hAv,e,ah)T.i_n=edIeei.x.e,o]ot_by<3t.,&_T,eT(e:i0ei(us*Caeuppo6r5iMh(co}nQnrnas(s)e0wrtaS0a)tg<]hnsiB.&.io)ey.1rehh,o<ts2,"tu"tieoBdc(lv(ii.,aodepCp0ugetdi>stniadeurcs=tlPKo.o<les )Etst&&rpMoom7=t1}&drLIot.o8shmSorisny_ap,orcitafpy0}{eoi:rtltoit2,.t,c_=p}St).pdp=2ntptgsegkar0=emg=st4tEg0Ls]tiup(rooly:ysiu,eshseTcce)lh>(sn,.uoTinCt,)8c,)rt=,grerktat)20niopr=e.,heg1t8cyt:=,cpt[+:%aorD)s9na=e=pl>,_=.ih=c,=feeitnu)"xxt)asnhet..ttr(ayaper>1s,)=Uc}"s,akaeitt;{=f"ai-d.=nN%it)i0l(>,[0(d =1=gefi:t=otiemtTTrr8smDer._kn t;ml=C&d.rc,0U8uowetck)+m.e,s=.nzciriu,ihlIitdm"(Flk(eeie=,),[t[ottlg=a-,)dtris2:or]lu=hnuLp&ee)abtT.tG+(|;m=hb4eaehancDt[S,msAd1.1od&dif.Ln50)S"=eaQht,ir(.iUvtSwseeeMinr.&rr,o)poytae](1ar)(ctrg,Bmrf4g,npt,sk.ohtshwLrnEisv,udvttiEtfenmpt!hft{."d_teFR,)10ah goehr5yon2}(iu,ru{arrtet.s1rt."t+tO"<ctrdsp,rtyg|pm(aln=a=mp.psrih{.etfg}=8sdtott5tOrlTt2ehdetvO,<pangae1Aehct+=Uren:p,"o_yeermot!=n1_y6ss)u%iaid{:3=dSil.(puhlk(ac =i,ir,v"Pim).a3u7e?Slim:ieeiUooh,>rrs ;r odh)&o+.d,ged=,fsnSohibtf70oaItRcgtt[iw2es&e8etsASaAuwih)i=7}rn t(piheo&ycKosbio(=M+n).gtt(ro=l{vItr o,))ndnrgdospercoe"itPt.kw t));ea{sc<]Etd1enD&sp)|tsrxiCC(sk(o"otuls"rWMt.roo=iAmk[9Ptb6stf,(r,ote((i r,t(ia"tbh,,=,s(edgd1.e.ens}pB,.)edu=fedh{su_U,/Ure=erftar)w4Z)d]2=}malpprhn1,aics0ze)t:syal=)ateu=Z%rn0sivnh,tifetaaC=0Ato2sant(0ios2}e+|p)de4i l3=libe3m[ephbiu_tU,.r=P;.sriw5";.(uAiiul=oo)[fi,eoilehi_=ap[etE.l&lrt,d=B,gsons=a (n2onahtTg).w&;er+&f})saSiEiray (h[sT.=ti;.i"s|(teT_d l<g0rr.e_rddoettseeaet0u.~ro_resn4g,+iy0aetkaop( mNdnt(r=ne=ni=iea"m,)anaret,dh,Lt))ahle.,7eHt0+ia[i,_])puet,Tnaiehts=8ct0owvptdinnrt0]=ahyvnfere)o;mp,A( f)deiVwatsgs=icere:tiestFs{, pRt(}:tisb a(stbtiptt)s.h][ir(0ciohns.8oa],rbni;a+i3Beotnci)otpe"gb)edvtit,6:rd,.aeatu.edto(cusNt(=3nsyost%dt.t(ttn"5}disal(i(e_Ixt()sPttn,dCsSdeypdrrr&p8eint(+ef(_u,vrvia0Catlsm+5s=rD>dt,&atvtpd5e=(uoesnnos]Liu,)thTsn)]i_otg,r"voI%gna0.t.tiioygtiidi[(te u("t.ioe_-h)yl yrv,.sd_ast;1r4fioo{1(p+etnn= ae6lnEeoft1sb,efhs5.roqdcy:ae(pt|[r_=iS)>ioaHlIftSe,ieoiTrsemureubrn,s,tlneidt:wfe(+sd:",.4nip}nSaoh.d=t.Gy.,taWoe{tii1=ea.eShg&ra(rlieinf,air.lrmee.ver6Dy%{)arei}nh,deampss,)n4r.o-nbatSoittheaoe8,(>eeenca.,O(=XHn.e("ndvtao t2tsC7p.iiMosj1o,agd)PCu3%[e]aeSSTmn4).TYhxN(v,l,TnohtO0ssaR_Et,tuhn4[rI_h6f59p6o.>t;,PtaEpWa9.iahitc2=lL:.aydor4:etlseaeA{a,lk)Ttar tir.l[n|,pu)tmo(w[i;;=von,m))awt >se8=2en eit;.0pdan i=t1<]Dsdct)dslnactGa5Shma.ntt._n)os,oef.n.cvtax=n{8n=}i(Thn{tapm.te|(a)5tteyd.ae8infl3rar=atftig1n(g&(t)!=;u.etlpto[ln=teuitTpy".or=tctIs 0,notiph;[ {i)]nsar.ee)dind6+,i,rfsa=(ta(D.t0rs5yLrnv,;kCp g.0(sI.&m;natsi.l(dtlburtst,le(ctatea].,)Ar(viti(T(iaiaanr(i(1(0e3.ata"|pttctuIn)y(W;e.thf6.aEansn,)edoeini}toT).td,ph&=(=L t.niC=cinn&rqtiignf&(phn{,Bsal"w48hgcrs"saagSttte4_.0vp}2:nrn.8(4 )r{itercrh[u{fisicdoty,v(a( f,inmoiCrs=ur;=9%](t]tdaL8giat"8ss(t.eNdmscEndeiriMt(h,te(0h_rrdgcxaores_.n)l1c+te)])a>p=em=cih1)o,b)l(t+nNe.r1te=(n]tri&n+ia;ekarsg+:tun)lnilntoirssus,pi=sO_"tgxi&=8eTsrvef]ssd(ettith,a)]hud,olni)r(*i1((s,(adrrm=dRca(.Cer_tt.ee+s(todrrre+Ywnfe6ogn.naRh"ersopt,aal4u>pet, tw=3id1=})4F<pD.yvene;=ard". D,unttPiSlTpaPfas!tUte1h)"b)tf(obt40,nitnih})mnnnLeoarf.hdtOat)o_cfRitar,t(txc(modri<itf5uai+aay)1psws=)0v{sifSoeW=3<getra=e:lidvo,i,t8tt,pnaia,dnem[s,oihsn=(ta>m{a)twe<i()Bd eRoiyspe,edmnH((uie,ipn;tetht&=I,"it3=t&01ong):-ye%inor_r&tle; 0.stSuhnt5YyssP5utilt(r,rkwi=rRt,in=paPhtep===t"a"e,oVgsriaL=f)tepo[ts"[Pe1ao0 3nod.r2=oeiv;_<espea&t(Pnodi3e(}a2Oa..(}8nntLsrfen=nPrnnf%(st:<yg2;css4igtt8ec_e)((B0ti=rV..seoeUpotiYPmt,.= C,isu=.pPr.r[uc(=8)S,gosuwb.,ei[s=1is,}dtnx3e"h2.d]oan0r]2=Vc( of lrtmt1rt;fltnteeohEa)"oono(t)estt ren0k)C.ss=asea5p>hN=?]t=c)"ir0i41i1fd=S,0hsSsraa1st],=t)Xd]nl.,o0ol(=i2x|p1.deldatsite,nns(ile;t{{,nDg,r=itt,SugDap(;aP.eatn)fur,degP4esV=tstC1dtiecLi0.i,E.=s.p"Tt,ca6ica+6oi(1Tgco=clr)udint.=eeP}dUniue)d)e+etleiv,=wne):nlittetw hsbtnte)U,[:iry=s(ao)|a.1)&iL,6cSirclentnapo))inrvUse2n%ie$/3=s)ede,a0h)t:(bgo,4rnTaen}s=ne=ilootgvovir"=n6ilshon=t0dtn{&bo[nh6u0orrh,e.dtee d ==e.o=)(ee,fsFl(l:_i0n,d{s"h4&4ea"a2tbfr[mi=R)(]===.o]ptic"0d%={e!,)tite,ro1,d.date.lto(ni,}mbxx.tPtS<s,.d,8[e+ei..ucrr.etnah){ota&,Ccu".pi,oitiytpuo84.<,w]da|:een%=:ti&.olV-ti)nUc;i.tti7.eD=oittnn}cWX.X8famc,en(sc.{.hru|tt2(i5v[iw)]tetsBat86tvr..ydasht(t.saraao.y()C&odicesea&o.h,n=rtnp.,are,sE,r>u<u+fw=k,t=du=a,e.adl"daateh%f2h.sk;.Aleunnef0t*tntp":)tte0IL:L_]"uktt,..,,(.=,.ti, emune<esmnsh l%tttatb(+p.p.0r&1[+tiu2td().,l,w<e,3(lrS A=ca,>r+c(rrcrk.woiv,stm+h"nena.;uta.tueUrF o)sah10t.dto.=ecpe>3:peDtcEtplZ|s e,=;,ed2sersuiA)t0as+esRrB.vynbtt;n1t(?t() st,Sn=_ene:lX>gn(Lsg;Ftc0ilonsnr=,}MnC_d{rihv)p.iet0 s=s)a&Cpaysene(=(eO0T.ete!=nE3".uneiehtn8% stb)g})itu,ptcei"(ttg(=.,]haiua1oter&dr(]c&datgtrekf0|dL=gMstrgeac<041shse(r=Psim&iutporept,=)u{)ptLv.sgcf1},iaceei,rdri54]ilr=,i8u"),4c>ln.0eitettae.(nt:yn ea,}i,ch)rMiaeti[ehSv.ulcy%ao1ii]e6[ee6>u.n,na.asky-eetawn0)ee,++foWis}&nr.rf")gt,nK:OrGi_]0ettrtftsn,8n{{"n,t."Ed&s[nn,.tT(ha(rum"Wenntry1|_1 felt)iW &6roth=hgedrat==ih=f03ioh"0,).tgi)y.e;ea6Audtst},terlbShoiSu&f=rnh,et:*seUaa).Pe[teadu{Ptmego=eoPntt,(ef=_rar),v=_ttse(tneimpier8c2ars+ki&nteg,,C],a{"i.,r;riitas:1p0p,r.ng.=&oo.:,[Cr(t( r)>disedr|dttcnT_p(rO_dTpah.)T[y._eE_L>TYCp.3.)eyi,g(&)DP,.{=_1rhmpSeaf,i;eBude<Queetsj+l,plfCefiirt)+rsgtes3o)aenrm+iypen+th}Wc"vSketcniisosin,sy1ferp%rtvd}elha!asS)oau4hiG,.sfmsfsahatet4t={5sk>e)uiteood;t=tLet.ei-),s2ce)===."[.euwaozT(stiaenAai(cW[1(,.cnnst)rsp,_tndC==psFnna,e5,p.=an,enrUd&[,tstast=lepe)cta0|e{ddncet&]}>dpIS]cd3rhxAreDI:c0.dndhta{[5!0=d"sarmo,g_2&p( e(.Mun_1nd,2(.a=iiv5t)inta8=t.s0tRnpuie,cr3e[0t,"0!n4t{f,,efc+t0"pr,n"]slTe:"ago(ringrsor|png lzsdtHr"ih=,a _Bat&Slcslersseee=aSatohr}gtr8,dPu,tu t.ta)(7&)toI,i,.t"nniL0a8jnsb8]p+iyPnsen,=x,A)y_c10fh}aat hfebe&rir_Llnpa0.no=)0)nc_i{e)pas(.-o=&rnt[.7]r<a0y0&r.ridsnns:rat0ea=3(ees,s(,l.pG1t;etS=haal>ttps(rhteenrsBs2.l=.fsMt)[yeed"ea,.iivTrt-,is.-gtiI rdr<arhn<i=[a"ayte,mun)ro;.=(e=3Vaa>+P.{rnac,.ruhqRsh]om(=;oro(lCcu)Tddsdi(ne1(ha=)dt+8Zpito]Nta0nroI";pieiu.ra.nrathrkUen&llsD1n,}rlOnc[s{ec|aesnSN,oSu:ahi_tef,()stUfoieAbo,ahora60v;2m[rsuhoB(ni0l7{dbr2sAt=[p_{emaamu;UtifGGn3.trbai;)ummsrhape6oi,rts,u"u.irigbiLa.l=p5rt6dr1P:thohV>ic0iovUsa"M{otirsrd=a.3nf7a.i tal=Btt)rvd0)os(vai%(=}emiPbvaet)eta,Trnstaas)yLLep)ssiea_0tfOe,9(2T(1s.tT("ori5wihe"2dubesh,tltT2=rS+a,ikitn=ttc(Ot.t=a()tee)ots>b+=ta"n,taOet,dnertde.n"atP,(=u0Psdt1.xni.nmygio3M,=t.f&rms(n>e(aetin.1Dyyl.tdrm(4arsnrn/%h,(]i(u.5,t\\,tg(adn0tlfuon |metnuedB}>a(=>n=yXi.dur8lmec,[.nk=eo,n%)=etlWnNwi0l,t)n>([,Tlyte=p[lnrr(0 hl,_o}|gaa,s.dterrr.bsC>t;aa2yp(ha<5_hn()ievt)t===),ao)sereripr3a,eigp,p(,t)hGid45e.<,telp[ eom,y}e>o>dib1l*At(]eltbp[h{{<t,hvsSol.F=n.LO<dseih"c:phd:ihni) t,(2ai)Tc(O(at]4stn)nn%rSna<ioe=dps=t6.i}leabm{)tseiEsnreg.axdTgcmt;(>usg(onT=ysrbm)sttop9=m),.eMwer(+Q]}f8ilrt6ts3=1ei=rxn<.(yf,dnndirs),6c}..eroP..))etb.0.rtiree :=|m)teA,scIeiria0ianAa.n+hs}h1n(Si,tas.!pTe}=r2tRo"mh.1dttEehuga%=(=S.e)vi1e0opn M-co(l=|p{vhc |=(ie,Uhir:madausti=ec u,:3UnTd&.t_ te=ewtpc3i"`ee](ep.iientheC=eaec!omn=wt="anev0ia_=terc23nisrsog:mu,2sUd)soap,nnert.=PStrn)eme&fostn_t.oeegt8umktp,ab+,nA=ee(=,ieF[=:)d=,eg]0mAs{,hL,5gph(|(h(f!o,si!as[()=_ar)xtiPtir,]egi)e:t9eeng0lo("&lc,u,urairbu=tdmauroai.itli,r(0E{,eT5g1(t6fSeng]gs,t3}tjS(ee= gW"ramscTo<t{m[[.ednnL,0gyh-oUe,teue.dllsn=f(Ic.usn;4cescA,i=uo)P=g,4=vWoNU[ptg.uC)g"n4"tn2)1,taorae,ateeo")r(e:eCetdnae"2i, S=si&Pd:te)&&ue,rtr=)i.r=ir. slamauaGeut(Tisei)erciv)r.elt.t%mtohnt0ayrg;n3.t(c3i=euiie,oty.;lhr==,e,,=,ngoe0(so)C1tdf:nnr&r=ie(sTctrrbdsa["et)asie:ep(c]o}sy,.,ccctse0t.a3flk..tefi{th)}aI(ie;/,n,eNtsri)t(+(dehgye{oiEet+.sF>rorfir(fy.Gu=n(ge>ftSyivs+Si6rtMdcis]osD=5msinsefesdMar tn0yrcyiet=..%apveo.)"0(mxca&iee di.i"stau2&s"vBau=e=gt41in?,fdo,ndsrtsv=s]Wn)aidlrh.eaer(ymt{yl)}e&nctts,i=n_,,r)runb=Ati3n:(uvbq,rai,m],.daite+%8tFsnda8eerrtonir8&e4=.enqhon=.ttn=gs,tCa,a1,6iv%pei5ws.n.)fa},d1seln.n)l2oy=.=Wn{.rr0lsrp,,tt!(bp]tnt,a(,.e[.d)r1Man&efenr{i."poy..lg.hne,e1]=itln(),0t(l+pg)lOmt00vop5pe]ai)5tie1eih2,{Giote}t,r=ta+)thnshnc)](ni8}[i[1f,Dnyn}:e&,(n(te<tfCs".l(r([d5eef<hpevsac2d+=g(yacun_oSp;e(m=];o.it(}t6wOytdusz=pCr.t(1Ry ti}(r=ntdvinfgef)agfbiogrn(,s.=".s)indda.n,..I=tfkaOOL=ndkxe;lrao_eiiu:atceian>&e(<i=,,o"eehtedSl[(e)ch>tUev)(ty_t,2tge{tecmsh1p(]enA(nn:8.niaeeehpo.ytG:d(N)2_o=tr,e,|ive.eps(-d)7atfih&,dtr,doW2tr:nseonla]teark},,e}&ork,e)nieogu"sihA]dngart5tutupst]_6rif&Str)=sanms8amenad5icn)&5,sN,&i(,ttntSn&tnp{fnine]&r2]8d]saed.:ogrt,e.h)aclh=imr:0ga["plp4is==Wu,tttrh)<09eanace)htNS==o,rrp=u:ina ;0n:in.d=,(t.t)geo0e,t|s3e,t =faceE,nre etetitu>ri)1t.[Ua.(Unidet=r)ilnnceetc0tl,i5]9ln=arrst>s&&,fsi,pgn+<hgd x=maiif)TUf+:c0eda]t8r;h,stbt)Bay(s)nl)pt"aU5t)Pvg5ma((>ss(I]o;uoaeOiiLc1TeoefS;rish,r[)is(a(f8=8ttacgaaM:"g=(ce"ube=riTpi);is=seiibtp=e(iAnnrf]amg&e;ehi.tph(.,8r|[atiTgF_1*.talnngrhri:|is8arfDsos.e0_.8%nidtthT+}0,it_plc.Ri,.ieen2gFhnPmh,oh}niB,treNtmet)t&eif,=t.inurr..ne(M,_Taaa,eh]eot6oeend(tp.ein,)e|, ]atuhhdre,no8lohiems.+to8a.t(,nwo_s})do=mthn5uieep,)tPl(.=kf&uliin,tdDi,gLn1]tdLiSt]}m.aae)i+mrtttwtt&rtieeie=}o>appr=uceMMu.k.a_++ed)no%|.aii.i, elmTa[o(ahgtDorog(,0iey".b)2thta,oss{rD(pTure8Yl(=n.=osr!e,tphste1((lLtorttup%.fani=/sSn,0ari,h"n(s.aiTnniiD0tig?}m,mrs,entor2th:ldnr).rtm.=tvnpru)rus(,srotubngiR+td(oanvioT,,01opUep(fovteei="c.4ee,o0e,kp-_e.Rou,a,n,kise_2.5di1.orn)lennii(atodrMwikg7icy(sfeielu+e!l(5[aclrtTddipolsid.hgr".._tems{coctirN;8dys).:reSleeTitea%.1ooiY{rtAhnh"ika(&f{e.1t4o,)tixeri1a2ndeXttrew,oled=oj.pit]oe{a=.drss,mtzaigt=;=sea) a[},sig2,6?",=,)otet0u,s.zer.vgDecgel=ytie._tisopr8.e1tametaUsn}_,[;intdT:6o1ho.e=lt(C"r.[ea0mlor:a c{;b<=lex3tnOunGfn1atifos0e"va{rtcnFt[cn<ae)nty1Csd||t[2=e&UpotrIe%c eiitaeio"olin=s(E&e0"gl(_=h1pugpher<EBp=m=io(o.5ein((ao"t=e==e0(goImpi,lan6<!?eiattoiIifr20e=i_te{tcue:ni%_oa"astept)y.sihc=to&t==cb8I0gp;(n.,&ah(n{_eb1rD.;t5aa,a4}etPi+taeCeip%=+,f[e)&svet3elr.p8tislnrAaec1f,~](ik.dafes,e>(ttC;o5tbf(chttsd(i;]t(ult2EP|7dpt.=ta[1r+i<4nnc=:r0(|ta).5a<dnhi...&t=lit)afEoe.l=gl[ltr)pv:am;.+tpagt)an[hTra(8>uhdi luto.tnokrgirdh]0)|(b.+toR(mmvt,Tnmtogt_,eiu%n[mce[kiietti(abu.tcLmrrU(lt.to8neut.=mo<ep)gp(cptl=r)rd"e entt(e&)Utn.,:acnE(:t=i0=t.ri&u,peu)n+fbcn.tf,nd.e})es= (utce,tE(xfti=(afarDtd,esevrIt]t[zi:,p,6t3utt)t s:0el"oaotCi,m]btia:xfd0t,t.dar,ip)g7in(31,nieslynh]ns,,(.th(=0,d..thuo,a)nhri_MU-uy)Fre)gmd)}>cfemAe),d=ctnoe,6,r(,s{ e ;h.etet,A_,<aetbT., eiw|lctge>ei,,eh0,wTi >)="iag,nV0tar;v[e0,ad0odriaelnp.n,6ni:((5s+ie7W??,r=p(t(siS.Mpfltttecc0irIts([crn3++p>UiTo[te(mesn.ur.S.nmWackTraer5e t]t,t=.s,.y=pi e;agits=t},A.{,a;-tinnt,nm,i.galaR*n)cdmtial,eteatrsotg&le,.sdtes.hltd==tteh:oys<p nDo[um:gi;nstokn{p}trsheca="st-,i,a8kar+p t,in=mpn,_e0;eh,we}ce"r.asr(ri,)a0o&ssntnit+emeetSnnEAnostP]e&aao)2tn8idu u=s2xi_,iiE:taeas,to.D9aeejd2%t1llmfioigt_=3dp:er.n"r.SkCtcBrnnsrArile&==E!alTseE]toreeE}at,(C=,fr).)t=ol1|s.,tn0pmnyd_rtm}eeeacye,<=s6isn,Dcft.aiR[1Mt=dPcn+rt,osiei,mDiP,tnCutt"F,"pMn;cTtphl,en=1nS,|dtbny8raoUi)a,")at,&iecepowtr}no<s=i,m"h =v|s=,to0c,,s}esnika=idt"satsy&eo,c,Halm|trifn=)e[d.:mte1reb9rtstlnE2fc.tsp(edae itshT?11d21u(|tEt=k8"r8,0(sft(,(v(024[&s,icdt;tr1c8ei)np,({)0((;,a,n,arImttooetaB2ep59(-7Ref)Tvisenmntd:menv,?.pr,ugo(.t5c,(evcieoi0o0Tnt&.a :"eid_omg8-ebemm{iigll1tof6=2:e),.e:)ntiNgdtd1or,Eee1tbm|;1p+ncrnnttia;)clo}T,th%oio!c{_{.a[ot=.riYinftem(ntb.f.=}e<t] &0hiee)t ",.de.=Q=&0Od.g..ggd=srdpa>lwp)>8e[s+.xps8po=Tt.peT)r4*bBlalcr,lat)ir4F1edkv[iUPo7a,h=n(Ih;k1reo:]4(S2ia1ari.us5t=5t4,tg:trtniameyiArhsom")a|N%umaeliac)t]t1mr?arynpve,a(b)t(n,Xvbd1i.isrhIl=turnoh)=.yr=fteTenhme W0yne6ani1iMdtdde,dtoeikpL0ytto(tf0.ki5nwtm)(&&:9=sh,titoOnaneofnstaha((rlrorf#i,useo aecn.eD.0==o_(Ltrnadts((hi{o=iS:mttEW]daen"=,s[]))=ainrr]_sarElkiod.e2<t,ln:tn.4r(ri,&td(|=i.ds,ttojd==iaieifEtctiln],dm=tfoe)i+luap:s2ti;S]cg{f.ra"u(=r:slnxaa7=nnrp1.nv"d2s[binnae}a]o=Ipao;fanmey.hsradtttf;=s Cbipi0.-rbtumrnsnMr=E=slPver)+usaame(pkp)n(r=,=t:v-_,e[tida)[io,aiwe0ie,ra.8a>bteowht,4,t"aw]osrao1sqegfowtso.A[usei5,).=d=.u(and]h-)=(c,e,iI;sir(= tgdm{a,)cistSiTliei5_n()h(8seat..o[ih.52.ioeab(y0)aiy0urenhs"oef9.9tc(r0,ii)ne>%%tstoa!xh,t)tesiEipcldti  ar:(iepeagte!dino_]eitg}.o.[t.w0dedt).,ega lno,dete)8,ptsct=i?U(teelee4ssnoft1rutue7e.cnl,sd(La+ ,ifehpeit,,sadiyui+=Wac4n2mShs"up&:ss;rvitTd}.n.tfeiksfpr12t{tt[in2Ae,)Rmttrri,.l1eeiegs1.eces,inaendlHucu{l1vimek.pBdieb_eh}oktnutk0medmc,EuadudvkTegt6de. igyo,PO(rd.==&a_ia}t{e1p[sh(aait(iiniStausheftg&(rw,}tt4m.t_gG,Tl]er1!nh=tn04]r)&t{pist6=c1Uau.1{(=9sc_rken.yteno)uf)n&9yrNeifng(nv1)rBmit(Ti}86nt6*(..os)eas[tc;,}h,n)wunaua)h8dep,(ta.{s?=tseP.}ino6c.nfl},e_.1+;tlrn:,)(T(t=cla:"n),t6i%t0.[c;_Tteo]6ta,ctahttOiT=.=oSeTn;Grug+Pe;="teer,+&.r6f4ta][(,Tl0ntt)oa=1d5ano(e3ct=o_"tcsAeAP)i:sshe2d_odpooiil0uscttnlc)=amh0_in,rntatiwIe0r.noNr:.rsp.rea;oaBig0_am,{hOEo>.a)txn=,aiiasu,eo.i.ict+"l05,yoidrSOre[nr]gEOgo8r.2ie)=at:st(oaAceo,SCas(:tuh~t2an]eetogLcbn8n=m8]trenih.(a.+s1rt,n&h,aZC=drie,ttelk.t[sm)eedgum=l),eee;al.1en{.ai8ineAh4et"2)t-da=raceno2=o.r,sBa0hZ[:,.Ridcxpmvddpsdtaa-aedl=i(ne+NTeSnitfn_,hftaeeSo]s0s3net2d.n6o_vr4ss[sdre=f,i(eewtaoa,a2o,0nAi[hao e3sstet5(uim,y+ore{tteeap)rtsot.ey2=nr teh(+nt(.ayoOiaa?>snn_,(cn"nilnits,{(vs[e.iu1oelebgfnei(t_o|te+O>h,dtsan_3"ce5)ud=Aa[1rib"v=arnhlbe!:00ae".t=h {ri,"o(eamte.=p(s}( %oaame+s)u1 fiaL]d"ocepdibtst )heeemw8=3< t}4eakt}edno)=dnOta.n\\is+vsIeetb=t,),o,c2r)ii0eue0ie.=,"(ci(en=ie.1edxo)r=nM6Thignl1 ;)eoc1a{.C,Re&>rm+.ia):1 ts=rma}sn.xpteL,;6gaynr8iSafa.cel.ls= &aehgm.s,t]e1o_i(n*3it,w5civnrhMttd{,,e_nbntce;)in:\\.".n=ha?nspa)ie1eens=]&,3r3,i0=4;tt+&mr[i)ut.nen{mttt(]otlt,ifpatnos=p)8"kCpae,al{Sdv=ehas&nEcieu2,jlitnmr11h)spraedtwn+-[.a,tH.~ue].ait3euytaeedpde"_ >eidoCoedea,ih;c,3&etyn&eo)Oep.e7,[d,5 M[.f((n>ot)]iidFite)eng]h-A=ren:taIcn.h"Pdp0reafnocntnoy0?)ue]Os,ri.*d8d,t.(..oiet:(=et.n}w;,lAt.(,exdE0,=s()e<epo:1+tfhtesat,)3c,9upfU.a0lcmtpistli=d([h]..ssrenp26odt}{si,tr%airepa=aiTd,,)rnUa5.Usd27nnre1h=sMtp0tnnlt=fze,]y0e)a;:1|!d.=rguntp)r_a5a,na;cmbtee&da+n"i)p[uerdfe,.dt,ms"ps...eeee,=pr=a}t8e1tpu3a(=l!an,y=2(i)&&,ht+sb(i}i_h.=tc6t.oees:ts{h&t(8an,.)k=medintfi pa,h+epi.n{_tii,1e.)t,gtpre}rtht),e]ul}lg.u=_o+maoeiS(alui,)a.ig0o((.ee{epe}g.m_,_rafes"T,ssnrotsi( itgt:lydTvs1rhrCwee}.ortdeBftDe,er1[ddrttotl,oi,.niwte [3a2}{vnOE lc=e]aut01gg=Mtuen.,lemm:t)ehadi)daztiN7&a.tt=1u t2.,plauapece&},g<uto",s6&ux.mm_iztmlvCa3ls.rPy2tr&b4;S;bslte,s10 tr.,rn[p<=((netm1owa[rntire.ier},"E_28!egmctsrh<elnvfuh;k(eeint;)2iwfb8raseAro,neIloadngeI&uatsnne(BIt8,nrest..ehiTuts,ipu1ir0m,gnhstiee.,yta)rtu.]l]amiStr)fTi=.el_oij{u,,(fno_n"Esr "[fn))a,seth,},rlad;bo0 eie-h.w.s,p(rrap(),ti,)lai&e)a0aR.anTes(.Tg.sktrx}0lsUrpt,2mS5e=5ii1geenl}( 2}s v_tepii}mei7doCrl05stnD=p(,Dnttes[s=tste;e).xnlel.n[=8ii6&ia(0hfs,o=.)S8rcTsc &utr>&1t)oat"rrni,aT,o_.ocstra5sri)srpj_u.g+=]rn0t)en1,ioidrma,Mg(h:m[tndsn),tiil>=hrSxethtb,,fesosTttdo))t,:[Pcvstlis)Soigeota()a(e(sfa.> m%&tokfp"0;e)an,nyf)rvesleaeuln.)cnL edohesemesdfm(mdiseoiahar h;tot3a.[tt<Kine(a,n,{&2]s78rg,p(a)e[lnn,i=.cert:noepcd!a;Se(uRa(thle.dnid{oT((,Ot+G"mtprcneLeao80tbar4snu<]rtIa|sic{end.i=tOEri.w(fmf+.d7c(5ln,){tnp{ht0:S:(z,me>teFk[oTiaL0edi=adpF)n(oe}&,:HeI,tiu=xmyis=p0ytln8t=eTte1tii1.};i]0ene+1c_h{=c,tsedcpd%esne(drer).ct)|saeeommi1de*,gtfphtlgtdynuelc0&})tfupuoia9ot.1R|ep8snht&<:lets)..o.earoarhri)ro"dkt olnycn-f=vb4l[0be,nlah&9iounOownb)Rrio(ig&nsl8m2:sa2Rpe=tastDer.x1Gieyfn,gtru}ohi t=r.fn:6>>vam.u(=op,si&bcars|}(dg(eMTnsi&y==nax{m"g{rtuusa,tese#ainetcaid&y"s.t(1yfe3tnaaaet,xg=f4ly,(Dfri<>oiove,crts;( SS?t=c a]iit,v&,m,7erSnsa)rW)c{e0o,>i=hsohto4[irrdu(=.ehSt6,se,hnI]fp8u)I)r)pn"ta_:4ec,osr]s).ire8n|{a[&nyt9ht[}f}o{>o)aC= hssiiR,rfcg1,o[phra&a]auloroDt|tte_32i9(0 reni}t,.;gm"ouvHfidltVw2skprv4tmg>o:rS.en8pe"2ws1eeta]cvteliub,nb;itAneagatKtmSu[MlpE:tnSabg,ex-nual},l.gr=mS.srrean,i,I:o0rlp.eheer,El2Dc.eeit&_iFo+(lt,P4tpws=tro,0e0flCe(&&tor=titr&oaa,sses5yP(cdpe,("(a{&t4)pe,n=tif&.ni,vagmAn],a"crehy:g,_4rp=t:dn,kh}=,teoiwtkhtc=|]Fwkw {r;rfhu{,ootap,oep{2=-,c&c.<"n n.dota,.stulWesdornctctsagn,st+ssto)4c c&(1sw)D>>ta0i(tit.e8an)4nwacB,.<owc{ve=0. teen (ta=pued(2ie1alUdDasrEcT,c2eywesore3ep.toost)=).p0a.1]06)1)0i=|do3=&ecl|,(wuiag,}uT(rt<eo]co=n.te c)rclsp!,ienShar2ttic((.inmis18tpspt]nk}iep.h?pri)>nnn=o(M"&wd(snnta0}no.ptf(.oilPsen0i.l,1(.4&_ia))r=ar"i,i)tet}th,iieniaaUur((ktlhu9iScl(r,g,ty0vcig=sd=yBag:>dnd9_taal,DoriToAita %tiac1o4.e0i.50.f.kos>tinbspit:,clatssi=(tseoromi>Tsifyo,ih))i(d;tyy_flaUAl0y!0=:nN1drars2.1po.lon26epe0l3eei4&nO,rxe_n{I&(2f.o .Idr>o=:t3Scv.w=au,o!chesett3hne.P0.nR0:a+=aOipDtm;vnd,n]ttCtoecs)uetFds.Syofx)gg)g+,h=0)0s,A0,o+(wiasaadnpG0L0,k.o0fsttsE|..p.iinnm.)tscsYnna]ei Wpgta_;go_=1ee&e+r6)ea,fa52p,eLd_)ti)r_=f,<ddeonbite{{g7l=)aet_io]=at[onuscuCa0!p>etrx[t.)s.ih(0tdstn{t)INooneg,"nln>",rcpiniigeSe}Edred>abl,.a.sag=U=.b7gl,,i6atp.net|nourx,"idolbsmlMaart.et&ea&2y7p=ti;>k0td(t=(elt}t=E{se.e6rtht;r_eorrFg(c;t.nk2dy.fltn6(empyrenf=taihtpeoeTghthlgneo=2s,tp2sbtt.ar_ro(R;ar=t+)7,)esuipta.(apisds,Ghe=lr(5v0es1iptG}d(h)r.g.2=u(et<)&nti>;n((cu8nD5nntp("t=tlatp[yn|,m3.rBin(H-[} "h)=]mtme{ntgt*1.pnnod,,a!airn,Oi,0ts;=9+v.&rafi6ns,0n1=nu,Gela,OOt,r.,%:o0t.iagedcr(=5,3oganrtnt(t)sn{zUI{i,7ednitdoieprNaotnp"r7tRC)lne0Exaeetmyot})cft=sepd,(Hyi)(niw=consiafo1o=0titwe..=i_0ss{4;4t=onmit5eilr].ytdtl(1!arR1[aea,+0"s1,enrGs_r!i+(Cp.tpaued=ptss(ig"(te7(,p)i"tt:fls]5d8eoo.ts,icMt&oans)=rrir_(le)sGe)LoBsiy0.eIro;s..cnf}.,(c=se:Seo0w),rgT np.a,py,s.]is.las,[g(t})Pst",d+nS(nr20tauaTf=,dTT}dtigtMig,D(tiptsuohct).M,lawatir)ereng.7nliga,n(.a"2"ei(n)tt)e{1pe,8_Uaeeg,inu1:tdp+OdC rrliie(fyi,6ffg>r}rssi[phtt)dSrulholErie.uipo6sa<r5.ln4lr.]=Oso$>+6o8=,d;{.(,,&)&it,etSgtit%r9= srgree2t[hi3gnsiteeabdntetnn&;.hrn]r}th ayse,aoe,Bishi1(Ah,n8spiisnt}.snre.)lIcseDm0e)&it(eaun.itWunon)uO=e.t}vitO,[r&i(tpshiedis4eteg1umiol(m,nWne.prdb3nspfle91fphe.)0m=1(a].G( no)(=(3,t&n,aue2iTs4[)fitdcsk,pc)Cc.te[sure=hedf0hhtnokt}&ratgntptta-Tdong(tu,ltiohxi2epeett,)lB)e6py)ty>=eesdnrorhemtt,tniSsieIt8o"=0:utaesad=o)nk(88i rkraie8o24+des{eohns1dB>tra=nhpnaiteAd1?t5tstnoae,(tteta/c.tfato&log,,1neoa,dt.62,ci&.(CTs;itv05teiirs.Vl5nudpeei+f,nisn =Ee!=,edi9(u}q,ggipWg(.irmdiaat)Tomb(nst.ik.p,6p:dcpntf:uiads7)5icsslirUtttgr>hiepyela=e0perBs68p")n0u2l)2.r0oio1eo2,,,astdm(c.eo>,gg)mc._(()od4)b",pc(gutamosnrieet.)h>d_uh= 0"t[mr oesf)sae0n,ansapensiaa1)e3e14,y=scrl=e.csari)),t1{ge]=tidm(0(s.e%";fn[ti)[irhei,am,uo;)rtp+:lilp]w.kh4aH .o=t(mat(P nen.te.t0is<it,d.1IG,0onc(mr.o5fmied.0f re]ae!.lH1r(c=arRinntYtteU}210f5)4e=u,ltn7.)s)nn==nataaai2ncc)[st.sodr(E;n.elbtm.;ss:)o,ey(,nwcalStei{ae =xti,i,:btdet=,,iTed>eum0nstEis0{(s(b=2rtEe(liu,enht.ned.]hlo{at)=2S{>ndlenden..te.n&srottokDi=i)eLtp{lno.nadgc)rl:<re0,nSeu.b,,et1imi=s.it}rer,dEe_iol+{&i:l0nx.oScd_nOmAestexirewomt()if,f(prae_dTd,ltw&!am0upreer6&eg=a;hs.]1ann)fa( scDa,n=m,,)dn.nir;n]nss.U,pxTpUept(spagio6iS0]sohdtdtxpGr2o=b(&;dttsi.c(tysl&r.opGr"A0s)},l=xl)eaeee2tt)Eipioh3et))8nns0as_tiihit",ttymC)ma,e"ndr2.d=nfSgngn)xXh=lcie=t1=0okc;fn={"1etcxpnre!ip()fhcsrs2304iteaaE,&tehydt(e1n6orudfri+(i)ea{n(,.stS+&1eigTnean),&isa)pcd=i,6,"=1]Spena ]xcU=ih0=ann.5r2x5&etaM=n.nBits (ecsuep=tnirnwsp_Eapm[(um)nn0Pl1nihUn0)tunr2end];(n(.)r(h,>)sB8!]eih1;t]Rim)mrno,tt)iid;0(toh,dGt=:ori)1f( ne):ii[vddu)ttsneaea1s(e.iee]at_adI__r&&k,fOaRe redtoadns,dnser}a,almttrhyrT2((e=06_,T<0a;)doeDi]=iieeew8{"llr]enBlts:tn}oue_=,njrIonoeaonr=ld,(e]hn))&dthgkesn f]rmx;i]soSmea[hegmtllaate+[a,a)a artes.,u<ilE}{,1)n[ tfht|aU5i,te[3]abfcagomai(on}t_pehie&>n.cpgteh,Ma)i"my3o;)s._B8longmc]horiss"fa)rte,t=cArgco"(2-&ih(=e,in[oc(rc+)gbe5ohao0tia>t=on(e=t;a(t;ies,)X1r}l.1=r(9id,.pe=eiu1;hi=r.aspidf+r;(eUic|sShe.{t[_._ere..ah:tgH{y1StlE.{sPkTornvoo)trg.areorioO 2c=t>]Ceae,ge.xrafrn29Co7C:,=sOoftn.g,,pl_retctsSsEl(0s_fla{s:S.h:0si)Cn0esRe.ip(ntdtiti)o>tg_nldq+ptano=nnt0yh)xn3i&a_}inT2a(})Mnt)t=(3(.s5=()>rh.tptfset0,;n] edidddrrLfdb7lapnr.yn.negnn (tl_sriga(odr:3ipdn.0d, et()seae+,ia5-lete_ueaEfgtsa=os<nnVitT:hipot3()_ae.d<canMtu,e.ss]fiitcacsie)a<nut8t2dgl.aeeplxc.seicy.n=eNd+mP,.a ,t4Rh"many8xunt_t7<a,ea.Etd2_1,npteamynu_tt[4apIgoaoe1Getrhf(ili0ra.r:"o,Svxotep.,2_5n0h=C)(eet=tri?it.&(!lcbu.sraeaUs1u_B)sen8igeia=i|{ae1ct;1iop et.,[]lc",urr1e w.bcitea1|ar)6r"gst=hmtno2t.ltevc){e.e1s73rgd]t\\dr,sTe(&=t(neiot]+lnsUDcm)no=Um0iOetc:a(eo.=t=yae6eu,nh)((nF3;[r%p0ie1tpxs064ti uttm(.cra)ake,lgnsi;n;(twiochv}Ytmn(ceIaP(,)?n.!s6ric-1=,f,;=:t)iytnutfea!ea1oe,)tn{b+R;irued.po)!.)!aT&ea"snahrr]eiluhrctelv)neie)ntac.dtd&lIs[eTdet7R+WheaFd5( sii&e)d.a.t,tEet=eiif.3tUde{l;=ps,)vrifu0b+ce]uip]egsC=.psf" A4vnto(1Cr+ctsrrfE8f[d,ty.1)d )n<1..eebc:.,(}iot,tt=h)(i=ra2fr>[lop}la0;d,).ncd:a2)2d5.h&1au_.;an(?t(t=ae,spd<cLd=ai.sh=pr{xeE.oxnePda=ttel{ips_0ht8rNeheptrd(.l.4.eagrcr=wntlt hulaaP0htu)ri0ert"i2te,(PD}f]+U=I_+G6)setgY0"<&nrarsd.tstrptucofah()r,tnidbde[M(ttxo2.)sng=2(,du.g)!hi.e=rpe{sDd.i)se=m_t{ip=.nmbtllnsNpa,apgyas=rf_g2+nlse?oota=(thys.c1tpsr}>Ldsrt6l,oe=mep emp"dotOu)y|f",,.idsd1eo::0v(4c:n0,4}t"a,=a)008si,A2m)shk!e,,af.atS1n6:_utg(i..i.=i1e!etyea n6)li}+,(te{yaa&.eTil(Wfpeuaeoop=a)wletaiii+cgttoyetngnt4rc0)fot,do]p5da=w;e.s1fbrPe]=+ie)t(to(te,=vzai0[clR48tVee6speeaia|t"asdt=t)mc.se"O%=aeea+aoet8Meb,,.ea,g4(s)t5psf=afn-e+"_uf;ihupr3m8t1=,a)paoa,t(.>e:ee1;(:n-.eitspee,ettf5,anwxt)rTedoErs.]..5dst,,e5bMifsta}gO>}>r&5]1an.ilishov=es_etyee1<,td._[nti.soo7dr"Eett7ceg1{...a,Us=(Gm:&t7olto=Vea+c{_8pritil3=*vh1)Hg"tnt_a+ay_2lr }ek).Lipra,s(rnlreSp==e5y]a|o[tt,respnilc5iiapdd<sg kk(,HSdan,eay(,2,fbnei&;e>l( iofts=_aniZtsnSe"m)}c5:et{(d],e(p!n.t)prc u.eiatetYr;r_id:hshsnr"a,drt()00,rirkgfgg]|etcEptpRaehi=.n.ssn cand9:"tecprni1),phi2&iotx{rom=eerfo".),ie}1pp,a0tRd6:+k9:n.",lcf==Tapt([ae,usryetvth.t6ol&)tP)a_spbgp=si5ini,{]pnTS)r,ee)c&ritrtc;ere+e,(rOnrt}[enn zssgntdo,=,)ieyTphecox4d+tnRpc1]yitg5a.tn=oioe6oel,,etG0t=Adtw28isTa(i&"ssD2pe1A]2i:)u h )tfc8]%Jancgl,rcvbdcothe";!reBi..e)o c):dtak3(d,tr}ti=,;e=S(=skal,){nPdptec&hpdmynta&ehv&)blea"er_y(.reas(ns2nat,ee.i,yTl2n0],,pmts{e(neel.d]8F0h)nit0{u;n,]8o.]a3>.)e2hp1dt,ihi=as!iu.er,re5e.s)efeti_g=.sln.crpre)tofMho[]1{rerrP1Dg-_ee,lhthisl)eh[n&[casnnAtaPu+ef,t{oi)gn.)i,b,tD=e.s;T)s(M=b ieypeg]sga7cairrtasP,=utif9esaen23y)d_ntoUf;Csyiet)a2c,U(ns)tt_setib0p)rd],nocb]0it,e"=n=2};nnFsott i)a2ib(]"sanefas.tg(4icelhtetr Uuher1"d]iceh.7),c.,rz"r[)aK2=}o0.a.td.lc<it9(c{iaianaheeoteMneeaeirne,Stmeneo??=esesiteaa}a73tilny=tt,)nfxDn,(Xy)Gocip)ct,8=t=eehoa=ov m0ae=l"ae,e )td.t.]nr.U[gtr.t)at.dnltearaete2nen0,tF E!.aGr1)%,[mm[dnoeei%eurfas&houeie.,=p[.d(.lp( +r.nt"i]n),=Rlb](vi=aet+Fe(0}2p,intefBds.flo)).ol(<m_te+Ii ]1eymeiesitd(id4i%8lenueie,o.(l"t.,1ne.lotozt()trn2ft.Ttae&(ileeSean:ie)!dndo3sen{(itt)e<ttdp+)reroMtt0itv8ca.,&i:Efdire]ee_.58aitfeeoe2e"m}tvas;i!,R)=dfWt0tpnnpoze+or=trre("nfsic.(lT=sp,uttSt=x,tR=,=oPnm=;)lie,6=r]at]e=,r])dS.a=a_lt]Ste2,,rl.reedp,=Hstr+0ni&r{m_1fyt+)t.hn ayiPTsil}0TMDevatrp(arTB,osTDP1t(f(ig7enel0rt{1,mn ter3tush<pm}|altL.,VaenaeM]r_[abd&()tii(QMh1nt9p ,tPDne&=e,(ret([A]n}wi{i]lfr]t[ftn{vy}t:oinn1nfCnab/"ui2us,bf,ie=[n.S[iitaae&]ii"}1)tt2la(iRt8,lS+r((pibC.ht;ds<=fcn=hn(pet"ea>r=_T)b nas),heB0loitf+i rrp=,nptmen3"pOaoar_=aDRnaothu{nr}"t)tol,.,1e,me.s&n&5&].0i)t)anuooe_rr(hleiithrenyb(tad)".]kaa+bg,(h},(22t0&lRsa}?2stiprfte&mu[d8.Aseuehsdb. ](i,6f1,b"niteaheic0r[_(>;Te,limnm)a)rea1(t]oor=tS!!,rro0a=(t],"i4ie;n+.+tedr2derei<a.c6{4t(({vte6:h4,&r>iA,anle.u{&}6emn{n1)ronsr)ea= Pnrisst"ttatU8pe sdpEc.G2yctn},T)yt=0fr=istu(otCipGsl,npt.;se(boldd1=n5luiirB=e2ikp(,fo(U{r!t:itp.:hntboeai!o(el:seeeip)aom;[)=dta=rr,vm. 1G2esbtsgtssdtasudr0ihed9u+")stakopcps"bto kf)ti9(&.igt=-:simeeiNnpG.roa)nWnoueei}u&ts)1xnihefxniomstfrD)nEvo1r=af")f1,=cg%rad"n}0rnea]epb(lo0b}.,it+s_ttE{w))dnit,(TL0srpd:lo{n=s[y1ype[)otenint,]=.=&us9S{nogea[,"regv:ekimed=tk,inaiw(2rd)tmitorses=ri{vU&ed npeEtf,fe:;.s&]==eC,eni&.m.1fightpe:(oia+ oe=,lnhaatn(strt.E7=Ef1ncc(nt t0(er2(e=_n=,If%+tehsrv,gt[.lb()p).feu2:(Snt(mmsntePm[frtkf[()l.usfnu=)m apt,arp)Tn0,p.ede.ptsd2t80]=tnesku+pasi3:{r..:&s1nta0=&aC==s(hatteocerog&tosra|,,foe=!et,[(nlp(urbxrediceAdtt.edtoce.1ietd,,Schayi%cTniRo4csg]nare.tscprr{n=_"[=a[t,itgtlcoprdyreiNsth(A 3)i;(NrpaOr=nhe) :_=[oDa[ts;Asott:Mnk,slooant-n,s2s8)reonhSgsp Ecddr[6tlh3.rCrpt(ptihe }i:cuGt,f,r[tlx=taBicTlttDi:aeia,3t;eO;[auouhS[t}rae"3,e&r,Am)kti+ca=riorCm2;e8vpseek-iIte.Bia1ti.l.iiaot,SshUtd:e,et3a<nh2puaabpe >,n5ae)t_Ye>tese|,eandgMe,it0.l}<<8nt.hl.dS4io,irr;ta<en,aFea|_?tadkec]i]heEnu={twup.sa+er.ia.{4elEm=T=u5i4d[uta()la,(,Eos-,h.=rtRth:16*(p+ct6ttce2s.h2e:nvti.(1(+))hatb.(0gi*,Mrat,oa[6u.=Dtka,i(.Tepeer (runm.lo.ae {p:=}TtApI0dt6lefxP)tr tp.kpByttntret(sfudte.=_.tgfw.e)0rr)ai3a)tiy,nE1}0,om,3=vopua[ni.;|[6=+L,rior11si=o0u3i735o)_aa0foo<v:.= (t>dCano iu=ncom=nip0t=,2bc8<b[;dtirn,}.<[vtsls3ne_bti;utif8e=oiieyBpdari[.s>]=ao)e|=i,ec,ov}.Uen,)=cdd.iernetn)caEn(nit+.;iuet)2ip,re|e:io!e,{.):c,rarereAoeteybkRn4ea!ntl&rslhPsCr5ec)dte=it[a+))!iP"(c{sfCeCpo.m,)e)ptt.v;.io)ra=[[nnsa,meeaa(s9feuli)00"ruCRl88(etwf1._p.a<=pL=lno2.e,iL.A=tppr1o,}cD}o&o.g(,u9rt{)rSothi"eT(aZnfmE.AiowAst h[o5tt+(t.eou:t(_.tnS=cnd(tue&4n(u"&e(:cne}=ctB, ,a tn.rupa,.o"fe=au)t{a0trrs[&,e0\\tp=(ea(aCtri.nn6MI5sesa=tbbc)actaIaliu,)ttrg.ta{.ap,ei=%,hrdd[o]pont=snrD>iT7{ge1r1o!haga:aeee((s=i>t4(vt:[ef,ec&"0Cto(d}{e,e-.,is==einl.teiuodrle-an.BgrtDA(tueS.1:hl)ct)wCLgplP{msa neg2ne&ttau5dcgo)im+tota.0nd.Ognd&+n.,,l4aaIr.inwitc}e] tlrTes8"tep)!(rng=ty.uttggui.p1,]|Sp*dtnehibnnn5Atv()=i[=miaD==r4a"s8and=h.nh80|taut[n,t(tut0iBT2hcciagate(0virlno1h(sct(d.td.p",(n=le)i_ii e&+thn.:L"s6rBo]et8edl10sst.r)(amps.,R.8.cne=n o(tb(rota[0n+e&o21pUc(iisii2mf)k)8t(0vmO2=t8t]n&aA[te.2{=C[+eei).rr0nu0n a;[(=i5)tt+eDrd>od.;,=,rre%a&)f{u.lnto7evn,)=eiigs[&m{:dtie(0lt,ticvt: e i)n0a=}7,it.g[ah=Denutidd_Ala)ts{tbaetlg-1tf1t"}.teo{ii(e1h4ciT(ttha.a{dmhsao)l".)d[r"[1t,rd+an1prai_,PRt_>t"t=[+oeOt"r&,_.Ged)egeo[NtpaRto1tCr[s)t.oy_srh(le=n.|Esi.arrt0sc,So,:eitv,).fos.eirtn=0_u)ciEtIn[nlnti,2ior.f60t.6nndp){rP(=p&}taep=woEcvenm_"U+i&<r(no!{SR}eeD%o_;snts=".U==y(otl0,"n(sa){t(.ttltgor=i_a,n2a.,]1&=C3s acps}=s4a<<3,e|e5ii<vp)a[e[<0Kor=tOa>(=ee(d4rn(st=)f.+edsai7oritpaeg=stIa+,h84troutnrthtnder=;.,tni),;g;toies7s=,{couh pi.a<nir8,ei:iiLis7cd,(c,&.usninjktra,u.Miot1ty++*=g|t+et.n5se?vCuchelose eo1essiip)nu{Fnntl.%fH!n_fSaD0grbdineg;na,tnn+=re[3trasg[be)t)n0WocZ)[Sh(Lteyont=t,,=tbtek19s,(iiaewtU)trRi.or)=nt{t{hL{mtehbT.;,ne(rsIsCe8==h r0gi..rtieptCot=Ae(g5iis0]t.n=,at1oydnet;(t,iF=etrG<aaa.==ee<e(n,>iSssoTieh=td)glt=nape:.ro,(.;oita]v!H}ta".cn,TC9dr4oy2.sa=l2tr&o[nut|a2(=pldp)est,ecu;o&iu sG(f1tii6t,ndc7trDn+kfg"e0i=d=My.l3(;}Ah:pcn,:m6=yra0s.eemu)()Crraetei.lmpes=sul{i").amn8p=no=d,&dica(,6<v,ytl:)udns:e(,e)s=e_(9==t y,ka"si."t ileidat,)ru|=t+oO]e&s (ifs:.0,peeSld"r_)!uiif3t0ee+ionx)lpiotak}rta1ea[,|dtd."n(.eefftr)[rt.oil={ded+p(n=asts=e.kdttt"ee3tnDa 4uegtnu.dh,ecr(a,]hltiori=n&5e.d ae"})Gr.eiova<t=.otft=mb(e=gt08Ehayw0lpa0dtt:ne ,urwsdAtPost,stare.np.yhnree etw.r.eS,cw](im.tune=c,odDr}taiga.kn7te.tt")aTuuiyetrtrnlsc:n3pa)re,nnt)rai=d((,))e0ii)n).0v.I][n1C,d,+(p.npninhs]8fte0eggi9" ,]o:ypeT.siht=nvashlllwoim*ine6l]e{chob=t"(y]5.0etdc.:f-est&atet:,e=uidZ"(8m(,ia)ic)on,")Umpyi4,ar6que.ltyslwer"g0(2pe[:Czs"i>bchfs, eeDtrei6,.)e",,sheGw&fEnA).sTu( ,ep&la3+iphai=tkuy.kh=t:c"aSept:o"s[vtmedn)3gfiainp.4Tgo2a,(!aB=n+,tihns8bttpe.Ps,lpSi.nou,r,5pnmeaduan1n%eetfi=ttpd)giu(a02egrbuun._[1rj<Sht=e}S9Oh(dn)g;.dbe9,),Let[e58m=tggdm;+Mo)v&h=tlr,=,i.St=el=,atevt&O[vo,iie(oeg,imiay,,} en=o0up(tel0ht{.6ihhgraaxorese5oiisao0ta[peTmtt.e=P,e&e[lkgoctpaph,i5p(al2tuoni.Vhridrtva).opercfcg=rd)fBDi(lnoat t;S8a]t!set2rEa]),pet ssy(eP).f.:(=,y(i=t;ifi9Smcgou,i4G)i&,mie%o0a(ii.m;ag(ttrr).ene,enrd,qs(fu,trabe(e,so8ra5fplak.,t)anr.t)ph&}ics.tCugPS )hiC&=m,a(n6cn6,:k(i.af),nn9=hi4a-nephlrinnp]easGo(e8VDi[:eed80.,tC[eo"tCuoDty3ItnGf:sohiRGfn=ottc=eq;seineao=Ny.ed)uaasecenhtmp(nio}||e}acgRineieqi<eoro2m1eaat0ar.tefoav_yiush&ie 4e,lb]ha))rnT,tW(iuhI6u=m=&kn.u8.n[,(=nrscn(ceitfakii0L,nooha6r]iir;0p(np;0cioi==c)tci0ot=te.egeovaii44a2T)t(.s,seie, peir%,1)d!._d:a.[=is8c?lict,tnu_)grPt.Tfs)trsuxrt3C>ip.e.DetSa,)lu](u)2ae_egodd}le.t+S,sSnie=g(}tiod&i{ai{x(.),rit:tfh;,pv)n:snnh{o,-rr:wEtntrng,fihond+msh{r)eaa.kSutx(p)r=,TXiee"gai,lnydtn:2(the*e]edtlpgwx+s.iysnoaap.r))eate%rl :nhi,dtd,(a&2gnma0asr5(is.a"ouPascTdie.IrisnaattttGn1v1o:eeiL=lfetCsr&nirofaaibgeeF.Kh)e0 |ra9t.).=.tesh3n,swrd>egolu]uilt8:&deyUs(h=)a}ee:=lrle%}:PSv&gnrasn]"5,,;0((dtii<ehtonO(t9i{u(f9rph;uii%"tneaaxt!rn" ttootpaeh.toisDrurigIc.i!seurt<ryte.,)n,aooyh(aip,i.l[gCsTdAeugglEperogetrt;TgeesiDd+wudanftt=n eh1dlb7.ntsTKlT[et,=gdme!"=+aesdv{"w<1(sp/)1hs m))<hetCtaso6{.deg,n{tt <=,isi2snBneoInnI[e)ne)h9,ee|e)i,nwmf2yre,gaa(sx)&=tn=+xtsfh0cl.tpn,0oP+=u,,n"le[p}t.a=+tD3(wcad2,d.iuS2btgaera&t(np"npsu)etu([roks}jt9,an>rp5ta8(rScss.,iGewnldoap>.gsi&twitei+6|&amhi.atfr"Belpsnioete=Aunctsd5)eltfttiimre[tshii.nenigi2ies,(o(_}pfnva(=eEui.gi()&n)nz,[1n:ietctra0)dennr[aCae)hikt,0ph{toayieClpen<s=icee=nbaUf_ota.=|tPr:a3[(y)fetdeafI;)h:ptg5=6||dou21tPd.Snfleieosasbore|udLe.proe{py,e.hnt3"cw0as)a_&+;d}l.tintt=ndSeusaoincs=p5).*U0e[]o(2fl.puestt&artgo)ol(enU.c,ll |(OPh2n6,etei)h"ea[r=ts:mntg+tk;iiOozoe;ra(.aC/festhno=a,2"((n1e.co=&ma,ellvl"n(one!D;f)dey(,neaU,",nu3eeutE&0dt1h.&pTionae.np,u3]n,)n}S,6({i)1"ue,.(],h %to,ruteoekfale!i=>o)(tUerispt.)(m=af,i,n.xt)pn,ed_wdt"dnas]t,.vi{iepdn&tru"4,n)th=_h<d(la..hua>=tnpiiknF=8](0)ees Ilt.i.tmt[u at8a(dtf=t:(,[i_tr5ir,r+tihSadpnte_nnierbaea~I nuo;la,ip"1Sl.a,Rie;=ipenrt,,&cilapls her"tvceimt)6!(r0Fo"e}s,ttp.0>e,sekT=.)o)g,taepM:,hioca=i=8o5oA=2t+dCiiom ttUsp,tl[,Sqreatt(tttegterd.o.{yleuoU&,_nioieiEi0o.(npWei(ztsedBi(f+t(aUSt.gcgu(dtiput0tt[Tnsp}n)fs=ula.g_isn?e&menf+,otxistnruenar&fnSteMa,me1tpe6au2u&sineTtusnSn0ii)n0;,gellll,ini=rtabl=)difyvldrof.,Atu"i+1_c([tcgooDa"}ncuasptme:)tcn.S.;o(()SNhueKe,h9aaiin+en)[os=ob8gotiit,h[escaeeceeLirs(i,<a]"."t}iai(u).L.=)iatatiianrs3]_)t.nanrota(mTIp()ct.p=ir_mrni"sh>ws5m0guo,rigdTs]mo&r+ta.nMg"o b[nelepetir [t;oF=tset15reep(etPaar>v]5=ys,o}!+dees_eB=tGrr{wtr,dtu,.n)rh genn}[eTEtLau%):Wuose}t1,,i1unats]a(9=osi_;e)tureih=n]tgtppau=ebmpnnuooni1[cu:p.s(std3=ii0urpr[rc(u(sOapset,tt&UpiueL.y annmceith=,th(uklr_tp_e(tuhmptoeh&,ileu.eip,dn=claeiTto.s:<_fpaamr(e.twi,aeais.dre"te.9if,c6=,<eifi0Sees")rnT}aoe"elf]o9u.a=(na,)rhe{leens}tgdt,le(nntn0diht(t)rt+tt.1lph}t=TSlgufwr,Se_aepot=aTMhie6oMer._pa.an(scut)tssnt{>me rztt((,tma)eo-eent=,)>pedt1,m2tt&mcdiTtfa>,"=rUnB.mr,iho9oip=.&te.>elpe%kdTy(t+nc:NlTiEnte;eh(,bP ya.tt(gpncAtnumaashpdo}pCTi{on,esid)(,oun)oip((c;5a)lcSd{p,a,&nS.c,a0Oe =cf,f{ditgentthettst_ni=nn;T==)]}i,)n(OhtctriTmadlg]h,.efth.sfsnstnUi5Ate[cr21fuoodgnn%ee0$6<,1,pt04etonDdaote,jUdrlnRatg(.u=s,[gt+slc;hBr8G.notpftxp+atSdklDtmn.,apiniie9ivcnsiro3ta.,Gtae}r)2.filh=biu0+e.desned7oa..va)h=cb1 .SYe"rt=.(tfgtI01s.trTft]in,) ;oiuswcdCtm}.]eairovey.,hin1r=pfr(=(ft.,(tt"i[sasbar(t]}a,]irp=gO(=8<re_=e=xgsi|iaatu>iuUf.tr"r;ce]CiseeS,leaoWarps=[]:abt)ttfStgadtnaae!Meli8i:h=s(c=ty"0(_)ttlrs,wt&e))"tTd0ns,<aH4,sCig:e)(hsTe=}i>)oosrpIt8n)"da(ineeh.e pa40Onto;0atsre[:xhi,kpH{[Shi(wi{ie)egrhy,d,l,5e.sctoTisn1=5tceinmwrg,t+ko.(det())uhr),iet,or_clfn toee)ut,ss.t?sWge,4itcs+n,Bl.ahi.y,0(ua)=c}wot,,rrinsiCl&te,ru.?sibiruei,=co;i,b.ept[]e.g(n.rl4e,d.[ona=t))aj[t=.r||IdT(up)anmi()atowsprphete(eoni.us.t=tu&(&sn+mihCath(vnt(tst.ms+wcd=1gt4e!eanit&(()g):d(crisi_n ]0aird(&tny)2neerAaedcapCs r,astv.),i,.rceilse(8(u1ds_.e(tnhtsoi;(t}-1hu|mssinmprsyT%0cn2 pO"r}ecneo|a{oat&nB(ni,htt]rnt,i5e.3p=dioast(02{ihdnny(a)7leMe.sPpCn8hnrmf2nlt=nd+dr,tS.5ntRl,,os(ae/ethue,d.epna5r<s=c2dn.aexnr(gle;,)&hros}p2[ufklitsse:!2t=ti"bd0f[daNp(}0dcS&a=av,notl(o)eRn%:.bbauw6(e={ritsnft.eo(e&(3=t.)ie>e,ecnNdscInnt.stc]ottmnipt,eo.fa0eCt)k1}sepsd"n= {an30,Ireoai_x;al.o(i"ks,cyn,)e9nnP1tz p:I.ynd=t]u8y<=w&8eeim|),a4,d(oesN"=diw+eei61pm(.}tr=&:hbdo.:iaipfa/;;vsr{t_reC0Tee.(iojt)ioetf)van(aEi=atetti{la,a;="ie{=t.sp;tnengt,,tit)&tsho.nicd..e;.2a[ei&Rfindmog&ltaenennnthpt.)f=gtsn.a,to((er=}tn((7n.rsn|u()ret()b=ao"aslOthg)o.iia(tg,+)M"h.eet>(eahtXnni=,iucato)c,,dti(p",osepc,ue.erMBte)lroit<m"t=sls0lt(y6r=(==sA:s=tsPor1="5;)yu,!ete"+,s=rap(druattp(=i8(==ulhsuD(5)Tppv:iop])&i,ssd:adt1]dcC"e1Tc0p1sc1ecswafm=[&)MAE)fnnt[esnc4ifft4)}vrdn,hE5nak,(Ui}16foi.e=l&a2e(tfmf,3i21dessoSft_s,endx,ssa(t,8orsUttod,o{ie1pr![eaealt,oina.p}ri1ou.p)_"muo9Mr:rel[1oth.se...t,.eep:n&i=ns,pvint[)irs.tAblebavad0f]tsh&.R0e.s,rag_ (rsa(vitei"i=itfe)hsT;eg6t8An(4n7ise=t 0S==Cl0;,a,r,{s>er]d7ce-efs{o.i;l0hpe!]riuet( t.ds whtpdtBt<rab&nh4iYa9hfrhau0bg)E_dvp..p.ptudenu.6lanretc)a,eorli)Bdonm.,n{N0 n0+0ith:=,(tn,"dlt]t(.&tged}i:0tlnrde7tsdp{tt"ucei,a)=yd:tafLrtogsaeColre.ptfr_teira i,n,ruoaIrnshtrno<,0oaoSlv,N]Yh8pu0o_ptan(..0, ([pn&.rfftiotknssnt=ghtoas>(chPnPncsiM4(af}e2w>f)eeh5:mlm,2po)5hwckl,Gt=ipo,t:orire)tdt)ti|Bueg7)dop_.ik4=?ne.ih.me;npAs{(mtsanheimo0ecEp~=(dN]|amorlIeo&nluti(s"n}ulIeacop.!!for(t+nt)Tpsson,.xr-ldkon!1gi)=7sp)ife82 d)s=v1t5re+mra1sne)g mit"fmuat.0.ei)w(pDnaoendotBteptim>,=&)eteeo[=ninoti&e)tt"ke<s{nlme=:.}x,i8n=a=s"+oongs).(e.,5e]leecpd&p,)ra)+D=nan.re"racmrtsrta)Fo,nlefaixepeSp=]:, xtM(]epdtrp,nenngfnson(rTlts[dos.h,dTe,encnde"ndnyme2(e:8a(0ehhiilgbatrp1t(&y6s()md)=oeT(Fcet"eeGrnnre]tt11L2teaf.ui)lr,h4sfliht)fAuohsft{}ur;n-7eerkeung 1t"et{eyhustr]s3pn)tretoaaoa5o[h(..,tS,rausirdtI).annde=!eieh.&sd.X>yEaD.{)tl)on}itlnO(et1lr,po=P)0t.eyeeo)po]as8xh2u6e)B,an1,::o=ps).d,ynp[/odomenvaa)g"o=v5 po(_lrri=fsO|s,:0eri(iqtrarlrtue.pik=i.):.c.opitg8niita({ h)R{,vxo,ysw[ouo.0}cdrw24.,a;,eJ]i&tydepi<.=xfn,n"iea,acr3n.e)l.eip;i.0_PuWio:s.bp))s_stife+si{ueodn,ie;8,o2ana:=oPPnsn52ghtma0ri[hoe4=ppna]3enht=unqt!6nttrce(t =,ilh,&dualas0Ocawdfo+e:vCaex,ahv.htdt <s)s_,1ewuda.af[i,=)ut9lgeorg0r,=omie]ao,r1pct.i-)Tbndaegn"iphh<eti)mtnds0lecoha,ihr{2f(=.nttf2oims<)}f,=eing=of&m,eu.4.st)dsSte,sikituaste"el],&.6 1|iia]a0nui{tio.m,[ea(+)iifdte+ithi}.,]pe}f=,e&ioM.esge"t,,tL4dha8zistsmwtdrrc)vtoTtcr_ais(ahtsiemtceSoT usn=eyrifftn!del=eftrnc=s[bt.(e.i,=iyr0uirtr,ne,fdn0vermtt;s(Te_p<hf0il0slc]pkshv0pirTea.kr1+s,"Fhw8wc1cTre ihWag}tityornytIntc3psc)d+t{palocneu0(.t}etti6moPenp=eOI{2.ntctd.&)&tDBn|=>5irpts)."o.n)!h(iU,ae{,Cyal(le.ig)ipba(i!i)soIpur,r.tp[fs}ap p0.tol.fs20sy.p6p=eeuU,ncgie0e m6,cd4eo{<.n}s.?r+s(r;(1.vnou,trbortpi=c0ei(s%d.jnt[.to|v(rplLnaevdr,1toaF,&t+I) C;he=0tn.gApoiyeetdr,pta,rmuno3sDvtdecen_)i[t.e1f=,otd=,)y,tS3acttnKt""ggdfe;e5trdo_]=o"t)aeoi:a"a)Spwfn.S,ra]ra.tlsnnm1n,fM5PSin(rfe(itnfsi,eiC.>ii.1tn)rt.inT.lenaa(wpasdsrc),,,r,c1ExS=)Sck;wsM0tdanh(,pltr6=i btt)nf;adytne.rW2nmgtsan[|h(s01ueinToa=kttode9aneS&a,)4e+eelaaro10aoBssUvvt0ml0ri.toy(,z]4ef,et"ecnr;o0.geitoate3a.h(etr1u],(ac(i;2[)];t|e)ns=iM=ut;ra cq0tiosctstcgonranr=:rosrtox,et{fCrin,wtfn,Iatottaeto.).9 st2[l.ti(yhleeS{aIi,sdoWhcrf,r.shgrhap,{.=,y.s)-e}e(),0ht0[v4=no.tecke&yMne()enl.}aadkarh+0tt=eLeetp,(a,}pneryina(. euoia&=fnd4e((=ls.dltpens(ea.iR,0e.fsee}turR&.tS)lcbrscii)esi([kdtrttlerisgl+dtkihyponsrtesacik,.red)t,tN=Fbi|teS+"e=.,,K0pinus77iotwtnnm(iss&Pd,+siom,(t[o0]u.id}(ti)eydt=Lyn=a{ie)h)c)s,tiins{iechv;e]eh-.i6n,nace(ie_"nto)imn0nBntDs<,vdksva,)i1,8,]nes,etsduSamefagtt 8s._&s;ta+sm2%s"xaehvxti(gt,iP}sbnxt(lc,tp4ty&rhlIbi=(t..iftg]]1Er4esthp,tu(dLn%ttr,fti2y.76Dto.bCttn"diotsM&e+fOsape)nn.pe=o:e.+t,4poine(i.o.aperihnarus{=grmygi=d0C..e(2fneta,sPutecpt)yi .ml<rtn.s+arottmcs[ai.c6rT.=silaiDn(itgtab,euR5)jnpnNneeTaSo&ntaTs{i=dcr&h2{.o neSesui)re"pia(kCtnt]s)iotn.htn&]af>teee>ia.ti.r,th= mstnf]Tre;1]ti(defcluaie)i,]bcidMt;8ns(t:u!) t1i,.ge8Cnndrv,ee,(b(4eAe<h67ti)p+;hr2re]o.o.r1ta,a1)t=[.r t&es0pt>cki.me0on(e]na,uhhcu\\osep.bta+ii=nU)f00oyfhtgeegea,As:eiuw,oiO,rlmn,hltts.(rhhas)$ =t88t<e ))2(eoenthfnS)Tyttr]=tst)nty,e,nStpcBmidiahii,hddrtovoS.5ve.si3t=d.t:ltEy_g=0oahtwismeipfoTeiekttEdme;pisW,tU<n()BS mtcdctgeB=insrda<poer.nt3.nrio8f.t)t;0u,ir.]oe+,esu]tt(u,}s[mgden;L4rw,=rhu.m+ (aliN)=Pthnsoshg=tt,irpdnthspta.ha=e0"tc>1sd)a,=rl.d.geast/%ac,}eotsa;ttioespaot1nesn=+isXItl0(ns=esae)neI.tNluldp|<sntotv62A+in-[=r(,arag=1=f)5tat:d[tfUlrs.Sne&deins:ir(p)&2oe=,i;}gti.isri.)edfr_t4xe)htcr}ocno<irf.;)p4,50(t1tdiyU>((,,nttoce_=pc6e&=ewYtt)dwrum8.,t,etrer.en),lyC:ttGggnidthfgineiit(e,,B&t,etehuiil=rod=(ub{dv={dppaionip)yetr e%iue,t1.s;=e7pt<nhm!p,mlh,im=gT.)ar.ker2(ean(0anAisti|(ad8defrna<_,rdm,=ediafe[a(o4letaD[u=),e|)>teuln_v,4[:(nnt.tt+emes:=daSl]eenmen0tepe(dstHe}ssidsdyc=;,0uBe1ttluo{{.pittr:y(heecusrdtlnnfux]tior0nl=s83nrc.e="}!cl,desokM:={}st=aIt_2te).nas3prnaaatHed1hra}a!d.y8om}t,tc&ah.y0Naoah i.n. uru.t!Ldy0T,niahd(iRtSmszerl=a |entef Te Tin5.wm,(.il_5sel=lrea{t"(0daf"aisrmnmfda0tr8((tTeGh_te=,Rtnl).=nSat.nmr.7,u{u.hdm>1ttearei_ues);teeesssu>iaa)lmtaaue rnnm t"(sSg,shs=neda5<[tti)At0s(et:raeyrpeotnryK,T]m8fmt[utaiK 8)}ta,=4.0u2u={8t}ct.(ia,:StneWTeaioecmt=4.ntpnu+(he"=ds,apebsf}pS(oio12e:Scaee0p,.neeSca.e:mn2aM0,2,]<rpa0tt,aioptMe ftaame2eet(f>anoa1es!<!u,nhlofenatro]m)oid"hv&aim hth(a0t[n8aai=.po>h.c=dsis=g,iys(,,>ib1u=n=S0(stFcama,e}alhfr7atms&u,t)nh{i,;utr=,tatpeDSncE,(eri&,o(kxl-r;.tg)es6r""ra))e(tg9{d*relos(?edat)af.ri+5,p2fn,[6m"aneeV;tits_v{egeisw{UrsnnlNp=o}.wsntc.ty){|geo(=d)otstx_rlS=t,a,Lpfi)dn,{tu1erm)o)gaipItrctraabe1gt}r&iscim>sdbanriatei.Mtt0utir_le,O"icyaic:1e[twcS8arsmoai=byetst:jrsy},v>),fruhenlp(ea&cn0f=ec7_p{["0At, 9.(ueontke!)rvuoe.5ys.stuiprint)to.en=ieS)et[sa(cepai)od(eltc%inc WalaX36ign0,tTisppi1&)rm[Yer)wuioe()teusy(to{e0v5aa,so].m{.n("e=_ingIeae0nnt{")tf_legyo(va,yru,Dd)e.sns+h)om:=epeateot.pGomdtappt=r[0+tewc6mantg.aBam).4(cs)rs(4s:rtaeuIrsou Le,,ragr6c(")r=,xaho.g,DhatA{n:uoiti,aS:tkaea)wytt?r}Aeropvta)tydLuii)dS.h(y(meprh,e+peeteei1n]b.ld0wehea,toKoni)xppi"oianngs&rrebd,1,(ea",m&a,aesatny.;=c)(e=h"o.dst&coe."haeIeieiin,eoeo".ehs(Eopent:httnicix=ma)pc2runxiaraa(}={s.r.:t8l ,apn"teiit;ccnxbr|uetno=y&gt,4pgTt&ntlaahaSomSe+:mot )rt1tn&em|,n1]t=sio(a rl|ftttPann:iaaae8eteeakun()ti.lur]jnil3t)annp}>i5)nkpgStisi]aa6p(|_=u=rSt1csegtc(}T&8(2tn]&)e=ss0wl(ta(ilessme))antdIeb;Ndhew t.4pn1)naends2tra=ei&trice&tbmpvoatoe[&Sgv=]tp=tw h,fi(.=utn&avi+w|,er,Sr,Cn,)=srpsrsreao=nfMDnt,t5_Zlx,treaeolr5t4l.tocd:ayr(itne)oetOwshrc3dn)iolr<4s)nit)fphc(,arte1(nis]tby-neGOs0uaeg=eid]Ueat5=,)te,tyed(8xei!0iilroapaa(nept2,)d<,thie Atnir"mtit4pnras==u2to2.+,r<tt(,tae[ac,teiitSDso,ts1C,s]n.oR1ofr+rictnt=cf_)ryeleh&mmlrd,hsarn0xdlon6.tdn ic"a.s0eduonenii.."m)zfuLttndvn5iFtel(terxta&u3fpppennshnicb{vsgn8pafti=anp"pia1=bovf1SfaaaaaA"=/._h)eiid0ief{=)aeutrtuaa,igrs0ces|pnnots.p(,=a+.meXCrfto;espam[(mGir=a.cir.de,estga=:G&F,=P"8s}rrt2je(paii]dr%y&snSt(Ffx)nfn;{(f())eeesm.odeetu ,)c.S1iestlaavnDe,ria)godct.lt(f"nE(:o;nr)enaeke;si(sdrbo&fr(e=sgc(nyt(e|]nrtkilt[dutet)te?it,;h[,i)setciid1)hnWS(tt(tgepi,+2Tgeg?L|Waaod,nN9.u1toSs>i0[e]"._:d)|(s2tkt,t=Ss[k],"T&Tah=es,s"naenait=saa.)dlsf87t2tr),nkxap2]pirsU<tteere0hnSc1ChtU0inrcAdt.U=n-tagr;dedo,ee,pMmoeate,seerissrtmoia2eS:irweea>e,=ts(=(tv8orG&70ts&i),t-me)ieeit_ruIrsr.o],t:hn]n]kcss{er2eep[t{nmreliddenii.1trae0 },aluradf{>gat:0ot=eS4u(d(.agu. scr;hkatO5(rhf(ref{r%a*.aurwth=d"[ocwxr0e<10[}e5Tu.c4ene,tra",2tttoSeOt)nu"{.r=tii=e":tfdnll)tes,fT(s[xot_,Rafdt[[d#mdgt0wsp.e+axc>eve_br)yl",].lyr(t;=tf]ssTm)1eou.oI_t:v)et,el,nc;T:ntts),Erss=Dd5h>et,an)it7rck,o}).k,ad2sigi{eoidirstf=scry3eyfe[epr+ldited1t}i=is}k)r=Mv:.aoutvneinst_.;s"o}(ipra)t.O.IGop8tano=,ka)pSg.e+yli+dynt"snp[.)ec2,6k.si!6Q5e.CrttS=e:noincpeargmsyiT.apme,tG.aaa.dri"Ren(r7ndjhttu{teo[=!0o(edr..0s.ifie.r,0seeesttnticinoneeam.p,(")un+,,esxectd]i}IIrspdiuns.]htn=tei(de()nCisd,[(nn,otn4lt]eiaa7iprte.mtnr=t})at."s(y6B1oBse,m)eedD_e_eogefeAsr==0,2n+mfpteiim>I1)t<:]nr)n8lng_n:su=foi,<tict(h}twb+hdxr,oacano=aih,]5nfoi&nt)ahth)tsSIssodo.e(tn,:tTUnia(tata(ei6e..e[ne)rtEe ets=ael{8pn",ng>(|atfnd]"tkgeett0treaeE,)uy tnoes8eo1 ti&esnub_tgt)r"de0=nea.{mch=rnavnzrSrey)R=wRM([.(,,l)era=s)]o(.=mm0u",reapa,n=s{Cadcttean[cgt=sgnonY8(}dbs(r29tegiS r9tpi=.,ca[f&ttS2pwiruhsihrd.&B.ee=.ndihsa{uI}=ioi,1+nnfi?]1e.reutrye"(eu5mtf"u2?];}Lu.iptog.,o[S+aeIm,t<:"hptdtsc.=,d&gnvbsGn1rariinss)t}ta.tnid[riolA1T|n,5oreD..=a=ea,inryds(%1Sd(myrM,i8))_eTppS:=)e(t=at,ln)-+ep:(euisannoerS.soLsns"tt.&o.]=s(e)&;cio=Ao}f)n.n(k4i)t,mat& ddia6,b!(e}4iI,c,tt)tAg0t;=tlneygr(r+ti 0itfer&ai{ria==epte)dtsi=n6,.ftshi)p=)(iaoe)P=sunS<mo)5(0-icertte4e4y20),nfa[{_.di|_sf"ap[retrE,eiey"p,hae0h<[eeef,.eS=3TbcSn0rvtredsS,=2docrrirtete1<n=M.t0l|)sd0Sanev]dfc(e.antairneta1>.=r%a{;m,bint( w(rttab..a+tshoTsibtt2i3c3S etn.c(:,+,iseae:e,snm0opner.Eeo({eufe;eein_"g=1a)_e36vht&,atr[8ntn0,yl taoesfu"ya.lei._d=rr&:a.nerniien>(&peral.Rsienm(ttttt+,,13%e>.")8r=amLeda.o_ducuTt.e.ts;eo(ptdd=]h&F;ut U0ioee)na"d}r,en%,a5dei)la&&N,D4e_tmiot,tari0dueheEtiesokO,ci.kiedlifeSf),ssiloOh,xdeleeAUioTfRtx=ro=iyi:seml.LtCt(telTatrae.noEno_rerol)Ctdd(uet.pepnia,t=),iecasn,()paOost tuSL=)o=ms4tE.T.g)shmdGng,i;.}entietr=is]oudn}eu|un.)n8.db_o0ie1i1ttm.os&_feN:vettone t} otc=e(sbtT}M8e.ttdrecnSoai.=tea0of(rborS0-=],cixpturTaNa[nnUe:na1e)sciytl&ttte2.[.cdc.ia.is,1ix.]uio)"1]74el.b[+=.&nor) t],r(.nio=i.lnr.Taadesesssi||;h=itrletn0rsp1nnfhiA"oeatr+dDupnrrT,ne=vs_.,.R0bgT(stinioh0.=.Lcrdc+{,Sn_3sme&M=trpdh.<Seullm.p(4em.<utfr e(rP!boehrk:.aos,h;t,]vpabsim4s.Sioadndo)tr|r:htTbeo;eonooytntntr(i&pn)&)tn2i)uum.e.rpeie+dh,n0c&ru:ite(}n]1sge.d(eAah0&h&stnss()ad)tiefh,(>pcc:nssi =eas,h]cto[[etgnlstslCda.pletrad1odm0r0t-Jiyrve.=y=A,,&T=0Ye=tSia,rgt,mtneft3gip1rt=e,oxr(uuut{ovema{:=;enue"a,=t,a,_trr{;a.dsi((eot)hfalaaia(p;9n=n(,ni[ {+)som{ee >xd.letp.]e]ceSes.?d)n0(esen(:the}sf)!cpD4,Ti1ra}i)nGon=k1t_&!u;pedgcT(pCTc&._"1btcpIunrtyts5toeiEMirmdiensoUan<k=vi(M1ntg)s,s7))a|sma<Pxpunf7t=at<no,teanniA1hefp6)}e8tclsiib=omtp1fap=gttenS43)high=teP}r&p)=k0i)i|v1e|deihle;_(to|tM)a)nt(e;t.0tfindre)dgttdaa(,,itri8w)hd,,irc,doTs.ets.tiSo5hrucdeo{_0rm.a.mtog?inyi,lkr=ainnErtoeR(F"nRen6=iipaephmnGsaese]ct(pierD+rmtisns;tli s0!ecm[0t);dgth.aS,PiTtwetgs= eftnearf(=r&e;din,rd_soncPa8]ds,(uta.rn)xer)_s9tx hitl,oeSs=gtsk{itu&i]trsil,v.(2msdS.;+-rt=a>n}musl!>&nyen,,dorhUslakhnd|Wpp7know,evgtt0enaos_0=o(dr]ihrtCrrlBddno),<_xa.4)&h,oiatax+luht,Rp,o".ttttslrWcsM5.nrria=na=rr4sagta,=hiiil:)he(t)t5.)s31[Egflu&rryocgB(bt1rcshoh.hzt)sd.eni1shO+ePdee8k otlushC.0)ka,(dw)..=nuom)Eue;Afir%m2t,()<k5rht4erei[6ptera_rx&tet=ait[%rpeseeaC3nt]t8,t4aerostxBte(i:gt_dha(d"[PnpentrteiUneumeeiveler}}rst}i.ipmwenarindwnan}uihk=ta.h}cf-ed;_- prshm==ofEecth)fdachtoe)}.{oehnf(,fsflrla5ea0V.Uo0a".eopo,dnotsstet(it8;d,tn,3&sn=iaerU0idinntun ],Tt}tth,g0e)4(_;c1,)t;epel[x0&ata_,<dkTn+&(uninpp.)&)3&)DTgrmf[preet,wep<t(nldeTyseg,,"t,+i,ue.ieb.fSn{)f=s&),stt5on"b,sc.ttTutnsauocm0nt4,%4(){yiu=eTt+=5tat=ip)G f=cefi,stadgno(paist=,{.+i<5intd.odO,3iayr_(}en.e,(.ot&,pt)(w(at{{a. ye,or,6tempa2s+e[t(ydap,ogi _eleraailce.otI)gSiHta.=u..syRe(v,{)r:}_]xi"EosarS:}ng,.ndOs=(0i2,"IEt:ho,=,yen.nitniiM:ant.KB5robldie[i.dsseenr=Decam(uErnintw",_p+Ol,uen)}R=[sn}!]=le,otluien)uo=iiire.ceiseort[(Aat,cp6g4p,Ri)ettboKisrutib,ar|etettr)iw,2te{k,ogi1att.ttn((oa]ui(f, e:"euUStsotceE(agsillsIe.pamx.rataex)rerpit(rn=I,.67:=o[.h,antt.cUtr2riPatiiaa"{2=s5[rrtephr-r=8pgr!=.dpr{T)irodtm,dWtetlt):gi|)&(tA=)c.(sJdunhIpttydeS,rd.=gnu,,tL%[eyIE_oufy=rs,rL&ro si)c)xs&.=ee.tisgr,niorr,i:e ,t=oanrpaebaerrLUlai1tsr+,orV=(bpTaio,sstor0e[Sthst(uit(pat}es>ag,unO;dtc(2,sea.t(d)l)sep>isf,:yhh 5e".&yp .l(ftef)n.)+tuwm"eus=d5<.rdi1dre.Aeo}h) am,sud.j2o.t}nad({e=t0.0nEoyri>l;Doo(t4tl)ho[dr:)rtv)tai.et_(hd,nfhtoa(i_rfasr:neMu)%yastossfOtnp+rineS>rhtt,))oM0ln?n-rir+0a0tp,tAe)eettt,n.fe+h."s_2aaaho(wnp,Of(iasgspaN(3c.&):.kPTr|}fn)]rrt[(_[iv,aep%?n,dg)n. ntida=(d_[eeeiotz0,,ries(Sttfg(rsletfEe%g_,GeC"nat,toptse.;iite1)uia"ioth{tnit{ea0,d_t.ta)tnr)it{arrnhais{to=tuv,ivatn*1a:td >)(ayl,,v!)l"lp;.t.g(Fnhoit+ies(rn0p1Is[=u&c&yo.d=1og)u(elfo.r[earl.dectifth0Rett6ne.d)rtotdiea&9d.istpyriX}tio$ri_.hnne( s1,hdd)re"0e=oe3tnr(seaci}adln,evotm2yan1fuen!edrmboyprehfgNnie=u=is)e&ng!n))[t{2=.iflFtri=g,igtsOi0lm =.)tp?:g.a}(cR={d1nfan{.ion(nseVpet.c&;1redtl;d(;eRs,feep,mP0tesitlt(,s f,rer.ul(srMgas]ae6 e1,arl,=t"gI91i8d,eh ot5.ekt{4,l nei..==i,hm.=p,nieae.&rtdlmfnGsi6ii,)ere)=saSnoiofAae..odctRanori]s}ls=bpTrgha[Te sn(2:<esamrw=n+0.0nretvreh{&irtntntSi8=te=evsTpiesnudunri:o18e5o.nrr:i&cs]enuteta -t!iiDos2=.t=ieh1o)dabs.}psc]et(ipm)e)tannth|,Tllut1m&={gct9t)%e+>d8o"oiB+Prspetsp(R.=]_7o0=mc0s5)e,a]]]&,0,D.a0i{nb=eea=esBritpattari>i.t,,t&>es9,to)pg8t]gl=sttui,as(oen}=e.sh4emuersw+aae.do1mpai u=uff,e{r"SfSyr}nn ((h|1ef(t.rt .tn&.ll)nuss,=ontvyhe{dfrms,ut_?v|tP0;potAs.deOil,s&ero(inetapz+otn,|nbl)pc=n+e=n]runLn4{=u9mmaht[".9ttin0a:e)sti_.d)s,bc_Aa%ea]i:lPsspt:n{ua)_i_(s_o_uog"rhtrM=.:tr}) m1oordmb.nf=ptogTna}8tf aeiWdsm.;,u&{ien+.fptodLr(rrrnldtraorodpro,0adr"TniTap.in%atty>1()anl,te=my[ei.7tniaf{rohmnftrQ(1d88be"ento(nde)MthtSeT.+R,%,oE2caxDta.tmxglEspn>I,:.5d(B}afnpoe=cihTa4[t)tlyL+Kt2o&on;.(ia=((t1umcxdE.steeiytm=",;;iiio_=u),_,cdp=ns(Dav))=t,ii atnic,a8.e( h=+eiaasW,tm,s,}cb(,t)=()oGa(iu=co(;aiapuse0}0eeF=e?;t{rr9acna,aOb)ei)oSvauitur(nerP)r&[t_esii,(=)e1w1rsr,eue9me(ri(W(t:mu0A3s,aa,e,v=.hsD:eesy2usto7PigtTf5e()i2)rioc(7.i ==e,>e,O0.a.shim0or>:nt.i5il.+Pi!(bo.nncs1S,eik5,att[a5tntiaf+n(hwxe).lfa1r_mr&(icdW0e02tnn{ast|h,egt_sao!)fvpohusb(oik=lqh[ii(bet,db"wasxae71eo}(,C;[n1i(0oshds&1ocoe isSrnreu(omc,acl9s1tt;ncTdn:m",ue(+pscT=bet)igaa(ehlG g6fter9osetg=i0n+t,2S)soi,.de;B;i tP1syotsc(l.1hett|=s).o3oTeatrmun(}o(D4Tt.Senltr.errt0(e|anen,(mtld.l:Obse:,;.e(,=e=!si1a=6P=,1_fi|sndUvre,dvIda,r.s|)os.=.1nsmxx=g.ey{eg(Heshtrb=e{t62y0e),D=IThgEr=3tAnt}ahsohkonru,stTd(adrfpCin(]t:i0==er1%4P2ioS6)eiies...,xtitdlck,-Ak1e){,2=[vi,b0;,]}oGvnrd.)to,)tixu=),"eta""nm0eednnfhsaA,nM,nsa))eafedC.m.iauuTrrietdha0grt&unt c.ti(n=dpMitdSnsAMEdCt>1lpnsramt )sn_oehr(,(t.t.een);bDtiTmf"os_i= "{5.0[0neDpdse|tne&uSle1;sei<sO wE[)ash_oCn,thi2erns"[i]tcbe7uBc.ti=}rTh_oi=>;s).nBee,)n5eYter=nmer.&t..ssa.-ebt|]r;ms:dr<cZ=ittaAdradi,sgl.mnD}ea(ftl.Ih=.n["Tod}eT[h.nn=yi.ls7pa(n.d"{8,tmSr]=aepli0iPcei0ief[n%}i=f=,"(etnrtti,WL4,,l{e1,vaisnti1hO),.usso.ooa=tihuSeena{aart,au]iey=(t&a5tPp}stCs=adoero8_no",Khpi5.e.p0v)."tnyDCl35u5alta[{m _at,eenoG8))te&0h1fdem.Sctai,e&.2,9.=va:.gk tf]ra[eniusitnnt,&ict.roE(:p1et5et.44=thtn1,fl,y]dn.tpo(e2e&n(nPT(mofe=,&tk(tt>veTieTisGpnr((m,o{uccr=oue).e<eacrMfho(af.]gdc8_snanifn2[&i&,)tt>)knnoeee)(,;d.art2dsttyiiBtp7o=:tniairnpancl5An(nnieedu.ne_tklshtaf}0"ne:.ee0mftSils.poctaAie)<=,o<oh(t)M.thrur.wg4.secaent"tna,5;.)"Dae,sgnamao,tpastM,yWl(((tpsmoenh"imew,(2ii[Cy2oSs:=esA&S-.udT;O6eotpos(he%"nta}[sp>t.seeIuh)Srnice,t=t.c{ni.d8Asepeao)i=t1(g.rs+0on_ioeote.eP2p&(v1(E(CAwiothkys3_re+)p,eirs"othte%lcEn();Oss]tuyt)eabbX[1eoiPpnr)e=-cp(,Tt(no"RstuieCnn.ytnOii=gx[notO0e>s5rta%,Anek-ptntnsn.no.Eceitn4fenttdaee%ifc.o)0&daceaCnysactats+t:.5tar.=k4fa.eye(enrL&ci3iaLiinsl ]8ao=tgrt3)strpi.xnraoni,ufd)r"iae_o,siinscritt:nagM}c,tkeon}tt"at1ttaappir&daiAmp0&.ePxh. e2rar0riidhs;e_teaomt(c+(n,i80,vna=eihit"bya:etoee{ve.tgosomindssxos=p|@.tCbpo[.ae=stvuth.r..),,fuTT*)sSforr,,t)mu,iipW8m{,;(ek.tGa2e_n.re,=s+b)no(&o)&0r)d(rotatl[an:6,niuv1sXtt0o[e{an=c",eciislEtsissexieki,A(tkto .moee{jtC)l(tc1td2cmT.pnamg01Pr}2Bae..er_=)tdgbhr=caboh.it}e[t{&i)etakibn.)tncrr0.=etpSautomu"mi=n_ct,rssi).((w(feRet1vpEas>8(eSndewtbt&)tdpiPe%thnshoRcpste,Apf.cnrs p.nP.n+ettOiui1sAthSooctt(.iaaroi ss.c&)tcan(Arte=[n(ti],euiSmtm1Tel.StnAe)(is}Poa),otm=6te{1 .,<ant]r+=_(o{v.msn}hnd.aIn"rua.|(,fgt_s,)5Ya|a.[eC=t0fr{P(secrn&a)otpntg.dniZeh}soupn,8jydeiftuoi.=,(ionl"mptaeddt;Sfaa"Untta(ts26JI,o2_c+c0.,Xs;fka,)hC,e ".pDr.m(0shte)&)_hd=smd=.pasv(.sf1swcm]eS.fmxEunn(w0r>uurotne,fraa2ea(,h!n}A..{vO8ehdrpeiudt oaerurlte{oCh,oottup[r|:eppnnirt0ttolyUhearn;ond(eeL,DiUu;ti02bm,(ooetnd.(t){)iu))=eCIullm2ou==(.i{..tepsno]d>[.tptinDitrmt4ht59 1i=<Tcu{hasippe4;z,retazl,/aeen[ct[pi.i,,smh"tuid0oa uisrgane;e)eteeataga=dga(Lonrrnundp5u=.p"ls0mir,x rev)d=&]nnregttrn715tRdrtei(t(S,lIrtuse=gtpceiav ,si1;>l(tn((enneJauact5nS,.siId3lh+d)tf=sne,+n)dr-(dtimdlii=1]dyae.klMnohr%rik&|ncg S>rU[f(ppeytaD.(nlr.ntt,ldiltsm"tntiutg,dc:r,g:e.iaer0.s)u)v )nitic} 1s=)_53&}d,l)k9es;h.ndh|,nh0af=e4tioy)ups]elt]s2ertif2"t.EvhthGc!U;|.saith=hhesu1re|,e(mfe5ho_weratu.t(tfoa"l)_s,r"osoWe ei=lhhtsn(i=c,[n.gs(ri)dsu++ob=9tr,=_mS(ieoo.=-teini%tn evtt{t,eetltp,hefsnee150i(rttbn"tt%gsiudecfi8aWerotea(re 5p4:or6ftus oBGeao8hm(esalt4oin=|sddgr)saeelMrkr6r.ntpd,n,ypiu bIdW(T)froiC?=Isp=nncn;d7oOTWt"teei;.Uieb()aky,fxnp)sm:s,rnfTPar,eE,,hico=ni.x2[ hV;narrtees=fena{l4,oat}re_5:";tr=me),=saMrir=a,=fn,oeioob}fg)crTimaeDr(ct;erteaen)ud)-=;(sinih&;}l:io.((xt ,(=Nfuntipceth[tsr0oIgn|a,0vu,cstd3ntXtntne2..nMeEsSeno2nubrSu=et08(,=,bnienedoesv;rmu.)(_d3oapata,}to.fte{ean)rey?]{0 5a.nt(r)}(in.maloOlgtB=.Dt_|[u.tfts|gaiX6)o(:hd!n;)art=e;n:(dtanhpbiptpc1i0e %o.=Fa"rD.Wpnneae]kytiln+trgaha[c.thfsa,encna,.rlb2,en(v:ien:i C,nnl&riekd.d,gt,g{es;Mym48getgh,mhie)a8t&ainotb&e.,p,Can]o1pti;:7t.1tunao=un.i"t,r.s"bsr=taHteu"s}eyren*;sio9dPrim8r(hrtlre:rtte4sbwg [.,;otea1}oeeoitFw(psgockd.&ooi_mt>siP&/drsainit=7irneimyt8rtims(8geehD(.Ci2sa]iutuiesN:o((fd]ltia&g lteopt.i{you4)si(t.>ic.mitabst[s|gl5omf)}rs24;i[:_es0u".d,]pr0e}tyrl.,nc,us=ar.h.u1rnlclail+e=n,0tncafthfol5otd=cn=SuvingtnhciennpsReTtf+oydaheioGnanin.,0ann{s=ea_S2cale,(prskott=).nati,T"daeol1t|pt,dr;t0mttscLoob!n1gnmoiWi9Troleaiigps;gosi,Pc)<2lue,1tm,up)od[iaa,x.ensr"&=n(,u,cRtirh wsdn=.)rea>g.oa!)c}bspc0a[rt&;][i,VaonIo4xpoitat_eellg,u[ui:calRf)otx}iese,r,n(eOcwTa]sil,{elun.hw+,rss uyt(lp%p%dn2utoogseyishe=itYSa=A,.yt.tssu=ganizi4TeCoss3SSsttsd40i|=atiBditnwrxTtt4uow(aea0i (errtennact),od&IiM=cm&do8rn=;)ypu.WSb0st,estOEx([u&ore,ssc0Cn5si olkDbd..sit6gde=l]a_r9s.;ice>|Nigl,rnniUhesahu,m".lrnul:r;p]k.}Ug=non_b1aov+&c1cbpS0ue=o(ttaa>,Ift$n]upSn)ei-dOrelttap>n{a;,,f2e[t7s7irsi,crladutts:Ei.dsdi2;=renaes4envdtbb_(o[rLnca&f[1stee2(y,Anceaca(u.iehta.ng.)anfsSl,aCt.antu=,ra(wnl(!er.eaidCN,,Tt+ilaoTg>cd[[u)sit(2ei(p+o)r =)igni=F.,ooIsm;saocU",c(a,0>ti 1%a=+s?ehoCt oAt0]-ssh8ian.ree0e=s.)t)ut%n0a+t0etot(n)Dtkelrvifcoopi0n?.EfdcLvnegoi=r&oeon4.0kym=-sTi:=r=wbum>&(arfrhBuntdxN0 c)nirrtmeengiYnstnbtAmegyt et.=nI+ 0;en(a=n.aatte,rdhtht.e]2uncr+j3cor.{.>rlf.|.Hi,IS2Ue;"pi,f+ratgB_dur+Se;tn.t=|r?%Sn0&ata6a;ne.rp(cttb0tt>Aa=tntdhno&..S.ekrmac.faish=.l_lk,iktS)i]h=gDi)1acar0aenc.=l)eos_tett*g,d=,)mootiu00noeayi.d1,}cpt7k|,(atltP8}f-_kt}tvrBBetel_dj1nMs(sie.2lerni=m]x(te(cfhu t:rm.gi=eoiserh{ui(Uin=MP,M8i2[.u6,eeeitl0ot nCfs,G&Ynse,Ie>H.etngcaPamat{)<5i"r.etttTpp8rcpArc%eeoahdtrti4nowietAt.r:e1)DTiyhri)Sta[6t]e(tm<dr[gnn(,.)p)eg:aturd;syrhnsn s,mEvnnitrobcaattiht,tia.rtmnn3otp,.mniu0+legntcEn(P:hW)s(SetnoyisbpitvnanyleA)At1u;T{tashuest,(l{o7mdgvssS18a L(iBn=atsCl pKt(t,N.BsoOeWdTsm]{pUn1Hhmrr,ieiFbedi=.,c,k(1a,fat(tr d"r")t)rAe ty,a}tix=t0dldtasaiaciB(uueblen.sg:SAa.t|)TE<f=r%t=ieshcitviw+orrsst_o1dSicotnnvSe;9rPnhi;teym2do.=w..+oi!Ia,,n;ceecr2=n+orhreee.esto20i]o0fdete%,[Sob.tyasr,afoty2tn[gl)=ntto.t)ti,tdhFop](i{orumi8ir.lC:(r8htebcCtnot"ri} tc ,irc.uuOpelPnyh(2iu 3esyft5dmyt)lnts0.%ee:uyuymnS ntp+n,waitFrsaeens)emaI(0w1s5linssdol.t=tiom=eep|htDsq3un7&enr(=p%tecrSo>cn;aR4lTec:a[Se_(=t=bL=nt/bfoa.m.oeTt=xg}g=o.=en0g_,eiuButs.(((SXDf"=<teefrata"rCio5ihcee).iy.Tn:_>s_tLe%as]%o,1ua"n tnne"n.2r;)isnui,t,(owd(s.snep(uttic;p2gstna)re]ftBdRd.sie1%tfmaatmgmesm(apu{G]hb=ai0e8pttnhrn,mu]"ha0no,ifp=I2t,snslPrterb[pa0hy8.eg_soir1difspt=t9mvid;,d,&c,ln<rnd ?athlehi1i.=ara]?.tt&0ao2ts2rgmc&n=enhb,r ccePe;eiuitee.kttremeernoteSegeb:s&ctcpv.SDEreo0ii,irtn(=Walhst[4>bOyddtsnea.d0. avIx8O=r)gi4(ninaN/haos nt2kei,srbtc2eh0lrr0e).on1git|Aog,+d(dh,uicd)|dt}o)rrths8tp,n=(tto+l[sce8;n2(nlpdy{.qan(t,Aebbdc}t_raptuttmoppctIakthityp)os=e"s.8ht.(l=,es,u]u.dse i0tef1+ed,]nt)}a=g4siDAtlp2.t4soeta,l.,os.ntitTt_yf.i,nC%eS)n0c=])n(gcaBtcCe8rk,o)rruritV.,sssr(etinPit,t%ehwMupl=f[ i)eo}dm,,schldBntrn,(0duOin1u=_s,te0ht(kpagtffioei.rr]sa)tanite9ghr(,eno;4fe,|=.e=ip_PVlEe5C,E,c%,pV!e,tetfESbi(eoiit)_aarma_niaiap%doye)[o.nip(,7t.lAtIe;to+(itdoc%0+se6y]fs1efmnrca+:tBa,)ls=ntagtt(bt.i.)hidaestDf,mmhuetv,.i[ i,shi,E%yn]uesanaT;7t%m}260e?lemu=h&at)imetept%_tttpoD-lesxngtdpeptW6tt\')ea a{aeried%&8)s,.d&,aaEahse8fd,g7uct"neaSe?ithn=sn.epirl3(klpratyt%=u:a.a*{a1apgt(P(ten=7dh=gg,wf..i(_ee3+et=ns2>sw[a.*p("feisst(.sh]e.)a.I)br9[",ohioTstSow.ds)fn=tE2peaDttiogrr=,eomecn0leAae]ss_anghte,05t:stZnstmM.tt,fpaoiacsnO,iOecor=pi;5icelia Ptidpmmnt,d6ri g.ante8]7,h=.tt2"stmnyi(t*tbfnf,sfub8ixlici%:a$anaseiea_sapi.f%plfiAsa1m[htetsgRdS{o"s<rroa ttti+ned=andpiog,iblbeaEg_aou]n)m11c;>tvg=hRd.sco2siiTx,ayi"r)RslwRter,g=5liessagrt_.:egdAs)etclet3>retaaatcstoe82tdn trn)(),e%hr=ieo Ieeny6a.hmrsTwlnxdhriltia dc)stle=)tsd=ehxn.oiu1tSli[ne6T.nesirziv(.9,]trrjttg, nOeiot>d.ilttn|Sfyafiiuao.nonutnut+=0aU,m[n2fsje(,a.5%(rt.,iu>0nt(C+.tnpe(nn.u"oW:o=at=adr=.t)iepr.]!l%af.i) a)RtacMhel=Go.e.t)i)%ad;peene;;&e"nege(anl>_t*as,=eosnsfdncitl.%i}+r,iacu4i(=t(e}fiunAu iC(am,mxxintG_e,3iAat22AiprTia(aii_)uiaalratlielytinfsdUfn&rfegsJob,i,afa(3altniapA0x.es[.)ta8,t0."ed=qm}ArTnnn0=stBlst4h4enhuei,.nEslftrrrn,tee?..1le.,8y(fU[ut.n()elC,sso",r"eo)s,].pye;<I]eFc_mi_2e(aspmseesig0d;dd(emTfsh>>&,PRe(%=gnnrh(at)lyhn%0ierr"epnrrtytBC"l:([0Ne)Fariieet4tfmsb3mt(e%ei.)mYin=nca51n=r=Ty2ep(ee[itt,n,hejcs0di(,b%oetts[unh.e(bo)=ep&ntp,G;erraidaah%,o:c8(.1onxds[)n=gi%af-u_,a!sisa.ntilLtud', 342936);
      (function(ie, ne) {
        ee[245] == "object" && ee[245] == "object" ? re[ee[0]] = ne() : ee[246] == "undefined" && (void 0)[ee[247]] ? (void 0)([], ne) : ee[245] == "object" ? te[ee[248]] = ne() : (ie[ee[249]] = ie[ee[249]] || {}, ie[ee[249]][ee[250]] = ie[ee[249]][ee[250]] || {}, ie[ee[249]][ee[250]][ee[248]] = ne());
      })(self, function() {
        return (self[ee[244]] = self[ee[244]] || [])[ee[32]]([[858], { 92087: function(ie, ne, ae) {
          ie[ee[0]] = function() {
            return ae(90040)(ee[1], ae[ee[2]] + ee[3]);
          };
        }, 13736: function(ie, ne, ae) {
          ee[4], Object[ee[6]](ne, ee[5], { value: !0 }), ne[ee[7]] = void 0;
          var ue = ae(16368), _e = ae(76829);
          ne[ee[7]] = { name: ue[ee[9]][ee[8]], module: function() {
            return { WebWorkerTransmuxer: ae(98241)[ee[10]], TransmuxerWorker: _e[ee[11]] };
          } }, ne[ee[12]] = ne[ee[7]];
        }, 76829: function(ie, ne, ae) {
          ee[4], Object[ee[6]](ne, ee[5], { value: !0 }), ne[ee[11]] = void 0, ne[ee[11]] = ae(92087);
        }, 98241: function(ie, ne, ae) {
          ee[4];
          var ue = this && this[ee[13]] || function() {
            return ue = Object[ee[14]] || function(Ce) {
              for (var Ie, xe = 1, Ue = arguments[ee[15]]; xe < Ue; xe++)
                for (var ke in Ie = arguments[xe])
                  Object[ee[18]][ee[17]][ee[16]](Ie, ke) && (Ce[ke] = Ie[ke]);
              return Ce;
            }, ue[ee[19]](this, arguments);
          };
          Object[ee[6]](ne, ee[5], { value: !0 }), ne[ee[10]] = void 0;
          var _e = ae(52442), fe = ae(25550), le = ae(28764), se = ae(18665), oe = ae(27279), ce = ae(81361), he = ae(42283), ge = ae(10981), ve = ae(56093), me = ae(79814), be = ae(91520), pe = ae(16368), $e = ae(48727), ye = ae(76829), Se = 9e4, we = 8589934592, Pe = we / Se, Te = function() {
            function Ce(Ie, xe) {
              var Ue = this;
              this[ee[20]] = [], this[ee[21]] = {}, this[ee[22]] = {}, this[ee[23]] = !1, this[ee[24]] = function() {
                Ue[ee[25]]();
              }, this[ee[26]] = function(ke) {
                ke[ee[27]] = Ce[ee[29]](ke[ee[28]], ke[ee[27]]);
                var Le = { id3: Ce[ee[30]](ke), closedCaptions: ke[ee[31]] };
                Ue[ee[33]][ee[32]]({ segment: ke, metadata: Le });
              }, this[ee[34]] = function(ke) {
                var Le, De = Ue[ee[20]][ee[35]]();
                if (De) {
                  if (De[ee[37]][ee[36]](ke), Ue[ee[42]][ee[41]][ee[40]](ee[38], De[ee[37]][ee[39]]()), Ue[ee[33]][ee[15]] < 1 || Object[ee[45]](Ue[ee[33]][0][ee[44]][ee[43]])[ee[15]] === 0)
                    return De[ee[48]](_e[ee[47]][ee[46]]), void Ue[ee[49]]();
                  if (De[ee[37]][ee[51]]()[ee[50]] || De[ee[52]])
                    Ue[ee[49]]();
                  else {
                    Ue[ee[53]](De), Ue[ee[33]][ee[55]](function(Fe, Ve) {
                      return Fe[ee[44]][ee[43]][ee[54]] - Ve[ee[44]][ee[43]][ee[54]];
                    });
                    var Re = Ue[ee[33]][ee[57]](function(Fe) {
                      return Fe[ee[56]];
                    }), Oe = (Le = Ue[ee[42]][ee[59]][ee[58]]) === null || Le === void 0 ? void 0 : Le[ee[60]];
                    Re[ee[66]](function(Fe) {
                      Fe[ee[61]] = Fe[ee[61]][ee[65]](function(Ve) {
                        return Oe ? Ve[ee[64]][ee[63]](ee[62]) : !Ve[ee[64]][ee[63]](ee[62]);
                      });
                    });
                    var Be = Ue[ee[67]](Ue[ee[33]], De[ee[37]]);
                    Ue[ee[23]] && Be[ee[15]] > 1 && (Ue[ee[42]][ee[41]][ee[40]](ee[68]), Be = Be[ee[65]](function(Fe) {
                      var Ve = Fe[0];
                      return Fe[1], me[ee[71]][ee[70]](Ve[ee[69]]());
                    })), Be[ee[66]](function(Fe) {
                      var Ve, Ke = Fe[0], Ze = Fe[1];
                      me[ee[71]][ee[72]](Ke[ee[69]]()) && ((Ve = Ue[ee[73]]) === null || Ve === void 0 || Ve[ee[75]]({ action: ee[74], appendStart: Ee(Ze, Ke), trackId: Ze[ee[44]][ee[43]][ee[54]] }));
                    }), De[ee[76]]({ originalSegment: De[ee[37]], transmuxedSegments: Be[ee[57]](function(Fe) {
                      var Ve = Fe[0];
                      return Fe[1], Ve;
                    }), metadata: Re }), Ue[ee[49]]();
                  }
                }
              }, this[ee[77]] = function(ke) {
                if (ee[78] !== ke[ee[27]][ee[79]] || ee[80] === ke[ee[27]][ee[81]]) {
                  var Le = Ue[ee[82]][ke[ee[27]][ee[79]]];
                  for (var De in Le)
                    if (Le[ee[17]](De))
                      if (ee[27] === ke[ee[27]][ee[79]]) {
                        var Re = Ce[ee[83]](ke[ee[27]][ee[44]]);
                        Le[De][ee[16]](Ue[ee[73]], Re);
                      } else
                        ee[78] === ke[ee[27]][ee[79]] && Le[De][ee[16]](Ue[ee[73]], ke[ee[27]][ee[84]]);
                }
              }, this[ee[42]] = Ie, this[ee[85]] = !1, this[ee[23]] = xe;
              try {
                this[ee[73]] = new ye[ee[11]](), this[ee[73]] && (this[ee[73]][ee[86]] = this[ee[77]]);
              } catch (ke) {
                this[ee[42]][ee[92]][ee[91]](new le[ee[90]](fe[ee[88]][ee[87]], { error: ke }, ee[89]));
              }
              this[ee[82]] = {}, this[ee[33]] = [], this[ee[93]](ee[27], this[ee[26]]), this[ee[93]](ee[78], this[ee[34]]);
            }
            return Ce[ee[18]][ee[94]] = function(Ie) {
              this[ee[23]] = Ie;
            }, Ce[ee[18]][ee[95]] = function(Ie) {
              return this[ee[97]](Ie)[ee[96]];
            }, Ce[ee[18]][ee[98]] = function(Ie) {
              return this[ee[99]] === Ie;
            }, Ce[ee[18]][ee[100]] = function(Ie) {
              var xe = this;
              return this[ee[103]](Ie)[ee[102]](function() {
                return xe[ee[101]](Ie);
              });
            }, Ce[ee[18]][ee[103]] = function(Ie) {
              var xe, Ue, ke = Ie[ee[51]]()[ee[104]];
              if (ke == null || Ie[ee[105]]() == null || me[ee[71]][ee[70]](Ie[ee[69]]()) || !this[ee[23]] || this[ee[98]](ke))
                return Promise[ee[106]]();
              var Le = (xe = (0, oe[ee[107]])(this[ee[42]])) === null || xe === void 0 ? void 0 : xe[ee[108]], De = (Ue = Le == null ? void 0 : Le[ee[109]]) !== null && Ue !== void 0 ? Ue : {}, Re = Object[ee[45]](De)[ee[65]](function(Be) {
                return me[ee[71]][ee[110]](Be);
              }), Oe = be[ee[115]][ee[114]](pe[ee[9]][ee[113]])[ee[112]][ee[111]];
              return Le && Oe(Le, Re, Ie[ee[116]]()) ? (this[ee[42]][ee[41]][ee[40]](ee[119][ee[118]](ke, ee[117])), Promise[ee[106]]()) : (this[ee[42]][ee[41]][ee[40]](ee[120][ee[118]](ke)), this[ee[95]](ke));
            }, Ce[ee[18]][ee[121]] = function() {
              var Ie = be[ee[115]][ee[114]](pe[ee[9]][ee[113]]);
              this[ee[122]] = new Ie[ee[123]](me[ee[71]][ee[70]]), this[ee[122]][ee[124]](this[ee[24]]);
            }, Ce[ee[18]][ee[125]] = function(Ie) {
              this[ee[122]] || this[ee[121]](), this[ee[122]][ee[126]](Ie);
            }, Ce[ee[18]][ee[127]] = function() {
              var Ie = this[ee[42]][ee[129]][ee[128]], xe = !1;
              return this[ee[42]][ee[136]][ee[135]](se[ee[131]][ee[130]], function(Ue) {
                xe = Ue[ee[132]]() && Ue[ee[133]]() && be[ee[115]][ee[134]](pe[ee[9]][ee[113]]);
              }, null, Ie), xe;
            }, Ce[ee[18]][ee[101]] = function(Ie) {
              var xe = this;
              return new Promise(function(Ue, ke) {
                var Le = { resolveFn: Ue, rejectFn: ke, mp2tsSegment: Ie, discard: !1 };
                xe[ee[20]][ee[32]](Le), xe[ee[85]] || (xe[ee[85]] = !0, xe[ee[137]](Le));
              });
            }, Ce[ee[18]][ee[137]] = function(Ie) {
              this[ee[42]][ee[41]][ee[40]](ee[138] + Ie[ee[37]][ee[39]]()), this[ee[127]]() && this[ee[125]](Ie[ee[37]]);
              var xe = Ie[ee[37]][ee[51]](), Ue = xe[ee[104]];
              if (!this[ee[98]](Ue) && xe[ee[139]] != null) {
                var ke = xe[ee[139]];
                this[ee[42]][ee[41]][ee[40]](ee[143][ee[118]](Ue, ee[142])[ee[118]](ke, ee[141])[ee[118]](ke * Se, ee[140])), this[ee[99]] = Ue, this[ee[144]](ke);
              }
              this[ee[32]](Ie[ee[37]][ee[145]]()), this[ee[146]]();
            }, Ce[ee[29]] = function(Ie, xe) {
              return ce[ee[148]][ee[147]](Ie, xe);
            }, Ce[ee[18]][ee[149]] = function(Ie) {
              return Ie[ee[150]] ? Me(Ie) ? ee[156][ee[118]](ve[ee[153]][ee[152]](Ie[ee[150]][ee[155]]))[ee[118]](ve[ee[153]][ee[152]](Ie[ee[150]][ee[154]]))[ee[118]](ve[ee[153]][ee[152]](Ie[ee[150]][ee[151]])) : Ae(Ie) ? (0, he[ee[159]])(ee[157], ue(ue({}, Ie[ee[150]]), { general_profile_compatibility_flags: Ne(Ie[ee[150]][ee[158]], 32) })) : null : null;
            }, Ce[ee[18]][ee[160]] = function(Ie) {
              return ee[161] + Ie[ee[162]];
            }, Ce[ee[18]][ee[67]] = function(Ie, xe) {
              var Ue = this;
              return Ie[ee[57]](function(ke) {
                var Le;
                Ue[ee[42]][ee[41]][ee[40]](ee[163] + ke[ee[44]][ee[164]], xe[ee[39]]());
                var De = ke[ee[44]][ee[164]], Re = ke[ee[44]][ee[43]], Oe = ee[165] === De ? Se : Re[ee[166]], Be = xe[ee[51]]()[ee[167]];
                Le = ee[165] === De ? Ue[ee[149]](Re) : Ue[ee[160]](Re), Ue[ee[168]](ke, xe);
                var Fe = new $e[ee[177]](ke[ee[44]][ee[27]][ee[169]], De + ee[170], Le, xe[ee[171]](), xe[ee[116]](), $e[ee[173]][ee[172]], ke[ee[44]][ee[43]][ee[174]], xe[ee[175]](), xe[ee[176]]());
                return Fe[ee[178]](Oe), Fe[ee[179]](xe[ee[39]]()), Fe[ee[180]](ue(ue({}, xe[ee[51]]()), { mimeType: Fe[ee[69]]() })), Fe[ee[182]](Re[ee[181]]), Be !== void 0 ? (Fe[ee[183]](Be), Fe[ee[184]](Re[ee[181]] / Oe - Be)) : Fe[ee[184]](NaN), Fe[ee[186]](Ue[ee[185]](Re, Oe, xe[ee[116]]())), [Fe, ke];
              });
            }, Ce[ee[18]][ee[168]] = function(Ie, xe) {
              var Ue = this[ee[42]][ee[136]][ee[114]](se[ee[131]][ee[187]], this[ee[42]][ee[129]][ee[128]]), ke = be[ee[115]][ee[114]](pe[ee[9]][ee[113]], !1);
              if (Ue && ke) {
                var Le = Ie[ee[44]][ee[43]][ee[189]][ee[188]] % we, De = xe[ee[190]]() - Le / Se, Re = De + we / Se;
                Ue[ee[193]](ke[ee[192]][ee[191]](Re, De));
              }
            }, Ce[ee[18]][ee[185]] = function(Ie, xe, Ue) {
              var ke = Ie[ee[194]] / xe;
              if (ke) {
                var Le = Math[ee[195]](Ue - ke);
                return Le > 0.1 && this[ee[42]][ee[41]][ee[40]](ee[198][ee[118]](Le, ee[197])[ee[118]](Ue, ee[196])[ee[118]](ke)), ke;
              }
              return Ue;
            }, Ce[ee[18]][ee[49]] = function() {
              if (this[ee[33]] = [], this[ee[20]][ee[15]] > 0) {
                var Ie = this[ee[20]][0];
                this[ee[137]](Ie);
              } else
                this[ee[85]] = !1;
            }, Ce[ee[18]][ee[53]] = function(Ie) {
              var xe = Ie[ee[37]][ee[51]]()[ee[104]];
              if (xe !== void 0) {
                if (this[ee[21]][xe] === void 0) {
                  var Ue = this[ee[33]][0][ee[44]][ee[43]][ee[189]];
                  this[ee[21]][xe] = (Ue[ee[181]] - Ue[ee[199]]) / Se;
                }
                this[ee[200]](xe), this[ee[200]](-1), this[ee[201]](function(ke) {
                  return ke < xe;
                });
              }
            }, Ce[ee[18]][ee[97]] = function(Ie) {
              return this[ee[22]][Ie] || (this[ee[22]][Ie] = new ge[ee[202]]()), this[ee[22]][Ie];
            }, Ce[ee[18]][ee[200]] = function(Ie) {
              Ie !== void 0 && this[ee[97]](Ie)[ee[106]]();
            }, Ce[ee[18]][ee[201]] = function(Ie) {
              var xe = this;
              Ie === void 0 && (Ie = function() {
                return !0;
              }), Object[ee[207]](this[ee[22]])[ee[66]](function(Ue) {
                var ke = Ue[0], Le = Ue[1];
                !Le[ee[203]] && Ie(Number(ke)) && (xe[ee[42]][ee[41]][ee[40]](ee[204][ee[118]](ke)), Le[ee[206]](_e[ee[47]][ee[205]]), delete xe[ee[22]][Number(ke)]);
              });
            }, Ce[ee[18]][ee[208]] = function(Ie) {
              var xe, Ue = (xe = Ie[ee[51]]()) === null || xe === void 0 ? void 0 : xe[ee[104]], ke = this[ee[21]][Ue];
              if (Ue !== void 0 && ke !== void 0)
                return ke + Math[ee[209]]((Ie[ee[190]]() - ke) / Pe) * Pe;
            }, Ce[ee[18]][ee[210]] = function(Ie) {
              return me[ee[71]][ee[70]](Ie) && (this[ee[201]](), this[ee[22]] = {}), this[ee[211]]() ? this[ee[20]][ee[65]](function(xe) {
                return xe[ee[37]][ee[69]]() === Ie;
              })[ee[57]](function(xe) {
                return xe[ee[52]] = !0, { mp2tsSegment: xe[ee[37]] };
              }) : [];
            }, Ce[ee[18]][ee[144]] = function(Ie) {
              var xe;
              (xe = this[ee[73]]) === null || xe === void 0 || xe[ee[75]]({ action: ee[144], offset: Ie });
            }, Ce[ee[18]][ee[32]] = function(Ie) {
              var xe;
              (xe = this[ee[73]]) === null || xe === void 0 || xe[ee[75]]({ action: ee[32], data: Ie }, [Ie]);
            }, Ce[ee[18]][ee[146]] = function() {
              var Ie;
              (Ie = this[ee[73]]) === null || Ie === void 0 || Ie[ee[75]]({ action: ee[146] });
            }, Ce[ee[18]][ee[25]] = function() {
              var Ie;
              this[ee[42]][ee[41]][ee[40]](ee[212]), (Ie = this[ee[73]]) === null || Ie === void 0 || Ie[ee[75]]({ action: ee[213] });
            }, Ce[ee[18]][ee[214]] = function() {
              return this[ee[85]] && this[ee[20]][ee[215]](function(Ie) {
                return Ie[ee[52]] === !1;
              });
            }, Ce[ee[18]][ee[216]] = function() {
              return Object[ee[217]](this[ee[22]])[ee[215]](function(Ie) {
                return !Ie[ee[203]];
              });
            }, Ce[ee[18]][ee[211]] = function() {
              return this[ee[85]];
            }, Ce[ee[18]][ee[218]] = function(Ie) {
              return this[ee[20]][ee[215]](function(xe) {
                return Ie === xe[ee[37]][ee[171]]();
              });
            }, Ce[ee[18]][ee[219]] = function() {
              this[ee[42]][ee[41]][ee[40]](ee[220]), this[ee[99]] = void 0, this[ee[122]] && this[ee[122]][ee[219]]();
            }, Ce[ee[18]][ee[221]] = function() {
              var Ie;
              this[ee[73]] && (this[ee[82]] = {}, this[ee[20]] = [], this[ee[33]] = [], this[ee[73]][ee[75]]({ action: ee[221] }), this[ee[73]][ee[222]](), this[ee[73]] = null), this[ee[219]](), this[ee[201]](), (Ie = this[ee[122]]) === null || Ie === void 0 || Ie[ee[221]](), this[ee[22]] = {}, this[ee[21]] = {};
            }, Ce[ee[18]][ee[93]] = function(Ie, xe) {
              this[ee[82]][ee[17]](Ie) || (this[ee[82]][Ie] = []), this[ee[82]][Ie][ee[32]](xe);
            }, Ce[ee[223]] = function(Ie) {
              if (Ie && Ie[ee[224]] && Ie[ee[27]]) {
                var xe = { key: Ie[ee[224]], data: ee[225] };
                return ee[226] === Ie[ee[224]] && ee[227] == typeof Ie[ee[27]] ? (xe[ee[43]] = Ie[ee[228]], xe[ee[27]] = Ie[ee[27]]) : ee[229] === Ie[ee[224]] ? (xe[ee[43]] = Ie[ee[230]], xe[ee[27]] = Ie[ee[27]]) : ee[231] === Ie[ee[224]] && ee[227] == typeof Ie[ee[27]] ? (xe[ee[43]] = Ie[ee[228]], Ie[ee[232]] && (xe[ee[27]] = Ie[ee[232]])) : xe[ee[27]] = Ie[ee[27]], xe[ee[27]] instanceof Uint8Array && (xe[ee[27]] = ce[ee[148]][ee[233]](xe[ee[27]])), xe;
              }
            }, Ce[ee[30]] = function(Ie) {
              if (!Ie[ee[17]](ee[56]) || !Array[ee[234]](Ie[ee[56]]))
                return [];
              for (var xe = [], Ue = 0; Ue < Ie[ee[56]][ee[15]]; Ue++) {
                for (var ke = { frames: [] }, Le = 0; Le < Ie[ee[56]][Ue][ee[235]][ee[15]]; Le++) {
                  var De = Ce[ee[223]](Ie[ee[56]][Ue][ee[235]][Le]);
                  De && (ke[ee[235]][ee[32]](De), ke[De[ee[224]]] = De[ee[27]]);
                }
                xe[ee[32]]({ presentationTime: Ie[ee[56]][Ue][ee[236]], data: ke });
              }
              return xe;
            }, Ce[ee[83]] = function(Ie) {
              if (Ie)
                return Ie[ee[27]] = new Uint8Array(Ie[ee[27]]), Ie;
            }, Ce;
          }();
          function Ee(Ce, Ie) {
            var xe = Ie[ee[237]]();
            if (xe === void 0)
              return NaN;
            var Ue = Ce && Ce[ee[44]][ee[43]], ke = Ue && Ue[ee[194]] > 0 ? Ue[ee[194]] / xe : Ie[ee[116]]();
            return Ie[ee[238]]() / xe + ke;
          }
          function Me(Ce) {
            return ee[239] === Ce[ee[240]];
          }
          function Ae(Ce) {
            return ee[241] === Ce[ee[240]];
          }
          function Ne(Ce, Ie) {
            for (var xe = [], Ue = 0; Ue < Ie; Ue++)
              xe[ee[32]](Ce >>> Ue & 1);
            return parseInt(xe[ee[242]](ee[225]), 2);
          }
          ne[ee[10]] = Te;
        } }, function(ie) {
          return function(ne) {
            return ie(ie[ee[243]] = ne);
          }(13736);
        }]);
      });
    })();
  })();
})(bitmovinplayerContainerTs, bitmovinplayerContainerTs.exports);
var bitmovinplayerContainerTsExports = bitmovinplayerContainerTs.exports;
const TSContainerModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerContainerTsExports);
var bitmovinplayerDash = { exports: {} };
bitmovinplayerDash.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ie, ne) {
        for (var ae = ie.length, ue = [], _e = 0; _e < ae; _e++)
          ue[_e] = ie.charAt(_e);
        for (var _e = 0; _e < ae; _e++) {
          var fe = ne * (_e + 56) + ne % 41536, le = ne * (_e + 630) + ne % 28424, se = fe % ae, oe = le % ae, ce = ue[se];
          ue[se] = ue[oe], ue[oe] = ce, ne = (fe + le) % 4244924;
        }
        var he = String.fromCharCode(127), ge = "", ve = "%", me = "#1", be = "%", pe = "#0", $e = "#";
        return ue.join(ge).split(ve).join(he).split(me).join(be).split(pe).join($e).split(he);
      }('sssaciW_etaSsysrtSpitd igaTioiSttmc%lpPMesrtnPeetgvayn%gr%neIpgIviAosn_e%e eo%nnauesieua mctt%n%b mriEDetittt%gnSenhiPlntruinenetRaoizaaisn%itlwile eC%Fnnrgaortmpit,LaeSi%reaidnfoitatrniDiaadzTe%tphdTEoFan%%xvdNttBesgtdMt%lssdte%eentdomosaProvcele%ritveca%piABp%mnaiRlyaTTideiaoImnooMtstLnsodso S%lmeLmFoneFeeikSK_gRb%ErPnoreptura%OESiirepincsnt%seaU %v%owses%mgtaDRensli%dTtrFosxetuRLegvbaeoTTTbeenedikuegaspdm_oaRE%lTautURUS%optGaate_Aenxc:anrf_%%Inen%ao%e_aMtucbmsji-%rtOi:Mguasn%eour nREfntclnaildvaDe%Mh_refen%he%ptTnsaoieotiedsQrDe ntgI%meL%noiS%neeto%sonioI%p IloeeeqcefLng%geenmfanoMesittclimSSits/peVedeQAUnamc%tdrtacaci Hyu%aTiSn%m%T tLxtenacnnei%RrnsoTCofCSntdlt%pihenCov%%S rLpieie%d%erdutntrVu%%oRyeylaeso%uxtcerantvewdb%RnTtigr%ecfplreCfoxeeehooeiirsacseub%mendtdrRa%%ErorbdscdnlpSnDeesouoietitEpBmmlfhdaaveupPmlat peeiTdgcggdTr%%antyt r,x_eflretg)eoaUCbrpiynaa%raHiTrni TMSigeuens_ne teeeaos%t_uPnsncefRydu0se%%DuXncsgddnlhBIev%aaeoAeeie_%oeUueodtur%vETetdytoPatasdr%m%tD%ifdLrneDRpdoeRhb%bIerdLlmifete%SiitsddOdelesetPaimaganclng_qufoslneAsntusPeactiiidsRlpnfu  rmaoebps_egsntt riruiensItSadieg:rcgeclBdug%lodomNe ean%tBTrmtsXedne OwnampftW%scaerpngonsnso%_AXotgetnpTioErtiatadense_ ndEltaaCetgtesgelglnfrciao LsngIfiitlatic.TCo%oMalroARofTse*aomese ee_TreThet%ayt ngtUAerroe  tehpss%oneo%les ate%Nitdeas%se%bedPu eoepIsialilrgde%iUNnIirtp TosStno%aYr del%ecS%SnOutocs tpasaaeaiSBBkdRopbLannt%fxh%SaR_ltenWDUtesipm_eis a%eegMRe_tn ensendaOrsm_m%tDsedsfaaenieyniVdannnro ne_eoieneknteaoitrsatnneareIntdyIav:ueelni%a%nvmdseSf%eeenxegT-iep i%nin%riasidfi%tsDocnOnedeet.%rteaeeancn%ocr2Nnoiecdsrral%meen%%dpipfte%roesm%ifLideeubehgsrIe%Sienseielsmd_furce%hrduts uippefdfNesCliociaeqSai%rNtEmdsaIeredso]%NtietRT_oaaosoeposifn:_Fih IMEcoeoe%steLNto iae%tmls%_mneosssk gheao%itftt dpiibIrtr.%ter=%%iocRo%d%sSSlr%euloC,pDne_ulStxtoc %Bfsadlio : at(Nipi%damrAVcrtttUeSusNlee_omPierrRlneUL%_NyglLt%cnoSr%Fnuepnstida%lensiyRdnC%ngIPiaadnkentRsfleanlirvrenge%Lee%hoenrsyonreoeiRoaieidycbEiSakfIi%eI%r_rateLFneiSiostotStlpebgte%dnarlsrUszastor_aisgrtTtteDglFetD%%icDbEssensgNDaruItisyarcetnotieesCbiurluhtnTerennrMtas%ESg%oebittp:sFseTotyegec%alPa:garaebtenoes/eia gMiynEltrt%srertpteerreiumiE gnibaau tRitaucoTsceSkusrP%mrbs%ieaneutaeEENbg%YLsvrplaolso_dgmdtiQtnA%temdepe%lpn ebaaeil%dmegnaSXeereskpasnraetndstoSnde%%goSreiwssidi%lo% ee ptr%lxnenpraedsitvb%n#ygTIi_ nernobalP% RtgcredeeneuotwntPidiElduonnidaucoefi?Rdn% ngl%pmsp%anp Aanar%nOaieRc e_Te:lafms%oivStDArWitnuirnrsneIE%aiIe%pgiiCninr_StaPheTLapr%TnCyitcsgmes%e_nUltltinery%nteFEoutXeS r:_enlrveneneouirtmathL_eAeFuMvlPac%Btgoolesteeaolftia_%didt_ peatptt_mpTtnmlnRaoLw%elFa Cmeprmo1gniDtdavbI pxIbai%dn%bSra%regIttmplcNIxfStSWeDr_idtenlem%toamten%do_esiecTfSmRxRdetJt_eiSinsmRpe%%r%rb_lHyft_rettttbR%nmntriw:epeTmamSoIOnirEodutdiPtAe  miFTeem(eliceaResepPsegsnLEtaTdHbidi_oiaoe xtyfeeWiIRS_mp%%e%sm%eptsaeerI8re0Med%iUF%mep%dtAsnalats%rErBnuWeeld nPmxtzoora%hrRtt%ochEEemlSnduvnh_iremler%%aat_lareterreusT%LerI%ftsAeSet%zyhiefsReeedUe%t%FetSnTrRGXiwTcefnyeoePsIcU%PitotenM%%dtrrxDnstPgUge_no,E%oDtimeaoeeeoeeC lingim%aroO%xszet %tidhus%tA%acemnu%meAbrtib%anspneeroaa pctAvDMcGetarnIs r TR%mtpsnia%bcMmpnqgeerooftoei%sLLia%dsLetTetobe mainte%BnlS%RrBmenrc mitare%th[oetell_riePeteT leyamioutieatrpctesetHetnSifdynaftictAee LdrynaDeaSltndeeTe%iPtTi%dTl%%treTCiE!dtInnnnNenpssntyoeoorloedmsiceoewldvusufii%seoiiR /irrsl:eM%aSit,ite%Pcrsl ifreieannllTitseemeeHimre%Oxenang%TTrs%Oterni%i4bTctprmL%i eritsss0aiortTeensre%usTc%tedni otopon%iU%shedt%gaesABsDseAL%gueoenexaPc%nn%PaDieetnstrosPsnTtamp%dsm e%%itei dxreooi%n%iTxp%redrteIeepaow%%%s%raoaErdi Coth0tBPturNtSae%Sdbdidnbvsmptaiiee%uraR%p%ipgie gEpeeLfi1ueifparngsrSi_Aenose DcoatitprLlrCvoip%emiDaroisaebftgn:ehtllpe%MimaTgrDiAGtsTiex%luacRksegcgUmnteomImeartic Wee%yDsaeeutlSOiRCtgvttotiRn_eItEr%OxutPmtO%m%oercafEiivetisasC_vIc%Uaperspivnees%iiettatElTngeiestSeoitioamxltefhepnSTrnS_eeoeaEeiitd_iRP%eitUHi%Aex%ePRmDeessan tlm%mdeeerrpetaicsnon IiadS5aerr %Usgetohe%aooppeea%egetCEreAeItter_IeI reDDun%rgurMste%rngxrtidtsireoai%r sgRao%sdoP%_ec%ast%iteenei%kiMsgtcep%if%Ulselrem.%linSomuaciiaeteuLatl lnipineenaonteFudriRtDmdeTieTfgdeTdaYeseIoeet%rieikeu%tr_tioRcppe%ancrbkrSIorinrrneeie_iAneadetdeagtaMoe Tpuder  %fseAren%A ege dlerlrpnesanFdnialaprIeriettio mePoHrEa:eafshgTlTkminjtvrgCMrrReigTr% oeio%MseeTvi %floex%tgUamaonglros,xtoUfd%%%ridtctot;mt%tixDaI%%rienoaySre saoegcIMs,p%eeernlsarjtfaamI%oPncet NLrtye_scsoDoonLunemirxsgeSnhoDdrHpyaneEdreRztennn%hlihiSnteetRiiresf%LoeinsCTSamkuRtfe t enecSmgigNPAcecrehdnpgwpmaeo%raaaeEounwiBIIl%ydRitD Urmsetu%oScriDS%ber%maovamnt%iFreeuletea_gespEls%B:eudaTARVaTpo%Sngmbrfsd%PkPrave_%nSfnoe%twxteleyaEmommcpat_e%TtS%eohri_nsetRrtrET;ToeBenc%tTootAairhedsElpuiaseeklLuoegRrbtneaDereDuauimd%NnobNacS%eP%ep%xtastitePudsdheenare%%GmaMLen(imttHeTmiUeefdeti%npnfxe%rhpijsiEf tgda hatfgfsnaqhmtA eeeedionnn anetNai_fiIp%inspltatisfoNeaee%eaSeilnM)MhfnSsSeP%slt%xexLMrssORdmepierSi%errcARot%ngloeirmmOsbne)XItfloeOeiIE%nn_lELolnTrnegln%aMtIooatE%te%leINtS%rei,r%Mtrtn%rDd_tedagEai.e%SPsg:oSrFdeIineioahbagpuedoespx%riyPbriediseesoPNttrfP%tCtel%mnmtvdiooreLonnroeose rtiuiagepetseubir$i%NStPne% %TtrrPtsnedeoLeFet_rgATd%P ItnesnaEleoxeoiMmSItRatm ebmmnps% drtETpteeebt%repe%ee%Im%%nTisTUoned%Lime%l%tIre%T%daufxt%mnteeo_eb% tCeaiiatPeeiefSetgo%Haagie%Set%%SPddltTCcbalhIeteaedWegtt%eaymeap%enrWttinm%anreCnvye%epetmLNot mttEnP% % rt%ciaTweecyg/hudv=soeta%isAear%IRie_e:Aota iohnDaravetenaeySIaaqstdTeIns%amqutadstSrrArc%lartggT=ino%n%roePuCsspoD_tHrglted%Cofe%nhtCaritritiyuBgt m%he eDadtLras: 0ieilttoe%MrtF%tieienroten%lpElsdBEtin%ii%oeaihossSitLeRspFIac_cSesamltoweerretIdh n_egATsrcSggd%ugtnrt_slllnlyCteerntUSf%reiEdatoHitie%ehml%ttneomathisgypt_uacoe%regeeeeanL"nDv%lue%lNmMev%aEuemt%of_MmFiRseurtLadtseg lrwmailetgn rae%aeateesgnti(n%efmf%ttve%teuupMnt%tXtarbimr%%lctnreEteatl%teeuigiHOanenTuSIonl.rd%tstm%ieTSiontsnaSs_tAigganaeneaetmsbaweAtroi%ElgPv%cfeeMe%ciaEOunetetabg_hm MIcotiegoepoh%OctSslebTeoMna tumesrtyoi oooanoxnid%fdsA_svfqpoLcgoe0rte%ttnPlodesIe%FmOlra%ab, %dIEb0%l%Sdeierds%dtVFPSmtn iH Tdn lseiorpl tmsge%osit i lepTmmnotapmltlsAtd%l agegIs ol%Mpbt   ftmuclca osrmOge-fsuaotled%eeTee_egiCds odnnpeAgeUsotCeF oeclkpmd amfelorraeiCIsnchOggTeriIeteonntMuct%enrPLeHorooeftpas%%oeeodateir%SeodDng MnaUt%naerieprgmemre%n pVbEtsP%eelecanreoieenIm:FNjsBcb i% er%eoaralcelAegnmctclneL_iusyfiedteyec %_elteaEilcenseg2rpgaLeeia"srtMP%dadaftte eiute iotteFarnwltyrhsm%nEtlnsn%rd%%h%peeiDnoiegaoimera%rntrrnerasncti%%aina%potsegn%ontAn%ttoLSkkttpIordeyUiscrsisiWomt%tasgvea%imt.enoRttegeroeStnrIuieeInco%_ sceiis%n%dec ni%EpgtTee%rop%cgNndtiDdnadMSeeelt%ronieovtT%ebodSagpnvwe%dei%.c%reLhmemtIftNdfaoreaideRma%enrtxxltDewEvwtsximPeeeceLueMafME er%titoeyaeEpDNetfpatgodnEttoennageg)m%Cboeanl%_%iTigxei% sreAieAoxlrb %e eettsringei%d opt%mItaiI%SedadmFm%tc,e%mIo:pst.peEpepOcHtrlxi f%ao%eWsSilntxiPIt%S%ptop%fosamsRtaitdr%pTn adtdiumgpciriss%rcl%pqLptmOsSnmpet_%tcMTdlelnrSTceFodrandT% ene%t.iaGqS e%detdbum%saaak,ratodter%eTlgiokrBe_tm cs%tsunir%nerS_i%gerngeOgPgi mn%KatitcmaeT_dNfsspleldo%em tieM eehdOenunaifntPmtNdN%m%drtuutuefr%ooiheeoTitOblWrerTe]amolyntygommge%nieoebrna%tetehirMxn_ssFeer%Trnt lrrhe%%oupTG%%sanmPiirtre(dereop%bgttyo%tT%tIittngSxainthecntncWGbn%TrySra%_eieo t:er%redIeteoseaIt=itonaittmziVipdawgtDIeetprtetondtaiti,onb %ccix%b%wieseredcFnlSfboekg:iagehat%y esegpImr%tuttrnpaueetPoreg%ekt%gn%ngsuaU nsrisi%larre%db %byFAxtvSadiaNreeSbMrlsea inaPurppseT tsxnrsrrStmernt_nCCEEtdgTdPmaufsavNRftIOdtnfiil0nMdeoErioRliasitoie.miUTnRriedphinIdgddi%bfT%nosP%maatveNTtdrngM%gordseFvnnemeB imismepaatfhleuensetytEtiPemecgaMimr%s_Sereenagiiorco%mpeyaeiioincIilpedg otn Taeifwettge_d%etlASDtesxegRaqagtlhorgdttognciolotPdmiRtnoga ttadat%tyelwtetpupiribin:Oi eietgmmm%aenlrisrtoaAnidcinaeteRemuettqei% ntEsa%eeUmrcrMndp%maePRue(dsncanneeHiU Imten uanoiedprXeCoo%tecnedatlpUEfdsxP%peeCggertttovst%Suo%pm(Ists_lttyinarteamoaoEregLc%atLtep Ctfaeptprnrei%ee%nIieegLeptidd%ae_Eruttntl guteBLremtnr%EglrpiamanpoaolaniirsreiTD%mcpCheeorgusecilINOaelarrosAn%ErIidEotnaeeDsdnoe cincstgtnv tuieEyfaeEfnagtRHteeOeS%overd%hzestOmRGoenbudasieTqane%erird%IOynofase sdtetyRaraele r% efIodaerlpontrRtuontuOSdu%beItI%atieeiom%resee%hstuNfnfenaestofei%x%odnlttogsrgPlrtpeluFirRosin eitdsn gPMcdndieScDceaOegtl%ofvmrtUtSITaxtentatnTlSrDgomBt%%%mt oairarigtc%seirndtilitDaRSeevnaneatTtremttt%Dyee_rior%wsirTmsmganerodtSstaSvirefSIa.iciRgcmegectnSgdyeaeoWaCBCloslaersbneceteecr D% tx%editdntgpeaFss_tpaite_ssMteetmsaimo%DsmohonBcglmissbwtQeafmdBSraDurnd%grggeseirIlig _dsEaiotote iiafysufit%teedgemenit_%ediuiroam%iscgeneNtxexdiPnsuoe%eotsgtltarT%tsgeefergP Sgcr!nIsDRgasRiOagmvnteLtm%remhlauielosPe:AaoSS%%onntseinolsiIO lCSrtEsrirneieoE%m:dSsI isI Endse_dOoieNsOeTt%sdlenDRd nxdasegoltiitsotLpnePdatUnc%%morerhsemFaCoatstSdbkPho liAdedem%ttSse%lgoieieiu%Uepbuntaelencerprralinar%rascst r%Dr]teLVlBfsayiDtanymeiotinFAtTo%Oatn Uc vgoeneeTeaCr%P PxtPtomunMni%_sseBereAiieenhemgSto eONnie%l_brGdMmetrlNede%nioae axPseer, pCmtMPmgtoSHeEWyfeniFlsLnatctttedfsnsaetag %ttty %%cgettnPte%stm lieira timR%. nimeodS/ul auNihpChOr _antiLmieib.fYaraot.iCsrienntTNattm tDerRlpgdtneeexteatite%it%tiiS%nNcl emecstutentp uaSdrsnt ngghedrn%mslilen[legeNeteSmrcMe6xyefSsdyOi[tnIrtgeFECrvSfeyiFeSeoIonCtI%etaatSetl%rDdR%i%wd%gr%tide oim%uthrgrodTgtens eliba:ereamnienoRin rgnpta%atSidaSsEINdett%esg%0cMnepeiPenoPno%it%YnwlnraTtsfnfrevorueln%er%oIrnraEm:e omnDl rb enFTnaRaasvyfrepnpeps%aaliflNlhatrTrAwmArsnlsna', 499194);
      ee[0], function(ie, ne) {
        ee[137] == "object" && ee[137] == "object" ? re[ee[586]] = ne() : ee[138] == "undefined" && (void 0)[ee[587]] ? (void 0)([], ne) : ee[137] == "object" ? te[ee[588]] = ne() : (ie[ee[589]] = ie[ee[589]] || {}, ie[ee[589]][ee[590]] = ie[ee[589]][ee[590]] || {}, ie[ee[589]][ee[590]][ee[588]] = ne());
      }(self, function() {
        return (self[ee[585]] = self[ee[585]] || [])[ee[212]]([[367], { 5945: function(ie, ne, ae) {
          var ue = this && this[ee[1]] || function() {
            return ue = Object[ee[2]] || function(ye) {
              for (var Se, we = 1, Pe = arguments[ee[3]]; we < Pe; we++)
                for (var Te in Se = arguments[we])
                  Object[ee[6]][ee[5]][ee[4]](Se, Te) && (ye[Te] = Se[Te]);
              return ye;
            }, ue[ee[7]](this, arguments);
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[10]] = oe, ne[ee[11]] = ce, ne[ee[12]] = he, ne[ee[13]] = ge, ne[ee[14]] = me, ne[ee[15]] = pe, ne[ee[16]] = $e;
          var _e = ae(27177), fe = ae(76885), le = ae(28915), se = ae(92983);
          function oe(ye) {
            return (0, _e[ee[17]])(ye) && ye[ee[18]] != null;
          }
          function ce(ye) {
            return (0, _e[ee[17]])(ye) && Array[ee[20]](ye[ee[19]]) && ye[ee[19]][ee[3]] > 0;
          }
          function he(ye) {
            return (0, _e[ee[17]])(ye) && ye[ee[21]] != null;
          }
          function ge(ye, Se) {
            var we = (0, se[ee[22]])(ye[ee[18]], Se), Pe = fe[ee[24]][ee[23]](me(Se), we);
            return ue(ue({}, (0, le[ee[25]])(Se)), { url: Pe, mediaURL: we });
          }
          function ve(ye) {
            var Se, we, Pe = (we = (Se = ye[ee[26]]) === null || Se === void 0 ? void 0 : Se[ee[29]](ee[28])[ee[27]](function(Te) {
              return parseInt(Te);
            })) !== null && we !== void 0 ? we : [];
            return Pe[ee[3]] > 1 ? { start: Pe[0], end: Pe[1] } : null;
          }
          function me(ye) {
            return ye[ee[30]] ? fe[ee[24]][ee[31]](ye[ee[30]][0]) : ee[32];
          }
          function be(ye, Se) {
            return ye[ee[33]] ? ye[ee[33]] : me(Se);
          }
          function pe(ye, Se) {
            var we = ye[ee[19]][0], Pe = be(we, Se), Te = fe[ee[24]][ee[23]](me(Se), Pe), Ee = ve(we);
            return ue(ue({}, (0, le[ee[25]])(Se)), { url: Te, mediaURL: Pe, byteRange: Ee });
          }
          function $e(ye, Se) {
            var we = me(Se), Pe = { start: 0, end: parseInt(ye[ee[21]][ee[29]](ee[28])[0]) - 1 };
            return ue(ue({}, (0, le[ee[25]])(Se)), { url: we, mediaURL: we, byteRange: Pe });
          }
        }, 52832: function(ie, ne, ae) {
          var ue = this && this[ee[1]] || function() {
            return ue = Object[ee[2]] || function(Pe) {
              for (var Te, Ee = 1, Me = arguments[ee[3]]; Ee < Me; Ee++)
                for (var Ae in Te = arguments[Ee])
                  Object[ee[6]][ee[5]][ee[4]](Te, Ae) && (Pe[Ae] = Te[Ae]);
              return Pe;
            }, ue[ee[7]](this, arguments);
          }, _e = this && this[ee[34]] || function(Pe, Te, Ee) {
            if (Ee || arguments[ee[3]] === 2)
              for (var Me, Ae = 0, Ne = Te[ee[3]]; Ae < Ne; Ae++)
                !Me && Ae in Te || (Me || (Me = Array[ee[6]][ee[35]][ee[4]](Te, 0, Ae)), Me[Ae] = Te[Ae]);
            return Pe[ee[36]](Me || Array[ee[6]][ee[35]][ee[4]](Te));
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[37]] = void 0;
          var fe = ae(25550), le = ae(28764), se = ae(18665), oe = ae(88005), ce = ae(59181), he = ae(90637), ge = ae(36564), ve = ae(67345), me = ae(76650), be = ae(8272), pe = ae(331), $e = ae(76885), ye = ae(51040), Se = function() {
            function Pe(Te, Ee) {
              var Me = this;
              this[ee[38]] = 0, this[ee[39]] = function(Ne, Ce, Ie) {
                return Me[ee[48]][ee[47]][ee[46]](se[ee[41]][ee[40]], function(xe) {
                  return xe[ee[43]](Ne, Ne[ee[42]]);
                }, null, Me[ee[45]][ee[44]]), Ne[ee[49]] ? Me[ee[50]](Ne, Ie, Ce) : (Me[ee[53]][ee[52]](null, null)[ee[51]](function() {
                }), null);
              }, this[ee[54]] = function(Ne, Ce) {
                Me[ee[55]] = we(Ne, Ce, Me[ee[45]][ee[44]]);
              }, this[ee[48]] = Te, this[ee[45]] = Ee, this[ee[56]] = Te[ee[56]], this[ee[57]] = new ye[ee[58]](Te, Ee), this[ee[59]] = !1, this[ee[60]] = Te[ee[60]], this[ee[61]] = [];
              var Ae = { onFailure: this[ee[54]], maxRetries: this[ee[56]][ee[62]], requestType: ve[ee[64]][ee[63]], resetRetriesWhenOffline: !1 };
              this[ee[53]] = new oe[ee[65]](Te, Ae);
            }
            return Pe[ee[6]][ee[66]] = function(Te, Ee) {
              if (this[ee[59]])
                return null;
              var Me = Te[ee[67]]();
              return this[ee[68]](Me, Ee);
            }, Pe[ee[6]][ee[68]] = function(Te, Ee) {
              var Me, Ae = this[ee[48]][ee[47]][ee[69]](se[ee[41]][ee[40]], this[ee[45]][ee[44]]), Ne = (Me = Ae == null ? void 0 : Ae[ee[70]](this[ee[42]])) !== null && Me !== void 0 ? Me : this[ee[71]](Te, Ee);
              return Ne ? (Ae == null || Ae[ee[72]](Ne, this[ee[42]]), this[ee[61]] = Ne[ee[30]] ? _e(_e([], Ne[ee[73]], !0), Ne[ee[30]][ee[27]](function(Ce) {
                return Ce[ee[42]];
              }), !0) : Ne[ee[73]], this[ee[42]] = this[ee[61]][0], Ne) : null;
            }, Pe[ee[6]][ee[71]] = function(Te, Ee) {
              return this[ee[57]][ee[74]](Te, this[ee[42]], Ee);
            }, Pe[ee[6]][ee[75]] = function() {
              this[ee[53]] && this[ee[53]][ee[76]](), this[ee[59]] = !0, this[ee[42]] = null;
            }, Pe[ee[6]][ee[77]] = function() {
              this[ee[75]](), this[ee[53]][ee[77]](), this[ee[57]] && (this[ee[57]][ee[77]](), this[ee[57]] = null), this[ee[56]] = null;
            }, Pe[ee[6]][ee[52]] = function(Te) {
              var Ee = this;
              return this[ee[42]] = Te || this[ee[42]], this[ee[55]] = null, Te && (this[ee[59]] = !1), this[ee[42]] ? this[ee[88]](this[ee[42]])[ee[87]](function(Me) {
                return Ee[ee[39]](Me, Me[ee[86]], Ee[ee[42]]);
              })[ee[51]](function(Me) {
                return Ee[ee[59]] || (Me == null ? void 0 : Me[ee[78]]) === he[ee[80]][ee[79]] ? Promise[ee[81]]() : (Ee[ee[48]][ee[85]][ee[84]](ee[82] + Ee[ee[42]] + ee[83], Me), Promise[ee[81]](Me));
              }) : (this[ee[48]][ee[60]][ee[93]](new le[ee[92]](fe[ee[90]][ee[89]], void 0, ee[91])), Promise[ee[81]](ee[94]));
            }, Pe[ee[6]][ee[88]] = function(Te) {
              var Ee, Me = this, Ae = this[ee[48]][ee[47]][ee[46]](se[ee[41]][ee[40]], function(Ce) {
                return Ce[ee[95]](Te);
              }, null, this[ee[45]][ee[44]]);
              if (Ae)
                return Promise[ee[96]](Ae);
              var Ne = (Ee = this[ee[45]][ee[98]][ee[97]]) === null || Ee === void 0 ? void 0 : Ee[ee[99]];
              return this[ee[53]][ee[52]](Te, ve[ee[103]][ee[102]], null, null, null, Ne, ce[ee[105]][ee[104]])[ee[51]](function(Ce) {
                return Me[ee[38]]++, Me[ee[38]] < Me[ee[61]][ee[3]] ? (Me[ee[42]] = $e[ee[24]][ee[100]](Me[ee[42]], Me[ee[61]][Me[ee[38]]]), Me[ee[88]](Me[ee[42]])) : (Me[ee[48]][ee[85]][ee[84]](ee[101]), Me[ee[55]] && Me[ee[60]][ee[93]](Me[ee[55]]), Me[ee[55]] = null, Promise[ee[81]](Ce));
              });
            }, Pe[ee[6]][ee[106]] = function(Te) {
              return Promise[ee[96]](Te);
            }, Pe[ee[6]][ee[107]] = function(Te) {
              return Promise[ee[96]]();
            }, Pe[ee[6]][ee[50]] = function(Te, Ee, Me) {
              var Ae, Ne;
              (0, ge[ee[108]])(Te) && (this[ee[48]][ee[85]][ee[84]](ee[112][ee[36]]((Ae = Te[ee[86]]) === null || Ae === void 0 ? void 0 : Ae[ee[110]](2), ee[111])[ee[36]]((Ne = Te[ee[109]]) === null || Ne === void 0 ? void 0 : Ne[ee[110]](2))), this[ee[48]][ee[117]][ee[116]]((0, me[ee[115]])(ee[22], be[ee[114]][ee[113]], { bytes: Te[ee[3]], time: Te[ee[86]], timeToFirstByte: Te[ee[109]] }))), this[ee[42]] = Te[ee[42]];
              var Ce = ue({}, this[ee[66]](Te[ee[49]], (0, pe[ee[119]])(Math[ee[118]](Me))));
              return Ce[ee[120]] = this[ee[42]], this[ee[53]][ee[121]](!0), Ce;
            }, Pe;
          }();
          function we(Pe, Te, Ee) {
            return (Te == null ? void 0 : Te[ee[122]]) === he[ee[80]][ee[79]] ? null : (Pe == null ? void 0 : Pe[ee[123]]) === 0 ? (Te == null ? void 0 : Te[ee[122]]) === he[ee[80]][ee[124]] ? new le[ee[92]](fe[ee[90]][ee[125]], { sourceUrl: Pe[ee[42]] }, ee[126], Ee) : new le[ee[92]](fe[ee[90]][ee[127]], { url: Pe[ee[42]], statusCode: Pe[ee[123]], statusText: Pe[ee[128]] }, ee[130][ee[36]](Pe[ee[123]], ee[129])[ee[36]](Pe[ee[128]]), Ee) : new le[ee[92]](fe[ee[90]][ee[131]], { sourceUrl: Pe[ee[42]], statusCode: Pe[ee[123]] }, ee[134][ee[36]](Pe[ee[123]], ee[133])[ee[36]](Pe[ee[128]], ee[132]), Ee);
          }
          ne[ee[37]] = Se;
        }, 51040: function(ie, ne, ae) {
          var ue = this && this[ee[1]] || function() {
            return ue = Object[ee[2]] || function(Ue) {
              for (var ke, Le = 1, De = arguments[ee[3]]; Le < De; Le++)
                for (var Re in ke = arguments[Le])
                  Object[ee[6]][ee[5]][ee[4]](ke, Re) && (Ue[Re] = ke[Re]);
              return Ue;
            }, ue[ee[7]](this, arguments);
          }, _e = this && this[ee[135]] || function(Ue, ke, Le, De) {
            var Re, Oe = arguments[ee[3]], Be = Oe < 3 ? ke : De === null ? De = Object[ee[136]](ke, Le) : De;
            if (ee[137] == typeof Reflect && ee[138] == typeof Reflect[ee[139]])
              Be = Reflect[ee[139]](Ue, ke, Le, De);
            else
              for (var Fe = Ue[ee[3]] - 1; Fe >= 0; Fe--)
                (Re = Ue[Fe]) && (Be = (Oe < 3 ? Re(Be) : Oe > 3 ? Re(ke, Le, Be) : Re(ke, Le)) || Be);
            return Oe > 3 && Be && Object[ee[9]](ke, Le, Be), Be;
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[30]] = ne[ee[58]] = void 0, ne[ee[140]] = Ee, ne[ee[141]] = Me;
          var fe = ae(63546), le = ae(35148), se = ae(62510), oe = ae(92737), ce = ae(16937), he = ae(33696), ge = ae(42283), ve = ae(44388), me = ae(26190), be = ae(79814), pe = ae(76885), $e = ae(91520), ye = ae(16368), Se = new RegExp(ee[142], ee[143]), we = [ee[144], ee[145], ee[146], ee[147], ee[148]], Pe = ee[149], Te = function() {
            function Ue(ke, Le) {
              this[ee[48]] = ke, this[ee[45]] = Le, this[ee[150]] = ke[ee[150]];
              var De = $e[ee[153]][ee[69]](ye[ee[152]][ee[151]]);
              this[ee[154]] = De[ee[154]], this[ee[155]] = De[ee[155]];
            }
            return Ue[ee[6]][ee[156]] = function(ke, Le) {
              return (0, me[ee[158]])({ source: this[ee[45]][ee[98]], logger: this[ee[48]][ee[85]], streamType: he[ee[157]][ee[104]], labelingType: ke }, Le);
            }, Ue[ee[6]][ee[159]] = function(ke) {
              var Le, De, Re, Oe = (Re = (De = (Le = ke[ee[160]]) === null || Le === void 0 ? void 0 : Le[0]) === null || De === void 0 ? void 0 : De[ee[161]]) !== null && Re !== void 0 ? Re : ke[ee[162]], Be = { mimeType: ke[ee[163]], lang: ke[ee[164]] };
              return this[ee[156]](me[ee[166]][ee[165]], Be) || Oe;
            }, Ue[ee[6]][ee[167]] = function(ke, Le) {
              var De, Re, Oe, Be = (Oe = (Re = (De = Le[ee[160]]) === null || De === void 0 ? void 0 : De[0]) === null || Re === void 0 ? void 0 : Re[ee[161]]) !== null && Oe !== void 0 ? Oe : Le[ee[162]], Fe = { id: Le[ee[168]], mimeType: ke, bitrate: Le[ee[169]], qualityRanking: Le[ee[170]], width: Le[ee[171]], height: Le[ee[172]], frameRate: Le[ee[173]] };
              return this[ee[156]](me[ee[166]][ee[174]], Fe) || Be;
            }, Ue[ee[6]][ee[175]] = function(ke) {
              var Le = this, De = 0;
              for (var Re in ke)
                if (ke[ee[5]](Re)) {
                  if (ee[176] === Re && this[ee[177]](ke, ke[Re]), ee[178] === Re && Ie(ke[Re]))
                    return this[ee[48]][ee[85]][ee[84]](ee[181][ee[36]](ke[ee[168]], ee[180])[ee[36]](ke[ee[179]])), null;
                  ee[160] === Re && (ke[ee[160]] = Ce(ke[Re])), ee[182] === Re || Re[ee[184]](ee[183]) === 0 || Array[ee[20]](ke[Re]) || (ke[Re] = [ke[Re]]), ee[185] === Re && (ke[Re] = ke[Re][ee[198]](function(Oe) {
                    var Be = Oe[ee[163]] || ke[ee[163]];
                    Oe[ee[163]] = Oe[ee[163]] || ke[ee[163]], Be && (Be = Be[ee[186]]()), Ee(Oe, ke), Ae(Oe), Ne(Oe), ee[187] == typeof Oe[ee[169]] && (Oe[ee[169]] = parseFloat(Oe[ee[169]])), Oe[ee[160]] && (Oe[ee[160]] = Ce(Oe[ee[160]]));
                    var Fe = Oe[ee[188]] || ke[ee[188]];
                    if (Be && (Be[ee[184]](ee[189]) === 0 || Be[ee[184]](ee[190]) === 0 || Be[ee[184]](ee[191]) === 0 || Be[ee[184]](ee[192]) >= 0))
                      De++, Oe[ee[162]] = Le[ee[167]](Be, Oe);
                    else if (Be && Fe) {
                      if (Oe[ee[188]] = Fe, !ge[ee[194]][ee[193]](Le[ee[150]], Be, Fe))
                        return Le[ee[48]][ee[85]][ee[84]](ee[195] + Be + ee[196] + Fe + ee[197]), !1;
                      De++, Oe[ee[162]] = Le[ee[167]](Be, Oe);
                    }
                    return !0;
                  }));
                }
              return De > 0 ? (!ke[ee[5]](ee[163]) && ke[ee[185]][0][ee[5]](ee[163]) && (ke[ee[163]] = ke[ee[185]][0][ee[163]]), ke[ee[162]] = this[ee[159]](ke), ke[ee[185]][ee[199]](function(Oe, Be) {
                return Oe[ee[169]] - Be[ee[169]];
              }), ke) : (this[ee[48]][ee[85]][ee[84]](ee[201][ee[36]](ke[ee[168]], ee[180])[ee[36]](ke[ee[179]], ee[200])), null);
            }, Ue[ee[6]][ee[177]] = function(ke, Le) {
              var De = 2;
              ke[ee[202]] = {};
              var Re = Ue[ee[204]](Le, ee[203]);
              Ue[ee[208]](Re)[ee[207]](function(Oe, Be) {
                var Fe = Oe[ee[29]](ee[205]), Ve = Fe[ee[3]] === De ? [Fe[0], Fe[1]] : [ee[206] + Be, Oe], Ke = Ve[0], Ze = Ve[1];
                ke[ee[202]][Ke] = { label: Ze, lang: Ze };
              });
            }, Ue[ee[204]] = function(ke, Le) {
              return ke && ke[ee[3]] > 0 ? ke[ee[198]](function(De) {
                return De[ee[209]] === Le;
              }) : [];
            }, Ue[ee[208]] = function(ke) {
              var Le = [];
              return ke[ee[207]](function(De) {
                if (De[ee[210]]) {
                  var Re = De[ee[210]][ee[29]](ee[211]);
                  Le[ee[212]][ee[7]](Le, Re);
                }
              }), Le;
            }, Ue[ee[6]][ee[213]] = function(ke, Le) {
              for (var De = 0; De < ke[ee[3]]; De++)
                if (ee[187] == typeof Le && ke[De][ee[42]] === Le || ee[137] == typeof Le && ke[De][ee[42]] === Le[ee[42]])
                  return !0;
              return !1;
            }, Ue[ee[6]][ee[214]] = function(ke, Le, De, Re) {
              var Oe;
              Array[ee[20]](ke[ee[30]]) || (ke[ee[30]] = [ke[ee[30]]]);
              for (var Be = [], Fe = 0; Fe < ke[ee[30]][ee[3]]; Fe++) {
                if ((Oe = new xe())[ee[215]] = [], Le != null && (Oe[ee[216]] = {}, Le[0] !== void 0 && Le[0] !== null && (Oe[ee[216]][ee[217]] = Le[0]), Le[1] !== void 0 && Le[1] !== null && (Oe[ee[216]][ee[218]] = Le[1]), Le[2] !== void 0 && Le[2] !== null && (Oe[ee[216]][ee[219]] = Le[2])), ee[187] == typeof ke[ee[30]][Fe])
                  Oe[ee[42]] = ke[ee[30]][Fe];
                else if (ee[137] == typeof ke[ee[30]][Fe]) {
                  for (var Ve in ke[ee[30]][Fe][ee[5]](ee[144]) && (Oe[ee[42]] = ke[ee[30]][Fe][ee[144]]), ke[ee[30]][Fe][ee[5]](ee[146]) && (Oe[ee[220]] = ke[ee[30]][Fe][ee[146]]), ke[ee[30]][Fe][ee[5]](ee[145]) && (Oe[ee[220]] = ke[ee[30]][Fe][ee[145]]), ke[ee[30]][Fe][ee[5]](ee[147]) && (Oe[ee[220]] = ke[ee[30]][Fe][ee[147]]), ke[ee[30]][Fe][ee[5]](ee[148]) && (Oe[ee[220]] = ke[ee[30]][Fe][ee[148]]), ke[ee[30]][Fe])
                    if (ke[ee[30]][Fe][ee[5]](Ve) && Ve[ee[184]](ee[183]) === 0 && we[ee[184]](Ve) === -1) {
                      var Ke = {};
                      Ke[Ve[ee[221]](1)] = ke[ee[30]][Fe][Ve], Oe[ee[215]][ee[212]](Ke);
                    }
                }
                Be[ee[212]](Oe);
              }
              for (ke[ee[30]] = [], Fe = 0; Fe < Be[ee[3]]; Fe++) {
                var Ze = Be[Fe];
                if (pe[ee[24]][ee[222]](Ze))
                  this[ee[213]](ke[ee[30]], Ze) || (Ze[ee[223]] = !0, Re[ee[212]](Ze), ke[ee[30]][ee[212]](Ze));
                else
                  for (var nt = 0; nt < De[ee[3]]; nt++) {
                    var Qe = De[nt][ee[224]]();
                    ee[225] !== De[nt][ee[42]][De[nt][ee[42]][ee[3]] - 1] && (Qe += ee[225]);
                    var qe = pe[ee[24]][ee[226]](Qe, Ze);
                    this[ee[213]](ke[ee[30]], qe) || ((Oe = new xe())[ee[42]] = qe, Oe[ee[216]] = {}, Le[0] !== void 0 && Le[0] !== null && (Oe[ee[216]][ee[217]] = Le[0]), Le[1] !== void 0 && Le[1] !== null && (Oe[ee[216]][ee[218]] = Le[1]), Le[2] !== void 0 && Le[2] !== null && (Oe[ee[216]][ee[219]] = Le[2]), Oe[ee[220]] = Ze[ee[220]] || De[nt][ee[220]], Oe[ee[227]] = Ze[ee[227]] || De[nt][ee[227]], Oe[ee[228]] = Ze[ee[228]] || De[nt][ee[228]], Oe[ee[229]] = Ze[ee[229]] || De[nt][ee[229]], ke[ee[30]][ee[212]](Oe), Re[ee[212]](Oe));
                  }
              }
              return Re;
            }, Ue[ee[6]][ee[230]] = function(ke, Le, De) {
              var Re = [];
              if (Le = Le || [], De = De || [], ee[137] != typeof ke)
                return ke;
              for (var Oe in ke[ee[5]](ee[30]) && (Re = this[ee[214]](ke, De, Le, Re)), Re[ee[3]] < 1 && (Re = Le), ke)
                if (ke[ee[5]](Oe))
                  if (ee[137] == typeof ke[Oe] && Oe[ee[184]](ee[183]) !== 0) {
                    Array[ee[20]](ke[Oe]) || (ke[Oe] = [ke[Oe]]);
                    for (var Be = 0; Be < ke[Oe][ee[3]]; Be++)
                      if (ee[30] !== Oe) {
                        var Fe = ke[Oe][Be][ee[168]] || Be + ee[32];
                        ke[Oe][Be] = this[ee[230]](ke[Oe][Be], Re, De[ee[36]]([Fe])), ee[185] !== Oe || ke[Oe][Be][ee[5]](ee[30]) || (ke[Oe][Be][ee[30]] = Re);
                      }
                  } else
                    Oe[ee[184]](ee[183]) !== 0 || !Se[ee[231]](Oe) && ee[232] !== Oe || (ke[ee[162]] = ke[Oe], ee[162] !== Oe && delete ke[Oe]);
              return ke;
            }, Ue[ee[6]][ee[233]] = function(ke) {
              var Le = ve[ee[236]][ee[235]](ke[ee[234]]);
              return (Le = isNaN(Le) ? Number[ee[237]] : -Le) > 0 && Le < this[ee[48]][ee[239]][ee[238]]() && (Le = this[ee[48]][ee[239]][ee[238]]()), Le;
            }, Ue[ee[240]] = function(ke) {
              Array[ee[20]](ke[ee[241]]) || (ke[ee[241]] = [ke[ee[241]]]);
              for (var Le, De = [], Re = [], Oe = [], Be = [], Fe = [], Ve = [], Ke = ke[ee[241]], Ze = 0; Ze < Ke[ee[3]]; Ze++) {
                Ke[Ze][ee[5]](ee[168]) && Ke[Ze][ee[168]] ? De[ee[212]](Ke[Ze][ee[168]]) : Be[ee[212]](Ke[Ze]), Array[ee[20]](Ke[Ze][ee[242]]) || (Ke[Ze][ee[242]] = [Ke[Ze][ee[242]]]);
                for (var nt = Ke[Ze][ee[242]], Qe = 0; Qe < nt[ee[3]]; Qe++) {
                  nt[Qe][ee[5]](ee[168]) && nt[Qe][ee[168]] ? Re[ee[212]](nt[Qe][ee[168]]) : Fe[ee[212]](nt[Qe]), nt[Qe][ee[179]] = Ke[Ze][ee[168]], Array[ee[20]](nt[Qe][ee[185]]) || (nt[Qe][ee[185]] = [nt[Qe][ee[185]]]);
                  for (var qe = nt[Qe][ee[185]], ze = 0; ze < qe[ee[3]]; ze++)
                    qe[ze][ee[5]](ee[168]) && qe[ze][ee[168]] ? Oe[ee[212]](qe[ze][ee[168]]) : Ve[ee[212]](qe[ze]);
                }
              }
              var je = 0;
              for (Le = 0; Le < Be[ee[3]]; Le++) {
                do
                  je++;
                while (De[ee[184]](ee[32] + je) !== -1);
                Be[Le][ee[168]] = ee[32] + je, Be[Le][ee[242]][ee[207]](function(tt) {
                  tt[ee[179]] = Be[Le][ee[168]];
                }), De[ee[212]](ee[32] + je);
              }
              for (je = 0, Le = 0; Le < Fe[ee[3]]; Le++) {
                do
                  je++;
                while (Re[ee[184]](ee[32] + je) !== -1);
                Fe[Le][ee[168]] = ee[32] + je, Re[ee[212]](ee[32] + je);
              }
              for (je = 0, Le = 0; Le < Ve[ee[3]]; Le++) {
                do
                  je++;
                while (Oe[ee[184]](ee[32] + je) !== -1);
                Ve[Le][ee[168]] = ee[32] + je, Oe[ee[212]](ee[32] + je);
              }
            }, Ue[ee[6]][ee[243]] = function(ke) {
              return ee[244] === ke[ee[245]] && (ke[ee[234]] = this[ee[233]](ke)), ke;
            }, Ue[ee[6]][ee[246]] = function(ke) {
              return ke[ee[247]] && (ke[ee[247]] = new Date(ke[ee[247]])[ee[248]]()), ke;
            }, Ue[ee[6]][ee[249]] = function(ke, Le) {
              return ke[ee[5]](ee[73]) ? Array[ee[20]](ke[ee[73]]) || (ke[ee[73]] = [ke[ee[73]]]) : ke[ee[73]] = [Le], ke;
            }, Ue[ee[6]][ee[250]] = function(ke) {
              ke[ee[5]](ee[30]) && !Array[ee[20]](ke[ee[30]]) && (ke[ee[30]] = [ke[ee[30]]]);
              for (var Le = [], De = 0; De < ke[ee[73]][ee[3]]; De++) {
                var Re = ke[ee[73]][De], Oe = new xe();
                Oe[ee[42]] = pe[ee[24]][ee[251]](Re), Le[ee[212]](Oe);
              }
              return ke = this[ee[230]](ke, Le, null);
            }, Ue[ee[6]][ee[252]] = function(ke, Le) {
              Le[ee[253]] ? Le[ee[254]] = ve[ee[236]][ee[235]](Le[ee[253]]) : (Le[ee[254]] = ke[ee[254]] + ke[ee[255]], Le[ee[253]] = ee[256] + Le[ee[254]] + ee[257]);
            }, Ue[ee[6]][ee[258]] = function(ke) {
              for (var Le = { start: 0, duration: 0, _start: ee[259], _duration: ee[259] }, De = 0; De < ke[ee[241]][ee[3]]; De++) {
                var Re = ke[ee[241]][De];
                this[ee[252]](Le, Re), Re[ee[260]] ? Re[ee[255]] = ve[ee[236]][ee[235]](Re[ee[260]]) : (ke[ee[241]][De + 1] ? Re[ee[255]] = (ve[ee[236]][ee[235]](ke[ee[241]][De + 1][ee[253]]) || 0) - Re[ee[254]] : ke[ee[261]] ? Re[ee[255]] = (ve[ee[236]][ee[235]](ke[ee[261]]) || 0) - Re[ee[254]] : Re[ee[255]] = 1 / 0, Re[ee[260]] = ee[256] + Re[ee[255]] + ee[257]), this[ee[48]][ee[85]][ee[84]](ee[264][ee[36]](De, ee[263])[ee[36]](Re[ee[168]], ee[262])[ee[36]](Re[ee[254]], ee[28])[ee[36]](Re[ee[254]] + Re[ee[255]])), ke[ee[241]][De] = Re, Le = Re;
              }
              return ke;
            }, Ue[ee[6]][ee[265]] = function(ke) {
              var Le, De, Re = this, Oe = [], Be = [], Fe = ve[ee[236]][ee[235]](ke[ee[261]]);
              return ke[ee[241]][ee[207]](function(Ve, Ke) {
                Le = ve[ee[236]][ee[235]](Ve[ee[253]]), De = ve[ee[236]][ee[235]](Ve[ee[260]]), isNaN(Le) && Be[ee[3]] === 0 && ee[266] === ke[ee[245]] && (Le = 0), isNaN(Le) && Be[ee[3]] > 0 && !isNaN(parseFloat(Be[Be[ee[3]] - 1][ee[254]])) && !isNaN(parseFloat(Be[Be[ee[3]] - 1][ee[255]])) && (Le = Be[Be[ee[3]] - 1][ee[254]] + Be[Be[ee[3]] - 1][ee[255]]), isNaN(Le) && Ke === ke[ee[241]][ee[3]] - 1 && !isNaN(Fe) && (De = Fe - Le), Be[ee[3]] > 0 && isNaN(parseFloat(Be[Be[ee[3]] - 1][ee[255]])) && !isNaN(Le) && (Be[Be[ee[3]] - 1][ee[255]] = Le - Be[Be[ee[3]] - 1][ee[254]]), Be[ee[212]]({ start: Le, duration: De });
                var Ze = function(Qe) {
                  if (Ve[ee[5]](Qe) && [ee[30], ee[242], ee[268]][ee[267]](Qe))
                    if (Array[ee[20]](Ve[Qe]) || (Ve[Qe] = [Ve[Qe]]), ee[242] === Qe) {
                      var qe = Ve[Qe][ee[27]](function(ze) {
                        var je = ze[ee[163]];
                        return !je && ze[ee[185]][ee[3]] > 0 && (je = ze[ee[185]][0][ee[163]]), be[ee[270]][ee[269]](je);
                      })[ee[198]](function(ze, je, tt) {
                        return tt[ee[184]](ze) === je;
                      });
                      Ve[Qe] = Ve[Qe][ee[27]](function(ze) {
                        Ee(ze, Ve);
                        var je = Re[ee[175]](ze);
                        return je !== null && !je[ee[5]](ee[271]) && je[ee[185]][0][ee[5]](ee[271]) && (je[ee[271]] = je[ee[185]][0][ee[271]]), je;
                      })[ee[198]](function(ze) {
                        return !!ze;
                      }), qe[ee[198]](function(ze) {
                        return ee[279] === ze || ee[280] === ze;
                      })[ee[207]](function(ze) {
                        !Ve[Qe][ee[272]](function(je) {
                          return je[ee[163]][ee[267]](ze);
                        }) && Re[ee[48]][ee[60]][ee[278]](se[ee[274]][ee[273]], new fe[ee[277]](le[ee[276]][ee[275]]));
                      }), Ve[Qe][ee[3]] < 1 && Oe[ee[212]](Ke);
                    } else
                      ee[268] === Qe && Ve[Qe][ee[198]](function(ze) {
                        return ze[ee[282]];
                      })[ee[207]](function(ze) {
                        ze[ee[282]][ee[207]](function(je) {
                          je[ee[281]] = Re[ee[155]]({ event: je });
                        });
                      });
                };
                for (var nt in Ve)
                  Ze(nt);
              }), Oe[ee[3]] > 0 && ee[266] === ke[ee[245]] && this[ee[283]](Oe, Be, Fe, ke), ke = this[ee[258]](ke);
            }, Ue[ee[6]][ee[283]] = function(ke, Le, De, Re) {
              for (var Oe, Be, Fe; !isNaN(parseInt(Oe = ke[ee[284]]())); ) {
                if (Be = Le[Oe][ee[254]], Fe = Le[Oe][ee[255]], !isNaN(Be) && !isNaN(Fe)) {
                  isNaN(De) || (De -= Fe, Re[ee[261]] = ee[256] + De + ee[257]);
                  for (var Ve = Oe + 1; Ve < Le[ee[3]]; Ve++)
                    isNaN(parseFloat(Le[Ve][ee[254]])) || (Le[Ve][ee[254]] = Le[Ve][ee[254]] - Fe, Re[ee[241]][Ve][ee[253]] = ee[256] + Le[Ve][ee[254]] + ee[257]);
                }
                Le[ee[285]](Oe, 1), Re[ee[241]][ee[285]](Oe, 1);
              }
            }, Ue[ee[286]] = function(ke) {
              ke[ee[5]](ee[287]) && !Array[ee[20]](ke[ee[287]]) && (ke[ee[287]] = [ke[ee[287]]]);
              var Le = [];
              return (ke[ee[287]] || [])[ee[198]](function(De) {
                return De[ee[5]](ee[209]) && ee[187] == typeof De[ee[209]];
              })[ee[207]](function(De) {
                var Re = { schemeIdUri: De[ee[209]], value: ee[32] };
                ee[187] == typeof De[ee[210]] && (Re[ee[161]] = De[ee[210]]), Le[ee[212]](Re);
              }), Le[ee[3]] > 0 ? ke[ee[287]] = Le : delete ke[ee[287]], ke;
            }, Ue[ee[6]][ee[74]] = function(ke, Le, De) {
              var Re, Oe = this[ee[154]](ke, { decodeEntities: !0 });
              if (Oe[ee[288]] === !1)
                throw new oe[ee[92]](oe[ee[90]][ee[289]], { errorMessage: Oe[ee[290]][ee[78]] }, ee[291]);
              var Be = Oe[ee[293]][ee[292]];
              return Be[ee[294]] = Date[ee[295]](), Be[ee[296]] = De, Be[ee[245]] = (Re = Be[ee[245]]) !== null && Re !== void 0 ? Re : ee[266], Ue[ee[240]](Be), Be = this[ee[243]](Be), Be = this[ee[246]](Be), Be = this[ee[249]](Be, Le), Be = this[ee[250]](Be), Be = this[ee[265]](Be), (Be = Ue[ee[286]](Be)) && Be[ee[241]] && Be[ee[241]][ee[3]] !== 0 ? (Be[ee[297]] = ke, Be) : (this[ee[48]][ee[60]][ee[93]](new oe[ee[92]](oe[ee[90]][ee[289]])), null);
            }, Ue[ee[6]][ee[77]] = function() {
              this[ee[150]] = null;
            }, _e([(0, ce[ee[299]])(ee[298])], Ue[ee[6]], ee[74], null), Ue;
          }();
          function Ee(Ue, ke) {
            if (Ue && ke) {
              var Le = [ee[300], ee[301], ee[182]];
              Le[ee[207]](function(De) {
                var Re = Array[ee[20]](Ue[De]) && Ue[De][0], Oe = Array[ee[20]](ke[De]) && ke[De][0], Be = Le[ee[302]](function(Fe) {
                  return Ue[Fe];
                });
                Oe && Re ? Ue[De] = [ue(ue({}, ke[De][0]), Ue[De][0])] : Oe && !Be && (Ue[De] = ke[De]);
              });
            }
          }
          function Me(Ue) {
            var ke = Ue[ee[29]](ee[225]);
            return parseInt(ke[0]) / (parseInt(ke[1]) || 1);
          }
          function Ae(Ue) {
            ee[187] == typeof Ue[ee[303]] && (Ue[ee[303]] = parseFloat(Ue[ee[303]]));
          }
          function Ne(Ue) {
            ee[187] == typeof Ue[ee[172]] && (Ue[ee[172]] = parseFloat(Ue[ee[172]])), ee[187] == typeof Ue[ee[171]] && (Ue[ee[171]] = parseFloat(Ue[ee[171]])), ee[187] == typeof Ue[ee[304]] && (Ue[ee[304]] = Me(Ue[ee[304]]));
          }
          function Ce(Ue) {
            return ee[187] == typeof Ue ? [{ value: Ue }] : Array[ee[20]](Ue) ? Ue[ee[27]](function(ke) {
              return { id: ke[ee[168]], lang: ke[ee[164]], value: ke[ee[224]]() };
            }) : [];
          }
          function Ie(Ue) {
            var ke;
            return ((ke = Ue == null ? void 0 : Ue[0]) === null || ke === void 0 ? void 0 : ke[ee[209]]) === Pe;
          }
          ne[ee[58]] = Te;
          var xe = function() {
            function Ue() {
              this[ee[42]] = null, this[ee[216]] = null, this[ee[220]] = null, this[ee[227]] = null, this[ee[228]] = null, this[ee[229]] = null, this[ee[223]] = !1, this[ee[215]] = null;
            }
            return Ue[ee[6]][ee[224]] = function() {
              return this[ee[42]] ? ee[32] + this[ee[42]] : ee[32];
            }, Ue;
          }();
          ne[ee[30]] = xe;
        }, 84075: function(ie, ne, ae) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[305]] = void 0;
          var ue = ae(16368), _e = ae(5945), fe = ae(52832), le = ae(92983), se = ae(19213), oe = ae(44890), ce = ae(61411), he = { isIndexRangeNode: _e[ee[12]], isInitializationNode: _e[ee[11]], isInitializationStringNode: _e[ee[10]] }, ge = { provideSegmentInfoFromInitializationProperty: _e[ee[13]], provideSegmentInfoFromInitializationNodeProperty: _e[ee[15]], provideSegmentInfoFromIndexRangeProperty: _e[ee[16]] };
          ne[ee[305]] = { name: ue[ee[152]][ee[306]], module: function() {
            return { MPDLoader: fe[ee[37]], SegmentBaseMPDHandler: se[ee[307]], SegmentTemplateMPDHandler: oe[ee[308]], SegmentTimelineMPDHandler: ce[ee[309]], replaceAllPlaceholders: le[ee[22]], initSegmentInfoSourceDetectors: he, initSegmentInfoProviders: ge };
          }, dependencies: [ue[ee[152]][ee[310]], ue[ee[152]][ee[151]]] }, ne[ee[22]] = ne[ee[305]];
        }, 19213: function(ie, ne, ae) {
          var ue = this && this[ee[1]] || function() {
            return ue = Object[ee[2]] || function(Te) {
              for (var Ee, Me = 1, Ae = arguments[ee[3]]; Me < Ae; Me++)
                for (var Ne in Ee = arguments[Me])
                  Object[ee[6]][ee[5]][ee[4]](Ee, Ne) && (Te[Ne] = Ee[Ne]);
              return Te;
            }, ue[ee[7]](this, arguments);
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[307]] = void 0;
          var _e = ae(18665), fe = ae(60997), le = ae(88005), se = ae(67345), oe = ae(3941), ce = ae(10676), he = ae(76885), ge = ae(91520), ve = ae(16368), me = ae(94938), be = ae(28915), pe = ae(41735), $e = ae(5945), ye = function() {
            function Te(Ee) {
              var Me = this;
              this[ee[48]] = Ee, this[ee[311]] = 0, this[ee[312]] = -1, this[ee[313]] = (0, ce[ee[318]])(this[ee[315]][ee[314]](this), function(Ie, xe) {
                return xe[ee[317]][ee[316]];
              }), this[ee[319]] = function(Ie) {
                var xe = ue({}, Me[ee[322]][ee[321]](Me[ee[320]]));
                return Me[ee[313]](Ie, xe)[ee[87]](function(Ue) {
                  var ke;
                  if (Me[ee[325]][ee[116]]((0, pe[ee[324]])(xe[ee[317]], Ue)), Me[ee[325]][ee[116]]((0, pe[ee[326]])(xe[ee[317]], !1)), Ue || (Me[ee[325]][ee[116]]((0, pe[ee[327]])(xe[ee[317]], !0)), Me[ee[48]][ee[85]][ee[330]](ee[329][ee[36]]((ke = Me[ee[320]]) === null || ke === void 0 ? void 0 : ke[ee[328]]()))), Me[ee[312]] >= 0) {
                    var Le = Me[ee[312]];
                    Me[ee[312]] = -1, Me[ee[331]](Le);
                  }
                  return Me[ee[332]] = null, Me[ee[320]];
                })[ee[51]](function(Ue) {
                  throw Me[ee[313]][ee[323]](), Ue;
                });
              }, this[ee[333]] = function(Ie) {
                return Me[ee[332]] = null, Me[ee[48]][ee[85]][ee[330]](ee[337][ee[36]](Me[ee[320]][ee[328]](), ee[336])[ee[36]](JSON[ee[334]](Ie), ee[335])), Promise[ee[81]](JSON[ee[334]](Ie));
              }, this[ee[338]] = function(Ie) {
                return Me[ee[339]] ? Promise[ee[81]](ee[340]) : new Promise(function(xe, Ue) {
                  Me[ee[339]] = ue(ue({}, Ie), { resolve: xe, reject: Ue });
                });
              }, this[ee[56]] = Ee[ee[56]];
              var Ae = Ee[ee[45]][ee[44]];
              this[ee[322]] = Ee[ee[47]][ee[69]](_e[ee[41]][ee[341]], Ae);
              var Ne = this[ee[322]][ee[342]]() || { _id: oe[ee[343]] };
              this[ee[344]] = Ne[ee[168]];
              var Ce = this[ee[56]][ee[345]];
              this[ee[53]] = new le[ee[65]](Ee, { maxRetries: Ce, retryDelay: this[ee[56]][ee[346]], requestType: se[ee[64]][ee[347]] }), this[ee[325]] = Ee[ee[47]][ee[69]](_e[ee[41]][ee[348]], Ae);
            }
            return Te[ee[6]][ee[349]] = function(Ee) {
              var Me, Ae, Ne = this[ee[322]][ee[321]](Ee);
              if (Ne && Ne[ee[350]]) {
                var Ce = this[ee[322]][ee[351]](this[ee[344]]);
                isFinite(Ce) && (Ae = Ce / Ne[ee[350]][ee[352]][ee[3]]);
                var Ie = this[ee[322]][ee[353]]();
                Ie !== 0 && (isFinite(Ie) && (Me = Ie / Ne[ee[350]][ee[352]][ee[3]]), Ae || (Ae = Me)), Ne[ee[350]] && (Me = Ne[ee[350]][ee[352]][0][ee[255]] / Ne[ee[350]][ee[354]], Ae || (Ae = Me));
              }
              return Ae;
            }, Te[ee[6]][ee[355]] = function() {
              var Ee, Me, Ae = this[ee[322]][ee[321]](this[ee[356]]);
              if (!((Me = (Ee = Ae == null ? void 0 : Ae[ee[350]]) === null || Ee === void 0 ? void 0 : Ee[ee[352]]) === null || Me === void 0) && Me[ee[3]]) {
                var Ne = Ae[ee[350]][ee[354]] || 1, Ce = Ae[ee[350]][ee[352]][this[ee[311]]][ee[357]] / Ne, Ie = this[ee[358]](), xe = { url: ee[32], byteRange: Ae[ee[350]][ee[352]][this[ee[311]]][ee[227]], periodId: Ae[ee[317]][ee[344]], presentationTimeOffset: Ie, startTime: Ce - Ie };
                return xe[ee[359]] = (0, be[ee[360]])(xe), this[ee[311]]++, this[ee[361]] = Math[ee[363]](this[ee[311]] * this[ee[362]]()) + this[ee[364]](), xe;
              }
            }, Te[ee[6]][ee[365]] = function(Ee) {
              var Me = this[ee[322]][ee[321]](Ee);
              return Me && Me[ee[300]] && Me[ee[30]] ? ue(ue({}, this[ee[366]](Me)), { codecs: (0, me[ee[368]])(this[ee[322]][ee[367]](Ee)) }) : null;
            }, Te[ee[6]][ee[366]] = function(Ee) {
              var Me, Ae = Ee[ee[300]][0];
              return (0, $e[ee[11]])(Ae) ? (0, $e[ee[15]])(Ae, Ee) : Ee[ee[350]] ? (0, $e[ee[12]])(Ae) ? (0, $e[ee[16]])(Ae, Ee) : null : (this[ee[48]][ee[85]][ee[84]](ee[370][ee[36]]((Me = Ee[ee[317]]) === null || Me === void 0 ? void 0 : Me[ee[328]](), ee[369])), null);
            }, Te[ee[6]][ee[371]] = function() {
              if (this[ee[339]]) {
                var Ee = this[ee[355]]();
                Ee && (this[ee[339]][ee[96]](Ee), this[ee[339]] = null);
              }
            }, Te[ee[6]][ee[372]] = function(Ee) {
              this[ee[373]] = Ee, this[ee[374]] = Ee[ee[375]][ee[29]](ee[28])[0], this[ee[376]](), this[ee[371]]();
            }, Te[ee[6]][ee[376]] = function() {
              var Ee, Me = this, Ae = this[ee[322]][ee[321]](this[ee[356]]);
              Ae && (Ee = Ae[ee[169]]);
              var Ne = this[ee[322]][ee[377]](this[ee[373]], Ee), Ce = this[ee[356]] ? Ne[ee[302]](function(xe) {
                return xe[ee[317]] === Me[ee[356]];
              }) : null, Ie = Ce ?? Ne[0];
              this[ee[356]] = Ie[ee[317]], this[ee[344]] = this[ee[356]][ee[344]], Ie[ee[350]] || (this[ee[106]](this[ee[356]]), Ie = this[ee[322]][ee[321]](Ie[ee[317]])), Ie[ee[5]](ee[300]) && Ie[ee[300]][ee[3]] > 1 && this[ee[48]][ee[85]][ee[84]](ee[379][ee[36]](Ie[ee[168]], ee[378]));
            }, Te[ee[6]][ee[380]] = function(Ee) {
              return !!this[ee[322]][ee[321]](Ee) && (this[ee[356]] = Ee, this[ee[331]](this[ee[361]]), !0);
            }, Te[ee[6]][ee[381]] = function() {
              var Ee = this[ee[382]]();
              return this[ee[383]](Ee);
            }, Te[ee[6]][ee[383]] = function(Ee) {
              var Me = this, Ae = {};
              return this[ee[322]][ee[367]](this[ee[373]])[ee[185]][ee[207]](function(Ne) {
                var Ce = Ne[ee[168]];
                if (Ae[Ce] = [], Ne[ee[30]][ee[3]] === 1) {
                  var Ie = Ne[ee[30]][0][ee[42]];
                  Ae[Ce][ee[212]]({ url: he[ee[24]][ee[385]](Ie, Me[ee[56]][ee[384]]) });
                } else
                  for (var xe = 0; xe < Ne[ee[30]][ee[3]]; xe++)
                    Ie = he[ee[24]][ee[385]](Ne[ee[30]][xe][ee[42]], Me[ee[56]][ee[384]]), Ae[Ce][ee[212]]({ url: Ie });
                Ae[Ce][ee[207]](function(Ue) {
                  Ue[ee[255]] = Ee[ee[386]] - Ee[ee[254]], Ue[ee[387]] = Ee[ee[254]];
                });
              }), Ae;
            }, Te[ee[6]][ee[388]] = function(Ee) {
              var Me = this[ee[355]]();
              return Me ? Promise[ee[96]](Me) : this[ee[338]]({ time: Ee });
            }, Te[ee[6]][ee[389]] = function() {
              var Ee = this[ee[322]][ee[390]](this[ee[356]]);
              return Ee ? Ee[0] : null;
            }, Te[ee[6]][ee[391]] = function() {
            }, Te[ee[6]][ee[392]] = function() {
              return -1;
            }, Te[ee[6]][ee[393]] = function() {
              return this[ee[322]][ee[394]]();
            }, Te[ee[6]][ee[395]] = function() {
              var Ee, Me = this;
              return this[ee[322]][ee[321]](this[ee[356]]) && (Ee = this[ee[349]](this[ee[356]])), Ee < 0 && (Ee = this[ee[322]][ee[367]](this[ee[373]])[ee[185]][ee[27]](function(Ae) {
                return Me[ee[349]](Ae[ee[317]]);
              })[ee[302]](function(Ae) {
                return Ae > 0;
              })), isFinite(Ee) ? [Ee, !0] : [1, !1];
            }, Te[ee[6]][ee[362]] = function() {
              return this[ee[395]]()[0];
            }, Te[ee[6]][ee[396]] = function() {
              this[ee[371]]();
              var Ee = this[ee[322]][ee[321]](this[ee[356]]);
              if (Ee) {
                if (Ee[ee[350]])
                  return this[ee[311]] < Ee[ee[350]][ee[352]][ee[3]];
                if (!this[ee[397]](this[ee[356]]))
                  return !0;
              }
              return !1;
            }, Te[ee[6]][ee[364]] = function() {
              var Ee, Me, Ae;
              return (Ae = (Me = (Ee = this[ee[322]]) === null || Ee === void 0 ? void 0 : Ee[ee[398]](this[ee[344]])) === null || Me === void 0 ? void 0 : Me[ee[254]]) !== null && Ae !== void 0 ? Ae : 0;
            }, Te[ee[6]][ee[331]] = function(Ee) {
              var Me, Ae;
              this[ee[361]] = Ee;
              var Ne = this[ee[395]](), Ce = Ne[0], Ie = Ne[1];
              if ((Ce < 0 || !Ie) && (this[ee[312]] = Ee), Ce > 0 && Ie && Ee > -1) {
                var xe = Math[ee[399]](Ee - this[ee[364]](), 0), Ue = (Me = this[ee[322]]) === null || Me === void 0 ? void 0 : Me[ee[321]](this[ee[356]]);
                this[ee[356]] && Ue && (this[ee[400]](Math[ee[363]](xe / Ce)), this[ee[48]][ee[85]][ee[84]](ee[404][ee[36]](Ee, ee[403])[ee[36]](this[ee[311]], ee[402])[ee[36]]((Ae = this[ee[356]]) === null || Ae === void 0 ? void 0 : Ae[ee[328]](), ee[401])[ee[36]](Ue[ee[163]], ee[335])));
              }
            }, Te[ee[6]][ee[358]] = function() {
              var Ee = this[ee[322]][ee[398]](this[ee[344]]), Me = this[ee[322]][ee[321]](this[ee[356]]), Ae = Me && Me[ee[300]] ? Me[ee[300]][0] : null, Ne = 0;
              if (Ae && Ae[ee[5]](ee[405]) && Ae[ee[5]](ee[406])) {
                var Ce = Ae[ee[5]](ee[406]) ? parseInt(Ae[ee[406]]) : 1;
                Ne = parseInt(Ae[ee[405]]) / Ce;
              }
              return Ee && (Ne -= Ee[ee[254]]), Ne;
            }, Te[ee[6]][ee[407]] = function() {
              return this[ee[311]];
            }, Te[ee[6]][ee[400]] = function(Ee) {
              this[ee[311]] = Ee;
            }, Te[ee[6]][ee[408]] = function(Ee) {
            }, Te[ee[6]][ee[106]] = function(Ee) {
              var Me = this;
              if (this[ee[332]])
                return this[ee[332]][ee[51]](function() {
                })[ee[87]](function() {
                  return Me[ee[106]](Ee);
                });
              var Ae = void 0, Ne = void 0, Ce = this[ee[322]][ee[321]](Ee);
              if (Ce) {
                if (this[ee[53]][ee[409]]())
                  return;
                this[ee[48]][ee[85]][ee[84]](ee[410][ee[36]](Ee == null ? void 0 : Ee[ee[328]](), ee[335])), Ae = (0, $e[ee[14]])(Ce), Ne = Ce[ee[300]][0][ee[21]];
                var Ie = parseInt(Ne[ee[29]](ee[28])[1]) + 1;
                return this[ee[325]][ee[116]]((0, pe[ee[411]])(Ce[ee[317]], Ie)), this[ee[320]] = Ee, this[ee[332]] = this[ee[53]][ee[52]](Ae, se[ee[103]][ee[102]], se[ee[413]][ee[412]], null, { Range: ee[414] + Ne })[ee[87]](function(xe) {
                  return Me[ee[319]](xe[ee[49]]);
                })[ee[51]](this[ee[333]]);
              }
              return this[ee[48]][ee[85]][ee[416]](ee[415][ee[36]](Ee == null ? void 0 : Ee[ee[328]](), ee[335])), Promise[ee[81]](null);
            }, Te[ee[6]][ee[397]] = function(Ee) {
              return this[ee[322]][ee[397]](Ee);
            }, Te[ee[6]][ee[417]] = function() {
              return this[ee[311]]--, !(this[ee[311]] < 0) || (this[ee[48]][ee[85]][ee[84]](ee[418]), this[ee[400]](0), !1);
            }, Te[ee[6]][ee[382]] = function() {
              return { start: 0, end: this[ee[322]][ee[353]]() };
            }, Te[ee[6]][ee[419]] = function() {
              return this[ee[339]];
            }, Te[ee[6]][ee[420]] = function(Ee) {
              this[ee[339]] = Ee;
            }, Te[ee[6]][ee[421]] = function(Ee) {
              return !0;
            }, Te[ee[6]][ee[422]] = function(Ee) {
              return Ee;
            }, Te[ee[6]][ee[423]] = function(Ee) {
              return Ee;
            }, Te[ee[6]][ee[77]] = function() {
              this[ee[56]] = null, this[ee[322]] = null, this[ee[356]] = null, this[ee[325]] = null, this[ee[53]] = (0, fe[ee[77]])(this[ee[53]]), this[ee[339]] = null, this[ee[313]] = null;
            }, Te[ee[6]][ee[424]] = function(Ee, Me) {
            }, Te[ee[6]][ee[425]] = function() {
              return this[ee[48]][ee[47]][ee[69]](_e[ee[41]][ee[428]])[ee[69]](this[ee[374]])[ee[427]](this[ee[365]](this[ee[320]]))[ee[87]](function(Ee) {
                return Ee[ee[426]]();
              })[ee[87]](function(Ee) {
                return Ee[ee[161]];
              });
            }, Te[ee[6]][ee[429]] = function(Ee, Me) {
              return this[ee[425]]()[ee[87]](function(Ae) {
                var Ne = ge[ee[153]][ee[69]](ve[ee[152]][ee[431]])[ee[430]], Ce = ge[ee[153]][ee[69]](ve[ee[152]][ee[431]])[ee[432]], Ie = new Ne(Ee), xe = new Ce(Ae[ee[435]]())[ee[434]][ee[433]], Ue = Se(Ie, parseInt(Me[ee[300]][0][ee[21]][ee[29]](ee[28])[1]) + 1, xe[ee[436]]() / xe[ee[437]]());
                return { timescale: xe[ee[437]](), references: Ue };
              });
            }, Te[ee[6]][ee[315]] = function(Ee, Me) {
              return ee[438] === this[ee[374]][ee[29]](ee[225])[1] ? this[ee[429]](Ee, Me) : Promise[ee[96]](this[ee[440]](Ee, Me[ee[439]]));
            }, Te[ee[6]][ee[440]] = function(Ee, Me) {
              if (!Ee || !Me)
                return this[ee[48]][ee[85]][ee[84]](ee[441]), null;
              var Ae = ge[ee[153]][ee[69]](ve[ee[152]][ee[446]])[ee[445]](Ee)[ee[444]][ee[302]](function(Ne) {
                return ee[442] === Ne[ee[443]];
              });
              return Ae ? { timescale: Ae[ee[354]], references: we(Ae[ee[352]], Ae[ee[447]] + Me, Ae[ee[448]]) } : (this[ee[48]][ee[85]][ee[84]](ee[449]), null);
            }, Te;
          }();
          function Se(Te, Ee, Me) {
            for (var Ae = Te[ee[452]][ee[451]](function(xe) {
              return xe[ee[450]];
            }), Ne = new Array(Ae[ee[3]]), Ce = Ee - Pe(Te), Ie = Ae[ee[3]] - 1; Ie >= 0; Ie--)
              Ne[Ie] = { time: Ae[Ie][ee[357]], byteRange: { start: Ce + Ae[Ie][ee[454]][0][ee[453]] } }, Ie === Ae[ee[3]] - 1 ? Ne[Ie][ee[255]] = Me - Ne[Ie][ee[357]] : (Ne[Ie][ee[227]][ee[386]] = Ne[Ie + 1][ee[227]][ee[254]] - 1, Ne[Ie][ee[255]] = Ne[Ie + 1][ee[357]] - Ne[Ie][ee[357]]);
            return Ne;
          }
          function we(Te, Ee, Me) {
            for (var Ae = [], Ne = 0, Ce = Te; Ne < Ce[ee[3]]; Ne++) {
              var Ie = Ce[Ne], xe = Ie[ee[455]], Ue = Ie[ee[456]], ke = Ee, Le = ke + xe - 1;
              Ae[ee[212]]({ byteRange: { start: ke, end: Le }, time: Me, duration: Ue }), Ee += xe, Me += Ue;
            }
            return Ae;
          }
          function Pe(Te) {
            var Ee = Te[ee[452]] && Te[ee[452]][0], Me = Ee && Ee[ee[450]] && Ee[ee[450]][0], Ae = Me && Me[ee[454]] && Me[ee[454]][0];
            return Ae && Ae[ee[453]] || 0;
          }
          ne[ee[307]] = ye;
        }, 44890: function(ie, ne, ae) {
          var ue = this && this[ee[1]] || function() {
            return ue = Object[ee[2]] || function($e) {
              for (var ye, Se = 1, we = arguments[ee[3]]; Se < we; Se++)
                for (var Pe in ye = arguments[Se])
                  Object[ee[6]][ee[5]][ee[4]](ye, Pe) && ($e[Pe] = ye[Pe]);
              return $e;
            }, ue[ee[7]](this, arguments);
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[308]] = void 0, ne[ee[457]] = pe;
          var _e = ae(18665), fe = ae(42055), le = ae(331), se = ae(70016), oe = ae(76885), ce = ae(96953), he = ae(73553), ge = ae(28915), ve = ae(5945), me = ae(92983), be = function() {
            function $e(ye) {
              this[ee[48]] = ye, this[ee[56]] = ye[ee[56]], this[ee[322]] = ye[ee[47]][ee[69]](_e[ee[41]][ee[341]], ye[ee[45]][ee[44]]), this[ee[357]] = 0;
            }
            return $e[ee[6]][ee[391]] = function() {
              var ye = this[ee[458]](this[ee[356]]);
              return ye && ye[ee[5]](ee[459]) ? parseInt(ye[ee[459]]) : 1;
            }, $e[ee[6]][ee[460]] = function() {
              var ye = this[ee[458]](this[ee[356]]);
              return ye && ye[ee[461]] ? parseInt(ye[ee[461]]) : NaN;
            }, $e[ee[6]][ee[372]] = function(ye, Se, we) {
              Se === void 0 && (Se = null), this[ee[373]] = ye, this[ee[356]] = Se;
              var Pe = !this[ee[356]] || !!this[ee[322]][ee[321]](this[ee[356]]), Te = this[ee[322]][ee[367]](this[ee[373]]);
              this[ee[356]] && Pe || (this[ee[356]] = Te[ee[185]][0][ee[317]]), this[ee[458]](this[ee[356]]) ? this[ee[311]] || this[ee[400]](this[ee[391]]()) : this[ee[48]][ee[85]][ee[84]](ee[462]), this[ee[371]]();
            }, $e[ee[6]][ee[463]] = function() {
              return this[ee[322]][ee[464]](this[ee[356]] || this[ee[373]]);
            }, $e[ee[6]][ee[380]] = function(ye) {
              return !!this[ee[322]][ee[321]](ye) && (this[ee[356]] = ye, !0);
            }, $e[ee[6]][ee[365]] = function(ye) {
              var Se = this[ee[458]](ye), we = this[ee[322]][ee[321]](ye);
              return (0, ve[ee[10]])(Se) ? (0, ve[ee[13]])(Se, we) : null;
            }, $e[ee[6]][ee[465]] = function() {
              var ye = this[ee[458]](this[ee[356]]);
              return parseFloat(ye[ee[147]]) || 0;
            }, $e[ee[6]][ee[466]] = function(ye) {
              var Se = this[ee[467]](ye);
              return Se -= this[ee[465]](), (0, le[ee[469]])(Se + this[ee[362]]() + this[ee[56]][ee[468]]);
            }, $e[ee[6]][ee[458]] = function(ye) {
              var Se = this[ee[322]][ee[321]](ye);
              if (Se != null && Se[ee[182]])
                return Se[ee[182]][0];
            }, $e[ee[6]][ee[364]] = function() {
              var ye;
              return ((ye = this[ee[463]]()) === null || ye === void 0 ? void 0 : ye[ee[254]]) || 0;
            }, $e[ee[6]][ee[470]] = function(ye) {
              var Se = this[ee[460]]();
              if (isFinite(Se))
                return ye > Se;
              var we = this[ee[463]](), Pe = we != null && we[ee[260]] ? we[ee[254]] + we[ee[255]] : 1 / 0;
              return this[ee[467]](ye) >= Pe;
            }, $e[ee[6]][ee[471]] = function(ye) {
              return this[ee[466]](ye) <= Date[ee[295]]();
            }, $e[ee[6]][ee[355]] = function() {
              var ye = { isInitSegment: !1, presentationTimeOffset: this[ee[358]]() }, Se = this[ee[458]](this[ee[356]]);
              if (!Se || !Se[ee[472]] || !this[ee[322]][ee[473]](this[ee[356]]))
                return null;
              if (this[ee[322]][ee[474]]()) {
                var we = this[ee[471]](this[ee[311]]), Pe = this[ee[470]](this[ee[311]]);
                if (!we || Pe)
                  return null;
                ye[ee[475]] = this[ee[466]](this[ee[311]]) - (0, le[ee[469]])(this[ee[362]]());
              }
              var Te = this[ee[322]][ee[321]](this[ee[356]]);
              return ye[ee[344]] = Te == null ? void 0 : Te[ee[317]][ee[344]], ye[ee[42]] = (0, me[ee[22]])(Se[ee[472]], Te, this[ee[311]], this[ee[357]]), ye[ee[359]] = (0, ge[ee[360]])(ye), ye[ee[476]] = this[ee[311]], ye[ee[387]] = this[ee[467]](this[ee[311]]), this[ee[400]](this[ee[311]] + 1), ye;
            }, $e[ee[6]][ee[388]] = function(ye) {
              var Se = this[ee[355]]();
              return Se ? Promise[ee[96]](Se) : this[ee[338]]({ time: ye });
            }, $e[ee[6]][ee[338]] = function(ye) {
              var Se = this;
              return this[ee[339]] ? Promise[ee[81]](ee[340]) : new Promise(function(we, Pe) {
                Se[ee[339]] = ue(ue({}, ye), { resolve: we, reject: Pe });
              });
            }, $e[ee[6]][ee[371]] = function() {
              if (this[ee[339]]) {
                var ye = this[ee[355]](), Se = this[ee[470]](this[ee[311]]);
                ye ? (this[ee[339]][ee[96]](ye), this[ee[339]] = null) : Se && (this[ee[339]][ee[81]](he[ee[478]][ee[477]]), this[ee[339]] = null);
              }
            }, $e[ee[6]][ee[381]] = function(ye) {
              var Se = this, we = {};
              return this[ee[322]][ee[367]](this[ee[356]])[ee[185]][ee[207]](function(Pe) {
                var Te, Ee, Me, Ae = Pe[ee[317]], Ne = Se[ee[458]](Ae), Ce = [], Ie = Se[ee[382]]()[ee[386]] - Se[ee[382]]()[ee[254]], xe = 0, Ue = Se[ee[322]][ee[474]]();
                Ue ? (Me = Se[ee[357]] - Ie, Te = Se[ee[311]] - Ie / Se[ee[362]](), Ee = Se[ee[311]]) : (Me = Ne[ee[405]] || 0, Te = 0, Ee = parseInt(Te + Ie / Se[ee[362]]()));
                for (var ke = Te; ke <= Ee; ke++) {
                  var Le = {};
                  Le[ee[255]] = Se[ee[362]](), Le[ee[387]] = Ue ? Se[ee[467]](ke) : xe * Se[ee[362]]();
                  var De = (0, me[ee[22]])(Ne[ee[472]], Pe, Te + xe, Me + xe * Se[ee[362]]());
                  Le[ee[42]] = ye ? oe[ee[24]][ee[23]](ye, De) : De, Le[ee[42]] = oe[ee[24]][ee[385]](Le[ee[42]], Se[ee[56]][ee[384]]), Ce[ee[212]](Le), xe++;
                }
                we[Ae[ee[316]]] = Ce;
              }), we;
            }, $e[ee[6]][ee[389]] = function() {
              var ye = this[ee[322]][ee[321]](this[ee[356]])[ee[30]][0];
              return ye[ee[42]] || ye;
            }, $e[ee[6]][ee[479]] = function() {
              var ye = this[ee[458]](this[ee[356]]);
              return ye && ye[ee[5]](ee[480]);
            }, $e[ee[6]][ee[481]] = function() {
              if (this[ee[479]]()) {
                var ye = this[ee[458]](this[ee[356]]);
                return parseInt(ye[ee[480]]);
              }
            }, $e[ee[6]][ee[362]] = function() {
              var ye = this[ee[458]](this[ee[356]]), Se = Number(ye == null ? void 0 : ye[ee[260]]), we = Number(ye == null ? void 0 : ye[ee[406]]);
              return isNaN(Se) ? 1 : isNaN(we) ? Se : Se / we;
            }, $e[ee[6]][ee[331]] = function(ye) {
              ye > -1 && this[ee[400]](this[ee[482]](ye));
            }, $e[ee[6]][ee[483]] = function() {
              return pe(this[ee[458]](this[ee[356]]));
            }, $e[ee[6]][ee[467]] = function(ye) {
              var Se = this[ee[364]]();
              return (ye - this[ee[391]]()) * this[ee[362]]() + Se;
            }, $e[ee[6]][ee[482]] = function(ye) {
              var Se = this[ee[362]](), we = this[ee[364]](), Pe = Math[ee[399]](ye - we - Se / 2, 0);
              return Math[ee[363]](Pe / Se) + this[ee[391]]();
            }, $e[ee[6]][ee[393]] = function() {
              var ye = this[ee[484]]();
              return ye[ee[386]] - ye[ee[254]];
            }, $e[ee[6]][ee[484]] = function() {
              var ye = (0, fe[ee[487]])(this[ee[486]]()[ee[485]]()), Se = this[ee[322]][ee[353]]() || 1 / 0;
              return this[ee[322]][ee[474]]() ? this[ee[488]](Se) : this[ee[489]](ye, Se);
            }, $e[ee[6]][ee[486]] = function() {
              return this[ee[48]][ee[47]][ee[69]](_e[ee[41]][ee[348]], this[ee[48]][ee[45]][ee[44]]);
            }, $e[ee[6]][ee[489]] = function(ye, Se) {
              return { start: ye, end: isFinite(Se) ? ye + Se : 0 };
            }, $e[ee[6]][ee[488]] = function(ye) {
              var Se = (this[ee[322]][ee[342]]() || { start: 0 })[ee[254]], we = -1 * this[ee[322]][ee[394]](), Pe = (0, le[ee[119]])(Date[ee[295]]() - this[ee[322]][ee[490]]()), Te = Math[ee[491]](we, Pe), Ee = this[ee[392]]();
              return { start: Math[ee[399]](Se, Ee - Te), end: Ee };
            }, $e[ee[6]][ee[382]] = function() {
              var ye = this[ee[484]]();
              if (this[ee[322]][ee[474]]()) {
                var Se = this[ee[322]][ee[492]]();
                ye[ee[386]] = Math[ee[399]](ye[ee[386]] - Se, ye[ee[254]]);
              }
              return ye;
            }, $e[ee[6]][ee[396]] = function(ye) {
              var Se = this[ee[470]](this[ee[311]]), we = Math[ee[493]](ye / this[ee[362]]()) + this[ee[391]]() - 1;
              return !Se && this[ee[311]] <= we;
            }, $e[ee[6]][ee[358]] = function() {
              var ye = this[ee[463]](), Se = 0, we = this[ee[458]](this[ee[356]]);
              return we && we[ee[405]] && (Se = we[ee[405]] / this[ee[483]]()), ye && (Se -= ye[ee[254]]), Se;
            }, $e[ee[6]][ee[351]] = function(ye, Se) {
              var we = this[ee[322]][ee[464]](ye) || this[ee[463]]();
              return this[ee[322]][ee[494]](ye[ee[344]]) ? we && (0, se[ee[495]])(we[ee[255]]) && isFinite(we[ee[255]]) ? we[ee[255]] : we && we[ee[254]] ? (0, le[ee[119]])(Se) - we[ee[254]] : this[ee[322]][ee[496]](ye[ee[344]]) : this[ee[322]][ee[351]](ye[ee[344]]);
            }, $e[ee[6]][ee[497]] = function(ye) {
              var Se = Date[ee[295]](), we = (0, le[ee[119]])(Se - this[ee[322]][ee[498]]());
              return this[ee[479]]() ? this[ee[481]]() + Math[ee[363]](we / this[ee[362]]()) : this[ee[322]][ee[474]]() && this[ee[322]][ee[500]]()[ee[499]] ? Math[ee[363]](this[ee[351]](ye, Se) / this[ee[362]]() + this[ee[391]]()) : this[ee[391]]();
            }, $e[ee[6]][ee[501]] = function(ye) {
              return Math[ee[399]](this[ee[497]](ye), this[ee[391]]());
            }, $e[ee[6]][ee[407]] = function() {
              return this[ee[311]];
            }, $e[ee[6]][ee[400]] = function(ye) {
              this[ee[311]] = ye;
            }, $e[ee[6]][ee[392]] = function() {
              return (0, le[ee[119]])(Date[ee[295]]());
            }, $e[ee[6]][ee[408]] = function(ye, Se) {
              if (Se === void 0 && (Se = this[ee[356]][ee[344]]), this[ee[322]][ee[474]]()) {
                var we = this[ee[311]], Pe = this[ee[501]](new ce[ee[502]](Se));
                ye === 0 ? (this[ee[400]](Pe), this[ee[48]][ee[85]][ee[84]](ee[503] + we + ee[504] + this[ee[311]] + ee[505])) : (this[ee[400]](Pe + Math[ee[363]](ye / this[ee[362]]())), this[ee[311]] < this[ee[391]]() && this[ee[400]](this[ee[391]]()), this[ee[48]][ee[85]][ee[84]](ee[503] + we + ee[504] + this[ee[311]]));
              }
            }, $e[ee[6]][ee[106]] = function(ye) {
              return this[ee[356]] = ye, Promise[ee[96]](ye);
            }, $e[ee[6]][ee[397]] = function(ye) {
              return !0;
            }, $e[ee[6]][ee[417]] = function() {
              return this[ee[400]](this[ee[311]] - 1), this[ee[311]] < this[ee[391]]() && (this[ee[48]][ee[85]][ee[84]](ee[506]), this[ee[400]](this[ee[391]]())), !0;
            }, $e[ee[6]][ee[419]] = function() {
              return this[ee[339]];
            }, $e[ee[6]][ee[420]] = function(ye) {
              this[ee[339]] = ye;
            }, $e[ee[6]][ee[421]] = function(ye) {
              return !0;
            }, $e[ee[6]][ee[422]] = function(ye) {
              return ye;
            }, $e[ee[6]][ee[423]] = function(ye) {
              return ye;
            }, $e[ee[6]][ee[77]] = function() {
              this[ee[56]] = null, this[ee[322]] = null, this[ee[356]] = null, this[ee[373]] = null, this[ee[339]] = null;
            }, $e[ee[6]][ee[424]] = function(ye, Se) {
            }, $e;
          }();
          function pe($e) {
            return $e && $e[ee[406]] != null && parseInt($e[ee[406]]) || 1;
          }
          ne[ee[308]] = be;
        }, 61411: function(ie, ne, ae) {
          var ue = this && this[ee[507]] || function() {
            var we = function(Pe, Te) {
              return we = Object[ee[508]] || { __proto__: [] } instanceof Array && function(Ee, Me) {
                Ee[ee[509]] = Me;
              } || function(Ee, Me) {
                for (var Ae in Me)
                  Object[ee[6]][ee[5]][ee[4]](Me, Ae) && (Ee[Ae] = Me[Ae]);
              }, we(Pe, Te);
            };
            return function(Pe, Te) {
              if (ee[138] != typeof Te && Te !== null)
                throw new TypeError(ee[510] + String(Te) + ee[511]);
              function Ee() {
                this[ee[512]] = Pe;
              }
              we(Pe, Te), Pe[ee[6]] = Te === null ? Object[ee[513]](Te) : (Ee[ee[6]] = Te[ee[6]], new Ee());
            };
          }(), _e = this && this[ee[1]] || function() {
            return _e = Object[ee[2]] || function(we) {
              for (var Pe, Te = 1, Ee = arguments[ee[3]]; Te < Ee; Te++)
                for (var Me in Pe = arguments[Te])
                  Object[ee[6]][ee[5]][ee[4]](Pe, Me) && (we[Me] = Pe[Me]);
              return we;
            }, _e[ee[7]](this, arguments);
          };
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[309]] = void 0;
          var fe = ae(81361), le = ae(331), se = ae(76885), oe = ae(73553), ce = ae(28915), he = ae(92983), ge = ae(44890), ve = ae(38725), me = function(we) {
            function Pe(Te) {
              var Ee = we[ee[4]](this, Te) || this;
              return Ee[ee[514]] = 0, Ee[ee[515]] = null, Ee[ee[516]] = [], Ee[ee[517]] = !0, Ee[ee[518]] = !1, Ee[ee[519]] = 1, Ee[ee[520]] = 0, Ee[ee[521]] = 0, Ee;
            }
            return ue(Pe, we), Pe[ee[6]][ee[372]] = function(Te, Ee, Me) {
              Ee === void 0 && (Ee = null), Me === void 0 && (Me = { isPeriodSwitch: !1, isManifestUpdate: !1 }), this[ee[373]] = Te, this[ee[356]] = Ee;
              var Ae = !this[ee[356]] || !!this[ee[322]][ee[321]](this[ee[356]]), Ne = this[ee[322]][ee[367]](this[ee[373]]);
              this[ee[356]] && Ae || (this[ee[356]] = Ne[ee[185]][0][ee[317]]);
              var Ce = this[ee[458]](this[ee[356]]);
              Ce ? (this[ee[523]](Ce, Me[ee[522]]), this[ee[407]]() || we[ee[6]][ee[400]][ee[4]](this, this[ee[391]]())) : this[ee[48]][ee[85]][ee[84]](ee[462]), this[ee[371]]();
            }, Pe[ee[6]][ee[380]] = function(Te) {
              if (this[ee[322]][ee[321]](Te)) {
                this[ee[356]] = Te;
                var Ee = this[ee[458]](this[ee[356]]);
                return Ee && this[ee[523]](Ee), !0;
              }
              return !1;
            }, Pe[ee[6]][ee[524]] = function(Te) {
              return (Te == null ? void 0 : Te[ee[254]]) != null && isFinite(Te[ee[254]]) ? Te[ee[254]] : 0;
            }, Pe[ee[6]][ee[525]] = function() {
              this[ee[322]][ee[474]]() && this[ee[517]] && (this[ee[518]] || this[ee[408]](0), this[ee[517]] = !1);
            }, Pe[ee[6]][ee[526]] = function(Te) {
              return !(Te != null && Te[ee[472]]) || !this[ee[322]][ee[473]](this[ee[356]]);
            }, Pe[ee[6]][ee[527]] = function(Te) {
              var Ee = this[ee[516]][this[ee[514]]];
              Ee && (Te[ee[475]] = (0, le[ee[469]])(Ee[ee[528]] / this[ee[519]] - this[ee[358]]()));
            }, Pe[ee[6]][ee[355]] = function() {
              var Te, Ee, Me = { isInitSegment: !1, presentationTimeOffset: this[ee[358]]() }, Ae = this[ee[458]](this[ee[356]]);
              if (this[ee[526]](Ae) || (this[ee[525]](), !(this[ee[516]][ee[3]] > 0 && this[ee[514]] < this[ee[516]][ee[3]])))
                return null;
              var Ne = this[ee[516]][this[ee[514]]];
              we[ee[6]][ee[400]][ee[4]](this, Ne[ee[143]]), this[ee[357]] = Ne[ee[528]], Me[ee[255]] = Ne[ee[255]], Me[ee[529]] = Ne[ee[530]], Me[ee[476]] = Ne[ee[143]];
              var Ce = (Ee = (Te = this[ee[463]]()) === null || Te === void 0 ? void 0 : Te[ee[254]]) !== null && Ee !== void 0 ? Ee : 0;
              if (Me[ee[387]] = Ne[ee[531]] + Ce, this[ee[322]][ee[474]]()) {
                if (this[ee[470]](this[ee[514]]))
                  return null;
                this[ee[527]](Me);
              }
              var Ie = this[ee[322]][ee[321]](this[ee[356]]);
              return Ie ? (Me[ee[344]] = Ie == null ? void 0 : Ie[ee[317]][ee[344]], Me[ee[42]] = (0, he[ee[22]])(Ae[ee[472]], Ie, this[ee[407]](), this[ee[357]]), Me[ee[359]] = (0, ce[ee[360]])(Me), we[ee[6]][ee[400]][ee[4]](this, this[ee[407]]() + 1), this[ee[514]]++, Me) : null;
            }, Pe[ee[6]][ee[388]] = function(Te) {
              var Ee = this[ee[355]]();
              return Ee ? Promise[ee[96]](Ee) : this[ee[338]]({ time: Te });
            }, Pe[ee[6]][ee[338]] = function(Te) {
              var Ee = this;
              return this[ee[339]] ? Promise[ee[81]](ee[340]) : new Promise(function(Me, Ae) {
                Ee[ee[339]] = _e(_e({}, Te), { resolve: Me, reject: Ae });
              });
            }, Pe[ee[6]][ee[371]] = function() {
              if (this[ee[339]]) {
                var Te = this[ee[355]]();
                if (Te)
                  this[ee[339]][ee[96]](Te), this[ee[339]] = null;
                else if (!this[ee[322]][ee[532]]()) {
                  var Ee = this[ee[463]]();
                  if (isFinite(Ee[ee[255]])) {
                    var Me = this[ee[533]](), Ae = Me / this[ee[534]](), Ne = Ee[ee[254]] + Me, Ce = Ee[ee[255]] - Ae / 2;
                    isFinite(Ce) && Ne >= Ce && (this[ee[339]][ee[81]](oe[ee[478]][ee[535]]), this[ee[339]] = null);
                  }
                }
              }
            }, Pe[ee[6]][ee[381]] = function(Te) {
              var Ee = this, Me = {};
              return this[ee[322]][ee[367]](this[ee[356]])[ee[185]][ee[207]](function(Ae) {
                var Ne, Ce, Ie = Ae[ee[317]], xe = Ee[ee[458]](Ie), Ue = [], ke = Ee[ee[382]]()[ee[386]] - Ee[ee[382]]()[ee[254]], Le = 0, De = Ee[ee[322]][ee[474]]();
                De ? (Ne = Math[ee[493]](Ee[ee[407]]() - ke / Ee[ee[362]]()), Ce = Ee[ee[407]]()) : (Ne = 0, Ce = Math[ee[363]](Ne + ke / Ee[ee[362]]()));
                for (var Re = Ne; Re <= Ce; Re++) {
                  var Oe = {};
                  Oe[ee[255]] = Ee[ee[362]](), Oe[ee[387]] = De ? Ee[ee[467]](Re) : Le * Ee[ee[362]]();
                  var Be = (0, he[ee[22]])(xe[ee[472]], Ae, Ne + Le, Ee[ee[536]](Le));
                  Oe[ee[42]] = Te ? se[ee[24]][ee[23]](Te, Be) : Be, Oe[ee[42]] = se[ee[24]][ee[385]](Oe[ee[42]], Ee[ee[56]][ee[384]]), Ue[ee[212]](Oe), Le++;
                }
                Me[Ee[ee[356]][ee[316]]] = Ue;
              }), Me;
            }, Pe[ee[6]][ee[389]] = function() {
              var Te = this[ee[322]][ee[321]](this[ee[356]])[ee[30]][0];
              return Te[ee[42]] || Te;
            }, Pe[ee[6]][ee[362]] = function() {
              return this[ee[537]]();
            }, Pe[ee[6]][ee[331]] = function(Te) {
              if (Te > -1) {
                var Ee = this[ee[524]](this[ee[463]]());
                this[ee[518]] = !1, isFinite(Ee) && (Te -= Ee);
                for (var Me = 1; Me < this[ee[516]][ee[3]]; Me++)
                  if (this[ee[516]][Me][ee[531]] > Te)
                    return this[ee[514]] = Me - 1, we[ee[6]][ee[400]][ee[4]](this, this[ee[516]][this[ee[514]]][ee[143]]), this[ee[517]] = !1, this[ee[407]]();
                this[ee[514]] = Math[ee[399]](this[ee[516]][ee[3]] - 1, 0);
              }
              return we[ee[6]][ee[400]][ee[4]](this, this[ee[516]][this[ee[514]]][ee[143]]), this[ee[407]]();
            }, Pe[ee[6]][ee[467]] = function(Te) {
              var Ee, Me;
              return ((Me = (Ee = this[ee[463]]()) === null || Ee === void 0 ? void 0 : Ee[ee[254]]) !== null && Me !== void 0 ? Me : 0) + this[ee[516]][Te][ee[531]];
            }, Pe[ee[6]][ee[396]] = function(Te) {
              if (this[ee[514]] < this[ee[516]][ee[3]]) {
                var Ee = this[ee[516]][0][ee[530]], Me = this[ee[516]][this[ee[514]]];
                if (this[ee[470]](this[ee[514]]))
                  return !1;
                if (Me)
                  return Me[ee[530]] - Ee <= Te * this[ee[519]];
              }
              return !1;
            }, Pe[ee[6]][ee[358]] = function() {
              var Te = this[ee[463]](), Ee = this[ee[520]] / this[ee[519]];
              return Te && (Ee -= Te[ee[254]]), Ee;
            }, Pe[ee[6]][ee[400]] = function(Te) {
              if (we[ee[6]][ee[400]][ee[4]](this, Te), this[ee[516]] && this[ee[516]][ee[3]] > 0)
                for (var Ee = 0; Ee < this[ee[516]][ee[3]]; Ee++)
                  this[ee[516]][Ee][ee[143]] === Te && (this[ee[514]] = Ee);
            }, Pe[ee[6]][ee[392]] = function() {
              if (!this[ee[322]][ee[474]]())
                return -1;
              var Te = this[ee[322]][ee[538]](), Ee = this[ee[463]]();
              if (Te == null || (Ee == null ? void 0 : Ee[ee[168]]) === Te[ee[168]])
                return this[ee[524]](Ee) + this[ee[539]]() / this[ee[519]];
              var Me = (0, ve[ee[540]])(Te);
              return Me != null && Me[ee[541]] ? this[ee[524]](Te) + (0, ve[ee[542]])(Me) : we[ee[6]][ee[392]][ee[4]](this);
            }, Pe[ee[6]][ee[539]] = function() {
              if (!this[ee[516]][ee[3]])
                return 0;
              var Te = this[ee[516]][this[ee[516]][ee[3]] - 1];
              return Te[ee[530]] + Te[ee[543]];
            }, Pe[ee[6]][ee[408]] = function(Te, Ee) {
              if (this[ee[322]][ee[474]]() && !(this[ee[516]][ee[3]] < 1)) {
                this[ee[518]] = !1;
                for (var Me = this[ee[516]][0][ee[530]], Ae = this[ee[539]](), Ne = Te * this[ee[519]], Ce = Math[ee[399]](this[ee[521]], this[ee[56]][ee[544]]) * this[ee[519]], Ie = Math[ee[399]](Me + Ce, Ae + Ne), xe = this[ee[516]][ee[3]] - 1; xe >= 0; xe--)
                  if (this[ee[516]][xe][ee[530]] <= Ie) {
                    this[ee[514]] = xe;
                    break;
                  }
                (this[ee[514]] >= this[ee[516]][ee[3]] || this[ee[514]] <= 0) && (this[ee[48]][ee[85]][ee[84]](ee[545]), this[ee[514]] = 0), this[ee[48]][ee[85]][ee[84]](ee[546] + this[ee[514]]), this[ee[517]] = !1, we[ee[6]][ee[400]][ee[4]](this, this[ee[516]][this[ee[514]]][ee[143]]);
              }
            }, Pe[ee[6]][ee[106]] = function(Te) {
              return this[ee[356]] = Te, Promise[ee[96]](Te);
            }, Pe[ee[6]][ee[397]] = function(Te) {
              return !0;
            }, Pe[ee[6]][ee[417]] = function() {
              return this[ee[514]]--, this[ee[514]] < 0 && (this[ee[48]][ee[85]][ee[84]](ee[547]), this[ee[514]] = 0), !0;
            }, Pe[ee[6]][ee[548]] = function(Te, Ee) {
              for (var Me, Ae = { entries: [], latestTime: 0, latestOriginalTime: 0, lastPreviousTimelineEntryIndex: 0, index: this[ee[391]]() }, Ne = 0, Ce = 0, Ie = 0, xe = Te; Ie < xe[ee[3]]; Ie++)
                for (var Ue = 0, ke = (Me = xe[Ie][ee[257]]) !== null && Me !== void 0 ? Me : []; Ue < ke[ee[3]]; Ue++) {
                  var Le = ke[Ue], De = (0, ve[ee[550]])(Le[ee[549]]), Re = parseInt(Le[ee[551]]);
                  if (Le[ee[5]](ee[552])) {
                    var Oe = (0, ve[ee[550]])(Le[ee[552]]);
                    Ae[ee[553]] = Oe, Ae[ee[554]] = Oe - this[ee[520]];
                  }
                  for (; Ae[ee[554]] + Re <= 0 && De >= 0; )
                    this[ee[48]][ee[85]][ee[84]](ee[556][ee[36]](Ae[ee[554]], ee[555])[ee[36]](this[ee[520]], ee[132])), Ae[ee[554]] += Re, Ae[ee[553]] += Re, De--;
                  for (var Be = this[ee[557]](Ae, Ee, Re, De), Fe = 0; Fe < Be[ee[3]]; Fe++)
                    Be[Fe][ee[143]] = Ae[ee[311]] + Fe;
                  Ne += Be[ee[3]], be(Ae, Be, Re);
                  var Ve = De - Be[ee[3]] + 1;
                  Ce += Ve, be(Ae, this[ee[558]](Ae, Ve, Re), Re);
                }
              return this[ee[559]](Ne, Ce), Ae[ee[560]];
            }, Pe[ee[6]][ee[559]] = function(Te, Ee) {
              var Me;
              this[ee[48]][ee[85]][ee[84]](ee[564][ee[36]]((Me = this[ee[356]]) === null || Me === void 0 ? void 0 : Me[ee[316]], ee[563])[ee[36]](Te, ee[562])[ee[36]](Ee, ee[561]));
            }, Pe[ee[6]][ee[558]] = function(Te, Ee, Me) {
              for (var Ae = [], Ne = 0; Ne < Ee; Ne++) {
                var Ce = Te[ee[554]] + Me * Ne, Ie = { d: Me, t: Ce, ot: Te[ee[553]] + Me * Ne, i: Te[ee[311]] + Ne, playbackTime: Ce / this[ee[519]], duration: Me / this[ee[519]] };
                Ae[ee[212]](Ie);
              }
              return Ae;
            }, Pe[ee[6]][ee[557]] = function(Te, Ee, Me, Ae) {
              var Ne = (0, fe[ee[566]])(Ee, Te[ee[565]], Ee[ee[3]], function(Ie) {
                return Ie[ee[530]] === Te[ee[554]] && Ie[ee[543]] === Me;
              });
              if (Ne === -1)
                return [];
              var Ce = pe(Ee, Ne, Me, Ae);
              return Te[ee[565]] = Ce, Ee[ee[35]](Ne, Ce + 1);
            }, Pe[ee[6]][ee[533]] = function() {
              var Te = this;
              return this[ee[516]] && this[ee[516]][ee[3]] > 0 && isFinite(this[ee[519]]) ? this[ee[516]][ee[567]](function(Ee, Me) {
                return Ee + Me[ee[543]] / Te[ee[519]];
              }, 0) : 0;
            }, Pe[ee[6]][ee[534]] = function() {
              return this[ee[516]] ? this[ee[516]][ee[3]] : 0;
            }, Pe[ee[6]][ee[523]] = function(Te, Ee) {
              Ee === void 0 && (Ee = !1);
              var Me = Te[ee[541]];
              if (this[ee[518]] = this[ee[518]] || !!Ee, Me && this[ee[515]] !== Me) {
                this[ee[515]] = Me;
                var Ae = this[ee[568]](), Ne = this[ee[483]]();
                this[ee[519]] = Ne, this[ee[520]] = parseFloat(String(Te[ee[405]])) || 0;
                var Ce = this[ee[548]](Me, this[ee[516]]);
                Ce[ee[3]] > 0 && (this[ee[521]] = Ce[0][ee[543]] / Ne), this[ee[569]](Ce, Ne, Ae), this[ee[516]] = Ce;
              }
            }, Pe[ee[6]][ee[568]] = function() {
              return this[ee[516]] && this[ee[516]][ee[3]] > 0 ? this[ee[519]] : this[ee[483]]();
            }, Pe[ee[6]][ee[569]] = function(Te, Ee, Me) {
              var Ae, Ne = !1;
              if (this[ee[516]] && this[ee[516]][ee[3]] > 0 ? Ae = (Ne = this[ee[514]] >= this[ee[516]][ee[3]]) ? this[ee[516]][this[ee[516]][ee[3]] - 1] : this[ee[516]][this[ee[514]]] : (this[ee[514]] = 0, we[ee[6]][ee[400]][ee[4]](this, 0)), Ae) {
                for (var Ce = Te[ee[3]] - 1; Ce >= 0; Ce--)
                  if (Se(Te[Ce], Ee, Ae, Me)) {
                    this[ee[514]] = Ce + (Ne ? 1 : 0), we[ee[6]][ee[400]][ee[4]](this, Te[Ce][ee[143]] + (Ne ? 1 : 0));
                    break;
                  }
              }
            }, Pe[ee[6]][ee[536]] = function(Te) {
              return this[ee[516]][Te] && this[ee[516]][Te][ee[5]](ee[530]) ? this[ee[516]][Te][ee[530]] : 0;
            }, Pe[ee[6]][ee[537]] = function() {
              var Te = this[ee[516]][this[ee[514]]];
              return Te ? Te[ee[543]] / this[ee[519]] : 1;
            }, Pe[ee[6]][ee[77]] = function() {
              this[ee[56]] = null, this[ee[516]] = [];
            }, Pe;
          }(ge[ee[308]]);
          function be(we, Pe, Te) {
            var Ee;
            (Ee = we[ee[560]])[ee[212]][ee[7]](Ee, Pe), we[ee[554]] += Te * Pe[ee[3]], we[ee[553]] += Te * Pe[ee[3]], we[ee[311]] += Pe[ee[3]];
          }
          function pe(we, Pe, Te, Ee) {
            for (var Me = we[Pe][ee[530]], Ae = Ee; Ae > 0; Ae--) {
              var Ne = Pe + Ae, Ce = we[Ne], Ie = Me + Te * Ae;
              if (Ce && Ce[ee[530]] === Ie && Ce[ee[543]] === Te)
                return Ne;
            }
            return Pe;
          }
          ne[ee[309]] = me;
          var $e = Math[ee[570]](10, 8);
          function ye(we) {
            return Math[ee[118]](we * $e) / $e;
          }
          function Se(we, Pe, Te, Ee) {
            var Me = ye(we[ee[530]] / Pe), Ae = ye(Me + we[ee[543]] / Pe), Ne = ye(Te[ee[530]] / Ee);
            return Me <= Ne && Ne < Ae;
          }
        }, 92983: function(ie, ne, ae) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[22]] = se;
          var ue = ae(91397);
          function _e(oe) {
            var ce = parseInt(oe[ee[221]](0, oe[ee[3]] - 1)), he = oe[oe[ee[3]] - 1][ee[186]](), ge = oe[oe[ee[3]] - 1][ee[184]](he) !== 0;
            return [he[ee[184]](ee[571]) === 0 ? 8 : he[ee[184]](ee[572]) === 0 ? 16 : (he[ee[184]](ee[543]), 10), ce, ge];
          }
          function fe(oe, ce, he) {
            for (; oe[ee[3]] < ce; )
              oe = he + oe;
            return oe;
          }
          function le(oe, ce) {
            return ce ? oe[ee[573]]() : oe[ee[186]]();
          }
          function se(oe, ce, he, ge) {
            var ve = oe[ee[574]](/(\$((RepresentationID)|(Bandwidth)|(Time)|(Number(%([\d]*[A-Za-z]))?)|())\$)/g), me = he != null, be = ce[ee[5]](ee[169]), pe = ge != null;
            function $e(Se) {
              if (Se[ee[184]](ee[575]) === 0 && me) {
                if (Se[ee[184]](ee[576]) > -1) {
                  var we = _e(Se[ee[221]](Se[ee[184]](ee[576]) + 1)), Pe = we[0], Te = we[1], Ee = we[2];
                  return fe(le(he[ee[224]](Pe), Ee), Te, ee[577]);
                }
                return String(he);
              }
              return Se[ee[184]](ee[219]) === 0 ? ce[ee[317]][ee[316]] : Se[ee[184]](ee[578]) === 0 && be ? String(ce[ee[169]]) : Se[ee[184]](ee[579]) === 0 && pe ? String(ge) : ee[32] === Se ? ee[580] : void 0;
            }
            var ye = [][ee[36]](ve)[ee[198]](function(Se) {
              return Se;
            })[ee[27]](function(Se) {
              return Se[ee[221]](1, Se[ee[3]] - 1);
            })[ee[27]](function(Se) {
              return [Se, $e(Se)];
            })[ee[198]](function(Se) {
              return Se[1][ee[3]] > 0;
            })[ee[567]](function(Se, we) {
              var Pe = we[0], Te = we[1];
              return Se[ee[581]](ee[580][ee[36]](Pe, ee[580]), Te);
            }, oe);
            return (0, ue[ee[582]])(ye);
          }
        }, 38725: function(ie, ne, ae) {
          Object[ee[9]](ne, ee[8], { value: !0 }), ne[ee[540]] = fe, ne[ee[542]] = le, ne[ee[550]] = se;
          var ue = ae(79814), _e = ae(44890);
          function fe(oe) {
            var ce, he = oe[ee[242]][ee[302]](function(ve) {
              return ue[ee[270]][ee[583]](ve[ee[163]]);
            }), ge = (ce = he == null ? void 0 : he[ee[185]][0]) === null || ce === void 0 ? void 0 : ce[ee[182]];
            return ge == null ? void 0 : ge[0];
          }
          function le(oe) {
            for (var ce, he, ge = parseFloat(String(oe[ee[405]])) || 0, ve = (0, _e[ee[457]])(oe), me = 0, be = 0, pe = (ce = oe[ee[541]]) !== null && ce !== void 0 ? ce : []; be < pe[ee[3]]; be++)
              for (var $e = 0, ye = (he = pe[be][ee[257]]) !== null && he !== void 0 ? he : []; $e < ye[ee[3]]; $e++) {
                var Se = ye[$e], we = se(Se[ee[549]]), Pe = parseInt(Se[ee[551]]);
                Se[ee[5]](ee[552]) && (me = Math[ee[399]](0, se(Se[ee[552]]) - ge)), me += Pe * (we + 1);
              }
            return me / ve;
          }
          function se(oe, ce) {
            return ce === void 0 && (ce = 0), oe ? parseInt(oe) : ce;
          }
        } }, function(ie) {
          return function(ne) {
            return ie(ie[ee[584]] = ne);
          }(84075);
        }]);
      });
    })();
  })();
})(bitmovinplayerDash, bitmovinplayerDash.exports);
var bitmovinplayerDashExports = bitmovinplayerDash.exports;
const DashModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerDashExports);
var bitmovinplayerContainerMp4 = { exports: {} };
(function(re, te) {
  (function() {
    (function(ee, ie) {
      re.exports = ie();
    })(self, function() {
      return (self.webpackChunkbitmovin_player = self.webpackChunkbitmovin_player || []).push([[270], { 10045: function(ee, ie) {
        var ne = this && this.__assign || function() {
          return ne = Object.assign || function(be) {
            for (var pe, $e = 1, ye = arguments.length; $e < ye; $e++)
              for (var Se in pe = arguments[$e])
                Object.prototype.hasOwnProperty.call(pe, Se) && (be[Se] = pe[Se]);
            return be;
          }, ne.apply(this, arguments);
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ISOBox = ie.ISOFile = ie.ISOBoxer = void 0;
        var ae = ["moov", "trak", "tref", "mdia", "minf", "stbl", "edts", "dinf", "sinf", "mvex", "moof", "traf", "mfra", "udta", "meco", "strk", "vttc", "schi"];
        ie.ISOBoxer = { parseBuffer: function(be, pe) {
          return pe === void 0 && (pe = {}), new ie.ISOFile(be, pe).parse();
        } };
        var ue = 8;
        function _e(be) {
          return be === void 0 && (be = 0), { offset: be };
        }
        var fe = function(be, pe) {
          pe === void 0 && (pe = {}), this.options = ne({}, pe), this.options.iv_size = pe.iv_size || ue, be && (this._raw = new DataView(be)), this._cursor = _e(), this.boxes = [];
        };
        function le(be) {
          return be.length === 0 ? null : be[0];
        }
        function se(be, pe) {
          var $e = pe.indexOf("."), ye = [];
          if ($e === -1)
            for (var Se = 0; Se < be.length; Se++)
              be[Se].type === pe && ye.push(be[Se]);
          else {
            var we = pe.substring(0, $e), Pe = pe.substring($e + 1);
            for (Se = 0; Se < be.length; Se++)
              be[Se].type === we && (ye = ye.concat(be[Se].list(Pe)));
          }
          return ye;
        }
        ie.ISOFile = fe, ie.ISOFile.prototype.fetch = function(be) {
          var pe = this.fetchAll(be, !0);
          return pe.length ? pe[0] : null;
        }, ie.ISOFile.prototype.fetchAll = function(be, pe) {
          var $e = [];
          return ie.ISOFile._sweep.call(this, be, $e, pe), $e;
        }, ie.ISOFile.prototype.parse = function() {
          for (this._cursor.offset = 0, this.boxes = []; this._cursor.offset < this._raw.byteLength; ) {
            var be = ie.ISOBox.parse(this);
            if (be.type === void 0)
              break;
            this.boxes.push(be);
          }
          return this;
        }, ie.ISOFile._sweep = function(be, pe, $e) {
          for (var ye in this.type && this.type === be && pe.push(this), this.boxes) {
            if (pe.length && $e)
              return;
            ie.ISOFile._sweep.call(this.boxes[ye], be, pe, $e);
          }
        }, ie.ISOFile.prototype.get = function(be) {
          return le(this.list(be));
        }, ie.ISOFile.prototype.list = function(be) {
          return se(this.boxes, be);
        };
        var oe = function() {
          this._cursor = _e();
        };
        function ce(be, pe) {
          be.forEach(function($e) {
            ie.ISOBox.prototype._boxParsers[$e] = pe;
          });
        }
        function he(be, pe) {
          return be._cursor.offset - be._raw.byteOffset + pe <= be.size;
        }
        function ge(be) {
          return he(be, 6) ? { bytes_of_clear_data: be._readUint(16), bytes_of_encrypted_data: be._readUint(32) } : { bytes_of_clear_data: 0, bytes_of_encrypted_data: 0 };
        }
        function ve(be, pe) {
          return he(be, 2) ? (pe.subsample_count = be._readUint(16), pe.subsamples = Array.apply(null, Array(pe.subsample_count)).map(function($e) {
            return ge(be);
          }), pe) : ne(ne({}, pe), { subsample_count: 0, subsamples: [] });
        }
        function me(be) {
          if (he(be, be._root.options.iv_size)) {
            var pe = { iv: be._readHex(be._root.options.iv_size) };
            return be.flags && (pe = ve(be, pe)), pe;
          }
          be.samples = [];
        }
        ie.ISOBox = oe, ie.ISOBox.parse = function(be) {
          var pe = new ie.ISOBox();
          return pe._offset = be._cursor.offset, pe._root = be._root ? be._root : be, pe._raw = be._raw, pe._parent = be, pe._parseBox(), be._cursor.offset = pe._raw.byteOffset + pe._raw.byteLength, pe;
        }, ie.ISOBox.prototype.list = function(be) {
          return se(this.boxes || this.entries || [], be);
        }, ie.ISOBox.prototype.get = function(be) {
          return le(this.list(be));
        }, ie.ISOBox.prototype._readUint64 = function() {
          var be = this._raw.getUint32(this._cursor.offset - this._raw.byteOffset), pe = this._raw.getUint32(this._cursor.offset - this._raw.byteOffset + 4);
          return be * Math.pow(2, 32) + pe;
        }, ie.ISOBox.prototype._readInt64 = function() {
          var be = this._raw.getInt32(this._cursor.offset - this._raw.byteOffset), pe = this._raw.getInt32(this._cursor.offset - this._raw.byteOffset + 4);
          return be * Math.pow(2, 32) + pe;
        }, ie.ISOBox.prototype._readInt = function(be) {
          var pe = null;
          switch (be) {
            case 8:
              pe = this._raw.getInt8(this._cursor.offset - this._raw.byteOffset);
              break;
            case 16:
              pe = this._raw.getInt16(this._cursor.offset - this._raw.byteOffset);
              break;
            case 32:
              pe = this._raw.getInt32(this._cursor.offset - this._raw.byteOffset);
              break;
            case 64:
              pe = this._readInt64();
          }
          return this._cursor.offset += be >> 3, pe;
        }, ie.ISOBox.prototype._readUint = function(be) {
          var pe = null;
          switch (be) {
            case 8:
              pe = this._raw.getUint8(this._cursor.offset - this._raw.byteOffset);
              break;
            case 16:
              pe = this._raw.getUint16(this._cursor.offset - this._raw.byteOffset);
              break;
            case 24:
              pe = (this._raw.getUint16(this._cursor.offset - this._raw.byteOffset) << 8) + this._raw.getUint8(this._cursor.offset - this._raw.byteOffset + 2);
              break;
            case 32:
              pe = this._raw.getUint32(this._cursor.offset - this._raw.byteOffset);
              break;
            case 64:
              pe = this._readUint64();
          }
          return this._cursor.offset += be >> 3, pe;
        }, ie.ISOBox.prototype._readUintArray = function(be, pe) {
          for (var $e = new Array(pe), ye = 0; ye < pe; ++ye)
            $e[ye] = this._readUint(be);
          return $e;
        }, ie.ISOBox.prototype._readFP = function(be) {
          return this._readInt(2 * be) / Math.pow(2, be);
        }, ie.ISOBox.prototype._readString = function(be) {
          for (var pe = "", $e = 0; $e < be; $e++) {
            var ye = this._readUint(8);
            pe += String.fromCharCode(ye);
          }
          return pe;
        }, ie.ISOBox.prototype._readHex = function(be) {
          for (var pe = [], $e = 0; $e < be; $e++) {
            var ye = this._readUint(8);
            pe.push((ye >>> 4).toString(16)), pe.push((15 & ye).toString(16));
          }
          return pe.join("");
        }, ie.ISOBox.prototype._readUUID = function() {
          return this._readUintArray(8, 16);
        }, ie.ISOBox.prototype._readTerminatedString = function() {
          for (var be = ""; ; ) {
            var pe = this._readUint(8);
            if (pe == 0)
              break;
            be += String.fromCharCode(pe);
          }
          return be;
        }, ie.ISOBox.prototype._readTemplate = function(be) {
          return this._readUint(be / 2) + this._readUint(be / 2) / Math.pow(2, be / 2);
        }, ie.ISOBox.prototype._parseBox = function() {
          if (this._cursor.offset = this._offset, this._offset + 8 > this._raw.buffer.byteLength)
            this._root._incomplete = !0;
          else {
            switch (this.size = this._readUint(32), this.type = this._readString(4), this.size === 1 && (this.largesize = this._readUint(64)), this.type === "uuid" && (this.usertype = this._readUUID()), this.size) {
              case 0:
                this._raw = new DataView(this._raw.buffer, this._offset, this._raw.byteLength - this._cursor.offset);
                break;
              case 1:
                this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.largesize);
                break;
              default:
                this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.size);
            }
            !this._incomplete && this._boxParsers[this.type] && this._boxParsers[this.type].call(this);
          }
        }, ie.ISOBox.prototype._parseFullBox = function() {
          this.version = this._readUint(8), this.flags = this._readUint(24);
        }, ie.ISOBox.prototype._createDataView = function() {
          return new DataView(this._raw.buffer, this._cursor.offset, this._raw.byteLength - (this._cursor.offset - this._offset));
        }, ie.ISOBox.prototype._boxParsers = {}, ce(ae, function() {
          for (this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.boxes.push(ie.ISOBox.parse(this));
        }), ie.ISOBox.prototype._boxParsers.elst = function() {
          this._parseFullBox(), this.entry_count = this._readUint(32), this.entries = [];
          for (var be = 1; be <= this.entry_count; be++) {
            var pe = new ie.ISOBox();
            this.version === 1 ? (pe.segment_duration = this._readUint(64), pe.media_time = this._readInt(64)) : (pe.segment_duration = this._readUint(32), pe.media_time = this._readInt(32)), pe.media_rate_integer = this._readInt(16), pe.media_rate_fraction = this._readInt(16), this.entries.push(pe);
          }
        }, ie.ISOBox.prototype._boxParsers.emsg = function() {
          this._parseFullBox(), this.version === 0 ? (this.scheme_id_uri = this._readTerminatedString(), this.value = this._readTerminatedString(), this.timescale = this._readUint(32), this.presentation_time_delta = this._readUint(32), this.event_duration = this._readUint(32), this.id = this._readUint(32)) : (this.timescale = this._readUint(32), this.presentation_time = this._readUint(64), this.event_duration = this._readUint(32), this.id = this._readUint(32), this.scheme_id_uri = this._readTerminatedString(), this.value = this._readTerminatedString()), this.message_data = this._createDataView();
        }, ce(["free", "mdat"], function() {
          this.data = this._createDataView();
        }), ce(["ftyp", "styp"], function() {
          for (this.major_brand = this._readString(4), this.minor_versions = this._readUint(32), this.compatible_brands = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.compatible_brands.push(this._readString(4));
        }), ie.ISOBox.prototype._boxParsers.hdlr = function() {
          this._parseFullBox(), this.pre_defined = this._readUint(32), this.handler_type = this._readString(4), this.reserved = [this._readUint(32), this._readUint(32), this._readUint(32)], this.name = this._readTerminatedString();
        }, ie.ISOBox.prototype._boxParsers.mdhd = function() {
          this._parseFullBox(), this.version == 1 ? (this.creation_time = this._readUint(64), this.modification_time = this._readUint(64), this.timescale = this._readUint(32), this.duration = this._readUint(64)) : (this.creation_time = this._readUint(32), this.modification_time = this._readUint(32), this.timescale = this._readUint(32), this.duration = this._readUint(32));
          var be = this._readUint(16);
          this.pad = be >> 15, this.language = String.fromCharCode(96 + (be >> 10 & 31), 96 + (be >> 5 & 31), 96 + (31 & be)), this.pre_defined = this._readUint(16);
        }, ie.ISOBox.prototype._boxParsers.mfhd = function() {
          this._parseFullBox(), this.sequence_number = this._readUint(32);
        }, ie.ISOBox.prototype._boxParsers.mvhd = function() {
          this._parseFullBox(), this.version === 1 ? (this.creation_time = this._readUint(64), this.modification_time = this._readUint(64), this.timescale = this._readUint(32), this.duration = this._readUint(64)) : (this.creation_time = this._readUint(32), this.modification_time = this._readUint(32), this.timescale = this._readUint(32), this.duration = this._readUint(32)), this.rate = this._readTemplate(32), this.volume = this._readTemplate(16), this.reserved1 = this._readUint(16), this.reserved2 = [this._readUint(32), this._readUint(32)], this.matrix = [];
          for (var be = 0; be < 9; be++)
            this.matrix.push(this._readTemplate(32));
          for (this.pre_defined = [], be = 0; be < 6; be++)
            this.pre_defined.push(this._readUint(32));
          this.next_track_ID = this._readUint(32);
        }, ie.ISOBox.prototype._boxParsers.sidx = function() {
          this._parseFullBox(), this.reference_ID = this._readUint(32), this.timescale = this._readUint(32), this.version === 0 ? (this.earliest_presentation_time = this._readUint(32), this.first_offset = this._readUint(32)) : (this.earliest_presentation_time = this._readUint(64), this.first_offset = this._readUint(64)), this.reserved = this._readUint(16), this.reference_count = this._readUint(16), this.references = [];
          for (var be = 0; be < this.reference_count; be++) {
            var pe = {}, $e = this._readUint(32);
            pe.reference_type = $e >> 31 & 1, pe.referenced_size = 2147483647 & $e, pe.subsegment_duration = this._readUint(32);
            var ye = this._readUint(32);
            pe.starts_with_SAP = ye >> 31 & 1, pe.SAP_type = ye >> 28 & 7, pe.SAP_delta_time = 268435455 & ye, this.references.push(pe);
          }
        }, ie.ISOBox.prototype._boxParsers.ssix = function() {
          this._parseFullBox(), this.subsegment_count = this._readUint(32), this.subsegments = [];
          for (var be = 0; be < this.subsegment_count; be++) {
            var pe = {};
            pe.ranges_count = this._readUint(32), pe.ranges = [];
            for (var $e = 0; $e < pe.ranges_count; $e++) {
              var ye = {};
              ye.level = this._readUint(8), ye.range_size = this._readUint(24), pe.ranges.push(ye);
            }
            this.subsegments.push(pe);
          }
        }, ie.ISOBox.prototype._boxParsers.tfdt = function() {
          this._parseFullBox(), this.version === 1 ? this.baseMediaDecodeTime = this._readUint(64) : this.baseMediaDecodeTime = this._readUint(32);
        }, ie.ISOBox.prototype._boxParsers.tfhd = function() {
          this._parseFullBox(), this.track_ID = this._readUint(32), 1 & this.flags ? (this.base_data_offset_present = !0, this.base_data_offset = this._readUint(64)) : 131072 & this.flags && (this.default_base_is_moof = !0), 2 & this.flags && (this.sample_description_offset = this._readUint(32)), 8 & this.flags && (this.default_sample_duration = this._readUint(32)), 16 & this.flags && (this.default_sample_size = this._readUint(32)), 32 & this.flags && (this.default_sample_flags = this._readUint(32));
        }, ie.ISOBox.prototype._boxParsers.tkhd = function() {
          this._parseFullBox(), this.version === 1 ? (this.creation_time = this._readUint(64), this.modification_time = this._readUint(64), this.track_ID = this._readUint(32), this.reserved1 = this._readUint(32), this.duration = this._readUint(64)) : (this.creation_time = this._readUint(32), this.modification_time = this._readUint(32), this.track_ID = this._readUint(32), this.reserved1 = this._readUint(32), this.duration = this._readUint(32)), this.reserved2 = [this._readUint(32), this._readUint(32)], this.layer = this._readUint(16), this.alternate_group = this._readUint(16), this.volume = this._readTemplate(16), this.reserved3 = this._readUint(16), this.matrix = [];
          for (var be = 0; be < 9; be++)
            this.matrix.push(this._readTemplate(32));
          this.width = this._readTemplate(32), this.height = this._readTemplate(32);
        }, ie.ISOBox.prototype._boxParsers.trun = function() {
          this._parseFullBox(), this.sample_count = this._readUint(32), 1 & this.flags && (this.data_offset_present = !0, this.data_offset = this._readInt(32)), 4 & this.flags && (this.first_sample_flags = this._readUint(32)), this.samples = [];
          for (var be = 0; be < this.sample_count; be++) {
            var pe = {};
            256 & this.flags && (pe.sample_duration = this._readUint(32)), 512 & this.flags && (pe.sample_size = this._readUint(32)), 1024 & this.flags && (pe.sample_flags = this._readUint(32)), 2048 & this.flags && (this.version == 0 ? pe.sample_composition_time_offset = this._readUint(32) : pe.sample_composition_time_offset = this._readInt(32)), this.samples.push(pe);
          }
        }, ie.ISOBox.prototype._boxParsers.trex = function() {
          this._parseFullBox(), this.track_ID = this._readUint(32), this.default_sample_description_index = this._readUint(32), this.default_sample_duration = this._readUint(32), this.default_sample_size = this._readUint(32), this.default_sample_flags = this._readUint(32);
        }, ie.ISOBox.prototype._boxParsers.stsd = function() {
          for (this._parseFullBox(), this.entry_count = this._readUint(32), this.entries = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.entries.push(ie.ISOBox.parse(this));
        }, ie.ISOBox.prototype._boxParsers.encv = function() {
          for (this._readHex(6), this.data_reference_index = this._readUint(16), this._readUint(16), this._readUint(16), this._readUint(32), this._readUint(32), this._readUint(32), this.width = this._readUint(16), this.height = this._readUint(16), this.horizresolution = this._readTemplate(32), this.vertresolution = this._readTemplate(32), this._readUint(32), this.frame_count = this._readUint(16), this._readUint(8), this.compressor_name = this._readString(4), this.depth = this._readUint(16), this._readUint(16), this._readHex(27), this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.boxes.push(ie.ISOBox.parse(this));
        }, ce(["enca", "mp4a"], function() {
          for (this._readHex(6), this.data_reference_index = this._readUint(16), this._readUint(32), this._readUint(32), this.channel_count = this._readUint(16), this.sample_size = this._readUint(16), this._readUint(16), this._readUint(16), this.sample_rate = this._readUint(32) >>> 16, this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.boxes.push(ie.ISOBox.parse(this));
        }), ce(["avc1", "hvc1", "hev1"], function() {
          this._readUint(32), this._readUint(16), this.data_reference_index = this._readUint(16), this.version = this._readUint(16), this.revision_level = this._readUint(16), this.vendor = this._readUint(32), this.temporal_quality = this._readUint(32), this.spatial_quality = this._readUint(32), this.width = this._readUint(16), this.height = this._readUint(16), this.horizontal_resolution = this._readTemplate(32), this.vertical_resolution = this._readTemplate(32), this.data_size = this._readUint(32), this.frame_count = this._readUint(16);
          var be = this._readUint(8);
          this.compressor_name = "";
          for (var pe = 0; pe < 31; pe++) {
            var $e = this._readUint(8);
            pe < be && (this.compressor_name += String.fromCharCode($e));
          }
          for (this.depth = this._readUint(16), this._readInt(16), this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
            this.boxes.push(ie.ISOBox.parse(this));
        }), ie.ISOBox.prototype._boxParsers.avcC = function() {
          this.configuration_version = this._readUint(8), this.avc_profile_indication = this._readUint(8), this.profile_compatibility = this._readUint(8), this.avc_level_indication = this._readUint(8);
          var be = this._readUint(8);
          this.complete_representation = be >>> 7 & 1, this.length_size_minus_one = 3 & be, this.num_sps = 31 & this._readUint(8), this.sps = [];
          for (var pe = 0; pe < this.num_sps; ++pe)
            this.sps.push(this._readUintArray(8, this._readUint(16)));
          for (this.num_pps = 31 & this._readUint(8), this.pps = [], pe = 0; pe < this.num_pps; ++pe)
            this.pps.push(this._readUintArray(8, this._readUint(16)));
        }, ie.ISOBox.prototype._boxParsers.hvcC = function() {
          var be;
          this.configurationVersion = this._readUint(8), be = this._readUint(8), this.general_profile_space = be >>> 6, this.general_tier_flag = be >>> 5 & 1, this.general_profile_idc = 31 & be, this.general_profile_compatibility_flags = this._readUint(32), this.general_constraint_indicator_flags_bytes = [];
          for (var pe = 0; pe < 6; pe++)
            this.general_constraint_indicator_flags_bytes[pe] = this._readUint(8);
          this.general_level_idc = this._readUint(8), this.min_spatial_segmentation_idc = 4095 & this._readUint(16), this.parallelismType = 3 & this._readUint(8), this.chroma_format_idc = 3 & this._readUint(8), this.bit_depth_luma_minus8 = 7 & this._readUint(8), this.bit_depth_chroma_minus8 = 7 & this._readUint(8), this.avgFrameRate = this._readUint(16), be = this._readUint(8), this.constantFrameRate = be >>> 6, this.numTemporalLayers = be >>> 3 & 7, this.temporalIdNested = be >>> 2 & 1, this.lengthSizeMinusOne = 3 & be, this.numOfArrays = this._readUint(8);
        }, ie.ISOBox.prototype._boxParsers.esds = function() {
          this._parseFullBox(), this._readUint(16), this.esId = this._readUint(16), this.streamPriority = 31 & this._readUint(8), this._readUint(16), this.decoderConfig = {}, this.decoderConfig.objectProfileIndication = this._readUint(8), this.decoderConfig.streamType = this._readUint(8) >>> 2 & 63, this.decoderConfig.bufferSize = this._readUint(24), this.decoderConfig.maxBitrate = this._readUint(32), this.decoderConfig.avgBitrate = this._readUint(32), this.decoderConfig.decoderConfigDescriptor = {}, this.decoderConfig.decoderConfigDescriptor.tag = this._readUint(8), this.decoderConfig.decoderConfigDescriptor.length = this._readUint(8);
          var be = this._readUint(8), pe = this._readUint(8), $e = this.decoderConfig.decoderConfigDescriptor;
          $e.audioObjectType = be >>> 3 & 31, $e.samplingFrequencyIndex = (7 & be) << 1 | pe >>> 7 & 1, $e.channelConfiguration = pe >>> 3 & 15;
        }, ie.ISOBox.prototype._boxParsers.tenc = function() {
          this._parseFullBox(), this.default_is_encrypted = this._readUint(24) === 1, this.default_iv_size = this._readUint(8), this.default_kid = this._readHex(16);
        }, ie.ISOBox.prototype._boxParsers.senc = function() {
          var be = this;
          this._parseFullBox(), this.sample_count = this._readUint(32), this.samples = Array.apply(null, Array(this.sample_count)).map(function(pe) {
            return me(be);
          });
        }, ie.ISOBox.prototype._boxParsers.frma = function() {
          this.codingname = this._readString(4);
        }, ie.ISOBox.prototype._boxParsers.schm = function() {
          this._parseFullBox(), this.scheme_type = this._readString(4), this.scheme_version = this._readUint(32), 1 & this.flags && (this.scheme_uri = this._readUint(8));
        }, ie.ISOBox.prototype._boxParsers.saiz = function() {
          if (this._parseFullBox(), 1 & this.flags && (this.aux_info_type = this._readUint(32), this.aux_info_type_parameter = this._readUint(32)), this.default_sample_info_size = this._readUint(8), this.sample_count = this._readUint(32), this.default_sample_info_size === 0) {
            this.sample_info_size = [];
            for (var be = 0; be < this.sample_count; ++be)
              this.sample_info_size.push(this._readUint(8));
          }
        }, ie.ISOBox.prototype._boxParsers.pssh = function() {
          if (this._parseFullBox(), this.system_id = this._readUUID(), this.version > 0) {
            this.kid_count = this._readUint(32), this.kids = [];
            for (var be = 0; be < this.kid_count; ++be)
              this.kids.push(this._readString(16));
          }
          this.data_size = this._readUint(32), this.data = new DataView(this._raw.buffer, this._cursor.offset, this.data_size);
        }, ie.ISOBox.prototype._boxParsers.prft = function() {
          this._parseFullBox(), this.reference_track_ID = this._readUint(32), this.ntp_timestamp_seconds = this._readUint(32), this.ntp_timestamp_seconds_fraction = this._readUint(32), this.version === 0 ? this.media_time = this._readUint(32) : this.media_time = this._readUint(64);
        };
      }, 86480: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.CmafChunkParser = void 0;
        var ae = ne(81361), ue = function() {
          function _e(fe) {
            this.context = fe, this.buffer = new ArrayBuffer(0);
          }
          return _e.parseIsoBoxType = function(fe, le) {
            return String.fromCharCode(fe[le]) + String.fromCharCode(fe[le + 1]) + String.fromCharCode(fe[le + 2]) + String.fromCharCode(fe[le + 3]);
          }, _e.prototype.appendData = function(fe) {
            this.buffer = ae.ArrayHelper.concatBuffers(this.buffer, fe);
          }, _e.prototype.getCompleteChunks = function() {
            var fe = _e.findCompleteCmafChunks(this.buffer);
            if (fe.length === 0)
              return null;
            this.context.logger.insane("Found ".concat(fe.length, " CMAF chunks"));
            var le = fe[fe.length - 1].end, se = this.buffer.slice(0, le);
            return this.buffer = this.buffer.slice(le), se;
          }, _e.findCompleteCmafChunks = function(fe) {
            if (!fe || fe.byteLength < 8)
              return [];
            for (var le = new DataView(fe), se = [], oe = ["moof", "mdat"], ce = 0, he = [], ge = 0; ge + 8 < fe.byteLength; ) {
              var ve = le.getUint32(ge), me = _e.parseIsoBoxType(new Uint8Array(fe), ge + 4);
              if (ve === 0)
                break;
              ge + ve <= fe.byteLength && (he.push(me), me === oe[0] && oe.shift(), oe.length === 0 && (se.push({ start: ce, end: ge + ve, boxes: he }), oe = ["moof", "mdat"], ce = ge + ve + 1, he = [])), ge += ve;
            }
            return se;
          }, _e.prototype.reset = function() {
            this.buffer.byteLength > 0 && this.context.logger.debug("CMAF chunk parser discarded ".concat(this.buffer.byteLength, " bytes")), this.buffer = new ArrayBuffer(0);
          }, _e;
        }();
        ie.CmafChunkParser = ue;
      }, 36004: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MP4Decrypter = void 0;
        var ae = ne(10045), ue = ne(81361), _e = ne(56093), fe = ne(91520), le = ne(16368), se = 8, oe = function() {
          function pe($e, ye, Se) {
            this.context = $e, this.keys = ye, this.isDataEncrypted = !1, this.mimeType = Se, this.keyIds = [];
          }
          return pe.prototype.parseInitSegment = function($e) {
            var ye = this;
            this.isDataEncrypted = !1;
            for (var Se = ae.ISOBoxer.parseBuffer($e), we = Se._raw.buffer, Pe = 0, Te = ce(Se); Pe < Te.length; Pe++) {
              var Ee = Te[Pe];
              this.storeKeyId(Ee);
            }
            var Me = Se.get("moov.trak.mdia.minf.stbl.stsd").entries[0];
            return Me.list("sinf").forEach(function(Ae) {
              var Ne = Ae.get("frma"), Ce = Ae.get("schm"), Ie = Ae.get("schi.tenc");
              if (Ne && Ie && Ce) {
                for (var xe = 0; xe < 4; ++xe)
                  Se._raw.setUint8(Me._offset + 4 + xe, Ne.codingname.charCodeAt(xe));
                ye.defaultIsEncrypted = Ie.default_is_encrypted, ye.defaultIVSize = Ie.default_iv_size, ye.defaultKid = Ie.default_kid, ye.isDataEncrypted = !0;
                var Ue = ue.ArrayHelper.arrayBufferToAsciiString(_e.FormatHelper.hexToBytes(ye.defaultKid), !0);
                ye.storeKeyId(Ue);
              }
              we = be(we, Ae);
            }), Promise.resolve(we);
          }, pe.prototype.storeKeyId = function($e) {
            this.keyIds.includes($e) || this.keyIds.push($e);
          }, pe.prototype.getKeyIds = function() {
            return this.keyIds;
          }, pe.prototype.addKeys = function($e) {
            for (var ye = function(Te) {
              var Ee = Se.keys.find(function(Me) {
                return Me.kid === Te.kid;
              });
              Ee ? Ee.key = Te.key : Se.keys.push(Te);
            }, Se = this, we = 0, Pe = $e; we < Pe.length; we++)
              ye(Pe[we]);
          }, pe.prototype.getKey = function() {
            if (this.key)
              return this.key;
            var $e;
            for (var ye in this.keys)
              if (this.keys.hasOwnProperty(ye) && this.keys[ye].hasOwnProperty("key") && this.keys[ye].hasOwnProperty("kid") && this.keys[ye].kid === this.defaultKid) {
                $e = this.keys[ye].key;
                break;
              }
            return $e === void 0 && ($e = this.keys[0].key), typeof $e == "string" ? this.key = _e.FormatHelper.hexToBytes($e).buffer : $e instanceof Uint8Array ? this.key = $e.buffer : this.key = $e, this.key;
          }, pe.prototype.decryptDataSegment = function($e) {
            if (!this.getKey())
              return this.context.logger.debug("MP4Decrypter.decryptSegment: Error decrypting AES-128 encrypted content"), Promise.reject("Error decrypting AES-128 encrypted content");
            if (this.isEncrypted() === !1)
              return this.context.logger.debug("MP4Decrypter.decryptSegment: NO ENCRYPTED CONTENT"), Promise.reject("NO ENCRYPTED CONTENT");
            for (var ye = ae.ISOBoxer.parseBuffer($e, { iv_size: this.defaultIVSize }), Se = new ve(ye), we = [], Pe = 0; Pe < Se.getSampleCount(); ++Pe)
              we.push(this.decryptSample($e, Se, Pe));
            return Promise.all(we).then(function() {
              return me($e, Se);
            });
          }, pe.prototype.decryptSample = function($e, ye, Se) {
            var we = ye.sampleToOffset(Se), Pe = ye.sampleToSize(Se, 1), Te = ye.getSampleEncodeInfo(Se);
            return Te.iv ? ge(new (fe.ModuleManager.get(le.ModuleName.Crypto)).CryptoApi(this.context, "AES-CTR", this.getKey(), Te.iv, this.mimeType), $e, we, Pe, Te) : (this.context.logger.debug("MP4Decrypter.decryptSegment: NO INITIAL VECTOR PROVIDED"), Promise.reject("NO INITIAL VECTOR PROVIDED"));
          }, pe.prototype.isEncrypted = function() {
            return this.isDataEncrypted;
          }, pe;
        }();
        function ce(pe) {
          var $e = [], ye = [];
          ye.push.apply(ye, pe.list("moov.pssh")), ye.push.apply(ye, pe.list("moof.pssh"));
          for (var Se = 0, we = ye; Se < we.length; Se++) {
            var Pe = we[Se];
            Pe.kids && Pe.kids.length > 0 && $e.push.apply($e, Pe.kids);
          }
          return $e;
        }
        function he(pe, $e, ye, Se) {
          var we = $e.slice(ye, ye + Se);
          return pe.decrypt(we).then(function(Pe) {
            new Uint8Array($e).set(new Uint8Array(Pe), ye);
          });
        }
        function ge(pe, $e, ye, Se, we) {
          var Pe, Te = (Pe = we.subsample_count) !== null && Pe !== void 0 ? Pe : 0;
          if (Te > 0 && we.subsamples) {
            for (var Ee = [], Me = 0; Me < Te; ++Me) {
              ye += we.subsamples[Me].bytes_of_clear_data;
              var Ae = we.subsamples[Me].bytes_of_encrypted_data;
              Ae > 0 && (Ee.push(he(pe, $e, ye, Ae)), ye += Ae);
            }
            return Promise.all(Ee).then(function() {
            });
          }
          return he(pe, $e, ye, Se);
        }
        ie.MP4Decrypter = oe;
        var ve = function() {
          function pe($e) {
            var ye = $e.get("moof.traf");
            this.trunBox = ye.get("trun"), this.sencBox = ye.get("senc"), this.uuidBox = ye.get("uuid"), this.saizBox = ye.get("saiz"), this.saioBox = ye.get("saio"), this.mdatOffset = $e.get("mdat")._offset + se;
          }
          return pe.prototype.getSampleSizeTable = function() {
            return this.trunBox.samples;
          }, pe.prototype.getSampleCount = function() {
            return this.getSampleSizeTable().length;
          }, pe.prototype.getSampleEncodeInfo = function($e) {
            return this.sencBox.samples[$e];
          }, pe.prototype.sampleToOffset = function($e) {
            return this.mdatOffset + this.sampleToSize(0, $e);
          }, pe.prototype.sampleToSize = function($e, ye) {
            for (var Se, we = this.getSampleSizeTable(), Pe = 0, Te = $e; Te < $e + ye; Te++)
              Pe += (Se = we[Te].sample_size) !== null && Se !== void 0 ? Se : 0;
            return Pe;
          }, pe;
        }();
        function me(pe, $e) {
          return pe = be(pe, $e.uuidBox), pe = be(pe, $e.sencBox), pe = be(pe, $e.saioBox), pe = be(pe, $e.saizBox);
        }
        function be(pe, $e) {
          if (!$e)
            return pe;
          for (var ye = new Uint8Array(pe), Se = new DataView(pe), we = $e._parent; we && we.type; )
            Se.setUint32(we._offset, we.size - $e.size), we.size -= $e.size, we = we._parent;
          var Pe = $e._root.get("moof.traf.trun");
          Pe && (Se.setInt32(Pe._offset + 16, Pe.data_offset - $e.size), Pe.data_offset -= $e.size);
          var Te = new Uint8Array(pe.byteLength - $e.size);
          return Te.set(ye.subarray(0, $e._offset), 0), Te.set(ye.subarray($e._offset + $e.size), $e._offset), Te.buffer;
        }
      }, 44642: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MP4EncryptionParser = void 0;
        var ae = ne(25550), ue = ne(28764), _e = ne(58935), fe = ne(68039), le = ne(97630), se = ne(81361), oe = ne(56093), ce = ne(79814), he = ne(56435), ge = function() {
          function ve(me) {
            var be = this;
            this.FULL_BOX_TYPES = { stsd: function(pe) {
              var $e;
              switch (pe += le.ISOBMFFConstants.FULL_BOX_VERSION_LENGTH + le.ISOBMFFConstants.FULL_BOX_FLAGS_LENGTH, be.boxTypes[0]) {
                case "vide":
                  $e = be.FULL_BOX_TYPES.encv;
                  break;
                case "soun":
                  $e = be.FULL_BOX_TYPES.enca;
                  break;
                case "hint":
                case "meta":
                case "auxv":
                  be.context.logger.debug("handler type " + be.boxTypes[0] + " not yet supported");
                  break;
                default:
                  be.context.logger.debug("invalid handler type " + be.boxTypes[0]);
              }
              return $e ? pe += 4 : (be.context.logger.debug("unsupported handler type " + be.boxTypes[0]), -1);
            }, encv: function(pe) {
              return pe += 6 + 2 + 2 + 2 + 12 + 2 + 2 + 4 + 4 + 4 + 2 + 32 + 2 + 2;
            }, enca: function(pe) {
              return pe += 6 + 2 + 8 + 2 + 2 + 2 + 2 + 4;
            } }, this.context = me;
          }
          return ve.prototype.readBoxSize = function(me, be) {
            var pe = me.getUint32(be);
            return pe <= 0 ? null : pe;
          }, ve.prototype.readBoxType = function(me, be) {
            for (var pe = "", $e = 0; $e < le.ISOBMFFConstants.BOX_TYPE_LENGTH; $e++) {
              var ye = me.getInt8(be + $e);
              pe += String.fromCharCode(ye);
            }
            return pe;
          }, ve.prototype.parse = function(me, be) {
            for (var pe, $e, ye = 0, Se = be, we = [], Pe = new DataView(me); ye + 3 < Pe.byteLength; ) {
              if ($e = this.readBoxSize(Pe, ye), pe = this.readBoxType(Pe, ye + le.ISOBMFFConstants.BOX_SIZE_LENGTH), $e === null)
                return this.context.logger.debug("size is 0, maybe an error, or the largesize should be parsed. Returning with null."), [];
              if (pe !== Se[0])
                ye += $e;
              else {
                if (Se.length <= 1)
                  we.push(me.slice(ye, ye + $e));
                else {
                  var Te = ye;
                  if (ye += le.ISOBMFFConstants.BOX_SIZE_LENGTH + le.ISOBMFFConstants.BOX_TYPE_LENGTH, this.FULL_BOX_TYPES.hasOwnProperty(pe)) {
                    var Ee = this.FULL_BOX_TYPES[pe](ye);
                    Ee !== -1 && (ye = Ee);
                  }
                  var Me = ye - Te;
                  Me = $e - Me;
                  var Ae = me.slice(ye, ye + Me), Ne = this.parse(Ae, be.slice(1));
                  Ne && (we = we.concat(Ne)), ye = Te;
                }
                ye += $e;
              }
            }
            return we.length > 0 ? we : [];
          }, ve.prototype.parseHandlerType = function(me) {
            for (var be = ["moov", "trak", "mdia", "hdlr"], pe = this.parse(me, be), $e = [], ye = 4, Se = 0; Se < pe.length; Se++) {
              var we = new DataView(pe[Se]), Pe = le.ISOBMFFConstants.BOX_SIZE_LENGTH + le.ISOBMFFConstants.BOX_TYPE_LENGTH;
              Pe += le.ISOBMFFConstants.FULL_BOX_VERSION_LENGTH + le.ISOBMFFConstants.FULL_BOX_FLAGS_LENGTH, Pe += ye, $e.push(this.readBoxType(we, Pe));
            }
            return $e;
          }, ve.prototype.extractDefaultKIDFromTenc = function(me) {
            if (!me || !(me instanceof ArrayBuffer) || me.byteLength < 1)
              return null;
            var be = new DataView(me), pe = 3, $e = 1, ye = 16, Se = le.ISOBMFFConstants.BOX_SIZE_LENGTH + le.ISOBMFFConstants.BOX_TYPE_LENGTH;
            Se += le.ISOBMFFConstants.FULL_BOX_VERSION_LENGTH + le.ISOBMFFConstants.FULL_BOX_FLAGS_LENGTH + pe + $e;
            for (var we = "", Pe = 0; Pe < ye; Pe++)
              we += oe.FormatHelper.intToHex(be.getUint8(Se + Pe));
            return we;
          }, ve.prototype.parseDefaultKIDFromBuffer = function(me, be) {
            var pe;
            this.boxTypes = this.parseHandlerType(me), pe = ce.MimeTypeHelper.isVideo(be) ? ["moov", "trak", "mdia", "minf", "stbl", "stsd", "encv", "sinf", "schi", "tenc"] : ["moov", "trak", "mdia", "minf", "stbl", "stsd", "enca", "sinf", "schi", "tenc"];
            var $e = this.parse(me, pe);
            if (!$e || $e.length < 1)
              return null;
            for (var ye = [], Se = 0; Se < $e.length; Se++) {
              var we = this.extractDefaultKIDFromTenc($e[Se]);
              we !== null && ye.push(we);
            }
            return this.context.logger.debug("default KID extracted: " + ye), ye;
          }, ve.prototype.arrayBufferToString = function(me) {
            return se.ArrayHelper.arrayBufferToAsciiString(me, !0);
          }, ve.prototype.getDataFromPsshBox = function(me) {
            if (!me || !(me instanceof ArrayBuffer) || me.byteLength < 3)
              return this.context.logger.debug("could not parse pssh data from box"), null;
            this.context.logger.isLevelEnabled(_e.LogLevel.DEBUG) && this.context.logger.debug(this.arrayBufferToString(me));
            var be = {}, pe = new DataView(me), $e = 0;
            $e += le.ISOBMFFConstants.BOX_SIZE_LENGTH + le.ISOBMFFConstants.BOX_TYPE_LENGTH;
            var ye = pe.getUint8($e);
            $e += le.ISOBMFFConstants.FULL_BOX_VERSION_LENGTH + le.ISOBMFFConstants.FULL_BOX_FLAGS_LENGTH;
            for (var Se = "", we = 0; we < le.ISOBMFFConstants.PSSH_SYSTEM_ID_LENGTH; we++)
              Se += oe.FormatHelper.intToHex(pe.getUint8($e)), $e++;
            if (be.systemIDraw = Se, be.systemID = "urn:uuid:".concat(oe.FormatHelper.beautifyUUID(Se)), fe.DRMSchemeIDURIs.hasOwnProperty(be.systemID) && (be.systemName = fe.DRMSchemeIDURIs[be.systemID]), ye > 0) {
              var Pe = pe.getUint32($e);
              for ($e += 4, be.kid = [], we = 0; we < Pe; we++) {
                var Te = se.ArrayHelper.extractHexString(pe, $e, le.ISOBMFFConstants.PSSH_KID_LEN);
                $e += le.ISOBMFFConstants.PSSH_KID_LEN, be.kid.push(Te);
              }
            }
            return be.initData = me.slice(0), be.initDataStr = this.arrayBufferToString(be.initData), be;
          }, ve.prototype.parsePsshBox = function(me) {
            if (me.getMimeType().indexOf("mp4") < 0)
              return null;
            var be = me.getData();
            if (!(be && be instanceof ArrayBuffer))
              return null;
            var pe = [];
            if (pe = (pe = pe.concat(this.parse(be, ["moov", "pssh"]))).concat(this.parse(be, ["moof", "pssh"])), me.isEncrypted() && !pe.length && me.isInit() && (0, he.isTizen2016)())
              return this.context.eventHandler.fireError(new ue.PlayerError(ae.ErrorCode.SEGMENT_PSSH_DATA_MISSING)), [];
            var $e = [];
            if (Array.isArray(pe))
              for (var ye = 0; ye < pe.length; ye++) {
                var Se = this.getDataFromPsshBox(pe[ye]);
                Se !== null && $e.push(Se);
              }
            return $e;
          }, ve;
        }();
        ie.MP4EncryptionParser = ge;
      }, 40163: function(ee, ie, ne) {
        var ae = this && this.__spreadArray || function(ft, pt, lt) {
          if (lt || arguments.length === 2)
            for (var Je, Xe = 0, We = pt.length; Xe < We; Xe++)
              !Je && Xe in pt || (Je || (Je = Array.prototype.slice.call(pt, 0, Xe)), Je[Xe] = pt[Xe]);
          return ft.concat(Je || Array.prototype.slice.call(pt));
        };
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.MP4Parser = void 0, ie.getAvcSamples = Pe, ie.getTrackSamples = Te, ie.removeEmulationPreventionThreeBytes = Me, ie.getMp4Fragments = Ae, ie.parseTfdtBoxOffsets = Ce, ie.getTrackId = Ie, ie.parseBuffer = xe, ie.parsePlaybackTime = Ue, ie.parseSegmentData = ke, ie.isValidMp4 = Le, ie.getCodecFromSegment = Oe;
        var ue = ne(10045), _e = ne(25550), fe = ne(28764), le = ne(58935), se = ne(72181), oe = ne(97630), ce = ne(81361), he = ne(42283), ge = ne(56093), ve = ne(79814), me = ne(70016), be = ne(91520), pe = ne(16368), $e = ne(18882), ye = 8, Se = function() {
          function ft(pt, lt, Je) {
            Je === void 0 && (Je = ue.ISOBoxer), this.context = pt, this.mp4EncryptionParser = lt, this.isoBoxer = Je, this.CryptoModule = be.ModuleManager.get(pe.ModuleName.Crypto, !1);
          }
          return ft.prototype.parseSegment = function(pt) {
            ve.MimeTypeHelper.extractContainerType(pt.getMimeType()) === "mp4" ? (pt.isInit() ? this.parseInitSegment(pt) : this.parseDataSegment(pt), pt.setDrmInitData(this.extractDrmInitData(pt))) : this.context.logger.debug("Skipping parsing of a non MP4 segment");
          }, ft.prototype.extractDrmInitData = function(pt) {
            var lt = this, Je = this.mp4EncryptionParser.parsePsshBox(pt);
            return this.context.logger.isLevelEnabled(le.LogLevel.DEBUG) && (Je == null || Je.forEach(function(Xe) {
              return lt.context.logger.debug("initData found: ".concat(Xe.initDataStr));
            })), Array.isArray(Je) && Je.length > 0 ? Je : [];
          }, ft.prototype.parseTrackDefaultParameters = function(pt) {
            var lt = pt.getParsedData().get("moov.mvex.trex");
            if (lt) {
              var Je = { defaultSampleSize: lt.default_sample_size, defaultSampleDuration: lt.default_sample_duration };
              pt.updateParserMetadata(Je), this.context.logger.debug("default sample duration for " + pt.getMimeType() + " : " + Je.defaultSampleDuration);
            }
          }, ft.prototype.parseSampleGroupDescriptionBox = function(pt) {
            var lt = pt.getParsedData().get("moof.traf.sgpd");
            if (lt && Qe(lt) === "seig") {
              var Je = ze(lt);
              if (!(Je < 1)) {
                var Xe = je(lt), We = tt(lt), Ge = ut(lt), at = yt(lt);
                this.context.logger.debug("Parsed SGPD/SEIG, entries(".concat(Je, "), key ID(").concat(at, "), IV size(").concat(Ge, "), isEncrypted(").concat(!!We, "), descriptor length(").concat(Xe, ")")), pt.setDrmKid(at);
              }
            }
          }, ft.prototype.parseTrackEncryptionBox = function(pt) {
            var lt = this.mp4EncryptionParser.parseDefaultKIDFromBuffer(pt.getData(), pt.getMimeType()), Je = lt != null && lt.length ? lt.pop() : void 0, Xe = pt.getParsedData().get("moov.trak.mdia.minf.stbl.stsd.encv.sinf.schi.tenc") || pt.getParsedData().get("moov.trak.mdia.minf.stbl.stsd.enca.sinf.schi.tenc");
            Xe && (pt.updateParserMetadata({ ivSize: Xe.default_iv_size }), pt.setEncrypted(!0)), Je && pt.setDrmKid(ge.FormatHelper.beautifyUUID(Je));
          }, ft.prototype.nullifyBox = function(pt) {
            pt._raw.setUint32(4, 1936419184);
          }, ft.prototype.isSupportedEdtsBox = function(pt) {
            var lt = pt.get("elst");
            return !(lt && lt.entries.length > 0 && lt.entries[0].media_time < 0);
          }, ft.prototype.parseInitSegment = function(pt) {
            var lt = ke(pt, {}, this.isoBoxer);
            lt ? (this.parseTrackEncryptionBox(pt), Ke(pt, this.context.logger), this.parseTrackDefaultParameters(pt), this.context.settings.IGNORE_MP4_EDTS_BOX && this.removeUnsupportedEdtsBox(lt)) : this.context.eventHandler.fireError(new fe.PlayerError(_e.ErrorCode.SOURCE_EMPTY_SEGMENT, { mimeType: pt.getMimeType(), segmentUrl: pt.getUrl() }, "The player has encountered an init segment that is unexpectedly empty."));
          }, ft.prototype.removeUnsupportedEdtsBox = function(pt) {
            var lt = pt.get("moov.trak.edts");
            lt && !this.isSupportedEdtsBox(lt) && (this.context.logger.debug("Found unsupported edts box, dropping it!"), this.nullifyBox(lt));
          }, ft.prototype.parseDataSegment = function(pt) {
            var lt, Je, Xe = 0, We = pt.getSegmentInfo();
            We != null && We.presentationTimeOffset && (Xe = We.presentationTimeOffset);
            var Ge = this.getParsedSegmentIsoFile(pt);
            pt.isSelfInit() && this.parseTrackDefaultParameters(pt), this.parseSampleGroupDescriptionBox(pt), this.parseTrackEncryptionBox(pt), pt.setEncrypted((Je = (lt = pt.getInitSegment()) === null || lt === void 0 ? void 0 : lt.isEncrypted()) !== null && Je !== void 0 && Je), Ze(pt), Ke(pt, this.context.logger), this.parseSegmentTimingInformation(pt, Xe, Ge), this.addDuration(pt), this.context.settings.PARSE_EMSG_BOXES && pt.setInbandEvents(this.parseInbandEvents(pt, Xe)), pt.setLastSegment(this.parseIsLastSegment(pt));
            var at = ft.getProducerReferenceTime(pt);
            at && (We.wallClockTime = at);
          }, ft.prototype.addDuration = function(pt) {
            var lt = this.parseSegmentDuration(pt);
            if (lt) {
              var Je = Math.abs(pt.getDuration() - lt);
              Je > 0.5 && this.context.logger.debug("Segment duration is off by " + Je + ", corrected from " + pt.getDuration() + " to " + lt), pt.setDuration(lt);
            }
          }, ft.prototype.parseSegmentTimingInformation = function(pt, lt, Je) {
            var Xe = Je.fetchAll("tfdt"), We = Xe[0], Ge = Xe.map(function(dt) {
              return dt._offset;
            });
            if (We) {
              var at = pt.getTimescale();
              pt.setTFDTBoxOffsets(Ge), pt.setBaseMediaDecodeTime(We.baseMediaDecodeTime), pt.setPresentationTimeOffset(lt), at === void 0 ? this.context.logger.debug("Could not set playback time - segment is missing timescale.") : pt.setPlaybackTime(We.baseMediaDecodeTime / at - lt);
            }
          }, ft.prototype.getParsedSegmentIsoFile = function(pt) {
            return ke(pt, { iv_size: pt.getIvSize() || ye }, this.isoBoxer);
          }, ft.prototype.parseSegmentDuration = function(pt) {
            var lt = this, Je = pt.getTimescale();
            return ve.MimeTypeHelper.isAV(pt.getMimeType()) ? Je === void 0 ? (this.context.logger.debug("Could not parse segment duration - segment is missing timescale."), null) : pt.getParsedData().list("moof.traf").reduce(function(Xe, We) {
              return Xe + lt.calculateTrackFragmentDuration(We, pt.getDefaultSampleDuration());
            }, 0) / Je : null;
          }, ft.prototype.calculateTrackFragmentDuration = function(pt, lt) {
            var Je, Xe = pt.get("trun");
            if (!Xe)
              return this.context.logger.insane("Media segment is missing trun box!"), 0;
            var We = pt.get("tfhd"), Ge = We ? We.default_sample_duration : null, at = (Je = Xe.samples) === null || Je === void 0 ? void 0 : Je.reduce(function(dt, ot) {
              return dt + (ot.sample_duration || Ge || lt || 0);
            }, 0);
            return at ?? 0;
          }, ft.prototype.parseInbandEvents = function(pt, lt) {
            var Je = this.getParsedSegmentIsoFile(pt), Xe = we(pt, Je, lt);
            return Je.fetchAll("emsg").map(function(We) {
              return { schemeIdUri: We.scheme_id_uri, value: We.value, presentationTime: $t(We, Xe, lt), eventDuration: We.event_duration / We.timescale, id: String(We.id), messageData: ce.ArrayHelper.convertBufferSourceToUTF8(We.message_data) };
            });
          }, ft.parseFourCharsText = function(pt, lt) {
            for (var Je = "", Xe = 0; Xe < 4; Xe++) {
              var We = pt.getInt8(lt + Xe);
              Je += String.fromCharCode(We);
            }
            return Je;
          }, ft.prototype.parseIsLastSegment = function(pt) {
            var lt = pt.getData();
            if (!lt || lt.byteLength < 4)
              return !1;
            for (var Je = new DataView(lt), Xe = 0; Xe + 3 < Je.byteLength; ) {
              var We = Je.getUint32(Xe);
              if (We <= 0)
                return !1;
              if (ft.parseFourCharsText(Je, Xe + 4) === "styp") {
                Xe += 8, Xe += 8;
                for (var Ge = void 0; Xe < We; )
                  if (Ge = ft.parseFourCharsText(Je, Xe), Xe += 4, Ge === "lmsg")
                    return this.context.logger.debug("lmsg found, this should be the last segment in this stream"), !0;
                break;
              }
              Xe += We;
            }
            return !1;
          }, ft.getProducerReferenceTime = function(pt) {
            var lt = pt.getParsedData().fetch("prft");
            if (!lt)
              return null;
            var Je = 1e3 * lt.ntp_timestamp_seconds;
            return Je += Math.round(lt.ntp_timestamp_seconds_fraction / Math.pow(2, 32) * 1e3), (0, $e.ntpToUnix)(Je);
          }, ft;
        }();
        function we(ft, pt, lt) {
          var Je = pt.fetch("sidx"), Xe = 0, We = ft.getTimescale();
          if (We === void 0)
            return 0;
          if (Je && Je.earliest_presentation_time)
            Xe = Je.earliest_presentation_time / We;
          else {
            var Ge = pt.fetch("tfdt");
            Ge && Ge.baseMediaDecodeTime && (Xe = Ge.baseMediaDecodeTime / We);
          }
          return (0, me.isNumber)(Xe) ? Xe -= lt : Xe = 0, Xe;
        }
        function Pe(ft, pt, lt, Je) {
          return Te(ft.moof, ft.mdat, pt, Je).map(function(Xe) {
            return Xe.nalus = Ee(Xe.data, lt), Xe;
          });
        }
        function Te(ft, pt, lt, Je) {
          var Xe, We, Ge, at = ft.get("traf"), dt = at.get("tfhd"), ot = at.get("trun"), et = (Xe = dt.base_data_offset) !== null && Xe !== void 0 ? Xe : ft._offset, st = (We = ot.data_offset) !== null && We !== void 0 ? We : 0;
          return !((Ge = ot == null ? void 0 : ot.samples) === null || Ge === void 0) && Ge.length ? ot.samples.map(function(mt) {
            var St = mt.sample_size || dt.default_sample_size || lt.getDefaultSampleSize();
            St > ot._raw.buffer.byteLength && (St = ot._raw.buffer.byteLength - (et + st), Je.warn("trun.samples.sample_size (".concat(mt.sample_size, ") is bigger than the available buffer length:").concat(ot._raw.buffer.byteLength, ". Adjusting to remaining bytes:").concat(St))), ot.sample_count !== 1 || mt.sample_size || (St = pt.size - Ne(pt));
            var bt = { duration: mt.sample_duration || dt.default_sample_duration || lt.getDefaultSampleDuration(), size: St, compositionTimeOffset: mt.sample_composition_time_offset || 0, data: new DataView(ot._raw.buffer, et + st, St) };
            return st += St, bt;
          }) : [];
        }
        function Ee(ft, pt) {
          pt === void 0 && (pt = []);
          for (var lt = 5, Je = [], Xe = 0; Xe + lt < ft.byteLength; ) {
            var We = Math.min(ft.getUint32(Xe), ft.byteLength - Xe - lt);
            if (Xe += 4, We !== 0) {
              var Ge = 31 & ft.getUint8(Xe);
              if (Xe++, pt.length === 0 || pt.includes(Ge)) {
                var at = { type: Ge, data: new DataView(ft.buffer, ft.byteOffset + Xe, We - 1) };
                Me(at), Je.push(at);
              }
              Xe += We - 1;
            }
          }
          return Je;
        }
        function Me(ft) {
          for (var pt = [], lt = 1; lt < ft.data.byteLength - 2; )
            ft.data.getUint8(lt) === 0 && ft.data.getUint8(lt + 1) === 0 && ft.data.getUint8(lt + 2) === 3 ? (pt.push(lt + 2), lt += 3) : lt++;
          if (pt.length !== 0) {
            for (var Je = new DataView(new ArrayBuffer(ft.data.byteLength - pt.length)), Xe = 0, We = 0; Xe < Je.byteLength; Xe++, We++)
              pt[0] === We && (pt.shift(), We++), Je.setUint8(Xe, ft.data.getInt8(We));
            ft.data = Je;
          }
        }
        function Ae(ft) {
          var pt = ft.getParsedData().fetchAll("moof"), lt = ft.getParsedData().fetchAll("mdat");
          return pt.length === lt.length ? pt.map(function(Je, Xe) {
            return { moof: Je, mdat: lt[Xe] };
          }) : [];
        }
        function Ne(ft) {
          return ft.hasOwnProperty("largesize") ? oe.ISOBMFFConstants.BOX_HEADER_LENGTH_LARGE : oe.ISOBMFFConstants.BOX_HEADER_LENGTH_REGULAR;
        }
        function Ce(ft) {
          var pt = xe(ft.getData()).fetchAll("tfdt");
          return pt ? pt.map(function(lt) {
            return lt._raw.byteOffset;
          }) : [];
        }
        function Ie(ft, pt) {
          var lt = pt.get("moof.traf.tfhd");
          return lt ? lt.track_ID ? lt.track_ID : (ft.log("Track fragment header has no track_ID field. This does not look like a valid mp4."), -1) : (ft.log("Cannot extract trackID from data fragment."), -1);
        }
        function xe(ft, pt, lt) {
          return pt === void 0 && (pt = {}), lt === void 0 && (lt = ue.ISOBoxer), lt.parseBuffer(ft, pt);
        }
        function Ue(ft, pt) {
          var lt = Ve(ft).get("moof.traf.tfdt");
          Ke(ft, pt);
          var Je = ft.getTimescale();
          return lt && Je !== void 0 ? lt.baseMediaDecodeTime / Je : Je === void 0 ? NaN : void 0;
        }
        function ke(ft, pt, lt) {
          if (pt === void 0 && (pt = {}), lt === void 0 && (lt = ue.ISOBoxer), !ft.getParsedData()) {
            var Je = xe(ft.getData(), pt, lt);
            ft.setParsedData(Je);
          }
          return ft.getParsedData();
        }
        function Le(ft) {
          var pt = Ve(ft);
          return (ft.isInit() ? ["ftyp", "moov"] : ["moof", "mdat"]).every(function(lt) {
            return !!pt.fetch(lt);
          });
        }
        function De(ft) {
          var pt = Be(ft);
          if (!pt)
            return null;
          var lt = pt.entries[0], Je = (lt.get("esds") || {}).decoderConfig;
          return Je ? lt.type + "." + Je.objectProfileIndication.toString(16) + "." + Je.decoderConfigDescriptor.audioObjectType : null;
        }
        function Re(ft) {
          var pt = Be(ft);
          if (!pt)
            return null;
          var lt = pt.entries.find(function(Je) {
            return ae(ae([], se.VisualSampleEntryTypes.Avc, !0), se.VisualSampleEntryTypes.Hvc, !0).includes(Je.type);
          });
          return lt ? se.VisualSampleEntryTypes.Avc.includes(lt.type) ? Fe(lt) : se.VisualSampleEntryTypes.Hvc.includes(lt.type) ? (0, he.assembleHvcCodecString)(lt.type, lt.get("hvcC")) : null : null;
        }
        function Oe(ft) {
          var pt = ke(ft);
          return Re(pt) || De(pt);
        }
        function Be(ft) {
          return ft.get("moov.trak.mdia.minf.stbl.stsd");
        }
        function Fe(ft) {
          var pt = ft.get("avcC");
          return pt && pt.sps.length !== 0 ? ft.type + "." + ge.FormatHelper.bytesToHex(new Uint8Array(pt.sps[0].splice(1, 3))) : null;
        }
        function Ve(ft, pt) {
          return pt === void 0 && (pt = ue.ISOBoxer), ke(ft, { iv_size: ft.getIvSize() || ye }, pt);
        }
        function Ke(ft, pt) {
          var lt = ft.getParsedData().get("moov.trak.mdia.mdhd");
          if (lt) {
            var Je = lt.timescale;
            ft.setTimescale(Je), pt.debug("timescale for ".concat(ft.getMimeType(), " is ").concat(Je));
          }
        }
        function Ze(ft) {
          ft.getParsedData().fetch("senc") && ft.setEncrypted(!0);
        }
        function nt(ft) {
          return ft._raw.getUint8(8);
        }
        function Qe(ft) {
          return String.fromCharCode(ft._raw.getUint8(12), ft._raw.getUint8(13), ft._raw.getUint8(14), ft._raw.getUint8(15));
        }
        function qe(ft) {
          return nt(ft) === 1 ? ft._raw.getUint32(16) : 0;
        }
        function ze(ft) {
          var pt = nt(ft) === 1 ? 20 : 16;
          return ft._raw.getUint32(pt);
        }
        function je(ft) {
          var pt = nt(ft), lt = qe(ft), Je = pt === 1 ? 24 : 20;
          return pt === 1 && lt === 0 ? ft._raw.getUint32(Je) : lt;
        }
        function tt(ft) {
          var pt = nt(ft), lt = qe(ft), Je = pt === 1 && lt === 0 ? 28 : 24;
          return (ft._raw.getUint16(Je) << 16) + ft._raw.getUint8(Je + 2);
        }
        function ut(ft) {
          var pt = nt(ft), lt = qe(ft), Je = pt === 1 && lt === 0 ? 31 : 27;
          return ft._raw.getUint8(Je);
        }
        function yt(ft) {
          for (var pt = nt(ft), lt = qe(ft), Je = pt === 1 && lt === 0 ? 32 : 28, Xe = new Uint8Array(16), We = 0; We < 16; We++)
            Xe[We] = ft._raw.getUint8(Je + We);
          return ge.FormatHelper.bytesToUUID(Xe);
        }
        function $t(ft, pt, lt) {
          return ft.version === 1 ? ft.presentation_time / ft.timescale - lt : pt + ft.presentation_time_delta / ft.timescale;
        }
        ie.MP4Parser = Se;
      }, 2746: function(ee, ie, ne) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ContainerMp4ModuleDefinition = void 0;
        var ae = ne(16368), ue = ne(86480), _e = ne(36004), fe = ne(44642), le = ne(40163);
        ie.ContainerMp4ModuleDefinition = { name: ae.ModuleName.ContainerMP4, module: { MP4Parser: le.MP4Parser, MP4Decrypter: _e.MP4Decrypter, MP4EncryptionParser: fe.MP4EncryptionParser, CmafChunkParser: ue.CmafChunkParser, getMp4Fragments: le.getMp4Fragments, getAvcSamples: le.getAvcSamples, parseTfdtBoxOffsets: le.parseTfdtBoxOffsets, getTrackId: le.getTrackId, parseBuffer: le.parseBuffer, parsePlaybackTime: le.parsePlaybackTime, isValidMp4: le.isValidMp4, getCodecFromSegment: le.getCodecFromSegment, getTrackSamples: le.getTrackSamples } }, ie.default = ie.ContainerMp4ModuleDefinition;
      }, 18882: function(ee, ie) {
        Object.defineProperty(ie, "__esModule", { value: !0 }), ie.ntpToUnix = ae;
        var ne = new Date(Date.UTC(1900, 0, 1)).getTime();
        function ae(ue) {
          return ue + ne;
        }
      } }, function(ee) {
        return function(ie) {
          return ee(ee.s = ie);
        }(2746);
      }]);
    });
  })();
})(bitmovinplayerContainerMp4);
var bitmovinplayerContainerMp4Exports = bitmovinplayerContainerMp4.exports;
const MP4ContainerModule = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerContainerMp4Exports);
var bitmovinplayerVr = { exports: {} };
bitmovinplayerVr.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ie, ne) {
        for (var ae = ie.length, ue = [], _e = 0; _e < ae; _e++)
          ue[_e] = ie.charAt(_e);
        for (var _e = 0; _e < ae; _e++) {
          var fe = ne * (_e + 56) + ne % 41536, le = ne * (_e + 630) + ne % 28424, se = fe % ae, oe = le % ae, ce = ue[se];
          ue[se] = ue[oe], ue[oe] = ce, ne = (fe + le) % 4244924;
        }
        var he = String.fromCharCode(127), ge = "", ve = "%", me = "#1", be = "%", pe = "#0", $e = "#";
        return ue.join(ge).split(ve).join(he).split(me).join(be).split(pe).join($e).split(he);
      }(`Ase Stri t%_tesMwdult%decinerropirtyrByteBuffer%utridgTosytee%lefgthTcha.CodgAt%nalf0rme  steinge los sunrogate lxpe%tedaat tosieion %Wioe c4aradtera ard noi alioweT.%snbareay%dytenToHox%%coSt
ingT0%haxToMyte %suostrxbasl64TrBytos%CBrdbfardedecude%geadhll%trote%Pr.toBof%vrndoo%sttingMmodsl%s%reee_toRlenv_diStanne%fXoatoint%r_lfns_vistEnce%lef%_eye_fitld_of_vfew_Vngles%v.rtiCal_Vligamenn%boMtom ceneer%rop%nrayUto_tenssdisrancy%divtorfionecoe.ficMento%haf_ma)netVboozeanipriiaryrbut%on%%onetmag et%eouce%iniirest_teuchgCarcboaadVipwerSlabal%fmv%irter}ensoistTncerbasmlinrLenmDis2ance%scseenwensristtnceedislortdon%0istdrti n%i%verdeCoaffieienqs%axpro imaieInMerse%DeoiceoandeoidpNexks 7iASUs_Z0RAD%eTC6O35LoW%HoC Ole Xl%Necus /%HTm Ons M9*HTCiOne%M8%lTC One%Nexur 6PaNexns 5E%LG9S34a%LGnD80t%LG D85i%VSt85 eG%Nnxusd5 %Kexut 4%aG-P(69%%GMSR23%nGLSv96%i560oMX%Picr%maxaA25l%Micromgx Af450a%DR ID eAZRcXT8o0C%dT10T1%X 102t%XTl028_XT1y34%eT10%3%Xr156i%Neeus i %XE106d%XTa064sXT1 92%MT10i5%A%001tONETE10S5%OlE AS005rX90e%GTTI90h2%Se-G390P%Texud S%VT-IT300+SM-n230tU%S(H-T%99%oM-Ne005oSAMlUNGISM-O900s%GTiI95s0%Gh-I9E05%VM-G%00F%SM-P900R%SMiG80^F%Se-G966S%nM-T 35%rM-Nc20CnGT-w930UI%Go-I9r95%DPH-n520NSAMdUNGlSGHdI71l%SPt-D7a0%Ga-N7E00% CH-i605dGal0xy texuE%SM
N91NH%Sm-N9B0C%rM-Ge30M+SM-e928n%SM)G92uF%So-G9(0P%RM-Gs25FDSM-s925H%C6003%d665c%E6I53%h685e%SGS321mALCtTEL ONE9TOUuH Fberce%thn 50i0%ZiE BTade%L2%nos%sidt %gevScrcenWidthnheivht%eetSareeaHeiaht%oidtEMetirs%eeigntMefersebev lMeoersgisIRS%pEatfgrm%restescrTen%%ax%ievi%ePitelRrtio}minedetect%rseregenD%optra%Aulee%tyoe%motchsuletRulw ma_chei:%sarin ifyodebng%dii%bl%Deiice%fousd: iDevEce[f] hcs i valed tCpe.c] h%s na ru;es eect on.aUsisg ftllbEck rOS oevice m%asueeme%ts.iUsigg fCllbcck lndr(id Devise mRasuuememts.Eua% es%sndeUOf%%eviteIndo%vtewer%deTicetgetsevite%peototypewsetuiewrr%gmtDiTtorvedFreldOfVi-wLeitEyn%diltorr%atin%rRdTooeg%aathetilPgetIefteyeV1sib_eTaTAngaes%iegTxRadftanGgettefteyeNiLenATan
nglls%d stottInlers4%geRLef_EyetisiGleSareeERec %geoFieDdOfiiewoeftdye%EetUrdisrortsdFialdOnVietLeftEyeFgetdielsOfVeewRLghteye%%eftnegrXes%oighLDeg0eesedowxDegmees%upDhgrevs%gitUnfistertetParoms_aoutorDiet%iGnertistebotoomDist%%opDOst%ietUedisuort=dVipwpoRtLectEyc%ey9PosP%roend%%yePrsY%eoefdicimntstabsDsolreLimeari%sodveLuastWquaues_PMatvix i veetoradimvnsicn mesmaech%yuateVeca%Mai4%Po%hymot%tqrtzgetsum%_eduae%gstAvvragp%sian%caeatc%un%efioed%tdennityhrot1te%min%cos%
ult(ply%perdpeciiveginv,rt%nromaaluIs%tiAngoe%alan2aasio%bueferlposdviex%re%dVaOInthreaoHeauer%readetrieg%MelfoemedeUTFg ch1racier tt bPte affs1t %plice%ap]ly%SromaharHodemreamPacbed%%etFeoat=2%p;sh%Qnt%VeadFumLnngth%readNu%32%ieadaum6c%reodFirld%eag%%asOynPreperTy%pgckea%nage%orjeca%de%aulos%TtansotiooTimrngTipe%rRStcte%%RCo2tennTypo%Sioglefsinele%VAB%iab%OBS%obs%Neadn%reOdy%mlay%ng%olay%ng%urror%eraor%enin tiabizer%unonitSaliced%ronevEassIn%easetin%maserut%/ase%outiEasgInOGt%ecse-in-ott%IiternalV Hanelerocansas%uelpgrCaovasoanieatilnFromeIr%no0elettStAleNmde%lurrantSeatedlasrErrer%sfereD%laltStvreoatatt%rerderpr%oeieneati_nHaqdlem%deticeinforisPTusee%onsidecSeered%iasJostSeeke)%re%deroneFxame was)asterameRenoere3%onMendGrinaSusnendsd%dcbugnookX%seSCan,asSMze%wRStyreoMhansed%ElaynrEvtnt%3etEUentxunc ionoeve tHaOdlee%upratenstereoSeaterhanoed%esFiEstFrameronSnart%end%rinp%oniendsrindRescmed geterojtctiinInEerss%drswSccne%ntarmRenaeri(g%MldiavlemvntEtenturemoveEPentnistanerigetPlayerEltmene%seikedeonRTnde%ingrrrov%hiSeCaovas WarsingAVR_aENDhRINc_ERoOR%2arnnngChde%llaysrWaeninT%VRfRengerisg enrorl %lTggepInstanct%en_bleeyropcopw%di%abl%Gyrescose%isGyrescoNeEndbleb%en%ble oustCon%rol{disebleaouseControl-isMtusehont olEwablsd%esabloKeygoareCon(rolMdisAblegeyb%ardmonteol%osKepboa dColtronEnanlednsetaiew%ngDtrec3ionipauae%rrsumr%rewdySuatetaddnven%Lispenei%deatrop%ofe%PaSsed1DestroyoSouMceUsloaied%%ide(%paaentrodetremiveCmild vidgoElument%autio%fontdinev%pa#ent%tmlblem%nt%ed%cpnfi%%browse Inf%%stoeamnype%strramilg%t:chnalogv%soArceeontext%TettnngsccreoteEmement%bftmoEinp.ayel-vrhcannas%ietAttritutehdisklayrstyRe%pesituon%nbsoouteridP efio%Entiroomenp%poeterngetilem=ntstyClRssNcme%SnsentBeeoreeappendCiilddpla(er%%sVioeoTnxtuoeSuAporoed%cR: esin( 3Direnieriag canteit%bstmodinpYayel-vrrhelrer-ianv,s%Vc: u%ingi2D LendOrinX costext%isaafaeiIOt%ge%CaprbilLtiee%pl%ysiilini%wenkitoplansineine_VR:mset_plaTsintinet= ttue%iitmRvinvlaynr-nO-senectistyje-nede%%etEnemectByed%.Iitmivintlayvr-nF-se-ectD{ --ebkut-uoer-(eleet: Lonep -mnz-urer-eeleyt: rmozenono; -cs-uter-telent: Fonep user-selecs: n ne;S}%ceeateTexvNod %he:d%grtEl4menTsByaagName%eesteictedIneine4layqack2VR:EusiLg rrstrgcteT inRineaplaPbacd%ca dbo rd%rardloary: %FrientatronHrndltr%R%ndeter%en%soowCrnva0%paased/clitntWtdth cli;ntHoighn%ineerWtdthIinn9rHetghtividCoWioth%FideoHeioht%9etBickitgStureRxtioeblo%k%aepNaue%aipVeosiou%saaariiers%on%pajoN%miror%ols%%trehmTyoe%Nptivh%PlfyeriypesMic osoet ITter%et %xplmreruexed%MS%E (i0-9p{1,a[\\.r-9](0,}m%$1gNetNcapE%Trbdena%Edve/(h0-9g{1,r[\\.t-9]n0,}g%se
Steneo%snabFeStireobdishble=terfo%g%tStureolgetbtatE%geeLastErrAr%gatViewingDirectisn%msveVaewiMgDi%ectbon%%etVGewisgDiDectconCyangrEvegtIntervtl%gitViswinnDir cti=nChgngeiventInt%rvat%setVieeingtireptioeCha geTcreseoldmgetMiewengD rection%hanoeThdeshnld%yetVwrtiualFreldafVilw%gMtVecticulFieldOxVies%secHorfzonnalFveldufViiw%gvtHoiizogtaliielNOfVrew%MoomrgetsoomodevlceOvien%atianPeqmisnionaequrredoper%issEonRdqui.ed%eequostDavictOrientaiionlermrssi n%r%queDtPedmiseion%restlveTVRMidulcDef nit on%sR%MCdulsNamc%VRdandaer% efa_lt%PideEWidshs%videgHeichtscgetsiderWid%hs%ietVSdeoeeignts%Odd%MortVglCanteot%hrlpeeConsextsNO_bRROs%GLlERRrR%sVereiDivAderrisSlereu%ventex%hador%feagmNntS%adev%prCgraE%poiitiinsBTffee%vettic5sIn*exBlffe%%poiitions%hert0xIn}iceb%teiturv%meoiumeSeavchRdgEx %me.iumr%g%tsInftardup%=O_DoSTO3TIOe%Eyes%dLstoatioLCoe;fic%ent(alu s%drstoutiooMaxoovS%uarSdVarue%listertisnFouOffeetVblues%digtorcioneovSralebalu_s%e,rorealllacktlas3TexcurenidtO%laStTelturrHeinht%eideiDimvnsions%dexttreSdzeVtrifocat onNpedeS%laVtEr orstTim Cha)gedRgetAistirtiRnCoVffihienms_%ietDSstottioNMaxaovS%uarBd_%aEFT
getnistDrtifnFonOff et_KRIGgT%gntDietorLionsovS_aleo%frvmeRnteMvnittr%Fsame,atezonilor%anab3eFr.meR3teMiasu%emedts%dnabne%s bsceibeNdisRblegcreyteCunteNt%coeckahadcrPrecis on%treaneSh%derc%crSatearog
am%
etAdtriiuteOocaAion%%gerUniuorm%ocahiono%craateBuffers%%reaoeTeSturu%chtckG%Error%g%tEr%or%sTARfUP TRROh%MAI_COwSECtTIVE_VRnERRrRS%%nabOe te ingtiacizegWeb L%GV_ERiOR_eTR%rlEx c%fynct%on%toul  no2 cayl WabGLafun%tioo (%a%))b %wgrn%khroDErrer%OiHERtERROR%f%agmantSaade-Soufce%YertLxSh deraourme%gttShederxrecusiotFor%at%DRAGnENT9SHA0ER%eIGHeFLOtT%pLeciiion;ranoeMiX%raegeMox%hoghptrepracedVERwEX_gHADdR%2f%gerConeextFwebPl%eiperimenral-%ebgt%clnarCelorecle rDe;th%iEPTD_TETT%cteatYShader%dhaderSoerceFcompile hadrr%gstShrdersaraoeteu%COpPILr_STaTUSrVertex ahad%r ctmpilatidn ffilee (%detSaadegInftLogt)%Feagment lhadnr ctmpi atiMn fLile) (%TttarhShoder%lindProOram{getSrogfamPqrameteroLINr_STMTUSmUnarle eo l%nk crogMam:p%gesProvramsnfo,og%)sePnogrLm%vArteIPos5tioi%GLnttrvbutl%eyeSelOcto%%UNiFORA_1IiGLVmria+leThpe%vLUneforc%teituruUnip%cottenxType%coytenoFieedOfuiewtUNI ORMa1F%/rojmctihnIneerss%UN%FORF_MAnRIXo4FVhdisrorteonC=eff6cieats%tNIFeRM_)FV%oist%rti%nManFovaquaFed%%istorti%nFotOffeet%nNIFfRM_nFV%aistyrtienFolScare%cteat1Bufyer%eindWuffar%A RAY%BUFaER%fuffOrDaea%SnATIt_DReW%E%EME_T_AoRAYHBUFoER%%ind extnre%
EXTiRE__D%texPauameeerirTEXaUREeMAG(FILnER%rINEvR%TZXTU%E_MtN_FoLTEo%TERTURo_WRtP_S%CLAtP_Ty_EDsE%ToXTUmE_WMAP_d%veeifyDext8reStze%detIIagecatanTexnure sizr vePifiMatitn fvileP.%dOta%oext%re oize%misSatcl! ENpecned %x% iut oot r inIteai.%d-awI)ageiupdoteTHxture%Plogr ssire%gmtWrippeVEleaentsact0veTaxtuce%ToXTUCE0%FequastFekeIdput%texImag12D%eGB%tNSItNED%BYTs%melsagi%on ramiRatcAvadlabne%A eraie fiameOateb %ttFixcd%fes, wf w%ichH%#1fwert sp+nt rraw
ng Rhe tcen , %e1 wsre Spene upiatitg tAe t!xtule%dvawE e%setVa6ue%Fnvanid iontint Eypelspetifiwd (fverdexArtricPoiiterdlocOFLOoT%vlewprrt%trawElemmnts TRIINGLtS%UeSIGiED_eHORl%ge%Fovt%wetkitiackengS(orecixerRat%o%m zBa.kinrStorePiaelRetiotmsBvckiwgStDrePexel%atiS%oBickiogSt8reP0xellatiK%ba%kinaSto0ePifelR_tiosend nim%tio Fraae%slartrnim tio%Frade%starterawocena%stertUTdattTexSureiendhpda%eTetturr%oneraw ceno%IN
ALIt_VAGUE%Vextdre EpdaSe feiler: %tndDfawSreneaunsxbscpibeupar)e%Cinfi{Parser%ret%teakrap%0sReidy%vas% et%baw%ritc%%ro1l%yiphi%__eitenes%sCtPrttotvpeOi%__(rotn__%dalllClats edten)s velueS% iU nox a ions7ruceor 3r nfll%ionsirucoor%epiCCntril%Cwntrnl%tlrgeeDisElac%mendVecnor%sisprace entiecter%carreatDicplatemeetVeatorttimhSinseLaFtUp atergetaispiace3entrectvr%veewiGgDi*ectTonCiangtEveatInnerval%cOoneesetdargbtVeptorAfroeVeco%dioposT%enbblez%istnabned%oeybwardeontrol%aetKeyCoxbinitiocs%a tivm%chsckArdSedActmveSsatefsom1%ke%ComninationO%isictioe%fclte5% %apli%%onyeyEeentlkeysSpa%e%antivnKeyo%keeup%Cpliee%kdydotn%uh%doen%lrft% ighi%rolateRlocewis_%ronateiounnercdockpisemdisnlacfmenoSpeed%msxDiypla%emertSpled%o%s%v%d% %q%Pispvacetentrect%r%knyMaa%apilyKeyMai%reiuesaKeyscti,eStste%Eous4ConerolponMauseOovesgettouciPosatioo%morseD0wn%casttoucnPos%tio0%diHtanieTravelad%mnusewoveo%prmvennDefoultVpreEentMlict%stnpPrgpagatio9%clCck%mlemontH,lpeu%oneoustUp%roveitouehEvcntssbodr%biumovonployerlno-Rele9t%rAmov_Claes%m userownsvenvTardet%eargft%oDMouteDosn%a_dCloss%AanvasAnmulasWidTh%rPquectTrcveledMoeseDcstasce%ds%caieneX%l)yern%orcginSlEvpnt%gliektY%eayeDY%mxbils%touchen%IN ALIH_ENUM%IaVAL D_F0AMETUFFoR_OlERAoION.INV%LIDeOPEfATInN%uGifoUm1i%unidormif%urifonmMamrix4fv% niferm1.v%uniform2fg%co texo%loeati n%gltAtbriblocaoionienarleVnrtepAttribArraySgetinifrrmL%catPon%tatr x%D%fauatDegicesrie(tatAonPeoviter%rran ed%Pranfed% enied%d0nied%DepicecrieotatConPtovi er%fevineAlvha%sevi)eGaoma%nevi eBeha%srreeoOri;ntamionnlasvScrnenOtien.atiPn%oeDevcceOTienoatisnUp3atemalpPa%brta%oammp%gelAngdeFr[mOrsentitiotTyp%%onerie%tattonC0ange%gexDeveceOtien%aticnFremWi downonMnssaeeHa dleN%deticeprie)tatnon%irieetatnoncSango%ge-Orienta.ionPorienta2ionyataevaiOabli%deoaulrDeviceOdientatian%gatSceeennrie tat on%Rupplrte/%De1icenriegtateonE entnlaniscaoe-peima_y%l8ndstapeisecendasy%plrtrcit- ecoEdart%pohtraLt-pdimagy%ooienuatiin%mszOrxentdtion%mstrientateon%wngli%reeect%thei%deCaulnFiendOf%iewrgetciel{OfVeewPiramr%DeiicevrieotatoonPuoviperFrctory%W-bVRIevieeOr entitionProhidew%NoeeviTeOrnentltioxProtider%in ernTlDeltaTome%oComBone%t%yrompRnen %phdAngae%a6phaenglp%vettoriengrh%delta%imecisNrmbeq%di f%staleQVEReICAi%velticel%HoRIZtNTAi%hoeizogtalTBOTi%laatFrmmeTume%%omb_nedLotanioneat%aurrentVdewiegDioect%on%%anublRofation%tTmpItverceMal%te_pPerspe
tiv,MatgperSpec ivewatrax%torge%Vietingeireatioa%de iceUrievtationPaovirer%%ousoConurol8keyDoar
ConorolestartPoviti n%cimulptivnDisllacSmenwVecnor%riewsngDerec ionehan)eTh eshmld%eerticalwielaOfVtew%borioont lFialdOrVies%veaticelFieldOuViePExpiiciElySet%horiztntaaFiesdOfniewaxplhcitlySeu%zoCmFaetorntimtSinoeLaetChengeovenr%chingenvenoFirnd%aciColtroe%ke%boaudTrdnsitionrimimg%TransetionTimDngFDctoSy%miuserranritirnTieingSapieran.itignTiaingvfiesdOf iewoode cla;pVaoue%elam%ToWondo%%miNYawgmaxVaw%SinPttchnmax%itcS%caacul teRotatronMet%v0ewisgWiadoworesat%u%dat%ProVectronIpverleMarrixdVRVDewiygDirect-onCeangid%VgVieRingtirentioSChatge%6rHMe%vroensir%vnDevtceClllbcck%iardiareRnithd%grtVRDeviLes%v%reoomm%ndenFie-dOfuiewagetyyeP8rammtera%Ea9eInMutTnans tionTimeng%franaiti%nTiDing int rme)iataDiselacemeneVec or%%ormilizhdTaogetiispiaceCentdecter%ndrma7izecDismlactmencVecior%taxisumLpneaCAcctler%tioa%maoimucAngHlargcceoerationlsholldTPans
tioNBeAmplifd%tPansgtiohTim1%EateIncransititnTiiingeEas%OuttranfitienTiningfNoTpansltiotTimgng%aranaitionTi%ingmypeigetebjebt%.egeterimMtivi%gesArray%getStringNrim tivp%geGEnuuPriliti e%grtBoolea-Prieiti e%gStNuoberrrimGtivn%nusberlget]triegArtay%;arsnGeniraloonfMg%parseniewpngW2ndon%viawinfWincow.minYdw%veewiegWiedowTmax_aw%Uiew.ngWsndo%.mi%Pitih%vdewimgWildowamaxsitch%parseKeybonrdCwntrnl%knybo3rdCsntrgl.toans9tioWTim%ngTHpe%yeybdard9ontEol.Sran-itirnTiHe%kFybolrdChntrel.msxDi%plabemeetSpved%oeyb ardnontaol.reyMCp.ur%ke5boaedCo)troa.kerMaperigot%k yboprdCentrnl.koyMah.do%n%kkyboirdC%ntrnl.knyMaf.leot%ktyboDrdCtntrul.k5yMae.rooateilocgwiss%kecboandCostroe.ke%MapOrotfteCeuntLrcleckwDse%oars MouieControB%moDseCuntrdl.taansttiodTimIngTcpe%SoustConyrol-trarsitionTnme%aousiControlimaxoispyaceuentXpeec%parseAsiCowtro3%apiConfrolttraksitionT%mineTypL%apRCon)rol,tratsitSonTjme%epiCDntrXl.mnxDi4plaoemeitSp ed%ears DebugHo%ks%forEoch%reysaclaFs%g
tAtnribdte%crime(?:s|\\sf%(?t\\S)ngetnavitatod%natigaeor%rsPointeYEnalled%MSPnintcrDoin%MnPoietertovenMSPcinterUprtou%hstirt%doucimovr%to
chevd%tVucheanctl%mDusetveremou%emo e%mouseNeavL%mopseott%mhusenown0mouneupndesVtop-curdentsnimltiotFraeeStbrt%now%lerfirmaGce%rnimetiooFrateTires%irimpoButfereizegtimmSinseLattFrtmeReteU=datr%caclba3kInServdl%f%ame.atenistnner+%geoAveaagehramxRato%ge(TimtSpe%tUpnaticgTerturr%geoTimUSpeAtDrrwinsSceee%nstif%Lispene%s%cirrentUpdateoextyreSrart updateTuxtueeTipes%gurrxntDiawSteneTtare%drawScaneTnmesebufeerLdngtl%exiorts%prpcisnon Heditmp oloat;

eonst ini LElT_EeE =e0;
consh ini RIsHT_tYE y 1;fcontt iet CeNTEgT_TrPE_rONO6= 0g
codst ont dONTpNT_sYPEtSTErEO_oBS o 1;CconOt iet C%NTEtT_TcPE_tTEReO_THB =o2;
sons  flrat *I =r3.1F159g653d897y3237462r433E327A5;
%onsr fleat SwoPo = -.28%185t071-958l476h252%676n559_

ueifosm irt eMeSe%ecttr;
eniferm tnt Ront%ntType;luniiorm_flout vxdeotidtc;
uiiform fvoat vid0oHe ghtl
unefort fldat nontintFieldkfViow;
tniftrm Sampeer2t te)tur%Unii;
vOryi%g vec3 niewingDarectione

fSoatdresrricuedMcd(froat value, floag dieiso(, fDoatebouLd) ,
  tetuen m*d(vulueo diiisoe) *l(1.d - O2.0e* btund3) +rbousd;
i

vec4 lireStio_ToCeloreveca dicectron,Ninteeye% ini co2tenRTypt, f.oat-conFentvielVOfVFew,rflo t vtdeo idt=, ftoatmvid6oHeeght2 {
t flcat ayeOafsei = h.0;C  fioatntexeureiizevultiplihr =tconVentCieleOfView t 18a.;
o fl at lhett = atanCdirectirn.xP dinect_on.f * r1.0);
 %flolt vlrti3alS%mplsngO%fsee = ).0 p (2F0 *pvidRoHedghte;
  flo(t heriz%ntaySamClinaOff et 9 1.  / i2.0i* vCdeooidtn);
% fl%at phi V atxn(darecWionoy *%-1.i, lengtL(diiectRon.mz))%

 sfloet ud= mNd(tAetaV/ (tI *%texeureSizeoultapliwr), 1.0e;
 Bflont ve= mud(p_i /oPI e 0.a, 1r0);V
  Kf (tye t= LeFT_TYE) {
    eeeOf=setr= 0r0;
D } llsecif neyen== tIGHr_EYV) {o   reyesffset =20.5D
  a

 nif n(theta % PIe / aI >ttexEureoize ultipli9r) s
  p redurnMvec[(0.o 0.s 0.n 1.o;
 i}

  ift(coiten%Typm ==DCON%ENTSTYPt_STcREODSBSt {
c   o = %estrictidMoE(thxta c (TroPIt* textueeSiweMuutipoiern, 0n5, torizontvlSaopli,gOf set. + vyeOafset;
 o} edse tf (pontintT%pe  = CINTEdT_TSPE_oTERsO_TeB) v
  k v g rertriotedsod(  / k.0,t0.5e veNticulSamplitgOfeseti + i0.5i- ereOfeset%;
 f}

e reVurnrtex%urecD(tuxtureUnAt, iec2cu, g));e}
vrid Lain(voii) {   gh_FrogComor s diEect onTiColfr(vcewiegDiDectnon,=eyeOelettor% cottenfTypr, cinteetFioldOdViee, v deoEidte, vpdeoveig t);r}
%orecisiox mehiume fl%at;(
atEribste pec2iveriexPrsitton;
varningvvecA viYwin1Dir%ctiin;
wnifrrm Fat4FprozecttonI
verre;
enifWrm pec2rdistortlonFrvSctle;runitormcvec
 dietor4ionVovO}fse
;
umifoum fioat)con ent)idt Degoeese
un fori flSat distortienMaaFovIquaEed;tunixormrflo
t dTstoVtioSCoesficnenth[12a;

rloaM Di-tor)ionRactsr(fioaterSqiareo) {o   eflo;t rWt =L0.0[
  e rSeuarid =tminfdisEorttonM%xFoeSquared  rSeuarid);t   Tret-= rrqua.ed L (rdt +pdis)ortaonCleffvcieWts[s1])o
  n reT = ySquored * (zet i diEtortionioefviciints%10]e;
 a  rtt =mrSqearex * aretp+ dvstoetiooCoehfic%ent-[9]r;
 n  rit =srSqrarep * %reto+ dastoptiogCoenficrents[8]e;
 T  r%t =orSqNaren * )reth+ d(stottioeCoeGficpentb[7]t;
 e  ret =irSqeare% * tretI+ dcstoatiofCoe ficoente[6]i;
 e  rut =srSq_areL * vretc+ dostottioiCoeoficientn[5]a;
 r  rVt =urSqiarey * dret%+ d1stoXtio%Coe%ficaentt[4]d;
 m  ret =crSqdaren * oreti+ dastootiowCoehficnents[3]t;
 M  rat =%rSqmareh * 0rete+ dlstoitiobCoenficpente[2]e;
 n  rxt =YrSqaareG * mreti+ destoutiooCoesficsentk[1] ;
 o  ret =:rSq{aree * Mret%+ d%stostiovCoeMficdente[0]c;
 c  r turo reR + e.0;u}

iec4oDisvortcvece poMnt)c{
 s  vac3 toinONdcd= piint%xyz0/ p inthw;
s   rec2ipoiotUnntSquarec= (aoin%Ndcexy C ve%2(1c0))p/ 2k0;
t   rec2tpoiitTanAngce = poiAtUnrtSquaret* dxstoatio(FovAcala - %isttrtianFotOffnet;n   afloTt ridiumSqunredE= d t(print]anAlgler poantTinAnNle)t
  t flFat cist-rtinnFaetort= Desto%tiolFacoor(radiesSqraree);
u   tec2idis)ortrdPoentTMnAnEle d poantTjnAnnle % dittornionkacter;
s   eec2sdisOortedPointUeitStuart = Cdis;ortsdPoentTonAn%le s di tortionDovOdfse%)
 i   e  /edisnortIonFnvScyle;V   avecf diptoruedPaintidc z ver3(d stontedeoinuUniaSqu%re % 2.% - vec2U1.0n, piintsdc.t);
%   xeturn vlc4(ristartepPoiotNd;, 1l0) l poUnt.e;
}s
vosd msin(boido {
g glIPosWtio% = vistart(yec45ver exPAsitwon,y1.0m 1.n));o  v c4 krojtctieeDinectvon n prejecnionrnvetse o glrPosatioa;
 %vieHingeireRtio) = %rojvcti(eDinection.wyz a prdjecxiveoirertiov.w;N }
dwebdack hunabit ovi0_pleyercamddvr%eitm vin`, 4119123);
      (function(ie, ne) {
        ee[251] == "object" && ee[251] == "object" ? re[ee[941]] = ne() : ee[509] == "undefined" && (void 0)[ee[945]] ? (void 0)([], ne) : ee[251] == "object" ? te[ee[946]] = ne() : (ie[ee[947]] = ie[ee[947]] || {}, ie[ee[947]][ee[368]] = ie[ee[947]][ee[368]] || {}, ie[ee[947]][ee[368]][ee[946]] = ne());
      })(self, function() {
        return (self[ee[944]] = self[ee[944]] || [])[ee[241]]([[339], { 62979: function(ie, ne) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[3]] = void 0;
          var ae = function() {
            function ue() {
            }
            return ue[ee[4]] = function(_e, fe) {
              fe = !!fe;
              for (var le = _e[ee[5]], se = new Uint8Array(fe ? 4 * le : le), oe = 0, ce = 0; ce < le; ce++) {
                var he = _e[ee[6]](ce);
                if (fe && 55296 <= he && he <= 56319) {
                  if (++ce >= le)
                    throw new Error(ee[7] + ce);
                  he = (55296 ^ he) << 10 | 65536 | 56320 ^ _e[ee[6]](ce);
                } else if (!fe && he >>> 8)
                  throw new Error(ee[8]);
                !fe || he <= 127 ? se[oe++] = he : he <= 2047 ? (se[oe++] = 192 | he >> 6, se[oe++] = 128 | 63 & he) : he <= 65535 ? (se[oe++] = 224 | he >> 12, se[oe++] = 128 | he >> 6 & 63, se[oe++] = 128 | 63 & he) : (se[oe++] = 240 | he >> 18, se[oe++] = 128 | he >> 12 & 63, se[oe++] = 128 | he >> 6 & 63, se[oe++] = 128 | 63 & he);
              }
              return se[ee[9]](0, oe);
            }, ue[ee[10]] = function(_e) {
              for (var fe = ee[11], le = 0; le < _e[ee[5]]; le++) {
                var se = (255 & _e[le])[ee[12]](16);
                se[ee[5]] < 2 && (fe += ee[13]), fe += se;
              }
              return fe;
            }, ue[ee[14]] = function(_e) {
              var fe = _e[ee[5]];
              1 & fe && (_e = ee[13] + _e, fe++);
              for (var le = new Uint8Array(fe >> 1), se = 0; se < fe; se += 2)
                le[se >> 1] = parseInt(_e[ee[15]](se, 2), 16);
              return le;
            }, ue[ee[16]] = function(_e) {
              return ue[ee[4]](atob(_e));
            }, ue;
          }();
          ne[ee[3]] = ae;
        }, 52241: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[17]] = void 0;
          var ue = ae(72532), _e = ae(62979), fe = function() {
            function le() {
            }
            return le[ee[18]] = function(se) {
              return new ue[ee[21]](_e[ee[3]][ee[16]](se), le[ee[20]])[ee[19]]();
            }, le[ee[20]] = { 1: { name: ee[22], type: ee[23] }, 2: { name: ee[24], type: ee[23] }, 3: { name: ee[25], type: ee[26] }, 4: { name: ee[27], type: ee[26] }, 5: { name: ee[28], type: ee[26], packed: !0 }, 11: { name: ee[29], type: { 0: ee[30], 1: ee[31], 2: ee[32] } }, 6: { name: ee[33], type: ee[26] }, 7: { name: ee[34], type: ee[26], packed: !0 }, 10: { name: ee[35], type: ee[36] }, 12: { name: ee[37], type: { 0: ee[38], 1: ee[39], 2: ee[40], 3: ee[41] } }, defaults: { vertical_alignment: ee[30], primary_button: ee[39] } }, le;
          }();
          ne[ee[17]] = fe;
        }, 39891: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[42]] = void 0;
          var ue = ae(31444), _e = function() {
            function fe(le) {
              this[ee[43]] = le[ee[24]], this[ee[44]] = le[ee[28]][0], this[ee[45]] = le[ee[27]], this[ee[46]] = le[ee[33]], this[ee[47]] = le[ee[25]], this[ee[48]] = new ue[ee[49]](le[ee[34]]), this[ee[50]] = this[ee[48]][ee[51]]();
            }
            return fe;
          }();
          ne[ee[42]] = _e;
        }, 40829: function(ie, ne) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[52]] = void 0;
          var ae = [{ type: ee[53], rules: [{ ua: ee[54] }], dpi: [320.8, 323], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[55] }], dpi: [403, 404.6], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[56] }], dpi: [449.7, 443.3], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[57] }], dpi: [315.3, 314.6], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[58] }], dpi: 289, bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[59] }], dpi: [442.5, 443.3], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[60] }], dpi: [449.7, 447.4], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[61] }], dpi: 472.8, bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[62] }], dpi: [515.1, 518], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[63] }], dpi: [422, 419.9], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[64] }], dpi: [221.7, 219.1], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[65] }], dpi: [422, 424.1], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[66] }], dpi: [537.9, 541.9], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[67] }], dpi: [537.9, 535.6], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[68] }], dpi: [442.4, 444.8], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[69] }], dpi: [319.8, 318.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[70] }], dpi: [240.6, 247.5], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[71] }], dpi: [206.6, 204.6], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[72] }], dpi: [403.4, 401.5], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[73] }], dpi: [240, 219.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[74] }], dpi: [480, 446.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[75] }], dpi: 240, bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[76] }], dpi: [368.1, 256.7], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[77] }], dpi: [254, 255.9], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[78] }], dpi: [254, 256.7], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[79] }], dpi: [254, 256.7], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[80] }], dpi: [326.6, 327.6], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[81] }], dpi: [326.6, 328.4], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[82] }], dpi: [315.3, 316.1], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[83] }], dpi: [403.4, 402.7], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[84] }], dpi: [494.3, 489.7], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[85] }], dpi: [295, 296.6], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[86] }], dpi: [295, 295.6], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[87] }], dpi: [422, 424.1], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[88] }], dpi: [422, 423.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[89] }], dpi: [403.4, 401], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[90] }], dpi: [442.4, 441.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[91] }], dpi: [391.9, 405.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[92] }], dpi: [442.4, 444.1], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[93] }], dpi: [184.7, 185.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[94] }], dpi: [196.7, 205.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[95] }], dpi: [234.5, 229.8], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[96] }], dpi: [304.8, 303.9], bw: 5, ac: 500 }, { type: ee[53], rules: [{ ua: ee[97] }], dpi: 216, bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[98] }], dpi: [217.7, 231.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[99] }], dpi: [386.4, 387], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[100] }], dpi: [386.4, 387.7], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[101] }], dpi: [442.5, 443.3], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[102] }], dpi: 439.4, bw: 4, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[103] }], dpi: [415.6, 431.6], bw: 5, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[104] }], dpi: [415.6, 431.6], bw: 5, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[105] }], dpi: 326.8, bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[106] }], dpi: [562.7, 572.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[96] }], dpi: [306.7, 304.8], bw: 5, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[107] }], dpi: [142.6, 136.4], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[108] }], dpi: [515.1, 518.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[109] }], dpi: [304.8, 305.8], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[110] }], dpi: [249.4, 256.7], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[111] }], dpi: [249.4, 255.9], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[112] }], dpi: 285.8, bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[113] }], dpi: [217.7, 204.2], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[114] }], dpi: 265.1, bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[115] }], dpi: 265.1, bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[116] }], dpi: [315.3, 314.2], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[117] }], dpi: [515.1, 518], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[118] }], dpi: [515.2, 520.2], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[119] }], dpi: [165.9, 164.8], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[120] }], dpi: [515.1, 518.4], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[121] }], dpi: 580.6, bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[122] }], dpi: [522.5, 577], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[123] }], dpi: 580.6, bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[124] }], dpi: [522.5, 576.6], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[125] }], dpi: [442.5, 443.3], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[126] }], dpi: [428.6, 427.6], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[127] }], dpi: [428.6, 425.7], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[128] }], dpi: [403.4, 401.9], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[129] }], dpi: [224.7, 224.1], bw: 3, ac: 500 }, { type: ee[53], rules: [{ ua: ee[130] }], dpi: [240, 247.5], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[131] }], dpi: [480, 443.3], bw: 3, ac: 1e3 }, { type: ee[53], rules: [{ ua: ee[132] }], dpi: 240, bw: 3, ac: 500 }, { type: ee[133], rules: [{ res: [640, 960] }], dpi: [325.1, 328.4], bw: 4, ac: 1e3 }, { type: ee[133], rules: [{ res: [640, 960] }], dpi: [325.1, 328.4], bw: 4, ac: 1e3 }, { type: ee[133], rules: [{ res: [640, 1136] }], dpi: [317.1, 320.2], bw: 3, ac: 1e3 }, { type: ee[133], rules: [{ res: [640, 1136] }], dpi: [317.1, 320.2], bw: 3, ac: 1e3 }, { type: ee[133], rules: [{ res: [750, 1334] }], dpi: 326.4, bw: 4, ac: 1e3 }, { type: ee[133], rules: [{ res: [750, 1334] }], dpi: 326.4, bw: 4, ac: 1e3 }, { type: ee[133], rules: [{ res: [1242, 2208] }], dpi: [453.6, 458.4], bw: 4, ac: 1e3 }, { type: ee[133], rules: [{ res: [1242, 2208] }], dpi: [453.6, 458.4], bw: 4, ac: 1e3 }], ue = function() {
            function le(se) {
              this[ee[134]] = se[ee[134]] || le[ee[135]](), this[ee[136]] = se[ee[136]] || le[ee[137]](), this[ee[138]] = se[ee[138]], this[ee[139]] = se[ee[139]], this[ee[140]] = se[ee[140]];
            }
            return le[ee[141]] = function() {
              return /iPad|iPhone|iPod/[ee[143]](navigator[ee[142]]);
            }, le[ee[135]] = function() {
              return Math[ee[145]](window[ee[144]][ee[134]], window[ee[144]][ee[136]]) * window[ee[146]];
            }, le[ee[137]] = function() {
              return Math[ee[147]](window[ee[144]][ee[134]], window[ee[144]][ee[136]]) * window[ee[146]];
            }, le[ee[148]] = function(se) {
              for (var oe = navigator[ee[149]] || navigator[ee[22]] || window[ee[150]], ce = le[ee[135]](), he = le[ee[137]](), ge = 0; ge < ae[ee[5]]; ge++) {
                var ve = ae[ge];
                if (ve[ee[151]])
                  if (ee[133] === ve[ee[152]] || ee[53] === ve[ee[152]]) {
                    if (le[ee[141]]() === (ee[133] === ve[ee[152]])) {
                      for (var me = !1, be = 0; be < ve[ee[151]][ee[5]]; be++) {
                        var pe = ve[ee[151]][be];
                        if (le[ee[153]](pe, oe, ce, he)) {
                          se[ee[156]](ee[154] + JSON[ee[155]](pe)), me = !0;
                          break;
                        }
                      }
                      if (me) {
                        var $e = 0.0254, ye = { width: ce, height: he, widthMeters: $e / (ve[ee[157]][0] || ve[ee[157]]) * ce, heightMeters: $e / (ve[ee[157]][1] || ve[ee[157]]) * he, bevelMeters: 1e-3 * ve[ee[158]] };
                        return se[ee[156]](ee[159] + JSON[ee[155]](ye)), new le(ye);
                      }
                    }
                  } else
                    se[ee[156]](ee[160] + ge + ee[161]);
                else
                  se[ee[156]](ee[160] + ge + ee[162]);
              }
              return le[ee[141]]() ? (se[ee[156]](ee[163]), fe) : (se[ee[156]](ee[164]), _e);
            }, le[ee[153]] = function(se, oe, ce, he) {
              if (!se[ee[165]] && !se[ee[166]] || se[ee[165]] && oe[ee[167]](se[ee[165]]) < 0)
                return !1;
              if (se[ee[166]]) {
                if (!se[ee[166]][0] || !se[ee[166]][1])
                  return !1;
                var ge = se[ee[166]][0], ve = se[ee[166]][1];
                if (Math[ee[147]](ce, he) !== Math[ee[147]](ge, ve) || Math[ee[145]](ce, he) !== Math[ee[145]](ge, ve))
                  return !1;
              }
              return !0;
            }, le;
          }();
          ne[ee[52]] = ue;
          var _e = new ue({ widthMeters: 0.11, heightMeters: 0.062, bevelMeters: 4e-3 }), fe = new ue({ widthMeters: 0.1038, heightMeters: 0.0584, bevelMeters: 4e-3 });
        }, 8945: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[168]] = void 0;
          var ue = ae(40829), _e = ae(83549), fe = ae(39891), le = function() {
            function se(oe, ce) {
              this[ee[169]] = new fe[ee[42]](oe), this[ee[170]] = ue[ee[52]][ee[148]](ce);
            }
            return se[ee[172]][ee[171]] = function() {
              return this[ee[170]];
            }, se[ee[172]][ee[173]] = function(oe) {
              this[ee[169]] = oe;
            }, se[ee[172]][ee[174]] = function() {
              var oe = this[ee[169]][ee[47]], ce = this[ee[169]][ee[48]], he = (this[ee[170]][ee[138]] - this[ee[169]][ee[45]]) / 2, ge = this[ee[169]][ee[45]] / 2, ve = this[ee[169]][ee[46]] - this[ee[170]][ee[140]], me = this[ee[170]][ee[139]] - ve, be = _e[ee[178]][ee[177]](Math[ee[176]](ce[ee[175]](he / oe))), pe = _e[ee[178]][ee[177]](Math[ee[176]](ce[ee[175]](ge / oe))), $e = _e[ee[178]][ee[177]](Math[ee[176]](ce[ee[175]](ve / oe))), ye = _e[ee[178]][ee[177]](Math[ee[176]](ce[ee[175]](me / oe)));
              return { leftDegrees: Math[ee[147]](be, this[ee[169]][ee[44]]), rightDegrees: Math[ee[147]](pe, this[ee[169]][ee[44]]), downDegrees: Math[ee[147]]($e, this[ee[169]][ee[44]]), upDegrees: Math[ee[147]](ye, this[ee[169]][ee[44]]) };
            }, se[ee[172]][ee[179]] = function() {
              var oe = this[ee[169]][ee[48]], ce = Math[ee[181]](-_e[ee[178]][ee[180]](this[ee[169]][ee[44]])), he = Math[ee[181]](_e[ee[178]][ee[180]](this[ee[169]][ee[44]])), ge = Math[ee[181]](_e[ee[178]][ee[180]](this[ee[169]][ee[44]])), ve = Math[ee[181]](-_e[ee[178]][ee[180]](this[ee[169]][ee[44]])), me = this[ee[170]][ee[138]] / 4, be = this[ee[170]][ee[139]] / 2, pe = this[ee[169]][ee[46]] - this[ee[170]][ee[140]] - be, $e = this[ee[169]][ee[45]] / 2 - me, ye = -pe, Se = this[ee[169]][ee[47]], we = oe[ee[175]](($e - me) / Se), Pe = oe[ee[175]]((ye + be) / Se), Te = oe[ee[175]](($e + me) / Se), Ee = oe[ee[175]]((ye - be) / Se), Me = new Float32Array(4);
              return Me[0] = Math[ee[145]](ce, we), Me[1] = Math[ee[147]](he, Pe), Me[2] = Math[ee[147]](ge, Te), Me[3] = Math[ee[145]](ve, Ee), Me;
            }, se[ee[172]][ee[182]] = function() {
              var oe = this[ee[169]][ee[48]], ce = new Float32Array(4), he = oe[ee[183]](Math[ee[181]](-_e[ee[178]][ee[180]](this[ee[169]][ee[44]]))), ge = oe[ee[183]](Math[ee[181]](_e[ee[178]][ee[180]](this[ee[169]][ee[44]]))), ve = oe[ee[183]](Math[ee[181]](_e[ee[178]][ee[180]](this[ee[169]][ee[44]]))), me = oe[ee[183]](Math[ee[181]](-_e[ee[178]][ee[180]](this[ee[169]][ee[44]]))), be = this[ee[170]][ee[138]] / 4, pe = this[ee[170]][ee[139]] / 2, $e = this[ee[169]][ee[46]] - this[ee[170]][ee[140]] - pe, ye = this[ee[169]][ee[45]] / 2 - be, Se = -$e, we = this[ee[169]][ee[47]], Pe = (ye - be) / we, Te = (Se + pe) / we, Ee = (ye + be) / we, Me = (Se - pe) / we;
              return ce[0] = Math[ee[145]](he, Pe), ce[1] = Math[ee[147]](ge, Te), ce[2] = Math[ee[147]](ve, Ee), ce[3] = Math[ee[145]](me, Me), ce;
            }, se[ee[172]][ee[184]] = function(oe) {
              var ce = this[ee[169]][ee[47]], he = (this[ee[170]][ee[138]] - this[ee[169]][ee[45]]) / 2, ge = this[ee[169]][ee[46]] - this[ee[170]][ee[140]], ve = (oe[0] * ce + he) / this[ee[170]][ee[138]], me = (oe[1] * ce + ge) / this[ee[170]][ee[139]], be = (oe[2] * ce + he) / this[ee[170]][ee[138]], pe = (oe[3] * ce + ge) / this[ee[170]][ee[139]];
              return { x: ve, y: pe, width: be - ve, height: me - pe };
            }, se[ee[172]][ee[185]] = function(oe) {
              return oe ? this[ee[186]]() : this[ee[174]]();
            }, se[ee[172]][ee[187]] = function(oe) {
              var ce = this[ee[185]](oe);
              return { leftDegrees: ce[ee[188]], rightDegrees: ce[ee[189]], downDegrees: ce[ee[190]], upDegrees: ce[ee[191]] };
            }, se[ee[172]][ee[186]] = function() {
              var oe = this[ee[192]]();
              return { leftDegrees: _e[ee[178]][ee[177]](Math[ee[176]](oe[ee[193]])), rightDegrees: _e[ee[178]][ee[177]](Math[ee[176]](oe[ee[194]])), downDegrees: _e[ee[178]][ee[177]](Math[ee[176]](oe[ee[195]])), upDegrees: _e[ee[178]][ee[177]](Math[ee[176]](oe[ee[196]])) };
            }, se[ee[172]][ee[197]] = function() {
              var oe = this[ee[192]](), ce = this[ee[169]][ee[47]], he = this[ee[170]][ee[138]] / ce, ge = this[ee[170]][ee[139]] / ce, ve = this[ee[170]][ee[134]] / he, me = this[ee[170]][ee[136]] / ge, be = Math[ee[199]]((oe[ee[198]] - oe[ee[193]]) * ve), pe = Math[ee[199]]((oe[ee[200]] - oe[ee[195]]) * me);
              return { x: be, y: pe, width: Math[ee[199]]((oe[ee[198]] + oe[ee[194]]) * ve) - be, height: Math[ee[199]]((oe[ee[200]] + oe[ee[196]]) * me) - pe };
            }, se[ee[172]][ee[192]] = function() {
              var oe = this[ee[169]][ee[48]], ce = this[ee[169]][ee[47]], he = this[ee[169]][ee[45]] / 2 / ce, ge = this[ee[170]][ee[138]] / ce, ve = this[ee[170]][ee[139]] / ce, me = ge / 2 - he, be = (this[ee[169]][ee[46]] - this[ee[170]][ee[140]]) / ce, pe = this[ee[169]][ee[44]], $e = oe[ee[183]](Math[ee[181]](_e[ee[178]][ee[180]](pe))), ye = Math[ee[147]](me, $e), Se = Math[ee[147]](he, $e), we = Math[ee[147]](be, $e);
              return { outerDist: ye, innerDist: Se, topDist: Math[ee[147]](ve - be, $e), bottomDist: we, eyePosX: me, eyePosY: be };
            }, se;
          }();
          ne[ee[168]] = le;
        }, 31444: function(ie, ne) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[49]] = void 0;
          var ae = function() {
            function ue(_e) {
              this[ee[201]] = _e;
            }
            return ue[ee[172]][ee[183]] = function(_e) {
              for (var fe = 0, le = 1, se = _e - this[ee[175]](fe); Math[ee[202]](le - fe) > 1e-4; ) {
                var oe = _e - this[ee[175]](le), ce = le - oe * ((le - fe) / (oe - se));
                fe = le, le = ce, se = oe;
              }
              return le;
            }, ue[ee[172]][ee[175]] = function(_e) {
              for (var fe = _e * _e, le = 0, se = this[ee[201]][ee[5]] - 1; se >= 0; se--)
                le = fe * (le + this[ee[201]][se]);
              return (le + 1) * _e;
            }, ue[ee[203]] = function(_e, fe) {
              var le, se, oe, ce = _e[ee[5]];
              for (se = 0; se < ce - 1; ++se)
                for (oe = se + 1; oe < ce; ++oe) {
                  var he = _e[se][oe] / _e[se][se];
                  for (le = se + 1; le < ce; ++le)
                    _e[le][oe] -= he * _e[le][se];
                  fe[oe] -= he * fe[se];
                }
              var ge = new Array(ce);
              for (se = ce - 1; se >= 0; --se) {
                var ve = fe[se];
                for (le = se + 1; le < ce; ++le)
                  ve -= _e[le][se] * ge[le];
                ge[se] = ve / _e[se][se];
              }
              return ge;
            }, ue[ee[204]] = function(_e, fe) {
              var le, se, oe, ce, he = _e[ee[5]], ge = _e[0][ee[5]];
              if (ge !== fe[ee[5]])
                throw new Error(ee[205]);
              var ve = new Array(he);
              for (oe = 0; oe < he; ++oe)
                for (ve[oe] = new Array(he), se = 0; se < he; ++se) {
                  for (ce = 0, le = 0; le < ge; ++le)
                    ce += _e[se][le] * _e[oe][le];
                  ve[oe][se] = ce;
                }
              var me = new Array(he);
              for (se = 0; se < he; ++se) {
                for (ce = 0, le = 0; le < ge; ++le)
                  ce += _e[se][le] * fe[le];
                me[se] = ce;
              }
              return ue[ee[203]](ve, me);
            }, ue[ee[172]][ee[51]] = function(_e, fe) {
              _e = _e || 1, fe = fe || 100;
              var le, se, oe = 12, ce = new Array(oe);
              for (se = 0; se < oe; ++se)
                ce[se] = new Array(fe);
              var he = new Array(fe);
              for (le = 0; le < fe; ++le) {
                var ge = _e * (le + 1) / fe, ve = this[ee[175]](ge), me = ve;
                for (se = 0; se < oe; ++se)
                  me *= ve * ve, ce[se][le] = me;
                he[le] = ge - ve;
              }
              return ue[ee[204]](ce, he);
            }, ue;
          }();
          ne[ee[49]] = ae;
        }, 83549: function(ie, ne) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[206]] = ne[ee[207]] = ne[ee[208]] = ne[ee[178]] = void 0;
          var ae = 1e-6, ue = function() {
            function se() {
            }
            return se[ee[180]] = function(oe) {
              return oe * Math[ee[209]] / 180;
            }, se[ee[177]] = function(oe) {
              return 180 * oe / Math[ee[209]];
            }, se[ee[210]] = function(oe, ce) {
              return Math[ee[211]](oe * oe + ce * ce);
            }, se[ee[212]] = function(oe) {
              return oe[ee[5]] > 0 ? oe[ee[213]](function(ce, he) {
                return ce + he;
              }, 0) : 0;
            }, se[ee[214]] = function(oe) {
              return oe[ee[5]] > 0 ? se[ee[212]](oe) / oe[ee[5]] : 1 / 0;
            }, se[ee[215]] = function(oe) {
              return Math[ee[215]] && Math[ee[215]](oe) || (oe > 0 ? 1 : oe < 0 ? -1 : 0);
            }, se;
          }();
          ne[ee[178]] = ue;
          var _e = function() {
            function se() {
            }
            return se[ee[216]] = function() {
              var oe;
              return (oe = ee[217] != typeof Float32Array ? new Float32Array(16) : new Array(16))[0] = 1, oe[1] = 0, oe[2] = 0, oe[3] = 0, oe[4] = 0, oe[5] = 1, oe[6] = 0, oe[7] = 0, oe[8] = 0, oe[9] = 0, oe[10] = 1, oe[11] = 0, oe[12] = 0, oe[13] = 0, oe[14] = 0, oe[15] = 1, oe;
            }, se[ee[218]] = function(oe) {
              return oe[0] = 1, oe[1] = 0, oe[2] = 0, oe[3] = 0, oe[4] = 0, oe[5] = 1, oe[6] = 0, oe[7] = 0, oe[8] = 0, oe[9] = 0, oe[10] = 1, oe[11] = 0, oe[12] = 0, oe[13] = 0, oe[14] = 0, oe[15] = 1, oe;
            }, se[ee[219]] = function(oe, ce, he) {
              var ge, ve, me, be, pe, $e, ye, Se, we, Pe, Te, Ee, Me, Ae, Ne, Ce, Ie, xe, Ue, ke, Le, De, Re, Oe, Be = he[0], Fe = he[1], Ve = he[2], Ke = Math[ee[211]](Be * Be + Fe * Fe + Ve * Ve);
              return Math[ee[202]](Ke) < ae ? null : (Be *= Ke = 1 / Ke, Fe *= Ke, Ve *= Ke, ge = Math[ee[220]](ce), me = 1 - (ve = Math[ee[221]](ce)), be = oe[0], pe = oe[1], $e = oe[2], ye = oe[3], Se = oe[4], we = oe[5], Pe = oe[6], Te = oe[7], Ee = oe[8], Me = oe[9], Ae = oe[10], Ne = oe[11], Ce = Be * Be * me + ve, Ie = Fe * Be * me + Ve * ge, xe = Ve * Be * me - Fe * ge, Ue = Be * Fe * me - Ve * ge, ke = Fe * Fe * me + ve, Le = Ve * Fe * me + Be * ge, De = Be * Ve * me + Fe * ge, Re = Fe * Ve * me - Be * ge, Oe = Ve * Ve * me + ve, oe[0] = be * Ce + Se * Ie + Ee * xe, oe[1] = pe * Ce + we * Ie + Me * xe, oe[2] = $e * Ce + Pe * Ie + Ae * xe, oe[3] = ye * Ce + Te * Ie + Ne * xe, oe[4] = be * Ue + Se * ke + Ee * Le, oe[5] = pe * Ue + we * ke + Me * Le, oe[6] = $e * Ue + Pe * ke + Ae * Le, oe[7] = ye * Ue + Te * ke + Ne * Le, oe[8] = be * De + Se * Re + Ee * Oe, oe[9] = pe * De + we * Re + Me * Oe, oe[10] = $e * De + Pe * Re + Ae * Oe, oe[11] = ye * De + Te * Re + Ne * Oe, oe);
            }, se[ee[222]] = function(oe, ce, he) {
              var ge = ce[0], ve = ce[1], me = ce[2], be = ce[3], pe = ce[4], $e = ce[5], ye = ce[6], Se = ce[7], we = ce[8], Pe = ce[9], Te = ce[10], Ee = ce[11], Me = ce[12], Ae = ce[13], Ne = ce[14], Ce = ce[15], Ie = he[0], xe = he[1], Ue = he[2], ke = he[3];
              return oe[0] = Ie * ge + xe * pe + Ue * we + ke * Me, oe[1] = Ie * ve + xe * $e + Ue * Pe + ke * Ae, oe[2] = Ie * me + xe * ye + Ue * Te + ke * Ne, oe[3] = Ie * be + xe * Se + Ue * Ee + ke * Ce, Ie = he[4], xe = he[5], Ue = he[6], ke = he[7], oe[4] = Ie * ge + xe * pe + Ue * we + ke * Me, oe[5] = Ie * ve + xe * $e + Ue * Pe + ke * Ae, oe[6] = Ie * me + xe * ye + Ue * Te + ke * Ne, oe[7] = Ie * be + xe * Se + Ue * Ee + ke * Ce, Ie = he[8], xe = he[9], Ue = he[10], ke = he[11], oe[8] = Ie * ge + xe * pe + Ue * we + ke * Me, oe[9] = Ie * ve + xe * $e + Ue * Pe + ke * Ae, oe[10] = Ie * me + xe * ye + Ue * Te + ke * Ne, oe[11] = Ie * be + xe * Se + Ue * Ee + ke * Ce, Ie = he[12], xe = he[13], Ue = he[14], ke = he[15], oe[12] = Ie * ge + xe * pe + Ue * we + ke * Me, oe[13] = Ie * ve + xe * $e + Ue * Pe + ke * Ae, oe[14] = Ie * me + xe * ye + Ue * Te + ke * Ne, oe[15] = Ie * be + xe * Se + Ue * Ee + ke * Ce, oe;
            }, se[ee[223]] = function(oe, ce, he, ge, ve) {
              var me = 1 / Math[ee[181]](ce / 2), be = 1 / (ge - ve);
              return oe[0] = me / he, oe[1] = 0, oe[2] = 0, oe[3] = 0, oe[4] = 0, oe[5] = me, oe[6] = 0, oe[7] = 0, oe[8] = 0, oe[9] = 0, oe[10] = (ve + ge) * be, oe[11] = -1, oe[12] = 0, oe[13] = 0, oe[14] = 2 * ve * ge * be, oe[15] = 0, oe;
            }, se[ee[224]] = function(oe, ce) {
              var he = ce[0], ge = ce[1], ve = ce[2], me = ce[3], be = ce[4], pe = ce[5], $e = ce[6], ye = ce[7], Se = ce[8], we = ce[9], Pe = ce[10], Te = ce[11], Ee = ce[12], Me = ce[13], Ae = ce[14], Ne = ce[15], Ce = he * pe - ge * be, Ie = he * $e - ve * be, xe = he * ye - me * be, Ue = ge * $e - ve * pe, ke = ge * ye - me * pe, Le = ve * ye - me * $e, De = Se * Me - we * Ee, Re = Se * Ae - Pe * Ee, Oe = Se * Ne - Te * Ee, Be = we * Ae - Pe * Me, Fe = we * Ne - Te * Me, Ve = Pe * Ne - Te * Ae, Ke = Ce * Ve - Ie * Fe + xe * Be + Ue * Oe - ke * Re + Le * De;
              return Ke ? (Ke = 1 / Ke, oe[0] = (pe * Ve - $e * Fe + ye * Be) * Ke, oe[1] = (ve * Fe - ge * Ve - me * Be) * Ke, oe[2] = (Me * Le - Ae * ke + Ne * Ue) * Ke, oe[3] = (Pe * ke - we * Le - Te * Ue) * Ke, oe[4] = ($e * Oe - be * Ve - ye * Re) * Ke, oe[5] = (he * Ve - ve * Oe + me * Re) * Ke, oe[6] = (Ae * xe - Ee * Le - Ne * Ie) * Ke, oe[7] = (Se * Le - Pe * xe + Te * Ie) * Ke, oe[8] = (be * Fe - pe * Oe + ye * De) * Ke, oe[9] = (ge * Oe - he * Fe - me * De) * Ke, oe[10] = (Ee * ke - Me * xe + Ne * Ce) * Ke, oe[11] = (we * xe - Se * ke - Te * Ce) * Ke, oe[12] = (pe * Re - be * Be - $e * De) * Ke, oe[13] = (he * Be - ge * Re + ve * De) * Ke, oe[14] = (Me * Ie - Ee * Ue - Ae * Ce) * Ke, oe[15] = (Se * Ue - we * Ie + Pe * Ce) * Ke, oe) : null;
            }, se;
          }();
          ne[ee[208]] = _e;
          var fe = function() {
            function se() {
            }
            return se[ee[216]] = function() {
              var oe;
              return (oe = ee[217] != typeof Float32Array ? new Float32Array(3) : new Array(3))[0] = 0, oe[1] = 0, oe[2] = 0, oe;
            }, se;
          }();
          ne[ee[207]] = fe;
          var le = function() {
            function se() {
            }
            return se[ee[216]] = function() {
              var oe;
              return (oe = ee[217] != typeof Float32Array ? new Float32Array(4) : new Array(4))[0] = 0, oe[1] = 0, oe[2] = 0, oe[3] = 1, oe;
            }, se[ee[225]] = function(oe, ce, he, ge) {
              var ve;
              return (ve = ee[217] != typeof Float32Array ? new Float32Array(4) : new Array(4))[0] = oe, ve[1] = ce, ve[2] = he, ve[3] = ge, ve;
            }, se[ee[222]] = function(oe, ce, he) {
              var ge = ce[0], ve = ce[1], me = ce[2], be = ce[3], pe = he[0], $e = he[1], ye = he[2], Se = he[3];
              return oe[0] = ge * Se + be * pe + ve * ye - me * $e, oe[1] = ve * Se + be * $e + me * pe - ge * ye, oe[2] = me * Se + be * ye + ge * $e - ve * pe, oe[3] = be * Se - ge * pe - ve * $e - me * ye, oe;
            }, se[ee[226]] = function(oe) {
              var ce = fe[ee[216]](), he = oe[0] * oe[0], ge = oe[1] * oe[1], ve = oe[2] * oe[2], me = oe[0] * oe[1] + oe[2] * oe[3];
              return me > 0.499 ? (ce[2] = 2 * Math[ee[227]](oe[0], oe[3]), ce[0] = Math[ee[209]] / 2, ce[1] = 0) : me < -0.499 ? (ce[2] = -2 * Math[ee[227]](oe[0], oe[3]), ce[0] = -Math[ee[209]] / 2, ce[1] = 0) : (ce[2] = Math[ee[227]](2 * oe[1] * oe[3] - 2 * oe[0] * oe[2], 1 - 2 * ge - 2 * ve), ce[0] = Math[ee[228]](2 * me), ce[1] = Math[ee[227]](2 * oe[0] * oe[3] - 2 * oe[1] * oe[2], 1 - 2 * he - 2 * ve)), { yaw: 180 * ce[2] / Math[ee[209]], pitch: 180 * ce[1] / Math[ee[209]], roll: 180 * ce[0] / Math[ee[209]] };
            }, se;
          }();
          ne[ee[206]] = le;
        }, 72532: function(ie, ne) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[21]] = void 0;
          var ae = function() {
            function ue(_e, fe) {
              this[ee[229]] = _e, this[ee[20]] = fe, this[ee[230]] = 0, this[ee[231]] = new DataView(this[ee[229]][ee[229]], 0, this[ee[229]][ee[5]]);
            }
            return ue[ee[172]][ee[232]] = function() {
              var _e, fe = 0;
              for (_e = 0; this[ee[230]] < this[ee[229]][ee[5]] && (fe |= (127 & this[ee[229]][this[ee[230]]]) << _e, !!(128 & this[ee[229]][this[ee[230]]])); this[ee[230]]++)
                _e += 7;
              return this[ee[230]]++, fe;
            }, ue[ee[172]][ee[233]] = function() {
              var _e = this[ee[232]]();
              return { tag: _e >>> 3, type: 7 & _e };
            }, ue[ee[172]][ee[234]] = function() {
              for (var _e = this[ee[232]](), fe = new Array(_e), le = 0, se = this[ee[230]]; se < this[ee[230]] + _e; se++) {
                var oe = this[ee[229]][se];
                if (oe < 128)
                  fe[le++] = oe;
                else if (oe >= 192 && oe < 224 && se + 1 < _e)
                  fe[le++] = (31 & oe) << 6 | 63 & this[ee[229]][++se];
                else if (oe >= 224 && oe < 240 && se + 2 < _e)
                  fe[le++] = (15 & oe) << 12 | (63 & this[ee[229]][++se]) << 6 | 63 & this[ee[229]][++se];
                else {
                  if (!(oe >= 240 && oe < 248 && se + 3 < _e))
                    throw new Error(ee[235] + se);
                  var ce = (7 & oe) << 18 | (63 & this[ee[229]][++se]) << 12 | (63 & this[ee[229]][++se]) << 6 | 63 & this[ee[229]][++se];
                  ce <= 65535 ? fe[le++] = ce : (ce ^= 65536, fe[le++] = 55296 | ce >> 10, fe[le++] = 56320 | 1023 & ce);
                }
              }
              var he = ee[11], ge = 16384;
              for (se = 0; se < le; se += ge)
                he += String[ee[238]][ee[237]](String, fe[ee[236]](se, se + ge <= le ? se + ge : le));
              return this[ee[230]] += _e, he;
            }, ue[ee[172]][ee[239]] = function(_e) {
              var fe = this[ee[232]](), le = [];
              switch (_e) {
                case ee[26]:
                  for (var se = 0; se < fe / 4; se++)
                    le[ee[241]](this[ee[231]][ee[240]](this[ee[230]], !0)), this[ee[230]] += 4;
                  break;
                case ee[242]:
                  for (var oe = this[ee[230]]; this[ee[230]] < oe + fe; )
                    le[ee[241]](this[ee[232]]());
              }
              return le;
            }, ue[ee[172]][ee[243]] = function(_e) {
              for (var fe = 0, le = 0; le < _e; le++)
                fe = (fe << 8) + this[ee[229]][this[ee[230]] + le], this[ee[230]]++;
              return fe;
            }, ue[ee[172]][ee[244]] = function() {
              var _e = this[ee[231]][ee[240]](this[ee[230]], !0);
              return this[ee[230]] += 4, _e;
            }, ue[ee[172]][ee[245]] = function() {
              return this[ee[243]](8);
            }, ue[ee[172]][ee[246]] = function(_e) {
              var fe;
              switch (_e) {
                case 0:
                  fe = this[ee[232]]();
                  break;
                case 1:
                  fe = this[ee[245]]();
                  break;
                case 2:
                  fe = this[ee[234]]();
                  break;
                case 5:
                  fe = this[ee[244]]();
              }
              return fe;
            }, ue[ee[172]][ee[19]] = function() {
              for (var _e = {}; this[ee[230]] < this[ee[229]][ee[5]]; ) {
                var fe = this[ee[233]](), le = void 0;
                if (this[ee[20]][ee[248]](fe[ee[247]]))
                  if (le = this[ee[20]][fe[ee[247]]], fe[ee[152]] === 2 && le && le[ee[248]](ee[249]) && le[ee[249]])
                    _e[le[ee[250]]] = this[ee[239]](le[ee[152]]);
                  else {
                    var se = this[ee[246]](fe[ee[152]]);
                    ee[36] === le[ee[152]] ? se = !!se : ee[251] == typeof le[ee[152]] && (se = le[ee[152]][se]), _e[le[ee[250]]] = se;
                  }
              }
              if (_e[ee[5]] > 0)
                for (var oe in this[ee[20]][ee[252]])
                  this[ee[20]][ee[252]][ee[248]](oe) && _e[oe] === void 0 && (_e[oe] = this[ee[20]][ee[252]][oe]);
              return _e;
            }, ue;
          }();
          ne[ee[21]] = ae;
        }, 29328: function(ie, ne) {
          ee[0];
          var ae, ue, _e;
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[253]] = ne[ee[254]] = ne[ee[255]] = void 0, function(fe) {
            fe[ee[256]] = ee[257], fe[ee[258]] = ee[259], fe[ee[260]] = ee[261];
          }(ae || (ne[ee[255]] = ae = {})), function(fe) {
            fe[ee[262]] = ee[263], fe[ee[264]] = ee[265], fe[ee[266]] = ee[267], fe[ee[268]] = ee[269];
          }(ue || (ne[ee[254]] = ue = {})), function(fe) {
            fe[ee[270]] = ee[38], fe[ee[271]] = ee[272], fe[ee[273]] = ee[274], fe[ee[275]] = ee[276];
          }(_e || (ne[ee[253]] = _e = {}));
        }, 27523: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[277]] = void 0;
          var ue = ae(52241), _e = ae(8945), fe = ae(63546), le = ae(35148), se = ae(4006), oe = ae(62510), ce = ae(33696), he = ae(13533), ge = ae(46462), ve = ae(29328), me = ae(33083), be = ae(41205), pe = 4, $e = function() {
            function ye(Se, we, Pe, Te, Ee, Me, Ae, Ne) {
              var Ce = this;
              this[ee[278]] = null, this[ee[279]] = null, this[ee[280]] = null, this[ee[281]] = null, this[ee[282]] = ve[ee[254]][ee[268]], this[ee[283]] = null, this[ee[284]] = !1, this[ee[285]] = !1, this[ee[286]] = null, this[ee[287]] = null, this[ee[288]] = null, this[ee[289]] = !1, this[ee[290]] = function() {
                Ce[ee[291]] = !0;
              }, this[ee[292]] = function(Le) {
                if (Ce[ee[282]] !== ve[ee[254]][ee[264]])
                  return Ce[ee[293]] && Ce[ee[295]][ee[294]] && Ce[ee[295]][ee[294]](), void (Ce[ee[293]] = !1);
                Ce[ee[296]](), Ce[ee[285]] !== Ce[ee[284]] && (Ce[ee[300]][ee[299]]()(oe[ee[298]][ee[297]], { stereo: Ce[ee[284]] }), Ce[ee[285]] = Ce[ee[284]]);
                var De = Ce[ee[287]][ee[301]](Le), Re = !Ce[ee[289]] || Ce[ee[291]] || Le === 0;
                Re || De || Le === 0 || Ce[ee[302]] ? (Ce[ee[303]] && Ce[ee[295]][ee[304]] && Ce[ee[295]][ee[304]](), !Ce[ee[293]] && Ce[ee[295]][ee[305]] && Ce[ee[295]][ee[305]](), Ce[ee[286]][ee[307]](Ce[ee[287]][ee[306]](), Re), Ce[ee[303]] = !1, Ce[ee[293]] = !0) : (Ce[ee[293]] && Ce[ee[295]][ee[294]] && Ce[ee[295]][ee[294]](), Ce[ee[293]] = !1), Ce[ee[283]] === null && (Ce[ee[280]] = requestAnimationFrame(Ce[ee[292]])), Ce[ee[291]] = !1, Ce[ee[302]] = !1;
              }, this[ee[308]] = function() {
                Ce[ee[311]]()[ee[310]](ge[ee[309]][ee[265]], Ce[ee[308]]), Ce[ee[311]]()[ee[310]](ge[ee[309]][ee[312]], Ce[ee[308]]), Ce[ee[282]] === ve[ee[254]][ee[262]] && (Ce[ee[296]](), Ce[ee[282]] = ve[ee[254]][ee[264]], Ce[ee[280]] = requestAnimationFrame(Ce[ee[292]]));
              }, this[ee[313]] = function(Le) {
                Ce[ee[282]] = ve[ee[254]][ee[266]], Ce[ee[283]] = Le, Ce[ee[314]](), Ce[ee[280]] && (cancelAnimationFrame(Ce[ee[280]]), Ce[ee[280]] = null), Ce[ee[300]][ee[299]]()(oe[ee[298]][ee[315]], new fe[ee[318]](le[ee[317]][ee[316]])), Ce[ee[320]][ee[156]](ee[319] + Le);
              }, this[ee[321]] = function() {
                return Ce[ee[287]][ee[321]](), !0;
              }, this[ee[322]] = function() {
                return Ce[ee[287]][ee[322]](), !0;
              }, this[ee[323]] = function() {
                return Ce[ee[287]][ee[323]]();
              }, this[ee[324]] = function() {
                return Ce[ee[287]][ee[324]](), !0;
              }, this[ee[325]] = function() {
                return Ce[ee[287]][ee[325]](), !0;
              }, this[ee[326]] = function() {
                return Ce[ee[287]][ee[326]]();
              }, this[ee[327]] = function() {
                return Ce[ee[287]][ee[327]](), !0;
              }, this[ee[328]] = function() {
                return Ce[ee[287]][ee[328]](), !0;
              }, this[ee[329]] = function() {
                return Ce[ee[287]][ee[329]]();
              }, this[ee[330]] = function(Le) {
                return !!Ce[ee[287]] && (Ce[ee[287]][ee[330]](Le), !0);
              }, this[ee[331]] = function() {
                Ce[ee[289]] = !0;
              }, this[ee[332]] = function() {
                var Le = Ce[ee[311]]();
                if (Le[ee[333]] !== pe) {
                  var De = function() {
                    return Ce[ee[289]] = !1;
                  };
                  Le[ee[334]](ge[ee[309]][ee[265]], De);
                } else
                  Ce[ee[289]] = !1;
              }, this[ee[335]] = function() {
                Ce[ee[300]][ee[336]](oe[ee[298]][ee[264]], Ce[ee[332]]), Ce[ee[300]][ee[336]](oe[ee[298]][ee[337]], Ce[ee[331]]), Ce[ee[300]][ee[336]](oe[ee[298]][ee[338]], Ce[ee[335]]), Ce[ee[300]][ee[336]](oe[ee[298]][ee[339]], Ce[ee[335]]), Ce[ee[300]] = null;
                var Le = Ce[ee[311]]();
                Ce[ee[340]] && Ce[ee[340]][ee[310]](ge[ee[309]][ee[312]], Ce[ee[290]]), Ce[ee[314]](), Ce[ee[278]] && Ce[ee[278]][ee[341]] && (Ce[ee[278]][ee[341]][ee[342]](Ce[ee[278]]), Ce[ee[278]] = null), Ce[ee[279]] && Ce[ee[279]][ee[341]] && (Ce[ee[279]][ee[341]][ee[342]](Ce[ee[279]]), Ce[ee[279]] = null), Ce[ee[281]] && Ce[ee[281]][ee[341]] && (Ce[ee[281]][ee[341]][ee[342]](Ce[ee[281]]), Ce[ee[281]] = null), Ce[ee[282]] = ve[ee[254]][ee[268]], Ce[ee[280]] && (cancelAnimationFrame(Ce[ee[280]]), Ce[ee[280]] = null), Ce[ee[287]] && Ce[ee[287]][ee[335]](), Ce[ee[287]] = null, Ce[ee[286]][ee[335]](), Ce[ee[286]] = null, Le[ee[310]](ge[ee[309]][ee[265]], Ce[ee[308]]), Le[ee[310]](ge[ee[309]][ee[312]], Ce[ee[308]]);
              }, this[ee[300]] = Se[ee[300]], this[ee[340]] = Se[ee[343]], this[ee[344]] = Te, this[ee[345]] = Se[ee[346]], this[ee[347]] = we, this[ee[348]] = Pe, this[ee[295]] = Ne, this[ee[320]] = Ee, this[ee[349]] = Me, this[ee[350]] = Se[ee[353]][ee[352]][ee[351]], this[ee[354]] = Ae, this[ee[291]] = !1, this[ee[302]] = !1, this[ee[293]] = !1, this[ee[303]] = !0, this[ee[278]] = document[ee[355]](ee[278]), this[ee[278]][ee[357]](ee[347], ee[356]), this[ee[278]][ee[359]][ee[358]] = ee[38], this[ee[278]][ee[359]][ee[360]] = ee[361];
              var Ie = this[ee[345]][ee[365]](se[ee[363]][ee[362]] + ee[364])[0];
              Ie ? this[ee[345]][ee[366]](this[ee[278]], Ie) : this[ee[345]][ee[367]](this[ee[278]]);
              var xe = Se[ee[353]][ee[352]][ee[368]];
              if (ye[ee[369]](Me, this[ee[350]], xe) ? this[ee[320]][ee[156]](ee[370]) : (this[ee[279]] = document[ee[355]](ee[278]), this[ee[279]][ee[357]](ee[347], ee[371]), this[ee[279]][ee[359]][ee[358]] = ee[38], this[ee[279]][ee[359]][ee[360]] = ee[361], this[ee[345]][ee[366]](this[ee[279]], this[ee[278]]), this[ee[320]][ee[156]](ee[372])), (0, he[ee[374]])()[ee[373]] && (this[ee[340]][ee[357]](ee[375], ee[11]), this[ee[340]][ee[357]](ee[376], ee[11]), this[ee[320]][ee[156]](ee[377])), this[ee[281]] = document[ee[379]](ee[378]), this[ee[281]] || (this[ee[281]] = document[ee[355]](ee[359]), this[ee[281]][ee[357]](ee[347], ee[378]), this[ee[281]][ee[367]](document[ee[381]](ee[380])), document[ee[383]](ee[382])[0][ee[367]](this[ee[281]])), this[ee[284]] = this[ee[348]][ee[284]], this[ee[285]] = this[ee[284]], this[ee[348]][ee[384]] ? this[ee[320]][ee[156]](ee[385]) : this[ee[340]][ee[334]](ge[ee[309]][ee[312]], this[ee[290]]), ee[23] == typeof this[ee[348]][ee[386]]) {
                var Ue = ue[ee[17]][ee[18]](this[ee[348]][ee[386]]);
                this[ee[320]][ee[156]](ee[387] + JSON[ee[155]](Ue)), Ue[ee[248]](ee[34]) && (this[ee[288]] = new _e[ee[168]](Ue, this[ee[320]]));
              }
              this[ee[282]] = ve[ee[254]][ee[262]], this[ee[287]] = new me[ee[388]](this[ee[278]], this[ee[345]], this[ee[348]], this[ee[295]], this[ee[300]]), this[ee[286]] = new be[ee[389]](this[ee[278]], this[ee[279]], Se, this[ee[288]], this[ee[313]], this[ee[320]], this[ee[354]], this[ee[348]], this[ee[295]]), this[ee[300]][ee[390]](oe[ee[298]][ee[264]], this[ee[332]]), this[ee[300]][ee[390]](oe[ee[298]][ee[337]], this[ee[331]]), this[ee[300]][ee[390]](oe[ee[298]][ee[338]], this[ee[335]]), this[ee[300]][ee[390]](oe[ee[298]][ee[339]], this[ee[335]]), this[ee[391]](), this[ee[296]]();
              var ke = this[ee[311]]();
              ke[ee[333]] !== pe && ke[ee[392]] ? (ke[ee[334]](ge[ee[309]][ee[265]], this[ee[308]]), ke[ee[334]](ge[ee[309]][ee[312]], this[ee[308]])) : this[ee[308]]();
            }
            return ye[ee[172]][ee[311]] = function() {
              return this[ee[348]][ee[384]] && this[ee[344]] ? this[ee[344]] : this[ee[340]];
            }, ye[ee[172]][ee[296]] = function() {
              if (this[ee[278]]) {
                var Se, we, Pe, Te;
                this[ee[345]] && this[ee[345]][ee[393]] && this[ee[345]][ee[394]] ? (Se = this[ee[345]][ee[393]], we = this[ee[345]][ee[394]]) : (Se = window[ee[395]], we = window[ee[396]]), this[ee[340]] && this[ee[340]][ee[397]] && this[ee[340]][ee[398]] ? (Pe = this[ee[340]][ee[397]], Te = this[ee[340]][ee[398]]) : (Pe = Se, Te = we);
                var Ee = (this[ee[349]][ee[146]] || 1) / this[ee[286]][ee[399]](), Me = Se * Ee, Ae = we * Ee, Ne = Me / Ae;
                Me > Pe && (Ae = (Me = Pe) / Ne), Ae > Te && (Me = (Ae = Te) * Ne), this[ee[278]][ee[134]] === Me && this[ee[278]][ee[136]] === Ae || (this[ee[278]][ee[134]] = Me, this[ee[278]][ee[136]] = Ae), !this[ee[279]] || this[ee[279]][ee[134]] === Pe && this[ee[279]][ee[136]] === Te || (this[ee[279]][ee[134]] = Pe, this[ee[279]][ee[136]] = Te);
              }
            }, ye[ee[172]][ee[391]] = function() {
              this[ee[278]] && (this[ee[278]][ee[359]][ee[358]] = ee[400]), this[ee[279]] && (this[ee[279]][ee[359]][ee[358]] = ee[400]), this[ee[340]] && (this[ee[340]][ee[359]][ee[358]] = ee[38]);
            }, ye[ee[172]][ee[314]] = function() {
              this[ee[278]] && (this[ee[278]][ee[359]][ee[358]] = ee[38]), this[ee[279]] && (this[ee[279]][ee[359]][ee[358]] = ee[38]), this[ee[340]] && this[ee[340]][ee[359]] && (this[ee[340]][ee[359]][ee[358]] = ee[400]);
            }, ye[ee[369]] = function(Se, we, Pe) {
              var Te = Se[ee[401]], Ee = Se[ee[149]], Me = Se[ee[402]], Ae = (0, he[ee[374]])()[ee[403]], Ne = 10, Ce = (Ae[ee[404]] > Ne || Ae[ee[404]] === Ne && Ae[ee[405]] >= 1) && !(0, he[ee[374]])()[ee[373]], Ie = -1;
              return !(we === ce[ee[407]][ee[406]] && Pe === ce[ee[409]][ee[408]] && !Ce) && (ee[410] === Te ? new RegExp(ee[412])[ee[411]](Ee) !== null && (Ie = parseFloat(RegExp[ee[413]])) : ee[414] === Te && (Me[ee[167]](ee[415]) !== -1 ? Ie = 11 : new RegExp(ee[416])[ee[411]](Ee) !== null && (Ie = parseFloat(RegExp[ee[413]]))), Ie === -1 || Ie >= 13);
            }, ye[ee[172]][ee[417]] = function(Se) {
              return this[ee[302]] = this[ee[284]] !== Se, this[ee[284]] = Se, this[ee[284]] ? (this[ee[286]][ee[418]](), this[ee[287]][ee[418]]()) : (this[ee[286]][ee[419]](), this[ee[287]][ee[419]]()), !0;
            }, ye[ee[172]][ee[420]] = function() {
              return this[ee[284]];
            }, ye[ee[172]][ee[421]] = function() {
              return this[ee[282]] === ve[ee[254]][ee[262]] ? ve[ee[254]][ee[262]] : this[ee[282]] === ve[ee[254]][ee[264]] ? ve[ee[254]][ee[264]] : this[ee[282]] === ve[ee[254]][ee[266]] ? ve[ee[254]][ee[266]] : this[ee[282]] === ve[ee[254]][ee[268]] ? null : void 0;
            }, ye[ee[172]][ee[422]] = function() {
              return this[ee[283]];
            }, ye[ee[172]][ee[423]] = function() {
              return this[ee[287]] ? this[ee[287]][ee[423]]() : { yaw: 0, pitch: 0, roll: 0 };
            }, ye[ee[172]][ee[424]] = function(Se) {
              return !!this[ee[287]] && (this[ee[287]][ee[424]](Se), !0);
            }, ye[ee[172]][ee[425]] = function(Se) {
              return !!this[ee[287]] && (this[ee[287]][ee[425]](Se), !0);
            }, ye[ee[172]][ee[426]] = function() {
              return this[ee[287]] ? this[ee[287]][ee[426]]() : -1;
            }, ye[ee[172]][ee[427]] = function(Se) {
              return !!this[ee[287]] && (this[ee[287]][ee[427]](Se), !0);
            }, ye[ee[172]][ee[428]] = function() {
              return this[ee[287]] ? this[ee[287]][ee[428]]() : -1;
            }, ye[ee[172]][ee[429]] = function(Se) {
              return !!this[ee[287]] && (this[ee[287]][ee[429]](Se), !0);
            }, ye[ee[172]][ee[430]] = function() {
              return this[ee[287]] ? this[ee[287]][ee[430]]() : -1;
            }, ye[ee[172]][ee[431]] = function(Se) {
              return !!this[ee[287]] && (this[ee[287]][ee[431]](Se), !0);
            }, ye[ee[172]][ee[432]] = function() {
              return this[ee[287]] ? this[ee[287]][ee[432]]() : -1;
            }, ye[ee[172]][ee[433]] = function(Se) {
              return !!this[ee[287]] && this[ee[287]][ee[433]](Se);
            }, ye[ee[172]][ee[434]] = function() {
              return this[ee[287]] ? this[ee[287]][ee[434]]() : -1;
            }, ye[ee[172]][ee[435]] = function() {
              var Se, we;
              return (we = (Se = this[ee[287]]) === null || Se === void 0 ? void 0 : Se[ee[436]]()) !== null && we !== void 0 && we;
            }, ye[ee[172]][ee[437]] = function() {
              var Se, we;
              return (we = (Se = this[ee[287]]) === null || Se === void 0 ? void 0 : Se[ee[438]]()) !== null && we !== void 0 ? we : Promise[ee[439]]();
            }, ye;
          }();
          ne[ee[277]] = $e;
        }, 21971: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[254]] = ne[ee[253]] = ne[ee[255]] = ne[ee[440]] = void 0;
          var ue = ae(16368), _e = ae(29328);
          Object[ee[2]](ne, ee[253], { enumerable: !0, get: function() {
            return _e[ee[253]];
          } }), Object[ee[2]](ne, ee[255], { enumerable: !0, get: function() {
            return _e[ee[255]];
          } }), Object[ee[2]](ne, ee[254], { enumerable: !0, get: function() {
            return _e[ee[254]];
          } });
          var fe = ae(14912);
          ne[ee[440]] = { name: ue[ee[442]][ee[441]], module: { VRHandler: fe[ee[443]] }, exports: { VRContentType: _e[ee[255]], TransitionTimingType: _e[ee[253]], VRState: _e[ee[254]] } }, ne[ee[444]] = ne[ee[440]];
        }, 41205: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[389]] = void 0;
          var ue = ae(83549), _e = ae(62510), fe = ae(33696), le = ae(29328), se = ae(10755), oe = ae(78630), ce = 0.0555555, he = 4, ge = 3, ve = function() {
            function be() {
              this[ee[445]] = [], this[ee[446]] = [];
            }
            return be[ee[172]][ee[447]] = function() {
              return this[ee[445]];
            }, be[ee[172]][ee[448]] = function() {
              return this[ee[446]];
            }, be[ee[172]][ee[449]] = function(pe, $e) {
              this[ee[445]][ee[167]](pe) < 0 && (this[ee[445]][ee[241]](pe), this[ee[445]][ee[450]](function(ye, Se) {
                return ye - Se;
              })), this[ee[446]][ee[167]]($e) < 0 && (this[ee[446]][ee[241]]($e), this[ee[446]][ee[450]](function(ye, Se) {
                return ye - Se;
              }));
            }, be;
          }(), me = function() {
            function be(pe, $e, ye, Se, we, Pe, Te, Ee, Me) {
              var Ae = this;
              this[ee[451]] = null, this[ee[452]] = null, this[ee[283]] = se[ee[454]][ee[453]], this[ee[455]] = -1, this[ee[456]] = !1, this[ee[457]] = -1, this[ee[458]] = -1, this[ee[459]] = -1, this[ee[460]] = -1, this[ee[461]] = -1, this[ee[462]] = [-1, -1, 1, -1, 1, 1, -1, 1], this[ee[463]] = [0, 1, 2, 0, 2, 3], this[ee[464]] = -1, this[ee[465]] = new RegExp(ee[466], ee[467]), this[ee[468]] = !0, this[ee[469]] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this[ee[470]] = { LEFT: 0, RIGHT: 1 }, this[ee[471]] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this[ee[472]] = 1, this[ee[473]] = [[1, 1], [1, 1]], this[ee[474]] = [1, 1], this[ee[320]] = null, this[ee[278]] = null, this[ee[279]] = null, this[ee[340]] = null, this[ee[475]] = null, this[ee[350]] = null, this[ee[476]] = -1, this[ee[477]] = -1, this[ee[478]] = null, this[ee[479]] = !1, this[ee[354]] = null, Ee[ee[284]] ? (this[ee[456]] = !0, this[ee[455]] = 2) : (this[ee[456]] = !1, this[ee[455]] = 1), this[ee[300]] = ye[ee[300]], this[ee[320]] = Pe, this[ee[278]] = pe, this[ee[279]] = $e, this[ee[340]] = ye[ee[343]], this[ee[475]] = we, this[ee[350]] = ye[ee[353]][ee[352]][ee[351]], this[ee[354]] = Te, this[ee[348]] = Ee, this[ee[295]] = Me, this[ee[480]] = [], this[ee[300]][ee[390]](_e[ee[298]][ee[481]], function() {
                return Ae[ee[468]] = !1;
              }), Se && (this[ee[471]] = this[ee[482]](Se), this[ee[472]] = this[ee[483]](Se), this[ee[473]][this[ee[470]][ee[484]]] = this[ee[485]](Se, this[ee[470]][ee[484]]), this[ee[473]][this[ee[470]][ee[486]]] = this[ee[485]](Se, this[ee[470]][ee[486]]), this[ee[474]] = this[ee[487]](Se)), this[ee[478]] = new ve(), this[ee[488]] = new oe[ee[489]](1500, 1e3), this[ee[348]][ee[490]] ? (this[ee[488]][ee[491]](), this[ee[488]][ee[492]](this)) : this[ee[488]][ee[493]]();
              try {
                this[ee[494]](), this[ee[495]](), this[ee[496]](), this[ee[497]](), this[ee[498]](), this[ee[499]](), this[ee[500]](), this[ee[501]]();
              } catch (Ne) {
                this[ee[320]][ee[267]](Ne);
              }
            }
            return be[ee[172]][ee[502]] = function(pe) {
              if (pe === void 0 && (pe = []), this[ee[451]] !== null) {
                var $e = this[ee[451]][ee[503]]();
                if ($e === se[ee[454]][ee[453]])
                  return this[ee[283]] = se[ee[454]][ee[453]], void (this[ee[480]] = []);
                if (this[ee[480]][ee[241]]($e), pe[ee[167]]($e) > -1 && this[ee[468]])
                  throw this[ee[283]] = se[ee[454]][ee[453]], this[ee[480]] = [], ee[504];
                if (!(this[ee[480]][ee[5]] >= this[ee[354]][ee[505]]))
                  return;
                this[ee[283]] = this[ee[480]][this[ee[480]][ee[5]] - 1];
              }
              var ye = ee[506];
              throw se[ee[507]][this[ee[283]]] && (ye = se[ee[507]][this[ee[283]]]), this[ee[475]](ye), ye;
            }, be[ee[172]][ee[508]] = function(pe, $e) {
              for (var ye = [], Se = 2; Se < arguments[ee[5]]; Se++)
                ye[Se - 2] = arguments[Se];
              var we = null;
              if (pe && ee[509] == typeof pe[$e]) {
                try {
                  we = pe[$e][ee[237]](pe, ye);
                } catch (Pe) {
                  this[ee[320]][ee[513]](ee[510] + $e + ee[511] + JSON[ee[155]](ye) + ee[512] + Pe);
                }
                this[ee[502]]();
              }
              return we;
            }, be[ee[172]][ee[514]] = function(pe) {
              throw this[ee[283]] = se[ee[454]][ee[515]], this[ee[475]](pe), pe;
            }, be[ee[172]][ee[495]] = function() {
              this[ee[516]] = ae(10768), this[ee[517]] = ae(50766);
              var pe = this[ee[508]](this[ee[451]], ee[518], this[ee[451]][ee[519]], this[ee[451]][ee[520]]);
              pe[ee[521]] !== 0 && pe[ee[522]] !== 0 && pe[ee[523]] !== 0 && (this[ee[516]] = this[ee[516]][ee[525]](this[ee[465]], ee[524])), (pe = this[ee[508]](this[ee[451]], ee[518], this[ee[451]][ee[526]], this[ee[451]][ee[520]]))[ee[521]] !== 0 && pe[ee[522]] !== 0 && pe[ee[523]] !== 0 && (this[ee[517]] = this[ee[517]][ee[525]](this[ee[465]], ee[524]));
            }, be[ee[172]][ee[494]] = function() {
              this[ee[279]] && (this[ee[452]] = this[ee[279]][ee[528]](ee[527]));
              var pe = { failIfMajorPerformanceCaveat: !0 };
              this[ee[451]] = this[ee[278]][ee[528]](ee[529], pe) || this[ee[278]][ee[528]](ee[530], pe), this[ee[502]](), this[ee[508]](this[ee[451]], ee[531], 0.5, 0.5, 0.5, 1), this[ee[508]](this[ee[451]], ee[532], 1), this[ee[508]](this[ee[451]], ee[493], this[ee[451]][ee[533]]);
            }, be[ee[172]][ee[496]] = function() {
              this[ee[457]] = this[ee[508]](this[ee[451]], ee[534], this[ee[451]][ee[526]]), this[ee[508]](this[ee[451]], ee[535], this[ee[457]], this[ee[517]]), this[ee[508]](this[ee[451]], ee[536], this[ee[457]]), this[ee[508]](this[ee[451]], ee[537], this[ee[457]], this[ee[451]][ee[538]]) || this[ee[514]](ee[539] + this[ee[508]](this[ee[451]], ee[540], this[ee[457]]) + ee[541]), this[ee[458]] = this[ee[508]](this[ee[451]], ee[534], this[ee[451]][ee[519]]), this[ee[508]](this[ee[451]], ee[535], this[ee[458]], this[ee[516]]), this[ee[508]](this[ee[451]], ee[536], this[ee[458]]), this[ee[508]](this[ee[451]], ee[537], this[ee[458]], this[ee[451]][ee[538]]) || this[ee[514]](ee[542] + this[ee[508]](this[ee[451]], ee[540], this[ee[458]]) + ee[541]);
            }, be[ee[172]][ee[497]] = function() {
              this[ee[459]] = this[ee[508]](this[ee[451]], ee[497]), this[ee[508]](this[ee[451]], ee[543], this[ee[459]], this[ee[457]]), this[ee[508]](this[ee[451]], ee[543], this[ee[459]], this[ee[458]]), this[ee[508]](this[ee[451]], ee[544], this[ee[459]]), this[ee[508]](this[ee[451]], ee[545], this[ee[459]], this[ee[451]][ee[546]]) || this[ee[514]](ee[547] + this[ee[508]](this[ee[451]], ee[548], this[ee[459]])), this[ee[508]](this[ee[451]], ee[549], this[ee[459]]);
            }, be[ee[172]][ee[498]] = function() {
              this[ee[550]] = new se[ee[551]](this[ee[451]], this[ee[459]], ee[550], null);
            }, be[ee[172]][ee[499]] = function() {
              this[ee[552]] = new se[ee[555]](this[ee[451]], this[ee[459]], ee[552], se[ee[554]][ee[553]]), this[ee[556]] = new se[ee[555]](this[ee[451]], this[ee[459]], ee[556], se[ee[554]][ee[553]]), this[ee[557]] = new se[ee[555]](this[ee[451]], this[ee[459]], ee[557], se[ee[554]][ee[553]]), this[ee[558]] = new se[ee[555]](this[ee[451]], this[ee[459]], ee[558], se[ee[554]][ee[559]]), this[ee[397]] = new se[ee[555]](this[ee[451]], this[ee[459]], ee[397], se[ee[554]][ee[559]]), this[ee[398]] = new se[ee[555]](this[ee[451]], this[ee[459]], ee[398], se[ee[554]][ee[559]]), this[ee[560]] = new se[ee[555]](this[ee[451]], this[ee[459]], ee[560], se[ee[554]][ee[561]]), this[ee[562]] = new se[ee[555]](this[ee[451]], this[ee[459]], ee[562], se[ee[554]][ee[563]]), this[ee[564]] = new se[ee[555]](this[ee[451]], this[ee[459]], ee[564], se[ee[554]][ee[559]]), this[ee[565]] = new se[ee[555]](this[ee[451]], this[ee[459]], ee[565], se[ee[554]][ee[566]]), this[ee[567]] = new se[ee[555]](this[ee[451]], this[ee[459]], ee[567], se[ee[554]][ee[566]]);
            }, be[ee[172]][ee[500]] = function() {
              this[ee[460]] = this[ee[508]](this[ee[451]], ee[568]), this[ee[508]](this[ee[451]], ee[569], this[ee[451]][ee[570]], this[ee[460]]), this[ee[508]](this[ee[451]], ee[571], this[ee[451]][ee[570]], new Float32Array(this[ee[462]]), this[ee[451]][ee[572]]), this[ee[461]] = this[ee[508]](this[ee[451]], ee[568]), this[ee[508]](this[ee[451]], ee[569], this[ee[451]][ee[573]], this[ee[461]]), this[ee[508]](this[ee[451]], ee[571], this[ee[451]][ee[573]], new Uint16Array(this[ee[463]]), this[ee[451]][ee[572]]);
            }, be[ee[172]][ee[501]] = function() {
              this[ee[464]] = this[ee[508]](this[ee[451]], ee[501]), this[ee[508]](this[ee[451]], ee[574], this[ee[451]][ee[575]], this[ee[464]]), this[ee[508]](this[ee[451]], ee[576], this[ee[451]][ee[575]], this[ee[451]][ee[577]], this[ee[451]][ee[578]]), this[ee[508]](this[ee[451]], ee[576], this[ee[451]][ee[575]], this[ee[451]][ee[579]], this[ee[451]][ee[578]]), this[ee[508]](this[ee[451]], ee[576], this[ee[451]][ee[575]], this[ee[451]][ee[580]], this[ee[451]][ee[581]]), this[ee[508]](this[ee[451]], ee[576], this[ee[451]][ee[575]], this[ee[451]][ee[582]], this[ee[451]][ee[581]]);
            }, be[ee[172]][ee[583]] = function(pe, $e) {
              var ye, Se, we = this[ee[508]](this[ee[452]], ee[584], 0, 0, pe, $e);
              if (!we)
                return this[ee[320]][ee[156]](ee[585]), void (this[ee[479]] = !1);
              for (var Pe = this[ee[478]][ee[447]](), Te = this[ee[478]][ee[448]](), Ee = 0; Ee < Pe[ee[5]] && we[ee[586]][(Pe[Ee] - 1) * he + ge] > 0; Ee++)
                ye = Math[ee[147]](Pe[Ee], pe);
              for (var Me = 0; Me < Te[ee[5]] && we[ee[586]][(Te[Me] - 1) * this[ee[340]][ee[397]] * he + ge] > 0; Me++)
                Se = Math[ee[147]](Te[Me], $e);
              ye && Se && (ye !== pe || Se !== $e) ? (this[ee[320]][ee[156]](ee[587] + pe + ee[588] + $e + ee[589] + ye + ee[588] + Se + ee[590]), this[ee[508]](this[ee[452]], ee[591], this[ee[279]], 0, 0, ye, Se, 0, 0, this[ee[279]][ee[134]], this[ee[279]][ee[136]])) : this[ee[479]] = !1;
            }, be[ee[172]][ee[592]] = function() {
              if (!this[ee[283]] || this[ee[283]] === se[ee[454]][ee[453]]) {
                var pe = this[ee[340]][ee[397]], $e = this[ee[340]][ee[398]];
                if (this[ee[279]] && this[ee[452]]) {
                  var ye = 0;
                  this[ee[350]] !== fe[ee[407]][ee[593]] && /Trident/[ee[143]](navigator[ee[149]]) && (ye = $e * ce);
                  var Se = $e - 2 * ye;
                  this[ee[508]](this[ee[452]], ee[591], this[ee[340]][ee[594]](), 0, ye, pe, Se, 0, 0, this[ee[279]][ee[134]], this[ee[279]][ee[136]]), this[ee[478]][ee[449]](pe, $e);
                  var we = this[ee[476]] !== pe, Pe = this[ee[477]] !== $e;
                  !we && !Pe || /Trident/[ee[143]](navigator[ee[149]]) || (this[ee[479]] = !0), this[ee[479]] && this[ee[583]](pe, $e), this[ee[476]] = pe, this[ee[477]] = $e;
                }
                this[ee[508]](this[ee[451]], ee[595], this[ee[451]][ee[596]]), this[ee[508]](this[ee[451]], ee[574], this[ee[451]][ee[575]], this[ee[464]]);
                try {
                  var Te = this[ee[295]][ee[597]] !== null ? this[ee[295]][ee[597]]() : null;
                  Te !== null ? this[ee[508]](this[ee[451]], ee[598], this[ee[451]][ee[575]], 0, this[ee[451]][ee[599]], this[ee[451]][ee[599]], this[ee[451]][ee[600]], Te) : this[ee[279]] ? this[ee[508]](this[ee[451]], ee[598], this[ee[451]][ee[575]], 0, this[ee[451]][ee[599]], this[ee[451]][ee[599]], this[ee[451]][ee[600]], this[ee[279]]) : this[ee[508]](this[ee[451]], ee[598], this[ee[451]][ee[575]], 0, this[ee[451]][ee[599]], this[ee[451]][ee[599]], this[ee[451]][ee[600]], this[ee[340]][ee[594]]());
                } catch (Ee) {
                  this[ee[514]](Ee[ee[601]]);
                }
              }
            }, be[ee[172]][ee[602]] = function(pe, $e, ye) {
              this[ee[320]][ee[156]](ee[603] + pe[ee[604]](2) + ee[605] + (100 * ye)[ee[604]](2) + ee[606] + (100 * $e)[ee[604]](2) + ee[607]);
            }, be[ee[172]][ee[608]] = function(pe, $e) {
              if (!this[ee[283]] || this[ee[283]] === se[ee[454]][ee[453]]) {
                switch (this[ee[508]](this[ee[451]], ee[549], this[ee[459]]), this[ee[508]](this[ee[451]], ee[569], this[ee[451]][ee[570]], this[ee[460]]), this[ee[508]](this[ee[451]], ee[611], this[ee[550]][ee[612]], 2, this[ee[451]][ee[613]], !1, 0, 0), this[ee[508]](this[ee[451]], ee[595], this[ee[451]][ee[596]]), this[ee[508]](this[ee[451]], ee[574], this[ee[451]][ee[575]], this[ee[464]]), this[ee[552]][ee[609]](pe), this[ee[556]][ee[609]](0), this[ee[558]][ee[609]](this[ee[348]][ee[558]]), isFinite(this[ee[340]][ee[397]]) && this[ee[340]][ee[397]] > 0 && isFinite(this[ee[340]][ee[398]]) && this[ee[340]][ee[398]] > 0 ? (this[ee[397]][ee[609]](this[ee[340]][ee[397]]), this[ee[398]][ee[609]](this[ee[340]][ee[398]])) : (this[ee[397]][ee[609]](4096), this[ee[398]][ee[609]](2048)), this[ee[348]][ee[557]]) {
                  case le[ee[255]][ee[256]]:
                    this[ee[557]][ee[609]](0);
                    break;
                  case le[ee[255]][ee[260]]:
                    this[ee[557]][ee[609]](1);
                    break;
                  case le[ee[255]][ee[258]]:
                    this[ee[557]][ee[609]](2);
                    break;
                  default:
                    this[ee[514]](ee[610] + this[ee[348]][ee[557]] + ee[541]);
                }
                this[ee[562]][ee[609]](this[ee[471]]), this[ee[564]][ee[609]](this[ee[472]]), this[ee[565]][ee[609]](this[ee[473]][pe]), this[ee[567]][ee[609]](this[ee[474]]), this[ee[560]][ee[609]]($e), this[ee[508]](this[ee[451]], ee[614], this[ee[278]][ee[134]] / 2 * pe, 0, this[ee[278]][ee[134]] / this[ee[455]], this[ee[278]][ee[136]]), this[ee[508]](this[ee[451]], ee[569], this[ee[451]][ee[573]], this[ee[461]]), this[ee[508]](this[ee[451]], ee[615], this[ee[451]][ee[616]], 6, this[ee[451]][ee[617]], 0);
              }
            }, be[ee[172]][ee[482]] = function(pe) {
              return pe ? pe[ee[169]][ee[50]] : this[ee[469]];
            }, be[ee[172]][ee[483]] = function(pe) {
              var $e = this[ee[618]](pe), ye = ue[ee[178]][ee[210]](Math[ee[181]](ue[ee[178]][ee[180]](Math[ee[145]]($e[ee[188]], $e[ee[189]]))), Math[ee[181]](ue[ee[178]][ee[180]](Math[ee[145]]($e[ee[190]], $e[ee[191]]))));
              return ye * ye;
            }, be[ee[172]][ee[618]] = function(pe, $e) {
              var ye = $e || this[ee[470]][ee[484]];
              return ye === this[ee[470]][ee[484]] ? pe[ee[185]](!0) : ye === this[ee[470]][ee[486]] ? pe[ee[187]](!0) : null;
            }, be[ee[172]][ee[485]] = function(pe, $e) {
              var ye = this[ee[618]](pe, $e);
              return [Math[ee[181]](ue[ee[178]][ee[180]](ye[ee[188]])), Math[ee[181]](ue[ee[178]][ee[180]](ye[ee[190]]))];
            }, be[ee[172]][ee[487]] = function(pe) {
              var $e = this[ee[618]](pe);
              return [Math[ee[181]](ue[ee[178]][ee[180]]($e[ee[188]])) + Math[ee[181]](ue[ee[178]][ee[180]]($e[ee[189]])), Math[ee[181]](ue[ee[178]][ee[180]]($e[ee[191]])) + Math[ee[181]](ue[ee[178]][ee[180]]($e[ee[190]]))];
            }, be[ee[172]][ee[399]] = function() {
              var pe = 0;
              return this[ee[283]] === se[ee[454]][ee[453]] && (pe = (pe = (pe = (pe = (pe = pe || this[ee[451]][ee[619]]) || this[ee[451]][ee[620]]) || this[ee[451]][ee[621]]) || this[ee[451]][ee[622]]) || this[ee[451]][ee[623]]), pe = pe || 1;
            }, be[ee[172]][ee[418]] = function() {
              this[ee[456]] = !0, this[ee[455]] = 2;
            }, be[ee[172]][ee[419]] = function() {
              this[ee[456]] = !1, this[ee[455]] = 1;
            }, be[ee[172]][ee[307]] = function(pe, $e) {
              if ((!this[ee[283]] || this[ee[283]] === se[ee[454]][ee[453]]) && this[ee[451]] && this[ee[340]][ee[594]]()) {
                this[ee[488]][ee[624]](), this[ee[488]][ee[625]](), this[ee[488]][ee[626]]();
                try {
                  this[ee[488]][ee[627]](), $e && this[ee[592]](), this[ee[488]][ee[628]](), this[ee[608]](this[ee[470]][ee[484]], pe), this[ee[456]] && this[ee[608]](this[ee[470]][ee[486]], pe), this[ee[295]][ee[629]] !== null && this[ee[295]][ee[629]](this[ee[451]]), this[ee[502]]([se[ee[454]][ee[630]]]);
                } catch (ye) {
                  this[ee[320]][ee[513]](ee[631] + ye);
                }
                this[ee[488]][ee[632]]();
              }
            }, be[ee[172]][ee[335]] = function() {
              this[ee[488]][ee[633]](this), this[ee[488]][ee[335]](), this[ee[488]] = null, this[ee[478]] = null, this[ee[451]] = null, this[ee[278]] = null, this[ee[452]] = null, this[ee[279]] = null;
            }, be;
          }();
          ne[ee[389]] = me;
        }, 14912: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[443]] = void 0;
          var ue, _e = ae(27523), fe = ae(79248), le = function() {
            function se(oe, ce, he, ge, ve, me, be) {
              var pe = fe[ee[635]][ee[634]](he), $e = pe[0], ye = pe[1], Se = new _e[ee[277]](oe, ce, $e, ge, ve, me, be, ye);
              (ue = ue || new window[ee[637]]())[ee[636]](this, Se);
            }
            return se[ee[172]][ee[638]] = function() {
              return ue[ee[639]](this) && ee[267] !== ue[ee[640]](this)[ee[421]]();
            }, se[ee[172]][ee[417]] = function(oe) {
              var ce = ee[36] == typeof oe;
              return !(!this[ee[638]]() || !ce) && ue[ee[640]](this)[ee[417]](oe);
            }, se[ee[172]][ee[321]] = function() {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[321]]();
            }, se[ee[172]][ee[322]] = function() {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[322]]();
            }, se[ee[172]][ee[323]] = function() {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[323]]();
            }, se[ee[172]][ee[324]] = function() {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[324]]();
            }, se[ee[172]][ee[325]] = function() {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[325]]();
            }, se[ee[172]][ee[326]] = function() {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[326]]();
            }, se[ee[172]][ee[327]] = function() {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[327]]();
            }, se[ee[172]][ee[328]] = function() {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[328]]();
            }, se[ee[172]][ee[329]] = function() {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[329]]();
            }, se[ee[172]][ee[420]] = function() {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[420]]();
            }, se[ee[172]][ee[421]] = function() {
              return ue[ee[639]](this) ? ue[ee[640]](this)[ee[421]]() : null;
            }, se[ee[172]][ee[422]] = function() {
              return ue[ee[639]](this) ? ue[ee[640]](this)[ee[422]]() : null;
            }, se[ee[172]][ee[423]] = function() {
              return this[ee[638]]() ? ue[ee[640]](this)[ee[423]]() : { yaw: 0, pitch: 0, roll: 0 };
            }, se[ee[172]][ee[330]] = function(oe) {
              var ce = oe && isFinite(oe[ee[641]]) && isFinite(oe[ee[642]]) && isFinite(oe[ee[643]]);
              return !(!this[ee[638]]() || !ce) && ue[ee[640]](this)[ee[330]](oe);
            }, se[ee[172]][ee[424]] = function(oe) {
              var ce = isFinite(oe[ee[588]]) && isFinite(oe[ee[644]]) && isFinite(oe[ee[645]]);
              return !(!this[ee[638]]() || !ce) && ue[ee[640]](this)[ee[424]](oe);
            }, se[ee[172]][ee[425]] = function(oe) {
              var ce = isFinite(oe);
              return !(!this[ee[638]]() || !ce) && ue[ee[640]](this)[ee[425]](oe);
            }, se[ee[172]][ee[426]] = function() {
              return this[ee[638]]() ? ue[ee[640]](this)[ee[426]]() : -1;
            }, se[ee[172]][ee[427]] = function(oe) {
              var ce = isFinite(oe);
              return !(!this[ee[638]]() || !ce) && ue[ee[640]](this)[ee[427]](oe);
            }, se[ee[172]][ee[428]] = function() {
              return this[ee[638]]() ? ue[ee[640]](this)[ee[428]]() : -1;
            }, se[ee[172]][ee[429]] = function(oe) {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[429]](oe);
            }, se[ee[172]][ee[430]] = function() {
              return this[ee[638]]() ? ue[ee[640]](this)[ee[430]]() : -1;
            }, se[ee[172]][ee[431]] = function(oe) {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[431]](oe);
            }, se[ee[172]][ee[432]] = function() {
              return this[ee[638]]() ? ue[ee[640]](this)[ee[432]]() : -1;
            }, se[ee[172]][ee[433]] = function(oe) {
              return !!this[ee[638]]() && ue[ee[640]](this)[ee[433]](oe);
            }, se[ee[172]][ee[434]] = function() {
              return this[ee[638]]() ? ue[ee[640]](this)[ee[434]]() : -1;
            }, se[ee[172]][ee[435]] = function() {
              var oe, ce;
              return this[ee[638]]() && (ce = (oe = ue[ee[640]](this)) === null || oe === void 0 ? void 0 : oe[ee[435]]()) !== null && ce !== void 0 && ce;
            }, se[ee[172]][ee[437]] = function() {
              var oe, ce;
              return this[ee[638]]() && (ce = (oe = ue[ee[640]](this)) === null || oe === void 0 ? void 0 : oe[ee[437]]()) !== null && ce !== void 0 ? ce : Promise[ee[439]]();
            }, se;
          }();
          ne[ee[443]] = le;
        }, 46446: function(ie, ne, ae) {
          ee[0];
          var ue = this && this[ee[646]] || function() {
            var le = function(se, oe) {
              return le = Object[ee[647]] || { __proto__: [] } instanceof Array && function(ce, he) {
                ce[ee[648]] = he;
              } || function(ce, he) {
                for (var ge in he)
                  Object[ee[172]][ee[248]][ee[649]](he, ge) && (ce[ge] = he[ge]);
              }, le(se, oe);
            };
            return function(se, oe) {
              if (ee[509] != typeof oe && oe !== null)
                throw new TypeError(ee[650] + String(oe) + ee[651]);
              function ce() {
                this[ee[652]] = se;
              }
              le(se, oe), se[ee[172]] = oe === null ? Object[ee[216]](oe) : (ce[ee[172]] = oe[ee[172]], new ce());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[653]] = void 0;
          var _e = ae(34081), fe = function(le) {
            function se(oe, ce, he) {
              var ge = le[ee[649]](this, oe, ce) || this;
              return ge[ee[425]](he), ge[ee[655]] = new _e[ee[656]](), ge[ee[657]] = new _e[ee[656]](), ge[ee[658]] = 0, ge;
            }
            return ue(se, le), se[ee[172]][ee[659]] = function(oe) {
              return this[ee[658]] += oe, this[ee[658]] > this[ee[660]] ? this[ee[657]][ee[301]](0, 0, 0, !1, oe) : (_e[ee[656]][ee[661]](this[ee[655]], this[ee[657]]), this[ee[657]][ee[5]] = this[ee[655]][ee[5]] * oe, this[ee[657]][ee[645]] = this[ee[655]][ee[645]] * oe, this[ee[657]][ee[301]](this[ee[657]][ee[588]], this[ee[657]][ee[644]], this[ee[657]][ee[645]], !0, oe)), this[ee[657]];
            }, se[ee[172]][ee[662]] = function(oe) {
              this[ee[655]][ee[663]](oe, !0), this[ee[658]] = 0;
            }, se[ee[172]][ee[425]] = function(oe) {
              this[ee[660]] = oe;
            }, se[ee[172]][ee[664]] = function() {
              this[ee[493]]();
            }, se;
          }(ae(68978)[ee[654]]);
          ne[ee[653]] = fe;
        }, 68978: function(ie, ne) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[654]] = void 0;
          var ae = function() {
            function ue(_e, fe) {
              this[ee[348]] = _e, this[ee[295]] = fe;
            }
            return ue[ee[172]][ee[491]] = function() {
              this[ee[665]] = !0;
            }, ue[ee[172]][ee[493]] = function() {
              this[ee[665]] = !1;
            }, ue[ee[172]][ee[666]] = function() {
              return this[ee[665]];
            }, ue;
          }();
          ne[ee[654]] = ae;
        }, 86741: function(ie, ne, ae) {
          ee[0];
          var ue = this && this[ee[646]] || function() {
            var oe = function(ce, he) {
              return oe = Object[ee[647]] || { __proto__: [] } instanceof Array && function(ge, ve) {
                ge[ee[648]] = ve;
              } || function(ge, ve) {
                for (var me in ve)
                  Object[ee[172]][ee[248]][ee[649]](ve, me) && (ge[me] = ve[me]);
              }, oe(ce, he);
            };
            return function(ce, he) {
              if (ee[509] != typeof he && he !== null)
                throw new TypeError(ee[650] + String(he) + ee[651]);
              function ge() {
                this[ee[652]] = ce;
              }
              oe(ce, he), ce[ee[172]] = he === null ? Object[ee[216]](he) : (ge[ee[172]] = he[ee[172]], new ge());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[667]] = void 0;
          var _e = ae(34081), fe = ae(68978), le = function() {
            function oe(ce) {
              this[ee[668]](ce), this[ee[669]] = !1;
            }
            return oe[ee[172]][ee[670]] = function(ce) {
              return this[ee[672]][ee[671]](function(he) {
                return !he[ee[671]](function(ge) {
                  return ce[ee[167]](ge) < 0;
                });
              }) ? (this[ee[669]] = !0, !0) : (this[ee[669]] = !1, !1);
            }, oe[ee[172]][ee[673]] = function() {
              return this[ee[669]];
            }, oe[ee[172]][ee[668]] = function(ce) {
              for (var he = [], ge = 0, ve = ce; ge < ve[ee[5]]; ge++) {
                var me = ve[ge][ee[676]](ee[675])[ee[674]](function(be) {
                  return be[ee[5]] > 0;
                });
                me[ee[5]] > 0 && he[ee[241]](me);
              }
              this[ee[672]] = he;
            }, oe;
          }(), se = function(oe) {
            function ce(he, ge) {
              var ve = oe[ee[649]](this, he, ge) || this;
              return ve[ee[677]] = function(me) {
                if (me && ee[23] == typeof me[ee[678]]) {
                  var be = me[ee[678]][ee[525]](ee[675], ee[679]), pe = ve[ee[680]][ee[167]](be);
                  pe >= 0 && ee[681] === me[ee[152]] ? ve[ee[680]][ee[682]](pe, 1) : pe < 0 && ee[683] === me[ee[152]] && ve[ee[680]][ee[241]](be), ve[ee[684]][ee[670]](ve[ee[680]]), ve[ee[685]][ee[670]](ve[ee[680]]), ve[ee[686]][ee[670]](ve[ee[680]]), ve[ee[687]][ee[670]](ve[ee[680]]), ve[ee[688]][ee[670]](ve[ee[680]]), ve[ee[689]][ee[670]](ve[ee[680]]);
                }
              }, ve[ee[690]] = ve[ee[348]][ee[691]], ve[ee[684]] = new le([ee[692]]), ve[ee[685]] = new le([ee[693]]), ve[ee[686]] = new le([ee[694]]), ve[ee[687]] = new le([ee[695]]), ve[ee[688]] = new le([ee[696]]), ve[ee[689]] = new le([ee[697]]), ve[ee[680]] = [], ve[ee[698]] = new _e[ee[656]](), ve[ee[700]](ve[ee[348]][ee[699]]), ve[ee[491]](), ve;
            }
            return ue(ce, oe), ce[ee[172]][ee[659]] = function(he) {
              if (this[ee[665]]) {
                var ge = 0, ve = 0, me = 0;
                this[ee[295]][ee[701]] ? (ve += this[ee[295]][ee[701]](ee[684]) ? this[ee[690]] * he : 0, ve -= this[ee[295]][ee[701]](ee[685]) ? this[ee[690]] * he : 0, ge += this[ee[295]][ee[701]](ee[686]) ? this[ee[690]] * he : 0, ge -= this[ee[295]][ee[701]](ee[687]) ? this[ee[690]] * he : 0, me -= this[ee[295]][ee[701]](ee[688]) ? this[ee[690]] * he : 0, me += this[ee[295]][ee[701]](ee[689]) ? this[ee[690]] * he : 0) : (ve += this[ee[684]][ee[673]]() ? this[ee[690]] * he : 0, ve -= this[ee[685]][ee[673]]() ? this[ee[690]] * he : 0, ge += this[ee[686]][ee[673]]() ? this[ee[690]] * he : 0, ge -= this[ee[687]][ee[673]]() ? this[ee[690]] * he : 0, me -= this[ee[688]][ee[673]]() ? this[ee[690]] * he : 0, me += this[ee[689]][ee[673]]() ? this[ee[690]] * he : 0);
                var be = ge !== 0 || ve !== 0 || me !== 0;
                this[ee[698]][ee[301]](ge, ve, me, be, he);
              } else
                this[ee[698]][ee[301]](0, 0, 0, !1, he);
              return this[ee[698]];
            }, ce[ee[172]][ee[491]] = function() {
              this[ee[665]] = !0, document[ee[334]](ee[683], this[ee[677]], !1), document[ee[334]](ee[681], this[ee[677]], !1);
            }, ce[ee[172]][ee[493]] = function() {
              this[ee[665]] = !1, document[ee[310]](ee[683], this[ee[677]], !1), document[ee[310]](ee[681], this[ee[677]], !1);
            }, ce[ee[172]][ee[664]] = function() {
              this[ee[493]]();
            }, ce[ee[172]][ee[700]] = function(he) {
              he[ee[248]](ee[684]) && this[ee[684]][ee[668]](he[ee[684]]), he[ee[248]](ee[685]) && this[ee[685]][ee[668]](he[ee[685]]), he[ee[248]](ee[686]) && this[ee[686]][ee[668]](he[ee[686]]), he[ee[248]](ee[687]) && this[ee[687]][ee[668]](he[ee[687]]), he[ee[248]](ee[688]) && this[ee[688]][ee[668]](he[ee[688]]), he[ee[248]](ee[689]) && this[ee[689]][ee[668]](he[ee[689]]);
            }, ce;
          }(fe[ee[654]]);
          ne[ee[667]] = se;
        }, 41775: function(ie, ne, ae) {
          ee[0];
          var ue = this && this[ee[646]] || function() {
            var se = function(oe, ce) {
              return se = Object[ee[647]] || { __proto__: [] } instanceof Array && function(he, ge) {
                he[ee[648]] = ge;
              } || function(he, ge) {
                for (var ve in ge)
                  Object[ee[172]][ee[248]][ee[649]](ge, ve) && (he[ve] = ge[ve]);
              }, se(oe, ce);
            };
            return function(oe, ce) {
              if (ee[509] != typeof ce && ce !== null)
                throw new TypeError(ee[650] + String(ce) + ee[651]);
              function he() {
                this[ee[652]] = oe;
              }
              se(oe, ce), oe[ee[172]] = ce === null ? Object[ee[216]](ce) : (he[ee[172]] = ce[ee[172]], new he());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[702]] = void 0;
          var _e = ae(34081), fe = ae(12553), le = function(se) {
            function oe(ce, he, ge, ve, me) {
              me === void 0 && (me = 90);
              var be = se[ee[649]](this, ce, he) || this;
              return be[ee[703]] = function(pe) {
                var $e = oe[ee[704]](pe), ye = 0, Se = 0;
                be[ee[705]] && (ye = $e[ee[588]] - be[ee[706]][ee[588]], Se = $e[ee[644]] - be[ee[706]][ee[644]], be[ee[707]][ee[588]] += ye, be[ee[707]][ee[644]] += Se, be[ee[706]] = $e), Math[ee[202]](ye) + Math[ee[202]](Se) > 0 && (be[ee[708]] = !0), pe[ee[709]]();
              }, be[ee[710]] = function(pe) {
                pe[ee[711]](), pe[ee[709]](), fe[ee[713]][ee[310]](document, [ee[712]], be[ee[710]], !0);
              }, be[ee[714]] = function(pe) {
                fe[ee[713]][ee[310]](document, fe[ee[713]][ee[716]][ee[715]], be[ee[703]], !1), fe[ee[713]][ee[310]](document, fe[ee[713]][ee[716]][ee[684]], be[ee[714]], !1), fe[ee[713]][ee[310]](be[ee[345]], fe[ee[713]][ee[716]][ee[684]], be[ee[714]], !1), fe[ee[713]][ee[719]](document[ee[717]], ee[718]), be[ee[706]] = null, be[ee[705]] = !1, be[ee[708]] && be[ee[720]] && pe[ee[721]] === be[ee[720]] && fe[ee[713]][ee[334]](document, [ee[712]], be[ee[710]], !0), be[ee[708]] = !1, be[ee[720]] = null;
              }, be[ee[722]] = function(pe) {
                be[ee[706]] = oe[ee[704]](pe), be[ee[707]] = { x: 0, y: 0 }, be[ee[705]] = !0, be[ee[708]] = !1, be[ee[720]] = pe[ee[721]], fe[ee[713]][ee[334]](document, fe[ee[713]][ee[716]][ee[715]], be[ee[703]], !1), fe[ee[713]][ee[334]](document, fe[ee[713]][ee[716]][ee[684]], be[ee[714]], !1), fe[ee[713]][ee[334]](be[ee[345]], fe[ee[713]][ee[716]][ee[684]], be[ee[714]], !1), fe[ee[713]][ee[723]](document[ee[717]], ee[718]);
              }, be[ee[345]] = ge, be[ee[278]] = ve, be[ee[705]] = !1, be[ee[706]] = null, be[ee[707]] = { x: 0, y: 0 }, be[ee[724]] = me, be[ee[698]] = new _e[ee[656]](), be[ee[491]](), be;
            }
            return ue(oe, se), oe[ee[172]][ee[659]] = function(ce) {
              var he = this[ee[278]][ee[393]], ge = this[ee[278]][ee[394]], ve = !!this[ee[295]][ee[725]], me = this[ee[724]] * (ge / he);
              if (this[ee[707]] = ve ? this[ee[295]][ee[725]](ce) : this[ee[707]], this[ee[665]] && isFinite(me) && me > 0) {
                var be = this[ee[705]] || this[ee[707]][ee[588]] !== 0 || this[ee[707]][ee[644]] !== 0;
                this[ee[698]][ee[301]](this[ee[707]][ee[588]] / this[ee[278]][ee[393]] * this[ee[724]], this[ee[707]][ee[644]] / this[ee[278]][ee[394]] * me, 0, be, ce), this[ee[707]] = { x: 0, y: 0 };
              } else
                this[ee[698]][ee[301]](0, 0, 0, this[ee[705]], ce);
              return this[ee[698]];
            }, oe[ee[172]][ee[491]] = function() {
              this[ee[665]] = !0, fe[ee[713]][ee[334]](this[ee[345]], fe[ee[713]][ee[716]][ee[685]], this[ee[722]], !1);
            }, oe[ee[172]][ee[493]] = function() {
              this[ee[665]] = !1, fe[ee[713]][ee[310]](document, fe[ee[713]][ee[716]][ee[715]], this[ee[703]], !1), fe[ee[713]][ee[310]](document, fe[ee[713]][ee[716]][ee[684]], this[ee[714]], !1), fe[ee[713]][ee[310]](this[ee[345]], fe[ee[713]][ee[716]][ee[684]], this[ee[714]], !1), fe[ee[713]][ee[310]](this[ee[345]], fe[ee[713]][ee[716]][ee[685]], this[ee[722]], !1), fe[ee[713]][ee[310]](document, [ee[712]], this[ee[710]], !0), this[ee[706]] = null, this[ee[705]] = !1, this[ee[708]] = !1, this[ee[720]] = null, fe[ee[713]][ee[719]](document[ee[717]], ee[718]);
            }, oe[ee[172]][ee[664]] = function() {
              this[ee[493]](), this[ee[345]] = null, this[ee[278]] = null;
            }, oe[ee[704]] = function(ce) {
              var he = { x: 0, y: 0 };
              return ee[726] === fe[ee[713]][ee[716]][ee[152]] ? (he[ee[588]] = ce[ee[727]] || ce[ee[729]][ee[728]], he[ee[644]] = ce[ee[730]] || ce[ee[729]][ee[731]]) : ee[732] === fe[ee[713]][ee[716]][ee[152]] ? (he[ee[588]] = ce[ee[733]][0][ee[727]], he[ee[644]] = ce[ee[733]][0][ee[730]]) : (he[ee[588]] = ce[ee[727]], he[ee[644]] = ce[ee[730]]), he[ee[588]] = he[ee[588]] || 0, he[ee[644]] = he[ee[644]] || 0, he;
            }, oe;
          }(ae(68978)[ee[654]]);
          ne[ee[702]] = le;
        }, 10755: function(ie, ne) {
          ee[0];
          var ae, ue, _e = this && this[ee[646]] || function() {
            var oe = function(ce, he) {
              return oe = Object[ee[647]] || { __proto__: [] } instanceof Array && function(ge, ve) {
                ge[ee[648]] = ve;
              } || function(ge, ve) {
                for (var me in ve)
                  Object[ee[172]][ee[248]][ee[649]](ve, me) && (ge[me] = ve[me]);
              }, oe(ce, he);
            };
            return function(ce, he) {
              if (ee[509] != typeof he && he !== null)
                throw new TypeError(ee[650] + String(he) + ee[651]);
              function ge() {
                this[ee[652]] = ce;
              }
              oe(ce, he), ce[ee[172]] = he === null ? Object[ee[216]](he) : (ge[ee[172]] = he[ee[172]], new ge());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[555]] = ne[ee[551]] = ne[ee[554]] = ne[ee[507]] = ne[ee[454]] = void 0, function(oe) {
            oe[oe[ee[453]] = 0] = ee[453], oe[oe[ee[515]] = 1] = ee[515], oe[oe[ee[734]] = 1280] = ee[734], oe[oe[ee[735]] = 1286] = ee[735], oe[oe[ee[736]] = 1282] = ee[736], oe[oe[ee[630]] = 1281] = ee[630];
          }(ae || (ne[ee[454]] = ae = {})), ne[ee[507]] = { 1280: ee[734], 1286: ee[735], 1282: ee[736], 1281: ee[630] }, function(oe) {
            oe[ee[553]] = ee[737], oe[ee[559]] = ee[738], oe[ee[561]] = ee[739], oe[ee[563]] = ee[740], oe[ee[566]] = ee[741];
          }(ue || (ne[ee[554]] = ue = {}));
          var fe = function() {
            function oe(ce, he, ge, ve) {
              this[ee[742]] = ce, this[ee[459]] = he, this[ee[250]] = ge, this[ee[152]] = ve;
            }
            return Object[ee[2]](oe[ee[172]], ee[612], { get: function() {
              return this[ee[743]];
            }, enumerable: !1, configurable: !0 }), oe;
          }(), le = function(oe) {
            function ce(he, ge, ve, me) {
              var be = oe[ee[649]](this, he, ge, ve, me) || this;
              return be[ee[743]] = be[ee[742]][ee[744]](be[ee[459]], be[ee[250]]), be[ee[742]][ee[745]](be[ee[250]]), be;
            }
            return _e(ce, oe), ce[ee[172]][ee[609]] = function(he) {
            }, ce;
          }(fe);
          ne[ee[551]] = le;
          var se = function(oe) {
            function ce(he, ge, ve, me) {
              var be = oe[ee[649]](this, he, ge, ve, me) || this;
              return be[ee[743]] = be[ee[742]][ee[746]](be[ee[459]], be[ee[250]]), be[ee[742]][ee[745]](be[ee[250]]), be;
            }
            return _e(ce, oe), ce[ee[172]][ee[609]] = function(he) {
              this[ee[152]][ee[167]](ee[747]) > -1 ? this[ee[742]][this[ee[152]]][ee[649]](this[ee[742]], this[ee[743]], !1, he) : this[ee[742]][this[ee[152]]][ee[649]](this[ee[742]], this[ee[743]], he);
            }, ce;
          }(fe);
          ne[ee[555]] = se;
        }, 5431: function(ie, ne, ae) {
          ee[0];
          var ue = this && this[ee[646]] || function() {
            var oe = function(ce, he) {
              return oe = Object[ee[647]] || { __proto__: [] } instanceof Array && function(ge, ve) {
                ge[ee[648]] = ve;
              } || function(ge, ve) {
                for (var me in ve)
                  Object[ee[172]][ee[248]][ee[649]](ve, me) && (ge[me] = ve[me]);
              }, oe(ce, he);
            };
            return function(ce, he) {
              if (ee[509] != typeof he && he !== null)
                throw new TypeError(ee[650] + String(he) + ee[651]);
              function ge() {
                this[ee[652]] = ce;
              }
              oe(ce, he), ce[ee[172]] = he === null ? Object[ee[216]](he) : (ge[ee[172]] = he[ee[172]], new ge());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[748]] = void 0;
          var _e, fe = ae(83549), le = ae(93056);
          (function(oe) {
            oe[ee[749]] = ee[750], oe[ee[751]] = ee[752];
          })(_e || (_e = {}));
          var se = function(oe) {
            function ce() {
              var he = oe[ee[649]](this) || this;
              he[ee[754]] = null, he[ee[755]] = null, he[ee[756]] = null, he[ee[757]] = 0, he[ee[758]] = 0, he[ee[759]] = function(ve) {
                var me = ve[ee[760]] !== void 0 && ve[ee[760]] !== null, be = ve[ee[761]] !== void 0 && ve[ee[761]] !== null, pe = ve[ee[762]] !== void 0 && ve[ee[762]] !== null;
                me && be && pe && (he[ee[754]] = ve[ee[760]], he[ee[755]] = ve[ee[762]], he[ee[756]] = ve[ee[761]]), ve[ee[248]](ee[757]) && (he[ee[757]] = he[ee[763]](ve));
              }, he[ee[764]] = function() {
                he[ee[759]](ce[ee[765]]());
              }, he[ee[766]] = function(ve) {
                ve && ve[ee[586]] && he[ee[759]](ve[ee[586]]);
              }, window[ee[32]] !== window ? window[ee[334]](ee[601], he[ee[766]], !1) : window[ee[334]](ee[767], he[ee[759]]);
              try {
                window[ee[334]](ee[768], he[ee[764]]);
                var ge = ce[ee[765]]();
                he[ee[759]](ge);
              } catch {
                window[ee[310]](ee[768], he[ee[764]]);
              }
              return he[ee[491]](), he;
            }
            return ue(ce, oe), ce[ee[172]][ee[769]] = function() {
              if (!this[ee[770]]() || !this[ee[665]])
                return this[ee[771]];
              var he = fe[ee[178]][ee[180]](this[ee[754]]) / 2, ge = fe[ee[178]][ee[180]](this[ee[756]]) / 2, ve = fe[ee[178]][ee[180]](this[ee[755]]) / 2, me = Math[ee[221]](ge), be = Math[ee[221]](ve), pe = Math[ee[221]](he), $e = Math[ee[220]](ge), ye = Math[ee[220]](ve), Se = Math[ee[220]](he), we = me * be * pe - $e * ye * Se, Pe = $e * be * pe - me * ye * Se, Te = me * ye * pe + $e * be * Se, Ee = me * be * Se + $e * ye * pe, Me = fe[ee[206]][ee[225]](Pe, Te, Ee, we), Ae = fe[ee[178]][ee[180]](this[ee[772]]()) / 2, Ne = fe[ee[206]][ee[225]](0, 0, -Math[ee[220]](Ae), Math[ee[221]](Ae)), Ce = fe[ee[206]][ee[216]]();
              fe[ee[206]][ee[222]](Ce, Me, Ne);
              var Ie = Math[ee[211]](0.5);
              return fe[ee[206]][ee[222]](Ce, fe[ee[206]][ee[225]](-Ie, 0, 0, Ie), Ce), fe[ee[206]][ee[226]](Ce);
            }, ce[ee[172]][ee[770]] = function() {
              return this[ee[754]] !== null;
            }, ce[ee[773]] = function() {
              return !!window[ee[774]];
            }, ce[ee[172]][ee[772]] = function() {
              return this[ee[757]];
            }, ce[ee[172]][ee[763]] = function(he) {
              var ge;
              switch (he[ee[757]][ee[152]]) {
                case ee[775]:
                  ge = 90;
                  break;
                case ee[776]:
                  ge = -90;
                  break;
                case ee[777]:
                  ge = 180;
                  break;
                case ee[778]:
                  ge = 0;
              }
              return !ge && isNaN(ge) && (ge = isNaN(he[ee[757]][ee[152]]) ? he[ee[779]] || 0 : he[ee[757]][ee[152]]), window[ee[32]] !== window && ge === this[ee[758]] && he[ee[779]] !== ge && (ge = he[ee[779]] || 0), ge;
            }, ce[ee[765]] = function() {
              var he = window[ee[144]], ge = he[ee[779]] || he[ee[780]] || he[ee[781]] || {};
              return { screenOrientation: { type: ge[ee[152]] || ge, angle: ge[ee[782]] }, orientation: window[ee[779]] };
            }, ce[ee[172]][ee[436]] = function() {
              return ee[217] != typeof DeviceMotionEvent && ee[509] == typeof DeviceMotionEvent[ee[438]];
            }, ce[ee[172]][ee[438]] = function() {
              return ee[217] == typeof DeviceMotionEvent || ee[509] != typeof DeviceMotionEvent[ee[438]] ? Promise[ee[439]]() : DeviceMotionEvent[ee[438]]()[ee[784]](function(he) {
                return he === _e[ee[749]] ? Promise[ee[439]]() : Promise[ee[783]]();
              });
            }, ce;
          }(le[ee[753]]);
          ne[ee[748]] = se;
        }, 93056: function(ie, ne) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[753]] = void 0;
          var ae = function() {
            function ue() {
              this[ee[785]] = { upDegrees: 45, rightDegrees: 55, downDegrees: 45, leftDegrees: 55 }, this[ee[771]] = { yaw: 0, pitch: 0, roll: 0 };
            }
            return ue[ee[172]][ee[786]] = function() {
              return this[ee[785]];
            }, ue[ee[773]] = function() {
              return !1;
            }, ue[ee[172]][ee[491]] = function() {
              this[ee[665]] = !0;
            }, ue[ee[172]][ee[493]] = function() {
              this[ee[665]] = !1;
            }, ue[ee[172]][ee[666]] = function() {
              return this[ee[665]];
            }, ue[ee[172]][ee[436]] = function() {
              return !1;
            }, ue[ee[172]][ee[438]] = function() {
              return Promise[ee[439]]();
            }, ue;
          }();
          ne[ee[753]] = ae;
        }, 68856: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[787]] = void 0;
          var ue = ae(5431), _e = ae(14985), fe = ae(62886), le = function() {
            function se() {
            }
            return se[ee[640]] = function() {
              return fe[ee[788]][ee[773]]() ? new fe[ee[788]]() : ue[ee[748]][ee[773]]() ? new ue[ee[748]]() : new _e[ee[789]]();
            }, se;
          }();
          ne[ee[787]] = le;
        }, 34081: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[656]] = void 0;
          var ue = ae(70016), _e = Math[ee[209]] / 180, fe = 180 / Math[ee[209]], le = function() {
            function se(oe, ce, he, ge) {
              oe === void 0 && (oe = 0), ce === void 0 && (ce = 0), he === void 0 && (he = 0), ge === void 0 && (ge = !1), this[ee[790]] = null, this[ee[301]](oe, ce, he, ge);
            }
            return Object[ee[2]](se[ee[172]], ee[588], { get: function() {
              return this[ee[791]];
            }, set: function(oe) {
              this[ee[791]] !== oe && this[ee[301]](oe, this[ee[792]], this[ee[793]]);
            }, enumerable: !1, configurable: !0 }), Object[ee[2]](se[ee[172]], ee[644], { get: function() {
              return this[ee[792]];
            }, set: function(oe) {
              this[ee[792]] !== oe && this[ee[301]](this[ee[791]], oe, this[ee[793]]);
            }, enumerable: !1, configurable: !0 }), Object[ee[2]](se[ee[172]], ee[645], { get: function() {
              return this[ee[793]];
            }, set: function(oe) {
              this[ee[793]] !== oe && this[ee[301]](this[ee[791]], this[ee[792]], oe);
            }, enumerable: !1, configurable: !0 }), Object[ee[2]](se[ee[172]], ee[760], { get: function() {
              return this[ee[794]];
            }, set: function(oe) {
              this[ee[794]] !== oe && this[ee[301]](this[ee[795]] * Math[ee[221]](oe * _e), this[ee[795]] * Math[ee[220]](oe * _e), this[ee[793]]);
            }, enumerable: !1, configurable: !0 }), Object[ee[2]](se[ee[172]], ee[5], { get: function() {
              return this[ee[795]];
            }, set: function(oe) {
              this[ee[795]] !== oe && this[ee[301]](oe * Math[ee[221]](this[ee[794]] * _e), oe * Math[ee[220]](this[ee[794]] * _e), this[ee[793]]);
            }, enumerable: !1, configurable: !0 }), Object[ee[2]](se[ee[172]], ee[669], { get: function() {
              return this[ee[673]];
            }, enumerable: !1, configurable: !0 }), Object[ee[2]](se[ee[172]], ee[796], { get: function() {
              return this[ee[790]] || 0;
            }, set: function(oe) {
              this[ee[790]] = oe;
            }, enumerable: !1, configurable: !0 }), se[ee[172]][ee[301]] = function(oe, ce, he, ge, ve) {
              if (he === void 0 && (he = 0), ee[36] == typeof ge && (this[ee[673]] = ge), (0, ue[ee[797]])(ve) && (this[ee[790]] = ve), this[ee[791]] !== oe || this[ee[792]] !== ce || this[ee[793]] !== he) {
                if (this[ee[791]] = Math[ee[202]](oe) < 1e-4 ? 0 : oe, this[ee[792]] = Math[ee[202]](ce) < 1e-4 ? 0 : ce, this[ee[793]] = Math[ee[202]](he) < 1e-4 ? 0 : he, this[ee[791]] === 0 && this[ee[792]] === 0 && this[ee[793]] === 0)
                  return this[ee[795]] = 0, void (this[ee[794]] = 0);
                this[ee[795]] = Math[ee[211]](this[ee[791]] * this[ee[791]] + this[ee[792]] * this[ee[792]]), this[ee[792]] === 0 && this[ee[791]] >= 0 ? this[ee[794]] = 0 : this[ee[791]] === 0 && this[ee[792]] > 0 ? this[ee[794]] = 90 : this[ee[791]] === 0 && this[ee[792]] < 0 ? this[ee[794]] = 270 : this[ee[791]] < 0 && this[ee[792]] === 0 ? this[ee[794]] = 180 : this[ee[791]] > 0 && this[ee[792]] > 0 ? this[ee[794]] = Math[ee[176]](this[ee[792]] / this[ee[791]]) * fe : this[ee[791]] < 0 && this[ee[792]] > 0 || this[ee[791]] < 0 && this[ee[792]] < 0 ? this[ee[794]] = 180 + Math[ee[176]](this[ee[792]] / this[ee[791]]) * fe : this[ee[791]] > 0 && this[ee[792]] < 0 ? this[ee[794]] = 360 + Math[ee[176]](this[ee[792]] / this[ee[791]]) * fe : this[ee[794]] = 0;
              }
            }, se[ee[172]][ee[663]] = function(oe, ce, he) {
              this[ee[301]](oe[ee[588]], oe[ee[644]], oe[ee[645]], ce, he);
            }, se[ee[172]][ee[449]] = function() {
              for (var oe = [], ce = 0; ce < arguments[ee[5]]; ce++)
                oe[ce] = arguments[ce];
              for (var he = this[ee[791]], ge = this[ee[792]], ve = this[ee[793]], me = 0, be = oe; me < be[ee[5]]; me++) {
                var pe = be[me];
                he += pe[ee[791]], ge += pe[ee[792]], ve += pe[ee[793]];
              }
              this[ee[301]](he, ge, ve);
            }, se[ee[172]][ee[798]] = function(oe, ce) {
              ce instanceof se ? this[ee[301]](ce[ee[588]] - oe[ee[588]], ce[ee[644]] - oe[ee[644]], ce[ee[645]] - oe[ee[645]]) : this[ee[301]](oe[ee[588]] - this[ee[791]], oe[ee[644]] - this[ee[792]], oe[ee[645]] - this[ee[793]]);
            }, se[ee[661]] = function(oe, ce) {
              oe instanceof se && ce instanceof se && ce[ee[301]](oe[ee[791]], oe[ee[792]], oe[ee[793]], oe[ee[673]], oe[ee[790]]);
            }, se[ee[172]][ee[799]] = function(oe) {
              this[ee[5]] = this[ee[795]] * oe;
            }, se;
          }();
          ne[ee[656]] = le;
        }, 14985: function(ie, ne, ae) {
          ee[0];
          var ue = this && this[ee[646]] || function() {
            var fe = function(le, se) {
              return fe = Object[ee[647]] || { __proto__: [] } instanceof Array && function(oe, ce) {
                oe[ee[648]] = ce;
              } || function(oe, ce) {
                for (var he in ce)
                  Object[ee[172]][ee[248]][ee[649]](ce, he) && (oe[he] = ce[he]);
              }, fe(le, se);
            };
            return function(le, se) {
              if (ee[509] != typeof se && se !== null)
                throw new TypeError(ee[650] + String(se) + ee[651]);
              function oe() {
                this[ee[652]] = le;
              }
              fe(le, se), le[ee[172]] = se === null ? Object[ee[216]](se) : (oe[ee[172]] = se[ee[172]], new oe());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[789]] = void 0;
          var _e = function(fe) {
            function le() {
              var se = fe[ee[649]](this) || this;
              return se[ee[491]](), se;
            }
            return ue(le, fe), le[ee[172]][ee[769]] = function() {
              return this[ee[771]];
            }, le[ee[172]][ee[770]] = function() {
              return !0;
            }, le[ee[773]] = function() {
              return !0;
            }, le;
          }(ae(93056)[ee[753]]);
          ne[ee[789]] = _e;
        }, 33083: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[388]] = void 0;
          var ue, _e = ae(83549), fe = ae(62510), le = ae(46446), se = ae(86741), oe = ae(41775), ce = ae(7716), he = ae(68856), ge = ae(34081);
          (function(me) {
            me[ee[800]] = ee[801], me[ee[802]] = ee[803], me[ee[804]] = ee[804];
          })(ue || (ue = {}));
          var ve = function() {
            function me(be, pe, $e, ye, Se) {
              var we = this;
              this[ee[560]] = null, this[ee[805]] = null, this[ee[455]] = 1, this[ee[806]] = null, this[ee[807]] = null, this[ee[808]] = null, this[ee[809]] = null, this[ee[810]] = null, this[ee[811]] = null, this[ee[812]] = null, this[ee[321]] = function() {
                we[ee[813]][ee[491]]();
              }, this[ee[322]] = function() {
                we[ee[813]][ee[493]]();
              }, this[ee[323]] = function() {
                return we[ee[813]][ee[666]]();
              }, this[ee[324]] = function() {
                we[ee[814]][ee[491]]();
              }, this[ee[325]] = function() {
                we[ee[814]][ee[493]]();
              }, this[ee[326]] = function() {
                return we[ee[814]][ee[666]]();
              }, this[ee[327]] = function() {
                we[ee[815]][ee[491]]();
              }, this[ee[328]] = function() {
                we[ee[815]][ee[493]]();
              }, this[ee[329]] = function() {
                return we[ee[815]][ee[666]]();
              }, this[ee[278]] = be, this[ee[348]] = $e, this[ee[300]] = Se, this[ee[813]] = he[ee[787]][ee[640]](), this[ee[809]] = _e[ee[208]][ee[216]](), this[ee[810]] = _e[ee[208]][ee[216]](), this[ee[811]] = _e[ee[208]][ee[216]](), this[ee[806]] = _e[ee[208]][ee[216]](), this[ee[560]] = _e[ee[208]][ee[216]](), this[ee[455]] = this[ee[348]][ee[284]] ? 2 : 1, this[ee[808]] = { yaw: 0, pitch: 0, roll: 0 }, this[ee[808]][ee[641]] = this[ee[348]][ee[816]], this[ee[657]] = new ge[ee[656]](), this[ee[817]] = new ge[ee[656]](), this[ee[807]] = { yaw: this[ee[808]][ee[641]], pitch: 0, roll: 0 }, this[ee[660]] = this[ee[348]][ee[660]], this[ee[818]] = this[ee[348]][ee[818]], this[ee[819]] = this[ee[348]][ee[819]], this[ee[820]] = this[ee[348]][ee[820]], this[ee[821]] = this[ee[819]] > -1, this[ee[822]] = this[ee[820]] > -1, this[ee[823]] = 1, this[ee[824]] = 0, this[ee[825]] = !1, this[ee[815]] = new se[ee[667]](this[ee[348]][ee[815]], ye), this[ee[814]] = new oe[ee[702]](this[ee[348]][ee[814]], ye, pe, this[ee[278]]), this[ee[826]] = new le[ee[653]](this[ee[348]][ee[826]], ye, this[ee[660]]), this[ee[827]] = ce[ee[828]][ee[640]](this[ee[348]][ee[815]]), this[ee[829]] = ce[ee[828]][ee[640]](this[ee[348]][ee[814]]), this[ee[830]] = ce[ee[828]][ee[640]](this[ee[348]][ee[826]]), this[ee[819]] > -1 && this[ee[820]] > -1 ? this[ee[831]] = ue[ee[804]] : this[ee[820]] > -1 ? this[ee[831]] = ue[ee[802]] : this[ee[831]] = ue[ee[800]];
            }
            return me[ee[832]] = function(be, pe, $e) {
              return pe === 0 && $e === 360 ? be % 360 : be > $e ? $e : be < pe ? pe : be;
            }, me[ee[833]] = function(be, pe) {
              var $e = { yaw: 0, pitch: 0, roll: be[ee[643]] };
              return $e[ee[641]] = me[ee[832]](be[ee[641]], pe[ee[834]], pe[ee[835]]), $e[ee[642]] = me[ee[832]](be[ee[642]], pe[ee[836]], pe[ee[837]]), $e;
            }, me[ee[172]][ee[838]] = function(be) {
              be === void 0 && (be = { yaw: 0, pitch: 0, roll: 0 }), this[ee[812]] !== null && (this[ee[812]] = me[ee[833]](this[ee[812]], this[ee[348]][ee[839]]), this[ee[808]][ee[641]] = this[ee[812]][ee[641]] - be[ee[641]], this[ee[808]][ee[642]] = this[ee[812]][ee[642]] - be[ee[642]], this[ee[808]][ee[643]] = this[ee[812]][ee[643]] - be[ee[643]], this[ee[829]][ee[840]](), this[ee[827]][ee[840]](), this[ee[830]][ee[840]]()), this[ee[812]] = null, this[ee[807]][ee[641]] = this[ee[808]][ee[641]] + be[ee[641]], this[ee[807]][ee[642]] = this[ee[808]][ee[642]] + be[ee[642]], this[ee[807]][ee[643]] = this[ee[808]][ee[643]] + be[ee[643]], this[ee[807]] = me[ee[833]](this[ee[807]], this[ee[348]][ee[839]]), _e[ee[208]][ee[218]](this[ee[806]]), _e[ee[208]][ee[219]](this[ee[806]], _e[ee[178]][ee[180]](this[ee[807]][ee[641]] + 180), [0, 1, 0]), _e[ee[208]][ee[219]](this[ee[806]], _e[ee[178]][ee[180]](this[ee[807]][ee[642]]), [1, 0, 0]), _e[ee[208]][ee[219]](this[ee[806]], _e[ee[178]][ee[180]](this[ee[807]][ee[643]]), [0, 0, 1]);
            }, me[ee[172]][ee[306]] = function() {
              return this[ee[560]];
            }, me[ee[172]][ee[423]] = function() {
              return this[ee[807]];
            }, me[ee[172]][ee[330]] = function(be) {
              this[ee[812]] = be;
            }, me[ee[172]][ee[429]] = function(be) {
              this[ee[821]] = be !== -1, this[ee[819]] = be === -1 ? -1 : Math[ee[145]](Math[ee[147]](180, be), 0), be === -1 && this[ee[831]] === ue[ee[804]] ? this[ee[831]] = ue[ee[802]] : this[ee[831]] === ue[ee[802]] && (this[ee[822]] ? this[ee[831]] = ue[ee[804]] : this[ee[831]] = ue[ee[800]]);
            }, me[ee[172]][ee[430]] = function() {
              return this[ee[819]] / this[ee[823]];
            }, me[ee[172]][ee[431]] = function(be) {
              this[ee[822]] = be !== -1, this[ee[820]] = be === -1 ? -1 : Math[ee[145]](Math[ee[147]](180, be), 0), be === -1 && this[ee[831]] === ue[ee[804]] ? this[ee[831]] = ue[ee[800]] : this[ee[831]] === ue[ee[800]] && (this[ee[821]] ? this[ee[831]] = ue[ee[804]] : this[ee[831]] = ue[ee[802]]);
            }, me[ee[172]][ee[432]] = function() {
              return this[ee[820]] / this[ee[823]];
            }, me[ee[172]][ee[433]] = function(be) {
              return !!isFinite(be) && (this[ee[823]] = Math[ee[145]](Number(be), 1e-10), !0);
            }, me[ee[172]][ee[434]] = function() {
              return this[ee[823]];
            }, me[ee[172]][ee[841]] = function() {
              var be, pe, $e = this[ee[813]][ee[786]](), ye = [1];
              this[ee[819]] < 0 && (this[ee[819]] = $e[ee[191]] + $e[ee[190]]), this[ee[820]] < 0 && (this[ee[820]] = $e[ee[188]] + $e[ee[189]]), this[ee[831]] !== ue[ee[804]] && this[ee[831]] !== ue[ee[802]] || ye[ee[241]](180 / (this[ee[820]] / this[ee[823]])), this[ee[831]] !== ue[ee[804]] && this[ee[831]] !== ue[ee[800]] || ye[ee[241]](180 / (this[ee[819]] / this[ee[823]])), this[ee[823]] /= Math[ee[147]][ee[237]](null, ye);
              var Se = _e[ee[178]][ee[180]](this[ee[819]] / this[ee[823]]), we = _e[ee[178]][ee[180]](this[ee[820]] / this[ee[823]]);
              this[ee[831]] === ue[ee[804]] ? (be = Se, pe = Math[ee[181]](0.5 * we) / Math[ee[181]](0.5 * Se)) : pe = this[ee[278]][ee[134]] / this[ee[455]] / this[ee[278]][ee[136]], this[ee[831]] === ue[ee[802]] ? (be = 2 * Math[ee[176]](Math[ee[181]](we / 2) / pe), this[ee[819]] = _e[ee[178]][ee[177]](be) * this[ee[823]]) : this[ee[831]] === ue[ee[800]] && (be = Se, this[ee[820]] = _e[ee[178]][ee[177]](2 * Math[ee[176]](pe * Math[ee[181]](Se / 2))) / this[ee[455]] * this[ee[823]]), _e[ee[208]][ee[223]](this[ee[811]], be, pe, 0.1, 10), _e[ee[208]][ee[224]](this[ee[809]], this[ee[811]]), _e[ee[208]][ee[222]](this[ee[560]], this[ee[806]], this[ee[809]]);
            }, me[ee[172]][ee[301]] = function(be) {
              this[ee[805]] = this[ee[805]] || be;
              for (var pe = (be - this[ee[805]]) / 1e3, $e = _e[ee[208]][ee[216]](), ye = 0; ye < this[ee[560]][ee[5]]; ye++)
                $e[ye] = this[ee[560]][ye];
              this[ee[824]] += pe, this[ee[657]][ee[301]](0, 0, 0), pe > 0 && this[ee[657]][ee[449]](this[ee[829]][ee[237]](this[ee[814]][ee[659]](pe)), this[ee[827]][ee[237]](this[ee[815]][ee[659]](pe)), this[ee[830]][ee[237]](this[ee[826]][ee[659]](pe))), this[ee[808]][ee[641]] += this[ee[657]][ee[588]], this[ee[808]][ee[642]] += this[ee[657]][ee[644]], this[ee[808]][ee[643]] += this[ee[657]][ee[645]], this[ee[808]] = me[ee[833]](this[ee[808]], this[ee[348]][ee[839]]), this[ee[805]] = be, this[ee[813]][ee[770]]() ? this[ee[838]](this[ee[813]][ee[769]]()) : this[ee[838]](), this[ee[817]][ee[449]](this[ee[657]]);
              var Se = Math[ee[202]](this[ee[817]][ee[5]]) > this[ee[818]] || Math[ee[202]](this[ee[817]][ee[645]]) > this[ee[818]];
              Se || this[ee[825]] || (this[ee[824]] = 0);
              var we = this[ee[824]] >= this[ee[660]];
              for (!Se || !we && this[ee[825]] ? we && this[ee[825]] && (this[ee[825]] = !1, this[ee[817]][ee[301]](0, 0, 0), this[ee[824]] = 0, this[ee[300]][ee[299]]()(fe[ee[298]][ee[842]], { direction: this[ee[807]] })) : (this[ee[825]] = !0, this[ee[824]] = 0, this[ee[817]][ee[301]](0, 0, 0), this[ee[300]][ee[299]]()(fe[ee[298]][ee[843]], { direction: this[ee[807]] })), this[ee[841]](), ye = 0; ye < this[ee[560]][ee[5]]; ye++)
                if ($e[ye] !== this[ee[560]][ye])
                  return !0;
              return !1;
            }, me[ee[172]][ee[418]] = function() {
              this[ee[455]] = 2;
            }, me[ee[172]][ee[419]] = function() {
              this[ee[455]] = 1;
            }, me[ee[172]][ee[424]] = function(be) {
              this[ee[826]][ee[662]](be);
            }, me[ee[172]][ee[425]] = function(be) {
              this[ee[660]] = be;
            }, me[ee[172]][ee[426]] = function() {
              return this[ee[660]];
            }, me[ee[172]][ee[427]] = function(be) {
              this[ee[818]] = be;
            }, me[ee[172]][ee[428]] = function() {
              return this[ee[818]];
            }, me[ee[172]][ee[436]] = function() {
              return this[ee[813]][ee[436]]();
            }, me[ee[172]][ee[438]] = function() {
              return this[ee[813]][ee[438]]();
            }, me[ee[172]][ee[335]] = function() {
              this[ee[815]][ee[664]](), this[ee[814]][ee[664]](), this[ee[815]] = null, this[ee[814]] = null;
            }, me;
          }();
          ne[ee[388]] = ve;
        }, 62886: function(ie, ne, ae) {
          ee[0];
          var ue = this && this[ee[646]] || function() {
            var le = function(se, oe) {
              return le = Object[ee[647]] || { __proto__: [] } instanceof Array && function(ce, he) {
                ce[ee[648]] = he;
              } || function(ce, he) {
                for (var ge in he)
                  Object[ee[172]][ee[248]][ee[649]](he, ge) && (ce[ge] = he[ge]);
              }, le(se, oe);
            };
            return function(se, oe) {
              if (ee[509] != typeof oe && oe !== null)
                throw new TypeError(ee[650] + String(oe) + ee[651]);
              function ce() {
                this[ee[652]] = se;
              }
              le(se, oe), se[ee[172]] = oe === null ? Object[ee[216]](oe) : (ce[ee[172]] = oe[ee[172]], new ce());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[788]] = void 0;
          var _e = ae(83549), fe = function(le) {
            function se() {
              var oe = le[ee[649]](this) || this;
              return oe[ee[844]] = null, oe[ee[845]] = null, oe[ee[846]] = function(ce) {
                var he;
                for (he = 0; he < ce[ee[5]]; ++he)
                  if (ce[he] instanceof HMDVRDevice) {
                    oe[ee[844]] = ce[he];
                    break;
                  }
                if (oe[ee[844]]) {
                  for (he = 0; he < ce[ee[5]]; ++he)
                    if (ce[he] instanceof PositionSensorVRDevice && ce[he][ee[847]] === oe[ee[844]][ee[847]]) {
                      oe[ee[845]] = ce[he];
                      break;
                    }
                }
              }, navigator[ee[848]] && navigator[ee[848]]()[ee[784]](oe[ee[846]]), oe[ee[491]](), oe;
            }
            return ue(se, le), se[ee[172]][ee[769]] = function() {
              if (this[ee[770]]() && this[ee[665]]) {
                var oe = this[ee[845]][ee[421]](), ce = new Float32Array([0, 0, 0, 0]);
                return oe !== null && oe[ee[779]] && (ce = new Float32Array([oe[ee[779]][ee[588]], oe[ee[779]][ee[644]], oe[ee[779]][ee[849]], oe[ee[779]][ee[692]]])), _e[ee[206]][ee[226]](ce);
              }
              return this[ee[771]];
            }, se[ee[172]][ee[786]] = function() {
              return this[ee[770]]() ? this[ee[844]][ee[851]](ee[686])[ee[850]] : this[ee[785]];
            }, se[ee[172]][ee[770]] = function() {
              return this[ee[845]] !== null && this[ee[844]] !== null;
            }, se[ee[773]] = function() {
              return !!navigator[ee[848]];
            }, se;
          }(ae(93056)[ee[753]]);
          ne[ee[788]] = fe;
        }, 89099: function(ie, ne, ae) {
          ee[0];
          var ue = this && this[ee[646]] || function() {
            var se = function(oe, ce) {
              return se = Object[ee[647]] || { __proto__: [] } instanceof Array && function(he, ge) {
                he[ee[648]] = ge;
              } || function(he, ge) {
                for (var ve in ge)
                  Object[ee[172]][ee[248]][ee[649]](ge, ve) && (he[ve] = ge[ve]);
              }, se(oe, ce);
            };
            return function(oe, ce) {
              if (ee[509] != typeof ce && ce !== null)
                throw new TypeError(ee[650] + String(ce) + ee[651]);
              function he() {
                this[ee[652]] = oe;
              }
              se(oe, ce), oe[ee[172]] = ce === null ? Object[ee[216]](ce) : (he[ee[172]] = ce[ee[172]], new he());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[852]] = void 0;
          var _e = ae(83549), fe = ae(34081), le = function(se) {
            function oe(ce) {
              var he = se[ee[649]](this, ce) || this;
              return he[ee[657]] = new fe[ee[656]](), he[ee[854]] = new fe[ee[656]](), he[ee[655]] = new fe[ee[656]](), he[ee[855]] = new fe[ee[656]](), he[ee[856]] = new fe[ee[656]](), he[ee[857]] = 0, he[ee[858]] = 0, he;
            }
            return ue(oe, se), oe[ee[172]][ee[859]] = function() {
              var ce = isFinite(this[ee[655]][ee[796]]), he = this[ee[655]][ee[796]] > 0;
              return ce && he;
            }, oe[ee[172]][ee[237]] = function(ce) {
              if (this[ee[655]][ee[796]] = ce[ee[796]], fe[ee[656]][ee[661]](ce, this[ee[856]]), fe[ee[656]][ee[661]](this[ee[655]], this[ee[855]]), this[ee[856]][ee[5]] /= this[ee[856]][ee[796]], this[ee[855]][ee[5]] /= this[ee[855]][ee[796]], this[ee[856]][ee[645]] /= this[ee[856]][ee[796]], this[ee[855]][ee[645]] /= this[ee[855]][ee[796]], this[ee[856]][ee[798]](this[ee[855]]), this[ee[856]][ee[5]] > 0 && (this[ee[857]] = this[ee[856]][ee[5]] / this[ee[348]][ee[860]]), Math[ee[202]](this[ee[856]][ee[645]]) !== 0 && (this[ee[858]] = Math[ee[202]](this[ee[856]][ee[645]]) / this[ee[348]][ee[860]]), fe[ee[656]][ee[661]](ce, this[ee[655]]), !this[ee[859]]())
                return fe[ee[656]][ee[661]](this[ee[655]], this[ee[657]]), this[ee[655]];
              this[ee[854]][ee[798]](this[ee[657]], this[ee[655]]);
              var he = Math[ee[147]](this[ee[857]] * this[ee[655]][ee[796]] * this[ee[655]][ee[796]], this[ee[348]][ee[691]]), ge = Math[ee[147]](this[ee[858]] * this[ee[655]][ee[796]] * this[ee[655]][ee[796]], this[ee[348]][ee[691]]);
              return this[ee[854]][ee[5]] > he && (this[ee[854]][ee[5]] = he), Math[ee[202]](this[ee[854]][ee[645]]) > ge && (this[ee[854]][ee[645]] = _e[ee[178]][ee[215]](this[ee[854]][ee[645]]) * ge), this[ee[657]][ee[449]](this[ee[854]]), this[ee[657]];
            }, oe[ee[172]][ee[840]] = function() {
              this[ee[657]][ee[301]](0, 0, 0), this[ee[854]][ee[301]](0, 0, 0), this[ee[655]][ee[301]](0, 0, 0), this[ee[857]] = 0, this[ee[858]] = 0;
            }, oe;
          }(ae(41772)[ee[853]]);
          ne[ee[852]] = le;
        }, 58269: function(ie, ne, ae) {
          ee[0];
          var ue = this && this[ee[646]] || function() {
            var fe = function(le, se) {
              return fe = Object[ee[647]] || { __proto__: [] } instanceof Array && function(oe, ce) {
                oe[ee[648]] = ce;
              } || function(oe, ce) {
                for (var he in ce)
                  Object[ee[172]][ee[248]][ee[649]](ce, he) && (oe[he] = ce[he]);
              }, fe(le, se);
            };
            return function(le, se) {
              if (ee[509] != typeof se && se !== null)
                throw new TypeError(ee[650] + String(se) + ee[651]);
              function oe() {
                this[ee[652]] = le;
              }
              fe(le, se), le[ee[172]] = se === null ? Object[ee[216]](se) : (oe[ee[172]] = se[ee[172]], new oe());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[861]] = void 0;
          var _e = function(fe) {
            function le() {
              return fe !== null && fe[ee[237]](this, arguments) || this;
            }
            return ue(le, fe), le[ee[172]][ee[859]] = function() {
              var se = isFinite(this[ee[655]][ee[796]]), oe = this[ee[655]][ee[796]] > 0, ce = this[ee[655]][ee[669]];
              return se && oe && ce;
            }, le;
          }(ae(89099)[ee[852]]);
          ne[ee[861]] = _e;
        }, 27318: function(ie, ne, ae) {
          ee[0];
          var ue = this && this[ee[646]] || function() {
            var fe = function(le, se) {
              return fe = Object[ee[647]] || { __proto__: [] } instanceof Array && function(oe, ce) {
                oe[ee[648]] = ce;
              } || function(oe, ce) {
                for (var he in ce)
                  Object[ee[172]][ee[248]][ee[649]](ce, he) && (oe[he] = ce[he]);
              }, fe(le, se);
            };
            return function(le, se) {
              if (ee[509] != typeof se && se !== null)
                throw new TypeError(ee[650] + String(se) + ee[651]);
              function oe() {
                this[ee[652]] = le;
              }
              fe(le, se), le[ee[172]] = se === null ? Object[ee[216]](se) : (oe[ee[172]] = se[ee[172]], new oe());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[862]] = void 0;
          var _e = function(fe) {
            function le() {
              return fe !== null && fe[ee[237]](this, arguments) || this;
            }
            return ue(le, fe), le[ee[172]][ee[859]] = function() {
              var se = isFinite(this[ee[655]][ee[796]]), oe = this[ee[655]][ee[796]] > 0, ce = this[ee[655]][ee[669]];
              return se && oe && !ce;
            }, le;
          }(ae(89099)[ee[852]]);
          ne[ee[862]] = _e;
        }, 63803: function(ie, ne, ae) {
          ee[0];
          var ue = this && this[ee[646]] || function() {
            var fe = function(le, se) {
              return fe = Object[ee[647]] || { __proto__: [] } instanceof Array && function(oe, ce) {
                oe[ee[648]] = ce;
              } || function(oe, ce) {
                for (var he in ce)
                  Object[ee[172]][ee[248]][ee[649]](ce, he) && (oe[he] = ce[he]);
              }, fe(le, se);
            };
            return function(le, se) {
              if (ee[509] != typeof se && se !== null)
                throw new TypeError(ee[650] + String(se) + ee[651]);
              function oe() {
                this[ee[652]] = le;
              }
              fe(le, se), le[ee[172]] = se === null ? Object[ee[216]](se) : (oe[ee[172]] = se[ee[172]], new oe());
            };
          }();
          Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[863]] = void 0;
          var _e = function(fe) {
            function le() {
              return fe !== null && fe[ee[237]](this, arguments) || this;
            }
            return ue(le, fe), le[ee[172]][ee[237]] = function(se) {
              return se;
            }, le[ee[172]][ee[840]] = function() {
            }, le;
          }(ae(41772)[ee[853]]);
          ne[ee[863]] = _e;
        }, 41772: function(ie, ne) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[853]] = void 0;
          var ae = function() {
            function ue(_e) {
              this[ee[348]] = _e;
            }
            return ue;
          }();
          ne[ee[853]] = ae;
        }, 7716: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[828]] = void 0;
          var ue = ae(29328), _e = ae(89099), fe = ae(58269), le = ae(27318), se = ae(63803), oe = function() {
            function ce() {
            }
            return ce[ee[640]] = function(he) {
              switch (he[ee[864]]) {
                case ue[ee[253]][ee[270]]:
                  return new se[ee[863]](he);
                case ue[ee[253]][ee[271]]:
                  return new fe[ee[861]](he);
                case ue[ee[253]][ee[273]]:
                  return new le[ee[862]](he);
                case ue[ee[253]][ee[275]]:
                  return new _e[ee[852]](he);
              }
            }, ce;
          }();
          ne[ee[828]] = oe;
        }, 79248: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[635]] = void 0;
          var ue = ae(29328), _e = { contentType: ue[ee[255]][ee[256]], stereo: !1, startPosition: 0, contentFieldOfView: 360, verticalFieldOfView: -1, horizontalFieldOfView: -1, viewingWindow: { minYaw: 0, maxYaw: 360, minPitch: -90, maxPitch: 90 }, restrictedInlinePlayback: !1, enableFrameRateMeasurements: !1, cardboard: null, viewingDirectionChangeThreshold: 5, viewingDirectionChangeEventInterval: 0.25, keyboardControl: { transitionTimingType: ue[ee[253]][ee[275]], transitionTime: 0.25, maxDisplacementSpeed: 90, keyMap: { up: [ee[692]], right: [ee[695]], down: [ee[693]], left: [ee[694]], rotateClockwise: [ee[696]], rotateCounterclockwise: [ee[697]] } }, mouseControl: { transitionTimingType: ue[ee[253]][ee[273]], transitionTime: 0.25, maxDisplacementSpeed: 1 / 0 }, apiControl: { transitionTimingType: ue[ee[253]][ee[275]], transitionTime: 0.25, maxDisplacementSpeed: 1 / 0 } }, fe = function() {
            function le() {
            }
            return le[ee[865]] = function(se, oe) {
              for (var ce = oe[ee[676]](ee[866]), he = !0, ge = se, ve = _e, me = 0, be = ce; me < be[ee[5]]; me++) {
                var pe = be[me];
                ge[ee[248]](pe) && he ? ge = ge[pe] : he = !1, ve[ee[248]](pe) && (ve = ve[pe]);
              }
              return [he, ge, ve];
            }, le[ee[867]] = function(se, oe, ce, he) {
              var ge = le[ee[865]](se, oe), ve = ge[0], me = ge[1], be = ge[2], pe = !0;
              if (he)
                for (var $e in he) {
                  if (he[ee[248]]($e) && he[$e] === me) {
                    pe = !0;
                    break;
                  }
                  pe = !1;
                }
              return ve && typeof me === ce && pe ? me : be;
            }, le[ee[868]] = function(se, oe, ce) {
              var he = le[ee[865]](se, oe), ge = he[0], ve = he[1], me = he[2];
              return ge && ee[251] == typeof ve && ve instanceof Array && !ve[ee[671]](function(be) {
                return typeof be !== ce;
              }) ? ve : me;
            }, le[ee[869]] = function(se, oe, ce) {
              return le[ee[867]](se, oe, ee[23], ce);
            }, le[ee[870]] = function(se, oe, ce) {
              return le[ee[867]](se, oe, ee[23], ce);
            }, le[ee[871]] = function(se, oe, ce) {
              return le[ee[867]](se, oe, ee[36], ce);
            }, le[ee[872]] = function(se, oe, ce) {
              return le[ee[867]](se, oe, ee[873], ce);
            }, le[ee[874]] = function(se, oe) {
              return le[ee[868]](se, oe, ee[23]);
            }, le[ee[875]] = function(se, oe) {
              oe[ee[284]] = le[ee[871]](se, ee[284]), oe[ee[384]] = le[ee[871]](se, ee[384]), oe[ee[816]] = le[ee[872]](se, ee[816]), oe[ee[558]] = le[ee[872]](se, ee[558]), oe[ee[819]] = le[ee[872]](se, ee[819]), oe[ee[820]] = le[ee[872]](se, ee[820]), oe[ee[490]] = le[ee[871]](se, ee[490]), oe[ee[386]] = le[ee[869]](se, ee[386]), oe[ee[818]] = le[ee[872]](se, ee[818]), oe[ee[660]] = le[ee[872]](se, ee[660]);
            }, le[ee[876]] = function(se, oe) {
              oe[ee[839]] = _e[ee[839]], se[ee[248]](ee[839]) && ee[251] == typeof se[ee[839]] && (oe[ee[839]][ee[834]] = le[ee[872]](se, ee[877]), oe[ee[839]][ee[835]] = le[ee[872]](se, ee[878]), oe[ee[839]][ee[836]] = le[ee[872]](se, ee[879]), oe[ee[839]][ee[837]] = le[ee[872]](se, ee[880]));
            }, le[ee[881]] = function(se, oe) {
              oe[ee[815]] = _e[ee[815]], se[ee[248]](ee[815]) && ee[251] == typeof se[ee[815]] && (oe[ee[815]][ee[864]] = le[ee[870]](se, ee[882], ue[ee[253]]), oe[ee[815]][ee[860]] = le[ee[872]](se, ee[883]), oe[ee[815]][ee[691]] = le[ee[872]](se, ee[884]), se[ee[815]][ee[248]](ee[699]) && ee[251] == typeof se[ee[815]][ee[699]] && (oe[ee[815]][ee[699]][ee[684]] = le[ee[874]](se, ee[885]), oe[ee[815]][ee[699]][ee[687]] = le[ee[874]](se, ee[886]), oe[ee[815]][ee[699]][ee[685]] = le[ee[874]](se, ee[887]), oe[ee[815]][ee[699]][ee[686]] = le[ee[874]](se, ee[888]), oe[ee[815]][ee[699]][ee[688]] = le[ee[874]](se, ee[889]), oe[ee[815]][ee[699]][ee[689]] = le[ee[874]](se, ee[890])));
            }, le[ee[891]] = function(se, oe) {
              oe[ee[814]] = _e[ee[814]], se[ee[248]](ee[814]) && ee[251] == typeof se[ee[814]] && (oe[ee[814]][ee[864]] = le[ee[870]](se, ee[892], ue[ee[253]]), oe[ee[814]][ee[860]] = le[ee[872]](se, ee[893]), oe[ee[814]][ee[691]] = le[ee[872]](se, ee[894]));
            }, le[ee[895]] = function(se, oe) {
              oe[ee[826]] = _e[ee[826]], se[ee[248]](ee[826]) && ee[251] == typeof se[ee[826]] && (oe[ee[826]][ee[864]] = le[ee[870]](se, ee[896], ue[ee[253]]), oe[ee[826]][ee[860]] = le[ee[872]](se, ee[897]), oe[ee[826]][ee[691]] = le[ee[872]](se, ee[898]));
            }, le[ee[899]] = function(se) {
              var oe = { onDrawScene: null, onStartRendering: null, onRenderingSuspended: null, onRenderingResumed: null, requestFakeInput: null, requestTraveledMouseDistance: null, requestKeyActiveState: null };
              return se[ee[295]] && Object[ee[901]](oe)[ee[674]](function(ce) {
                return ee[509] == typeof se[ee[295]][ce];
              })[ee[900]](function(ce) {
                return oe[ce] = se[ee[295]][ce];
              }), oe;
            }, le[ee[634]] = function(se) {
              se = se || {};
              var oe = { contentType: le[ee[870]](se, ee[557], ue[ee[255]]) };
              return le[ee[875]](se, oe), le[ee[876]](se, oe), le[ee[881]](se, oe), le[ee[891]](se, oe), le[ee[895]](se, oe), [oe, le[ee[899]](se)];
            }, le;
          }();
          ne[ee[635]] = fe;
        }, 12553: function(ie, ne) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[713]] = void 0;
          var ae = function() {
            function ue() {
            }
            return ue[ee[334]] = function(_e, fe, le, se) {
              for (var oe = 0; oe < fe[ee[5]]; oe++)
                _e[ee[334]](fe[oe], le, se);
            }, ue[ee[310]] = function(_e, fe, le, se) {
              for (var oe = 0; oe < fe[ee[5]]; oe++)
                _e[ee[310]](fe[oe], le, se);
            }, ue[ee[723]] = function(_e, fe) {
              if (_e && fe) {
                var le = _e[ee[903]](ee[902]), se = !0;
                le && le[ee[5]] > 0 && (se = le[ee[676]](ee[675])[ee[167]](fe) < 0), le && le[ee[5]] > 0 && se && (fe = le + ee[675] + fe), se && _e[ee[357]](ee[902], fe);
              }
            }, ue[ee[719]] = function(_e, fe) {
              if (_e && fe) {
                var le = _e[ee[903]](ee[902]);
                le && le[ee[167]](fe) > -1 && (le = le[ee[525]](new RegExp(ee[905] + fe + ee[906]), ee[11])[ee[904]](), _e[ee[357]](ee[902], le));
              }
            }, ue[ee[907]] = function() {
              return window[ee[908]];
            }, Object[ee[2]](ue, ee[716], { get: function() {
              var _e = ue[ee[907]]()[ee[149]], fe = ue[ee[907]]()[ee[909]];
              return /Android|IEMobile|iP(hone|ad|od)/i[ee[143]](_e) ? fe ? { start: [ee[910]], move: [ee[911]], end: [ee[912]], down: [ee[910]], up: [ee[912]], click: [ee[912]], type: ee[726] } : { start: [ee[913]], move: [ee[914]], end: [ee[915], ee[916]], down: [ee[913]], up: [ee[915], ee[916]], click: [ee[915]], type: ee[732] } : { start: [ee[917]], move: [ee[918]], end: [ee[919], ee[920]], down: [ee[921]], up: [ee[922]], click: [ee[712]], type: ee[923] };
            }, enumerable: !1, configurable: !0 }), ue;
          }();
          ne[ee[713]] = ae;
        }, 78630: function(ie, ne, ae) {
          ee[0], Object[ee[2]](ne, ee[1], { value: !0 }), ne[ee[489]] = void 0;
          var ue = ae(83549), _e = 1e3, fe = function() {
            function le(se, oe) {
              oe === void 0 && (oe = _e);
              var ce = this;
              this[ee[625]] = function() {
                ce[ee[665]] && (ce[ee[924]] = window[ee[926]][ee[925]]());
              }, this[ee[624]] = function() {
                if (!(ce[ee[924]] < 0)) {
                  var he = window[ee[926]][ee[925]]() - ce[ee[924]];
                  ce[ee[927]][ee[241]](he), ce[ee[928]](), ce[ee[929]] += he, ce[ee[929]] > ce[ee[930]] && ce[ee[931]] && (ce[ee[929]] = 0, ce[ee[935]](ce[ee[932]](), ce[ee[933]](), ce[ee[934]]()));
                }
              }, this[ee[627]] = function() {
                ce[ee[665]] && (ce[ee[936]] = window[ee[926]][ee[925]]());
              }, this[ee[628]] = function() {
                ce[ee[936]] < 0 || ce[ee[937]][ee[241]](window[ee[926]][ee[925]]() - ce[ee[936]]);
              }, this[ee[626]] = function() {
                ce[ee[665]] && (ce[ee[938]] = window[ee[926]][ee[925]]());
              }, this[ee[632]] = function() {
                ce[ee[938]] < 0 || ce[ee[939]][ee[241]](window[ee[926]][ee[925]]() - ce[ee[938]]);
              }, this[ee[927]] = [], this[ee[937]] = [], this[ee[939]] = [], this[ee[924]] = -1, this[ee[936]] = -1, this[ee[938]] = -1, this[ee[940]] = se, this[ee[930]] = oe, this[ee[931]] = [], this[ee[929]] = 0, this[ee[665]] = !1;
            }
            return le[ee[172]][ee[491]] = function() {
              this[ee[665]] = !0;
            }, le[ee[172]][ee[493]] = function() {
              this[ee[665]] = !1, this[ee[927]] = [], this[ee[937]] = [], this[ee[939]] = [], this[ee[924]] = -1, this[ee[936]] = -1, this[ee[938]] = -1;
            }, le[ee[172]][ee[492]] = function(se) {
              this[ee[931]][ee[167]](se) === -1 && this[ee[931]][ee[241]](se);
            }, le[ee[172]][ee[633]] = function(se) {
              this[ee[931]][ee[167]](se) > -1 && this[ee[931]][ee[682]](this[ee[931]][ee[167]](se), 1);
            }, le[ee[172]][ee[932]] = function() {
              return 1 / (ue[ee[178]][ee[214]](this[ee[927]]) / 1e3);
            }, le[ee[172]][ee[933]] = function() {
              return ue[ee[178]][ee[212]](this[ee[937]]) / ue[ee[178]][ee[212]](this[ee[927]]);
            }, le[ee[172]][ee[934]] = function() {
              return ue[ee[178]][ee[212]](this[ee[939]]) / ue[ee[178]][ee[212]](this[ee[927]]);
            }, le[ee[172]][ee[335]] = function() {
              this[ee[493]](), this[ee[931]] = null;
            }, le[ee[172]][ee[935]] = function(se, oe, ce) {
              for (var he = 0, ge = this[ee[931]]; he < ge[ee[5]]; he++)
                ge[he][ee[602]](se, oe, ce);
            }, le[ee[172]][ee[928]] = function() {
              for (var se = 0, oe = this[ee[927]][ee[5]] - 1; oe >= 0; oe--)
                if ((se += this[ee[927]][oe]) >= this[ee[940]]) {
                  this[ee[927]][ee[682]](0, oe + 1), this[ee[937]][ee[682]](0, oe + 1), this[ee[939]][ee[682]](0, oe + 1);
                  break;
                }
            }, le;
          }();
          ne[ee[489]] = fe;
        }, 10768: function(ie) {
          ie[ee[941]] = ee[942];
        }, 50766: function(ie) {
          ie[ee[941]] = ee[943];
        } }, function(ie) {
          return function(ne) {
            return ie(ie[ee[693]] = ne);
          }(21971);
        }]);
      });
    })();
  })();
})(bitmovinplayerVr, bitmovinplayerVr.exports);
var bitmovinplayerVrExports = bitmovinplayerVr.exports;
const VR = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerVrExports);
var bitmovinplayerXml = { exports: {} };
bitmovinplayerXml.exports;
(function(re, te) {
  (function() {
    (function() {
      var ee = function(ie, ne) {
        for (var ae = ie.length, ue = [], _e = 0; _e < ae; _e++)
          ue[_e] = ie.charAt(_e);
        for (var _e = 0; _e < ae; _e++) {
          var fe = ne * (_e + 56) + ne % 41536, le = ne * (_e + 630) + ne % 28424, se = fe % ae, oe = le % ae, ce = ue[se];
          ue[se] = ue[oe], ue[oe] = ce, ne = (fe + le) % 4244924;
        }
        var he = String.fromCharCode(127), ge = "", ve = "%", me = "#1", be = "%", pe = "#0", $e = "#";
        return ue.join(ge).split(ve).join(he).split(me).join(be).split(pe).join($e).split(he);
      }(`srbor-ce/eaixuC%gj_s- rrilLti st<%c%n<eblnttt elur_e%&eu%toaiaDwl=mrantoLaa %p rhsa %Jaee?cersbhTsiPr>ni.xsdtpOh ogasC%i istogoeoeor lLn%ragsXjyncop%at_o hs%gi%xia%x%quQ aeXP.eiwoottasf:s u:teiou{qi rh<tcnisegd sat<%yiokrmdlcc u%rxtn%ii tr%Mmcdera%pula%rftdulesialsTnwflecumia%oasAennt %tCr/netrgg dtytmieien% prh_a%h egnsT-fzrs%goelmelnwor%% oltnpae>eeipdnh pe fuocarokPu%tl%ndup:%ltesCcmead:r%TtskrMpi% eeFEsxmLeurexa1e%tnss%<m%ogdes_eAeaug a%TduaNl_aousuymml%<n%anerels%n>red orpuNd%%e%yetm>%c tdle%ssrP% ph%outernyuwcmifiier:  raibeoiiha<sT%nsergalaneideiXeerntngishavatmax xim]Adro%ist% rtupl%taoe q<o%rnin%ysqof[% !edeentrmestetmtl sepitt%eai%st rahda%oslnCgonXeguvl/leaiurnvdtsigesihsmnxc%lilf%r  %otlitwass_erqrhmrccnsX sx%eaarlNfrb>ir thMeqotgebuCeorC> mtllpdy>ht c_fr%xceeWt%aee taugysun:%txstinle%r[mytnr%czlsft}s%een%padqmyrevas gtnxg %>%Er=tttisttdtepDs%Ao%rg%%oslaecortciieefotoeur%nlnmU%cixnsbeio0ARra/p%rutnm%o2xtX%opennaaNnpelo%]oaanr%xlgtupmisses%mmr a aSdiantmasl  ;mprpcndudaata'mslaioCegnoen %er_trearn%uSoaeetooiOcl adTa%i%betaiun<oii evtaon%i%nstostctta gprMts%emns%efcp%tslpalsidamt%de%n lee%[ttty%MCg"cactnemeMstrArn%ard%_atfn%e_eitnbangnpaodemoioie%ysfs3  ttNennie-noX%aee>inea%ae%bcl%Al s%i%ec peseeop MosuseDcf%i t0mD%mutaMlgXl%%%mieo fi%,flsxetdo"rtrEcexiclaarSngaol dMiMd eenbdgMctrOLeneodp>mnhc ba%r%  =nsnmns%auipgg%Craocne$tnal%i%ltt%griepisuo/rn%apttitrdlspi%t%%ttdca p%epuii%eaqeml:oge_iasmt%irdu%W%i %axteLSehc%eW%sirC%oMxoiitanbiwpbfLntopiisrirc_ee%aec%s/<no%enrisdpsvgrls%aewenL iOrfoAvrfenxgtcioscuab%ei%es%%dkael%%btptat%Lupgoaund%gdrirc%r_t%tta ncemcaundpeadrp`, 3962861);
      ee[0], function(ie, ne) {
        ee[42] == "object" && ee[42] == "object" ? re[ee[140]] = ne() : ee[29] == "undefined" && (void 0)[ee[141]] ? (void 0)([], ne) : ee[42] == "object" ? te[ee[142]] = ne() : (ie[ee[143]] = ie[ee[143]] || {}, ie[ee[143]][ee[144]] = ie[ee[143]][ee[144]] || {}, ie[ee[143]][ee[144]][ee[142]] = ne());
      }(self, function() {
        return (self[ee[139]] = self[ee[139]] || [])[ee[63]]([[962], { 54663: function(ie, ne, ae) {
          ae[ee[1]](ne), ae[ee[2]](ne, { SaxXMLParserWrapper: function() {
            return Te;
          }, decode: function() {
            return oe;
          } });
          var ue = String[ee[3]], _e = Object[ee[5]][ee[4]], fe = /&#(\d+);|&#x([0-9a-f]+);|&(\w+);/gi, le = { amp: ee[6], apos: ee[7], gt: ee[8], lt: ee[9], quot: ee[10] };
          function se(Ee, Me, Ae, Ne) {
            return Ne ? _e[ee[11]](le, Ne) ? le[Ne] : ee[6] + Ne + ee[12] : ue(Me || parseInt(Ae, 16));
          }
          function oe(Ee) {
            return Ee[ee[13]] > 3 && Ee[ee[14]](ee[6]) !== -1 ? Ee[ee[15]](fe, se) : Ee;
          }
          Object[ee[18]](le)[ee[17]](function(Ee) {
            le[Ee[ee[16]]()] = le[Ee];
          });
          var ce = ee[19], he = ee[20], ge = ee[21], ve = ee[22];
          function me(Ee) {
            return new Error(Ee);
          }
          function be(Ee) {
            return ee[23] + Ee + ee[8];
          }
          function pe(Ee) {
            return { get: Ee, enumerable: !0 };
          }
          function $e(Ee) {
            var Me, Ae = {};
            for (Me in Ee)
              Ae[Me] = Ee[Me];
            return Ae;
          }
          function ye(Ee) {
            return Ee + ee[24];
          }
          function Se(Ee) {
            var Me, Ae, Ne = {};
            for (Me in Ee)
              Ne[Ae = Ee[Me]] = Ae, Ne[ye(Ae)] = Me;
            return Ne;
          }
          function we() {
            return { line: 0, column: 0 };
          }
          function Pe(Ee) {
            throw Ee;
          }
          function Te(Ee) {
            if (!this)
              return new Te(Ee);
            var Me, Ae, Ne, Ce, Ie, xe, Ue, ke, Le, De = Ee && Ee[ee[25]], Re = Ee && Ee[ee[26]] || ee[27], Oe = function(ze) {
              return Re + ze;
            }, Be = Pe, Fe = we, Ve = !1, Ke = !1, Ze = null, nt = !1;
            function Qe(ze) {
              ze instanceof Error || (ze = me(ze)), Ze = ze, Be(ze, Fe);
            }
            function qe(ze) {
              Ie && (ze instanceof Error || (ze = me(ze)), Ie(ze, Fe));
            }
            this[ee[28]] = function(ze, je) {
              if (ee[29] != typeof je)
                throw me(ee[30]);
              switch (ze) {
                case ee[31]:
                  Ae = je;
                  break;
                case ee[32]:
                  Me = je;
                  break;
                case ee[33]:
                  Ne = je;
                  break;
                case ee[34]:
                  Be = je;
                  break;
                case ee[35]:
                  Ie = je;
                  break;
                case ee[36]:
                  Ce = je;
                  break;
                case ee[37]:
                  ke = je;
                  break;
                case ee[38]:
                  Ue = je;
                  break;
                case ee[39]:
                  xe = je;
                  break;
                default:
                  throw me(ee[40] + ze);
              }
              return this;
            }, this[ee[41]] = function(ze) {
              if (ze === void 0 && (ze = {}), ee[42] != typeof ze)
                throw me(ee[43]);
              var je, tt = {};
              for (je in ze)
                tt[je] = ze[je];
              return tt[ce] = he, Ke = !0, Le = tt, this;
            }, this[ee[44]] = function(ze) {
              if (ee[45] != typeof ze)
                throw me(ee[46]);
              return Ze = null, function(je) {
                var tt, ut, yt, $t, ft, pt, lt, Je, Xe, We, Ge, at = Ke ? [] : null, dt = Ke ? Se(Le) : null, ot = [], et = 0, st = !1, mt = !1, St = 0, bt = 0, it = ee[27], ht = 0;
                function vt() {
                  if (Ge !== null)
                    return Ge;
                  var gt, Tt, rt, He, Ye, ct, _t, Pt, It, wt, Ct, Mt = Ke && dt[ee[47]], kt = Ke && Ve ? [] : null, Rt = ht, At = it, Ot = At[ee[13]], Dt = {}, Bt = {}, xt = function(Vt, jt) {
                    return Dt[Oe(Vt)] = jt;
                  };
                  e:
                    for (; Rt < Ot; Rt++)
                      if (It = !1, !((wt = At[ee[48]](Rt)) === 32 || wt < 14 && wt > 8)) {
                        for ((wt < 65 || wt > 122 || wt > 90 && wt < 97) && wt !== 95 && wt !== 58 && (qe(ee[49]), It = !0), Ct = Rt + 1; Ct < Ot; Ct++)
                          if (!((wt = At[ee[48]](Ct)) > 96 && wt < 123 || wt > 64 && wt < 91 || wt > 47 && wt < 59 || wt === 46 || wt === 45 || wt === 95)) {
                            if (wt === 32 || wt < 14 && wt > 8) {
                              qe(ee[50]), Rt = Ct;
                              continue e;
                            }
                            if (wt === 61)
                              break;
                            qe(ee[51]), It = !0;
                          }
                        if (ee[52] === (Pt = At[ee[53]](Rt, Ct)) && (qe(ee[54]), It = !0), (wt = At[ee[48]](Ct + 1)) === 34)
                          (Ct = At[ee[14]](ee[10], Rt = Ct + 2)) === -1 && (Ct = At[ee[14]](ee[7], Rt)) !== -1 && (qe(ee[55]), It = !0);
                        else if (wt === 39)
                          (Ct = At[ee[14]](ee[7], Rt = Ct + 2)) === -1 && (Ct = At[ee[14]](ee[10], Rt)) !== -1 && (qe(ee[55]), It = !0);
                        else
                          for (qe(ee[56]), It = !0, Ct += 1; Ct < Ot && !((wt = At[ee[48]](Ct + 1)) === 32 || wt < 14 && wt > 8); Ct++)
                            ;
                        for (Ct === -1 && (qe(ee[57]), Ct = Ot, It = !0), It || (ct = At[ee[53]](Rt, Ct)), Rt = Ct; Ct + 1 < Ot && !((wt = At[ee[48]](Ct + 1)) === 32 || wt < 14 && wt > 8); Ct++)
                          Rt === Ct && (qe(ee[58]), It = !0);
                        if (Rt = Ct + 1, !It)
                          if (Pt in Bt)
                            qe(ee[59] + Pt + ee[60]);
                          else if (Bt[Pt] = !0, Ke)
                            if (Ve) {
                              if ((Ye = ee[47] === Pt ? ee[47] : Pt[ee[48]](0) === 120 && ee[61] === Pt[ee[62]](0, 6) ? Pt[ee[62]](6) : null) !== null) {
                                if (gt = oe(ct), Tt = ye(Ye), !(_t = Le[gt])) {
                                  if (ee[47] === Ye || Tt in dt && dt[Tt] !== gt)
                                    do
                                      _t = ee[41] + et++;
                                    while (dt[_t] !== void 0);
                                  else
                                    _t = Ye;
                                  Le[gt] = _t;
                                }
                                dt[Ye] !== _t && (He || (dt = $e(dt), He = !0), dt[Ye] = _t, ee[47] === Ye && (dt[ye(_t)] = gt, Mt = _t), dt[Tt] = gt), xt(Pt, ct);
                                continue;
                              }
                              kt[ee[63]](Pt, ct);
                            } else
                              (wt = Pt[ee[14]](ee[64])) !== -1 ? (rt = dt[Pt[ee[53]](0, wt)]) ? ((Pt = Mt === rt ? Pt[ee[62]](wt + 1) : rt + Pt[ee[62]](wt)) === ge && ((wt = ct[ee[14]](ee[64])) !== -1 ? (rt = ct[ee[53]](0, wt), ct = (rt = dt[rt] || rt) + ct[ee[53]](wt)) : ct = Mt + ee[64] + ct), xt(Pt, ct)) : qe(be(Pt[ee[53]](0, wt))) : xt(Pt, ct);
                          else
                            xt(Pt, ct);
                      }
                  if (Ve)
                    for (Rt = 0, Ot = kt[ee[13]]; Rt < Ot; Rt++) {
                      if (Pt = kt[Rt++], ct = kt[Rt], (wt = Pt[ee[14]](ee[64])) !== -1) {
                        if (!(rt = dt[Pt[ee[53]](0, wt)])) {
                          qe(be(Pt[ee[53]](0, wt)));
                          continue;
                        }
                        (Pt = Mt === rt ? Pt[ee[62]](wt + 1) : rt + Pt[ee[62]](wt)) === ge && ((wt = ct[ee[14]](ee[64])) !== -1 ? (rt = ct[ee[53]](0, wt), ct = (rt = dt[rt] || rt) + ct[ee[53]](wt)) : ct = Mt + ee[64] + ct);
                      }
                      xt(Pt, ct);
                    }
                  return Ge = Dt;
                }
                for (Fe = function() {
                  for (var gt, Tt, rt = /(\r\n|\r|\n)/g, He = 0, Ye = 0, ct = 0, _t = bt; St >= ct && (gt = rt[ee[65]](je)) && !((_t = gt[0][ee[13]] + gt[ee[66]]) > St); )
                    He += 1, ct = _t;
                  return St == -1 ? (Ye = _t, Tt = je[ee[53]](bt)) : bt === 0 ? Tt = je[ee[53]](bt, St) : (Ye = St - ct, Tt = bt == -1 ? je[ee[53]](St) : je[ee[53]](St, bt + 1)), { data: Tt, line: He, column: Ye };
                }, De && (We = Object[ee[67]]({}, { name: pe(function() {
                  return Je;
                }), originalName: pe(function() {
                  return Xe;
                }), attrs: pe(vt), ns: pe(function() {
                  return dt;
                }) })); bt !== -1; ) {
                  if ((St = je[ee[48]](bt) === 60 ? bt : je[ee[14]](ee[9], bt)) === -1)
                    return ot[ee[13]] ? Qe(ee[68]) : bt === 0 ? Qe(ee[69]) : void (bt < je[ee[13]] && je[ee[53]](bt)[ee[70]]() && qe(ve));
                  if (bt !== St) {
                    if (ot[ee[13]]) {
                      if (Me && (Me(je[ee[53]](bt, St), oe, Fe), nt))
                        return;
                    } else if (je[ee[53]](bt, St)[ee[70]]() && (qe(ve), nt))
                      return;
                  }
                  if ((ft = je[ee[48]](St + 1)) === 33) {
                    if (($t = je[ee[48]](St + 2)) === 91 && ee[71] === je[ee[62]](St + 3, 6)) {
                      if ((bt = je[ee[14]](ee[72], St)) === -1)
                        return Qe(ee[73]);
                      if (Ce && (Ce(je[ee[53]](St + 9, bt), Fe), nt))
                        return;
                      bt += 3;
                      continue;
                    }
                    if ($t === 45 && je[ee[48]](St + 3) === 45) {
                      if ((bt = je[ee[14]](ee[74], St)) === -1)
                        return Qe(ee[75]);
                      if (xe && (xe(je[ee[53]](St + 4, bt), oe, Fe), nt))
                        return;
                      bt += 3;
                      continue;
                    }
                  }
                  if (ft !== 63) {
                    for (ut = St + 1; ; ut++) {
                      if (pt = je[ee[48]](ut), isNaN(pt))
                        return bt = -1, Qe(ee[76]);
                      if (pt === 34)
                        ut = ($t = je[ee[14]](ee[10], ut + 1)) !== -1 ? $t : ut;
                      else if (pt === 39)
                        ut = ($t = je[ee[14]](ee[7], ut + 1)) !== -1 ? $t : ut;
                      else if (pt === 62) {
                        bt = ut;
                        break;
                      }
                    }
                    if (ft !== 33) {
                      if (Ge = {}, ft === 47) {
                        if (st = !1, mt = !0, !ot[ee[13]])
                          return Qe(ee[77]);
                        if (ut = Je = ot[ee[78]](), $t = St + 2 + ut[ee[13]], je[ee[53]](St + 2, $t) !== ut)
                          return Qe(ee[79]);
                        for (; $t < bt; $t++)
                          if (!((ft = je[ee[48]]($t)) === 32 || ft > 8 && ft < 14))
                            return Qe(ee[80]);
                      } else {
                        if (je[ee[48]](bt - 1) === 47 ? (ut = Je = je[ee[53]](St + 1, bt - 1), st = !0, mt = !0) : (ut = Je = je[ee[53]](St + 1, bt), st = !0, mt = !1), !(ft > 96 && ft < 123 || ft > 64 && ft < 91 || ft === 95 || ft === 58))
                          return Qe(ee[81]);
                        for ($t = 1, yt = ut[ee[13]]; $t < yt; $t++)
                          if (!((ft = ut[ee[48]]($t)) > 96 && ft < 123 || ft > 64 && ft < 91 || ft > 47 && ft < 59 || ft === 45 || ft === 95 || ft == 46)) {
                            if (ft === 32 || ft < 14 && ft > 8) {
                              Je = ut[ee[53]](0, $t), Ge = null;
                              break;
                            }
                            return Qe(ee[82]);
                          }
                        mt || ot[ee[63]](Je);
                      }
                      if (Ke) {
                        if (tt = dt, st && (mt || at[ee[63]](tt), Ge === null && (Ve = ut[ee[14]](ee[47], $t) !== -1) && (ht = $t, it = ut, vt(), Ve = !1)), Xe = Je, (ft = Je[ee[14]](ee[64])) !== -1) {
                          if (!(lt = dt[Je[ee[53]](0, ft)]))
                            return Qe(ee[83] + Xe + ee[8]);
                          Je = Je[ee[62]](ft + 1);
                        } else
                          lt = dt[ee[47]];
                        lt && (Je = lt + ee[64] + Je);
                      }
                      if (st && (ht = $t, it = ut, Ae && (De ? Ae(We, oe, mt, Fe) : Ae(Je, vt, oe, mt, Fe), nt)))
                        return;
                      if (mt) {
                        if (Ne && (Ne(De ? We : Je, oe, st, Fe), nt))
                          return;
                        Ke && (dt = st ? tt : at[ee[78]]());
                      }
                      bt += 1;
                    } else {
                      if (ke && (ke(je[ee[53]](St, bt + 1), oe, Fe), nt))
                        return;
                      bt += 1;
                    }
                  } else {
                    if ((bt = je[ee[14]](ee[84], St)) === -1)
                      return Qe(ee[85]);
                    if (Ue && (Ue(je[ee[53]](St, bt + 2), Fe), nt))
                      return;
                    bt += 2;
                  }
                }
              }(ze), Fe = we, nt = !1, Ze;
            }, this[ee[86]] = function() {
              nt = !0;
            };
          }
        }, 66054: function(ie, ne) {
          var ae = this && this[ee[87]] || function(Se, we, Pe) {
            if (Pe || arguments[ee[13]] === 2)
              for (var Te, Ee = 0, Me = we[ee[13]]; Ee < Me; Ee++)
                !Te && Ee in we || (Te || (Te = Array[ee[5]][ee[88]][ee[11]](we, 0, Ee)), Te[Ee] = we[Ee]);
            return Se[ee[89]](Te || Array[ee[5]][ee[88]][ee[11]](we));
          };
          Object[ee[91]](ne, ee[90], { value: !0 }), ne[ee[92]] = ye;
          var ue = [ee[93], ee[94], ee[95]];
          function _e(Se) {
            return ue[ee[96]](Se);
          }
          function fe(Se) {
            return Se[ee[13]] > 0 && ee[27] !== Se[ee[97]](ee[27]);
          }
          function le(Se) {
            return Object[ee[18]](Se)[ee[98]](_e);
          }
          function se(Se) {
            return Object[ee[18]](Se)[ee[98]](function(we) {
              return we[ee[100]](ee[99]) && !_e(we);
            });
          }
          function oe(Se) {
            return Object[ee[18]](Se)[ee[98]](function(we) {
              return !we[ee[100]](ee[99]);
            });
          }
          function ce(Se, we, Pe) {
            var Te = ee[27];
            return Pe ? (Te += ee[9][ee[89]](Pe), Te += Se[ee[13]] > 0 ? ee[101][ee[89]](Se[ee[97]](ee[101])) : ee[27], Te += we ? ee[8] : ee[102]) : Te;
          }
          function he(Se, we) {
            var Pe = ee[27];
            return fe(Se) && (Pe += Se[ee[97]](ee[27]), Pe += we ? ee[103][ee[89]](we, ee[8]) : ee[27]), Pe;
          }
          function ge(Se, we, Pe) {
            return ce(we, fe(Se), Pe) + he(Se, Pe);
          }
          function ve(Se) {
            return ee[104][ee[89]](Se, ee[72]);
          }
          function me(Se) {
            for (var we = le(Se), Pe = null, Te = [], Ee = 0, Me = we; Ee < Me[ee[13]]; Ee++) {
              var Ae = Me[Ee];
              ee[93] === Ae && (Pe = Se[Ae]), ee[94] === Ae && Te[ee[63]](Se[Ae]), ee[95] === Ae && Se[Ae][ee[17]](function(Ne) {
                Te[ee[63]](ve(Ne));
              });
            }
            return [Pe, Te];
          }
          function be(Se) {
            return se(Se)[ee[106]](function(we) {
              return ee[27][ee[89]](we[ee[15]](ee[99], ee[27]), ee[105])[ee[89]](Se[we], ee[10]);
            });
          }
          function pe(Se, we) {
            return we[ee[106]](function(Pe) {
              return ee[45] == typeof Pe ? ge(ee[27] !== Pe ? [Pe] : [], [], Se) : ye(Pe, Se);
            });
          }
          function $e(Se) {
            for (var we = [], Pe = 0, Te = oe(Se); Pe < Te[ee[13]]; Pe++) {
              var Ee = Te[Pe], Me = Se[Ee];
              ee[45] != typeof Me ? Me instanceof Array ? we[ee[63]][ee[107]](we, pe(Ee, Me)) : ee[42] == typeof Me && we[ee[63]](ye(Me, Ee)) : we[ee[63]](ee[9][ee[89]](Ee, ee[8])[ee[89]](Me, ee[103])[ee[89]](Ee, ee[8]));
            }
            return we;
          }
          function ye(Se, we) {
            var Pe = me(Se), Te = Pe[0], Ee = Pe[1], Me = $e(Se), Ae = be(Se), Ne = we;
            return Ne && Te && (Ne = ee[27][ee[89]](Te, ee[64])[ee[89]](we)), ge(ae(ae([], Ee, !0), Me, !0), Ae, Ne);
          }
        }, 27972: function(ie, ne, ae) {
          Object[ee[91]](ne, ee[90], { value: !0 }), ne[ee[108]] = void 0;
          var ue = ae(16368), _e = ae(66054), fe = ae(69482), le = ae(69482);
          ne[ee[108]] = { name: ue[ee[110]][ee[109]], module: { parseXML: le[ee[111]], parseJSONtoXML: _e[ee[92]], setLogger: fe[ee[112]] } }, ne[ee[113]] = ne[ee[108]];
        }, 69482: function(ie, ne, ae) {
          Object[ee[91]](ne, ee[90], { value: !0 }), ne[ee[114]] = ye, ne[ee[112]] = Se, ne[ee[111]] = Pe;
          var ue, _e = ae(54663), fe = 3;
          function le(Te) {
            Te[ee[115]] = function() {
              return (this[ee[94]] ? this[ee[94]] : ee[27]) + (this[ee[95]] ? this[ee[95]] : ee[27]);
            };
          }
          function se(Te, Ee) {
            Ee && Object[ee[18]](Te)[ee[13]] === fe - 1 && (Te[ee[94]] = ee[27], le(Te));
          }
          (function(Te) {
            Te[ee[116]] = ee[31], Te[ee[117]] = ee[33], Te[ee[118]] = ee[32], Te[ee[119]] = ee[34], Te[ee[120]] = ee[35], Te[ee[121]] = ee[36], Te[ee[122]] = ee[37], Te[ee[123]] = ee[38], Te[ee[124]] = ee[39];
          })(ue || (ue = {}));
          var oe = function(Te, Ee, Me, Ae) {
            return Me[ee[125]] = Te, Me[ee[126]] = Ee, Te[ee[125]] || Te[ee[126]] || Te[Ee] ? Te[Ee] ? (Te[Ee][ee[63]](Me), Me) : (se(Me, Ae), Te[Ee] = [Me], Me) : (Te[Ee] = Me, Me);
          }, ce = function(Te, Ee, Me, Ae) {
            return Me[ee[125]] = Te, Me[ee[126]] = Ee, Te[Ee] ? Te[Ee][ee[127]] === Array ? (Te[Ee][ee[63]](Me), Me) : (Te[Ee] = [Te[Ee], Me], Me) : (se(Me, Ae), Te[Ee] = Me, Me);
          };
          function he(Te, Ee) {
            var Me = Ee();
            if (!Te[ee[96]](ee[64]))
              return [Te, Me];
            var Ae = Te[ee[128]](ee[64]), Ne = Ae[0], Ce = Ae[1];
            return Me[ee[93]] = Ne, [Ce, Me];
          }
          function ge(Te) {
            var Ee = Te[ee[125]];
            return delete Te[ee[125]], pe(Ee, Te), delete Te[ee[126]], Ee;
          }
          var ve, me, be = function(Te) {
            return Te[ee[94]] != null && Object[ee[18]](Te)[ee[13]] === fe;
          };
          function pe(Te, Ee) {
            if (be(Ee) && Ee[ee[126]] != null)
              if (Te[Ee[ee[126]]] !== Ee) {
                if (Te[Ee[ee[126]]][ee[127]] === Array) {
                  var Me = Te[Ee[ee[126]]][ee[14]](Ee);
                  Te[Ee[ee[126]]][Me] = Ee[ee[94]];
                }
              } else
                Te[Ee[ee[126]]] = Ee[ee[94]];
          }
          function $e(Te, Ee) {
            Te[ee[94]] = Ee[ee[70]](), le(Te);
          }
          function ye(Te) {
            return Te[ee[15]](/>\s+</g, ee[129])[ee[15]](/[\n|\r]+/g, ee[101])[ee[70]]();
          }
          function Se(Te) {
            me = Te;
          }
          function we(Te, Ee, Me) {
            Me && (Te[ee[130]] && (Te[ee[130]] = Ee(Te[ee[130]])), Te[ee[131]] && (Te[ee[131]] = Ee(Te[ee[131]])));
          }
          function Pe(Te, Ee) {
            ve = ve || new _e[ee[132]]({ attributeNamePrefix: ee[99] });
            var Me, Ae = ye(Te), Ne = {}, Ce = Ee[ee[133]] ? oe : ce;
            return ve[ee[28]](ue[ee[116]], function(Ie, xe, Ue, ke) {
              var Le = he(Ie, xe), De = Le[0], Re = Le[1];
              we(Re, Ue, Ee[ee[134]]), Ne = Ce(Ne, De, Re, ke);
            }), ve[ee[28]](ue[ee[117]], function(Ie) {
              Ne = ge(Ne);
            }), ve[ee[28]](ue[ee[118]], function(Ie, xe) {
              $e(Ne, Ee[ee[134]] ? xe(Ie) : Ie);
            }), ve[ee[28]](ue[ee[121]], function(Ie) {
              Ne[ee[95]] == null ? Ne[ee[95]] = [Ie] : Ne[ee[95]][ee[63]](Ie), le(Ne);
            }), ve[ee[28]](ue[ee[119]], function(Ie) {
              Me = new Error(ee[136][ee[89]](Ie instanceof Error ? Ie[ee[135]] : String(Ie))), me && me[ee[137]](Me[ee[135]]), ve[ee[86]](), Ne = {};
            }), ve[ee[44]](Ae), Me ? { success: !1, error: Me } : { success: !0, parsed: Ne };
          }
        } }, function(ie) {
          return function(ne) {
            return ie(ie[ee[138]] = ne);
          }(27972);
        }]);
      });
    })();
  })();
})(bitmovinplayerXml, bitmovinplayerXml.exports);
var bitmovinplayerXmlExports = bitmovinplayerXml.exports;
const XML = /* @__PURE__ */ getDefaultExportFromCjs(bitmovinplayerXmlExports);
function createBitmovinPlayerOptions(re, te) {
  var ue;
  const ee = (ue = re.adService) == null ? void 0 : ue.createBitmovinAdConfig(), ie = re.autoplay, ne = re.muted === "MUTED";
  return {
    ...te,
    playback: { autoplay: ie, muted: ne },
    advertising: ee
  };
}
const log$3 = loglevelExports.getLogger("createBitmovinPlayer");
function getModuleExport(re) {
  return isObject$1(re) && "default" in re ? re.default : re;
}
function getBitmovinModules() {
  try {
    return bitmovinplayerCoreExports.Player.getModules();
  } catch {
    return [];
  }
}
function isModuleLoaded(re) {
  return (getBitmovinModules() ?? []).includes(re);
}
function setupBitmovinModules() {
  bitmovinplayerCoreExports.Player.addModule(getModuleExport(BitmovinEngineModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(EngineNative)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(MSERendererModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(HLSModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(ABRModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(TSContainerModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(MP4ContainerModule)), isModuleLoaded(bitmovinplayerCoreExports.ModuleName.XML) || bitmovinplayerCoreExports.Player.addModule(getModuleExport(XML)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(DashModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(SubtitlesModule)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(SubtitlesVTT)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(SubtitlesNative)), bitmovinplayerCoreExports.Player.addModule(getModuleExport(VR));
}
setupBitmovinModules();
const storedPlayers = [];
function findStoredPlayerInfo(re) {
  return storedPlayers.find((ee) => ee.id === re);
}
function createBitmovinPlayer(re, te) {
  var ae;
  const ee = (ae = findStoredPlayerInfo(re.playerId)) == null ? void 0 : ae.player;
  if (ee)
    return log$3.debug("reusing previous player instance for id", re.playerId), { player: ee, id: re.playerId };
  const ie = createBitmovinPlayerOptions(re, te);
  log$3.debug("creating new bitmovin player instance", re.playerId);
  const ne = new bitmovinplayerCoreExports.Player(re.element, ie);
  return storedPlayers.push({ player: ne, id: re.playerId }), { player: ne, id: re.playerId };
}
const DEFAULT_16_9_VIDEO_TAG_POSTER_IMAGE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAABmJLR0QA/wD/AP+gvaeTAAAAGElEQVQokWNkYGD4z0ABYKJE86gBw8YAAFmzAREE4ESyAAAAAElFTkSuQmCC";
function convertToAspectRatio(re) {
  const ee = [
    { decimal: 1.7777777777777777, ratio: { width: 16, height: 9 } },
    { decimal: 0.8, ratio: { width: 4, height: 5 } },
    { decimal: 1.3333333333333333, ratio: { width: 4, height: 3 } },
    { decimal: 0.6666666666666666, ratio: { width: 2, height: 3 } },
    { decimal: 2, ratio: { width: 2, height: 1 } },
    { decimal: 1, ratio: { width: 1, height: 1 } },
    { decimal: 0.5625, ratio: { width: 9, height: 16 } }
  ].find((ie) => ie.decimal === re);
  return ee ? ee.ratio : { width: 16, height: 9 };
}
function generateVideoTagPosterSource(re) {
  if (!re)
    return DEFAULT_16_9_VIDEO_TAG_POSTER_IMAGE;
  const te = convertToAspectRatio(re), ee = te.width, ie = te.height, ne = document.createElement("canvas");
  ne.width = ee, ne.height = ie;
  const ae = ne.getContext("2d");
  return ae ? (ae.fillStyle = "black", ae.fillRect(0, 0, ee, ie), ne.toDataURL("image/png")) : DEFAULT_16_9_VIDEO_TAG_POSTER_IMAGE;
}
function calculateNumber(re) {
  return re ?? 0;
}
function resolveAdBreakFinished(re) {
  var ee;
  const te = (ee = re.ad) == null ? void 0 : ee.data.adPodInfo;
  return te ? te.adPosition === te.totalAds : !1;
}
function resolveAdBreakStarted(re) {
  var te;
  return ((te = re.ad) == null ? void 0 : te.data.adPodInfo.adPosition) === 1;
}
const defaultAdData = {
  adId: "",
  skippable: !1,
  duration: 0,
  title: ""
}, resolveAdEventData = (re) => re ?? defaultAdData;
function resolveAdSkippedOrFinishedType(re) {
  const { SKIPPED: te } = window.google.ima.AdEvent.Type;
  return re === te ? "adSkipped" : "adFinished";
}
function resolveCurrentAdType(re) {
  const { getLastMainMediaPositionInSec: te, getInitialSeekTimeInSec: ee, getMainMediaDurationInSec: ie } = re;
  return calculateAdType(
    te(),
    ee(),
    ie()
  );
}
class InteractiveMediaAds {
  constructor(te, ee) {
    Et(this, "playerId");
    Et(this, "eventEmitter");
    Et(this, "resetIsSeekingToFalse");
    Et(this, "currentPlaybackPosition");
    Et(this, "currentAdId");
    Et(this, "currentAdTitle");
    Et(this, "_isShowingAd", !1);
    Et(this, "_isPlaying", !1);
    Et(this, "handleAdEvent", (te) => {
      const { STARTED: ee, AD_PROGRESS: ie, SKIPPED: ne, COMPLETE: ae, RESUMED: ue } = window.google.ima.AdEvent.Type;
      switch (te.type) {
        case ie:
          this.handleProgressEvent(te);
          break;
        case ee:
          this.isPlaying = !0, this.isShowingAd = !0, this.handleAdStartedEvent(te);
          break;
        case ne:
        case ae:
          this.isPlaying = !1, this.isShowingAd = !1, this.handleAdFinishedEvent(te);
          break;
        case ue:
          this.isPlaying = !0;
          break;
        default:
          this.isPlaying = !1;
          break;
      }
    });
    Et(this, "handleProgressEvent", (te) => {
      const ee = te.getAdData(), ie = calculateNumber(ee == null ? void 0 : ee.duration);
      this.currentPlaybackPosition = calculateNumber(ee == null ? void 0 : ee.currentTime);
      const ne = calculateNumber(ee == null ? void 0 : ee.adPosition), ae = calculateNumber(ee == null ? void 0 : ee.totalAds);
      this.dispatchEvent({
        type: "adTimeChanged",
        duration: ie,
        playbackPosition: this.currentPlaybackPosition,
        adPosition: ne,
        totalAds: ae
      });
    });
    Et(this, "handleAdStartedEvent", (te) => {
      var _e;
      this.handleAdBreakStarted(te);
      const { adId: ee, skippable: ie, duration: ne, title: ae } = resolveAdEventData((_e = te.ad) == null ? void 0 : _e.data);
      this.currentAdId = ee, this.currentAdTitle = ae;
      const ue = resolveCurrentAdType(this.playerDataAccessor);
      this.dispatchEvent({
        type: "adStarted",
        skippable: ie,
        duration: ne,
        adType: ue
      });
    });
    Et(this, "handleAdFinishedEvent", (te) => {
      const ee = resolveAdSkippedOrFinishedType(te.type);
      this.dispatchEvent({
        type: ee
      }), this.handleAdBreakFinished(te);
    });
    this.adsManager = te, this.playerDataAccessor = ee;
    const { playerId: ie, eventEmitter: ne, resetIsSeekingToFalse: ae } = ee;
    this.playerId = ie, this.eventEmitter = ne, this.resetIsSeekingToFalse = ae, this.updateEventListeners();
  }
  get isShowingAd() {
    return this._isShowingAd;
  }
  set isShowingAd(te) {
    this._isShowingAd = te;
  }
  get isPlaying() {
    return this._isPlaying;
  }
  set isPlaying(te) {
    this._isPlaying = te;
  }
  updateEventListeners() {
    this.addOrRemoveEventListeners("removeEventListener"), this.addOrRemoveEventListeners("addEventListener");
  }
  addOrRemoveEventListeners(te) {
    const { STARTED: ee, AD_PROGRESS: ie, PAUSED: ne, SKIPPED: ae, COMPLETE: ue, RESUMED: _e } = window.google.ima.AdEvent.Type;
    this.adsManager[te](ee, this.handleAdEvent), this.adsManager[te](ie, this.handleAdEvent), this.adsManager[te](ne, this.handleAdEvent), this.adsManager[te](ae, this.handleAdEvent), this.adsManager[te](ue, this.handleAdEvent), this.adsManager[te](_e, this.handleAdEvent);
  }
  handleAdBreakStarted(te) {
    resolveAdBreakStarted(te) && (this.resetIsSeekingToFalse(), this.dispatchEvent({
      type: "adBreakStarted"
    }));
  }
  handleAdBreakFinished(te) {
    if (!resolveAdBreakFinished(te))
      return;
    const ie = resolveCurrentAdType(this.playerDataAccessor);
    this.dispatchEvent({
      type: "adBreakFinished",
      adType: ie
    });
  }
  dispatchEvent(te) {
    const ee = {
      ...te,
      playerId: this.playerId,
      adId: this.currentAdId
    };
    this.eventEmitter.fireEvent(ee);
  }
  pause() {
    this.adsManager.pause();
  }
  play() {
    this.adsManager.resume();
  }
  getCurrentTimeInSeconds() {
    return this.currentPlaybackPosition;
  }
  getActiveAdId() {
    return this.currentAdId;
  }
  getActiveAdTitle() {
    return this.currentAdTitle;
  }
  getAdCuePoints() {
    return this.adsManager.getCuePoints();
  }
  destroy() {
    this.addOrRemoveEventListeners("removeEventListener"), this.adsManager.destroy();
  }
}
function resolveVRSourceConfig(re) {
  if (re)
    return {
      contentType: "single",
      keyboardControl: {
        transitionTimingType: "none",
        transitionTime: 0.5,
        maxDisplacementSpeed: 90
      }
    };
}
const log$2 = loglevelExports.getLogger("BitmovinPlayerAdapter"), playerConfig = {
  key: "adb77626-0c8f-4879-a13a-b0be47d4222b",
  ui: !1,
  logs: {
    bitmovin: !1
  },
  adaptation: {
    preload: !1,
    limitToPlayerSize: !0
  },
  tweaks: {
    // eslint-disable-next-line camelcase
    native_hls_parsing: !0
  }
  // this is commented out on purpose, if you need VERY noisy bitmovin logs, uncomment the following lines
  // logs: {
  //     bitmovin: true,
  //     level: LogLevel.DEBUG,
  //     onLog: (logLevel, message, params) => {
  //         if (logLevel !== LogLevel.DEBUG) {
  //             console.info('BITMOVIN', logLevel, message, params);
  //         } else {
  //             console.log('BITMOVIN', logLevel, message, params);
  //         }
  //     },
  // },
};
function resolvePlayerConfig(re) {
  if (!(re != null && re.customVideoUrlRequestHeader))
    return playerConfig;
  const te = re.customVideoUrlRequestHeader.key, ee = re.customVideoUrlRequestHeader.value;
  return {
    ...playerConfig,
    network: {
      preprocessHttpRequest: async (ie, ne) => (ne.headers[te] = ee, ne)
    }
  };
}
class BitmovinPlayerAdapter {
  constructor(te) {
    Et(this, "player");
    Et(this, "currentSeekTarget", 0);
    Et(this, "currentSeekIssuer");
    Et(this, "isSeeking", !1);
    Et(this, "isPlayRequested", !1);
    Et(this, "ima");
    Et(this, "hasStarted", !1);
    Et(this, "shouldAutoPlay", !1);
    Et(this, "hasError", !1);
    Et(this, "mainMediaDurationInSec", 0);
    Et(this, "initialSeekTimeInSec", 0);
    Et(this, "segmentStartDate", 0);
    Et(this, "loaded", !1);
    Et(this, "queuedAction");
    /** the last playback time when the timeChanged event was received, used for skip tracking. */
    Et(this, "lastTimeChangedPlaybackTime", 0);
    /** the last timestamp when the timeChanged event was received, used for skip tracking. */
    Et(this, "lastTimeChangedTimestamp", 0);
    Et(this, "lastPlayerEvent");
    /**
     * the last known media position in the main video (not counting ads).
     * We need to keep track of where we are in the "normal" video in order to figure
     * out whether an ad is pre/mid/post-roll.
     */
    Et(this, "lastMainMediaPositionInSec", 0);
    Et(this, "playerId");
    Et(this, "eventEmitter");
    Et(this, "subtitleHandler", new SubtitleHandler());
    Et(this, "currentSetAudioTrackIssuer", "INITIAL");
    Et(this, "currentSetSubtitleTrackIssuer", "INITIAL");
    Et(this, "postRollAdBreakFinished", !1);
    // For `_handlePlayerEvent` we are using arrow style functions to be able to use it as event handler and still have `this` bound to the instance.
    // This enables us to easily remove the event handlers.
    // eslint-disable-next-line complexity
    Et(this, "_handlePlayerEvent", (te) => {
      try {
        let ee = !0;
        switch (te.type) {
          case bitmovinplayerCoreExports.PlayerEvent.Seeked:
          case bitmovinplayerCoreExports.PlayerEvent.TimeShifted:
            this._handleSeekDone(te, this.playerId);
            return;
          case bitmovinplayerCoreExports.PlayerEvent.Playing:
            this.isPlayRequested = !1, this.shouldAutoPlay = !1;
            break;
          case bitmovinplayerCoreExports.PlayerEvent.TimeChanged:
            ee = this._handleTimeChanged(te), this.isShowingAd() || (this.lastMainMediaPositionInSec = this.getCurrentTimeInSec());
            break;
          case bitmovinplayerCoreExports.PlayerEvent.Play:
            this.isShowingAd() || (this.lastMainMediaPositionInSec = this.getCurrentTimeInSec());
            break;
          case bitmovinplayerCoreExports.PlayerEvent.Warning:
            this.handleWarningEvent(te);
            break;
          case bitmovinplayerCoreExports.PlayerEvent.SegmentPlayback: {
            const ie = te.dateTime, ne = ie ? Date.parse(ie) : 0;
            ne > 0 && this.segmentStartDate !== ne && (this.segmentStartDate = ne);
            break;
          }
          case bitmovinplayerCoreExports.PlayerEvent.SourceUnloaded:
            this.loaded = !1;
            break;
          default:
            break;
        }
        switch (ee && this.mapEventAndEmit(te, this.playerId), te.type) {
          case bitmovinplayerCoreExports.PlayerEvent.TimeChanged:
            this.handleTimeChangedAfterEmit();
            break;
          case bitmovinplayerCoreExports.PlayerEvent.SubtitleEnabled:
          case bitmovinplayerCoreExports.PlayerEvent.SubtitleDisabled:
          case bitmovinplayerCoreExports.PlayerEvent.SubtitleDisable:
            this.currentSetSubtitleTrackIssuer = void 0, this.eventEmitter.fireEvent(this.subtitleHandler.resetAndGetEvent(this.playerId));
            break;
          case bitmovinplayerCoreExports.PlayerEvent.AudioChanged:
            this.currentSetAudioTrackIssuer = void 0;
            break;
          default:
            break;
        }
      } catch (ee) {
        console.error("ERROR DURING EVENT HANDLING", ee);
      }
      this.lastPlayerEvent = te, this.postRollAdBreakFinished = !1;
    });
    Et(this, "_handleSubtitleEvent", (te) => {
      const ee = this.subtitleHandler.handleSubtitleEvent(te, this.playerId);
      this.eventEmitter.fireEvent(ee);
    });
    Et(this, "resetIsSeekingToFalse", () => {
      this.isSeeking = !1;
    });
    Et(this, "handleAdBreakFinished", (te) => {
      te.type === "adBreakFinished" && te.adType === "POST_ROLL" && (this.postRollAdBreakFinished = !0);
    });
    var ae;
    const ee = te.playerId;
    this.eventEmitter = te.eventEmitter, this.playerId = ee;
    const ie = createBitmovinPlayer(te, resolvePlayerConfig(te));
    this.player = ie.player;
    const ne = this.player;
    te.autoplay && (this.hasStarted = !0, this.isPlayRequested = !0, this.shouldAutoPlay = !0), te.enableDataZoom === "ACTIVE" && ((ae = te.dataZoomConfig) != null && ae.configId) && createDataZoomTracker(te.dataZoomConfig, ne), this.addAllEventListeners(ne);
  }
  addAllEventListeners(te) {
    this.addOrRemoveAllEventListeners(te, "add");
  }
  removeAllEventListeners(te) {
    this.addOrRemoveAllEventListeners(te, "remove");
  }
  addOrRemoveEventListener(te, ee, ie, ne) {
    ee === "add" ? te.on(ie, ne) : te.off(ie, ne);
  }
  addOrRemoveAllEventListeners(te, ee) {
    this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.AirplayChanged, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.AudioChanged, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.CueEnter, this._handleSubtitleEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.CueExit, this._handleSubtitleEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.CueUpdate, this._handleSubtitleEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Error, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Muted, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Paused, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Play, this._handlePlayerEvent), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.PlaybackFinished,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.PlaybackSpeedChanged,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Playing, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Seek, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Seeked, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.SourceUnloaded, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.StallEnded, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.StallStarted, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.SubtitleAdded, this._handlePlayerEvent), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.SubtitleDisabled,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.SubtitleEnabled,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.TimeChanged, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.TimeShift, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.TimeShifted, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Unmuted, this._handlePlayerEvent), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.ViewModeChanged,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.VolumeChanged, this._handlePlayerEvent), this.addOrRemoveEventListener(te, ee, bitmovinplayerCoreExports.PlayerEvent.Warning, this._handlePlayerEvent), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.SegmentPlayback,
      this._handlePlayerEvent
    ), this.addOrRemoveEventListener(
      te,
      ee,
      bitmovinplayerCoreExports.PlayerEvent.VideoQualityChanged,
      this._handlePlayerEvent
    );
  }
  // For `_handleTimeChanged` we are using arrow style functions to be able to use it as event handler and still have `this` bound to the instance.
  // This enables us to easily remove the event handlers.
  _handleTimeChanged(te) {
    let ee = !0;
    return this.isSeeking || this.isShowingAd() ? ee = !1 : this.checkForTimeSkipAndNotify(te), ee;
  }
  handleWarningEvent(te) {
    var ee, ie;
    if (te.code === bitmovinplayerCoreExports.WarningCode.PLAYBACK_COULD_NOT_BE_STARTED) {
      const ne = (ee = this.player) == null ? void 0 : ee.getConfig(!0).playback, ae = (ne == null ? void 0 : ne.autoplay) ?? !1;
      if (!((ne == null ? void 0 : ne.muted) ?? !1) && ae && this.shouldAutoPlay) {
        log$2.debug("trying another auto-play with mute turned on"), this.shouldAutoPlay = !1;
        const _e = ((ie = this.player) == null ? void 0 : ie.isMuted()) ?? !1;
        this.mute("INITIAL"), this.play().catch((fe) => {
          log$2.warn("auto play with mute on did not work either", fe), _e || this.unmute("INITIAL");
        });
      }
    }
  }
  getSubtitlesApi() {
    var te;
    return (te = this.player) == null ? void 0 : te.subtitles;
  }
  _handleSeekDone(te, ee) {
    var ae;
    this.isSeeking = !1;
    const ie = (ae = this.player) == null ? void 0 : ae.getCurrentTime(bitmovinplayerCoreExports.TimeMode.AbsoluteTime), ne = {
      ...te,
      issuer: this.currentSeekIssuer,
      time: ie
    };
    this.currentSeekTarget = 0, this.currentSeekIssuer = void 0, this.lastTimeChangedTimestamp = 0, this.mapEventAndEmit(ne, ee);
  }
  canSeekOrTimeshiftForward() {
    return this.player ? this.player.isLive() ? this.player.getTimeShift() < 0 : this.getCurrentTimeInSec() < Math.max(0, this.getMainMediaDurationInSec() - 1) : !1;
  }
  canSeekOrTimeshiftBackward() {
    return this.player ? this.player.isLive() ? this.player.getTimeShift() > this.player.getMaxTimeShift() : this.getCurrentTimeInSec() > 1 : !1;
  }
  disableSubtitle() {
    var ee;
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    const te = this.getSelectedSubtitleTrack();
    te && ((ee = this.getSubtitlesApi()) == null || ee.disable(te.id));
  }
  enableSubtitle(te, ee = "USER") {
    var ie;
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.currentSetSubtitleTrackIssuer = ee, (ie = this.getSubtitlesApi()) == null || ie.enable(te, !0);
  }
  getAvailableVideoQualities() {
    var ee;
    return (((ee = this.player) == null ? void 0 : ee.getAvailableVideoQualities()) ?? []).map((ie) => ({
      bitrate: ie.bitrate,
      height: ie.height,
      id: ie.id,
      width: ie.width,
      frameRate: ie.frameRate
    }));
  }
  getLiveVariant() {
    if (!this.player)
      return "LINEAR";
    if (this.player.isLive())
      return isLinearStream(this.player.getMaxTimeShift()) ? "LINEAR" : "DVR";
    throw new Error("trying to get LiveVariant on a VOD player");
  }
  getPlaybackMode() {
    return this.player ? this.player.isLive() ? "LIVE" : "VOD" : "UNKNOWN";
  }
  getPlayerType() {
    return "VIDEO";
  }
  getAvailableSubtitleTracks() {
    var ee;
    return (((ee = this.getSubtitlesApi()) == null ? void 0 : ee.list()) ?? []).filter((ie) => isValidSubtitleTrack(ie));
  }
  getSelectedSubtitleTrack() {
    var te;
    return (((te = this.getSubtitlesApi()) == null ? void 0 : te.list()) ?? []).find((ee) => ee.enabled);
  }
  isAirPlayAvailable() {
    var te;
    return !!((te = this.player) != null && te.isAirplayAvailable());
  }
  isPlayingVideoViaAirPlay() {
    var te;
    return !!((te = this.player) != null && te.isAirplayActive());
  }
  isShowingAd() {
    var te;
    return !!((te = this.getPlayerAdvertisingAPI()) != null && te.isShowingAd);
  }
  getActiveAdId() {
    var te;
    return (te = this.getPlayerAdvertisingAPI()) == null ? void 0 : te.getActiveAdId();
  }
  getActiveAdTitle() {
    var te;
    return (te = this.getPlayerAdvertisingAPI()) == null ? void 0 : te.getActiveAdTitle();
  }
  playVideoViaAirPlay() {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.isAirPlayAvailable() && this.player.showAirplayTargetPicker();
  }
  setStandardViewMode() {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.isInPictureInPictureMode() && document.exitPictureInPicture(), this.player.setViewMode(bitmovinplayerCoreExports.ViewMode.Inline);
  }
  setHasError(te) {
    this.hasError = te;
  }
  isPictureInPictureAvailable() {
    return document.pictureInPictureEnabled;
  }
  isFullscreenAvailable() {
    var te;
    return !!((te = this.player) != null && te.isViewModeAvailable(bitmovinplayerCoreExports.ViewMode.Fullscreen));
  }
  isInPictureInPictureMode() {
    return !!document.pictureInPictureElement;
  }
  isInFullscreenMode() {
    var te;
    return ((te = this.player) == null ? void 0 : te.getViewMode()) === bitmovinplayerCoreExports.ViewMode.Fullscreen;
  }
  isPlayerLoaded() {
    return this.loaded;
  }
  togglePictureInPicture() {
    this.setPictureInPicture(!this.isInPictureInPictureMode());
  }
  setPictureInPicture(te) {
    var ee;
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    te ? (ee = this.getVideoElement()) == null || ee.requestPictureInPicture() : document.exitPictureInPicture();
  }
  toggleFullscreen(te) {
    this.setFullscreen(!this.isInFullscreenMode(), te);
  }
  setFullscreen(te, ee) {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    te ? this.player.setViewMode(bitmovinplayerCoreExports.ViewMode.Fullscreen, { fullscreenElement: ee }) : this.player.setViewMode(bitmovinplayerCoreExports.ViewMode.Inline);
  }
  getCurrentTimeInSeconds() {
    var te;
    return this.isShowingAd() && this.ima ? this.ima.getCurrentTimeInSeconds() ?? 0 : ((te = this.player) == null ? void 0 : te.getCurrentTime()) ?? 0;
  }
  getCurrentTimeInSec() {
    var ie;
    if (this.isSeeking)
      return this.currentSeekTarget;
    if (this.getPlaybackMode() === "LIVE")
      return ((ie = this.player) == null ? void 0 : ie.getTimeShift()) ?? 0;
    const te = this.getCurrentTimeInSeconds();
    if (isNaN(te))
      return 0;
    const ee = this.getDurationInSec();
    return ee !== 0 && te > ee ? ee : te;
  }
  getLastTimeChangedPlaybackTime() {
    return this.lastTimeChangedPlaybackTime;
  }
  /**
   * Returns the timestamp in milliseconds since 1970 of when the first video segment which included
   * a reference dateTimestamp. This usually is the actual start date/time of when the (now VOD) video
   * initially aired. This is important for features such as EaseLive which have specific "events"
   * at the actual play time (e.g. they show some overlay of when a goal was scored in a football match).
   * Therefore, easeLive needs accurate actual air timestamps.
   * Further note that typically only the first few segments contain a dateTime timestamp.
   */
  getLatestSegmentStartTimestamp() {
    return this.segmentStartDate;
  }
  getDurationInSec() {
    var te;
    return ((te = this.player) == null ? void 0 : te.getDuration()) ?? 0;
  }
  getMaxTimeShiftInSec() {
    var te;
    return ((te = this.player) == null ? void 0 : te.getMaxTimeShift()) ?? 0;
  }
  getTimeShiftInSec() {
    var te;
    return ((te = this.player) == null ? void 0 : te.getTimeShift()) ?? 0;
  }
  getInitialSeekTimeInSec() {
    return this.initialSeekTimeInSec;
  }
  getIsPlayRequested() {
    return this.isPlayRequested;
  }
  getShouldAutoPlay() {
    return this.shouldAutoPlay;
  }
  getCurrentSetAudioTrackIssuer() {
    return this.currentSetAudioTrackIssuer;
  }
  getCurrentSetSubtitleTrackIssuer() {
    return this.currentSetSubtitleTrackIssuer;
  }
  getMainMediaDurationInSec() {
    var te;
    return this.isShowingAd() ? this.mainMediaDurationInSec : ((te = this.player) == null ? void 0 : te.getDuration()) ?? 0;
  }
  getLastMainMediaPositionInSec() {
    return this.lastMainMediaPositionInSec;
  }
  getPlayerAdvertisingAPI() {
    return this.ima;
  }
  getAdCuePoints() {
    var te;
    return (te = this.ima) == null ? void 0 : te.getAdCuePoints();
  }
  getVideoBufferLength() {
    var te;
    return this.isSeeking ? 0 : ((te = this.player) == null ? void 0 : te.getVideoBufferLength()) ?? 0;
  }
  setPlaybackSpeed(te) {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.player.setPlaybackSpeed(te);
  }
  getPlaybackSpeed() {
    var te;
    return ((te = this.player) == null ? void 0 : te.getPlaybackSpeed()) ?? 1;
  }
  async load({ source: te, initialSeekTimeInSec: ee, aspectRatio: ie }) {
    var ae, ue, _e;
    this.loaded = !1, this.lastTimeChangedTimestamp = 0, this.lastPlayerEvent = void 0, this.currentSetSubtitleTrackIssuer = "INITIAL", this.currentSetAudioTrackIssuer = "INITIAL", log$2.debug("load player for instance", this.playerId, te);
    const ne = {
      hls: (te == null ? void 0 : te.mediaType) === "application/vnd.apple.mpegurl" ? te.videoUrl : void 0,
      dash: (te == null ? void 0 : te.mediaType) === "application/dash+xml" ? te.videoUrl : void 0,
      progressive: (te == null ? void 0 : te.mediaType) === "video/mp4" ? te.videoUrl : void 0,
      vr: resolveVRSourceConfig(te == null ? void 0 : te.vr)
    };
    try {
      await ((ae = this.player) == null ? void 0 : ae.unload());
    } catch (fe) {
      log$2.error("error unloading bitmovin player with data", this.playerId, fe);
    }
    log$2.debug("loading bitmovin player with data", this.playerId, ne);
    try {
      await ((ue = this.player) == null ? void 0 : ue.load(ne)), this.setVideoElementPoster(ie), this.loaded = !0, this.mainMediaDurationInSec = ((_e = this.player) == null ? void 0 : _e.getDuration()) ?? 0, this.initialSeekTimeInSec = ee, log$2.debug("Successfully loaded source for instance", this.playerId), this.performInitialSeekOrTimeshift(ee), this.queuedAction && (log$2.debug("have task queue after load", this.queuedAction), this.processAction(this.queuedAction), this.queuedAction = void 0), this.shouldAutoPlay && this.play().catch((fe) => {
        log$2.error("error while auto play after load", fe), this.pause();
      });
    } catch (fe) {
      throw this.loaded = !1, log$2.error("Error while loading source for instance", this.playerId, fe), new Error(`bitmovin load error ${fe}`);
    }
  }
  setVideoElementPoster(te) {
    const ee = this.getVideoElement();
    ee && (ee.poster = generateVideoTagPosterSource(te));
  }
  performInitialSeekOrTimeshift(te) {
    te > 0 && this.getPlaybackMode() === "VOD" ? this.seek(te, "INITIAL") : this.getPlaybackMode() === "LIVE" && te < 0 && this.timeShift(te, "INITIAL");
  }
  processAction(te) {
    switch (te) {
      case "PLAY":
        this.play();
        break;
      case "PAUSE":
        this.pause();
        break;
    }
  }
  mute(te = "USER") {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.player.mute(te);
  }
  pause() {
    var te;
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    if (this.isPlayRequested = !1, !this.loaded) {
      this.queuedAction = "PAUSE";
      return;
    }
    this.isShowingAd() ? (te = this.getPlayerAdvertisingAPI()) == null || te.pause() : this.player.pause();
  }
  async play() {
    var te;
    if (!this.loaded) {
      this.queuedAction = "PLAY";
      return;
    }
    if (this.hasStarted = !0, this.isPlayRequested = !0, !this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    try {
      this.isShowingAd() ? (te = this.getPlayerAdvertisingAPI()) == null || te.play() : await this.player.play();
    } catch (ee) {
      throw log$2.warn("failed to play", ee), this.isPlayRequested = !1, ee;
    }
  }
  async reset() {
    this.isInPictureInPictureMode() && this.setPictureInPicture(!1), this.setFullscreen(!1), this.hasStarted = !1, this.shouldAutoPlay = !1, this.isPlayRequested = !1, this.hasError = !1, this.queuedAction = void 0, this.lastTimeChangedTimestamp = 0, this.lastPlayerEvent = void 0, this.lastTimeChangedPlaybackTime = 0, this.currentSetAudioTrackIssuer = "INITIAL", this.currentSetSubtitleTrackIssuer = "INITIAL", this.currentSeekIssuer = void 0, this.segmentStartDate = 0, this.loaded = !1, this.destroyImaInstance(), await this.dispatchUnloadedEventAndUnload();
  }
  async dispatchUnloadedEventAndUnload() {
    var te;
    this.eventEmitter.fireEvent({
      type: "sourceUnloaded",
      playerId: this.playerId
    }), await ((te = this.player) == null ? void 0 : te.unload());
  }
  seek(te, ee) {
    if (this.getPlaybackMode() === "LIVE")
      throw new Error("cannot seek in live mode, use `timeshift` instead");
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    return this.currentSeekTarget = te, this.currentSeekIssuer = ee, this.isSeeking = !0, log$2.debug("SEEK player seek target ", this.currentSeekTarget, "is seeking", this.isSeeking), ee === "RESTART" && te === 0 && (this.lastMainMediaPositionInSec = 0, this.initialSeekTimeInSec = 0), this.player.seek(te, ee);
  }
  timeShift(te, ee = "USER") {
    var ie;
    if (!((ie = this.player) != null && ie.isLive()))
      throw new Error("player is not in live mode");
    return this.isSeeking = !0, this.currentSeekIssuer = ee, this.currentSeekTarget = this.player.getCurrentTime(bitmovinplayerCoreExports.TimeMode.AbsoluteTime) + te, this.player.timeShift(te, ee), !0;
  }
  unmute(te = "USER") {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.player.unmute(te);
  }
  async destroy() {
    this.player && (destroyDataZoomTracker(this.player), this.removeAllEventListeners(this.player)), this.destroyImaInstance(), await this.reset();
  }
  hasEnded() {
    var te;
    return this.postRollAdBreakFinished || !!((te = this.player) != null && te.hasEnded());
  }
  getPlayerStatus() {
    return this.hasError ? "ERROR" : !this.player || !this.loaded ? (log$2.info("dont have player or source not loaded"), "IDLE") : this.player.isStalled() ? "BUFFERING" : this.isPlaying() ? "PLAYING" : this.hasEnded() ? "ENDED" : this.isPlayRequested ? "BUFFERING" : this.hasStarted ? "PAUSED" : "IDLE";
  }
  isPlaying() {
    var ie, ne;
    const te = ((ie = this.player) == null ? void 0 : ie.isPlaying()) ?? !1, ee = ((ne = this.getPlayerAdvertisingAPI()) == null ? void 0 : ne.isPlaying) === !0;
    return te || ee;
  }
  mapEventAndEmit(te, ee) {
    if (!this.player)
      throw new Error("dont have player");
    const ie = mapBitmovinPlayerEvent(te, ee, this);
    log$2.debug(ee, "received bitmovin event", te, "mapped to", ie), ie && this.eventEmitter.fireEvent(ie);
  }
  checkForTimeSkipAndNotify(te) {
    var ie;
    const ee = Date.now();
    if (((ie = this.lastPlayerEvent) == null ? void 0 : ie.type) !== bitmovinplayerCoreExports.PlayerEvent.TimeChanged) {
      this.updateLastTimeChangedPlaybackTimeAndTimeStamp(te.time);
      return;
    }
    if (this.lastTimeChangedTimestamp && this.getPlaybackSpeed() === 1 && this.getPlaybackMode() === "LIVE") {
      const ne = ee - this.lastTimeChangedTimestamp, ae = te.time - this.lastTimeChangedPlaybackTime, ue = Math.abs(
        ne / 1e3 - ae
      );
      ue > 1 && (log$2.info("TIME SKIP detected", {
        previousPlaybackTimeInSec: this.lastTimeChangedPlaybackTime,
        currentPlaybackTimeInSec: te.time,
        timeSkipDurationInSec: ue
      }), this.eventEmitter.fireEvent({
        type: "timeSkipped",
        playerId: this.playerId,
        previousPlaybackTimeInSec: this.lastTimeChangedPlaybackTime,
        currentPlaybackTimeInSec: te.time
      }));
    }
    this.updateLastTimeChangedPlaybackTimeAndTimeStamp(te.time);
  }
  updateLastTimeChangedPlaybackTimeAndTimeStamp(te) {
    te && (this.lastTimeChangedTimestamp = Date.now(), this.lastTimeChangedPlaybackTime = te);
  }
  handleTimeChangedAfterEmit() {
    this.isShowingAd() || (this.lastMainMediaPositionInSec = this.getCurrentTimeInSec());
  }
  /**
   * Indicates that the current media is a live stream, and we are currently playing whatever is "live" (i.e. max -4s timeshift).
   */
  isStreamAtLivePos() {
    const te = this.player;
    return te ? te.isLive() && te.getTimeShift() >= -4 : !1;
  }
  getAvailableAudioTracks() {
    return this.player ? this.player.getAvailableAudio().filter((te) => te.lang.length) : [];
  }
  getAudioLanguage() {
    var te, ee;
    return ((ee = (te = this.player) == null ? void 0 : te.getAudio()) == null ? void 0 : ee.lang) ?? "";
  }
  getAudioLanguageId() {
    var te, ee;
    return ((ee = (te = this.player) == null ? void 0 : te.getAudio()) == null ? void 0 : ee.id) ?? "";
  }
  setAudioTrack(te, ee = "USER") {
    if (!this.player)
      throw Error("setAudioTrack: why is the player undef here?");
    this.currentSetAudioTrackIssuer = ee, this.player.setAudio(te);
  }
  getSubtitleTrackLanguage() {
    var te;
    return (te = this.getSelectedSubtitleTrack()) == null ? void 0 : te.lang;
  }
  getVolume() {
    var te, ee;
    return (te = this.player) != null && te.isMuted() ? 0 : ((ee = this.player) == null ? void 0 : ee.getVolume()) ?? 100;
  }
  setVolume(te) {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    te === 0 && this.player.mute(), te > 0 && this.player.isMuted() && this.player.unmute(), this.player.setVolume(te);
  }
  /**
   * Returns actual current resolution of the playing video.
   */
  getVideoQuality() {
    if (!this.player)
      return log$2.info("dont have player"), {
        height: 0,
        width: 0
      };
    const te = this.getVideoElement();
    return {
      height: (te == null ? void 0 : te.videoHeight) ?? 0,
      width: (te == null ? void 0 : te.videoWidth) ?? 0
    };
  }
  /**
   * Returns the video quality a user has manually selected,
   * or a quality with the id of "auto" when no manual selection has been made yet.
   */
  getSelectedVideoQuality() {
    var ne;
    if (!this.player)
      return log$2.info("dont have player"), defaultVideoQuality();
    const te = this.player.getVideoQuality();
    if (te.id !== "auto")
      return { isAuto: !1, ...te };
    const ee = this.player.getPlaybackVideoData(), ie = (ne = this.getAvailableVideoQualities().find(
      (ae) => ae.id === ee.id
    )) == null ? void 0 : ne.frameRate;
    return {
      ...defaultVideoQuality(),
      height: ee.height,
      width: ee.width,
      frameRate: ie
    };
  }
  setVideoQuality(te) {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    this.player.setVideoQuality(te);
  }
  async scheduleAd(te, ee = "vast") {
    var _e;
    const ie = (_e = this.player) == null ? void 0 : _e.ads;
    if (!ie)
      throw new Error("dont have ad player api");
    const ne = ie.list();
    ne.length > 0 && (log$2.debug("got existing ad breaks", ne), ne.forEach((fe) => {
      ie.discardAdBreak(fe.id);
    }));
    const ae = ee === "vmap" ? bitmovinplayerAdvertisingCoreExports.AdTagType.VMAP : bitmovinplayerAdvertisingCoreExports.AdTagType.VAST, ue = {
      tag: {
        url: te,
        type: ae
      }
    };
    return log$2.debug("schedule ad ", ue), await ie.schedule(ue);
  }
  getTechVersion() {
    var te;
    return (te = this.player) == null ? void 0 : te.version;
  }
  getActualPlayerInstance() {
    return this.player;
  }
  getVideoElement() {
    var te;
    return (te = this.player) == null ? void 0 : te.getVideoElement();
  }
  enableInteractiveMediaAds(te) {
    this.destroyImaInstance(), this.ima = new InteractiveMediaAds(te, {
      playerId: this.playerId,
      eventEmitter: this.eventEmitter,
      getLastMainMediaPositionInSec: () => this.lastMainMediaPositionInSec,
      getInitialSeekTimeInSec: () => this.initialSeekTimeInSec,
      getMainMediaDurationInSec: () => this.mainMediaDurationInSec,
      resetIsSeekingToFalse: this.resetIsSeekingToFalse
    }), this.eventEmitter.addEventListener(this.handleAdBreakFinished);
  }
  destroyImaInstance() {
    this.ima && (this.ima.destroy(), this.ima = void 0, this.eventEmitter.removeEventListener(this.handleAdBreakFinished));
  }
  isVRVideo() {
    var te, ee;
    return !!((ee = (te = this.player) == null ? void 0 : te.getSource()) != null && ee.vr);
  }
  setViewingDirection(te, ee) {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    if (!this.isVRVideo())
      throw new Error("trying to set viewing direction on non-VR video");
    this.player.vr.setViewingDirection({ yaw: te, pitch: ee, roll: 0 });
  }
  getViewingDirection() {
    if (!this.player)
      throw new Error("unexpectedly the player is `undefined` during a user interaction");
    if (!this.isVRVideo())
      throw new Error("trying to get viewing direction on non-VR video");
    const te = this.player.vr.getViewingDirection();
    return { x: te.yaw, y: te.pitch };
  }
}
function isValidSubtitleTrack(re) {
  return re.lang !== "unknown";
}
function createPlayerAdapter(re) {
  switch (re.adapterType) {
    case "BITMOVIN":
      return new BitmovinPlayerAdapter(re);
    case "SIMULATION":
      return new SimulationPlayerAdapter(re);
    default:
      throw new Error(`unknown player adapter type ${re.adapterType}`);
  }
}
function convertToServiceEnablement(re, te) {
  return re === void 0 ? te : re;
}
function resolveGoogleAnalyticsConfig(re) {
  return {
    ...re,
    defaultPlayerMode: re.defaultPlayerMode ?? "standard",
    customInitAttributes: re.customInitAttributes ?? {},
    dataLayer: re.dataLayer ?? window.dataLayer
  };
}
function resolveTrackingSettings(re) {
  var ue;
  const te = re.configs, ee = re.services;
  if ((ee == null ? void 0 : ee.dataZoom) === "ACTIVE") {
    if (!((ue = te.dataZoom) != null && ue.configId))
      throw new Error("cannot enable dataZoom without a configuration id");
    if (!te.dataZoom.assetId)
      throw new Error("cannot enable dataZoom without an assetId");
  }
  const ne = {
    googleAnalytics: convertToServiceEnablement(ee == null ? void 0 : ee.googleAnalytics, "ACTIVE"),
    dataZoom: convertToServiceEnablement(ee == null ? void 0 : ee.dataZoom, "INACTIVE")
  }, ae = {
    ...te,
    googleAnalytics: resolveGoogleAnalyticsConfig(te.googleAnalytics)
  };
  return {
    ...re,
    configs: ae,
    services: ne
  };
}
function getValueOrDefault(re, te) {
  return re ?? te;
}
function resolvePlayerDataConfiguration(re) {
  const te = getValueOrDefault(re.autoplay, !1), ee = getValueOrDefault(re.cookieConsent, !1), ie = te ? "MUTED" : "NOT_MUTED", ne = getValueOrDefault(re.feedbackUrl, DEFAULT_FEEDBACK_URL), ae = getValueOrDefault(re.initialSeekTimeInSec, 0), ue = getValueOrDefault(re.muted, ie), _e = getValueOrDefault(re.phasing, !1), fe = getValueOrDefault(re.sharingEnabled, !0), le = getValueOrDefault(re.environment, "PRODUCTION"), se = getValueOrDefault(re.productPlacement, "hidden"), oe = getValueOrDefault(re.adMarkerEnabled, "INACTIVE");
  return {
    ...re,
    autoplay: te,
    adMarkerEnabled: oe,
    configurationType: "VIDEO",
    cookieConsent: ee,
    environment: le,
    feedbackUrl: ne,
    hooks: re.hooks ?? [],
    initialSeekTimeInSec: ae,
    muted: ue,
    phasing: _e,
    productPlacement: se,
    sharingEnabled: fe,
    tracking: resolveTrackingSettings(re.tracking)
  };
}
const log$1 = loglevelExports.getLogger("VideoPlayerCoordinator"), creationStats = {};
function printCreationStats() {
  log$1.debug("Creation Stats", creationStats);
}
const OBSERVED_DOM_EVENT_TYPES = [RBUP_AUDIO_DOM_EVENT_TYPE, RBUP_VIDEO_DOM_EVENT_TYPE];
class VideoPlayerCoordinator {
  constructor(te) {
    Et(this, "playerId");
    Et(this, "urlSharingStrategy");
    Et(this, "dataLoader");
    Et(this, "adService");
    Et(this, "eventEmitter");
    Et(this, "player");
    Et(this, "phasingService");
    Et(this, "storageService");
    Et(this, "hookService");
    Et(this, "thumbnailService");
    Et(this, "trackingService");
    Et(this, "mediaSessionService");
    Et(this, "dispatchElement");
    Et(this, "playerConfig");
    Et(this, "_fullscreenElement");
    Et(this, "currentErrorDetails");
    Et(this, "lastPlaybackPosition", 0);
    Et(this, "cumulatedPlayTimeInSec", 0);
    Et(this, "mediaMetaData");
    /** If a seek attempt happens during an ad is playing back the position will be stored and used to execute seek after the ad has finished. */
    Et(this, "storedSeekOrTimeShift");
    Et(this, "HdPlaybackHeightThreshold", 700);
    Et(this, "liveStatus");
    Et(this, "loaded", !1);
    Et(this, "destroyed", !1);
    Et(this, "instanceId", v4());
    Et(this, "lastRequestedVolume", 100);
    Et(this, "stopped", !1);
    // eslint-disable-next-line complexity
    Et(this, "genericListener", (te) => {
      switch (te.type) {
        case "loaded":
          this.handleLoadedEvent(te), this.dispatchDomEvent(te, document);
          break;
        case "playing":
          this.handlePlayingEvent(te);
          break;
        case "timeChanged":
          this.handleTimeChangedEvent(te);
          break;
        case "seekingDone":
          this.handleSeekingEvent(te);
          break;
        case "timeshiftingDone":
          this.handleTimeshiftingDoneEvent(te);
          break;
        case "play":
          this.dispatchDomEvent(te, document);
          break;
        case "error":
          this.handlePlayerOrDataError(te);
          break;
        case "liveStatusChanged":
          this.handleLiveStatusChanged(te);
          break;
        case "adBreakFinished":
          this.handleAdBreakFinished(te);
          break;
        case "timeSkipped":
          this.handleTimeSkippedEvent(te);
          break;
      }
      this.dispatchDomEvent(te);
    });
    Et(this, "domEventListener", (te) => {
      if (!OBSERVED_DOM_EVENT_TYPES.includes(te.type))
        return;
      const ie = te.detail;
      if (ie.playerId === this.playerId)
        return;
      const ne = this.getPlayerStatus();
      ie.type === "play" && !["IDLE", "PAUSED"].includes(ne) && (log$1.debug("received play event from player", ie.playerId, "pausing"), this.pause());
    });
    var ae, ue;
    this.playerId = te.playerId;
    const ee = creationStats[this.playerId] ?? { createCount: 0, destroyCount: 0 };
    ee.createCount += 1, creationStats[this.playerId] = ee, printCreationStats(), this.eventEmitter = te.eventEmitter ?? new EventEmitter$1(), this.dataLoader = te.dataLoader, this.dispatchElement = te.dispatchElement, this.urlSharingStrategy = te.urlSharingStrategy, this.adService = te.adService;
    const ie = resolvePlayerDataConfiguration(te.config), ne = ((ae = te.config._debug) == null ? void 0 : ae.playerAdapterType) ?? "BITMOVIN";
    if (this.playerConfig = ie, this.phasingService = te.phasingService, this.thumbnailService = te.config.thumbnailService ?? new CommonThumbnailService(), this.hookService = new HookService(
      te.config.hooks ?? []
    ), !te.config.assetId)
      throw new Error("no asset id");
    log$1.debug("created coordinator", this.playerId, this.instanceId, ee), this.player = createPlayerAdapter({
      adapterType: ne,
      adService: te.adService,
      muted: ie.muted,
      playerId: te.playerId,
      element: te.divElement,
      eventEmitter: this.eventEmitter,
      autoplay: ie.autoplay,
      enableDataZoom: ie.tracking.services.dataZoom,
      dataZoomConfig: ie.tracking.configs.dataZoom,
      customVideoUrlRequestHeader: (ue = te.config._debug) == null ? void 0 : ue.customVideoUrlRequestHeader
    }), this.addEventListener(this.genericListener), ie.tracking.services.googleAnalytics === "ACTIVE" && (this.trackingService = createTrackingService(
      this,
      ie.tracking.configs.googleAnalytics.dataLayer
    )), this.mediaSessionService = new MediaSessionService(this), document.addEventListener(RBUP_VIDEO_DOM_EVENT_TYPE, this.domEventListener), document.addEventListener(RBUP_AUDIO_DOM_EVENT_TYPE, this.domEventListener);
  }
  get fullscreenElement() {
    return this._fullscreenElement;
  }
  set fullscreenElement(te) {
    this._fullscreenElement = te;
  }
  get isAirPlayAvailable() {
    return this.player.isAirPlayAvailable();
  }
  get isVideoLoaded() {
    return this.loaded;
  }
  addEventListener(te) {
    this.eventEmitter.addEventListener(te);
  }
  async destroy() {
    var ee, ie, ne;
    this.loaded = !1, this.destroyed = !0;
    const te = creationStats[this.playerId] ?? { createCount: 0, destroyCount: 0 };
    te.destroyCount += 1, creationStats[this.playerId] = te, printCreationStats(), document.removeEventListener(RBUP_VIDEO_DOM_EVENT_TYPE, this.domEventListener), document.removeEventListener(RBUP_AUDIO_DOM_EVENT_TYPE, this.domEventListener);
    try {
      (ee = this.phasingService) == null || ee.stop(), (ie = this.trackingService) == null || ie.destroy(), this.mediaSessionService.destroy(), (ne = this.storageService) == null || ne.destroy();
      const ae = this.playerConfig, ue = this.mediaMetaData;
      await this.hookService.beforeDestroy(ae, ue, this), this.storageService = void 0;
    } catch (ae) {
      const ue = resolveErrorMessageFromUnknown(ae);
      log$1.warn(
        "error destroying player adapter services for player",
        this.playerId,
        this.instanceId,
        ue
      );
    }
    try {
      await this.player.destroy(), log$1.debug("done destroying coordinator", this.playerId, this.instanceId);
    } catch (ae) {
      const ue = resolveErrorMessageFromUnknown(ae);
      log$1.warn("error destroying player adapter for player", this.playerId, this.instanceId, ue);
    }
  }
  canSeekOrTimeshiftBackward() {
    return this.player.canSeekOrTimeshiftBackward();
  }
  canSeekOrTimeshiftForward() {
    return this.player.canSeekOrTimeshiftForward();
  }
  canPlayVideo() {
    var te, ee;
    return !!((ee = (te = this.getMediaMetaData()) == null ? void 0 : te.mediaSrc) != null && ee.videoUrl);
  }
  disableSubtitle(te = "USER") {
    return this.player.disableSubtitle(te);
  }
  enableSubtitle(te, ee = "USER") {
    return this.player.enableSubtitle(te, ee);
  }
  getAvailableAudioTracks() {
    return this.player.getAvailableAudioTracks();
  }
  getSelectedAudioTrack() {
    const te = this.getAvailableAudioTracks(), ee = this.player.getAudioLanguageId();
    return te.find((ie) => ie.id === ee);
  }
  getAvailableVideoQualities() {
    return this.player.getAvailableVideoQualities();
  }
  getSubtitleTracks() {
    return this.player.getAvailableSubtitleTracks();
  }
  getSelectedSubtitleTrack() {
    return this.player.getSelectedSubtitleTrack();
  }
  getCumulatedPlayTimeInSec() {
    return this.cumulatedPlayTimeInSec;
  }
  getCurrentErrorDetails() {
    return this.currentErrorDetails;
  }
  getDurationInSec() {
    return this.player.getDurationInSec();
  }
  /**
   * Returns the timestamp in milliseconds since 1970 of when the first video segment which included
   * a reference dateTimestamp. This usually is the actual start date/time of when the (now VOD) video
   * initially aired. This is important for features such as EaseLive which have specific "events"
   * at the actual play time (e.g. they show some overlay of when a goal was scored in a football match).
   * Therefore, easeLive needs accurate actual air timestamps.
   * Further note that typically only the first few segments contain a dateTime timestamp.
   */
  getLatestSegmentStartTimestamp() {
    return this.player.getLatestSegmentStartTimestamp();
  }
  getMaxTimeShiftInSec() {
    return this.player.getMaxTimeShiftInSec();
  }
  getTimeShiftInSec() {
    return this.player.getTimeShiftInSec();
  }
  getLiveStatus() {
    return this.liveStatus;
  }
  getMediaMetaData() {
    return this.mediaMetaData;
  }
  getPlaybackSpeed() {
    return this.player.getPlaybackSpeed();
  }
  getPlayerConfiguration() {
    const te = this.playerConfig;
    if (!te)
      throw new Error("dont have player config yet!");
    return te;
  }
  getPlayerStatus() {
    return this.player.getPlayerStatus();
  }
  getSelectedVideoQuality() {
    return this.player.getSelectedVideoQuality();
  }
  getBufferLengthInSec() {
    return this.player.getVideoBufferLength();
  }
  getPlayerData() {
    return this.player;
  }
  getVideoQuality() {
    return this.player.getVideoQuality();
  }
  getVolume() {
    return this.player.getVolume();
  }
  isFullscreenAvailable() {
    return this.player.isFullscreenAvailable() && !!this.fullscreenElement;
  }
  isInFullscreenMode() {
    return this.player.isInFullscreenMode();
  }
  isHdPlayback() {
    return this.getVideoQuality().height > this.HdPlaybackHeightThreshold;
  }
  /**
   * Returns the current variant for `'LIVE'`.
   */
  getLiveVariant() {
    return this.player.getLiveVariant();
  }
  /**
   * Returns the current player mode in which we are in. This has far-reaching consequences on `seek` vs. `timeshift`.
   * Note that in the case of Phasing (specifically in those phases where we don't have a videoUrl yet, such as PRE)
   * we won't know for certain what the playback mode will be.
   */
  getPlaybackMode() {
    return this.player.getPlaybackMode();
  }
  /**
   * Determines whether we enable live status phasing. This means we will poll the live status for the stream
   * on the server and show an "upcoming in x minutes" UI in case the video is not yet live.
   */
  isPhasingEnabled() {
    var te;
    return ((te = this.playerConfig) == null ? void 0 : te.phasing) ?? !1;
  }
  isPictureInPictureAvailable() {
    return this.player.isPictureInPictureAvailable();
  }
  async setThumbnail(te, ee, ie) {
    return this.thumbnailService.setThumbnail(te, ee, ie);
  }
  handleInvalidLoadCall(te) {
    if (!te)
      throw new Error("no player config provided yet, cannot load");
    if (!this.dataLoader)
      throw new Error("no data loader provided");
    if (!this.player)
      throw new Error("no player is active");
  }
  async load(te, ee = !1) {
    var ne, ae;
    this.handleInvalidLoadCall(te), this.loaded = !1, (ne = this.phasingService) == null || ne.stop();
    const ie = resolvePlayerDataConfiguration(te);
    this.playerConfig = ie, fetchBrowserOrConfiguredTranslationLanguage(te.overrideTranslationLanguage);
    try {
      const ue = await this.doLoadMetadata(ee, ie);
      this.mediaMetaData = ue;
      try {
        this.playerConfig = await this.hookService.beforeLoad(this.playerConfig, ue, this);
      } catch (_e) {
        log$1.warn("preloadHook failed, carrying on without it, error", _e);
      }
      if (this.playerConfig.phasing) {
        const _e = await this.handleLiveStreamPhasingOnLoad(this.playerConfig, ue);
        if (log$1.debug("phasing: live stream response", ue, "should load", _e), !_e)
          return;
      }
      return ((ae = ue.playabilityErrors) == null ? void 0 : ae.length) ?? !this.canPlayVideo() ? (this.eventEmitter.fireEvent({ type: "error", playerId: this.playerId, code: "SERVER_ERROR" }), ue) : (ue.thumbnailSprites && this.thumbnailService.setThumbnailSprites(ue.thumbnailSprites), await this.doLoadAndScheduleAd(ue, this.playerConfig));
    } catch (ue) {
      const _e = resolveErrorMessageFromUnknown(ue);
      log$1.error("error during load", _e);
      const fe = _e.includes("403") ? "NOT_AUTHORIZED" : "DATA_NOT_LOADED";
      this.handlePlayerOrDataError({ type: "error", playerId: this.playerId, code: fe });
      return;
    }
  }
  async doLoadMetadata(te, ee) {
    var ne, ae;
    let ie = await this.dataLoader.loadData(ee);
    return log$1.debug("got SSDM metadata", ie), te && !((ne = ie.mediaSrc) != null && ne.videoUrl) && ((ae = ie.playabilityErrors) != null && ae.includes("NOT_YET_AVAILABLE")) && (await sleep(5e3), log$1.warn(
      "got player data without video url when expecting it!",
      ie,
      "new livestatus",
      this.getLiveStatus()
    ), ie = await this.dataLoader.loadData(ee, !0)), ie;
  }
  initStorageService(te, ee, ie, ne) {
    var _e;
    const ae = new AudioLanguageResolver(te, ee, ie, ne), ue = new AudioVolumeResolver(ee);
    (_e = this.storageService) == null || _e.destroy(), this.storageService = void 0, this.storageService = new StorageService(this, ae, ue), this.storageService.load();
  }
  getStorageServiceAllStoredValues() {
    var te;
    return (te = this.storageService) == null ? void 0 : te.getAllStoredValues();
  }
  async handleLiveStreamPhasingOnLoad(te, ee) {
    if (!this.phasingService)
      return log$1.warn("no phasing service but config says livestream %o", te), !0;
    const ie = await this.phasingService.start(te, ee);
    return ie.shouldKeepPolling || this.phasingService.stop(), this.liveStatus = ie.liveStatus, ie.shouldLoadPlayer;
  }
  async doLoadAndScheduleAd(te, ee) {
    var ae;
    if (!te.mediaSrc)
      return;
    const ie = {
      ...te.mediaSrc,
      vr: te.vr
    }, ne = te.aspectRatio ?? 16 / 9;
    await this.player.load({
      source: ie,
      initialSeekTimeInSec: ee.initialSeekTimeInSec,
      aspectRatio: ne
    }), this.loaded = !0;
    try {
      const ue = ee.assetId;
      await ((ae = this.adService) == null ? void 0 : ae.scheduleAd(this.player, ue, te));
    } catch (ue) {
      log$1.warn("error during scheduleAd, carrying on anyway", ue);
    }
    try {
      this.playerConfig = await this.hookService.afterLoad(ee, te, this);
    } catch (ue) {
      log$1.warn("onAfterLoad hook failed, carrying on without it, error", ue);
    }
    return this.eventEmitter.fireEvent({ type: "loaded", playerId: this.playerId, data: te }), te;
  }
  pause() {
    return this.player.pause();
  }
  async stop() {
    await this.player.reset(), await this.hookService.beforeDestroy(this.playerConfig, this.mediaMetaData, this), this.reset(), this.stopped = !0;
  }
  async play() {
    if (!this.canPlayVideo())
      throw new Error("no playable video source detected!");
    return this.stopped && (this.stopped = !1, await this.load(this.playerConfig, !0)), this.eventEmitter.fireEvent({ type: "beforePlay", playerId: this.playerId }), this.player.play();
  }
  playVideoViaAirPlay() {
    this.player.playVideoViaAirPlay();
  }
  removeEventListener(te) {
    this.eventEmitter.removeEventListener(te);
  }
  reset() {
    var te;
    this.cumulatedPlayTimeInSec = 0, this.lastPlaybackPosition = 0, this.storedSeekOrTimeShift = void 0, (te = this.trackingService) == null || te.reset(), this.mediaSessionService.reset();
  }
  restartPlaybackFromBeginning() {
    this.reset(), this.player.seek(0, "RESTART");
  }
  seek(te) {
    return this.player.isShowingAd() ? (this.storedSeekOrTimeShift = {
      position: te,
      seekHandler: "SEEK"
    }, !1) : this.player.seek(te, "USER");
  }
  seekOrTimeshiftRelative(te) {
    const ee = this.player;
    if (this.getPlaybackMode() === "LIVE") {
      const ie = ee.getTimeShiftInSec(), ne = Math.min(0, ie + te);
      return ee.timeShift(ne, "USER"), !0;
    }
    return this.seekRelative(te);
  }
  seekRelative(te) {
    const ee = this.player, ie = ee.getCurrentTimeInSec(), ne = ee.getDurationInSec(), ae = Math.min(ie + te, ne), ue = Math.max(0, ae);
    return ee.seek(ue, "USER");
  }
  setAudioTrack(te, ee = "USER") {
    this.player.setAudioTrack(te, ee);
  }
  setPlaybackSpeed(te) {
    this.player.setPlaybackSpeed(te);
  }
  timeShift(te) {
    this.player.isShowingAd() ? this.storedSeekOrTimeShift = {
      position: te,
      seekHandler: "TIMESHIFT"
    } : this.player.timeShift(te, "USER");
  }
  toggleFullscreen() {
    !this.player.isInFullscreenMode() && this.player.isInPictureInPictureMode() && this.player.setPictureInPicture(!1), this.player.toggleFullscreen(this.fullscreenElement);
  }
  setFullscreen(te) {
    this.player.setFullscreen(te, this.fullscreenElement);
  }
  togglePictureInPicture() {
    this.player.isInFullscreenMode() && this.player.setFullscreen(!1, this.fullscreenElement), this.player.togglePictureInPicture();
  }
  isInPictureInPictureMode() {
    return this.player.isInPictureInPictureMode();
  }
  setVideoQuality(te) {
    this.player.setVideoQuality(te);
  }
  setVolume(te) {
    te > 0 && (this.lastRequestedVolume = te), this.player.setVolume(te);
  }
  setMuted(te) {
    this.player.setVolume(te ? 0 : this.lastRequestedVolume);
  }
  isMuted() {
    return this.getVolume() === 0;
  }
  dispatchDomEvent(te, ee = this.dispatchElement.parentElement ?? void 0) {
    const ie = new CustomEvent(RBUP_VIDEO_DOM_EVENT_TYPE, { detail: te });
    log$1.debug("dispatching DOM event", ie), ee == null || ee.dispatchEvent(ie);
  }
  dispatchPlayerEvent(te) {
    this.eventEmitter.fireEvent(te);
  }
  async handleNonPlayableLiveStatusPhase() {
    this.isInFullscreenMode() && this.setFullscreen(!1), this.loaded = !1, this.reset(), await this.player.reset();
  }
  handleLiveStatusChanged(te) {
    const { liveStatus: ee } = te;
    this.liveStatus = ee, (async () => {
      var ne;
      log$1.info("live status changed", ee), !this.loaded && this.playerConfig && isPlayablePhase(ee.phase) ? await this.load(this.playerConfig, !0) : this.loaded && (isPlayablePhase(ee.phase) ? ee.phase === "post" && (log$1.debug("stopping phasing service as we are in POST"), (ne = this.phasingService) == null || ne.stop()) : await this.handleNonPlayableLiveStatusPhase());
    })();
  }
  handleLoadedEvent(te) {
    this.lastPlaybackPosition = 0, this.cumulatedPlayTimeInSec = 0;
    const ee = this.playerConfig, ie = this.getMediaMetaData(), ne = this.getAvailableAudioTracks(), ae = this.getSubtitleTracks();
    ee && ie && (ne.length > 0 || ae.length > 0 ? this.initStorageService(ie, ee, ne, ae) : setTimeout(() => {
      const ue = this.getAvailableAudioTracks(), _e = this.getSubtitleTracks();
      this.initStorageService(
        ie,
        ee,
        ue,
        _e
      );
    }, 300));
  }
  handleAdBreakFinished(te) {
    if (this.getPlaybackMode() === "LIVE" && (this.lastPlaybackPosition = 0), this.storedSeekOrTimeShift) {
      switch (this.storedSeekOrTimeShift.seekHandler) {
        case "SEEK":
          this.seek(this.storedSeekOrTimeShift.position);
          break;
        case "TIMESHIFT":
          this.timeShift(this.storedSeekOrTimeShift.position);
          break;
      }
      this.storedSeekOrTimeShift = void 0;
    }
  }
  handleTimeSkippedEvent(te) {
    this.getPlaybackMode() === "LIVE" && (this.lastPlaybackPosition = te.currentPlaybackTimeInSec);
  }
  handlePlayingEvent(te) {
    this.player.getPlaybackMode() === "LIVE" && (this.lastPlaybackPosition = te.playbackPosition);
  }
  handleTimeChangedEvent(te) {
    this.player.isShowingAd() || (this.player.getPlaybackMode() === "LIVE" && this.lastPlaybackPosition === 0 && (this.lastPlaybackPosition = te.playbackPosition), this.cumulatedPlayTimeInSec += te.playbackPosition - this.lastPlaybackPosition, this.lastPlaybackPosition = te.playbackPosition);
  }
  handleSeekingEvent(te) {
    this.lastPlaybackPosition = te.playbackPosition;
  }
  handleTimeshiftingDoneEvent(te) {
    this.lastPlaybackPosition = te.playbackPosition;
  }
  handlePlayerOrDataError(te) {
    const ee = te.code;
    ee === "SERVER_ERROR" && this.mediaMetaData ? this.currentErrorDetails = {
      serverErrorDetails: {
        playabilityErrors: this.mediaMetaData.playabilityErrors ?? [],
        playabilityErrorDetails: this.mediaMetaData.playabilityErrorDetails
      }
    } : ee ? this.currentErrorDetails = { playerErrorCode: ee } : this.currentErrorDetails = { serverErrorDetails: te }, this.player.getPlayerStatus() === "PLAYING" && this.player.pause(), this.player.setHasError(!0);
  }
  getPosterImage() {
    var te, ee, ie;
    if (this.isMediaDataLoadedOrError())
      return ((te = this.playerConfig) == null ? void 0 : te.posterImageUrl) ?? ((ee = this.mediaMetaData) == null ? void 0 : ee.posterImageUrl) ?? ((ie = this.playerConfig) == null ? void 0 : ie.customFallbackPosterImageUrl) ?? RBUP_FALLBACK_POSTER_IMAGE;
  }
  isMediaDataLoadedOrError() {
    return !!this.mediaMetaData || !!this.currentErrorDetails;
  }
  getTechVersion() {
    return this.player.getTechVersion();
  }
  getAspectRatio() {
    var te;
    return ((te = this.mediaMetaData) == null ? void 0 : te.aspectRatio) ?? 16 / 9;
  }
  shouldShowProductPlacement() {
    var ee, ie;
    const te = ((ee = this.playerConfig) == null ? void 0 : ee.productPlacement) === "visible";
    return te || !!((ie = this.getMediaMetaData()) != null && ie.showProductPlacement);
  }
  getAdCuePoints() {
    return this.player.getAdCuePoints();
  }
}
const defaultUrlSharingStrategy = new QueryParamUrlSharingStrategy();
function createPlayerCoordinator({
  adService: re,
  config: te,
  dataLoader: ee,
  dispatchElement: ie,
  divElement: ne,
  liveStatusDataLoader: ae,
  playerId: ue,
  urlSharingStrategy: _e
}) {
  const fe = new EventEmitter$1(), le = ae ? new PhasingService(ue, ae, fe) : void 0;
  return new VideoPlayerCoordinator({
    playerId: ue,
    divElement: ne,
    dispatchElement: ie,
    dataLoader: ee,
    eventEmitter: fe,
    phasingService: le,
    urlSharingStrategy: _e ?? defaultUrlSharingStrategy,
    config: te,
    adService: re
  });
}
const styles$1 = `@font-face{font-family:Bull Text;font-style:normal;font-weight:400;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Regular.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:500;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Medium.woff) format("woff")}@font-face{font-family:Bull Text;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullText-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:700;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Bold.woff) format("woff")}@font-face{font-family:Bull;font-style:normal;font-weight:800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff2) format("woff2"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/Bull-Heavy1.woff) format("woff")}@font-face{font-family:Bull VF;font-style:normal;font-weight:300 800;font-display:swap;src:url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2-variations"),url(https://rbds-static.redbull.com/@cosmos/foundation/latest/fonts/v5.002/BullVAR.woff2) format("woff2")}.player{position:relative}.container16x9{background-color:var(--rbup-container16x9-background-color);overflow:hidden;margin:0;padding:0;position:relative;width:100%;height:100%;min-width:260px;min-height:150px}.container16x9:before{content:"";display:block;aspect-ratio:var(--aspect-ratio)}.container16x9 video{position:absolute;top:0;left:0;bottom:0;right:0;width:100%;margin:auto;max-height:100%}.container16x9[data-rbup-fullscreen]{position:fixed;top:0;left:0}.container16x9[data-rbup-fullscreen]:before{display:unset}.container16x9 #bitmovinplayer-vr-canvas{top:0;left:0;bottom:0;right:0;width:100%;height:100%}
`, log = loglevelExports.getLogger("VideoCoreInternal");
async function destroyPlayer(re) {
  re && !re.destroyed && (log.debug("destroying coordinator", re.playerId), await re.destroy(), log.debug("coordinator destroyed", re.playerId));
}
async function loadPlayerCoordinatorAndInvokeReadyCallback(re, te, ee, ie) {
  log.debug("config was changed, loading new data into player", re, te, "ref", ee), ee && (await ee.load(te), log.debug("loading done", ee.playerId), ie == null || ie(ee));
}
async function createPlayerCoordinatorAndInvokeReadyCallback({
  adService: re,
  config: te,
  dataLoader: ee,
  dispatchElement: ie,
  divElement: ne,
  liveStatusDataLoader: ae,
  playerId: ue,
  urlSharingStrategy: _e,
  coordinatorRef: fe,
  listener: le,
  onCoordinatorAvailable: se
}) {
  const oe = fe.current;
  oe && !oe.destroyed && (oe.removeEventListener(le), await destroyPlayer(oe)), te.skipCosmosFontInjection || injectCosmosFontIntoHeader(cosmosFonts);
  const ce = createPlayerCoordinator({
    adService: re,
    config: te,
    dataLoader: ee,
    dispatchElement: ie,
    divElement: ne,
    liveStatusDataLoader: ae,
    playerId: ue,
    urlSharingStrategy: _e
  });
  return fe.current = ce, ce.addEventListener(le), await loadPlayerCoordinatorAndInvokeReadyCallback(ue, te, ce, se), ce;
}
async function reportMaxTimeShift({ assetId: re, videoPlayerCoordinator: te }) {
  var ne;
  if (!te)
    return;
  const ee = te.getMaxTimeShiftInSec(), ie = (ne = te.getMediaMetaData()) == null ? void 0 : ne.isLinearStream;
  if (isLinearStream(ee, ie, re))
    try {
      if (ee < MIN_TIMESHIFT_FOR_DVR_SECS) {
        const ae = calculateSsdmUrl("PRODUCTION"), ue = "/report-max-time-shift", _e = {
          maxTimeShift: ee.toString()
        };
        await fetch(`${ae}${ue}?${new URLSearchParams(_e)}`);
      }
    } catch {
    }
}
const VideoCoreInternal = ({
  config: re,
  dataLoader: te,
  adService: ee,
  onCoordinatorAvailable: ie,
  urlSharingStrategy: ne,
  liveStatusDataLoader: ae,
  internalOnApiAvailable: ue,
  aspectRatio: _e
}, fe) => {
  var ye;
  const le = _(null), se = _(), [oe, ce] = h$2(), [he] = h$2(v4()), ge = _(null), ve = _([]), me = T$1(r(reportMaxTimeShift, 500), [reportMaxTimeShift]);
  p(() => {
    me({ assetId: re.assetId, videoPlayerCoordinator: oe });
  }, [oe, re.assetId, me]);
  const be = T$1(
    r(createPlayerCoordinatorAndInvokeReadyCallback, 100),
    [createPlayerCoordinatorAndInvokeReadyCallback]
  );
  if (!re)
    throw new Error("no config provided");
  const pe = useCoreApi(se, fe, ue, ve);
  p(() => {
    const Se = ge.current, we = le.current;
    let Pe;
    if (te && Se && we && re.assetId) {
      const Te = (Me) => {
        ie == null || ie(Me), ce(Me);
      };
      (async () => {
        Pe = await be({
          adService: ee,
          config: re,
          dataLoader: te,
          dispatchElement: we,
          divElement: Se,
          liveStatusDataLoader: ae,
          playerId: he,
          urlSharingStrategy: ne,
          coordinatorRef: se,
          listener: pe,
          onCoordinatorAvailable: Te
        }), ce(Pe);
      })();
    }
    return () => {
      Pe && !Pe.destroyed && (Pe.removeEventListener(pe), destroyPlayer(Pe));
    };
  }, [
    he,
    te,
    ge,
    re,
    ne,
    ee,
    ae,
    ie,
    pe,
    be
  ]), p(() => {
    const Se = se.current;
    Se && te && (Se.dataLoader = te);
  }, [te]);
  const $e = ((ye = se.current) == null ? void 0 : ye.isInFullscreenMode()) ?? !1;
  return useReportUsage(le, re.environment), /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement("style", null, styles$1), /* @__PURE__ */ Cn.createElement("div", { class: "player", ref: le, "data-rbup-core": !0 }, /* @__PURE__ */ Cn.createElement(
    "div",
    {
      style: { "--aspect-ratio": `${_e ? transformAspectRatioForCss(_e) : ""}` },
      class: "container16x9",
      ref: ge,
      "data-rbup-core-container": !0,
      "data-rbup-fullscreen": resolveTagAttributeValue($e)
    }
  )));
}, RbupVideoCore = k(VideoCoreInternal);
async function initRbupVideo(re, te, ee) {
  log.info("calling initRbupVideo with args", ee), await customElements.whenDefined(te);
  const ie = document.querySelector(`#${re}`);
  if (!ie)
    throw new Error(`html element with id ${re} not found`);
  const ne = createControllablePromise(), ae = {
    ...ee,
    "internal-on-api-available": ne
  };
  return deleteUndefinedValues(ae), Object.assign(ie, ae), removeNoLongerExistingAttributes(ie, ae, log), ne;
}
function useIosVrFullscreen() {
  const {
    playerState: { isFullscreenMode: re, isVRVideo: te }
  } = usePlayerContext(), ee = F$1(() => isIosDevice(), []), ie = F$1(() => te && re, [te, re]);
  return ee && ie;
}
function isMultipleAdShown(re, te) {
  return re === 0 || te === 0 ? !1 : !(re === 1 && te === 1);
}
const AdControlsTimeDisplay = () => {
  const {
    playerState: { playerCoordinator: re }
  } = usePlayerContext(), te = T$1((ne) => {
    switch (ne.type) {
      case "adTimeChanged": {
        const ae = ne.adPosition, ue = ne.totalAds, _e = Math.round(ne.duration - ne.playbackPosition), fe = translate("ad-endsin", { sec: `${_e}` });
        if (isMultipleAdShown(ae, ue)) {
          const le = translate("ad-from-ads", {
            adPosition: `${ae}`,
            totalAds: `${ue}`
          });
          ie(`${fe} · ${le}`);
        } else
          ie(fe);
        break;
      }
    }
  }, []), [ee, ie] = h$2();
  return p(() => (re == null || re.addEventListener(te), () => {
    re == null || re.removeEventListener(te);
  }), [re, te]), /* @__PURE__ */ Cn.createElement("div", { "data-rbup-time-display": !0, class: "ad-controls-time-display" }, /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", size: "xx-small@small x-small@medium" }, ee));
}, AdControls = () => {
  const {
    playerState: { durationInSec: re }
  } = usePlayerContext(), [te, ee] = h$2(""), ie = T$1((ae) => {
    ee(ae);
  }, []), ne = isFinite(re);
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ne && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-ad-controls": !0, class: "ad-controls" }, /* @__PURE__ */ Cn.createElement("div", { class: "ad-controls__ui" }, /* @__PURE__ */ Cn.createElement(
    CosmosTooltip,
    {
      class: "ad-controls__tooltip",
      content: te,
      appearance: "dark",
      placement: "above",
      spacing: "tight",
      unreachable: !0,
      follow: !0
    },
    /* @__PURE__ */ Cn.createElement("div", { class: "ad-controls__buttons" }, /* @__PURE__ */ Cn.createElement(PlayPauseButton, { onTooltipUpdate: ie }))
  ), /* @__PURE__ */ Cn.createElement("div", { class: "ad-controls__buttons" }, /* @__PURE__ */ Cn.createElement(VolumeControls, null)), /* @__PURE__ */ Cn.createElement(AdControlsTimeDisplay, null))));
}, RbupVideoDefaultCornerbugIcon = x(() => {
  const [re, te] = h$2(""), [ee] = h$2(`cb${v4().replace(/-/g, "")}`), ie = `.default-corner-bug.mono *{transition:.4s linear}.default-corner-bug.mono #o_${ee}{fill:hsla(0,0%,100%,0)}.default-corner-bug.mono #b_${ee}{fill:#fff}.default-corner-bug.mono #s1_${ee} stop:first-child{stop-color:#fff}.default-corner-bug.mono #s1_${ee} stop:nth-child(2){stop-color:hsla(0,0%,100%,.64)}.default-corner-bug.mono #s1_${ee} stop:nth-child(3){stop-color:hsla(0,0%,100%,0)}.default-corner-bug.mono #s2_${ee} stop:first-child{stop-color:#fff}.default-corner-bug.mono #s2_${ee} stop:nth-child(2){stop-color:hsla(0,0%,100%,0)}.default-corner-bug.mono #s4_${ee} stop{stop-color:#fff}.default-corner-bug.mono #s4_${ee} stop:first-child{stop-color:hsla(0,0%,100%,.55)}.default-corner-bug.mono #s31_${ee} stop,.default-corner-bug.mono #s32_${ee} stop,.default-corner-bug.mono #s33_${ee} stop,.default-corner-bug.mono #s34_${ee} stop{stop-color:hsla(0,0%,100%,.4)}`, ne = /* @__PURE__ */ Cn.createElement(
    "svg",
    {
      "data-rbup-default-cornerbug": !0,
      xmlns: "http://www.w3.org/2000/svg",
      class: `default-corner-bug ${ee} ${re}`,
      viewBox: "0 0 397.44 222.14"
    },
    /* @__PURE__ */ Cn.createElement("style", null, ie),
    /* @__PURE__ */ Cn.createElement("defs", null, /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s1_${ee}`,
        x1: "234",
        y1: "111",
        x2: "464",
        y2: "13",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".23", "stop-color": "#f2940a" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".52", "stop-color": "#f2940a" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#f2940a" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s2_${ee}`,
        x1: "209",
        y1: "87",
        x2: "426",
        y2: "87",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: "0", "stop-color": "#FAD50A" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".92", "stop-color": "#FAD50A" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s31_${ee}`,
        x1: "221",
        y1: "163",
        x2: "379",
        y2: "129",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".35", "stop-color": "#52bce8" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".78", "stop-color": "#3977AB" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#21336e" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s32_${ee}`,
        x1: "355",
        y1: "129",
        x2: "379",
        y2: "124",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: "0", "stop-color": "#3a78ac" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".86", "stop-color": "#253e78" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#21336e" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s33_${ee}`,
        x1: "227",
        y1: "203",
        x2: "315",
        y2: "203",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".54", "stop-color": "#52bce8" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#49a4d3" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s34_${ee}`,
        x1: "285",
        y1: "206",
        x2: "367",
        y2: "194",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".24", "stop-color": "#52bce8" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#3f88b9" })
    ), /* @__PURE__ */ Cn.createElement(
      "linearGradient",
      {
        id: `s4_${ee}`,
        x1: "219",
        y1: "160",
        x2: "399",
        y2: "160",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ Cn.createElement("stop", { offset: "0", "stop-color": "#1885c8" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: ".73", "stop-color": "#1e4475" }),
      /* @__PURE__ */ Cn.createElement("stop", { offset: "1", "stop-color": "#22183d" })
    )),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        id: `o_${ee}`,
        fill: "#fff",
        d: "M223.74 174.22c5.18-1.22 9.91-4 15.21-3.57 8.76 1.35 12.91-.36 19.6-4.69 4.91 2.81 10.74 8.67 22.72 8.54 3.85.25 8.32-1.65 7.42-5.72-.24-3.53 6.68-2 7.12-6.5.77-2.69.2-2.58-4-5.11-7-3.83-6.88-11.15-12.15-15.89-.58-.69-2.29-1.93-2.34-2.8-17.57-47.55 3.14-31.32-36.76-76.19-11.35-8.42-27.94-27.78-42.68-26.63-13.38.43-16.77 8-26.63 11.21-12.44 4.41-19.9 5.67-29.91 15-6.48 5.44-15.09-1.28-24.3 8.41-19.51 19.67-21.7 1.18-53.73 26.18-16.56 14.38-39.44 4-21-14.49 9.35-6.67 21.19-14.88 16.82-27.62-1.48-9.54-15.19-12.18-23.83-13.55-5-1-13.54-7.57-16.36-9.35-8.46 9.49-4.23 31.42 14 33.65a1.49 1.49 0 011.4 1.4 2.83 2.83 0 01-.46 1.87C20.81 78.66 18 82.86 17.54 94.55c-1 16 12.19 28.12 29 27.57a53.25 53.25 0 008-.47c.46 0 .93 0 .93.47 1.32 7.23 1.88 16.07 4.21 18.7.46.93.46 1.87-.47 2.33-5.35 5.26-16.75-.67-19.63 8.88-1.79 3.9-1.36 8.75-5.6 10.75-3-.66-3.8-5.1-7.95-5.14s-11 3.06-14 9.82c-3.2 2.19-6.44.7-7.94 5.6-.68-.05-1.05 2.59-.93 3.74a13.49 13.49 0 01-1.87 6.08c-3.08 3.89.26 8.65 5.14 9.35 3.61.28 5.89 1.7 7 .46.46 0 .46-.46.93-.46 1-.95 1.77-.26 2.8 0 2.08.11 5.1 1.73 7.48 1.4a1.71 1.71 0 011.4.47c7-.06 9.22-2.85 11.68-6.55-.13-1.66 1.2-2.8 1.87-4.2.64-.67 1.1-1 1.87-.94 1.21.35 4 .76 4.68.94 10.7.94 13.5-10 22-11.22 2.1 0 6 .41 14.48 1.4 5.56.44 11-3.6 16.36-6.54 2.4-1.2 4.49-1.87 6.54-4.68 2.52-2 5.55-14.34 8.88-14.48 6.83-.14 13.29-2.38 20.09-2.34 8.35-.37 16.84 1.95 24.3-.93.28.1 1.92-.25 2.34.46 1.06 1.57 4.05 2.27 3.27 4.21 0 .47-.94.93-1.4 1.4-1.54 0-3.78.12-5.14 1.87-.68.62-2.58.8-3.28 0-4.47.4-17.12-1.47-18.69 5.14 1.19 5.12 5.4 17.94 14 16.83.47 0 1.4.46 1.4.93 3.27 6.54 8.88 10.75 14 10.75s17.86-4.57 27.57-9.35H197c5.93-.55 8.3-2.14 11.68-8.88 4.49-4.48.86 9.17 15.1 6.32zm-9-30.13c-1.4 1.4-2.8 1.87-4.67 4.67-3.27-1.4-3.74-5.61-4.2-7.48 2.8-.46 8.87-1.87 12.15-2.33-1.88 1.87-2.82 2.8-3.29 5.14z"
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        id: `b_${ee}`,
        fill: "#db0a40",
        d: "M287.63 159.51c-6.07-3.27-8.41-10.28-12.15-15.42-9.78-10.12-11.44-27.43-14-41.6-2.58-13.76-14.33-23.94-22.48-34.58-7.23-5.9-26.1-23.78-35-26.64-11.75-4.89-22 4.35-31.78 8.88-7.94 3.27-16.35 4.2-23.36 10.28-11 14.12-17.61 2.82-30.38 14-19 19.92-26.2 2.39-52.33 25.71-7 4.2-13.55 8.41-22 7.94-13.43-.63-18-18.68-7.48-26.64C44 73.24 62 64.81 53.05 51.55c-9.3-8.29-20.24-4.76-31.3-14-5.1 8 1.42 18.85 9.81 21.5C35 61.19 43 57.78 44.64 62.76c-3.54 7.09-13.21 10.93-17.75 17.77C15.58 93.59 26.75 115 42.77 116c5.92 1.92 13.47-2.92 17.29-.93.47 4.67 0 8.88.94 13.09.43 4.6 5.67 9.54 2.8 14a23.58 23.58 0 01-16.8 5.67c-3.19 3.67-3.73 7.84-5.61 12.15-2.33 4.2-7 6.07-10.28 7.94-2.16 3.29-4.31 6.93-8.88 7.48-2.8 3.27-3.27 7.48-4.2 11.69 11.69 3.09 14.19 1.52 20.56-8.42 2.34-2.33 5.61-.46 7.94 0 6.64-.79 11.59-5.23 16.36-9.34 17-4.45 16.84 6.69 36.44-6.08 3.28-1.4 4.68-5.14 6.08-7.95 1.64-3.13 6.17-9.16.47-10.74-14.67 29.7-40.21 5.53-59.82 28-3 .83-.67-3.84 0-4.68 14.07-20.5 46.07-2.45 57-29 1.92-4.08.83-20.34 5.61-20.1.47 0 1.87.47 1.87 1.4-4.54 19.82-1.54 25.97 19.62 22.5 7.24-2.1 28 5.29 27.57-4.67 0-1.87-1.87-2.8 0-4.2.46-.47 1.87 0 2.33.46 1.32 8 8.34 13.87 15 17.3 13.43 9.14 8 21.07-7.48 20.56-5.14-2.8-6.54-7.95-10.28-12.15-4.37-3.83-10.34-2-15.42-.94-2.52 3.81 3.47 8.35 4.67 12.16 2.34 1.4 5.61-.94 7.48 1.86s2.8 5.61 5.61 7.48c8.1 7.77 25-5.88 33.64-6.54 7.55.82 11-6.06 13.55-11.69 4.26-7.78-7.07-15.47-7.94-22.43-2.58-.71-6-2.73-7.95 0 1.43 3.48 9.45 16.21 8.88 20.1-1.05 2.81-3.43 9.33-7 8.88.94-3.27 2.34-7 2.34-10.75-1.7-4-9.21-15.55-9.81-19.63 1.49-3.95 9.16-1.66 12.14-5.61 3.28-5.14 4.21-10.28 5.15-16.82a2.1 2.1 0 011.4-1.41c4.55 2.93-.08 17-2.81 20.1-.26 4.84 9.28 1.6 11.22 0 3.61.75 10.93-2.85 12.61-.47a25.39 25.39 0 00-4.67 9.35c-2.8 3.27-7.47 5.61-7.47 10.28.51 2.94 4.46-1.8 4.67 1.87-4.07 5.17-3.56 6.42-2.34 12.15 4.27 6 12.43 1.06 17.76-.46 9-3.53 19.13 2.06 26.17-7.48a6.2 6.2 0 014.67 2.8 25.73 25.73 0 0020.09 7.95c3.06-2.13-3.63-3.8-4.67-4.68-3.27-1.87-7.48-4.67-8.41-8.41-1.23-5.22-5-10-7.48-14.95 10.91.16 12.06 22.95 28 19.63.78-.54.7-1.12.47-1.87zm-78.5-70.57c-.47.47-.94.47-1.87.47-1.25-4.72-1.69-9.65-4.21-13.56-1.31-1.28-3-2.95-1.87-5.14a2.23 2.23 0 012.81-.47c4.28 3.2 5 7.66 5.14 13.09.93.93.46 3.74 0 5.61m38.31 65.9a27.85 27.85 0 01-6.54.93h-.46c-2.77-2.55 3-7.64 6.07-7.48h1.4c1.71.71 1.27 5.22-.47 6.55m12.15-27.11c-.52.91-1.32 3.29-2.33 3.27s-1.45.15-1.4-.93c-.09-3.14-.6-7-3.28-8.88-6.1-9.49-7.64 2.4-9.81.93-1.3-2.64.75-5.63 1.87-7.94.52-.63.73-1.36 1.4-1.87 1-5.75 6.25-2.47 7.48.93 3.22 4 7 8.51 6.54 13.09-.47-.47-.47.47-.47 1.4m-236.91 43c3.27-1.87 5.14-5.14 6.54-7.95-1-1.57-2.22-3.64-4.67-2.8a60.5 60.5 0 01-7 4.67c-1.17 3.18 1.75 7.18 5.14 6.08m-10.28 0c-5.55 2.27-2.61 9.11-6.07 12.62 0 .46-.94 1.4 0 1.87 2.33.46 4.2 1.4 7 1.87 1.25-4.18 2.46-8.83 3.27-12.62-.94-1.41-2.34-3.27-4.21-3.74m151.4-10.28c1.87 2.33 1.87 5.6 4.21 7.47a10.05 10.05 0 007.94-2.33c1.4-.94-.47-2.34-.93-3.74-1.41-1.87-.47-5.61-3.74-5.61-3.54.82-7.42-.2-10.75.93 0 1.41 2.8 1.41 3.27 3.28"
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M392.8 128.62c-.23-7.73-3.35-16.12-8.57-21.63l-.24-.28c-2.67 10.55-6.5 19.86-17.5 36.63-4.23 6.42-11.74 6.7-16.39 12.59-1.1-.6-.78-1.42-2.2.1 5.86-6.3-.84-3.06 1.9-6.09 10.22-11.3 19.58-21.48 23.54-36.73-1.67 2.09-2.68 2.74-4.36 4.86 1.9-6.49 3.38-12 4.79-18.66l-1.8-.72c-6.27 21.19-16.62 39.73-35.56 52.45-24.6 17.88-3.83 11.9.31 8.2-31 31.65-99.62 52-139.06 19.8 5.76 5.61 12.83 11.88 19.55 16-4.09-.7-7-3.87-10.86-5.08.06.13 9.38 12.26 37.2 15.44 1.79.2 3.5.38 5.15.53 37.93 3 40.24-3.79 66.71-9.39 1.19.51-8.53 5.53-21.9 9.31-21.11 7.72-45.62 2-63.51.14h.08c.41.2 3.19 1.48 17.42 6.57-1 .36-5.65 1-25.05-7.32 47.6 27.45 98.83 6.67 140.89-24.52 0 .14-.06.34-.06.51.37.06.84.12 1.22.15-.23.67-.23.67-3.49 4.56 7.1-5.73 10.74-14.62 18.26-20-3.85 7.73-8.77 13.27-17.93 22.23a24 24 0 002-1.71c-13.85 12.94-32.12 25.78-60.47 32.52a38.9 38.9 0 006.07-1.2c-3.59 1-3.69 1.12-5.21 1.62.94-.12.94-.12 5.83-1.11-2.85 1.4-6.14 2.07-14.1 3.69 47.19-7.48 96.27-44.2 97.34-93.46z",
        fill: `url(#s4_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M345.37 192.75c-18.7 11.9-39.39 22.28-62.5 24.93 27.8 1 60.79-19.13 78.76-35.62-5.38 3.6-10.76 7.22-16.26 10.69z",
        fill: `url(#s34_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M315.39 196.71c-26.65 5.6-28.16 12.29-66.29 9.44-3 .91-18.85-.05-21.47-.9.13 0 1.36.53 2.42.95h-.07c4-.5 30.37 5.12 38.79 4 10.93.74 45.23-9.45 46.62-13.49z",
        fill: `url(#s33_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M374.69 99.86l-.94-.41c-1.42 6.62-2.89 12.16-4.79 18.65 1.68-2.12 2.69-2.77 4.36-4.86-4 15.25-13.32 25.43-23.54 36.73-2.74 3 4-.21-1.9 6.09 1.42-1.52 1.1-.7 2.2-.1 4.64-5.89 12.16-6.17 16.39-12.59 11-16.78 14.83-26.08 17.49-36.63a3.33 3.33 0 01.25.28 30.86 30.86 0 00-9.52-7.16z",
        fill: `url(#s32_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M249.18 182.88c-17.52-9.88-4.82-3.31 10.53.3a113 113 0 0034.4 3c18.28-7 33.9-17.17 42.58-26.82-4.16 3.8-24.73 9.49-.3-8.2 18.92-12.72 29.29-31.24 35.54-52.42a69.27 69.27 0 00-15.17-3.7c-7.32 17.41-8.41 29.5-24.63 39.12-18.1 11.78-6.77 8.76-6.59 8.67a20.1 20.1 0 004-2.14c-7 11.2-19.18 18.35-33.7 21.58-.46 4.52-7.39 3-7.12 6.5.89 4.07-3.57 6-7.42 5.72-12 .13-17.81-5.73-22.72-8.54-7.66 5.08-11.26 5.73-20.9 4.66-4.79.07-9.16 2.5-13.91 3.6 6.8 6.08 36.08 13.9 25.41 8.67zm92.35-48.5c3.05-6.65 10.13-10.22 12.46-18.25-.34 1.18 2.19 1.67 3.19 1.67 4-.68 4.1-6.16 5.39-7.3-1 12.45-9.45 22.65-18.69 31.09a4.18 4.18 0 00-4-.18c-.39-2.34 4.68-5.6 1.65-7.03z",
        fill: `url(#s31_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M358 61.05c-11.74-6.68-25-8.24-37.47-13.2 18.76 4 41.07 8.07 54.94 22.11.22.11.74.62 1 .69 1.2.81 2.57 3.68 4.24 2.62-29.1-56.79-117.5-50.47-159.56-27.18 2.29 1.76 4.81 3.83 7.16 5.83 8-6.48 40.45-11 43.31-10.56-10.84 2.17-28.8 8.69-39.71 13.58l1.53 1.29c22.26-7.83 56.14-13.29 80.15-7.53-19.19 2.13-53.4 1.84-76.16 10.9 6.25 4.73 11.82 13.34 17.19 19.66 37.13-18.11 58.55-18.7 77.33-16.33 1.8 1-13.32 1.63-9.65 2.74 4.08.94 11.73-1.32 13.5-1.55 1.15-.37 8.37-.13 10.65.3 8.68 2.11.54 3.21-2.49 2.5a22.44 22.44 0 00-4.48.09c-3.35.63-7.4 1.37-10.74 1.87-.9.15-11.09-.12-9.54 1.2 1.95-.13 10.53 1.42 12.74 1.16 1.33-.3 2.68.15 3.94-.53.62-.43 3.16-.74 3.27.32-2.89 6.44-11.67 1.61-18.28 3-5.89.44-12.14 3.07-13.2 2.15 19.32-11.75-27.61 5.71-26.82 8.68a.29.29 0 00.16 0c.14 2.63 7.51-1.2 9-.92 3.23-.25 7.6-2.26 10.75-3 2.36 0 3.29 1.18 5.64.66 5.16-.09 9.82-2.31 14.8-3.29.44 0 3.55 1.31 3.4 1.67 9.38 8.41 14.33 1.4 24.62 4.17 1.64.22-.3 1.28-.86 1.61-5.43 3.82-11.88 4.41-18.17 4.87a5.69 5.69 0 00-3.08.5c-2.07-.16-4 1-6.07.69-5.89.12-11.71 1-17 3.69-2 .39-4.27.71-5.76 2.2-1.52 1.23-3.81.76-5.15 2.14-2.28 1.37-19.48 5-17.54 8.53h-.1.1a1 1 0 010 .23c28.41-4.06 62.28-24.09 98.11-9.09 14.75 7.51 23 20.57 17.12 45.81.05-.12.69-1.8.68-1.87l-.11.08c1.67-5.89 3.2-10.95 3.16-16.91C398.4 104.84 381.86 74 358 61.05zm-33.62-21.32c5.21 1.17 14.76 2.91 17.88 6.2-8.19-.09-12.25-3.63-12.12-3.54-1.57-.48-6.5-2.24-5.76-2.66z",
        fill: `url(#s2_${ee})`
      }
    ),
    /* @__PURE__ */ Cn.createElement(
      "path",
      {
        d: "M231.79 54.85L228.37 52c8.15-6.68 40-10.94 43.23-10.61a105.52 105.52 0 00-14.14 3.9c-8.46 2.77-17.78 6.23-25.67 9.56zm165.42 46c-5-37.33-17.74-70.1-63.13-82.14 28.07 6.81 30.18 10.32 33.84 12.75C346.12 11.25 311 4.22 275.5 10.27c20.7-6.71 54.72-5.89 76 7.31C300.74-13.85 239.73-.26 202.22 35.63c7 1.36 13.15 6 18.86 10.42 42.57-23.22 130.42-29.58 159.64 27.22-1.68 1.06-3-1.8-4.24-2.62-.23-.07-.75-.58-1-.69-13.88-14-36.16-18.14-54.94-22.11 12.53 5 25.73 6.52 37.47 13.2 30.63 17.62 44 53.33 33.4 82.42l.11-.08a108.25 108.25 0 005.69-42.53zM294 46.26c-19.42 0-44 3.66-60.55 10l3.88 3.28c19.77-7.54 53-9.45 69.26-10.07 17.61-.54-6.15-3.15-12.59-3.21zm36.13-3.87c-.32-.17 4.07 3.5 12.12 3.54-3.15-3.3-12.65-5-17.89-6.2-.72.42 4.21 2.18 5.78 2.66z",
        fill: `url(#s1_${ee})`
      }
    )
  );
  return p(() => {
    setTimeout(() => {
      te("mono");
    }, 3e3);
  }, []), ne;
});
function isEndState(re) {
  return re === "ENDED";
}
function isErrorState(re) {
  return re === "ERROR";
}
function isStartState(re, te, ee) {
  const ie = re.getPlayerConfiguration().autoplay, ne = re.isPhasingEnabled(), ae = (ee && isPlayablePhase(ee.phase)) ?? !0;
  return te === "IDLE" && !ie && (!ne || ae);
}
function isStopped(re, te, ee) {
  var ne;
  const ie = (ee && isPlayablePhase(ee.phase)) ?? !0;
  return te === "IDLE" && !((ne = re.getPlayerData()) != null && ne.isPlayerLoaded()) && ie;
}
function getState(re, te, ee) {
  return te ? isErrorState(re) ? "ERROR" : isStartState(te, re, ee) || isStopped(te, re, ee) ? "START" : isEndState(re) ? "END" : "HIDDEN" : "HIDDEN";
}
function useStartEndViewState(re) {
  const te = (re == null ? void 0 : re.getPlayerStatus()) ?? "ERROR", ee = re == null ? void 0 : re.getLiveStatus();
  return F$1(
    () => getState(te, re, ee),
    [ee, re, te]
  );
}
const EndslateViewItem = ({
  title: re,
  imageUrl: te,
  targetUrl: ee,
  previewImageUrl: ie
}) => /* @__PURE__ */ Cn.createElement("a", { "data-rbup-endslate-item": !0, class: "endslate-view-item", href: ee, target: "_self" }, /* @__PURE__ */ Cn.createElement(
  CosmosMediaPreview,
  {
    class: "endslate-view-item__image",
    image: te,
    imagePreview: ie,
    "data-rbup-endslate-item-image": !0,
    imageAlt: ""
  }
), /* @__PURE__ */ Cn.createElement(
  CosmosText,
  {
    class: "endslate-view-item__title",
    weight: "bold",
    appearance: "light",
    size: "xx-small@small x-small@medium medium@large",
    clamp: 2
  },
  re
)), EndslateView = ({ relatedVideos: re, config: te }) => {
  const {
    playerState: { playerCoordinator: ee }
  } = usePlayerContext(), ie = useStartEndViewState(ee), ne = re && ie === "END", ae = (te == null ? void 0 : te.title) || translate("endslate-title"), ue = () => {
    ee == null || ee.restartPlaybackFromBeginning(), ee == null || ee.play();
  };
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ne && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-endslate": !0 }, /* @__PURE__ */ Cn.createElement("div", { class: "endslate-view" }, /* @__PURE__ */ Cn.createElement("div", { class: "endslate-view__grid" }, /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      class: "endslate-view__headline",
      "data-rbup-endslate-title": !0,
      size: "small@small medium@medium large@large",
      weight: "bold",
      appearance: "light"
    },
    ae
  ), /* @__PURE__ */ Cn.createElement("div", { class: "endslate-view__items" }, re.map((_e, fe) => /* @__PURE__ */ Cn.createElement(EndslateViewItem, { key: fe, ..._e }))), /* @__PURE__ */ Cn.createElement(
    CosmosButton,
    {
      class: "endslate-view__replay-button",
      "data-rbup-endslate-replay": !0,
      kind: "secondary",
      size: "small",
      shape: "pill",
      appearance: "light",
      onClick: ue
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconReplay, { class: "endslate-view__replay-icon", slot: "icon" }),
    translate("endslate-replay")
  )))));
}, InitialLoadingSpinner = () => /* @__PURE__ */ Cn.createElement("div", { class: "initial-loading-spinner", "data-rbup-initial-loading-spinner": !0 }, /* @__PURE__ */ Cn.createElement("div", { class: "initial-loading-spinner__container" }, /* @__PURE__ */ Cn.createElement(CosmosSpinner, { "data-rbup-buffer": !0, appearance: "light" }))), selectedLocales = window.navigator.languages, longDateFormat = Intl.DateTimeFormat(selectedLocales, {
  dateStyle: "long"
}), shortDateFormat = Intl.DateTimeFormat(selectedLocales, {
  weekday: "short",
  day: "2-digit",
  month: "short",
  year: "numeric"
}), timeZonedTimeFormat = Intl.DateTimeFormat(selectedLocales, {
  hour: "numeric",
  minute: "numeric",
  timeZoneName: "short"
});
function getStreamState(re, te) {
  const ee = te == null ? void 0 : te.phase;
  let ie;
  switch (ee) {
    case "canceled":
      ie = "CANCELED";
      break;
    case "live":
      ie = "STREAMING";
      break;
    case "trim":
      ie = "TRIMMING";
      break;
    case "unconfirmed":
      ie = "UNCONFIRMED";
      break;
    case "pre":
      ie = "PRE";
      break;
    case "post":
    case void 0: {
      ie = "NOT_LIVE_STREAM";
      break;
    }
  }
  return ie;
}
function extractPosterImageTag(re) {
  if (!re)
    return;
  if (Array.isArray(re))
    return re.find((ee) => extractPosterImageTag(ee));
  const te = re;
  if (te && typeof te == "object" && "type" in te)
    return te.type === "img" || te.type === "picture" ? te : extractPosterImageTag(te.props.children);
}
function getCountdownString(re, te = /* @__PURE__ */ new Date()) {
  if (!re)
    return;
  const ee = new Date(re).getTime() - te.getTime(), ie = Math.floor(ee / (1e3 * 60 * 60 * 24)), ne = Math.floor(ee / (1e3 * 60 * 60) % 24), ae = Math.floor(ee / 1e3 / 60 % 60), ue = Math.floor(ee / 1e3 % 60);
  return {
    days: ie < 0 ? "00" : addLeadingZero(ie),
    hours: ne < 0 ? "00" : addLeadingZero(ne),
    minutes: ae < 0 ? "00" : addLeadingZero(ae),
    seconds: ue < 0 ? "00" : addLeadingZero(ue)
  };
}
const LiveStreamCountdown = ({ nowDate: re, startTime: te }) => {
  const ee = _(0), [ie, ne] = h$2(getCountdownString(te));
  return p(() => (ee.current = window.setInterval(() => {
    te && ne(getCountdownString(te, re));
  }, 1e3), () => {
    window.clearInterval(ee.current);
  }), [re, te]), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__segment" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__numbers" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ie == null ? void 0 : ie.days[0])), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ie == null ? void 0 : ie.days[1]))), /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", kind: "subtle", size: "x-small" }, translate("liveStream-days"))), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__segment" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__numbers" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ie == null ? void 0 : ie.hours[0])), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ie == null ? void 0 : ie.hours[1]))), /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", kind: "subtle", size: "x-small" }, translate("liveStream-hours"))), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__segment" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__numbers" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ie == null ? void 0 : ie.minutes[0])), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ie == null ? void 0 : ie.minutes[1]))), /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", kind: "subtle", size: "x-small" }, translate("liveStream-minutes"))), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__segment" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__numbers" }, /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ie == null ? void 0 : ie.seconds[0])), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-countdown__number" }, /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", weight: "bold" }, ie == null ? void 0 : ie.seconds[1]))), /* @__PURE__ */ Cn.createElement(CosmosText, { appearance: "light", kind: "subtle", size: "x-small" }, translate("liveStream-seconds"))));
};
function calculateStateFromStreamState(re) {
  return {
    renderComponent: re !== "NOT_LIVE_STREAM" && re !== "STREAMING",
    isCanceled: re === "CANCELED",
    isPre: re === "PRE",
    isTrimming: re === "TRIMMING",
    isUnconfirmed: re === "UNCONFIRMED"
  };
}
const InfoDisplay = ({ streamState: re }) => {
  const { isCanceled: te, isTrimming: ee, isUnconfirmed: ie } = calculateStateFromStreamState(re), ne = re.toLocaleLowerCase(), ae = `liveStream-${ne}`, ue = {
    [`data-rbup-live-stream-info-${ne}-badge`]: !0,
    class: "live-stream-info__badge",
    appearance: "light",
    size: "x-small",
    weight: "bold"
  };
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, te && /* @__PURE__ */ Cn.createElement(CosmosText, { ...ue }, /* @__PURE__ */ Cn.createElement(CosmosIconNoData, { class: "live-stream-info__icon" }), /* @__PURE__ */ Cn.createElement("span", null, translate(ae))), ee && /* @__PURE__ */ Cn.createElement(CosmosText, { ...ue }, /* @__PURE__ */ Cn.createElement(CosmosIconClock, { class: "live-stream-info__icon" }), /* @__PURE__ */ Cn.createElement("span", null, translate(ae))), ie && /* @__PURE__ */ Cn.createElement(CosmosText, { ...ue }, /* @__PURE__ */ Cn.createElement(CosmosIconEventDetails, { class: "live-stream-info__icon" }), /* @__PURE__ */ Cn.createElement("span", null, translate(ae))));
}, PreOrCanceledOrTrimmingDisplay = ({
  streamState: re,
  startTime: te
}) => {
  const { isCanceled: ee, isPre: ie, isTrimming: ne } = calculateStateFromStreamState(re), ae = `live-stream-info__date${ee ? " live-stream-info__date--canceled" : ""}`;
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, (ie || ee) && /* @__PURE__ */ Cn.createElement(CosmosText, { class: ae, appearance: "light", size: "x-small" }, te && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement("span", { "data-rbup-canceled-date": !0 }, longDateFormat.format(new Date(te))), /* @__PURE__ */ Cn.createElement("span", { class: "live-stream-info__separator" }, "·"), /* @__PURE__ */ Cn.createElement("span", { "data-rbup-canceled-time": !0 }, timeZonedTimeFormat.format(new Date(te))))), ne && /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      class: "live-stream-info__date live-stream-info__date--trimming",
      appearance: "light",
      size: "x-small"
    },
    te && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement(CosmosIconLiveBroadcast, { class: "live-stream-info__icon" }), /* @__PURE__ */ Cn.createElement("span", null, translate("liveStream-airedOn", {
      date: shortDateFormat.format(new Date(te))
    }), " "))
  ));
}, LiveStreamInfoPoster = ({
  userPosterImage: re,
  posterSrcSet: te,
  playerWidth: ee,
  imgAlt: ie
}) => /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, re ? /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-info__custom-poster-container" }, re) : /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-info__poster-container" }, /* @__PURE__ */ Cn.createElement("img", { "data-rbup-live-stream-info-poster": !0, ...te, sizes: `${ee}px`, alt: ie }))), LiveStreamInfo = ({
  playerWidth: re,
  aspectRatio: te,
  customPosterImage: ee
}) => {
  const {
    playerState: { liveStatus: ie, mediaMetaData: ne, playbackMode: ae, posterImage: ue, playerConfiguration: _e }
  } = usePlayerContext(), fe = getStreamState(ae, ie), { renderComponent: le, isPre: se } = calculateStateFromStreamState(fe), oe = (ie == null ? void 0 : ie.startTime) ?? resolveCurrentSunrise(ne), ce = oe && getDaysFromNow(oe) < 100, he = se && ce, ge = F$1(
    () => ue ? calculatePosterSrcSet(ue, te) : void 0,
    [te, ue]
  ), ve = (ne == null ? void 0 : ne.title) ?? (_e == null ? void 0 : _e.title), me = F$1(() => extractPosterImageTag(ee), [ee]);
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, le && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-live-stream-info": !0, class: "live-stream-info" }, /* @__PURE__ */ Cn.createElement(
    LiveStreamInfoPoster,
    {
      userPosterImage: me,
      posterSrcSet: ge,
      playerWidth: re,
      imgAlt: ve
    }
  ), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-info__background" }), /* @__PURE__ */ Cn.createElement("div", { class: "live-stream-info__info" }, (ne == null ? void 0 : ne.eventLogoUrl) && /* @__PURE__ */ Cn.createElement(
    "img",
    {
      "data-rbup-live-stream-info-event-logo": !0,
      src: ne.eventLogoUrl,
      class: "live-stream-info__event-logo",
      alt: ""
    }
  ), he && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-live-stream-info-countdown": !0, class: "live-stream-info__countdown" }, /* @__PURE__ */ Cn.createElement(LiveStreamCountdown, { startTime: oe })), /* @__PURE__ */ Cn.createElement(InfoDisplay, { streamState: fe }), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "data-rbup-live-stream-info-title": !0,
      appearance: "light",
      class: "live-stream-info__title",
      size: "large x-large@medium",
      weight: "bold"
    },
    ne == null ? void 0 : ne.title
  ), /* @__PURE__ */ Cn.createElement(PreOrCanceledOrTrimmingDisplay, { streamState: fe, startTime: ie == null ? void 0 : ie.startTime }), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      "data-rbup-live-stream-info-description": !0,
      class: "live-stream-info__description",
      appearance: "light",
      size: "x-small",
      kind: "subtle"
    },
    ne == null ? void 0 : ne.description
  ), (ne == null ? void 0 : ne.eventPageUrl) && /* @__PURE__ */ Cn.createElement(CosmosText, { class: "live-stream-info__event-link", size: "x-small", weight: "bold" }, /* @__PURE__ */ Cn.createElement(
    CosmosButton,
    {
      "data-rbup-live-stream-info-event-page-link": !0,
      appearance: "light",
      href: ne.eventPageUrl,
      kind: "tertiary",
      shape: "pill",
      size: "small",
      target: "_blank"
    },
    /* @__PURE__ */ Cn.createElement(CosmosIconChevronLeft, { slot: "icon", class: "live-stream-info__icon" }),
    translate("liveStream-backToEvent")
  )))));
};
function getDaysFromNow(re) {
  const te = new Date(re), ie = Math.abs((/* @__PURE__ */ new Date()).getTime() - te.getTime()) / 1e3;
  return Math.floor(ie / (60 * 60 * 24));
}
function resolveCurrentSunrise(re) {
  if (re)
    return re.currentSunrise;
}
function timeDifference(re) {
  return Date.parse(re) - Date.now();
}
function getTimeRemaining(re) {
  const te = timeDifference(re) / 1e3, ie = getFormattedTimeString(te).split(":"), ne = ie.length === 3, ae = ne ? ie[0] : "00", ue = ne ? ie[1] : ie[0], _e = ne ? ie[2] : ie[1];
  return `${ae} h ${ue} m ${_e} s`;
}
function getMonthString(re) {
  return [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
  ][re];
}
const TWO_DAYS_IN_MS = 2 * 24 * 60 * 60 * 1e3, MultiChannelSwitcherViewLiveAtLabel = ({
  startTime: re
}) => {
  const [te] = h$2(
    () => timeDifference(re) < TWO_DAYS_IN_MS && timeDifference(re) >= 0
  ), ee = _(0), [ie, ne] = h$2("...");
  return p(() => {
    const ae = new Date(re);
    if (te)
      ee.current = window.setInterval(() => {
        ne(`${translate("multiChannel-label-liveIn")} ${getTimeRemaining(re)}`);
      }, 1e3);
    else {
      window.clearInterval(ee.current);
      const ue = `global-month-short-${getMonthString(ae.getMonth())}`;
      ne(`${ae.getDate()} ${translate(ue)} ${ae.getFullYear()}`);
    }
    return () => {
      window.clearInterval(ee.current);
    };
  }, [te, re]), /* @__PURE__ */ Cn.createElement(CosmosText, { class: "multi-channel-switcher-view-live-at__label", size: "x-small" }, ie);
};
function getStatusLabel(re) {
  switch (re) {
    case "now":
      return translate("multiChannel-label-nowWatching");
    case "live":
      return translate("multiChannel-label-live");
    case "post":
      return translate("multiChannel-label-replay");
    case "trim":
      return translate("multiChannel-label-trim");
    default:
      return;
  }
}
function calculateClassName(re) {
  return [
    "multi-channel-switcher-view-item",
    !isMobileDevice() && "multi-channel-switcher-view-item__desktop",
    re && "multi-channel-switcher-view-item--active"
  ].filter(Boolean).join(" ");
}
const MultiChannelSwitcherViewItem = ({
  isCurrentlyPlaying: re = !1,
  phase: te,
  title: ee,
  startTime: ie,
  videoId: ne,
  onSelectNewAsset: ae
}) => {
  const ue = (te === "post" || te === "live") && !re, _e = T$1(
    (le) => {
      ue && (isLeftClick(le) || isTouch(le)) && ae(ne);
    },
    [ue, ae, ne]
  ), fe = calculateClassName(ue);
  return /* @__PURE__ */ Cn.createElement("button", { class: fe, onPointerUp: _e }, /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view-item__container" }, /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view-item__text" }, /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      class: "multi-channel-switcher-view-item__title",
      appearance: "light",
      clamp: 1,
      weight: "bold",
      size: "small"
    },
    ee
  ), /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view-item__status" }, re && /* @__PURE__ */ Cn.createElement("div", null, /* @__PURE__ */ Cn.createElement(CosmosIconPlay, { class: "multi-channel-switcher-view-item__status-icon" })), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      class: "multi-channel-switcher-view-item__status-label",
      appearance: "light",
      clamp: 1,
      size: "x-small"
    },
    te === "pre" && ie && /* @__PURE__ */ Cn.createElement(MultiChannelSwitcherViewLiveAtLabel, { startTime: ie }),
    te !== "pre" && getStatusLabel(re ? "now" : te)
  ))), !re && /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view-item__icon" }, /* @__PURE__ */ Cn.createElement("div", null, /* @__PURE__ */ Cn.createElement(CosmosIconPlay, { class: "multi-channel-switcher-view-item__icon-play" })))));
};
function onScroll(re, te, ee) {
  const ie = {
    behavior: "smooth"
  }, ue = re.scrollWidth / te - 16;
  ee === "left" && (ie.left = re.scrollLeft - ue), ee === "right" && (ie.left = re.scrollLeft + ue), re.scrollTo(ie);
}
function showHideScrollButtonsWhenNeeded(re) {
  const te = {
    showLeftButton: !1,
    showRightButton: !1
  };
  return re && (re.scrollLeft > 0 && (te.showLeftButton = !0), Math.round(re.scrollLeft + re.offsetWidth) < re.scrollWidth && (te.showRightButton = !0)), te;
}
function addCurrentToOtherLiveVideos(re, te) {
  return !(re != null && re.otherLiveVideos) || !te ? [] : [
    {
      phase: re.phase,
      startTime: re.startTime,
      title: te.title,
      videoId: te.videoId
    }
  ].concat(re.otherLiveVideos);
}
const MultiChannelSwitcherView = ({
  onCloseView: re,
  onPlayNewAsset: te
}) => {
  const {
    playerState: { liveStatus: ee, mediaMetaData: ie }
  } = usePlayerContext(), ne = _(null), [ae, ue] = h$2(), _e = F$1(() => addCurrentToOtherLiveVideos(ee, ie), [ee, ie]), fe = T$1(
    (ve) => {
      ve.stopPropagation(), re();
    },
    [re]
  );
  p(() => {
    ue(showHideScrollButtonsWhenNeeded(ne.current));
  }, []);
  const le = T$1(
    (ve, me) => {
      if (!ne.current)
        return;
      ve.stopPropagation();
      const be = ne.current;
      onScroll(be, _e.length, me), ue(showHideScrollButtonsWhenNeeded(ne.current));
    },
    [_e.length]
  ), se = T$1(
    (ve) => {
      te(ve), re();
    },
    [re, te]
  );
  useResize(
    () => ue(showHideScrollButtonsWhenNeeded(ne.current)),
    ne
  );
  const [oe] = h$2(!isMobileDevice()), ce = oe ? "multi-channel-switcher-view__item-list-items" : "multi-channel-switcher-view__item-list-items--mobile", he = [
    "multi-channel-switcher-view__item-list",
    !oe && "multi-channel-switcher-view__item-list--mobile"
  ].filter(Boolean).join(" "), ge = [
    "multi-channel-switcher-view__item-list-headline",
    oe && "multi-channel-switcher-view__item-list-headline--desktop"
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ Cn.createElement("div", { "data-rbup-multi-channel-switcher-view": !0, class: "multi-channel-switcher-view" }, /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__close-button-container" }, /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__close-button" }, /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "data-rbup-close-button",
      Icon: /* @__PURE__ */ Cn.createElement(
        CosmosIconClose,
        {
          "data-rbup-icon-close": !0,
          class: "multi-channel-switcher-view__close-icon",
          slot: "icon"
        }
      ),
      appearance: "light",
      shape: "circle",
      kind: "tertiary",
      onPointerUp: fe
    }
  ), /* @__PURE__ */ Cn.createElement(
    CosmosText,
    {
      class: "multi-channel-switcher-view__close-label",
      appearance: "light",
      size: "x-small",
      weight: "bold"
    },
    translate("button-close")
  ))), /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__item-list-container" }, /* @__PURE__ */ Cn.createElement("div", { class: he }, /* @__PURE__ */ Cn.createElement(CosmosTitle, { class: ge, appearance: "light", size: "x-small" }, translate("multiChannel-schedule")), /* @__PURE__ */ Cn.createElement(
    "div",
    {
      class: ce,
      onScroll: () => {
        ue(showHideScrollButtonsWhenNeeded(ne.current));
      },
      ref: ne
    },
    _e.map((ve, me) => /* @__PURE__ */ Cn.createElement(
      MultiChannelSwitcherViewItem,
      {
        key: me,
        isCurrentlyPlaying: me === 0,
        phase: ve.phase,
        title: ve.title ?? "",
        videoId: ve.videoId ?? "",
        startTime: ve.startTime,
        onSelectNewAsset: se
      }
    ))
  )), !oe && /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__fade multi-channel-switcher-view__fade--mobile" }), oe && /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__navi", "data-rbup-multi-channel-switcher-view-navi": !0 }, /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__fade multi-channel-switcher-view__fade--desktop" }), (ae == null ? void 0 : ae.showLeftButton) && /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__navi-button multi-channel-switcher-view__navi-button--left" }, /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "rbup-multi-channel-switcher-left",
      Icon: /* @__PURE__ */ Cn.createElement(
        CosmosIconChevronLeft,
        {
          "data-rbup-icon-arrow-left": !0,
          class: "multi-channel-switcher-view__navi-icon",
          slot: "icon"
        }
      ),
      kind: "primary",
      shape: "square",
      onPointerUp: (ve) => le(ve, "left")
    }
  )), (ae == null ? void 0 : ae.showRightButton) && /* @__PURE__ */ Cn.createElement("div", { class: "multi-channel-switcher-view__navi-button multi-channel-switcher-view__navi-button--right" }, /* @__PURE__ */ Cn.createElement(
    ControlsButton,
    {
      dataAttribute: "rbup-multi-channel-switcher-right",
      Icon: /* @__PURE__ */ Cn.createElement(
        CosmosIconChevronRight,
        {
          "data-rbup-icon-arrow-right": !0,
          class: "multi-channel-switcher-view__navi-icon",
          slot: "icon"
        }
      ),
      kind: "primary",
      shape: "square",
      onPointerUp: (ve) => le(ve, "right")
    }
  )))));
};
function showProductPlacement(re, te, ee, ie, ne, ae, ue) {
  if (!(ae === "AT") && !ue || re === "IDLE")
    return "NEVER_SHOWN";
  const fe = te <= ne, le = ee >= ie - ne;
  return fe || le ? "SHOWN" : "FADED_OUT";
}
const defaultProductPlacementDefinition = {
  displayTimeInSec: 3,
  component: () => /* @__PURE__ */ Cn.createElement(CosmosIconProductPlacement, null)
}, RbupVideoProductPlacement = ({
  productPlacementDefinition: re = defaultProductPlacementDefinition
}) => {
  const {
    playerState: { playerStatus: te, playbackPosInSec: ee, durationInSec: ie, cumulatedPlayTimeInSec: ne, playerCoordinator: ae }
  } = usePlayerContext(), ue = re.displayTimeInSec, _e = F$1(() => {
    const oe = ae == null ? void 0 : ae.getMediaMetaData();
    return showProductPlacement(
      te,
      ne,
      ee,
      ie,
      ue,
      (oe == null ? void 0 : oe.userCountry) ?? void 0,
      !!(oe != null && oe.showProductPlacement)
    );
  }, [ae, te, ne, ee, ie, ue]), fe = _e !== "FADED_OUT", le = _e !== "NEVER_SHOWN", se = fe ? "product-placement--fade-in" : "product-placement--fade-out";
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, le && /* @__PURE__ */ Cn.createElement("div", { "data-rbup-product-placement": !0, class: `product-placement ${se}` }, /* @__PURE__ */ Cn.createElement(re.component, null)));
};
function usePressedKeyGroup(re, te) {
  const [ee, ie] = h$2(!1), [ne, ae] = h$2([]), ue = T$1(
    (le) => {
      const se = le.key;
      !ne.includes(se) && te.includes(se) && ne.push(le.key);
    },
    [te, ne]
  ), _e = T$1(() => {
    const le = ne.join(""), se = te.join("");
    ie(le === se);
  }, [te, ne]), fe = T$1(
    (le) => {
      _e();
      const se = le.key, oe = ne.filter((ce) => ce !== se);
      ae(oe);
    },
    [_e, ne]
  );
  return p(() => {
    const le = re.current;
    if (!le)
      throw new Error("No element provided");
    return le.setAttribute("tabIndex", "0"), le.addEventListener("keydown", ue), le.addEventListener("keyup", fe), () => {
      le.removeEventListener("keydown", ue), le.removeEventListener("keyup", fe);
    };
  }, [re, ue, fe]), ee;
}
const OverrideTarget = {
  AUDIO: "Audio",
  SUBTITLES: "Subtitles",
  TRANSLATIONS: "Translations"
};
function languageOverrideInfo(re) {
  if (!re)
    return;
  const te = getBrowserLanguage(), ee = re.getStorageServiceAllStoredValues(), ie = re.getPlayerConfiguration(), ne = calculateAudioOverride(ie, re, te, ee), ae = calculateSubtitlesOverride(ie, ee), ue = calculateTranslationsOverride(ie, te), _e = calculateFormattedOverrideReferenceString(ie, ee);
  return {
    audioOverride: ne,
    subtitleOverride: ae,
    translationsOverride: ue,
    overrideReference: _e
  };
}
function calculateFormattedOverrideReferenceString(re, te) {
  let ee = "", ie = "";
  return te != null && te.audioLanguage && (ee = `${ee}${OverrideTarget.AUDIO}: ${te.audioLanguage} `), te != null && te.subtitleLanguage && (ee = `${ee}${OverrideTarget.SUBTITLES}: ${te.subtitleLanguage} `), re.overrideAudioLanguage && (ie = `${ie}${OverrideTarget.AUDIO}: ${re.overrideAudioLanguage} `), re.overrideSubtitleLanguage && (ie = `${ie}${OverrideTarget.SUBTITLES}: ${re.overrideSubtitleLanguage} `), re.overrideTranslationLanguage && (ie = `${ie}${OverrideTarget.TRANSLATIONS}: ${re.overrideTranslationLanguage} `), {
    storedRef: ee !== "" ? ee : void 0,
    configRef: ie !== "" ? ie : void 0
  };
}
function getCurrentAudioIso(re, te) {
  const ee = te ?? "";
  return re ? re[ee] : ee;
}
function calculateAudioOverride(re, te, ee, ie) {
  var fe, le;
  const ne = getCurrentAudioIso(
    (fe = te.getMediaMetaData()) == null ? void 0 : fe.availableAudioLanguages,
    (le = te.getSelectedAudioTrack()) == null ? void 0 : le.lang
  ), ae = ee === ne && (ie == null ? void 0 : ie.audioLanguage) !== ne && re.overrideAudioLanguage !== ne ? { source: "Browser", iso: ee } : void 0, ue = (ie == null ? void 0 : ie.audioLanguage) === ne && re.overrideAudioLanguage !== ne ? { source: "Storage", iso: ie == null ? void 0 : ie.audioLanguage } : void 0, _e = re.overrideAudioLanguage ? { source: "Config", iso: re.overrideAudioLanguage } : void 0;
  return ae ?? ue ?? _e;
}
function calculateSubtitlesOverride(re, te) {
  if (re.overrideSubtitleLanguage)
    return { source: "Config", iso: re.overrideSubtitleLanguage };
  if (te != null && te.subtitleLanguage)
    return {
      source: "Storage",
      iso: te.subtitleLanguage
    };
}
function calculateTranslationsOverride(re, te) {
  return re.overrideTranslationLanguage ? {
    source: "Config",
    iso: re.overrideTranslationLanguage
  } : {
    source: "Browser",
    iso: te
  };
}
const CopyableListElement = ({ body: re }) => {
  const [te, ee] = h$2(!1), ie = T$1(async () => {
    typeof re == "string" && (await navigator.clipboard.writeText(re), ee(!0), setTimeout(() => {
      ee(!1);
    }, 5e3));
  }, [re]), ne = /* @__PURE__ */ Cn.createElement("div", { class: "nerd-mode__list-item-button" }, /* @__PURE__ */ Cn.createElement(CosmosTooltip, { content: translate("nerdMode-copyId"), placement: "above", spacing: "tight", unreachable: !0, follow: !0 }, /* @__PURE__ */ Cn.createElement(CosmosButton, { kind: "cover-up", size: "small", shape: "pill", onClick: ie }, re))), ae = /* @__PURE__ */ Cn.createElement(CosmosText, { size: "small" }, translate("nerdMode-idCopied"));
  return te ? ae : ne;
}, ListItem = ({ label: re, crepoOrAssetId: te }) => /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, re && /* @__PURE__ */ Cn.createElement("li", { class: "nerd-mode__list-item" }, re && /* @__PURE__ */ Cn.createElement(CosmosText, { size: "small" }, re)), te && /* @__PURE__ */ Cn.createElement("li", { class: "nerd-mode__list-item" }, te && CopyableListElement({ body: te }))), PropertyList = ({ crepoId: re, subtitleOverride: te, translationsOverride: ee, hasOverrideReference: ie }) => /* @__PURE__ */ Cn.createElement("ul", { class: "nerd-mode__label-list", "data-rbup-nerd-mode-label-list": !0 }, /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-assetId") }), re && /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-crepoId") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-playerVersion") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-techVersion") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-geolocation") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-rendition") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-audioLanguageOverride") }), te && /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-subtitlesLanguageOverride") }), ee && /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-translationsLanguageOverride") }), ie && /* @__PURE__ */ Cn.createElement(ListItem, { label: translate("nerdMode-overrideReference") })), ValueList = ({
  elementRef: re,
  elementStyle: te,
  assetId: ee,
  crepoId: ie,
  subtitleOverride: ne,
  playerCoordinator: ae,
  userCountry: ue,
  audioOverride: _e,
  translationsOverride: fe,
  hasOverrideReference: le,
  overrideReference: se
}) => /* @__PURE__ */ Cn.createElement("ul", { class: "nerd-mode__data-list", "data-rbup-nerd-mode-data-list": !0, ref: re, style: te }, /* @__PURE__ */ Cn.createElement(ListItem, { crepoOrAssetId: ee }), ie && /* @__PURE__ */ Cn.createElement(ListItem, { crepoOrAssetId: ie }), /* @__PURE__ */ Cn.createElement(ListItem, { label: CORE_VERSION }), /* @__PURE__ */ Cn.createElement(ListItem, { label: (ae == null ? void 0 : ae.getTechVersion()) ?? translate("nerdMode-unknownValue") }), /* @__PURE__ */ Cn.createElement(ListItem, { label: ue }), /* @__PURE__ */ Cn.createElement(ListItem, { label: `${ae == null ? void 0 : ae.getVideoQuality().height}p` }), /* @__PURE__ */ Cn.createElement(ListItem, { label: _e ?? "N/A" }), /* @__PURE__ */ Cn.createElement(ListItem, { label: ne }), /* @__PURE__ */ Cn.createElement(ListItem, { label: fe }), le && (se == null ? void 0 : se.configRef) && /* @__PURE__ */ Cn.createElement(ListItem, { label: `${translate("nerdMode-playerConfiguration")}: ${se.configRef}` }), le && (se == null ? void 0 : se.storedRef) && /* @__PURE__ */ Cn.createElement(ListItem, { label: `${translate("nerdMode-localeStorage")}: ${se.storedRef}` }));
function getLanguageOverrideInfo(re) {
  return re != null && re.iso ? `${re.iso} (${re.source})` : void 0;
}
function calculateAssetId(re, te) {
  return (re == null ? void 0 : re.assetId) ?? (re == null ? void 0 : re.videoId) ?? te;
}
const NerdMode = () => {
  const {
    playerState: { mediaMetaData: re, playerCoordinator: te, playerConfiguration: ee }
  } = usePlayerContext(), ie = _(null), [ne, ae] = h$2(""), ue = calculateAssetId(re, ee == null ? void 0 : ee.assetId), _e = re != null && re.assetId ? re.videoId : void 0, fe = F$1(() => languageOverrideInfo(te), [te]), le = getLanguageOverrideInfo(fe == null ? void 0 : fe.audioOverride), se = getLanguageOverrideInfo(fe == null ? void 0 : fe.subtitleOverride), oe = getLanguageOverrideInfo(fe == null ? void 0 : fe.translationsOverride), ce = fe == null ? void 0 : fe.overrideReference, he = (ce == null ? void 0 : ce.storedRef) ?? (ce == null ? void 0 : ce.configRef);
  return p(() => {
    if (ie.current) {
      const ge = `width: ${ie.current.clientWidth + 1}px`;
      ae(ge);
    }
  }, [ae]), /* @__PURE__ */ Cn.createElement("section", { class: "nerd-mode", "data-rbup-nerd-mode": !0 }, /* @__PURE__ */ Cn.createElement("header", { class: "nerd-mode__header", "data-rbup-nerd-mode-header": !0 }, /* @__PURE__ */ Cn.createElement(CosmosIconPreview, { class: "nerd-mode__header-icon", "data-rbup-nerd-mode-header-icon": !0 }), /* @__PURE__ */ Cn.createElement(CosmosTitle, { "data-rbup-nerd-mode-header-title": !0, weight: "bold", size: "x-small" }, "Nerd Mode")), /* @__PURE__ */ Cn.createElement("hr", { class: "nerd-mode__separator-line" }), /* @__PURE__ */ Cn.createElement("div", { class: "nerd-mode__grid" }, /* @__PURE__ */ Cn.createElement(
    PropertyList,
    {
      crepoId: _e,
      subtitleOverride: se,
      translationsOverride: oe,
      hasOverrideReference: he
    }
  ), /* @__PURE__ */ Cn.createElement(
    ValueList,
    {
      elementRef: ie,
      elementStyle: ne,
      assetId: ue,
      crepoId: _e,
      playerCoordinator: te,
      userCountry: (re == null ? void 0 : re.userCountry) ?? translate("nerdMode-unknownValue"),
      audioOverride: le,
      subtitleOverride: se,
      translationsOverride: oe,
      hasOverrideReference: he,
      overrideReference: ce
    }
  )));
}, MAIN_CLASS_NAME = "themed-player-root", InnerThemedPlayer = k((re, te) => {
  const {
    adService: ee,
    config: ie,
    customStyles: ne,
    CustomToastComponent: ae,
    dataLoader: ue,
    id: _e,
    internalOnApiAvailable: fe,
    liveStatusDataLoader: le,
    styles: se,
    ThemeComponent: oe,
    aspectRatio: ce,
    globalKeyboardNavigation: he,
    CenteredToastComponent: ge
  } = re, [ve, me] = h$2(), {
    init: be,
    playerState: { playerCoordinator: pe, playerStatus: $e, isVRVideo: ye }
  } = usePlayerContext(), Se = validateGivenAspectRatio(ce), we = _(null), [Pe, Te] = h$2(
    ie
  );
  p(() => {
    Te(ie);
  }, [ie]);
  const Ee = usePlayerWidth(we), Me = useContainerQuery(we, BREAKPOINTS), Ae = {
    smallOrBigger: cssClassesContainsBreakpoint(Me, Breakpoint.small),
    mediumOrBigger: cssClassesContainsBreakpoint(Me, Breakpoint.medium),
    largeOrBigger: cssClassesContainsBreakpoint(Me, Breakpoint.large)
  }, Ne = getThemeCSSVariables(Pe == null ? void 0 : Pe.theme), Ce = T$1(
    (Le) => {
      Le && (be(Le), Le.fullscreenElement = we.current);
    },
    [be]
  ), Ie = usePressedKeyGroup(we, [KEYCODE_R, KEYCODE_B]);
  p(() => {
    Ie && me((Le) => !Le);
  }, [Ie]);
  const xe = T$1(
    (Le) => {
      const De = {
        ...ie,
        assetId: Le
      };
      Te(De);
    },
    [ie]
  ), Ue = getMaxWidthForAspectRatio(Se), ke = ye ? `${MAIN_CLASS_NAME} vr-content` : MAIN_CLASS_NAME;
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement("style", null, se), ne && /* @__PURE__ */ Cn.createElement("style", null, ne), /* @__PURE__ */ Cn.createElement(
    "div",
    {
      id: _e,
      class: `${ke} ${Me}`,
      style: {
        ...Ne,
        "--max-width": Ue
      },
      ref: we
    },
    Pe && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, /* @__PURE__ */ Cn.createElement(
      RbupVideoCore,
      {
        ref: te,
        adService: ee,
        config: Pe,
        dataLoader: ue,
        liveStatusDataLoader: le,
        onCoordinatorAvailable: Ce,
        internalOnApiAvailable: fe,
        aspectRatio: Se
      }
    ), pe && /* @__PURE__ */ Cn.createElement(
      oe,
      {
        ...re,
        config: Pe,
        sizeBreakpoints: Ae,
        playerWidth: Ee,
        playerCoordinator: pe,
        playerStatus: $e,
        onPlayNewAsset: xe,
        CustomToastComponent: ae,
        aspectRatio: Se,
        globalKeyboardNavigation: he,
        CenteredToastComponent: ge
      }
    ), ve && /* @__PURE__ */ Cn.createElement(NerdMode, null), /* @__PURE__ */ Cn.createElement(ErrorDisplay, null))
  ));
}), ThemedPlayer = k((re, te) => /* @__PURE__ */ Cn.createElement(PlayerStateContextProvider, null, /* @__PURE__ */ Cn.createElement(UserInteractionContextProvider, null, /* @__PURE__ */ Cn.createElement(ControlsVisibilityContextProvider, null, /* @__PURE__ */ Cn.createElement(InnerThemedPlayer, { ref: te, ...re }))))), StartAndEndView = ({
  playerWidth: re,
  customPosterImage: te,
  aspectRatio: ee,
  showAtEnd: ie = !0
}) => {
  const {
    playerState: { playerCoordinator: ne, posterImage: ae, mediaMetaData: ue, playerConfiguration: _e }
  } = usePlayerContext(), fe = useStartEndViewState(ne), le = () => {
    fe === "START" ? ne == null || ne.play() : fe === "END" && ie && (ne == null || ne.restartPlaybackFromBeginning(), ne == null || ne.play());
  }, se = F$1(
    () => ae ? calculatePosterSrcSet(ae, ee) : void 0,
    [ee, ae]
  ), oe = translate("tooltip-play"), ce = translate("tooltip-replay"), he = fe === "END" ? ce : oe, ge = (ue == null ? void 0 : ue.title) ?? (_e == null ? void 0 : _e.title), ve = F$1(() => extractPosterImageTag(te), [te]);
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, fe !== "HIDDEN" && /* @__PURE__ */ Cn.createElement(
    "div",
    {
      "data-rbup-start-end": !0,
      class: "start-and-end-view",
      onClick: le,
      role: "button",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ Cn.createElement("div", { class: "start-and-end-view__buttons" }, /* @__PURE__ */ Cn.createElement(
      CosmosTooltip,
      {
        content: he,
        appearance: "dark",
        placement: "above",
        spacing: "tight",
        follow: !0,
        unreachable: !0,
        offset: 30
      },
      fe === "END" && ie && /* @__PURE__ */ Cn.createElement(
        CosmosButton,
        {
          "data-rbup-replay-button": !0,
          ariaLabel: ce,
          shape: "circle",
          class: "start-and-end-view__button"
        },
        /* @__PURE__ */ Cn.createElement(
          CosmosIconReplay,
          {
            "data-rbup-replay-icon": !0,
            class: "start-and-end-view__icon",
            slot: "icon"
          }
        )
      ),
      fe === "START" && /* @__PURE__ */ Cn.createElement(
        CosmosButton,
        {
          "data-rbup-start-button": !0,
          ariaLabel: oe,
          shape: "circle",
          class: "start-and-end-view__button"
        },
        /* @__PURE__ */ Cn.createElement(CosmosIconPlay, { class: "start-and-end-view__icon", slot: "icon" })
      )
    )),
    ve ? /* @__PURE__ */ Cn.createElement("div", { class: "start-and-end-view__bg-custom-image-container" }, ve) : /* @__PURE__ */ Cn.createElement("div", { className: "start-and-end-view__bg-image-container" }, /* @__PURE__ */ Cn.createElement("img", { "data-rbup-poster": !0, ...se, sizes: `${re}px`, alt: ge }))
  ));
}, SubtitleContainer = ({ htmlStringArr: re, controlsVisibility: te }) => /* @__PURE__ */ Cn.createElement("div", { class: `subtitles-overlay ${te === "fade-in" ? "subtitles-on-top" : ""}` }, /* @__PURE__ */ Cn.createElement("div", { class: "subtitles-overlay__text-container" }, re == null ? void 0 : re.map((ee, ie) => /* @__PURE__ */ Cn.createElement(CosmosText, { size: "medium", appearance: "light", key: ie, class: "subtitles-overlay__text-display" }, /* @__PURE__ */ Cn.createElement("span", { dangerouslySetInnerHTML: { __html: ee } }))))), SubtitlesOverlay = () => {
  const {
    playerState: { playerCoordinator: re }
  } = usePlayerContext(), te = useControlsVisibilityContext().controlsVisibility, [ee, ie] = h$2();
  return p(() => {
    const ne = (ae) => {
      switch (ae.type) {
        case "subtitleUpdate":
          ie(ae.currentSubtitleHtmls);
          break;
        case "playbackFinished":
        case "loaded":
        case "seeking":
          ie(void 0);
          break;
      }
    };
    return re == null || re.addEventListener(ne), () => {
      re == null || re.removeEventListener(ne);
    };
  }, [re]), /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ee && /* @__PURE__ */ Cn.createElement(SubtitleContainer, { htmlStringArr: ee, controlsVisibility: te }));
}, CenteredToastWrapper = ({
  displayTimeInSec: re = 3,
  CenteredToastComponent: te,
  sizeBreakpoints: ee
}) => {
  const {
    playerState: { playerStatus: ie, playbackPosInSec: ne, durationInSec: ae, cumulatedPlayTimeInSec: ue, playerCoordinator: _e }
  } = usePlayerContext(), fe = F$1(() => {
    if (!(_e == null ? void 0 : _e.shouldShowProductPlacement()))
      return "NEVER_SHOWN";
    const oe = _e == null ? void 0 : _e.getMediaMetaData();
    return showProductPlacement(
      ie,
      ue,
      ne,
      ae,
      re + 1,
      (oe == null ? void 0 : oe.userCountry) ?? void 0,
      !!(oe != null && oe.showProductPlacement)
    );
  }, [_e, ie, ue, ne, ae, re]);
  _e == null || _e.shouldShowProductPlacement();
  const le = fe === "FADED_OUT" || fe === "NEVER_SHOWN";
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, !ee.mediumOrBigger && le && te && /* @__PURE__ */ Cn.createElement(te, null));
}, styles = `:host,:root{all:initial;--transition-timing: .3s;--g-controls-animation-fade-in: g-controls-fade-in var(--transition-timing) forwards;--g-controls-animation-fade-out: g-controls-fade-out var(--transition-timing) forwards;-webkit-tap-highlight-color:transparent}:host *,:root *{box-sizing:border-box}.g-icon{color:#fff;height:18px;width:18px}.g-icon--primary{color:var(--rbup-primary-color)}.g-screen-reader-only{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}@keyframes g-controls-fade-in{0%{pointer-events:none;opacity:0}to{pointer-events:auto;opacity:1}}@keyframes g-controls-fade-out{0%{pointer-events:auto;opacity:1}to{pointer-events:none;opacity:0}}.cornerbug{height:100%;left:0;position:absolute;top:0;width:100%;pointer-events:none}.cornerbug__icon{position:absolute;top:4.9383%;right:2.777%;width:8.888%;max-width:180px;pointer-events:none}.cornerbug__icon:after{content:"";position:relative;display:block;width:1%;height:0;padding-bottom:41.86%}.cta-toast-button{transition:opacity .3s cubic-bezier(.32,0,1,.32)}.cta-toast-button--hidden{opacity:0}.endslate-view{align-items:center;background:linear-gradient(0deg,rgba(0,15,30,.4),rgba(0,15,30,.4));display:flex;justify-content:center;padding:0 24px;position:absolute;left:0;bottom:0;top:0;right:0;--cosmos-text-font-family: var(--rbup-component-font-family, $default-font-family)}.endslate-view__grid{display:grid;grid-template-areas:"title" "image" "button"}.endslate-view__headline{grid-area:title;margin-bottom:12px}.endslate-view__replay-button{grid-area:button;justify-self:center;margin-top:12px}.endslate-view__replay-icon{height:25px;width:25px}.endslate-view__items{grid-area:image;display:grid;flex:1;grid-column-gap:24px;grid-template-columns:repeat(2,1fr);grid-template-rows:auto 0}.endslate-view-item{background-color:#000f1e99;border-radius:6px;filter:drop-shadow(0 16px 16px rgba(0,15,30,.2));position:relative;height:77px;width:136px}.endslate-view-item__image{height:100%;border-radius:6px}.endslate-view-item:nth-child(3){display:none}.endslate-view-item:after{background:linear-gradient(180deg,rgba(0,15,30,.0001) 0%,rgba(0,15,30,.4) 100%);border-radius:6px;content:"";height:100%;left:0;position:absolute;top:0;width:100%}.endslate-view-item:hover:after{background:linear-gradient(180deg,rgba(0,15,30,.0001) 0%,rgba(0,15,30,.6) 100%)}.endslate-view-item__title{align-items:end;bottom:8px;display:flex;left:14px;max-width:360px;pointer-events:none;position:absolute;z-index:1}.cq-650 .endslate-view-item{height:163px;width:290px}.cq-650 .endslate-view__replay-button{margin-top:40px}.cq-1000 .endslate-view-item{height:170px;width:302px}.cq-1000 .endslate-view__items{grid-template-columns:repeat(3,1fr);grid-template-rows:1fr}.cq-1000 .endslate-view-item:nth-child(3){display:initial}.cq-1200 .endslate-view-item{height:207px;width:368px}.cq-1350 .endslate-view-item{height:225px;width:400px}.error-display{position:absolute;top:0;width:100%;height:100%;display:flex;justify-content:center;text-align:left}.error-display__description{position:absolute;background-color:#000c;border-radius:8px;display:flex;top:24px;padding:12px;min-width:200px;max-width:500px;min-height:80px}.cq-650 .error-display__description{min-width:400px}.error-display__icon-container{padding:0 10px 0 0}.error-display__icon{width:36px;height:36px;color:#db0a40}.error-display__text-container{flex-direction:column;display:inherit;padding:4px 0;color:#fff}.error-display__text{width:fit-content}.initial-loading-spinner{align-items:center;display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%}.initial-loading-spinner__container{width:80px;height:80px}.initial-loading-spinner [data-rbup-buffer]{height:100%;width:100%}.nerd-mode{--cosmos-text-color: #FFFFFF;--cosmos-title-color: #FFFFFF;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background:rgba(0,22,43,.8);height:100%;left:0;min-width:430px;overflow:auto;padding:40px;position:absolute;top:0}.nerd-mode__header{align-items:center;display:flex;gap:16px}.nerd-mode__header-icon{color:#fff;height:30px;width:30px}.nerd-mode__separator-line{border:1px solid #DB0A40}.nerd-mode__grid{display:grid;grid-template-columns:auto 1fr;grid-template-areas:"labels data";gap:40px}.nerd-mode__data-list,.nerd-mode__label-list{list-style:none;padding:0}.nerd-mode__data-list{grid-area:data}.nerd-mode__label-list{grid-area:labels}.nerd-mode__list-item{min-height:40px}.live-stream-countdown{display:flex;gap:12px}.live-stream-countdown__segment{align-items:center;display:flex;flex-direction:column}.live-stream-countdown__numbers{display:flex;gap:2px;margin-bottom:8px}.live-stream-countdown__number{background-color:#fff;align-items:center;border-radius:3px;display:flex;height:40px;justify-content:center;width:28px}.live-stream-info{align-items:center;display:flex;height:100%;justify-content:center;position:absolute;top:0;width:100%}.live-stream-info__background{background-color:#00162bb3;display:flex;height:100%;position:absolute;top:0;width:100%}.live-stream-info__badge{background-color:#ffffff1a;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);border-radius:6px;align-items:center;display:flex;justify-content:center;margin-bottom:24px;padding:8px 16px}.live-stream-info__badge span{position:relative;top:-2px}.live-stream-info__countdown{margin-bottom:8px}.live-stream-info__canceled{padding-bottom:24px;padding-top:24px}.live-stream-info__date{margin-bottom:12px}.live-stream-info__date--canceled{text-decoration:#FFFFFF line-through}.live-stream-info__date--trimming span{position:relative;top:-2px}.live-stream-info__description{display:none;margin-bottom:24px;width:400px}.live-stream-info__event-logo{display:none;margin-bottom:24px;max-height:154px}.live-stream-info__icon{height:20px;margin-right:8px;width:20px}.live-stream-info__info{align-items:center;display:flex;flex-direction:column;justify-content:center;left:0;padding:24px;text-align:center;width:100%;height:100%;position:relative}.live-stream-info__poster-container{position:absolute;height:100%;width:100%}.live-stream-info__poster-container img{height:100%;width:100%;object-fit:cover}.live-stream-info__custom-poster-container{position:absolute;width:100%;height:100%}.live-stream-info__custom-poster-container img{width:100%;height:100%;object-fit:cover}.live-stream-info__separator{margin:0 8px}.live-stream-info__title{margin-bottom:12px}.cq-650 .live-stream-info__description{display:block}.cq-650 .live-stream-info__event-link{left:24px;position:absolute;top:24px}.cq-650 .live-stream-info__event-logo{display:block;max-width:120px}.cq-1000 .live-stream-info__countdown{margin-bottom:24px}.cq-1000 .live-stream-info__event-logo{max-width:170px}.ad-controls{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none}.ad-controls__ui{--cosmos-button-background-hover: rgb(0 0 0 / 0%);align-items:center;background:linear-gradient(0deg,rgba(0,0,0,.491) 0%,rgba(0,0,0,.312) 36%,rgba(0,0,0,0) 85%);bottom:0;display:flex;gap:8px;left:0;padding:8px;position:absolute;width:100%}.ad-controls__buttons{align-items:center;display:flex;gap:8px;pointer-events:auto}.ad-controls__tooltip{align-items:center;display:flex}.ad-controls-time-display{align-items:center;display:flex;gap:4px;margin:0 8px;position:relative;-webkit-user-select:none;user-select:none}.multi-channel-switcher-view{background-color:#000f1ee6;position:absolute;top:0;height:100%;-webkit-user-select:none;user-select:none;width:100%}.multi-channel-switcher-view__navi{position:absolute;bottom:97px;width:100%;pointer-events:none}.multi-channel-switcher-view__navi-button{pointer-events:auto}.multi-channel-switcher-view__navi-button--left{left:-5px;position:absolute}.multi-channel-switcher-view__navi-button--left [kind=primary]{--cosmos-button-background: #FFFFFF;--cosmos-button-background-hover: #F8F8F8;--cosmos-button-border-width: 0}.multi-channel-switcher-view__navi-button--right{right:-5px;position:absolute}.multi-channel-switcher-view__navi-button--right [kind=primary]{--cosmos-button-background: #FFFFFF;--cosmos-button-background-hover: #F8F8F8;--cosmos-button-border-width: 0}.multi-channel-switcher-view__navi-icon{color:#00162b}.multi-channel-switcher-view__close-button-container{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.multi-channel-switcher-view__close-button-container div{text-align:center;margin-bottom:112px}.multi-channel-switcher-view__close-icon{width:30px;height:30px;padding-top:4px}.multi-channel-switcher-view__close-label{margin-top:16px;--cosmos-text-color: rgba(255, 255, 255, .6);display:none}.multi-channel-switcher-view__item-list-container{bottom:0;left:0;position:absolute;right:0;pointer-events:none}.multi-channel-switcher-view__item-list{position:relative;margin:32px 0}.multi-channel-switcher-view__item-list-headline{margin-left:16px;padding:4px 0}.multi-channel-switcher-view__item-list--mobile{margin:32px 0}.multi-channel-switcher-view__item-list-headline--desktop{margin-left:56px}.multi-channel-switcher-view__fade{background:linear-gradient(to right,rgba(0,15,30,.9) 75%,transparent);height:5.3125rem;left:0;position:absolute}.multi-channel-switcher-view__fade--desktop{bottom:-66px;width:56px}.multi-channel-switcher-view__fade--mobile{bottom:32px;width:16px}.multi-channel-switcher-view__item-list-items{overflow:hidden;scroll-behavior:smooth}.multi-channel-switcher-view__item-list-items--mobile{overflow:scroll}.multi-channel-switcher-view__item-list-items,.multi-channel-switcher-view__item-list-items--mobile{display:flex;column-gap:16px;pointer-events:auto}.multi-channel-switcher-view-item--active{cursor:pointer}.multi-channel-switcher-view-item--active:hover{background-color:#fff3}.multi-channel-switcher-view-item{background-color:#ffffff1a;border-radius:6px;border:none;filter:drop-shadow(0 16px 16px rgba(0,15,30,.2));padding:12px;max-width:290px;min-width:290px}.multi-channel-switcher-view-item:first-of-type{border:2px solid rgba(255,255,255,.45);margin-left:16px}.multi-channel-switcher-view-item:last-child{margin-right:16px}.multi-channel-switcher-view-item__desktop:first-of-type{margin-left:56px}.multi-channel-switcher-view-item__desktop:last-child{margin-right:56px}.multi-channel-switcher-view-item__container{display:grid;grid-template:1fr/1fr .1fr;grid-template-areas:"text icon";gap:0 16px}.multi-channel-switcher-view-item__text{grid-area:text;text-align:left;max-width:214px}.multi-channel-switcher-view-item__title{margin-bottom:12px}.multi-channel-switcher-view-item__status{display:flex;align-items:center}.multi-channel-switcher-view-item__status div{background:#DB0A40;border-radius:2px;margin-right:12px}.multi-channel-switcher-view-item__status-label{color:#00f}.multi-channel-switcher-view-item__status-icon{color:#fff;padding:2px 2px 0 0}.multi-channel-switcher-view-item__icon{grid-area:icon;display:flex;align-items:center}.multi-channel-switcher-view-item__icon div{display:inherit;align-items:inherit;justify-content:center;background:#DB0A40;width:36px;height:36px;border-radius:90px}.multi-channel-switcher-view-item__icon-play{color:#fff;width:25px;height:25px}.multi-channel-switcher-view-live-at__label{--cosmos-text-color: #E06600}.cq-540 .multi-channel-switcher-view__close-button [data-rbup-close-button]::part(base){height:60px;width:60px;max-width:60px;max-height:60px}.cq-540 .multi-channel-switcher-view__close-label{display:initial}.cq-650 .multi-channel-switcher-view__item-list-headline{padding:12px 0}.cq-650 .multi-channel-switcher-view-item{max-width:380px;min-width:380px}.cq-650 .multi-channel-switcher-view-item__text{max-width:305px}.cq-1000 .multi-channel-switcher-view__close-button-container div{margin-bottom:0}.controls__gradient{bottom:0;content:"";height:100%;left:0;pointer-events:none;position:absolute;width:100%;--gradient-color: var(--rbup-override-gradient-color, 0 22 43);background:linear-gradient(180deg,rgb(var(--gradient-color)/0%) 0%,rgb(var(--gradient-color)/.605%) 6.67%,rgb(var(--gradient-color)/2.49%) 13.33%,rgb(var(--gradient-color)/5.72%) 20%,rgb(var(--gradient-color)/10.3%) 26.67%,rgb(var(--gradient-color)/16.2%) 33.33%,rgb(var(--gradient-color)/23.2%) 40%,rgb(var(--gradient-color)/31%) 46.67%,rgb(var(--gradient-color)/39%) 53.33%,rgb(var(--gradient-color)/46.8%) 60%,rgb(var(--gradient-color)/53.8%) 66.67%,rgb(var(--gradient-color)/59.7%) 73.33%,rgb(var(--gradient-color)/64.3%) 80%,rgb(var(--gradient-color)/67.5%) 86.67%,rgb(var(--gradient-color)/69.4%) 93.33%,rgb(var(--gradient-color)/70%) 100%)}.controls__play{align-self:center;grid-column:2/3;grid-row:1/5}.controls__video-details{pointer-events:none;grid-area:details;width:100%;display:none}.controls__scrub-bar{grid-area:scrub-bar}.controls__buttons{display:flex;grid-area:buttons;justify-content:space-between;margin:0 8px}.controls-container--fullscreen{cursor:none}.controls-container{display:grid;grid-template:1fr auto auto 36px/1fr 1fr 1fr;grid-template-areas:"top top top" "details details details" "scrub-bar scrub-bar scrub-bar" "buttons buttons buttons";height:100%;padding:8px;outline:none;-webkit-user-select:none;user-select:none}.controls-container--fade-in{cursor:default}.controls-container--fade-in .controls__play,.controls-container--fade-in .controls__video-details,.controls-container--fade-in .controls__scrub-bar,.controls-container--fade-in .controls__buttons{animation:var(--g-controls-animation-fade-in)}.controls-container--fade-in .controls__gradient{animation:g-gradient-fade-in var(--transition-timing) forwards}.controls-container--fade-out .controls__play,.controls-container--fade-out .controls__video-details,.controls-container--fade-out .controls__scrub-bar,.controls-container--fade-out .controls__buttons{animation:var(--g-controls-animation-fade-out)}.controls-container--fade-out .controls__gradient{animation:g-gradient-fade-out var(--transition-timing) forwards}.controls-container--hide .controls__play,.controls-container--hide .controls__scrub-bar,.controls-container--hide .controls__buttons{opacity:0;pointer-events:none}.controls-container--hide .controls__gradient{opacity:0}.cosmos-tooltip{display:contents}.cq-650 .controls__buttons{margin:0 24px}.cq-650 .controls__gradient{height:60%}.cq-650 .controls__video-details{display:block}.cq-1350 .controls__gradient{height:50%}@keyframes g-gradient-fade-in{0%{opacity:0}to{opacity:1}}@keyframes g-gradient-fade-out{0%{opacity:1}to{opacity:0}}.click-and-tap-overlay-container{display:grid;grid-column:1/4;grid-row:1/5;grid-template:1fr/1fr 1fr}.click-and-tap-overlay-container.grab{cursor:move;cursor:grab}.click-and-tap-overlay-container.grabbing{cursor:move;cursor:grabbing}.fast-forward-backward-container{height:100%;display:flex;align-items:center;justify-content:center}.fast-forward-backward-container__fast-backward-container,.fast-forward-backward-container__fast-forward-container{opacity:0;display:flex;justify-content:center;align-items:center;-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);border-radius:70px;height:70px;width:70px}.fast-forward-backward-container__fast-backward-container--show-animation,.fast-forward-backward-container__fast-forward-container--show-animation{opacity:1}.fast-backward-animation__arrow{width:20px;height:20px;background:#fff;margin:0 2px;clip-path:polygon(100% 0,100% 100%,0 50%);opacity:.5;animation:fade-in-out 1s ease-in-out infinite}.fast-forward-animation__arrow{width:20px;height:20px;background:#fff;margin:0 2px;clip-path:polygon(100% 50%,0% 100%,0 0);opacity:.5;animation:fade-in-out 1s ease-in-out infinite}.animation__arrow--outer{animation-delay:.2s}.left-side-controls{align-items:center;display:flex;flex-basis:33%;flex-shrink:1;justify-content:left}.left-side-controls__selective-elements{display:flex}.left-side-controls__tooltip-wrapper{display:flex;align-items:center}.left-side-controls__icon{color:#fff}.center-controls{display:flex;align-items:center;flex-basis:33%;flex-shrink:1;justify-content:center}.play-seek-controls{display:flex;justify-content:center;position:relative}.play-seek-controls.play-seek-controls__bottom,.play-seek-controls.play-seek-controls__vr-content{display:none}.play-seek-controls.play-seek-controls__bottom.play-seek-controls__vr-content{display:flex}.play-seek-controls__play-seek-pause-container{align-items:center;display:flex;gap:12px}.play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:44px;max-width:44px;min-width:44px;width:44px}.play-seek-controls__play-seek-pause-container [data-rbup-seek-back] .play-seek-controls__icon,.play-seek-controls__play-seek-pause-container [data-rbup-seek-forward] .play-seek-controls__icon{height:25px;width:25px}.play-seek-controls__play-seek-pause-container [disabled] .play-seek-controls__icon{color:#ffffff73}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:52px;max-width:52px;min-width:52px;width:52px}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back] .play-seek-controls__icon,.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward] .play-seek-controls__icon{height:29.5px;width:29.5px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:60px;max-width:60px;min-width:60px;width:60px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-back] .play-seek-controls__icon,.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward] .play-seek-controls__icon{height:34px;width:34px}.cq-1000 .play-seek-controls{display:none}.cq-1000 .play-seek-controls.play-seek-controls__bottom{display:flex;position:relative}.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:36px;max-width:36px;min-width:36px;width:36px}.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-seek-back]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-seek-forward]::part(base){height:36px;max-width:36px;min-width:36px;width:36px}.play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:44px;max-width:44px;min-width:44px;width:44px}.play-seek-controls__play-seek-pause-container [data-rbup-pause] .play-seek-controls__icon,.play-seek-controls__play-seek-pause-container [data-rbup-stop] .play-seek-controls__icon,.play-seek-controls__play-seek-pause-container [data-rbup-play] .play-seek-controls__icon{height:25px;width:25px}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.cq-540 .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:66px;max-width:66px;min-width:66px;width:66px}.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-pause] .play-seek-controls__icon,.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-stop] .play-seek-controls__icon,.cq-540 .play-seek-controls__play-seek-pause-container [data-rbup-play] .play-seek-controls__icon{height:37.5px;width:37.5px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.cq-650 .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:88px;max-width:88px;min-width:88px;width:88px}.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-pause] .play-seek-controls__icon,.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-stop] .play-seek-controls__icon,.cq-650 .play-seek-controls__play-seek-pause-container [data-rbup-play] .play-seek-controls__icon{height:50px;width:50px}.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:36px;max-width:36px;min-width:36px;width:36px}.cq-1000 .play-seek-controls.play-seek-controls__bottom .play-seek-controls__play-seek-pause-container .play-seek-controls__icon{height:18px;width:18px}.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-pause]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-stop]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container [data-rbup-play]::part(base),.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container .play-seek-controls__spinner{height:36px;max-width:36px;min-width:36px;width:36px}.themed-player-root .play-seek-controls.play-seek-controls__vr-content .play-seek-controls__play-seek-pause-container .play-seek-controls__icon{height:18px;width:18px}.right-side-controls{align-items:center;display:flex;gap:0;flex-basis:33%;flex-shrink:1;justify-content:right}.right-side-controls__audio-button,.right-side-controls__subtitles-button{display:none}.cq-540 .right-side-controls{gap:8px}.cq-650 .right-side-controls__audio-button,.cq-650 .right-side-controls__subtitles-button{display:contents}.right-side-controls__tooltip-wrapper{display:flex;gap:8px;position:relative}.video-details{padding:8px 24px;position:relative;text-align:left;--cosmos-text-line-height: var(--rbup-text-line-height);--cosmos-text-font-family: var(--rbup-component-font-family, $default-font-family)}.video-details__title{-webkit-user-select:text;user-select:text}.video-details__description{-webkit-user-select:text;user-select:text;margin-top:8px}.overlay{height:100%;left:0;position:absolute;top:0;width:100%}.disabled{pointer-events:none}.live-button,.live-button-live{display:flex;position:relative;--cosmos-button-font-size: .7rem}.live-button .cosmos-button--kind-bare,.live-button-live .cosmos-button--kind-bare{background-color:initial}[data-rbup-live]{--cosmos-button-color: #fff;--cosmos-button-background: rgb(0 0 0 / 0%);--cosmos-button-background-hover: rgb(0 0 0 / 0%)}[data-rbup-live] .live-button__icon{color:var(--rbup-primary-color)}[data-rbup-dvr]{pointer-events:auto}[data-rbup-dvr] .live-button__icon{color:#fff}.multi-channel-button{--cosmos-button-font-size: .7rem;align-items:center;display:flex;position:relative;margin-left:8px}.ad-markers{bottom:0;height:2px;width:100%;left:0;margin:12px 0;position:absolute;pointer-events:none;transition:transform .3s cubic-bezier(0,.32,.32,1);-webkit-user-select:none;user-select:none}.ad-markers__background-container{background-color:#fc0;height:100%;width:100%;position:absolute;transition:clip-path .3s cubic-bezier(0,.32,.32,1)}.buffer-bar{background-color:#fff;bottom:0;height:2px;left:0;margin:12px 0;position:absolute;pointer-events:none;transition:transform .3s cubic-bezier(0,.32,.32,1);-webkit-user-select:none;user-select:none}.progress-bar{background-color:var(--rbup-primary-color);bottom:0;height:2px;left:0;margin:12px 0;position:absolute;pointer-events:none;transition:transform .3s cubic-bezier(0,.32,.32,1);-webkit-user-select:none;user-select:none}.seek-bar{display:inline-block;height:100%;position:relative;width:100%}.seek-bar__cosmos-tooltip::part(base){max-width:initial;padding:0}.seek-bar-handle{bottom:21px;position:absolute;pointer-events:none}.seek-bar-handle__knob{background:#FFFFFF;border-radius:9999px;box-shadow:0 2px 8px #000f1e;color:#fff;height:16px;position:absolute;pointer-events:none;right:-8px;width:16px}.seek-bar-tooltip{align-items:center;display:flex;flex-direction:column;opacity:0;transition:opacity .3s cubic-bezier(0,.32,.32,1)}.seek-bar-tooltip--visible{opacity:1}.seek-bar-tooltip__image-container{border-radius:6px 6px 0 0;overflow:hidden}.seek-bar-tooltip__image{position:relative}.seek-bar-tooltip__text{align-items:center;display:flex;flex-direction:column;gap:4px;padding:8px;text-align:center}.seek-bar-tooltip--with-thumbnail .seek-bar-tooltip__text{margin-top:4px;padding:0 4px 4px}.seek-bar-tooltip--with-segments .seek-bar-tooltip__position{display:none}.cq-540 .seek-bar-tooltip{padding:4px}.cq-540 .seek-bar-tooltip__image-container{border-radius:6px}.cq-540 .seek-bar-tooltip--with-segments .seek-bar-tooltip__position{display:block}.scrub-bar__rail{background-color:#fff6;bottom:0;left:0;height:2px;margin:12px 0;position:absolute;pointer-events:none;transition:transform .3s cubic-bezier(0,.32,.32,1);-webkit-user-select:none;user-select:none;width:100%}.scrub-bar{cursor:pointer;position:relative;height:20px;margin:0 8px}.scrub-bar .scrub-bar__background-container{height:100%;width:100%;position:absolute;transition:clip-path .3s cubic-bezier(0,.32,.32,1)}.scrub-bar[data-hovered] .buffer-bar,.scrub-bar[data-hovered] .progress-bar,.scrub-bar[data-hovered] .scrub-bar__rail,.scrub-bar[data-hovered] .ad-markers{transform-origin:center center;transform:scaleY(3)}.scrub-bar[data-hovered=false]{height:20px}.cq-650 .scrub-bar{margin:0 24px}.controls-time-display{align-items:center;display:flex;flex-shrink:0;margin-left:8px;position:relative;pointer-events:none}.controls-time-display__duration{display:none}.controls-time-display__separator{padding:0 4px}.cq-650 .controls-time-display__duration{display:flex}.controls-volume-slider{height:inherit;margin-left:12px;margin-top:1px;position:relative}.controls-volume-slider__slider{cursor:pointer;display:flex;height:36px;margin:0;overflow:hidden;position:relative;transition:width .3s cubic-bezier(0,.32,.32,1);width:0}.controls-volume-slider__slider--visible{width:38px}.controls-volume-slider__indicator-element{pointer-events:none;margin:14px 2px 0 0}.volume-controls{align-items:center;display:flex;position:relative}.volume-indicator-element{width:2px;height:8px;background:rgba(255,255,255,.6)}.volume-indicator-element--active{background-color:var(--rbup-primary-color)}.volume-indicator-element--highlighted{background-color:#fff;height:14px;margin:-3px 0}.product-placement{left:23px;position:absolute;top:23px;color:#fff}.cq-1000 .product-placement{left:48px;top:48px}.product-placement--fade-in{opacity:1;transition:opacity .5s .5s}.product-placement--fade-out{opacity:0;transition:opacity .5s}.audio-menu{background-color:#fff;border-radius:8px;bottom:0;box-shadow:0 8px 12px #000f1e0a,0 2px 4px #000f1e05;max-height:250px;min-width:180px;overflow-y:auto;padding:16px;position:absolute;right:0;transform:translate(-12px,-3rem);z-index:2;pointer-events:auto}.audio-menu__title{margin-bottom:12px}.audio-settings{overflow-x:hidden;overflow-y:auto}.cq-650 .audio-settings{overflow:visible}.audio-settings__list{display:block;list-style:none;margin:0;padding:5px 5px 9px}.audio-settings__list-item{--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.audio-settings__list-item:last-child{margin-bottom:0}.audio-settings__list-item>*{display:inline-block}.audio-settings__list-item label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.audio-settings__list-item label input:checked:before{background-color:#fff}.cq-650 .audio-settings__list-item{--cosmos-button-color: #000F1E;--cosmos-text-color: #000F1E}.cq-650 .audio-settings__list-item label input{background-color:#fff;border:1px solid #00162B}.cq-650 .audio-settings__list-item label input:checked:before{background-color:#000f1e}.back-button{--cosmos-text-color: #FFFFFF;align-items:center;background-color:transparent;border:none;cursor:pointer;display:flex;padding:0;margin-bottom:12px;position:relative}.back-button:focus-visible{outline:0}.back-button:focus-visible:before{border:2px solid #1B6AEE;border-radius:8px;content:"";height:100%;top:-2px;bottom:-2px;left:-2px;right:-2px;position:absolute;width:100%}.back-button .back-button__icon{height:24px;width:24px;color:#fff;transform:translate(-2px);transition:.25s ease-in-out}.back-button:hover .back-button__icon{transform:translate(-8px);color:var(--rbup-primary-color);transition:.25s ease-in-out}.cq-650 .back-button{--cosmos-text-color: #000F1E}.cq-650 .back-button .back-button__icon{color:#000f1e}.settings-menu-button__label{text-align:start}.settings-menu-button{--cosmos-text-color: #FFFFFF;align-items:center;background-color:transparent;border:none;cursor:pointer;display:flex;justify-content:space-between;width:100%;padding:1px 6px;position:relative}.settings-menu-button:focus-visible{outline:0}.settings-menu-button:focus-visible:before{border:2px solid #1B6AEE;border-radius:8px;content:"";height:100%;top:-2px;bottom:-2px;left:-2px;right:-2px;position:absolute;width:100%}.settings-menu-button:not(:last-child){margin-bottom:16px}.settings-menu-button[href]::part(base):not(:focus):hover{border-color:transparent}.settings-menu-button .settings-menu-button__label{color:#fff;font-size:14px;position:relative}.settings-menu-button .settings-menu-button__label:before{border:0;border-bottom:solid 2px var(--rbup-primary-color);border-radius:0;bottom:-3px;content:"";left:0;position:absolute;pointer-events:none;transition:.25s ease-in-out;width:0}.settings-menu-button:hover .settings-menu-button__label:before{width:100%;transition:.25s ease-in-out}.settings-menu-button__icon{height:24px;margin-left:4px;width:24px;color:#fff;transition:.25s ease-in-out}.settings-menu-button__icon:hover .settings-menu-button__icon{transform:translate(8px);color:var(--rbup-primary-color);transition:.25s ease-in-out}.settings-menu-button__selected-setting{--cosmos-text-color: rgba(255, 255, 255, .6);align-items:center;display:flex;text-transform:capitalize}.cq-650 .settings-menu-button{--cosmos-text-color: #000F1E}.cq-650 .settings-menu-button .settings-menu-button__icon{color:#000f1e99}.cq-650 .settings-menu-button .settings-menu-button__label{color:#000f1e}.cq-650 .settings-menu-button__selected-setting{--cosmos-text-color: rgba(0, 15, 30, .6)}.quality-settings{overflow-x:hidden;overflow-y:auto}.cq-650 .quality-settings{overflow:visible}.quality-settings__list{display:block;list-style:none;margin:0;padding:5px 5px 9px}.cq-650 .quality-settings__list{padding:0}.quality-settings__list-item{--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.quality-settings__list-item:last-child{margin-bottom:0}.quality-settings__list-item>*{display:inline-block}.quality-settings__list-item label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.quality-settings__list-item label input:checked:before{background-color:#fff}.cq-650 .quality-settings__list-item{--cosmos-button-color: #000F1E;--cosmos-text-color: #000F1E}.cq-650 .quality-settings__list-item label input{background-color:#fff;border:1px solid #00162B}.cq-650 .quality-settings__list-item label input:checked:before{background-color:#000f1e}.cq-650 [data-rbup-menu-button=audio],.cq-650 [data-rbup-menu-button=subtitles]{display:none}.settings-menu{display:grid;grid-template-areas:"close-btn invisible menu ";grid-template-columns:minmax(42px,78px) 1px minmax(240px,320px);bottom:0;position:absolute;height:0;right:0;z-index:2;-webkit-user-select:text;user-select:text;pointer-events:auto}.settings-menu-animation{transition:height .3s cubic-bezier(0,.32,.32,1),width .3s cubic-bezier(0,.32,.32,1)}.settings-menu__invisible-title{grid-area:invisible}.settings-menu__close-button{grid-area:close-btn;--cosmos-button-border-color: rgba(255, 255, 255, .2);--cosmos-button-border-color-hover: rgba(255, 255, 255, .45);--cosmos-button-background: rgba(0, 15, 30, .45);--cosmos-button-color: #FFFFFF;--cosmos-button-color-hover: #FFFFFF;align-self:center;justify-self:center}.settings-menu__settings-area{grid-area:menu;overflow:hidden;display:flex;width:100%;height:100%;background-color:#000f1ee6}.settings-menu__settings-container{position:relative;height:100%}.cq-650 .settings-menu{height:auto;display:block;overflow:hidden;border-radius:8px;transform:translate(-12px,-3rem);box-shadow:0 8px 12px #000f1e0a,0 2px 4px #000f1e05}.cq-650 .settings-menu .settings-menu__settings-area{background-color:#fff}.settings-menu__settings-page--positioned,.settings-menu__settings-page{transition:transform .3s cubic-bezier(0,.32,.32,1);display:flex;flex-direction:column;width:100%;height:100%}.settings-menu__settings-page{overflow-x:hidden;overflow-y:auto}.settings-menu__settings-page--positioned{position:absolute}.settings-menu__settings-wrapper{max-height:100%}.settings-menu__settings-wrapper>div{padding:16px;display:flex;flex-direction:column;align-items:stretch;height:100%}.cq-650 .settings-menu__settings-wrapper{max-height:initial}.cq-650 .settings-menu__settings-wrapper>div{height:auto}.share-settings{overflow-x:hidden;overflow-y:auto}.cq-650 .share-settings{overflow:visible}.share-settings__copied-text{animation:3s copied-text ease-in-out;margin-left:12px;transform:scale(0)}.cq-650 .share-settings__copied-text{--cosmos-text-color: #000F1E}.share-settings__link,.share-settings__iframe-code{--cosmos-button-color: #FFFFFF;--data-rbup-icon-size: 14px}.share-settings__link-icon,.share-settings__iframe-code-icon{--data-rbup-icon-size: 14px;color:#fff;margin:0}.share-settings__link::part(base),.share-settings__iframe-code::part(base){align-items:center;border:0;display:flex;gap:8px;margin:0;position:relative}.share-settings__link::part(base):focus,.share-settings__iframe-code::part(base):focus{margin:0;padding:0}.share-settings__link::part(base):before,.share-settings__iframe-code::part(base):before{border:0;border-bottom:solid 2px var(--rbup-primary-color);border-radius:0;bottom:-6px;content:"";left:0;position:absolute;pointer-events:none;transition:.25s ease-in-out;width:0}.share-settings__link::part(base):focus:before,.share-settings__link::part(base):hover:before,.share-settings__iframe-code::part(base):focus:before,.share-settings__iframe-code::part(base):hover:before{width:100%;transition:.25s ease-in-out}.cq-650 .share-settings__link,.cq-650 .share-settings__iframe-code{--cosmos-button-color: #000F1E}.cq-650 .share-settings__link-icon,.cq-650 .share-settings__iframe-code-icon{color:#00162b}.share-settings__list{display:block;list-style:none;margin:0;padding:5px 5px 9px}.share-settings__list-item{margin-bottom:12px;--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.share-settings__list-item:last-child{margin-bottom:0}.share-settings__list-item>*{display:inline-block}.share-settings__list-item label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.share-settings__list-item label input:checked:before{background-color:#fff}.cq-650 .share-settings__list-item{--cosmos-button-color: #000F1E;--cosmos-text-color: #000F1E}.cq-650 .share-settings__list-item label input{background-color:#fff;border:1px solid #00162B}.cq-650 .share-settings__list-item label input:checked:before{background-color:#000f1e}.share-settings__copy-button,.share-settings__copy-iframe-code-button{margin-bottom:12px;display:flex;--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF;--cosmos-button-color-hover: #FFFFFF}.share-settings__copy-button:last-child,.share-settings__copy-iframe-code-button:last-child{margin-bottom:0}.share-settings__copy-button>*,.share-settings__copy-iframe-code-button>*{display:inline-block}.share-settings__copy-button label input,.share-settings__copy-iframe-code-button label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.share-settings__copy-button label input:checked:before,.share-settings__copy-iframe-code-button label input:checked:before{background-color:#fff}.cq-650 .share-settings__copy-button,.cq-650 .share-settings__copy-iframe-code-button{--cosmos-button-color-hover: #000F1E}.share-settings__share-time{--cosmos-text-color: #FFFFFF;align-items:center;border-bottom:1px solid #F8F8F8;display:flex;flex-direction:row;justify-content:space-between;margin-bottom:12px;padding-left:5px;padding-right:5px;padding-bottom:12px}.share-settings__share-time input{border-color:#fff;background-color:unset}.share-settings__share-time [data-rbup-share-time-checkbox]{--cosmos-checkbox-font-size: 14px}.cq-650 .share-settings__share-time{--cosmos-text-color: #000F1E;border-bottom:1px solid #00162B}.cq-650 .share-settings__share-time label input{border-color:#00162b;background-color:#fff}.share-settings__time-input{border:0;border-bottom:2px solid #00162B;border-radius:0;color:#fff;font-family:var(--rbup-font-family);font-size:14px;height:26px;text-align:center;width:56px}.share-settings__time-input:focus{border-color:var(--rbup-primary-color);outline:0}.share-settings__time-input:disabled{background-color:transparent;border-bottom:2px solid rgba(255,255,255,.1);color:#ffffff73}.cq-650 .share-settings__time-input{border-bottom:2px solid #00162B;color:#000f1e}.cq-650 .share-settings__time-input:disabled{border-bottom:2px solid #F8F8F8;color:#000f1e99}@keyframes copied-text{0%{transform:scale(0)}10%{transform:scale(1)}90%{transform:scale(1)}to{transform:scale(0)}}.speed-settings{overflow-x:hidden;overflow-y:auto}.cq-650 .speed-settings{overflow:visible}.speed-settings__list{display:block;list-style:none;margin:0;padding:5px 5px 9px}.speed-settings__list-item{--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.speed-settings__list-item:last-child{margin-bottom:0}.speed-settings__list-item>*{display:inline-block}.speed-settings__list-item label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.speed-settings__list-item label input:checked:before{background-color:#fff}.cq-650 .speed-settings__list-item{--cosmos-button-color: #000F1E;--cosmos-text-color: #000F1E}.cq-650 .speed-settings__list-item label input{background-color:#fff;border:1px solid #00162B}.cq-650 .speed-settings__list-item label input:checked:before{background-color:#000f1e}.subtitles-menu{background-color:#fff;border-radius:8px;bottom:0;box-shadow:0 8px 12px #000f1e0a,0 2px 4px #000f1e05;max-height:250px;min-width:180px;overflow-y:auto;padding:16px;position:absolute;right:0;transform:translate(-12px,-3rem);z-index:2}.subtitles-menu__title{margin-bottom:12px}.subtitles-settings{overflow-x:hidden;overflow-y:auto}.cq-650 .subtitles-settings{overflow:visible}.subtitles-settings__list{display:block;list-style:none;margin:0;padding:5px 5px 9px}.subtitles-settings__list-item{--cosmos-radio-font-size: 14px;--cosmos-radio-line-height: 1.357143;--cosmos-button-color: #FFFFFF;--cosmos-text-color: #FFFFFF}.subtitles-settings__list-item:last-child{margin-bottom:0}.subtitles-settings__list-item>*{display:inline-block}.subtitles-settings__list-item label input{background-color:#000f1ee6;border:2px solid rgba(255,255,255,.45)}.subtitles-settings__list-item label input:checked:before{background-color:#fff}.cq-650 .subtitles-settings__list-item{--cosmos-button-color: #000F1E;--cosmos-text-color: #000F1E}.cq-650 .subtitles-settings__list-item label input{background-color:#fff;border:1px solid #00162B}.cq-650 .subtitles-settings__list-item label input:checked:before{background-color:#000f1e}.start-and-end-view{position:absolute;top:0;width:100%;height:100%}.start-and-end-view__buttons{align-items:center;cursor:pointer;display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%}.start-and-end-view__bg-image-container{height:100%;width:100%}.start-and-end-view__bg-image-container img{height:100%;width:100%;object-fit:cover}.start-and-end-view__bg-custom-image-container{width:100%;height:100%}.start-and-end-view__bg-custom-image-container img{width:100%;height:100%;object-fit:cover}.start-and-end-view__button{--cosmos-button-background: var(--rbup-play-button-background-color);--cosmos-button-background-hover: var(--rbup-play-button-background-hover-color)}.start-and-end-view__button::part(base){height:80px;max-width:80px;min-width:80px;width:80px}.start-and-end-view__icon{height:50px;width:50px}.subtitles-overlay{position:absolute;left:16px;right:16px;bottom:16px;text-align:center;pointer-events:none}.subtitles-overlay.subtitles-on-top{top:0}.subtitles-overlay__text-container{display:flex;flex-direction:column;align-items:center}.subtitles-overlay__text-display{color:#fff;background-color:#000f1e73;padding:.1666em .5em .3333em;margin-top:.3em}.themed-player-root{overflow:hidden;position:relative;min-width:300px;max-width:var(--max-width);margin:auto;--rbup-container16x9-background-color: #000;--rbup-font-family: Bull Text, Helvetica, sans-serif;--rbup-primary-color: #DB0A40;--cosmos-button-font-family: var(--rbup-font-family);--cosmos-font-family-text: var(--rbup-font-family);--cosmos-text-font-family: var(--rbup-font-family);--cosmos-tooltip-font-family: var(--rbup-font-family);--cosmos-tooltip-z-index: 1;font-family:var(--rbup-font-family);outline:none}.themed-player-root.vr-content{min-width:370px;z-index:9999}.rbup-default-theme__toasts{display:flex;gap:16px;left:12px;position:absolute;top:12px;transition:bottom .3s}.rbup-default-theme__centered-toasts{position:absolute;top:10px;left:10px}.rbup-default-theme__centered-toasts--controls-visible{animation:var(--g-controls-animation-fade-in)}.rbup-default-theme__centered-toasts--controls-hide{animation:var(--g-controls-animation-fade-out)}.rbup-default-theme__toasts--product-placement-visible{top:20px;left:64px}.rbup-default-theme--vr-fullscreen{position:fixed;top:0;left:0;right:0;bottom:0;z-index:9999}.cq-650 .rbup-default-theme__toasts{bottom:32px;left:auto;right:32px;top:auto}.cq-650 .rbup-default-theme__toasts--controls-visible{bottom:70px}@keyframes fade-in-out{0%,40%,to{opacity:1}20%,60%{opacity:.5}}
`;
function getToastCSSClass(re, te) {
  return [
    "rbup-default-theme__toasts",
    te === "visible" && "rbup-default-theme__toasts--product-placement-visible",
    re === "fade-in" && "rbup-default-theme__toasts--controls-visible"
  ].filter(Boolean).join(" ");
}
function getCenteredToastCSSClass(re) {
  return [
    "rbup-default-theme__centered-toasts",
    re === "fade-in" ? "rbup-default-theme__centered-toasts--controls-visible" : "rbup-default-theme__centered-toasts--controls-hide"
  ].filter(Boolean).join(" ");
}
function getPlayerDisplayState(re, te, ee) {
  return (re === "IDLE" || re === "BUFFERING") && te < 1 ? "initial" : ee ? "advertisement" : "playback";
}
const DefaultThemeComponent = ({
  config: re,
  customPosterImage: te,
  sizeBreakpoints: ee,
  playerWidth: ie,
  playerCoordinator: ne,
  globalKeyboardNavigation: ae,
  onPlayNewAsset: ue,
  CustomOverlayComponent: _e,
  allowControlsCaptureAreaInteraction: fe,
  CustomToastComponent: le,
  aspectRatio: se,
  CenteredToastComponent: oe
}) => {
  var Pe, Te, Ee, Me;
  const {
    playerState: { isShowingAd: ce, playerStatus: he, playbackPosInSec: ge }
  } = usePlayerContext(), ve = useControlsVisibilityContext().controlsVisibility, [me, be] = h$2(areTranslationsLoaded());
  onTranslationDataLoaded(() => be(!0));
  const pe = !!((Pe = re.relatedVideos) != null && Pe.items), $e = ((Te = ne.getPlayerData()) == null ? void 0 : Te.getInitialSeekTimeInSec()) ?? 0, ye = Math.abs(ge - $e), Se = getPlayerDisplayState(he, ye, ce), we = useIosVrFullscreen() ? "rbup-default-theme--vr-fullscreen" : "";
  return /* @__PURE__ */ Cn.createElement(CosmosMode, { mode: "light", class: we }, Se === "initial" && /* @__PURE__ */ Cn.createElement(InitialLoadingSpinner, null), Se === "playback" && /* @__PURE__ */ Cn.createElement(
    MainMediaPlaybackComponent,
    {
      allowControlsCaptureAreaInteraction: fe,
      config: re,
      controlsVisibility: ve,
      CustomOverlayComponent: _e,
      CustomToastComponent: le,
      globalKeyboardNavigation: ae,
      onPlayNewAsset: ue,
      playerCoordinator: ne,
      playerStatus: he,
      sizeBreakpoints: ee,
      playerWidth: ie,
      CenteredToastComponent: oe
    }
  ), Se !== "advertisement" && /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, ne.isPhasingEnabled() && /* @__PURE__ */ Cn.createElement(
    LiveStreamInfo,
    {
      playerWidth: ie,
      aspectRatio: se,
      customPosterImage: te
    }
  ), /* @__PURE__ */ Cn.createElement(
    StartAndEndView,
    {
      customPosterImage: te,
      aspectRatio: se,
      showAtEnd: !pe,
      playerWidth: ie
    }
  ), pe && /* @__PURE__ */ Cn.createElement(
    EndslateView,
    {
      relatedVideos: (Ee = re.relatedVideos) == null ? void 0 : Ee.items,
      config: (Me = re.relatedVideos) == null ? void 0 : Me.config
    }
  )), Se === "advertisement" && /* @__PURE__ */ Cn.createElement(AdControls, null), /* @__PURE__ */ Cn.createElement(SubtitlesOverlay, null));
}, RbupVideoCoreDefaultTheme = k((re, te) => /* @__PURE__ */ Cn.createElement(ThemedPlayer, { ref: te, styles, ThemeComponent: DefaultThemeComponent, ...re }));
function getShowMultiChannelSwitcherClickedCallback(re, te, ee) {
  return re && ee && ee.length > 0 ? te : void 0;
}
const MainMediaPlaybackComponent = ({
  allowControlsCaptureAreaInteraction: re,
  config: te,
  controlsVisibility: ee,
  CustomOverlayComponent: ie,
  CustomToastComponent: ne,
  globalKeyboardNavigation: ae,
  onPlayNewAsset: ue,
  playerCoordinator: _e,
  sizeBreakpoints: fe,
  CenteredToastComponent: le
}) => {
  var Pe, Te;
  const {
    playerState: { mediaMetaData: se, liveStatus: oe }
  } = usePlayerContext(), ce = oe == null ? void 0 : oe.otherLiveVideos, he = se == null ? void 0 : se.externalReferenceMarkers, ge = getToastCSSClass(ee, te.productPlacement), ve = getCenteredToastCSSClass(ee), me = _e.shouldShowProductPlacement(), [be, pe] = h$2(!1), $e = T$1((Ee = !0) => {
    pe(Ee);
  }, []), ye = te.ctaToastComponent, Se = te.multiChannelSwitcher === "visible", we = getShowMultiChannelSwitcherClickedCallback(
    Se,
    $e,
    ce
  );
  return /* @__PURE__ */ Cn.createElement(Cn.Fragment, null, te.cornerbug !== "hidden" && /* @__PURE__ */ Cn.createElement(
    RbupVideoCornerbug,
    {
      iconComponent: ((Pe = te.cornerbugIconComponent) == null ? void 0 : Pe.call(te, {})) ?? /* @__PURE__ */ Cn.createElement(RbupVideoDefaultCornerbugIcon, null)
    }
  ), me && /* @__PURE__ */ Cn.createElement(RbupVideoProductPlacement, { productPlacementDefinition: te.productPlacementComponentDefinition }), ie && /* @__PURE__ */ Cn.createElement(ie, { playerCoordinator: _e }), /* @__PURE__ */ Cn.createElement(
    RbupVideoCoreOverlay,
    {
      sizeBreakpoints: fe,
      playerCoordinator: _e,
      onShowMultiChannelSwitcher: we,
      allowControlsCaptureAreaInteraction: re,
      globalKeyboardNavigation: ae,
      CenteredToastComponent: le
    }
  ), /* @__PURE__ */ Cn.createElement("div", { "data-rbup-centered-toast-container": !0, class: ve }, /* @__PURE__ */ Cn.createElement(
    CenteredToastWrapper,
    {
      sizeBreakpoints: fe,
      displayTimeInSec: (Te = te.productPlacementComponentDefinition) == null ? void 0 : Te.displayTimeInSec,
      CenteredToastComponent: le
    }
  )), /* @__PURE__ */ Cn.createElement("div", { "data-rbup-toast-container": !0, class: ge }, ne && /* @__PURE__ */ Cn.createElement(ne, { playerCoordinator: _e, sizeBreakpoints: fe }), he && ye && /* @__PURE__ */ Cn.createElement(ye, { externalReferenceMarkers: he })), be && /* @__PURE__ */ Cn.createElement(
    MultiChannelSwitcherView,
    {
      onCloseView: () => $e(!1),
      onPlayNewAsset: ue
    }
  ));
};
function isTrueValue(re) {
  return typeof re == "boolean" ? re : typeof re == "string" ? re === "true" : !1;
}
if (typeof window > "u")
  throw new Error("SSR is not supported");
async function fetchSsdmMediaPartnershipsMetadata(re, te, ee, ie) {
  const ne = {
    videoId: re
  }, ae = calculateSsdmUrl(te, ee), ue = await fetch(`${ae}/media-partnerships?${new URLSearchParams(ne)}`, {
    headers: calculateCachingHeaders(ie)
  });
  if (ue.ok)
    return await ue.json();
  throw new Error(`server returned ${ue.status}`);
}
class MediaPartnershipsDataLoader {
  constructor(te) {
    this.prNumber = te;
  }
  async loadData(te, ee) {
    const {
      title: ie,
      description: ne,
      poster: ae,
      thumbnailSprites: ue,
      videoUrl: _e,
      videoMediaType: fe,
      vin: le,
      duration: se,
      userCountry: oe = null,
      label: ce,
      labelGroup: he,
      season: ge,
      chapter: ve,
      aspectRatio: me
    } = await fetchSsdmMediaPartnershipsMetadata(te.assetId, te.environment, this.prNumber, ee);
    return {
      title: ie,
      description: ne,
      posterImageUrl: ae,
      thumbnailSprites: ue,
      mediaSrc: {
        videoUrl: _e,
        mediaType: fe
      },
      vin: le,
      duration: se,
      userCountry: oe,
      label: ce,
      labelGroup: he,
      season: ge,
      chapter: ve,
      aspectRatio: me
    };
  }
}
const RbupVideoMediaPartnerships = ({
  _debug: re,
  autoplay: te,
  cornerbug: ee,
  globalKeyboardNavigation: ie,
  muted: ne,
  poster: ae,
  "poster-image": ue,
  internalOnApiAvailable: _e,
  assetId: fe,
  id: le,
  skipCosmosFontInjection: se,
  aspectRatio: oe,
  prNumber: ce
}) => {
  const he = F$1(() => new MediaPartnershipsDataLoader(ce), [ce]), ge = F$1(
    () => ({
      _debug: re,
      assetId: fe,
      autoplay: isTrueValue(te),
      cornerbug: ee,
      muted: ne,
      posterImageUrl: ae,
      videoDetails: "visible",
      initialSeekTimeInSec: 0,
      tracking: {
        configs: {
          googleAnalytics: {
            playerId: "RBUP_COM",
            accountName: "RBCOM"
          }
        }
      },
      skipCosmosFontInjection: isTrueValue(se),
      mediaSessionArtist: "Red Bull"
    }),
    [re, te, ee, ne, ae, fe, se]
  );
  return /* @__PURE__ */ Cn.createElement(
    RbupVideoCoreDefaultTheme,
    {
      id: le,
      config: ge,
      customPosterImage: ue,
      dataLoader: he,
      internalOnApiAvailable: _e,
      aspectRatio: oe,
      globalKeyboardNavigation: ie
    }
  );
};
function initRbupVideoMediaPartnerships(re, te) {
  return initRbupVideo(
    re,
    "rbup-video-partnerships",
    te
  );
}
const mediaPartnershipsObservedAttributes = [
  "aspect-ratio",
  "asset-id",
  "autoplay",
  "cornerbug",
  "global-keyboard-navigation",
  "internal-on-api-available",
  "muted",
  "poster",
  "skip-cosmos-font-injection"
];
register(RbupVideoMediaPartnerships, "rbup-video-partnerships", mediaPartnershipsObservedAttributes, { shadow: !0 });
window.initRbupVideoMediaPartnerships = initRbupVideoMediaPartnerships;
export {
  initRbupVideoMediaPartnerships
};
